/* 30e42ae399e33ee01a31c65c0e055ecf28f4b79e */ window.global = window;
(function () {
	'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function getAugmentedNamespace(n) {
	  if (n.__esModule) return n;
	  var f = n.default;
		if (typeof f == "function") {
			var a = function a () {
				if (this instanceof a) {
	        return Reflect.construct(f, arguments, this.constructor);
				}
				return f.apply(this, arguments);
			};
			a.prototype = f.prototype;
	  } else a = {};
	  Object.defineProperty(a, '__esModule', {value: true});
		Object.keys(n).forEach(function (k) {
			var d = Object.getOwnPropertyDescriptor(n, k);
			Object.defineProperty(a, k, d.get ? d : {
				enumerable: true,
				get: function () {
					return n[k];
				}
			});
		});
		return a;
	}

	var buffer$2 = {};

	var base64Js = {};

	base64Js.byteLength = byteLength;
	base64Js.toByteArray = toByteArray;
	base64Js.fromByteArray = fromByteArray;

	var lookup = [];
	var revLookup = [];
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	for (var i$8 = 0, len = code.length; i$8 < len; ++i$8) {
	  lookup[i$8] = code[i$8];
	  revLookup[code.charCodeAt(i$8)] = i$8;
	}

	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62;
	revLookup['_'.charCodeAt(0)] = 63;

	function getLens (b64) {
	  var len = b64.length;

	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }

	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=');
	  if (validLen === -1) validLen = len;

	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4);

	  return [validLen, placeHoldersLen]
	}

	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64);
	  var validLen = lens[0];
	  var placeHoldersLen = lens[1];
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}

	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}

	function toByteArray (b64) {
	  var tmp;
	  var lens = getLens(b64);
	  var validLen = lens[0];
	  var placeHoldersLen = lens[1];

	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));

	  var curByte = 0;

	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen;

	  var i;
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)];
	    arr[curByte++] = (tmp >> 16) & 0xFF;
	    arr[curByte++] = (tmp >> 8) & 0xFF;
	    arr[curByte++] = tmp & 0xFF;
	  }

	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4);
	    arr[curByte++] = tmp & 0xFF;
	  }

	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2);
	    arr[curByte++] = (tmp >> 8) & 0xFF;
	    arr[curByte++] = tmp & 0xFF;
	  }

	  return arr
	}

	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}

	function encodeChunk (uint8, start, end) {
	  var tmp;
	  var output = [];
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF);
	    output.push(tripletToBase64(tmp));
	  }
	  return output.join('')
	}

	function fromByteArray (uint8) {
	  var tmp;
	  var len = uint8.length;
	  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
	  var parts = [];
	  var maxChunkLength = 16383; // must be multiple of 3

	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
	  }

	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1];
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    );
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    );
	  }

	  return parts.join('')
	}

	var ieee754 = {};

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */

	ieee754.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m;
	  var eLen = (nBytes * 8) - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = -7;
	  var i = isLE ? (nBytes - 1) : 0;
	  var d = isLE ? -1 : 1;
	  var s = buffer[offset + i];

	  i += d;

	  e = s & ((1 << (-nBits)) - 1);
	  s >>= (-nBits);
	  nBits += eLen;
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

	  m = e & ((1 << (-nBits)) - 1);
	  e >>= (-nBits);
	  nBits += mLen;
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	};

	ieee754.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c;
	  var eLen = (nBytes * 8) - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
	  var i = isLE ? 0 : (nBytes - 1);
	  var d = isLE ? 1 : -1;
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

	  value = Math.abs(value);

	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0;
	    e = eMax;
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2);
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * Math.pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }

	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	      e = 0;
	    }
	  }

	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

	  e = (e << mLen) | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

	  buffer[offset + i - d] |= s * 128;
	};

	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */

	(function (exports) {

		const base64 = base64Js;
		const ieee754$1 = ieee754;
		const customInspectSymbol =
		  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
		    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
		    : null;

		exports.Buffer = Buffer;
		exports.SlowBuffer = SlowBuffer;
		exports.INSPECT_MAX_BYTES = 50;

		const K_MAX_LENGTH = 0x7fffffff;
		exports.kMaxLength = K_MAX_LENGTH;

		/**
		 * If `Buffer.TYPED_ARRAY_SUPPORT`:
		 *   === true    Use Uint8Array implementation (fastest)
		 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
		 *               implementation (most compatible, even IE6)
		 *
		 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
		 * Opera 11.6+, iOS 4.2+.
		 *
		 * We report that the browser does not support typed arrays if the are not subclassable
		 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
		 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
		 * for __proto__ and has a buggy typed array implementation.
		 */
		Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();

		if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
		    typeof console.error === 'function') {
		  console.error(
		    'This browser lacks typed array (Uint8Array) support which is required by ' +
		    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
		  );
		}

		function typedArraySupport () {
		  // Can typed array instances can be augmented?
		  try {
		    const arr = new Uint8Array(1);
		    const proto = { foo: function () { return 42 } };
		    Object.setPrototypeOf(proto, Uint8Array.prototype);
		    Object.setPrototypeOf(arr, proto);
		    return arr.foo() === 42
		  } catch (e) {
		    return false
		  }
		}

		Object.defineProperty(Buffer.prototype, 'parent', {
		  enumerable: true,
		  get: function () {
		    if (!Buffer.isBuffer(this)) return undefined
		    return this.buffer
		  }
		});

		Object.defineProperty(Buffer.prototype, 'offset', {
		  enumerable: true,
		  get: function () {
		    if (!Buffer.isBuffer(this)) return undefined
		    return this.byteOffset
		  }
		});

		function createBuffer (length) {
		  if (length > K_MAX_LENGTH) {
		    throw new RangeError('The value "' + length + '" is invalid for option "size"')
		  }
		  // Return an augmented `Uint8Array` instance
		  const buf = new Uint8Array(length);
		  Object.setPrototypeOf(buf, Buffer.prototype);
		  return buf
		}

		/**
		 * The Buffer constructor returns instances of `Uint8Array` that have their
		 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
		 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
		 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
		 * returns a single octet.
		 *
		 * The `Uint8Array` prototype remains unmodified.
		 */

		function Buffer (arg, encodingOrOffset, length) {
		  // Common case.
		  if (typeof arg === 'number') {
		    if (typeof encodingOrOffset === 'string') {
		      throw new TypeError(
		        'The "string" argument must be of type string. Received type number'
		      )
		    }
		    return allocUnsafe(arg)
		  }
		  return from(arg, encodingOrOffset, length)
		}

		Buffer.poolSize = 8192; // not used by this implementation

		function from (value, encodingOrOffset, length) {
		  if (typeof value === 'string') {
		    return fromString(value, encodingOrOffset)
		  }

		  if (ArrayBuffer.isView(value)) {
		    return fromArrayView(value)
		  }

		  if (value == null) {
		    throw new TypeError(
		      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
		      'or Array-like Object. Received type ' + (typeof value)
		    )
		  }

		  if (isInstance(value, ArrayBuffer) ||
		      (value && isInstance(value.buffer, ArrayBuffer))) {
		    return fromArrayBuffer(value, encodingOrOffset, length)
		  }

		  if (typeof SharedArrayBuffer !== 'undefined' &&
		      (isInstance(value, SharedArrayBuffer) ||
		      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
		    return fromArrayBuffer(value, encodingOrOffset, length)
		  }

		  if (typeof value === 'number') {
		    throw new TypeError(
		      'The "value" argument must not be of type number. Received type number'
		    )
		  }

		  const valueOf = value.valueOf && value.valueOf();
		  if (valueOf != null && valueOf !== value) {
		    return Buffer.from(valueOf, encodingOrOffset, length)
		  }

		  const b = fromObject(value);
		  if (b) return b

		  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
		      typeof value[Symbol.toPrimitive] === 'function') {
		    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
		  }

		  throw new TypeError(
		    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
		    'or Array-like Object. Received type ' + (typeof value)
		  )
		}

		/**
		 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
		 * if value is a number.
		 * Buffer.from(str[, encoding])
		 * Buffer.from(array)
		 * Buffer.from(buffer)
		 * Buffer.from(arrayBuffer[, byteOffset[, length]])
		 **/
		Buffer.from = function (value, encodingOrOffset, length) {
		  return from(value, encodingOrOffset, length)
		};

		// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
		// https://github.com/feross/buffer/pull/148
		Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
		Object.setPrototypeOf(Buffer, Uint8Array);

		function assertSize (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('"size" argument must be of type number')
		  } else if (size < 0) {
		    throw new RangeError('The value "' + size + '" is invalid for option "size"')
		  }
		}

		function alloc (size, fill, encoding) {
		  assertSize(size);
		  if (size <= 0) {
		    return createBuffer(size)
		  }
		  if (fill !== undefined) {
		    // Only pay attention to encoding if it's a string. This
		    // prevents accidentally sending in a number that would
		    // be interpreted as a start offset.
		    return typeof encoding === 'string'
		      ? createBuffer(size).fill(fill, encoding)
		      : createBuffer(size).fill(fill)
		  }
		  return createBuffer(size)
		}

		/**
		 * Creates a new filled Buffer instance.
		 * alloc(size[, fill[, encoding]])
		 **/
		Buffer.alloc = function (size, fill, encoding) {
		  return alloc(size, fill, encoding)
		};

		function allocUnsafe (size) {
		  assertSize(size);
		  return createBuffer(size < 0 ? 0 : checked(size) | 0)
		}

		/**
		 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
		 * */
		Buffer.allocUnsafe = function (size) {
		  return allocUnsafe(size)
		};
		/**
		 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
		 */
		Buffer.allocUnsafeSlow = function (size) {
		  return allocUnsafe(size)
		};

		function fromString (string, encoding) {
		  if (typeof encoding !== 'string' || encoding === '') {
		    encoding = 'utf8';
		  }

		  if (!Buffer.isEncoding(encoding)) {
		    throw new TypeError('Unknown encoding: ' + encoding)
		  }

		  const length = byteLength(string, encoding) | 0;
		  let buf = createBuffer(length);

		  const actual = buf.write(string, encoding);

		  if (actual !== length) {
		    // Writing a hex string, for example, that contains invalid characters will
		    // cause everything after the first invalid character to be ignored. (e.g.
		    // 'abxxcd' will be treated as 'ab')
		    buf = buf.slice(0, actual);
		  }

		  return buf
		}

		function fromArrayLike (array) {
		  const length = array.length < 0 ? 0 : checked(array.length) | 0;
		  const buf = createBuffer(length);
		  for (let i = 0; i < length; i += 1) {
		    buf[i] = array[i] & 255;
		  }
		  return buf
		}

		function fromArrayView (arrayView) {
		  if (isInstance(arrayView, Uint8Array)) {
		    const copy = new Uint8Array(arrayView);
		    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
		  }
		  return fromArrayLike(arrayView)
		}

		function fromArrayBuffer (array, byteOffset, length) {
		  if (byteOffset < 0 || array.byteLength < byteOffset) {
		    throw new RangeError('"offset" is outside of buffer bounds')
		  }

		  if (array.byteLength < byteOffset + (length || 0)) {
		    throw new RangeError('"length" is outside of buffer bounds')
		  }

		  let buf;
		  if (byteOffset === undefined && length === undefined) {
		    buf = new Uint8Array(array);
		  } else if (length === undefined) {
		    buf = new Uint8Array(array, byteOffset);
		  } else {
		    buf = new Uint8Array(array, byteOffset, length);
		  }

		  // Return an augmented `Uint8Array` instance
		  Object.setPrototypeOf(buf, Buffer.prototype);

		  return buf
		}

		function fromObject (obj) {
		  if (Buffer.isBuffer(obj)) {
		    const len = checked(obj.length) | 0;
		    const buf = createBuffer(len);

		    if (buf.length === 0) {
		      return buf
		    }

		    obj.copy(buf, 0, 0, len);
		    return buf
		  }

		  if (obj.length !== undefined) {
		    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
		      return createBuffer(0)
		    }
		    return fromArrayLike(obj)
		  }

		  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
		    return fromArrayLike(obj.data)
		  }
		}

		function checked (length) {
		  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
		  // length is NaN (which is otherwise coerced to zero.)
		  if (length >= K_MAX_LENGTH) {
		    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
		                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
		  }
		  return length | 0
		}

		function SlowBuffer (length) {
		  if (+length != length) { // eslint-disable-line eqeqeq
		    length = 0;
		  }
		  return Buffer.alloc(+length)
		}

		Buffer.isBuffer = function isBuffer (b) {
		  return b != null && b._isBuffer === true &&
		    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
		};

		Buffer.compare = function compare (a, b) {
		  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
		  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
		  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
		    throw new TypeError(
		      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
		    )
		  }

		  if (a === b) return 0

		  let x = a.length;
		  let y = b.length;

		  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
		    if (a[i] !== b[i]) {
		      x = a[i];
		      y = b[i];
		      break
		    }
		  }

		  if (x < y) return -1
		  if (y < x) return 1
		  return 0
		};

		Buffer.isEncoding = function isEncoding (encoding) {
		  switch (String(encoding).toLowerCase()) {
		    case 'hex':
		    case 'utf8':
		    case 'utf-8':
		    case 'ascii':
		    case 'latin1':
		    case 'binary':
		    case 'base64':
		    case 'ucs2':
		    case 'ucs-2':
		    case 'utf16le':
		    case 'utf-16le':
		      return true
		    default:
		      return false
		  }
		};

		Buffer.concat = function concat (list, length) {
		  if (!Array.isArray(list)) {
		    throw new TypeError('"list" argument must be an Array of Buffers')
		  }

		  if (list.length === 0) {
		    return Buffer.alloc(0)
		  }

		  let i;
		  if (length === undefined) {
		    length = 0;
		    for (i = 0; i < list.length; ++i) {
		      length += list[i].length;
		    }
		  }

		  const buffer = Buffer.allocUnsafe(length);
		  let pos = 0;
		  for (i = 0; i < list.length; ++i) {
		    let buf = list[i];
		    if (isInstance(buf, Uint8Array)) {
		      if (pos + buf.length > buffer.length) {
		        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
		        buf.copy(buffer, pos);
		      } else {
		        Uint8Array.prototype.set.call(
		          buffer,
		          buf,
		          pos
		        );
		      }
		    } else if (!Buffer.isBuffer(buf)) {
		      throw new TypeError('"list" argument must be an Array of Buffers')
		    } else {
		      buf.copy(buffer, pos);
		    }
		    pos += buf.length;
		  }
		  return buffer
		};

		function byteLength (string, encoding) {
		  if (Buffer.isBuffer(string)) {
		    return string.length
		  }
		  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
		    return string.byteLength
		  }
		  if (typeof string !== 'string') {
		    throw new TypeError(
		      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
		      'Received type ' + typeof string
		    )
		  }

		  const len = string.length;
		  const mustMatch = (arguments.length > 2 && arguments[2] === true);
		  if (!mustMatch && len === 0) return 0

		  // Use a for loop to avoid recursion
		  let loweredCase = false;
		  for (;;) {
		    switch (encoding) {
		      case 'ascii':
		      case 'latin1':
		      case 'binary':
		        return len
		      case 'utf8':
		      case 'utf-8':
		        return utf8ToBytes(string).length
		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return len * 2
		      case 'hex':
		        return len >>> 1
		      case 'base64':
		        return base64ToBytes(string).length
		      default:
		        if (loweredCase) {
		          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
		        }
		        encoding = ('' + encoding).toLowerCase();
		        loweredCase = true;
		    }
		  }
		}
		Buffer.byteLength = byteLength;

		function slowToString (encoding, start, end) {
		  let loweredCase = false;

		  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
		  // property of a typed array.

		  // This behaves neither like String nor Uint8Array in that we set start/end
		  // to their upper/lower bounds if the value passed is out of range.
		  // undefined is handled specially as per ECMA-262 6th Edition,
		  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
		  if (start === undefined || start < 0) {
		    start = 0;
		  }
		  // Return early if start > this.length. Done here to prevent potential uint32
		  // coercion fail below.
		  if (start > this.length) {
		    return ''
		  }

		  if (end === undefined || end > this.length) {
		    end = this.length;
		  }

		  if (end <= 0) {
		    return ''
		  }

		  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
		  end >>>= 0;
		  start >>>= 0;

		  if (end <= start) {
		    return ''
		  }

		  if (!encoding) encoding = 'utf8';

		  while (true) {
		    switch (encoding) {
		      case 'hex':
		        return hexSlice(this, start, end)

		      case 'utf8':
		      case 'utf-8':
		        return utf8Slice(this, start, end)

		      case 'ascii':
		        return asciiSlice(this, start, end)

		      case 'latin1':
		      case 'binary':
		        return latin1Slice(this, start, end)

		      case 'base64':
		        return base64Slice(this, start, end)

		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return utf16leSlice(this, start, end)

		      default:
		        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
		        encoding = (encoding + '').toLowerCase();
		        loweredCase = true;
		    }
		  }
		}

		// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
		// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
		// reliably in a browserify context because there could be multiple different
		// copies of the 'buffer' package in use. This method works even for Buffer
		// instances that were created from another copy of the `buffer` package.
		// See: https://github.com/feross/buffer/issues/154
		Buffer.prototype._isBuffer = true;

		function swap (b, n, m) {
		  const i = b[n];
		  b[n] = b[m];
		  b[m] = i;
		}

		Buffer.prototype.swap16 = function swap16 () {
		  const len = this.length;
		  if (len % 2 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 16-bits')
		  }
		  for (let i = 0; i < len; i += 2) {
		    swap(this, i, i + 1);
		  }
		  return this
		};

		Buffer.prototype.swap32 = function swap32 () {
		  const len = this.length;
		  if (len % 4 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 32-bits')
		  }
		  for (let i = 0; i < len; i += 4) {
		    swap(this, i, i + 3);
		    swap(this, i + 1, i + 2);
		  }
		  return this
		};

		Buffer.prototype.swap64 = function swap64 () {
		  const len = this.length;
		  if (len % 8 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 64-bits')
		  }
		  for (let i = 0; i < len; i += 8) {
		    swap(this, i, i + 7);
		    swap(this, i + 1, i + 6);
		    swap(this, i + 2, i + 5);
		    swap(this, i + 3, i + 4);
		  }
		  return this
		};

		Buffer.prototype.toString = function toString () {
		  const length = this.length;
		  if (length === 0) return ''
		  if (arguments.length === 0) return utf8Slice(this, 0, length)
		  return slowToString.apply(this, arguments)
		};

		Buffer.prototype.toLocaleString = Buffer.prototype.toString;

		Buffer.prototype.equals = function equals (b) {
		  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
		  if (this === b) return true
		  return Buffer.compare(this, b) === 0
		};

		Buffer.prototype.inspect = function inspect () {
		  let str = '';
		  const max = exports.INSPECT_MAX_BYTES;
		  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
		  if (this.length > max) str += ' ... ';
		  return '<Buffer ' + str + '>'
		};
		if (customInspectSymbol) {
		  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
		}

		Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
		  if (isInstance(target, Uint8Array)) {
		    target = Buffer.from(target, target.offset, target.byteLength);
		  }
		  if (!Buffer.isBuffer(target)) {
		    throw new TypeError(
		      'The "target" argument must be one of type Buffer or Uint8Array. ' +
		      'Received type ' + (typeof target)
		    )
		  }

		  if (start === undefined) {
		    start = 0;
		  }
		  if (end === undefined) {
		    end = target ? target.length : 0;
		  }
		  if (thisStart === undefined) {
		    thisStart = 0;
		  }
		  if (thisEnd === undefined) {
		    thisEnd = this.length;
		  }

		  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
		    throw new RangeError('out of range index')
		  }

		  if (thisStart >= thisEnd && start >= end) {
		    return 0
		  }
		  if (thisStart >= thisEnd) {
		    return -1
		  }
		  if (start >= end) {
		    return 1
		  }

		  start >>>= 0;
		  end >>>= 0;
		  thisStart >>>= 0;
		  thisEnd >>>= 0;

		  if (this === target) return 0

		  let x = thisEnd - thisStart;
		  let y = end - start;
		  const len = Math.min(x, y);

		  const thisCopy = this.slice(thisStart, thisEnd);
		  const targetCopy = target.slice(start, end);

		  for (let i = 0; i < len; ++i) {
		    if (thisCopy[i] !== targetCopy[i]) {
		      x = thisCopy[i];
		      y = targetCopy[i];
		      break
		    }
		  }

		  if (x < y) return -1
		  if (y < x) return 1
		  return 0
		};

		// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
		// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
		//
		// Arguments:
		// - buffer - a Buffer to search
		// - val - a string, Buffer, or number
		// - byteOffset - an index into `buffer`; will be clamped to an int32
		// - encoding - an optional encoding, relevant is val is a string
		// - dir - true for indexOf, false for lastIndexOf
		function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
		  // Empty buffer means no match
		  if (buffer.length === 0) return -1

		  // Normalize byteOffset
		  if (typeof byteOffset === 'string') {
		    encoding = byteOffset;
		    byteOffset = 0;
		  } else if (byteOffset > 0x7fffffff) {
		    byteOffset = 0x7fffffff;
		  } else if (byteOffset < -0x80000000) {
		    byteOffset = -0x80000000;
		  }
		  byteOffset = +byteOffset; // Coerce to Number.
		  if (numberIsNaN(byteOffset)) {
		    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
		    byteOffset = dir ? 0 : (buffer.length - 1);
		  }

		  // Normalize byteOffset: negative offsets start from the end of the buffer
		  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
		  if (byteOffset >= buffer.length) {
		    if (dir) return -1
		    else byteOffset = buffer.length - 1;
		  } else if (byteOffset < 0) {
		    if (dir) byteOffset = 0;
		    else return -1
		  }

		  // Normalize val
		  if (typeof val === 'string') {
		    val = Buffer.from(val, encoding);
		  }

		  // Finally, search either indexOf (if dir is true) or lastIndexOf
		  if (Buffer.isBuffer(val)) {
		    // Special case: looking for empty string/buffer always fails
		    if (val.length === 0) {
		      return -1
		    }
		    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
		  } else if (typeof val === 'number') {
		    val = val & 0xFF; // Search for a byte value [0-255]
		    if (typeof Uint8Array.prototype.indexOf === 'function') {
		      if (dir) {
		        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
		      } else {
		        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
		      }
		    }
		    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
		  }

		  throw new TypeError('val must be string, number or Buffer')
		}

		function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
		  let indexSize = 1;
		  let arrLength = arr.length;
		  let valLength = val.length;

		  if (encoding !== undefined) {
		    encoding = String(encoding).toLowerCase();
		    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
		        encoding === 'utf16le' || encoding === 'utf-16le') {
		      if (arr.length < 2 || val.length < 2) {
		        return -1
		      }
		      indexSize = 2;
		      arrLength /= 2;
		      valLength /= 2;
		      byteOffset /= 2;
		    }
		  }

		  function read (buf, i) {
		    if (indexSize === 1) {
		      return buf[i]
		    } else {
		      return buf.readUInt16BE(i * indexSize)
		    }
		  }

		  let i;
		  if (dir) {
		    let foundIndex = -1;
		    for (i = byteOffset; i < arrLength; i++) {
		      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
		        if (foundIndex === -1) foundIndex = i;
		        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
		      } else {
		        if (foundIndex !== -1) i -= i - foundIndex;
		        foundIndex = -1;
		      }
		    }
		  } else {
		    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
		    for (i = byteOffset; i >= 0; i--) {
		      let found = true;
		      for (let j = 0; j < valLength; j++) {
		        if (read(arr, i + j) !== read(val, j)) {
		          found = false;
		          break
		        }
		      }
		      if (found) return i
		    }
		  }

		  return -1
		}

		Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
		  return this.indexOf(val, byteOffset, encoding) !== -1
		};

		Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
		  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
		};

		Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
		  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
		};

		function hexWrite (buf, string, offset, length) {
		  offset = Number(offset) || 0;
		  const remaining = buf.length - offset;
		  if (!length) {
		    length = remaining;
		  } else {
		    length = Number(length);
		    if (length > remaining) {
		      length = remaining;
		    }
		  }

		  const strLen = string.length;

		  if (length > strLen / 2) {
		    length = strLen / 2;
		  }
		  let i;
		  for (i = 0; i < length; ++i) {
		    const parsed = parseInt(string.substr(i * 2, 2), 16);
		    if (numberIsNaN(parsed)) return i
		    buf[offset + i] = parsed;
		  }
		  return i
		}

		function utf8Write (buf, string, offset, length) {
		  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
		}

		function asciiWrite (buf, string, offset, length) {
		  return blitBuffer(asciiToBytes(string), buf, offset, length)
		}

		function base64Write (buf, string, offset, length) {
		  return blitBuffer(base64ToBytes(string), buf, offset, length)
		}

		function ucs2Write (buf, string, offset, length) {
		  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
		}

		Buffer.prototype.write = function write (string, offset, length, encoding) {
		  // Buffer#write(string)
		  if (offset === undefined) {
		    encoding = 'utf8';
		    length = this.length;
		    offset = 0;
		  // Buffer#write(string, encoding)
		  } else if (length === undefined && typeof offset === 'string') {
		    encoding = offset;
		    length = this.length;
		    offset = 0;
		  // Buffer#write(string, offset[, length][, encoding])
		  } else if (isFinite(offset)) {
		    offset = offset >>> 0;
		    if (isFinite(length)) {
		      length = length >>> 0;
		      if (encoding === undefined) encoding = 'utf8';
		    } else {
		      encoding = length;
		      length = undefined;
		    }
		  } else {
		    throw new Error(
		      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
		    )
		  }

		  const remaining = this.length - offset;
		  if (length === undefined || length > remaining) length = remaining;

		  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
		    throw new RangeError('Attempt to write outside buffer bounds')
		  }

		  if (!encoding) encoding = 'utf8';

		  let loweredCase = false;
		  for (;;) {
		    switch (encoding) {
		      case 'hex':
		        return hexWrite(this, string, offset, length)

		      case 'utf8':
		      case 'utf-8':
		        return utf8Write(this, string, offset, length)

		      case 'ascii':
		      case 'latin1':
		      case 'binary':
		        return asciiWrite(this, string, offset, length)

		      case 'base64':
		        // Warning: maxLength not taken into account in base64Write
		        return base64Write(this, string, offset, length)

		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return ucs2Write(this, string, offset, length)

		      default:
		        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
		        encoding = ('' + encoding).toLowerCase();
		        loweredCase = true;
		    }
		  }
		};

		Buffer.prototype.toJSON = function toJSON () {
		  return {
		    type: 'Buffer',
		    data: Array.prototype.slice.call(this._arr || this, 0)
		  }
		};

		function base64Slice (buf, start, end) {
		  if (start === 0 && end === buf.length) {
		    return base64.fromByteArray(buf)
		  } else {
		    return base64.fromByteArray(buf.slice(start, end))
		  }
		}

		function utf8Slice (buf, start, end) {
		  end = Math.min(buf.length, end);
		  const res = [];

		  let i = start;
		  while (i < end) {
		    const firstByte = buf[i];
		    let codePoint = null;
		    let bytesPerSequence = (firstByte > 0xEF)
		      ? 4
		      : (firstByte > 0xDF)
		          ? 3
		          : (firstByte > 0xBF)
		              ? 2
		              : 1;

		    if (i + bytesPerSequence <= end) {
		      let secondByte, thirdByte, fourthByte, tempCodePoint;

		      switch (bytesPerSequence) {
		        case 1:
		          if (firstByte < 0x80) {
		            codePoint = firstByte;
		          }
		          break
		        case 2:
		          secondByte = buf[i + 1];
		          if ((secondByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
		            if (tempCodePoint > 0x7F) {
		              codePoint = tempCodePoint;
		            }
		          }
		          break
		        case 3:
		          secondByte = buf[i + 1];
		          thirdByte = buf[i + 2];
		          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
		            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
		              codePoint = tempCodePoint;
		            }
		          }
		          break
		        case 4:
		          secondByte = buf[i + 1];
		          thirdByte = buf[i + 2];
		          fourthByte = buf[i + 3];
		          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
		            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
		              codePoint = tempCodePoint;
		            }
		          }
		      }
		    }

		    if (codePoint === null) {
		      // we did not generate a valid codePoint so insert a
		      // replacement char (U+FFFD) and advance only 1 byte
		      codePoint = 0xFFFD;
		      bytesPerSequence = 1;
		    } else if (codePoint > 0xFFFF) {
		      // encode to utf16 (surrogate pair dance)
		      codePoint -= 0x10000;
		      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
		      codePoint = 0xDC00 | codePoint & 0x3FF;
		    }

		    res.push(codePoint);
		    i += bytesPerSequence;
		  }

		  return decodeCodePointsArray(res)
		}

		// Based on http://stackoverflow.com/a/22747272/680742, the browser with
		// the lowest limit is Chrome, with 0x10000 args.
		// We go 1 magnitude less, for safety
		const MAX_ARGUMENTS_LENGTH = 0x1000;

		function decodeCodePointsArray (codePoints) {
		  const len = codePoints.length;
		  if (len <= MAX_ARGUMENTS_LENGTH) {
		    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
		  }

		  // Decode in chunks to avoid "call stack size exceeded".
		  let res = '';
		  let i = 0;
		  while (i < len) {
		    res += String.fromCharCode.apply(
		      String,
		      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
		    );
		  }
		  return res
		}

		function asciiSlice (buf, start, end) {
		  let ret = '';
		  end = Math.min(buf.length, end);

		  for (let i = start; i < end; ++i) {
		    ret += String.fromCharCode(buf[i] & 0x7F);
		  }
		  return ret
		}

		function latin1Slice (buf, start, end) {
		  let ret = '';
		  end = Math.min(buf.length, end);

		  for (let i = start; i < end; ++i) {
		    ret += String.fromCharCode(buf[i]);
		  }
		  return ret
		}

		function hexSlice (buf, start, end) {
		  const len = buf.length;

		  if (!start || start < 0) start = 0;
		  if (!end || end < 0 || end > len) end = len;

		  let out = '';
		  for (let i = start; i < end; ++i) {
		    out += hexSliceLookupTable[buf[i]];
		  }
		  return out
		}

		function utf16leSlice (buf, start, end) {
		  const bytes = buf.slice(start, end);
		  let res = '';
		  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
		  for (let i = 0; i < bytes.length - 1; i += 2) {
		    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256));
		  }
		  return res
		}

		Buffer.prototype.slice = function slice (start, end) {
		  const len = this.length;
		  start = ~~start;
		  end = end === undefined ? len : ~~end;

		  if (start < 0) {
		    start += len;
		    if (start < 0) start = 0;
		  } else if (start > len) {
		    start = len;
		  }

		  if (end < 0) {
		    end += len;
		    if (end < 0) end = 0;
		  } else if (end > len) {
		    end = len;
		  }

		  if (end < start) end = start;

		  const newBuf = this.subarray(start, end);
		  // Return an augmented `Uint8Array` instance
		  Object.setPrototypeOf(newBuf, Buffer.prototype);

		  return newBuf
		};

		/*
		 * Need to make sure that buffer isn't trying to write out of bounds.
		 */
		function checkOffset (offset, ext, length) {
		  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
		  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
		}

		Buffer.prototype.readUintLE =
		Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) checkOffset(offset, byteLength, this.length);

		  let val = this[offset];
		  let mul = 1;
		  let i = 0;
		  while (++i < byteLength && (mul *= 0x100)) {
		    val += this[offset + i] * mul;
		  }

		  return val
		};

		Buffer.prototype.readUintBE =
		Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) {
		    checkOffset(offset, byteLength, this.length);
		  }

		  let val = this[offset + --byteLength];
		  let mul = 1;
		  while (byteLength > 0 && (mul *= 0x100)) {
		    val += this[offset + --byteLength] * mul;
		  }

		  return val
		};

		Buffer.prototype.readUint8 =
		Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 1, this.length);
		  return this[offset]
		};

		Buffer.prototype.readUint16LE =
		Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  return this[offset] | (this[offset + 1] << 8)
		};

		Buffer.prototype.readUint16BE =
		Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  return (this[offset] << 8) | this[offset + 1]
		};

		Buffer.prototype.readUint32LE =
		Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);

		  return ((this[offset]) |
		      (this[offset + 1] << 8) |
		      (this[offset + 2] << 16)) +
		      (this[offset + 3] * 0x1000000)
		};

		Buffer.prototype.readUint32BE =
		Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);

		  return (this[offset] * 0x1000000) +
		    ((this[offset + 1] << 16) |
		    (this[offset + 2] << 8) |
		    this[offset + 3])
		};

		Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
		  offset = offset >>> 0;
		  validateNumber(offset, 'offset');
		  const first = this[offset];
		  const last = this[offset + 7];
		  if (first === undefined || last === undefined) {
		    boundsError(offset, this.length - 8);
		  }

		  const lo = first +
		    this[++offset] * 2 ** 8 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 24;

		  const hi = this[++offset] +
		    this[++offset] * 2 ** 8 +
		    this[++offset] * 2 ** 16 +
		    last * 2 ** 24;

		  return BigInt(lo) + (BigInt(hi) << BigInt(32))
		});

		Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
		  offset = offset >>> 0;
		  validateNumber(offset, 'offset');
		  const first = this[offset];
		  const last = this[offset + 7];
		  if (first === undefined || last === undefined) {
		    boundsError(offset, this.length - 8);
		  }

		  const hi = first * 2 ** 24 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 8 +
		    this[++offset];

		  const lo = this[++offset] * 2 ** 24 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 8 +
		    last;

		  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
		});

		Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) checkOffset(offset, byteLength, this.length);

		  let val = this[offset];
		  let mul = 1;
		  let i = 0;
		  while (++i < byteLength && (mul *= 0x100)) {
		    val += this[offset + i] * mul;
		  }
		  mul *= 0x80;

		  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

		  return val
		};

		Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) checkOffset(offset, byteLength, this.length);

		  let i = byteLength;
		  let mul = 1;
		  let val = this[offset + --i];
		  while (i > 0 && (mul *= 0x100)) {
		    val += this[offset + --i] * mul;
		  }
		  mul *= 0x80;

		  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

		  return val
		};

		Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 1, this.length);
		  if (!(this[offset] & 0x80)) return (this[offset])
		  return ((0xff - this[offset] + 1) * -1)
		};

		Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  const val = this[offset] | (this[offset + 1] << 8);
		  return (val & 0x8000) ? val | 0xFFFF0000 : val
		};

		Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  const val = this[offset + 1] | (this[offset] << 8);
		  return (val & 0x8000) ? val | 0xFFFF0000 : val
		};

		Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);

		  return (this[offset]) |
		    (this[offset + 1] << 8) |
		    (this[offset + 2] << 16) |
		    (this[offset + 3] << 24)
		};

		Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);

		  return (this[offset] << 24) |
		    (this[offset + 1] << 16) |
		    (this[offset + 2] << 8) |
		    (this[offset + 3])
		};

		Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
		  offset = offset >>> 0;
		  validateNumber(offset, 'offset');
		  const first = this[offset];
		  const last = this[offset + 7];
		  if (first === undefined || last === undefined) {
		    boundsError(offset, this.length - 8);
		  }

		  const val = this[offset + 4] +
		    this[offset + 5] * 2 ** 8 +
		    this[offset + 6] * 2 ** 16 +
		    (last << 24); // Overflow

		  return (BigInt(val) << BigInt(32)) +
		    BigInt(first +
		    this[++offset] * 2 ** 8 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 24)
		});

		Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
		  offset = offset >>> 0;
		  validateNumber(offset, 'offset');
		  const first = this[offset];
		  const last = this[offset + 7];
		  if (first === undefined || last === undefined) {
		    boundsError(offset, this.length - 8);
		  }

		  const val = (first << 24) + // Overflow
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 8 +
		    this[++offset];

		  return (BigInt(val) << BigInt(32)) +
		    BigInt(this[++offset] * 2 ** 24 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 8 +
		    last)
		});

		Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);
		  return ieee754$1.read(this, offset, true, 23, 4)
		};

		Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);
		  return ieee754$1.read(this, offset, false, 23, 4)
		};

		Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 8, this.length);
		  return ieee754$1.read(this, offset, true, 52, 8)
		};

		Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 8, this.length);
		  return ieee754$1.read(this, offset, false, 52, 8)
		};

		function checkInt (buf, value, offset, ext, max, min) {
		  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
		  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
		  if (offset + ext > buf.length) throw new RangeError('Index out of range')
		}

		Buffer.prototype.writeUintLE =
		Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) {
		    const maxBytes = Math.pow(2, 8 * byteLength) - 1;
		    checkInt(this, value, offset, byteLength, maxBytes, 0);
		  }

		  let mul = 1;
		  let i = 0;
		  this[offset] = value & 0xFF;
		  while (++i < byteLength && (mul *= 0x100)) {
		    this[offset + i] = (value / mul) & 0xFF;
		  }

		  return offset + byteLength
		};

		Buffer.prototype.writeUintBE =
		Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) {
		    const maxBytes = Math.pow(2, 8 * byteLength) - 1;
		    checkInt(this, value, offset, byteLength, maxBytes, 0);
		  }

		  let i = byteLength - 1;
		  let mul = 1;
		  this[offset + i] = value & 0xFF;
		  while (--i >= 0 && (mul *= 0x100)) {
		    this[offset + i] = (value / mul) & 0xFF;
		  }

		  return offset + byteLength
		};

		Buffer.prototype.writeUint8 =
		Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
		  this[offset] = (value & 0xff);
		  return offset + 1
		};

		Buffer.prototype.writeUint16LE =
		Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
		  this[offset] = (value & 0xff);
		  this[offset + 1] = (value >>> 8);
		  return offset + 2
		};

		Buffer.prototype.writeUint16BE =
		Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
		  this[offset] = (value >>> 8);
		  this[offset + 1] = (value & 0xff);
		  return offset + 2
		};

		Buffer.prototype.writeUint32LE =
		Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
		  this[offset + 3] = (value >>> 24);
		  this[offset + 2] = (value >>> 16);
		  this[offset + 1] = (value >>> 8);
		  this[offset] = (value & 0xff);
		  return offset + 4
		};

		Buffer.prototype.writeUint32BE =
		Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
		  this[offset] = (value >>> 24);
		  this[offset + 1] = (value >>> 16);
		  this[offset + 2] = (value >>> 8);
		  this[offset + 3] = (value & 0xff);
		  return offset + 4
		};

		function wrtBigUInt64LE (buf, value, offset, min, max) {
		  checkIntBI(value, min, max, buf, offset, 7);

		  let lo = Number(value & BigInt(0xffffffff));
		  buf[offset++] = lo;
		  lo = lo >> 8;
		  buf[offset++] = lo;
		  lo = lo >> 8;
		  buf[offset++] = lo;
		  lo = lo >> 8;
		  buf[offset++] = lo;
		  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
		  buf[offset++] = hi;
		  hi = hi >> 8;
		  buf[offset++] = hi;
		  hi = hi >> 8;
		  buf[offset++] = hi;
		  hi = hi >> 8;
		  buf[offset++] = hi;
		  return offset
		}

		function wrtBigUInt64BE (buf, value, offset, min, max) {
		  checkIntBI(value, min, max, buf, offset, 7);

		  let lo = Number(value & BigInt(0xffffffff));
		  buf[offset + 7] = lo;
		  lo = lo >> 8;
		  buf[offset + 6] = lo;
		  lo = lo >> 8;
		  buf[offset + 5] = lo;
		  lo = lo >> 8;
		  buf[offset + 4] = lo;
		  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
		  buf[offset + 3] = hi;
		  hi = hi >> 8;
		  buf[offset + 2] = hi;
		  hi = hi >> 8;
		  buf[offset + 1] = hi;
		  hi = hi >> 8;
		  buf[offset] = hi;
		  return offset + 8
		}

		Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
		  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
		});

		Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
		  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
		});

		Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) {
		    const limit = Math.pow(2, (8 * byteLength) - 1);

		    checkInt(this, value, offset, byteLength, limit - 1, -limit);
		  }

		  let i = 0;
		  let mul = 1;
		  let sub = 0;
		  this[offset] = value & 0xFF;
		  while (++i < byteLength && (mul *= 0x100)) {
		    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
		      sub = 1;
		    }
		    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
		  }

		  return offset + byteLength
		};

		Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) {
		    const limit = Math.pow(2, (8 * byteLength) - 1);

		    checkInt(this, value, offset, byteLength, limit - 1, -limit);
		  }

		  let i = byteLength - 1;
		  let mul = 1;
		  let sub = 0;
		  this[offset + i] = value & 0xFF;
		  while (--i >= 0 && (mul *= 0x100)) {
		    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
		      sub = 1;
		    }
		    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
		  }

		  return offset + byteLength
		};

		Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
		  if (value < 0) value = 0xff + value + 1;
		  this[offset] = (value & 0xff);
		  return offset + 1
		};

		Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
		  this[offset] = (value & 0xff);
		  this[offset + 1] = (value >>> 8);
		  return offset + 2
		};

		Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
		  this[offset] = (value >>> 8);
		  this[offset + 1] = (value & 0xff);
		  return offset + 2
		};

		Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
		  this[offset] = (value & 0xff);
		  this[offset + 1] = (value >>> 8);
		  this[offset + 2] = (value >>> 16);
		  this[offset + 3] = (value >>> 24);
		  return offset + 4
		};

		Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
		  if (value < 0) value = 0xffffffff + value + 1;
		  this[offset] = (value >>> 24);
		  this[offset + 1] = (value >>> 16);
		  this[offset + 2] = (value >>> 8);
		  this[offset + 3] = (value & 0xff);
		  return offset + 4
		};

		Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
		  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
		});

		Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
		  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
		});

		function checkIEEE754 (buf, value, offset, ext, max, min) {
		  if (offset + ext > buf.length) throw new RangeError('Index out of range')
		  if (offset < 0) throw new RangeError('Index out of range')
		}

		function writeFloat (buf, value, offset, littleEndian, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) {
		    checkIEEE754(buf, value, offset, 4);
		  }
		  ieee754$1.write(buf, value, offset, littleEndian, 23, 4);
		  return offset + 4
		}

		Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
		  return writeFloat(this, value, offset, true, noAssert)
		};

		Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
		  return writeFloat(this, value, offset, false, noAssert)
		};

		function writeDouble (buf, value, offset, littleEndian, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) {
		    checkIEEE754(buf, value, offset, 8);
		  }
		  ieee754$1.write(buf, value, offset, littleEndian, 52, 8);
		  return offset + 8
		}

		Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
		  return writeDouble(this, value, offset, true, noAssert)
		};

		Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
		  return writeDouble(this, value, offset, false, noAssert)
		};

		// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
		Buffer.prototype.copy = function copy (target, targetStart, start, end) {
		  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
		  if (!start) start = 0;
		  if (!end && end !== 0) end = this.length;
		  if (targetStart >= target.length) targetStart = target.length;
		  if (!targetStart) targetStart = 0;
		  if (end > 0 && end < start) end = start;

		  // Copy 0 bytes; we're done
		  if (end === start) return 0
		  if (target.length === 0 || this.length === 0) return 0

		  // Fatal error conditions
		  if (targetStart < 0) {
		    throw new RangeError('targetStart out of bounds')
		  }
		  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
		  if (end < 0) throw new RangeError('sourceEnd out of bounds')

		  // Are we oob?
		  if (end > this.length) end = this.length;
		  if (target.length - targetStart < end - start) {
		    end = target.length - targetStart + start;
		  }

		  const len = end - start;

		  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
		    // Use built-in when available, missing from IE11
		    this.copyWithin(targetStart, start, end);
		  } else {
		    Uint8Array.prototype.set.call(
		      target,
		      this.subarray(start, end),
		      targetStart
		    );
		  }

		  return len
		};

		// Usage:
		//    buffer.fill(number[, offset[, end]])
		//    buffer.fill(buffer[, offset[, end]])
		//    buffer.fill(string[, offset[, end]][, encoding])
		Buffer.prototype.fill = function fill (val, start, end, encoding) {
		  // Handle string cases:
		  if (typeof val === 'string') {
		    if (typeof start === 'string') {
		      encoding = start;
		      start = 0;
		      end = this.length;
		    } else if (typeof end === 'string') {
		      encoding = end;
		      end = this.length;
		    }
		    if (encoding !== undefined && typeof encoding !== 'string') {
		      throw new TypeError('encoding must be a string')
		    }
		    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
		      throw new TypeError('Unknown encoding: ' + encoding)
		    }
		    if (val.length === 1) {
		      const code = val.charCodeAt(0);
		      if ((encoding === 'utf8' && code < 128) ||
		          encoding === 'latin1') {
		        // Fast path: If `val` fits into a single byte, use that numeric value.
		        val = code;
		      }
		    }
		  } else if (typeof val === 'number') {
		    val = val & 255;
		  } else if (typeof val === 'boolean') {
		    val = Number(val);
		  }

		  // Invalid ranges are not set to a default, so can range check early.
		  if (start < 0 || this.length < start || this.length < end) {
		    throw new RangeError('Out of range index')
		  }

		  if (end <= start) {
		    return this
		  }

		  start = start >>> 0;
		  end = end === undefined ? this.length : end >>> 0;

		  if (!val) val = 0;

		  let i;
		  if (typeof val === 'number') {
		    for (i = start; i < end; ++i) {
		      this[i] = val;
		    }
		  } else {
		    const bytes = Buffer.isBuffer(val)
		      ? val
		      : Buffer.from(val, encoding);
		    const len = bytes.length;
		    if (len === 0) {
		      throw new TypeError('The value "' + val +
		        '" is invalid for argument "value"')
		    }
		    for (i = 0; i < end - start; ++i) {
		      this[i + start] = bytes[i % len];
		    }
		  }

		  return this
		};

		// CUSTOM ERRORS
		// =============

		// Simplified versions from Node, changed for Buffer-only usage
		const errors = {};
		function E (sym, getMessage, Base) {
		  errors[sym] = class NodeError extends Base {
		    constructor () {
		      super();

		      Object.defineProperty(this, 'message', {
		        value: getMessage.apply(this, arguments),
		        writable: true,
		        configurable: true
		      });

		      // Add the error code to the name to include it in the stack trace.
		      this.name = `${this.name} [${sym}]`;
		      // Access the stack to generate the error message including the error code
		      // from the name.
		      this.stack; // eslint-disable-line no-unused-expressions
		      // Reset the name to the actual name.
		      delete this.name;
		    }

		    get code () {
		      return sym
		    }

		    set code (value) {
		      Object.defineProperty(this, 'code', {
		        configurable: true,
		        enumerable: true,
		        value,
		        writable: true
		      });
		    }

		    toString () {
		      return `${this.name} [${sym}]: ${this.message}`
		    }
		  };
		}

		E('ERR_BUFFER_OUT_OF_BOUNDS',
		  function (name) {
		    if (name) {
		      return `${name} is outside of buffer bounds`
		    }

		    return 'Attempt to access memory outside buffer bounds'
		  }, RangeError);
		E('ERR_INVALID_ARG_TYPE',
		  function (name, actual) {
		    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
		  }, TypeError);
		E('ERR_OUT_OF_RANGE',
		  function (str, range, input) {
		    let msg = `The value of "${str}" is out of range.`;
		    let received = input;
		    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
		      received = addNumericalSeparator(String(input));
		    } else if (typeof input === 'bigint') {
		      received = String(input);
		      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
		        received = addNumericalSeparator(received);
		      }
		      received += 'n';
		    }
		    msg += ` It must be ${range}. Received ${received}`;
		    return msg
		  }, RangeError);

		function addNumericalSeparator (val) {
		  let res = '';
		  let i = val.length;
		  const start = val[0] === '-' ? 1 : 0;
		  for (; i >= start + 4; i -= 3) {
		    res = `_${val.slice(i - 3, i)}${res}`;
		  }
		  return `${val.slice(0, i)}${res}`
		}

		// CHECK FUNCTIONS
		// ===============

		function checkBounds (buf, offset, byteLength) {
		  validateNumber(offset, 'offset');
		  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
		    boundsError(offset, buf.length - (byteLength + 1));
		  }
		}

		function checkIntBI (value, min, max, buf, offset, byteLength) {
		  if (value > max || value < min) {
		    const n = typeof min === 'bigint' ? 'n' : '';
		    let range;
		    if (byteLength > 3) {
		      if (min === 0 || min === BigInt(0)) {
		        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
		      } else {
		        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
		                `${(byteLength + 1) * 8 - 1}${n}`;
		      }
		    } else {
		      range = `>= ${min}${n} and <= ${max}${n}`;
		    }
		    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
		  }
		  checkBounds(buf, offset, byteLength);
		}

		function validateNumber (value, name) {
		  if (typeof value !== 'number') {
		    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
		  }
		}

		function boundsError (value, length, type) {
		  if (Math.floor(value) !== value) {
		    validateNumber(value, type);
		    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
		  }

		  if (length < 0) {
		    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
		  }

		  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
		                                    `>= ${type ? 1 : 0} and <= ${length}`,
		                                    value)
		}

		// HELPER FUNCTIONS
		// ================

		const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;

		function base64clean (str) {
		  // Node takes equal signs as end of the Base64 encoding
		  str = str.split('=')[0];
		  // Node strips out invalid characters like \n and \t from the string, base64-js does not
		  str = str.trim().replace(INVALID_BASE64_RE, '');
		  // Node converts strings with length < 2 to ''
		  if (str.length < 2) return ''
		  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
		  while (str.length % 4 !== 0) {
		    str = str + '=';
		  }
		  return str
		}

		function utf8ToBytes (string, units) {
		  units = units || Infinity;
		  let codePoint;
		  const length = string.length;
		  let leadSurrogate = null;
		  const bytes = [];

		  for (let i = 0; i < length; ++i) {
		    codePoint = string.charCodeAt(i);

		    // is surrogate component
		    if (codePoint > 0xD7FF && codePoint < 0xE000) {
		      // last char was a lead
		      if (!leadSurrogate) {
		        // no lead yet
		        if (codePoint > 0xDBFF) {
		          // unexpected trail
		          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		          continue
		        } else if (i + 1 === length) {
		          // unpaired lead
		          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		          continue
		        }

		        // valid lead
		        leadSurrogate = codePoint;

		        continue
		      }

		      // 2 leads in a row
		      if (codePoint < 0xDC00) {
		        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		        leadSurrogate = codePoint;
		        continue
		      }

		      // valid surrogate pair
		      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
		    } else if (leadSurrogate) {
		      // valid bmp char, but last char was a lead
		      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		    }

		    leadSurrogate = null;

		    // encode utf8
		    if (codePoint < 0x80) {
		      if ((units -= 1) < 0) break
		      bytes.push(codePoint);
		    } else if (codePoint < 0x800) {
		      if ((units -= 2) < 0) break
		      bytes.push(
		        codePoint >> 0x6 | 0xC0,
		        codePoint & 0x3F | 0x80
		      );
		    } else if (codePoint < 0x10000) {
		      if ((units -= 3) < 0) break
		      bytes.push(
		        codePoint >> 0xC | 0xE0,
		        codePoint >> 0x6 & 0x3F | 0x80,
		        codePoint & 0x3F | 0x80
		      );
		    } else if (codePoint < 0x110000) {
		      if ((units -= 4) < 0) break
		      bytes.push(
		        codePoint >> 0x12 | 0xF0,
		        codePoint >> 0xC & 0x3F | 0x80,
		        codePoint >> 0x6 & 0x3F | 0x80,
		        codePoint & 0x3F | 0x80
		      );
		    } else {
		      throw new Error('Invalid code point')
		    }
		  }

		  return bytes
		}

		function asciiToBytes (str) {
		  const byteArray = [];
		  for (let i = 0; i < str.length; ++i) {
		    // Node's code seems to be doing this and not & 0x7F..
		    byteArray.push(str.charCodeAt(i) & 0xFF);
		  }
		  return byteArray
		}

		function utf16leToBytes (str, units) {
		  let c, hi, lo;
		  const byteArray = [];
		  for (let i = 0; i < str.length; ++i) {
		    if ((units -= 2) < 0) break

		    c = str.charCodeAt(i);
		    hi = c >> 8;
		    lo = c % 256;
		    byteArray.push(lo);
		    byteArray.push(hi);
		  }

		  return byteArray
		}

		function base64ToBytes (str) {
		  return base64.toByteArray(base64clean(str))
		}

		function blitBuffer (src, dst, offset, length) {
		  let i;
		  for (i = 0; i < length; ++i) {
		    if ((i + offset >= dst.length) || (i >= src.length)) break
		    dst[i + offset] = src[i];
		  }
		  return i
		}

		// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
		// the `instanceof` check but they should be treated as of that type.
		// See: https://github.com/feross/buffer/issues/166
		function isInstance (obj, type) {
		  return obj instanceof type ||
		    (obj != null && obj.constructor != null && obj.constructor.name != null &&
		      obj.constructor.name === type.name)
		}
		function numberIsNaN (obj) {
		  // For IE11 support
		  return obj !== obj // eslint-disable-line no-self-compare
		}

		// Create lookup table for `toString('hex')`
		// See: https://github.com/feross/buffer/issues/219
		const hexSliceLookupTable = (function () {
		  const alphabet = '0123456789abcdef';
		  const table = new Array(256);
		  for (let i = 0; i < 16; ++i) {
		    const i16 = i * 16;
		    for (let j = 0; j < 16; ++j) {
		      table[i16 + j] = alphabet[i] + alphabet[j];
		    }
		  }
		  return table
		})();

		// Return not function with Error if BigInt not supported
		function defineBigIntMethod (fn) {
		  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
		}

		function BufferBigIntNotDefined () {
		  throw new Error('BigInt not supported')
		} 
	} (buffer$2));

	window.Buffer = buffer$2.Buffer;

	function noop$6() { }
	const identity$2 = x => x;
	function assign$6(tar, src) {
	    // @ts-ignore
	    for (const k in src)
	        tar[k] = src[k];
	    return tar;
	}
	function run$1(fn) {
	    return fn();
	}
	function blank_object() {
	    return Object.create(null);
	}
	function run_all(fns) {
	    fns.forEach(run$1);
	}
	function is_function(thing) {
	    return typeof thing === 'function';
	}
	function safe_not_equal(a, b) {
	    return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
	}
	let src_url_equal_anchor;
	function src_url_equal(element_src, url) {
	    if (!src_url_equal_anchor) {
	        src_url_equal_anchor = document.createElement('a');
	    }
	    src_url_equal_anchor.href = url;
	    return element_src === src_url_equal_anchor.href;
	}
	function is_empty(obj) {
	    return Object.keys(obj).length === 0;
	}
	function subscribe$1(store, ...callbacks) {
	    if (store == null) {
	        return noop$6;
	    }
	    const unsub = store.subscribe(...callbacks);
	    return unsub.unsubscribe ? () => unsub.unsubscribe() : unsub;
	}
	function get_store_value(store) {
	    let value;
	    subscribe$1(store, _ => value = _)();
	    return value;
	}
	function component_subscribe(component, store, callback) {
	    component.$$.on_destroy.push(subscribe$1(store, callback));
	}
	function create_slot(definition, ctx, $$scope, fn) {
	    if (definition) {
	        const slot_ctx = get_slot_context(definition, ctx, $$scope, fn);
	        return definition[0](slot_ctx);
	    }
	}
	function get_slot_context(definition, ctx, $$scope, fn) {
	    return definition[1] && fn
	        ? assign$6($$scope.ctx.slice(), definition[1](fn(ctx)))
	        : $$scope.ctx;
	}
	function get_slot_changes(definition, $$scope, dirty, fn) {
	    if (definition[2] && fn) {
	        const lets = definition[2](fn(dirty));
	        if ($$scope.dirty === undefined) {
	            return lets;
	        }
	        if (typeof lets === 'object') {
	            const merged = [];
	            const len = Math.max($$scope.dirty.length, lets.length);
	            for (let i = 0; i < len; i += 1) {
	                merged[i] = $$scope.dirty[i] | lets[i];
	            }
	            return merged;
	        }
	        return $$scope.dirty | lets;
	    }
	    return $$scope.dirty;
	}
	function update_slot_base(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn) {
	    if (slot_changes) {
	        const slot_context = get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
	        slot.p(slot_context, slot_changes);
	    }
	}
	function get_all_dirty_from_scope($$scope) {
	    if ($$scope.ctx.length > 32) {
	        const dirty = [];
	        const length = $$scope.ctx.length / 32;
	        for (let i = 0; i < length; i++) {
	            dirty[i] = -1;
	        }
	        return dirty;
	    }
	    return -1;
	}
	function exclude_internal_props(props) {
	    const result = {};
	    for (const k in props)
	        if (k[0] !== '$')
	            result[k] = props[k];
	    return result;
	}
	function compute_rest_props(props, keys) {
	    const rest = {};
	    keys = new Set(keys);
	    for (const k in props)
	        if (!keys.has(k) && k[0] !== '$')
	            rest[k] = props[k];
	    return rest;
	}
	function compute_slots(slots) {
	    const result = {};
	    for (const key in slots) {
	        result[key] = true;
	    }
	    return result;
	}

	const is_client = typeof window !== 'undefined';
	let now = is_client
	    ? () => window.performance.now()
	    : () => Date.now();
	let raf = is_client ? cb => requestAnimationFrame(cb) : noop$6;

	const tasks = new Set();
	function run_tasks(now) {
	    tasks.forEach(task => {
	        if (!task.c(now)) {
	            tasks.delete(task);
	            task.f();
	        }
	    });
	    if (tasks.size !== 0)
	        raf(run_tasks);
	}
	/**
	 * Creates a new task that runs on each raf frame
	 * until it returns a falsy value or is aborted
	 */
	function loop(callback) {
	    let task;
	    if (tasks.size === 0)
	        raf(run_tasks);
	    return {
	        promise: new Promise(fulfill => {
	            tasks.add(task = { c: callback, f: fulfill });
	        }),
	        abort() {
	            tasks.delete(task);
	        }
	    };
	}
	function append(target, node) {
	    target.appendChild(node);
	}
	function append_styles(target, style_sheet_id, styles) {
	    const append_styles_to = get_root_for_style(target);
	    if (!append_styles_to.getElementById(style_sheet_id)) {
	        const style = element('style');
	        style.id = style_sheet_id;
	        style.textContent = styles;
	        append_stylesheet(append_styles_to, style);
	    }
	}
	function get_root_for_style(node) {
	    if (!node)
	        return document;
	    const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
	    if (root && root.host) {
	        return root;
	    }
	    return node.ownerDocument;
	}
	function append_empty_stylesheet(node) {
	    const style_element = element('style');
	    append_stylesheet(get_root_for_style(node), style_element);
	    return style_element.sheet;
	}
	function append_stylesheet(node, style) {
	    append(node.head || node, style);
	    return style.sheet;
	}
	function insert(target, node, anchor) {
	    target.insertBefore(node, anchor || null);
	}
	function detach(node) {
	    if (node.parentNode) {
	        node.parentNode.removeChild(node);
	    }
	}
	function destroy_each(iterations, detaching) {
	    for (let i = 0; i < iterations.length; i += 1) {
	        if (iterations[i])
	            iterations[i].d(detaching);
	    }
	}
	function element(name) {
	    return document.createElement(name);
	}
	function svg_element(name) {
	    return document.createElementNS('http://www.w3.org/2000/svg', name);
	}
	function text(data) {
	    return document.createTextNode(data);
	}
	function space() {
	    return text(' ');
	}
	function empty$3() {
	    return text('');
	}
	function listen(node, event, handler, options) {
	    node.addEventListener(event, handler, options);
	    return () => node.removeEventListener(event, handler, options);
	}
	function prevent_default(fn) {
	    return function (event) {
	        event.preventDefault();
	        // @ts-ignore
	        return fn.call(this, event);
	    };
	}
	function attr(node, attribute, value) {
	    if (value == null)
	        node.removeAttribute(attribute);
	    else if (node.getAttribute(attribute) !== value)
	        node.setAttribute(attribute, value);
	}
	/**
	 * List of attributes that should always be set through the attr method,
	 * because updating them through the property setter doesn't work reliably.
	 * In the example of `width`/`height`, the problem is that the setter only
	 * accepts numeric values, but the attribute can also be set to a string like `50%`.
	 * If this list becomes too big, rethink this approach.
	 */
	const always_set_through_set_attribute = ['width', 'height'];
	function set_attributes(node, attributes) {
	    // @ts-ignore
	    const descriptors = Object.getOwnPropertyDescriptors(node.__proto__);
	    for (const key in attributes) {
	        if (attributes[key] == null) {
	            node.removeAttribute(key);
	        }
	        else if (key === 'style') {
	            node.style.cssText = attributes[key];
	        }
	        else if (key === '__value') {
	            node.value = node[key] = attributes[key];
	        }
	        else if (descriptors[key] && descriptors[key].set && always_set_through_set_attribute.indexOf(key) === -1) {
	            node[key] = attributes[key];
	        }
	        else {
	            attr(node, key, attributes[key]);
	        }
	    }
	}
	function set_custom_element_data_map(node, data_map) {
	    Object.keys(data_map).forEach((key) => {
	        set_custom_element_data(node, key, data_map[key]);
	    });
	}
	function set_custom_element_data(node, prop, value) {
	    if (prop in node) {
	        node[prop] = typeof node[prop] === 'boolean' && value === '' ? true : value;
	    }
	    else {
	        attr(node, prop, value);
	    }
	}
	function set_dynamic_element_data(tag) {
	    return (/-/.test(tag)) ? set_custom_element_data_map : set_attributes;
	}
	function init_binding_group(group) {
	    let _inputs;
	    return {
	        /* push */ p(...inputs) {
	            _inputs = inputs;
	            _inputs.forEach(input => group.push(input));
	        },
	        /* remove */ r() {
	            _inputs.forEach(input => group.splice(group.indexOf(input), 1));
	        }
	    };
	}
	function children$1(element) {
	    return Array.from(element.childNodes);
	}
	function set_data(text, data) {
	    data = '' + data;
	    if (text.data === data)
	        return;
	    text.data = data;
	}
	function set_input_value(input, value) {
	    input.value = value == null ? '' : value;
	}
	function set_style(node, key, value, important) {
	    if (value == null) {
	        node.style.removeProperty(key);
	    }
	    else {
	        node.style.setProperty(key, value, important ? 'important' : '');
	    }
	}
	// unfortunately this can't be a constant as that wouldn't be tree-shakeable
	// so we cache the result instead
	let crossorigin;
	function is_crossorigin() {
	    if (crossorigin === undefined) {
	        crossorigin = false;
	        try {
	            if (typeof window !== 'undefined' && window.parent) {
	                void window.parent.document;
	            }
	        }
	        catch (error) {
	            crossorigin = true;
	        }
	    }
	    return crossorigin;
	}
	function add_iframe_resize_listener(node, fn) {
	    const computed_style = getComputedStyle(node);
	    if (computed_style.position === 'static') {
	        node.style.position = 'relative';
	    }
	    const iframe = element('iframe');
	    iframe.setAttribute('style', 'display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; ' +
	        'overflow: hidden; border: 0; opacity: 0; pointer-events: none; z-index: -1;');
	    iframe.setAttribute('aria-hidden', 'true');
	    iframe.tabIndex = -1;
	    const crossorigin = is_crossorigin();
	    let unsubscribe;
	    if (crossorigin) {
	        iframe.src = "data:text/html,<script>onresize=function(){parent.postMessage(0,'*')}</script>";
	        unsubscribe = listen(window, 'message', (event) => {
	            if (event.source === iframe.contentWindow)
	                fn();
	        });
	    }
	    else {
	        iframe.src = 'about:blank';
	        iframe.onload = () => {
	            unsubscribe = listen(iframe.contentWindow, 'resize', fn);
	            // make sure an initial resize event is fired _after_ the iframe is loaded (which is asynchronous)
	            // see https://github.com/sveltejs/svelte/issues/4233
	            fn();
	        };
	    }
	    append(node, iframe);
	    return () => {
	        if (crossorigin) {
	            unsubscribe();
	        }
	        else if (unsubscribe && iframe.contentWindow) {
	            unsubscribe();
	        }
	        detach(iframe);
	    };
	}
	function toggle_class(element, name, toggle) {
	    element.classList[toggle ? 'add' : 'remove'](name);
	}
	function custom_event(type, detail, { bubbles = false, cancelable = false } = {}) {
	    const e = document.createEvent('CustomEvent');
	    e.initCustomEvent(type, bubbles, cancelable, detail);
	    return e;
	}
	function attribute_to_object(attributes) {
	    const result = {};
	    for (const attribute of attributes) {
	        result[attribute.name] = attribute.value;
	    }
	    return result;
	}

	// we need to store the information for multiple documents because a Svelte application could also contain iframes
	// https://github.com/sveltejs/svelte/issues/3624
	const managed_styles = new Map();
	let active = 0;
	// https://github.com/darkskyapp/string-hash/blob/master/index.js
	function hash$8(str) {
	    let hash = 5381;
	    let i = str.length;
	    while (i--)
	        hash = ((hash << 5) - hash) ^ str.charCodeAt(i);
	    return hash >>> 0;
	}
	function create_style_information(doc, node) {
	    const info = { stylesheet: append_empty_stylesheet(node), rules: {} };
	    managed_styles.set(doc, info);
	    return info;
	}
	function create_rule(node, a, b, duration, delay, ease, fn, uid = 0) {
	    const step = 16.666 / duration;
	    let keyframes = '{\n';
	    for (let p = 0; p <= 1; p += step) {
	        const t = a + (b - a) * ease(p);
	        keyframes += p * 100 + `%{${fn(t, 1 - t)}}\n`;
	    }
	    const rule = keyframes + `100% {${fn(b, 1 - b)}}\n}`;
	    const name = `__svelte_${hash$8(rule)}_${uid}`;
	    const doc = get_root_for_style(node);
	    const { stylesheet, rules } = managed_styles.get(doc) || create_style_information(doc, node);
	    if (!rules[name]) {
	        rules[name] = true;
	        stylesheet.insertRule(`@keyframes ${name} ${rule}`, stylesheet.cssRules.length);
	    }
	    const animation = node.style.animation || '';
	    node.style.animation = `${animation ? `${animation}, ` : ''}${name} ${duration}ms linear ${delay}ms 1 both`;
	    active += 1;
	    return name;
	}
	function delete_rule(node, name) {
	    const previous = (node.style.animation || '').split(', ');
	    const next = previous.filter(name
	        ? anim => anim.indexOf(name) < 0 // remove specific animation
	        : anim => anim.indexOf('__svelte') === -1 // remove all Svelte animations
	    );
	    const deleted = previous.length - next.length;
	    if (deleted) {
	        node.style.animation = next.join(', ');
	        active -= deleted;
	        if (!active)
	            clear_rules();
	    }
	}
	function clear_rules() {
	    raf(() => {
	        if (active)
	            return;
	        managed_styles.forEach(info => {
	            const { ownerNode } = info.stylesheet;
	            // there is no ownerNode if it runs on jsdom.
	            if (ownerNode)
	                detach(ownerNode);
	        });
	        managed_styles.clear();
	    });
	}

	let current_component;
	function set_current_component(component) {
	    current_component = component;
	}
	function get_current_component() {
	    if (!current_component)
	        throw new Error('Function called outside component initialization');
	    return current_component;
	}
	/**
	 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
	 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
	 * it can be called from an external module).
	 *
	 * `onMount` does not run inside a [server-side component](/docs#run-time-server-side-component-api).
	 *
	 * https://svelte.dev/docs#run-time-svelte-onmount
	 */
	function onMount(fn) {
	    get_current_component().$$.on_mount.push(fn);
	}
	/**
	 * Schedules a callback to run immediately before the component is unmounted.
	 *
	 * Out of `onMount`, `beforeUpdate`, `afterUpdate` and `onDestroy`, this is the
	 * only one that runs inside a server-side component.
	 *
	 * https://svelte.dev/docs#run-time-svelte-ondestroy
	 */
	function onDestroy(fn) {
	    get_current_component().$$.on_destroy.push(fn);
	}
	/**
	 * Creates an event dispatcher that can be used to dispatch [component events](/docs#template-syntax-component-directives-on-eventname).
	 * Event dispatchers are functions that can take two arguments: `name` and `detail`.
	 *
	 * Component events created with `createEventDispatcher` create a
	 * [CustomEvent](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent).
	 * These events do not [bubble](https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Events#Event_bubbling_and_capture).
	 * The `detail` argument corresponds to the [CustomEvent.detail](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/detail)
	 * property and can contain any type of data.
	 *
	 * https://svelte.dev/docs#run-time-svelte-createeventdispatcher
	 */
	function createEventDispatcher() {
	    const component = get_current_component();
	    return (type, detail, { cancelable = false } = {}) => {
	        const callbacks = component.$$.callbacks[type];
	        if (callbacks) {
	            // TODO are there situations where events could be dispatched
	            // in a server (non-DOM) environment?
	            const event = custom_event(type, detail, { cancelable });
	            callbacks.slice().forEach(fn => {
	                fn.call(component, event);
	            });
	            return !event.defaultPrevented;
	        }
	        return true;
	    };
	}
	// TODO figure out if we still want to support
	// shorthand events, or if we want to implement
	// a real bubbling mechanism
	function bubble(component, event) {
	    const callbacks = component.$$.callbacks[event.type];
	    if (callbacks) {
	        // @ts-ignore
	        callbacks.slice().forEach(fn => fn.call(this, event));
	    }
	}

	const dirty_components = [];
	const binding_callbacks = [];
	let render_callbacks = [];
	const flush_callbacks = [];
	const resolved_promise = /* @__PURE__ */ Promise.resolve();
	let update_scheduled = false;
	function schedule_update() {
	    if (!update_scheduled) {
	        update_scheduled = true;
	        resolved_promise.then(flush);
	    }
	}
	function add_render_callback(fn) {
	    render_callbacks.push(fn);
	}
	function add_flush_callback(fn) {
	    flush_callbacks.push(fn);
	}
	// flush() calls callbacks in this order:
	// 1. All beforeUpdate callbacks, in order: parents before children
	// 2. All bind:this callbacks, in reverse order: children before parents.
	// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
	//    for afterUpdates called during the initial onMount, which are called in
	//    reverse order: children before parents.
	// Since callbacks might update component values, which could trigger another
	// call to flush(), the following steps guard against this:
	// 1. During beforeUpdate, any updated components will be added to the
	//    dirty_components array and will cause a reentrant call to flush(). Because
	//    the flush index is kept outside the function, the reentrant call will pick
	//    up where the earlier call left off and go through all dirty components. The
	//    current_component value is saved and restored so that the reentrant call will
	//    not interfere with the "parent" flush() call.
	// 2. bind:this callbacks cannot trigger new flush() calls.
	// 3. During afterUpdate, any updated components will NOT have their afterUpdate
	//    callback called a second time; the seen_callbacks set, outside the flush()
	//    function, guarantees this behavior.
	const seen_callbacks = new Set();
	let flushidx = 0; // Do *not* move this inside the flush() function
	function flush() {
	    // Do not reenter flush while dirty components are updated, as this can
	    // result in an infinite loop. Instead, let the inner flush handle it.
	    // Reentrancy is ok afterwards for bindings etc.
	    if (flushidx !== 0) {
	        return;
	    }
	    const saved_component = current_component;
	    do {
	        // first, call beforeUpdate functions
	        // and update components
	        try {
	            while (flushidx < dirty_components.length) {
	                const component = dirty_components[flushidx];
	                flushidx++;
	                set_current_component(component);
	                update$1(component.$$);
	            }
	        }
	        catch (e) {
	            // reset dirty state to not end up in a deadlocked state and then rethrow
	            dirty_components.length = 0;
	            flushidx = 0;
	            throw e;
	        }
	        set_current_component(null);
	        dirty_components.length = 0;
	        flushidx = 0;
	        while (binding_callbacks.length)
	            binding_callbacks.pop()();
	        // then, once components are updated, call
	        // afterUpdate functions. This may cause
	        // subsequent updates...
	        for (let i = 0; i < render_callbacks.length; i += 1) {
	            const callback = render_callbacks[i];
	            if (!seen_callbacks.has(callback)) {
	                // ...so guard against infinite loops
	                seen_callbacks.add(callback);
	                callback();
	            }
	        }
	        render_callbacks.length = 0;
	    } while (dirty_components.length);
	    while (flush_callbacks.length) {
	        flush_callbacks.pop()();
	    }
	    update_scheduled = false;
	    seen_callbacks.clear();
	    set_current_component(saved_component);
	}
	function update$1($$) {
	    if ($$.fragment !== null) {
	        $$.update();
	        run_all($$.before_update);
	        const dirty = $$.dirty;
	        $$.dirty = [-1];
	        $$.fragment && $$.fragment.p($$.ctx, dirty);
	        $$.after_update.forEach(add_render_callback);
	    }
	}
	/**
	 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
	 */
	function flush_render_callbacks(fns) {
	    const filtered = [];
	    const targets = [];
	    render_callbacks.forEach((c) => fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
	    targets.forEach((c) => c());
	    render_callbacks = filtered;
	}

	let promise;
	function wait$1() {
	    if (!promise) {
	        promise = Promise.resolve();
	        promise.then(() => {
	            promise = null;
	        });
	    }
	    return promise;
	}
	function dispatch$8(node, direction, kind) {
	    node.dispatchEvent(custom_event(`${direction ? 'intro' : 'outro'}${kind}`));
	}
	const outroing = new Set();
	let outros;
	function group_outros() {
	    outros = {
	        r: 0,
	        c: [],
	        p: outros // parent group
	    };
	}
	function check_outros() {
	    if (!outros.r) {
	        run_all(outros.c);
	    }
	    outros = outros.p;
	}
	function transition_in(block, local) {
	    if (block && block.i) {
	        outroing.delete(block);
	        block.i(local);
	    }
	}
	function transition_out(block, local, detach, callback) {
	    if (block && block.o) {
	        if (outroing.has(block))
	            return;
	        outroing.add(block);
	        outros.c.push(() => {
	            outroing.delete(block);
	            if (callback) {
	                if (detach)
	                    block.d(1);
	                callback();
	            }
	        });
	        block.o(local);
	    }
	    else if (callback) {
	        callback();
	    }
	}
	const null_transition = { duration: 0 };
	function create_bidirectional_transition(node, fn, params, intro) {
	    const options = { direction: 'both' };
	    let config = fn(node, params, options);
	    let t = intro ? 0 : 1;
	    let running_program = null;
	    let pending_program = null;
	    let animation_name = null;
	    function clear_animation() {
	        if (animation_name)
	            delete_rule(node, animation_name);
	    }
	    function init(program, duration) {
	        const d = (program.b - t);
	        duration *= Math.abs(d);
	        return {
	            a: t,
	            b: program.b,
	            d,
	            duration,
	            start: program.start,
	            end: program.start + duration,
	            group: program.group
	        };
	    }
	    function go(b) {
	        const { delay = 0, duration = 300, easing = identity$2, tick = noop$6, css } = config || null_transition;
	        const program = {
	            start: now() + delay,
	            b
	        };
	        if (!b) {
	            // @ts-ignore todo: improve typings
	            program.group = outros;
	            outros.r += 1;
	        }
	        if (running_program || pending_program) {
	            pending_program = program;
	        }
	        else {
	            // if this is an intro, and there's a delay, we need to do
	            // an initial tick and/or apply CSS animation immediately
	            if (css) {
	                clear_animation();
	                animation_name = create_rule(node, t, b, duration, delay, easing, css);
	            }
	            if (b)
	                tick(0, 1);
	            running_program = init(program, duration);
	            add_render_callback(() => dispatch$8(node, b, 'start'));
	            loop(now => {
	                if (pending_program && now > pending_program.start) {
	                    running_program = init(pending_program, duration);
	                    pending_program = null;
	                    dispatch$8(node, running_program.b, 'start');
	                    if (css) {
	                        clear_animation();
	                        animation_name = create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
	                    }
	                }
	                if (running_program) {
	                    if (now >= running_program.end) {
	                        tick(t = running_program.b, 1 - t);
	                        dispatch$8(node, running_program.b, 'end');
	                        if (!pending_program) {
	                            // we're done
	                            if (running_program.b) {
	                                // intro — we can tidy up immediately
	                                clear_animation();
	                            }
	                            else {
	                                // outro — needs to be coordinated
	                                if (!--running_program.group.r)
	                                    run_all(running_program.group.c);
	                            }
	                        }
	                        running_program = null;
	                    }
	                    else if (now >= running_program.start) {
	                        const p = now - running_program.start;
	                        t = running_program.a + running_program.d * easing(p / running_program.duration);
	                        tick(t, 1 - t);
	                    }
	                }
	                return !!(running_program || pending_program);
	            });
	        }
	    }
	    return {
	        run(b) {
	            if (is_function(config)) {
	                wait$1().then(() => {
	                    // @ts-ignore
	                    config = config(options);
	                    go(b);
	                });
	            }
	            else {
	                go(b);
	            }
	        },
	        end() {
	            clear_animation();
	            running_program = pending_program = null;
	        }
	    };
	}

	function get_spread_update(levels, updates) {
	    const update = {};
	    const to_null_out = {};
	    const accounted_for = { $$scope: 1 };
	    let i = levels.length;
	    while (i--) {
	        const o = levels[i];
	        const n = updates[i];
	        if (n) {
	            for (const key in o) {
	                if (!(key in n))
	                    to_null_out[key] = 1;
	            }
	            for (const key in n) {
	                if (!accounted_for[key]) {
	                    update[key] = n[key];
	                    accounted_for[key] = 1;
	                }
	            }
	            levels[i] = n;
	        }
	        else {
	            for (const key in o) {
	                accounted_for[key] = 1;
	            }
	        }
	    }
	    for (const key in to_null_out) {
	        if (!(key in update))
	            update[key] = undefined;
	    }
	    return update;
	}

	function bind$4(component, name, callback) {
	    const index = component.$$.props[name];
	    if (index !== undefined) {
	        component.$$.bound[index] = callback;
	        callback(component.$$.ctx[index]);
	    }
	}
	function create_component(block) {
	    block && block.c();
	}
	function mount_component(component, target, anchor, customElement) {
	    const { fragment, after_update } = component.$$;
	    fragment && fragment.m(target, anchor);
	    if (!customElement) {
	        // onMount happens before the initial afterUpdate
	        add_render_callback(() => {
	            const new_on_destroy = component.$$.on_mount.map(run$1).filter(is_function);
	            // if the component was destroyed immediately
	            // it will update the `$$.on_destroy` reference to `null`.
	            // the destructured on_destroy may still reference to the old array
	            if (component.$$.on_destroy) {
	                component.$$.on_destroy.push(...new_on_destroy);
	            }
	            else {
	                // Edge case - component was destroyed immediately,
	                // most likely as a result of a binding initialising
	                run_all(new_on_destroy);
	            }
	            component.$$.on_mount = [];
	        });
	    }
	    after_update.forEach(add_render_callback);
	}
	function destroy_component(component, detaching) {
	    const $$ = component.$$;
	    if ($$.fragment !== null) {
	        flush_render_callbacks($$.after_update);
	        run_all($$.on_destroy);
	        $$.fragment && $$.fragment.d(detaching);
	        // TODO null out other refs, including component.$$ (but need to
	        // preserve final state?)
	        $$.on_destroy = $$.fragment = null;
	        $$.ctx = [];
	    }
	}
	function make_dirty(component, i) {
	    if (component.$$.dirty[0] === -1) {
	        dirty_components.push(component);
	        schedule_update();
	        component.$$.dirty.fill(0);
	    }
	    component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
	}
	function init$3(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [-1]) {
	    const parent_component = current_component;
	    set_current_component(component);
	    const $$ = component.$$ = {
	        fragment: null,
	        ctx: [],
	        // state
	        props,
	        update: noop$6,
	        not_equal,
	        bound: blank_object(),
	        // lifecycle
	        on_mount: [],
	        on_destroy: [],
	        on_disconnect: [],
	        before_update: [],
	        after_update: [],
	        context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
	        // everything else
	        callbacks: blank_object(),
	        dirty,
	        skip_bound: false,
	        root: options.target || parent_component.$$.root
	    };
	    append_styles && append_styles($$.root);
	    let ready = false;
	    $$.ctx = instance
	        ? instance(component, options.props || {}, (i, ret, ...rest) => {
	            const value = rest.length ? rest[0] : ret;
	            if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
	                if (!$$.skip_bound && $$.bound[i])
	                    $$.bound[i](value);
	                if (ready)
	                    make_dirty(component, i);
	            }
	            return ret;
	        })
	        : [];
	    $$.update();
	    ready = true;
	    run_all($$.before_update);
	    // `false` as a special case of no DOM component
	    $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
	    if (options.target) {
	        if (options.hydrate) {
	            const nodes = children$1(options.target);
	            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	            $$.fragment && $$.fragment.l(nodes);
	            nodes.forEach(detach);
	        }
	        else {
	            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	            $$.fragment && $$.fragment.c();
	        }
	        if (options.intro)
	            transition_in(component.$$.fragment);
	        mount_component(component, options.target, options.anchor, options.customElement);
	        flush();
	    }
	    set_current_component(parent_component);
	}
	/**
	 * Base class for Svelte components. Used when dev=false.
	 */
	class SvelteComponent {
	    $destroy() {
	        destroy_component(this, 1);
	        this.$destroy = noop$6;
	    }
	    $on(type, callback) {
	        if (!is_function(callback)) {
	            return noop$6;
	        }
	        const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
	        callbacks.push(callback);
	        return () => {
	            const index = callbacks.indexOf(callback);
	            if (index !== -1)
	                callbacks.splice(index, 1);
	        };
	    }
	    $set($$props) {
	        if (this.$$set && !is_empty($$props)) {
	            this.$$.skip_bound = true;
	            this.$$set($$props);
	            this.$$.skip_bound = false;
	        }
	    }
	}

	const subscriber_queue = [];
	/**
	 * Creates a `Readable` store that allows reading by subscription.
	 * @param value initial value
	 * @param {StartStopNotifier} [start]
	 */
	function readable(value, start) {
	    return {
	        subscribe: writable(value, start).subscribe
	    };
	}
	/**
	 * Create a `Writable` store that allows both updating and reading by subscription.
	 * @param {*=}value initial value
	 * @param {StartStopNotifier=} start
	 */
	function writable(value, start = noop$6) {
	    let stop;
	    const subscribers = new Set();
	    function set(new_value) {
	        if (safe_not_equal(value, new_value)) {
	            value = new_value;
	            if (stop) { // store is ready
	                const run_queue = !subscriber_queue.length;
	                for (const subscriber of subscribers) {
	                    subscriber[1]();
	                    subscriber_queue.push(subscriber, value);
	                }
	                if (run_queue) {
	                    for (let i = 0; i < subscriber_queue.length; i += 2) {
	                        subscriber_queue[i][0](subscriber_queue[i + 1]);
	                    }
	                    subscriber_queue.length = 0;
	                }
	            }
	        }
	    }
	    function update(fn) {
	        set(fn(value));
	    }
	    function subscribe(run, invalidate = noop$6) {
	        const subscriber = [run, invalidate];
	        subscribers.add(subscriber);
	        if (subscribers.size === 1) {
	            stop = start(set) || noop$6;
	        }
	        run(value);
	        return () => {
	            subscribers.delete(subscriber);
	            if (subscribers.size === 0 && stop) {
	                stop();
	                stop = null;
	            }
	        };
	    }
	    return { set, update, subscribe };
	}
	function derived(stores, fn, initial_value) {
	    const single = !Array.isArray(stores);
	    const stores_array = single
	        ? [stores]
	        : stores;
	    const auto = fn.length < 2;
	    return readable(initial_value, (set) => {
	        let started = false;
	        const values = [];
	        let pending = 0;
	        let cleanup = noop$6;
	        const sync = () => {
	            if (pending) {
	                return;
	            }
	            cleanup();
	            const result = fn(single ? values[0] : values, set);
	            if (auto) {
	                set(result);
	            }
	            else {
	                cleanup = is_function(result) ? result : noop$6;
	            }
	        };
	        const unsubscribers = stores_array.map((store, i) => subscribe$1(store, (value) => {
	            values[i] = value;
	            pending &= ~(1 << i);
	            if (started) {
	                sync();
	            }
	        }, () => {
	            pending |= (1 << i);
	        }));
	        started = true;
	        sync();
	        return function stop() {
	            run_all(unsubscribers);
	            cleanup();
	            // We need to set this to false because callbacks can still happen despite having unsubscribed:
	            // Callbacks might already be placed in the queue which doesn't know it should no longer
	            // invoke this derived store.
	            started = false;
	        };
	    });
	}

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */

	var __assign$2 = function() {
	    __assign$2 = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign$2.apply(this, arguments);
	};

	function __rest$3(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	}

	function __values$2(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	}

	function __read$2(o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	}

	function __spreadArray$2(to, from, pack) {
	    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	        if (ar || !(i in from)) {
	            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	            ar[i] = from[i];
	        }
	    }
	    return to.concat(ar || Array.prototype.slice.call(from));
	}

	var ActionTypes;

	(function (ActionTypes) {
	  ActionTypes["Start"] = "xstate.start";
	  ActionTypes["Stop"] = "xstate.stop";
	  ActionTypes["Raise"] = "xstate.raise";
	  ActionTypes["Send"] = "xstate.send";
	  ActionTypes["Cancel"] = "xstate.cancel";
	  ActionTypes["NullEvent"] = "";
	  ActionTypes["Assign"] = "xstate.assign";
	  ActionTypes["After"] = "xstate.after";
	  ActionTypes["DoneState"] = "done.state";
	  ActionTypes["DoneInvoke"] = "done.invoke";
	  ActionTypes["Log"] = "xstate.log";
	  ActionTypes["Init"] = "xstate.init";
	  ActionTypes["Invoke"] = "xstate.invoke";
	  ActionTypes["ErrorExecution"] = "error.execution";
	  ActionTypes["ErrorCommunication"] = "error.communication";
	  ActionTypes["ErrorPlatform"] = "error.platform";
	  ActionTypes["ErrorCustom"] = "xstate.error";
	  ActionTypes["Update"] = "xstate.update";
	  ActionTypes["Pure"] = "xstate.pure";
	  ActionTypes["Choose"] = "xstate.choose";
	})(ActionTypes || (ActionTypes = {}));

	var SpecialTargets;

	(function (SpecialTargets) {
	  SpecialTargets["Parent"] = "#_parent";
	  SpecialTargets["Internal"] = "#_internal";
	})(SpecialTargets || (SpecialTargets = {}));

	var start$1 = ActionTypes.Start;
	var stop$1 = ActionTypes.Stop;
	var raise$1 = ActionTypes.Raise;
	var send$2 = ActionTypes.Send;
	var cancel$1 = ActionTypes.Cancel;
	var nullEvent = ActionTypes.NullEvent;
	var assign$5 = ActionTypes.Assign;
	ActionTypes.After;
	ActionTypes.DoneState;
	var log$1 = ActionTypes.Log;
	var init$2 = ActionTypes.Init;
	var invoke = ActionTypes.Invoke;
	ActionTypes.ErrorExecution;
	var errorPlatform = ActionTypes.ErrorPlatform;
	var error$1 = ActionTypes.ErrorCustom;
	var update = ActionTypes.Update;
	var choose = ActionTypes.Choose;
	var pure = ActionTypes.Pure;

	var STATE_DELIMITER = '.';
	var EMPTY_ACTIVITY_MAP = {};
	var DEFAULT_GUARD_TYPE = 'xstate.guard';
	var TARGETLESS_KEY = '';

	var _a;
	function matchesState(parentStateId, childStateId, delimiter) {
	  if (delimiter === void 0) {
	    delimiter = STATE_DELIMITER;
	  }

	  var parentStateValue = toStateValue(parentStateId, delimiter);
	  var childStateValue = toStateValue(childStateId, delimiter);

	  if (isString$2(childStateValue)) {
	    if (isString$2(parentStateValue)) {
	      return childStateValue === parentStateValue;
	    } // Parent more specific than child


	    return false;
	  }

	  if (isString$2(parentStateValue)) {
	    return parentStateValue in childStateValue;
	  }

	  return Object.keys(parentStateValue).every(function (key) {
	    if (!(key in childStateValue)) {
	      return false;
	    }

	    return matchesState(parentStateValue[key], childStateValue[key]);
	  });
	}
	function getEventType(event) {
	  try {
	    return isString$2(event) || typeof event === 'number' ? "".concat(event) : event.type;
	  } catch (e) {
	    throw new Error('Events must be strings or objects with a string event.type property.');
	  }
	}
	function toStatePath(stateId, delimiter) {
	  try {
	    if (isArray$6(stateId)) {
	      return stateId;
	    }

	    return stateId.toString().split(delimiter);
	  } catch (e) {
	    throw new Error("'".concat(stateId, "' is not a valid state path."));
	  }
	}
	function isStateLike(state) {
	  return typeof state === 'object' && 'value' in state && 'context' in state && 'event' in state && '_event' in state;
	}
	function toStateValue(stateValue, delimiter) {
	  if (isStateLike(stateValue)) {
	    return stateValue.value;
	  }

	  if (isArray$6(stateValue)) {
	    return pathToStateValue(stateValue);
	  }

	  if (typeof stateValue !== 'string') {
	    return stateValue;
	  }

	  var statePath = toStatePath(stateValue, delimiter);
	  return pathToStateValue(statePath);
	}
	function pathToStateValue(statePath) {
	  if (statePath.length === 1) {
	    return statePath[0];
	  }

	  var value = {};
	  var marker = value;

	  for (var i = 0; i < statePath.length - 1; i++) {
	    if (i === statePath.length - 2) {
	      marker[statePath[i]] = statePath[i + 1];
	    } else {
	      marker[statePath[i]] = {};
	      marker = marker[statePath[i]];
	    }
	  }

	  return value;
	}
	function mapValues(collection, iteratee) {
	  var result = {};
	  var collectionKeys = Object.keys(collection);

	  for (var i = 0; i < collectionKeys.length; i++) {
	    var key = collectionKeys[i];
	    result[key] = iteratee(collection[key], key, collection, i);
	  }

	  return result;
	}
	function mapFilterValues(collection, iteratee, predicate) {
	  var e_1, _a;

	  var result = {};

	  try {
	    for (var _b = __values$2(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()) {
	      var key = _c.value;
	      var item = collection[key];

	      if (!predicate(item)) {
	        continue;
	      }

	      result[key] = iteratee(item, key, collection);
	    }
	  } catch (e_1_1) {
	    e_1 = {
	      error: e_1_1
	    };
	  } finally {
	    try {
	      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	    } finally {
	      if (e_1) throw e_1.error;
	    }
	  }

	  return result;
	}
	/**
	 * Retrieves a value at the given path.
	 * @param props The deep path to the prop of the desired value
	 */

	var path = function (props) {
	  return function (object) {
	    var e_2, _a;

	    var result = object;

	    try {
	      for (var props_1 = __values$2(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
	        var prop = props_1_1.value;
	        result = result[prop];
	      }
	    } catch (e_2_1) {
	      e_2 = {
	        error: e_2_1
	      };
	    } finally {
	      try {
	        if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
	      } finally {
	        if (e_2) throw e_2.error;
	      }
	    }

	    return result;
	  };
	};
	/**
	 * Retrieves a value at the given path via the nested accessor prop.
	 * @param props The deep path to the prop of the desired value
	 */

	function nestedPath(props, accessorProp) {
	  return function (object) {
	    var e_3, _a;

	    var result = object;

	    try {
	      for (var props_2 = __values$2(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()) {
	        var prop = props_2_1.value;
	        result = result[accessorProp][prop];
	      }
	    } catch (e_3_1) {
	      e_3 = {
	        error: e_3_1
	      };
	    } finally {
	      try {
	        if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
	      } finally {
	        if (e_3) throw e_3.error;
	      }
	    }

	    return result;
	  };
	}
	function toStatePaths(stateValue) {
	  if (!stateValue) {
	    return [[]];
	  }

	  if (isString$2(stateValue)) {
	    return [[stateValue]];
	  }

	  var result = flatten(Object.keys(stateValue).map(function (key) {
	    var subStateValue = stateValue[key];

	    if (typeof subStateValue !== 'string' && (!subStateValue || !Object.keys(subStateValue).length)) {
	      return [[key]];
	    }

	    return toStatePaths(stateValue[key]).map(function (subPath) {
	      return [key].concat(subPath);
	    });
	  }));
	  return result;
	}
	function flatten(array) {
	  var _a;

	  return (_a = []).concat.apply(_a, __spreadArray$2([], __read$2(array), false));
	}
	function toArrayStrict(value) {
	  if (isArray$6(value)) {
	    return value;
	  }

	  return [value];
	}
	function toArray$2(value) {
	  if (value === undefined) {
	    return [];
	  }

	  return toArrayStrict(value);
	}
	function mapContext(mapper, context, _event) {
	  var e_5, _a;

	  if (isFunction$2(mapper)) {
	    return mapper(context, _event.data);
	  }

	  var result = {};

	  try {
	    for (var _b = __values$2(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()) {
	      var key = _c.value;
	      var subMapper = mapper[key];

	      if (isFunction$2(subMapper)) {
	        result[key] = subMapper(context, _event.data);
	      } else {
	        result[key] = subMapper;
	      }
	    }
	  } catch (e_5_1) {
	    e_5 = {
	      error: e_5_1
	    };
	  } finally {
	    try {
	      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	    } finally {
	      if (e_5) throw e_5.error;
	    }
	  }

	  return result;
	}
	function isBuiltInEvent(eventType) {
	  return /^(done|error)\./.test(eventType);
	}
	function isPromiseLike(value) {
	  if (value instanceof Promise) {
	    return true;
	  } // Check if shape matches the Promise/A+ specification for a "thenable".


	  if (value !== null && (isFunction$2(value) || typeof value === 'object') && isFunction$2(value.then)) {
	    return true;
	  }

	  return false;
	}
	function isBehavior(value) {
	  return value !== null && typeof value === 'object' && 'transition' in value && typeof value.transition === 'function';
	}
	function partition$2(items, predicate) {
	  var e_6, _a;

	  var _b = __read$2([[], []], 2),
	      truthy = _b[0],
	      falsy = _b[1];

	  try {
	    for (var items_1 = __values$2(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
	      var item = items_1_1.value;

	      if (predicate(item)) {
	        truthy.push(item);
	      } else {
	        falsy.push(item);
	      }
	    }
	  } catch (e_6_1) {
	    e_6 = {
	      error: e_6_1
	    };
	  } finally {
	    try {
	      if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
	    } finally {
	      if (e_6) throw e_6.error;
	    }
	  }

	  return [truthy, falsy];
	}
	function updateHistoryStates(hist, stateValue) {
	  return mapValues(hist.states, function (subHist, key) {
	    if (!subHist) {
	      return undefined;
	    }

	    var subStateValue = (isString$2(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);

	    if (!subStateValue) {
	      return undefined;
	    }

	    return {
	      current: subStateValue,
	      states: updateHistoryStates(subHist, subStateValue)
	    };
	  });
	}
	function updateHistoryValue(hist, stateValue) {
	  return {
	    current: stateValue,
	    states: updateHistoryStates(hist, stateValue)
	  };
	}
	function updateContext(context, _event, assignActions, state) {
	  {
	    warn(!!context, 'Attempting to update undefined context');
	  }

	  var updatedContext = context ? assignActions.reduce(function (acc, assignAction) {
	    var e_7, _a;

	    var assignment = assignAction.assignment;
	    var meta = {
	      state: state,
	      action: assignAction,
	      _event: _event
	    };
	    var partialUpdate = {};

	    if (isFunction$2(assignment)) {
	      partialUpdate = assignment(acc, _event.data, meta);
	    } else {
	      try {
	        for (var _b = __values$2(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()) {
	          var key = _c.value;
	          var propAssignment = assignment[key];
	          partialUpdate[key] = isFunction$2(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
	        }
	      } catch (e_7_1) {
	        e_7 = {
	          error: e_7_1
	        };
	      } finally {
	        try {
	          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        } finally {
	          if (e_7) throw e_7.error;
	        }
	      }
	    }

	    return Object.assign({}, acc, partialUpdate);
	  }, context) : context;
	  return updatedContext;
	} // tslint:disable-next-line:no-empty

	var warn = function () {};

	{
	  warn = function (condition, message) {
	    var error = condition instanceof Error ? condition : undefined;

	    if (!error && condition) {
	      return;
	    }

	    if (console !== undefined) {
	      var args = ["Warning: ".concat(message)];

	      if (error) {
	        args.push(error);
	      } // tslint:disable-next-line:no-console


	      console.warn.apply(console, args);
	    }
	  };
	}
	function isArray$6(value) {
	  return Array.isArray(value);
	} // tslint:disable-next-line:ban-types

	function isFunction$2(value) {
	  return typeof value === 'function';
	}
	function isString$2(value) {
	  return typeof value === 'string';
	}
	function toGuard(condition, guardMap) {
	  if (!condition) {
	    return undefined;
	  }

	  if (isString$2(condition)) {
	    return {
	      type: DEFAULT_GUARD_TYPE,
	      name: condition,
	      predicate: guardMap ? guardMap[condition] : undefined
	    };
	  }

	  if (isFunction$2(condition)) {
	    return {
	      type: DEFAULT_GUARD_TYPE,
	      name: condition.name,
	      predicate: condition
	    };
	  }

	  return condition;
	}
	function isObservable$1(value) {
	  try {
	    return 'subscribe' in value && isFunction$2(value.subscribe);
	  } catch (e) {
	    return false;
	  }
	}
	var symbolObservable = /*#__PURE__*/function () {
	  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
	}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages

	(_a = {}, _a[symbolObservable] = function () {
	  return this;
	}, _a[Symbol.observable] = function () {
	  return this;
	}, _a);
	function isMachine(value) {
	  return !!value && '__xstatenode' in value;
	}
	function isActor$1(value) {
	  return !!value && typeof value.send === 'function';
	}
	function toEventObject(event, payload // id?: TEvent['type']
	) {
	  if (isString$2(event) || typeof event === 'number') {
	    return __assign$2({
	      type: event
	    }, payload);
	  }

	  return event;
	}
	function toSCXMLEvent(event, scxmlEvent) {
	  if (!isString$2(event) && '$$type' in event && event.$$type === 'scxml') {
	    return event;
	  }

	  var eventObject = toEventObject(event);
	  return __assign$2({
	    name: eventObject.type,
	    data: eventObject,
	    $$type: 'scxml',
	    type: 'external'
	  }, scxmlEvent);
	}
	function toTransitionConfigArray(event, configLike) {
	  var transitions = toArrayStrict(configLike).map(function (transitionLike) {
	    if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string' || isMachine(transitionLike)) {
	      return {
	        target: transitionLike,
	        event: event
	      };
	    }

	    return __assign$2(__assign$2({}, transitionLike), {
	      event: event
	    });
	  });
	  return transitions;
	}
	function normalizeTarget(target) {
	  if (target === undefined || target === TARGETLESS_KEY) {
	    return undefined;
	  }

	  return toArray$2(target);
	}
	function reportUnhandledExceptionOnInvocation(originalError, currentError, id) {
	  {
	    var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : '';

	    if (originalError === currentError) {
	      // tslint:disable-next-line:no-console
	      console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
	    } else {
	      var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ''; // tslint:disable-next-line:no-console

	      console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
	    }
	  }
	}
	function evaluateGuard(machine, guard, context, _event, state) {
	  var guards = machine.options.guards;
	  var guardMeta = {
	    state: state,
	    cond: guard,
	    _event: _event
	  }; // TODO: do not hardcode!

	  if (guard.type === DEFAULT_GUARD_TYPE) {
	    return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
	  }

	  var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];

	  if (!condFn) {
	    throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
	  }

	  return condFn(context, _event.data, guardMeta);
	}
	function toInvokeSource$1(src) {
	  if (typeof src === 'string') {
	    return {
	      type: src
	    };
	  }

	  return src;
	}
	function toObserver(nextHandler, errorHandler, completionHandler) {
	  var noop = function () {};

	  var isObserver = typeof nextHandler === 'object';
	  var self = isObserver ? nextHandler : null;
	  return {
	    next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
	    error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
	    complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
	  };
	}
	function createInvokeId(stateNodeId, index) {
	  return "".concat(stateNodeId, ":invocation[").concat(index, "]");
	}
	function isRaisableAction(action) {
	  return (action.type === raise$1 || action.type === send$2 && action.to === SpecialTargets.Internal) && typeof action.delay !== 'number';
	}

	var initEvent = /*#__PURE__*/toSCXMLEvent({
	  type: init$2
	});
	function getActionFunction(actionType, actionFunctionMap) {
	  return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
	}
	function toActionObject(action, actionFunctionMap) {
	  var actionObject;

	  if (isString$2(action) || typeof action === 'number') {
	    var exec = getActionFunction(action, actionFunctionMap);

	    if (isFunction$2(exec)) {
	      actionObject = {
	        type: action,
	        exec: exec
	      };
	    } else if (exec) {
	      actionObject = exec;
	    } else {
	      actionObject = {
	        type: action,
	        exec: undefined
	      };
	    }
	  } else if (isFunction$2(action)) {
	    actionObject = {
	      // Convert action to string if unnamed
	      type: action.name || action.toString(),
	      exec: action
	    };
	  } else {
	    var exec = getActionFunction(action.type, actionFunctionMap);

	    if (isFunction$2(exec)) {
	      actionObject = __assign$2(__assign$2({}, action), {
	        exec: exec
	      });
	    } else if (exec) {
	      var actionType = exec.type || action.type;
	      actionObject = __assign$2(__assign$2(__assign$2({}, exec), action), {
	        type: actionType
	      });
	    } else {
	      actionObject = action;
	    }
	  }

	  return actionObject;
	}
	var toActionObjects = function (action, actionFunctionMap) {
	  if (!action) {
	    return [];
	  }

	  var actions = isArray$6(action) ? action : [action];
	  return actions.map(function (subAction) {
	    return toActionObject(subAction, actionFunctionMap);
	  });
	};
	function toActivityDefinition(action) {
	  var actionObject = toActionObject(action);
	  return __assign$2(__assign$2({
	    id: isString$2(action) ? action : actionObject.id
	  }, actionObject), {
	    type: actionObject.type
	  });
	}
	/**
	 * Raises an event. This places the event in the internal event queue, so that
	 * the event is immediately consumed by the machine in the current step.
	 *
	 * @param eventType The event to raise.
	 */

	function raise(event, options) {
	  return {
	    type: raise$1,
	    event: typeof event === 'function' ? event : toEventObject(event),
	    delay: options ? options.delay : undefined,
	    id: options === null || options === void 0 ? void 0 : options.id
	  };
	}
	function resolveRaise(action, ctx, _event, delaysMap) {
	  var meta = {
	    _event: _event
	  };
	  var resolvedEvent = toSCXMLEvent(isFunction$2(action.event) ? action.event(ctx, _event.data, meta) : action.event);
	  var resolvedDelay;

	  if (isString$2(action.delay)) {
	    var configDelay = delaysMap && delaysMap[action.delay];
	    resolvedDelay = isFunction$2(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
	  } else {
	    resolvedDelay = isFunction$2(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
	  }

	  return __assign$2(__assign$2({}, action), {
	    type: raise$1,
	    _event: resolvedEvent,
	    delay: resolvedDelay
	  });
	}
	/**
	 * Sends an event. This returns an action that will be read by an interpreter to
	 * send the event in the next step, after the current step is finished executing.
	 *
	 * @deprecated Use the `sendTo(...)` action creator instead.
	 *
	 * @param event The event to send.
	 * @param options Options to pass into the send event:
	 *  - `id` - The unique send event identifier (used with `cancel()`).
	 *  - `delay` - The number of milliseconds to delay the sending of the event.
	 *  - `to` - The target of this event (by default, the machine the event was sent from).
	 */

	function send$1(event, options) {
	  return {
	    to: options ? options.to : undefined,
	    type: send$2,
	    event: isFunction$2(event) ? event : toEventObject(event),
	    delay: options ? options.delay : undefined,
	    // TODO: don't auto-generate IDs here like that
	    // there is too big chance of the ID collision
	    id: options && options.id !== undefined ? options.id : isFunction$2(event) ? event.name : getEventType(event)
	  };
	}
	function resolveSend(action, ctx, _event, delaysMap) {
	  var meta = {
	    _event: _event
	  }; // TODO: helper function for resolving Expr

	  var resolvedEvent = toSCXMLEvent(isFunction$2(action.event) ? action.event(ctx, _event.data, meta) : action.event);
	  var resolvedDelay;

	  if (isString$2(action.delay)) {
	    var configDelay = delaysMap && delaysMap[action.delay];
	    resolvedDelay = isFunction$2(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
	  } else {
	    resolvedDelay = isFunction$2(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
	  }

	  var resolvedTarget = isFunction$2(action.to) ? action.to(ctx, _event.data, meta) : action.to;
	  return __assign$2(__assign$2({}, action), {
	    to: resolvedTarget,
	    _event: resolvedEvent,
	    event: resolvedEvent.data,
	    delay: resolvedDelay
	  });
	}
	var resolveLog = function (action, ctx, _event) {
	  return __assign$2(__assign$2({}, action), {
	    value: isString$2(action.expr) ? action.expr : action.expr(ctx, _event.data, {
	      _event: _event
	    })
	  });
	};
	/**
	 * Cancels an in-flight `send(...)` action. A canceled sent action will not
	 * be executed, nor will its event be sent, unless it has already been sent
	 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
	 *
	 * @param sendId The `id` of the `send(...)` action to cancel.
	 */

	var cancel = function (sendId) {
	  return {
	    type: cancel$1,
	    sendId: sendId
	  };
	};
	/**
	 * Starts an activity.
	 *
	 * @param activity The activity to start.
	 */

	function start(activity) {
	  var activityDef = toActivityDefinition(activity);
	  return {
	    type: ActionTypes.Start,
	    activity: activityDef,
	    exec: undefined
	  };
	}
	/**
	 * Stops an activity.
	 *
	 * @param actorRef The activity to stop.
	 */

	function stop(actorRef) {
	  var activity = isFunction$2(actorRef) ? actorRef : toActivityDefinition(actorRef);
	  return {
	    type: ActionTypes.Stop,
	    activity: activity,
	    exec: undefined
	  };
	}
	function resolveStop(action, context, _event) {
	  var actorRefOrString = isFunction$2(action.activity) ? action.activity(context, _event.data) : action.activity;
	  var resolvedActorRef = typeof actorRefOrString === 'string' ? {
	    id: actorRefOrString
	  } : actorRefOrString;
	  var actionObject = {
	    type: ActionTypes.Stop,
	    activity: resolvedActorRef
	  };
	  return actionObject;
	}
	/**
	 * Updates the current context of the machine.
	 *
	 * @param assignment An object that represents the partial context to update.
	 */

	var assign$4 = function (assignment) {
	  return {
	    type: assign$5,
	    assignment: assignment
	  };
	};
	/**
	 * Returns an event type that represents an implicit event that
	 * is sent after the specified `delay`.
	 *
	 * @param delayRef The delay in milliseconds
	 * @param id The state node ID where this event is handled
	 */

	function after(delayRef, id) {
	  var idSuffix = id ? "#".concat(id) : '';
	  return "".concat(ActionTypes.After, "(").concat(delayRef, ")").concat(idSuffix);
	}
	/**
	 * Returns an event that represents that a final state node
	 * has been reached in the parent state node.
	 *
	 * @param id The final state node's parent state node `id`
	 * @param data The data to pass into the event
	 */

	function done$1(id, data) {
	  var type = "".concat(ActionTypes.DoneState, ".").concat(id);
	  var eventObject = {
	    type: type,
	    data: data
	  };

	  eventObject.toString = function () {
	    return type;
	  };

	  return eventObject;
	}
	/**
	 * Returns an event that represents that an invoked service has terminated.
	 *
	 * An invoked service is terminated when it has reached a top-level final state node,
	 * but not when it is canceled.
	 *
	 * @param id The final state node ID
	 * @param data The data to pass into the event
	 */

	function doneInvoke(id, data) {
	  var type = "".concat(ActionTypes.DoneInvoke, ".").concat(id);
	  var eventObject = {
	    type: type,
	    data: data
	  };

	  eventObject.toString = function () {
	    return type;
	  };

	  return eventObject;
	}
	function error(id, data) {
	  var type = "".concat(ActionTypes.ErrorPlatform, ".").concat(id);
	  var eventObject = {
	    type: type,
	    data: data
	  };

	  eventObject.toString = function () {
	    return type;
	  };

	  return eventObject;
	}

	var pluckAssigns = function (actionBlocks) {
	  var e_1, _a;

	  var assignActions = [];

	  try {
	    for (var actionBlocks_1 = __values$2(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()) {
	      var block = actionBlocks_1_1.value;
	      var i = 0;

	      while (i < block.actions.length) {
	        if (block.actions[i].type === assign$5) {
	          assignActions.push(block.actions[i]);
	          block.actions.splice(i, 1);
	          continue;
	        }

	        i++;
	      }
	    }
	  } catch (e_1_1) {
	    e_1 = {
	      error: e_1_1
	    };
	  } finally {
	    try {
	      if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
	    } finally {
	      if (e_1) throw e_1.error;
	    }
	  }

	  return assignActions;
	};

	function resolveActions(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
	  if (preserveActionOrder === void 0) {
	    preserveActionOrder = false;
	  }

	  var assignActions = preserveActionOrder ? [] : pluckAssigns(actionBlocks);
	  var updatedContext = assignActions.length ? updateContext(currentContext, _event, assignActions, currentState) : currentContext;
	  var preservedContexts = preserveActionOrder ? [currentContext] : undefined;
	  var deferredToBlockEnd = [];

	  function handleAction(blockType, actionObject) {
	    var _a;

	    switch (actionObject.type) {
	      case raise$1:
	        {
	          var raisedAction = resolveRaise(actionObject, updatedContext, _event, machine.options.delays);

	          if (predictableExec && typeof raisedAction.delay === 'number') {
	            predictableExec(raisedAction, updatedContext, _event);
	          }

	          return raisedAction;
	        }

	      case send$2:
	        var sendAction = resolveSend(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init

	        {
	          var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here

	          warn(!isString$2(configuredDelay) || typeof sendAction.delay === 'number', // tslint:disable-next-line:max-line-length
	          "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
	        }

	        if (predictableExec && sendAction.to !== SpecialTargets.Internal) {
	          if (blockType === 'entry') {
	            deferredToBlockEnd.push(sendAction);
	          } else {
	            predictableExec(sendAction, updatedContext, _event);
	          }
	        }

	        return sendAction;

	      case log$1:
	        {
	          var resolved = resolveLog(actionObject, updatedContext, _event);
	          predictableExec === null || predictableExec === void 0 ? void 0 : predictableExec(resolved, updatedContext, _event);
	          return resolved;
	        }

	      case choose:
	        {
	          var chooseAction = actionObject;
	          var matchedActions = (_a = chooseAction.conds.find(function (condition) {
	            var guard = toGuard(condition.cond, machine.options.guards);
	            return !guard || evaluateGuard(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
	          })) === null || _a === void 0 ? void 0 : _a.actions;

	          if (!matchedActions) {
	            return [];
	          }

	          var _b = __read$2(resolveActions(machine, currentState, updatedContext, _event, [{
	            type: blockType,
	            actions: toActionObjects(toArray$2(matchedActions), machine.options.actions)
	          }], predictableExec, preserveActionOrder), 2),
	              resolvedActionsFromChoose = _b[0],
	              resolvedContextFromChoose = _b[1];

	          updatedContext = resolvedContextFromChoose;
	          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
	          return resolvedActionsFromChoose;
	        }

	      case pure:
	        {
	          var matchedActions = actionObject.get(updatedContext, _event.data);

	          if (!matchedActions) {
	            return [];
	          }

	          var _c = __read$2(resolveActions(machine, currentState, updatedContext, _event, [{
	            type: blockType,
	            actions: toActionObjects(toArray$2(matchedActions), machine.options.actions)
	          }], predictableExec, preserveActionOrder), 2),
	              resolvedActionsFromPure = _c[0],
	              resolvedContext = _c[1];

	          updatedContext = resolvedContext;
	          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
	          return resolvedActionsFromPure;
	        }

	      case stop$1:
	        {
	          var resolved = resolveStop(actionObject, updatedContext, _event);
	          predictableExec === null || predictableExec === void 0 ? void 0 : predictableExec(resolved, currentContext, _event);
	          return resolved;
	        }

	      case assign$5:
	        {
	          updatedContext = updateContext(updatedContext, _event, [actionObject], !predictableExec ? currentState : undefined);
	          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
	          break;
	        }

	      default:
	        var resolvedActionObject = toActionObject(actionObject, machine.options.actions);
	        var exec_1 = resolvedActionObject.exec;

	        if (predictableExec) {
	          predictableExec(resolvedActionObject, updatedContext, _event);
	        } else if (exec_1 && preservedContexts) {
	          var contextIndex_1 = preservedContexts.length - 1;

	          var wrapped = __assign$2(__assign$2({}, resolvedActionObject), {
	            exec: function (_ctx) {
	              var args = [];

	              for (var _i = 1; _i < arguments.length; _i++) {
	                args[_i - 1] = arguments[_i];
	              }

	              exec_1.apply(void 0, __spreadArray$2([preservedContexts[contextIndex_1]], __read$2(args), false));
	            }
	          });

	          resolvedActionObject = wrapped;
	        }

	        return resolvedActionObject;
	    }
	  }

	  function processBlock(block) {
	    var e_2, _a;

	    var resolvedActions = [];

	    try {
	      for (var _b = __values$2(block.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
	        var action = _c.value;
	        var resolved = handleAction(block.type, action);

	        if (resolved) {
	          resolvedActions = resolvedActions.concat(resolved);
	        }
	      }
	    } catch (e_2_1) {
	      e_2 = {
	        error: e_2_1
	      };
	    } finally {
	      try {
	        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	      } finally {
	        if (e_2) throw e_2.error;
	      }
	    }

	    deferredToBlockEnd.forEach(function (action) {
	      predictableExec(action, updatedContext, _event);
	    });
	    deferredToBlockEnd.length = 0;
	    return resolvedActions;
	  }

	  var resolvedActions = flatten(actionBlocks.map(processBlock));
	  return [resolvedActions, updatedContext];
	}

	/**
	 * Maintains a stack of the current service in scope.
	 * This is used to provide the correct service to spawn().
	 */
	var serviceStack = [];
	var provide = function (service, fn) {
	  serviceStack.push(service);
	  var result = fn(service);
	  serviceStack.pop();
	  return result;
	};

	function createNullActor(id) {
	  var _a;

	  return _a = {
	    id: id,
	    send: function () {
	      return void 0;
	    },
	    subscribe: function () {
	      return {
	        unsubscribe: function () {
	          return void 0;
	        }
	      };
	    },
	    getSnapshot: function () {
	      return undefined;
	    },
	    toJSON: function () {
	      return {
	        id: id
	      };
	    }
	  }, _a[symbolObservable] = function () {
	    return this;
	  }, _a;
	}
	/**
	 * Creates a deferred actor that is able to be invoked given the provided
	 * invocation information in its `.meta` value.
	 *
	 * @param invokeDefinition The meta information needed to invoke the actor.
	 */

	function createInvocableActor(invokeDefinition, machine, context, _event) {
	  var _a;

	  var invokeSrc = toInvokeSource$1(invokeDefinition.src);
	  var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
	  var resolvedData = invokeDefinition.data ? mapContext(invokeDefinition.data, context, _event) : undefined;
	  var tempActor = serviceCreator ? createDeferredActor(serviceCreator, invokeDefinition.id, resolvedData) : createNullActor(invokeDefinition.id); // @ts-ignore

	  tempActor.meta = invokeDefinition;
	  return tempActor;
	}
	function createDeferredActor(entity, id, data) {
	  var tempActor = createNullActor(id); // @ts-ignore

	  tempActor.deferred = true;

	  if (isMachine(entity)) {
	    // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
	    var initialState_1 = tempActor.state = provide(undefined, function () {
	      return (data ? entity.withContext(data) : entity).initialState;
	    });

	    tempActor.getSnapshot = function () {
	      return initialState_1;
	    };
	  }

	  return tempActor;
	}
	function isActor(item) {
	  try {
	    return typeof item.send === 'function';
	  } catch (e) {
	    return false;
	  }
	}
	function isSpawnedActor(item) {
	  return isActor(item) && 'id' in item;
	} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now

	function toActorRef(actorRefLike) {
	  var _a;

	  return __assign$2((_a = {
	    subscribe: function () {
	      return {
	        unsubscribe: function () {
	          return void 0;
	        }
	      };
	    },
	    id: 'anonymous',
	    getSnapshot: function () {
	      return undefined;
	    }
	  }, _a[symbolObservable] = function () {
	    return this;
	  }, _a), actorRefLike);
	}

	var isLeafNode = function (stateNode) {
	  return stateNode.type === 'atomic' || stateNode.type === 'final';
	};
	function getAllChildren(stateNode) {
	  return Object.keys(stateNode.states).map(function (key) {
	    return stateNode.states[key];
	  });
	}
	function getChildren(stateNode) {
	  return getAllChildren(stateNode).filter(function (sn) {
	    return sn.type !== 'history';
	  });
	}
	function getAllStateNodes(stateNode) {
	  var stateNodes = [stateNode];

	  if (isLeafNode(stateNode)) {
	    return stateNodes;
	  }

	  return stateNodes.concat(flatten(getChildren(stateNode).map(getAllStateNodes)));
	}
	function getConfiguration(prevStateNodes, stateNodes) {
	  var e_1, _a, e_2, _b, e_3, _c, e_4, _d;

	  var prevConfiguration = new Set(prevStateNodes);
	  var prevAdjList = getAdjList(prevConfiguration);
	  var configuration = new Set(stateNodes);

	  try {
	    // add all ancestors
	    for (var configuration_1 = __values$2(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()) {
	      var s = configuration_1_1.value;
	      var m = s.parent;

	      while (m && !configuration.has(m)) {
	        configuration.add(m);
	        m = m.parent;
	      }
	    }
	  } catch (e_1_1) {
	    e_1 = {
	      error: e_1_1
	    };
	  } finally {
	    try {
	      if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
	    } finally {
	      if (e_1) throw e_1.error;
	    }
	  }

	  var adjList = getAdjList(configuration);

	  try {
	    // add descendants
	    for (var configuration_2 = __values$2(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()) {
	      var s = configuration_2_1.value; // if previously active, add existing child nodes

	      if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) {
	        if (prevAdjList.get(s)) {
	          prevAdjList.get(s).forEach(function (sn) {
	            return configuration.add(sn);
	          });
	        } else {
	          s.initialStateNodes.forEach(function (sn) {
	            return configuration.add(sn);
	          });
	        }
	      } else {
	        if (s.type === 'parallel') {
	          try {
	            for (var _e = (e_3 = void 0, __values$2(getChildren(s))), _f = _e.next(); !_f.done; _f = _e.next()) {
	              var child = _f.value;

	              if (!configuration.has(child)) {
	                configuration.add(child);

	                if (prevAdjList.get(child)) {
	                  prevAdjList.get(child).forEach(function (sn) {
	                    return configuration.add(sn);
	                  });
	                } else {
	                  child.initialStateNodes.forEach(function (sn) {
	                    return configuration.add(sn);
	                  });
	                }
	              }
	            }
	          } catch (e_3_1) {
	            e_3 = {
	              error: e_3_1
	            };
	          } finally {
	            try {
	              if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
	            } finally {
	              if (e_3) throw e_3.error;
	            }
	          }
	        }
	      }
	    }
	  } catch (e_2_1) {
	    e_2 = {
	      error: e_2_1
	    };
	  } finally {
	    try {
	      if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
	    } finally {
	      if (e_2) throw e_2.error;
	    }
	  }

	  try {
	    // add all ancestors
	    for (var configuration_3 = __values$2(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()) {
	      var s = configuration_3_1.value;
	      var m = s.parent;

	      while (m && !configuration.has(m)) {
	        configuration.add(m);
	        m = m.parent;
	      }
	    }
	  } catch (e_4_1) {
	    e_4 = {
	      error: e_4_1
	    };
	  } finally {
	    try {
	      if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
	    } finally {
	      if (e_4) throw e_4.error;
	    }
	  }

	  return configuration;
	}

	function getValueFromAdj(baseNode, adjList) {
	  var childStateNodes = adjList.get(baseNode);

	  if (!childStateNodes) {
	    return {}; // todo: fix?
	  }

	  if (baseNode.type === 'compound') {
	    var childStateNode = childStateNodes[0];

	    if (childStateNode) {
	      if (isLeafNode(childStateNode)) {
	        return childStateNode.key;
	      }
	    } else {
	      return {};
	    }
	  }

	  var stateValue = {};
	  childStateNodes.forEach(function (csn) {
	    stateValue[csn.key] = getValueFromAdj(csn, adjList);
	  });
	  return stateValue;
	}

	function getAdjList(configuration) {
	  var e_5, _a;

	  var adjList = new Map();

	  try {
	    for (var configuration_4 = __values$2(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()) {
	      var s = configuration_4_1.value;

	      if (!adjList.has(s)) {
	        adjList.set(s, []);
	      }

	      if (s.parent) {
	        if (!adjList.has(s.parent)) {
	          adjList.set(s.parent, []);
	        }

	        adjList.get(s.parent).push(s);
	      }
	    }
	  } catch (e_5_1) {
	    e_5 = {
	      error: e_5_1
	    };
	  } finally {
	    try {
	      if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
	    } finally {
	      if (e_5) throw e_5.error;
	    }
	  }

	  return adjList;
	}
	function getValue(rootNode, configuration) {
	  var config = getConfiguration([rootNode], configuration);
	  return getValueFromAdj(rootNode, getAdjList(config));
	}
	function has$4(iterable, item) {
	  if (Array.isArray(iterable)) {
	    return iterable.some(function (member) {
	      return member === item;
	    });
	  }

	  if (iterable instanceof Set) {
	    return iterable.has(item);
	  }

	  return false; // TODO: fix
	}
	function nextEvents(configuration) {
	  return __spreadArray$2([], __read$2(new Set(flatten(__spreadArray$2([], __read$2(configuration.map(function (sn) {
	    return sn.ownEvents;
	  })), false)))), false);
	}
	function isInFinalState(configuration, stateNode) {
	  if (stateNode.type === 'compound') {
	    return getChildren(stateNode).some(function (s) {
	      return s.type === 'final' && has$4(configuration, s);
	    });
	  }

	  if (stateNode.type === 'parallel') {
	    return getChildren(stateNode).every(function (sn) {
	      return isInFinalState(configuration, sn);
	    });
	  }

	  return false;
	}
	function getMeta(configuration) {
	  if (configuration === void 0) {
	    configuration = [];
	  }

	  return configuration.reduce(function (acc, stateNode) {
	    if (stateNode.meta !== undefined) {
	      acc[stateNode.id] = stateNode.meta;
	    }

	    return acc;
	  }, {});
	}
	function getTagsFromConfiguration(configuration) {
	  return new Set(flatten(configuration.map(function (sn) {
	    return sn.tags;
	  })));
	}

	function stateValuesEqual(a, b) {
	  if (a === b) {
	    return true;
	  }

	  if (a === undefined || b === undefined) {
	    return false;
	  }

	  if (isString$2(a) || isString$2(b)) {
	    return a === b;
	  }

	  var aKeys = Object.keys(a);
	  var bKeys = Object.keys(b);
	  return aKeys.length === bKeys.length && aKeys.every(function (key) {
	    return stateValuesEqual(a[key], b[key]);
	  });
	}
	function isStateConfig(state) {
	  if (typeof state !== 'object' || state === null) {
	    return false;
	  }

	  return 'value' in state && '_event' in state;
	}
	function bindActionToState(action, state) {
	  var exec = action.exec;

	  var boundAction = __assign$2(__assign$2({}, action), {
	    exec: exec !== undefined ? function () {
	      return exec(state.context, state.event, {
	        action: action,
	        state: state,
	        _event: state._event
	      });
	    } : undefined
	  });

	  return boundAction;
	}

	var State$1 =
	/*#__PURE__*/

	/** @class */
	function () {
	  /**
	   * Creates a new State instance.
	   * @param value The state value
	   * @param context The extended state
	   * @param historyValue The tree representing historical values of the state nodes
	   * @param history The previous state
	   * @param actions An array of action objects to execute as side-effects
	   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
	   * @param meta
	   * @param events Internal event queue. Should be empty with run-to-completion semantics.
	   * @param configuration
	   */
	  function State(config) {
	    var _this = this;

	    var _a;

	    this.actions = [];
	    this.activities = EMPTY_ACTIVITY_MAP;
	    this.meta = {};
	    this.events = [];
	    this.value = config.value;
	    this.context = config.context;
	    this._event = config._event;
	    this._sessionid = config._sessionid;
	    this.event = this._event.data;
	    this.historyValue = config.historyValue;
	    this.history = config.history;
	    this.actions = config.actions || [];
	    this.activities = config.activities || EMPTY_ACTIVITY_MAP;
	    this.meta = getMeta(config.configuration);
	    this.events = config.events || [];
	    this.matches = this.matches.bind(this);
	    this.toStrings = this.toStrings.bind(this);
	    this.configuration = config.configuration;
	    this.transitions = config.transitions;
	    this.children = config.children;
	    this.done = !!config.done;
	    this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
	    this.machine = config.machine;
	    Object.defineProperty(this, 'nextEvents', {
	      get: function () {
	        return nextEvents(_this.configuration);
	      }
	    });
	  }
	  /**
	   * Creates a new State instance for the given `stateValue` and `context`.
	   * @param stateValue
	   * @param context
	   */


	  State.from = function (stateValue, context) {
	    if (stateValue instanceof State) {
	      if (stateValue.context !== context) {
	        return new State({
	          value: stateValue.value,
	          context: context,
	          _event: stateValue._event,
	          _sessionid: null,
	          historyValue: stateValue.historyValue,
	          history: stateValue.history,
	          actions: [],
	          activities: stateValue.activities,
	          meta: {},
	          events: [],
	          configuration: [],
	          transitions: [],
	          children: {}
	        });
	      }

	      return stateValue;
	    }

	    var _event = initEvent;
	    return new State({
	      value: stateValue,
	      context: context,
	      _event: _event,
	      _sessionid: null,
	      historyValue: undefined,
	      history: undefined,
	      actions: [],
	      activities: undefined,
	      meta: undefined,
	      events: [],
	      configuration: [],
	      transitions: [],
	      children: {}
	    });
	  };
	  /**
	   * Creates a new State instance for the given `config`.
	   * @param config The state config
	   */


	  State.create = function (config) {
	    return new State(config);
	  };
	  /**
	   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
	   * @param stateValue
	   * @param context
	   */


	  State.inert = function (stateValue, context) {
	    if (stateValue instanceof State) {
	      if (!stateValue.actions.length) {
	        return stateValue;
	      }

	      var _event = initEvent;
	      return new State({
	        value: stateValue.value,
	        context: context,
	        _event: _event,
	        _sessionid: null,
	        historyValue: stateValue.historyValue,
	        history: stateValue.history,
	        activities: stateValue.activities,
	        configuration: stateValue.configuration,
	        transitions: [],
	        children: {}
	      });
	    }

	    return State.from(stateValue, context);
	  };
	  /**
	   * Returns an array of all the string leaf state node paths.
	   * @param stateValue
	   * @param delimiter The character(s) that separate each subpath in the string state node path.
	   */


	  State.prototype.toStrings = function (stateValue, delimiter) {
	    var _this = this;

	    if (stateValue === void 0) {
	      stateValue = this.value;
	    }

	    if (delimiter === void 0) {
	      delimiter = '.';
	    }

	    if (isString$2(stateValue)) {
	      return [stateValue];
	    }

	    var valueKeys = Object.keys(stateValue);
	    return valueKeys.concat.apply(valueKeys, __spreadArray$2([], __read$2(valueKeys.map(function (key) {
	      return _this.toStrings(stateValue[key], delimiter).map(function (s) {
	        return key + delimiter + s;
	      });
	    })), false));
	  };

	  State.prototype.toJSON = function () {
	    var _a = this;
	        _a.configuration;
	        _a.transitions;
	        var tags = _a.tags;
	        _a.machine;
	        var jsonValues = __rest$3(_a, ["configuration", "transitions", "tags", "machine"]);

	    return __assign$2(__assign$2({}, jsonValues), {
	      tags: Array.from(tags)
	    });
	  };

	  State.prototype.matches = function (parentStateValue) {
	    return matchesState(parentStateValue, this.value);
	  };
	  /**
	   * Whether the current state configuration has a state node with the specified `tag`.
	   * @param tag
	   */


	  State.prototype.hasTag = function (tag) {
	    return this.tags.has(tag);
	  };
	  /**
	   * Determines whether sending the `event` will cause a non-forbidden transition
	   * to be selected, even if the transitions have no actions nor
	   * change the state value.
	   *
	   * @param event The event to test
	   * @returns Whether the event will cause a transition
	   */


	  State.prototype.can = function (event) {
	    var _a;

	    var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
	    return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
	    transitionData.transitions.some(function (t) {
	      return t.target !== undefined || t.actions.length;
	    });
	  };

	  return State;
	}();

	var defaultOptions$1 = {
	  deferEvents: false
	};

	var Scheduler$1 =
	/*#__PURE__*/

	/** @class */
	function () {
	  function Scheduler(options) {
	    this.processingEvent = false;
	    this.queue = [];
	    this.initialized = false;
	    this.options = __assign$2(__assign$2({}, defaultOptions$1), options);
	  }

	  Scheduler.prototype.initialize = function (callback) {
	    this.initialized = true;

	    if (callback) {
	      if (!this.options.deferEvents) {
	        this.schedule(callback);
	        return;
	      }

	      this.process(callback);
	    }

	    this.flushEvents();
	  };

	  Scheduler.prototype.schedule = function (task) {
	    if (!this.initialized || this.processingEvent) {
	      this.queue.push(task);
	      return;
	    }

	    if (this.queue.length !== 0) {
	      throw new Error('Event queue should be empty when it is not processing events');
	    }

	    this.process(task);
	    this.flushEvents();
	  };

	  Scheduler.prototype.clear = function () {
	    this.queue = [];
	  };

	  Scheduler.prototype.flushEvents = function () {
	    var nextCallback = this.queue.shift();

	    while (nextCallback) {
	      this.process(nextCallback);
	      nextCallback = this.queue.shift();
	    }
	  };

	  Scheduler.prototype.process = function (callback) {
	    this.processingEvent = true;

	    try {
	      callback();
	    } catch (e) {
	      // there is no use to keep the future events
	      // as the situation is not anymore the same
	      this.clear();
	      throw e;
	    } finally {
	      this.processingEvent = false;
	    }
	  };

	  return Scheduler;
	}();

	var children = /*#__PURE__*/new Map();
	var sessionIdIndex = 0;
	var registry = {
	  bookId: function () {
	    return "x:".concat(sessionIdIndex++);
	  },
	  register: function (id, actor) {
	    children.set(id, actor);
	    return id;
	  },
	  get: function (id) {
	    return children.get(id);
	  },
	  free: function (id) {
	    children.delete(id);
	  }
	};

	function getGlobal() {
	  if (typeof globalThis !== 'undefined') {
	    return globalThis;
	  }

	  if (typeof self !== 'undefined') {
	    return self;
	  }

	  if (typeof window !== 'undefined') {
	    return window;
	  }

	  if (typeof global !== 'undefined') {
	    return global;
	  }

	  {
	    console.warn('XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues');
	  }
	}

	function getDevTools() {
	  var global = getGlobal();

	  if (global && '__xstate__' in global) {
	    return global.__xstate__;
	  }

	  return undefined;
	}

	function registerService(service) {
	  if (!getGlobal()) {
	    return;
	  }

	  var devTools = getDevTools();

	  if (devTools) {
	    devTools.register(service);
	  }
	}

	function spawnBehavior(behavior, options) {
	  if (options === void 0) {
	    options = {};
	  }

	  var state = behavior.initialState;
	  var observers = new Set();
	  var mailbox = [];
	  var flushing = false;

	  var flush = function () {
	    if (flushing) {
	      return;
	    }

	    flushing = true;

	    while (mailbox.length > 0) {
	      var event_1 = mailbox.shift();
	      state = behavior.transition(state, event_1, actorCtx);
	      observers.forEach(function (observer) {
	        return observer.next(state);
	      });
	    }

	    flushing = false;
	  };

	  var actor = toActorRef({
	    id: options.id,
	    send: function (event) {
	      mailbox.push(event);
	      flush();
	    },
	    getSnapshot: function () {
	      return state;
	    },
	    subscribe: function (next, handleError, complete) {
	      var observer = toObserver(next, handleError, complete);
	      observers.add(observer);
	      observer.next(state);
	      return {
	        unsubscribe: function () {
	          observers.delete(observer);
	        }
	      };
	    }
	  });
	  var actorCtx = {
	    parent: options.parent,
	    self: actor,
	    id: options.id || 'anonymous',
	    observers: observers
	  };
	  state = behavior.start ? behavior.start(actorCtx) : state;
	  return actor;
	}

	var DEFAULT_SPAWN_OPTIONS = {
	  sync: false,
	  autoForward: false
	};
	var InterpreterStatus;

	(function (InterpreterStatus) {
	  InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
	  InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
	  InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
	})(InterpreterStatus || (InterpreterStatus = {}));

	var Interpreter =
	/*#__PURE__*/

	/** @class */
	function () {
	  /**
	   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
	   *
	   * @param machine The machine to be interpreted
	   * @param options Interpreter options
	   */
	  function Interpreter(machine, options) {
	    if (options === void 0) {
	      options = Interpreter.defaultOptions;
	    }

	    var _this = this;

	    this.machine = machine;
	    this.delayedEventsMap = {};
	    this.listeners = new Set();
	    this.contextListeners = new Set();
	    this.stopListeners = new Set();
	    this.doneListeners = new Set();
	    this.eventListeners = new Set();
	    this.sendListeners = new Set();
	    /**
	     * Whether the service is started.
	     */

	    this.initialized = false;
	    this.status = InterpreterStatus.NotStarted;
	    this.children = new Map();
	    this.forwardTo = new Set();
	    this._outgoingQueue = [];
	    /**
	     * Alias for Interpreter.prototype.start
	     */

	    this.init = this.start;
	    /**
	     * Sends an event to the running interpreter to trigger a transition.
	     *
	     * An array of events (batched) can be sent as well, which will send all
	     * batched events to the running interpreter. The listeners will be
	     * notified only **once** when all events are processed.
	     *
	     * @param event The event(s) to send
	     */

	    this.send = function (event, payload) {
	      if (isArray$6(event)) {
	        _this.batch(event);

	        return _this.state;
	      }

	      var _event = toSCXMLEvent(toEventObject(event, payload));

	      if (_this.status === InterpreterStatus.Stopped) {
	        // do nothing
	        {
	          warn(false, "Event \"".concat(_event.name, "\" was sent to stopped service \"").concat(_this.machine.id, "\". This service has already reached its final state, and will not transition.\nEvent: ").concat(JSON.stringify(_event.data)));
	        }

	        return _this.state;
	      }

	      if (_this.status !== InterpreterStatus.Running && !_this.options.deferEvents) {
	        throw new Error("Event \"".concat(_event.name, "\" was sent to uninitialized service \"").concat(_this.machine.id // tslint:disable-next-line:max-line-length
	        , "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ").concat(JSON.stringify(_event.data)));
	      }

	      _this.scheduler.schedule(function () {
	        // Forward copy of event to child actors
	        _this.forward(_event);

	        var nextState = _this._nextState(_event);

	        _this.update(nextState, _event);
	      });

	      return _this._state; // TODO: deprecate (should return void)
	      // tslint:disable-next-line:semicolon
	    };

	    this.sendTo = function (event, to, immediate) {
	      var isParent = _this.parent && (to === SpecialTargets.Parent || _this.parent.id === to);
	      var target = isParent ? _this.parent : isString$2(to) ? to === SpecialTargets.Internal ? _this : _this.children.get(to) || registry.get(to) : isActor$1(to) ? to : undefined;

	      if (!target) {
	        if (!isParent) {
	          throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
	        } // tslint:disable-next-line:no-console


	        {
	          warn(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event.type));
	        }

	        return;
	      }

	      if ('machine' in target) {
	        // perhaps those events should be rejected in the parent
	        // but atm it doesn't have easy access to all of the information that is required to do it reliably
	        if (_this.status !== InterpreterStatus.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
	        _this.state.done) {
	          // Send SCXML events to machines
	          var scxmlEvent = __assign$2(__assign$2({}, event), {
	            name: event.name === error$1 ? "".concat(error(_this.id)) : event.name,
	            origin: _this.sessionId
	          });

	          if (!immediate && _this.machine.config.predictableActionArguments) {
	            _this._outgoingQueue.push([target, scxmlEvent]);
	          } else {
	            target.send(scxmlEvent);
	          }
	        }
	      } else {
	        // Send normal events to other targets
	        if (!immediate && _this.machine.config.predictableActionArguments) {
	          _this._outgoingQueue.push([target, event.data]);
	        } else {
	          target.send(event.data);
	        }
	      }
	    };

	    this._exec = function (action, context, _event, actionFunctionMap) {
	      if (actionFunctionMap === void 0) {
	        actionFunctionMap = _this.machine.options.actions;
	      }

	      var actionOrExec = action.exec || getActionFunction(action.type, actionFunctionMap);
	      var exec = isFunction$2(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;

	      if (exec) {
	        try {
	          return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
	            action: action,
	            state: _this.state,
	            _event: _event
	          } : {
	            action: action,
	            _event: _event
	          });
	        } catch (err) {
	          if (_this.parent) {
	            _this.parent.send({
	              type: 'xstate.error',
	              data: err
	            });
	          }

	          throw err;
	        }
	      }

	      switch (action.type) {
	        case raise$1:
	          {
	            // if raise action reached the interpreter then it's a delayed one
	            var sendAction_1 = action;

	            _this.defer(sendAction_1);

	            break;
	          }

	        case send$2:
	          var sendAction = action;

	          if (typeof sendAction.delay === 'number') {
	            _this.defer(sendAction);

	            return;
	          } else {
	            if (sendAction.to) {
	              _this.sendTo(sendAction._event, sendAction.to, _event === initEvent);
	            } else {
	              _this.send(sendAction._event);
	            }
	          }

	          break;

	        case cancel$1:
	          _this.cancel(action.sendId);

	          break;

	        case start$1:
	          {
	            if (_this.status !== InterpreterStatus.Running) {
	              return;
	            }

	            var activity = action.activity; // If the activity will be stopped right after it's started
	            // (such as in transient states)
	            // don't bother starting the activity.

	            if ( // in v4 with `predictableActionArguments` invokes are called eagerly when the `this.state` still points to the previous state
	            !_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) {
	              break;
	            } // Invoked services


	            if (activity.type === ActionTypes.Invoke) {
	              var invokeSource = toInvokeSource$1(activity.src);
	              var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : undefined;
	              var id = activity.id,
	                  data = activity.data;

	              {
	                warn(!('forward' in activity), // tslint:disable-next-line:max-line-length
	                "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead.");
	              }

	              var autoForward = 'autoForward' in activity ? activity.autoForward : !!activity.forward;

	              if (!serviceCreator) {
	                // tslint:disable-next-line:no-console
	                {
	                  warn(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
	                }

	                return;
	              }

	              var resolvedData = data ? mapContext(data, context, _event) : undefined;

	              if (typeof serviceCreator === 'string') {
	                // TODO: warn
	                return;
	              }

	              var source = isFunction$2(serviceCreator) ? serviceCreator(context, _event.data, {
	                data: resolvedData,
	                src: invokeSource,
	                meta: activity.meta
	              }) : serviceCreator;

	              if (!source) {
	                // TODO: warn?
	                return;
	              }

	              var options = void 0;

	              if (isMachine(source)) {
	                source = resolvedData ? source.withContext(resolvedData) : source;
	                options = {
	                  autoForward: autoForward
	                };
	              }

	              _this.spawn(source, id, options);
	            } else {
	              _this.spawnActivity(activity);
	            }

	            break;
	          }

	        case stop$1:
	          {
	            _this.stopChild(action.activity.id);

	            break;
	          }

	        case log$1:
	          var _a = action,
	              label = _a.label,
	              value = _a.value;

	          if (label) {
	            _this.logger(label, value);
	          } else {
	            _this.logger(value);
	          }

	          break;

	        default:
	          {
	            warn(false, "No implementation found for action type '".concat(action.type, "'"));
	          }

	          break;
	      }
	    };

	    var resolvedOptions = __assign$2(__assign$2({}, Interpreter.defaultOptions), options);

	    var clock = resolvedOptions.clock,
	        logger = resolvedOptions.logger,
	        parent = resolvedOptions.parent,
	        id = resolvedOptions.id;
	    var resolvedId = id !== undefined ? id : machine.id;
	    this.id = resolvedId;
	    this.logger = logger;
	    this.clock = clock;
	    this.parent = parent;
	    this.options = resolvedOptions;
	    this.scheduler = new Scheduler$1({
	      deferEvents: this.options.deferEvents
	    });
	    this.sessionId = registry.bookId();
	  }

	  Object.defineProperty(Interpreter.prototype, "initialState", {
	    get: function () {
	      var _this = this;

	      if (this._initialState) {
	        return this._initialState;
	      }

	      return provide(this, function () {
	        _this._initialState = _this.machine.initialState;
	        return _this._initialState;
	      });
	    },
	    enumerable: false,
	    configurable: true
	  });
	  Object.defineProperty(Interpreter.prototype, "state", {
	    /**
	     * @deprecated Use `.getSnapshot()` instead.
	     */
	    get: function () {
	      {
	        warn(this.status !== InterpreterStatus.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
	      }

	      return this._state;
	    },
	    enumerable: false,
	    configurable: true
	  });
	  /**
	   * Executes the actions of the given state, with that state's `context` and `event`.
	   *
	   * @param state The state whose actions will be executed
	   * @param actionsConfig The action implementations to use
	   */

	  Interpreter.prototype.execute = function (state, actionsConfig) {
	    var e_1, _a;

	    try {
	      for (var _b = __values$2(state.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
	        var action = _c.value;
	        this.exec(action, state, actionsConfig);
	      }
	    } catch (e_1_1) {
	      e_1 = {
	        error: e_1_1
	      };
	    } finally {
	      try {
	        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	      } finally {
	        if (e_1) throw e_1.error;
	      }
	    }
	  };

	  Interpreter.prototype.update = function (state, _event) {
	    var e_2, _a, e_3, _b, e_4, _c, e_5, _d;

	    var _this = this; // Attach session ID to state


	    state._sessionid = this.sessionId; // Update state

	    this._state = state; // Execute actions

	    if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
	    // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
	    _event === initEvent) && this.options.execute) {
	      this.execute(this.state);
	    } else {
	      var item = void 0;

	      while (item = this._outgoingQueue.shift()) {
	        item[0].send(item[1]);
	      }
	    } // Update children


	    this.children.forEach(function (child) {
	      _this.state.children[child.id] = child;
	    }); // Dev tools

	    if (this.devTools) {
	      this.devTools.send(_event.data, state);
	    } // Execute listeners


	    if (state.event) {
	      try {
	        for (var _e = __values$2(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()) {
	          var listener = _f.value;
	          listener(state.event);
	        }
	      } catch (e_2_1) {
	        e_2 = {
	          error: e_2_1
	        };
	      } finally {
	        try {
	          if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
	        } finally {
	          if (e_2) throw e_2.error;
	        }
	      }
	    }

	    try {
	      for (var _g = __values$2(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()) {
	        var listener = _h.value;
	        listener(state, state.event);
	      }
	    } catch (e_3_1) {
	      e_3 = {
	        error: e_3_1
	      };
	    } finally {
	      try {
	        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
	      } finally {
	        if (e_3) throw e_3.error;
	      }
	    }

	    try {
	      for (var _j = __values$2(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()) {
	        var contextListener = _k.value;
	        contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
	      }
	    } catch (e_4_1) {
	      e_4 = {
	        error: e_4_1
	      };
	    } finally {
	      try {
	        if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
	      } finally {
	        if (e_4) throw e_4.error;
	      }
	    }

	    if (this.state.done) {
	      // get final child state node
	      var finalChildStateNode = state.configuration.find(function (sn) {
	        return sn.type === 'final' && sn.parent === _this.machine;
	      });
	      var doneData = finalChildStateNode && finalChildStateNode.doneData ? mapContext(finalChildStateNode.doneData, state.context, _event) : undefined;
	      this._doneEvent = doneInvoke(this.id, doneData);

	      try {
	        for (var _l = __values$2(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()) {
	          var listener = _m.value;
	          listener(this._doneEvent);
	        }
	      } catch (e_5_1) {
	        e_5 = {
	          error: e_5_1
	        };
	      } finally {
	        try {
	          if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
	        } finally {
	          if (e_5) throw e_5.error;
	        }
	      }

	      this._stop();

	      this._stopChildren();

	      registry.free(this.sessionId);
	    }
	  };
	  /*
	   * Adds a listener that is notified whenever a state transition happens. The listener is called with
	   * the next state and the event object that caused the state transition.
	   *
	   * @param listener The state listener
	   */


	  Interpreter.prototype.onTransition = function (listener) {
	    this.listeners.add(listener); // Send current state to listener

	    if (this.status === InterpreterStatus.Running) {
	      listener(this.state, this.state.event);
	    }

	    return this;
	  };

	  Interpreter.prototype.subscribe = function (nextListenerOrObserver, _, // TODO: error listener
	  completeListener) {
	    var _this = this;

	    var observer = toObserver(nextListenerOrObserver, _, completeListener);
	    this.listeners.add(observer.next); // Send current state to listener

	    if (this.status !== InterpreterStatus.NotStarted) {
	      observer.next(this.state);
	    }

	    var completeOnce = function () {
	      _this.doneListeners.delete(completeOnce);

	      _this.stopListeners.delete(completeOnce);

	      observer.complete();
	    };

	    if (this.status === InterpreterStatus.Stopped) {
	      observer.complete();
	    } else {
	      this.onDone(completeOnce);
	      this.onStop(completeOnce);
	    }

	    return {
	      unsubscribe: function () {
	        _this.listeners.delete(observer.next);

	        _this.doneListeners.delete(completeOnce);

	        _this.stopListeners.delete(completeOnce);
	      }
	    };
	  };
	  /**
	   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
	   * @param listener The event listener
	   */


	  Interpreter.prototype.onEvent = function (listener) {
	    this.eventListeners.add(listener);
	    return this;
	  };
	  /**
	   * Adds an event listener that is notified whenever a `send` event occurs.
	   * @param listener The event listener
	   */


	  Interpreter.prototype.onSend = function (listener) {
	    this.sendListeners.add(listener);
	    return this;
	  };
	  /**
	   * Adds a context listener that is notified whenever the state context changes.
	   * @param listener The context listener
	   */


	  Interpreter.prototype.onChange = function (listener) {
	    this.contextListeners.add(listener);
	    return this;
	  };
	  /**
	   * Adds a listener that is notified when the machine is stopped.
	   * @param listener The listener
	   */


	  Interpreter.prototype.onStop = function (listener) {
	    this.stopListeners.add(listener);
	    return this;
	  };
	  /**
	   * Adds a state listener that is notified when the statechart has reached its final state.
	   * @param listener The state listener
	   */


	  Interpreter.prototype.onDone = function (listener) {
	    if (this.status === InterpreterStatus.Stopped && this._doneEvent) {
	      listener(this._doneEvent);
	    } else {
	      this.doneListeners.add(listener);
	    }

	    return this;
	  };
	  /**
	   * Removes a listener.
	   * @param listener The listener to remove
	   */


	  Interpreter.prototype.off = function (listener) {
	    this.listeners.delete(listener);
	    this.eventListeners.delete(listener);
	    this.sendListeners.delete(listener);
	    this.stopListeners.delete(listener);
	    this.doneListeners.delete(listener);
	    this.contextListeners.delete(listener);
	    return this;
	  };
	  /**
	   * Starts the interpreter from the given state, or the initial state.
	   * @param initialState The state to start the statechart from
	   */


	  Interpreter.prototype.start = function (initialState) {
	    var _this = this;

	    if (this.status === InterpreterStatus.Running) {
	      // Do not restart the service if it is already started
	      return this;
	    } // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
	    // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
	    // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
	    // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)


	    this.machine._init();

	    registry.register(this.sessionId, this);
	    this.initialized = true;
	    this.status = InterpreterStatus.Running;
	    var resolvedState = initialState === undefined ? this.initialState : provide(this, function () {
	      return isStateConfig(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState(State$1.from(initialState, _this.machine.context));
	    });

	    if (this.options.devTools) {
	      this.attachDev();
	    }

	    this.scheduler.initialize(function () {
	      _this.update(resolvedState, initEvent);
	    });
	    return this;
	  };

	  Interpreter.prototype._stopChildren = function () {
	    // TODO: think about converting those to actions
	    this.children.forEach(function (child) {
	      if (isFunction$2(child.stop)) {
	        child.stop();
	      }
	    });
	    this.children.clear();
	  };

	  Interpreter.prototype._stop = function () {
	    var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;

	    try {
	      for (var _f = __values$2(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()) {
	        var listener = _g.value;
	        this.listeners.delete(listener);
	      }
	    } catch (e_6_1) {
	      e_6 = {
	        error: e_6_1
	      };
	    } finally {
	      try {
	        if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
	      } finally {
	        if (e_6) throw e_6.error;
	      }
	    }

	    try {
	      for (var _h = __values$2(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()) {
	        var listener = _j.value; // call listener, then remove

	        listener();
	        this.stopListeners.delete(listener);
	      }
	    } catch (e_7_1) {
	      e_7 = {
	        error: e_7_1
	      };
	    } finally {
	      try {
	        if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
	      } finally {
	        if (e_7) throw e_7.error;
	      }
	    }

	    try {
	      for (var _k = __values$2(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()) {
	        var listener = _l.value;
	        this.contextListeners.delete(listener);
	      }
	    } catch (e_8_1) {
	      e_8 = {
	        error: e_8_1
	      };
	    } finally {
	      try {
	        if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
	      } finally {
	        if (e_8) throw e_8.error;
	      }
	    }

	    try {
	      for (var _m = __values$2(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()) {
	        var listener = _o.value;
	        this.doneListeners.delete(listener);
	      }
	    } catch (e_9_1) {
	      e_9 = {
	        error: e_9_1
	      };
	    } finally {
	      try {
	        if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
	      } finally {
	        if (e_9) throw e_9.error;
	      }
	    }

	    if (!this.initialized) {
	      // Interpreter already stopped; do nothing
	      return this;
	    }

	    this.initialized = false;
	    this.status = InterpreterStatus.Stopped;
	    this._initialState = undefined;

	    try {
	      // we are going to stop within the current sync frame
	      // so we can safely just cancel this here as nothing async should be fired anyway
	      for (var _p = __values$2(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()) {
	        var key = _q.value;
	        this.clock.clearTimeout(this.delayedEventsMap[key]);
	      }
	    } catch (e_10_1) {
	      e_10 = {
	        error: e_10_1
	      };
	    } finally {
	      try {
	        if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
	      } finally {
	        if (e_10) throw e_10.error;
	      }
	    } // clear everything that might be enqueued


	    this.scheduler.clear();
	    this.scheduler = new Scheduler$1({
	      deferEvents: this.options.deferEvents
	    });
	  };
	  /**
	   * Stops the interpreter and unsubscribe all listeners.
	   *
	   * This will also notify the `onStop` listeners.
	   */


	  Interpreter.prototype.stop = function () {
	    // TODO: add warning for stopping non-root interpreters
	    var _this = this; // grab the current scheduler as it will be replaced in _stop


	    var scheduler = this.scheduler;

	    this._stop(); // let what is currently processed to be finished


	    scheduler.schedule(function () {
	      // it feels weird to handle this here but we need to handle this even slightly "out of band"
	      var _event = toSCXMLEvent({
	        type: 'xstate.stop'
	      });

	      var nextState = provide(_this, function () {
	        var exitActions = flatten(__spreadArray$2([], __read$2(_this.state.configuration), false).sort(function (a, b) {
	          return b.order - a.order;
	        }).map(function (stateNode) {
	          return toActionObjects(stateNode.onExit, _this.machine.options.actions);
	        }));

	        var _a = __read$2(resolveActions(_this.machine, _this.state, _this.state.context, _event, [{
	          type: 'exit',
	          actions: exitActions
	        }], _this.machine.config.predictableActionArguments ? _this._exec : undefined, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2),
	            resolvedActions = _a[0],
	            updatedContext = _a[1];

	        var newState = new State$1({
	          value: _this.state.value,
	          context: updatedContext,
	          _event: _event,
	          _sessionid: _this.sessionId,
	          historyValue: undefined,
	          history: _this.state,
	          actions: resolvedActions.filter(function (action) {
	            return !isRaisableAction(action);
	          }),
	          activities: {},
	          events: [],
	          configuration: [],
	          transitions: [],
	          children: {},
	          done: _this.state.done,
	          tags: _this.state.tags,
	          machine: _this.machine
	        });
	        newState.changed = true;
	        return newState;
	      });

	      _this.update(nextState, _event);

	      _this._stopChildren();

	      registry.free(_this.sessionId);
	    });
	    return this;
	  };

	  Interpreter.prototype.batch = function (events) {
	    var _this = this;

	    if (this.status === InterpreterStatus.NotStarted && this.options.deferEvents) {
	      // tslint:disable-next-line:no-console
	      {
	        warn(false, "".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\" and are deferred. Make sure .start() is called for this service.\nEvent: ").concat(JSON.stringify(event)));
	      }
	    } else if (this.status !== InterpreterStatus.Running) {
	      throw new Error( // tslint:disable-next-line:max-line-length
	      "".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options."));
	    }

	    if (!events.length) {
	      return;
	    }

	    var exec = !!this.machine.config.predictableActionArguments && this._exec;
	    this.scheduler.schedule(function () {
	      var e_11, _a;

	      var nextState = _this.state;
	      var batchChanged = false;
	      var batchedActions = [];

	      var _loop_1 = function (event_1) {
	        var _event = toSCXMLEvent(event_1);

	        _this.forward(_event);

	        nextState = provide(_this, function () {
	          return _this.machine.transition(nextState, _event, undefined, exec || undefined);
	        });
	        batchedActions.push.apply(batchedActions, __spreadArray$2([], __read$2(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function (a) {
	          return bindActionToState(a, nextState);
	        })), false));
	        batchChanged = batchChanged || !!nextState.changed;
	      };

	      try {
	        for (var events_1 = __values$2(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
	          var event_1 = events_1_1.value;

	          _loop_1(event_1);
	        }
	      } catch (e_11_1) {
	        e_11 = {
	          error: e_11_1
	        };
	      } finally {
	        try {
	          if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
	        } finally {
	          if (e_11) throw e_11.error;
	        }
	      }

	      nextState.changed = batchChanged;
	      nextState.actions = batchedActions;

	      _this.update(nextState, toSCXMLEvent(events[events.length - 1]));
	    });
	  };
	  /**
	   * Returns a send function bound to this interpreter instance.
	   *
	   * @param event The event to be sent by the sender.
	   */


	  Interpreter.prototype.sender = function (event) {
	    return this.send.bind(this, event);
	  };

	  Interpreter.prototype._nextState = function (event, exec) {
	    var _this = this;

	    if (exec === void 0) {
	      exec = !!this.machine.config.predictableActionArguments && this._exec;
	    }

	    var _event = toSCXMLEvent(event);

	    if (_event.name.indexOf(errorPlatform) === 0 && !this.state.nextEvents.some(function (nextEvent) {
	      return nextEvent.indexOf(errorPlatform) === 0;
	    })) {
	      throw _event.data.data;
	    }

	    var nextState = provide(this, function () {
	      return _this.machine.transition(_this.state, _event, undefined, exec || undefined);
	    });
	    return nextState;
	  };
	  /**
	   * Returns the next state given the interpreter's current state and the event.
	   *
	   * This is a pure method that does _not_ update the interpreter's state.
	   *
	   * @param event The event to determine the next state
	   */


	  Interpreter.prototype.nextState = function (event) {
	    return this._nextState(event, false);
	  };

	  Interpreter.prototype.forward = function (event) {
	    var e_12, _a;

	    try {
	      for (var _b = __values$2(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()) {
	        var id = _c.value;
	        var child = this.children.get(id);

	        if (!child) {
	          throw new Error("Unable to forward event '".concat(event, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
	        }

	        child.send(event);
	      }
	    } catch (e_12_1) {
	      e_12 = {
	        error: e_12_1
	      };
	    } finally {
	      try {
	        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	      } finally {
	        if (e_12) throw e_12.error;
	      }
	    }
	  };

	  Interpreter.prototype.defer = function (sendAction) {
	    var _this = this;

	    var timerId = this.clock.setTimeout(function () {
	      if ('to' in sendAction && sendAction.to) {
	        _this.sendTo(sendAction._event, sendAction.to, true);
	      } else {
	        _this.send(sendAction._event);
	      }
	    }, sendAction.delay);

	    if (sendAction.id) {
	      this.delayedEventsMap[sendAction.id] = timerId;
	    }
	  };

	  Interpreter.prototype.cancel = function (sendId) {
	    this.clock.clearTimeout(this.delayedEventsMap[sendId]);
	    delete this.delayedEventsMap[sendId];
	  };

	  Interpreter.prototype.exec = function (action, state, actionFunctionMap) {
	    if (actionFunctionMap === void 0) {
	      actionFunctionMap = this.machine.options.actions;
	    }

	    this._exec(action, state.context, state._event, actionFunctionMap);
	  };

	  Interpreter.prototype.removeChild = function (childId) {
	    var _a;

	    this.children.delete(childId);
	    this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
	    // such as when a child is added then removed while initializing the state

	    (_a = this.state) === null || _a === void 0 ? true : delete _a.children[childId];
	  };

	  Interpreter.prototype.stopChild = function (childId) {
	    var child = this.children.get(childId);

	    if (!child) {
	      return;
	    }

	    this.removeChild(childId);

	    if (isFunction$2(child.stop)) {
	      child.stop();
	    }
	  };

	  Interpreter.prototype.spawn = function (entity, name, options) {
	    if (this.status !== InterpreterStatus.Running) {
	      return createDeferredActor(entity, name);
	    }

	    if (isPromiseLike(entity)) {
	      return this.spawnPromise(Promise.resolve(entity), name);
	    } else if (isFunction$2(entity)) {
	      return this.spawnCallback(entity, name);
	    } else if (isSpawnedActor(entity)) {
	      return this.spawnActor(entity, name);
	    } else if (isObservable$1(entity)) {
	      return this.spawnObservable(entity, name);
	    } else if (isMachine(entity)) {
	      return this.spawnMachine(entity, __assign$2(__assign$2({}, options), {
	        id: name
	      }));
	    } else if (isBehavior(entity)) {
	      return this.spawnBehavior(entity, name);
	    } else {
	      throw new Error("Unable to spawn entity \"".concat(name, "\" of type \"").concat(typeof entity, "\"."));
	    }
	  };

	  Interpreter.prototype.spawnMachine = function (machine, options) {
	    var _this = this;

	    if (options === void 0) {
	      options = {};
	    }

	    var childService = new Interpreter(machine, __assign$2(__assign$2({}, this.options), {
	      parent: this,
	      id: options.id || machine.id
	    }));

	    var resolvedOptions = __assign$2(__assign$2({}, DEFAULT_SPAWN_OPTIONS), options);

	    if (resolvedOptions.sync) {
	      childService.onTransition(function (state) {
	        _this.send(update, {
	          state: state,
	          id: childService.id
	        });
	      });
	    }

	    var actor = childService;
	    this.children.set(childService.id, actor);

	    if (resolvedOptions.autoForward) {
	      this.forwardTo.add(childService.id);
	    }

	    childService.onDone(function (doneEvent) {
	      _this.removeChild(childService.id);

	      _this.send(toSCXMLEvent(doneEvent, {
	        origin: childService.id
	      }));
	    }).start();
	    return actor;
	  };

	  Interpreter.prototype.spawnBehavior = function (behavior, id) {
	    var actorRef = spawnBehavior(behavior, {
	      id: id,
	      parent: this
	    });
	    this.children.set(id, actorRef);
	    return actorRef;
	  };

	  Interpreter.prototype.spawnPromise = function (promise, id) {
	    var _a;

	    var _this = this;

	    var canceled = false;
	    var resolvedData;
	    promise.then(function (response) {
	      if (!canceled) {
	        resolvedData = response;

	        _this.removeChild(id);

	        _this.send(toSCXMLEvent(doneInvoke(id, response), {
	          origin: id
	        }));
	      }
	    }, function (errorData) {
	      if (!canceled) {
	        _this.removeChild(id);

	        var errorEvent = error(id, errorData);

	        try {
	          // Send "error.platform.id" to this (parent).
	          _this.send(toSCXMLEvent(errorEvent, {
	            origin: id
	          }));
	        } catch (error) {
	          reportUnhandledExceptionOnInvocation(errorData, error, id);

	          if (_this.devTools) {
	            _this.devTools.send(errorEvent, _this.state);
	          }

	          if (_this.machine.strict) {
	            // it would be better to always stop the state machine if unhandled
	            // exception/promise rejection happens but because we don't want to
	            // break existing code so enforce it on strict mode only especially so
	            // because documentation says that onError is optional
	            _this.stop();
	          }
	        }
	      }
	    });
	    var actor = (_a = {
	      id: id,
	      send: function () {
	        return void 0;
	      },
	      subscribe: function (next, handleError, complete) {
	        var observer = toObserver(next, handleError, complete);
	        var unsubscribed = false;
	        promise.then(function (response) {
	          if (unsubscribed) {
	            return;
	          }

	          observer.next(response);

	          if (unsubscribed) {
	            return;
	          }

	          observer.complete();
	        }, function (err) {
	          if (unsubscribed) {
	            return;
	          }

	          observer.error(err);
	        });
	        return {
	          unsubscribe: function () {
	            return unsubscribed = true;
	          }
	        };
	      },
	      stop: function () {
	        canceled = true;
	      },
	      toJSON: function () {
	        return {
	          id: id
	        };
	      },
	      getSnapshot: function () {
	        return resolvedData;
	      }
	    }, _a[symbolObservable] = function () {
	      return this;
	    }, _a);
	    this.children.set(id, actor);
	    return actor;
	  };

	  Interpreter.prototype.spawnCallback = function (callback, id) {
	    var _a;

	    var _this = this;

	    var canceled = false;
	    var receivers = new Set();
	    var listeners = new Set();
	    var emitted;

	    var receive = function (e) {
	      emitted = e;
	      listeners.forEach(function (listener) {
	        return listener(e);
	      });

	      if (canceled) {
	        return;
	      }

	      _this.send(toSCXMLEvent(e, {
	        origin: id
	      }));
	    };

	    var callbackStop;

	    try {
	      callbackStop = callback(receive, function (newListener) {
	        receivers.add(newListener);
	      });
	    } catch (err) {
	      this.send(error(id, err));
	    }

	    if (isPromiseLike(callbackStop)) {
	      // it turned out to be an async function, can't reliably check this before calling `callback`
	      // because transpiled async functions are not recognizable
	      return this.spawnPromise(callbackStop, id);
	    }

	    var actor = (_a = {
	      id: id,
	      send: function (event) {
	        return receivers.forEach(function (receiver) {
	          return receiver(event);
	        });
	      },
	      subscribe: function (next) {
	        var observer = toObserver(next);
	        listeners.add(observer.next);
	        return {
	          unsubscribe: function () {
	            listeners.delete(observer.next);
	          }
	        };
	      },
	      stop: function () {
	        canceled = true;

	        if (isFunction$2(callbackStop)) {
	          callbackStop();
	        }
	      },
	      toJSON: function () {
	        return {
	          id: id
	        };
	      },
	      getSnapshot: function () {
	        return emitted;
	      }
	    }, _a[symbolObservable] = function () {
	      return this;
	    }, _a);
	    this.children.set(id, actor);
	    return actor;
	  };

	  Interpreter.prototype.spawnObservable = function (source, id) {
	    var _a;

	    var _this = this;

	    var emitted;
	    var subscription = source.subscribe(function (value) {
	      emitted = value;

	      _this.send(toSCXMLEvent(value, {
	        origin: id
	      }));
	    }, function (err) {
	      _this.removeChild(id);

	      _this.send(toSCXMLEvent(error(id, err), {
	        origin: id
	      }));
	    }, function () {
	      _this.removeChild(id);

	      _this.send(toSCXMLEvent(doneInvoke(id), {
	        origin: id
	      }));
	    });
	    var actor = (_a = {
	      id: id,
	      send: function () {
	        return void 0;
	      },
	      subscribe: function (next, handleError, complete) {
	        return source.subscribe(next, handleError, complete);
	      },
	      stop: function () {
	        return subscription.unsubscribe();
	      },
	      getSnapshot: function () {
	        return emitted;
	      },
	      toJSON: function () {
	        return {
	          id: id
	        };
	      }
	    }, _a[symbolObservable] = function () {
	      return this;
	    }, _a);
	    this.children.set(id, actor);
	    return actor;
	  };

	  Interpreter.prototype.spawnActor = function (actor, name) {
	    this.children.set(name, actor);
	    return actor;
	  };

	  Interpreter.prototype.spawnActivity = function (activity) {
	    var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;

	    if (!implementation) {
	      {
	        warn(false, "No implementation found for activity '".concat(activity.type, "'"));
	      } // tslint:disable-next-line:no-console


	      return;
	    } // Start implementation


	    var dispose = implementation(this.state.context, activity);
	    this.spawnEffect(activity.id, dispose);
	  };

	  Interpreter.prototype.spawnEffect = function (id, dispose) {
	    var _a;

	    this.children.set(id, (_a = {
	      id: id,
	      send: function () {
	        return void 0;
	      },
	      subscribe: function () {
	        return {
	          unsubscribe: function () {
	            return void 0;
	          }
	        };
	      },
	      stop: dispose || undefined,
	      getSnapshot: function () {
	        return undefined;
	      },
	      toJSON: function () {
	        return {
	          id: id
	        };
	      }
	    }, _a[symbolObservable] = function () {
	      return this;
	    }, _a));
	  };

	  Interpreter.prototype.attachDev = function () {
	    var global = getGlobal();

	    if (this.options.devTools && global) {
	      if (global.__REDUX_DEVTOOLS_EXTENSION__) {
	        var devToolsOptions = typeof this.options.devTools === 'object' ? this.options.devTools : undefined;
	        this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect(__assign$2(__assign$2({
	          name: this.id,
	          autoPause: true,
	          stateSanitizer: function (state) {
	            return {
	              value: state.value,
	              context: state.context,
	              actions: state.actions
	            };
	          }
	        }, devToolsOptions), {
	          features: __assign$2({
	            jump: false,
	            skip: false
	          }, devToolsOptions ? devToolsOptions.features : undefined)
	        }), this.machine);
	        this.devTools.init(this.state);
	      } // add XState-specific dev tooling hook


	      registerService(this);
	    }
	  };

	  Interpreter.prototype.toJSON = function () {
	    return {
	      id: this.id
	    };
	  };

	  Interpreter.prototype[symbolObservable] = function () {
	    return this;
	  };

	  Interpreter.prototype.getSnapshot = function () {
	    if (this.status === InterpreterStatus.NotStarted) {
	      return this.initialState;
	    }

	    return this._state;
	  };
	  /**
	   * The default interpreter options:
	   *
	   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
	   * - `logger` uses the global `console.log()` method
	   */


	  Interpreter.defaultOptions = {
	    execute: true,
	    deferEvents: true,
	    clock: {
	      setTimeout: function (fn, ms) {
	        return setTimeout(fn, ms);
	      },
	      clearTimeout: function (id) {
	        return clearTimeout(id);
	      }
	    },
	    logger: /*#__PURE__*/console.log.bind(console),
	    devTools: false
	  };
	  Interpreter.interpret = interpret;
	  return Interpreter;
	}();
	/**
	 * Creates a new Interpreter instance for the given machine with the provided options, if any.
	 *
	 * @param machine The machine to interpret
	 * @param options Interpreter options
	 */

	function interpret(machine, options) {
	  var interpreter = new Interpreter(machine, options);
	  return interpreter;
	}

	function toInvokeSource(src) {
	  if (typeof src === 'string') {
	    var simpleSrc = {
	      type: src
	    };

	    simpleSrc.toString = function () {
	      return src;
	    }; // v4 compat - TODO: remove in v5


	    return simpleSrc;
	  }

	  return src;
	}
	function toInvokeDefinition(invokeConfig) {
	  return __assign$2(__assign$2({
	    type: invoke
	  }, invokeConfig), {
	    toJSON: function () {
	      invokeConfig.onDone;
	          invokeConfig.onError;
	          var invokeDef = __rest$3(invokeConfig, ["onDone", "onError"]);

	      return __assign$2(__assign$2({}, invokeDef), {
	        type: invoke,
	        src: toInvokeSource(invokeConfig.src)
	      });
	    }
	  });
	}

	var NULL_EVENT = '';
	var STATE_IDENTIFIER = '#';
	var WILDCARD = '*';
	var EMPTY_OBJECT = {};

	var isStateId = function (str) {
	  return str[0] === STATE_IDENTIFIER;
	};

	var createDefaultOptions = function () {
	  return {
	    actions: {},
	    guards: {},
	    services: {},
	    activities: {},
	    delays: {}
	  };
	};

	var validateArrayifiedTransitions = function (stateNode, event, transitions) {
	  var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function (transition) {
	    return !('cond' in transition) && !('in' in transition) && (isString$2(transition.target) || isMachine(transition.target));
	  });
	  var eventText = event === NULL_EVENT ? 'the transient event' : "event '".concat(event, "'");
	  warn(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
	};

	var StateNode =
	/*#__PURE__*/

	/** @class */
	function () {
	  function StateNode(
	  /**
	   * The raw config used to create the machine.
	   */
	  config, options,
	  /**
	   * The initial extended state
	   */
	  _context, // TODO: this is unsafe, but we're removing it in v5 anyway
	  _stateInfo) {
	    if (_context === void 0) {
	      _context = 'context' in config ? config.context : undefined;
	    }

	    var _this = this;

	    var _a;

	    this.config = config;
	    this._context = _context;
	    /**
	     * The order this state node appears. Corresponds to the implicit SCXML document order.
	     */

	    this.order = -1;
	    this.__xstatenode = true;
	    this.__cache = {
	      events: undefined,
	      relativeValue: new Map(),
	      initialStateValue: undefined,
	      initialState: undefined,
	      on: undefined,
	      transitions: undefined,
	      candidates: {},
	      delayedTransitions: undefined
	    };
	    this.idMap = {};
	    this.tags = [];
	    this.options = Object.assign(createDefaultOptions(), options);
	    this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
	    this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || '(machine)';
	    this.machine = this.parent ? this.parent.machine : this;
	    this.path = this.parent ? this.parent.path.concat(this.key) : [];
	    this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : STATE_DELIMITER);
	    this.id = this.config.id || __spreadArray$2([this.machine.key], __read$2(this.path), false).join(this.delimiter);
	    this.version = this.parent ? this.parent.version : this.config.version;
	    this.type = this.config.type || (this.config.parallel ? 'parallel' : this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
	    this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
	    this.description = this.config.description;

	    {
	      warn(!('parallel' in this.config), "The \"parallel\" property is deprecated and will be removed in version 4.1. ".concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
	    }

	    this.initial = this.config.initial;
	    this.states = this.config.states ? mapValues(this.config.states, function (stateConfig, key) {
	      var _a;

	      var stateNode = new StateNode(stateConfig, {}, undefined, {
	        parent: _this,
	        key: key
	      });
	      Object.assign(_this.idMap, __assign$2((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
	      return stateNode;
	    }) : EMPTY_OBJECT; // Document order

	    var order = 0;

	    function dfs(stateNode) {
	      var e_1, _a;

	      stateNode.order = order++;

	      try {
	        for (var _b = __values$2(getAllChildren(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()) {
	          var child = _c.value;
	          dfs(child);
	        }
	      } catch (e_1_1) {
	        e_1 = {
	          error: e_1_1
	        };
	      } finally {
	        try {
	          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        } finally {
	          if (e_1) throw e_1.error;
	        }
	      }
	    }

	    dfs(this); // History config

	    this.history = this.config.history === true ? 'shallow' : this.config.history || false;
	    this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function (_a) {
	      var event = _a.event;
	      return event === NULL_EVENT;
	    }) : NULL_EVENT in this.config.on);
	    this.strict = !!this.config.strict; // TODO: deprecate (entry)

	    this.onEntry = toArray$2(this.config.entry || this.config.onEntry).map(function (action) {
	      return toActionObject(action);
	    }); // TODO: deprecate (exit)

	    this.onExit = toArray$2(this.config.exit || this.config.onExit).map(function (action) {
	      return toActionObject(action);
	    });
	    this.meta = this.config.meta;
	    this.doneData = this.type === 'final' ? this.config.data : undefined;
	    this.invoke = toArray$2(this.config.invoke).map(function (invokeConfig, i) {
	      var _a, _b;

	      if (isMachine(invokeConfig)) {
	        var invokeId = createInvokeId(_this.id, i);
	        _this.machine.options.services = __assign$2((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
	        return toInvokeDefinition({
	          src: invokeId,
	          id: invokeId
	        });
	      } else if (isString$2(invokeConfig.src)) {
	        var invokeId = invokeConfig.id || createInvokeId(_this.id, i);
	        return toInvokeDefinition(__assign$2(__assign$2({}, invokeConfig), {
	          id: invokeId,
	          src: invokeConfig.src
	        }));
	      } else if (isMachine(invokeConfig.src) || isFunction$2(invokeConfig.src)) {
	        var invokeId = invokeConfig.id || createInvokeId(_this.id, i);
	        _this.machine.options.services = __assign$2((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
	        return toInvokeDefinition(__assign$2(__assign$2({
	          id: invokeId
	        }, invokeConfig), {
	          src: invokeId
	        }));
	      } else {
	        var invokeSource = invokeConfig.src;
	        return toInvokeDefinition(__assign$2(__assign$2({
	          id: createInvokeId(_this.id, i)
	        }, invokeConfig), {
	          src: invokeSource
	        }));
	      }
	    });
	    this.activities = toArray$2(this.config.activities).concat(this.invoke).map(function (activity) {
	      return toActivityDefinition(activity);
	    });
	    this.transition = this.transition.bind(this);
	    this.tags = toArray$2(this.config.tags); // TODO: this is the real fix for initialization once
	    // state node getters are deprecated
	    // if (!this.parent) {
	    //   this._init();
	    // }
	  }

	  StateNode.prototype._init = function () {
	    if (this.__cache.transitions) {
	      return;
	    }

	    getAllStateNodes(this).forEach(function (stateNode) {
	      return stateNode.on;
	    });
	  };
	  /**
	   * Clones this state machine with custom options and context.
	   *
	   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
	   * @param context Custom context (will override predefined context)
	   */


	  StateNode.prototype.withConfig = function (options, context) {
	    var _a = this.options,
	        actions = _a.actions,
	        activities = _a.activities,
	        guards = _a.guards,
	        services = _a.services,
	        delays = _a.delays;
	    return new StateNode(this.config, {
	      actions: __assign$2(__assign$2({}, actions), options.actions),
	      activities: __assign$2(__assign$2({}, activities), options.activities),
	      guards: __assign$2(__assign$2({}, guards), options.guards),
	      services: __assign$2(__assign$2({}, services), options.services),
	      delays: __assign$2(__assign$2({}, delays), options.delays)
	    }, context !== null && context !== void 0 ? context : this.context);
	  };
	  /**
	   * Clones this state machine with custom context.
	   *
	   * @param context Custom context (will override predefined context, not recursive)
	   */


	  StateNode.prototype.withContext = function (context) {
	    return new StateNode(this.config, this.options, context);
	  };

	  Object.defineProperty(StateNode.prototype, "context", {
	    get: function () {
	      return isFunction$2(this._context) ? this._context() : this._context;
	    },
	    enumerable: false,
	    configurable: true
	  });
	  Object.defineProperty(StateNode.prototype, "definition", {
	    /**
	     * The well-structured state node definition.
	     */
	    get: function () {
	      return {
	        id: this.id,
	        key: this.key,
	        version: this.version,
	        context: this.context,
	        type: this.type,
	        initial: this.initial,
	        history: this.history,
	        states: mapValues(this.states, function (state) {
	          return state.definition;
	        }),
	        on: this.on,
	        transitions: this.transitions,
	        entry: this.onEntry,
	        exit: this.onExit,
	        activities: this.activities || [],
	        meta: this.meta,
	        order: this.order || -1,
	        data: this.doneData,
	        invoke: this.invoke,
	        description: this.description,
	        tags: this.tags
	      };
	    },
	    enumerable: false,
	    configurable: true
	  });

	  StateNode.prototype.toJSON = function () {
	    return this.definition;
	  };

	  Object.defineProperty(StateNode.prototype, "on", {
	    /**
	     * The mapping of events to transitions.
	     */
	    get: function () {
	      if (this.__cache.on) {
	        return this.__cache.on;
	      }

	      var transitions = this.transitions;
	      return this.__cache.on = transitions.reduce(function (map, transition) {
	        map[transition.eventType] = map[transition.eventType] || [];
	        map[transition.eventType].push(transition);
	        return map;
	      }, {});
	    },
	    enumerable: false,
	    configurable: true
	  });
	  Object.defineProperty(StateNode.prototype, "after", {
	    get: function () {
	      return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
	    },
	    enumerable: false,
	    configurable: true
	  });
	  Object.defineProperty(StateNode.prototype, "transitions", {
	    /**
	     * All the transitions that can be taken from this state node.
	     */
	    get: function () {
	      return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
	    },
	    enumerable: false,
	    configurable: true
	  });

	  StateNode.prototype.getCandidates = function (eventName) {
	    if (this.__cache.candidates[eventName]) {
	      return this.__cache.candidates[eventName];
	    }

	    var transient = eventName === NULL_EVENT;
	    var candidates = this.transitions.filter(function (transition) {
	      var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions

	      return transient ? sameEventType : sameEventType || transition.eventType === WILDCARD;
	    });
	    this.__cache.candidates[eventName] = candidates;
	    return candidates;
	  };
	  /**
	   * All delayed transitions from the config.
	   */


	  StateNode.prototype.getDelayedTransitions = function () {
	    var _this = this;

	    var afterConfig = this.config.after;

	    if (!afterConfig) {
	      return [];
	    }

	    var mutateEntryExit = function (delay, i) {
	      var delayRef = isFunction$2(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
	      var eventType = after(delayRef, _this.id);

	      _this.onEntry.push(send$1(eventType, {
	        delay: delay
	      }));

	      _this.onExit.push(cancel(eventType));

	      return eventType;
	    };

	    var delayedTransitions = isArray$6(afterConfig) ? afterConfig.map(function (transition, i) {
	      var eventType = mutateEntryExit(transition.delay, i);
	      return __assign$2(__assign$2({}, transition), {
	        event: eventType
	      });
	    }) : flatten(Object.keys(afterConfig).map(function (delay, i) {
	      var configTransition = afterConfig[delay];
	      var resolvedTransition = isString$2(configTransition) ? {
	        target: configTransition
	      } : configTransition;
	      var resolvedDelay = !isNaN(+delay) ? +delay : delay;
	      var eventType = mutateEntryExit(resolvedDelay, i);
	      return toArray$2(resolvedTransition).map(function (transition) {
	        return __assign$2(__assign$2({}, transition), {
	          event: eventType,
	          delay: resolvedDelay
	        });
	      });
	    }));
	    return delayedTransitions.map(function (delayedTransition) {
	      var delay = delayedTransition.delay;
	      return __assign$2(__assign$2({}, _this.formatTransition(delayedTransition)), {
	        delay: delay
	      });
	    });
	  };
	  /**
	   * Returns the state nodes represented by the current state value.
	   *
	   * @param state The state value or State instance
	   */


	  StateNode.prototype.getStateNodes = function (state) {
	    var _a;

	    var _this = this;

	    if (!state) {
	      return [];
	    }

	    var stateValue = state instanceof State$1 ? state.value : toStateValue(state, this.delimiter);

	    if (isString$2(stateValue)) {
	      var initialStateValue = this.getStateNode(stateValue).initial;
	      return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [this, this.states[stateValue]];
	    }

	    var subStateKeys = Object.keys(stateValue);
	    var subStateNodes = [this];
	    subStateNodes.push.apply(subStateNodes, __spreadArray$2([], __read$2(flatten(subStateKeys.map(function (subStateKey) {
	      return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
	    }))), false));
	    return subStateNodes;
	  };
	  /**
	   * Returns `true` if this state node explicitly handles the given event.
	   *
	   * @param event The event in question
	   */


	  StateNode.prototype.handles = function (event) {
	    var eventType = getEventType(event);
	    return this.events.includes(eventType);
	  };
	  /**
	   * Resolves the given `state` to a new `State` instance relative to this machine.
	   *
	   * This ensures that `.events` and `.nextEvents` represent the correct values.
	   *
	   * @param state The state to resolve
	   */


	  StateNode.prototype.resolveState = function (state) {
	    var stateFromConfig = state instanceof State$1 ? state : State$1.create(state);
	    var configuration = Array.from(getConfiguration([], this.getStateNodes(stateFromConfig.value)));
	    return new State$1(__assign$2(__assign$2({}, stateFromConfig), {
	      value: this.resolve(stateFromConfig.value),
	      configuration: configuration,
	      done: isInFinalState(configuration, this),
	      tags: getTagsFromConfiguration(configuration),
	      machine: this.machine
	    }));
	  };

	  StateNode.prototype.transitionLeafNode = function (stateValue, state, _event) {
	    var stateNode = this.getStateNode(stateValue);
	    var next = stateNode.next(state, _event);

	    if (!next || !next.transitions.length) {
	      return this.next(state, _event);
	    }

	    return next;
	  };

	  StateNode.prototype.transitionCompoundNode = function (stateValue, state, _event) {
	    var subStateKeys = Object.keys(stateValue);
	    var stateNode = this.getStateNode(subStateKeys[0]);

	    var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);

	    if (!next || !next.transitions.length) {
	      return this.next(state, _event);
	    }

	    return next;
	  };

	  StateNode.prototype.transitionParallelNode = function (stateValue, state, _event) {
	    var e_2, _a;

	    var transitionMap = {};

	    try {
	      for (var _b = __values$2(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()) {
	        var subStateKey = _c.value;
	        var subStateValue = stateValue[subStateKey];

	        if (!subStateValue) {
	          continue;
	        }

	        var subStateNode = this.getStateNode(subStateKey);

	        var next = subStateNode._transition(subStateValue, state, _event);

	        if (next) {
	          transitionMap[subStateKey] = next;
	        }
	      }
	    } catch (e_2_1) {
	      e_2 = {
	        error: e_2_1
	      };
	    } finally {
	      try {
	        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	      } finally {
	        if (e_2) throw e_2.error;
	      }
	    }

	    var stateTransitions = Object.keys(transitionMap).map(function (key) {
	      return transitionMap[key];
	    });
	    var enabledTransitions = flatten(stateTransitions.map(function (st) {
	      return st.transitions;
	    }));
	    var willTransition = stateTransitions.some(function (st) {
	      return st.transitions.length > 0;
	    });

	    if (!willTransition) {
	      return this.next(state, _event);
	    }

	    var configuration = flatten(Object.keys(transitionMap).map(function (key) {
	      return transitionMap[key].configuration;
	    }));
	    return {
	      transitions: enabledTransitions,
	      exitSet: flatten(stateTransitions.map(function (t) {
	        return t.exitSet;
	      })),
	      configuration: configuration,
	      source: state,
	      actions: flatten(Object.keys(transitionMap).map(function (key) {
	        return transitionMap[key].actions;
	      }))
	    };
	  };

	  StateNode.prototype._transition = function (stateValue, state, _event) {
	    // leaf node
	    if (isString$2(stateValue)) {
	      return this.transitionLeafNode(stateValue, state, _event);
	    } // hierarchical node


	    if (Object.keys(stateValue).length === 1) {
	      return this.transitionCompoundNode(stateValue, state, _event);
	    } // orthogonal node


	    return this.transitionParallelNode(stateValue, state, _event);
	  };

	  StateNode.prototype.getTransitionData = function (state, event) {
	    return this._transition(state.value, state, toSCXMLEvent(event));
	  };

	  StateNode.prototype.next = function (state, _event) {
	    var e_3, _a;

	    var _this = this;

	    var eventName = _event.name;
	    var actions = [];
	    var nextStateNodes = [];
	    var selectedTransition;

	    try {
	      for (var _b = __values$2(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()) {
	        var candidate = _c.value;
	        var cond = candidate.cond,
	            stateIn = candidate.in;
	        var resolvedContext = state.context;
	        var isInState = stateIn ? isString$2(stateIn) && isStateId(stateIn) ? // Check if in state by ID
	        state.matches(toStateValue(this.getStateNodeById(stateIn).path, this.delimiter)) : // Check if in state by relative grandparent
	        matchesState(toStateValue(stateIn, this.delimiter), path(this.path.slice(0, -2))(state.value)) : true;
	        var guardPassed = false;

	        try {
	          guardPassed = !cond || evaluateGuard(this.machine, cond, resolvedContext, _event, state);
	        } catch (err) {
	          throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
	        }

	        if (guardPassed && isInState) {
	          if (candidate.target !== undefined) {
	            nextStateNodes = candidate.target;
	          }

	          actions.push.apply(actions, __spreadArray$2([], __read$2(candidate.actions), false));
	          selectedTransition = candidate;
	          break;
	        }
	      }
	    } catch (e_3_1) {
	      e_3 = {
	        error: e_3_1
	      };
	    } finally {
	      try {
	        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	      } finally {
	        if (e_3) throw e_3.error;
	      }
	    }

	    if (!selectedTransition) {
	      return undefined;
	    }

	    if (!nextStateNodes.length) {
	      return {
	        transitions: [selectedTransition],
	        exitSet: [],
	        configuration: state.value ? [this] : [],
	        source: state,
	        actions: actions
	      };
	    }

	    var allNextStateNodes = flatten(nextStateNodes.map(function (stateNode) {
	      return _this.getRelativeStateNodes(stateNode, state.historyValue);
	    }));
	    var isInternal = !!selectedTransition.internal;
	    return {
	      transitions: [selectedTransition],
	      exitSet: isInternal ? [] : flatten(nextStateNodes.map(function (targetNode) {
	        return _this.getPotentiallyReenteringNodes(targetNode);
	      })),
	      configuration: allNextStateNodes,
	      source: state,
	      actions: actions
	    };
	  }; // even though the name of this function mentions reentry nodes
	  // we are pushing its result into `exitSet`
	  // that's because what we exit might be reentered (it's an invariant of reentrancy)


	  StateNode.prototype.getPotentiallyReenteringNodes = function (targetNode) {
	    if (this.order < targetNode.order) {
	      return [this];
	    }

	    var nodes = [];
	    var marker = this;
	    var possibleAncestor = targetNode;

	    while (marker && marker !== possibleAncestor) {
	      nodes.push(marker);
	      marker = marker.parent;
	    }

	    if (marker !== possibleAncestor) {
	      // we never got to `possibleAncestor`, therefore the initial `marker` "escapes" it
	      // it's in a different part of the tree so no states will be reentered for such an external transition
	      return [];
	    }

	    nodes.push(possibleAncestor);
	    return nodes;
	  };

	  StateNode.prototype.getActions = function (resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
	    var e_4, _a, e_5, _b;

	    var _this = this;

	    var prevConfig = prevState ? getConfiguration([], this.getStateNodes(prevState.value)) : [];
	    var entrySet = new Set();

	    try {
	      for (var _c = __values$2(Array.from(resolvedConfig).sort(function (a, b) {
	        return a.order - b.order;
	      })), _d = _c.next(); !_d.done; _d = _c.next()) {
	        var sn = _d.value;

	        if (!has$4(prevConfig, sn) || has$4(transition.exitSet, sn) || sn.parent && entrySet.has(sn.parent)) {
	          entrySet.add(sn);
	        }
	      }
	    } catch (e_4_1) {
	      e_4 = {
	        error: e_4_1
	      };
	    } finally {
	      try {
	        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	      } finally {
	        if (e_4) throw e_4.error;
	      }
	    }

	    try {
	      for (var prevConfig_1 = __values$2(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()) {
	        var sn = prevConfig_1_1.value;

	        if (!has$4(resolvedConfig, sn) || has$4(transition.exitSet, sn.parent)) {
	          transition.exitSet.push(sn);
	        }
	      }
	    } catch (e_5_1) {
	      e_5 = {
	        error: e_5_1
	      };
	    } finally {
	      try {
	        if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
	      } finally {
	        if (e_5) throw e_5.error;
	      }
	    }

	    transition.exitSet.sort(function (a, b) {
	      return b.order - a.order;
	    });
	    var entryStates = Array.from(entrySet).sort(function (a, b) {
	      return a.order - b.order;
	    });
	    var exitStates = new Set(transition.exitSet);
	    var doneEvents = flatten(entryStates.map(function (sn) {
	      var events = [];

	      if (sn.type !== 'final') {
	        return events;
	      }

	      var parent = sn.parent;

	      if (!parent.parent) {
	        return events;
	      }

	      events.push(done$1(sn.id, sn.doneData), // TODO: deprecate - final states should not emit done events for their own state.
	      done$1(parent.id, sn.doneData ? mapContext(sn.doneData, currentContext, _event) : undefined));
	      var grandparent = parent.parent;

	      if (grandparent.type === 'parallel') {
	        if (getChildren(grandparent).every(function (parentNode) {
	          return isInFinalState(transition.configuration, parentNode);
	        })) {
	          events.push(done$1(grandparent.id));
	        }
	      }

	      return events;
	    }));
	    var entryActions = entryStates.map(function (stateNode) {
	      var entryActions = stateNode.onEntry;
	      var invokeActions = stateNode.activities.map(function (activity) {
	        return start(activity);
	      });
	      return {
	        type: 'entry',
	        actions: toActionObjects(predictableExec ? __spreadArray$2(__spreadArray$2([], __read$2(entryActions), false), __read$2(invokeActions), false) : __spreadArray$2(__spreadArray$2([], __read$2(invokeActions), false), __read$2(entryActions), false), _this.machine.options.actions)
	      };
	    }).concat({
	      type: 'state_done',
	      actions: doneEvents.map(function (event) {
	        return raise(event);
	      })
	    });
	    var exitActions = Array.from(exitStates).map(function (stateNode) {
	      return {
	        type: 'exit',
	        actions: toActionObjects(__spreadArray$2(__spreadArray$2([], __read$2(stateNode.onExit), false), __read$2(stateNode.activities.map(function (activity) {
	          return stop(activity);
	        })), false), _this.machine.options.actions)
	      };
	    });
	    var actions = exitActions.concat({
	      type: 'transition',
	      actions: toActionObjects(transition.actions, this.machine.options.actions)
	    }).concat(entryActions);

	    if (isDone) {
	      var stopActions = toActionObjects(flatten(__spreadArray$2([], __read$2(resolvedConfig), false).sort(function (a, b) {
	        return b.order - a.order;
	      }).map(function (stateNode) {
	        return stateNode.onExit;
	      })), this.machine.options.actions).filter(function (action) {
	        return !isRaisableAction(action);
	      });
	      return actions.concat({
	        type: 'stop',
	        actions: stopActions
	      });
	    }

	    return actions;
	  };
	  /**
	   * Determines the next state given the current `state` and sent `event`.
	   *
	   * @param state The current State instance or state value
	   * @param event The event that was sent at the current state
	   * @param context The current context (extended state) of the current state
	   */


	  StateNode.prototype.transition = function (state, event, context, exec) {
	    if (state === void 0) {
	      state = this.initialState;
	    }

	    var _event = toSCXMLEvent(event);

	    var currentState;

	    if (state instanceof State$1) {
	      currentState = context === undefined ? state : this.resolveState(State$1.from(state, context));
	    } else {
	      var resolvedStateValue = isString$2(state) ? this.resolve(pathToStateValue(this.getResolvedPath(state))) : this.resolve(state);
	      var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
	      currentState = this.resolveState(State$1.from(resolvedStateValue, resolvedContext));
	    }

	    if (_event.name === WILDCARD) {
	      throw new Error("An event cannot have the wildcard type ('".concat(WILDCARD, "')"));
	    }

	    if (this.strict) {
	      if (!this.events.includes(_event.name) && !isBuiltInEvent(_event.name)) {
	        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
	      }
	    }

	    var stateTransition = this._transition(currentState.value, currentState, _event) || {
	      transitions: [],
	      configuration: [],
	      exitSet: [],
	      source: currentState,
	      actions: []
	    };
	    var prevConfig = getConfiguration([], this.getStateNodes(currentState.value));
	    var resolvedConfig = stateTransition.configuration.length ? getConfiguration(prevConfig, stateTransition.configuration) : prevConfig;
	    stateTransition.configuration = __spreadArray$2([], __read$2(resolvedConfig), false);
	    return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
	  };

	  StateNode.prototype.resolveRaisedTransition = function (state, _event, originalEvent, predictableExec) {
	    var _a;

	    var currentActions = state.actions;
	    state = this.transition(state, _event, undefined, predictableExec); // Save original event to state
	    // TODO: this should be the raised event! Delete in V5 (breaking)

	    state._event = originalEvent;
	    state.event = originalEvent.data;

	    (_a = state.actions).unshift.apply(_a, __spreadArray$2([], __read$2(currentActions), false));

	    return state;
	  };

	  StateNode.prototype.resolveTransition = function (stateTransition, currentState, context, predictableExec, _event) {
	    var e_6, _a, e_7, _b;

	    var _this = this;

	    if (_event === void 0) {
	      _event = initEvent;
	    }

	    var configuration = stateTransition.configuration; // Transition will "apply" if:
	    // - this is the initial state (there is no current state)
	    // - OR there are transitions

	    var willTransition = !currentState || stateTransition.transitions.length > 0;
	    var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
	    var isDone = isInFinalState(resolvedConfiguration, this);
	    var resolvedStateValue = willTransition ? getValue(this.machine, configuration) : undefined;
	    var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
	    var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
	    var activities = currentState ? __assign$2({}, currentState.activities) : {};

	    try {
	      for (var actionBlocks_1 = __values$2(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()) {
	        var block = actionBlocks_1_1.value;

	        try {
	          for (var _c = (e_7 = void 0, __values$2(block.actions)), _d = _c.next(); !_d.done; _d = _c.next()) {
	            var action = _d.value;

	            if (action.type === start$1) {
	              activities[action.activity.id || action.activity.type] = action;
	            } else if (action.type === stop$1) {
	              activities[action.activity.id || action.activity.type] = false;
	            }
	          }
	        } catch (e_7_1) {
	          e_7 = {
	            error: e_7_1
	          };
	        } finally {
	          try {
	            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
	          } finally {
	            if (e_7) throw e_7.error;
	          }
	        }
	      }
	    } catch (e_6_1) {
	      e_6 = {
	        error: e_6_1
	      };
	    } finally {
	      try {
	        if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
	      } finally {
	        if (e_6) throw e_6.error;
	      }
	    }

	    var _e = __read$2(resolveActions(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2),
	        resolvedActions = _e[0],
	        updatedContext = _e[1];

	    var _f = __read$2(partition$2(resolvedActions, isRaisableAction), 2),
	        raisedEvents = _f[0],
	        nonRaisedActions = _f[1];

	    var invokeActions = resolvedActions.filter(function (action) {
	      var _a;

	      return action.type === start$1 && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === invoke;
	    });
	    var children = invokeActions.reduce(function (acc, action) {
	      acc[action.activity.id] = createInvocableActor(action.activity, _this.machine, updatedContext, _event);
	      return acc;
	    }, currentState ? __assign$2({}, currentState.children) : {});
	    var nextState = new State$1({
	      value: resolvedStateValue || currentState.value,
	      context: updatedContext,
	      _event: _event,
	      // Persist _sessionid between states
	      _sessionid: currentState ? currentState._sessionid : null,
	      historyValue: resolvedStateValue ? historyValue ? updateHistoryValue(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
	      history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
	      actions: resolvedStateValue ? nonRaisedActions : [],
	      activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
	      events: [],
	      configuration: resolvedConfiguration,
	      transitions: stateTransition.transitions,
	      children: children,
	      done: isDone,
	      tags: getTagsFromConfiguration(resolvedConfiguration),
	      machine: this
	    });
	    var didUpdateContext = context !== updatedContext;
	    nextState.changed = _event.name === update || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks

	    var history = nextState.history;

	    if (history) {
	      delete history.history;
	    } // There are transient transitions if the machine is not in a final state
	    // and if some of the state nodes have transient ("always") transitions.


	    var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function (stateNode) {
	      return stateNode._transient;
	    })); // If there are no enabled transitions, check if there are transient transitions.
	    // If there are transient transitions, continue checking for more transitions
	    // because an transient transition should be triggered even if there are no
	    // enabled transitions.
	    //
	    // If we're already working on an transient transition then stop to prevent an infinite loop.
	    //
	    // Otherwise, if there are no enabled nor transient transitions, we are done.

	    if (!willTransition && (!hasAlwaysTransitions || _event.name === NULL_EVENT)) {
	      return nextState;
	    }

	    var maybeNextState = nextState;

	    if (!isDone) {
	      if (hasAlwaysTransitions) {
	        maybeNextState = this.resolveRaisedTransition(maybeNextState, {
	          type: nullEvent
	        }, _event, predictableExec);
	      }

	      while (raisedEvents.length) {
	        var raisedEvent = raisedEvents.shift();
	        maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
	      }
	    } // Detect if state changed


	    var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !stateValuesEqual(maybeNextState.value, history.value) : undefined);
	    maybeNextState.changed = changed; // Preserve original history after raised events

	    maybeNextState.history = history;
	    return maybeNextState;
	  };
	  /**
	   * Returns the child state node from its relative `stateKey`, or throws.
	   */


	  StateNode.prototype.getStateNode = function (stateKey) {
	    if (isStateId(stateKey)) {
	      return this.machine.getStateNodeById(stateKey);
	    }

	    if (!this.states) {
	      throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
	    }

	    var result = this.states[stateKey];

	    if (!result) {
	      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
	    }

	    return result;
	  };
	  /**
	   * Returns the state node with the given `stateId`, or throws.
	   *
	   * @param stateId The state ID. The prefix "#" is removed.
	   */


	  StateNode.prototype.getStateNodeById = function (stateId) {
	    var resolvedStateId = isStateId(stateId) ? stateId.slice(STATE_IDENTIFIER.length) : stateId;

	    if (resolvedStateId === this.id) {
	      return this;
	    }

	    var stateNode = this.machine.idMap[resolvedStateId];

	    if (!stateNode) {
	      throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
	    }

	    return stateNode;
	  };
	  /**
	   * Returns the relative state node from the given `statePath`, or throws.
	   *
	   * @param statePath The string or string array relative path to the state node.
	   */


	  StateNode.prototype.getStateNodeByPath = function (statePath) {
	    if (typeof statePath === 'string' && isStateId(statePath)) {
	      try {
	        return this.getStateNodeById(statePath.slice(1));
	      } catch (e) {// try individual paths
	        // throw e;
	      }
	    }

	    var arrayStatePath = toStatePath(statePath, this.delimiter).slice();
	    var currentStateNode = this;

	    while (arrayStatePath.length) {
	      var key = arrayStatePath.shift();

	      if (!key.length) {
	        break;
	      }

	      currentStateNode = currentStateNode.getStateNode(key);
	    }

	    return currentStateNode;
	  };
	  /**
	   * Resolves a partial state value with its full representation in this machine.
	   *
	   * @param stateValue The partial state value to resolve.
	   */


	  StateNode.prototype.resolve = function (stateValue) {
	    var _a;

	    var _this = this;

	    if (!stateValue) {
	      return this.initialStateValue || EMPTY_OBJECT; // TODO: type-specific properties
	    }

	    switch (this.type) {
	      case 'parallel':
	        return mapValues(this.initialStateValue, function (subStateValue, subStateKey) {
	          return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : EMPTY_OBJECT;
	        });

	      case 'compound':
	        if (isString$2(stateValue)) {
	          var subStateNode = this.getStateNode(stateValue);

	          if (subStateNode.type === 'parallel' || subStateNode.type === 'compound') {
	            return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
	          }

	          return stateValue;
	        }

	        if (!Object.keys(stateValue).length) {
	          return this.initialStateValue || {};
	        }

	        return mapValues(stateValue, function (subStateValue, subStateKey) {
	          return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : EMPTY_OBJECT;
	        });

	      default:
	        return stateValue || EMPTY_OBJECT;
	    }
	  };

	  StateNode.prototype.getResolvedPath = function (stateIdentifier) {
	    if (isStateId(stateIdentifier)) {
	      var stateNode = this.machine.idMap[stateIdentifier.slice(STATE_IDENTIFIER.length)];

	      if (!stateNode) {
	        throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
	      }

	      return stateNode.path;
	    }

	    return toStatePath(stateIdentifier, this.delimiter);
	  };

	  Object.defineProperty(StateNode.prototype, "initialStateValue", {
	    get: function () {
	      var _a;

	      if (this.__cache.initialStateValue) {
	        return this.__cache.initialStateValue;
	      }

	      var initialStateValue;

	      if (this.type === 'parallel') {
	        initialStateValue = mapFilterValues(this.states, function (state) {
	          return state.initialStateValue || EMPTY_OBJECT;
	        }, function (stateNode) {
	          return !(stateNode.type === 'history');
	        });
	      } else if (this.initial !== undefined) {
	        if (!this.states[this.initial]) {
	          throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
	        }

	        initialStateValue = isLeafNode(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
	      } else {
	        // The finite state value of a machine without child states is just an empty object
	        initialStateValue = {};
	      }

	      this.__cache.initialStateValue = initialStateValue;
	      return this.__cache.initialStateValue;
	    },
	    enumerable: false,
	    configurable: true
	  });

	  StateNode.prototype.getInitialState = function (stateValue, context) {
	    this._init(); // TODO: this should be in the constructor (see note in constructor)


	    var configuration = this.getStateNodes(stateValue);
	    return this.resolveTransition({
	      configuration: configuration,
	      exitSet: [],
	      transitions: [],
	      source: undefined,
	      actions: []
	    }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
	  };

	  Object.defineProperty(StateNode.prototype, "initialState", {
	    /**
	     * The initial State instance, which includes all actions to be executed from
	     * entering the initial state.
	     */
	    get: function () {
	      var initialStateValue = this.initialStateValue;

	      if (!initialStateValue) {
	        throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
	      }

	      return this.getInitialState(initialStateValue);
	    },
	    enumerable: false,
	    configurable: true
	  });
	  Object.defineProperty(StateNode.prototype, "target", {
	    /**
	     * The target state value of the history state node, if it exists. This represents the
	     * default state value to transition to if no history value exists yet.
	     */
	    get: function () {
	      var target;

	      if (this.type === 'history') {
	        var historyConfig = this.config;

	        if (isString$2(historyConfig.target)) {
	          target = isStateId(historyConfig.target) ? pathToStateValue(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
	        } else {
	          target = historyConfig.target;
	        }
	      }

	      return target;
	    },
	    enumerable: false,
	    configurable: true
	  });
	  /**
	   * Returns the leaf nodes from a state path relative to this state node.
	   *
	   * @param relativeStateId The relative state path to retrieve the state nodes
	   * @param history The previous state to retrieve history
	   * @param resolve Whether state nodes should resolve to initial child state nodes
	   */

	  StateNode.prototype.getRelativeStateNodes = function (relativeStateId, historyValue, resolve) {
	    if (resolve === void 0) {
	      resolve = true;
	    }

	    return resolve ? relativeStateId.type === 'history' ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [relativeStateId];
	  };

	  Object.defineProperty(StateNode.prototype, "initialStateNodes", {
	    get: function () {
	      var _this = this;

	      if (isLeafNode(this)) {
	        return [this];
	      } // Case when state node is compound but no initial state is defined


	      if (this.type === 'compound' && !this.initial) {
	        {
	          warn(false, "Compound state node '".concat(this.id, "' has no initial state."));
	        }

	        return [this];
	      }

	      var initialStateNodePaths = toStatePaths(this.initialStateValue);
	      return flatten(initialStateNodePaths.map(function (initialPath) {
	        return _this.getFromRelativePath(initialPath);
	      }));
	    },
	    enumerable: false,
	    configurable: true
	  });
	  /**
	   * Retrieves state nodes from a relative path to this state node.
	   *
	   * @param relativePath The relative path from this state node
	   * @param historyValue
	   */

	  StateNode.prototype.getFromRelativePath = function (relativePath) {
	    if (!relativePath.length) {
	      return [this];
	    }

	    var _a = __read$2(relativePath),
	        stateKey = _a[0],
	        childStatePath = _a.slice(1);

	    if (!this.states) {
	      throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
	    }

	    var childStateNode = this.getStateNode(stateKey);

	    if (childStateNode.type === 'history') {
	      return childStateNode.resolveHistory();
	    }

	    if (!this.states[stateKey]) {
	      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
	    }

	    return this.states[stateKey].getFromRelativePath(childStatePath);
	  };

	  StateNode.prototype.historyValue = function (relativeStateValue) {
	    if (!Object.keys(this.states).length) {
	      return undefined;
	    }

	    return {
	      current: relativeStateValue || this.initialStateValue,
	      states: mapFilterValues(this.states, function (stateNode, key) {
	        if (!relativeStateValue) {
	          return stateNode.historyValue();
	        }

	        var subStateValue = isString$2(relativeStateValue) ? undefined : relativeStateValue[key];
	        return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
	      }, function (stateNode) {
	        return !stateNode.history;
	      })
	    };
	  };
	  /**
	   * Resolves to the historical value(s) of the parent state node,
	   * represented by state nodes.
	   *
	   * @param historyValue
	   */


	  StateNode.prototype.resolveHistory = function (historyValue) {
	    var _this = this;

	    if (this.type !== 'history') {
	      return [this];
	    }

	    var parent = this.parent;

	    if (!historyValue) {
	      var historyTarget = this.target;
	      return historyTarget ? flatten(toStatePaths(historyTarget).map(function (relativeChildPath) {
	        return parent.getFromRelativePath(relativeChildPath);
	      })) : parent.initialStateNodes;
	    }

	    var subHistoryValue = nestedPath(parent.path, 'states')(historyValue).current;

	    if (isString$2(subHistoryValue)) {
	      return [parent.getStateNode(subHistoryValue)];
	    }

	    return flatten(toStatePaths(subHistoryValue).map(function (subStatePath) {
	      return _this.history === 'deep' ? parent.getFromRelativePath(subStatePath) : [parent.states[subStatePath[0]]];
	    }));
	  };

	  Object.defineProperty(StateNode.prototype, "stateIds", {
	    /**
	     * All the state node IDs of this state node and its descendant state nodes.
	     */
	    get: function () {
	      var _this = this;

	      var childStateIds = flatten(Object.keys(this.states).map(function (stateKey) {
	        return _this.states[stateKey].stateIds;
	      }));
	      return [this.id].concat(childStateIds);
	    },
	    enumerable: false,
	    configurable: true
	  });
	  Object.defineProperty(StateNode.prototype, "events", {
	    /**
	     * All the event types accepted by this state node and its descendants.
	     */
	    get: function () {
	      var e_8, _a, e_9, _b;

	      if (this.__cache.events) {
	        return this.__cache.events;
	      }

	      var states = this.states;
	      var events = new Set(this.ownEvents);

	      if (states) {
	        try {
	          for (var _c = __values$2(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()) {
	            var stateId = _d.value;
	            var state = states[stateId];

	            if (state.states) {
	              try {
	                for (var _e = (e_9 = void 0, __values$2(state.events)), _f = _e.next(); !_f.done; _f = _e.next()) {
	                  var event_1 = _f.value;
	                  events.add("".concat(event_1));
	                }
	              } catch (e_9_1) {
	                e_9 = {
	                  error: e_9_1
	                };
	              } finally {
	                try {
	                  if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                } finally {
	                  if (e_9) throw e_9.error;
	                }
	              }
	            }
	          }
	        } catch (e_8_1) {
	          e_8 = {
	            error: e_8_1
	          };
	        } finally {
	          try {
	            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	          } finally {
	            if (e_8) throw e_8.error;
	          }
	        }
	      }

	      return this.__cache.events = Array.from(events);
	    },
	    enumerable: false,
	    configurable: true
	  });
	  Object.defineProperty(StateNode.prototype, "ownEvents", {
	    /**
	     * All the events that have transitions directly from this state node.
	     *
	     * Excludes any inert events.
	     */
	    get: function () {
	      var events = new Set(this.transitions.filter(function (transition) {
	        return !(!transition.target && !transition.actions.length && transition.internal);
	      }).map(function (transition) {
	        return transition.eventType;
	      }));
	      return Array.from(events);
	    },
	    enumerable: false,
	    configurable: true
	  });

	  StateNode.prototype.resolveTarget = function (_target) {
	    var _this = this;

	    if (_target === undefined) {
	      // an undefined target signals that the state node should not transition from that state when receiving that event
	      return undefined;
	    }

	    return _target.map(function (target) {
	      if (!isString$2(target)) {
	        return target;
	      }

	      var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
	      // do not include machine key on target

	      if (isInternalTarget && !_this.parent) {
	        return _this.getStateNodeByPath(target.slice(1));
	      }

	      var resolvedTarget = isInternalTarget ? _this.key + target : target;

	      if (_this.parent) {
	        try {
	          var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);

	          return targetStateNode;
	        } catch (err) {
	          throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
	        }
	      } else {
	        return _this.getStateNodeByPath(resolvedTarget);
	      }
	    });
	  };

	  StateNode.prototype.formatTransition = function (transitionConfig) {
	    var _this = this;

	    var normalizedTarget = normalizeTarget(transitionConfig.target);
	    var internal = 'internal' in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function (_target) {
	      return isString$2(_target) && _target[0] === _this.delimiter;
	    }) : true;
	    var guards = this.machine.options.guards;
	    var target = this.resolveTarget(normalizedTarget);

	    var transition = __assign$2(__assign$2({}, transitionConfig), {
	      actions: toActionObjects(toArray$2(transitionConfig.actions)),
	      cond: toGuard(transitionConfig.cond, guards),
	      target: target,
	      source: this,
	      internal: internal,
	      eventType: transitionConfig.event,
	      toJSON: function () {
	        return __assign$2(__assign$2({}, transition), {
	          target: transition.target ? transition.target.map(function (t) {
	            return "#".concat(t.id);
	          }) : undefined,
	          source: "#".concat(_this.id)
	        });
	      }
	    });

	    return transition;
	  };

	  StateNode.prototype.formatTransitions = function () {
	    var e_10, _a;

	    var _this = this;

	    var onConfig;

	    if (!this.config.on) {
	      onConfig = [];
	    } else if (Array.isArray(this.config.on)) {
	      onConfig = this.config.on;
	    } else {
	      var _b = this.config.on,
	          _c = WILDCARD,
	          _d = _b[_c],
	          wildcardConfigs = _d === void 0 ? [] : _d,
	          strictTransitionConfigs_1 = __rest$3(_b, [typeof _c === "symbol" ? _c : _c + ""]);

	      onConfig = flatten(Object.keys(strictTransitionConfigs_1).map(function (key) {
	        if (key === NULL_EVENT) {
	          warn(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + "Please check the `on` configuration for \"#".concat(_this.id, "\"."));
	        }

	        var transitionConfigArray = toTransitionConfigArray(key, strictTransitionConfigs_1[key]);

	        {
	          validateArrayifiedTransitions(_this, key, transitionConfigArray);
	        }

	        return transitionConfigArray;
	      }).concat(toTransitionConfigArray(WILDCARD, wildcardConfigs)));
	    }

	    var eventlessConfig = this.config.always ? toTransitionConfigArray('', this.config.always) : [];
	    var doneConfig = this.config.onDone ? toTransitionConfigArray(String(done$1(this.id)), this.config.onDone) : [];

	    {
	      warn(!(this.config.onDone && !this.parent), "Root nodes cannot have an \".onDone\" transition. Please check the config of \"".concat(this.id, "\"."));
	    }

	    var invokeConfig = flatten(this.invoke.map(function (invokeDef) {
	      var settleTransitions = [];

	      if (invokeDef.onDone) {
	        settleTransitions.push.apply(settleTransitions, __spreadArray$2([], __read$2(toTransitionConfigArray(String(doneInvoke(invokeDef.id)), invokeDef.onDone)), false));
	      }

	      if (invokeDef.onError) {
	        settleTransitions.push.apply(settleTransitions, __spreadArray$2([], __read$2(toTransitionConfigArray(String(error(invokeDef.id)), invokeDef.onError)), false));
	      }

	      return settleTransitions;
	    }));
	    var delayedTransitions = this.after;
	    var formattedTransitions = flatten(__spreadArray$2(__spreadArray$2(__spreadArray$2(__spreadArray$2([], __read$2(doneConfig), false), __read$2(invokeConfig), false), __read$2(onConfig), false), __read$2(eventlessConfig), false).map(function (transitionConfig) {
	      return toArray$2(transitionConfig).map(function (transition) {
	        return _this.formatTransition(transition);
	      });
	    }));

	    try {
	      for (var delayedTransitions_1 = __values$2(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()) {
	        var delayedTransition = delayedTransitions_1_1.value;
	        formattedTransitions.push(delayedTransition);
	      }
	    } catch (e_10_1) {
	      e_10 = {
	        error: e_10_1
	      };
	    } finally {
	      try {
	        if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
	      } finally {
	        if (e_10) throw e_10.error;
	      }
	    }

	    return formattedTransitions;
	  };

	  return StateNode;
	}();

	var warned = false;
	function createMachine(config, options) {
	  if (!('predictableActionArguments' in config) && !warned) {
	    warned = true;
	    console.warn('It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html');
	  }

	  return new StateNode(config, options);
	}

	var assign$3 = assign$4,
	    send = send$1;

	const utf8encoder = new TextEncoder();
	/**
	 * @param {string} str
	 * @returns {string}
	 */
	function strToHex(str) {
	  const rb = utf8encoder.encode(str);
	  let acc = "";
	  for (const byte of rb) {
	    acc += `0${byte.toString(16)}`.slice(-2);
	  }
	  return `0x${acc}`
	}

	/**
	 * @param {string} hex
	 * @returns {string}
	 */
	function hexToStr(hex) {
	  return decodeURIComponent(hex.replace(/\s+/ug, "").replace(/[0-9a-f]{2}/ug, "%$&")).slice(2)
	}

	class MappedSigner {
	  /** @type {NonNullable<import("wagmi/actions").GetWalletClientResult>} */
	  #signer

	  /**
	   * @param {NonNullable<import("wagmi/actions").GetWalletClientResult>} signer
	   */
	  constructor(signer) {
	    this.#signer = signer;
	  }

	  /**
	   * @param {string} message
	   */
	  async signMessage(message) {
	    return this.#signer.signMessage({ message })
	  }

	  async getAddress() {
	    const addresses = await this.#signer.getAddresses();
	    return addresses[ 0 ]
	  }

	  /**
	   * Maps VIEM to Etehrs.JS
	   * @param {any} domain
	   * @param {any} types
	   * @param {any} values
	   */
	  async _signTypedData(domain, types, values) {
	    const [ primaryType ] = Object.keys(types);
	    return this.#signer.signTypedData({
	      domain,
	      types,
	      primaryType,
	      message: values,
	    })
	  }
	}

	/**
	 * Return the message that should be signed to validate the given tokens
	 * @param {import("../services/state").Context} context
	 * @returns {string}
	 */
	function getOfferItemRedemptionMessage(context) {
	  const now = new Date();

	  const selectedOffer = context.offers.find((offer) => offer.id === context.offerSelectedId);
	  if (!selectedOffer) {
	    throw new Error("Offer not found")
	  }
	  const selectedItem = selectedOffer.redemption.items.find((item) => item.id === context.offerSelectedItemId);

	  let tokenCount = 0;
	  const tokenMessages = [];
	  switch (selectedOffer.redemption.selectType) {
	    case "single": {
	      const selectedContract = selectedOffer?.redemption.contractTokens.find((token) => `${token.type}:${token.address}` === context.offerSelectedContract);
	      if (!selectedContract || context.offerSelectedTokenId == null) {
	        throw new Error("Selected token is required")
	      }
	      const token = selectedContract.tokens[ context.offerSelectedTokenId ];
	      if (token.redeemMessage) {
	        tokenMessages.push(hexToStr(token.redeemMessage));
	      } else {
	        const tokenIds = [ context.offerSelectedTokenId ];
	        const contractTokensCount = tokenIds.length;
	        tokenCount += contractTokensCount;
	        const contractText = `${selectedContract.name} (${selectedContract.type}: ${selectedContract.address})`;
	        const tokenText = tokenIds.join(", ");
	        tokenMessages.push(`contract: ${contractText}\ntoken id${contractTokensCount > 1 ? "s" : ""}: ${tokenText}`);
	      }
	      break
	    }
	    case "wallet": {
	      for (const contract of selectedOffer.redemption.contractTokens) {
	        const tokenIds = Object.keys(contract.tokens);
	        const contractTokensCount = tokenIds.length;
	        tokenCount += contractTokensCount;
	        const contractText = `${contract.name} (${contract.type}: ${contract.address})`;
	        const tokenText = tokenIds.join(", ");
	        tokenMessages.push(`contract: ${contractText}\ntoken id${contractTokensCount > 1 ? "s" : ""}: ${tokenText}`);
	      }
	      break
	    }
	    default:
	      throw new Error("Unknown redemption type")
	  }

	  tokenMessages.unshift(`
Redeem ${tokenCount} token${tokenCount > 1 ? "s" : ""} for ${selectedItem?.name ?? selectedOffer.name} [${selectedOffer.id + (selectedItem ? `|${selectedItem.id}` : "")}]
signed: ${now.toDateString()} ${now.toTimeString()}`);

	  return strToHex(tokenMessages.join("\n---\n"))
	}

	// $app/environment is not supported in static exports from `sveltekit package`, so declare these manually to their sveltekit runtime values

	// eslint-disable-next-line no-undef
	const dev = false;

	/**
	 * @template ValueType
	 * @param {?Storage} storage
	 * @param {string} key
	 * @param {ValueType} initialValue
	 * @returns
	 */
	function getStore(storage, key, initialValue) {
	  if (!storage) {
	    return writable(initialValue)
	  }
	  const storedValue = storage.getItem(key);
	  if (storedValue) {
	    initialValue = JSON.parse(storedValue);
	  }

	  const { subscribe, set } = writable(initialValue);

	  return {
	    subscribe,
	    /** @param {ValueType} value */
	    set(value) {
	      storage.setItem(key, JSON.stringify(value));
	      set(value);
	    },
	  }
	}

	/**
	 * Store for value from `localStorage`
	 * @template ValueType - The type of localStorage value.  Must be JSON-able
	 * @param {string} key
	 * @param {ValueType} initialValue
	 */
	function localStore(key, initialValue) {
	  return getStore(window?.localStorage , key, initialValue)
	}

	var eventemitter3 = {exports: {}};

	(function (module) {

		var has = Object.prototype.hasOwnProperty
		  , prefix = '~';

		/**
		 * Constructor to create a storage for our `EE` objects.
		 * An `Events` instance is a plain object whose properties are event names.
		 *
		 * @constructor
		 * @private
		 */
		function Events() {}

		//
		// We try to not inherit from `Object.prototype`. In some engines creating an
		// instance in this way is faster than calling `Object.create(null)` directly.
		// If `Object.create(null)` is not supported we prefix the event names with a
		// character to make sure that the built-in object properties are not
		// overridden or used as an attack vector.
		//
		if (Object.create) {
		  Events.prototype = Object.create(null);

		  //
		  // This hack is needed because the `__proto__` property is still inherited in
		  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
		  //
		  if (!new Events().__proto__) prefix = false;
		}

		/**
		 * Representation of a single event listener.
		 *
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
		 * @constructor
		 * @private
		 */
		function EE(fn, context, once) {
		  this.fn = fn;
		  this.context = context;
		  this.once = once || false;
		}

		/**
		 * Add a listener for a given event.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} once Specify if the listener is a one-time listener.
		 * @returns {EventEmitter}
		 * @private
		 */
		function addListener(emitter, event, fn, context, once) {
		  if (typeof fn !== 'function') {
		    throw new TypeError('The listener must be a function');
		  }

		  var listener = new EE(fn, context || emitter, once)
		    , evt = prefix ? prefix + event : event;

		  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
		  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
		  else emitter._events[evt] = [emitter._events[evt], listener];

		  return emitter;
		}

		/**
		 * Clear event by name.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} evt The Event name.
		 * @private
		 */
		function clearEvent(emitter, evt) {
		  if (--emitter._eventsCount === 0) emitter._events = new Events();
		  else delete emitter._events[evt];
		}

		/**
		 * Minimal `EventEmitter` interface that is molded against the Node.js
		 * `EventEmitter` interface.
		 *
		 * @constructor
		 * @public
		 */
		function EventEmitter() {
		  this._events = new Events();
		  this._eventsCount = 0;
		}

		/**
		 * Return an array listing the events for which the emitter has registered
		 * listeners.
		 *
		 * @returns {Array}
		 * @public
		 */
		EventEmitter.prototype.eventNames = function eventNames() {
		  var names = []
		    , events
		    , name;

		  if (this._eventsCount === 0) return names;

		  for (name in (events = this._events)) {
		    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
		  }

		  if (Object.getOwnPropertySymbols) {
		    return names.concat(Object.getOwnPropertySymbols(events));
		  }

		  return names;
		};

		/**
		 * Return the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Array} The registered listeners.
		 * @public
		 */
		EventEmitter.prototype.listeners = function listeners(event) {
		  var evt = prefix ? prefix + event : event
		    , handlers = this._events[evt];

		  if (!handlers) return [];
		  if (handlers.fn) return [handlers.fn];

		  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
		    ee[i] = handlers[i].fn;
		  }

		  return ee;
		};

		/**
		 * Return the number of listeners listening to a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Number} The number of listeners.
		 * @public
		 */
		EventEmitter.prototype.listenerCount = function listenerCount(event) {
		  var evt = prefix ? prefix + event : event
		    , listeners = this._events[evt];

		  if (!listeners) return 0;
		  if (listeners.fn) return 1;
		  return listeners.length;
		};

		/**
		 * Calls each of the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Boolean} `true` if the event had listeners, else `false`.
		 * @public
		 */
		EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
		  var evt = prefix ? prefix + event : event;

		  if (!this._events[evt]) return false;

		  var listeners = this._events[evt]
		    , len = arguments.length
		    , args
		    , i;

		  if (listeners.fn) {
		    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

		    switch (len) {
		      case 1: return listeners.fn.call(listeners.context), true;
		      case 2: return listeners.fn.call(listeners.context, a1), true;
		      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
		      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
		      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
		      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
		    }

		    for (i = 1, args = new Array(len -1); i < len; i++) {
		      args[i - 1] = arguments[i];
		    }

		    listeners.fn.apply(listeners.context, args);
		  } else {
		    var length = listeners.length
		      , j;

		    for (i = 0; i < length; i++) {
		      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

		      switch (len) {
		        case 1: listeners[i].fn.call(listeners[i].context); break;
		        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
		        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
		        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
		        default:
		          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
		            args[j - 1] = arguments[j];
		          }

		          listeners[i].fn.apply(listeners[i].context, args);
		      }
		    }
		  }

		  return true;
		};

		/**
		 * Add a listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.on = function on(event, fn, context) {
		  return addListener(this, event, fn, context, false);
		};

		/**
		 * Add a one-time listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.once = function once(event, fn, context) {
		  return addListener(this, event, fn, context, true);
		};

		/**
		 * Remove the listeners of a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn Only remove the listeners that match this function.
		 * @param {*} context Only remove the listeners that have this context.
		 * @param {Boolean} once Only remove one-time listeners.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
		  var evt = prefix ? prefix + event : event;

		  if (!this._events[evt]) return this;
		  if (!fn) {
		    clearEvent(this, evt);
		    return this;
		  }

		  var listeners = this._events[evt];

		  if (listeners.fn) {
		    if (
		      listeners.fn === fn &&
		      (!once || listeners.once) &&
		      (!context || listeners.context === context)
		    ) {
		      clearEvent(this, evt);
		    }
		  } else {
		    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
		      if (
		        listeners[i].fn !== fn ||
		        (once && !listeners[i].once) ||
		        (context && listeners[i].context !== context)
		      ) {
		        events.push(listeners[i]);
		      }
		    }

		    //
		    // Reset the array, or remove it completely if we have no more listeners.
		    //
		    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
		    else clearEvent(this, evt);
		  }

		  return this;
		};

		/**
		 * Remove all listeners, or those of the specified event.
		 *
		 * @param {(String|Symbol)} [event] The event name.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
		  var evt;

		  if (event) {
		    evt = prefix ? prefix + event : event;
		    if (this._events[evt]) clearEvent(this, evt);
		  } else {
		    this._events = new Events();
		    this._eventsCount = 0;
		  }

		  return this;
		};

		//
		// Alias methods names because people roll like that.
		//
		EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
		EventEmitter.prototype.addListener = EventEmitter.prototype.on;

		//
		// Expose the prefix.
		//
		EventEmitter.prefixed = prefix;

		//
		// Allow `EventEmitter` to be imported as module namespace.
		//
		EventEmitter.EventEmitter = EventEmitter;

		//
		// Expose the module.
		//
		{
		  module.exports = EventEmitter;
		} 
	} (eventemitter3));

	var eventemitter3Exports = eventemitter3.exports;
	var EventEmitter$1 = /*@__PURE__*/getDefaultExportFromCjs(eventemitter3Exports);

	// src/arbitrum.ts

	// src/goerli.ts
	var goerli$1 = {
	  id: 5,
	  network: "goerli",
	  name: "Goerli",
	  nativeCurrency: { name: "Goerli Ether", symbol: "ETH", decimals: 18 },
	  rpcUrls: {
	    alchemy: {
	      http: ["https://eth-goerli.g.alchemy.com/v2"],
	      webSocket: ["wss://eth-goerli.g.alchemy.com/v2"]
	    },
	    infura: {
	      http: ["https://goerli.infura.io/v3"],
	      webSocket: ["wss://goerli.infura.io/ws/v3"]
	    },
	    default: {
	      http: ["https://rpc.ankr.com/eth_goerli"]
	    },
	    public: {
	      http: ["https://rpc.ankr.com/eth_goerli"]
	    }
	  },
	  blockExplorers: {
	    etherscan: {
	      name: "Etherscan",
	      url: "https://goerli.etherscan.io"
	    },
	    default: {
	      name: "Etherscan",
	      url: "https://goerli.etherscan.io"
	    }
	  },
	  contracts: {
	    ensRegistry: {
	      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
	    },
	    ensUniversalResolver: {
	      address: "0x56522D00C410a43BFfDF00a9A569489297385790",
	      blockCreated: 8765204
	    },
	    multicall3: {
	      address: "0xca11bde05977b3631167028862be2a173976ca11",
	      blockCreated: 6507670
	    }
	  },
	  testnet: true
	};

	// src/mainnet.ts
	var mainnet$1 = {
	  id: 1,
	  network: "homestead",
	  name: "Ethereum",
	  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
	  rpcUrls: {
	    alchemy: {
	      http: ["https://eth-mainnet.g.alchemy.com/v2"],
	      webSocket: ["wss://eth-mainnet.g.alchemy.com/v2"]
	    },
	    infura: {
	      http: ["https://mainnet.infura.io/v3"],
	      webSocket: ["wss://mainnet.infura.io/ws/v3"]
	    },
	    default: {
	      http: ["https://cloudflare-eth.com"]
	    },
	    public: {
	      http: ["https://cloudflare-eth.com"]
	    }
	  },
	  blockExplorers: {
	    etherscan: {
	      name: "Etherscan",
	      url: "https://etherscan.io"
	    },
	    default: {
	      name: "Etherscan",
	      url: "https://etherscan.io"
	    }
	  },
	  contracts: {
	    ensRegistry: {
	      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
	    },
	    ensUniversalResolver: {
	      address: "0xc0497E381f536Be9ce14B0dD3817cBcAe57d2F62",
	      blockCreated: 16966585
	    },
	    multicall3: {
	      address: "0xca11bde05977b3631167028862be2a173976ca11",
	      blockCreated: 14353601
	    }
	  }
	};

	const version$9 = '1.5.3';

	const getContractAddress = (address) => address;
	const getUrl = (url) => url;
	const getVersion = () => `viem@${version$9}`;

	class BaseError extends Error {
	    constructor(shortMessage, args = {}) {
	        super();
	        Object.defineProperty(this, "details", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "docsPath", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "metaMessages", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "shortMessage", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ViemError'
	        });
	        Object.defineProperty(this, "version", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: getVersion()
	        });
	        const details = args.cause instanceof BaseError
	            ? args.cause.details
	            : args.cause?.message
	                ? args.cause.message
	                : args.details;
	        const docsPath = args.cause instanceof BaseError
	            ? args.cause.docsPath || args.docsPath
	            : args.docsPath;
	        this.message = [
	            shortMessage || 'An error occurred.',
	            '',
	            ...(args.metaMessages ? [...args.metaMessages, ''] : []),
	            ...(docsPath
	                ? [
	                    `Docs: https://viem.sh${docsPath}.html${args.docsSlug ? `#${args.docsSlug}` : ''}`,
	                ]
	                : []),
	            ...(details ? [`Details: ${details}`] : []),
	            `Version: ${this.version}`,
	        ].join('\n');
	        if (args.cause)
	            this.cause = args.cause;
	        this.details = details;
	        this.docsPath = docsPath;
	        this.metaMessages = args.metaMessages;
	        this.shortMessage = shortMessage;
	    }
	    walk(fn) {
	        return walk(this, fn);
	    }
	}
	function walk(err, fn) {
	    if (fn?.(err))
	        return err;
	    if (err && typeof err === 'object' && 'cause' in err)
	        return walk(err.cause, fn);
	    return fn ? null : err;
	}

	class ChainDoesNotSupportContract extends BaseError {
	    constructor({ blockNumber, chain, contract, }) {
	        super(`Chain "${chain.name}" does not support contract "${contract.name}".`, {
	            metaMessages: [
	                'This could be due to any of the following:',
	                ...(blockNumber &&
	                    contract.blockCreated &&
	                    contract.blockCreated > blockNumber
	                    ? [
	                        `- The contract "${contract.name}" was not deployed until block ${contract.blockCreated} (current block ${blockNumber}).`,
	                    ]
	                    : [
	                        `- The chain does not have the contract "${contract.name}" configured.`,
	                    ]),
	            ],
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ChainDoesNotSupportContract'
	        });
	    }
	}
	class ChainMismatchError extends BaseError {
	    constructor({ chain, currentChainId, }) {
	        super(`The current chain of the wallet (id: ${currentChainId}) does not match the target chain for the transaction (id: ${chain.id} – ${chain.name}).`, {
	            metaMessages: [
	                `Current Chain ID:  ${currentChainId}`,
	                `Expected Chain ID: ${chain.id} – ${chain.name}`,
	            ],
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ChainMismatchError'
	        });
	    }
	}
	class ChainNotFoundError extends BaseError {
	    constructor() {
	        super([
	            'No chain was provided to the request.',
	            'Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient.',
	        ].join('\n'));
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ChainNotFoundError'
	        });
	    }
	}
	class ClientChainNotConfiguredError extends BaseError {
	    constructor() {
	        super('No chain was provided to the Client.');
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ClientChainNotConfiguredError'
	        });
	    }
	}

	function assertCurrentChain({ chain, currentChainId, }) {
	    if (!chain)
	        throw new ChainNotFoundError();
	    if (currentChainId !== chain.id)
	        throw new ChainMismatchError({ chain, currentChainId });
	}
	function defineChain(chain, config) {
	    return {
	        ...chain,
	        formatters: config?.formatters,
	        serializers: config?.serializers,
	    };
	}
	function getChainContractAddress({ blockNumber, chain, contract: name, }) {
	    const contract = chain?.contracts?.[name];
	    if (!contract)
	        throw new ChainDoesNotSupportContract({
	            chain,
	            contract: { name },
	        });
	    if (blockNumber &&
	        contract.blockCreated &&
	        contract.blockCreated > blockNumber)
	        throw new ChainDoesNotSupportContract({
	            blockNumber,
	            chain,
	            contract: {
	                name,
	                blockCreated: contract.blockCreated,
	            },
	        });
	    return contract.address;
	}

	class IntegerOutOfRangeError extends BaseError {
	    constructor({ max, min, signed, size, value, }) {
	        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? 'signed' : 'unsigned'} ` : ''}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'IntegerOutOfRangeError'
	        });
	    }
	}
	class InvalidHexBooleanError extends BaseError {
	    constructor(hex) {
	        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'InvalidHexBooleanError'
	        });
	    }
	}
	class SizeOverflowError extends BaseError {
	    constructor({ givenSize, maxSize }) {
	        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'SizeOverflowError'
	        });
	    }
	}

	function isHex(value, { strict = true } = {}) {
	    if (!value)
	        return false;
	    if (typeof value !== 'string')
	        return false;
	    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith('0x');
	}

	/**
	 * @description Retrieves the size of the value (in bytes).
	 *
	 * @param value The value (hex or byte array) to retrieve the size of.
	 * @returns The size of the value (in bytes).
	 */
	function size$2(value) {
	    if (isHex(value, { strict: false }))
	        return Math.ceil((value.length - 2) / 2);
	    return value.length;
	}

	function trim(hexOrBytes, { dir = 'left' } = {}) {
	    let data = typeof hexOrBytes === 'string' ? hexOrBytes.replace('0x', '') : hexOrBytes;
	    let sliceLength = 0;
	    for (let i = 0; i < data.length - 1; i++) {
	        if (data[dir === 'left' ? i : data.length - i - 1].toString() === '0')
	            sliceLength++;
	        else
	            break;
	    }
	    data =
	        dir === 'left'
	            ? data.slice(sliceLength)
	            : data.slice(0, data.length - sliceLength);
	    if (typeof hexOrBytes === 'string') {
	        if (data.length === 1 && dir === 'right')
	            data = `${data}0`;
	        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
	    }
	    return data;
	}

	class SliceOffsetOutOfBoundsError extends BaseError {
	    constructor({ offset, position, size, }) {
	        super(`Slice ${position === 'start' ? 'starting' : 'ending'} at offset "${offset}" is out-of-bounds (size: ${size}).`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'SliceOffsetOutOfBoundsError'
	        });
	    }
	}
	class SizeExceedsPaddingSizeError extends BaseError {
	    constructor({ size, targetSize, type, }) {
	        super(`${type.charAt(0).toUpperCase()}${type
            .slice(1)
            .toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'SizeExceedsPaddingSizeError'
	        });
	    }
	}

	function pad(hexOrBytes, { dir, size = 32 } = {}) {
	    if (typeof hexOrBytes === 'string')
	        return padHex(hexOrBytes, { dir, size });
	    return padBytes(hexOrBytes, { dir, size });
	}
	function padHex(hex_, { dir, size = 32 } = {}) {
	    if (size === null)
	        return hex_;
	    const hex = hex_.replace('0x', '');
	    if (hex.length > size * 2)
	        throw new SizeExceedsPaddingSizeError({
	            size: Math.ceil(hex.length / 2),
	            targetSize: size,
	            type: 'hex',
	        });
	    return `0x${hex[dir === 'right' ? 'padEnd' : 'padStart'](size * 2, '0')}`;
	}
	function padBytes(bytes, { dir, size = 32 } = {}) {
	    if (size === null)
	        return bytes;
	    if (bytes.length > size)
	        throw new SizeExceedsPaddingSizeError({
	            size: bytes.length,
	            targetSize: size,
	            type: 'bytes',
	        });
	    const paddedBytes = new Uint8Array(size);
	    for (let i = 0; i < size; i++) {
	        const padEnd = dir === 'right';
	        paddedBytes[padEnd ? i : size - i - 1] =
	            bytes[padEnd ? i : bytes.length - i - 1];
	    }
	    return paddedBytes;
	}

	const hexes$1 = /*#__PURE__*/ Array.from({ length: 256 }, (_v, i) => i.toString(16).padStart(2, '0'));
	/**
	 * Encodes a string, number, bigint, or ByteArray into a hex string
	 *
	 * - Docs: https://viem.sh/docs/utilities/toHex.html
	 * - Example: https://viem.sh/docs/utilities/toHex.html#usage
	 *
	 * @param value Value to encode.
	 * @param opts Options.
	 * @returns Hex value.
	 *
	 * @example
	 * import { toHex } from 'viem'
	 * const data = toHex('Hello world')
	 * // '0x48656c6c6f20776f726c6421'
	 *
	 * @example
	 * import { toHex } from 'viem'
	 * const data = toHex(420)
	 * // '0x1a4'
	 *
	 * @example
	 * import { toHex } from 'viem'
	 * const data = toHex('Hello world', { size: 32 })
	 * // '0x48656c6c6f20776f726c64210000000000000000000000000000000000000000'
	 */
	function toHex$1(value, opts = {}) {
	    if (typeof value === 'number' || typeof value === 'bigint')
	        return numberToHex$1(value, opts);
	    if (typeof value === 'string') {
	        return stringToHex(value, opts);
	    }
	    if (typeof value === 'boolean')
	        return boolToHex(value, opts);
	    return bytesToHex$2(value, opts);
	}
	/**
	 * Encodes a boolean into a hex string
	 *
	 * - Docs: https://viem.sh/docs/utilities/toHex.html#booltohex
	 *
	 * @param value Value to encode.
	 * @param opts Options.
	 * @returns Hex value.
	 *
	 * @example
	 * import { boolToHex } from 'viem'
	 * const data = boolToHex(true)
	 * // '0x1'
	 *
	 * @example
	 * import { boolToHex } from 'viem'
	 * const data = boolToHex(false)
	 * // '0x0'
	 *
	 * @example
	 * import { boolToHex } from 'viem'
	 * const data = boolToHex(true, { size: 32 })
	 * // '0x0000000000000000000000000000000000000000000000000000000000000001'
	 */
	function boolToHex(value, opts = {}) {
	    const hex = `0x${Number(value)}`;
	    if (typeof opts.size === 'number') {
	        assertSize(hex, { size: opts.size });
	        return pad(hex, { size: opts.size });
	    }
	    return hex;
	}
	/**
	 * Encodes a bytes array into a hex string
	 *
	 * - Docs: https://viem.sh/docs/utilities/toHex.html#bytestohex
	 *
	 * @param value Value to encode.
	 * @param opts Options.
	 * @returns Hex value.
	 *
	 * @example
	 * import { bytesToHex } from 'viem'
	 * const data = bytesToHex(Uint8Array.from([72, 101, 108, 108, 111, 32, 87, 111, 114, 108, 100, 33])
	 * // '0x48656c6c6f20576f726c6421'
	 *
	 * @example
	 * import { bytesToHex } from 'viem'
	 * const data = bytesToHex(Uint8Array.from([72, 101, 108, 108, 111, 32, 87, 111, 114, 108, 100, 33]), { size: 32 })
	 * // '0x48656c6c6f20576f726c64210000000000000000000000000000000000000000'
	 */
	function bytesToHex$2(value, opts = {}) {
	    let hexString = '';
	    for (let i = 0; i < value.length; i++) {
	        hexString += hexes$1[value[i]];
	    }
	    const hex = `0x${hexString}`;
	    if (typeof opts.size === 'number') {
	        assertSize(hex, { size: opts.size });
	        return pad(hex, { dir: 'right', size: opts.size });
	    }
	    return hex;
	}
	/**
	 * Encodes a number or bigint into a hex string
	 *
	 * - Docs: https://viem.sh/docs/utilities/toHex.html#numbertohex
	 *
	 * @param value Value to encode.
	 * @param opts Options.
	 * @returns Hex value.
	 *
	 * @example
	 * import { numberToHex } from 'viem'
	 * const data = numberToHex(420)
	 * // '0x1a4'
	 *
	 * @example
	 * import { numberToHex } from 'viem'
	 * const data = numberToHex(420, { size: 32 })
	 * // '0x00000000000000000000000000000000000000000000000000000000000001a4'
	 */
	function numberToHex$1(value_, opts = {}) {
	    const { signed, size } = opts;
	    const value = BigInt(value_);
	    let maxValue;
	    if (size) {
	        if (signed)
	            maxValue = (1n << (BigInt(size) * 8n - 1n)) - 1n;
	        else
	            maxValue = 2n ** (BigInt(size) * 8n) - 1n;
	    }
	    else if (typeof value_ === 'number') {
	        maxValue = BigInt(Number.MAX_SAFE_INTEGER);
	    }
	    const minValue = typeof maxValue === 'bigint' && signed ? -maxValue - 1n : 0;
	    if ((maxValue && value > maxValue) || value < minValue) {
	        const suffix = typeof value_ === 'bigint' ? 'n' : '';
	        throw new IntegerOutOfRangeError({
	            max: maxValue ? `${maxValue}${suffix}` : undefined,
	            min: `${minValue}${suffix}`,
	            signed,
	            size,
	            value: `${value_}${suffix}`,
	        });
	    }
	    const hex = `0x${(signed && value < 0
        ? (1n << BigInt(size * 8)) + BigInt(value)
        : value).toString(16)}`;
	    if (size)
	        return pad(hex, { size });
	    return hex;
	}
	const encoder$1 = /*#__PURE__*/ new TextEncoder();
	/**
	 * Encodes a UTF-8 string into a hex string
	 *
	 * - Docs: https://viem.sh/docs/utilities/toHex.html#stringtohex
	 *
	 * @param value Value to encode.
	 * @param opts Options.
	 * @returns Hex value.
	 *
	 * @example
	 * import { stringToHex } from 'viem'
	 * const data = stringToHex('Hello World!')
	 * // '0x48656c6c6f20576f726c6421'
	 *
	 * @example
	 * import { stringToHex } from 'viem'
	 * const data = stringToHex('Hello World!', { size: 32 })
	 * // '0x48656c6c6f20576f726c64210000000000000000000000000000000000000000'
	 */
	function stringToHex(value_, opts = {}) {
	    const value = encoder$1.encode(value_);
	    return bytesToHex$2(value, opts);
	}

	const encoder = /*#__PURE__*/ new TextEncoder();
	/**
	 * Encodes a UTF-8 string, hex value, bigint, number or boolean to a byte array.
	 *
	 * - Docs: https://viem.sh/docs/utilities/toBytes.html
	 * - Example: https://viem.sh/docs/utilities/toBytes.html#usage
	 *
	 * @param value Value to encode.
	 * @param opts Options.
	 * @returns Byte array value.
	 *
	 * @example
	 * import { toBytes } from 'viem'
	 * const data = toBytes('Hello world')
	 * // Uint8Array([72, 101, 108, 108, 111, 32, 87, 111, 114, 108, 100, 33])
	 *
	 * @example
	 * import { toBytes } from 'viem'
	 * const data = toBytes(420)
	 * // Uint8Array([1, 164])
	 *
	 * @example
	 * import { toBytes } from 'viem'
	 * const data = toBytes(420, { size: 4 })
	 * // Uint8Array([0, 0, 1, 164])
	 */
	function toBytes$1(value, opts = {}) {
	    if (typeof value === 'number' || typeof value === 'bigint')
	        return numberToBytes$1(value, opts);
	    if (typeof value === 'boolean')
	        return boolToBytes(value, opts);
	    if (isHex(value))
	        return hexToBytes$2(value, opts);
	    return stringToBytes$1(value, opts);
	}
	/**
	 * Encodes a boolean into a byte array.
	 *
	 * - Docs: https://viem.sh/docs/utilities/toBytes.html#booltobytes
	 *
	 * @param value Boolean value to encode.
	 * @param opts Options.
	 * @returns Byte array value.
	 *
	 * @example
	 * import { boolToBytes } from 'viem'
	 * const data = boolToBytes(true)
	 * // Uint8Array([1])
	 *
	 * @example
	 * import { boolToBytes } from 'viem'
	 * const data = boolToBytes(true, { size: 32 })
	 * // Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1])
	 */
	function boolToBytes(value, opts = {}) {
	    const bytes = new Uint8Array(1);
	    bytes[0] = Number(value);
	    if (typeof opts.size === 'number') {
	        assertSize(bytes, { size: opts.size });
	        return pad(bytes, { size: opts.size });
	    }
	    return bytes;
	}
	/**
	 * Encodes a hex string into a byte array.
	 *
	 * - Docs: https://viem.sh/docs/utilities/toBytes.html#hextobytes
	 *
	 * @param hex Hex string to encode.
	 * @param opts Options.
	 * @returns Byte array value.
	 *
	 * @example
	 * import { hexToBytes } from 'viem'
	 * const data = hexToBytes('0x48656c6c6f20776f726c6421')
	 * // Uint8Array([72, 101, 108, 108, 111, 32, 87, 111, 114, 108, 100, 33])
	 *
	 * @example
	 * import { hexToBytes } from 'viem'
	 * const data = hexToBytes('0x48656c6c6f20776f726c6421', { size: 32 })
	 * // Uint8Array([72, 101, 108, 108, 111, 32, 87, 111, 114, 108, 100, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
	 */
	function hexToBytes$2(hex_, opts = {}) {
	    let hex = hex_;
	    if (opts.size) {
	        assertSize(hex, { size: opts.size });
	        hex = pad(hex, { dir: 'right', size: opts.size });
	    }
	    let hexString = hex.slice(2);
	    if (hexString.length % 2)
	        hexString = `0${hexString}`;
	    const bytes = new Uint8Array(hexString.length / 2);
	    for (let index = 0; index < bytes.length; index++) {
	        const start = index * 2;
	        const hexByte = hexString.slice(start, start + 2);
	        const byte = Number.parseInt(hexByte, 16);
	        if (Number.isNaN(byte) || byte < 0)
	            throw new BaseError(`Invalid byte sequence ("${hexByte}" in "${hexString}").`);
	        bytes[index] = byte;
	    }
	    return bytes;
	}
	/**
	 * Encodes a number into a byte array.
	 *
	 * - Docs: https://viem.sh/docs/utilities/toBytes.html#numbertobytes
	 *
	 * @param value Number to encode.
	 * @param opts Options.
	 * @returns Byte array value.
	 *
	 * @example
	 * import { numberToBytes } from 'viem'
	 * const data = numberToBytes(420)
	 * // Uint8Array([1, 164])
	 *
	 * @example
	 * import { numberToBytes } from 'viem'
	 * const data = numberToBytes(420, { size: 4 })
	 * // Uint8Array([0, 0, 1, 164])
	 */
	function numberToBytes$1(value, opts) {
	    const hex = numberToHex$1(value, opts);
	    return hexToBytes$2(hex);
	}
	/**
	 * Encodes a UTF-8 string into a byte array.
	 *
	 * - Docs: https://viem.sh/docs/utilities/toBytes.html#stringtobytes
	 *
	 * @param value String to encode.
	 * @param opts Options.
	 * @returns Byte array value.
	 *
	 * @example
	 * import { stringToBytes } from 'viem'
	 * const data = stringToBytes('Hello world!')
	 * // Uint8Array([72, 101, 108, 108, 111, 32, 119, 111, 114, 108, 100, 33])
	 *
	 * @example
	 * import { stringToBytes } from 'viem'
	 * const data = stringToBytes('Hello world!', { size: 32 })
	 * // Uint8Array([72, 101, 108, 108, 111, 32, 87, 111, 114, 108, 100, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
	 */
	function stringToBytes$1(value, opts = {}) {
	    const bytes = encoder.encode(value);
	    if (typeof opts.size === 'number') {
	        assertSize(bytes, { size: opts.size });
	        return pad(bytes, { dir: 'right', size: opts.size });
	    }
	    return bytes;
	}

	function assertSize(hexOrBytes, { size }) {
	    if (size$2(hexOrBytes) > size)
	        throw new SizeOverflowError({
	            givenSize: size$2(hexOrBytes),
	            maxSize: size,
	        });
	}
	/**
	 * Decodes a hex value into a bigint.
	 *
	 * - Docs: https://viem.sh/docs/utilities/fromHex.html#hextobigint
	 *
	 * @param hex Hex value to decode.
	 * @param opts Options.
	 * @returns BigInt value.
	 *
	 * @example
	 * import { hexToBigInt } from 'viem'
	 * const data = hexToBigInt('0x1a4', { signed: true })
	 * // 420n
	 *
	 * @example
	 * import { hexToBigInt } from 'viem'
	 * const data = hexToBigInt('0x00000000000000000000000000000000000000000000000000000000000001a4', { size: 32 })
	 * // 420n
	 */
	function hexToBigInt$1(hex, opts = {}) {
	    const { signed } = opts;
	    if (opts.size)
	        assertSize(hex, { size: opts.size });
	    const value = BigInt(hex);
	    if (!signed)
	        return value;
	    const size = (hex.length - 2) / 2;
	    const max = (1n << (BigInt(size) * 8n - 1n)) - 1n;
	    if (value <= max)
	        return value;
	    return value - BigInt(`0x${'f'.padStart(size * 2, 'f')}`) - 1n;
	}
	/**
	 * Decodes a hex value into a boolean.
	 *
	 * - Docs: https://viem.sh/docs/utilities/fromHex.html#hextobool
	 *
	 * @param hex Hex value to decode.
	 * @param opts Options.
	 * @returns Boolean value.
	 *
	 * @example
	 * import { hexToBool } from 'viem'
	 * const data = hexToBool('0x01')
	 * // true
	 *
	 * @example
	 * import { hexToBool } from 'viem'
	 * const data = hexToBool('0x0000000000000000000000000000000000000000000000000000000000000001', { size: 32 })
	 * // true
	 */
	function hexToBool(hex_, opts = {}) {
	    let hex = hex_;
	    if (opts.size) {
	        assertSize(hex, { size: opts.size });
	        hex = trim(hex);
	    }
	    if (trim(hex) === '0x00')
	        return false;
	    if (trim(hex) === '0x01')
	        return true;
	    throw new InvalidHexBooleanError(hex);
	}
	/**
	 * Decodes a hex string into a number.
	 *
	 * - Docs: https://viem.sh/docs/utilities/fromHex.html#hextonumber
	 *
	 * @param hex Hex value to decode.
	 * @param opts Options.
	 * @returns Number value.
	 *
	 * @example
	 * import { hexToNumber } from 'viem'
	 * const data = hexToNumber('0x1a4')
	 * // 420
	 *
	 * @example
	 * import { hexToNumber } from 'viem'
	 * const data = hexToBigInt('0x00000000000000000000000000000000000000000000000000000000000001a4', { size: 32 })
	 * // 420
	 */
	function hexToNumber$2(hex, opts = {}) {
	    return Number(hexToBigInt$1(hex, opts));
	}
	/**
	 * Decodes a hex value into a UTF-8 string.
	 *
	 * - Docs: https://viem.sh/docs/utilities/fromHex.html#hextostring
	 *
	 * @param hex Hex value to decode.
	 * @param opts Options.
	 * @returns String value.
	 *
	 * @example
	 * import { hexToString } from 'viem'
	 * const data = hexToString('0x48656c6c6f20576f726c6421')
	 * // 'Hello world!'
	 *
	 * @example
	 * import { hexToString } from 'viem'
	 * const data = hexToString('0x48656c6c6f20576f726c64210000000000000000000000000000000000000000', {
	 *  size: 32,
	 * })
	 * // 'Hello world'
	 */
	function hexToString(hex, opts = {}) {
	    let bytes = hexToBytes$2(hex);
	    if (opts.size) {
	        assertSize(bytes, { size: opts.size });
	        bytes = trim(bytes, { dir: 'right' });
	    }
	    return new TextDecoder().decode(bytes);
	}

	const transactionType = {
	    '0x0': 'legacy',
	    '0x1': 'eip2930',
	    '0x2': 'eip1559',
	};
	function formatTransaction(transaction) {
	    const transaction_ = {
	        ...transaction,
	        blockHash: transaction.blockHash ? transaction.blockHash : null,
	        blockNumber: transaction.blockNumber
	            ? BigInt(transaction.blockNumber)
	            : null,
	        chainId: transaction.chainId ? hexToNumber$2(transaction.chainId) : undefined,
	        gas: transaction.gas ? BigInt(transaction.gas) : undefined,
	        gasPrice: transaction.gasPrice ? BigInt(transaction.gasPrice) : undefined,
	        maxFeePerGas: transaction.maxFeePerGas
	            ? BigInt(transaction.maxFeePerGas)
	            : undefined,
	        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas
	            ? BigInt(transaction.maxPriorityFeePerGas)
	            : undefined,
	        nonce: transaction.nonce ? hexToNumber$2(transaction.nonce) : undefined,
	        to: transaction.to ? transaction.to : null,
	        transactionIndex: transaction.transactionIndex
	            ? Number(transaction.transactionIndex)
	            : null,
	        type: transaction.type ? transactionType[transaction.type] : undefined,
	        typeHex: transaction.type ? transaction.type : undefined,
	        value: transaction.value ? BigInt(transaction.value) : undefined,
	        v: transaction.v ? BigInt(transaction.v) : undefined,
	    };
	    if (transaction_.type === 'legacy') {
	        delete transaction_['accessList'];
	        delete transaction_['maxFeePerGas'];
	        delete transaction_['maxPriorityFeePerGas'];
	    }
	    if (transaction_.type === 'eip2930') {
	        delete transaction_['maxFeePerGas'];
	        delete transaction_['maxPriorityFeePerGas'];
	    }
	    return transaction_;
	}

	function formatBlock(block) {
	    const transactions = block.transactions?.map((transaction) => {
	        if (typeof transaction === 'string')
	            return transaction;
	        return formatTransaction(transaction);
	    });
	    return {
	        ...block,
	        baseFeePerGas: block.baseFeePerGas ? BigInt(block.baseFeePerGas) : null,
	        difficulty: block.difficulty ? BigInt(block.difficulty) : undefined,
	        gasLimit: block.gasLimit ? BigInt(block.gasLimit) : undefined,
	        gasUsed: block.gasUsed ? BigInt(block.gasUsed) : undefined,
	        hash: block.hash ? block.hash : null,
	        logsBloom: block.logsBloom ? block.logsBloom : null,
	        nonce: block.nonce ? block.nonce : null,
	        number: block.number ? BigInt(block.number) : null,
	        size: block.size ? BigInt(block.size) : undefined,
	        timestamp: block.timestamp ? BigInt(block.timestamp) : undefined,
	        transactions,
	        totalDifficulty: block.totalDifficulty
	            ? BigInt(block.totalDifficulty)
	            : null,
	    };
	}

	function formatLog(log, { args, eventName } = {}) {
	    return {
	        ...log,
	        blockHash: log.blockHash ? log.blockHash : null,
	        blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
	        logIndex: log.logIndex ? Number(log.logIndex) : null,
	        transactionHash: log.transactionHash ? log.transactionHash : null,
	        transactionIndex: log.transactionIndex
	            ? Number(log.transactionIndex)
	            : null,
	        ...(eventName ? { args, eventName } : {}),
	    };
	}

	const statuses = {
	    '0x0': 'reverted',
	    '0x1': 'success',
	};
	function formatTransactionReceipt(transactionReceipt) {
	    return {
	        ...transactionReceipt,
	        blockNumber: transactionReceipt.blockNumber
	            ? BigInt(transactionReceipt.blockNumber)
	            : null,
	        contractAddress: transactionReceipt.contractAddress
	            ? transactionReceipt.contractAddress
	            : null,
	        cumulativeGasUsed: transactionReceipt.cumulativeGasUsed
	            ? BigInt(transactionReceipt.cumulativeGasUsed)
	            : null,
	        effectiveGasPrice: transactionReceipt.effectiveGasPrice
	            ? BigInt(transactionReceipt.effectiveGasPrice)
	            : null,
	        gasUsed: transactionReceipt.gasUsed
	            ? BigInt(transactionReceipt.gasUsed)
	            : null,
	        logs: transactionReceipt.logs
	            ? transactionReceipt.logs.map((log) => formatLog(log))
	            : null,
	        to: transactionReceipt.to ? transactionReceipt.to : null,
	        transactionIndex: transactionReceipt.transactionIndex
	            ? hexToNumber$2(transactionReceipt.transactionIndex)
	            : null,
	        status: transactionReceipt.status
	            ? statuses[transactionReceipt.status]
	            : null,
	        type: transactionReceipt.type
	            ? transactionType[transactionReceipt.type] || transactionReceipt.type
	            : null,
	    };
	}

	function formatTransactionRequest(transactionRequest) {
	    return {
	        ...transactionRequest,
	        gas: typeof transactionRequest.gas !== 'undefined'
	            ? numberToHex$1(transactionRequest.gas)
	            : undefined,
	        gasPrice: typeof transactionRequest.gasPrice !== 'undefined'
	            ? numberToHex$1(transactionRequest.gasPrice)
	            : undefined,
	        maxFeePerGas: typeof transactionRequest.maxFeePerGas !== 'undefined'
	            ? numberToHex$1(transactionRequest.maxFeePerGas)
	            : undefined,
	        maxPriorityFeePerGas: typeof transactionRequest.maxPriorityFeePerGas !== 'undefined'
	            ? numberToHex$1(transactionRequest.maxPriorityFeePerGas)
	            : undefined,
	        nonce: typeof transactionRequest.nonce !== 'undefined'
	            ? numberToHex$1(transactionRequest.nonce)
	            : undefined,
	        value: typeof transactionRequest.value !== 'undefined'
	            ? numberToHex$1(transactionRequest.value)
	            : undefined,
	    };
	}

	class InvalidAddressError extends BaseError {
	    constructor({ address }) {
	        super(`Address "${address}" is invalid.`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'InvalidAddressError'
	        });
	    }
	}

	const etherUnits = {
	    gwei: 9,
	    wei: 18,
	};
	const gweiUnits = {
	    ether: -9,
	    wei: 9,
	};

	function formatUnits(value, decimals) {
	    let display = value.toString();
	    const negative = display.startsWith('-');
	    if (negative)
	        display = display.slice(1);
	    display = display.padStart(decimals, '0');
	    let [integer, fraction] = [
	        display.slice(0, display.length - decimals),
	        display.slice(display.length - decimals),
	    ];
	    fraction = fraction.replace(/(0+)$/, '');
	    return `${negative ? '-' : ''}${integer || '0'}${fraction ? `.${fraction}` : ''}`;
	}

	function formatGwei(wei, unit = 'wei') {
	    return formatUnits(wei, gweiUnits[unit]);
	}

	/**
	 * geth:    https://github.com/ethereum/go-ethereum/blob/master/core/error.go
	 *          https://github.com/ethereum/go-ethereum/blob/master/core/types/transaction.go#L34-L41
	 *
	 * erigon:  https://github.com/ledgerwatch/erigon/blob/master/core/error.go
	 *          https://github.com/ledgerwatch/erigon/blob/master/core/types/transaction.go#L41-L46
	 *
	 * anvil:   https://github.com/foundry-rs/foundry/blob/master/anvil/src/eth/error.rs#L108
	 */
	class ExecutionRevertedError extends BaseError {
	    constructor({ cause, message, } = {}) {
	        const reason = message
	            ?.replace('execution reverted: ', '')
	            ?.replace('execution reverted', '');
	        super(`Execution reverted ${reason ? `with reason: ${reason}` : 'for an unknown reason'}.`, {
	            cause,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ExecutionRevertedError'
	        });
	    }
	}
	Object.defineProperty(ExecutionRevertedError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: 3
	});
	Object.defineProperty(ExecutionRevertedError, "nodeMessage", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: /execution reverted/
	});
	class FeeCapTooHighError extends BaseError {
	    constructor({ cause, maxFeePerGas, } = {}) {
	        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${formatGwei(maxFeePerGas)} gwei` : ''}) cannot be higher than the maximum allowed value (2^256-1).`, {
	            cause,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'FeeCapTooHigh'
	        });
	    }
	}
	Object.defineProperty(FeeCapTooHighError, "nodeMessage", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
	});
	class FeeCapTooLowError extends BaseError {
	    constructor({ cause, maxFeePerGas, } = {}) {
	        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${formatGwei(maxFeePerGas)}` : ''} gwei) cannot be lower than the block base fee.`, {
	            cause,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'FeeCapTooLow'
	        });
	    }
	}
	Object.defineProperty(FeeCapTooLowError, "nodeMessage", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
	});
	class NonceTooHighError extends BaseError {
	    constructor({ cause, nonce } = {}) {
	        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ''}is higher than the next one expected.`, { cause });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'NonceTooHighError'
	        });
	    }
	}
	Object.defineProperty(NonceTooHighError, "nodeMessage", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: /nonce too high/
	});
	class NonceTooLowError extends BaseError {
	    constructor({ cause, nonce } = {}) {
	        super([
	            `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ''}is lower than the current nonce of the account.`,
	            'Try increasing the nonce or find the latest nonce with `getTransactionCount`.',
	        ].join('\n'), { cause });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'NonceTooLowError'
	        });
	    }
	}
	Object.defineProperty(NonceTooLowError, "nodeMessage", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: /nonce too low|transaction already imported/
	});
	class NonceMaxValueError extends BaseError {
	    constructor({ cause, nonce } = {}) {
	        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ''}exceeds the maximum allowed nonce.`, { cause });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'NonceMaxValueError'
	        });
	    }
	}
	Object.defineProperty(NonceMaxValueError, "nodeMessage", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: /nonce has max value/
	});
	class InsufficientFundsError extends BaseError {
	    constructor({ cause } = {}) {
	        super([
	            'The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account.',
	        ].join('\n'), {
	            cause,
	            metaMessages: [
	                'This error could arise when the account does not have enough funds to:',
	                ' - pay for the total gas fee,',
	                ' - pay for the value to send.',
	                ' ',
	                'The cost of the transaction is calculated as `gas * gas fee + value`, where:',
	                ' - `gas` is the amount of gas needed for transaction to execute,',
	                ' - `gas fee` is the gas fee,',
	                ' - `value` is the amount of ether to send to the recipient.',
	            ],
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'InsufficientFundsError'
	        });
	    }
	}
	Object.defineProperty(InsufficientFundsError, "nodeMessage", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: /insufficient funds/
	});
	class IntrinsicGasTooHighError extends BaseError {
	    constructor({ cause, gas } = {}) {
	        super(`The amount of gas ${gas ? `(${gas}) ` : ''}provided for the transaction exceeds the limit allowed for the block.`, {
	            cause,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'IntrinsicGasTooHighError'
	        });
	    }
	}
	Object.defineProperty(IntrinsicGasTooHighError, "nodeMessage", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: /intrinsic gas too high|gas limit reached/
	});
	class IntrinsicGasTooLowError extends BaseError {
	    constructor({ cause, gas } = {}) {
	        super(`The amount of gas ${gas ? `(${gas}) ` : ''}provided for the transaction is too low.`, {
	            cause,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'IntrinsicGasTooLowError'
	        });
	    }
	}
	Object.defineProperty(IntrinsicGasTooLowError, "nodeMessage", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: /intrinsic gas too low/
	});
	class TransactionTypeNotSupportedError extends BaseError {
	    constructor({ cause }) {
	        super('The transaction type is not supported for this chain.', {
	            cause,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'TransactionTypeNotSupportedError'
	        });
	    }
	}
	Object.defineProperty(TransactionTypeNotSupportedError, "nodeMessage", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: /transaction type not valid/
	});
	class TipAboveFeeCapError extends BaseError {
	    constructor({ cause, maxPriorityFeePerGas, maxFeePerGas, } = {}) {
	        super([
	            `The provided tip (\`maxPriorityFeePerGas\`${maxPriorityFeePerGas
                ? ` = ${formatGwei(maxPriorityFeePerGas)} gwei`
                : ''}) cannot be higher than the fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${formatGwei(maxFeePerGas)} gwei` : ''}).`,
	        ].join('\n'), {
	            cause,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'TipAboveFeeCapError'
	        });
	    }
	}
	Object.defineProperty(TipAboveFeeCapError, "nodeMessage", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
	});
	class UnknownNodeError extends BaseError {
	    constructor({ cause }) {
	        super(`An error occurred while executing: ${cause?.message}`, {
	            cause,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'UnknownNodeError'
	        });
	    }
	}

	const addressRegex = /^0x[a-fA-F0-9]{40}$/;
	function isAddress(address) {
	    return addressRegex.test(address);
	}

	function concat$4(values) {
	    if (typeof values[0] === 'string')
	        return concatHex(values);
	    return concatBytes$2(values);
	}
	function concatBytes$2(values) {
	    let length = 0;
	    for (const arr of values) {
	        length += arr.length;
	    }
	    const result = new Uint8Array(length);
	    let offset = 0;
	    for (const arr of values) {
	        result.set(arr, offset);
	        offset += arr.length;
	    }
	    return result;
	}
	function concatHex(values) {
	    return `0x${values.reduce((acc, x) => acc + x.replace('0x', ''), '')}`;
	}

	function formatEther(wei, unit = 'wei') {
	    return formatUnits(wei, etherUnits[unit]);
	}

	function prettyPrint(args) {
	    const entries = Object.entries(args)
	        .map(([key, value]) => {
	        if (value === undefined || value === false)
	            return null;
	        return [key, value];
	    })
	        .filter(Boolean);
	    const maxLength = entries.reduce((acc, [key]) => Math.max(acc, key.length), 0);
	    return entries
	        .map(([key, value]) => `  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`)
	        .join('\n');
	}
	class FeeConflictError extends BaseError {
	    constructor() {
	        super([
	            'Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.',
	            'Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others.',
	        ].join('\n'));
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'FeeConflictError'
	        });
	    }
	}
	class TransactionExecutionError extends BaseError {
	    constructor(cause, { account, docsPath, chain, data, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, to, value, }) {
	        const prettyArgs = prettyPrint({
	            chain: chain && `${chain?.name} (id: ${chain?.id})`,
	            from: account?.address,
	            to,
	            value: typeof value !== 'undefined' &&
	                `${formatEther(value)} ${chain?.nativeCurrency.symbol || 'ETH'}`,
	            data,
	            gas,
	            gasPrice: typeof gasPrice !== 'undefined' && `${formatGwei(gasPrice)} gwei`,
	            maxFeePerGas: typeof maxFeePerGas !== 'undefined' &&
	                `${formatGwei(maxFeePerGas)} gwei`,
	            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== 'undefined' &&
	                `${formatGwei(maxPriorityFeePerGas)} gwei`,
	            nonce,
	        });
	        super(cause.shortMessage, {
	            cause,
	            docsPath,
	            metaMessages: [
	                ...(cause.metaMessages ? [...cause.metaMessages, ' '] : []),
	                'Request Arguments:',
	                prettyArgs,
	            ].filter(Boolean),
	        });
	        Object.defineProperty(this, "cause", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'TransactionExecutionError'
	        });
	        this.cause = cause;
	    }
	}
	class TransactionNotFoundError extends BaseError {
	    constructor({ blockHash, blockNumber, blockTag, hash, index, }) {
	        let identifier = 'Transaction';
	        if (blockTag && index !== undefined)
	            identifier = `Transaction at block time "${blockTag}" at index "${index}"`;
	        if (blockHash && index !== undefined)
	            identifier = `Transaction at block hash "${blockHash}" at index "${index}"`;
	        if (blockNumber && index !== undefined)
	            identifier = `Transaction at block number "${blockNumber}" at index "${index}"`;
	        if (hash)
	            identifier = `Transaction with hash "${hash}"`;
	        super(`${identifier} could not be found.`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'TransactionNotFoundError'
	        });
	    }
	}
	class TransactionReceiptNotFoundError extends BaseError {
	    constructor({ hash }) {
	        super(`Transaction receipt with hash "${hash}" could not be found. The Transaction may not be processed on a block yet.`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'TransactionReceiptNotFoundError'
	        });
	    }
	}
	class WaitForTransactionReceiptTimeoutError extends BaseError {
	    constructor({ hash }) {
	        super(`Timed out while waiting for transaction with hash "${hash}" to be confirmed.`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'WaitForTransactionReceiptTimeoutError'
	        });
	    }
	}

	const goerli = /*#__PURE__*/ defineChain(goerli$1);
	const mainnet = /*#__PURE__*/ defineChain(mainnet$1);

	var __defProp = Object.defineProperty;
	var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
	var __publicField = (obj, key, value) => {
	  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
	  return value;
	};
	var __accessCheck$1 = (obj, member, msg) => {
	  if (!member.has(obj))
	    throw TypeError("Cannot " + msg);
	};
	var __privateGet$1 = (obj, member, getter) => {
	  __accessCheck$1(obj, member, "read from private field");
	  return getter ? getter.call(obj) : member.get(obj);
	};
	var __privateAdd$1 = (obj, member, value) => {
	  if (member.has(obj))
	    throw TypeError("Cannot add the same private member more than once");
	  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
	};
	var __privateSet$1 = (obj, member, value, setter) => {
	  __accessCheck$1(obj, member, "write to private field");
	  setter ? setter.call(obj, value) : member.set(obj, value);
	  return value;
	};
	var __privateMethod$1 = (obj, member, method) => {
	  __accessCheck$1(obj, member, "access private method");
	  return method;
	};
	var Connector = class extends EventEmitter$1 {
	  constructor({
	    chains = [mainnet, goerli],
	    options
	  }) {
	    super();
	    __publicField(this, "chains");
	    __publicField(this, "options");
	    __publicField(this, "storage");
	    this.chains = chains;
	    this.options = options;
	  }
	  getBlockExplorerUrls(chain) {
	    const { default: blockExplorer, ...blockExplorers } = chain.blockExplorers ?? {};
	    if (blockExplorer)
	      return [
	        blockExplorer.url,
	        ...Object.values(blockExplorers).map((x) => x.url)
	      ];
	  }
	  isChainUnsupported(chainId) {
	    return !this.chains.some((x) => x.id === chainId);
	  }
	  setStorage(storage) {
	    this.storage = storage;
	  }
	};

	// src/errors.ts
	var ChainNotConfiguredForConnectorError = class extends Error {
	  constructor({
	    chainId,
	    connectorId
	  }) {
	    super(`Chain "${chainId}" not configured for connector "${connectorId}".`);
	    __publicField(this, "name", "ChainNotConfiguredForConnectorError");
	  }
	};
	var ConnectorNotFoundError = class extends Error {
	  constructor() {
	    super(...arguments);
	    __publicField(this, "name", "ConnectorNotFoundError");
	    __publicField(this, "message", "Connector not found");
	  }
	};

	// src/utils/normalizeChainId.ts
	function normalizeChainId(chainId) {
	  if (typeof chainId === "string")
	    return Number.parseInt(
	      chainId,
	      chainId.trim().substring(0, 2) === "0x" ? 16 : 10
	    );
	  if (typeof chainId === "bigint")
	    return Number(chainId);
	  return chainId;
	}

	function formatAbiItem(abiItem, { includeName = false } = {}) {
	    if (abiItem.type !== 'function' &&
	        abiItem.type !== 'event' &&
	        abiItem.type !== 'error')
	        throw new InvalidDefinitionTypeError(abiItem.type);
	    return `${abiItem.name}(${formatAbiParams(abiItem.inputs, { includeName })})`;
	}
	function formatAbiParams(params, { includeName = false } = {}) {
	    if (!params)
	        return '';
	    return params
	        .map((param) => formatAbiParam(param, { includeName }))
	        .join(includeName ? ', ' : ',');
	}
	function formatAbiParam(param, { includeName }) {
	    if (param.type.startsWith('tuple')) {
	        return `(${formatAbiParams(param.components, { includeName })})${param.type.slice('tuple'.length)}`;
	    }
	    return param.type + (includeName && param.name ? ` ${param.name}` : '');
	}

	class AbiConstructorNotFoundError extends BaseError {
	    constructor({ docsPath }) {
	        super([
	            'A constructor was not found on the ABI.',
	            'Make sure you are using the correct ABI and that the constructor exists on it.',
	        ].join('\n'), {
	            docsPath,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AbiConstructorNotFoundError'
	        });
	    }
	}
	class AbiConstructorParamsNotFoundError extends BaseError {
	    constructor({ docsPath }) {
	        super([
	            'Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.',
	            'Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists.',
	        ].join('\n'), {
	            docsPath,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AbiConstructorParamsNotFoundError'
	        });
	    }
	}
	class AbiDecodingDataSizeTooSmallError extends BaseError {
	    constructor({ data, params, size, }) {
	        super([`Data size of ${size} bytes is too small for given parameters.`].join('\n'), {
	            metaMessages: [
	                `Params: (${formatAbiParams(params, { includeName: true })})`,
	                `Data:   ${data} (${size} bytes)`,
	            ],
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AbiDecodingDataSizeTooSmallError'
	        });
	        Object.defineProperty(this, "data", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "params", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "size", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        this.data = data;
	        this.params = params;
	        this.size = size;
	    }
	}
	class AbiDecodingZeroDataError extends BaseError {
	    constructor() {
	        super('Cannot decode zero data ("0x") with ABI parameters.');
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AbiDecodingZeroDataError'
	        });
	    }
	}
	class AbiEncodingArrayLengthMismatchError extends BaseError {
	    constructor({ expectedLength, givenLength, type, }) {
	        super([
	            `ABI encoding array length mismatch for type ${type}.`,
	            `Expected length: ${expectedLength}`,
	            `Given length: ${givenLength}`,
	        ].join('\n'));
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AbiEncodingArrayLengthMismatchError'
	        });
	    }
	}
	class AbiEncodingBytesSizeMismatchError extends BaseError {
	    constructor({ expectedSize, value }) {
	        super(`Size of bytes "${value}" (bytes${size$2(value)}) does not match expected size (bytes${expectedSize}).`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AbiEncodingBytesSizeMismatchError'
	        });
	    }
	}
	class AbiEncodingLengthMismatchError extends BaseError {
	    constructor({ expectedLength, givenLength, }) {
	        super([
	            'ABI encoding params/values length mismatch.',
	            `Expected length (params): ${expectedLength}`,
	            `Given length (values): ${givenLength}`,
	        ].join('\n'));
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AbiEncodingLengthMismatchError'
	        });
	    }
	}
	class AbiErrorSignatureNotFoundError extends BaseError {
	    constructor(signature, { docsPath }) {
	        super([
	            `Encoded error signature "${signature}" not found on ABI.`,
	            'Make sure you are using the correct ABI and that the error exists on it.',
	            `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`,
	        ].join('\n'), {
	            docsPath,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AbiErrorSignatureNotFoundError'
	        });
	        Object.defineProperty(this, "signature", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        this.signature = signature;
	    }
	}
	class AbiEventSignatureEmptyTopicsError extends BaseError {
	    constructor({ docsPath }) {
	        super('Cannot extract event signature from empty topics.', {
	            docsPath,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AbiEventSignatureEmptyTopicsError'
	        });
	    }
	}
	class AbiEventSignatureNotFoundError extends BaseError {
	    constructor(signature, { docsPath }) {
	        super([
	            `Encoded event signature "${signature}" not found on ABI.`,
	            'Make sure you are using the correct ABI and that the event exists on it.',
	            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`,
	        ].join('\n'), {
	            docsPath,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AbiEventSignatureNotFoundError'
	        });
	    }
	}
	class AbiEventNotFoundError extends BaseError {
	    constructor(eventName, { docsPath } = {}) {
	        super([
	            `Event ${eventName ? `"${eventName}" ` : ''}not found on ABI.`,
	            'Make sure you are using the correct ABI and that the event exists on it.',
	        ].join('\n'), {
	            docsPath,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AbiEventNotFoundError'
	        });
	    }
	}
	class AbiFunctionNotFoundError extends BaseError {
	    constructor(functionName, { docsPath } = {}) {
	        super([
	            `Function ${functionName ? `"${functionName}" ` : ''}not found on ABI.`,
	            'Make sure you are using the correct ABI and that the function exists on it.',
	        ].join('\n'), {
	            docsPath,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AbiFunctionNotFoundError'
	        });
	    }
	}
	class AbiFunctionOutputsNotFoundError extends BaseError {
	    constructor(functionName, { docsPath }) {
	        super([
	            `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
	            'Cannot decode function result without knowing what the parameter types are.',
	            'Make sure you are using the correct ABI and that the function exists on it.',
	        ].join('\n'), {
	            docsPath,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AbiFunctionOutputsNotFoundError'
	        });
	    }
	}
	class BytesSizeMismatchError extends BaseError {
	    constructor({ expectedSize, givenSize, }) {
	        super(`Expected bytes${expectedSize}, got bytes${givenSize}.`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'BytesSizeMismatchError'
	        });
	    }
	}
	class DecodeLogDataMismatch extends BaseError {
	    constructor({ abiItem, data, params, size, }) {
	        super([
	            `Data size of ${size} bytes is too small for non-indexed event parameters.`,
	        ].join('\n'), {
	            metaMessages: [
	                `Params: (${formatAbiParams(params, { includeName: true })})`,
	                `Data:   ${data} (${size} bytes)`,
	            ],
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'DecodeLogDataMismatch'
	        });
	        Object.defineProperty(this, "abiItem", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "data", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "params", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "size", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        this.abiItem = abiItem;
	        this.data = data;
	        this.params = params;
	        this.size = size;
	    }
	}
	class DecodeLogTopicsMismatch extends BaseError {
	    constructor({ abiItem, param, }) {
	        super([
	            `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ''} on event "${formatAbiItem(abiItem, { includeName: true })}".`,
	        ].join('\n'));
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'DecodeLogTopicsMismatch'
	        });
	        Object.defineProperty(this, "abiItem", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        this.abiItem = abiItem;
	    }
	}
	class InvalidAbiEncodingTypeError extends BaseError {
	    constructor(type, { docsPath }) {
	        super([
	            `Type "${type}" is not a valid encoding type.`,
	            'Please provide a valid ABI type.',
	        ].join('\n'), { docsPath });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'InvalidAbiEncodingType'
	        });
	    }
	}
	class InvalidAbiDecodingTypeError extends BaseError {
	    constructor(type, { docsPath }) {
	        super([
	            `Type "${type}" is not a valid decoding type.`,
	            'Please provide a valid ABI type.',
	        ].join('\n'), { docsPath });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'InvalidAbiDecodingType'
	        });
	    }
	}
	class InvalidArrayError extends BaseError {
	    constructor(value) {
	        super([`Value "${value}" is not a valid array.`].join('\n'));
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'InvalidArrayError'
	        });
	    }
	}
	class InvalidDefinitionTypeError extends BaseError {
	    constructor(type) {
	        super([
	            `"${type}" is not a valid definition type.`,
	            'Valid types: "function", "event", "error"',
	        ].join('\n'));
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'InvalidDefinitionTypeError'
	        });
	    }
	}

	class FilterTypeNotSupportedError extends BaseError {
	    constructor(type) {
	        super(`Filter type "${type}" is not supported.`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'FilterTypeNotSupportedError'
	        });
	    }
	}

	const paramsRegex = /((function|event)\s)?(.*)(\((.*)\))/;
	function extractFunctionParts(def) {
	    const parts = def.match(paramsRegex);
	    const type = parts?.[2] || undefined;
	    const name = parts?.[3];
	    const params = parts?.[5] || undefined;
	    return { type, name, params };
	}
	function extractFunctionName(def) {
	    return extractFunctionParts(def).name;
	}
	function extractFunctionParams(def) {
	    const params = extractFunctionParts(def).params;
	    const splitParams = params?.split(',').map((x) => x.trim().split(' '));
	    return splitParams?.map((param) => ({
	        type: param[0],
	        name: param[1] === 'indexed' ? param[2] : param[1],
	        ...(param[1] === 'indexed' ? { indexed: true } : {}),
	    }));
	}

	function number$2(n) {
	    if (!Number.isSafeInteger(n) || n < 0)
	        throw new Error(`Wrong positive integer: ${n}`);
	}
	function bool(b) {
	    if (typeof b !== 'boolean')
	        throw new Error(`Expected boolean, not ${b}`);
	}
	function bytes$1(b, ...lengths) {
	    if (!(b instanceof Uint8Array))
	        throw new TypeError('Expected Uint8Array');
	    if (lengths.length > 0 && !lengths.includes(b.length))
	        throw new TypeError(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
	}
	function hash$7(hash) {
	    if (typeof hash !== 'function' || typeof hash.create !== 'function')
	        throw new Error('Hash should be wrapped by utils.wrapConstructor');
	    number$2(hash.outputLen);
	    number$2(hash.blockLen);
	}
	function exists(instance, checkFinished = true) {
	    if (instance.destroyed)
	        throw new Error('Hash instance has been destroyed');
	    if (checkFinished && instance.finished)
	        throw new Error('Hash#digest() has already been called');
	}
	function output(out, instance) {
	    bytes$1(out);
	    const min = instance.outputLen;
	    if (out.length < min) {
	        throw new Error(`digestInto() expects output buffer of length at least ${min}`);
	    }
	}
	const assert$k = {
	    number: number$2,
	    bool,
	    bytes: bytes$1,
	    hash: hash$7,
	    exists,
	    output,
	};

	const U32_MASK64 = BigInt(2 ** 32 - 1);
	const _32n = BigInt(32);
	// We are not using BigUint64Array, because they are extremely slow as per 2022
	function fromBig(n, le = false) {
	    if (le)
	        return { h: Number(n & U32_MASK64), l: Number((n >> _32n) & U32_MASK64) };
	    return { h: Number((n >> _32n) & U32_MASK64) | 0, l: Number(n & U32_MASK64) | 0 };
	}
	function split(lst, le = false) {
	    let Ah = new Uint32Array(lst.length);
	    let Al = new Uint32Array(lst.length);
	    for (let i = 0; i < lst.length; i++) {
	        const { h, l } = fromBig(lst[i], le);
	        [Ah[i], Al[i]] = [h, l];
	    }
	    return [Ah, Al];
	}
	const toBig = (h, l) => (BigInt(h >>> 0) << _32n) | BigInt(l >>> 0);
	// for Shift in [0, 32)
	const shrSH = (h, l, s) => h >>> s;
	const shrSL = (h, l, s) => (h << (32 - s)) | (l >>> s);
	// Right rotate for Shift in [1, 32)
	const rotrSH = (h, l, s) => (h >>> s) | (l << (32 - s));
	const rotrSL = (h, l, s) => (h << (32 - s)) | (l >>> s);
	// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
	const rotrBH = (h, l, s) => (h << (64 - s)) | (l >>> (s - 32));
	const rotrBL = (h, l, s) => (h >>> (s - 32)) | (l << (64 - s));
	// Right rotate for shift===32 (just swaps l&h)
	const rotr32H = (h, l) => l;
	const rotr32L = (h, l) => h;
	// Left rotate for Shift in [1, 32)
	const rotlSH = (h, l, s) => (h << s) | (l >>> (32 - s));
	const rotlSL = (h, l, s) => (l << s) | (h >>> (32 - s));
	// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
	const rotlBH = (h, l, s) => (l << (s - 32)) | (h >>> (64 - s));
	const rotlBL = (h, l, s) => (h << (s - 32)) | (l >>> (64 - s));
	// JS uses 32-bit signed integers for bitwise operations which means we cannot
	// simple take carry out of low bit sum by shift, we need to use division.
	// Removing "export" has 5% perf penalty -_-
	function add(Ah, Al, Bh, Bl) {
	    const l = (Al >>> 0) + (Bl >>> 0);
	    return { h: (Ah + Bh + ((l / 2 ** 32) | 0)) | 0, l: l | 0 };
	}
	// Addition with more than 2 elements
	const add3L = (Al, Bl, Cl) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
	const add3H = (low, Ah, Bh, Ch) => (Ah + Bh + Ch + ((low / 2 ** 32) | 0)) | 0;
	const add4L = (Al, Bl, Cl, Dl) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
	const add4H = (low, Ah, Bh, Ch, Dh) => (Ah + Bh + Ch + Dh + ((low / 2 ** 32) | 0)) | 0;
	const add5L = (Al, Bl, Cl, Dl, El) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
	const add5H = (low, Ah, Bh, Ch, Dh, Eh) => (Ah + Bh + Ch + Dh + Eh + ((low / 2 ** 32) | 0)) | 0;
	// prettier-ignore
	const u64 = {
	    fromBig, split, toBig,
	    shrSH, shrSL,
	    rotrSH, rotrSL, rotrBH, rotrBL,
	    rotr32H, rotr32L,
	    rotlSH, rotlSL, rotlBH, rotlBL,
	    add, add3L, add3H, add4L, add4H, add5H, add5L,
	};

	/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
	// We use `globalThis.crypto`, but node.js versions earlier than v19 don't
	// declare it in global scope. For node.js, package.json#exports field mapping
	// rewrites import from `crypto` to `cryptoNode`, which imports native module.
	// Makes the utils un-importable in browsers without a bundler.
	// Once node.js 18 is deprecated, we can just drop the import.
	const u32 = (arr) => new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
	// big-endian hardware is rare. Just in case someone still decides to run hashes:
	// early-throw an error because we don't support BE yet.
	const isLE = new Uint8Array(new Uint32Array([0x11223344]).buffer)[0] === 0x44;
	if (!isLE)
	    throw new Error('Non little-endian hardware is not supported');
	Array.from({ length: 256 }, (v, i) => i.toString(16).padStart(2, '0'));
	function utf8ToBytes(str) {
	    if (typeof str !== 'string') {
	        throw new TypeError(`utf8ToBytes expected string, got ${typeof str}`);
	    }
	    return new TextEncoder().encode(str);
	}
	function toBytes(data) {
	    if (typeof data === 'string')
	        data = utf8ToBytes(data);
	    if (!(data instanceof Uint8Array))
	        throw new TypeError(`Expected input type is Uint8Array (got ${typeof data})`);
	    return data;
	}
	// For runtime check if class implements interface
	let Hash$7 = class Hash {
	    // Safe version that clones internal state
	    clone() {
	        return this._cloneInto();
	    }
	};
	function wrapConstructor(hashConstructor) {
	    const hashC = (message) => hashConstructor().update(toBytes(message)).digest();
	    const tmp = hashConstructor();
	    hashC.outputLen = tmp.outputLen;
	    hashC.blockLen = tmp.blockLen;
	    hashC.create = () => hashConstructor();
	    return hashC;
	}
	function wrapConstructorWithOpts(hashCons) {
	    const hashC = (msg, opts) => hashCons(opts).update(toBytes(msg)).digest();
	    const tmp = hashCons({});
	    hashC.outputLen = tmp.outputLen;
	    hashC.blockLen = tmp.blockLen;
	    hashC.create = (opts) => hashCons(opts);
	    return hashC;
	}

	// Various per round constants calculations
	const [SHA3_PI, SHA3_ROTL, _SHA3_IOTA] = [[], [], []];
	const _0n$1 = BigInt(0);
	const _1n$1 = BigInt(1);
	const _2n$1 = BigInt(2);
	const _7n = BigInt(7);
	const _256n = BigInt(256);
	const _0x71n = BigInt(0x71);
	for (let round = 0, R = _1n$1, x = 1, y = 0; round < 24; round++) {
	    // Pi
	    [x, y] = [y, (2 * x + 3 * y) % 5];
	    SHA3_PI.push(2 * (5 * y + x));
	    // Rotational
	    SHA3_ROTL.push((((round + 1) * (round + 2)) / 2) % 64);
	    // Iota
	    let t = _0n$1;
	    for (let j = 0; j < 7; j++) {
	        R = ((R << _1n$1) ^ ((R >> _7n) * _0x71n)) % _256n;
	        if (R & _2n$1)
	            t ^= _1n$1 << ((_1n$1 << BigInt(j)) - _1n$1);
	    }
	    _SHA3_IOTA.push(t);
	}
	const [SHA3_IOTA_H, SHA3_IOTA_L] = u64.split(_SHA3_IOTA, true);
	// Left rotation (without 0, 32, 64)
	const rotlH = (h, l, s) => s > 32 ? u64.rotlBH(h, l, s) : u64.rotlSH(h, l, s);
	const rotlL = (h, l, s) => s > 32 ? u64.rotlBL(h, l, s) : u64.rotlSL(h, l, s);
	// Same as keccakf1600, but allows to skip some rounds
	function keccakP(s, rounds = 24) {
	    const B = new Uint32Array(5 * 2);
	    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
	    for (let round = 24 - rounds; round < 24; round++) {
	        // Theta θ
	        for (let x = 0; x < 10; x++)
	            B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
	        for (let x = 0; x < 10; x += 2) {
	            const idx1 = (x + 8) % 10;
	            const idx0 = (x + 2) % 10;
	            const B0 = B[idx0];
	            const B1 = B[idx0 + 1];
	            const Th = rotlH(B0, B1, 1) ^ B[idx1];
	            const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
	            for (let y = 0; y < 50; y += 10) {
	                s[x + y] ^= Th;
	                s[x + y + 1] ^= Tl;
	            }
	        }
	        // Rho (ρ) and Pi (π)
	        let curH = s[2];
	        let curL = s[3];
	        for (let t = 0; t < 24; t++) {
	            const shift = SHA3_ROTL[t];
	            const Th = rotlH(curH, curL, shift);
	            const Tl = rotlL(curH, curL, shift);
	            const PI = SHA3_PI[t];
	            curH = s[PI];
	            curL = s[PI + 1];
	            s[PI] = Th;
	            s[PI + 1] = Tl;
	        }
	        // Chi (χ)
	        for (let y = 0; y < 50; y += 10) {
	            for (let x = 0; x < 10; x++)
	                B[x] = s[y + x];
	            for (let x = 0; x < 10; x++)
	                s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
	        }
	        // Iota (ι)
	        s[0] ^= SHA3_IOTA_H[round];
	        s[1] ^= SHA3_IOTA_L[round];
	    }
	    B.fill(0);
	}
	let Keccak$1 = class Keccak extends Hash$7 {
	    // NOTE: we accept arguments in bytes instead of bits here.
	    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24) {
	        super();
	        this.blockLen = blockLen;
	        this.suffix = suffix;
	        this.outputLen = outputLen;
	        this.enableXOF = enableXOF;
	        this.rounds = rounds;
	        this.pos = 0;
	        this.posOut = 0;
	        this.finished = false;
	        this.destroyed = false;
	        // Can be passed from user as dkLen
	        assert$k.number(outputLen);
	        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
	        if (0 >= this.blockLen || this.blockLen >= 200)
	            throw new Error('Sha3 supports only keccak-f1600 function');
	        this.state = new Uint8Array(200);
	        this.state32 = u32(this.state);
	    }
	    keccak() {
	        keccakP(this.state32, this.rounds);
	        this.posOut = 0;
	        this.pos = 0;
	    }
	    update(data) {
	        assert$k.exists(this);
	        const { blockLen, state } = this;
	        data = toBytes(data);
	        const len = data.length;
	        for (let pos = 0; pos < len;) {
	            const take = Math.min(blockLen - this.pos, len - pos);
	            for (let i = 0; i < take; i++)
	                state[this.pos++] ^= data[pos++];
	            if (this.pos === blockLen)
	                this.keccak();
	        }
	        return this;
	    }
	    finish() {
	        if (this.finished)
	            return;
	        this.finished = true;
	        const { state, suffix, pos, blockLen } = this;
	        // Do the padding
	        state[pos] ^= suffix;
	        if ((suffix & 0x80) !== 0 && pos === blockLen - 1)
	            this.keccak();
	        state[blockLen - 1] ^= 0x80;
	        this.keccak();
	    }
	    writeInto(out) {
	        assert$k.exists(this, false);
	        assert$k.bytes(out);
	        this.finish();
	        const bufferOut = this.state;
	        const { blockLen } = this;
	        for (let pos = 0, len = out.length; pos < len;) {
	            if (this.posOut >= blockLen)
	                this.keccak();
	            const take = Math.min(blockLen - this.posOut, len - pos);
	            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
	            this.posOut += take;
	            pos += take;
	        }
	        return out;
	    }
	    xofInto(out) {
	        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
	        if (!this.enableXOF)
	            throw new Error('XOF is not possible for this instance');
	        return this.writeInto(out);
	    }
	    xof(bytes) {
	        assert$k.number(bytes);
	        return this.xofInto(new Uint8Array(bytes));
	    }
	    digestInto(out) {
	        assert$k.output(out, this);
	        if (this.finished)
	            throw new Error('digest() was already called');
	        this.writeInto(out);
	        this.destroy();
	        return out;
	    }
	    digest() {
	        return this.digestInto(new Uint8Array(this.outputLen));
	    }
	    destroy() {
	        this.destroyed = true;
	        this.state.fill(0);
	    }
	    _cloneInto(to) {
	        const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
	        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
	        to.state32.set(this.state32);
	        to.pos = this.pos;
	        to.posOut = this.posOut;
	        to.finished = this.finished;
	        to.rounds = rounds;
	        // Suffix can change in cSHAKE
	        to.suffix = suffix;
	        to.outputLen = outputLen;
	        to.enableXOF = enableXOF;
	        to.destroyed = this.destroyed;
	        return to;
	    }
	};
	const gen = (suffix, blockLen, outputLen) => wrapConstructor(() => new Keccak$1(blockLen, suffix, outputLen));
	gen(0x06, 144, 224 / 8);
	/**
	 * SHA3-256 hash function
	 * @param message - that would be hashed
	 */
	gen(0x06, 136, 256 / 8);
	gen(0x06, 104, 384 / 8);
	gen(0x06, 72, 512 / 8);
	gen(0x01, 144, 224 / 8);
	/**
	 * keccak-256 hash function. Different from SHA3-256.
	 * @param message - that would be hashed
	 */
	const keccak_256 = gen(0x01, 136, 256 / 8);
	gen(0x01, 104, 384 / 8);
	gen(0x01, 72, 512 / 8);
	const genShake = (suffix, blockLen, outputLen) => wrapConstructorWithOpts((opts = {}) => new Keccak$1(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
	genShake(0x1f, 168, 128 / 8);
	genShake(0x1f, 136, 256 / 8);

	function keccak256$1(value, to_) {
	    const to = to_ || 'hex';
	    const bytes = keccak_256(isHex(value, { strict: false }) ? toBytes$1(value) : value);
	    if (to === 'bytes')
	        return bytes;
	    return toHex$1(bytes);
	}

	const hash$6 = (value) => keccak256$1(toBytes$1(value));
	function hashFunction(def) {
	    const name = extractFunctionName(def);
	    const params = extractFunctionParams(def) || [];
	    return hash$6(`${name}(${params.map(({ type }) => type).join(',')})`);
	}
	function hashAbiItem(abiItem) {
	    return hash$6(formatAbiItem(abiItem));
	}

	const getEventSelector = (event) => {
	    if (typeof event === 'string')
	        return hashFunction(event);
	    return hashAbiItem(event);
	};

	/**
	 * @description Returns a section of the hex or byte array given a start/end bytes offset.
	 *
	 * @param value The hex or byte array to slice.
	 * @param start The start offset (in bytes).
	 * @param end The end offset (in bytes).
	 */
	function slice$1(value, start, end, { strict } = {}) {
	    if (isHex(value, { strict: false }))
	        return sliceHex(value, start, end, {
	            strict,
	        });
	    return sliceBytes(value, start, end, {
	        strict,
	    });
	}
	function assertStartOffset(value, start) {
	    if (typeof start === 'number' && start > 0 && start > size$2(value) - 1)
	        throw new SliceOffsetOutOfBoundsError({
	            offset: start,
	            position: 'start',
	            size: size$2(value),
	        });
	}
	function assertEndOffset(value, start, end) {
	    if (typeof start === 'number' &&
	        typeof end === 'number' &&
	        size$2(value) !== end - start) {
	        throw new SliceOffsetOutOfBoundsError({
	            offset: end,
	            position: 'end',
	            size: size$2(value),
	        });
	    }
	}
	/**
	 * @description Returns a section of the byte array given a start/end bytes offset.
	 *
	 * @param value The byte array to slice.
	 * @param start The start offset (in bytes).
	 * @param end The end offset (in bytes).
	 */
	function sliceBytes(value_, start, end, { strict } = {}) {
	    assertStartOffset(value_, start);
	    const value = value_.slice(start, end);
	    if (strict)
	        assertEndOffset(value, start, end);
	    return value;
	}
	/**
	 * @description Returns a section of the hex value given a start/end bytes offset.
	 *
	 * @param value The hex value to slice.
	 * @param start The start offset (in bytes).
	 * @param end The end offset (in bytes).
	 */
	function sliceHex(value_, start, end, { strict } = {}) {
	    assertStartOffset(value_, start);
	    const value = `0x${value_
        .replace('0x', '')
        .slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
	    if (strict)
	        assertEndOffset(value, start, end);
	    return value;
	}

	/**
	 * @description Encodes a list of primitive values into an ABI-encoded hex value.
	 */
	function encodeAbiParameters(params, values) {
	    if (params.length !== values.length)
	        throw new AbiEncodingLengthMismatchError({
	            expectedLength: params.length,
	            givenLength: values.length,
	        });
	    // Prepare the parameters to determine dynamic types to encode.
	    const preparedParams = prepareParams({
	        params: params,
	        values,
	    });
	    const data = encodeParams(preparedParams);
	    if (data.length === 0)
	        return '0x';
	    return data;
	}
	function prepareParams({ params, values, }) {
	    const preparedParams = [];
	    for (let i = 0; i < params.length; i++) {
	        preparedParams.push(prepareParam({ param: params[i], value: values[i] }));
	    }
	    return preparedParams;
	}
	function prepareParam({ param, value, }) {
	    const arrayComponents = getArrayComponents(param.type);
	    if (arrayComponents) {
	        const [length, type] = arrayComponents;
	        return encodeArray(value, { length, param: { ...param, type } });
	    }
	    if (param.type === 'tuple') {
	        return encodeTuple(value, {
	            param: param,
	        });
	    }
	    if (param.type === 'address') {
	        return encodeAddress(value);
	    }
	    if (param.type === 'bool') {
	        return encodeBool(value);
	    }
	    if (param.type.startsWith('uint') || param.type.startsWith('int')) {
	        const signed = param.type.startsWith('int');
	        return encodeNumber(value, { signed });
	    }
	    if (param.type.startsWith('bytes')) {
	        return encodeBytes(value, { param });
	    }
	    if (param.type === 'string') {
	        return encodeString(value);
	    }
	    throw new InvalidAbiEncodingTypeError(param.type, {
	        docsPath: '/docs/contract/encodeAbiParameters',
	    });
	}
	/////////////////////////////////////////////////////////////////
	function encodeParams(preparedParams) {
	    // 1. Compute the size of the static part of the parameters.
	    let staticSize = 0;
	    for (let i = 0; i < preparedParams.length; i++) {
	        const { dynamic, encoded } = preparedParams[i];
	        if (dynamic)
	            staticSize += 32;
	        else
	            staticSize += size$2(encoded);
	    }
	    // 2. Split the parameters into static and dynamic parts.
	    const staticParams = [];
	    const dynamicParams = [];
	    let dynamicSize = 0;
	    for (let i = 0; i < preparedParams.length; i++) {
	        const { dynamic, encoded } = preparedParams[i];
	        if (dynamic) {
	            staticParams.push(numberToHex$1(staticSize + dynamicSize, { size: 32 }));
	            dynamicParams.push(encoded);
	            dynamicSize += size$2(encoded);
	        }
	        else {
	            staticParams.push(encoded);
	        }
	    }
	    // 3. Concatenate static and dynamic parts.
	    return concat$4([...staticParams, ...dynamicParams]);
	}
	/////////////////////////////////////////////////////////////////
	function encodeAddress(value) {
	    if (!isAddress(value))
	        throw new InvalidAddressError({ address: value });
	    return { dynamic: false, encoded: padHex(value.toLowerCase()) };
	}
	function encodeArray(value, { length, param, }) {
	    const dynamic = length === null;
	    if (!Array.isArray(value))
	        throw new InvalidArrayError(value);
	    if (!dynamic && value.length !== length)
	        throw new AbiEncodingArrayLengthMismatchError({
	            expectedLength: length,
	            givenLength: value.length,
	            type: `${param.type}[${length}]`,
	        });
	    let dynamicChild = false;
	    const preparedParams = [];
	    for (let i = 0; i < value.length; i++) {
	        const preparedParam = prepareParam({ param, value: value[i] });
	        if (preparedParam.dynamic)
	            dynamicChild = true;
	        preparedParams.push(preparedParam);
	    }
	    if (dynamic || dynamicChild) {
	        const data = encodeParams(preparedParams);
	        if (dynamic) {
	            const length = numberToHex$1(preparedParams.length, { size: 32 });
	            return {
	                dynamic: true,
	                encoded: preparedParams.length > 0 ? concat$4([length, data]) : length,
	            };
	        }
	        if (dynamicChild)
	            return { dynamic: true, encoded: data };
	    }
	    return {
	        dynamic: false,
	        encoded: concat$4(preparedParams.map(({ encoded }) => encoded)),
	    };
	}
	function encodeBytes(value, { param }) {
	    const [, paramSize] = param.type.split('bytes');
	    const bytesSize = size$2(value);
	    if (!paramSize) {
	        let value_ = value;
	        // If the size is not divisible by 32 bytes, pad the end
	        // with empty bytes to the ceiling 32 bytes.
	        if (bytesSize % 32 !== 0)
	            value_ = padHex(value_, {
	                dir: 'right',
	                size: Math.ceil((value.length - 2) / 2 / 32) * 32,
	            });
	        return {
	            dynamic: true,
	            encoded: concat$4([padHex(numberToHex$1(bytesSize, { size: 32 })), value_]),
	        };
	    }
	    if (bytesSize !== parseInt(paramSize))
	        throw new AbiEncodingBytesSizeMismatchError({
	            expectedSize: parseInt(paramSize),
	            value,
	        });
	    return { dynamic: false, encoded: padHex(value, { dir: 'right' }) };
	}
	function encodeBool(value) {
	    return { dynamic: false, encoded: padHex(boolToHex(value)) };
	}
	function encodeNumber(value, { signed }) {
	    return {
	        dynamic: false,
	        encoded: numberToHex$1(value, {
	            size: 32,
	            signed,
	        }),
	    };
	}
	function encodeString(value) {
	    const hexValue = stringToHex(value);
	    const partsLength = Math.ceil(size$2(hexValue) / 32);
	    const parts = [];
	    for (let i = 0; i < partsLength; i++) {
	        parts.push(padHex(slice$1(hexValue, i * 32, (i + 1) * 32), {
	            dir: 'right',
	        }));
	    }
	    return {
	        dynamic: true,
	        encoded: concat$4([
	            padHex(numberToHex$1(size$2(hexValue), { size: 32 })),
	            ...parts,
	        ]),
	    };
	}
	function encodeTuple(value, { param }) {
	    let dynamic = false;
	    const preparedParams = [];
	    for (let i = 0; i < param.components.length; i++) {
	        const param_ = param.components[i];
	        const index = Array.isArray(value) ? i : param_.name;
	        const preparedParam = prepareParam({
	            param: param_,
	            value: value[index],
	        });
	        preparedParams.push(preparedParam);
	        if (preparedParam.dynamic)
	            dynamic = true;
	    }
	    return {
	        dynamic,
	        encoded: dynamic
	            ? encodeParams(preparedParams)
	            : concat$4(preparedParams.map(({ encoded }) => encoded)),
	    };
	}
	function getArrayComponents(type) {
	    const matches = type.match(/^(.*)\[(\d+)?\]$/);
	    return matches
	        ? // Return `null` if the array is dynamic.
	            [matches[2] ? Number(matches[2]) : null, matches[1]]
	        : undefined;
	}

	function getAbiItem({ abi, args = [], name, }) {
	    const abiItems = abi.filter((x) => 'name' in x && x.name === name);
	    if (abiItems.length === 0)
	        return undefined;
	    if (abiItems.length === 1)
	        return abiItems[0];
	    for (const abiItem of abiItems) {
	        if (!('inputs' in abiItem))
	            continue;
	        if (!args || args.length === 0) {
	            if (!abiItem.inputs || abiItem.inputs.length === 0)
	                return abiItem;
	            continue;
	        }
	        if (!abiItem.inputs)
	            continue;
	        if (abiItem.inputs.length === 0)
	            continue;
	        if (abiItem.inputs.length !== args.length)
	            continue;
	        const matched = args.every((arg, index) => {
	            const abiParameter = 'inputs' in abiItem && abiItem.inputs[index];
	            if (!abiParameter)
	                return false;
	            return isArgOfType(arg, abiParameter);
	        });
	        if (matched)
	            return abiItem;
	    }
	    return abiItems[0];
	}
	function isArgOfType(arg, abiParameter) {
	    const argType = typeof arg;
	    const abiParameterType = abiParameter.type;
	    switch (abiParameterType) {
	        case 'address':
	            return isAddress(arg);
	        case 'bool':
	            return argType === 'boolean';
	        case 'function':
	            return argType === 'string';
	        case 'string':
	            return argType === 'string';
	        default: {
	            if (abiParameterType === 'tuple' && 'components' in abiParameter)
	                return Object.values(abiParameter.components).every((component, index) => {
	                    return isArgOfType(Object.values(arg)[index], component);
	                });
	            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
	            // https://regexr.com/6v8hp
	            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType))
	                return argType === 'number' || argType === 'bigint';
	            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
	            // https://regexr.com/6va55
	            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType))
	                return argType === 'string' || arg instanceof Uint8Array;
	            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
	            // https://regexr.com/6va6i
	            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) {
	                return (Array.isArray(arg) &&
	                    arg.every((x) => isArgOfType(x, {
	                        ...abiParameter,
	                        // Pop off `[]` or `[M]` from end of type
	                        type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, ''),
	                    })));
	            }
	            return false;
	        }
	    }
	}

	function encodeEventTopics({ abi, eventName, args }) {
	    let abiItem = abi[0];
	    if (eventName) {
	        abiItem = getAbiItem({
	            abi,
	            args,
	            name: eventName,
	        });
	        if (!abiItem)
	            throw new AbiEventNotFoundError(eventName, {
	                docsPath: '/docs/contract/encodeEventTopics',
	            });
	    }
	    if (abiItem.type !== 'event')
	        throw new AbiEventNotFoundError(undefined, {
	            docsPath: '/docs/contract/encodeEventTopics',
	        });
	    const definition = formatAbiItem(abiItem);
	    const signature = getEventSelector(definition);
	    let topics = [];
	    if (args && 'inputs' in abiItem) {
	        const indexedInputs = abiItem.inputs?.filter((param) => 'indexed' in param && param.indexed);
	        const args_ = Array.isArray(args)
	            ? args
	            : Object.values(args).length > 0
	                ? indexedInputs?.map((x) => args[x.name]) ?? []
	                : [];
	        if (args_.length > 0) {
	            topics =
	                indexedInputs?.map((param, i) => Array.isArray(args_[i])
	                    ? args_[i].map((_, j) => encodeArg({ param, value: args_[i][j] }))
	                    : args_[i]
	                        ? encodeArg({ param, value: args_[i] })
	                        : null) ?? [];
	        }
	    }
	    return [signature, ...topics];
	}
	function encodeArg({ param, value, }) {
	    if (param.type === 'string' || param.type === 'bytes')
	        return keccak256$1(toBytes$1(value));
	    if (param.type === 'tuple' || param.type.match(/^(.*)\[(\d+)?\]$/))
	        throw new FilterTypeNotSupportedError(param.type);
	    return encodeAbiParameters([param], [value]);
	}

	/**
	 * Scopes `request` to the filter ID. If the client is a fallback, it will
	 * listen for responses and scope the child transport `request` function
	 * to the successful filter ID.
	 */
	function createFilterRequestScope(client, { method }) {
	    const requestMap = {};
	    if (client.transport.type === 'fallback')
	        client.transport.onResponse?.(({ method: method_, response: id, status, transport, }) => {
	            if (status === 'success' && method === method_)
	                requestMap[id] = transport.request;
	        });
	    return ((id) => requestMap[id] || client.request);
	}

	/**
	 * Creates a Filter to retrieve event logs that can be used with [`getFilterChanges`](https://viem.sh/docs/actions/public/getFilterChanges.html) or [`getFilterLogs`](https://viem.sh/docs/actions/public/getFilterLogs.html).
	 *
	 * - Docs: https://viem.sh/docs/contract/createContractEventFilter.html
	 *
	 * @param client - Client to use
	 * @param parameters - {@link CreateContractEventFilterParameters}
	 * @returns [`Filter`](https://viem.sh/docs/glossary/types.html#filter). {@link CreateContractEventFilterReturnType}
	 *
	 * @example
	 * import { createPublicClient, http, parseAbi } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { createContractEventFilter } from 'viem/contract'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const filter = await createContractEventFilter(client, {
	 *   abi: parseAbi(['event Transfer(address indexed, address indexed, uint256)']),
	 * })
	 */
	async function createContractEventFilter(client, { address, abi, args, eventName, fromBlock, strict, toBlock, }) {
	    const getRequest = createFilterRequestScope(client, {
	        method: 'eth_newFilter',
	    });
	    const topics = eventName
	        ? encodeEventTopics({
	            abi,
	            args,
	            eventName,
	        })
	        : undefined;
	    const id = await client.request({
	        method: 'eth_newFilter',
	        params: [
	            {
	                address,
	                fromBlock: typeof fromBlock === 'bigint' ? numberToHex$1(fromBlock) : fromBlock,
	                toBlock: typeof toBlock === 'bigint' ? numberToHex$1(toBlock) : toBlock,
	                topics,
	            },
	        ],
	    });
	    return {
	        abi,
	        args,
	        eventName,
	        id,
	        request: getRequest(id),
	        strict,
	        type: 'event',
	    };
	}

	function parseAccount(account) {
	    if (typeof account === 'string')
	        return { address: account, type: 'json-rpc' };
	    return account;
	}

	const getFunctionSelector = (fn) => {
	    if (typeof fn === 'string')
	        return slice$1(hashFunction(fn), 0, 4);
	    return slice$1(hashAbiItem(fn), 0, 4);
	};

	function encodeFunctionData({ abi, args, functionName, }) {
	    let abiItem = abi[0];
	    if (functionName) {
	        abiItem = getAbiItem({
	            abi,
	            args,
	            name: functionName,
	        });
	        if (!abiItem)
	            throw new AbiFunctionNotFoundError(functionName, {
	                docsPath: '/docs/contract/encodeFunctionData',
	            });
	    }
	    if (abiItem.type !== 'function')
	        throw new AbiFunctionNotFoundError(undefined, {
	            docsPath: '/docs/contract/encodeFunctionData',
	        });
	    const definition = formatAbiItem(abiItem);
	    const signature = getFunctionSelector(definition);
	    const data = 'inputs' in abiItem && abiItem.inputs
	        ? encodeAbiParameters(abiItem.inputs, (args ?? []))
	        : undefined;
	    return concatHex([signature, data ?? '0x']);
	}

	// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#panic-via-assert-and-error-via-require
	const panicReasons = {
	    1: 'An `assert` condition failed.',
	    17: 'Arithmic operation resulted in underflow or overflow.',
	    18: 'Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).',
	    33: 'Attempted to convert to an invalid type.',
	    34: 'Attempted to access a storage byte array that is incorrectly encoded.',
	    49: 'Performed `.pop()` on an empty array',
	    50: 'Array index is out of bounds.',
	    65: 'Allocated too much memory or created an array which is too large.',
	    81: 'Attempted to call a zero-initialized variable of internal function type.',
	};
	const solidityError = {
	    inputs: [
	        {
	            name: 'message',
	            type: 'string',
	        },
	    ],
	    name: 'Error',
	    type: 'error',
	};
	const solidityPanic = {
	    inputs: [
	        {
	            name: 'reason',
	            type: 'uint256',
	        },
	    ],
	    name: 'Panic',
	    type: 'error',
	};

	function checksumAddress(address_, chainId) {
	    const hexAddress = chainId
	        ? `${chainId}${address_.toLowerCase()}`
	        : address_.substring(2).toLowerCase();
	    const hash = keccak256$1(stringToBytes$1(hexAddress), 'bytes');
	    const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split('');
	    for (let i = 0; i < 40; i += 2) {
	        if (hash[i >> 1] >> 4 >= 8 && address[i]) {
	            address[i] = address[i].toUpperCase();
	        }
	        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) {
	            address[i + 1] = address[i + 1].toUpperCase();
	        }
	    }
	    return `0x${address.join('')}`;
	}
	function getAddress$1(address, chainId) {
	    if (!isAddress(address))
	        throw new InvalidAddressError({ address });
	    return checksumAddress(address, chainId);
	}

	function decodeAbiParameters(params, data) {
	    if (data === '0x' && params.length > 0)
	        throw new AbiDecodingZeroDataError();
	    if (size$2(data) && size$2(data) < 32)
	        throw new AbiDecodingDataSizeTooSmallError({
	            data,
	            params: params,
	            size: size$2(data),
	        });
	    return decodeParams({
	        data,
	        params: params,
	    });
	}
	function decodeParams({ data, params, }) {
	    const decodedValues = [];
	    let position = 0;
	    for (let i = 0; i < params.length; i++) {
	        if (position >= size$2(data))
	            throw new AbiDecodingDataSizeTooSmallError({
	                data,
	                params,
	                size: size$2(data),
	            });
	        const param = params[i];
	        const { consumed, value } = decodeParam({ data, param, position });
	        decodedValues.push(value);
	        // Step across the data by the amount of data consumed by this parameter.
	        position += consumed;
	    }
	    return decodedValues;
	}
	function decodeParam({ data, param, position, }) {
	    const arrayComponents = getArrayComponents(param.type);
	    if (arrayComponents) {
	        const [length, type] = arrayComponents;
	        return decodeArray(data, {
	            length,
	            param: { ...param, type: type },
	            position,
	        });
	    }
	    if (param.type === 'tuple') {
	        return decodeTuple(data, { param: param, position });
	    }
	    if (param.type === 'string') {
	        return decodeString(data, { position });
	    }
	    if (param.type.startsWith('bytes')) {
	        return decodeBytes(data, { param, position });
	    }
	    const value = slice$1(data, position, position + 32, { strict: true });
	    if (param.type.startsWith('uint') || param.type.startsWith('int')) {
	        return decodeNumber(value, { param });
	    }
	    if (param.type === 'address') {
	        return decodeAddress(value);
	    }
	    if (param.type === 'bool') {
	        return decodeBool(value);
	    }
	    throw new InvalidAbiDecodingTypeError(param.type, {
	        docsPath: '/docs/contract/decodeAbiParameters',
	    });
	}
	////////////////////////////////////////////////////////////////////
	function decodeAddress(value) {
	    return { consumed: 32, value: checksumAddress(slice$1(value, -20)) };
	}
	function decodeArray(data, { param, length, position, }) {
	    // If the length of the array is not known in advance (dynamic array),
	    // we will need to decode the offset of the array data.
	    if (!length) {
	        // Get the offset of the array data.
	        const offset = hexToNumber$2(slice$1(data, position, position + 32, { strict: true }));
	        // Get the length of the array from the offset.
	        const length = hexToNumber$2(slice$1(data, offset, offset + 32, { strict: true }));
	        let consumed = 0;
	        const value = [];
	        for (let i = 0; i < length; ++i) {
	            const decodedChild = decodeParam({
	                data: slice$1(data, offset + 32),
	                param,
	                position: consumed,
	            });
	            consumed += decodedChild.consumed;
	            value.push(decodedChild.value);
	        }
	        return { value, consumed: 32 };
	    }
	    // If the length of the array is known in advance,
	    // and the length of an element deeply nested in the array is not known,
	    // we need to decode the offset of the array data.
	    if (hasDynamicChild(param)) {
	        // Get the child type of the array.
	        const arrayComponents = getArrayComponents(param.type);
	        // If the child type is not known, the array is dynamic.
	        const dynamicChild = !arrayComponents?.[0];
	        let consumed = 0;
	        const value = [];
	        for (let i = 0; i < length; ++i) {
	            const offset = hexToNumber$2(slice$1(data, position, position + 32, { strict: true }));
	            const decodedChild = decodeParam({
	                data: slice$1(data, offset),
	                param,
	                position: dynamicChild ? consumed : i * 32,
	            });
	            consumed += decodedChild.consumed;
	            value.push(decodedChild.value);
	        }
	        return { value, consumed: 32 };
	    }
	    // If the length of the array is known in advance,
	    // and the length of each element in the array is known,
	    // the array data is encoded contiguously after the array.
	    let consumed = 0;
	    const value = [];
	    for (let i = 0; i < length; ++i) {
	        const decodedChild = decodeParam({
	            data,
	            param,
	            position: position + consumed,
	        });
	        consumed += decodedChild.consumed;
	        value.push(decodedChild.value);
	    }
	    return { value, consumed };
	}
	function decodeBool(value) {
	    return { consumed: 32, value: hexToBool(value) };
	}
	function decodeBytes(data, { param, position }) {
	    const [_, size] = param.type.split('bytes');
	    if (!size) {
	        // If we don't have a size, we're dealing with a dynamic-size array
	        // so we need to read the offset of the data part first.
	        const offset = hexToNumber$2(slice$1(data, position, position + 32, { strict: true }));
	        const length = hexToNumber$2(slice$1(data, offset, offset + 32, { strict: true }));
	        // If there is no length, we have zero data.
	        if (length === 0)
	            return { consumed: 32, value: '0x' };
	        const value = slice$1(data, offset + 32, offset + 32 + length, {
	            strict: true,
	        });
	        return { consumed: 32, value };
	    }
	    const value = slice$1(data, position, position + parseInt(size), {
	        strict: true,
	    });
	    return { consumed: 32, value };
	}
	function decodeNumber(value, { param }) {
	    const signed = param.type.startsWith('int');
	    const size = parseInt(param.type.split('int')[1] || '256');
	    return {
	        consumed: 32,
	        value: size > 48
	            ? hexToBigInt$1(value, { signed })
	            : hexToNumber$2(value, { signed }),
	    };
	}
	function decodeString(data, { position }) {
	    const offset = hexToNumber$2(slice$1(data, position, position + 32, { strict: true }));
	    const length = hexToNumber$2(slice$1(data, offset, offset + 32, { strict: true }));
	    // If there is no length, we have zero data (empty string).
	    if (length === 0)
	        return { consumed: 32, value: '' };
	    const value = hexToString(trim(slice$1(data, offset + 32, offset + 32 + length, { strict: true })));
	    return { consumed: 32, value };
	}
	function decodeTuple(data, { param, position }) {
	    // Tuples can have unnamed components (i.e. they are arrays), so we must
	    // determine whether the tuple is named or unnamed. In the case of a named
	    // tuple, the value will be an object where each property is the name of the
	    // component. In the case of an unnamed tuple, the value will be an array.
	    const hasUnnamedChild = param.components.length === 0 || param.components.some(({ name }) => !name);
	    // Initialize the value to an object or an array, depending on whether the
	    // tuple is named or unnamed.
	    const value = hasUnnamedChild ? [] : {};
	    let consumed = 0;
	    // If the tuple has a dynamic child, we must first decode the offset to the
	    // tuple data.
	    if (hasDynamicChild(param)) {
	        const offset = hexToNumber$2(slice$1(data, position, position + 32, { strict: true }));
	        // Decode each component of the tuple, starting at the offset.
	        for (let i = 0; i < param.components.length; ++i) {
	            const component = param.components[i];
	            const decodedChild = decodeParam({
	                data: slice$1(data, offset),
	                param: component,
	                position: consumed,
	            });
	            consumed += decodedChild.consumed;
	            value[hasUnnamedChild ? i : component?.name] = decodedChild.value;
	        }
	        return { consumed: 32, value };
	    }
	    // If the tuple has static children, we can just decode each component
	    // in sequence.
	    for (let i = 0; i < param.components.length; ++i) {
	        const component = param.components[i];
	        const decodedChild = decodeParam({
	            data,
	            param: component,
	            position: position + consumed,
	        });
	        consumed += decodedChild.consumed;
	        value[hasUnnamedChild ? i : component?.name] = decodedChild.value;
	    }
	    return { consumed, value };
	}
	function hasDynamicChild(param) {
	    const { type } = param;
	    if (type === 'string')
	        return true;
	    if (type === 'bytes')
	        return true;
	    if (type.endsWith('[]'))
	        return true;
	    if (type === 'tuple')
	        return param.components?.some(hasDynamicChild);
	    const arrayComponents = getArrayComponents(param.type);
	    if (arrayComponents &&
	        hasDynamicChild({ ...param, type: arrayComponents[1] }))
	        return true;
	    return false;
	}

	function decodeErrorResult({ abi, data, }) {
	    const signature = slice$1(data, 0, 4);
	    if (signature === '0x')
	        throw new AbiDecodingZeroDataError();
	    const abi_ = [...(abi || []), solidityError, solidityPanic];
	    const abiItem = abi_.find((x) => x.type === 'error' && signature === getFunctionSelector(formatAbiItem(x)));
	    if (!abiItem)
	        throw new AbiErrorSignatureNotFoundError(signature, {
	            docsPath: '/docs/contract/decodeErrorResult',
	        });
	    return {
	        abiItem,
	        args: ('inputs' in abiItem && abiItem.inputs && abiItem.inputs.length > 0
	            ? decodeAbiParameters(abiItem.inputs, slice$1(data, 4))
	            : undefined),
	        errorName: abiItem.name,
	    };
	}

	const stringify$3 = (value, replacer, space) => JSON.stringify(value, (key, value_) => {
	    const value = typeof value_ === 'bigint' ? value_.toString() : value_;
	    return typeof replacer === 'function' ? replacer(key, value) : value;
	}, space);

	function formatAbiItemWithArgs({ abiItem, args, includeFunctionName = true, includeName = false, }) {
	    if (!('name' in abiItem))
	        return;
	    if (!('inputs' in abiItem))
	        return;
	    if (!abiItem.inputs)
	        return;
	    return `${includeFunctionName ? abiItem.name : ''}(${abiItem.inputs
        .map((input, i) => `${includeName && input.name ? `${input.name}: ` : ''}${typeof args[i] === 'object' ? stringify$3(args[i]) : args[i]}`)
        .join(', ')})`;
	}

	class CallExecutionError extends BaseError {
	    constructor(cause, { account: account_, docsPath, chain, data, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, to, value, }) {
	        const account = account_ ? parseAccount(account_) : undefined;
	        const prettyArgs = prettyPrint({
	            from: account?.address,
	            to,
	            value: typeof value !== 'undefined' &&
	                `${formatEther(value)} ${chain?.nativeCurrency.symbol || 'ETH'}`,
	            data,
	            gas,
	            gasPrice: typeof gasPrice !== 'undefined' && `${formatGwei(gasPrice)} gwei`,
	            maxFeePerGas: typeof maxFeePerGas !== 'undefined' &&
	                `${formatGwei(maxFeePerGas)} gwei`,
	            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== 'undefined' &&
	                `${formatGwei(maxPriorityFeePerGas)} gwei`,
	            nonce,
	        });
	        super(cause.shortMessage, {
	            cause,
	            docsPath,
	            metaMessages: [
	                ...(cause.metaMessages ? [...cause.metaMessages, ' '] : []),
	                'Raw Call Arguments:',
	                prettyArgs,
	            ].filter(Boolean),
	        });
	        Object.defineProperty(this, "cause", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'CallExecutionError'
	        });
	        this.cause = cause;
	    }
	}
	class ContractFunctionExecutionError extends BaseError {
	    constructor(cause, { abi, args, contractAddress, docsPath, functionName, sender, }) {
	        const abiItem = getAbiItem({ abi, args, name: functionName });
	        const formattedArgs = abiItem
	            ? formatAbiItemWithArgs({
	                abiItem,
	                args,
	                includeFunctionName: false,
	                includeName: false,
	            })
	            : undefined;
	        const functionWithParams = abiItem
	            ? formatAbiItem(abiItem, { includeName: true })
	            : undefined;
	        const prettyArgs = prettyPrint({
	            address: contractAddress && getContractAddress(contractAddress),
	            function: functionWithParams,
	            args: formattedArgs &&
	                formattedArgs !== '()' &&
	                `${[...Array(functionName?.length ?? 0).keys()]
                    .map(() => ' ')
                    .join('')}${formattedArgs}`,
	            sender,
	        });
	        super(cause.shortMessage ||
	            `An unknown error occurred while executing the contract function "${functionName}".`, {
	            cause,
	            docsPath,
	            metaMessages: [
	                ...(cause.metaMessages ? [...cause.metaMessages, ' '] : []),
	                'Contract Call:',
	                prettyArgs,
	            ].filter(Boolean),
	        });
	        Object.defineProperty(this, "abi", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "args", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "cause", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "contractAddress", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "formattedArgs", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "functionName", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "sender", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ContractFunctionExecutionError'
	        });
	        this.abi = abi;
	        this.args = args;
	        this.cause = cause;
	        this.contractAddress = contractAddress;
	        this.functionName = functionName;
	        this.sender = sender;
	    }
	}
	class ContractFunctionRevertedError extends BaseError {
	    constructor({ abi, data, functionName, message, }) {
	        let cause;
	        let decodedData = undefined;
	        let metaMessages;
	        let reason;
	        if (data && data !== '0x') {
	            try {
	                decodedData = decodeErrorResult({ abi, data });
	                const { abiItem, errorName, args: errorArgs } = decodedData;
	                if (errorName === 'Error') {
	                    reason = errorArgs[0];
	                }
	                else if (errorName === 'Panic') {
	                    const [firstArg] = errorArgs;
	                    reason = panicReasons[firstArg];
	                }
	                else {
	                    const errorWithParams = abiItem
	                        ? formatAbiItem(abiItem, { includeName: true })
	                        : undefined;
	                    const formattedArgs = abiItem && errorArgs
	                        ? formatAbiItemWithArgs({
	                            abiItem,
	                            args: errorArgs,
	                            includeFunctionName: false,
	                            includeName: false,
	                        })
	                        : undefined;
	                    metaMessages = [
	                        errorWithParams ? `Error: ${errorWithParams}` : '',
	                        formattedArgs && formattedArgs !== '()'
	                            ? `       ${[...Array(errorName?.length ?? 0).keys()]
                                .map(() => ' ')
                                .join('')}${formattedArgs}`
	                            : '',
	                    ];
	                }
	            }
	            catch (err) {
	                cause = err;
	            }
	        }
	        else if (message)
	            reason = message;
	        let signature;
	        if (cause instanceof AbiErrorSignatureNotFoundError) {
	            signature = cause.signature;
	            metaMessages = [
	                `Unable to decode signature "${signature}" as it was not found on the provided ABI.`,
	                'Make sure you are using the correct ABI and that the error exists on it.',
	                `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`,
	            ];
	        }
	        super((reason && reason !== 'execution reverted') || signature
	            ? [
	                `The contract function "${functionName}" reverted with the following ${signature ? 'signature' : 'reason'}:`,
	                reason || signature,
	            ].join('\n')
	            : `The contract function "${functionName}" reverted.`, {
	            cause,
	            metaMessages,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ContractFunctionRevertedError'
	        });
	        Object.defineProperty(this, "data", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "reason", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "signature", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        this.data = decodedData;
	        this.reason = reason;
	        this.signature = signature;
	    }
	}
	class ContractFunctionZeroDataError extends BaseError {
	    constructor({ functionName }) {
	        super(`The contract function "${functionName}" returned no data ("0x").`, {
	            metaMessages: [
	                'This could be due to any of the following:',
	                `  - The contract does not have the function "${functionName}",`,
	                '  - The parameters passed to the contract function may be invalid, or',
	                '  - The address is not a contract.',
	            ],
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ContractFunctionZeroDataError'
	        });
	    }
	}
	class RawContractError extends BaseError {
	    constructor({ data, message, }) {
	        super(message || '');
	        Object.defineProperty(this, "code", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 3
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'RawContractError'
	        });
	        Object.defineProperty(this, "data", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        this.data = data;
	    }
	}

	const EXECUTION_REVERTED_ERROR_CODE = 3;
	function getContractError(err, { abi, address, args, docsPath, functionName, sender, }) {
	    const { code, data, message, shortMessage } = (err instanceof RawContractError
	        ? err
	        : err instanceof BaseError
	            ? err.walk((err) => 'data' in err) || err.walk()
	            : {});
	    let cause = err;
	    if (err instanceof AbiDecodingZeroDataError) {
	        cause = new ContractFunctionZeroDataError({ functionName });
	    }
	    else if (code === EXECUTION_REVERTED_ERROR_CODE &&
	        (data || message || shortMessage)) {
	        cause = new ContractFunctionRevertedError({
	            abi,
	            data: typeof data === 'object' ? data.data : data,
	            functionName,
	            message: shortMessage ?? message,
	        });
	    }
	    return new ContractFunctionExecutionError(cause, {
	        abi,
	        args,
	        contractAddress: address,
	        docsPath,
	        functionName,
	        sender,
	    });
	}

	class AccountNotFoundError extends BaseError {
	    constructor({ docsPath } = {}) {
	        super([
	            'Could not find an Account to execute with this Action.',
	            'Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the WalletClient.',
	        ].join('\n'), {
	            docsPath,
	            docsSlug: 'account',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'AccountNotFoundError'
	        });
	    }
	}

	class EstimateGasExecutionError extends BaseError {
	    constructor(cause, { account, docsPath, chain, data, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, to, value, }) {
	        const prettyArgs = prettyPrint({
	            from: account?.address,
	            to,
	            value: typeof value !== 'undefined' &&
	                `${formatEther(value)} ${chain?.nativeCurrency.symbol || 'ETH'}`,
	            data,
	            gas,
	            gasPrice: typeof gasPrice !== 'undefined' && `${formatGwei(gasPrice)} gwei`,
	            maxFeePerGas: typeof maxFeePerGas !== 'undefined' &&
	                `${formatGwei(maxFeePerGas)} gwei`,
	            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== 'undefined' &&
	                `${formatGwei(maxPriorityFeePerGas)} gwei`,
	            nonce,
	        });
	        super(cause.shortMessage, {
	            cause,
	            docsPath,
	            metaMessages: [
	                ...(cause.metaMessages ? [...cause.metaMessages, ' '] : []),
	                'Estimate Gas Arguments:',
	                prettyArgs,
	            ].filter(Boolean),
	        });
	        Object.defineProperty(this, "cause", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'EstimateGasExecutionError'
	        });
	        this.cause = cause;
	    }
	}

	class HttpRequestError extends BaseError {
	    constructor({ body, details, headers, status, url, }) {
	        super('HTTP request failed.', {
	            details,
	            metaMessages: [
	                status && `Status: ${status}`,
	                `URL: ${getUrl(url)}`,
	                body && `Request body: ${stringify$3(body)}`,
	            ].filter(Boolean),
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'HttpRequestError'
	        });
	        Object.defineProperty(this, "body", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "headers", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "status", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        Object.defineProperty(this, "url", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        this.body = body;
	        this.headers = headers;
	        this.status = status;
	        this.url = url;
	    }
	}
	class WebSocketRequestError extends BaseError {
	    constructor({ body, details, url, }) {
	        super('WebSocket request failed.', {
	            details,
	            metaMessages: [`URL: ${getUrl(url)}`, `Request body: ${stringify$3(body)}`],
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'WebSocketRequestError'
	        });
	    }
	}
	class RpcRequestError extends BaseError {
	    constructor({ body, error, url, }) {
	        super('RPC Request failed.', {
	            cause: error,
	            details: error.message,
	            metaMessages: [`URL: ${getUrl(url)}`, `Request body: ${stringify$3(body)}`],
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'RpcRequestError'
	        });
	        Object.defineProperty(this, "code", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        this.code = error.code;
	    }
	}
	let TimeoutError$1 = class TimeoutError extends BaseError {
	    constructor({ body, url, }) {
	        super('The request took too long to respond.', {
	            details: 'The request timed out.',
	            metaMessages: [`URL: ${getUrl(url)}`, `Request body: ${stringify$3(body)}`],
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'TimeoutError'
	        });
	    }
	};

	const unknownErrorCode = -1;
	/**
	 * Error subclass implementing JSON RPC 2.0 errors and Ethereum RPC errors per EIP-1474.
	 *
	 * - EIP https://eips.ethereum.org/EIPS/eip-1474
	 */
	class RpcError extends BaseError {
	    constructor(cause, { code, docsPath, metaMessages, shortMessage }) {
	        super(shortMessage, {
	            cause,
	            docsPath,
	            metaMessages: metaMessages || cause?.metaMessages,
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'RpcError'
	        });
	        Object.defineProperty(this, "code", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        this.name = cause.name;
	        this.code = (cause instanceof RpcRequestError ? cause.code : code ?? unknownErrorCode);
	    }
	}
	/**
	 * Error subclass implementing Ethereum Provider errors per EIP-1193.
	 *
	 * - EIP https://eips.ethereum.org/EIPS/eip-1193
	 */
	class ProviderRpcError extends RpcError {
	    constructor(cause, options) {
	        super(cause, options);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ProviderRpcError'
	        });
	        Object.defineProperty(this, "data", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: void 0
	        });
	        this.data = options.data;
	    }
	}
	/**
	 * Subclass for a "Parse error" EIP-1474 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1474#error-codes
	 */
	class ParseRpcError extends RpcError {
	    constructor(cause) {
	        super(cause, {
	            code: ParseRpcError.code,
	            shortMessage: 'Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ParseRpcError'
	        });
	    }
	}
	Object.defineProperty(ParseRpcError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: -32700
	});
	/**
	 * Subclass for a "Invalid request" EIP-1474 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1474#error-codes
	 */
	class InvalidRequestRpcError extends RpcError {
	    constructor(cause) {
	        super(cause, {
	            code: InvalidRequestRpcError.code,
	            shortMessage: 'JSON is not a valid request object.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'InvalidRequestRpcError'
	        });
	    }
	}
	Object.defineProperty(InvalidRequestRpcError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: -32600
	});
	/**
	 * Subclass for a "Method not found" EIP-1474 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1474#error-codes
	 */
	class MethodNotFoundRpcError extends RpcError {
	    constructor(cause) {
	        super(cause, {
	            code: MethodNotFoundRpcError.code,
	            shortMessage: 'The method does not exist / is not available.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'MethodNotFoundRpcError'
	        });
	    }
	}
	Object.defineProperty(MethodNotFoundRpcError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: -32601
	});
	/**
	 * Subclass for an "Invalid params" EIP-1474 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1474#error-codes
	 */
	class InvalidParamsRpcError extends RpcError {
	    constructor(cause) {
	        super(cause, {
	            code: InvalidParamsRpcError.code,
	            shortMessage: [
	                'Invalid parameters were provided to the RPC method.',
	                'Double check you have provided the correct parameters.',
	            ].join('\n'),
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'InvalidParamsRpcError'
	        });
	    }
	}
	Object.defineProperty(InvalidParamsRpcError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: -32602
	});
	/**
	 * Subclass for an "Internal error" EIP-1474 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1474#error-codes
	 */
	class InternalRpcError extends RpcError {
	    constructor(cause) {
	        super(cause, {
	            code: InternalRpcError.code,
	            shortMessage: 'An internal error was received.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'InternalRpcError'
	        });
	    }
	}
	Object.defineProperty(InternalRpcError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: -32603
	});
	/**
	 * Subclass for an "Invalid input" EIP-1474 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1474#error-codes
	 */
	class InvalidInputRpcError extends RpcError {
	    constructor(cause) {
	        super(cause, {
	            code: InvalidInputRpcError.code,
	            shortMessage: [
	                'Missing or invalid parameters.',
	                'Double check you have provided the correct parameters.',
	            ].join('\n'),
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'InvalidInputRpcError'
	        });
	    }
	}
	Object.defineProperty(InvalidInputRpcError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: -32000
	});
	/**
	 * Subclass for a "Resource not found" EIP-1474 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1474#error-codes
	 */
	class ResourceNotFoundRpcError extends RpcError {
	    constructor(cause) {
	        super(cause, {
	            code: ResourceNotFoundRpcError.code,
	            shortMessage: 'Requested resource not found.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ResourceNotFoundRpcError'
	        });
	    }
	}
	Object.defineProperty(ResourceNotFoundRpcError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: -32001
	});
	/**
	 * Subclass for a "Resource unavailable" EIP-1474 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1474#error-codes
	 */
	class ResourceUnavailableRpcError extends RpcError {
	    constructor(cause) {
	        super(cause, {
	            code: ResourceUnavailableRpcError.code,
	            shortMessage: 'Requested resource not available.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ResourceUnavailableRpcError'
	        });
	    }
	}
	Object.defineProperty(ResourceUnavailableRpcError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: -32002
	});
	/**
	 * Subclass for a "Transaction rejected" EIP-1474 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1474#error-codes
	 */
	class TransactionRejectedRpcError extends RpcError {
	    constructor(cause) {
	        super(cause, {
	            code: TransactionRejectedRpcError.code,
	            shortMessage: 'Transaction creation failed.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'TransactionRejectedRpcError'
	        });
	    }
	}
	Object.defineProperty(TransactionRejectedRpcError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: -32003
	});
	/**
	 * Subclass for a "Method not supported" EIP-1474 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1474#error-codes
	 */
	class MethodNotSupportedRpcError extends RpcError {
	    constructor(cause) {
	        super(cause, {
	            code: MethodNotSupportedRpcError.code,
	            shortMessage: 'Method is not implemented.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'MethodNotSupportedRpcError'
	        });
	    }
	}
	Object.defineProperty(MethodNotSupportedRpcError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: -32004
	});
	/**
	 * Subclass for a "Limit exceeded" EIP-1474 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1474#error-codes
	 */
	class LimitExceededRpcError extends RpcError {
	    constructor(cause) {
	        super(cause, {
	            code: LimitExceededRpcError.code,
	            shortMessage: 'Request exceeds defined limit.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'LimitExceededRpcError'
	        });
	    }
	}
	Object.defineProperty(LimitExceededRpcError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: -32005
	});
	/**
	 * Subclass for a "JSON-RPC version not supported" EIP-1474 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1474#error-codes
	 */
	class JsonRpcVersionUnsupportedError extends RpcError {
	    constructor(cause) {
	        super(cause, {
	            code: JsonRpcVersionUnsupportedError.code,
	            shortMessage: 'Version of JSON-RPC protocol is not supported.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'JsonRpcVersionUnsupportedError'
	        });
	    }
	}
	Object.defineProperty(JsonRpcVersionUnsupportedError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: -32006
	});
	/**
	 * Subclass for a "User Rejected Request" EIP-1193 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1193#provider-errors
	 */
	class UserRejectedRequestError extends ProviderRpcError {
	    constructor(cause) {
	        super(cause, {
	            code: UserRejectedRequestError.code,
	            shortMessage: 'User rejected the request.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'UserRejectedRequestError'
	        });
	    }
	}
	Object.defineProperty(UserRejectedRequestError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: 4001
	});
	/**
	 * Subclass for an "Unauthorized" EIP-1193 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1193#provider-errors
	 */
	class UnauthorizedProviderError extends ProviderRpcError {
	    constructor(cause) {
	        super(cause, {
	            code: UnauthorizedProviderError.code,
	            shortMessage: 'The requested method and/or account has not been authorized by the user.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'UnauthorizedProviderError'
	        });
	    }
	}
	Object.defineProperty(UnauthorizedProviderError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: 4100
	});
	/**
	 * Subclass for an "Unsupported Method" EIP-1193 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1193#provider-errors
	 */
	class UnsupportedProviderMethodError extends ProviderRpcError {
	    constructor(cause) {
	        super(cause, {
	            code: UnsupportedProviderMethodError.code,
	            shortMessage: 'The Provider does not support the requested method.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'UnsupportedProviderMethodError'
	        });
	    }
	}
	Object.defineProperty(UnsupportedProviderMethodError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: 4200
	});
	/**
	 * Subclass for an "Disconnected" EIP-1193 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1193#provider-errors
	 */
	class ProviderDisconnectedError extends ProviderRpcError {
	    constructor(cause) {
	        super(cause, {
	            code: ProviderDisconnectedError.code,
	            shortMessage: 'The Provider is disconnected from all chains.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ProviderDisconnectedError'
	        });
	    }
	}
	Object.defineProperty(ProviderDisconnectedError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: 4900
	});
	/**
	 * Subclass for an "Chain Disconnected" EIP-1193 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1193#provider-errors
	 */
	class ChainDisconnectedError extends ProviderRpcError {
	    constructor(cause) {
	        super(cause, {
	            code: ChainDisconnectedError.code,
	            shortMessage: 'The Provider is not connected to the requested chain.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'ChainDisconnectedError'
	        });
	    }
	}
	Object.defineProperty(ChainDisconnectedError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: 4901
	});
	/**
	 * Subclass for an "Switch Chain" EIP-1193 error.
	 *
	 * EIP https://eips.ethereum.org/EIPS/eip-1193#provider-errors
	 */
	class SwitchChainError extends ProviderRpcError {
	    constructor(cause) {
	        super(cause, {
	            code: SwitchChainError.code,
	            shortMessage: 'An error occurred when attempting to switch chain.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'SwitchChainError'
	        });
	    }
	}
	Object.defineProperty(SwitchChainError, "code", {
	    enumerable: true,
	    configurable: true,
	    writable: true,
	    value: 4902
	});
	/**
	 * Subclass for an unknown RPC error.
	 */
	class UnknownRpcError extends RpcError {
	    constructor(cause) {
	        super(cause, {
	            shortMessage: 'An unknown RPC error occurred.',
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'UnknownRpcError'
	        });
	    }
	}

	function containsNodeError(err) {
	    return (err instanceof TransactionRejectedRpcError ||
	        err instanceof InvalidInputRpcError ||
	        (err instanceof RpcRequestError && err.code === ExecutionRevertedError.code));
	}
	function getNodeError(err, args) {
	    const message = err.details.toLowerCase();
	    if (FeeCapTooHighError.nodeMessage.test(message))
	        return new FeeCapTooHighError({
	            cause: err,
	            maxFeePerGas: args?.maxFeePerGas,
	        });
	    else if (FeeCapTooLowError.nodeMessage.test(message))
	        return new FeeCapTooLowError({
	            cause: err,
	            maxFeePerGas: args?.maxFeePerGas,
	        });
	    else if (NonceTooHighError.nodeMessage.test(message))
	        return new NonceTooHighError({ cause: err, nonce: args?.nonce });
	    else if (NonceTooLowError.nodeMessage.test(message))
	        return new NonceTooLowError({ cause: err, nonce: args?.nonce });
	    else if (NonceMaxValueError.nodeMessage.test(message))
	        return new NonceMaxValueError({ cause: err, nonce: args?.nonce });
	    else if (InsufficientFundsError.nodeMessage.test(message))
	        return new InsufficientFundsError({ cause: err });
	    else if (IntrinsicGasTooHighError.nodeMessage.test(message))
	        return new IntrinsicGasTooHighError({ cause: err, gas: args?.gas });
	    else if (IntrinsicGasTooLowError.nodeMessage.test(message))
	        return new IntrinsicGasTooLowError({ cause: err, gas: args?.gas });
	    else if (TransactionTypeNotSupportedError.nodeMessage.test(message))
	        return new TransactionTypeNotSupportedError({ cause: err });
	    else if (TipAboveFeeCapError.nodeMessage.test(message))
	        return new TipAboveFeeCapError({
	            cause: err,
	            maxFeePerGas: args?.maxFeePerGas,
	            maxPriorityFeePerGas: args?.maxPriorityFeePerGas,
	        });
	    else if (message.match(ExecutionRevertedError.nodeMessage) ||
	        ('code' in err.cause &&
	            err.cause?.code === ExecutionRevertedError.code))
	        return new ExecutionRevertedError({
	            cause: err,
	            message: err.cause.details || err.details,
	        });
	    return new UnknownNodeError({
	        cause: err.cause.cause,
	    });
	}

	function getEstimateGasError(err, { docsPath, ...args }) {
	    let cause = err;
	    if (containsNodeError(err))
	        cause = getNodeError(err, args);
	    return new EstimateGasExecutionError(cause, {
	        docsPath,
	        ...args,
	    });
	}

	/**
	 * @description Picks out the keys from `value` that exist in the formatter.
	 */
	function extract(value, { format }) {
	    if (!format)
	        return {};
	    const keys = Object.keys(format({}));
	    return keys.reduce((data, key) => {
	        // rome-ignore lint/suspicious/noPrototypeBuiltins:
	        if (value?.hasOwnProperty(key)) {
	            data[key] = value[key];
	        }
	        return data;
	    }, {});
	}

	function assertRequest(args) {
	    const { account: account_, gasPrice, maxFeePerGas, maxPriorityFeePerGas, to, } = args;
	    const account = account_ ? parseAccount(account_) : undefined;
	    if (account && !isAddress(account.address))
	        throw new InvalidAddressError({ address: account.address });
	    if (to && !isAddress(to))
	        throw new InvalidAddressError({ address: to });
	    if (typeof gasPrice !== 'undefined' &&
	        (typeof maxFeePerGas !== 'undefined' ||
	            typeof maxPriorityFeePerGas !== 'undefined'))
	        throw new FeeConflictError();
	    if (maxFeePerGas && maxFeePerGas > 2n ** 256n - 1n)
	        throw new FeeCapTooHighError({ maxFeePerGas });
	    if (maxPriorityFeePerGas &&
	        maxFeePerGas &&
	        maxPriorityFeePerGas > maxFeePerGas)
	        throw new TipAboveFeeCapError({ maxFeePerGas, maxPriorityFeePerGas });
	}

	class BlockNotFoundError extends BaseError {
	    constructor({ blockHash, blockNumber, }) {
	        let identifier = 'Block';
	        if (blockHash)
	            identifier = `Block at hash "${blockHash}"`;
	        if (blockNumber)
	            identifier = `Block at number "${blockNumber}"`;
	        super(`${identifier} could not be found.`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'BlockNotFoundError'
	        });
	    }
	}

	/**
	 * Returns information about a block at a block number, hash, or tag.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getBlock.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/blocks/fetching-blocks
	 * - JSON-RPC Methods:
	 *   - Calls [`eth_getBlockByNumber`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getblockbynumber) for `blockNumber` & `blockTag`.
	 *   - Calls [`eth_getBlockByHash`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getblockbyhash) for `blockHash`.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetBlockParameters}
	 * @returns Information about the block. {@link GetBlockReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getBlock } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const block = await getBlock(client)
	 */
	async function getBlock(client, { blockHash, blockNumber, blockTag: blockTag_, includeTransactions: includeTransactions_, } = {}) {
	    const blockTag = blockTag_ ?? 'latest';
	    const includeTransactions = includeTransactions_ ?? false;
	    const blockNumberHex = blockNumber !== undefined ? numberToHex$1(blockNumber) : undefined;
	    let block = null;
	    if (blockHash) {
	        block = await client.request({
	            method: 'eth_getBlockByHash',
	            params: [blockHash, includeTransactions],
	        });
	    }
	    else {
	        block = await client.request({
	            method: 'eth_getBlockByNumber',
	            params: [blockNumberHex || blockTag, includeTransactions],
	        });
	    }
	    if (!block)
	        throw new BlockNotFoundError({ blockHash, blockNumber });
	    const format = client.chain?.formatters?.block?.format || formatBlock;
	    return format(block);
	}

	/**
	 * Returns the current price of gas (in wei).
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getGasPrice.html
	 * - JSON-RPC Methods: [`eth_gasPrice`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gasprice)
	 *
	 * @param client - Client to use
	 * @returns The gas price (in wei). {@link GetGasPriceReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getGasPrice } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const gasPrice = await getGasPrice(client)
	 */
	async function getGasPrice(client) {
	    const gasPrice = await client.request({
	        method: 'eth_gasPrice',
	    });
	    return BigInt(gasPrice);
	}

	/**
	 * Returns the number of [Transactions](https://viem.sh/docs/glossary/terms.html#transaction) an Account has broadcast / sent.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getTransactionCount.html
	 * - JSON-RPC Methods: [`eth_getTransactionCount`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gettransactioncount)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetTransactionCountParameters}
	 * @returns The number of transactions an account has sent. {@link GetTransactionCountReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getTransactionCount } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const transactionCount = await getTransactionCount(client, {
	 *   address: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
	 * })
	 */
	async function getTransactionCount(client, { address, blockTag = 'latest', blockNumber }) {
	    const count = await client.request({
	        method: 'eth_getTransactionCount',
	        params: [address, blockNumber ? numberToHex$1(blockNumber) : blockTag],
	    });
	    return hexToNumber$2(count);
	}

	const defaultTip = 1500000000n; // 1.5 gwei
	async function prepareRequest(client, args) {
	    const { account: account_, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, } = args;
	    if (!account_)
	        throw new AccountNotFoundError();
	    const account = parseAccount(account_);
	    const block = await getBlock(client, { blockTag: 'latest' });
	    const request = { ...args, from: account.address };
	    if (typeof nonce === 'undefined')
	        request.nonce = await getTransactionCount(client, {
	            address: account.address,
	            blockTag: 'pending',
	        });
	    if (typeof block.baseFeePerGas === 'bigint') {
	        if (typeof gasPrice !== 'undefined')
	            throw new BaseError('Chain does not support legacy `gasPrice`.');
	        // EIP-1559 fees
	        if (typeof maxFeePerGas === 'undefined') {
	            // Set a buffer of 1.2x on top of the base fee to account for fluctuations.
	            request.maxPriorityFeePerGas = maxPriorityFeePerGas ?? defaultTip;
	            request.maxFeePerGas =
	                (block.baseFeePerGas * 120n) / 100n + request.maxPriorityFeePerGas;
	        }
	        else {
	            if (typeof maxPriorityFeePerGas === 'undefined' &&
	                maxFeePerGas < defaultTip)
	                throw new BaseError('`maxFeePerGas` cannot be less than the default `maxPriorityFeePerGas` (1.5 gwei).');
	            request.maxFeePerGas = maxFeePerGas;
	            request.maxPriorityFeePerGas = maxPriorityFeePerGas ?? defaultTip;
	        }
	    }
	    else {
	        if (typeof maxFeePerGas !== 'undefined' ||
	            typeof maxPriorityFeePerGas !== 'undefined')
	            throw new BaseError('Chain does not support EIP-1559 fees.');
	        // Legacy fees
	        if (typeof gasPrice === 'undefined')
	            // Set a buffer of 1.2x on top of the base fee to account for fluctuations.
	            request.gasPrice = ((await getGasPrice(client)) * 120n) / 100n;
	    }
	    if (typeof gas === 'undefined')
	        request.gas = await estimateGas(client, {
	            ...request,
	            account: { address: account.address, type: 'json-rpc' },
	        });
	    assertRequest(request);
	    return request;
	}

	/**
	 * Estimates the gas necessary to complete a transaction without submitting it to the network.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/estimateGas.html
	 * - JSON-RPC Methods: [`eth_estimateGas`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_estimategas)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link EstimateGasParameters}
	 * @returns The gas estimate (in wei). {@link EstimateGasReturnType}
	 *
	 * @example
	 * import { createPublicClient, http, parseEther } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { estimateGas } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const gasEstimate = await estimateGas(client, {
	 *   account: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
	 *   to: '0x70997970c51812dc3a010c7d01b50e0d17dc79c8',
	 *   value: parseEther('1'),
	 * })
	 */
	async function estimateGas(client, args) {
	    const account_ = args.account ?? client.account;
	    if (!account_)
	        throw new AccountNotFoundError({
	            docsPath: '/docs/actions/public/estimateGas',
	        });
	    const account = parseAccount(account_);
	    try {
	        const { accessList, blockNumber, blockTag, data, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, to, value, ...rest } = account.type === 'local' ? await prepareRequest(client, args) : args;
	        const blockNumberHex = blockNumber ? numberToHex$1(blockNumber) : undefined;
	        const block = blockNumberHex || blockTag;
	        assertRequest(args);
	        const format = client.chain?.formatters?.transactionRequest?.format ||
	            formatTransactionRequest;
	        const request = format({
	            // Pick out extra data that might exist on the chain's transaction request type.
	            ...extract(rest, { format }),
	            from: account.address,
	            accessList,
	            data,
	            gas,
	            gasPrice,
	            maxFeePerGas,
	            maxPriorityFeePerGas,
	            nonce,
	            to,
	            value,
	        });
	        const balance = await client.request({
	            method: 'eth_estimateGas',
	            params: block ? [request, block] : [request],
	        });
	        return BigInt(balance);
	    }
	    catch (err) {
	        throw getEstimateGasError(err, {
	            ...args,
	            account,
	            chain: client.chain,
	        });
	    }
	}

	/**
	 * Estimates the gas required to successfully execute a contract write function call.
	 *
	 * - Docs: https://viem.sh/docs/contract/estimateContractGas.html
	 *
	 * Internally, uses a [Public Client](https://viem.sh/docs/clients/public.html) to call the [`estimateGas` action](https://viem.sh/docs/actions/public/estimateGas.html) with [ABI-encoded `data`](https://viem.sh/docs/contract/encodeFunctionData.html).
	 *
	 * @param client - Client to use
	 * @param parameters - {@link EstimateContractGasParameters}
	 * @returns The gas estimate (in wei). {@link EstimateContractGasReturnType}
	 *
	 * @example
	 * import { createPublicClient, http, parseAbi } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { estimateContractGas } from 'viem/contract'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const gas = await estimateContractGas(client, {
	 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
	 *   abi: parseAbi(['function mint() public']),
	 *   functionName: 'mint',
	 *   account: '0xf39fd6e51aad88f6f4ce6ab8827279cfffb92266',
	 * })
	 */
	async function estimateContractGas(client, { abi, address, args, functionName, ...request }) {
	    const data = encodeFunctionData({
	        abi,
	        args,
	        functionName,
	    });
	    try {
	        const gas = await estimateGas(client, {
	            data,
	            to: address,
	            ...request,
	        });
	        return gas;
	    }
	    catch (err) {
	        const account = request.account ? parseAccount(request.account) : undefined;
	        throw getContractError(err, {
	            abi: abi,
	            address,
	            args,
	            docsPath: '/docs/contract/simulateContract',
	            functionName,
	            sender: account?.address,
	        });
	    }
	}

	const docsPath$2 = '/docs/contract/decodeFunctionResult';
	function decodeFunctionResult({ abi, args, functionName, data, }) {
	    let abiItem = abi[0];
	    if (functionName) {
	        abiItem = getAbiItem({
	            abi,
	            args,
	            name: functionName,
	        });
	        if (!abiItem)
	            throw new AbiFunctionNotFoundError(functionName, { docsPath: docsPath$2 });
	    }
	    if (abiItem.type !== 'function')
	        throw new AbiFunctionNotFoundError(undefined, { docsPath: docsPath$2 });
	    if (!abiItem.outputs)
	        throw new AbiFunctionOutputsNotFoundError(abiItem.name, { docsPath: docsPath$2 });
	    const values = decodeAbiParameters(abiItem.outputs, data);
	    if (values && values.length > 1)
	        return values;
	    if (values && values.length === 1)
	        return values[0];
	    return undefined;
	}

	/* [Multicall3](https://github.com/mds1/multicall) */
	const multicall3Abi = [
	    {
	        inputs: [
	            {
	                components: [
	                    {
	                        name: 'target',
	                        type: 'address',
	                    },
	                    {
	                        name: 'allowFailure',
	                        type: 'bool',
	                    },
	                    {
	                        name: 'callData',
	                        type: 'bytes',
	                    },
	                ],
	                name: 'calls',
	                type: 'tuple[]',
	            },
	        ],
	        name: 'aggregate3',
	        outputs: [
	            {
	                components: [
	                    {
	                        name: 'success',
	                        type: 'bool',
	                    },
	                    {
	                        name: 'returnData',
	                        type: 'bytes',
	                    },
	                ],
	                name: 'returnData',
	                type: 'tuple[]',
	            },
	        ],
	        stateMutability: 'view',
	        type: 'function',
	    },
	];
	const universalResolverErrors = [
	    {
	        inputs: [],
	        name: 'ResolverNotFound',
	        type: 'error',
	    },
	    {
	        inputs: [],
	        name: 'ResolverWildcardNotSupported',
	        type: 'error',
	    },
	];
	const universalResolverResolveAbi = [
	    ...universalResolverErrors,
	    {
	        name: 'resolve',
	        type: 'function',
	        stateMutability: 'view',
	        inputs: [
	            { name: 'name', type: 'bytes' },
	            { name: 'data', type: 'bytes' },
	        ],
	        outputs: [
	            { name: '', type: 'bytes' },
	            { name: 'address', type: 'address' },
	        ],
	    },
	];
	const universalResolverReverseAbi = [
	    ...universalResolverErrors,
	    {
	        name: 'reverse',
	        type: 'function',
	        stateMutability: 'view',
	        inputs: [{ type: 'bytes', name: 'reverseName' }],
	        outputs: [
	            { type: 'string', name: 'resolvedName' },
	            { type: 'address', name: 'resolvedAddress' },
	            { type: 'address', name: 'reverseResolver' },
	            { type: 'address', name: 'resolver' },
	        ],
	    },
	];
	const textResolverAbi = [
	    {
	        name: 'text',
	        type: 'function',
	        stateMutability: 'view',
	        inputs: [
	            { name: 'name', type: 'bytes32' },
	            { name: 'key', type: 'string' },
	        ],
	        outputs: [{ name: '', type: 'string' }],
	    },
	];
	const addressResolverAbi = [
	    {
	        name: 'addr',
	        type: 'function',
	        stateMutability: 'view',
	        inputs: [{ name: 'name', type: 'bytes32' }],
	        outputs: [{ name: '', type: 'address' }],
	    },
	    {
	        name: 'addr',
	        type: 'function',
	        stateMutability: 'view',
	        inputs: [
	            { name: 'name', type: 'bytes32' },
	            { name: 'coinType', type: 'uint256' },
	        ],
	        outputs: [{ name: '', type: 'bytes' }],
	    },
	];
	// ERC-6492 - universal deployless signature validator contract
	// constructor(address _signer, bytes32 _hash, bytes _signature) → bytes4 returnValue
	// returnValue is either 0x1 (valid) or 0x0 (invalid)
	const universalSignatureValidatorAbi = [
	    {
	        inputs: [
	            {
	                internalType: 'address',
	                name: '_signer',
	                type: 'address',
	            },
	            {
	                internalType: 'bytes32',
	                name: '_hash',
	                type: 'bytes32',
	            },
	            {
	                internalType: 'bytes',
	                name: '_signature',
	                type: 'bytes',
	            },
	        ],
	        stateMutability: 'nonpayable',
	        type: 'constructor',
	    },
	];

	const aggregate3Signature = '0x82ad56cb';

	function getCallError(err, { docsPath, ...args }) {
	    let cause = err;
	    if (containsNodeError(err))
	        cause = getNodeError(err, args);
	    return new CallExecutionError(cause, {
	        docsPath,
	        ...args,
	    });
	}

	const schedulerCache = /*#__PURE__*/ new Map();
	function createBatchScheduler({ fn, id, shouldSplitBatch, wait = 0, }) {
	    const exec = async () => {
	        const scheduler = getScheduler();
	        flush();
	        const args = scheduler.map(({ args }) => args);
	        if (args.length === 0)
	            return;
	        fn(args)
	            .then((data) => {
	            scheduler.forEach(({ pendingPromise }, i) => pendingPromise.resolve?.([data[i], data]));
	        })
	            .catch((err) => {
	            scheduler.forEach(({ pendingPromise }) => pendingPromise.reject?.(err));
	        });
	    };
	    const flush = () => schedulerCache.delete(id);
	    const getBatchedArgs = () => getScheduler().map(({ args }) => args);
	    const getScheduler = () => schedulerCache.get(id) || [];
	    const setScheduler = (item) => schedulerCache.set(id, [...getScheduler(), item]);
	    return {
	        flush,
	        async schedule(args) {
	            const pendingPromise = {};
	            const promise = new Promise((resolve, reject) => {
	                pendingPromise.resolve = resolve;
	                pendingPromise.reject = reject;
	            });
	            const split = shouldSplitBatch?.([...getBatchedArgs(), args]);
	            if (split)
	                exec();
	            const hasActiveScheduler = getScheduler().length > 0;
	            if (hasActiveScheduler) {
	                setScheduler({ args, pendingPromise });
	                return promise;
	            }
	            setScheduler({ args, pendingPromise });
	            setTimeout(exec, wait);
	            return promise;
	        },
	    };
	}

	/**
	 * Executes a new message call immediately without submitting a transaction to the network.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/call.html
	 * - JSON-RPC Methods: [`eth_call`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_call)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link CallParameters}
	 * @returns The call data. {@link CallReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { call } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const data = await call(client, {
	 *   account: '0xf39fd6e51aad88f6f4ce6ab8827279cfffb92266',
	 *   data: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
	 *   to: '0x70997970c51812dc3a010c7d01b50e0d17dc79c8',
	 * })
	 */
	async function call$1(client, args) {
	    const { account: account_, batch = Boolean(client.batch?.multicall), blockNumber, blockTag = 'latest', accessList, data, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, to, value, ...rest } = args;
	    const account = account_ ? parseAccount(account_) : undefined;
	    try {
	        assertRequest(args);
	        const blockNumberHex = blockNumber ? numberToHex$1(blockNumber) : undefined;
	        const block = blockNumberHex || blockTag;
	        const format = client.chain?.formatters?.transactionRequest?.format ||
	            formatTransactionRequest;
	        const request = format({
	            // Pick out extra data that might exist on the chain's transaction request type.
	            ...extract(rest, { format }),
	            from: account?.address,
	            accessList,
	            data,
	            gas,
	            gasPrice,
	            maxFeePerGas,
	            maxPriorityFeePerGas,
	            nonce,
	            to,
	            value,
	        });
	        if (batch && shouldPerformMulticall({ request })) {
	            try {
	                return await scheduleMulticall(client, {
	                    ...request,
	                    blockNumber,
	                    blockTag,
	                });
	            }
	            catch (err) {
	                if (!(err instanceof ClientChainNotConfiguredError) &&
	                    !(err instanceof ChainDoesNotSupportContract))
	                    throw err;
	            }
	        }
	        const response = await client.request({
	            method: 'eth_call',
	            params: block
	                ? [request, block]
	                : [request],
	        });
	        if (response === '0x')
	            return { data: undefined };
	        return { data: response };
	    }
	    catch (err) {
	        const data = getRevertErrorData(err);
	        const { offchainLookup, offchainLookupSignature } = await Promise.resolve().then(function () { return ccip; });
	        if (data?.slice(0, 10) === offchainLookupSignature && to) {
	            return { data: await offchainLookup(client, { data, to }) };
	        }
	        throw getCallError(err, {
	            ...args,
	            account,
	            chain: client.chain,
	        });
	    }
	}
	// We only want to perform a scheduled multicall if:
	// - The request has calldata,
	// - The request has a target address,
	// - The target address is not already the aggregate3 signature,
	// - The request has no other properties (`nonce`, `gas`, etc cannot be sent with a multicall).
	function shouldPerformMulticall({ request }) {
	    const { data, to, ...request_ } = request;
	    if (!data)
	        return false;
	    if (data.startsWith(aggregate3Signature))
	        return false;
	    if (!to)
	        return false;
	    if (Object.values(request_).filter((x) => typeof x !== 'undefined').length > 0)
	        return false;
	    return true;
	}
	async function scheduleMulticall(client, args) {
	    const { batchSize = 1024, wait = 0 } = typeof client.batch?.multicall === 'object' ? client.batch.multicall : {};
	    const { blockNumber, blockTag = 'latest', data, multicallAddress: multicallAddress_, to, } = args;
	    let multicallAddress = multicallAddress_;
	    if (!multicallAddress) {
	        if (!client.chain)
	            throw new ClientChainNotConfiguredError();
	        multicallAddress = getChainContractAddress({
	            blockNumber,
	            chain: client.chain,
	            contract: 'multicall3',
	        });
	    }
	    const blockNumberHex = blockNumber ? numberToHex$1(blockNumber) : undefined;
	    const block = blockNumberHex || blockTag;
	    const { schedule } = createBatchScheduler({
	        id: `${client.uid}.${block}`,
	        wait,
	        shouldSplitBatch(args) {
	            const size = args.reduce((size, { data }) => size + (data.length - 2), 0);
	            return size > batchSize * 2;
	        },
	        fn: async (requests) => {
	            const calls = requests.map((request) => ({
	                allowFailure: true,
	                callData: request.data,
	                target: request.to,
	            }));
	            const calldata = encodeFunctionData({
	                abi: multicall3Abi,
	                args: [calls],
	                functionName: 'aggregate3',
	            });
	            const data = await client.request({
	                method: 'eth_call',
	                params: [
	                    {
	                        data: calldata,
	                        to: multicallAddress,
	                    },
	                    block,
	                ],
	            });
	            return decodeFunctionResult({
	                abi: multicall3Abi,
	                args: [calls],
	                functionName: 'aggregate3',
	                data: data || '0x',
	            });
	        },
	    });
	    const [{ returnData, success }] = await schedule({ data, to });
	    if (!success)
	        throw new RawContractError({ data: returnData });
	    if (returnData === '0x')
	        return { data: undefined };
	    return { data: returnData };
	}
	function getRevertErrorData(err) {
	    if (!(err instanceof BaseError))
	        return undefined;
	    const error = err.walk();
	    return typeof error.data === 'object' ? error.data.data : error.data;
	}

	/**
	 * Calls a read-only function on a contract, and returns the response.
	 *
	 * - Docs: https://viem.sh/docs/contract/readContract.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/contracts/reading-contracts
	 *
	 * A "read-only" function (constant function) on a Solidity contract is denoted by a `view` or `pure` keyword. They can only read the state of the contract, and cannot make any changes to it. Since read-only methods do not change the state of the contract, they do not require any gas to be executed, and can be called by any user without the need to pay for gas.
	 *
	 * Internally, uses a [Public Client](https://viem.sh/docs/clients/public.html) to call the [`call` action](https://viem.sh/docs/actions/public/call.html) with [ABI-encoded `data`](https://viem.sh/docs/contract/encodeFunctionData.html).
	 *
	 * @param client - Client to use
	 * @param parameters - {@link ReadContractParameters}
	 * @returns The response from the contract. Type is inferred. {@link ReadContractReturnType}
	 *
	 * @example
	 * import { createPublicClient, http, parseAbi } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { readContract } from 'viem/contract'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const result = await readContract(client, {
	 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
	 *   abi: parseAbi(['function balanceOf(address) view returns (uint256)']),
	 *   functionName: 'balanceOf',
	 *   args: ['0xA0Cf798816D4b9b9866b5330EEa46a18382f251e'],
	 * })
	 * // 424122n
	 */
	async function readContract(client, { abi, address, args, functionName, ...callRequest }) {
	    const calldata = encodeFunctionData({
	        abi,
	        args,
	        functionName,
	    });
	    try {
	        const { data } = await call$1(client, {
	            data: calldata,
	            to: address,
	            ...callRequest,
	        });
	        return decodeFunctionResult({
	            abi,
	            args,
	            functionName,
	            data: data || '0x',
	        });
	    }
	    catch (err) {
	        throw getContractError(err, {
	            abi: abi,
	            address,
	            args,
	            docsPath: '/docs/contract/readContract',
	            functionName,
	        });
	    }
	}

	/**
	 * Simulates/validates a contract interaction. This is useful for retrieving **return data** and **revert reasons** of contract write functions.
	 *
	 * - Docs: https://viem.sh/docs/contract/simulateContract.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/contracts/writing-to-contracts
	 *
	 * This function does not require gas to execute and _**does not**_ change the state of the blockchain. It is almost identical to [`readContract`](https://viem.sh/docs/contract/readContract.html), but also supports contract write functions.
	 *
	 * Internally, uses a [Public Client](https://viem.sh/docs/clients/public.html) to call the [`call` action](https://viem.sh/docs/actions/public/call.html) with [ABI-encoded `data`](https://viem.sh/docs/contract/encodeFunctionData.html).
	 *
	 * @param client - Client to use
	 * @param parameters - {@link SimulateContractParameters}
	 * @returns The simulation result and write request. {@link SimulateContractReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { simulateContract } from 'viem/contract'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const result = await simulateContract(client, {
	 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
	 *   abi: parseAbi(['function mint(uint32) view returns (uint32)']),
	 *   functionName: 'mint',
	 *   args: ['69420'],
	 *   account: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
	 * })
	 */
	async function simulateContract(client, { abi, address, args, dataSuffix, functionName, ...callRequest }) {
	    const account = callRequest.account
	        ? parseAccount(callRequest.account)
	        : undefined;
	    const calldata = encodeFunctionData({
	        abi,
	        args,
	        functionName,
	    });
	    try {
	        const { data } = await call$1(client, {
	            batch: false,
	            data: `${calldata}${dataSuffix ? dataSuffix.replace('0x', '') : ''}`,
	            to: address,
	            ...callRequest,
	        });
	        const result = decodeFunctionResult({
	            abi,
	            args,
	            functionName,
	            data: data || '0x',
	        });
	        return {
	            result,
	            request: {
	                abi,
	                address,
	                args,
	                dataSuffix,
	                functionName,
	                ...callRequest,
	            },
	        };
	    }
	    catch (err) {
	        throw getContractError(err, {
	            abi: abi,
	            address,
	            args,
	            docsPath: '/docs/contract/simulateContract',
	            functionName,
	            sender: account?.address,
	        });
	    }
	}

	const listenersCache = /*#__PURE__*/ new Map();
	const cleanupCache = /*#__PURE__*/ new Map();
	let callbackCount = 0;
	/**
	 * @description Sets up an observer for a given function. If another function
	 * is set up under the same observer id, the function will only be called once
	 * for both instances of the observer.
	 */
	function observe(observerId, callbacks, fn) {
	    const callbackId = ++callbackCount;
	    const getListeners = () => listenersCache.get(observerId) || [];
	    const unsubscribe = () => {
	        const listeners = getListeners();
	        listenersCache.set(observerId, listeners.filter((cb) => cb.id !== callbackId));
	    };
	    const unwatch = () => {
	        const cleanup = cleanupCache.get(observerId);
	        if (getListeners().length === 1 && cleanup)
	            cleanup();
	        unsubscribe();
	    };
	    const listeners = getListeners();
	    listenersCache.set(observerId, [
	        ...listeners,
	        { id: callbackId, fns: callbacks },
	    ]);
	    if (listeners && listeners.length > 0)
	        return unwatch;
	    const emit = {};
	    for (const key in callbacks) {
	        emit[key] = ((...args) => {
	            const listeners = getListeners();
	            if (listeners.length === 0)
	                return;
	            listeners.forEach((listener) => listener.fns[key]?.(...args));
	        });
	    }
	    const cleanup = fn(emit);
	    if (typeof cleanup === 'function')
	        cleanupCache.set(observerId, cleanup);
	    return unwatch;
	}

	async function wait(time) {
	    return new Promise((res) => setTimeout(res, time));
	}

	/**
	 * @description Polls a function at a specified interval.
	 */
	function poll(fn, { emitOnBegin, initialWaitTime, interval }) {
	    let active = true;
	    const unwatch = () => (active = false);
	    const watch = async () => {
	        let data;
	        if (emitOnBegin)
	            data = await fn({ unpoll: unwatch });
	        const initialWait = (await initialWaitTime?.(data)) ?? interval;
	        await wait(initialWait);
	        const poll = async () => {
	            if (!active)
	                return;
	            await fn({ unpoll: unwatch });
	            await wait(interval);
	            poll();
	        };
	        poll();
	    };
	    watch();
	    return unwatch;
	}

	const promiseCache = /*#__PURE__*/ new Map();
	const responseCache = /*#__PURE__*/ new Map();
	function getCache(cacheKey) {
	    const buildCache = (cacheKey, cache) => ({
	        clear: () => cache.delete(cacheKey),
	        get: () => cache.get(cacheKey),
	        set: (data) => cache.set(cacheKey, data),
	    });
	    const promise = buildCache(cacheKey, promiseCache);
	    const response = buildCache(cacheKey, responseCache);
	    return {
	        clear: () => {
	            promise.clear();
	            response.clear();
	        },
	        promise,
	        response,
	    };
	}
	/**
	 * @description Returns the result of a given promise, and caches the result for
	 * subsequent invocations against a provided cache key.
	 */
	async function withCache(fn, { cacheKey, cacheTime = Infinity }) {
	    const cache = getCache(cacheKey);
	    // If a response exists in the cache, and it's not expired, return it
	    // and do not invoke the promise.
	    // If the max age is 0, the cache is disabled.
	    const response = cache.response.get();
	    if (response && cacheTime > 0) {
	        const age = new Date().getTime() - response.created.getTime();
	        if (age < cacheTime)
	            return response.data;
	    }
	    let promise = cache.promise.get();
	    if (!promise) {
	        promise = fn();
	        // Store the promise in the cache so that subsequent invocations
	        // will wait for the same promise to resolve (deduping).
	        cache.promise.set(promise);
	    }
	    try {
	        const data = await promise;
	        // Store the response in the cache so that subsequent invocations
	        // will return the same response.
	        cache.response.set({ created: new Date(), data });
	        return data;
	    }
	    finally {
	        // Clear the promise cache so that subsequent invocations will
	        // invoke the promise again.
	        cache.promise.clear();
	    }
	}

	const cacheKey = (id) => `blockNumber.${id}`;
	/**
	 * Returns the number of the most recent block seen.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getBlockNumber.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/blocks/fetching-blocks
	 * - JSON-RPC Methods: [`eth_blockNumber`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_blocknumber)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetBlockNumberParameters}
	 * @returns The number of the block. {@link GetBlockNumberReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getBlockNumber } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const blockNumber = await getBlockNumber(client)
	 * // 69420n
	 */
	async function getBlockNumber(client, { cacheTime = client.cacheTime, maxAge } = {}) {
	    const blockNumberHex = await withCache(() => client.request({
	        method: 'eth_blockNumber',
	    }), { cacheKey: cacheKey(client.uid), cacheTime: maxAge ?? cacheTime });
	    return BigInt(blockNumberHex);
	}

	const docsPath$1 = '/docs/contract/decodeEventLog';
	function decodeEventLog({ abi, data, strict: strict_, topics, }) {
	    const strict = strict_ ?? true;
	    const [signature, ...argTopics] = topics;
	    if (!signature)
	        throw new AbiEventSignatureEmptyTopicsError({
	            docsPath: docsPath$1,
	        });
	    const abiItem = abi.find((x) => x.type === 'event' &&
	        signature === getEventSelector(formatAbiItem(x)));
	    if (!(abiItem && 'name' in abiItem) || abiItem.type !== 'event')
	        throw new AbiEventSignatureNotFoundError(signature, {
	            docsPath: docsPath$1,
	        });
	    const { name, inputs } = abiItem;
	    const isUnnamed = inputs?.some((x) => !('name' in x && x.name));
	    let args = isUnnamed ? [] : {};
	    // Decode topics (indexed args).
	    const indexedInputs = inputs.filter((x) => 'indexed' in x && x.indexed);
	    if (argTopics.length > 0) {
	        for (let i = 0; i < indexedInputs.length; i++) {
	            const param = indexedInputs[i];
	            const topic = argTopics[i];
	            if (!topic)
	                throw new DecodeLogTopicsMismatch({
	                    abiItem,
	                    param: param,
	                });
	            args[param.name || i] = decodeTopic({ param, value: topic });
	        }
	    }
	    // Decode data (non-indexed args).
	    const nonIndexedInputs = inputs.filter((x) => !('indexed' in x && x.indexed));
	    if (nonIndexedInputs.length > 0) {
	        if (data && data !== '0x') {
	            try {
	                const decodedData = decodeAbiParameters(nonIndexedInputs, data);
	                if (decodedData) {
	                    if (isUnnamed)
	                        args = [...args, ...decodedData];
	                    else {
	                        for (let i = 0; i < nonIndexedInputs.length; i++) {
	                            args[nonIndexedInputs[i].name] = decodedData[i];
	                        }
	                    }
	                }
	            }
	            catch (err) {
	                if (strict) {
	                    if (err instanceof AbiDecodingDataSizeTooSmallError)
	                        throw new DecodeLogDataMismatch({
	                            abiItem,
	                            data: err.data,
	                            params: err.params,
	                            size: err.size,
	                        });
	                    throw err;
	                }
	            }
	        }
	        else if (strict) {
	            throw new DecodeLogDataMismatch({
	                abiItem,
	                data: '0x',
	                params: nonIndexedInputs,
	                size: 0,
	            });
	        }
	    }
	    return {
	        eventName: name,
	        args: Object.values(args).length > 0 ? args : undefined,
	    };
	}
	function decodeTopic({ param, value }) {
	    if (param.type === 'string' ||
	        param.type === 'bytes' ||
	        param.type === 'tuple' ||
	        param.type.match(/^(.*)\[(\d+)?\]$/))
	        return value;
	    const decodedArg = decodeAbiParameters([param], value) || [];
	    return decodedArg[0];
	}

	/**
	 * Returns a list of logs or hashes based on a [Filter](/docs/glossary/terms#filter) since the last time it was called.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getFilterChanges.html
	 * - JSON-RPC Methods: [`eth_getFilterChanges`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getfilterchanges)
	 *
	 * A Filter can be created from the following actions:
	 *
	 * - [`createBlockFilter`](https://viem.sh/docs/actions/public/createBlockFilter.html)
	 * - [`createContractEventFilter`](https://viem.sh/docs/contract/createContractEventFilter.html)
	 * - [`createEventFilter`](https://viem.sh/docs/actions/public/createEventFilter.html)
	 * - [`createPendingTransactionFilter`](https://viem.sh/docs/actions/public/createPendingTransactionFilter.html)
	 *
	 * Depending on the type of filter, the return value will be different:
	 *
	 * - If the filter was created with `createContractEventFilter` or `createEventFilter`, it returns a list of logs.
	 * - If the filter was created with `createPendingTransactionFilter`, it returns a list of transaction hashes.
	 * - If the filter was created with `createBlockFilter`, it returns a list of block hashes.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetFilterChangesParameters}
	 * @returns Logs or hashes. {@link GetFilterChangesReturnType}
	 *
	 * @example
	 * // Blocks
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { createBlockFilter, getFilterChanges } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const filter = await createBlockFilter(client)
	 * const hashes = await getFilterChanges(client, { filter })
	 *
	 * @example
	 * // Contract Events
	 * import { createPublicClient, http, parseAbi } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { createContractEventFilter, getFilterChanges } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const filter = await createContractEventFilter(client, {
	 *   address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
	 *   abi: parseAbi(['event Transfer(address indexed, address indexed, uint256)']),
	 *   eventName: 'Transfer',
	 * })
	 * const logs = await getFilterChanges(client, { filter })
	 *
	 * @example
	 * // Raw Events
	 * import { createPublicClient, http, parseAbiItem } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { createEventFilter, getFilterChanges } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const filter = await createEventFilter(client, {
	 *   address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
	 *   event: parseAbiItem('event Transfer(address indexed, address indexed, uint256)'),
	 * })
	 * const logs = await getFilterChanges(client, { filter })
	 *
	 * @example
	 * // Transactions
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { createPendingTransactionFilter, getFilterChanges } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const filter = await createPendingTransactionFilter(client)
	 * const hashes = await getFilterChanges(client, { filter })
	 */
	async function getFilterChanges(_client, { filter, }) {
	    const strict = 'strict' in filter && filter.strict;
	    const logs = await filter.request({
	        method: 'eth_getFilterChanges',
	        params: [filter.id],
	    });
	    return logs
	        .map((log) => {
	        if (typeof log === 'string')
	            return log;
	        try {
	            const { eventName, args } = 'abi' in filter && filter.abi
	                ? decodeEventLog({
	                    abi: filter.abi,
	                    data: log.data,
	                    topics: log.topics,
	                    strict,
	                })
	                : { eventName: undefined, args: undefined };
	            return formatLog(log, { args, eventName });
	        }
	        catch (err) {
	            let eventName;
	            let isUnnamed;
	            if (err instanceof DecodeLogDataMismatch ||
	                err instanceof DecodeLogTopicsMismatch) {
	                // If strict mode is on, and log data/topics do not match event definition, skip.
	                if ('strict' in filter && filter.strict)
	                    return;
	                eventName = err.abiItem.name;
	                isUnnamed = err.abiItem.inputs?.some((x) => !('name' in x && x.name));
	            }
	            // Set args undefined if there is an error decoding (e.g. indexed/non-indexed params mismatch).
	            return formatLog(log, { args: isUnnamed ? [] : {}, eventName });
	        }
	    })
	        .filter(Boolean);
	}

	/**
	 * Returns a list of event logs matching the provided parameters.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getLogs.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/filters-and-logs/event-logs
	 * - JSON-RPC Methods: [`eth_getLogs`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getlogs)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetLogsParameters}
	 * @returns A list of event logs. {@link GetLogsReturnType}
	 *
	 * @example
	 * import { createPublicClient, http, parseAbiItem } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getLogs } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const logs = await getLogs(client)
	 */
	async function getLogs(client, { address, blockHash, fromBlock, toBlock, event, events: events_, args, strict: strict_, } = {}) {
	    const strict = strict_ ?? false;
	    const events = events_ ?? (event ? [event] : undefined);
	    let topics = [];
	    if (events) {
	        topics = [
	            events.flatMap((event) => encodeEventTopics({
	                abi: [event],
	                eventName: event.name,
	                args,
	            })),
	        ];
	        if (event)
	            topics = topics[0];
	    }
	    let logs;
	    if (blockHash) {
	        logs = await client.request({
	            method: 'eth_getLogs',
	            params: [{ address, topics, blockHash }],
	        });
	    }
	    else {
	        logs = await client.request({
	            method: 'eth_getLogs',
	            params: [
	                {
	                    address,
	                    topics,
	                    fromBlock: typeof fromBlock === 'bigint' ? numberToHex$1(fromBlock) : fromBlock,
	                    toBlock: typeof toBlock === 'bigint' ? numberToHex$1(toBlock) : toBlock,
	                },
	            ],
	        });
	    }
	    return logs
	        .map((log) => {
	        try {
	            const { eventName, args } = events
	                ? decodeEventLog({
	                    abi: events,
	                    data: log.data,
	                    topics: log.topics,
	                    strict,
	                })
	                : { eventName: undefined, args: undefined };
	            return formatLog(log, { args, eventName: eventName });
	        }
	        catch (err) {
	            let eventName;
	            let isUnnamed;
	            if (err instanceof DecodeLogDataMismatch ||
	                err instanceof DecodeLogTopicsMismatch) {
	                // If strict mode is on, and log data/topics do not match event definition, skip.
	                if (strict)
	                    return;
	                eventName = err.abiItem.name;
	                isUnnamed = err.abiItem.inputs?.some((x) => !('name' in x && x.name));
	            }
	            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
	            return formatLog(log, { args: isUnnamed ? [] : {}, eventName });
	        }
	    })
	        .filter(Boolean);
	}

	/**
	 * Destroys a [`Filter`](https://viem.sh/docs/glossary/types.html#filter).
	 *
	 * - Docs: https://viem.sh/docs/actions/public/uninstallFilter.html
	 * - JSON-RPC Methods: [`eth_uninstallFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_uninstallFilter)
	 *
	 * Destroys a Filter that was created from one of the following Actions:
	 * - [`createBlockFilter`](https://viem.sh/docs/actions/public/createBlockFilter.html)
	 * - [`createEventFilter`](https://viem.sh/docs/actions/public/createEventFilter.html)
	 * - [`createPendingTransactionFilter`](https://viem.sh/docs/actions/public/createPendingTransactionFilter.html)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link UninstallFilterParameters}
	 * @returns A boolean indicating if the Filter was successfully uninstalled. {@link UninstallFilterReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { createPendingTransactionFilter, uninstallFilter } from 'viem/public'
	 *
	 * const filter = await createPendingTransactionFilter(client)
	 * const uninstalled = await uninstallFilter(client, { filter })
	 * // true
	 */
	async function uninstallFilter(_client, { filter }) {
	    return filter.request({
	        method: 'eth_uninstallFilter',
	        params: [filter.id],
	    });
	}

	/**
	 * Watches and returns emitted contract event logs.
	 *
	 * - Docs: https://viem.sh/docs/contract/watchContractEvent.html
	 *
	 * This Action will batch up all the event logs found within the [`pollingInterval`](https://viem.sh/docs/contract/watchContractEvent.html#pollinginterval-optional), and invoke them via [`onLogs`](https://viem.sh/docs/contract/watchContractEvent.html#onLogs).
	 *
	 * `watchContractEvent` will attempt to create an [Event Filter](https://viem.sh/docs/contract/createContractEventFilter.html) and listen to changes to the Filter per polling interval, however, if the RPC Provider does not support Filters (e.g. `eth_newFilter`), then `watchContractEvent` will fall back to using [`getLogs`](https://viem.sh/docs/actions/public/getLogs) instead.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link WatchContractEventParameters}
	 * @returns A function that can be invoked to stop watching for new event logs. {@link WatchContractEventReturnType}
	 *
	 * @example
	 * import { createPublicClient, http, parseAbi } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { watchContractEvent } from 'viem/contract'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const unwatch = watchContractEvent(client, {
	 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
	 *   abi: parseAbi(['event Transfer(address indexed from, address indexed to, uint256 value)']),
	 *   eventName: 'Transfer',
	 *   args: { from: '0xc961145a54C96E3aE9bAA048c4F4D6b04C13916b' },
	 *   onLogs: (logs) => console.log(logs),
	 * })
	 */
	function watchContractEvent(client, { abi, address, args, batch = true, eventName, onError, onLogs, pollingInterval = client.pollingInterval, strict: strict_, }) {
	    const observerId = stringify$3([
	        'watchContractEvent',
	        address,
	        args,
	        batch,
	        client.uid,
	        eventName,
	        pollingInterval,
	    ]);
	    const strict = strict_ ?? false;
	    return observe(observerId, { onLogs, onError }, (emit) => {
	        let previousBlockNumber;
	        let filter;
	        let initialized = false;
	        const unwatch = poll(async () => {
	            if (!initialized) {
	                try {
	                    filter = (await createContractEventFilter(client, {
	                        abi,
	                        address,
	                        args,
	                        eventName,
	                        strict,
	                    }));
	                }
	                catch { }
	                initialized = true;
	                return;
	            }
	            try {
	                let logs;
	                if (filter) {
	                    logs = await getFilterChanges(client, { filter });
	                }
	                else {
	                    // If the filter doesn't exist, we will fall back to use `getLogs`.
	                    // The fall back exists because some RPC Providers do not support filters.
	                    // Fetch the block number to use for `getLogs`.
	                    const blockNumber = await getBlockNumber(client);
	                    // If the block number has changed, we will need to fetch the logs.
	                    // If the block number doesn't exist, we are yet to reach the first poll interval,
	                    // so do not emit any logs.
	                    if (previousBlockNumber && previousBlockNumber !== blockNumber) {
	                        logs = await getLogs(client, {
	                            address,
	                            args,
	                            fromBlock: previousBlockNumber + 1n,
	                            toBlock: blockNumber,
	                            event: getAbiItem({
	                                abi,
	                                name: eventName,
	                            }),
	                        });
	                    }
	                    else {
	                        logs = [];
	                    }
	                    previousBlockNumber = blockNumber;
	                }
	                if (logs.length === 0)
	                    return;
	                if (batch)
	                    emit.onLogs(logs);
	                else
	                    logs.forEach((log) => emit.onLogs([log]));
	            }
	            catch (err) {
	                // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
	                // Reinitalize the filter when this occurs
	                if (filter && err instanceof InvalidInputRpcError)
	                    initialized = false;
	                emit.onError?.(err);
	            }
	        }, {
	            emitOnBegin: true,
	            interval: pollingInterval,
	        });
	        return async () => {
	            if (filter)
	                await uninstallFilter(client, { filter });
	            unwatch();
	        };
	    });
	}

	function getTransactionError(err, { docsPath, ...args }) {
	    let cause = err;
	    if (containsNodeError(err))
	        cause = getNodeError(err, args);
	    return new TransactionExecutionError(cause, {
	        docsPath,
	        ...args,
	    });
	}

	/**
	 * Returns the chain ID associated with the current network.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getChainId.html
	 * - JSON-RPC Methods: [`eth_chainId`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_chainid)
	 *
	 * @param client - Client to use
	 * @returns The current chain ID. {@link GetChainIdReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getChainId } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const chainId = await getChainId(client)
	 * // 1
	 */
	async function getChainId(client) {
	    const chainIdHex = await client.request({
	        method: 'eth_chainId',
	    });
	    return hexToNumber$2(chainIdHex);
	}

	/**
	 * Creates, signs, and sends a new transaction to the network.
	 *
	 * - Docs: https://viem.sh/docs/actions/wallet/sendTransaction.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/transactions/sending-transactions
	 * - JSON-RPC Methods:
	 *   - JSON-RPC Accounts: [`eth_sendTransaction`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_sendtransaction)
	 *   - Local Accounts: [`eth_sendRawTransaction`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_sendrawtransaction)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link SendTransactionParameters}
	 * @returns The [Transaction](https://viem.sh/docs/glossary/terms.html#transaction) hash. {@link SendTransactionReturnType}
	 *
	 * @example
	 * import { createWalletClient, custom } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { sendTransaction } from 'viem/wallet'
	 *
	 * const client = createWalletClient({
	 *   chain: mainnet,
	 *   transport: custom(window.ethereum),
	 * })
	 * const hash = await sendTransaction(client, {
	 *   account: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
	 *   to: '0x70997970c51812dc3a010c7d01b50e0d17dc79c8',
	 *   value: 1000000000000000000n,
	 * })
	 *
	 * @example
	 * // Account Hoisting
	 * import { createWalletClient, http } from 'viem'
	 * import { privateKeyToAccount } from 'viem/accounts'
	 * import { mainnet } from 'viem/chains'
	 * import { sendTransaction } from 'viem/wallet'
	 *
	 * const client = createWalletClient({
	 *   account: privateKeyToAccount('0x…'),
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const hash = await sendTransaction(client, {
	 *   to: '0x70997970c51812dc3a010c7d01b50e0d17dc79c8',
	 *   value: 1000000000000000000n,
	 * })
	 */
	async function sendTransaction(client, args) {
	    const { account: account_ = client.account, chain = client.chain, accessList, data, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, to, value, ...rest } = args;
	    if (!account_)
	        throw new AccountNotFoundError({
	            docsPath: '/docs/actions/wallet/sendTransaction',
	        });
	    const account = parseAccount(account_);
	    try {
	        assertRequest(args);
	        let chainId;
	        if (chain !== null) {
	            chainId = await getChainId(client);
	            assertCurrentChain({
	                currentChainId: chainId,
	                chain,
	            });
	        }
	        if (account.type === 'local') {
	            // Prepare the request for signing (assign appropriate fees, etc.)
	            const request = await prepareRequest(client, {
	                account,
	                accessList,
	                chain,
	                data,
	                gas,
	                gasPrice,
	                maxFeePerGas,
	                maxPriorityFeePerGas,
	                nonce,
	                to,
	                value,
	                ...rest,
	            });
	            if (!chainId)
	                chainId = await getChainId(client);
	            const serializer = chain?.serializers?.transaction;
	            const signedRequest = (await account.signTransaction({
	                ...request,
	                chainId,
	            }, { serializer }));
	            return await client.request({
	                method: 'eth_sendRawTransaction',
	                params: [signedRequest],
	            });
	        }
	        const format = chain?.formatters?.transactionRequest?.format || formatTransactionRequest;
	        const request = format({
	            // Pick out extra data that might exist on the chain's transaction request type.
	            ...extract(rest, { format }),
	            accessList,
	            data,
	            from: account.address,
	            gas,
	            gasPrice,
	            maxFeePerGas,
	            maxPriorityFeePerGas,
	            nonce,
	            to,
	            value,
	        });
	        return await client.request({
	            method: 'eth_sendTransaction',
	            params: [request],
	        });
	    }
	    catch (err) {
	        throw getTransactionError(err, {
	            ...args,
	            account,
	            chain: args.chain || undefined,
	        });
	    }
	}

	/**
	 * Executes a write function on a contract.
	 *
	 * - Docs: https://viem.sh/docs/contract/writeContract.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/contracts/writing-to-contracts
	 *
	 * A "write" function on a Solidity contract modifies the state of the blockchain. These types of functions require gas to be executed, and hence a [Transaction](https://viem.sh/docs/glossary/terms.html) is needed to be broadcast in order to change the state.
	 *
	 * Internally, uses a [Wallet Client](https://viem.sh/docs/clients/wallet.html) to call the [`sendTransaction` action](https://viem.sh/docs/actions/wallet/sendTransaction.html) with [ABI-encoded `data`](https://viem.sh/docs/contract/encodeFunctionData.html).
	 *
	 * __Warning: The `write` internally sends a transaction – it does not validate if the contract write will succeed (the contract may throw an error). It is highly recommended to [simulate the contract write with `contract.simulate`](https://viem.sh/docs/contract/writeContract.html#usage) before you execute it.__
	 *
	 * @param client - Client to use
	 * @param parameters - {@link WriteContractParameters}
	 * @returns A [Transaction Hash](https://viem.sh/docs/glossary/terms.html#hash). {@link WriteContractReturnType}
	 *
	 * @example
	 * import { createWalletClient, custom, parseAbi } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { writeContract } from 'viem/contract'
	 *
	 * const client = createWalletClient({
	 *   chain: mainnet,
	 *   transport: custom(window.ethereum),
	 * })
	 * const hash = await writeContract(client, {
	 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
	 *   abi: parseAbi(['function mint(uint32 tokenId) nonpayable']),
	 *   functionName: 'mint',
	 *   args: [69420],
	 * })
	 *
	 * @example
	 * // With Validation
	 * import { createWalletClient, http, parseAbi } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { simulateContract, writeContract } from 'viem/contract'
	 *
	 * const client = createWalletClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const { request } = await simulateContract(client, {
	 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
	 *   abi: parseAbi(['function mint(uint32 tokenId) nonpayable']),
	 *   functionName: 'mint',
	 *   args: [69420],
	 * }
	 * const hash = await writeContract(client, request)
	 */
	async function writeContract(client, { abi, address, args, dataSuffix, functionName, ...request }) {
	    const data = encodeFunctionData({
	        abi,
	        args,
	        functionName,
	    });
	    const hash = await sendTransaction(client, {
	        data: `${data}${dataSuffix ? dataSuffix.replace('0x', '') : ''}`,
	        to: address,
	        ...request,
	    });
	    return hash;
	}

	/**
	 * Adds an EVM chain to the wallet.
	 *
	 * - Docs: https://viem.sh/docs/actions/wallet/addChain.html
	 * - JSON-RPC Methods: [`eth_addEthereumChain`](https://eips.ethereum.org/EIPS/eip-3085)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link AddChainParameters}
	 *
	 * @example
	 * import { createWalletClient, custom } from 'viem'
	 * import { optimism } from 'viem/chains'
	 * import { addChain } from 'viem/wallet'
	 *
	 * const client = createWalletClient({
	 *   transport: custom(window.ethereum),
	 * })
	 * await addChain(client, { chain: optimism })
	 */
	async function addChain(client, { chain }) {
	    const { id, name, nativeCurrency, rpcUrls, blockExplorers } = chain;
	    await client.request({
	        method: 'wallet_addEthereumChain',
	        params: [
	            {
	                chainId: numberToHex$1(id),
	                chainName: name,
	                nativeCurrency,
	                rpcUrls: rpcUrls.default.http,
	                blockExplorerUrls: blockExplorers
	                    ? Object.values(blockExplorers).map(({ url }) => url)
	                    : undefined,
	            },
	        ],
	    });
	}

	const size$1 = 256;
	let index$4 = size$1;
	let buffer$1;
	function uid(length = 11) {
	    if (!buffer$1 || index$4 + length > size$1 * 2) {
	        buffer$1 = '';
	        index$4 = 0;
	        for (let i = 0; i < size$1; i++) {
	            buffer$1 += ((256 + Math.random() * 256) | 0).toString(16).substring(1);
	        }
	    }
	    return buffer$1.substring(index$4, index$4++ + length);
	}

	function createClient(parameters) {
	    const { batch, cacheTime = parameters.pollingInterval ?? 4000, key = 'base', name = 'Base Client', pollingInterval = 4000, type = 'base', } = parameters;
	    const chain = parameters.chain;
	    const account = parameters.account
	        ? parseAccount(parameters.account)
	        : undefined;
	    const { config, request, value } = parameters.transport({
	        chain,
	        pollingInterval,
	    });
	    const transport = { ...config, ...value };
	    const client = {
	        account,
	        batch,
	        cacheTime,
	        chain,
	        key,
	        name,
	        pollingInterval,
	        request,
	        transport,
	        type,
	        uid: uid(),
	    };
	    function extend(base) {
	        return (extendFn) => {
	            const extended = extendFn(base);
	            for (const key in client)
	                delete extended[key];
	            const combined = { ...base, ...extended };
	            return Object.assign(combined, { extend: extend(combined) });
	        };
	    }
	    return Object.assign(client, { extend: extend(client) });
	}

	function withRetry(fn, { delay: delay_ = 100, retryCount = 2, shouldRetry = () => true, } = {}) {
	    return new Promise((resolve, reject) => {
	        const attemptRetry = async ({ count = 0 } = {}) => {
	            const retry = async ({ error }) => {
	                const delay = typeof delay_ === 'function' ? delay_({ count, error }) : delay_;
	                if (delay)
	                    await wait(delay);
	                attemptRetry({ count: count + 1 });
	            };
	            try {
	                const data = await fn();
	                resolve(data);
	            }
	            catch (err) {
	                if (count < retryCount &&
	                    (await shouldRetry({ count, error: err })))
	                    return retry({ error: err });
	                reject(err);
	            }
	        };
	        attemptRetry();
	    });
	}

	const isDeterministicError = (error) => {
	    if ('code' in error)
	        return (error.code !== -1 &&
	            error.code !== -32004 &&
	            error.code !== -32005 &&
	            error.code !== -32042 &&
	            error.code !== -32603);
	    if (error instanceof HttpRequestError && error.status)
	        return (error.status !== 403 &&
	            error.status !== 408 &&
	            error.status !== 413 &&
	            error.status !== 429 &&
	            error.status !== 500 &&
	            error.status !== 502 &&
	            error.status !== 503 &&
	            error.status !== 504);
	    return false;
	};
	function buildRequest(request, { retryDelay = 150, retryCount = 3, } = {}) {
	    return (async (args) => withRetry(async () => {
	        try {
	            return await request(args);
	        }
	        catch (err_) {
	            const err = err_;
	            switch (err.code) {
	                // -32700
	                case ParseRpcError.code:
	                    throw new ParseRpcError(err);
	                // -32600
	                case InvalidRequestRpcError.code:
	                    throw new InvalidRequestRpcError(err);
	                // -32601
	                case MethodNotFoundRpcError.code:
	                    throw new MethodNotFoundRpcError(err);
	                // -32602
	                case InvalidParamsRpcError.code:
	                    throw new InvalidParamsRpcError(err);
	                // -32603
	                case InternalRpcError.code:
	                    throw new InternalRpcError(err);
	                // -32000
	                case InvalidInputRpcError.code:
	                    throw new InvalidInputRpcError(err);
	                // -32001
	                case ResourceNotFoundRpcError.code:
	                    throw new ResourceNotFoundRpcError(err);
	                // -32002
	                case ResourceUnavailableRpcError.code:
	                    throw new ResourceUnavailableRpcError(err);
	                // -32003
	                case TransactionRejectedRpcError.code:
	                    throw new TransactionRejectedRpcError(err);
	                // -32004
	                case MethodNotSupportedRpcError.code:
	                    throw new MethodNotSupportedRpcError(err);
	                // -32005
	                case LimitExceededRpcError.code:
	                    throw new LimitExceededRpcError(err);
	                // -32006
	                case JsonRpcVersionUnsupportedError.code:
	                    throw new JsonRpcVersionUnsupportedError(err);
	                // 4001
	                case UserRejectedRequestError.code:
	                    throw new UserRejectedRequestError(err);
	                // 4100
	                case UnauthorizedProviderError.code:
	                    throw new UnauthorizedProviderError(err);
	                // 4200
	                case UnsupportedProviderMethodError.code:
	                    throw new UnsupportedProviderMethodError(err);
	                // 4900
	                case ProviderDisconnectedError.code:
	                    throw new ProviderDisconnectedError(err);
	                // 4901
	                case ChainDisconnectedError.code:
	                    throw new ChainDisconnectedError(err);
	                // 4902
	                case SwitchChainError.code:
	                    throw new SwitchChainError(err);
	                default:
	                    if (err_ instanceof BaseError)
	                        throw err_;
	                    throw new UnknownRpcError(err);
	            }
	        }
	    }, {
	        delay: ({ count, error }) => {
	            // If we find a Retry-After header, let's retry after the given time.
	            if (error && error instanceof HttpRequestError) {
	                const retryAfter = error?.headers?.get('Retry-After');
	                if (retryAfter?.match(/\d/))
	                    return parseInt(retryAfter) * 1000;
	            }
	            // Otherwise, let's retry with an exponential backoff.
	            return ~~(1 << count) * retryDelay;
	        },
	        retryCount,
	        shouldRetry: ({ error }) => !isDeterministicError(error),
	    }));
	}

	/**
	 * @description Creates an transport intended to be used with a client.
	 */
	function createTransport({ key, name, request, retryCount = 3, retryDelay = 150, timeout, type, }, value) {
	    return {
	        config: { key, name, request, retryCount, retryDelay, timeout, type },
	        request: buildRequest(request, { retryCount, retryDelay }),
	        value,
	    };
	}

	/**
	 * @description Creates a custom transport given an EIP-1193 compliant `request` attribute.
	 */
	function custom(provider, config = {}) {
	    const { key = 'custom', name = 'Custom Provider', retryDelay } = config;
	    return ({ retryCount: defaultRetryCount }) => createTransport({
	        key,
	        name,
	        request: provider.request.bind(provider),
	        retryCount: config.retryCount ?? defaultRetryCount,
	        retryDelay,
	        type: 'custom',
	    });
	}

	function fallback(transports_, config = {}) {
	    const { key = 'fallback', name = 'Fallback', rank = false, retryCount, retryDelay, } = config;
	    return ({ chain, pollingInterval = 4000, timeout }) => {
	        let transports = transports_;
	        let onResponse = () => { };
	        const transport = createTransport({
	            key,
	            name,
	            async request({ method, params }) {
	                const fetch = async (i = 0) => {
	                    const transport = transports[i]({ chain, retryCount: 0, timeout });
	                    try {
	                        const response = await transport.request({
	                            method,
	                            params,
	                        });
	                        onResponse({
	                            method,
	                            params: params,
	                            response,
	                            transport,
	                            status: 'success',
	                        });
	                        return response;
	                    }
	                    catch (err) {
	                        onResponse({
	                            error: err,
	                            method,
	                            params: params,
	                            transport,
	                            status: 'error',
	                        });
	                        // If the error is deterministic, we don't need to fall back.
	                        // So throw the error.
	                        if (isDeterministicError(err))
	                            throw err;
	                        // If we've reached the end of the fallbacks, throw the error.
	                        if (i === transports.length - 1)
	                            throw err;
	                        // Otherwise, try the next fallback.
	                        return fetch(i + 1);
	                    }
	                };
	                return fetch();
	            },
	            retryCount,
	            retryDelay,
	            type: 'fallback',
	        }, {
	            onResponse: (fn) => (onResponse = fn),
	            transports: transports.map((fn) => fn({ chain, retryCount: 0 })),
	        });
	        if (rank) {
	            const rankOptions = (typeof rank === 'object' ? rank : {});
	            rankTransports({
	                chain,
	                interval: rankOptions.interval ?? pollingInterval,
	                onTransports: (transports_) => (transports = transports_),
	                sampleCount: rankOptions.sampleCount,
	                timeout: rankOptions.timeout,
	                transports,
	                weights: rankOptions.weights,
	            });
	        }
	        return transport;
	    };
	}
	function rankTransports({ chain, interval = 4000, onTransports, sampleCount = 10, timeout = 1000, transports, weights = {}, }) {
	    const { stability: stabilityWeight = 0.7, latency: latencyWeight = 0.3 } = weights;
	    const samples = [];
	    const rankTransports_ = async () => {
	        // 1. Take a sample from each Transport.
	        const sample = await Promise.all(transports.map(async (transport) => {
	            const transport_ = transport({ chain, retryCount: 0, timeout });
	            const start = Date.now();
	            let end;
	            let success;
	            try {
	                await transport_.request({ method: 'net_listening' });
	                success = 1;
	            }
	            catch {
	                success = 0;
	            }
	            finally {
	                end = Date.now();
	            }
	            const latency = end - start;
	            return { latency, success };
	        }));
	        // 2. Store the sample. If we have more than `sampleCount` samples, remove
	        // the oldest sample.
	        samples.push(sample);
	        if (samples.length > sampleCount)
	            samples.shift();
	        // 3. Calculate the max latency from samples.
	        const maxLatency = Math.max(...samples.map((sample) => Math.max(...sample.map(({ latency }) => latency))));
	        // 4. Calculate the score for each Transport.
	        const scores = transports
	            .map((_, i) => {
	            const latencies = samples.map((sample) => sample[i].latency);
	            const meanLatency = latencies.reduce((acc, latency) => acc + latency, 0) /
	                latencies.length;
	            const latencyScore = 1 - meanLatency / maxLatency;
	            const successes = samples.map((sample) => sample[i].success);
	            const stabilityScore = successes.reduce((acc, success) => acc + success, 0) /
	                successes.length;
	            if (stabilityScore === 0)
	                return [0, i];
	            return [
	                latencyWeight * latencyScore + stabilityWeight * stabilityScore,
	                i,
	            ];
	        })
	            .sort((a, b) => b[0] - a[0]);
	        // 5. Sort the Transports by score.
	        onTransports(scores.map(([, i]) => transports[i]));
	        // 6. Wait, and then rank again.
	        await wait(interval);
	        rankTransports_();
	    };
	    rankTransports_();
	}

	class UrlRequiredError extends BaseError {
	    constructor() {
	        super('No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.', {
	            docsPath: '/docs/clients/intro',
	        });
	    }
	}

	function withTimeout$2(fn, { errorInstance, timeout, signal, }) {
	    return new Promise((resolve, reject) => {
	        (async () => {
	            let timeoutId;
	            try {
	                const controller = new AbortController();
	                if (timeout > 0) {
	                    timeoutId = setTimeout(() => {
	                        if (signal) {
	                            controller.abort();
	                        }
	                        else {
	                            reject(errorInstance);
	                        }
	                    }, timeout);
	                }
	                resolve(await fn({ signal: controller?.signal }));
	            }
	            catch (err) {
	                if (err.name === 'AbortError')
	                    reject(errorInstance);
	                reject(err);
	            }
	            finally {
	                clearTimeout(timeoutId);
	            }
	        })();
	    });
	}

	let id$1 = 0;
	async function http$1(url, { body, fetchOptions = {}, timeout = 10000 }) {
	    const { headers, method, signal: signal_ } = fetchOptions;
	    try {
	        const response = await withTimeout$2(async ({ signal }) => {
	            const response = await fetch(url, {
	                ...fetchOptions,
	                body: Array.isArray(body)
	                    ? stringify$3(body.map((body) => ({
	                        jsonrpc: '2.0',
	                        id: id$1++,
	                        ...body,
	                    })))
	                    : stringify$3({ jsonrpc: '2.0', id: id$1++, ...body }),
	                headers: {
	                    ...headers,
	                    'Content-Type': 'application/json',
	                },
	                method: method || 'POST',
	                signal: signal_ || (timeout > 0 ? signal : undefined),
	            });
	            return response;
	        }, {
	            errorInstance: new TimeoutError$1({ body, url }),
	            timeout,
	            signal: true,
	        });
	        let data;
	        if (response.headers.get('Content-Type')?.startsWith('application/json')) {
	            data = await response.json();
	        }
	        else {
	            data = await response.text();
	        }
	        if (!response.ok) {
	            throw new HttpRequestError({
	                body,
	                details: stringify$3(data.error) || response.statusText,
	                headers: response.headers,
	                status: response.status,
	                url,
	            });
	        }
	        return data;
	    }
	    catch (err) {
	        if (err instanceof HttpRequestError)
	            throw err;
	        if (err instanceof TimeoutError$1)
	            throw err;
	        throw new HttpRequestError({
	            body,
	            details: err.message,
	            url,
	        });
	    }
	}
	const sockets = /*#__PURE__*/ new Map();
	async function getSocket(url_) {
	    const url = new URL(url_);
	    const urlKey = url.toString();
	    let socket = sockets.get(urlKey);
	    // If the socket already exists, return it.
	    if (socket)
	        return socket;
	    const { schedule } = createBatchScheduler({
	        id: urlKey,
	        fn: async () => {
	            let WebSocket = await Promise.resolve().then(function () { return browser$5; });
	            // Workaround for Vite.
	            // https://github.com/vitejs/vite/issues/9703
	            // TODO: Remove when issue is resolved.
	            if (WebSocket.default
	                ?.constructor)
	                WebSocket = WebSocket
	                    .default;
	            else
	                WebSocket = WebSocket.WebSocket;
	            const webSocket = new WebSocket(url);
	            // Set up a cache for incoming "synchronous" requests.
	            const requests = new Map();
	            // Set up a cache for subscriptions (eth_subscribe).
	            const subscriptions = new Map();
	            const onMessage = ({ data }) => {
	                const message = JSON.parse(data);
	                const isSubscription = message.method === 'eth_subscription';
	                const id = isSubscription ? message.params.subscription : message.id;
	                const cache = isSubscription ? subscriptions : requests;
	                const callback = cache.get(id);
	                if (callback)
	                    callback({ data });
	                if (!isSubscription)
	                    cache.delete(id);
	            };
	            const onClose = () => {
	                sockets.delete(urlKey);
	                webSocket.removeEventListener('close', onClose);
	                webSocket.removeEventListener('message', onMessage);
	            };
	            // Setup event listeners for RPC & subscription responses.
	            webSocket.addEventListener('close', onClose);
	            webSocket.addEventListener('message', onMessage);
	            // Wait for the socket to open.
	            if (webSocket.readyState === WebSocket.CONNECTING) {
	                await new Promise((resolve, reject) => {
	                    if (!webSocket)
	                        return;
	                    webSocket.onopen = resolve;
	                    webSocket.onerror = reject;
	                });
	            }
	            // Create a new socket instance.
	            socket = Object.assign(webSocket, {
	                requests,
	                subscriptions,
	            });
	            sockets.set(urlKey, socket);
	            return [socket];
	        },
	    });
	    const [_, [socket_]] = await schedule();
	    return socket_;
	}
	function webSocket$1(socket, { body, onResponse }) {
	    if (socket.readyState === socket.CLOSED ||
	        socket.readyState === socket.CLOSING)
	        throw new WebSocketRequestError({
	            body,
	            url: socket.url,
	            details: 'Socket is closed.',
	        });
	    const id_ = id$1++;
	    const callback = ({ data }) => {
	        const message = JSON.parse(data);
	        if (typeof message.id === 'number' && id_ !== message.id)
	            return;
	        onResponse?.(message);
	        // If we are subscribing to a topic, we want to set up a listener for incoming
	        // messages.
	        if (body.method === 'eth_subscribe' && typeof message.result === 'string') {
	            socket.subscriptions.set(message.result, callback);
	        }
	        // If we are unsubscribing from a topic, we want to remove the listener.
	        if (body.method === 'eth_unsubscribe') {
	            socket.subscriptions.delete(body.params?.[0]);
	        }
	    };
	    socket.requests.set(id_, callback);
	    socket.send(JSON.stringify({ jsonrpc: '2.0', ...body, id: id_ }));
	    return socket;
	}
	async function webSocketAsync(socket, { body, timeout = 10000 }) {
	    return withTimeout$2(() => new Promise((onResponse) => rpc$1.webSocket(socket, {
	        body,
	        onResponse,
	    })), {
	        errorInstance: new TimeoutError$1({ body, url: socket.url }),
	        timeout,
	    });
	}
	///////////////////////////////////////////////////
	const rpc$1 = {
	    http: http$1,
	    webSocket: webSocket$1,
	    webSocketAsync,
	};

	/**
	 * @description Creates a HTTP transport that connects to a JSON-RPC API.
	 */
	function http(
	/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */
	url, config = {}) {
	    const { batch, fetchOptions, key = 'http', name = 'HTTP JSON-RPC', retryDelay, } = config;
	    return ({ chain, retryCount: retryCount_, timeout: timeout_ }) => {
	        const { batchSize = 1000, wait = 0 } = typeof batch === 'object' ? batch : {};
	        const retryCount = config.retryCount ?? retryCount_;
	        const timeout = timeout_ ?? config.timeout ?? 10000;
	        const url_ = url || chain?.rpcUrls.default.http[0];
	        if (!url_)
	            throw new UrlRequiredError();
	        return createTransport({
	            key,
	            name,
	            async request({ method, params }) {
	                const body = { method, params };
	                const { schedule } = createBatchScheduler({
	                    id: `${url}`,
	                    wait,
	                    shouldSplitBatch(requests) {
	                        return requests.length > batchSize;
	                    },
	                    fn: (body) => rpc$1.http(url_, {
	                        body,
	                        fetchOptions,
	                        timeout,
	                    }),
	                });
	                const fn = async (body) => batch
	                    ? schedule(body)
	                    : [await rpc$1.http(url_, { body, fetchOptions, timeout })];
	                const [{ error, result }] = await fn(body);
	                if (error)
	                    throw new RpcRequestError({
	                        body,
	                        error,
	                        url: url_,
	                    });
	                return result;
	            },
	            retryCount,
	            retryDelay,
	            timeout,
	            type: 'http',
	        }, {
	            url,
	        });
	    };
	}

	/*
	 * @description Checks if error is a valid null result UniversalResolver error
	 */
	function isNullUniversalResolverError(err, callType) {
	    if (!(err instanceof BaseError))
	        return false;
	    const cause = err.walk((e) => e instanceof ContractFunctionRevertedError);
	    if (!(cause instanceof ContractFunctionRevertedError))
	        return false;
	    if (cause.data?.errorName === 'ResolverNotFound')
	        return true;
	    if (cause.data?.errorName === 'ResolverWildcardNotSupported')
	        return true;
	    // Backwards compatibility for older UniversalResolver contracts
	    if (cause.reason?.includes('Wildcard on non-extended resolvers is not supported'))
	        return true;
	    // No primary name set for address.
	    if (callType === 'reverse' && cause.reason === panicReasons[50])
	        return true;
	    return false;
	}

	class OffchainLookupError extends BaseError {
	    constructor({ callbackSelector, cause, data, extraData, sender, urls, }) {
	        super(cause.shortMessage ||
	            'An error occurred while fetching for an offchain result.', {
	            cause,
	            metaMessages: [
	                ...(cause.metaMessages || []),
	                cause.metaMessages?.length ? '' : [],
	                'Offchain Gateway Call:',
	                urls && [
	                    '  Gateway URL(s):',
	                    ...urls.map((url) => `    ${getUrl(url)}`),
	                ],
	                `  Sender: ${sender}`,
	                `  Data: ${data}`,
	                `  Callback selector: ${callbackSelector}`,
	                `  Extra data: ${extraData}`,
	            ].flat(),
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'OffchainLookupError'
	        });
	    }
	}
	class OffchainLookupResponseMalformedError extends BaseError {
	    constructor({ result, url }) {
	        super('Offchain gateway response is malformed. Response data must be a hex value.', {
	            metaMessages: [
	                `Gateway URL: ${getUrl(url)}`,
	                `Response: ${stringify$3(result)}`,
	            ],
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'OffchainLookupResponseMalformedError'
	        });
	    }
	}
	class OffchainLookupSenderMismatchError extends BaseError {
	    constructor({ sender, to }) {
	        super('Reverted sender address does not match target contract address (`to`).', {
	            metaMessages: [
	                `Contract address: ${to}`,
	                `OffchainLookup sender address: ${sender}`,
	            ],
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'OffchainLookupSenderMismatchError'
	        });
	    }
	}

	function isAddressEqual(a, b) {
	    if (!isAddress(a))
	        throw new InvalidAddressError({ address: a });
	    if (!isAddress(b))
	        throw new InvalidAddressError({ address: b });
	    return a.toLowerCase() === b.toLowerCase();
	}

	const offchainLookupSignature = '0x556f1830';
	const offchainLookupAbiItem = {
	    name: 'OffchainLookup',
	    type: 'error',
	    inputs: [
	        {
	            name: 'sender',
	            type: 'address',
	        },
	        {
	            name: 'urls',
	            type: 'string[]',
	        },
	        {
	            name: 'callData',
	            type: 'bytes',
	        },
	        {
	            name: 'callbackFunction',
	            type: 'bytes4',
	        },
	        {
	            name: 'extraData',
	            type: 'bytes',
	        },
	    ],
	};
	async function offchainLookup(client, { blockNumber, blockTag, data, to, }) {
	    const { args } = decodeErrorResult({
	        data,
	        abi: [offchainLookupAbiItem],
	    });
	    const [sender, urls, callData, callbackSelector, extraData] = args;
	    try {
	        if (!isAddressEqual(to, sender))
	            throw new OffchainLookupSenderMismatchError({ sender, to });
	        const result = await ccipFetch({ data: callData, sender, urls });
	        const { data: data_ } = await call$1(client, {
	            blockNumber,
	            blockTag,
	            data: concat$4([
	                callbackSelector,
	                encodeAbiParameters([{ type: 'bytes' }, { type: 'bytes' }], [result, extraData]),
	            ]),
	            to,
	        });
	        return data_;
	    }
	    catch (err) {
	        throw new OffchainLookupError({
	            callbackSelector,
	            cause: err,
	            data,
	            extraData,
	            sender,
	            urls,
	        });
	    }
	}
	async function ccipFetch({ data, sender, urls, }) {
	    let error = new Error('An unknown error occurred.');
	    for (let i = 0; i < urls.length; i++) {
	        const url = urls[i];
	        const method = url.includes('{sender}') || url.includes('{data}') ? 'GET' : 'POST';
	        const body = method === 'POST' ? { data, sender } : undefined;
	        try {
	            const response = await fetch(url.replace('{sender}', sender).replace('{data}', data), {
	                body: JSON.stringify(body),
	                method,
	            });
	            let result;
	            if (response.headers.get('Content-Type')?.startsWith('application/json')) {
	                result = (await response.json()).data;
	            }
	            else {
	                result = (await response.text());
	            }
	            if (!response.ok) {
	                error = new HttpRequestError({
	                    body,
	                    details: stringify$3(result.error) || response.statusText,
	                    headers: response.headers,
	                    status: response.status,
	                    url,
	                });
	                continue;
	            }
	            if (!isHex(result)) {
	                error = new OffchainLookupResponseMalformedError({
	                    result,
	                    url,
	                });
	                continue;
	            }
	            return result;
	        }
	        catch (err) {
	            error = new HttpRequestError({
	                body,
	                details: err.message,
	                url,
	            });
	        }
	    }
	    throw error;
	}

	var ccip = /*#__PURE__*/Object.freeze({
		__proto__: null,
		ccipFetch: ccipFetch,
		offchainLookup: offchainLookup,
		offchainLookupAbiItem: offchainLookupAbiItem,
		offchainLookupSignature: offchainLookupSignature
	});

	// `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
	// https://regexr.com/6va55
	const bytesRegex = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
	// `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
	// https://regexr.com/6v8hp
	const integerRegex = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;

	function validateTypedData({ domain, message, primaryType, types: types_, }) {
	    const types = types_;
	    const validateData = (struct, value_) => {
	        for (const param of struct) {
	            const { name, type: type_ } = param;
	            const type = type_;
	            const value = value_[name];
	            const integerMatch = type.match(integerRegex);
	            if (integerMatch &&
	                (typeof value === 'number' || typeof value === 'bigint')) {
	                const [_type, base, size_] = integerMatch;
	                // If number cannot be cast to a sized hex value, it is out of range
	                // and will throw.
	                numberToHex$1(value, {
	                    signed: base === 'int',
	                    size: parseInt(size_) / 8,
	                });
	            }
	            if (type === 'address' && typeof value === 'string' && !isAddress(value))
	                throw new InvalidAddressError({ address: value });
	            const bytesMatch = type.match(bytesRegex);
	            if (bytesMatch) {
	                const [_type, size_] = bytesMatch;
	                if (size_ && size$2(value) !== parseInt(size_))
	                    throw new BytesSizeMismatchError({
	                        expectedSize: parseInt(size_),
	                        givenSize: size$2(value),
	                    });
	            }
	            const struct = types[type];
	            if (struct)
	                validateData(struct, value);
	        }
	    };
	    // Validate domain types.
	    if (types['EIP712Domain'] && domain)
	        validateData(types['EIP712Domain'], domain);
	    if (primaryType !== 'EIP712Domain') {
	        // Validate message types.
	        const type = types[primaryType];
	        validateData(type, message);
	    }
	}

	const docsPath = '/docs/contract/encodeDeployData';
	function encodeDeployData({ abi, args, bytecode, }) {
	    if (!args || args.length === 0)
	        return bytecode;
	    const description = abi.find((x) => 'type' in x && x.type === 'constructor');
	    if (!description)
	        throw new AbiConstructorNotFoundError({ docsPath });
	    if (!('inputs' in description))
	        throw new AbiConstructorParamsNotFoundError({ docsPath });
	    if (!description.inputs || description.inputs.length === 0)
	        throw new AbiConstructorParamsNotFoundError({ docsPath });
	    const data = encodeAbiParameters(description.inputs, args);
	    return concatHex([bytecode, data]);
	}

	// Implementation forked and adapted from https://github.com/MetaMask/eth-sig-util/blob/main/src/sign-typed-data.ts
	function hashTypedData({ domain: domain_, message, primaryType, types: types_, }) {
	    const domain = typeof domain_ === 'undefined' ? {} : domain_;
	    const types = {
	        EIP712Domain: [
	            typeof domain?.name === 'string' && { name: 'name', type: 'string' },
	            domain?.version && { name: 'version', type: 'string' },
	            typeof domain?.chainId === 'number' && {
	                name: 'chainId',
	                type: 'uint256',
	            },
	            domain?.verifyingContract && {
	                name: 'verifyingContract',
	                type: 'address',
	            },
	            domain?.salt && { name: 'salt', type: 'bytes32' },
	        ].filter(Boolean),
	        ...types_,
	    };
	    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
	    // as we can't statically check this with TypeScript.
	    validateTypedData({
	        domain,
	        message,
	        primaryType,
	        types,
	    });
	    const parts = ['0x1901'];
	    if (domain)
	        parts.push(hashDomain({
	            domain,
	            types: types,
	        }));
	    if (primaryType !== 'EIP712Domain') {
	        parts.push(hashStruct({
	            data: message,
	            primaryType: primaryType,
	            types: types,
	        }));
	    }
	    return keccak256$1(concat$4(parts));
	}
	function hashDomain({ domain, types, }) {
	    return hashStruct({
	        data: domain,
	        primaryType: 'EIP712Domain',
	        types,
	    });
	}
	function hashStruct({ data, primaryType, types, }) {
	    const encoded = encodeData$1({
	        data,
	        primaryType,
	        types,
	    });
	    return keccak256$1(encoded);
	}
	function encodeData$1({ data, primaryType, types, }) {
	    const encodedTypes = [{ type: 'bytes32' }];
	    const encodedValues = [hashType({ primaryType, types })];
	    for (const field of types[primaryType]) {
	        const [type, value] = encodeField({
	            types,
	            name: field.name,
	            type: field.type,
	            value: data[field.name],
	        });
	        encodedTypes.push(type);
	        encodedValues.push(value);
	    }
	    return encodeAbiParameters(encodedTypes, encodedValues);
	}
	function hashType({ primaryType, types, }) {
	    const encodedHashType = toHex$1(encodeType({ primaryType, types }));
	    return keccak256$1(encodedHashType);
	}
	function encodeType({ primaryType, types, }) {
	    let result = '';
	    const unsortedDeps = findTypeDependencies({ primaryType, types });
	    unsortedDeps.delete(primaryType);
	    const deps = [primaryType, ...Array.from(unsortedDeps).sort()];
	    for (const type of deps) {
	        result += `${type}(${types[type]
            .map(({ name, type: t }) => `${t} ${name}`)
            .join(',')})`;
	    }
	    return result;
	}
	function findTypeDependencies({ primaryType: primaryType_, types, }, results = new Set()) {
	    const match = primaryType_.match(/^\w*/u);
	    const primaryType = match?.[0];
	    if (results.has(primaryType) || types[primaryType] === undefined) {
	        return results;
	    }
	    results.add(primaryType);
	    for (const field of types[primaryType]) {
	        findTypeDependencies({ primaryType: field.type, types }, results);
	    }
	    return results;
	}
	function encodeField({ types, name, type, value, }) {
	    if (types[type] !== undefined) {
	        return [
	            { type: 'bytes32' },
	            keccak256$1(encodeData$1({ data: value, primaryType: type, types })),
	        ];
	    }
	    if (type === 'bytes') {
	        const prepend = value.length % 2 ? '0' : '';
	        value = `0x${prepend + value.slice(2)}`;
	        return [{ type: 'bytes32' }, keccak256$1(value)];
	    }
	    if (type === 'string')
	        return [{ type: 'bytes32' }, keccak256$1(toHex$1(value))];
	    if (type.lastIndexOf(']') === type.length - 1) {
	        const parsedType = type.slice(0, type.lastIndexOf('['));
	        const typeValuePairs = value.map((item) => encodeField({
	            name,
	            type: parsedType,
	            types,
	            value: item,
	        }));
	        return [
	            { type: 'bytes32' },
	            keccak256$1(encodeAbiParameters(typeValuePairs.map(([t]) => t), typeValuePairs.map(([, v]) => v))),
	        ];
	    }
	    return [{ type }, value];
	}

	function hashMessage$1(message, to_) {
	    const messageBytes = (() => {
	        if (typeof message === 'string')
	            return stringToBytes$1(message);
	        if (message.raw instanceof Uint8Array)
	            return message.raw;
	        return toBytes$1(message.raw);
	    })();
	    const prefixBytes = stringToBytes$1(`\x19Ethereum Signed Message:\n${messageBytes.length}`);
	    return keccak256$1(concat$4([prefixBytes, messageBytes]), to_);
	}

	function encodedLabelToLabelhash(label) {
	    if (label.length !== 66)
	        return null;
	    if (label.indexOf('[') !== 0)
	        return null;
	    if (label.indexOf(']') !== 65)
	        return null;
	    const hash = `0x${label.slice(1, 65)}`;
	    if (!isHex(hash))
	        return null;
	    return hash;
	}

	/**
	 * @description Hashes ENS name
	 *
	 * - Since ENS names prohibit certain forbidden characters (e.g. underscore) and have other validation rules, you likely want to [normalize ENS names](https://docs.ens.domains/contract-api-reference/name-processing#normalising-names) with [UTS-46 normalization](https://unicode.org/reports/tr46) before passing them to `namehash`. You can use the built-in [`normalize`](https://viem.sh/docs/ens/utilities/normalize.html) function for this.
	 *
	 * @example
	 * namehash('wagmi-dev.eth')
	 * '0xf246651c1b9a6b141d19c2604e9a58f567973833990f830d882534a747801359'
	 *
	 * @link https://eips.ethereum.org/EIPS/eip-137
	 */
	function namehash(name) {
	    let result = new Uint8Array(32).fill(0);
	    if (!name)
	        return bytesToHex$2(result);
	    const labels = name.split('.');
	    // Iterate in reverse order building up hash
	    for (let i = labels.length - 1; i >= 0; i -= 1) {
	        const hashFromEncodedLabel = encodedLabelToLabelhash(labels[i]);
	        const hashed = hashFromEncodedLabel
	            ? toBytes$1(hashFromEncodedLabel)
	            : keccak256$1(stringToBytes$1(labels[i]), 'bytes');
	        result = keccak256$1(concat$4([result, hashed]), 'bytes');
	    }
	    return bytesToHex$2(result);
	}

	function encodeLabelhash(hash) {
	    return `[${hash.slice(2)}]`;
	}

	/**
	 * @description Hashes ENS label
	 *
	 * - Since ENS labels prohibit certain forbidden characters (e.g. underscore) and have other validation rules, you likely want to [normalize ENS labels](https://docs.ens.domains/contract-api-reference/name-processing#normalising-names) with [UTS-46 normalization](https://unicode.org/reports/tr46) before passing them to `labelhash`. You can use the built-in [`normalize`](https://viem.sh/docs/ens/utilities/normalize.html) function for this.
	 *
	 * @example
	 * labelhash('eth')
	 * '0x4f5b812789fc606be1b3b16908db13fc7a9adf7ca72641f84d75b47069d3d7f0'
	 */
	function labelhash(label) {
	    const result = new Uint8Array(32).fill(0);
	    if (!label)
	        return bytesToHex$2(result);
	    return encodedLabelToLabelhash(label) || keccak256$1(stringToBytes$1(label));
	}

	/*
	 * @description Encodes a DNS packet into a ByteArray containing a UDP payload.
	 */
	function packetToBytes(packet) {
	    // strip leading and trailing `.`
	    const value = packet.replace(/^\.|\.$/gm, '');
	    if (value.length === 0)
	        return new Uint8Array(1);
	    const bytes = new Uint8Array(stringToBytes$1(value).byteLength + 2);
	    let offset = 0;
	    const list = value.split('.');
	    for (let i = 0; i < list.length; i++) {
	        let encoded = stringToBytes$1(list[i]);
	        // if the length is > 255, make the encoded label value a labelhash
	        // this is compatible with the universal resolver
	        if (encoded.byteLength > 255)
	            encoded = stringToBytes$1(encodeLabelhash(labelhash(list[i])));
	        bytes[offset] = encoded.length;
	        bytes.set(encoded, offset + 1);
	        offset += encoded.length + 1;
	    }
	    if (bytes.byteLength !== offset + 1)
	        return bytes.slice(0, offset + 1);
	    return bytes;
	}

	/**
	 * Gets address for ENS name.
	 *
	 * - Docs: https://viem.sh/docs/ens/actions/getEnsAddress.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/ens
	 *
	 * Calls `resolve(bytes, bytes)` on ENS Universal Resolver Contract.
	 *
	 * Since ENS names prohibit certain forbidden characters (e.g. underscore) and have other validation rules, you likely want to [normalize ENS names](https://docs.ens.domains/contract-api-reference/name-processing#normalising-names) with [UTS-46 normalization](https://unicode.org/reports/tr46) before passing them to `getEnsAddress`. You can use the built-in [`normalize`](https://viem.sh/docs/ens/utilities/normalize.html) function for this.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetEnsAddressParameters}
	 * @returns Address for ENS name or `null` if not found. {@link GetEnsAddressReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getEnsAddress, normalize } from 'viem/ens'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const ensAddress = await getEnsAddress(client, {
	 *   name: normalize('wagmi-dev.eth'),
	 * })
	 * // '0xd2135CfB216b74109775236E36d4b433F1DF507B'
	 */
	async function getEnsAddress(client, { blockNumber, blockTag, coinType, name, universalResolverAddress: universalResolverAddress_, }) {
	    let universalResolverAddress = universalResolverAddress_;
	    if (!universalResolverAddress) {
	        if (!client.chain)
	            throw new Error('client chain not configured. universalResolverAddress is required.');
	        universalResolverAddress = getChainContractAddress({
	            blockNumber,
	            chain: client.chain,
	            contract: 'ensUniversalResolver',
	        });
	    }
	    try {
	        const functionData = encodeFunctionData({
	            abi: addressResolverAbi,
	            functionName: 'addr',
	            ...(coinType != null
	                ? { args: [namehash(name), BigInt(coinType)] }
	                : { args: [namehash(name)] }),
	        });
	        const res = await readContract(client, {
	            address: universalResolverAddress,
	            abi: universalResolverResolveAbi,
	            functionName: 'resolve',
	            args: [toHex$1(packetToBytes(name)), functionData],
	            blockNumber,
	            blockTag,
	        });
	        if (res[0] === '0x')
	            return null;
	        const address = trim(decodeFunctionResult({
	            abi: addressResolverAbi,
	            args: coinType != null ? [namehash(name), BigInt(coinType)] : undefined,
	            functionName: 'addr',
	            data: res[0],
	        }));
	        if (address === '0x')
	            return null;
	        if (trim(address) === '0x00')
	            return null;
	        return address;
	    }
	    catch (err) {
	        if (isNullUniversalResolverError(err, 'resolve'))
	            return null;
	        throw err;
	    }
	}

	class EnsAvatarInvalidMetadataError extends BaseError {
	    constructor({ data }) {
	        super('Unable to extract image from metadata. The metadata may be malformed or invalid.', {
	            metaMessages: [
	                '- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.',
	                '',
	                `Provided data: ${JSON.stringify(data)}`,
	            ],
	        });
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'EnsAvatarInvalidMetadataError'
	        });
	    }
	}
	class EnsAvatarInvalidNftUriError extends BaseError {
	    constructor({ reason }) {
	        super(`ENS NFT avatar URI is invalid. ${reason}`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'EnsAvatarInvalidNftUriError'
	        });
	    }
	}
	class EnsAvatarUriResolutionError extends BaseError {
	    constructor({ uri }) {
	        super(`Unable to resolve ENS avatar URI "${uri}". The URI may be malformed, invalid, or does not respond with a valid image.`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'EnsAvatarUriResolutionError'
	        });
	    }
	}
	class EnsAvatarUnsupportedNamespaceError extends BaseError {
	    constructor({ namespace }) {
	        super(`ENS NFT avatar namespace "${namespace}" is not supported. Must be "erc721" or "erc1155".`);
	        Object.defineProperty(this, "name", {
	            enumerable: true,
	            configurable: true,
	            writable: true,
	            value: 'EnsAvatarUnsupportedNamespaceError'
	        });
	    }
	}

	const networkRegex = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/;
	const ipfsHashRegex = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/;
	const base64Regex = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/;
	const dataURIRegex = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
	async function isImageUri(uri) {
	    try {
	        const res = await fetch(uri, { method: 'HEAD' });
	        // retrieve content type header to check if content is image
	        if (res.status === 200) {
	            const contentType = res.headers.get('content-type');
	            return contentType?.startsWith('image/');
	        }
	        return false;
	    }
	    catch (error) {
	        // if error is not cors related then fail
	        if (typeof error === 'object' && typeof error.response !== 'undefined') {
	            return false;
	        }
	        // fail in NodeJS, since the error is not cors but any other network issue
	        // rome-ignore lint/suspicious/noPrototypeBuiltins:
	        if (!globalThis.hasOwnProperty('Image'))
	            return false;
	        // in case of cors, use image api to validate if given url is an actual image
	        return new Promise((resolve) => {
	            const img = new Image();
	            img.onload = () => {
	                resolve(true);
	            };
	            img.onerror = () => {
	                resolve(false);
	            };
	            img.src = uri;
	        });
	    }
	}
	function getGateway(custom, defaultGateway) {
	    if (!custom)
	        return defaultGateway;
	    if (custom.endsWith('/'))
	        return custom.slice(0, -1);
	    return custom;
	}
	function resolveAvatarUri({ uri, gatewayUrls, }) {
	    const isEncoded = base64Regex.test(uri);
	    if (isEncoded)
	        return { uri, isOnChain: true, isEncoded };
	    const ipfsGateway = getGateway(gatewayUrls?.ipfs, 'https://ipfs.io');
	    const arweaveGateway = getGateway(gatewayUrls?.arweave, 'https://arweave.net');
	    const networkRegexMatch = uri.match(networkRegex);
	    const { protocol, subpath, target, subtarget = '', } = networkRegexMatch?.groups || {};
	    const isIPNS = protocol === 'ipns:/' || subpath === 'ipns/';
	    const isIPFS = protocol === 'ipfs:/' || subpath === 'ipfs/' || ipfsHashRegex.test(uri);
	    if (uri.startsWith('http') && !isIPNS && !isIPFS) {
	        let replacedUri = uri;
	        if (gatewayUrls?.arweave)
	            replacedUri = uri.replace(/https:\/\/arweave.net/g, gatewayUrls?.arweave);
	        return { uri: replacedUri, isOnChain: false, isEncoded: false };
	    }
	    if ((isIPNS || isIPFS) && target) {
	        return {
	            uri: `${ipfsGateway}/${isIPNS ? 'ipns' : 'ipfs'}/${target}${subtarget}`,
	            isOnChain: false,
	            isEncoded: false,
	        };
	    }
	    else if (protocol === 'ar:/' && target) {
	        return {
	            uri: `${arweaveGateway}/${target}${subtarget || ''}`,
	            isOnChain: false,
	            isEncoded: false,
	        };
	    }
	    let parsedUri = uri.replace(dataURIRegex, '');
	    if (parsedUri.startsWith('<svg')) {
	        // if svg, base64 encode
	        parsedUri = `data:image/svg+xml;base64,${btoa(parsedUri)}`;
	    }
	    if (parsedUri.startsWith('data:') || parsedUri.startsWith('{')) {
	        return {
	            uri: parsedUri,
	            isOnChain: true,
	            isEncoded: false,
	        };
	    }
	    throw new EnsAvatarUriResolutionError({ uri });
	}
	function getJsonImage(data) {
	    // validation check for json data, must include one of theses properties
	    if (typeof data !== 'object' ||
	        (!('image' in data) && !('image_url' in data) && !('image_data' in data))) {
	        throw new EnsAvatarInvalidMetadataError({ data });
	    }
	    return data.image || data.image_url || data.image_data;
	}
	async function getMetadataAvatarUri({ gatewayUrls, uri, }) {
	    try {
	        const res = await fetch(uri).then((res) => res.json());
	        const image = await parseAvatarUri({
	            gatewayUrls,
	            uri: getJsonImage(res),
	        });
	        return image;
	    }
	    catch {
	        throw new EnsAvatarUriResolutionError({ uri });
	    }
	}
	async function parseAvatarUri({ gatewayUrls, uri, }) {
	    const { uri: resolvedURI, isOnChain } = resolveAvatarUri({ uri, gatewayUrls });
	    if (isOnChain)
	        return resolvedURI;
	    // check if resolvedURI is an image, if it is return the url
	    const isImage = await isImageUri(resolvedURI);
	    if (isImage)
	        return resolvedURI;
	    throw new EnsAvatarUriResolutionError({ uri });
	}
	function parseNftUri(uri_) {
	    let uri = uri_;
	    // parse valid nft spec (CAIP-22/CAIP-29)
	    // @see: https://github.com/ChainAgnostic/CAIPs/tree/master/CAIPs
	    if (uri.startsWith('did:nft:')) {
	        // convert DID to CAIP
	        uri = uri.replace('did:nft:', '').replace(/_/g, '/');
	    }
	    const [reference, asset_namespace, tokenID] = uri.split('/');
	    const [eip_namespace, chainID] = reference.split(':');
	    const [erc_namespace, contractAddress] = asset_namespace.split(':');
	    if (!eip_namespace || eip_namespace.toLowerCase() !== 'eip155')
	        throw new EnsAvatarInvalidNftUriError({ reason: 'Only EIP-155 supported' });
	    if (!chainID)
	        throw new EnsAvatarInvalidNftUriError({ reason: 'Chain ID not found' });
	    if (!contractAddress)
	        throw new EnsAvatarInvalidNftUriError({
	            reason: 'Contract address not found',
	        });
	    if (!tokenID)
	        throw new EnsAvatarInvalidNftUriError({ reason: 'Token ID not found' });
	    if (!erc_namespace)
	        throw new EnsAvatarInvalidNftUriError({ reason: 'ERC namespace not found' });
	    return {
	        chainID: parseInt(chainID),
	        namespace: erc_namespace.toLowerCase(),
	        contractAddress: contractAddress,
	        tokenID,
	    };
	}
	async function getNftTokenUri(client, { nft }) {
	    if (nft.namespace === 'erc721') {
	        return readContract(client, {
	            address: nft.contractAddress,
	            abi: [
	                {
	                    name: 'tokenURI',
	                    type: 'function',
	                    stateMutability: 'view',
	                    inputs: [{ name: 'tokenId', type: 'uint256' }],
	                    outputs: [{ name: '', type: 'string' }],
	                },
	            ],
	            functionName: 'tokenURI',
	            args: [BigInt(nft.tokenID)],
	        });
	    }
	    if (nft.namespace === 'erc1155') {
	        return readContract(client, {
	            address: nft.contractAddress,
	            abi: [
	                {
	                    name: 'uri',
	                    type: 'function',
	                    stateMutability: 'view',
	                    inputs: [{ name: '_id', type: 'uint256' }],
	                    outputs: [{ name: '', type: 'string' }],
	                },
	            ],
	            functionName: 'uri',
	            args: [BigInt(nft.tokenID)],
	        });
	    }
	    throw new EnsAvatarUnsupportedNamespaceError({ namespace: nft.namespace });
	}

	async function parseAvatarRecord(client, { gatewayUrls, record, }) {
	    if (/eip155:/i.test(record))
	        return parseNftAvatarUri(client, { gatewayUrls, record });
	    return parseAvatarUri({ uri: record, gatewayUrls });
	}
	async function parseNftAvatarUri(client, { gatewayUrls, record, }) {
	    // parse NFT URI into properties
	    const nft = parseNftUri(record);
	    // fetch tokenURI from the NFT contract
	    const nftUri = await getNftTokenUri(client, { nft });
	    // resolve the URI from the fetched tokenURI
	    const { uri: resolvedNftUri, isOnChain, isEncoded, } = resolveAvatarUri({ uri: nftUri, gatewayUrls });
	    // if the resolved URI is on chain, return the data
	    if (isOnChain &&
	        (resolvedNftUri.includes('data:application/json;base64,') ||
	            resolvedNftUri.startsWith('{'))) {
	        const encodedJson = isEncoded
	            ? // if it is encoded, decode it
	                atob(resolvedNftUri.replace('data:application/json;base64,', ''))
	            : // if it isn't encoded assume it is a JSON string, but it could be anything (it will error if it is)
	                resolvedNftUri;
	        const decoded = JSON.parse(encodedJson);
	        return parseAvatarUri({ uri: getJsonImage(decoded), gatewayUrls });
	    }
	    let uriTokenId = nft.tokenID;
	    if (nft.namespace === 'erc1155')
	        uriTokenId = uriTokenId.replace('0x', '').padStart(64, '0');
	    return getMetadataAvatarUri({
	        gatewayUrls,
	        uri: resolvedNftUri.replace(/(?:0x)?{id}/, uriTokenId),
	    });
	}

	/**
	 * Gets a text record for specified ENS name.
	 *
	 * - Docs: https://viem.sh/docs/ens/actions/getEnsResolver.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/ens
	 *
	 * Calls `resolve(bytes, bytes)` on ENS Universal Resolver Contract.
	 *
	 * Since ENS names prohibit certain forbidden characters (e.g. underscore) and have other validation rules, you likely want to [normalize ENS names](https://docs.ens.domains/contract-api-reference/name-processing#normalising-names) with [UTS-46 normalization](https://unicode.org/reports/tr46) before passing them to `getEnsAddress`. You can use the built-in [`normalize`](https://viem.sh/docs/ens/utilities/normalize.html) function for this.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetEnsTextParameters}
	 * @returns Address for ENS resolver. {@link GetEnsTextReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getEnsText, normalize } from 'viem/ens'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const twitterRecord = await getEnsText(client, {
	 *   name: normalize('wagmi-dev.eth'),
	 *   key: 'com.twitter',
	 * })
	 * // 'wagmi_sh'
	 */
	async function getEnsText(client, { blockNumber, blockTag, name, key, universalResolverAddress: universalResolverAddress_, }) {
	    let universalResolverAddress = universalResolverAddress_;
	    if (!universalResolverAddress) {
	        if (!client.chain)
	            throw new Error('client chain not configured. universalResolverAddress is required.');
	        universalResolverAddress = getChainContractAddress({
	            blockNumber,
	            chain: client.chain,
	            contract: 'ensUniversalResolver',
	        });
	    }
	    try {
	        const res = await readContract(client, {
	            address: universalResolverAddress,
	            abi: universalResolverResolveAbi,
	            functionName: 'resolve',
	            args: [
	                toHex$1(packetToBytes(name)),
	                encodeFunctionData({
	                    abi: textResolverAbi,
	                    functionName: 'text',
	                    args: [namehash(name), key],
	                }),
	            ],
	            blockNumber,
	            blockTag,
	        });
	        if (res[0] === '0x')
	            return null;
	        const record = decodeFunctionResult({
	            abi: textResolverAbi,
	            functionName: 'text',
	            data: res[0],
	        });
	        return record === '' ? null : record;
	    }
	    catch (err) {
	        if (isNullUniversalResolverError(err, 'resolve'))
	            return null;
	        throw err;
	    }
	}

	/**
	 * Gets the avatar of an ENS name.
	 *
	 * - Docs: https://viem.sh/docs/ens/actions/getEnsAvatar.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/ens
	 *
	 * Calls [`getEnsText`](https://viem.sh/docs/ens/actions/getEnsText.html) with `key` set to `'avatar'`.
	 *
	 * Since ENS names prohibit certain forbidden characters (e.g. underscore) and have other validation rules, you likely want to [normalize ENS names](https://docs.ens.domains/contract-api-reference/name-processing#normalising-names) with [UTS-46 normalization](https://unicode.org/reports/tr46) before passing them to `getEnsAddress`. You can use the built-in [`normalize`](https://viem.sh/docs/ens/utilities/normalize.html) function for this.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetEnsAvatarParameters}
	 * @returns Avatar URI or `null` if not found. {@link GetEnsAvatarReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getEnsAvatar, normalize } from 'viem/ens'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const ensAvatar = await getEnsAvatar(client, {
	 *   name: normalize('wagmi-dev.eth'),
	 * })
	 * // 'https://ipfs.io/ipfs/Qma8mnp6xV3J2cRNf3mTth5C8nV11CAnceVinc3y8jSbio'
	 */
	async function getEnsAvatar(client, { blockNumber, blockTag, gatewayUrls, name, universalResolverAddress, }) {
	    const record = await getEnsText(client, {
	        blockNumber,
	        blockTag,
	        key: 'avatar',
	        name,
	        universalResolverAddress,
	    });
	    if (!record)
	        return null;
	    try {
	        return await parseAvatarRecord(client, { record, gatewayUrls });
	    }
	    catch {
	        return null;
	    }
	}

	/**
	 * Gets primary name for specified address.
	 *
	 * - Docs: https://viem.sh/docs/ens/actions/getEnsName.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/ens
	 *
	 * Calls `reverse(bytes)` on ENS Universal Resolver Contract to "reverse resolve" the address to the primary ENS name.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetEnsNameParameters}
	 * @returns Name or `null` if not found. {@link GetEnsNameReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getEnsName } from 'viem/ens'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const ensName = await getEnsName(client, {
	 *   address: '0xd2135CfB216b74109775236E36d4b433F1DF507B',
	 * })
	 * // 'wagmi-dev.eth'
	 */
	async function getEnsName(client, { address, blockNumber, blockTag, universalResolverAddress: universalResolverAddress_, }) {
	    let universalResolverAddress = universalResolverAddress_;
	    if (!universalResolverAddress) {
	        if (!client.chain)
	            throw new Error('client chain not configured. universalResolverAddress is required.');
	        universalResolverAddress = getChainContractAddress({
	            blockNumber,
	            chain: client.chain,
	            contract: 'ensUniversalResolver',
	        });
	    }
	    const reverseNode = `${address.toLowerCase().substring(2)}.addr.reverse`;
	    try {
	        const res = await readContract(client, {
	            address: universalResolverAddress,
	            abi: universalResolverReverseAbi,
	            functionName: 'reverse',
	            args: [toHex$1(packetToBytes(reverseNode))],
	            blockNumber,
	            blockTag,
	        });
	        return res[0];
	    }
	    catch (err) {
	        if (isNullUniversalResolverError(err, 'reverse'))
	            return null;
	        throw err;
	    }
	}

	/**
	 * Gets resolver for ENS name.
	 *
	 * - Docs: https://viem.sh/docs/ens/actions/getEnsResolver.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/ens
	 *
	 * Calls `findResolver(bytes)` on ENS Universal Resolver Contract to retrieve the resolver of an ENS name.
	 *
	 * Since ENS names prohibit certain forbidden characters (e.g. underscore) and have other validation rules, you likely want to [normalize ENS names](https://docs.ens.domains/contract-api-reference/name-processing#normalising-names) with [UTS-46 normalization](https://unicode.org/reports/tr46) before passing them to `getEnsAddress`. You can use the built-in [`normalize`](https://viem.sh/docs/ens/utilities/normalize.html) function for this.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetEnsResolverParameters}
	 * @returns Address for ENS resolver. {@link GetEnsResolverReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getEnsResolver, normalize } from 'viem/ens'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const resolverAddress = await getEnsResolver(client, {
	 *   name: normalize('wagmi-dev.eth'),
	 * })
	 * // '0x4976fb03C32e5B8cfe2b6cCB31c09Ba78EBaBa41'
	 */
	async function getEnsResolver(client, { blockNumber, blockTag, name, universalResolverAddress: universalResolverAddress_, }) {
	    let universalResolverAddress = universalResolverAddress_;
	    if (!universalResolverAddress) {
	        if (!client.chain)
	            throw new Error('client chain not configured. universalResolverAddress is required.');
	        universalResolverAddress = getChainContractAddress({
	            blockNumber,
	            chain: client.chain,
	            contract: 'ensUniversalResolver',
	        });
	    }
	    const [resolverAddress] = await readContract(client, {
	        address: universalResolverAddress,
	        abi: [
	            {
	                inputs: [{ type: 'bytes' }],
	                name: 'findResolver',
	                outputs: [{ type: 'address' }, { type: 'bytes32' }],
	                stateMutability: 'view',
	                type: 'function',
	            },
	        ],
	        functionName: 'findResolver',
	        args: [toHex$1(packetToBytes(name))],
	        blockNumber,
	        blockTag,
	    });
	    return resolverAddress;
	}

	/**
	 * Creates a [`Filter`](https://viem.sh/docs/glossary/types.html#filter) to listen for new block hashes that can be used with [`getFilterChanges`](https://viem.sh/docs/actions/public/getFilterChanges.html).
	 *
	 * - Docs: https://viem.sh/docs/actions/public/createBlockFilter.html
	 * - JSON-RPC Methods: [`eth_newBlockFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_newBlockFilter)
	 *
	 * @param client - Client to use
	 * @returns [`Filter`](https://viem.sh/docs/glossary/types.html#filter). {@link CreateBlockFilterReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { createBlockFilter } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const filter = await createBlockFilter(client)
	 * // { id: "0x345a6572337856574a76364e457a4366", type: 'block' }
	 */
	async function createBlockFilter(client) {
	    const getRequest = createFilterRequestScope(client, {
	        method: 'eth_newBlockFilter',
	    });
	    const id = await client.request({
	        method: 'eth_newBlockFilter',
	    });
	    return { id, request: getRequest(id), type: 'block' };
	}

	/**
	 * Creates a [`Filter`](https://viem.sh/docs/glossary/types.html#filter) to listen for new events that can be used with [`getFilterChanges`](https://viem.sh/docs/actions/public/getFilterChanges.html).
	 *
	 * - Docs: https://viem.sh/docs/actions/public/createEventFilter.html
	 * - JSON-RPC Methods: [`eth_newFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_newfilter)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link CreateEventFilterParameters}
	 * @returns [`Filter`](https://viem.sh/docs/glossary/types.html#filter). {@link CreateEventFilterReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { createEventFilter } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const filter = await createEventFilter(client, {
	 *   address: '0xfba3912ca04dd458c843e2ee08967fc04f3579c2',
	 * })
	 */
	async function createEventFilter(client, { address, args, event, events: events_, fromBlock, strict, toBlock, } = {}) {
	    const events = events_ ?? (event ? [event] : undefined);
	    const getRequest = createFilterRequestScope(client, {
	        method: 'eth_newFilter',
	    });
	    let topics = [];
	    if (events) {
	        topics = [
	            events.flatMap((event) => encodeEventTopics({
	                abi: [event],
	                eventName: event.name,
	                args,
	            })),
	        ];
	        if (event)
	            topics = topics[0];
	    }
	    const id = await client.request({
	        method: 'eth_newFilter',
	        params: [
	            {
	                address,
	                fromBlock: typeof fromBlock === 'bigint' ? numberToHex$1(fromBlock) : fromBlock,
	                toBlock: typeof toBlock === 'bigint' ? numberToHex$1(toBlock) : toBlock,
	                ...(topics.length ? { topics } : {}),
	            },
	        ],
	    });
	    return {
	        abi: events,
	        args,
	        eventName: event ? event.name : undefined,
	        fromBlock,
	        id,
	        request: getRequest(id),
	        strict,
	        toBlock,
	        type: 'event',
	    };
	}

	/**
	 * Creates a Filter to listen for new pending transaction hashes that can be used with [`getFilterChanges`](https://viem.sh/docs/actions/public/getFilterChanges.html).
	 *
	 * - Docs: https://viem.sh/docs/actions/public/createPendingTransactionFilter.html
	 * - JSON-RPC Methods: [`eth_newPendingTransactionFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_newpendingtransactionfilter)
	 *
	 * @param client - Client to use
	 * @returns [`Filter`](https://viem.sh/docs/glossary/types.html#filter). {@link CreateBlockFilterReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { createPendingTransactionFilter } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const filter = await createPendingTransactionFilter(client)
	 * // { id: "0x345a6572337856574a76364e457a4366", type: 'transaction' }
	 */
	async function createPendingTransactionFilter(client) {
	    const getRequest = createFilterRequestScope(client, {
	        method: 'eth_newPendingTransactionFilter',
	    });
	    const id = await client.request({
	        method: 'eth_newPendingTransactionFilter',
	    });
	    return { id, request: getRequest(id), type: 'transaction' };
	}

	/**
	 * Returns the balance of an address in wei.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getBalance.html
	 * - JSON-RPC Methods: [`eth_getBalance`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getbalance)
	 *
	 * You can convert the balance to ether units with [`formatEther`](https://viem.sh/docs/utilities/formatEther.html).
	 *
	 * ```ts
	 * const balance = await getBalance(client, {
	 *   address: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
	 *   blockTag: 'safe'
	 * })
	 * const balanceAsEther = formatEther(balance)
	 * // "6.942"
	 * ```
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetBalanceParameters}
	 * @returns The balance of the address in wei. {@link GetBalanceReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getBalance } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const balance = await getBalance(client, {
	 *   address: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
	 * })
	 * // 10000000000000000000000n (wei)
	 */
	async function getBalance(client, { address, blockNumber, blockTag = 'latest' }) {
	    const blockNumberHex = blockNumber ? numberToHex$1(blockNumber) : undefined;
	    const balance = await client.request({
	        method: 'eth_getBalance',
	        params: [address, blockNumberHex || blockTag],
	    });
	    return BigInt(balance);
	}

	/**
	 * Returns the number of Transactions at a block number, hash, or tag.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getBlockTransactionCount.html
	 * - JSON-RPC Methods:
	 *   - Calls [`eth_getBlockTransactionCountByNumber`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getblocktransactioncountbynumber) for `blockNumber` & `blockTag`.
	 *   - Calls [`eth_getBlockTransactionCountByHash`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getblocktransactioncountbyhash) for `blockHash`.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetBlockTransactionCountParameters}
	 * @returns The block transaction count. {@link GetBlockTransactionCountReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getBlockTransactionCount } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const count = await getBlockTransactionCount(client)
	 */
	async function getBlockTransactionCount(client, { blockHash, blockNumber, blockTag = 'latest', } = {}) {
	    const blockNumberHex = blockNumber !== undefined ? numberToHex$1(blockNumber) : undefined;
	    let count;
	    if (blockHash) {
	        count = await client.request({
	            method: 'eth_getBlockTransactionCountByHash',
	            params: [blockHash],
	        });
	    }
	    else {
	        count = await client.request({
	            method: 'eth_getBlockTransactionCountByNumber',
	            params: [blockNumberHex || blockTag],
	        });
	    }
	    return hexToNumber$2(count);
	}

	/**
	 * Retrieves the bytecode at an address.
	 *
	 * - Docs: https://viem.sh/docs/contract/getBytecode.html
	 * - JSON-RPC Methods: [`eth_getCode`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getcode)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetBytecodeParameters}
	 * @returns The contract's bytecode. {@link GetBytecodeReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getBytecode } from 'viem/contract'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const code = await getBytecode(client, {
	 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
	 * })
	 */
	async function getBytecode(client, { address, blockNumber, blockTag = 'latest' }) {
	    const blockNumberHex = blockNumber !== undefined ? numberToHex$1(blockNumber) : undefined;
	    const hex = await client.request({
	        method: 'eth_getCode',
	        params: [address, blockNumberHex || blockTag],
	    });
	    if (hex === '0x')
	        return undefined;
	    return hex;
	}

	function formatFeeHistory(feeHistory) {
	    return {
	        baseFeePerGas: feeHistory.baseFeePerGas.map((value) => BigInt(value)),
	        gasUsedRatio: feeHistory.gasUsedRatio,
	        oldestBlock: BigInt(feeHistory.oldestBlock),
	        reward: feeHistory.reward?.map((reward) => reward.map((value) => BigInt(value))),
	    };
	}

	/**
	 * Returns a collection of historical gas information.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getFeeHistory.html
	 * - JSON-RPC Methods: [`eth_feeHistory`](https://docs.alchemy.com/reference/eth-feehistory)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetFeeHistoryParameters}
	 * @returns The gas estimate (in wei). {@link GetFeeHistoryReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getFeeHistory } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const feeHistory = await getFeeHistory(client, {
	 *   blockCount: 4,
	 *   rewardPercentiles: [25, 75],
	 * })
	 */
	async function getFeeHistory(client, { blockCount, blockNumber, blockTag = 'latest', rewardPercentiles, }) {
	    const blockNumberHex = blockNumber ? numberToHex$1(blockNumber) : undefined;
	    const feeHistory = await client.request({
	        method: 'eth_feeHistory',
	        params: [
	            numberToHex$1(blockCount),
	            blockNumberHex || blockTag,
	            rewardPercentiles,
	        ],
	    });
	    return formatFeeHistory(feeHistory);
	}

	/**
	 * Returns a list of event logs since the filter was created.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getFilterLogs.html
	 * - JSON-RPC Methods: [`eth_getFilterLogs`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getfilterlogs)
	 *
	 * `getFilterLogs` is only compatible with **event filters**.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetFilterLogsParameters}
	 * @returns A list of event logs. {@link GetFilterLogsReturnType}
	 *
	 * @example
	 * import { createPublicClient, http, parseAbiItem } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { createEventFilter, getFilterLogs } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const filter = await createEventFilter(client, {
	 *   address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
	 *   event: parseAbiItem('event Transfer(address indexed, address indexed, uint256)'),
	 * })
	 * const logs = await getFilterLogs(client, { filter })
	 */
	async function getFilterLogs(_client, { filter, }) {
	    const strict = filter.strict ?? false;
	    const logs = await filter.request({
	        method: 'eth_getFilterLogs',
	        params: [filter.id],
	    });
	    return logs
	        .map((log) => {
	        try {
	            const { eventName, args } = 'abi' in filter && filter.abi
	                ? decodeEventLog({
	                    abi: filter.abi,
	                    data: log.data,
	                    topics: log.topics,
	                    strict,
	                })
	                : { eventName: undefined, args: undefined };
	            return formatLog(log, { args, eventName });
	        }
	        catch (err) {
	            let eventName;
	            let isUnnamed;
	            if (err instanceof DecodeLogDataMismatch ||
	                err instanceof DecodeLogTopicsMismatch) {
	                // If strict mode is on, and log data/topics do not match event definition, skip.
	                if ('strict' in filter && filter.strict)
	                    return;
	                eventName = err.abiItem.name;
	                isUnnamed = err.abiItem.inputs?.some((x) => !('name' in x && x.name));
	            }
	            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
	            return formatLog(log, { args: isUnnamed ? [] : {}, eventName });
	        }
	    })
	        .filter(Boolean);
	}

	/**
	 * Returns the value from a storage slot at a given address.
	 *
	 * - Docs: https://viem.sh/docs/contract/getStorageAt.html
	 * - JSON-RPC Methods: [`eth_getStorageAt`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getstorageat)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetStorageAtParameters}
	 * @returns The value of the storage slot. {@link GetStorageAtReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getStorageAt } from 'viem/contract'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const code = await getStorageAt(client, {
	 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
	 *   slot: toHex(0),
	 * })
	 */
	async function getStorageAt(client, { address, blockNumber, blockTag = 'latest', slot }) {
	    const blockNumberHex = blockNumber !== undefined ? numberToHex$1(blockNumber) : undefined;
	    const data = await client.request({
	        method: 'eth_getStorageAt',
	        params: [address, slot, blockNumberHex || blockTag],
	    });
	    return data;
	}

	/**
	 * Returns information about a [Transaction](https://viem.sh/docs/glossary/terms.html#transaction) given a hash or block identifier.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getTransaction.html
	 * - Example: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/transactions/fetching-transactions
	 * - JSON-RPC Methods: [`eth_getTransactionByHash`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getTransactionByHash)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetTransactionParameters}
	 * @returns The transaction information. {@link GetTransactionReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getTransaction } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const transaction = await getTransaction(client, {
	 *   hash: '0x4ca7ee652d57678f26e887c149ab0735f41de37bcad58c9f6d3ed5824f15b74d',
	 * })
	 */
	async function getTransaction(client, { blockHash, blockNumber, blockTag: blockTag_, hash, index, }) {
	    const blockTag = blockTag_ || 'latest';
	    const blockNumberHex = blockNumber !== undefined ? numberToHex$1(blockNumber) : undefined;
	    let transaction = null;
	    if (hash) {
	        transaction = await client.request({
	            method: 'eth_getTransactionByHash',
	            params: [hash],
	        });
	    }
	    else if (blockHash) {
	        transaction = await client.request({
	            method: 'eth_getTransactionByBlockHashAndIndex',
	            params: [blockHash, numberToHex$1(index)],
	        });
	    }
	    else if (blockNumberHex || blockTag) {
	        transaction = await client.request({
	            method: 'eth_getTransactionByBlockNumberAndIndex',
	            params: [blockNumberHex || blockTag, numberToHex$1(index)],
	        });
	    }
	    if (!transaction)
	        throw new TransactionNotFoundError({
	            blockHash,
	            blockNumber,
	            blockTag,
	            hash,
	            index,
	        });
	    const format = client.chain?.formatters?.transaction?.format || formatTransaction;
	    return format(transaction);
	}

	/**
	 * Returns the number of blocks passed (confirmations) since the transaction was processed on a block.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getTransactionConfirmations.html
	 * - Example: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/transactions/fetching-transactions
	 * - JSON-RPC Methods: [`eth_getTransactionConfirmations`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getTransactionConfirmations)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetTransactionConfirmationsParameters}
	 * @returns The number of blocks passed since the transaction was processed. If confirmations is 0, then the Transaction has not been confirmed & processed yet. {@link GetTransactionConfirmationsReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getTransactionConfirmations } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const confirmations = await getTransactionConfirmations(client, {
	 *   hash: '0x4ca7ee652d57678f26e887c149ab0735f41de37bcad58c9f6d3ed5824f15b74d',
	 * })
	 */
	async function getTransactionConfirmations(client, { hash, transactionReceipt }) {
	    const [blockNumber, transaction] = await Promise.all([
	        getBlockNumber(client),
	        hash ? getTransaction(client, { hash }) : undefined,
	    ]);
	    const transactionBlockNumber = transactionReceipt?.blockNumber || transaction?.blockNumber;
	    if (!transactionBlockNumber)
	        return 0n;
	    return blockNumber - transactionBlockNumber + 1n;
	}

	/**
	 * Returns the [Transaction Receipt](https://viem.sh/docs/glossary/terms.html#transaction-receipt) given a [Transaction](https://viem.sh/docs/glossary/terms.html#transaction) hash.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/getTransactionReceipt.html
	 * - Example: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/transactions/fetching-transactions
	 * - JSON-RPC Methods: [`eth_getTransactionReceipt`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gettransactionreceipt)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link GetTransactionReceiptParameters}
	 * @returns The transaction receipt. {@link GetTransactionReceiptReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getTransactionReceipt } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const transactionReceipt = await getTransactionReceipt(client, {
	 *   hash: '0x4ca7ee652d57678f26e887c149ab0735f41de37bcad58c9f6d3ed5824f15b74d',
	 * })
	 */
	async function getTransactionReceipt(client, { hash }) {
	    const receipt = await client.request({
	        method: 'eth_getTransactionReceipt',
	        params: [hash],
	    });
	    if (!receipt)
	        throw new TransactionReceiptNotFoundError({ hash });
	    const format = client.chain?.formatters?.transactionReceipt?.format ||
	        formatTransactionReceipt;
	    return format(receipt);
	}

	/**
	 * Similar to [`readContract`](https://viem.sh/docs/contract/readContract.html), but batches up multiple functions on a contract in a single RPC call via the [`multicall3` contract](https://github.com/mds1/multicall).
	 *
	 * - Docs: https://viem.sh/docs/contract/multicall.html
	 *
	 * @param client - Client to use
	 * @param parameters - {@link MulticallParameters}
	 * @returns An array of results with accompanying status. {@link MulticallReturnType}
	 *
	 * @example
	 * import { createPublicClient, http, parseAbi } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { multicall } from 'viem/contract'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const abi = parseAbi([
	 *   'function balanceOf(address) view returns (uint256)',
	 *   'function totalSupply() view returns (uint256)',
	 * ])
	 * const results = await multicall(client, {
	 *   contracts: [
	 *     {
	 *       address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
	 *       abi,
	 *       functionName: 'balanceOf',
	 *       args: ['0xA0Cf798816D4b9b9866b5330EEa46a18382f251e'],
	 *     },
	 *     {
	 *       address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
	 *       abi,
	 *       functionName: 'totalSupply',
	 *     },
	 *   ],
	 * })
	 * // [{ result: 424122n, status: 'success' }, { result: 1000000n, status: 'success' }]
	 */
	async function multicall(client, args) {
	    const { allowFailure = true, batchSize: batchSize_, blockNumber, blockTag, contracts: contracts_, multicallAddress: multicallAddress_, } = args;
	    const batchSize = batchSize_ ??
	        ((typeof client.batch?.multicall === 'object' &&
	            client.batch.multicall.batchSize) ||
	            1024);
	    // Fix type cast from `Narrow` in type definition.
	    const contracts = contracts_;
	    let multicallAddress = multicallAddress_;
	    if (!multicallAddress) {
	        if (!client.chain)
	            throw new Error('client chain not configured. multicallAddress is required.');
	        multicallAddress = getChainContractAddress({
	            blockNumber,
	            chain: client.chain,
	            contract: 'multicall3',
	        });
	    }
	    const chunkedCalls = [[]];
	    let currentChunk = 0;
	    let currentChunkSize = 0;
	    for (let i = 0; i < contracts.length; i++) {
	        const { abi, address, args, functionName } = contracts[i];
	        try {
	            const callData = encodeFunctionData({
	                abi,
	                args,
	                functionName,
	            });
	            currentChunkSize += callData.length;
	            if (batchSize > 0 && currentChunkSize > batchSize) {
	                currentChunk++;
	                currentChunkSize = (callData.length - 2) / 2;
	                chunkedCalls[currentChunk] = [];
	            }
	            chunkedCalls[currentChunk] = [
	                ...chunkedCalls[currentChunk],
	                {
	                    allowFailure: true,
	                    callData,
	                    target: address,
	                },
	            ];
	        }
	        catch (err) {
	            const error = getContractError(err, {
	                abi,
	                address,
	                args,
	                docsPath: '/docs/contract/multicall',
	                functionName,
	            });
	            if (!allowFailure)
	                throw error;
	            chunkedCalls[currentChunk] = [
	                ...chunkedCalls[currentChunk],
	                {
	                    allowFailure: true,
	                    callData: '0x',
	                    target: address,
	                },
	            ];
	        }
	    }
	    const results = await Promise.all(chunkedCalls.map((calls) => readContract(client, {
	        abi: multicall3Abi,
	        address: multicallAddress,
	        args: [calls],
	        blockNumber,
	        blockTag,
	        functionName: 'aggregate3',
	    })));
	    return results.flat().map(({ returnData, success }, i) => {
	        const calls = chunkedCalls.flat();
	        const { callData } = calls[i];
	        const { abi, address, functionName, args } = contracts[i];
	        try {
	            if (callData === '0x')
	                throw new AbiDecodingZeroDataError();
	            if (!success)
	                throw new RawContractError({ data: returnData });
	            const result = decodeFunctionResult({
	                abi,
	                args,
	                data: returnData,
	                functionName: functionName,
	            });
	            return allowFailure ? { result, status: 'success' } : result;
	        }
	        catch (err) {
	            const error = getContractError(err, {
	                abi,
	                address,
	                args,
	                docsPath: '/docs/contract/multicall',
	                functionName,
	            });
	            if (!allowFailure)
	                throw error;
	            return { error, result: undefined, status: 'failure' };
	        }
	    });
	}

	const universalSignatureValidatorByteCode = '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';

	/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
	BigInt(0);
	BigInt(1);
	BigInt(2);
	Array.from({ length: 256 }, (v, i) => i.toString(16).padStart(2, '0'));
	function equalBytes(b1, b2) {
	    // We don't care about timing attacks here
	    if (b1.length !== b2.length)
	        return false;
	    for (let i = 0; i < b1.length; i++)
	        if (b1[i] !== b2[i])
	            return false;
	    return true;
	}
	// validate type tests
	// const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
	// const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
	// // Should fail type-check
	// const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
	// const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
	// const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
	// const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

	function isBytesEqual(a_, b_) {
	    const a = isHex(a_) ? toBytes$1(a_) : a_;
	    const b = isHex(b_) ? toBytes$1(b_) : b_;
	    return equalBytes(a, b);
	}

	/**
	 * Verifies a message hash on chain using ERC-6492.
	 *
	 * @param client - Client to use.
	 * @param parameters - {@link VerifyHashParameters}
	 * @returns Whether or not the signature is valid. {@link VerifyHashReturnType}
	 */
	async function verifyHash(client, { address, hash, signature, ...callRequest }) {
	    const signatureHex = isHex(signature) ? signature : toHex$1(signature);
	    try {
	        const { data } = await call$1(client, {
	            data: encodeDeployData({
	                abi: universalSignatureValidatorAbi,
	                args: [address, hash, signatureHex],
	                bytecode: universalSignatureValidatorByteCode,
	            }),
	            ...callRequest,
	        });
	        return isBytesEqual(data ?? '0x0', '0x1');
	    }
	    catch (error) {
	        if (error instanceof CallExecutionError) {
	            // if the execution fails, the signature was not valid and an internal method inside of the validator reverted
	            // this can happen for many reasons, for example if signer can not be recovered from the signature
	            // or if the signature has no valid format
	            return false;
	        }
	        throw error;
	    }
	}

	/**
	 * Verify that a message was signed by the provided address.
	 *
	 * Compatible with Smart Contract Accounts & Externally Owned Accounts via [ERC-6492](https://eips.ethereum.org/EIPS/eip-6492).
	 *
	 * - Docs {@link https://viem.sh/docs/actions/public/verifyMessage.html}
	 *
	 * @param client - Client to use.
	 * @param parameters - {@link VerifyMessageParameters}
	 * @returns Whether or not the signature is valid. {@link VerifyMessageReturnType}
	 */
	async function verifyMessage$1(client, { address, message, signature, ...callRequest }) {
	    const hash = hashMessage$1(message);
	    return verifyHash(client, {
	        address,
	        hash,
	        signature,
	        ...callRequest,
	    });
	}

	/**
	 * Verify that typed data was signed by the provided address.
	 *
	 * - Docs {@link https://viem.sh/docs/actions/public/verifyTypedData.html}
	 *
	 * @param client - Client to use.
	 * @param parameters - {@link VerifyTypedDataParameters}
	 * @returns Whether or not the signature is valid. {@link VerifyTypedDataReturnType}
	 */
	async function verifyTypedData(client, { address, signature, message, primaryType, types, domain, ...callRequest }) {
	    const hash = hashTypedData({ message, primaryType, types, domain });
	    return verifyHash(client, {
	        address,
	        hash,
	        signature,
	        ...callRequest,
	    });
	}

	/**
	 * Watches and returns incoming block numbers.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/watchBlockNumber.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/blocks/watching-blocks
	 * - JSON-RPC Methods:
	 *   - When `poll: true`, calls [`eth_blockNumber`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_blocknumber) on a polling interval.
	 *   - When `poll: false` & WebSocket Transport, uses a WebSocket subscription via [`eth_subscribe`](https://docs.alchemy.com/reference/eth-subscribe-polygon) and the `"newHeads"` event.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link WatchBlockNumberParameters}
	 * @returns A function that can be invoked to stop watching for new block numbers. {@link WatchBlockNumberReturnType}
	 *
	 * @example
	 * import { createPublicClient, watchBlockNumber, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const unwatch = watchBlockNumber(client, {
	 *   onBlockNumber: (blockNumber) => console.log(blockNumber),
	 * })
	 */
	function watchBlockNumber(client, { emitOnBegin = false, emitMissed = false, onBlockNumber, onError, poll: poll_, pollingInterval = client.pollingInterval, }) {
	    const enablePolling = typeof poll_ !== 'undefined' ? poll_ : client.transport.type !== 'webSocket';
	    let prevBlockNumber;
	    const pollBlockNumber = () => {
	        const observerId = stringify$3([
	            'watchBlockNumber',
	            client.uid,
	            emitOnBegin,
	            emitMissed,
	            pollingInterval,
	        ]);
	        return observe(observerId, { onBlockNumber, onError }, (emit) => poll(async () => {
	            try {
	                const blockNumber = await getBlockNumber(client, { cacheTime: 0 });
	                if (prevBlockNumber) {
	                    // If the current block number is the same as the previous,
	                    // we can skip.
	                    if (blockNumber === prevBlockNumber)
	                        return;
	                    // If we have missed out on some previous blocks, and the
	                    // `emitMissed` flag is truthy, let's emit those blocks.
	                    if (blockNumber - prevBlockNumber > 1 && emitMissed) {
	                        for (let i = prevBlockNumber + 1n; i < blockNumber; i++) {
	                            emit.onBlockNumber(i, prevBlockNumber);
	                            prevBlockNumber = i;
	                        }
	                    }
	                }
	                // If the next block number is greater than the previous,
	                // it is not in the past, and we can emit the new block number.
	                if (!prevBlockNumber || blockNumber > prevBlockNumber) {
	                    emit.onBlockNumber(blockNumber, prevBlockNumber);
	                    prevBlockNumber = blockNumber;
	                }
	            }
	            catch (err) {
	                emit.onError?.(err);
	            }
	        }, {
	            emitOnBegin,
	            interval: pollingInterval,
	        }));
	    };
	    const subscribeBlockNumber = () => {
	        let active = true;
	        let unsubscribe = () => (active = false);
	        (async () => {
	            try {
	                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
	                    params: ['newHeads'],
	                    onData(data) {
	                        if (!active)
	                            return;
	                        const blockNumber = hexToBigInt$1(data.result?.number);
	                        onBlockNumber(blockNumber, prevBlockNumber);
	                        prevBlockNumber = blockNumber;
	                    },
	                    onError(error) {
	                        onError?.(error);
	                    },
	                });
	                unsubscribe = unsubscribe_;
	                if (!active)
	                    unsubscribe();
	            }
	            catch (err) {
	                onError?.(err);
	            }
	        })();
	        return unsubscribe;
	    };
	    return enablePolling ? pollBlockNumber() : subscribeBlockNumber();
	}

	/**
	 * Waits for the [Transaction](https://viem.sh/docs/glossary/terms.html#transaction) to be included on a [Block](https://viem.sh/docs/glossary/terms.html#block) (one confirmation), and then returns the [Transaction Receipt](https://viem.sh/docs/glossary/terms.html#transaction-receipt). If the Transaction reverts, then the action will throw an error.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/waitForTransactionReceipt.html
	 * - Example: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/transactions/sending-transactions
	 * - JSON-RPC Methods:
	 *   - Polls [`eth_getTransactionReceipt`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getTransactionReceipt) on each block until it has been processed.
	 *   - If a Transaction has been replaced:
	 *     - Calls [`eth_getBlockByNumber`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getblockbynumber) and extracts the transactions
	 *     - Checks if one of the Transactions is a replacement
	 *     - If so, calls [`eth_getTransactionReceipt`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getTransactionReceipt).
	 *
	 * The `waitForTransactionReceipt` action additionally supports Replacement detection (e.g. sped up Transactions).
	 *
	 * Transactions can be replaced when a user modifies their transaction in their wallet (to speed up or cancel). Transactions are replaced when they are sent from the same nonce.
	 *
	 * There are 3 types of Transaction Replacement reasons:
	 *
	 * - `repriced`: The gas price has been modified (e.g. different `maxFeePerGas`)
	 * - `cancelled`: The Transaction has been cancelled (e.g. `value === 0n`)
	 * - `replaced`: The Transaction has been replaced (e.g. different `value` or `data`)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link WaitForTransactionReceiptParameters}
	 * @returns The transaction receipt. {@link WaitForTransactionReceiptReturnType}
	 *
	 * @example
	 * import { createPublicClient, waitForTransactionReceipt, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const transactionReceipt = await waitForTransactionReceipt(client, {
	 *   hash: '0x4ca7ee652d57678f26e887c149ab0735f41de37bcad58c9f6d3ed5824f15b74d',
	 * })
	 */
	async function waitForTransactionReceipt(client, { confirmations = 1, hash, onReplaced, pollingInterval = client.pollingInterval, timeout, }) {
	    const observerId = stringify$3(['waitForTransactionReceipt', client.uid, hash]);
	    let transaction;
	    let replacedTransaction;
	    let receipt;
	    let retrying = false;
	    return new Promise((resolve, reject) => {
	        if (timeout)
	            setTimeout(() => reject(new WaitForTransactionReceiptTimeoutError({ hash })), timeout);
	        const _unobserve = observe(observerId, { onReplaced, resolve, reject }, (emit) => {
	            const _unwatch = watchBlockNumber(client, {
	                emitMissed: true,
	                emitOnBegin: true,
	                poll: true,
	                pollingInterval,
	                async onBlockNumber(blockNumber_) {
	                    if (retrying)
	                        return;
	                    let blockNumber = blockNumber_;
	                    const done = (fn) => {
	                        _unwatch();
	                        fn();
	                        _unobserve();
	                    };
	                    try {
	                        // If we already have a valid receipt, let's check if we have enough
	                        // confirmations. If we do, then we can resolve.
	                        if (receipt) {
	                            if (blockNumber - receipt.blockNumber + 1n < confirmations)
	                                return;
	                            done(() => emit.resolve(receipt));
	                            return;
	                        }
	                        // Get the transaction to check if it's been replaced.
	                        // We need to retry as some RPC Providers may be slow to sync
	                        // up mined transactions.
	                        if (!transaction) {
	                            retrying = true;
	                            await withRetry(async () => {
	                                transaction = await getTransaction(client, { hash });
	                                if (transaction.blockNumber)
	                                    blockNumber = transaction.blockNumber;
	                            }, {
	                                // exponential backoff
	                                delay: ({ count }) => ~~(1 << count) * 200,
	                                retryCount: 6,
	                            });
	                            retrying = false;
	                        }
	                        // Get the receipt to check if it's been processed.
	                        receipt = await getTransactionReceipt(client, { hash });
	                        // Check if we have enough confirmations. If not, continue polling.
	                        if (confirmations > 0 &&
	                            blockNumber - receipt.blockNumber + 1n < confirmations)
	                            return;
	                        done(() => emit.resolve(receipt));
	                    }
	                    catch (err) {
	                        // If the receipt is not found, the transaction will be pending.
	                        // We need to check if it has potentially been replaced.
	                        if (transaction &&
	                            (err instanceof TransactionNotFoundError ||
	                                err instanceof TransactionReceiptNotFoundError)) {
	                            replacedTransaction = transaction;
	                            // Let's retrieve the transactions from the current block.
	                            const block = await getBlock(client, {
	                                blockNumber,
	                                includeTransactions: true,
	                            });
	                            const replacementTransaction = block.transactions.find(({ from, nonce }) => from === replacedTransaction.from &&
	                                nonce === replacedTransaction.nonce);
	                            // If we couldn't find a replacement transaction, continue polling.
	                            if (!replacementTransaction)
	                                return;
	                            // If we found a replacement transaction, return it's receipt.
	                            receipt = await getTransactionReceipt(client, {
	                                hash: replacementTransaction.hash,
	                            });
	                            // Check if we have enough confirmations. If not, continue polling.
	                            if (blockNumber - receipt.blockNumber + 1n < confirmations)
	                                return;
	                            let reason = 'replaced';
	                            if (replacementTransaction.to === replacedTransaction.to &&
	                                replacementTransaction.value === replacedTransaction.value) {
	                                reason = 'repriced';
	                            }
	                            else if (replacementTransaction.from === replacementTransaction.to &&
	                                replacementTransaction.value === 0n) {
	                                reason = 'cancelled';
	                            }
	                            done(() => {
	                                emit.onReplaced?.({
	                                    reason,
	                                    replacedTransaction: replacedTransaction,
	                                    transaction: replacementTransaction,
	                                    transactionReceipt: receipt,
	                                });
	                                emit.resolve(receipt);
	                            });
	                        }
	                        else {
	                            done(() => emit.reject(err));
	                        }
	                    }
	                },
	            });
	        });
	    });
	}

	/**
	 * Watches and returns information for incoming blocks.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/watchBlocks.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/blocks/watching-blocks
	 * - JSON-RPC Methods:
	 *   - When `poll: true`, calls [`eth_getBlockByNumber`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getBlockByNumber) on a polling interval.
	 *   - When `poll: false` & WebSocket Transport, uses a WebSocket subscription via [`eth_subscribe`](https://docs.alchemy.com/reference/eth-subscribe-polygon) and the `"newHeads"` event.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link WatchBlocksParameters}
	 * @returns A function that can be invoked to stop watching for new block numbers. {@link WatchBlocksReturnType}
	 *
	 * @example
	 * import { createPublicClient, watchBlocks, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const unwatch = watchBlocks(client, {
	 *   onBlock: (block) => console.log(block),
	 * })
	 */
	function watchBlocks(client, { blockTag = 'latest', emitMissed = false, emitOnBegin = false, onBlock, onError, includeTransactions: includeTransactions_, poll: poll_, pollingInterval = client.pollingInterval, }) {
	    const enablePolling = typeof poll_ !== 'undefined' ? poll_ : client.transport.type !== 'webSocket';
	    const includeTransactions = includeTransactions_ ?? false;
	    let prevBlock;
	    const pollBlocks = () => {
	        const observerId = stringify$3([
	            'watchBlocks',
	            client.uid,
	            emitMissed,
	            emitOnBegin,
	            includeTransactions,
	            pollingInterval,
	        ]);
	        return observe(observerId, { onBlock, onError }, (emit) => poll(async () => {
	            try {
	                const block = await getBlock(client, {
	                    blockTag,
	                    includeTransactions,
	                });
	                if (block.number && prevBlock?.number) {
	                    // If the current block number is the same as the previous,
	                    // we can skip.
	                    if (block.number === prevBlock.number)
	                        return;
	                    // If we have missed out on some previous blocks, and the
	                    // `emitMissed` flag is truthy, let's emit those blocks.
	                    if (block.number - prevBlock.number > 1 && emitMissed) {
	                        for (let i = prevBlock?.number + 1n; i < block.number; i++) {
	                            const block = await getBlock(client, {
	                                blockNumber: i,
	                                includeTransactions,
	                            });
	                            emit.onBlock(block, prevBlock);
	                            prevBlock = block;
	                        }
	                    }
	                }
	                if (
	                // If no previous block exists, emit.
	                !prevBlock?.number ||
	                    // If the block tag is "pending" with no block number, emit.
	                    (blockTag === 'pending' && !block?.number) ||
	                    // If the next block number is greater than the previous block number, emit.
	                    // We don't want to emit blocks in the past.
	                    (block.number && block.number > prevBlock.number)) {
	                    emit.onBlock(block, prevBlock);
	                    prevBlock = block;
	                }
	            }
	            catch (err) {
	                emit.onError?.(err);
	            }
	        }, {
	            emitOnBegin,
	            interval: pollingInterval,
	        }));
	    };
	    const subscribeBlocks = () => {
	        let active = true;
	        let unsubscribe = () => (active = false);
	        (async () => {
	            try {
	                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
	                    params: ['newHeads'],
	                    onData(data) {
	                        if (!active)
	                            return;
	                        const format = client.chain?.formatters?.block?.format || formatBlock;
	                        const block = format(data.result);
	                        onBlock(block, prevBlock);
	                        prevBlock = block;
	                    },
	                    onError(error) {
	                        onError?.(error);
	                    },
	                });
	                unsubscribe = unsubscribe_;
	                if (!active)
	                    unsubscribe();
	            }
	            catch (err) {
	                onError?.(err);
	            }
	        })();
	        return unsubscribe;
	    };
	    return enablePolling ? pollBlocks() : subscribeBlocks();
	}

	/**
	 * Watches and returns emitted [Event Logs](https://viem.sh/docs/glossary/terms.html#event-log).
	 *
	 * - Docs: https://viem.sh/docs/actions/public/watchEvent.html
	 * - JSON-RPC Methods:
	 *   - **RPC Provider supports `eth_newFilter`:**
	 *     - Calls [`eth_newFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_newfilter) to create a filter (called on initialize).
	 *     - On a polling interval, it will call [`eth_getFilterChanges`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getfilterchanges).
	 *   - **RPC Provider does not support `eth_newFilter`:**
	 *     - Calls [`eth_getLogs`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getlogs) for each block between the polling interval.
	 *
	 * This Action will batch up all the Event Logs found within the [`pollingInterval`](https://viem.sh/docs/actions/public/watchEvent.html#pollinginterval-optional), and invoke them via [`onLogs`](https://viem.sh/docs/actions/public/watchEvent.html#onLogs).
	 *
	 * `watchEvent` will attempt to create an [Event Filter](https://viem.sh/docs/actions/public/createEventFilter.html) and listen to changes to the Filter per polling interval, however, if the RPC Provider does not support Filters (e.g. `eth_newFilter`), then `watchEvent` will fall back to using [`getLogs`](https://viem.sh/docs/actions/public/getLogs.html) instead.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link WatchEventParameters}
	 * @returns A function that can be invoked to stop watching for new Event Logs. {@link WatchEventReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { watchEvent } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const unwatch = watchEvent(client, {
	 *   onLogs: (logs) => console.log(logs),
	 * })
	 */
	function watchEvent(client, { address, args, batch = true, event, events, onError, onLogs, pollingInterval = client.pollingInterval, strict: strict_, }) {
	    const observerId = stringify$3([
	        'watchEvent',
	        address,
	        args,
	        batch,
	        client.uid,
	        event,
	        pollingInterval,
	    ]);
	    const strict = strict_ ?? false;
	    return observe(observerId, { onLogs, onError }, (emit) => {
	        let previousBlockNumber;
	        let filter;
	        let initialized = false;
	        const unwatch = poll(async () => {
	            if (!initialized) {
	                try {
	                    filter = (await createEventFilter(client, {
	                        address,
	                        args,
	                        event: event,
	                        events,
	                        strict,
	                    }));
	                }
	                catch { }
	                initialized = true;
	                return;
	            }
	            try {
	                let logs;
	                if (filter) {
	                    logs = await getFilterChanges(client, { filter });
	                }
	                else {
	                    // If the filter doesn't exist, we will fall back to use `getLogs`.
	                    // The fall back exists because some RPC Providers do not support filters.
	                    // Fetch the block number to use for `getLogs`.
	                    const blockNumber = await getBlockNumber(client);
	                    // If the block number has changed, we will need to fetch the logs.
	                    // If the block number doesn't exist, we are yet to reach the first poll interval,
	                    // so do not emit any logs.
	                    if (previousBlockNumber && previousBlockNumber !== blockNumber) {
	                        logs = await getLogs(client, {
	                            address,
	                            args,
	                            event: event,
	                            events,
	                            fromBlock: previousBlockNumber + 1n,
	                            toBlock: blockNumber,
	                        });
	                    }
	                    else {
	                        logs = [];
	                    }
	                    previousBlockNumber = blockNumber;
	                }
	                if (logs.length === 0)
	                    return;
	                if (batch)
	                    emit.onLogs(logs);
	                else
	                    logs.forEach((log) => emit.onLogs([log]));
	            }
	            catch (err) {
	                // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
	                // Reinitalize the filter when this occurs
	                if (filter && err instanceof InvalidInputRpcError)
	                    initialized = false;
	                emit.onError?.(err);
	            }
	        }, {
	            emitOnBegin: true,
	            interval: pollingInterval,
	        });
	        return async () => {
	            if (filter)
	                await uninstallFilter(client, { filter });
	            unwatch();
	        };
	    });
	}

	/**
	 * Watches and returns pending transaction hashes.
	 *
	 * - Docs: https://viem.sh/docs/actions/public/watchPendingTransactions.html
	 * - JSON-RPC Methods:
	 *   - When `poll: true`
	 *     - Calls [`eth_newPendingTransactionFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_newpendingtransactionfilter) to initialize the filter.
	 *     - Calls [`eth_getFilterChanges`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getFilterChanges) on a polling interval.
	 *   - When `poll: false` & WebSocket Transport, uses a WebSocket subscription via [`eth_subscribe`](https://docs.alchemy.com/reference/eth-subscribe-polygon) and the `"newPendingTransactions"` event.
	 *
	 * This Action will batch up all the pending transactions found within the [`pollingInterval`](https://viem.sh/docs/actions/public/watchPendingTransactions.html#pollinginterval-optional), and invoke them via [`onTransactions`](https://viem.sh/docs/actions/public/watchPendingTransactions.html#ontransactions).
	 *
	 * @param client - Client to use
	 * @param parameters - {@link WatchPendingTransactionsParameters}
	 * @returns A function that can be invoked to stop watching for new pending transaction hashes. {@link WatchPendingTransactionsReturnType}
	 *
	 * @example
	 * import { createPublicClient, http } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { watchPendingTransactions } from 'viem/public'
	 *
	 * const client = createPublicClient({
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const unwatch = await watchPendingTransactions(client, {
	 *   onTransactions: (hashes) => console.log(hashes),
	 * })
	 */
	function watchPendingTransactions(client, { batch = true, onError, onTransactions, poll: poll_, pollingInterval = client.pollingInterval, }) {
	    const enablePolling = typeof poll_ !== 'undefined' ? poll_ : client.transport.type !== 'webSocket';
	    const pollPendingTransactions = () => {
	        const observerId = stringify$3([
	            'watchPendingTransactions',
	            client.uid,
	            batch,
	            pollingInterval,
	        ]);
	        return observe(observerId, { onTransactions, onError }, (emit) => {
	            let filter;
	            const unwatch = poll(async () => {
	                try {
	                    if (!filter) {
	                        try {
	                            filter = await createPendingTransactionFilter(client);
	                            return;
	                        }
	                        catch (err) {
	                            unwatch();
	                            throw err;
	                        }
	                    }
	                    const hashes = await getFilterChanges(client, { filter });
	                    if (hashes.length === 0)
	                        return;
	                    if (batch)
	                        emit.onTransactions(hashes);
	                    else
	                        hashes.forEach((hash) => emit.onTransactions([hash]));
	                }
	                catch (err) {
	                    emit.onError?.(err);
	                }
	            }, {
	                emitOnBegin: true,
	                interval: pollingInterval,
	            });
	            return async () => {
	                if (filter)
	                    await uninstallFilter(client, { filter });
	                unwatch();
	            };
	        });
	    };
	    const subscribePendingTransactions = () => {
	        let active = true;
	        let unsubscribe = () => (active = false);
	        (async () => {
	            try {
	                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
	                    params: ['newPendingTransactions'],
	                    onData(data) {
	                        if (!active)
	                            return;
	                        const transaction = data.result;
	                        onTransactions([transaction]);
	                    },
	                    onError(error) {
	                        onError?.(error);
	                    },
	                });
	                unsubscribe = unsubscribe_;
	                if (!active)
	                    unsubscribe();
	            }
	            catch (err) {
	                onError?.(err);
	            }
	        })();
	        return unsubscribe;
	    };
	    return enablePolling
	        ? pollPendingTransactions()
	        : subscribePendingTransactions();
	}

	function publicActions(client) {
	    return {
	        call: (args) => call$1(client, args),
	        createBlockFilter: () => createBlockFilter(client),
	        createContractEventFilter: (args) => createContractEventFilter(client, args),
	        createEventFilter: (args) => createEventFilter(client, args),
	        createPendingTransactionFilter: () => createPendingTransactionFilter(client),
	        estimateContractGas: (args) => estimateContractGas(client, args),
	        estimateGas: (args) => estimateGas(client, args),
	        getBalance: (args) => getBalance(client, args),
	        getBlock: (args) => getBlock(client, args),
	        getBlockNumber: (args) => getBlockNumber(client, args),
	        getBlockTransactionCount: (args) => getBlockTransactionCount(client, args),
	        getBytecode: (args) => getBytecode(client, args),
	        getChainId: () => getChainId(client),
	        getEnsAddress: (args) => getEnsAddress(client, args),
	        getEnsAvatar: (args) => getEnsAvatar(client, args),
	        getEnsName: (args) => getEnsName(client, args),
	        getEnsResolver: (args) => getEnsResolver(client, args),
	        getEnsText: (args) => getEnsText(client, args),
	        getFeeHistory: (args) => getFeeHistory(client, args),
	        getFilterChanges: (args) => getFilterChanges(client, args),
	        getFilterLogs: (args) => getFilterLogs(client, args),
	        getGasPrice: () => getGasPrice(client),
	        getLogs: (args) => getLogs(client, args),
	        getStorageAt: (args) => getStorageAt(client, args),
	        getTransaction: (args) => getTransaction(client, args),
	        getTransactionConfirmations: (args) => getTransactionConfirmations(client, args),
	        getTransactionCount: (args) => getTransactionCount(client, args),
	        getTransactionReceipt: (args) => getTransactionReceipt(client, args),
	        multicall: (args) => multicall(client, args),
	        readContract: (args) => readContract(client, args),
	        simulateContract: (args) => simulateContract(client, args),
	        verifyMessage: (args) => verifyMessage$1(client, args),
	        verifyTypedData: (args) => verifyTypedData(client, args),
	        uninstallFilter: (args) => uninstallFilter(client, args),
	        waitForTransactionReceipt: (args) => waitForTransactionReceipt(client, args),
	        watchBlocks: (args) => watchBlocks(client, args),
	        watchBlockNumber: (args) => watchBlockNumber(client, args),
	        watchContractEvent: (args) => watchContractEvent(client, args),
	        watchEvent: (args) => watchEvent(client, args),
	        watchPendingTransactions: (args) => watchPendingTransactions(client, args),
	    };
	}

	function createPublicClient(parameters) {
	    const { key = 'public', name = 'Public Client' } = parameters;
	    const client = createClient({
	        ...parameters,
	        key,
	        name,
	        type: 'publicClient',
	    });
	    return client.extend(publicActions);
	}

	/**
	 * Deploys a contract to the network, given bytecode and constructor arguments.
	 *
	 * - Docs: https://viem.sh/docs/contract/deployContract.html
	 * - Examples: https://stackblitz.com/github/wagmi-dev/viem/tree/main/examples/contracts/deploying-contracts
	 *
	 * @param client - Client to use
	 * @param parameters - {@link DeployContractParameters}
	 * @returns The [Transaction](https://viem.sh/docs/glossary/terms.html#transaction) hash. {@link DeployContractReturnType}
	 *
	 * @example
	 * import { createWalletClient, http } from 'viem'
	 * import { privateKeyToAccount } from 'viem/accounts'
	 * import { mainnet } from 'viem/chains'
	 * import { deployContract } from 'viem/contract'
	 *
	 * const client = createWalletClient({
	 *   account: privateKeyToAccount('0x…'),
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const hash = await deployContract(client, {
	 *   abi: [],
	 *   account: '0x…,
	 *   bytecode: '0x608060405260405161083e38038061083e833981016040819052610...',
	 * })
	 */
	function deployContract(walletClient, { abi, args, bytecode, ...request }) {
	    const calldata = encodeDeployData({
	        abi,
	        args,
	        bytecode,
	    });
	    return sendTransaction(walletClient, {
	        ...request,
	        data: calldata,
	    });
	}

	/**
	 * Returns a list of account addresses owned by the wallet or client.
	 *
	 * - Docs: https://viem.sh/docs/actions/wallet/getAddresses.html
	 * - JSON-RPC Methods: [`eth_accounts`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_accounts)
	 *
	 * @param client - Client to use
	 * @returns List of account addresses owned by the wallet or client. {@link GetAddressesReturnType}
	 *
	 * @example
	 * import { createWalletClient, custom } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getAddresses } from 'viem/wallet'
	 *
	 * const client = createWalletClient({
	 *   chain: mainnet,
	 *   transport: custom(window.ethereum),
	 * })
	 * const accounts = await getAddresses(client)
	 */
	async function getAddresses(client) {
	    const addresses = await client.request({ method: 'eth_accounts' });
	    return addresses.map((address) => checksumAddress(address));
	}

	/**
	 * Gets the wallets current permissions.
	 *
	 * - Docs: https://viem.sh/docs/actions/wallet/getPermissions.html
	 * - JSON-RPC Methods: [`wallet_getPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
	 *
	 * @param client - Client to use
	 * @returns The wallet permissions. {@link GetPermissionsReturnType}
	 *
	 * @example
	 * import { createWalletClient, custom } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { getPermissions } from 'viem/wallet'
	 *
	 * const client = createWalletClient({
	 *   chain: mainnet,
	 *   transport: custom(window.ethereum),
	 * })
	 * const permissions = await getPermissions(client)
	 */
	async function getPermissions(client) {
	    const permissions = await client.request({ method: 'wallet_getPermissions' });
	    return permissions;
	}

	/**
	 * Requests a list of accounts managed by a wallet.
	 *
	 * - Docs: https://viem.sh/docs/actions/wallet/requestAddresses.html
	 * - JSON-RPC Methods: [`eth_requestAccounts`](https://eips.ethereum.org/EIPS/eip-1102)
	 *
	 * Sends a request to the wallet, asking for permission to access the user's accounts. After the user accepts the request, it will return a list of accounts (addresses).
	 *
	 * This API can be useful for dapps that need to access the user's accounts in order to execute transactions or interact with smart contracts.
	 *
	 * @param client - Client to use
	 * @returns List of accounts managed by a wallet {@link RequestAddressesReturnType}
	 *
	 * @example
	 * import { createWalletClient, custom } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { requestAddresses } from 'viem/wallet'
	 *
	 * const client = createWalletClient({
	 *   chain: mainnet,
	 *   transport: custom(window.ethereum),
	 * })
	 * const accounts = await requestAddresses(client)
	 */
	async function requestAddresses(client) {
	    const addresses = await client.request({ method: 'eth_requestAccounts' });
	    return addresses.map((address) => getAddress$1(address));
	}

	/**
	 * Requests permissions for a wallet.
	 *
	 * - Docs: https://viem.sh/docs/actions/wallet/requestPermissions.html
	 * - JSON-RPC Methods: [`wallet_requestPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link RequestPermissionsParameters}
	 * @returns The wallet permissions. {@link RequestPermissionsReturnType}
	 *
	 * @example
	 * import { createWalletClient, custom } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { requestPermissions } from 'viem/wallet'
	 *
	 * const client = createWalletClient({
	 *   chain: mainnet,
	 *   transport: custom(window.ethereum),
	 * })
	 * const permissions = await requestPermissions(client, {
	 *   eth_accounts: {}
	 * })
	 */
	async function requestPermissions(client, permissions) {
	    return client.request({
	        method: 'wallet_requestPermissions',
	        params: [permissions],
	    });
	}

	/**
	 * Calculates an Ethereum-specific signature in [EIP-191 format](https://eips.ethereum.org/EIPS/eip-191): `keccak256("\x19Ethereum Signed Message:\n" + len(message) + message))`.
	 *
	 * - Docs: https://viem.sh/docs/actions/wallet/signMessage.html
	 * - JSON-RPC Methods:
	 *   - JSON-RPC Accounts: [`personal_sign`](https://docs.metamask.io/guide/signing-data.html#personal-sign)
	 *   - Local Accounts: Signs locally. No JSON-RPC request.
	 *
	 * With the calculated signature, you can:
	 * - use [`verifyMessage`](https://viem.sh/docs/utilities/verifyMessage.html) to verify the signature,
	 * - use [`recoverMessageAddress`](https://viem.sh/docs/utilities/recoverMessageAddress.html) to recover the signing address from a signature.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link SignMessageParameters}
	 * @returns The signed message. {@link SignMessageReturnType}
	 *
	 * @example
	 * import { createWalletClient, custom } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { signMessage } from 'viem/wallet'
	 *
	 * const client = createWalletClient({
	 *   chain: mainnet,
	 *   transport: custom(window.ethereum),
	 * })
	 * const signature = await signMessage(client, {
	 *   account: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
	 *   message: 'hello world',
	 * })
	 *
	 * @example
	 * // Account Hoisting
	 * import { createWalletClient, custom } from 'viem'
	 * import { privateKeyToAccount } from 'viem/accounts'
	 * import { mainnet } from 'viem/chains'
	 * import { signMessage } from 'viem/wallet'
	 *
	 * const client = createWalletClient({
	 *   account: privateKeyToAccount('0x…'),
	 *   chain: mainnet,
	 *   transport: custom(window.ethereum),
	 * })
	 * const signature = await signMessage(client, {
	 *   message: 'hello world',
	 * })
	 */
	async function signMessage$1(client, { account: account_ = client.account, message, }) {
	    if (!account_)
	        throw new AccountNotFoundError({
	            docsPath: '/docs/actions/wallet/signMessage',
	        });
	    const account = parseAccount(account_);
	    if (account.type === 'local')
	        return account.signMessage({ message });
	    const message_ = (() => {
	        if (typeof message === 'string')
	            return stringToHex(message);
	        if (message.raw instanceof Uint8Array)
	            return toHex$1(message.raw);
	        return message.raw;
	    })();
	    return client.request({
	        method: 'personal_sign',
	        params: [message_, account.address],
	    });
	}

	/**
	 * Signs typed data and calculates an Ethereum-specific signature in [https://eips.ethereum.org/EIPS/eip-712](https://eips.ethereum.org/EIPS/eip-712): `sign(keccak256("\x19\x01" ‖ domainSeparator ‖ hashStruct(message)))`
	 *
	 * - Docs: https://viem.sh/docs/actions/wallet/signTypedData.html
	 * - JSON-RPC Methods:
	 *   - JSON-RPC Accounts: [`eth_signTypedData_v4`](https://docs.metamask.io/guide/signing-data.html#signtypeddata-v4)
	 *   - Local Accounts: Signs locally. No JSON-RPC request.
	 *
	 * @param client - Client to use
	 * @param parameters - {@link SignTypedDataParameters}
	 * @returns The signed data. {@link SignTypedDataReturnType}
	 *
	 * @example
	 * import { createWalletClient, custom } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { signTypedData } from 'viem/wallet'
	 *
	 * const client = createWalletClient({
	 *   chain: mainnet,
	 *   transport: custom(window.ethereum),
	 * })
	 * const signature = await signTypedData(client, {
	 *   account: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
	 *   domain: {
	 *     name: 'Ether Mail',
	 *     version: '1',
	 *     chainId: 1,
	 *     verifyingContract: '0xCcCCccccCCCCcCCCCCCcCcCccCcCCCcCcccccccC',
	 *   },
	 *   types: {
	 *     Person: [
	 *       { name: 'name', type: 'string' },
	 *       { name: 'wallet', type: 'address' },
	 *     ],
	 *     Mail: [
	 *       { name: 'from', type: 'Person' },
	 *       { name: 'to', type: 'Person' },
	 *       { name: 'contents', type: 'string' },
	 *     ],
	 *   },
	 *   primaryType: 'Mail',
	 *   message: {
	 *     from: {
	 *       name: 'Cow',
	 *       wallet: '0xCD2a3d9F938E13CD947Ec05AbC7FE734Df8DD826',
	 *     },
	 *     to: {
	 *       name: 'Bob',
	 *       wallet: '0xbBbBBBBbbBBBbbbBbbBbbbbBBbBbbbbBbBbbBBbB',
	 *     },
	 *     contents: 'Hello, Bob!',
	 *   },
	 * })
	 *
	 * @example
	 * // Account Hoisting
	 * import { createWalletClient, http } from 'viem'
	 * import { privateKeyToAccount } from 'viem/accounts'
	 * import { mainnet } from 'viem/chains'
	 * import { signTypedData } from 'viem/wallet'
	 *
	 * const client = createWalletClient({
	 *   account: privateKeyToAccount('0x…'),
	 *   chain: mainnet,
	 *   transport: http(),
	 * })
	 * const signature = await signTypedData(client, {
	 *   domain: {
	 *     name: 'Ether Mail',
	 *     version: '1',
	 *     chainId: 1,
	 *     verifyingContract: '0xCcCCccccCCCCcCCCCCCcCcCccCcCCCcCcccccccC',
	 *   },
	 *   types: {
	 *     Person: [
	 *       { name: 'name', type: 'string' },
	 *       { name: 'wallet', type: 'address' },
	 *     ],
	 *     Mail: [
	 *       { name: 'from', type: 'Person' },
	 *       { name: 'to', type: 'Person' },
	 *       { name: 'contents', type: 'string' },
	 *     ],
	 *   },
	 *   primaryType: 'Mail',
	 *   message: {
	 *     from: {
	 *       name: 'Cow',
	 *       wallet: '0xCD2a3d9F938E13CD947Ec05AbC7FE734Df8DD826',
	 *     },
	 *     to: {
	 *       name: 'Bob',
	 *       wallet: '0xbBbBBBBbbBBBbbbBbbBbbbbBBbBbbbbBbBbbBBbB',
	 *     },
	 *     contents: 'Hello, Bob!',
	 *   },
	 * })
	 */
	async function signTypedData(client, { account: account_ = client.account, domain, message, primaryType, types: types_, }) {
	    if (!account_)
	        throw new AccountNotFoundError({
	            docsPath: '/docs/actions/wallet/signTypedData',
	        });
	    const account = parseAccount(account_);
	    const types = {
	        EIP712Domain: [
	            typeof domain?.name === 'string' && { name: 'name', type: 'string' },
	            domain?.version && { name: 'version', type: 'string' },
	            typeof domain?.chainId === 'number' && {
	                name: 'chainId',
	                type: 'uint256',
	            },
	            domain?.verifyingContract && {
	                name: 'verifyingContract',
	                type: 'address',
	            },
	            domain?.salt && { name: 'salt', type: 'bytes32' },
	        ].filter(Boolean),
	        ...types_,
	    };
	    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
	    // as we can't statically check this with TypeScript.
	    validateTypedData({
	        domain,
	        message,
	        primaryType,
	        types,
	    });
	    if (account.type === 'local')
	        return account.signTypedData({
	            domain,
	            primaryType,
	            types,
	            message,
	        });
	    const typedData = stringify$3({ domain: domain ?? {}, primaryType, types, message }, (_, value) => (isHex(value) ? value.toLowerCase() : value));
	    return client.request({
	        method: 'eth_signTypedData_v4',
	        params: [account.address, typedData],
	    });
	}

	/**
	 * Switch the target chain in a wallet.
	 *
	 * - Docs: https://viem.sh/docs/actions/wallet/switchChain.html
	 * - JSON-RPC Methods: [`eth_switchEthereumChain`](https://eips.ethereum.org/EIPS/eip-3326)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link SwitchChainParameters}
	 *
	 * @example
	 * import { createWalletClient, custom } from 'viem'
	 * import { mainnet, optimism } from 'viem/chains'
	 * import { switchChain } from 'viem/wallet'
	 *
	 * const client = createWalletClient({
	 *   chain: mainnet,
	 *   transport: custom(window.ethereum),
	 * })
	 * await switchChain(client, { id: optimism.id })
	 */
	async function switchChain(client, { id }) {
	    await client.request({
	        method: 'wallet_switchEthereumChain',
	        params: [
	            {
	                chainId: numberToHex$1(id),
	            },
	        ],
	    });
	}

	/**
	 * Adds an EVM chain to the wallet.
	 *
	 * - Docs: https://viem.sh/docs/actions/wallet/watchAsset.html
	 * - JSON-RPC Methods: [`eth_switchEthereumChain`](https://eips.ethereum.org/EIPS/eip-747)
	 *
	 * @param client - Client to use
	 * @param parameters - {@link WatchAssetParameters}
	 * @returns Boolean indicating if the token was successfully added. {@link WatchAssetReturnType}
	 *
	 * @example
	 * import { createWalletClient, custom } from 'viem'
	 * import { mainnet } from 'viem/chains'
	 * import { watchAsset } from 'viem/wallet'
	 *
	 * const client = createWalletClient({
	 *   chain: mainnet,
	 *   transport: custom(window.ethereum),
	 * })
	 * const success = await watchAsset(client, {
	 *   type: 'ERC20',
	 *   options: {
	 *     address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
	 *     decimals: 18,
	 *     symbol: 'WETH',
	 *   },
	 * })
	 */
	async function watchAsset(client, params) {
	    const added = await client.request({
	        method: 'wallet_watchAsset',
	        params,
	    });
	    return added;
	}

	function walletActions(client) {
	    return {
	        addChain: (args) => addChain(client, args),
	        deployContract: (args) => deployContract(client, args),
	        getAddresses: () => getAddresses(client),
	        getChainId: () => getChainId(client),
	        getPermissions: () => getPermissions(client),
	        requestAddresses: () => requestAddresses(client),
	        requestPermissions: (args) => requestPermissions(client, args),
	        sendTransaction: (args) => sendTransaction(client, args),
	        signMessage: (args) => signMessage$1(client, args),
	        signTypedData: (args) => signTypedData(client, args),
	        switchChain: (args) => switchChain(client, args),
	        watchAsset: (args) => watchAsset(client, args),
	        writeContract: (args) => writeContract(client, args),
	    };
	}

	function createWalletClient(parameters) {
	    const { key = 'wallet', name = 'Wallet Client', transport } = parameters;
	    const client = createClient({
	        ...parameters,
	        key,
	        name,
	        transport: (opts) => transport({ ...opts, retryCount: 0 }),
	        type: 'walletClient',
	    });
	    return client.extend(walletActions);
	}

	/**
	 * @description Creates a WebSocket transport that connects to a JSON-RPC API.
	 */
	function webSocket(
	/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */
	url, config = {}) {
	    const { key = 'webSocket', name = 'WebSocket JSON-RPC', retryDelay } = config;
	    return ({ chain, retryCount: retryCount_, timeout: timeout_ }) => {
	        const retryCount = config.retryCount ?? retryCount_;
	        const timeout = timeout_ ?? config.timeout ?? 10000;
	        const url_ = url || chain?.rpcUrls.default.webSocket?.[0];
	        if (!url_)
	            throw new UrlRequiredError();
	        return createTransport({
	            key,
	            name,
	            async request({ method, params }) {
	                const body = { method, params };
	                const socket = await getSocket(url_);
	                const { error, result } = await rpc$1.webSocketAsync(socket, {
	                    body,
	                    timeout,
	                });
	                if (error)
	                    throw new RpcRequestError({
	                        body,
	                        error,
	                        url: url_,
	                    });
	                return result;
	            },
	            retryCount,
	            retryDelay,
	            timeout,
	            type: 'webSocket',
	        }, {
	            getSocket() {
	                return getSocket(url_);
	            },
	            async subscribe({ params, onData, onError }) {
	                const socket = await getSocket(url_);
	                const { result: subscriptionId } = await new Promise((resolve, reject) => rpc$1.webSocket(socket, {
	                    body: {
	                        method: 'eth_subscribe',
	                        params,
	                    },
	                    onResponse(response) {
	                        if (response.error) {
	                            reject(response.error);
	                            onError?.(response.error);
	                            return;
	                        }
	                        if (typeof response.id === 'number') {
	                            resolve(response);
	                            return;
	                        }
	                        if (response.method !== 'eth_subscription')
	                            return;
	                        onData(response.params);
	                    },
	                }));
	                return {
	                    subscriptionId,
	                    async unsubscribe() {
	                        return new Promise((resolve) => rpc$1.webSocket(socket, {
	                            body: {
	                                method: 'eth_unsubscribe',
	                                params: [subscriptionId],
	                            },
	                            onResponse: resolve,
	                        }));
	                    },
	                };
	            },
	        });
	    };
	}

	// src/utils/getInjectedName.ts
	function getInjectedName(ethereum) {
	  if (!ethereum)
	    return "Injected";
	  const getName = (provider) => {
	    if (provider.isApexWallet)
	      return "Apex Wallet";
	    if (provider.isAvalanche)
	      return "Core Wallet";
	    if (provider.isBackpack)
	      return "Backpack";
	    if (provider.isBifrost)
	      return "Bifrost Wallet";
	    if (provider.isBitKeep)
	      return "BitKeep";
	    if (provider.isBitski)
	      return "Bitski";
	    if (provider.isBlockWallet)
	      return "BlockWallet";
	    if (provider.isBraveWallet)
	      return "Brave Wallet";
	    if (provider.isCoinbaseWallet)
	      return "Coinbase Wallet";
	    if (provider.isDawn)
	      return "Dawn Wallet";
	    if (provider.isDefiant)
	      return "Defiant";
	    if (provider.isEnkrypt)
	      return "Enkrypt";
	    if (provider.isExodus)
	      return "Exodus";
	    if (provider.isFrame)
	      return "Frame";
	    if (provider.isFrontier)
	      return "Frontier Wallet";
	    if (provider.isGamestop)
	      return "GameStop Wallet";
	    if (provider.isHaqqWallet)
	      return "HAQQ Wallet";
	    if (provider.isHyperPay)
	      return "HyperPay Wallet";
	    if (provider.isImToken)
	      return "ImToken";
	    if (provider.isHaloWallet)
	      return "Halo Wallet";
	    if (provider.isKuCoinWallet)
	      return "KuCoin Wallet";
	    if (provider.isMathWallet)
	      return "MathWallet";
	    if (provider.isNovaWallet)
	      return "Nova Wallet";
	    if (provider.isOkxWallet || provider.isOKExWallet)
	      return "OKX Wallet";
	    if (provider.isOneInchIOSWallet || provider.isOneInchAndroidWallet)
	      return "1inch Wallet";
	    if (provider.isOpera)
	      return "Opera";
	    if (provider.isPhantom)
	      return "Phantom";
	    if (provider.isPortal)
	      return "Ripio Portal";
	    if (provider.isRabby)
	      return "Rabby Wallet";
	    if (provider.isRainbow)
	      return "Rainbow";
	    if (provider.isStatus)
	      return "Status";
	    if (provider.isTalisman)
	      return "Talisman";
	    if (provider.isTally)
	      return "Taho";
	    if (provider.isTokenPocket)
	      return "TokenPocket";
	    if (provider.isTokenary)
	      return "Tokenary";
	    if (provider.isTrust || provider.isTrustWallet)
	      return "Trust Wallet";
	    if (provider.isTTWallet)
	      return "TTWallet";
	    if (provider.isXDEFI)
	      return "XDEFI Wallet";
	    if (provider.isZerion)
	      return "Zerion";
	    if (provider.isMetaMask)
	      return "MetaMask";
	  };
	  if (ethereum.providers?.length) {
	    const nameSet = /* @__PURE__ */ new Set();
	    let unknownCount = 1;
	    for (const provider of ethereum.providers) {
	      let name = getName(provider);
	      if (!name) {
	        name = `Unknown Wallet #${unknownCount}`;
	        unknownCount += 1;
	      }
	      nameSet.add(name);
	    }
	    const names = [...nameSet];
	    if (names.length)
	      return names;
	    return names[0] ?? "Injected";
	  }
	  return getName(ethereum) ?? "Injected";
	}

	// src/injected.ts
	var _provider$2;
	var InjectedConnector = class extends Connector {
	  constructor({
	    chains,
	    options: options_
	  } = {}) {
	    const options = {
	      shimDisconnect: true,
	      getProvider() {
	        if (typeof window === "undefined")
	          return;
	        const ethereum = window.ethereum;
	        if (ethereum?.providers)
	          return ethereum.providers[0];
	        return ethereum;
	      },
	      ...options_
	    };
	    super({ chains, options });
	    __publicField(this, "id", "injected");
	    __publicField(this, "name");
	    __publicField(this, "ready");
	    __privateAdd$1(this, _provider$2, void 0);
	    __publicField(this, "shimDisconnectKey", `${this.id}.shimDisconnect`);
	    __publicField(this, "onAccountsChanged", (accounts) => {
	      if (accounts.length === 0)
	        this.emit("disconnect");
	      else
	        this.emit("change", {
	          account: getAddress$1(accounts[0])
	        });
	    });
	    __publicField(this, "onChainChanged", (chainId) => {
	      const id = normalizeChainId(chainId);
	      const unsupported = this.isChainUnsupported(id);
	      this.emit("change", { chain: { id, unsupported } });
	    });
	    __publicField(this, "onDisconnect", async (error) => {
	      if (error.code === 1013) {
	        const provider = await this.getProvider();
	        if (provider) {
	          const isAuthorized = await this.getAccount();
	          if (isAuthorized)
	            return;
	        }
	      }
	      this.emit("disconnect");
	      if (this.options.shimDisconnect)
	        this.storage?.removeItem(this.shimDisconnectKey);
	    });
	    const provider = options.getProvider();
	    if (typeof options.name === "string")
	      this.name = options.name;
	    else if (provider) {
	      const detectedName = getInjectedName(provider);
	      if (options.name)
	        this.name = options.name(detectedName);
	      else {
	        if (typeof detectedName === "string")
	          this.name = detectedName;
	        else
	          this.name = detectedName[0];
	      }
	    } else
	      this.name = "Injected";
	    this.ready = !!provider;
	  }
	  async connect({ chainId } = {}) {
	    try {
	      const provider = await this.getProvider();
	      if (!provider)
	        throw new ConnectorNotFoundError();
	      if (provider.on) {
	        provider.on("accountsChanged", this.onAccountsChanged);
	        provider.on("chainChanged", this.onChainChanged);
	        provider.on("disconnect", this.onDisconnect);
	      }
	      this.emit("message", { type: "connecting" });
	      const accounts = await provider.request({
	        method: "eth_requestAccounts"
	      });
	      const account = getAddress$1(accounts[0]);
	      let id = await this.getChainId();
	      let unsupported = this.isChainUnsupported(id);
	      if (chainId && id !== chainId) {
	        const chain = await this.switchChain(chainId);
	        id = chain.id;
	        unsupported = this.isChainUnsupported(id);
	      }
	      if (this.options.shimDisconnect)
	        this.storage?.setItem(this.shimDisconnectKey, true);
	      return { account, chain: { id, unsupported } };
	    } catch (error) {
	      if (this.isUserRejectedRequestError(error))
	        throw new UserRejectedRequestError(error);
	      if (error.code === -32002)
	        throw new ResourceUnavailableRpcError(error);
	      throw error;
	    }
	  }
	  async disconnect() {
	    const provider = await this.getProvider();
	    if (!provider?.removeListener)
	      return;
	    provider.removeListener("accountsChanged", this.onAccountsChanged);
	    provider.removeListener("chainChanged", this.onChainChanged);
	    provider.removeListener("disconnect", this.onDisconnect);
	    if (this.options.shimDisconnect)
	      this.storage?.removeItem(this.shimDisconnectKey);
	  }
	  async getAccount() {
	    const provider = await this.getProvider();
	    if (!provider)
	      throw new ConnectorNotFoundError();
	    const accounts = await provider.request({
	      method: "eth_accounts"
	    });
	    return getAddress$1(accounts[0]);
	  }
	  async getChainId() {
	    const provider = await this.getProvider();
	    if (!provider)
	      throw new ConnectorNotFoundError();
	    return provider.request({ method: "eth_chainId" }).then(normalizeChainId);
	  }
	  async getProvider() {
	    const provider = this.options.getProvider();
	    if (provider)
	      __privateSet$1(this, _provider$2, provider);
	    return __privateGet$1(this, _provider$2);
	  }
	  async getWalletClient({
	    chainId
	  } = {}) {
	    const [provider, account] = await Promise.all([
	      this.getProvider(),
	      this.getAccount()
	    ]);
	    const chain = this.chains.find((x) => x.id === chainId);
	    if (!provider)
	      throw new Error("provider is required.");
	    return createWalletClient({
	      account,
	      chain,
	      transport: custom(provider)
	    });
	  }
	  async isAuthorized() {
	    try {
	      if (this.options.shimDisconnect && !this.storage?.getItem(this.shimDisconnectKey))
	        return false;
	      const provider = await this.getProvider();
	      if (!provider)
	        throw new ConnectorNotFoundError();
	      const account = await this.getAccount();
	      return !!account;
	    } catch {
	      return false;
	    }
	  }
	  async switchChain(chainId) {
	    const provider = await this.getProvider();
	    if (!provider)
	      throw new ConnectorNotFoundError();
	    const id = numberToHex$1(chainId);
	    try {
	      await Promise.all([
	        provider.request({
	          method: "wallet_switchEthereumChain",
	          params: [{ chainId: id }]
	        }),
	        new Promise(
	          (res) => this.on("change", ({ chain }) => {
	            if (chain?.id === chainId)
	              res();
	          })
	        )
	      ]);
	      return this.chains.find((x) => x.id === chainId) ?? {
	        id: chainId,
	        name: `Chain ${id}`,
	        network: `${id}`,
	        nativeCurrency: { name: "Ether", decimals: 18, symbol: "ETH" },
	        rpcUrls: { default: { http: [""] }, public: { http: [""] } }
	      };
	    } catch (error) {
	      const chain = this.chains.find((x) => x.id === chainId);
	      if (!chain)
	        throw new ChainNotConfiguredForConnectorError({
	          chainId,
	          connectorId: this.id
	        });
	      if (error.code === 4902 || error?.data?.originalError?.code === 4902) {
	        try {
	          await provider.request({
	            method: "wallet_addEthereumChain",
	            params: [
	              {
	                chainId: id,
	                chainName: chain.name,
	                nativeCurrency: chain.nativeCurrency,
	                rpcUrls: [chain.rpcUrls.public?.http[0] ?? ""],
	                blockExplorerUrls: this.getBlockExplorerUrls(chain)
	              }
	            ]
	          });
	          const currentChainId = await this.getChainId();
	          if (currentChainId !== chainId)
	            throw new UserRejectedRequestError(
	              new Error("User rejected switch after adding network.")
	            );
	          return chain;
	        } catch (error2) {
	          throw new UserRejectedRequestError(error2);
	        }
	      }
	      if (this.isUserRejectedRequestError(error))
	        throw new UserRejectedRequestError(error);
	      throw new SwitchChainError(error);
	    }
	  }
	  async watchAsset({
	    address,
	    decimals = 18,
	    image,
	    symbol
	  }) {
	    const provider = await this.getProvider();
	    if (!provider)
	      throw new ConnectorNotFoundError();
	    return provider.request({
	      method: "wallet_watchAsset",
	      params: {
	        type: "ERC20",
	        options: {
	          address,
	          decimals,
	          image,
	          symbol
	        }
	      }
	    });
	  }
	  isUserRejectedRequestError(error) {
	    return error.code === 4001;
	  }
	};
	_provider$2 = new WeakMap();

	var __accessCheck = (obj, member, msg) => {
	  if (!member.has(obj))
	    throw TypeError("Cannot " + msg);
	};
	var __privateGet = (obj, member, getter) => {
	  __accessCheck(obj, member, "read from private field");
	  return getter ? getter.call(obj) : member.get(obj);
	};
	var __privateAdd = (obj, member, value) => {
	  if (member.has(obj))
	    throw TypeError("Cannot add the same private member more than once");
	  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
	};
	var __privateSet = (obj, member, value, setter) => {
	  __accessCheck(obj, member, "write to private field");
	  setter ? setter.call(obj, value) : member.set(obj, value);
	  return value;
	};
	var __privateMethod = (obj, member, method) => {
	  __accessCheck(obj, member, "access private method");
	  return method;
	};

	const subscribeWithSelectorImpl = (fn) => (set, get, api) => {
	  const origSubscribe = api.subscribe;
	  api.subscribe = (selector, optListener, options) => {
	    let listener = selector;
	    if (optListener) {
	      const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
	      let currentSlice = selector(api.getState());
	      listener = (state) => {
	        const nextSlice = selector(state);
	        if (!equalityFn(currentSlice, nextSlice)) {
	          const previousSlice = currentSlice;
	          optListener(currentSlice = nextSlice, previousSlice);
	        }
	      };
	      if (options == null ? void 0 : options.fireImmediately) {
	        optListener(currentSlice, currentSlice);
	      }
	    }
	    return origSubscribe(listener);
	  };
	  const initialState = fn(set, get, api);
	  return initialState;
	};
	const subscribeWithSelector = subscribeWithSelectorImpl;

	function createJSONStorage(getStorage, options) {
	  let storage;
	  try {
	    storage = getStorage();
	  } catch (e) {
	    return;
	  }
	  const persistStorage = {
	    getItem: (name) => {
	      var _a;
	      const parse = (str2) => {
	        if (str2 === null) {
	          return null;
	        }
	        return JSON.parse(str2, options == null ? void 0 : options.reviver);
	      };
	      const str = (_a = storage.getItem(name)) != null ? _a : null;
	      if (str instanceof Promise) {
	        return str.then(parse);
	      }
	      return parse(str);
	    },
	    setItem: (name, newValue) => storage.setItem(
	      name,
	      JSON.stringify(newValue, options == null ? void 0 : options.replacer)
	    ),
	    removeItem: (name) => storage.removeItem(name)
	  };
	  return persistStorage;
	}
	const toThenable = (fn) => (input) => {
	  try {
	    const result = fn(input);
	    if (result instanceof Promise) {
	      return result;
	    }
	    return {
	      then(onFulfilled) {
	        return toThenable(onFulfilled)(result);
	      },
	      catch(_onRejected) {
	        return this;
	      }
	    };
	  } catch (e) {
	    return {
	      then(_onFulfilled) {
	        return this;
	      },
	      catch(onRejected) {
	        return toThenable(onRejected)(e);
	      }
	    };
	  }
	};
	const oldImpl = (config, baseOptions) => (set, get, api) => {
	  let options = {
	    getStorage: () => localStorage,
	    serialize: JSON.stringify,
	    deserialize: JSON.parse,
	    partialize: (state) => state,
	    version: 0,
	    merge: (persistedState, currentState) => ({
	      ...currentState,
	      ...persistedState
	    }),
	    ...baseOptions
	  };
	  let hasHydrated = false;
	  const hydrationListeners = /* @__PURE__ */ new Set();
	  const finishHydrationListeners = /* @__PURE__ */ new Set();
	  let storage;
	  try {
	    storage = options.getStorage();
	  } catch (e) {
	  }
	  if (!storage) {
	    return config(
	      (...args) => {
	        console.warn(
	          `[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`
	        );
	        set(...args);
	      },
	      get,
	      api
	    );
	  }
	  const thenableSerialize = toThenable(options.serialize);
	  const setItem = () => {
	    const state = options.partialize({ ...get() });
	    let errorInSync;
	    const thenable = thenableSerialize({ state, version: options.version }).then(
	      (serializedValue) => storage.setItem(options.name, serializedValue)
	    ).catch((e) => {
	      errorInSync = e;
	    });
	    if (errorInSync) {
	      throw errorInSync;
	    }
	    return thenable;
	  };
	  const savedSetState = api.setState;
	  api.setState = (state, replace) => {
	    savedSetState(state, replace);
	    void setItem();
	  };
	  const configResult = config(
	    (...args) => {
	      set(...args);
	      void setItem();
	    },
	    get,
	    api
	  );
	  let stateFromStorage;
	  const hydrate = () => {
	    var _a;
	    if (!storage)
	      return;
	    hasHydrated = false;
	    hydrationListeners.forEach((cb) => cb(get()));
	    const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
	    return toThenable(storage.getItem.bind(storage))(options.name).then((storageValue) => {
	      if (storageValue) {
	        return options.deserialize(storageValue);
	      }
	    }).then((deserializedStorageValue) => {
	      if (deserializedStorageValue) {
	        if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
	          if (options.migrate) {
	            return options.migrate(
	              deserializedStorageValue.state,
	              deserializedStorageValue.version
	            );
	          }
	          console.error(
	            `State loaded from storage couldn't be migrated since no migrate function was provided`
	          );
	        } else {
	          return deserializedStorageValue.state;
	        }
	      }
	    }).then((migratedState) => {
	      var _a2;
	      stateFromStorage = options.merge(
	        migratedState,
	        (_a2 = get()) != null ? _a2 : configResult
	      );
	      set(stateFromStorage, true);
	      return setItem();
	    }).then(() => {
	      postRehydrationCallback == null ? void 0 : postRehydrationCallback(stateFromStorage, void 0);
	      hasHydrated = true;
	      finishHydrationListeners.forEach((cb) => cb(stateFromStorage));
	    }).catch((e) => {
	      postRehydrationCallback == null ? void 0 : postRehydrationCallback(void 0, e);
	    });
	  };
	  api.persist = {
	    setOptions: (newOptions) => {
	      options = {
	        ...options,
	        ...newOptions
	      };
	      if (newOptions.getStorage) {
	        storage = newOptions.getStorage();
	      }
	    },
	    clearStorage: () => {
	      storage == null ? void 0 : storage.removeItem(options.name);
	    },
	    getOptions: () => options,
	    rehydrate: () => hydrate(),
	    hasHydrated: () => hasHydrated,
	    onHydrate: (cb) => {
	      hydrationListeners.add(cb);
	      return () => {
	        hydrationListeners.delete(cb);
	      };
	    },
	    onFinishHydration: (cb) => {
	      finishHydrationListeners.add(cb);
	      return () => {
	        finishHydrationListeners.delete(cb);
	      };
	    }
	  };
	  hydrate();
	  return stateFromStorage || configResult;
	};
	const newImpl = (config, baseOptions) => (set, get, api) => {
	  let options = {
	    storage: createJSONStorage(() => localStorage),
	    partialize: (state) => state,
	    version: 0,
	    merge: (persistedState, currentState) => ({
	      ...currentState,
	      ...persistedState
	    }),
	    ...baseOptions
	  };
	  let hasHydrated = false;
	  const hydrationListeners = /* @__PURE__ */ new Set();
	  const finishHydrationListeners = /* @__PURE__ */ new Set();
	  let storage = options.storage;
	  if (!storage) {
	    return config(
	      (...args) => {
	        console.warn(
	          `[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`
	        );
	        set(...args);
	      },
	      get,
	      api
	    );
	  }
	  const setItem = () => {
	    const state = options.partialize({ ...get() });
	    return storage.setItem(options.name, {
	      state,
	      version: options.version
	    });
	  };
	  const savedSetState = api.setState;
	  api.setState = (state, replace) => {
	    savedSetState(state, replace);
	    void setItem();
	  };
	  const configResult = config(
	    (...args) => {
	      set(...args);
	      void setItem();
	    },
	    get,
	    api
	  );
	  let stateFromStorage;
	  const hydrate = () => {
	    var _a, _b;
	    if (!storage)
	      return;
	    hasHydrated = false;
	    hydrationListeners.forEach((cb) => {
	      var _a2;
	      return cb((_a2 = get()) != null ? _a2 : configResult);
	    });
	    const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
	    return toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue) => {
	      if (deserializedStorageValue) {
	        if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
	          if (options.migrate) {
	            return options.migrate(
	              deserializedStorageValue.state,
	              deserializedStorageValue.version
	            );
	          }
	          console.error(
	            `State loaded from storage couldn't be migrated since no migrate function was provided`
	          );
	        } else {
	          return deserializedStorageValue.state;
	        }
	      }
	    }).then((migratedState) => {
	      var _a2;
	      stateFromStorage = options.merge(
	        migratedState,
	        (_a2 = get()) != null ? _a2 : configResult
	      );
	      set(stateFromStorage, true);
	      return setItem();
	    }).then(() => {
	      postRehydrationCallback == null ? void 0 : postRehydrationCallback(stateFromStorage, void 0);
	      stateFromStorage = get();
	      hasHydrated = true;
	      finishHydrationListeners.forEach((cb) => cb(stateFromStorage));
	    }).catch((e) => {
	      postRehydrationCallback == null ? void 0 : postRehydrationCallback(void 0, e);
	    });
	  };
	  api.persist = {
	    setOptions: (newOptions) => {
	      options = {
	        ...options,
	        ...newOptions
	      };
	      if (newOptions.storage) {
	        storage = newOptions.storage;
	      }
	    },
	    clearStorage: () => {
	      storage == null ? void 0 : storage.removeItem(options.name);
	    },
	    getOptions: () => options,
	    rehydrate: () => hydrate(),
	    hasHydrated: () => hasHydrated,
	    onHydrate: (cb) => {
	      hydrationListeners.add(cb);
	      return () => {
	        hydrationListeners.delete(cb);
	      };
	    },
	    onFinishHydration: (cb) => {
	      finishHydrationListeners.add(cb);
	      return () => {
	        finishHydrationListeners.delete(cb);
	      };
	    }
	  };
	  if (!options.skipHydration) {
	    hydrate();
	  }
	  return stateFromStorage || configResult;
	};
	const persistImpl = (config, baseOptions) => {
	  if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
	    if ((undefined ? undefined.MODE : void 0) !== "production") {
	      console.warn(
	        "[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead."
	      );
	    }
	    return oldImpl(config, baseOptions);
	  }
	  return newImpl(config, baseOptions);
	};
	const persist = persistImpl;

	const createStoreImpl = (createState) => {
	  let state;
	  const listeners = /* @__PURE__ */ new Set();
	  const setState = (partial, replace) => {
	    const nextState = typeof partial === "function" ? partial(state) : partial;
	    if (!Object.is(nextState, state)) {
	      const previousState = state;
	      state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
	      listeners.forEach((listener) => listener(state, previousState));
	    }
	  };
	  const getState = () => state;
	  const subscribe = (listener) => {
	    listeners.add(listener);
	    return () => listeners.delete(listener);
	  };
	  const destroy = () => {
	    if ((undefined ? undefined.MODE : void 0) !== "production") {
	      console.warn(
	        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
	      );
	    }
	    listeners.clear();
	  };
	  const api = { setState, getState, subscribe, destroy };
	  state = createState(setState, getState, api);
	  return api;
	};
	const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;

	function shallow(objA, objB) {
	  if (Object.is(objA, objB)) {
	    return true;
	  }
	  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
	    return false;
	  }
	  if (objA instanceof Map && objB instanceof Map) {
	    if (objA.size !== objB.size)
	      return false;
	    for (const [key, value] of objA) {
	      if (!Object.is(value, objB.get(key))) {
	        return false;
	      }
	    }
	    return true;
	  }
	  if (objA instanceof Set && objB instanceof Set) {
	    if (objA.size !== objB.size)
	      return false;
	    for (const value of objA) {
	      if (!objB.has(value)) {
	        return false;
	      }
	    }
	    return true;
	  }
	  const keysA = Object.keys(objA);
	  if (keysA.length !== Object.keys(objB).length) {
	    return false;
	  }
	  for (let i = 0; i < keysA.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	  return true;
	}

	function configureChains(defaultChains, providers, {
	  batch = { multicall: { wait: 32 } },
	  pollingInterval = 4e3,
	  rank,
	  retryCount,
	  retryDelay,
	  stallTimeout
	} = {}) {
	  if (!defaultChains.length)
	    throw new Error("must have at least one chain");
	  let chains = [];
	  const httpUrls = {};
	  const wsUrls = {};
	  for (const chain of defaultChains) {
	    let configExists = false;
	    for (const provider of providers) {
	      const apiConfig = provider(chain);
	      if (!apiConfig)
	        continue;
	      configExists = true;
	      if (!chains.some(({ id }) => id === chain.id)) {
	        chains = [...chains, apiConfig.chain];
	      }
	      httpUrls[chain.id] = [
	        ...httpUrls[chain.id] || [],
	        ...apiConfig.rpcUrls.http
	      ];
	      if (apiConfig.rpcUrls.webSocket) {
	        wsUrls[chain.id] = [
	          ...wsUrls[chain.id] || [],
	          ...apiConfig.rpcUrls.webSocket
	        ];
	      }
	    }
	    if (!configExists) {
	      throw new Error(
	        [
	          `Could not find valid provider configuration for chain "${chain.name}".
`,
	          "You may need to add `jsonRpcProvider` to `configureChains` with the chain's RPC URLs.",
	          "Read more: https://wagmi.sh/core/providers/jsonRpc"
	        ].join("\n")
	      );
	    }
	  }
	  return {
	    chains,
	    publicClient: ({ chainId }) => {
	      const activeChain = chains.find((x) => x.id === chainId) ?? defaultChains[0];
	      const chainHttpUrls = httpUrls[activeChain.id];
	      if (!chainHttpUrls || !chainHttpUrls[0])
	        throw new Error(`No providers configured for chain "${activeChain.id}"`);
	      const publicClient = createPublicClient({
	        batch,
	        chain: activeChain,
	        transport: fallback(
	          chainHttpUrls.map((url) => http(url, { timeout: stallTimeout })),
	          { rank, retryCount, retryDelay }
	        ),
	        pollingInterval
	      });
	      return Object.assign(publicClient, {
	        chains
	      });
	    },
	    webSocketPublicClient: ({ chainId }) => {
	      const activeChain = chains.find((x) => x.id === chainId) ?? defaultChains[0];
	      const chainWsUrls = wsUrls[activeChain.id];
	      if (!chainWsUrls || !chainWsUrls[0])
	        return void 0;
	      const publicClient = createPublicClient({
	        batch,
	        chain: activeChain,
	        transport: fallback(
	          chainWsUrls.map((url) => webSocket(url, { timeout: stallTimeout })),
	          { rank, retryCount, retryDelay }
	        ),
	        pollingInterval
	      });
	      return Object.assign(publicClient, {
	        chains
	      });
	    }
	  };
	}
	var ConnectorAlreadyConnectedError = class extends Error {
	  constructor() {
	    super(...arguments);
	    this.name = "ConnectorAlreadyConnectedError";
	    this.message = "Connector already connected";
	  }
	};

	// src/utils/deserialize.ts
	var findAndReplace = (cacheRef, {
	  find,
	  replace
	}) => {
	  if (cacheRef && find(cacheRef)) {
	    return replace(cacheRef);
	  }
	  if (typeof cacheRef !== "object") {
	    return cacheRef;
	  }
	  if (Array.isArray(cacheRef)) {
	    return cacheRef.map((item) => findAndReplace(item, { find, replace }));
	  }
	  if (cacheRef instanceof Object) {
	    return Object.entries(cacheRef).reduce(
	      (curr, [key, value]) => ({
	        ...curr,
	        [key]: findAndReplace(value, { find, replace })
	      }),
	      {}
	    );
	  }
	  return cacheRef;
	};
	function deserialize(cachedString) {
	  const cache = JSON.parse(cachedString);
	  const deserializedCacheWithBigInts = findAndReplace(cache, {
	    find: (data) => typeof data === "string" && data.startsWith("#bigint."),
	    replace: (data) => BigInt(data.replace("#bigint.", ""))
	  });
	  return deserializedCacheWithBigInts;
	}

	// src/utils/serialize.ts
	function getReferenceKey(keys, cutoff) {
	  return keys.slice(0, cutoff).join(".") || ".";
	}
	function getCutoff(array, value) {
	  const { length } = array;
	  for (let index = 0; index < length; ++index) {
	    if (array[index] === value) {
	      return index + 1;
	    }
	  }
	  return 0;
	}
	function createReplacer(replacer, circularReplacer) {
	  const hasReplacer = typeof replacer === "function";
	  const hasCircularReplacer = typeof circularReplacer === "function";
	  const cache = [];
	  const keys = [];
	  return function replace(key, value) {
	    if (typeof value === "object") {
	      if (cache.length) {
	        const thisCutoff = getCutoff(cache, this);
	        if (thisCutoff === 0) {
	          cache[cache.length] = this;
	        } else {
	          cache.splice(thisCutoff);
	          keys.splice(thisCutoff);
	        }
	        keys[keys.length] = key;
	        const valueCutoff = getCutoff(cache, value);
	        if (valueCutoff !== 0) {
	          return hasCircularReplacer ? circularReplacer.call(
	            this,
	            key,
	            value,
	            getReferenceKey(keys, valueCutoff)
	          ) : `[ref=${getReferenceKey(keys, valueCutoff)}]`;
	        }
	      } else {
	        cache[0] = value;
	        keys[0] = key;
	      }
	    }
	    return hasReplacer ? replacer.call(this, key, value) : value;
	  };
	}
	function serialize(value, replacer, indent, circularReplacer) {
	  return JSON.stringify(
	    value,
	    createReplacer((key, value_) => {
	      const value2 = typeof value_ === "bigint" ? `#bigint.${value_.toString()}` : value_;
	      return replacer?.(key, value2) || value2;
	    }, circularReplacer),
	    indent ?? void 0
	  );
	}

	// src/storage.ts
	var noopStorage = {
	  getItem: (_key) => "",
	  setItem: (_key, _value) => null,
	  removeItem: (_key) => null
	};
	function createStorage({
	  deserialize: deserialize2 = deserialize,
	  key: prefix = "wagmi",
	  serialize: serialize2 = serialize,
	  storage
	}) {
	  return {
	    ...storage,
	    getItem: (key, defaultState = null) => {
	      const value = storage.getItem(`${prefix}.${key}`);
	      try {
	        return value ? deserialize2(value) : defaultState;
	      } catch (error) {
	        console.warn(error);
	        return defaultState;
	      }
	    },
	    setItem: (key, value) => {
	      if (value === null) {
	        storage.removeItem(`${prefix}.${key}`);
	      } else {
	        try {
	          storage.setItem(`${prefix}.${key}`, serialize2(value));
	        } catch (err) {
	          console.error(err);
	        }
	      }
	    },
	    removeItem: (key) => storage.removeItem(`${prefix}.${key}`)
	  };
	}

	// src/config.ts
	var storeKey = "store";
	var _isAutoConnecting, _lastUsedConnector, _addEffects, addEffects_fn;
	var Config = class {
	  constructor({
	    autoConnect = false,
	    connectors = [new InjectedConnector()],
	    publicClient,
	    storage = createStorage({
	      storage: typeof window !== "undefined" ? window.localStorage : noopStorage
	    }),
	    logger = {
	      warn: console.warn
	    },
	    webSocketPublicClient
	  }) {
	    __privateAdd(this, _addEffects);
	    this.publicClients = /* @__PURE__ */ new Map();
	    this.webSocketPublicClients = /* @__PURE__ */ new Map();
	    __privateAdd(this, _isAutoConnecting, void 0);
	    __privateAdd(this, _lastUsedConnector, void 0);
	    this.args = {
	      autoConnect,
	      connectors,
	      logger,
	      publicClient,
	      storage,
	      webSocketPublicClient
	    };
	    let status = "disconnected";
	    let chainId;
	    if (autoConnect) {
	      try {
	        const rawState = storage.getItem(storeKey);
	        const data = rawState?.state?.data;
	        status = data?.account ? "reconnecting" : "connecting";
	        chainId = data?.chain?.id;
	      } catch (_error) {
	      }
	    }
	    const connectors_ = typeof connectors === "function" ? connectors() : connectors;
	    connectors_.forEach((connector) => connector.setStorage(storage));
	    this.store = createStore(
	      subscribeWithSelector(
	        persist(
	          () => ({
	            connectors: connectors_,
	            publicClient: this.getPublicClient({ chainId }),
	            status,
	            webSocketPublicClient: this.getWebSocketPublicClient({ chainId })
	          }),
	          {
	            name: storeKey,
	            storage,
	            partialize: (state) => ({
	              ...autoConnect && {
	                data: {
	                  account: state?.data?.account,
	                  chain: state?.data?.chain
	                }
	              },
	              chains: state?.chains
	            }),
	            version: 2
	          }
	        )
	      )
	    );
	    this.storage = storage;
	    __privateSet(this, _lastUsedConnector, storage?.getItem("wallet"));
	    __privateMethod(this, _addEffects, addEffects_fn).call(this);
	    if (autoConnect && typeof window !== "undefined")
	      setTimeout(async () => await this.autoConnect(), 0);
	  }
	  get chains() {
	    return this.store.getState().chains;
	  }
	  get connectors() {
	    return this.store.getState().connectors;
	  }
	  get connector() {
	    return this.store.getState().connector;
	  }
	  get data() {
	    return this.store.getState().data;
	  }
	  get error() {
	    return this.store.getState().error;
	  }
	  get lastUsedChainId() {
	    return this.data?.chain?.id;
	  }
	  get publicClient() {
	    return this.store.getState().publicClient;
	  }
	  get status() {
	    return this.store.getState().status;
	  }
	  get subscribe() {
	    return this.store.subscribe;
	  }
	  get webSocketPublicClient() {
	    return this.store.getState().webSocketPublicClient;
	  }
	  setState(updater) {
	    const newState = typeof updater === "function" ? updater(this.store.getState()) : updater;
	    this.store.setState(newState, true);
	  }
	  clearState() {
	    this.setState((x) => ({
	      ...x,
	      chains: void 0,
	      connector: void 0,
	      data: void 0,
	      error: void 0,
	      status: "disconnected"
	    }));
	  }
	  async destroy() {
	    if (this.connector)
	      await this.connector.disconnect?.();
	    __privateSet(this, _isAutoConnecting, false);
	    this.clearState();
	    this.store.destroy();
	  }
	  async autoConnect() {
	    if (__privateGet(this, _isAutoConnecting))
	      return;
	    __privateSet(this, _isAutoConnecting, true);
	    this.setState((x) => ({
	      ...x,
	      status: x.data?.account ? "reconnecting" : "connecting"
	    }));
	    const sorted = __privateGet(this, _lastUsedConnector) ? [...this.connectors].sort(
	      (x) => x.id === __privateGet(this, _lastUsedConnector) ? -1 : 1
	    ) : this.connectors;
	    let connected = false;
	    for (const connector of sorted) {
	      if (!connector.ready || !connector.isAuthorized)
	        continue;
	      const isAuthorized = await connector.isAuthorized();
	      if (!isAuthorized)
	        continue;
	      const data = await connector.connect();
	      this.setState((x) => ({
	        ...x,
	        connector,
	        chains: connector?.chains,
	        data,
	        status: "connected"
	      }));
	      connected = true;
	      break;
	    }
	    if (!connected)
	      this.setState((x) => ({
	        ...x,
	        data: void 0,
	        status: "disconnected"
	      }));
	    __privateSet(this, _isAutoConnecting, false);
	    return this.data;
	  }
	  setConnectors(connectors) {
	    this.args = {
	      ...this.args,
	      connectors
	    };
	    const connectors_ = typeof connectors === "function" ? connectors() : connectors;
	    connectors_.forEach((connector) => connector.setStorage(this.args.storage));
	    this.setState((x) => ({
	      ...x,
	      connectors: connectors_
	    }));
	  }
	  getPublicClient({ chainId } = {}) {
	    let publicClient_ = this.publicClients.get(-1);
	    if (publicClient_ && publicClient_?.chain.id === chainId)
	      return publicClient_;
	    publicClient_ = this.publicClients.get(chainId ?? -1);
	    if (publicClient_)
	      return publicClient_;
	    const { publicClient } = this.args;
	    publicClient_ = typeof publicClient === "function" ? publicClient({ chainId }) : publicClient;
	    this.publicClients.set(chainId ?? -1, publicClient_);
	    return publicClient_;
	  }
	  setPublicClient(publicClient) {
	    const chainId = this.data?.chain?.id;
	    this.args = {
	      ...this.args,
	      publicClient
	    };
	    this.publicClients.clear();
	    this.setState((x) => ({
	      ...x,
	      publicClient: this.getPublicClient({ chainId })
	    }));
	  }
	  getWebSocketPublicClient({ chainId } = {}) {
	    let webSocketPublicClient_ = this.webSocketPublicClients.get(-1);
	    if (webSocketPublicClient_ && webSocketPublicClient_?.chain.id === chainId)
	      return webSocketPublicClient_;
	    webSocketPublicClient_ = this.webSocketPublicClients.get(chainId ?? -1);
	    if (webSocketPublicClient_)
	      return webSocketPublicClient_;
	    const { webSocketPublicClient } = this.args;
	    webSocketPublicClient_ = typeof webSocketPublicClient === "function" ? webSocketPublicClient({ chainId }) : webSocketPublicClient;
	    if (webSocketPublicClient_)
	      this.webSocketPublicClients.set(chainId ?? -1, webSocketPublicClient_);
	    return webSocketPublicClient_;
	  }
	  setWebSocketPublicClient(webSocketPublicClient) {
	    const chainId = this.data?.chain?.id;
	    this.args = {
	      ...this.args,
	      webSocketPublicClient
	    };
	    this.webSocketPublicClients.clear();
	    this.setState((x) => ({
	      ...x,
	      webSocketPublicClient: this.getWebSocketPublicClient({
	        chainId
	      })
	    }));
	  }
	  setLastUsedConnector(lastUsedConnector = null) {
	    this.storage?.setItem("wallet", lastUsedConnector);
	  }
	};
	_isAutoConnecting = new WeakMap();
	_lastUsedConnector = new WeakMap();
	_addEffects = new WeakSet();
	addEffects_fn = function() {
	  const onChange = (data) => {
	    this.setState((x) => ({
	      ...x,
	      data: { ...x.data, ...data }
	    }));
	  };
	  const onDisconnect = () => {
	    this.clearState();
	  };
	  const onError = (error) => {
	    this.setState((x) => ({ ...x, error }));
	  };
	  this.store.subscribe(
	    ({ connector }) => connector,
	    (connector, prevConnector) => {
	      prevConnector?.off?.("change", onChange);
	      prevConnector?.off?.("disconnect", onDisconnect);
	      prevConnector?.off?.("error", onError);
	      if (!connector)
	        return;
	      connector.on?.("change", onChange);
	      connector.on?.("disconnect", onDisconnect);
	      connector.on?.("error", onError);
	    }
	  );
	  const { publicClient, webSocketPublicClient } = this.args;
	  const subscribePublicClient = typeof publicClient === "function";
	  const subscribeWebSocketPublicClient = typeof webSocketPublicClient === "function";
	  if (subscribePublicClient || subscribeWebSocketPublicClient)
	    this.store.subscribe(
	      ({ data }) => data?.chain?.id,
	      (chainId) => {
	        this.setState((x) => ({
	          ...x,
	          publicClient: this.getPublicClient({ chainId }),
	          webSocketPublicClient: this.getWebSocketPublicClient({
	            chainId
	          })
	        }));
	      }
	    );
	};
	var config$3;
	function createConfig(args) {
	  const config_ = new Config(args);
	  config$3 = config_;
	  return config_;
	}
	function getConfig() {
	  if (!config$3) {
	    throw new Error(
	      "No wagmi config found. Ensure you have set up a config: https://wagmi.sh/react/config"
	    );
	  }
	  return config$3;
	}

	// src/actions/accounts/connect.ts
	async function connect({ chainId, connector }) {
	  const config2 = getConfig();
	  const activeConnector = config2.connector;
	  if (activeConnector && connector.id === activeConnector.id)
	    throw new ConnectorAlreadyConnectedError();
	  try {
	    config2.setState((x) => ({ ...x, status: "connecting" }));
	    const data = await connector.connect({ chainId });
	    config2.setLastUsedConnector(connector.id);
	    config2.setState((x) => ({
	      ...x,
	      connector,
	      chains: connector?.chains,
	      data,
	      status: "connected"
	    }));
	    config2.storage.setItem("connected", true);
	    return { ...data, connector };
	  } catch (err) {
	    config2.setState((x) => {
	      return {
	        ...x,
	        status: x.connector ? "connected" : "disconnected"
	      };
	    });
	    throw err;
	  }
	}

	// src/actions/accounts/disconnect.ts
	async function disconnect() {
	  const config2 = getConfig();
	  if (config2.connector)
	    await config2.connector.disconnect();
	  config2.clearState();
	  config2.storage.removeItem("connected");
	}

	// src/actions/viem/getWalletClient.ts
	async function getWalletClient({
	  chainId
	} = {}) {
	  const config2 = getConfig();
	  const walletClient = await config2.connector?.getWalletClient?.({ chainId }) || null;
	  return walletClient;
	}

	// src/actions/accounts/getAccount.ts
	function getAccount() {
	  const { data, connector, status } = getConfig();
	  switch (status) {
	    case "connected":
	      return {
	        address: data?.account,
	        connector,
	        isConnected: true,
	        isConnecting: false,
	        isDisconnected: false,
	        isReconnecting: false,
	        status
	      };
	    case "reconnecting":
	      return {
	        address: data?.account,
	        connector,
	        isConnected: !!data?.account,
	        isConnecting: false,
	        isDisconnected: false,
	        isReconnecting: true,
	        status
	      };
	    case "connecting":
	      return {
	        address: data?.account,
	        connector,
	        isConnected: false,
	        isConnecting: true,
	        isDisconnected: false,
	        isReconnecting: false,
	        status
	      };
	    case "disconnected":
	      return {
	        address: void 0,
	        connector: void 0,
	        isConnected: false,
	        isConnecting: false,
	        isDisconnected: true,
	        isReconnecting: false,
	        status
	      };
	  }
	}

	// src/actions/accounts/signMessage.ts
	async function signMessage(args) {
	  const walletClient = await getWalletClient();
	  if (!walletClient)
	    throw new ConnectorNotFoundError();
	  return await walletClient.signMessage({
	    message: args.message
	  });
	}
	function watchAccount(callback, { selector = (x) => x } = {}) {
	  const config2 = getConfig();
	  const handleChange = () => callback(getAccount());
	  const unsubscribe = config2.subscribe(
	    ({ data, connector, status }) => selector({
	      address: data?.account,
	      connector,
	      status
	    }),
	    handleChange,
	    {
	      equalityFn: shallow
	    }
	  );
	  return unsubscribe;
	}

	var _client, _provider$1;
	var CoinbaseWalletConnector = class extends Connector {
	  constructor({ chains, options }) {
	    super({
	      chains,
	      options: {
	        reloadOnDisconnect: false,
	        ...options
	      }
	    });
	    __publicField(this, "id", "coinbaseWallet");
	    __publicField(this, "name", "Coinbase Wallet");
	    __publicField(this, "ready", true);
	    __privateAdd$1(this, _client, void 0);
	    __privateAdd$1(this, _provider$1, void 0);
	    __publicField(this, "onAccountsChanged", (accounts) => {
	      if (accounts.length === 0)
	        this.emit("disconnect");
	      else
	        this.emit("change", { account: getAddress$1(accounts[0]) });
	    });
	    __publicField(this, "onChainChanged", (chainId) => {
	      const id = normalizeChainId(chainId);
	      const unsupported = this.isChainUnsupported(id);
	      this.emit("change", { chain: { id, unsupported } });
	    });
	    __publicField(this, "onDisconnect", () => {
	      this.emit("disconnect");
	    });
	  }
	  async connect({ chainId } = {}) {
	    try {
	      const provider = await this.getProvider();
	      provider.on("accountsChanged", this.onAccountsChanged);
	      provider.on("chainChanged", this.onChainChanged);
	      provider.on("disconnect", this.onDisconnect);
	      this.emit("message", { type: "connecting" });
	      const accounts = await provider.enable();
	      const account = getAddress$1(accounts[0]);
	      let id = await this.getChainId();
	      let unsupported = this.isChainUnsupported(id);
	      if (chainId && id !== chainId) {
	        const chain = await this.switchChain(chainId);
	        id = chain.id;
	        unsupported = this.isChainUnsupported(id);
	      }
	      return {
	        account,
	        chain: { id, unsupported }
	      };
	    } catch (error) {
	      if (/(user closed modal|accounts received is empty)/i.test(
	        error.message
	      ))
	        throw new UserRejectedRequestError(error);
	      throw error;
	    }
	  }
	  async disconnect() {
	    if (!__privateGet$1(this, _provider$1))
	      return;
	    const provider = await this.getProvider();
	    provider.removeListener("accountsChanged", this.onAccountsChanged);
	    provider.removeListener("chainChanged", this.onChainChanged);
	    provider.removeListener("disconnect", this.onDisconnect);
	    provider.disconnect();
	    provider.close();
	  }
	  async getAccount() {
	    const provider = await this.getProvider();
	    const accounts = await provider.request({
	      method: "eth_accounts"
	    });
	    return getAddress$1(accounts[0]);
	  }
	  async getChainId() {
	    const provider = await this.getProvider();
	    const chainId = normalizeChainId(provider.chainId);
	    return chainId;
	  }
	  async getProvider() {
	    if (!__privateGet$1(this, _provider$1)) {
	      let CoinbaseWalletSDK = (await Promise.resolve().then(function () { return index$3; })).default;
	      if (typeof CoinbaseWalletSDK !== "function" && typeof CoinbaseWalletSDK.default === "function")
	        CoinbaseWalletSDK = CoinbaseWalletSDK.default;
	      __privateSet$1(this, _client, new CoinbaseWalletSDK(this.options));
	      const walletExtensionChainId = __privateGet$1(this, _client).walletExtension?.getChainId();
	      const chain = this.chains.find(
	        (chain2) => this.options.chainId ? chain2.id === this.options.chainId : chain2.id === walletExtensionChainId
	      ) || this.chains[0];
	      const chainId = this.options.chainId || chain?.id;
	      const jsonRpcUrl = this.options.jsonRpcUrl || chain?.rpcUrls.default.http[0];
	      __privateSet$1(this, _provider$1, __privateGet$1(this, _client).makeWeb3Provider(jsonRpcUrl, chainId));
	    }
	    return __privateGet$1(this, _provider$1);
	  }
	  async getWalletClient({
	    chainId
	  } = {}) {
	    const [provider, account] = await Promise.all([
	      this.getProvider(),
	      this.getAccount()
	    ]);
	    const chain = this.chains.find((x) => x.id === chainId);
	    if (!provider)
	      throw new Error("provider is required.");
	    return createWalletClient({
	      account,
	      chain,
	      transport: custom(provider)
	    });
	  }
	  async isAuthorized() {
	    try {
	      const account = await this.getAccount();
	      return !!account;
	    } catch {
	      return false;
	    }
	  }
	  async switchChain(chainId) {
	    const provider = await this.getProvider();
	    const id = numberToHex$1(chainId);
	    try {
	      await provider.request({
	        method: "wallet_switchEthereumChain",
	        params: [{ chainId: id }]
	      });
	      return this.chains.find((x) => x.id === chainId) ?? {
	        id: chainId,
	        name: `Chain ${id}`,
	        network: `${id}`,
	        nativeCurrency: { name: "Ether", decimals: 18, symbol: "ETH" },
	        rpcUrls: { default: { http: [""] }, public: { http: [""] } }
	      };
	    } catch (error) {
	      const chain = this.chains.find((x) => x.id === chainId);
	      if (!chain)
	        throw new ChainNotConfiguredForConnectorError({
	          chainId,
	          connectorId: this.id
	        });
	      if (error.code === 4902) {
	        try {
	          await provider.request({
	            method: "wallet_addEthereumChain",
	            params: [
	              {
	                chainId: id,
	                chainName: chain.name,
	                nativeCurrency: chain.nativeCurrency,
	                rpcUrls: [chain.rpcUrls.public?.http[0] ?? ""],
	                blockExplorerUrls: this.getBlockExplorerUrls(chain)
	              }
	            ]
	          });
	          return chain;
	        } catch (error2) {
	          throw new UserRejectedRequestError(error2);
	        }
	      }
	      throw new SwitchChainError(error);
	    }
	  }
	  async watchAsset({
	    address,
	    decimals = 18,
	    image,
	    symbol
	  }) {
	    const provider = await this.getProvider();
	    return provider.request({
	      method: "wallet_watchAsset",
	      params: {
	        type: "ERC20",
	        options: {
	          address,
	          decimals,
	          image,
	          symbol
	        }
	      }
	    });
	  }
	};
	_client = new WeakMap();
	_provider$1 = new WeakMap();

	var _UNSTABLE_shimOnConnectSelectAccount;
	var MetaMaskConnector = class extends InjectedConnector {
	  constructor({
	    chains,
	    options: options_
	  } = {}) {
	    const options = {
	      name: "MetaMask",
	      shimDisconnect: true,
	      getProvider() {
	        function getReady(ethereum2) {
	          const isMetaMask = !!ethereum2?.isMetaMask;
	          if (!isMetaMask)
	            return;
	          if (ethereum2.isBraveWallet && !ethereum2._events && !ethereum2._state)
	            return;
	          if (ethereum2.isApexWallet)
	            return;
	          if (ethereum2.isAvalanche)
	            return;
	          if (ethereum2.isBitKeep)
	            return;
	          if (ethereum2.isBlockWallet)
	            return;
	          if (ethereum2.isMathWallet)
	            return;
	          if (ethereum2.isOkxWallet || ethereum2.isOKExWallet)
	            return;
	          if (ethereum2.isOneInchIOSWallet || ethereum2.isOneInchAndroidWallet)
	            return;
	          if (ethereum2.isOpera)
	            return;
	          if (ethereum2.isPortal)
	            return;
	          if (ethereum2.isRabby)
	            return;
	          if (ethereum2.isDefiant)
	            return;
	          if (ethereum2.isTokenPocket)
	            return;
	          if (ethereum2.isTokenary)
	            return;
	          if (ethereum2.isZerion)
	            return;
	          return ethereum2;
	        }
	        if (typeof window === "undefined")
	          return;
	        const ethereum = window.ethereum;
	        if (ethereum?.providers)
	          return ethereum.providers.find(getReady);
	        return getReady(ethereum);
	      },
	      ...options_
	    };
	    super({ chains, options });
	    __publicField(this, "id", "metaMask");
	    __publicField(this, "shimDisconnectKey", `${this.id}.shimDisconnect`);
	    __privateAdd$1(this, _UNSTABLE_shimOnConnectSelectAccount, void 0);
	    __privateSet$1(this, _UNSTABLE_shimOnConnectSelectAccount, options.UNSTABLE_shimOnConnectSelectAccount);
	  }
	  async connect({ chainId } = {}) {
	    try {
	      const provider = await this.getProvider();
	      if (!provider)
	        throw new ConnectorNotFoundError();
	      if (provider.on) {
	        provider.on("accountsChanged", this.onAccountsChanged);
	        provider.on("chainChanged", this.onChainChanged);
	        provider.on("disconnect", this.onDisconnect);
	      }
	      this.emit("message", { type: "connecting" });
	      let account = null;
	      if (__privateGet$1(this, _UNSTABLE_shimOnConnectSelectAccount) && this.options?.shimDisconnect && !this.storage?.getItem(this.shimDisconnectKey)) {
	        account = await this.getAccount().catch(() => null);
	        const isConnected = !!account;
	        if (isConnected)
	          try {
	            await provider.request({
	              method: "wallet_requestPermissions",
	              params: [{ eth_accounts: {} }]
	            });
	            account = await this.getAccount();
	          } catch (error) {
	            if (this.isUserRejectedRequestError(error))
	              throw new UserRejectedRequestError(error);
	            if (error.code === new ResourceUnavailableRpcError(error).code)
	              throw error;
	          }
	      }
	      if (!account) {
	        const accounts = await provider.request({
	          method: "eth_requestAccounts"
	        });
	        account = getAddress$1(accounts[0]);
	      }
	      let id = await this.getChainId();
	      let unsupported = this.isChainUnsupported(id);
	      if (chainId && id !== chainId) {
	        const chain = await this.switchChain(chainId);
	        id = chain.id;
	        unsupported = this.isChainUnsupported(id);
	      }
	      if (this.options?.shimDisconnect)
	        this.storage?.setItem(this.shimDisconnectKey, true);
	      return { account, chain: { id, unsupported }, provider };
	    } catch (error) {
	      if (this.isUserRejectedRequestError(error))
	        throw new UserRejectedRequestError(error);
	      if (error.code === -32002)
	        throw new ResourceUnavailableRpcError(error);
	      throw error;
	    }
	  }
	};
	_UNSTABLE_shimOnConnectSelectAccount = new WeakMap();

	var chacha20poly1305 = {};

	var chacha = {};

	var binary = {};

	var int = {};

	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		/**
		 * Package int provides helper functions for integerss.
		 */
		// Shim using 16-bit pieces.
		function imulShim(a, b) {
		    var ah = (a >>> 16) & 0xffff, al = a & 0xffff;
		    var bh = (b >>> 16) & 0xffff, bl = b & 0xffff;
		    return ((al * bl) + (((ah * bl + al * bh) << 16) >>> 0) | 0);
		}
		/** 32-bit integer multiplication.  */
		// Use system Math.imul if available, otherwise use our shim.
		exports.mul = Math.imul || imulShim;
		/** 32-bit integer addition.  */
		function add(a, b) {
		    return (a + b) | 0;
		}
		exports.add = add;
		/**  32-bit integer subtraction.  */
		function sub(a, b) {
		    return (a - b) | 0;
		}
		exports.sub = sub;
		/** 32-bit integer left rotation */
		function rotl(x, n) {
		    return x << n | x >>> (32 - n);
		}
		exports.rotl = rotl;
		/** 32-bit integer left rotation */
		function rotr(x, n) {
		    return x << (32 - n) | x >>> n;
		}
		exports.rotr = rotr;
		function isIntegerShim(n) {
		    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
		}
		/**
		 * Returns true if the argument is an integer number.
		 *
		 * In ES2015, Number.isInteger.
		 */
		exports.isInteger = Number.isInteger || isIntegerShim;
		/**
		 *  Math.pow(2, 53) - 1
		 *
		 *  In ES2015 Number.MAX_SAFE_INTEGER.
		 */
		exports.MAX_SAFE_INTEGER = 9007199254740991;
		/**
		 * Returns true if the argument is a safe integer number
		 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
		 *
		 * In ES2015, Number.isSafeInteger.
		 */
		exports.isSafeInteger = function (n) {
		    return exports.isInteger(n) && (n >= -exports.MAX_SAFE_INTEGER && n <= exports.MAX_SAFE_INTEGER);
		};
		
	} (int));

	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(binary, "__esModule", { value: true });
	/**
	 * Package binary provides functions for encoding and decoding numbers in byte arrays.
	 */
	var int_1 = int;
	// TODO(dchest): add asserts for correct value ranges and array offsets.
	/**
	 * Reads 2 bytes from array starting at offset as big-endian
	 * signed 16-bit integer and returns it.
	 */
	function readInt16BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return (((array[offset + 0] << 8) | array[offset + 1]) << 16) >> 16;
	}
	binary.readInt16BE = readInt16BE;
	/**
	 * Reads 2 bytes from array starting at offset as big-endian
	 * unsigned 16-bit integer and returns it.
	 */
	function readUint16BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return ((array[offset + 0] << 8) | array[offset + 1]) >>> 0;
	}
	binary.readUint16BE = readUint16BE;
	/**
	 * Reads 2 bytes from array starting at offset as little-endian
	 * signed 16-bit integer and returns it.
	 */
	function readInt16LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return (((array[offset + 1] << 8) | array[offset]) << 16) >> 16;
	}
	binary.readInt16LE = readInt16LE;
	/**
	 * Reads 2 bytes from array starting at offset as little-endian
	 * unsigned 16-bit integer and returns it.
	 */
	function readUint16LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return ((array[offset + 1] << 8) | array[offset]) >>> 0;
	}
	binary.readUint16LE = readUint16LE;
	/**
	 * Writes 2-byte big-endian representation of 16-bit unsigned
	 * value to byte array starting at offset.
	 *
	 * If byte array is not given, creates a new 2-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeUint16BE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(2); }
	    if (offset === void 0) { offset = 0; }
	    out[offset + 0] = value >>> 8;
	    out[offset + 1] = value >>> 0;
	    return out;
	}
	binary.writeUint16BE = writeUint16BE;
	binary.writeInt16BE = writeUint16BE;
	/**
	 * Writes 2-byte little-endian representation of 16-bit unsigned
	 * value to array starting at offset.
	 *
	 * If byte array is not given, creates a new 2-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeUint16LE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(2); }
	    if (offset === void 0) { offset = 0; }
	    out[offset + 0] = value >>> 0;
	    out[offset + 1] = value >>> 8;
	    return out;
	}
	binary.writeUint16LE = writeUint16LE;
	binary.writeInt16LE = writeUint16LE;
	/**
	 * Reads 4 bytes from array starting at offset as big-endian
	 * signed 32-bit integer and returns it.
	 */
	function readInt32BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return (array[offset] << 24) |
	        (array[offset + 1] << 16) |
	        (array[offset + 2] << 8) |
	        array[offset + 3];
	}
	binary.readInt32BE = readInt32BE;
	/**
	 * Reads 4 bytes from array starting at offset as big-endian
	 * unsigned 32-bit integer and returns it.
	 */
	function readUint32BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return ((array[offset] << 24) |
	        (array[offset + 1] << 16) |
	        (array[offset + 2] << 8) |
	        array[offset + 3]) >>> 0;
	}
	binary.readUint32BE = readUint32BE;
	/**
	 * Reads 4 bytes from array starting at offset as little-endian
	 * signed 32-bit integer and returns it.
	 */
	function readInt32LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return (array[offset + 3] << 24) |
	        (array[offset + 2] << 16) |
	        (array[offset + 1] << 8) |
	        array[offset];
	}
	binary.readInt32LE = readInt32LE;
	/**
	 * Reads 4 bytes from array starting at offset as little-endian
	 * unsigned 32-bit integer and returns it.
	 */
	function readUint32LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return ((array[offset + 3] << 24) |
	        (array[offset + 2] << 16) |
	        (array[offset + 1] << 8) |
	        array[offset]) >>> 0;
	}
	binary.readUint32LE = readUint32LE;
	/**
	 * Writes 4-byte big-endian representation of 32-bit unsigned
	 * value to byte array starting at offset.
	 *
	 * If byte array is not given, creates a new 4-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeUint32BE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(4); }
	    if (offset === void 0) { offset = 0; }
	    out[offset + 0] = value >>> 24;
	    out[offset + 1] = value >>> 16;
	    out[offset + 2] = value >>> 8;
	    out[offset + 3] = value >>> 0;
	    return out;
	}
	binary.writeUint32BE = writeUint32BE;
	binary.writeInt32BE = writeUint32BE;
	/**
	 * Writes 4-byte little-endian representation of 32-bit unsigned
	 * value to array starting at offset.
	 *
	 * If byte array is not given, creates a new 4-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeUint32LE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(4); }
	    if (offset === void 0) { offset = 0; }
	    out[offset + 0] = value >>> 0;
	    out[offset + 1] = value >>> 8;
	    out[offset + 2] = value >>> 16;
	    out[offset + 3] = value >>> 24;
	    return out;
	}
	binary.writeUint32LE = writeUint32LE;
	binary.writeInt32LE = writeUint32LE;
	/**
	 * Reads 8 bytes from array starting at offset as big-endian
	 * signed 64-bit integer and returns it.
	 *
	 * IMPORTANT: due to JavaScript limitation, supports exact
	 * numbers in range -9007199254740991 to 9007199254740991.
	 * If the number stored in the byte array is outside this range,
	 * the result is not exact.
	 */
	function readInt64BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var hi = readInt32BE(array, offset);
	    var lo = readInt32BE(array, offset + 4);
	    return hi * 0x100000000 + lo - ((lo >> 31) * 0x100000000);
	}
	binary.readInt64BE = readInt64BE;
	/**
	 * Reads 8 bytes from array starting at offset as big-endian
	 * unsigned 64-bit integer and returns it.
	 *
	 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
	 */
	function readUint64BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var hi = readUint32BE(array, offset);
	    var lo = readUint32BE(array, offset + 4);
	    return hi * 0x100000000 + lo;
	}
	binary.readUint64BE = readUint64BE;
	/**
	 * Reads 8 bytes from array starting at offset as little-endian
	 * signed 64-bit integer and returns it.
	 *
	 * IMPORTANT: due to JavaScript limitation, supports exact
	 * numbers in range -9007199254740991 to 9007199254740991.
	 * If the number stored in the byte array is outside this range,
	 * the result is not exact.
	 */
	function readInt64LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var lo = readInt32LE(array, offset);
	    var hi = readInt32LE(array, offset + 4);
	    return hi * 0x100000000 + lo - ((lo >> 31) * 0x100000000);
	}
	binary.readInt64LE = readInt64LE;
	/**
	 * Reads 8 bytes from array starting at offset as little-endian
	 * unsigned 64-bit integer and returns it.
	 *
	 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
	 */
	function readUint64LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var lo = readUint32LE(array, offset);
	    var hi = readUint32LE(array, offset + 4);
	    return hi * 0x100000000 + lo;
	}
	binary.readUint64LE = readUint64LE;
	/**
	 * Writes 8-byte big-endian representation of 64-bit unsigned
	 * value to byte array starting at offset.
	 *
	 * Due to JavaScript limitation, supports values up to 2^53-1.
	 *
	 * If byte array is not given, creates a new 8-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeUint64BE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(8); }
	    if (offset === void 0) { offset = 0; }
	    writeUint32BE(value / 0x100000000 >>> 0, out, offset);
	    writeUint32BE(value >>> 0, out, offset + 4);
	    return out;
	}
	binary.writeUint64BE = writeUint64BE;
	binary.writeInt64BE = writeUint64BE;
	/**
	 * Writes 8-byte little-endian representation of 64-bit unsigned
	 * value to byte array starting at offset.
	 *
	 * Due to JavaScript limitation, supports values up to 2^53-1.
	 *
	 * If byte array is not given, creates a new 8-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeUint64LE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(8); }
	    if (offset === void 0) { offset = 0; }
	    writeUint32LE(value >>> 0, out, offset);
	    writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
	    return out;
	}
	binary.writeUint64LE = writeUint64LE;
	binary.writeInt64LE = writeUint64LE;
	/**
	 * Reads bytes from array starting at offset as big-endian
	 * unsigned bitLen-bit integer and returns it.
	 *
	 * Supports bit lengths divisible by 8, up to 48.
	 */
	function readUintBE(bitLength, array, offset) {
	    if (offset === void 0) { offset = 0; }
	    // TODO(dchest): implement support for bitLengths non-divisible by 8
	    if (bitLength % 8 !== 0) {
	        throw new Error("readUintBE supports only bitLengths divisible by 8");
	    }
	    if (bitLength / 8 > array.length - offset) {
	        throw new Error("readUintBE: array is too short for the given bitLength");
	    }
	    var result = 0;
	    var mul = 1;
	    for (var i = bitLength / 8 + offset - 1; i >= offset; i--) {
	        result += array[i] * mul;
	        mul *= 256;
	    }
	    return result;
	}
	binary.readUintBE = readUintBE;
	/**
	 * Reads bytes from array starting at offset as little-endian
	 * unsigned bitLen-bit integer and returns it.
	 *
	 * Supports bit lengths divisible by 8, up to 48.
	 */
	function readUintLE(bitLength, array, offset) {
	    if (offset === void 0) { offset = 0; }
	    // TODO(dchest): implement support for bitLengths non-divisible by 8
	    if (bitLength % 8 !== 0) {
	        throw new Error("readUintLE supports only bitLengths divisible by 8");
	    }
	    if (bitLength / 8 > array.length - offset) {
	        throw new Error("readUintLE: array is too short for the given bitLength");
	    }
	    var result = 0;
	    var mul = 1;
	    for (var i = offset; i < offset + bitLength / 8; i++) {
	        result += array[i] * mul;
	        mul *= 256;
	    }
	    return result;
	}
	binary.readUintLE = readUintLE;
	/**
	 * Writes a big-endian representation of bitLen-bit unsigned
	 * value to array starting at offset.
	 *
	 * Supports bit lengths divisible by 8, up to 48.
	 *
	 * If byte array is not given, creates a new one.
	 *
	 * Returns the output byte array.
	 */
	function writeUintBE(bitLength, value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(bitLength / 8); }
	    if (offset === void 0) { offset = 0; }
	    // TODO(dchest): implement support for bitLengths non-divisible by 8
	    if (bitLength % 8 !== 0) {
	        throw new Error("writeUintBE supports only bitLengths divisible by 8");
	    }
	    if (!int_1.isSafeInteger(value)) {
	        throw new Error("writeUintBE value must be an integer");
	    }
	    var div = 1;
	    for (var i = bitLength / 8 + offset - 1; i >= offset; i--) {
	        out[i] = (value / div) & 0xff;
	        div *= 256;
	    }
	    return out;
	}
	binary.writeUintBE = writeUintBE;
	/**
	 * Writes a little-endian representation of bitLen-bit unsigned
	 * value to array starting at offset.
	 *
	 * Supports bit lengths divisible by 8, up to 48.
	 *
	 * If byte array is not given, creates a new one.
	 *
	 * Returns the output byte array.
	 */
	function writeUintLE(bitLength, value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(bitLength / 8); }
	    if (offset === void 0) { offset = 0; }
	    // TODO(dchest): implement support for bitLengths non-divisible by 8
	    if (bitLength % 8 !== 0) {
	        throw new Error("writeUintLE supports only bitLengths divisible by 8");
	    }
	    if (!int_1.isSafeInteger(value)) {
	        throw new Error("writeUintLE value must be an integer");
	    }
	    var div = 1;
	    for (var i = offset; i < offset + bitLength / 8; i++) {
	        out[i] = (value / div) & 0xff;
	        div *= 256;
	    }
	    return out;
	}
	binary.writeUintLE = writeUintLE;
	/**
	 * Reads 4 bytes from array starting at offset as big-endian
	 * 32-bit floating-point number and returns it.
	 */
	function readFloat32BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
	    return view.getFloat32(offset);
	}
	binary.readFloat32BE = readFloat32BE;
	/**
	 * Reads 4 bytes from array starting at offset as little-endian
	 * 32-bit floating-point number and returns it.
	 */
	function readFloat32LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
	    return view.getFloat32(offset, true);
	}
	binary.readFloat32LE = readFloat32LE;
	/**
	 * Reads 8 bytes from array starting at offset as big-endian
	 * 64-bit floating-point number ("double") and returns it.
	 */
	function readFloat64BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
	    return view.getFloat64(offset);
	}
	binary.readFloat64BE = readFloat64BE;
	/**
	 * Reads 8 bytes from array starting at offset as little-endian
	 * 64-bit floating-point number ("double") and returns it.
	 */
	function readFloat64LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
	    return view.getFloat64(offset, true);
	}
	binary.readFloat64LE = readFloat64LE;
	/**
	 * Writes 4-byte big-endian floating-point representation of value
	 * to byte array starting at offset.
	 *
	 * If byte array is not given, creates a new 4-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeFloat32BE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(4); }
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
	    view.setFloat32(offset, value);
	    return out;
	}
	binary.writeFloat32BE = writeFloat32BE;
	/**
	 * Writes 4-byte little-endian floating-point representation of value
	 * to byte array starting at offset.
	 *
	 * If byte array is not given, creates a new 4-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeFloat32LE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(4); }
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
	    view.setFloat32(offset, value, true);
	    return out;
	}
	binary.writeFloat32LE = writeFloat32LE;
	/**
	 * Writes 8-byte big-endian floating-point representation of value
	 * to byte array starting at offset.
	 *
	 * If byte array is not given, creates a new 8-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeFloat64BE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(8); }
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
	    view.setFloat64(offset, value);
	    return out;
	}
	binary.writeFloat64BE = writeFloat64BE;
	/**
	 * Writes 8-byte little-endian floating-point representation of value
	 * to byte array starting at offset.
	 *
	 * If byte array is not given, creates a new 8-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeFloat64LE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(8); }
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
	    view.setFloat64(offset, value, true);
	    return out;
	}
	binary.writeFloat64LE = writeFloat64LE;

	var wipe$1 = {};

	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(wipe$1, "__esModule", { value: true });
	/**
	 * Sets all values in the given array to zero and returns it.
	 *
	 * The fact that it sets bytes to zero can be relied on.
	 *
	 * There is no guarantee that this function makes data disappear from memory,
	 * as runtime implementation can, for example, have copying garbage collector
	 * that will make copies of sensitive data before we wipe it. Or that an
	 * operating system will write our data to swap or sleep image. Another thing
	 * is that an optimizing compiler can remove calls to this function or make it
	 * no-op. There's nothing we can do with it, so we just do our best and hope
	 * that everything will be okay and good will triumph over evil.
	 */
	function wipe(array) {
	    // Right now it's similar to array.fill(0). If it turns
	    // out that runtimes optimize this call away, maybe
	    // we can try something else.
	    for (var i = 0; i < array.length; i++) {
	        array[i] = 0;
	    }
	    return array;
	}
	wipe$1.wipe = wipe;

	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(chacha, "__esModule", { value: true });
	/**
	 * Package chacha implements ChaCha stream cipher.
	 */
	var binary_1 = binary;
	var wipe_1$3 = wipe$1;
	// Number of ChaCha rounds (ChaCha20).
	var ROUNDS = 20;
	// Applies the ChaCha core function to 16-byte input,
	// 32-byte key key, and puts the result into 64-byte array out.
	function core(out, input, key) {
	    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
	    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
	    var j2 = 0x79622D32; // "2-by"
	    var j3 = 0x6B206574; // "te k"
	    var j4 = (key[3] << 24) | (key[2] << 16) | (key[1] << 8) | key[0];
	    var j5 = (key[7] << 24) | (key[6] << 16) | (key[5] << 8) | key[4];
	    var j6 = (key[11] << 24) | (key[10] << 16) | (key[9] << 8) | key[8];
	    var j7 = (key[15] << 24) | (key[14] << 16) | (key[13] << 8) | key[12];
	    var j8 = (key[19] << 24) | (key[18] << 16) | (key[17] << 8) | key[16];
	    var j9 = (key[23] << 24) | (key[22] << 16) | (key[21] << 8) | key[20];
	    var j10 = (key[27] << 24) | (key[26] << 16) | (key[25] << 8) | key[24];
	    var j11 = (key[31] << 24) | (key[30] << 16) | (key[29] << 8) | key[28];
	    var j12 = (input[3] << 24) | (input[2] << 16) | (input[1] << 8) | input[0];
	    var j13 = (input[7] << 24) | (input[6] << 16) | (input[5] << 8) | input[4];
	    var j14 = (input[11] << 24) | (input[10] << 16) | (input[9] << 8) | input[8];
	    var j15 = (input[15] << 24) | (input[14] << 16) | (input[13] << 8) | input[12];
	    var x0 = j0;
	    var x1 = j1;
	    var x2 = j2;
	    var x3 = j3;
	    var x4 = j4;
	    var x5 = j5;
	    var x6 = j6;
	    var x7 = j7;
	    var x8 = j8;
	    var x9 = j9;
	    var x10 = j10;
	    var x11 = j11;
	    var x12 = j12;
	    var x13 = j13;
	    var x14 = j14;
	    var x15 = j15;
	    for (var i = 0; i < ROUNDS; i += 2) {
	        x0 = x0 + x4 | 0;
	        x12 ^= x0;
	        x12 = x12 >>> (32 - 16) | x12 << 16;
	        x8 = x8 + x12 | 0;
	        x4 ^= x8;
	        x4 = x4 >>> (32 - 12) | x4 << 12;
	        x1 = x1 + x5 | 0;
	        x13 ^= x1;
	        x13 = x13 >>> (32 - 16) | x13 << 16;
	        x9 = x9 + x13 | 0;
	        x5 ^= x9;
	        x5 = x5 >>> (32 - 12) | x5 << 12;
	        x2 = x2 + x6 | 0;
	        x14 ^= x2;
	        x14 = x14 >>> (32 - 16) | x14 << 16;
	        x10 = x10 + x14 | 0;
	        x6 ^= x10;
	        x6 = x6 >>> (32 - 12) | x6 << 12;
	        x3 = x3 + x7 | 0;
	        x15 ^= x3;
	        x15 = x15 >>> (32 - 16) | x15 << 16;
	        x11 = x11 + x15 | 0;
	        x7 ^= x11;
	        x7 = x7 >>> (32 - 12) | x7 << 12;
	        x2 = x2 + x6 | 0;
	        x14 ^= x2;
	        x14 = x14 >>> (32 - 8) | x14 << 8;
	        x10 = x10 + x14 | 0;
	        x6 ^= x10;
	        x6 = x6 >>> (32 - 7) | x6 << 7;
	        x3 = x3 + x7 | 0;
	        x15 ^= x3;
	        x15 = x15 >>> (32 - 8) | x15 << 8;
	        x11 = x11 + x15 | 0;
	        x7 ^= x11;
	        x7 = x7 >>> (32 - 7) | x7 << 7;
	        x1 = x1 + x5 | 0;
	        x13 ^= x1;
	        x13 = x13 >>> (32 - 8) | x13 << 8;
	        x9 = x9 + x13 | 0;
	        x5 ^= x9;
	        x5 = x5 >>> (32 - 7) | x5 << 7;
	        x0 = x0 + x4 | 0;
	        x12 ^= x0;
	        x12 = x12 >>> (32 - 8) | x12 << 8;
	        x8 = x8 + x12 | 0;
	        x4 ^= x8;
	        x4 = x4 >>> (32 - 7) | x4 << 7;
	        x0 = x0 + x5 | 0;
	        x15 ^= x0;
	        x15 = x15 >>> (32 - 16) | x15 << 16;
	        x10 = x10 + x15 | 0;
	        x5 ^= x10;
	        x5 = x5 >>> (32 - 12) | x5 << 12;
	        x1 = x1 + x6 | 0;
	        x12 ^= x1;
	        x12 = x12 >>> (32 - 16) | x12 << 16;
	        x11 = x11 + x12 | 0;
	        x6 ^= x11;
	        x6 = x6 >>> (32 - 12) | x6 << 12;
	        x2 = x2 + x7 | 0;
	        x13 ^= x2;
	        x13 = x13 >>> (32 - 16) | x13 << 16;
	        x8 = x8 + x13 | 0;
	        x7 ^= x8;
	        x7 = x7 >>> (32 - 12) | x7 << 12;
	        x3 = x3 + x4 | 0;
	        x14 ^= x3;
	        x14 = x14 >>> (32 - 16) | x14 << 16;
	        x9 = x9 + x14 | 0;
	        x4 ^= x9;
	        x4 = x4 >>> (32 - 12) | x4 << 12;
	        x2 = x2 + x7 | 0;
	        x13 ^= x2;
	        x13 = x13 >>> (32 - 8) | x13 << 8;
	        x8 = x8 + x13 | 0;
	        x7 ^= x8;
	        x7 = x7 >>> (32 - 7) | x7 << 7;
	        x3 = x3 + x4 | 0;
	        x14 ^= x3;
	        x14 = x14 >>> (32 - 8) | x14 << 8;
	        x9 = x9 + x14 | 0;
	        x4 ^= x9;
	        x4 = x4 >>> (32 - 7) | x4 << 7;
	        x1 = x1 + x6 | 0;
	        x12 ^= x1;
	        x12 = x12 >>> (32 - 8) | x12 << 8;
	        x11 = x11 + x12 | 0;
	        x6 ^= x11;
	        x6 = x6 >>> (32 - 7) | x6 << 7;
	        x0 = x0 + x5 | 0;
	        x15 ^= x0;
	        x15 = x15 >>> (32 - 8) | x15 << 8;
	        x10 = x10 + x15 | 0;
	        x5 ^= x10;
	        x5 = x5 >>> (32 - 7) | x5 << 7;
	    }
	    binary_1.writeUint32LE(x0 + j0 | 0, out, 0);
	    binary_1.writeUint32LE(x1 + j1 | 0, out, 4);
	    binary_1.writeUint32LE(x2 + j2 | 0, out, 8);
	    binary_1.writeUint32LE(x3 + j3 | 0, out, 12);
	    binary_1.writeUint32LE(x4 + j4 | 0, out, 16);
	    binary_1.writeUint32LE(x5 + j5 | 0, out, 20);
	    binary_1.writeUint32LE(x6 + j6 | 0, out, 24);
	    binary_1.writeUint32LE(x7 + j7 | 0, out, 28);
	    binary_1.writeUint32LE(x8 + j8 | 0, out, 32);
	    binary_1.writeUint32LE(x9 + j9 | 0, out, 36);
	    binary_1.writeUint32LE(x10 + j10 | 0, out, 40);
	    binary_1.writeUint32LE(x11 + j11 | 0, out, 44);
	    binary_1.writeUint32LE(x12 + j12 | 0, out, 48);
	    binary_1.writeUint32LE(x13 + j13 | 0, out, 52);
	    binary_1.writeUint32LE(x14 + j14 | 0, out, 56);
	    binary_1.writeUint32LE(x15 + j15 | 0, out, 60);
	}
	/**
	 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
	 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
	 * write the result into dst and return it.
	 *
	 * dst and src may be the same, but otherwise must not overlap.
	 *
	 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
	 * same key and nonce, otherwise the stream will repeat. The function will
	 * throw error if counter overflows to prevent this.
	 *
	 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
	 * is more than a million petabytes). However, it is not recommended to
	 * generate 8-byte nonces randomly, as the chance of collision is high.
	 *
	 * Never use the same key and nonce to encrypt more than one message.
	 *
	 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
	 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
	 * in the last remaining bytes. The counter will be incremented inplace for
	 * each ChaCha block. This is useful if you need to encrypt one stream of data
	 * in chunks.
	 */
	function streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
	    if (nonceInplaceCounterLength === void 0) { nonceInplaceCounterLength = 0; }
	    // We only support 256-bit keys.
	    if (key.length !== 32) {
	        throw new Error("ChaCha: key size must be 32 bytes");
	    }
	    if (dst.length < src.length) {
	        throw new Error("ChaCha: destination is shorter than source");
	    }
	    var nc;
	    var counterLength;
	    if (nonceInplaceCounterLength === 0) {
	        if (nonce.length !== 8 && nonce.length !== 12) {
	            throw new Error("ChaCha nonce must be 8 or 12 bytes");
	        }
	        nc = new Uint8Array(16);
	        // First counterLength bytes of nc are counter, starting with zero.
	        counterLength = nc.length - nonce.length;
	        // Last bytes of nc after counterLength are nonce, set them.
	        nc.set(nonce, counterLength);
	    }
	    else {
	        if (nonce.length !== 16) {
	            throw new Error("ChaCha nonce with counter must be 16 bytes");
	        }
	        // This will update passed nonce with counter inplace.
	        nc = nonce;
	        counterLength = nonceInplaceCounterLength;
	    }
	    // Allocate temporary space for ChaCha block.
	    var block = new Uint8Array(64);
	    for (var i = 0; i < src.length; i += 64) {
	        // Generate a block.
	        core(block, nc, key);
	        // XOR block bytes with src into dst.
	        for (var j = i; j < i + 64 && j < src.length; j++) {
	            dst[j] = src[j] ^ block[j - i];
	        }
	        // Increment counter.
	        incrementCounter(nc, 0, counterLength);
	    }
	    // Cleanup temporary space.
	    wipe_1$3.wipe(block);
	    if (nonceInplaceCounterLength === 0) {
	        // Cleanup counter.
	        wipe_1$3.wipe(nc);
	    }
	    return dst;
	}
	chacha.streamXOR = streamXOR;
	/**
	 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
	 * nonce and write it into dst and return it.
	 *
	 * Never use the same key and nonce to generate more than one stream.
	 *
	 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
	 * the nonce as described in the streamXOR documentation.
	 *
	 * stream is like streamXOR with all-zero src.
	 */
	function stream(key, nonce, dst, nonceInplaceCounterLength) {
	    if (nonceInplaceCounterLength === void 0) { nonceInplaceCounterLength = 0; }
	    wipe_1$3.wipe(dst);
	    return streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
	}
	chacha.stream = stream;
	function incrementCounter(counter, pos, len) {
	    var carry = 1;
	    while (len--) {
	        carry = carry + (counter[pos] & 0xff) | 0;
	        counter[pos] = carry & 0xff;
	        carry >>>= 8;
	        pos++;
	    }
	    if (carry > 0) {
	        throw new Error("ChaCha: counter overflow");
	    }
	}

	var poly1305 = {};

	var constantTime = {};

	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(constantTime, "__esModule", { value: true });
	/**
	 * Package constant-time provides functions for performing algorithmically constant-time operations.
	 */
	/**
	 * NOTE! Due to the inability to guarantee real constant time evaluation of
	 * anything in JavaScript VM, this is module is the best effort.
	 */
	/**
	 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
	 *
	 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
	 * integers, they'll be converted to them with bitwise operations.
	 */
	function select(subject, resultIfOne, resultIfZero) {
	    return (~(subject - 1) & resultIfOne) | ((subject - 1) & resultIfZero);
	}
	constantTime.select = select;
	/**
	 * Returns 1 if a <= b, or 0 if not.
	 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
	 */
	function lessOrEqual(a, b) {
	    return (((a | 0) - (b | 0) - 1) >>> 31) & 1;
	}
	constantTime.lessOrEqual = lessOrEqual;
	/**
	 * Returns 1 if a and b are of equal length and their contents
	 * are equal, or 0 otherwise.
	 *
	 * Note that unlike in equal(), zero-length inputs are considered
	 * the same, so this function will return 1.
	 */
	function compare$c(a, b) {
	    if (a.length !== b.length) {
	        return 0;
	    }
	    var result = 0;
	    for (var i = 0; i < a.length; i++) {
	        result |= a[i] ^ b[i];
	    }
	    return (1 & ((result - 1) >>> 8));
	}
	constantTime.compare = compare$c;
	/**
	 * Returns true if a and b are of equal non-zero length,
	 * and their contents are equal, or false otherwise.
	 *
	 * Note that unlike in compare() zero-length inputs are considered
	 * _not_ equal, so this function will return false.
	 */
	function equal(a, b) {
	    if (a.length === 0 || b.length === 0) {
	        return false;
	    }
	    return compare$c(a, b) !== 0;
	}
	constantTime.equal = equal;

	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		/**
		 * Package poly1305 implements Poly1305 one-time message authentication algorithm.
		 */
		var constant_time_1 = constantTime;
		var wipe_1 = wipe$1;
		exports.DIGEST_LENGTH = 16;
		// Port of Andrew Moon's Poly1305-donna-16. Public domain.
		// https://github.com/floodyberry/poly1305-donna
		/**
		 * Poly1305 computes 16-byte authenticator of message using
		 * a one-time 32-byte key.
		 *
		 * Important: key should be used for only one message,
		 * it should never repeat.
		 */
		var Poly1305 = /** @class */ (function () {
		    function Poly1305(key) {
		        this.digestLength = exports.DIGEST_LENGTH;
		        this._buffer = new Uint8Array(16);
		        this._r = new Uint16Array(10);
		        this._h = new Uint16Array(10);
		        this._pad = new Uint16Array(8);
		        this._leftover = 0;
		        this._fin = 0;
		        this._finished = false;
		        var t0 = key[0] | key[1] << 8;
		        this._r[0] = (t0) & 0x1fff;
		        var t1 = key[2] | key[3] << 8;
		        this._r[1] = ((t0 >>> 13) | (t1 << 3)) & 0x1fff;
		        var t2 = key[4] | key[5] << 8;
		        this._r[2] = ((t1 >>> 10) | (t2 << 6)) & 0x1f03;
		        var t3 = key[6] | key[7] << 8;
		        this._r[3] = ((t2 >>> 7) | (t3 << 9)) & 0x1fff;
		        var t4 = key[8] | key[9] << 8;
		        this._r[4] = ((t3 >>> 4) | (t4 << 12)) & 0x00ff;
		        this._r[5] = ((t4 >>> 1)) & 0x1ffe;
		        var t5 = key[10] | key[11] << 8;
		        this._r[6] = ((t4 >>> 14) | (t5 << 2)) & 0x1fff;
		        var t6 = key[12] | key[13] << 8;
		        this._r[7] = ((t5 >>> 11) | (t6 << 5)) & 0x1f81;
		        var t7 = key[14] | key[15] << 8;
		        this._r[8] = ((t6 >>> 8) | (t7 << 8)) & 0x1fff;
		        this._r[9] = ((t7 >>> 5)) & 0x007f;
		        this._pad[0] = key[16] | key[17] << 8;
		        this._pad[1] = key[18] | key[19] << 8;
		        this._pad[2] = key[20] | key[21] << 8;
		        this._pad[3] = key[22] | key[23] << 8;
		        this._pad[4] = key[24] | key[25] << 8;
		        this._pad[5] = key[26] | key[27] << 8;
		        this._pad[6] = key[28] | key[29] << 8;
		        this._pad[7] = key[30] | key[31] << 8;
		    }
		    Poly1305.prototype._blocks = function (m, mpos, bytes) {
		        var hibit = this._fin ? 0 : 1 << 11;
		        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
		        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
		        while (bytes >= 16) {
		            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
		            h0 += (t0) & 0x1fff;
		            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
		            h1 += ((t0 >>> 13) | (t1 << 3)) & 0x1fff;
		            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
		            h2 += ((t1 >>> 10) | (t2 << 6)) & 0x1fff;
		            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
		            h3 += ((t2 >>> 7) | (t3 << 9)) & 0x1fff;
		            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
		            h4 += ((t3 >>> 4) | (t4 << 12)) & 0x1fff;
		            h5 += ((t4 >>> 1)) & 0x1fff;
		            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
		            h6 += ((t4 >>> 14) | (t5 << 2)) & 0x1fff;
		            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
		            h7 += ((t5 >>> 11) | (t6 << 5)) & 0x1fff;
		            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
		            h8 += ((t6 >>> 8) | (t7 << 8)) & 0x1fff;
		            h9 += ((t7 >>> 5)) | hibit;
		            var c = 0;
		            var d0 = c;
		            d0 += h0 * r0;
		            d0 += h1 * (5 * r9);
		            d0 += h2 * (5 * r8);
		            d0 += h3 * (5 * r7);
		            d0 += h4 * (5 * r6);
		            c = (d0 >>> 13);
		            d0 &= 0x1fff;
		            d0 += h5 * (5 * r5);
		            d0 += h6 * (5 * r4);
		            d0 += h7 * (5 * r3);
		            d0 += h8 * (5 * r2);
		            d0 += h9 * (5 * r1);
		            c += (d0 >>> 13);
		            d0 &= 0x1fff;
		            var d1 = c;
		            d1 += h0 * r1;
		            d1 += h1 * r0;
		            d1 += h2 * (5 * r9);
		            d1 += h3 * (5 * r8);
		            d1 += h4 * (5 * r7);
		            c = (d1 >>> 13);
		            d1 &= 0x1fff;
		            d1 += h5 * (5 * r6);
		            d1 += h6 * (5 * r5);
		            d1 += h7 * (5 * r4);
		            d1 += h8 * (5 * r3);
		            d1 += h9 * (5 * r2);
		            c += (d1 >>> 13);
		            d1 &= 0x1fff;
		            var d2 = c;
		            d2 += h0 * r2;
		            d2 += h1 * r1;
		            d2 += h2 * r0;
		            d2 += h3 * (5 * r9);
		            d2 += h4 * (5 * r8);
		            c = (d2 >>> 13);
		            d2 &= 0x1fff;
		            d2 += h5 * (5 * r7);
		            d2 += h6 * (5 * r6);
		            d2 += h7 * (5 * r5);
		            d2 += h8 * (5 * r4);
		            d2 += h9 * (5 * r3);
		            c += (d2 >>> 13);
		            d2 &= 0x1fff;
		            var d3 = c;
		            d3 += h0 * r3;
		            d3 += h1 * r2;
		            d3 += h2 * r1;
		            d3 += h3 * r0;
		            d3 += h4 * (5 * r9);
		            c = (d3 >>> 13);
		            d3 &= 0x1fff;
		            d3 += h5 * (5 * r8);
		            d3 += h6 * (5 * r7);
		            d3 += h7 * (5 * r6);
		            d3 += h8 * (5 * r5);
		            d3 += h9 * (5 * r4);
		            c += (d3 >>> 13);
		            d3 &= 0x1fff;
		            var d4 = c;
		            d4 += h0 * r4;
		            d4 += h1 * r3;
		            d4 += h2 * r2;
		            d4 += h3 * r1;
		            d4 += h4 * r0;
		            c = (d4 >>> 13);
		            d4 &= 0x1fff;
		            d4 += h5 * (5 * r9);
		            d4 += h6 * (5 * r8);
		            d4 += h7 * (5 * r7);
		            d4 += h8 * (5 * r6);
		            d4 += h9 * (5 * r5);
		            c += (d4 >>> 13);
		            d4 &= 0x1fff;
		            var d5 = c;
		            d5 += h0 * r5;
		            d5 += h1 * r4;
		            d5 += h2 * r3;
		            d5 += h3 * r2;
		            d5 += h4 * r1;
		            c = (d5 >>> 13);
		            d5 &= 0x1fff;
		            d5 += h5 * r0;
		            d5 += h6 * (5 * r9);
		            d5 += h7 * (5 * r8);
		            d5 += h8 * (5 * r7);
		            d5 += h9 * (5 * r6);
		            c += (d5 >>> 13);
		            d5 &= 0x1fff;
		            var d6 = c;
		            d6 += h0 * r6;
		            d6 += h1 * r5;
		            d6 += h2 * r4;
		            d6 += h3 * r3;
		            d6 += h4 * r2;
		            c = (d6 >>> 13);
		            d6 &= 0x1fff;
		            d6 += h5 * r1;
		            d6 += h6 * r0;
		            d6 += h7 * (5 * r9);
		            d6 += h8 * (5 * r8);
		            d6 += h9 * (5 * r7);
		            c += (d6 >>> 13);
		            d6 &= 0x1fff;
		            var d7 = c;
		            d7 += h0 * r7;
		            d7 += h1 * r6;
		            d7 += h2 * r5;
		            d7 += h3 * r4;
		            d7 += h4 * r3;
		            c = (d7 >>> 13);
		            d7 &= 0x1fff;
		            d7 += h5 * r2;
		            d7 += h6 * r1;
		            d7 += h7 * r0;
		            d7 += h8 * (5 * r9);
		            d7 += h9 * (5 * r8);
		            c += (d7 >>> 13);
		            d7 &= 0x1fff;
		            var d8 = c;
		            d8 += h0 * r8;
		            d8 += h1 * r7;
		            d8 += h2 * r6;
		            d8 += h3 * r5;
		            d8 += h4 * r4;
		            c = (d8 >>> 13);
		            d8 &= 0x1fff;
		            d8 += h5 * r3;
		            d8 += h6 * r2;
		            d8 += h7 * r1;
		            d8 += h8 * r0;
		            d8 += h9 * (5 * r9);
		            c += (d8 >>> 13);
		            d8 &= 0x1fff;
		            var d9 = c;
		            d9 += h0 * r9;
		            d9 += h1 * r8;
		            d9 += h2 * r7;
		            d9 += h3 * r6;
		            d9 += h4 * r5;
		            c = (d9 >>> 13);
		            d9 &= 0x1fff;
		            d9 += h5 * r4;
		            d9 += h6 * r3;
		            d9 += h7 * r2;
		            d9 += h8 * r1;
		            d9 += h9 * r0;
		            c += (d9 >>> 13);
		            d9 &= 0x1fff;
		            c = (((c << 2) + c)) | 0;
		            c = (c + d0) | 0;
		            d0 = c & 0x1fff;
		            c = (c >>> 13);
		            d1 += c;
		            h0 = d0;
		            h1 = d1;
		            h2 = d2;
		            h3 = d3;
		            h4 = d4;
		            h5 = d5;
		            h6 = d6;
		            h7 = d7;
		            h8 = d8;
		            h9 = d9;
		            mpos += 16;
		            bytes -= 16;
		        }
		        this._h[0] = h0;
		        this._h[1] = h1;
		        this._h[2] = h2;
		        this._h[3] = h3;
		        this._h[4] = h4;
		        this._h[5] = h5;
		        this._h[6] = h6;
		        this._h[7] = h7;
		        this._h[8] = h8;
		        this._h[9] = h9;
		    };
		    Poly1305.prototype.finish = function (mac, macpos) {
		        if (macpos === void 0) { macpos = 0; }
		        var g = new Uint16Array(10);
		        var c;
		        var mask;
		        var f;
		        var i;
		        if (this._leftover) {
		            i = this._leftover;
		            this._buffer[i++] = 1;
		            for (; i < 16; i++) {
		                this._buffer[i] = 0;
		            }
		            this._fin = 1;
		            this._blocks(this._buffer, 0, 16);
		        }
		        c = this._h[1] >>> 13;
		        this._h[1] &= 0x1fff;
		        for (i = 2; i < 10; i++) {
		            this._h[i] += c;
		            c = this._h[i] >>> 13;
		            this._h[i] &= 0x1fff;
		        }
		        this._h[0] += (c * 5);
		        c = this._h[0] >>> 13;
		        this._h[0] &= 0x1fff;
		        this._h[1] += c;
		        c = this._h[1] >>> 13;
		        this._h[1] &= 0x1fff;
		        this._h[2] += c;
		        g[0] = this._h[0] + 5;
		        c = g[0] >>> 13;
		        g[0] &= 0x1fff;
		        for (i = 1; i < 10; i++) {
		            g[i] = this._h[i] + c;
		            c = g[i] >>> 13;
		            g[i] &= 0x1fff;
		        }
		        g[9] -= (1 << 13);
		        mask = (c ^ 1) - 1;
		        for (i = 0; i < 10; i++) {
		            g[i] &= mask;
		        }
		        mask = ~mask;
		        for (i = 0; i < 10; i++) {
		            this._h[i] = (this._h[i] & mask) | g[i];
		        }
		        this._h[0] = ((this._h[0]) | (this._h[1] << 13)) & 0xffff;
		        this._h[1] = ((this._h[1] >>> 3) | (this._h[2] << 10)) & 0xffff;
		        this._h[2] = ((this._h[2] >>> 6) | (this._h[3] << 7)) & 0xffff;
		        this._h[3] = ((this._h[3] >>> 9) | (this._h[4] << 4)) & 0xffff;
		        this._h[4] = ((this._h[4] >>> 12) | (this._h[5] << 1) | (this._h[6] << 14)) & 0xffff;
		        this._h[5] = ((this._h[6] >>> 2) | (this._h[7] << 11)) & 0xffff;
		        this._h[6] = ((this._h[7] >>> 5) | (this._h[8] << 8)) & 0xffff;
		        this._h[7] = ((this._h[8] >>> 8) | (this._h[9] << 5)) & 0xffff;
		        f = this._h[0] + this._pad[0];
		        this._h[0] = f & 0xffff;
		        for (i = 1; i < 8; i++) {
		            f = (((this._h[i] + this._pad[i]) | 0) + (f >>> 16)) | 0;
		            this._h[i] = f & 0xffff;
		        }
		        mac[macpos + 0] = this._h[0] >>> 0;
		        mac[macpos + 1] = this._h[0] >>> 8;
		        mac[macpos + 2] = this._h[1] >>> 0;
		        mac[macpos + 3] = this._h[1] >>> 8;
		        mac[macpos + 4] = this._h[2] >>> 0;
		        mac[macpos + 5] = this._h[2] >>> 8;
		        mac[macpos + 6] = this._h[3] >>> 0;
		        mac[macpos + 7] = this._h[3] >>> 8;
		        mac[macpos + 8] = this._h[4] >>> 0;
		        mac[macpos + 9] = this._h[4] >>> 8;
		        mac[macpos + 10] = this._h[5] >>> 0;
		        mac[macpos + 11] = this._h[5] >>> 8;
		        mac[macpos + 12] = this._h[6] >>> 0;
		        mac[macpos + 13] = this._h[6] >>> 8;
		        mac[macpos + 14] = this._h[7] >>> 0;
		        mac[macpos + 15] = this._h[7] >>> 8;
		        this._finished = true;
		        return this;
		    };
		    Poly1305.prototype.update = function (m) {
		        var mpos = 0;
		        var bytes = m.length;
		        var want;
		        if (this._leftover) {
		            want = (16 - this._leftover);
		            if (want > bytes) {
		                want = bytes;
		            }
		            for (var i = 0; i < want; i++) {
		                this._buffer[this._leftover + i] = m[mpos + i];
		            }
		            bytes -= want;
		            mpos += want;
		            this._leftover += want;
		            if (this._leftover < 16) {
		                return this;
		            }
		            this._blocks(this._buffer, 0, 16);
		            this._leftover = 0;
		        }
		        if (bytes >= 16) {
		            want = bytes - (bytes % 16);
		            this._blocks(m, mpos, want);
		            mpos += want;
		            bytes -= want;
		        }
		        if (bytes) {
		            for (var i = 0; i < bytes; i++) {
		                this._buffer[this._leftover + i] = m[mpos + i];
		            }
		            this._leftover += bytes;
		        }
		        return this;
		    };
		    Poly1305.prototype.digest = function () {
		        // TODO(dchest): it behaves differently than other hashes/HMAC,
		        // because it throws when finished — others just return saved result.
		        if (this._finished) {
		            throw new Error("Poly1305 was finished");
		        }
		        var mac = new Uint8Array(16);
		        this.finish(mac);
		        return mac;
		    };
		    Poly1305.prototype.clean = function () {
		        wipe_1.wipe(this._buffer);
		        wipe_1.wipe(this._r);
		        wipe_1.wipe(this._h);
		        wipe_1.wipe(this._pad);
		        this._leftover = 0;
		        this._fin = 0;
		        this._finished = true; // mark as finished even if not
		        return this;
		    };
		    return Poly1305;
		}());
		exports.Poly1305 = Poly1305;
		/**
		 * Returns 16-byte authenticator of data using a one-time 32-byte key.
		 *
		 * Important: key should be used for only one message, it should never repeat.
		 */
		function oneTimeAuth(key, data) {
		    var h = new Poly1305(key);
		    h.update(data);
		    var digest = h.digest();
		    h.clean();
		    return digest;
		}
		exports.oneTimeAuth = oneTimeAuth;
		/**
		 * Returns true if two authenticators are 16-byte long and equal.
		 * Uses contant-time comparison to avoid leaking timing information.
		 */
		function equal(a, b) {
		    if (a.length !== exports.DIGEST_LENGTH || b.length !== exports.DIGEST_LENGTH) {
		        return false;
		    }
		    return constant_time_1.equal(a, b);
		}
		exports.equal = equal;
		
	} (poly1305));

	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		var chacha_1 = chacha;
		var poly1305_1 = poly1305;
		var wipe_1 = wipe$1;
		var binary_1 = binary;
		var constant_time_1 = constantTime;
		exports.KEY_LENGTH = 32;
		exports.NONCE_LENGTH = 12;
		exports.TAG_LENGTH = 16;
		var ZEROS = new Uint8Array(16);
		/**
		 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
		 *
		 * Defined in RFC7539.
		 */
		var ChaCha20Poly1305 = /** @class */ (function () {
		    /**
		     * Creates a new instance with the given 32-byte key.
		     */
		    function ChaCha20Poly1305(key) {
		        this.nonceLength = exports.NONCE_LENGTH;
		        this.tagLength = exports.TAG_LENGTH;
		        if (key.length !== exports.KEY_LENGTH) {
		            throw new Error("ChaCha20Poly1305 needs 32-byte key");
		        }
		        // Copy key.
		        this._key = new Uint8Array(key);
		    }
		    /**
		     * Encrypts and authenticates plaintext, authenticates associated data,
		     * and returns sealed ciphertext, which includes authentication tag.
		     *
		     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
		     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
		     * and nonce.
		     *
		     * If dst is given (it must be the size of plaintext + the size of tag
		     * length) the result will be put into it. Dst and plaintext must not
		     * overlap.
		     */
		    ChaCha20Poly1305.prototype.seal = function (nonce, plaintext, associatedData, dst) {
		        if (nonce.length > 16) {
		            throw new Error("ChaCha20Poly1305: incorrect nonce length");
		        }
		        // Allocate space for counter, and set nonce as last bytes of it.
		        var counter = new Uint8Array(16);
		        counter.set(nonce, counter.length - nonce.length);
		        // Generate authentication key by taking first 32-bytes of stream.
		        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
		        // and it will get incremented after generating the block, which is
		        // exactly what we need: we only use the first 32 bytes of 64-byte
		        // ChaCha block and discard the next 32 bytes.
		        var authKey = new Uint8Array(32);
		        chacha_1.stream(this._key, counter, authKey, 4);
		        // Allocate space for sealed ciphertext.
		        var resultLength = plaintext.length + this.tagLength;
		        var result;
		        if (dst) {
		            if (dst.length !== resultLength) {
		                throw new Error("ChaCha20Poly1305: incorrect destination length");
		            }
		            result = dst;
		        }
		        else {
		            result = new Uint8Array(resultLength);
		        }
		        // Encrypt plaintext.
		        chacha_1.streamXOR(this._key, counter, plaintext, result, 4);
		        // Authenticate.
		        // XXX: can "simplify" here: pass full result (which is already padded
		        // due to zeroes prepared for tag), and ciphertext length instead of
		        // subarray of result.
		        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
		        // Cleanup.
		        wipe_1.wipe(counter);
		        return result;
		    };
		    /**
		     * Authenticates sealed ciphertext (which includes authentication tag) and
		     * associated data, decrypts ciphertext and returns decrypted plaintext.
		     *
		     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
		     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
		     * and nonce.
		     *
		     * If authentication fails, it returns null.
		     *
		     * If dst is given (it must be of ciphertext length minus tag length),
		     * the result will be put into it. Dst and plaintext must not overlap.
		     */
		    ChaCha20Poly1305.prototype.open = function (nonce, sealed, associatedData, dst) {
		        if (nonce.length > 16) {
		            throw new Error("ChaCha20Poly1305: incorrect nonce length");
		        }
		        // Sealed ciphertext should at least contain tag.
		        if (sealed.length < this.tagLength) {
		            // TODO(dchest): should we throw here instead?
		            return null;
		        }
		        // Allocate space for counter, and set nonce as last bytes of it.
		        var counter = new Uint8Array(16);
		        counter.set(nonce, counter.length - nonce.length);
		        // Generate authentication key by taking first 32-bytes of stream.
		        var authKey = new Uint8Array(32);
		        chacha_1.stream(this._key, counter, authKey, 4);
		        // Authenticate.
		        // XXX: can simplify and avoid allocation: since authenticate()
		        // already allocates tag (from Poly1305.digest(), it can return)
		        // it instead of copying to calculatedTag. But then in seal()
		        // we'll need to copy it.
		        var calculatedTag = new Uint8Array(this.tagLength);
		        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
		        // Constant-time compare tags and return null if they differ.
		        if (!constant_time_1.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) {
		            return null;
		        }
		        // Allocate space for decrypted plaintext.
		        var resultLength = sealed.length - this.tagLength;
		        var result;
		        if (dst) {
		            if (dst.length !== resultLength) {
		                throw new Error("ChaCha20Poly1305: incorrect destination length");
		            }
		            result = dst;
		        }
		        else {
		            result = new Uint8Array(resultLength);
		        }
		        // Decrypt.
		        chacha_1.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
		        // Cleanup.
		        wipe_1.wipe(counter);
		        return result;
		    };
		    ChaCha20Poly1305.prototype.clean = function () {
		        wipe_1.wipe(this._key);
		        return this;
		    };
		    ChaCha20Poly1305.prototype._authenticate = function (tagOut, authKey, ciphertext, associatedData) {
		        // Initialize Poly1305 with authKey.
		        var h = new poly1305_1.Poly1305(authKey);
		        // Authenticate padded associated data.
		        if (associatedData) {
		            h.update(associatedData);
		            if (associatedData.length % 16 > 0) {
		                h.update(ZEROS.subarray(associatedData.length % 16));
		            }
		        }
		        // Authenticate padded ciphertext.
		        h.update(ciphertext);
		        if (ciphertext.length % 16 > 0) {
		            h.update(ZEROS.subarray(ciphertext.length % 16));
		        }
		        // Authenticate length of associated data.
		        // XXX: can avoid allocation here?
		        var length = new Uint8Array(8);
		        if (associatedData) {
		            binary_1.writeUint64LE(associatedData.length, length);
		        }
		        h.update(length);
		        // Authenticate length of ciphertext.
		        binary_1.writeUint64LE(ciphertext.length, length);
		        h.update(length);
		        // Get tag and copy it into tagOut.
		        var tag = h.digest();
		        for (var i = 0; i < tag.length; i++) {
		            tagOut[i] = tag[i];
		        }
		        // Cleanup.
		        h.clean();
		        wipe_1.wipe(tag);
		        wipe_1.wipe(length);
		    };
		    return ChaCha20Poly1305;
		}());
		exports.ChaCha20Poly1305 = ChaCha20Poly1305;
		
	} (chacha20poly1305));

	var hkdf = {};

	var hmac$2 = {};

	var hash$5 = {};

	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(hash$5, "__esModule", { value: true });
	function isSerializableHash(h) {
	    return (typeof h.saveState !== "undefined" &&
	        typeof h.restoreState !== "undefined" &&
	        typeof h.cleanSavedState !== "undefined");
	}
	hash$5.isSerializableHash = isSerializableHash;

	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(hmac$2, "__esModule", { value: true });
	/**
	 * Package hmac implements HMAC algorithm.
	 */
	var hash_1 = hash$5;
	var constant_time_1 = constantTime;
	var wipe_1$2 = wipe$1;
	/**
	 *  HMAC implements hash-based message authentication algorithm.
	 */
	var HMAC = /** @class */ (function () {
	    /**
	     * Constructs a new HMAC with the given Hash and secret key.
	     */
	    function HMAC(hash, key) {
	        this._finished = false; // true if HMAC was finalized
	        // Initialize inner and outer hashes.
	        this._inner = new hash();
	        this._outer = new hash();
	        // Set block and digest sizes for this HMAC
	        // instance to values from the hash.
	        this.blockSize = this._outer.blockSize;
	        this.digestLength = this._outer.digestLength;
	        // Pad temporary stores a key (or its hash) padded with zeroes.
	        var pad = new Uint8Array(this.blockSize);
	        if (key.length > this.blockSize) {
	            // If key is bigger than hash block size, it must be
	            // hashed and this hash is used as a key instead.
	            this._inner.update(key).finish(pad).clean();
	        }
	        else {
	            // Otherwise, copy the key into pad.
	            pad.set(key);
	        }
	        // Now two different keys are derived from padded key
	        // by xoring a different byte value to each.
	        // To make inner hash key, xor byte 0x36 into pad.
	        for (var i = 0; i < pad.length; i++) {
	            pad[i] ^= 0x36;
	        }
	        // Update inner hash with the result.
	        this._inner.update(pad);
	        // To make outer hash key, xor byte 0x5c into pad.
	        // But since we already xored 0x36 there, we must
	        // first undo this by xoring it again.
	        for (var i = 0; i < pad.length; i++) {
	            pad[i] ^= 0x36 ^ 0x5c;
	        }
	        // Update outer hash with the result.
	        this._outer.update(pad);
	        // Save states of both hashes, so that we can quickly restore
	        // them later in reset() without the need to remember the actual
	        // key and perform this initialization again.
	        if (hash_1.isSerializableHash(this._inner) && hash_1.isSerializableHash(this._outer)) {
	            this._innerKeyedState = this._inner.saveState();
	            this._outerKeyedState = this._outer.saveState();
	        }
	        // Clean pad.
	        wipe_1$2.wipe(pad);
	    }
	    /**
	     * Returns HMAC state to the state initialized with key
	     * to make it possible to run HMAC over the other data with the same
	     * key without creating a new instance.
	     */
	    HMAC.prototype.reset = function () {
	        if (!hash_1.isSerializableHash(this._inner) || !hash_1.isSerializableHash(this._outer)) {
	            throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
	        }
	        // Restore keyed states of inner and outer hashes.
	        this._inner.restoreState(this._innerKeyedState);
	        this._outer.restoreState(this._outerKeyedState);
	        this._finished = false;
	        return this;
	    };
	    /**
	     * Cleans HMAC state.
	     */
	    HMAC.prototype.clean = function () {
	        if (hash_1.isSerializableHash(this._inner)) {
	            this._inner.cleanSavedState(this._innerKeyedState);
	        }
	        if (hash_1.isSerializableHash(this._outer)) {
	            this._outer.cleanSavedState(this._outerKeyedState);
	        }
	        this._inner.clean();
	        this._outer.clean();
	    };
	    /**
	     * Updates state with provided data.
	     */
	    HMAC.prototype.update = function (data) {
	        this._inner.update(data);
	        return this;
	    };
	    /**
	     * Finalizes HMAC and puts the result in out.
	     */
	    HMAC.prototype.finish = function (out) {
	        if (this._finished) {
	            // If HMAC was finalized, outer hash is also finalized,
	            // so it produces the same digest it produced when it
	            // was finalized.
	            this._outer.finish(out);
	            return this;
	        }
	        // Finalize inner hash and store the result temporarily.
	        this._inner.finish(out);
	        // Update outer hash with digest of inner hash and and finalize it.
	        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
	        this._finished = true;
	        return this;
	    };
	    /**
	     * Returns the computed message authentication code.
	     */
	    HMAC.prototype.digest = function () {
	        var out = new Uint8Array(this.digestLength);
	        this.finish(out);
	        return out;
	    };
	    /**
	     * Saves HMAC state.
	     * This function is needed for PBKDF2 optimization.
	     */
	    HMAC.prototype.saveState = function () {
	        if (!hash_1.isSerializableHash(this._inner)) {
	            throw new Error("hmac: can't saveState() because hash doesn't implement it");
	        }
	        return this._inner.saveState();
	    };
	    HMAC.prototype.restoreState = function (savedState) {
	        if (!hash_1.isSerializableHash(this._inner) || !hash_1.isSerializableHash(this._outer)) {
	            throw new Error("hmac: can't restoreState() because hash doesn't implement it");
	        }
	        this._inner.restoreState(savedState);
	        this._outer.restoreState(this._outerKeyedState);
	        this._finished = false;
	        return this;
	    };
	    HMAC.prototype.cleanSavedState = function (savedState) {
	        if (!hash_1.isSerializableHash(this._inner)) {
	            throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
	        }
	        this._inner.cleanSavedState(savedState);
	    };
	    return HMAC;
	}());
	hmac$2.HMAC = HMAC;
	/**
	 * Returns HMAC using the given hash constructor for the key over data.
	 */
	function hmac$1(hash, key, data) {
	    var h = new HMAC(hash, key);
	    h.update(data);
	    var digest = h.digest();
	    h.clean();
	    return digest;
	}
	hmac$2.hmac = hmac$1;
	/**
	 * Returns true if two HMAC digests are equal.
	 * Uses constant-time comparison to avoid leaking timing information.
	 *
	 * Example:
	 *
	 *    const receivedDigest = ...
	 *    const realDigest = hmac(SHA256, key, data);
	 *    if (!equal(receivedDigest, realDigest)) {
	 *        throw new Error("Authentication error");
	 *    }
	 */
	hmac$2.equal = constant_time_1.equal;

	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(hkdf, "__esModule", { value: true });
	var hmac_1 = hmac$2;
	var wipe_1$1 = wipe$1;
	/**
	 * HMAC-based Extract-and-Expand Key Derivation Function.
	 *
	 * Implements HKDF from RFC5869.
	 *
	 * Expands the given master key with salt and info into
	 * a limited stream of key material.
	 */
	var HKDF = /** @class */ (function () {
	    /**
	     * Create a new HKDF instance for the given hash function
	     * with the master key, optional salt, and info.
	     *
	     * - Master key is a high-entropy secret key (not a password).
	     * - Salt is a non-secret random value.
	     * - Info is application- and/or context-specific information.
	     */
	    function HKDF(hash, key, salt, info) {
	        if (salt === void 0) { salt = new Uint8Array(0); }
	        this._counter = new Uint8Array(1); // starts with zero
	        this._hash = hash;
	        this._info = info;
	        // HKDF-Extract uses salt as HMAC key, and key as data.
	        var okm = hmac_1.hmac(this._hash, salt, key);
	        // Initialize HMAC for expanding with extracted key.
	        this._hmac = new hmac_1.HMAC(hash, okm);
	        // Allocate buffer.
	        this._buffer = new Uint8Array(this._hmac.digestLength);
	        this._bufpos = this._buffer.length;
	    }
	    // Fill buffer with new block of HKDF-Extract output.
	    HKDF.prototype._fillBuffer = function () {
	        // Increment counter.
	        this._counter[0]++;
	        var ctr = this._counter[0];
	        // Check if counter overflowed.
	        if (ctr === 0) {
	            throw new Error("hkdf: cannot expand more");
	        }
	        // Prepare HMAC instance for new data with old key.
	        this._hmac.reset();
	        // Hash in previous output if it was generated
	        // (i.e. counter is greater than 1).
	        if (ctr > 1) {
	            this._hmac.update(this._buffer);
	        }
	        // Hash in info if it exists.
	        if (this._info) {
	            this._hmac.update(this._info);
	        }
	        // Hash in the counter.
	        this._hmac.update(this._counter);
	        // Output result to buffer and clean HMAC instance.
	        this._hmac.finish(this._buffer);
	        // Reset buffer position.
	        this._bufpos = 0;
	    };
	    /**
	     * Expand returns next key material of the given length.
	     *
	     * It throws if expansion limit is reached (which is
	     * 254 digests of the underlying HMAC function).
	     */
	    HKDF.prototype.expand = function (length) {
	        var out = new Uint8Array(length);
	        for (var i = 0; i < out.length; i++) {
	            if (this._bufpos === this._buffer.length) {
	                this._fillBuffer();
	            }
	            out[i] = this._buffer[this._bufpos++];
	        }
	        return out;
	    };
	    HKDF.prototype.clean = function () {
	        this._hmac.clean();
	        wipe_1$1.wipe(this._buffer);
	        wipe_1$1.wipe(this._counter);
	        this._bufpos = 0;
	    };
	    return HKDF;
	}());
	var HKDF_1 = hkdf.HKDF = HKDF;

	var random = {};

	var system = {};

	var browser$6 = {};

	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(browser$6, "__esModule", { value: true });
	browser$6.BrowserRandomSource = void 0;
	const QUOTA = 65536;
	class BrowserRandomSource {
	    constructor() {
	        this.isAvailable = false;
	        this.isInstantiated = false;
	        const browserCrypto = typeof self !== 'undefined'
	            ? (self.crypto || self.msCrypto) // IE11 has msCrypto
	            : null;
	        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
	            this._crypto = browserCrypto;
	            this.isAvailable = true;
	            this.isInstantiated = true;
	        }
	    }
	    randomBytes(length) {
	        if (!this.isAvailable || !this._crypto) {
	            throw new Error("Browser random byte generator is not available.");
	        }
	        const out = new Uint8Array(length);
	        for (let i = 0; i < out.length; i += QUOTA) {
	            this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, QUOTA)));
	        }
	        return out;
	    }
	}
	browser$6.BrowserRandomSource = BrowserRandomSource;

	function commonjsRequire$1(path) {
		throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
	}

	var node = {};

	var _nodeResolve_empty = {};

	var nodeCrypto = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: _nodeResolve_empty
	});

	var require$$3 = /*@__PURE__*/getAugmentedNamespace(nodeCrypto);

	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(node, "__esModule", { value: true });
	node.NodeRandomSource = void 0;
	const wipe_1 = wipe$1;
	class NodeRandomSource {
	    constructor() {
	        this.isAvailable = false;
	        this.isInstantiated = false;
	        if (typeof commonjsRequire$1 !== "undefined") {
	            const nodeCrypto = require$$3;
	            if (nodeCrypto && nodeCrypto.randomBytes) {
	                this._crypto = nodeCrypto;
	                this.isAvailable = true;
	                this.isInstantiated = true;
	            }
	        }
	    }
	    randomBytes(length) {
	        if (!this.isAvailable || !this._crypto) {
	            throw new Error("Node.js random byte generator is not available.");
	        }
	        // Get random bytes (result is Buffer).
	        let buffer = this._crypto.randomBytes(length);
	        // Make sure we got the length that we requested.
	        if (buffer.length !== length) {
	            throw new Error("NodeRandomSource: got fewer bytes than requested");
	        }
	        // Allocate output array.
	        const out = new Uint8Array(length);
	        // Copy bytes from buffer to output.
	        for (let i = 0; i < out.length; i++) {
	            out[i] = buffer[i];
	        }
	        // Cleanup.
	        (0, wipe_1.wipe)(buffer);
	        return out;
	    }
	}
	node.NodeRandomSource = NodeRandomSource;

	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(system, "__esModule", { value: true });
	system.SystemRandomSource = void 0;
	const browser_1 = browser$6;
	const node_1 = node;
	class SystemRandomSource {
	    constructor() {
	        this.isAvailable = false;
	        this.name = "";
	        // Try browser.
	        this._source = new browser_1.BrowserRandomSource();
	        if (this._source.isAvailable) {
	            this.isAvailable = true;
	            this.name = "Browser";
	            return;
	        }
	        // If no browser source, try Node.
	        this._source = new node_1.NodeRandomSource();
	        if (this._source.isAvailable) {
	            this.isAvailable = true;
	            this.name = "Node";
	            return;
	        }
	        // No sources, we're out of options.
	    }
	    randomBytes(length) {
	        if (!this.isAvailable) {
	            throw new Error("System random byte generator is not available.");
	        }
	        return this._source.randomBytes(length);
	    }
	}
	system.SystemRandomSource = SystemRandomSource;

	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.randomStringForEntropy = exports.randomString = exports.randomUint32 = exports.randomBytes = exports.defaultRandomSource = void 0;
		const system_1 = system;
		const binary_1 = binary;
		const wipe_1 = wipe$1;
		exports.defaultRandomSource = new system_1.SystemRandomSource();
		function randomBytes(length, prng = exports.defaultRandomSource) {
		    return prng.randomBytes(length);
		}
		exports.randomBytes = randomBytes;
		/**
		 * Returns a uniformly random unsigned 32-bit integer.
		 */
		function randomUint32(prng = exports.defaultRandomSource) {
		    // Generate 4-byte random buffer.
		    const buf = randomBytes(4, prng);
		    // Convert bytes from buffer into a 32-bit integer.
		    // It's not important which byte order to use, since
		    // the result is random.
		    const result = (0, binary_1.readUint32LE)(buf);
		    // Clean the buffer.
		    (0, wipe_1.wipe)(buf);
		    return result;
		}
		exports.randomUint32 = randomUint32;
		/** 62 alphanumeric characters for default charset of randomString() */
		const ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
		/**
		 * Returns a uniform random string of the given length
		 * with characters from the given charset.
		 *
		 * Charset must not have more than 256 characters.
		 *
		 * Default charset generates case-sensitive alphanumeric
		 * strings (0-9, A-Z, a-z).
		 */
		function randomString(length, charset = ALPHANUMERIC, prng = exports.defaultRandomSource) {
		    if (charset.length < 2) {
		        throw new Error("randomString charset is too short");
		    }
		    if (charset.length > 256) {
		        throw new Error("randomString charset is too long");
		    }
		    let out = '';
		    const charsLen = charset.length;
		    const maxByte = 256 - (256 % charsLen);
		    while (length > 0) {
		        const buf = randomBytes(Math.ceil(length * 256 / maxByte), prng);
		        for (let i = 0; i < buf.length && length > 0; i++) {
		            const randomByte = buf[i];
		            if (randomByte < maxByte) {
		                out += charset.charAt(randomByte % charsLen);
		                length--;
		            }
		        }
		        (0, wipe_1.wipe)(buf);
		    }
		    return out;
		}
		exports.randomString = randomString;
		/**
		 * Returns uniform random string containing at least the given
		 * number of bits of entropy.
		 *
		 * For example, randomStringForEntropy(128) will return a 22-character
		 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
		 * will return a 39-character numeric string, both will contain at
		 * least 128 bits of entropy.
		 *
		 * Default charset generates case-sensitive alphanumeric
		 * strings (0-9, A-Z, a-z).
		 */
		function randomStringForEntropy(bits, charset = ALPHANUMERIC, prng = exports.defaultRandomSource) {
		    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
		    return randomString(length, charset, prng);
		}
		exports.randomStringForEntropy = randomStringForEntropy;
		
	} (random));

	var sha256$1 = {};

	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		var binary_1 = binary;
		var wipe_1 = wipe$1;
		exports.DIGEST_LENGTH = 32;
		exports.BLOCK_SIZE = 64;
		/**
		 * SHA2-256 cryptographic hash algorithm.
		 */
		var SHA256 = /** @class */ (function () {
		    function SHA256() {
		        /** Length of hash output */
		        this.digestLength = exports.DIGEST_LENGTH;
		        /** Block size */
		        this.blockSize = exports.BLOCK_SIZE;
		        // Note: Int32Array is used instead of Uint32Array for performance reasons.
		        this._state = new Int32Array(8); // hash state
		        this._temp = new Int32Array(64); // temporary state
		        this._buffer = new Uint8Array(128); // buffer for data to hash
		        this._bufferLength = 0; // number of bytes in buffer
		        this._bytesHashed = 0; // number of total bytes hashed
		        this._finished = false; // indicates whether the hash was finalized
		        this.reset();
		    }
		    SHA256.prototype._initState = function () {
		        this._state[0] = 0x6a09e667;
		        this._state[1] = 0xbb67ae85;
		        this._state[2] = 0x3c6ef372;
		        this._state[3] = 0xa54ff53a;
		        this._state[4] = 0x510e527f;
		        this._state[5] = 0x9b05688c;
		        this._state[6] = 0x1f83d9ab;
		        this._state[7] = 0x5be0cd19;
		    };
		    /**
		     * Resets hash state making it possible
		     * to re-use this instance to hash other data.
		     */
		    SHA256.prototype.reset = function () {
		        this._initState();
		        this._bufferLength = 0;
		        this._bytesHashed = 0;
		        this._finished = false;
		        return this;
		    };
		    /**
		     * Cleans internal buffers and resets hash state.
		     */
		    SHA256.prototype.clean = function () {
		        wipe_1.wipe(this._buffer);
		        wipe_1.wipe(this._temp);
		        this.reset();
		    };
		    /**
		     * Updates hash state with the given data.
		     *
		     * Throws error when trying to update already finalized hash:
		     * instance must be reset to update it again.
		     */
		    SHA256.prototype.update = function (data, dataLength) {
		        if (dataLength === void 0) { dataLength = data.length; }
		        if (this._finished) {
		            throw new Error("SHA256: can't update because hash was finished.");
		        }
		        var dataPos = 0;
		        this._bytesHashed += dataLength;
		        if (this._bufferLength > 0) {
		            while (this._bufferLength < this.blockSize && dataLength > 0) {
		                this._buffer[this._bufferLength++] = data[dataPos++];
		                dataLength--;
		            }
		            if (this._bufferLength === this.blockSize) {
		                hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
		                this._bufferLength = 0;
		            }
		        }
		        if (dataLength >= this.blockSize) {
		            dataPos = hashBlocks(this._temp, this._state, data, dataPos, dataLength);
		            dataLength %= this.blockSize;
		        }
		        while (dataLength > 0) {
		            this._buffer[this._bufferLength++] = data[dataPos++];
		            dataLength--;
		        }
		        return this;
		    };
		    /**
		     * Finalizes hash state and puts hash into out.
		     * If hash was already finalized, puts the same value.
		     */
		    SHA256.prototype.finish = function (out) {
		        if (!this._finished) {
		            var bytesHashed = this._bytesHashed;
		            var left = this._bufferLength;
		            var bitLenHi = (bytesHashed / 0x20000000) | 0;
		            var bitLenLo = bytesHashed << 3;
		            var padLength = (bytesHashed % 64 < 56) ? 64 : 128;
		            this._buffer[left] = 0x80;
		            for (var i = left + 1; i < padLength - 8; i++) {
		                this._buffer[i] = 0;
		            }
		            binary_1.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
		            binary_1.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
		            hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
		            this._finished = true;
		        }
		        for (var i = 0; i < this.digestLength / 4; i++) {
		            binary_1.writeUint32BE(this._state[i], out, i * 4);
		        }
		        return this;
		    };
		    /**
		     * Returns the final hash digest.
		     */
		    SHA256.prototype.digest = function () {
		        var out = new Uint8Array(this.digestLength);
		        this.finish(out);
		        return out;
		    };
		    /**
		     * Function useful for HMAC/PBKDF2 optimization.
		     * Returns hash state to be used with restoreState().
		     * Only chain value is saved, not buffers or other
		     * state variables.
		     */
		    SHA256.prototype.saveState = function () {
		        if (this._finished) {
		            throw new Error("SHA256: cannot save finished state");
		        }
		        return {
		            state: new Int32Array(this._state),
		            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
		            bufferLength: this._bufferLength,
		            bytesHashed: this._bytesHashed
		        };
		    };
		    /**
		     * Function useful for HMAC/PBKDF2 optimization.
		     * Restores state saved by saveState() and sets bytesHashed
		     * to the given value.
		     */
		    SHA256.prototype.restoreState = function (savedState) {
		        this._state.set(savedState.state);
		        this._bufferLength = savedState.bufferLength;
		        if (savedState.buffer) {
		            this._buffer.set(savedState.buffer);
		        }
		        this._bytesHashed = savedState.bytesHashed;
		        this._finished = false;
		        return this;
		    };
		    /**
		     * Cleans state returned by saveState().
		     */
		    SHA256.prototype.cleanSavedState = function (savedState) {
		        wipe_1.wipe(savedState.state);
		        if (savedState.buffer) {
		            wipe_1.wipe(savedState.buffer);
		        }
		        savedState.bufferLength = 0;
		        savedState.bytesHashed = 0;
		    };
		    return SHA256;
		}());
		exports.SHA256 = SHA256;
		// Constants
		var K = new Int32Array([
		    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b,
		    0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01,
		    0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7,
		    0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
		    0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152,
		    0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147,
		    0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc,
		    0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
		    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819,
		    0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08,
		    0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f,
		    0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
		    0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
		]);
		function hashBlocks(w, v, p, pos, len) {
		    while (len >= 64) {
		        var a = v[0];
		        var b = v[1];
		        var c = v[2];
		        var d = v[3];
		        var e = v[4];
		        var f = v[5];
		        var g = v[6];
		        var h = v[7];
		        for (var i = 0; i < 16; i++) {
		            var j = pos + i * 4;
		            w[i] = binary_1.readUint32BE(p, j);
		        }
		        for (var i = 16; i < 64; i++) {
		            var u = w[i - 2];
		            var t1 = (u >>> 17 | u << (32 - 17)) ^ (u >>> 19 | u << (32 - 19)) ^ (u >>> 10);
		            u = w[i - 15];
		            var t2 = (u >>> 7 | u << (32 - 7)) ^ (u >>> 18 | u << (32 - 18)) ^ (u >>> 3);
		            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
		        }
		        for (var i = 0; i < 64; i++) {
		            var t1 = (((((e >>> 6 | e << (32 - 6)) ^ (e >>> 11 | e << (32 - 11)) ^
		                (e >>> 25 | e << (32 - 25))) + ((e & f) ^ (~e & g))) | 0) +
		                ((h + ((K[i] + w[i]) | 0)) | 0)) | 0;
		            var t2 = (((a >>> 2 | a << (32 - 2)) ^ (a >>> 13 | a << (32 - 13)) ^
		                (a >>> 22 | a << (32 - 22))) + ((a & b) ^ (a & c) ^ (b & c))) | 0;
		            h = g;
		            g = f;
		            f = e;
		            e = (d + t1) | 0;
		            d = c;
		            c = b;
		            b = a;
		            a = (t1 + t2) | 0;
		        }
		        v[0] += a;
		        v[1] += b;
		        v[2] += c;
		        v[3] += d;
		        v[4] += e;
		        v[5] += f;
		        v[6] += g;
		        v[7] += h;
		        pos += 64;
		        len -= 64;
		    }
		    return pos;
		}
		function hash(data) {
		    var h = new SHA256();
		    h.update(data);
		    var digest = h.digest();
		    h.clean();
		    return digest;
		}
		exports.hash = hash;
		
	} (sha256$1));

	var x25519 = {};

	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.sharedKey = exports.generateKeyPair = exports.generateKeyPairFromSeed = exports.scalarMultBase = exports.scalarMult = exports.SHARED_KEY_LENGTH = exports.SECRET_KEY_LENGTH = exports.PUBLIC_KEY_LENGTH = void 0;
		/**
		 * Package x25519 implements X25519 key agreement.
		 */
		const random_1 = random;
		const wipe_1 = wipe$1;
		exports.PUBLIC_KEY_LENGTH = 32;
		exports.SECRET_KEY_LENGTH = 32;
		exports.SHARED_KEY_LENGTH = 32;
		// Returns new zero-filled 16-element GF (Float64Array).
		// If passed an array of numbers, prefills the returned
		// array with them.
		//
		// We use Float64Array, because we need 48-bit numbers
		// for this implementation.
		function gf(init) {
		    const r = new Float64Array(16);
		    if (init) {
		        for (let i = 0; i < init.length; i++) {
		            r[i] = init[i];
		        }
		    }
		    return r;
		}
		// Base point.
		const _9 = new Uint8Array(32);
		_9[0] = 9;
		const _121665 = gf([0xdb41, 1]);
		function car25519(o) {
		    let c = 1;
		    for (let i = 0; i < 16; i++) {
		        let v = o[i] + c + 65535;
		        c = Math.floor(v / 65536);
		        o[i] = v - c * 65536;
		    }
		    o[0] += c - 1 + 37 * (c - 1);
		}
		function sel25519(p, q, b) {
		    const c = ~(b - 1);
		    for (let i = 0; i < 16; i++) {
		        const t = c & (p[i] ^ q[i]);
		        p[i] ^= t;
		        q[i] ^= t;
		    }
		}
		function pack25519(o, n) {
		    const m = gf();
		    const t = gf();
		    for (let i = 0; i < 16; i++) {
		        t[i] = n[i];
		    }
		    car25519(t);
		    car25519(t);
		    car25519(t);
		    for (let j = 0; j < 2; j++) {
		        m[0] = t[0] - 0xffed;
		        for (let i = 1; i < 15; i++) {
		            m[i] = t[i] - 0xffff - ((m[i - 1] >> 16) & 1);
		            m[i - 1] &= 0xffff;
		        }
		        m[15] = t[15] - 0x7fff - ((m[14] >> 16) & 1);
		        const b = (m[15] >> 16) & 1;
		        m[14] &= 0xffff;
		        sel25519(t, m, 1 - b);
		    }
		    for (let i = 0; i < 16; i++) {
		        o[2 * i] = t[i] & 0xff;
		        o[2 * i + 1] = t[i] >> 8;
		    }
		}
		function unpack25519(o, n) {
		    for (let i = 0; i < 16; i++) {
		        o[i] = n[2 * i] + (n[2 * i + 1] << 8);
		    }
		    o[15] &= 0x7fff;
		}
		function add(o, a, b) {
		    for (let i = 0; i < 16; i++) {
		        o[i] = a[i] + b[i];
		    }
		}
		function sub(o, a, b) {
		    for (let i = 0; i < 16; i++) {
		        o[i] = a[i] - b[i];
		    }
		}
		function mul(o, a, b) {
		    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
		    v = a[0];
		    t0 += v * b0;
		    t1 += v * b1;
		    t2 += v * b2;
		    t3 += v * b3;
		    t4 += v * b4;
		    t5 += v * b5;
		    t6 += v * b6;
		    t7 += v * b7;
		    t8 += v * b8;
		    t9 += v * b9;
		    t10 += v * b10;
		    t11 += v * b11;
		    t12 += v * b12;
		    t13 += v * b13;
		    t14 += v * b14;
		    t15 += v * b15;
		    v = a[1];
		    t1 += v * b0;
		    t2 += v * b1;
		    t3 += v * b2;
		    t4 += v * b3;
		    t5 += v * b4;
		    t6 += v * b5;
		    t7 += v * b6;
		    t8 += v * b7;
		    t9 += v * b8;
		    t10 += v * b9;
		    t11 += v * b10;
		    t12 += v * b11;
		    t13 += v * b12;
		    t14 += v * b13;
		    t15 += v * b14;
		    t16 += v * b15;
		    v = a[2];
		    t2 += v * b0;
		    t3 += v * b1;
		    t4 += v * b2;
		    t5 += v * b3;
		    t6 += v * b4;
		    t7 += v * b5;
		    t8 += v * b6;
		    t9 += v * b7;
		    t10 += v * b8;
		    t11 += v * b9;
		    t12 += v * b10;
		    t13 += v * b11;
		    t14 += v * b12;
		    t15 += v * b13;
		    t16 += v * b14;
		    t17 += v * b15;
		    v = a[3];
		    t3 += v * b0;
		    t4 += v * b1;
		    t5 += v * b2;
		    t6 += v * b3;
		    t7 += v * b4;
		    t8 += v * b5;
		    t9 += v * b6;
		    t10 += v * b7;
		    t11 += v * b8;
		    t12 += v * b9;
		    t13 += v * b10;
		    t14 += v * b11;
		    t15 += v * b12;
		    t16 += v * b13;
		    t17 += v * b14;
		    t18 += v * b15;
		    v = a[4];
		    t4 += v * b0;
		    t5 += v * b1;
		    t6 += v * b2;
		    t7 += v * b3;
		    t8 += v * b4;
		    t9 += v * b5;
		    t10 += v * b6;
		    t11 += v * b7;
		    t12 += v * b8;
		    t13 += v * b9;
		    t14 += v * b10;
		    t15 += v * b11;
		    t16 += v * b12;
		    t17 += v * b13;
		    t18 += v * b14;
		    t19 += v * b15;
		    v = a[5];
		    t5 += v * b0;
		    t6 += v * b1;
		    t7 += v * b2;
		    t8 += v * b3;
		    t9 += v * b4;
		    t10 += v * b5;
		    t11 += v * b6;
		    t12 += v * b7;
		    t13 += v * b8;
		    t14 += v * b9;
		    t15 += v * b10;
		    t16 += v * b11;
		    t17 += v * b12;
		    t18 += v * b13;
		    t19 += v * b14;
		    t20 += v * b15;
		    v = a[6];
		    t6 += v * b0;
		    t7 += v * b1;
		    t8 += v * b2;
		    t9 += v * b3;
		    t10 += v * b4;
		    t11 += v * b5;
		    t12 += v * b6;
		    t13 += v * b7;
		    t14 += v * b8;
		    t15 += v * b9;
		    t16 += v * b10;
		    t17 += v * b11;
		    t18 += v * b12;
		    t19 += v * b13;
		    t20 += v * b14;
		    t21 += v * b15;
		    v = a[7];
		    t7 += v * b0;
		    t8 += v * b1;
		    t9 += v * b2;
		    t10 += v * b3;
		    t11 += v * b4;
		    t12 += v * b5;
		    t13 += v * b6;
		    t14 += v * b7;
		    t15 += v * b8;
		    t16 += v * b9;
		    t17 += v * b10;
		    t18 += v * b11;
		    t19 += v * b12;
		    t20 += v * b13;
		    t21 += v * b14;
		    t22 += v * b15;
		    v = a[8];
		    t8 += v * b0;
		    t9 += v * b1;
		    t10 += v * b2;
		    t11 += v * b3;
		    t12 += v * b4;
		    t13 += v * b5;
		    t14 += v * b6;
		    t15 += v * b7;
		    t16 += v * b8;
		    t17 += v * b9;
		    t18 += v * b10;
		    t19 += v * b11;
		    t20 += v * b12;
		    t21 += v * b13;
		    t22 += v * b14;
		    t23 += v * b15;
		    v = a[9];
		    t9 += v * b0;
		    t10 += v * b1;
		    t11 += v * b2;
		    t12 += v * b3;
		    t13 += v * b4;
		    t14 += v * b5;
		    t15 += v * b6;
		    t16 += v * b7;
		    t17 += v * b8;
		    t18 += v * b9;
		    t19 += v * b10;
		    t20 += v * b11;
		    t21 += v * b12;
		    t22 += v * b13;
		    t23 += v * b14;
		    t24 += v * b15;
		    v = a[10];
		    t10 += v * b0;
		    t11 += v * b1;
		    t12 += v * b2;
		    t13 += v * b3;
		    t14 += v * b4;
		    t15 += v * b5;
		    t16 += v * b6;
		    t17 += v * b7;
		    t18 += v * b8;
		    t19 += v * b9;
		    t20 += v * b10;
		    t21 += v * b11;
		    t22 += v * b12;
		    t23 += v * b13;
		    t24 += v * b14;
		    t25 += v * b15;
		    v = a[11];
		    t11 += v * b0;
		    t12 += v * b1;
		    t13 += v * b2;
		    t14 += v * b3;
		    t15 += v * b4;
		    t16 += v * b5;
		    t17 += v * b6;
		    t18 += v * b7;
		    t19 += v * b8;
		    t20 += v * b9;
		    t21 += v * b10;
		    t22 += v * b11;
		    t23 += v * b12;
		    t24 += v * b13;
		    t25 += v * b14;
		    t26 += v * b15;
		    v = a[12];
		    t12 += v * b0;
		    t13 += v * b1;
		    t14 += v * b2;
		    t15 += v * b3;
		    t16 += v * b4;
		    t17 += v * b5;
		    t18 += v * b6;
		    t19 += v * b7;
		    t20 += v * b8;
		    t21 += v * b9;
		    t22 += v * b10;
		    t23 += v * b11;
		    t24 += v * b12;
		    t25 += v * b13;
		    t26 += v * b14;
		    t27 += v * b15;
		    v = a[13];
		    t13 += v * b0;
		    t14 += v * b1;
		    t15 += v * b2;
		    t16 += v * b3;
		    t17 += v * b4;
		    t18 += v * b5;
		    t19 += v * b6;
		    t20 += v * b7;
		    t21 += v * b8;
		    t22 += v * b9;
		    t23 += v * b10;
		    t24 += v * b11;
		    t25 += v * b12;
		    t26 += v * b13;
		    t27 += v * b14;
		    t28 += v * b15;
		    v = a[14];
		    t14 += v * b0;
		    t15 += v * b1;
		    t16 += v * b2;
		    t17 += v * b3;
		    t18 += v * b4;
		    t19 += v * b5;
		    t20 += v * b6;
		    t21 += v * b7;
		    t22 += v * b8;
		    t23 += v * b9;
		    t24 += v * b10;
		    t25 += v * b11;
		    t26 += v * b12;
		    t27 += v * b13;
		    t28 += v * b14;
		    t29 += v * b15;
		    v = a[15];
		    t15 += v * b0;
		    t16 += v * b1;
		    t17 += v * b2;
		    t18 += v * b3;
		    t19 += v * b4;
		    t20 += v * b5;
		    t21 += v * b6;
		    t22 += v * b7;
		    t23 += v * b8;
		    t24 += v * b9;
		    t25 += v * b10;
		    t26 += v * b11;
		    t27 += v * b12;
		    t28 += v * b13;
		    t29 += v * b14;
		    t30 += v * b15;
		    t0 += 38 * t16;
		    t1 += 38 * t17;
		    t2 += 38 * t18;
		    t3 += 38 * t19;
		    t4 += 38 * t20;
		    t5 += 38 * t21;
		    t6 += 38 * t22;
		    t7 += 38 * t23;
		    t8 += 38 * t24;
		    t9 += 38 * t25;
		    t10 += 38 * t26;
		    t11 += 38 * t27;
		    t12 += 38 * t28;
		    t13 += 38 * t29;
		    t14 += 38 * t30;
		    // t15 left as is
		    // first car
		    c = 1;
		    v = t0 + c + 65535;
		    c = Math.floor(v / 65536);
		    t0 = v - c * 65536;
		    v = t1 + c + 65535;
		    c = Math.floor(v / 65536);
		    t1 = v - c * 65536;
		    v = t2 + c + 65535;
		    c = Math.floor(v / 65536);
		    t2 = v - c * 65536;
		    v = t3 + c + 65535;
		    c = Math.floor(v / 65536);
		    t3 = v - c * 65536;
		    v = t4 + c + 65535;
		    c = Math.floor(v / 65536);
		    t4 = v - c * 65536;
		    v = t5 + c + 65535;
		    c = Math.floor(v / 65536);
		    t5 = v - c * 65536;
		    v = t6 + c + 65535;
		    c = Math.floor(v / 65536);
		    t6 = v - c * 65536;
		    v = t7 + c + 65535;
		    c = Math.floor(v / 65536);
		    t7 = v - c * 65536;
		    v = t8 + c + 65535;
		    c = Math.floor(v / 65536);
		    t8 = v - c * 65536;
		    v = t9 + c + 65535;
		    c = Math.floor(v / 65536);
		    t9 = v - c * 65536;
		    v = t10 + c + 65535;
		    c = Math.floor(v / 65536);
		    t10 = v - c * 65536;
		    v = t11 + c + 65535;
		    c = Math.floor(v / 65536);
		    t11 = v - c * 65536;
		    v = t12 + c + 65535;
		    c = Math.floor(v / 65536);
		    t12 = v - c * 65536;
		    v = t13 + c + 65535;
		    c = Math.floor(v / 65536);
		    t13 = v - c * 65536;
		    v = t14 + c + 65535;
		    c = Math.floor(v / 65536);
		    t14 = v - c * 65536;
		    v = t15 + c + 65535;
		    c = Math.floor(v / 65536);
		    t15 = v - c * 65536;
		    t0 += c - 1 + 37 * (c - 1);
		    // second car
		    c = 1;
		    v = t0 + c + 65535;
		    c = Math.floor(v / 65536);
		    t0 = v - c * 65536;
		    v = t1 + c + 65535;
		    c = Math.floor(v / 65536);
		    t1 = v - c * 65536;
		    v = t2 + c + 65535;
		    c = Math.floor(v / 65536);
		    t2 = v - c * 65536;
		    v = t3 + c + 65535;
		    c = Math.floor(v / 65536);
		    t3 = v - c * 65536;
		    v = t4 + c + 65535;
		    c = Math.floor(v / 65536);
		    t4 = v - c * 65536;
		    v = t5 + c + 65535;
		    c = Math.floor(v / 65536);
		    t5 = v - c * 65536;
		    v = t6 + c + 65535;
		    c = Math.floor(v / 65536);
		    t6 = v - c * 65536;
		    v = t7 + c + 65535;
		    c = Math.floor(v / 65536);
		    t7 = v - c * 65536;
		    v = t8 + c + 65535;
		    c = Math.floor(v / 65536);
		    t8 = v - c * 65536;
		    v = t9 + c + 65535;
		    c = Math.floor(v / 65536);
		    t9 = v - c * 65536;
		    v = t10 + c + 65535;
		    c = Math.floor(v / 65536);
		    t10 = v - c * 65536;
		    v = t11 + c + 65535;
		    c = Math.floor(v / 65536);
		    t11 = v - c * 65536;
		    v = t12 + c + 65535;
		    c = Math.floor(v / 65536);
		    t12 = v - c * 65536;
		    v = t13 + c + 65535;
		    c = Math.floor(v / 65536);
		    t13 = v - c * 65536;
		    v = t14 + c + 65535;
		    c = Math.floor(v / 65536);
		    t14 = v - c * 65536;
		    v = t15 + c + 65535;
		    c = Math.floor(v / 65536);
		    t15 = v - c * 65536;
		    t0 += c - 1 + 37 * (c - 1);
		    o[0] = t0;
		    o[1] = t1;
		    o[2] = t2;
		    o[3] = t3;
		    o[4] = t4;
		    o[5] = t5;
		    o[6] = t6;
		    o[7] = t7;
		    o[8] = t8;
		    o[9] = t9;
		    o[10] = t10;
		    o[11] = t11;
		    o[12] = t12;
		    o[13] = t13;
		    o[14] = t14;
		    o[15] = t15;
		}
		function square(o, a) {
		    mul(o, a, a);
		}
		function inv25519(o, inp) {
		    const c = gf();
		    for (let i = 0; i < 16; i++) {
		        c[i] = inp[i];
		    }
		    for (let i = 253; i >= 0; i--) {
		        square(c, c);
		        if (i !== 2 && i !== 4) {
		            mul(c, c, inp);
		        }
		    }
		    for (let i = 0; i < 16; i++) {
		        o[i] = c[i];
		    }
		}
		function scalarMult(n, p) {
		    const z = new Uint8Array(32);
		    const x = new Float64Array(80);
		    const a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
		    for (let i = 0; i < 31; i++) {
		        z[i] = n[i];
		    }
		    z[31] = (n[31] & 127) | 64;
		    z[0] &= 248;
		    unpack25519(x, p);
		    for (let i = 0; i < 16; i++) {
		        b[i] = x[i];
		    }
		    a[0] = d[0] = 1;
		    for (let i = 254; i >= 0; --i) {
		        const r = (z[i >>> 3] >>> (i & 7)) & 1;
		        sel25519(a, b, r);
		        sel25519(c, d, r);
		        add(e, a, c);
		        sub(a, a, c);
		        add(c, b, d);
		        sub(b, b, d);
		        square(d, e);
		        square(f, a);
		        mul(a, c, a);
		        mul(c, b, e);
		        add(e, a, c);
		        sub(a, a, c);
		        square(b, a);
		        sub(c, d, f);
		        mul(a, c, _121665);
		        add(a, a, d);
		        mul(c, c, a);
		        mul(a, d, f);
		        mul(d, b, x);
		        square(b, e);
		        sel25519(a, b, r);
		        sel25519(c, d, r);
		    }
		    for (let i = 0; i < 16; i++) {
		        x[i + 16] = a[i];
		        x[i + 32] = c[i];
		        x[i + 48] = b[i];
		        x[i + 64] = d[i];
		    }
		    const x32 = x.subarray(32);
		    const x16 = x.subarray(16);
		    inv25519(x32, x32);
		    mul(x16, x16, x32);
		    const q = new Uint8Array(32);
		    pack25519(q, x16);
		    return q;
		}
		exports.scalarMult = scalarMult;
		function scalarMultBase(n) {
		    return scalarMult(n, _9);
		}
		exports.scalarMultBase = scalarMultBase;
		function generateKeyPairFromSeed(seed) {
		    if (seed.length !== exports.SECRET_KEY_LENGTH) {
		        throw new Error(`x25519: seed must be ${exports.SECRET_KEY_LENGTH} bytes`);
		    }
		    const secretKey = new Uint8Array(seed);
		    const publicKey = scalarMultBase(secretKey);
		    return {
		        publicKey,
		        secretKey
		    };
		}
		exports.generateKeyPairFromSeed = generateKeyPairFromSeed;
		function generateKeyPair(prng) {
		    const seed = (0, random_1.randomBytes)(32, prng);
		    const result = generateKeyPairFromSeed(seed);
		    (0, wipe_1.wipe)(seed);
		    return result;
		}
		exports.generateKeyPair = generateKeyPair;
		/**
		 * Returns a shared key between our secret key and a peer's public key.
		 *
		 * Throws an error if the given keys are of wrong length.
		 *
		 * If rejectZero is true throws if the calculated shared key is all-zero.
		 * From RFC 7748:
		 *
		 * > Protocol designers using Diffie-Hellman over the curves defined in
		 * > this document must not assume "contributory behavior".  Specially,
		 * > contributory behavior means that both parties' private keys
		 * > contribute to the resulting shared key.  Since curve25519 and
		 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
		 * > small order will eliminate any contribution from the other party's
		 * > private key.  This situation can be detected by checking for the all-
		 * > zero output, which implementations MAY do, as specified in Section 6.
		 * > However, a large number of existing implementations do not do this.
		 *
		 * IMPORTANT: the returned key is a raw result of scalar multiplication.
		 * To use it as a key material, hash it with a cryptographic hash function.
		 */
		function sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
		    if (mySecretKey.length !== exports.PUBLIC_KEY_LENGTH) {
		        throw new Error("X25519: incorrect secret key length");
		    }
		    if (theirPublicKey.length !== exports.PUBLIC_KEY_LENGTH) {
		        throw new Error("X25519: incorrect public key length");
		    }
		    const result = scalarMult(mySecretKey, theirPublicKey);
		    if (rejectZero) {
		        let zeros = 0;
		        for (let i = 0; i < result.length; i++) {
		            zeros |= result[i];
		        }
		        if (zeros === 0) {
		            throw new Error("X25519: invalid shared key");
		        }
		    }
		    return result;
		}
		exports.sharedKey = sharedKey;
		
	} (x25519));

	function allocUnsafe(size = 0) {
	  if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) {
	    return globalThis.Buffer.allocUnsafe(size);
	  }
	  return new Uint8Array(size);
	}

	function concat$3(arrays, length) {
	  if (!length) {
	    length = arrays.reduce((acc, curr) => acc + curr.length, 0);
	  }
	  const output = allocUnsafe(length);
	  let offset = 0;
	  for (const arr of arrays) {
	    output.set(arr, offset);
	    offset += arr.length;
	  }
	  return output;
	}

	function base$2(ALPHABET, name) {
	  if (ALPHABET.length >= 255) {
	    throw new TypeError('Alphabet too long');
	  }
	  var BASE_MAP = new Uint8Array(256);
	  for (var j = 0; j < BASE_MAP.length; j++) {
	    BASE_MAP[j] = 255;
	  }
	  for (var i = 0; i < ALPHABET.length; i++) {
	    var x = ALPHABET.charAt(i);
	    var xc = x.charCodeAt(0);
	    if (BASE_MAP[xc] !== 255) {
	      throw new TypeError(x + ' is ambiguous');
	    }
	    BASE_MAP[xc] = i;
	  }
	  var BASE = ALPHABET.length;
	  var LEADER = ALPHABET.charAt(0);
	  var FACTOR = Math.log(BASE) / Math.log(256);
	  var iFACTOR = Math.log(256) / Math.log(BASE);
	  function encode(source) {
	    if (source instanceof Uint8Array);
	    else if (ArrayBuffer.isView(source)) {
	      source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
	    } else if (Array.isArray(source)) {
	      source = Uint8Array.from(source);
	    }
	    if (!(source instanceof Uint8Array)) {
	      throw new TypeError('Expected Uint8Array');
	    }
	    if (source.length === 0) {
	      return '';
	    }
	    var zeroes = 0;
	    var length = 0;
	    var pbegin = 0;
	    var pend = source.length;
	    while (pbegin !== pend && source[pbegin] === 0) {
	      pbegin++;
	      zeroes++;
	    }
	    var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
	    var b58 = new Uint8Array(size);
	    while (pbegin !== pend) {
	      var carry = source[pbegin];
	      var i = 0;
	      for (var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++) {
	        carry += 256 * b58[it1] >>> 0;
	        b58[it1] = carry % BASE >>> 0;
	        carry = carry / BASE >>> 0;
	      }
	      if (carry !== 0) {
	        throw new Error('Non-zero carry');
	      }
	      length = i;
	      pbegin++;
	    }
	    var it2 = size - length;
	    while (it2 !== size && b58[it2] === 0) {
	      it2++;
	    }
	    var str = LEADER.repeat(zeroes);
	    for (; it2 < size; ++it2) {
	      str += ALPHABET.charAt(b58[it2]);
	    }
	    return str;
	  }
	  function decodeUnsafe(source) {
	    if (typeof source !== 'string') {
	      throw new TypeError('Expected String');
	    }
	    if (source.length === 0) {
	      return new Uint8Array();
	    }
	    var psz = 0;
	    if (source[psz] === ' ') {
	      return;
	    }
	    var zeroes = 0;
	    var length = 0;
	    while (source[psz] === LEADER) {
	      zeroes++;
	      psz++;
	    }
	    var size = (source.length - psz) * FACTOR + 1 >>> 0;
	    var b256 = new Uint8Array(size);
	    while (source[psz]) {
	      var carry = BASE_MAP[source.charCodeAt(psz)];
	      if (carry === 255) {
	        return;
	      }
	      var i = 0;
	      for (var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++) {
	        carry += BASE * b256[it3] >>> 0;
	        b256[it3] = carry % 256 >>> 0;
	        carry = carry / 256 >>> 0;
	      }
	      if (carry !== 0) {
	        throw new Error('Non-zero carry');
	      }
	      length = i;
	      psz++;
	    }
	    if (source[psz] === ' ') {
	      return;
	    }
	    var it4 = size - length;
	    while (it4 !== size && b256[it4] === 0) {
	      it4++;
	    }
	    var vch = new Uint8Array(zeroes + (size - it4));
	    var j = zeroes;
	    while (it4 !== size) {
	      vch[j++] = b256[it4++];
	    }
	    return vch;
	  }
	  function decode(string) {
	    var buffer = decodeUnsafe(string);
	    if (buffer) {
	      return buffer;
	    }
	    throw new Error(`Non-${ name } character`);
	  }
	  return {
	    encode: encode,
	    decodeUnsafe: decodeUnsafe,
	    decode: decode
	  };
	}
	var src$1 = base$2;
	var _brrp__multiformats_scope_baseX = src$1;

	const coerce$3 = o => {
	  if (o instanceof Uint8Array && o.constructor.name === 'Uint8Array')
	    return o;
	  if (o instanceof ArrayBuffer)
	    return new Uint8Array(o);
	  if (ArrayBuffer.isView(o)) {
	    return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
	  }
	  throw new Error('Unknown type, must be binary type');
	};
	const fromString$2 = str => new TextEncoder().encode(str);
	const toString$1 = b => new TextDecoder().decode(b);

	class Encoder {
	  constructor(name, prefix, baseEncode) {
	    this.name = name;
	    this.prefix = prefix;
	    this.baseEncode = baseEncode;
	  }
	  encode(bytes) {
	    if (bytes instanceof Uint8Array) {
	      return `${ this.prefix }${ this.baseEncode(bytes) }`;
	    } else {
	      throw Error('Unknown type, must be binary type');
	    }
	  }
	}
	class Decoder {
	  constructor(name, prefix, baseDecode) {
	    this.name = name;
	    this.prefix = prefix;
	    if (prefix.codePointAt(0) === undefined) {
	      throw new Error('Invalid prefix character');
	    }
	    this.prefixCodePoint = prefix.codePointAt(0);
	    this.baseDecode = baseDecode;
	  }
	  decode(text) {
	    if (typeof text === 'string') {
	      if (text.codePointAt(0) !== this.prefixCodePoint) {
	        throw Error(`Unable to decode multibase string ${ JSON.stringify(text) }, ${ this.name } decoder only supports inputs prefixed with ${ this.prefix }`);
	      }
	      return this.baseDecode(text.slice(this.prefix.length));
	    } else {
	      throw Error('Can only multibase decode strings');
	    }
	  }
	  or(decoder) {
	    return or$1(this, decoder);
	  }
	}
	class ComposedDecoder {
	  constructor(decoders) {
	    this.decoders = decoders;
	  }
	  or(decoder) {
	    return or$1(this, decoder);
	  }
	  decode(input) {
	    const prefix = input[0];
	    const decoder = this.decoders[prefix];
	    if (decoder) {
	      return decoder.decode(input);
	    } else {
	      throw RangeError(`Unable to decode multibase string ${ JSON.stringify(input) }, only inputs prefixed with ${ Object.keys(this.decoders) } are supported`);
	    }
	  }
	}
	const or$1 = (left, right) => new ComposedDecoder({
	  ...left.decoders || { [left.prefix]: left },
	  ...right.decoders || { [right.prefix]: right }
	});
	class Codec {
	  constructor(name, prefix, baseEncode, baseDecode) {
	    this.name = name;
	    this.prefix = prefix;
	    this.baseEncode = baseEncode;
	    this.baseDecode = baseDecode;
	    this.encoder = new Encoder(name, prefix, baseEncode);
	    this.decoder = new Decoder(name, prefix, baseDecode);
	  }
	  encode(input) {
	    return this.encoder.encode(input);
	  }
	  decode(input) {
	    return this.decoder.decode(input);
	  }
	}
	const from$1 = ({name, prefix, encode, decode}) => new Codec(name, prefix, encode, decode);
	const baseX = ({prefix, name, alphabet}) => {
	  const {encode, decode} = _brrp__multiformats_scope_baseX(alphabet, name);
	  return from$1({
	    prefix,
	    name,
	    encode,
	    decode: text => coerce$3(decode(text))
	  });
	};
	const decode$3 = (string, alphabet, bitsPerChar, name) => {
	  const codes = {};
	  for (let i = 0; i < alphabet.length; ++i) {
	    codes[alphabet[i]] = i;
	  }
	  let end = string.length;
	  while (string[end - 1] === '=') {
	    --end;
	  }
	  const out = new Uint8Array(end * bitsPerChar / 8 | 0);
	  let bits = 0;
	  let buffer = 0;
	  let written = 0;
	  for (let i = 0; i < end; ++i) {
	    const value = codes[string[i]];
	    if (value === undefined) {
	      throw new SyntaxError(`Non-${ name } character`);
	    }
	    buffer = buffer << bitsPerChar | value;
	    bits += bitsPerChar;
	    if (bits >= 8) {
	      bits -= 8;
	      out[written++] = 255 & buffer >> bits;
	    }
	  }
	  if (bits >= bitsPerChar || 255 & buffer << 8 - bits) {
	    throw new SyntaxError('Unexpected end of data');
	  }
	  return out;
	};
	const encode$2 = (data, alphabet, bitsPerChar) => {
	  const pad = alphabet[alphabet.length - 1] === '=';
	  const mask = (1 << bitsPerChar) - 1;
	  let out = '';
	  let bits = 0;
	  let buffer = 0;
	  for (let i = 0; i < data.length; ++i) {
	    buffer = buffer << 8 | data[i];
	    bits += 8;
	    while (bits > bitsPerChar) {
	      bits -= bitsPerChar;
	      out += alphabet[mask & buffer >> bits];
	    }
	  }
	  if (bits) {
	    out += alphabet[mask & buffer << bitsPerChar - bits];
	  }
	  if (pad) {
	    while (out.length * bitsPerChar & 7) {
	      out += '=';
	    }
	  }
	  return out;
	};
	const rfc4648 = ({name, prefix, bitsPerChar, alphabet}) => {
	  return from$1({
	    prefix,
	    name,
	    encode(input) {
	      return encode$2(input, alphabet, bitsPerChar);
	    },
	    decode(input) {
	      return decode$3(input, alphabet, bitsPerChar, name);
	    }
	  });
	};

	const identity$1 = from$1({
	  prefix: '\0',
	  name: 'identity',
	  encode: buf => toString$1(buf),
	  decode: str => fromString$2(str)
	});

	var identityBase = /*#__PURE__*/Object.freeze({
		__proto__: null,
		identity: identity$1
	});

	const base2 = rfc4648({
	  prefix: '0',
	  name: 'base2',
	  alphabet: '01',
	  bitsPerChar: 1
	});

	var base2$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		base2: base2
	});

	const base8 = rfc4648({
	  prefix: '7',
	  name: 'base8',
	  alphabet: '01234567',
	  bitsPerChar: 3
	});

	var base8$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		base8: base8
	});

	const base10 = baseX({
	  prefix: '9',
	  name: 'base10',
	  alphabet: '0123456789'
	});

	var base10$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		base10: base10
	});

	const base16 = rfc4648({
	  prefix: 'f',
	  name: 'base16',
	  alphabet: '0123456789abcdef',
	  bitsPerChar: 4
	});
	const base16upper = rfc4648({
	  prefix: 'F',
	  name: 'base16upper',
	  alphabet: '0123456789ABCDEF',
	  bitsPerChar: 4
	});

	var base16$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		base16: base16,
		base16upper: base16upper
	});

	const base32 = rfc4648({
	  prefix: 'b',
	  name: 'base32',
	  alphabet: 'abcdefghijklmnopqrstuvwxyz234567',
	  bitsPerChar: 5
	});
	const base32upper = rfc4648({
	  prefix: 'B',
	  name: 'base32upper',
	  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567',
	  bitsPerChar: 5
	});
	const base32pad = rfc4648({
	  prefix: 'c',
	  name: 'base32pad',
	  alphabet: 'abcdefghijklmnopqrstuvwxyz234567=',
	  bitsPerChar: 5
	});
	const base32padupper = rfc4648({
	  prefix: 'C',
	  name: 'base32padupper',
	  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=',
	  bitsPerChar: 5
	});
	const base32hex = rfc4648({
	  prefix: 'v',
	  name: 'base32hex',
	  alphabet: '0123456789abcdefghijklmnopqrstuv',
	  bitsPerChar: 5
	});
	const base32hexupper = rfc4648({
	  prefix: 'V',
	  name: 'base32hexupper',
	  alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV',
	  bitsPerChar: 5
	});
	const base32hexpad = rfc4648({
	  prefix: 't',
	  name: 'base32hexpad',
	  alphabet: '0123456789abcdefghijklmnopqrstuv=',
	  bitsPerChar: 5
	});
	const base32hexpadupper = rfc4648({
	  prefix: 'T',
	  name: 'base32hexpadupper',
	  alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV=',
	  bitsPerChar: 5
	});
	const base32z = rfc4648({
	  prefix: 'h',
	  name: 'base32z',
	  alphabet: 'ybndrfg8ejkmcpqxot1uwisza345h769',
	  bitsPerChar: 5
	});

	var base32$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		base32: base32,
		base32hex: base32hex,
		base32hexpad: base32hexpad,
		base32hexpadupper: base32hexpadupper,
		base32hexupper: base32hexupper,
		base32pad: base32pad,
		base32padupper: base32padupper,
		base32upper: base32upper,
		base32z: base32z
	});

	const base36 = baseX({
	  prefix: 'k',
	  name: 'base36',
	  alphabet: '0123456789abcdefghijklmnopqrstuvwxyz'
	});
	const base36upper = baseX({
	  prefix: 'K',
	  name: 'base36upper',
	  alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
	});

	var base36$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		base36: base36,
		base36upper: base36upper
	});

	const base58btc = baseX({
	  name: 'base58btc',
	  prefix: 'z',
	  alphabet: '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
	});
	const base58flickr = baseX({
	  name: 'base58flickr',
	  prefix: 'Z',
	  alphabet: '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'
	});

	var base58 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		base58btc: base58btc,
		base58flickr: base58flickr
	});

	const base64$4 = rfc4648({
	  prefix: 'm',
	  name: 'base64',
	  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	  bitsPerChar: 6
	});
	const base64pad = rfc4648({
	  prefix: 'M',
	  name: 'base64pad',
	  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
	  bitsPerChar: 6
	});
	const base64url = rfc4648({
	  prefix: 'u',
	  name: 'base64url',
	  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
	  bitsPerChar: 6
	});
	const base64urlpad = rfc4648({
	  prefix: 'U',
	  name: 'base64urlpad',
	  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=',
	  bitsPerChar: 6
	});

	var base64$5 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		base64: base64$4,
		base64pad: base64pad,
		base64url: base64url,
		base64urlpad: base64urlpad
	});

	const alphabet = Array.from('\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42');
	const alphabetBytesToChars = alphabet.reduce((p, c, i) => {
	  p[i] = c;
	  return p;
	}, []);
	const alphabetCharsToBytes = alphabet.reduce((p, c, i) => {
	  p[c.codePointAt(0)] = i;
	  return p;
	}, []);
	function encode$1(data) {
	  return data.reduce((p, c) => {
	    p += alphabetBytesToChars[c];
	    return p;
	  }, '');
	}
	function decode$2(str) {
	  const byts = [];
	  for (const char of str) {
	    const byt = alphabetCharsToBytes[char.codePointAt(0)];
	    if (byt === undefined) {
	      throw new Error(`Non-base256emoji character: ${ char }`);
	    }
	    byts.push(byt);
	  }
	  return new Uint8Array(byts);
	}
	const base256emoji = from$1({
	  prefix: '\uD83D\uDE80',
	  name: 'base256emoji',
	  encode: encode$1,
	  decode: decode$2
	});

	var base256emoji$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		base256emoji: base256emoji
	});

	new TextEncoder();
	new TextDecoder();

	const bases = {
	  ...identityBase,
	  ...base2$1,
	  ...base8$1,
	  ...base10$1,
	  ...base16$1,
	  ...base32$1,
	  ...base36$1,
	  ...base58,
	  ...base64$5,
	  ...base256emoji$1
	};

	function createCodec(name, prefix, encode, decode) {
	  return {
	    name,
	    prefix,
	    encoder: {
	      name,
	      prefix,
	      encode
	    },
	    decoder: { decode }
	  };
	}
	const string$1 = createCodec('utf8', 'u', buf => {
	  const decoder = new TextDecoder('utf8');
	  return 'u' + decoder.decode(buf);
	}, str => {
	  const encoder = new TextEncoder();
	  return encoder.encode(str.substring(1));
	});
	const ascii = createCodec('ascii', 'a', buf => {
	  let string = 'a';
	  for (let i = 0; i < buf.length; i++) {
	    string += String.fromCharCode(buf[i]);
	  }
	  return string;
	}, str => {
	  str = str.substring(1);
	  const buf = allocUnsafe(str.length);
	  for (let i = 0; i < str.length; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	});
	const BASES = {
	  utf8: string$1,
	  'utf-8': string$1,
	  hex: bases.base16,
	  latin1: ascii,
	  ascii: ascii,
	  binary: ascii,
	  ...bases
	};

	function fromString$1(string, encoding = 'utf8') {
	  const base = BASES[encoding];
	  if (!base) {
	    throw new Error(`Unsupported encoding "${ encoding }"`);
	  }
	  if ((encoding === 'utf8' || encoding === 'utf-8') && globalThis.Buffer != null && globalThis.Buffer.from != null) {
	    return globalThis.Buffer.from(string, 'utf8');
	  }
	  return base.decoder.decode(`${ base.prefix }${ string }`);
	}

	function toString(array, encoding = 'utf8') {
	  const base = BASES[encoding];
	  if (!base) {
	    throw new Error(`Unsupported encoding "${ encoding }"`);
	  }
	  if ((encoding === 'utf8' || encoding === 'utf-8') && globalThis.Buffer != null && globalThis.Buffer.from != null) {
	    return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString('utf8');
	  }
	  return base.encoder.encode(array).substring(1);
	}

	var __spreadArray$1 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
	    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	        if (ar || !(i in from)) {
	            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	            ar[i] = from[i];
	        }
	    }
	    return to.concat(ar || Array.prototype.slice.call(from));
	};
	var BrowserInfo = /** @class */ (function () {
	    function BrowserInfo(name, version, os) {
	        this.name = name;
	        this.version = version;
	        this.os = os;
	        this.type = 'browser';
	    }
	    return BrowserInfo;
	}());
	var NodeInfo = /** @class */ (function () {
	    function NodeInfo(version) {
	        this.version = version;
	        this.type = 'node';
	        this.name = 'node';
	        this.os = process.platform;
	    }
	    return NodeInfo;
	}());
	var SearchBotDeviceInfo = /** @class */ (function () {
	    function SearchBotDeviceInfo(name, version, os, bot) {
	        this.name = name;
	        this.version = version;
	        this.os = os;
	        this.bot = bot;
	        this.type = 'bot-device';
	    }
	    return SearchBotDeviceInfo;
	}());
	var BotInfo = /** @class */ (function () {
	    function BotInfo() {
	        this.type = 'bot';
	        this.bot = true; // NOTE: deprecated test name instead
	        this.name = 'bot';
	        this.version = null;
	        this.os = null;
	    }
	    return BotInfo;
	}());
	var ReactNativeInfo = /** @class */ (function () {
	    function ReactNativeInfo() {
	        this.type = 'react-native';
	        this.name = 'react-native';
	        this.version = null;
	        this.os = null;
	    }
	    return ReactNativeInfo;
	}());
	// tslint:disable-next-line:max-line-length
	var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
	var SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
	var REQUIRED_VERSION_PARTS = 3;
	var userAgentRules = [
	    ['aol', /AOLShield\/([0-9\._]+)/],
	    ['edge', /Edge\/([0-9\._]+)/],
	    ['edge-ios', /EdgiOS\/([0-9\._]+)/],
	    ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
	    ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/],
	    ['samsung', /SamsungBrowser\/([0-9\.]+)/],
	    ['silk', /\bSilk\/([0-9._-]+)\b/],
	    ['miui', /MiuiBrowser\/([0-9\.]+)$/],
	    ['beaker', /BeakerBrowser\/([0-9\.]+)/],
	    ['edge-chromium', /EdgA?\/([0-9\.]+)/],
	    [
	        'chromium-webview',
	        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
	    ],
	    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
	    ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/],
	    ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/],
	    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
	    ['fxios', /FxiOS\/([0-9\.]+)/],
	    ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/],
	    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
	    ['opera', /OPR\/([0-9\.]+)(:?\s|$)/],
	    ['pie', /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/],
	    ['pie', /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/],
	    ['netfront', /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/],
	    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
	    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
	    ['ie', /MSIE\s(7\.0)/],
	    ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
	    ['android', /Android\s([0-9\.]+)/],
	    ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
	    ['safari', /Version\/([0-9\._]+).*Safari/],
	    ['facebook', /FB[AS]V\/([0-9\.]+)/],
	    ['instagram', /Instagram\s([0-9\.]+)/],
	    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/],
	    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
	    ['curl', /^curl\/([0-9\.]+)$/],
	    ['searchbot', SEARCHBOX_UA_REGEX],
	];
	var operatingSystemRules = [
	    ['iOS', /iP(hone|od|ad)/],
	    ['Android OS', /Android/],
	    ['BlackBerry OS', /BlackBerry|BB10/],
	    ['Windows Mobile', /IEMobile/],
	    ['Amazon OS', /Kindle/],
	    ['Windows 3.11', /Win16/],
	    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
	    ['Windows 98', /(Windows 98)|(Win98)/],
	    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
	    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
	    ['Windows Server 2003', /(Windows NT 5.2)/],
	    ['Windows Vista', /(Windows NT 6.0)/],
	    ['Windows 7', /(Windows NT 6.1)/],
	    ['Windows 8', /(Windows NT 6.2)/],
	    ['Windows 8.1', /(Windows NT 6.3)/],
	    ['Windows 10', /(Windows NT 10.0)/],
	    ['Windows ME', /Windows ME/],
	    ['Windows CE', /Windows CE|WinCE|Microsoft Pocket Internet Explorer/],
	    ['Open BSD', /OpenBSD/],
	    ['Sun OS', /SunOS/],
	    ['Chrome OS', /CrOS/],
	    ['Linux', /(Linux)|(X11)/],
	    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
	    ['QNX', /QNX/],
	    ['BeOS', /BeOS/],
	    ['OS/2', /OS\/2/],
	];
	function detect(userAgent) {
	    if (!!userAgent) {
	        return parseUserAgent(userAgent);
	    }
	    if (typeof document === 'undefined' &&
	        typeof navigator !== 'undefined' &&
	        navigator.product === 'ReactNative') {
	        return new ReactNativeInfo();
	    }
	    if (typeof navigator !== 'undefined') {
	        return parseUserAgent(navigator.userAgent);
	    }
	    return getNodeVersion();
	}
	function matchUserAgent(ua) {
	    // opted for using reduce here rather than Array#first with a regex.test call
	    // this is primarily because using the reduce we only perform the regex
	    // execution once rather than once for the test and for the exec again below
	    // probably something that needs to be benchmarked though
	    return (ua !== '' &&
	        userAgentRules.reduce(function (matched, _a) {
	            var browser = _a[0], regex = _a[1];
	            if (matched) {
	                return matched;
	            }
	            var uaMatch = regex.exec(ua);
	            return !!uaMatch && [browser, uaMatch];
	        }, false));
	}
	function parseUserAgent(ua) {
	    var matchedRule = matchUserAgent(ua);
	    if (!matchedRule) {
	        return null;
	    }
	    var name = matchedRule[0], match = matchedRule[1];
	    if (name === 'searchbot') {
	        return new BotInfo();
	    }
	    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
	    var versionParts = match[1] && match[1].split('.').join('_').split('_').slice(0, 3);
	    if (versionParts) {
	        if (versionParts.length < REQUIRED_VERSION_PARTS) {
	            versionParts = __spreadArray$1(__spreadArray$1([], versionParts, true), createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length), true);
	        }
	    }
	    else {
	        versionParts = [];
	    }
	    var version = versionParts.join('.');
	    var os = detectOS(ua);
	    var searchBotMatch = SEARCHBOT_OS_REGEX.exec(ua);
	    if (searchBotMatch && searchBotMatch[1]) {
	        return new SearchBotDeviceInfo(name, version, os, searchBotMatch[1]);
	    }
	    return new BrowserInfo(name, version, os);
	}
	function detectOS(ua) {
	    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
	        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
	        var match = regex.exec(ua);
	        if (match) {
	            return os;
	        }
	    }
	    return null;
	}
	function getNodeVersion() {
	    var isNode = typeof process !== 'undefined' && process.version;
	    return isNode ? new NodeInfo(process.version.slice(1)) : null;
	}
	function createVersionParts(count) {
	    var output = [];
	    for (var ii = 0; ii < count; ii++) {
	        output.push('0');
	    }
	    return output;
	}

	var cjs$6 = {};

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$1 = function(d, b) {
	    extendStatics$1 = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return extendStatics$1(d, b);
	};

	function __extends$1(d, b) {
	    extendStatics$1(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var __assign$1 = function() {
	    __assign$1 = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign$1.apply(this, arguments);
	};

	function __rest$2(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	}

	function __decorate$2(decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	}

	function __param$1(paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	}

	function __metadata$1(metadataKey, metadataValue) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	}

	function __awaiter$4(thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	}

	function __generator$1(thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	}

	function __createBinding$2(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}

	function __exportStar$1(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	}

	function __values$1(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	}

	function __read$1(o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	}

	function __spread$1() {
	    for (var ar = [], i = 0; i < arguments.length; i++)
	        ar = ar.concat(__read$1(arguments[i]));
	    return ar;
	}

	function __spreadArrays$1() {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	}
	function __await$1(v) {
	    return this instanceof __await$1 ? (this.v = v, this) : new __await$1(v);
	}

	function __asyncGenerator$1(thisArg, _arguments, generator) {
	    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	    var g = generator.apply(thisArg, _arguments || []), i, q = [];
	    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	    function step(r) { r.value instanceof __await$1 ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
	    function fulfill(value) { resume("next", value); }
	    function reject(value) { resume("throw", value); }
	    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	}

	function __asyncDelegator$1(o) {
	    var i, p;
	    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await$1(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	}

	function __asyncValues$1(o) {
	    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	    var m = o[Symbol.asyncIterator], i;
	    return m ? m.call(o) : (o = typeof __values$1 === "function" ? __values$1(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	}

	function __makeTemplateObject$1(cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	}
	function __importStar$2(mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	    result.default = mod;
	    return result;
	}

	function __importDefault$f(mod) {
	    return (mod && mod.__esModule) ? mod : { default: mod };
	}

	function __classPrivateFieldGet$2(receiver, privateMap) {
	    if (!privateMap.has(receiver)) {
	        throw new TypeError("attempted to get private field on non-instance");
	    }
	    return privateMap.get(receiver);
	}

	function __classPrivateFieldSet$2(receiver, privateMap, value) {
	    if (!privateMap.has(receiver)) {
	        throw new TypeError("attempted to set private field on non-instance");
	    }
	    privateMap.set(receiver, value);
	    return value;
	}

	var tslib_es6$2 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		get __assign () { return __assign$1; },
		__asyncDelegator: __asyncDelegator$1,
		__asyncGenerator: __asyncGenerator$1,
		__asyncValues: __asyncValues$1,
		__await: __await$1,
		__awaiter: __awaiter$4,
		__classPrivateFieldGet: __classPrivateFieldGet$2,
		__classPrivateFieldSet: __classPrivateFieldSet$2,
		__createBinding: __createBinding$2,
		__decorate: __decorate$2,
		__exportStar: __exportStar$1,
		__extends: __extends$1,
		__generator: __generator$1,
		__importDefault: __importDefault$f,
		__importStar: __importStar$2,
		__makeTemplateObject: __makeTemplateObject$1,
		__metadata: __metadata$1,
		__param: __param$1,
		__read: __read$1,
		__rest: __rest$2,
		__spread: __spread$1,
		__spreadArrays: __spreadArrays$1,
		__values: __values$1
	});

	var require$$0$4 = /*@__PURE__*/getAugmentedNamespace(tslib_es6$2);

	var utils$x = {};

	var delay$1 = {};

	var hasRequiredDelay;

	function requireDelay () {
		if (hasRequiredDelay) return delay$1;
		hasRequiredDelay = 1;
		Object.defineProperty(delay$1, "__esModule", { value: true });
		delay$1.delay = void 0;
		function delay(timeout) {
		    return new Promise(resolve => {
		        setTimeout(() => {
		            resolve(true);
		        }, timeout);
		    });
		}
		delay$1.delay = delay;
		
		return delay$1;
	}

	var convert = {};

	var constants$5 = {};

	var misc$1 = {};

	var hasRequiredMisc;

	function requireMisc () {
		if (hasRequiredMisc) return misc$1;
		hasRequiredMisc = 1;
		Object.defineProperty(misc$1, "__esModule", { value: true });
		misc$1.ONE_THOUSAND = misc$1.ONE_HUNDRED = void 0;
		misc$1.ONE_HUNDRED = 100;
		misc$1.ONE_THOUSAND = 1000;
		
		return misc$1;
	}

	var time$3 = {};

	var hasRequiredTime;

	function requireTime () {
		if (hasRequiredTime) return time$3;
		hasRequiredTime = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			exports.ONE_YEAR = exports.FOUR_WEEKS = exports.THREE_WEEKS = exports.TWO_WEEKS = exports.ONE_WEEK = exports.THIRTY_DAYS = exports.SEVEN_DAYS = exports.FIVE_DAYS = exports.THREE_DAYS = exports.ONE_DAY = exports.TWENTY_FOUR_HOURS = exports.TWELVE_HOURS = exports.SIX_HOURS = exports.THREE_HOURS = exports.ONE_HOUR = exports.SIXTY_MINUTES = exports.THIRTY_MINUTES = exports.TEN_MINUTES = exports.FIVE_MINUTES = exports.ONE_MINUTE = exports.SIXTY_SECONDS = exports.THIRTY_SECONDS = exports.TEN_SECONDS = exports.FIVE_SECONDS = exports.ONE_SECOND = void 0;
			exports.ONE_SECOND = 1;
			exports.FIVE_SECONDS = 5;
			exports.TEN_SECONDS = 10;
			exports.THIRTY_SECONDS = 30;
			exports.SIXTY_SECONDS = 60;
			exports.ONE_MINUTE = exports.SIXTY_SECONDS;
			exports.FIVE_MINUTES = exports.ONE_MINUTE * 5;
			exports.TEN_MINUTES = exports.ONE_MINUTE * 10;
			exports.THIRTY_MINUTES = exports.ONE_MINUTE * 30;
			exports.SIXTY_MINUTES = exports.ONE_MINUTE * 60;
			exports.ONE_HOUR = exports.SIXTY_MINUTES;
			exports.THREE_HOURS = exports.ONE_HOUR * 3;
			exports.SIX_HOURS = exports.ONE_HOUR * 6;
			exports.TWELVE_HOURS = exports.ONE_HOUR * 12;
			exports.TWENTY_FOUR_HOURS = exports.ONE_HOUR * 24;
			exports.ONE_DAY = exports.TWENTY_FOUR_HOURS;
			exports.THREE_DAYS = exports.ONE_DAY * 3;
			exports.FIVE_DAYS = exports.ONE_DAY * 5;
			exports.SEVEN_DAYS = exports.ONE_DAY * 7;
			exports.THIRTY_DAYS = exports.ONE_DAY * 30;
			exports.ONE_WEEK = exports.SEVEN_DAYS;
			exports.TWO_WEEKS = exports.ONE_WEEK * 2;
			exports.THREE_WEEKS = exports.ONE_WEEK * 3;
			exports.FOUR_WEEKS = exports.ONE_WEEK * 4;
			exports.ONE_YEAR = exports.ONE_DAY * 365;
			
		} (time$3));
		return time$3;
	}

	var hasRequiredConstants$2;

	function requireConstants$2 () {
		if (hasRequiredConstants$2) return constants$5;
		hasRequiredConstants$2 = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			const tslib_1 = require$$0$4;
			tslib_1.__exportStar(requireMisc(), exports);
			tslib_1.__exportStar(requireTime(), exports);
			
		} (constants$5));
		return constants$5;
	}

	var hasRequiredConvert;

	function requireConvert () {
		if (hasRequiredConvert) return convert;
		hasRequiredConvert = 1;
		Object.defineProperty(convert, "__esModule", { value: true });
		convert.fromMiliseconds = convert.toMiliseconds = void 0;
		const constants_1 = requireConstants$2();
		function toMiliseconds(seconds) {
		    return seconds * constants_1.ONE_THOUSAND;
		}
		convert.toMiliseconds = toMiliseconds;
		function fromMiliseconds(miliseconds) {
		    return Math.floor(miliseconds / constants_1.ONE_THOUSAND);
		}
		convert.fromMiliseconds = fromMiliseconds;
		
		return convert;
	}

	var hasRequiredUtils$2;

	function requireUtils$2 () {
		if (hasRequiredUtils$2) return utils$x;
		hasRequiredUtils$2 = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			const tslib_1 = require$$0$4;
			tslib_1.__exportStar(requireDelay(), exports);
			tslib_1.__exportStar(requireConvert(), exports);
			
		} (utils$x));
		return utils$x;
	}

	var watch$1 = {};

	var hasRequiredWatch$1;

	function requireWatch$1 () {
		if (hasRequiredWatch$1) return watch$1;
		hasRequiredWatch$1 = 1;
		Object.defineProperty(watch$1, "__esModule", { value: true });
		watch$1.Watch = void 0;
		class Watch {
		    constructor() {
		        this.timestamps = new Map();
		    }
		    start(label) {
		        if (this.timestamps.has(label)) {
		            throw new Error(`Watch already started for label: ${label}`);
		        }
		        this.timestamps.set(label, { started: Date.now() });
		    }
		    stop(label) {
		        const timestamp = this.get(label);
		        if (typeof timestamp.elapsed !== "undefined") {
		            throw new Error(`Watch already stopped for label: ${label}`);
		        }
		        const elapsed = Date.now() - timestamp.started;
		        this.timestamps.set(label, { started: timestamp.started, elapsed });
		    }
		    get(label) {
		        const timestamp = this.timestamps.get(label);
		        if (typeof timestamp === "undefined") {
		            throw new Error(`No timestamp found for label: ${label}`);
		        }
		        return timestamp;
		    }
		    elapsed(label) {
		        const timestamp = this.get(label);
		        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
		        return elapsed;
		    }
		}
		watch$1.Watch = Watch;
		watch$1.default = Watch;
		
		return watch$1;
	}

	var types$5 = {};

	var watch = {};

	var hasRequiredWatch;

	function requireWatch () {
		if (hasRequiredWatch) return watch;
		hasRequiredWatch = 1;
		Object.defineProperty(watch, "__esModule", { value: true });
		watch.IWatch = void 0;
		class IWatch {
		}
		watch.IWatch = IWatch;
		
		return watch;
	}

	var hasRequiredTypes$2;

	function requireTypes$2 () {
		if (hasRequiredTypes$2) return types$5;
		hasRequiredTypes$2 = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			const tslib_1 = require$$0$4;
			tslib_1.__exportStar(requireWatch(), exports);
			
		} (types$5));
		return types$5;
	}

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		const tslib_1 = require$$0$4;
		tslib_1.__exportStar(requireUtils$2(), exports);
		tslib_1.__exportStar(requireWatch$1(), exports);
		tslib_1.__exportStar(requireTypes$2(), exports);
		tslib_1.__exportStar(requireConstants$2(), exports);
		
	} (cjs$6));

	var cjs$5 = {};

	Object.defineProperty(cjs$5, "__esModule", { value: true });
	cjs$5.getLocalStorage = cjs$5.getLocalStorageOrThrow = cjs$5.getCrypto = cjs$5.getCryptoOrThrow = getLocation_1 = cjs$5.getLocation = cjs$5.getLocationOrThrow = getNavigator_1 = cjs$5.getNavigator = cjs$5.getNavigatorOrThrow = getDocument_1 = cjs$5.getDocument = cjs$5.getDocumentOrThrow = cjs$5.getFromWindowOrThrow = cjs$5.getFromWindow = void 0;
	function getFromWindow(name) {
	    let res = undefined;
	    if (typeof window !== "undefined" && typeof window[name] !== "undefined") {
	        res = window[name];
	    }
	    return res;
	}
	cjs$5.getFromWindow = getFromWindow;
	function getFromWindowOrThrow(name) {
	    const res = getFromWindow(name);
	    if (!res) {
	        throw new Error(`${name} is not defined in Window`);
	    }
	    return res;
	}
	cjs$5.getFromWindowOrThrow = getFromWindowOrThrow;
	function getDocumentOrThrow() {
	    return getFromWindowOrThrow("document");
	}
	cjs$5.getDocumentOrThrow = getDocumentOrThrow;
	function getDocument() {
	    return getFromWindow("document");
	}
	var getDocument_1 = cjs$5.getDocument = getDocument;
	function getNavigatorOrThrow() {
	    return getFromWindowOrThrow("navigator");
	}
	cjs$5.getNavigatorOrThrow = getNavigatorOrThrow;
	function getNavigator() {
	    return getFromWindow("navigator");
	}
	var getNavigator_1 = cjs$5.getNavigator = getNavigator;
	function getLocationOrThrow() {
	    return getFromWindowOrThrow("location");
	}
	cjs$5.getLocationOrThrow = getLocationOrThrow;
	function getLocation() {
	    return getFromWindow("location");
	}
	var getLocation_1 = cjs$5.getLocation = getLocation;
	function getCryptoOrThrow() {
	    return getFromWindowOrThrow("crypto");
	}
	cjs$5.getCryptoOrThrow = getCryptoOrThrow;
	function getCrypto() {
	    return getFromWindow("crypto");
	}
	cjs$5.getCrypto = getCrypto;
	function getLocalStorageOrThrow() {
	    return getFromWindowOrThrow("localStorage");
	}
	cjs$5.getLocalStorageOrThrow = getLocalStorageOrThrow;
	function getLocalStorage() {
	    return getFromWindow("localStorage");
	}
	cjs$5.getLocalStorage = getLocalStorage;

	var cjs$4 = {};

	Object.defineProperty(cjs$4, "__esModule", { value: true });
	var getWindowMetadata_1 = cjs$4.getWindowMetadata = void 0;
	const window_getters_1 = cjs$5;
	function getWindowMetadata() {
	    let doc;
	    let loc;
	    try {
	        doc = window_getters_1.getDocumentOrThrow();
	        loc = window_getters_1.getLocationOrThrow();
	    }
	    catch (e) {
	        return null;
	    }
	    function getIcons() {
	        const links = doc.getElementsByTagName("link");
	        const icons = [];
	        for (let i = 0; i < links.length; i++) {
	            const link = links[i];
	            const rel = link.getAttribute("rel");
	            if (rel) {
	                if (rel.toLowerCase().indexOf("icon") > -1) {
	                    const href = link.getAttribute("href");
	                    if (href) {
	                        if (href.toLowerCase().indexOf("https:") === -1 &&
	                            href.toLowerCase().indexOf("http:") === -1 &&
	                            href.indexOf("//") !== 0) {
	                            let absoluteHref = loc.protocol + "//" + loc.host;
	                            if (href.indexOf("/") === 0) {
	                                absoluteHref += href;
	                            }
	                            else {
	                                const path = loc.pathname.split("/");
	                                path.pop();
	                                const finalPath = path.join("/");
	                                absoluteHref += finalPath + "/" + href;
	                            }
	                            icons.push(absoluteHref);
	                        }
	                        else if (href.indexOf("//") === 0) {
	                            const absoluteUrl = loc.protocol + href;
	                            icons.push(absoluteUrl);
	                        }
	                        else {
	                            icons.push(href);
	                        }
	                    }
	                }
	            }
	        }
	        return icons;
	    }
	    function getWindowMetadataOfAny(...args) {
	        const metaTags = doc.getElementsByTagName("meta");
	        for (let i = 0; i < metaTags.length; i++) {
	            const tag = metaTags[i];
	            const attributes = ["itemprop", "property", "name"]
	                .map((target) => tag.getAttribute(target))
	                .filter((attr) => {
	                if (attr) {
	                    return args.includes(attr);
	                }
	                return false;
	            });
	            if (attributes.length && attributes) {
	                const content = tag.getAttribute("content");
	                if (content) {
	                    return content;
	                }
	            }
	        }
	        return "";
	    }
	    function getName() {
	        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
	        if (!name) {
	            name = doc.title;
	        }
	        return name;
	    }
	    function getDescription() {
	        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
	        return description;
	    }
	    const name = getName();
	    const description = getDescription();
	    const url = loc.origin;
	    const icons = getIcons();
	    const meta = {
	        description,
	        url,
	        icons,
	        name,
	    };
	    return meta;
	}
	getWindowMetadata_1 = cjs$4.getWindowMetadata = getWindowMetadata;

	var queryString = {};

	var strictUriEncode = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

	var token = '%[a-f0-9]{2}';
	var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
	var multiMatcher = new RegExp('(' + token + ')+', 'gi');

	function decodeComponents(components, split) {
		try {
			// Try to decode the entire string first
			return [decodeURIComponent(components.join(''))];
		} catch (err) {
			// Do nothing
		}

		if (components.length === 1) {
			return components;
		}

		split = split || 1;

		// Split the array in 2 parts
		var left = components.slice(0, split);
		var right = components.slice(split);

		return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
	}

	function decode$1(input) {
		try {
			return decodeURIComponent(input);
		} catch (err) {
			var tokens = input.match(singleMatcher) || [];

			for (var i = 1; i < tokens.length; i++) {
				input = decodeComponents(tokens, i).join('');

				tokens = input.match(singleMatcher) || [];
			}

			return input;
		}
	}

	function customDecodeURIComponent(input) {
		// Keep track of all the replacements and prefill the map with the `BOM`
		var replaceMap = {
			'%FE%FF': '\uFFFD\uFFFD',
			'%FF%FE': '\uFFFD\uFFFD'
		};

		var match = multiMatcher.exec(input);
		while (match) {
			try {
				// Decode as big chunks as possible
				replaceMap[match[0]] = decodeURIComponent(match[0]);
			} catch (err) {
				var result = decode$1(match[0]);

				if (result !== match[0]) {
					replaceMap[match[0]] = result;
				}
			}

			match = multiMatcher.exec(input);
		}

		// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
		replaceMap['%C2'] = '\uFFFD';

		var entries = Object.keys(replaceMap);

		for (var i = 0; i < entries.length; i++) {
			// Replace all decoded components
			var key = entries[i];
			input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
		}

		return input;
	}

	var decodeUriComponent = function (encodedURI) {
		if (typeof encodedURI !== 'string') {
			throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
		}

		try {
			encodedURI = encodedURI.replace(/\+/g, ' ');

			// Try the built in decoder first
			return decodeURIComponent(encodedURI);
		} catch (err) {
			// Fallback to a more advanced decoder
			return customDecodeURIComponent(encodedURI);
		}
	};

	var splitOnFirst = (string, separator) => {
		if (!(typeof string === 'string' && typeof separator === 'string')) {
			throw new TypeError('Expected the arguments to be of type `string`');
		}

		if (separator === '') {
			return [string];
		}

		const separatorIndex = string.indexOf(separator);

		if (separatorIndex === -1) {
			return [string];
		}

		return [
			string.slice(0, separatorIndex),
			string.slice(separatorIndex + separator.length)
		];
	};

	var filterObj = function (obj, predicate) {
		var ret = {};
		var keys = Object.keys(obj);
		var isArr = Array.isArray(predicate);

		for (var i = 0; i < keys.length; i++) {
			var key = keys[i];
			var val = obj[key];

			if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
				ret[key] = val;
			}
		}

		return ret;
	};

	(function (exports) {
		const strictUriEncode$1 = strictUriEncode;
		const decodeComponent = decodeUriComponent;
		const splitOnFirst$1 = splitOnFirst;
		const filterObject = filterObj;

		const isNullOrUndefined = value => value === null || value === undefined;

		const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

		function encoderForArrayFormat(options) {
			switch (options.arrayFormat) {
				case 'index':
					return key => (result, value) => {
						const index = result.length;

						if (
							value === undefined ||
							(options.skipNull && value === null) ||
							(options.skipEmptyString && value === '')
						) {
							return result;
						}

						if (value === null) {
							return [...result, [encode(key, options), '[', index, ']'].join('')];
						}

						return [
							...result,
							[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
						];
					};

				case 'bracket':
					return key => (result, value) => {
						if (
							value === undefined ||
							(options.skipNull && value === null) ||
							(options.skipEmptyString && value === '')
						) {
							return result;
						}

						if (value === null) {
							return [...result, [encode(key, options), '[]'].join('')];
						}

						return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
					};

				case 'colon-list-separator':
					return key => (result, value) => {
						if (
							value === undefined ||
							(options.skipNull && value === null) ||
							(options.skipEmptyString && value === '')
						) {
							return result;
						}

						if (value === null) {
							return [...result, [encode(key, options), ':list='].join('')];
						}

						return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
					};

				case 'comma':
				case 'separator':
				case 'bracket-separator': {
					const keyValueSep = options.arrayFormat === 'bracket-separator' ?
						'[]=' :
						'=';

					return key => (result, value) => {
						if (
							value === undefined ||
							(options.skipNull && value === null) ||
							(options.skipEmptyString && value === '')
						) {
							return result;
						}

						// Translate null to an empty string so that it doesn't serialize as 'null'
						value = value === null ? '' : value;

						if (result.length === 0) {
							return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
						}

						return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
					};
				}

				default:
					return key => (result, value) => {
						if (
							value === undefined ||
							(options.skipNull && value === null) ||
							(options.skipEmptyString && value === '')
						) {
							return result;
						}

						if (value === null) {
							return [...result, encode(key, options)];
						}

						return [...result, [encode(key, options), '=', encode(value, options)].join('')];
					};
			}
		}

		function parserForArrayFormat(options) {
			let result;

			switch (options.arrayFormat) {
				case 'index':
					return (key, value, accumulator) => {
						result = /\[(\d*)\]$/.exec(key);

						key = key.replace(/\[\d*\]$/, '');

						if (!result) {
							accumulator[key] = value;
							return;
						}

						if (accumulator[key] === undefined) {
							accumulator[key] = {};
						}

						accumulator[key][result[1]] = value;
					};

				case 'bracket':
					return (key, value, accumulator) => {
						result = /(\[\])$/.exec(key);
						key = key.replace(/\[\]$/, '');

						if (!result) {
							accumulator[key] = value;
							return;
						}

						if (accumulator[key] === undefined) {
							accumulator[key] = [value];
							return;
						}

						accumulator[key] = [].concat(accumulator[key], value);
					};

				case 'colon-list-separator':
					return (key, value, accumulator) => {
						result = /(:list)$/.exec(key);
						key = key.replace(/:list$/, '');

						if (!result) {
							accumulator[key] = value;
							return;
						}

						if (accumulator[key] === undefined) {
							accumulator[key] = [value];
							return;
						}

						accumulator[key] = [].concat(accumulator[key], value);
					};

				case 'comma':
				case 'separator':
					return (key, value, accumulator) => {
						const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
						const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
						value = isEncodedArray ? decode(value, options) : value;
						const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
						accumulator[key] = newValue;
					};

				case 'bracket-separator':
					return (key, value, accumulator) => {
						const isArray = /(\[\])$/.test(key);
						key = key.replace(/\[\]$/, '');

						if (!isArray) {
							accumulator[key] = value ? decode(value, options) : value;
							return;
						}

						const arrayValue = value === null ?
							[] :
							value.split(options.arrayFormatSeparator).map(item => decode(item, options));

						if (accumulator[key] === undefined) {
							accumulator[key] = arrayValue;
							return;
						}

						accumulator[key] = [].concat(accumulator[key], arrayValue);
					};

				default:
					return (key, value, accumulator) => {
						if (accumulator[key] === undefined) {
							accumulator[key] = value;
							return;
						}

						accumulator[key] = [].concat(accumulator[key], value);
					};
			}
		}

		function validateArrayFormatSeparator(value) {
			if (typeof value !== 'string' || value.length !== 1) {
				throw new TypeError('arrayFormatSeparator must be single character string');
			}
		}

		function encode(value, options) {
			if (options.encode) {
				return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
			}

			return value;
		}

		function decode(value, options) {
			if (options.decode) {
				return decodeComponent(value);
			}

			return value;
		}

		function keysSorter(input) {
			if (Array.isArray(input)) {
				return input.sort();
			}

			if (typeof input === 'object') {
				return keysSorter(Object.keys(input))
					.sort((a, b) => Number(a) - Number(b))
					.map(key => input[key]);
			}

			return input;
		}

		function removeHash(input) {
			const hashStart = input.indexOf('#');
			if (hashStart !== -1) {
				input = input.slice(0, hashStart);
			}

			return input;
		}

		function getHash(url) {
			let hash = '';
			const hashStart = url.indexOf('#');
			if (hashStart !== -1) {
				hash = url.slice(hashStart);
			}

			return hash;
		}

		function extract(input) {
			input = removeHash(input);
			const queryStart = input.indexOf('?');
			if (queryStart === -1) {
				return '';
			}

			return input.slice(queryStart + 1);
		}

		function parseValue(value, options) {
			if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
				value = Number(value);
			} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
				value = value.toLowerCase() === 'true';
			}

			return value;
		}

		function parse(query, options) {
			options = Object.assign({
				decode: true,
				sort: true,
				arrayFormat: 'none',
				arrayFormatSeparator: ',',
				parseNumbers: false,
				parseBooleans: false
			}, options);

			validateArrayFormatSeparator(options.arrayFormatSeparator);

			const formatter = parserForArrayFormat(options);

			// Create an object with no prototype
			const ret = Object.create(null);

			if (typeof query !== 'string') {
				return ret;
			}

			query = query.trim().replace(/^[?#&]/, '');

			if (!query) {
				return ret;
			}

			for (const param of query.split('&')) {
				if (param === '') {
					continue;
				}

				let [key, value] = splitOnFirst$1(options.decode ? param.replace(/\+/g, ' ') : param, '=');

				// Missing `=` should be `null`:
				// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
				value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
				formatter(decode(key, options), value, ret);
			}

			for (const key of Object.keys(ret)) {
				const value = ret[key];
				if (typeof value === 'object' && value !== null) {
					for (const k of Object.keys(value)) {
						value[k] = parseValue(value[k], options);
					}
				} else {
					ret[key] = parseValue(value, options);
				}
			}

			if (options.sort === false) {
				return ret;
			}

			return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
				const value = ret[key];
				if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
					// Sort object keys, not values
					result[key] = keysSorter(value);
				} else {
					result[key] = value;
				}

				return result;
			}, Object.create(null));
		}

		exports.extract = extract;
		exports.parse = parse;

		exports.stringify = (object, options) => {
			if (!object) {
				return '';
			}

			options = Object.assign({
				encode: true,
				strict: true,
				arrayFormat: 'none',
				arrayFormatSeparator: ','
			}, options);

			validateArrayFormatSeparator(options.arrayFormatSeparator);

			const shouldFilter = key => (
				(options.skipNull && isNullOrUndefined(object[key])) ||
				(options.skipEmptyString && object[key] === '')
			);

			const formatter = encoderForArrayFormat(options);

			const objectCopy = {};

			for (const key of Object.keys(object)) {
				if (!shouldFilter(key)) {
					objectCopy[key] = object[key];
				}
			}

			const keys = Object.keys(objectCopy);

			if (options.sort !== false) {
				keys.sort(options.sort);
			}

			return keys.map(key => {
				const value = object[key];

				if (value === undefined) {
					return '';
				}

				if (value === null) {
					return encode(key, options);
				}

				if (Array.isArray(value)) {
					if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
						return encode(key, options) + '[]';
					}

					return value
						.reduce(formatter(key), [])
						.join('&');
				}

				return encode(key, options) + '=' + encode(value, options);
			}).filter(x => x.length > 0).join('&');
		};

		exports.parseUrl = (url, options) => {
			options = Object.assign({
				decode: true
			}, options);

			const [url_, hash] = splitOnFirst$1(url, '#');

			return Object.assign(
				{
					url: url_.split('?')[0] || '',
					query: parse(extract(url), options)
				},
				options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
			);
		};

		exports.stringifyUrl = (object, options) => {
			options = Object.assign({
				encode: true,
				strict: true,
				[encodeFragmentIdentifier]: true
			}, options);

			const url = removeHash(object.url).split('?')[0] || '';
			const queryFromUrl = exports.extract(object.url);
			const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

			const query = Object.assign(parsedQueryFromUrl, object.query);
			let queryString = exports.stringify(query, options);
			if (queryString) {
				queryString = `?${queryString}`;
			}

			let hash = getHash(object.url);
			if (object.fragmentIdentifier) {
				hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
			}

			return `${url}${queryString}${hash}`;
		};

		exports.pick = (input, filter, options) => {
			options = Object.assign({
				parseFragmentIdentifier: true,
				[encodeFragmentIdentifier]: false
			}, options);

			const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
			return exports.stringifyUrl({
				url,
				query: filterObject(query, filter),
				fragmentIdentifier
			}, options);
		};

		exports.exclude = (input, filter, options) => {
			const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

			return exports.pick(input, exclusionFilter, options);
		}; 
	} (queryString));

	const RELAY_JSONRPC = {
	    waku: {
	        publish: "waku_publish",
	        batchPublish: "waku_batchPublish",
	        subscribe: "waku_subscribe",
	        batchSubscribe: "waku_batchSubscribe",
	        subscription: "waku_subscription",
	        unsubscribe: "waku_unsubscribe",
	        batchUnsubscribe: "waku_batchUnsubscribe",
	    },
	    irn: {
	        publish: "irn_publish",
	        batchPublish: "irn_batchPublish",
	        subscribe: "irn_subscribe",
	        batchSubscribe: "irn_batchSubscribe",
	        subscription: "irn_subscription",
	        unsubscribe: "irn_unsubscribe",
	        batchUnsubscribe: "irn_batchUnsubscribe",
	    },
	    iridium: {
	        publish: "iridium_publish",
	        batchPublish: "iridium_batchPublish",
	        subscribe: "iridium_subscribe",
	        batchSubscribe: "iridium_batchSubscribe",
	        subscription: "iridium_subscription",
	        unsubscribe: "iridium_unsubscribe",
	        batchUnsubscribe: "iridium_batchUnsubscribe",
	    },
	};

	function On$1(e,n=[]){const t=[];return Object.keys(e).forEach(r=>{if(n.length&&!n.includes(r))return;const o=e[r];t.push(...o.accounts);}),t}function k$4(e,n){return e.includes(":")?[e]:n.chains||[]}const B$5="base10",f$5="base16",L$6="base64pad",x$4="utf8",Y$3=0,U$4=1,Rn$1=0,Oe$3=1,J$4=12,Q$4=32;function wn(){const e=x25519.generateKeyPair();return {privateKey:toString(e.secretKey,f$5),publicKey:toString(e.publicKey,f$5)}}function An$1(){const e=random.randomBytes(Q$4);return toString(e,f$5)}function Un(e,n){const t=x25519.sharedKey(fromString$1(e,f$5),fromString$1(n,f$5)),r=new HKDF_1(sha256$1.SHA256,t).expand(Q$4);return toString(r,f$5)}function _n$1(e){const n=sha256$1.hash(fromString$1(e,f$5));return toString(n,f$5)}function $n$1(e){const n=sha256$1.hash(fromString$1(e,x$4));return toString(n,f$5)}function Se$1(e){return fromString$1(`${e}`,B$5)}function $$6(e){return Number(toString(e,B$5))}function jn$1(e){const n=Se$1(typeof e.type<"u"?e.type:Y$3);if($$6(n)===U$4&&typeof e.senderPublicKey>"u")throw new Error("Missing sender public key for type 1 envelope");const t=typeof e.senderPublicKey<"u"?fromString$1(e.senderPublicKey,f$5):void 0,r=typeof e.iv<"u"?fromString$1(e.iv,f$5):random.randomBytes(J$4),o=new chacha20poly1305.ChaCha20Poly1305(fromString$1(e.symKey,f$5)).seal(r,fromString$1(e.message,x$4));return Ie$2({type:n,sealed:o,iv:r,senderPublicKey:t})}function Cn$1(e){const n=new chacha20poly1305.ChaCha20Poly1305(fromString$1(e.symKey,f$5)),{sealed:t,iv:r}=Z$4(e.encoded),o=n.open(r,t);if(o===null)throw new Error("Failed to decrypt");return toString(o,x$4)}function Ie$2(e){if($$6(e.type)===U$4){if(typeof e.senderPublicKey>"u")throw new Error("Missing sender public key for type 1 envelope");return toString(concat$3([e.type,e.senderPublicKey,e.iv,e.sealed]),L$6)}return toString(concat$3([e.type,e.iv,e.sealed]),L$6)}function Z$4(e){const n=fromString$1(e,L$6),t=n.slice(Rn$1,Oe$3),r=Oe$3;if($$6(t)===U$4){const l=r+Q$4,d=l+J$4,c=n.slice(r,l),u=n.slice(l,d),a=n.slice(d);return {type:t,sealed:a,iv:u,senderPublicKey:c}}const o=r+J$4,s=n.slice(r,o),i=n.slice(o);return {type:t,sealed:i,iv:s}}function Dn(e,n){const t=Z$4(e);return Pe$2({type:$$6(t.type),senderPublicKey:typeof t.senderPublicKey<"u"?toString(t.senderPublicKey,f$5):void 0,receiverPublicKey:n?.receiverPublicKey})}function Pe$2(e){const n=e?.type||Y$3;if(n===U$4){if(typeof e?.senderPublicKey>"u")throw new Error("missing sender public key");if(typeof e?.receiverPublicKey>"u")throw new Error("missing receiver public key")}return {type:n,senderPublicKey:e?.senderPublicKey,receiverPublicKey:e?.receiverPublicKey}}function Vn$1(e){return e.type===U$4&&typeof e.senderPublicKey=="string"&&typeof e.receiverPublicKey=="string"}var Mn$1=Object.defineProperty,Te$2=Object.getOwnPropertySymbols,kn=Object.prototype.hasOwnProperty,Kn$1=Object.prototype.propertyIsEnumerable,Re$2=(e,n,t)=>n in e?Mn$1(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,we$2=(e,n)=>{for(var t in n||(n={}))kn.call(n,t)&&Re$2(e,t,n[t]);if(Te$2)for(var t of Te$2(n))Kn$1.call(n,t)&&Re$2(e,t,n[t]);return e};const Ae$3="ReactNative",N$5={reactNative:"react-native",node:"node",browser:"browser",unknown:"unknown"},_e$2="js";function ee$3(){return typeof process<"u"&&typeof process.versions<"u"&&typeof process.versions.node<"u"}function $e$3(){return !getDocument_1()&&!!getNavigator_1()&&navigator.product===Ae$3}function je$3(){return !ee$3()&&!!getNavigator_1()}function j$7(){return $e$3()?N$5.reactNative:ee$3()?N$5.node:je$3()?N$5.browser:N$5.unknown}function Ce$2(e,n){let t=queryString.parse(e);return t=we$2(we$2({},t),n),e=queryString.stringify(t),e}function Fn$1(){return getWindowMetadata_1()||{name:"",description:"",url:"",icons:[""]}}function De$2(){if(j$7()===N$5.reactNative&&typeof global<"u"&&typeof(global==null?void 0:global.Platform)<"u"){const{OS:t,Version:r}=global.Platform;return [t,r].join("-")}const e=detect();if(e===null)return "unknown";const n=e.os?e.os.replace(" ","").toLowerCase():"unknown";return e.type==="browser"?[n,e.name,e.version].join("-"):[n,e.version].join("-")}function Ve$3(){var e;const n=j$7();return n===N$5.browser?[n,((e=getLocation_1())==null?void 0:e.host)||"unknown"].join(":"):n}function Me$3(e,n,t){const r=De$2(),o=Ve$3();return [[e,n].join("-"),[_e$2,t].join("-"),r,o].join("/")}function qn$1({protocol:e,version:n,relayUrl:t,sdkVersion:r,auth:o,projectId:s,useOnCloseEvent:i}){const l=t.split("?"),d=Me$3(e,n,r),c={auth:o,ua:d,projectId:s,useOnCloseEvent:i||void 0},u=Ce$2(l[1]||"",c);return l[0]+"?"+u}function O$6(e,n){return e.filter(t=>n.includes(t)).length===e.length}function Bn$1(e){return Object.fromEntries(e.entries())}function Yn(e){return new Map(Object.entries(e))}function Xn$1(e=cjs$6.FIVE_MINUTES,n){const t=cjs$6.toMiliseconds(e||cjs$6.FIVE_MINUTES);let r,o,s;return {resolve:i=>{s&&r&&(clearTimeout(s),r(i));},reject:i=>{s&&o&&(clearTimeout(s),o(i));},done:()=>new Promise((i,l)=>{s=setTimeout(()=>{l(new Error(n));},t),r=i,o=l;})}}function et$3(e,n,t){return new Promise(async(r,o)=>{const s=setTimeout(()=>o(new Error(t)),n);try{const i=await e;r(i);}catch(i){o(i);}clearTimeout(s);})}function ne$3(e,n){if(typeof n=="string"&&n.startsWith(`${e}:`))return n;if(e.toLowerCase()==="topic"){if(typeof n!="string")throw new Error('Value must be "string" for expirer target type: topic');return `topic:${n}`}else if(e.toLowerCase()==="id"){if(typeof n!="number")throw new Error('Value must be "number" for expirer target type: id');return `id:${n}`}throw new Error(`Unknown expirer target type: ${e}`)}function nt$3(e){return ne$3("topic",e)}function tt$3(e){return ne$3("id",e)}function rt$3(e){const[n,t]=e.split(":"),r={id:void 0,topic:void 0};if(n==="topic"&&typeof t=="string")r.topic=t;else if(n==="id"&&Number.isInteger(Number(t)))r.id=Number(t);else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);return r}function ot$4(e,n){return cjs$6.fromMiliseconds((n||Date.now())+cjs$6.toMiliseconds(e))}function st$3(e){return Date.now()>=cjs$6.toMiliseconds(e)}function it$3(e,n){return `${e}${n?`:${n}`:""}`}function S$6(e=[],n=[]){return [...new Set([...e,...n])]}async function ct$3({id:e,topic:n,wcDeepLink:t}){try{if(!t)return;const r=typeof t=="string"?JSON.parse(t):t;let o=r?.href;if(typeof o!="string")return;o.endsWith("/")&&(o=o.slice(0,-1));const s=`${o}/wc?requestId=${e}&sessionTopic=${n}`,i=j$7();i===N$5.browser?s.startsWith("https://")?window.open(s,"_blank","noreferrer noopener"):window.open(s,"_self","noreferrer noopener"):i===N$5.reactNative&&typeof(global==null?void 0:global.Linking)<"u"&&await global.Linking.openURL(s);}catch(r){console.error(r);}}const xe$2="irn";function at$3(e){return e?.relay||{protocol:xe$2}}function ut$3(e){const n=RELAY_JSONRPC[e];if(typeof n>"u")throw new Error(`Relay Protocol not supported: ${e}`);return n}var lt$6=Object.defineProperty,Fe$3=Object.getOwnPropertySymbols,dt$3=Object.prototype.hasOwnProperty,ft$4=Object.prototype.propertyIsEnumerable,He$2=(e,n,t)=>n in e?lt$6(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,pt$3=(e,n)=>{for(var t in n||(n={}))dt$3.call(n,t)&&He$2(e,t,n[t]);if(Fe$3)for(var t of Fe$3(n))ft$4.call(n,t)&&He$2(e,t,n[t]);return e};function qe$3(e,n="-"){const t={},r="relay"+n;return Object.keys(e).forEach(o=>{if(o.startsWith(r)){const s=o.replace(r,""),i=e[o];t[s]=i;}}),t}function mt$2(e){const n=e.indexOf(":"),t=e.indexOf("?")!==-1?e.indexOf("?"):void 0,r=e.substring(0,n),o=e.substring(n+1,t).split("@"),s=typeof t<"u"?e.substring(t):"",i=queryString.parse(s);return {protocol:r,topic:ze$3(o[0]),version:parseInt(o[1],10),symKey:i.symKey,relay:qe$3(i)}}function ze$3(e){return e.startsWith("//")?e.substring(2):e}function Ge$3(e,n="-"){const t="relay",r={};return Object.keys(e).forEach(o=>{const s=t+n+o;e[o]&&(r[s]=e[o]);}),r}function yt$3(e){return `${e.protocol}:${e.topic}@${e.version}?`+queryString.stringify(pt$3({symKey:e.symKey},Ge$3(e.relay)))}var ht$2=Object.defineProperty,Et$2=Object.defineProperties,vt$2=Object.getOwnPropertyDescriptors,We$3=Object.getOwnPropertySymbols,gt$7=Object.prototype.hasOwnProperty,Nt$2=Object.prototype.propertyIsEnumerable,Be$3=(e,n,t)=>n in e?ht$2(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,bt$2=(e,n)=>{for(var t in n||(n={}))gt$7.call(n,t)&&Be$3(e,t,n[t]);if(We$3)for(var t of We$3(n))Nt$2.call(n,t)&&Be$3(e,t,n[t]);return e},Ot$2=(e,n)=>Et$2(e,vt$2(n));function R$4(e){const n=[];return e.forEach(t=>{const[r,o]=t.split(":");n.push(`${r}:${o}`);}),n}function Ye$2(e){const n=[];return Object.values(e).forEach(t=>{n.push(...R$4(t.accounts));}),n}function Je$1(e,n){const t=[];return Object.values(e).forEach(r=>{R$4(r.accounts).includes(n)&&t.push(...r.methods);}),t}function Qe$2(e,n){const t=[];return Object.values(e).forEach(r=>{R$4(r.accounts).includes(n)&&t.push(...r.events);}),t}function St$2(e,n){const t=sn(e,n);if(t)throw new Error(t.message);const r={};for(const[o,s]of Object.entries(e))r[o]={methods:s.methods,events:s.events,chains:s.accounts.map(i=>`${i.split(":")[0]}:${i.split(":")[1]}`)};return r}function te$3(e){return e.includes(":")}function Ze$2(e){return te$3(e)?e.split(":")[0]:e}function re$6(e){var n,t,r;const o={};if(!H$6(e))return o;for(const[s,i]of Object.entries(e)){const l=te$3(s)?[s]:i.chains,d=i.methods||[],c=i.events||[],u=Ze$2(s);o[u]=Ot$2(bt$2({},o[u]),{chains:S$6(l,(n=o[u])==null?void 0:n.chains),methods:S$6(d,(t=o[u])==null?void 0:t.methods),events:S$6(c,(r=o[u])==null?void 0:r.events)});}return o}const Pt$2={INVALID_METHOD:{message:"Invalid method.",code:1001},INVALID_EVENT:{message:"Invalid event.",code:1002},INVALID_UPDATE_REQUEST:{message:"Invalid update request.",code:1003},INVALID_EXTEND_REQUEST:{message:"Invalid extend request.",code:1004},INVALID_SESSION_SETTLE_REQUEST:{message:"Invalid session settle request.",code:1005},UNAUTHORIZED_METHOD:{message:"Unauthorized method.",code:3001},UNAUTHORIZED_EVENT:{message:"Unauthorized event.",code:3002},UNAUTHORIZED_UPDATE_REQUEST:{message:"Unauthorized update request.",code:3003},UNAUTHORIZED_EXTEND_REQUEST:{message:"Unauthorized extend request.",code:3004},USER_REJECTED:{message:"User rejected.",code:5e3},USER_REJECTED_CHAINS:{message:"User rejected chains.",code:5001},USER_REJECTED_METHODS:{message:"User rejected methods.",code:5002},USER_REJECTED_EVENTS:{message:"User rejected events.",code:5003},UNSUPPORTED_CHAINS:{message:"Unsupported chains.",code:5100},UNSUPPORTED_METHODS:{message:"Unsupported methods.",code:5101},UNSUPPORTED_EVENTS:{message:"Unsupported events.",code:5102},UNSUPPORTED_ACCOUNTS:{message:"Unsupported accounts.",code:5103},UNSUPPORTED_NAMESPACE_KEY:{message:"Unsupported namespace key.",code:5104},USER_DISCONNECTED:{message:"User disconnected.",code:6e3},SESSION_SETTLEMENT_FAILED:{message:"Session settlement failed.",code:7e3},WC_METHOD_UNSUPPORTED:{message:"Unsupported wc_ method.",code:10001}},Tt$2={NOT_INITIALIZED:{message:"Not initialized.",code:1},NO_MATCHING_KEY:{message:"No matching key.",code:2},RESTORE_WILL_OVERRIDE:{message:"Restore will override.",code:3},RESUBSCRIBED:{message:"Resubscribed.",code:4},MISSING_OR_INVALID:{message:"Missing or invalid.",code:5},EXPIRED:{message:"Expired.",code:6},UNKNOWN_TYPE:{message:"Unknown type.",code:7},MISMATCHED_TOPIC:{message:"Mismatched topic.",code:8},NON_CONFORMING_NAMESPACES:{message:"Non conforming namespaces.",code:9}};function b$6(e,n){const{message:t,code:r}=Tt$2[e];return {message:n?`${t} ${n}`:t,code:r}}function w$5(e,n){const{message:t,code:r}=Pt$2[e];return {message:n?`${t} ${n}`:t,code:r}}function C$5(e,n){return Array.isArray(e)?typeof n<"u"&&e.length?e.every(n):!0:!1}function H$6(e){return Object.getPrototypeOf(e)===Object.prototype&&Object.keys(e).length}function I$4(e){return typeof e>"u"}function m$5(e,n){return n&&I$4(e)?!0:typeof e=="string"&&!!e.trim().length}function q$5(e,n){return n&&I$4(e)?!0:typeof e=="number"&&!isNaN(e)}function Rt$2(e,n){const{requiredNamespaces:t}=n,r=Object.keys(e.namespaces),o=Object.keys(t);let s=!0;return O$6(o,r)?(r.forEach(i=>{const{accounts:l,methods:d,events:c}=e.namespaces[i],u=R$4(l),a=t[i];(!O$6(k$4(i,a),u)||!O$6(a.methods,d)||!O$6(a.events,c))&&(s=!1);}),s):!1}function D$6(e){return m$5(e,!1)&&e.includes(":")?e.split(":").length===2:!1}function Xe$2(e){if(m$5(e,!1)&&e.includes(":")){const n=e.split(":");if(n.length===3){const t=n[0]+":"+n[1];return !!n[2]&&D$6(t)}}return !1}function wt$2(e){if(m$5(e,!1))try{return typeof new URL(e)<"u"}catch{return !1}return !1}function At$2(e){var n;return (n=e?.proposer)==null?void 0:n.publicKey}function Ut$2(e){return e?.topic}function _t$2(e,n){let t=null;return m$5(e?.publicKey,!1)||(t=b$6("MISSING_OR_INVALID",`${n} controller public key should be a string`)),t}function oe$4(e){let n=!0;return C$5(e)?e.length&&(n=e.every(t=>m$5(t,!1))):n=!1,n}function en$1(e,n,t){let r=null;return C$5(n)&&n.length?n.forEach(o=>{r||D$6(o)||(r=w$5("UNSUPPORTED_CHAINS",`${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));}):D$6(e)||(r=w$5("UNSUPPORTED_CHAINS",`${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)),r}function nn(e,n,t){let r=null;return Object.entries(e).forEach(([o,s])=>{if(r)return;const i=en$1(o,k$4(o,s),`${n} ${t}`);i&&(r=i);}),r}function tn(e,n){let t=null;return C$5(e)?e.forEach(r=>{t||Xe$2(r)||(t=w$5("UNSUPPORTED_ACCOUNTS",`${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));}):t=w$5("UNSUPPORTED_ACCOUNTS",`${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`),t}function rn(e,n){let t=null;return Object.values(e).forEach(r=>{if(t)return;const o=tn(r?.accounts,`${n} namespace`);o&&(t=o);}),t}function on$1(e,n){let t=null;return oe$4(e?.methods)?oe$4(e?.events)||(t=w$5("UNSUPPORTED_EVENTS",`${n}, events should be an array of strings or empty array for no events`)):t=w$5("UNSUPPORTED_METHODS",`${n}, methods should be an array of strings or empty array for no methods`),t}function se$3(e,n){let t=null;return Object.values(e).forEach(r=>{if(t)return;const o=on$1(r,`${n}, namespace`);o&&(t=o);}),t}function $t$2(e,n,t){let r=null;if(e&&H$6(e)){const o=se$3(e,n);o&&(r=o);const s=nn(e,n,t);s&&(r=s);}else r=b$6("MISSING_OR_INVALID",`${n}, ${t} should be an object with data`);return r}function sn(e,n){let t=null;if(e&&H$6(e)){const r=se$3(e,n);r&&(t=r);const o=rn(e,n);o&&(t=o);}else t=b$6("MISSING_OR_INVALID",`${n}, namespaces should be an object with data`);return t}function cn(e){return m$5(e.protocol,!0)}function jt$1(e,n){let t=!1;return n&&!e?t=!0:e&&C$5(e)&&e.length&&e.forEach(r=>{t=cn(r);}),t}function Ct$2(e){return typeof e=="number"}function Dt$2(e){return typeof e<"u"&&typeof e!==null}function Vt$1(e){return !(!e||typeof e!="object"||!e.code||!q$5(e.code,!1)||!e.message||!m$5(e.message,!1))}function Mt$2(e){return !(I$4(e)||!m$5(e.method,!1))}function kt$2(e){return !(I$4(e)||I$4(e.result)&&I$4(e.error)||!q$5(e.id,!1)||!m$5(e.jsonrpc,!1))}function Kt$2(e){return !(I$4(e)||!m$5(e.name,!1))}function Lt$2(e,n){return !(!D$6(n)||!Ye$2(e).includes(n))}function xt$2(e,n,t){return m$5(t,!1)?Je$1(e,n).includes(t):!1}function Ft$2(e,n,t){return m$5(t,!1)?Qe$2(e,n).includes(t):!1}function an(e,n,t){let r=null;const o=Ht$1(e),s=qt$1(n),i=Object.keys(o),l=Object.keys(s),d=un(Object.keys(e)),c=un(Object.keys(n)),u=d.filter(a=>!c.includes(a));return u.length&&(r=b$6("NON_CONFORMING_NAMESPACES",`${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)),O$6(i,l)||(r=b$6("NON_CONFORMING_NAMESPACES",`${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${l.toString()}`)),Object.keys(n).forEach(a=>{if(!a.includes(":")||r)return;const g=R$4(n[a].accounts);g.includes(a)||(r=b$6("NON_CONFORMING_NAMESPACES",`${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${g.toString()}`));}),i.forEach(a=>{r||(O$6(o[a].methods,s[a].methods)?O$6(o[a].events,s[a].events)||(r=b$6("NON_CONFORMING_NAMESPACES",`${t} namespaces events don't satisfy namespace events for ${a}`)):r=b$6("NON_CONFORMING_NAMESPACES",`${t} namespaces methods don't satisfy namespace methods for ${a}`));}),r}function Ht$1(e){const n={};return Object.keys(e).forEach(t=>{var r;t.includes(":")?n[t]=e[t]:(r=e[t].chains)==null||r.forEach(o=>{n[o]={methods:e[t].methods,events:e[t].events};});}),n}function un(e){return [...new Set(e.map(n=>n.includes(":")?n.split(":")[0]:n))]}function qt$1(e){const n={};return Object.keys(e).forEach(t=>{if(t.includes(":"))n[t]=e[t];else {const r=R$4(e[t].accounts);r?.forEach(o=>{n[o]={accounts:e[t].accounts.filter(s=>s.includes(`${o}:`)),methods:e[t].methods,events:e[t].events};});}}),n}function zt$2(e,n){return q$5(e,!1)&&e<=n.max&&e>=n.min}

	var NAMESPACE = "eip155";
	var STORE_KEY = "store";
	var REQUESTED_CHAINS_KEY = "requestedChains";
	var ADD_ETH_CHAIN_METHOD = "wallet_addEthereumChain";
	var _provider, _initProviderPromise, _createProvider, createProvider_fn, _initProvider, initProvider_fn, _isChainsStale, isChainsStale_fn, _setupListeners, setupListeners_fn, _removeListeners, removeListeners_fn, _setRequestedChainsIds, setRequestedChainsIds_fn, _getRequestedChainsIds, getRequestedChainsIds_fn, _getNamespaceChainsIds, getNamespaceChainsIds_fn, _getNamespaceMethods, getNamespaceMethods_fn;
	var WalletConnectConnector = class extends Connector {
	  constructor(config) {
	    super({
	      ...config,
	      options: { isNewChainsStale: true, ...config.options }
	    });
	    __privateAdd$1(this, _createProvider);
	    __privateAdd$1(this, _initProvider);
	    __privateAdd$1(this, _isChainsStale);
	    __privateAdd$1(this, _setupListeners);
	    __privateAdd$1(this, _removeListeners);
	    __privateAdd$1(this, _setRequestedChainsIds);
	    __privateAdd$1(this, _getRequestedChainsIds);
	    __privateAdd$1(this, _getNamespaceChainsIds);
	    __privateAdd$1(this, _getNamespaceMethods);
	    __publicField(this, "id", "walletConnect");
	    __publicField(this, "name", "WalletConnect");
	    __publicField(this, "ready", true);
	    __privateAdd$1(this, _provider, void 0);
	    __privateAdd$1(this, _initProviderPromise, void 0);
	    __publicField(this, "onAccountsChanged", (accounts) => {
	      if (accounts.length === 0)
	        this.emit("disconnect");
	      else
	        this.emit("change", { account: getAddress$1(accounts[0]) });
	    });
	    __publicField(this, "onChainChanged", (chainId) => {
	      const id = Number(chainId);
	      const unsupported = this.isChainUnsupported(id);
	      this.emit("change", { chain: { id, unsupported } });
	    });
	    __publicField(this, "onDisconnect", () => {
	      __privateMethod$1(this, _setRequestedChainsIds, setRequestedChainsIds_fn).call(this, []);
	      this.emit("disconnect");
	    });
	    __publicField(this, "onDisplayUri", (uri) => {
	      this.emit("message", { type: "display_uri", data: uri });
	    });
	    __publicField(this, "onConnect", () => {
	      this.emit("connect", {});
	    });
	    __privateMethod$1(this, _createProvider, createProvider_fn).call(this);
	  }
	  async connect({ chainId, pairingTopic } = {}) {
	    try {
	      let targetChainId = chainId;
	      if (!targetChainId) {
	        const store = this.storage?.getItem(STORE_KEY);
	        const lastUsedChainId = store?.state?.data?.chain?.id;
	        if (lastUsedChainId && !this.isChainUnsupported(lastUsedChainId))
	          targetChainId = lastUsedChainId;
	        else
	          targetChainId = this.chains[0]?.id;
	      }
	      if (!targetChainId)
	        throw new Error("No chains found on connector.");
	      const provider = await this.getProvider();
	      __privateMethod$1(this, _setupListeners, setupListeners_fn).call(this);
	      const isChainsStale = __privateMethod$1(this, _isChainsStale, isChainsStale_fn).call(this);
	      if (provider.session && isChainsStale)
	        await provider.disconnect();
	      if (!provider.session || isChainsStale) {
	        const optionalChains = this.chains.filter((chain) => chain.id !== targetChainId).map((optionalChain) => optionalChain.id);
	        this.emit("message", { type: "connecting" });
	        await provider.connect({
	          pairingTopic,
	          chains: [targetChainId],
	          optionalChains: optionalChains.length ? optionalChains : void 0
	        });
	        __privateMethod$1(this, _setRequestedChainsIds, setRequestedChainsIds_fn).call(this, this.chains.map(({ id: id2 }) => id2));
	      }
	      const accounts = await provider.enable();
	      const account = getAddress$1(accounts[0]);
	      const id = await this.getChainId();
	      const unsupported = this.isChainUnsupported(id);
	      return {
	        account,
	        chain: { id, unsupported }
	      };
	    } catch (error) {
	      if (/user rejected/i.test(error?.message)) {
	        throw new UserRejectedRequestError(error);
	      }
	      throw error;
	    }
	  }
	  async disconnect() {
	    const provider = await this.getProvider();
	    try {
	      await provider.disconnect();
	    } catch (error) {
	      if (!/No matching key/i.test(error.message))
	        throw error;
	    } finally {
	      __privateMethod$1(this, _removeListeners, removeListeners_fn).call(this);
	      __privateMethod$1(this, _setRequestedChainsIds, setRequestedChainsIds_fn).call(this, []);
	    }
	  }
	  async getAccount() {
	    const { accounts } = await this.getProvider();
	    return getAddress$1(accounts[0]);
	  }
	  async getChainId() {
	    const { chainId } = await this.getProvider();
	    return chainId;
	  }
	  async getProvider({ chainId } = {}) {
	    if (!__privateGet$1(this, _provider))
	      await __privateMethod$1(this, _createProvider, createProvider_fn).call(this);
	    if (chainId)
	      await this.switchChain(chainId);
	    return __privateGet$1(this, _provider);
	  }
	  async getWalletClient({
	    chainId
	  } = {}) {
	    const [provider, account] = await Promise.all([
	      this.getProvider({ chainId }),
	      this.getAccount()
	    ]);
	    const chain = this.chains.find((x) => x.id === chainId);
	    if (!provider)
	      throw new Error("provider is required.");
	    return createWalletClient({
	      account,
	      chain,
	      transport: custom(provider)
	    });
	  }
	  async isAuthorized() {
	    try {
	      const [account, provider] = await Promise.all([
	        this.getAccount(),
	        this.getProvider()
	      ]);
	      const isChainsStale = __privateMethod$1(this, _isChainsStale, isChainsStale_fn).call(this);
	      if (!account)
	        return false;
	      if (isChainsStale && provider.session) {
	        try {
	          await provider.disconnect();
	        } catch {
	        }
	        return false;
	      }
	      return true;
	    } catch {
	      return false;
	    }
	  }
	  async switchChain(chainId) {
	    const chain = this.chains.find((chain2) => chain2.id === chainId);
	    if (!chain)
	      throw new SwitchChainError(new Error("chain not found on connector."));
	    try {
	      const provider = await this.getProvider();
	      const namespaceChains = __privateMethod$1(this, _getNamespaceChainsIds, getNamespaceChainsIds_fn).call(this);
	      const namespaceMethods = __privateMethod$1(this, _getNamespaceMethods, getNamespaceMethods_fn).call(this);
	      const isChainApproved = namespaceChains.includes(chainId);
	      if (!isChainApproved && namespaceMethods.includes(ADD_ETH_CHAIN_METHOD)) {
	        await provider.request({
	          method: ADD_ETH_CHAIN_METHOD,
	          params: [
	            {
	              chainId: numberToHex$1(chain.id),
	              blockExplorerUrls: [chain.blockExplorers?.default?.url],
	              chainName: chain.name,
	              nativeCurrency: chain.nativeCurrency,
	              rpcUrls: [...chain.rpcUrls.default.http]
	            }
	          ]
	        });
	        const requestedChains = __privateMethod$1(this, _getRequestedChainsIds, getRequestedChainsIds_fn).call(this);
	        requestedChains.push(chainId);
	        __privateMethod$1(this, _setRequestedChainsIds, setRequestedChainsIds_fn).call(this, requestedChains);
	      }
	      await provider.request({
	        method: "wallet_switchEthereumChain",
	        params: [{ chainId: numberToHex$1(chainId) }]
	      });
	      return chain;
	    } catch (error) {
	      const message = typeof error === "string" ? error : error?.message;
	      if (/user rejected request/i.test(message)) {
	        throw new UserRejectedRequestError(error);
	      }
	      throw new SwitchChainError(error);
	    }
	  }
	};
	_provider = new WeakMap();
	_initProviderPromise = new WeakMap();
	_createProvider = new WeakSet();
	createProvider_fn = async function() {
	  if (!__privateGet$1(this, _initProviderPromise) && typeof window !== "undefined") {
	    __privateSet$1(this, _initProviderPromise, __privateMethod$1(this, _initProvider, initProvider_fn).call(this));
	  }
	  return __privateGet$1(this, _initProviderPromise);
	};
	_initProvider = new WeakSet();
	initProvider_fn = async function() {
	  const { EthereumProvider, OPTIONAL_EVENTS, OPTIONAL_METHODS } = await Promise.resolve().then(function () { return index_es; });
	  const [defaultChain, ...optionalChains] = this.chains.map(({ id }) => id);
	  if (defaultChain) {
	    const {
	      projectId,
	      showQrModal = true,
	      qrModalOptions,
	      metadata,
	      relayUrl
	    } = this.options;
	    __privateSet$1(this, _provider, await EthereumProvider.init({
	      showQrModal,
	      qrModalOptions,
	      projectId,
	      optionalMethods: OPTIONAL_METHODS,
	      optionalEvents: OPTIONAL_EVENTS,
	      chains: [defaultChain],
	      optionalChains: optionalChains.length ? optionalChains : void 0,
	      rpcMap: Object.fromEntries(
	        this.chains.map((chain) => [
	          chain.id,
	          chain.rpcUrls.default.http[0]
	        ])
	      ),
	      metadata,
	      relayUrl
	    }));
	  }
	};
	_isChainsStale = new WeakSet();
	isChainsStale_fn = function() {
	  const namespaceMethods = __privateMethod$1(this, _getNamespaceMethods, getNamespaceMethods_fn).call(this);
	  if (namespaceMethods.includes(ADD_ETH_CHAIN_METHOD))
	    return false;
	  if (!this.options.isNewChainsStale)
	    return false;
	  const requestedChains = __privateMethod$1(this, _getRequestedChainsIds, getRequestedChainsIds_fn).call(this);
	  const connectorChains = this.chains.map(({ id }) => id);
	  const namespaceChains = __privateMethod$1(this, _getNamespaceChainsIds, getNamespaceChainsIds_fn).call(this);
	  if (namespaceChains.length && !namespaceChains.some((id) => connectorChains.includes(id)))
	    return false;
	  return !connectorChains.every((id) => requestedChains.includes(id));
	};
	_setupListeners = new WeakSet();
	setupListeners_fn = function() {
	  if (!__privateGet$1(this, _provider))
	    return;
	  __privateMethod$1(this, _removeListeners, removeListeners_fn).call(this);
	  __privateGet$1(this, _provider).on("accountsChanged", this.onAccountsChanged);
	  __privateGet$1(this, _provider).on("chainChanged", this.onChainChanged);
	  __privateGet$1(this, _provider).on("disconnect", this.onDisconnect);
	  __privateGet$1(this, _provider).on("session_delete", this.onDisconnect);
	  __privateGet$1(this, _provider).on("display_uri", this.onDisplayUri);
	  __privateGet$1(this, _provider).on("connect", this.onConnect);
	};
	_removeListeners = new WeakSet();
	removeListeners_fn = function() {
	  if (!__privateGet$1(this, _provider))
	    return;
	  __privateGet$1(this, _provider).removeListener("accountsChanged", this.onAccountsChanged);
	  __privateGet$1(this, _provider).removeListener("chainChanged", this.onChainChanged);
	  __privateGet$1(this, _provider).removeListener("disconnect", this.onDisconnect);
	  __privateGet$1(this, _provider).removeListener("session_delete", this.onDisconnect);
	  __privateGet$1(this, _provider).removeListener("display_uri", this.onDisplayUri);
	  __privateGet$1(this, _provider).removeListener("connect", this.onConnect);
	};
	_setRequestedChainsIds = new WeakSet();
	setRequestedChainsIds_fn = function(chains) {
	  this.storage?.setItem(REQUESTED_CHAINS_KEY, chains);
	};
	_getRequestedChainsIds = new WeakSet();
	getRequestedChainsIds_fn = function() {
	  return this.storage?.getItem(REQUESTED_CHAINS_KEY) ?? [];
	};
	_getNamespaceChainsIds = new WeakSet();
	getNamespaceChainsIds_fn = function() {
	  if (!__privateGet$1(this, _provider))
	    return [];
	  const namespaces = __privateGet$1(this, _provider).session?.namespaces;
	  if (!namespaces)
	    return [];
	  const normalizedNamespaces = re$6(namespaces);
	  const chainIds = normalizedNamespaces[NAMESPACE]?.chains?.map(
	    (chain) => parseInt(chain.split(":")[1] || "")
	  );
	  return chainIds ?? [];
	};
	_getNamespaceMethods = new WeakSet();
	getNamespaceMethods_fn = function() {
	  if (!__privateGet$1(this, _provider))
	    return [];
	  const namespaces = __privateGet$1(this, _provider).session?.namespaces;
	  if (!namespaces)
	    return [];
	  const normalizedNamespaces = re$6(namespaces);
	  const methods = normalizedNamespaces[NAMESPACE]?.methods;
	  return methods ?? [];
	};

	// src/providers/public.ts
	function publicProvider() {
	  return function(chain) {
	    if (!chain.rpcUrls.public.http[0])
	      return null;
	    return {
	      chain,
	      rpcUrls: chain.rpcUrls.public
	    };
	  };
	}

	const config$1 = writable({
	  /** @type {?string} */
	  clientKey: null,
	  clientHost: "https://app.getpercs.com",
	  apiHost: "https://api.getpercs.com",
	  /** @type {?string} */
	  sessionId: null,
	  /** @type {RedemptionAction[]} */
	  redemptionActions: [],
	  /** @type {unknown} */
	  walletConnectors: null,
	});

	/**
	 * @typedef {{
	 *   clientKey: string
	 *   clientHost?: string
	 *   apiHost?: string
	 *   sessionId?: string
	 *   redemptionActions?: RedemptionAction[]
	 *   walletConnectors?: unknown
	 * }} Options
	 *
	 * @typedef {{
	 *   type: "button"
	 *   text: string
	 *   onAction(redemption: any): Promise<string | void>
	 * }} RedemptionAction
	 */

	var config$2 = {
	  subscribe: config$1.subscribe,
	  /**
	   * @param {Options} options
	   */
	  init(options) {
	    config$1.update(($config) => ({
	      clientKey: options.clientKey,
	      clientHost: options.clientHost ?? $config.clientHost,
	      apiHost: options.apiHost ?? $config.apiHost,
	      sessionId: options.sessionId ?? $config.sessionId,
	      redemptionActions: options.redemptionActions ?? $config.redemptionActions,
	      walletConnectors: options.walletConnectors ?? null,
	    }));
	  },
	};

	/* eslint-disable no-underscore-dangle */
	/**
	 * Port of wagmi `useConnect` hook to a svelte store
	 */


	class PercsCoinbaseConnector extends CoinbaseWalletConnector {
	  logo = "https://assets.getpercs.com/nft-gating/coinbase.webp"
	  hasModal = true

	  constructor() {
	    super({
	      options: {
	        appName: "percs",
	      },
	    });
	  }

	  connect(args) {
	    return super.connect(args)
	      .catch((err) => {
	        // Coinbase throws raw objects instead of errors, so we need to wrap
	        if (typeof err === "object" && err && "message" in err) {
	          throw new Error(err.message)
	        }
	        throw err
	      })
	  }
	}

	class PercsInjectedConnector extends InjectedConnector {
	  logo = "https://assets.getpercs.com/nft-gating/metamask.webp"
	  hasModal = false
	  name = "MetaMask"

	  constructor() {
	    super({
	      options: {
	      },
	    });
	  }
	}

	class MetaMaskOnboarding {
	  /** @type {string} */
	  forwarderOrigin
	  /** @type {string} */
	  state

	  constructor() {
	    this.forwarderOrigin = "https://fwd.metamask.io";
	    this.state = MetaMaskOnboarding.isMetaMaskInstalled() ? "INSTALLED" : "NOT_INSTALLED";
	    this._onMessage = this._onMessage.bind(this);
	    this._onMessageFromForwarder = this._onMessageFromForwarder.bind(this);
	    window.addEventListener("message", this._onMessage);
	    if (sessionStorage.getItem("REGISTRATION_IN_PROGRESS") === "true") {
	      MetaMaskOnboarding._injectForwarder(this.forwarderOrigin);
	    }
	  }
	  _onMessage(event) {
	    if (event.origin !== this.forwarderOrigin) {
	      // Ignoring non-forwarder message
	      return undefined
	    }
	    if (event.data.type === "metamask:reload") {
	      return this._onMessageFromForwarder(event)
	    }
	    return undefined
	  }
	  async _onMessageFromForwarder(event) {
	    switch (this.state) {
	      case "RELOADING":
	        break
	      case "NOT_INSTALLED":
	        this.state = "RELOADING";
	        location.reload();
	        break
	      case "INSTALLED":
	        this.state = "REGISTERING";
	        await MetaMaskOnboarding._register();
	        this.state = "REGISTERED";
	        event.source.postMessage({ type: "metamask:registrationCompleted" }, event.origin);
	        MetaMaskOnboarding.stopOnboarding();
	        break
	      case "REGISTERING":
	        break
	      case "REGISTERED":
	        break
	      default:
	        MetaMaskOnboarding._onMessageUnknownStateError(this.state);
	    }
	  }
	  static _onMessageUnknownStateError(state) {
	    throw new Error(`Unknown state: "${state}"`)
	  }
	  /**
	   * Starts onboarding by opening the MetaMask download page and the MetaMaskOnboarding forwarder
	   */
	  static startOnboarding() {
	    sessionStorage.setItem("REGISTRATION_IN_PROGRESS", "true");
	    MetaMaskOnboarding._openDownloadPage();
	    MetaMaskOnboarding._openForwarder();
	  }
	  /**
	   * Stops onboarding registration, including removing the injected forwarder (if any)
	   *
	   * Typically this function is not necessary, but it can be useful for cases where
	   * onboarding completes before the forwarder has registered.
	   */
	  static stopOnboarding() {
	    if (sessionStorage.getItem("REGISTRATION_IN_PROGRESS") === "true") {
	      MetaMaskOnboarding._removeForwarder();
	      sessionStorage.setItem("REGISTRATION_IN_PROGRESS", "false");
	    }
	  }
	  static _openForwarder() {
	    MetaMaskOnboarding._injectForwarder("https://fwd.metamask.io");
	  }
	  static _openDownloadPage() {
	    const deeplink = `https://metamask.app.link/dapp/${window.location.hostname}${window.location.pathname}`;
	    window.open(deeplink, "_blank");
	  }
	  static isMetaMaskInstalled() {
	    return Boolean(window.ethereum?.isMetaMask)
	  }
	  static _register() {
	    return window.ethereum.request({
	      method: "wallet_registerOnboarding",
	    })
	  }
	  /**
	   * @param {string} forwarderOrigin
	   */
	  static _injectForwarder(forwarderOrigin) {
	    const container = document.body;
	    const iframe = document.createElement("iframe");
	    iframe.setAttribute("height", "0");
	    iframe.setAttribute("width", "0");
	    iframe.setAttribute("style", "display: none;");
	    iframe.setAttribute("src", forwarderOrigin);
	    iframe.setAttribute("id", "FORWARDER_ID");
	    container.insertBefore(iframe, container.children[ 0 ]);
	  }
	  static _removeForwarder() {
	    document.getElementById("FORWARDER_ID")?.remove();
	  }
	}

	class PercsMetamaskConnector extends MetaMaskConnector {
	  logo = "https://assets.getpercs.com/nft-gating/metamask.webp"
	  hasModal = true

	  constructor() {
	    super({
	      options: {
	        shimDisconnect: true,
	      },
	    });
	  }

	  connect(args) {
	    if (window.ethereum == null) {
	      // Provider missing
	      // @todo should only run on desktop chromium browser
	      MetaMaskOnboarding.startOnboarding();
	      throw new Error("MetaMask extension is not installed.  Please add your wallet or use a different connector")
	    }
	    return super.connect(args)
	  }
	}

	class PercsWalletConnectConnector extends WalletConnectConnector {
	  logo = "https://assets.getpercs.com/nft-gating/wallet-connect.webp"
	  hasModal = true

	  constructor() {
	    const explorerRecommendedWalletIds = [
	      // Venly
	      "a21d06c656c8b1de253686e06fc2f1b3d4aa39c46df2bfda8a6cc524ef32c20c",
	    ];
	    super({
	      options: {
	        projectId: "b148164112087c6059149f948b802ffa",
	        qrModalOptions: {
	          explorerRecommendedWalletIds,
	        }
	      },
	    });
	  }
	}

	const defaultConnectors = [
	  window.ethereum ? new PercsInjectedConnector() : new PercsMetamaskConnector(),
	  new PercsCoinbaseConnector(),
	  new PercsWalletConnectConnector(),
	];

	/** @type {import("svelte/store").Writable<import("@wagmi/core").GetAccountResult & { isModalOpen: boolean }>} */
	const wallet = writable(
	  {
	    address: undefined,
	    connector: undefined,
	    isConnected: false,
	    isConnecting: false,
	    isDisconnected: true,
	    isReconnecting: false,
	    status: "disconnected",
	    isModalOpen: false,
	  },
	  () => {
	    const { chains, publicClient, webSocketPublicClient } = configureChains(
	      [ mainnet$1 ],
	      [
	        publicProvider(),
	      ],
	    );

	    createConfig({
	      autoConnect: true,
	      chains,
	      connectors: defaultConnectors,
	      publicClient,
	      webSocketPublicClient,
	    });

	    const timer = setInterval(async () => {
	      const $wallet = get_store_value(wallet);
	      if ($wallet.connector) {
	        const account = await $wallet.connector.getAccount()
	          .catch(() => null);
	        if (!account) {
	          // This happens when the wallet disconnect is triggered in the provider
	          wallet.update((result) => ({
	            ...result,
	            address: undefined,
	            connector: undefined,
	            isConnected: false,
	            isConnecting: false,
	            isDisconnected: true,
	            isReconnecting: false,
	            status: "disconnected",
	          }));
	        }
	      }
	    }, 200);

	    const unwatchAccount = watchAccount((accountResult) => {
	      /** @type {any} */
	      const address = accountResult.address ? accountResult.address.toLowerCase() : undefined;
	      if (!address && accountResult.isConnecting) {
	        // it keeps triggring a connect unclear
	        return
	      }
	      wallet.update(({ isModalOpen }) => ({
	        ...accountResult,
	        address,
	        isModalOpen,
	      }));
	    });

	    return () => {
	      unwatchAccount();
	      clearInterval(timer);
	    }
	  }
	);

	const store = derived([ config$2, wallet ], ([ $config, $wallet ], set) => {
	  const { chains, publicClient, webSocketPublicClient } = configureChains(
	    [ mainnet$1 ],
	    [
	      publicProvider(),
	    ],
	  );

	  const connectors = $config.walletConnectors ?? defaultConnectors;

	  createConfig({
	    autoConnect: true,
	    chains,
	    connectors,
	    publicClient,
	    webSocketPublicClient,
	  });

	  set({ ...$wallet, connectors });
	});

	var wallet$1 = {
	  connect(args) {
	    wallet.update(($wallet) => ({
	      ...$wallet,
	      address: undefined,
	      connector: args.connector,
	      status: "connecting",
	      isConnected: false,
	      isReconnecting: false,
	      isConnecting: true,
	      isDisconnected: false,
	      errorMessage: null,
	      ...(args.connector.hasModal ? { isModalOpen: true } : {}),
	    }));
	    return connect(args)
	      .then(async ({ account: address, connector }) => {
	        if (connector == null) {
	          // This should never happen
	          throw new Error("WAGMI: connector not defined")
	        }
	        /** @type {any} */
	        const lowerAddress = address.toLowerCase();
	        address = lowerAddress;
	        wallet.update(($wallet) => ({
	          ...$wallet,
	          address,
	          connector,
	          status: "connected",
	          isConnected: true,
	          isConnecting: false,
	          isDisconnected: false,
	          isReconnecting: false,
	          isModalOpen: false,
	        }));
	      })
	      .catch(async (err) => {
	        if (err instanceof Error) {
	          if (err.name === "ConnectorAlreadyConnectedError") {
	            const accountResult = await getAccount();
	            wallet.update(($wallet) => ({
	              ...$wallet,
	              ...accountResult,
	              isModalOpen: false,
	            }));
	          } else {
	            wallet.update(($wallet) => ({
	              ...$wallet,
	              errorMessage: "shortMessage" in err ? err.shortMessage : err.message,
	              isModalOpen: false,
	            }));
	          }
	        }
	        throw err
	      })
	  },
	  disconnect() {
	    // Manually clear the wagmi keys or the wagmi state is wrong on page reload
	    for (let i = 0; i < localStorage.length; i++) {
	      const key = localStorage.key(i);
	      if (key?.startsWith("wagmi") || key?.startsWith("-walletlink:")) {
	        localStorage.removeItem(key);
	      }
	    }
	    wallet.set({
	      address: undefined,
	      connector: undefined,
	      isConnected: false,
	      isConnecting: false,
	      isDisconnected: true,
	      isReconnecting: false,
	      status: "disconnected",
	      isModalOpen: false,
	    });
	    return disconnect()
	  },
	  signPersonalMessage(account, message) {
	    return signMessage({ message: hexToStr(message) })
	  },
	  ...store,
	};

	const listeners = {
	  /** @type {Array<(data: {}) => any>} */
	  "modal_close": [],
	  /** @type {Array<(data: {}) => any>} */
	  "offer_redeem": [],
	};

	/**
	 * @template {keyof listeners} Event
	 * @param {Event} event
	 * @param {typeof listeners[Event][number]} fn
	 */
	function addListener(event, fn) {
	  const index = listeners[ event ].indexOf(fn);
	  if (index === -1) {
	    listeners[ event ].push(fn);
	  }
	}

	/**
	 * @template {keyof listeners} Event
	 * @param {Event} event
	 * @param {listeners[Event][number]} fn
	 */
	function removeListener(event, fn) {
	  const index = listeners[ event ].indexOf(fn);
	  if (index > -1) {
	    listeners[ event ].splice(index, 1);
	  }
	}

	/**
	 * @template {keyof listeners} Event
	 * @param {Event} event
	 * @param {Parameters<listeners[Event][number]>[0]} data
	 */
	function emit(event, data) {
	  for (const handler of listeners[ event ]) {
	    handler(data);
	  }
	}

	let id = 0;

	// API Methods

	class ApiError extends Error {
	  /**
	   *
	   * @param {string} message
	   * @param {Record<string, any>} data
	   */
	  constructor(message, data) {
	    super(message);
	    if (data != null) {
	      this.data = data;
	    }
	  }

	  toJSON() {
	    return {
	      message: this.message,
	      ...(this.data != null ? { data: this.data } : {}),
	    }
	  }
	}

	/**
	 * @param {string} method
	 * @param {unknown} params
	 * @returns {Promise<any>}
	 */
	async function callApiRpc(method, params) {
	  const $config = get_store_value(config$2);
	  const response = await fetch(`${$config.apiHost}/rpc`, {
	    method: "POST",
	    credentials: "omit",
	    // @ts-ignore
	    headers: {
	      "Content-Type": "application/json",
	      "x-api-key": $config.clientKey,
	    },
	    body: JSON.stringify({
	      jsonrpc: "2.0",
	      method,
	      params,
	      id: ++id,
	    }),
	  });

	  const responseText = await response.text();
	  let responseJson;
	  try {
	    responseJson = JSON.parse(responseText);
	  } catch (err) {
	    throw new ApiError("Unknown Error", { response: responseText })
	  }
	  if (responseJson.error) {
	    throw new ApiError(responseJson.error.message, responseJson.error.data)
	  }
	  return responseJson.result
	}

	/**
	 * @todo link to wallet
	 * @todo assign offer id on open if required
	 */


	/**
	 * @typedef {import("@percs/api-types").SubscriptionOption} SubscriptionOption
	 *
	 * @typedef {{
	 *   isEmailGate: boolean
	 *   commaSeparatedTags?: string
	 *   title?: string
	 *   description?: string
	 *   cta?: string
	 *   declineCta?: string
	 *   illustration?: string
	 *   dealLink?: string
	 *   dismissable?: boolean
	 * }} Gate
	 *
	 * @typedef {object} Subscribe
	 * @prop {Image} headingImage
	 * @prop {string} headingText
	 * @prop {string} descriptionText
	 * @prop {string} successHeadingText
	 * @prop {string} successDescriptionText
	 * @prop {Array<"email" | "xmtp_messaging">=} providers
	 *
	 * @typedef {{
	 *   src: string
	 * }} Image
	 *
	 * @typedef {{
	 *   id: number
	 *   image: Image
	 *   type: "discount" | "event" | "gate" | "giveaway"
	 *   messaging: {
	 *     title: string
	 *     description: string
	 *     instructions: string
	 *     redeemText: string
	 *     rejectText: string
	 *   }
	 *   name: string
	 *   redemption: {
	 *     selectType: "single" | "wallet"
	 *     type: "discount_code"
	 *     contractTokens: ContractToken[]
	 *     items: Array<{
	 *       id: number
	 *       isExpired: boolean
	 *       isRedeemed: boolean
	 *       discountDetail?: {
	 *         value: number,
	 *         type: "currency" | "percentage",
	 *       },
	 *       name: string
	 *       type: "discount"
	 *     }>
	 *     helpLink?: {
	 *       url: string
	 *       text: string
	 *     }
	 *   }
	 * }} Offer
	 *
	 * @typedef {("ETH"|"MATIC"|"AETH")} ChainCode
	 *
	 * @typedef {{
	 *   type: ChainCode | "custom"
	 *   address: string
	 *   name: string
	 *   tokens: {
	 *     [tokenId: string]: {
	 *       account: string
	 *       image: Image
	 *       name: string
	 *       isRedeemed: boolean
	 *       redeemMessage?: string
	 *     }
	 *   }
	 *   redemptionFields: {
	 *     schema: {
	 *       type: "object"
	 *       properties: {
	 *         [key: string]: any
	 *       }
	 *     }
	 *     uiSchema: {
	 *       type: "VerticalLayout"
	 *       elements: RedemptionSchemaUiElement[]
	 *     }
	 *   }
	 * }} ContractToken
	 *
	 * @typedef {{ type: "Control", scope: string, label: string }} RedemptionSchemaUiElement
	 *
	 * @typedef {{
	 *   provider: { name: string, logo: string, errorMessage?: string } | null
	 *   accounts: string[]
	 *   error: string | null
	 *   contractTokenRedemptions?: Array<{
	 *     type: ChainCode | "custom"
	 *     address: string
	 *     tokenRedemptions: {
	 *       [ tokenId: string ]: {
	 *         display: "discount_code"
	 *         offerType: "text"
	 *         value: string
	 *         link?: { text: string, url: string }
	 *       }
	 *     }
	 *   }>
	 *   redemptionValues?: Record<string, any>
	 *   scope?: string
	 *   offerId: string | null
	 *   offers: Offer[]
	 *   offerSelectedId: string | number | null
	 *   offerSelectedItemId: string | number | null
	 *   offerSelectedContract: string | null
	 *   offerSelectedTokenId: string | null
	 *   offersActiveTab: "Active" | "Redeemed"
	 *   autoSelectedItem: boolean | null
	 *   gate?: Gate
	 *   subscribe?: Subscribe
	 *   subscriptionOptions?: SubscriptionOption[]
	 *   selectedSubscriptionOption?: SubscriptionOption | null
	 * }} Context
	 */

	/** @type {typeof assignGeneric<Context>} */
	const assign$2 = assign$3;

	/** @type {{ id?: string }} */
	const initialValue = {};
	const sessionStore = localStore("percs_session", initialValue);

	const executionContext = Math.random().toString(16).slice(2, 8);
	let increment = 0;
	async function logEvent({ event, ...data }) {
	  // Load a session
	  const { id: sessionId } = get_store_value(sessionStore);
	  const baseEvent = {
	    version: 1,
	    seq: `${executionContext}-${++increment}`,
	    event: {
	      ...event,
	      data,
	    },
	  };
	  if (sessionId) {
	    return callApiRpc("updateSession", { ...baseEvent, sessionId })
	  }
	  return callApiRpc("startSession", { ...baseEvent })
	    .then(sessionStore.set)
	}

	/**
	 * @param {Context} context
	 */
	const redeemOfferItem = (context) => {
	  const $wallet = get_store_value(wallet$1);
	  const message = getOfferItemRedemptionMessage(context);

	  /** @type {{ offerId: string, itemId: string, message: string, values?: any }} */
	  const data = { offerId: context.offerSelectedId, itemId: context.offerSelectedItemId, message };
	  if (context.redemptionValues) {
	    data.values = context.redemptionValues;
	  }
	  return wallet$1.signPersonalMessage($wallet.address, message)
	    .then(
	      (signature) => callApiRpc("redeemTokens", { ...data, signature }),
	    )
	};

	/**
	 * @param {Context} context
	 * @returns {Pick<Context, "offerSelectedId" | "offerSelectedItemId" | "offerSelectedContract" | "offerSelectedTokenId">}
	 */
	function getHighestPriorityDiscount(context) {
	  let highestValue = 0;
	  let selectedItem;
	  let selectedOffer;
	  let isPercentage = false;
	  for (const offer of context.offers) {
	    for (const item of offer.redemption.items ?? []) {
	      if (!("discountDetail" in item)) {
	        continue
	      }
	      if (!item.discountDetail) {
	        continue
	      }
	      const {
	        discountDetail: { value, type }
	      } = item;
	      const isItemPercentage = type === "percentage";
	      if (isPercentage) {
	        if (!isItemPercentage) {
	          continue
	        }
	      } else if (isItemPercentage) {
	        isPercentage = isItemPercentage;
	        selectedItem = item;
	        selectedOffer = offer;
	        highestValue = value;
	        continue
	      }

	      if (highestValue < value) {
	        selectedItem = item;
	        selectedOffer = offer;
	        highestValue = value;
	      }
	    }
	  }

	  if (!selectedOffer || !selectedItem) {
	    selectedOffer = context.offers?.[ 0 ];
	    const selectedContract = selectedOffer?.redemption?.contractTokens[ 0 ];
	    return {
	      offerSelectedId: selectedOffer?.id || null,
	      offerSelectedItemId: selectedOffer?.redemption?.items?.[ 0 ]?.id || null,
	      offerSelectedContract: selectedContract ? `${selectedContract.type}:${selectedContract.address}` : null,
	      offerSelectedTokenId: Object.keys(selectedContract.tokens)[ 0 ],
	    }
	  }

	  return {
	    offerSelectedId: selectedOffer?.id || null,
	    offerSelectedItemId: selectedItem?.id || null,
	    offerSelectedContract: `${selectedOffer?.redemption?.contractTokens[ 0 ].type}:${selectedOffer?.redemption?.contractTokens[ 0 ].address}`,
	    offerSelectedTokenId: Object.keys(selectedOffer?.redemption?.contractTokens[ 0 ]?.tokens ?? {})[ 0 ],
	  }
	}

	/**
	 * @param {Context} context
	 * @returns {Pick<Context, "offerSelectedId" | "offerSelectedItemId" | "offerSelectedContract" | "offerSelectedTokenId">}
	 */
	function getDefaultSelectionContext(context) {
	  for (const offer of context.offers) {
	    for (const contract of offer.redemption.contractTokens) {
	      for (const [ tokenId, token ] of Object.entries(contract.tokens)) {
	        if (!token.isRedeemed) {
	          return {
	            offerSelectedId: offer.id,
	            offerSelectedItemId: offer.redemption.items[ 0 ].id,
	            offerSelectedContract: `${contract.type}:${contract.address}`,
	            offerSelectedTokenId: tokenId,
	          }
	        }
	      }
	    }
	  }

	  const selectedOffer = context.offers?.[ 0 ];
	  const selectedContract = selectedOffer?.redemption?.contractTokens[ 0 ];
	  return {
	    offerSelectedId: selectedOffer?.id || null,
	    offerSelectedItemId: selectedOffer?.redemption?.items?.[ 0 ]?.id || null,
	    offerSelectedContract: selectedContract ? `${selectedContract.type}:${selectedContract.address}` : null,
	    offerSelectedTokenId: Object.keys(selectedContract.tokens)[ 0 ],
	  }
	}

	/**
	 * @param {{ email: string, timeSpentSeconds: number, address?: string }} data
	 */
	function logUserSubscribeToDealsAction(data) {
	  return callApiRpc("logUserSubscribeToDealsAction", data)
	}

	/**
	 * @param {Context} context
	 */
	function isRedeemDetailsRequired(context) {
	  const redemption = context.offers.find(({ id }) => id === context.offerSelectedId)?.redemption;
	  if (redemption?.items[ 0 ]?.redemption?.link?.url) {
	    return false
	  }
	  return redemption?.contractTokens[ 0 ].redemptionFields?.schema?.properties != null
	}

	/** @type {Context} */
	const initialContext = {
	  provider: null,
	  accounts: [],
	  error: null,
	  offerId: null,
	  offers: [],
	  offerSelectedId: null,
	  offerSelectedItemId: null,
	  offerSelectedContract: null,
	  offerSelectedTokenId: null,
	  autoSelectedItem: null,
	  offersActiveTab: "Active",
	  gate: { isEmailGate: false },
	};

	const stateMachine = createMachine(
	  {
	    id: "percs-client",
	    predictableActionArguments: true,
	    type: "parallel",
	    context: initialContext,
	    states: {
	      "wallet": {
	        initial: "disconnected",
	        states: {
	          "connected": {
	            id: "wallet-connected",
	            on: {
	              WALLET_DISCONNECT: {
	                target: "disconnected",
	                actions: [
	                  assign$2({
	                    accounts: (_) => [],
	                    provider: (_) => null,
	                  }),
	                ],
	              },
	            },
	          },
	          "disconnected": {
	            id: "wallet-disconnected",
	            on: {
	              WALLET_CONNECT: {
	                target: "connected",
	                actions: [
	                  assign$2({
	                    accounts: (_, event) => event.data.accounts,
	                    provider: (_, event) => event.data.provider,
	                  }),
	                ],
	              },
	            },
	          },
	        },
	      },
	      "modal": {
	        id: "modal",
	        initial: "closed",
	        states: {
	          "closed": {
	            id: "modal-closed",
	            entry: [
	              assign$2((context) => ({
	                ...context,
	                gate: undefined,
	                scope: undefined,
	                subscribe: undefined,
	                offerSelectedType: null,
	                offers: null,
	              })),
	            ],
	            on: {
	              MODAL_OPEN: {
	                target: "open",
	                actions: [
	                  assign$2((context, { scope = "", gate = {}, subscribe, offerSelectedType }) => ({
	                    ...context,
	                    subscribe,
	                    scope,
	                    gate,
	                    offerSelectedType,
	                  })),
	                ],
	              },
	            },
	          },
	          "open": {
	            initial: "init",
	            id: "modal-open",
	            on: {
	              MODAL_CLOSE: {
	                target: "closed",
	                actions: [
	                  () => {
	                    emit("modal_close", {});
	                  },
	                ],
	              },
	            },
	            states: {
	              "init": {
	                entry: [
	                  assign$2((contextInit) => ({
	                    ...contextInit,
	                    error: null,
	                  })),
	                ],
	                always: [
	                  { target: "email-gate", cond: "isEmailGate" },
	                  { target: "provider-connect-success", in: "#wallet-connected" },
	                  { target: "provider-connect" },
	                ],
	              },
	              "email-gate": {
	                initial: "init",
	                id: "email-gate",
	                states: {
	                  "init": {
	                    on: {
	                      EMAIL_GATE_SUBMIT: "submit",
	                    },
	                  },
	                  "submit": {
	                    invoke: {
	                      id: "submit",
	                      src: (context, { email, timeSpentSeconds }) => logUserSubscribeToDealsAction({ email, timeSpentSeconds, address: context.accounts[ 0 ] }),
	                      onDone: {
	                        target: "success",
	                      },
	                      onError: {
	                        target: "error",
	                        actions: assign$2({ error: (_, event) => event.data }),
	                      },
	                    },
	                  },
	                  "error": {
	                    on: {
	                      EMAIL_GATE_SUBMIT: "submit",
	                    },
	                  },
	                  "success": {
	                    type: "final",
	                    invoke: {
	                      id: "success",
	                      src: (context) => Promise.resolve(window.open(context.gate?.dealLink, "_blank")),
	                    },
	                  },
	                },
	              },
	              "provider-connect": {
	                on: {
	                  WALLET_CONNECT: {
	                    target: "provider-connect-success",
	                    actions: [
	                      assign$2({
	                        accounts: (_, event) => event.data.accounts,
	                        provider: (_, event) => event.data.provider,
	                      }),
	                    ],
	                  },
	                  NO_PROVIDER: "provider-empty",
	                  PROVIDER_CONNECT: {
	                    target: "provider-connecting",
	                    actions: [
	                      assign$2({ provider: (_, event) => event.data.provider }),
	                    ],
	                  },
	                },
	              },
	              "provider-connecting": {
	                on: {
	                  WALLET_CONNECT: {
	                    target: "provider-connect-success",
	                    actions: [
	                      assign$2({
	                        accounts: (_, event) => event.data.accounts,
	                        provider: (_, event) => event.data.provider,
	                      }),
	                    ],
	                  },
	                  CONNECT: "provider-connect",
	                  PROVIDER_ERROR: {
	                    target: "provider-connect-error",
	                    actions: [
	                      assign$2({
	                        provider: (context, event) => ({
	                          ...context.provider,
	                          errorMessage: event.data.errorMessage,
	                        }),
	                      }),
	                    ],
	                  },
	                },
	              },
	              "provider-empty": {
	                on: {
	                  WALLET_CONNECT: {
	                    target: "provider-connect-success",
	                    actions: [
	                      assign$2({
	                        accounts: (_, event) => event.data.accounts,
	                        provider: (_, event) => event.data.provider,
	                      }),
	                    ],
	                  },
	                  CONNECT: "provider-connect",
	                },
	              },
	              "provider-connect-success": {
	                always: [
	                  { target: "subscribe", cond: "isSubscribe" },
	                  { target: "offer", cond: "hasScope" },
	                ],
	                on: {
	                  WALLET_DISCONNECT: "provider-connect",
	                },
	              },
	              "provider-connect-error": {
	                on: {
	                  WALLET_CONNECT: {
	                    target: "provider-connect-success",
	                    actions: [
	                      assign$2({
	                        accounts: (_, event) => event.data.accounts,
	                        provider: (_, event) => event.data.provider,
	                      }),
	                    ],
	                  },
	                  CONNECT: {
	                    target: "provider-connect",
	                    actions: [
	                      assign$2({
	                        provider: ({ provider }) => (provider?.errorMessage ? { name: provider.name, logo: provider.logo } : provider),
	                      })
	                    ]
	                  },
	                  PROVIDER_CONNECT: {
	                    target: "provider-connecting",
	                    actions: [
	                      assign$2({ provider: (_, event) => event.data.provider }),
	                    ],
	                  },
	                },
	              },
	              "subscribe": {
	                initial: "init",
	                on: {
	                  WALLET_DISCONNECT: "provider-connect",
	                },
	                states: {
	                  "init": {
	                    always: [
	                      {
	                        target: "loading",
	                      },
	                    ],
	                  },
	                  "loading": {
	                    invoke: {
	                      id: "getSubscriptionOptions",
	                      // @todo skip if options already loaded
	                      src: () => callApiRpc("getSubscriptionOptions", {}),
	                      onDone: {
	                        target: "integration-options",
	                        actions: [
	                          assign$2((context, event) => {
	                            const { providers } = context.subscribe ?? {};
	                            if (providers) {
	                              return {
	                                ...context,
	                                subscriptionOptions: event.data.subscriptionOptions.filter((option) => providers.includes(option.type)),
	                              }
	                            }
	                            return {
	                              ...context,
	                              subscriptionOptions: event.data.subscriptionOptions,
	                            }
	                          }),
	                        ],
	                      },
	                      onError: {
	                        target: "loading-error",
	                        actions: assign$2({ error: (_, event) => event.data }),
	                      },
	                    },
	                  },
	                  "loading-error": {
	                    on: {
	                      RETRY: {
	                        target: "loading",
	                      },
	                    },
	                  },
	                  "integration-options": {
	                    on: {
	                      INTEGRATION_SELECT: {
	                        target: "integration-selected",
	                        actions: [
	                          assign$2((context, event) => ({
	                            ...context,
	                            selectedSubscriptionOption: event.data.selectedSubscriptionOption,
	                          })),
	                        ],
	                      },
	                    },
	                  },
	                  "integration-selected": {
	                    on: {
	                      SUBSCRIBE: {
	                        target: "integration-success",
	                      },
	                      ERROR: {
	                        target: "integration-error",
	                        actions: assign$2({ error: (_, event) => event.data }),
	                      },
	                      BACK: {
	                        target: "integration-options",
	                        actions: [
	                          assign$2((context) => ({
	                            ...context,
	                            selectedSubscriptionOption: null,
	                          })),
	                        ],
	                      },
	                    },
	                  },
	                  "integration-error": {
	                    on: {
	                      RETRY: {
	                        target: "integration-selected",
	                        actions: [
	                          assign$2((context) => ({
	                            ...context,
	                            error: null,
	                          })),
	                        ],
	                      },
	                      BACK: {
	                        target: "integration-options",
	                        actions: [
	                          assign$2((context) => ({
	                            ...context,
	                            error: null,
	                            selectedSubscriptionOption: null,
	                          })),
	                        ],
	                      },
	                    },
	                  },
	                  "integration-success": {
	                    type: "final",
	                  },
	                },
	              },
	              "offer": {
	                initial: "loading",
	                id: "offer",
	                on: {
	                  WALLET_DISCONNECT: "provider-connect",
	                },
	                states: {
	                  "loading": {
	                    invoke: {
	                      id: "getOffers",
	                      // @todo skip if offer already loaded
	                      src: (context) => callApiRpc("getOffers", { scope: context.scope, accounts: [ get_store_value(wallet$1).address ], type: context.offerSelectedType }),
	                      onDone: {
	                        target: "success",
	                        actions: [
	                          assign$2((context, event) => {
	                            let selectedOffer = null;
	                            let selectedContract = null;
	                            if (context.offerSelectedType === "access" && !context.offerSelectedId) {
	                              if ("data" in event && "offers" in event.data && event.data.offers.length > 0) {
	                                for (const offer of event.data.offers) {
	                                  if ("type" in offer && offer.type === "gate") {
	                                    selectedOffer = offer;
	                                    continue
	                                  }
	                                }
	                              }
	                            } else if (context.offerSelectedType === "discount") {
	                              if ("offers" in context && context.offers) {
	                                selectedOffer = context.offers.find((offer) => offer.redemption.contractTokens.length > 0);
	                              } else if ("offers" in event.data && event.data.offers.length > 0) {
	                                [ selectedOffer ] = event.data.offers;
	                              }
	                            }

	                            if (!selectedOffer) {
	                              [ selectedOffer ] = event.data.offers;
	                            }

	                            selectedContract = selectedOffer?.redemption?.contractTokens[ 0 ] ?? null;
	                            return ({
	                              ...context,
	                              offerSelectedId: selectedOffer?.id || null,
	                              offerSelectedItemId: selectedOffer?.redemption?.items?.[ 0 ]?.id || null,
	                              offerSelectedContract: selectedContract ? `${selectedContract.type}:${selectedContract.address}` : null,
	                              offerSelectedTokenId: selectedContract ? Object.keys(selectedContract.tokens)[ 0 ] : null,
	                              autoSelectedItem: true,
	                              offers: event.data.offers || [],
	                            })
	                          }),
	                        ],
	                      },
	                      onError: {
	                        target: "error",
	                        actions: assign$2({ error: (_, event) => event.data }),
	                      },
	                    },
	                  },
	                  "success": {
	                    always: [
	                      { target: "empty", cond: "isOfferEmpty" },
	                      { target: "expired", cond: "isExpired" },
	                      {
	                        target: "event",
	                        cond: "isOfferTypeEvent",
	                      },
	                      {
	                        target: "discount",
	                        cond: "isOfferTypeDiscount",
	                        actions: [
	                          assign$2((context) => ({
	                            ...context,
	                            ...getHighestPriorityDiscount(context),
	                            autoSelectedItem: true,
	                          })),
	                        ],
	                      },
	                      {
	                        target: "giveaway",
	                        cond: "isOfferTypeGiveaway",
	                      },
	                      {
	                        target: "gate",
	                        cond: "isOfferTypeGate",
	                      },
	                    ],
	                  },
	                  "empty": {
	                    type: "final",
	                  },
	                  "expired": {
	                    type: "final",
	                  },
	                  "giveaway": {
	                    initial: "init",
	                    states: {
	                      "init": {
	                        always: [
	                          {
	                            target: "success",
	                            cond: "isRedeemed",
	                            actions: [
	                              assign$2((context) => ({
	                                ...context,
	                                offerSelectedId: context.offers?.[ 0 ].id || null,
	                                offerSelectedItemId: context.offers?.[ 0 ].redemption?.items?.find(({ isRedeemed }) => isRedeemed)?.id || null,
	                                autoSelectedItem: false,
	                              })),
	                            ],
	                          },
	                        ],
	                        on: {
	                          SELECT_EMAIL: {
	                            target: "selected",
	                            actions: [
	                              assign$2({ email: (_, event) => event.data.email }),
	                            ],
	                          },
	                        },
	                      },
	                      "selected": {
	                        always: [
	                          {
	                            target: "success",
	                            cond: "isRedeemed",
	                            actions: [
	                              assign$2((context) => ({
	                                ...context,
	                                offerSelectedId: context.offers?.[ 0 ].id || null,
	                                offerSelectedItemId: context.offers?.[ 0 ].redemption?.items?.find(({ isRedeemed }) => isRedeemed)?.id || null,
	                                offerSelectedToken: context.offers?.[ 0 ].redemption?.contractTokens[ 0 ].tokens[ 0 ],
	                                autoSelectedItem: false,
	                              })),
	                            ],
	                          },
	                        ],
	                        on: {
	                          SHARED: "shared",
	                        },
	                      },
	                      "shared": {
	                        always: [
	                          {
	                            target: "success",
	                            cond: "isRedeemed",
	                            actions: [
	                              assign$2((context) => ({
	                                ...context,
	                                offerSelectedItemId: context.offer.redemption?.items?.find(({ isRedeemed }) => isRedeemed)?.id || null,
	                                autoSelectedItem: false,
	                              })),
	                            ],
	                          },
	                        ],
	                        on: {
	                          OFFER_REDEEM: "redeeming",
	                        },
	                      },
	                      "redeeming": {
	                        invoke: {
	                          id: "redeem-giveaway-offer",
	                          // @todo skip if offer already loaded
	                          src: (context, eventData) => {
	                            return redeemOfferItem(context)
	                          },
	                          onDone: {
	                            target: "success",
	                          },
	                          onError: {
	                            target: "error",
	                            actions: assign$2({ error: (_, event) => event.data }),
	                          },
	                        },
	                      },
	                      "success": {
	                        type: "final",
	                        entry: [
	                          (context) => {
	                            emit("offer_redeem", {
	                              offerId: context.offerId,
	                              offerItemId: context.offerSelectedItemId,
	                            });
	                          },
	                        ],
	                      },
	                      "error": {
	                        on: {
	                          OFFER_REDEEM: "redeeming",
	                        },
	                      },
	                    },
	                  },
	                  "gate": {
	                    initial: "init",
	                    states: {
	                      "init": {
	                        on: {
	                          OFFER_REDEEM: {
	                            target: "redeem-start",
	                            actions: [
	                            ],
	                          },
	                        },
	                      },
	                      "redeem-start": {
	                        always: [
	                          {
	                            target: "redeem-details",
	                            cond: "isRedeemDetailsRequired",
	                            actions: [
	                            ],
	                          },
	                          {
	                            target: "redeem-loading",
	                            actions: [
	                            ],
	                          },
	                        ],
	                      },
	                      "redeem-details": {
	                        on: {
	                          OFFER_REDEEM_CANCEL: {
	                            target: "init",
	                            actions: [
	                              assign$2({ redemptionValues: (_, event) => event.redemptionValues })
	                            ],
	                          },
	                          OFFER_REDEEM: {
	                            target: "redeem-loading",
	                            actions: [
	                              assign$2({ redemptionValues: (_, event) => event.redemptionValues })
	                            ],
	                          },
	                        },
	                      },
	                      "redeem-loading": {
	                        invoke: {
	                          src: (context, eventData) => {
	                            return redeemOfferItem(context)
	                          },
	                          onDone: {
	                            target: "redeem-success",
	                          },
	                          onError: {
	                            target: "redeem-error",
	                            actions: assign$2({ error: (_, event) => event.data }),
	                          },
	                        },
	                      },
	                      "redeem-success": {
	                        type: "final",
	                        entry: [
	                          (context, event) => {
	                            if ("properties" in event.data && "_perc_request_id" in event.data.properties && !context.offerId && context.offerSelectedId) {
	                              emit("offer_redeem", {
	                                properties: event.data.properties,
	                              });
	                            } else {
	                              emit("offer_redeem", {
	                                offerId: context.offerId,
	                                offerItemId: context.offerSelectedItemId,
	                              });
	                            }
	                          },
	                          // @todo may want to wait on this to display a success message for a few seconds
	                          send({ type: "MODAL_CLOSE" }),
	                        ],
	                      },
	                      "redeem-error": {
	                        on: {
	                          RETRY: "redeem-loading",
	                        },
	                      },
	                    },
	                  },
	                  "event": {
	                    initial: "init",
	                    states: {
	                      "init": {
	                        always: [
	                          {
	                            target: "selected",
	                            actions: [
	                              assign$2((context) => ({
	                                ...context,
	                                ...getDefaultSelectionContext(context),
	                                autoSelectedItem: true,
	                              })),
	                            ],
	                          },
	                        ],
	                      },
	                      "selected": {
	                        always: [
	                          {
	                            target: "redeem-existing",
	                            cond: "isRedeemed",
	                          },
	                        ],
	                        on: {
	                          OFFER_SHOW_ALL: "list",
	                          OFFER_REDEEM: "redeem-start",
	                        },
	                      },
	                      "redeem-existing": {
	                        always: [
	                          // @todo if redemption is cached
	                          // { target: "redeem-success" },
	                        ],
	                        on: {
	                          OFFER_SHOW_ALL: "list",
	                          OFFER_REDEEM: "redeem-existing-loading",
	                        },
	                      },
	                      "redeem-existing-loading": {
	                        invoke: {
	                          id: "redeem-existing-offer-item",
	                          // @todo skip if offer already loaded
	                          src: redeemOfferItem,
	                          onDone: {
	                            target: "redeem-success",
	                            actions: [
	                              assign$2((context, event) => ({
	                                ...context,
	                                contractTokenRedemptions: event.data.contractTokenRedemptions || null,
	                              })),
	                            ],
	                          },
	                          onError: {
	                            target: "redeem-existing-error",
	                            actions: assign$2({ error: (_, event) => event.data }),
	                          },
	                        },
	                      },
	                      "redeem-existing-error": {
	                        on: {
	                          RETRY: "redeem-existing-loading",
	                        },
	                      },
	                      "redeem-start": {
	                        always: [
	                          {
	                            target: "redeem-details",
	                            cond: "isRedeemDetailsRequired",
	                            actions: [
	                            ],
	                          },
	                          {
	                            target: "redeem-loading",
	                            actions: [
	                            ],
	                          },
	                        ],
	                      },
	                      "redeem-details": {
	                        on: {
	                          OFFER_REDEEM_CANCEL: {
	                            target: "selected",
	                            actions: [
	                              assign$2({ redemptionValues: (_, event) => event.redemptionValues })
	                            ],
	                          },
	                          OFFER_REDEEM: {
	                            target: "redeem-loading",
	                            actions: [
	                              assign$2({ redemptionValues: (_, event) => event.redemptionValues })
	                            ],
	                          },
	                        },
	                      },
	                      "redeem-loading": {
	                        invoke: {
	                          id: "redeem-offer-item",
	                          // @todo skip if offer already loaded
	                          src: redeemOfferItem,
	                          onDone: {
	                            target: "redeem-success",
	                            actions: [
	                              assign$2((context, event) => ({
	                                ...context,
	                                offers: context.offers.map((offer) => {
	                                  if (offer.id !== context.offerSelectedId) {
	                                    return offer
	                                  }
	                                  return {
	                                    ...offer,
	                                    redemption: {
	                                      ...offer.redemption,
	                                      items: offer.redemption.items.map((item) => {
	                                        if (context.offerSelectedItemId !== item.id) {
	                                          return item
	                                        }
	                                        return {
	                                          ...item,
	                                          isRedeemed: true,
	                                        }
	                                      }),
	                                      contractTokens: offer.redemption.contractTokens.map((contract) => {
	                                        if (context.offerSelectedContract !== `${contract.type}:${contract.address}`) {
	                                          return contract
	                                        }
	                                        return {
	                                          ...contract,
	                                          tokens: Object.fromEntries(Object.entries(contract.tokens).map(([ tokenId, token ]) => {
	                                            if (tokenId !== context.offerSelectedTokenId) {
	                                              return [ tokenId, token ]
	                                            }
	                                            return [ tokenId, { ...token, isRedeemed: true } ]
	                                          }))
	                                        }
	                                      }),
	                                    },
	                                  }
	                                }),
	                                contractTokenRedemptions: event.data.contractTokenRedemptions || null,
	                              })),
	                            ],
	                          },
	                          onError: {
	                            target: "redeem-error",
	                            actions: assign$2({ error: (_, event) => event.data }),
	                          },
	                        },
	                      },
	                      "redeem-success": {
	                        entry: [
	                          (context) => {
	                            emit("offer_redeem", {
	                              offerId: context.offerSelectedId,
	                              offerItemId: context.offerSelectedItemId,
	                            });
	                          },
	                        ],
	                        on: {
	                          OFFER_SHOW_ALL: "list",
	                        },
	                      },
	                      "redeem-error": {
	                        on: {
	                          RETRY: "redeem-loading",
	                          OFFER_SHOW_ALL: "list",
	                        },
	                      },
	                      "list": {
	                        on: {
	                          OFFER_ITEM_SELECT: {
	                            target: "selected",
	                            actions: [
	                              assign$2((context, event) => {
	                                if (!event.itemId) {
	                                  // This is if the user clicks "back", just select previous screen
	                                  return context
	                                }
	                                return {
	                                  ...context,
	                                  offerSelectedId: event.offerId || null,
	                                  offerSelectedItemId: event.itemId || null,
	                                  offerSelectedContract: event.contract || null,
	                                  offerSelectedTokenId: event.tokenId || null,
	                                  autoSelectedItem: false,
	                                }
	                              }),
	                            ],
	                          },
	                          OFFERS_TAB_SELECT: {
	                            actions: [
	                              assign$2((context, event) => ({
	                                ...context,
	                                offersActiveTab: event.activeTab,
	                              }))
	                            ]
	                          }
	                        },
	                      },
	                    }
	                  },
	                  "discount": {
	                    initial: "init",
	                    states: {
	                      "init": {
	                        always: [
	                          {
	                            target: "selected",
	                            actions: [
	                              assign$2((context) => ({
	                                ...context,
	                                ...getHighestPriorityDiscount(context),
	                                autoSelectedItem: true,
	                              })),
	                            ],
	                          },
	                        ],
	                      },
	                      "selected": {
	                        always: [
	                          {
	                            target: "redeem-existing",
	                            cond: "isRedeemed",
	                          },
	                        ],
	                        on: {
	                          OFFER_SHOW_ALL: "list",
	                          OFFER_REDEEM: "redeem-start",
	                        },
	                      },
	                      "redeem-existing": {
	                        always: [
	                          // @todo if redemption is cached
	                          // { target: "redeem-success" },
	                        ],
	                        on: {
	                          OFFER_SHOW_ALL: "list",
	                          OFFER_REDEEM: "redeem-existing-loading",
	                        },
	                      },
	                      "redeem-existing-loading": {
	                        invoke: {
	                          id: "redeem-existing-offer-item",
	                          // @todo skip if offer already loaded
	                          src: redeemOfferItem,
	                          onDone: {
	                            target: "redeem-success",
	                            actions: [
	                              assign$2((context, event) => ({
	                                ...context,
	                                contractTokenRedemptions: event.data.contractTokenRedemptions || null,
	                              })),
	                            ],
	                          },
	                          onError: {
	                            target: "redeem-existing-error",
	                            actions: assign$2({ error: (_, event) => event.data }),
	                          },
	                        },
	                      },
	                      "redeem-existing-error": {
	                        on: {
	                          RETRY: "redeem-existing-loading",
	                        },
	                      },
	                      "redeem-start": {
	                        always: [
	                          {
	                            target: "redeem-details",
	                            cond: "isRedeemDetailsRequired",
	                            actions: [
	                            ],
	                          },
	                          {
	                            target: "redeem-loading",
	                            actions: [
	                            ],
	                          },
	                        ],
	                      },
	                      "redeem-details": {
	                        on: {
	                          OFFER_REDEEM_CANCEL: {
	                            target: "selected",
	                            actions: [
	                              assign$2({ redemptionValues: (_, event) => event.redemptionValues })
	                            ],
	                          },
	                          OFFER_REDEEM: {
	                            target: "redeem-loading",
	                            actions: [
	                              assign$2({ redemptionValues: (_, event) => event.redemptionValues })
	                            ],
	                          },
	                        },
	                      },
	                      "redeem-loading": {
	                        invoke: {
	                          id: "redeem-offer-item",
	                          // @todo skip if offer already loaded
	                          src: redeemOfferItem,
	                          onDone: {
	                            target: "redeem-success",
	                            actions: [
	                              assign$2((context, event) => ({
	                                ...context,
	                                offers: context.offers.map((offer) => {
	                                  if (offer.id !== context.offerSelectedId) {
	                                    return offer
	                                  }
	                                  return {
	                                    ...offer,
	                                    redemption: {
	                                      ...offer.redemption,
	                                      items: offer.redemption.items.map((item) => {
	                                        if (context.offerSelectedItemId !== item.id) {
	                                          return item
	                                        }
	                                        return {
	                                          ...item,
	                                          isRedeemed: true,
	                                        }
	                                      }),
	                                      contractTokens: offer.redemption.contractTokens.map((contract) => {
	                                        if (context.offerSelectedContract !== `${contract.type}:${contract.address}`) {
	                                          return contract
	                                        }
	                                        return {
	                                          ...contract,
	                                          tokens: Object.fromEntries(Object.entries(contract.tokens).map(([ tokenId, token ]) => {
	                                            if (tokenId !== context.offerSelectedTokenId) {
	                                              return [ tokenId, token ]
	                                            }
	                                            return [ tokenId, { ...token, isRedeemed: true } ]
	                                          }))
	                                        }
	                                      }),
	                                    },
	                                  }
	                                }),
	                                contractTokenRedemptions: event.data.contractTokenRedemptions || null,
	                              })),
	                            ],
	                          },
	                          onError: {
	                            target: "redeem-error",
	                            actions: assign$2({ error: (_, event) => event.data }),
	                          },
	                        },
	                      },
	                      "redeem-success": {
	                        entry: [
	                          (context) => {
	                            emit("offer_redeem", {
	                              offerId: context.offerSelectedId,
	                              offerItemId: context.offerSelectedItemId,
	                            });
	                          },
	                        ],
	                        on: {
	                          OFFER_SHOW_ALL: "list",
	                        },
	                      },
	                      "redeem-error": {
	                        on: {
	                          RETRY: "redeem-loading",
	                          OFFER_SHOW_ALL: "list",
	                        },
	                      },
	                      "list": {
	                        on: {
	                          OFFER_ITEM_SELECT: {
	                            target: "selected",
	                            actions: [
	                              assign$2((context, event) => {
	                                if (!event.itemId) {
	                                  // This is if the user clicks "back", just select previous screen
	                                  return context
	                                }
	                                return {
	                                  ...context,
	                                  offerSelectedId: event.offerId || null,
	                                  offerSelectedItemId: event.itemId || null,
	                                  offerSelectedContract: event.contract || null,
	                                  offerSelectedTokenId: event.tokenId || null,
	                                  autoSelectedItem: false,
	                                }
	                              }),
	                            ],
	                          },
	                          OFFERS_TAB_SELECT: {
	                            actions: [
	                              assign$2((context, event) => ({
	                                ...context,
	                                offersActiveTab: event.activeTab,
	                              }))
	                            ]
	                          }
	                        },
	                      },
	                    }
	                  },
	                  "error": {
	                    on: {
	                      RETRY: "loading",
	                    },
	                  },
	                },
	              },
	            },
	          },
	        },
	      },
	    },
	  },
	  {
	    guards: {
	      hasScope: (context) => context.scope != null,
	      isEmailGate: (context) => context.gate?.isEmailGate ?? false,
	      isSubscribe: (context) => context.subscribe != null,
	      isExpired: (context) => context.offers?.some((offer) => offer.redemption?.items.every(({ isExpired }) => isExpired)),
	      isRedeemed: (context) => context.offers.find(({ id }) => id === context.offerSelectedId)?.redemption.contractTokens.find(({ type, address }) => `${type}:${address}` === context.offerSelectedContract)?.tokens[ context.offerSelectedTokenId || "" ].isRedeemed ?? false,
	      isRedeemDetailsRequired,
	      isOfferEmpty: (context) => !context.offers?.some((offer) => offer.redemption?.contractTokens?.length),
	      isOfferTypeDiscount: (context) => context.offers?.some((offer) => offer.id === context.offerSelectedId && offer.type === "discount"),
	      isOfferTypeEvent: (context) => context.offers?.[ 0 ].type === "event",
	      isOfferTypeGate: (context) => context.offers?.some((offer) => offer.id === context.offerSelectedId && offer.type === "gate"),
	      isOfferTypeGiveaway: (context) => context.offers?.[ 0 ].type === "giveaway",
	    },
	  },
	);

	const stateService = interpret(stateMachine, { devTools: dev })
	  .onTransition((state) => {
	    const { value, event } = state;
	    if (event.type === "xstate.init") {
	      // Config isn't loaded when the state machine is initialized, so requests here are missing client key
	      return
	    }
	    if (event.type.startsWith("done.invoke")) {
	      // Ignore generated actions
	      return
	    }
	    if (event.type.startsWith("WALLET_") || value.modal === "closed") {
	      // Ignore wallet actions when modal isn't open
	      return
	    }
	    logEvent({ event, value }).catch(console.error);
	  })
	  .start();

	function init$1() {
	  wallet$1.subscribe(($wallet) => {
	    if ($wallet.errorMessage) {
	      stateService.send(
	        "PROVIDER_ERROR",
	        {
	          data: {
	            errorMessage: $wallet.errorMessage,
	          },
	        },
	      );
	    } else if ($wallet.isConnecting) {
	      stateService.send(
	        "PROVIDER_CONNECT",
	        {
	          data: {
	            accounts: $wallet.address ? [ $wallet.address.toLowerCase() ] : [],
	            provider: $wallet.connector
	              ? {
	                name: $wallet.connector.name,
	                logo: $wallet.connector.logo,
	              }
	              : null,
	          },
	        },
	      );
	    } else if ($wallet.isConnected) {
	      stateService.send(
	        "WALLET_CONNECT",
	        {
	          data: {
	            accounts: $wallet.address ? [ $wallet.address.toLowerCase() ] : [],
	            provider: $wallet.connector
	              ? {
	                name: $wallet.connector.name,
	                logo: $wallet.connector.logo,
	              }
	              : null,
	          },
	        },
	      );
	    } else {
	      stateService.send("WALLET_DISCONNECT");
	    }
	  });

	  logEvent({
	    event: {
	      type: "PAGE_LOAD",
	    },
	    url: window.location.href,
	    ...(window.location.search ? { search: [ ...(new URLSearchParams(window.location.search)).entries() ] } : {}),
	  }).catch(console.error);
	}

	/**
	 * @typedef {{
	 *   text: string
	 * }} Notification
	 */

	/** @type {Notification[]} */
	const initial = [];
	const notifications = writable(initial);

	var notifications$1 = {
	  subscribe: notifications.subscribe,
	  /**
	   * @param {Notification} notification
	   */
	  addNotification(notification) {
	    notifications.update(($notifications) => [ ...$notifications, notification ]);
	  },
	  /**
	   * @param {number} index
	   */
	  dismissNotification(index) {
	    notifications.update(($notifications) => $notifications.filter((_, i) => i !== index));
	  },
	};

	/* dist/components/internal/PercsNotifications.svelte generated by Svelte v3.59.2 */

	function add_css$G(target) {
		append_styles(target, "svelte-qd2n2", ".percs-notifications__item{display:flex;align-items:center;gap:8px;padding:0 8px;color:rgb(74 222 128)}.percs-notifications__message-icon{height:1.5em;width:1.5em}.percs-notifications__message{color:rgb(31 41 55)}.percs-notifications__close-button{background-color:white;border:none;cursor:pointer}.percs-notifications__close-icon{height:1em;width:1em}.sr-only.svelte-qd2n2{display:none}");
	}

	function get_each_context$7(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[3] = list[i];
		child_ctx[5] = i;
		return child_ctx;
	}

	// (27:8) {#each $notifications as notification, index}
	function create_each_block$7(ctx) {
		let div1;
		let svg0;
		let path0;
		let t0;
		let div0;
		let p;
		let t1_value = /*notification*/ ctx[3].text + "";
		let t1;
		let t2;
		let button;
		let t5;
		let mounted;
		let dispose;

		function click_handler() {
			return /*click_handler*/ ctx[2](/*index*/ ctx[5]);
		}

		return {
			c() {
				div1 = element("div");
				svg0 = svg_element("svg");
				path0 = svg_element("path");
				t0 = space();
				div0 = element("div");
				p = element("p");
				t1 = text(t1_value);
				t2 = space();
				button = element("button");

				button.innerHTML = `<span class="sr-only svelte-qd2n2">Close</span> 
              
              <svg class="percs-notifications__close-icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"></path></svg>`;

				t5 = space();
				attr(path0, "stroke-linecap", "round");
				attr(path0, "stroke-linejoin", "round");
				attr(path0, "d", "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z");
				attr(svg0, "class", "percs-notifications__message-icon");
				attr(svg0, "fill", "none");
				attr(svg0, "viewBox", "0 0 24 24");
				attr(svg0, "stroke-width", "1.5");
				attr(svg0, "stroke", "currentColor");
				attr(svg0, "aria-hidden", "true");
				attr(p, "class", "percs-notifications__message");
				attr(button, "type", "button");
				attr(button, "class", "percs-notifications__close-button");
				attr(div1, "class", "percs-notifications__item");
			},
			m(target, anchor) {
				insert(target, div1, anchor);
				append(div1, svg0);
				append(svg0, path0);
				append(div1, t0);
				append(div1, div0);
				append(div0, p);
				append(p, t1);
				append(div1, t2);
				append(div1, button);
				append(div1, t5);

				if (!mounted) {
					dispose = listen(button, "click", click_handler);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*$notifications*/ 1 && t1_value !== (t1_value = /*notification*/ ctx[3].text + "")) set_data(t1, t1_value);
			},
			d(detaching) {
				if (detaching) detach(div1);
				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$V(ctx) {
		let div3;
		let div2;
		let div1;
		let div0;
		let each_value = /*$notifications*/ ctx[0];
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$7(get_each_context$7(ctx, each_value, i));
		}

		return {
			c() {
				div3 = element("div");
				div2 = element("div");
				div1 = element("div");
				div0 = element("div");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				attr(div0, "class", "p-4");
				attr(div1, "class", "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5");
				attr(div2, "class", "flex w-full flex-col items-center space-y-4 sm:items-end");
				attr(div3, "aria-live", "assertive");
				attr(div3, "class", "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6");
			},
			m(target, anchor) {
				insert(target, div3, anchor);
				append(div3, div2);
				append(div2, div1);
				append(div1, div0);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(div0, null);
					}
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*handleDismiss, $notifications*/ 3) {
					each_value = /*$notifications*/ ctx[0];
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$7(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$7(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(div0, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(div3);
				destroy_each(each_blocks, detaching);
			}
		};
	}

	function instance$V($$self, $$props, $$invalidate) {
		let $notifications;
		component_subscribe($$self, notifications$1, $$value => $$invalidate(0, $notifications = $$value));

		function handleDismiss(index) {
			notifications$1.dismissNotification(index);
		}

		const click_handler = index => handleDismiss(index);
		return [$notifications, handleDismiss, click_handler];
	}

	class PercsNotifications extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$V, create_fragment$V, safe_not_equal, {}, add_css$G);
		}
	}

	/* dist/components/internal/PercsAppLauncher.svelte generated by Svelte v3.59.2 */

	function add_css$F(target) {
		append_styles(target, "svelte-a9lsse", ".percs-app-launcher__message-container{position:fixed;right:18px;bottom:100px;background-color:white;list-style-type:none;border:2px solid black;border-radius:8px;padding:0;z-index:10;margin-left:16px}.percs-app-launcher{position:fixed;display:var(--app-launcher-button-display, inline);right:18px;bottom:18px;cursor:pointer;border-radius:50%;border:none;padding:2px;z-index:10}.percs-app-launcher__icon{background-color:black;width:60px;height:60px;display:flex;align-items:center;justify-content:center;border-radius:50%}.percs-app-launcher__notification{position:absolute;right:-2px;top:-8px;border-radius:50%;background-color:#FD665F;color:white;text-align:center;width:24px;height:24px;display:flex;align-items:center;justify-content:center}.percs-app-launcher__notification-text{font-weight:500}");
	}

	// (9:0) {#if $notifications.length > 0}
	function create_if_block_2$g(ctx) {
		let div;
		let percsnotifications;
		let current;
		percsnotifications = new PercsNotifications({});

		return {
			c() {
				div = element("div");
				create_component(percsnotifications.$$.fragment);
				attr(div, "class", "percs-app-launcher__message-container");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				mount_component(percsnotifications, div, null);
				current = true;
			},
			i(local) {
				if (current) return;
				transition_in(percsnotifications.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsnotifications.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div);
				destroy_component(percsnotifications);
			}
		};
	}

	// (16:2) {#if notification}
	function create_if_block$v(ctx) {
		let if_block_anchor;

		function select_block_type(ctx, dirty) {
			if (typeof /*notification*/ ctx[0] === "number") return create_if_block_1$p;
			return create_else_block$g;
		}

		let current_block_type = select_block_type(ctx);
		let if_block = current_block_type(ctx);

		return {
			c() {
				if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, dirty) {
				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				}
			},
			d(detaching) {
				if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (21:4) {:else}
	function create_else_block$g(ctx) {
		let div;

		return {
			c() {
				div = element("div");
				attr(div, "class", "percs-app-launcher__notification");
			},
			m(target, anchor) {
				insert(target, div, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(div);
			}
		};
	}

	// (17:4) {#if typeof notification === "number"}
	function create_if_block_1$p(ctx) {
		let div1;
		let div0;
		let t;

		return {
			c() {
				div1 = element("div");
				div0 = element("div");
				t = text(/*notification*/ ctx[0]);
				attr(div0, "class", "percs-app-launcher__notification-text");
				attr(div1, "class", "percs-app-launcher__notification");
			},
			m(target, anchor) {
				insert(target, div1, anchor);
				append(div1, div0);
				append(div0, t);
			},
			p(ctx, dirty) {
				if (dirty & /*notification*/ 1) set_data(t, /*notification*/ ctx[0]);
			},
			d(detaching) {
				if (detaching) detach(div1);
			}
		};
	}

	function create_fragment$U(ctx) {
		let t0;
		let button;
		let t1;
		let div;
		let current;
		let mounted;
		let dispose;
		let if_block0 = /*$notifications*/ ctx[1].length > 0 && create_if_block_2$g();
		let if_block1 = /*notification*/ ctx[0] && create_if_block$v(ctx);
		const default_slot_template = /*#slots*/ ctx[3].default;
		const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[2], null);

		return {
			c() {
				if (if_block0) if_block0.c();
				t0 = space();
				button = element("button");
				if (if_block1) if_block1.c();
				t1 = space();
				div = element("div");
				if (default_slot) default_slot.c();
				attr(div, "class", "percs-app-launcher__icon");
				attr(button, "type", "button");
				attr(button, "class", "percs-app-launcher");
			},
			m(target, anchor) {
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t0, anchor);
				insert(target, button, anchor);
				if (if_block1) if_block1.m(button, null);
				append(button, t1);
				append(button, div);

				if (default_slot) {
					default_slot.m(div, null);
				}

				current = true;

				if (!mounted) {
					dispose = listen(button, "click", /*click_handler*/ ctx[4]);
					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (/*$notifications*/ ctx[1].length > 0) {
					if (if_block0) {
						if (dirty & /*$notifications*/ 2) {
							transition_in(if_block0, 1);
						}
					} else {
						if_block0 = create_if_block_2$g();
						if_block0.c();
						transition_in(if_block0, 1);
						if_block0.m(t0.parentNode, t0);
					}
				} else if (if_block0) {
					group_outros();

					transition_out(if_block0, 1, 1, () => {
						if_block0 = null;
					});

					check_outros();
				}

				if (/*notification*/ ctx[0]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block$v(ctx);
						if_block1.c();
						if_block1.m(button, t1);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (default_slot) {
					if (default_slot.p && (!current || dirty & /*$$scope*/ 4)) {
						update_slot_base(
							default_slot,
							default_slot_template,
							ctx,
							/*$$scope*/ ctx[2],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[2])
							: get_slot_changes(default_slot_template, /*$$scope*/ ctx[2], dirty, null),
							null
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block0);
				transition_in(default_slot, local);
				current = true;
			},
			o(local) {
				transition_out(if_block0);
				transition_out(default_slot, local);
				current = false;
			},
			d(detaching) {
				if (if_block0) if_block0.d(detaching);
				if (detaching) detach(t0);
				if (detaching) detach(button);
				if (if_block1) if_block1.d();
				if (default_slot) default_slot.d(detaching);
				mounted = false;
				dispose();
			}
		};
	}

	function instance$U($$self, $$props, $$invalidate) {
		let $notifications;
		component_subscribe($$self, notifications$1, $$value => $$invalidate(1, $notifications = $$value));
		let { $$slots: slots = {}, $$scope } = $$props;
		let { notification = false } = $$props;

		function click_handler(event) {
			bubble.call(this, $$self, event);
		}

		$$self.$$set = $$props => {
			if ('notification' in $$props) $$invalidate(0, notification = $$props.notification);
			if ('$$scope' in $$props) $$invalidate(2, $$scope = $$props.$$scope);
		};

		return [notification, $notifications, $$scope, slots, click_handler];
	}

	class PercsAppLauncher extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$U, create_fragment$U, safe_not_equal, { notification: 0 }, add_css$F);
		}
	}

	/* dist/components/PercsAppLauncher.svelte generated by Svelte v3.59.2 */

	function create_default_slot$v(ctx) {
		let svg;
		let path0;
		let path1;

		return {
			c() {
				svg = svg_element("svg");
				path0 = svg_element("path");
				path1 = svg_element("path");
				attr(path0, "fill-rule", "evenodd");
				attr(path0, "clip-rule", "evenodd");
				attr(path0, "d", "M5.25 5.75344C5.25002 4.73998 5.54338 3.74818 6.09466 2.89777C6.64595 2.04736 7.43159 1.37469 8.35675 0.960961C9.28192 0.547227 10.3071 0.410114 11.3084 0.566175C12.3098 0.722235 13.2446 1.1648 14 1.84044C14.8687 1.06187 15.9719 0.594797 17.1356 0.512945C18.2992 0.431093 19.457 0.739127 20.4261 1.38842C21.3953 2.03771 22.1205 2.99128 22.4875 4.0986C22.8544 5.20591 22.8421 6.4039 22.4525 7.50344H24.5C25.4283 7.50344 26.3185 7.87219 26.9749 8.52856C27.6313 9.18494 28 10.0752 28 11.0034C28 11.9317 27.6313 12.8219 26.9749 13.4783C26.3185 14.1347 25.4283 14.5034 24.5 14.5034H15.75V12.7534C15.75 12.2893 15.5656 11.8442 15.2374 11.516C14.9092 11.1878 14.4641 11.0034 14 11.0034C13.5359 11.0034 13.0908 11.1878 12.7626 11.516C12.4344 11.8442 12.25 12.2893 12.25 12.7534V14.5034H3.5C2.57174 14.5034 1.6815 14.1347 1.02513 13.4783C0.368749 12.8219 0 11.9317 0 11.0034C0 10.0752 0.368749 9.18494 1.02513 8.52856C1.6815 7.87219 2.57174 7.50344 3.5 7.50344H5.5475C5.355 6.95569 5.25 6.36594 5.25 5.75344ZM12.25 7.50344V5.75344C12.25 5.40732 12.1474 5.06898 11.9551 4.78119C11.7628 4.4934 11.4895 4.2691 11.1697 4.13665C10.8499 4.0042 10.4981 3.96954 10.1586 4.03706C9.81913 4.10459 9.50731 4.27126 9.26256 4.516C9.01782 4.76074 8.85115 5.07256 8.78363 5.41203C8.7161 5.7515 8.75076 6.10336 8.88321 6.42313C9.01566 6.7429 9.23997 7.01622 9.52775 7.20851C9.81554 7.4008 10.1539 7.50344 10.5 7.50344H12.25ZM17.5 7.50344C17.8461 7.50344 18.1845 7.4008 18.4722 7.20851C18.76 7.01622 18.9843 6.7429 19.1168 6.42313C19.2492 6.10336 19.2839 5.7515 19.2164 5.41203C19.1488 5.07256 18.9822 4.76074 18.7374 4.516C18.4927 4.27126 18.1809 4.10459 17.8414 4.03706C17.5019 3.96954 17.1501 4.0042 16.8303 4.13665C16.5105 4.2691 16.2372 4.4934 16.0449 4.78119C15.8526 5.06898 15.75 5.40732 15.75 5.75344V7.50344H17.5Z");
				attr(path0, "fill", "white");
				attr(path1, "d", "M12 16.5039H0V26.5039C0 27.5648 0.421427 28.5822 1.17157 29.3323C1.92172 30.0825 2.93913 30.5039 4 30.5039H12V16.5039ZM16 30.5039H24C25.0609 30.5039 26.0783 30.0825 26.8284 29.3323C27.5786 28.5822 28 27.5648 28 26.5039V16.5039H16V30.5039Z");
				attr(path1, "fill", "white");
				attr(svg, "width", "28");
				attr(svg, "height", "31");
				attr(svg, "viewBox", "0 0 28 31");
				attr(svg, "fill", "none");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			},
			m(target, anchor) {
				insert(target, svg, anchor);
				append(svg, path0);
				append(svg, path1);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(svg);
			}
		};
	}

	function create_fragment$T(ctx) {
		let percsapplauncher;
		let current;

		percsapplauncher = new PercsAppLauncher({
				props: {
					notification: true,
					$$slots: { default: [create_default_slot$v] },
					$$scope: { ctx }
				}
			});

		percsapplauncher.$on("click", /*handleDiscountClick*/ ctx[0]);

		return {
			c() {
				create_component(percsapplauncher.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsapplauncher, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsapplauncher_changes = {};

				if (dirty & /*$$scope*/ 32) {
					percsapplauncher_changes.$$scope = { dirty, ctx };
				}

				percsapplauncher.$set(percsapplauncher_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsapplauncher.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsapplauncher.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsapplauncher, detaching);
			}
		};
	}

	function instance$T($$self, $$props, $$invalidate) {
		let { title } = $$props;
		let { description } = $$props;
		let { illustration } = $$props;
		let { scope } = $$props;

		function handleDiscountClick() {
			const gate = { title, description, illustration };

			stateService.send({
				type: "MODAL_OPEN",
				gate,
				scope,
				offerSelectedType: "discount"
			});
		}

		$$self.$$set = $$props => {
			if ('title' in $$props) $$invalidate(1, title = $$props.title);
			if ('description' in $$props) $$invalidate(2, description = $$props.description);
			if ('illustration' in $$props) $$invalidate(3, illustration = $$props.illustration);
			if ('scope' in $$props) $$invalidate(4, scope = $$props.scope);
		};

		return [handleDiscountClick, title, description, illustration, scope];
	}

	class PercsAppLauncher_1 extends SvelteComponent {
		constructor(options) {
			super();

			init$3(this, options, instance$T, create_fragment$T, safe_not_equal, {
				title: 1,
				description: 2,
				illustration: 3,
				scope: 4
			});
		}
	}

	/* dist/components/internal/PercsButton.svelte generated by Svelte v3.59.2 */

	function add_css$E(target) {
		append_styles(target, "svelte-1m9qxfr", ".button.svelte-1m9qxfr{border-radius:6px;background:none;padding:8px 16px;font-family:inherit;font-style:normal;font-weight:500;font-size:14px;line-height:20px;border:2px solid transparent;cursor:pointer;text-decoration:none;display:flex;align-items:center;justify-content:center}.button.svelte-1m9qxfr:disabled{opacity:0.5;cursor:not-allowed}.button__icon{height:32px;width:32px;margin-right:5px}.default.svelte-1m9qxfr{--button-color:#d1d5db;--button-hover-color:#c1c6cc}.primary.svelte-1m9qxfr{--button-color:#285FE0;--button-hover-color:#285fe0e0}.accent.svelte-1m9qxfr{--button-color:#fd665f;--button-hover-color:#fd675fe0}.flat.svelte-1m9qxfr{color:var(--button-color)}.flat.svelte-1m9qxfr:hover,.flat.svelte-1m9qxfr:focus,.flat.svelte-1m9qxfr:active{text-decoration:underline}.outlined.svelte-1m9qxfr{border:2px solid var(--dialog-button-color, var(--button-color, #d1d5db));color:var(--dialog-button-text-color, var(--dialog-button-color, var(--button-color)))}.outlined.svelte-1m9qxfr:hover,.outlined.svelte-1m9qxfr:focus,.outlined.svelte-1m9qxfr:active{color:var(--dialog-button-color, var(--button-hover-color, var(--button-color)));opacity:0.8}.contained.svelte-1m9qxfr{border:2px solid var(--dialog-button-color, var(--button-color));background:var(--dialog-button-color, var(--button-color, #d1d5db));color:var(--dialog-button-text-color, #ffffff)}.contained.svelte-1m9qxfr:hover,.contained.svelte-1m9qxfr:focus,.contained.svelte-1m9qxfr:active{background-color:var(--dialog-button-color, var(--button-hover-color));color:var(--dialog-button-text-color, #ffffff)}.small.svelte-1m9qxfr{padding:6px 30px}.no-padding-x.svelte-1m9qxfr{padding-left:0;padding-right:0}");
	}

	const get_icon_slot_changes$1 = dirty => ({});
	const get_icon_slot_context$1 = ctx => ({});

	// (39:2) {:else}
	function create_else_block$f(ctx) {
		let current;
		const default_slot_template = /*#slots*/ ctx[10].default;
		const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[9], null);

		return {
			c() {
				if (default_slot) default_slot.c();
			},
			m(target, anchor) {
				if (default_slot) {
					default_slot.m(target, anchor);
				}

				current = true;
			},
			p(ctx, dirty) {
				if (default_slot) {
					if (default_slot.p && (!current || dirty & /*$$scope*/ 512)) {
						update_slot_base(
							default_slot,
							default_slot_template,
							ctx,
							/*$$scope*/ ctx[9],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[9])
							: get_slot_changes(default_slot_template, /*$$scope*/ ctx[9], dirty, null),
							null
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(default_slot, local);
				current = true;
			},
			o(local) {
				transition_out(default_slot, local);
				current = false;
			},
			d(detaching) {
				if (default_slot) default_slot.d(detaching);
			}
		};
	}

	// (36:25) 
	function create_if_block_1$o(ctx) {
		let img;
		let img_src_value;
		let img_alt_value;
		let t;
		let current;
		const default_slot_template = /*#slots*/ ctx[10].default;
		const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[9], null);

		return {
			c() {
				img = element("img");
				t = space();
				if (default_slot) default_slot.c();
				attr(img, "class", "button__icon");
				if (!src_url_equal(img.src, img_src_value = /*icon*/ ctx[6].src)) attr(img, "src", img_src_value);
				attr(img, "alt", img_alt_value = /*icon*/ ctx[6].alt);
			},
			m(target, anchor) {
				insert(target, img, anchor);
				insert(target, t, anchor);

				if (default_slot) {
					default_slot.m(target, anchor);
				}

				current = true;
			},
			p(ctx, dirty) {
				if (!current || dirty & /*icon*/ 64 && !src_url_equal(img.src, img_src_value = /*icon*/ ctx[6].src)) {
					attr(img, "src", img_src_value);
				}

				if (!current || dirty & /*icon*/ 64 && img_alt_value !== (img_alt_value = /*icon*/ ctx[6].alt)) {
					attr(img, "alt", img_alt_value);
				}

				if (default_slot) {
					if (default_slot.p && (!current || dirty & /*$$scope*/ 512)) {
						update_slot_base(
							default_slot,
							default_slot_template,
							ctx,
							/*$$scope*/ ctx[9],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[9])
							: get_slot_changes(default_slot_template, /*$$scope*/ ctx[9], dirty, null),
							null
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(default_slot, local);
				current = true;
			},
			o(local) {
				transition_out(default_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(img);
				if (detaching) detach(t);
				if (default_slot) default_slot.d(detaching);
			}
		};
	}

	// (33:2) {#if $$slots.icon}
	function create_if_block$u(ctx) {
		let t;
		let current;
		const icon_slot_template = /*#slots*/ ctx[10].icon;
		const icon_slot = create_slot(icon_slot_template, ctx, /*$$scope*/ ctx[9], get_icon_slot_context$1);
		const default_slot_template = /*#slots*/ ctx[10].default;
		const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[9], null);

		return {
			c() {
				if (icon_slot) icon_slot.c();
				t = space();
				if (default_slot) default_slot.c();
			},
			m(target, anchor) {
				if (icon_slot) {
					icon_slot.m(target, anchor);
				}

				insert(target, t, anchor);

				if (default_slot) {
					default_slot.m(target, anchor);
				}

				current = true;
			},
			p(ctx, dirty) {
				if (icon_slot) {
					if (icon_slot.p && (!current || dirty & /*$$scope*/ 512)) {
						update_slot_base(
							icon_slot,
							icon_slot_template,
							ctx,
							/*$$scope*/ ctx[9],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[9])
							: get_slot_changes(icon_slot_template, /*$$scope*/ ctx[9], dirty, get_icon_slot_changes$1),
							get_icon_slot_context$1
						);
					}
				}

				if (default_slot) {
					if (default_slot.p && (!current || dirty & /*$$scope*/ 512)) {
						update_slot_base(
							default_slot,
							default_slot_template,
							ctx,
							/*$$scope*/ ctx[9],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[9])
							: get_slot_changes(default_slot_template, /*$$scope*/ ctx[9], dirty, null),
							null
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(icon_slot, local);
				transition_in(default_slot, local);
				current = true;
			},
			o(local) {
				transition_out(icon_slot, local);
				transition_out(default_slot, local);
				current = false;
			},
			d(detaching) {
				if (icon_slot) icon_slot.d(detaching);
				if (detaching) detach(t);
				if (default_slot) default_slot.d(detaching);
			}
		};
	}

	// (18:0) <svelte:element   {...$$props}   this={as}   on:click   {type}   class="button"   class:outlined={variant === "outlined"}   class:flat={variant === "flat"}   class:contained={variant === "contained"}   class:default={theme === "default"}   class:primary={theme === "primary"}   class:accent={theme === "accent"}   class:small={size === "small"}   class:no-padding-x={noPaddingX != null} >
	function create_dynamic_element$1(ctx) {
		let svelte_element;
		let current_block_type_index;
		let if_block;
		let current;
		let mounted;
		let dispose;
		const if_block_creators = [create_if_block$u, create_if_block_1$o, create_else_block$f];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*$$slots*/ ctx[8].icon) return 0;
			if (/*icon*/ ctx[6] != null) return 1;
			return 2;
		}

		current_block_type_index = select_block_type(ctx);
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		let svelte_element_levels = [/*$$props*/ ctx[7], { type: /*type*/ ctx[4] }, { class: "button" }];
		let svelte_element_data = {};

		for (let i = 0; i < svelte_element_levels.length; i += 1) {
			svelte_element_data = assign$6(svelte_element_data, svelte_element_levels[i]);
		}

		return {
			c() {
				svelte_element = element(/*as*/ ctx[5]);
				if_block.c();
				set_dynamic_element_data(/*as*/ ctx[5])(svelte_element, svelte_element_data);
				toggle_class(svelte_element, "outlined", /*variant*/ ctx[0] === "outlined");
				toggle_class(svelte_element, "flat", /*variant*/ ctx[0] === "flat");
				toggle_class(svelte_element, "contained", /*variant*/ ctx[0] === "contained");
				toggle_class(svelte_element, "default", /*theme*/ ctx[2] === "default");
				toggle_class(svelte_element, "primary", /*theme*/ ctx[2] === "primary");
				toggle_class(svelte_element, "accent", /*theme*/ ctx[2] === "accent");
				toggle_class(svelte_element, "small", /*size*/ ctx[1] === "small");
				toggle_class(svelte_element, "no-padding-x", /*noPaddingX*/ ctx[3] != null);
				toggle_class(svelte_element, "svelte-1m9qxfr", true);
			},
			m(target, anchor) {
				insert(target, svelte_element, anchor);
				if_blocks[current_block_type_index].m(svelte_element, null);
				current = true;

				if (!mounted) {
					dispose = listen(svelte_element, "click", /*click_handler*/ ctx[11]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type(ctx);

				if (current_block_type_index === previous_block_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(svelte_element, null);
				}

				set_dynamic_element_data(/*as*/ ctx[5])(svelte_element, svelte_element_data = get_spread_update(svelte_element_levels, [
					dirty & /*$$props*/ 128 && /*$$props*/ ctx[7],
					(!current || dirty & /*type*/ 16) && { type: /*type*/ ctx[4] },
					{ class: "button" }
				]));

				toggle_class(svelte_element, "outlined", /*variant*/ ctx[0] === "outlined");
				toggle_class(svelte_element, "flat", /*variant*/ ctx[0] === "flat");
				toggle_class(svelte_element, "contained", /*variant*/ ctx[0] === "contained");
				toggle_class(svelte_element, "default", /*theme*/ ctx[2] === "default");
				toggle_class(svelte_element, "primary", /*theme*/ ctx[2] === "primary");
				toggle_class(svelte_element, "accent", /*theme*/ ctx[2] === "accent");
				toggle_class(svelte_element, "small", /*size*/ ctx[1] === "small");
				toggle_class(svelte_element, "no-padding-x", /*noPaddingX*/ ctx[3] != null);
				toggle_class(svelte_element, "svelte-1m9qxfr", true);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(svelte_element);
				if_blocks[current_block_type_index].d();
				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$S(ctx) {
		let previous_tag = /*as*/ ctx[5];
		let svelte_element_anchor;
		let current;
		let svelte_element = /*as*/ ctx[5] && create_dynamic_element$1(ctx);

		return {
			c() {
				if (svelte_element) svelte_element.c();
				svelte_element_anchor = empty$3();
			},
			m(target, anchor) {
				if (svelte_element) svelte_element.m(target, anchor);
				insert(target, svelte_element_anchor, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				if (/*as*/ ctx[5]) {
					if (!previous_tag) {
						svelte_element = create_dynamic_element$1(ctx);
						previous_tag = /*as*/ ctx[5];
						svelte_element.c();
						svelte_element.m(svelte_element_anchor.parentNode, svelte_element_anchor);
					} else if (safe_not_equal(previous_tag, /*as*/ ctx[5])) {
						svelte_element.d(1);
						svelte_element = create_dynamic_element$1(ctx);
						previous_tag = /*as*/ ctx[5];
						svelte_element.c();
						svelte_element.m(svelte_element_anchor.parentNode, svelte_element_anchor);
					} else {
						svelte_element.p(ctx, dirty);
					}
				} else if (previous_tag) {
					svelte_element.d(1);
					svelte_element = null;
					previous_tag = /*as*/ ctx[5];
				}
			},
			i(local) {
				if (current) return;
				transition_in(svelte_element);
				current = true;
			},
			o(local) {
				transition_out(svelte_element);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(svelte_element_anchor);
				if (svelte_element) svelte_element.d(detaching);
			}
		};
	}

	function instance$S($$self, $$props, $$invalidate) {
		let { $$slots: slots = {}, $$scope } = $$props;
		const $$slots = compute_slots(slots);
		let { variant = "outlined" } = $$props;
		let { size = "normal" } = $$props;
		let { theme = "accent" } = $$props;
		let { noPaddingX = false } = $$props;
		let { type = "button" } = $$props;
		let { as = "button" } = $$props;
		let { icon = null } = $$props;

		function click_handler(event) {
			bubble.call(this, $$self, event);
		}

		$$self.$$set = $$new_props => {
			$$invalidate(7, $$props = assign$6(assign$6({}, $$props), exclude_internal_props($$new_props)));
			if ('variant' in $$new_props) $$invalidate(0, variant = $$new_props.variant);
			if ('size' in $$new_props) $$invalidate(1, size = $$new_props.size);
			if ('theme' in $$new_props) $$invalidate(2, theme = $$new_props.theme);
			if ('noPaddingX' in $$new_props) $$invalidate(3, noPaddingX = $$new_props.noPaddingX);
			if ('type' in $$new_props) $$invalidate(4, type = $$new_props.type);
			if ('as' in $$new_props) $$invalidate(5, as = $$new_props.as);
			if ('icon' in $$new_props) $$invalidate(6, icon = $$new_props.icon);
			if ('$$scope' in $$new_props) $$invalidate(9, $$scope = $$new_props.$$scope);
		};

		$$props = exclude_internal_props($$props);

		return [
			variant,
			size,
			theme,
			noPaddingX,
			type,
			as,
			icon,
			$$props,
			$$slots,
			$$scope,
			slots,
			click_handler
		];
	}

	class PercsButton extends SvelteComponent {
		constructor(options) {
			super();

			init$3(
				this,
				options,
				instance$S,
				create_fragment$S,
				safe_not_equal,
				{
					variant: 0,
					size: 1,
					theme: 2,
					noPaddingX: 3,
					type: 4,
					as: 5,
					icon: 6
				},
				add_css$E
			);
		}
	}

	/* dist/components/PercsConnectButton.svelte generated by Svelte v3.59.2 */

	function create_else_block$e(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					$$slots: { default: [create_default_slot$u] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[1]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 4) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (6:0) {#if $state.context.accounts.length > 0}
	function create_if_block$t(ctx) {
		let t;

		return {
			c() {
				t = text("Connected");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p: noop$6,
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (9:2) <PercsButton on:click={() => state.send("MODAL_OPEN")}>
	function create_default_slot$u(ctx) {
		let t;

		return {
			c() {
				t = text("Connect Wallet");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	function create_fragment$R(ctx) {
		let current_block_type_index;
		let if_block;
		let if_block_anchor;
		let current;
		const if_block_creators = [create_if_block$t, create_else_block$e];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*$state*/ ctx[0].context.accounts.length > 0) return 0;
			return 1;
		}

		current_block_type_index = select_block_type(ctx);
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

		return {
			c() {
				if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if_blocks[current_block_type_index].m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type(ctx);

				if (current_block_type_index === previous_block_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if_blocks[current_block_type_index].d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	function instance$R($$self, $$props, $$invalidate) {
		let $state;
		component_subscribe($$self, stateService, $$value => $$invalidate(0, $state = $$value));
		const click_handler = () => stateService.send("MODAL_OPEN");
		return [$state, click_handler];
	}

	class PercsConnectButton extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$R, create_fragment$R, safe_not_equal, {});
		}
	}

	/* dist/components/PercsOfferButton.svelte generated by Svelte v3.59.2 */

	function add_css$D(target) {
		append_styles(target, "svelte-y7nagz", "button.svelte-y7nagz{display:inline-block;width:100%;margin:30px auto;padding:12px 0;border:2px solid #161b5d;border-radius:30px;background-color:#fbb338;box-shadow:3px 3px 0 2px #fd4b38;transition:all 300ms ease-in-out;color:#161b5d;font-size:18px;text-align:center;line-height:inherit;cursor:pointer}button.svelte-y7nagz:hover{box-shadow:1px 1px 0 2px #fbb338}");
	}

	function create_fragment$Q(ctx) {
		let button;
		let t;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				t = text(/*text*/ ctx[0]);
				attr(button, "class", "svelte-y7nagz");
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, t);

				if (!mounted) {
					dispose = listen(button, "click", /*click_handler*/ ctx[3]);
					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*text*/ 1) set_data(t, /*text*/ ctx[0]);
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(button);
				mounted = false;
				dispose();
			}
		};
	}

	function instance$Q($$self, $$props, $$invalidate) {
		let { scope = "" } = $$props;
		let { text = "Redeem" } = $$props;

		function handleClick() {
			const gate = {
				commaSeparatedTags: $$props["comma-separated-tags"] ?? $$props.commaseparatedtags ?? $$props.commaSeparatedTags,
				isEmailGate: `${$$props["is-email-gate"] ?? $$props.isemailgate ?? $$props.isEmailGate}`.toLocaleLowerCase() === "true",
				title: $$props.title,
				description: $$props.description,
				cta: $$props.cta,
				declineCta: $$props["decline-cta"] ?? $$props.declinecta ?? $$props.declineCta,
				illustration: $$props.illustration,
				dealLink: $$props["deal-link"] ?? $$props.deallink ?? $$props.dealLink
			};

			stateService.send({ type: "MODAL_OPEN", gate, scope });
		}

		const click_handler = () => handleClick();

		$$self.$$set = $$new_props => {
			$$invalidate(4, $$props = assign$6(assign$6({}, $$props), exclude_internal_props($$new_props)));
			if ('scope' in $$new_props) $$invalidate(2, scope = $$new_props.scope);
			if ('text' in $$new_props) $$invalidate(0, text = $$new_props.text);
		};

		$$props = exclude_internal_props($$props);
		return [text, handleClick, scope, click_handler];
	}

	class PercsOfferButton extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$Q, create_fragment$Q, safe_not_equal, { scope: 2, text: 0 }, add_css$D);
		}
	}

	/**
	 * @param {string} base
	 * @param {string | string[]} modifiers
	 */
	function bem(base, modifiers) {
	  if (typeof modifiers === "string") {
	    if (modifiers === "") {
	      return base
	    }
	    modifiers = modifiers.split(/\s/u);
	  }
	  return `${base} ${modifiers.map((modifier) => `${base}--${modifier}`).join(" ")}`
	}

	/**
	 * @param {string} text
	 * @param {number} maxLength
	 * @returns
	 */
	function truncateCenter(text, maxLength = 50) {
	  if (text.length <= maxLength) {
	    return text
	  }
	  const half = Math.ceil(maxLength / 2);
	  const prefix = text.substring(0, half);
	  const suffix = text.substring(text.length - (maxLength - half));
	  return `${prefix}…${suffix}`
	}

	/* dist/components/internal/PercsAccountBadge.svelte generated by Svelte v3.59.2 */

	function add_css$C(target) {
		append_styles(target, "svelte-15q2ny1", ".account-badge{position:relative}.account-badge__button{color:#285FE0;border:2px solid #285FE0;border-radius:13px;width:max-content;padding:4px 8px;font-size:12px;cursor:pointer;z-index:10}.account-badge__button--open{border-radius:13px 13px 0 0}.account-badge__popup{position:absolute;border:2px solid #285FE0;border-top:0;border-radius:0 0 19px 19px;width:100%;padding:4px;background-color:white;box-sizing:border-box}.account-badge__disconnect-button{border:2px solid rgb(248, 113, 113);background-color:rgb(254, 242, 242);border-radius:13px;color:rgb(153, 27, 27);font-weight:900;cursor:pointer;width:100%}");
	}

	// (26:2) {#if isOpen}
	function create_if_block$s(ctx) {
		let div;
		let button;
		let mounted;
		let dispose;

		return {
			c() {
				div = element("div");
				button = element("button");
				button.textContent = "Disconnect";
				attr(button, "class", "account-badge__disconnect-button");
				attr(div, "class", "account-badge__popup");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, button);

				if (!mounted) {
					dispose = listen(button, "click", /*handleDisconnect*/ ctx[3]);
					mounted = true;
				}
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(div);
				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$P(ctx) {
		let div;
		let button;
		let t0;
		let span;
		let t1;
		let t2_value = truncateCenter(/*account*/ ctx[2].slice(2), 12) + "";
		let t2;
		let t3;
		let t4;
		let mounted;
		let dispose;
		let if_block = /*isOpen*/ ctx[1] && create_if_block$s(ctx);

		return {
			c() {
				div = element("div");
				button = element("button");
				t0 = text("Account: (");
				span = element("span");
				t1 = text("0x");
				t2 = text(t2_value);
				t3 = text(")");
				t4 = space();
				if (if_block) if_block.c();
				attr(span, "title", /*account*/ ctx[2]);
				attr(button, "class", "account-badge__button");
				toggle_class(button, "account-badge__button--open", /*isOpen*/ ctx[1]);
				attr(div, "class", "account-badge");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, button);
				append(button, t0);
				append(button, span);
				append(span, t1);
				append(span, t2);
				append(button, t3);
				append(div, t4);
				if (if_block) if_block.m(div, null);

				if (!mounted) {
					dispose = listen(button, "click", /*click_handler*/ ctx[5]);
					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*account*/ 4 && t2_value !== (t2_value = truncateCenter(/*account*/ ctx[2].slice(2), 12) + "")) set_data(t2, t2_value);

				if (dirty & /*account*/ 4) {
					attr(span, "title", /*account*/ ctx[2]);
				}

				if (dirty & /*isOpen*/ 2) {
					toggle_class(button, "account-badge__button--open", /*isOpen*/ ctx[1]);
				}

				if (/*isOpen*/ ctx[1]) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block$s(ctx);
						if_block.c();
						if_block.m(div, null);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(div);
				if (if_block) if_block.d();
				mounted = false;
				dispose();
			}
		};
	}

	function instance$P($$self, $$props, $$invalidate) {
		let account;

		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(4, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();
		let isOpen = false;

		async function handleDisconnect() {
			await wallet$1.disconnect();
		}

		const click_handler = () => {
			$$invalidate(1, isOpen = !isOpen);
		};

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*$state*/ 16) {
				$$invalidate(2, [account] = $state.context.accounts, account);
			}
		};

		return [state, isOpen, account, handleDisconnect, $state, click_handler];
	}

	class PercsAccountBadge extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$P, create_fragment$P, safe_not_equal, { state: 0 }, add_css$C);
		}
	}

	/* dist/components/internal/PercsDialogHeader.svelte generated by Svelte v3.59.2 */

	function add_css$B(target) {
		append_styles(target, "svelte-lrfvpy", ".dialog-header{background-color:var(--dialog-background-color, #ffffff);padding:0 12px;position:relative;display:flex;flex-direction:row;align-items:center;border-bottom:1px solid var(--dialog-text-color, #eaecf0)}.dialog-header__account-badge{display:flex;align-items:center;justify-content:center;padding:1em}.dialog-header__container{background-color:var(--dialog-background-color, #ffffff);color:var(--dialog-text-color, #101828);padding-left:12px;padding-right:12px}.dialog-header__text{flex-grow:1;font-style:normal;font-weight:600;font-size:18px;text-align:center;padding-top:5px;padding-bottom:5px;color:var(--dialog-header-text-color, var(--dialog-text-color, #101828))}.dialog-header__close{font-size:24px;position:absolute;right:12px;border:none;background-color:transparent;cursor:pointer;color:var(--dialog-text-color, #101828)}.dialog-header__-email-gate{color:#161b5d;max-width:280px;gap:8px;margin:8px auto;margin-bottom:32px}.dialog-header__-email-gate h2{margin-bottom:8px}");
	}

	// (18:2) {#if $state.context.gate?.dismissable !== false}
	function create_if_block_1$n(ctx) {
		let button;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				button.textContent = "×";
				attr(button, "type", "button");
				attr(button, "class", "dialog-header__close");
			},
			m(target, anchor) {
				insert(target, button, anchor);

				if (!mounted) {
					dispose = listen(button, "click", /*click_handler*/ ctx[7]);
					mounted = true;
				}
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(button);
				mounted = false;
				dispose();
			}
		};
	}

	// (23:2) {#if $state.context.accounts.length > 0}
	function create_if_block$r(ctx) {
		let div;
		let percsaccountbadge;
		let current;
		percsaccountbadge = new PercsAccountBadge({ props: { state: /*state*/ ctx[1] } });

		return {
			c() {
				div = element("div");
				create_component(percsaccountbadge.$$.fragment);
				attr(div, "class", "dialog-header__account-badge");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				mount_component(percsaccountbadge, div, null);
				current = true;
			},
			p(ctx, dirty) {
				const percsaccountbadge_changes = {};
				if (dirty & /*state*/ 2) percsaccountbadge_changes.state = /*state*/ ctx[1];
				percsaccountbadge.$set(percsaccountbadge_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsaccountbadge.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsaccountbadge.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div);
				destroy_component(percsaccountbadge);
			}
		};
	}

	function create_fragment$O(ctx) {
		let div0;
		let h2;
		let t0;
		let t1;
		let div0_class_value;
		let t2;
		let div1;
		let t3;
		let current;
		let if_block0 = /*$state*/ ctx[3].context.gate?.dismissable !== false && create_if_block_1$n(ctx);
		let if_block1 = /*$state*/ ctx[3].context.accounts.length > 0 && create_if_block$r(ctx);
		const default_slot_template = /*#slots*/ ctx[6].default;
		const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[5], null);

		return {
			c() {
				div0 = element("div");
				h2 = element("h2");
				t0 = text(/*text*/ ctx[2]);
				t1 = space();
				if (if_block0) if_block0.c();
				t2 = space();
				div1 = element("div");
				if (if_block1) if_block1.c();
				t3 = space();
				if (default_slot) default_slot.c();
				attr(h2, "class", "dialog-header__text");
				attr(div0, "class", div0_class_value = bem("dialog-header", /*modifiers*/ ctx[0]));
				attr(div1, "class", "dialog-header__container");
			},
			m(target, anchor) {
				insert(target, div0, anchor);
				append(div0, h2);
				append(h2, t0);
				append(div0, t1);
				if (if_block0) if_block0.m(div0, null);
				insert(target, t2, anchor);
				insert(target, div1, anchor);
				if (if_block1) if_block1.m(div1, null);
				append(div1, t3);

				if (default_slot) {
					default_slot.m(div1, null);
				}

				current = true;
			},
			p(ctx, [dirty]) {
				if (!current || dirty & /*text*/ 4) set_data(t0, /*text*/ ctx[2]);

				if (/*$state*/ ctx[3].context.gate?.dismissable !== false) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_1$n(ctx);
						if_block0.c();
						if_block0.m(div0, null);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (!current || dirty & /*modifiers*/ 1 && div0_class_value !== (div0_class_value = bem("dialog-header", /*modifiers*/ ctx[0]))) {
					attr(div0, "class", div0_class_value);
				}

				if (/*$state*/ ctx[3].context.accounts.length > 0) {
					if (if_block1) {
						if_block1.p(ctx, dirty);

						if (dirty & /*$state*/ 8) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block$r(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(div1, t3);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}

				if (default_slot) {
					if (default_slot.p && (!current || dirty & /*$$scope*/ 32)) {
						update_slot_base(
							default_slot,
							default_slot_template,
							ctx,
							/*$$scope*/ ctx[5],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[5])
							: get_slot_changes(default_slot_template, /*$$scope*/ ctx[5], dirty, null),
							null
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block1);
				transition_in(default_slot, local);
				current = true;
			},
			o(local) {
				transition_out(if_block1);
				transition_out(default_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div0);
				if (if_block0) if_block0.d();
				if (detaching) detach(t2);
				if (detaching) detach(div1);
				if (if_block1) if_block1.d();
				if (default_slot) default_slot.d(detaching);
			}
		};
	}

	function instance$O($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(3, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { $$slots: slots = {}, $$scope } = $$props;
		let { modifiers = "" } = $$props;
		let { state } = $$props;
		$$subscribe_state();
		let { text } = $$props;
		const dispatch = createEventDispatcher();
		const click_handler = () => dispatch("close");

		$$self.$$set = $$props => {
			if ('modifiers' in $$props) $$invalidate(0, modifiers = $$props.modifiers);
			if ('state' in $$props) $$subscribe_state($$invalidate(1, state = $$props.state));
			if ('text' in $$props) $$invalidate(2, text = $$props.text);
			if ('$$scope' in $$props) $$invalidate(5, $$scope = $$props.$$scope);
		};

		return [modifiers, state, text, $state, dispatch, $$scope, slots, click_handler];
	}

	class PercsDialogHeader extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$O, create_fragment$O, safe_not_equal, { modifiers: 0, state: 1, text: 2 }, add_css$B);
		}
	}

	/* dist/components/internal/PercsDialogContent.svelte generated by Svelte v3.59.2 */

	function add_css$A(target) {
		append_styles(target, "svelte-qxubs7", ".dialog__content{background-color:var(--dialog-background-color, #ffffff);color:var(--dialog-text-color, #000000);padding:24px 32px 12px;display:flex;flex-direction:column}.dialog__content--center{height:316px;max-height:50vw;display:grid;grid-template-rows:1fr min-content;align-items:center;padding:18px}.dialog__content--full{padding:0 16px 16px}.dialog__content--spaced{gap:8px}.dialog__content--email-gate{display:flex;flex-direction:column;gap:12px;margin-bottom:-16px}.dialog__content--offer-giveaway-success{gap:32px;align-items:center;display:grid;grid-auto-flow:row}.dialog__content--offer-giveaway-success svg{margin-top:8px;justify-self:center}");
	}

	function create_fragment$N(ctx) {
		let div;
		let div_class_value;
		let current;
		const default_slot_template = /*#slots*/ ctx[2].default;
		const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[1], null);

		return {
			c() {
				div = element("div");
				if (default_slot) default_slot.c();
				attr(div, "class", div_class_value = bem("dialog__content", /*modifiers*/ ctx[0]));
			},
			m(target, anchor) {
				insert(target, div, anchor);

				if (default_slot) {
					default_slot.m(div, null);
				}

				current = true;
			},
			p(ctx, [dirty]) {
				if (default_slot) {
					if (default_slot.p && (!current || dirty & /*$$scope*/ 2)) {
						update_slot_base(
							default_slot,
							default_slot_template,
							ctx,
							/*$$scope*/ ctx[1],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[1])
							: get_slot_changes(default_slot_template, /*$$scope*/ ctx[1], dirty, null),
							null
						);
					}
				}

				if (!current || dirty & /*modifiers*/ 1 && div_class_value !== (div_class_value = bem("dialog__content", /*modifiers*/ ctx[0]))) {
					attr(div, "class", div_class_value);
				}
			},
			i(local) {
				if (current) return;
				transition_in(default_slot, local);
				current = true;
			},
			o(local) {
				transition_out(default_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div);
				if (default_slot) default_slot.d(detaching);
			}
		};
	}

	function instance$N($$self, $$props, $$invalidate) {
		let { $$slots: slots = {}, $$scope } = $$props;
		let { modifiers = "" } = $$props;

		$$self.$$set = $$props => {
			if ('modifiers' in $$props) $$invalidate(0, modifiers = $$props.modifiers);
			if ('$$scope' in $$props) $$invalidate(1, $$scope = $$props.$$scope);
		};

		return [modifiers, $$scope, slots];
	}

	class PercsDialogContent extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$N, create_fragment$N, safe_not_equal, { modifiers: 0 }, add_css$A);
		}
	}

	/* dist/components/internal/PercsDialogIllustration.svelte generated by Svelte v3.59.2 */

	function add_css$z(target) {
		append_styles(target, "svelte-10pcy60", ".dialog__illustration{height:200px;width:200px;margin:24px auto}");
	}

	function create_fragment$M(ctx) {
		let img;
		let img_src_value;

		return {
			c() {
				img = element("img");
				if (!src_url_equal(img.src, img_src_value = /*src*/ ctx[0])) attr(img, "src", img_src_value);
				attr(img, "alt", /*alt*/ ctx[1]);
				attr(img, "class", "dialog__illustration");
			},
			m(target, anchor) {
				insert(target, img, anchor);
			},
			p(ctx, [dirty]) {
				if (dirty & /*src*/ 1 && !src_url_equal(img.src, img_src_value = /*src*/ ctx[0])) {
					attr(img, "src", img_src_value);
				}

				if (dirty & /*alt*/ 2) {
					attr(img, "alt", /*alt*/ ctx[1]);
				}
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(img);
			}
		};
	}

	function instance$M($$self, $$props, $$invalidate) {
		let { src } = $$props;
		let { alt } = $$props;

		$$self.$$set = $$props => {
			if ('src' in $$props) $$invalidate(0, src = $$props.src);
			if ('alt' in $$props) $$invalidate(1, alt = $$props.alt);
		};

		return [src, alt];
	}

	class PercsDialogIllustration extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$M, create_fragment$M, safe_not_equal, { src: 0, alt: 1 }, add_css$z);
		}
	}

	/* dist/components/dialog-contents/EmailGate.svelte generated by Svelte v3.59.2 */

	function add_css$y(target) {
		append_styles(target, "svelte-5j9skb", ".error.svelte-5j9skb{color:#FD665F}.dialog__field--email.svelte-5j9skb{margin-bottom:8px;background-color:white;border:1px solid #eee;border-radius:3px;height:40px;padding:8px;box-sizing:border-box}.dialog__field--email.svelte-5j9skb:hover,.dialog__field--email.svelte-5j9skb:focus,.dialog__field--email.svelte-5j9skb:active{outline:none;border-color:rgb(52, 52, 52);transition:all cubic-bezier(0.075, 0.82, 0.165, 1) 0.3s}");
	}

	// (46:4) {:else}
	function create_else_block_1$4(ctx) {
		let t;

		return {
			c() {
				t = text(/*tagsList*/ ctx[2]);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*tagsList*/ 4) set_data(t, /*tagsList*/ ctx[2]);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (44:4) {#if $state.matches("modal.open.email-gate.error")}
	function create_if_block_1$m(ctx) {
		let t;

		return {
			c() {
				t = text("We encountered an error, please try again later");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (41:0) <PercsDialogHeader {state} on:close text={title || "Get Access"} modifiers="email-gate">
	function create_default_slot_3$d(ctx) {
		let span0;
		let t1;
		let span1;
		let show_if;

		function select_block_type(ctx, dirty) {
			if (dirty & /*$state*/ 8) show_if = null;
			if (show_if == null) show_if = !!/*$state*/ ctx[3].matches("modal.open.email-gate.error");
			if (show_if) return create_if_block_1$m;
			return create_else_block_1$4;
		}

		let current_block_type = select_block_type(ctx, -1);
		let if_block = current_block_type(ctx);

		return {
			c() {
				span0 = element("span");
				span0.textContent = `${/*description*/ ctx[5]}`;
				t1 = space();
				span1 = element("span");
				if_block.c();
				attr(span1, "class", "error svelte-5j9skb");
			},
			m(target, anchor) {
				insert(target, span0, anchor);
				insert(target, t1, anchor);
				insert(target, span1, anchor);
				if_block.m(span1, null);
			},
			p(ctx, dirty) {
				if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(span1, null);
					}
				}
			},
			d(detaching) {
				if (detaching) detach(span0);
				if (detaching) detach(t1);
				if (detaching) detach(span1);
				if_block.d();
			}
		};
	}

	// (70:6) {:else}
	function create_else_block$d(ctx) {
		let t;

		return {
			c() {
				t = text(/*cta*/ ctx[6]);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (68:6) {#if $state.matches("modal.open.email-gate.submit")}
	function create_if_block$q(ctx) {
		let t;

		return {
			c() {
				t = text("Submitting");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (63:4) <PercsButton       type="submit"       disabled={$state.matches("modal.open.email-gate.submit") || !email}       variant="contained"     >
	function create_default_slot_2$j(ctx) {
		let show_if;
		let if_block_anchor;

		function select_block_type_1(ctx, dirty) {
			if (dirty & /*$state*/ 8) show_if = null;
			if (show_if == null) show_if = !!/*$state*/ ctx[3].matches("modal.open.email-gate.submit");
			if (show_if) return create_if_block$q;
			return create_else_block$d;
		}

		let current_block_type = select_block_type_1(ctx, -1);
		let if_block = current_block_type(ctx);

		return {
			c() {
				if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, dirty) {
				if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				}
			},
			d(detaching) {
				if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (74:4) <PercsButton type="button" variant="flat" on:click={handleDismiss}>
	function create_default_slot_1$p(ctx) {
		let t;

		return {
			c() {
				t = text(/*declineCta*/ ctx[7]);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (52:2) <PercsDialogContent modifiers="email-gate">
	function create_default_slot$t(ctx) {
		let percsdialogillustration;
		let t0;
		let input;
		let input_disabled_value;
		let t1;
		let percsbutton0;
		let t2;
		let percsbutton1;
		let current;
		let mounted;
		let dispose;

		percsdialogillustration = new PercsDialogIllustration({
				props: {
					src: /*illustration*/ ctx[4],
					alt: /*description*/ ctx[5]
				}
			});

		percsbutton0 = new PercsButton({
				props: {
					type: "submit",
					disabled: /*$state*/ ctx[3].matches("modal.open.email-gate.submit") || !/*email*/ ctx[1],
					variant: "contained",
					$$slots: { default: [create_default_slot_2$j] },
					$$scope: { ctx }
				}
			});

		percsbutton1 = new PercsButton({
				props: {
					type: "button",
					variant: "flat",
					$$slots: { default: [create_default_slot_1$p] },
					$$scope: { ctx }
				}
			});

		percsbutton1.$on("click", /*handleDismiss*/ ctx[9]);

		return {
			c() {
				create_component(percsdialogillustration.$$.fragment);
				t0 = space();
				input = element("input");
				t1 = space();
				create_component(percsbutton0.$$.fragment);
				t2 = space();
				create_component(percsbutton1.$$.fragment);
				attr(input, "class", "dialog__field--email svelte-5j9skb");
				attr(input, "placeholder", "Email Address");
				attr(input, "type", "email");
				attr(input, "name", "email");
				input.required = true;
				input.disabled = input_disabled_value = /*$state*/ ctx[3].matches("modal.open.email-gate.submit");
			},
			m(target, anchor) {
				mount_component(percsdialogillustration, target, anchor);
				insert(target, t0, anchor);
				insert(target, input, anchor);
				set_input_value(input, /*email*/ ctx[1]);
				insert(target, t1, anchor);
				mount_component(percsbutton0, target, anchor);
				insert(target, t2, anchor);
				mount_component(percsbutton1, target, anchor);
				current = true;

				if (!mounted) {
					dispose = listen(input, "input", /*input_input_handler*/ ctx[11]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (!current || dirty & /*$state*/ 8 && input_disabled_value !== (input_disabled_value = /*$state*/ ctx[3].matches("modal.open.email-gate.submit"))) {
					input.disabled = input_disabled_value;
				}

				if (dirty & /*email*/ 2 && input.value !== /*email*/ ctx[1]) {
					set_input_value(input, /*email*/ ctx[1]);
				}

				const percsbutton0_changes = {};
				if (dirty & /*$state, email*/ 10) percsbutton0_changes.disabled = /*$state*/ ctx[3].matches("modal.open.email-gate.submit") || !/*email*/ ctx[1];

				if (dirty & /*$$scope, $state*/ 16392) {
					percsbutton0_changes.$$scope = { dirty, ctx };
				}

				percsbutton0.$set(percsbutton0_changes);
				const percsbutton1_changes = {};

				if (dirty & /*$$scope*/ 16384) {
					percsbutton1_changes.$$scope = { dirty, ctx };
				}

				percsbutton1.$set(percsbutton1_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogillustration.$$.fragment, local);
				transition_in(percsbutton0.$$.fragment, local);
				transition_in(percsbutton1.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogillustration.$$.fragment, local);
				transition_out(percsbutton0.$$.fragment, local);
				transition_out(percsbutton1.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogillustration, detaching);
				if (detaching) detach(t0);
				if (detaching) detach(input);
				if (detaching) detach(t1);
				destroy_component(percsbutton0, detaching);
				if (detaching) detach(t2);
				destroy_component(percsbutton1, detaching);
				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$L(ctx) {
		let percsdialogheader;
		let t;
		let form;
		let percsdialogcontent;
		let current;
		let mounted;
		let dispose;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: /*title*/ ctx[8] || "Get Access",
					modifiers: "email-gate",
					$$slots: { default: [create_default_slot_3$d] },
					$$scope: { ctx }
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[10]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "email-gate",
					$$slots: { default: [create_default_slot$t] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				form = element("form");
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				insert(target, form, anchor);
				mount_component(percsdialogcontent, form, null);
				current = true;

				if (!mounted) {
					dispose = listen(form, "submit", prevent_default(/*handleDismiss*/ ctx[9]));
					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];

				if (dirty & /*$$scope, $state, tagsList*/ 16396) {
					percsdialogheader_changes.$$scope = { dirty, ctx };
				}

				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, $state, email*/ 16394) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				if (detaching) detach(form);
				destroy_component(percsdialogcontent);
				mounted = false;
				dispose();
			}
		};
	}

	function instance$L($$self, $$props, $$invalidate) {
		let tagsList;

		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(3, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		/** @type {string} */
		let email = "";

		const { illustration, description, cta, declineCta, title, commaSeparatedTags } = $state.context.gate || {};

		/** @type {number} */
		let mountedAt;

		onMount(() => {
			mountedAt = Date.now();
		});

		function handleDismiss() {
			const data = {
				...email ? { email } : {},
				timeSpentSeconds: (Date.now() - mountedAt) / 1000
			};

			state.send("EMAIL_GATE_SUBMIT", data);
		}

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		function input_input_handler() {
			email = this.value;
			$$invalidate(1, email);
		}

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		$$invalidate(2, tagsList = commaSeparatedTags?.split(", ").map(tag => `[${tag}]`).join(", "));

		return [
			state,
			email,
			tagsList,
			$state,
			illustration,
			description,
			cta,
			declineCta,
			title,
			handleDismiss,
			close_handler,
			input_input_handler
		];
	}

	class EmailGate extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$L, create_fragment$L, safe_not_equal, { state: 0 }, add_css$y);
		}
	}

	/* dist/components/dialog-contents/EmailGateSuccess.svelte generated by Svelte v3.59.2 */

	function create_default_slot_2$i(ctx) {
		let span;

		return {
			c() {
				span = element("span");
				span.textContent = "We'll reach out to you when we find a good deal.";
			},
			m(target, anchor) {
				insert(target, span, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(span);
			}
		};
	}

	// (23:2) <PercsButton     as="a"     variant="flat"     href={dealLink}     target="_blank"   >
	function create_default_slot_1$o(ctx) {
		let t;

		return {
			c() {
				t = text(/*cta*/ ctx[3]);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (21:0) <PercsDialogContent modifiers="email-gate">
	function create_default_slot$s(ctx) {
		let percsdialogillustration;
		let t;
		let percsbutton;
		let current;

		percsdialogillustration = new PercsDialogIllustration({
				props: {
					src: /*illustration*/ ctx[1],
					alt: /*description*/ ctx[2]
				}
			});

		percsbutton = new PercsButton({
				props: {
					as: "a",
					variant: "flat",
					href: /*dealLink*/ ctx[4],
					target: "_blank",
					$$slots: { default: [create_default_slot_1$o] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogillustration.$$.fragment);
				t = space();
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogillustration, target, anchor);
				insert(target, t, anchor);
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 128) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogillustration.$$.fragment, local);
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogillustration.$$.fragment, local);
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogillustration, detaching);
				if (detaching) detach(t);
				destroy_component(percsbutton, detaching);
			}
		};
	}

	function create_fragment$K(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Thank you",
					modifiers: "email-gate",
					$$slots: { default: [create_default_slot_2$i] },
					$$scope: { ctx }
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[5]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "email-gate",
					$$slots: { default: [create_default_slot$s] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];

				if (dirty & /*$$scope*/ 128) {
					percsdialogheader_changes.$$scope = { dirty, ctx };
				}

				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope*/ 128) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$K($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(6, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();
		const { illustration, description, cta, dealLink } = $state.context.gate || {};

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [state, illustration, description, cta, dealLink, close_handler];
	}

	class EmailGateSuccess extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$K, create_fragment$K, safe_not_equal, { state: 0 });
		}
	}

	/* dist/components/dialog-contents/OfferEmpty.svelte generated by Svelte v3.59.2 */

	function add_css$x(target) {
		append_styles(target, "svelte-cgt4t9", ".offer-list__title{color:#161b5d;font-size:24px;font-weight:bold;text-align:center;text-transform:uppercase;width:80%;max-width:250px;margin:0 auto}");
	}

	// (23:0) <PercsDialogContent>
	function create_default_slot$r(ctx) {
		let h2;
		let t;

		return {
			c() {
				h2 = element("h2");
				t = text(/*message*/ ctx[1]);
				attr(h2, "class", "offer-list__title");
			},
			m(target, anchor) {
				insert(target, h2, anchor);
				append(h2, t);
			},
			p(ctx, dirty) {
				if (dirty & /*message*/ 2) set_data(t, /*message*/ ctx[1]);
			},
			d(detaching) {
				if (detaching) detach(h2);
			}
		};
	}

	function create_fragment$J(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: { state: /*state*/ ctx[0], text: "Offers" }
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[3]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot$r] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];
				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, message*/ 18) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$J($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(2, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		/** @type {string} */
		let message;

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*$state*/ 4) {
				{
					if ($state.context.offers.length === 0) {
						$$invalidate(1, message = "This offer is no longer available");
					} else if ($state.context.offers[0].type === "discount") {
						$$invalidate(1, message = "There are no discounts available");
					} else {
						$$invalidate(1, message = "You are not eligible for this offer");
					}
				}
			}
		};

		return [state, message, $state, close_handler];
	}

	class OfferEmpty extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$J, create_fragment$J, safe_not_equal, { state: 0 }, add_css$x);
		}
	}

	/* dist/components/dialog-contents/OfferError.svelte generated by Svelte v3.59.2 */

	function create_default_slot_1$n(ctx) {
		let t;

		return {
			c() {
				t = text("Retry");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (12:0) <PercsDialogContent modifiers="center">
	function create_default_slot$q(ctx) {
		let div;
		let span;
		let t0_value = /*$state*/ ctx[1].context.error.message + "";
		let t0;
		let t1;
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					autofocus: true,
					$$slots: { default: [create_default_slot_1$n] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[3]);

		return {
			c() {
				div = element("div");
				span = element("span");
				t0 = text(t0_value);
				t1 = space();
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, span);
				append(span, t0);
				insert(target, t1, anchor);
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if ((!current || dirty & /*$state*/ 2) && t0_value !== (t0_value = /*$state*/ ctx[1].context.error.message + "")) set_data(t0, t0_value);
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 16) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div);
				if (detaching) detach(t1);
				destroy_component(percsbutton, detaching);
			}
		};
	}

	function create_fragment$I(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: { state: /*state*/ ctx[0], text: "Error" }
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[2]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "center",
					$$slots: { default: [create_default_slot$q] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];
				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, $state*/ 19) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$I($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(1, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("RETRY");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [state, $state, close_handler, click_handler];
	}

	class OfferError extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$I, create_fragment$I, safe_not_equal, { state: 0 });
		}
	}

	var time$2 = readable(new Date(), (set) => {
	  set(new Date());
	  const interval = setInterval(
	    () => {
	      set(new Date());
	    },
	    1000,
	  );

	  return () => clearInterval(interval)
	});

	/* dist/components/internal/PercsCountdown.svelte generated by Svelte v3.59.2 */

	function add_css$w(target) {
		append_styles(target, "svelte-1fher6u", ".countdown.svelte-1fher6u{display:flex;justify-content:flex-start;gap:3px;align-items:center;color:#161B5D}span.svelte-1fher6u{line-height:1;margin-right:1px}");
	}

	// (23:2) {#if days > 0}
	function create_if_block_3$c(ctx) {
		let span;
		let t0;
		let t1;

		return {
			c() {
				span = element("span");
				t0 = text(/*days*/ ctx[3]);
				t1 = text("d");
				attr(span, "class", "svelte-1fher6u");
			},
			m(target, anchor) {
				insert(target, span, anchor);
				append(span, t0);
				append(span, t1);
			},
			p(ctx, dirty) {
				if (dirty & /*days*/ 8) set_data(t0, /*days*/ ctx[3]);
			},
			d(detaching) {
				if (detaching) detach(span);
			}
		};
	}

	// (26:2) {#if hours > 0}
	function create_if_block_2$f(ctx) {
		let span;
		let t0;
		let t1;

		return {
			c() {
				span = element("span");
				t0 = text(/*hours*/ ctx[2]);
				t1 = text("h");
				attr(span, "class", "svelte-1fher6u");
			},
			m(target, anchor) {
				insert(target, span, anchor);
				append(span, t0);
				append(span, t1);
			},
			p(ctx, dirty) {
				if (dirty & /*hours*/ 4) set_data(t0, /*hours*/ ctx[2]);
			},
			d(detaching) {
				if (detaching) detach(span);
			}
		};
	}

	// (29:2) {#if minutes > 0}
	function create_if_block_1$l(ctx) {
		let span;
		let t0;
		let t1;

		return {
			c() {
				span = element("span");
				t0 = text(/*minutes*/ ctx[1]);
				t1 = text("m");
				attr(span, "class", "svelte-1fher6u");
			},
			m(target, anchor) {
				insert(target, span, anchor);
				append(span, t0);
				append(span, t1);
			},
			p(ctx, dirty) {
				if (dirty & /*minutes*/ 2) set_data(t0, /*minutes*/ ctx[1]);
			},
			d(detaching) {
				if (detaching) detach(span);
			}
		};
	}

	// (32:2) {#if seconds > 0 && days <= 0}
	function create_if_block$p(ctx) {
		let span;
		let t0;
		let t1;

		return {
			c() {
				span = element("span");
				t0 = text(/*seconds*/ ctx[0]);
				t1 = text("s");
				attr(span, "class", "svelte-1fher6u");
			},
			m(target, anchor) {
				insert(target, span, anchor);
				append(span, t0);
				append(span, t1);
			},
			p(ctx, dirty) {
				if (dirty & /*seconds*/ 1) set_data(t0, /*seconds*/ ctx[0]);
			},
			d(detaching) {
				if (detaching) detach(span);
			}
		};
	}

	function create_fragment$H(ctx) {
		let div;
		let svg;
		let path0;
		let path1;
		let t0;
		let t1;
		let t2;
		let t3;
		let if_block0 = /*days*/ ctx[3] > 0 && create_if_block_3$c(ctx);
		let if_block1 = /*hours*/ ctx[2] > 0 && create_if_block_2$f(ctx);
		let if_block2 = /*minutes*/ ctx[1] > 0 && create_if_block_1$l(ctx);
		let if_block3 = /*seconds*/ ctx[0] > 0 && /*days*/ ctx[3] <= 0 && create_if_block$p(ctx);

		return {
			c() {
				div = element("div");
				svg = svg_element("svg");
				path0 = svg_element("path");
				path1 = svg_element("path");
				t0 = space();
				if (if_block0) if_block0.c();
				t1 = space();
				if (if_block1) if_block1.c();
				t2 = space();
				if (if_block2) if_block2.c();
				t3 = space();
				if (if_block3) if_block3.c();
				attr(path0, "d", "M8.5 1C4.63438 1 1.5 4.13438 1.5 8C1.5 11.8656 4.63438 15 8.5 15C12.3656 15 15.5 11.8656 15.5 8C15.5 4.13438 12.3656 1 8.5 1ZM8.5 13.8125C5.29063 13.8125 2.6875 11.2094 2.6875 8C2.6875 4.79063 5.29063 2.1875 8.5 2.1875C11.7094 2.1875 14.3125 4.79063 14.3125 8C14.3125 11.2094 11.7094 13.8125 8.5 13.8125Z");
				attr(path0, "fill", "#161B5D");
				attr(path1, "d", "M11.2297 9.97812L9.00156 8.36719V4.5C9.00156 4.43125 8.94531 4.375 8.87656 4.375H8.125C8.05625 4.375 8 4.43125 8 4.5V8.80313C8 8.84375 8.01875 8.88125 8.05156 8.90469L10.6359 10.7891C10.6922 10.8297 10.7703 10.8172 10.8109 10.7625L11.2578 10.1531C11.2984 10.0953 11.2859 10.0172 11.2297 9.97812Z");
				attr(path1, "fill", "#161B5D");
				attr(svg, "width", "17");
				attr(svg, "height", "16");
				attr(svg, "viewBox", "0 0 17 16");
				attr(svg, "fill", "#161B5D");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(svg, "data-testid", "countdown");
				attr(div, "class", "countdown svelte-1fher6u");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, svg);
				append(svg, path0);
				append(svg, path1);
				append(div, t0);
				if (if_block0) if_block0.m(div, null);
				append(div, t1);
				if (if_block1) if_block1.m(div, null);
				append(div, t2);
				if (if_block2) if_block2.m(div, null);
				append(div, t3);
				if (if_block3) if_block3.m(div, null);
			},
			p(ctx, [dirty]) {
				if (/*days*/ ctx[3] > 0) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_3$c(ctx);
						if_block0.c();
						if_block0.m(div, t1);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*hours*/ ctx[2] > 0) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_2$f(ctx);
						if_block1.c();
						if_block1.m(div, t2);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (/*minutes*/ ctx[1] > 0) {
					if (if_block2) {
						if_block2.p(ctx, dirty);
					} else {
						if_block2 = create_if_block_1$l(ctx);
						if_block2.c();
						if_block2.m(div, t3);
					}
				} else if (if_block2) {
					if_block2.d(1);
					if_block2 = null;
				}

				if (/*seconds*/ ctx[0] > 0 && /*days*/ ctx[3] <= 0) {
					if (if_block3) {
						if_block3.p(ctx, dirty);
					} else {
						if_block3 = create_if_block$p(ctx);
						if_block3.c();
						if_block3.m(div, null);
					}
				} else if (if_block3) {
					if_block3.d(1);
					if_block3 = null;
				}
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(div);
				if (if_block0) if_block0.d();
				if (if_block1) if_block1.d();
				if (if_block2) if_block2.d();
				if (if_block3) if_block3.d();
			}
		};
	}

	function instance$H($$self, $$props, $$invalidate) {
		let delta;
		let days;
		let hours;
		let minutes;
		let seconds;
		let $time;
		component_subscribe($$self, time$2, $$value => $$invalidate(6, $time = $$value));
		let { date } = $$props;

		$$self.$$set = $$props => {
			if ('date' in $$props) $$invalidate(4, date = $$props.date);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*date, $time*/ 80) {
				$$invalidate(5, delta = Math.max(0, Math.ceil((+date - +$time) / 1000)));
			}

			if ($$self.$$.dirty & /*delta*/ 32) {
				$$invalidate(3, days = Math.floor(delta / 86400));
			}

			if ($$self.$$.dirty & /*delta*/ 32) {
				$$invalidate(2, hours = Math.floor(delta % 86400 / 3600));
			}

			if ($$self.$$.dirty & /*delta*/ 32) {
				$$invalidate(1, minutes = Math.floor(delta % 3600 / 60));
			}

			if ($$self.$$.dirty & /*delta*/ 32) {
				$$invalidate(0, seconds = delta % 60);
			}
		};

		return [seconds, minutes, hours, days, date, delta, $time];
	}

	class PercsCountdown extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$H, create_fragment$H, safe_not_equal, { date: 4 }, add_css$w);
		}
	}

	/* dist/components/internal/PercsOfferItemCard.svelte generated by Svelte v3.59.2 */

	function add_css$v(target) {
		append_styles(target, "svelte-19y89rv", ":root{--container-background:inherit}.offer-item-card.svelte-19y89rv.svelte-19y89rv{border:2px solid var(--container-background);border-radius:8px;display:flex;flex-direction:column;background-color:transparent;padding:0px;box-sizing:border-box;max-width:200px;cursor:inherit}button.offer-item-card.svelte-19y89rv.svelte-19y89rv:hover,button.offer-item-card.svelte-19y89rv.svelte-19y89rv:focus,button.offer-item-card.svelte-19y89rv.svelte-19y89rv:active{opacity:0.9;cursor:pointer}.offer-item-card.svelte-19y89rv.svelte-19y89rv:disabled{opacity:0.7}.offer-item-card__availability.svelte-19y89rv.svelte-19y89rv{color:#161B5D;opacity:0.5;margin-top:4px;width:140px;text-align:left}.offer-item-card__content.svelte-19y89rv.svelte-19y89rv{height:35px;padding:12px 10px;display:flex;align-items:center;justify-content:flex-start;position:relative}.offer-item-card__content--disabled.svelte-19y89rv.svelte-19y89rv{margin:0px auto}.offer-item-card__community.svelte-19y89rv.svelte-19y89rv{height:36px;width:36px}.offer-item-card__community.svelte-19y89rv img.svelte-19y89rv{height:36px;width:36px;object-fit:cover;border-radius:100px;overflow:hidden}.offer-item-card__image.svelte-19y89rv.svelte-19y89rv{width:calc(100% + 2px);left:-1px;position:relative;top:-2px;overflow:hidden;border-top-left-radius:8px;border-top-right-radius:8px}.offer-item-card__image.svelte-19y89rv img.svelte-19y89rv{width:100%;height:100%;border-radius:8px}.flex.svelte-19y89rv.svelte-19y89rv{display:flex}.flex-col.svelte-19y89rv.svelte-19y89rv{flex-direction:column}.sold-out.svelte-19y89rv.svelte-19y89rv{color:#161B5D;font-weight:bold}.unlocked.svelte-19y89rv.svelte-19y89rv{display:flex;flex-direction:row;align-items:flex-end;justify-content:flex-start;text-align:left;gap:8px}.unlocked.svelte-19y89rv span.svelte-19y89rv{font-weight:400;font-size:20px;color:black;line-height:20px}.unlocked.svelte-19y89rv svg.svelte-19y89rv{height:24px;width:24px}");
	}

	// (53:2) {#if item.image}
	function create_if_block_5$6(ctx) {
		let div;

		function select_block_type(ctx, dirty) {
			if (/*item*/ ctx[0].image.src) return create_if_block_6$4;
			return create_else_block_2$2;
		}

		let current_block_type = select_block_type(ctx);
		let if_block = current_block_type(ctx);

		return {
			c() {
				div = element("div");
				if_block.c();
				attr(div, "class", "offer-item-card__image svelte-19y89rv");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				if_block.m(div, null);
			},
			p(ctx, dirty) {
				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(div, null);
					}
				}
			},
			d(detaching) {
				if (detaching) detach(div);
				if_block.d();
			}
		};
	}

	// (57:6) {:else}
	function create_else_block_2$2(ctx) {
		let svg;
		let path0;
		let mask;
		let path1;
		let g1;
		let rect;
		let rect_fill_value;
		let g0;
		let path2;
		let path3;
		let path4;
		let path5;
		let path6;
		let path7;
		let path8;
		let path9;
		let path10;
		let path11;
		let path12;
		let path13;
		let path14;
		let path15;
		let path16;
		let path17;
		let path18;
		let path19;
		let path20;
		let path21;
		let path22;
		let path23;
		let if_block = /*item*/ ctx[0].value && create_if_block_7$4(ctx);

		return {
			c() {
				svg = svg_element("svg");
				path0 = svg_element("path");
				mask = svg_element("mask");
				path1 = svg_element("path");
				g1 = svg_element("g");
				rect = svg_element("rect");
				g0 = svg_element("g");
				path2 = svg_element("path");
				path3 = svg_element("path");
				path4 = svg_element("path");
				path5 = svg_element("path");
				path6 = svg_element("path");
				path7 = svg_element("path");
				path8 = svg_element("path");
				path9 = svg_element("path");
				path10 = svg_element("path");
				path11 = svg_element("path");
				path12 = svg_element("path");
				path13 = svg_element("path");
				path14 = svg_element("path");
				path15 = svg_element("path");
				path16 = svg_element("path");
				path17 = svg_element("path");
				path18 = svg_element("path");
				path19 = svg_element("path");
				path20 = svg_element("path");
				path21 = svg_element("path");
				path22 = svg_element("path");
				path23 = svg_element("path");
				if (if_block) if_block.c();
				attr(path0, "fill-rule", "evenodd");
				attr(path0, "clip-rule", "evenodd");
				attr(path0, "d", "M-72.7552 3.24476L-76 0L272 0L268.755 3.24476L272 6.48951L268.755 9.73427L272 12.979L268.755 16.2238L272 19.4685L268.755 22.7133L272 25.958L268.755 29.2028L272 32.4476L268.755 35.6923L272 38.9371L268.755 42.1818L272 45.4266L268.755 48.6713L271.849 51.7653C252.459 51.8465 236.765 67.5906 236.765 87C236.765 106.409 252.459 122.154 271.849 122.235L268.755 125.329L272 128.573L268.755 131.818L272 135.063L268.755 138.308L272 141.552L268.755 144.797L272 148.042L268.755 151.287L272 154.531L268.755 157.776L272 161.021L268.755 164.266L272 167.51L268.755 170.755L272 174H-76L-72.7552 170.755L-76 167.51L-72.7552 164.266L-76 161.021L-72.7552 157.776L-76 154.531L-72.7552 151.287L-76 148.042L-72.7552 144.797L-76 141.552L-72.7552 138.308L-76 135.063L-72.7552 131.818L-76 128.573L-72.7552 125.329L-75.8493 122.235C-56.4588 122.154 -40.765 106.409 -40.765 87C-40.765 67.5906 -56.4588 51.8465 -75.8493 51.7653L-72.7552 48.6713L-76 45.4266L-72.7552 42.1818L-76 38.9371L-72.7552 35.6923L-76 32.4476L-72.7552 29.2028L-76 25.958L-72.7552 22.7133L-76 19.4685L-72.7552 16.2238L-76 12.979L-72.7552 9.73427L-76 6.48951L-72.7552 3.24476Z");
				attr(path0, "fill", "#F2F2F0");
				attr(path1, "fill-rule", "evenodd");
				attr(path1, "clip-rule", "evenodd");
				attr(path1, "d", "M-72.7552 3.24476L-76 0L272 0L268.755 3.24476L272 6.48951L268.755 9.73427L272 12.979L268.755 16.2238L272 19.4685L268.755 22.7133L272 25.958L268.755 29.2028L272 32.4476L268.755 35.6923L272 38.9371L268.755 42.1818L272 45.4266L268.755 48.6713L271.849 51.7653C252.459 51.8465 236.765 67.5906 236.765 87C236.765 106.409 252.459 122.154 271.849 122.235L268.755 125.329L272 128.573L268.755 131.818L272 135.063L268.755 138.308L272 141.552L268.755 144.797L272 148.042L268.755 151.287L272 154.531L268.755 157.776L272 161.021L268.755 164.266L272 167.51L268.755 170.755L272 174H-76L-72.7552 170.755L-76 167.51L-72.7552 164.266L-76 161.021L-72.7552 157.776L-76 154.531L-72.7552 151.287L-76 148.042L-72.7552 144.797L-76 141.552L-72.7552 138.308L-76 135.063L-72.7552 131.818L-76 128.573L-72.7552 125.329L-75.8493 122.235C-56.4588 122.154 -40.765 106.409 -40.765 87C-40.765 67.5906 -56.4588 51.8465 -75.8493 51.7653L-72.7552 48.6713L-76 45.4266L-72.7552 42.1818L-76 38.9371L-72.7552 35.6923L-76 32.4476L-72.7552 29.2028L-76 25.958L-72.7552 22.7133L-76 19.4685L-72.7552 16.2238L-76 12.979L-72.7552 9.73427L-76 6.48951L-72.7552 3.24476Z");
				attr(path1, "fill", "#F2F2F0");
				attr(mask, "id", "mask0_743_28802");
				set_style(mask, "mask-type", "alpha");
				attr(mask, "maskUnits", "userSpaceOnUse");
				attr(mask, "x", "-76");
				attr(mask, "y", "0");
				attr(mask, "width", "348");
				attr(mask, "height", "174");
				attr(rect, "x", "0");
				attr(rect, "y", "0");
				attr(rect, "width", "200");
				attr(rect, "height", "158");
				attr(rect, "fill", rect_fill_value = /*item*/ ctx[0].image["background-color"]);
				attr(path2, "d", "M7.8059 115.777C7.22794 116.927 5.31665 115.492 3.71932 113.891C2.51555 112.685 0.64073 112.283 -0.84086 113.126C-2.02684 113.8 -2.72602 115.154 -2.11798 116.376C-1.38954 117.839 -0.239116 119.152 0.693422 120.03C1.15494 120.465 1.312 121.151 1.02726 121.718C0.697356 122.374 0.961998 123.174 1.61835 123.504L3.24145 124.319L3.2488 124.323C3.84263 124.622 4.3228 124.863 4.62175 124.268C4.92193 123.671 5.8935 122.955 6.52746 123.167C10.8766 124.62 14.4564 121.618 15.5917 119.691C18.8505 114.285 10.8473 110.804 11.9344 108.641C12.4041 107.707 13.0776 107.809 13.7398 108.367C15.2743 109.661 17.4677 110.64 19.1635 109.566C20.0547 109.001 20.5826 107.994 20.106 107.053C19.4352 105.729 18.1837 104.205 17.0572 103.269C16.5432 102.842 16.3039 102.104 16.6041 101.507C16.9043 100.909 16.6635 100.182 16.0663 99.8818L15.5085 99.6014C14.7071 99.1987 13.7321 99.4342 13.2031 100.158L13.1707 100.203C12.6981 100.85 11.8715 101.113 11.0837 100.966C7.72894 100.341 5.74519 101.552 4.58342 103.863C1.5397 109.919 8.91447 113.572 7.8059 115.777Z");
				attr(path2, "fill", "#F2F2F0");
				attr(path2, "stroke", "black");
				attr(path2, "stroke-width", "1.24289");
				attr(path3, "d", "M92.0168 144.149C91.4389 145.299 89.5276 143.864 87.9303 142.263C86.7265 141.056 84.8517 140.655 83.3701 141.497C82.1841 142.172 81.4849 143.526 82.093 144.747C82.8214 146.21 83.9718 147.523 84.9044 148.402C85.3659 148.837 85.5229 149.523 85.2382 150.089C84.9083 150.746 85.1729 151.545 85.8293 151.875L87.4524 152.691L87.4597 152.695C88.0536 152.993 88.5337 153.235 88.8327 152.64C89.1329 152.043 90.1044 151.327 90.7384 151.539C95.0875 152.992 98.6673 149.99 99.8026 148.062C103.061 142.656 95.0583 139.176 96.1453 137.013C96.6151 136.078 97.2885 136.18 97.9507 136.739C99.4852 138.033 101.679 139.012 103.374 137.937C104.266 137.373 104.794 136.366 104.317 135.425C103.646 134.1 102.395 132.576 101.268 131.64C100.754 131.213 100.515 130.475 100.815 129.878C101.115 129.281 100.874 128.554 100.277 128.253L99.7194 127.973C98.9181 127.57 97.943 127.806 97.414 128.53L97.3817 128.574C96.909 129.221 96.0824 129.485 95.2947 129.338C91.9399 128.713 89.9561 129.923 88.7944 132.235C85.7506 138.29 93.1254 141.943 92.0168 144.149Z");
				attr(path3, "fill", "#F2F2F0");
				attr(path3, "stroke", "black");
				attr(path3, "stroke-width", "1.24289");
				attr(path4, "d", "M177.065 169.681C176.487 170.831 174.575 169.396 172.978 167.795C171.774 166.588 169.9 166.187 168.418 167.03C167.232 167.704 166.533 169.058 167.141 170.28C167.869 171.743 169.02 173.056 169.952 173.934C170.414 174.369 170.571 175.055 170.286 175.622C169.956 176.278 170.221 177.077 170.877 177.407L172.5 178.223L172.508 178.227C173.101 178.525 173.582 178.767 173.881 178.172C174.181 177.575 175.152 176.859 175.786 177.071C180.135 178.524 183.715 175.522 184.85 173.594C188.109 168.189 180.106 164.708 181.193 162.545C181.663 161.611 182.336 161.712 182.999 162.271C184.533 163.565 186.726 164.544 188.422 163.47C189.313 162.905 189.841 161.898 189.365 160.957C188.694 159.633 187.442 158.109 186.316 157.173C185.802 156.745 185.563 156.008 185.863 155.41C186.163 154.813 185.922 154.086 185.325 153.786L184.767 153.505C183.966 153.102 182.991 153.338 182.462 154.062L182.43 154.107C181.957 154.754 181.13 155.017 180.343 154.87C176.988 154.245 175.004 155.455 173.842 157.767C170.798 163.822 178.173 167.475 177.065 169.681Z");
				attr(path4, "fill", "#F2F2F0");
				attr(path4, "stroke", "black");
				attr(path4, "stroke-width", "1.24289");
				attr(path5, "d", "M59.2929 104.833C59.2611 106.12 56.9202 105.638 54.7922 104.872C53.1886 104.295 51.3218 104.732 50.3417 106.126C49.5571 107.242 49.5029 108.766 50.5741 109.611C51.8574 110.623 53.4582 111.319 54.6765 111.715C55.2795 111.911 55.7144 112.465 55.6988 113.099C55.6806 113.833 56.2612 114.443 56.9956 114.461L58.8117 114.506L58.8199 114.506C59.4843 114.523 60.0216 114.536 60.038 113.871C60.0545 113.202 60.6276 112.141 61.2914 112.062C65.8446 111.519 67.8002 107.276 68.0041 105.048C68.6436 98.7688 59.9204 99.0374 59.9802 96.6176C60.006 95.5719 60.6585 95.3765 61.4957 95.5989C63.4358 96.1141 65.8372 96.063 66.9122 94.3678C67.4771 93.4769 67.5246 92.3406 66.6918 91.693C65.5199 90.7818 63.7376 89.9379 62.3193 89.5722C61.6721 89.4054 61.1409 88.8405 61.1574 88.1723C61.1739 87.5041 60.6456 86.949 59.9774 86.9325L59.3533 86.917C58.4567 86.8949 57.6755 87.5241 57.5063 88.4049L57.4959 88.4587C57.3447 89.2456 56.7097 89.8368 55.9346 90.0402C52.6339 90.9067 51.3567 92.8483 51.2928 95.4344C51.1253 102.21 59.3539 102.365 59.2929 104.833Z");
				attr(path5, "fill", "#F2F2F0");
				attr(path5, "stroke", "black");
				attr(path5, "stroke-width", "1.24289");
				attr(path6, "d", "M144.471 129.927C144.439 131.214 142.098 130.732 139.97 129.966C138.366 129.389 136.5 129.826 135.519 131.221C134.735 132.337 134.681 133.86 135.752 134.705C137.035 135.717 138.636 136.413 139.854 136.81C140.457 137.006 140.892 137.559 140.877 138.193C140.858 138.927 141.439 139.537 142.173 139.556L143.989 139.6L143.998 139.601C144.662 139.617 145.199 139.63 145.216 138.965C145.232 138.297 145.805 137.235 146.469 137.156C151.022 136.613 152.978 132.37 153.182 130.143C153.821 123.863 145.098 124.132 145.158 121.712C145.184 120.666 145.836 120.471 146.673 120.693C148.613 121.208 151.015 121.157 152.09 119.462C152.655 118.571 152.702 117.435 151.87 116.787C150.698 115.876 148.915 115.032 147.497 114.666C146.85 114.5 146.319 113.935 146.335 113.266C146.352 112.598 145.823 112.043 145.155 112.027L144.531 112.011C143.634 111.989 142.853 112.618 142.684 113.499L142.674 113.553C142.522 114.34 141.887 114.931 141.112 115.134C137.812 116.001 136.534 117.943 136.471 120.529C136.303 127.304 144.532 127.46 144.471 129.927Z");
				attr(path6, "fill", "#F2F2F0");
				attr(path6, "stroke", "black");
				attr(path6, "stroke-width", "1.24289");
				attr(path7, "d", "M33.5266 28.475C32.9486 29.6248 31.0374 28.19 29.44 26.5889C28.2363 25.3824 26.3614 24.981 24.8798 25.8235C23.6939 26.4979 22.9947 27.8521 23.6027 29.0735C24.3312 30.5366 25.4816 31.8496 26.4141 32.7281C26.8756 33.1628 27.0327 33.849 26.748 34.4155C26.4181 35.0719 26.6827 35.8714 27.3391 36.2013L28.9622 37.0171L28.9695 37.0208C29.5633 37.3193 30.0435 37.5607 30.3424 36.9659C30.6426 36.3687 31.6142 35.6531 32.2482 35.8649C36.5973 37.318 40.1771 34.3158 41.3124 32.3883C44.5712 26.9827 36.568 23.5019 37.6551 21.3391C38.1248 20.4045 38.7983 20.5063 39.4605 21.0648C40.995 22.3589 43.1884 23.3378 44.8842 22.2637C45.7754 21.6992 46.3033 20.6919 45.8267 19.7508C45.1559 18.4265 43.9044 16.9025 42.7779 15.9665C42.2639 15.5393 42.0246 14.8017 42.3248 14.2044C42.625 13.6072 42.3842 12.8797 41.787 12.5796L41.2292 12.2992C40.4278 11.8964 39.4528 12.132 38.9238 12.8562L38.8914 12.9005C38.4188 13.5476 37.5922 13.811 36.8044 13.6642C33.4496 13.0387 31.4659 14.2493 30.3041 16.5607C27.2604 22.6163 34.6352 26.2694 33.5266 28.475Z");
				attr(path7, "fill", "#F2F2F0");
				attr(path7, "stroke", "black");
				attr(path7, "stroke-width", "1.24289");
				attr(path8, "d", "M117.738 56.8465C117.16 57.9964 115.248 56.5616 113.651 54.9605C112.447 53.7539 110.572 53.3526 109.091 54.1951C107.905 54.8695 107.206 56.2237 107.814 57.445C108.542 58.9082 109.693 60.2212 110.625 61.0996C111.087 61.5344 111.244 62.2206 110.959 62.7871C110.629 63.4435 110.894 64.243 111.55 64.5729L113.173 65.3887L113.18 65.3924C113.774 65.6909 114.254 65.9323 114.553 65.3375C114.854 64.7403 115.825 64.0247 116.459 64.2365C120.808 65.6896 124.388 62.6873 125.523 60.7599C128.782 55.3542 120.779 51.8734 121.866 49.7107C122.336 48.7761 123.009 48.8779 123.671 49.4364C125.206 50.7305 127.399 51.7094 129.095 50.6352C129.986 50.0708 130.514 49.0635 130.038 48.1224C129.367 46.7981 128.115 45.2741 126.989 44.338C126.475 43.9108 126.236 43.1732 126.536 42.576C126.836 41.9788 126.595 41.2513 125.998 40.9511L125.44 40.6708C124.639 40.268 123.664 40.5036 123.135 41.2278L123.102 41.2721C122.63 41.9191 121.803 42.1826 121.015 42.0358C117.661 41.4103 115.677 42.6209 114.515 44.9323C111.471 50.9879 118.846 54.641 117.738 56.8465Z");
				attr(path8, "fill", "#F2F2F0");
				attr(path8, "stroke", "black");
				attr(path8, "stroke-width", "1.24289");
				attr(path9, "d", "M202.785 82.3788C202.207 83.5286 200.296 82.0938 198.699 80.4928C197.495 79.2862 195.62 78.8848 194.139 79.7273C192.953 80.4017 192.253 81.7559 192.862 82.9773C193.59 84.4404 194.74 85.7534 195.673 86.6319C196.134 87.0666 196.291 87.7529 196.007 88.3194C195.677 88.9757 195.941 89.7752 196.598 90.1051L198.221 90.9209L198.228 90.9246C198.822 91.2231 199.302 91.4645 199.601 90.8697C199.901 90.2725 200.873 89.5569 201.507 89.7687C205.856 91.2218 209.436 88.2196 210.571 86.2921C213.83 80.8865 205.827 77.4057 206.914 75.2429C207.384 74.3083 208.057 74.4101 208.719 74.9686C210.254 76.2627 212.447 77.2416 214.143 76.1675C215.034 75.603 215.562 74.5957 215.085 73.6546C214.415 72.3303 213.163 70.8063 212.037 69.8703C211.523 69.4431 211.283 68.7055 211.584 68.1082C211.884 67.511 211.643 66.7835 211.046 66.4834L210.488 66.203C209.687 65.8002 208.712 66.0358 208.183 66.76L208.15 66.8043C207.678 67.4514 206.851 67.7149 206.063 67.568C202.708 66.9425 200.725 68.1531 199.563 70.4645C196.519 76.5201 203.894 80.1732 202.785 82.3788Z");
				attr(path9, "fill", "#F2F2F0");
				attr(path9, "stroke", "black");
				attr(path9, "stroke-width", "1.24289");
				attr(path10, "d", "M-0.163192 -7.56397C-0.194989 -6.27742 -2.53588 -6.75906 -4.66382 -7.52505C-6.26747 -8.10231 -8.13422 -7.66495 -9.11439 -6.27061C-9.899 -5.15447 -9.95318 -3.63136 -8.88195 -2.78646C-7.59863 -1.77426 -5.99781 -1.07802 -4.77952 -0.681704C-4.17658 -0.485566 -3.74161 0.0679568 -3.75727 0.7018C-3.77542 1.43618 -3.19481 2.04622 -2.46043 2.06437L-0.644396 2.10925L-0.63617 2.10946C0.0282537 2.12589 0.565504 2.13918 0.581951 1.47371C0.598466 0.8055 1.17159 -0.256378 1.83531 -0.335452C6.38856 -0.877922 8.34419 -5.12103 8.54809 -7.34867C9.18754 -13.6282 0.464303 -13.3595 0.524109 -15.7793C0.549953 -16.825 1.20242 -17.0204 2.03962 -16.7981C3.97971 -16.2829 6.38112 -16.334 7.4561 -18.0292C8.02104 -18.9201 8.0685 -20.0564 7.23571 -20.704C6.06383 -21.6152 4.28152 -22.4591 2.86327 -22.8247C2.21602 -22.9916 1.68483 -23.5565 1.70135 -24.2247C1.71786 -24.8929 1.18956 -25.448 0.521352 -25.4645L-0.102797 -25.4799C-0.999352 -25.5021 -1.78052 -24.8728 -1.94977 -23.9921L-1.96012 -23.9382C-2.11135 -23.1513 -2.74636 -22.5602 -3.52142 -22.3567C-6.82219 -21.4903 -8.09933 -19.5487 -8.16325 -16.9626C-8.33071 -10.1871 -0.102201 -10.0317 -0.163192 -7.56397Z");
				attr(path10, "fill", "#F2F2F0");
				attr(path10, "stroke", "black");
				attr(path10, "stroke-width", "1.24289");
				attr(path11, "d", "M85.0145 17.5303C84.9827 18.8168 82.6419 18.3352 80.5139 17.5692C78.9103 16.9919 77.0435 17.4293 76.0633 18.8236C75.2787 19.9398 75.2246 21.4629 76.2958 22.3078C77.5791 23.32 79.1799 24.0162 80.3982 24.4125C81.0012 24.6087 81.4361 25.1622 81.4205 25.796C81.4023 26.5304 81.9829 27.1405 82.7173 27.1586L84.5333 27.2035L84.5416 27.2037C85.206 27.2201 85.7432 27.2334 85.7597 26.5679C85.7762 25.8997 86.3493 24.8379 87.013 24.7588C91.5663 24.2163 93.5219 19.9732 93.7258 17.7456C94.3653 11.466 85.642 11.7347 85.7018 9.31491C85.7277 8.26921 86.3802 8.07379 87.2174 8.29614C89.1574 8.81138 91.5589 8.76027 92.6338 7.06503C93.1988 6.17412 93.2462 5.03786 92.4134 4.39028C91.2416 3.47902 89.4593 2.63513 88.041 2.26951C87.3938 2.10265 86.8626 1.53774 86.8791 0.869527C86.8956 0.201317 86.3673 -0.353761 85.6991 -0.370276L85.0749 -0.385702C84.1784 -0.407861 83.3972 0.221404 83.228 1.10212L83.2176 1.15599C83.0664 1.94291 82.4314 2.53404 81.6563 2.7375C78.3555 3.60397 77.0784 5.54554 77.0145 8.13169C76.847 14.9071 85.0755 15.0625 85.0145 17.5303Z");
				attr(path11, "fill", "#F2F2F0");
				attr(path11, "stroke", "black");
				attr(path11, "stroke-width", "1.24289");
				attr(path12, "d", "M170.19 42.625C170.159 43.9115 167.818 43.4299 165.69 42.6639C164.086 42.0867 162.219 42.524 161.239 43.9183C160.455 45.0345 160.4 46.5576 161.472 47.4025C162.755 48.4147 164.356 49.1109 165.574 49.5073C166.177 49.7034 166.612 50.2569 166.596 50.8908C166.578 51.6251 167.159 52.2352 167.893 52.2533L169.709 52.2982L169.717 52.2984C170.382 52.3149 170.919 52.3281 170.935 51.6627C170.952 50.9945 171.525 49.9326 172.189 49.8535C176.742 49.311 178.698 45.0679 178.902 42.8403C179.541 36.5608 170.818 36.8294 170.878 34.4096C170.903 33.3639 171.556 33.1685 172.393 33.3909C174.333 33.9061 176.735 33.855 177.81 32.1598C178.375 31.2688 178.422 30.1326 177.589 29.485C176.417 28.5737 174.635 27.7299 173.217 27.3642C172.57 27.1974 172.038 26.6325 172.055 25.9643C172.071 25.296 171.543 24.741 170.875 24.7245L170.251 24.709C169.354 24.6869 168.573 25.3161 168.404 26.1968L168.393 26.2507C168.242 27.0376 167.607 27.6288 166.832 27.8322C163.531 28.6987 162.254 30.6403 162.19 33.2264C162.023 40.0019 170.251 40.1573 170.19 42.625Z");
				attr(path12, "fill", "#F2F2F0");
				attr(path12, "stroke", "black");
				attr(path12, "stroke-width", "1.24289");
				attr(path13, "d", "M-5.05446 159.429C-5.63241 160.578 -7.5437 159.144 -9.14103 157.543C-10.3448 156.336 -12.2196 155.935 -13.7012 156.777C-14.8872 157.452 -15.5864 158.806 -14.9783 160.027C-14.2499 161.49 -13.0995 162.803 -12.1669 163.682C-11.7054 164.116 -11.5484 164.803 -11.8331 165.369C-12.163 166.026 -11.8984 166.825 -11.242 167.155L-9.6189 167.971L-9.61155 167.974C-9.01772 168.273 -8.53755 168.514 -8.23861 167.92C-7.93843 167.322 -6.96685 166.607 -6.33289 166.819C-1.98377 168.272 1.59601 165.269 2.73133 163.342C5.99018 157.936 -2.01301 154.455 -0.925965 152.293C-0.456208 151.358 0.21724 151.46 0.879416 152.018C2.41391 153.313 4.60734 154.291 6.30312 153.217C7.19432 152.653 7.72227 151.646 7.24561 150.704C6.57487 149.38 5.32335 147.856 4.19689 146.92C3.6828 146.493 3.44359 145.755 3.74377 145.158C4.04395 144.561 3.80315 143.833 3.20594 143.533L2.6481 143.253C1.84679 142.85 0.871759 143.086 0.342748 143.81L0.310389 143.854C-0.162285 144.501 -0.988878 144.765 -1.77662 144.618C-5.13141 143.992 -7.11516 145.203 -8.27693 147.514C-11.3207 153.57 -3.94589 157.223 -5.05446 159.429Z");
				attr(path13, "fill", "#F2F2F0");
				attr(path13, "stroke", "black");
				attr(path13, "stroke-width", "1.24289");
				attr(path14, "d", "M79.1565 187.801C78.5785 188.951 76.6672 187.516 75.0699 185.915C73.8661 184.708 71.9913 184.307 70.5097 185.149C69.3237 185.824 68.6246 187.178 69.2326 188.399C69.961 189.862 71.1115 191.175 72.044 192.054C72.5055 192.488 72.6626 193.175 72.3778 193.741C72.0479 194.398 72.3126 195.197 72.9689 195.527L74.592 196.343L74.5994 196.347C75.1932 196.645 75.6734 196.886 75.9723 196.292C76.2725 195.694 77.2441 194.979 77.8781 195.191C82.2272 196.644 85.8069 193.641 86.9423 191.714C90.2011 186.308 82.1979 182.828 83.285 180.665C83.7547 179.73 84.4282 179.832 85.0904 180.39C86.6248 181.685 88.8183 182.663 90.5141 181.589C91.4053 181.025 91.9332 180.018 91.4566 179.076C90.7858 177.752 89.5343 176.228 88.4078 175.292C87.8937 174.865 87.6545 174.127 87.9547 173.53C88.2549 172.933 88.0141 172.205 87.4169 171.905L86.859 171.625C86.0577 171.222 85.0827 171.458 84.5537 172.182L84.5213 172.226C84.0487 172.873 83.2221 173.137 82.4343 172.99C79.0795 172.364 77.0958 173.575 75.934 175.886C72.8903 181.942 80.2651 185.595 79.1565 187.801Z");
				attr(path14, "fill", "#F2F2F0");
				attr(path14, "stroke", "black");
				attr(path14, "stroke-width", "1.24289");
				attr(path15, "d", "M46.4335 148.484C46.4017 149.771 44.0608 149.289 41.9329 148.523C40.3292 147.946 38.4625 148.383 37.4823 149.778C36.6977 150.894 36.6435 152.417 37.7147 153.262C38.998 154.274 40.5989 154.97 41.8172 155.367C42.4201 155.563 42.8551 156.116 42.8394 156.75C42.8213 157.485 43.4019 158.095 44.1362 158.113L45.9523 158.158L45.9605 158.158C46.6249 158.174 47.1622 158.188 47.1786 157.522C47.1951 156.854 47.7683 155.792 48.432 155.713C52.9852 155.17 54.9409 150.927 55.1448 148.7C55.7842 142.42 47.061 142.689 47.1208 140.269C47.1466 139.223 47.7991 139.028 48.6363 139.25C50.5764 139.765 52.9778 139.714 54.0528 138.019C54.6177 137.128 54.6652 135.992 53.8324 135.344C52.6605 134.433 50.8782 133.589 49.4599 133.224C48.8127 133.057 48.2815 132.492 48.298 131.824C48.3145 131.155 47.7862 130.6 47.118 130.584L46.4939 130.568C45.5973 130.546 44.8162 131.176 44.6469 132.056L44.6366 132.11C44.4853 132.897 43.8503 133.488 43.0753 133.692C39.7745 134.558 38.4973 136.5 38.4334 139.086C38.266 145.861 46.4945 146.017 46.4335 148.484Z");
				attr(path15, "fill", "#F2F2F0");
				attr(path15, "stroke", "black");
				attr(path15, "stroke-width", "1.24289");
				attr(path16, "d", "M131.61 173.579C131.578 174.865 129.238 174.384 127.11 173.618C125.506 173.04 123.639 173.478 122.659 174.872C121.874 175.988 121.82 177.511 122.891 178.356C124.175 179.368 125.776 180.065 126.994 180.461C127.597 180.657 128.032 181.211 128.016 181.844C127.998 182.579 128.579 183.189 129.313 183.207L131.129 183.252L131.137 183.252C131.802 183.268 132.339 183.282 132.355 182.616C132.372 181.948 132.945 180.886 133.609 180.807C138.162 180.265 140.118 176.022 140.322 173.794C140.961 167.514 132.238 167.783 132.298 165.363C132.323 164.318 132.976 164.122 133.813 164.344C135.753 164.86 138.155 164.809 139.23 163.113C139.794 162.222 139.842 161.086 139.009 160.439C137.837 159.527 136.055 158.683 134.637 158.318C133.989 158.151 133.458 157.586 133.475 156.918C133.491 156.25 132.963 155.695 132.295 155.678L131.671 155.663C130.774 155.64 129.993 156.27 129.824 157.15L129.813 157.204C129.662 157.991 129.027 158.582 128.252 158.786C124.951 159.652 123.674 161.594 123.61 164.18C123.443 170.955 131.671 171.111 131.61 173.579Z");
				attr(path16, "fill", "#F2F2F0");
				attr(path16, "stroke", "black");
				attr(path16, "stroke-width", "1.24289");
				attr(path17, "d", "M20.6662 72.1263C20.0883 73.2762 18.177 71.8414 16.5797 70.2403C15.3759 69.0337 13.5011 68.6324 12.0195 69.4749C10.8335 70.1493 10.1343 71.5035 10.7424 72.7248C11.4708 74.188 12.6212 75.501 13.5538 76.3794C14.0153 76.8142 14.1724 77.5004 13.8876 78.0669C13.5577 78.7233 13.8223 79.5228 14.4787 79.8527L16.1018 80.6685L16.1092 80.6722C16.703 80.9707 17.1832 81.212 17.4821 80.6173C17.7823 80.0201 18.7539 79.3044 19.3878 79.5163C23.7369 80.9694 27.3167 77.9671 28.452 76.0397C31.7109 70.634 23.7077 67.1532 24.7947 64.9905C25.2645 64.0559 25.9379 64.1577 26.6001 64.7162C28.1346 66.0103 30.328 66.9892 32.0238 65.915C32.915 65.3505 33.443 64.3433 32.9663 63.4022C32.2956 62.0778 31.0441 60.5539 29.9176 59.6178C29.4035 59.1906 29.1643 58.453 29.4645 57.8558C29.7647 57.2586 29.5239 56.5311 28.9266 56.2309L28.3688 55.9505C27.5675 55.5478 26.5925 55.7834 26.0635 56.5076L26.0311 56.5519C25.5584 57.1989 24.7318 57.4624 23.9441 57.3155C20.5893 56.6901 18.6055 57.9007 17.4438 60.2121C14.4001 66.2677 21.7748 69.9208 20.6662 72.1263Z");
				attr(path17, "fill", "#F2F2F0");
				attr(path17, "stroke", "black");
				attr(path17, "stroke-width", "1.24289");
				attr(path18, "d", "M104.877 100.498C104.299 101.648 102.388 100.213 100.791 98.6124C99.5868 97.4058 97.712 97.0044 96.2304 97.8469C95.0444 98.5213 94.3453 99.8756 94.9533 101.097C95.6817 102.56 96.8322 103.873 97.7647 104.751C98.2262 105.186 98.3833 105.872 98.0985 106.439C97.7686 107.095 98.0333 107.895 98.6896 108.225L100.313 109.041L100.32 109.044C100.914 109.343 101.394 109.584 101.693 108.989C101.993 108.392 102.965 107.677 103.599 107.888C107.948 109.341 111.528 106.339 112.663 104.412C115.922 99.0061 107.919 95.5253 109.006 93.3626C109.475 92.428 110.149 92.5298 110.811 93.0882C112.346 94.3824 114.539 95.3612 116.235 94.2871C117.126 93.7226 117.654 92.7153 117.177 91.7742C116.507 90.4499 115.255 88.9259 114.129 87.9899C113.614 87.5627 113.375 86.8251 113.675 86.2279C113.976 85.6307 113.735 84.9032 113.138 84.603L112.58 84.3226C111.778 83.9199 110.803 84.1554 110.274 84.8796L110.242 84.9239C109.769 85.571 108.943 85.8345 108.155 85.6876C104.8 85.0621 102.816 86.2727 101.655 88.5841C98.611 94.6397 105.986 98.2929 104.877 100.498Z");
				attr(path18, "fill", "#F2F2F0");
				attr(path18, "stroke", "black");
				attr(path18, "stroke-width", "1.24289");
				attr(path19, "d", "M189.925 126.03C189.347 127.18 187.436 125.745 185.838 124.144C184.635 122.938 182.76 122.536 181.278 123.379C180.092 124.053 179.393 125.407 180.001 126.629C180.73 128.092 181.88 129.405 182.813 130.283C183.274 130.718 183.431 131.404 183.146 131.971C182.816 132.627 183.081 133.427 183.737 133.756L185.361 134.572L185.368 134.576C185.962 134.874 186.442 135.116 186.741 134.521C187.041 133.924 188.013 133.208 188.647 133.42C192.996 134.873 196.576 131.871 197.711 129.943C200.97 124.538 192.966 121.057 194.054 118.894C194.523 117.96 195.197 118.062 195.859 118.62C197.393 119.914 199.587 120.893 201.283 119.819C202.174 119.254 202.702 118.247 202.225 117.306C201.554 115.982 200.303 114.458 199.176 113.522C198.662 113.094 198.423 112.357 198.723 111.76C199.023 111.162 198.783 110.435 198.185 110.135L197.628 109.854C196.826 109.452 195.851 109.687 195.322 110.411L195.29 110.456C194.817 111.103 193.991 111.366 193.203 111.219C189.848 110.594 187.864 111.804 186.703 114.116C183.659 120.171 191.034 123.825 189.925 126.03Z");
				attr(path19, "fill", "#F2F2F0");
				attr(path19, "stroke", "black");
				attr(path19, "stroke-width", "1.24289");
				attr(path20, "d", "M72.1542 61.1821C72.1224 62.4687 69.7815 61.987 67.6536 61.221C66.0499 60.6438 64.1832 61.0811 63.203 62.4755C62.4184 63.5916 62.3642 65.1147 63.4354 65.9596C64.7187 66.9718 66.3196 67.6681 67.5379 68.0644C68.1408 68.2605 68.5758 68.8141 68.5601 69.4479C68.542 70.1823 69.1226 70.7923 69.857 70.8105L71.673 70.8553L71.6812 70.8555C72.3456 70.872 72.8829 70.8853 72.8993 70.2198C72.9158 69.5516 73.489 68.4897 74.1527 68.4106C78.7059 67.8682 80.6616 63.6251 80.8655 61.3974C81.5049 55.1179 72.7817 55.3866 72.8415 52.9668C72.8673 51.9211 73.5198 51.7256 74.357 51.948C76.2971 52.4632 78.6985 52.4121 79.7735 50.7169C80.3384 49.826 80.3859 48.6897 79.5531 48.0421C78.3812 47.1309 76.5989 46.287 75.1807 45.9214C74.5334 45.7545 74.0022 45.1896 74.0187 44.5214C74.0352 43.8532 73.5069 43.2981 72.8387 43.2816L72.2146 43.2662C71.318 43.244 70.5369 43.8733 70.3676 44.754L70.3573 44.8078C70.206 45.5948 69.571 46.1859 68.796 46.3894C65.4952 47.2558 64.218 49.1974 64.1541 51.7835C63.9867 58.559 72.2152 58.7144 72.1542 61.1821Z");
				attr(path20, "fill", "#F2F2F0");
				attr(path20, "stroke", "black");
				attr(path20, "stroke-width", "1.24289");
				attr(path21, "d", "M157.331 86.2764C157.299 87.5629 154.958 87.0813 152.83 86.3153C151.227 85.738 149.36 86.1754 148.38 87.5697C147.595 88.6859 147.541 90.209 148.612 91.0539C149.896 92.0661 151.496 92.7623 152.715 93.1586C153.318 93.3548 153.753 93.9083 153.737 94.5421C153.719 95.2765 154.299 95.8866 155.034 95.9047L156.85 95.9496L156.858 95.9498C157.522 95.9662 158.06 95.9795 158.076 95.314C158.093 94.6458 158.666 93.584 159.329 93.5049C163.883 92.9624 165.838 88.7193 166.042 86.4917C166.682 80.2121 157.958 80.4808 158.018 78.061C158.044 77.0153 158.697 76.8199 159.534 77.0422C161.474 77.5575 163.875 77.5064 164.95 75.8111C165.515 74.9202 165.563 73.784 164.73 73.1364C163.558 72.2251 161.776 71.3812 160.357 71.0156C159.71 70.8487 159.179 70.2838 159.195 69.6156C159.212 68.9474 158.684 68.3923 158.015 68.3758L157.391 68.3604C156.495 68.3382 155.714 68.9675 155.544 69.8482L155.534 69.9021C155.383 70.689 154.748 71.2801 153.973 71.4836C150.672 72.3501 149.395 74.2916 149.331 76.8778C149.163 83.6532 157.392 83.8086 157.331 86.2764Z");
				attr(path21, "fill", "#F2F2F0");
				attr(path21, "stroke", "black");
				attr(path21, "stroke-width", "1.24289");
				attr(path22, "d", "M130.598 13.1957C130.02 14.3455 128.109 12.9107 126.511 11.3096C125.308 10.1031 123.433 9.70169 121.951 10.5442C120.765 11.2186 120.066 12.5728 120.674 13.7942C121.402 15.2573 122.553 16.5703 123.485 17.4488C123.947 17.8835 124.104 18.5697 123.819 19.1362C123.489 19.7926 123.754 20.5921 124.41 20.922L126.033 21.7378L126.041 21.7415C126.635 22.04 127.115 22.2814 127.414 21.6866C127.714 21.0894 128.685 20.3738 129.319 20.5856C133.669 22.0387 137.248 19.0365 138.384 17.109C141.643 11.7034 133.639 8.22256 134.726 6.05984C135.196 5.12524 135.87 5.22704 136.532 5.78549C138.066 7.07962 140.26 8.0585 141.955 6.98437C142.847 6.41987 143.375 5.4126 142.898 4.47149C142.227 3.14718 140.976 1.62321 139.849 0.687154C139.335 0.259964 139.096 -0.477639 139.396 -1.07486C139.696 -1.67208 139.455 -2.39956 138.858 -2.69974L138.3 -2.98012C137.499 -3.38288 136.524 -3.14729 135.995 -2.42311L135.963 -2.37881C135.49 -1.73174 134.663 -1.46825 133.876 -1.61512C130.521 -2.24059 128.537 -1.02999 127.375 1.2814C124.332 7.33701 131.706 10.9901 130.598 13.1957Z");
				attr(path22, "fill", "#F2F2F0");
				attr(path22, "stroke", "black");
				attr(path22, "stroke-width", "1.24289");
				attr(path23, "d", "M183.051 -1.02588C183.019 0.26067 180.678 -0.22097 178.55 -0.986961C176.946 -1.56422 175.08 -1.12687 174.099 0.267471C173.315 1.38361 173.261 2.90673 174.332 3.75163C175.615 4.76382 177.216 5.46007 178.434 5.85638C179.037 6.05252 179.472 6.60604 179.457 7.23989C179.438 7.97426 180.019 8.5843 180.753 8.60245L182.569 8.64734L182.578 8.64754C183.242 8.66397 183.779 8.67726 183.796 8.0118C183.812 7.34359 184.385 6.28171 185.049 6.20263C189.602 5.66016 191.558 1.41706 191.762 -0.810584C192.401 -7.0901 183.678 -6.82144 183.738 -9.24125C183.764 -10.2869 184.416 -10.4824 185.253 -10.26C187.194 -9.74477 189.595 -9.79588 190.67 -11.4911C191.235 -12.382 191.282 -13.5183 190.45 -14.1659C189.278 -15.0771 187.495 -15.921 186.077 -16.2866C185.43 -16.4535 184.899 -17.0184 184.915 -17.6866C184.932 -18.3548 184.403 -18.9099 183.735 -18.9264L183.111 -18.9419C182.215 -18.964 181.433 -18.3347 181.264 -17.454L181.254 -17.4002C181.103 -16.6132 180.468 -16.0221 179.692 -15.8187C176.392 -14.9522 175.115 -13.0106 175.051 -10.4245C174.883 -3.64902 183.112 -3.49361 183.051 -1.02588Z");
				attr(path23, "fill", "#F2F2F0");
				attr(path23, "stroke", "black");
				attr(path23, "stroke-width", "1.24289");
				attr(g0, "opacity", "0.3");
				attr(g1, "mask", "url(#mask0_743_28802)");
				set_style(svg, "width", "100%");
				attr(svg, "width", "200");
				attr(svg, "height", "158");
				attr(svg, "viewBox", "0 0 200 158");
				attr(svg, "fill", "none");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			},
			m(target, anchor) {
				insert(target, svg, anchor);
				append(svg, path0);
				append(svg, mask);
				append(mask, path1);
				append(svg, g1);
				append(g1, rect);
				append(g1, g0);
				append(g0, path2);
				append(g0, path3);
				append(g0, path4);
				append(g0, path5);
				append(g0, path6);
				append(g0, path7);
				append(g0, path8);
				append(g0, path9);
				append(g0, path10);
				append(g0, path11);
				append(g0, path12);
				append(g0, path13);
				append(g0, path14);
				append(g0, path15);
				append(g0, path16);
				append(g0, path17);
				append(g0, path18);
				append(g0, path19);
				append(g0, path20);
				append(g0, path21);
				append(g0, path22);
				append(g0, path23);
				if (if_block) if_block.m(svg, null);
			},
			p(ctx, dirty) {
				if (dirty & /*item*/ 1 && rect_fill_value !== (rect_fill_value = /*item*/ ctx[0].image["background-color"])) {
					attr(rect, "fill", rect_fill_value);
				}

				if (/*item*/ ctx[0].value) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block_7$4(ctx);
						if_block.c();
						if_block.m(svg, null);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			d(detaching) {
				if (detaching) detach(svg);
				if (if_block) if_block.d();
			}
		};
	}

	// (55:6) {#if item.image.src}
	function create_if_block_6$4(ctx) {
		let img;
		let img_src_value;
		let img_alt_value;

		return {
			c() {
				img = element("img");
				if (!src_url_equal(img.src, img_src_value = /*item*/ ctx[0].image.src)) attr(img, "src", img_src_value);
				attr(img, "alt", img_alt_value = /*item*/ ctx[0].name);
				attr(img, "class", "svelte-19y89rv");
			},
			m(target, anchor) {
				insert(target, img, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*item*/ 1 && !src_url_equal(img.src, img_src_value = /*item*/ ctx[0].image.src)) {
					attr(img, "src", img_src_value);
				}

				if (dirty & /*item*/ 1 && img_alt_value !== (img_alt_value = /*item*/ ctx[0].name)) {
					attr(img, "alt", img_alt_value);
				}
			},
			d(detaching) {
				if (detaching) detach(img);
			}
		};
	}

	// (91:10) {#if item.value}
	function create_if_block_7$4(ctx) {
		let text0;
		let t0_value = /*item*/ ctx[0].value + "";
		let t0;
		let text1;
		let t1_value = /*item*/ ctx[0].value + "";
		let t1;
		let text1_fill_value;

		return {
			c() {
				text0 = svg_element("text");
				t0 = text(t0_value);
				text1 = svg_element("text");
				t1 = text(t1_value);
				attr(text0, "x", "52%");
				attr(text0, "y", "52%");
				attr(text0, "dominant-baseline", "middle");
				attr(text0, "text-anchor", "middle");
				attr(text0, "fill", "black");
				attr(text0, "font-weight", "bolder");
				attr(text0, "font-family", "Arial Black");
				attr(text0, "font-size", "3.5em");
				attr(text0, "stroke", "black");
				attr(text0, "stroke-width", "2px");
				attr(text1, "x", "50%");
				attr(text1, "y", "50%");
				attr(text1, "dominant-baseline", "middle");
				attr(text1, "text-anchor", "middle");
				attr(text1, "fill", text1_fill_value = /*item*/ ctx[0].image.color);
				attr(text1, "font-weight", "bolder");
				attr(text1, "font-family", "Arial Black");
				attr(text1, "font-size", "3.5em");
				attr(text1, "stroke", "black");
				attr(text1, "stroke-width", "2px");
			},
			m(target, anchor) {
				insert(target, text0, anchor);
				append(text0, t0);
				insert(target, text1, anchor);
				append(text1, t1);
			},
			p(ctx, dirty) {
				if (dirty & /*item*/ 1 && t0_value !== (t0_value = /*item*/ ctx[0].value + "")) set_data(t0, t0_value);
				if (dirty & /*item*/ 1 && t1_value !== (t1_value = /*item*/ ctx[0].value + "")) set_data(t1, t1_value);

				if (dirty & /*item*/ 1 && text1_fill_value !== (text1_fill_value = /*item*/ ctx[0].image.color)) {
					attr(text1, "fill", text1_fill_value);
				}
			},
			d(detaching) {
				if (detaching) detach(text0);
				if (detaching) detach(text1);
			}
		};
	}

	// (111:4) {:else}
	function create_else_block$c(ctx) {
		let div0;
		let current_block_type_index;
		let if_block0;
		let t;
		let div1;
		let current;
		const if_block_creators = [create_if_block_2$e, create_else_block_1$3];
		const if_blocks = [];

		function select_block_type_2(ctx, dirty) {
			if (/*item*/ ctx[0].isRedeemed) return 0;
			return 1;
		}

		current_block_type_index = select_block_type_2(ctx);
		if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		let if_block1 = /*item*/ ctx[0].communityImages?.length && create_if_block_1$k(ctx);

		return {
			c() {
				div0 = element("div");
				if_block0.c();
				t = space();
				div1 = element("div");
				if (if_block1) if_block1.c();
				attr(div0, "class", "flex flex-col svelte-19y89rv");
				attr(div1, "class", "offer-item-card__community svelte-19y89rv");
			},
			m(target, anchor) {
				insert(target, div0, anchor);
				if_blocks[current_block_type_index].m(div0, null);
				insert(target, t, anchor);
				insert(target, div1, anchor);
				if (if_block1) if_block1.m(div1, null);
				current = true;
			},
			p(ctx, dirty) {
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type_2(ctx);

				if (current_block_type_index === previous_block_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block0 = if_blocks[current_block_type_index];

					if (!if_block0) {
						if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block0.c();
					} else {
						if_block0.p(ctx, dirty);
					}

					transition_in(if_block0, 1);
					if_block0.m(div0, null);
				}

				if (/*item*/ ctx[0].communityImages?.length) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_1$k(ctx);
						if_block1.c();
						if_block1.m(div1, null);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block0);
				current = true;
			},
			o(local) {
				transition_out(if_block0);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div0);
				if_blocks[current_block_type_index].d();
				if (detaching) detach(t);
				if (detaching) detach(div1);
				if (if_block1) if_block1.d();
			}
		};
	}

	// (109:4) {#if isSoldOut}
	function create_if_block$o(ctx) {
		let span;

		return {
			c() {
				span = element("span");
				span.textContent = "Sold Out";
				attr(span, "class", "sold-out svelte-19y89rv");
			},
			m(target, anchor) {
				insert(target, span, anchor);
			},
			p: noop$6,
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(span);
			}
		};
	}

	// (121:8) {:else}
	function create_else_block_1$3(ctx) {
		let t;
		let if_block1_anchor;
		let current;
		let if_block0 = /*countdownDate*/ ctx[1] != null && create_if_block_4$8(ctx);
		let if_block1 = /*item*/ ctx[0].redemption?.availableCount != null && create_if_block_3$b(ctx);

		return {
			c() {
				if (if_block0) if_block0.c();
				t = space();
				if (if_block1) if_block1.c();
				if_block1_anchor = empty$3();
			},
			m(target, anchor) {
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, if_block1_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (/*countdownDate*/ ctx[1] != null) {
					if (if_block0) {
						if_block0.p(ctx, dirty);

						if (dirty & /*countdownDate*/ 2) {
							transition_in(if_block0, 1);
						}
					} else {
						if_block0 = create_if_block_4$8(ctx);
						if_block0.c();
						transition_in(if_block0, 1);
						if_block0.m(t.parentNode, t);
					}
				} else if (if_block0) {
					group_outros();

					transition_out(if_block0, 1, 1, () => {
						if_block0 = null;
					});

					check_outros();
				}

				if (/*item*/ ctx[0].redemption?.availableCount != null) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_3$b(ctx);
						if_block1.c();
						if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block0);
				current = true;
			},
			o(local) {
				transition_out(if_block0);
				current = false;
			},
			d(detaching) {
				if (if_block0) if_block0.d(detaching);
				if (detaching) detach(t);
				if (if_block1) if_block1.d(detaching);
				if (detaching) detach(if_block1_anchor);
			}
		};
	}

	// (113:8) {#if item.isRedeemed}
	function create_if_block_2$e(ctx) {
		let div0;
		let t2;
		let div1;

		let t3_value = (/*item*/ ctx[0].redeemText ?? (/*item*/ ctx[0].redemption.totalLimit
		? `1 of ${/*item*/ ctx[0].redemption.totalLimit}`
		: "Exclusive")) + "";

		let t3;

		return {
			c() {
				div0 = element("div");

				div0.innerHTML = `<svg width="17" height="16" viewBox="0 0 17 16" fill="#000000" xmlns="http://www.w3.org/2000/svg" data-testid="item-unlocked-icon" class="svelte-19y89rv"><path d="M5.83366 7.33333H5.33366V7.83333H5.83366V7.33333ZM10.667 4.66667C10.667 4.94281 10.8908 5.16667 11.167 5.16667C11.4431 5.16667 11.667 4.94281 11.667 4.66667H10.667ZM9.00033 10C9.00033 9.72386 8.77647 9.5 8.50033 9.5C8.22418 9.5 8.00033 9.72386 8.00033 10H9.00033ZM8.00033 11.3333C8.00033 11.6095 8.22418 11.8333 8.50033 11.8333C8.77647 11.8333 9.00033 11.6095 9.00033 11.3333H8.00033ZM4.50033 7.83333H12.5003V6.83333H4.50033V7.83333ZM13.3337 8.66667V12.6667H14.3337V8.66667H13.3337ZM12.5003 13.5H4.50033V14.5H12.5003V13.5ZM3.66699 12.6667V8.66667H2.66699V12.6667H3.66699ZM4.50033 13.5C4.04009 13.5 3.66699 13.1269 3.66699 12.6667H2.66699C2.66699 13.6792 3.4878 14.5 4.50033 14.5V13.5ZM13.3337 12.6667C13.3337 13.1269 12.9606 13.5 12.5003 13.5V14.5C13.5128 14.5 14.3337 13.6792 14.3337 12.6667H13.3337ZM12.5003 7.83333C12.9606 7.83333 13.3337 8.20643 13.3337 8.66667H14.3337C14.3337 7.65415 13.5128 6.83333 12.5003 6.83333V7.83333ZM4.50033 6.83333C3.4878 6.83333 2.66699 7.65415 2.66699 8.66667H3.66699C3.66699 8.20643 4.04009 7.83333 4.50033 7.83333V6.83333ZM11.167 6.83333H5.83366V7.83333H11.167V6.83333ZM6.33366 7.33333V4.66667H5.33366V7.33333H6.33366ZM8.50033 2.5C9.69694 2.5 10.667 3.47005 10.667 4.66667H11.667C11.667 2.91777 10.2492 1.5 8.50033 1.5V2.5ZM8.50033 1.5C6.75142 1.5 5.33366 2.91777 5.33366 4.66667H6.33366C6.33366 3.47005 7.30371 2.5 8.50033 2.5V1.5ZM8.00033 10V11.3333H9.00033V10H8.00033Z" fill="#000000"></path></svg> 
            <span class="svelte-19y89rv">Unlocked</span>`;

				t2 = space();
				div1 = element("div");
				t3 = text(t3_value);
				attr(div0, "class", "unlocked svelte-19y89rv");
				attr(div1, "class", "offer-item-card__availability svelte-19y89rv");
			},
			m(target, anchor) {
				insert(target, div0, anchor);
				insert(target, t2, anchor);
				insert(target, div1, anchor);
				append(div1, t3);
			},
			p(ctx, dirty) {
				if (dirty & /*item*/ 1 && t3_value !== (t3_value = (/*item*/ ctx[0].redeemText ?? (/*item*/ ctx[0].redemption.totalLimit
				? `1 of ${/*item*/ ctx[0].redemption.totalLimit}`
				: "Exclusive")) + "")) set_data(t3, t3_value);
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(div0);
				if (detaching) detach(t2);
				if (detaching) detach(div1);
			}
		};
	}

	// (122:10) {#if countdownDate != null}
	function create_if_block_4$8(ctx) {
		let percscountdown;
		let current;

		percscountdown = new PercsCountdown({
				props: { date: /*countdownDate*/ ctx[1] }
			});

		return {
			c() {
				create_component(percscountdown.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percscountdown, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percscountdown_changes = {};
				if (dirty & /*countdownDate*/ 2) percscountdown_changes.date = /*countdownDate*/ ctx[1];
				percscountdown.$set(percscountdown_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percscountdown.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percscountdown.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percscountdown, detaching);
			}
		};
	}

	// (125:10) {#if item.redemption?.availableCount != null}
	function create_if_block_3$b(ctx) {
		let div;
		let t0_value = /*item*/ ctx[0].redemption?.availableCount + "";
		let t0;
		let t1;

		return {
			c() {
				div = element("div");
				t0 = text(t0_value);
				t1 = text(" available");
				attr(div, "class", "offer-item-card__availability svelte-19y89rv");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, t0);
				append(div, t1);
			},
			p(ctx, dirty) {
				if (dirty & /*item*/ 1 && t0_value !== (t0_value = /*item*/ ctx[0].redemption?.availableCount + "")) set_data(t0, t0_value);
			},
			d(detaching) {
				if (detaching) detach(div);
			}
		};
	}

	// (131:8) {#if item.communityImages?.length}
	function create_if_block_1$k(ctx) {
		let img;
		let img_src_value;
		let img_alt_value;

		return {
			c() {
				img = element("img");
				if (!src_url_equal(img.src, img_src_value = /*item*/ ctx[0].communityImages[0].src)) attr(img, "src", img_src_value);
				attr(img, "alt", img_alt_value = /*item*/ ctx[0].communityImages[0].alt);
				attr(img, "class", "svelte-19y89rv");
			},
			m(target, anchor) {
				insert(target, img, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*item*/ 1 && !src_url_equal(img.src, img_src_value = /*item*/ ctx[0].communityImages[0].src)) {
					attr(img, "src", img_src_value);
				}

				if (dirty & /*item*/ 1 && img_alt_value !== (img_alt_value = /*item*/ ctx[0].communityImages[0].alt)) {
					attr(img, "alt", img_alt_value);
				}
			},
			d(detaching) {
				if (detaching) detach(img);
			}
		};
	}

	// (42:0) <svelte:element   this={component.$$.callbacks?.click?.length ? "button" : "div"}   class="offer-item-card"   disabled={isSoldOut}   style="--container-background: {item.image?.[ "background-color" ]};"   on:click   on:keydown   on:keyup   on:keypress   data-testid="offer-item" >
	function create_dynamic_element(ctx) {
		let svelte_element;
		let t;
		let div;
		let current_block_type_index;
		let if_block1;
		let svelte_element_style_value;
		let current;
		let mounted;
		let dispose;
		let if_block0 = /*item*/ ctx[0].image && create_if_block_5$6(ctx);
		const if_block_creators = [create_if_block$o, create_else_block$c];
		const if_blocks = [];

		function select_block_type_1(ctx, dirty) {
			if (/*isSoldOut*/ ctx[2]) return 0;
			return 1;
		}

		current_block_type_index = select_block_type_1(ctx);
		if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

		let svelte_element_levels = [
			{ class: "offer-item-card svelte-19y89rv" },
			{ disabled: /*isSoldOut*/ ctx[2] },
			{
				style: svelte_element_style_value = "--container-background: " + /*item*/ ctx[0].image?.["background-color"] + ";"
			},
			{ "data-testid": "offer-item" }
		];

		let svelte_element_data = {};

		for (let i = 0; i < svelte_element_levels.length; i += 1) {
			svelte_element_data = assign$6(svelte_element_data, svelte_element_levels[i]);
		}

		return {
			c() {
				svelte_element = element((/*component*/ ctx[3].$$.callbacks?.click?.length)
				? "button"
				: "div");

				if (if_block0) if_block0.c();
				t = space();
				div = element("div");
				if_block1.c();
				attr(div, "class", "offer-item-card__content svelte-19y89rv");
				toggle_class(div, "offer-item-card__content--disabled", /*isSoldOut*/ ctx[2]);

				set_dynamic_element_data((/*component*/ ctx[3].$$.callbacks?.click?.length)
				? "button"
				: "div")(svelte_element, svelte_element_data);
			},
			m(target, anchor) {
				insert(target, svelte_element, anchor);
				if (if_block0) if_block0.m(svelte_element, null);
				append(svelte_element, t);
				append(svelte_element, div);
				if_blocks[current_block_type_index].m(div, null);
				current = true;

				if (!mounted) {
					dispose = [
						listen(svelte_element, "click", /*click_handler*/ ctx[5]),
						listen(svelte_element, "keydown", /*keydown_handler*/ ctx[6]),
						listen(svelte_element, "keyup", /*keyup_handler*/ ctx[7]),
						listen(svelte_element, "keypress", /*keypress_handler*/ ctx[8])
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (/*item*/ ctx[0].image) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_5$6(ctx);
						if_block0.c();
						if_block0.m(svelte_element, t);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type_1(ctx);

				if (current_block_type_index === previous_block_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block1 = if_blocks[current_block_type_index];

					if (!if_block1) {
						if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block1.c();
					} else {
						if_block1.p(ctx, dirty);
					}

					transition_in(if_block1, 1);
					if_block1.m(div, null);
				}

				if (!current || dirty & /*isSoldOut*/ 4) {
					toggle_class(div, "offer-item-card__content--disabled", /*isSoldOut*/ ctx[2]);
				}

				set_dynamic_element_data((/*component*/ ctx[3].$$.callbacks?.click?.length)
				? "button"
				: "div")(svelte_element, svelte_element_data = get_spread_update(svelte_element_levels, [
					{ class: "offer-item-card svelte-19y89rv" },
					(!current || dirty & /*isSoldOut*/ 4) && { disabled: /*isSoldOut*/ ctx[2] },
					(!current || dirty & /*item*/ 1 && svelte_element_style_value !== (svelte_element_style_value = "--container-background: " + /*item*/ ctx[0].image?.["background-color"] + ";")) && { style: svelte_element_style_value },
					{ "data-testid": "offer-item" }
				]));
			},
			i(local) {
				if (current) return;
				transition_in(if_block1);
				current = true;
			},
			o(local) {
				transition_out(if_block1);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(svelte_element);
				if (if_block0) if_block0.d();
				if_blocks[current_block_type_index].d();
				mounted = false;
				run_all(dispose);
			}
		};
	}

	function create_fragment$G(ctx) {

		let svelte_element = ((/*component*/ ctx[3].$$.callbacks?.click?.length)
		? "button"
		: "div") && create_dynamic_element(ctx);

		return {
			c() {
				if (svelte_element) svelte_element.c();
			},
			m(target, anchor) {
				if (svelte_element) svelte_element.m(target, anchor);
			},
			p(ctx, [dirty]) {
				if ((/*component*/ ctx[3].$$.callbacks?.click?.length)
				? "button"
				: "div") {
					svelte_element.p(ctx, dirty);
				}
			},
			i: noop$6,
			o(local) {
				transition_out(svelte_element);
			},
			d(detaching) {
				if (svelte_element) svelte_element.d(detaching);
			}
		};
	}

	function instance$G($$self, $$props, $$invalidate) {
		let { offer } = $$props;
		let { item } = $$props;
		const component = get_current_component();

		/** @type {?Date} */
		let countdownDate = null;

		let isSoldOut = false;

		const checkIsSoldOut = checkItem => {
			const isoDate = checkItem.validDates?.[1]?.value || offer.validDates?.[1]?.value;

			if (isoDate) {
				$$invalidate(1, countdownDate = new Date(isoDate));

				if (countdownDate <= new Date()) {
					return true;
				}

				if (!checkItem.availableCount && !checkItem.redemption?.totalLimit) {
					return false;
				} else if (!checkItem.redemption?.totalLimit) {
					return true;
				}
			}

			return false;
		};

		function click_handler(event) {
			bubble.call(this, $$self, event);
		}

		function keydown_handler(event) {
			bubble.call(this, $$self, event);
		}

		function keyup_handler(event) {
			bubble.call(this, $$self, event);
		}

		function keypress_handler(event) {
			bubble.call(this, $$self, event);
		}

		$$self.$$set = $$props => {
			if ('offer' in $$props) $$invalidate(4, offer = $$props.offer);
			if ('item' in $$props) $$invalidate(0, item = $$props.item);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*item*/ 1) {
				{
					$$invalidate(2, isSoldOut = checkIsSoldOut(item));
				} // @todo community image
			}
		};

		return [
			item,
			countdownDate,
			isSoldOut,
			component,
			offer,
			click_handler,
			keydown_handler,
			keyup_handler,
			keypress_handler
		];
	}

	class PercsOfferItemCard extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$G, create_fragment$G, safe_not_equal, { offer: 4, item: 0 }, add_css$v);
		}
	}

	/* dist/components/internal/PercsTokenOfferButtonCard.svelte generated by Svelte v3.59.2 */

	function add_css$u(target) {
		append_styles(target, "svelte-7323pj", ".percs-token-offer-button-card{display:flex;flex-direction:column;gap:8px;max-width:400px;height:min-content;padding:12px;background-color:#FFFFFF;box-sizing:border-box;border:1px solid #EAECF0;border-radius:12px;box-shadow:0px 1px 2px rgba(16, 24, 40, 0.05)}.percs-token-offer-button-card__image-container{position:relative}.percs-token-offer-button-card__image{width:100%;border-radius:6px}.percs-token-offer-button-card__button{color:white;background-color:#059669;font-size:16;padding:7px;text-transform:uppercase;border:none;cursor:pointer}");
	}

	function create_fragment$F(ctx) {
		let div;
		let img;
		let img_src_value;
		let img_alt_value;
		let t0;
		let button;
		let t1;
		let t2;
		let mounted;
		let dispose;

		return {
			c() {
				div = element("div");
				img = element("img");
				t0 = space();
				button = element("button");
				t1 = text("Claim ");
				t2 = text(/*offerText*/ ctx[1]);
				attr(img, "class", "percs-token-offer-button-card__image");
				if (!src_url_equal(img.src, img_src_value = /*token*/ ctx[0].image?.src ?? /*token*/ ctx[0].imageThumbnailUrl ?? "https://assets.getpercs.com/logo.svg")) attr(img, "src", img_src_value);
				attr(img, "alt", img_alt_value = /*token*/ ctx[0].name);
				attr(button, "type", "button");
				attr(button, "class", "percs-token-offer-button-card__button");
				attr(div, "class", "percs-token-offer-button-card");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, img);
				append(div, t0);
				append(div, button);
				append(button, t1);
				append(button, t2);

				if (!mounted) {
					dispose = [
						listen(div, "click", /*click_handler*/ ctx[2]),
						listen(div, "keydown", /*keydown_handler*/ ctx[3]),
						listen(div, "keypress", /*keypress_handler*/ ctx[4]),
						listen(div, "keyup", /*keyup_handler*/ ctx[5])
					];

					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*token*/ 1 && !src_url_equal(img.src, img_src_value = /*token*/ ctx[0].image?.src ?? /*token*/ ctx[0].imageThumbnailUrl ?? "https://assets.getpercs.com/logo.svg")) {
					attr(img, "src", img_src_value);
				}

				if (dirty & /*token*/ 1 && img_alt_value !== (img_alt_value = /*token*/ ctx[0].name)) {
					attr(img, "alt", img_alt_value);
				}

				if (dirty & /*offerText*/ 2) set_data(t2, /*offerText*/ ctx[1]);
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(div);
				mounted = false;
				run_all(dispose);
			}
		};
	}

	function instance$F($$self, $$props, $$invalidate) {
		let { token } = $$props;
		let { offerText } = $$props;

		function click_handler(event) {
			bubble.call(this, $$self, event);
		}

		function keydown_handler(event) {
			bubble.call(this, $$self, event);
		}

		function keypress_handler(event) {
			bubble.call(this, $$self, event);
		}

		function keyup_handler(event) {
			bubble.call(this, $$self, event);
		}

		$$self.$$set = $$props => {
			if ('token' in $$props) $$invalidate(0, token = $$props.token);
			if ('offerText' in $$props) $$invalidate(1, offerText = $$props.offerText);
		};

		return [
			token,
			offerText,
			click_handler,
			keydown_handler,
			keypress_handler,
			keyup_handler
		];
	}

	class PercsTokenOfferButtonCard extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$F, create_fragment$F, safe_not_equal, { token: 0, offerText: 1 }, add_css$u);
		}
	}

	/* dist/components/internal/PercsOfferItemList.svelte generated by Svelte v3.59.2 */

	function add_css$t(target) {
		append_styles(target, "svelte-stancf", ".offer-list{gap:8px;overflow-y:auto;height:40vh;max-height:416px;overflow-x:hidden;margin:unset;margin-bottom:24px;padding:0px;padding-right:12px;position:relative;width:calc(100% + 8px);display:grid;grid-template-columns:1fr 1fr}.offer-list::-webkit-scrollbar{width:6px}.offer-list::-webkit-scrollbar-track{background:#161b5d29;opacity:0.2;border-radius:49px;width:6px}.offer-list::-webkit-scrollbar-thumb{background:#161b5d3c;opacity:0.3;border-radius:49px;width:4px}.offer-list::-webkit-scrollbar-thumb:hover{background:#555}.offer-list__item-container{cursor:pointer;border:none;padding:0;background-color:transparent}");
	}

	function get_each_context$6(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[6] = list[i].offer;
		child_ctx[7] = list[i].item;
		child_ctx[8] = list[i].contract;
		child_ctx[9] = list[i].tokenId;
		child_ctx[10] = list[i].token;
		return child_ctx;
	}

	// (69:0) {:else}
	function create_else_block$b(ctx) {
		let h2;
		let t0;
		let t1_value = /*$state*/ ctx[2].context.offersActiveTab + "";
		let t1;
		let t2;

		return {
			c() {
				h2 = element("h2");
				t0 = text("There are no ");
				t1 = text(t1_value);
				t2 = text(" offers");
				attr(h2, "class", "offer-list__title");
			},
			m(target, anchor) {
				insert(target, h2, anchor);
				append(h2, t0);
				append(h2, t1);
				append(h2, t2);
			},
			p(ctx, dirty) {
				if (dirty & /*$state*/ 4 && t1_value !== (t1_value = /*$state*/ ctx[2].context.offersActiveTab + "")) set_data(t1, t1_value);
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(h2);
			}
		};
	}

	// (54:0) {#if entries.length}
	function create_if_block$n(ctx) {
		let ul;
		let current;
		let each_value = /*entries*/ ctx[1];
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$6(get_each_context$6(ctx, each_value, i));
		}

		const out = i => transition_out(each_blocks[i], 1, 1, () => {
			each_blocks[i] = null;
		});

		return {
			c() {
				ul = element("ul");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				attr(ul, "class", "offer-list offer-list--small");
			},
			m(target, anchor) {
				insert(target, ul, anchor);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(ul, null);
					}
				}

				current = true;
			},
			p(ctx, dirty) {
				if (dirty & /*state, entries*/ 3) {
					each_value = /*entries*/ ctx[1];
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$6(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
							transition_in(each_blocks[i], 1);
						} else {
							each_blocks[i] = create_each_block$6(child_ctx);
							each_blocks[i].c();
							transition_in(each_blocks[i], 1);
							each_blocks[i].m(ul, null);
						}
					}

					group_outros();

					for (i = each_value.length; i < each_blocks.length; i += 1) {
						out(i);
					}

					check_outros();
				}
			},
			i(local) {
				if (current) return;

				for (let i = 0; i < each_value.length; i += 1) {
					transition_in(each_blocks[i]);
				}

				current = true;
			},
			o(local) {
				each_blocks = each_blocks.filter(Boolean);

				for (let i = 0; i < each_blocks.length; i += 1) {
					transition_out(each_blocks[i]);
				}

				current = false;
			},
			d(detaching) {
				if (detaching) detach(ul);
				destroy_each(each_blocks, detaching);
			}
		};
	}

	// (64:57) 
	function create_if_block_2$d(ctx) {
		let percstokenofferbuttoncard;
		let current;

		function click_handler_1() {
			return /*click_handler_1*/ ctx[4](/*offer*/ ctx[6], /*item*/ ctx[7], /*contract*/ ctx[8], /*tokenId*/ ctx[9]);
		}

		percstokenofferbuttoncard = new PercsTokenOfferButtonCard({
				props: {
					token: /*token*/ ctx[10],
					offerText: /*item*/ ctx[7].name
				}
			});

		percstokenofferbuttoncard.$on("click", click_handler_1);

		return {
			c() {
				create_component(percstokenofferbuttoncard.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percstokenofferbuttoncard, target, anchor);
				current = true;
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				const percstokenofferbuttoncard_changes = {};
				if (dirty & /*entries*/ 2) percstokenofferbuttoncard_changes.token = /*token*/ ctx[10];
				if (dirty & /*entries*/ 2) percstokenofferbuttoncard_changes.offerText = /*item*/ ctx[7].name;
				percstokenofferbuttoncard.$set(percstokenofferbuttoncard_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percstokenofferbuttoncard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percstokenofferbuttoncard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percstokenofferbuttoncard, detaching);
			}
		};
	}

	// (57:6) {#if offer.redemption.selectType === "wallet"}
	function create_if_block_1$j(ctx) {
		let button;
		let percsofferitemcard;
		let t;
		let current;
		let mounted;
		let dispose;

		percsofferitemcard = new PercsOfferItemCard({
				props: {
					offer: /*offer*/ ctx[6],
					item: /*item*/ ctx[7]
				}
			});

		function click_handler() {
			return /*click_handler*/ ctx[3](/*offer*/ ctx[6], /*item*/ ctx[7]);
		}

		return {
			c() {
				button = element("button");
				create_component(percsofferitemcard.$$.fragment);
				t = space();
				attr(button, "type", "button");
				attr(button, "class", "offer-list__item-container");
			},
			m(target, anchor) {
				insert(target, button, anchor);
				mount_component(percsofferitemcard, button, null);
				append(button, t);
				current = true;

				if (!mounted) {
					dispose = listen(button, "click", click_handler);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				const percsofferitemcard_changes = {};
				if (dirty & /*entries*/ 2) percsofferitemcard_changes.offer = /*offer*/ ctx[6];
				if (dirty & /*entries*/ 2) percsofferitemcard_changes.item = /*item*/ ctx[7];
				percsofferitemcard.$set(percsofferitemcard_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsofferitemcard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsofferitemcard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(button);
				destroy_component(percsofferitemcard);
				mounted = false;
				dispose();
			}
		};
	}

	// (56:4) {#each entries as { offer, item, contract, tokenId, token }}
	function create_each_block$6(ctx) {
		let current_block_type_index;
		let if_block;
		let if_block_anchor;
		let current;
		const if_block_creators = [create_if_block_1$j, create_if_block_2$d];
		const if_blocks = [];

		function select_block_type_1(ctx, dirty) {
			if (/*offer*/ ctx[6].redemption.selectType === "wallet") return 0;
			if (/*offer*/ ctx[6].redemption.selectType === "single") return 1;
			return -1;
		}

		if (~(current_block_type_index = select_block_type_1(ctx))) {
			if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		}

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].m(target, anchor);
				}

				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type_1(ctx);

				if (current_block_type_index === previous_block_index) {
					if (~current_block_type_index) {
						if_blocks[current_block_type_index].p(ctx, dirty);
					}
				} else {
					if (if_block) {
						group_outros();

						transition_out(if_blocks[previous_block_index], 1, 1, () => {
							if_blocks[previous_block_index] = null;
						});

						check_outros();
					}

					if (~current_block_type_index) {
						if_block = if_blocks[current_block_type_index];

						if (!if_block) {
							if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
							if_block.c();
						} else {
							if_block.p(ctx, dirty);
						}

						transition_in(if_block, 1);
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					} else {
						if_block = null;
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].d(detaching);
				}

				if (detaching) detach(if_block_anchor);
			}
		};
	}

	function create_fragment$E(ctx) {
		let current_block_type_index;
		let if_block;
		let if_block_anchor;
		let current;
		const if_block_creators = [create_if_block$n, create_else_block$b];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*entries*/ ctx[1].length) return 0;
			return 1;
		}

		current_block_type_index = select_block_type(ctx);
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

		return {
			c() {
				if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if_blocks[current_block_type_index].m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type(ctx);

				if (current_block_type_index === previous_block_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if_blocks[current_block_type_index].d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	function instance$E($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(2, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		/** @typedef {import("../../services/state").Offer} Offer*/
		/**
	 * @typedef {{
	 *   offer: Offer
	 *   item: Offer["redemption"]["items"][number]
	 *   contract?: Offer["redemption"]["contractTokens"][number]
	 *   tokenId?: string
	 *   token?: Offer["redemption"]["contractTokens"][number]["tokens"][string]
	 * }} Entry
	 */
		/** @type {Entry[]} */
		let entries = [];

		/**
	 * @param {{ offer: Offer, contract: Offer["redemption"]["contractTokens"][number], token:  Offer["redemption"]["contractTokens"][number]["tokens"][string], tokenId: string }}
	 */
		function pushTokenEntry({ offer, contract, token, tokenId }) {
			if (token.isRedeemed && $state.context.offersActiveTab === "Redeemed") {
				for (const item of offer.redemption.items) {
					entries.push({ offer, item, contract, tokenId, token });
				}
			} else if (!token.isRedeemed && $state.context.offersActiveTab === "Active") {
				for (const item of offer.redemption.items) {
					entries.push({ offer, item, contract, tokenId, token });
				}
			}
		}

		const click_handler = (offer, item) => state.send("OFFER_ITEM_SELECT", { offerId: offer.id, itemId: item.id });

		const click_handler_1 = (offer, item, contract, tokenId) => state.send("OFFER_ITEM_SELECT", {
			offerId: offer.id,
			itemId: item.id,
			contract: `${contract.type}:${contract.address}`,
			tokenId
		});

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*$state, entries*/ 6) {
				{
					$$invalidate(1, entries = []);

					for (const offer of $state.context.offers) {
						if (offer.redemption.selectType === "wallet") {
							for (const item of offer.redemption.items) {
								entries.push({ offer, item });
							}
						} else if (offer.redemption.selectType === "single") {
							for (const contract of offer.redemption.contractTokens) {
								Object.entries(contract.tokens).forEach(([tokenId, token]) => pushTokenEntry({ offer, contract, token, tokenId }));
							}
						}
					}
				}
			}
		};

		return [state, entries, $state, click_handler, click_handler_1];
	}

	class PercsOfferItemList extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$E, create_fragment$E, safe_not_equal, { state: 0 }, add_css$t);
		}
	}

	/* dist/components/dialog-contents/OfferExpired.svelte generated by Svelte v3.59.2 */

	function create_default_slot_1$m(ctx) {
		let h2;
		let t1;
		let small;

		return {
			c() {
				h2 = element("h2");
				h2.textContent = "Oops, looks like this deal is over.";
				t1 = space();
				small = element("small");
				small.textContent = "Better luck next time!!";
			},
			m(target, anchor) {
				insert(target, h2, anchor);
				insert(target, t1, anchor);
				insert(target, small, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(h2);
				if (detaching) detach(t1);
				if (detaching) detach(small);
			}
		};
	}

	// (14:0) <PercsDialogContent>
	function create_default_slot$p(ctx) {
		let percsofferitemlist;
		let current;
		percsofferitemlist = new PercsOfferItemList({ props: { state: /*state*/ ctx[0] } });

		return {
			c() {
				create_component(percsofferitemlist.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsofferitemlist, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsofferitemlist_changes = {};
				if (dirty & /*state*/ 1) percsofferitemlist_changes.state = /*state*/ ctx[0];
				percsofferitemlist.$set(percsofferitemlist_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsofferitemlist.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsofferitemlist.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsofferitemlist, detaching);
			}
		};
	}

	function create_fragment$D(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Offer Expired",
					$$slots: { default: [create_default_slot_1$m] },
					$$scope: { ctx }
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[1]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot$p] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];

				if (dirty & /*$$scope*/ 4) {
					percsdialogheader_changes.$$scope = { dirty, ctx };
				}

				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state*/ 5) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$D($$self, $$props, $$invalidate) {
		let { state } = $$props;

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		$$self.$$set = $$props => {
			if ('state' in $$props) $$invalidate(0, state = $$props.state);
		};

		return [state, close_handler];
	}

	class OfferExpired extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$D, create_fragment$D, safe_not_equal, { state: 0 });
		}
	}

	/* dist/components/internal/PercsDialogActions.svelte generated by Svelte v3.59.2 */

	function add_css$s(target) {
		append_styles(target, "svelte-86tiki", ".dialog__actions{margin-top:8px;display:flex;flex-direction:column;gap:8px}");
	}

	function create_fragment$C(ctx) {
		let div;
		let div_class_value;
		let current;
		const default_slot_template = /*#slots*/ ctx[2].default;
		const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[1], null);

		return {
			c() {
				div = element("div");
				if (default_slot) default_slot.c();
				attr(div, "class", div_class_value = bem("dialog__actions", /*modifiers*/ ctx[0]));
			},
			m(target, anchor) {
				insert(target, div, anchor);

				if (default_slot) {
					default_slot.m(div, null);
				}

				current = true;
			},
			p(ctx, [dirty]) {
				if (default_slot) {
					if (default_slot.p && (!current || dirty & /*$$scope*/ 2)) {
						update_slot_base(
							default_slot,
							default_slot_template,
							ctx,
							/*$$scope*/ ctx[1],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[1])
							: get_slot_changes(default_slot_template, /*$$scope*/ ctx[1], dirty, null),
							null
						);
					}
				}

				if (!current || dirty & /*modifiers*/ 1 && div_class_value !== (div_class_value = bem("dialog__actions", /*modifiers*/ ctx[0]))) {
					attr(div, "class", div_class_value);
				}
			},
			i(local) {
				if (current) return;
				transition_in(default_slot, local);
				current = true;
			},
			o(local) {
				transition_out(default_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div);
				if (default_slot) default_slot.d(detaching);
			}
		};
	}

	function instance$C($$self, $$props, $$invalidate) {
		let { $$slots: slots = {}, $$scope } = $$props;
		let { modifiers = "" } = $$props;

		$$self.$$set = $$props => {
			if ('modifiers' in $$props) $$invalidate(0, modifiers = $$props.modifiers);
			if ('$$scope' in $$props) $$invalidate(1, $$scope = $$props.$$scope);
		};

		return [modifiers, $$scope, slots];
	}

	class PercsDialogActions extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$C, create_fragment$C, safe_not_equal, { modifiers: 0 }, add_css$s);
		}
	}

	/* dist/components/internal/PercsTokenListItem.svelte generated by Svelte v3.59.2 */

	function add_css$r(target) {
		append_styles(target, "svelte-1yrar46", ".percs-token-list-item.svelte-1yrar46{background-color:white;position:relative;display:flex;flex-direction:row;align-items:center;border:1px solid rgb(209, 213, 219);padding:1.25rem;border-radius:8px}.percs-token-list-item__image-container.svelte-1yrar46{flex-shrink:0}.percs-token-list-item__image.svelte-1yrar46{height:2.5rem;width:2.5rem;border-radius:100%}.percs-token-list-item__text-container.svelte-1yrar46{min-width:0;flex:1;padding-left:12px}.percs-token-list-item__token-name-text.svelte-1yrar46{text-align:left;color:rgb(17 24 39);font-weight:500;font-size:0.875rem;line-height:1.25rem;margin:0}.percs-token-list-item__contract-name-text.svelte-1yrar46{text-align:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:0.875rem;line-height:1.25rem;color:rgb(107 114 128);margin:0}.percs-token-list-item__icon.svelte-1yrar46{color:rgb(74 222 128);width:1.75rem;height:1.75rem}");
	}

	function create_fragment$B(ctx) {
		let div2;
		let div0;
		let img;
		let img_src_value;
		let t0;
		let div1;
		let p0;
		let t1_value = /*token*/ ctx[1].name + "";
		let t1;
		let t2;
		let p1;
		let t3_value = (/*contract*/ ctx[0].name ?? "Allowed Wallet") + "";
		let t3;
		let t4;
		let svg;
		let path;

		return {
			c() {
				div2 = element("div");
				div0 = element("div");
				img = element("img");
				t0 = space();
				div1 = element("div");
				p0 = element("p");
				t1 = text(t1_value);
				t2 = space();
				p1 = element("p");
				t3 = text(t3_value);
				t4 = space();
				svg = svg_element("svg");
				path = svg_element("path");
				attr(img, "class", "percs-token-list-item__image rounded-full svelte-1yrar46");
				if (!src_url_equal(img.src, img_src_value = /*token*/ ctx[1].image?.src ?? "https://assets.getpercs.com/logo.svg")) attr(img, "src", img_src_value);
				attr(img, "alt", "");
				attr(div0, "class", "percs-token-list-item__image-container svelte-1yrar46");
				attr(p0, "class", "percs-token-list-item__token-name-text text-sm font-medium text-gray-900 svelte-1yrar46");
				attr(p1, "class", "percs-token-list-item__contract-name-text truncate text-sm text-gray-500 svelte-1yrar46");
				attr(div1, "class", "percs-token-list-item__text-container svelte-1yrar46");
				attr(path, "fill-rule", "evenodd");
				attr(path, "d", "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z");
				attr(path, "clip-rule", "evenodd");
				attr(svg, "class", "percs-token-list-item__icon h-5 w-5 text-green-400 svelte-1yrar46");
				attr(svg, "viewBox", "0 0 20 20");
				attr(svg, "fill", "currentColor");
				attr(svg, "aria-hidden", "true");
				attr(div2, "class", "percs-token-list-item space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400 svelte-1yrar46");
			},
			m(target, anchor) {
				insert(target, div2, anchor);
				append(div2, div0);
				append(div0, img);
				append(div2, t0);
				append(div2, div1);
				append(div1, p0);
				append(p0, t1);
				append(div1, t2);
				append(div1, p1);
				append(p1, t3);
				append(div2, t4);
				append(div2, svg);
				append(svg, path);
			},
			p(ctx, [dirty]) {
				if (dirty & /*token*/ 2 && !src_url_equal(img.src, img_src_value = /*token*/ ctx[1].image?.src ?? "https://assets.getpercs.com/logo.svg")) {
					attr(img, "src", img_src_value);
				}

				if (dirty & /*token*/ 2 && t1_value !== (t1_value = /*token*/ ctx[1].name + "")) set_data(t1, t1_value);
				if (dirty & /*contract*/ 1 && t3_value !== (t3_value = (/*contract*/ ctx[0].name ?? "Allowed Wallet") + "")) set_data(t3, t3_value);
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(div2);
			}
		};
	}

	function instance$B($$self, $$props, $$invalidate) {
		let { contract } = $$props;
		let { token } = $$props;

		$$self.$$set = $$props => {
			if ('contract' in $$props) $$invalidate(0, contract = $$props.contract);
			if ('token' in $$props) $$invalidate(1, token = $$props.token);
		};

		return [contract, token];
	}

	class PercsTokenListItem extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$B, create_fragment$B, safe_not_equal, { contract: 0, token: 1 }, add_css$r);
		}
	}

	/* dist/components/dialog-contents/OfferGate.svelte generated by Svelte v3.59.2 */

	function add_css$q(target) {
		append_styles(target, "svelte-qn5jsx", ".offer-gate__text{margin-block-end:0em}");
	}

	// (18:0) <PercsDialogHeader {state} on:close text="Unlock to Access">
	function create_default_slot_3$c(ctx) {
		let p;

		return {
			c() {
				p = element("p");
				p.textContent = "Unlock to access your exclusive content";
				attr(p, "class", "offer-gate__text");
			},
			m(target, anchor) {
				insert(target, p, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(p);
			}
		};
	}

	// (23:2) {#if $state.context.gate?.illustration}
	function create_if_block_3$a(ctx) {
		let img;
		let img_src_value;

		return {
			c() {
				img = element("img");
				if (!src_url_equal(img.src, img_src_value = /*$state*/ ctx[3].context.gate?.illustration)) attr(img, "src", img_src_value);
				attr(img, "alt", "illustration");
			},
			m(target, anchor) {
				insert(target, img, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*$state*/ 8 && !src_url_equal(img.src, img_src_value = /*$state*/ ctx[3].context.gate?.illustration)) {
					attr(img, "src", img_src_value);
				}
			},
			d(detaching) {
				if (detaching) detach(img);
			}
		};
	}

	// (28:2) {#if selectedItem}
	function create_if_block$m(ctx) {
		let current_block_type_index;
		let if_block;
		let if_block_anchor;
		let current;
		const if_block_creators = [create_if_block_1$i, create_if_block_2$c];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*selectedOffer*/ ctx[2]?.redemption.selectType === "wallet") return 0;
			if (/*selectedOffer*/ ctx[2]?.redemption.selectType === "single") return 1;
			return -1;
		}

		if (~(current_block_type_index = select_block_type(ctx))) {
			if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		}

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].m(target, anchor);
				}

				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type(ctx);

				if (current_block_type_index === previous_block_index) {
					if (~current_block_type_index) {
						if_blocks[current_block_type_index].p(ctx, dirty);
					}
				} else {
					if (if_block) {
						group_outros();

						transition_out(if_blocks[previous_block_index], 1, 1, () => {
							if_blocks[previous_block_index] = null;
						});

						check_outros();
					}

					if (~current_block_type_index) {
						if_block = if_blocks[current_block_type_index];

						if (!if_block) {
							if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
							if_block.c();
						} else {
							if_block.p(ctx, dirty);
						}

						transition_in(if_block, 1);
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					} else {
						if_block = null;
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].d(detaching);
				}

				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (31:64) 
	function create_if_block_2$c(ctx) {
		let percstokenlistitem;
		let current;

		percstokenlistitem = new PercsTokenListItem({
				props: {
					contract: /*selectedContract*/ ctx[1],
					token: /*selectedToken*/ ctx[4]
				}
			});

		return {
			c() {
				create_component(percstokenlistitem.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percstokenlistitem, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percstokenlistitem_changes = {};
				if (dirty & /*selectedContract*/ 2) percstokenlistitem_changes.contract = /*selectedContract*/ ctx[1];
				if (dirty & /*selectedToken*/ 16) percstokenlistitem_changes.token = /*selectedToken*/ ctx[4];
				percstokenlistitem.$set(percstokenlistitem_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percstokenlistitem.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percstokenlistitem.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percstokenlistitem, detaching);
			}
		};
	}

	// (29:4) {#if selectedOffer?.redemption.selectType === "wallet"}
	function create_if_block_1$i(ctx) {
		let percsofferitemcard;
		let current;

		percsofferitemcard = new PercsOfferItemCard({
				props: {
					offer: /*selectedOffer*/ ctx[2],
					item: /*selectedItem*/ ctx[5]
				}
			});

		return {
			c() {
				create_component(percsofferitemcard.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsofferitemcard, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsofferitemcard_changes = {};
				if (dirty & /*selectedOffer*/ 4) percsofferitemcard_changes.offer = /*selectedOffer*/ ctx[2];
				if (dirty & /*selectedItem*/ 32) percsofferitemcard_changes.item = /*selectedItem*/ ctx[5];
				percsofferitemcard.$set(percsofferitemcard_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsofferitemcard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsofferitemcard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsofferitemcard, detaching);
			}
		};
	}

	// (38:4) <PercsButton variant="contained" on:click={() => state.send("OFFER_REDEEM")}>
	function create_default_slot_2$h(ctx) {
		let t;

		return {
			c() {
				t = text("Unlock");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (37:2) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$l(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					$$slots: { default: [create_default_slot_2$h] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[7]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 256) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (22:0) <PercsDialogContent>
	function create_default_slot$o(ctx) {
		let t0;
		let p;
		let t1_value = (/*$state*/ ctx[3].context.gate?.description || "Connect a wallet with your NFTs to unlock this offer.") + "";
		let t1;
		let t2;
		let t3;
		let percsdialogactions;
		let current;
		let if_block0 = /*$state*/ ctx[3].context.gate?.illustration && create_if_block_3$a(ctx);
		let if_block1 = /*selectedItem*/ ctx[5] && create_if_block$m(ctx);

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$l] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				if (if_block0) if_block0.c();
				t0 = space();
				p = element("p");
				t1 = text(t1_value);
				t2 = space();
				if (if_block1) if_block1.c();
				t3 = space();
				create_component(percsdialogactions.$$.fragment);
			},
			m(target, anchor) {
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t0, anchor);
				insert(target, p, anchor);
				append(p, t1);
				insert(target, t2, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, t3, anchor);
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (/*$state*/ ctx[3].context.gate?.illustration) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_3$a(ctx);
						if_block0.c();
						if_block0.m(t0.parentNode, t0);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if ((!current || dirty & /*$state*/ 8) && t1_value !== (t1_value = (/*$state*/ ctx[3].context.gate?.description || "Connect a wallet with your NFTs to unlock this offer.") + "")) set_data(t1, t1_value);

				if (/*selectedItem*/ ctx[5]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);

						if (dirty & /*selectedItem*/ 32) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block$m(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(t3.parentNode, t3);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}

				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state*/ 257) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(if_block1);
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(if_block1);
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (if_block0) if_block0.d(detaching);
				if (detaching) detach(t0);
				if (detaching) detach(p);
				if (detaching) detach(t2);
				if (if_block1) if_block1.d(detaching);
				if (detaching) detach(t3);
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	function create_fragment$A(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Unlock to Access",
					$$slots: { default: [create_default_slot_3$c] },
					$$scope: { ctx }
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[6]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot$o] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];

				if (dirty & /*$$scope*/ 256) {
					percsdialogheader_changes.$$scope = { dirty, ctx };
				}

				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, selectedOffer, selectedItem, selectedContract, selectedToken, $state*/ 319) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$A($$self, $$props, $$invalidate) {
		let selectedOffer;
		let selectedItem;
		let selectedContract;
		let selectedToken;

		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(3, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("OFFER_REDEEM");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*$state*/ 8) {
				$$invalidate(2, selectedOffer = $state.context.offers.find(offer => offer.id === $state.context.offerSelectedId));
			}

			if ($$self.$$.dirty & /*selectedOffer, $state*/ 12) {
				$$invalidate(5, selectedItem = selectedOffer?.redemption.items.find(item => item.id === $state.context.offerSelectedItemId));
			}

			if ($$self.$$.dirty & /*selectedOffer, $state*/ 12) {
				$$invalidate(1, selectedContract = selectedOffer?.redemption.contractTokens.find(token => `${token.type}:${token.address}` === $state.context.offerSelectedContract));
			}

			if ($$self.$$.dirty & /*selectedContract, $state*/ 10) {
				$$invalidate(4, selectedToken = selectedContract?.tokens[$state.context.offerSelectedTokenId]);
			}
		};

		return [
			state,
			selectedContract,
			selectedOffer,
			$state,
			selectedToken,
			selectedItem,
			close_handler,
			click_handler
		];
	}

	class OfferGate extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$A, create_fragment$A, safe_not_equal, { state: 0 }, add_css$q);
		}
	}

	/* dist/components/internal/PercsCheckbox.svelte generated by Svelte v3.59.2 */

	function add_css$p(target) {
		append_styles(target, "svelte-6defx3", ".disabled.svelte-6defx3.svelte-6defx3.svelte-6defx3{opacity:0.5}.default.svelte-6defx3.svelte-6defx3.svelte-6defx3{--color:#d1d5db;--hover-color:#c1c6cc}.primary.svelte-6defx3.svelte-6defx3.svelte-6defx3{--color:#285fe0;--hover-color:#285fe0e0}.accent.svelte-6defx3.svelte-6defx3.svelte-6defx3{--color:#fd665f;--hover-color:#fd675fe0}label.svelte-6defx3.svelte-6defx3.svelte-6defx3{display:block;position:relative;padding-left:35px;margin-bottom:12px;font-size:14px;font-weight:400;color:black;text-align:left;line-height:1.5;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}label.svelte-6defx3 input.svelte-6defx3.svelte-6defx3{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.checkmark.svelte-6defx3.svelte-6defx3.svelte-6defx3{position:absolute;top:3px;left:0;height:16px;width:16px;border:2px solid var(--color);border-radius:4px}label.svelte-6defx3 input.svelte-6defx3~.checkmark.svelte-6defx3{background-color:transparent}label.svelte-6defx3 input.svelte-6defx3:hover~.checkmark.svelte-6defx3,label.svelte-6defx3 input.svelte-6defx3:focus~.checkmark.svelte-6defx3,label.svelte-6defx3 input.svelte-6defx3:active~.checkmark.svelte-6defx3{outline:1px solid #000}label.svelte-6defx3 input.svelte-6defx3:checked~.checkmark.svelte-6defx3{background-color:var(--color)}.checkmark.svelte-6defx3.svelte-6defx3.svelte-6defx3:after{content:\"\";position:absolute;display:none}label.svelte-6defx3 input.svelte-6defx3:checked~.checkmark.svelte-6defx3:after{display:block}label.svelte-6defx3 .checkmark.svelte-6defx3.svelte-6defx3:after{left:4.5px;top:1px;width:2.5px;height:9px;border-radius:2px;border:solid white;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}");
	}

	function create_fragment$z(ctx) {
		let label;
		let input;
		let t0;
		let t1;
		let span;
		let current;
		let mounted;
		let dispose;
		const default_slot_template = /*#slots*/ ctx[6].default;
		const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[5], null);
		let label_levels = [/*$$props*/ ctx[4], { htmlfor: /*randomId*/ ctx[3] }];
		let label_data = {};

		for (let i = 0; i < label_levels.length; i += 1) {
			label_data = assign$6(label_data, label_levels[i]);
		}

		return {
			c() {
				label = element("label");
				input = element("input");
				t0 = space();
				if (default_slot) default_slot.c();
				t1 = space();
				span = element("span");
				attr(input, "type", "checkbox");
				attr(input, "id", /*randomId*/ ctx[3]);
				input.disabled = /*disabled*/ ctx[2];
				attr(input, "class", "svelte-6defx3");
				attr(span, "class", "checkmark svelte-6defx3");
				set_attributes(label, label_data);
				toggle_class(label, "default", /*theme*/ ctx[1] === "default");
				toggle_class(label, "primary", /*theme*/ ctx[1] === "primary");
				toggle_class(label, "accent", /*theme*/ ctx[1] === "accent");
				toggle_class(label, "disabled", /*disabled*/ ctx[2]);
				toggle_class(label, "svelte-6defx3", true);
			},
			m(target, anchor) {
				insert(target, label, anchor);
				append(label, input);
				input.checked = /*checked*/ ctx[0];
				append(label, t0);

				if (default_slot) {
					default_slot.m(label, null);
				}

				append(label, t1);
				append(label, span);
				current = true;

				if (!mounted) {
					dispose = [
						listen(input, "change", /*change_handler*/ ctx[7]),
						listen(input, "change", /*input_change_handler*/ ctx[8])
					];

					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (!current || dirty & /*disabled*/ 4) {
					input.disabled = /*disabled*/ ctx[2];
				}

				if (dirty & /*checked*/ 1) {
					input.checked = /*checked*/ ctx[0];
				}

				if (default_slot) {
					if (default_slot.p && (!current || dirty & /*$$scope*/ 32)) {
						update_slot_base(
							default_slot,
							default_slot_template,
							ctx,
							/*$$scope*/ ctx[5],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[5])
							: get_slot_changes(default_slot_template, /*$$scope*/ ctx[5], dirty, null),
							null
						);
					}
				}

				set_attributes(label, label_data = get_spread_update(label_levels, [
					dirty & /*$$props*/ 16 && /*$$props*/ ctx[4],
					{ htmlfor: /*randomId*/ ctx[3] }
				]));

				toggle_class(label, "default", /*theme*/ ctx[1] === "default");
				toggle_class(label, "primary", /*theme*/ ctx[1] === "primary");
				toggle_class(label, "accent", /*theme*/ ctx[1] === "accent");
				toggle_class(label, "disabled", /*disabled*/ ctx[2]);
				toggle_class(label, "svelte-6defx3", true);
			},
			i(local) {
				if (current) return;
				transition_in(default_slot, local);
				current = true;
			},
			o(local) {
				transition_out(default_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(label);
				if (default_slot) default_slot.d(detaching);
				mounted = false;
				run_all(dispose);
			}
		};
	}

	function instance$z($$self, $$props, $$invalidate) {
		let { $$slots: slots = {}, $$scope } = $$props;
		let { theme = "accent" } = $$props;
		let { disabled = false } = $$props;
		let { checked = false } = $$props;

		// Enable support for multiple checkboxes on the same page
		const randomId = `percs-${Math.random()}`;

		function change_handler(event) {
			bubble.call(this, $$self, event);
		}

		function input_change_handler() {
			checked = this.checked;
			$$invalidate(0, checked);
		}

		$$self.$$set = $$new_props => {
			$$invalidate(4, $$props = assign$6(assign$6({}, $$props), exclude_internal_props($$new_props)));
			if ('theme' in $$new_props) $$invalidate(1, theme = $$new_props.theme);
			if ('disabled' in $$new_props) $$invalidate(2, disabled = $$new_props.disabled);
			if ('checked' in $$new_props) $$invalidate(0, checked = $$new_props.checked);
			if ('$$scope' in $$new_props) $$invalidate(5, $$scope = $$new_props.$$scope);
		};

		$$props = exclude_internal_props($$props);

		return [
			checked,
			theme,
			disabled,
			randomId,
			$$props,
			$$scope,
			slots,
			change_handler,
			input_change_handler
		];
	}

	class PercsCheckbox extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$z, create_fragment$z, safe_not_equal, { theme: 1, disabled: 2, checked: 0 }, add_css$p);
		}
	}

	/* dist/components/internal/PercsGiveawayItemCard.svelte generated by Svelte v3.59.2 */

	function add_css$o(target) {
		append_styles(target, "svelte-ik24bc", ".cards.svelte-ik24bc.svelte-ik24bc{display:grid;grid-auto-flow:row;gap:8px;justify-items:stretch;justify-content:stretch}.card.svelte-ik24bc.svelte-ik24bc{border-radius:10px;padding:14px 8px;box-sizing:border-box;border:2px solid var(--border-color, transparent)}.card__product.svelte-ik24bc.svelte-ik24bc{--border-color:#fbb338;display:grid;background-color:white;grid-template-columns:62px 1fr;grid-template-rows:repeat(2, min-content);column-gap:16px;row-gap:8px;align-content:center}.product__image.svelte-ik24bc.svelte-ik24bc{height:52px;width:62px;grid-row:1/-1}.product__image.svelte-ik24bc img.svelte-ik24bc,.product__image.svelte-ik24bc svg.svelte-ik24bc{height:52px;border-radius:8px;width:62px}.title.svelte-ik24bc.svelte-ik24bc{font-size:16px;line-height:24px;color:#161b5d;font-weight:600;text-align:left;line-height:150%;margin:0}.card--email.svelte-ik24bc.svelte-ik24bc{--border-color:#FD665F;display:grid;gap:16px;grid-auto-flow:row}.card--success.svelte-ik24bc.svelte-ik24bc{justify-content:space-between;max-height:56px;grid-auto-flow:column}.card--email.svelte-ik24bc input.svelte-ik24bc{height:36px;border-radius:4px;border:2px solid #D1D5D8;color:#161b5d;background-color:white;padding:2px 8px}.card--email.svelte-ik24bc input.svelte-ik24bc::placeholder{color:#D1D5D8}.card--twitter.svelte-ik24bc.svelte-ik24bc{--border-color:#285FE0;display:grid;align-items:center;height:56px;padding:6px 10px}.card--submit.svelte-ik24bc.svelte-ik24bc{margin-top:32px;display:grid;grid-auto-flow:row;gap:16px}.btn__twitter.svelte-ik24bc.svelte-ik24bc{display:flex;gap:16px;font-size:16px;font-weight:light;line-height:1.5;padding:0 8px}.disabled.svelte-ik24bc.svelte-ik24bc{opacity:0.5}.terms.svelte-ik24bc.svelte-ik24bc{color:var(--color);text-decoration:none}");
	}

	// (80:6) {:else}
	function create_else_block_3(ctx) {
		let svg;
		let path0;
		let mask;
		let path1;
		let g1;
		let rect;
		let g0;
		let path2;
		let path3;
		let path4;
		let path5;
		let path6;
		let path7;
		let path8;
		let path9;
		let path10;
		let path11;
		let path12;
		let path13;
		let path14;
		let path15;
		let path16;
		let path17;
		let path18;
		let path19;
		let path20;
		let path21;
		let path22;
		let path23;

		return {
			c() {
				svg = svg_element("svg");
				path0 = svg_element("path");
				mask = svg_element("mask");
				path1 = svg_element("path");
				g1 = svg_element("g");
				rect = svg_element("rect");
				g0 = svg_element("g");
				path2 = svg_element("path");
				path3 = svg_element("path");
				path4 = svg_element("path");
				path5 = svg_element("path");
				path6 = svg_element("path");
				path7 = svg_element("path");
				path8 = svg_element("path");
				path9 = svg_element("path");
				path10 = svg_element("path");
				path11 = svg_element("path");
				path12 = svg_element("path");
				path13 = svg_element("path");
				path14 = svg_element("path");
				path15 = svg_element("path");
				path16 = svg_element("path");
				path17 = svg_element("path");
				path18 = svg_element("path");
				path19 = svg_element("path");
				path20 = svg_element("path");
				path21 = svg_element("path");
				path22 = svg_element("path");
				path23 = svg_element("path");
				attr(path0, "fill-rule", "evenodd");
				attr(path0, "clip-rule", "evenodd");
				attr(path0, "d", "M-72.7552 3.24476L-76 0L272 0L268.755 3.24476L272 6.48951L268.755 9.73427L272 12.979L268.755 16.2238L272 19.4685L268.755 22.7133L272 25.958L268.755 29.2028L272 32.4476L268.755 35.6923L272 38.9371L268.755 42.1818L272 45.4266L268.755 48.6713L271.849 51.7653C252.459 51.8465 236.765 67.5906 236.765 87C236.765 106.409 252.459 122.154 271.849 122.235L268.755 125.329L272 128.573L268.755 131.818L272 135.063L268.755 138.308L272 141.552L268.755 144.797L272 148.042L268.755 151.287L272 154.531L268.755 157.776L272 161.021L268.755 164.266L272 167.51L268.755 170.755L272 174H-76L-72.7552 170.755L-76 167.51L-72.7552 164.266L-76 161.021L-72.7552 157.776L-76 154.531L-72.7552 151.287L-76 148.042L-72.7552 144.797L-76 141.552L-72.7552 138.308L-76 135.063L-72.7552 131.818L-76 128.573L-72.7552 125.329L-75.8493 122.235C-56.4588 122.154 -40.765 106.409 -40.765 87C-40.765 67.5906 -56.4588 51.8465 -75.8493 51.7653L-72.7552 48.6713L-76 45.4266L-72.7552 42.1818L-76 38.9371L-72.7552 35.6923L-76 32.4476L-72.7552 29.2028L-76 25.958L-72.7552 22.7133L-76 19.4685L-72.7552 16.2238L-76 12.979L-72.7552 9.73427L-76 6.48951L-72.7552 3.24476Z");
				attr(path0, "fill", "#F2F2F0");
				attr(path1, "fill-rule", "evenodd");
				attr(path1, "clip-rule", "evenodd");
				attr(path1, "d", "M-72.7552 3.24476L-76 0L272 0L268.755 3.24476L272 6.48951L268.755 9.73427L272 12.979L268.755 16.2238L272 19.4685L268.755 22.7133L272 25.958L268.755 29.2028L272 32.4476L268.755 35.6923L272 38.9371L268.755 42.1818L272 45.4266L268.755 48.6713L271.849 51.7653C252.459 51.8465 236.765 67.5906 236.765 87C236.765 106.409 252.459 122.154 271.849 122.235L268.755 125.329L272 128.573L268.755 131.818L272 135.063L268.755 138.308L272 141.552L268.755 144.797L272 148.042L268.755 151.287L272 154.531L268.755 157.776L272 161.021L268.755 164.266L272 167.51L268.755 170.755L272 174H-76L-72.7552 170.755L-76 167.51L-72.7552 164.266L-76 161.021L-72.7552 157.776L-76 154.531L-72.7552 151.287L-76 148.042L-72.7552 144.797L-76 141.552L-72.7552 138.308L-76 135.063L-72.7552 131.818L-76 128.573L-72.7552 125.329L-75.8493 122.235C-56.4588 122.154 -40.765 106.409 -40.765 87C-40.765 67.5906 -56.4588 51.8465 -75.8493 51.7653L-72.7552 48.6713L-76 45.4266L-72.7552 42.1818L-76 38.9371L-72.7552 35.6923L-76 32.4476L-72.7552 29.2028L-76 25.958L-72.7552 22.7133L-76 19.4685L-72.7552 16.2238L-76 12.979L-72.7552 9.73427L-76 6.48951L-72.7552 3.24476Z");
				attr(path1, "fill", "#F2F2F0");
				attr(mask, "id", "mask0_743_28802");
				set_style(mask, "mask-type", "alpha");
				attr(mask, "maskUnits", "userSpaceOnUse");
				attr(mask, "x", "-76");
				attr(mask, "y", "0");
				attr(mask, "width", "348");
				attr(mask, "height", "174");
				attr(rect, "x", "-209.846");
				attr(rect, "y", "-138.159");
				attr(rect, "width", "615.692");
				attr(rect, "height", "526.531");
				attr(path2, "d", "M7.8059 115.777C7.22794 116.927 5.31665 115.492 3.71932 113.891C2.51555 112.685 0.64073 112.283 -0.84086 113.126C-2.02684 113.8 -2.72602 115.154 -2.11798 116.376C-1.38954 117.839 -0.239116 119.152 0.693422 120.03C1.15494 120.465 1.312 121.151 1.02726 121.718C0.697356 122.374 0.961998 123.174 1.61835 123.504L3.24145 124.319L3.2488 124.323C3.84263 124.622 4.3228 124.863 4.62175 124.268C4.92193 123.671 5.8935 122.955 6.52746 123.167C10.8766 124.62 14.4564 121.618 15.5917 119.691C18.8505 114.285 10.8473 110.804 11.9344 108.641C12.4041 107.707 13.0776 107.809 13.7398 108.367C15.2743 109.661 17.4677 110.64 19.1635 109.566C20.0547 109.001 20.5826 107.994 20.106 107.053C19.4352 105.729 18.1837 104.205 17.0572 103.269C16.5432 102.842 16.3039 102.104 16.6041 101.507C16.9043 100.909 16.6635 100.182 16.0663 99.8818L15.5085 99.6014C14.7071 99.1987 13.7321 99.4342 13.2031 100.158L13.1707 100.203C12.6981 100.85 11.8715 101.113 11.0837 100.966C7.72894 100.341 5.74519 101.552 4.58342 103.863C1.5397 109.919 8.91447 113.572 7.8059 115.777Z");
				attr(path2, "fill", "#F2F2F0");
				attr(path2, "stroke", "black");
				attr(path2, "stroke-width", "1.24289");
				attr(path3, "d", "M92.0168 144.149C91.4389 145.299 89.5276 143.864 87.9303 142.263C86.7265 141.056 84.8517 140.655 83.3701 141.497C82.1841 142.172 81.4849 143.526 82.093 144.747C82.8214 146.21 83.9718 147.523 84.9044 148.402C85.3659 148.837 85.5229 149.523 85.2382 150.089C84.9083 150.746 85.1729 151.545 85.8293 151.875L87.4524 152.691L87.4597 152.695C88.0536 152.993 88.5337 153.235 88.8327 152.64C89.1329 152.043 90.1044 151.327 90.7384 151.539C95.0875 152.992 98.6673 149.99 99.8026 148.062C103.061 142.656 95.0583 139.176 96.1453 137.013C96.6151 136.078 97.2885 136.18 97.9507 136.739C99.4852 138.033 101.679 139.012 103.374 137.937C104.266 137.373 104.794 136.366 104.317 135.425C103.646 134.1 102.395 132.576 101.268 131.64C100.754 131.213 100.515 130.475 100.815 129.878C101.115 129.281 100.874 128.554 100.277 128.253L99.7194 127.973C98.9181 127.57 97.943 127.806 97.414 128.53L97.3817 128.574C96.909 129.221 96.0824 129.485 95.2947 129.338C91.9399 128.713 89.9561 129.923 88.7944 132.235C85.7506 138.29 93.1254 141.943 92.0168 144.149Z");
				attr(path3, "fill", "#F2F2F0");
				attr(path3, "stroke", "black");
				attr(path3, "stroke-width", "1.24289");
				attr(path4, "d", "M177.065 169.681C176.487 170.831 174.575 169.396 172.978 167.795C171.774 166.588 169.9 166.187 168.418 167.03C167.232 167.704 166.533 169.058 167.141 170.28C167.869 171.743 169.02 173.056 169.952 173.934C170.414 174.369 170.571 175.055 170.286 175.622C169.956 176.278 170.221 177.077 170.877 177.407L172.5 178.223L172.508 178.227C173.101 178.525 173.582 178.767 173.881 178.172C174.181 177.575 175.152 176.859 175.786 177.071C180.135 178.524 183.715 175.522 184.85 173.594C188.109 168.189 180.106 164.708 181.193 162.545C181.663 161.611 182.336 161.712 182.999 162.271C184.533 163.565 186.726 164.544 188.422 163.47C189.313 162.905 189.841 161.898 189.365 160.957C188.694 159.633 187.442 158.109 186.316 157.173C185.802 156.745 185.563 156.008 185.863 155.41C186.163 154.813 185.922 154.086 185.325 153.786L184.767 153.505C183.966 153.102 182.991 153.338 182.462 154.062L182.43 154.107C181.957 154.754 181.13 155.017 180.343 154.87C176.988 154.245 175.004 155.455 173.842 157.767C170.798 163.822 178.173 167.475 177.065 169.681Z");
				attr(path4, "fill", "#F2F2F0");
				attr(path4, "stroke", "black");
				attr(path4, "stroke-width", "1.24289");
				attr(path5, "d", "M59.2929 104.833C59.2611 106.12 56.9202 105.638 54.7922 104.872C53.1886 104.295 51.3218 104.732 50.3417 106.126C49.5571 107.242 49.5029 108.766 50.5741 109.611C51.8574 110.623 53.4582 111.319 54.6765 111.715C55.2795 111.911 55.7144 112.465 55.6988 113.099C55.6806 113.833 56.2612 114.443 56.9956 114.461L58.8117 114.506L58.8199 114.506C59.4843 114.523 60.0216 114.536 60.038 113.871C60.0545 113.202 60.6276 112.141 61.2914 112.062C65.8446 111.519 67.8002 107.276 68.0041 105.048C68.6436 98.7688 59.9204 99.0374 59.9802 96.6176C60.006 95.5719 60.6585 95.3765 61.4957 95.5989C63.4358 96.1141 65.8372 96.063 66.9122 94.3678C67.4771 93.4769 67.5246 92.3406 66.6918 91.693C65.5199 90.7818 63.7376 89.9379 62.3193 89.5722C61.6721 89.4054 61.1409 88.8405 61.1574 88.1723C61.1739 87.5041 60.6456 86.949 59.9774 86.9325L59.3533 86.917C58.4567 86.8949 57.6755 87.5241 57.5063 88.4049L57.4959 88.4587C57.3447 89.2456 56.7097 89.8368 55.9346 90.0402C52.6339 90.9067 51.3567 92.8483 51.2928 95.4344C51.1253 102.21 59.3539 102.365 59.2929 104.833Z");
				attr(path5, "fill", "#F2F2F0");
				attr(path5, "stroke", "black");
				attr(path5, "stroke-width", "1.24289");
				attr(path6, "d", "M144.471 129.927C144.439 131.214 142.098 130.732 139.97 129.966C138.366 129.389 136.5 129.826 135.519 131.221C134.735 132.337 134.681 133.86 135.752 134.705C137.035 135.717 138.636 136.413 139.854 136.81C140.457 137.006 140.892 137.559 140.877 138.193C140.858 138.927 141.439 139.537 142.173 139.556L143.989 139.6L143.998 139.601C144.662 139.617 145.199 139.63 145.216 138.965C145.232 138.297 145.805 137.235 146.469 137.156C151.022 136.613 152.978 132.37 153.182 130.143C153.821 123.863 145.098 124.132 145.158 121.712C145.184 120.666 145.836 120.471 146.673 120.693C148.613 121.208 151.015 121.157 152.09 119.462C152.655 118.571 152.702 117.435 151.87 116.787C150.698 115.876 148.915 115.032 147.497 114.666C146.85 114.5 146.319 113.935 146.335 113.266C146.352 112.598 145.823 112.043 145.155 112.027L144.531 112.011C143.634 111.989 142.853 112.618 142.684 113.499L142.674 113.553C142.522 114.34 141.887 114.931 141.112 115.134C137.812 116.001 136.534 117.943 136.471 120.529C136.303 127.304 144.532 127.46 144.471 129.927Z");
				attr(path6, "fill", "#F2F2F0");
				attr(path6, "stroke", "black");
				attr(path6, "stroke-width", "1.24289");
				attr(path7, "d", "M33.5266 28.475C32.9486 29.6248 31.0374 28.19 29.44 26.5889C28.2363 25.3824 26.3614 24.981 24.8798 25.8235C23.6939 26.4979 22.9947 27.8521 23.6027 29.0735C24.3312 30.5366 25.4816 31.8496 26.4141 32.7281C26.8756 33.1628 27.0327 33.849 26.748 34.4155C26.4181 35.0719 26.6827 35.8714 27.3391 36.2013L28.9622 37.0171L28.9695 37.0208C29.5633 37.3193 30.0435 37.5607 30.3424 36.9659C30.6426 36.3687 31.6142 35.6531 32.2482 35.8649C36.5973 37.318 40.1771 34.3158 41.3124 32.3883C44.5712 26.9827 36.568 23.5019 37.6551 21.3391C38.1248 20.4045 38.7983 20.5063 39.4605 21.0648C40.995 22.3589 43.1884 23.3378 44.8842 22.2637C45.7754 21.6992 46.3033 20.6919 45.8267 19.7508C45.1559 18.4265 43.9044 16.9025 42.7779 15.9665C42.2639 15.5393 42.0246 14.8017 42.3248 14.2044C42.625 13.6072 42.3842 12.8797 41.787 12.5796L41.2292 12.2992C40.4278 11.8964 39.4528 12.132 38.9238 12.8562L38.8914 12.9005C38.4188 13.5476 37.5922 13.811 36.8044 13.6642C33.4496 13.0387 31.4659 14.2493 30.3041 16.5607C27.2604 22.6163 34.6352 26.2694 33.5266 28.475Z");
				attr(path7, "fill", "#F2F2F0");
				attr(path7, "stroke", "black");
				attr(path7, "stroke-width", "1.24289");
				attr(path8, "d", "M117.738 56.8465C117.16 57.9964 115.248 56.5616 113.651 54.9605C112.447 53.7539 110.572 53.3526 109.091 54.1951C107.905 54.8695 107.206 56.2237 107.814 57.445C108.542 58.9082 109.693 60.2212 110.625 61.0996C111.087 61.5344 111.244 62.2206 110.959 62.7871C110.629 63.4435 110.894 64.243 111.55 64.5729L113.173 65.3887L113.18 65.3924C113.774 65.6909 114.254 65.9323 114.553 65.3375C114.854 64.7403 115.825 64.0247 116.459 64.2365C120.808 65.6896 124.388 62.6873 125.523 60.7599C128.782 55.3542 120.779 51.8734 121.866 49.7107C122.336 48.7761 123.009 48.8779 123.671 49.4364C125.206 50.7305 127.399 51.7094 129.095 50.6352C129.986 50.0708 130.514 49.0635 130.038 48.1224C129.367 46.7981 128.115 45.2741 126.989 44.338C126.475 43.9108 126.236 43.1732 126.536 42.576C126.836 41.9788 126.595 41.2513 125.998 40.9511L125.44 40.6708C124.639 40.268 123.664 40.5036 123.135 41.2278L123.102 41.2721C122.63 41.9191 121.803 42.1826 121.015 42.0358C117.661 41.4103 115.677 42.6209 114.515 44.9323C111.471 50.9879 118.846 54.641 117.738 56.8465Z");
				attr(path8, "fill", "#F2F2F0");
				attr(path8, "stroke", "black");
				attr(path8, "stroke-width", "1.24289");
				attr(path9, "d", "M202.785 82.3788C202.207 83.5286 200.296 82.0938 198.699 80.4928C197.495 79.2862 195.62 78.8848 194.139 79.7273C192.953 80.4017 192.253 81.7559 192.862 82.9773C193.59 84.4404 194.74 85.7534 195.673 86.6319C196.134 87.0666 196.291 87.7529 196.007 88.3194C195.677 88.9757 195.941 89.7752 196.598 90.1051L198.221 90.9209L198.228 90.9246C198.822 91.2231 199.302 91.4645 199.601 90.8697C199.901 90.2725 200.873 89.5569 201.507 89.7687C205.856 91.2218 209.436 88.2196 210.571 86.2921C213.83 80.8865 205.827 77.4057 206.914 75.2429C207.384 74.3083 208.057 74.4101 208.719 74.9686C210.254 76.2627 212.447 77.2416 214.143 76.1675C215.034 75.603 215.562 74.5957 215.085 73.6546C214.415 72.3303 213.163 70.8063 212.037 69.8703C211.523 69.4431 211.283 68.7055 211.584 68.1082C211.884 67.511 211.643 66.7835 211.046 66.4834L210.488 66.203C209.687 65.8002 208.712 66.0358 208.183 66.76L208.15 66.8043C207.678 67.4514 206.851 67.7149 206.063 67.568C202.708 66.9425 200.725 68.1531 199.563 70.4645C196.519 76.5201 203.894 80.1732 202.785 82.3788Z");
				attr(path9, "fill", "#F2F2F0");
				attr(path9, "stroke", "black");
				attr(path9, "stroke-width", "1.24289");
				attr(path10, "d", "M-0.163192 -7.56397C-0.194989 -6.27742 -2.53588 -6.75906 -4.66382 -7.52505C-6.26747 -8.10231 -8.13422 -7.66495 -9.11439 -6.27061C-9.899 -5.15447 -9.95318 -3.63136 -8.88195 -2.78646C-7.59863 -1.77426 -5.99781 -1.07802 -4.77952 -0.681704C-4.17658 -0.485566 -3.74161 0.0679568 -3.75727 0.7018C-3.77542 1.43618 -3.19481 2.04622 -2.46043 2.06437L-0.644396 2.10925L-0.63617 2.10946C0.0282537 2.12589 0.565504 2.13918 0.581951 1.47371C0.598466 0.8055 1.17159 -0.256378 1.83531 -0.335452C6.38856 -0.877922 8.34419 -5.12103 8.54809 -7.34867C9.18754 -13.6282 0.464303 -13.3595 0.524109 -15.7793C0.549953 -16.825 1.20242 -17.0204 2.03962 -16.7981C3.97971 -16.2829 6.38112 -16.334 7.4561 -18.0292C8.02104 -18.9201 8.0685 -20.0564 7.23571 -20.704C6.06383 -21.6152 4.28152 -22.4591 2.86327 -22.8247C2.21602 -22.9916 1.68483 -23.5565 1.70135 -24.2247C1.71786 -24.8929 1.18956 -25.448 0.521352 -25.4645L-0.102797 -25.4799C-0.999352 -25.5021 -1.78052 -24.8728 -1.94977 -23.9921L-1.96012 -23.9382C-2.11135 -23.1513 -2.74636 -22.5602 -3.52142 -22.3567C-6.82219 -21.4903 -8.09933 -19.5487 -8.16325 -16.9626C-8.33071 -10.1871 -0.102201 -10.0317 -0.163192 -7.56397Z");
				attr(path10, "fill", "#F2F2F0");
				attr(path10, "stroke", "black");
				attr(path10, "stroke-width", "1.24289");
				attr(path11, "d", "M85.0145 17.5303C84.9827 18.8168 82.6419 18.3352 80.5139 17.5692C78.9103 16.9919 77.0435 17.4293 76.0633 18.8236C75.2787 19.9398 75.2246 21.4629 76.2958 22.3078C77.5791 23.32 79.1799 24.0162 80.3982 24.4125C81.0012 24.6087 81.4361 25.1622 81.4205 25.796C81.4023 26.5304 81.9829 27.1405 82.7173 27.1586L84.5333 27.2035L84.5416 27.2037C85.206 27.2201 85.7432 27.2334 85.7597 26.5679C85.7762 25.8997 86.3493 24.8379 87.013 24.7588C91.5663 24.2163 93.5219 19.9732 93.7258 17.7456C94.3653 11.466 85.642 11.7347 85.7018 9.31491C85.7277 8.26921 86.3802 8.07379 87.2174 8.29614C89.1574 8.81138 91.5589 8.76027 92.6338 7.06503C93.1988 6.17412 93.2462 5.03786 92.4134 4.39028C91.2416 3.47902 89.4593 2.63513 88.041 2.26951C87.3938 2.10265 86.8626 1.53774 86.8791 0.869527C86.8956 0.201317 86.3673 -0.353761 85.6991 -0.370276L85.0749 -0.385702C84.1784 -0.407861 83.3972 0.221404 83.228 1.10212L83.2176 1.15599C83.0664 1.94291 82.4314 2.53404 81.6563 2.7375C78.3555 3.60397 77.0784 5.54554 77.0145 8.13169C76.847 14.9071 85.0755 15.0625 85.0145 17.5303Z");
				attr(path11, "fill", "#F2F2F0");
				attr(path11, "stroke", "black");
				attr(path11, "stroke-width", "1.24289");
				attr(path12, "d", "M170.19 42.625C170.159 43.9115 167.818 43.4299 165.69 42.6639C164.086 42.0867 162.219 42.524 161.239 43.9183C160.455 45.0345 160.4 46.5576 161.472 47.4025C162.755 48.4147 164.356 49.1109 165.574 49.5073C166.177 49.7034 166.612 50.2569 166.596 50.8908C166.578 51.6251 167.159 52.2352 167.893 52.2533L169.709 52.2982L169.717 52.2984C170.382 52.3149 170.919 52.3281 170.935 51.6627C170.952 50.9945 171.525 49.9326 172.189 49.8535C176.742 49.311 178.698 45.0679 178.902 42.8403C179.541 36.5608 170.818 36.8294 170.878 34.4096C170.903 33.3639 171.556 33.1685 172.393 33.3909C174.333 33.9061 176.735 33.855 177.81 32.1598C178.375 31.2688 178.422 30.1326 177.589 29.485C176.417 28.5737 174.635 27.7299 173.217 27.3642C172.57 27.1974 172.038 26.6325 172.055 25.9643C172.071 25.296 171.543 24.741 170.875 24.7245L170.251 24.709C169.354 24.6869 168.573 25.3161 168.404 26.1968L168.393 26.2507C168.242 27.0376 167.607 27.6288 166.832 27.8322C163.531 28.6987 162.254 30.6403 162.19 33.2264C162.023 40.0019 170.251 40.1573 170.19 42.625Z");
				attr(path12, "fill", "#F2F2F0");
				attr(path12, "stroke", "black");
				attr(path12, "stroke-width", "1.24289");
				attr(path13, "d", "M-5.05446 159.429C-5.63241 160.578 -7.5437 159.144 -9.14103 157.543C-10.3448 156.336 -12.2196 155.935 -13.7012 156.777C-14.8872 157.452 -15.5864 158.806 -14.9783 160.027C-14.2499 161.49 -13.0995 162.803 -12.1669 163.682C-11.7054 164.116 -11.5484 164.803 -11.8331 165.369C-12.163 166.026 -11.8984 166.825 -11.242 167.155L-9.6189 167.971L-9.61155 167.974C-9.01772 168.273 -8.53755 168.514 -8.23861 167.92C-7.93843 167.322 -6.96685 166.607 -6.33289 166.819C-1.98377 168.272 1.59601 165.269 2.73133 163.342C5.99018 157.936 -2.01301 154.455 -0.925965 152.293C-0.456208 151.358 0.21724 151.46 0.879416 152.018C2.41391 153.313 4.60734 154.291 6.30312 153.217C7.19432 152.653 7.72227 151.646 7.24561 150.704C6.57487 149.38 5.32335 147.856 4.19689 146.92C3.6828 146.493 3.44359 145.755 3.74377 145.158C4.04395 144.561 3.80315 143.833 3.20594 143.533L2.6481 143.253C1.84679 142.85 0.871759 143.086 0.342748 143.81L0.310389 143.854C-0.162285 144.501 -0.988878 144.765 -1.77662 144.618C-5.13141 143.992 -7.11516 145.203 -8.27693 147.514C-11.3207 153.57 -3.94589 157.223 -5.05446 159.429Z");
				attr(path13, "fill", "#F2F2F0");
				attr(path13, "stroke", "black");
				attr(path13, "stroke-width", "1.24289");
				attr(path14, "d", "M79.1565 187.801C78.5785 188.951 76.6672 187.516 75.0699 185.915C73.8661 184.708 71.9913 184.307 70.5097 185.149C69.3237 185.824 68.6246 187.178 69.2326 188.399C69.961 189.862 71.1115 191.175 72.044 192.054C72.5055 192.488 72.6626 193.175 72.3778 193.741C72.0479 194.398 72.3126 195.197 72.9689 195.527L74.592 196.343L74.5994 196.347C75.1932 196.645 75.6734 196.886 75.9723 196.292C76.2725 195.694 77.2441 194.979 77.8781 195.191C82.2272 196.644 85.8069 193.641 86.9423 191.714C90.2011 186.308 82.1979 182.828 83.285 180.665C83.7547 179.73 84.4282 179.832 85.0904 180.39C86.6248 181.685 88.8183 182.663 90.5141 181.589C91.4053 181.025 91.9332 180.018 91.4566 179.076C90.7858 177.752 89.5343 176.228 88.4078 175.292C87.8937 174.865 87.6545 174.127 87.9547 173.53C88.2549 172.933 88.0141 172.205 87.4169 171.905L86.859 171.625C86.0577 171.222 85.0827 171.458 84.5537 172.182L84.5213 172.226C84.0487 172.873 83.2221 173.137 82.4343 172.99C79.0795 172.364 77.0958 173.575 75.934 175.886C72.8903 181.942 80.2651 185.595 79.1565 187.801Z");
				attr(path14, "fill", "#F2F2F0");
				attr(path14, "stroke", "black");
				attr(path14, "stroke-width", "1.24289");
				attr(path15, "d", "M46.4335 148.484C46.4017 149.771 44.0608 149.289 41.9329 148.523C40.3292 147.946 38.4625 148.383 37.4823 149.778C36.6977 150.894 36.6435 152.417 37.7147 153.262C38.998 154.274 40.5989 154.97 41.8172 155.367C42.4201 155.563 42.8551 156.116 42.8394 156.75C42.8213 157.485 43.4019 158.095 44.1362 158.113L45.9523 158.158L45.9605 158.158C46.6249 158.174 47.1622 158.188 47.1786 157.522C47.1951 156.854 47.7683 155.792 48.432 155.713C52.9852 155.17 54.9409 150.927 55.1448 148.7C55.7842 142.42 47.061 142.689 47.1208 140.269C47.1466 139.223 47.7991 139.028 48.6363 139.25C50.5764 139.765 52.9778 139.714 54.0528 138.019C54.6177 137.128 54.6652 135.992 53.8324 135.344C52.6605 134.433 50.8782 133.589 49.4599 133.224C48.8127 133.057 48.2815 132.492 48.298 131.824C48.3145 131.155 47.7862 130.6 47.118 130.584L46.4939 130.568C45.5973 130.546 44.8162 131.176 44.6469 132.056L44.6366 132.11C44.4853 132.897 43.8503 133.488 43.0753 133.692C39.7745 134.558 38.4973 136.5 38.4334 139.086C38.266 145.861 46.4945 146.017 46.4335 148.484Z");
				attr(path15, "fill", "#F2F2F0");
				attr(path15, "stroke", "black");
				attr(path15, "stroke-width", "1.24289");
				attr(path16, "d", "M131.61 173.579C131.578 174.865 129.238 174.384 127.11 173.618C125.506 173.04 123.639 173.478 122.659 174.872C121.874 175.988 121.82 177.511 122.891 178.356C124.175 179.368 125.776 180.065 126.994 180.461C127.597 180.657 128.032 181.211 128.016 181.844C127.998 182.579 128.579 183.189 129.313 183.207L131.129 183.252L131.137 183.252C131.802 183.268 132.339 183.282 132.355 182.616C132.372 181.948 132.945 180.886 133.609 180.807C138.162 180.265 140.118 176.022 140.322 173.794C140.961 167.514 132.238 167.783 132.298 165.363C132.323 164.318 132.976 164.122 133.813 164.344C135.753 164.86 138.155 164.809 139.23 163.113C139.794 162.222 139.842 161.086 139.009 160.439C137.837 159.527 136.055 158.683 134.637 158.318C133.989 158.151 133.458 157.586 133.475 156.918C133.491 156.25 132.963 155.695 132.295 155.678L131.671 155.663C130.774 155.64 129.993 156.27 129.824 157.15L129.813 157.204C129.662 157.991 129.027 158.582 128.252 158.786C124.951 159.652 123.674 161.594 123.61 164.18C123.443 170.955 131.671 171.111 131.61 173.579Z");
				attr(path16, "fill", "#F2F2F0");
				attr(path16, "stroke", "black");
				attr(path16, "stroke-width", "1.24289");
				attr(path17, "d", "M20.6662 72.1263C20.0883 73.2762 18.177 71.8414 16.5797 70.2403C15.3759 69.0337 13.5011 68.6324 12.0195 69.4749C10.8335 70.1493 10.1343 71.5035 10.7424 72.7248C11.4708 74.188 12.6212 75.501 13.5538 76.3794C14.0153 76.8142 14.1724 77.5004 13.8876 78.0669C13.5577 78.7233 13.8223 79.5228 14.4787 79.8527L16.1018 80.6685L16.1092 80.6722C16.703 80.9707 17.1832 81.212 17.4821 80.6173C17.7823 80.0201 18.7539 79.3044 19.3878 79.5163C23.7369 80.9694 27.3167 77.9671 28.452 76.0397C31.7109 70.634 23.7077 67.1532 24.7947 64.9905C25.2645 64.0559 25.9379 64.1577 26.6001 64.7162C28.1346 66.0103 30.328 66.9892 32.0238 65.915C32.915 65.3505 33.443 64.3433 32.9663 63.4022C32.2956 62.0778 31.0441 60.5539 29.9176 59.6178C29.4035 59.1906 29.1643 58.453 29.4645 57.8558C29.7647 57.2586 29.5239 56.5311 28.9266 56.2309L28.3688 55.9505C27.5675 55.5478 26.5925 55.7834 26.0635 56.5076L26.0311 56.5519C25.5584 57.1989 24.7318 57.4624 23.9441 57.3155C20.5893 56.6901 18.6055 57.9007 17.4438 60.2121C14.4001 66.2677 21.7748 69.9208 20.6662 72.1263Z");
				attr(path17, "fill", "#F2F2F0");
				attr(path17, "stroke", "black");
				attr(path17, "stroke-width", "1.24289");
				attr(path18, "d", "M104.877 100.498C104.299 101.648 102.388 100.213 100.791 98.6124C99.5868 97.4058 97.712 97.0044 96.2304 97.8469C95.0444 98.5213 94.3453 99.8756 94.9533 101.097C95.6817 102.56 96.8322 103.873 97.7647 104.751C98.2262 105.186 98.3833 105.872 98.0985 106.439C97.7686 107.095 98.0333 107.895 98.6896 108.225L100.313 109.041L100.32 109.044C100.914 109.343 101.394 109.584 101.693 108.989C101.993 108.392 102.965 107.677 103.599 107.888C107.948 109.341 111.528 106.339 112.663 104.412C115.922 99.0061 107.919 95.5253 109.006 93.3626C109.475 92.428 110.149 92.5298 110.811 93.0882C112.346 94.3824 114.539 95.3612 116.235 94.2871C117.126 93.7226 117.654 92.7153 117.177 91.7742C116.507 90.4499 115.255 88.9259 114.129 87.9899C113.614 87.5627 113.375 86.8251 113.675 86.2279C113.976 85.6307 113.735 84.9032 113.138 84.603L112.58 84.3226C111.778 83.9199 110.803 84.1554 110.274 84.8796L110.242 84.9239C109.769 85.571 108.943 85.8345 108.155 85.6876C104.8 85.0621 102.816 86.2727 101.655 88.5841C98.611 94.6397 105.986 98.2929 104.877 100.498Z");
				attr(path18, "fill", "#F2F2F0");
				attr(path18, "stroke", "black");
				attr(path18, "stroke-width", "1.24289");
				attr(path19, "d", "M189.925 126.03C189.347 127.18 187.436 125.745 185.838 124.144C184.635 122.938 182.76 122.536 181.278 123.379C180.092 124.053 179.393 125.407 180.001 126.629C180.73 128.092 181.88 129.405 182.813 130.283C183.274 130.718 183.431 131.404 183.146 131.971C182.816 132.627 183.081 133.427 183.737 133.756L185.361 134.572L185.368 134.576C185.962 134.874 186.442 135.116 186.741 134.521C187.041 133.924 188.013 133.208 188.647 133.42C192.996 134.873 196.576 131.871 197.711 129.943C200.97 124.538 192.966 121.057 194.054 118.894C194.523 117.96 195.197 118.062 195.859 118.62C197.393 119.914 199.587 120.893 201.283 119.819C202.174 119.254 202.702 118.247 202.225 117.306C201.554 115.982 200.303 114.458 199.176 113.522C198.662 113.094 198.423 112.357 198.723 111.76C199.023 111.162 198.783 110.435 198.185 110.135L197.628 109.854C196.826 109.452 195.851 109.687 195.322 110.411L195.29 110.456C194.817 111.103 193.991 111.366 193.203 111.219C189.848 110.594 187.864 111.804 186.703 114.116C183.659 120.171 191.034 123.825 189.925 126.03Z");
				attr(path19, "fill", "#F2F2F0");
				attr(path19, "stroke", "black");
				attr(path19, "stroke-width", "1.24289");
				attr(path20, "d", "M72.1542 61.1821C72.1224 62.4687 69.7815 61.987 67.6536 61.221C66.0499 60.6438 64.1832 61.0811 63.203 62.4755C62.4184 63.5916 62.3642 65.1147 63.4354 65.9596C64.7187 66.9718 66.3196 67.6681 67.5379 68.0644C68.1408 68.2605 68.5758 68.8141 68.5601 69.4479C68.542 70.1823 69.1226 70.7923 69.857 70.8105L71.673 70.8553L71.6812 70.8555C72.3456 70.872 72.8829 70.8853 72.8993 70.2198C72.9158 69.5516 73.489 68.4897 74.1527 68.4106C78.7059 67.8682 80.6616 63.6251 80.8655 61.3974C81.5049 55.1179 72.7817 55.3866 72.8415 52.9668C72.8673 51.9211 73.5198 51.7256 74.357 51.948C76.2971 52.4632 78.6985 52.4121 79.7735 50.7169C80.3384 49.826 80.3859 48.6897 79.5531 48.0421C78.3812 47.1309 76.5989 46.287 75.1807 45.9214C74.5334 45.7545 74.0022 45.1896 74.0187 44.5214C74.0352 43.8532 73.5069 43.2981 72.8387 43.2816L72.2146 43.2662C71.318 43.244 70.5369 43.8733 70.3676 44.754L70.3573 44.8078C70.206 45.5948 69.571 46.1859 68.796 46.3894C65.4952 47.2558 64.218 49.1974 64.1541 51.7835C63.9867 58.559 72.2152 58.7144 72.1542 61.1821Z");
				attr(path20, "fill", "#F2F2F0");
				attr(path20, "stroke", "black");
				attr(path20, "stroke-width", "1.24289");
				attr(path21, "d", "M157.331 86.2764C157.299 87.5629 154.958 87.0813 152.83 86.3153C151.227 85.738 149.36 86.1754 148.38 87.5697C147.595 88.6859 147.541 90.209 148.612 91.0539C149.896 92.0661 151.496 92.7623 152.715 93.1586C153.318 93.3548 153.753 93.9083 153.737 94.5421C153.719 95.2765 154.299 95.8866 155.034 95.9047L156.85 95.9496L156.858 95.9498C157.522 95.9662 158.06 95.9795 158.076 95.314C158.093 94.6458 158.666 93.584 159.329 93.5049C163.883 92.9624 165.838 88.7193 166.042 86.4917C166.682 80.2121 157.958 80.4808 158.018 78.061C158.044 77.0153 158.697 76.8199 159.534 77.0422C161.474 77.5575 163.875 77.5064 164.95 75.8111C165.515 74.9202 165.563 73.784 164.73 73.1364C163.558 72.2251 161.776 71.3812 160.357 71.0156C159.71 70.8487 159.179 70.2838 159.195 69.6156C159.212 68.9474 158.684 68.3923 158.015 68.3758L157.391 68.3604C156.495 68.3382 155.714 68.9675 155.544 69.8482L155.534 69.9021C155.383 70.689 154.748 71.2801 153.973 71.4836C150.672 72.3501 149.395 74.2916 149.331 76.8778C149.163 83.6532 157.392 83.8086 157.331 86.2764Z");
				attr(path21, "fill", "#F2F2F0");
				attr(path21, "stroke", "black");
				attr(path21, "stroke-width", "1.24289");
				attr(path22, "d", "M130.598 13.1957C130.02 14.3455 128.109 12.9107 126.511 11.3096C125.308 10.1031 123.433 9.70169 121.951 10.5442C120.765 11.2186 120.066 12.5728 120.674 13.7942C121.402 15.2573 122.553 16.5703 123.485 17.4488C123.947 17.8835 124.104 18.5697 123.819 19.1362C123.489 19.7926 123.754 20.5921 124.41 20.922L126.033 21.7378L126.041 21.7415C126.635 22.04 127.115 22.2814 127.414 21.6866C127.714 21.0894 128.685 20.3738 129.319 20.5856C133.669 22.0387 137.248 19.0365 138.384 17.109C141.643 11.7034 133.639 8.22256 134.726 6.05984C135.196 5.12524 135.87 5.22704 136.532 5.78549C138.066 7.07962 140.26 8.0585 141.955 6.98437C142.847 6.41987 143.375 5.4126 142.898 4.47149C142.227 3.14718 140.976 1.62321 139.849 0.687154C139.335 0.259964 139.096 -0.477639 139.396 -1.07486C139.696 -1.67208 139.455 -2.39956 138.858 -2.69974L138.3 -2.98012C137.499 -3.38288 136.524 -3.14729 135.995 -2.42311L135.963 -2.37881C135.49 -1.73174 134.663 -1.46825 133.876 -1.61512C130.521 -2.24059 128.537 -1.02999 127.375 1.2814C124.332 7.33701 131.706 10.9901 130.598 13.1957Z");
				attr(path22, "fill", "#F2F2F0");
				attr(path22, "stroke", "black");
				attr(path22, "stroke-width", "1.24289");
				attr(path23, "d", "M183.051 -1.02588C183.019 0.26067 180.678 -0.22097 178.55 -0.986961C176.946 -1.56422 175.08 -1.12687 174.099 0.267471C173.315 1.38361 173.261 2.90673 174.332 3.75163C175.615 4.76382 177.216 5.46007 178.434 5.85638C179.037 6.05252 179.472 6.60604 179.457 7.23989C179.438 7.97426 180.019 8.5843 180.753 8.60245L182.569 8.64734L182.578 8.64754C183.242 8.66397 183.779 8.67726 183.796 8.0118C183.812 7.34359 184.385 6.28171 185.049 6.20263C189.602 5.66016 191.558 1.41706 191.762 -0.810584C192.401 -7.0901 183.678 -6.82144 183.738 -9.24125C183.764 -10.2869 184.416 -10.4824 185.253 -10.26C187.194 -9.74477 189.595 -9.79588 190.67 -11.4911C191.235 -12.382 191.282 -13.5183 190.45 -14.1659C189.278 -15.0771 187.495 -15.921 186.077 -16.2866C185.43 -16.4535 184.899 -17.0184 184.915 -17.6866C184.932 -18.3548 184.403 -18.9099 183.735 -18.9264L183.111 -18.9419C182.215 -18.964 181.433 -18.3347 181.264 -17.454L181.254 -17.4002C181.103 -16.6132 180.468 -16.0221 179.692 -15.8187C176.392 -14.9522 175.115 -13.0106 175.051 -10.4245C174.883 -3.64902 183.112 -3.49361 183.051 -1.02588Z");
				attr(path23, "fill", "#F2F2F0");
				attr(path23, "stroke", "black");
				attr(path23, "stroke-width", "1.24289");
				attr(g0, "opacity", "0.3");
				attr(g1, "mask", "url(#mask0_743_28802)");
				set_style(svg, "width", "100%");
				attr(svg, "width", "197");
				attr(svg, "height", "168");
				attr(svg, "viewBox", "0 0 197 168");
				attr(svg, "fill", "none");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(svg, "class", "svelte-ik24bc");
			},
			m(target, anchor) {
				insert(target, svg, anchor);
				append(svg, path0);
				append(svg, mask);
				append(mask, path1);
				append(svg, g1);
				append(g1, rect);
				append(g1, g0);
				append(g0, path2);
				append(g0, path3);
				append(g0, path4);
				append(g0, path5);
				append(g0, path6);
				append(g0, path7);
				append(g0, path8);
				append(g0, path9);
				append(g0, path10);
				append(g0, path11);
				append(g0, path12);
				append(g0, path13);
				append(g0, path14);
				append(g0, path15);
				append(g0, path16);
				append(g0, path17);
				append(g0, path18);
				append(g0, path19);
				append(g0, path20);
				append(g0, path21);
				append(g0, path22);
				append(g0, path23);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(svg);
			}
		};
	}

	// (78:33) 
	function create_if_block_7$3(ctx) {
		let img;
		let img_src_value;
		let img_alt_value;

		return {
			c() {
				img = element("img");
				if (!src_url_equal(img.src, img_src_value = /*offer*/ ctx[1].image.src)) attr(img, "src", img_src_value);
				attr(img, "alt", img_alt_value = /*item*/ ctx[2].name);
				attr(img, "class", "svelte-ik24bc");
			},
			m(target, anchor) {
				insert(target, img, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*offer*/ 2 && !src_url_equal(img.src, img_src_value = /*offer*/ ctx[1].image.src)) {
					attr(img, "src", img_src_value);
				}

				if (dirty & /*item*/ 4 && img_alt_value !== (img_alt_value = /*item*/ ctx[2].name)) {
					attr(img, "alt", img_alt_value);
				}
			},
			d(detaching) {
				if (detaching) detach(img);
			}
		};
	}

	// (76:6) {#if item.image?.src}
	function create_if_block_6$3(ctx) {
		let img;
		let img_src_value;
		let img_alt_value;

		return {
			c() {
				img = element("img");
				if (!src_url_equal(img.src, img_src_value = /*item*/ ctx[2].image.src)) attr(img, "src", img_src_value);
				attr(img, "alt", img_alt_value = /*item*/ ctx[2].name);
				attr(img, "class", "svelte-ik24bc");
			},
			m(target, anchor) {
				insert(target, img, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*item*/ 4 && !src_url_equal(img.src, img_src_value = /*item*/ ctx[2].image.src)) {
					attr(img, "src", img_src_value);
				}

				if (dirty & /*item*/ 4 && img_alt_value !== (img_alt_value = /*item*/ ctx[2].name)) {
					attr(img, "alt", img_alt_value);
				}
			},
			d(detaching) {
				if (detaching) detach(img);
			}
		};
	}

	// (118:4) {#if countdownDate != null}
	function create_if_block_5$5(ctx) {
		let percscountdown;
		let current;

		percscountdown = new PercsCountdown({
				props: { date: /*countdownDate*/ ctx[10] }
			});

		return {
			c() {
				create_component(percscountdown.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percscountdown, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percscountdown_changes = {};
				if (dirty & /*countdownDate*/ 1024) percscountdown_changes.date = /*countdownDate*/ ctx[10];
				percscountdown.$set(percscountdown_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percscountdown.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percscountdown.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percscountdown, detaching);
			}
		};
	}

	// (129:2) {:else}
	function create_else_block_2$1(ctx) {
		let section;
		let h2;
		let t0;
		let t1;
		let svg;
		let path;

		return {
			c() {
				section = element("section");
				h2 = element("h2");
				t0 = text(/*email*/ ctx[7]);
				t1 = space();
				svg = svg_element("svg");
				path = svg_element("path");
				attr(h2, "class", "title svelte-ik24bc");
				attr(path, "fill-rule", "evenodd");
				attr(path, "clip-rule", "evenodd");
				attr(path, "d", "M7.52032 4.14634C8.292 4.08476 9.02459 3.78131 9.61379 3.27919C10.9888 2.10746 13.011 2.10746 14.386 3.27919C14.9752 3.78131 15.7078 4.08476 16.4795 4.14634C18.2803 4.29004 19.7103 5.72002 19.854 7.52081C19.9155 8.29249 20.219 9.02508 20.7211 9.61428C21.8928 10.9892 21.8928 13.0115 20.7211 14.3865C20.219 14.9757 19.9155 15.7083 19.854 16.48C19.7103 18.2808 18.2803 19.7107 16.4795 19.8544C15.7078 19.916 14.9752 20.2195 14.386 20.7216C13.011 21.8933 10.9888 21.8933 9.61379 20.7216C9.02459 20.2195 8.292 19.916 7.52032 19.8544C5.71953 19.7107 4.28955 18.2808 4.14585 16.48C4.08427 15.7083 3.78082 14.9757 3.2787 14.3865C2.10697 13.0115 2.10697 10.9892 3.2787 9.61428C3.78082 9.02508 4.08427 8.29249 4.14585 7.52081C4.28955 5.72002 5.71953 4.29004 7.52032 4.14634ZM16.4484 10.4489C16.9171 9.98029 16.9171 9.22049 16.4484 8.75186C15.9798 8.28323 15.22 8.28323 14.7514 8.75186L10.7999 12.7033L9.24843 11.1519C8.7798 10.6832 8.02 10.6832 7.55137 11.1519C7.08275 11.6205 7.08275 12.3803 7.55137 12.8489L9.95137 15.2489C10.42 15.7175 11.1798 15.7175 11.6484 15.2489L16.4484 10.4489Z");
				attr(path, "fill", "#285FE0");
				attr(svg, "width", "24");
				attr(svg, "height", "24");
				attr(svg, "viewBox", "0 0 24 24");
				attr(svg, "fill", "none");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(section, "class", "card card--email card--success svelte-ik24bc");
			},
			m(target, anchor) {
				insert(target, section, anchor);
				append(section, h2);
				append(h2, t0);
				append(section, t1);
				append(section, svg);
				append(svg, path);
			},
			p(ctx, dirty) {
				if (dirty & /*email*/ 128) set_data(t0, /*email*/ ctx[7]);
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(section);
			}
		};
	}

	// (123:2) {#if $state.matches("modal.open.offer.giveaway.init")}
	function create_if_block_4$7(ctx) {
		let form;
		let h2;
		let t1;
		let input;
		let t2;
		let percsbutton;
		let current;
		let mounted;
		let dispose;

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					type: "submit",
					disabled: !/*email*/ ctx[7],
					$$slots: { default: [create_default_slot_3$b] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				form = element("form");
				h2 = element("h2");
				h2.textContent = "Enter email";
				t1 = space();
				input = element("input");
				t2 = space();
				create_component(percsbutton.$$.fragment);
				attr(h2, "class", "title svelte-ik24bc");
				attr(input, "type", "email");
				attr(input, "name", "email");
				attr(input, "placeholder", "example@mail.com");
				input.required = true;
				input.disabled = /*disabled*/ ctx[5];
				attr(input, "class", "svelte-ik24bc");
				attr(form, "class", "card card--email svelte-ik24bc");
			},
			m(target, anchor) {
				insert(target, form, anchor);
				append(form, h2);
				append(form, t1);
				append(form, input);
				set_input_value(input, /*email*/ ctx[7]);
				append(form, t2);
				mount_component(percsbutton, form, null);
				current = true;

				if (!mounted) {
					dispose = [
						listen(input, "input", /*input_input_handler*/ ctx[15]),
						listen(form, "submit", prevent_default(/*handleSaveEmail*/ ctx[12]))
					];

					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (!current || dirty & /*disabled*/ 32) {
					input.disabled = /*disabled*/ ctx[5];
				}

				if (dirty & /*email*/ 128 && input.value !== /*email*/ ctx[7]) {
					set_input_value(input, /*email*/ ctx[7]);
				}

				const percsbutton_changes = {};
				if (dirty & /*email*/ 128) percsbutton_changes.disabled = !/*email*/ ctx[7];

				if (dirty & /*$$scope*/ 1048576) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(form);
				destroy_component(percsbutton);
				mounted = false;
				run_all(dispose);
			}
		};
	}

	// (127:6) <PercsButton variant="contained" type="submit" disabled={!email}>
	function create_default_slot_3$b(ctx) {
		let t;

		return {
			c() {
				t = text("Submit");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (148:4) {:else}
	function create_else_block_1$2(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					as: "a",
					variant: "contained",
					theme: "primary",
					href: `https://x.com/intent/tweet?text=${/*item*/ ctx[2].socialsShareMessage}`,
					size: "small",
					target: "_blank",
					disabled: /*$state*/ ctx[11].matches("modal.open.offer.giveaway.init"),
					$$slots: { default: [create_default_slot_2$g] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*handleShareOnTwitter*/ ctx[13]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};
				if (dirty & /*item*/ 4) percsbutton_changes.href = `https://x.com/intent/tweet?text=${/*item*/ ctx[2].socialsShareMessage}`;
				if (dirty & /*$state*/ 2048) percsbutton_changes.disabled = /*$state*/ ctx[11].matches("modal.open.offer.giveaway.init");

				if (dirty & /*$$scope, processingTwitter*/ 1048640) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (144:4) {#if sharedOnTwitter}
	function create_if_block_3$9(ctx) {
		let svg;
		let path;

		return {
			c() {
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "fill-rule", "evenodd");
				attr(path, "clip-rule", "evenodd");
				attr(path, "d", "M7.52032 4.14634C8.292 4.08476 9.02459 3.78131 9.61379 3.27919C10.9888 2.10746 13.011 2.10746 14.386 3.27919C14.9752 3.78131 15.7078 4.08476 16.4795 4.14634C18.2803 4.29004 19.7103 5.72002 19.854 7.52081C19.9155 8.29249 20.219 9.02508 20.7211 9.61428C21.8928 10.9892 21.8928 13.0115 20.7211 14.3865C20.219 14.9757 19.9155 15.7083 19.854 16.48C19.7103 18.2808 18.2803 19.7107 16.4795 19.8544C15.7078 19.916 14.9752 20.2195 14.386 20.7216C13.011 21.8933 10.9888 21.8933 9.61379 20.7216C9.02459 20.2195 8.292 19.916 7.52032 19.8544C5.71953 19.7107 4.28955 18.2808 4.14585 16.48C4.08427 15.7083 3.78082 14.9757 3.2787 14.3865C2.10697 13.0115 2.10697 10.9892 3.2787 9.61428C3.78082 9.02508 4.08427 8.29249 4.14585 7.52081C4.28955 5.72002 5.71953 4.29004 7.52032 4.14634ZM16.4484 10.4489C16.9171 9.98029 16.9171 9.22049 16.4484 8.75186C15.9798 8.28323 15.22 8.28323 14.7514 8.75186L10.7999 12.7033L9.24843 11.1519C8.7798 10.6832 8.02 10.6832 7.55137 11.1519C7.08275 11.6205 7.08275 12.3803 7.55137 12.8489L9.95137 15.2489C10.42 15.7175 11.1798 15.7175 11.6484 15.2489L16.4484 10.4489Z");
				attr(path, "fill", "#285FE0");
				attr(svg, "width", "24");
				attr(svg, "height", "24");
				attr(svg, "viewBox", "0 0 24 24");
				attr(svg, "fill", "none");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			},
			m(target, anchor) {
				insert(target, svg, anchor);
				append(svg, path);
			},
			p: noop$6,
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(svg);
			}
		};
	}

	// (149:6) <PercsButton         as="a"         variant="contained"         theme="primary"         href={`https://x.com/intent/tweet?text=${item.socialsShareMessage}`}         size="small"         target="_blank"         disabled={$state.matches("modal.open.offer.giveaway.init")}         on:click={handleShareOnTwitter}       >
	function create_default_slot_2$g(ctx) {
		let div;
		let span;
		let t0_value = (/*processingTwitter*/ ctx[6] ? "Processing" : "Tweet") + "";
		let t0;
		let t1;
		let svg;
		let path;

		return {
			c() {
				div = element("div");
				span = element("span");
				t0 = text(t0_value);
				t1 = space();
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "d", "M7.91856 21C16.2205 21 20.7613 14.0743 20.7613 8.0683C20.7613 7.87158 20.7613 7.67576 20.7481 7.48082C21.6315 6.83743 22.394 6.0408 23 5.12823C22.1763 5.49596 21.3024 5.73701 20.4075 5.84331C21.3498 5.27537 22.0551 4.38197 22.3919 3.32945C21.5059 3.8589 20.5366 4.232 19.5258 4.43264C18.8452 3.70399 17.9452 3.2215 16.9648 3.05982C15.9845 2.89815 14.9786 3.06631 14.1028 3.53829C13.227 4.01026 12.53 4.75974 12.1198 5.67073C11.7097 6.58173 11.6091 7.60345 11.8337 8.5778C10.0392 8.48716 8.28361 8.01756 6.681 7.19948C5.07839 6.38141 3.66453 5.23314 2.5312 3.82921C1.954 4.82976 1.77722 6.0142 2.03684 7.14139C2.29647 8.26857 2.97298 9.25374 3.92864 9.89632C3.2103 9.87512 2.50759 9.67999 1.88 9.32744V9.38504C1.88029 10.4344 2.24103 11.4513 2.90105 12.2633C3.56107 13.0754 4.47972 13.6326 5.5012 13.8403C4.83669 14.0228 4.13947 14.0495 3.46312 13.9183C3.75166 14.8213 4.31323 15.611 5.0693 16.1769C5.82538 16.7428 6.73817 17.0566 7.68008 17.0746C6.74424 17.8153 5.67254 18.3629 4.5263 18.6862C3.38006 19.0094 2.18178 19.1019 1 18.9584C3.06418 20.2922 5.46593 20.9997 7.91856 20.9965");
				attr(path, "fill", "white");
				attr(svg, "width", "24");
				attr(svg, "height", "24");
				attr(svg, "viewBox", "0 0 24 24");
				attr(svg, "fill", "none");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(div, "class", "btn__twitter svelte-ik24bc");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, span);
				append(span, t0);
				append(div, t1);
				append(div, svg);
				append(svg, path);
			},
			p(ctx, dirty) {
				if (dirty & /*processingTwitter*/ 64 && t0_value !== (t0_value = (/*processingTwitter*/ ctx[6] ? "Processing" : "Tweet") + "")) set_data(t0, t0_value);
			},
			d(detaching) {
				if (detaching) detach(div);
			}
		};
	}

	// (170:4) {#if item.termsAndConditions?.link}
	function create_if_block_2$b(ctx) {
		let percscheckbox;
		let updating_checked;
		let current;

		function percscheckbox_checked_binding(value) {
			/*percscheckbox_checked_binding*/ ctx[16](value);
		}

		let percscheckbox_props = {
			$$slots: { default: [create_default_slot_1$k] },
			$$scope: { ctx }
		};

		if (/*termsAndConditionsAgreed*/ ctx[9] !== void 0) {
			percscheckbox_props.checked = /*termsAndConditionsAgreed*/ ctx[9];
		}

		percscheckbox = new PercsCheckbox({ props: percscheckbox_props });
		binding_callbacks.push(() => bind$4(percscheckbox, 'checked', percscheckbox_checked_binding));

		return {
			c() {
				create_component(percscheckbox.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percscheckbox, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percscheckbox_changes = {};

				if (dirty & /*$$scope, item*/ 1048580) {
					percscheckbox_changes.$$scope = { dirty, ctx };
				}

				if (!updating_checked && dirty & /*termsAndConditionsAgreed*/ 512) {
					updating_checked = true;
					percscheckbox_changes.checked = /*termsAndConditionsAgreed*/ ctx[9];
					add_flush_callback(() => updating_checked = false);
				}

				percscheckbox.$set(percscheckbox_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percscheckbox.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percscheckbox.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percscheckbox, detaching);
			}
		};
	}

	// (171:6) <PercsCheckbox bind:checked={termsAndConditionsAgreed}>
	function create_default_slot_1$k(ctx) {
		let span;
		let t0;
		let a;
		let t1;
		let a_href_value;

		return {
			c() {
				span = element("span");
				t0 = text("I agree to ");
				a = element("a");
				t1 = text("terms and conditions");
				attr(a, "href", a_href_value = /*item*/ ctx[2].termsAndConditions?.link);
				attr(a, "target", "_blank");
				attr(a, "rel", "noreferrer");
				attr(a, "class", "terms svelte-ik24bc");
			},
			m(target, anchor) {
				insert(target, span, anchor);
				append(span, t0);
				append(span, a);
				append(a, t1);
			},
			p(ctx, dirty) {
				if (dirty & /*item*/ 4 && a_href_value !== (a_href_value = /*item*/ ctx[2].termsAndConditions?.link)) {
					attr(a, "href", a_href_value);
				}
			},
			d(detaching) {
				if (detaching) detach(span);
			}
		};
	}

	// (187:6) {:else}
	function create_else_block$a(ctx) {
		let t;

		return {
			c() {
				t = text("Enter into the contest");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (185:25) 
	function create_if_block_1$h(ctx) {
		let t;

		return {
			c() {
				t = text("Retry");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (183:6) {#if submitting}
	function create_if_block$l(ctx) {
		let t;

		return {
			c() {
				t = text("Processing");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (178:4) <PercsButton       on:click={handleSubmit}       variant="contained"       disabled={!termsAndConditionsAgreed || !sharedOnTwitter || disabled}     >
	function create_default_slot$n(ctx) {
		let if_block_anchor;

		function select_block_type_3(ctx, dirty) {
			if (/*submitting*/ ctx[3]) return create_if_block$l;
			if (/*canRetry*/ ctx[4]) return create_if_block_1$h;
			return create_else_block$a;
		}

		let current_block_type = select_block_type_3(ctx);
		let if_block = current_block_type(ctx);

		return {
			c() {
				if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, dirty) {
				if (current_block_type !== (current_block_type = select_block_type_3(ctx))) {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				}
			},
			d(detaching) {
				if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	function create_fragment$y(ctx) {
		let div1;
		let section0;
		let div0;
		let t0;
		let span;
		let t1_value = /*item*/ ctx[2].name + "";
		let t1;
		let t2;
		let t3;
		let show_if;
		let current_block_type_index;
		let if_block2;
		let t4;
		let section1;
		let h2;
		let t6;
		let current_block_type_index_1;
		let if_block3;
		let t7;
		let section2;
		let t8;
		let percsbutton;
		let current;

		function select_block_type(ctx, dirty) {
			if (/*item*/ ctx[2].image?.src) return create_if_block_6$3;
			if (/*offer*/ ctx[1].image?.src) return create_if_block_7$3;
			return create_else_block_3;
		}

		let current_block_type = select_block_type(ctx);
		let if_block0 = current_block_type(ctx);
		let if_block1 = /*countdownDate*/ ctx[10] != null && create_if_block_5$5(ctx);
		const if_block_creators = [create_if_block_4$7, create_else_block_2$1];
		const if_blocks = [];

		function select_block_type_1(ctx, dirty) {
			if (dirty & /*$state*/ 2048) show_if = null;
			if (show_if == null) show_if = !!/*$state*/ ctx[11].matches("modal.open.offer.giveaway.init");
			if (show_if) return 0;
			return 1;
		}

		current_block_type_index = select_block_type_1(ctx, -1);
		if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		const if_block_creators_1 = [create_if_block_3$9, create_else_block_1$2];
		const if_blocks_1 = [];

		function select_block_type_2(ctx, dirty) {
			if (/*sharedOnTwitter*/ ctx[8]) return 0;
			return 1;
		}

		current_block_type_index_1 = select_block_type_2(ctx);
		if_block3 = if_blocks_1[current_block_type_index_1] = if_block_creators_1[current_block_type_index_1](ctx);
		let if_block4 = /*item*/ ctx[2].termsAndConditions?.link && create_if_block_2$b(ctx);

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					disabled: !/*termsAndConditionsAgreed*/ ctx[9] || !/*sharedOnTwitter*/ ctx[8] || /*disabled*/ ctx[5],
					$$slots: { default: [create_default_slot$n] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*handleSubmit*/ ctx[14]);

		return {
			c() {
				div1 = element("div");
				section0 = element("section");
				div0 = element("div");
				if_block0.c();
				t0 = space();
				span = element("span");
				t1 = text(t1_value);
				t2 = space();
				if (if_block1) if_block1.c();
				t3 = space();
				if_block2.c();
				t4 = space();
				section1 = element("section");
				h2 = element("h2");
				h2.textContent = "Share Tweet";
				t6 = space();
				if_block3.c();
				t7 = space();
				section2 = element("section");
				if (if_block4) if_block4.c();
				t8 = space();
				create_component(percsbutton.$$.fragment);
				attr(div0, "class", "product__image svelte-ik24bc");
				attr(span, "class", "title svelte-ik24bc");
				attr(section0, "class", "card card__product svelte-ik24bc");
				attr(h2, "class", "title svelte-ik24bc");
				attr(section1, "class", "card card--twitter card--success svelte-ik24bc");
				toggle_class(section1, "disabled", /*$state*/ ctx[11].matches("modal.open.offer.giveaway.init"));
				attr(section2, "class", "card--submit svelte-ik24bc");
				attr(div1, "class", "cards svelte-ik24bc");
			},
			m(target, anchor) {
				insert(target, div1, anchor);
				append(div1, section0);
				append(section0, div0);
				if_block0.m(div0, null);
				append(section0, t0);
				append(section0, span);
				append(span, t1);
				append(section0, t2);
				if (if_block1) if_block1.m(section0, null);
				append(div1, t3);
				if_blocks[current_block_type_index].m(div1, null);
				append(div1, t4);
				append(div1, section1);
				append(section1, h2);
				append(section1, t6);
				if_blocks_1[current_block_type_index_1].m(section1, null);
				append(div1, t7);
				append(div1, section2);
				if (if_block4) if_block4.m(section2, null);
				append(section2, t8);
				mount_component(percsbutton, section2, null);
				current = true;
			},
			p(ctx, [dirty]) {
				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0.d(1);
					if_block0 = current_block_type(ctx);

					if (if_block0) {
						if_block0.c();
						if_block0.m(div0, null);
					}
				}

				if ((!current || dirty & /*item*/ 4) && t1_value !== (t1_value = /*item*/ ctx[2].name + "")) set_data(t1, t1_value);

				if (/*countdownDate*/ ctx[10] != null) {
					if (if_block1) {
						if_block1.p(ctx, dirty);

						if (dirty & /*countdownDate*/ 1024) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block_5$5(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(section0, null);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}

				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type_1(ctx, dirty);

				if (current_block_type_index === previous_block_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block2 = if_blocks[current_block_type_index];

					if (!if_block2) {
						if_block2 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block2.c();
					} else {
						if_block2.p(ctx, dirty);
					}

					transition_in(if_block2, 1);
					if_block2.m(div1, t4);
				}

				let previous_block_index_1 = current_block_type_index_1;
				current_block_type_index_1 = select_block_type_2(ctx);

				if (current_block_type_index_1 === previous_block_index_1) {
					if_blocks_1[current_block_type_index_1].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks_1[previous_block_index_1], 1, 1, () => {
						if_blocks_1[previous_block_index_1] = null;
					});

					check_outros();
					if_block3 = if_blocks_1[current_block_type_index_1];

					if (!if_block3) {
						if_block3 = if_blocks_1[current_block_type_index_1] = if_block_creators_1[current_block_type_index_1](ctx);
						if_block3.c();
					} else {
						if_block3.p(ctx, dirty);
					}

					transition_in(if_block3, 1);
					if_block3.m(section1, null);
				}

				if (!current || dirty & /*$state*/ 2048) {
					toggle_class(section1, "disabled", /*$state*/ ctx[11].matches("modal.open.offer.giveaway.init"));
				}

				if (/*item*/ ctx[2].termsAndConditions?.link) {
					if (if_block4) {
						if_block4.p(ctx, dirty);

						if (dirty & /*item*/ 4) {
							transition_in(if_block4, 1);
						}
					} else {
						if_block4 = create_if_block_2$b(ctx);
						if_block4.c();
						transition_in(if_block4, 1);
						if_block4.m(section2, t8);
					}
				} else if (if_block4) {
					group_outros();

					transition_out(if_block4, 1, 1, () => {
						if_block4 = null;
					});

					check_outros();
				}

				const percsbutton_changes = {};
				if (dirty & /*termsAndConditionsAgreed, sharedOnTwitter, disabled*/ 800) percsbutton_changes.disabled = !/*termsAndConditionsAgreed*/ ctx[9] || !/*sharedOnTwitter*/ ctx[8] || /*disabled*/ ctx[5];

				if (dirty & /*$$scope, submitting, canRetry*/ 1048600) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(if_block1);
				transition_in(if_block2);
				transition_in(if_block3);
				transition_in(if_block4);
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(if_block1);
				transition_out(if_block2);
				transition_out(if_block3);
				transition_out(if_block4);
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div1);
				if_block0.d();
				if (if_block1) if_block1.d();
				if_blocks[current_block_type_index].d();
				if_blocks_1[current_block_type_index_1].d();
				if (if_block4) if_block4.d();
				destroy_component(percsbutton);
			}
		};
	}

	function instance$y($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(11, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();
		let { offer } = $$props;
		let { item } = $$props;
		let { submitting = false } = $$props;
		let { canRetry = false } = $$props;
		let { disabled = false } = $$props;
		const dispatch = createEventDispatcher();
		let processingTwitter = false;

		// @todo externalizing these variables to the state machines context can enable simplifying ( all be it increasing verbosity of ) PercsModal giveaway implementation
		let email = "";

		let sharedOnTwitter = false;
		let termsAndConditionsAgreed = false;

		/** @type {?Date} */
		let countdownDate = null;

		const checkIsSoldOut = checkItem => {
			const isoDate = checkItem.validDates?.[1]?.value || offer.validDates?.[1]?.value;

			if (isoDate) {
				$$invalidate(10, countdownDate = new Date(isoDate));

				if (countdownDate <= new Date()) {
					return true;
				}
			}

			if (!checkItem.availableCount && !checkItem.redemption?.totalLimit) {
				return false;
			}

			if (!checkItem.redemption?.totalLimit) {
				return true;
			}

			return false;
		};

		// @todo community image
		function handleSaveEmail() {
			state.send("SELECT_EMAIL", { data: { email } });
		}

		function handleShareOnTwitter() {
			$$invalidate(6, processingTwitter = true);

			setTimeout(
				() => {
					$$invalidate(6, processingTwitter = false);
					$$invalidate(8, sharedOnTwitter = true);
					state.send("SHARED");
				},
				5000
			);
		}

		function handleSubmit() {
			dispatch("submit", {
				email,
				termsAndConditionsAgreed,
				sharedOnTwitter
			});
		}

		function input_input_handler() {
			email = this.value;
			$$invalidate(7, email);
		}

		function percscheckbox_checked_binding(value) {
			termsAndConditionsAgreed = value;
			$$invalidate(9, termsAndConditionsAgreed);
		}

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
			if ('offer' in $$props) $$invalidate(1, offer = $$props.offer);
			if ('item' in $$props) $$invalidate(2, item = $$props.item);
			if ('submitting' in $$props) $$invalidate(3, submitting = $$props.submitting);
			if ('canRetry' in $$props) $$invalidate(4, canRetry = $$props.canRetry);
			if ('disabled' in $$props) $$invalidate(5, disabled = $$props.disabled);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*item*/ 4) {
				checkIsSoldOut(item);
			}
		};

		return [
			state,
			offer,
			item,
			submitting,
			canRetry,
			disabled,
			processingTwitter,
			email,
			sharedOnTwitter,
			termsAndConditionsAgreed,
			countdownDate,
			$state,
			handleSaveEmail,
			handleShareOnTwitter,
			handleSubmit,
			input_input_handler,
			percscheckbox_checked_binding
		];
	}

	class PercsGiveawayItemCard extends SvelteComponent {
		constructor(options) {
			super();

			init$3(
				this,
				options,
				instance$y,
				create_fragment$y,
				safe_not_equal,
				{
					state: 0,
					offer: 1,
					item: 2,
					submitting: 3,
					canRetry: 4,
					disabled: 5
				},
				add_css$o
			);
		}
	}

	/* dist/components/dialog-contents/OfferGiveaway.svelte generated by Svelte v3.59.2 */

	function create_if_block$k(ctx) {
		let h2;
		let t;

		return {
			c() {
				h2 = element("h2");
				t = text(/*headerText*/ ctx[5]);
			},
			m(target, anchor) {
				insert(target, h2, anchor);
				append(h2, t);
			},
			p(ctx, dirty) {
				if (dirty & /*headerText*/ 32) set_data(t, /*headerText*/ ctx[5]);
			},
			d(detaching) {
				if (detaching) detach(h2);
			}
		};
	}

	// (53:0) <PercsDialogHeader {state} on:close text="Enter Contest">
	function create_default_slot_1$j(ctx) {
		let if_block_anchor;
		let if_block = /*headerText*/ ctx[5] && create_if_block$k(ctx);

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, dirty) {
				if (/*headerText*/ ctx[5]) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block$k(ctx);
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			d(detaching) {
				if (if_block) if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (58:0) <PercsDialogContent>
	function create_default_slot$m(ctx) {
		let percsgiveawayitemcard;
		let current;

		percsgiveawayitemcard = new PercsGiveawayItemCard({
				props: {
					state: /*state*/ ctx[0],
					offer: /*selectedOffer*/ ctx[3],
					item: /*selectedItem*/ ctx[2],
					disabled: /*selectedItem*/ ctx[2].isRedeemed || /*isSoldOut*/ ctx[1],
					submitting: /*$state*/ ctx[4].matches("modal.open.offer.giveaway.redeeming"),
					canRetry: /*$state*/ ctx[4].matches("modal.open.offer.giveaway.error")
				}
			});

		percsgiveawayitemcard.$on("submit", /*handleGiveawaySubmit*/ ctx[6]);

		return {
			c() {
				create_component(percsgiveawayitemcard.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsgiveawayitemcard, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsgiveawayitemcard_changes = {};
				if (dirty & /*state*/ 1) percsgiveawayitemcard_changes.state = /*state*/ ctx[0];
				if (dirty & /*selectedOffer*/ 8) percsgiveawayitemcard_changes.offer = /*selectedOffer*/ ctx[3];
				if (dirty & /*selectedItem*/ 4) percsgiveawayitemcard_changes.item = /*selectedItem*/ ctx[2];
				if (dirty & /*selectedItem, isSoldOut*/ 6) percsgiveawayitemcard_changes.disabled = /*selectedItem*/ ctx[2].isRedeemed || /*isSoldOut*/ ctx[1];
				if (dirty & /*$state*/ 16) percsgiveawayitemcard_changes.submitting = /*$state*/ ctx[4].matches("modal.open.offer.giveaway.redeeming");
				if (dirty & /*$state*/ 16) percsgiveawayitemcard_changes.canRetry = /*$state*/ ctx[4].matches("modal.open.offer.giveaway.error");
				percsgiveawayitemcard.$set(percsgiveawayitemcard_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsgiveawayitemcard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsgiveawayitemcard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsgiveawayitemcard, detaching);
			}
		};
	}

	function create_fragment$x(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Enter Contest",
					$$slots: { default: [create_default_slot_1$j] },
					$$scope: { ctx }
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[7]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot$m] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];

				if (dirty & /*$$scope, headerText*/ 288) {
					percsdialogheader_changes.$$scope = { dirty, ctx };
				}

				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, selectedOffer, selectedItem, isSoldOut, $state*/ 287) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function checkIsSoldOut(item, validDates) {
		const isoDate = item.validDates?.[1]?.value || validDates?.[1]?.value;

		if (isoDate) {
			const countdownDate = new Date(isoDate);

			if (countdownDate <= new Date()) {
				return true;
			} else if (!item.availableCount && !item.redemption?.totalLimit) {
				return false;
			} else if (!item.redemption?.totalLimit) {
				return true;
			}
		}

		return false;
	}

	function instance$x($$self, $$props, $$invalidate) {
		let selectedOffer;
		let selectedItem;
		let isSoldOut;

		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(4, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		/** @type {string} */
		let headerText = "";

		/**
	 * @param {CustomEvent<{ email: string, termsAndConditionsAgreed: boolean, sharedOnTwitter: boolean }>} event
	 */
		function handleGiveawaySubmit({ detail }) {
			state.send("OFFER_REDEEM", detail);
		}

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*$state*/ 16) {
				$$invalidate(3, selectedOffer = $state.context.offers.find(offer => offer.id === $state.context.offerSelectedId));
			}

			if ($$self.$$.dirty & /*selectedOffer, $state*/ 24) {
				$$invalidate(2, selectedItem = selectedOffer?.redemption.items.find(item => item.id === $state.context.offerSelectedItemId));
			}

			if ($$self.$$.dirty & /*selectedItem, selectedOffer*/ 12) {
				$$invalidate(1, isSoldOut = selectedItem != null
				? checkIsSoldOut(selectedItem, selectedOffer?.validDates)
				: false);
			}

			if ($$self.$$.dirty & /*$state, selectedItem, isSoldOut*/ 22) {
				{
					if ($state.matches("modal.open.offer.giveaway.error")) {
						$$invalidate(5, headerText = $state.context.error.message);
					} else if (selectedItem.isRedeemed) {
						$$invalidate(5, headerText = "You are already in the contest.");
					} else if (isSoldOut) {
						$$invalidate(5, headerText = "This offer is sold out.");
					}
				}
			}
		};

		return [
			state,
			isSoldOut,
			selectedItem,
			selectedOffer,
			$state,
			headerText,
			handleGiveawaySubmit,
			close_handler
		];
	}

	class OfferGiveaway extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$x, create_fragment$x, safe_not_equal, { state: 0 });
		}
	}

	/* dist/components/dialog-contents/OfferGiveawaySuccess.svelte generated by Svelte v3.59.2 */

	function add_css$n(target) {
		append_styles(target, "svelte-5dej2l", ".text-justify.svelte-5dej2l{text-align:justify}");
	}

	// (30:2) {#if $state.context.offers?.[ 0 ]?.redemption.helpLink}
	function create_if_block$j(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					as: "a",
					href: /*$state*/ ctx[1].context.offers[0].redemption.helpLink.url,
					target: "_blank",
					$$slots: { default: [create_default_slot_1$i] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};
				if (dirty & /*$state*/ 2) percsbutton_changes.href = /*$state*/ ctx[1].context.offers[0].redemption.helpLink.url;

				if (dirty & /*$$scope, $state*/ 10) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (31:4) <PercsButton       variant="contained"       as="a"       href={$state.context.offers[ 0 ].redemption.helpLink.url}       target="_blank"     >
	function create_default_slot_1$i(ctx) {
		let t_value = /*$state*/ ctx[1].context.offers[0].redemption.helpLink.text + "";
		let t;

		return {
			c() {
				t = text(t_value);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*$state*/ 2 && t_value !== (t_value = /*$state*/ ctx[1].context.offers[0].redemption.helpLink.text + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (12:0) <PercsDialogContent modifiers="offer-giveaway-success">
	function create_default_slot$l(ctx) {
		let svg;
		let path0;
		let path1;
		let path2;
		let path3;
		let path4;
		let path5;
		let t0;
		let div;
		let t4;
		let if_block_anchor;
		let current;
		let if_block = /*$state*/ ctx[1].context.offers?.[0]?.redemption.helpLink && create_if_block$j(ctx);

		return {
			c() {
				svg = svg_element("svg");
				path0 = svg_element("path");
				path1 = svg_element("path");
				path2 = svg_element("path");
				path3 = svg_element("path");
				path4 = svg_element("path");
				path5 = svg_element("path");
				t0 = space();
				div = element("div");

				div.innerHTML = `<p class="text-justify svelte-5dej2l">Keep an eye on your inbox, as we will be contacting the winner privately to claim their prize.</p> 
    <p>Good luck!</p>`;

				t4 = space();
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
				attr(path0, "d", "M50.1352 36.136C52.8675 31.8382 56.3678 29.0025 61.0496 27.6733C73.6771 24.0992 85.8616 35.3089 83.5281 48.2023C82.0512 56.34 77.2217 62.2477 71.0334 67.0624C64.4021 72.2168 57.3425 76.8395 50.5192 81.6542C40.5206 75.4365 30.6253 69.8537 23.0635 61.1548C18.9282 56.4139 16.3584 51.0084 16.506 44.51C16.6685 36.9926 21.5718 30.2726 28.7348 27.9096C35.8683 25.5465 43.9617 27.9834 48.4958 33.8763C48.998 34.5409 49.4706 35.235 50.1352 36.136Z");
				attr(path0, "fill", "#FD665F");
				attr(path0, "stroke", "#161B5D");
				attr(path0, "stroke-width", "2.48537");
				attr(path0, "stroke-miterlimit", "10");
				attr(path0, "stroke-linecap", "round");
				attr(path0, "stroke-linejoin", "round");
				attr(path1, "d", "M65.8491 34.2461C68.9211 34.2461 71.8749 35.6639 73.9426 38.1451C75.1241 39.563 77.0145 42.5758 76.2466 46.7407C75.2718 52.1019 72.1703 56.6655 66.4842 61.0815");
				attr(path1, "stroke", "white");
				attr(path1, "stroke-width", "2.48537");
				attr(path1, "stroke-miterlimit", "10");
				attr(path1, "stroke-linecap", "round");
				attr(path1, "stroke-linejoin", "round");
				attr(path2, "d", "M79.7125 14.2153C83.6112 10.3194 82.0348 8 83.8598 8C85.6849 8 84.1084 10.3194 88.0043 14.2153C91.9001 18.1112 94.2196 16.5348 94.2196 18.3598C94.2196 20.1849 91.903 18.6084 88.0043 22.5043C84.1084 26.4002 85.6849 28.7196 83.8598 28.7196C82.0348 28.7196 83.6112 26.4002 79.7153 22.5043C75.8194 18.6084 73.5 20.1849 73.5 18.3598C73.5 16.5348 75.8194 18.1112 79.7153 14.2153H79.7125Z");
				attr(path2, "fill", "#FBB338");
				attr(path2, "stroke", "#161B5D");
				attr(path2, "stroke-width", "2.49");
				attr(path2, "stroke-linejoin", "round");
				attr(path3, "d", "M77.9975 83.4996C80.82 80.6792 79.6788 79 81 79C82.3213 79 81.18 80.6792 84.0004 83.4996C86.8208 86.32 88.5 85.1788 88.5 86.5C88.5 87.8212 86.8229 86.68 84.0004 89.5004C81.18 92.3208 82.3213 94 81 94C79.6788 94 80.82 92.3208 77.9996 89.5004C75.1792 86.68 73.5 87.8212 73.5 86.5C73.5 85.1788 75.1792 86.32 77.9996 83.4996H77.9975Z");
				attr(path3, "fill", "#FBB338");
				attr(path3, "stroke", "#161B5D");
				attr(path3, "stroke-width", "2.49");
				attr(path3, "stroke-linejoin", "round");
				attr(path4, "d", "M19.1985 13.6998C20.892 12.0075 20.2073 11 21 11C21.7928 11 21.108 12.0075 22.8002 13.6998C24.4925 15.392 25.5 14.7073 25.5 15.5C25.5 16.2927 24.4937 15.608 22.8002 17.3002C21.108 18.9925 21.7928 20 21 20C20.2073 20 20.892 18.9925 19.1998 17.3002C17.5075 15.608 16.5 16.2927 16.5 15.5C16.5 14.7073 17.5075 15.392 19.1998 13.6998H19.1985Z");
				attr(path4, "fill", "#FBB338");
				attr(path4, "stroke", "#161B5D");
				attr(path4, "stroke-width", "2.49");
				attr(path4, "stroke-linejoin", "round");
				attr(path5, "d", "M8.88228 71.3838C11.0049 69.2628 10.1466 68 11.1402 68C12.1338 68 11.2756 69.2628 13.3966 71.3838C15.5176 73.5049 16.7804 72.6466 16.7804 73.6402C16.7804 74.6338 15.5192 73.7756 13.3966 75.8966C11.2756 78.0176 12.1338 79.2804 11.1402 79.2804C10.1466 79.2804 11.0049 78.0176 8.88382 75.8966C6.76278 73.7756 5.5 74.6338 5.5 73.6402C5.5 72.6466 6.76278 73.5049 8.88382 71.3838H8.88228Z");
				attr(path5, "fill", "#FBB338");
				attr(path5, "stroke", "#161B5D");
				attr(path5, "stroke-width", "2.49");
				attr(path5, "stroke-linejoin", "round");
				attr(svg, "width", "101");
				attr(svg, "height", "100");
				attr(svg, "viewBox", "0 0 101 100");
				attr(svg, "fill", "none");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			},
			m(target, anchor) {
				insert(target, svg, anchor);
				append(svg, path0);
				append(svg, path1);
				append(svg, path2);
				append(svg, path3);
				append(svg, path4);
				append(svg, path5);
				insert(target, t0, anchor);
				insert(target, div, anchor);
				insert(target, t4, anchor);
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (/*$state*/ ctx[1].context.offers?.[0]?.redemption.helpLink) {
					if (if_block) {
						if_block.p(ctx, dirty);

						if (dirty & /*$state*/ 2) {
							transition_in(if_block, 1);
						}
					} else {
						if_block = create_if_block$j(ctx);
						if_block.c();
						transition_in(if_block, 1);
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					group_outros();

					transition_out(if_block, 1, 1, () => {
						if_block = null;
					});

					check_outros();
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(svg);
				if (detaching) detach(t0);
				if (detaching) detach(div);
				if (detaching) detach(t4);
				if (if_block) if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	function create_fragment$w(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Thank you for entering the giveaway!"
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[2]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "offer-giveaway-success",
					$$slots: { default: [create_default_slot$l] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];
				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, $state*/ 10) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$w($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(1, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [state, $state, close_handler];
	}

	class OfferGiveawaySuccess extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$w, create_fragment$w, safe_not_equal, { state: 0 }, add_css$n);
		}
	}

	/* dist/components/internal/PercsTabBar.svelte generated by Svelte v3.59.2 */

	function add_css$m(target) {
		append_styles(target, "svelte-bvm9us", ".tab-bar{display:inline-flex;flex-wrap:wrap;gap:4px;margin-bottom:8px}.tab-bar__button{background-color:white;padding:8px 12px;border:none;border-radius:6px;cursor:pointer}.tab-bar__button--active{background-color:#F2F4F7}");
	}

	function get_each_context$5(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[4] = list[i];
		child_ctx[6] = i;
		return child_ctx;
	}

	// (13:2) {#each tabs as tab, index}
	function create_each_block$5(ctx) {
		let button;
		let t0_value = /*tab*/ ctx[4] + "";
		let t0;
		let t1;
		let button_aria_selected_value;
		let mounted;
		let dispose;

		function click_handler() {
			return /*click_handler*/ ctx[3](/*tab*/ ctx[4]);
		}

		return {
			c() {
				button = element("button");
				t0 = text(t0_value);
				t1 = space();
				attr(button, "class", "tab-bar__button");
				attr(button, "role", "tab");
				attr(button, "aria-selected", button_aria_selected_value = /*tab*/ ctx[4] === /*active*/ ctx[0]);
				attr(button, "tabindex", "0");
				attr(button, "id", "tab-" + /*index*/ ctx[6]);
				toggle_class(button, "tab-bar__button--active", /*tab*/ ctx[4] === /*active*/ ctx[0]);
			},
			m(target, anchor) {
				insert(target, button, anchor);
				append(button, t0);
				append(button, t1);

				if (!mounted) {
					dispose = listen(button, "click", click_handler);
					mounted = true;
				}
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				if (dirty & /*tabs*/ 2 && t0_value !== (t0_value = /*tab*/ ctx[4] + "")) set_data(t0, t0_value);

				if (dirty & /*tabs, active*/ 3 && button_aria_selected_value !== (button_aria_selected_value = /*tab*/ ctx[4] === /*active*/ ctx[0])) {
					attr(button, "aria-selected", button_aria_selected_value);
				}

				if (dirty & /*tabs, active*/ 3) {
					toggle_class(button, "tab-bar__button--active", /*tab*/ ctx[4] === /*active*/ ctx[0]);
				}
			},
			d(detaching) {
				if (detaching) detach(button);
				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$v(ctx) {
		let div;
		let each_value = /*tabs*/ ctx[1];
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$5(get_each_context$5(ctx, each_value, i));
		}

		return {
			c() {
				div = element("div");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				attr(div, "class", "tab-bar");
				attr(div, "role", "tablist");
				attr(div, "aria-label", "Token Redemption Status");
			},
			m(target, anchor) {
				insert(target, div, anchor);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(div, null);
					}
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*tabs, active, dispatch*/ 7) {
					each_value = /*tabs*/ ctx[1];
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$5(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$5(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(div, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(div);
				destroy_each(each_blocks, detaching);
			}
		};
	}

	function instance$v($$self, $$props, $$invalidate) {
		let { active } = $$props;
		let { tabs } = $$props;
		const dispatch = createEventDispatcher();

		const click_handler = tab => {
			dispatch("select", tab);
		};

		$$self.$$set = $$props => {
			if ('active' in $$props) $$invalidate(0, active = $$props.active);
			if ('tabs' in $$props) $$invalidate(1, tabs = $$props.tabs);
		};

		return [active, tabs, dispatch, click_handler];
	}

	class PercsTabBar extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$v, create_fragment$v, safe_not_equal, { active: 0, tabs: 1 }, add_css$m);
		}
	}

	/* dist/components/dialog-contents/OfferList.svelte generated by Svelte v3.59.2 */

	function create_if_block_2$a(ctx) {
		let small;

		return {
			c() {
				small = element("small");
				small.textContent = "Deals you missed";
			},
			m(target, anchor) {
				insert(target, small, anchor);
			},
			d(detaching) {
				if (detaching) detach(small);
			}
		};
	}

	// (37:0) <PercsDialogHeader {state} on:close text="Your Offers">
	function create_default_slot_3$a(ctx) {
		let if_block_anchor;
		let if_block = /*areAllOfferItemsSoldOut*/ ctx[3] && create_if_block_2$a();

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
			},
			p(ctx, dirty) {
				if (/*areAllOfferItemsSoldOut*/ ctx[3]) {
					if (if_block) ; else {
						if_block = create_if_block_2$a();
						if_block.c();
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}
			},
			d(detaching) {
				if (if_block) if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (43:2) {#if $state.context.offers[ 0 ].redemption.selectType !== "wallet"}
	function create_if_block_1$g(ctx) {
		let percstabbar;
		let current;

		percstabbar = new PercsTabBar({
				props: {
					tabs: /*tabs*/ ctx[4],
					active: /*activeTab*/ ctx[2]
				}
			});

		percstabbar.$on("select", /*select_handler*/ ctx[6]);

		return {
			c() {
				create_component(percstabbar.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percstabbar, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percstabbar_changes = {};
				if (dirty & /*activeTab*/ 4) percstabbar_changes.active = /*activeTab*/ ctx[2];
				percstabbar.$set(percstabbar_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percstabbar.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percstabbar.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percstabbar, detaching);
			}
		};
	}

	// (52:2) {#if !areAllOfferItemsSoldOut}
	function create_if_block$i(ctx) {
		let percsdialogactions;
		let current;

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$h] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogactions.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state*/ 513) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	// (54:6) <PercsButton         variant="contained"         on:click={() => state.send("OFFER_ITEM_SELECT")}       >
	function create_default_slot_2$f(ctx) {
		let t;

		return {
			c() {
				t = text("Back");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (53:4) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$h(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					$$slots: { default: [create_default_slot_2$f] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[7]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 512) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (42:0) <PercsDialogContent>
	function create_default_slot$k(ctx) {
		let t0;
		let percsofferitemlist;
		let t1;
		let if_block1_anchor;
		let current;
		let if_block0 = /*$state*/ ctx[1].context.offers[0].redemption.selectType !== "wallet" && create_if_block_1$g(ctx);
		percsofferitemlist = new PercsOfferItemList({ props: { state: /*state*/ ctx[0] } });
		let if_block1 = !/*areAllOfferItemsSoldOut*/ ctx[3] && create_if_block$i(ctx);

		return {
			c() {
				if (if_block0) if_block0.c();
				t0 = space();
				create_component(percsofferitemlist.$$.fragment);
				t1 = space();
				if (if_block1) if_block1.c();
				if_block1_anchor = empty$3();
			},
			m(target, anchor) {
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t0, anchor);
				mount_component(percsofferitemlist, target, anchor);
				insert(target, t1, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, if_block1_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (/*$state*/ ctx[1].context.offers[0].redemption.selectType !== "wallet") {
					if (if_block0) {
						if_block0.p(ctx, dirty);

						if (dirty & /*$state*/ 2) {
							transition_in(if_block0, 1);
						}
					} else {
						if_block0 = create_if_block_1$g(ctx);
						if_block0.c();
						transition_in(if_block0, 1);
						if_block0.m(t0.parentNode, t0);
					}
				} else if (if_block0) {
					group_outros();

					transition_out(if_block0, 1, 1, () => {
						if_block0 = null;
					});

					check_outros();
				}

				const percsofferitemlist_changes = {};
				if (dirty & /*state*/ 1) percsofferitemlist_changes.state = /*state*/ ctx[0];
				percsofferitemlist.$set(percsofferitemlist_changes);

				if (!/*areAllOfferItemsSoldOut*/ ctx[3]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);

						if (dirty & /*areAllOfferItemsSoldOut*/ 8) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block$i(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block0);
				transition_in(percsofferitemlist.$$.fragment, local);
				transition_in(if_block1);
				current = true;
			},
			o(local) {
				transition_out(if_block0);
				transition_out(percsofferitemlist.$$.fragment, local);
				transition_out(if_block1);
				current = false;
			},
			d(detaching) {
				if (if_block0) if_block0.d(detaching);
				if (detaching) detach(t0);
				destroy_component(percsofferitemlist, detaching);
				if (detaching) detach(t1);
				if (if_block1) if_block1.d(detaching);
				if (detaching) detach(if_block1_anchor);
			}
		};
	}

	function create_fragment$u(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Your Offers",
					$$slots: { default: [create_default_slot_3$a] },
					$$scope: { ctx }
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[5]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot$k] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];

				if (dirty & /*$$scope, areAllOfferItemsSoldOut*/ 520) {
					percsdialogheader_changes.$$scope = { dirty, ctx };
				}

				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, areAllOfferItemsSoldOut, activeTab, $state*/ 527) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$u($$self, $$props, $$invalidate) {
		let areAllOfferItemsSoldOut;
		let activeTab;

		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(1, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		function checkItemsSoldOut() {
			if (!$state.context.offer) {
				return false;
			}

			return $state.context.offer?.redemption.items.every(item => {
				if (!item.redemption.totalLimit) {
					return true;
				}

				const isoDate = item.validDates?.[1]?.value || $state.context.offer?.validDates?.[1]?.value;

				if (isoDate) {
					const countdownDate = new Date(isoDate);

					if (countdownDate <= new Date()) {
						return true;
					}
				}

				return false;
			});
		}

		const tabs = ["Active", "Redeemed"];

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const select_handler = event => {
			state.send("OFFERS_TAB_SELECT", { activeTab: event.detail });
		};

		const click_handler = () => state.send("OFFER_ITEM_SELECT");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*$state*/ 2) {
				$$invalidate(2, activeTab = $state.context.offersActiveTab);
			}
		};

		$$invalidate(3, areAllOfferItemsSoldOut = checkItemsSoldOut());

		return [
			state,
			$state,
			activeTab,
			areAllOfferItemsSoldOut,
			tabs,
			close_handler,
			select_handler,
			click_handler
		];
	}

	class OfferList extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$u, create_fragment$u, safe_not_equal, { state: 0 });
		}
	}

	/* dist/components/dialog-contents/OfferLoading.svelte generated by Svelte v3.59.2 */

	function create_default_slot$j(ctx) {
		let h2;

		return {
			c() {
				h2 = element("h2");
				h2.textContent = "Loading Offers…";
			},
			m(target, anchor) {
				insert(target, h2, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(h2);
			}
		};
	}

	function create_fragment$t(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Your Offers"
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[1]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "center",
					$$slots: { default: [create_default_slot$j] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];
				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope*/ 4) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$t($$self, $$props, $$invalidate) {
		let { state } = $$props;

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		$$self.$$set = $$props => {
			if ('state' in $$props) $$invalidate(0, state = $$props.state);
		};

		return [state, close_handler];
	}

	class OfferLoading extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$t, create_fragment$t, safe_not_equal, { state: 0 });
		}
	}

	/* dist/components/internal/PercsEmailInput.svelte generated by Svelte v3.59.2 */

	function add_css$l(target) {
		append_styles(target, "svelte-1ln9h3j", ".percs-email-input__label{display:block;font-size:0.875rem;line-height:1.5rem;font-weight:500;color:rgb(17 24 39)}.percs-email-input__container{position:relative;margin-top:0.5rem;border-radius:0.375rem;box-shadow:0 1px 2px 0 rgb(0 0 0 / 0.05)}.percs-email-input__icon-container{position:absolute;top:0;bottom:0;left:0;display:flex;align-items:center;padding-left:0.75rem;pointer-events:none}.percs-email-input__icon{height:1.25rem;width:1.25rem;color:rgb(156 163 175)}.percs-email-input__input{display:block;width:calc(100% - 2.875rem);border-radius:0.375rem;border-width:0;padding-top:0.375rem;padding-bottom:0.375rem;padding-left:2.5rem;padding-right:0.375rem;color:rgb(17 24 39)}.sr-only{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}");
	}

	function create_fragment$s(ctx) {
		let div2;
		let label_1;
		let t0_value = (/*label*/ ctx[1] ?? "Email") + "";
		let t0;
		let label_1_class_value;
		let t1;
		let div1;
		let div0;
		let t2;
		let input;
		let mounted;
		let dispose;

		return {
			c() {
				div2 = element("div");
				label_1 = element("label");
				t0 = text(t0_value);
				t1 = space();
				div1 = element("div");
				div0 = element("div");
				div0.innerHTML = `<svg class="percs-email-input__icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M3 4a2 2 0 00-2 2v1.161l8.441 4.221a1.25 1.25 0 001.118 0L19 7.162V6a2 2 0 00-2-2H3z"></path><path d="M19 8.839l-7.77 3.885a2.75 2.75 0 01-2.46 0L1 8.839V14a2 2 0 002 2h14a2 2 0 002-2V8.839z"></path></svg>`;
				t2 = space();
				input = element("input");
				attr(label_1, "for", /*id*/ ctx[2]);

				attr(label_1, "class", label_1_class_value = /*label*/ ctx[1]
				? "percs-email-input__label"
				: "sr-only");

				attr(div0, "class", "percs-email-input__icon-container");
				attr(input, "type", "email");
				attr(input, "name", "email");
				attr(input, "id", /*id*/ ctx[2]);
				attr(input, "autocomplete", "email");
				input.required = true;
				attr(input, "class", "percs-email-input__input");
				attr(input, "placeholder", "you@example.com");
				attr(div1, "class", "percs-email-input__container");
				attr(div2, "class", "percs-email-input");
			},
			m(target, anchor) {
				insert(target, div2, anchor);
				append(div2, label_1);
				append(label_1, t0);
				append(div2, t1);
				append(div2, div1);
				append(div1, div0);
				append(div1, t2);
				append(div1, input);
				set_input_value(input, /*value*/ ctx[0]);

				if (!mounted) {
					dispose = listen(input, "input", /*input_input_handler*/ ctx[3]);
					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*label*/ 2 && t0_value !== (t0_value = (/*label*/ ctx[1] ?? "Email") + "")) set_data(t0, t0_value);

				if (dirty & /*id*/ 4) {
					attr(label_1, "for", /*id*/ ctx[2]);
				}

				if (dirty & /*label*/ 2 && label_1_class_value !== (label_1_class_value = /*label*/ ctx[1]
				? "percs-email-input__label"
				: "sr-only")) {
					attr(label_1, "class", label_1_class_value);
				}

				if (dirty & /*id*/ 4) {
					attr(input, "id", /*id*/ ctx[2]);
				}

				if (dirty & /*value*/ 1 && input.value !== /*value*/ ctx[0]) {
					set_input_value(input, /*value*/ ctx[0]);
				}
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(div2);
				mounted = false;
				dispose();
			}
		};
	}

	function instance$s($$self, $$props, $$invalidate) {
		let { label = "" } = $$props;
		let { value } = $$props;
		let { id = `email-${Math.floor(Math.random() * 10000)}` } = $$props;

		function input_input_handler() {
			value = this.value;
			$$invalidate(0, value);
		}

		$$self.$$set = $$props => {
			if ('label' in $$props) $$invalidate(1, label = $$props.label);
			if ('value' in $$props) $$invalidate(0, value = $$props.value);
			if ('id' in $$props) $$invalidate(2, id = $$props.id);
		};

		return [value, label, id, input_input_handler];
	}

	class PercsEmailInput extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$s, create_fragment$s, safe_not_equal, { label: 1, value: 0, id: 2 }, add_css$l);
		}
	}

	function cubicInOut(t) {
	    return t < 0.5 ? 4.0 * t * t * t : 0.5 * Math.pow(2.0 * t - 2.0, 3.0) + 1.0;
	}

	function fade(node, { delay = 0, duration = 400, easing = identity$2 } = {}) {
	    const o = +getComputedStyle(node).opacity;
	    return {
	        delay,
	        duration,
	        easing,
	        css: t => `opacity: ${t * o}`
	    };
	}
	function draw(node, { delay = 0, speed, duration, easing = cubicInOut } = {}) {
	    let len = node.getTotalLength();
	    const style = getComputedStyle(node);
	    if (style.strokeLinecap !== 'butt') {
	        len += parseInt(style.strokeWidth);
	    }
	    if (duration === undefined) {
	        if (speed === undefined) {
	            duration = 800;
	        }
	        else {
	            duration = len / speed;
	        }
	    }
	    else if (typeof duration === 'function') {
	        duration = duration(len);
	    }
	    return {
	        delay,
	        duration,
	        easing,
	        css: (_, u) => `
			stroke-dasharray: ${len};
			stroke-dashoffset: ${u * len};
		`
	    };
	}

	/**
	 * @param {Element} element
	 * @param {{ duration: number?, inFrom?: "left" | "right"}} options
	 * @returns {{ duration: number, css: (t: number) => string }}
	 */
	function slideIn(element, options = { duration: 300, inFrom: "left" }) {
	  const { duration = 300, inFrom = "left" } = options;
	  return {
	    duration,
	    css: (t) => {
	      const difference = inFrom === "right" ? 1 - t : t - 1;
	      return `transform: translateX(${difference * 100}%); opacity: ${t}`
	    }
	  }
	}

	/* dist/components/internal/PercsAlert.svelte generated by Svelte v3.59.2 */

	function add_css$k(target) {
		append_styles(target, "svelte-1cgyfjw", ".percs-alert{width:100%;background-color:white;pointer-events:auto;padding:1rem}.percs-alert--variant-dismissable{border-radius:0.5rem;box-shadow:0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);overflow:hidden;max-width:24rem}.percs-alert--variant-flat{border-radius:0.375rem}.percs-alert__container{display:flex;align-items:flex-start}.percs-alert__icon-container{flex-shrink:0}.percs-alert__icon{height:1.25rem;width:1.25rem}.percs-alert--type-warning .percs-alert__icon{--tw-text-opacity:1;color:rgb(234 179 8 / var(--tw-text-opacity))}.percs-alert__content{flex:1 1 0%;width:0px;margin-left:0.75rem;padding-top:0.125rem}.percs-alert__close-icon-container{margin-left:1rem;display:flex;flex-shrink:0}.percs-alert__close-icon-button{cursor:pointer;display:inline-flex;background-color:white;color:rgb(156 163 175);position:relative;display:flex;border-radius:0.375rem;outline:none;border:none}.percs-alert__close-icon-button:hover{color:rgb(107 114 128)}.percs-alert__close-icon{height:1.25rem;width:1.25rem}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border-width:0}");
	}

	// (88:0) {:else}
	function create_else_block_1$1(ctx) {
		let div3;
		let div2;
		let div0;
		let t0;
		let div1;
		let t1;
		let div3_class_value;
		let current;

		function select_block_type_2(ctx, dirty) {
			if (/*type*/ ctx[2] === "success") return create_if_block_9$1;
			if (/*type*/ ctx[2] === "warning") return create_if_block_10$1;
			return create_else_block_2;
		}

		let current_block_type = select_block_type_2(ctx);
		let if_block0 = current_block_type(ctx);
		const default_slot_template = /*#slots*/ ctx[8].default;
		const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[7], null);
		const default_slot_or_fallback = default_slot || fallback_block_1(ctx);
		let if_block1 = /*variant*/ ctx[3] === "default" && create_if_block_6$2(ctx);

		return {
			c() {
				div3 = element("div");
				div2 = element("div");
				div0 = element("div");
				if_block0.c();
				t0 = space();
				div1 = element("div");
				if (default_slot_or_fallback) default_slot_or_fallback.c();
				t1 = space();
				if (if_block1) if_block1.c();
				attr(div0, "class", "percs-alert__icon-container");
				attr(div1, "class", "percs-alert__content");
				attr(div2, "class", "percs-alert__container");
				attr(div3, "class", div3_class_value = "percs-alert percs-alert--type-" + /*type*/ ctx[2]);
				toggle_class(div3, "percs-alert--variant-dismissable", /*variant*/ ctx[3] === "default");
				toggle_class(div3, "percs-alert--variant-flat", /*variant*/ ctx[3] === "flat");
			},
			m(target, anchor) {
				insert(target, div3, anchor);
				append(div3, div2);
				append(div2, div0);
				if_block0.m(div0, null);
				append(div2, t0);
				append(div2, div1);

				if (default_slot_or_fallback) {
					default_slot_or_fallback.m(div1, null);
				}

				append(div2, t1);
				if (if_block1) if_block1.m(div2, null);
				current = true;
			},
			p(ctx, dirty) {
				if (current_block_type !== (current_block_type = select_block_type_2(ctx))) {
					if_block0.d(1);
					if_block0 = current_block_type(ctx);

					if (if_block0) {
						if_block0.c();
						if_block0.m(div0, null);
					}
				}

				if (default_slot) {
					if (default_slot.p && (!current || dirty & /*$$scope*/ 128)) {
						update_slot_base(
							default_slot,
							default_slot_template,
							ctx,
							/*$$scope*/ ctx[7],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[7])
							: get_slot_changes(default_slot_template, /*$$scope*/ ctx[7], dirty, null),
							null
						);
					}
				} else {
					if (default_slot_or_fallback && default_slot_or_fallback.p && (!current || dirty & /*description, message*/ 3)) {
						default_slot_or_fallback.p(ctx, !current ? -1 : dirty);
					}
				}

				if (/*variant*/ ctx[3] === "default") {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_6$2(ctx);
						if_block1.c();
						if_block1.m(div2, null);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}

				if (!current || dirty & /*type*/ 4 && div3_class_value !== (div3_class_value = "percs-alert percs-alert--type-" + /*type*/ ctx[2])) {
					attr(div3, "class", div3_class_value);
				}

				if (!current || dirty & /*type, variant*/ 12) {
					toggle_class(div3, "percs-alert--variant-dismissable", /*variant*/ ctx[3] === "default");
				}

				if (!current || dirty & /*type, variant*/ 12) {
					toggle_class(div3, "percs-alert--variant-flat", /*variant*/ ctx[3] === "flat");
				}
			},
			i(local) {
				if (current) return;
				transition_in(default_slot_or_fallback, local);
				current = true;
			},
			o(local) {
				transition_out(default_slot_or_fallback, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div3);
				if_block0.d();
				if (default_slot_or_fallback) default_slot_or_fallback.d(detaching);
				if (if_block1) if_block1.d();
			}
		};
	}

	// (35:0) {#if animate}
	function create_if_block$h(ctx) {
		let div3;
		let div2;
		let div0;
		let current_block_type_index;
		let if_block0;
		let t0;
		let div1;
		let t1;
		let div3_class_value;
		let div3_transition;
		let current;
		const if_block_creators = [create_if_block_4$6, create_if_block_5$4, create_else_block$9];
		const if_blocks = [];

		function select_block_type_1(ctx, dirty) {
			if (/*type*/ ctx[2] === "success") return 0;
			if (/*type*/ ctx[2] === "warning") return 1;
			return 2;
		}

		current_block_type_index = select_block_type_1(ctx);
		if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		const default_slot_template = /*#slots*/ ctx[8].default;
		const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[7], null);
		const default_slot_or_fallback = default_slot || fallback_block$1(ctx);
		let if_block1 = /*variant*/ ctx[3] === "default" && create_if_block_1$f(ctx);

		return {
			c() {
				div3 = element("div");
				div2 = element("div");
				div0 = element("div");
				if_block0.c();
				t0 = space();
				div1 = element("div");
				if (default_slot_or_fallback) default_slot_or_fallback.c();
				t1 = space();
				if (if_block1) if_block1.c();
				attr(div0, "class", "percs-alert__icon-container");
				attr(div1, "class", "percs-alert__content");
				attr(div2, "class", "percs-alert__container");
				attr(div3, "class", div3_class_value = "percs-alert percs-alert--type-" + /*type*/ ctx[2]);
				toggle_class(div3, "percs-alert--variant-dismissable", /*variant*/ ctx[3] === "default");
				toggle_class(div3, "percs-alert--variant-flat", /*variant*/ ctx[3] === "flat");
			},
			m(target, anchor) {
				insert(target, div3, anchor);
				append(div3, div2);
				append(div2, div0);
				if_blocks[current_block_type_index].m(div0, null);
				append(div2, t0);
				append(div2, div1);

				if (default_slot_or_fallback) {
					default_slot_or_fallback.m(div1, null);
				}

				append(div2, t1);
				if (if_block1) if_block1.m(div2, null);
				current = true;
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type_1(ctx);

				if (current_block_type_index !== previous_block_index) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block0 = if_blocks[current_block_type_index];

					if (!if_block0) {
						if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block0.c();
					}

					transition_in(if_block0, 1);
					if_block0.m(div0, null);
				}

				if (default_slot) {
					if (default_slot.p && (!current || dirty & /*$$scope*/ 128)) {
						update_slot_base(
							default_slot,
							default_slot_template,
							ctx,
							/*$$scope*/ ctx[7],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[7])
							: get_slot_changes(default_slot_template, /*$$scope*/ ctx[7], dirty, null),
							null
						);
					}
				} else {
					if (default_slot_or_fallback && default_slot_or_fallback.p && (!current || dirty & /*description, message*/ 3)) {
						default_slot_or_fallback.p(ctx, !current ? -1 : dirty);
					}
				}

				if (/*variant*/ ctx[3] === "default") {
					if (if_block1) {
						if_block1.p(ctx, dirty);

						if (dirty & /*variant*/ 8) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block_1$f(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(div2, null);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}

				if (!current || dirty & /*type*/ 4 && div3_class_value !== (div3_class_value = "percs-alert percs-alert--type-" + /*type*/ ctx[2])) {
					attr(div3, "class", div3_class_value);
				}

				if (!current || dirty & /*type, variant*/ 12) {
					toggle_class(div3, "percs-alert--variant-dismissable", /*variant*/ ctx[3] === "default");
				}

				if (!current || dirty & /*type, variant*/ 12) {
					toggle_class(div3, "percs-alert--variant-flat", /*variant*/ ctx[3] === "flat");
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block0);
				transition_in(default_slot_or_fallback, local);
				transition_in(if_block1);

				if (local) {
					add_render_callback(() => {
						if (!current) return;

						if (!div3_transition) div3_transition = create_bidirectional_transition(
							div3,
							/*animateFn*/ ctx[6],
							{
								dismissible: /*variant*/ ctx[3] === "default"
							},
							true
						);

						div3_transition.run(1);
					});
				}

				current = true;
			},
			o(local) {
				transition_out(if_block0);
				transition_out(default_slot_or_fallback, local);
				transition_out(if_block1);

				if (local) {
					if (!div3_transition) div3_transition = create_bidirectional_transition(
						div3,
						/*animateFn*/ ctx[6],
						{
							dismissible: /*variant*/ ctx[3] === "default"
						},
						false
					);

					div3_transition.run(0);
				}

				current = false;
			},
			d(detaching) {
				if (detaching) detach(div3);
				if_blocks[current_block_type_index].d();
				if (default_slot_or_fallback) default_slot_or_fallback.d(detaching);
				if (if_block1) if_block1.d();
				if (detaching && div3_transition) div3_transition.end();
			}
		};
	}

	// (106:8) {:else}
	function create_else_block_2(ctx) {
		let svg;
		let path;

		return {
			c() {
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "d", "M9.75 9.75L14.25 14.25M14.25 9.75L9.75 14.25M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z");
				attr(path, "stroke", "#EF4444");
				attr(path, "stroke-width", "1.5");
				attr(path, "stroke-linecap", "round");
				attr(path, "stroke-linejoin", "round");
				attr(svg, "class", "percs-alert__icon");
				attr(svg, "viewBox", "0 0 24 24");
				attr(svg, "fill", "none");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			},
			m(target, anchor) {
				insert(target, svg, anchor);
				append(svg, path);
			},
			d(detaching) {
				if (detaching) detach(svg);
			}
		};
	}

	// (101:37) 
	function create_if_block_10$1(ctx) {
		let svg;
		let path;

		return {
			c() {
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "fill-rule", "evenodd");
				attr(path, "d", "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z");
				attr(path, "clip-rule", "evenodd");
				attr(svg, "class", "percs-alert__icon");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(svg, "viewBox", "0 0 20 20");
				attr(svg, "fill", "currentColor");
				attr(svg, "aria-hidden", "true");
			},
			m(target, anchor) {
				insert(target, svg, anchor);
				append(svg, path);
			},
			d(detaching) {
				if (detaching) detach(svg);
			}
		};
	}

	// (96:8) {#if type === "success"}
	function create_if_block_9$1(ctx) {
		let svg;
		let path;

		return {
			c() {
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "stroke-linecap", "round");
				attr(path, "stroke-linejoin", "round");
				attr(path, "d", "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z");
				attr(svg, "class", "percs-alert__icon text-green-400");
				attr(svg, "fill", "none");
				attr(svg, "viewBox", "0 0 24 24");
				attr(svg, "stroke-width", "1.5");
				attr(svg, "stroke", "currentColor");
				attr(svg, "aria-hidden", "true");
			},
			m(target, anchor) {
				insert(target, svg, anchor);
				append(svg, path);
			},
			d(detaching) {
				if (detaching) detach(svg);
			}
		};
	}

	// (115:10) {#if message}
	function create_if_block_8$1(ctx) {
		let p;
		let t;

		return {
			c() {
				p = element("p");
				t = text(/*message*/ ctx[0]);
				attr(p, "class", "text-sm font-medium text-gray-900");
			},
			m(target, anchor) {
				insert(target, p, anchor);
				append(p, t);
			},
			p(ctx, dirty) {
				if (dirty & /*message*/ 1) set_data(t, /*message*/ ctx[0]);
			},
			d(detaching) {
				if (detaching) detach(p);
			}
		};
	}

	// (118:10) {#if description}
	function create_if_block_7$2(ctx) {
		let p;
		let t;

		return {
			c() {
				p = element("p");
				t = text(/*description*/ ctx[1]);
				attr(p, "class", "mt-1 text-sm text-gray-500");
			},
			m(target, anchor) {
				insert(target, p, anchor);
				append(p, t);
			},
			p(ctx, dirty) {
				if (dirty & /*description*/ 2) set_data(t, /*description*/ ctx[1]);
			},
			d(detaching) {
				if (detaching) detach(p);
			}
		};
	}

	// (114:14)            
	function fallback_block_1(ctx) {
		let t;
		let if_block1_anchor;
		let if_block0 = /*message*/ ctx[0] && create_if_block_8$1(ctx);
		let if_block1 = /*description*/ ctx[1] && create_if_block_7$2(ctx);

		return {
			c() {
				if (if_block0) if_block0.c();
				t = space();
				if (if_block1) if_block1.c();
				if_block1_anchor = empty$3();
			},
			m(target, anchor) {
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, if_block1_anchor, anchor);
			},
			p(ctx, dirty) {
				if (/*message*/ ctx[0]) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_8$1(ctx);
						if_block0.c();
						if_block0.m(t.parentNode, t);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*description*/ ctx[1]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_7$2(ctx);
						if_block1.c();
						if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}
			},
			d(detaching) {
				if (if_block0) if_block0.d(detaching);
				if (detaching) detach(t);
				if (if_block1) if_block1.d(detaching);
				if (detaching) detach(if_block1_anchor);
			}
		};
	}

	// (123:6) {#if variant === "default"}
	function create_if_block_6$2(ctx) {
		let div;
		let button;
		let mounted;
		let dispose;

		return {
			c() {
				div = element("div");
				button = element("button");

				button.innerHTML = `<span class="sr-only">Close</span> 
            
            <svg class="percs-alert__close-icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"></path></svg>`;

				attr(button, "type", "button");
				attr(button, "class", "percs-alert__close-icon-button focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2");
				attr(div, "class", "percs-alert__close-icon-container");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, button);

				if (!mounted) {
					dispose = listen(button, "click", /*handleDismisss*/ ctx[5]);
					mounted = true;
				}
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(div);
				mounted = false;
				dispose();
			}
		};
	}

	// (54:8) {:else}
	function create_else_block$9(ctx) {
		let svg;
		let path;
		let path_transition;
		let current;

		return {
			c() {
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "d", "M9.75 9.75L14.25 14.25M14.25 9.75L9.75 14.25M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z");
				attr(path, "stroke", "#EF4444");
				attr(path, "stroke-width", "1.5");
				attr(path, "stroke-linecap", "round");
				attr(path, "stroke-linejoin", "round");
				attr(svg, "class", "percs-alert__icon");
				attr(svg, "viewBox", "0 0 24 24");
				attr(svg, "fill", "none");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			},
			m(target, anchor) {
				insert(target, svg, anchor);
				append(svg, path);
				current = true;
			},
			i(local) {
				if (current) return;

				if (local) {
					add_render_callback(() => {
						if (!current) return;
						if (!path_transition) path_transition = create_bidirectional_transition(path, draw, { duration: 400 }, true);
						path_transition.run(1);
					});
				}

				current = true;
			},
			o(local) {
				if (local) {
					if (!path_transition) path_transition = create_bidirectional_transition(path, draw, { duration: 400 }, false);
					path_transition.run(0);
				}

				current = false;
			},
			d(detaching) {
				if (detaching) detach(svg);
				if (detaching && path_transition) path_transition.end();
			}
		};
	}

	// (49:37) 
	function create_if_block_5$4(ctx) {
		let svg;
		let path;

		return {
			c() {
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "fill-rule", "evenodd");
				attr(path, "d", "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z");
				attr(path, "clip-rule", "evenodd");
				attr(svg, "class", "percs-alert__icon");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(svg, "viewBox", "0 0 20 20");
				attr(svg, "fill", "currentColor");
				attr(svg, "aria-hidden", "true");
			},
			m(target, anchor) {
				insert(target, svg, anchor);
				append(svg, path);
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(svg);
			}
		};
	}

	// (44:8) {#if type === "success"}
	function create_if_block_4$6(ctx) {
		let svg;
		let path;
		let path_transition;
		let current;

		return {
			c() {
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "stroke-linecap", "round");
				attr(path, "stroke-linejoin", "round");
				attr(path, "d", "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z");
				attr(svg, "class", "percs-alert__icon text-green-400");
				attr(svg, "fill", "none");
				attr(svg, "viewBox", "0 0 24 24");
				attr(svg, "stroke-width", "1.5");
				attr(svg, "stroke", "currentColor");
				attr(svg, "aria-hidden", "true");
			},
			m(target, anchor) {
				insert(target, svg, anchor);
				append(svg, path);
				current = true;
			},
			i(local) {
				if (current) return;

				if (local) {
					add_render_callback(() => {
						if (!current) return;
						if (!path_transition) path_transition = create_bidirectional_transition(path, draw, { duration: 400 }, true);
						path_transition.run(1);
					});
				}

				current = true;
			},
			o(local) {
				if (local) {
					if (!path_transition) path_transition = create_bidirectional_transition(path, draw, { duration: 400 }, false);
					path_transition.run(0);
				}

				current = false;
			},
			d(detaching) {
				if (detaching) detach(svg);
				if (detaching && path_transition) path_transition.end();
			}
		};
	}

	// (63:10) {#if message}
	function create_if_block_3$8(ctx) {
		let p;
		let t;

		return {
			c() {
				p = element("p");
				t = text(/*message*/ ctx[0]);
				attr(p, "class", "text-sm font-medium text-gray-900");
			},
			m(target, anchor) {
				insert(target, p, anchor);
				append(p, t);
			},
			p(ctx, dirty) {
				if (dirty & /*message*/ 1) set_data(t, /*message*/ ctx[0]);
			},
			d(detaching) {
				if (detaching) detach(p);
			}
		};
	}

	// (66:10) {#if description}
	function create_if_block_2$9(ctx) {
		let p;
		let t;

		return {
			c() {
				p = element("p");
				t = text(/*description*/ ctx[1]);
				attr(p, "class", "mt-1 text-sm text-gray-500");
			},
			m(target, anchor) {
				insert(target, p, anchor);
				append(p, t);
			},
			p(ctx, dirty) {
				if (dirty & /*description*/ 2) set_data(t, /*description*/ ctx[1]);
			},
			d(detaching) {
				if (detaching) detach(p);
			}
		};
	}

	// (62:14)            
	function fallback_block$1(ctx) {
		let t;
		let if_block1_anchor;
		let if_block0 = /*message*/ ctx[0] && create_if_block_3$8(ctx);
		let if_block1 = /*description*/ ctx[1] && create_if_block_2$9(ctx);

		return {
			c() {
				if (if_block0) if_block0.c();
				t = space();
				if (if_block1) if_block1.c();
				if_block1_anchor = empty$3();
			},
			m(target, anchor) {
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, if_block1_anchor, anchor);
			},
			p(ctx, dirty) {
				if (/*message*/ ctx[0]) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_3$8(ctx);
						if_block0.c();
						if_block0.m(t.parentNode, t);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (/*description*/ ctx[1]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);
					} else {
						if_block1 = create_if_block_2$9(ctx);
						if_block1.c();
						if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
					}
				} else if (if_block1) {
					if_block1.d(1);
					if_block1 = null;
				}
			},
			d(detaching) {
				if (if_block0) if_block0.d(detaching);
				if (detaching) detach(t);
				if (if_block1) if_block1.d(detaching);
				if (detaching) detach(if_block1_anchor);
			}
		};
	}

	// (71:6) {#if variant === "default"}
	function create_if_block_1$f(ctx) {
		let div;
		let button;
		let span;
		let t1;
		let svg;
		let path;
		let path_transition;
		let current;
		let mounted;
		let dispose;

		return {
			c() {
				div = element("div");
				button = element("button");
				span = element("span");
				span.textContent = "Close";
				t1 = space();
				svg = svg_element("svg");
				path = svg_element("path");
				attr(span, "class", "sr-only");
				attr(path, "d", "M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z");
				attr(svg, "class", "percs-alert__close-icon");
				attr(svg, "viewBox", "0 0 20 20");
				attr(svg, "fill", "currentColor");
				attr(svg, "aria-hidden", "true");
				attr(button, "type", "button");
				attr(button, "class", "percs-alert__close-icon-button focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2");
				attr(div, "class", "percs-alert__close-icon-container");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, button);
				append(button, span);
				append(button, t1);
				append(button, svg);
				append(svg, path);
				current = true;

				if (!mounted) {
					dispose = listen(button, "click", /*handleDismisss*/ ctx[5]);
					mounted = true;
				}
			},
			p: noop$6,
			i(local) {
				if (current) return;

				if (local) {
					add_render_callback(() => {
						if (!current) return;
						if (!path_transition) path_transition = create_bidirectional_transition(path, draw, { duration: 400 }, true);
						path_transition.run(1);
					});
				}

				current = true;
			},
			o(local) {
				if (local) {
					if (!path_transition) path_transition = create_bidirectional_transition(path, draw, { duration: 400 }, false);
					path_transition.run(0);
				}

				current = false;
			},
			d(detaching) {
				if (detaching) detach(div);
				if (detaching && path_transition) path_transition.end();
				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$r(ctx) {
		let current_block_type_index;
		let if_block;
		let if_block_anchor;
		let current;
		const if_block_creators = [create_if_block$h, create_else_block_1$1];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*animate*/ ctx[4]) return 0;
			return 1;
		}

		current_block_type_index = select_block_type(ctx);
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

		return {
			c() {
				if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if_blocks[current_block_type_index].m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type(ctx);

				if (current_block_type_index === previous_block_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if_blocks[current_block_type_index].d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	function instance$r($$self, $$props, $$invalidate) {
		let { $$slots: slots = {}, $$scope } = $$props;
		let { message = null } = $$props;
		let { description = null } = $$props;
		let { type = "success" } = $$props;
		let { variant = "default" } = $$props;
		let { animate = true } = $$props;
		const dispatch = createEventDispatcher();

		function handleDismisss() {
			dispatch("dismiss");
		}

		/**
	 * @param {Element} node
	 * @param {{ dismissible: boolean }} arg
	 */
		function animateFn(node, arg) {
			if (arg.dismissible) {
				return slideIn(node, { inFrom: "right", duration: 300 });
			}

			return fade(node);
		}

		$$self.$$set = $$props => {
			if ('message' in $$props) $$invalidate(0, message = $$props.message);
			if ('description' in $$props) $$invalidate(1, description = $$props.description);
			if ('type' in $$props) $$invalidate(2, type = $$props.type);
			if ('variant' in $$props) $$invalidate(3, variant = $$props.variant);
			if ('animate' in $$props) $$invalidate(4, animate = $$props.animate);
			if ('$$scope' in $$props) $$invalidate(7, $$scope = $$props.$$scope);
		};

		return [
			message,
			description,
			type,
			variant,
			animate,
			handleDismisss,
			animateFn,
			$$scope,
			slots
		];
	}

	class PercsAlert extends SvelteComponent {
		constructor(options) {
			super();

			init$3(
				this,
				options,
				instance$r,
				create_fragment$r,
				safe_not_equal,
				{
					message: 0,
					description: 1,
					type: 2,
					variant: 3,
					animate: 4
				},
				add_css$k
			);
		}
	}

	/* dist/components/internal/PercsSearchInput.svelte generated by Svelte v3.59.2 */

	function add_css$j(target) {
		append_styles(target, "svelte-15xmv68", ".percs-search-input__container-outer{margin-top:0.25rem;display:flex;border-radius:0.375rem;box-shadow:0 1px 2px 0 rgb(0 0 0 / 0.05)}.percs-search-input__container-inner{position:relative;display:flex;align-items:stretch;flex-grow:1}.percs-search-input__label{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border-width:0}.percs-search-input__icon{height:1.25rem;width:1.25rem;color:rgb(156 163 175)}.percs-search-input__icon-container{position:absolute;padding-left:0.75rem;display:flex;align-items:center;top:0;bottom:0;left:0;pointer-events:none}.percs-search-input__input{display:block;width:100%;border-radius:0px;border-top-left-radius:0.375rem;border-bottom-left-radius:0.375rem;padding-top:0.5rem;padding-bottom:0.5rem;padding-right:0.75rem;padding-left:2.5rem;border-color:rgb(209 213 219)}.percs-search-input__input:focus{border-color:rgb(99 102 241)}");
	}

	function create_fragment$q(ctx) {
		let div3;
		let label;
		let t1;
		let div2;
		let div1;
		let div0;
		let t2;
		let input;
		let mounted;
		let dispose;
		let div3_levels = [{ class: "percs-search-input" }, /*$$restProps*/ ctx[1]];
		let div_data_3 = {};

		for (let i = 0; i < div3_levels.length; i += 1) {
			div_data_3 = assign$6(div_data_3, div3_levels[i]);
		}

		return {
			c() {
				div3 = element("div");
				label = element("label");
				label.textContent = "Search";
				t1 = space();
				div2 = element("div");
				div1 = element("div");
				div0 = element("div");
				div0.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="percs-search-input__icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>`;
				t2 = space();
				input = element("input");
				attr(label, "for", "search");
				attr(label, "class", "percs-search-input__label");
				attr(div0, "class", "percs-search-input__icon-container");
				attr(input, "type", "search");
				attr(input, "name", "search");
				attr(input, "id", "search");
				attr(input, "class", "percs-search-input__input focus:ring-indigo-500 sm:text-sm");
				attr(input, "placeholder", "Search");
				attr(div1, "class", "percs-search-input__container-inner focus-within:z-10");
				attr(div2, "class", "percs-search-input__container-outer");
				set_attributes(div3, div_data_3);
			},
			m(target, anchor) {
				insert(target, div3, anchor);
				append(div3, label);
				append(div3, t1);
				append(div3, div2);
				append(div2, div1);
				append(div1, div0);
				append(div1, t2);
				append(div1, input);
				set_input_value(input, /*value*/ ctx[0]);

				if (!mounted) {
					dispose = listen(input, "input", /*input_input_handler*/ ctx[2]);
					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*value*/ 1 && input.value !== /*value*/ ctx[0]) {
					set_input_value(input, /*value*/ ctx[0]);
				}

				set_attributes(div3, div_data_3 = get_spread_update(div3_levels, [
					{ class: "percs-search-input" },
					dirty & /*$$restProps*/ 2 && /*$$restProps*/ ctx[1]
				]));
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(div3);
				mounted = false;
				dispose();
			}
		};
	}

	function instance$q($$self, $$props, $$invalidate) {
		const omit_props_names = ["value"];
		let $$restProps = compute_rest_props($$props, omit_props_names);
		let { value = "" } = $$props;

		function input_input_handler() {
			value = this.value;
			$$invalidate(0, value);
		}

		$$self.$$set = $$new_props => {
			$$props = assign$6(assign$6({}, $$props), exclude_internal_props($$new_props));
			$$invalidate(1, $$restProps = compute_rest_props($$props, omit_props_names));
			if ('value' in $$new_props) $$invalidate(0, value = $$new_props.value);
		};

		return [value, $$restProps, input_input_handler];
	}

	class PercsSearchInput extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$q, create_fragment$q, safe_not_equal, { value: 0 }, add_css$j);
		}
	}

	/* dist/components/internal/PercsLocationSelect.svelte generated by Svelte v3.59.2 */

	function add_css$i(target) {
		append_styles(target, "svelte-1b9cbt2", ".percs-location-select__label{font-size:1.125rem;line-height:1.5rem;font-weight:500;color:rgb(17 24 39)}.percs-location-select__subtext{margin-top:0.25rem;font-size:0.875rem;line-height:1.25rem;color:rgb(107 114 128)}.percs-location-select__container{overflow-y:auto;max-height:12rem}.percs-location-select__empty{display:flex;align-items:start;padding-left:1rem;padding-right:1rem;padding-bottom:1rem}.percs-location-select__fieldset{background-color:white}.percs-location-select__option{position:relative;border-width:1px;padding:1rem;display:flex;cursor:-pointer;border-color:rgb(229 231 235);border-bottom-left-radius:0.375rem;border-bottom-right-radius:0.375rem}.percs-location-select__option--hidden{display:none}.percs-location-select__option--selected .percs-location-select__option{background-color:rgb(238 242 255);border-color:rgb(199 210 254);z-index:10}.percs-location-select__option-input{height:1rem;width:1rem;margin-top:0.125rem;cursor:-pointer;color:rgb(79 70 229);border-color:rgb(209 213 219);flex-shrink:0}.percs-location-select__option-text-container{margin-left:0.75rem;display:flex;flex-direction:column}.percs-location-select__option-text-title{display:block;font-size:0.875rem;line-height:1.25rem;font-weight:500;color:rgb(17 24 39)}.percs-location-select__option--selected .percs-location-select__option-text-title{color:rgb(49 46 129)}.percs-location-select__option-text-description{display:block;font-size:0.875rem;line-height:1.25rem;color:rgb(107 114 128)}.percs-location-select__option--selected .percs-location-select__option-text-description{color:rgb(67 56 202)}.my-4{margin-top:1rem;margin-bottom:1rem}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border-width:0}");
	}

	function get_each_context$4(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[15] = list[i];
		child_ctx[17] = i;
		return child_ctx;
	}

	// (61:4) {#if locationSearchValue && matchedIndexes.length === 0}
	function create_if_block_1$e(ctx) {
		let div1;
		let div0;
		let t0;
		let t1;
		let t2;

		return {
			c() {
				div1 = element("div");
				div0 = element("div");
				t0 = text("No matching locations for \"");
				t1 = text(/*locationSearchValue*/ ctx[3]);
				t2 = text("\"");
				attr(div1, "class", "percs-location-select__empty");
			},
			m(target, anchor) {
				insert(target, div1, anchor);
				append(div1, div0);
				append(div0, t0);
				append(div0, t1);
				append(div0, t2);
			},
			p(ctx, dirty) {
				if (dirty & /*locationSearchValue*/ 8) set_data(t1, /*locationSearchValue*/ ctx[3]);
			},
			d(detaching) {
				if (detaching) detach(div1);
			}
		};
	}

	// (69:8) {#each options as option, index}
	function create_each_block$4(ctx) {
		let label;
		let input;
		let input_value_value;
		let value_has_changed = false;
		let t0;
		let span2;
		let span0;
		let t1_value = /*option*/ ctx[15].title + "";
		let t1;
		let t2;
		let span1;
		let t3_value = /*option*/ ctx[15].description + "";
		let t3;
		let t4;
		let binding_group;
		let mounted;
		let dispose;
		binding_group = init_binding_group(/*$$binding_groups*/ ctx[12][0]);

		return {
			c() {
				label = element("label");
				input = element("input");
				t0 = space();
				span2 = element("span");
				span0 = element("span");
				t1 = text(t1_value);
				t2 = space();
				span1 = element("span");
				t3 = text(t3_value);
				t4 = space();
				attr(input, "type", "radio");
				attr(input, "name", "location");
				input.__value = input_value_value = /*option*/ ctx[15].const;
				input.value = input.__value;
				input.required = true;
				attr(input, "class", "percs-location-select__option-input");
				attr(input, "aria-labelledby", "location-" + /*index*/ ctx[17] + "-label");
				attr(input, "aria-describedby", "location-" + /*index*/ ctx[17] + "-description");
				attr(span0, "id", "location-" + /*index*/ ctx[17] + "-label");
				attr(span0, "class", "percs-location-select__option-text-title");
				attr(span1, "id", "location-" + /*index*/ ctx[17] + "-description");
				attr(span1, "class", "percs-location-select__option-text-description");
				attr(span2, "class", "percs-location-select__option-text-container");
				attr(label, "class", "percs-location-select__option");
				toggle_class(label, "percs-location-select__option--selected", /*value*/ ctx[0] === /*option*/ ctx[15].const);
				toggle_class(label, "percs-location-select__option--hidden", /*value*/ ctx[0] !== /*option*/ ctx[15].const && /*locationSearchValue*/ ctx[3] && !/*matchedIndexes*/ ctx[4].includes(/*index*/ ctx[17]));
				binding_group.p(input);
			},
			m(target, anchor) {
				insert(target, label, anchor);
				append(label, input);
				input.checked = input.__value === /*value*/ ctx[0];
				append(label, t0);
				append(label, span2);
				append(span2, span0);
				append(span0, t1);
				append(span2, t2);
				append(span2, span1);
				append(span1, t3);
				append(label, t4);

				if (!mounted) {
					dispose = listen(input, "change", /*input_change_handler*/ ctx[11]);
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*options*/ 4 && input_value_value !== (input_value_value = /*option*/ ctx[15].const)) {
					input.__value = input_value_value;
					input.value = input.__value;
					value_has_changed = true;
				}

				if (value_has_changed || dirty & /*value, options*/ 5) {
					input.checked = input.__value === /*value*/ ctx[0];
				}

				if (dirty & /*options*/ 4 && t1_value !== (t1_value = /*option*/ ctx[15].title + "")) set_data(t1, t1_value);
				if (dirty & /*options*/ 4 && t3_value !== (t3_value = /*option*/ ctx[15].description + "")) set_data(t3, t3_value);

				if (dirty & /*value, options*/ 5) {
					toggle_class(label, "percs-location-select__option--selected", /*value*/ ctx[0] === /*option*/ ctx[15].const);
				}

				if (dirty & /*value, options, locationSearchValue, matchedIndexes*/ 29) {
					toggle_class(label, "percs-location-select__option--hidden", /*value*/ ctx[0] !== /*option*/ ctx[15].const && /*locationSearchValue*/ ctx[3] && !/*matchedIndexes*/ ctx[4].includes(/*index*/ ctx[17]));
				}
			},
			d(detaching) {
				if (detaching) detach(label);
				binding_group.r();
				mounted = false;
				dispose();
			}
		};
	}

	// (95:2) {#if selectedLocation}
	function create_if_block$g(ctx) {
		let div;
		let percsalert;
		let current;

		percsalert = new PercsAlert({
				props: {
					type: "warning",
					variant: "flat",
					$$slots: { default: [create_default_slot$i] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				div = element("div");
				create_component(percsalert.$$.fragment);
				attr(div, "class", "pt-4");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				mount_component(percsalert, div, null);
				current = true;
			},
			i(local) {
				if (current) return;
				transition_in(percsalert.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsalert.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div);
				destroy_component(percsalert);
			}
		};
	}

	// (97:6) <PercsAlert type="warning" variant="flat">
	function create_default_slot$i(ctx) {
		let div;

		return {
			c() {
				div = element("div");
				div.textContent = "Once the ticket is redeemed, the redemption location cannot change.";
				attr(div, "class", "text-[#fbb338]");
			},
			m(target, anchor) {
				insert(target, div, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(div);
			}
		};
	}

	function create_fragment$p(ctx) {
		let div2;
		let h2;
		let t0_value = /*element*/ ctx[1].label + "";
		let t0;
		let t1;
		let p;
		let t3;
		let percssearchinput;
		let updating_value;
		let t4;
		let div1;
		let t5;
		let fieldset;
		let legend;
		let t6_value = /*element*/ ctx[1].label + "";
		let t6;
		let t7;
		let div0;
		let div1_style_value;
		let div1_resize_listener;
		let t8;
		let div2_style_value;
		let div2_resize_listener;
		let current;

		function percssearchinput_value_binding(value) {
			/*percssearchinput_value_binding*/ ctx[10](value);
		}

		let percssearchinput_props = { class: "my-4" };

		if (/*locationSearchValue*/ ctx[3] !== void 0) {
			percssearchinput_props.value = /*locationSearchValue*/ ctx[3];
		}

		percssearchinput = new PercsSearchInput({ props: percssearchinput_props });
		binding_callbacks.push(() => bind$4(percssearchinput, 'value', percssearchinput_value_binding));
		let if_block0 = /*locationSearchValue*/ ctx[3] && /*matchedIndexes*/ ctx[4].length === 0 && create_if_block_1$e(ctx);
		let each_value = /*options*/ ctx[2];
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$4(get_each_context$4(ctx, each_value, i));
		}

		let if_block1 = /*selectedLocation*/ ctx[9] && create_if_block$g(ctx);

		return {
			c() {
				div2 = element("div");
				h2 = element("h2");
				t0 = text(t0_value);
				t1 = space();
				p = element("p");
				p.textContent = "Your code will be valid for the selected store only";
				t3 = space();
				create_component(percssearchinput.$$.fragment);
				t4 = space();
				div1 = element("div");
				if (if_block0) if_block0.c();
				t5 = space();
				fieldset = element("fieldset");
				legend = element("legend");
				t6 = text(t6_value);
				t7 = space();
				div0 = element("div");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t8 = space();
				if (if_block1) if_block1.c();
				attr(h2, "class", "percs-location-select__label");
				attr(p, "class", "percs-location-select__subtext");
				attr(legend, "class", "sr-only");
				attr(fieldset, "class", "percs-location-select__fieldset");
				attr(div1, "class", "percs-location-select__container");

				attr(div1, "style", div1_style_value = /*displayHeight*/ ctx[8] > 0
				? `height: ${/*displayHeight*/ ctx[8]}px;`
				: "");

				add_render_callback(() => /*div1_elementresize_handler*/ ctx[13].call(div1));
				attr(div2, "class", "percs-location-select");

				attr(div2, "style", div2_style_value = /*displayWidth*/ ctx[6] > 0
				? `width: ${/*displayWidth*/ ctx[6]}px;`
				: "");

				add_render_callback(() => /*div2_elementresize_handler*/ ctx[14].call(div2));
			},
			m(target, anchor) {
				insert(target, div2, anchor);
				append(div2, h2);
				append(h2, t0);
				append(div2, t1);
				append(div2, p);
				append(div2, t3);
				mount_component(percssearchinput, div2, null);
				append(div2, t4);
				append(div2, div1);
				if (if_block0) if_block0.m(div1, null);
				append(div1, t5);
				append(div1, fieldset);
				append(fieldset, legend);
				append(legend, t6);
				append(fieldset, t7);
				append(fieldset, div0);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(div0, null);
					}
				}

				div1_resize_listener = add_iframe_resize_listener(div1, /*div1_elementresize_handler*/ ctx[13].bind(div1));
				append(div2, t8);
				if (if_block1) if_block1.m(div2, null);
				div2_resize_listener = add_iframe_resize_listener(div2, /*div2_elementresize_handler*/ ctx[14].bind(div2));
				current = true;
			},
			p(ctx, [dirty]) {
				if ((!current || dirty & /*element*/ 2) && t0_value !== (t0_value = /*element*/ ctx[1].label + "")) set_data(t0, t0_value);
				const percssearchinput_changes = {};

				if (!updating_value && dirty & /*locationSearchValue*/ 8) {
					updating_value = true;
					percssearchinput_changes.value = /*locationSearchValue*/ ctx[3];
					add_flush_callback(() => updating_value = false);
				}

				percssearchinput.$set(percssearchinput_changes);

				if (/*locationSearchValue*/ ctx[3] && /*matchedIndexes*/ ctx[4].length === 0) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_1$e(ctx);
						if_block0.c();
						if_block0.m(div1, t5);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if ((!current || dirty & /*element*/ 2) && t6_value !== (t6_value = /*element*/ ctx[1].label + "")) set_data(t6, t6_value);

				if (dirty & /*value, options, locationSearchValue, matchedIndexes*/ 29) {
					each_value = /*options*/ ctx[2];
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$4(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
						} else {
							each_blocks[i] = create_each_block$4(child_ctx);
							each_blocks[i].c();
							each_blocks[i].m(div0, null);
						}
					}

					for (; i < each_blocks.length; i += 1) {
						each_blocks[i].d(1);
					}

					each_blocks.length = each_value.length;
				}

				if (!current || dirty & /*displayHeight*/ 256 && div1_style_value !== (div1_style_value = /*displayHeight*/ ctx[8] > 0
				? `height: ${/*displayHeight*/ ctx[8]}px;`
				: "")) {
					attr(div1, "style", div1_style_value);
				}

				if (/*selectedLocation*/ ctx[9]) {
					if (if_block1) {
						if (dirty & /*selectedLocation*/ 512) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block$g(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(div2, null);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}

				if (!current || dirty & /*displayWidth*/ 64 && div2_style_value !== (div2_style_value = /*displayWidth*/ ctx[6] > 0
				? `width: ${/*displayWidth*/ ctx[6]}px;`
				: "")) {
					attr(div2, "style", div2_style_value);
				}
			},
			i(local) {
				if (current) return;
				transition_in(percssearchinput.$$.fragment, local);
				transition_in(if_block1);
				current = true;
			},
			o(local) {
				transition_out(percssearchinput.$$.fragment, local);
				transition_out(if_block1);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div2);
				destroy_component(percssearchinput);
				if (if_block0) if_block0.d();
				destroy_each(each_blocks, detaching);
				div1_resize_listener();
				if (if_block1) if_block1.d();
				div2_resize_listener();
			}
		};
	}

	function instance$p($$self, $$props, $$invalidate) {
		let { element } = $$props;
		let { options = [] } = $$props;
		let { value = null } = $$props;
		let locationSearchValue = "";

		/** @type {number[]} */
		let matchedIndexes = [];

		/** @type {any | null} */
		let selectedLocation = null;

		let renderWidth = 0;
		let displayWidth = 0;
		let renderHeight = 0;
		let displayHeight = 0;
		const $$binding_groups = [[]];

		function percssearchinput_value_binding(value) {
			locationSearchValue = value;
			$$invalidate(3, locationSearchValue);
		}

		function input_change_handler() {
			value = this.__value;
			$$invalidate(0, value);
		}

		function div1_elementresize_handler() {
			renderHeight = this.clientHeight;
			$$invalidate(7, renderHeight);
		}

		function div2_elementresize_handler() {
			renderWidth = this.clientWidth;
			$$invalidate(5, renderWidth);
		}

		$$self.$$set = $$props => {
			if ('element' in $$props) $$invalidate(1, element = $$props.element);
			if ('options' in $$props) $$invalidate(2, options = $$props.options);
			if ('value' in $$props) $$invalidate(0, value = $$props.value);
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*value, options, locationSearchValue, matchedIndexes*/ 29) {
				{
					if (value) {
						$$invalidate(9, selectedLocation = options.find(location => location.const === value));
					} else {
						$$invalidate(9, selectedLocation = null);
					}

					if (locationSearchValue) {
						$$invalidate(4, matchedIndexes = []);
						const searchTokens = locationSearchValue.toLowerCase().split(/\s+/u);

						for (let i = 0; i < options.length; i++) {
							const option = options[i];
							let isMatched = true;

							// eslint-disable-next-line max-depth
							for (const searchToken of searchTokens) {
								// eslint-disable-next-line max-depth
								if (!option.title.toLowerCase().includes(searchToken) && !option.description.toLowerCase().includes(searchToken)) {
									isMatched = false;
									continue;
								}
							}

							// eslint-disable-next-line max-depth
							if (isMatched) {
								matchedIndexes.push(i);
							}
						}
					}
				}
			}

			if ($$self.$$.dirty & /*renderWidth, displayWidth*/ 96) {
				$$invalidate(6, displayWidth = Math.max(renderWidth, displayWidth));
			}

			if ($$self.$$.dirty & /*renderHeight, displayHeight*/ 384) {
				$$invalidate(8, displayHeight = Math.max(renderHeight, displayHeight));
			}
		};

		return [
			value,
			element,
			options,
			locationSearchValue,
			matchedIndexes,
			renderWidth,
			displayWidth,
			renderHeight,
			displayHeight,
			selectedLocation,
			percssearchinput_value_binding,
			input_change_handler,
			$$binding_groups,
			div1_elementresize_handler,
			div2_elementresize_handler
		];
	}

	class PercsLocationSelect extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$p, create_fragment$p, safe_not_equal, { element: 1, options: 2, value: 0 }, add_css$i);
		}
	}

	/* dist/components/dialog-contents/OfferRedeemDetails.svelte generated by Svelte v3.59.2 */

	function add_css$h(target) {
		append_styles(target, "svelte-14r22lf", ".text-left{text-align:left}.space-y-4 > * + *{margin-top:1rem}");
	}

	function get_each_context$3(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[11] = list[i];
		return child_ctx;
	}

	// (35:6) {#if element.type === "Control"}
	function create_if_block$f(ctx) {
		let current_block_type_index;
		let if_block;
		let if_block_anchor;
		let current;
		const if_block_creators = [create_if_block_1$d, create_if_block_2$8];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*element*/ ctx[11].scope === "#/properties/location") return 0;
			if (/*element*/ ctx[11].scope === "#/properties/email") return 1;
			return -1;
		}

		if (~(current_block_type_index = select_block_type(ctx))) {
			if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		}

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].m(target, anchor);
				}

				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (if_block) if_block.p(ctx, dirty);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].d(detaching);
				}

				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (42:57) 
	function create_if_block_2$8(ctx) {
		let percsemailinput;
		let updating_value;
		let current;

		function percsemailinput_value_binding(value) {
			/*percsemailinput_value_binding*/ ctx[5](value);
		}

		let percsemailinput_props = { label: /*element*/ ctx[11].label };

		if (/*redemptionValues*/ ctx[1].email !== void 0) {
			percsemailinput_props.value = /*redemptionValues*/ ctx[1].email;
		}

		percsemailinput = new PercsEmailInput({ props: percsemailinput_props });
		binding_callbacks.push(() => bind$4(percsemailinput, 'value', percsemailinput_value_binding));

		return {
			c() {
				create_component(percsemailinput.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsemailinput, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsemailinput_changes = {};

				if (!updating_value && dirty & /*redemptionValues*/ 2) {
					updating_value = true;
					percsemailinput_changes.value = /*redemptionValues*/ ctx[1].email;
					add_flush_callback(() => updating_value = false);
				}

				percsemailinput.$set(percsemailinput_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsemailinput.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsemailinput.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsemailinput, detaching);
			}
		};
	}

	// (36:8) {#if element.scope === "#/properties/location"}
	function create_if_block_1$d(ctx) {
		let percslocationselect;
		let updating_value;
		let current;

		function percslocationselect_value_binding(value) {
			/*percslocationselect_value_binding*/ ctx[4](value);
		}

		let percslocationselect_props = {
			element: /*element*/ ctx[11],
			options: /*redemptionFields*/ ctx[2].schema.properties.location.oneOf
		};

		if (/*redemptionValues*/ ctx[1].location !== void 0) {
			percslocationselect_props.value = /*redemptionValues*/ ctx[1].location;
		}

		percslocationselect = new PercsLocationSelect({ props: percslocationselect_props });
		binding_callbacks.push(() => bind$4(percslocationselect, 'value', percslocationselect_value_binding));

		return {
			c() {
				create_component(percslocationselect.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percslocationselect, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percslocationselect_changes = {};

				if (!updating_value && dirty & /*redemptionValues*/ 2) {
					updating_value = true;
					percslocationselect_changes.value = /*redemptionValues*/ ctx[1].location;
					add_flush_callback(() => updating_value = false);
				}

				percslocationselect.$set(percslocationselect_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percslocationselect.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percslocationselect.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percslocationselect, detaching);
			}
		};
	}

	// (34:4) {#each redemptionFields.uiSchema.elements as element }
	function create_each_block$3(ctx) {
		let if_block_anchor;
		let current;
		let if_block = /*element*/ ctx[11].type === "Control" && create_if_block$f(ctx);

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (/*element*/ ctx[11].type === "Control") if_block.p(ctx, dirty);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (if_block) if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (52:6) <PercsButton type="submit" variant="contained">
	function create_default_slot_3$9(ctx) {
		let t;

		return {
			c() {
				t = text("Redeem");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (53:6) <PercsButton on:click={() => state.send("OFFER_REDEEM_CANCEL", { redemptionValues })}>
	function create_default_slot_2$e(ctx) {
		let t;

		return {
			c() {
				t = text("Back");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (51:4) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$g(ctx) {
		let percsbutton0;
		let t;
		let percsbutton1;
		let current;

		percsbutton0 = new PercsButton({
				props: {
					type: "submit",
					variant: "contained",
					$$slots: { default: [create_default_slot_3$9] },
					$$scope: { ctx }
				}
			});

		percsbutton1 = new PercsButton({
				props: {
					$$slots: { default: [create_default_slot_2$e] },
					$$scope: { ctx }
				}
			});

		percsbutton1.$on("click", /*click_handler*/ ctx[6]);

		return {
			c() {
				create_component(percsbutton0.$$.fragment);
				t = space();
				create_component(percsbutton1.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton0, target, anchor);
				insert(target, t, anchor);
				mount_component(percsbutton1, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton0_changes = {};

				if (dirty & /*$$scope*/ 16384) {
					percsbutton0_changes.$$scope = { dirty, ctx };
				}

				percsbutton0.$set(percsbutton0_changes);
				const percsbutton1_changes = {};

				if (dirty & /*$$scope*/ 16384) {
					percsbutton1_changes.$$scope = { dirty, ctx };
				}

				percsbutton1.$set(percsbutton1_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton0.$$.fragment, local);
				transition_in(percsbutton1.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton0.$$.fragment, local);
				transition_out(percsbutton1.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton0, detaching);
				if (detaching) detach(t);
				destroy_component(percsbutton1, detaching);
			}
		};
	}

	// (32:0) <PercsDialogContent>
	function create_default_slot$h(ctx) {
		let form;
		let t;
		let percsdialogactions;
		let current;
		let mounted;
		let dispose;
		let each_value = /*redemptionFields*/ ctx[2].uiSchema.elements;
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$3(get_each_context$3(ctx, each_value, i));
		}

		const out = i => transition_out(each_blocks[i], 1, 1, () => {
			each_blocks[i] = null;
		});

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$g] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				form = element("form");

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t = space();
				create_component(percsdialogactions.$$.fragment);
				attr(form, "class", "text-left space-y-4");
			},
			m(target, anchor) {
				insert(target, form, anchor);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(form, null);
					}
				}

				append(form, t);
				mount_component(percsdialogactions, form, null);
				current = true;

				if (!mounted) {
					dispose = listen(form, "submit", prevent_default(/*submit_handler*/ ctx[7]));
					mounted = true;
				}
			},
			p(ctx, dirty) {
				if (dirty & /*redemptionFields, redemptionValues*/ 6) {
					each_value = /*redemptionFields*/ ctx[2].uiSchema.elements;
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$3(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
							transition_in(each_blocks[i], 1);
						} else {
							each_blocks[i] = create_each_block$3(child_ctx);
							each_blocks[i].c();
							transition_in(each_blocks[i], 1);
							each_blocks[i].m(form, t);
						}
					}

					group_outros();

					for (i = each_value.length; i < each_blocks.length; i += 1) {
						out(i);
					}

					check_outros();
				}

				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state, redemptionValues*/ 16387) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;

				for (let i = 0; i < each_value.length; i += 1) {
					transition_in(each_blocks[i]);
				}

				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				each_blocks = each_blocks.filter(Boolean);

				for (let i = 0; i < each_blocks.length; i += 1) {
					transition_out(each_blocks[i]);
				}

				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(form);
				destroy_each(each_blocks, detaching);
				destroy_component(percsdialogactions);
				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$o(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Offer Details"
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[3]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot$h] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];
				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, redemptionValues*/ 16387) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$o($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(8, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();
		const selectedOffer = $state.context.offers.find(offer => offer.id === $state.context.offerSelectedId);
		const selectedContract = selectedOffer?.redemption.contractTokens.find(token => `${token.type}:${token.address}` === $state.context.offerSelectedContract);
		const { redemptionFields } = selectedContract ?? {};

		if (!redemptionFields) {
			throw new Error("Invalid state");
		}

		const redemptionValues = Object.fromEntries(Object.keys(redemptionFields.schema?.properties ?? {}).map(key => [key, ""]));

		if ($state.context.redemptionValues) {
			for (const key of Object.keys(redemptionValues)) {
				if (key in $state.context.redemptionValues) {
					redemptionValues[key] = $state.context.redemptionValues[key];
				}
			}
		}

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		function percslocationselect_value_binding(value) {
			if ($$self.$$.not_equal(redemptionValues.location, value)) {
				redemptionValues.location = value;
				$$invalidate(1, redemptionValues);
			}
		}

		function percsemailinput_value_binding(value) {
			if ($$self.$$.not_equal(redemptionValues.email, value)) {
				redemptionValues.email = value;
				$$invalidate(1, redemptionValues);
			}
		}

		const click_handler = () => state.send("OFFER_REDEEM_CANCEL", { redemptionValues });
		const submit_handler = () => state.send("OFFER_REDEEM", { redemptionValues });

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [
			state,
			redemptionValues,
			redemptionFields,
			close_handler,
			percslocationselect_value_binding,
			percsemailinput_value_binding,
			click_handler,
			submit_handler
		];
	}

	class OfferRedeemDetails extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$o, create_fragment$o, safe_not_equal, { state: 0 }, add_css$h);
		}
	}

	/* dist/components/internal/PercsCopyCode.svelte generated by Svelte v3.59.2 */

	function add_css$g(target) {
		append_styles(target, "svelte-kaunkj", ".copy-container.svelte-kaunkj{margin-top:12px;gap:6px}button.svelte-kaunkj{border-radius:6px;background:none;padding:9px 16px;font-family:inherit;font-style:normal;font-weight:500;font-size:14px;line-height:20px;border:2px solid transparent;cursor:pointer}.textbox.svelte-kaunkj{border-radius:5px;padding:9px 8px;border:1px solid #D1D5DB;text-align:left;background-color:white}.textbox__button.svelte-kaunkj{width:90px;border-radius:5px;border:1px solid #D1D5DB;background-color:white}.textbox__button--copied.svelte-kaunkj{background-color:#285FE0}.textbox__text.svelte-kaunkj{width:20ch;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;color:#9CA3AF}@media only screen and (max-width: 600px){.textbox__text.svelte-kaunkj{width:12ch}}.textbox__text--copied.svelte-kaunkj{color:#285FE0}.flex.svelte-kaunkj{display:flex}.grow.svelte-kaunkj{flex-grow:1}.justify-center.svelte-kaunkj{justify-content:center}.items-center.svelte-kaunkj{align-items:center}.truncate.svelte-kaunkj{text-overflow:ellipsis}");
	}

	// (33:4) {:else}
	function create_else_block_1(ctx) {
		let span;
		let t;

		return {
			c() {
				span = element("span");
				t = text(/*value*/ ctx[0]);
				attr(span, "class", "textbox__text svelte-kaunkj");
				attr(span, "title", /*value*/ ctx[0]);
			},
			m(target, anchor) {
				insert(target, span, anchor);
				append(span, t);
			},
			p(ctx, dirty) {
				if (dirty & /*value*/ 1) set_data(t, /*value*/ ctx[0]);

				if (dirty & /*value*/ 1) {
					attr(span, "title", /*value*/ ctx[0]);
				}
			},
			d(detaching) {
				if (detaching) detach(span);
			}
		};
	}

	// (31:4) {#if isCopied}
	function create_if_block_1$c(ctx) {
		let span;

		return {
			c() {
				span = element("span");
				span.textContent = "Code copied!";
				attr(span, "class", "textbox__text textbox__text--copied svelte-kaunkj");
			},
			m(target, anchor) {
				insert(target, span, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(span);
			}
		};
	}

	// (49:4) {:else}
	function create_else_block$8(ctx) {
		let button;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");

				button.innerHTML = `<svg width="16" height="16" style="margin-right: 8px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="copy-code-icon"><g clip-path="url(#clip0_743_29259)"><path d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.33301 10.0002H2.66634C2.31272 10.0002 1.97358 9.85969 1.72353 9.60964C1.47348 9.35959 1.33301 9.02045 1.33301 8.66683V2.66683C1.33301 2.31321 1.47348 1.97407 1.72353 1.72402C1.97358 1.47397 2.31272 1.3335 2.66634 1.3335H8.66634C9.01996 1.3335 9.3591 1.47397 9.60915 1.72402C9.8592 1.97407 9.99967 2.31321 9.99967 2.66683V3.3335" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_743_29259"><rect width="16" height="16" fill="white"></rect></clipPath></defs></svg>
        Copy`;

				attr(button, "class", "flex items-center textbox__button svelte-kaunkj");
				attr(button, "type", "button");
				attr(button, "data-testid", "btn-copy");
			},
			m(target, anchor) {
				insert(target, button, anchor);

				if (!mounted) {
					dispose = listen(button, "click", /*handleCopy*/ ctx[2]);
					mounted = true;
				}
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(button);
				mounted = false;
				dispose();
			}
		};
	}

	// (38:4) {#if isCopied}
	function create_if_block$e(ctx) {
		let button;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				button.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="code-copied-icon"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.52081 2.14585C6.29249 2.08427 7.02508 1.78082 7.61428 1.2787C8.98925 0.106968 11.0115 0.106968 12.3865 1.2787C12.9757 1.78082 13.7083 2.08427 14.48 2.14585C16.2808 2.28955 17.7107 3.71953 17.8544 5.52032C17.916 6.292 18.2195 7.02459 18.7216 7.61379C19.8933 8.98876 19.8933 11.011 18.7216 12.386C18.2195 12.9752 17.916 13.7078 17.8544 14.4795C17.7107 16.2803 16.2808 17.7103 14.48 17.854C13.7083 17.9155 12.9757 18.219 12.3865 18.7211C11.0115 19.8928 8.98925 19.8928 7.61428 18.7211C7.02508 18.219 6.29249 17.9155 5.52081 17.854C3.72002 17.7103 2.29004 16.2803 2.14634 14.4795C2.08476 13.7078 1.78131 12.9752 1.27919 12.386C0.107456 11.011 0.107456 8.98876 1.27919 7.61379C1.78131 7.02459 2.08476 6.292 2.14634 5.52032C2.29004 3.71953 3.72002 2.28955 5.52081 2.14585ZM14.4489 8.44843C14.9175 7.9798 14.9175 7.22 14.4489 6.75137C13.9803 6.28275 13.2205 6.28275 12.7519 6.75137L8.80039 10.7028L7.24892 9.15137C6.78029 8.68274 6.02049 8.68274 5.55186 9.15137C5.08323 9.62 5.08323 10.3798 5.55186 10.8484L7.95186 13.2484C8.42049 13.7171 9.18029 13.7171 9.64892 13.2484L14.4489 8.44843Z" fill="white"></path></svg>`;
				attr(button, "class", "flex items-center textbox__button textbox__button--copied justify-center svelte-kaunkj");
				attr(button, "type", "button");
				attr(button, "data-testid", "btn-copy");
			},
			m(target, anchor) {
				insert(target, button, anchor);

				if (!mounted) {
					dispose = listen(button, "click", /*handleCopy*/ ctx[2]);
					mounted = true;
				}
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(button);
				mounted = false;
				dispose();
			}
		};
	}

	function create_fragment$n(ctx) {
		let div2;
		let div0;
		let t;
		let div1;

		function select_block_type(ctx, dirty) {
			if (/*isCopied*/ ctx[1]) return create_if_block_1$c;
			return create_else_block_1;
		}

		let current_block_type = select_block_type(ctx);
		let if_block0 = current_block_type(ctx);

		function select_block_type_1(ctx, dirty) {
			if (/*isCopied*/ ctx[1]) return create_if_block$e;
			return create_else_block$8;
		}

		let current_block_type_1 = select_block_type_1(ctx);
		let if_block1 = current_block_type_1(ctx);

		return {
			c() {
				div2 = element("div");
				div0 = element("div");
				if_block0.c();
				t = space();
				div1 = element("div");
				if_block1.c();
				attr(div0, "class", "grow truncate textbox svelte-kaunkj");
				attr(div0, "data-testid", "copy-code-text");
				attr(div2, "class", "copy-container flex items-center svelte-kaunkj");
			},
			m(target, anchor) {
				insert(target, div2, anchor);
				append(div2, div0);
				if_block0.m(div0, null);
				append(div2, t);
				append(div2, div1);
				if_block1.m(div1, null);
			},
			p(ctx, [dirty]) {
				if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0.d(1);
					if_block0 = current_block_type(ctx);

					if (if_block0) {
						if_block0.c();
						if_block0.m(div0, null);
					}
				}

				if (current_block_type_1 === (current_block_type_1 = select_block_type_1(ctx)) && if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1.d(1);
					if_block1 = current_block_type_1(ctx);

					if (if_block1) {
						if_block1.c();
						if_block1.m(div1, null);
					}
				}
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(div2);
				if_block0.d();
				if_block1.d();
			}
		};
	}

	function instance$n($$self, $$props, $$invalidate) {
		let { value } = $$props;
		let isCopied = false;

		/** @type {?NodeJS.Timeout} */
		let copyTimer = null;

		function handleCopy() {
			navigator.clipboard.writeText(value);
			$$invalidate(1, isCopied = true);

			if (copyTimer != null) {
				clearTimeout(copyTimer);
			}

			copyTimer = setTimeout(
				() => {
					$$invalidate(1, isCopied = false);
				},
				6000
			);
		}

		onDestroy(() => {
			if (copyTimer != null) {
				clearTimeout(copyTimer);
			}
		});

		$$self.$$set = $$props => {
			if ('value' in $$props) $$invalidate(0, value = $$props.value);
		};

		return [value, isCopied, handleCopy];
	}

	class PercsCopyCode extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$n, create_fragment$n, safe_not_equal, { value: 0 }, add_css$g);
		}
	}

	/* dist/components/internal/PercsTokenOfferBadgeCard.svelte generated by Svelte v3.59.2 */

	function add_css$f(target) {
		append_styles(target, "svelte-kwhw83", ".percs-token-offer-badge-card{display:flex;flex-direction:column;align-items:flex-start;gap:8px;max-width:400px;padding:12px;background-color:#FFFFFF;box-sizing:border-box;border:1px solid #EAECF0;border-radius:12px;box-shadow:0px 1px 2px rgba(16, 24, 40, 0.05)}.percs-token-offer-badge-card__image-container{position:relative;width:100%;border-radius:6px;overflow:hidden}.percs-token-offer-badge-card__image{width:100%;border-radius:6px}.percs-token-offer-badge-card__overlay{position:absolute;top:0;right:0;background-color:#059669;border-radius:0px 0px 0px 139px / 0px 0px 0px 150px;padding:7px 12px 7px 30px;color:white;box-sizing:border-box;border-bottom:1px solid #FFFFFF;border-left:1px solid #FFFFFF;text-transform:uppercase}.percs-token-offer-badge-card__text{font-weight:600}");
	}

	function create_fragment$m(ctx) {
		let div3;
		let div1;
		let div0;
		let t0;
		let t1;
		let img;
		let img_src_value;
		let img_alt_value;
		let t2;
		let div2;
		let t3_value = /*token*/ ctx[0].name + "";
		let t3;
		let mounted;
		let dispose;

		return {
			c() {
				div3 = element("div");
				div1 = element("div");
				div0 = element("div");
				t0 = text(/*offerText*/ ctx[1]);
				t1 = space();
				img = element("img");
				t2 = space();
				div2 = element("div");
				t3 = text(t3_value);
				attr(div0, "class", "percs-token-offer-badge-card__overlay");
				attr(img, "class", "percs-token-offer-badge-card__image");
				if (!src_url_equal(img.src, img_src_value = /*token*/ ctx[0].image?.src ?? "https://assets.getpercs.com/logo.svg")) attr(img, "src", img_src_value);
				attr(img, "alt", img_alt_value = /*token*/ ctx[0].name);
				attr(div1, "class", "percs-token-offer-badge-card__image-container");
				attr(div2, "class", "percs-token-offer-badge-card__text");
				attr(div3, "class", "percs-token-offer-badge-card");
			},
			m(target, anchor) {
				insert(target, div3, anchor);
				append(div3, div1);
				append(div1, div0);
				append(div0, t0);
				append(div1, t1);
				append(div1, img);
				append(div3, t2);
				append(div3, div2);
				append(div2, t3);

				if (!mounted) {
					dispose = [
						listen(div3, "click", /*click_handler*/ ctx[2]),
						listen(div3, "keydown", /*keydown_handler*/ ctx[3]),
						listen(div3, "keypress", /*keypress_handler*/ ctx[4]),
						listen(div3, "keyup", /*keyup_handler*/ ctx[5])
					];

					mounted = true;
				}
			},
			p(ctx, [dirty]) {
				if (dirty & /*offerText*/ 2) set_data(t0, /*offerText*/ ctx[1]);

				if (dirty & /*token*/ 1 && !src_url_equal(img.src, img_src_value = /*token*/ ctx[0].image?.src ?? "https://assets.getpercs.com/logo.svg")) {
					attr(img, "src", img_src_value);
				}

				if (dirty & /*token*/ 1 && img_alt_value !== (img_alt_value = /*token*/ ctx[0].name)) {
					attr(img, "alt", img_alt_value);
				}

				if (dirty & /*token*/ 1 && t3_value !== (t3_value = /*token*/ ctx[0].name + "")) set_data(t3, t3_value);
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(div3);
				mounted = false;
				run_all(dispose);
			}
		};
	}

	function instance$m($$self, $$props, $$invalidate) {
		let { token } = $$props;
		let { offerText } = $$props;

		function click_handler(event) {
			bubble.call(this, $$self, event);
		}

		function keydown_handler(event) {
			bubble.call(this, $$self, event);
		}

		function keypress_handler(event) {
			bubble.call(this, $$self, event);
		}

		function keyup_handler(event) {
			bubble.call(this, $$self, event);
		}

		$$self.$$set = $$props => {
			if ('token' in $$props) $$invalidate(0, token = $$props.token);
			if ('offerText' in $$props) $$invalidate(1, offerText = $$props.offerText);
		};

		return [
			token,
			offerText,
			click_handler,
			keydown_handler,
			keypress_handler,
			keyup_handler
		];
	}

	class PercsTokenOfferBadgeCard extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$m, create_fragment$m, safe_not_equal, { token: 0, offerText: 1 }, add_css$f);
		}
	}

	/* dist/components/dialog-contents/OfferRedeemDiscountSuccess.svelte generated by Svelte v3.59.2 */

	function add_css$e(target) {
		append_styles(target, "svelte-9dlmm5", ".order-redeem-success__text.svelte-9dlmm5{margin-block-start:0em;margin-block-end:0em;padding-block-start:1em;padding-block-end:1em}");
	}

	function get_each_context$2(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[13] = list[i];
		return child_ctx;
	}

	// (49:0) <PercsDialogHeader {state} on:close text="Discount Details">
	function create_default_slot_5$3(ctx) {
		let h2;
		let t1;
		let p;

		return {
			c() {
				h2 = element("h2");
				h2.textContent = "You have claimed your NFT discount.";
				t1 = space();
				p = element("p");
				p.textContent = "Apply your discount and buy now!  Or copy your discount and use at checkout.";
				attr(p, "class", "order-redeem-success__text svelte-9dlmm5");
			},
			m(target, anchor) {
				insert(target, h2, anchor);
				insert(target, t1, anchor);
				insert(target, p, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(h2);
				if (detaching) detach(t1);
				if (detaching) detach(p);
			}
		};
	}

	// (57:62) 
	function create_if_block_5$3(ctx) {
		let percstokenofferbadgecard;
		let current;

		percstokenofferbadgecard = new PercsTokenOfferBadgeCard({
				props: {
					token: /*selectedToken*/ ctx[4],
					offerText: /*selectedItem*/ ctx[5]?.name ?? ""
				}
			});

		return {
			c() {
				create_component(percstokenofferbadgecard.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percstokenofferbadgecard, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percstokenofferbadgecard_changes = {};
				if (dirty & /*selectedToken*/ 16) percstokenofferbadgecard_changes.token = /*selectedToken*/ ctx[4];
				if (dirty & /*selectedItem*/ 32) percstokenofferbadgecard_changes.offerText = /*selectedItem*/ ctx[5]?.name ?? "";
				percstokenofferbadgecard.$set(percstokenofferbadgecard_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percstokenofferbadgecard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percstokenofferbadgecard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percstokenofferbadgecard, detaching);
			}
		};
	}

	// (55:2) {#if selectedOffer?.redemption.selectType === "wallet"}
	function create_if_block_4$5(ctx) {
		let percsofferitemcard;
		let current;

		percsofferitemcard = new PercsOfferItemCard({
				props: {
					offer: /*selectedOffer*/ ctx[1],
					item: /*selectedItem*/ ctx[5]
				}
			});

		return {
			c() {
				create_component(percsofferitemcard.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsofferitemcard, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsofferitemcard_changes = {};
				if (dirty & /*selectedOffer*/ 2) percsofferitemcard_changes.offer = /*selectedOffer*/ ctx[1];
				if (dirty & /*selectedItem*/ 32) percsofferitemcard_changes.item = /*selectedItem*/ ctx[5];
				percsofferitemcard.$set(percsofferitemcard_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsofferitemcard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsofferitemcard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsofferitemcard, detaching);
			}
		};
	}

	// (61:2) {#if redemption.display === "discount_code"}
	function create_if_block_3$7(ctx) {
		let percscopycode;
		let current;

		percscopycode = new PercsCopyCode({
				props: { value: /*redemption*/ ctx[2].value }
			});

		return {
			c() {
				create_component(percscopycode.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percscopycode, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percscopycode_changes = {};
				if (dirty & /*redemption*/ 4) percscopycode_changes.value = /*redemption*/ ctx[2].value;
				percscopycode.$set(percscopycode_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percscopycode.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percscopycode.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percscopycode, detaching);
			}
		};
	}

	// (65:2) {#if redemption.link || $config.redemptionActions.length > 0}
	function create_if_block$d(ctx) {
		let percsdialogactions;
		let current;

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$f] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogactions.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state, hasOtherItems, redemption, $config*/ 65613) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	// (68:8) <PercsButton variant="contained" on:click={getActionHandler(redemptionAction)}>
	function create_default_slot_4$6(ctx) {
		let t_value = /*redemptionAction*/ ctx[13].text + "";
		let t;

		return {
			c() {
				t = text(t_value);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*$config*/ 64 && t_value !== (t_value = /*redemptionAction*/ ctx[13].text + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (67:6) {#each $config.redemptionActions as redemptionAction}
	function create_each_block$2(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					$$slots: { default: [create_default_slot_4$6] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", function () {
			if (is_function(/*getActionHandler*/ ctx[7](/*redemptionAction*/ ctx[13]))) /*getActionHandler*/ ctx[7](/*redemptionAction*/ ctx[13]).apply(this, arguments);
		});

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				const percsbutton_changes = {};

				if (dirty & /*$$scope, $config*/ 65600) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (72:6) {#if redemption.link}
	function create_if_block_2$7(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					as: "a",
					target: "_blank",
					href: /*redemption*/ ctx[2].link?.url,
					$$slots: { default: [create_default_slot_3$8] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};
				if (dirty & /*redemption*/ 4) percsbutton_changes.href = /*redemption*/ ctx[2].link?.url;

				if (dirty & /*$$scope, redemption*/ 65540) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (73:8) <PercsButton variant="contained" as="a" target="_blank" href={redemption.link?.url}>
	function create_default_slot_3$8(ctx) {
		let t_value = /*redemption*/ ctx[2].link.text + "";
		let t;

		return {
			c() {
				t = text(t_value);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*redemption*/ 4 && t_value !== (t_value = /*redemption*/ ctx[2].link.text + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (77:6) {#if hasOtherItems}
	function create_if_block_1$b(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					$$slots: { default: [create_default_slot_2$d] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[10]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 65536) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (78:8) <PercsButton on:click={() => state.send("OFFER_SHOW_ALL")}>
	function create_default_slot_2$d(ctx) {
		let t;

		return {
			c() {
				t = text("View other discounts");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (66:4) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$f(ctx) {
		let t0;
		let t1;
		let if_block1_anchor;
		let current;
		let each_value = /*$config*/ ctx[6].redemptionActions;
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$2(get_each_context$2(ctx, each_value, i));
		}

		const out = i => transition_out(each_blocks[i], 1, 1, () => {
			each_blocks[i] = null;
		});

		let if_block0 = /*redemption*/ ctx[2].link && create_if_block_2$7(ctx);
		let if_block1 = /*hasOtherItems*/ ctx[3] && create_if_block_1$b(ctx);

		return {
			c() {
				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t0 = space();
				if (if_block0) if_block0.c();
				t1 = space();
				if (if_block1) if_block1.c();
				if_block1_anchor = empty$3();
			},
			m(target, anchor) {
				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(target, anchor);
					}
				}

				insert(target, t0, anchor);
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t1, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, if_block1_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (dirty & /*getActionHandler, $config*/ 192) {
					each_value = /*$config*/ ctx[6].redemptionActions;
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$2(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
							transition_in(each_blocks[i], 1);
						} else {
							each_blocks[i] = create_each_block$2(child_ctx);
							each_blocks[i].c();
							transition_in(each_blocks[i], 1);
							each_blocks[i].m(t0.parentNode, t0);
						}
					}

					group_outros();

					for (i = each_value.length; i < each_blocks.length; i += 1) {
						out(i);
					}

					check_outros();
				}

				if (/*redemption*/ ctx[2].link) {
					if (if_block0) {
						if_block0.p(ctx, dirty);

						if (dirty & /*redemption*/ 4) {
							transition_in(if_block0, 1);
						}
					} else {
						if_block0 = create_if_block_2$7(ctx);
						if_block0.c();
						transition_in(if_block0, 1);
						if_block0.m(t1.parentNode, t1);
					}
				} else if (if_block0) {
					group_outros();

					transition_out(if_block0, 1, 1, () => {
						if_block0 = null;
					});

					check_outros();
				}

				if (/*hasOtherItems*/ ctx[3]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);

						if (dirty & /*hasOtherItems*/ 8) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block_1$b(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}
			},
			i(local) {
				if (current) return;

				for (let i = 0; i < each_value.length; i += 1) {
					transition_in(each_blocks[i]);
				}

				transition_in(if_block0);
				transition_in(if_block1);
				current = true;
			},
			o(local) {
				each_blocks = each_blocks.filter(Boolean);

				for (let i = 0; i < each_blocks.length; i += 1) {
					transition_out(each_blocks[i]);
				}

				transition_out(if_block0);
				transition_out(if_block1);
				current = false;
			},
			d(detaching) {
				destroy_each(each_blocks, detaching);
				if (detaching) detach(t0);
				if (if_block0) if_block0.d(detaching);
				if (detaching) detach(t1);
				if (if_block1) if_block1.d(detaching);
				if (detaching) detach(if_block1_anchor);
			}
		};
	}

	// (54:0) <PercsDialogContent>
	function create_default_slot$g(ctx) {
		let current_block_type_index;
		let if_block0;
		let t0;
		let t1;
		let if_block2_anchor;
		let current;
		const if_block_creators = [create_if_block_4$5, create_if_block_5$3];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*selectedOffer*/ ctx[1]?.redemption.selectType === "wallet") return 0;
			if (/*selectedOffer*/ ctx[1]?.redemption.selectType === "single") return 1;
			return -1;
		}

		if (~(current_block_type_index = select_block_type(ctx))) {
			if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		}

		let if_block1 = /*redemption*/ ctx[2].display === "discount_code" && create_if_block_3$7(ctx);
		let if_block2 = (/*redemption*/ ctx[2].link || /*$config*/ ctx[6].redemptionActions.length > 0) && create_if_block$d(ctx);

		return {
			c() {
				if (if_block0) if_block0.c();
				t0 = space();
				if (if_block1) if_block1.c();
				t1 = space();
				if (if_block2) if_block2.c();
				if_block2_anchor = empty$3();
			},
			m(target, anchor) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].m(target, anchor);
				}

				insert(target, t0, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, t1, anchor);
				if (if_block2) if_block2.m(target, anchor);
				insert(target, if_block2_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type(ctx);

				if (current_block_type_index === previous_block_index) {
					if (~current_block_type_index) {
						if_blocks[current_block_type_index].p(ctx, dirty);
					}
				} else {
					if (if_block0) {
						group_outros();

						transition_out(if_blocks[previous_block_index], 1, 1, () => {
							if_blocks[previous_block_index] = null;
						});

						check_outros();
					}

					if (~current_block_type_index) {
						if_block0 = if_blocks[current_block_type_index];

						if (!if_block0) {
							if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
							if_block0.c();
						} else {
							if_block0.p(ctx, dirty);
						}

						transition_in(if_block0, 1);
						if_block0.m(t0.parentNode, t0);
					} else {
						if_block0 = null;
					}
				}

				if (/*redemption*/ ctx[2].display === "discount_code") {
					if (if_block1) {
						if_block1.p(ctx, dirty);

						if (dirty & /*redemption*/ 4) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block_3$7(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(t1.parentNode, t1);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}

				if (/*redemption*/ ctx[2].link || /*$config*/ ctx[6].redemptionActions.length > 0) {
					if (if_block2) {
						if_block2.p(ctx, dirty);

						if (dirty & /*redemption, $config*/ 68) {
							transition_in(if_block2, 1);
						}
					} else {
						if_block2 = create_if_block$d(ctx);
						if_block2.c();
						transition_in(if_block2, 1);
						if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
					}
				} else if (if_block2) {
					group_outros();

					transition_out(if_block2, 1, 1, () => {
						if_block2 = null;
					});

					check_outros();
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block0);
				transition_in(if_block1);
				transition_in(if_block2);
				current = true;
			},
			o(local) {
				transition_out(if_block0);
				transition_out(if_block1);
				transition_out(if_block2);
				current = false;
			},
			d(detaching) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].d(detaching);
				}

				if (detaching) detach(t0);
				if (if_block1) if_block1.d(detaching);
				if (detaching) detach(t1);
				if (if_block2) if_block2.d(detaching);
				if (detaching) detach(if_block2_anchor);
			}
		};
	}

	function create_fragment$l(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Discount Details",
					$$slots: { default: [create_default_slot_5$3] },
					$$scope: { ctx }
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[9]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot$g] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];

				if (dirty & /*$$scope*/ 65536) {
					percsdialogheader_changes.$$scope = { dirty, ctx };
				}

				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, hasOtherItems, redemption, $config, selectedOffer, selectedItem, selectedToken*/ 65663) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$l($$self, $$props, $$invalidate) {
		let selectedOffer;
		let selectedItem;
		let selectedToken;
		let redemption;
		let hasOtherItems;

		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(8, $state = $$value)), state);

		let $config;
		component_subscribe($$self, config$2, $$value => $$invalidate(6, $config = $$value));
		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();
		let successMessage = "";

		/**
	 *
	 * @param {typeof $config.redemptionActions[number]} redemptionAction
	 */
		function getActionHandler(redemptionAction) {
			return async () => {
				successMessage = "";

				try {
					const message = await redemptionAction.onAction(redemption);

					if (typeof message === "string") {
						successMessage = message;
					}
				} catch(err) {
					if (err instanceof Error) {
						err.message;
					} else {
						throw err;
					}
				}
			};
		}

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("OFFER_SHOW_ALL");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*$state*/ 256) {
				$$invalidate(1, selectedOffer = $state.context.offers.find(({ id }) => id === $state.context.offerSelectedId) ?? null);
			}

			if ($$self.$$.dirty & /*selectedOffer, $state*/ 258) {
				$$invalidate(5, selectedItem = selectedOffer?.redemption.items.find(({ id }) => id === $state.context.offerSelectedItemId) ?? null);
			}

			if ($$self.$$.dirty & /*selectedOffer, $state*/ 258) {
				$$invalidate(4, selectedToken = selectedOffer?.redemption.contractTokens.find(token => `${token.type}:${token.address}` === $state.context.offerSelectedContract)?.tokens[$state.context.offerSelectedTokenId]);
			}

			if ($$self.$$.dirty & /*$state*/ 256) {
				$$invalidate(2, [redemption] = Object.values($state.context.contractTokenRedemptions?.[0].tokenRedemptions ?? {}), redemption);
			}

			if ($$self.$$.dirty & /*$state*/ 256) {
				$$invalidate(3, hasOtherItems = $state.context.offers.length > 0 || $state.context.offers.some(offer => offer.redemption.items.length > 1 || offer.redemption.contractTokens.length > 1 || Object.keys(offer.redemption.contractTokens[0].tokens).length > 1));
			}
		};

		return [
			state,
			selectedOffer,
			redemption,
			hasOtherItems,
			selectedToken,
			selectedItem,
			$config,
			getActionHandler,
			$state,
			close_handler,
			click_handler
		];
	}

	class OfferRedeemDiscountSuccess extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$l, create_fragment$l, safe_not_equal, { state: 0 }, add_css$e);
		}
	}

	/* dist/components/dialog-contents/OfferRedeemError.svelte generated by Svelte v3.59.2 */

	function add_css$d(target) {
		append_styles(target, "svelte-crb7px", ".my-4.svelte-crb7px{margin-top:1rem;margin-bottom:1rem}.offer-redeem-error__text.svelte-crb7px{margin-block-end:0em;padding-block-end:1em}");
	}

	// (19:0) <PercsDialogHeader {state} on:close text="Redemption Error">
	function create_default_slot_4$5(ctx) {
		let h2;
		let t_value = /*$state*/ ctx[1].context.error.message + "";
		let t;

		return {
			c() {
				h2 = element("h2");
				t = text(t_value);
				attr(h2, "class", "offer-redeem-error__text svelte-crb7px");
			},
			m(target, anchor) {
				insert(target, h2, anchor);
				append(h2, t);
			},
			p(ctx, dirty) {
				if (dirty & /*$state*/ 2 && t_value !== (t_value = /*$state*/ ctx[1].context.error.message + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) detach(h2);
			}
		};
	}

	// (25:2) {#if selectedItem}
	function create_if_block_1$a(ctx) {
		let current_block_type_index;
		let if_block;
		let if_block_anchor;
		let current;
		const if_block_creators = [create_if_block_2$6, create_if_block_3$6];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*selectedOffer*/ ctx[2]?.redemption.selectType === "wallet") return 0;
			if (/*selectedOffer*/ ctx[2]?.redemption.selectType === "single") return 1;
			return -1;
		}

		if (~(current_block_type_index = select_block_type(ctx))) {
			if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		}

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].m(target, anchor);
				}

				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (if_block) if_block.p(ctx, dirty);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].d(detaching);
				}

				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (28:64) 
	function create_if_block_3$6(ctx) {
		let percstokenlistitem;
		let current;

		percstokenlistitem = new PercsTokenListItem({
				props: {
					contract: /*selectedContract*/ ctx[4],
					token: /*selectedToken*/ ctx[5]
				}
			});

		return {
			c() {
				create_component(percstokenlistitem.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percstokenlistitem, target, anchor);
				current = true;
			},
			p: noop$6,
			i(local) {
				if (current) return;
				transition_in(percstokenlistitem.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percstokenlistitem.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percstokenlistitem, detaching);
			}
		};
	}

	// (26:4) {#if selectedOffer?.redemption.selectType === "wallet"}
	function create_if_block_2$6(ctx) {
		let percsofferitemcard;
		let current;

		percsofferitemcard = new PercsOfferItemCard({
				props: {
					offer: /*selectedOffer*/ ctx[2],
					item: /*selectedItem*/ ctx[3]
				}
			});

		return {
			c() {
				create_component(percsofferitemcard.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsofferitemcard, target, anchor);
				current = true;
			},
			p: noop$6,
			i(local) {
				if (current) return;
				transition_in(percsofferitemcard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsofferitemcard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsofferitemcard, detaching);
			}
		};
	}

	// (33:4) <PercsButton noPaddingX on:click={() => state.send("RETRY")}>
	function create_default_slot_3$7(ctx) {
		let t;

		return {
			c() {
				t = text("Retry");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (34:4) {#if hasOtherItems}
	function create_if_block$c(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					noPaddingX: true,
					variant: "contained",
					$$slots: { default: [create_default_slot_2$c] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler_1*/ ctx[9]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 1024) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (35:6) <PercsButton noPaddingX variant="contained" on:click={() => state.send("OFFER_SHOW_ALL")}>
	function create_default_slot_2$c(ctx) {
		let t;

		return {
			c() {
				t = text("View other discounts");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (32:2) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$e(ctx) {
		let percsbutton;
		let t;
		let if_block_anchor;
		let current;

		percsbutton = new PercsButton({
				props: {
					noPaddingX: true,
					$$slots: { default: [create_default_slot_3$7] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[8]);
		let if_block = /*hasOtherItems*/ ctx[6] && create_if_block$c(ctx);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
				t = space();
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				insert(target, t, anchor);
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 1024) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
				if (/*hasOtherItems*/ ctx[6]) if_block.p(ctx, dirty);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
				if (detaching) detach(t);
				if (if_block) if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (22:0) <PercsDialogContent>
	function create_default_slot$f(ctx) {
		let p;
		let t0_value = (/*$state*/ ctx[1].context.gate?.description || "Connect a wallet with your NFTs to unlock this offer.") + "";
		let t0;
		let t1;
		let t2;
		let percsdialogactions;
		let current;
		let if_block = /*selectedItem*/ ctx[3] && create_if_block_1$a(ctx);

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$e] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				p = element("p");
				t0 = text(t0_value);
				t1 = space();
				if (if_block) if_block.c();
				t2 = space();
				create_component(percsdialogactions.$$.fragment);
				attr(p, "class", "my-4 svelte-crb7px");
			},
			m(target, anchor) {
				insert(target, p, anchor);
				append(p, t0);
				insert(target, t1, anchor);
				if (if_block) if_block.m(target, anchor);
				insert(target, t2, anchor);
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if ((!current || dirty & /*$state*/ 2) && t0_value !== (t0_value = (/*$state*/ ctx[1].context.gate?.description || "Connect a wallet with your NFTs to unlock this offer.") + "")) set_data(t0, t0_value);
				if (/*selectedItem*/ ctx[3]) if_block.p(ctx, dirty);
				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state*/ 1025) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(p);
				if (detaching) detach(t1);
				if (if_block) if_block.d(detaching);
				if (detaching) detach(t2);
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	function create_fragment$k(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Redemption Error",
					$$slots: { default: [create_default_slot_4$5] },
					$$scope: { ctx }
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[7]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot$f] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];

				if (dirty & /*$$scope, $state*/ 1026) {
					percsdialogheader_changes.$$scope = { dirty, ctx };
				}

				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, $state*/ 1027) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$k($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(1, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();
		const selectedOffer = $state.context.offers.find(offer => offer.id === $state.context.offerSelectedId);
		const selectedItem = selectedOffer?.redemption.items.find(item => item.id === $state.context.offerSelectedItemId);
		const selectedContract = selectedOffer?.redemption.contractTokens.find(token => `${token.type}:${token.address}` === $state.context.offerSelectedContract);
		const selectedToken = selectedContract?.tokens[$state.context.offerSelectedTokenId];
		const hasOtherItems = $state.context.offers.length > 1 || $state.context.offers.some(offer => offer.redemption.selectType !== "wallet" && offer.type !== "gate" && (offer.redemption.items.length > 1 || offer.redemption.contractTokens.length > 1 || Object.keys(offer.redemption.contractTokens[0].tokens).length > 1));

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("RETRY");
		const click_handler_1 = () => state.send("OFFER_SHOW_ALL");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [
			state,
			$state,
			selectedOffer,
			selectedItem,
			selectedContract,
			selectedToken,
			hasOtherItems,
			close_handler,
			click_handler,
			click_handler_1
		];
	}

	class OfferRedeemError extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$k, create_fragment$k, safe_not_equal, { state: 0 }, add_css$d);
		}
	}

	/* dist/components/dialog-contents/OfferRedeemEventSuccess.svelte generated by Svelte v3.59.2 */

	function create_default_slot_5$2(ctx) {
		let p;

		return {
			c() {
				p = element("p");
				p.textContent = "Unlock to access your tickets";
			},
			m(target, anchor) {
				insert(target, p, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(p);
			}
		};
	}

	// (39:2) {#if selectedItem}
	function create_if_block_3$5(ctx) {
		let current_block_type_index;
		let if_block;
		let if_block_anchor;
		let current;
		const if_block_creators = [create_if_block_4$4, create_if_block_5$2];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*selectedOffer*/ ctx[4]?.redemption.selectType === "wallet") return 0;
			if (/*selectedOffer*/ ctx[4]?.redemption.selectType === "single") return 1;
			return -1;
		}

		if (~(current_block_type_index = select_block_type(ctx))) {
			if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		}

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].m(target, anchor);
				}

				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (if_block) if_block.p(ctx, dirty);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].d(detaching);
				}

				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (42:64) 
	function create_if_block_5$2(ctx) {
		let percstokenofferbadgecard;
		let current;

		percstokenofferbadgecard = new PercsTokenOfferBadgeCard({
				props: {
					token: /*selectedToken*/ ctx[6],
					offerText: /*selectedItem*/ ctx[5].name
				}
			});

		return {
			c() {
				create_component(percstokenofferbadgecard.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percstokenofferbadgecard, target, anchor);
				current = true;
			},
			p: noop$6,
			i(local) {
				if (current) return;
				transition_in(percstokenofferbadgecard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percstokenofferbadgecard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percstokenofferbadgecard, detaching);
			}
		};
	}

	// (40:4) {#if selectedOffer?.redemption.selectType === "wallet"}
	function create_if_block_4$4(ctx) {
		let percsofferitemcard;
		let current;

		percsofferitemcard = new PercsOfferItemCard({
				props: {
					offer: /*selectedOffer*/ ctx[4],
					item: /*selectedItem*/ ctx[5]
				}
			});

		return {
			c() {
				create_component(percsofferitemcard.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsofferitemcard, target, anchor);
				current = true;
			},
			p: noop$6,
			i(local) {
				if (current) return;
				transition_in(percsofferitemcard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsofferitemcard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsofferitemcard, detaching);
			}
		};
	}

	// (51:2) {#if ticketUrl}
	function create_if_block$b(ctx) {
		let percsdialogactions;
		let current;

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$d] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogactions.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state, ticketUrl, urlText, virtualEventSharedUrl*/ 8207) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	// (55:6) {:else}
	function create_else_block$7(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					as: "a",
					target: "_blank",
					href: /*ticketUrl*/ ctx[1],
					variant: "contained",
					$$slots: { default: [create_default_slot_4$4] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};
				if (dirty & /*ticketUrl*/ 2) percsbutton_changes.href = /*ticketUrl*/ ctx[1];

				if (dirty & /*$$scope*/ 8192) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (53:6) {#if virtualEventSharedUrl}
	function create_if_block_2$5(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					as: "a",
					target: "_blank",
					href: /*ticketUrl*/ ctx[1],
					title: /*ticketUrl*/ ctx[1],
					variant: "contained",
					$$slots: { default: [create_default_slot_3$6] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};
				if (dirty & /*ticketUrl*/ 2) percsbutton_changes.href = /*ticketUrl*/ ctx[1];
				if (dirty & /*ticketUrl*/ 2) percsbutton_changes.title = /*ticketUrl*/ ctx[1];

				if (dirty & /*$$scope, urlText*/ 8200) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (56:8) <PercsButton as="a" target="_blank" href={ticketUrl} variant="contained">
	function create_default_slot_4$4(ctx) {
		let t;

		return {
			c() {
				t = text("View ticket");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (54:8) <PercsButton as="a" target="_blank" href={ticketUrl} title={ticketUrl} variant="contained">
	function create_default_slot_3$6(ctx) {
		let t;

		return {
			c() {
				t = text(/*urlText*/ ctx[3]);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*urlText*/ 8) set_data(t, /*urlText*/ ctx[3]);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (58:6) {#if hasOtherItems}
	function create_if_block_1$9(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					$$slots: { default: [create_default_slot_2$b] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[9]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 8192) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (59:8) <PercsButton on:click={() => state.send("OFFER_SHOW_ALL")}>
	function create_default_slot_2$b(ctx) {
		let t;

		return {
			c() {
				t = text("View other tickets");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (52:4) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$d(ctx) {
		let current_block_type_index;
		let if_block0;
		let t;
		let if_block1_anchor;
		let current;
		const if_block_creators = [create_if_block_2$5, create_else_block$7];
		const if_blocks = [];

		function select_block_type_1(ctx, dirty) {
			if (/*virtualEventSharedUrl*/ ctx[2]) return 0;
			return 1;
		}

		current_block_type_index = select_block_type_1(ctx);
		if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		let if_block1 = /*hasOtherItems*/ ctx[7] && create_if_block_1$9(ctx);

		return {
			c() {
				if_block0.c();
				t = space();
				if (if_block1) if_block1.c();
				if_block1_anchor = empty$3();
			},
			m(target, anchor) {
				if_blocks[current_block_type_index].m(target, anchor);
				insert(target, t, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, if_block1_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type_1(ctx);

				if (current_block_type_index === previous_block_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block0 = if_blocks[current_block_type_index];

					if (!if_block0) {
						if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block0.c();
					} else {
						if_block0.p(ctx, dirty);
					}

					transition_in(if_block0, 1);
					if_block0.m(t.parentNode, t);
				}

				if (/*hasOtherItems*/ ctx[7]) if_block1.p(ctx, dirty);
			},
			i(local) {
				if (current) return;
				transition_in(if_block0);
				transition_in(if_block1);
				current = true;
			},
			o(local) {
				transition_out(if_block0);
				transition_out(if_block1);
				current = false;
			},
			d(detaching) {
				if_blocks[current_block_type_index].d(detaching);
				if (detaching) detach(t);
				if (if_block1) if_block1.d(detaching);
				if (detaching) detach(if_block1_anchor);
			}
		};
	}

	// (38:0) <PercsDialogContent>
	function create_default_slot$e(ctx) {
		let t;
		let if_block1_anchor;
		let current;
		let if_block0 = /*selectedItem*/ ctx[5] && create_if_block_3$5(ctx);
		let if_block1 = /*ticketUrl*/ ctx[1] && create_if_block$b(ctx);

		return {
			c() {
				if (if_block0) if_block0.c();
				t = space();
				if (if_block1) if_block1.c();
				if_block1_anchor = empty$3();
			},
			m(target, anchor) {
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, if_block1_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (/*selectedItem*/ ctx[5]) if_block0.p(ctx, dirty);

				if (/*ticketUrl*/ ctx[1]) {
					if (if_block1) {
						if_block1.p(ctx, dirty);

						if (dirty & /*ticketUrl*/ 2) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block$b(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block0);
				transition_in(if_block1);
				current = true;
			},
			o(local) {
				transition_out(if_block0);
				transition_out(if_block1);
				current = false;
			},
			d(detaching) {
				if (if_block0) if_block0.d(detaching);
				if (detaching) detach(t);
				if (if_block1) if_block1.d(detaching);
				if (detaching) detach(if_block1_anchor);
			}
		};
	}

	function create_fragment$j(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Unlock to Access",
					$$slots: { default: [create_default_slot_5$2] },
					$$scope: { ctx }
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[8]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot$e] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];

				if (dirty & /*$$scope*/ 8192) {
					percsdialogheader_changes.$$scope = { dirty, ctx };
				}

				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, ticketUrl, urlText, virtualEventSharedUrl*/ 8207) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$j($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(10, $state = $$value)), state);

		let $config;
		component_subscribe($$self, config$2, $$value => $$invalidate(11, $config = $$value));
		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();
		const selectedOffer = $state.context.offers.find(offer => offer.id === $state.context.offerSelectedId);
		const selectedItem = selectedOffer?.redemption.items.find(item => item.id === $state.context.offerSelectedItemId);

		/** @type {?string}*/
		let ticketUrl = null;

		let virtualEventSharedUrl = false;
		let urlText = "";
		const selectedContract = selectedOffer?.redemption.contractTokens.find(token => `${token.type}:${token.address}` === $state.context.offerSelectedContract);
		const selectedToken = selectedContract?.tokens[$state.context.offerSelectedTokenId];

		// we're dealing with a virtual event with a shared url.
		if (selectedItem && selectedItem.redemption.link) {
			ticketUrl = selectedItem.redemption.link.url;
			urlText = selectedItem.redemption.link.text;
			virtualEventSharedUrl = true;
		} else {
			const contractTokenRedemption = $state.context.contractTokenRedemptions?.find(contractRedemptions => `${contractRedemptions.type}:${contractRedemptions.address}` === $state.context.offerSelectedContract)?.tokenRedemptions[$state.context.offerSelectedTokenId];

			ticketUrl = selectedOffer
			? `${$config.clientHost}/offers/${selectedOffer.id}-${selectedOffer.slug}/tickets/${contractTokenRedemption.value}?code=${encodeURIComponent(contractTokenRedemption.dataUrl.slice(("data:image/png;base64,").length))}`
			: null;
		}

		const hasOtherItems = $state.context.offers.length > 0 || $state.context.offers.some(offer => offer.redemption.items.length > 1 || offer.redemption.contractTokens.length > 1 || Object.keys(offer.redemption.contractTokens[0].tokens).length > 1);

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("OFFER_SHOW_ALL");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [
			state,
			ticketUrl,
			virtualEventSharedUrl,
			urlText,
			selectedOffer,
			selectedItem,
			selectedToken,
			hasOtherItems,
			close_handler,
			click_handler
		];
	}

	class OfferRedeemEventSuccess extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$j, create_fragment$j, safe_not_equal, { state: 0 });
		}
	}

	/* dist/components/dialog-contents/OfferRedeemLoading.svelte generated by Svelte v3.59.2 */

	function add_css$c(target) {
		append_styles(target, "svelte-16lk2ak", ".my-4.svelte-16lk2ak{margin-top:1rem;margin-bottom:1rem}");
	}

	// (22:2) {#if selectedItem}
	function create_if_block_1$8(ctx) {
		let current_block_type_index;
		let if_block;
		let if_block_anchor;
		let current;
		const if_block_creators = [create_if_block_2$4, create_if_block_3$4];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*selectedOffer*/ ctx[2]?.redemption.selectType === "wallet") return 0;
			if (/*selectedOffer*/ ctx[2]?.redemption.selectType === "single") return 1;
			return -1;
		}

		if (~(current_block_type_index = select_block_type(ctx))) {
			if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		}

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].m(target, anchor);
				}

				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (if_block) if_block.p(ctx, dirty);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].d(detaching);
				}

				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (25:64) 
	function create_if_block_3$4(ctx) {
		let percstokenlistitem;
		let current;

		percstokenlistitem = new PercsTokenListItem({
				props: {
					contract: /*selectedContract*/ ctx[4],
					token: /*selectedToken*/ ctx[5]
				}
			});

		return {
			c() {
				create_component(percstokenlistitem.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percstokenlistitem, target, anchor);
				current = true;
			},
			p: noop$6,
			i(local) {
				if (current) return;
				transition_in(percstokenlistitem.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percstokenlistitem.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percstokenlistitem, detaching);
			}
		};
	}

	// (23:4) {#if selectedOffer?.redemption.selectType === "wallet"}
	function create_if_block_2$4(ctx) {
		let percsofferitemcard;
		let current;

		percsofferitemcard = new PercsOfferItemCard({
				props: {
					offer: /*selectedOffer*/ ctx[2],
					item: /*selectedItem*/ ctx[3]
				}
			});

		return {
			c() {
				create_component(percsofferitemcard.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsofferitemcard, target, anchor);
				current = true;
			},
			p: noop$6,
			i(local) {
				if (current) return;
				transition_in(percsofferitemcard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsofferitemcard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsofferitemcard, detaching);
			}
		};
	}

	// (29:2) {#if selectedLocation}
	function create_if_block$a(ctx) {
		let div;

		return {
			c() {
				div = element("div");
				div.textContent = `Location: ${/*selectedLocation*/ ctx[6].title}`;
				attr(div, "class", "my-4 svelte-16lk2ak");
			},
			m(target, anchor) {
				insert(target, div, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(div);
			}
		};
	}

	// (19:0) <PercsDialogContent>
	function create_default_slot$d(ctx) {
		let p;
		let t0_value = (/*$state*/ ctx[1].context.gate?.description || "Connect a wallet with your NFTs to unlock this offer.") + "";
		let t0;
		let t1;
		let t2;
		let t3;
		let span;
		let current;
		let if_block0 = /*selectedItem*/ ctx[3] && create_if_block_1$8(ctx);
		let if_block1 = /*selectedLocation*/ ctx[6] && create_if_block$a(ctx);

		return {
			c() {
				p = element("p");
				t0 = text(t0_value);
				t1 = space();
				if (if_block0) if_block0.c();
				t2 = space();
				if (if_block1) if_block1.c();
				t3 = space();
				span = element("span");

				span.textContent = `${/*selectedToken*/ ctx[5].isRedeemed
			? "Unlocking…"
			: "Redeeming…"}`;

				attr(p, "class", "my-4 svelte-16lk2ak");
				attr(span, "class", "my-4 svelte-16lk2ak");
			},
			m(target, anchor) {
				insert(target, p, anchor);
				append(p, t0);
				insert(target, t1, anchor);
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t2, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, t3, anchor);
				insert(target, span, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if ((!current || dirty & /*$state*/ 2) && t0_value !== (t0_value = (/*$state*/ ctx[1].context.gate?.description || "Connect a wallet with your NFTs to unlock this offer.") + "")) set_data(t0, t0_value);
				if (/*selectedItem*/ ctx[3]) if_block0.p(ctx, dirty);
				if (/*selectedLocation*/ ctx[6]) if_block1.p(ctx, dirty);
			},
			i(local) {
				if (current) return;
				transition_in(if_block0);
				current = true;
			},
			o(local) {
				transition_out(if_block0);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(p);
				if (detaching) detach(t1);
				if (if_block0) if_block0.d(detaching);
				if (detaching) detach(t2);
				if (if_block1) if_block1.d(detaching);
				if (detaching) detach(t3);
				if (detaching) detach(span);
			}
		};
	}

	function create_fragment$i(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Offer Details"
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[7]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot$d] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];
				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, $state*/ 258) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$i($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(1, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();
		const selectedOffer = $state.context.offers.find(offer => offer.id === $state.context.offerSelectedId);
		const selectedItem = selectedOffer?.redemption.items.find(item => item.id === $state.context.offerSelectedItemId);
		const selectedContract = selectedOffer?.redemption.contractTokens.find(token => `${token.type}:${token.address}` === $state.context.offerSelectedContract);
		const selectedToken = selectedContract?.tokens[$state.context.offerSelectedTokenId];

		const selectedLocation = ($state.context.redemptionValues?.location)
		? selectedContract?.redemptionFields.schema.properties.location.oneOf.find(location => location.const === $state.context.redemptionValues?.location)
		: null;

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [
			state,
			$state,
			selectedOffer,
			selectedItem,
			selectedContract,
			selectedToken,
			selectedLocation,
			close_handler
		];
	}

	class OfferRedeemLoading extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$i, create_fragment$i, safe_not_equal, { state: 0 }, add_css$c);
		}
	}

	/* dist/components/dialog-contents/OfferSelectedDiscount.svelte generated by Svelte v3.59.2 */

	function add_css$b(target) {
		append_styles(target, "svelte-1a2q4yu", ".offer-selected__text.svelte-1a2q4yu{margin-block-end:0em;padding-block-end:1em}");
	}

	// (22:4) {:else}
	function create_else_block$6(ctx) {
		let p;

		return {
			c() {
				p = element("p");
				p.textContent = "You have an NFT discount.  Claim your discount now.";
			},
			m(target, anchor) {
				insert(target, p, anchor);
			},
			d(detaching) {
				if (detaching) detach(p);
			}
		};
	}

	// (20:4) {#if selectedToken?.isRedeemed}
	function create_if_block_4$3(ctx) {
		let p;

		return {
			c() {
				p = element("p");
				p.textContent = "You have already claimed your discount.";
			},
			m(target, anchor) {
				insert(target, p, anchor);
			},
			d(detaching) {
				if (detaching) detach(p);
			}
		};
	}

	// (18:0) <PercsDialogHeader {state} on:close text="Offer Details">
	function create_default_slot_4$3(ctx) {
		let div;

		function select_block_type(ctx, dirty) {
			if (/*selectedToken*/ ctx[3]?.isRedeemed) return create_if_block_4$3;
			return create_else_block$6;
		}

		let current_block_type = select_block_type(ctx);
		let if_block = current_block_type(ctx);

		return {
			c() {
				div = element("div");
				if_block.c();
				attr(div, "class", "offer-selected__text svelte-1a2q4yu");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				if_block.m(div, null);
			},
			p(ctx, dirty) {
				if (current_block_type !== (current_block_type = select_block_type(ctx))) {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(div, null);
					}
				}
			},
			d(detaching) {
				if (detaching) detach(div);
				if_block.d();
			}
		};
	}

	// (28:2) {#if selectedItem}
	function create_if_block_1$7(ctx) {
		let current_block_type_index;
		let if_block;
		let if_block_anchor;
		let current;
		const if_block_creators = [create_if_block_2$3, create_if_block_3$3];
		const if_blocks = [];

		function select_block_type_1(ctx, dirty) {
			if (/*selectedOffer*/ ctx[1]?.redemption.selectType === "wallet") return 0;
			if (/*selectedOffer*/ ctx[1]?.redemption.selectType === "single") return 1;
			return -1;
		}

		if (~(current_block_type_index = select_block_type_1(ctx))) {
			if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		}

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].m(target, anchor);
				}

				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type_1(ctx);

				if (current_block_type_index === previous_block_index) {
					if (~current_block_type_index) {
						if_blocks[current_block_type_index].p(ctx, dirty);
					}
				} else {
					if (if_block) {
						group_outros();

						transition_out(if_blocks[previous_block_index], 1, 1, () => {
							if_blocks[previous_block_index] = null;
						});

						check_outros();
					}

					if (~current_block_type_index) {
						if_block = if_blocks[current_block_type_index];

						if (!if_block) {
							if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
							if_block.c();
						} else {
							if_block.p(ctx, dirty);
						}

						transition_in(if_block, 1);
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					} else {
						if_block = null;
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].d(detaching);
				}

				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (31:64) 
	function create_if_block_3$3(ctx) {
		let percstokenofferbadgecard;
		let current;

		percstokenofferbadgecard = new PercsTokenOfferBadgeCard({
				props: {
					token: /*selectedToken*/ ctx[3],
					offerText: /*selectedItem*/ ctx[4].name
				}
			});

		return {
			c() {
				create_component(percstokenofferbadgecard.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percstokenofferbadgecard, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percstokenofferbadgecard_changes = {};
				if (dirty & /*selectedToken*/ 8) percstokenofferbadgecard_changes.token = /*selectedToken*/ ctx[3];
				if (dirty & /*selectedItem*/ 16) percstokenofferbadgecard_changes.offerText = /*selectedItem*/ ctx[4].name;
				percstokenofferbadgecard.$set(percstokenofferbadgecard_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percstokenofferbadgecard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percstokenofferbadgecard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percstokenofferbadgecard, detaching);
			}
		};
	}

	// (29:4) {#if selectedOffer?.redemption.selectType === "wallet"}
	function create_if_block_2$3(ctx) {
		let percsofferitemcard;
		let current;

		percsofferitemcard = new PercsOfferItemCard({
				props: {
					offer: /*selectedOffer*/ ctx[1],
					item: /*selectedItem*/ ctx[4]
				}
			});

		return {
			c() {
				create_component(percsofferitemcard.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsofferitemcard, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsofferitemcard_changes = {};
				if (dirty & /*selectedOffer*/ 2) percsofferitemcard_changes.offer = /*selectedOffer*/ ctx[1];
				if (dirty & /*selectedItem*/ 16) percsofferitemcard_changes.item = /*selectedItem*/ ctx[4];
				percsofferitemcard.$set(percsofferitemcard_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsofferitemcard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsofferitemcard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsofferitemcard, detaching);
			}
		};
	}

	// (36:4) <PercsButton variant="contained" on:click={() => state.send("OFFER_REDEEM")}>
	function create_default_slot_3$5(ctx) {
		let t_value = ((/*selectedToken*/ ctx[3]?.isRedeemed)
		? "Unlock"
		: "Redeem") + "";

		let t;

		return {
			c() {
				t = text(t_value);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*selectedToken*/ 8 && t_value !== (t_value = ((/*selectedToken*/ ctx[3]?.isRedeemed)
				? "Unlock"
				: "Redeem") + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (37:4) {#if hasOtherItems}
	function create_if_block$9(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					$$slots: { default: [create_default_slot_2$a] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler_1*/ ctx[8]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 512) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (38:6) <PercsButton on:click={() => state.send("OFFER_SHOW_ALL")}>
	function create_default_slot_2$a(ctx) {
		let t;

		return {
			c() {
				t = text("View other discounts");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (35:2) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$c(ctx) {
		let percsbutton;
		let t;
		let if_block_anchor;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					$$slots: { default: [create_default_slot_3$5] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[7]);
		let if_block = /*hasOtherItems*/ ctx[2] && create_if_block$9(ctx);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
				t = space();
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				insert(target, t, anchor);
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope, selectedToken*/ 520) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);

				if (/*hasOtherItems*/ ctx[2]) {
					if (if_block) {
						if_block.p(ctx, dirty);

						if (dirty & /*hasOtherItems*/ 4) {
							transition_in(if_block, 1);
						}
					} else {
						if_block = create_if_block$9(ctx);
						if_block.c();
						transition_in(if_block, 1);
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					group_outros();

					transition_out(if_block, 1, 1, () => {
						if_block = null;
					});

					check_outros();
				}
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
				if (detaching) detach(t);
				if (if_block) if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (27:0) <PercsDialogContent>
	function create_default_slot$c(ctx) {
		let t;
		let percsdialogactions;
		let current;
		let if_block = /*selectedItem*/ ctx[4] && create_if_block_1$7(ctx);

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$c] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				if (if_block) if_block.c();
				t = space();
				create_component(percsdialogactions.$$.fragment);
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (/*selectedItem*/ ctx[4]) {
					if (if_block) {
						if_block.p(ctx, dirty);

						if (dirty & /*selectedItem*/ 16) {
							transition_in(if_block, 1);
						}
					} else {
						if_block = create_if_block_1$7(ctx);
						if_block.c();
						transition_in(if_block, 1);
						if_block.m(t.parentNode, t);
					}
				} else if (if_block) {
					group_outros();

					transition_out(if_block, 1, 1, () => {
						if_block = null;
					});

					check_outros();
				}

				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state, hasOtherItems, selectedToken*/ 525) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (if_block) if_block.d(detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	function create_fragment$h(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Offer Details",
					$$slots: { default: [create_default_slot_4$3] },
					$$scope: { ctx }
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[6]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot$c] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];

				if (dirty & /*$$scope, selectedToken*/ 520) {
					percsdialogheader_changes.$$scope = { dirty, ctx };
				}

				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, hasOtherItems, selectedToken, selectedOffer, selectedItem*/ 543) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$h($$self, $$props, $$invalidate) {
		let selectedOffer;
		let selectedItem;
		let selectedToken;
		let hasOtherItems;

		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(5, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("OFFER_REDEEM");
		const click_handler_1 = () => state.send("OFFER_SHOW_ALL");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*$state*/ 32) {
				$$invalidate(1, selectedOffer = $state.context.offers.find(({ id }) => id === $state.context.offerSelectedId) ?? null);
			}

			if ($$self.$$.dirty & /*selectedOffer, $state*/ 34) {
				$$invalidate(4, selectedItem = selectedOffer?.redemption.items.find(({ id }) => id === $state.context.offerSelectedItemId) ?? null);
			}

			if ($$self.$$.dirty & /*selectedOffer, $state*/ 34) {
				$$invalidate(3, selectedToken = selectedOffer?.redemption.contractTokens.find(token => `${token.type}:${token.address}` === $state.context.offerSelectedContract)?.tokens[$state.context.offerSelectedTokenId]);
			}

			if ($$self.$$.dirty & /*$state*/ 32) {
				$$invalidate(2, hasOtherItems = $state.context.offers.length > 1 || $state.context.offers.some(offer => offer.redemption.items.length > 1 || offer.redemption.contractTokens.length > 1 || Object.keys(offer.redemption.contractTokens[0].tokens).length > 1));
			}
		};

		return [
			state,
			selectedOffer,
			hasOtherItems,
			selectedToken,
			selectedItem,
			$state,
			close_handler,
			click_handler,
			click_handler_1
		];
	}

	class OfferSelectedDiscount extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$h, create_fragment$h, safe_not_equal, { state: 0 }, add_css$b);
		}
	}

	/* dist/components/dialog-contents/OfferSelectedEvent.svelte generated by Svelte v3.59.2 */

	function add_css$a(target) {
		append_styles(target, "svelte-1a2q4yu", ".offer-selected__text.svelte-1a2q4yu{margin-block-end:0em;padding-block-end:1em}");
	}

	// (22:4) {:else}
	function create_else_block$5(ctx) {
		let p;

		return {
			c() {
				p = element("p");
				p.textContent = "You have an NFT ticket.  Claim your ticket now.";
			},
			m(target, anchor) {
				insert(target, p, anchor);
			},
			d(detaching) {
				if (detaching) detach(p);
			}
		};
	}

	// (20:4) {#if selectedToken?.isRedeemed}
	function create_if_block_4$2(ctx) {
		let p;

		return {
			c() {
				p = element("p");
				p.textContent = "You have already claimed your ticket.";
			},
			m(target, anchor) {
				insert(target, p, anchor);
			},
			d(detaching) {
				if (detaching) detach(p);
			}
		};
	}

	// (18:0) <PercsDialogHeader {state} on:close text="Offer Details">
	function create_default_slot_4$2(ctx) {
		let div;

		function select_block_type(ctx, dirty) {
			if (/*selectedToken*/ ctx[3]?.isRedeemed) return create_if_block_4$2;
			return create_else_block$5;
		}

		let current_block_type = select_block_type(ctx);
		let if_block = current_block_type(ctx);

		return {
			c() {
				div = element("div");
				if_block.c();
				attr(div, "class", "offer-selected__text svelte-1a2q4yu");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				if_block.m(div, null);
			},
			p(ctx, dirty) {
				if (current_block_type !== (current_block_type = select_block_type(ctx))) {
					if_block.d(1);
					if_block = current_block_type(ctx);

					if (if_block) {
						if_block.c();
						if_block.m(div, null);
					}
				}
			},
			d(detaching) {
				if (detaching) detach(div);
				if_block.d();
			}
		};
	}

	// (28:2) {#if selectedItem}
	function create_if_block_1$6(ctx) {
		let current_block_type_index;
		let if_block;
		let if_block_anchor;
		let current;
		const if_block_creators = [create_if_block_2$2, create_if_block_3$2];
		const if_blocks = [];

		function select_block_type_1(ctx, dirty) {
			if (/*selectedOffer*/ ctx[1]?.redemption.selectType === "wallet") return 0;
			if (/*selectedOffer*/ ctx[1]?.redemption.selectType === "single") return 1;
			return -1;
		}

		if (~(current_block_type_index = select_block_type_1(ctx))) {
			if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		}

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].m(target, anchor);
				}

				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type_1(ctx);

				if (current_block_type_index === previous_block_index) {
					if (~current_block_type_index) {
						if_blocks[current_block_type_index].p(ctx, dirty);
					}
				} else {
					if (if_block) {
						group_outros();

						transition_out(if_blocks[previous_block_index], 1, 1, () => {
							if_blocks[previous_block_index] = null;
						});

						check_outros();
					}

					if (~current_block_type_index) {
						if_block = if_blocks[current_block_type_index];

						if (!if_block) {
							if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
							if_block.c();
						} else {
							if_block.p(ctx, dirty);
						}

						transition_in(if_block, 1);
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					} else {
						if_block = null;
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].d(detaching);
				}

				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (31:64) 
	function create_if_block_3$2(ctx) {
		let percstokenofferbadgecard;
		let current;

		percstokenofferbadgecard = new PercsTokenOfferBadgeCard({
				props: {
					token: /*selectedToken*/ ctx[3],
					offerText: /*selectedItem*/ ctx[4].name
				}
			});

		return {
			c() {
				create_component(percstokenofferbadgecard.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percstokenofferbadgecard, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percstokenofferbadgecard_changes = {};
				if (dirty & /*selectedToken*/ 8) percstokenofferbadgecard_changes.token = /*selectedToken*/ ctx[3];
				if (dirty & /*selectedItem*/ 16) percstokenofferbadgecard_changes.offerText = /*selectedItem*/ ctx[4].name;
				percstokenofferbadgecard.$set(percstokenofferbadgecard_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percstokenofferbadgecard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percstokenofferbadgecard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percstokenofferbadgecard, detaching);
			}
		};
	}

	// (29:4) {#if selectedOffer?.redemption.selectType === "wallet"}
	function create_if_block_2$2(ctx) {
		let percsofferitemcard;
		let current;

		percsofferitemcard = new PercsOfferItemCard({
				props: {
					offer: /*selectedOffer*/ ctx[1],
					item: /*selectedItem*/ ctx[4]
				}
			});

		return {
			c() {
				create_component(percsofferitemcard.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsofferitemcard, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsofferitemcard_changes = {};
				if (dirty & /*selectedOffer*/ 2) percsofferitemcard_changes.offer = /*selectedOffer*/ ctx[1];
				if (dirty & /*selectedItem*/ 16) percsofferitemcard_changes.item = /*selectedItem*/ ctx[4];
				percsofferitemcard.$set(percsofferitemcard_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsofferitemcard.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsofferitemcard.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsofferitemcard, detaching);
			}
		};
	}

	// (36:4) <PercsButton variant="contained" on:click={() => state.send("OFFER_REDEEM")}>
	function create_default_slot_3$4(ctx) {
		let t_value = ((/*selectedToken*/ ctx[3]?.isRedeemed)
		? "Unlock"
		: "Redeem") + "";

		let t;

		return {
			c() {
				t = text(t_value);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*selectedToken*/ 8 && t_value !== (t_value = ((/*selectedToken*/ ctx[3]?.isRedeemed)
				? "Unlock"
				: "Redeem") + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (37:4) {#if hasOtherItems}
	function create_if_block$8(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					$$slots: { default: [create_default_slot_2$9] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler_1*/ ctx[8]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 512) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (38:6) <PercsButton on:click={() => state.send("OFFER_SHOW_ALL")}>
	function create_default_slot_2$9(ctx) {
		let t;

		return {
			c() {
				t = text("View other tickets");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (35:2) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$b(ctx) {
		let percsbutton;
		let t;
		let if_block_anchor;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					$$slots: { default: [create_default_slot_3$4] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[7]);
		let if_block = /*hasOtherItems*/ ctx[2] && create_if_block$8(ctx);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
				t = space();
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				insert(target, t, anchor);
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope, selectedToken*/ 520) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);

				if (/*hasOtherItems*/ ctx[2]) {
					if (if_block) {
						if_block.p(ctx, dirty);

						if (dirty & /*hasOtherItems*/ 4) {
							transition_in(if_block, 1);
						}
					} else {
						if_block = create_if_block$8(ctx);
						if_block.c();
						transition_in(if_block, 1);
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					group_outros();

					transition_out(if_block, 1, 1, () => {
						if_block = null;
					});

					check_outros();
				}
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
				if (detaching) detach(t);
				if (if_block) if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (27:0) <PercsDialogContent>
	function create_default_slot$b(ctx) {
		let t;
		let percsdialogactions;
		let current;
		let if_block = /*selectedItem*/ ctx[4] && create_if_block_1$6(ctx);

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$b] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				if (if_block) if_block.c();
				t = space();
				create_component(percsdialogactions.$$.fragment);
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (/*selectedItem*/ ctx[4]) {
					if (if_block) {
						if_block.p(ctx, dirty);

						if (dirty & /*selectedItem*/ 16) {
							transition_in(if_block, 1);
						}
					} else {
						if_block = create_if_block_1$6(ctx);
						if_block.c();
						transition_in(if_block, 1);
						if_block.m(t.parentNode, t);
					}
				} else if (if_block) {
					group_outros();

					transition_out(if_block, 1, 1, () => {
						if_block = null;
					});

					check_outros();
				}

				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state, hasOtherItems, selectedToken*/ 525) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (if_block) if_block.d(detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	function create_fragment$g(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Offer Details",
					$$slots: { default: [create_default_slot_4$2] },
					$$scope: { ctx }
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[6]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot$b] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];

				if (dirty & /*$$scope, selectedToken*/ 520) {
					percsdialogheader_changes.$$scope = { dirty, ctx };
				}

				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, hasOtherItems, selectedToken, selectedOffer, selectedItem*/ 543) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$g($$self, $$props, $$invalidate) {
		let selectedOffer;
		let selectedItem;
		let selectedToken;
		let hasOtherItems;

		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(5, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("OFFER_REDEEM");
		const click_handler_1 = () => state.send("OFFER_SHOW_ALL");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*$state*/ 32) {
				$$invalidate(1, selectedOffer = $state.context.offers.find(({ id }) => id === $state.context.offerSelectedId) ?? null);
			}

			if ($$self.$$.dirty & /*selectedOffer, $state*/ 34) {
				$$invalidate(4, selectedItem = selectedOffer?.redemption.items.find(({ id }) => id === $state.context.offerSelectedItemId) ?? null);
			}

			if ($$self.$$.dirty & /*selectedOffer, $state*/ 34) {
				$$invalidate(3, selectedToken = selectedOffer?.redemption.contractTokens.find(token => `${token.type}:${token.address}` === $state.context.offerSelectedContract)?.tokens[$state.context.offerSelectedTokenId]);
			}

			if ($$self.$$.dirty & /*$state*/ 32) {
				$$invalidate(2, hasOtherItems = $state.context.offers.length > 1 || $state.context.offers.some(offer => offer.redemption.items.length > 1 || offer.redemption.contractTokens.length > 1 || Object.keys(offer.redemption.contractTokens[0].tokens).length > 1));
			}
		};

		return [
			state,
			selectedOffer,
			hasOtherItems,
			selectedToken,
			selectedItem,
			$state,
			close_handler,
			click_handler,
			click_handler_1
		];
	}

	class OfferSelectedEvent extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$g, create_fragment$g, safe_not_equal, { state: 0 }, add_css$a);
		}
	}

	/* dist/components/internal/PercsDialogImageHeader.svelte generated by Svelte v3.59.2 */

	function add_css$9(target) {
		append_styles(target, "svelte-1xsg7rj", ".dialog-image-header{background-color:var(--dialog-background-color, #ffffff);position:relative;display:flex;flex-direction:row;align-items:center;border-bottom:1px solid var(--dialog-text-color, #eaecf0)}.dialog-image-header__image{height:180px;width:100%;background-position:center;background-size:cover}.dialog-image-header__container{background-color:var(--dialog-background-color, #ffffff);color:var(--dialog-text-color, #101828);padding-left:12px;padding-right:12px}.dialog-image-header__text{flex-grow:1;font-style:normal;font-weight:600;font-size:18px;text-align:center;padding-top:5px;padding-bottom:5px;color:var(--dialog-image-header-text-color, var(--dialog-text-color, #101828))}.dialog-image-header__close{font-size:24px;position:absolute;padding-top:3px;right:12px;top:12px;border:none;background-color:transparent;cursor:pointer;color:var(--dialog-text-color, #101828);background-color:white;border-radius:9999px;width:34px;height:34px}.dialog-image-header__-email-gate{color:#161b5d;max-width:280px;gap:8px;margin:8px auto;margin-bottom:32px}.dialog-image-header__-email-gate h2{margin-bottom:8px}");
	}

	// (23:2) {#if dismissable !== false}
	function create_if_block_1$5(ctx) {
		let button;
		let mounted;
		let dispose;

		return {
			c() {
				button = element("button");
				button.textContent = "×";
				attr(button, "type", "button");
				attr(button, "class", "dialog-image-header__close");
			},
			m(target, anchor) {
				insert(target, button, anchor);

				if (!mounted) {
					dispose = listen(button, "click", /*click_handler*/ ctx[9]);
					mounted = true;
				}
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(button);
				mounted = false;
				dispose();
			}
		};
	}

	// (27:0) {#if $state.context.accounts.length > 0}
	function create_if_block$7(ctx) {
		let div;
		let percsaccountbadge;
		let current;
		percsaccountbadge = new PercsAccountBadge({ props: { state: /*state*/ ctx[1] } });

		return {
			c() {
				div = element("div");
				create_component(percsaccountbadge.$$.fragment);
				attr(div, "class", "dialog-header__account-badge");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				mount_component(percsaccountbadge, div, null);
				current = true;
			},
			p(ctx, dirty) {
				const percsaccountbadge_changes = {};
				if (dirty & /*state*/ 2) percsaccountbadge_changes.state = /*state*/ ctx[1];
				percsaccountbadge.$set(percsaccountbadge_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsaccountbadge.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsaccountbadge.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div);
				destroy_component(percsaccountbadge);
			}
		};
	}

	function create_fragment$f(ctx) {
		let div1;
		let div0;
		let div0_style_value;
		let t0;
		let div1_class_value;
		let t1;
		let t2;
		let h2;
		let t3;
		let t4;
		let div2;
		let current;
		let if_block0 = /*dismissable*/ ctx[4] !== false && create_if_block_1$5(ctx);
		let if_block1 = /*$state*/ ctx[5].context.accounts.length > 0 && create_if_block$7(ctx);
		const default_slot_template = /*#slots*/ ctx[8].default;
		const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[7], null);

		return {
			c() {
				div1 = element("div");
				div0 = element("div");
				t0 = space();
				if (if_block0) if_block0.c();
				t1 = space();
				if (if_block1) if_block1.c();
				t2 = space();
				h2 = element("h2");
				t3 = text(/*text*/ ctx[2]);
				t4 = space();
				div2 = element("div");
				if (default_slot) default_slot.c();
				attr(div0, "class", "dialog-image-header__image");
				attr(div0, "style", div0_style_value = `background-image: url("${/*image*/ ctx[3].src}")`);
				attr(div1, "class", div1_class_value = bem("dialog-image-header", /*modifiers*/ ctx[0]));
				attr(h2, "class", "dialog-image-header__text");
				attr(div2, "class", "dialog-image-header__container");
			},
			m(target, anchor) {
				insert(target, div1, anchor);
				append(div1, div0);
				append(div1, t0);
				if (if_block0) if_block0.m(div1, null);
				insert(target, t1, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, t2, anchor);
				insert(target, h2, anchor);
				append(h2, t3);
				insert(target, t4, anchor);
				insert(target, div2, anchor);

				if (default_slot) {
					default_slot.m(div2, null);
				}

				current = true;
			},
			p(ctx, [dirty]) {
				if (!current || dirty & /*image*/ 8 && div0_style_value !== (div0_style_value = `background-image: url("${/*image*/ ctx[3].src}")`)) {
					attr(div0, "style", div0_style_value);
				}

				if (/*dismissable*/ ctx[4] !== false) {
					if (if_block0) {
						if_block0.p(ctx, dirty);
					} else {
						if_block0 = create_if_block_1$5(ctx);
						if_block0.c();
						if_block0.m(div1, null);
					}
				} else if (if_block0) {
					if_block0.d(1);
					if_block0 = null;
				}

				if (!current || dirty & /*modifiers*/ 1 && div1_class_value !== (div1_class_value = bem("dialog-image-header", /*modifiers*/ ctx[0]))) {
					attr(div1, "class", div1_class_value);
				}

				if (/*$state*/ ctx[5].context.accounts.length > 0) {
					if (if_block1) {
						if_block1.p(ctx, dirty);

						if (dirty & /*$state*/ 32) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block$7(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(t2.parentNode, t2);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}

				if (!current || dirty & /*text*/ 4) set_data(t3, /*text*/ ctx[2]);

				if (default_slot) {
					if (default_slot.p && (!current || dirty & /*$$scope*/ 128)) {
						update_slot_base(
							default_slot,
							default_slot_template,
							ctx,
							/*$$scope*/ ctx[7],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[7])
							: get_slot_changes(default_slot_template, /*$$scope*/ ctx[7], dirty, null),
							null
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block1);
				transition_in(default_slot, local);
				current = true;
			},
			o(local) {
				transition_out(if_block1);
				transition_out(default_slot, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div1);
				if (if_block0) if_block0.d();
				if (detaching) detach(t1);
				if (if_block1) if_block1.d(detaching);
				if (detaching) detach(t2);
				if (detaching) detach(h2);
				if (detaching) detach(t4);
				if (detaching) detach(div2);
				if (default_slot) default_slot.d(detaching);
			}
		};
	}

	function instance$f($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(5, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { $$slots: slots = {}, $$scope } = $$props;
		let { modifiers = "" } = $$props;
		let { state } = $$props;
		$$subscribe_state();
		let { text } = $$props;
		let { image } = $$props;
		let { dismissable = true } = $$props;
		const dispatch = createEventDispatcher();
		const click_handler = () => dispatch("close");

		$$self.$$set = $$props => {
			if ('modifiers' in $$props) $$invalidate(0, modifiers = $$props.modifiers);
			if ('state' in $$props) $$subscribe_state($$invalidate(1, state = $$props.state));
			if ('text' in $$props) $$invalidate(2, text = $$props.text);
			if ('image' in $$props) $$invalidate(3, image = $$props.image);
			if ('dismissable' in $$props) $$invalidate(4, dismissable = $$props.dismissable);
			if ('$$scope' in $$props) $$invalidate(7, $$scope = $$props.$$scope);
		};

		return [
			modifiers,
			state,
			text,
			image,
			dismissable,
			$state,
			dispatch,
			$$scope,
			slots,
			click_handler
		];
	}

	class PercsDialogImageHeader extends SvelteComponent {
		constructor(options) {
			super();

			init$3(
				this,
				options,
				instance$f,
				create_fragment$f,
				safe_not_equal,
				{
					modifiers: 0,
					state: 1,
					text: 2,
					image: 3,
					dismissable: 4
				},
				add_css$9
			);
		}
	}

	/* dist/components/dialog-contents/ProviderConnect.svelte generated by Svelte v3.59.2 */

	function add_css$8(target) {
		append_styles(target, "svelte-lf28pt", ".mt-2.svelte-lf28pt{margin-top:1rem}");
	}

	function get_each_context$1(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[7] = list[i];
		return child_ctx;
	}

	// (23:0) {:else}
	function create_else_block$4(ctx) {
		let percsdialogheader;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: /*$state*/ ctx[1].context.gate?.title || "Connect wallet"
				}
			});

		percsdialogheader.$on("close", /*close_handler_1*/ ctx[5]);

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];
				if (dirty & /*$state*/ 2) percsdialogheader_changes.text = /*$state*/ ctx[1].context.gate?.title || "Connect wallet";
				percsdialogheader.$set(percsdialogheader_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
			}
		};
	}

	// (21:0) {#if $state.context.subscribe}
	function create_if_block_1$4(ctx) {
		let percsdialogimageheader;
		let current;

		percsdialogimageheader = new PercsDialogImageHeader({
				props: {
					state: /*state*/ ctx[0],
					text: /*$state*/ ctx[1].context.subscribe.headingText,
					image: /*$state*/ ctx[1].context.subscribe.headingImage
				}
			});

		percsdialogimageheader.$on("close", /*close_handler*/ ctx[4]);

		return {
			c() {
				create_component(percsdialogimageheader.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogimageheader, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogimageheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogimageheader_changes.state = /*state*/ ctx[0];
				if (dirty & /*$state*/ 2) percsdialogimageheader_changes.text = /*$state*/ ctx[1].context.subscribe.headingText;
				if (dirty & /*$state*/ 2) percsdialogimageheader_changes.image = /*$state*/ ctx[1].context.subscribe.headingImage;
				percsdialogimageheader.$set(percsdialogimageheader_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogimageheader.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogimageheader.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogimageheader, detaching);
			}
		};
	}

	// (27:2) {#if $state.context.gate?.illustration}
	function create_if_block$6(ctx) {
		let img;
		let img_src_value;

		return {
			c() {
				img = element("img");
				if (!src_url_equal(img.src, img_src_value = /*$state*/ ctx[1].context.gate?.illustration)) attr(img, "src", img_src_value);
				attr(img, "alt", "illustration");
				attr(img, "class", "mt-2 svelte-lf28pt");
			},
			m(target, anchor) {
				insert(target, img, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*$state*/ 2 && !src_url_equal(img.src, img_src_value = /*$state*/ ctx[1].context.gate?.illustration)) {
					attr(img, "src", img_src_value);
				}
			},
			d(detaching) {
				if (detaching) detach(img);
			}
		};
	}

	// (33:4) <PercsButton       on:click={() => handleProviderClick(connector)}       icon={{ src: connector.logo ?? "https://app.getpercs.com/images/wallets.svg", alt: `Connect with ${connector.name}` }}     >
	function create_default_slot_1$a(ctx) {
		let t0_value = /*connector*/ ctx[7].name + "";
		let t0;
		let t1;

		return {
			c() {
				t0 = text(t0_value);
				t1 = space();
			},
			m(target, anchor) {
				insert(target, t0, anchor);
				insert(target, t1, anchor);
			},
			p(ctx, dirty) {
				if (dirty & /*$wallet*/ 4 && t0_value !== (t0_value = /*connector*/ ctx[7].name + "")) set_data(t0, t0_value);
			},
			d(detaching) {
				if (detaching) detach(t0);
				if (detaching) detach(t1);
			}
		};
	}

	// (32:2) {#each $wallet.connectors as connector}
	function create_each_block$1(ctx) {
		let percsbutton;
		let current;

		function click_handler() {
			return /*click_handler*/ ctx[6](/*connector*/ ctx[7]);
		}

		percsbutton = new PercsButton({
				props: {
					icon: {
						src: /*connector*/ ctx[7].logo ?? "https://app.getpercs.com/images/wallets.svg",
						alt: `Connect with ${/*connector*/ ctx[7].name}`
					},
					$$slots: { default: [create_default_slot_1$a] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", click_handler);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				const percsbutton_changes = {};

				if (dirty & /*$wallet*/ 4) percsbutton_changes.icon = {
					src: /*connector*/ ctx[7].logo ?? "https://app.getpercs.com/images/wallets.svg",
					alt: `Connect with ${/*connector*/ ctx[7].name}`
				};

				if (dirty & /*$$scope, $wallet*/ 1028) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (26:0) <PercsDialogContent modifiers="spaced full">
	function create_default_slot$a(ctx) {
		let t0;
		let p;
		let t1_value = (/*$state*/ ctx[1].context.gate?.description || "Connect a wallet with your NFTs to unlock this offer.") + "";
		let t1;
		let t2;
		let each_1_anchor;
		let current;
		let if_block = /*$state*/ ctx[1].context.gate?.illustration && create_if_block$6(ctx);
		let each_value = /*$wallet*/ ctx[2].connectors;
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block$1(get_each_context$1(ctx, each_value, i));
		}

		const out = i => transition_out(each_blocks[i], 1, 1, () => {
			each_blocks[i] = null;
		});

		return {
			c() {
				if (if_block) if_block.c();
				t0 = space();
				p = element("p");
				t1 = text(t1_value);
				t2 = space();

				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				each_1_anchor = empty$3();
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, t0, anchor);
				insert(target, p, anchor);
				append(p, t1);
				insert(target, t2, anchor);

				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(target, anchor);
					}
				}

				insert(target, each_1_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (/*$state*/ ctx[1].context.gate?.illustration) {
					if (if_block) {
						if_block.p(ctx, dirty);
					} else {
						if_block = create_if_block$6(ctx);
						if_block.c();
						if_block.m(t0.parentNode, t0);
					}
				} else if (if_block) {
					if_block.d(1);
					if_block = null;
				}

				if ((!current || dirty & /*$state*/ 2) && t1_value !== (t1_value = (/*$state*/ ctx[1].context.gate?.description || "Connect a wallet with your NFTs to unlock this offer.") + "")) set_data(t1, t1_value);

				if (dirty & /*$wallet, handleProviderClick*/ 12) {
					each_value = /*$wallet*/ ctx[2].connectors;
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context$1(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
							transition_in(each_blocks[i], 1);
						} else {
							each_blocks[i] = create_each_block$1(child_ctx);
							each_blocks[i].c();
							transition_in(each_blocks[i], 1);
							each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
						}
					}

					group_outros();

					for (i = each_value.length; i < each_blocks.length; i += 1) {
						out(i);
					}

					check_outros();
				}
			},
			i(local) {
				if (current) return;

				for (let i = 0; i < each_value.length; i += 1) {
					transition_in(each_blocks[i]);
				}

				current = true;
			},
			o(local) {
				each_blocks = each_blocks.filter(Boolean);

				for (let i = 0; i < each_blocks.length; i += 1) {
					transition_out(each_blocks[i]);
				}

				current = false;
			},
			d(detaching) {
				if (if_block) if_block.d(detaching);
				if (detaching) detach(t0);
				if (detaching) detach(p);
				if (detaching) detach(t2);
				destroy_each(each_blocks, detaching);
				if (detaching) detach(each_1_anchor);
			}
		};
	}

	function create_fragment$e(ctx) {
		let current_block_type_index;
		let if_block;
		let t;
		let percsdialogcontent;
		let current;
		const if_block_creators = [create_if_block_1$4, create_else_block$4];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*$state*/ ctx[1].context.subscribe) return 0;
			return 1;
		}

		current_block_type_index = select_block_type(ctx);
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "spaced full",
					$$slots: { default: [create_default_slot$a] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				if_block.c();
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				if_blocks[current_block_type_index].m(target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type(ctx);

				if (current_block_type_index === previous_block_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(t.parentNode, t);
				}

				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, $wallet, $state*/ 1030) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if_blocks[current_block_type_index].d(detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$e($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(1, $state = $$value)), state);

		let $wallet;
		component_subscribe($$self, wallet$1, $$value => $$invalidate(2, $wallet = $$value));
		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		/**
	 * @param {import("@wagmi/connectors").Connector} connector
	 */
		function handleProviderClick(connector) {
			wallet$1.connect({ connector });
		}

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_1(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = connector => handleProviderClick(connector);

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [
			state,
			$state,
			$wallet,
			handleProviderClick,
			close_handler,
			close_handler_1,
			click_handler
		];
	}

	class ProviderConnect extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$e, create_fragment$e, safe_not_equal, { state: 0 }, add_css$8);
		}
	}

	/* dist/components/internal/PercsProviderLogo.svelte generated by Svelte v3.59.2 */

	function add_css$7(target) {
		append_styles(target, "svelte-1dwv6mv", ".provider-logo{height:56px;width:56px;margin:32px}");
	}

	function create_fragment$d(ctx) {
		let img;
		let img_src_value;

		return {
			c() {
				img = element("img");
				attr(img, "class", "provider-logo");
				if (!src_url_equal(img.src, img_src_value = /*src*/ ctx[0])) attr(img, "src", img_src_value);
				attr(img, "alt", "Connect with");
			},
			m(target, anchor) {
				insert(target, img, anchor);
			},
			p(ctx, [dirty]) {
				if (dirty & /*src*/ 1 && !src_url_equal(img.src, img_src_value = /*src*/ ctx[0])) {
					attr(img, "src", img_src_value);
				}
			},
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(img);
			}
		};
	}

	function instance$d($$self, $$props, $$invalidate) {
		let { src } = $$props;

		$$self.$$set = $$props => {
			if ('src' in $$props) $$invalidate(0, src = $$props.src);
		};

		return [src];
	}

	class PercsProviderLogo extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$d, create_fragment$d, safe_not_equal, { src: 0 }, add_css$7);
		}
	}

	/* dist/components/dialog-contents/ProviderConnecting.svelte generated by Svelte v3.59.2 */

	function add_css$6(target) {
		append_styles(target, "svelte-n1q229", ".connecting-provider.svelte-n1q229{display:flex;flex-direction:column;font-weight:400;font-size:14px;line-height:20px;color:var(--dialog-text-color, #161b5d);margin:0 auto;align-items:center;justify-content:space-between}.connecting-provider__text.svelte-n1q229{margin-block-start:0em;margin-block-end:0em;padding-block-start:1em;padding-block-end:1em}");
	}

	// (14:0) {:else}
	function create_else_block$3(ctx) {
		let percsdialogheader;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Connect Wallet",
					$$slots: { default: [create_default_slot_2$8] },
					$$scope: { ctx }
				}
			});

		percsdialogheader.$on("close", /*close_handler_1*/ ctx[3]);

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];

				if (dirty & /*$$scope*/ 32) {
					percsdialogheader_changes.$$scope = { dirty, ctx };
				}

				percsdialogheader.$set(percsdialogheader_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
			}
		};
	}

	// (12:0) {#if $state.context.subscribe}
	function create_if_block_1$3(ctx) {
		let percsdialogimageheader;
		let current;

		percsdialogimageheader = new PercsDialogImageHeader({
				props: {
					state: /*state*/ ctx[0],
					text: /*$state*/ ctx[1].context.subscribe.headingText,
					image: /*$state*/ ctx[1].context.subscribe.headingImage
				}
			});

		percsdialogimageheader.$on("close", /*close_handler*/ ctx[2]);

		return {
			c() {
				create_component(percsdialogimageheader.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogimageheader, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogimageheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogimageheader_changes.state = /*state*/ ctx[0];
				if (dirty & /*$state*/ 2) percsdialogimageheader_changes.text = /*$state*/ ctx[1].context.subscribe.headingText;
				if (dirty & /*$state*/ 2) percsdialogimageheader_changes.image = /*$state*/ ctx[1].context.subscribe.headingImage;
				percsdialogimageheader.$set(percsdialogimageheader_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogimageheader.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogimageheader.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogimageheader, detaching);
			}
		};
	}

	// (15:2) <PercsDialogHeader {state} on:close text="Connect Wallet">
	function create_default_slot_2$8(ctx) {
		let p;

		return {
			c() {
				p = element("p");
				p.textContent = "Connect a wallet with your NFTs to unlock this offer.";
				attr(p, "class", "connecting-provider__text svelte-n1q229");
			},
			m(target, anchor) {
				insert(target, p, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(p);
			}
		};
	}

	// (21:4) {#if $state.context.provider}
	function create_if_block$5(ctx) {
		let percsproviderlogo;
		let current;

		percsproviderlogo = new PercsProviderLogo({
				props: {
					src: /*$state*/ ctx[1].context.provider.logo
				}
			});

		return {
			c() {
				create_component(percsproviderlogo.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsproviderlogo, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsproviderlogo_changes = {};
				if (dirty & /*$state*/ 2) percsproviderlogo_changes.src = /*$state*/ ctx[1].context.provider.logo;
				percsproviderlogo.$set(percsproviderlogo_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsproviderlogo.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsproviderlogo.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsproviderlogo, detaching);
			}
		};
	}

	// (30:2) <PercsButton variant="outlined" on:click={() => state.send("CONNECT")}>
	function create_default_slot_1$9(ctx) {
		let t;

		return {
			c() {
				t = text("Back");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (19:0) <PercsDialogContent modifiers="spaced full">
	function create_default_slot$9(ctx) {
		let div;
		let t0;
		let p;
		let t1;
		let t2_value = /*$state*/ ctx[1].context.provider?.name + "";
		let t2;
		let t3;
		let br;
		let t4;
		let t5_value = /*$state*/ ctx[1].context.provider?.name + "";
		let t5;
		let t6;
		let t7;
		let percsbutton;
		let current;
		let if_block = /*$state*/ ctx[1].context.provider && create_if_block$5(ctx);

		percsbutton = new PercsButton({
				props: {
					variant: "outlined",
					$$slots: { default: [create_default_slot_1$9] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[4]);

		return {
			c() {
				div = element("div");
				if (if_block) if_block.c();
				t0 = space();
				p = element("p");
				t1 = text("Connecting with ");
				t2 = text(t2_value);
				t3 = text(".\n      ");
				br = element("br");
				t4 = text("\n      Please check your ");
				t5 = text(t5_value);
				t6 = text(" notifications.");
				t7 = space();
				create_component(percsbutton.$$.fragment);
				attr(div, "class", "connecting-provider svelte-n1q229");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				if (if_block) if_block.m(div, null);
				append(div, t0);
				append(div, p);
				append(p, t1);
				append(p, t2);
				append(p, t3);
				append(p, br);
				append(p, t4);
				append(p, t5);
				append(p, t6);
				insert(target, t7, anchor);
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (/*$state*/ ctx[1].context.provider) {
					if (if_block) {
						if_block.p(ctx, dirty);

						if (dirty & /*$state*/ 2) {
							transition_in(if_block, 1);
						}
					} else {
						if_block = create_if_block$5(ctx);
						if_block.c();
						transition_in(if_block, 1);
						if_block.m(div, t0);
					}
				} else if (if_block) {
					group_outros();

					transition_out(if_block, 1, 1, () => {
						if_block = null;
					});

					check_outros();
				}

				if ((!current || dirty & /*$state*/ 2) && t2_value !== (t2_value = /*$state*/ ctx[1].context.provider?.name + "")) set_data(t2, t2_value);
				if ((!current || dirty & /*$state*/ 2) && t5_value !== (t5_value = /*$state*/ ctx[1].context.provider?.name + "")) set_data(t5, t5_value);
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 32) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div);
				if (if_block) if_block.d();
				if (detaching) detach(t7);
				destroy_component(percsbutton, detaching);
			}
		};
	}

	function create_fragment$c(ctx) {
		let current_block_type_index;
		let if_block;
		let t;
		let percsdialogcontent;
		let current;
		const if_block_creators = [create_if_block_1$3, create_else_block$3];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*$state*/ ctx[1].context.subscribe) return 0;
			return 1;
		}

		current_block_type_index = select_block_type(ctx);
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "spaced full",
					$$slots: { default: [create_default_slot$9] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				if_block.c();
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				if_blocks[current_block_type_index].m(target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type(ctx);

				if (current_block_type_index === previous_block_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(t.parentNode, t);
				}

				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, $state*/ 35) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if_blocks[current_block_type_index].d(detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$c($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(1, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_1(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("CONNECT");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [state, $state, close_handler, close_handler_1, click_handler];
	}

	class ProviderConnecting extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$c, create_fragment$c, safe_not_equal, { state: 0 }, add_css$6);
		}
	}

	/* dist/components/dialog-contents/ProviderConnectError.svelte generated by Svelte v3.59.2 */

	function add_css$5(target) {
		append_styles(target, "svelte-1pjs9sb", ".provider-connect-error{display:flex;flex-direction:column;gap:32px;font-weight:400;font-size:14px;line-height:20px;color:var(--dialog-text-color, #161b5d);margin:0 auto;align-items:center;justify-content:space-between}.provider-connect-error__text{margin-block-start:0em;margin-block-end:0em;padding-block-start:1em;padding-block-end:1em}");
	}

	// (29:4) {#if $state.context.provider}
	function create_if_block_1$2(ctx) {
		let percsproviderlogo;
		let current;

		percsproviderlogo = new PercsProviderLogo({
				props: {
					src: /*$state*/ ctx[1].context.provider.logo
				}
			});

		return {
			c() {
				create_component(percsproviderlogo.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsproviderlogo, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsproviderlogo_changes = {};
				if (dirty & /*$state*/ 2) percsproviderlogo_changes.src = /*$state*/ ctx[1].context.provider.logo;
				percsproviderlogo.$set(percsproviderlogo_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsproviderlogo.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsproviderlogo.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsproviderlogo, detaching);
			}
		};
	}

	// (33:2) {#if $state.context.provider?.errorMessage}
	function create_if_block$4(ctx) {
		let percsalert;
		let current;

		percsalert = new PercsAlert({
				props: {
					message: /*$state*/ ctx[1].context.provider?.errorMessage,
					type: "error",
					variant: "flat",
					animate: false
				}
			});

		return {
			c() {
				create_component(percsalert.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsalert, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsalert_changes = {};
				if (dirty & /*$state*/ 2) percsalert_changes.message = /*$state*/ ctx[1].context.provider?.errorMessage;
				percsalert.$set(percsalert_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsalert.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsalert.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsalert, detaching);
			}
		};
	}

	// (38:4) <PercsButton variant="contained" on:click={() => handleProviderClick()}>
	function create_default_slot_3$3(ctx) {
		let t;

		return {
			c() {
				t = text("Retry");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (39:4) <PercsButton variant="outlined" on:click={() => state.send("CONNECT")}>
	function create_default_slot_2$7(ctx) {
		let t;

		return {
			c() {
				t = text("Back");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (37:2) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$8(ctx) {
		let percsbutton0;
		let t;
		let percsbutton1;
		let current;

		percsbutton0 = new PercsButton({
				props: {
					variant: "contained",
					$$slots: { default: [create_default_slot_3$3] },
					$$scope: { ctx }
				}
			});

		percsbutton0.$on("click", /*click_handler*/ ctx[4]);

		percsbutton1 = new PercsButton({
				props: {
					variant: "outlined",
					$$slots: { default: [create_default_slot_2$7] },
					$$scope: { ctx }
				}
			});

		percsbutton1.$on("click", /*click_handler_1*/ ctx[5]);

		return {
			c() {
				create_component(percsbutton0.$$.fragment);
				t = space();
				create_component(percsbutton1.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton0, target, anchor);
				insert(target, t, anchor);
				mount_component(percsbutton1, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton0_changes = {};

				if (dirty & /*$$scope*/ 128) {
					percsbutton0_changes.$$scope = { dirty, ctx };
				}

				percsbutton0.$set(percsbutton0_changes);
				const percsbutton1_changes = {};

				if (dirty & /*$$scope*/ 128) {
					percsbutton1_changes.$$scope = { dirty, ctx };
				}

				percsbutton1.$set(percsbutton1_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton0.$$.fragment, local);
				transition_in(percsbutton1.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton0.$$.fragment, local);
				transition_out(percsbutton1.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton0, detaching);
				if (detaching) detach(t);
				destroy_component(percsbutton1, detaching);
			}
		};
	}

	// (27:0) <PercsDialogContent>
	function create_default_slot$8(ctx) {
		let div;
		let t0;
		let t1;
		let percsdialogactions;
		let current;
		let if_block0 = /*$state*/ ctx[1].context.provider && create_if_block_1$2(ctx);
		let if_block1 = /*$state*/ ctx[1].context.provider?.errorMessage && create_if_block$4(ctx);

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$8] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				div = element("div");
				if (if_block0) if_block0.c();
				t0 = space();
				if (if_block1) if_block1.c();
				t1 = space();
				create_component(percsdialogactions.$$.fragment);
				attr(div, "class", "provider-connect-error");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				if (if_block0) if_block0.m(div, null);
				insert(target, t0, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, t1, anchor);
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (/*$state*/ ctx[1].context.provider) {
					if (if_block0) {
						if_block0.p(ctx, dirty);

						if (dirty & /*$state*/ 2) {
							transition_in(if_block0, 1);
						}
					} else {
						if_block0 = create_if_block_1$2(ctx);
						if_block0.c();
						transition_in(if_block0, 1);
						if_block0.m(div, null);
					}
				} else if (if_block0) {
					group_outros();

					transition_out(if_block0, 1, 1, () => {
						if_block0 = null;
					});

					check_outros();
				}

				if (/*$state*/ ctx[1].context.provider?.errorMessage) {
					if (if_block1) {
						if_block1.p(ctx, dirty);

						if (dirty & /*$state*/ 2) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block$4(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(t1.parentNode, t1);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}

				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state*/ 129) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(if_block0);
				transition_in(if_block1);
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(if_block0);
				transition_out(if_block1);
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div);
				if (if_block0) if_block0.d();
				if (detaching) detach(t0);
				if (if_block1) if_block1.d(detaching);
				if (detaching) detach(t1);
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	function create_fragment$b(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: `${/*$state*/ ctx[1].context.provider?.name} error`
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[3]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot$8] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];
				if (dirty & /*$state*/ 2) percsdialogheader_changes.text = `${/*$state*/ ctx[1].context.provider?.name} error`;
				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, $state*/ 131) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$b($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(1, $state = $$value)), state);

		let $wallet;
		component_subscribe($$self, wallet$1, $$value => $$invalidate(6, $wallet = $$value));
		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		function handleProviderClick() {
			for (const connector of $wallet.connectors) {
				if ($state.context.provider?.name === connector.name) {
					wallet$1.connect({ connector });
					break;
				}
			}
		}

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => handleProviderClick();
		const click_handler_1 = () => state.send("CONNECT");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [
			state,
			$state,
			handleProviderClick,
			close_handler,
			click_handler,
			click_handler_1
		];
	}

	class ProviderConnectError extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$b, create_fragment$b, safe_not_equal, { state: 0 }, add_css$5);
		}
	}

	/* dist/components/dialog-contents/ProviderConnectSuccess.svelte generated by Svelte v3.59.2 */

	function create_fragment$a(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Wallet Connected"
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[1]);
		percsdialogcontent = new PercsDialogContent({});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];
				percsdialogheader.$set(percsdialogheader_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$a($$self, $$props, $$invalidate) {
		let { state } = $$props;

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		$$self.$$set = $$props => {
			if ('state' in $$props) $$invalidate(0, state = $$props.state);
		};

		return [state, close_handler];
	}

	class ProviderConnectSuccess extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$a, create_fragment$a, safe_not_equal, { state: 0 });
		}
	}

	/* dist/components/internal/PercsVerticalSpacer.svelte generated by Svelte v3.59.2 */

	function add_css$4(target) {
		append_styles(target, "svelte-13jqpam", ".space-16.svelte-13jqpam{height:16px}");
	}

	function create_fragment$9(ctx) {
		let div;

		return {
			c() {
				div = element("div");
				attr(div, "class", "space-16 svelte-13jqpam");
			},
			m(target, anchor) {
				insert(target, div, anchor);
			},
			p: noop$6,
			i: noop$6,
			o: noop$6,
			d(detaching) {
				if (detaching) detach(div);
			}
		};
	}

	class PercsVerticalSpacer extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, null, create_fragment$9, safe_not_equal, {}, add_css$4);
		}
	}

	/* dist/components/dialog-contents/ProviderEmpty.svelte generated by Svelte v3.59.2 */

	function create_default_slot_2$6(ctx) {
		let p;

		return {
			c() {
				p = element("p");
				p.textContent = "Connect a wallet with your NFTs to unlock this offer.";
			},
			m(target, anchor) {
				insert(target, p, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(p);
			}
		};
	}

	// (25:2) <PercsButton variant="outlined" on:click={() => state.send("CONNECT")}>
	function create_default_slot_1$7(ctx) {
		let t;

		return {
			c() {
				t = text("Back");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (18:0) <PercsDialogContent modifiers="spaced">
	function create_default_slot$7(ctx) {
		let p;
		let t0;
		let t1_value = /*$state*/ ctx[1].context.provider?.name + "";
		let t1;
		let t2;
		let br;
		let t3;
		let a;
		let t4;
		let t5;
		let t6;
		let percsverticalspacer;
		let t7;
		let percsbutton;
		let current;
		percsverticalspacer = new PercsVerticalSpacer({});

		percsbutton = new PercsButton({
				props: {
					variant: "outlined",
					$$slots: { default: [create_default_slot_1$7] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[4]);

		return {
			c() {
				p = element("p");
				t0 = text("Seems ");
				t1 = text(t1_value);
				t2 = text(" isn't installed on this browser.\n    ");
				br = element("br");
				t3 = space();
				a = element("a");
				t4 = text("Install it");
				t5 = text(" and refresh this page afterwards to retry.");
				t6 = space();
				create_component(percsverticalspacer.$$.fragment);
				t7 = space();
				create_component(percsbutton.$$.fragment);
				attr(a, "href", /*installUrl*/ ctx[2]);
			},
			m(target, anchor) {
				insert(target, p, anchor);
				append(p, t0);
				append(p, t1);
				append(p, t2);
				append(p, br);
				append(p, t3);
				append(p, a);
				append(a, t4);
				append(p, t5);
				insert(target, t6, anchor);
				mount_component(percsverticalspacer, target, anchor);
				insert(target, t7, anchor);
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if ((!current || dirty & /*$state*/ 2) && t1_value !== (t1_value = /*$state*/ ctx[1].context.provider?.name + "")) set_data(t1, t1_value);

				if (!current || dirty & /*installUrl*/ 4) {
					attr(a, "href", /*installUrl*/ ctx[2]);
				}

				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 32) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsverticalspacer.$$.fragment, local);
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsverticalspacer.$$.fragment, local);
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(p);
				if (detaching) detach(t6);
				destroy_component(percsverticalspacer, detaching);
				if (detaching) detach(t7);
				destroy_component(percsbutton, detaching);
			}
		};
	}

	function create_fragment$8(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Connect Wallet",
					$$slots: { default: [create_default_slot_2$6] },
					$$scope: { ctx }
				}
			});

		percsdialogheader.$on("close", /*close_handler*/ ctx[3]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "spaced",
					$$slots: { default: [create_default_slot$7] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];

				if (dirty & /*$$scope*/ 32) {
					percsdialogheader_changes.$$scope = { dirty, ctx };
				}

				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, installUrl, $state*/ 39) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$9($$self, $$props, $$invalidate) {
		let installUrl;

		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(1, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("CONNECT");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*$state*/ 2) {
				$$invalidate(2, installUrl = $state.context.provider?.name === "MetaMask"
				? `https://metamask.app.link/dapp/${window.location.host}${window.location.pathname}`
				: `https://go.cb-w.com/dapp?cb_url=${encodeURIComponent(window.location.href)}`);
			}
		};

		return [state, $state, installUrl, close_handler, click_handler];
	}

	class ProviderEmpty extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$9, create_fragment$8, safe_not_equal, { state: 0 });
		}
	}

	/* dist/components/dialog-contents/SubscribeIntegrationOptions.svelte generated by Svelte v3.59.2 */

	function add_css$3(target) {
		append_styles(target, "svelte-14r22lf", ".text-left{text-align:left}.space-y-4 > * + *{margin-top:1rem}");
	}

	function get_each_context(ctx, list, i) {
		const child_ctx = ctx.slice();
		child_ctx[19] = list[i];
		return child_ctx;
	}

	const get_icon_slot_changes = dirty => ({});
	const get_icon_slot_context = ctx => ({});

	// (106:0) {:else}
	function create_else_block$2(ctx) {
		let percsdialogcontent;
		let current;

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "spaced full",
					$$slots: { default: [create_default_slot_8] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope*/ 131072) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	// (84:35) 
	function create_if_block_3$1(ctx) {
		let percsdialogcontent;
		let current;

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "spaced full",
					$$slots: { default: [create_default_slot_4$1] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, emailValue*/ 131080) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	// (60:0) {#if selectedType == null}
	function create_if_block$3(ctx) {
		let percsdialogcontent;
		let current;

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "full",
					$$slots: { default: [create_default_slot$6] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope*/ 131072) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	// (113:8) {#if subscriptionOption.type !== "email"}
	function create_if_block_6$1(ctx) {
		let percsbutton;
		let current;

		function click_handler_2() {
			return /*click_handler_2*/ ctx[16](/*subscriptionOption*/ ctx[19]);
		}

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					icon: /*subscriptionOption*/ ctx[19].logo
					? {
							src: /*subscriptionOption*/ ctx[19].logo,
							alt: `${/*subscriptionOption*/ ctx[19].name} logo`
						}
					: null,
					$$slots: { default: [create_default_slot_11] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", click_handler_2);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(new_ctx, dirty) {
				ctx = new_ctx;
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 131072) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (119:12) {#if subscriptionOption.type === "email"}
	function create_if_block_7$1(ctx) {
		let current;
		const icon_slot_template = /*#slots*/ ctx[10].icon;
		const icon_slot = create_slot(icon_slot_template, ctx, /*$$scope*/ ctx[17], get_icon_slot_context);
		const icon_slot_or_fallback = icon_slot || fallback_block();

		return {
			c() {
				if (icon_slot_or_fallback) icon_slot_or_fallback.c();
			},
			m(target, anchor) {
				if (icon_slot_or_fallback) {
					icon_slot_or_fallback.m(target, anchor);
				}

				current = true;
			},
			p(ctx, dirty) {
				if (icon_slot) {
					if (icon_slot.p && (!current || dirty & /*$$scope*/ 131072)) {
						update_slot_base(
							icon_slot,
							icon_slot_template,
							ctx,
							/*$$scope*/ ctx[17],
							!current
							? get_all_dirty_from_scope(/*$$scope*/ ctx[17])
							: get_slot_changes(icon_slot_template, /*$$scope*/ ctx[17], dirty, get_icon_slot_changes),
							get_icon_slot_context
						);
					}
				}
			},
			i(local) {
				if (current) return;
				transition_in(icon_slot_or_fallback, local);
				current = true;
			},
			o(local) {
				transition_out(icon_slot_or_fallback, local);
				current = false;
			},
			d(detaching) {
				if (icon_slot_or_fallback) icon_slot_or_fallback.d(detaching);
			}
		};
	}

	// (120:32)                  
	function fallback_block(ctx) {
		let svg;
		let path;

		return {
			c() {
				svg = svg_element("svg");
				path = svg_element("path");
				attr(path, "stroke-linecap", "round");
				attr(path, "stroke-linejoin", "round");
				attr(path, "d", "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75");
				attr(svg, "class", "button__icon");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(svg, "fill", "none");
				attr(svg, "viewBox", "0 0 24 24");
				attr(svg, "stroke-width", "1.5");
				attr(svg, "stroke", "currentColor");
			},
			m(target, anchor) {
				insert(target, svg, anchor);
				append(svg, path);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(svg);
			}
		};
	}

	// (114:10) <PercsButton             on:click={() => handleSubscribe(subscriptionOption)}             variant="contained"             icon={subscriptionOption.logo ? { src: subscriptionOption.logo, alt: `${subscriptionOption.name} logo` } : null}           >
	function create_default_slot_11(ctx) {
		let t0;
		let t1_value = /*subscriptionOption*/ ctx[19].name + "";
		let t1;
		let current;
		let if_block = /*subscriptionOption*/ ctx[19].type === "email" && create_if_block_7$1(ctx);

		return {
			c() {
				if (if_block) if_block.c();
				t0 = space();
				t1 = text(t1_value);
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, t0, anchor);
				insert(target, t1, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (/*subscriptionOption*/ ctx[19].type === "email") if_block.p(ctx, dirty);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (if_block) if_block.d(detaching);
				if (detaching) detach(t0);
				if (detaching) detach(t1);
			}
		};
	}

	// (112:6) {#each subscriptionOptions as subscriptionOption}
	function create_each_block(ctx) {
		let if_block_anchor;
		let current;
		let if_block = /*subscriptionOption*/ ctx[19].type !== "email" && create_if_block_6$1(ctx);

		return {
			c() {
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (/*subscriptionOption*/ ctx[19].type !== "email") if_block.p(ctx, dirty);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if (if_block) if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (130:6) {#if typeOptions.length > 1}
	function create_if_block_5$1(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					$$slots: { default: [create_default_slot_10] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*handleClearType*/ ctx[8]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 131072) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (131:8) <PercsButton on:click={handleClearType}>
	function create_default_slot_10(ctx) {
		let t;

		return {
			c() {
				t = text("Back");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (111:4) <PercsDialogActions modifiers="margins">
	function create_default_slot_9(ctx) {
		let t;
		let if_block_anchor;
		let current;
		let each_value = /*subscriptionOptions*/ ctx[5];
		let each_blocks = [];

		for (let i = 0; i < each_value.length; i += 1) {
			each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
		}

		const out = i => transition_out(each_blocks[i], 1, 1, () => {
			each_blocks[i] = null;
		});

		let if_block = /*typeOptions*/ ctx[6].length > 1 && create_if_block_5$1(ctx);

		return {
			c() {
				for (let i = 0; i < each_blocks.length; i += 1) {
					each_blocks[i].c();
				}

				t = space();
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				for (let i = 0; i < each_blocks.length; i += 1) {
					if (each_blocks[i]) {
						each_blocks[i].m(target, anchor);
					}
				}

				insert(target, t, anchor);
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (dirty & /*subscriptionOptions, handleSubscribe, $$scope*/ 131616) {
					each_value = /*subscriptionOptions*/ ctx[5];
					let i;

					for (i = 0; i < each_value.length; i += 1) {
						const child_ctx = get_each_context(ctx, each_value, i);

						if (each_blocks[i]) {
							each_blocks[i].p(child_ctx, dirty);
							transition_in(each_blocks[i], 1);
						} else {
							each_blocks[i] = create_each_block(child_ctx);
							each_blocks[i].c();
							transition_in(each_blocks[i], 1);
							each_blocks[i].m(t.parentNode, t);
						}
					}

					group_outros();

					for (i = each_value.length; i < each_blocks.length; i += 1) {
						out(i);
					}

					check_outros();
				}

				if (/*typeOptions*/ ctx[6].length > 1) if_block.p(ctx, dirty);
			},
			i(local) {
				if (current) return;

				for (let i = 0; i < each_value.length; i += 1) {
					transition_in(each_blocks[i]);
				}

				transition_in(if_block);
				current = true;
			},
			o(local) {
				each_blocks = each_blocks.filter(Boolean);

				for (let i = 0; i < each_blocks.length; i += 1) {
					transition_out(each_blocks[i]);
				}

				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				destroy_each(each_blocks, detaching);
				if (detaching) detach(t);
				if (if_block) if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (107:2) <PercsDialogContent modifiers="spaced full">
	function create_default_slot_8(ctx) {
		let p;
		let t1;
		let percsdialogactions;
		let current;

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_9] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				p = element("p");
				p.textContent = "Please select a messaging platform to receive updates from us.";
				t1 = space();
				create_component(percsdialogactions.$$.fragment);
			},
			m(target, anchor) {
				insert(target, p, anchor);
				insert(target, t1, anchor);
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogactions_changes = {};

				if (dirty & /*$$scope*/ 131072) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(p);
				if (detaching) detach(t1);
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	// (92:8) <PercsButton           type="submit"           variant="contained"         >
	function create_default_slot_7(ctx) {
		let t;

		return {
			c() {
				t = text("Continue");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (98:8) {#if typeOptions.length > 1}
	function create_if_block_4$1(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					$$slots: { default: [create_default_slot_6] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*handleClearType*/ ctx[8]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 131072) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (99:10) <PercsButton on:click={handleClearType}>
	function create_default_slot_6(ctx) {
		let t;

		return {
			c() {
				t = text("Back");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (91:6) <PercsDialogActions modifiers="margins">
	function create_default_slot_5$1(ctx) {
		let percsbutton;
		let t;
		let if_block_anchor;
		let current;

		percsbutton = new PercsButton({
				props: {
					type: "submit",
					variant: "contained",
					$$slots: { default: [create_default_slot_7] },
					$$scope: { ctx }
				}
			});

		let if_block = /*typeOptions*/ ctx[6].length > 1 && create_if_block_4$1(ctx);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
				t = space();
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				insert(target, t, anchor);
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 131072) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
				if (/*typeOptions*/ ctx[6].length > 1) if_block.p(ctx, dirty);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
				if (detaching) detach(t);
				if (if_block) if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	// (85:2) <PercsDialogContent modifiers="spaced full">
	function create_default_slot_4$1(ctx) {
		let form;
		let p;
		let t1;
		let percsemailinput;
		let updating_value;
		let t2;
		let percsdialogactions;
		let current;
		let mounted;
		let dispose;

		function percsemailinput_value_binding(value) {
			/*percsemailinput_value_binding*/ ctx[14](value);
		}

		let percsemailinput_props = {};

		if (/*emailValue*/ ctx[3] !== void 0) {
			percsemailinput_props.value = /*emailValue*/ ctx[3];
		}

		percsemailinput = new PercsEmailInput({ props: percsemailinput_props });
		binding_callbacks.push(() => bind$4(percsemailinput, 'value', percsemailinput_value_binding));

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_5$1] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				form = element("form");
				p = element("p");
				p.textContent = "Please add your email below to receive updates from us.";
				t1 = space();
				create_component(percsemailinput.$$.fragment);
				t2 = space();
				create_component(percsdialogactions.$$.fragment);
				attr(form, "class", "text-left space-y-4");
			},
			m(target, anchor) {
				insert(target, form, anchor);
				append(form, p);
				append(form, t1);
				mount_component(percsemailinput, form, null);
				append(form, t2);
				mount_component(percsdialogactions, form, null);
				current = true;

				if (!mounted) {
					dispose = listen(form, "submit", prevent_default(/*submit_handler*/ ctx[15]));
					mounted = true;
				}
			},
			p(ctx, dirty) {
				const percsemailinput_changes = {};

				if (!updating_value && dirty & /*emailValue*/ 8) {
					updating_value = true;
					percsemailinput_changes.value = /*emailValue*/ ctx[3];
					add_flush_callback(() => updating_value = false);
				}

				percsemailinput.$set(percsemailinput_changes);
				const percsdialogactions_changes = {};

				if (dirty & /*$$scope*/ 131072) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsemailinput.$$.fragment, local);
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsemailinput.$$.fragment, local);
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(form);
				destroy_component(percsemailinput);
				destroy_component(percsdialogactions);
				mounted = false;
				dispose();
			}
		};
	}

	// (66:6) {#if typeOptions.includes("Wallet")}
	function create_if_block_2$1(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					$$slots: { default: [create_default_slot_3$2] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[12]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 131072) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (67:8) <PercsButton           on:click={() => handleSelectType("Wallet")}           variant="contained"         >
	function create_default_slot_3$2(ctx) {
		let t;

		return {
			c() {
				t = text("Subscribe with Wallet");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (74:6) {#if typeOptions.includes("Email")}
	function create_if_block_1$1(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					$$slots: { default: [create_default_slot_2$5] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler_1*/ ctx[13]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 131072) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (75:8) <PercsButton           on:click={() => handleSelectType("Email")}           variant="contained"         >
	function create_default_slot_2$5(ctx) {
		let t;

		return {
			c() {
				t = text("Subscribe with Email");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (65:4) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$6(ctx) {
		let show_if_1 = /*typeOptions*/ ctx[6].includes("Wallet");
		let t;
		let show_if = /*typeOptions*/ ctx[6].includes("Email");
		let if_block1_anchor;
		let current;
		let if_block0 = show_if_1 && create_if_block_2$1(ctx);
		let if_block1 = show_if && create_if_block_1$1(ctx);

		return {
			c() {
				if (if_block0) if_block0.c();
				t = space();
				if (if_block1) if_block1.c();
				if_block1_anchor = empty$3();
			},
			m(target, anchor) {
				if (if_block0) if_block0.m(target, anchor);
				insert(target, t, anchor);
				if (if_block1) if_block1.m(target, anchor);
				insert(target, if_block1_anchor, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if (show_if_1) if_block0.p(ctx, dirty);
				if (show_if) if_block1.p(ctx, dirty);
			},
			i(local) {
				if (current) return;
				transition_in(if_block0);
				transition_in(if_block1);
				current = true;
			},
			o(local) {
				transition_out(if_block0);
				transition_out(if_block1);
				current = false;
			},
			d(detaching) {
				if (if_block0) if_block0.d(detaching);
				if (detaching) detach(t);
				if (if_block1) if_block1.d(detaching);
				if (detaching) detach(if_block1_anchor);
			}
		};
	}

	// (61:2) <PercsDialogContent modifiers="full">
	function create_default_slot$6(ctx) {
		let p;
		let t1;
		let percsdialogactions;
		let current;

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$6] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				p = element("p");
				p.textContent = "Please select a subscription method.";
				t1 = space();
				create_component(percsdialogactions.$$.fragment);
			},
			m(target, anchor) {
				insert(target, p, anchor);
				insert(target, t1, anchor);
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogactions_changes = {};

				if (dirty & /*$$scope*/ 131072) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(p);
				if (detaching) detach(t1);
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	function create_fragment$7(ctx) {
		let percsdialogimageheader;
		let t;
		let current_block_type_index;
		let if_block;
		let if_block_anchor;
		let current;

		percsdialogimageheader = new PercsDialogImageHeader({
				props: {
					state: /*state*/ ctx[0],
					text: /*headerText*/ ctx[1],
					image: /*subscribe*/ ctx[4].headingImage
				}
			});

		percsdialogimageheader.$on("close", /*close_handler*/ ctx[11]);
		const if_block_creators = [create_if_block$3, create_if_block_3$1, create_else_block$2];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*selectedType*/ ctx[2] == null) return 0;
			if (/*selectedType*/ ctx[2] === "Email") return 1;
			return 2;
		}

		current_block_type_index = select_block_type(ctx);
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

		return {
			c() {
				create_component(percsdialogimageheader.$$.fragment);
				t = space();
				if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				mount_component(percsdialogimageheader, target, anchor);
				insert(target, t, anchor);
				if_blocks[current_block_type_index].m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogimageheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogimageheader_changes.state = /*state*/ ctx[0];
				if (dirty & /*headerText*/ 2) percsdialogimageheader_changes.text = /*headerText*/ ctx[1];
				percsdialogimageheader.$set(percsdialogimageheader_changes);
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type(ctx);

				if (current_block_type_index === previous_block_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogimageheader.$$.fragment, local);
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(percsdialogimageheader.$$.fragment, local);
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogimageheader, detaching);
				if (detaching) detach(t);
				if_blocks[current_block_type_index].d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	function instance$8($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(18, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { $$slots: slots = {}, $$scope } = $$props;
		let { state } = $$props;
		$$subscribe_state();

		/**
	 * @typedef {"Email" | "Wallet"} SubscriptionType
	 */
		if (!$state.context.subscribe || !$state.context.subscriptionOptions) {
			throw new Error("subscriptionOptions not initialized");
		}

		const { subscribe, subscriptionOptions } = $state.context;
		let headerText = "Subscribe to continue";

		/** @type {Array<SubscriptionType>} */
		const typeOptions = [];

		/** @type {SubscriptionType?} */
		let selectedType = null;

		if (subscriptionOptions.some(option => option.type !== "email")) {
			typeOptions.push("Wallet");
		}

		if (subscriptionOptions.some(option => option.type === "email")) {
			typeOptions.push("Email");
		}

		if (typeOptions.length === 1) {
			[selectedType] = typeOptions;
		}

		let emailValue = "";

		/**
	 * @param {SubscriptionType} type
	 */
		function handleSelectType(type) {
			$$invalidate(2, selectedType = type);
			$$invalidate(1, headerText = `${type} subscription`);
		}

		function handleClearType() {
			$$invalidate(2, selectedType = null);
			$$invalidate(1, headerText = "Subscribe to continue");
		}

		/**
	 * @param {typeof subscriptionOptions[ number ]} selectedSubscriptionOption
	 */
		function handleSubscribe(selectedSubscriptionOption) {
			state.send("INTEGRATION_SELECT", { data: { selectedSubscriptionOption } });
		}

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => handleSelectType("Wallet");
		const click_handler_1 = () => handleSelectType("Email");

		function percsemailinput_value_binding(value) {
			emailValue = value;
			$$invalidate(3, emailValue);
		}

		const submit_handler = () => handleSubscribe({
			type: "email",
			settings: {
				verificationMessage: "Please subscribe me with {email}"
			},
			values: { email: emailValue }
		});

		const click_handler_2 = subscriptionOption => handleSubscribe(subscriptionOption);

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
			if ('$$scope' in $$props) $$invalidate(17, $$scope = $$props.$$scope);
		};

		return [
			state,
			headerText,
			selectedType,
			emailValue,
			subscribe,
			subscriptionOptions,
			typeOptions,
			handleSelectType,
			handleClearType,
			handleSubscribe,
			slots,
			close_handler,
			click_handler,
			click_handler_1,
			percsemailinput_value_binding,
			submit_handler,
			click_handler_2,
			$$scope
		];
	}

	class SubscribeIntegrationOptions extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$8, create_fragment$7, safe_not_equal, { state: 0 }, add_css$3);
		}
	}

	var bn$1 = {exports: {}};

	bn$1.exports;

	(function (module) {
		(function (module, exports) {

		  // Utils
		  function assert (val, msg) {
		    if (!val) throw new Error(msg || 'Assertion failed');
		  }

		  // Could use `inherits` module, but don't want to move from single file
		  // architecture yet.
		  function inherits (ctor, superCtor) {
		    ctor.super_ = superCtor;
		    var TempCtor = function () {};
		    TempCtor.prototype = superCtor.prototype;
		    ctor.prototype = new TempCtor();
		    ctor.prototype.constructor = ctor;
		  }

		  // BN

		  function BN (number, base, endian) {
		    if (BN.isBN(number)) {
		      return number;
		    }

		    this.negative = 0;
		    this.words = null;
		    this.length = 0;

		    // Reduction context
		    this.red = null;

		    if (number !== null) {
		      if (base === 'le' || base === 'be') {
		        endian = base;
		        base = 10;
		      }

		      this._init(number || 0, base || 10, endian || 'be');
		    }
		  }
		  if (typeof module === 'object') {
		    module.exports = BN;
		  } else {
		    exports.BN = BN;
		  }

		  BN.BN = BN;
		  BN.wordSize = 26;

		  var Buffer;
		  try {
		    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
		      Buffer = window.Buffer;
		    } else {
		      Buffer = require$$3.Buffer;
		    }
		  } catch (e) {
		  }

		  BN.isBN = function isBN (num) {
		    if (num instanceof BN) {
		      return true;
		    }

		    return num !== null && typeof num === 'object' &&
		      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
		  };

		  BN.max = function max (left, right) {
		    if (left.cmp(right) > 0) return left;
		    return right;
		  };

		  BN.min = function min (left, right) {
		    if (left.cmp(right) < 0) return left;
		    return right;
		  };

		  BN.prototype._init = function init (number, base, endian) {
		    if (typeof number === 'number') {
		      return this._initNumber(number, base, endian);
		    }

		    if (typeof number === 'object') {
		      return this._initArray(number, base, endian);
		    }

		    if (base === 'hex') {
		      base = 16;
		    }
		    assert(base === (base | 0) && base >= 2 && base <= 36);

		    number = number.toString().replace(/\s+/g, '');
		    var start = 0;
		    if (number[0] === '-') {
		      start++;
		      this.negative = 1;
		    }

		    if (start < number.length) {
		      if (base === 16) {
		        this._parseHex(number, start, endian);
		      } else {
		        this._parseBase(number, base, start);
		        if (endian === 'le') {
		          this._initArray(this.toArray(), base, endian);
		        }
		      }
		    }
		  };

		  BN.prototype._initNumber = function _initNumber (number, base, endian) {
		    if (number < 0) {
		      this.negative = 1;
		      number = -number;
		    }
		    if (number < 0x4000000) {
		      this.words = [number & 0x3ffffff];
		      this.length = 1;
		    } else if (number < 0x10000000000000) {
		      this.words = [
		        number & 0x3ffffff,
		        (number / 0x4000000) & 0x3ffffff
		      ];
		      this.length = 2;
		    } else {
		      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
		      this.words = [
		        number & 0x3ffffff,
		        (number / 0x4000000) & 0x3ffffff,
		        1
		      ];
		      this.length = 3;
		    }

		    if (endian !== 'le') return;

		    // Reverse the bytes
		    this._initArray(this.toArray(), base, endian);
		  };

		  BN.prototype._initArray = function _initArray (number, base, endian) {
		    // Perhaps a Uint8Array
		    assert(typeof number.length === 'number');
		    if (number.length <= 0) {
		      this.words = [0];
		      this.length = 1;
		      return this;
		    }

		    this.length = Math.ceil(number.length / 3);
		    this.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      this.words[i] = 0;
		    }

		    var j, w;
		    var off = 0;
		    if (endian === 'be') {
		      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
		        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
		        this.words[j] |= (w << off) & 0x3ffffff;
		        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
		        off += 24;
		        if (off >= 26) {
		          off -= 26;
		          j++;
		        }
		      }
		    } else if (endian === 'le') {
		      for (i = 0, j = 0; i < number.length; i += 3) {
		        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
		        this.words[j] |= (w << off) & 0x3ffffff;
		        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
		        off += 24;
		        if (off >= 26) {
		          off -= 26;
		          j++;
		        }
		      }
		    }
		    return this._strip();
		  };

		  function parseHex4Bits (string, index) {
		    var c = string.charCodeAt(index);
		    // '0' - '9'
		    if (c >= 48 && c <= 57) {
		      return c - 48;
		    // 'A' - 'F'
		    } else if (c >= 65 && c <= 70) {
		      return c - 55;
		    // 'a' - 'f'
		    } else if (c >= 97 && c <= 102) {
		      return c - 87;
		    } else {
		      assert(false, 'Invalid character in ' + string);
		    }
		  }

		  function parseHexByte (string, lowerBound, index) {
		    var r = parseHex4Bits(string, index);
		    if (index - 1 >= lowerBound) {
		      r |= parseHex4Bits(string, index - 1) << 4;
		    }
		    return r;
		  }

		  BN.prototype._parseHex = function _parseHex (number, start, endian) {
		    // Create possibly bigger array to ensure that it fits the number
		    this.length = Math.ceil((number.length - start) / 6);
		    this.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      this.words[i] = 0;
		    }

		    // 24-bits chunks
		    var off = 0;
		    var j = 0;

		    var w;
		    if (endian === 'be') {
		      for (i = number.length - 1; i >= start; i -= 2) {
		        w = parseHexByte(number, start, i) << off;
		        this.words[j] |= w & 0x3ffffff;
		        if (off >= 18) {
		          off -= 18;
		          j += 1;
		          this.words[j] |= w >>> 26;
		        } else {
		          off += 8;
		        }
		      }
		    } else {
		      var parseLength = number.length - start;
		      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
		        w = parseHexByte(number, start, i) << off;
		        this.words[j] |= w & 0x3ffffff;
		        if (off >= 18) {
		          off -= 18;
		          j += 1;
		          this.words[j] |= w >>> 26;
		        } else {
		          off += 8;
		        }
		      }
		    }

		    this._strip();
		  };

		  function parseBase (str, start, end, mul) {
		    var r = 0;
		    var b = 0;
		    var len = Math.min(str.length, end);
		    for (var i = start; i < len; i++) {
		      var c = str.charCodeAt(i) - 48;

		      r *= mul;

		      // 'a'
		      if (c >= 49) {
		        b = c - 49 + 0xa;

		      // 'A'
		      } else if (c >= 17) {
		        b = c - 17 + 0xa;

		      // '0' - '9'
		      } else {
		        b = c;
		      }
		      assert(c >= 0 && b < mul, 'Invalid character');
		      r += b;
		    }
		    return r;
		  }

		  BN.prototype._parseBase = function _parseBase (number, base, start) {
		    // Initialize as zero
		    this.words = [0];
		    this.length = 1;

		    // Find length of limb in base
		    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
		      limbLen++;
		    }
		    limbLen--;
		    limbPow = (limbPow / base) | 0;

		    var total = number.length - start;
		    var mod = total % limbLen;
		    var end = Math.min(total, total - mod) + start;

		    var word = 0;
		    for (var i = start; i < end; i += limbLen) {
		      word = parseBase(number, i, i + limbLen, base);

		      this.imuln(limbPow);
		      if (this.words[0] + word < 0x4000000) {
		        this.words[0] += word;
		      } else {
		        this._iaddn(word);
		      }
		    }

		    if (mod !== 0) {
		      var pow = 1;
		      word = parseBase(number, i, number.length, base);

		      for (i = 0; i < mod; i++) {
		        pow *= base;
		      }

		      this.imuln(pow);
		      if (this.words[0] + word < 0x4000000) {
		        this.words[0] += word;
		      } else {
		        this._iaddn(word);
		      }
		    }

		    this._strip();
		  };

		  BN.prototype.copy = function copy (dest) {
		    dest.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      dest.words[i] = this.words[i];
		    }
		    dest.length = this.length;
		    dest.negative = this.negative;
		    dest.red = this.red;
		  };

		  function move (dest, src) {
		    dest.words = src.words;
		    dest.length = src.length;
		    dest.negative = src.negative;
		    dest.red = src.red;
		  }

		  BN.prototype._move = function _move (dest) {
		    move(dest, this);
		  };

		  BN.prototype.clone = function clone () {
		    var r = new BN(null);
		    this.copy(r);
		    return r;
		  };

		  BN.prototype._expand = function _expand (size) {
		    while (this.length < size) {
		      this.words[this.length++] = 0;
		    }
		    return this;
		  };

		  // Remove leading `0` from `this`
		  BN.prototype._strip = function strip () {
		    while (this.length > 1 && this.words[this.length - 1] === 0) {
		      this.length--;
		    }
		    return this._normSign();
		  };

		  BN.prototype._normSign = function _normSign () {
		    // -0 = 0
		    if (this.length === 1 && this.words[0] === 0) {
		      this.negative = 0;
		    }
		    return this;
		  };

		  // Check Symbol.for because not everywhere where Symbol defined
		  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
		  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
		    try {
		      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
		    } catch (e) {
		      BN.prototype.inspect = inspect;
		    }
		  } else {
		    BN.prototype.inspect = inspect;
		  }

		  function inspect () {
		    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
		  }

		  /*

		  var zeros = [];
		  var groupSizes = [];
		  var groupBases = [];

		  var s = '';
		  var i = -1;
		  while (++i < BN.wordSize) {
		    zeros[i] = s;
		    s += '0';
		  }
		  groupSizes[0] = 0;
		  groupSizes[1] = 0;
		  groupBases[0] = 0;
		  groupBases[1] = 0;
		  var base = 2 - 1;
		  while (++base < 36 + 1) {
		    var groupSize = 0;
		    var groupBase = 1;
		    while (groupBase < (1 << BN.wordSize) / base) {
		      groupBase *= base;
		      groupSize += 1;
		    }
		    groupSizes[base] = groupSize;
		    groupBases[base] = groupBase;
		  }

		  */

		  var zeros = [
		    '',
		    '0',
		    '00',
		    '000',
		    '0000',
		    '00000',
		    '000000',
		    '0000000',
		    '00000000',
		    '000000000',
		    '0000000000',
		    '00000000000',
		    '000000000000',
		    '0000000000000',
		    '00000000000000',
		    '000000000000000',
		    '0000000000000000',
		    '00000000000000000',
		    '000000000000000000',
		    '0000000000000000000',
		    '00000000000000000000',
		    '000000000000000000000',
		    '0000000000000000000000',
		    '00000000000000000000000',
		    '000000000000000000000000',
		    '0000000000000000000000000'
		  ];

		  var groupSizes = [
		    0, 0,
		    25, 16, 12, 11, 10, 9, 8,
		    8, 7, 7, 7, 7, 6, 6,
		    6, 6, 6, 6, 6, 5, 5,
		    5, 5, 5, 5, 5, 5, 5,
		    5, 5, 5, 5, 5, 5, 5
		  ];

		  var groupBases = [
		    0, 0,
		    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
		    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
		    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
		    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
		    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
		  ];

		  BN.prototype.toString = function toString (base, padding) {
		    base = base || 10;
		    padding = padding | 0 || 1;

		    var out;
		    if (base === 16 || base === 'hex') {
		      out = '';
		      var off = 0;
		      var carry = 0;
		      for (var i = 0; i < this.length; i++) {
		        var w = this.words[i];
		        var word = (((w << off) | carry) & 0xffffff).toString(16);
		        carry = (w >>> (24 - off)) & 0xffffff;
		        off += 2;
		        if (off >= 26) {
		          off -= 26;
		          i--;
		        }
		        if (carry !== 0 || i !== this.length - 1) {
		          out = zeros[6 - word.length] + word + out;
		        } else {
		          out = word + out;
		        }
		      }
		      if (carry !== 0) {
		        out = carry.toString(16) + out;
		      }
		      while (out.length % padding !== 0) {
		        out = '0' + out;
		      }
		      if (this.negative !== 0) {
		        out = '-' + out;
		      }
		      return out;
		    }

		    if (base === (base | 0) && base >= 2 && base <= 36) {
		      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
		      var groupSize = groupSizes[base];
		      // var groupBase = Math.pow(base, groupSize);
		      var groupBase = groupBases[base];
		      out = '';
		      var c = this.clone();
		      c.negative = 0;
		      while (!c.isZero()) {
		        var r = c.modrn(groupBase).toString(base);
		        c = c.idivn(groupBase);

		        if (!c.isZero()) {
		          out = zeros[groupSize - r.length] + r + out;
		        } else {
		          out = r + out;
		        }
		      }
		      if (this.isZero()) {
		        out = '0' + out;
		      }
		      while (out.length % padding !== 0) {
		        out = '0' + out;
		      }
		      if (this.negative !== 0) {
		        out = '-' + out;
		      }
		      return out;
		    }

		    assert(false, 'Base should be between 2 and 36');
		  };

		  BN.prototype.toNumber = function toNumber () {
		    var ret = this.words[0];
		    if (this.length === 2) {
		      ret += this.words[1] * 0x4000000;
		    } else if (this.length === 3 && this.words[2] === 0x01) {
		      // NOTE: at this stage it is known that the top bit is set
		      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
		    } else if (this.length > 2) {
		      assert(false, 'Number can only safely store up to 53 bits');
		    }
		    return (this.negative !== 0) ? -ret : ret;
		  };

		  BN.prototype.toJSON = function toJSON () {
		    return this.toString(16, 2);
		  };

		  if (Buffer) {
		    BN.prototype.toBuffer = function toBuffer (endian, length) {
		      return this.toArrayLike(Buffer, endian, length);
		    };
		  }

		  BN.prototype.toArray = function toArray (endian, length) {
		    return this.toArrayLike(Array, endian, length);
		  };

		  var allocate = function allocate (ArrayType, size) {
		    if (ArrayType.allocUnsafe) {
		      return ArrayType.allocUnsafe(size);
		    }
		    return new ArrayType(size);
		  };

		  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
		    this._strip();

		    var byteLength = this.byteLength();
		    var reqLength = length || Math.max(1, byteLength);
		    assert(byteLength <= reqLength, 'byte array longer than desired length');
		    assert(reqLength > 0, 'Requested array length <= 0');

		    var res = allocate(ArrayType, reqLength);
		    var postfix = endian === 'le' ? 'LE' : 'BE';
		    this['_toArrayLike' + postfix](res, byteLength);
		    return res;
		  };

		  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
		    var position = 0;
		    var carry = 0;

		    for (var i = 0, shift = 0; i < this.length; i++) {
		      var word = (this.words[i] << shift) | carry;

		      res[position++] = word & 0xff;
		      if (position < res.length) {
		        res[position++] = (word >> 8) & 0xff;
		      }
		      if (position < res.length) {
		        res[position++] = (word >> 16) & 0xff;
		      }

		      if (shift === 6) {
		        if (position < res.length) {
		          res[position++] = (word >> 24) & 0xff;
		        }
		        carry = 0;
		        shift = 0;
		      } else {
		        carry = word >>> 24;
		        shift += 2;
		      }
		    }

		    if (position < res.length) {
		      res[position++] = carry;

		      while (position < res.length) {
		        res[position++] = 0;
		      }
		    }
		  };

		  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
		    var position = res.length - 1;
		    var carry = 0;

		    for (var i = 0, shift = 0; i < this.length; i++) {
		      var word = (this.words[i] << shift) | carry;

		      res[position--] = word & 0xff;
		      if (position >= 0) {
		        res[position--] = (word >> 8) & 0xff;
		      }
		      if (position >= 0) {
		        res[position--] = (word >> 16) & 0xff;
		      }

		      if (shift === 6) {
		        if (position >= 0) {
		          res[position--] = (word >> 24) & 0xff;
		        }
		        carry = 0;
		        shift = 0;
		      } else {
		        carry = word >>> 24;
		        shift += 2;
		      }
		    }

		    if (position >= 0) {
		      res[position--] = carry;

		      while (position >= 0) {
		        res[position--] = 0;
		      }
		    }
		  };

		  if (Math.clz32) {
		    BN.prototype._countBits = function _countBits (w) {
		      return 32 - Math.clz32(w);
		    };
		  } else {
		    BN.prototype._countBits = function _countBits (w) {
		      var t = w;
		      var r = 0;
		      if (t >= 0x1000) {
		        r += 13;
		        t >>>= 13;
		      }
		      if (t >= 0x40) {
		        r += 7;
		        t >>>= 7;
		      }
		      if (t >= 0x8) {
		        r += 4;
		        t >>>= 4;
		      }
		      if (t >= 0x02) {
		        r += 2;
		        t >>>= 2;
		      }
		      return r + t;
		    };
		  }

		  BN.prototype._zeroBits = function _zeroBits (w) {
		    // Short-cut
		    if (w === 0) return 26;

		    var t = w;
		    var r = 0;
		    if ((t & 0x1fff) === 0) {
		      r += 13;
		      t >>>= 13;
		    }
		    if ((t & 0x7f) === 0) {
		      r += 7;
		      t >>>= 7;
		    }
		    if ((t & 0xf) === 0) {
		      r += 4;
		      t >>>= 4;
		    }
		    if ((t & 0x3) === 0) {
		      r += 2;
		      t >>>= 2;
		    }
		    if ((t & 0x1) === 0) {
		      r++;
		    }
		    return r;
		  };

		  // Return number of used bits in a BN
		  BN.prototype.bitLength = function bitLength () {
		    var w = this.words[this.length - 1];
		    var hi = this._countBits(w);
		    return (this.length - 1) * 26 + hi;
		  };

		  function toBitArray (num) {
		    var w = new Array(num.bitLength());

		    for (var bit = 0; bit < w.length; bit++) {
		      var off = (bit / 26) | 0;
		      var wbit = bit % 26;

		      w[bit] = (num.words[off] >>> wbit) & 0x01;
		    }

		    return w;
		  }

		  // Number of trailing zero bits
		  BN.prototype.zeroBits = function zeroBits () {
		    if (this.isZero()) return 0;

		    var r = 0;
		    for (var i = 0; i < this.length; i++) {
		      var b = this._zeroBits(this.words[i]);
		      r += b;
		      if (b !== 26) break;
		    }
		    return r;
		  };

		  BN.prototype.byteLength = function byteLength () {
		    return Math.ceil(this.bitLength() / 8);
		  };

		  BN.prototype.toTwos = function toTwos (width) {
		    if (this.negative !== 0) {
		      return this.abs().inotn(width).iaddn(1);
		    }
		    return this.clone();
		  };

		  BN.prototype.fromTwos = function fromTwos (width) {
		    if (this.testn(width - 1)) {
		      return this.notn(width).iaddn(1).ineg();
		    }
		    return this.clone();
		  };

		  BN.prototype.isNeg = function isNeg () {
		    return this.negative !== 0;
		  };

		  // Return negative clone of `this`
		  BN.prototype.neg = function neg () {
		    return this.clone().ineg();
		  };

		  BN.prototype.ineg = function ineg () {
		    if (!this.isZero()) {
		      this.negative ^= 1;
		    }

		    return this;
		  };

		  // Or `num` with `this` in-place
		  BN.prototype.iuor = function iuor (num) {
		    while (this.length < num.length) {
		      this.words[this.length++] = 0;
		    }

		    for (var i = 0; i < num.length; i++) {
		      this.words[i] = this.words[i] | num.words[i];
		    }

		    return this._strip();
		  };

		  BN.prototype.ior = function ior (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuor(num);
		  };

		  // Or `num` with `this`
		  BN.prototype.or = function or (num) {
		    if (this.length > num.length) return this.clone().ior(num);
		    return num.clone().ior(this);
		  };

		  BN.prototype.uor = function uor (num) {
		    if (this.length > num.length) return this.clone().iuor(num);
		    return num.clone().iuor(this);
		  };

		  // And `num` with `this` in-place
		  BN.prototype.iuand = function iuand (num) {
		    // b = min-length(num, this)
		    var b;
		    if (this.length > num.length) {
		      b = num;
		    } else {
		      b = this;
		    }

		    for (var i = 0; i < b.length; i++) {
		      this.words[i] = this.words[i] & num.words[i];
		    }

		    this.length = b.length;

		    return this._strip();
		  };

		  BN.prototype.iand = function iand (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuand(num);
		  };

		  // And `num` with `this`
		  BN.prototype.and = function and (num) {
		    if (this.length > num.length) return this.clone().iand(num);
		    return num.clone().iand(this);
		  };

		  BN.prototype.uand = function uand (num) {
		    if (this.length > num.length) return this.clone().iuand(num);
		    return num.clone().iuand(this);
		  };

		  // Xor `num` with `this` in-place
		  BN.prototype.iuxor = function iuxor (num) {
		    // a.length > b.length
		    var a;
		    var b;
		    if (this.length > num.length) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    for (var i = 0; i < b.length; i++) {
		      this.words[i] = a.words[i] ^ b.words[i];
		    }

		    if (this !== a) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    this.length = a.length;

		    return this._strip();
		  };

		  BN.prototype.ixor = function ixor (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuxor(num);
		  };

		  // Xor `num` with `this`
		  BN.prototype.xor = function xor (num) {
		    if (this.length > num.length) return this.clone().ixor(num);
		    return num.clone().ixor(this);
		  };

		  BN.prototype.uxor = function uxor (num) {
		    if (this.length > num.length) return this.clone().iuxor(num);
		    return num.clone().iuxor(this);
		  };

		  // Not ``this`` with ``width`` bitwidth
		  BN.prototype.inotn = function inotn (width) {
		    assert(typeof width === 'number' && width >= 0);

		    var bytesNeeded = Math.ceil(width / 26) | 0;
		    var bitsLeft = width % 26;

		    // Extend the buffer with leading zeroes
		    this._expand(bytesNeeded);

		    if (bitsLeft > 0) {
		      bytesNeeded--;
		    }

		    // Handle complete words
		    for (var i = 0; i < bytesNeeded; i++) {
		      this.words[i] = ~this.words[i] & 0x3ffffff;
		    }

		    // Handle the residue
		    if (bitsLeft > 0) {
		      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
		    }

		    // And remove leading zeroes
		    return this._strip();
		  };

		  BN.prototype.notn = function notn (width) {
		    return this.clone().inotn(width);
		  };

		  // Set `bit` of `this`
		  BN.prototype.setn = function setn (bit, val) {
		    assert(typeof bit === 'number' && bit >= 0);

		    var off = (bit / 26) | 0;
		    var wbit = bit % 26;

		    this._expand(off + 1);

		    if (val) {
		      this.words[off] = this.words[off] | (1 << wbit);
		    } else {
		      this.words[off] = this.words[off] & ~(1 << wbit);
		    }

		    return this._strip();
		  };

		  // Add `num` to `this` in-place
		  BN.prototype.iadd = function iadd (num) {
		    var r;

		    // negative + positive
		    if (this.negative !== 0 && num.negative === 0) {
		      this.negative = 0;
		      r = this.isub(num);
		      this.negative ^= 1;
		      return this._normSign();

		    // positive + negative
		    } else if (this.negative === 0 && num.negative !== 0) {
		      num.negative = 0;
		      r = this.isub(num);
		      num.negative = 1;
		      return r._normSign();
		    }

		    // a.length > b.length
		    var a, b;
		    if (this.length > num.length) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    var carry = 0;
		    for (var i = 0; i < b.length; i++) {
		      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
		      this.words[i] = r & 0x3ffffff;
		      carry = r >>> 26;
		    }
		    for (; carry !== 0 && i < a.length; i++) {
		      r = (a.words[i] | 0) + carry;
		      this.words[i] = r & 0x3ffffff;
		      carry = r >>> 26;
		    }

		    this.length = a.length;
		    if (carry !== 0) {
		      this.words[this.length] = carry;
		      this.length++;
		    // Copy the rest of the words
		    } else if (a !== this) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    return this;
		  };

		  // Add `num` to `this`
		  BN.prototype.add = function add (num) {
		    var res;
		    if (num.negative !== 0 && this.negative === 0) {
		      num.negative = 0;
		      res = this.sub(num);
		      num.negative ^= 1;
		      return res;
		    } else if (num.negative === 0 && this.negative !== 0) {
		      this.negative = 0;
		      res = num.sub(this);
		      this.negative = 1;
		      return res;
		    }

		    if (this.length > num.length) return this.clone().iadd(num);

		    return num.clone().iadd(this);
		  };

		  // Subtract `num` from `this` in-place
		  BN.prototype.isub = function isub (num) {
		    // this - (-num) = this + num
		    if (num.negative !== 0) {
		      num.negative = 0;
		      var r = this.iadd(num);
		      num.negative = 1;
		      return r._normSign();

		    // -this - num = -(this + num)
		    } else if (this.negative !== 0) {
		      this.negative = 0;
		      this.iadd(num);
		      this.negative = 1;
		      return this._normSign();
		    }

		    // At this point both numbers are positive
		    var cmp = this.cmp(num);

		    // Optimization - zeroify
		    if (cmp === 0) {
		      this.negative = 0;
		      this.length = 1;
		      this.words[0] = 0;
		      return this;
		    }

		    // a > b
		    var a, b;
		    if (cmp > 0) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    var carry = 0;
		    for (var i = 0; i < b.length; i++) {
		      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
		      carry = r >> 26;
		      this.words[i] = r & 0x3ffffff;
		    }
		    for (; carry !== 0 && i < a.length; i++) {
		      r = (a.words[i] | 0) + carry;
		      carry = r >> 26;
		      this.words[i] = r & 0x3ffffff;
		    }

		    // Copy rest of the words
		    if (carry === 0 && i < a.length && a !== this) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    this.length = Math.max(this.length, i);

		    if (a !== this) {
		      this.negative = 1;
		    }

		    return this._strip();
		  };

		  // Subtract `num` from `this`
		  BN.prototype.sub = function sub (num) {
		    return this.clone().isub(num);
		  };

		  function smallMulTo (self, num, out) {
		    out.negative = num.negative ^ self.negative;
		    var len = (self.length + num.length) | 0;
		    out.length = len;
		    len = (len - 1) | 0;

		    // Peel one iteration (compiler can't do it, because of code complexity)
		    var a = self.words[0] | 0;
		    var b = num.words[0] | 0;
		    var r = a * b;

		    var lo = r & 0x3ffffff;
		    var carry = (r / 0x4000000) | 0;
		    out.words[0] = lo;

		    for (var k = 1; k < len; k++) {
		      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
		      // note that ncarry could be >= 0x3ffffff
		      var ncarry = carry >>> 26;
		      var rword = carry & 0x3ffffff;
		      var maxJ = Math.min(k, num.length - 1);
		      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
		        var i = (k - j) | 0;
		        a = self.words[i] | 0;
		        b = num.words[j] | 0;
		        r = a * b + rword;
		        ncarry += (r / 0x4000000) | 0;
		        rword = r & 0x3ffffff;
		      }
		      out.words[k] = rword | 0;
		      carry = ncarry | 0;
		    }
		    if (carry !== 0) {
		      out.words[k] = carry | 0;
		    } else {
		      out.length--;
		    }

		    return out._strip();
		  }

		  // TODO(indutny): it may be reasonable to omit it for users who don't need
		  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
		  // multiplication (like elliptic secp256k1).
		  var comb10MulTo = function comb10MulTo (self, num, out) {
		    var a = self.words;
		    var b = num.words;
		    var o = out.words;
		    var c = 0;
		    var lo;
		    var mid;
		    var hi;
		    var a0 = a[0] | 0;
		    var al0 = a0 & 0x1fff;
		    var ah0 = a0 >>> 13;
		    var a1 = a[1] | 0;
		    var al1 = a1 & 0x1fff;
		    var ah1 = a1 >>> 13;
		    var a2 = a[2] | 0;
		    var al2 = a2 & 0x1fff;
		    var ah2 = a2 >>> 13;
		    var a3 = a[3] | 0;
		    var al3 = a3 & 0x1fff;
		    var ah3 = a3 >>> 13;
		    var a4 = a[4] | 0;
		    var al4 = a4 & 0x1fff;
		    var ah4 = a4 >>> 13;
		    var a5 = a[5] | 0;
		    var al5 = a5 & 0x1fff;
		    var ah5 = a5 >>> 13;
		    var a6 = a[6] | 0;
		    var al6 = a6 & 0x1fff;
		    var ah6 = a6 >>> 13;
		    var a7 = a[7] | 0;
		    var al7 = a7 & 0x1fff;
		    var ah7 = a7 >>> 13;
		    var a8 = a[8] | 0;
		    var al8 = a8 & 0x1fff;
		    var ah8 = a8 >>> 13;
		    var a9 = a[9] | 0;
		    var al9 = a9 & 0x1fff;
		    var ah9 = a9 >>> 13;
		    var b0 = b[0] | 0;
		    var bl0 = b0 & 0x1fff;
		    var bh0 = b0 >>> 13;
		    var b1 = b[1] | 0;
		    var bl1 = b1 & 0x1fff;
		    var bh1 = b1 >>> 13;
		    var b2 = b[2] | 0;
		    var bl2 = b2 & 0x1fff;
		    var bh2 = b2 >>> 13;
		    var b3 = b[3] | 0;
		    var bl3 = b3 & 0x1fff;
		    var bh3 = b3 >>> 13;
		    var b4 = b[4] | 0;
		    var bl4 = b4 & 0x1fff;
		    var bh4 = b4 >>> 13;
		    var b5 = b[5] | 0;
		    var bl5 = b5 & 0x1fff;
		    var bh5 = b5 >>> 13;
		    var b6 = b[6] | 0;
		    var bl6 = b6 & 0x1fff;
		    var bh6 = b6 >>> 13;
		    var b7 = b[7] | 0;
		    var bl7 = b7 & 0x1fff;
		    var bh7 = b7 >>> 13;
		    var b8 = b[8] | 0;
		    var bl8 = b8 & 0x1fff;
		    var bh8 = b8 >>> 13;
		    var b9 = b[9] | 0;
		    var bl9 = b9 & 0x1fff;
		    var bh9 = b9 >>> 13;

		    out.negative = self.negative ^ num.negative;
		    out.length = 19;
		    /* k = 0 */
		    lo = Math.imul(al0, bl0);
		    mid = Math.imul(al0, bh0);
		    mid = (mid + Math.imul(ah0, bl0)) | 0;
		    hi = Math.imul(ah0, bh0);
		    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
		    w0 &= 0x3ffffff;
		    /* k = 1 */
		    lo = Math.imul(al1, bl0);
		    mid = Math.imul(al1, bh0);
		    mid = (mid + Math.imul(ah1, bl0)) | 0;
		    hi = Math.imul(ah1, bh0);
		    lo = (lo + Math.imul(al0, bl1)) | 0;
		    mid = (mid + Math.imul(al0, bh1)) | 0;
		    mid = (mid + Math.imul(ah0, bl1)) | 0;
		    hi = (hi + Math.imul(ah0, bh1)) | 0;
		    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
		    w1 &= 0x3ffffff;
		    /* k = 2 */
		    lo = Math.imul(al2, bl0);
		    mid = Math.imul(al2, bh0);
		    mid = (mid + Math.imul(ah2, bl0)) | 0;
		    hi = Math.imul(ah2, bh0);
		    lo = (lo + Math.imul(al1, bl1)) | 0;
		    mid = (mid + Math.imul(al1, bh1)) | 0;
		    mid = (mid + Math.imul(ah1, bl1)) | 0;
		    hi = (hi + Math.imul(ah1, bh1)) | 0;
		    lo = (lo + Math.imul(al0, bl2)) | 0;
		    mid = (mid + Math.imul(al0, bh2)) | 0;
		    mid = (mid + Math.imul(ah0, bl2)) | 0;
		    hi = (hi + Math.imul(ah0, bh2)) | 0;
		    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
		    w2 &= 0x3ffffff;
		    /* k = 3 */
		    lo = Math.imul(al3, bl0);
		    mid = Math.imul(al3, bh0);
		    mid = (mid + Math.imul(ah3, bl0)) | 0;
		    hi = Math.imul(ah3, bh0);
		    lo = (lo + Math.imul(al2, bl1)) | 0;
		    mid = (mid + Math.imul(al2, bh1)) | 0;
		    mid = (mid + Math.imul(ah2, bl1)) | 0;
		    hi = (hi + Math.imul(ah2, bh1)) | 0;
		    lo = (lo + Math.imul(al1, bl2)) | 0;
		    mid = (mid + Math.imul(al1, bh2)) | 0;
		    mid = (mid + Math.imul(ah1, bl2)) | 0;
		    hi = (hi + Math.imul(ah1, bh2)) | 0;
		    lo = (lo + Math.imul(al0, bl3)) | 0;
		    mid = (mid + Math.imul(al0, bh3)) | 0;
		    mid = (mid + Math.imul(ah0, bl3)) | 0;
		    hi = (hi + Math.imul(ah0, bh3)) | 0;
		    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
		    w3 &= 0x3ffffff;
		    /* k = 4 */
		    lo = Math.imul(al4, bl0);
		    mid = Math.imul(al4, bh0);
		    mid = (mid + Math.imul(ah4, bl0)) | 0;
		    hi = Math.imul(ah4, bh0);
		    lo = (lo + Math.imul(al3, bl1)) | 0;
		    mid = (mid + Math.imul(al3, bh1)) | 0;
		    mid = (mid + Math.imul(ah3, bl1)) | 0;
		    hi = (hi + Math.imul(ah3, bh1)) | 0;
		    lo = (lo + Math.imul(al2, bl2)) | 0;
		    mid = (mid + Math.imul(al2, bh2)) | 0;
		    mid = (mid + Math.imul(ah2, bl2)) | 0;
		    hi = (hi + Math.imul(ah2, bh2)) | 0;
		    lo = (lo + Math.imul(al1, bl3)) | 0;
		    mid = (mid + Math.imul(al1, bh3)) | 0;
		    mid = (mid + Math.imul(ah1, bl3)) | 0;
		    hi = (hi + Math.imul(ah1, bh3)) | 0;
		    lo = (lo + Math.imul(al0, bl4)) | 0;
		    mid = (mid + Math.imul(al0, bh4)) | 0;
		    mid = (mid + Math.imul(ah0, bl4)) | 0;
		    hi = (hi + Math.imul(ah0, bh4)) | 0;
		    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
		    w4 &= 0x3ffffff;
		    /* k = 5 */
		    lo = Math.imul(al5, bl0);
		    mid = Math.imul(al5, bh0);
		    mid = (mid + Math.imul(ah5, bl0)) | 0;
		    hi = Math.imul(ah5, bh0);
		    lo = (lo + Math.imul(al4, bl1)) | 0;
		    mid = (mid + Math.imul(al4, bh1)) | 0;
		    mid = (mid + Math.imul(ah4, bl1)) | 0;
		    hi = (hi + Math.imul(ah4, bh1)) | 0;
		    lo = (lo + Math.imul(al3, bl2)) | 0;
		    mid = (mid + Math.imul(al3, bh2)) | 0;
		    mid = (mid + Math.imul(ah3, bl2)) | 0;
		    hi = (hi + Math.imul(ah3, bh2)) | 0;
		    lo = (lo + Math.imul(al2, bl3)) | 0;
		    mid = (mid + Math.imul(al2, bh3)) | 0;
		    mid = (mid + Math.imul(ah2, bl3)) | 0;
		    hi = (hi + Math.imul(ah2, bh3)) | 0;
		    lo = (lo + Math.imul(al1, bl4)) | 0;
		    mid = (mid + Math.imul(al1, bh4)) | 0;
		    mid = (mid + Math.imul(ah1, bl4)) | 0;
		    hi = (hi + Math.imul(ah1, bh4)) | 0;
		    lo = (lo + Math.imul(al0, bl5)) | 0;
		    mid = (mid + Math.imul(al0, bh5)) | 0;
		    mid = (mid + Math.imul(ah0, bl5)) | 0;
		    hi = (hi + Math.imul(ah0, bh5)) | 0;
		    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
		    w5 &= 0x3ffffff;
		    /* k = 6 */
		    lo = Math.imul(al6, bl0);
		    mid = Math.imul(al6, bh0);
		    mid = (mid + Math.imul(ah6, bl0)) | 0;
		    hi = Math.imul(ah6, bh0);
		    lo = (lo + Math.imul(al5, bl1)) | 0;
		    mid = (mid + Math.imul(al5, bh1)) | 0;
		    mid = (mid + Math.imul(ah5, bl1)) | 0;
		    hi = (hi + Math.imul(ah5, bh1)) | 0;
		    lo = (lo + Math.imul(al4, bl2)) | 0;
		    mid = (mid + Math.imul(al4, bh2)) | 0;
		    mid = (mid + Math.imul(ah4, bl2)) | 0;
		    hi = (hi + Math.imul(ah4, bh2)) | 0;
		    lo = (lo + Math.imul(al3, bl3)) | 0;
		    mid = (mid + Math.imul(al3, bh3)) | 0;
		    mid = (mid + Math.imul(ah3, bl3)) | 0;
		    hi = (hi + Math.imul(ah3, bh3)) | 0;
		    lo = (lo + Math.imul(al2, bl4)) | 0;
		    mid = (mid + Math.imul(al2, bh4)) | 0;
		    mid = (mid + Math.imul(ah2, bl4)) | 0;
		    hi = (hi + Math.imul(ah2, bh4)) | 0;
		    lo = (lo + Math.imul(al1, bl5)) | 0;
		    mid = (mid + Math.imul(al1, bh5)) | 0;
		    mid = (mid + Math.imul(ah1, bl5)) | 0;
		    hi = (hi + Math.imul(ah1, bh5)) | 0;
		    lo = (lo + Math.imul(al0, bl6)) | 0;
		    mid = (mid + Math.imul(al0, bh6)) | 0;
		    mid = (mid + Math.imul(ah0, bl6)) | 0;
		    hi = (hi + Math.imul(ah0, bh6)) | 0;
		    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
		    w6 &= 0x3ffffff;
		    /* k = 7 */
		    lo = Math.imul(al7, bl0);
		    mid = Math.imul(al7, bh0);
		    mid = (mid + Math.imul(ah7, bl0)) | 0;
		    hi = Math.imul(ah7, bh0);
		    lo = (lo + Math.imul(al6, bl1)) | 0;
		    mid = (mid + Math.imul(al6, bh1)) | 0;
		    mid = (mid + Math.imul(ah6, bl1)) | 0;
		    hi = (hi + Math.imul(ah6, bh1)) | 0;
		    lo = (lo + Math.imul(al5, bl2)) | 0;
		    mid = (mid + Math.imul(al5, bh2)) | 0;
		    mid = (mid + Math.imul(ah5, bl2)) | 0;
		    hi = (hi + Math.imul(ah5, bh2)) | 0;
		    lo = (lo + Math.imul(al4, bl3)) | 0;
		    mid = (mid + Math.imul(al4, bh3)) | 0;
		    mid = (mid + Math.imul(ah4, bl3)) | 0;
		    hi = (hi + Math.imul(ah4, bh3)) | 0;
		    lo = (lo + Math.imul(al3, bl4)) | 0;
		    mid = (mid + Math.imul(al3, bh4)) | 0;
		    mid = (mid + Math.imul(ah3, bl4)) | 0;
		    hi = (hi + Math.imul(ah3, bh4)) | 0;
		    lo = (lo + Math.imul(al2, bl5)) | 0;
		    mid = (mid + Math.imul(al2, bh5)) | 0;
		    mid = (mid + Math.imul(ah2, bl5)) | 0;
		    hi = (hi + Math.imul(ah2, bh5)) | 0;
		    lo = (lo + Math.imul(al1, bl6)) | 0;
		    mid = (mid + Math.imul(al1, bh6)) | 0;
		    mid = (mid + Math.imul(ah1, bl6)) | 0;
		    hi = (hi + Math.imul(ah1, bh6)) | 0;
		    lo = (lo + Math.imul(al0, bl7)) | 0;
		    mid = (mid + Math.imul(al0, bh7)) | 0;
		    mid = (mid + Math.imul(ah0, bl7)) | 0;
		    hi = (hi + Math.imul(ah0, bh7)) | 0;
		    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
		    w7 &= 0x3ffffff;
		    /* k = 8 */
		    lo = Math.imul(al8, bl0);
		    mid = Math.imul(al8, bh0);
		    mid = (mid + Math.imul(ah8, bl0)) | 0;
		    hi = Math.imul(ah8, bh0);
		    lo = (lo + Math.imul(al7, bl1)) | 0;
		    mid = (mid + Math.imul(al7, bh1)) | 0;
		    mid = (mid + Math.imul(ah7, bl1)) | 0;
		    hi = (hi + Math.imul(ah7, bh1)) | 0;
		    lo = (lo + Math.imul(al6, bl2)) | 0;
		    mid = (mid + Math.imul(al6, bh2)) | 0;
		    mid = (mid + Math.imul(ah6, bl2)) | 0;
		    hi = (hi + Math.imul(ah6, bh2)) | 0;
		    lo = (lo + Math.imul(al5, bl3)) | 0;
		    mid = (mid + Math.imul(al5, bh3)) | 0;
		    mid = (mid + Math.imul(ah5, bl3)) | 0;
		    hi = (hi + Math.imul(ah5, bh3)) | 0;
		    lo = (lo + Math.imul(al4, bl4)) | 0;
		    mid = (mid + Math.imul(al4, bh4)) | 0;
		    mid = (mid + Math.imul(ah4, bl4)) | 0;
		    hi = (hi + Math.imul(ah4, bh4)) | 0;
		    lo = (lo + Math.imul(al3, bl5)) | 0;
		    mid = (mid + Math.imul(al3, bh5)) | 0;
		    mid = (mid + Math.imul(ah3, bl5)) | 0;
		    hi = (hi + Math.imul(ah3, bh5)) | 0;
		    lo = (lo + Math.imul(al2, bl6)) | 0;
		    mid = (mid + Math.imul(al2, bh6)) | 0;
		    mid = (mid + Math.imul(ah2, bl6)) | 0;
		    hi = (hi + Math.imul(ah2, bh6)) | 0;
		    lo = (lo + Math.imul(al1, bl7)) | 0;
		    mid = (mid + Math.imul(al1, bh7)) | 0;
		    mid = (mid + Math.imul(ah1, bl7)) | 0;
		    hi = (hi + Math.imul(ah1, bh7)) | 0;
		    lo = (lo + Math.imul(al0, bl8)) | 0;
		    mid = (mid + Math.imul(al0, bh8)) | 0;
		    mid = (mid + Math.imul(ah0, bl8)) | 0;
		    hi = (hi + Math.imul(ah0, bh8)) | 0;
		    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
		    w8 &= 0x3ffffff;
		    /* k = 9 */
		    lo = Math.imul(al9, bl0);
		    mid = Math.imul(al9, bh0);
		    mid = (mid + Math.imul(ah9, bl0)) | 0;
		    hi = Math.imul(ah9, bh0);
		    lo = (lo + Math.imul(al8, bl1)) | 0;
		    mid = (mid + Math.imul(al8, bh1)) | 0;
		    mid = (mid + Math.imul(ah8, bl1)) | 0;
		    hi = (hi + Math.imul(ah8, bh1)) | 0;
		    lo = (lo + Math.imul(al7, bl2)) | 0;
		    mid = (mid + Math.imul(al7, bh2)) | 0;
		    mid = (mid + Math.imul(ah7, bl2)) | 0;
		    hi = (hi + Math.imul(ah7, bh2)) | 0;
		    lo = (lo + Math.imul(al6, bl3)) | 0;
		    mid = (mid + Math.imul(al6, bh3)) | 0;
		    mid = (mid + Math.imul(ah6, bl3)) | 0;
		    hi = (hi + Math.imul(ah6, bh3)) | 0;
		    lo = (lo + Math.imul(al5, bl4)) | 0;
		    mid = (mid + Math.imul(al5, bh4)) | 0;
		    mid = (mid + Math.imul(ah5, bl4)) | 0;
		    hi = (hi + Math.imul(ah5, bh4)) | 0;
		    lo = (lo + Math.imul(al4, bl5)) | 0;
		    mid = (mid + Math.imul(al4, bh5)) | 0;
		    mid = (mid + Math.imul(ah4, bl5)) | 0;
		    hi = (hi + Math.imul(ah4, bh5)) | 0;
		    lo = (lo + Math.imul(al3, bl6)) | 0;
		    mid = (mid + Math.imul(al3, bh6)) | 0;
		    mid = (mid + Math.imul(ah3, bl6)) | 0;
		    hi = (hi + Math.imul(ah3, bh6)) | 0;
		    lo = (lo + Math.imul(al2, bl7)) | 0;
		    mid = (mid + Math.imul(al2, bh7)) | 0;
		    mid = (mid + Math.imul(ah2, bl7)) | 0;
		    hi = (hi + Math.imul(ah2, bh7)) | 0;
		    lo = (lo + Math.imul(al1, bl8)) | 0;
		    mid = (mid + Math.imul(al1, bh8)) | 0;
		    mid = (mid + Math.imul(ah1, bl8)) | 0;
		    hi = (hi + Math.imul(ah1, bh8)) | 0;
		    lo = (lo + Math.imul(al0, bl9)) | 0;
		    mid = (mid + Math.imul(al0, bh9)) | 0;
		    mid = (mid + Math.imul(ah0, bl9)) | 0;
		    hi = (hi + Math.imul(ah0, bh9)) | 0;
		    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
		    w9 &= 0x3ffffff;
		    /* k = 10 */
		    lo = Math.imul(al9, bl1);
		    mid = Math.imul(al9, bh1);
		    mid = (mid + Math.imul(ah9, bl1)) | 0;
		    hi = Math.imul(ah9, bh1);
		    lo = (lo + Math.imul(al8, bl2)) | 0;
		    mid = (mid + Math.imul(al8, bh2)) | 0;
		    mid = (mid + Math.imul(ah8, bl2)) | 0;
		    hi = (hi + Math.imul(ah8, bh2)) | 0;
		    lo = (lo + Math.imul(al7, bl3)) | 0;
		    mid = (mid + Math.imul(al7, bh3)) | 0;
		    mid = (mid + Math.imul(ah7, bl3)) | 0;
		    hi = (hi + Math.imul(ah7, bh3)) | 0;
		    lo = (lo + Math.imul(al6, bl4)) | 0;
		    mid = (mid + Math.imul(al6, bh4)) | 0;
		    mid = (mid + Math.imul(ah6, bl4)) | 0;
		    hi = (hi + Math.imul(ah6, bh4)) | 0;
		    lo = (lo + Math.imul(al5, bl5)) | 0;
		    mid = (mid + Math.imul(al5, bh5)) | 0;
		    mid = (mid + Math.imul(ah5, bl5)) | 0;
		    hi = (hi + Math.imul(ah5, bh5)) | 0;
		    lo = (lo + Math.imul(al4, bl6)) | 0;
		    mid = (mid + Math.imul(al4, bh6)) | 0;
		    mid = (mid + Math.imul(ah4, bl6)) | 0;
		    hi = (hi + Math.imul(ah4, bh6)) | 0;
		    lo = (lo + Math.imul(al3, bl7)) | 0;
		    mid = (mid + Math.imul(al3, bh7)) | 0;
		    mid = (mid + Math.imul(ah3, bl7)) | 0;
		    hi = (hi + Math.imul(ah3, bh7)) | 0;
		    lo = (lo + Math.imul(al2, bl8)) | 0;
		    mid = (mid + Math.imul(al2, bh8)) | 0;
		    mid = (mid + Math.imul(ah2, bl8)) | 0;
		    hi = (hi + Math.imul(ah2, bh8)) | 0;
		    lo = (lo + Math.imul(al1, bl9)) | 0;
		    mid = (mid + Math.imul(al1, bh9)) | 0;
		    mid = (mid + Math.imul(ah1, bl9)) | 0;
		    hi = (hi + Math.imul(ah1, bh9)) | 0;
		    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
		    w10 &= 0x3ffffff;
		    /* k = 11 */
		    lo = Math.imul(al9, bl2);
		    mid = Math.imul(al9, bh2);
		    mid = (mid + Math.imul(ah9, bl2)) | 0;
		    hi = Math.imul(ah9, bh2);
		    lo = (lo + Math.imul(al8, bl3)) | 0;
		    mid = (mid + Math.imul(al8, bh3)) | 0;
		    mid = (mid + Math.imul(ah8, bl3)) | 0;
		    hi = (hi + Math.imul(ah8, bh3)) | 0;
		    lo = (lo + Math.imul(al7, bl4)) | 0;
		    mid = (mid + Math.imul(al7, bh4)) | 0;
		    mid = (mid + Math.imul(ah7, bl4)) | 0;
		    hi = (hi + Math.imul(ah7, bh4)) | 0;
		    lo = (lo + Math.imul(al6, bl5)) | 0;
		    mid = (mid + Math.imul(al6, bh5)) | 0;
		    mid = (mid + Math.imul(ah6, bl5)) | 0;
		    hi = (hi + Math.imul(ah6, bh5)) | 0;
		    lo = (lo + Math.imul(al5, bl6)) | 0;
		    mid = (mid + Math.imul(al5, bh6)) | 0;
		    mid = (mid + Math.imul(ah5, bl6)) | 0;
		    hi = (hi + Math.imul(ah5, bh6)) | 0;
		    lo = (lo + Math.imul(al4, bl7)) | 0;
		    mid = (mid + Math.imul(al4, bh7)) | 0;
		    mid = (mid + Math.imul(ah4, bl7)) | 0;
		    hi = (hi + Math.imul(ah4, bh7)) | 0;
		    lo = (lo + Math.imul(al3, bl8)) | 0;
		    mid = (mid + Math.imul(al3, bh8)) | 0;
		    mid = (mid + Math.imul(ah3, bl8)) | 0;
		    hi = (hi + Math.imul(ah3, bh8)) | 0;
		    lo = (lo + Math.imul(al2, bl9)) | 0;
		    mid = (mid + Math.imul(al2, bh9)) | 0;
		    mid = (mid + Math.imul(ah2, bl9)) | 0;
		    hi = (hi + Math.imul(ah2, bh9)) | 0;
		    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
		    w11 &= 0x3ffffff;
		    /* k = 12 */
		    lo = Math.imul(al9, bl3);
		    mid = Math.imul(al9, bh3);
		    mid = (mid + Math.imul(ah9, bl3)) | 0;
		    hi = Math.imul(ah9, bh3);
		    lo = (lo + Math.imul(al8, bl4)) | 0;
		    mid = (mid + Math.imul(al8, bh4)) | 0;
		    mid = (mid + Math.imul(ah8, bl4)) | 0;
		    hi = (hi + Math.imul(ah8, bh4)) | 0;
		    lo = (lo + Math.imul(al7, bl5)) | 0;
		    mid = (mid + Math.imul(al7, bh5)) | 0;
		    mid = (mid + Math.imul(ah7, bl5)) | 0;
		    hi = (hi + Math.imul(ah7, bh5)) | 0;
		    lo = (lo + Math.imul(al6, bl6)) | 0;
		    mid = (mid + Math.imul(al6, bh6)) | 0;
		    mid = (mid + Math.imul(ah6, bl6)) | 0;
		    hi = (hi + Math.imul(ah6, bh6)) | 0;
		    lo = (lo + Math.imul(al5, bl7)) | 0;
		    mid = (mid + Math.imul(al5, bh7)) | 0;
		    mid = (mid + Math.imul(ah5, bl7)) | 0;
		    hi = (hi + Math.imul(ah5, bh7)) | 0;
		    lo = (lo + Math.imul(al4, bl8)) | 0;
		    mid = (mid + Math.imul(al4, bh8)) | 0;
		    mid = (mid + Math.imul(ah4, bl8)) | 0;
		    hi = (hi + Math.imul(ah4, bh8)) | 0;
		    lo = (lo + Math.imul(al3, bl9)) | 0;
		    mid = (mid + Math.imul(al3, bh9)) | 0;
		    mid = (mid + Math.imul(ah3, bl9)) | 0;
		    hi = (hi + Math.imul(ah3, bh9)) | 0;
		    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
		    w12 &= 0x3ffffff;
		    /* k = 13 */
		    lo = Math.imul(al9, bl4);
		    mid = Math.imul(al9, bh4);
		    mid = (mid + Math.imul(ah9, bl4)) | 0;
		    hi = Math.imul(ah9, bh4);
		    lo = (lo + Math.imul(al8, bl5)) | 0;
		    mid = (mid + Math.imul(al8, bh5)) | 0;
		    mid = (mid + Math.imul(ah8, bl5)) | 0;
		    hi = (hi + Math.imul(ah8, bh5)) | 0;
		    lo = (lo + Math.imul(al7, bl6)) | 0;
		    mid = (mid + Math.imul(al7, bh6)) | 0;
		    mid = (mid + Math.imul(ah7, bl6)) | 0;
		    hi = (hi + Math.imul(ah7, bh6)) | 0;
		    lo = (lo + Math.imul(al6, bl7)) | 0;
		    mid = (mid + Math.imul(al6, bh7)) | 0;
		    mid = (mid + Math.imul(ah6, bl7)) | 0;
		    hi = (hi + Math.imul(ah6, bh7)) | 0;
		    lo = (lo + Math.imul(al5, bl8)) | 0;
		    mid = (mid + Math.imul(al5, bh8)) | 0;
		    mid = (mid + Math.imul(ah5, bl8)) | 0;
		    hi = (hi + Math.imul(ah5, bh8)) | 0;
		    lo = (lo + Math.imul(al4, bl9)) | 0;
		    mid = (mid + Math.imul(al4, bh9)) | 0;
		    mid = (mid + Math.imul(ah4, bl9)) | 0;
		    hi = (hi + Math.imul(ah4, bh9)) | 0;
		    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
		    w13 &= 0x3ffffff;
		    /* k = 14 */
		    lo = Math.imul(al9, bl5);
		    mid = Math.imul(al9, bh5);
		    mid = (mid + Math.imul(ah9, bl5)) | 0;
		    hi = Math.imul(ah9, bh5);
		    lo = (lo + Math.imul(al8, bl6)) | 0;
		    mid = (mid + Math.imul(al8, bh6)) | 0;
		    mid = (mid + Math.imul(ah8, bl6)) | 0;
		    hi = (hi + Math.imul(ah8, bh6)) | 0;
		    lo = (lo + Math.imul(al7, bl7)) | 0;
		    mid = (mid + Math.imul(al7, bh7)) | 0;
		    mid = (mid + Math.imul(ah7, bl7)) | 0;
		    hi = (hi + Math.imul(ah7, bh7)) | 0;
		    lo = (lo + Math.imul(al6, bl8)) | 0;
		    mid = (mid + Math.imul(al6, bh8)) | 0;
		    mid = (mid + Math.imul(ah6, bl8)) | 0;
		    hi = (hi + Math.imul(ah6, bh8)) | 0;
		    lo = (lo + Math.imul(al5, bl9)) | 0;
		    mid = (mid + Math.imul(al5, bh9)) | 0;
		    mid = (mid + Math.imul(ah5, bl9)) | 0;
		    hi = (hi + Math.imul(ah5, bh9)) | 0;
		    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
		    w14 &= 0x3ffffff;
		    /* k = 15 */
		    lo = Math.imul(al9, bl6);
		    mid = Math.imul(al9, bh6);
		    mid = (mid + Math.imul(ah9, bl6)) | 0;
		    hi = Math.imul(ah9, bh6);
		    lo = (lo + Math.imul(al8, bl7)) | 0;
		    mid = (mid + Math.imul(al8, bh7)) | 0;
		    mid = (mid + Math.imul(ah8, bl7)) | 0;
		    hi = (hi + Math.imul(ah8, bh7)) | 0;
		    lo = (lo + Math.imul(al7, bl8)) | 0;
		    mid = (mid + Math.imul(al7, bh8)) | 0;
		    mid = (mid + Math.imul(ah7, bl8)) | 0;
		    hi = (hi + Math.imul(ah7, bh8)) | 0;
		    lo = (lo + Math.imul(al6, bl9)) | 0;
		    mid = (mid + Math.imul(al6, bh9)) | 0;
		    mid = (mid + Math.imul(ah6, bl9)) | 0;
		    hi = (hi + Math.imul(ah6, bh9)) | 0;
		    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
		    w15 &= 0x3ffffff;
		    /* k = 16 */
		    lo = Math.imul(al9, bl7);
		    mid = Math.imul(al9, bh7);
		    mid = (mid + Math.imul(ah9, bl7)) | 0;
		    hi = Math.imul(ah9, bh7);
		    lo = (lo + Math.imul(al8, bl8)) | 0;
		    mid = (mid + Math.imul(al8, bh8)) | 0;
		    mid = (mid + Math.imul(ah8, bl8)) | 0;
		    hi = (hi + Math.imul(ah8, bh8)) | 0;
		    lo = (lo + Math.imul(al7, bl9)) | 0;
		    mid = (mid + Math.imul(al7, bh9)) | 0;
		    mid = (mid + Math.imul(ah7, bl9)) | 0;
		    hi = (hi + Math.imul(ah7, bh9)) | 0;
		    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
		    w16 &= 0x3ffffff;
		    /* k = 17 */
		    lo = Math.imul(al9, bl8);
		    mid = Math.imul(al9, bh8);
		    mid = (mid + Math.imul(ah9, bl8)) | 0;
		    hi = Math.imul(ah9, bh8);
		    lo = (lo + Math.imul(al8, bl9)) | 0;
		    mid = (mid + Math.imul(al8, bh9)) | 0;
		    mid = (mid + Math.imul(ah8, bl9)) | 0;
		    hi = (hi + Math.imul(ah8, bh9)) | 0;
		    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
		    w17 &= 0x3ffffff;
		    /* k = 18 */
		    lo = Math.imul(al9, bl9);
		    mid = Math.imul(al9, bh9);
		    mid = (mid + Math.imul(ah9, bl9)) | 0;
		    hi = Math.imul(ah9, bh9);
		    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
		    w18 &= 0x3ffffff;
		    o[0] = w0;
		    o[1] = w1;
		    o[2] = w2;
		    o[3] = w3;
		    o[4] = w4;
		    o[5] = w5;
		    o[6] = w6;
		    o[7] = w7;
		    o[8] = w8;
		    o[9] = w9;
		    o[10] = w10;
		    o[11] = w11;
		    o[12] = w12;
		    o[13] = w13;
		    o[14] = w14;
		    o[15] = w15;
		    o[16] = w16;
		    o[17] = w17;
		    o[18] = w18;
		    if (c !== 0) {
		      o[19] = c;
		      out.length++;
		    }
		    return out;
		  };

		  // Polyfill comb
		  if (!Math.imul) {
		    comb10MulTo = smallMulTo;
		  }

		  function bigMulTo (self, num, out) {
		    out.negative = num.negative ^ self.negative;
		    out.length = self.length + num.length;

		    var carry = 0;
		    var hncarry = 0;
		    for (var k = 0; k < out.length - 1; k++) {
		      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
		      // note that ncarry could be >= 0x3ffffff
		      var ncarry = hncarry;
		      hncarry = 0;
		      var rword = carry & 0x3ffffff;
		      var maxJ = Math.min(k, num.length - 1);
		      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
		        var i = k - j;
		        var a = self.words[i] | 0;
		        var b = num.words[j] | 0;
		        var r = a * b;

		        var lo = r & 0x3ffffff;
		        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
		        lo = (lo + rword) | 0;
		        rword = lo & 0x3ffffff;
		        ncarry = (ncarry + (lo >>> 26)) | 0;

		        hncarry += ncarry >>> 26;
		        ncarry &= 0x3ffffff;
		      }
		      out.words[k] = rword;
		      carry = ncarry;
		      ncarry = hncarry;
		    }
		    if (carry !== 0) {
		      out.words[k] = carry;
		    } else {
		      out.length--;
		    }

		    return out._strip();
		  }

		  function jumboMulTo (self, num, out) {
		    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
		    // var fftm = new FFTM();
		    // return fftm.mulp(self, num, out);
		    return bigMulTo(self, num, out);
		  }

		  BN.prototype.mulTo = function mulTo (num, out) {
		    var res;
		    var len = this.length + num.length;
		    if (this.length === 10 && num.length === 10) {
		      res = comb10MulTo(this, num, out);
		    } else if (len < 63) {
		      res = smallMulTo(this, num, out);
		    } else if (len < 1024) {
		      res = bigMulTo(this, num, out);
		    } else {
		      res = jumboMulTo(this, num, out);
		    }

		    return res;
		  };

		  // Multiply `this` by `num`
		  BN.prototype.mul = function mul (num) {
		    var out = new BN(null);
		    out.words = new Array(this.length + num.length);
		    return this.mulTo(num, out);
		  };

		  // Multiply employing FFT
		  BN.prototype.mulf = function mulf (num) {
		    var out = new BN(null);
		    out.words = new Array(this.length + num.length);
		    return jumboMulTo(this, num, out);
		  };

		  // In-place Multiplication
		  BN.prototype.imul = function imul (num) {
		    return this.clone().mulTo(num, this);
		  };

		  BN.prototype.imuln = function imuln (num) {
		    var isNegNum = num < 0;
		    if (isNegNum) num = -num;

		    assert(typeof num === 'number');
		    assert(num < 0x4000000);

		    // Carry
		    var carry = 0;
		    for (var i = 0; i < this.length; i++) {
		      var w = (this.words[i] | 0) * num;
		      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
		      carry >>= 26;
		      carry += (w / 0x4000000) | 0;
		      // NOTE: lo is 27bit maximum
		      carry += lo >>> 26;
		      this.words[i] = lo & 0x3ffffff;
		    }

		    if (carry !== 0) {
		      this.words[i] = carry;
		      this.length++;
		    }

		    return isNegNum ? this.ineg() : this;
		  };

		  BN.prototype.muln = function muln (num) {
		    return this.clone().imuln(num);
		  };

		  // `this` * `this`
		  BN.prototype.sqr = function sqr () {
		    return this.mul(this);
		  };

		  // `this` * `this` in-place
		  BN.prototype.isqr = function isqr () {
		    return this.imul(this.clone());
		  };

		  // Math.pow(`this`, `num`)
		  BN.prototype.pow = function pow (num) {
		    var w = toBitArray(num);
		    if (w.length === 0) return new BN(1);

		    // Skip leading zeroes
		    var res = this;
		    for (var i = 0; i < w.length; i++, res = res.sqr()) {
		      if (w[i] !== 0) break;
		    }

		    if (++i < w.length) {
		      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
		        if (w[i] === 0) continue;

		        res = res.mul(q);
		      }
		    }

		    return res;
		  };

		  // Shift-left in-place
		  BN.prototype.iushln = function iushln (bits) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var r = bits % 26;
		    var s = (bits - r) / 26;
		    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
		    var i;

		    if (r !== 0) {
		      var carry = 0;

		      for (i = 0; i < this.length; i++) {
		        var newCarry = this.words[i] & carryMask;
		        var c = ((this.words[i] | 0) - newCarry) << r;
		        this.words[i] = c | carry;
		        carry = newCarry >>> (26 - r);
		      }

		      if (carry) {
		        this.words[i] = carry;
		        this.length++;
		      }
		    }

		    if (s !== 0) {
		      for (i = this.length - 1; i >= 0; i--) {
		        this.words[i + s] = this.words[i];
		      }

		      for (i = 0; i < s; i++) {
		        this.words[i] = 0;
		      }

		      this.length += s;
		    }

		    return this._strip();
		  };

		  BN.prototype.ishln = function ishln (bits) {
		    // TODO(indutny): implement me
		    assert(this.negative === 0);
		    return this.iushln(bits);
		  };

		  // Shift-right in-place
		  // NOTE: `hint` is a lowest bit before trailing zeroes
		  // NOTE: if `extended` is present - it will be filled with destroyed bits
		  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var h;
		    if (hint) {
		      h = (hint - (hint % 26)) / 26;
		    } else {
		      h = 0;
		    }

		    var r = bits % 26;
		    var s = Math.min((bits - r) / 26, this.length);
		    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
		    var maskedWords = extended;

		    h -= s;
		    h = Math.max(0, h);

		    // Extended mode, copy masked part
		    if (maskedWords) {
		      for (var i = 0; i < s; i++) {
		        maskedWords.words[i] = this.words[i];
		      }
		      maskedWords.length = s;
		    }

		    if (s === 0) ; else if (this.length > s) {
		      this.length -= s;
		      for (i = 0; i < this.length; i++) {
		        this.words[i] = this.words[i + s];
		      }
		    } else {
		      this.words[0] = 0;
		      this.length = 1;
		    }

		    var carry = 0;
		    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
		      var word = this.words[i] | 0;
		      this.words[i] = (carry << (26 - r)) | (word >>> r);
		      carry = word & mask;
		    }

		    // Push carried bits as a mask
		    if (maskedWords && carry !== 0) {
		      maskedWords.words[maskedWords.length++] = carry;
		    }

		    if (this.length === 0) {
		      this.words[0] = 0;
		      this.length = 1;
		    }

		    return this._strip();
		  };

		  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
		    // TODO(indutny): implement me
		    assert(this.negative === 0);
		    return this.iushrn(bits, hint, extended);
		  };

		  // Shift-left
		  BN.prototype.shln = function shln (bits) {
		    return this.clone().ishln(bits);
		  };

		  BN.prototype.ushln = function ushln (bits) {
		    return this.clone().iushln(bits);
		  };

		  // Shift-right
		  BN.prototype.shrn = function shrn (bits) {
		    return this.clone().ishrn(bits);
		  };

		  BN.prototype.ushrn = function ushrn (bits) {
		    return this.clone().iushrn(bits);
		  };

		  // Test if n bit is set
		  BN.prototype.testn = function testn (bit) {
		    assert(typeof bit === 'number' && bit >= 0);
		    var r = bit % 26;
		    var s = (bit - r) / 26;
		    var q = 1 << r;

		    // Fast case: bit is much higher than all existing words
		    if (this.length <= s) return false;

		    // Check bit and return
		    var w = this.words[s];

		    return !!(w & q);
		  };

		  // Return only lowers bits of number (in-place)
		  BN.prototype.imaskn = function imaskn (bits) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var r = bits % 26;
		    var s = (bits - r) / 26;

		    assert(this.negative === 0, 'imaskn works only with positive numbers');

		    if (this.length <= s) {
		      return this;
		    }

		    if (r !== 0) {
		      s++;
		    }
		    this.length = Math.min(s, this.length);

		    if (r !== 0) {
		      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
		      this.words[this.length - 1] &= mask;
		    }

		    return this._strip();
		  };

		  // Return only lowers bits of number
		  BN.prototype.maskn = function maskn (bits) {
		    return this.clone().imaskn(bits);
		  };

		  // Add plain number `num` to `this`
		  BN.prototype.iaddn = function iaddn (num) {
		    assert(typeof num === 'number');
		    assert(num < 0x4000000);
		    if (num < 0) return this.isubn(-num);

		    // Possible sign change
		    if (this.negative !== 0) {
		      if (this.length === 1 && (this.words[0] | 0) <= num) {
		        this.words[0] = num - (this.words[0] | 0);
		        this.negative = 0;
		        return this;
		      }

		      this.negative = 0;
		      this.isubn(num);
		      this.negative = 1;
		      return this;
		    }

		    // Add without checks
		    return this._iaddn(num);
		  };

		  BN.prototype._iaddn = function _iaddn (num) {
		    this.words[0] += num;

		    // Carry
		    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
		      this.words[i] -= 0x4000000;
		      if (i === this.length - 1) {
		        this.words[i + 1] = 1;
		      } else {
		        this.words[i + 1]++;
		      }
		    }
		    this.length = Math.max(this.length, i + 1);

		    return this;
		  };

		  // Subtract plain number `num` from `this`
		  BN.prototype.isubn = function isubn (num) {
		    assert(typeof num === 'number');
		    assert(num < 0x4000000);
		    if (num < 0) return this.iaddn(-num);

		    if (this.negative !== 0) {
		      this.negative = 0;
		      this.iaddn(num);
		      this.negative = 1;
		      return this;
		    }

		    this.words[0] -= num;

		    if (this.length === 1 && this.words[0] < 0) {
		      this.words[0] = -this.words[0];
		      this.negative = 1;
		    } else {
		      // Carry
		      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
		        this.words[i] += 0x4000000;
		        this.words[i + 1] -= 1;
		      }
		    }

		    return this._strip();
		  };

		  BN.prototype.addn = function addn (num) {
		    return this.clone().iaddn(num);
		  };

		  BN.prototype.subn = function subn (num) {
		    return this.clone().isubn(num);
		  };

		  BN.prototype.iabs = function iabs () {
		    this.negative = 0;

		    return this;
		  };

		  BN.prototype.abs = function abs () {
		    return this.clone().iabs();
		  };

		  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
		    var len = num.length + shift;
		    var i;

		    this._expand(len);

		    var w;
		    var carry = 0;
		    for (i = 0; i < num.length; i++) {
		      w = (this.words[i + shift] | 0) + carry;
		      var right = (num.words[i] | 0) * mul;
		      w -= right & 0x3ffffff;
		      carry = (w >> 26) - ((right / 0x4000000) | 0);
		      this.words[i + shift] = w & 0x3ffffff;
		    }
		    for (; i < this.length - shift; i++) {
		      w = (this.words[i + shift] | 0) + carry;
		      carry = w >> 26;
		      this.words[i + shift] = w & 0x3ffffff;
		    }

		    if (carry === 0) return this._strip();

		    // Subtraction overflow
		    assert(carry === -1);
		    carry = 0;
		    for (i = 0; i < this.length; i++) {
		      w = -(this.words[i] | 0) + carry;
		      carry = w >> 26;
		      this.words[i] = w & 0x3ffffff;
		    }
		    this.negative = 1;

		    return this._strip();
		  };

		  BN.prototype._wordDiv = function _wordDiv (num, mode) {
		    var shift = this.length - num.length;

		    var a = this.clone();
		    var b = num;

		    // Normalize
		    var bhi = b.words[b.length - 1] | 0;
		    var bhiBits = this._countBits(bhi);
		    shift = 26 - bhiBits;
		    if (shift !== 0) {
		      b = b.ushln(shift);
		      a.iushln(shift);
		      bhi = b.words[b.length - 1] | 0;
		    }

		    // Initialize quotient
		    var m = a.length - b.length;
		    var q;

		    if (mode !== 'mod') {
		      q = new BN(null);
		      q.length = m + 1;
		      q.words = new Array(q.length);
		      for (var i = 0; i < q.length; i++) {
		        q.words[i] = 0;
		      }
		    }

		    var diff = a.clone()._ishlnsubmul(b, 1, m);
		    if (diff.negative === 0) {
		      a = diff;
		      if (q) {
		        q.words[m] = 1;
		      }
		    }

		    for (var j = m - 1; j >= 0; j--) {
		      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
		        (a.words[b.length + j - 1] | 0);

		      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
		      // (0x7ffffff)
		      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

		      a._ishlnsubmul(b, qj, j);
		      while (a.negative !== 0) {
		        qj--;
		        a.negative = 0;
		        a._ishlnsubmul(b, 1, j);
		        if (!a.isZero()) {
		          a.negative ^= 1;
		        }
		      }
		      if (q) {
		        q.words[j] = qj;
		      }
		    }
		    if (q) {
		      q._strip();
		    }
		    a._strip();

		    // Denormalize
		    if (mode !== 'div' && shift !== 0) {
		      a.iushrn(shift);
		    }

		    return {
		      div: q || null,
		      mod: a
		    };
		  };

		  // NOTE: 1) `mode` can be set to `mod` to request mod only,
		  //       to `div` to request div only, or be absent to
		  //       request both div & mod
		  //       2) `positive` is true if unsigned mod is requested
		  BN.prototype.divmod = function divmod (num, mode, positive) {
		    assert(!num.isZero());

		    if (this.isZero()) {
		      return {
		        div: new BN(0),
		        mod: new BN(0)
		      };
		    }

		    var div, mod, res;
		    if (this.negative !== 0 && num.negative === 0) {
		      res = this.neg().divmod(num, mode);

		      if (mode !== 'mod') {
		        div = res.div.neg();
		      }

		      if (mode !== 'div') {
		        mod = res.mod.neg();
		        if (positive && mod.negative !== 0) {
		          mod.iadd(num);
		        }
		      }

		      return {
		        div: div,
		        mod: mod
		      };
		    }

		    if (this.negative === 0 && num.negative !== 0) {
		      res = this.divmod(num.neg(), mode);

		      if (mode !== 'mod') {
		        div = res.div.neg();
		      }

		      return {
		        div: div,
		        mod: res.mod
		      };
		    }

		    if ((this.negative & num.negative) !== 0) {
		      res = this.neg().divmod(num.neg(), mode);

		      if (mode !== 'div') {
		        mod = res.mod.neg();
		        if (positive && mod.negative !== 0) {
		          mod.isub(num);
		        }
		      }

		      return {
		        div: res.div,
		        mod: mod
		      };
		    }

		    // Both numbers are positive at this point

		    // Strip both numbers to approximate shift value
		    if (num.length > this.length || this.cmp(num) < 0) {
		      return {
		        div: new BN(0),
		        mod: this
		      };
		    }

		    // Very short reduction
		    if (num.length === 1) {
		      if (mode === 'div') {
		        return {
		          div: this.divn(num.words[0]),
		          mod: null
		        };
		      }

		      if (mode === 'mod') {
		        return {
		          div: null,
		          mod: new BN(this.modrn(num.words[0]))
		        };
		      }

		      return {
		        div: this.divn(num.words[0]),
		        mod: new BN(this.modrn(num.words[0]))
		      };
		    }

		    return this._wordDiv(num, mode);
		  };

		  // Find `this` / `num`
		  BN.prototype.div = function div (num) {
		    return this.divmod(num, 'div', false).div;
		  };

		  // Find `this` % `num`
		  BN.prototype.mod = function mod (num) {
		    return this.divmod(num, 'mod', false).mod;
		  };

		  BN.prototype.umod = function umod (num) {
		    return this.divmod(num, 'mod', true).mod;
		  };

		  // Find Round(`this` / `num`)
		  BN.prototype.divRound = function divRound (num) {
		    var dm = this.divmod(num);

		    // Fast case - exact division
		    if (dm.mod.isZero()) return dm.div;

		    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

		    var half = num.ushrn(1);
		    var r2 = num.andln(1);
		    var cmp = mod.cmp(half);

		    // Round down
		    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

		    // Round up
		    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
		  };

		  BN.prototype.modrn = function modrn (num) {
		    var isNegNum = num < 0;
		    if (isNegNum) num = -num;

		    assert(num <= 0x3ffffff);
		    var p = (1 << 26) % num;

		    var acc = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      acc = (p * acc + (this.words[i] | 0)) % num;
		    }

		    return isNegNum ? -acc : acc;
		  };

		  // WARNING: DEPRECATED
		  BN.prototype.modn = function modn (num) {
		    return this.modrn(num);
		  };

		  // In-place division by number
		  BN.prototype.idivn = function idivn (num) {
		    var isNegNum = num < 0;
		    if (isNegNum) num = -num;

		    assert(num <= 0x3ffffff);

		    var carry = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      var w = (this.words[i] | 0) + carry * 0x4000000;
		      this.words[i] = (w / num) | 0;
		      carry = w % num;
		    }

		    this._strip();
		    return isNegNum ? this.ineg() : this;
		  };

		  BN.prototype.divn = function divn (num) {
		    return this.clone().idivn(num);
		  };

		  BN.prototype.egcd = function egcd (p) {
		    assert(p.negative === 0);
		    assert(!p.isZero());

		    var x = this;
		    var y = p.clone();

		    if (x.negative !== 0) {
		      x = x.umod(p);
		    } else {
		      x = x.clone();
		    }

		    // A * x + B * y = x
		    var A = new BN(1);
		    var B = new BN(0);

		    // C * x + D * y = y
		    var C = new BN(0);
		    var D = new BN(1);

		    var g = 0;

		    while (x.isEven() && y.isEven()) {
		      x.iushrn(1);
		      y.iushrn(1);
		      ++g;
		    }

		    var yp = y.clone();
		    var xp = x.clone();

		    while (!x.isZero()) {
		      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
		      if (i > 0) {
		        x.iushrn(i);
		        while (i-- > 0) {
		          if (A.isOdd() || B.isOdd()) {
		            A.iadd(yp);
		            B.isub(xp);
		          }

		          A.iushrn(1);
		          B.iushrn(1);
		        }
		      }

		      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
		      if (j > 0) {
		        y.iushrn(j);
		        while (j-- > 0) {
		          if (C.isOdd() || D.isOdd()) {
		            C.iadd(yp);
		            D.isub(xp);
		          }

		          C.iushrn(1);
		          D.iushrn(1);
		        }
		      }

		      if (x.cmp(y) >= 0) {
		        x.isub(y);
		        A.isub(C);
		        B.isub(D);
		      } else {
		        y.isub(x);
		        C.isub(A);
		        D.isub(B);
		      }
		    }

		    return {
		      a: C,
		      b: D,
		      gcd: y.iushln(g)
		    };
		  };

		  // This is reduced incarnation of the binary EEA
		  // above, designated to invert members of the
		  // _prime_ fields F(p) at a maximal speed
		  BN.prototype._invmp = function _invmp (p) {
		    assert(p.negative === 0);
		    assert(!p.isZero());

		    var a = this;
		    var b = p.clone();

		    if (a.negative !== 0) {
		      a = a.umod(p);
		    } else {
		      a = a.clone();
		    }

		    var x1 = new BN(1);
		    var x2 = new BN(0);

		    var delta = b.clone();

		    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
		      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
		      if (i > 0) {
		        a.iushrn(i);
		        while (i-- > 0) {
		          if (x1.isOdd()) {
		            x1.iadd(delta);
		          }

		          x1.iushrn(1);
		        }
		      }

		      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
		      if (j > 0) {
		        b.iushrn(j);
		        while (j-- > 0) {
		          if (x2.isOdd()) {
		            x2.iadd(delta);
		          }

		          x2.iushrn(1);
		        }
		      }

		      if (a.cmp(b) >= 0) {
		        a.isub(b);
		        x1.isub(x2);
		      } else {
		        b.isub(a);
		        x2.isub(x1);
		      }
		    }

		    var res;
		    if (a.cmpn(1) === 0) {
		      res = x1;
		    } else {
		      res = x2;
		    }

		    if (res.cmpn(0) < 0) {
		      res.iadd(p);
		    }

		    return res;
		  };

		  BN.prototype.gcd = function gcd (num) {
		    if (this.isZero()) return num.abs();
		    if (num.isZero()) return this.abs();

		    var a = this.clone();
		    var b = num.clone();
		    a.negative = 0;
		    b.negative = 0;

		    // Remove common factor of two
		    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
		      a.iushrn(1);
		      b.iushrn(1);
		    }

		    do {
		      while (a.isEven()) {
		        a.iushrn(1);
		      }
		      while (b.isEven()) {
		        b.iushrn(1);
		      }

		      var r = a.cmp(b);
		      if (r < 0) {
		        // Swap `a` and `b` to make `a` always bigger than `b`
		        var t = a;
		        a = b;
		        b = t;
		      } else if (r === 0 || b.cmpn(1) === 0) {
		        break;
		      }

		      a.isub(b);
		    } while (true);

		    return b.iushln(shift);
		  };

		  // Invert number in the field F(num)
		  BN.prototype.invm = function invm (num) {
		    return this.egcd(num).a.umod(num);
		  };

		  BN.prototype.isEven = function isEven () {
		    return (this.words[0] & 1) === 0;
		  };

		  BN.prototype.isOdd = function isOdd () {
		    return (this.words[0] & 1) === 1;
		  };

		  // And first word and num
		  BN.prototype.andln = function andln (num) {
		    return this.words[0] & num;
		  };

		  // Increment at the bit position in-line
		  BN.prototype.bincn = function bincn (bit) {
		    assert(typeof bit === 'number');
		    var r = bit % 26;
		    var s = (bit - r) / 26;
		    var q = 1 << r;

		    // Fast case: bit is much higher than all existing words
		    if (this.length <= s) {
		      this._expand(s + 1);
		      this.words[s] |= q;
		      return this;
		    }

		    // Add bit and propagate, if needed
		    var carry = q;
		    for (var i = s; carry !== 0 && i < this.length; i++) {
		      var w = this.words[i] | 0;
		      w += carry;
		      carry = w >>> 26;
		      w &= 0x3ffffff;
		      this.words[i] = w;
		    }
		    if (carry !== 0) {
		      this.words[i] = carry;
		      this.length++;
		    }
		    return this;
		  };

		  BN.prototype.isZero = function isZero () {
		    return this.length === 1 && this.words[0] === 0;
		  };

		  BN.prototype.cmpn = function cmpn (num) {
		    var negative = num < 0;

		    if (this.negative !== 0 && !negative) return -1;
		    if (this.negative === 0 && negative) return 1;

		    this._strip();

		    var res;
		    if (this.length > 1) {
		      res = 1;
		    } else {
		      if (negative) {
		        num = -num;
		      }

		      assert(num <= 0x3ffffff, 'Number is too big');

		      var w = this.words[0] | 0;
		      res = w === num ? 0 : w < num ? -1 : 1;
		    }
		    if (this.negative !== 0) return -res | 0;
		    return res;
		  };

		  // Compare two numbers and return:
		  // 1 - if `this` > `num`
		  // 0 - if `this` == `num`
		  // -1 - if `this` < `num`
		  BN.prototype.cmp = function cmp (num) {
		    if (this.negative !== 0 && num.negative === 0) return -1;
		    if (this.negative === 0 && num.negative !== 0) return 1;

		    var res = this.ucmp(num);
		    if (this.negative !== 0) return -res | 0;
		    return res;
		  };

		  // Unsigned comparison
		  BN.prototype.ucmp = function ucmp (num) {
		    // At this point both numbers have the same sign
		    if (this.length > num.length) return 1;
		    if (this.length < num.length) return -1;

		    var res = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      var a = this.words[i] | 0;
		      var b = num.words[i] | 0;

		      if (a === b) continue;
		      if (a < b) {
		        res = -1;
		      } else if (a > b) {
		        res = 1;
		      }
		      break;
		    }
		    return res;
		  };

		  BN.prototype.gtn = function gtn (num) {
		    return this.cmpn(num) === 1;
		  };

		  BN.prototype.gt = function gt (num) {
		    return this.cmp(num) === 1;
		  };

		  BN.prototype.gten = function gten (num) {
		    return this.cmpn(num) >= 0;
		  };

		  BN.prototype.gte = function gte (num) {
		    return this.cmp(num) >= 0;
		  };

		  BN.prototype.ltn = function ltn (num) {
		    return this.cmpn(num) === -1;
		  };

		  BN.prototype.lt = function lt (num) {
		    return this.cmp(num) === -1;
		  };

		  BN.prototype.lten = function lten (num) {
		    return this.cmpn(num) <= 0;
		  };

		  BN.prototype.lte = function lte (num) {
		    return this.cmp(num) <= 0;
		  };

		  BN.prototype.eqn = function eqn (num) {
		    return this.cmpn(num) === 0;
		  };

		  BN.prototype.eq = function eq (num) {
		    return this.cmp(num) === 0;
		  };

		  //
		  // A reduce context, could be using montgomery or something better, depending
		  // on the `m` itself.
		  //
		  BN.red = function red (num) {
		    return new Red(num);
		  };

		  BN.prototype.toRed = function toRed (ctx) {
		    assert(!this.red, 'Already a number in reduction context');
		    assert(this.negative === 0, 'red works only with positives');
		    return ctx.convertTo(this)._forceRed(ctx);
		  };

		  BN.prototype.fromRed = function fromRed () {
		    assert(this.red, 'fromRed works only with numbers in reduction context');
		    return this.red.convertFrom(this);
		  };

		  BN.prototype._forceRed = function _forceRed (ctx) {
		    this.red = ctx;
		    return this;
		  };

		  BN.prototype.forceRed = function forceRed (ctx) {
		    assert(!this.red, 'Already a number in reduction context');
		    return this._forceRed(ctx);
		  };

		  BN.prototype.redAdd = function redAdd (num) {
		    assert(this.red, 'redAdd works only with red numbers');
		    return this.red.add(this, num);
		  };

		  BN.prototype.redIAdd = function redIAdd (num) {
		    assert(this.red, 'redIAdd works only with red numbers');
		    return this.red.iadd(this, num);
		  };

		  BN.prototype.redSub = function redSub (num) {
		    assert(this.red, 'redSub works only with red numbers');
		    return this.red.sub(this, num);
		  };

		  BN.prototype.redISub = function redISub (num) {
		    assert(this.red, 'redISub works only with red numbers');
		    return this.red.isub(this, num);
		  };

		  BN.prototype.redShl = function redShl (num) {
		    assert(this.red, 'redShl works only with red numbers');
		    return this.red.shl(this, num);
		  };

		  BN.prototype.redMul = function redMul (num) {
		    assert(this.red, 'redMul works only with red numbers');
		    this.red._verify2(this, num);
		    return this.red.mul(this, num);
		  };

		  BN.prototype.redIMul = function redIMul (num) {
		    assert(this.red, 'redMul works only with red numbers');
		    this.red._verify2(this, num);
		    return this.red.imul(this, num);
		  };

		  BN.prototype.redSqr = function redSqr () {
		    assert(this.red, 'redSqr works only with red numbers');
		    this.red._verify1(this);
		    return this.red.sqr(this);
		  };

		  BN.prototype.redISqr = function redISqr () {
		    assert(this.red, 'redISqr works only with red numbers');
		    this.red._verify1(this);
		    return this.red.isqr(this);
		  };

		  // Square root over p
		  BN.prototype.redSqrt = function redSqrt () {
		    assert(this.red, 'redSqrt works only with red numbers');
		    this.red._verify1(this);
		    return this.red.sqrt(this);
		  };

		  BN.prototype.redInvm = function redInvm () {
		    assert(this.red, 'redInvm works only with red numbers');
		    this.red._verify1(this);
		    return this.red.invm(this);
		  };

		  // Return negative clone of `this` % `red modulo`
		  BN.prototype.redNeg = function redNeg () {
		    assert(this.red, 'redNeg works only with red numbers');
		    this.red._verify1(this);
		    return this.red.neg(this);
		  };

		  BN.prototype.redPow = function redPow (num) {
		    assert(this.red && !num.red, 'redPow(normalNum)');
		    this.red._verify1(this);
		    return this.red.pow(this, num);
		  };

		  // Prime numbers with efficient reduction
		  var primes = {
		    k256: null,
		    p224: null,
		    p192: null,
		    p25519: null
		  };

		  // Pseudo-Mersenne prime
		  function MPrime (name, p) {
		    // P = 2 ^ N - K
		    this.name = name;
		    this.p = new BN(p, 16);
		    this.n = this.p.bitLength();
		    this.k = new BN(1).iushln(this.n).isub(this.p);

		    this.tmp = this._tmp();
		  }

		  MPrime.prototype._tmp = function _tmp () {
		    var tmp = new BN(null);
		    tmp.words = new Array(Math.ceil(this.n / 13));
		    return tmp;
		  };

		  MPrime.prototype.ireduce = function ireduce (num) {
		    // Assumes that `num` is less than `P^2`
		    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
		    var r = num;
		    var rlen;

		    do {
		      this.split(r, this.tmp);
		      r = this.imulK(r);
		      r = r.iadd(this.tmp);
		      rlen = r.bitLength();
		    } while (rlen > this.n);

		    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
		    if (cmp === 0) {
		      r.words[0] = 0;
		      r.length = 1;
		    } else if (cmp > 0) {
		      r.isub(this.p);
		    } else {
		      if (r.strip !== undefined) {
		        // r is a BN v4 instance
		        r.strip();
		      } else {
		        // r is a BN v5 instance
		        r._strip();
		      }
		    }

		    return r;
		  };

		  MPrime.prototype.split = function split (input, out) {
		    input.iushrn(this.n, 0, out);
		  };

		  MPrime.prototype.imulK = function imulK (num) {
		    return num.imul(this.k);
		  };

		  function K256 () {
		    MPrime.call(
		      this,
		      'k256',
		      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
		  }
		  inherits(K256, MPrime);

		  K256.prototype.split = function split (input, output) {
		    // 256 = 9 * 26 + 22
		    var mask = 0x3fffff;

		    var outLen = Math.min(input.length, 9);
		    for (var i = 0; i < outLen; i++) {
		      output.words[i] = input.words[i];
		    }
		    output.length = outLen;

		    if (input.length <= 9) {
		      input.words[0] = 0;
		      input.length = 1;
		      return;
		    }

		    // Shift by 9 limbs
		    var prev = input.words[9];
		    output.words[output.length++] = prev & mask;

		    for (i = 10; i < input.length; i++) {
		      var next = input.words[i] | 0;
		      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
		      prev = next;
		    }
		    prev >>>= 22;
		    input.words[i - 10] = prev;
		    if (prev === 0 && input.length > 10) {
		      input.length -= 10;
		    } else {
		      input.length -= 9;
		    }
		  };

		  K256.prototype.imulK = function imulK (num) {
		    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
		    num.words[num.length] = 0;
		    num.words[num.length + 1] = 0;
		    num.length += 2;

		    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
		    var lo = 0;
		    for (var i = 0; i < num.length; i++) {
		      var w = num.words[i] | 0;
		      lo += w * 0x3d1;
		      num.words[i] = lo & 0x3ffffff;
		      lo = w * 0x40 + ((lo / 0x4000000) | 0);
		    }

		    // Fast length reduction
		    if (num.words[num.length - 1] === 0) {
		      num.length--;
		      if (num.words[num.length - 1] === 0) {
		        num.length--;
		      }
		    }
		    return num;
		  };

		  function P224 () {
		    MPrime.call(
		      this,
		      'p224',
		      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
		  }
		  inherits(P224, MPrime);

		  function P192 () {
		    MPrime.call(
		      this,
		      'p192',
		      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
		  }
		  inherits(P192, MPrime);

		  function P25519 () {
		    // 2 ^ 255 - 19
		    MPrime.call(
		      this,
		      '25519',
		      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
		  }
		  inherits(P25519, MPrime);

		  P25519.prototype.imulK = function imulK (num) {
		    // K = 0x13
		    var carry = 0;
		    for (var i = 0; i < num.length; i++) {
		      var hi = (num.words[i] | 0) * 0x13 + carry;
		      var lo = hi & 0x3ffffff;
		      hi >>>= 26;

		      num.words[i] = lo;
		      carry = hi;
		    }
		    if (carry !== 0) {
		      num.words[num.length++] = carry;
		    }
		    return num;
		  };

		  // Exported mostly for testing purposes, use plain name instead
		  BN._prime = function prime (name) {
		    // Cached version of prime
		    if (primes[name]) return primes[name];

		    var prime;
		    if (name === 'k256') {
		      prime = new K256();
		    } else if (name === 'p224') {
		      prime = new P224();
		    } else if (name === 'p192') {
		      prime = new P192();
		    } else if (name === 'p25519') {
		      prime = new P25519();
		    } else {
		      throw new Error('Unknown prime ' + name);
		    }
		    primes[name] = prime;

		    return prime;
		  };

		  //
		  // Base reduction engine
		  //
		  function Red (m) {
		    if (typeof m === 'string') {
		      var prime = BN._prime(m);
		      this.m = prime.p;
		      this.prime = prime;
		    } else {
		      assert(m.gtn(1), 'modulus must be greater than 1');
		      this.m = m;
		      this.prime = null;
		    }
		  }

		  Red.prototype._verify1 = function _verify1 (a) {
		    assert(a.negative === 0, 'red works only with positives');
		    assert(a.red, 'red works only with red numbers');
		  };

		  Red.prototype._verify2 = function _verify2 (a, b) {
		    assert((a.negative | b.negative) === 0, 'red works only with positives');
		    assert(a.red && a.red === b.red,
		      'red works only with red numbers');
		  };

		  Red.prototype.imod = function imod (a) {
		    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

		    move(a, a.umod(this.m)._forceRed(this));
		    return a;
		  };

		  Red.prototype.neg = function neg (a) {
		    if (a.isZero()) {
		      return a.clone();
		    }

		    return this.m.sub(a)._forceRed(this);
		  };

		  Red.prototype.add = function add (a, b) {
		    this._verify2(a, b);

		    var res = a.add(b);
		    if (res.cmp(this.m) >= 0) {
		      res.isub(this.m);
		    }
		    return res._forceRed(this);
		  };

		  Red.prototype.iadd = function iadd (a, b) {
		    this._verify2(a, b);

		    var res = a.iadd(b);
		    if (res.cmp(this.m) >= 0) {
		      res.isub(this.m);
		    }
		    return res;
		  };

		  Red.prototype.sub = function sub (a, b) {
		    this._verify2(a, b);

		    var res = a.sub(b);
		    if (res.cmpn(0) < 0) {
		      res.iadd(this.m);
		    }
		    return res._forceRed(this);
		  };

		  Red.prototype.isub = function isub (a, b) {
		    this._verify2(a, b);

		    var res = a.isub(b);
		    if (res.cmpn(0) < 0) {
		      res.iadd(this.m);
		    }
		    return res;
		  };

		  Red.prototype.shl = function shl (a, num) {
		    this._verify1(a);
		    return this.imod(a.ushln(num));
		  };

		  Red.prototype.imul = function imul (a, b) {
		    this._verify2(a, b);
		    return this.imod(a.imul(b));
		  };

		  Red.prototype.mul = function mul (a, b) {
		    this._verify2(a, b);
		    return this.imod(a.mul(b));
		  };

		  Red.prototype.isqr = function isqr (a) {
		    return this.imul(a, a.clone());
		  };

		  Red.prototype.sqr = function sqr (a) {
		    return this.mul(a, a);
		  };

		  Red.prototype.sqrt = function sqrt (a) {
		    if (a.isZero()) return a.clone();

		    var mod3 = this.m.andln(3);
		    assert(mod3 % 2 === 1);

		    // Fast case
		    if (mod3 === 3) {
		      var pow = this.m.add(new BN(1)).iushrn(2);
		      return this.pow(a, pow);
		    }

		    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
		    //
		    // Find Q and S, that Q * 2 ^ S = (P - 1)
		    var q = this.m.subn(1);
		    var s = 0;
		    while (!q.isZero() && q.andln(1) === 0) {
		      s++;
		      q.iushrn(1);
		    }
		    assert(!q.isZero());

		    var one = new BN(1).toRed(this);
		    var nOne = one.redNeg();

		    // Find quadratic non-residue
		    // NOTE: Max is such because of generalized Riemann hypothesis.
		    var lpow = this.m.subn(1).iushrn(1);
		    var z = this.m.bitLength();
		    z = new BN(2 * z * z).toRed(this);

		    while (this.pow(z, lpow).cmp(nOne) !== 0) {
		      z.redIAdd(nOne);
		    }

		    var c = this.pow(z, q);
		    var r = this.pow(a, q.addn(1).iushrn(1));
		    var t = this.pow(a, q);
		    var m = s;
		    while (t.cmp(one) !== 0) {
		      var tmp = t;
		      for (var i = 0; tmp.cmp(one) !== 0; i++) {
		        tmp = tmp.redSqr();
		      }
		      assert(i < m);
		      var b = this.pow(c, new BN(1).iushln(m - i - 1));

		      r = r.redMul(b);
		      c = b.redSqr();
		      t = t.redMul(c);
		      m = i;
		    }

		    return r;
		  };

		  Red.prototype.invm = function invm (a) {
		    var inv = a._invmp(this.m);
		    if (inv.negative !== 0) {
		      inv.negative = 0;
		      return this.imod(inv).redNeg();
		    } else {
		      return this.imod(inv);
		    }
		  };

		  Red.prototype.pow = function pow (a, num) {
		    if (num.isZero()) return new BN(1).toRed(this);
		    if (num.cmpn(1) === 0) return a.clone();

		    var windowSize = 4;
		    var wnd = new Array(1 << windowSize);
		    wnd[0] = new BN(1).toRed(this);
		    wnd[1] = a;
		    for (var i = 2; i < wnd.length; i++) {
		      wnd[i] = this.mul(wnd[i - 1], a);
		    }

		    var res = wnd[0];
		    var current = 0;
		    var currentLen = 0;
		    var start = num.bitLength() % 26;
		    if (start === 0) {
		      start = 26;
		    }

		    for (i = num.length - 1; i >= 0; i--) {
		      var word = num.words[i];
		      for (var j = start - 1; j >= 0; j--) {
		        var bit = (word >> j) & 1;
		        if (res !== wnd[0]) {
		          res = this.sqr(res);
		        }

		        if (bit === 0 && current === 0) {
		          currentLen = 0;
		          continue;
		        }

		        current <<= 1;
		        current |= bit;
		        currentLen++;
		        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

		        res = this.mul(res, wnd[current]);
		        currentLen = 0;
		        current = 0;
		      }
		      start = 26;
		    }

		    return res;
		  };

		  Red.prototype.convertTo = function convertTo (num) {
		    var r = num.umod(this.m);

		    return r === num ? r.clone() : r;
		  };

		  Red.prototype.convertFrom = function convertFrom (num) {
		    var res = num.clone();
		    res.red = null;
		    return res;
		  };

		  //
		  // Montgomery method engine
		  //

		  BN.mont = function mont (num) {
		    return new Mont(num);
		  };

		  function Mont (m) {
		    Red.call(this, m);

		    this.shift = this.m.bitLength();
		    if (this.shift % 26 !== 0) {
		      this.shift += 26 - (this.shift % 26);
		    }

		    this.r = new BN(1).iushln(this.shift);
		    this.r2 = this.imod(this.r.sqr());
		    this.rinv = this.r._invmp(this.m);

		    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
		    this.minv = this.minv.umod(this.r);
		    this.minv = this.r.sub(this.minv);
		  }
		  inherits(Mont, Red);

		  Mont.prototype.convertTo = function convertTo (num) {
		    return this.imod(num.ushln(this.shift));
		  };

		  Mont.prototype.convertFrom = function convertFrom (num) {
		    var r = this.imod(num.mul(this.rinv));
		    r.red = null;
		    return r;
		  };

		  Mont.prototype.imul = function imul (a, b) {
		    if (a.isZero() || b.isZero()) {
		      a.words[0] = 0;
		      a.length = 1;
		      return a;
		    }

		    var t = a.imul(b);
		    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
		    var u = t.isub(c).iushrn(this.shift);
		    var res = u;

		    if (u.cmp(this.m) >= 0) {
		      res = u.isub(this.m);
		    } else if (u.cmpn(0) < 0) {
		      res = u.iadd(this.m);
		    }

		    return res._forceRed(this);
		  };

		  Mont.prototype.mul = function mul (a, b) {
		    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

		    var t = a.mul(b);
		    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
		    var u = t.isub(c).iushrn(this.shift);
		    var res = u;
		    if (u.cmp(this.m) >= 0) {
		      res = u.isub(this.m);
		    } else if (u.cmpn(0) < 0) {
		      res = u.iadd(this.m);
		    }

		    return res._forceRed(this);
		  };

		  Mont.prototype.invm = function invm (a) {
		    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
		    var res = this.imod(a._invmp(this.m).mul(this.r2));
		    return res._forceRed(this);
		  };
		})(module, commonjsGlobal); 
	} (bn$1));

	var bnExports$1 = bn$1.exports;
	var BN$b = /*@__PURE__*/getDefaultExportFromCjs(bnExports$1);

	const version$8 = "logger/5.7.0";

	let _permanentCensorErrors = false;
	let _censorErrors = false;
	const LogLevels = { debug: 1, "default": 2, info: 2, warning: 3, error: 4, off: 5 };
	let _logLevel = LogLevels["default"];
	let _globalLogger = null;
	function _checkNormalize() {
	    try {
	        const missing = [];
	        // Make sure all forms of normalization are supported
	        ["NFD", "NFC", "NFKD", "NFKC"].forEach((form) => {
	            try {
	                if ("test".normalize(form) !== "test") {
	                    throw new Error("bad normalize");
	                }
	                ;
	            }
	            catch (error) {
	                missing.push(form);
	            }
	        });
	        if (missing.length) {
	            throw new Error("missing " + missing.join(", "));
	        }
	        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) {
	            throw new Error("broken implementation");
	        }
	    }
	    catch (error) {
	        return error.message;
	    }
	    return null;
	}
	const _normalizeError = _checkNormalize();
	var LogLevel;
	(function (LogLevel) {
	    LogLevel["DEBUG"] = "DEBUG";
	    LogLevel["INFO"] = "INFO";
	    LogLevel["WARNING"] = "WARNING";
	    LogLevel["ERROR"] = "ERROR";
	    LogLevel["OFF"] = "OFF";
	})(LogLevel || (LogLevel = {}));
	var ErrorCode$1;
	(function (ErrorCode) {
	    ///////////////////
	    // Generic Errors
	    // Unknown Error
	    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
	    // Not Implemented
	    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
	    // Unsupported Operation
	    //   - operation
	    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
	    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
	    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
	    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
	    // Some sort of bad response from the server
	    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
	    // Timeout
	    ErrorCode["TIMEOUT"] = "TIMEOUT";
	    ///////////////////
	    // Operational  Errors
	    // Buffer Overrun
	    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
	    // Numeric Fault
	    //   - operation: the operation being executed
	    //   - fault: the reason this faulted
	    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
	    ///////////////////
	    // Argument Errors
	    // Missing new operator to an object
	    //  - name: The name of the class
	    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
	    // Invalid argument (e.g. value is incompatible with type) to a function:
	    //   - argument: The argument name that was invalid
	    //   - value: The value of the argument
	    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
	    // Missing argument to a function:
	    //   - count: The number of arguments received
	    //   - expectedCount: The number of arguments expected
	    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
	    // Too many arguments
	    //   - count: The number of arguments received
	    //   - expectedCount: The number of arguments expected
	    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
	    ///////////////////
	    // Blockchain Errors
	    // Call exception
	    //  - transaction: the transaction
	    //  - address?: the contract address
	    //  - args?: The arguments passed into the function
	    //  - method?: The Solidity method signature
	    //  - errorSignature?: The EIP848 error signature
	    //  - errorArgs?: The EIP848 error parameters
	    //  - reason: The reason (only for EIP848 "Error(string)")
	    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
	    // Insufficient funds (< value + gasLimit * gasPrice)
	    //   - transaction: the transaction attempted
	    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
	    // Nonce has already been used
	    //   - transaction: the transaction attempted
	    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
	    // The replacement fee for the transaction is too low
	    //   - transaction: the transaction attempted
	    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
	    // The gas limit could not be estimated
	    //   - transaction: the transaction passed to estimateGas
	    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
	    // The transaction was replaced by one with a higher gas price
	    //   - reason: "cancelled", "replaced" or "repriced"
	    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
	    //   - hash: original transaction hash
	    //   - replacement: the full TransactionsResponse for the replacement
	    //   - receipt: the receipt of the replacement
	    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
	    ///////////////////
	    // Interaction Errors
	    // The user rejected the action, such as signing a message or sending
	    // a transaction
	    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
	})(ErrorCode$1 || (ErrorCode$1 = {}));
	const HEX = "0123456789abcdef";
	class Logger {
	    constructor(version) {
	        Object.defineProperty(this, "version", {
	            enumerable: true,
	            value: version,
	            writable: false
	        });
	    }
	    _log(logLevel, args) {
	        const level = logLevel.toLowerCase();
	        if (LogLevels[level] == null) {
	            this.throwArgumentError("invalid log level name", "logLevel", logLevel);
	        }
	        if (_logLevel > LogLevels[level]) {
	            return;
	        }
	        console.log.apply(console, args);
	    }
	    debug(...args) {
	        this._log(Logger.levels.DEBUG, args);
	    }
	    info(...args) {
	        this._log(Logger.levels.INFO, args);
	    }
	    warn(...args) {
	        this._log(Logger.levels.WARNING, args);
	    }
	    makeError(message, code, params) {
	        // Errors are being censored
	        if (_censorErrors) {
	            return this.makeError("censored error", code, {});
	        }
	        if (!code) {
	            code = Logger.errors.UNKNOWN_ERROR;
	        }
	        if (!params) {
	            params = {};
	        }
	        const messageDetails = [];
	        Object.keys(params).forEach((key) => {
	            const value = params[key];
	            try {
	                if (value instanceof Uint8Array) {
	                    let hex = "";
	                    for (let i = 0; i < value.length; i++) {
	                        hex += HEX[value[i] >> 4];
	                        hex += HEX[value[i] & 0x0f];
	                    }
	                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
	                }
	                else {
	                    messageDetails.push(key + "=" + JSON.stringify(value));
	                }
	            }
	            catch (error) {
	                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
	            }
	        });
	        messageDetails.push(`code=${code}`);
	        messageDetails.push(`version=${this.version}`);
	        const reason = message;
	        let url = "";
	        switch (code) {
	            case ErrorCode$1.NUMERIC_FAULT: {
	                url = "NUMERIC_FAULT";
	                const fault = message;
	                switch (fault) {
	                    case "overflow":
	                    case "underflow":
	                    case "division-by-zero":
	                        url += "-" + fault;
	                        break;
	                    case "negative-power":
	                    case "negative-width":
	                        url += "-unsupported";
	                        break;
	                    case "unbound-bitwise-result":
	                        url += "-unbound-result";
	                        break;
	                }
	                break;
	            }
	            case ErrorCode$1.CALL_EXCEPTION:
	            case ErrorCode$1.INSUFFICIENT_FUNDS:
	            case ErrorCode$1.MISSING_NEW:
	            case ErrorCode$1.NONCE_EXPIRED:
	            case ErrorCode$1.REPLACEMENT_UNDERPRICED:
	            case ErrorCode$1.TRANSACTION_REPLACED:
	            case ErrorCode$1.UNPREDICTABLE_GAS_LIMIT:
	                url = code;
	                break;
	        }
	        if (url) {
	            message += " [ See: https:/\/links.ethers.org/v5-errors-" + url + " ]";
	        }
	        if (messageDetails.length) {
	            message += " (" + messageDetails.join(", ") + ")";
	        }
	        // @TODO: Any??
	        const error = new Error(message);
	        error.reason = reason;
	        error.code = code;
	        Object.keys(params).forEach(function (key) {
	            error[key] = params[key];
	        });
	        return error;
	    }
	    throwError(message, code, params) {
	        throw this.makeError(message, code, params);
	    }
	    throwArgumentError(message, name, value) {
	        return this.throwError(message, Logger.errors.INVALID_ARGUMENT, {
	            argument: name,
	            value: value
	        });
	    }
	    assert(condition, message, code, params) {
	        if (!!condition) {
	            return;
	        }
	        this.throwError(message, code, params);
	    }
	    assertArgument(condition, message, name, value) {
	        if (!!condition) {
	            return;
	        }
	        this.throwArgumentError(message, name, value);
	    }
	    checkNormalize(message) {
	        if (_normalizeError) {
	            this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
	                operation: "String.prototype.normalize", form: _normalizeError
	            });
	        }
	    }
	    checkSafeUint53(value, message) {
	        if (typeof (value) !== "number") {
	            return;
	        }
	        if (message == null) {
	            message = "value not safe";
	        }
	        if (value < 0 || value >= 0x1fffffffffffff) {
	            this.throwError(message, Logger.errors.NUMERIC_FAULT, {
	                operation: "checkSafeInteger",
	                fault: "out-of-safe-range",
	                value: value
	            });
	        }
	        if (value % 1) {
	            this.throwError(message, Logger.errors.NUMERIC_FAULT, {
	                operation: "checkSafeInteger",
	                fault: "non-integer",
	                value: value
	            });
	        }
	    }
	    checkArgumentCount(count, expectedCount, message) {
	        if (message) {
	            message = ": " + message;
	        }
	        else {
	            message = "";
	        }
	        if (count < expectedCount) {
	            this.throwError("missing argument" + message, Logger.errors.MISSING_ARGUMENT, {
	                count: count,
	                expectedCount: expectedCount
	            });
	        }
	        if (count > expectedCount) {
	            this.throwError("too many arguments" + message, Logger.errors.UNEXPECTED_ARGUMENT, {
	                count: count,
	                expectedCount: expectedCount
	            });
	        }
	    }
	    checkNew(target, kind) {
	        if (target === Object || target == null) {
	            this.throwError("missing new", Logger.errors.MISSING_NEW, { name: kind.name });
	        }
	    }
	    checkAbstract(target, kind) {
	        if (target === kind) {
	            this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, { name: target.name, operation: "new" });
	        }
	        else if (target === Object || target == null) {
	            this.throwError("missing new", Logger.errors.MISSING_NEW, { name: kind.name });
	        }
	    }
	    static globalLogger() {
	        if (!_globalLogger) {
	            _globalLogger = new Logger(version$8);
	        }
	        return _globalLogger;
	    }
	    static setCensorship(censorship, permanent) {
	        if (!censorship && permanent) {
	            this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
	                operation: "setCensorship"
	            });
	        }
	        if (_permanentCensorErrors) {
	            if (!censorship) {
	                return;
	            }
	            this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
	                operation: "setCensorship"
	            });
	        }
	        _censorErrors = !!censorship;
	        _permanentCensorErrors = !!permanent;
	    }
	    static setLogLevel(logLevel) {
	        const level = LogLevels[logLevel.toLowerCase()];
	        if (level == null) {
	            Logger.globalLogger().warn("invalid log level - " + logLevel);
	            return;
	        }
	        _logLevel = level;
	    }
	    static from(version) {
	        return new Logger(version);
	    }
	}
	Logger.errors = ErrorCode$1;
	Logger.levels = LogLevel;

	const version$7 = "bytes/5.7.0";

	const logger$3 = new Logger(version$7);
	///////////////////////////////
	function isHexable(value) {
	    return !!(value.toHexString);
	}
	function addSlice(array) {
	    if (array.slice) {
	        return array;
	    }
	    array.slice = function () {
	        const args = Array.prototype.slice.call(arguments);
	        return addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
	    };
	    return array;
	}
	function isBytesLike(value) {
	    return ((isHexString$2(value) && !(value.length % 2)) || isBytes$1(value));
	}
	function isInteger(value) {
	    return (typeof (value) === "number" && value == value && (value % 1) === 0);
	}
	function isBytes$1(value) {
	    if (value == null) {
	        return false;
	    }
	    if (value.constructor === Uint8Array) {
	        return true;
	    }
	    if (typeof (value) === "string") {
	        return false;
	    }
	    if (!isInteger(value.length) || value.length < 0) {
	        return false;
	    }
	    for (let i = 0; i < value.length; i++) {
	        const v = value[i];
	        if (!isInteger(v) || v < 0 || v >= 256) {
	            return false;
	        }
	    }
	    return true;
	}
	function arrayify(value, options) {
	    if (!options) {
	        options = {};
	    }
	    if (typeof (value) === "number") {
	        logger$3.checkSafeUint53(value, "invalid arrayify value");
	        const result = [];
	        while (value) {
	            result.unshift(value & 0xff);
	            value = parseInt(String(value / 256));
	        }
	        if (result.length === 0) {
	            result.push(0);
	        }
	        return addSlice(new Uint8Array(result));
	    }
	    if (options.allowMissingPrefix && typeof (value) === "string" && value.substring(0, 2) !== "0x") {
	        value = "0x" + value;
	    }
	    if (isHexable(value)) {
	        value = value.toHexString();
	    }
	    if (isHexString$2(value)) {
	        let hex = value.substring(2);
	        if (hex.length % 2) {
	            if (options.hexPad === "left") {
	                hex = "0" + hex;
	            }
	            else if (options.hexPad === "right") {
	                hex += "0";
	            }
	            else {
	                logger$3.throwArgumentError("hex data is odd-length", "value", value);
	            }
	        }
	        const result = [];
	        for (let i = 0; i < hex.length; i += 2) {
	            result.push(parseInt(hex.substring(i, i + 2), 16));
	        }
	        return addSlice(new Uint8Array(result));
	    }
	    if (isBytes$1(value)) {
	        return addSlice(new Uint8Array(value));
	    }
	    return logger$3.throwArgumentError("invalid arrayify value", "value", value);
	}
	function concat$2(items) {
	    const objects = items.map(item => arrayify(item));
	    const length = objects.reduce((accum, item) => (accum + item.length), 0);
	    const result = new Uint8Array(length);
	    objects.reduce((offset, object) => {
	        result.set(object, offset);
	        return offset + object.length;
	    }, 0);
	    return addSlice(result);
	}
	function zeroPad(value, length) {
	    value = arrayify(value);
	    if (value.length > length) {
	        logger$3.throwArgumentError("value out of range", "value", arguments[0]);
	    }
	    const result = new Uint8Array(length);
	    result.set(value, length - value.length);
	    return addSlice(result);
	}
	function isHexString$2(value, length) {
	    if (typeof (value) !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) {
	        return false;
	    }
	    if (length && value.length !== 2 + 2 * length) {
	        return false;
	    }
	    return true;
	}
	const HexCharacters = "0123456789abcdef";
	function hexlify(value, options) {
	    if (!options) {
	        options = {};
	    }
	    if (typeof (value) === "number") {
	        logger$3.checkSafeUint53(value, "invalid hexlify value");
	        let hex = "";
	        while (value) {
	            hex = HexCharacters[value & 0xf] + hex;
	            value = Math.floor(value / 16);
	        }
	        if (hex.length) {
	            if (hex.length % 2) {
	                hex = "0" + hex;
	            }
	            return "0x" + hex;
	        }
	        return "0x00";
	    }
	    if (typeof (value) === "bigint") {
	        value = value.toString(16);
	        if (value.length % 2) {
	            return ("0x0" + value);
	        }
	        return "0x" + value;
	    }
	    if (options.allowMissingPrefix && typeof (value) === "string" && value.substring(0, 2) !== "0x") {
	        value = "0x" + value;
	    }
	    if (isHexable(value)) {
	        return value.toHexString();
	    }
	    if (isHexString$2(value)) {
	        if (value.length % 2) {
	            if (options.hexPad === "left") {
	                value = "0x0" + value.substring(2);
	            }
	            else if (options.hexPad === "right") {
	                value += "0";
	            }
	            else {
	                logger$3.throwArgumentError("hex data is odd-length", "value", value);
	            }
	        }
	        return value.toLowerCase();
	    }
	    if (isBytes$1(value)) {
	        let result = "0x";
	        for (let i = 0; i < value.length; i++) {
	            let v = value[i];
	            result += HexCharacters[(v & 0xf0) >> 4] + HexCharacters[v & 0x0f];
	        }
	        return result;
	    }
	    return logger$3.throwArgumentError("invalid hexlify value", "value", value);
	}
	/*
	function unoddify(value: BytesLike | Hexable | number): BytesLike | Hexable | number {
	    if (typeof(value) === "string" && value.length % 2 && value.substring(0, 2) === "0x") {
	        return "0x0" + value.substring(2);
	    }
	    return value;
	}
	*/
	function hexDataLength(data) {
	    if (typeof (data) !== "string") {
	        data = hexlify(data);
	    }
	    else if (!isHexString$2(data) || (data.length % 2)) {
	        return null;
	    }
	    return (data.length - 2) / 2;
	}
	function hexDataSlice(data, offset, endOffset) {
	    if (typeof (data) !== "string") {
	        data = hexlify(data);
	    }
	    else if (!isHexString$2(data) || (data.length % 2)) {
	        logger$3.throwArgumentError("invalid hexData", "value", data);
	    }
	    offset = 2 + 2 * offset;
	    if (endOffset != null) {
	        return "0x" + data.substring(offset, 2 + 2 * endOffset);
	    }
	    return "0x" + data.substring(offset);
	}
	function hexZeroPad(value, length) {
	    if (typeof (value) !== "string") {
	        value = hexlify(value);
	    }
	    else if (!isHexString$2(value)) {
	        logger$3.throwArgumentError("invalid hex string", "value", value);
	    }
	    if (value.length > 2 * length + 2) {
	        logger$3.throwArgumentError("value out of range", "value", arguments[1]);
	    }
	    while (value.length < 2 * length + 2) {
	        value = "0x0" + value.substring(2);
	    }
	    return value;
	}
	function splitSignature(signature) {
	    const result = {
	        r: "0x",
	        s: "0x",
	        _vs: "0x",
	        recoveryParam: 0,
	        v: 0,
	        yParityAndS: "0x",
	        compact: "0x"
	    };
	    if (isBytesLike(signature)) {
	        let bytes = arrayify(signature);
	        // Get the r, s and v
	        if (bytes.length === 64) {
	            // EIP-2098; pull the v from the top bit of s and clear it
	            result.v = 27 + (bytes[32] >> 7);
	            bytes[32] &= 0x7f;
	            result.r = hexlify(bytes.slice(0, 32));
	            result.s = hexlify(bytes.slice(32, 64));
	        }
	        else if (bytes.length === 65) {
	            result.r = hexlify(bytes.slice(0, 32));
	            result.s = hexlify(bytes.slice(32, 64));
	            result.v = bytes[64];
	        }
	        else {
	            logger$3.throwArgumentError("invalid signature string", "signature", signature);
	        }
	        // Allow a recid to be used as the v
	        if (result.v < 27) {
	            if (result.v === 0 || result.v === 1) {
	                result.v += 27;
	            }
	            else {
	                logger$3.throwArgumentError("signature invalid v byte", "signature", signature);
	            }
	        }
	        // Compute recoveryParam from v
	        result.recoveryParam = 1 - (result.v % 2);
	        // Compute _vs from recoveryParam and s
	        if (result.recoveryParam) {
	            bytes[32] |= 0x80;
	        }
	        result._vs = hexlify(bytes.slice(32, 64));
	    }
	    else {
	        result.r = signature.r;
	        result.s = signature.s;
	        result.v = signature.v;
	        result.recoveryParam = signature.recoveryParam;
	        result._vs = signature._vs;
	        // If the _vs is available, use it to populate missing s, v and recoveryParam
	        // and verify non-missing s, v and recoveryParam
	        if (result._vs != null) {
	            const vs = zeroPad(arrayify(result._vs), 32);
	            result._vs = hexlify(vs);
	            // Set or check the recid
	            const recoveryParam = ((vs[0] >= 128) ? 1 : 0);
	            if (result.recoveryParam == null) {
	                result.recoveryParam = recoveryParam;
	            }
	            else if (result.recoveryParam !== recoveryParam) {
	                logger$3.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
	            }
	            // Set or check the s
	            vs[0] &= 0x7f;
	            const s = hexlify(vs);
	            if (result.s == null) {
	                result.s = s;
	            }
	            else if (result.s !== s) {
	                logger$3.throwArgumentError("signature v mismatch _vs", "signature", signature);
	            }
	        }
	        // Use recid and v to populate each other
	        if (result.recoveryParam == null) {
	            if (result.v == null) {
	                logger$3.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
	            }
	            else if (result.v === 0 || result.v === 1) {
	                result.recoveryParam = result.v;
	            }
	            else {
	                result.recoveryParam = 1 - (result.v % 2);
	            }
	        }
	        else {
	            if (result.v == null) {
	                result.v = 27 + result.recoveryParam;
	            }
	            else {
	                const recId = (result.v === 0 || result.v === 1) ? result.v : (1 - (result.v % 2));
	                if (result.recoveryParam !== recId) {
	                    logger$3.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
	                }
	            }
	        }
	        if (result.r == null || !isHexString$2(result.r)) {
	            logger$3.throwArgumentError("signature missing or invalid r", "signature", signature);
	        }
	        else {
	            result.r = hexZeroPad(result.r, 32);
	        }
	        if (result.s == null || !isHexString$2(result.s)) {
	            logger$3.throwArgumentError("signature missing or invalid s", "signature", signature);
	        }
	        else {
	            result.s = hexZeroPad(result.s, 32);
	        }
	        const vs = arrayify(result.s);
	        if (vs[0] >= 128) {
	            logger$3.throwArgumentError("signature s out of range", "signature", signature);
	        }
	        if (result.recoveryParam) {
	            vs[0] |= 0x80;
	        }
	        const _vs = hexlify(vs);
	        if (result._vs) {
	            if (!isHexString$2(result._vs)) {
	                logger$3.throwArgumentError("signature invalid _vs", "signature", signature);
	            }
	            result._vs = hexZeroPad(result._vs, 32);
	        }
	        // Set or check the _vs
	        if (result._vs == null) {
	            result._vs = _vs;
	        }
	        else if (result._vs !== _vs) {
	            logger$3.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
	        }
	    }
	    result.yParityAndS = result._vs;
	    result.compact = result.r + result.yParityAndS.substring(2);
	    return result;
	}

	var BN$a = BN$b.BN;
	// value should have no prefix
	function _base36To16(value) {
	    return (new BN$a(value, 36)).toString(16);
	}

	(undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	function defineReadOnly(object, name, value) {
	    Object.defineProperty(object, name, {
	        enumerable: true,
	        value: value,
	        writable: false,
	    });
	}

	var sha3$1 = {exports: {}};

	/**
	 * [js-sha3]{@link https://github.com/emn178/js-sha3}
	 *
	 * @version 0.8.0
	 * @author Chen, Yi-Cyuan [emn178@gmail.com]
	 * @copyright Chen, Yi-Cyuan 2015-2018
	 * @license MIT
	 */

	(function (module) {
		/*jslint bitwise: true */
		(function () {

		  var INPUT_ERROR = 'input is invalid type';
		  var FINALIZE_ERROR = 'finalize already called';
		  var WINDOW = typeof window === 'object';
		  var root = WINDOW ? window : {};
		  if (root.JS_SHA3_NO_WINDOW) {
		    WINDOW = false;
		  }
		  var WEB_WORKER = !WINDOW && typeof self === 'object';
		  var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
		  if (NODE_JS) {
		    root = commonjsGlobal;
		  } else if (WEB_WORKER) {
		    root = self;
		  }
		  var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && 'object' === 'object' && module.exports;
		  var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
		  var HEX_CHARS = '0123456789abcdef'.split('');
		  var SHAKE_PADDING = [31, 7936, 2031616, 520093696];
		  var CSHAKE_PADDING = [4, 1024, 262144, 67108864];
		  var KECCAK_PADDING = [1, 256, 65536, 16777216];
		  var PADDING = [6, 1536, 393216, 100663296];
		  var SHIFT = [0, 8, 16, 24];
		  var RC = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649,
		    0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0,
		    2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771,
		    2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648,
		    2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];
		  var BITS = [224, 256, 384, 512];
		  var SHAKE_BITS = [128, 256];
		  var OUTPUT_TYPES = ['hex', 'buffer', 'arrayBuffer', 'array', 'digest'];
		  var CSHAKE_BYTEPAD = {
		    '128': 168,
		    '256': 136
		  };

		  if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) {
		    Array.isArray = function (obj) {
		      return Object.prototype.toString.call(obj) === '[object Array]';
		    };
		  }

		  if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
		    ArrayBuffer.isView = function (obj) {
		      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
		    };
		  }

		  var createOutputMethod = function (bits, padding, outputType) {
		    return function (message) {
		      return new Keccak(bits, padding, bits).update(message)[outputType]();
		    };
		  };

		  var createShakeOutputMethod = function (bits, padding, outputType) {
		    return function (message, outputBits) {
		      return new Keccak(bits, padding, outputBits).update(message)[outputType]();
		    };
		  };

		  var createCshakeOutputMethod = function (bits, padding, outputType) {
		    return function (message, outputBits, n, s) {
		      return methods['cshake' + bits].update(message, outputBits, n, s)[outputType]();
		    };
		  };

		  var createKmacOutputMethod = function (bits, padding, outputType) {
		    return function (key, message, outputBits, s) {
		      return methods['kmac' + bits].update(key, message, outputBits, s)[outputType]();
		    };
		  };

		  var createOutputMethods = function (method, createMethod, bits, padding) {
		    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
		      var type = OUTPUT_TYPES[i];
		      method[type] = createMethod(bits, padding, type);
		    }
		    return method;
		  };

		  var createMethod = function (bits, padding) {
		    var method = createOutputMethod(bits, padding, 'hex');
		    method.create = function () {
		      return new Keccak(bits, padding, bits);
		    };
		    method.update = function (message) {
		      return method.create().update(message);
		    };
		    return createOutputMethods(method, createOutputMethod, bits, padding);
		  };

		  var createShakeMethod = function (bits, padding) {
		    var method = createShakeOutputMethod(bits, padding, 'hex');
		    method.create = function (outputBits) {
		      return new Keccak(bits, padding, outputBits);
		    };
		    method.update = function (message, outputBits) {
		      return method.create(outputBits).update(message);
		    };
		    return createOutputMethods(method, createShakeOutputMethod, bits, padding);
		  };

		  var createCshakeMethod = function (bits, padding) {
		    var w = CSHAKE_BYTEPAD[bits];
		    var method = createCshakeOutputMethod(bits, padding, 'hex');
		    method.create = function (outputBits, n, s) {
		      if (!n && !s) {
		        return methods['shake' + bits].create(outputBits);
		      } else {
		        return new Keccak(bits, padding, outputBits).bytepad([n, s], w);
		      }
		    };
		    method.update = function (message, outputBits, n, s) {
		      return method.create(outputBits, n, s).update(message);
		    };
		    return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
		  };

		  var createKmacMethod = function (bits, padding) {
		    var w = CSHAKE_BYTEPAD[bits];
		    var method = createKmacOutputMethod(bits, padding, 'hex');
		    method.create = function (key, outputBits, s) {
		      return new Kmac(bits, padding, outputBits).bytepad(['KMAC', s], w).bytepad([key], w);
		    };
		    method.update = function (key, message, outputBits, s) {
		      return method.create(key, outputBits, s).update(message);
		    };
		    return createOutputMethods(method, createKmacOutputMethod, bits, padding);
		  };

		  var algorithms = [
		    { name: 'keccak', padding: KECCAK_PADDING, bits: BITS, createMethod: createMethod },
		    { name: 'sha3', padding: PADDING, bits: BITS, createMethod: createMethod },
		    { name: 'shake', padding: SHAKE_PADDING, bits: SHAKE_BITS, createMethod: createShakeMethod },
		    { name: 'cshake', padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createCshakeMethod },
		    { name: 'kmac', padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createKmacMethod }
		  ];

		  var methods = {}, methodNames = [];

		  for (var i = 0; i < algorithms.length; ++i) {
		    var algorithm = algorithms[i];
		    var bits = algorithm.bits;
		    for (var j = 0; j < bits.length; ++j) {
		      var methodName = algorithm.name + '_' + bits[j];
		      methodNames.push(methodName);
		      methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
		      if (algorithm.name !== 'sha3') {
		        var newMethodName = algorithm.name + bits[j];
		        methodNames.push(newMethodName);
		        methods[newMethodName] = methods[methodName];
		      }
		    }
		  }

		  function Keccak(bits, padding, outputBits) {
		    this.blocks = [];
		    this.s = [];
		    this.padding = padding;
		    this.outputBits = outputBits;
		    this.reset = true;
		    this.finalized = false;
		    this.block = 0;
		    this.start = 0;
		    this.blockCount = (1600 - (bits << 1)) >> 5;
		    this.byteCount = this.blockCount << 2;
		    this.outputBlocks = outputBits >> 5;
		    this.extraBytes = (outputBits & 31) >> 3;

		    for (var i = 0; i < 50; ++i) {
		      this.s[i] = 0;
		    }
		  }

		  Keccak.prototype.update = function (message) {
		    if (this.finalized) {
		      throw new Error(FINALIZE_ERROR);
		    }
		    var notString, type = typeof message;
		    if (type !== 'string') {
		      if (type === 'object') {
		        if (message === null) {
		          throw new Error(INPUT_ERROR);
		        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
		          message = new Uint8Array(message);
		        } else if (!Array.isArray(message)) {
		          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
		            throw new Error(INPUT_ERROR);
		          }
		        }
		      } else {
		        throw new Error(INPUT_ERROR);
		      }
		      notString = true;
		    }
		    var blocks = this.blocks, byteCount = this.byteCount, length = message.length,
		      blockCount = this.blockCount, index = 0, s = this.s, i, code;

		    while (index < length) {
		      if (this.reset) {
		        this.reset = false;
		        blocks[0] = this.block;
		        for (i = 1; i < blockCount + 1; ++i) {
		          blocks[i] = 0;
		        }
		      }
		      if (notString) {
		        for (i = this.start; index < length && i < byteCount; ++index) {
		          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
		        }
		      } else {
		        for (i = this.start; index < length && i < byteCount; ++index) {
		          code = message.charCodeAt(index);
		          if (code < 0x80) {
		            blocks[i >> 2] |= code << SHIFT[i++ & 3];
		          } else if (code < 0x800) {
		            blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
		            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
		          } else if (code < 0xd800 || code >= 0xe000) {
		            blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
		            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
		            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
		          } else {
		            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
		            blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
		            blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
		            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
		            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
		          }
		        }
		      }
		      this.lastByteIndex = i;
		      if (i >= byteCount) {
		        this.start = i - byteCount;
		        this.block = blocks[blockCount];
		        for (i = 0; i < blockCount; ++i) {
		          s[i] ^= blocks[i];
		        }
		        f(s);
		        this.reset = true;
		      } else {
		        this.start = i;
		      }
		    }
		    return this;
		  };

		  Keccak.prototype.encode = function (x, right) {
		    var o = x & 255, n = 1;
		    var bytes = [o];
		    x = x >> 8;
		    o = x & 255;
		    while (o > 0) {
		      bytes.unshift(o);
		      x = x >> 8;
		      o = x & 255;
		      ++n;
		    }
		    if (right) {
		      bytes.push(n);
		    } else {
		      bytes.unshift(n);
		    }
		    this.update(bytes);
		    return bytes.length;
		  };

		  Keccak.prototype.encodeString = function (str) {
		    var notString, type = typeof str;
		    if (type !== 'string') {
		      if (type === 'object') {
		        if (str === null) {
		          throw new Error(INPUT_ERROR);
		        } else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) {
		          str = new Uint8Array(str);
		        } else if (!Array.isArray(str)) {
		          if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) {
		            throw new Error(INPUT_ERROR);
		          }
		        }
		      } else {
		        throw new Error(INPUT_ERROR);
		      }
		      notString = true;
		    }
		    var bytes = 0, length = str.length;
		    if (notString) {
		      bytes = length;
		    } else {
		      for (var i = 0; i < str.length; ++i) {
		        var code = str.charCodeAt(i);
		        if (code < 0x80) {
		          bytes += 1;
		        } else if (code < 0x800) {
		          bytes += 2;
		        } else if (code < 0xd800 || code >= 0xe000) {
		          bytes += 3;
		        } else {
		          code = 0x10000 + (((code & 0x3ff) << 10) | (str.charCodeAt(++i) & 0x3ff));
		          bytes += 4;
		        }
		      }
		    }
		    bytes += this.encode(bytes * 8);
		    this.update(str);
		    return bytes;
		  };

		  Keccak.prototype.bytepad = function (strs, w) {
		    var bytes = this.encode(w);
		    for (var i = 0; i < strs.length; ++i) {
		      bytes += this.encodeString(strs[i]);
		    }
		    var paddingBytes = w - bytes % w;
		    var zeros = [];
		    zeros.length = paddingBytes;
		    this.update(zeros);
		    return this;
		  };

		  Keccak.prototype.finalize = function () {
		    if (this.finalized) {
		      return;
		    }
		    this.finalized = true;
		    var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
		    blocks[i >> 2] |= this.padding[i & 3];
		    if (this.lastByteIndex === this.byteCount) {
		      blocks[0] = blocks[blockCount];
		      for (i = 1; i < blockCount + 1; ++i) {
		        blocks[i] = 0;
		      }
		    }
		    blocks[blockCount - 1] |= 0x80000000;
		    for (i = 0; i < blockCount; ++i) {
		      s[i] ^= blocks[i];
		    }
		    f(s);
		  };

		  Keccak.prototype.toString = Keccak.prototype.hex = function () {
		    this.finalize();

		    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
		      extraBytes = this.extraBytes, i = 0, j = 0;
		    var hex = '', block;
		    while (j < outputBlocks) {
		      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
		        block = s[i];
		        hex += HEX_CHARS[(block >> 4) & 0x0F] + HEX_CHARS[block & 0x0F] +
		          HEX_CHARS[(block >> 12) & 0x0F] + HEX_CHARS[(block >> 8) & 0x0F] +
		          HEX_CHARS[(block >> 20) & 0x0F] + HEX_CHARS[(block >> 16) & 0x0F] +
		          HEX_CHARS[(block >> 28) & 0x0F] + HEX_CHARS[(block >> 24) & 0x0F];
		      }
		      if (j % blockCount === 0) {
		        f(s);
		        i = 0;
		      }
		    }
		    if (extraBytes) {
		      block = s[i];
		      hex += HEX_CHARS[(block >> 4) & 0x0F] + HEX_CHARS[block & 0x0F];
		      if (extraBytes > 1) {
		        hex += HEX_CHARS[(block >> 12) & 0x0F] + HEX_CHARS[(block >> 8) & 0x0F];
		      }
		      if (extraBytes > 2) {
		        hex += HEX_CHARS[(block >> 20) & 0x0F] + HEX_CHARS[(block >> 16) & 0x0F];
		      }
		    }
		    return hex;
		  };

		  Keccak.prototype.arrayBuffer = function () {
		    this.finalize();

		    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
		      extraBytes = this.extraBytes, i = 0, j = 0;
		    var bytes = this.outputBits >> 3;
		    var buffer;
		    if (extraBytes) {
		      buffer = new ArrayBuffer((outputBlocks + 1) << 2);
		    } else {
		      buffer = new ArrayBuffer(bytes);
		    }
		    var array = new Uint32Array(buffer);
		    while (j < outputBlocks) {
		      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
		        array[j] = s[i];
		      }
		      if (j % blockCount === 0) {
		        f(s);
		      }
		    }
		    if (extraBytes) {
		      array[i] = s[i];
		      buffer = buffer.slice(0, bytes);
		    }
		    return buffer;
		  };

		  Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;

		  Keccak.prototype.digest = Keccak.prototype.array = function () {
		    this.finalize();

		    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
		      extraBytes = this.extraBytes, i = 0, j = 0;
		    var array = [], offset, block;
		    while (j < outputBlocks) {
		      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
		        offset = j << 2;
		        block = s[i];
		        array[offset] = block & 0xFF;
		        array[offset + 1] = (block >> 8) & 0xFF;
		        array[offset + 2] = (block >> 16) & 0xFF;
		        array[offset + 3] = (block >> 24) & 0xFF;
		      }
		      if (j % blockCount === 0) {
		        f(s);
		      }
		    }
		    if (extraBytes) {
		      offset = j << 2;
		      block = s[i];
		      array[offset] = block & 0xFF;
		      if (extraBytes > 1) {
		        array[offset + 1] = (block >> 8) & 0xFF;
		      }
		      if (extraBytes > 2) {
		        array[offset + 2] = (block >> 16) & 0xFF;
		      }
		    }
		    return array;
		  };

		  function Kmac(bits, padding, outputBits) {
		    Keccak.call(this, bits, padding, outputBits);
		  }

		  Kmac.prototype = new Keccak();

		  Kmac.prototype.finalize = function () {
		    this.encode(this.outputBits, true);
		    return Keccak.prototype.finalize.call(this);
		  };

		  var f = function (s) {
		    var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9,
		      b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17,
		      b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33,
		      b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
		    for (n = 0; n < 48; n += 2) {
		      c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
		      c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
		      c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
		      c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
		      c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
		      c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
		      c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
		      c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
		      c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
		      c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];

		      h = c8 ^ ((c2 << 1) | (c3 >>> 31));
		      l = c9 ^ ((c3 << 1) | (c2 >>> 31));
		      s[0] ^= h;
		      s[1] ^= l;
		      s[10] ^= h;
		      s[11] ^= l;
		      s[20] ^= h;
		      s[21] ^= l;
		      s[30] ^= h;
		      s[31] ^= l;
		      s[40] ^= h;
		      s[41] ^= l;
		      h = c0 ^ ((c4 << 1) | (c5 >>> 31));
		      l = c1 ^ ((c5 << 1) | (c4 >>> 31));
		      s[2] ^= h;
		      s[3] ^= l;
		      s[12] ^= h;
		      s[13] ^= l;
		      s[22] ^= h;
		      s[23] ^= l;
		      s[32] ^= h;
		      s[33] ^= l;
		      s[42] ^= h;
		      s[43] ^= l;
		      h = c2 ^ ((c6 << 1) | (c7 >>> 31));
		      l = c3 ^ ((c7 << 1) | (c6 >>> 31));
		      s[4] ^= h;
		      s[5] ^= l;
		      s[14] ^= h;
		      s[15] ^= l;
		      s[24] ^= h;
		      s[25] ^= l;
		      s[34] ^= h;
		      s[35] ^= l;
		      s[44] ^= h;
		      s[45] ^= l;
		      h = c4 ^ ((c8 << 1) | (c9 >>> 31));
		      l = c5 ^ ((c9 << 1) | (c8 >>> 31));
		      s[6] ^= h;
		      s[7] ^= l;
		      s[16] ^= h;
		      s[17] ^= l;
		      s[26] ^= h;
		      s[27] ^= l;
		      s[36] ^= h;
		      s[37] ^= l;
		      s[46] ^= h;
		      s[47] ^= l;
		      h = c6 ^ ((c0 << 1) | (c1 >>> 31));
		      l = c7 ^ ((c1 << 1) | (c0 >>> 31));
		      s[8] ^= h;
		      s[9] ^= l;
		      s[18] ^= h;
		      s[19] ^= l;
		      s[28] ^= h;
		      s[29] ^= l;
		      s[38] ^= h;
		      s[39] ^= l;
		      s[48] ^= h;
		      s[49] ^= l;

		      b0 = s[0];
		      b1 = s[1];
		      b32 = (s[11] << 4) | (s[10] >>> 28);
		      b33 = (s[10] << 4) | (s[11] >>> 28);
		      b14 = (s[20] << 3) | (s[21] >>> 29);
		      b15 = (s[21] << 3) | (s[20] >>> 29);
		      b46 = (s[31] << 9) | (s[30] >>> 23);
		      b47 = (s[30] << 9) | (s[31] >>> 23);
		      b28 = (s[40] << 18) | (s[41] >>> 14);
		      b29 = (s[41] << 18) | (s[40] >>> 14);
		      b20 = (s[2] << 1) | (s[3] >>> 31);
		      b21 = (s[3] << 1) | (s[2] >>> 31);
		      b2 = (s[13] << 12) | (s[12] >>> 20);
		      b3 = (s[12] << 12) | (s[13] >>> 20);
		      b34 = (s[22] << 10) | (s[23] >>> 22);
		      b35 = (s[23] << 10) | (s[22] >>> 22);
		      b16 = (s[33] << 13) | (s[32] >>> 19);
		      b17 = (s[32] << 13) | (s[33] >>> 19);
		      b48 = (s[42] << 2) | (s[43] >>> 30);
		      b49 = (s[43] << 2) | (s[42] >>> 30);
		      b40 = (s[5] << 30) | (s[4] >>> 2);
		      b41 = (s[4] << 30) | (s[5] >>> 2);
		      b22 = (s[14] << 6) | (s[15] >>> 26);
		      b23 = (s[15] << 6) | (s[14] >>> 26);
		      b4 = (s[25] << 11) | (s[24] >>> 21);
		      b5 = (s[24] << 11) | (s[25] >>> 21);
		      b36 = (s[34] << 15) | (s[35] >>> 17);
		      b37 = (s[35] << 15) | (s[34] >>> 17);
		      b18 = (s[45] << 29) | (s[44] >>> 3);
		      b19 = (s[44] << 29) | (s[45] >>> 3);
		      b10 = (s[6] << 28) | (s[7] >>> 4);
		      b11 = (s[7] << 28) | (s[6] >>> 4);
		      b42 = (s[17] << 23) | (s[16] >>> 9);
		      b43 = (s[16] << 23) | (s[17] >>> 9);
		      b24 = (s[26] << 25) | (s[27] >>> 7);
		      b25 = (s[27] << 25) | (s[26] >>> 7);
		      b6 = (s[36] << 21) | (s[37] >>> 11);
		      b7 = (s[37] << 21) | (s[36] >>> 11);
		      b38 = (s[47] << 24) | (s[46] >>> 8);
		      b39 = (s[46] << 24) | (s[47] >>> 8);
		      b30 = (s[8] << 27) | (s[9] >>> 5);
		      b31 = (s[9] << 27) | (s[8] >>> 5);
		      b12 = (s[18] << 20) | (s[19] >>> 12);
		      b13 = (s[19] << 20) | (s[18] >>> 12);
		      b44 = (s[29] << 7) | (s[28] >>> 25);
		      b45 = (s[28] << 7) | (s[29] >>> 25);
		      b26 = (s[38] << 8) | (s[39] >>> 24);
		      b27 = (s[39] << 8) | (s[38] >>> 24);
		      b8 = (s[48] << 14) | (s[49] >>> 18);
		      b9 = (s[49] << 14) | (s[48] >>> 18);

		      s[0] = b0 ^ (~b2 & b4);
		      s[1] = b1 ^ (~b3 & b5);
		      s[10] = b10 ^ (~b12 & b14);
		      s[11] = b11 ^ (~b13 & b15);
		      s[20] = b20 ^ (~b22 & b24);
		      s[21] = b21 ^ (~b23 & b25);
		      s[30] = b30 ^ (~b32 & b34);
		      s[31] = b31 ^ (~b33 & b35);
		      s[40] = b40 ^ (~b42 & b44);
		      s[41] = b41 ^ (~b43 & b45);
		      s[2] = b2 ^ (~b4 & b6);
		      s[3] = b3 ^ (~b5 & b7);
		      s[12] = b12 ^ (~b14 & b16);
		      s[13] = b13 ^ (~b15 & b17);
		      s[22] = b22 ^ (~b24 & b26);
		      s[23] = b23 ^ (~b25 & b27);
		      s[32] = b32 ^ (~b34 & b36);
		      s[33] = b33 ^ (~b35 & b37);
		      s[42] = b42 ^ (~b44 & b46);
		      s[43] = b43 ^ (~b45 & b47);
		      s[4] = b4 ^ (~b6 & b8);
		      s[5] = b5 ^ (~b7 & b9);
		      s[14] = b14 ^ (~b16 & b18);
		      s[15] = b15 ^ (~b17 & b19);
		      s[24] = b24 ^ (~b26 & b28);
		      s[25] = b25 ^ (~b27 & b29);
		      s[34] = b34 ^ (~b36 & b38);
		      s[35] = b35 ^ (~b37 & b39);
		      s[44] = b44 ^ (~b46 & b48);
		      s[45] = b45 ^ (~b47 & b49);
		      s[6] = b6 ^ (~b8 & b0);
		      s[7] = b7 ^ (~b9 & b1);
		      s[16] = b16 ^ (~b18 & b10);
		      s[17] = b17 ^ (~b19 & b11);
		      s[26] = b26 ^ (~b28 & b20);
		      s[27] = b27 ^ (~b29 & b21);
		      s[36] = b36 ^ (~b38 & b30);
		      s[37] = b37 ^ (~b39 & b31);
		      s[46] = b46 ^ (~b48 & b40);
		      s[47] = b47 ^ (~b49 & b41);
		      s[8] = b8 ^ (~b0 & b2);
		      s[9] = b9 ^ (~b1 & b3);
		      s[18] = b18 ^ (~b10 & b12);
		      s[19] = b19 ^ (~b11 & b13);
		      s[28] = b28 ^ (~b20 & b22);
		      s[29] = b29 ^ (~b21 & b23);
		      s[38] = b38 ^ (~b30 & b32);
		      s[39] = b39 ^ (~b31 & b33);
		      s[48] = b48 ^ (~b40 & b42);
		      s[49] = b49 ^ (~b41 & b43);

		      s[0] ^= RC[n];
		      s[1] ^= RC[n + 1];
		    }
		  };

		  if (COMMON_JS) {
		    module.exports = methods;
		  } else {
		    for (i = 0; i < methodNames.length; ++i) {
		      root[methodNames[i]] = methods[methodNames[i]];
		    }
		  }
		})(); 
	} (sha3$1));

	var sha3Exports = sha3$1.exports;
	var sha3 = /*@__PURE__*/getDefaultExportFromCjs(sha3Exports);

	function keccak256(data) {
	    return '0x' + sha3.keccak_256(arrayify(data));
	}

	const version$6 = "address/5.7.0";

	const logger$2 = new Logger(version$6);
	function getChecksumAddress(address) {
	    if (!isHexString$2(address, 20)) {
	        logger$2.throwArgumentError("invalid address", "address", address);
	    }
	    address = address.toLowerCase();
	    const chars = address.substring(2).split("");
	    const expanded = new Uint8Array(40);
	    for (let i = 0; i < 40; i++) {
	        expanded[i] = chars[i].charCodeAt(0);
	    }
	    const hashed = arrayify(keccak256(expanded));
	    for (let i = 0; i < 40; i += 2) {
	        if ((hashed[i >> 1] >> 4) >= 8) {
	            chars[i] = chars[i].toUpperCase();
	        }
	        if ((hashed[i >> 1] & 0x0f) >= 8) {
	            chars[i + 1] = chars[i + 1].toUpperCase();
	        }
	    }
	    return "0x" + chars.join("");
	}
	// Shims for environments that are missing some required constants and functions
	const MAX_SAFE_INTEGER$2 = 0x1fffffffffffff;
	function log10(x) {
	    if (Math.log10) {
	        return Math.log10(x);
	    }
	    return Math.log(x) / Math.LN10;
	}
	// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
	// Create lookup table
	const ibanLookup = {};
	for (let i = 0; i < 10; i++) {
	    ibanLookup[String(i)] = String(i);
	}
	for (let i = 0; i < 26; i++) {
	    ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
	}
	// How many decimal digits can we process? (for 64-bit float, this is 15)
	const safeDigits = Math.floor(log10(MAX_SAFE_INTEGER$2));
	function ibanChecksum(address) {
	    address = address.toUpperCase();
	    address = address.substring(4) + address.substring(0, 2) + "00";
	    let expanded = address.split("").map((c) => { return ibanLookup[c]; }).join("");
	    // Javascript can handle integers safely up to 15 (decimal) digits
	    while (expanded.length >= safeDigits) {
	        let block = expanded.substring(0, safeDigits);
	        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
	    }
	    let checksum = String(98 - (parseInt(expanded, 10) % 97));
	    while (checksum.length < 2) {
	        checksum = "0" + checksum;
	    }
	    return checksum;
	}
	function getAddress(address) {
	    let result = null;
	    if (typeof (address) !== "string") {
	        logger$2.throwArgumentError("invalid address", "address", address);
	    }
	    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
	        // Missing the 0x prefix
	        if (address.substring(0, 2) !== "0x") {
	            address = "0x" + address;
	        }
	        result = getChecksumAddress(address);
	        // It is a checksummed address with a bad checksum
	        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) {
	            logger$2.throwArgumentError("bad address checksum", "address", address);
	        }
	        // Maybe ICAP? (we only support direct mode)
	    }
	    else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
	        // It is an ICAP address with a bad checksum
	        if (address.substring(2, 4) !== ibanChecksum(address)) {
	            logger$2.throwArgumentError("bad icap checksum", "address", address);
	        }
	        result = _base36To16(address.substring(4));
	        while (result.length < 40) {
	            result = "0" + result;
	        }
	        result = getChecksumAddress("0x" + result);
	    }
	    else {
	        logger$2.throwArgumentError("invalid address", "address", address);
	    }
	    return result;
	}

	const version$5 = "strings/5.7.0";

	const logger$1 = new Logger(version$5);
	///////////////////////////////
	var UnicodeNormalizationForm;
	(function (UnicodeNormalizationForm) {
	    UnicodeNormalizationForm["current"] = "";
	    UnicodeNormalizationForm["NFC"] = "NFC";
	    UnicodeNormalizationForm["NFD"] = "NFD";
	    UnicodeNormalizationForm["NFKC"] = "NFKC";
	    UnicodeNormalizationForm["NFKD"] = "NFKD";
	})(UnicodeNormalizationForm || (UnicodeNormalizationForm = {}));
	var Utf8ErrorReason;
	(function (Utf8ErrorReason) {
	    // A continuation byte was present where there was nothing to continue
	    // - offset = the index the codepoint began in
	    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
	    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
	    // - offset = the index the codepoint began in
	    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
	    // The string is too short to process the expected codepoint
	    // - offset = the index the codepoint began in
	    Utf8ErrorReason["OVERRUN"] = "string overrun";
	    // A missing continuation byte was expected but not found
	    // - offset = the index the continuation byte was expected at
	    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
	    // The computed code point is outside the range for UTF-8
	    // - offset       = start of this codepoint
	    // - badCodepoint = the computed codepoint; outside the UTF-8 range
	    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
	    // UTF-8 strings may not contain UTF-16 surrogate pairs
	    // - offset       = start of this codepoint
	    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
	    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
	    // The string is an overlong representation
	    // - offset       = start of this codepoint
	    // - badCodepoint = the computed codepoint; already bounds checked
	    Utf8ErrorReason["OVERLONG"] = "overlong representation";
	})(Utf8ErrorReason || (Utf8ErrorReason = {}));
	// http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
	function toUtf8Bytes(str, form = UnicodeNormalizationForm.current) {
	    if (form != UnicodeNormalizationForm.current) {
	        logger$1.checkNormalize();
	        str = str.normalize(form);
	    }
	    let result = [];
	    for (let i = 0; i < str.length; i++) {
	        const c = str.charCodeAt(i);
	        if (c < 0x80) {
	            result.push(c);
	        }
	        else if (c < 0x800) {
	            result.push((c >> 6) | 0xc0);
	            result.push((c & 0x3f) | 0x80);
	        }
	        else if ((c & 0xfc00) == 0xd800) {
	            i++;
	            const c2 = str.charCodeAt(i);
	            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) {
	                throw new Error("invalid utf-8 string");
	            }
	            // Surrogate Pair
	            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
	            result.push((pair >> 18) | 0xf0);
	            result.push(((pair >> 12) & 0x3f) | 0x80);
	            result.push(((pair >> 6) & 0x3f) | 0x80);
	            result.push((pair & 0x3f) | 0x80);
	        }
	        else {
	            result.push((c >> 12) | 0xe0);
	            result.push(((c >> 6) & 0x3f) | 0x80);
	            result.push((c & 0x3f) | 0x80);
	        }
	    }
	    return arrayify(result);
	}

	const messagePrefix = "\x19Ethereum Signed Message:\n";
	function hashMessage(message) {
	    if (typeof (message) === "string") {
	        message = toUtf8Bytes(message);
	    }
	    return keccak256(concat$2([
	        toUtf8Bytes(messagePrefix),
	        toUtf8Bytes(String(message.length)),
	        message
	    ]));
	}

	var hash$4 = {};

	var utils$w = {};

	var minimalisticAssert$1 = assert$j;

	function assert$j(val, msg) {
	  if (!val)
	    throw new Error(msg || 'Assertion failed');
	}

	assert$j.equal = function assertEqual(l, r, msg) {
	  if (l != r)
	    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
	};

	var inherits_browser$1 = {exports: {}};

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  inherits_browser$1.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor;
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      });
	    }
	  };
	} else {
	  // old school shim for old browsers
	  inherits_browser$1.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor;
	      var TempCtor = function () {};
	      TempCtor.prototype = superCtor.prototype;
	      ctor.prototype = new TempCtor();
	      ctor.prototype.constructor = ctor;
	    }
	  };
	}

	var inherits_browserExports = inherits_browser$1.exports;

	var assert$i = minimalisticAssert$1;
	var inherits$9 = inherits_browserExports;

	utils$w.inherits = inherits$9;

	function isSurrogatePair(msg, i) {
	  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
	    return false;
	  }
	  if (i < 0 || i + 1 >= msg.length) {
	    return false;
	  }
	  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
	}

	function toArray$1(msg, enc) {
	  if (Array.isArray(msg))
	    return msg.slice();
	  if (!msg)
	    return [];
	  var res = [];
	  if (typeof msg === 'string') {
	    if (!enc) {
	      // Inspired by stringToUtf8ByteArray() in closure-library by Google
	      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
	      // Apache License 2.0
	      // https://github.com/google/closure-library/blob/master/LICENSE
	      var p = 0;
	      for (var i = 0; i < msg.length; i++) {
	        var c = msg.charCodeAt(i);
	        if (c < 128) {
	          res[p++] = c;
	        } else if (c < 2048) {
	          res[p++] = (c >> 6) | 192;
	          res[p++] = (c & 63) | 128;
	        } else if (isSurrogatePair(msg, i)) {
	          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
	          res[p++] = (c >> 18) | 240;
	          res[p++] = ((c >> 12) & 63) | 128;
	          res[p++] = ((c >> 6) & 63) | 128;
	          res[p++] = (c & 63) | 128;
	        } else {
	          res[p++] = (c >> 12) | 224;
	          res[p++] = ((c >> 6) & 63) | 128;
	          res[p++] = (c & 63) | 128;
	        }
	      }
	    } else if (enc === 'hex') {
	      msg = msg.replace(/[^a-z0-9]+/ig, '');
	      if (msg.length % 2 !== 0)
	        msg = '0' + msg;
	      for (i = 0; i < msg.length; i += 2)
	        res.push(parseInt(msg[i] + msg[i + 1], 16));
	    }
	  } else {
	    for (i = 0; i < msg.length; i++)
	      res[i] = msg[i] | 0;
	  }
	  return res;
	}
	utils$w.toArray = toArray$1;

	function toHex(msg) {
	  var res = '';
	  for (var i = 0; i < msg.length; i++)
	    res += zero2(msg[i].toString(16));
	  return res;
	}
	utils$w.toHex = toHex;

	function htonl(w) {
	  var res = (w >>> 24) |
	            ((w >>> 8) & 0xff00) |
	            ((w << 8) & 0xff0000) |
	            ((w & 0xff) << 24);
	  return res >>> 0;
	}
	utils$w.htonl = htonl;

	function toHex32(msg, endian) {
	  var res = '';
	  for (var i = 0; i < msg.length; i++) {
	    var w = msg[i];
	    if (endian === 'little')
	      w = htonl(w);
	    res += zero8(w.toString(16));
	  }
	  return res;
	}
	utils$w.toHex32 = toHex32;

	function zero2(word) {
	  if (word.length === 1)
	    return '0' + word;
	  else
	    return word;
	}
	utils$w.zero2 = zero2;

	function zero8(word) {
	  if (word.length === 7)
	    return '0' + word;
	  else if (word.length === 6)
	    return '00' + word;
	  else if (word.length === 5)
	    return '000' + word;
	  else if (word.length === 4)
	    return '0000' + word;
	  else if (word.length === 3)
	    return '00000' + word;
	  else if (word.length === 2)
	    return '000000' + word;
	  else if (word.length === 1)
	    return '0000000' + word;
	  else
	    return word;
	}
	utils$w.zero8 = zero8;

	function join32(msg, start, end, endian) {
	  var len = end - start;
	  assert$i(len % 4 === 0);
	  var res = new Array(len / 4);
	  for (var i = 0, k = start; i < res.length; i++, k += 4) {
	    var w;
	    if (endian === 'big')
	      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
	    else
	      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
	    res[i] = w >>> 0;
	  }
	  return res;
	}
	utils$w.join32 = join32;

	function split32(msg, endian) {
	  var res = new Array(msg.length * 4);
	  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
	    var m = msg[i];
	    if (endian === 'big') {
	      res[k] = m >>> 24;
	      res[k + 1] = (m >>> 16) & 0xff;
	      res[k + 2] = (m >>> 8) & 0xff;
	      res[k + 3] = m & 0xff;
	    } else {
	      res[k + 3] = m >>> 24;
	      res[k + 2] = (m >>> 16) & 0xff;
	      res[k + 1] = (m >>> 8) & 0xff;
	      res[k] = m & 0xff;
	    }
	  }
	  return res;
	}
	utils$w.split32 = split32;

	function rotr32$1(w, b) {
	  return (w >>> b) | (w << (32 - b));
	}
	utils$w.rotr32 = rotr32$1;

	function rotl32$2(w, b) {
	  return (w << b) | (w >>> (32 - b));
	}
	utils$w.rotl32 = rotl32$2;

	function sum32$3(a, b) {
	  return (a + b) >>> 0;
	}
	utils$w.sum32 = sum32$3;

	function sum32_3$1(a, b, c) {
	  return (a + b + c) >>> 0;
	}
	utils$w.sum32_3 = sum32_3$1;

	function sum32_4$2(a, b, c, d) {
	  return (a + b + c + d) >>> 0;
	}
	utils$w.sum32_4 = sum32_4$2;

	function sum32_5$2(a, b, c, d, e) {
	  return (a + b + c + d + e) >>> 0;
	}
	utils$w.sum32_5 = sum32_5$2;

	function sum64$1(buf, pos, ah, al) {
	  var bh = buf[pos];
	  var bl = buf[pos + 1];

	  var lo = (al + bl) >>> 0;
	  var hi = (lo < al ? 1 : 0) + ah + bh;
	  buf[pos] = hi >>> 0;
	  buf[pos + 1] = lo;
	}
	utils$w.sum64 = sum64$1;

	function sum64_hi$1(ah, al, bh, bl) {
	  var lo = (al + bl) >>> 0;
	  var hi = (lo < al ? 1 : 0) + ah + bh;
	  return hi >>> 0;
	}
	utils$w.sum64_hi = sum64_hi$1;

	function sum64_lo$1(ah, al, bh, bl) {
	  var lo = al + bl;
	  return lo >>> 0;
	}
	utils$w.sum64_lo = sum64_lo$1;

	function sum64_4_hi$1(ah, al, bh, bl, ch, cl, dh, dl) {
	  var carry = 0;
	  var lo = al;
	  lo = (lo + bl) >>> 0;
	  carry += lo < al ? 1 : 0;
	  lo = (lo + cl) >>> 0;
	  carry += lo < cl ? 1 : 0;
	  lo = (lo + dl) >>> 0;
	  carry += lo < dl ? 1 : 0;

	  var hi = ah + bh + ch + dh + carry;
	  return hi >>> 0;
	}
	utils$w.sum64_4_hi = sum64_4_hi$1;

	function sum64_4_lo$1(ah, al, bh, bl, ch, cl, dh, dl) {
	  var lo = al + bl + cl + dl;
	  return lo >>> 0;
	}
	utils$w.sum64_4_lo = sum64_4_lo$1;

	function sum64_5_hi$1(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
	  var carry = 0;
	  var lo = al;
	  lo = (lo + bl) >>> 0;
	  carry += lo < al ? 1 : 0;
	  lo = (lo + cl) >>> 0;
	  carry += lo < cl ? 1 : 0;
	  lo = (lo + dl) >>> 0;
	  carry += lo < dl ? 1 : 0;
	  lo = (lo + el) >>> 0;
	  carry += lo < el ? 1 : 0;

	  var hi = ah + bh + ch + dh + eh + carry;
	  return hi >>> 0;
	}
	utils$w.sum64_5_hi = sum64_5_hi$1;

	function sum64_5_lo$1(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
	  var lo = al + bl + cl + dl + el;

	  return lo >>> 0;
	}
	utils$w.sum64_5_lo = sum64_5_lo$1;

	function rotr64_hi$1(ah, al, num) {
	  var r = (al << (32 - num)) | (ah >>> num);
	  return r >>> 0;
	}
	utils$w.rotr64_hi = rotr64_hi$1;

	function rotr64_lo$1(ah, al, num) {
	  var r = (ah << (32 - num)) | (al >>> num);
	  return r >>> 0;
	}
	utils$w.rotr64_lo = rotr64_lo$1;

	function shr64_hi$1(ah, al, num) {
	  return ah >>> num;
	}
	utils$w.shr64_hi = shr64_hi$1;

	function shr64_lo$1(ah, al, num) {
	  var r = (ah << (32 - num)) | (al >>> num);
	  return r >>> 0;
	}
	utils$w.shr64_lo = shr64_lo$1;

	var common$6 = {};

	var utils$v = utils$w;
	var assert$h = minimalisticAssert$1;

	function BlockHash$4() {
	  this.pending = null;
	  this.pendingTotal = 0;
	  this.blockSize = this.constructor.blockSize;
	  this.outSize = this.constructor.outSize;
	  this.hmacStrength = this.constructor.hmacStrength;
	  this.padLength = this.constructor.padLength / 8;
	  this.endian = 'big';

	  this._delta8 = this.blockSize / 8;
	  this._delta32 = this.blockSize / 32;
	}
	common$6.BlockHash = BlockHash$4;

	BlockHash$4.prototype.update = function update(msg, enc) {
	  // Convert message to array, pad it, and join into 32bit blocks
	  msg = utils$v.toArray(msg, enc);
	  if (!this.pending)
	    this.pending = msg;
	  else
	    this.pending = this.pending.concat(msg);
	  this.pendingTotal += msg.length;

	  // Enough data, try updating
	  if (this.pending.length >= this._delta8) {
	    msg = this.pending;

	    // Process pending data in blocks
	    var r = msg.length % this._delta8;
	    this.pending = msg.slice(msg.length - r, msg.length);
	    if (this.pending.length === 0)
	      this.pending = null;

	    msg = utils$v.join32(msg, 0, msg.length - r, this.endian);
	    for (var i = 0; i < msg.length; i += this._delta32)
	      this._update(msg, i, i + this._delta32);
	  }

	  return this;
	};

	BlockHash$4.prototype.digest = function digest(enc) {
	  this.update(this._pad());
	  assert$h(this.pending === null);

	  return this._digest(enc);
	};

	BlockHash$4.prototype._pad = function pad() {
	  var len = this.pendingTotal;
	  var bytes = this._delta8;
	  var k = bytes - ((len + this.padLength) % bytes);
	  var res = new Array(k + this.padLength);
	  res[0] = 0x80;
	  for (var i = 1; i < k; i++)
	    res[i] = 0;

	  // Append length
	  len <<= 3;
	  if (this.endian === 'big') {
	    for (var t = 8; t < this.padLength; t++)
	      res[i++] = 0;

	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = (len >>> 24) & 0xff;
	    res[i++] = (len >>> 16) & 0xff;
	    res[i++] = (len >>> 8) & 0xff;
	    res[i++] = len & 0xff;
	  } else {
	    res[i++] = len & 0xff;
	    res[i++] = (len >>> 8) & 0xff;
	    res[i++] = (len >>> 16) & 0xff;
	    res[i++] = (len >>> 24) & 0xff;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;

	    for (t = 8; t < this.padLength; t++)
	      res[i++] = 0;
	  }

	  return res;
	};

	var sha$1 = {};

	var common$5 = {};

	var utils$u = utils$w;
	var rotr32 = utils$u.rotr32;

	function ft_1$1(s, x, y, z) {
	  if (s === 0)
	    return ch32$1(x, y, z);
	  if (s === 1 || s === 3)
	    return p32(x, y, z);
	  if (s === 2)
	    return maj32$1(x, y, z);
	}
	common$5.ft_1 = ft_1$1;

	function ch32$1(x, y, z) {
	  return (x & y) ^ ((~x) & z);
	}
	common$5.ch32 = ch32$1;

	function maj32$1(x, y, z) {
	  return (x & y) ^ (x & z) ^ (y & z);
	}
	common$5.maj32 = maj32$1;

	function p32(x, y, z) {
	  return x ^ y ^ z;
	}
	common$5.p32 = p32;

	function s0_256$1(x) {
	  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
	}
	common$5.s0_256 = s0_256$1;

	function s1_256$1(x) {
	  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
	}
	common$5.s1_256 = s1_256$1;

	function g0_256$1(x) {
	  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
	}
	common$5.g0_256 = g0_256$1;

	function g1_256$1(x) {
	  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
	}
	common$5.g1_256 = g1_256$1;

	var utils$t = utils$w;
	var common$4 = common$6;
	var shaCommon$1 = common$5;

	var rotl32$1 = utils$t.rotl32;
	var sum32$2 = utils$t.sum32;
	var sum32_5$1 = utils$t.sum32_5;
	var ft_1 = shaCommon$1.ft_1;
	var BlockHash$3 = common$4.BlockHash;

	var sha1_K = [
	  0x5A827999, 0x6ED9EBA1,
	  0x8F1BBCDC, 0xCA62C1D6
	];

	function SHA1() {
	  if (!(this instanceof SHA1))
	    return new SHA1();

	  BlockHash$3.call(this);
	  this.h = [
	    0x67452301, 0xefcdab89, 0x98badcfe,
	    0x10325476, 0xc3d2e1f0 ];
	  this.W = new Array(80);
	}

	utils$t.inherits(SHA1, BlockHash$3);
	var _1 = SHA1;

	SHA1.blockSize = 512;
	SHA1.outSize = 160;
	SHA1.hmacStrength = 80;
	SHA1.padLength = 64;

	SHA1.prototype._update = function _update(msg, start) {
	  var W = this.W;

	  for (var i = 0; i < 16; i++)
	    W[i] = msg[start + i];

	  for(; i < W.length; i++)
	    W[i] = rotl32$1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

	  var a = this.h[0];
	  var b = this.h[1];
	  var c = this.h[2];
	  var d = this.h[3];
	  var e = this.h[4];

	  for (i = 0; i < W.length; i++) {
	    var s = ~~(i / 20);
	    var t = sum32_5$1(rotl32$1(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
	    e = d;
	    d = c;
	    c = rotl32$1(b, 30);
	    b = a;
	    a = t;
	  }

	  this.h[0] = sum32$2(this.h[0], a);
	  this.h[1] = sum32$2(this.h[1], b);
	  this.h[2] = sum32$2(this.h[2], c);
	  this.h[3] = sum32$2(this.h[3], d);
	  this.h[4] = sum32$2(this.h[4], e);
	};

	SHA1.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils$t.toHex32(this.h, 'big');
	  else
	    return utils$t.split32(this.h, 'big');
	};

	var utils$s = utils$w;
	var common$3 = common$6;
	var shaCommon = common$5;
	var assert$g = minimalisticAssert$1;

	var sum32$1 = utils$s.sum32;
	var sum32_4$1 = utils$s.sum32_4;
	var sum32_5 = utils$s.sum32_5;
	var ch32 = shaCommon.ch32;
	var maj32 = shaCommon.maj32;
	var s0_256 = shaCommon.s0_256;
	var s1_256 = shaCommon.s1_256;
	var g0_256 = shaCommon.g0_256;
	var g1_256 = shaCommon.g1_256;

	var BlockHash$2 = common$3.BlockHash;

	var sha256_K = [
	  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
	  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
	  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
	  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
	  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
	  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
	  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
	  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
	  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
	  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
	  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
	  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
	  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
	  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
	  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
	  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
	];

	function SHA256$1() {
	  if (!(this instanceof SHA256$1))
	    return new SHA256$1();

	  BlockHash$2.call(this);
	  this.h = [
	    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
	    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
	  ];
	  this.k = sha256_K;
	  this.W = new Array(64);
	}
	utils$s.inherits(SHA256$1, BlockHash$2);
	var _256 = SHA256$1;

	SHA256$1.blockSize = 512;
	SHA256$1.outSize = 256;
	SHA256$1.hmacStrength = 192;
	SHA256$1.padLength = 64;

	SHA256$1.prototype._update = function _update(msg, start) {
	  var W = this.W;

	  for (var i = 0; i < 16; i++)
	    W[i] = msg[start + i];
	  for (; i < W.length; i++)
	    W[i] = sum32_4$1(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

	  var a = this.h[0];
	  var b = this.h[1];
	  var c = this.h[2];
	  var d = this.h[3];
	  var e = this.h[4];
	  var f = this.h[5];
	  var g = this.h[6];
	  var h = this.h[7];

	  assert$g(this.k.length === W.length);
	  for (i = 0; i < W.length; i++) {
	    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
	    var T2 = sum32$1(s0_256(a), maj32(a, b, c));
	    h = g;
	    g = f;
	    f = e;
	    e = sum32$1(d, T1);
	    d = c;
	    c = b;
	    b = a;
	    a = sum32$1(T1, T2);
	  }

	  this.h[0] = sum32$1(this.h[0], a);
	  this.h[1] = sum32$1(this.h[1], b);
	  this.h[2] = sum32$1(this.h[2], c);
	  this.h[3] = sum32$1(this.h[3], d);
	  this.h[4] = sum32$1(this.h[4], e);
	  this.h[5] = sum32$1(this.h[5], f);
	  this.h[6] = sum32$1(this.h[6], g);
	  this.h[7] = sum32$1(this.h[7], h);
	};

	SHA256$1.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils$s.toHex32(this.h, 'big');
	  else
	    return utils$s.split32(this.h, 'big');
	};

	var utils$r = utils$w;
	var SHA256 = _256;

	function SHA224() {
	  if (!(this instanceof SHA224))
	    return new SHA224();

	  SHA256.call(this);
	  this.h = [
	    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
	}
	utils$r.inherits(SHA224, SHA256);
	var _224 = SHA224;

	SHA224.blockSize = 512;
	SHA224.outSize = 224;
	SHA224.hmacStrength = 192;
	SHA224.padLength = 64;

	SHA224.prototype._digest = function digest(enc) {
	  // Just truncate output
	  if (enc === 'hex')
	    return utils$r.toHex32(this.h.slice(0, 7), 'big');
	  else
	    return utils$r.split32(this.h.slice(0, 7), 'big');
	};

	var utils$q = utils$w;
	var common$2 = common$6;
	var assert$f = minimalisticAssert$1;

	var rotr64_hi = utils$q.rotr64_hi;
	var rotr64_lo = utils$q.rotr64_lo;
	var shr64_hi = utils$q.shr64_hi;
	var shr64_lo = utils$q.shr64_lo;
	var sum64 = utils$q.sum64;
	var sum64_hi = utils$q.sum64_hi;
	var sum64_lo = utils$q.sum64_lo;
	var sum64_4_hi = utils$q.sum64_4_hi;
	var sum64_4_lo = utils$q.sum64_4_lo;
	var sum64_5_hi = utils$q.sum64_5_hi;
	var sum64_5_lo = utils$q.sum64_5_lo;

	var BlockHash$1 = common$2.BlockHash;

	var sha512_K = [
	  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	];

	function SHA512$2() {
	  if (!(this instanceof SHA512$2))
	    return new SHA512$2();

	  BlockHash$1.call(this);
	  this.h = [
	    0x6a09e667, 0xf3bcc908,
	    0xbb67ae85, 0x84caa73b,
	    0x3c6ef372, 0xfe94f82b,
	    0xa54ff53a, 0x5f1d36f1,
	    0x510e527f, 0xade682d1,
	    0x9b05688c, 0x2b3e6c1f,
	    0x1f83d9ab, 0xfb41bd6b,
	    0x5be0cd19, 0x137e2179 ];
	  this.k = sha512_K;
	  this.W = new Array(160);
	}
	utils$q.inherits(SHA512$2, BlockHash$1);
	var _512 = SHA512$2;

	SHA512$2.blockSize = 1024;
	SHA512$2.outSize = 512;
	SHA512$2.hmacStrength = 192;
	SHA512$2.padLength = 128;

	SHA512$2.prototype._prepareBlock = function _prepareBlock(msg, start) {
	  var W = this.W;

	  // 32 x 32bit words
	  for (var i = 0; i < 32; i++)
	    W[i] = msg[start + i];
	  for (; i < W.length; i += 2) {
	    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
	    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
	    var c1_hi = W[i - 14];  // i - 7
	    var c1_lo = W[i - 13];
	    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
	    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
	    var c3_hi = W[i - 32];  // i - 16
	    var c3_lo = W[i - 31];

	    W[i] = sum64_4_hi(
	      c0_hi, c0_lo,
	      c1_hi, c1_lo,
	      c2_hi, c2_lo,
	      c3_hi, c3_lo);
	    W[i + 1] = sum64_4_lo(
	      c0_hi, c0_lo,
	      c1_hi, c1_lo,
	      c2_hi, c2_lo,
	      c3_hi, c3_lo);
	  }
	};

	SHA512$2.prototype._update = function _update(msg, start) {
	  this._prepareBlock(msg, start);

	  var W = this.W;

	  var ah = this.h[0];
	  var al = this.h[1];
	  var bh = this.h[2];
	  var bl = this.h[3];
	  var ch = this.h[4];
	  var cl = this.h[5];
	  var dh = this.h[6];
	  var dl = this.h[7];
	  var eh = this.h[8];
	  var el = this.h[9];
	  var fh = this.h[10];
	  var fl = this.h[11];
	  var gh = this.h[12];
	  var gl = this.h[13];
	  var hh = this.h[14];
	  var hl = this.h[15];

	  assert$f(this.k.length === W.length);
	  for (var i = 0; i < W.length; i += 2) {
	    var c0_hi = hh;
	    var c0_lo = hl;
	    var c1_hi = s1_512_hi(eh, el);
	    var c1_lo = s1_512_lo(eh, el);
	    var c2_hi = ch64_hi(eh, el, fh, fl, gh);
	    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
	    var c3_hi = this.k[i];
	    var c3_lo = this.k[i + 1];
	    var c4_hi = W[i];
	    var c4_lo = W[i + 1];

	    var T1_hi = sum64_5_hi(
	      c0_hi, c0_lo,
	      c1_hi, c1_lo,
	      c2_hi, c2_lo,
	      c3_hi, c3_lo,
	      c4_hi, c4_lo);
	    var T1_lo = sum64_5_lo(
	      c0_hi, c0_lo,
	      c1_hi, c1_lo,
	      c2_hi, c2_lo,
	      c3_hi, c3_lo,
	      c4_hi, c4_lo);

	    c0_hi = s0_512_hi(ah, al);
	    c0_lo = s0_512_lo(ah, al);
	    c1_hi = maj64_hi(ah, al, bh, bl, ch);
	    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

	    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
	    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

	    hh = gh;
	    hl = gl;

	    gh = fh;
	    gl = fl;

	    fh = eh;
	    fl = el;

	    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
	    el = sum64_lo(dl, dl, T1_hi, T1_lo);

	    dh = ch;
	    dl = cl;

	    ch = bh;
	    cl = bl;

	    bh = ah;
	    bl = al;

	    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
	    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
	  }

	  sum64(this.h, 0, ah, al);
	  sum64(this.h, 2, bh, bl);
	  sum64(this.h, 4, ch, cl);
	  sum64(this.h, 6, dh, dl);
	  sum64(this.h, 8, eh, el);
	  sum64(this.h, 10, fh, fl);
	  sum64(this.h, 12, gh, gl);
	  sum64(this.h, 14, hh, hl);
	};

	SHA512$2.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils$q.toHex32(this.h, 'big');
	  else
	    return utils$q.split32(this.h, 'big');
	};

	function ch64_hi(xh, xl, yh, yl, zh) {
	  var r = (xh & yh) ^ ((~xh) & zh);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function ch64_lo(xh, xl, yh, yl, zh, zl) {
	  var r = (xl & yl) ^ ((~xl) & zl);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function maj64_hi(xh, xl, yh, yl, zh) {
	  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function maj64_lo(xh, xl, yh, yl, zh, zl) {
	  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function s0_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 28);
	  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
	  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function s0_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 28);
	  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
	  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function s1_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 14);
	  var c1_hi = rotr64_hi(xh, xl, 18);
	  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function s1_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 14);
	  var c1_lo = rotr64_lo(xh, xl, 18);
	  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function g0_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 1);
	  var c1_hi = rotr64_hi(xh, xl, 8);
	  var c2_hi = shr64_hi(xh, xl, 7);

	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function g0_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 1);
	  var c1_lo = rotr64_lo(xh, xl, 8);
	  var c2_lo = shr64_lo(xh, xl, 7);

	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function g1_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 19);
	  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
	  var c2_hi = shr64_hi(xh, xl, 6);

	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	function g1_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 19);
	  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
	  var c2_lo = shr64_lo(xh, xl, 6);

	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}

	var utils$p = utils$w;

	var SHA512$1 = _512;

	function SHA384() {
	  if (!(this instanceof SHA384))
	    return new SHA384();

	  SHA512$1.call(this);
	  this.h = [
	    0xcbbb9d5d, 0xc1059ed8,
	    0x629a292a, 0x367cd507,
	    0x9159015a, 0x3070dd17,
	    0x152fecd8, 0xf70e5939,
	    0x67332667, 0xffc00b31,
	    0x8eb44a87, 0x68581511,
	    0xdb0c2e0d, 0x64f98fa7,
	    0x47b5481d, 0xbefa4fa4 ];
	}
	utils$p.inherits(SHA384, SHA512$1);
	var _384 = SHA384;

	SHA384.blockSize = 1024;
	SHA384.outSize = 384;
	SHA384.hmacStrength = 192;
	SHA384.padLength = 128;

	SHA384.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils$p.toHex32(this.h.slice(0, 12), 'big');
	  else
	    return utils$p.split32(this.h.slice(0, 12), 'big');
	};

	sha$1.sha1 = _1;
	sha$1.sha224 = _224;
	sha$1.sha256 = _256;
	sha$1.sha384 = _384;
	sha$1.sha512 = _512;

	var ripemd = {};

	var utils$o = utils$w;
	var common$1 = common$6;

	var rotl32 = utils$o.rotl32;
	var sum32 = utils$o.sum32;
	var sum32_3 = utils$o.sum32_3;
	var sum32_4 = utils$o.sum32_4;
	var BlockHash = common$1.BlockHash;

	function RIPEMD160() {
	  if (!(this instanceof RIPEMD160))
	    return new RIPEMD160();

	  BlockHash.call(this);

	  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
	  this.endian = 'little';
	}
	utils$o.inherits(RIPEMD160, BlockHash);
	ripemd.ripemd160 = RIPEMD160;

	RIPEMD160.blockSize = 512;
	RIPEMD160.outSize = 160;
	RIPEMD160.hmacStrength = 192;
	RIPEMD160.padLength = 64;

	RIPEMD160.prototype._update = function update(msg, start) {
	  var A = this.h[0];
	  var B = this.h[1];
	  var C = this.h[2];
	  var D = this.h[3];
	  var E = this.h[4];
	  var Ah = A;
	  var Bh = B;
	  var Ch = C;
	  var Dh = D;
	  var Eh = E;
	  for (var j = 0; j < 80; j++) {
	    var T = sum32(
	      rotl32(
	        sum32_4(A, f$4(j, B, C, D), msg[r$8[j] + start], K$8(j)),
	        s$7[j]),
	      E);
	    A = E;
	    E = D;
	    D = rotl32(C, 10);
	    C = B;
	    B = T;
	    T = sum32(
	      rotl32(
	        sum32_4(Ah, f$4(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
	        sh[j]),
	      Eh);
	    Ah = Eh;
	    Eh = Dh;
	    Dh = rotl32(Ch, 10);
	    Ch = Bh;
	    Bh = T;
	  }
	  T = sum32_3(this.h[1], C, Dh);
	  this.h[1] = sum32_3(this.h[2], D, Eh);
	  this.h[2] = sum32_3(this.h[3], E, Ah);
	  this.h[3] = sum32_3(this.h[4], A, Bh);
	  this.h[4] = sum32_3(this.h[0], B, Ch);
	  this.h[0] = T;
	};

	RIPEMD160.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils$o.toHex32(this.h, 'little');
	  else
	    return utils$o.split32(this.h, 'little');
	};

	function f$4(j, x, y, z) {
	  if (j <= 15)
	    return x ^ y ^ z;
	  else if (j <= 31)
	    return (x & y) | ((~x) & z);
	  else if (j <= 47)
	    return (x | (~y)) ^ z;
	  else if (j <= 63)
	    return (x & z) | (y & (~z));
	  else
	    return x ^ (y | (~z));
	}

	function K$8(j) {
	  if (j <= 15)
	    return 0x00000000;
	  else if (j <= 31)
	    return 0x5a827999;
	  else if (j <= 47)
	    return 0x6ed9eba1;
	  else if (j <= 63)
	    return 0x8f1bbcdc;
	  else
	    return 0xa953fd4e;
	}

	function Kh(j) {
	  if (j <= 15)
	    return 0x50a28be6;
	  else if (j <= 31)
	    return 0x5c4dd124;
	  else if (j <= 47)
	    return 0x6d703ef3;
	  else if (j <= 63)
	    return 0x7a6d76e9;
	  else
	    return 0x00000000;
	}

	var r$8 = [
	  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
	  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
	  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
	  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
	  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
	];

	var rh = [
	  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
	  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
	  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
	  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
	  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
	];

	var s$7 = [
	  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
	  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
	  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
	  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
	  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
	];

	var sh = [
	  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
	  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
	  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
	  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
	  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
	];

	var utils$n = utils$w;
	var assert$e = minimalisticAssert$1;

	function Hmac(hash, key, enc) {
	  if (!(this instanceof Hmac))
	    return new Hmac(hash, key, enc);
	  this.Hash = hash;
	  this.blockSize = hash.blockSize / 8;
	  this.outSize = hash.outSize / 8;
	  this.inner = null;
	  this.outer = null;

	  this._init(utils$n.toArray(key, enc));
	}
	var hmac = Hmac;

	Hmac.prototype._init = function init(key) {
	  // Shorten key, if needed
	  if (key.length > this.blockSize)
	    key = new this.Hash().update(key).digest();
	  assert$e(key.length <= this.blockSize);

	  // Add padding to key
	  for (var i = key.length; i < this.blockSize; i++)
	    key.push(0);

	  for (i = 0; i < key.length; i++)
	    key[i] ^= 0x36;
	  this.inner = new this.Hash().update(key);

	  // 0x36 ^ 0x5c = 0x6a
	  for (i = 0; i < key.length; i++)
	    key[i] ^= 0x6a;
	  this.outer = new this.Hash().update(key);
	};

	Hmac.prototype.update = function update(msg, enc) {
	  this.inner.update(msg, enc);
	  return this;
	};

	Hmac.prototype.digest = function digest(enc) {
	  this.outer.update(this.inner.digest());
	  return this.outer.digest(enc);
	};

	(function (exports) {
		var hash = exports;

		hash.utils = utils$w;
		hash.common = common$6;
		hash.sha = sha$1;
		hash.ripemd = ripemd;
		hash.hmac = hmac;

		// Proxy hash functions to the main object
		hash.sha1 = hash.sha.sha1;
		hash.sha256 = hash.sha.sha256;
		hash.sha224 = hash.sha.sha224;
		hash.sha384 = hash.sha.sha384;
		hash.sha512 = hash.sha.sha512;
		hash.ripemd160 = hash.ripemd.ripemd160; 
	} (hash$4));

	var hash$3 = /*@__PURE__*/getDefaultExportFromCjs(hash$4);

	function createCommonjsModule(fn, basedir, module) {
		return module = {
			path: basedir,
			exports: {},
			require: function (path, base) {
				return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
			}
		}, fn(module, module.exports), module.exports;
	}

	function commonjsRequire () {
		throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	}

	var minimalisticAssert = assert$d;

	function assert$d(val, msg) {
	  if (!val)
	    throw new Error(msg || 'Assertion failed');
	}

	assert$d.equal = function assertEqual(l, r, msg) {
	  if (l != r)
	    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
	};

	var utils_1$2 = createCommonjsModule(function (module, exports) {

	var utils = exports;

	function toArray(msg, enc) {
	  if (Array.isArray(msg))
	    return msg.slice();
	  if (!msg)
	    return [];
	  var res = [];
	  if (typeof msg !== 'string') {
	    for (var i = 0; i < msg.length; i++)
	      res[i] = msg[i] | 0;
	    return res;
	  }
	  if (enc === 'hex') {
	    msg = msg.replace(/[^a-z0-9]+/ig, '');
	    if (msg.length % 2 !== 0)
	      msg = '0' + msg;
	    for (var i = 0; i < msg.length; i += 2)
	      res.push(parseInt(msg[i] + msg[i + 1], 16));
	  } else {
	    for (var i = 0; i < msg.length; i++) {
	      var c = msg.charCodeAt(i);
	      var hi = c >> 8;
	      var lo = c & 0xff;
	      if (hi)
	        res.push(hi, lo);
	      else
	        res.push(lo);
	    }
	  }
	  return res;
	}
	utils.toArray = toArray;

	function zero2(word) {
	  if (word.length === 1)
	    return '0' + word;
	  else
	    return word;
	}
	utils.zero2 = zero2;

	function toHex(msg) {
	  var res = '';
	  for (var i = 0; i < msg.length; i++)
	    res += zero2(msg[i].toString(16));
	  return res;
	}
	utils.toHex = toHex;

	utils.encode = function encode(arr, enc) {
	  if (enc === 'hex')
	    return toHex(arr);
	  else
	    return arr;
	};
	});

	var utils_1$1$1 = createCommonjsModule(function (module, exports) {

	var utils = exports;




	utils.assert = minimalisticAssert;
	utils.toArray = utils_1$2.toArray;
	utils.zero2 = utils_1$2.zero2;
	utils.toHex = utils_1$2.toHex;
	utils.encode = utils_1$2.encode;

	// Represent num in a w-NAF form
	function getNAF(num, w, bits) {
	  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
	  naf.fill(0);

	  var ws = 1 << (w + 1);
	  var k = num.clone();

	  for (var i = 0; i < naf.length; i++) {
	    var z;
	    var mod = k.andln(ws - 1);
	    if (k.isOdd()) {
	      if (mod > (ws >> 1) - 1)
	        z = (ws >> 1) - mod;
	      else
	        z = mod;
	      k.isubn(z);
	    } else {
	      z = 0;
	    }

	    naf[i] = z;
	    k.iushrn(1);
	  }

	  return naf;
	}
	utils.getNAF = getNAF;

	// Represent k1, k2 in a Joint Sparse Form
	function getJSF(k1, k2) {
	  var jsf = [
	    [],
	    [],
	  ];

	  k1 = k1.clone();
	  k2 = k2.clone();
	  var d1 = 0;
	  var d2 = 0;
	  var m8;
	  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
	    // First phase
	    var m14 = (k1.andln(3) + d1) & 3;
	    var m24 = (k2.andln(3) + d2) & 3;
	    if (m14 === 3)
	      m14 = -1;
	    if (m24 === 3)
	      m24 = -1;
	    var u1;
	    if ((m14 & 1) === 0) {
	      u1 = 0;
	    } else {
	      m8 = (k1.andln(7) + d1) & 7;
	      if ((m8 === 3 || m8 === 5) && m24 === 2)
	        u1 = -m14;
	      else
	        u1 = m14;
	    }
	    jsf[0].push(u1);

	    var u2;
	    if ((m24 & 1) === 0) {
	      u2 = 0;
	    } else {
	      m8 = (k2.andln(7) + d2) & 7;
	      if ((m8 === 3 || m8 === 5) && m14 === 2)
	        u2 = -m24;
	      else
	        u2 = m24;
	    }
	    jsf[1].push(u2);

	    // Second phase
	    if (2 * d1 === u1 + 1)
	      d1 = 1 - d1;
	    if (2 * d2 === u2 + 1)
	      d2 = 1 - d2;
	    k1.iushrn(1);
	    k2.iushrn(1);
	  }

	  return jsf;
	}
	utils.getJSF = getJSF;

	function cachedProperty(obj, name, computer) {
	  var key = '_' + name;
	  obj.prototype[name] = function cachedProperty() {
	    return this[key] !== undefined ? this[key] :
	      this[key] = computer.call(this);
	  };
	}
	utils.cachedProperty = cachedProperty;

	function parseBytes(bytes) {
	  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
	    bytes;
	}
	utils.parseBytes = parseBytes;

	function intFromLE(bytes) {
	  return new BN$b(bytes, 'hex', 'le');
	}
	utils.intFromLE = intFromLE;
	});



	var getNAF$1 = utils_1$1$1.getNAF;
	var getJSF$1 = utils_1$1$1.getJSF;
	var assert$1$1 = utils_1$1$1.assert;

	function BaseCurve$1(type, conf) {
	  this.type = type;
	  this.p = new BN$b(conf.p, 16);

	  // Use Montgomery, when there is no fast reduction for the prime
	  this.red = conf.prime ? BN$b.red(conf.prime) : BN$b.mont(this.p);

	  // Useful for many curves
	  this.zero = new BN$b(0).toRed(this.red);
	  this.one = new BN$b(1).toRed(this.red);
	  this.two = new BN$b(2).toRed(this.red);

	  // Curve configuration, optional
	  this.n = conf.n && new BN$b(conf.n, 16);
	  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

	  // Temporary arrays
	  this._wnafT1 = new Array(4);
	  this._wnafT2 = new Array(4);
	  this._wnafT3 = new Array(4);
	  this._wnafT4 = new Array(4);

	  this._bitLength = this.n ? this.n.bitLength() : 0;

	  // Generalized Greg Maxwell's trick
	  var adjustCount = this.n && this.p.div(this.n);
	  if (!adjustCount || adjustCount.cmpn(100) > 0) {
	    this.redN = null;
	  } else {
	    this._maxwellTrick = true;
	    this.redN = this.n.toRed(this.red);
	  }
	}
	var base$1 = BaseCurve$1;

	BaseCurve$1.prototype.point = function point() {
	  throw new Error('Not implemented');
	};

	BaseCurve$1.prototype.validate = function validate() {
	  throw new Error('Not implemented');
	};

	BaseCurve$1.prototype._fixedNafMul = function _fixedNafMul(p, k) {
	  assert$1$1(p.precomputed);
	  var doubles = p._getDoubles();

	  var naf = getNAF$1(k, 1, this._bitLength);
	  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
	  I /= 3;

	  // Translate into more windowed form
	  var repr = [];
	  var j;
	  var nafW;
	  for (j = 0; j < naf.length; j += doubles.step) {
	    nafW = 0;
	    for (var l = j + doubles.step - 1; l >= j; l--)
	      nafW = (nafW << 1) + naf[l];
	    repr.push(nafW);
	  }

	  var a = this.jpoint(null, null, null);
	  var b = this.jpoint(null, null, null);
	  for (var i = I; i > 0; i--) {
	    for (j = 0; j < repr.length; j++) {
	      nafW = repr[j];
	      if (nafW === i)
	        b = b.mixedAdd(doubles.points[j]);
	      else if (nafW === -i)
	        b = b.mixedAdd(doubles.points[j].neg());
	    }
	    a = a.add(b);
	  }
	  return a.toP();
	};

	BaseCurve$1.prototype._wnafMul = function _wnafMul(p, k) {
	  var w = 4;

	  // Precompute window
	  var nafPoints = p._getNAFPoints(w);
	  w = nafPoints.wnd;
	  var wnd = nafPoints.points;

	  // Get NAF form
	  var naf = getNAF$1(k, w, this._bitLength);

	  // Add `this`*(N+1) for every w-NAF index
	  var acc = this.jpoint(null, null, null);
	  for (var i = naf.length - 1; i >= 0; i--) {
	    // Count zeroes
	    for (var l = 0; i >= 0 && naf[i] === 0; i--)
	      l++;
	    if (i >= 0)
	      l++;
	    acc = acc.dblp(l);

	    if (i < 0)
	      break;
	    var z = naf[i];
	    assert$1$1(z !== 0);
	    if (p.type === 'affine') {
	      // J +- P
	      if (z > 0)
	        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
	      else
	        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
	    } else {
	      // J +- J
	      if (z > 0)
	        acc = acc.add(wnd[(z - 1) >> 1]);
	      else
	        acc = acc.add(wnd[(-z - 1) >> 1].neg());
	    }
	  }
	  return p.type === 'affine' ? acc.toP() : acc;
	};

	BaseCurve$1.prototype._wnafMulAdd = function _wnafMulAdd(defW,
	  points,
	  coeffs,
	  len,
	  jacobianResult) {
	  var wndWidth = this._wnafT1;
	  var wnd = this._wnafT2;
	  var naf = this._wnafT3;

	  // Fill all arrays
	  var max = 0;
	  var i;
	  var j;
	  var p;
	  for (i = 0; i < len; i++) {
	    p = points[i];
	    var nafPoints = p._getNAFPoints(defW);
	    wndWidth[i] = nafPoints.wnd;
	    wnd[i] = nafPoints.points;
	  }

	  // Comb small window NAFs
	  for (i = len - 1; i >= 1; i -= 2) {
	    var a = i - 1;
	    var b = i;
	    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
	      naf[a] = getNAF$1(coeffs[a], wndWidth[a], this._bitLength);
	      naf[b] = getNAF$1(coeffs[b], wndWidth[b], this._bitLength);
	      max = Math.max(naf[a].length, max);
	      max = Math.max(naf[b].length, max);
	      continue;
	    }

	    var comb = [
	      points[a], /* 1 */
	      null, /* 3 */
	      null, /* 5 */
	      points[b], /* 7 */
	    ];

	    // Try to avoid Projective points, if possible
	    if (points[a].y.cmp(points[b].y) === 0) {
	      comb[1] = points[a].add(points[b]);
	      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
	    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
	      comb[1] = points[a].toJ().mixedAdd(points[b]);
	      comb[2] = points[a].add(points[b].neg());
	    } else {
	      comb[1] = points[a].toJ().mixedAdd(points[b]);
	      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
	    }

	    var index = [
	      -3, /* -1 -1 */
	      -1, /* -1 0 */
	      -5, /* -1 1 */
	      -7, /* 0 -1 */
	      0, /* 0 0 */
	      7, /* 0 1 */
	      5, /* 1 -1 */
	      1, /* 1 0 */
	      3,  /* 1 1 */
	    ];

	    var jsf = getJSF$1(coeffs[a], coeffs[b]);
	    max = Math.max(jsf[0].length, max);
	    naf[a] = new Array(max);
	    naf[b] = new Array(max);
	    for (j = 0; j < max; j++) {
	      var ja = jsf[0][j] | 0;
	      var jb = jsf[1][j] | 0;

	      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
	      naf[b][j] = 0;
	      wnd[a] = comb;
	    }
	  }

	  var acc = this.jpoint(null, null, null);
	  var tmp = this._wnafT4;
	  for (i = max; i >= 0; i--) {
	    var k = 0;

	    while (i >= 0) {
	      var zero = true;
	      for (j = 0; j < len; j++) {
	        tmp[j] = naf[j][i] | 0;
	        if (tmp[j] !== 0)
	          zero = false;
	      }
	      if (!zero)
	        break;
	      k++;
	      i--;
	    }
	    if (i >= 0)
	      k++;
	    acc = acc.dblp(k);
	    if (i < 0)
	      break;

	    for (j = 0; j < len; j++) {
	      var z = tmp[j];
	      if (z === 0)
	        continue;
	      else if (z > 0)
	        p = wnd[j][(z - 1) >> 1];
	      else if (z < 0)
	        p = wnd[j][(-z - 1) >> 1].neg();

	      if (p.type === 'affine')
	        acc = acc.mixedAdd(p);
	      else
	        acc = acc.add(p);
	    }
	  }
	  // Zeroify references
	  for (i = 0; i < len; i++)
	    wnd[i] = null;

	  if (jacobianResult)
	    return acc;
	  else
	    return acc.toP();
	};

	function BasePoint$1(curve, type) {
	  this.curve = curve;
	  this.type = type;
	  this.precomputed = null;
	}
	BaseCurve$1.BasePoint = BasePoint$1;

	BasePoint$1.prototype.eq = function eq(/*other*/) {
	  throw new Error('Not implemented');
	};

	BasePoint$1.prototype.validate = function validate() {
	  return this.curve.validate(this);
	};

	BaseCurve$1.prototype.decodePoint = function decodePoint(bytes, enc) {
	  bytes = utils_1$1$1.toArray(bytes, enc);

	  var len = this.p.byteLength();

	  // uncompressed, hybrid-odd, hybrid-even
	  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
	      bytes.length - 1 === 2 * len) {
	    if (bytes[0] === 0x06)
	      assert$1$1(bytes[bytes.length - 1] % 2 === 0);
	    else if (bytes[0] === 0x07)
	      assert$1$1(bytes[bytes.length - 1] % 2 === 1);

	    var res =  this.point(bytes.slice(1, 1 + len),
	      bytes.slice(1 + len, 1 + 2 * len));

	    return res;
	  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
	              bytes.length - 1 === len) {
	    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
	  }
	  throw new Error('Unknown point format');
	};

	BasePoint$1.prototype.encodeCompressed = function encodeCompressed(enc) {
	  return this.encode(enc, true);
	};

	BasePoint$1.prototype._encode = function _encode(compact) {
	  var len = this.curve.p.byteLength();
	  var x = this.getX().toArray('be', len);

	  if (compact)
	    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

	  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
	};

	BasePoint$1.prototype.encode = function encode(enc, compact) {
	  return utils_1$1$1.encode(this._encode(compact), enc);
	};

	BasePoint$1.prototype.precompute = function precompute(power) {
	  if (this.precomputed)
	    return this;

	  var precomputed = {
	    doubles: null,
	    naf: null,
	    beta: null,
	  };
	  precomputed.naf = this._getNAFPoints(8);
	  precomputed.doubles = this._getDoubles(4, power);
	  precomputed.beta = this._getBeta();
	  this.precomputed = precomputed;

	  return this;
	};

	BasePoint$1.prototype._hasDoubles = function _hasDoubles(k) {
	  if (!this.precomputed)
	    return false;

	  var doubles = this.precomputed.doubles;
	  if (!doubles)
	    return false;

	  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
	};

	BasePoint$1.prototype._getDoubles = function _getDoubles(step, power) {
	  if (this.precomputed && this.precomputed.doubles)
	    return this.precomputed.doubles;

	  var doubles = [ this ];
	  var acc = this;
	  for (var i = 0; i < power; i += step) {
	    for (var j = 0; j < step; j++)
	      acc = acc.dbl();
	    doubles.push(acc);
	  }
	  return {
	    step: step,
	    points: doubles,
	  };
	};

	BasePoint$1.prototype._getNAFPoints = function _getNAFPoints(wnd) {
	  if (this.precomputed && this.precomputed.naf)
	    return this.precomputed.naf;

	  var res = [ this ];
	  var max = (1 << wnd) - 1;
	  var dbl = max === 1 ? null : this.dbl();
	  for (var i = 1; i < max; i++)
	    res[i] = res[i - 1].add(dbl);
	  return {
	    wnd: wnd,
	    points: res,
	  };
	};

	BasePoint$1.prototype._getBeta = function _getBeta() {
	  return null;
	};

	BasePoint$1.prototype.dblp = function dblp(k) {
	  var r = this;
	  for (var i = 0; i < k; i++)
	    r = r.dbl();
	  return r;
	};

	var inherits_browser = createCommonjsModule(function (module) {
	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor;
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      });
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor;
	      var TempCtor = function () {};
	      TempCtor.prototype = superCtor.prototype;
	      ctor.prototype = new TempCtor();
	      ctor.prototype.constructor = ctor;
	    }
	  };
	}
	});






	var assert$2$1 = utils_1$1$1.assert;

	function ShortCurve$1(conf) {
	  base$1.call(this, 'short', conf);

	  this.a = new BN$b(conf.a, 16).toRed(this.red);
	  this.b = new BN$b(conf.b, 16).toRed(this.red);
	  this.tinv = this.two.redInvm();

	  this.zeroA = this.a.fromRed().cmpn(0) === 0;
	  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

	  // If the curve is endomorphic, precalculate beta and lambda
	  this.endo = this._getEndomorphism(conf);
	  this._endoWnafT1 = new Array(4);
	  this._endoWnafT2 = new Array(4);
	}
	inherits_browser(ShortCurve$1, base$1);
	var short_1 = ShortCurve$1;

	ShortCurve$1.prototype._getEndomorphism = function _getEndomorphism(conf) {
	  // No efficient endomorphism
	  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
	    return;

	  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
	  var beta;
	  var lambda;
	  if (conf.beta) {
	    beta = new BN$b(conf.beta, 16).toRed(this.red);
	  } else {
	    var betas = this._getEndoRoots(this.p);
	    // Choose the smallest beta
	    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
	    beta = beta.toRed(this.red);
	  }
	  if (conf.lambda) {
	    lambda = new BN$b(conf.lambda, 16);
	  } else {
	    // Choose the lambda that is matching selected beta
	    var lambdas = this._getEndoRoots(this.n);
	    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
	      lambda = lambdas[0];
	    } else {
	      lambda = lambdas[1];
	      assert$2$1(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
	    }
	  }

	  // Get basis vectors, used for balanced length-two representation
	  var basis;
	  if (conf.basis) {
	    basis = conf.basis.map(function(vec) {
	      return {
	        a: new BN$b(vec.a, 16),
	        b: new BN$b(vec.b, 16),
	      };
	    });
	  } else {
	    basis = this._getEndoBasis(lambda);
	  }

	  return {
	    beta: beta,
	    lambda: lambda,
	    basis: basis,
	  };
	};

	ShortCurve$1.prototype._getEndoRoots = function _getEndoRoots(num) {
	  // Find roots of for x^2 + x + 1 in F
	  // Root = (-1 +- Sqrt(-3)) / 2
	  //
	  var red = num === this.p ? this.red : BN$b.mont(num);
	  var tinv = new BN$b(2).toRed(red).redInvm();
	  var ntinv = tinv.redNeg();

	  var s = new BN$b(3).toRed(red).redNeg().redSqrt().redMul(tinv);

	  var l1 = ntinv.redAdd(s).fromRed();
	  var l2 = ntinv.redSub(s).fromRed();
	  return [ l1, l2 ];
	};

	ShortCurve$1.prototype._getEndoBasis = function _getEndoBasis(lambda) {
	  // aprxSqrt >= sqrt(this.n)
	  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

	  // 3.74
	  // Run EGCD, until r(L + 1) < aprxSqrt
	  var u = lambda;
	  var v = this.n.clone();
	  var x1 = new BN$b(1);
	  var y1 = new BN$b(0);
	  var x2 = new BN$b(0);
	  var y2 = new BN$b(1);

	  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
	  var a0;
	  var b0;
	  // First vector
	  var a1;
	  var b1;
	  // Second vector
	  var a2;
	  var b2;

	  var prevR;
	  var i = 0;
	  var r;
	  var x;
	  while (u.cmpn(0) !== 0) {
	    var q = v.div(u);
	    r = v.sub(q.mul(u));
	    x = x2.sub(q.mul(x1));
	    var y = y2.sub(q.mul(y1));

	    if (!a1 && r.cmp(aprxSqrt) < 0) {
	      a0 = prevR.neg();
	      b0 = x1;
	      a1 = r.neg();
	      b1 = x;
	    } else if (a1 && ++i === 2) {
	      break;
	    }
	    prevR = r;

	    v = u;
	    u = r;
	    x2 = x1;
	    x1 = x;
	    y2 = y1;
	    y1 = y;
	  }
	  a2 = r.neg();
	  b2 = x;

	  var len1 = a1.sqr().add(b1.sqr());
	  var len2 = a2.sqr().add(b2.sqr());
	  if (len2.cmp(len1) >= 0) {
	    a2 = a0;
	    b2 = b0;
	  }

	  // Normalize signs
	  if (a1.negative) {
	    a1 = a1.neg();
	    b1 = b1.neg();
	  }
	  if (a2.negative) {
	    a2 = a2.neg();
	    b2 = b2.neg();
	  }

	  return [
	    { a: a1, b: b1 },
	    { a: a2, b: b2 },
	  ];
	};

	ShortCurve$1.prototype._endoSplit = function _endoSplit(k) {
	  var basis = this.endo.basis;
	  var v1 = basis[0];
	  var v2 = basis[1];

	  var c1 = v2.b.mul(k).divRound(this.n);
	  var c2 = v1.b.neg().mul(k).divRound(this.n);

	  var p1 = c1.mul(v1.a);
	  var p2 = c2.mul(v2.a);
	  var q1 = c1.mul(v1.b);
	  var q2 = c2.mul(v2.b);

	  // Calculate answer
	  var k1 = k.sub(p1).sub(p2);
	  var k2 = q1.add(q2).neg();
	  return { k1: k1, k2: k2 };
	};

	ShortCurve$1.prototype.pointFromX = function pointFromX(x, odd) {
	  x = new BN$b(x, 16);
	  if (!x.red)
	    x = x.toRed(this.red);

	  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
	  var y = y2.redSqrt();
	  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
	    throw new Error('invalid point');

	  // XXX Is there any way to tell if the number is odd without converting it
	  // to non-red form?
	  var isOdd = y.fromRed().isOdd();
	  if (odd && !isOdd || !odd && isOdd)
	    y = y.redNeg();

	  return this.point(x, y);
	};

	ShortCurve$1.prototype.validate = function validate(point) {
	  if (point.inf)
	    return true;

	  var x = point.x;
	  var y = point.y;

	  var ax = this.a.redMul(x);
	  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
	  return y.redSqr().redISub(rhs).cmpn(0) === 0;
	};

	ShortCurve$1.prototype._endoWnafMulAdd =
	    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
	      var npoints = this._endoWnafT1;
	      var ncoeffs = this._endoWnafT2;
	      for (var i = 0; i < points.length; i++) {
	        var split = this._endoSplit(coeffs[i]);
	        var p = points[i];
	        var beta = p._getBeta();

	        if (split.k1.negative) {
	          split.k1.ineg();
	          p = p.neg(true);
	        }
	        if (split.k2.negative) {
	          split.k2.ineg();
	          beta = beta.neg(true);
	        }

	        npoints[i * 2] = p;
	        npoints[i * 2 + 1] = beta;
	        ncoeffs[i * 2] = split.k1;
	        ncoeffs[i * 2 + 1] = split.k2;
	      }
	      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

	      // Clean-up references to points and coefficients
	      for (var j = 0; j < i * 2; j++) {
	        npoints[j] = null;
	        ncoeffs[j] = null;
	      }
	      return res;
	    };

	function Point$4(curve, x, y, isRed) {
	  base$1.BasePoint.call(this, curve, 'affine');
	  if (x === null && y === null) {
	    this.x = null;
	    this.y = null;
	    this.inf = true;
	  } else {
	    this.x = new BN$b(x, 16);
	    this.y = new BN$b(y, 16);
	    // Force redgomery representation when loading from JSON
	    if (isRed) {
	      this.x.forceRed(this.curve.red);
	      this.y.forceRed(this.curve.red);
	    }
	    if (!this.x.red)
	      this.x = this.x.toRed(this.curve.red);
	    if (!this.y.red)
	      this.y = this.y.toRed(this.curve.red);
	    this.inf = false;
	  }
	}
	inherits_browser(Point$4, base$1.BasePoint);

	ShortCurve$1.prototype.point = function point(x, y, isRed) {
	  return new Point$4(this, x, y, isRed);
	};

	ShortCurve$1.prototype.pointFromJSON = function pointFromJSON(obj, red) {
	  return Point$4.fromJSON(this, obj, red);
	};

	Point$4.prototype._getBeta = function _getBeta() {
	  if (!this.curve.endo)
	    return;

	  var pre = this.precomputed;
	  if (pre && pre.beta)
	    return pre.beta;

	  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
	  if (pre) {
	    var curve = this.curve;
	    var endoMul = function(p) {
	      return curve.point(p.x.redMul(curve.endo.beta), p.y);
	    };
	    pre.beta = beta;
	    beta.precomputed = {
	      beta: null,
	      naf: pre.naf && {
	        wnd: pre.naf.wnd,
	        points: pre.naf.points.map(endoMul),
	      },
	      doubles: pre.doubles && {
	        step: pre.doubles.step,
	        points: pre.doubles.points.map(endoMul),
	      },
	    };
	  }
	  return beta;
	};

	Point$4.prototype.toJSON = function toJSON() {
	  if (!this.precomputed)
	    return [ this.x, this.y ];

	  return [ this.x, this.y, this.precomputed && {
	    doubles: this.precomputed.doubles && {
	      step: this.precomputed.doubles.step,
	      points: this.precomputed.doubles.points.slice(1),
	    },
	    naf: this.precomputed.naf && {
	      wnd: this.precomputed.naf.wnd,
	      points: this.precomputed.naf.points.slice(1),
	    },
	  } ];
	};

	Point$4.fromJSON = function fromJSON(curve, obj, red) {
	  if (typeof obj === 'string')
	    obj = JSON.parse(obj);
	  var res = curve.point(obj[0], obj[1], red);
	  if (!obj[2])
	    return res;

	  function obj2point(obj) {
	    return curve.point(obj[0], obj[1], red);
	  }

	  var pre = obj[2];
	  res.precomputed = {
	    beta: null,
	    doubles: pre.doubles && {
	      step: pre.doubles.step,
	      points: [ res ].concat(pre.doubles.points.map(obj2point)),
	    },
	    naf: pre.naf && {
	      wnd: pre.naf.wnd,
	      points: [ res ].concat(pre.naf.points.map(obj2point)),
	    },
	  };
	  return res;
	};

	Point$4.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
	      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
	};

	Point$4.prototype.isInfinity = function isInfinity() {
	  return this.inf;
	};

	Point$4.prototype.add = function add(p) {
	  // O + P = P
	  if (this.inf)
	    return p;

	  // P + O = P
	  if (p.inf)
	    return this;

	  // P + P = 2P
	  if (this.eq(p))
	    return this.dbl();

	  // P + (-P) = O
	  if (this.neg().eq(p))
	    return this.curve.point(null, null);

	  // P + Q = O
	  if (this.x.cmp(p.x) === 0)
	    return this.curve.point(null, null);

	  var c = this.y.redSub(p.y);
	  if (c.cmpn(0) !== 0)
	    c = c.redMul(this.x.redSub(p.x).redInvm());
	  var nx = c.redSqr().redISub(this.x).redISub(p.x);
	  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
	  return this.curve.point(nx, ny);
	};

	Point$4.prototype.dbl = function dbl() {
	  if (this.inf)
	    return this;

	  // 2P = O
	  var ys1 = this.y.redAdd(this.y);
	  if (ys1.cmpn(0) === 0)
	    return this.curve.point(null, null);

	  var a = this.curve.a;

	  var x2 = this.x.redSqr();
	  var dyinv = ys1.redInvm();
	  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

	  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
	  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
	  return this.curve.point(nx, ny);
	};

	Point$4.prototype.getX = function getX() {
	  return this.x.fromRed();
	};

	Point$4.prototype.getY = function getY() {
	  return this.y.fromRed();
	};

	Point$4.prototype.mul = function mul(k) {
	  k = new BN$b(k, 16);
	  if (this.isInfinity())
	    return this;
	  else if (this._hasDoubles(k))
	    return this.curve._fixedNafMul(this, k);
	  else if (this.curve.endo)
	    return this.curve._endoWnafMulAdd([ this ], [ k ]);
	  else
	    return this.curve._wnafMul(this, k);
	};

	Point$4.prototype.mulAdd = function mulAdd(k1, p2, k2) {
	  var points = [ this, p2 ];
	  var coeffs = [ k1, k2 ];
	  if (this.curve.endo)
	    return this.curve._endoWnafMulAdd(points, coeffs);
	  else
	    return this.curve._wnafMulAdd(1, points, coeffs, 2);
	};

	Point$4.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
	  var points = [ this, p2 ];
	  var coeffs = [ k1, k2 ];
	  if (this.curve.endo)
	    return this.curve._endoWnafMulAdd(points, coeffs, true);
	  else
	    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
	};

	Point$4.prototype.eq = function eq(p) {
	  return this === p ||
	         this.inf === p.inf &&
	             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
	};

	Point$4.prototype.neg = function neg(_precompute) {
	  if (this.inf)
	    return this;

	  var res = this.curve.point(this.x, this.y.redNeg());
	  if (_precompute && this.precomputed) {
	    var pre = this.precomputed;
	    var negate = function(p) {
	      return p.neg();
	    };
	    res.precomputed = {
	      naf: pre.naf && {
	        wnd: pre.naf.wnd,
	        points: pre.naf.points.map(negate),
	      },
	      doubles: pre.doubles && {
	        step: pre.doubles.step,
	        points: pre.doubles.points.map(negate),
	      },
	    };
	  }
	  return res;
	};

	Point$4.prototype.toJ = function toJ() {
	  if (this.inf)
	    return this.curve.jpoint(null, null, null);

	  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
	  return res;
	};

	function JPoint$1(curve, x, y, z) {
	  base$1.BasePoint.call(this, curve, 'jacobian');
	  if (x === null && y === null && z === null) {
	    this.x = this.curve.one;
	    this.y = this.curve.one;
	    this.z = new BN$b(0);
	  } else {
	    this.x = new BN$b(x, 16);
	    this.y = new BN$b(y, 16);
	    this.z = new BN$b(z, 16);
	  }
	  if (!this.x.red)
	    this.x = this.x.toRed(this.curve.red);
	  if (!this.y.red)
	    this.y = this.y.toRed(this.curve.red);
	  if (!this.z.red)
	    this.z = this.z.toRed(this.curve.red);

	  this.zOne = this.z === this.curve.one;
	}
	inherits_browser(JPoint$1, base$1.BasePoint);

	ShortCurve$1.prototype.jpoint = function jpoint(x, y, z) {
	  return new JPoint$1(this, x, y, z);
	};

	JPoint$1.prototype.toP = function toP() {
	  if (this.isInfinity())
	    return this.curve.point(null, null);

	  var zinv = this.z.redInvm();
	  var zinv2 = zinv.redSqr();
	  var ax = this.x.redMul(zinv2);
	  var ay = this.y.redMul(zinv2).redMul(zinv);

	  return this.curve.point(ax, ay);
	};

	JPoint$1.prototype.neg = function neg() {
	  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
	};

	JPoint$1.prototype.add = function add(p) {
	  // O + P = P
	  if (this.isInfinity())
	    return p;

	  // P + O = P
	  if (p.isInfinity())
	    return this;

	  // 12M + 4S + 7A
	  var pz2 = p.z.redSqr();
	  var z2 = this.z.redSqr();
	  var u1 = this.x.redMul(pz2);
	  var u2 = p.x.redMul(z2);
	  var s1 = this.y.redMul(pz2.redMul(p.z));
	  var s2 = p.y.redMul(z2.redMul(this.z));

	  var h = u1.redSub(u2);
	  var r = s1.redSub(s2);
	  if (h.cmpn(0) === 0) {
	    if (r.cmpn(0) !== 0)
	      return this.curve.jpoint(null, null, null);
	    else
	      return this.dbl();
	  }

	  var h2 = h.redSqr();
	  var h3 = h2.redMul(h);
	  var v = u1.redMul(h2);

	  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
	  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
	  var nz = this.z.redMul(p.z).redMul(h);

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint$1.prototype.mixedAdd = function mixedAdd(p) {
	  // O + P = P
	  if (this.isInfinity())
	    return p.toJ();

	  // P + O = P
	  if (p.isInfinity())
	    return this;

	  // 8M + 3S + 7A
	  var z2 = this.z.redSqr();
	  var u1 = this.x;
	  var u2 = p.x.redMul(z2);
	  var s1 = this.y;
	  var s2 = p.y.redMul(z2).redMul(this.z);

	  var h = u1.redSub(u2);
	  var r = s1.redSub(s2);
	  if (h.cmpn(0) === 0) {
	    if (r.cmpn(0) !== 0)
	      return this.curve.jpoint(null, null, null);
	    else
	      return this.dbl();
	  }

	  var h2 = h.redSqr();
	  var h3 = h2.redMul(h);
	  var v = u1.redMul(h2);

	  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
	  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
	  var nz = this.z.redMul(h);

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint$1.prototype.dblp = function dblp(pow) {
	  if (pow === 0)
	    return this;
	  if (this.isInfinity())
	    return this;
	  if (!pow)
	    return this.dbl();

	  var i;
	  if (this.curve.zeroA || this.curve.threeA) {
	    var r = this;
	    for (i = 0; i < pow; i++)
	      r = r.dbl();
	    return r;
	  }

	  // 1M + 2S + 1A + N * (4S + 5M + 8A)
	  // N = 1 => 6M + 6S + 9A
	  var a = this.curve.a;
	  var tinv = this.curve.tinv;

	  var jx = this.x;
	  var jy = this.y;
	  var jz = this.z;
	  var jz4 = jz.redSqr().redSqr();

	  // Reuse results
	  var jyd = jy.redAdd(jy);
	  for (i = 0; i < pow; i++) {
	    var jx2 = jx.redSqr();
	    var jyd2 = jyd.redSqr();
	    var jyd4 = jyd2.redSqr();
	    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

	    var t1 = jx.redMul(jyd2);
	    var nx = c.redSqr().redISub(t1.redAdd(t1));
	    var t2 = t1.redISub(nx);
	    var dny = c.redMul(t2);
	    dny = dny.redIAdd(dny).redISub(jyd4);
	    var nz = jyd.redMul(jz);
	    if (i + 1 < pow)
	      jz4 = jz4.redMul(jyd4);

	    jx = nx;
	    jz = nz;
	    jyd = dny;
	  }

	  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
	};

	JPoint$1.prototype.dbl = function dbl() {
	  if (this.isInfinity())
	    return this;

	  if (this.curve.zeroA)
	    return this._zeroDbl();
	  else if (this.curve.threeA)
	    return this._threeDbl();
	  else
	    return this._dbl();
	};

	JPoint$1.prototype._zeroDbl = function _zeroDbl() {
	  var nx;
	  var ny;
	  var nz;
	  // Z = 1
	  if (this.zOne) {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
	    //     #doubling-mdbl-2007-bl
	    // 1M + 5S + 14A

	    // XX = X1^2
	    var xx = this.x.redSqr();
	    // YY = Y1^2
	    var yy = this.y.redSqr();
	    // YYYY = YY^2
	    var yyyy = yy.redSqr();
	    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
	    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	    s = s.redIAdd(s);
	    // M = 3 * XX + a; a = 0
	    var m = xx.redAdd(xx).redIAdd(xx);
	    // T = M ^ 2 - 2*S
	    var t = m.redSqr().redISub(s).redISub(s);

	    // 8 * YYYY
	    var yyyy8 = yyyy.redIAdd(yyyy);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    yyyy8 = yyyy8.redIAdd(yyyy8);

	    // X3 = T
	    nx = t;
	    // Y3 = M * (S - T) - 8 * YYYY
	    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
	    // Z3 = 2*Y1
	    nz = this.y.redAdd(this.y);
	  } else {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
	    //     #doubling-dbl-2009-l
	    // 2M + 5S + 13A

	    // A = X1^2
	    var a = this.x.redSqr();
	    // B = Y1^2
	    var b = this.y.redSqr();
	    // C = B^2
	    var c = b.redSqr();
	    // D = 2 * ((X1 + B)^2 - A - C)
	    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
	    d = d.redIAdd(d);
	    // E = 3 * A
	    var e = a.redAdd(a).redIAdd(a);
	    // F = E^2
	    var f = e.redSqr();

	    // 8 * C
	    var c8 = c.redIAdd(c);
	    c8 = c8.redIAdd(c8);
	    c8 = c8.redIAdd(c8);

	    // X3 = F - 2 * D
	    nx = f.redISub(d).redISub(d);
	    // Y3 = E * (D - X3) - 8 * C
	    ny = e.redMul(d.redISub(nx)).redISub(c8);
	    // Z3 = 2 * Y1 * Z1
	    nz = this.y.redMul(this.z);
	    nz = nz.redIAdd(nz);
	  }

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint$1.prototype._threeDbl = function _threeDbl() {
	  var nx;
	  var ny;
	  var nz;
	  // Z = 1
	  if (this.zOne) {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
	    //     #doubling-mdbl-2007-bl
	    // 1M + 5S + 15A

	    // XX = X1^2
	    var xx = this.x.redSqr();
	    // YY = Y1^2
	    var yy = this.y.redSqr();
	    // YYYY = YY^2
	    var yyyy = yy.redSqr();
	    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
	    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	    s = s.redIAdd(s);
	    // M = 3 * XX + a
	    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
	    // T = M^2 - 2 * S
	    var t = m.redSqr().redISub(s).redISub(s);
	    // X3 = T
	    nx = t;
	    // Y3 = M * (S - T) - 8 * YYYY
	    var yyyy8 = yyyy.redIAdd(yyyy);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
	    // Z3 = 2 * Y1
	    nz = this.y.redAdd(this.y);
	  } else {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
	    // 3M + 5S

	    // delta = Z1^2
	    var delta = this.z.redSqr();
	    // gamma = Y1^2
	    var gamma = this.y.redSqr();
	    // beta = X1 * gamma
	    var beta = this.x.redMul(gamma);
	    // alpha = 3 * (X1 - delta) * (X1 + delta)
	    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
	    alpha = alpha.redAdd(alpha).redIAdd(alpha);
	    // X3 = alpha^2 - 8 * beta
	    var beta4 = beta.redIAdd(beta);
	    beta4 = beta4.redIAdd(beta4);
	    var beta8 = beta4.redAdd(beta4);
	    nx = alpha.redSqr().redISub(beta8);
	    // Z3 = (Y1 + Z1)^2 - gamma - delta
	    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
	    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
	    var ggamma8 = gamma.redSqr();
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
	  }

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint$1.prototype._dbl = function _dbl() {
	  var a = this.curve.a;

	  // 4M + 6S + 10A
	  var jx = this.x;
	  var jy = this.y;
	  var jz = this.z;
	  var jz4 = jz.redSqr().redSqr();

	  var jx2 = jx.redSqr();
	  var jy2 = jy.redSqr();

	  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

	  var jxd4 = jx.redAdd(jx);
	  jxd4 = jxd4.redIAdd(jxd4);
	  var t1 = jxd4.redMul(jy2);
	  var nx = c.redSqr().redISub(t1.redAdd(t1));
	  var t2 = t1.redISub(nx);

	  var jyd8 = jy2.redSqr();
	  jyd8 = jyd8.redIAdd(jyd8);
	  jyd8 = jyd8.redIAdd(jyd8);
	  jyd8 = jyd8.redIAdd(jyd8);
	  var ny = c.redMul(t2).redISub(jyd8);
	  var nz = jy.redAdd(jy).redMul(jz);

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint$1.prototype.trpl = function trpl() {
	  if (!this.curve.zeroA)
	    return this.dbl().add(this);

	  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
	  // 5M + 10S + ...

	  // XX = X1^2
	  var xx = this.x.redSqr();
	  // YY = Y1^2
	  var yy = this.y.redSqr();
	  // ZZ = Z1^2
	  var zz = this.z.redSqr();
	  // YYYY = YY^2
	  var yyyy = yy.redSqr();
	  // M = 3 * XX + a * ZZ2; a = 0
	  var m = xx.redAdd(xx).redIAdd(xx);
	  // MM = M^2
	  var mm = m.redSqr();
	  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
	  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	  e = e.redIAdd(e);
	  e = e.redAdd(e).redIAdd(e);
	  e = e.redISub(mm);
	  // EE = E^2
	  var ee = e.redSqr();
	  // T = 16*YYYY
	  var t = yyyy.redIAdd(yyyy);
	  t = t.redIAdd(t);
	  t = t.redIAdd(t);
	  t = t.redIAdd(t);
	  // U = (M + E)^2 - MM - EE - T
	  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
	  // X3 = 4 * (X1 * EE - 4 * YY * U)
	  var yyu4 = yy.redMul(u);
	  yyu4 = yyu4.redIAdd(yyu4);
	  yyu4 = yyu4.redIAdd(yyu4);
	  var nx = this.x.redMul(ee).redISub(yyu4);
	  nx = nx.redIAdd(nx);
	  nx = nx.redIAdd(nx);
	  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
	  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
	  ny = ny.redIAdd(ny);
	  ny = ny.redIAdd(ny);
	  ny = ny.redIAdd(ny);
	  // Z3 = (Z1 + E)^2 - ZZ - EE
	  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint$1.prototype.mul = function mul(k, kbase) {
	  k = new BN$b(k, kbase);

	  return this.curve._wnafMul(this, k);
	};

	JPoint$1.prototype.eq = function eq(p) {
	  if (p.type === 'affine')
	    return this.eq(p.toJ());

	  if (this === p)
	    return true;

	  // x1 * z2^2 == x2 * z1^2
	  var z2 = this.z.redSqr();
	  var pz2 = p.z.redSqr();
	  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
	    return false;

	  // y1 * z2^3 == y2 * z1^3
	  var z3 = z2.redMul(this.z);
	  var pz3 = pz2.redMul(p.z);
	  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
	};

	JPoint$1.prototype.eqXToP = function eqXToP(x) {
	  var zs = this.z.redSqr();
	  var rx = x.toRed(this.curve.red).redMul(zs);
	  if (this.x.cmp(rx) === 0)
	    return true;

	  var xc = x.clone();
	  var t = this.curve.redN.redMul(zs);
	  for (;;) {
	    xc.iadd(this.curve.n);
	    if (xc.cmp(this.curve.p) >= 0)
	      return false;

	    rx.redIAdd(t);
	    if (this.x.cmp(rx) === 0)
	      return true;
	  }
	};

	JPoint$1.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC JPoint Infinity>';
	  return '<EC JPoint x: ' + this.x.toString(16, 2) +
	      ' y: ' + this.y.toString(16, 2) +
	      ' z: ' + this.z.toString(16, 2) + '>';
	};

	JPoint$1.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.z.cmpn(0) === 0;
	};

	var curve_1 = createCommonjsModule(function (module, exports) {

	var curve = exports;

	curve.base = base$1;
	curve.short = short_1;
	curve.mont = /*RicMoo:ethers:require(./mont)*/(null);
	curve.edwards = /*RicMoo:ethers:require(./edwards)*/(null);
	});

	var curves_1 = createCommonjsModule(function (module, exports) {

	var curves = exports;





	var assert = utils_1$1$1.assert;

	function PresetCurve(options) {
	  if (options.type === 'short')
	    this.curve = new curve_1.short(options);
	  else if (options.type === 'edwards')
	    this.curve = new curve_1.edwards(options);
	  else
	    this.curve = new curve_1.mont(options);
	  this.g = this.curve.g;
	  this.n = this.curve.n;
	  this.hash = options.hash;

	  assert(this.g.validate(), 'Invalid curve');
	  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
	}
	curves.PresetCurve = PresetCurve;

	function defineCurve(name, options) {
	  Object.defineProperty(curves, name, {
	    configurable: true,
	    enumerable: true,
	    get: function() {
	      var curve = new PresetCurve(options);
	      Object.defineProperty(curves, name, {
	        configurable: true,
	        enumerable: true,
	        value: curve,
	      });
	      return curve;
	    },
	  });
	}

	defineCurve('p192', {
	  type: 'short',
	  prime: 'p192',
	  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
	  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
	  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
	  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
	  hash: hash$3.sha256,
	  gRed: false,
	  g: [
	    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
	    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
	  ],
	});

	defineCurve('p224', {
	  type: 'short',
	  prime: 'p224',
	  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
	  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
	  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
	  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
	  hash: hash$3.sha256,
	  gRed: false,
	  g: [
	    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
	    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
	  ],
	});

	defineCurve('p256', {
	  type: 'short',
	  prime: null,
	  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
	  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
	  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
	  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
	  hash: hash$3.sha256,
	  gRed: false,
	  g: [
	    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
	    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
	  ],
	});

	defineCurve('p384', {
	  type: 'short',
	  prime: null,
	  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'fffffffe ffffffff 00000000 00000000 ffffffff',
	  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'fffffffe ffffffff 00000000 00000000 fffffffc',
	  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
	     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
	  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
	     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
	  hash: hash$3.sha384,
	  gRed: false,
	  g: [
	    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
	    '5502f25d bf55296c 3a545e38 72760ab7',
	    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
	    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
	  ],
	});

	defineCurve('p521', {
	  type: 'short',
	  prime: null,
	  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff ffffffff ffffffff ffffffff',
	  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff ffffffff ffffffff fffffffc',
	  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
	     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
	     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
	  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
	     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
	  hash: hash$3.sha512,
	  gRed: false,
	  g: [
	    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
	    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
	    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
	    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
	    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
	    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
	  ],
	});

	defineCurve('curve25519', {
	  type: 'mont',
	  prime: 'p25519',
	  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
	  a: '76d06',
	  b: '1',
	  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
	  hash: hash$3.sha256,
	  gRed: false,
	  g: [
	    '9',
	  ],
	});

	defineCurve('ed25519', {
	  type: 'edwards',
	  prime: 'p25519',
	  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
	  a: '-1',
	  c: '1',
	  // -121665 * (121666^(-1)) (mod P)
	  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
	  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
	  hash: hash$3.sha256,
	  gRed: false,
	  g: [
	    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

	    // 4/5
	    '6666666666666666666666666666666666666666666666666666666666666658',
	  ],
	});

	var pre;
	try {
	  pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/(null).crash();
	} catch (e) {
	  pre = undefined;
	}

	defineCurve('secp256k1', {
	  type: 'short',
	  prime: 'k256',
	  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
	  a: '0',
	  b: '7',
	  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
	  h: '1',
	  hash: hash$3.sha256,

	  // Precomputed endomorphism
	  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
	  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
	  basis: [
	    {
	      a: '3086d221a7d46bcde86c90e49284eb15',
	      b: '-e4437ed6010e88286f547fa90abfe4c3',
	    },
	    {
	      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
	      b: '3086d221a7d46bcde86c90e49284eb15',
	    },
	  ],

	  gRed: false,
	  g: [
	    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
	    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
	    pre,
	  ],
	});
	});





	function HmacDRBG$2(options) {
	  if (!(this instanceof HmacDRBG$2))
	    return new HmacDRBG$2(options);
	  this.hash = options.hash;
	  this.predResist = !!options.predResist;

	  this.outLen = this.hash.outSize;
	  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

	  this._reseed = null;
	  this.reseedInterval = null;
	  this.K = null;
	  this.V = null;

	  var entropy = utils_1$2.toArray(options.entropy, options.entropyEnc || 'hex');
	  var nonce = utils_1$2.toArray(options.nonce, options.nonceEnc || 'hex');
	  var pers = utils_1$2.toArray(options.pers, options.persEnc || 'hex');
	  minimalisticAssert(entropy.length >= (this.minEntropy / 8),
	         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
	  this._init(entropy, nonce, pers);
	}
	var hmacDrbg$1 = HmacDRBG$2;

	HmacDRBG$2.prototype._init = function init(entropy, nonce, pers) {
	  var seed = entropy.concat(nonce).concat(pers);

	  this.K = new Array(this.outLen / 8);
	  this.V = new Array(this.outLen / 8);
	  for (var i = 0; i < this.V.length; i++) {
	    this.K[i] = 0x00;
	    this.V[i] = 0x01;
	  }

	  this._update(seed);
	  this._reseed = 1;
	  this.reseedInterval = 0x1000000000000;  // 2^48
	};

	HmacDRBG$2.prototype._hmac = function hmac() {
	  return new hash$3.hmac(this.hash, this.K);
	};

	HmacDRBG$2.prototype._update = function update(seed) {
	  var kmac = this._hmac()
	                 .update(this.V)
	                 .update([ 0x00 ]);
	  if (seed)
	    kmac = kmac.update(seed);
	  this.K = kmac.digest();
	  this.V = this._hmac().update(this.V).digest();
	  if (!seed)
	    return;

	  this.K = this._hmac()
	               .update(this.V)
	               .update([ 0x01 ])
	               .update(seed)
	               .digest();
	  this.V = this._hmac().update(this.V).digest();
	};

	HmacDRBG$2.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
	  // Optional entropy enc
	  if (typeof entropyEnc !== 'string') {
	    addEnc = add;
	    add = entropyEnc;
	    entropyEnc = null;
	  }

	  entropy = utils_1$2.toArray(entropy, entropyEnc);
	  add = utils_1$2.toArray(add, addEnc);

	  minimalisticAssert(entropy.length >= (this.minEntropy / 8),
	         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

	  this._update(entropy.concat(add || []));
	  this._reseed = 1;
	};

	HmacDRBG$2.prototype.generate = function generate(len, enc, add, addEnc) {
	  if (this._reseed > this.reseedInterval)
	    throw new Error('Reseed is required');

	  // Optional encoding
	  if (typeof enc !== 'string') {
	    addEnc = add;
	    add = enc;
	    enc = null;
	  }

	  // Optional additional data
	  if (add) {
	    add = utils_1$2.toArray(add, addEnc || 'hex');
	    this._update(add);
	  }

	  var temp = [];
	  while (temp.length < len) {
	    this.V = this._hmac().update(this.V).digest();
	    temp = temp.concat(this.V);
	  }

	  var res = temp.slice(0, len);
	  this._update(add);
	  this._reseed++;
	  return utils_1$2.encode(res, enc);
	};



	var assert$3$1 = utils_1$1$1.assert;

	function KeyPair$4(ec, options) {
	  this.ec = ec;
	  this.priv = null;
	  this.pub = null;

	  // KeyPair(ec, { priv: ..., pub: ... })
	  if (options.priv)
	    this._importPrivate(options.priv, options.privEnc);
	  if (options.pub)
	    this._importPublic(options.pub, options.pubEnc);
	}
	var key$2 = KeyPair$4;

	KeyPair$4.fromPublic = function fromPublic(ec, pub, enc) {
	  if (pub instanceof KeyPair$4)
	    return pub;

	  return new KeyPair$4(ec, {
	    pub: pub,
	    pubEnc: enc,
	  });
	};

	KeyPair$4.fromPrivate = function fromPrivate(ec, priv, enc) {
	  if (priv instanceof KeyPair$4)
	    return priv;

	  return new KeyPair$4(ec, {
	    priv: priv,
	    privEnc: enc,
	  });
	};

	KeyPair$4.prototype.validate = function validate() {
	  var pub = this.getPublic();

	  if (pub.isInfinity())
	    return { result: false, reason: 'Invalid public key' };
	  if (!pub.validate())
	    return { result: false, reason: 'Public key is not a point' };
	  if (!pub.mul(this.ec.curve.n).isInfinity())
	    return { result: false, reason: 'Public key * N != O' };

	  return { result: true, reason: null };
	};

	KeyPair$4.prototype.getPublic = function getPublic(compact, enc) {
	  // compact is optional argument
	  if (typeof compact === 'string') {
	    enc = compact;
	    compact = null;
	  }

	  if (!this.pub)
	    this.pub = this.ec.g.mul(this.priv);

	  if (!enc)
	    return this.pub;

	  return this.pub.encode(enc, compact);
	};

	KeyPair$4.prototype.getPrivate = function getPrivate(enc) {
	  if (enc === 'hex')
	    return this.priv.toString(16, 2);
	  else
	    return this.priv;
	};

	KeyPair$4.prototype._importPrivate = function _importPrivate(key, enc) {
	  this.priv = new BN$b(key, enc || 16);

	  // Ensure that the priv won't be bigger than n, otherwise we may fail
	  // in fixed multiplication method
	  this.priv = this.priv.umod(this.ec.curve.n);
	};

	KeyPair$4.prototype._importPublic = function _importPublic(key, enc) {
	  if (key.x || key.y) {
	    // Montgomery points only have an `x` coordinate.
	    // Weierstrass/Edwards points on the other hand have both `x` and
	    // `y` coordinates.
	    if (this.ec.curve.type === 'mont') {
	      assert$3$1(key.x, 'Need x coordinate');
	    } else if (this.ec.curve.type === 'short' ||
	               this.ec.curve.type === 'edwards') {
	      assert$3$1(key.x && key.y, 'Need both x and y coordinate');
	    }
	    this.pub = this.ec.curve.point(key.x, key.y);
	    return;
	  }
	  this.pub = this.ec.curve.decodePoint(key, enc);
	};

	// ECDH
	KeyPair$4.prototype.derive = function derive(pub) {
	  if(!pub.validate()) {
	    assert$3$1(pub.validate(), 'public point not validated');
	  }
	  return pub.mul(this.priv).getX();
	};

	// ECDSA
	KeyPair$4.prototype.sign = function sign(msg, enc, options) {
	  return this.ec.sign(msg, this, enc, options);
	};

	KeyPair$4.prototype.verify = function verify(msg, signature) {
	  return this.ec.verify(msg, signature, this);
	};

	KeyPair$4.prototype.inspect = function inspect() {
	  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
	         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
	};




	var assert$4$1 = utils_1$1$1.assert;

	function Signature$6(options, enc) {
	  if (options instanceof Signature$6)
	    return options;

	  if (this._importDER(options, enc))
	    return;

	  assert$4$1(options.r && options.s, 'Signature without r or s');
	  this.r = new BN$b(options.r, 16);
	  this.s = new BN$b(options.s, 16);
	  if (options.recoveryParam === undefined)
	    this.recoveryParam = null;
	  else
	    this.recoveryParam = options.recoveryParam;
	}
	var signature$2 = Signature$6;

	function Position$1() {
	  this.place = 0;
	}

	function getLength$1(buf, p) {
	  var initial = buf[p.place++];
	  if (!(initial & 0x80)) {
	    return initial;
	  }
	  var octetLen = initial & 0xf;

	  // Indefinite length or overflow
	  if (octetLen === 0 || octetLen > 4) {
	    return false;
	  }

	  var val = 0;
	  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
	    val <<= 8;
	    val |= buf[off];
	    val >>>= 0;
	  }

	  // Leading zeroes
	  if (val <= 0x7f) {
	    return false;
	  }

	  p.place = off;
	  return val;
	}

	function rmPadding$1(buf) {
	  var i = 0;
	  var len = buf.length - 1;
	  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
	    i++;
	  }
	  if (i === 0) {
	    return buf;
	  }
	  return buf.slice(i);
	}

	Signature$6.prototype._importDER = function _importDER(data, enc) {
	  data = utils_1$1$1.toArray(data, enc);
	  var p = new Position$1();
	  if (data[p.place++] !== 0x30) {
	    return false;
	  }
	  var len = getLength$1(data, p);
	  if (len === false) {
	    return false;
	  }
	  if ((len + p.place) !== data.length) {
	    return false;
	  }
	  if (data[p.place++] !== 0x02) {
	    return false;
	  }
	  var rlen = getLength$1(data, p);
	  if (rlen === false) {
	    return false;
	  }
	  var r = data.slice(p.place, rlen + p.place);
	  p.place += rlen;
	  if (data[p.place++] !== 0x02) {
	    return false;
	  }
	  var slen = getLength$1(data, p);
	  if (slen === false) {
	    return false;
	  }
	  if (data.length !== slen + p.place) {
	    return false;
	  }
	  var s = data.slice(p.place, slen + p.place);
	  if (r[0] === 0) {
	    if (r[1] & 0x80) {
	      r = r.slice(1);
	    } else {
	      // Leading zeroes
	      return false;
	    }
	  }
	  if (s[0] === 0) {
	    if (s[1] & 0x80) {
	      s = s.slice(1);
	    } else {
	      // Leading zeroes
	      return false;
	    }
	  }

	  this.r = new BN$b(r);
	  this.s = new BN$b(s);
	  this.recoveryParam = null;

	  return true;
	};

	function constructLength$1(arr, len) {
	  if (len < 0x80) {
	    arr.push(len);
	    return;
	  }
	  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
	  arr.push(octets | 0x80);
	  while (--octets) {
	    arr.push((len >>> (octets << 3)) & 0xff);
	  }
	  arr.push(len);
	}

	Signature$6.prototype.toDER = function toDER(enc) {
	  var r = this.r.toArray();
	  var s = this.s.toArray();

	  // Pad values
	  if (r[0] & 0x80)
	    r = [ 0 ].concat(r);
	  // Pad values
	  if (s[0] & 0x80)
	    s = [ 0 ].concat(s);

	  r = rmPadding$1(r);
	  s = rmPadding$1(s);

	  while (!s[0] && !(s[1] & 0x80)) {
	    s = s.slice(1);
	  }
	  var arr = [ 0x02 ];
	  constructLength$1(arr, r.length);
	  arr = arr.concat(r);
	  arr.push(0x02);
	  constructLength$1(arr, s.length);
	  var backHalf = arr.concat(s);
	  var res = [ 0x30 ];
	  constructLength$1(res, backHalf.length);
	  res = res.concat(backHalf);
	  return utils_1$1$1.encode(res, enc);
	};





	var rand$1 = /*RicMoo:ethers:require(brorand)*/(function() { throw new Error('unsupported'); });
	var assert$5$1 = utils_1$1$1.assert;




	function EC$1(options) {
	  if (!(this instanceof EC$1))
	    return new EC$1(options);

	  // Shortcut `elliptic.ec(curve-name)`
	  if (typeof options === 'string') {
	    assert$5$1(Object.prototype.hasOwnProperty.call(curves_1, options),
	      'Unknown curve ' + options);

	    options = curves_1[options];
	  }

	  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
	  if (options instanceof curves_1.PresetCurve)
	    options = { curve: options };

	  this.curve = options.curve.curve;
	  this.n = this.curve.n;
	  this.nh = this.n.ushrn(1);
	  this.g = this.curve.g;

	  // Point on curve
	  this.g = options.curve.g;
	  this.g.precompute(options.curve.n.bitLength() + 1);

	  // Hash for function for DRBG
	  this.hash = options.hash || options.curve.hash;
	}
	var ec$1 = EC$1;

	EC$1.prototype.keyPair = function keyPair(options) {
	  return new key$2(this, options);
	};

	EC$1.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
	  return key$2.fromPrivate(this, priv, enc);
	};

	EC$1.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
	  return key$2.fromPublic(this, pub, enc);
	};

	EC$1.prototype.genKeyPair = function genKeyPair(options) {
	  if (!options)
	    options = {};

	  // Instantiate Hmac_DRBG
	  var drbg = new hmacDrbg$1({
	    hash: this.hash,
	    pers: options.pers,
	    persEnc: options.persEnc || 'utf8',
	    entropy: options.entropy || rand$1(this.hash.hmacStrength),
	    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
	    nonce: this.n.toArray(),
	  });

	  var bytes = this.n.byteLength();
	  var ns2 = this.n.sub(new BN$b(2));
	  for (;;) {
	    var priv = new BN$b(drbg.generate(bytes));
	    if (priv.cmp(ns2) > 0)
	      continue;

	    priv.iaddn(1);
	    return this.keyFromPrivate(priv);
	  }
	};

	EC$1.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
	  var delta = msg.byteLength() * 8 - this.n.bitLength();
	  if (delta > 0)
	    msg = msg.ushrn(delta);
	  if (!truncOnly && msg.cmp(this.n) >= 0)
	    return msg.sub(this.n);
	  else
	    return msg;
	};

	EC$1.prototype.sign = function sign(msg, key, enc, options) {
	  if (typeof enc === 'object') {
	    options = enc;
	    enc = null;
	  }
	  if (!options)
	    options = {};

	  key = this.keyFromPrivate(key, enc);
	  msg = this._truncateToN(new BN$b(msg, 16));

	  // Zero-extend key to provide enough entropy
	  var bytes = this.n.byteLength();
	  var bkey = key.getPrivate().toArray('be', bytes);

	  // Zero-extend nonce to have the same byte size as N
	  var nonce = msg.toArray('be', bytes);

	  // Instantiate Hmac_DRBG
	  var drbg = new hmacDrbg$1({
	    hash: this.hash,
	    entropy: bkey,
	    nonce: nonce,
	    pers: options.pers,
	    persEnc: options.persEnc || 'utf8',
	  });

	  // Number of bytes to generate
	  var ns1 = this.n.sub(new BN$b(1));

	  for (var iter = 0; ; iter++) {
	    var k = options.k ?
	      options.k(iter) :
	      new BN$b(drbg.generate(this.n.byteLength()));
	    k = this._truncateToN(k, true);
	    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
	      continue;

	    var kp = this.g.mul(k);
	    if (kp.isInfinity())
	      continue;

	    var kpX = kp.getX();
	    var r = kpX.umod(this.n);
	    if (r.cmpn(0) === 0)
	      continue;

	    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
	    s = s.umod(this.n);
	    if (s.cmpn(0) === 0)
	      continue;

	    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
	                        (kpX.cmp(r) !== 0 ? 2 : 0);

	    // Use complement of `s`, if it is > `n / 2`
	    if (options.canonical && s.cmp(this.nh) > 0) {
	      s = this.n.sub(s);
	      recoveryParam ^= 1;
	    }

	    return new signature$2({ r: r, s: s, recoveryParam: recoveryParam });
	  }
	};

	EC$1.prototype.verify = function verify(msg, signature$1, key, enc) {
	  msg = this._truncateToN(new BN$b(msg, 16));
	  key = this.keyFromPublic(key, enc);
	  signature$1 = new signature$2(signature$1, 'hex');

	  // Perform primitive values validation
	  var r = signature$1.r;
	  var s = signature$1.s;
	  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
	    return false;
	  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
	    return false;

	  // Validate signature
	  var sinv = s.invm(this.n);
	  var u1 = sinv.mul(msg).umod(this.n);
	  var u2 = sinv.mul(r).umod(this.n);
	  var p;

	  if (!this.curve._maxwellTrick) {
	    p = this.g.mulAdd(u1, key.getPublic(), u2);
	    if (p.isInfinity())
	      return false;

	    return p.getX().umod(this.n).cmp(r) === 0;
	  }

	  // NOTE: Greg Maxwell's trick, inspired by:
	  // https://git.io/vad3K

	  p = this.g.jmulAdd(u1, key.getPublic(), u2);
	  if (p.isInfinity())
	    return false;

	  // Compare `p.x` of Jacobian point with `r`,
	  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
	  // inverse of `p.z^2`
	  return p.eqXToP(r);
	};

	EC$1.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
	  assert$5$1((3 & j) === j, 'The recovery param is more than two bits');
	  signature$1 = new signature$2(signature$1, enc);

	  var n = this.n;
	  var e = new BN$b(msg);
	  var r = signature$1.r;
	  var s = signature$1.s;

	  // A set LSB signifies that the y-coordinate is odd
	  var isYOdd = j & 1;
	  var isSecondKey = j >> 1;
	  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
	    throw new Error('Unable to find sencond key candinate');

	  // 1.1. Let x = r + jn.
	  if (isSecondKey)
	    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
	  else
	    r = this.curve.pointFromX(r, isYOdd);

	  var rInv = signature$1.r.invm(n);
	  var s1 = n.sub(e).mul(rInv).umod(n);
	  var s2 = s.mul(rInv).umod(n);

	  // 1.6.1 Compute Q = r^-1 (sR -  eG)
	  //               Q = r^-1 (sR + -eG)
	  return this.g.mulAdd(s1, r, s2);
	};

	EC$1.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
	  signature$1 = new signature$2(signature$1, enc);
	  if (signature$1.recoveryParam !== null)
	    return signature$1.recoveryParam;

	  for (var i = 0; i < 4; i++) {
	    var Qprime;
	    try {
	      Qprime = this.recoverPubKey(e, signature$1, i);
	    } catch (e) {
	      continue;
	    }

	    if (Qprime.eq(Q))
	      return i;
	  }
	  throw new Error('Unable to find valid recovery factor');
	};

	var elliptic_1 = createCommonjsModule(function (module, exports) {

	var elliptic = exports;

	elliptic.version = /*RicMoo:ethers*/{ version: "6.5.4" }.version;
	elliptic.utils = utils_1$1$1;
	elliptic.rand = /*RicMoo:ethers:require(brorand)*/(function() { throw new Error('unsupported'); });
	elliptic.curve = curve_1;
	elliptic.curves = curves_1;

	// Protocols
	elliptic.ec = ec$1;
	elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/(null);
	});

	var EC$1$1 = elliptic_1.ec;

	const version$4 = "signing-key/5.7.0";

	const logger = new Logger(version$4);
	let _curve = null;
	function getCurve() {
	    if (!_curve) {
	        _curve = new EC$1$1("secp256k1");
	    }
	    return _curve;
	}
	class SigningKey {
	    constructor(privateKey) {
	        defineReadOnly(this, "curve", "secp256k1");
	        defineReadOnly(this, "privateKey", hexlify(privateKey));
	        if (hexDataLength(this.privateKey) !== 32) {
	            logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
	        }
	        const keyPair = getCurve().keyFromPrivate(arrayify(this.privateKey));
	        defineReadOnly(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
	        defineReadOnly(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
	        defineReadOnly(this, "_isSigningKey", true);
	    }
	    _addPoint(other) {
	        const p0 = getCurve().keyFromPublic(arrayify(this.publicKey));
	        const p1 = getCurve().keyFromPublic(arrayify(other));
	        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
	    }
	    signDigest(digest) {
	        const keyPair = getCurve().keyFromPrivate(arrayify(this.privateKey));
	        const digestBytes = arrayify(digest);
	        if (digestBytes.length !== 32) {
	            logger.throwArgumentError("bad digest length", "digest", digest);
	        }
	        const signature = keyPair.sign(digestBytes, { canonical: true });
	        return splitSignature({
	            recoveryParam: signature.recoveryParam,
	            r: hexZeroPad("0x" + signature.r.toString(16), 32),
	            s: hexZeroPad("0x" + signature.s.toString(16), 32),
	        });
	    }
	    computeSharedSecret(otherKey) {
	        const keyPair = getCurve().keyFromPrivate(arrayify(this.privateKey));
	        const otherKeyPair = getCurve().keyFromPublic(arrayify(computePublicKey(otherKey)));
	        return hexZeroPad("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
	    }
	    static isSigningKey(value) {
	        return !!(value && value._isSigningKey);
	    }
	}
	function recoverPublicKey$1(digest, signature) {
	    const sig = splitSignature(signature);
	    const rs = { r: arrayify(sig.r), s: arrayify(sig.s) };
	    return "0x" + getCurve().recoverPubKey(arrayify(digest), rs, sig.recoveryParam).encode("hex", false);
	}
	function computePublicKey(key, compressed) {
	    const bytes = arrayify(key);
	    if (bytes.length === 32) {
	        const signingKey = new SigningKey(bytes);
	        if (compressed) {
	            return "0x" + getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
	        }
	        return signingKey.publicKey;
	    }
	    else if (bytes.length === 33) {
	        if (compressed) {
	            return hexlify(bytes);
	        }
	        return "0x" + getCurve().keyFromPublic(bytes).getPublic(false, "hex");
	    }
	    else if (bytes.length === 65) {
	        if (!compressed) {
	            return hexlify(bytes);
	        }
	        return "0x" + getCurve().keyFromPublic(bytes).getPublic(true, "hex");
	    }
	    return logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
	}

	var TransactionTypes;
	(function (TransactionTypes) {
	    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
	    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
	    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
	})(TransactionTypes || (TransactionTypes = {}));
	function computeAddress(key) {
	    const publicKey = computePublicKey(key);
	    return getAddress(hexDataSlice(keccak256(hexDataSlice(publicKey, 1)), 12));
	}
	function recoverAddress(digest, signature) {
	    return computeAddress(recoverPublicKey$1(arrayify(digest), signature));
	}

	(undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	function verifyMessage(message, signature) {
	    return recoverAddress(hashMessage(message), signature);
	}

	/**
	 * @license
	 * Copyright 2009 The Closure Library Authors
	 * Copyright 2020 Daniel Wirtz / The long.js Authors.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * SPDX-License-Identifier: Apache-2.0
	 */

	// WebAssembly optimizations to do native i64 multiplication and divide
	var wasm = null;
	try {
	  wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
	    0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11
	  ])), {}).exports;
	} catch (e) {
	  // no wasm support :(
	}

	/**
	 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
	 *  See the from* functions below for more convenient ways of constructing Longs.
	 * @exports Long
	 * @class A Long class for representing a 64 bit two's-complement integer value.
	 * @param {number} low The low (signed) 32 bits of the long
	 * @param {number} high The high (signed) 32 bits of the long
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @constructor
	 */
	function Long(low, high, unsigned) {

	  /**
	   * The low 32 bits as a signed value.
	   * @type {number}
	   */
	  this.low = low | 0;

	  /**
	   * The high 32 bits as a signed value.
	   * @type {number}
	   */
	  this.high = high | 0;

	  /**
	   * Whether unsigned or not.
	   * @type {boolean}
	   */
	  this.unsigned = !!unsigned;
	}

	// The internal representation of a long is the two given signed, 32-bit values.
	// We use 32-bit pieces because these are the size of integers on which
	// Javascript performs bit-operations.  For operations like addition and
	// multiplication, we split each number into 16 bit pieces, which can easily be
	// multiplied within Javascript's floating-point representation without overflow
	// or change in sign.
	//
	// In the algorithms below, we frequently reduce the negative case to the
	// positive case by negating the input(s) and then post-processing the result.
	// Note that we must ALWAYS check specially whether those values are MIN_VALUE
	// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
	// a positive number, it overflows back into a negative).  Not handling this
	// case would often result in infinite recursion.
	//
	// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
	// methods on which they depend.

	/**
	 * An indicator used to reliably determine if an object is a Long or not.
	 * @type {boolean}
	 * @const
	 * @private
	 */
	Long.prototype.__isLong__;

	Object.defineProperty(Long.prototype, "__isLong__", { value: true });

	/**
	 * @function
	 * @param {*} obj Object
	 * @returns {boolean}
	 * @inner
	 */
	function isLong(obj) {
	  return (obj && obj["__isLong__"]) === true;
	}

	/**
	 * @function
	 * @param {*} value number
	 * @returns {number}
	 * @inner
	 */
	function ctz32(value) {
	  var c = Math.clz32(value & -value);
	  return value ? 31 - c : c;
	}

	/**
	 * Tests if the specified object is a Long.
	 * @function
	 * @param {*} obj Object
	 * @returns {boolean}
	 */
	Long.isLong = isLong;

	/**
	 * A cache of the Long representations of small integer values.
	 * @type {!Object}
	 * @inner
	 */
	var INT_CACHE = {};

	/**
	 * A cache of the Long representations of small unsigned integer values.
	 * @type {!Object}
	 * @inner
	 */
	var UINT_CACHE = {};

	/**
	 * @param {number} value
	 * @param {boolean=} unsigned
	 * @returns {!Long}
	 * @inner
	 */
	function fromInt(value, unsigned) {
	  var obj, cachedObj, cache;
	  if (unsigned) {
	    value >>>= 0;
	    if (cache = (0 <= value && value < 256)) {
	      cachedObj = UINT_CACHE[value];
	      if (cachedObj)
	        return cachedObj;
	    }
	    obj = fromBits(value, 0, true);
	    if (cache)
	      UINT_CACHE[value] = obj;
	    return obj;
	  } else {
	    value |= 0;
	    if (cache = (-128 <= value && value < 128)) {
	      cachedObj = INT_CACHE[value];
	      if (cachedObj)
	        return cachedObj;
	    }
	    obj = fromBits(value, value < 0 ? -1 : 0, false);
	    if (cache)
	      INT_CACHE[value] = obj;
	    return obj;
	  }
	}

	/**
	 * Returns a Long representing the given 32 bit integer value.
	 * @function
	 * @param {number} value The 32 bit integer in question
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {!Long} The corresponding Long value
	 */
	Long.fromInt = fromInt;

	/**
	 * @param {number} value
	 * @param {boolean=} unsigned
	 * @returns {!Long}
	 * @inner
	 */
	function fromNumber(value, unsigned) {
	  if (isNaN(value))
	    return unsigned ? UZERO : ZERO;
	  if (unsigned) {
	    if (value < 0)
	      return UZERO;
	    if (value >= TWO_PWR_64_DBL)
	      return MAX_UNSIGNED_VALUE;
	  } else {
	    if (value <= -TWO_PWR_63_DBL)
	      return MIN_VALUE;
	    if (value + 1 >= TWO_PWR_63_DBL)
	      return MAX_VALUE;
	  }
	  if (value < 0)
	    return fromNumber(-value, unsigned).neg();
	  return fromBits((value % TWO_PWR_32_DBL) | 0, (value / TWO_PWR_32_DBL) | 0, unsigned);
	}

	/**
	 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
	 * @function
	 * @param {number} value The number in question
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {!Long} The corresponding Long value
	 */
	Long.fromNumber = fromNumber;

	/**
	 * @param {number} lowBits
	 * @param {number} highBits
	 * @param {boolean=} unsigned
	 * @returns {!Long}
	 * @inner
	 */
	function fromBits(lowBits, highBits, unsigned) {
	  return new Long(lowBits, highBits, unsigned);
	}

	/**
	 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
	 *  assumed to use 32 bits.
	 * @function
	 * @param {number} lowBits The low 32 bits
	 * @param {number} highBits The high 32 bits
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {!Long} The corresponding Long value
	 */
	Long.fromBits = fromBits;

	/**
	 * @function
	 * @param {number} base
	 * @param {number} exponent
	 * @returns {number}
	 * @inner
	 */
	var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)

	/**
	 * @param {string} str
	 * @param {(boolean|number)=} unsigned
	 * @param {number=} radix
	 * @returns {!Long}
	 * @inner
	 */
	function fromString(str, unsigned, radix) {
	  if (str.length === 0)
	    throw Error('empty string');
	  if (typeof unsigned === 'number') {
	    // For goog.math.long compatibility
	    radix = unsigned;
	    unsigned = false;
	  } else {
	    unsigned = !!unsigned;
	  }
	  if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
	    return unsigned ? UZERO : ZERO;
	  radix = radix || 10;
	  if (radix < 2 || 36 < radix)
	    throw RangeError('radix');

	  var p;
	  if ((p = str.indexOf('-')) > 0)
	    throw Error('interior hyphen');
	  else if (p === 0) {
	    return fromString(str.substring(1), unsigned, radix).neg();
	  }

	  // Do several (8) digits each time through the loop, so as to
	  // minimize the calls to the very expensive emulated div.
	  var radixToPower = fromNumber(pow_dbl(radix, 8));

	  var result = ZERO;
	  for (var i = 0; i < str.length; i += 8) {
	    var size = Math.min(8, str.length - i),
	      value = parseInt(str.substring(i, i + size), radix);
	    if (size < 8) {
	      var power = fromNumber(pow_dbl(radix, size));
	      result = result.mul(power).add(fromNumber(value));
	    } else {
	      result = result.mul(radixToPower);
	      result = result.add(fromNumber(value));
	    }
	  }
	  result.unsigned = unsigned;
	  return result;
	}

	/**
	 * Returns a Long representation of the given string, written using the specified radix.
	 * @function
	 * @param {string} str The textual representation of the Long
	 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
	 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
	 * @returns {!Long} The corresponding Long value
	 */
	Long.fromString = fromString;

	/**
	 * @function
	 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
	 * @param {boolean=} unsigned
	 * @returns {!Long}
	 * @inner
	 */
	function fromValue(val, unsigned) {
	  if (typeof val === 'number')
	    return fromNumber(val, unsigned);
	  if (typeof val === 'string')
	    return fromString(val, unsigned);
	  // Throws for non-objects, converts non-instanceof Long:
	  return fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
	}

	/**
	 * Converts the specified value to a Long using the appropriate from* function for its type.
	 * @function
	 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {!Long}
	 */
	Long.fromValue = fromValue;

	// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
	// no runtime penalty for these.

	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_16_DBL = 1 << 16;

	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_24_DBL = 1 << 24;

	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;

	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;

	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;

	/**
	 * @type {!Long}
	 * @const
	 * @inner
	 */
	var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);

	/**
	 * @type {!Long}
	 * @inner
	 */
	var ZERO = fromInt(0);

	/**
	 * Signed zero.
	 * @type {!Long}
	 */
	Long.ZERO = ZERO;

	/**
	 * @type {!Long}
	 * @inner
	 */
	var UZERO = fromInt(0, true);

	/**
	 * Unsigned zero.
	 * @type {!Long}
	 */
	Long.UZERO = UZERO;

	/**
	 * @type {!Long}
	 * @inner
	 */
	var ONE = fromInt(1);

	/**
	 * Signed one.
	 * @type {!Long}
	 */
	Long.ONE = ONE;

	/**
	 * @type {!Long}
	 * @inner
	 */
	var UONE = fromInt(1, true);

	/**
	 * Unsigned one.
	 * @type {!Long}
	 */
	Long.UONE = UONE;

	/**
	 * @type {!Long}
	 * @inner
	 */
	var NEG_ONE = fromInt(-1);

	/**
	 * Signed negative one.
	 * @type {!Long}
	 */
	Long.NEG_ONE = NEG_ONE;

	/**
	 * @type {!Long}
	 * @inner
	 */
	var MAX_VALUE = fromBits(0xFFFFFFFF | 0, 0x7FFFFFFF | 0, false);

	/**
	 * Maximum signed value.
	 * @type {!Long}
	 */
	Long.MAX_VALUE = MAX_VALUE;

	/**
	 * @type {!Long}
	 * @inner
	 */
	var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF | 0, 0xFFFFFFFF | 0, true);

	/**
	 * Maximum unsigned value.
	 * @type {!Long}
	 */
	Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;

	/**
	 * @type {!Long}
	 * @inner
	 */
	var MIN_VALUE = fromBits(0, 0x80000000 | 0, false);

	/**
	 * Minimum signed value.
	 * @type {!Long}
	 */
	Long.MIN_VALUE = MIN_VALUE;

	/**
	 * @alias Long.prototype
	 * @inner
	 */
	var LongPrototype = Long.prototype;

	/**
	 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
	 * @this {!Long}
	 * @returns {number}
	 */
	LongPrototype.toInt = function toInt() {
	  return this.unsigned ? this.low >>> 0 : this.low;
	};

	/**
	 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
	 * @this {!Long}
	 * @returns {number}
	 */
	LongPrototype.toNumber = function toNumber() {
	  if (this.unsigned)
	    return ((this.high >>> 0) * TWO_PWR_32_DBL) + (this.low >>> 0);
	  return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
	};

	/**
	 * Converts the Long to a string written in the specified radix.
	 * @this {!Long}
	 * @param {number=} radix Radix (2-36), defaults to 10
	 * @returns {string}
	 * @override
	 * @throws {RangeError} If `radix` is out of range
	 */
	LongPrototype.toString = function toString(radix) {
	  radix = radix || 10;
	  if (radix < 2 || 36 < radix)
	    throw RangeError('radix');
	  if (this.isZero())
	    return '0';
	  if (this.isNegative()) { // Unsigned Longs are never negative
	    if (this.eq(MIN_VALUE)) {
	      // We need to change the Long value before it can be negated, so we remove
	      // the bottom-most digit in this base and then recurse to do the rest.
	      var radixLong = fromNumber(radix),
	        div = this.div(radixLong),
	        rem1 = div.mul(radixLong).sub(this);
	      return div.toString(radix) + rem1.toInt().toString(radix);
	    } else
	      return '-' + this.neg().toString(radix);
	  }

	  // Do several (6) digits each time through the loop, so as to
	  // minimize the calls to the very expensive emulated div.
	  var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
	    rem = this;
	  var result = '';
	  while (true) {
	    var remDiv = rem.div(radixToPower),
	      intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
	      digits = intval.toString(radix);
	    rem = remDiv;
	    if (rem.isZero())
	      return digits + result;
	    else {
	      while (digits.length < 6)
	        digits = '0' + digits;
	      result = '' + digits + result;
	    }
	  }
	};

	/**
	 * Gets the high 32 bits as a signed integer.
	 * @this {!Long}
	 * @returns {number} Signed high bits
	 */
	LongPrototype.getHighBits = function getHighBits() {
	  return this.high;
	};

	/**
	 * Gets the high 32 bits as an unsigned integer.
	 * @this {!Long}
	 * @returns {number} Unsigned high bits
	 */
	LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
	  return this.high >>> 0;
	};

	/**
	 * Gets the low 32 bits as a signed integer.
	 * @this {!Long}
	 * @returns {number} Signed low bits
	 */
	LongPrototype.getLowBits = function getLowBits() {
	  return this.low;
	};

	/**
	 * Gets the low 32 bits as an unsigned integer.
	 * @this {!Long}
	 * @returns {number} Unsigned low bits
	 */
	LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
	  return this.low >>> 0;
	};

	/**
	 * Gets the number of bits needed to represent the absolute value of this Long.
	 * @this {!Long}
	 * @returns {number}
	 */
	LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
	  if (this.isNegative()) // Unsigned Longs are never negative
	    return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
	  var val = this.high != 0 ? this.high : this.low;
	  for (var bit = 31; bit > 0; bit--)
	    if ((val & (1 << bit)) != 0)
	      break;
	  return this.high != 0 ? bit + 33 : bit + 1;
	};

	/**
	 * Tests if this Long's value equals zero.
	 * @this {!Long}
	 * @returns {boolean}
	 */
	LongPrototype.isZero = function isZero() {
	  return this.high === 0 && this.low === 0;
	};

	/**
	 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
	 * @returns {boolean}
	 */
	LongPrototype.eqz = LongPrototype.isZero;

	/**
	 * Tests if this Long's value is negative.
	 * @this {!Long}
	 * @returns {boolean}
	 */
	LongPrototype.isNegative = function isNegative() {
	  return !this.unsigned && this.high < 0;
	};

	/**
	 * Tests if this Long's value is positive or zero.
	 * @this {!Long}
	 * @returns {boolean}
	 */
	LongPrototype.isPositive = function isPositive() {
	  return this.unsigned || this.high >= 0;
	};

	/**
	 * Tests if this Long's value is odd.
	 * @this {!Long}
	 * @returns {boolean}
	 */
	LongPrototype.isOdd = function isOdd() {
	  return (this.low & 1) === 1;
	};

	/**
	 * Tests if this Long's value is even.
	 * @this {!Long}
	 * @returns {boolean}
	 */
	LongPrototype.isEven = function isEven() {
	  return (this.low & 1) === 0;
	};

	/**
	 * Tests if this Long's value equals the specified's.
	 * @this {!Long}
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.equals = function equals(other) {
	  if (!isLong(other))
	    other = fromValue(other);
	  if (this.unsigned !== other.unsigned && (this.high >>> 31) === 1 && (other.high >>> 31) === 1)
	    return false;
	  return this.high === other.high && this.low === other.low;
	};

	/**
	 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.eq = LongPrototype.equals;

	/**
	 * Tests if this Long's value differs from the specified's.
	 * @this {!Long}
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.notEquals = function notEquals(other) {
	  return !this.eq(/* validates */ other);
	};

	/**
	 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.neq = LongPrototype.notEquals;

	/**
	 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.ne = LongPrototype.notEquals;

	/**
	 * Tests if this Long's value is less than the specified's.
	 * @this {!Long}
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.lessThan = function lessThan(other) {
	  return this.comp(/* validates */ other) < 0;
	};

	/**
	 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.lt = LongPrototype.lessThan;

	/**
	 * Tests if this Long's value is less than or equal the specified's.
	 * @this {!Long}
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
	  return this.comp(/* validates */ other) <= 0;
	};

	/**
	 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.lte = LongPrototype.lessThanOrEqual;

	/**
	 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.le = LongPrototype.lessThanOrEqual;

	/**
	 * Tests if this Long's value is greater than the specified's.
	 * @this {!Long}
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.greaterThan = function greaterThan(other) {
	  return this.comp(/* validates */ other) > 0;
	};

	/**
	 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.gt = LongPrototype.greaterThan;

	/**
	 * Tests if this Long's value is greater than or equal the specified's.
	 * @this {!Long}
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
	  return this.comp(/* validates */ other) >= 0;
	};

	/**
	 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.gte = LongPrototype.greaterThanOrEqual;

	/**
	 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.ge = LongPrototype.greaterThanOrEqual;

	/**
	 * Compares this Long's value with the specified's.
	 * @this {!Long}
	 * @param {!Long|number|string} other Other value
	 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
	 *  if the given one is greater
	 */
	LongPrototype.compare = function compare(other) {
	  if (!isLong(other))
	    other = fromValue(other);
	  if (this.eq(other))
	    return 0;
	  var thisNeg = this.isNegative(),
	    otherNeg = other.isNegative();
	  if (thisNeg && !otherNeg)
	    return -1;
	  if (!thisNeg && otherNeg)
	    return 1;
	  // At this point the sign bits are the same
	  if (!this.unsigned)
	    return this.sub(other).isNegative() ? -1 : 1;
	  // Both are positive if at least one is unsigned
	  return (other.high >>> 0) > (this.high >>> 0) || (other.high === this.high && (other.low >>> 0) > (this.low >>> 0)) ? -1 : 1;
	};

	/**
	 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
	 *  if the given one is greater
	 */
	LongPrototype.comp = LongPrototype.compare;

	/**
	 * Negates this Long's value.
	 * @this {!Long}
	 * @returns {!Long} Negated Long
	 */
	LongPrototype.negate = function negate() {
	  if (!this.unsigned && this.eq(MIN_VALUE))
	    return MIN_VALUE;
	  return this.not().add(ONE);
	};

	/**
	 * Negates this Long's value. This is an alias of {@link Long#negate}.
	 * @function
	 * @returns {!Long} Negated Long
	 */
	LongPrototype.neg = LongPrototype.negate;

	/**
	 * Returns the sum of this and the specified Long.
	 * @this {!Long}
	 * @param {!Long|number|string} addend Addend
	 * @returns {!Long} Sum
	 */
	LongPrototype.add = function add(addend) {
	  if (!isLong(addend))
	    addend = fromValue(addend);

	  // Divide each number into 4 chunks of 16 bits, and then sum the chunks.

	  var a48 = this.high >>> 16;
	  var a32 = this.high & 0xFFFF;
	  var a16 = this.low >>> 16;
	  var a00 = this.low & 0xFFFF;

	  var b48 = addend.high >>> 16;
	  var b32 = addend.high & 0xFFFF;
	  var b16 = addend.low >>> 16;
	  var b00 = addend.low & 0xFFFF;

	  var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
	  c00 += a00 + b00;
	  c16 += c00 >>> 16;
	  c00 &= 0xFFFF;
	  c16 += a16 + b16;
	  c32 += c16 >>> 16;
	  c16 &= 0xFFFF;
	  c32 += a32 + b32;
	  c48 += c32 >>> 16;
	  c32 &= 0xFFFF;
	  c48 += a48 + b48;
	  c48 &= 0xFFFF;
	  return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
	};

	/**
	 * Returns the difference of this and the specified Long.
	 * @this {!Long}
	 * @param {!Long|number|string} subtrahend Subtrahend
	 * @returns {!Long} Difference
	 */
	LongPrototype.subtract = function subtract(subtrahend) {
	  if (!isLong(subtrahend))
	    subtrahend = fromValue(subtrahend);
	  return this.add(subtrahend.neg());
	};

	/**
	 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
	 * @function
	 * @param {!Long|number|string} subtrahend Subtrahend
	 * @returns {!Long} Difference
	 */
	LongPrototype.sub = LongPrototype.subtract;

	/**
	 * Returns the product of this and the specified Long.
	 * @this {!Long}
	 * @param {!Long|number|string} multiplier Multiplier
	 * @returns {!Long} Product
	 */
	LongPrototype.multiply = function multiply(multiplier) {
	  if (this.isZero())
	    return this;
	  if (!isLong(multiplier))
	    multiplier = fromValue(multiplier);

	  // use wasm support if present
	  if (wasm) {
	    var low = wasm["mul"](this.low,
	      this.high,
	      multiplier.low,
	      multiplier.high);
	    return fromBits(low, wasm["get_high"](), this.unsigned);
	  }

	  if (multiplier.isZero())
	    return this.unsigned ? UZERO : ZERO;
	  if (this.eq(MIN_VALUE))
	    return multiplier.isOdd() ? MIN_VALUE : ZERO;
	  if (multiplier.eq(MIN_VALUE))
	    return this.isOdd() ? MIN_VALUE : ZERO;

	  if (this.isNegative()) {
	    if (multiplier.isNegative())
	      return this.neg().mul(multiplier.neg());
	    else
	      return this.neg().mul(multiplier).neg();
	  } else if (multiplier.isNegative())
	    return this.mul(multiplier.neg()).neg();

	  // If both longs are small, use float multiplication
	  if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
	    return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);

	  // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
	  // We can skip products that would overflow.

	  var a48 = this.high >>> 16;
	  var a32 = this.high & 0xFFFF;
	  var a16 = this.low >>> 16;
	  var a00 = this.low & 0xFFFF;

	  var b48 = multiplier.high >>> 16;
	  var b32 = multiplier.high & 0xFFFF;
	  var b16 = multiplier.low >>> 16;
	  var b00 = multiplier.low & 0xFFFF;

	  var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
	  c00 += a00 * b00;
	  c16 += c00 >>> 16;
	  c00 &= 0xFFFF;
	  c16 += a16 * b00;
	  c32 += c16 >>> 16;
	  c16 &= 0xFFFF;
	  c16 += a00 * b16;
	  c32 += c16 >>> 16;
	  c16 &= 0xFFFF;
	  c32 += a32 * b00;
	  c48 += c32 >>> 16;
	  c32 &= 0xFFFF;
	  c32 += a16 * b16;
	  c48 += c32 >>> 16;
	  c32 &= 0xFFFF;
	  c32 += a00 * b32;
	  c48 += c32 >>> 16;
	  c32 &= 0xFFFF;
	  c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
	  c48 &= 0xFFFF;
	  return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
	};

	/**
	 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
	 * @function
	 * @param {!Long|number|string} multiplier Multiplier
	 * @returns {!Long} Product
	 */
	LongPrototype.mul = LongPrototype.multiply;

	/**
	 * Returns this Long divided by the specified. The result is signed if this Long is signed or
	 *  unsigned if this Long is unsigned.
	 * @this {!Long}
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Quotient
	 */
	LongPrototype.divide = function divide(divisor) {
	  if (!isLong(divisor))
	    divisor = fromValue(divisor);
	  if (divisor.isZero())
	    throw Error('division by zero');

	  // use wasm support if present
	  if (wasm) {
	    // guard against signed division overflow: the largest
	    // negative number / -1 would be 1 larger than the largest
	    // positive number, due to two's complement.
	    if (!this.unsigned &&
	      this.high === -0x80000000 &&
	      divisor.low === -1 && divisor.high === -1) {
	      // be consistent with non-wasm code path
	      return this;
	    }
	    var low = (this.unsigned ? wasm["div_u"] : wasm["div_s"])(
	      this.low,
	      this.high,
	      divisor.low,
	      divisor.high
	    );
	    return fromBits(low, wasm["get_high"](), this.unsigned);
	  }

	  if (this.isZero())
	    return this.unsigned ? UZERO : ZERO;
	  var approx, rem, res;
	  if (!this.unsigned) {
	    // This section is only relevant for signed longs and is derived from the
	    // closure library as a whole.
	    if (this.eq(MIN_VALUE)) {
	      if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
	        return MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
	      else if (divisor.eq(MIN_VALUE))
	        return ONE;
	      else {
	        // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
	        var halfThis = this.shr(1);
	        approx = halfThis.div(divisor).shl(1);
	        if (approx.eq(ZERO)) {
	          return divisor.isNegative() ? ONE : NEG_ONE;
	        } else {
	          rem = this.sub(divisor.mul(approx));
	          res = approx.add(rem.div(divisor));
	          return res;
	        }
	      }
	    } else if (divisor.eq(MIN_VALUE))
	      return this.unsigned ? UZERO : ZERO;
	    if (this.isNegative()) {
	      if (divisor.isNegative())
	        return this.neg().div(divisor.neg());
	      return this.neg().div(divisor).neg();
	    } else if (divisor.isNegative())
	      return this.div(divisor.neg()).neg();
	    res = ZERO;
	  } else {
	    // The algorithm below has not been made for unsigned longs. It's therefore
	    // required to take special care of the MSB prior to running it.
	    if (!divisor.unsigned)
	      divisor = divisor.toUnsigned();
	    if (divisor.gt(this))
	      return UZERO;
	    if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
	      return UONE;
	    res = UZERO;
	  }

	  // Repeat the following until the remainder is less than other:  find a
	  // floating-point that approximates remainder / other *from below*, add this
	  // into the result, and subtract it from the remainder.  It is critical that
	  // the approximate value is less than or equal to the real value so that the
	  // remainder never becomes negative.
	  rem = this;
	  while (rem.gte(divisor)) {
	    // Approximate the result of division. This may be a little greater or
	    // smaller than the actual value.
	    approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));

	    // We will tweak the approximate result by changing it in the 48-th digit or
	    // the smallest non-fractional digit, whichever is larger.
	    var log2 = Math.ceil(Math.log(approx) / Math.LN2),
	      delta = (log2 <= 48) ? 1 : pow_dbl(2, log2 - 48),

	      // Decrease the approximation until it is smaller than the remainder.  Note
	      // that if it is too large, the product overflows and is negative.
	      approxRes = fromNumber(approx),
	      approxRem = approxRes.mul(divisor);
	    while (approxRem.isNegative() || approxRem.gt(rem)) {
	      approx -= delta;
	      approxRes = fromNumber(approx, this.unsigned);
	      approxRem = approxRes.mul(divisor);
	    }

	    // We know the answer can't be zero... and actually, zero would cause
	    // infinite recursion since we would make no progress.
	    if (approxRes.isZero())
	      approxRes = ONE;

	    res = res.add(approxRes);
	    rem = rem.sub(approxRem);
	  }
	  return res;
	};

	/**
	 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
	 * @function
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Quotient
	 */
	LongPrototype.div = LongPrototype.divide;

	/**
	 * Returns this Long modulo the specified.
	 * @this {!Long}
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Remainder
	 */
	LongPrototype.modulo = function modulo(divisor) {
	  if (!isLong(divisor))
	    divisor = fromValue(divisor);

	  // use wasm support if present
	  if (wasm) {
	    var low = (this.unsigned ? wasm["rem_u"] : wasm["rem_s"])(
	      this.low,
	      this.high,
	      divisor.low,
	      divisor.high
	    );
	    return fromBits(low, wasm["get_high"](), this.unsigned);
	  }

	  return this.sub(this.div(divisor).mul(divisor));
	};

	/**
	 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
	 * @function
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Remainder
	 */
	LongPrototype.mod = LongPrototype.modulo;

	/**
	 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
	 * @function
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Remainder
	 */
	LongPrototype.rem = LongPrototype.modulo;

	/**
	 * Returns the bitwise NOT of this Long.
	 * @this {!Long}
	 * @returns {!Long}
	 */
	LongPrototype.not = function not() {
	  return fromBits(~this.low, ~this.high, this.unsigned);
	};

	/**
	 * Returns count leading zeros of this Long.
	 * @this {!Long}
	 * @returns {!number}
	 */
	LongPrototype.countLeadingZeros = function countLeadingZeros() {
	  return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
	};

	/**
	 * Returns count leading zeros. This is an alias of {@link Long#countLeadingZeros}.
	 * @function
	 * @param {!Long}
	 * @returns {!number}
	 */
	LongPrototype.clz = LongPrototype.countLeadingZeros;

	/**
	 * Returns count trailing zeros of this Long.
	 * @this {!Long}
	 * @returns {!number}
	 */
	LongPrototype.countTrailingZeros = function countTrailingZeros() {
	  return this.low ? ctz32(this.low) : ctz32(this.high) + 32;
	};

	/**
	 * Returns count trailing zeros. This is an alias of {@link Long#countTrailingZeros}.
	 * @function
	 * @param {!Long}
	 * @returns {!number}
	 */
	LongPrototype.ctz = LongPrototype.countTrailingZeros;

	/**
	 * Returns the bitwise AND of this Long and the specified.
	 * @this {!Long}
	 * @param {!Long|number|string} other Other Long
	 * @returns {!Long}
	 */
	LongPrototype.and = function and(other) {
	  if (!isLong(other))
	    other = fromValue(other);
	  return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
	};

	/**
	 * Returns the bitwise OR of this Long and the specified.
	 * @this {!Long}
	 * @param {!Long|number|string} other Other Long
	 * @returns {!Long}
	 */
	LongPrototype.or = function or(other) {
	  if (!isLong(other))
	    other = fromValue(other);
	  return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
	};

	/**
	 * Returns the bitwise XOR of this Long and the given one.
	 * @this {!Long}
	 * @param {!Long|number|string} other Other Long
	 * @returns {!Long}
	 */
	LongPrototype.xor = function xor(other) {
	  if (!isLong(other))
	    other = fromValue(other);
	  return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
	};

	/**
	 * Returns this Long with bits shifted to the left by the given amount.
	 * @this {!Long}
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shiftLeft = function shiftLeft(numBits) {
	  if (isLong(numBits))
	    numBits = numBits.toInt();
	  if ((numBits &= 63) === 0)
	    return this;
	  else if (numBits < 32)
	    return fromBits(this.low << numBits, (this.high << numBits) | (this.low >>> (32 - numBits)), this.unsigned);
	  else
	    return fromBits(0, this.low << (numBits - 32), this.unsigned);
	};

	/**
	 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shl = LongPrototype.shiftLeft;

	/**
	 * Returns this Long with bits arithmetically shifted to the right by the given amount.
	 * @this {!Long}
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shiftRight = function shiftRight(numBits) {
	  if (isLong(numBits))
	    numBits = numBits.toInt();
	  if ((numBits &= 63) === 0)
	    return this;
	  else if (numBits < 32)
	    return fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >> numBits, this.unsigned);
	  else
	    return fromBits(this.high >> (numBits - 32), this.high >= 0 ? 0 : -1, this.unsigned);
	};

	/**
	 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shr = LongPrototype.shiftRight;

	/**
	 * Returns this Long with bits logically shifted to the right by the given amount.
	 * @this {!Long}
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
	  if (isLong(numBits)) numBits = numBits.toInt();
	  if ((numBits &= 63) === 0) return this;
	  if (numBits < 32) return fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >>> numBits, this.unsigned);
	  if (numBits === 32) return fromBits(this.high, 0, this.unsigned);
	  return fromBits(this.high >>> (numBits - 32), 0, this.unsigned);
	};

	/**
	 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shru = LongPrototype.shiftRightUnsigned;

	/**
	 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;

	/**
	 * Returns this Long with bits rotated to the left by the given amount.
	 * @this {!Long}
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Rotated Long
	 */
	LongPrototype.rotateLeft = function rotateLeft(numBits) {
	  var b;
	  if (isLong(numBits)) numBits = numBits.toInt();
	  if ((numBits &= 63) === 0) return this;
	  if (numBits === 32) return fromBits(this.high, this.low, this.unsigned);
	  if (numBits < 32) {
	    b = (32 - numBits);
	    return fromBits(((this.low << numBits) | (this.high >>> b)), ((this.high << numBits) | (this.low >>> b)), this.unsigned);
	  }
	  numBits -= 32;
	  b = (32 - numBits);
	  return fromBits(((this.high << numBits) | (this.low >>> b)), ((this.low << numBits) | (this.high >>> b)), this.unsigned);
	};
	/**
	 * Returns this Long with bits rotated to the left by the given amount. This is an alias of {@link Long#rotateLeft}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Rotated Long
	 */
	LongPrototype.rotl = LongPrototype.rotateLeft;

	/**
	 * Returns this Long with bits rotated to the right by the given amount.
	 * @this {!Long}
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Rotated Long
	 */
	LongPrototype.rotateRight = function rotateRight(numBits) {
	  var b;
	  if (isLong(numBits)) numBits = numBits.toInt();
	  if ((numBits &= 63) === 0) return this;
	  if (numBits === 32) return fromBits(this.high, this.low, this.unsigned);
	  if (numBits < 32) {
	    b = (32 - numBits);
	    return fromBits(((this.high << b) | (this.low >>> numBits)), ((this.low << b) | (this.high >>> numBits)), this.unsigned);
	  }
	  numBits -= 32;
	  b = (32 - numBits);
	  return fromBits(((this.low << b) | (this.high >>> numBits)), ((this.high << b) | (this.low >>> numBits)), this.unsigned);
	};
	/**
	 * Returns this Long with bits rotated to the right by the given amount. This is an alias of {@link Long#rotateRight}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Rotated Long
	 */
	LongPrototype.rotr = LongPrototype.rotateRight;

	/**
	 * Converts this Long to signed.
	 * @this {!Long}
	 * @returns {!Long} Signed long
	 */
	LongPrototype.toSigned = function toSigned() {
	  if (!this.unsigned)
	    return this;
	  return fromBits(this.low, this.high, false);
	};

	/**
	 * Converts this Long to unsigned.
	 * @this {!Long}
	 * @returns {!Long} Unsigned long
	 */
	LongPrototype.toUnsigned = function toUnsigned() {
	  if (this.unsigned)
	    return this;
	  return fromBits(this.low, this.high, true);
	};

	/**
	 * Converts this Long to its byte representation.
	 * @param {boolean=} le Whether little or big endian, defaults to big endian
	 * @this {!Long}
	 * @returns {!Array.<number>} Byte representation
	 */
	LongPrototype.toBytes = function toBytes(le) {
	  return le ? this.toBytesLE() : this.toBytesBE();
	};

	/**
	 * Converts this Long to its little endian byte representation.
	 * @this {!Long}
	 * @returns {!Array.<number>} Little endian byte representation
	 */
	LongPrototype.toBytesLE = function toBytesLE() {
	  var hi = this.high,
	    lo = this.low;
	  return [
	    lo & 0xff,
	    lo >>> 8 & 0xff,
	    lo >>> 16 & 0xff,
	    lo >>> 24,
	    hi & 0xff,
	    hi >>> 8 & 0xff,
	    hi >>> 16 & 0xff,
	    hi >>> 24
	  ];
	};

	/**
	 * Converts this Long to its big endian byte representation.
	 * @this {!Long}
	 * @returns {!Array.<number>} Big endian byte representation
	 */
	LongPrototype.toBytesBE = function toBytesBE() {
	  var hi = this.high,
	    lo = this.low;
	  return [
	    hi >>> 24,
	    hi >>> 16 & 0xff,
	    hi >>> 8 & 0xff,
	    hi & 0xff,
	    lo >>> 24,
	    lo >>> 16 & 0xff,
	    lo >>> 8 & 0xff,
	    lo & 0xff
	  ];
	};

	/**
	 * Creates a Long from its byte representation.
	 * @param {!Array.<number>} bytes Byte representation
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @param {boolean=} le Whether little or big endian, defaults to big endian
	 * @returns {Long} The corresponding Long value
	 */
	Long.fromBytes = function fromBytes(bytes, unsigned, le) {
	  return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
	};

	/**
	 * Creates a Long from its little endian byte representation.
	 * @param {!Array.<number>} bytes Little endian byte representation
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {Long} The corresponding Long value
	 */
	Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
	  return new Long(
	    bytes[0] |
	    bytes[1] << 8 |
	    bytes[2] << 16 |
	    bytes[3] << 24,
	    bytes[4] |
	    bytes[5] << 8 |
	    bytes[6] << 16 |
	    bytes[7] << 24,
	    unsigned
	  );
	};

	/**
	 * Creates a Long from its big endian byte representation.
	 * @param {!Array.<number>} bytes Big endian byte representation
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {Long} The corresponding Long value
	 */
	Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
	  return new Long(
	    bytes[4] << 24 |
	    bytes[5] << 16 |
	    bytes[6] << 8 |
	    bytes[7],
	    bytes[0] << 24 |
	    bytes[1] << 16 |
	    bytes[2] << 8 |
	    bytes[3],
	    unsigned
	  );
	};

	/* eslint-disable */
	// @ts-nocheck
	/*
	* This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
	*/
	var __awaiter$3 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	/**
	 * base64 encoder and decoder
	 * Copied and adapted from https://github.com/protobufjs/protobuf.js/blob/master/lib/base64/index.js
	 */
	// Base64 encoding table
	const b64 = new Array(64);
	// Base64 decoding table
	const s64 = new Array(123);
	// 65..90, 97..122, 48..57, 43, 47
	for (let i = 0; i < 64;)
	    s64[b64[i] = i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i - 59 | 43] = i++;
	function b64Encode(buffer, start, end) {
	    let parts = null;
	    const chunk = [];
	    let i = 0, // output index
	    j = 0, // goto index
	    t; // temporary
	    while (start < end) {
	        const b = buffer[start++];
	        switch (j) {
	            case 0:
	                chunk[i++] = b64[b >> 2];
	                t = (b & 3) << 4;
	                j = 1;
	                break;
	            case 1:
	                chunk[i++] = b64[t | b >> 4];
	                t = (b & 15) << 2;
	                j = 2;
	                break;
	            case 2:
	                chunk[i++] = b64[t | b >> 6];
	                chunk[i++] = b64[b & 63];
	                j = 0;
	                break;
	        }
	        if (i > 8191) {
	            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
	            i = 0;
	        }
	    }
	    if (j) {
	        chunk[i++] = b64[t];
	        chunk[i++] = 61;
	        if (j === 1)
	            chunk[i++] = 61;
	    }
	    if (parts) {
	        if (i)
	            parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
	        return parts.join("");
	    }
	    return String.fromCharCode.apply(String, chunk.slice(0, i));
	}
	const invalidEncoding = "invalid encoding";
	function b64Decode(s) {
	    const buffer = [];
	    let offset = 0;
	    let j = 0, // goto index
	    t; // temporary
	    for (let i = 0; i < s.length;) {
	        let c = s.charCodeAt(i++);
	        if (c === 61 && j > 1)
	            break;
	        if ((c = s64[c]) === undefined)
	            throw Error(invalidEncoding);
	        switch (j) {
	            case 0:
	                t = c;
	                j = 1;
	                break;
	            case 1:
	                buffer[offset++] = t << 2 | (c & 48) >> 4;
	                t = c;
	                j = 2;
	                break;
	            case 2:
	                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
	                t = c;
	                j = 3;
	                break;
	            case 3:
	                buffer[offset++] = (t & 3) << 6 | c;
	                j = 0;
	                break;
	        }
	    }
	    if (j === 1)
	        throw Error(invalidEncoding);
	    return new Uint8Array(buffer);
	}
	function replacer(key, value) {
	    if (value && value.constructor === Uint8Array) {
	        return b64Encode(value, 0, value.length);
	    }
	    return value;
	}
	function fetchReq(path, init) {
	    const _a = init || {}, { pathPrefix } = _a, req = __rest$1(_a, ["pathPrefix"]);
	    const url = pathPrefix ? `${pathPrefix}${path}` : path;
	    return fetch(url, req).then(r => r.json().then((body) => {
	        if (!r.ok) {
	            throw body;
	        }
	        return body;
	    }));
	}
	/**
	 * fetchStreamingRequest is able to handle grpc-gateway server side streaming call
	 * it takes NotifyStreamEntityArrival that lets users respond to entity arrival during the call
	 * all entities will be returned as an array after the call finishes.
	 **/
	function fetchStreamingRequest(path, callback, init) {
	    return __awaiter$3(this, void 0, void 0, function* () {
	        const _a = init || {}, { pathPrefix } = _a, req = __rest$1(_a, ["pathPrefix"]);
	        const url = pathPrefix ? `${pathPrefix}${path}` : path;
	        const result = yield fetch(url, req);
	        // needs to use the .ok to check the status of HTTP status code
	        // http other than 200 will not throw an error, instead the .ok will become false.
	        // see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#
	        if (!result.ok) {
	            const resp = yield result.json();
	            const errMsg = resp.error && resp.error.message ? resp.error.message : "";
	            throw new Error(errMsg);
	        }
	        if (!result.body) {
	            throw new Error("response doesnt have a body");
	        }
	        yield result.body
	            .pipeThrough(new TextDecoderStream())
	            .pipeThrough(getNewLineDelimitedJSONDecodingStream())
	            .pipeTo(getNotifyEntityArrivalSink((e) => {
	            if (callback) {
	                callback(e);
	            }
	        }));
	        // wait for the streaming to finish and return the success respond
	        return;
	    });
	}
	/**
	 * getNewLineDelimitedJSONDecodingStream returns a TransformStream that's able to handle new line delimited json stream content into parsed entities
	 */
	function getNewLineDelimitedJSONDecodingStream() {
	    return new TransformStream({
	        start(controller) {
	            controller.buf = '';
	            controller.pos = 0;
	        },
	        transform(chunk, controller) {
	            if (controller.buf === undefined) {
	                controller.buf = '';
	            }
	            if (controller.pos === undefined) {
	                controller.pos = 0;
	            }
	            controller.buf += chunk;
	            while (controller.pos < controller.buf.length) {
	                if (controller.buf[controller.pos] === '\n') {
	                    const line = controller.buf.substring(0, controller.pos);
	                    const response = JSON.parse(line);
	                    controller.enqueue(response.result);
	                    controller.buf = controller.buf.substring(controller.pos + 1);
	                    controller.pos = 0;
	                }
	                else {
	                    ++controller.pos;
	                }
	            }
	        }
	    });
	}
	/**
	 * getNotifyEntityArrivalSink takes the NotifyStreamEntityArrival callback and return
	 * a sink that will call the callback on entity arrival
	 * @param notifyCallback
	 */
	function getNotifyEntityArrivalSink(notifyCallback) {
	    return new WritableStream({
	        write(entity) {
	            notifyCallback(entity);
	        }
	    });
	}
	/**
	 * Checks if given value is a plain object
	 * Logic copied and adapted from below source:
	 * https://github.com/char0n/ramda-adjunct/blob/master/src/isPlainObj.js
	 * @param  {unknown} value
	 * @return {boolean}
	 */
	function isPlainObject$1(value) {
	    const isObject = Object.prototype.toString.call(value).slice(8, -1) === "Object";
	    const isObjLike = value !== null && isObject;
	    if (!isObjLike || !isObject) {
	        return false;
	    }
	    const proto = Object.getPrototypeOf(value);
	    const hasObjectConstructor = typeof proto === "object" &&
	        proto.constructor === Object.prototype.constructor;
	    return hasObjectConstructor;
	}
	/**
	 * Checks if given value is of a primitive type
	 * @param  {unknown} value
	 * @return {boolean}
	 */
	function isPrimitive(value) {
	    return ["string", "number", "boolean"].some(t => typeof value === t);
	}
	/**
	 * Checks if given primitive is zero-value
	 * @param  {Primitive} value
	 * @return {boolean}
	 */
	function isZeroValuePrimitive(value) {
	    return value === false || value === 0 || value === "";
	}
	/**
	 * Flattens a deeply nested request payload and returns an object
	 * with only primitive values and non-empty array of primitive values
	 * as per https://github.com/googleapis/googleapis/blob/master/google/api/http.proto
	 * @param  {RequestPayload} requestPayload
	 * @param  {String} path
	 * @return {FlattenedRequestPayload>}
	 */
	function flattenRequestPayload(requestPayload, path = "") {
	    return Object.keys(requestPayload).reduce((acc, key) => {
	        const value = requestPayload[key];
	        const newPath = path ? [path, key].join(".") : key;
	        const isNonEmptyPrimitiveArray = Array.isArray(value) &&
	            value.every(v => isPrimitive(v)) &&
	            value.length > 0;
	        const isNonZeroValuePrimitive = isPrimitive(value) && !isZeroValuePrimitive(value);
	        let objectToMerge = {};
	        if (isPlainObject$1(value)) {
	            objectToMerge = flattenRequestPayload(value, newPath);
	        }
	        else if (isNonZeroValuePrimitive || isNonEmptyPrimitiveArray) {
	            objectToMerge = { [newPath]: value };
	        }
	        return Object.assign(Object.assign({}, acc), objectToMerge);
	    }, {});
	}
	/**
	 * Renders a deeply nested request payload into a string of URL search
	 * parameters by first flattening the request payload and then removing keys
	 * which are already present in the URL path.
	 * @param  {RequestPayload} requestPayload
	 * @param  {string[]} urlPathParams
	 * @return {string}
	 */
	function renderURLSearchParams(requestPayload, urlPathParams = []) {
	    const flattenedRequestPayload = flattenRequestPayload(requestPayload);
	    const urlSearchParams = Object.keys(flattenedRequestPayload).reduce((acc, key) => {
	        // key should not be present in the url path as a parameter
	        const value = flattenedRequestPayload[key];
	        if (urlPathParams.find(f => f === key)) {
	            return acc;
	        }
	        return Array.isArray(value)
	            ? [...acc, ...value.map(m => [key, m.toString()])]
	            : (acc = [...acc, [key, value.toString()]]);
	    }, []);
	    return new URLSearchParams(urlSearchParams).toString();
	}

	var fetcher = /*#__PURE__*/Object.freeze({
		__proto__: null,
		b64Decode: b64Decode,
		b64Encode: b64Encode,
		fetchReq: fetchReq,
		fetchStreamingRequest: fetchStreamingRequest,
		renderURLSearchParams: renderURLSearchParams,
		replacer: replacer
	});

	/* eslint-disable */
	// @ts-nocheck
	/*
	* This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
	*/
	var SortDirection;
	(function (SortDirection) {
	    SortDirection["SORT_DIRECTION_UNSPECIFIED"] = "SORT_DIRECTION_UNSPECIFIED";
	    SortDirection["SORT_DIRECTION_ASCENDING"] = "SORT_DIRECTION_ASCENDING";
	    SortDirection["SORT_DIRECTION_DESCENDING"] = "SORT_DIRECTION_DESCENDING";
	})(SortDirection || (SortDirection = {}));
	class MessageApi {
	    static Publish(req, initReq) {
	        return fetchReq(`/message/v1/publish`, Object.assign(Object.assign({}, initReq), { method: "POST", body: JSON.stringify(req, replacer) }));
	    }
	    static Subscribe(req, entityNotifier, initReq) {
	        return fetchStreamingRequest(`/message/v1/subscribe`, entityNotifier, Object.assign(Object.assign({}, initReq), { method: "POST", body: JSON.stringify(req, replacer) }));
	    }
	    static SubscribeAll(req, entityNotifier, initReq) {
	        return fetchStreamingRequest(`/message/v1/subscribe-all`, entityNotifier, Object.assign(Object.assign({}, initReq), { method: "POST", body: JSON.stringify(req, replacer) }));
	    }
	    static Query(req, initReq) {
	        return fetchReq(`/message/v1/query`, Object.assign(Object.assign({}, initReq), { method: "POST", body: JSON.stringify(req, replacer) }));
	    }
	    static BatchQuery(req, initReq) {
	        return fetchReq(`/message/v1/batch-query`, Object.assign(Object.assign({}, initReq), { method: "POST", body: JSON.stringify(req, replacer) }));
	    }
	}

	var messageApi = /*#__PURE__*/Object.freeze({
		__proto__: null,
		MessageApi: MessageApi,
		get SortDirection () { return SortDirection; }
	});

	var indexMinimal = {};

	var minimal$1 = {};

	var aspromise;
	var hasRequiredAspromise;

	function requireAspromise () {
		if (hasRequiredAspromise) return aspromise;
		hasRequiredAspromise = 1;
		aspromise = asPromise;

		/**
		 * Callback as used by {@link util.asPromise}.
		 * @typedef asPromiseCallback
		 * @type {function}
		 * @param {Error|null} error Error, if any
		 * @param {...*} params Additional arguments
		 * @returns {undefined}
		 */

		/**
		 * Returns a promise from a node-style callback function.
		 * @memberof util
		 * @param {asPromiseCallback} fn Function to call
		 * @param {*} ctx Function context
		 * @param {...*} params Function arguments
		 * @returns {Promise<*>} Promisified function
		 */
		function asPromise(fn, ctx/*, varargs */) {
		    var params  = new Array(arguments.length - 1),
		        offset  = 0,
		        index   = 2,
		        pending = true;
		    while (index < arguments.length)
		        params[offset++] = arguments[index++];
		    return new Promise(function executor(resolve, reject) {
		        params[offset] = function callback(err/*, varargs */) {
		            if (pending) {
		                pending = false;
		                if (err)
		                    reject(err);
		                else {
		                    var params = new Array(arguments.length - 1),
		                        offset = 0;
		                    while (offset < params.length)
		                        params[offset++] = arguments[offset];
		                    resolve.apply(null, params);
		                }
		            }
		        };
		        try {
		            fn.apply(ctx || null, params);
		        } catch (err) {
		            if (pending) {
		                pending = false;
		                reject(err);
		            }
		        }
		    });
		}
		return aspromise;
	}

	var base64$3 = {};

	var hasRequiredBase64;

	function requireBase64 () {
		if (hasRequiredBase64) return base64$3;
		hasRequiredBase64 = 1;
		(function (exports) {

			/**
			 * A minimal base64 implementation for number arrays.
			 * @memberof util
			 * @namespace
			 */
			var base64 = exports;

			/**
			 * Calculates the byte length of a base64 encoded string.
			 * @param {string} string Base64 encoded string
			 * @returns {number} Byte length
			 */
			base64.length = function length(string) {
			    var p = string.length;
			    if (!p)
			        return 0;
			    var n = 0;
			    while (--p % 4 > 1 && string.charAt(p) === "=")
			        ++n;
			    return Math.ceil(string.length * 3) / 4 - n;
			};

			// Base64 encoding table
			var b64 = new Array(64);

			// Base64 decoding table
			var s64 = new Array(123);

			// 65..90, 97..122, 48..57, 43, 47
			for (var i = 0; i < 64;)
			    s64[b64[i] = i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i - 59 | 43] = i++;

			/**
			 * Encodes a buffer to a base64 encoded string.
			 * @param {Uint8Array} buffer Source buffer
			 * @param {number} start Source start
			 * @param {number} end Source end
			 * @returns {string} Base64 encoded string
			 */
			base64.encode = function encode(buffer, start, end) {
			    var parts = null,
			        chunk = [];
			    var i = 0, // output index
			        j = 0, // goto index
			        t;     // temporary
			    while (start < end) {
			        var b = buffer[start++];
			        switch (j) {
			            case 0:
			                chunk[i++] = b64[b >> 2];
			                t = (b & 3) << 4;
			                j = 1;
			                break;
			            case 1:
			                chunk[i++] = b64[t | b >> 4];
			                t = (b & 15) << 2;
			                j = 2;
			                break;
			            case 2:
			                chunk[i++] = b64[t | b >> 6];
			                chunk[i++] = b64[b & 63];
			                j = 0;
			                break;
			        }
			        if (i > 8191) {
			            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
			            i = 0;
			        }
			    }
			    if (j) {
			        chunk[i++] = b64[t];
			        chunk[i++] = 61;
			        if (j === 1)
			            chunk[i++] = 61;
			    }
			    if (parts) {
			        if (i)
			            parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
			        return parts.join("");
			    }
			    return String.fromCharCode.apply(String, chunk.slice(0, i));
			};

			var invalidEncoding = "invalid encoding";

			/**
			 * Decodes a base64 encoded string to a buffer.
			 * @param {string} string Source string
			 * @param {Uint8Array} buffer Destination buffer
			 * @param {number} offset Destination offset
			 * @returns {number} Number of bytes written
			 * @throws {Error} If encoding is invalid
			 */
			base64.decode = function decode(string, buffer, offset) {
			    var start = offset;
			    var j = 0, // goto index
			        t;     // temporary
			    for (var i = 0; i < string.length;) {
			        var c = string.charCodeAt(i++);
			        if (c === 61 && j > 1)
			            break;
			        if ((c = s64[c]) === undefined)
			            throw Error(invalidEncoding);
			        switch (j) {
			            case 0:
			                t = c;
			                j = 1;
			                break;
			            case 1:
			                buffer[offset++] = t << 2 | (c & 48) >> 4;
			                t = c;
			                j = 2;
			                break;
			            case 2:
			                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
			                t = c;
			                j = 3;
			                break;
			            case 3:
			                buffer[offset++] = (t & 3) << 6 | c;
			                j = 0;
			                break;
			        }
			    }
			    if (j === 1)
			        throw Error(invalidEncoding);
			    return offset - start;
			};

			/**
			 * Tests if the specified string appears to be base64 encoded.
			 * @param {string} string String to test
			 * @returns {boolean} `true` if probably base64 encoded, otherwise false
			 */
			base64.test = function test(string) {
			    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
			}; 
		} (base64$3));
		return base64$3;
	}

	var eventemitter;
	var hasRequiredEventemitter;

	function requireEventemitter () {
		if (hasRequiredEventemitter) return eventemitter;
		hasRequiredEventemitter = 1;
		eventemitter = EventEmitter;

		/**
		 * Constructs a new event emitter instance.
		 * @classdesc A minimal event emitter.
		 * @memberof util
		 * @constructor
		 */
		function EventEmitter() {

		    /**
		     * Registered listeners.
		     * @type {Object.<string,*>}
		     * @private
		     */
		    this._listeners = {};
		}

		/**
		 * Registers an event listener.
		 * @param {string} evt Event name
		 * @param {function} fn Listener
		 * @param {*} [ctx] Listener context
		 * @returns {util.EventEmitter} `this`
		 */
		EventEmitter.prototype.on = function on(evt, fn, ctx) {
		    (this._listeners[evt] || (this._listeners[evt] = [])).push({
		        fn  : fn,
		        ctx : ctx || this
		    });
		    return this;
		};

		/**
		 * Removes an event listener or any matching listeners if arguments are omitted.
		 * @param {string} [evt] Event name. Removes all listeners if omitted.
		 * @param {function} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
		 * @returns {util.EventEmitter} `this`
		 */
		EventEmitter.prototype.off = function off(evt, fn) {
		    if (evt === undefined)
		        this._listeners = {};
		    else {
		        if (fn === undefined)
		            this._listeners[evt] = [];
		        else {
		            var listeners = this._listeners[evt];
		            for (var i = 0; i < listeners.length;)
		                if (listeners[i].fn === fn)
		                    listeners.splice(i, 1);
		                else
		                    ++i;
		        }
		    }
		    return this;
		};

		/**
		 * Emits an event by calling its listeners with the specified arguments.
		 * @param {string} evt Event name
		 * @param {...*} args Arguments
		 * @returns {util.EventEmitter} `this`
		 */
		EventEmitter.prototype.emit = function emit(evt) {
		    var listeners = this._listeners[evt];
		    if (listeners) {
		        var args = [],
		            i = 1;
		        for (; i < arguments.length;)
		            args.push(arguments[i++]);
		        for (i = 0; i < listeners.length;)
		            listeners[i].fn.apply(listeners[i++].ctx, args);
		    }
		    return this;
		};
		return eventemitter;
	}

	var float;
	var hasRequiredFloat;

	function requireFloat () {
		if (hasRequiredFloat) return float;
		hasRequiredFloat = 1;

		float = factory(factory);

		/**
		 * Reads / writes floats / doubles from / to buffers.
		 * @name util.float
		 * @namespace
		 */

		/**
		 * Writes a 32 bit float to a buffer using little endian byte order.
		 * @name util.float.writeFloatLE
		 * @function
		 * @param {number} val Value to write
		 * @param {Uint8Array} buf Target buffer
		 * @param {number} pos Target buffer offset
		 * @returns {undefined}
		 */

		/**
		 * Writes a 32 bit float to a buffer using big endian byte order.
		 * @name util.float.writeFloatBE
		 * @function
		 * @param {number} val Value to write
		 * @param {Uint8Array} buf Target buffer
		 * @param {number} pos Target buffer offset
		 * @returns {undefined}
		 */

		/**
		 * Reads a 32 bit float from a buffer using little endian byte order.
		 * @name util.float.readFloatLE
		 * @function
		 * @param {Uint8Array} buf Source buffer
		 * @param {number} pos Source buffer offset
		 * @returns {number} Value read
		 */

		/**
		 * Reads a 32 bit float from a buffer using big endian byte order.
		 * @name util.float.readFloatBE
		 * @function
		 * @param {Uint8Array} buf Source buffer
		 * @param {number} pos Source buffer offset
		 * @returns {number} Value read
		 */

		/**
		 * Writes a 64 bit double to a buffer using little endian byte order.
		 * @name util.float.writeDoubleLE
		 * @function
		 * @param {number} val Value to write
		 * @param {Uint8Array} buf Target buffer
		 * @param {number} pos Target buffer offset
		 * @returns {undefined}
		 */

		/**
		 * Writes a 64 bit double to a buffer using big endian byte order.
		 * @name util.float.writeDoubleBE
		 * @function
		 * @param {number} val Value to write
		 * @param {Uint8Array} buf Target buffer
		 * @param {number} pos Target buffer offset
		 * @returns {undefined}
		 */

		/**
		 * Reads a 64 bit double from a buffer using little endian byte order.
		 * @name util.float.readDoubleLE
		 * @function
		 * @param {Uint8Array} buf Source buffer
		 * @param {number} pos Source buffer offset
		 * @returns {number} Value read
		 */

		/**
		 * Reads a 64 bit double from a buffer using big endian byte order.
		 * @name util.float.readDoubleBE
		 * @function
		 * @param {Uint8Array} buf Source buffer
		 * @param {number} pos Source buffer offset
		 * @returns {number} Value read
		 */

		// Factory function for the purpose of node-based testing in modified global environments
		function factory(exports) {

		    // float: typed array
		    if (typeof Float32Array !== "undefined") (function() {

		        var f32 = new Float32Array([ -0 ]),
		            f8b = new Uint8Array(f32.buffer),
		            le  = f8b[3] === 128;

		        function writeFloat_f32_cpy(val, buf, pos) {
		            f32[0] = val;
		            buf[pos    ] = f8b[0];
		            buf[pos + 1] = f8b[1];
		            buf[pos + 2] = f8b[2];
		            buf[pos + 3] = f8b[3];
		        }

		        function writeFloat_f32_rev(val, buf, pos) {
		            f32[0] = val;
		            buf[pos    ] = f8b[3];
		            buf[pos + 1] = f8b[2];
		            buf[pos + 2] = f8b[1];
		            buf[pos + 3] = f8b[0];
		        }

		        /* istanbul ignore next */
		        exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
		        /* istanbul ignore next */
		        exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;

		        function readFloat_f32_cpy(buf, pos) {
		            f8b[0] = buf[pos    ];
		            f8b[1] = buf[pos + 1];
		            f8b[2] = buf[pos + 2];
		            f8b[3] = buf[pos + 3];
		            return f32[0];
		        }

		        function readFloat_f32_rev(buf, pos) {
		            f8b[3] = buf[pos    ];
		            f8b[2] = buf[pos + 1];
		            f8b[1] = buf[pos + 2];
		            f8b[0] = buf[pos + 3];
		            return f32[0];
		        }

		        /* istanbul ignore next */
		        exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
		        /* istanbul ignore next */
		        exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;

		    // float: ieee754
		    })(); else (function() {

		        function writeFloat_ieee754(writeUint, val, buf, pos) {
		            var sign = val < 0 ? 1 : 0;
		            if (sign)
		                val = -val;
		            if (val === 0)
		                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
		            else if (isNaN(val))
		                writeUint(2143289344, buf, pos);
		            else if (val > 3.4028234663852886e+38) // +-Infinity
		                writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
		            else if (val < 1.1754943508222875e-38) // denormal
		                writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
		            else {
		                var exponent = Math.floor(Math.log(val) / Math.LN2),
		                    mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
		                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
		            }
		        }

		        exports.writeFloatLE = writeFloat_ieee754.bind(null, writeUintLE);
		        exports.writeFloatBE = writeFloat_ieee754.bind(null, writeUintBE);

		        function readFloat_ieee754(readUint, buf, pos) {
		            var uint = readUint(buf, pos),
		                sign = (uint >> 31) * 2 + 1,
		                exponent = uint >>> 23 & 255,
		                mantissa = uint & 8388607;
		            return exponent === 255
		                ? mantissa
		                ? NaN
		                : sign * Infinity
		                : exponent === 0 // denormal
		                ? sign * 1.401298464324817e-45 * mantissa
		                : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
		        }

		        exports.readFloatLE = readFloat_ieee754.bind(null, readUintLE);
		        exports.readFloatBE = readFloat_ieee754.bind(null, readUintBE);

		    })();

		    // double: typed array
		    if (typeof Float64Array !== "undefined") (function() {

		        var f64 = new Float64Array([-0]),
		            f8b = new Uint8Array(f64.buffer),
		            le  = f8b[7] === 128;

		        function writeDouble_f64_cpy(val, buf, pos) {
		            f64[0] = val;
		            buf[pos    ] = f8b[0];
		            buf[pos + 1] = f8b[1];
		            buf[pos + 2] = f8b[2];
		            buf[pos + 3] = f8b[3];
		            buf[pos + 4] = f8b[4];
		            buf[pos + 5] = f8b[5];
		            buf[pos + 6] = f8b[6];
		            buf[pos + 7] = f8b[7];
		        }

		        function writeDouble_f64_rev(val, buf, pos) {
		            f64[0] = val;
		            buf[pos    ] = f8b[7];
		            buf[pos + 1] = f8b[6];
		            buf[pos + 2] = f8b[5];
		            buf[pos + 3] = f8b[4];
		            buf[pos + 4] = f8b[3];
		            buf[pos + 5] = f8b[2];
		            buf[pos + 6] = f8b[1];
		            buf[pos + 7] = f8b[0];
		        }

		        /* istanbul ignore next */
		        exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
		        /* istanbul ignore next */
		        exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;

		        function readDouble_f64_cpy(buf, pos) {
		            f8b[0] = buf[pos    ];
		            f8b[1] = buf[pos + 1];
		            f8b[2] = buf[pos + 2];
		            f8b[3] = buf[pos + 3];
		            f8b[4] = buf[pos + 4];
		            f8b[5] = buf[pos + 5];
		            f8b[6] = buf[pos + 6];
		            f8b[7] = buf[pos + 7];
		            return f64[0];
		        }

		        function readDouble_f64_rev(buf, pos) {
		            f8b[7] = buf[pos    ];
		            f8b[6] = buf[pos + 1];
		            f8b[5] = buf[pos + 2];
		            f8b[4] = buf[pos + 3];
		            f8b[3] = buf[pos + 4];
		            f8b[2] = buf[pos + 5];
		            f8b[1] = buf[pos + 6];
		            f8b[0] = buf[pos + 7];
		            return f64[0];
		        }

		        /* istanbul ignore next */
		        exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
		        /* istanbul ignore next */
		        exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;

		    // double: ieee754
		    })(); else (function() {

		        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
		            var sign = val < 0 ? 1 : 0;
		            if (sign)
		                val = -val;
		            if (val === 0) {
		                writeUint(0, buf, pos + off0);
		                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
		            } else if (isNaN(val)) {
		                writeUint(0, buf, pos + off0);
		                writeUint(2146959360, buf, pos + off1);
		            } else if (val > 1.7976931348623157e+308) { // +-Infinity
		                writeUint(0, buf, pos + off0);
		                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
		            } else {
		                var mantissa;
		                if (val < 2.2250738585072014e-308) { // denormal
		                    mantissa = val / 5e-324;
		                    writeUint(mantissa >>> 0, buf, pos + off0);
		                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
		                } else {
		                    var exponent = Math.floor(Math.log(val) / Math.LN2);
		                    if (exponent === 1024)
		                        exponent = 1023;
		                    mantissa = val * Math.pow(2, -exponent);
		                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
		                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
		                }
		            }
		        }

		        exports.writeDoubleLE = writeDouble_ieee754.bind(null, writeUintLE, 0, 4);
		        exports.writeDoubleBE = writeDouble_ieee754.bind(null, writeUintBE, 4, 0);

		        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
		            var lo = readUint(buf, pos + off0),
		                hi = readUint(buf, pos + off1);
		            var sign = (hi >> 31) * 2 + 1,
		                exponent = hi >>> 20 & 2047,
		                mantissa = 4294967296 * (hi & 1048575) + lo;
		            return exponent === 2047
		                ? mantissa
		                ? NaN
		                : sign * Infinity
		                : exponent === 0 // denormal
		                ? sign * 5e-324 * mantissa
		                : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
		        }

		        exports.readDoubleLE = readDouble_ieee754.bind(null, readUintLE, 0, 4);
		        exports.readDoubleBE = readDouble_ieee754.bind(null, readUintBE, 4, 0);

		    })();

		    return exports;
		}

		// uint helpers

		function writeUintLE(val, buf, pos) {
		    buf[pos    ] =  val        & 255;
		    buf[pos + 1] =  val >>> 8  & 255;
		    buf[pos + 2] =  val >>> 16 & 255;
		    buf[pos + 3] =  val >>> 24;
		}

		function writeUintBE(val, buf, pos) {
		    buf[pos    ] =  val >>> 24;
		    buf[pos + 1] =  val >>> 16 & 255;
		    buf[pos + 2] =  val >>> 8  & 255;
		    buf[pos + 3] =  val        & 255;
		}

		function readUintLE(buf, pos) {
		    return (buf[pos    ]
		          | buf[pos + 1] << 8
		          | buf[pos + 2] << 16
		          | buf[pos + 3] << 24) >>> 0;
		}

		function readUintBE(buf, pos) {
		    return (buf[pos    ] << 24
		          | buf[pos + 1] << 16
		          | buf[pos + 2] << 8
		          | buf[pos + 3]) >>> 0;
		}
		return float;
	}

	var inquire_1;
	var hasRequiredInquire;

	function requireInquire () {
		if (hasRequiredInquire) return inquire_1;
		hasRequiredInquire = 1;
		inquire_1 = inquire;

		/**
		 * Requires a module only if available.
		 * @memberof util
		 * @param {string} moduleName Module to require
		 * @returns {?Object} Required module if available and not empty, otherwise `null`
		 */
		function inquire(moduleName) {
		    try {
		        var mod = eval("quire".replace(/^/,"re"))(moduleName); // eslint-disable-line no-eval
		        if (mod && (mod.length || Object.keys(mod).length))
		            return mod;
		    } catch (e) {} // eslint-disable-line no-empty
		    return null;
		}
		return inquire_1;
	}

	var utf8$2 = {};

	var hasRequiredUtf8;

	function requireUtf8 () {
		if (hasRequiredUtf8) return utf8$2;
		hasRequiredUtf8 = 1;
		(function (exports) {

			/**
			 * A minimal UTF8 implementation for number arrays.
			 * @memberof util
			 * @namespace
			 */
			var utf8 = exports;

			/**
			 * Calculates the UTF8 byte length of a string.
			 * @param {string} string String
			 * @returns {number} Byte length
			 */
			utf8.length = function utf8_length(string) {
			    var len = 0,
			        c = 0;
			    for (var i = 0; i < string.length; ++i) {
			        c = string.charCodeAt(i);
			        if (c < 128)
			            len += 1;
			        else if (c < 2048)
			            len += 2;
			        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
			            ++i;
			            len += 4;
			        } else
			            len += 3;
			    }
			    return len;
			};

			/**
			 * Reads UTF8 bytes as a string.
			 * @param {Uint8Array} buffer Source buffer
			 * @param {number} start Source start
			 * @param {number} end Source end
			 * @returns {string} String read
			 */
			utf8.read = function utf8_read(buffer, start, end) {
			    var len = end - start;
			    if (len < 1)
			        return "";
			    var parts = null,
			        chunk = [],
			        i = 0, // char offset
			        t;     // temporary
			    while (start < end) {
			        t = buffer[start++];
			        if (t < 128)
			            chunk[i++] = t;
			        else if (t > 191 && t < 224)
			            chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
			        else if (t > 239 && t < 365) {
			            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
			            chunk[i++] = 0xD800 + (t >> 10);
			            chunk[i++] = 0xDC00 + (t & 1023);
			        } else
			            chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
			        if (i > 8191) {
			            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
			            i = 0;
			        }
			    }
			    if (parts) {
			        if (i)
			            parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
			        return parts.join("");
			    }
			    return String.fromCharCode.apply(String, chunk.slice(0, i));
			};

			/**
			 * Writes a string as UTF8 bytes.
			 * @param {string} string Source string
			 * @param {Uint8Array} buffer Destination buffer
			 * @param {number} offset Destination offset
			 * @returns {number} Bytes written
			 */
			utf8.write = function utf8_write(string, buffer, offset) {
			    var start = offset,
			        c1, // character 1
			        c2; // character 2
			    for (var i = 0; i < string.length; ++i) {
			        c1 = string.charCodeAt(i);
			        if (c1 < 128) {
			            buffer[offset++] = c1;
			        } else if (c1 < 2048) {
			            buffer[offset++] = c1 >> 6       | 192;
			            buffer[offset++] = c1       & 63 | 128;
			        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
			            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
			            ++i;
			            buffer[offset++] = c1 >> 18      | 240;
			            buffer[offset++] = c1 >> 12 & 63 | 128;
			            buffer[offset++] = c1 >> 6  & 63 | 128;
			            buffer[offset++] = c1       & 63 | 128;
			        } else {
			            buffer[offset++] = c1 >> 12      | 224;
			            buffer[offset++] = c1 >> 6  & 63 | 128;
			            buffer[offset++] = c1       & 63 | 128;
			        }
			    }
			    return offset - start;
			}; 
		} (utf8$2));
		return utf8$2;
	}

	var pool_1;
	var hasRequiredPool;

	function requirePool () {
		if (hasRequiredPool) return pool_1;
		hasRequiredPool = 1;
		pool_1 = pool;

		/**
		 * An allocator as used by {@link util.pool}.
		 * @typedef PoolAllocator
		 * @type {function}
		 * @param {number} size Buffer size
		 * @returns {Uint8Array} Buffer
		 */

		/**
		 * A slicer as used by {@link util.pool}.
		 * @typedef PoolSlicer
		 * @type {function}
		 * @param {number} start Start offset
		 * @param {number} end End offset
		 * @returns {Uint8Array} Buffer slice
		 * @this {Uint8Array}
		 */

		/**
		 * A general purpose buffer pool.
		 * @memberof util
		 * @function
		 * @param {PoolAllocator} alloc Allocator
		 * @param {PoolSlicer} slice Slicer
		 * @param {number} [size=8192] Slab size
		 * @returns {PoolAllocator} Pooled allocator
		 */
		function pool(alloc, slice, size) {
		    var SIZE   = size || 8192;
		    var MAX    = SIZE >>> 1;
		    var slab   = null;
		    var offset = SIZE;
		    return function pool_alloc(size) {
		        if (size < 1 || size > MAX)
		            return alloc(size);
		        if (offset + size > SIZE) {
		            slab = alloc(SIZE);
		            offset = 0;
		        }
		        var buf = slice.call(slab, offset, offset += size);
		        if (offset & 7) // align to 32 bit
		            offset = (offset | 7) + 1;
		        return buf;
		    };
		}
		return pool_1;
	}

	var longbits;
	var hasRequiredLongbits;

	function requireLongbits () {
		if (hasRequiredLongbits) return longbits;
		hasRequiredLongbits = 1;
		longbits = LongBits;

		var util = requireMinimal();

		/**
		 * Constructs new long bits.
		 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
		 * @memberof util
		 * @constructor
		 * @param {number} lo Low 32 bits, unsigned
		 * @param {number} hi High 32 bits, unsigned
		 */
		function LongBits(lo, hi) {

		    // note that the casts below are theoretically unnecessary as of today, but older statically
		    // generated converter code might still call the ctor with signed 32bits. kept for compat.

		    /**
		     * Low bits.
		     * @type {number}
		     */
		    this.lo = lo >>> 0;

		    /**
		     * High bits.
		     * @type {number}
		     */
		    this.hi = hi >>> 0;
		}

		/**
		 * Zero bits.
		 * @memberof util.LongBits
		 * @type {util.LongBits}
		 */
		var zero = LongBits.zero = new LongBits(0, 0);

		zero.toNumber = function() { return 0; };
		zero.zzEncode = zero.zzDecode = function() { return this; };
		zero.length = function() { return 1; };

		/**
		 * Zero hash.
		 * @memberof util.LongBits
		 * @type {string}
		 */
		var zeroHash = LongBits.zeroHash = "\0\0\0\0\0\0\0\0";

		/**
		 * Constructs new long bits from the specified number.
		 * @param {number} value Value
		 * @returns {util.LongBits} Instance
		 */
		LongBits.fromNumber = function fromNumber(value) {
		    if (value === 0)
		        return zero;
		    var sign = value < 0;
		    if (sign)
		        value = -value;
		    var lo = value >>> 0,
		        hi = (value - lo) / 4294967296 >>> 0;
		    if (sign) {
		        hi = ~hi >>> 0;
		        lo = ~lo >>> 0;
		        if (++lo > 4294967295) {
		            lo = 0;
		            if (++hi > 4294967295)
		                hi = 0;
		        }
		    }
		    return new LongBits(lo, hi);
		};

		/**
		 * Constructs new long bits from a number, long or string.
		 * @param {Long|number|string} value Value
		 * @returns {util.LongBits} Instance
		 */
		LongBits.from = function from(value) {
		    if (typeof value === "number")
		        return LongBits.fromNumber(value);
		    if (util.isString(value)) {
		        /* istanbul ignore else */
		        if (util.Long)
		            value = util.Long.fromString(value);
		        else
		            return LongBits.fromNumber(parseInt(value, 10));
		    }
		    return value.low || value.high ? new LongBits(value.low >>> 0, value.high >>> 0) : zero;
		};

		/**
		 * Converts this long bits to a possibly unsafe JavaScript number.
		 * @param {boolean} [unsigned=false] Whether unsigned or not
		 * @returns {number} Possibly unsafe number
		 */
		LongBits.prototype.toNumber = function toNumber(unsigned) {
		    if (!unsigned && this.hi >>> 31) {
		        var lo = ~this.lo + 1 >>> 0,
		            hi = ~this.hi     >>> 0;
		        if (!lo)
		            hi = hi + 1 >>> 0;
		        return -(lo + hi * 4294967296);
		    }
		    return this.lo + this.hi * 4294967296;
		};

		/**
		 * Converts this long bits to a long.
		 * @param {boolean} [unsigned=false] Whether unsigned or not
		 * @returns {Long} Long
		 */
		LongBits.prototype.toLong = function toLong(unsigned) {
		    return util.Long
		        ? new util.Long(this.lo | 0, this.hi | 0, Boolean(unsigned))
		        /* istanbul ignore next */
		        : { low: this.lo | 0, high: this.hi | 0, unsigned: Boolean(unsigned) };
		};

		var charCodeAt = String.prototype.charCodeAt;

		/**
		 * Constructs new long bits from the specified 8 characters long hash.
		 * @param {string} hash Hash
		 * @returns {util.LongBits} Bits
		 */
		LongBits.fromHash = function fromHash(hash) {
		    if (hash === zeroHash)
		        return zero;
		    return new LongBits(
		        ( charCodeAt.call(hash, 0)
		        | charCodeAt.call(hash, 1) << 8
		        | charCodeAt.call(hash, 2) << 16
		        | charCodeAt.call(hash, 3) << 24) >>> 0
		    ,
		        ( charCodeAt.call(hash, 4)
		        | charCodeAt.call(hash, 5) << 8
		        | charCodeAt.call(hash, 6) << 16
		        | charCodeAt.call(hash, 7) << 24) >>> 0
		    );
		};

		/**
		 * Converts this long bits to a 8 characters long hash.
		 * @returns {string} Hash
		 */
		LongBits.prototype.toHash = function toHash() {
		    return String.fromCharCode(
		        this.lo        & 255,
		        this.lo >>> 8  & 255,
		        this.lo >>> 16 & 255,
		        this.lo >>> 24      ,
		        this.hi        & 255,
		        this.hi >>> 8  & 255,
		        this.hi >>> 16 & 255,
		        this.hi >>> 24
		    );
		};

		/**
		 * Zig-zag encodes this long bits.
		 * @returns {util.LongBits} `this`
		 */
		LongBits.prototype.zzEncode = function zzEncode() {
		    var mask =   this.hi >> 31;
		    this.hi  = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
		    this.lo  = ( this.lo << 1                   ^ mask) >>> 0;
		    return this;
		};

		/**
		 * Zig-zag decodes this long bits.
		 * @returns {util.LongBits} `this`
		 */
		LongBits.prototype.zzDecode = function zzDecode() {
		    var mask = -(this.lo & 1);
		    this.lo  = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
		    this.hi  = ( this.hi >>> 1                  ^ mask) >>> 0;
		    return this;
		};

		/**
		 * Calculates the length of this longbits when encoded as a varint.
		 * @returns {number} Length
		 */
		LongBits.prototype.length = function length() {
		    var part0 =  this.lo,
		        part1 = (this.lo >>> 28 | this.hi << 4) >>> 0,
		        part2 =  this.hi >>> 24;
		    return part2 === 0
		         ? part1 === 0
		           ? part0 < 16384
		             ? part0 < 128 ? 1 : 2
		             : part0 < 2097152 ? 3 : 4
		           : part1 < 16384
		             ? part1 < 128 ? 5 : 6
		             : part1 < 2097152 ? 7 : 8
		         : part2 < 128 ? 9 : 10;
		};
		return longbits;
	}

	var hasRequiredMinimal;

	function requireMinimal () {
		if (hasRequiredMinimal) return minimal$1;
		hasRequiredMinimal = 1;
		(function (exports) {
			var util = exports;

			// used to return a Promise where callback is omitted
			util.asPromise = requireAspromise();

			// converts to / from base64 encoded strings
			util.base64 = requireBase64();

			// base class of rpc.Service
			util.EventEmitter = requireEventemitter();

			// float handling accross browsers
			util.float = requireFloat();

			// requires modules optionally and hides the call from bundlers
			util.inquire = requireInquire();

			// converts to / from utf8 encoded strings
			util.utf8 = requireUtf8();

			// provides a node-like buffer pool in the browser
			util.pool = requirePool();

			// utility to work with the low and high bits of a 64 bit value
			util.LongBits = requireLongbits();

			/**
			 * Whether running within node or not.
			 * @memberof util
			 * @type {boolean}
			 */
			util.isNode = Boolean(typeof commonjsGlobal !== "undefined"
			                   && commonjsGlobal
			                   && commonjsGlobal.process
			                   && commonjsGlobal.process.versions
			                   && commonjsGlobal.process.versions.node);

			/**
			 * Global object reference.
			 * @memberof util
			 * @type {Object}
			 */
			util.global = util.isNode && commonjsGlobal
			           || typeof window !== "undefined" && window
			           || typeof self   !== "undefined" && self
			           || commonjsGlobal; // eslint-disable-line no-invalid-this

			/**
			 * An immuable empty array.
			 * @memberof util
			 * @type {Array.<*>}
			 * @const
			 */
			util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes

			/**
			 * An immutable empty object.
			 * @type {Object}
			 * @const
			 */
			util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes

			/**
			 * Tests if the specified value is an integer.
			 * @function
			 * @param {*} value Value to test
			 * @returns {boolean} `true` if the value is an integer
			 */
			util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
			    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
			};

			/**
			 * Tests if the specified value is a string.
			 * @param {*} value Value to test
			 * @returns {boolean} `true` if the value is a string
			 */
			util.isString = function isString(value) {
			    return typeof value === "string" || value instanceof String;
			};

			/**
			 * Tests if the specified value is a non-null object.
			 * @param {*} value Value to test
			 * @returns {boolean} `true` if the value is a non-null object
			 */
			util.isObject = function isObject(value) {
			    return value && typeof value === "object";
			};

			/**
			 * Checks if a property on a message is considered to be present.
			 * This is an alias of {@link util.isSet}.
			 * @function
			 * @param {Object} obj Plain object or message instance
			 * @param {string} prop Property name
			 * @returns {boolean} `true` if considered to be present, otherwise `false`
			 */
			util.isset =

			/**
			 * Checks if a property on a message is considered to be present.
			 * @param {Object} obj Plain object or message instance
			 * @param {string} prop Property name
			 * @returns {boolean} `true` if considered to be present, otherwise `false`
			 */
			util.isSet = function isSet(obj, prop) {
			    var value = obj[prop];
			    if (value != null && obj.hasOwnProperty(prop)) // eslint-disable-line eqeqeq, no-prototype-builtins
			        return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
			    return false;
			};

			/**
			 * Any compatible Buffer instance.
			 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
			 * @interface Buffer
			 * @extends Uint8Array
			 */

			/**
			 * Node's Buffer class if available.
			 * @type {Constructor<Buffer>}
			 */
			util.Buffer = (function() {
			    try {
			        var Buffer = util.inquire("buffer").Buffer;
			        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
			        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
			    } catch (e) {
			        /* istanbul ignore next */
			        return null;
			    }
			})();

			// Internal alias of or polyfull for Buffer.from.
			util._Buffer_from = null;

			// Internal alias of or polyfill for Buffer.allocUnsafe.
			util._Buffer_allocUnsafe = null;

			/**
			 * Creates a new buffer of whatever type supported by the environment.
			 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
			 * @returns {Uint8Array|Buffer} Buffer
			 */
			util.newBuffer = function newBuffer(sizeOrArray) {
			    /* istanbul ignore next */
			    return typeof sizeOrArray === "number"
			        ? util.Buffer
			            ? util._Buffer_allocUnsafe(sizeOrArray)
			            : new util.Array(sizeOrArray)
			        : util.Buffer
			            ? util._Buffer_from(sizeOrArray)
			            : typeof Uint8Array === "undefined"
			                ? sizeOrArray
			                : new Uint8Array(sizeOrArray);
			};

			/**
			 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
			 * @type {Constructor<Uint8Array>}
			 */
			util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */ : Array;

			/**
			 * Any compatible Long instance.
			 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
			 * @interface Long
			 * @property {number} low Low bits
			 * @property {number} high High bits
			 * @property {boolean} unsigned Whether unsigned or not
			 */

			/**
			 * Long.js's Long class if available.
			 * @type {Constructor<Long>}
			 */
			util.Long = /* istanbul ignore next */ util.global.dcodeIO && /* istanbul ignore next */ util.global.dcodeIO.Long
			         || /* istanbul ignore next */ util.global.Long
			         || util.inquire("long");

			/**
			 * Regular expression used to verify 2 bit (`bool`) map keys.
			 * @type {RegExp}
			 * @const
			 */
			util.key2Re = /^true|false|0|1$/;

			/**
			 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
			 * @type {RegExp}
			 * @const
			 */
			util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;

			/**
			 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
			 * @type {RegExp}
			 * @const
			 */
			util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;

			/**
			 * Converts a number or long to an 8 characters long hash string.
			 * @param {Long|number} value Value to convert
			 * @returns {string} Hash
			 */
			util.longToHash = function longToHash(value) {
			    return value
			        ? util.LongBits.from(value).toHash()
			        : util.LongBits.zeroHash;
			};

			/**
			 * Converts an 8 characters long hash string to a long or number.
			 * @param {string} hash Hash
			 * @param {boolean} [unsigned=false] Whether unsigned or not
			 * @returns {Long|number} Original value
			 */
			util.longFromHash = function longFromHash(hash, unsigned) {
			    var bits = util.LongBits.fromHash(hash);
			    if (util.Long)
			        return util.Long.fromBits(bits.lo, bits.hi, unsigned);
			    return bits.toNumber(Boolean(unsigned));
			};

			/**
			 * Merges the properties of the source object into the destination object.
			 * @memberof util
			 * @param {Object.<string,*>} dst Destination object
			 * @param {Object.<string,*>} src Source object
			 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
			 * @returns {Object.<string,*>} Destination object
			 */
			function merge(dst, src, ifNotSet) { // used by converters
			    for (var keys = Object.keys(src), i = 0; i < keys.length; ++i)
			        if (dst[keys[i]] === undefined || !ifNotSet)
			            dst[keys[i]] = src[keys[i]];
			    return dst;
			}

			util.merge = merge;

			/**
			 * Converts the first character of a string to lower case.
			 * @param {string} str String to convert
			 * @returns {string} Converted string
			 */
			util.lcFirst = function lcFirst(str) {
			    return str.charAt(0).toLowerCase() + str.substring(1);
			};

			/**
			 * Creates a custom error constructor.
			 * @memberof util
			 * @param {string} name Error name
			 * @returns {Constructor<Error>} Custom error constructor
			 */
			function newError(name) {

			    function CustomError(message, properties) {

			        if (!(this instanceof CustomError))
			            return new CustomError(message, properties);

			        // Error.call(this, message);
			        // ^ just returns a new error instance because the ctor can be called as a function

			        Object.defineProperty(this, "message", { get: function() { return message; } });

			        /* istanbul ignore next */
			        if (Error.captureStackTrace) // node
			            Error.captureStackTrace(this, CustomError);
			        else
			            Object.defineProperty(this, "stack", { value: new Error().stack || "" });

			        if (properties)
			            merge(this, properties);
			    }

			    CustomError.prototype = Object.create(Error.prototype, {
			        constructor: {
			            value: CustomError,
			            writable: true,
			            enumerable: false,
			            configurable: true,
			        },
			        name: {
			            get: function get() { return name; },
			            set: undefined,
			            enumerable: false,
			            // configurable: false would accurately preserve the behavior of
			            // the original, but I'm guessing that was not intentional.
			            // For an actual error subclass, this property would
			            // be configurable.
			            configurable: true,
			        },
			        toString: {
			            value: function value() { return this.name + ": " + this.message; },
			            writable: true,
			            enumerable: false,
			            configurable: true,
			        },
			    });

			    return CustomError;
			}

			util.newError = newError;

			/**
			 * Constructs a new protocol error.
			 * @classdesc Error subclass indicating a protocol specifc error.
			 * @memberof util
			 * @extends Error
			 * @template T extends Message<T>
			 * @constructor
			 * @param {string} message Error message
			 * @param {Object.<string,*>} [properties] Additional properties
			 * @example
			 * try {
			 *     MyMessage.decode(someBuffer); // throws if required fields are missing
			 * } catch (e) {
			 *     if (e instanceof ProtocolError && e.instance)
			 *         console.log("decoded so far: " + JSON.stringify(e.instance));
			 * }
			 */
			util.ProtocolError = newError("ProtocolError");

			/**
			 * So far decoded message instance.
			 * @name util.ProtocolError#instance
			 * @type {Message<T>}
			 */

			/**
			 * A OneOf getter as returned by {@link util.oneOfGetter}.
			 * @typedef OneOfGetter
			 * @type {function}
			 * @returns {string|undefined} Set field name, if any
			 */

			/**
			 * Builds a getter for a oneof's present field name.
			 * @param {string[]} fieldNames Field names
			 * @returns {OneOfGetter} Unbound getter
			 */
			util.oneOfGetter = function getOneOf(fieldNames) {
			    var fieldMap = {};
			    for (var i = 0; i < fieldNames.length; ++i)
			        fieldMap[fieldNames[i]] = 1;

			    /**
			     * @returns {string|undefined} Set field name, if any
			     * @this Object
			     * @ignore
			     */
			    return function() { // eslint-disable-line consistent-return
			        for (var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)
			            if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null)
			                return keys[i];
			    };
			};

			/**
			 * A OneOf setter as returned by {@link util.oneOfSetter}.
			 * @typedef OneOfSetter
			 * @type {function}
			 * @param {string|undefined} value Field name
			 * @returns {undefined}
			 */

			/**
			 * Builds a setter for a oneof's present field name.
			 * @param {string[]} fieldNames Field names
			 * @returns {OneOfSetter} Unbound setter
			 */
			util.oneOfSetter = function setOneOf(fieldNames) {

			    /**
			     * @param {string} name Field name
			     * @returns {undefined}
			     * @this Object
			     * @ignore
			     */
			    return function(name) {
			        for (var i = 0; i < fieldNames.length; ++i)
			            if (fieldNames[i] !== name)
			                delete this[fieldNames[i]];
			    };
			};

			/**
			 * Default conversion options used for {@link Message#toJSON} implementations.
			 *
			 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
			 *
			 * - Longs become strings
			 * - Enums become string keys
			 * - Bytes become base64 encoded strings
			 * - (Sub-)Messages become plain objects
			 * - Maps become plain objects with all string keys
			 * - Repeated fields become arrays
			 * - NaN and Infinity for float and double fields become strings
			 *
			 * @type {IConversionOptions}
			 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
			 */
			util.toJSONOptions = {
			    longs: String,
			    enums: String,
			    bytes: String,
			    json: true
			};

			// Sets up buffer utility according to the environment (called in index-minimal)
			util._configure = function() {
			    var Buffer = util.Buffer;
			    /* istanbul ignore if */
			    if (!Buffer) {
			        util._Buffer_from = util._Buffer_allocUnsafe = null;
			        return;
			    }
			    // because node 4.x buffers are incompatible & immutable
			    // see: https://github.com/dcodeIO/protobuf.js/pull/665
			    util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from ||
			        /* istanbul ignore next */
			        function Buffer_from(value, encoding) {
			            return new Buffer(value, encoding);
			        };
			    util._Buffer_allocUnsafe = Buffer.allocUnsafe ||
			        /* istanbul ignore next */
			        function Buffer_allocUnsafe(size) {
			            return new Buffer(size);
			        };
			}; 
		} (minimal$1));
		return minimal$1;
	}

	var writer = Writer$1;

	var util$8      = requireMinimal();

	var BufferWriter$1; // cyclic

	var LongBits$1  = util$8.LongBits,
	    base64$2    = util$8.base64,
	    utf8$1      = util$8.utf8;

	/**
	 * Constructs a new writer operation instance.
	 * @classdesc Scheduled writer operation.
	 * @constructor
	 * @param {function(*, Uint8Array, number)} fn Function to call
	 * @param {number} len Value byte length
	 * @param {*} val Value to write
	 * @ignore
	 */
	function Op(fn, len, val) {

	    /**
	     * Function to call.
	     * @type {function(Uint8Array, number, *)}
	     */
	    this.fn = fn;

	    /**
	     * Value byte length.
	     * @type {number}
	     */
	    this.len = len;

	    /**
	     * Next operation.
	     * @type {Writer.Op|undefined}
	     */
	    this.next = undefined;

	    /**
	     * Value to write.
	     * @type {*}
	     */
	    this.val = val; // type varies
	}

	/* istanbul ignore next */
	function noop$5() {} // eslint-disable-line no-empty-function

	/**
	 * Constructs a new writer state instance.
	 * @classdesc Copied writer state.
	 * @memberof Writer
	 * @constructor
	 * @param {Writer} writer Writer to copy state from
	 * @ignore
	 */
	function State(writer) {

	    /**
	     * Current head.
	     * @type {Writer.Op}
	     */
	    this.head = writer.head;

	    /**
	     * Current tail.
	     * @type {Writer.Op}
	     */
	    this.tail = writer.tail;

	    /**
	     * Current buffer length.
	     * @type {number}
	     */
	    this.len = writer.len;

	    /**
	     * Next state.
	     * @type {State|null}
	     */
	    this.next = writer.states;
	}

	/**
	 * Constructs a new writer instance.
	 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
	 * @constructor
	 */
	function Writer$1() {

	    /**
	     * Current length.
	     * @type {number}
	     */
	    this.len = 0;

	    /**
	     * Operations head.
	     * @type {Object}
	     */
	    this.head = new Op(noop$5, 0, 0);

	    /**
	     * Operations tail
	     * @type {Object}
	     */
	    this.tail = this.head;

	    /**
	     * Linked forked states.
	     * @type {Object|null}
	     */
	    this.states = null;

	    // When a value is written, the writer calculates its byte length and puts it into a linked
	    // list of operations to perform when finish() is called. This both allows us to allocate
	    // buffers of the exact required size and reduces the amount of work we have to do compared
	    // to first calculating over objects and then encoding over objects. In our case, the encoding
	    // part is just a linked list walk calling operations with already prepared values.
	}

	var create$2 = function create() {
	    return util$8.Buffer
	        ? function create_buffer_setup() {
	            return (Writer$1.create = function create_buffer() {
	                return new BufferWriter$1();
	            })();
	        }
	        /* istanbul ignore next */
	        : function create_array() {
	            return new Writer$1();
	        };
	};

	/**
	 * Creates a new writer.
	 * @function
	 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
	 */
	Writer$1.create = create$2();

	/**
	 * Allocates a buffer of the specified size.
	 * @param {number} size Buffer size
	 * @returns {Uint8Array} Buffer
	 */
	Writer$1.alloc = function alloc(size) {
	    return new util$8.Array(size);
	};

	// Use Uint8Array buffer pool in the browser, just like node does with buffers
	/* istanbul ignore else */
	if (util$8.Array !== Array)
	    Writer$1.alloc = util$8.pool(Writer$1.alloc, util$8.Array.prototype.subarray);

	/**
	 * Pushes a new operation to the queue.
	 * @param {function(Uint8Array, number, *)} fn Function to call
	 * @param {number} len Value byte length
	 * @param {number} val Value to write
	 * @returns {Writer} `this`
	 * @private
	 */
	Writer$1.prototype._push = function push(fn, len, val) {
	    this.tail = this.tail.next = new Op(fn, len, val);
	    this.len += len;
	    return this;
	};

	function writeByte(val, buf, pos) {
	    buf[pos] = val & 255;
	}

	function writeVarint32(val, buf, pos) {
	    while (val > 127) {
	        buf[pos++] = val & 127 | 128;
	        val >>>= 7;
	    }
	    buf[pos] = val;
	}

	/**
	 * Constructs a new varint writer operation instance.
	 * @classdesc Scheduled varint writer operation.
	 * @extends Op
	 * @constructor
	 * @param {number} len Value byte length
	 * @param {number} val Value to write
	 * @ignore
	 */
	function VarintOp(len, val) {
	    this.len = len;
	    this.next = undefined;
	    this.val = val;
	}

	VarintOp.prototype = Object.create(Op.prototype);
	VarintOp.prototype.fn = writeVarint32;

	/**
	 * Writes an unsigned 32 bit value as a varint.
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer$1.prototype.uint32 = function write_uint32(value) {
	    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
	    // uint32 is by far the most frequently used operation and benefits significantly from this.
	    this.len += (this.tail = this.tail.next = new VarintOp(
	        (value = value >>> 0)
	                < 128       ? 1
	        : value < 16384     ? 2
	        : value < 2097152   ? 3
	        : value < 268435456 ? 4
	        :                     5,
	    value)).len;
	    return this;
	};

	/**
	 * Writes a signed 32 bit value as a varint.
	 * @function
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer$1.prototype.int32 = function write_int32(value) {
	    return value < 0
	        ? this._push(writeVarint64, 10, LongBits$1.fromNumber(value)) // 10 bytes per spec
	        : this.uint32(value);
	};

	/**
	 * Writes a 32 bit value as a varint, zig-zag encoded.
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer$1.prototype.sint32 = function write_sint32(value) {
	    return this.uint32((value << 1 ^ value >> 31) >>> 0);
	};

	function writeVarint64(val, buf, pos) {
	    while (val.hi) {
	        buf[pos++] = val.lo & 127 | 128;
	        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
	        val.hi >>>= 7;
	    }
	    while (val.lo > 127) {
	        buf[pos++] = val.lo & 127 | 128;
	        val.lo = val.lo >>> 7;
	    }
	    buf[pos++] = val.lo;
	}

	/**
	 * Writes an unsigned 64 bit value as a varint.
	 * @param {Long|number|string} value Value to write
	 * @returns {Writer} `this`
	 * @throws {TypeError} If `value` is a string and no long library is present.
	 */
	Writer$1.prototype.uint64 = function write_uint64(value) {
	    var bits = LongBits$1.from(value);
	    return this._push(writeVarint64, bits.length(), bits);
	};

	/**
	 * Writes a signed 64 bit value as a varint.
	 * @function
	 * @param {Long|number|string} value Value to write
	 * @returns {Writer} `this`
	 * @throws {TypeError} If `value` is a string and no long library is present.
	 */
	Writer$1.prototype.int64 = Writer$1.prototype.uint64;

	/**
	 * Writes a signed 64 bit value as a varint, zig-zag encoded.
	 * @param {Long|number|string} value Value to write
	 * @returns {Writer} `this`
	 * @throws {TypeError} If `value` is a string and no long library is present.
	 */
	Writer$1.prototype.sint64 = function write_sint64(value) {
	    var bits = LongBits$1.from(value).zzEncode();
	    return this._push(writeVarint64, bits.length(), bits);
	};

	/**
	 * Writes a boolish value as a varint.
	 * @param {boolean} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer$1.prototype.bool = function write_bool(value) {
	    return this._push(writeByte, 1, value ? 1 : 0);
	};

	function writeFixed32(val, buf, pos) {
	    buf[pos    ] =  val         & 255;
	    buf[pos + 1] =  val >>> 8   & 255;
	    buf[pos + 2] =  val >>> 16  & 255;
	    buf[pos + 3] =  val >>> 24;
	}

	/**
	 * Writes an unsigned 32 bit value as fixed 32 bits.
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer$1.prototype.fixed32 = function write_fixed32(value) {
	    return this._push(writeFixed32, 4, value >>> 0);
	};

	/**
	 * Writes a signed 32 bit value as fixed 32 bits.
	 * @function
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer$1.prototype.sfixed32 = Writer$1.prototype.fixed32;

	/**
	 * Writes an unsigned 64 bit value as fixed 64 bits.
	 * @param {Long|number|string} value Value to write
	 * @returns {Writer} `this`
	 * @throws {TypeError} If `value` is a string and no long library is present.
	 */
	Writer$1.prototype.fixed64 = function write_fixed64(value) {
	    var bits = LongBits$1.from(value);
	    return this._push(writeFixed32, 4, bits.lo)._push(writeFixed32, 4, bits.hi);
	};

	/**
	 * Writes a signed 64 bit value as fixed 64 bits.
	 * @function
	 * @param {Long|number|string} value Value to write
	 * @returns {Writer} `this`
	 * @throws {TypeError} If `value` is a string and no long library is present.
	 */
	Writer$1.prototype.sfixed64 = Writer$1.prototype.fixed64;

	/**
	 * Writes a float (32 bit).
	 * @function
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer$1.prototype.float = function write_float(value) {
	    return this._push(util$8.float.writeFloatLE, 4, value);
	};

	/**
	 * Writes a double (64 bit float).
	 * @function
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer$1.prototype.double = function write_double(value) {
	    return this._push(util$8.float.writeDoubleLE, 8, value);
	};

	var writeBytes = util$8.Array.prototype.set
	    ? function writeBytes_set(val, buf, pos) {
	        buf.set(val, pos); // also works for plain array values
	    }
	    /* istanbul ignore next */
	    : function writeBytes_for(val, buf, pos) {
	        for (var i = 0; i < val.length; ++i)
	            buf[pos + i] = val[i];
	    };

	/**
	 * Writes a sequence of bytes.
	 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
	 * @returns {Writer} `this`
	 */
	Writer$1.prototype.bytes = function write_bytes(value) {
	    var len = value.length >>> 0;
	    if (!len)
	        return this._push(writeByte, 1, 0);
	    if (util$8.isString(value)) {
	        var buf = Writer$1.alloc(len = base64$2.length(value));
	        base64$2.decode(value, buf, 0);
	        value = buf;
	    }
	    return this.uint32(len)._push(writeBytes, len, value);
	};

	/**
	 * Writes a string.
	 * @param {string} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer$1.prototype.string = function write_string(value) {
	    var len = utf8$1.length(value);
	    return len
	        ? this.uint32(len)._push(utf8$1.write, len, value)
	        : this._push(writeByte, 1, 0);
	};

	/**
	 * Forks this writer's state by pushing it to a stack.
	 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
	 * @returns {Writer} `this`
	 */
	Writer$1.prototype.fork = function fork() {
	    this.states = new State(this);
	    this.head = this.tail = new Op(noop$5, 0, 0);
	    this.len = 0;
	    return this;
	};

	/**
	 * Resets this instance to the last state.
	 * @returns {Writer} `this`
	 */
	Writer$1.prototype.reset = function reset() {
	    if (this.states) {
	        this.head   = this.states.head;
	        this.tail   = this.states.tail;
	        this.len    = this.states.len;
	        this.states = this.states.next;
	    } else {
	        this.head = this.tail = new Op(noop$5, 0, 0);
	        this.len  = 0;
	    }
	    return this;
	};

	/**
	 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
	 * @returns {Writer} `this`
	 */
	Writer$1.prototype.ldelim = function ldelim() {
	    var head = this.head,
	        tail = this.tail,
	        len  = this.len;
	    this.reset().uint32(len);
	    if (len) {
	        this.tail.next = head.next; // skip noop
	        this.tail = tail;
	        this.len += len;
	    }
	    return this;
	};

	/**
	 * Finishes the write operation.
	 * @returns {Uint8Array} Finished buffer
	 */
	Writer$1.prototype.finish = function finish() {
	    var head = this.head.next, // skip noop
	        buf  = this.constructor.alloc(this.len),
	        pos  = 0;
	    while (head) {
	        head.fn(head.val, buf, pos);
	        pos += head.len;
	        head = head.next;
	    }
	    // this.head = this.tail = null;
	    return buf;
	};

	Writer$1._configure = function(BufferWriter_) {
	    BufferWriter$1 = BufferWriter_;
	    Writer$1.create = create$2();
	    BufferWriter$1._configure();
	};

	var writer_buffer = BufferWriter;

	// extends Writer
	var Writer = writer;
	(BufferWriter.prototype = Object.create(Writer.prototype)).constructor = BufferWriter;

	var util$7 = requireMinimal();

	/**
	 * Constructs a new buffer writer instance.
	 * @classdesc Wire format writer using node buffers.
	 * @extends Writer
	 * @constructor
	 */
	function BufferWriter() {
	    Writer.call(this);
	}

	BufferWriter._configure = function () {
	    /**
	     * Allocates a buffer of the specified size.
	     * @function
	     * @param {number} size Buffer size
	     * @returns {Buffer} Buffer
	     */
	    BufferWriter.alloc = util$7._Buffer_allocUnsafe;

	    BufferWriter.writeBytesBuffer = util$7.Buffer && util$7.Buffer.prototype instanceof Uint8Array && util$7.Buffer.prototype.set.name === "set"
	        ? function writeBytesBuffer_set(val, buf, pos) {
	          buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
	          // also works for plain array values
	        }
	        /* istanbul ignore next */
	        : function writeBytesBuffer_copy(val, buf, pos) {
	          if (val.copy) // Buffer values
	            val.copy(buf, pos, 0, val.length);
	          else for (var i = 0; i < val.length;) // plain array values
	            buf[pos++] = val[i++];
	        };
	};


	/**
	 * @override
	 */
	BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
	    if (util$7.isString(value))
	        value = util$7._Buffer_from(value, "base64");
	    var len = value.length >>> 0;
	    this.uint32(len);
	    if (len)
	        this._push(BufferWriter.writeBytesBuffer, len, value);
	    return this;
	};

	function writeStringBuffer(val, buf, pos) {
	    if (val.length < 40) // plain js is faster for short strings (probably due to redundant assertions)
	        util$7.utf8.write(val, buf, pos);
	    else if (buf.utf8Write)
	        buf.utf8Write(val, pos);
	    else
	        buf.write(val, pos);
	}

	/**
	 * @override
	 */
	BufferWriter.prototype.string = function write_string_buffer(value) {
	    var len = util$7.Buffer.byteLength(value);
	    this.uint32(len);
	    if (len)
	        this._push(writeStringBuffer, len, value);
	    return this;
	};


	/**
	 * Finishes the write operation.
	 * @name BufferWriter#finish
	 * @function
	 * @returns {Buffer} Finished buffer
	 */

	BufferWriter._configure();

	var reader = Reader$1;

	var util$6      = requireMinimal();

	var BufferReader$1; // cyclic

	var LongBits  = util$6.LongBits,
	    utf8      = util$6.utf8;

	/* istanbul ignore next */
	function indexOutOfRange(reader, writeLength) {
	    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
	}

	/**
	 * Constructs a new reader instance using the specified buffer.
	 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
	 * @constructor
	 * @param {Uint8Array} buffer Buffer to read from
	 */
	function Reader$1(buffer) {

	    /**
	     * Read buffer.
	     * @type {Uint8Array}
	     */
	    this.buf = buffer;

	    /**
	     * Read buffer position.
	     * @type {number}
	     */
	    this.pos = 0;

	    /**
	     * Read buffer length.
	     * @type {number}
	     */
	    this.len = buffer.length;
	}

	var create_array = typeof Uint8Array !== "undefined"
	    ? function create_typed_array(buffer) {
	        if (buffer instanceof Uint8Array || Array.isArray(buffer))
	            return new Reader$1(buffer);
	        throw Error("illegal buffer");
	    }
	    /* istanbul ignore next */
	    : function create_array(buffer) {
	        if (Array.isArray(buffer))
	            return new Reader$1(buffer);
	        throw Error("illegal buffer");
	    };

	var create$1 = function create() {
	    return util$6.Buffer
	        ? function create_buffer_setup(buffer) {
	            return (Reader$1.create = function create_buffer(buffer) {
	                return util$6.Buffer.isBuffer(buffer)
	                    ? new BufferReader$1(buffer)
	                    /* istanbul ignore next */
	                    : create_array(buffer);
	            })(buffer);
	        }
	        /* istanbul ignore next */
	        : create_array;
	};

	/**
	 * Creates a new reader using the specified buffer.
	 * @function
	 * @param {Uint8Array|Buffer} buffer Buffer to read from
	 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
	 * @throws {Error} If `buffer` is not a valid buffer
	 */
	Reader$1.create = create$1();

	Reader$1.prototype._slice = util$6.Array.prototype.subarray || /* istanbul ignore next */ util$6.Array.prototype.slice;

	/**
	 * Reads a varint as an unsigned 32 bit value.
	 * @function
	 * @returns {number} Value read
	 */
	Reader$1.prototype.uint32 = (function read_uint32_setup() {
	    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
	    return function read_uint32() {
	        value = (         this.buf[this.pos] & 127       ) >>> 0; if (this.buf[this.pos++] < 128) return value;
	        value = (value | (this.buf[this.pos] & 127) <<  7) >>> 0; if (this.buf[this.pos++] < 128) return value;
	        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0; if (this.buf[this.pos++] < 128) return value;
	        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0; if (this.buf[this.pos++] < 128) return value;
	        value = (value | (this.buf[this.pos] &  15) << 28) >>> 0; if (this.buf[this.pos++] < 128) return value;

	        /* istanbul ignore if */
	        if ((this.pos += 5) > this.len) {
	            this.pos = this.len;
	            throw indexOutOfRange(this, 10);
	        }
	        return value;
	    };
	})();

	/**
	 * Reads a varint as a signed 32 bit value.
	 * @returns {number} Value read
	 */
	Reader$1.prototype.int32 = function read_int32() {
	    return this.uint32() | 0;
	};

	/**
	 * Reads a zig-zag encoded varint as a signed 32 bit value.
	 * @returns {number} Value read
	 */
	Reader$1.prototype.sint32 = function read_sint32() {
	    var value = this.uint32();
	    return value >>> 1 ^ -(value & 1) | 0;
	};

	/* eslint-disable no-invalid-this */

	function readLongVarint() {
	    // tends to deopt with local vars for octet etc.
	    var bits = new LongBits(0, 0);
	    var i = 0;
	    if (this.len - this.pos > 4) { // fast route (lo)
	        for (; i < 4; ++i) {
	            // 1st..4th
	            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
	            if (this.buf[this.pos++] < 128)
	                return bits;
	        }
	        // 5th
	        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
	        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >>  4) >>> 0;
	        if (this.buf[this.pos++] < 128)
	            return bits;
	        i = 0;
	    } else {
	        for (; i < 3; ++i) {
	            /* istanbul ignore if */
	            if (this.pos >= this.len)
	                throw indexOutOfRange(this);
	            // 1st..3th
	            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
	            if (this.buf[this.pos++] < 128)
	                return bits;
	        }
	        // 4th
	        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
	        return bits;
	    }
	    if (this.len - this.pos > 4) { // fast route (hi)
	        for (; i < 5; ++i) {
	            // 6th..10th
	            bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
	            if (this.buf[this.pos++] < 128)
	                return bits;
	        }
	    } else {
	        for (; i < 5; ++i) {
	            /* istanbul ignore if */
	            if (this.pos >= this.len)
	                throw indexOutOfRange(this);
	            // 6th..10th
	            bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
	            if (this.buf[this.pos++] < 128)
	                return bits;
	        }
	    }
	    /* istanbul ignore next */
	    throw Error("invalid varint encoding");
	}

	/* eslint-enable no-invalid-this */

	/**
	 * Reads a varint as a signed 64 bit value.
	 * @name Reader#int64
	 * @function
	 * @returns {Long} Value read
	 */

	/**
	 * Reads a varint as an unsigned 64 bit value.
	 * @name Reader#uint64
	 * @function
	 * @returns {Long} Value read
	 */

	/**
	 * Reads a zig-zag encoded varint as a signed 64 bit value.
	 * @name Reader#sint64
	 * @function
	 * @returns {Long} Value read
	 */

	/**
	 * Reads a varint as a boolean.
	 * @returns {boolean} Value read
	 */
	Reader$1.prototype.bool = function read_bool() {
	    return this.uint32() !== 0;
	};

	function readFixed32_end(buf, end) { // note that this uses `end`, not `pos`
	    return (buf[end - 4]
	          | buf[end - 3] << 8
	          | buf[end - 2] << 16
	          | buf[end - 1] << 24) >>> 0;
	}

	/**
	 * Reads fixed 32 bits as an unsigned 32 bit integer.
	 * @returns {number} Value read
	 */
	Reader$1.prototype.fixed32 = function read_fixed32() {

	    /* istanbul ignore if */
	    if (this.pos + 4 > this.len)
	        throw indexOutOfRange(this, 4);

	    return readFixed32_end(this.buf, this.pos += 4);
	};

	/**
	 * Reads fixed 32 bits as a signed 32 bit integer.
	 * @returns {number} Value read
	 */
	Reader$1.prototype.sfixed32 = function read_sfixed32() {

	    /* istanbul ignore if */
	    if (this.pos + 4 > this.len)
	        throw indexOutOfRange(this, 4);

	    return readFixed32_end(this.buf, this.pos += 4) | 0;
	};

	/* eslint-disable no-invalid-this */

	function readFixed64(/* this: Reader */) {

	    /* istanbul ignore if */
	    if (this.pos + 8 > this.len)
	        throw indexOutOfRange(this, 8);

	    return new LongBits(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
	}

	/* eslint-enable no-invalid-this */

	/**
	 * Reads fixed 64 bits.
	 * @name Reader#fixed64
	 * @function
	 * @returns {Long} Value read
	 */

	/**
	 * Reads zig-zag encoded fixed 64 bits.
	 * @name Reader#sfixed64
	 * @function
	 * @returns {Long} Value read
	 */

	/**
	 * Reads a float (32 bit) as a number.
	 * @function
	 * @returns {number} Value read
	 */
	Reader$1.prototype.float = function read_float() {

	    /* istanbul ignore if */
	    if (this.pos + 4 > this.len)
	        throw indexOutOfRange(this, 4);

	    var value = util$6.float.readFloatLE(this.buf, this.pos);
	    this.pos += 4;
	    return value;
	};

	/**
	 * Reads a double (64 bit float) as a number.
	 * @function
	 * @returns {number} Value read
	 */
	Reader$1.prototype.double = function read_double() {

	    /* istanbul ignore if */
	    if (this.pos + 8 > this.len)
	        throw indexOutOfRange(this, 4);

	    var value = util$6.float.readDoubleLE(this.buf, this.pos);
	    this.pos += 8;
	    return value;
	};

	/**
	 * Reads a sequence of bytes preceeded by its length as a varint.
	 * @returns {Uint8Array} Value read
	 */
	Reader$1.prototype.bytes = function read_bytes() {
	    var length = this.uint32(),
	        start  = this.pos,
	        end    = this.pos + length;

	    /* istanbul ignore if */
	    if (end > this.len)
	        throw indexOutOfRange(this, length);

	    this.pos += length;
	    if (Array.isArray(this.buf)) // plain array
	        return this.buf.slice(start, end);
	    return start === end // fix for IE 10/Win8 and others' subarray returning array of size 1
	        ? new this.buf.constructor(0)
	        : this._slice.call(this.buf, start, end);
	};

	/**
	 * Reads a string preceeded by its byte length as a varint.
	 * @returns {string} Value read
	 */
	Reader$1.prototype.string = function read_string() {
	    var bytes = this.bytes();
	    return utf8.read(bytes, 0, bytes.length);
	};

	/**
	 * Skips the specified number of bytes if specified, otherwise skips a varint.
	 * @param {number} [length] Length if known, otherwise a varint is assumed
	 * @returns {Reader} `this`
	 */
	Reader$1.prototype.skip = function skip(length) {
	    if (typeof length === "number") {
	        /* istanbul ignore if */
	        if (this.pos + length > this.len)
	            throw indexOutOfRange(this, length);
	        this.pos += length;
	    } else {
	        do {
	            /* istanbul ignore if */
	            if (this.pos >= this.len)
	                throw indexOutOfRange(this);
	        } while (this.buf[this.pos++] & 128);
	    }
	    return this;
	};

	/**
	 * Skips the next element of the specified wire type.
	 * @param {number} wireType Wire type received
	 * @returns {Reader} `this`
	 */
	Reader$1.prototype.skipType = function(wireType) {
	    switch (wireType) {
	        case 0:
	            this.skip();
	            break;
	        case 1:
	            this.skip(8);
	            break;
	        case 2:
	            this.skip(this.uint32());
	            break;
	        case 3:
	            while ((wireType = this.uint32() & 7) !== 4) {
	                this.skipType(wireType);
	            }
	            break;
	        case 5:
	            this.skip(4);
	            break;

	        /* istanbul ignore next */
	        default:
	            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
	    }
	    return this;
	};

	Reader$1._configure = function(BufferReader_) {
	    BufferReader$1 = BufferReader_;
	    Reader$1.create = create$1();
	    BufferReader$1._configure();

	    var fn = util$6.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
	    util$6.merge(Reader$1.prototype, {

	        int64: function read_int64() {
	            return readLongVarint.call(this)[fn](false);
	        },

	        uint64: function read_uint64() {
	            return readLongVarint.call(this)[fn](true);
	        },

	        sint64: function read_sint64() {
	            return readLongVarint.call(this).zzDecode()[fn](false);
	        },

	        fixed64: function read_fixed64() {
	            return readFixed64.call(this)[fn](true);
	        },

	        sfixed64: function read_sfixed64() {
	            return readFixed64.call(this)[fn](false);
	        }

	    });
	};

	var reader_buffer = BufferReader;

	// extends Reader
	var Reader = reader;
	(BufferReader.prototype = Object.create(Reader.prototype)).constructor = BufferReader;

	var util$5 = requireMinimal();

	/**
	 * Constructs a new buffer reader instance.
	 * @classdesc Wire format reader using node buffers.
	 * @extends Reader
	 * @constructor
	 * @param {Buffer} buffer Buffer to read from
	 */
	function BufferReader(buffer) {
	    Reader.call(this, buffer);

	    /**
	     * Read buffer.
	     * @name BufferReader#buf
	     * @type {Buffer}
	     */
	}

	BufferReader._configure = function () {
	    /* istanbul ignore else */
	    if (util$5.Buffer)
	        BufferReader.prototype._slice = util$5.Buffer.prototype.slice;
	};


	/**
	 * @override
	 */
	BufferReader.prototype.string = function read_string_buffer() {
	    var len = this.uint32(); // modifies pos
	    return this.buf.utf8Slice
	        ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len))
	        : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
	};

	/**
	 * Reads a sequence of bytes preceeded by its length as a varint.
	 * @name BufferReader#bytes
	 * @function
	 * @returns {Buffer} Value read
	 */

	BufferReader._configure();

	var rpc = {};

	var service = Service;

	var util$4 = requireMinimal();

	// Extends EventEmitter
	(Service.prototype = Object.create(util$4.EventEmitter.prototype)).constructor = Service;

	/**
	 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
	 *
	 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
	 * @typedef rpc.ServiceMethodCallback
	 * @template TRes extends Message<TRes>
	 * @type {function}
	 * @param {Error|null} error Error, if any
	 * @param {TRes} [response] Response message
	 * @returns {undefined}
	 */

	/**
	 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
	 * @typedef rpc.ServiceMethod
	 * @template TReq extends Message<TReq>
	 * @template TRes extends Message<TRes>
	 * @type {function}
	 * @param {TReq|Properties<TReq>} request Request message or plain object
	 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
	 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
	 */

	/**
	 * Constructs a new RPC service instance.
	 * @classdesc An RPC service as returned by {@link Service#create}.
	 * @exports rpc.Service
	 * @extends util.EventEmitter
	 * @constructor
	 * @param {RPCImpl} rpcImpl RPC implementation
	 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
	 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
	 */
	function Service(rpcImpl, requestDelimited, responseDelimited) {

	    if (typeof rpcImpl !== "function")
	        throw TypeError("rpcImpl must be a function");

	    util$4.EventEmitter.call(this);

	    /**
	     * RPC implementation. Becomes `null` once the service is ended.
	     * @type {RPCImpl|null}
	     */
	    this.rpcImpl = rpcImpl;

	    /**
	     * Whether requests are length-delimited.
	     * @type {boolean}
	     */
	    this.requestDelimited = Boolean(requestDelimited);

	    /**
	     * Whether responses are length-delimited.
	     * @type {boolean}
	     */
	    this.responseDelimited = Boolean(responseDelimited);
	}

	/**
	 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
	 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
	 * @param {Constructor<TReq>} requestCtor Request constructor
	 * @param {Constructor<TRes>} responseCtor Response constructor
	 * @param {TReq|Properties<TReq>} request Request message or plain object
	 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
	 * @returns {undefined}
	 * @template TReq extends Message<TReq>
	 * @template TRes extends Message<TRes>
	 */
	Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {

	    if (!request)
	        throw TypeError("request must be specified");

	    var self = this;
	    if (!callback)
	        return util$4.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);

	    if (!self.rpcImpl) {
	        setTimeout(function() { callback(Error("already ended")); }, 0);
	        return undefined;
	    }

	    try {
	        return self.rpcImpl(
	            method,
	            requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(),
	            function rpcCallback(err, response) {

	                if (err) {
	                    self.emit("error", err, method);
	                    return callback(err);
	                }

	                if (response === null) {
	                    self.end(/* endedByRPC */ true);
	                    return undefined;
	                }

	                if (!(response instanceof responseCtor)) {
	                    try {
	                        response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
	                    } catch (err) {
	                        self.emit("error", err, method);
	                        return callback(err);
	                    }
	                }

	                self.emit("data", response, method);
	                return callback(null, response);
	            }
	        );
	    } catch (err) {
	        self.emit("error", err, method);
	        setTimeout(function() { callback(err); }, 0);
	        return undefined;
	    }
	};

	/**
	 * Ends this service and emits the `end` event.
	 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
	 * @returns {rpc.Service} `this`
	 */
	Service.prototype.end = function end(endedByRPC) {
	    if (this.rpcImpl) {
	        if (!endedByRPC) // signal end to rpcImpl
	            this.rpcImpl(null, null, null);
	        this.rpcImpl = null;
	        this.emit("end").off();
	    }
	    return this;
	};

	(function (exports) {

		/**
		 * Streaming RPC helpers.
		 * @namespace
		 */
		var rpc = exports;

		/**
		 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
		 * @typedef RPCImpl
		 * @type {function}
		 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
		 * @param {Uint8Array} requestData Request data
		 * @param {RPCImplCallback} callback Callback function
		 * @returns {undefined}
		 * @example
		 * function rpcImpl(method, requestData, callback) {
		 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
		 *         throw Error("no such method");
		 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
		 *         callback(err, responseData);
		 *     });
		 * }
		 */

		/**
		 * Node-style callback as used by {@link RPCImpl}.
		 * @typedef RPCImplCallback
		 * @type {function}
		 * @param {Error|null} error Error, if any, otherwise `null`
		 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
		 * @returns {undefined}
		 */

		rpc.Service = service; 
	} (rpc));

	var roots = {};

	(function (exports) {
		var protobuf = exports;

		/**
		 * Build type, one of `"full"`, `"light"` or `"minimal"`.
		 * @name build
		 * @type {string}
		 * @const
		 */
		protobuf.build = "minimal";

		// Serialization
		protobuf.Writer       = writer;
		protobuf.BufferWriter = writer_buffer;
		protobuf.Reader       = reader;
		protobuf.BufferReader = reader_buffer;

		// Utility
		protobuf.util         = requireMinimal();
		protobuf.rpc          = rpc;
		protobuf.roots        = roots;
		protobuf.configure    = configure;

		/* istanbul ignore next */
		/**
		 * Reconfigures the library according to the environment.
		 * @returns {undefined}
		 */
		function configure() {
		    protobuf.util._configure();
		    protobuf.Writer._configure(protobuf.BufferWriter);
		    protobuf.Reader._configure(protobuf.BufferReader);
		}

		// Set up buffer utility according to the environment
		configure(); 
	} (indexMinimal));

	var minimal = indexMinimal;

	var _m0 = /*@__PURE__*/getDefaultExportFromCjs(minimal);

	/* eslint-disable */
	function createBaseSignature() {
	    return { ecdsaCompact: undefined, walletEcdsaCompact: undefined };
	}
	const Signature$5 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.ecdsaCompact !== undefined) {
	            Signature_ECDSACompact.encode(message.ecdsaCompact, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.walletEcdsaCompact !== undefined) {
	            Signature_WalletECDSACompact.encode(message.walletEcdsaCompact, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSignature();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.ecdsaCompact = Signature_ECDSACompact.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.walletEcdsaCompact = Signature_WalletECDSACompact.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            ecdsaCompact: isSet$b(object.ecdsaCompact)
	                ? Signature_ECDSACompact.fromJSON(object.ecdsaCompact)
	                : undefined,
	            walletEcdsaCompact: isSet$b(object.walletEcdsaCompact)
	                ? Signature_WalletECDSACompact.fromJSON(object.walletEcdsaCompact)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.ecdsaCompact !== undefined &&
	            (obj.ecdsaCompact = message.ecdsaCompact
	                ? Signature_ECDSACompact.toJSON(message.ecdsaCompact)
	                : undefined);
	        message.walletEcdsaCompact !== undefined &&
	            (obj.walletEcdsaCompact = message.walletEcdsaCompact
	                ? Signature_WalletECDSACompact.toJSON(message.walletEcdsaCompact)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseSignature();
	        message.ecdsaCompact =
	            object.ecdsaCompact !== undefined && object.ecdsaCompact !== null
	                ? Signature_ECDSACompact.fromPartial(object.ecdsaCompact)
	                : undefined;
	        message.walletEcdsaCompact =
	            object.walletEcdsaCompact !== undefined &&
	                object.walletEcdsaCompact !== null
	                ? Signature_WalletECDSACompact.fromPartial(object.walletEcdsaCompact)
	                : undefined;
	        return message;
	    },
	};
	function createBaseSignature_ECDSACompact() {
	    return { bytes: new Uint8Array(), recovery: 0 };
	}
	const Signature_ECDSACompact = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.bytes.length !== 0) {
	            writer.uint32(10).bytes(message.bytes);
	        }
	        if (message.recovery !== 0) {
	            writer.uint32(16).uint32(message.recovery);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSignature_ECDSACompact();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.bytes = reader.bytes();
	                    break;
	                case 2:
	                    message.recovery = reader.uint32();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            bytes: isSet$b(object.bytes)
	                ? bytesFromBase64$8(object.bytes)
	                : new Uint8Array(),
	            recovery: isSet$b(object.recovery) ? Number(object.recovery) : 0,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.bytes !== undefined &&
	            (obj.bytes = base64FromBytes$8(message.bytes !== undefined ? message.bytes : new Uint8Array()));
	        message.recovery !== undefined &&
	            (obj.recovery = Math.round(message.recovery));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b;
	        const message = createBaseSignature_ECDSACompact();
	        message.bytes = (_a = object.bytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.recovery = (_b = object.recovery) !== null && _b !== void 0 ? _b : 0;
	        return message;
	    },
	};
	function createBaseSignature_WalletECDSACompact() {
	    return { bytes: new Uint8Array(), recovery: 0 };
	}
	const Signature_WalletECDSACompact = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.bytes.length !== 0) {
	            writer.uint32(10).bytes(message.bytes);
	        }
	        if (message.recovery !== 0) {
	            writer.uint32(16).uint32(message.recovery);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSignature_WalletECDSACompact();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.bytes = reader.bytes();
	                    break;
	                case 2:
	                    message.recovery = reader.uint32();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            bytes: isSet$b(object.bytes)
	                ? bytesFromBase64$8(object.bytes)
	                : new Uint8Array(),
	            recovery: isSet$b(object.recovery) ? Number(object.recovery) : 0,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.bytes !== undefined &&
	            (obj.bytes = base64FromBytes$8(message.bytes !== undefined ? message.bytes : new Uint8Array()));
	        message.recovery !== undefined &&
	            (obj.recovery = Math.round(message.recovery));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b;
	        const message = createBaseSignature_WalletECDSACompact();
	        message.bytes = (_a = object.bytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.recovery = (_b = object.recovery) !== null && _b !== void 0 ? _b : 0;
	        return message;
	    },
	};
	var globalThis$9 = (() => {
	    if (typeof globalThis$9 !== "undefined")
	        return globalThis$9;
	    if (typeof self !== "undefined")
	        return self;
	    if (typeof window !== "undefined")
	        return window;
	    if (typeof global !== "undefined")
	        return global;
	    throw "Unable to locate global object";
	})();
	function bytesFromBase64$8(b64) {
	    if (globalThis$9.Buffer) {
	        return Uint8Array.from(globalThis$9.Buffer.from(b64, "base64"));
	    }
	    else {
	        const bin = globalThis$9.atob(b64);
	        const arr = new Uint8Array(bin.length);
	        for (let i = 0; i < bin.length; ++i) {
	            arr[i] = bin.charCodeAt(i);
	        }
	        return arr;
	    }
	}
	function base64FromBytes$8(arr) {
	    if (globalThis$9.Buffer) {
	        return globalThis$9.Buffer.from(arr).toString("base64");
	    }
	    else {
	        const bin = [];
	        arr.forEach((byte) => {
	            bin.push(String.fromCharCode(byte));
	        });
	        return globalThis$9.btoa(bin.join(""));
	    }
	}
	if (_m0.util.Long !== Long) {
	    _m0.util.Long = Long;
	    _m0.configure();
	}
	function isSet$b(value) {
	    return value !== null && value !== undefined;
	}

	/* eslint-disable */
	function createBaseUnsignedPublicKey() {
	    return { createdNs: Long.UZERO, secp256k1Uncompressed: undefined };
	}
	const UnsignedPublicKey = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (!message.createdNs.isZero()) {
	            writer.uint32(8).uint64(message.createdNs);
	        }
	        if (message.secp256k1Uncompressed !== undefined) {
	            UnsignedPublicKey_Secp256k1Uncompressed.encode(message.secp256k1Uncompressed, writer.uint32(26).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseUnsignedPublicKey();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.createdNs = reader.uint64();
	                    break;
	                case 3:
	                    message.secp256k1Uncompressed =
	                        UnsignedPublicKey_Secp256k1Uncompressed.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            createdNs: isSet$a(object.createdNs)
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO,
	            secp256k1Uncompressed: isSet$a(object.secp256k1Uncompressed)
	                ? UnsignedPublicKey_Secp256k1Uncompressed.fromJSON(object.secp256k1Uncompressed)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.createdNs !== undefined &&
	            (obj.createdNs = (message.createdNs || Long.UZERO).toString());
	        message.secp256k1Uncompressed !== undefined &&
	            (obj.secp256k1Uncompressed = message.secp256k1Uncompressed
	                ? UnsignedPublicKey_Secp256k1Uncompressed.toJSON(message.secp256k1Uncompressed)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseUnsignedPublicKey();
	        message.createdNs =
	            object.createdNs !== undefined && object.createdNs !== null
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO;
	        message.secp256k1Uncompressed =
	            object.secp256k1Uncompressed !== undefined &&
	                object.secp256k1Uncompressed !== null
	                ? UnsignedPublicKey_Secp256k1Uncompressed.fromPartial(object.secp256k1Uncompressed)
	                : undefined;
	        return message;
	    },
	};
	function createBaseUnsignedPublicKey_Secp256k1Uncompressed() {
	    return { bytes: new Uint8Array() };
	}
	const UnsignedPublicKey_Secp256k1Uncompressed = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.bytes.length !== 0) {
	            writer.uint32(10).bytes(message.bytes);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseUnsignedPublicKey_Secp256k1Uncompressed();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.bytes = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            bytes: isSet$a(object.bytes)
	                ? bytesFromBase64$7(object.bytes)
	                : new Uint8Array(),
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.bytes !== undefined &&
	            (obj.bytes = base64FromBytes$7(message.bytes !== undefined ? message.bytes : new Uint8Array()));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseUnsignedPublicKey_Secp256k1Uncompressed();
	        message.bytes = (_a = object.bytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        return message;
	    },
	};
	function createBaseSignedPublicKey() {
	    return { keyBytes: new Uint8Array(), signature: undefined };
	}
	const SignedPublicKey = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.keyBytes.length !== 0) {
	            writer.uint32(10).bytes(message.keyBytes);
	        }
	        if (message.signature !== undefined) {
	            Signature$5.encode(message.signature, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSignedPublicKey();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.keyBytes = reader.bytes();
	                    break;
	                case 2:
	                    message.signature = Signature$5.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            keyBytes: isSet$a(object.keyBytes)
	                ? bytesFromBase64$7(object.keyBytes)
	                : new Uint8Array(),
	            signature: isSet$a(object.signature)
	                ? Signature$5.fromJSON(object.signature)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.keyBytes !== undefined &&
	            (obj.keyBytes = base64FromBytes$7(message.keyBytes !== undefined ? message.keyBytes : new Uint8Array()));
	        message.signature !== undefined &&
	            (obj.signature = message.signature
	                ? Signature$5.toJSON(message.signature)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseSignedPublicKey();
	        message.keyBytes = (_a = object.keyBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.signature =
	            object.signature !== undefined && object.signature !== null
	                ? Signature$5.fromPartial(object.signature)
	                : undefined;
	        return message;
	    },
	};
	function createBaseSignedPublicKeyBundle() {
	    return { identityKey: undefined, preKey: undefined };
	}
	const SignedPublicKeyBundle = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.identityKey !== undefined) {
	            SignedPublicKey.encode(message.identityKey, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.preKey !== undefined) {
	            SignedPublicKey.encode(message.preKey, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSignedPublicKeyBundle();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.identityKey = SignedPublicKey.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.preKey = SignedPublicKey.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            identityKey: isSet$a(object.identityKey)
	                ? SignedPublicKey.fromJSON(object.identityKey)
	                : undefined,
	            preKey: isSet$a(object.preKey)
	                ? SignedPublicKey.fromJSON(object.preKey)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.identityKey !== undefined &&
	            (obj.identityKey = message.identityKey
	                ? SignedPublicKey.toJSON(message.identityKey)
	                : undefined);
	        message.preKey !== undefined &&
	            (obj.preKey = message.preKey
	                ? SignedPublicKey.toJSON(message.preKey)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseSignedPublicKeyBundle();
	        message.identityKey =
	            object.identityKey !== undefined && object.identityKey !== null
	                ? SignedPublicKey.fromPartial(object.identityKey)
	                : undefined;
	        message.preKey =
	            object.preKey !== undefined && object.preKey !== null
	                ? SignedPublicKey.fromPartial(object.preKey)
	                : undefined;
	        return message;
	    },
	};
	function createBasePublicKey() {
	    return {
	        timestamp: Long.UZERO,
	        signature: undefined,
	        secp256k1Uncompressed: undefined,
	    };
	}
	const PublicKey = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (!message.timestamp.isZero()) {
	            writer.uint32(8).uint64(message.timestamp);
	        }
	        if (message.signature !== undefined) {
	            Signature$5.encode(message.signature, writer.uint32(18).fork()).ldelim();
	        }
	        if (message.secp256k1Uncompressed !== undefined) {
	            PublicKey_Secp256k1Uncompressed.encode(message.secp256k1Uncompressed, writer.uint32(26).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBasePublicKey();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.timestamp = reader.uint64();
	                    break;
	                case 2:
	                    message.signature = Signature$5.decode(reader, reader.uint32());
	                    break;
	                case 3:
	                    message.secp256k1Uncompressed =
	                        PublicKey_Secp256k1Uncompressed.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            timestamp: isSet$a(object.timestamp)
	                ? Long.fromValue(object.timestamp)
	                : Long.UZERO,
	            signature: isSet$a(object.signature)
	                ? Signature$5.fromJSON(object.signature)
	                : undefined,
	            secp256k1Uncompressed: isSet$a(object.secp256k1Uncompressed)
	                ? PublicKey_Secp256k1Uncompressed.fromJSON(object.secp256k1Uncompressed)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.timestamp !== undefined &&
	            (obj.timestamp = (message.timestamp || Long.UZERO).toString());
	        message.signature !== undefined &&
	            (obj.signature = message.signature
	                ? Signature$5.toJSON(message.signature)
	                : undefined);
	        message.secp256k1Uncompressed !== undefined &&
	            (obj.secp256k1Uncompressed = message.secp256k1Uncompressed
	                ? PublicKey_Secp256k1Uncompressed.toJSON(message.secp256k1Uncompressed)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBasePublicKey();
	        message.timestamp =
	            object.timestamp !== undefined && object.timestamp !== null
	                ? Long.fromValue(object.timestamp)
	                : Long.UZERO;
	        message.signature =
	            object.signature !== undefined && object.signature !== null
	                ? Signature$5.fromPartial(object.signature)
	                : undefined;
	        message.secp256k1Uncompressed =
	            object.secp256k1Uncompressed !== undefined &&
	                object.secp256k1Uncompressed !== null
	                ? PublicKey_Secp256k1Uncompressed.fromPartial(object.secp256k1Uncompressed)
	                : undefined;
	        return message;
	    },
	};
	function createBasePublicKey_Secp256k1Uncompressed() {
	    return { bytes: new Uint8Array() };
	}
	const PublicKey_Secp256k1Uncompressed = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.bytes.length !== 0) {
	            writer.uint32(10).bytes(message.bytes);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBasePublicKey_Secp256k1Uncompressed();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.bytes = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            bytes: isSet$a(object.bytes)
	                ? bytesFromBase64$7(object.bytes)
	                : new Uint8Array(),
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.bytes !== undefined &&
	            (obj.bytes = base64FromBytes$7(message.bytes !== undefined ? message.bytes : new Uint8Array()));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBasePublicKey_Secp256k1Uncompressed();
	        message.bytes = (_a = object.bytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        return message;
	    },
	};
	function createBasePublicKeyBundle() {
	    return { identityKey: undefined, preKey: undefined };
	}
	const PublicKeyBundle = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.identityKey !== undefined) {
	            PublicKey.encode(message.identityKey, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.preKey !== undefined) {
	            PublicKey.encode(message.preKey, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBasePublicKeyBundle();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.identityKey = PublicKey.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.preKey = PublicKey.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            identityKey: isSet$a(object.identityKey)
	                ? PublicKey.fromJSON(object.identityKey)
	                : undefined,
	            preKey: isSet$a(object.preKey)
	                ? PublicKey.fromJSON(object.preKey)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.identityKey !== undefined &&
	            (obj.identityKey = message.identityKey
	                ? PublicKey.toJSON(message.identityKey)
	                : undefined);
	        message.preKey !== undefined &&
	            (obj.preKey = message.preKey
	                ? PublicKey.toJSON(message.preKey)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBasePublicKeyBundle();
	        message.identityKey =
	            object.identityKey !== undefined && object.identityKey !== null
	                ? PublicKey.fromPartial(object.identityKey)
	                : undefined;
	        message.preKey =
	            object.preKey !== undefined && object.preKey !== null
	                ? PublicKey.fromPartial(object.preKey)
	                : undefined;
	        return message;
	    },
	};
	var globalThis$8 = (() => {
	    if (typeof globalThis$8 !== "undefined")
	        return globalThis$8;
	    if (typeof self !== "undefined")
	        return self;
	    if (typeof window !== "undefined")
	        return window;
	    if (typeof global !== "undefined")
	        return global;
	    throw "Unable to locate global object";
	})();
	function bytesFromBase64$7(b64) {
	    if (globalThis$8.Buffer) {
	        return Uint8Array.from(globalThis$8.Buffer.from(b64, "base64"));
	    }
	    else {
	        const bin = globalThis$8.atob(b64);
	        const arr = new Uint8Array(bin.length);
	        for (let i = 0; i < bin.length; ++i) {
	            arr[i] = bin.charCodeAt(i);
	        }
	        return arr;
	    }
	}
	function base64FromBytes$7(arr) {
	    if (globalThis$8.Buffer) {
	        return globalThis$8.Buffer.from(arr).toString("base64");
	    }
	    else {
	        const bin = [];
	        arr.forEach((byte) => {
	            bin.push(String.fromCharCode(byte));
	        });
	        return globalThis$8.btoa(bin.join(""));
	    }
	}
	if (_m0.util.Long !== Long) {
	    _m0.util.Long = Long;
	    _m0.configure();
	}
	function isSet$a(value) {
	    return value !== null && value !== undefined;
	}

	/* eslint-disable */
	function createBaseToken() {
	    return {
	        identityKey: undefined,
	        authDataBytes: new Uint8Array(),
	        authDataSignature: undefined,
	    };
	}
	const Token = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.identityKey !== undefined) {
	            PublicKey.encode(message.identityKey, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.authDataBytes.length !== 0) {
	            writer.uint32(18).bytes(message.authDataBytes);
	        }
	        if (message.authDataSignature !== undefined) {
	            Signature$5.encode(message.authDataSignature, writer.uint32(26).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseToken();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.identityKey = PublicKey.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.authDataBytes = reader.bytes();
	                    break;
	                case 3:
	                    message.authDataSignature = Signature$5.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            identityKey: isSet$9(object.identityKey)
	                ? PublicKey.fromJSON(object.identityKey)
	                : undefined,
	            authDataBytes: isSet$9(object.authDataBytes)
	                ? bytesFromBase64$6(object.authDataBytes)
	                : new Uint8Array(),
	            authDataSignature: isSet$9(object.authDataSignature)
	                ? Signature$5.fromJSON(object.authDataSignature)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.identityKey !== undefined &&
	            (obj.identityKey = message.identityKey
	                ? PublicKey.toJSON(message.identityKey)
	                : undefined);
	        message.authDataBytes !== undefined &&
	            (obj.authDataBytes = base64FromBytes$6(message.authDataBytes !== undefined
	                ? message.authDataBytes
	                : new Uint8Array()));
	        message.authDataSignature !== undefined &&
	            (obj.authDataSignature = message.authDataSignature
	                ? Signature$5.toJSON(message.authDataSignature)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseToken();
	        message.identityKey =
	            object.identityKey !== undefined && object.identityKey !== null
	                ? PublicKey.fromPartial(object.identityKey)
	                : undefined;
	        message.authDataBytes = (_a = object.authDataBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.authDataSignature =
	            object.authDataSignature !== undefined &&
	                object.authDataSignature !== null
	                ? Signature$5.fromPartial(object.authDataSignature)
	                : undefined;
	        return message;
	    },
	};
	function createBaseAuthData() {
	    return { walletAddr: "", createdNs: Long.UZERO };
	}
	const AuthData = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.walletAddr !== "") {
	            writer.uint32(10).string(message.walletAddr);
	        }
	        if (!message.createdNs.isZero()) {
	            writer.uint32(16).uint64(message.createdNs);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseAuthData();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.walletAddr = reader.string();
	                    break;
	                case 2:
	                    message.createdNs = reader.uint64();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            walletAddr: isSet$9(object.walletAddr) ? String(object.walletAddr) : "",
	            createdNs: isSet$9(object.createdNs)
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.walletAddr !== undefined && (obj.walletAddr = message.walletAddr);
	        message.createdNs !== undefined &&
	            (obj.createdNs = (message.createdNs || Long.UZERO).toString());
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseAuthData();
	        message.walletAddr = (_a = object.walletAddr) !== null && _a !== void 0 ? _a : "";
	        message.createdNs =
	            object.createdNs !== undefined && object.createdNs !== null
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO;
	        return message;
	    },
	};
	var globalThis$7 = (() => {
	    if (typeof globalThis$7 !== "undefined")
	        return globalThis$7;
	    if (typeof self !== "undefined")
	        return self;
	    if (typeof window !== "undefined")
	        return window;
	    if (typeof global !== "undefined")
	        return global;
	    throw "Unable to locate global object";
	})();
	function bytesFromBase64$6(b64) {
	    if (globalThis$7.Buffer) {
	        return Uint8Array.from(globalThis$7.Buffer.from(b64, "base64"));
	    }
	    else {
	        const bin = globalThis$7.atob(b64);
	        const arr = new Uint8Array(bin.length);
	        for (let i = 0; i < bin.length; ++i) {
	            arr[i] = bin.charCodeAt(i);
	        }
	        return arr;
	    }
	}
	function base64FromBytes$6(arr) {
	    if (globalThis$7.Buffer) {
	        return globalThis$7.Buffer.from(arr).toString("base64");
	    }
	    else {
	        const bin = [];
	        arr.forEach((byte) => {
	            bin.push(String.fromCharCode(byte));
	        });
	        return globalThis$7.btoa(bin.join(""));
	    }
	}
	if (_m0.util.Long !== Long) {
	    _m0.util.Long = Long;
	    _m0.configure();
	}
	function isSet$9(value) {
	    return value !== null && value !== undefined;
	}

	/* eslint-disable */
	function createBaseCiphertext() {
	    return { aes256GcmHkdfSha256: undefined };
	}
	const Ciphertext = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.aes256GcmHkdfSha256 !== undefined) {
	            Ciphertext_Aes256gcmHkdfsha256.encode(message.aes256GcmHkdfSha256, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseCiphertext();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.aes256GcmHkdfSha256 = Ciphertext_Aes256gcmHkdfsha256.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            aes256GcmHkdfSha256: isSet$8(object.aes256GcmHkdfSha256)
	                ? Ciphertext_Aes256gcmHkdfsha256.fromJSON(object.aes256GcmHkdfSha256)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.aes256GcmHkdfSha256 !== undefined &&
	            (obj.aes256GcmHkdfSha256 = message.aes256GcmHkdfSha256
	                ? Ciphertext_Aes256gcmHkdfsha256.toJSON(message.aes256GcmHkdfSha256)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseCiphertext();
	        message.aes256GcmHkdfSha256 =
	            object.aes256GcmHkdfSha256 !== undefined &&
	                object.aes256GcmHkdfSha256 !== null
	                ? Ciphertext_Aes256gcmHkdfsha256.fromPartial(object.aes256GcmHkdfSha256)
	                : undefined;
	        return message;
	    },
	};
	function createBaseCiphertext_Aes256gcmHkdfsha256() {
	    return {
	        hkdfSalt: new Uint8Array(),
	        gcmNonce: new Uint8Array(),
	        payload: new Uint8Array(),
	    };
	}
	const Ciphertext_Aes256gcmHkdfsha256 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.hkdfSalt.length !== 0) {
	            writer.uint32(10).bytes(message.hkdfSalt);
	        }
	        if (message.gcmNonce.length !== 0) {
	            writer.uint32(18).bytes(message.gcmNonce);
	        }
	        if (message.payload.length !== 0) {
	            writer.uint32(26).bytes(message.payload);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseCiphertext_Aes256gcmHkdfsha256();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.hkdfSalt = reader.bytes();
	                    break;
	                case 2:
	                    message.gcmNonce = reader.bytes();
	                    break;
	                case 3:
	                    message.payload = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            hkdfSalt: isSet$8(object.hkdfSalt)
	                ? bytesFromBase64$5(object.hkdfSalt)
	                : new Uint8Array(),
	            gcmNonce: isSet$8(object.gcmNonce)
	                ? bytesFromBase64$5(object.gcmNonce)
	                : new Uint8Array(),
	            payload: isSet$8(object.payload)
	                ? bytesFromBase64$5(object.payload)
	                : new Uint8Array(),
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.hkdfSalt !== undefined &&
	            (obj.hkdfSalt = base64FromBytes$5(message.hkdfSalt !== undefined ? message.hkdfSalt : new Uint8Array()));
	        message.gcmNonce !== undefined &&
	            (obj.gcmNonce = base64FromBytes$5(message.gcmNonce !== undefined ? message.gcmNonce : new Uint8Array()));
	        message.payload !== undefined &&
	            (obj.payload = base64FromBytes$5(message.payload !== undefined ? message.payload : new Uint8Array()));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b, _c;
	        const message = createBaseCiphertext_Aes256gcmHkdfsha256();
	        message.hkdfSalt = (_a = object.hkdfSalt) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.gcmNonce = (_b = object.gcmNonce) !== null && _b !== void 0 ? _b : new Uint8Array();
	        message.payload = (_c = object.payload) !== null && _c !== void 0 ? _c : new Uint8Array();
	        return message;
	    },
	};
	function createBaseSignedEciesCiphertext() {
	    return { eciesBytes: new Uint8Array(), signature: undefined };
	}
	const SignedEciesCiphertext = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.eciesBytes.length !== 0) {
	            writer.uint32(10).bytes(message.eciesBytes);
	        }
	        if (message.signature !== undefined) {
	            Signature$5.encode(message.signature, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSignedEciesCiphertext();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.eciesBytes = reader.bytes();
	                    break;
	                case 2:
	                    message.signature = Signature$5.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            eciesBytes: isSet$8(object.eciesBytes)
	                ? bytesFromBase64$5(object.eciesBytes)
	                : new Uint8Array(),
	            signature: isSet$8(object.signature)
	                ? Signature$5.fromJSON(object.signature)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.eciesBytes !== undefined &&
	            (obj.eciesBytes = base64FromBytes$5(message.eciesBytes !== undefined ? message.eciesBytes : new Uint8Array()));
	        message.signature !== undefined &&
	            (obj.signature = message.signature
	                ? Signature$5.toJSON(message.signature)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseSignedEciesCiphertext();
	        message.eciesBytes = (_a = object.eciesBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.signature =
	            object.signature !== undefined && object.signature !== null
	                ? Signature$5.fromPartial(object.signature)
	                : undefined;
	        return message;
	    },
	};
	function createBaseSignedEciesCiphertext_Ecies() {
	    return {
	        ephemeralPublicKey: new Uint8Array(),
	        iv: new Uint8Array(),
	        mac: new Uint8Array(),
	        ciphertext: new Uint8Array(),
	    };
	}
	const SignedEciesCiphertext_Ecies = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.ephemeralPublicKey.length !== 0) {
	            writer.uint32(10).bytes(message.ephemeralPublicKey);
	        }
	        if (message.iv.length !== 0) {
	            writer.uint32(18).bytes(message.iv);
	        }
	        if (message.mac.length !== 0) {
	            writer.uint32(26).bytes(message.mac);
	        }
	        if (message.ciphertext.length !== 0) {
	            writer.uint32(34).bytes(message.ciphertext);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSignedEciesCiphertext_Ecies();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.ephemeralPublicKey = reader.bytes();
	                    break;
	                case 2:
	                    message.iv = reader.bytes();
	                    break;
	                case 3:
	                    message.mac = reader.bytes();
	                    break;
	                case 4:
	                    message.ciphertext = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            ephemeralPublicKey: isSet$8(object.ephemeralPublicKey)
	                ? bytesFromBase64$5(object.ephemeralPublicKey)
	                : new Uint8Array(),
	            iv: isSet$8(object.iv) ? bytesFromBase64$5(object.iv) : new Uint8Array(),
	            mac: isSet$8(object.mac) ? bytesFromBase64$5(object.mac) : new Uint8Array(),
	            ciphertext: isSet$8(object.ciphertext)
	                ? bytesFromBase64$5(object.ciphertext)
	                : new Uint8Array(),
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.ephemeralPublicKey !== undefined &&
	            (obj.ephemeralPublicKey = base64FromBytes$5(message.ephemeralPublicKey !== undefined
	                ? message.ephemeralPublicKey
	                : new Uint8Array()));
	        message.iv !== undefined &&
	            (obj.iv = base64FromBytes$5(message.iv !== undefined ? message.iv : new Uint8Array()));
	        message.mac !== undefined &&
	            (obj.mac = base64FromBytes$5(message.mac !== undefined ? message.mac : new Uint8Array()));
	        message.ciphertext !== undefined &&
	            (obj.ciphertext = base64FromBytes$5(message.ciphertext !== undefined ? message.ciphertext : new Uint8Array()));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b, _c, _d;
	        const message = createBaseSignedEciesCiphertext_Ecies();
	        message.ephemeralPublicKey = (_a = object.ephemeralPublicKey) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.iv = (_b = object.iv) !== null && _b !== void 0 ? _b : new Uint8Array();
	        message.mac = (_c = object.mac) !== null && _c !== void 0 ? _c : new Uint8Array();
	        message.ciphertext = (_d = object.ciphertext) !== null && _d !== void 0 ? _d : new Uint8Array();
	        return message;
	    },
	};
	var globalThis$6 = (() => {
	    if (typeof globalThis$6 !== "undefined")
	        return globalThis$6;
	    if (typeof self !== "undefined")
	        return self;
	    if (typeof window !== "undefined")
	        return window;
	    if (typeof global !== "undefined")
	        return global;
	    throw "Unable to locate global object";
	})();
	function bytesFromBase64$5(b64) {
	    if (globalThis$6.Buffer) {
	        return Uint8Array.from(globalThis$6.Buffer.from(b64, "base64"));
	    }
	    else {
	        const bin = globalThis$6.atob(b64);
	        const arr = new Uint8Array(bin.length);
	        for (let i = 0; i < bin.length; ++i) {
	            arr[i] = bin.charCodeAt(i);
	        }
	        return arr;
	    }
	}
	function base64FromBytes$5(arr) {
	    if (globalThis$6.Buffer) {
	        return globalThis$6.Buffer.from(arr).toString("base64");
	    }
	    else {
	        const bin = [];
	        arr.forEach((byte) => {
	            bin.push(String.fromCharCode(byte));
	        });
	        return globalThis$6.btoa(bin.join(""));
	    }
	}
	if (_m0.util.Long !== Long) {
	    _m0.util.Long = Long;
	    _m0.configure();
	}
	function isSet$8(value) {
	    return value !== null && value !== undefined;
	}

	/* eslint-disable */
	function createBaseInvitationV1() {
	    return { topic: "", context: undefined, aes256GcmHkdfSha256: undefined };
	}
	const InvitationV1 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.topic !== "") {
	            writer.uint32(10).string(message.topic);
	        }
	        if (message.context !== undefined) {
	            InvitationV1_Context.encode(message.context, writer.uint32(18).fork()).ldelim();
	        }
	        if (message.aes256GcmHkdfSha256 !== undefined) {
	            InvitationV1_Aes256gcmHkdfsha256.encode(message.aes256GcmHkdfSha256, writer.uint32(26).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseInvitationV1();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.topic = reader.string();
	                    break;
	                case 2:
	                    message.context = InvitationV1_Context.decode(reader, reader.uint32());
	                    break;
	                case 3:
	                    message.aes256GcmHkdfSha256 = InvitationV1_Aes256gcmHkdfsha256.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            topic: isSet$7(object.topic) ? String(object.topic) : "",
	            context: isSet$7(object.context)
	                ? InvitationV1_Context.fromJSON(object.context)
	                : undefined,
	            aes256GcmHkdfSha256: isSet$7(object.aes256GcmHkdfSha256)
	                ? InvitationV1_Aes256gcmHkdfsha256.fromJSON(object.aes256GcmHkdfSha256)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.topic !== undefined && (obj.topic = message.topic);
	        message.context !== undefined &&
	            (obj.context = message.context
	                ? InvitationV1_Context.toJSON(message.context)
	                : undefined);
	        message.aes256GcmHkdfSha256 !== undefined &&
	            (obj.aes256GcmHkdfSha256 = message.aes256GcmHkdfSha256
	                ? InvitationV1_Aes256gcmHkdfsha256.toJSON(message.aes256GcmHkdfSha256)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseInvitationV1();
	        message.topic = (_a = object.topic) !== null && _a !== void 0 ? _a : "";
	        message.context =
	            object.context !== undefined && object.context !== null
	                ? InvitationV1_Context.fromPartial(object.context)
	                : undefined;
	        message.aes256GcmHkdfSha256 =
	            object.aes256GcmHkdfSha256 !== undefined &&
	                object.aes256GcmHkdfSha256 !== null
	                ? InvitationV1_Aes256gcmHkdfsha256.fromPartial(object.aes256GcmHkdfSha256)
	                : undefined;
	        return message;
	    },
	};
	function createBaseInvitationV1_Aes256gcmHkdfsha256() {
	    return { keyMaterial: new Uint8Array() };
	}
	const InvitationV1_Aes256gcmHkdfsha256 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.keyMaterial.length !== 0) {
	            writer.uint32(10).bytes(message.keyMaterial);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseInvitationV1_Aes256gcmHkdfsha256();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.keyMaterial = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            keyMaterial: isSet$7(object.keyMaterial)
	                ? bytesFromBase64$4(object.keyMaterial)
	                : new Uint8Array(),
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.keyMaterial !== undefined &&
	            (obj.keyMaterial = base64FromBytes$4(message.keyMaterial !== undefined
	                ? message.keyMaterial
	                : new Uint8Array()));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseInvitationV1_Aes256gcmHkdfsha256();
	        message.keyMaterial = (_a = object.keyMaterial) !== null && _a !== void 0 ? _a : new Uint8Array();
	        return message;
	    },
	};
	function createBaseInvitationV1_Context() {
	    return { conversationId: "", metadata: {} };
	}
	const InvitationV1_Context = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.conversationId !== "") {
	            writer.uint32(10).string(message.conversationId);
	        }
	        Object.entries(message.metadata).forEach(([key, value]) => {
	            InvitationV1_Context_MetadataEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
	        });
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseInvitationV1_Context();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.conversationId = reader.string();
	                    break;
	                case 2:
	                    const entry2 = InvitationV1_Context_MetadataEntry.decode(reader, reader.uint32());
	                    if (entry2.value !== undefined) {
	                        message.metadata[entry2.key] = entry2.value;
	                    }
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            conversationId: isSet$7(object.conversationId)
	                ? String(object.conversationId)
	                : "",
	            metadata: isObject$5(object.metadata)
	                ? Object.entries(object.metadata).reduce((acc, [key, value]) => {
	                    acc[key] = String(value);
	                    return acc;
	                }, {})
	                : {},
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.conversationId !== undefined &&
	            (obj.conversationId = message.conversationId);
	        obj.metadata = {};
	        if (message.metadata) {
	            Object.entries(message.metadata).forEach(([k, v]) => {
	                obj.metadata[k] = v;
	            });
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b;
	        const message = createBaseInvitationV1_Context();
	        message.conversationId = (_a = object.conversationId) !== null && _a !== void 0 ? _a : "";
	        message.metadata = Object.entries((_b = object.metadata) !== null && _b !== void 0 ? _b : {}).reduce((acc, [key, value]) => {
	            if (value !== undefined) {
	                acc[key] = String(value);
	            }
	            return acc;
	        }, {});
	        return message;
	    },
	};
	function createBaseInvitationV1_Context_MetadataEntry() {
	    return { key: "", value: "" };
	}
	const InvitationV1_Context_MetadataEntry = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.key !== "") {
	            writer.uint32(10).string(message.key);
	        }
	        if (message.value !== "") {
	            writer.uint32(18).string(message.value);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseInvitationV1_Context_MetadataEntry();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.key = reader.string();
	                    break;
	                case 2:
	                    message.value = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            key: isSet$7(object.key) ? String(object.key) : "",
	            value: isSet$7(object.value) ? String(object.value) : "",
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.key !== undefined && (obj.key = message.key);
	        message.value !== undefined && (obj.value = message.value);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b;
	        const message = createBaseInvitationV1_Context_MetadataEntry();
	        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
	        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
	        return message;
	    },
	};
	function createBaseSealedInvitationHeaderV1() {
	    return { sender: undefined, recipient: undefined, createdNs: Long.UZERO };
	}
	const SealedInvitationHeaderV1 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.sender !== undefined) {
	            SignedPublicKeyBundle.encode(message.sender, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.recipient !== undefined) {
	            SignedPublicKeyBundle.encode(message.recipient, writer.uint32(18).fork()).ldelim();
	        }
	        if (!message.createdNs.isZero()) {
	            writer.uint32(24).uint64(message.createdNs);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSealedInvitationHeaderV1();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.sender = SignedPublicKeyBundle.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.recipient = SignedPublicKeyBundle.decode(reader, reader.uint32());
	                    break;
	                case 3:
	                    message.createdNs = reader.uint64();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            sender: isSet$7(object.sender)
	                ? SignedPublicKeyBundle.fromJSON(object.sender)
	                : undefined,
	            recipient: isSet$7(object.recipient)
	                ? SignedPublicKeyBundle.fromJSON(object.recipient)
	                : undefined,
	            createdNs: isSet$7(object.createdNs)
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.sender !== undefined &&
	            (obj.sender = message.sender
	                ? SignedPublicKeyBundle.toJSON(message.sender)
	                : undefined);
	        message.recipient !== undefined &&
	            (obj.recipient = message.recipient
	                ? SignedPublicKeyBundle.toJSON(message.recipient)
	                : undefined);
	        message.createdNs !== undefined &&
	            (obj.createdNs = (message.createdNs || Long.UZERO).toString());
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseSealedInvitationHeaderV1();
	        message.sender =
	            object.sender !== undefined && object.sender !== null
	                ? SignedPublicKeyBundle.fromPartial(object.sender)
	                : undefined;
	        message.recipient =
	            object.recipient !== undefined && object.recipient !== null
	                ? SignedPublicKeyBundle.fromPartial(object.recipient)
	                : undefined;
	        message.createdNs =
	            object.createdNs !== undefined && object.createdNs !== null
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO;
	        return message;
	    },
	};
	function createBaseSealedInvitationV1() {
	    return { headerBytes: new Uint8Array(), ciphertext: undefined };
	}
	const SealedInvitationV1 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.headerBytes.length !== 0) {
	            writer.uint32(10).bytes(message.headerBytes);
	        }
	        if (message.ciphertext !== undefined) {
	            Ciphertext.encode(message.ciphertext, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSealedInvitationV1();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.headerBytes = reader.bytes();
	                    break;
	                case 2:
	                    message.ciphertext = Ciphertext.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            headerBytes: isSet$7(object.headerBytes)
	                ? bytesFromBase64$4(object.headerBytes)
	                : new Uint8Array(),
	            ciphertext: isSet$7(object.ciphertext)
	                ? Ciphertext.fromJSON(object.ciphertext)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.headerBytes !== undefined &&
	            (obj.headerBytes = base64FromBytes$4(message.headerBytes !== undefined
	                ? message.headerBytes
	                : new Uint8Array()));
	        message.ciphertext !== undefined &&
	            (obj.ciphertext = message.ciphertext
	                ? Ciphertext.toJSON(message.ciphertext)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseSealedInvitationV1();
	        message.headerBytes = (_a = object.headerBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.ciphertext =
	            object.ciphertext !== undefined && object.ciphertext !== null
	                ? Ciphertext.fromPartial(object.ciphertext)
	                : undefined;
	        return message;
	    },
	};
	function createBaseSealedInvitation() {
	    return { v1: undefined };
	}
	const SealedInvitation = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.v1 !== undefined) {
	            SealedInvitationV1.encode(message.v1, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSealedInvitation();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.v1 = SealedInvitationV1.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            v1: isSet$7(object.v1) ? SealedInvitationV1.fromJSON(object.v1) : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.v1 !== undefined &&
	            (obj.v1 = message.v1 ? SealedInvitationV1.toJSON(message.v1) : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseSealedInvitation();
	        message.v1 =
	            object.v1 !== undefined && object.v1 !== null
	                ? SealedInvitationV1.fromPartial(object.v1)
	                : undefined;
	        return message;
	    },
	};
	var globalThis$5 = (() => {
	    if (typeof globalThis$5 !== "undefined")
	        return globalThis$5;
	    if (typeof self !== "undefined")
	        return self;
	    if (typeof window !== "undefined")
	        return window;
	    if (typeof global !== "undefined")
	        return global;
	    throw "Unable to locate global object";
	})();
	function bytesFromBase64$4(b64) {
	    if (globalThis$5.Buffer) {
	        return Uint8Array.from(globalThis$5.Buffer.from(b64, "base64"));
	    }
	    else {
	        const bin = globalThis$5.atob(b64);
	        const arr = new Uint8Array(bin.length);
	        for (let i = 0; i < bin.length; ++i) {
	            arr[i] = bin.charCodeAt(i);
	        }
	        return arr;
	    }
	}
	function base64FromBytes$4(arr) {
	    if (globalThis$5.Buffer) {
	        return globalThis$5.Buffer.from(arr).toString("base64");
	    }
	    else {
	        const bin = [];
	        arr.forEach((byte) => {
	            bin.push(String.fromCharCode(byte));
	        });
	        return globalThis$5.btoa(bin.join(""));
	    }
	}
	if (_m0.util.Long !== Long) {
	    _m0.util.Long = Long;
	    _m0.configure();
	}
	function isObject$5(value) {
	    return typeof value === "object" && value !== null;
	}
	function isSet$7(value) {
	    return value !== null && value !== undefined;
	}

	/* eslint-disable */
	function createBaseConversationReference() {
	    return {
	        topic: "",
	        peerAddress: "",
	        createdNs: Long.UZERO,
	        context: undefined,
	    };
	}
	const ConversationReference = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.topic !== "") {
	            writer.uint32(10).string(message.topic);
	        }
	        if (message.peerAddress !== "") {
	            writer.uint32(18).string(message.peerAddress);
	        }
	        if (!message.createdNs.isZero()) {
	            writer.uint32(24).uint64(message.createdNs);
	        }
	        if (message.context !== undefined) {
	            InvitationV1_Context.encode(message.context, writer.uint32(34).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseConversationReference();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.topic = reader.string();
	                    break;
	                case 2:
	                    message.peerAddress = reader.string();
	                    break;
	                case 3:
	                    message.createdNs = reader.uint64();
	                    break;
	                case 4:
	                    message.context = InvitationV1_Context.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            topic: isSet$6(object.topic) ? String(object.topic) : "",
	            peerAddress: isSet$6(object.peerAddress) ? String(object.peerAddress) : "",
	            createdNs: isSet$6(object.createdNs)
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO,
	            context: isSet$6(object.context)
	                ? InvitationV1_Context.fromJSON(object.context)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.topic !== undefined && (obj.topic = message.topic);
	        message.peerAddress !== undefined &&
	            (obj.peerAddress = message.peerAddress);
	        message.createdNs !== undefined &&
	            (obj.createdNs = (message.createdNs || Long.UZERO).toString());
	        message.context !== undefined &&
	            (obj.context = message.context
	                ? InvitationV1_Context.toJSON(message.context)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b;
	        const message = createBaseConversationReference();
	        message.topic = (_a = object.topic) !== null && _a !== void 0 ? _a : "";
	        message.peerAddress = (_b = object.peerAddress) !== null && _b !== void 0 ? _b : "";
	        message.createdNs =
	            object.createdNs !== undefined && object.createdNs !== null
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO;
	        message.context =
	            object.context !== undefined && object.context !== null
	                ? InvitationV1_Context.fromPartial(object.context)
	                : undefined;
	        return message;
	    },
	};
	if (_m0.util.Long !== Long) {
	    _m0.util.Long = Long;
	    _m0.configure();
	}
	function isSet$6(value) {
	    return value !== null && value !== undefined;
	}

	/* eslint-disable */
	function createBaseMessageHeaderV1() {
	    return { sender: undefined, recipient: undefined, timestamp: Long.UZERO };
	}
	const MessageHeaderV1 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.sender !== undefined) {
	            PublicKeyBundle.encode(message.sender, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.recipient !== undefined) {
	            PublicKeyBundle.encode(message.recipient, writer.uint32(18).fork()).ldelim();
	        }
	        if (!message.timestamp.isZero()) {
	            writer.uint32(24).uint64(message.timestamp);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseMessageHeaderV1();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.sender = PublicKeyBundle.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.recipient = PublicKeyBundle.decode(reader, reader.uint32());
	                    break;
	                case 3:
	                    message.timestamp = reader.uint64();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            sender: isSet$5(object.sender)
	                ? PublicKeyBundle.fromJSON(object.sender)
	                : undefined,
	            recipient: isSet$5(object.recipient)
	                ? PublicKeyBundle.fromJSON(object.recipient)
	                : undefined,
	            timestamp: isSet$5(object.timestamp)
	                ? Long.fromValue(object.timestamp)
	                : Long.UZERO,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.sender !== undefined &&
	            (obj.sender = message.sender
	                ? PublicKeyBundle.toJSON(message.sender)
	                : undefined);
	        message.recipient !== undefined &&
	            (obj.recipient = message.recipient
	                ? PublicKeyBundle.toJSON(message.recipient)
	                : undefined);
	        message.timestamp !== undefined &&
	            (obj.timestamp = (message.timestamp || Long.UZERO).toString());
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseMessageHeaderV1();
	        message.sender =
	            object.sender !== undefined && object.sender !== null
	                ? PublicKeyBundle.fromPartial(object.sender)
	                : undefined;
	        message.recipient =
	            object.recipient !== undefined && object.recipient !== null
	                ? PublicKeyBundle.fromPartial(object.recipient)
	                : undefined;
	        message.timestamp =
	            object.timestamp !== undefined && object.timestamp !== null
	                ? Long.fromValue(object.timestamp)
	                : Long.UZERO;
	        return message;
	    },
	};
	function createBaseMessageV1() {
	    return { headerBytes: new Uint8Array(), ciphertext: undefined };
	}
	const MessageV1 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.headerBytes.length !== 0) {
	            writer.uint32(10).bytes(message.headerBytes);
	        }
	        if (message.ciphertext !== undefined) {
	            Ciphertext.encode(message.ciphertext, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseMessageV1();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.headerBytes = reader.bytes();
	                    break;
	                case 2:
	                    message.ciphertext = Ciphertext.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            headerBytes: isSet$5(object.headerBytes)
	                ? bytesFromBase64$3(object.headerBytes)
	                : new Uint8Array(),
	            ciphertext: isSet$5(object.ciphertext)
	                ? Ciphertext.fromJSON(object.ciphertext)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.headerBytes !== undefined &&
	            (obj.headerBytes = base64FromBytes$3(message.headerBytes !== undefined
	                ? message.headerBytes
	                : new Uint8Array()));
	        message.ciphertext !== undefined &&
	            (obj.ciphertext = message.ciphertext
	                ? Ciphertext.toJSON(message.ciphertext)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseMessageV1();
	        message.headerBytes = (_a = object.headerBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.ciphertext =
	            object.ciphertext !== undefined && object.ciphertext !== null
	                ? Ciphertext.fromPartial(object.ciphertext)
	                : undefined;
	        return message;
	    },
	};
	function createBaseMessageHeaderV2() {
	    return { createdNs: Long.UZERO, topic: "" };
	}
	const MessageHeaderV2 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (!message.createdNs.isZero()) {
	            writer.uint32(8).uint64(message.createdNs);
	        }
	        if (message.topic !== "") {
	            writer.uint32(18).string(message.topic);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseMessageHeaderV2();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.createdNs = reader.uint64();
	                    break;
	                case 2:
	                    message.topic = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            createdNs: isSet$5(object.createdNs)
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO,
	            topic: isSet$5(object.topic) ? String(object.topic) : "",
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.createdNs !== undefined &&
	            (obj.createdNs = (message.createdNs || Long.UZERO).toString());
	        message.topic !== undefined && (obj.topic = message.topic);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseMessageHeaderV2();
	        message.createdNs =
	            object.createdNs !== undefined && object.createdNs !== null
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO;
	        message.topic = (_a = object.topic) !== null && _a !== void 0 ? _a : "";
	        return message;
	    },
	};
	function createBaseMessageV2() {
	    return { headerBytes: new Uint8Array(), ciphertext: undefined };
	}
	const MessageV2 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.headerBytes.length !== 0) {
	            writer.uint32(10).bytes(message.headerBytes);
	        }
	        if (message.ciphertext !== undefined) {
	            Ciphertext.encode(message.ciphertext, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseMessageV2();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.headerBytes = reader.bytes();
	                    break;
	                case 2:
	                    message.ciphertext = Ciphertext.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            headerBytes: isSet$5(object.headerBytes)
	                ? bytesFromBase64$3(object.headerBytes)
	                : new Uint8Array(),
	            ciphertext: isSet$5(object.ciphertext)
	                ? Ciphertext.fromJSON(object.ciphertext)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.headerBytes !== undefined &&
	            (obj.headerBytes = base64FromBytes$3(message.headerBytes !== undefined
	                ? message.headerBytes
	                : new Uint8Array()));
	        message.ciphertext !== undefined &&
	            (obj.ciphertext = message.ciphertext
	                ? Ciphertext.toJSON(message.ciphertext)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseMessageV2();
	        message.headerBytes = (_a = object.headerBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.ciphertext =
	            object.ciphertext !== undefined && object.ciphertext !== null
	                ? Ciphertext.fromPartial(object.ciphertext)
	                : undefined;
	        return message;
	    },
	};
	function createBaseMessage() {
	    return { v1: undefined, v2: undefined };
	}
	const Message = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.v1 !== undefined) {
	            MessageV1.encode(message.v1, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.v2 !== undefined) {
	            MessageV2.encode(message.v2, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseMessage();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.v1 = MessageV1.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.v2 = MessageV2.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            v1: isSet$5(object.v1) ? MessageV1.fromJSON(object.v1) : undefined,
	            v2: isSet$5(object.v2) ? MessageV2.fromJSON(object.v2) : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.v1 !== undefined &&
	            (obj.v1 = message.v1 ? MessageV1.toJSON(message.v1) : undefined);
	        message.v2 !== undefined &&
	            (obj.v2 = message.v2 ? MessageV2.toJSON(message.v2) : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseMessage();
	        message.v1 =
	            object.v1 !== undefined && object.v1 !== null
	                ? MessageV1.fromPartial(object.v1)
	                : undefined;
	        message.v2 =
	            object.v2 !== undefined && object.v2 !== null
	                ? MessageV2.fromPartial(object.v2)
	                : undefined;
	        return message;
	    },
	};
	function createBaseDecodedMessage() {
	    return {
	        id: "",
	        messageVersion: "",
	        senderAddress: "",
	        recipientAddress: undefined,
	        sentNs: Long.UZERO,
	        contentTopic: "",
	        conversation: undefined,
	        contentBytes: new Uint8Array(),
	    };
	}
	const DecodedMessage = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.id !== "") {
	            writer.uint32(10).string(message.id);
	        }
	        if (message.messageVersion !== "") {
	            writer.uint32(18).string(message.messageVersion);
	        }
	        if (message.senderAddress !== "") {
	            writer.uint32(26).string(message.senderAddress);
	        }
	        if (message.recipientAddress !== undefined) {
	            writer.uint32(34).string(message.recipientAddress);
	        }
	        if (!message.sentNs.isZero()) {
	            writer.uint32(40).uint64(message.sentNs);
	        }
	        if (message.contentTopic !== "") {
	            writer.uint32(50).string(message.contentTopic);
	        }
	        if (message.conversation !== undefined) {
	            ConversationReference.encode(message.conversation, writer.uint32(58).fork()).ldelim();
	        }
	        if (message.contentBytes.length !== 0) {
	            writer.uint32(66).bytes(message.contentBytes);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseDecodedMessage();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.id = reader.string();
	                    break;
	                case 2:
	                    message.messageVersion = reader.string();
	                    break;
	                case 3:
	                    message.senderAddress = reader.string();
	                    break;
	                case 4:
	                    message.recipientAddress = reader.string();
	                    break;
	                case 5:
	                    message.sentNs = reader.uint64();
	                    break;
	                case 6:
	                    message.contentTopic = reader.string();
	                    break;
	                case 7:
	                    message.conversation = ConversationReference.decode(reader, reader.uint32());
	                    break;
	                case 8:
	                    message.contentBytes = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            id: isSet$5(object.id) ? String(object.id) : "",
	            messageVersion: isSet$5(object.messageVersion)
	                ? String(object.messageVersion)
	                : "",
	            senderAddress: isSet$5(object.senderAddress)
	                ? String(object.senderAddress)
	                : "",
	            recipientAddress: isSet$5(object.recipientAddress)
	                ? String(object.recipientAddress)
	                : undefined,
	            sentNs: isSet$5(object.sentNs) ? Long.fromValue(object.sentNs) : Long.UZERO,
	            contentTopic: isSet$5(object.contentTopic)
	                ? String(object.contentTopic)
	                : "",
	            conversation: isSet$5(object.conversation)
	                ? ConversationReference.fromJSON(object.conversation)
	                : undefined,
	            contentBytes: isSet$5(object.contentBytes)
	                ? bytesFromBase64$3(object.contentBytes)
	                : new Uint8Array(),
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.id !== undefined && (obj.id = message.id);
	        message.messageVersion !== undefined &&
	            (obj.messageVersion = message.messageVersion);
	        message.senderAddress !== undefined &&
	            (obj.senderAddress = message.senderAddress);
	        message.recipientAddress !== undefined &&
	            (obj.recipientAddress = message.recipientAddress);
	        message.sentNs !== undefined &&
	            (obj.sentNs = (message.sentNs || Long.UZERO).toString());
	        message.contentTopic !== undefined &&
	            (obj.contentTopic = message.contentTopic);
	        message.conversation !== undefined &&
	            (obj.conversation = message.conversation
	                ? ConversationReference.toJSON(message.conversation)
	                : undefined);
	        message.contentBytes !== undefined &&
	            (obj.contentBytes = base64FromBytes$3(message.contentBytes !== undefined
	                ? message.contentBytes
	                : new Uint8Array()));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b, _c, _d, _e, _f;
	        const message = createBaseDecodedMessage();
	        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
	        message.messageVersion = (_b = object.messageVersion) !== null && _b !== void 0 ? _b : "";
	        message.senderAddress = (_c = object.senderAddress) !== null && _c !== void 0 ? _c : "";
	        message.recipientAddress = (_d = object.recipientAddress) !== null && _d !== void 0 ? _d : undefined;
	        message.sentNs =
	            object.sentNs !== undefined && object.sentNs !== null
	                ? Long.fromValue(object.sentNs)
	                : Long.UZERO;
	        message.contentTopic = (_e = object.contentTopic) !== null && _e !== void 0 ? _e : "";
	        message.conversation =
	            object.conversation !== undefined && object.conversation !== null
	                ? ConversationReference.fromPartial(object.conversation)
	                : undefined;
	        message.contentBytes = (_f = object.contentBytes) !== null && _f !== void 0 ? _f : new Uint8Array();
	        return message;
	    },
	};
	var globalThis$4 = (() => {
	    if (typeof globalThis$4 !== "undefined")
	        return globalThis$4;
	    if (typeof self !== "undefined")
	        return self;
	    if (typeof window !== "undefined")
	        return window;
	    if (typeof global !== "undefined")
	        return global;
	    throw "Unable to locate global object";
	})();
	function bytesFromBase64$3(b64) {
	    if (globalThis$4.Buffer) {
	        return Uint8Array.from(globalThis$4.Buffer.from(b64, "base64"));
	    }
	    else {
	        const bin = globalThis$4.atob(b64);
	        const arr = new Uint8Array(bin.length);
	        for (let i = 0; i < bin.length; ++i) {
	            arr[i] = bin.charCodeAt(i);
	        }
	        return arr;
	    }
	}
	function base64FromBytes$3(arr) {
	    if (globalThis$4.Buffer) {
	        return globalThis$4.Buffer.from(arr).toString("base64");
	    }
	    else {
	        const bin = [];
	        arr.forEach((byte) => {
	            bin.push(String.fromCharCode(byte));
	        });
	        return globalThis$4.btoa(bin.join(""));
	    }
	}
	if (_m0.util.Long !== Long) {
	    _m0.util.Long = Long;
	    _m0.configure();
	}
	function isSet$5(value) {
	    return value !== null && value !== undefined;
	}

	/* eslint-disable */
	/** Message content encoding structures */
	/**
	 * Recognized compression algorithms
	 * protolint:disable ENUM_FIELD_NAMES_ZERO_VALUE_END_WITH
	 */
	var Compression;
	(function (Compression) {
	    Compression[Compression["COMPRESSION_DEFLATE"] = 0] = "COMPRESSION_DEFLATE";
	    Compression[Compression["COMPRESSION_GZIP"] = 1] = "COMPRESSION_GZIP";
	    Compression[Compression["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
	})(Compression || (Compression = {}));
	function compressionFromJSON(object) {
	    switch (object) {
	        case 0:
	        case "COMPRESSION_DEFLATE":
	            return Compression.COMPRESSION_DEFLATE;
	        case 1:
	        case "COMPRESSION_GZIP":
	            return Compression.COMPRESSION_GZIP;
	        case -1:
	        case "UNRECOGNIZED":
	        default:
	            return Compression.UNRECOGNIZED;
	    }
	}
	function compressionToJSON(object) {
	    switch (object) {
	        case Compression.COMPRESSION_DEFLATE:
	            return "COMPRESSION_DEFLATE";
	        case Compression.COMPRESSION_GZIP:
	            return "COMPRESSION_GZIP";
	        case Compression.UNRECOGNIZED:
	        default:
	            return "UNRECOGNIZED";
	    }
	}
	function createBaseContentTypeId() {
	    return { authorityId: "", typeId: "", versionMajor: 0, versionMinor: 0 };
	}
	const ContentTypeId = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.authorityId !== "") {
	            writer.uint32(10).string(message.authorityId);
	        }
	        if (message.typeId !== "") {
	            writer.uint32(18).string(message.typeId);
	        }
	        if (message.versionMajor !== 0) {
	            writer.uint32(24).uint32(message.versionMajor);
	        }
	        if (message.versionMinor !== 0) {
	            writer.uint32(32).uint32(message.versionMinor);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseContentTypeId();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.authorityId = reader.string();
	                    break;
	                case 2:
	                    message.typeId = reader.string();
	                    break;
	                case 3:
	                    message.versionMajor = reader.uint32();
	                    break;
	                case 4:
	                    message.versionMinor = reader.uint32();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            authorityId: isSet$4(object.authorityId) ? String(object.authorityId) : "",
	            typeId: isSet$4(object.typeId) ? String(object.typeId) : "",
	            versionMajor: isSet$4(object.versionMajor)
	                ? Number(object.versionMajor)
	                : 0,
	            versionMinor: isSet$4(object.versionMinor)
	                ? Number(object.versionMinor)
	                : 0,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.authorityId !== undefined &&
	            (obj.authorityId = message.authorityId);
	        message.typeId !== undefined && (obj.typeId = message.typeId);
	        message.versionMajor !== undefined &&
	            (obj.versionMajor = Math.round(message.versionMajor));
	        message.versionMinor !== undefined &&
	            (obj.versionMinor = Math.round(message.versionMinor));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b, _c, _d;
	        const message = createBaseContentTypeId();
	        message.authorityId = (_a = object.authorityId) !== null && _a !== void 0 ? _a : "";
	        message.typeId = (_b = object.typeId) !== null && _b !== void 0 ? _b : "";
	        message.versionMajor = (_c = object.versionMajor) !== null && _c !== void 0 ? _c : 0;
	        message.versionMinor = (_d = object.versionMinor) !== null && _d !== void 0 ? _d : 0;
	        return message;
	    },
	};
	function createBaseEncodedContent() {
	    return {
	        type: undefined,
	        parameters: {},
	        fallback: undefined,
	        compression: undefined,
	        content: new Uint8Array(),
	    };
	}
	const EncodedContent = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.type !== undefined) {
	            ContentTypeId.encode(message.type, writer.uint32(10).fork()).ldelim();
	        }
	        Object.entries(message.parameters).forEach(([key, value]) => {
	            EncodedContent_ParametersEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
	        });
	        if (message.fallback !== undefined) {
	            writer.uint32(26).string(message.fallback);
	        }
	        if (message.compression !== undefined) {
	            writer.uint32(40).int32(message.compression);
	        }
	        if (message.content.length !== 0) {
	            writer.uint32(34).bytes(message.content);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseEncodedContent();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.type = ContentTypeId.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    const entry2 = EncodedContent_ParametersEntry.decode(reader, reader.uint32());
	                    if (entry2.value !== undefined) {
	                        message.parameters[entry2.key] = entry2.value;
	                    }
	                    break;
	                case 3:
	                    message.fallback = reader.string();
	                    break;
	                case 5:
	                    message.compression = reader.int32();
	                    break;
	                case 4:
	                    message.content = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            type: isSet$4(object.type)
	                ? ContentTypeId.fromJSON(object.type)
	                : undefined,
	            parameters: isObject$4(object.parameters)
	                ? Object.entries(object.parameters).reduce((acc, [key, value]) => {
	                    acc[key] = String(value);
	                    return acc;
	                }, {})
	                : {},
	            fallback: isSet$4(object.fallback) ? String(object.fallback) : undefined,
	            compression: isSet$4(object.compression)
	                ? compressionFromJSON(object.compression)
	                : undefined,
	            content: isSet$4(object.content)
	                ? bytesFromBase64$2(object.content)
	                : new Uint8Array(),
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.type !== undefined &&
	            (obj.type = message.type
	                ? ContentTypeId.toJSON(message.type)
	                : undefined);
	        obj.parameters = {};
	        if (message.parameters) {
	            Object.entries(message.parameters).forEach(([k, v]) => {
	                obj.parameters[k] = v;
	            });
	        }
	        message.fallback !== undefined && (obj.fallback = message.fallback);
	        message.compression !== undefined &&
	            (obj.compression =
	                message.compression !== undefined
	                    ? compressionToJSON(message.compression)
	                    : undefined);
	        message.content !== undefined &&
	            (obj.content = base64FromBytes$2(message.content !== undefined ? message.content : new Uint8Array()));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b, _c, _d;
	        const message = createBaseEncodedContent();
	        message.type =
	            object.type !== undefined && object.type !== null
	                ? ContentTypeId.fromPartial(object.type)
	                : undefined;
	        message.parameters = Object.entries((_a = object.parameters) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
	            if (value !== undefined) {
	                acc[key] = String(value);
	            }
	            return acc;
	        }, {});
	        message.fallback = (_b = object.fallback) !== null && _b !== void 0 ? _b : undefined;
	        message.compression = (_c = object.compression) !== null && _c !== void 0 ? _c : undefined;
	        message.content = (_d = object.content) !== null && _d !== void 0 ? _d : new Uint8Array();
	        return message;
	    },
	};
	function createBaseEncodedContent_ParametersEntry() {
	    return { key: "", value: "" };
	}
	const EncodedContent_ParametersEntry = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.key !== "") {
	            writer.uint32(10).string(message.key);
	        }
	        if (message.value !== "") {
	            writer.uint32(18).string(message.value);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseEncodedContent_ParametersEntry();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.key = reader.string();
	                    break;
	                case 2:
	                    message.value = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            key: isSet$4(object.key) ? String(object.key) : "",
	            value: isSet$4(object.value) ? String(object.value) : "",
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.key !== undefined && (obj.key = message.key);
	        message.value !== undefined && (obj.value = message.value);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b;
	        const message = createBaseEncodedContent_ParametersEntry();
	        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
	        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
	        return message;
	    },
	};
	function createBaseSignedContent() {
	    return { payload: new Uint8Array(), sender: undefined, signature: undefined };
	}
	const SignedContent = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.payload.length !== 0) {
	            writer.uint32(10).bytes(message.payload);
	        }
	        if (message.sender !== undefined) {
	            SignedPublicKeyBundle.encode(message.sender, writer.uint32(18).fork()).ldelim();
	        }
	        if (message.signature !== undefined) {
	            Signature$5.encode(message.signature, writer.uint32(26).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSignedContent();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.payload = reader.bytes();
	                    break;
	                case 2:
	                    message.sender = SignedPublicKeyBundle.decode(reader, reader.uint32());
	                    break;
	                case 3:
	                    message.signature = Signature$5.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            payload: isSet$4(object.payload)
	                ? bytesFromBase64$2(object.payload)
	                : new Uint8Array(),
	            sender: isSet$4(object.sender)
	                ? SignedPublicKeyBundle.fromJSON(object.sender)
	                : undefined,
	            signature: isSet$4(object.signature)
	                ? Signature$5.fromJSON(object.signature)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.payload !== undefined &&
	            (obj.payload = base64FromBytes$2(message.payload !== undefined ? message.payload : new Uint8Array()));
	        message.sender !== undefined &&
	            (obj.sender = message.sender
	                ? SignedPublicKeyBundle.toJSON(message.sender)
	                : undefined);
	        message.signature !== undefined &&
	            (obj.signature = message.signature
	                ? Signature$5.toJSON(message.signature)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseSignedContent();
	        message.payload = (_a = object.payload) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.sender =
	            object.sender !== undefined && object.sender !== null
	                ? SignedPublicKeyBundle.fromPartial(object.sender)
	                : undefined;
	        message.signature =
	            object.signature !== undefined && object.signature !== null
	                ? Signature$5.fromPartial(object.signature)
	                : undefined;
	        return message;
	    },
	};
	var globalThis$3 = (() => {
	    if (typeof globalThis$3 !== "undefined")
	        return globalThis$3;
	    if (typeof self !== "undefined")
	        return self;
	    if (typeof window !== "undefined")
	        return window;
	    if (typeof global !== "undefined")
	        return global;
	    throw "Unable to locate global object";
	})();
	function bytesFromBase64$2(b64) {
	    if (globalThis$3.Buffer) {
	        return Uint8Array.from(globalThis$3.Buffer.from(b64, "base64"));
	    }
	    else {
	        const bin = globalThis$3.atob(b64);
	        const arr = new Uint8Array(bin.length);
	        for (let i = 0; i < bin.length; ++i) {
	            arr[i] = bin.charCodeAt(i);
	        }
	        return arr;
	    }
	}
	function base64FromBytes$2(arr) {
	    if (globalThis$3.Buffer) {
	        return globalThis$3.Buffer.from(arr).toString("base64");
	    }
	    else {
	        const bin = [];
	        arr.forEach((byte) => {
	            bin.push(String.fromCharCode(byte));
	        });
	        return globalThis$3.btoa(bin.join(""));
	    }
	}
	if (_m0.util.Long !== Long) {
	    _m0.util.Long = Long;
	    _m0.configure();
	}
	function isObject$4(value) {
	    return typeof value === "object" && value !== null;
	}
	function isSet$4(value) {
	    return value !== null && value !== undefined;
	}

	/* eslint-disable */
	if (_m0.util.Long !== Long) {
	    _m0.util.Long = Long;
	    _m0.configure();
	}

	/* eslint-disable */
	function createBaseSignedPrivateKey() {
	    return { createdNs: Long.UZERO, secp256k1: undefined, publicKey: undefined };
	}
	const SignedPrivateKey = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (!message.createdNs.isZero()) {
	            writer.uint32(8).uint64(message.createdNs);
	        }
	        if (message.secp256k1 !== undefined) {
	            SignedPrivateKey_Secp256k1.encode(message.secp256k1, writer.uint32(18).fork()).ldelim();
	        }
	        if (message.publicKey !== undefined) {
	            SignedPublicKey.encode(message.publicKey, writer.uint32(26).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSignedPrivateKey();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.createdNs = reader.uint64();
	                    break;
	                case 2:
	                    message.secp256k1 = SignedPrivateKey_Secp256k1.decode(reader, reader.uint32());
	                    break;
	                case 3:
	                    message.publicKey = SignedPublicKey.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            createdNs: isSet$3(object.createdNs)
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO,
	            secp256k1: isSet$3(object.secp256k1)
	                ? SignedPrivateKey_Secp256k1.fromJSON(object.secp256k1)
	                : undefined,
	            publicKey: isSet$3(object.publicKey)
	                ? SignedPublicKey.fromJSON(object.publicKey)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.createdNs !== undefined &&
	            (obj.createdNs = (message.createdNs || Long.UZERO).toString());
	        message.secp256k1 !== undefined &&
	            (obj.secp256k1 = message.secp256k1
	                ? SignedPrivateKey_Secp256k1.toJSON(message.secp256k1)
	                : undefined);
	        message.publicKey !== undefined &&
	            (obj.publicKey = message.publicKey
	                ? SignedPublicKey.toJSON(message.publicKey)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseSignedPrivateKey();
	        message.createdNs =
	            object.createdNs !== undefined && object.createdNs !== null
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO;
	        message.secp256k1 =
	            object.secp256k1 !== undefined && object.secp256k1 !== null
	                ? SignedPrivateKey_Secp256k1.fromPartial(object.secp256k1)
	                : undefined;
	        message.publicKey =
	            object.publicKey !== undefined && object.publicKey !== null
	                ? SignedPublicKey.fromPartial(object.publicKey)
	                : undefined;
	        return message;
	    },
	};
	function createBaseSignedPrivateKey_Secp256k1() {
	    return { bytes: new Uint8Array() };
	}
	const SignedPrivateKey_Secp256k1 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.bytes.length !== 0) {
	            writer.uint32(10).bytes(message.bytes);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSignedPrivateKey_Secp256k1();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.bytes = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            bytes: isSet$3(object.bytes)
	                ? bytesFromBase64$1(object.bytes)
	                : new Uint8Array(),
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.bytes !== undefined &&
	            (obj.bytes = base64FromBytes$1(message.bytes !== undefined ? message.bytes : new Uint8Array()));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseSignedPrivateKey_Secp256k1();
	        message.bytes = (_a = object.bytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        return message;
	    },
	};
	function createBasePrivateKeyBundleV2() {
	    return { identityKey: undefined, preKeys: [] };
	}
	const PrivateKeyBundleV2 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.identityKey !== undefined) {
	            SignedPrivateKey.encode(message.identityKey, writer.uint32(10).fork()).ldelim();
	        }
	        for (const v of message.preKeys) {
	            SignedPrivateKey.encode(v, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBasePrivateKeyBundleV2();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.identityKey = SignedPrivateKey.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.preKeys.push(SignedPrivateKey.decode(reader, reader.uint32()));
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            identityKey: isSet$3(object.identityKey)
	                ? SignedPrivateKey.fromJSON(object.identityKey)
	                : undefined,
	            preKeys: Array.isArray(object === null || object === void 0 ? void 0 : object.preKeys)
	                ? object.preKeys.map((e) => SignedPrivateKey.fromJSON(e))
	                : [],
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.identityKey !== undefined &&
	            (obj.identityKey = message.identityKey
	                ? SignedPrivateKey.toJSON(message.identityKey)
	                : undefined);
	        if (message.preKeys) {
	            obj.preKeys = message.preKeys.map((e) => e ? SignedPrivateKey.toJSON(e) : undefined);
	        }
	        else {
	            obj.preKeys = [];
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBasePrivateKeyBundleV2();
	        message.identityKey =
	            object.identityKey !== undefined && object.identityKey !== null
	                ? SignedPrivateKey.fromPartial(object.identityKey)
	                : undefined;
	        message.preKeys =
	            ((_a = object.preKeys) === null || _a === void 0 ? void 0 : _a.map((e) => SignedPrivateKey.fromPartial(e))) || [];
	        return message;
	    },
	};
	function createBasePrivateKey() {
	    return { timestamp: Long.UZERO, secp256k1: undefined, publicKey: undefined };
	}
	const PrivateKey = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (!message.timestamp.isZero()) {
	            writer.uint32(8).uint64(message.timestamp);
	        }
	        if (message.secp256k1 !== undefined) {
	            PrivateKey_Secp256k1.encode(message.secp256k1, writer.uint32(18).fork()).ldelim();
	        }
	        if (message.publicKey !== undefined) {
	            PublicKey.encode(message.publicKey, writer.uint32(26).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBasePrivateKey();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.timestamp = reader.uint64();
	                    break;
	                case 2:
	                    message.secp256k1 = PrivateKey_Secp256k1.decode(reader, reader.uint32());
	                    break;
	                case 3:
	                    message.publicKey = PublicKey.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            timestamp: isSet$3(object.timestamp)
	                ? Long.fromValue(object.timestamp)
	                : Long.UZERO,
	            secp256k1: isSet$3(object.secp256k1)
	                ? PrivateKey_Secp256k1.fromJSON(object.secp256k1)
	                : undefined,
	            publicKey: isSet$3(object.publicKey)
	                ? PublicKey.fromJSON(object.publicKey)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.timestamp !== undefined &&
	            (obj.timestamp = (message.timestamp || Long.UZERO).toString());
	        message.secp256k1 !== undefined &&
	            (obj.secp256k1 = message.secp256k1
	                ? PrivateKey_Secp256k1.toJSON(message.secp256k1)
	                : undefined);
	        message.publicKey !== undefined &&
	            (obj.publicKey = message.publicKey
	                ? PublicKey.toJSON(message.publicKey)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBasePrivateKey();
	        message.timestamp =
	            object.timestamp !== undefined && object.timestamp !== null
	                ? Long.fromValue(object.timestamp)
	                : Long.UZERO;
	        message.secp256k1 =
	            object.secp256k1 !== undefined && object.secp256k1 !== null
	                ? PrivateKey_Secp256k1.fromPartial(object.secp256k1)
	                : undefined;
	        message.publicKey =
	            object.publicKey !== undefined && object.publicKey !== null
	                ? PublicKey.fromPartial(object.publicKey)
	                : undefined;
	        return message;
	    },
	};
	function createBasePrivateKey_Secp256k1() {
	    return { bytes: new Uint8Array() };
	}
	const PrivateKey_Secp256k1 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.bytes.length !== 0) {
	            writer.uint32(10).bytes(message.bytes);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBasePrivateKey_Secp256k1();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.bytes = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            bytes: isSet$3(object.bytes)
	                ? bytesFromBase64$1(object.bytes)
	                : new Uint8Array(),
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.bytes !== undefined &&
	            (obj.bytes = base64FromBytes$1(message.bytes !== undefined ? message.bytes : new Uint8Array()));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBasePrivateKey_Secp256k1();
	        message.bytes = (_a = object.bytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        return message;
	    },
	};
	function createBasePrivateKeyBundleV1() {
	    return { identityKey: undefined, preKeys: [] };
	}
	const PrivateKeyBundleV1 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.identityKey !== undefined) {
	            PrivateKey.encode(message.identityKey, writer.uint32(10).fork()).ldelim();
	        }
	        for (const v of message.preKeys) {
	            PrivateKey.encode(v, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBasePrivateKeyBundleV1();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.identityKey = PrivateKey.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.preKeys.push(PrivateKey.decode(reader, reader.uint32()));
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            identityKey: isSet$3(object.identityKey)
	                ? PrivateKey.fromJSON(object.identityKey)
	                : undefined,
	            preKeys: Array.isArray(object === null || object === void 0 ? void 0 : object.preKeys)
	                ? object.preKeys.map((e) => PrivateKey.fromJSON(e))
	                : [],
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.identityKey !== undefined &&
	            (obj.identityKey = message.identityKey
	                ? PrivateKey.toJSON(message.identityKey)
	                : undefined);
	        if (message.preKeys) {
	            obj.preKeys = message.preKeys.map((e) => e ? PrivateKey.toJSON(e) : undefined);
	        }
	        else {
	            obj.preKeys = [];
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBasePrivateKeyBundleV1();
	        message.identityKey =
	            object.identityKey !== undefined && object.identityKey !== null
	                ? PrivateKey.fromPartial(object.identityKey)
	                : undefined;
	        message.preKeys =
	            ((_a = object.preKeys) === null || _a === void 0 ? void 0 : _a.map((e) => PrivateKey.fromPartial(e))) || [];
	        return message;
	    },
	};
	function createBasePrivateKeyBundle() {
	    return { v1: undefined, v2: undefined };
	}
	const PrivateKeyBundle = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.v1 !== undefined) {
	            PrivateKeyBundleV1.encode(message.v1, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.v2 !== undefined) {
	            PrivateKeyBundleV2.encode(message.v2, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBasePrivateKeyBundle();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.v1 = PrivateKeyBundleV1.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.v2 = PrivateKeyBundleV2.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            v1: isSet$3(object.v1) ? PrivateKeyBundleV1.fromJSON(object.v1) : undefined,
	            v2: isSet$3(object.v2) ? PrivateKeyBundleV2.fromJSON(object.v2) : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.v1 !== undefined &&
	            (obj.v1 = message.v1 ? PrivateKeyBundleV1.toJSON(message.v1) : undefined);
	        message.v2 !== undefined &&
	            (obj.v2 = message.v2 ? PrivateKeyBundleV2.toJSON(message.v2) : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBasePrivateKeyBundle();
	        message.v1 =
	            object.v1 !== undefined && object.v1 !== null
	                ? PrivateKeyBundleV1.fromPartial(object.v1)
	                : undefined;
	        message.v2 =
	            object.v2 !== undefined && object.v2 !== null
	                ? PrivateKeyBundleV2.fromPartial(object.v2)
	                : undefined;
	        return message;
	    },
	};
	function createBaseEncryptedPrivateKeyBundleV1() {
	    return { walletPreKey: new Uint8Array(), ciphertext: undefined };
	}
	const EncryptedPrivateKeyBundleV1 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.walletPreKey.length !== 0) {
	            writer.uint32(10).bytes(message.walletPreKey);
	        }
	        if (message.ciphertext !== undefined) {
	            Ciphertext.encode(message.ciphertext, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseEncryptedPrivateKeyBundleV1();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.walletPreKey = reader.bytes();
	                    break;
	                case 2:
	                    message.ciphertext = Ciphertext.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            walletPreKey: isSet$3(object.walletPreKey)
	                ? bytesFromBase64$1(object.walletPreKey)
	                : new Uint8Array(),
	            ciphertext: isSet$3(object.ciphertext)
	                ? Ciphertext.fromJSON(object.ciphertext)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.walletPreKey !== undefined &&
	            (obj.walletPreKey = base64FromBytes$1(message.walletPreKey !== undefined
	                ? message.walletPreKey
	                : new Uint8Array()));
	        message.ciphertext !== undefined &&
	            (obj.ciphertext = message.ciphertext
	                ? Ciphertext.toJSON(message.ciphertext)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseEncryptedPrivateKeyBundleV1();
	        message.walletPreKey = (_a = object.walletPreKey) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.ciphertext =
	            object.ciphertext !== undefined && object.ciphertext !== null
	                ? Ciphertext.fromPartial(object.ciphertext)
	                : undefined;
	        return message;
	    },
	};
	function createBaseEncryptedPrivateKeyBundle() {
	    return { v1: undefined };
	}
	const EncryptedPrivateKeyBundle = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.v1 !== undefined) {
	            EncryptedPrivateKeyBundleV1.encode(message.v1, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseEncryptedPrivateKeyBundle();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.v1 = EncryptedPrivateKeyBundleV1.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            v1: isSet$3(object.v1)
	                ? EncryptedPrivateKeyBundleV1.fromJSON(object.v1)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.v1 !== undefined &&
	            (obj.v1 = message.v1
	                ? EncryptedPrivateKeyBundleV1.toJSON(message.v1)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseEncryptedPrivateKeyBundle();
	        message.v1 =
	            object.v1 !== undefined && object.v1 !== null
	                ? EncryptedPrivateKeyBundleV1.fromPartial(object.v1)
	                : undefined;
	        return message;
	    },
	};
	var globalThis$2 = (() => {
	    if (typeof globalThis$2 !== "undefined")
	        return globalThis$2;
	    if (typeof self !== "undefined")
	        return self;
	    if (typeof window !== "undefined")
	        return window;
	    if (typeof global !== "undefined")
	        return global;
	    throw "Unable to locate global object";
	})();
	function bytesFromBase64$1(b64) {
	    if (globalThis$2.Buffer) {
	        return Uint8Array.from(globalThis$2.Buffer.from(b64, "base64"));
	    }
	    else {
	        const bin = globalThis$2.atob(b64);
	        const arr = new Uint8Array(bin.length);
	        for (let i = 0; i < bin.length; ++i) {
	            arr[i] = bin.charCodeAt(i);
	        }
	        return arr;
	    }
	}
	function base64FromBytes$1(arr) {
	    if (globalThis$2.Buffer) {
	        return globalThis$2.Buffer.from(arr).toString("base64");
	    }
	    else {
	        const bin = [];
	        arr.forEach((byte) => {
	            bin.push(String.fromCharCode(byte));
	        });
	        return globalThis$2.btoa(bin.join(""));
	    }
	}
	if (_m0.util.Long !== Long) {
	    _m0.util.Long = Long;
	    _m0.configure();
	}
	function isSet$3(value) {
	    return value !== null && value !== undefined;
	}

	/* eslint-disable */
	function createBaseContactBundleV1() {
	    return { keyBundle: undefined };
	}
	const ContactBundleV1 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.keyBundle !== undefined) {
	            PublicKeyBundle.encode(message.keyBundle, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseContactBundleV1();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.keyBundle = PublicKeyBundle.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            keyBundle: isSet$2(object.keyBundle)
	                ? PublicKeyBundle.fromJSON(object.keyBundle)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.keyBundle !== undefined &&
	            (obj.keyBundle = message.keyBundle
	                ? PublicKeyBundle.toJSON(message.keyBundle)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseContactBundleV1();
	        message.keyBundle =
	            object.keyBundle !== undefined && object.keyBundle !== null
	                ? PublicKeyBundle.fromPartial(object.keyBundle)
	                : undefined;
	        return message;
	    },
	};
	function createBaseContactBundleV2() {
	    return { keyBundle: undefined };
	}
	const ContactBundleV2 = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.keyBundle !== undefined) {
	            SignedPublicKeyBundle.encode(message.keyBundle, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseContactBundleV2();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.keyBundle = SignedPublicKeyBundle.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            keyBundle: isSet$2(object.keyBundle)
	                ? SignedPublicKeyBundle.fromJSON(object.keyBundle)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.keyBundle !== undefined &&
	            (obj.keyBundle = message.keyBundle
	                ? SignedPublicKeyBundle.toJSON(message.keyBundle)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseContactBundleV2();
	        message.keyBundle =
	            object.keyBundle !== undefined && object.keyBundle !== null
	                ? SignedPublicKeyBundle.fromPartial(object.keyBundle)
	                : undefined;
	        return message;
	    },
	};
	function createBaseContactBundle() {
	    return { v1: undefined, v2: undefined };
	}
	const ContactBundle = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.v1 !== undefined) {
	            ContactBundleV1.encode(message.v1, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.v2 !== undefined) {
	            ContactBundleV2.encode(message.v2, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseContactBundle();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.v1 = ContactBundleV1.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.v2 = ContactBundleV2.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            v1: isSet$2(object.v1) ? ContactBundleV1.fromJSON(object.v1) : undefined,
	            v2: isSet$2(object.v2) ? ContactBundleV2.fromJSON(object.v2) : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.v1 !== undefined &&
	            (obj.v1 = message.v1 ? ContactBundleV1.toJSON(message.v1) : undefined);
	        message.v2 !== undefined &&
	            (obj.v2 = message.v2 ? ContactBundleV2.toJSON(message.v2) : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseContactBundle();
	        message.v1 =
	            object.v1 !== undefined && object.v1 !== null
	                ? ContactBundleV1.fromPartial(object.v1)
	                : undefined;
	        message.v2 =
	            object.v2 !== undefined && object.v2 !== null
	                ? ContactBundleV2.fromPartial(object.v2)
	                : undefined;
	        return message;
	    },
	};
	if (_m0.util.Long !== Long) {
	    _m0.util.Long = Long;
	    _m0.configure();
	}
	function isSet$2(value) {
	    return value !== null && value !== undefined;
	}

	/* eslint-disable */
	const protobufPackage = "xmtp.keystore_api.v1";
	/** Message content encoding structures */
	/** Application-specific error codes for the Keystore API. */
	var ErrorCode;
	(function (ErrorCode) {
	    ErrorCode[ErrorCode["ERROR_CODE_UNSPECIFIED"] = 0] = "ERROR_CODE_UNSPECIFIED";
	    ErrorCode[ErrorCode["ERROR_CODE_INVALID_INPUT"] = 1] = "ERROR_CODE_INVALID_INPUT";
	    ErrorCode[ErrorCode["ERROR_CODE_NO_MATCHING_PREKEY"] = 2] = "ERROR_CODE_NO_MATCHING_PREKEY";
	    ErrorCode[ErrorCode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
	})(ErrorCode || (ErrorCode = {}));
	function errorCodeFromJSON(object) {
	    switch (object) {
	        case 0:
	        case "ERROR_CODE_UNSPECIFIED":
	            return ErrorCode.ERROR_CODE_UNSPECIFIED;
	        case 1:
	        case "ERROR_CODE_INVALID_INPUT":
	            return ErrorCode.ERROR_CODE_INVALID_INPUT;
	        case 2:
	        case "ERROR_CODE_NO_MATCHING_PREKEY":
	            return ErrorCode.ERROR_CODE_NO_MATCHING_PREKEY;
	        case -1:
	        case "UNRECOGNIZED":
	        default:
	            return ErrorCode.UNRECOGNIZED;
	    }
	}
	function errorCodeToJSON(object) {
	    switch (object) {
	        case ErrorCode.ERROR_CODE_UNSPECIFIED:
	            return "ERROR_CODE_UNSPECIFIED";
	        case ErrorCode.ERROR_CODE_INVALID_INPUT:
	            return "ERROR_CODE_INVALID_INPUT";
	        case ErrorCode.ERROR_CODE_NO_MATCHING_PREKEY:
	            return "ERROR_CODE_NO_MATCHING_PREKEY";
	        case ErrorCode.UNRECOGNIZED:
	        default:
	            return "UNRECOGNIZED";
	    }
	}
	/** Status of the Keystore for the specified wallet address */
	var GetKeystoreStatusResponse_KeystoreStatus;
	(function (GetKeystoreStatusResponse_KeystoreStatus) {
	    GetKeystoreStatusResponse_KeystoreStatus[GetKeystoreStatusResponse_KeystoreStatus["KEYSTORE_STATUS_UNSPECIFIED"] = 0] = "KEYSTORE_STATUS_UNSPECIFIED";
	    GetKeystoreStatusResponse_KeystoreStatus[GetKeystoreStatusResponse_KeystoreStatus["KEYSTORE_STATUS_UNINITIALIZED"] = 1] = "KEYSTORE_STATUS_UNINITIALIZED";
	    GetKeystoreStatusResponse_KeystoreStatus[GetKeystoreStatusResponse_KeystoreStatus["KEYSTORE_STATUS_INITIALIZED"] = 2] = "KEYSTORE_STATUS_INITIALIZED";
	    GetKeystoreStatusResponse_KeystoreStatus[GetKeystoreStatusResponse_KeystoreStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
	})(GetKeystoreStatusResponse_KeystoreStatus || (GetKeystoreStatusResponse_KeystoreStatus = {}));
	function getKeystoreStatusResponse_KeystoreStatusFromJSON(object) {
	    switch (object) {
	        case 0:
	        case "KEYSTORE_STATUS_UNSPECIFIED":
	            return GetKeystoreStatusResponse_KeystoreStatus.KEYSTORE_STATUS_UNSPECIFIED;
	        case 1:
	        case "KEYSTORE_STATUS_UNINITIALIZED":
	            return GetKeystoreStatusResponse_KeystoreStatus.KEYSTORE_STATUS_UNINITIALIZED;
	        case 2:
	        case "KEYSTORE_STATUS_INITIALIZED":
	            return GetKeystoreStatusResponse_KeystoreStatus.KEYSTORE_STATUS_INITIALIZED;
	        case -1:
	        case "UNRECOGNIZED":
	        default:
	            return GetKeystoreStatusResponse_KeystoreStatus.UNRECOGNIZED;
	    }
	}
	function getKeystoreStatusResponse_KeystoreStatusToJSON(object) {
	    switch (object) {
	        case GetKeystoreStatusResponse_KeystoreStatus.KEYSTORE_STATUS_UNSPECIFIED:
	            return "KEYSTORE_STATUS_UNSPECIFIED";
	        case GetKeystoreStatusResponse_KeystoreStatus.KEYSTORE_STATUS_UNINITIALIZED:
	            return "KEYSTORE_STATUS_UNINITIALIZED";
	        case GetKeystoreStatusResponse_KeystoreStatus.KEYSTORE_STATUS_INITIALIZED:
	            return "KEYSTORE_STATUS_INITIALIZED";
	        case GetKeystoreStatusResponse_KeystoreStatus.UNRECOGNIZED:
	        default:
	            return "UNRECOGNIZED";
	    }
	}
	function createBaseKeystoreError() {
	    return { message: "", code: 0 };
	}
	const KeystoreError = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.message !== "") {
	            writer.uint32(10).string(message.message);
	        }
	        if (message.code !== 0) {
	            writer.uint32(16).int32(message.code);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseKeystoreError();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.message = reader.string();
	                    break;
	                case 2:
	                    message.code = reader.int32();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            message: isSet$1(object.message) ? String(object.message) : "",
	            code: isSet$1(object.code) ? errorCodeFromJSON(object.code) : 0,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.message !== undefined && (obj.message = message.message);
	        message.code !== undefined && (obj.code = errorCodeToJSON(message.code));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b;
	        const message = createBaseKeystoreError();
	        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
	        message.code = (_b = object.code) !== null && _b !== void 0 ? _b : 0;
	        return message;
	    },
	};
	function createBaseDecryptV1Request() {
	    return { requests: [] };
	}
	const DecryptV1Request = {
	    encode(message, writer = _m0.Writer.create()) {
	        for (const v of message.requests) {
	            DecryptV1Request_Request.encode(v, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseDecryptV1Request();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.requests.push(DecryptV1Request_Request.decode(reader, reader.uint32()));
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            requests: Array.isArray(object === null || object === void 0 ? void 0 : object.requests)
	                ? object.requests.map((e) => DecryptV1Request_Request.fromJSON(e))
	                : [],
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        if (message.requests) {
	            obj.requests = message.requests.map((e) => e ? DecryptV1Request_Request.toJSON(e) : undefined);
	        }
	        else {
	            obj.requests = [];
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseDecryptV1Request();
	        message.requests =
	            ((_a = object.requests) === null || _a === void 0 ? void 0 : _a.map((e) => DecryptV1Request_Request.fromPartial(e))) ||
	                [];
	        return message;
	    },
	};
	function createBaseDecryptV1Request_Request() {
	    return {
	        payload: undefined,
	        peerKeys: undefined,
	        headerBytes: new Uint8Array(),
	        isSender: false,
	    };
	}
	const DecryptV1Request_Request = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.payload !== undefined) {
	            Ciphertext.encode(message.payload, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.peerKeys !== undefined) {
	            PublicKeyBundle.encode(message.peerKeys, writer.uint32(18).fork()).ldelim();
	        }
	        if (message.headerBytes.length !== 0) {
	            writer.uint32(26).bytes(message.headerBytes);
	        }
	        if (message.isSender === true) {
	            writer.uint32(32).bool(message.isSender);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseDecryptV1Request_Request();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.payload = Ciphertext.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.peerKeys = PublicKeyBundle.decode(reader, reader.uint32());
	                    break;
	                case 3:
	                    message.headerBytes = reader.bytes();
	                    break;
	                case 4:
	                    message.isSender = reader.bool();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            payload: isSet$1(object.payload)
	                ? Ciphertext.fromJSON(object.payload)
	                : undefined,
	            peerKeys: isSet$1(object.peerKeys)
	                ? PublicKeyBundle.fromJSON(object.peerKeys)
	                : undefined,
	            headerBytes: isSet$1(object.headerBytes)
	                ? bytesFromBase64(object.headerBytes)
	                : new Uint8Array(),
	            isSender: isSet$1(object.isSender) ? Boolean(object.isSender) : false,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.payload !== undefined &&
	            (obj.payload = message.payload
	                ? Ciphertext.toJSON(message.payload)
	                : undefined);
	        message.peerKeys !== undefined &&
	            (obj.peerKeys = message.peerKeys
	                ? PublicKeyBundle.toJSON(message.peerKeys)
	                : undefined);
	        message.headerBytes !== undefined &&
	            (obj.headerBytes = base64FromBytes(message.headerBytes !== undefined
	                ? message.headerBytes
	                : new Uint8Array()));
	        message.isSender !== undefined && (obj.isSender = message.isSender);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b;
	        const message = createBaseDecryptV1Request_Request();
	        message.payload =
	            object.payload !== undefined && object.payload !== null
	                ? Ciphertext.fromPartial(object.payload)
	                : undefined;
	        message.peerKeys =
	            object.peerKeys !== undefined && object.peerKeys !== null
	                ? PublicKeyBundle.fromPartial(object.peerKeys)
	                : undefined;
	        message.headerBytes = (_a = object.headerBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.isSender = (_b = object.isSender) !== null && _b !== void 0 ? _b : false;
	        return message;
	    },
	};
	function createBaseDecryptResponse() {
	    return { responses: [] };
	}
	const DecryptResponse = {
	    encode(message, writer = _m0.Writer.create()) {
	        for (const v of message.responses) {
	            DecryptResponse_Response.encode(v, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseDecryptResponse();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.responses.push(DecryptResponse_Response.decode(reader, reader.uint32()));
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            responses: Array.isArray(object === null || object === void 0 ? void 0 : object.responses)
	                ? object.responses.map((e) => DecryptResponse_Response.fromJSON(e))
	                : [],
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        if (message.responses) {
	            obj.responses = message.responses.map((e) => e ? DecryptResponse_Response.toJSON(e) : undefined);
	        }
	        else {
	            obj.responses = [];
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseDecryptResponse();
	        message.responses =
	            ((_a = object.responses) === null || _a === void 0 ? void 0 : _a.map((e) => DecryptResponse_Response.fromPartial(e))) ||
	                [];
	        return message;
	    },
	};
	function createBaseDecryptResponse_Response() {
	    return { result: undefined, error: undefined };
	}
	const DecryptResponse_Response = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.result !== undefined) {
	            DecryptResponse_Response_Success.encode(message.result, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.error !== undefined) {
	            KeystoreError.encode(message.error, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseDecryptResponse_Response();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.result = DecryptResponse_Response_Success.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.error = KeystoreError.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            result: isSet$1(object.result)
	                ? DecryptResponse_Response_Success.fromJSON(object.result)
	                : undefined,
	            error: isSet$1(object.error)
	                ? KeystoreError.fromJSON(object.error)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.result !== undefined &&
	            (obj.result = message.result
	                ? DecryptResponse_Response_Success.toJSON(message.result)
	                : undefined);
	        message.error !== undefined &&
	            (obj.error = message.error
	                ? KeystoreError.toJSON(message.error)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseDecryptResponse_Response();
	        message.result =
	            object.result !== undefined && object.result !== null
	                ? DecryptResponse_Response_Success.fromPartial(object.result)
	                : undefined;
	        message.error =
	            object.error !== undefined && object.error !== null
	                ? KeystoreError.fromPartial(object.error)
	                : undefined;
	        return message;
	    },
	};
	function createBaseDecryptResponse_Response_Success() {
	    return { decrypted: new Uint8Array() };
	}
	const DecryptResponse_Response_Success = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.decrypted.length !== 0) {
	            writer.uint32(10).bytes(message.decrypted);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseDecryptResponse_Response_Success();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.decrypted = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            decrypted: isSet$1(object.decrypted)
	                ? bytesFromBase64(object.decrypted)
	                : new Uint8Array(),
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.decrypted !== undefined &&
	            (obj.decrypted = base64FromBytes(message.decrypted !== undefined ? message.decrypted : new Uint8Array()));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseDecryptResponse_Response_Success();
	        message.decrypted = (_a = object.decrypted) !== null && _a !== void 0 ? _a : new Uint8Array();
	        return message;
	    },
	};
	function createBaseDecryptV2Request() {
	    return { requests: [] };
	}
	const DecryptV2Request = {
	    encode(message, writer = _m0.Writer.create()) {
	        for (const v of message.requests) {
	            DecryptV2Request_Request.encode(v, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseDecryptV2Request();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.requests.push(DecryptV2Request_Request.decode(reader, reader.uint32()));
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            requests: Array.isArray(object === null || object === void 0 ? void 0 : object.requests)
	                ? object.requests.map((e) => DecryptV2Request_Request.fromJSON(e))
	                : [],
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        if (message.requests) {
	            obj.requests = message.requests.map((e) => e ? DecryptV2Request_Request.toJSON(e) : undefined);
	        }
	        else {
	            obj.requests = [];
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseDecryptV2Request();
	        message.requests =
	            ((_a = object.requests) === null || _a === void 0 ? void 0 : _a.map((e) => DecryptV2Request_Request.fromPartial(e))) ||
	                [];
	        return message;
	    },
	};
	function createBaseDecryptV2Request_Request() {
	    return {
	        payload: undefined,
	        headerBytes: new Uint8Array(),
	        contentTopic: "",
	    };
	}
	const DecryptV2Request_Request = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.payload !== undefined) {
	            Ciphertext.encode(message.payload, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.headerBytes.length !== 0) {
	            writer.uint32(18).bytes(message.headerBytes);
	        }
	        if (message.contentTopic !== "") {
	            writer.uint32(26).string(message.contentTopic);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseDecryptV2Request_Request();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.payload = Ciphertext.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.headerBytes = reader.bytes();
	                    break;
	                case 3:
	                    message.contentTopic = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            payload: isSet$1(object.payload)
	                ? Ciphertext.fromJSON(object.payload)
	                : undefined,
	            headerBytes: isSet$1(object.headerBytes)
	                ? bytesFromBase64(object.headerBytes)
	                : new Uint8Array(),
	            contentTopic: isSet$1(object.contentTopic)
	                ? String(object.contentTopic)
	                : "",
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.payload !== undefined &&
	            (obj.payload = message.payload
	                ? Ciphertext.toJSON(message.payload)
	                : undefined);
	        message.headerBytes !== undefined &&
	            (obj.headerBytes = base64FromBytes(message.headerBytes !== undefined
	                ? message.headerBytes
	                : new Uint8Array()));
	        message.contentTopic !== undefined &&
	            (obj.contentTopic = message.contentTopic);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b;
	        const message = createBaseDecryptV2Request_Request();
	        message.payload =
	            object.payload !== undefined && object.payload !== null
	                ? Ciphertext.fromPartial(object.payload)
	                : undefined;
	        message.headerBytes = (_a = object.headerBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.contentTopic = (_b = object.contentTopic) !== null && _b !== void 0 ? _b : "";
	        return message;
	    },
	};
	function createBaseEncryptV1Request() {
	    return { requests: [] };
	}
	const EncryptV1Request = {
	    encode(message, writer = _m0.Writer.create()) {
	        for (const v of message.requests) {
	            EncryptV1Request_Request.encode(v, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseEncryptV1Request();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.requests.push(EncryptV1Request_Request.decode(reader, reader.uint32()));
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            requests: Array.isArray(object === null || object === void 0 ? void 0 : object.requests)
	                ? object.requests.map((e) => EncryptV1Request_Request.fromJSON(e))
	                : [],
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        if (message.requests) {
	            obj.requests = message.requests.map((e) => e ? EncryptV1Request_Request.toJSON(e) : undefined);
	        }
	        else {
	            obj.requests = [];
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseEncryptV1Request();
	        message.requests =
	            ((_a = object.requests) === null || _a === void 0 ? void 0 : _a.map((e) => EncryptV1Request_Request.fromPartial(e))) ||
	                [];
	        return message;
	    },
	};
	function createBaseEncryptV1Request_Request() {
	    return {
	        recipient: undefined,
	        payload: new Uint8Array(),
	        headerBytes: new Uint8Array(),
	    };
	}
	const EncryptV1Request_Request = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.recipient !== undefined) {
	            PublicKeyBundle.encode(message.recipient, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.payload.length !== 0) {
	            writer.uint32(18).bytes(message.payload);
	        }
	        if (message.headerBytes.length !== 0) {
	            writer.uint32(26).bytes(message.headerBytes);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseEncryptV1Request_Request();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.recipient = PublicKeyBundle.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.payload = reader.bytes();
	                    break;
	                case 3:
	                    message.headerBytes = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            recipient: isSet$1(object.recipient)
	                ? PublicKeyBundle.fromJSON(object.recipient)
	                : undefined,
	            payload: isSet$1(object.payload)
	                ? bytesFromBase64(object.payload)
	                : new Uint8Array(),
	            headerBytes: isSet$1(object.headerBytes)
	                ? bytesFromBase64(object.headerBytes)
	                : new Uint8Array(),
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.recipient !== undefined &&
	            (obj.recipient = message.recipient
	                ? PublicKeyBundle.toJSON(message.recipient)
	                : undefined);
	        message.payload !== undefined &&
	            (obj.payload = base64FromBytes(message.payload !== undefined ? message.payload : new Uint8Array()));
	        message.headerBytes !== undefined &&
	            (obj.headerBytes = base64FromBytes(message.headerBytes !== undefined
	                ? message.headerBytes
	                : new Uint8Array()));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b;
	        const message = createBaseEncryptV1Request_Request();
	        message.recipient =
	            object.recipient !== undefined && object.recipient !== null
	                ? PublicKeyBundle.fromPartial(object.recipient)
	                : undefined;
	        message.payload = (_a = object.payload) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.headerBytes = (_b = object.headerBytes) !== null && _b !== void 0 ? _b : new Uint8Array();
	        return message;
	    },
	};
	function createBaseEncryptResponse() {
	    return { responses: [] };
	}
	const EncryptResponse = {
	    encode(message, writer = _m0.Writer.create()) {
	        for (const v of message.responses) {
	            EncryptResponse_Response.encode(v, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseEncryptResponse();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.responses.push(EncryptResponse_Response.decode(reader, reader.uint32()));
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            responses: Array.isArray(object === null || object === void 0 ? void 0 : object.responses)
	                ? object.responses.map((e) => EncryptResponse_Response.fromJSON(e))
	                : [],
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        if (message.responses) {
	            obj.responses = message.responses.map((e) => e ? EncryptResponse_Response.toJSON(e) : undefined);
	        }
	        else {
	            obj.responses = [];
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseEncryptResponse();
	        message.responses =
	            ((_a = object.responses) === null || _a === void 0 ? void 0 : _a.map((e) => EncryptResponse_Response.fromPartial(e))) ||
	                [];
	        return message;
	    },
	};
	function createBaseEncryptResponse_Response() {
	    return { result: undefined, error: undefined };
	}
	const EncryptResponse_Response = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.result !== undefined) {
	            EncryptResponse_Response_Success.encode(message.result, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.error !== undefined) {
	            KeystoreError.encode(message.error, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseEncryptResponse_Response();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.result = EncryptResponse_Response_Success.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.error = KeystoreError.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            result: isSet$1(object.result)
	                ? EncryptResponse_Response_Success.fromJSON(object.result)
	                : undefined,
	            error: isSet$1(object.error)
	                ? KeystoreError.fromJSON(object.error)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.result !== undefined &&
	            (obj.result = message.result
	                ? EncryptResponse_Response_Success.toJSON(message.result)
	                : undefined);
	        message.error !== undefined &&
	            (obj.error = message.error
	                ? KeystoreError.toJSON(message.error)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseEncryptResponse_Response();
	        message.result =
	            object.result !== undefined && object.result !== null
	                ? EncryptResponse_Response_Success.fromPartial(object.result)
	                : undefined;
	        message.error =
	            object.error !== undefined && object.error !== null
	                ? KeystoreError.fromPartial(object.error)
	                : undefined;
	        return message;
	    },
	};
	function createBaseEncryptResponse_Response_Success() {
	    return { encrypted: undefined };
	}
	const EncryptResponse_Response_Success = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.encrypted !== undefined) {
	            Ciphertext.encode(message.encrypted, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseEncryptResponse_Response_Success();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.encrypted = Ciphertext.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            encrypted: isSet$1(object.encrypted)
	                ? Ciphertext.fromJSON(object.encrypted)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.encrypted !== undefined &&
	            (obj.encrypted = message.encrypted
	                ? Ciphertext.toJSON(message.encrypted)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseEncryptResponse_Response_Success();
	        message.encrypted =
	            object.encrypted !== undefined && object.encrypted !== null
	                ? Ciphertext.fromPartial(object.encrypted)
	                : undefined;
	        return message;
	    },
	};
	function createBaseEncryptV2Request() {
	    return { requests: [] };
	}
	const EncryptV2Request = {
	    encode(message, writer = _m0.Writer.create()) {
	        for (const v of message.requests) {
	            EncryptV2Request_Request.encode(v, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseEncryptV2Request();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.requests.push(EncryptV2Request_Request.decode(reader, reader.uint32()));
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            requests: Array.isArray(object === null || object === void 0 ? void 0 : object.requests)
	                ? object.requests.map((e) => EncryptV2Request_Request.fromJSON(e))
	                : [],
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        if (message.requests) {
	            obj.requests = message.requests.map((e) => e ? EncryptV2Request_Request.toJSON(e) : undefined);
	        }
	        else {
	            obj.requests = [];
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseEncryptV2Request();
	        message.requests =
	            ((_a = object.requests) === null || _a === void 0 ? void 0 : _a.map((e) => EncryptV2Request_Request.fromPartial(e))) ||
	                [];
	        return message;
	    },
	};
	function createBaseEncryptV2Request_Request() {
	    return {
	        payload: new Uint8Array(),
	        headerBytes: new Uint8Array(),
	        contentTopic: "",
	    };
	}
	const EncryptV2Request_Request = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.payload.length !== 0) {
	            writer.uint32(10).bytes(message.payload);
	        }
	        if (message.headerBytes.length !== 0) {
	            writer.uint32(18).bytes(message.headerBytes);
	        }
	        if (message.contentTopic !== "") {
	            writer.uint32(26).string(message.contentTopic);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseEncryptV2Request_Request();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.payload = reader.bytes();
	                    break;
	                case 2:
	                    message.headerBytes = reader.bytes();
	                    break;
	                case 3:
	                    message.contentTopic = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            payload: isSet$1(object.payload)
	                ? bytesFromBase64(object.payload)
	                : new Uint8Array(),
	            headerBytes: isSet$1(object.headerBytes)
	                ? bytesFromBase64(object.headerBytes)
	                : new Uint8Array(),
	            contentTopic: isSet$1(object.contentTopic)
	                ? String(object.contentTopic)
	                : "",
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.payload !== undefined &&
	            (obj.payload = base64FromBytes(message.payload !== undefined ? message.payload : new Uint8Array()));
	        message.headerBytes !== undefined &&
	            (obj.headerBytes = base64FromBytes(message.headerBytes !== undefined
	                ? message.headerBytes
	                : new Uint8Array()));
	        message.contentTopic !== undefined &&
	            (obj.contentTopic = message.contentTopic);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b, _c;
	        const message = createBaseEncryptV2Request_Request();
	        message.payload = (_a = object.payload) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.headerBytes = (_b = object.headerBytes) !== null && _b !== void 0 ? _b : new Uint8Array();
	        message.contentTopic = (_c = object.contentTopic) !== null && _c !== void 0 ? _c : "";
	        return message;
	    },
	};
	function createBaseCreateInviteRequest() {
	    return { context: undefined, recipient: undefined, createdNs: Long.UZERO };
	}
	const CreateInviteRequest = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.context !== undefined) {
	            InvitationV1_Context.encode(message.context, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.recipient !== undefined) {
	            SignedPublicKeyBundle.encode(message.recipient, writer.uint32(18).fork()).ldelim();
	        }
	        if (!message.createdNs.isZero()) {
	            writer.uint32(24).uint64(message.createdNs);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseCreateInviteRequest();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.context = InvitationV1_Context.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.recipient = SignedPublicKeyBundle.decode(reader, reader.uint32());
	                    break;
	                case 3:
	                    message.createdNs = reader.uint64();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            context: isSet$1(object.context)
	                ? InvitationV1_Context.fromJSON(object.context)
	                : undefined,
	            recipient: isSet$1(object.recipient)
	                ? SignedPublicKeyBundle.fromJSON(object.recipient)
	                : undefined,
	            createdNs: isSet$1(object.createdNs)
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.context !== undefined &&
	            (obj.context = message.context
	                ? InvitationV1_Context.toJSON(message.context)
	                : undefined);
	        message.recipient !== undefined &&
	            (obj.recipient = message.recipient
	                ? SignedPublicKeyBundle.toJSON(message.recipient)
	                : undefined);
	        message.createdNs !== undefined &&
	            (obj.createdNs = (message.createdNs || Long.UZERO).toString());
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseCreateInviteRequest();
	        message.context =
	            object.context !== undefined && object.context !== null
	                ? InvitationV1_Context.fromPartial(object.context)
	                : undefined;
	        message.recipient =
	            object.recipient !== undefined && object.recipient !== null
	                ? SignedPublicKeyBundle.fromPartial(object.recipient)
	                : undefined;
	        message.createdNs =
	            object.createdNs !== undefined && object.createdNs !== null
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO;
	        return message;
	    },
	};
	function createBaseCreateInviteFromTopicRequest() {
	    return { recipient: undefined, contentTopic: "", createdNs: Long.UZERO };
	}
	const CreateInviteFromTopicRequest = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.recipient !== undefined) {
	            SignedPublicKeyBundle.encode(message.recipient, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.contentTopic !== "") {
	            writer.uint32(18).string(message.contentTopic);
	        }
	        if (!message.createdNs.isZero()) {
	            writer.uint32(24).uint64(message.createdNs);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseCreateInviteFromTopicRequest();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.recipient = SignedPublicKeyBundle.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.contentTopic = reader.string();
	                    break;
	                case 3:
	                    message.createdNs = reader.uint64();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            recipient: isSet$1(object.recipient)
	                ? SignedPublicKeyBundle.fromJSON(object.recipient)
	                : undefined,
	            contentTopic: isSet$1(object.contentTopic)
	                ? String(object.contentTopic)
	                : "",
	            createdNs: isSet$1(object.createdNs)
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.recipient !== undefined &&
	            (obj.recipient = message.recipient
	                ? SignedPublicKeyBundle.toJSON(message.recipient)
	                : undefined);
	        message.contentTopic !== undefined &&
	            (obj.contentTopic = message.contentTopic);
	        message.createdNs !== undefined &&
	            (obj.createdNs = (message.createdNs || Long.UZERO).toString());
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseCreateInviteFromTopicRequest();
	        message.recipient =
	            object.recipient !== undefined && object.recipient !== null
	                ? SignedPublicKeyBundle.fromPartial(object.recipient)
	                : undefined;
	        message.contentTopic = (_a = object.contentTopic) !== null && _a !== void 0 ? _a : "";
	        message.createdNs =
	            object.createdNs !== undefined && object.createdNs !== null
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO;
	        return message;
	    },
	};
	function createBaseCreateInvitesRequest() {
	    return { context: undefined, recipients: [], createdNs: Long.UZERO };
	}
	const CreateInvitesRequest = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.context !== undefined) {
	            InvitationV1_Context.encode(message.context, writer.uint32(10).fork()).ldelim();
	        }
	        for (const v of message.recipients) {
	            SignedPublicKeyBundle.encode(v, writer.uint32(18).fork()).ldelim();
	        }
	        if (!message.createdNs.isZero()) {
	            writer.uint32(24).uint64(message.createdNs);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseCreateInvitesRequest();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.context = InvitationV1_Context.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.recipients.push(SignedPublicKeyBundle.decode(reader, reader.uint32()));
	                    break;
	                case 3:
	                    message.createdNs = reader.uint64();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            context: isSet$1(object.context)
	                ? InvitationV1_Context.fromJSON(object.context)
	                : undefined,
	            recipients: Array.isArray(object === null || object === void 0 ? void 0 : object.recipients)
	                ? object.recipients.map((e) => SignedPublicKeyBundle.fromJSON(e))
	                : [],
	            createdNs: isSet$1(object.createdNs)
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.context !== undefined &&
	            (obj.context = message.context
	                ? InvitationV1_Context.toJSON(message.context)
	                : undefined);
	        if (message.recipients) {
	            obj.recipients = message.recipients.map((e) => e ? SignedPublicKeyBundle.toJSON(e) : undefined);
	        }
	        else {
	            obj.recipients = [];
	        }
	        message.createdNs !== undefined &&
	            (obj.createdNs = (message.createdNs || Long.UZERO).toString());
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseCreateInvitesRequest();
	        message.context =
	            object.context !== undefined && object.context !== null
	                ? InvitationV1_Context.fromPartial(object.context)
	                : undefined;
	        message.recipients =
	            ((_a = object.recipients) === null || _a === void 0 ? void 0 : _a.map((e) => SignedPublicKeyBundle.fromPartial(e))) || [];
	        message.createdNs =
	            object.createdNs !== undefined && object.createdNs !== null
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO;
	        return message;
	    },
	};
	function createBaseCreateInviteResponse() {
	    return { conversation: undefined, payload: new Uint8Array() };
	}
	const CreateInviteResponse = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.conversation !== undefined) {
	            ConversationReference.encode(message.conversation, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.payload.length !== 0) {
	            writer.uint32(18).bytes(message.payload);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseCreateInviteResponse();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.conversation = ConversationReference.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.payload = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            conversation: isSet$1(object.conversation)
	                ? ConversationReference.fromJSON(object.conversation)
	                : undefined,
	            payload: isSet$1(object.payload)
	                ? bytesFromBase64(object.payload)
	                : new Uint8Array(),
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.conversation !== undefined &&
	            (obj.conversation = message.conversation
	                ? ConversationReference.toJSON(message.conversation)
	                : undefined);
	        message.payload !== undefined &&
	            (obj.payload = base64FromBytes(message.payload !== undefined ? message.payload : new Uint8Array()));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseCreateInviteResponse();
	        message.conversation =
	            object.conversation !== undefined && object.conversation !== null
	                ? ConversationReference.fromPartial(object.conversation)
	                : undefined;
	        message.payload = (_a = object.payload) !== null && _a !== void 0 ? _a : new Uint8Array();
	        return message;
	    },
	};
	function createBaseCreateInvitesResponse() {
	    return { responses: [] };
	}
	const CreateInvitesResponse = {
	    encode(message, writer = _m0.Writer.create()) {
	        for (const v of message.responses) {
	            CreateInviteResponse.encode(v, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseCreateInvitesResponse();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.responses.push(CreateInviteResponse.decode(reader, reader.uint32()));
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            responses: Array.isArray(object === null || object === void 0 ? void 0 : object.responses)
	                ? object.responses.map((e) => CreateInviteResponse.fromJSON(e))
	                : [],
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        if (message.responses) {
	            obj.responses = message.responses.map((e) => e ? CreateInviteResponse.toJSON(e) : undefined);
	        }
	        else {
	            obj.responses = [];
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseCreateInvitesResponse();
	        message.responses =
	            ((_a = object.responses) === null || _a === void 0 ? void 0 : _a.map((e) => CreateInviteResponse.fromPartial(e))) || [];
	        return message;
	    },
	};
	function createBaseSaveInvitesRequest() {
	    return { requests: [] };
	}
	const SaveInvitesRequest = {
	    encode(message, writer = _m0.Writer.create()) {
	        for (const v of message.requests) {
	            SaveInvitesRequest_Request.encode(v, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSaveInvitesRequest();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.requests.push(SaveInvitesRequest_Request.decode(reader, reader.uint32()));
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            requests: Array.isArray(object === null || object === void 0 ? void 0 : object.requests)
	                ? object.requests.map((e) => SaveInvitesRequest_Request.fromJSON(e))
	                : [],
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        if (message.requests) {
	            obj.requests = message.requests.map((e) => e ? SaveInvitesRequest_Request.toJSON(e) : undefined);
	        }
	        else {
	            obj.requests = [];
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseSaveInvitesRequest();
	        message.requests =
	            ((_a = object.requests) === null || _a === void 0 ? void 0 : _a.map((e) => SaveInvitesRequest_Request.fromPartial(e))) ||
	                [];
	        return message;
	    },
	};
	function createBaseSaveInvitesRequest_Request() {
	    return {
	        contentTopic: "",
	        timestampNs: Long.UZERO,
	        payload: new Uint8Array(),
	    };
	}
	const SaveInvitesRequest_Request = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.contentTopic !== "") {
	            writer.uint32(10).string(message.contentTopic);
	        }
	        if (!message.timestampNs.isZero()) {
	            writer.uint32(16).uint64(message.timestampNs);
	        }
	        if (message.payload.length !== 0) {
	            writer.uint32(26).bytes(message.payload);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSaveInvitesRequest_Request();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.contentTopic = reader.string();
	                    break;
	                case 2:
	                    message.timestampNs = reader.uint64();
	                    break;
	                case 3:
	                    message.payload = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            contentTopic: isSet$1(object.contentTopic)
	                ? String(object.contentTopic)
	                : "",
	            timestampNs: isSet$1(object.timestampNs)
	                ? Long.fromValue(object.timestampNs)
	                : Long.UZERO,
	            payload: isSet$1(object.payload)
	                ? bytesFromBase64(object.payload)
	                : new Uint8Array(),
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.contentTopic !== undefined &&
	            (obj.contentTopic = message.contentTopic);
	        message.timestampNs !== undefined &&
	            (obj.timestampNs = (message.timestampNs || Long.UZERO).toString());
	        message.payload !== undefined &&
	            (obj.payload = base64FromBytes(message.payload !== undefined ? message.payload : new Uint8Array()));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b;
	        const message = createBaseSaveInvitesRequest_Request();
	        message.contentTopic = (_a = object.contentTopic) !== null && _a !== void 0 ? _a : "";
	        message.timestampNs =
	            object.timestampNs !== undefined && object.timestampNs !== null
	                ? Long.fromValue(object.timestampNs)
	                : Long.UZERO;
	        message.payload = (_b = object.payload) !== null && _b !== void 0 ? _b : new Uint8Array();
	        return message;
	    },
	};
	function createBaseSaveInvitesResponse() {
	    return { responses: [] };
	}
	const SaveInvitesResponse = {
	    encode(message, writer = _m0.Writer.create()) {
	        for (const v of message.responses) {
	            SaveInvitesResponse_Response.encode(v, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSaveInvitesResponse();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.responses.push(SaveInvitesResponse_Response.decode(reader, reader.uint32()));
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            responses: Array.isArray(object === null || object === void 0 ? void 0 : object.responses)
	                ? object.responses.map((e) => SaveInvitesResponse_Response.fromJSON(e))
	                : [],
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        if (message.responses) {
	            obj.responses = message.responses.map((e) => e ? SaveInvitesResponse_Response.toJSON(e) : undefined);
	        }
	        else {
	            obj.responses = [];
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseSaveInvitesResponse();
	        message.responses =
	            ((_a = object.responses) === null || _a === void 0 ? void 0 : _a.map((e) => SaveInvitesResponse_Response.fromPartial(e))) || [];
	        return message;
	    },
	};
	function createBaseSaveInvitesResponse_Response() {
	    return { result: undefined, error: undefined };
	}
	const SaveInvitesResponse_Response = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.result !== undefined) {
	            SaveInvitesResponse_Response_Success.encode(message.result, writer.uint32(10).fork()).ldelim();
	        }
	        if (message.error !== undefined) {
	            KeystoreError.encode(message.error, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSaveInvitesResponse_Response();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.result = SaveInvitesResponse_Response_Success.decode(reader, reader.uint32());
	                    break;
	                case 2:
	                    message.error = KeystoreError.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            result: isSet$1(object.result)
	                ? SaveInvitesResponse_Response_Success.fromJSON(object.result)
	                : undefined,
	            error: isSet$1(object.error)
	                ? KeystoreError.fromJSON(object.error)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.result !== undefined &&
	            (obj.result = message.result
	                ? SaveInvitesResponse_Response_Success.toJSON(message.result)
	                : undefined);
	        message.error !== undefined &&
	            (obj.error = message.error
	                ? KeystoreError.toJSON(message.error)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseSaveInvitesResponse_Response();
	        message.result =
	            object.result !== undefined && object.result !== null
	                ? SaveInvitesResponse_Response_Success.fromPartial(object.result)
	                : undefined;
	        message.error =
	            object.error !== undefined && object.error !== null
	                ? KeystoreError.fromPartial(object.error)
	                : undefined;
	        return message;
	    },
	};
	function createBaseSaveInvitesResponse_Response_Success() {
	    return { conversation: undefined };
	}
	const SaveInvitesResponse_Response_Success = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.conversation !== undefined) {
	            ConversationReference.encode(message.conversation, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSaveInvitesResponse_Response_Success();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.conversation = ConversationReference.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            conversation: isSet$1(object.conversation)
	                ? ConversationReference.fromJSON(object.conversation)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.conversation !== undefined &&
	            (obj.conversation = message.conversation
	                ? ConversationReference.toJSON(message.conversation)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseSaveInvitesResponse_Response_Success();
	        message.conversation =
	            object.conversation !== undefined && object.conversation !== null
	                ? ConversationReference.fromPartial(object.conversation)
	                : undefined;
	        return message;
	    },
	};
	function createBaseCreateAuthTokenRequest() {
	    return { timestampNs: undefined };
	}
	const CreateAuthTokenRequest = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.timestampNs !== undefined) {
	            writer.uint32(8).uint64(message.timestampNs);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseCreateAuthTokenRequest();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.timestampNs = reader.uint64();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            timestampNs: isSet$1(object.timestampNs)
	                ? Long.fromValue(object.timestampNs)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.timestampNs !== undefined &&
	            (obj.timestampNs = (message.timestampNs || undefined).toString());
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseCreateAuthTokenRequest();
	        message.timestampNs =
	            object.timestampNs !== undefined && object.timestampNs !== null
	                ? Long.fromValue(object.timestampNs)
	                : undefined;
	        return message;
	    },
	};
	function createBaseGetV2ConversationsResponse() {
	    return { conversations: [] };
	}
	const GetV2ConversationsResponse = {
	    encode(message, writer = _m0.Writer.create()) {
	        for (const v of message.conversations) {
	            ConversationReference.encode(v, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseGetV2ConversationsResponse();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.conversations.push(ConversationReference.decode(reader, reader.uint32()));
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            conversations: Array.isArray(object === null || object === void 0 ? void 0 : object.conversations)
	                ? object.conversations.map((e) => ConversationReference.fromJSON(e))
	                : [],
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        if (message.conversations) {
	            obj.conversations = message.conversations.map((e) => e ? ConversationReference.toJSON(e) : undefined);
	        }
	        else {
	            obj.conversations = [];
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseGetV2ConversationsResponse();
	        message.conversations =
	            ((_a = object.conversations) === null || _a === void 0 ? void 0 : _a.map((e) => ConversationReference.fromPartial(e))) ||
	                [];
	        return message;
	    },
	};
	function createBaseGetKeystoreStatusRequest() {
	    return { walletAddress: "" };
	}
	const GetKeystoreStatusRequest = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.walletAddress !== "") {
	            writer.uint32(10).string(message.walletAddress);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseGetKeystoreStatusRequest();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.walletAddress = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            walletAddress: isSet$1(object.walletAddress)
	                ? String(object.walletAddress)
	                : "",
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.walletAddress !== undefined &&
	            (obj.walletAddress = message.walletAddress);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseGetKeystoreStatusRequest();
	        message.walletAddress = (_a = object.walletAddress) !== null && _a !== void 0 ? _a : "";
	        return message;
	    },
	};
	function createBaseGetKeystoreStatusResponse() {
	    return { status: 0 };
	}
	const GetKeystoreStatusResponse = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.status !== 0) {
	            writer.uint32(8).int32(message.status);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseGetKeystoreStatusResponse();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.status = reader.int32();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            status: isSet$1(object.status)
	                ? getKeystoreStatusResponse_KeystoreStatusFromJSON(object.status)
	                : 0,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.status !== undefined &&
	            (obj.status = getKeystoreStatusResponse_KeystoreStatusToJSON(message.status));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseGetKeystoreStatusResponse();
	        message.status = (_a = object.status) !== null && _a !== void 0 ? _a : 0;
	        return message;
	    },
	};
	function createBaseInitKeystoreRequest() {
	    return { v1: undefined };
	}
	const InitKeystoreRequest = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.v1 !== undefined) {
	            PrivateKeyBundleV1.encode(message.v1, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseInitKeystoreRequest();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.v1 = PrivateKeyBundleV1.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            v1: isSet$1(object.v1) ? PrivateKeyBundleV1.fromJSON(object.v1) : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.v1 !== undefined &&
	            (obj.v1 = message.v1 ? PrivateKeyBundleV1.toJSON(message.v1) : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseInitKeystoreRequest();
	        message.v1 =
	            object.v1 !== undefined && object.v1 !== null
	                ? PrivateKeyBundleV1.fromPartial(object.v1)
	                : undefined;
	        return message;
	    },
	};
	function createBaseInitKeystoreResponse() {
	    return { error: undefined };
	}
	const InitKeystoreResponse = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.error !== undefined) {
	            KeystoreError.encode(message.error, writer.uint32(10).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseInitKeystoreResponse();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.error = KeystoreError.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            error: isSet$1(object.error)
	                ? KeystoreError.fromJSON(object.error)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.error !== undefined &&
	            (obj.error = message.error
	                ? KeystoreError.toJSON(message.error)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        const message = createBaseInitKeystoreResponse();
	        message.error =
	            object.error !== undefined && object.error !== null
	                ? KeystoreError.fromPartial(object.error)
	                : undefined;
	        return message;
	    },
	};
	function createBaseSignDigestRequest() {
	    return {
	        digest: new Uint8Array(),
	        identityKey: undefined,
	        prekeyIndex: undefined,
	    };
	}
	const SignDigestRequest = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.digest.length !== 0) {
	            writer.uint32(10).bytes(message.digest);
	        }
	        if (message.identityKey !== undefined) {
	            writer.uint32(16).bool(message.identityKey);
	        }
	        if (message.prekeyIndex !== undefined) {
	            writer.uint32(24).uint32(message.prekeyIndex);
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseSignDigestRequest();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.digest = reader.bytes();
	                    break;
	                case 2:
	                    message.identityKey = reader.bool();
	                    break;
	                case 3:
	                    message.prekeyIndex = reader.uint32();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            digest: isSet$1(object.digest)
	                ? bytesFromBase64(object.digest)
	                : new Uint8Array(),
	            identityKey: isSet$1(object.identityKey)
	                ? Boolean(object.identityKey)
	                : undefined,
	            prekeyIndex: isSet$1(object.prekeyIndex)
	                ? Number(object.prekeyIndex)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.digest !== undefined &&
	            (obj.digest = base64FromBytes(message.digest !== undefined ? message.digest : new Uint8Array()));
	        message.identityKey !== undefined &&
	            (obj.identityKey = message.identityKey);
	        message.prekeyIndex !== undefined &&
	            (obj.prekeyIndex = Math.round(message.prekeyIndex));
	        return obj;
	    },
	    fromPartial(object) {
	        var _a, _b, _c;
	        const message = createBaseSignDigestRequest();
	        message.digest = (_a = object.digest) !== null && _a !== void 0 ? _a : new Uint8Array();
	        message.identityKey = (_b = object.identityKey) !== null && _b !== void 0 ? _b : undefined;
	        message.prekeyIndex = (_c = object.prekeyIndex) !== null && _c !== void 0 ? _c : undefined;
	        return message;
	    },
	};
	function createBaseTopicMap() {
	    return { topics: {} };
	}
	const TopicMap = {
	    encode(message, writer = _m0.Writer.create()) {
	        Object.entries(message.topics).forEach(([key, value]) => {
	            TopicMap_TopicsEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
	        });
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseTopicMap();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    const entry1 = TopicMap_TopicsEntry.decode(reader, reader.uint32());
	                    if (entry1.value !== undefined) {
	                        message.topics[entry1.key] = entry1.value;
	                    }
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            topics: isObject$3(object.topics)
	                ? Object.entries(object.topics).reduce((acc, [key, value]) => {
	                    acc[key] = TopicMap_TopicData.fromJSON(value);
	                    return acc;
	                }, {})
	                : {},
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        obj.topics = {};
	        if (message.topics) {
	            Object.entries(message.topics).forEach(([k, v]) => {
	                obj.topics[k] = TopicMap_TopicData.toJSON(v);
	            });
	        }
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseTopicMap();
	        message.topics = Object.entries((_a = object.topics) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
	            if (value !== undefined) {
	                acc[key] = TopicMap_TopicData.fromPartial(value);
	            }
	            return acc;
	        }, {});
	        return message;
	    },
	};
	function createBaseTopicMap_TopicData() {
	    return { createdNs: Long.UZERO, peerAddress: "", invitation: undefined };
	}
	const TopicMap_TopicData = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (!message.createdNs.isZero()) {
	            writer.uint32(8).uint64(message.createdNs);
	        }
	        if (message.peerAddress !== "") {
	            writer.uint32(18).string(message.peerAddress);
	        }
	        if (message.invitation !== undefined) {
	            InvitationV1.encode(message.invitation, writer.uint32(26).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseTopicMap_TopicData();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.createdNs = reader.uint64();
	                    break;
	                case 2:
	                    message.peerAddress = reader.string();
	                    break;
	                case 3:
	                    message.invitation = InvitationV1.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            createdNs: isSet$1(object.createdNs)
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO,
	            peerAddress: isSet$1(object.peerAddress) ? String(object.peerAddress) : "",
	            invitation: isSet$1(object.invitation)
	                ? InvitationV1.fromJSON(object.invitation)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.createdNs !== undefined &&
	            (obj.createdNs = (message.createdNs || Long.UZERO).toString());
	        message.peerAddress !== undefined &&
	            (obj.peerAddress = message.peerAddress);
	        message.invitation !== undefined &&
	            (obj.invitation = message.invitation
	                ? InvitationV1.toJSON(message.invitation)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseTopicMap_TopicData();
	        message.createdNs =
	            object.createdNs !== undefined && object.createdNs !== null
	                ? Long.fromValue(object.createdNs)
	                : Long.UZERO;
	        message.peerAddress = (_a = object.peerAddress) !== null && _a !== void 0 ? _a : "";
	        message.invitation =
	            object.invitation !== undefined && object.invitation !== null
	                ? InvitationV1.fromPartial(object.invitation)
	                : undefined;
	        return message;
	    },
	};
	function createBaseTopicMap_TopicsEntry() {
	    return { key: "", value: undefined };
	}
	const TopicMap_TopicsEntry = {
	    encode(message, writer = _m0.Writer.create()) {
	        if (message.key !== "") {
	            writer.uint32(10).string(message.key);
	        }
	        if (message.value !== undefined) {
	            TopicMap_TopicData.encode(message.value, writer.uint32(18).fork()).ldelim();
	        }
	        return writer;
	    },
	    decode(input, length) {
	        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
	        let end = length === undefined ? reader.len : reader.pos + length;
	        const message = createBaseTopicMap_TopicsEntry();
	        while (reader.pos < end) {
	            const tag = reader.uint32();
	            switch (tag >>> 3) {
	                case 1:
	                    message.key = reader.string();
	                    break;
	                case 2:
	                    message.value = TopicMap_TopicData.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	            }
	        }
	        return message;
	    },
	    fromJSON(object) {
	        return {
	            key: isSet$1(object.key) ? String(object.key) : "",
	            value: isSet$1(object.value)
	                ? TopicMap_TopicData.fromJSON(object.value)
	                : undefined,
	        };
	    },
	    toJSON(message) {
	        const obj = {};
	        message.key !== undefined && (obj.key = message.key);
	        message.value !== undefined &&
	            (obj.value = message.value
	                ? TopicMap_TopicData.toJSON(message.value)
	                : undefined);
	        return obj;
	    },
	    fromPartial(object) {
	        var _a;
	        const message = createBaseTopicMap_TopicsEntry();
	        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
	        message.value =
	            object.value !== undefined && object.value !== null
	                ? TopicMap_TopicData.fromPartial(object.value)
	                : undefined;
	        return message;
	    },
	};
	var globalThis$1 = (() => {
	    if (typeof globalThis$1 !== "undefined")
	        return globalThis$1;
	    if (typeof self !== "undefined")
	        return self;
	    if (typeof window !== "undefined")
	        return window;
	    if (typeof global !== "undefined")
	        return global;
	    throw "Unable to locate global object";
	})();
	function bytesFromBase64(b64) {
	    if (globalThis$1.Buffer) {
	        return Uint8Array.from(globalThis$1.Buffer.from(b64, "base64"));
	    }
	    else {
	        const bin = globalThis$1.atob(b64);
	        const arr = new Uint8Array(bin.length);
	        for (let i = 0; i < bin.length; ++i) {
	            arr[i] = bin.charCodeAt(i);
	        }
	        return arr;
	    }
	}
	function base64FromBytes(arr) {
	    if (globalThis$1.Buffer) {
	        return globalThis$1.Buffer.from(arr).toString("base64");
	    }
	    else {
	        const bin = [];
	        arr.forEach((byte) => {
	            bin.push(String.fromCharCode(byte));
	        });
	        return globalThis$1.btoa(bin.join(""));
	    }
	}
	if (_m0.util.Long !== Long) {
	    _m0.util.Long = Long;
	    _m0.configure();
	}
	function isObject$3(value) {
	    return typeof value === "object" && value !== null;
	}
	function isSet$1(value) {
	    return value !== null && value !== undefined;
	}

	var keystore = /*#__PURE__*/Object.freeze({
		__proto__: null,
		CreateAuthTokenRequest: CreateAuthTokenRequest,
		CreateInviteFromTopicRequest: CreateInviteFromTopicRequest,
		CreateInviteRequest: CreateInviteRequest,
		CreateInviteResponse: CreateInviteResponse,
		CreateInvitesRequest: CreateInvitesRequest,
		CreateInvitesResponse: CreateInvitesResponse,
		DecryptResponse: DecryptResponse,
		DecryptResponse_Response: DecryptResponse_Response,
		DecryptResponse_Response_Success: DecryptResponse_Response_Success,
		DecryptV1Request: DecryptV1Request,
		DecryptV1Request_Request: DecryptV1Request_Request,
		DecryptV2Request: DecryptV2Request,
		DecryptV2Request_Request: DecryptV2Request_Request,
		EncryptResponse: EncryptResponse,
		EncryptResponse_Response: EncryptResponse_Response,
		EncryptResponse_Response_Success: EncryptResponse_Response_Success,
		EncryptV1Request: EncryptV1Request,
		EncryptV1Request_Request: EncryptV1Request_Request,
		EncryptV2Request: EncryptV2Request,
		EncryptV2Request_Request: EncryptV2Request_Request,
		get ErrorCode () { return ErrorCode; },
		GetKeystoreStatusRequest: GetKeystoreStatusRequest,
		GetKeystoreStatusResponse: GetKeystoreStatusResponse,
		get GetKeystoreStatusResponse_KeystoreStatus () { return GetKeystoreStatusResponse_KeystoreStatus; },
		GetV2ConversationsResponse: GetV2ConversationsResponse,
		InitKeystoreRequest: InitKeystoreRequest,
		InitKeystoreResponse: InitKeystoreResponse,
		KeystoreError: KeystoreError,
		SaveInvitesRequest: SaveInvitesRequest,
		SaveInvitesRequest_Request: SaveInvitesRequest_Request,
		SaveInvitesResponse: SaveInvitesResponse,
		SaveInvitesResponse_Response: SaveInvitesResponse_Response,
		SaveInvitesResponse_Response_Success: SaveInvitesResponse_Response_Success,
		SignDigestRequest: SignDigestRequest,
		TopicMap: TopicMap,
		TopicMap_TopicData: TopicMap_TopicData,
		TopicMap_TopicsEntry: TopicMap_TopicsEntry,
		errorCodeFromJSON: errorCodeFromJSON,
		errorCodeToJSON: errorCodeToJSON,
		getKeystoreStatusResponse_KeystoreStatusFromJSON: getKeystoreStatusResponse_KeystoreStatusFromJSON,
		getKeystoreStatusResponse_KeystoreStatusToJSON: getKeystoreStatusResponse_KeystoreStatusToJSON,
		protobufPackage: protobufPackage
	});

	/*! noble-secp256k1 - MIT License (c) 2019 Paul Miller (paulmillr.com) */
	const _0n = BigInt(0);
	const _1n = BigInt(1);
	const _2n = BigInt(2);
	const _3n = BigInt(3);
	const _8n = BigInt(8);
	const CURVE = Object.freeze({
	    a: _0n,
	    b: BigInt(7),
	    P: BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f'),
	    n: BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141'),
	    h: _1n,
	    Gx: BigInt('55066263022277343669578718895168534326250603453777594175500187360389116729240'),
	    Gy: BigInt('32670510020758816978083085130507043184471273380659243275938904335757337482424'),
	    beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
	});
	const divNearest = (a, b) => (a + b / _2n) / b;
	const endo = {
	    beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
	    splitScalar(k) {
	        const { n } = CURVE;
	        const a1 = BigInt('0x3086d221a7d46bcde86c90e49284eb15');
	        const b1 = -_1n * BigInt('0xe4437ed6010e88286f547fa90abfe4c3');
	        const a2 = BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8');
	        const b2 = a1;
	        const POW_2_128 = BigInt('0x100000000000000000000000000000000');
	        const c1 = divNearest(b2 * k, n);
	        const c2 = divNearest(-b1 * k, n);
	        let k1 = mod(k - c1 * a1 - c2 * a2, n);
	        let k2 = mod(-c1 * b1 - c2 * b2, n);
	        const k1neg = k1 > POW_2_128;
	        const k2neg = k2 > POW_2_128;
	        if (k1neg)
	            k1 = n - k1;
	        if (k2neg)
	            k2 = n - k2;
	        if (k1 > POW_2_128 || k2 > POW_2_128) {
	            throw new Error('splitScalarEndo: Endomorphism failed, k=' + k);
	        }
	        return { k1neg, k1, k2neg, k2 };
	    },
	};
	const fieldLen = 32;
	const groupLen = 32;
	const hashLen = 32;
	const compressedLen = fieldLen + 1;
	const uncompressedLen = 2 * fieldLen + 1;
	function weierstrass(x) {
	    const { a, b } = CURVE;
	    const x2 = mod(x * x);
	    const x3 = mod(x2 * x);
	    return mod(x3 + a * x + b);
	}
	const USE_ENDOMORPHISM = CURVE.a === _0n;
	class ShaError extends Error {
	    constructor(message) {
	        super(message);
	    }
	}
	function assertJacPoint(other) {
	    if (!(other instanceof JacobianPoint))
	        throw new TypeError('JacobianPoint expected');
	}
	class JacobianPoint {
	    constructor(x, y, z) {
	        this.x = x;
	        this.y = y;
	        this.z = z;
	    }
	    static fromAffine(p) {
	        if (!(p instanceof Point$3)) {
	            throw new TypeError('JacobianPoint#fromAffine: expected Point');
	        }
	        if (p.equals(Point$3.ZERO))
	            return JacobianPoint.ZERO;
	        return new JacobianPoint(p.x, p.y, _1n);
	    }
	    static toAffineBatch(points) {
	        const toInv = invertBatch(points.map((p) => p.z));
	        return points.map((p, i) => p.toAffine(toInv[i]));
	    }
	    static normalizeZ(points) {
	        return JacobianPoint.toAffineBatch(points).map(JacobianPoint.fromAffine);
	    }
	    equals(other) {
	        assertJacPoint(other);
	        const { x: X1, y: Y1, z: Z1 } = this;
	        const { x: X2, y: Y2, z: Z2 } = other;
	        const Z1Z1 = mod(Z1 * Z1);
	        const Z2Z2 = mod(Z2 * Z2);
	        const U1 = mod(X1 * Z2Z2);
	        const U2 = mod(X2 * Z1Z1);
	        const S1 = mod(mod(Y1 * Z2) * Z2Z2);
	        const S2 = mod(mod(Y2 * Z1) * Z1Z1);
	        return U1 === U2 && S1 === S2;
	    }
	    negate() {
	        return new JacobianPoint(this.x, mod(-this.y), this.z);
	    }
	    double() {
	        const { x: X1, y: Y1, z: Z1 } = this;
	        const A = mod(X1 * X1);
	        const B = mod(Y1 * Y1);
	        const C = mod(B * B);
	        const x1b = X1 + B;
	        const D = mod(_2n * (mod(x1b * x1b) - A - C));
	        const E = mod(_3n * A);
	        const F = mod(E * E);
	        const X3 = mod(F - _2n * D);
	        const Y3 = mod(E * (D - X3) - _8n * C);
	        const Z3 = mod(_2n * Y1 * Z1);
	        return new JacobianPoint(X3, Y3, Z3);
	    }
	    add(other) {
	        assertJacPoint(other);
	        const { x: X1, y: Y1, z: Z1 } = this;
	        const { x: X2, y: Y2, z: Z2 } = other;
	        if (X2 === _0n || Y2 === _0n)
	            return this;
	        if (X1 === _0n || Y1 === _0n)
	            return other;
	        const Z1Z1 = mod(Z1 * Z1);
	        const Z2Z2 = mod(Z2 * Z2);
	        const U1 = mod(X1 * Z2Z2);
	        const U2 = mod(X2 * Z1Z1);
	        const S1 = mod(mod(Y1 * Z2) * Z2Z2);
	        const S2 = mod(mod(Y2 * Z1) * Z1Z1);
	        const H = mod(U2 - U1);
	        const r = mod(S2 - S1);
	        if (H === _0n) {
	            if (r === _0n) {
	                return this.double();
	            }
	            else {
	                return JacobianPoint.ZERO;
	            }
	        }
	        const HH = mod(H * H);
	        const HHH = mod(H * HH);
	        const V = mod(U1 * HH);
	        const X3 = mod(r * r - HHH - _2n * V);
	        const Y3 = mod(r * (V - X3) - S1 * HHH);
	        const Z3 = mod(Z1 * Z2 * H);
	        return new JacobianPoint(X3, Y3, Z3);
	    }
	    subtract(other) {
	        return this.add(other.negate());
	    }
	    multiplyUnsafe(scalar) {
	        const P0 = JacobianPoint.ZERO;
	        if (typeof scalar === 'bigint' && scalar === _0n)
	            return P0;
	        let n = normalizeScalar(scalar);
	        if (n === _1n)
	            return this;
	        if (!USE_ENDOMORPHISM) {
	            let p = P0;
	            let d = this;
	            while (n > _0n) {
	                if (n & _1n)
	                    p = p.add(d);
	                d = d.double();
	                n >>= _1n;
	            }
	            return p;
	        }
	        let { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
	        let k1p = P0;
	        let k2p = P0;
	        let d = this;
	        while (k1 > _0n || k2 > _0n) {
	            if (k1 & _1n)
	                k1p = k1p.add(d);
	            if (k2 & _1n)
	                k2p = k2p.add(d);
	            d = d.double();
	            k1 >>= _1n;
	            k2 >>= _1n;
	        }
	        if (k1neg)
	            k1p = k1p.negate();
	        if (k2neg)
	            k2p = k2p.negate();
	        k2p = new JacobianPoint(mod(k2p.x * endo.beta), k2p.y, k2p.z);
	        return k1p.add(k2p);
	    }
	    precomputeWindow(W) {
	        const windows = USE_ENDOMORPHISM ? 128 / W + 1 : 256 / W + 1;
	        const points = [];
	        let p = this;
	        let base = p;
	        for (let window = 0; window < windows; window++) {
	            base = p;
	            points.push(base);
	            for (let i = 1; i < 2 ** (W - 1); i++) {
	                base = base.add(p);
	                points.push(base);
	            }
	            p = base.double();
	        }
	        return points;
	    }
	    wNAF(n, affinePoint) {
	        if (!affinePoint && this.equals(JacobianPoint.BASE))
	            affinePoint = Point$3.BASE;
	        const W = (affinePoint && affinePoint._WINDOW_SIZE) || 1;
	        if (256 % W) {
	            throw new Error('Point#wNAF: Invalid precomputation window, must be power of 2');
	        }
	        let precomputes = affinePoint && pointPrecomputes.get(affinePoint);
	        if (!precomputes) {
	            precomputes = this.precomputeWindow(W);
	            if (affinePoint && W !== 1) {
	                precomputes = JacobianPoint.normalizeZ(precomputes);
	                pointPrecomputes.set(affinePoint, precomputes);
	            }
	        }
	        let p = JacobianPoint.ZERO;
	        let f = JacobianPoint.BASE;
	        const windows = 1 + (USE_ENDOMORPHISM ? 128 / W : 256 / W);
	        const windowSize = 2 ** (W - 1);
	        const mask = BigInt(2 ** W - 1);
	        const maxNumber = 2 ** W;
	        const shiftBy = BigInt(W);
	        for (let window = 0; window < windows; window++) {
	            const offset = window * windowSize;
	            let wbits = Number(n & mask);
	            n >>= shiftBy;
	            if (wbits > windowSize) {
	                wbits -= maxNumber;
	                n += _1n;
	            }
	            const offset1 = offset;
	            const offset2 = offset + Math.abs(wbits) - 1;
	            const cond1 = window % 2 !== 0;
	            const cond2 = wbits < 0;
	            if (wbits === 0) {
	                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
	            }
	            else {
	                p = p.add(constTimeNegate(cond2, precomputes[offset2]));
	            }
	        }
	        return { p, f };
	    }
	    multiply(scalar, affinePoint) {
	        let n = normalizeScalar(scalar);
	        let point;
	        let fake;
	        if (USE_ENDOMORPHISM) {
	            const { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
	            let { p: k1p, f: f1p } = this.wNAF(k1, affinePoint);
	            let { p: k2p, f: f2p } = this.wNAF(k2, affinePoint);
	            k1p = constTimeNegate(k1neg, k1p);
	            k2p = constTimeNegate(k2neg, k2p);
	            k2p = new JacobianPoint(mod(k2p.x * endo.beta), k2p.y, k2p.z);
	            point = k1p.add(k2p);
	            fake = f1p.add(f2p);
	        }
	        else {
	            const { p, f } = this.wNAF(n, affinePoint);
	            point = p;
	            fake = f;
	        }
	        return JacobianPoint.normalizeZ([point, fake])[0];
	    }
	    toAffine(invZ) {
	        const { x, y, z } = this;
	        const is0 = this.equals(JacobianPoint.ZERO);
	        if (invZ == null)
	            invZ = is0 ? _8n : invert(z);
	        const iz1 = invZ;
	        const iz2 = mod(iz1 * iz1);
	        const iz3 = mod(iz2 * iz1);
	        const ax = mod(x * iz2);
	        const ay = mod(y * iz3);
	        const zz = mod(z * iz1);
	        if (is0)
	            return Point$3.ZERO;
	        if (zz !== _1n)
	            throw new Error('invZ was invalid');
	        return new Point$3(ax, ay);
	    }
	}
	JacobianPoint.BASE = new JacobianPoint(CURVE.Gx, CURVE.Gy, _1n);
	JacobianPoint.ZERO = new JacobianPoint(_0n, _1n, _0n);
	function constTimeNegate(condition, item) {
	    const neg = item.negate();
	    return condition ? neg : item;
	}
	const pointPrecomputes = new WeakMap();
	let Point$3 = class Point {
	    constructor(x, y) {
	        this.x = x;
	        this.y = y;
	    }
	    _setWindowSize(windowSize) {
	        this._WINDOW_SIZE = windowSize;
	        pointPrecomputes.delete(this);
	    }
	    hasEvenY() {
	        return this.y % _2n === _0n;
	    }
	    static fromCompressedHex(bytes) {
	        const isShort = bytes.length === 32;
	        const x = bytesToNumber$1(isShort ? bytes : bytes.subarray(1));
	        if (!isValidFieldElement(x))
	            throw new Error('Point is not on curve');
	        const y2 = weierstrass(x);
	        let y = sqrtMod(y2);
	        const isYOdd = (y & _1n) === _1n;
	        if (isShort) {
	            if (isYOdd)
	                y = mod(-y);
	        }
	        else {
	            const isFirstByteOdd = (bytes[0] & 1) === 1;
	            if (isFirstByteOdd !== isYOdd)
	                y = mod(-y);
	        }
	        const point = new Point(x, y);
	        point.assertValidity();
	        return point;
	    }
	    static fromUncompressedHex(bytes) {
	        const x = bytesToNumber$1(bytes.subarray(1, fieldLen + 1));
	        const y = bytesToNumber$1(bytes.subarray(fieldLen + 1, fieldLen * 2 + 1));
	        const point = new Point(x, y);
	        point.assertValidity();
	        return point;
	    }
	    static fromHex(hex) {
	        const bytes = ensureBytes(hex);
	        const len = bytes.length;
	        const header = bytes[0];
	        if (len === fieldLen)
	            return this.fromCompressedHex(bytes);
	        if (len === compressedLen && (header === 0x02 || header === 0x03)) {
	            return this.fromCompressedHex(bytes);
	        }
	        if (len === uncompressedLen && header === 0x04)
	            return this.fromUncompressedHex(bytes);
	        throw new Error(`Point.fromHex: received invalid point. Expected 32-${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes, not ${len}`);
	    }
	    static fromPrivateKey(privateKey) {
	        return Point.BASE.multiply(normalizePrivateKey(privateKey));
	    }
	    static fromSignature(msgHash, signature, recovery) {
	        const { r, s } = normalizeSignature(signature);
	        if (![0, 1, 2, 3].includes(recovery))
	            throw new Error('Cannot recover: invalid recovery bit');
	        const h = truncateHash(ensureBytes(msgHash));
	        const { n } = CURVE;
	        const radj = recovery === 2 || recovery === 3 ? r + n : r;
	        const rinv = invert(radj, n);
	        const u1 = mod(-h * rinv, n);
	        const u2 = mod(s * rinv, n);
	        const prefix = recovery & 1 ? '03' : '02';
	        const R = Point.fromHex(prefix + numTo32bStr(radj));
	        const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2);
	        if (!Q)
	            throw new Error('Cannot recover signature: point at infinify');
	        Q.assertValidity();
	        return Q;
	    }
	    toRawBytes(isCompressed = false) {
	        return hexToBytes$1(this.toHex(isCompressed));
	    }
	    toHex(isCompressed = false) {
	        const x = numTo32bStr(this.x);
	        if (isCompressed) {
	            const prefix = this.hasEvenY() ? '02' : '03';
	            return `${prefix}${x}`;
	        }
	        else {
	            return `04${x}${numTo32bStr(this.y)}`;
	        }
	    }
	    toHexX() {
	        return this.toHex(true).slice(2);
	    }
	    toRawX() {
	        return this.toRawBytes(true).slice(1);
	    }
	    assertValidity() {
	        const msg = 'Point is not on elliptic curve';
	        const { x, y } = this;
	        if (!isValidFieldElement(x) || !isValidFieldElement(y))
	            throw new Error(msg);
	        const left = mod(y * y);
	        const right = weierstrass(x);
	        if (mod(left - right) !== _0n)
	            throw new Error(msg);
	    }
	    equals(other) {
	        return this.x === other.x && this.y === other.y;
	    }
	    negate() {
	        return new Point(this.x, mod(-this.y));
	    }
	    double() {
	        return JacobianPoint.fromAffine(this).double().toAffine();
	    }
	    add(other) {
	        return JacobianPoint.fromAffine(this).add(JacobianPoint.fromAffine(other)).toAffine();
	    }
	    subtract(other) {
	        return this.add(other.negate());
	    }
	    multiply(scalar) {
	        return JacobianPoint.fromAffine(this).multiply(scalar, this).toAffine();
	    }
	    multiplyAndAddUnsafe(Q, a, b) {
	        const P = JacobianPoint.fromAffine(this);
	        const aP = a === _0n || a === _1n || this !== Point.BASE ? P.multiplyUnsafe(a) : P.multiply(a);
	        const bQ = JacobianPoint.fromAffine(Q).multiplyUnsafe(b);
	        const sum = aP.add(bQ);
	        return sum.equals(JacobianPoint.ZERO) ? undefined : sum.toAffine();
	    }
	};
	Point$3.BASE = new Point$3(CURVE.Gx, CURVE.Gy);
	Point$3.ZERO = new Point$3(_0n, _0n);
	function sliceDER(s) {
	    return Number.parseInt(s[0], 16) >= 8 ? '00' + s : s;
	}
	function parseDERInt(data) {
	    if (data.length < 2 || data[0] !== 0x02) {
	        throw new Error(`Invalid signature integer tag: ${bytesToHex$1(data)}`);
	    }
	    const len = data[1];
	    const res = data.subarray(2, len + 2);
	    if (!len || res.length !== len) {
	        throw new Error(`Invalid signature integer: wrong length`);
	    }
	    if (res[0] === 0x00 && res[1] <= 0x7f) {
	        throw new Error('Invalid signature integer: trailing length');
	    }
	    return { data: bytesToNumber$1(res), left: data.subarray(len + 2) };
	}
	function parseDERSignature(data) {
	    if (data.length < 2 || data[0] != 0x30) {
	        throw new Error(`Invalid signature tag: ${bytesToHex$1(data)}`);
	    }
	    if (data[1] !== data.length - 2) {
	        throw new Error('Invalid signature: incorrect length');
	    }
	    const { data: r, left: sBytes } = parseDERInt(data.subarray(2));
	    const { data: s, left: rBytesLeft } = parseDERInt(sBytes);
	    if (rBytesLeft.length) {
	        throw new Error(`Invalid signature: left bytes after parsing: ${bytesToHex$1(rBytesLeft)}`);
	    }
	    return { r, s };
	}
	let Signature$4 = class Signature {
	    constructor(r, s) {
	        this.r = r;
	        this.s = s;
	        this.assertValidity();
	    }
	    static fromCompact(hex) {
	        const arr = hex instanceof Uint8Array;
	        const name = 'Signature.fromCompact';
	        if (typeof hex !== 'string' && !arr)
	            throw new TypeError(`${name}: Expected string or Uint8Array`);
	        const str = arr ? bytesToHex$1(hex) : hex;
	        if (str.length !== 128)
	            throw new Error(`${name}: Expected 64-byte hex`);
	        return new Signature(hexToNumber$1(str.slice(0, 64)), hexToNumber$1(str.slice(64, 128)));
	    }
	    static fromDER(hex) {
	        const arr = hex instanceof Uint8Array;
	        if (typeof hex !== 'string' && !arr)
	            throw new TypeError(`Signature.fromDER: Expected string or Uint8Array`);
	        const { r, s } = parseDERSignature(arr ? hex : hexToBytes$1(hex));
	        return new Signature(r, s);
	    }
	    static fromHex(hex) {
	        return this.fromDER(hex);
	    }
	    assertValidity() {
	        const { r, s } = this;
	        if (!isWithinCurveOrder(r))
	            throw new Error('Invalid Signature: r must be 0 < r < n');
	        if (!isWithinCurveOrder(s))
	            throw new Error('Invalid Signature: s must be 0 < s < n');
	    }
	    hasHighS() {
	        const HALF = CURVE.n >> _1n;
	        return this.s > HALF;
	    }
	    normalizeS() {
	        return this.hasHighS() ? new Signature(this.r, mod(-this.s, CURVE.n)) : this;
	    }
	    toDERRawBytes() {
	        return hexToBytes$1(this.toDERHex());
	    }
	    toDERHex() {
	        const sHex = sliceDER(numberToHexUnpadded(this.s));
	        const rHex = sliceDER(numberToHexUnpadded(this.r));
	        const sHexL = sHex.length / 2;
	        const rHexL = rHex.length / 2;
	        const sLen = numberToHexUnpadded(sHexL);
	        const rLen = numberToHexUnpadded(rHexL);
	        const length = numberToHexUnpadded(rHexL + sHexL + 4);
	        return `30${length}02${rLen}${rHex}02${sLen}${sHex}`;
	    }
	    toRawBytes() {
	        return this.toDERRawBytes();
	    }
	    toHex() {
	        return this.toDERHex();
	    }
	    toCompactRawBytes() {
	        return hexToBytes$1(this.toCompactHex());
	    }
	    toCompactHex() {
	        return numTo32bStr(this.r) + numTo32bStr(this.s);
	    }
	};
	function concatBytes$1(...arrays) {
	    if (!arrays.every((b) => b instanceof Uint8Array))
	        throw new Error('Uint8Array list expected');
	    if (arrays.length === 1)
	        return arrays[0];
	    const length = arrays.reduce((a, arr) => a + arr.length, 0);
	    const result = new Uint8Array(length);
	    for (let i = 0, pad = 0; i < arrays.length; i++) {
	        const arr = arrays[i];
	        result.set(arr, pad);
	        pad += arr.length;
	    }
	    return result;
	}
	const hexes = Array.from({ length: 256 }, (v, i) => i.toString(16).padStart(2, '0'));
	function bytesToHex$1(uint8a) {
	    if (!(uint8a instanceof Uint8Array))
	        throw new Error('Expected Uint8Array');
	    let hex = '';
	    for (let i = 0; i < uint8a.length; i++) {
	        hex += hexes[uint8a[i]];
	    }
	    return hex;
	}
	const POW_2_256 = BigInt('0x10000000000000000000000000000000000000000000000000000000000000000');
	function numTo32bStr(num) {
	    if (typeof num !== 'bigint')
	        throw new Error('Expected bigint');
	    if (!(_0n <= num && num < POW_2_256))
	        throw new Error('Expected number 0 <= n < 2^256');
	    return num.toString(16).padStart(64, '0');
	}
	function numTo32b(num) {
	    const b = hexToBytes$1(numTo32bStr(num));
	    if (b.length !== 32)
	        throw new Error('Error: expected 32 bytes');
	    return b;
	}
	function numberToHexUnpadded(num) {
	    const hex = num.toString(16);
	    return hex.length & 1 ? `0${hex}` : hex;
	}
	function hexToNumber$1(hex) {
	    if (typeof hex !== 'string') {
	        throw new TypeError('hexToNumber: expected string, got ' + typeof hex);
	    }
	    return BigInt(`0x${hex}`);
	}
	function hexToBytes$1(hex) {
	    if (typeof hex !== 'string') {
	        throw new TypeError('hexToBytes: expected string, got ' + typeof hex);
	    }
	    if (hex.length % 2)
	        throw new Error('hexToBytes: received invalid unpadded hex' + hex.length);
	    const array = new Uint8Array(hex.length / 2);
	    for (let i = 0; i < array.length; i++) {
	        const j = i * 2;
	        const hexByte = hex.slice(j, j + 2);
	        const byte = Number.parseInt(hexByte, 16);
	        if (Number.isNaN(byte) || byte < 0)
	            throw new Error('Invalid byte sequence');
	        array[i] = byte;
	    }
	    return array;
	}
	function bytesToNumber$1(bytes) {
	    return hexToNumber$1(bytesToHex$1(bytes));
	}
	function ensureBytes(hex) {
	    return hex instanceof Uint8Array ? Uint8Array.from(hex) : hexToBytes$1(hex);
	}
	function normalizeScalar(num) {
	    if (typeof num === 'number' && Number.isSafeInteger(num) && num > 0)
	        return BigInt(num);
	    if (typeof num === 'bigint' && isWithinCurveOrder(num))
	        return num;
	    throw new TypeError('Expected valid private scalar: 0 < scalar < curve.n');
	}
	function mod(a, b = CURVE.P) {
	    const result = a % b;
	    return result >= _0n ? result : b + result;
	}
	function pow2(x, power) {
	    const { P } = CURVE;
	    let res = x;
	    while (power-- > _0n) {
	        res *= res;
	        res %= P;
	    }
	    return res;
	}
	function sqrtMod(x) {
	    const { P } = CURVE;
	    const _6n = BigInt(6);
	    const _11n = BigInt(11);
	    const _22n = BigInt(22);
	    const _23n = BigInt(23);
	    const _44n = BigInt(44);
	    const _88n = BigInt(88);
	    const b2 = (x * x * x) % P;
	    const b3 = (b2 * b2 * x) % P;
	    const b6 = (pow2(b3, _3n) * b3) % P;
	    const b9 = (pow2(b6, _3n) * b3) % P;
	    const b11 = (pow2(b9, _2n) * b2) % P;
	    const b22 = (pow2(b11, _11n) * b11) % P;
	    const b44 = (pow2(b22, _22n) * b22) % P;
	    const b88 = (pow2(b44, _44n) * b44) % P;
	    const b176 = (pow2(b88, _88n) * b88) % P;
	    const b220 = (pow2(b176, _44n) * b44) % P;
	    const b223 = (pow2(b220, _3n) * b3) % P;
	    const t1 = (pow2(b223, _23n) * b22) % P;
	    const t2 = (pow2(t1, _6n) * b2) % P;
	    const rt = pow2(t2, _2n);
	    const xc = (rt * rt) % P;
	    if (xc !== x)
	        throw new Error('Cannot find square root');
	    return rt;
	}
	function invert(number, modulo = CURVE.P) {
	    if (number === _0n || modulo <= _0n) {
	        throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
	    }
	    let a = mod(number, modulo);
	    let b = modulo;
	    let x = _0n, u = _1n;
	    while (a !== _0n) {
	        const q = b / a;
	        const r = b % a;
	        const m = x - u * q;
	        b = a, a = r, x = u, u = m;
	    }
	    const gcd = b;
	    if (gcd !== _1n)
	        throw new Error('invert: does not exist');
	    return mod(x, modulo);
	}
	function invertBatch(nums, p = CURVE.P) {
	    const scratch = new Array(nums.length);
	    const lastMultiplied = nums.reduce((acc, num, i) => {
	        if (num === _0n)
	            return acc;
	        scratch[i] = acc;
	        return mod(acc * num, p);
	    }, _1n);
	    const inverted = invert(lastMultiplied, p);
	    nums.reduceRight((acc, num, i) => {
	        if (num === _0n)
	            return acc;
	        scratch[i] = mod(acc * scratch[i], p);
	        return mod(acc * num, p);
	    }, inverted);
	    return scratch;
	}
	function bits2int_2(bytes) {
	    const delta = bytes.length * 8 - groupLen * 8;
	    const num = bytesToNumber$1(bytes);
	    return delta > 0 ? num >> BigInt(delta) : num;
	}
	function truncateHash(hash, truncateOnly = false) {
	    const h = bits2int_2(hash);
	    if (truncateOnly)
	        return h;
	    const { n } = CURVE;
	    return h >= n ? h - n : h;
	}
	let _sha256Sync;
	let _hmacSha256Sync;
	class HmacDrbg {
	    constructor(hashLen, qByteLen) {
	        this.hashLen = hashLen;
	        this.qByteLen = qByteLen;
	        if (typeof hashLen !== 'number' || hashLen < 2)
	            throw new Error('hashLen must be a number');
	        if (typeof qByteLen !== 'number' || qByteLen < 2)
	            throw new Error('qByteLen must be a number');
	        this.v = new Uint8Array(hashLen).fill(1);
	        this.k = new Uint8Array(hashLen).fill(0);
	        this.counter = 0;
	    }
	    hmac(...values) {
	        return utils$m.hmacSha256(this.k, ...values);
	    }
	    hmacSync(...values) {
	        return _hmacSha256Sync(this.k, ...values);
	    }
	    checkSync() {
	        if (typeof _hmacSha256Sync !== 'function')
	            throw new ShaError('hmacSha256Sync needs to be set');
	    }
	    incr() {
	        if (this.counter >= 1000)
	            throw new Error('Tried 1,000 k values for sign(), all were invalid');
	        this.counter += 1;
	    }
	    async reseed(seed = new Uint8Array()) {
	        this.k = await this.hmac(this.v, Uint8Array.from([0x00]), seed);
	        this.v = await this.hmac(this.v);
	        if (seed.length === 0)
	            return;
	        this.k = await this.hmac(this.v, Uint8Array.from([0x01]), seed);
	        this.v = await this.hmac(this.v);
	    }
	    reseedSync(seed = new Uint8Array()) {
	        this.checkSync();
	        this.k = this.hmacSync(this.v, Uint8Array.from([0x00]), seed);
	        this.v = this.hmacSync(this.v);
	        if (seed.length === 0)
	            return;
	        this.k = this.hmacSync(this.v, Uint8Array.from([0x01]), seed);
	        this.v = this.hmacSync(this.v);
	    }
	    async generate() {
	        this.incr();
	        let len = 0;
	        const out = [];
	        while (len < this.qByteLen) {
	            this.v = await this.hmac(this.v);
	            const sl = this.v.slice();
	            out.push(sl);
	            len += this.v.length;
	        }
	        return concatBytes$1(...out);
	    }
	    generateSync() {
	        this.checkSync();
	        this.incr();
	        let len = 0;
	        const out = [];
	        while (len < this.qByteLen) {
	            this.v = this.hmacSync(this.v);
	            const sl = this.v.slice();
	            out.push(sl);
	            len += this.v.length;
	        }
	        return concatBytes$1(...out);
	    }
	}
	function isWithinCurveOrder(num) {
	    return _0n < num && num < CURVE.n;
	}
	function isValidFieldElement(num) {
	    return _0n < num && num < CURVE.P;
	}
	function kmdToSig(kBytes, m, d, lowS = true) {
	    const { n } = CURVE;
	    const k = truncateHash(kBytes, true);
	    if (!isWithinCurveOrder(k))
	        return;
	    const kinv = invert(k, n);
	    const q = Point$3.BASE.multiply(k);
	    const r = mod(q.x, n);
	    if (r === _0n)
	        return;
	    const s = mod(kinv * mod(m + d * r, n), n);
	    if (s === _0n)
	        return;
	    let sig = new Signature$4(r, s);
	    let recovery = (q.x === sig.r ? 0 : 2) | Number(q.y & _1n);
	    if (lowS && sig.hasHighS()) {
	        sig = sig.normalizeS();
	        recovery ^= 1;
	    }
	    return { sig, recovery };
	}
	function normalizePrivateKey(key) {
	    let num;
	    if (typeof key === 'bigint') {
	        num = key;
	    }
	    else if (typeof key === 'number' && Number.isSafeInteger(key) && key > 0) {
	        num = BigInt(key);
	    }
	    else if (typeof key === 'string') {
	        if (key.length !== 2 * groupLen)
	            throw new Error('Expected 32 bytes of private key');
	        num = hexToNumber$1(key);
	    }
	    else if (key instanceof Uint8Array) {
	        if (key.length !== groupLen)
	            throw new Error('Expected 32 bytes of private key');
	        num = bytesToNumber$1(key);
	    }
	    else {
	        throw new TypeError('Expected valid private key');
	    }
	    if (!isWithinCurveOrder(num))
	        throw new Error('Expected private key: 0 < key < n');
	    return num;
	}
	function normalizePublicKey(publicKey) {
	    if (publicKey instanceof Point$3) {
	        publicKey.assertValidity();
	        return publicKey;
	    }
	    else {
	        return Point$3.fromHex(publicKey);
	    }
	}
	function normalizeSignature(signature) {
	    if (signature instanceof Signature$4) {
	        signature.assertValidity();
	        return signature;
	    }
	    try {
	        return Signature$4.fromDER(signature);
	    }
	    catch (error) {
	        return Signature$4.fromCompact(signature);
	    }
	}
	function getPublicKey(privateKey, isCompressed = false) {
	    return Point$3.fromPrivateKey(privateKey).toRawBytes(isCompressed);
	}
	function recoverPublicKey(msgHash, signature, recovery, isCompressed = false) {
	    return Point$3.fromSignature(msgHash, signature, recovery).toRawBytes(isCompressed);
	}
	function isProbPub(item) {
	    const arr = item instanceof Uint8Array;
	    const str = typeof item === 'string';
	    const len = (arr || str) && item.length;
	    if (arr)
	        return len === compressedLen || len === uncompressedLen;
	    if (str)
	        return len === compressedLen * 2 || len === uncompressedLen * 2;
	    if (item instanceof Point$3)
	        return true;
	    return false;
	}
	function getSharedSecret(privateA, publicB, isCompressed = false) {
	    if (isProbPub(privateA))
	        throw new TypeError('getSharedSecret: first arg must be private key');
	    if (!isProbPub(publicB))
	        throw new TypeError('getSharedSecret: second arg must be public key');
	    const b = normalizePublicKey(publicB);
	    b.assertValidity();
	    return b.multiply(normalizePrivateKey(privateA)).toRawBytes(isCompressed);
	}
	function bits2int(bytes) {
	    const slice = bytes.length > fieldLen ? bytes.slice(0, fieldLen) : bytes;
	    return bytesToNumber$1(slice);
	}
	function bits2octets(bytes) {
	    const z1 = bits2int(bytes);
	    const z2 = mod(z1, CURVE.n);
	    return int2octets(z2 < _0n ? z1 : z2);
	}
	function int2octets(num) {
	    return numTo32b(num);
	}
	function initSigArgs(msgHash, privateKey, extraEntropy) {
	    if (msgHash == null)
	        throw new Error(`sign: expected valid message hash, not "${msgHash}"`);
	    const h1 = ensureBytes(msgHash);
	    const d = normalizePrivateKey(privateKey);
	    const seedArgs = [int2octets(d), bits2octets(h1)];
	    if (extraEntropy != null) {
	        if (extraEntropy === true)
	            extraEntropy = utils$m.randomBytes(fieldLen);
	        const e = ensureBytes(extraEntropy);
	        if (e.length !== fieldLen)
	            throw new Error(`sign: Expected ${fieldLen} bytes of extra data`);
	        seedArgs.push(e);
	    }
	    const seed = concatBytes$1(...seedArgs);
	    const m = bits2int(h1);
	    return { seed, m, d };
	}
	function finalizeSig(recSig, opts) {
	    const { sig, recovery } = recSig;
	    const { der, recovered } = Object.assign({ canonical: true, der: true }, opts);
	    const hashed = der ? sig.toDERRawBytes() : sig.toCompactRawBytes();
	    return recovered ? [hashed, recovery] : hashed;
	}
	async function sign(msgHash, privKey, opts = {}) {
	    const { seed, m, d } = initSigArgs(msgHash, privKey, opts.extraEntropy);
	    const drbg = new HmacDrbg(hashLen, groupLen);
	    await drbg.reseed(seed);
	    let sig;
	    while (!(sig = kmdToSig(await drbg.generate(), m, d, opts.canonical)))
	        await drbg.reseed();
	    return finalizeSig(sig, opts);
	}
	const vopts = { strict: true };
	function verify(signature, msgHash, publicKey, opts = vopts) {
	    let sig;
	    try {
	        sig = normalizeSignature(signature);
	        msgHash = ensureBytes(msgHash);
	    }
	    catch (error) {
	        return false;
	    }
	    const { r, s } = sig;
	    if (opts.strict && sig.hasHighS())
	        return false;
	    const h = truncateHash(msgHash);
	    let P;
	    try {
	        P = normalizePublicKey(publicKey);
	    }
	    catch (error) {
	        return false;
	    }
	    const { n } = CURVE;
	    const sinv = invert(s, n);
	    const u1 = mod(h * sinv, n);
	    const u2 = mod(r * sinv, n);
	    const R = Point$3.BASE.multiplyAndAddUnsafe(P, u1, u2);
	    if (!R)
	        return false;
	    const v = mod(R.x, n);
	    return v === r;
	}
	Point$3.BASE._setWindowSize(8);
	const crypto$3 = {
	    node: nodeCrypto,
	    web: typeof self === 'object' && 'crypto' in self ? self.crypto : undefined,
	};
	const TAGGED_HASH_PREFIXES = {};
	const utils$m = {
	    bytesToHex: bytesToHex$1,
	    hexToBytes: hexToBytes$1,
	    concatBytes: concatBytes$1,
	    mod,
	    invert,
	    isValidPrivateKey(privateKey) {
	        try {
	            normalizePrivateKey(privateKey);
	            return true;
	        }
	        catch (error) {
	            return false;
	        }
	    },
	    _bigintTo32Bytes: numTo32b,
	    _normalizePrivateKey: normalizePrivateKey,
	    hashToPrivateKey: (hash) => {
	        hash = ensureBytes(hash);
	        const minLen = groupLen + 8;
	        if (hash.length < minLen || hash.length > 1024) {
	            throw new Error(`Expected valid bytes of private key as per FIPS 186`);
	        }
	        const num = mod(bytesToNumber$1(hash), CURVE.n - _1n) + _1n;
	        return numTo32b(num);
	    },
	    randomBytes: (bytesLength = 32) => {
	        if (crypto$3.web) {
	            return crypto$3.web.getRandomValues(new Uint8Array(bytesLength));
	        }
	        else if (crypto$3.node) {
	            const { randomBytes } = crypto$3.node;
	            return Uint8Array.from(randomBytes(bytesLength));
	        }
	        else {
	            throw new Error("The environment doesn't have randomBytes function");
	        }
	    },
	    randomPrivateKey: () => utils$m.hashToPrivateKey(utils$m.randomBytes(groupLen + 8)),
	    precompute(windowSize = 8, point = Point$3.BASE) {
	        const cached = point === Point$3.BASE ? point : new Point$3(point.x, point.y);
	        cached._setWindowSize(windowSize);
	        cached.multiply(_3n);
	        return cached;
	    },
	    sha256: async (...messages) => {
	        if (crypto$3.web) {
	            const buffer = await crypto$3.web.subtle.digest('SHA-256', concatBytes$1(...messages));
	            return new Uint8Array(buffer);
	        }
	        else if (crypto$3.node) {
	            const { createHash } = crypto$3.node;
	            const hash = createHash('sha256');
	            messages.forEach((m) => hash.update(m));
	            return Uint8Array.from(hash.digest());
	        }
	        else {
	            throw new Error("The environment doesn't have sha256 function");
	        }
	    },
	    hmacSha256: async (key, ...messages) => {
	        if (crypto$3.web) {
	            const ckey = await crypto$3.web.subtle.importKey('raw', key, { name: 'HMAC', hash: { name: 'SHA-256' } }, false, ['sign']);
	            const message = concatBytes$1(...messages);
	            const buffer = await crypto$3.web.subtle.sign('HMAC', ckey, message);
	            return new Uint8Array(buffer);
	        }
	        else if (crypto$3.node) {
	            const { createHmac } = crypto$3.node;
	            const hash = createHmac('sha256', key);
	            messages.forEach((m) => hash.update(m));
	            return Uint8Array.from(hash.digest());
	        }
	        else {
	            throw new Error("The environment doesn't have hmac-sha256 function");
	        }
	    },
	    sha256Sync: undefined,
	    hmacSha256Sync: undefined,
	    taggedHash: async (tag, ...messages) => {
	        let tagP = TAGGED_HASH_PREFIXES[tag];
	        if (tagP === undefined) {
	            const tagH = await utils$m.sha256(Uint8Array.from(tag, (c) => c.charCodeAt(0)));
	            tagP = concatBytes$1(tagH, tagH);
	            TAGGED_HASH_PREFIXES[tag] = tagP;
	        }
	        return utils$m.sha256(tagP, ...messages);
	    },
	    taggedHashSync: (tag, ...messages) => {
	        if (typeof _sha256Sync !== 'function')
	            throw new ShaError('sha256Sync is undefined, you need to set it');
	        let tagP = TAGGED_HASH_PREFIXES[tag];
	        if (tagP === undefined) {
	            const tagH = _sha256Sync(Uint8Array.from(tag, (c) => c.charCodeAt(0)));
	            tagP = concatBytes$1(tagH, tagH);
	            TAGGED_HASH_PREFIXES[tag] = tagP;
	        }
	        return _sha256Sync(tagP, ...messages);
	    },
	    _JacobianPoint: JacobianPoint,
	};
	Object.defineProperties(utils$m, {
	    sha256Sync: {
	        configurable: false,
	        get() {
	            return _sha256Sync;
	        },
	        set(val) {
	            if (!_sha256Sync)
	                _sha256Sync = val;
	        },
	    },
	    hmacSha256Sync: {
	        configurable: false,
	        get() {
	            return _hmacSha256Sync;
	        },
	        set(val) {
	            if (!_hmacSha256Sync)
	                _hmacSha256Sync = val;
	        },
	    },
	});

	const E_CANCELED = new Error('request for lock canceled');

	var __awaiter$2 = function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	let Semaphore$2 = class Semaphore {
	    constructor(_value, _cancelError = E_CANCELED) {
	        this._value = _value;
	        this._cancelError = _cancelError;
	        this._weightedQueues = [];
	        this._weightedWaiters = [];
	    }
	    acquire(weight = 1) {
	        if (weight <= 0)
	            throw new Error(`invalid weight ${weight}: must be positive`);
	        return new Promise((resolve, reject) => {
	            if (!this._weightedQueues[weight - 1])
	                this._weightedQueues[weight - 1] = [];
	            this._weightedQueues[weight - 1].push({ resolve, reject });
	            this._dispatch();
	        });
	    }
	    runExclusive(callback, weight = 1) {
	        return __awaiter$2(this, void 0, void 0, function* () {
	            const [value, release] = yield this.acquire(weight);
	            try {
	                return yield callback(value);
	            }
	            finally {
	                release();
	            }
	        });
	    }
	    waitForUnlock(weight = 1) {
	        if (weight <= 0)
	            throw new Error(`invalid weight ${weight}: must be positive`);
	        return new Promise((resolve) => {
	            if (!this._weightedWaiters[weight - 1])
	                this._weightedWaiters[weight - 1] = [];
	            this._weightedWaiters[weight - 1].push(resolve);
	            this._dispatch();
	        });
	    }
	    isLocked() {
	        return this._value <= 0;
	    }
	    getValue() {
	        return this._value;
	    }
	    setValue(value) {
	        this._value = value;
	        this._dispatch();
	    }
	    release(weight = 1) {
	        if (weight <= 0)
	            throw new Error(`invalid weight ${weight}: must be positive`);
	        this._value += weight;
	        this._dispatch();
	    }
	    cancel() {
	        this._weightedQueues.forEach((queue) => queue.forEach((entry) => entry.reject(this._cancelError)));
	        this._weightedQueues = [];
	    }
	    _dispatch() {
	        var _a;
	        for (let weight = this._value; weight > 0; weight--) {
	            const queueEntry = (_a = this._weightedQueues[weight - 1]) === null || _a === void 0 ? void 0 : _a.shift();
	            if (!queueEntry)
	                continue;
	            const previousValue = this._value;
	            const previousWeight = weight;
	            this._value -= weight;
	            weight = this._value + 1;
	            queueEntry.resolve([previousValue, this._newReleaser(previousWeight)]);
	        }
	        this._drainUnlockWaiters();
	    }
	    _newReleaser(weight) {
	        let called = false;
	        return () => {
	            if (called)
	                return;
	            called = true;
	            this.release(weight);
	        };
	    }
	    _drainUnlockWaiters() {
	        for (let weight = this._value; weight > 0; weight--) {
	            if (!this._weightedWaiters[weight - 1])
	                continue;
	            this._weightedWaiters[weight - 1].forEach((waiter) => waiter());
	            this._weightedWaiters[weight - 1] = [];
	        }
	    }
	};

	var __awaiter$1 = function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	let Mutex$3 = class Mutex {
	    constructor(cancelError) {
	        this._semaphore = new Semaphore$2(1, cancelError);
	    }
	    acquire() {
	        return __awaiter$1(this, void 0, void 0, function* () {
	            const [, releaser] = yield this._semaphore.acquire();
	            return releaser;
	        });
	    }
	    runExclusive(callback) {
	        return this._semaphore.runExclusive(() => callback());
	    }
	    isLocked() {
	        return this._semaphore.isLocked();
	    }
	    waitForUnlock() {
	        return this._semaphore.waitForUnlock();
	    }
	    release() {
	        if (this._semaphore.isLocked())
	            this._semaphore.release();
	    }
	    cancel() {
	        return this._semaphore.cancel();
	    }
	};

	var elliptic = {};

	var name$1 = "elliptic";
	var version$3 = "6.5.4";
	var description$1 = "EC cryptography";
	var main$1 = "lib/elliptic.js";
	var files = [
		"lib"
	];
	var scripts$1 = {
		lint: "eslint lib test",
		"lint:fix": "npm run lint -- --fix",
		unit: "istanbul test _mocha --reporter=spec test/index.js",
		test: "npm run lint && npm run unit",
		version: "grunt dist && git add dist/"
	};
	var repository$1 = {
		type: "git",
		url: "git@github.com:indutny/elliptic"
	};
	var keywords$1 = [
		"EC",
		"Elliptic",
		"curve",
		"Cryptography"
	];
	var author$1 = "Fedor Indutny <fedor@indutny.com>";
	var license$1 = "MIT";
	var bugs = {
		url: "https://github.com/indutny/elliptic/issues"
	};
	var homepage = "https://github.com/indutny/elliptic";
	var devDependencies$1 = {
		brfs: "^2.0.2",
		coveralls: "^3.1.0",
		eslint: "^7.6.0",
		grunt: "^1.2.1",
		"grunt-browserify": "^5.3.0",
		"grunt-cli": "^1.3.2",
		"grunt-contrib-connect": "^3.0.0",
		"grunt-contrib-copy": "^1.0.0",
		"grunt-contrib-uglify": "^5.0.0",
		"grunt-mocha-istanbul": "^5.0.2",
		"grunt-saucelabs": "^9.0.1",
		istanbul: "^0.4.5",
		mocha: "^8.0.1"
	};
	var dependencies$1 = {
		"bn.js": "^4.11.9",
		brorand: "^1.1.0",
		"hash.js": "^1.0.0",
		"hmac-drbg": "^1.0.1",
		inherits: "^2.0.4",
		"minimalistic-assert": "^1.0.1",
		"minimalistic-crypto-utils": "^1.0.1"
	};
	var require$$0$3 = {
		name: name$1,
		version: version$3,
		description: description$1,
		main: main$1,
		files: files,
		scripts: scripts$1,
		repository: repository$1,
		keywords: keywords$1,
		author: author$1,
		license: license$1,
		bugs: bugs,
		homepage: homepage,
		devDependencies: devDependencies$1,
		dependencies: dependencies$1
	};

	var utils$l = {};

	var bn = {exports: {}};

	bn.exports;

	(function (module) {
		(function (module, exports) {

		  // Utils
		  function assert (val, msg) {
		    if (!val) throw new Error(msg || 'Assertion failed');
		  }

		  // Could use `inherits` module, but don't want to move from single file
		  // architecture yet.
		  function inherits (ctor, superCtor) {
		    ctor.super_ = superCtor;
		    var TempCtor = function () {};
		    TempCtor.prototype = superCtor.prototype;
		    ctor.prototype = new TempCtor();
		    ctor.prototype.constructor = ctor;
		  }

		  // BN

		  function BN (number, base, endian) {
		    if (BN.isBN(number)) {
		      return number;
		    }

		    this.negative = 0;
		    this.words = null;
		    this.length = 0;

		    // Reduction context
		    this.red = null;

		    if (number !== null) {
		      if (base === 'le' || base === 'be') {
		        endian = base;
		        base = 10;
		      }

		      this._init(number || 0, base || 10, endian || 'be');
		    }
		  }
		  if (typeof module === 'object') {
		    module.exports = BN;
		  } else {
		    exports.BN = BN;
		  }

		  BN.BN = BN;
		  BN.wordSize = 26;

		  var Buffer;
		  try {
		    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
		      Buffer = window.Buffer;
		    } else {
		      Buffer = require$$3.Buffer;
		    }
		  } catch (e) {
		  }

		  BN.isBN = function isBN (num) {
		    if (num instanceof BN) {
		      return true;
		    }

		    return num !== null && typeof num === 'object' &&
		      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
		  };

		  BN.max = function max (left, right) {
		    if (left.cmp(right) > 0) return left;
		    return right;
		  };

		  BN.min = function min (left, right) {
		    if (left.cmp(right) < 0) return left;
		    return right;
		  };

		  BN.prototype._init = function init (number, base, endian) {
		    if (typeof number === 'number') {
		      return this._initNumber(number, base, endian);
		    }

		    if (typeof number === 'object') {
		      return this._initArray(number, base, endian);
		    }

		    if (base === 'hex') {
		      base = 16;
		    }
		    assert(base === (base | 0) && base >= 2 && base <= 36);

		    number = number.toString().replace(/\s+/g, '');
		    var start = 0;
		    if (number[0] === '-') {
		      start++;
		      this.negative = 1;
		    }

		    if (start < number.length) {
		      if (base === 16) {
		        this._parseHex(number, start, endian);
		      } else {
		        this._parseBase(number, base, start);
		        if (endian === 'le') {
		          this._initArray(this.toArray(), base, endian);
		        }
		      }
		    }
		  };

		  BN.prototype._initNumber = function _initNumber (number, base, endian) {
		    if (number < 0) {
		      this.negative = 1;
		      number = -number;
		    }
		    if (number < 0x4000000) {
		      this.words = [ number & 0x3ffffff ];
		      this.length = 1;
		    } else if (number < 0x10000000000000) {
		      this.words = [
		        number & 0x3ffffff,
		        (number / 0x4000000) & 0x3ffffff
		      ];
		      this.length = 2;
		    } else {
		      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
		      this.words = [
		        number & 0x3ffffff,
		        (number / 0x4000000) & 0x3ffffff,
		        1
		      ];
		      this.length = 3;
		    }

		    if (endian !== 'le') return;

		    // Reverse the bytes
		    this._initArray(this.toArray(), base, endian);
		  };

		  BN.prototype._initArray = function _initArray (number, base, endian) {
		    // Perhaps a Uint8Array
		    assert(typeof number.length === 'number');
		    if (number.length <= 0) {
		      this.words = [ 0 ];
		      this.length = 1;
		      return this;
		    }

		    this.length = Math.ceil(number.length / 3);
		    this.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      this.words[i] = 0;
		    }

		    var j, w;
		    var off = 0;
		    if (endian === 'be') {
		      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
		        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
		        this.words[j] |= (w << off) & 0x3ffffff;
		        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
		        off += 24;
		        if (off >= 26) {
		          off -= 26;
		          j++;
		        }
		      }
		    } else if (endian === 'le') {
		      for (i = 0, j = 0; i < number.length; i += 3) {
		        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
		        this.words[j] |= (w << off) & 0x3ffffff;
		        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
		        off += 24;
		        if (off >= 26) {
		          off -= 26;
		          j++;
		        }
		      }
		    }
		    return this.strip();
		  };

		  function parseHex4Bits (string, index) {
		    var c = string.charCodeAt(index);
		    // 'A' - 'F'
		    if (c >= 65 && c <= 70) {
		      return c - 55;
		    // 'a' - 'f'
		    } else if (c >= 97 && c <= 102) {
		      return c - 87;
		    // '0' - '9'
		    } else {
		      return (c - 48) & 0xf;
		    }
		  }

		  function parseHexByte (string, lowerBound, index) {
		    var r = parseHex4Bits(string, index);
		    if (index - 1 >= lowerBound) {
		      r |= parseHex4Bits(string, index - 1) << 4;
		    }
		    return r;
		  }

		  BN.prototype._parseHex = function _parseHex (number, start, endian) {
		    // Create possibly bigger array to ensure that it fits the number
		    this.length = Math.ceil((number.length - start) / 6);
		    this.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      this.words[i] = 0;
		    }

		    // 24-bits chunks
		    var off = 0;
		    var j = 0;

		    var w;
		    if (endian === 'be') {
		      for (i = number.length - 1; i >= start; i -= 2) {
		        w = parseHexByte(number, start, i) << off;
		        this.words[j] |= w & 0x3ffffff;
		        if (off >= 18) {
		          off -= 18;
		          j += 1;
		          this.words[j] |= w >>> 26;
		        } else {
		          off += 8;
		        }
		      }
		    } else {
		      var parseLength = number.length - start;
		      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
		        w = parseHexByte(number, start, i) << off;
		        this.words[j] |= w & 0x3ffffff;
		        if (off >= 18) {
		          off -= 18;
		          j += 1;
		          this.words[j] |= w >>> 26;
		        } else {
		          off += 8;
		        }
		      }
		    }

		    this.strip();
		  };

		  function parseBase (str, start, end, mul) {
		    var r = 0;
		    var len = Math.min(str.length, end);
		    for (var i = start; i < len; i++) {
		      var c = str.charCodeAt(i) - 48;

		      r *= mul;

		      // 'a'
		      if (c >= 49) {
		        r += c - 49 + 0xa;

		      // 'A'
		      } else if (c >= 17) {
		        r += c - 17 + 0xa;

		      // '0' - '9'
		      } else {
		        r += c;
		      }
		    }
		    return r;
		  }

		  BN.prototype._parseBase = function _parseBase (number, base, start) {
		    // Initialize as zero
		    this.words = [ 0 ];
		    this.length = 1;

		    // Find length of limb in base
		    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
		      limbLen++;
		    }
		    limbLen--;
		    limbPow = (limbPow / base) | 0;

		    var total = number.length - start;
		    var mod = total % limbLen;
		    var end = Math.min(total, total - mod) + start;

		    var word = 0;
		    for (var i = start; i < end; i += limbLen) {
		      word = parseBase(number, i, i + limbLen, base);

		      this.imuln(limbPow);
		      if (this.words[0] + word < 0x4000000) {
		        this.words[0] += word;
		      } else {
		        this._iaddn(word);
		      }
		    }

		    if (mod !== 0) {
		      var pow = 1;
		      word = parseBase(number, i, number.length, base);

		      for (i = 0; i < mod; i++) {
		        pow *= base;
		      }

		      this.imuln(pow);
		      if (this.words[0] + word < 0x4000000) {
		        this.words[0] += word;
		      } else {
		        this._iaddn(word);
		      }
		    }

		    this.strip();
		  };

		  BN.prototype.copy = function copy (dest) {
		    dest.words = new Array(this.length);
		    for (var i = 0; i < this.length; i++) {
		      dest.words[i] = this.words[i];
		    }
		    dest.length = this.length;
		    dest.negative = this.negative;
		    dest.red = this.red;
		  };

		  BN.prototype.clone = function clone () {
		    var r = new BN(null);
		    this.copy(r);
		    return r;
		  };

		  BN.prototype._expand = function _expand (size) {
		    while (this.length < size) {
		      this.words[this.length++] = 0;
		    }
		    return this;
		  };

		  // Remove leading `0` from `this`
		  BN.prototype.strip = function strip () {
		    while (this.length > 1 && this.words[this.length - 1] === 0) {
		      this.length--;
		    }
		    return this._normSign();
		  };

		  BN.prototype._normSign = function _normSign () {
		    // -0 = 0
		    if (this.length === 1 && this.words[0] === 0) {
		      this.negative = 0;
		    }
		    return this;
		  };

		  BN.prototype.inspect = function inspect () {
		    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
		  };

		  /*

		  var zeros = [];
		  var groupSizes = [];
		  var groupBases = [];

		  var s = '';
		  var i = -1;
		  while (++i < BN.wordSize) {
		    zeros[i] = s;
		    s += '0';
		  }
		  groupSizes[0] = 0;
		  groupSizes[1] = 0;
		  groupBases[0] = 0;
		  groupBases[1] = 0;
		  var base = 2 - 1;
		  while (++base < 36 + 1) {
		    var groupSize = 0;
		    var groupBase = 1;
		    while (groupBase < (1 << BN.wordSize) / base) {
		      groupBase *= base;
		      groupSize += 1;
		    }
		    groupSizes[base] = groupSize;
		    groupBases[base] = groupBase;
		  }

		  */

		  var zeros = [
		    '',
		    '0',
		    '00',
		    '000',
		    '0000',
		    '00000',
		    '000000',
		    '0000000',
		    '00000000',
		    '000000000',
		    '0000000000',
		    '00000000000',
		    '000000000000',
		    '0000000000000',
		    '00000000000000',
		    '000000000000000',
		    '0000000000000000',
		    '00000000000000000',
		    '000000000000000000',
		    '0000000000000000000',
		    '00000000000000000000',
		    '000000000000000000000',
		    '0000000000000000000000',
		    '00000000000000000000000',
		    '000000000000000000000000',
		    '0000000000000000000000000'
		  ];

		  var groupSizes = [
		    0, 0,
		    25, 16, 12, 11, 10, 9, 8,
		    8, 7, 7, 7, 7, 6, 6,
		    6, 6, 6, 6, 6, 5, 5,
		    5, 5, 5, 5, 5, 5, 5,
		    5, 5, 5, 5, 5, 5, 5
		  ];

		  var groupBases = [
		    0, 0,
		    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
		    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
		    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
		    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
		    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
		  ];

		  BN.prototype.toString = function toString (base, padding) {
		    base = base || 10;
		    padding = padding | 0 || 1;

		    var out;
		    if (base === 16 || base === 'hex') {
		      out = '';
		      var off = 0;
		      var carry = 0;
		      for (var i = 0; i < this.length; i++) {
		        var w = this.words[i];
		        var word = (((w << off) | carry) & 0xffffff).toString(16);
		        carry = (w >>> (24 - off)) & 0xffffff;
		        if (carry !== 0 || i !== this.length - 1) {
		          out = zeros[6 - word.length] + word + out;
		        } else {
		          out = word + out;
		        }
		        off += 2;
		        if (off >= 26) {
		          off -= 26;
		          i--;
		        }
		      }
		      if (carry !== 0) {
		        out = carry.toString(16) + out;
		      }
		      while (out.length % padding !== 0) {
		        out = '0' + out;
		      }
		      if (this.negative !== 0) {
		        out = '-' + out;
		      }
		      return out;
		    }

		    if (base === (base | 0) && base >= 2 && base <= 36) {
		      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
		      var groupSize = groupSizes[base];
		      // var groupBase = Math.pow(base, groupSize);
		      var groupBase = groupBases[base];
		      out = '';
		      var c = this.clone();
		      c.negative = 0;
		      while (!c.isZero()) {
		        var r = c.modn(groupBase).toString(base);
		        c = c.idivn(groupBase);

		        if (!c.isZero()) {
		          out = zeros[groupSize - r.length] + r + out;
		        } else {
		          out = r + out;
		        }
		      }
		      if (this.isZero()) {
		        out = '0' + out;
		      }
		      while (out.length % padding !== 0) {
		        out = '0' + out;
		      }
		      if (this.negative !== 0) {
		        out = '-' + out;
		      }
		      return out;
		    }

		    assert(false, 'Base should be between 2 and 36');
		  };

		  BN.prototype.toNumber = function toNumber () {
		    var ret = this.words[0];
		    if (this.length === 2) {
		      ret += this.words[1] * 0x4000000;
		    } else if (this.length === 3 && this.words[2] === 0x01) {
		      // NOTE: at this stage it is known that the top bit is set
		      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
		    } else if (this.length > 2) {
		      assert(false, 'Number can only safely store up to 53 bits');
		    }
		    return (this.negative !== 0) ? -ret : ret;
		  };

		  BN.prototype.toJSON = function toJSON () {
		    return this.toString(16);
		  };

		  BN.prototype.toBuffer = function toBuffer (endian, length) {
		    assert(typeof Buffer !== 'undefined');
		    return this.toArrayLike(Buffer, endian, length);
		  };

		  BN.prototype.toArray = function toArray (endian, length) {
		    return this.toArrayLike(Array, endian, length);
		  };

		  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
		    var byteLength = this.byteLength();
		    var reqLength = length || Math.max(1, byteLength);
		    assert(byteLength <= reqLength, 'byte array longer than desired length');
		    assert(reqLength > 0, 'Requested array length <= 0');

		    this.strip();
		    var littleEndian = endian === 'le';
		    var res = new ArrayType(reqLength);

		    var b, i;
		    var q = this.clone();
		    if (!littleEndian) {
		      // Assume big-endian
		      for (i = 0; i < reqLength - byteLength; i++) {
		        res[i] = 0;
		      }

		      for (i = 0; !q.isZero(); i++) {
		        b = q.andln(0xff);
		        q.iushrn(8);

		        res[reqLength - i - 1] = b;
		      }
		    } else {
		      for (i = 0; !q.isZero(); i++) {
		        b = q.andln(0xff);
		        q.iushrn(8);

		        res[i] = b;
		      }

		      for (; i < reqLength; i++) {
		        res[i] = 0;
		      }
		    }

		    return res;
		  };

		  if (Math.clz32) {
		    BN.prototype._countBits = function _countBits (w) {
		      return 32 - Math.clz32(w);
		    };
		  } else {
		    BN.prototype._countBits = function _countBits (w) {
		      var t = w;
		      var r = 0;
		      if (t >= 0x1000) {
		        r += 13;
		        t >>>= 13;
		      }
		      if (t >= 0x40) {
		        r += 7;
		        t >>>= 7;
		      }
		      if (t >= 0x8) {
		        r += 4;
		        t >>>= 4;
		      }
		      if (t >= 0x02) {
		        r += 2;
		        t >>>= 2;
		      }
		      return r + t;
		    };
		  }

		  BN.prototype._zeroBits = function _zeroBits (w) {
		    // Short-cut
		    if (w === 0) return 26;

		    var t = w;
		    var r = 0;
		    if ((t & 0x1fff) === 0) {
		      r += 13;
		      t >>>= 13;
		    }
		    if ((t & 0x7f) === 0) {
		      r += 7;
		      t >>>= 7;
		    }
		    if ((t & 0xf) === 0) {
		      r += 4;
		      t >>>= 4;
		    }
		    if ((t & 0x3) === 0) {
		      r += 2;
		      t >>>= 2;
		    }
		    if ((t & 0x1) === 0) {
		      r++;
		    }
		    return r;
		  };

		  // Return number of used bits in a BN
		  BN.prototype.bitLength = function bitLength () {
		    var w = this.words[this.length - 1];
		    var hi = this._countBits(w);
		    return (this.length - 1) * 26 + hi;
		  };

		  function toBitArray (num) {
		    var w = new Array(num.bitLength());

		    for (var bit = 0; bit < w.length; bit++) {
		      var off = (bit / 26) | 0;
		      var wbit = bit % 26;

		      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
		    }

		    return w;
		  }

		  // Number of trailing zero bits
		  BN.prototype.zeroBits = function zeroBits () {
		    if (this.isZero()) return 0;

		    var r = 0;
		    for (var i = 0; i < this.length; i++) {
		      var b = this._zeroBits(this.words[i]);
		      r += b;
		      if (b !== 26) break;
		    }
		    return r;
		  };

		  BN.prototype.byteLength = function byteLength () {
		    return Math.ceil(this.bitLength() / 8);
		  };

		  BN.prototype.toTwos = function toTwos (width) {
		    if (this.negative !== 0) {
		      return this.abs().inotn(width).iaddn(1);
		    }
		    return this.clone();
		  };

		  BN.prototype.fromTwos = function fromTwos (width) {
		    if (this.testn(width - 1)) {
		      return this.notn(width).iaddn(1).ineg();
		    }
		    return this.clone();
		  };

		  BN.prototype.isNeg = function isNeg () {
		    return this.negative !== 0;
		  };

		  // Return negative clone of `this`
		  BN.prototype.neg = function neg () {
		    return this.clone().ineg();
		  };

		  BN.prototype.ineg = function ineg () {
		    if (!this.isZero()) {
		      this.negative ^= 1;
		    }

		    return this;
		  };

		  // Or `num` with `this` in-place
		  BN.prototype.iuor = function iuor (num) {
		    while (this.length < num.length) {
		      this.words[this.length++] = 0;
		    }

		    for (var i = 0; i < num.length; i++) {
		      this.words[i] = this.words[i] | num.words[i];
		    }

		    return this.strip();
		  };

		  BN.prototype.ior = function ior (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuor(num);
		  };

		  // Or `num` with `this`
		  BN.prototype.or = function or (num) {
		    if (this.length > num.length) return this.clone().ior(num);
		    return num.clone().ior(this);
		  };

		  BN.prototype.uor = function uor (num) {
		    if (this.length > num.length) return this.clone().iuor(num);
		    return num.clone().iuor(this);
		  };

		  // And `num` with `this` in-place
		  BN.prototype.iuand = function iuand (num) {
		    // b = min-length(num, this)
		    var b;
		    if (this.length > num.length) {
		      b = num;
		    } else {
		      b = this;
		    }

		    for (var i = 0; i < b.length; i++) {
		      this.words[i] = this.words[i] & num.words[i];
		    }

		    this.length = b.length;

		    return this.strip();
		  };

		  BN.prototype.iand = function iand (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuand(num);
		  };

		  // And `num` with `this`
		  BN.prototype.and = function and (num) {
		    if (this.length > num.length) return this.clone().iand(num);
		    return num.clone().iand(this);
		  };

		  BN.prototype.uand = function uand (num) {
		    if (this.length > num.length) return this.clone().iuand(num);
		    return num.clone().iuand(this);
		  };

		  // Xor `num` with `this` in-place
		  BN.prototype.iuxor = function iuxor (num) {
		    // a.length > b.length
		    var a;
		    var b;
		    if (this.length > num.length) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    for (var i = 0; i < b.length; i++) {
		      this.words[i] = a.words[i] ^ b.words[i];
		    }

		    if (this !== a) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    this.length = a.length;

		    return this.strip();
		  };

		  BN.prototype.ixor = function ixor (num) {
		    assert((this.negative | num.negative) === 0);
		    return this.iuxor(num);
		  };

		  // Xor `num` with `this`
		  BN.prototype.xor = function xor (num) {
		    if (this.length > num.length) return this.clone().ixor(num);
		    return num.clone().ixor(this);
		  };

		  BN.prototype.uxor = function uxor (num) {
		    if (this.length > num.length) return this.clone().iuxor(num);
		    return num.clone().iuxor(this);
		  };

		  // Not ``this`` with ``width`` bitwidth
		  BN.prototype.inotn = function inotn (width) {
		    assert(typeof width === 'number' && width >= 0);

		    var bytesNeeded = Math.ceil(width / 26) | 0;
		    var bitsLeft = width % 26;

		    // Extend the buffer with leading zeroes
		    this._expand(bytesNeeded);

		    if (bitsLeft > 0) {
		      bytesNeeded--;
		    }

		    // Handle complete words
		    for (var i = 0; i < bytesNeeded; i++) {
		      this.words[i] = ~this.words[i] & 0x3ffffff;
		    }

		    // Handle the residue
		    if (bitsLeft > 0) {
		      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
		    }

		    // And remove leading zeroes
		    return this.strip();
		  };

		  BN.prototype.notn = function notn (width) {
		    return this.clone().inotn(width);
		  };

		  // Set `bit` of `this`
		  BN.prototype.setn = function setn (bit, val) {
		    assert(typeof bit === 'number' && bit >= 0);

		    var off = (bit / 26) | 0;
		    var wbit = bit % 26;

		    this._expand(off + 1);

		    if (val) {
		      this.words[off] = this.words[off] | (1 << wbit);
		    } else {
		      this.words[off] = this.words[off] & ~(1 << wbit);
		    }

		    return this.strip();
		  };

		  // Add `num` to `this` in-place
		  BN.prototype.iadd = function iadd (num) {
		    var r;

		    // negative + positive
		    if (this.negative !== 0 && num.negative === 0) {
		      this.negative = 0;
		      r = this.isub(num);
		      this.negative ^= 1;
		      return this._normSign();

		    // positive + negative
		    } else if (this.negative === 0 && num.negative !== 0) {
		      num.negative = 0;
		      r = this.isub(num);
		      num.negative = 1;
		      return r._normSign();
		    }

		    // a.length > b.length
		    var a, b;
		    if (this.length > num.length) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    var carry = 0;
		    for (var i = 0; i < b.length; i++) {
		      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
		      this.words[i] = r & 0x3ffffff;
		      carry = r >>> 26;
		    }
		    for (; carry !== 0 && i < a.length; i++) {
		      r = (a.words[i] | 0) + carry;
		      this.words[i] = r & 0x3ffffff;
		      carry = r >>> 26;
		    }

		    this.length = a.length;
		    if (carry !== 0) {
		      this.words[this.length] = carry;
		      this.length++;
		    // Copy the rest of the words
		    } else if (a !== this) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    return this;
		  };

		  // Add `num` to `this`
		  BN.prototype.add = function add (num) {
		    var res;
		    if (num.negative !== 0 && this.negative === 0) {
		      num.negative = 0;
		      res = this.sub(num);
		      num.negative ^= 1;
		      return res;
		    } else if (num.negative === 0 && this.negative !== 0) {
		      this.negative = 0;
		      res = num.sub(this);
		      this.negative = 1;
		      return res;
		    }

		    if (this.length > num.length) return this.clone().iadd(num);

		    return num.clone().iadd(this);
		  };

		  // Subtract `num` from `this` in-place
		  BN.prototype.isub = function isub (num) {
		    // this - (-num) = this + num
		    if (num.negative !== 0) {
		      num.negative = 0;
		      var r = this.iadd(num);
		      num.negative = 1;
		      return r._normSign();

		    // -this - num = -(this + num)
		    } else if (this.negative !== 0) {
		      this.negative = 0;
		      this.iadd(num);
		      this.negative = 1;
		      return this._normSign();
		    }

		    // At this point both numbers are positive
		    var cmp = this.cmp(num);

		    // Optimization - zeroify
		    if (cmp === 0) {
		      this.negative = 0;
		      this.length = 1;
		      this.words[0] = 0;
		      return this;
		    }

		    // a > b
		    var a, b;
		    if (cmp > 0) {
		      a = this;
		      b = num;
		    } else {
		      a = num;
		      b = this;
		    }

		    var carry = 0;
		    for (var i = 0; i < b.length; i++) {
		      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
		      carry = r >> 26;
		      this.words[i] = r & 0x3ffffff;
		    }
		    for (; carry !== 0 && i < a.length; i++) {
		      r = (a.words[i] | 0) + carry;
		      carry = r >> 26;
		      this.words[i] = r & 0x3ffffff;
		    }

		    // Copy rest of the words
		    if (carry === 0 && i < a.length && a !== this) {
		      for (; i < a.length; i++) {
		        this.words[i] = a.words[i];
		      }
		    }

		    this.length = Math.max(this.length, i);

		    if (a !== this) {
		      this.negative = 1;
		    }

		    return this.strip();
		  };

		  // Subtract `num` from `this`
		  BN.prototype.sub = function sub (num) {
		    return this.clone().isub(num);
		  };

		  function smallMulTo (self, num, out) {
		    out.negative = num.negative ^ self.negative;
		    var len = (self.length + num.length) | 0;
		    out.length = len;
		    len = (len - 1) | 0;

		    // Peel one iteration (compiler can't do it, because of code complexity)
		    var a = self.words[0] | 0;
		    var b = num.words[0] | 0;
		    var r = a * b;

		    var lo = r & 0x3ffffff;
		    var carry = (r / 0x4000000) | 0;
		    out.words[0] = lo;

		    for (var k = 1; k < len; k++) {
		      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
		      // note that ncarry could be >= 0x3ffffff
		      var ncarry = carry >>> 26;
		      var rword = carry & 0x3ffffff;
		      var maxJ = Math.min(k, num.length - 1);
		      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
		        var i = (k - j) | 0;
		        a = self.words[i] | 0;
		        b = num.words[j] | 0;
		        r = a * b + rword;
		        ncarry += (r / 0x4000000) | 0;
		        rword = r & 0x3ffffff;
		      }
		      out.words[k] = rword | 0;
		      carry = ncarry | 0;
		    }
		    if (carry !== 0) {
		      out.words[k] = carry | 0;
		    } else {
		      out.length--;
		    }

		    return out.strip();
		  }

		  // TODO(indutny): it may be reasonable to omit it for users who don't need
		  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
		  // multiplication (like elliptic secp256k1).
		  var comb10MulTo = function comb10MulTo (self, num, out) {
		    var a = self.words;
		    var b = num.words;
		    var o = out.words;
		    var c = 0;
		    var lo;
		    var mid;
		    var hi;
		    var a0 = a[0] | 0;
		    var al0 = a0 & 0x1fff;
		    var ah0 = a0 >>> 13;
		    var a1 = a[1] | 0;
		    var al1 = a1 & 0x1fff;
		    var ah1 = a1 >>> 13;
		    var a2 = a[2] | 0;
		    var al2 = a2 & 0x1fff;
		    var ah2 = a2 >>> 13;
		    var a3 = a[3] | 0;
		    var al3 = a3 & 0x1fff;
		    var ah3 = a3 >>> 13;
		    var a4 = a[4] | 0;
		    var al4 = a4 & 0x1fff;
		    var ah4 = a4 >>> 13;
		    var a5 = a[5] | 0;
		    var al5 = a5 & 0x1fff;
		    var ah5 = a5 >>> 13;
		    var a6 = a[6] | 0;
		    var al6 = a6 & 0x1fff;
		    var ah6 = a6 >>> 13;
		    var a7 = a[7] | 0;
		    var al7 = a7 & 0x1fff;
		    var ah7 = a7 >>> 13;
		    var a8 = a[8] | 0;
		    var al8 = a8 & 0x1fff;
		    var ah8 = a8 >>> 13;
		    var a9 = a[9] | 0;
		    var al9 = a9 & 0x1fff;
		    var ah9 = a9 >>> 13;
		    var b0 = b[0] | 0;
		    var bl0 = b0 & 0x1fff;
		    var bh0 = b0 >>> 13;
		    var b1 = b[1] | 0;
		    var bl1 = b1 & 0x1fff;
		    var bh1 = b1 >>> 13;
		    var b2 = b[2] | 0;
		    var bl2 = b2 & 0x1fff;
		    var bh2 = b2 >>> 13;
		    var b3 = b[3] | 0;
		    var bl3 = b3 & 0x1fff;
		    var bh3 = b3 >>> 13;
		    var b4 = b[4] | 0;
		    var bl4 = b4 & 0x1fff;
		    var bh4 = b4 >>> 13;
		    var b5 = b[5] | 0;
		    var bl5 = b5 & 0x1fff;
		    var bh5 = b5 >>> 13;
		    var b6 = b[6] | 0;
		    var bl6 = b6 & 0x1fff;
		    var bh6 = b6 >>> 13;
		    var b7 = b[7] | 0;
		    var bl7 = b7 & 0x1fff;
		    var bh7 = b7 >>> 13;
		    var b8 = b[8] | 0;
		    var bl8 = b8 & 0x1fff;
		    var bh8 = b8 >>> 13;
		    var b9 = b[9] | 0;
		    var bl9 = b9 & 0x1fff;
		    var bh9 = b9 >>> 13;

		    out.negative = self.negative ^ num.negative;
		    out.length = 19;
		    /* k = 0 */
		    lo = Math.imul(al0, bl0);
		    mid = Math.imul(al0, bh0);
		    mid = (mid + Math.imul(ah0, bl0)) | 0;
		    hi = Math.imul(ah0, bh0);
		    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
		    w0 &= 0x3ffffff;
		    /* k = 1 */
		    lo = Math.imul(al1, bl0);
		    mid = Math.imul(al1, bh0);
		    mid = (mid + Math.imul(ah1, bl0)) | 0;
		    hi = Math.imul(ah1, bh0);
		    lo = (lo + Math.imul(al0, bl1)) | 0;
		    mid = (mid + Math.imul(al0, bh1)) | 0;
		    mid = (mid + Math.imul(ah0, bl1)) | 0;
		    hi = (hi + Math.imul(ah0, bh1)) | 0;
		    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
		    w1 &= 0x3ffffff;
		    /* k = 2 */
		    lo = Math.imul(al2, bl0);
		    mid = Math.imul(al2, bh0);
		    mid = (mid + Math.imul(ah2, bl0)) | 0;
		    hi = Math.imul(ah2, bh0);
		    lo = (lo + Math.imul(al1, bl1)) | 0;
		    mid = (mid + Math.imul(al1, bh1)) | 0;
		    mid = (mid + Math.imul(ah1, bl1)) | 0;
		    hi = (hi + Math.imul(ah1, bh1)) | 0;
		    lo = (lo + Math.imul(al0, bl2)) | 0;
		    mid = (mid + Math.imul(al0, bh2)) | 0;
		    mid = (mid + Math.imul(ah0, bl2)) | 0;
		    hi = (hi + Math.imul(ah0, bh2)) | 0;
		    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
		    w2 &= 0x3ffffff;
		    /* k = 3 */
		    lo = Math.imul(al3, bl0);
		    mid = Math.imul(al3, bh0);
		    mid = (mid + Math.imul(ah3, bl0)) | 0;
		    hi = Math.imul(ah3, bh0);
		    lo = (lo + Math.imul(al2, bl1)) | 0;
		    mid = (mid + Math.imul(al2, bh1)) | 0;
		    mid = (mid + Math.imul(ah2, bl1)) | 0;
		    hi = (hi + Math.imul(ah2, bh1)) | 0;
		    lo = (lo + Math.imul(al1, bl2)) | 0;
		    mid = (mid + Math.imul(al1, bh2)) | 0;
		    mid = (mid + Math.imul(ah1, bl2)) | 0;
		    hi = (hi + Math.imul(ah1, bh2)) | 0;
		    lo = (lo + Math.imul(al0, bl3)) | 0;
		    mid = (mid + Math.imul(al0, bh3)) | 0;
		    mid = (mid + Math.imul(ah0, bl3)) | 0;
		    hi = (hi + Math.imul(ah0, bh3)) | 0;
		    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
		    w3 &= 0x3ffffff;
		    /* k = 4 */
		    lo = Math.imul(al4, bl0);
		    mid = Math.imul(al4, bh0);
		    mid = (mid + Math.imul(ah4, bl0)) | 0;
		    hi = Math.imul(ah4, bh0);
		    lo = (lo + Math.imul(al3, bl1)) | 0;
		    mid = (mid + Math.imul(al3, bh1)) | 0;
		    mid = (mid + Math.imul(ah3, bl1)) | 0;
		    hi = (hi + Math.imul(ah3, bh1)) | 0;
		    lo = (lo + Math.imul(al2, bl2)) | 0;
		    mid = (mid + Math.imul(al2, bh2)) | 0;
		    mid = (mid + Math.imul(ah2, bl2)) | 0;
		    hi = (hi + Math.imul(ah2, bh2)) | 0;
		    lo = (lo + Math.imul(al1, bl3)) | 0;
		    mid = (mid + Math.imul(al1, bh3)) | 0;
		    mid = (mid + Math.imul(ah1, bl3)) | 0;
		    hi = (hi + Math.imul(ah1, bh3)) | 0;
		    lo = (lo + Math.imul(al0, bl4)) | 0;
		    mid = (mid + Math.imul(al0, bh4)) | 0;
		    mid = (mid + Math.imul(ah0, bl4)) | 0;
		    hi = (hi + Math.imul(ah0, bh4)) | 0;
		    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
		    w4 &= 0x3ffffff;
		    /* k = 5 */
		    lo = Math.imul(al5, bl0);
		    mid = Math.imul(al5, bh0);
		    mid = (mid + Math.imul(ah5, bl0)) | 0;
		    hi = Math.imul(ah5, bh0);
		    lo = (lo + Math.imul(al4, bl1)) | 0;
		    mid = (mid + Math.imul(al4, bh1)) | 0;
		    mid = (mid + Math.imul(ah4, bl1)) | 0;
		    hi = (hi + Math.imul(ah4, bh1)) | 0;
		    lo = (lo + Math.imul(al3, bl2)) | 0;
		    mid = (mid + Math.imul(al3, bh2)) | 0;
		    mid = (mid + Math.imul(ah3, bl2)) | 0;
		    hi = (hi + Math.imul(ah3, bh2)) | 0;
		    lo = (lo + Math.imul(al2, bl3)) | 0;
		    mid = (mid + Math.imul(al2, bh3)) | 0;
		    mid = (mid + Math.imul(ah2, bl3)) | 0;
		    hi = (hi + Math.imul(ah2, bh3)) | 0;
		    lo = (lo + Math.imul(al1, bl4)) | 0;
		    mid = (mid + Math.imul(al1, bh4)) | 0;
		    mid = (mid + Math.imul(ah1, bl4)) | 0;
		    hi = (hi + Math.imul(ah1, bh4)) | 0;
		    lo = (lo + Math.imul(al0, bl5)) | 0;
		    mid = (mid + Math.imul(al0, bh5)) | 0;
		    mid = (mid + Math.imul(ah0, bl5)) | 0;
		    hi = (hi + Math.imul(ah0, bh5)) | 0;
		    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
		    w5 &= 0x3ffffff;
		    /* k = 6 */
		    lo = Math.imul(al6, bl0);
		    mid = Math.imul(al6, bh0);
		    mid = (mid + Math.imul(ah6, bl0)) | 0;
		    hi = Math.imul(ah6, bh0);
		    lo = (lo + Math.imul(al5, bl1)) | 0;
		    mid = (mid + Math.imul(al5, bh1)) | 0;
		    mid = (mid + Math.imul(ah5, bl1)) | 0;
		    hi = (hi + Math.imul(ah5, bh1)) | 0;
		    lo = (lo + Math.imul(al4, bl2)) | 0;
		    mid = (mid + Math.imul(al4, bh2)) | 0;
		    mid = (mid + Math.imul(ah4, bl2)) | 0;
		    hi = (hi + Math.imul(ah4, bh2)) | 0;
		    lo = (lo + Math.imul(al3, bl3)) | 0;
		    mid = (mid + Math.imul(al3, bh3)) | 0;
		    mid = (mid + Math.imul(ah3, bl3)) | 0;
		    hi = (hi + Math.imul(ah3, bh3)) | 0;
		    lo = (lo + Math.imul(al2, bl4)) | 0;
		    mid = (mid + Math.imul(al2, bh4)) | 0;
		    mid = (mid + Math.imul(ah2, bl4)) | 0;
		    hi = (hi + Math.imul(ah2, bh4)) | 0;
		    lo = (lo + Math.imul(al1, bl5)) | 0;
		    mid = (mid + Math.imul(al1, bh5)) | 0;
		    mid = (mid + Math.imul(ah1, bl5)) | 0;
		    hi = (hi + Math.imul(ah1, bh5)) | 0;
		    lo = (lo + Math.imul(al0, bl6)) | 0;
		    mid = (mid + Math.imul(al0, bh6)) | 0;
		    mid = (mid + Math.imul(ah0, bl6)) | 0;
		    hi = (hi + Math.imul(ah0, bh6)) | 0;
		    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
		    w6 &= 0x3ffffff;
		    /* k = 7 */
		    lo = Math.imul(al7, bl0);
		    mid = Math.imul(al7, bh0);
		    mid = (mid + Math.imul(ah7, bl0)) | 0;
		    hi = Math.imul(ah7, bh0);
		    lo = (lo + Math.imul(al6, bl1)) | 0;
		    mid = (mid + Math.imul(al6, bh1)) | 0;
		    mid = (mid + Math.imul(ah6, bl1)) | 0;
		    hi = (hi + Math.imul(ah6, bh1)) | 0;
		    lo = (lo + Math.imul(al5, bl2)) | 0;
		    mid = (mid + Math.imul(al5, bh2)) | 0;
		    mid = (mid + Math.imul(ah5, bl2)) | 0;
		    hi = (hi + Math.imul(ah5, bh2)) | 0;
		    lo = (lo + Math.imul(al4, bl3)) | 0;
		    mid = (mid + Math.imul(al4, bh3)) | 0;
		    mid = (mid + Math.imul(ah4, bl3)) | 0;
		    hi = (hi + Math.imul(ah4, bh3)) | 0;
		    lo = (lo + Math.imul(al3, bl4)) | 0;
		    mid = (mid + Math.imul(al3, bh4)) | 0;
		    mid = (mid + Math.imul(ah3, bl4)) | 0;
		    hi = (hi + Math.imul(ah3, bh4)) | 0;
		    lo = (lo + Math.imul(al2, bl5)) | 0;
		    mid = (mid + Math.imul(al2, bh5)) | 0;
		    mid = (mid + Math.imul(ah2, bl5)) | 0;
		    hi = (hi + Math.imul(ah2, bh5)) | 0;
		    lo = (lo + Math.imul(al1, bl6)) | 0;
		    mid = (mid + Math.imul(al1, bh6)) | 0;
		    mid = (mid + Math.imul(ah1, bl6)) | 0;
		    hi = (hi + Math.imul(ah1, bh6)) | 0;
		    lo = (lo + Math.imul(al0, bl7)) | 0;
		    mid = (mid + Math.imul(al0, bh7)) | 0;
		    mid = (mid + Math.imul(ah0, bl7)) | 0;
		    hi = (hi + Math.imul(ah0, bh7)) | 0;
		    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
		    w7 &= 0x3ffffff;
		    /* k = 8 */
		    lo = Math.imul(al8, bl0);
		    mid = Math.imul(al8, bh0);
		    mid = (mid + Math.imul(ah8, bl0)) | 0;
		    hi = Math.imul(ah8, bh0);
		    lo = (lo + Math.imul(al7, bl1)) | 0;
		    mid = (mid + Math.imul(al7, bh1)) | 0;
		    mid = (mid + Math.imul(ah7, bl1)) | 0;
		    hi = (hi + Math.imul(ah7, bh1)) | 0;
		    lo = (lo + Math.imul(al6, bl2)) | 0;
		    mid = (mid + Math.imul(al6, bh2)) | 0;
		    mid = (mid + Math.imul(ah6, bl2)) | 0;
		    hi = (hi + Math.imul(ah6, bh2)) | 0;
		    lo = (lo + Math.imul(al5, bl3)) | 0;
		    mid = (mid + Math.imul(al5, bh3)) | 0;
		    mid = (mid + Math.imul(ah5, bl3)) | 0;
		    hi = (hi + Math.imul(ah5, bh3)) | 0;
		    lo = (lo + Math.imul(al4, bl4)) | 0;
		    mid = (mid + Math.imul(al4, bh4)) | 0;
		    mid = (mid + Math.imul(ah4, bl4)) | 0;
		    hi = (hi + Math.imul(ah4, bh4)) | 0;
		    lo = (lo + Math.imul(al3, bl5)) | 0;
		    mid = (mid + Math.imul(al3, bh5)) | 0;
		    mid = (mid + Math.imul(ah3, bl5)) | 0;
		    hi = (hi + Math.imul(ah3, bh5)) | 0;
		    lo = (lo + Math.imul(al2, bl6)) | 0;
		    mid = (mid + Math.imul(al2, bh6)) | 0;
		    mid = (mid + Math.imul(ah2, bl6)) | 0;
		    hi = (hi + Math.imul(ah2, bh6)) | 0;
		    lo = (lo + Math.imul(al1, bl7)) | 0;
		    mid = (mid + Math.imul(al1, bh7)) | 0;
		    mid = (mid + Math.imul(ah1, bl7)) | 0;
		    hi = (hi + Math.imul(ah1, bh7)) | 0;
		    lo = (lo + Math.imul(al0, bl8)) | 0;
		    mid = (mid + Math.imul(al0, bh8)) | 0;
		    mid = (mid + Math.imul(ah0, bl8)) | 0;
		    hi = (hi + Math.imul(ah0, bh8)) | 0;
		    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
		    w8 &= 0x3ffffff;
		    /* k = 9 */
		    lo = Math.imul(al9, bl0);
		    mid = Math.imul(al9, bh0);
		    mid = (mid + Math.imul(ah9, bl0)) | 0;
		    hi = Math.imul(ah9, bh0);
		    lo = (lo + Math.imul(al8, bl1)) | 0;
		    mid = (mid + Math.imul(al8, bh1)) | 0;
		    mid = (mid + Math.imul(ah8, bl1)) | 0;
		    hi = (hi + Math.imul(ah8, bh1)) | 0;
		    lo = (lo + Math.imul(al7, bl2)) | 0;
		    mid = (mid + Math.imul(al7, bh2)) | 0;
		    mid = (mid + Math.imul(ah7, bl2)) | 0;
		    hi = (hi + Math.imul(ah7, bh2)) | 0;
		    lo = (lo + Math.imul(al6, bl3)) | 0;
		    mid = (mid + Math.imul(al6, bh3)) | 0;
		    mid = (mid + Math.imul(ah6, bl3)) | 0;
		    hi = (hi + Math.imul(ah6, bh3)) | 0;
		    lo = (lo + Math.imul(al5, bl4)) | 0;
		    mid = (mid + Math.imul(al5, bh4)) | 0;
		    mid = (mid + Math.imul(ah5, bl4)) | 0;
		    hi = (hi + Math.imul(ah5, bh4)) | 0;
		    lo = (lo + Math.imul(al4, bl5)) | 0;
		    mid = (mid + Math.imul(al4, bh5)) | 0;
		    mid = (mid + Math.imul(ah4, bl5)) | 0;
		    hi = (hi + Math.imul(ah4, bh5)) | 0;
		    lo = (lo + Math.imul(al3, bl6)) | 0;
		    mid = (mid + Math.imul(al3, bh6)) | 0;
		    mid = (mid + Math.imul(ah3, bl6)) | 0;
		    hi = (hi + Math.imul(ah3, bh6)) | 0;
		    lo = (lo + Math.imul(al2, bl7)) | 0;
		    mid = (mid + Math.imul(al2, bh7)) | 0;
		    mid = (mid + Math.imul(ah2, bl7)) | 0;
		    hi = (hi + Math.imul(ah2, bh7)) | 0;
		    lo = (lo + Math.imul(al1, bl8)) | 0;
		    mid = (mid + Math.imul(al1, bh8)) | 0;
		    mid = (mid + Math.imul(ah1, bl8)) | 0;
		    hi = (hi + Math.imul(ah1, bh8)) | 0;
		    lo = (lo + Math.imul(al0, bl9)) | 0;
		    mid = (mid + Math.imul(al0, bh9)) | 0;
		    mid = (mid + Math.imul(ah0, bl9)) | 0;
		    hi = (hi + Math.imul(ah0, bh9)) | 0;
		    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
		    w9 &= 0x3ffffff;
		    /* k = 10 */
		    lo = Math.imul(al9, bl1);
		    mid = Math.imul(al9, bh1);
		    mid = (mid + Math.imul(ah9, bl1)) | 0;
		    hi = Math.imul(ah9, bh1);
		    lo = (lo + Math.imul(al8, bl2)) | 0;
		    mid = (mid + Math.imul(al8, bh2)) | 0;
		    mid = (mid + Math.imul(ah8, bl2)) | 0;
		    hi = (hi + Math.imul(ah8, bh2)) | 0;
		    lo = (lo + Math.imul(al7, bl3)) | 0;
		    mid = (mid + Math.imul(al7, bh3)) | 0;
		    mid = (mid + Math.imul(ah7, bl3)) | 0;
		    hi = (hi + Math.imul(ah7, bh3)) | 0;
		    lo = (lo + Math.imul(al6, bl4)) | 0;
		    mid = (mid + Math.imul(al6, bh4)) | 0;
		    mid = (mid + Math.imul(ah6, bl4)) | 0;
		    hi = (hi + Math.imul(ah6, bh4)) | 0;
		    lo = (lo + Math.imul(al5, bl5)) | 0;
		    mid = (mid + Math.imul(al5, bh5)) | 0;
		    mid = (mid + Math.imul(ah5, bl5)) | 0;
		    hi = (hi + Math.imul(ah5, bh5)) | 0;
		    lo = (lo + Math.imul(al4, bl6)) | 0;
		    mid = (mid + Math.imul(al4, bh6)) | 0;
		    mid = (mid + Math.imul(ah4, bl6)) | 0;
		    hi = (hi + Math.imul(ah4, bh6)) | 0;
		    lo = (lo + Math.imul(al3, bl7)) | 0;
		    mid = (mid + Math.imul(al3, bh7)) | 0;
		    mid = (mid + Math.imul(ah3, bl7)) | 0;
		    hi = (hi + Math.imul(ah3, bh7)) | 0;
		    lo = (lo + Math.imul(al2, bl8)) | 0;
		    mid = (mid + Math.imul(al2, bh8)) | 0;
		    mid = (mid + Math.imul(ah2, bl8)) | 0;
		    hi = (hi + Math.imul(ah2, bh8)) | 0;
		    lo = (lo + Math.imul(al1, bl9)) | 0;
		    mid = (mid + Math.imul(al1, bh9)) | 0;
		    mid = (mid + Math.imul(ah1, bl9)) | 0;
		    hi = (hi + Math.imul(ah1, bh9)) | 0;
		    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
		    w10 &= 0x3ffffff;
		    /* k = 11 */
		    lo = Math.imul(al9, bl2);
		    mid = Math.imul(al9, bh2);
		    mid = (mid + Math.imul(ah9, bl2)) | 0;
		    hi = Math.imul(ah9, bh2);
		    lo = (lo + Math.imul(al8, bl3)) | 0;
		    mid = (mid + Math.imul(al8, bh3)) | 0;
		    mid = (mid + Math.imul(ah8, bl3)) | 0;
		    hi = (hi + Math.imul(ah8, bh3)) | 0;
		    lo = (lo + Math.imul(al7, bl4)) | 0;
		    mid = (mid + Math.imul(al7, bh4)) | 0;
		    mid = (mid + Math.imul(ah7, bl4)) | 0;
		    hi = (hi + Math.imul(ah7, bh4)) | 0;
		    lo = (lo + Math.imul(al6, bl5)) | 0;
		    mid = (mid + Math.imul(al6, bh5)) | 0;
		    mid = (mid + Math.imul(ah6, bl5)) | 0;
		    hi = (hi + Math.imul(ah6, bh5)) | 0;
		    lo = (lo + Math.imul(al5, bl6)) | 0;
		    mid = (mid + Math.imul(al5, bh6)) | 0;
		    mid = (mid + Math.imul(ah5, bl6)) | 0;
		    hi = (hi + Math.imul(ah5, bh6)) | 0;
		    lo = (lo + Math.imul(al4, bl7)) | 0;
		    mid = (mid + Math.imul(al4, bh7)) | 0;
		    mid = (mid + Math.imul(ah4, bl7)) | 0;
		    hi = (hi + Math.imul(ah4, bh7)) | 0;
		    lo = (lo + Math.imul(al3, bl8)) | 0;
		    mid = (mid + Math.imul(al3, bh8)) | 0;
		    mid = (mid + Math.imul(ah3, bl8)) | 0;
		    hi = (hi + Math.imul(ah3, bh8)) | 0;
		    lo = (lo + Math.imul(al2, bl9)) | 0;
		    mid = (mid + Math.imul(al2, bh9)) | 0;
		    mid = (mid + Math.imul(ah2, bl9)) | 0;
		    hi = (hi + Math.imul(ah2, bh9)) | 0;
		    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
		    w11 &= 0x3ffffff;
		    /* k = 12 */
		    lo = Math.imul(al9, bl3);
		    mid = Math.imul(al9, bh3);
		    mid = (mid + Math.imul(ah9, bl3)) | 0;
		    hi = Math.imul(ah9, bh3);
		    lo = (lo + Math.imul(al8, bl4)) | 0;
		    mid = (mid + Math.imul(al8, bh4)) | 0;
		    mid = (mid + Math.imul(ah8, bl4)) | 0;
		    hi = (hi + Math.imul(ah8, bh4)) | 0;
		    lo = (lo + Math.imul(al7, bl5)) | 0;
		    mid = (mid + Math.imul(al7, bh5)) | 0;
		    mid = (mid + Math.imul(ah7, bl5)) | 0;
		    hi = (hi + Math.imul(ah7, bh5)) | 0;
		    lo = (lo + Math.imul(al6, bl6)) | 0;
		    mid = (mid + Math.imul(al6, bh6)) | 0;
		    mid = (mid + Math.imul(ah6, bl6)) | 0;
		    hi = (hi + Math.imul(ah6, bh6)) | 0;
		    lo = (lo + Math.imul(al5, bl7)) | 0;
		    mid = (mid + Math.imul(al5, bh7)) | 0;
		    mid = (mid + Math.imul(ah5, bl7)) | 0;
		    hi = (hi + Math.imul(ah5, bh7)) | 0;
		    lo = (lo + Math.imul(al4, bl8)) | 0;
		    mid = (mid + Math.imul(al4, bh8)) | 0;
		    mid = (mid + Math.imul(ah4, bl8)) | 0;
		    hi = (hi + Math.imul(ah4, bh8)) | 0;
		    lo = (lo + Math.imul(al3, bl9)) | 0;
		    mid = (mid + Math.imul(al3, bh9)) | 0;
		    mid = (mid + Math.imul(ah3, bl9)) | 0;
		    hi = (hi + Math.imul(ah3, bh9)) | 0;
		    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
		    w12 &= 0x3ffffff;
		    /* k = 13 */
		    lo = Math.imul(al9, bl4);
		    mid = Math.imul(al9, bh4);
		    mid = (mid + Math.imul(ah9, bl4)) | 0;
		    hi = Math.imul(ah9, bh4);
		    lo = (lo + Math.imul(al8, bl5)) | 0;
		    mid = (mid + Math.imul(al8, bh5)) | 0;
		    mid = (mid + Math.imul(ah8, bl5)) | 0;
		    hi = (hi + Math.imul(ah8, bh5)) | 0;
		    lo = (lo + Math.imul(al7, bl6)) | 0;
		    mid = (mid + Math.imul(al7, bh6)) | 0;
		    mid = (mid + Math.imul(ah7, bl6)) | 0;
		    hi = (hi + Math.imul(ah7, bh6)) | 0;
		    lo = (lo + Math.imul(al6, bl7)) | 0;
		    mid = (mid + Math.imul(al6, bh7)) | 0;
		    mid = (mid + Math.imul(ah6, bl7)) | 0;
		    hi = (hi + Math.imul(ah6, bh7)) | 0;
		    lo = (lo + Math.imul(al5, bl8)) | 0;
		    mid = (mid + Math.imul(al5, bh8)) | 0;
		    mid = (mid + Math.imul(ah5, bl8)) | 0;
		    hi = (hi + Math.imul(ah5, bh8)) | 0;
		    lo = (lo + Math.imul(al4, bl9)) | 0;
		    mid = (mid + Math.imul(al4, bh9)) | 0;
		    mid = (mid + Math.imul(ah4, bl9)) | 0;
		    hi = (hi + Math.imul(ah4, bh9)) | 0;
		    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
		    w13 &= 0x3ffffff;
		    /* k = 14 */
		    lo = Math.imul(al9, bl5);
		    mid = Math.imul(al9, bh5);
		    mid = (mid + Math.imul(ah9, bl5)) | 0;
		    hi = Math.imul(ah9, bh5);
		    lo = (lo + Math.imul(al8, bl6)) | 0;
		    mid = (mid + Math.imul(al8, bh6)) | 0;
		    mid = (mid + Math.imul(ah8, bl6)) | 0;
		    hi = (hi + Math.imul(ah8, bh6)) | 0;
		    lo = (lo + Math.imul(al7, bl7)) | 0;
		    mid = (mid + Math.imul(al7, bh7)) | 0;
		    mid = (mid + Math.imul(ah7, bl7)) | 0;
		    hi = (hi + Math.imul(ah7, bh7)) | 0;
		    lo = (lo + Math.imul(al6, bl8)) | 0;
		    mid = (mid + Math.imul(al6, bh8)) | 0;
		    mid = (mid + Math.imul(ah6, bl8)) | 0;
		    hi = (hi + Math.imul(ah6, bh8)) | 0;
		    lo = (lo + Math.imul(al5, bl9)) | 0;
		    mid = (mid + Math.imul(al5, bh9)) | 0;
		    mid = (mid + Math.imul(ah5, bl9)) | 0;
		    hi = (hi + Math.imul(ah5, bh9)) | 0;
		    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
		    w14 &= 0x3ffffff;
		    /* k = 15 */
		    lo = Math.imul(al9, bl6);
		    mid = Math.imul(al9, bh6);
		    mid = (mid + Math.imul(ah9, bl6)) | 0;
		    hi = Math.imul(ah9, bh6);
		    lo = (lo + Math.imul(al8, bl7)) | 0;
		    mid = (mid + Math.imul(al8, bh7)) | 0;
		    mid = (mid + Math.imul(ah8, bl7)) | 0;
		    hi = (hi + Math.imul(ah8, bh7)) | 0;
		    lo = (lo + Math.imul(al7, bl8)) | 0;
		    mid = (mid + Math.imul(al7, bh8)) | 0;
		    mid = (mid + Math.imul(ah7, bl8)) | 0;
		    hi = (hi + Math.imul(ah7, bh8)) | 0;
		    lo = (lo + Math.imul(al6, bl9)) | 0;
		    mid = (mid + Math.imul(al6, bh9)) | 0;
		    mid = (mid + Math.imul(ah6, bl9)) | 0;
		    hi = (hi + Math.imul(ah6, bh9)) | 0;
		    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
		    w15 &= 0x3ffffff;
		    /* k = 16 */
		    lo = Math.imul(al9, bl7);
		    mid = Math.imul(al9, bh7);
		    mid = (mid + Math.imul(ah9, bl7)) | 0;
		    hi = Math.imul(ah9, bh7);
		    lo = (lo + Math.imul(al8, bl8)) | 0;
		    mid = (mid + Math.imul(al8, bh8)) | 0;
		    mid = (mid + Math.imul(ah8, bl8)) | 0;
		    hi = (hi + Math.imul(ah8, bh8)) | 0;
		    lo = (lo + Math.imul(al7, bl9)) | 0;
		    mid = (mid + Math.imul(al7, bh9)) | 0;
		    mid = (mid + Math.imul(ah7, bl9)) | 0;
		    hi = (hi + Math.imul(ah7, bh9)) | 0;
		    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
		    w16 &= 0x3ffffff;
		    /* k = 17 */
		    lo = Math.imul(al9, bl8);
		    mid = Math.imul(al9, bh8);
		    mid = (mid + Math.imul(ah9, bl8)) | 0;
		    hi = Math.imul(ah9, bh8);
		    lo = (lo + Math.imul(al8, bl9)) | 0;
		    mid = (mid + Math.imul(al8, bh9)) | 0;
		    mid = (mid + Math.imul(ah8, bl9)) | 0;
		    hi = (hi + Math.imul(ah8, bh9)) | 0;
		    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
		    w17 &= 0x3ffffff;
		    /* k = 18 */
		    lo = Math.imul(al9, bl9);
		    mid = Math.imul(al9, bh9);
		    mid = (mid + Math.imul(ah9, bl9)) | 0;
		    hi = Math.imul(ah9, bh9);
		    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
		    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
		    w18 &= 0x3ffffff;
		    o[0] = w0;
		    o[1] = w1;
		    o[2] = w2;
		    o[3] = w3;
		    o[4] = w4;
		    o[5] = w5;
		    o[6] = w6;
		    o[7] = w7;
		    o[8] = w8;
		    o[9] = w9;
		    o[10] = w10;
		    o[11] = w11;
		    o[12] = w12;
		    o[13] = w13;
		    o[14] = w14;
		    o[15] = w15;
		    o[16] = w16;
		    o[17] = w17;
		    o[18] = w18;
		    if (c !== 0) {
		      o[19] = c;
		      out.length++;
		    }
		    return out;
		  };

		  // Polyfill comb
		  if (!Math.imul) {
		    comb10MulTo = smallMulTo;
		  }

		  function bigMulTo (self, num, out) {
		    out.negative = num.negative ^ self.negative;
		    out.length = self.length + num.length;

		    var carry = 0;
		    var hncarry = 0;
		    for (var k = 0; k < out.length - 1; k++) {
		      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
		      // note that ncarry could be >= 0x3ffffff
		      var ncarry = hncarry;
		      hncarry = 0;
		      var rword = carry & 0x3ffffff;
		      var maxJ = Math.min(k, num.length - 1);
		      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
		        var i = k - j;
		        var a = self.words[i] | 0;
		        var b = num.words[j] | 0;
		        var r = a * b;

		        var lo = r & 0x3ffffff;
		        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
		        lo = (lo + rword) | 0;
		        rword = lo & 0x3ffffff;
		        ncarry = (ncarry + (lo >>> 26)) | 0;

		        hncarry += ncarry >>> 26;
		        ncarry &= 0x3ffffff;
		      }
		      out.words[k] = rword;
		      carry = ncarry;
		      ncarry = hncarry;
		    }
		    if (carry !== 0) {
		      out.words[k] = carry;
		    } else {
		      out.length--;
		    }

		    return out.strip();
		  }

		  function jumboMulTo (self, num, out) {
		    var fftm = new FFTM();
		    return fftm.mulp(self, num, out);
		  }

		  BN.prototype.mulTo = function mulTo (num, out) {
		    var res;
		    var len = this.length + num.length;
		    if (this.length === 10 && num.length === 10) {
		      res = comb10MulTo(this, num, out);
		    } else if (len < 63) {
		      res = smallMulTo(this, num, out);
		    } else if (len < 1024) {
		      res = bigMulTo(this, num, out);
		    } else {
		      res = jumboMulTo(this, num, out);
		    }

		    return res;
		  };

		  // Cooley-Tukey algorithm for FFT
		  // slightly revisited to rely on looping instead of recursion

		  function FFTM (x, y) {
		    this.x = x;
		    this.y = y;
		  }

		  FFTM.prototype.makeRBT = function makeRBT (N) {
		    var t = new Array(N);
		    var l = BN.prototype._countBits(N) - 1;
		    for (var i = 0; i < N; i++) {
		      t[i] = this.revBin(i, l, N);
		    }

		    return t;
		  };

		  // Returns binary-reversed representation of `x`
		  FFTM.prototype.revBin = function revBin (x, l, N) {
		    if (x === 0 || x === N - 1) return x;

		    var rb = 0;
		    for (var i = 0; i < l; i++) {
		      rb |= (x & 1) << (l - i - 1);
		      x >>= 1;
		    }

		    return rb;
		  };

		  // Performs "tweedling" phase, therefore 'emulating'
		  // behaviour of the recursive algorithm
		  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
		    for (var i = 0; i < N; i++) {
		      rtws[i] = rws[rbt[i]];
		      itws[i] = iws[rbt[i]];
		    }
		  };

		  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
		    this.permute(rbt, rws, iws, rtws, itws, N);

		    for (var s = 1; s < N; s <<= 1) {
		      var l = s << 1;

		      var rtwdf = Math.cos(2 * Math.PI / l);
		      var itwdf = Math.sin(2 * Math.PI / l);

		      for (var p = 0; p < N; p += l) {
		        var rtwdf_ = rtwdf;
		        var itwdf_ = itwdf;

		        for (var j = 0; j < s; j++) {
		          var re = rtws[p + j];
		          var ie = itws[p + j];

		          var ro = rtws[p + j + s];
		          var io = itws[p + j + s];

		          var rx = rtwdf_ * ro - itwdf_ * io;

		          io = rtwdf_ * io + itwdf_ * ro;
		          ro = rx;

		          rtws[p + j] = re + ro;
		          itws[p + j] = ie + io;

		          rtws[p + j + s] = re - ro;
		          itws[p + j + s] = ie - io;

		          /* jshint maxdepth : false */
		          if (j !== l) {
		            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

		            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
		            rtwdf_ = rx;
		          }
		        }
		      }
		    }
		  };

		  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
		    var N = Math.max(m, n) | 1;
		    var odd = N & 1;
		    var i = 0;
		    for (N = N / 2 | 0; N; N = N >>> 1) {
		      i++;
		    }

		    return 1 << i + 1 + odd;
		  };

		  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
		    if (N <= 1) return;

		    for (var i = 0; i < N / 2; i++) {
		      var t = rws[i];

		      rws[i] = rws[N - i - 1];
		      rws[N - i - 1] = t;

		      t = iws[i];

		      iws[i] = -iws[N - i - 1];
		      iws[N - i - 1] = -t;
		    }
		  };

		  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
		    var carry = 0;
		    for (var i = 0; i < N / 2; i++) {
		      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
		        Math.round(ws[2 * i] / N) +
		        carry;

		      ws[i] = w & 0x3ffffff;

		      if (w < 0x4000000) {
		        carry = 0;
		      } else {
		        carry = w / 0x4000000 | 0;
		      }
		    }

		    return ws;
		  };

		  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
		    var carry = 0;
		    for (var i = 0; i < len; i++) {
		      carry = carry + (ws[i] | 0);

		      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
		      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
		    }

		    // Pad with zeroes
		    for (i = 2 * len; i < N; ++i) {
		      rws[i] = 0;
		    }

		    assert(carry === 0);
		    assert((carry & ~0x1fff) === 0);
		  };

		  FFTM.prototype.stub = function stub (N) {
		    var ph = new Array(N);
		    for (var i = 0; i < N; i++) {
		      ph[i] = 0;
		    }

		    return ph;
		  };

		  FFTM.prototype.mulp = function mulp (x, y, out) {
		    var N = 2 * this.guessLen13b(x.length, y.length);

		    var rbt = this.makeRBT(N);

		    var _ = this.stub(N);

		    var rws = new Array(N);
		    var rwst = new Array(N);
		    var iwst = new Array(N);

		    var nrws = new Array(N);
		    var nrwst = new Array(N);
		    var niwst = new Array(N);

		    var rmws = out.words;
		    rmws.length = N;

		    this.convert13b(x.words, x.length, rws, N);
		    this.convert13b(y.words, y.length, nrws, N);

		    this.transform(rws, _, rwst, iwst, N, rbt);
		    this.transform(nrws, _, nrwst, niwst, N, rbt);

		    for (var i = 0; i < N; i++) {
		      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
		      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
		      rwst[i] = rx;
		    }

		    this.conjugate(rwst, iwst, N);
		    this.transform(rwst, iwst, rmws, _, N, rbt);
		    this.conjugate(rmws, _, N);
		    this.normalize13b(rmws, N);

		    out.negative = x.negative ^ y.negative;
		    out.length = x.length + y.length;
		    return out.strip();
		  };

		  // Multiply `this` by `num`
		  BN.prototype.mul = function mul (num) {
		    var out = new BN(null);
		    out.words = new Array(this.length + num.length);
		    return this.mulTo(num, out);
		  };

		  // Multiply employing FFT
		  BN.prototype.mulf = function mulf (num) {
		    var out = new BN(null);
		    out.words = new Array(this.length + num.length);
		    return jumboMulTo(this, num, out);
		  };

		  // In-place Multiplication
		  BN.prototype.imul = function imul (num) {
		    return this.clone().mulTo(num, this);
		  };

		  BN.prototype.imuln = function imuln (num) {
		    assert(typeof num === 'number');
		    assert(num < 0x4000000);

		    // Carry
		    var carry = 0;
		    for (var i = 0; i < this.length; i++) {
		      var w = (this.words[i] | 0) * num;
		      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
		      carry >>= 26;
		      carry += (w / 0x4000000) | 0;
		      // NOTE: lo is 27bit maximum
		      carry += lo >>> 26;
		      this.words[i] = lo & 0x3ffffff;
		    }

		    if (carry !== 0) {
		      this.words[i] = carry;
		      this.length++;
		    }

		    return this;
		  };

		  BN.prototype.muln = function muln (num) {
		    return this.clone().imuln(num);
		  };

		  // `this` * `this`
		  BN.prototype.sqr = function sqr () {
		    return this.mul(this);
		  };

		  // `this` * `this` in-place
		  BN.prototype.isqr = function isqr () {
		    return this.imul(this.clone());
		  };

		  // Math.pow(`this`, `num`)
		  BN.prototype.pow = function pow (num) {
		    var w = toBitArray(num);
		    if (w.length === 0) return new BN(1);

		    // Skip leading zeroes
		    var res = this;
		    for (var i = 0; i < w.length; i++, res = res.sqr()) {
		      if (w[i] !== 0) break;
		    }

		    if (++i < w.length) {
		      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
		        if (w[i] === 0) continue;

		        res = res.mul(q);
		      }
		    }

		    return res;
		  };

		  // Shift-left in-place
		  BN.prototype.iushln = function iushln (bits) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var r = bits % 26;
		    var s = (bits - r) / 26;
		    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
		    var i;

		    if (r !== 0) {
		      var carry = 0;

		      for (i = 0; i < this.length; i++) {
		        var newCarry = this.words[i] & carryMask;
		        var c = ((this.words[i] | 0) - newCarry) << r;
		        this.words[i] = c | carry;
		        carry = newCarry >>> (26 - r);
		      }

		      if (carry) {
		        this.words[i] = carry;
		        this.length++;
		      }
		    }

		    if (s !== 0) {
		      for (i = this.length - 1; i >= 0; i--) {
		        this.words[i + s] = this.words[i];
		      }

		      for (i = 0; i < s; i++) {
		        this.words[i] = 0;
		      }

		      this.length += s;
		    }

		    return this.strip();
		  };

		  BN.prototype.ishln = function ishln (bits) {
		    // TODO(indutny): implement me
		    assert(this.negative === 0);
		    return this.iushln(bits);
		  };

		  // Shift-right in-place
		  // NOTE: `hint` is a lowest bit before trailing zeroes
		  // NOTE: if `extended` is present - it will be filled with destroyed bits
		  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var h;
		    if (hint) {
		      h = (hint - (hint % 26)) / 26;
		    } else {
		      h = 0;
		    }

		    var r = bits % 26;
		    var s = Math.min((bits - r) / 26, this.length);
		    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
		    var maskedWords = extended;

		    h -= s;
		    h = Math.max(0, h);

		    // Extended mode, copy masked part
		    if (maskedWords) {
		      for (var i = 0; i < s; i++) {
		        maskedWords.words[i] = this.words[i];
		      }
		      maskedWords.length = s;
		    }

		    if (s === 0) ; else if (this.length > s) {
		      this.length -= s;
		      for (i = 0; i < this.length; i++) {
		        this.words[i] = this.words[i + s];
		      }
		    } else {
		      this.words[0] = 0;
		      this.length = 1;
		    }

		    var carry = 0;
		    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
		      var word = this.words[i] | 0;
		      this.words[i] = (carry << (26 - r)) | (word >>> r);
		      carry = word & mask;
		    }

		    // Push carried bits as a mask
		    if (maskedWords && carry !== 0) {
		      maskedWords.words[maskedWords.length++] = carry;
		    }

		    if (this.length === 0) {
		      this.words[0] = 0;
		      this.length = 1;
		    }

		    return this.strip();
		  };

		  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
		    // TODO(indutny): implement me
		    assert(this.negative === 0);
		    return this.iushrn(bits, hint, extended);
		  };

		  // Shift-left
		  BN.prototype.shln = function shln (bits) {
		    return this.clone().ishln(bits);
		  };

		  BN.prototype.ushln = function ushln (bits) {
		    return this.clone().iushln(bits);
		  };

		  // Shift-right
		  BN.prototype.shrn = function shrn (bits) {
		    return this.clone().ishrn(bits);
		  };

		  BN.prototype.ushrn = function ushrn (bits) {
		    return this.clone().iushrn(bits);
		  };

		  // Test if n bit is set
		  BN.prototype.testn = function testn (bit) {
		    assert(typeof bit === 'number' && bit >= 0);
		    var r = bit % 26;
		    var s = (bit - r) / 26;
		    var q = 1 << r;

		    // Fast case: bit is much higher than all existing words
		    if (this.length <= s) return false;

		    // Check bit and return
		    var w = this.words[s];

		    return !!(w & q);
		  };

		  // Return only lowers bits of number (in-place)
		  BN.prototype.imaskn = function imaskn (bits) {
		    assert(typeof bits === 'number' && bits >= 0);
		    var r = bits % 26;
		    var s = (bits - r) / 26;

		    assert(this.negative === 0, 'imaskn works only with positive numbers');

		    if (this.length <= s) {
		      return this;
		    }

		    if (r !== 0) {
		      s++;
		    }
		    this.length = Math.min(s, this.length);

		    if (r !== 0) {
		      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
		      this.words[this.length - 1] &= mask;
		    }

		    return this.strip();
		  };

		  // Return only lowers bits of number
		  BN.prototype.maskn = function maskn (bits) {
		    return this.clone().imaskn(bits);
		  };

		  // Add plain number `num` to `this`
		  BN.prototype.iaddn = function iaddn (num) {
		    assert(typeof num === 'number');
		    assert(num < 0x4000000);
		    if (num < 0) return this.isubn(-num);

		    // Possible sign change
		    if (this.negative !== 0) {
		      if (this.length === 1 && (this.words[0] | 0) < num) {
		        this.words[0] = num - (this.words[0] | 0);
		        this.negative = 0;
		        return this;
		      }

		      this.negative = 0;
		      this.isubn(num);
		      this.negative = 1;
		      return this;
		    }

		    // Add without checks
		    return this._iaddn(num);
		  };

		  BN.prototype._iaddn = function _iaddn (num) {
		    this.words[0] += num;

		    // Carry
		    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
		      this.words[i] -= 0x4000000;
		      if (i === this.length - 1) {
		        this.words[i + 1] = 1;
		      } else {
		        this.words[i + 1]++;
		      }
		    }
		    this.length = Math.max(this.length, i + 1);

		    return this;
		  };

		  // Subtract plain number `num` from `this`
		  BN.prototype.isubn = function isubn (num) {
		    assert(typeof num === 'number');
		    assert(num < 0x4000000);
		    if (num < 0) return this.iaddn(-num);

		    if (this.negative !== 0) {
		      this.negative = 0;
		      this.iaddn(num);
		      this.negative = 1;
		      return this;
		    }

		    this.words[0] -= num;

		    if (this.length === 1 && this.words[0] < 0) {
		      this.words[0] = -this.words[0];
		      this.negative = 1;
		    } else {
		      // Carry
		      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
		        this.words[i] += 0x4000000;
		        this.words[i + 1] -= 1;
		      }
		    }

		    return this.strip();
		  };

		  BN.prototype.addn = function addn (num) {
		    return this.clone().iaddn(num);
		  };

		  BN.prototype.subn = function subn (num) {
		    return this.clone().isubn(num);
		  };

		  BN.prototype.iabs = function iabs () {
		    this.negative = 0;

		    return this;
		  };

		  BN.prototype.abs = function abs () {
		    return this.clone().iabs();
		  };

		  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
		    var len = num.length + shift;
		    var i;

		    this._expand(len);

		    var w;
		    var carry = 0;
		    for (i = 0; i < num.length; i++) {
		      w = (this.words[i + shift] | 0) + carry;
		      var right = (num.words[i] | 0) * mul;
		      w -= right & 0x3ffffff;
		      carry = (w >> 26) - ((right / 0x4000000) | 0);
		      this.words[i + shift] = w & 0x3ffffff;
		    }
		    for (; i < this.length - shift; i++) {
		      w = (this.words[i + shift] | 0) + carry;
		      carry = w >> 26;
		      this.words[i + shift] = w & 0x3ffffff;
		    }

		    if (carry === 0) return this.strip();

		    // Subtraction overflow
		    assert(carry === -1);
		    carry = 0;
		    for (i = 0; i < this.length; i++) {
		      w = -(this.words[i] | 0) + carry;
		      carry = w >> 26;
		      this.words[i] = w & 0x3ffffff;
		    }
		    this.negative = 1;

		    return this.strip();
		  };

		  BN.prototype._wordDiv = function _wordDiv (num, mode) {
		    var shift = this.length - num.length;

		    var a = this.clone();
		    var b = num;

		    // Normalize
		    var bhi = b.words[b.length - 1] | 0;
		    var bhiBits = this._countBits(bhi);
		    shift = 26 - bhiBits;
		    if (shift !== 0) {
		      b = b.ushln(shift);
		      a.iushln(shift);
		      bhi = b.words[b.length - 1] | 0;
		    }

		    // Initialize quotient
		    var m = a.length - b.length;
		    var q;

		    if (mode !== 'mod') {
		      q = new BN(null);
		      q.length = m + 1;
		      q.words = new Array(q.length);
		      for (var i = 0; i < q.length; i++) {
		        q.words[i] = 0;
		      }
		    }

		    var diff = a.clone()._ishlnsubmul(b, 1, m);
		    if (diff.negative === 0) {
		      a = diff;
		      if (q) {
		        q.words[m] = 1;
		      }
		    }

		    for (var j = m - 1; j >= 0; j--) {
		      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
		        (a.words[b.length + j - 1] | 0);

		      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
		      // (0x7ffffff)
		      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

		      a._ishlnsubmul(b, qj, j);
		      while (a.negative !== 0) {
		        qj--;
		        a.negative = 0;
		        a._ishlnsubmul(b, 1, j);
		        if (!a.isZero()) {
		          a.negative ^= 1;
		        }
		      }
		      if (q) {
		        q.words[j] = qj;
		      }
		    }
		    if (q) {
		      q.strip();
		    }
		    a.strip();

		    // Denormalize
		    if (mode !== 'div' && shift !== 0) {
		      a.iushrn(shift);
		    }

		    return {
		      div: q || null,
		      mod: a
		    };
		  };

		  // NOTE: 1) `mode` can be set to `mod` to request mod only,
		  //       to `div` to request div only, or be absent to
		  //       request both div & mod
		  //       2) `positive` is true if unsigned mod is requested
		  BN.prototype.divmod = function divmod (num, mode, positive) {
		    assert(!num.isZero());

		    if (this.isZero()) {
		      return {
		        div: new BN(0),
		        mod: new BN(0)
		      };
		    }

		    var div, mod, res;
		    if (this.negative !== 0 && num.negative === 0) {
		      res = this.neg().divmod(num, mode);

		      if (mode !== 'mod') {
		        div = res.div.neg();
		      }

		      if (mode !== 'div') {
		        mod = res.mod.neg();
		        if (positive && mod.negative !== 0) {
		          mod.iadd(num);
		        }
		      }

		      return {
		        div: div,
		        mod: mod
		      };
		    }

		    if (this.negative === 0 && num.negative !== 0) {
		      res = this.divmod(num.neg(), mode);

		      if (mode !== 'mod') {
		        div = res.div.neg();
		      }

		      return {
		        div: div,
		        mod: res.mod
		      };
		    }

		    if ((this.negative & num.negative) !== 0) {
		      res = this.neg().divmod(num.neg(), mode);

		      if (mode !== 'div') {
		        mod = res.mod.neg();
		        if (positive && mod.negative !== 0) {
		          mod.isub(num);
		        }
		      }

		      return {
		        div: res.div,
		        mod: mod
		      };
		    }

		    // Both numbers are positive at this point

		    // Strip both numbers to approximate shift value
		    if (num.length > this.length || this.cmp(num) < 0) {
		      return {
		        div: new BN(0),
		        mod: this
		      };
		    }

		    // Very short reduction
		    if (num.length === 1) {
		      if (mode === 'div') {
		        return {
		          div: this.divn(num.words[0]),
		          mod: null
		        };
		      }

		      if (mode === 'mod') {
		        return {
		          div: null,
		          mod: new BN(this.modn(num.words[0]))
		        };
		      }

		      return {
		        div: this.divn(num.words[0]),
		        mod: new BN(this.modn(num.words[0]))
		      };
		    }

		    return this._wordDiv(num, mode);
		  };

		  // Find `this` / `num`
		  BN.prototype.div = function div (num) {
		    return this.divmod(num, 'div', false).div;
		  };

		  // Find `this` % `num`
		  BN.prototype.mod = function mod (num) {
		    return this.divmod(num, 'mod', false).mod;
		  };

		  BN.prototype.umod = function umod (num) {
		    return this.divmod(num, 'mod', true).mod;
		  };

		  // Find Round(`this` / `num`)
		  BN.prototype.divRound = function divRound (num) {
		    var dm = this.divmod(num);

		    // Fast case - exact division
		    if (dm.mod.isZero()) return dm.div;

		    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

		    var half = num.ushrn(1);
		    var r2 = num.andln(1);
		    var cmp = mod.cmp(half);

		    // Round down
		    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

		    // Round up
		    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
		  };

		  BN.prototype.modn = function modn (num) {
		    assert(num <= 0x3ffffff);
		    var p = (1 << 26) % num;

		    var acc = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      acc = (p * acc + (this.words[i] | 0)) % num;
		    }

		    return acc;
		  };

		  // In-place division by number
		  BN.prototype.idivn = function idivn (num) {
		    assert(num <= 0x3ffffff);

		    var carry = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      var w = (this.words[i] | 0) + carry * 0x4000000;
		      this.words[i] = (w / num) | 0;
		      carry = w % num;
		    }

		    return this.strip();
		  };

		  BN.prototype.divn = function divn (num) {
		    return this.clone().idivn(num);
		  };

		  BN.prototype.egcd = function egcd (p) {
		    assert(p.negative === 0);
		    assert(!p.isZero());

		    var x = this;
		    var y = p.clone();

		    if (x.negative !== 0) {
		      x = x.umod(p);
		    } else {
		      x = x.clone();
		    }

		    // A * x + B * y = x
		    var A = new BN(1);
		    var B = new BN(0);

		    // C * x + D * y = y
		    var C = new BN(0);
		    var D = new BN(1);

		    var g = 0;

		    while (x.isEven() && y.isEven()) {
		      x.iushrn(1);
		      y.iushrn(1);
		      ++g;
		    }

		    var yp = y.clone();
		    var xp = x.clone();

		    while (!x.isZero()) {
		      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
		      if (i > 0) {
		        x.iushrn(i);
		        while (i-- > 0) {
		          if (A.isOdd() || B.isOdd()) {
		            A.iadd(yp);
		            B.isub(xp);
		          }

		          A.iushrn(1);
		          B.iushrn(1);
		        }
		      }

		      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
		      if (j > 0) {
		        y.iushrn(j);
		        while (j-- > 0) {
		          if (C.isOdd() || D.isOdd()) {
		            C.iadd(yp);
		            D.isub(xp);
		          }

		          C.iushrn(1);
		          D.iushrn(1);
		        }
		      }

		      if (x.cmp(y) >= 0) {
		        x.isub(y);
		        A.isub(C);
		        B.isub(D);
		      } else {
		        y.isub(x);
		        C.isub(A);
		        D.isub(B);
		      }
		    }

		    return {
		      a: C,
		      b: D,
		      gcd: y.iushln(g)
		    };
		  };

		  // This is reduced incarnation of the binary EEA
		  // above, designated to invert members of the
		  // _prime_ fields F(p) at a maximal speed
		  BN.prototype._invmp = function _invmp (p) {
		    assert(p.negative === 0);
		    assert(!p.isZero());

		    var a = this;
		    var b = p.clone();

		    if (a.negative !== 0) {
		      a = a.umod(p);
		    } else {
		      a = a.clone();
		    }

		    var x1 = new BN(1);
		    var x2 = new BN(0);

		    var delta = b.clone();

		    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
		      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
		      if (i > 0) {
		        a.iushrn(i);
		        while (i-- > 0) {
		          if (x1.isOdd()) {
		            x1.iadd(delta);
		          }

		          x1.iushrn(1);
		        }
		      }

		      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
		      if (j > 0) {
		        b.iushrn(j);
		        while (j-- > 0) {
		          if (x2.isOdd()) {
		            x2.iadd(delta);
		          }

		          x2.iushrn(1);
		        }
		      }

		      if (a.cmp(b) >= 0) {
		        a.isub(b);
		        x1.isub(x2);
		      } else {
		        b.isub(a);
		        x2.isub(x1);
		      }
		    }

		    var res;
		    if (a.cmpn(1) === 0) {
		      res = x1;
		    } else {
		      res = x2;
		    }

		    if (res.cmpn(0) < 0) {
		      res.iadd(p);
		    }

		    return res;
		  };

		  BN.prototype.gcd = function gcd (num) {
		    if (this.isZero()) return num.abs();
		    if (num.isZero()) return this.abs();

		    var a = this.clone();
		    var b = num.clone();
		    a.negative = 0;
		    b.negative = 0;

		    // Remove common factor of two
		    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
		      a.iushrn(1);
		      b.iushrn(1);
		    }

		    do {
		      while (a.isEven()) {
		        a.iushrn(1);
		      }
		      while (b.isEven()) {
		        b.iushrn(1);
		      }

		      var r = a.cmp(b);
		      if (r < 0) {
		        // Swap `a` and `b` to make `a` always bigger than `b`
		        var t = a;
		        a = b;
		        b = t;
		      } else if (r === 0 || b.cmpn(1) === 0) {
		        break;
		      }

		      a.isub(b);
		    } while (true);

		    return b.iushln(shift);
		  };

		  // Invert number in the field F(num)
		  BN.prototype.invm = function invm (num) {
		    return this.egcd(num).a.umod(num);
		  };

		  BN.prototype.isEven = function isEven () {
		    return (this.words[0] & 1) === 0;
		  };

		  BN.prototype.isOdd = function isOdd () {
		    return (this.words[0] & 1) === 1;
		  };

		  // And first word and num
		  BN.prototype.andln = function andln (num) {
		    return this.words[0] & num;
		  };

		  // Increment at the bit position in-line
		  BN.prototype.bincn = function bincn (bit) {
		    assert(typeof bit === 'number');
		    var r = bit % 26;
		    var s = (bit - r) / 26;
		    var q = 1 << r;

		    // Fast case: bit is much higher than all existing words
		    if (this.length <= s) {
		      this._expand(s + 1);
		      this.words[s] |= q;
		      return this;
		    }

		    // Add bit and propagate, if needed
		    var carry = q;
		    for (var i = s; carry !== 0 && i < this.length; i++) {
		      var w = this.words[i] | 0;
		      w += carry;
		      carry = w >>> 26;
		      w &= 0x3ffffff;
		      this.words[i] = w;
		    }
		    if (carry !== 0) {
		      this.words[i] = carry;
		      this.length++;
		    }
		    return this;
		  };

		  BN.prototype.isZero = function isZero () {
		    return this.length === 1 && this.words[0] === 0;
		  };

		  BN.prototype.cmpn = function cmpn (num) {
		    var negative = num < 0;

		    if (this.negative !== 0 && !negative) return -1;
		    if (this.negative === 0 && negative) return 1;

		    this.strip();

		    var res;
		    if (this.length > 1) {
		      res = 1;
		    } else {
		      if (negative) {
		        num = -num;
		      }

		      assert(num <= 0x3ffffff, 'Number is too big');

		      var w = this.words[0] | 0;
		      res = w === num ? 0 : w < num ? -1 : 1;
		    }
		    if (this.negative !== 0) return -res | 0;
		    return res;
		  };

		  // Compare two numbers and return:
		  // 1 - if `this` > `num`
		  // 0 - if `this` == `num`
		  // -1 - if `this` < `num`
		  BN.prototype.cmp = function cmp (num) {
		    if (this.negative !== 0 && num.negative === 0) return -1;
		    if (this.negative === 0 && num.negative !== 0) return 1;

		    var res = this.ucmp(num);
		    if (this.negative !== 0) return -res | 0;
		    return res;
		  };

		  // Unsigned comparison
		  BN.prototype.ucmp = function ucmp (num) {
		    // At this point both numbers have the same sign
		    if (this.length > num.length) return 1;
		    if (this.length < num.length) return -1;

		    var res = 0;
		    for (var i = this.length - 1; i >= 0; i--) {
		      var a = this.words[i] | 0;
		      var b = num.words[i] | 0;

		      if (a === b) continue;
		      if (a < b) {
		        res = -1;
		      } else if (a > b) {
		        res = 1;
		      }
		      break;
		    }
		    return res;
		  };

		  BN.prototype.gtn = function gtn (num) {
		    return this.cmpn(num) === 1;
		  };

		  BN.prototype.gt = function gt (num) {
		    return this.cmp(num) === 1;
		  };

		  BN.prototype.gten = function gten (num) {
		    return this.cmpn(num) >= 0;
		  };

		  BN.prototype.gte = function gte (num) {
		    return this.cmp(num) >= 0;
		  };

		  BN.prototype.ltn = function ltn (num) {
		    return this.cmpn(num) === -1;
		  };

		  BN.prototype.lt = function lt (num) {
		    return this.cmp(num) === -1;
		  };

		  BN.prototype.lten = function lten (num) {
		    return this.cmpn(num) <= 0;
		  };

		  BN.prototype.lte = function lte (num) {
		    return this.cmp(num) <= 0;
		  };

		  BN.prototype.eqn = function eqn (num) {
		    return this.cmpn(num) === 0;
		  };

		  BN.prototype.eq = function eq (num) {
		    return this.cmp(num) === 0;
		  };

		  //
		  // A reduce context, could be using montgomery or something better, depending
		  // on the `m` itself.
		  //
		  BN.red = function red (num) {
		    return new Red(num);
		  };

		  BN.prototype.toRed = function toRed (ctx) {
		    assert(!this.red, 'Already a number in reduction context');
		    assert(this.negative === 0, 'red works only with positives');
		    return ctx.convertTo(this)._forceRed(ctx);
		  };

		  BN.prototype.fromRed = function fromRed () {
		    assert(this.red, 'fromRed works only with numbers in reduction context');
		    return this.red.convertFrom(this);
		  };

		  BN.prototype._forceRed = function _forceRed (ctx) {
		    this.red = ctx;
		    return this;
		  };

		  BN.prototype.forceRed = function forceRed (ctx) {
		    assert(!this.red, 'Already a number in reduction context');
		    return this._forceRed(ctx);
		  };

		  BN.prototype.redAdd = function redAdd (num) {
		    assert(this.red, 'redAdd works only with red numbers');
		    return this.red.add(this, num);
		  };

		  BN.prototype.redIAdd = function redIAdd (num) {
		    assert(this.red, 'redIAdd works only with red numbers');
		    return this.red.iadd(this, num);
		  };

		  BN.prototype.redSub = function redSub (num) {
		    assert(this.red, 'redSub works only with red numbers');
		    return this.red.sub(this, num);
		  };

		  BN.prototype.redISub = function redISub (num) {
		    assert(this.red, 'redISub works only with red numbers');
		    return this.red.isub(this, num);
		  };

		  BN.prototype.redShl = function redShl (num) {
		    assert(this.red, 'redShl works only with red numbers');
		    return this.red.shl(this, num);
		  };

		  BN.prototype.redMul = function redMul (num) {
		    assert(this.red, 'redMul works only with red numbers');
		    this.red._verify2(this, num);
		    return this.red.mul(this, num);
		  };

		  BN.prototype.redIMul = function redIMul (num) {
		    assert(this.red, 'redMul works only with red numbers');
		    this.red._verify2(this, num);
		    return this.red.imul(this, num);
		  };

		  BN.prototype.redSqr = function redSqr () {
		    assert(this.red, 'redSqr works only with red numbers');
		    this.red._verify1(this);
		    return this.red.sqr(this);
		  };

		  BN.prototype.redISqr = function redISqr () {
		    assert(this.red, 'redISqr works only with red numbers');
		    this.red._verify1(this);
		    return this.red.isqr(this);
		  };

		  // Square root over p
		  BN.prototype.redSqrt = function redSqrt () {
		    assert(this.red, 'redSqrt works only with red numbers');
		    this.red._verify1(this);
		    return this.red.sqrt(this);
		  };

		  BN.prototype.redInvm = function redInvm () {
		    assert(this.red, 'redInvm works only with red numbers');
		    this.red._verify1(this);
		    return this.red.invm(this);
		  };

		  // Return negative clone of `this` % `red modulo`
		  BN.prototype.redNeg = function redNeg () {
		    assert(this.red, 'redNeg works only with red numbers');
		    this.red._verify1(this);
		    return this.red.neg(this);
		  };

		  BN.prototype.redPow = function redPow (num) {
		    assert(this.red && !num.red, 'redPow(normalNum)');
		    this.red._verify1(this);
		    return this.red.pow(this, num);
		  };

		  // Prime numbers with efficient reduction
		  var primes = {
		    k256: null,
		    p224: null,
		    p192: null,
		    p25519: null
		  };

		  // Pseudo-Mersenne prime
		  function MPrime (name, p) {
		    // P = 2 ^ N - K
		    this.name = name;
		    this.p = new BN(p, 16);
		    this.n = this.p.bitLength();
		    this.k = new BN(1).iushln(this.n).isub(this.p);

		    this.tmp = this._tmp();
		  }

		  MPrime.prototype._tmp = function _tmp () {
		    var tmp = new BN(null);
		    tmp.words = new Array(Math.ceil(this.n / 13));
		    return tmp;
		  };

		  MPrime.prototype.ireduce = function ireduce (num) {
		    // Assumes that `num` is less than `P^2`
		    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
		    var r = num;
		    var rlen;

		    do {
		      this.split(r, this.tmp);
		      r = this.imulK(r);
		      r = r.iadd(this.tmp);
		      rlen = r.bitLength();
		    } while (rlen > this.n);

		    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
		    if (cmp === 0) {
		      r.words[0] = 0;
		      r.length = 1;
		    } else if (cmp > 0) {
		      r.isub(this.p);
		    } else {
		      if (r.strip !== undefined) {
		        // r is BN v4 instance
		        r.strip();
		      } else {
		        // r is BN v5 instance
		        r._strip();
		      }
		    }

		    return r;
		  };

		  MPrime.prototype.split = function split (input, out) {
		    input.iushrn(this.n, 0, out);
		  };

		  MPrime.prototype.imulK = function imulK (num) {
		    return num.imul(this.k);
		  };

		  function K256 () {
		    MPrime.call(
		      this,
		      'k256',
		      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
		  }
		  inherits(K256, MPrime);

		  K256.prototype.split = function split (input, output) {
		    // 256 = 9 * 26 + 22
		    var mask = 0x3fffff;

		    var outLen = Math.min(input.length, 9);
		    for (var i = 0; i < outLen; i++) {
		      output.words[i] = input.words[i];
		    }
		    output.length = outLen;

		    if (input.length <= 9) {
		      input.words[0] = 0;
		      input.length = 1;
		      return;
		    }

		    // Shift by 9 limbs
		    var prev = input.words[9];
		    output.words[output.length++] = prev & mask;

		    for (i = 10; i < input.length; i++) {
		      var next = input.words[i] | 0;
		      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
		      prev = next;
		    }
		    prev >>>= 22;
		    input.words[i - 10] = prev;
		    if (prev === 0 && input.length > 10) {
		      input.length -= 10;
		    } else {
		      input.length -= 9;
		    }
		  };

		  K256.prototype.imulK = function imulK (num) {
		    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
		    num.words[num.length] = 0;
		    num.words[num.length + 1] = 0;
		    num.length += 2;

		    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
		    var lo = 0;
		    for (var i = 0; i < num.length; i++) {
		      var w = num.words[i] | 0;
		      lo += w * 0x3d1;
		      num.words[i] = lo & 0x3ffffff;
		      lo = w * 0x40 + ((lo / 0x4000000) | 0);
		    }

		    // Fast length reduction
		    if (num.words[num.length - 1] === 0) {
		      num.length--;
		      if (num.words[num.length - 1] === 0) {
		        num.length--;
		      }
		    }
		    return num;
		  };

		  function P224 () {
		    MPrime.call(
		      this,
		      'p224',
		      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
		  }
		  inherits(P224, MPrime);

		  function P192 () {
		    MPrime.call(
		      this,
		      'p192',
		      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
		  }
		  inherits(P192, MPrime);

		  function P25519 () {
		    // 2 ^ 255 - 19
		    MPrime.call(
		      this,
		      '25519',
		      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
		  }
		  inherits(P25519, MPrime);

		  P25519.prototype.imulK = function imulK (num) {
		    // K = 0x13
		    var carry = 0;
		    for (var i = 0; i < num.length; i++) {
		      var hi = (num.words[i] | 0) * 0x13 + carry;
		      var lo = hi & 0x3ffffff;
		      hi >>>= 26;

		      num.words[i] = lo;
		      carry = hi;
		    }
		    if (carry !== 0) {
		      num.words[num.length++] = carry;
		    }
		    return num;
		  };

		  // Exported mostly for testing purposes, use plain name instead
		  BN._prime = function prime (name) {
		    // Cached version of prime
		    if (primes[name]) return primes[name];

		    var prime;
		    if (name === 'k256') {
		      prime = new K256();
		    } else if (name === 'p224') {
		      prime = new P224();
		    } else if (name === 'p192') {
		      prime = new P192();
		    } else if (name === 'p25519') {
		      prime = new P25519();
		    } else {
		      throw new Error('Unknown prime ' + name);
		    }
		    primes[name] = prime;

		    return prime;
		  };

		  //
		  // Base reduction engine
		  //
		  function Red (m) {
		    if (typeof m === 'string') {
		      var prime = BN._prime(m);
		      this.m = prime.p;
		      this.prime = prime;
		    } else {
		      assert(m.gtn(1), 'modulus must be greater than 1');
		      this.m = m;
		      this.prime = null;
		    }
		  }

		  Red.prototype._verify1 = function _verify1 (a) {
		    assert(a.negative === 0, 'red works only with positives');
		    assert(a.red, 'red works only with red numbers');
		  };

		  Red.prototype._verify2 = function _verify2 (a, b) {
		    assert((a.negative | b.negative) === 0, 'red works only with positives');
		    assert(a.red && a.red === b.red,
		      'red works only with red numbers');
		  };

		  Red.prototype.imod = function imod (a) {
		    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
		    return a.umod(this.m)._forceRed(this);
		  };

		  Red.prototype.neg = function neg (a) {
		    if (a.isZero()) {
		      return a.clone();
		    }

		    return this.m.sub(a)._forceRed(this);
		  };

		  Red.prototype.add = function add (a, b) {
		    this._verify2(a, b);

		    var res = a.add(b);
		    if (res.cmp(this.m) >= 0) {
		      res.isub(this.m);
		    }
		    return res._forceRed(this);
		  };

		  Red.prototype.iadd = function iadd (a, b) {
		    this._verify2(a, b);

		    var res = a.iadd(b);
		    if (res.cmp(this.m) >= 0) {
		      res.isub(this.m);
		    }
		    return res;
		  };

		  Red.prototype.sub = function sub (a, b) {
		    this._verify2(a, b);

		    var res = a.sub(b);
		    if (res.cmpn(0) < 0) {
		      res.iadd(this.m);
		    }
		    return res._forceRed(this);
		  };

		  Red.prototype.isub = function isub (a, b) {
		    this._verify2(a, b);

		    var res = a.isub(b);
		    if (res.cmpn(0) < 0) {
		      res.iadd(this.m);
		    }
		    return res;
		  };

		  Red.prototype.shl = function shl (a, num) {
		    this._verify1(a);
		    return this.imod(a.ushln(num));
		  };

		  Red.prototype.imul = function imul (a, b) {
		    this._verify2(a, b);
		    return this.imod(a.imul(b));
		  };

		  Red.prototype.mul = function mul (a, b) {
		    this._verify2(a, b);
		    return this.imod(a.mul(b));
		  };

		  Red.prototype.isqr = function isqr (a) {
		    return this.imul(a, a.clone());
		  };

		  Red.prototype.sqr = function sqr (a) {
		    return this.mul(a, a);
		  };

		  Red.prototype.sqrt = function sqrt (a) {
		    if (a.isZero()) return a.clone();

		    var mod3 = this.m.andln(3);
		    assert(mod3 % 2 === 1);

		    // Fast case
		    if (mod3 === 3) {
		      var pow = this.m.add(new BN(1)).iushrn(2);
		      return this.pow(a, pow);
		    }

		    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
		    //
		    // Find Q and S, that Q * 2 ^ S = (P - 1)
		    var q = this.m.subn(1);
		    var s = 0;
		    while (!q.isZero() && q.andln(1) === 0) {
		      s++;
		      q.iushrn(1);
		    }
		    assert(!q.isZero());

		    var one = new BN(1).toRed(this);
		    var nOne = one.redNeg();

		    // Find quadratic non-residue
		    // NOTE: Max is such because of generalized Riemann hypothesis.
		    var lpow = this.m.subn(1).iushrn(1);
		    var z = this.m.bitLength();
		    z = new BN(2 * z * z).toRed(this);

		    while (this.pow(z, lpow).cmp(nOne) !== 0) {
		      z.redIAdd(nOne);
		    }

		    var c = this.pow(z, q);
		    var r = this.pow(a, q.addn(1).iushrn(1));
		    var t = this.pow(a, q);
		    var m = s;
		    while (t.cmp(one) !== 0) {
		      var tmp = t;
		      for (var i = 0; tmp.cmp(one) !== 0; i++) {
		        tmp = tmp.redSqr();
		      }
		      assert(i < m);
		      var b = this.pow(c, new BN(1).iushln(m - i - 1));

		      r = r.redMul(b);
		      c = b.redSqr();
		      t = t.redMul(c);
		      m = i;
		    }

		    return r;
		  };

		  Red.prototype.invm = function invm (a) {
		    var inv = a._invmp(this.m);
		    if (inv.negative !== 0) {
		      inv.negative = 0;
		      return this.imod(inv).redNeg();
		    } else {
		      return this.imod(inv);
		    }
		  };

		  Red.prototype.pow = function pow (a, num) {
		    if (num.isZero()) return new BN(1).toRed(this);
		    if (num.cmpn(1) === 0) return a.clone();

		    var windowSize = 4;
		    var wnd = new Array(1 << windowSize);
		    wnd[0] = new BN(1).toRed(this);
		    wnd[1] = a;
		    for (var i = 2; i < wnd.length; i++) {
		      wnd[i] = this.mul(wnd[i - 1], a);
		    }

		    var res = wnd[0];
		    var current = 0;
		    var currentLen = 0;
		    var start = num.bitLength() % 26;
		    if (start === 0) {
		      start = 26;
		    }

		    for (i = num.length - 1; i >= 0; i--) {
		      var word = num.words[i];
		      for (var j = start - 1; j >= 0; j--) {
		        var bit = (word >> j) & 1;
		        if (res !== wnd[0]) {
		          res = this.sqr(res);
		        }

		        if (bit === 0 && current === 0) {
		          currentLen = 0;
		          continue;
		        }

		        current <<= 1;
		        current |= bit;
		        currentLen++;
		        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

		        res = this.mul(res, wnd[current]);
		        currentLen = 0;
		        current = 0;
		      }
		      start = 26;
		    }

		    return res;
		  };

		  Red.prototype.convertTo = function convertTo (num) {
		    var r = num.umod(this.m);

		    return r === num ? r.clone() : r;
		  };

		  Red.prototype.convertFrom = function convertFrom (num) {
		    var res = num.clone();
		    res.red = null;
		    return res;
		  };

		  //
		  // Montgomery method engine
		  //

		  BN.mont = function mont (num) {
		    return new Mont(num);
		  };

		  function Mont (m) {
		    Red.call(this, m);

		    this.shift = this.m.bitLength();
		    if (this.shift % 26 !== 0) {
		      this.shift += 26 - (this.shift % 26);
		    }

		    this.r = new BN(1).iushln(this.shift);
		    this.r2 = this.imod(this.r.sqr());
		    this.rinv = this.r._invmp(this.m);

		    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
		    this.minv = this.minv.umod(this.r);
		    this.minv = this.r.sub(this.minv);
		  }
		  inherits(Mont, Red);

		  Mont.prototype.convertTo = function convertTo (num) {
		    return this.imod(num.ushln(this.shift));
		  };

		  Mont.prototype.convertFrom = function convertFrom (num) {
		    var r = this.imod(num.mul(this.rinv));
		    r.red = null;
		    return r;
		  };

		  Mont.prototype.imul = function imul (a, b) {
		    if (a.isZero() || b.isZero()) {
		      a.words[0] = 0;
		      a.length = 1;
		      return a;
		    }

		    var t = a.imul(b);
		    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
		    var u = t.isub(c).iushrn(this.shift);
		    var res = u;

		    if (u.cmp(this.m) >= 0) {
		      res = u.isub(this.m);
		    } else if (u.cmpn(0) < 0) {
		      res = u.iadd(this.m);
		    }

		    return res._forceRed(this);
		  };

		  Mont.prototype.mul = function mul (a, b) {
		    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

		    var t = a.mul(b);
		    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
		    var u = t.isub(c).iushrn(this.shift);
		    var res = u;
		    if (u.cmp(this.m) >= 0) {
		      res = u.isub(this.m);
		    } else if (u.cmpn(0) < 0) {
		      res = u.iadd(this.m);
		    }

		    return res._forceRed(this);
		  };

		  Mont.prototype.invm = function invm (a) {
		    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
		    var res = this.imod(a._invmp(this.m).mul(this.r2));
		    return res._forceRed(this);
		  };
		})(module, commonjsGlobal); 
	} (bn));

	var bnExports = bn.exports;

	var utils$k = {};

	(function (exports) {

		var utils = exports;

		function toArray(msg, enc) {
		  if (Array.isArray(msg))
		    return msg.slice();
		  if (!msg)
		    return [];
		  var res = [];
		  if (typeof msg !== 'string') {
		    for (var i = 0; i < msg.length; i++)
		      res[i] = msg[i] | 0;
		    return res;
		  }
		  if (enc === 'hex') {
		    msg = msg.replace(/[^a-z0-9]+/ig, '');
		    if (msg.length % 2 !== 0)
		      msg = '0' + msg;
		    for (var i = 0; i < msg.length; i += 2)
		      res.push(parseInt(msg[i] + msg[i + 1], 16));
		  } else {
		    for (var i = 0; i < msg.length; i++) {
		      var c = msg.charCodeAt(i);
		      var hi = c >> 8;
		      var lo = c & 0xff;
		      if (hi)
		        res.push(hi, lo);
		      else
		        res.push(lo);
		    }
		  }
		  return res;
		}
		utils.toArray = toArray;

		function zero2(word) {
		  if (word.length === 1)
		    return '0' + word;
		  else
		    return word;
		}
		utils.zero2 = zero2;

		function toHex(msg) {
		  var res = '';
		  for (var i = 0; i < msg.length; i++)
		    res += zero2(msg[i].toString(16));
		  return res;
		}
		utils.toHex = toHex;

		utils.encode = function encode(arr, enc) {
		  if (enc === 'hex')
		    return toHex(arr);
		  else
		    return arr;
		}; 
	} (utils$k));

	(function (exports) {

		var utils = exports;
		var BN = bnExports;
		var minAssert = minimalisticAssert$1;
		var minUtils = utils$k;

		utils.assert = minAssert;
		utils.toArray = minUtils.toArray;
		utils.zero2 = minUtils.zero2;
		utils.toHex = minUtils.toHex;
		utils.encode = minUtils.encode;

		// Represent num in a w-NAF form
		function getNAF(num, w, bits) {
		  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
		  naf.fill(0);

		  var ws = 1 << (w + 1);
		  var k = num.clone();

		  for (var i = 0; i < naf.length; i++) {
		    var z;
		    var mod = k.andln(ws - 1);
		    if (k.isOdd()) {
		      if (mod > (ws >> 1) - 1)
		        z = (ws >> 1) - mod;
		      else
		        z = mod;
		      k.isubn(z);
		    } else {
		      z = 0;
		    }

		    naf[i] = z;
		    k.iushrn(1);
		  }

		  return naf;
		}
		utils.getNAF = getNAF;

		// Represent k1, k2 in a Joint Sparse Form
		function getJSF(k1, k2) {
		  var jsf = [
		    [],
		    [],
		  ];

		  k1 = k1.clone();
		  k2 = k2.clone();
		  var d1 = 0;
		  var d2 = 0;
		  var m8;
		  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
		    // First phase
		    var m14 = (k1.andln(3) + d1) & 3;
		    var m24 = (k2.andln(3) + d2) & 3;
		    if (m14 === 3)
		      m14 = -1;
		    if (m24 === 3)
		      m24 = -1;
		    var u1;
		    if ((m14 & 1) === 0) {
		      u1 = 0;
		    } else {
		      m8 = (k1.andln(7) + d1) & 7;
		      if ((m8 === 3 || m8 === 5) && m24 === 2)
		        u1 = -m14;
		      else
		        u1 = m14;
		    }
		    jsf[0].push(u1);

		    var u2;
		    if ((m24 & 1) === 0) {
		      u2 = 0;
		    } else {
		      m8 = (k2.andln(7) + d2) & 7;
		      if ((m8 === 3 || m8 === 5) && m14 === 2)
		        u2 = -m24;
		      else
		        u2 = m24;
		    }
		    jsf[1].push(u2);

		    // Second phase
		    if (2 * d1 === u1 + 1)
		      d1 = 1 - d1;
		    if (2 * d2 === u2 + 1)
		      d2 = 1 - d2;
		    k1.iushrn(1);
		    k2.iushrn(1);
		  }

		  return jsf;
		}
		utils.getJSF = getJSF;

		function cachedProperty(obj, name, computer) {
		  var key = '_' + name;
		  obj.prototype[name] = function cachedProperty() {
		    return this[key] !== undefined ? this[key] :
		      this[key] = computer.call(this);
		  };
		}
		utils.cachedProperty = cachedProperty;

		function parseBytes(bytes) {
		  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
		    bytes;
		}
		utils.parseBytes = parseBytes;

		function intFromLE(bytes) {
		  return new BN(bytes, 'hex', 'le');
		}
		utils.intFromLE = intFromLE; 
	} (utils$l));

	var brorand = {exports: {}};

	var r$7;

	brorand.exports = function rand(len) {
	  if (!r$7)
	    r$7 = new Rand(null);

	  return r$7.generate(len);
	};

	function Rand(rand) {
	  this.rand = rand;
	}
	brorand.exports.Rand = Rand;

	Rand.prototype.generate = function generate(len) {
	  return this._rand(len);
	};

	// Emulate crypto API using randy
	Rand.prototype._rand = function _rand(n) {
	  if (this.rand.getBytes)
	    return this.rand.getBytes(n);

	  var res = new Uint8Array(n);
	  for (var i = 0; i < res.length; i++)
	    res[i] = this.rand.getByte();
	  return res;
	};

	if (typeof self === 'object') {
	  if (self.crypto && self.crypto.getRandomValues) {
	    // Modern browsers
	    Rand.prototype._rand = function _rand(n) {
	      var arr = new Uint8Array(n);
	      self.crypto.getRandomValues(arr);
	      return arr;
	    };
	  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
	    // IE
	    Rand.prototype._rand = function _rand(n) {
	      var arr = new Uint8Array(n);
	      self.msCrypto.getRandomValues(arr);
	      return arr;
	    };

	  // Safari's WebWorkers do not have `crypto`
	  } else if (typeof window === 'object') {
	    // Old junk
	    Rand.prototype._rand = function() {
	      throw new Error('Not implemented yet');
	    };
	  }
	} else {
	  // Node.js or Web worker with no crypto support
	  try {
	    var crypto$2 = require$$3;
	    if (typeof crypto$2.randomBytes !== 'function')
	      throw new Error('Not supported');

	    Rand.prototype._rand = function _rand(n) {
	      return crypto$2.randomBytes(n);
	    };
	  } catch (e) {
	  }
	}

	var brorandExports = brorand.exports;

	var curve = {};

	var BN$9 = bnExports;
	var utils$j = utils$l;
	var getNAF = utils$j.getNAF;
	var getJSF = utils$j.getJSF;
	var assert$c = utils$j.assert;

	function BaseCurve(type, conf) {
	  this.type = type;
	  this.p = new BN$9(conf.p, 16);

	  // Use Montgomery, when there is no fast reduction for the prime
	  this.red = conf.prime ? BN$9.red(conf.prime) : BN$9.mont(this.p);

	  // Useful for many curves
	  this.zero = new BN$9(0).toRed(this.red);
	  this.one = new BN$9(1).toRed(this.red);
	  this.two = new BN$9(2).toRed(this.red);

	  // Curve configuration, optional
	  this.n = conf.n && new BN$9(conf.n, 16);
	  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

	  // Temporary arrays
	  this._wnafT1 = new Array(4);
	  this._wnafT2 = new Array(4);
	  this._wnafT3 = new Array(4);
	  this._wnafT4 = new Array(4);

	  this._bitLength = this.n ? this.n.bitLength() : 0;

	  // Generalized Greg Maxwell's trick
	  var adjustCount = this.n && this.p.div(this.n);
	  if (!adjustCount || adjustCount.cmpn(100) > 0) {
	    this.redN = null;
	  } else {
	    this._maxwellTrick = true;
	    this.redN = this.n.toRed(this.red);
	  }
	}
	var base = BaseCurve;

	BaseCurve.prototype.point = function point() {
	  throw new Error('Not implemented');
	};

	BaseCurve.prototype.validate = function validate() {
	  throw new Error('Not implemented');
	};

	BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
	  assert$c(p.precomputed);
	  var doubles = p._getDoubles();

	  var naf = getNAF(k, 1, this._bitLength);
	  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
	  I /= 3;

	  // Translate into more windowed form
	  var repr = [];
	  var j;
	  var nafW;
	  for (j = 0; j < naf.length; j += doubles.step) {
	    nafW = 0;
	    for (var l = j + doubles.step - 1; l >= j; l--)
	      nafW = (nafW << 1) + naf[l];
	    repr.push(nafW);
	  }

	  var a = this.jpoint(null, null, null);
	  var b = this.jpoint(null, null, null);
	  for (var i = I; i > 0; i--) {
	    for (j = 0; j < repr.length; j++) {
	      nafW = repr[j];
	      if (nafW === i)
	        b = b.mixedAdd(doubles.points[j]);
	      else if (nafW === -i)
	        b = b.mixedAdd(doubles.points[j].neg());
	    }
	    a = a.add(b);
	  }
	  return a.toP();
	};

	BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
	  var w = 4;

	  // Precompute window
	  var nafPoints = p._getNAFPoints(w);
	  w = nafPoints.wnd;
	  var wnd = nafPoints.points;

	  // Get NAF form
	  var naf = getNAF(k, w, this._bitLength);

	  // Add `this`*(N+1) for every w-NAF index
	  var acc = this.jpoint(null, null, null);
	  for (var i = naf.length - 1; i >= 0; i--) {
	    // Count zeroes
	    for (var l = 0; i >= 0 && naf[i] === 0; i--)
	      l++;
	    if (i >= 0)
	      l++;
	    acc = acc.dblp(l);

	    if (i < 0)
	      break;
	    var z = naf[i];
	    assert$c(z !== 0);
	    if (p.type === 'affine') {
	      // J +- P
	      if (z > 0)
	        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
	      else
	        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
	    } else {
	      // J +- J
	      if (z > 0)
	        acc = acc.add(wnd[(z - 1) >> 1]);
	      else
	        acc = acc.add(wnd[(-z - 1) >> 1].neg());
	    }
	  }
	  return p.type === 'affine' ? acc.toP() : acc;
	};

	BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
	  points,
	  coeffs,
	  len,
	  jacobianResult) {
	  var wndWidth = this._wnafT1;
	  var wnd = this._wnafT2;
	  var naf = this._wnafT3;

	  // Fill all arrays
	  var max = 0;
	  var i;
	  var j;
	  var p;
	  for (i = 0; i < len; i++) {
	    p = points[i];
	    var nafPoints = p._getNAFPoints(defW);
	    wndWidth[i] = nafPoints.wnd;
	    wnd[i] = nafPoints.points;
	  }

	  // Comb small window NAFs
	  for (i = len - 1; i >= 1; i -= 2) {
	    var a = i - 1;
	    var b = i;
	    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
	      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
	      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
	      max = Math.max(naf[a].length, max);
	      max = Math.max(naf[b].length, max);
	      continue;
	    }

	    var comb = [
	      points[a], /* 1 */
	      null, /* 3 */
	      null, /* 5 */
	      points[b], /* 7 */
	    ];

	    // Try to avoid Projective points, if possible
	    if (points[a].y.cmp(points[b].y) === 0) {
	      comb[1] = points[a].add(points[b]);
	      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
	    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
	      comb[1] = points[a].toJ().mixedAdd(points[b]);
	      comb[2] = points[a].add(points[b].neg());
	    } else {
	      comb[1] = points[a].toJ().mixedAdd(points[b]);
	      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
	    }

	    var index = [
	      -3, /* -1 -1 */
	      -1, /* -1 0 */
	      -5, /* -1 1 */
	      -7, /* 0 -1 */
	      0, /* 0 0 */
	      7, /* 0 1 */
	      5, /* 1 -1 */
	      1, /* 1 0 */
	      3,  /* 1 1 */
	    ];

	    var jsf = getJSF(coeffs[a], coeffs[b]);
	    max = Math.max(jsf[0].length, max);
	    naf[a] = new Array(max);
	    naf[b] = new Array(max);
	    for (j = 0; j < max; j++) {
	      var ja = jsf[0][j] | 0;
	      var jb = jsf[1][j] | 0;

	      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
	      naf[b][j] = 0;
	      wnd[a] = comb;
	    }
	  }

	  var acc = this.jpoint(null, null, null);
	  var tmp = this._wnafT4;
	  for (i = max; i >= 0; i--) {
	    var k = 0;

	    while (i >= 0) {
	      var zero = true;
	      for (j = 0; j < len; j++) {
	        tmp[j] = naf[j][i] | 0;
	        if (tmp[j] !== 0)
	          zero = false;
	      }
	      if (!zero)
	        break;
	      k++;
	      i--;
	    }
	    if (i >= 0)
	      k++;
	    acc = acc.dblp(k);
	    if (i < 0)
	      break;

	    for (j = 0; j < len; j++) {
	      var z = tmp[j];
	      if (z === 0)
	        continue;
	      else if (z > 0)
	        p = wnd[j][(z - 1) >> 1];
	      else if (z < 0)
	        p = wnd[j][(-z - 1) >> 1].neg();

	      if (p.type === 'affine')
	        acc = acc.mixedAdd(p);
	      else
	        acc = acc.add(p);
	    }
	  }
	  // Zeroify references
	  for (i = 0; i < len; i++)
	    wnd[i] = null;

	  if (jacobianResult)
	    return acc;
	  else
	    return acc.toP();
	};

	function BasePoint(curve, type) {
	  this.curve = curve;
	  this.type = type;
	  this.precomputed = null;
	}
	BaseCurve.BasePoint = BasePoint;

	BasePoint.prototype.eq = function eq(/*other*/) {
	  throw new Error('Not implemented');
	};

	BasePoint.prototype.validate = function validate() {
	  return this.curve.validate(this);
	};

	BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
	  bytes = utils$j.toArray(bytes, enc);

	  var len = this.p.byteLength();

	  // uncompressed, hybrid-odd, hybrid-even
	  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
	      bytes.length - 1 === 2 * len) {
	    if (bytes[0] === 0x06)
	      assert$c(bytes[bytes.length - 1] % 2 === 0);
	    else if (bytes[0] === 0x07)
	      assert$c(bytes[bytes.length - 1] % 2 === 1);

	    var res =  this.point(bytes.slice(1, 1 + len),
	      bytes.slice(1 + len, 1 + 2 * len));

	    return res;
	  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
	              bytes.length - 1 === len) {
	    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
	  }
	  throw new Error('Unknown point format');
	};

	BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
	  return this.encode(enc, true);
	};

	BasePoint.prototype._encode = function _encode(compact) {
	  var len = this.curve.p.byteLength();
	  var x = this.getX().toArray('be', len);

	  if (compact)
	    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

	  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
	};

	BasePoint.prototype.encode = function encode(enc, compact) {
	  return utils$j.encode(this._encode(compact), enc);
	};

	BasePoint.prototype.precompute = function precompute(power) {
	  if (this.precomputed)
	    return this;

	  var precomputed = {
	    doubles: null,
	    naf: null,
	    beta: null,
	  };
	  precomputed.naf = this._getNAFPoints(8);
	  precomputed.doubles = this._getDoubles(4, power);
	  precomputed.beta = this._getBeta();
	  this.precomputed = precomputed;

	  return this;
	};

	BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
	  if (!this.precomputed)
	    return false;

	  var doubles = this.precomputed.doubles;
	  if (!doubles)
	    return false;

	  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
	};

	BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
	  if (this.precomputed && this.precomputed.doubles)
	    return this.precomputed.doubles;

	  var doubles = [ this ];
	  var acc = this;
	  for (var i = 0; i < power; i += step) {
	    for (var j = 0; j < step; j++)
	      acc = acc.dbl();
	    doubles.push(acc);
	  }
	  return {
	    step: step,
	    points: doubles,
	  };
	};

	BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
	  if (this.precomputed && this.precomputed.naf)
	    return this.precomputed.naf;

	  var res = [ this ];
	  var max = (1 << wnd) - 1;
	  var dbl = max === 1 ? null : this.dbl();
	  for (var i = 1; i < max; i++)
	    res[i] = res[i - 1].add(dbl);
	  return {
	    wnd: wnd,
	    points: res,
	  };
	};

	BasePoint.prototype._getBeta = function _getBeta() {
	  return null;
	};

	BasePoint.prototype.dblp = function dblp(k) {
	  var r = this;
	  for (var i = 0; i < k; i++)
	    r = r.dbl();
	  return r;
	};

	var utils$i = utils$l;
	var BN$8 = bnExports;
	var inherits$8 = inherits_browserExports;
	var Base$2 = base;

	var assert$b = utils$i.assert;

	function ShortCurve(conf) {
	  Base$2.call(this, 'short', conf);

	  this.a = new BN$8(conf.a, 16).toRed(this.red);
	  this.b = new BN$8(conf.b, 16).toRed(this.red);
	  this.tinv = this.two.redInvm();

	  this.zeroA = this.a.fromRed().cmpn(0) === 0;
	  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

	  // If the curve is endomorphic, precalculate beta and lambda
	  this.endo = this._getEndomorphism(conf);
	  this._endoWnafT1 = new Array(4);
	  this._endoWnafT2 = new Array(4);
	}
	inherits$8(ShortCurve, Base$2);
	var short = ShortCurve;

	ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
	  // No efficient endomorphism
	  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
	    return;

	  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
	  var beta;
	  var lambda;
	  if (conf.beta) {
	    beta = new BN$8(conf.beta, 16).toRed(this.red);
	  } else {
	    var betas = this._getEndoRoots(this.p);
	    // Choose the smallest beta
	    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
	    beta = beta.toRed(this.red);
	  }
	  if (conf.lambda) {
	    lambda = new BN$8(conf.lambda, 16);
	  } else {
	    // Choose the lambda that is matching selected beta
	    var lambdas = this._getEndoRoots(this.n);
	    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
	      lambda = lambdas[0];
	    } else {
	      lambda = lambdas[1];
	      assert$b(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
	    }
	  }

	  // Get basis vectors, used for balanced length-two representation
	  var basis;
	  if (conf.basis) {
	    basis = conf.basis.map(function(vec) {
	      return {
	        a: new BN$8(vec.a, 16),
	        b: new BN$8(vec.b, 16),
	      };
	    });
	  } else {
	    basis = this._getEndoBasis(lambda);
	  }

	  return {
	    beta: beta,
	    lambda: lambda,
	    basis: basis,
	  };
	};

	ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
	  // Find roots of for x^2 + x + 1 in F
	  // Root = (-1 +- Sqrt(-3)) / 2
	  //
	  var red = num === this.p ? this.red : BN$8.mont(num);
	  var tinv = new BN$8(2).toRed(red).redInvm();
	  var ntinv = tinv.redNeg();

	  var s = new BN$8(3).toRed(red).redNeg().redSqrt().redMul(tinv);

	  var l1 = ntinv.redAdd(s).fromRed();
	  var l2 = ntinv.redSub(s).fromRed();
	  return [ l1, l2 ];
	};

	ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
	  // aprxSqrt >= sqrt(this.n)
	  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

	  // 3.74
	  // Run EGCD, until r(L + 1) < aprxSqrt
	  var u = lambda;
	  var v = this.n.clone();
	  var x1 = new BN$8(1);
	  var y1 = new BN$8(0);
	  var x2 = new BN$8(0);
	  var y2 = new BN$8(1);

	  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
	  var a0;
	  var b0;
	  // First vector
	  var a1;
	  var b1;
	  // Second vector
	  var a2;
	  var b2;

	  var prevR;
	  var i = 0;
	  var r;
	  var x;
	  while (u.cmpn(0) !== 0) {
	    var q = v.div(u);
	    r = v.sub(q.mul(u));
	    x = x2.sub(q.mul(x1));
	    var y = y2.sub(q.mul(y1));

	    if (!a1 && r.cmp(aprxSqrt) < 0) {
	      a0 = prevR.neg();
	      b0 = x1;
	      a1 = r.neg();
	      b1 = x;
	    } else if (a1 && ++i === 2) {
	      break;
	    }
	    prevR = r;

	    v = u;
	    u = r;
	    x2 = x1;
	    x1 = x;
	    y2 = y1;
	    y1 = y;
	  }
	  a2 = r.neg();
	  b2 = x;

	  var len1 = a1.sqr().add(b1.sqr());
	  var len2 = a2.sqr().add(b2.sqr());
	  if (len2.cmp(len1) >= 0) {
	    a2 = a0;
	    b2 = b0;
	  }

	  // Normalize signs
	  if (a1.negative) {
	    a1 = a1.neg();
	    b1 = b1.neg();
	  }
	  if (a2.negative) {
	    a2 = a2.neg();
	    b2 = b2.neg();
	  }

	  return [
	    { a: a1, b: b1 },
	    { a: a2, b: b2 },
	  ];
	};

	ShortCurve.prototype._endoSplit = function _endoSplit(k) {
	  var basis = this.endo.basis;
	  var v1 = basis[0];
	  var v2 = basis[1];

	  var c1 = v2.b.mul(k).divRound(this.n);
	  var c2 = v1.b.neg().mul(k).divRound(this.n);

	  var p1 = c1.mul(v1.a);
	  var p2 = c2.mul(v2.a);
	  var q1 = c1.mul(v1.b);
	  var q2 = c2.mul(v2.b);

	  // Calculate answer
	  var k1 = k.sub(p1).sub(p2);
	  var k2 = q1.add(q2).neg();
	  return { k1: k1, k2: k2 };
	};

	ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
	  x = new BN$8(x, 16);
	  if (!x.red)
	    x = x.toRed(this.red);

	  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
	  var y = y2.redSqrt();
	  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
	    throw new Error('invalid point');

	  // XXX Is there any way to tell if the number is odd without converting it
	  // to non-red form?
	  var isOdd = y.fromRed().isOdd();
	  if (odd && !isOdd || !odd && isOdd)
	    y = y.redNeg();

	  return this.point(x, y);
	};

	ShortCurve.prototype.validate = function validate(point) {
	  if (point.inf)
	    return true;

	  var x = point.x;
	  var y = point.y;

	  var ax = this.a.redMul(x);
	  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
	  return y.redSqr().redISub(rhs).cmpn(0) === 0;
	};

	ShortCurve.prototype._endoWnafMulAdd =
	    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
	      var npoints = this._endoWnafT1;
	      var ncoeffs = this._endoWnafT2;
	      for (var i = 0; i < points.length; i++) {
	        var split = this._endoSplit(coeffs[i]);
	        var p = points[i];
	        var beta = p._getBeta();

	        if (split.k1.negative) {
	          split.k1.ineg();
	          p = p.neg(true);
	        }
	        if (split.k2.negative) {
	          split.k2.ineg();
	          beta = beta.neg(true);
	        }

	        npoints[i * 2] = p;
	        npoints[i * 2 + 1] = beta;
	        ncoeffs[i * 2] = split.k1;
	        ncoeffs[i * 2 + 1] = split.k2;
	      }
	      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

	      // Clean-up references to points and coefficients
	      for (var j = 0; j < i * 2; j++) {
	        npoints[j] = null;
	        ncoeffs[j] = null;
	      }
	      return res;
	    };

	function Point$2(curve, x, y, isRed) {
	  Base$2.BasePoint.call(this, curve, 'affine');
	  if (x === null && y === null) {
	    this.x = null;
	    this.y = null;
	    this.inf = true;
	  } else {
	    this.x = new BN$8(x, 16);
	    this.y = new BN$8(y, 16);
	    // Force redgomery representation when loading from JSON
	    if (isRed) {
	      this.x.forceRed(this.curve.red);
	      this.y.forceRed(this.curve.red);
	    }
	    if (!this.x.red)
	      this.x = this.x.toRed(this.curve.red);
	    if (!this.y.red)
	      this.y = this.y.toRed(this.curve.red);
	    this.inf = false;
	  }
	}
	inherits$8(Point$2, Base$2.BasePoint);

	ShortCurve.prototype.point = function point(x, y, isRed) {
	  return new Point$2(this, x, y, isRed);
	};

	ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
	  return Point$2.fromJSON(this, obj, red);
	};

	Point$2.prototype._getBeta = function _getBeta() {
	  if (!this.curve.endo)
	    return;

	  var pre = this.precomputed;
	  if (pre && pre.beta)
	    return pre.beta;

	  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
	  if (pre) {
	    var curve = this.curve;
	    var endoMul = function(p) {
	      return curve.point(p.x.redMul(curve.endo.beta), p.y);
	    };
	    pre.beta = beta;
	    beta.precomputed = {
	      beta: null,
	      naf: pre.naf && {
	        wnd: pre.naf.wnd,
	        points: pre.naf.points.map(endoMul),
	      },
	      doubles: pre.doubles && {
	        step: pre.doubles.step,
	        points: pre.doubles.points.map(endoMul),
	      },
	    };
	  }
	  return beta;
	};

	Point$2.prototype.toJSON = function toJSON() {
	  if (!this.precomputed)
	    return [ this.x, this.y ];

	  return [ this.x, this.y, this.precomputed && {
	    doubles: this.precomputed.doubles && {
	      step: this.precomputed.doubles.step,
	      points: this.precomputed.doubles.points.slice(1),
	    },
	    naf: this.precomputed.naf && {
	      wnd: this.precomputed.naf.wnd,
	      points: this.precomputed.naf.points.slice(1),
	    },
	  } ];
	};

	Point$2.fromJSON = function fromJSON(curve, obj, red) {
	  if (typeof obj === 'string')
	    obj = JSON.parse(obj);
	  var res = curve.point(obj[0], obj[1], red);
	  if (!obj[2])
	    return res;

	  function obj2point(obj) {
	    return curve.point(obj[0], obj[1], red);
	  }

	  var pre = obj[2];
	  res.precomputed = {
	    beta: null,
	    doubles: pre.doubles && {
	      step: pre.doubles.step,
	      points: [ res ].concat(pre.doubles.points.map(obj2point)),
	    },
	    naf: pre.naf && {
	      wnd: pre.naf.wnd,
	      points: [ res ].concat(pre.naf.points.map(obj2point)),
	    },
	  };
	  return res;
	};

	Point$2.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
	      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
	};

	Point$2.prototype.isInfinity = function isInfinity() {
	  return this.inf;
	};

	Point$2.prototype.add = function add(p) {
	  // O + P = P
	  if (this.inf)
	    return p;

	  // P + O = P
	  if (p.inf)
	    return this;

	  // P + P = 2P
	  if (this.eq(p))
	    return this.dbl();

	  // P + (-P) = O
	  if (this.neg().eq(p))
	    return this.curve.point(null, null);

	  // P + Q = O
	  if (this.x.cmp(p.x) === 0)
	    return this.curve.point(null, null);

	  var c = this.y.redSub(p.y);
	  if (c.cmpn(0) !== 0)
	    c = c.redMul(this.x.redSub(p.x).redInvm());
	  var nx = c.redSqr().redISub(this.x).redISub(p.x);
	  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
	  return this.curve.point(nx, ny);
	};

	Point$2.prototype.dbl = function dbl() {
	  if (this.inf)
	    return this;

	  // 2P = O
	  var ys1 = this.y.redAdd(this.y);
	  if (ys1.cmpn(0) === 0)
	    return this.curve.point(null, null);

	  var a = this.curve.a;

	  var x2 = this.x.redSqr();
	  var dyinv = ys1.redInvm();
	  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

	  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
	  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
	  return this.curve.point(nx, ny);
	};

	Point$2.prototype.getX = function getX() {
	  return this.x.fromRed();
	};

	Point$2.prototype.getY = function getY() {
	  return this.y.fromRed();
	};

	Point$2.prototype.mul = function mul(k) {
	  k = new BN$8(k, 16);
	  if (this.isInfinity())
	    return this;
	  else if (this._hasDoubles(k))
	    return this.curve._fixedNafMul(this, k);
	  else if (this.curve.endo)
	    return this.curve._endoWnafMulAdd([ this ], [ k ]);
	  else
	    return this.curve._wnafMul(this, k);
	};

	Point$2.prototype.mulAdd = function mulAdd(k1, p2, k2) {
	  var points = [ this, p2 ];
	  var coeffs = [ k1, k2 ];
	  if (this.curve.endo)
	    return this.curve._endoWnafMulAdd(points, coeffs);
	  else
	    return this.curve._wnafMulAdd(1, points, coeffs, 2);
	};

	Point$2.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
	  var points = [ this, p2 ];
	  var coeffs = [ k1, k2 ];
	  if (this.curve.endo)
	    return this.curve._endoWnafMulAdd(points, coeffs, true);
	  else
	    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
	};

	Point$2.prototype.eq = function eq(p) {
	  return this === p ||
	         this.inf === p.inf &&
	             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
	};

	Point$2.prototype.neg = function neg(_precompute) {
	  if (this.inf)
	    return this;

	  var res = this.curve.point(this.x, this.y.redNeg());
	  if (_precompute && this.precomputed) {
	    var pre = this.precomputed;
	    var negate = function(p) {
	      return p.neg();
	    };
	    res.precomputed = {
	      naf: pre.naf && {
	        wnd: pre.naf.wnd,
	        points: pre.naf.points.map(negate),
	      },
	      doubles: pre.doubles && {
	        step: pre.doubles.step,
	        points: pre.doubles.points.map(negate),
	      },
	    };
	  }
	  return res;
	};

	Point$2.prototype.toJ = function toJ() {
	  if (this.inf)
	    return this.curve.jpoint(null, null, null);

	  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
	  return res;
	};

	function JPoint(curve, x, y, z) {
	  Base$2.BasePoint.call(this, curve, 'jacobian');
	  if (x === null && y === null && z === null) {
	    this.x = this.curve.one;
	    this.y = this.curve.one;
	    this.z = new BN$8(0);
	  } else {
	    this.x = new BN$8(x, 16);
	    this.y = new BN$8(y, 16);
	    this.z = new BN$8(z, 16);
	  }
	  if (!this.x.red)
	    this.x = this.x.toRed(this.curve.red);
	  if (!this.y.red)
	    this.y = this.y.toRed(this.curve.red);
	  if (!this.z.red)
	    this.z = this.z.toRed(this.curve.red);

	  this.zOne = this.z === this.curve.one;
	}
	inherits$8(JPoint, Base$2.BasePoint);

	ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
	  return new JPoint(this, x, y, z);
	};

	JPoint.prototype.toP = function toP() {
	  if (this.isInfinity())
	    return this.curve.point(null, null);

	  var zinv = this.z.redInvm();
	  var zinv2 = zinv.redSqr();
	  var ax = this.x.redMul(zinv2);
	  var ay = this.y.redMul(zinv2).redMul(zinv);

	  return this.curve.point(ax, ay);
	};

	JPoint.prototype.neg = function neg() {
	  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
	};

	JPoint.prototype.add = function add(p) {
	  // O + P = P
	  if (this.isInfinity())
	    return p;

	  // P + O = P
	  if (p.isInfinity())
	    return this;

	  // 12M + 4S + 7A
	  var pz2 = p.z.redSqr();
	  var z2 = this.z.redSqr();
	  var u1 = this.x.redMul(pz2);
	  var u2 = p.x.redMul(z2);
	  var s1 = this.y.redMul(pz2.redMul(p.z));
	  var s2 = p.y.redMul(z2.redMul(this.z));

	  var h = u1.redSub(u2);
	  var r = s1.redSub(s2);
	  if (h.cmpn(0) === 0) {
	    if (r.cmpn(0) !== 0)
	      return this.curve.jpoint(null, null, null);
	    else
	      return this.dbl();
	  }

	  var h2 = h.redSqr();
	  var h3 = h2.redMul(h);
	  var v = u1.redMul(h2);

	  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
	  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
	  var nz = this.z.redMul(p.z).redMul(h);

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype.mixedAdd = function mixedAdd(p) {
	  // O + P = P
	  if (this.isInfinity())
	    return p.toJ();

	  // P + O = P
	  if (p.isInfinity())
	    return this;

	  // 8M + 3S + 7A
	  var z2 = this.z.redSqr();
	  var u1 = this.x;
	  var u2 = p.x.redMul(z2);
	  var s1 = this.y;
	  var s2 = p.y.redMul(z2).redMul(this.z);

	  var h = u1.redSub(u2);
	  var r = s1.redSub(s2);
	  if (h.cmpn(0) === 0) {
	    if (r.cmpn(0) !== 0)
	      return this.curve.jpoint(null, null, null);
	    else
	      return this.dbl();
	  }

	  var h2 = h.redSqr();
	  var h3 = h2.redMul(h);
	  var v = u1.redMul(h2);

	  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
	  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
	  var nz = this.z.redMul(h);

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype.dblp = function dblp(pow) {
	  if (pow === 0)
	    return this;
	  if (this.isInfinity())
	    return this;
	  if (!pow)
	    return this.dbl();

	  var i;
	  if (this.curve.zeroA || this.curve.threeA) {
	    var r = this;
	    for (i = 0; i < pow; i++)
	      r = r.dbl();
	    return r;
	  }

	  // 1M + 2S + 1A + N * (4S + 5M + 8A)
	  // N = 1 => 6M + 6S + 9A
	  var a = this.curve.a;
	  var tinv = this.curve.tinv;

	  var jx = this.x;
	  var jy = this.y;
	  var jz = this.z;
	  var jz4 = jz.redSqr().redSqr();

	  // Reuse results
	  var jyd = jy.redAdd(jy);
	  for (i = 0; i < pow; i++) {
	    var jx2 = jx.redSqr();
	    var jyd2 = jyd.redSqr();
	    var jyd4 = jyd2.redSqr();
	    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

	    var t1 = jx.redMul(jyd2);
	    var nx = c.redSqr().redISub(t1.redAdd(t1));
	    var t2 = t1.redISub(nx);
	    var dny = c.redMul(t2);
	    dny = dny.redIAdd(dny).redISub(jyd4);
	    var nz = jyd.redMul(jz);
	    if (i + 1 < pow)
	      jz4 = jz4.redMul(jyd4);

	    jx = nx;
	    jz = nz;
	    jyd = dny;
	  }

	  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
	};

	JPoint.prototype.dbl = function dbl() {
	  if (this.isInfinity())
	    return this;

	  if (this.curve.zeroA)
	    return this._zeroDbl();
	  else if (this.curve.threeA)
	    return this._threeDbl();
	  else
	    return this._dbl();
	};

	JPoint.prototype._zeroDbl = function _zeroDbl() {
	  var nx;
	  var ny;
	  var nz;
	  // Z = 1
	  if (this.zOne) {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
	    //     #doubling-mdbl-2007-bl
	    // 1M + 5S + 14A

	    // XX = X1^2
	    var xx = this.x.redSqr();
	    // YY = Y1^2
	    var yy = this.y.redSqr();
	    // YYYY = YY^2
	    var yyyy = yy.redSqr();
	    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
	    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	    s = s.redIAdd(s);
	    // M = 3 * XX + a; a = 0
	    var m = xx.redAdd(xx).redIAdd(xx);
	    // T = M ^ 2 - 2*S
	    var t = m.redSqr().redISub(s).redISub(s);

	    // 8 * YYYY
	    var yyyy8 = yyyy.redIAdd(yyyy);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    yyyy8 = yyyy8.redIAdd(yyyy8);

	    // X3 = T
	    nx = t;
	    // Y3 = M * (S - T) - 8 * YYYY
	    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
	    // Z3 = 2*Y1
	    nz = this.y.redAdd(this.y);
	  } else {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
	    //     #doubling-dbl-2009-l
	    // 2M + 5S + 13A

	    // A = X1^2
	    var a = this.x.redSqr();
	    // B = Y1^2
	    var b = this.y.redSqr();
	    // C = B^2
	    var c = b.redSqr();
	    // D = 2 * ((X1 + B)^2 - A - C)
	    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
	    d = d.redIAdd(d);
	    // E = 3 * A
	    var e = a.redAdd(a).redIAdd(a);
	    // F = E^2
	    var f = e.redSqr();

	    // 8 * C
	    var c8 = c.redIAdd(c);
	    c8 = c8.redIAdd(c8);
	    c8 = c8.redIAdd(c8);

	    // X3 = F - 2 * D
	    nx = f.redISub(d).redISub(d);
	    // Y3 = E * (D - X3) - 8 * C
	    ny = e.redMul(d.redISub(nx)).redISub(c8);
	    // Z3 = 2 * Y1 * Z1
	    nz = this.y.redMul(this.z);
	    nz = nz.redIAdd(nz);
	  }

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype._threeDbl = function _threeDbl() {
	  var nx;
	  var ny;
	  var nz;
	  // Z = 1
	  if (this.zOne) {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
	    //     #doubling-mdbl-2007-bl
	    // 1M + 5S + 15A

	    // XX = X1^2
	    var xx = this.x.redSqr();
	    // YY = Y1^2
	    var yy = this.y.redSqr();
	    // YYYY = YY^2
	    var yyyy = yy.redSqr();
	    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
	    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	    s = s.redIAdd(s);
	    // M = 3 * XX + a
	    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
	    // T = M^2 - 2 * S
	    var t = m.redSqr().redISub(s).redISub(s);
	    // X3 = T
	    nx = t;
	    // Y3 = M * (S - T) - 8 * YYYY
	    var yyyy8 = yyyy.redIAdd(yyyy);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
	    // Z3 = 2 * Y1
	    nz = this.y.redAdd(this.y);
	  } else {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
	    // 3M + 5S

	    // delta = Z1^2
	    var delta = this.z.redSqr();
	    // gamma = Y1^2
	    var gamma = this.y.redSqr();
	    // beta = X1 * gamma
	    var beta = this.x.redMul(gamma);
	    // alpha = 3 * (X1 - delta) * (X1 + delta)
	    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
	    alpha = alpha.redAdd(alpha).redIAdd(alpha);
	    // X3 = alpha^2 - 8 * beta
	    var beta4 = beta.redIAdd(beta);
	    beta4 = beta4.redIAdd(beta4);
	    var beta8 = beta4.redAdd(beta4);
	    nx = alpha.redSqr().redISub(beta8);
	    // Z3 = (Y1 + Z1)^2 - gamma - delta
	    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
	    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
	    var ggamma8 = gamma.redSqr();
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
	  }

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype._dbl = function _dbl() {
	  var a = this.curve.a;

	  // 4M + 6S + 10A
	  var jx = this.x;
	  var jy = this.y;
	  var jz = this.z;
	  var jz4 = jz.redSqr().redSqr();

	  var jx2 = jx.redSqr();
	  var jy2 = jy.redSqr();

	  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

	  var jxd4 = jx.redAdd(jx);
	  jxd4 = jxd4.redIAdd(jxd4);
	  var t1 = jxd4.redMul(jy2);
	  var nx = c.redSqr().redISub(t1.redAdd(t1));
	  var t2 = t1.redISub(nx);

	  var jyd8 = jy2.redSqr();
	  jyd8 = jyd8.redIAdd(jyd8);
	  jyd8 = jyd8.redIAdd(jyd8);
	  jyd8 = jyd8.redIAdd(jyd8);
	  var ny = c.redMul(t2).redISub(jyd8);
	  var nz = jy.redAdd(jy).redMul(jz);

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype.trpl = function trpl() {
	  if (!this.curve.zeroA)
	    return this.dbl().add(this);

	  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
	  // 5M + 10S + ...

	  // XX = X1^2
	  var xx = this.x.redSqr();
	  // YY = Y1^2
	  var yy = this.y.redSqr();
	  // ZZ = Z1^2
	  var zz = this.z.redSqr();
	  // YYYY = YY^2
	  var yyyy = yy.redSqr();
	  // M = 3 * XX + a * ZZ2; a = 0
	  var m = xx.redAdd(xx).redIAdd(xx);
	  // MM = M^2
	  var mm = m.redSqr();
	  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
	  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	  e = e.redIAdd(e);
	  e = e.redAdd(e).redIAdd(e);
	  e = e.redISub(mm);
	  // EE = E^2
	  var ee = e.redSqr();
	  // T = 16*YYYY
	  var t = yyyy.redIAdd(yyyy);
	  t = t.redIAdd(t);
	  t = t.redIAdd(t);
	  t = t.redIAdd(t);
	  // U = (M + E)^2 - MM - EE - T
	  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
	  // X3 = 4 * (X1 * EE - 4 * YY * U)
	  var yyu4 = yy.redMul(u);
	  yyu4 = yyu4.redIAdd(yyu4);
	  yyu4 = yyu4.redIAdd(yyu4);
	  var nx = this.x.redMul(ee).redISub(yyu4);
	  nx = nx.redIAdd(nx);
	  nx = nx.redIAdd(nx);
	  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
	  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
	  ny = ny.redIAdd(ny);
	  ny = ny.redIAdd(ny);
	  ny = ny.redIAdd(ny);
	  // Z3 = (Z1 + E)^2 - ZZ - EE
	  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

	  return this.curve.jpoint(nx, ny, nz);
	};

	JPoint.prototype.mul = function mul(k, kbase) {
	  k = new BN$8(k, kbase);

	  return this.curve._wnafMul(this, k);
	};

	JPoint.prototype.eq = function eq(p) {
	  if (p.type === 'affine')
	    return this.eq(p.toJ());

	  if (this === p)
	    return true;

	  // x1 * z2^2 == x2 * z1^2
	  var z2 = this.z.redSqr();
	  var pz2 = p.z.redSqr();
	  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
	    return false;

	  // y1 * z2^3 == y2 * z1^3
	  var z3 = z2.redMul(this.z);
	  var pz3 = pz2.redMul(p.z);
	  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
	};

	JPoint.prototype.eqXToP = function eqXToP(x) {
	  var zs = this.z.redSqr();
	  var rx = x.toRed(this.curve.red).redMul(zs);
	  if (this.x.cmp(rx) === 0)
	    return true;

	  var xc = x.clone();
	  var t = this.curve.redN.redMul(zs);
	  for (;;) {
	    xc.iadd(this.curve.n);
	    if (xc.cmp(this.curve.p) >= 0)
	      return false;

	    rx.redIAdd(t);
	    if (this.x.cmp(rx) === 0)
	      return true;
	  }
	};

	JPoint.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC JPoint Infinity>';
	  return '<EC JPoint x: ' + this.x.toString(16, 2) +
	      ' y: ' + this.y.toString(16, 2) +
	      ' z: ' + this.z.toString(16, 2) + '>';
	};

	JPoint.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.z.cmpn(0) === 0;
	};

	var BN$7 = bnExports;
	var inherits$7 = inherits_browserExports;
	var Base$1 = base;

	var utils$h = utils$l;

	function MontCurve(conf) {
	  Base$1.call(this, 'mont', conf);

	  this.a = new BN$7(conf.a, 16).toRed(this.red);
	  this.b = new BN$7(conf.b, 16).toRed(this.red);
	  this.i4 = new BN$7(4).toRed(this.red).redInvm();
	  this.two = new BN$7(2).toRed(this.red);
	  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
	}
	inherits$7(MontCurve, Base$1);
	var mont = MontCurve;

	MontCurve.prototype.validate = function validate(point) {
	  var x = point.normalize().x;
	  var x2 = x.redSqr();
	  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
	  var y = rhs.redSqrt();

	  return y.redSqr().cmp(rhs) === 0;
	};

	function Point$1(curve, x, z) {
	  Base$1.BasePoint.call(this, curve, 'projective');
	  if (x === null && z === null) {
	    this.x = this.curve.one;
	    this.z = this.curve.zero;
	  } else {
	    this.x = new BN$7(x, 16);
	    this.z = new BN$7(z, 16);
	    if (!this.x.red)
	      this.x = this.x.toRed(this.curve.red);
	    if (!this.z.red)
	      this.z = this.z.toRed(this.curve.red);
	  }
	}
	inherits$7(Point$1, Base$1.BasePoint);

	MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
	  return this.point(utils$h.toArray(bytes, enc), 1);
	};

	MontCurve.prototype.point = function point(x, z) {
	  return new Point$1(this, x, z);
	};

	MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
	  return Point$1.fromJSON(this, obj);
	};

	Point$1.prototype.precompute = function precompute() {
	  // No-op
	};

	Point$1.prototype._encode = function _encode() {
	  return this.getX().toArray('be', this.curve.p.byteLength());
	};

	Point$1.fromJSON = function fromJSON(curve, obj) {
	  return new Point$1(curve, obj[0], obj[1] || curve.one);
	};

	Point$1.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
	      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
	};

	Point$1.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.z.cmpn(0) === 0;
	};

	Point$1.prototype.dbl = function dbl() {
	  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
	  // 2M + 2S + 4A

	  // A = X1 + Z1
	  var a = this.x.redAdd(this.z);
	  // AA = A^2
	  var aa = a.redSqr();
	  // B = X1 - Z1
	  var b = this.x.redSub(this.z);
	  // BB = B^2
	  var bb = b.redSqr();
	  // C = AA - BB
	  var c = aa.redSub(bb);
	  // X3 = AA * BB
	  var nx = aa.redMul(bb);
	  // Z3 = C * (BB + A24 * C)
	  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
	  return this.curve.point(nx, nz);
	};

	Point$1.prototype.add = function add() {
	  throw new Error('Not supported on Montgomery curve');
	};

	Point$1.prototype.diffAdd = function diffAdd(p, diff) {
	  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
	  // 4M + 2S + 6A

	  // A = X2 + Z2
	  var a = this.x.redAdd(this.z);
	  // B = X2 - Z2
	  var b = this.x.redSub(this.z);
	  // C = X3 + Z3
	  var c = p.x.redAdd(p.z);
	  // D = X3 - Z3
	  var d = p.x.redSub(p.z);
	  // DA = D * A
	  var da = d.redMul(a);
	  // CB = C * B
	  var cb = c.redMul(b);
	  // X5 = Z1 * (DA + CB)^2
	  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
	  // Z5 = X1 * (DA - CB)^2
	  var nz = diff.x.redMul(da.redISub(cb).redSqr());
	  return this.curve.point(nx, nz);
	};

	Point$1.prototype.mul = function mul(k) {
	  var t = k.clone();
	  var a = this; // (N / 2) * Q + Q
	  var b = this.curve.point(null, null); // (N / 2) * Q
	  var c = this; // Q

	  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
	    bits.push(t.andln(1));

	  for (var i = bits.length - 1; i >= 0; i--) {
	    if (bits[i] === 0) {
	      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
	      a = a.diffAdd(b, c);
	      // N * Q = 2 * ((N / 2) * Q + Q))
	      b = b.dbl();
	    } else {
	      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
	      b = a.diffAdd(b, c);
	      // N * Q + Q = 2 * ((N / 2) * Q + Q)
	      a = a.dbl();
	    }
	  }
	  return b;
	};

	Point$1.prototype.mulAdd = function mulAdd() {
	  throw new Error('Not supported on Montgomery curve');
	};

	Point$1.prototype.jumlAdd = function jumlAdd() {
	  throw new Error('Not supported on Montgomery curve');
	};

	Point$1.prototype.eq = function eq(other) {
	  return this.getX().cmp(other.getX()) === 0;
	};

	Point$1.prototype.normalize = function normalize() {
	  this.x = this.x.redMul(this.z.redInvm());
	  this.z = this.curve.one;
	  return this;
	};

	Point$1.prototype.getX = function getX() {
	  // Normalize coordinates
	  this.normalize();

	  return this.x.fromRed();
	};

	var utils$g = utils$l;
	var BN$6 = bnExports;
	var inherits$6 = inherits_browserExports;
	var Base = base;

	var assert$a = utils$g.assert;

	function EdwardsCurve(conf) {
	  // NOTE: Important as we are creating point in Base.call()
	  this.twisted = (conf.a | 0) !== 1;
	  this.mOneA = this.twisted && (conf.a | 0) === -1;
	  this.extended = this.mOneA;

	  Base.call(this, 'edwards', conf);

	  this.a = new BN$6(conf.a, 16).umod(this.red.m);
	  this.a = this.a.toRed(this.red);
	  this.c = new BN$6(conf.c, 16).toRed(this.red);
	  this.c2 = this.c.redSqr();
	  this.d = new BN$6(conf.d, 16).toRed(this.red);
	  this.dd = this.d.redAdd(this.d);

	  assert$a(!this.twisted || this.c.fromRed().cmpn(1) === 0);
	  this.oneC = (conf.c | 0) === 1;
	}
	inherits$6(EdwardsCurve, Base);
	var edwards = EdwardsCurve;

	EdwardsCurve.prototype._mulA = function _mulA(num) {
	  if (this.mOneA)
	    return num.redNeg();
	  else
	    return this.a.redMul(num);
	};

	EdwardsCurve.prototype._mulC = function _mulC(num) {
	  if (this.oneC)
	    return num;
	  else
	    return this.c.redMul(num);
	};

	// Just for compatibility with Short curve
	EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
	  return this.point(x, y, z, t);
	};

	EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
	  x = new BN$6(x, 16);
	  if (!x.red)
	    x = x.toRed(this.red);

	  var x2 = x.redSqr();
	  var rhs = this.c2.redSub(this.a.redMul(x2));
	  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

	  var y2 = rhs.redMul(lhs.redInvm());
	  var y = y2.redSqrt();
	  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
	    throw new Error('invalid point');

	  var isOdd = y.fromRed().isOdd();
	  if (odd && !isOdd || !odd && isOdd)
	    y = y.redNeg();

	  return this.point(x, y);
	};

	EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
	  y = new BN$6(y, 16);
	  if (!y.red)
	    y = y.toRed(this.red);

	  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
	  var y2 = y.redSqr();
	  var lhs = y2.redSub(this.c2);
	  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
	  var x2 = lhs.redMul(rhs.redInvm());

	  if (x2.cmp(this.zero) === 0) {
	    if (odd)
	      throw new Error('invalid point');
	    else
	      return this.point(this.zero, y);
	  }

	  var x = x2.redSqrt();
	  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
	    throw new Error('invalid point');

	  if (x.fromRed().isOdd() !== odd)
	    x = x.redNeg();

	  return this.point(x, y);
	};

	EdwardsCurve.prototype.validate = function validate(point) {
	  if (point.isInfinity())
	    return true;

	  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
	  point.normalize();

	  var x2 = point.x.redSqr();
	  var y2 = point.y.redSqr();
	  var lhs = x2.redMul(this.a).redAdd(y2);
	  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

	  return lhs.cmp(rhs) === 0;
	};

	function Point(curve, x, y, z, t) {
	  Base.BasePoint.call(this, curve, 'projective');
	  if (x === null && y === null && z === null) {
	    this.x = this.curve.zero;
	    this.y = this.curve.one;
	    this.z = this.curve.one;
	    this.t = this.curve.zero;
	    this.zOne = true;
	  } else {
	    this.x = new BN$6(x, 16);
	    this.y = new BN$6(y, 16);
	    this.z = z ? new BN$6(z, 16) : this.curve.one;
	    this.t = t && new BN$6(t, 16);
	    if (!this.x.red)
	      this.x = this.x.toRed(this.curve.red);
	    if (!this.y.red)
	      this.y = this.y.toRed(this.curve.red);
	    if (!this.z.red)
	      this.z = this.z.toRed(this.curve.red);
	    if (this.t && !this.t.red)
	      this.t = this.t.toRed(this.curve.red);
	    this.zOne = this.z === this.curve.one;

	    // Use extended coordinates
	    if (this.curve.extended && !this.t) {
	      this.t = this.x.redMul(this.y);
	      if (!this.zOne)
	        this.t = this.t.redMul(this.z.redInvm());
	    }
	  }
	}
	inherits$6(Point, Base.BasePoint);

	EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
	  return Point.fromJSON(this, obj);
	};

	EdwardsCurve.prototype.point = function point(x, y, z, t) {
	  return new Point(this, x, y, z, t);
	};

	Point.fromJSON = function fromJSON(curve, obj) {
	  return new Point(curve, obj[0], obj[1], obj[2]);
	};

	Point.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
	      ' y: ' + this.y.fromRed().toString(16, 2) +
	      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
	};

	Point.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.x.cmpn(0) === 0 &&
	    (this.y.cmp(this.z) === 0 ||
	    (this.zOne && this.y.cmp(this.curve.c) === 0));
	};

	Point.prototype._extDbl = function _extDbl() {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
	  //     #doubling-dbl-2008-hwcd
	  // 4M + 4S

	  // A = X1^2
	  var a = this.x.redSqr();
	  // B = Y1^2
	  var b = this.y.redSqr();
	  // C = 2 * Z1^2
	  var c = this.z.redSqr();
	  c = c.redIAdd(c);
	  // D = a * A
	  var d = this.curve._mulA(a);
	  // E = (X1 + Y1)^2 - A - B
	  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
	  // G = D + B
	  var g = d.redAdd(b);
	  // F = G - C
	  var f = g.redSub(c);
	  // H = D - B
	  var h = d.redSub(b);
	  // X3 = E * F
	  var nx = e.redMul(f);
	  // Y3 = G * H
	  var ny = g.redMul(h);
	  // T3 = E * H
	  var nt = e.redMul(h);
	  // Z3 = F * G
	  var nz = f.redMul(g);
	  return this.curve.point(nx, ny, nz, nt);
	};

	Point.prototype._projDbl = function _projDbl() {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
	  //     #doubling-dbl-2008-bbjlp
	  //     #doubling-dbl-2007-bl
	  // and others
	  // Generally 3M + 4S or 2M + 4S

	  // B = (X1 + Y1)^2
	  var b = this.x.redAdd(this.y).redSqr();
	  // C = X1^2
	  var c = this.x.redSqr();
	  // D = Y1^2
	  var d = this.y.redSqr();

	  var nx;
	  var ny;
	  var nz;
	  var e;
	  var h;
	  var j;
	  if (this.curve.twisted) {
	    // E = a * C
	    e = this.curve._mulA(c);
	    // F = E + D
	    var f = e.redAdd(d);
	    if (this.zOne) {
	      // X3 = (B - C - D) * (F - 2)
	      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
	      // Y3 = F * (E - D)
	      ny = f.redMul(e.redSub(d));
	      // Z3 = F^2 - 2 * F
	      nz = f.redSqr().redSub(f).redSub(f);
	    } else {
	      // H = Z1^2
	      h = this.z.redSqr();
	      // J = F - 2 * H
	      j = f.redSub(h).redISub(h);
	      // X3 = (B-C-D)*J
	      nx = b.redSub(c).redISub(d).redMul(j);
	      // Y3 = F * (E - D)
	      ny = f.redMul(e.redSub(d));
	      // Z3 = F * J
	      nz = f.redMul(j);
	    }
	  } else {
	    // E = C + D
	    e = c.redAdd(d);
	    // H = (c * Z1)^2
	    h = this.curve._mulC(this.z).redSqr();
	    // J = E - 2 * H
	    j = e.redSub(h).redSub(h);
	    // X3 = c * (B - E) * J
	    nx = this.curve._mulC(b.redISub(e)).redMul(j);
	    // Y3 = c * E * (C - D)
	    ny = this.curve._mulC(e).redMul(c.redISub(d));
	    // Z3 = E * J
	    nz = e.redMul(j);
	  }
	  return this.curve.point(nx, ny, nz);
	};

	Point.prototype.dbl = function dbl() {
	  if (this.isInfinity())
	    return this;

	  // Double in extended coordinates
	  if (this.curve.extended)
	    return this._extDbl();
	  else
	    return this._projDbl();
	};

	Point.prototype._extAdd = function _extAdd(p) {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
	  //     #addition-add-2008-hwcd-3
	  // 8M

	  // A = (Y1 - X1) * (Y2 - X2)
	  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
	  // B = (Y1 + X1) * (Y2 + X2)
	  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
	  // C = T1 * k * T2
	  var c = this.t.redMul(this.curve.dd).redMul(p.t);
	  // D = Z1 * 2 * Z2
	  var d = this.z.redMul(p.z.redAdd(p.z));
	  // E = B - A
	  var e = b.redSub(a);
	  // F = D - C
	  var f = d.redSub(c);
	  // G = D + C
	  var g = d.redAdd(c);
	  // H = B + A
	  var h = b.redAdd(a);
	  // X3 = E * F
	  var nx = e.redMul(f);
	  // Y3 = G * H
	  var ny = g.redMul(h);
	  // T3 = E * H
	  var nt = e.redMul(h);
	  // Z3 = F * G
	  var nz = f.redMul(g);
	  return this.curve.point(nx, ny, nz, nt);
	};

	Point.prototype._projAdd = function _projAdd(p) {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
	  //     #addition-add-2008-bbjlp
	  //     #addition-add-2007-bl
	  // 10M + 1S

	  // A = Z1 * Z2
	  var a = this.z.redMul(p.z);
	  // B = A^2
	  var b = a.redSqr();
	  // C = X1 * X2
	  var c = this.x.redMul(p.x);
	  // D = Y1 * Y2
	  var d = this.y.redMul(p.y);
	  // E = d * C * D
	  var e = this.curve.d.redMul(c).redMul(d);
	  // F = B - E
	  var f = b.redSub(e);
	  // G = B + E
	  var g = b.redAdd(e);
	  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
	  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
	  var nx = a.redMul(f).redMul(tmp);
	  var ny;
	  var nz;
	  if (this.curve.twisted) {
	    // Y3 = A * G * (D - a * C)
	    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
	    // Z3 = F * G
	    nz = f.redMul(g);
	  } else {
	    // Y3 = A * G * (D - C)
	    ny = a.redMul(g).redMul(d.redSub(c));
	    // Z3 = c * F * G
	    nz = this.curve._mulC(f).redMul(g);
	  }
	  return this.curve.point(nx, ny, nz);
	};

	Point.prototype.add = function add(p) {
	  if (this.isInfinity())
	    return p;
	  if (p.isInfinity())
	    return this;

	  if (this.curve.extended)
	    return this._extAdd(p);
	  else
	    return this._projAdd(p);
	};

	Point.prototype.mul = function mul(k) {
	  if (this._hasDoubles(k))
	    return this.curve._fixedNafMul(this, k);
	  else
	    return this.curve._wnafMul(this, k);
	};

	Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
	  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
	};

	Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
	  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
	};

	Point.prototype.normalize = function normalize() {
	  if (this.zOne)
	    return this;

	  // Normalize coordinates
	  var zi = this.z.redInvm();
	  this.x = this.x.redMul(zi);
	  this.y = this.y.redMul(zi);
	  if (this.t)
	    this.t = this.t.redMul(zi);
	  this.z = this.curve.one;
	  this.zOne = true;
	  return this;
	};

	Point.prototype.neg = function neg() {
	  return this.curve.point(this.x.redNeg(),
	    this.y,
	    this.z,
	    this.t && this.t.redNeg());
	};

	Point.prototype.getX = function getX() {
	  this.normalize();
	  return this.x.fromRed();
	};

	Point.prototype.getY = function getY() {
	  this.normalize();
	  return this.y.fromRed();
	};

	Point.prototype.eq = function eq(other) {
	  return this === other ||
	         this.getX().cmp(other.getX()) === 0 &&
	         this.getY().cmp(other.getY()) === 0;
	};

	Point.prototype.eqXToP = function eqXToP(x) {
	  var rx = x.toRed(this.curve.red).redMul(this.z);
	  if (this.x.cmp(rx) === 0)
	    return true;

	  var xc = x.clone();
	  var t = this.curve.redN.redMul(this.z);
	  for (;;) {
	    xc.iadd(this.curve.n);
	    if (xc.cmp(this.curve.p) >= 0)
	      return false;

	    rx.redIAdd(t);
	    if (this.x.cmp(rx) === 0)
	      return true;
	  }
	};

	// Compatibility with BaseCurve
	Point.prototype.toP = Point.prototype.normalize;
	Point.prototype.mixedAdd = Point.prototype.add;

	(function (exports) {

		var curve = exports;

		curve.base = base;
		curve.short = short;
		curve.mont = mont;
		curve.edwards = edwards; 
	} (curve));

	var curves$2 = {};

	var secp256k1;
	var hasRequiredSecp256k1;

	function requireSecp256k1 () {
		if (hasRequiredSecp256k1) return secp256k1;
		hasRequiredSecp256k1 = 1;
		secp256k1 = {
		  doubles: {
		    step: 4,
		    points: [
		      [
		        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
		        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
		      ],
		      [
		        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
		        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
		      ],
		      [
		        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
		        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
		      ],
		      [
		        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
		        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
		      ],
		      [
		        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
		        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
		      ],
		      [
		        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
		        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
		      ],
		      [
		        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
		        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
		      ],
		      [
		        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
		        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
		      ],
		      [
		        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
		        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
		      ],
		      [
		        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
		        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
		      ],
		      [
		        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
		        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
		      ],
		      [
		        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
		        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
		      ],
		      [
		        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
		        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
		      ],
		      [
		        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
		        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
		      ],
		      [
		        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
		        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
		      ],
		      [
		        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
		        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
		      ],
		      [
		        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
		        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
		      ],
		      [
		        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
		        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
		      ],
		      [
		        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
		        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
		      ],
		      [
		        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
		        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
		      ],
		      [
		        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
		        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
		      ],
		      [
		        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
		        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
		      ],
		      [
		        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
		        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
		      ],
		      [
		        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
		        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
		      ],
		      [
		        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
		        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
		      ],
		      [
		        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
		        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
		      ],
		      [
		        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
		        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
		      ],
		      [
		        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
		        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
		      ],
		      [
		        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
		        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
		      ],
		      [
		        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
		        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
		      ],
		      [
		        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
		        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
		      ],
		      [
		        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
		        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
		      ],
		      [
		        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
		        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
		      ],
		      [
		        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
		        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
		      ],
		      [
		        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
		        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
		      ],
		      [
		        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
		        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
		      ],
		      [
		        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
		        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
		      ],
		      [
		        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
		        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
		      ],
		      [
		        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
		        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
		      ],
		      [
		        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
		        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
		      ],
		      [
		        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
		        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
		      ],
		      [
		        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
		        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
		      ],
		      [
		        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
		        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
		      ],
		      [
		        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
		        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
		      ],
		      [
		        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
		        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
		      ],
		      [
		        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
		        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
		      ],
		      [
		        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
		        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
		      ],
		      [
		        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
		        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
		      ],
		      [
		        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
		        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
		      ],
		      [
		        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
		        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
		      ],
		      [
		        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
		        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
		      ],
		      [
		        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
		        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
		      ],
		      [
		        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
		        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
		      ],
		      [
		        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
		        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
		      ],
		      [
		        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
		        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
		      ],
		      [
		        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
		        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
		      ],
		      [
		        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
		        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
		      ],
		      [
		        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
		        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
		      ],
		      [
		        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
		        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
		      ],
		      [
		        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
		        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
		      ],
		      [
		        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
		        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
		      ],
		      [
		        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
		        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
		      ],
		      [
		        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
		        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
		      ],
		      [
		        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
		        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
		      ],
		      [
		        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
		        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
		      ],
		    ],
		  },
		  naf: {
		    wnd: 7,
		    points: [
		      [
		        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
		        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
		      ],
		      [
		        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
		        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
		      ],
		      [
		        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
		        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
		      ],
		      [
		        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
		        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
		      ],
		      [
		        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
		        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
		      ],
		      [
		        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
		        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
		      ],
		      [
		        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
		        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
		      ],
		      [
		        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
		        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
		      ],
		      [
		        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
		        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
		      ],
		      [
		        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
		        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
		      ],
		      [
		        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
		        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
		      ],
		      [
		        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
		        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
		      ],
		      [
		        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
		        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
		      ],
		      [
		        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
		        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
		      ],
		      [
		        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
		        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
		      ],
		      [
		        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
		        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
		      ],
		      [
		        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
		        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
		      ],
		      [
		        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
		        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
		      ],
		      [
		        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
		        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
		      ],
		      [
		        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
		        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
		      ],
		      [
		        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
		        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
		      ],
		      [
		        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
		        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
		      ],
		      [
		        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
		        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
		      ],
		      [
		        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
		        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
		      ],
		      [
		        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
		        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
		      ],
		      [
		        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
		        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
		      ],
		      [
		        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
		        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
		      ],
		      [
		        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
		        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
		      ],
		      [
		        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
		        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
		      ],
		      [
		        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
		        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
		      ],
		      [
		        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
		        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
		      ],
		      [
		        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
		        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
		      ],
		      [
		        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
		        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
		      ],
		      [
		        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
		        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
		      ],
		      [
		        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
		        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
		      ],
		      [
		        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
		        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
		      ],
		      [
		        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
		        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
		      ],
		      [
		        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
		        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
		      ],
		      [
		        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
		        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
		      ],
		      [
		        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
		        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
		      ],
		      [
		        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
		        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
		      ],
		      [
		        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
		        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
		      ],
		      [
		        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
		        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
		      ],
		      [
		        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
		        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
		      ],
		      [
		        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
		        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
		      ],
		      [
		        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
		        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
		      ],
		      [
		        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
		        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
		      ],
		      [
		        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
		        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
		      ],
		      [
		        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
		        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
		      ],
		      [
		        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
		        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
		      ],
		      [
		        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
		        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
		      ],
		      [
		        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
		        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
		      ],
		      [
		        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
		        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
		      ],
		      [
		        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
		        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
		      ],
		      [
		        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
		        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
		      ],
		      [
		        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
		        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
		      ],
		      [
		        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
		        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
		      ],
		      [
		        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
		        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
		      ],
		      [
		        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
		        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
		      ],
		      [
		        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
		        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
		      ],
		      [
		        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
		        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
		      ],
		      [
		        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
		        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
		      ],
		      [
		        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
		        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
		      ],
		      [
		        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
		        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
		      ],
		      [
		        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
		        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
		      ],
		      [
		        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
		        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
		      ],
		      [
		        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
		        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
		      ],
		      [
		        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
		        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
		      ],
		      [
		        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
		        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
		      ],
		      [
		        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
		        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
		      ],
		      [
		        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
		        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
		      ],
		      [
		        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
		        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
		      ],
		      [
		        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
		        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
		      ],
		      [
		        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
		        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
		      ],
		      [
		        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
		        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
		      ],
		      [
		        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
		        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
		      ],
		      [
		        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
		        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
		      ],
		      [
		        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
		        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
		      ],
		      [
		        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
		        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
		      ],
		      [
		        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
		        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
		      ],
		      [
		        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
		        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
		      ],
		      [
		        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
		        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
		      ],
		      [
		        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
		        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
		      ],
		      [
		        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
		        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
		      ],
		      [
		        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
		        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
		      ],
		      [
		        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
		        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
		      ],
		      [
		        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
		        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
		      ],
		      [
		        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
		        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
		      ],
		      [
		        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
		        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
		      ],
		      [
		        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
		        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
		      ],
		      [
		        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
		        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
		      ],
		      [
		        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
		        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
		      ],
		      [
		        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
		        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
		      ],
		      [
		        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
		        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
		      ],
		      [
		        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
		        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
		      ],
		      [
		        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
		        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
		      ],
		      [
		        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
		        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
		      ],
		      [
		        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
		        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
		      ],
		      [
		        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
		        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
		      ],
		      [
		        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
		        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
		      ],
		      [
		        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
		        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
		      ],
		      [
		        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
		        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
		      ],
		      [
		        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
		        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
		      ],
		      [
		        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
		        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
		      ],
		      [
		        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
		        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
		      ],
		      [
		        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
		        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
		      ],
		      [
		        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
		        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
		      ],
		      [
		        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
		        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
		      ],
		      [
		        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
		        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
		      ],
		      [
		        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
		        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
		      ],
		      [
		        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
		        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
		      ],
		      [
		        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
		        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
		      ],
		      [
		        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
		        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
		      ],
		      [
		        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
		        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
		      ],
		      [
		        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
		        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
		      ],
		      [
		        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
		        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
		      ],
		      [
		        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
		        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
		      ],
		      [
		        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
		        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
		      ],
		      [
		        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
		        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
		      ],
		      [
		        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
		        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
		      ],
		      [
		        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
		        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
		      ],
		      [
		        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
		        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
		      ],
		      [
		        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
		        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
		      ],
		      [
		        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
		        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
		      ],
		      [
		        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
		        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
		      ],
		      [
		        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
		        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
		      ],
		      [
		        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
		        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
		      ],
		    ],
		  },
		};
		return secp256k1;
	}

	(function (exports) {

		var curves = exports;

		var hash = hash$4;
		var curve$1 = curve;
		var utils = utils$l;

		var assert = utils.assert;

		function PresetCurve(options) {
		  if (options.type === 'short')
		    this.curve = new curve$1.short(options);
		  else if (options.type === 'edwards')
		    this.curve = new curve$1.edwards(options);
		  else
		    this.curve = new curve$1.mont(options);
		  this.g = this.curve.g;
		  this.n = this.curve.n;
		  this.hash = options.hash;

		  assert(this.g.validate(), 'Invalid curve');
		  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
		}
		curves.PresetCurve = PresetCurve;

		function defineCurve(name, options) {
		  Object.defineProperty(curves, name, {
		    configurable: true,
		    enumerable: true,
		    get: function() {
		      var curve = new PresetCurve(options);
		      Object.defineProperty(curves, name, {
		        configurable: true,
		        enumerable: true,
		        value: curve,
		      });
		      return curve;
		    },
		  });
		}

		defineCurve('p192', {
		  type: 'short',
		  prime: 'p192',
		  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
		  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
		  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
		  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
		  hash: hash.sha256,
		  gRed: false,
		  g: [
		    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
		    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
		  ],
		});

		defineCurve('p224', {
		  type: 'short',
		  prime: 'p224',
		  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
		  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
		  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
		  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
		  hash: hash.sha256,
		  gRed: false,
		  g: [
		    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
		    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
		  ],
		});

		defineCurve('p256', {
		  type: 'short',
		  prime: null,
		  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
		  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
		  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
		  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
		  hash: hash.sha256,
		  gRed: false,
		  g: [
		    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
		    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
		  ],
		});

		defineCurve('p384', {
		  type: 'short',
		  prime: null,
		  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'fffffffe ffffffff 00000000 00000000 ffffffff',
		  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'fffffffe ffffffff 00000000 00000000 fffffffc',
		  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
		     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
		  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
		     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
		  hash: hash.sha384,
		  gRed: false,
		  g: [
		    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
		    '5502f25d bf55296c 3a545e38 72760ab7',
		    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
		    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
		  ],
		});

		defineCurve('p521', {
		  type: 'short',
		  prime: null,
		  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'ffffffff ffffffff ffffffff ffffffff ffffffff',
		  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'ffffffff ffffffff ffffffff ffffffff fffffffc',
		  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
		     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
		     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
		  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
		     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
		     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
		  hash: hash.sha512,
		  gRed: false,
		  g: [
		    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
		    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
		    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
		    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
		    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
		    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
		  ],
		});

		defineCurve('curve25519', {
		  type: 'mont',
		  prime: 'p25519',
		  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
		  a: '76d06',
		  b: '1',
		  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
		  hash: hash.sha256,
		  gRed: false,
		  g: [
		    '9',
		  ],
		});

		defineCurve('ed25519', {
		  type: 'edwards',
		  prime: 'p25519',
		  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
		  a: '-1',
		  c: '1',
		  // -121665 * (121666^(-1)) (mod P)
		  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
		  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
		  hash: hash.sha256,
		  gRed: false,
		  g: [
		    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

		    // 4/5
		    '6666666666666666666666666666666666666666666666666666666666666658',
		  ],
		});

		var pre;
		try {
		  pre = requireSecp256k1();
		} catch (e) {
		  pre = undefined;
		}

		defineCurve('secp256k1', {
		  type: 'short',
		  prime: 'k256',
		  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
		  a: '0',
		  b: '7',
		  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
		  h: '1',
		  hash: hash.sha256,

		  // Precomputed endomorphism
		  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
		  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
		  basis: [
		    {
		      a: '3086d221a7d46bcde86c90e49284eb15',
		      b: '-e4437ed6010e88286f547fa90abfe4c3',
		    },
		    {
		      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
		      b: '3086d221a7d46bcde86c90e49284eb15',
		    },
		  ],

		  gRed: false,
		  g: [
		    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
		    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
		    pre,
		  ],
		}); 
	} (curves$2));

	var hash$2 = hash$4;
	var utils$f = utils$k;
	var assert$9 = minimalisticAssert$1;

	function HmacDRBG$1(options) {
	  if (!(this instanceof HmacDRBG$1))
	    return new HmacDRBG$1(options);
	  this.hash = options.hash;
	  this.predResist = !!options.predResist;

	  this.outLen = this.hash.outSize;
	  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

	  this._reseed = null;
	  this.reseedInterval = null;
	  this.K = null;
	  this.V = null;

	  var entropy = utils$f.toArray(options.entropy, options.entropyEnc || 'hex');
	  var nonce = utils$f.toArray(options.nonce, options.nonceEnc || 'hex');
	  var pers = utils$f.toArray(options.pers, options.persEnc || 'hex');
	  assert$9(entropy.length >= (this.minEntropy / 8),
	         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
	  this._init(entropy, nonce, pers);
	}
	var hmacDrbg = HmacDRBG$1;

	HmacDRBG$1.prototype._init = function init(entropy, nonce, pers) {
	  var seed = entropy.concat(nonce).concat(pers);

	  this.K = new Array(this.outLen / 8);
	  this.V = new Array(this.outLen / 8);
	  for (var i = 0; i < this.V.length; i++) {
	    this.K[i] = 0x00;
	    this.V[i] = 0x01;
	  }

	  this._update(seed);
	  this._reseed = 1;
	  this.reseedInterval = 0x1000000000000;  // 2^48
	};

	HmacDRBG$1.prototype._hmac = function hmac() {
	  return new hash$2.hmac(this.hash, this.K);
	};

	HmacDRBG$1.prototype._update = function update(seed) {
	  var kmac = this._hmac()
	                 .update(this.V)
	                 .update([ 0x00 ]);
	  if (seed)
	    kmac = kmac.update(seed);
	  this.K = kmac.digest();
	  this.V = this._hmac().update(this.V).digest();
	  if (!seed)
	    return;

	  this.K = this._hmac()
	               .update(this.V)
	               .update([ 0x01 ])
	               .update(seed)
	               .digest();
	  this.V = this._hmac().update(this.V).digest();
	};

	HmacDRBG$1.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
	  // Optional entropy enc
	  if (typeof entropyEnc !== 'string') {
	    addEnc = add;
	    add = entropyEnc;
	    entropyEnc = null;
	  }

	  entropy = utils$f.toArray(entropy, entropyEnc);
	  add = utils$f.toArray(add, addEnc);

	  assert$9(entropy.length >= (this.minEntropy / 8),
	         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

	  this._update(entropy.concat(add || []));
	  this._reseed = 1;
	};

	HmacDRBG$1.prototype.generate = function generate(len, enc, add, addEnc) {
	  if (this._reseed > this.reseedInterval)
	    throw new Error('Reseed is required');

	  // Optional encoding
	  if (typeof enc !== 'string') {
	    addEnc = add;
	    add = enc;
	    enc = null;
	  }

	  // Optional additional data
	  if (add) {
	    add = utils$f.toArray(add, addEnc || 'hex');
	    this._update(add);
	  }

	  var temp = [];
	  while (temp.length < len) {
	    this.V = this._hmac().update(this.V).digest();
	    temp = temp.concat(this.V);
	  }

	  var res = temp.slice(0, len);
	  this._update(add);
	  this._reseed++;
	  return utils$f.encode(res, enc);
	};

	var BN$5 = bnExports;
	var utils$e = utils$l;
	var assert$8 = utils$e.assert;

	function KeyPair$3(ec, options) {
	  this.ec = ec;
	  this.priv = null;
	  this.pub = null;

	  // KeyPair(ec, { priv: ..., pub: ... })
	  if (options.priv)
	    this._importPrivate(options.priv, options.privEnc);
	  if (options.pub)
	    this._importPublic(options.pub, options.pubEnc);
	}
	var key$1 = KeyPair$3;

	KeyPair$3.fromPublic = function fromPublic(ec, pub, enc) {
	  if (pub instanceof KeyPair$3)
	    return pub;

	  return new KeyPair$3(ec, {
	    pub: pub,
	    pubEnc: enc,
	  });
	};

	KeyPair$3.fromPrivate = function fromPrivate(ec, priv, enc) {
	  if (priv instanceof KeyPair$3)
	    return priv;

	  return new KeyPair$3(ec, {
	    priv: priv,
	    privEnc: enc,
	  });
	};

	KeyPair$3.prototype.validate = function validate() {
	  var pub = this.getPublic();

	  if (pub.isInfinity())
	    return { result: false, reason: 'Invalid public key' };
	  if (!pub.validate())
	    return { result: false, reason: 'Public key is not a point' };
	  if (!pub.mul(this.ec.curve.n).isInfinity())
	    return { result: false, reason: 'Public key * N != O' };

	  return { result: true, reason: null };
	};

	KeyPair$3.prototype.getPublic = function getPublic(compact, enc) {
	  // compact is optional argument
	  if (typeof compact === 'string') {
	    enc = compact;
	    compact = null;
	  }

	  if (!this.pub)
	    this.pub = this.ec.g.mul(this.priv);

	  if (!enc)
	    return this.pub;

	  return this.pub.encode(enc, compact);
	};

	KeyPair$3.prototype.getPrivate = function getPrivate(enc) {
	  if (enc === 'hex')
	    return this.priv.toString(16, 2);
	  else
	    return this.priv;
	};

	KeyPair$3.prototype._importPrivate = function _importPrivate(key, enc) {
	  this.priv = new BN$5(key, enc || 16);

	  // Ensure that the priv won't be bigger than n, otherwise we may fail
	  // in fixed multiplication method
	  this.priv = this.priv.umod(this.ec.curve.n);
	};

	KeyPair$3.prototype._importPublic = function _importPublic(key, enc) {
	  if (key.x || key.y) {
	    // Montgomery points only have an `x` coordinate.
	    // Weierstrass/Edwards points on the other hand have both `x` and
	    // `y` coordinates.
	    if (this.ec.curve.type === 'mont') {
	      assert$8(key.x, 'Need x coordinate');
	    } else if (this.ec.curve.type === 'short' ||
	               this.ec.curve.type === 'edwards') {
	      assert$8(key.x && key.y, 'Need both x and y coordinate');
	    }
	    this.pub = this.ec.curve.point(key.x, key.y);
	    return;
	  }
	  this.pub = this.ec.curve.decodePoint(key, enc);
	};

	// ECDH
	KeyPair$3.prototype.derive = function derive(pub) {
	  if(!pub.validate()) {
	    assert$8(pub.validate(), 'public point not validated');
	  }
	  return pub.mul(this.priv).getX();
	};

	// ECDSA
	KeyPair$3.prototype.sign = function sign(msg, enc, options) {
	  return this.ec.sign(msg, this, enc, options);
	};

	KeyPair$3.prototype.verify = function verify(msg, signature) {
	  return this.ec.verify(msg, signature, this);
	};

	KeyPair$3.prototype.inspect = function inspect() {
	  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
	         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
	};

	var BN$4 = bnExports;

	var utils$d = utils$l;
	var assert$7 = utils$d.assert;

	function Signature$3(options, enc) {
	  if (options instanceof Signature$3)
	    return options;

	  if (this._importDER(options, enc))
	    return;

	  assert$7(options.r && options.s, 'Signature without r or s');
	  this.r = new BN$4(options.r, 16);
	  this.s = new BN$4(options.s, 16);
	  if (options.recoveryParam === undefined)
	    this.recoveryParam = null;
	  else
	    this.recoveryParam = options.recoveryParam;
	}
	var signature$1 = Signature$3;

	function Position() {
	  this.place = 0;
	}

	function getLength(buf, p) {
	  var initial = buf[p.place++];
	  if (!(initial & 0x80)) {
	    return initial;
	  }
	  var octetLen = initial & 0xf;

	  // Indefinite length or overflow
	  if (octetLen === 0 || octetLen > 4) {
	    return false;
	  }

	  var val = 0;
	  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
	    val <<= 8;
	    val |= buf[off];
	    val >>>= 0;
	  }

	  // Leading zeroes
	  if (val <= 0x7f) {
	    return false;
	  }

	  p.place = off;
	  return val;
	}

	function rmPadding(buf) {
	  var i = 0;
	  var len = buf.length - 1;
	  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
	    i++;
	  }
	  if (i === 0) {
	    return buf;
	  }
	  return buf.slice(i);
	}

	Signature$3.prototype._importDER = function _importDER(data, enc) {
	  data = utils$d.toArray(data, enc);
	  var p = new Position();
	  if (data[p.place++] !== 0x30) {
	    return false;
	  }
	  var len = getLength(data, p);
	  if (len === false) {
	    return false;
	  }
	  if ((len + p.place) !== data.length) {
	    return false;
	  }
	  if (data[p.place++] !== 0x02) {
	    return false;
	  }
	  var rlen = getLength(data, p);
	  if (rlen === false) {
	    return false;
	  }
	  var r = data.slice(p.place, rlen + p.place);
	  p.place += rlen;
	  if (data[p.place++] !== 0x02) {
	    return false;
	  }
	  var slen = getLength(data, p);
	  if (slen === false) {
	    return false;
	  }
	  if (data.length !== slen + p.place) {
	    return false;
	  }
	  var s = data.slice(p.place, slen + p.place);
	  if (r[0] === 0) {
	    if (r[1] & 0x80) {
	      r = r.slice(1);
	    } else {
	      // Leading zeroes
	      return false;
	    }
	  }
	  if (s[0] === 0) {
	    if (s[1] & 0x80) {
	      s = s.slice(1);
	    } else {
	      // Leading zeroes
	      return false;
	    }
	  }

	  this.r = new BN$4(r);
	  this.s = new BN$4(s);
	  this.recoveryParam = null;

	  return true;
	};

	function constructLength(arr, len) {
	  if (len < 0x80) {
	    arr.push(len);
	    return;
	  }
	  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
	  arr.push(octets | 0x80);
	  while (--octets) {
	    arr.push((len >>> (octets << 3)) & 0xff);
	  }
	  arr.push(len);
	}

	Signature$3.prototype.toDER = function toDER(enc) {
	  var r = this.r.toArray();
	  var s = this.s.toArray();

	  // Pad values
	  if (r[0] & 0x80)
	    r = [ 0 ].concat(r);
	  // Pad values
	  if (s[0] & 0x80)
	    s = [ 0 ].concat(s);

	  r = rmPadding(r);
	  s = rmPadding(s);

	  while (!s[0] && !(s[1] & 0x80)) {
	    s = s.slice(1);
	  }
	  var arr = [ 0x02 ];
	  constructLength(arr, r.length);
	  arr = arr.concat(r);
	  arr.push(0x02);
	  constructLength(arr, s.length);
	  var backHalf = arr.concat(s);
	  var res = [ 0x30 ];
	  constructLength(res, backHalf.length);
	  res = res.concat(backHalf);
	  return utils$d.encode(res, enc);
	};

	var BN$3 = bnExports;
	var HmacDRBG = hmacDrbg;
	var utils$c = utils$l;
	var curves$1 = curves$2;
	var rand = brorandExports;
	var assert$6 = utils$c.assert;

	var KeyPair$2 = key$1;
	var Signature$2 = signature$1;

	function EC(options) {
	  if (!(this instanceof EC))
	    return new EC(options);

	  // Shortcut `elliptic.ec(curve-name)`
	  if (typeof options === 'string') {
	    assert$6(Object.prototype.hasOwnProperty.call(curves$1, options),
	      'Unknown curve ' + options);

	    options = curves$1[options];
	  }

	  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
	  if (options instanceof curves$1.PresetCurve)
	    options = { curve: options };

	  this.curve = options.curve.curve;
	  this.n = this.curve.n;
	  this.nh = this.n.ushrn(1);
	  this.g = this.curve.g;

	  // Point on curve
	  this.g = options.curve.g;
	  this.g.precompute(options.curve.n.bitLength() + 1);

	  // Hash for function for DRBG
	  this.hash = options.hash || options.curve.hash;
	}
	var ec = EC;

	EC.prototype.keyPair = function keyPair(options) {
	  return new KeyPair$2(this, options);
	};

	EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
	  return KeyPair$2.fromPrivate(this, priv, enc);
	};

	EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
	  return KeyPair$2.fromPublic(this, pub, enc);
	};

	EC.prototype.genKeyPair = function genKeyPair(options) {
	  if (!options)
	    options = {};

	  // Instantiate Hmac_DRBG
	  var drbg = new HmacDRBG({
	    hash: this.hash,
	    pers: options.pers,
	    persEnc: options.persEnc || 'utf8',
	    entropy: options.entropy || rand(this.hash.hmacStrength),
	    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
	    nonce: this.n.toArray(),
	  });

	  var bytes = this.n.byteLength();
	  var ns2 = this.n.sub(new BN$3(2));
	  for (;;) {
	    var priv = new BN$3(drbg.generate(bytes));
	    if (priv.cmp(ns2) > 0)
	      continue;

	    priv.iaddn(1);
	    return this.keyFromPrivate(priv);
	  }
	};

	EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
	  var delta = msg.byteLength() * 8 - this.n.bitLength();
	  if (delta > 0)
	    msg = msg.ushrn(delta);
	  if (!truncOnly && msg.cmp(this.n) >= 0)
	    return msg.sub(this.n);
	  else
	    return msg;
	};

	EC.prototype.sign = function sign(msg, key, enc, options) {
	  if (typeof enc === 'object') {
	    options = enc;
	    enc = null;
	  }
	  if (!options)
	    options = {};

	  key = this.keyFromPrivate(key, enc);
	  msg = this._truncateToN(new BN$3(msg, 16));

	  // Zero-extend key to provide enough entropy
	  var bytes = this.n.byteLength();
	  var bkey = key.getPrivate().toArray('be', bytes);

	  // Zero-extend nonce to have the same byte size as N
	  var nonce = msg.toArray('be', bytes);

	  // Instantiate Hmac_DRBG
	  var drbg = new HmacDRBG({
	    hash: this.hash,
	    entropy: bkey,
	    nonce: nonce,
	    pers: options.pers,
	    persEnc: options.persEnc || 'utf8',
	  });

	  // Number of bytes to generate
	  var ns1 = this.n.sub(new BN$3(1));

	  for (var iter = 0; ; iter++) {
	    var k = options.k ?
	      options.k(iter) :
	      new BN$3(drbg.generate(this.n.byteLength()));
	    k = this._truncateToN(k, true);
	    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
	      continue;

	    var kp = this.g.mul(k);
	    if (kp.isInfinity())
	      continue;

	    var kpX = kp.getX();
	    var r = kpX.umod(this.n);
	    if (r.cmpn(0) === 0)
	      continue;

	    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
	    s = s.umod(this.n);
	    if (s.cmpn(0) === 0)
	      continue;

	    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
	                        (kpX.cmp(r) !== 0 ? 2 : 0);

	    // Use complement of `s`, if it is > `n / 2`
	    if (options.canonical && s.cmp(this.nh) > 0) {
	      s = this.n.sub(s);
	      recoveryParam ^= 1;
	    }

	    return new Signature$2({ r: r, s: s, recoveryParam: recoveryParam });
	  }
	};

	EC.prototype.verify = function verify(msg, signature, key, enc) {
	  msg = this._truncateToN(new BN$3(msg, 16));
	  key = this.keyFromPublic(key, enc);
	  signature = new Signature$2(signature, 'hex');

	  // Perform primitive values validation
	  var r = signature.r;
	  var s = signature.s;
	  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
	    return false;
	  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
	    return false;

	  // Validate signature
	  var sinv = s.invm(this.n);
	  var u1 = sinv.mul(msg).umod(this.n);
	  var u2 = sinv.mul(r).umod(this.n);
	  var p;

	  if (!this.curve._maxwellTrick) {
	    p = this.g.mulAdd(u1, key.getPublic(), u2);
	    if (p.isInfinity())
	      return false;

	    return p.getX().umod(this.n).cmp(r) === 0;
	  }

	  // NOTE: Greg Maxwell's trick, inspired by:
	  // https://git.io/vad3K

	  p = this.g.jmulAdd(u1, key.getPublic(), u2);
	  if (p.isInfinity())
	    return false;

	  // Compare `p.x` of Jacobian point with `r`,
	  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
	  // inverse of `p.z^2`
	  return p.eqXToP(r);
	};

	EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
	  assert$6((3 & j) === j, 'The recovery param is more than two bits');
	  signature = new Signature$2(signature, enc);

	  var n = this.n;
	  var e = new BN$3(msg);
	  var r = signature.r;
	  var s = signature.s;

	  // A set LSB signifies that the y-coordinate is odd
	  var isYOdd = j & 1;
	  var isSecondKey = j >> 1;
	  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
	    throw new Error('Unable to find sencond key candinate');

	  // 1.1. Let x = r + jn.
	  if (isSecondKey)
	    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
	  else
	    r = this.curve.pointFromX(r, isYOdd);

	  var rInv = signature.r.invm(n);
	  var s1 = n.sub(e).mul(rInv).umod(n);
	  var s2 = s.mul(rInv).umod(n);

	  // 1.6.1 Compute Q = r^-1 (sR -  eG)
	  //               Q = r^-1 (sR + -eG)
	  return this.g.mulAdd(s1, r, s2);
	};

	EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
	  signature = new Signature$2(signature, enc);
	  if (signature.recoveryParam !== null)
	    return signature.recoveryParam;

	  for (var i = 0; i < 4; i++) {
	    var Qprime;
	    try {
	      Qprime = this.recoverPubKey(e, signature, i);
	    } catch (e) {
	      continue;
	    }

	    if (Qprime.eq(Q))
	      return i;
	  }
	  throw new Error('Unable to find valid recovery factor');
	};

	var utils$b = utils$l;
	var assert$5 = utils$b.assert;
	var parseBytes$2 = utils$b.parseBytes;
	var cachedProperty$1 = utils$b.cachedProperty;

	/**
	* @param {EDDSA} eddsa - instance
	* @param {Object} params - public/private key parameters
	*
	* @param {Array<Byte>} [params.secret] - secret seed bytes
	* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
	* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
	*
	*/
	function KeyPair$1(eddsa, params) {
	  this.eddsa = eddsa;
	  this._secret = parseBytes$2(params.secret);
	  if (eddsa.isPoint(params.pub))
	    this._pub = params.pub;
	  else
	    this._pubBytes = parseBytes$2(params.pub);
	}

	KeyPair$1.fromPublic = function fromPublic(eddsa, pub) {
	  if (pub instanceof KeyPair$1)
	    return pub;
	  return new KeyPair$1(eddsa, { pub: pub });
	};

	KeyPair$1.fromSecret = function fromSecret(eddsa, secret) {
	  if (secret instanceof KeyPair$1)
	    return secret;
	  return new KeyPair$1(eddsa, { secret: secret });
	};

	KeyPair$1.prototype.secret = function secret() {
	  return this._secret;
	};

	cachedProperty$1(KeyPair$1, 'pubBytes', function pubBytes() {
	  return this.eddsa.encodePoint(this.pub());
	});

	cachedProperty$1(KeyPair$1, 'pub', function pub() {
	  if (this._pubBytes)
	    return this.eddsa.decodePoint(this._pubBytes);
	  return this.eddsa.g.mul(this.priv());
	});

	cachedProperty$1(KeyPair$1, 'privBytes', function privBytes() {
	  var eddsa = this.eddsa;
	  var hash = this.hash();
	  var lastIx = eddsa.encodingLength - 1;

	  var a = hash.slice(0, eddsa.encodingLength);
	  a[0] &= 248;
	  a[lastIx] &= 127;
	  a[lastIx] |= 64;

	  return a;
	});

	cachedProperty$1(KeyPair$1, 'priv', function priv() {
	  return this.eddsa.decodeInt(this.privBytes());
	});

	cachedProperty$1(KeyPair$1, 'hash', function hash() {
	  return this.eddsa.hash().update(this.secret()).digest();
	});

	cachedProperty$1(KeyPair$1, 'messagePrefix', function messagePrefix() {
	  return this.hash().slice(this.eddsa.encodingLength);
	});

	KeyPair$1.prototype.sign = function sign(message) {
	  assert$5(this._secret, 'KeyPair can only verify');
	  return this.eddsa.sign(message, this);
	};

	KeyPair$1.prototype.verify = function verify(message, sig) {
	  return this.eddsa.verify(message, sig, this);
	};

	KeyPair$1.prototype.getSecret = function getSecret(enc) {
	  assert$5(this._secret, 'KeyPair is public only');
	  return utils$b.encode(this.secret(), enc);
	};

	KeyPair$1.prototype.getPublic = function getPublic(enc) {
	  return utils$b.encode(this.pubBytes(), enc);
	};

	var key = KeyPair$1;

	var BN$2 = bnExports;
	var utils$a = utils$l;
	var assert$4 = utils$a.assert;
	var cachedProperty = utils$a.cachedProperty;
	var parseBytes$1 = utils$a.parseBytes;

	/**
	* @param {EDDSA} eddsa - eddsa instance
	* @param {Array<Bytes>|Object} sig -
	* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
	* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
	* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
	* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
	*/
	function Signature$1(eddsa, sig) {
	  this.eddsa = eddsa;

	  if (typeof sig !== 'object')
	    sig = parseBytes$1(sig);

	  if (Array.isArray(sig)) {
	    sig = {
	      R: sig.slice(0, eddsa.encodingLength),
	      S: sig.slice(eddsa.encodingLength),
	    };
	  }

	  assert$4(sig.R && sig.S, 'Signature without R or S');

	  if (eddsa.isPoint(sig.R))
	    this._R = sig.R;
	  if (sig.S instanceof BN$2)
	    this._S = sig.S;

	  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
	  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
	}

	cachedProperty(Signature$1, 'S', function S() {
	  return this.eddsa.decodeInt(this.Sencoded());
	});

	cachedProperty(Signature$1, 'R', function R() {
	  return this.eddsa.decodePoint(this.Rencoded());
	});

	cachedProperty(Signature$1, 'Rencoded', function Rencoded() {
	  return this.eddsa.encodePoint(this.R());
	});

	cachedProperty(Signature$1, 'Sencoded', function Sencoded() {
	  return this.eddsa.encodeInt(this.S());
	});

	Signature$1.prototype.toBytes = function toBytes() {
	  return this.Rencoded().concat(this.Sencoded());
	};

	Signature$1.prototype.toHex = function toHex() {
	  return utils$a.encode(this.toBytes(), 'hex').toUpperCase();
	};

	var signature = Signature$1;

	var hash$1 = hash$4;
	var curves = curves$2;
	var utils$9 = utils$l;
	var assert$3 = utils$9.assert;
	var parseBytes = utils$9.parseBytes;
	var KeyPair = key;
	var Signature = signature;

	function EDDSA(curve) {
	  assert$3(curve === 'ed25519', 'only tested with ed25519 so far');

	  if (!(this instanceof EDDSA))
	    return new EDDSA(curve);

	  curve = curves[curve].curve;
	  this.curve = curve;
	  this.g = curve.g;
	  this.g.precompute(curve.n.bitLength() + 1);

	  this.pointClass = curve.point().constructor;
	  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
	  this.hash = hash$1.sha512;
	}

	var eddsa = EDDSA;

	/**
	* @param {Array|String} message - message bytes
	* @param {Array|String|KeyPair} secret - secret bytes or a keypair
	* @returns {Signature} - signature
	*/
	EDDSA.prototype.sign = function sign(message, secret) {
	  message = parseBytes(message);
	  var key = this.keyFromSecret(secret);
	  var r = this.hashInt(key.messagePrefix(), message);
	  var R = this.g.mul(r);
	  var Rencoded = this.encodePoint(R);
	  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
	    .mul(key.priv());
	  var S = r.add(s_).umod(this.curve.n);
	  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
	};

	/**
	* @param {Array} message - message bytes
	* @param {Array|String|Signature} sig - sig bytes
	* @param {Array|String|Point|KeyPair} pub - public key
	* @returns {Boolean} - true if public key matches sig of message
	*/
	EDDSA.prototype.verify = function verify(message, sig, pub) {
	  message = parseBytes(message);
	  sig = this.makeSignature(sig);
	  var key = this.keyFromPublic(pub);
	  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
	  var SG = this.g.mul(sig.S());
	  var RplusAh = sig.R().add(key.pub().mul(h));
	  return RplusAh.eq(SG);
	};

	EDDSA.prototype.hashInt = function hashInt() {
	  var hash = this.hash();
	  for (var i = 0; i < arguments.length; i++)
	    hash.update(arguments[i]);
	  return utils$9.intFromLE(hash.digest()).umod(this.curve.n);
	};

	EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
	  return KeyPair.fromPublic(this, pub);
	};

	EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
	  return KeyPair.fromSecret(this, secret);
	};

	EDDSA.prototype.makeSignature = function makeSignature(sig) {
	  if (sig instanceof Signature)
	    return sig;
	  return new Signature(this, sig);
	};

	/**
	* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
	*
	* EDDSA defines methods for encoding and decoding points and integers. These are
	* helper convenience methods, that pass along to utility functions implied
	* parameters.
	*
	*/
	EDDSA.prototype.encodePoint = function encodePoint(point) {
	  var enc = point.getY().toArray('le', this.encodingLength);
	  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
	  return enc;
	};

	EDDSA.prototype.decodePoint = function decodePoint(bytes) {
	  bytes = utils$9.parseBytes(bytes);

	  var lastIx = bytes.length - 1;
	  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
	  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

	  var y = utils$9.intFromLE(normed);
	  return this.curve.pointFromY(y, xIsOdd);
	};

	EDDSA.prototype.encodeInt = function encodeInt(num) {
	  return num.toArray('le', this.encodingLength);
	};

	EDDSA.prototype.decodeInt = function decodeInt(bytes) {
	  return utils$9.intFromLE(bytes);
	};

	EDDSA.prototype.isPoint = function isPoint(val) {
	  return val instanceof this.pointClass;
	};

	(function (exports) {

		var elliptic = exports;

		elliptic.version = require$$0$3.version;
		elliptic.utils = utils$l;
		elliptic.rand = brorandExports;
		elliptic.curve = curve;
		elliptic.curves = curves$2;

		// Protocols
		elliptic.ec = ec;
		elliptic.eddsa = eddsa; 
	} (elliptic));

	var As$1 = /*@__PURE__*/getDefaultExportFromCjs(elliptic);

	var xi=Object.create;var hn=Object.defineProperty;var Bi$1=Object.getOwnPropertyDescriptor;var Si=Object.getOwnPropertyNames;var ki$1=Object.getPrototypeOf,Ti=Object.prototype.hasOwnProperty;var fn=(i,e)=>()=>(e||i((e={exports:{}}).exports,e),e.exports);var Mi$1=(i,e,t,r)=>{if(e&&typeof e=="object"||typeof e=="function")for(let s of Si(e))!Ti.call(i,s)&&s!==t&&hn(i,s,{get:()=>e[s],enumerable:!(r=Bi$1(e,s))||r.enumerable});return i};var gn=(i,e,t)=>(t=i!=null?xi(ki$1(i)):{},Mi$1(e||!i||!i.__esModule?hn(t,"default",{value:i,enumerable:!0}):t,i));var Pn=fn((ao,bn)=>{bn.exports={webcrypto:window.crypto};});var jn=fn((Ec,Er)=>{(function(){var i="input is invalid type",e="finalize already called",t=typeof window=="object",r=t?window:{};r.JS_SHA3_NO_WINDOW&&(t=!1);var s=!t&&typeof self=="object",o=!r.JS_SHA3_NO_NODE_JS&&typeof process=="object"&&process.versions&&process.versions.node;o?r=global:s&&(r=self);var a=!r.JS_SHA3_NO_COMMON_JS&&typeof Er=="object"&&Er.exports,c=typeof define=="function"&&define.amd,p=!r.JS_SHA3_NO_ARRAY_BUFFER&&typeof ArrayBuffer<"u",m="0123456789abcdef".split(""),l=[31,7936,2031616,520093696],b=[4,1024,262144,67108864],T=[1,256,65536,16777216],Ee=[6,1536,393216,100663296],M=[0,8,16,24],xe=[1,0,32898,0,32906,2147483648,2147516416,2147483648,32907,0,2147483649,0,2147516545,2147483648,32777,2147483648,138,0,136,0,2147516425,0,2147483658,0,2147516555,0,139,2147483648,32905,2147483648,32771,2147483648,32770,2147483648,128,2147483648,32778,0,2147483658,2147483648,2147516545,2147483648,32896,2147483648,2147483649,0,2147516424,2147483648],kr=[224,256,384,512],Tr=[128,256],on=["hex","buffer","arrayBuffer","array","digest"],an={128:168,256:136};(r.JS_SHA3_NO_NODE_JS||!Array.isArray)&&(Array.isArray=function(n){return Object.prototype.toString.call(n)==="[object Array]"}),p&&(r.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW||!ArrayBuffer.isView)&&(ArrayBuffer.isView=function(n){return typeof n=="object"&&n.buffer&&n.buffer.constructor===ArrayBuffer});for(var cn=function(n,d,u){return function(y){return new B(n,d,n).update(y)[u]()}},pn=function(n,d,u){return function(y,h){return new B(n,d,h).update(y)[u]()}},dn=function(n,d,u){return function(y,h,g,v){return ye["cshake"+n].update(y,h,g,v)[u]()}},un=function(n,d,u){return function(y,h,g,v){return ye["kmac"+n].update(y,h,g,v)[u]()}},mt=function(n,d,u,y){for(var h=0;h<on.length;++h){var g=on[h];n[g]=d(u,y,g);}return n},yn=function(n,d){var u=cn(n,d,"hex");return u.create=function(){return new B(n,d,n)},u.update=function(y){return u.create().update(y)},mt(u,cn,n,d)},Ci=function(n,d){var u=pn(n,d,"hex");return u.create=function(y){return new B(n,d,y)},u.update=function(y,h){return u.create(h).update(y)},mt(u,pn,n,d)},Ai=function(n,d){var u=an[n],y=dn(n,d,"hex");return y.create=function(h,g,v){return !g&&!v?ye["shake"+n].create(h):new B(n,d,h).bytepad([g,v],u)},y.update=function(h,g,v,f){return y.create(g,v,f).update(h)},mt(y,dn,n,d)},Ei=function(n,d){var u=an[n],y=un(n,d,"hex");return y.create=function(h,g,v){return new Ur(n,d,g).bytepad(["KMAC",v],u).bytepad([h],u)},y.update=function(h,g,v,f){return y.create(h,v,f).update(g)},mt(y,un,n,d)},ln=[{name:"keccak",padding:T,bits:kr,createMethod:yn},{name:"sha3",padding:Ee,bits:kr,createMethod:yn},{name:"shake",padding:l,bits:Tr,createMethod:Ci},{name:"cshake",padding:b,bits:Tr,createMethod:Ai},{name:"kmac",padding:b,bits:Tr,createMethod:Ei}],ye={},Qe=[],he=0;he<ln.length;++he)for(var Le=ln[he],ht=Le.bits,Ye=0;Ye<ht.length;++Ye){var Mr=Le.name+"_"+ht[Ye];if(Qe.push(Mr),ye[Mr]=Le.createMethod(ht[Ye],Le.padding),Le.name!=="sha3"){var mn=Le.name+ht[Ye];Qe.push(mn),ye[mn]=ye[Mr];}}function B(n,d,u){this.blocks=[],this.s=[],this.padding=d,this.outputBits=u,this.reset=!0,this.finalized=!1,this.block=0,this.start=0,this.blockCount=1600-(n<<1)>>5,this.byteCount=this.blockCount<<2,this.outputBlocks=u>>5,this.extraBytes=(u&31)>>3;for(var y=0;y<50;++y)this.s[y]=0;}B.prototype.update=function(n){if(this.finalized)throw new Error(e);var d,u=typeof n;if(u!=="string"){if(u==="object"){if(n===null)throw new Error(i);if(p&&n.constructor===ArrayBuffer)n=new Uint8Array(n);else if(!Array.isArray(n)&&(!p||!ArrayBuffer.isView(n)))throw new Error(i)}else throw new Error(i);d=!0;}for(var y=this.blocks,h=this.byteCount,g=n.length,v=this.blockCount,f=0,S=this.s,w,C;f<g;){if(this.reset)for(this.reset=!1,y[0]=this.block,w=1;w<v+1;++w)y[w]=0;if(d)for(w=this.start;f<g&&w<h;++f)y[w>>2]|=n[f]<<M[w++&3];else for(w=this.start;f<g&&w<h;++f)C=n.charCodeAt(f),C<128?y[w>>2]|=C<<M[w++&3]:C<2048?(y[w>>2]|=(192|C>>6)<<M[w++&3],y[w>>2]|=(128|C&63)<<M[w++&3]):C<55296||C>=57344?(y[w>>2]|=(224|C>>12)<<M[w++&3],y[w>>2]|=(128|C>>6&63)<<M[w++&3],y[w>>2]|=(128|C&63)<<M[w++&3]):(C=65536+((C&1023)<<10|n.charCodeAt(++f)&1023),y[w>>2]|=(240|C>>18)<<M[w++&3],y[w>>2]|=(128|C>>12&63)<<M[w++&3],y[w>>2]|=(128|C>>6&63)<<M[w++&3],y[w>>2]|=(128|C&63)<<M[w++&3]);if(this.lastByteIndex=w,w>=h){for(this.start=w-h,this.block=y[v],w=0;w<v;++w)S[w]^=y[w];Je(S),this.reset=!0;}else this.start=w;}return this},B.prototype.encode=function(n,d){var u=n&255,y=1,h=[u];for(n=n>>8,u=n&255;u>0;)h.unshift(u),n=n>>8,u=n&255,++y;return d?h.push(y):h.unshift(y),this.update(h),h.length},B.prototype.encodeString=function(n){var d,u=typeof n;if(u!=="string"){if(u==="object"){if(n===null)throw new Error(i);if(p&&n.constructor===ArrayBuffer)n=new Uint8Array(n);else if(!Array.isArray(n)&&(!p||!ArrayBuffer.isView(n)))throw new Error(i)}else throw new Error(i);d=!0;}var y=0,h=n.length;if(d)y=h;else for(var g=0;g<n.length;++g){var v=n.charCodeAt(g);v<128?y+=1:v<2048?y+=2:v<55296||v>=57344?y+=3:(v=65536+((v&1023)<<10|n.charCodeAt(++g)&1023),y+=4);}return y+=this.encode(y*8),this.update(n),y},B.prototype.bytepad=function(n,d){for(var u=this.encode(d),y=0;y<n.length;++y)u+=this.encodeString(n[y]);var h=d-u%d,g=[];return g.length=h,this.update(g),this},B.prototype.finalize=function(){if(!this.finalized){this.finalized=!0;var n=this.blocks,d=this.lastByteIndex,u=this.blockCount,y=this.s;if(n[d>>2]|=this.padding[d&3],this.lastByteIndex===this.byteCount)for(n[0]=n[u],d=1;d<u+1;++d)n[d]=0;for(n[u-1]|=2147483648,d=0;d<u;++d)y[d]^=n[d];Je(y);}},B.prototype.toString=B.prototype.hex=function(){this.finalize();for(var n=this.blockCount,d=this.s,u=this.outputBlocks,y=this.extraBytes,h=0,g=0,v="",f;g<u;){for(h=0;h<n&&g<u;++h,++g)f=d[h],v+=m[f>>4&15]+m[f&15]+m[f>>12&15]+m[f>>8&15]+m[f>>20&15]+m[f>>16&15]+m[f>>28&15]+m[f>>24&15];g%n===0&&(Je(d),h=0);}return y&&(f=d[h],v+=m[f>>4&15]+m[f&15],y>1&&(v+=m[f>>12&15]+m[f>>8&15]),y>2&&(v+=m[f>>20&15]+m[f>>16&15])),v},B.prototype.arrayBuffer=function(){this.finalize();var n=this.blockCount,d=this.s,u=this.outputBlocks,y=this.extraBytes,h=0,g=0,v=this.outputBits>>3,f;y?f=new ArrayBuffer(u+1<<2):f=new ArrayBuffer(v);for(var S=new Uint32Array(f);g<u;){for(h=0;h<n&&g<u;++h,++g)S[g]=d[h];g%n===0&&Je(d);}return y&&(S[h]=d[h],f=f.slice(0,v)),f},B.prototype.buffer=B.prototype.arrayBuffer,B.prototype.digest=B.prototype.array=function(){this.finalize();for(var n=this.blockCount,d=this.s,u=this.outputBlocks,y=this.extraBytes,h=0,g=0,v=[],f,S;g<u;){for(h=0;h<n&&g<u;++h,++g)f=g<<2,S=d[h],v[f]=S&255,v[f+1]=S>>8&255,v[f+2]=S>>16&255,v[f+3]=S>>24&255;g%n===0&&Je(d);}return y&&(f=g<<2,S=d[h],v[f]=S&255,y>1&&(v[f+1]=S>>8&255),y>2&&(v[f+2]=S>>16&255)),v};function Ur(n,d,u){B.call(this,n,d,u);}Ur.prototype=new B,Ur.prototype.finalize=function(){return this.encode(this.outputBits,!0),B.prototype.finalize.call(this)};var Je=function(n){var d,u,y,h,g,v,f,S,w,C,ft,gt,vt,wt,bt,Pt,Kt,Ct,At,Et,xt,Bt,St,kt,Tt,Mt,Ut,Dt,It,Nt,Vt,Rt,Ot,_t,Lt,Ft,Ht,qt,zt,$t,Xt,Wt,Gt,jt,Qt,Yt,Jt,Zt,er,tr,rr,nr,ir,sr,or,ar,cr,pr,dr,ur,yr,lr,mr;for(y=0;y<48;y+=2)h=n[0]^n[10]^n[20]^n[30]^n[40],g=n[1]^n[11]^n[21]^n[31]^n[41],v=n[2]^n[12]^n[22]^n[32]^n[42],f=n[3]^n[13]^n[23]^n[33]^n[43],S=n[4]^n[14]^n[24]^n[34]^n[44],w=n[5]^n[15]^n[25]^n[35]^n[45],C=n[6]^n[16]^n[26]^n[36]^n[46],ft=n[7]^n[17]^n[27]^n[37]^n[47],gt=n[8]^n[18]^n[28]^n[38]^n[48],vt=n[9]^n[19]^n[29]^n[39]^n[49],d=gt^(v<<1|f>>>31),u=vt^(f<<1|v>>>31),n[0]^=d,n[1]^=u,n[10]^=d,n[11]^=u,n[20]^=d,n[21]^=u,n[30]^=d,n[31]^=u,n[40]^=d,n[41]^=u,d=h^(S<<1|w>>>31),u=g^(w<<1|S>>>31),n[2]^=d,n[3]^=u,n[12]^=d,n[13]^=u,n[22]^=d,n[23]^=u,n[32]^=d,n[33]^=u,n[42]^=d,n[43]^=u,d=v^(C<<1|ft>>>31),u=f^(ft<<1|C>>>31),n[4]^=d,n[5]^=u,n[14]^=d,n[15]^=u,n[24]^=d,n[25]^=u,n[34]^=d,n[35]^=u,n[44]^=d,n[45]^=u,d=S^(gt<<1|vt>>>31),u=w^(vt<<1|gt>>>31),n[6]^=d,n[7]^=u,n[16]^=d,n[17]^=u,n[26]^=d,n[27]^=u,n[36]^=d,n[37]^=u,n[46]^=d,n[47]^=u,d=C^(h<<1|g>>>31),u=ft^(g<<1|h>>>31),n[8]^=d,n[9]^=u,n[18]^=d,n[19]^=u,n[28]^=d,n[29]^=u,n[38]^=d,n[39]^=u,n[48]^=d,n[49]^=u,wt=n[0],bt=n[1],Yt=n[11]<<4|n[10]>>>28,Jt=n[10]<<4|n[11]>>>28,Dt=n[20]<<3|n[21]>>>29,It=n[21]<<3|n[20]>>>29,ur=n[31]<<9|n[30]>>>23,yr=n[30]<<9|n[31]>>>23,Wt=n[40]<<18|n[41]>>>14,Gt=n[41]<<18|n[40]>>>14,_t=n[2]<<1|n[3]>>>31,Lt=n[3]<<1|n[2]>>>31,Pt=n[13]<<12|n[12]>>>20,Kt=n[12]<<12|n[13]>>>20,Zt=n[22]<<10|n[23]>>>22,er=n[23]<<10|n[22]>>>22,Nt=n[33]<<13|n[32]>>>19,Vt=n[32]<<13|n[33]>>>19,lr=n[42]<<2|n[43]>>>30,mr=n[43]<<2|n[42]>>>30,sr=n[5]<<30|n[4]>>>2,or=n[4]<<30|n[5]>>>2,Ft=n[14]<<6|n[15]>>>26,Ht=n[15]<<6|n[14]>>>26,Ct=n[25]<<11|n[24]>>>21,At=n[24]<<11|n[25]>>>21,tr=n[34]<<15|n[35]>>>17,rr=n[35]<<15|n[34]>>>17,Rt=n[45]<<29|n[44]>>>3,Ot=n[44]<<29|n[45]>>>3,kt=n[6]<<28|n[7]>>>4,Tt=n[7]<<28|n[6]>>>4,ar=n[17]<<23|n[16]>>>9,cr=n[16]<<23|n[17]>>>9,qt=n[26]<<25|n[27]>>>7,zt=n[27]<<25|n[26]>>>7,Et=n[36]<<21|n[37]>>>11,xt=n[37]<<21|n[36]>>>11,nr=n[47]<<24|n[46]>>>8,ir=n[46]<<24|n[47]>>>8,jt=n[8]<<27|n[9]>>>5,Qt=n[9]<<27|n[8]>>>5,Mt=n[18]<<20|n[19]>>>12,Ut=n[19]<<20|n[18]>>>12,pr=n[29]<<7|n[28]>>>25,dr=n[28]<<7|n[29]>>>25,$t=n[38]<<8|n[39]>>>24,Xt=n[39]<<8|n[38]>>>24,Bt=n[48]<<14|n[49]>>>18,St=n[49]<<14|n[48]>>>18,n[0]=wt^~Pt&Ct,n[1]=bt^~Kt&At,n[10]=kt^~Mt&Dt,n[11]=Tt^~Ut&It,n[20]=_t^~Ft&qt,n[21]=Lt^~Ht&zt,n[30]=jt^~Yt&Zt,n[31]=Qt^~Jt&er,n[40]=sr^~ar&pr,n[41]=or^~cr&dr,n[2]=Pt^~Ct&Et,n[3]=Kt^~At&xt,n[12]=Mt^~Dt&Nt,n[13]=Ut^~It&Vt,n[22]=Ft^~qt&$t,n[23]=Ht^~zt&Xt,n[32]=Yt^~Zt&tr,n[33]=Jt^~er&rr,n[42]=ar^~pr&ur,n[43]=cr^~dr&yr,n[4]=Ct^~Et&Bt,n[5]=At^~xt&St,n[14]=Dt^~Nt&Rt,n[15]=It^~Vt&Ot,n[24]=qt^~$t&Wt,n[25]=zt^~Xt&Gt,n[34]=Zt^~tr&nr,n[35]=er^~rr&ir,n[44]=pr^~ur&lr,n[45]=dr^~yr&mr,n[6]=Et^~Bt&wt,n[7]=xt^~St&bt,n[16]=Nt^~Rt&kt,n[17]=Vt^~Ot&Tt,n[26]=$t^~Wt&_t,n[27]=Xt^~Gt&Lt,n[36]=tr^~nr&jt,n[37]=rr^~ir&Qt,n[46]=ur^~lr&sr,n[47]=yr^~mr&or,n[8]=Bt^~wt&Pt,n[9]=St^~bt&Kt,n[18]=Rt^~kt&Mt,n[19]=Ot^~Tt&Ut,n[28]=Wt^~_t&Ft,n[29]=Gt^~Lt&Ht,n[38]=nr^~jt&Yt,n[39]=ir^~Qt&Jt,n[48]=lr^~sr&ar,n[49]=mr^~or&cr,n[0]^=xe[y],n[1]^=xe[y+1];};if(a)Er.exports=ye;else {for(he=0;he<Qe.length;++he)r[Qe[he]]=ye[Qe[he]];c&&define(function(){return ye});}})();});var Be$2=i=>`/xmtp/0/${i}/proto`,Fe$2=(i,e)=>{let t=[getAddress(i),getAddress(e)];return t.sort(),Be$2(`dm-${t.join("-")}`)},et$2=i=>Be$2(`m-${i}`),tt$2=i=>Be$2(`contact-${getAddress(i)}`),se$2=i=>Be$2(`intro-${getAddress(i)}`),fe$1=i=>Be$2(`invite-${getAddress(i)}`),Dr$1=i=>Be$2(`privatestore-${i}`);var hr$2=i=>new Promise(e=>setTimeout(e,i));var Ui$1=i=>!!i;async function rt$2(i,e,t,r,s=Ui$1,o=1){let a=typeof o=="number"?o:1;try{return await i(...e)}catch(c){if(!s(c)||a>t)throw c;return await hr$2(r),rt$2(i,e,t,r,s,a+1)}}async function*Ir$1(i,e){for await(let t of i){let r=await Promise.allSettled(t.map(e)),s=[];for(let o of r)o.status==="fulfilled"?s.push(o.value):console.warn("Failed to process envelope due to reason: ",o.reason);yield s;}}function V$3(i){return Long.fromNumber(i.valueOf()).multiply(1e6)}function j$6(i){return new Date(i.divide(1e6).toNumber())}var oe$3=i=>i&&V$3(i).toString();var{b64Decode:ae$3,b64Encode:Ys$1}=fetcher;function Nr(i,e){let t=new Uint8Array(i.length+e.length);return t.set(i),t.set(e,i.length),t}var _$7=class _{topics;client;messages;resolvers;callback;unsubscribeFn;onConnectionLost;constructor(e,t,r,s,o){this.messages=[],this.resolvers=[],this.topics=t,this.client=e,this.callback=this.newMessageCallback(r,s),this.onConnectionLost=o;}newMessageCallback(e,t){return async r=>{if(r.message)try{let s=await e(r);if(!s)return;if(t){let a=t(s);a&&this.resubscribeToTopics(a);}let o=this.resolvers.pop();o?o({value:s}):this.messages.unshift(s);}catch(s){console.warn(s);}}}async start(){if(!this.callback)throw new Error("Missing callback for stream");this.unsubscribeFn=this.client.apiClient.subscribe({contentTopics:this.topics},async e=>{this.callback&&await this?.callback(e);},this.onConnectionLost);}static async create(e,t,r,s,o){let a=new _$7(e,t,r,s,o);return await a.start(),a}[Symbol.asyncIterator](){return this}async return(){return this.unsubscribeFn&&await this.unsubscribeFn(),this.callback?(this.callback=void 0,this.resolvers.forEach(e=>e({value:void 0,done:!0})),{value:void 0,done:!0}):{value:void 0,done:!0}}next(){let e=this.messages.pop();return e?Promise.resolve({value:e}):this.callback?new Promise(t=>this.resolvers.unshift(t)):Promise.resolve({value:void 0,done:!0})}async resubscribeToTopics(e){if(!this.callback||!this.unsubscribeFn)throw new Error("Missing callback for stream");await this.unsubscribeFn(),this.topics=e,this.unsubscribeFn=this.client.apiClient.subscribe({contentTopics:this.topics},async t=>{this.callback&&await this?.callback(t);},this.onConnectionLost);}};var Vr=32,Rr$1=12,Ni=16,U$3=class U{aes256GcmHkdfSha256;constructor(e){if(!e.aes256GcmHkdfSha256)throw new Error("invalid ciphertext");if(e.aes256GcmHkdfSha256.payload.length<Ni)throw new Error(`invalid ciphertext ciphertext length: ${e.aes256GcmHkdfSha256.payload.length}`);if(e.aes256GcmHkdfSha256.hkdfSalt.length!==Vr)throw new Error(`invalid ciphertext salt length: ${e.aes256GcmHkdfSha256.hkdfSalt.length}`);if(e.aes256GcmHkdfSha256.gcmNonce.length!==Rr$1)throw new Error(`invalid ciphertext nonce length: ${e.aes256GcmHkdfSha256.gcmNonce.length}`);this.aes256GcmHkdfSha256=e.aes256GcmHkdfSha256;}toBytes(){return Ciphertext.encode(this).finish()}static fromBytes(e){return new U$3(Ciphertext.decode(e))}};var Kn=gn(Pn(),1),Vi$1=typeof globalThis=="object"&&"crypto"in globalThis?globalThis.crypto:void 0,Ri=Vi$1??Kn.webcrypto,k$3=Ri;var Oi=new ArrayBuffer(0);async function D$5(i){return new Uint8Array(await k$3.subtle.digest("SHA-256",i))}async function Q$3(i,e,t){let r=k$3.getRandomValues(new Uint8Array(Vr)),s=k$3.getRandomValues(new Uint8Array(Rr$1)),o=await An(e,r),a=await k$3.subtle.encrypt(Cn(s,t),o,i);return new U$3({aes256GcmHkdfSha256:{payload:new Uint8Array(a),hkdfSalt:r,gcmNonce:s}})}async function H$5(i,e,t){if(!i.aes256GcmHkdfSha256)throw new Error("invalid payload ciphertext");let r=await An(e,i.aes256GcmHkdfSha256.hkdfSalt),s=await k$3.subtle.decrypt(Cn(i.aes256GcmHkdfSha256.gcmNonce,t),r,i.aes256GcmHkdfSha256.payload);return new Uint8Array(s)}function Cn(i,e){let t={name:"AES-GCM",iv:i};return e&&(t.additionalData=e),t}async function An(i,e){let t=await k$3.subtle.importKey("raw",i,"HKDF",!1,["deriveKey"]);return k$3.subtle.deriveKey({name:"HKDF",hash:"SHA-256",salt:e,info:Oi},t,{name:"AES-GCM",length:256},!1,["encrypt","decrypt"])}var q$4=utils$m.bytesToHex;function z$4(i){i.startsWith("0x")&&(i=i.slice(2));let e=new Uint8Array(i.length/2);for(let t=0;t<e.length;t++){let r=t*2;e[t]=Number.parseInt(i.slice(r,r+2),16);}return e}function ge$1(i,e){if(i.length!==e.length)return !1;for(let t=0;t<i.length;t++)if(i[t]!==e[t])return !1;return !0}function Bn(i){if(i.bytes.length!==32)throw new Error(`invalid private key length: ${i.bytes.length}`)}var N$4=class N{createdNs;secp256k1;publicKey;constructor(e){if(!e.secp256k1)throw new Error("invalid private key");if(Bn(e.secp256k1),this.secp256k1=e.secp256k1,this.createdNs=e.createdNs,!e.publicKey)throw new Error("missing public key");this.publicKey=new A$4(e.publicKey);}static async generate(e){let t={bytes:utils$m.randomPrivateKey()},r=Long.fromNumber(new Date().getTime()).mul(1e6),s=new J$3({secp256k1Uncompressed:{bytes:getPublicKey(t.bytes)},createdNs:r}),o=await e.signKey(s);return new N$4({secp256k1:t,createdNs:r,publicKey:o})}generated(){return new Date(this.createdNs.div(1e6).toNumber())}async sign(e){let[t,r]=await sign(e,this.secp256k1.bytes,{recovered:!0,der:!1});return new E$4({ecdsaCompact:{bytes:t,recovery:r}})}async signKey(e){let t=e.toBytes(),r=await D$5(t),s=await this.sign(r);return new A$4({keyBytes:t,signature:s})}static async signerKey(e,t){let r=await D$5(e.bytesToSign());return Or(r,t)}sharedSecret(e){return getSharedSecret(this.secp256k1.bytes,e.secp256k1Uncompressed.bytes,!1)}encrypt(e,t,r){let s=this.sharedSecret(t);return Q$3(e,s,r)}decrypt(e,t,r){let s=this.sharedSecret(t);return H$5(e,s,r)}matches(e){return this.publicKey.equals(e)}equals(e){return ge$1(this.secp256k1.bytes,e.secp256k1.bytes)&&this.publicKey.equals(e.publicKey)}toBytes(){return SignedPrivateKey.encode(this).finish()}validatePublicKey(){let e=getPublicKey(this.secp256k1.bytes);return ge$1(e,this.publicKey.secp256k1Uncompressed.bytes)}static fromBytes(e){return new N$4(SignedPrivateKey.decode(e))}static fromLegacyKey(e,t){return new N$4({createdNs:e.timestamp.mul(1e6),secp256k1:e.secp256k1,publicKey:A$4.fromLegacyKey(e.publicKey,t)})}},Y$2=class Y{timestamp;secp256k1;publicKey;constructor(e){if(!e.secp256k1)throw new Error("invalid private key");if(Bn(e.secp256k1),this.timestamp=e.timestamp,this.secp256k1=e.secp256k1,!e.publicKey)throw new Error("missing public key");this.publicKey=new I$3(e.publicKey);}static generate(){let e={bytes:utils$m.randomPrivateKey()},t=Long.fromNumber(new Date().getTime());return new Y$2({secp256k1:e,timestamp:t,publicKey:new I$3({secp256k1Uncompressed:{bytes:getPublicKey(e.bytes)},timestamp:t})})}generated(){return new Date(this.timestamp.toNumber())}async sign(e){let[t,r]=await sign(e,this.secp256k1.bytes,{recovered:!0,der:!1});return new E$4({ecdsaCompact:{bytes:t,recovery:r}})}async signKey(e){let t=await D$5(e.bytesToSign());return e.signature=await this.sign(t),e}sharedSecret(e){return getSharedSecret(this.secp256k1.bytes,e.secp256k1Uncompressed.bytes,!1)}encrypt(e,t,r){let s=this.sharedSecret(t);return Q$3(e,s,r)}decrypt(e,t,r){let s=this.sharedSecret(t);return H$5(e,s,r)}matches(e){return this.publicKey.equals(e)}validatePublicKey(){let e=getPublicKey(this.secp256k1.bytes);return ge$1(e,this.publicKey.secp256k1Uncompressed.bytes)}toBytes(){return PrivateKey.encode(this).finish()}static fromBytes(e){return new Y$2(PrivateKey.decode(e))}};function Tn(i){if(i.bytes.length!==64)throw new Error(`invalid signature length: ${i.bytes.length}`);if(i.recovery!==0&&i.recovery!==1)throw new Error(`invalid recovery bit: ${i.recovery}`)}function Mn(i,e){return i.recovery===e.recovery&&ge$1(i.bytes,e.bytes)}function Or(i,e){let t=recoverPublicKey(i,e.bytes,e.recovery);return t?new J$3({secp256k1Uncompressed:{bytes:t},createdNs:Long.fromNumber(0)}):void 0}var E$4=class E{ecdsaCompact;walletEcdsaCompact;constructor(e){if(e.ecdsaCompact)Tn(e.ecdsaCompact),this.ecdsaCompact=e.ecdsaCompact;else if(e.walletEcdsaCompact)Tn(e.walletEcdsaCompact),this.walletEcdsaCompact=e.walletEcdsaCompact;else throw new Error("invalid signature")}async signerKey(e){return this.ecdsaCompact?N$4.signerKey(e,this.ecdsaCompact):this.walletEcdsaCompact?ee$2.signerKey(e,this.walletEcdsaCompact):void 0}getPublicKey(e){let t;if(this.ecdsaCompact)t=recoverPublicKey(e,this.ecdsaCompact.bytes,this.ecdsaCompact.recovery);else if(this.walletEcdsaCompact)t=recoverPublicKey(e,this.walletEcdsaCompact.bytes,this.walletEcdsaCompact.recovery);else throw new Error("invalid v1 signature");return t?new I$3({secp256k1Uncompressed:{bytes:t},timestamp:Long.fromNumber(0)}):void 0}equals(e){return this.ecdsaCompact&&e.ecdsaCompact?Mn(this.ecdsaCompact,e.ecdsaCompact):this.walletEcdsaCompact&&e.walletEcdsaCompact?Mn(this.walletEcdsaCompact,e.walletEcdsaCompact):!1}toBytes(){return Signature$5.encode(this).finish()}static fromBytes(e){return new E$4(Signature$5.decode(e))}};var ee$2=class ee{wallet;constructor(e){this.wallet=e;}static identitySigRequestText(e){return `XMTP : Create Identity
${q$4(e)}

For more info: https://xmtp.org/signatures/`}static signerKey(e,t){let r=z$4(hashMessage(this.identitySigRequestText(e.bytesToSign())));return Or(r,t)}async signKey(e){let t=e.toBytes(),r=await this.wallet.signMessage(ee$2.identitySigRequestText(t)),s=splitSignature(r),o=z$4(s.r),a=z$4(s.s),c=new Uint8Array(64);c.set(o),c.set(a,o.length);let p=new E$4({walletEcdsaCompact:{bytes:c,recovery:s.recoveryParam}});return new A$4({keyBytes:t,signature:p})}};function Fi$2(i){if(i.bytes.length!==65)throw new Error(`invalid public key length: ${i.bytes.length}`);if(i.bytes[0]!==4)throw new Error(`unrecognized public key prefix: ${i.bytes[0]}`)}var Hi$1=new Long(10**9).mul(10**9),J$3=class J{createdNs;secp256k1Uncompressed;constructor(e){if(!e?.secp256k1Uncompressed)throw new Error("invalid public key");Fi$2(e.secp256k1Uncompressed),this.secp256k1Uncompressed=e.secp256k1Uncompressed,this.createdNs=e.createdNs.toUnsigned();}generated(){return new Date(this.timestamp.toNumber())}isFromLegacyKey(){return this.createdNs.lessThan(Hi$1)}get timestamp(){return (this.isFromLegacyKey()?this.createdNs:this.createdNs.div(1e6)).toUnsigned()}verify(e,t){return e.ecdsaCompact?verify(e.ecdsaCompact.bytes,t,this.secp256k1Uncompressed.bytes):!1}async verifyKey(e){if(!e.signature)return !1;let t=await D$5(e.bytesToSign());return this.verify(e.signature,t)}equals(e){return ge$1(this.secp256k1Uncompressed.bytes,e.secp256k1Uncompressed.bytes)}getEthereumAddress(){return computeAddress(this.secp256k1Uncompressed.bytes)}toBytes(){return UnsignedPublicKey.encode(this).finish()}static fromBytes(e){return new J$3(UnsignedPublicKey.decode(e))}},A$4=class A extends J$3{keyBytes;signature;constructor(e){if(!e.keyBytes)throw new Error("missing key bytes");if(super(UnsignedPublicKey.decode(e.keyBytes)),this.keyBytes=e.keyBytes,!e.signature)throw new Error("missing key signature");this.signature=new E$4(e.signature);}get unsignedKey(){return new J$3({createdNs:this.createdNs,secp256k1Uncompressed:this.secp256k1Uncompressed})}signerKey(){return this.signature.signerKey(this)}async walletSignatureAddress(){if(!this.signature.walletEcdsaCompact)throw new Error("key was not signed by a wallet");let e=await this.signerKey();if(!e)throw new Error("key signature not valid");return e.getEthereumAddress()}equals(e){return this.unsignedKey.equals(e.unsignedKey)&&this.signature.equals(e.signature)}bytesToSign(){return this.keyBytes}toBytes(){return SignedPublicKey.encode(this).finish()}static fromBytes(e){return new A$4(SignedPublicKey.decode(e))}toLegacyKey(){if(!this.isFromLegacyKey())throw new Error("cannot be converted to legacy key");let e=this.signature;return e.walletEcdsaCompact&&(e=new E$4({ecdsaCompact:e.walletEcdsaCompact})),new I$3({timestamp:this.timestamp,secp256k1Uncompressed:this.secp256k1Uncompressed,signature:e})}static fromLegacyKey(e,t){if(!e.signature)throw new Error("key is not signed");let r=e.signature;return t&&(r=new E$4({walletEcdsaCompact:r.ecdsaCompact})),new A$4({keyBytes:e.bytesToSign(),signature:r})}},I$3=class I extends J$3{signature;constructor(e){super({createdNs:e.timestamp.mul(1e6),secp256k1Uncompressed:e.secp256k1Uncompressed}),e.signature&&(!e.signature.ecdsaCompact&&e.signature.walletEcdsaCompact?this.signature=new E$4({ecdsaCompact:{bytes:e.signature.walletEcdsaCompact.bytes,recovery:e.signature.walletEcdsaCompact.recovery}}):this.signature=new E$4(e.signature));}get timestamp(){return this.createdNs.div(1e6)}bytesToSign(){return PublicKey.encode({timestamp:this.timestamp,secp256k1Uncompressed:this.secp256k1Uncompressed}).finish()}async signWithWallet(e){let t=await e.signMessage(ee$2.identitySigRequestText(this.bytesToSign())),r=splitSignature(t),s=z$4(r.r),o=z$4(r.s),a=new Uint8Array(64);a.set(s),a.set(o,s.length),this.signature=new E$4({ecdsaCompact:{bytes:a,recovery:r.recoveryParam}});}walletSignatureAddress(){if(!this.signature)throw new Error("key is not signed");let e=z$4(hashMessage(ee$2.identitySigRequestText(this.bytesToSign()))),t=this.signature.getPublicKey(e);if(!t)throw new Error("key signature is malformed");return t.getEthereumAddress()}toBytes(){return PublicKey.encode(this).finish()}static fromBytes(e){return new I$3(PublicKey.decode(e))}};var K$7=class K{identityKey;preKey;constructor(e){if(!e.identityKey)throw new Error("missing identity key");if(!e.preKey)throw new Error("missing pre-key");this.identityKey=new A$4(e.identityKey),this.preKey=new A$4(e.preKey);}walletSignatureAddress(){return this.identityKey.walletSignatureAddress()}equals(e){return this.identityKey.equals(e.identityKey)&&this.preKey.equals(e.preKey)}toBytes(){return SignedPublicKeyBundle.encode(this).finish()}isFromLegacyBundle(){return this.identityKey.isFromLegacyKey()&&this.preKey.isFromLegacyKey()}toLegacyBundle(){return new P$5({identityKey:this.identityKey.toLegacyKey(),preKey:this.preKey.toLegacyKey()})}static fromBytes(e){let t=SignedPublicKeyBundle.decode(e);return new K$7(t)}static fromLegacyBundle(e){return new K$7({identityKey:A$4.fromLegacyKey(e.identityKey,!0),preKey:A$4.fromLegacyKey(e.preKey)})}},P$5=class P{identityKey;preKey;constructor(e){if(!e.identityKey)throw new Error("missing identity key");if(!e.preKey)throw new Error("missing pre-key");this.identityKey=new I$3(e.identityKey),this.preKey=new I$3(e.preKey);}equals(e){return this.identityKey.equals(e.identityKey)&&this.preKey.equals(e.preKey)}walletSignatureAddress(){return this.identityKey.walletSignatureAddress()}toBytes(){return PublicKeyBundle.encode(this).finish()}static fromBytes(e){let t=PublicKeyBundle.decode(e);return new P$5(t)}};var nt$2=class nt extends Error{constructor(e){super(`no pre-key matches: ${q$4(e.secp256k1Uncompressed.bytes)}`);}};var $$5=class ${identityKey;preKeys;version=2;_publicKeyBundle;constructor(e){if(!e.identityKey)throw new Error("missing identity key");this.identityKey=new N$4(e.identityKey),this.preKeys=(e.preKeys||[]).map(t=>new N$4(t));}static async generate(e){let t=await N$4.generate(new ee$2(e)),r=new $$5({identityKey:t,preKeys:[]});return await r.addPreKey(),r}getCurrentPreKey(){return this.preKeys[0]}findPreKey(e){let t=this.preKeys.find(r=>r.matches(e));if(!t)throw new nt$2(e);return t}async addPreKey(){this._publicKeyBundle=void 0;let e=await N$4.generate(this.identityKey);this.preKeys.unshift(e);}getPublicKeyBundle(){return this._publicKeyBundle||(this._publicKeyBundle=new K$7({identityKey:this.identityKey.publicKey,preKey:this.getCurrentPreKey().publicKey})),this._publicKeyBundle}async sharedSecret(e,t,r){if(!e.identityKey||!e.preKey)throw new Error("invalid peer key bundle");if(!await e.identityKey.verifyKey(e.preKey))throw new Error("peer preKey signature invalid");if(!this.identityKey)throw new Error("missing identity key");let s,o,a;r?(a=this.findPreKey(t),s=a.sharedSecret(e.identityKey),o=this.identityKey.sharedSecret(e.preKey)):(a=this.findPreKey(t),s=this.identityKey.sharedSecret(e.preKey),o=a.sharedSecret(e.identityKey));let c=a.sharedSecret(e.preKey),p=new Uint8Array(s.length+o.length+c.length);return p.set(s,0),p.set(o,s.length),p.set(c,s.length+o.length),p}encode(){return PrivateKeyBundle.encode({v1:void 0,v2:this}).finish()}validatePublicKeys(){return this.identityKey.validatePublicKey()?this.preKeys.every(e=>e.validatePublicKey()):!1}equals(e){if(this.preKeys.length!==e.preKeys.length)return !1;for(let t=0;t<this.preKeys.length;t++)if(!this.preKeys[t].equals(e.preKeys[t]))return !1;return this.identityKey.equals(e.identityKey)}static fromLegacyBundle(e){return new $$5({identityKey:N$4.fromLegacyKey(e.identityKey,!0),preKeys:e.preKeys.map(t=>N$4.fromLegacyKey(t))})}},Z$3=class Z{identityKey;preKeys;version=1;_publicKeyBundle;constructor(e){if(!e.identityKey)throw new Error("missing identity key");this.identityKey=new Y$2(e.identityKey),this.preKeys=(e.preKeys||[]).map(t=>new Y$2(t));}static async generate(e){let t=Y$2.generate();e&&await t.publicKey.signWithWallet(e);let r=new Z$3({identityKey:t,preKeys:[]});return await r.addPreKey(),r}getCurrentPreKey(){return this.preKeys[0]}findPreKey(e){let t=this.preKeys.find(r=>r.matches(e));if(!t)throw new nt$2(e);return t}async addPreKey(){this._publicKeyBundle=void 0;let e=Y$2.generate();await this.identityKey.signKey(e.publicKey),this.preKeys.unshift(e);}getPublicKeyBundle(){return this._publicKeyBundle||(this._publicKeyBundle=new P$5({identityKey:this.identityKey.publicKey,preKey:this.getCurrentPreKey().publicKey})),this._publicKeyBundle}validatePublicKeys(){return this.identityKey.validatePublicKey()?this.preKeys.every(e=>e.validatePublicKey()):!1}async sharedSecret(e,t,r){if(!e.identityKey||!e.preKey)throw new Error("invalid peer key bundle");if(!await e.identityKey.verifyKey(e.preKey))throw new Error("peer preKey signature invalid");if(!this.identityKey)throw new Error("missing identity key");let s,o,a;r?(a=this.findPreKey(t),s=a.sharedSecret(e.identityKey),o=this.identityKey.sharedSecret(e.preKey)):(a=this.findPreKey(t),s=this.identityKey.sharedSecret(e.preKey),o=a.sharedSecret(e.identityKey));let c=a.sharedSecret(e.preKey),p=new Uint8Array(s.length+o.length+c.length);return p.set(s,0),p.set(o,s.length),p.set(c,s.length+o.length),p}encode(){return PrivateKeyBundle.encode({v1:this,v2:void 0}).finish()}};function it$2(i){let e=PrivateKeyBundle.decode(i);if(e.v1)return new Z$3(e.v1);if(e.v2)return new $$5(e.v2);throw new Error("unknown private key bundle version")}var qi$1=16,zi=65,$i$2=32,Xi$1=16,Wi$2=i=>{if(i.iv.length!==qi$1)throw new Error("Invalid iv length");if(i.ephemeralPublicKey.length!==zi)throw new Error("Invalid ephemPublicKey length");if(i.ciphertext.length<1||i.ciphertext.length%Xi$1!==0)throw new Error("Invalid ciphertext length");if(i.mac.length!==$i$2)throw new Error("Invalid mac length")},ce$3=class ce{eciesBytes;signature;ciphertext;constructor({eciesBytes:e,signature:t}){if(!e||!e.length)throw new Error("eciesBytes is empty");if(!t)throw new Error("signature is undefined");this.eciesBytes=e,this.signature=new E$4(t),this.ciphertext=SignedEciesCiphertext_Ecies.decode(e);}toBytes(){return SignedEciesCiphertext.encode(this).finish()}async verify(e){return e.verify(this.signature,await D$5(this.eciesBytes))}static fromBytes(e){let t=SignedEciesCiphertext.decode(e);return new ce$3(t)}static async create(e,t){Wi$2(e);let r=SignedEciesCiphertext_Ecies.encode(e).finish(),s=await t.sign(await D$5(r));return new ce$3({eciesBytes:r,signature:s})}};var st$2=class st{messageEnvelope;onSend;constructor(e,t){this.messageEnvelope=e,this.onSend=t;}async messageID(){if(!this.messageEnvelope.message)throw new Error("no envelope message");return q$4(await D$5(this.messageEnvelope.message))}async send(){await this.onSend();}};var x$3=class x extends Error{code;constructor(e,t){super(t),this.code=e;}};var Se=i=>{if(i.error)throw new x$3(i.error.code,i.error.message);if(!i.result)throw new x$3(ErrorCode.ERROR_CODE_UNSPECIFIED,"No result from Keystore");if("encrypted"in i.result&&!i.result.encrypted)throw new Error("Missing ciphertext");if("decrypted"in i.result&&!i.result.decrypted)throw new Error("Missing decrypted result");return i.result},br$1=(i,e)=>({requests:i.map(t=>{let r=new P$5({identityKey:t.header.sender?.identityKey,preKey:t.header.sender?.preKey}),s=e.equals(r);return {payload:t.ciphertext,peerKeys:s?new P$5({identityKey:t.header.recipient?.identityKey,preKey:t.header.recipient?.preKey}):r,headerBytes:t.headerBytes,isSender:s}})});var R$3=class R{authorityId;typeId;versionMajor;versionMinor;constructor(e){this.authorityId=e.authorityId,this.typeId=e.typeId,this.versionMajor=e.versionMajor,this.versionMinor=e.versionMinor;}toString(){return `${this.authorityId}/${this.typeId}:${this.versionMajor}.${this.versionMinor}`}static fromString(e){let[t,r]=e.split(":"),[s,o]=t.split("/"),[a,c]=r.split(".");return new R$3({authorityId:s,typeId:o,versionMajor:Number(a),versionMinor:Number(c)})}sameAs(e){return this.authorityId===e.authorityId&&this.typeId===e.typeId}};new R$3({authorityId:"xmtp.org",typeId:"fallback",versionMajor:1,versionMinor:0});var we$1=new R$3({authorityId:"xmtp.org",typeId:"text",versionMajor:1,versionMinor:0});var ot$3=class ot{get contentType(){return we$1}encode(e){return {type:we$1,parameters:{encoding:"UTF-8"},content:new TextEncoder().encode(e)}}decode(e){let t=e.parameters.encoding;if(t&&t!=="UTF-8")throw new Error(`unrecognized encoding ${t}`);return new TextDecoder().decode(e.content)}};var X$3=class X{conversationVersion="v1";peerAddress;createdAt;context=void 0;client;constructor(e,t,r){this.peerAddress=getAddress(t),this.client=e,this.createdAt=r;}get clientAddress(){return this.client.address}get topic(){return Fe$2(this.peerAddress,this.client.address)}get ephemeralTopic(){return Fe$2(this.peerAddress,this.client.address).replace("/xmtp/0/dm-","/xmtp/0/dmE-")}async messages(e){let t=Fe$2(this.peerAddress,this.client.address),r=await this.client.listEnvelopes(t,this.processEnvelope.bind(this),e);return this.decryptBatch(r,t,!1)}messagesPaginated(e){return this.client.listEnvelopesPaginated(this.topic,this.decodeMessage.bind(this),e)}async decodeMessage(e){if(!e.contentTopic)throw new Error("Missing content topic");let t=await this.processEnvelope(e),r=await this.decryptBatch([t],e.contentTopic,!0);if(!r.length)throw new Error("No results");return r[0]}async prepareMessage(e,t){let r,s=await this.client.getUserContact(this.peerAddress);if(!s)throw new Error(`recipient ${this.peerAddress} is not registered`);s instanceof P$5||(s=s.toLegacyBundle()),this.client.contacts.has(this.peerAddress)?r=[this.topic]:(r=[se$2(this.peerAddress),se$2(this.client.address),this.topic],this.client.contacts.add(this.peerAddress));let o=await this.client.encodeContent(e,t),a=await this.createMessage(o,s,t?.timestamp),c={contentTopic:this.topic,message:a.toBytes(),timestampNs:oe$3(a.sent)};return new st$2(c,async()=>{await this.client.publishEnvelopes(r.map(p=>({contentTopic:p,message:a.toBytes(),timestamp:a.sent})));})}streamMessages(e){return _$7.create(this.client,[this.topic],async t=>this.decodeMessage(t),void 0,e)}async processEnvelope({message:e,contentTopic:t}){let r=ae$3(e),s=await F$4.fromBytes(r),{senderAddress:o,recipientAddress:a}=s;if(!o||!a||!t||Fe$2(o,a)!==this.topic)throw new Error("Headers do not match intended recipient");return s}streamEphemeral(e){return _$7.create(this.client,[this.ephemeralTopic],this.decodeMessage.bind(this),void 0,e)}async send(e,t){let r,s=await this.client.getUserContact(this.peerAddress);if(!s)throw new Error(`recipient ${this.peerAddress} is not registered`);s instanceof P$5||(s=s.toLegacyBundle());let o=t?.ephemeral?this.ephemeralTopic:this.topic;this.client.contacts.has(this.peerAddress)?r=[this.topic]:(r=[se$2(this.peerAddress),se$2(this.client.address),o],this.client.contacts.add(this.peerAddress));let a=t?.contentType||we$1,c=await this.client.encodeContent(e,t),p=await this.createMessage(c,s,t?.timestamp);return await this.client.publishEnvelopes(r.map(m=>({contentTopic:m,message:p.toBytes(),timestamp:p.sent}))),O$5.fromV1Message(p,e,a,c,r[0],this)}async decryptBatch(e,t,r=!1){let s=(await this.client.keystore.decryptV1(br$1(e,this.client.publicKeyBundle))).responses,o=[];for(let a=0;a<s.length;a++){let c=s[a],p=e[a];try{let{decrypted:m}=Se(c);o.push(await this.buildDecodedMessage(p,m,t));}catch(m){if(r)throw m;console.warn("Error decoding content",m);}}return o}async buildDecodedMessage(e,t,r){let{content:s,contentType:o,error:a,contentFallback:c}=await at$2(t,this.client);return O$5.fromV1Message(e,s,o,t,r,this,a,c)}async createMessage(e,t,r){return r=r||new Date,F$4.encode(this.client.keystore,e,this.client.publicKeyBundle,t,r)}},te$2=class te{conversationVersion="v2";client;topic;peerAddress;createdAt;context;constructor(e,t,r,s,o){this.topic=t,this.createdAt=s,this.context=o,this.client=e,this.peerAddress=r;}get clientAddress(){return this.client.address}async messages(e){let t=await this.client.listEnvelopes(this.topic,this.processEnvelope.bind(this),e);return this.decryptBatch(t,!1)}messagesPaginated(e){return this.client.listEnvelopesPaginated(this.topic,this.decodeMessage.bind(this),e)}get ephemeralTopic(){return this.topic.replace("/xmtp/0/m","/xmtp/0/mE")}streamEphemeral(e){return _$7.create(this.client,[this.ephemeralTopic],this.decodeMessage.bind(this),void 0,e)}streamMessages(e){return _$7.create(this.client,[this.topic],this.decodeMessage.bind(this),void 0,e)}async send(e,t){let r=await this.client.encodeContent(e,t),s=await this.createMessage(r,t?.timestamp),o;t?.ephemeral?o=this.ephemeralTopic:o=this.topic,await this.client.publishEnvelopes([{contentTopic:o,message:s.toBytes(),timestamp:s.sent}]);let a=t?.contentType||we$1;return O$5.fromV2Message(s,e,a,this.topic,r,this,this.client.address)}async createMessage(e,t){let r={topic:this.topic,createdNs:V$3(t||new Date)},s=MessageHeaderV2.encode(r).finish(),o=await D$5(Nr(s,e)),a={payload:e,sender:this.client.signedPublicKeyBundle,signature:await this.client.keystore.signDigest({digest:o,prekeyIndex:0,identityKey:void 0})},c=SignedContent.encode(a).finish(),p=await this.encryptMessage(c,s),m={v1:void 0,v2:{headerBytes:s,ciphertext:p}},l=Message.encode(m).finish();return be$1.create(m,r,l)}async decryptBatch(e,t=!1){let r=(await this.client.keystore.decryptV2(this.buildDecryptRequest(e))).responses,s=[];for(let o=0;o<r.length;o++){let a=r[o],c=e[o];try{let{decrypted:p}=Se(a);s.push(await this.buildDecodedMessage(c,p));}catch(p){if(t)throw p;console.warn("Error decoding content",p);}}return s}buildDecryptRequest(e){return {requests:e.map(t=>({payload:t.ciphertext,headerBytes:t.headerBytes,contentTopic:this.topic}))}}async encryptMessage(e,t){let{responses:r}=await this.client.keystore.encryptV2({requests:[{payload:e,headerBytes:t,contentTopic:this.topic}]});if(r.length!==1)throw new Error("Invalid response length");let{encrypted:s}=Se(r[0]);return s}async buildDecodedMessage(e,t){let r=SignedContent.decode(t);if(!r.sender?.identityKey||!r.sender?.preKey||!r.signature)throw new Error("incomplete signed content");await Yi$1(r);let s=await D$5(Nr(e.headerBytes,r.payload));if(!new A$4(r.sender?.preKey).verify(new E$4(r.signature),s))throw new Error("invalid signature");let o=await new K$7(r.sender).walletSignatureAddress(),{content:a,contentType:c,error:p,contentFallback:m}=await at$2(r.payload,this.client);return O$5.fromV2Message(e,a,c,this.topic,r.payload,this,o,p,m)}async prepareMessage(e,t){let r=await this.client.encodeContent(e,t),s=await this.createMessage(r,t?.timestamp),a={contentTopic:t?.ephemeral?this.ephemeralTopic:this.topic,message:s.toBytes(),timestampNs:oe$3(s.sent)};return new st$2(a,async()=>{await this.client.publishEnvelopes([{contentTopic:this.topic,message:s.toBytes(),timestamp:s.sent}]);})}async processEnvelope(e){if(!e.message||!e.contentTopic)throw new Error("empty envelope");let t=ae$3(e.message.toString()),r=Message.decode(t);if(!r.v2)throw new Error("unknown message version");let s=MessageHeaderV2.decode(r.v2.headerBytes);if(s.topic!==this.topic)throw new Error("topic mismatch");return be$1.create(r,s,t)}async decodeMessage(e){if(!e.contentTopic)throw new Error("Missing content topic");let t=await this.processEnvelope(e),r=await this.decryptBatch([t],!0);if(!r.length)throw new Error("No results");return r[0]}};async function Yi$1(i){let e=i.sender?.preKey;if(!e||!e.signature||!e.keyBytes)throw new Error("missing pre-key or pre-key signature");let t=i.sender?.identityKey;if(!t)throw new Error("missing identity key in bundle");if(!await new A$4(t).verifyKey(new A$4(e)))throw new Error("pre key not signed by identity key")}async function Vn(i,e){if(i.compression===void 0)return;let t={bytes:new Uint8Array(i.content.length)};await _n(i.content).pipeThrough(new DecompressionStream(On(i.compression))).pipeTo(Ln(t,e)),i.content=t.bytes;}async function Rn(i){if(i.compression===void 0)return;let e={bytes:new Uint8Array(i.content.length/10)};await _n(i.content).pipeThrough(new CompressionStream(On(i.compression))).pipeTo(Ln(e,i.content.length+1e3)),i.content=e.bytes;}function On(i){if(i===Compression.COMPRESSION_GZIP)return "gzip";if(i===Compression.COMPRESSION_DEFLATE)return "deflate";throw new Error("unrecognized compression algorithm")}function _n(i,e=1024){let t=0;return new ReadableStream({pull(r){if(t>=i.length)return r.close();let s=t+e;s=s<=i.length?s:i.length,r.enqueue(i.subarray(t,s)),t=s;}})}function Ln(i,e){let t=0;return new WritableStream({write(r){let s=t+r.length;if(s>e)throw new Error("maximum output size exceeded");for(;i.bytes.length<s;)i.bytes=Ji$1(i.bytes,e);i.bytes.set(r,t),t=s;},close(){t<i.bytes.length&&(i.bytes=i.bytes.subarray(0,t));}})}function Ji$1(i,e){let t=i.length*2;t>e&&(t=e);let r=new Uint8Array(t);return r.set(i),r}var Fn=i=>{if(i.v1?.ciphertext)return [i.v1.headerBytes,new U$3(i.v1.ciphertext)];if(i.v2?.ciphertext)return [i.v2.headerBytes,new U$3(i.v2.ciphertext)];throw new Error("unknown message version")},Kr=class{headerBytes;ciphertext;contentType;error;id;bytes;constructor(e,t,r){[this.headerBytes,this.ciphertext]=Fn(r),this.id=e,this.bytes=t;}toBytes(){return this.bytes}},F$4=class F extends Kr{header;senderAddress;conversation=void 0;constructor(e,t,r,s,o){super(e,t,r),this.senderAddress=o,this.header=s;}static async create(e,t,r){if(!t.sender)throw new Error("missing message sender");let s=new P$5(t.sender).walletSignatureAddress(),o=q$4(await D$5(r));return new F$4(o,r,e,t,s)}get sent(){return new Date(this.header.timestamp.toNumber())}get recipientAddress(){if(this.header?.recipient?.identityKey)return new I$3(this.header.recipient.identityKey).walletSignatureAddress()}async decrypt(e,t){let r=(await e.decryptV1(br$1([this],t))).responses;if(!r.length)throw new Error("No response from Keystore");let{decrypted:s}=Se(r[0]);return s}static fromBytes(e){let t=Message.decode(e),[r]=Fn(t),s=MessageHeaderV1.decode(r);if(!s)throw new Error("missing message header");if(!s.sender)throw new Error("missing message sender");if(!s.sender.identityKey)throw new Error("missing message sender identity key");if(!s.sender.preKey)throw new Error("missing message sender pre-key");if(!s.recipient)throw new Error("missing message recipient");if(!s.recipient.identityKey)throw new Error("missing message recipient identity-key");if(!s.recipient.preKey)throw new Error("missing message recipient pre-key");return F$4.create(t,s,e)}static async encode(e,t,r,s,o){let a={sender:r,recipient:s,timestamp:Long.fromNumber(o.getTime())},c=MessageHeaderV1.encode(a).finish(),p=await e.encryptV1({requests:[{recipient:s,headerBytes:c,payload:t}]});if(!p.responses.length)throw new Error("No response from Keystore");let{encrypted:m}=Se(p.responses[0]),l={v1:{headerBytes:c,ciphertext:m},v2:void 0},b=Message.encode(l).finish();return F$4.create(l,a,b)}},be$1=class be extends Kr{senderAddress;header;constructor(e,t,r,s){super(e,t,r),this.header=s;}static async create(e,t,r){let s=q$4(await D$5(r));return new be$1(s,r,e,t)}get sent(){return j$6(this.header.createdNs)}},O$5=class O{id;messageVersion;senderAddress;recipientAddress;sent;contentTopic;conversation;contentType;content;error;contentBytes;contentFallback;constructor({id:e,messageVersion:t,senderAddress:r,recipientAddress:s,conversation:o,contentBytes:a,contentType:c,contentTopic:p,content:m,sent:l,error:b,contentFallback:T}){this.id=e,this.messageVersion=t,this.senderAddress=r,this.recipientAddress=s,this.conversation=o,this.contentType=c,this.sent=l,this.error=b,this.content=m,this.contentTopic=p,this.contentBytes=a,this.contentFallback=T;}toBytes(){return DecodedMessage.encode({...this,conversation:{topic:this.conversation.topic,context:this.conversation.context??void 0,createdNs:V$3(this.conversation.createdAt),peerAddress:this.conversation.peerAddress},sentNs:V$3(this.sent)}).finish()}static async fromBytes(e,t){let r=DecodedMessage.decode(e),s=r.messageVersion;if(s!=="v1"&&s!=="v2")throw new Error("Invalid message version");if(!r.conversation)throw new Error("No conversation reference found");let{content:o,contentType:a,error:c,contentFallback:p}=await at$2(r.contentBytes,t);return new O$5({...r,content:o,contentType:a,error:c,messageVersion:s,sent:j$6(r.sentNs),conversation:ts$2(r.conversation,t,s),contentFallback:p})}static fromV1Message(e,t,r,s,o,a,c,p){let{id:m,senderAddress:l,recipientAddress:b,sent:T}=e;if(!l)throw new Error("Sender address is required");return new O$5({id:m,messageVersion:"v1",senderAddress:l,recipientAddress:b,sent:T,content:t,contentBytes:s,contentType:r,contentTopic:o,conversation:a,error:c,contentFallback:p})}static fromV2Message(e,t,r,s,o,a,c,p,m){let{id:l,sent:b}=e;return new O$5({id:l,messageVersion:"v2",senderAddress:c,sent:b,content:t,contentBytes:o,contentType:r,contentTopic:s,conversation:a,error:p,contentFallback:m})}};async function at$2(i,e){let t=EncodedContent.decode(i);if(!t.type)throw new Error("missing content type");let r,s=new R$3(t.type),o;await Vn(t,1e3);let a=e.codecFor(s);return a?r=a.decode(t,e):o=new Error("unknown content type "+s),{content:r,contentType:s,error:o,contentFallback:t.fallback}}function ts$2(i,e,t){if(t==="v1")return new X$3(e,i.peerAddress,j$6(i.createdNs));if(t==="v2")return new te$2(e,i.topic,i.peerAddress,j$6(i.createdNs),i.context);throw new Error(`Unknown conversation version ${t}`)}var rs$2=60*60-10,ct$2=class ct{authenticator;token;maxAgeMs;constructor(e,t=rs$2){this.authenticator=e,this.maxAgeMs=t*1e3;}async getToken(){return (!this.token||this.token.ageMs>this.maxAgeMs)&&await this.refresh(),this.token.toBase64()}async refresh(){this.token=await this.authenticator.createToken();}};var Hn={name:"@xmtp/xmtp-js",version:"10.2.0",description:"XMTP client SDK for interacting with XMTP networks.",type:"module",main:"dist/index.cjs",module:"dist/index.js",types:"dist/index.d.ts",browser:"dist/web/index.js",exports:{".":{types:"./dist/index.d.ts",browser:"./dist/web/index.js",import:"./dist/index.js",require:"./dist/index.cjs"}},scripts:{prebench:"npm run build:bench",bench:"node dist/bench/index.cjs",build:"npm run clean:dist && npm run build:node && npm run build:web","build:bench":"tsup --out-dir dist/bench --entry.0 bench/index.ts --format cjs","build:node":"tsup","build:web":"tsup --platform browser --target esnext","build:docs":"rimraf docs && mkdir -p tmp && cp README.md tmp/ && sed -i.bak '/badge.svg/d' tmp/README.md && typedoc --excludePrivate --readme tmp/README.md src/index.ts",clean:"npm run clean:dist && npm run clean:proto","clean:dist":"rimraf dist","clean:proto":"rimraf -g src/proto/*.ts",package:"npm pack",prepublishOnly:"npm run build","test:setup":"./dev/up","test:teardown":"./dev/down",test:"npm run test:node","test:node":"jest --no-cache --env='node' --testTimeout=30000","test:jsdom":"jest --no-cache --env='./jest.jsdom.env.cjs' --testTimeout=30000","test:cov":"jest --coverage --no-cache --runInBand",lint:"prettier --check . && eslint .",autolint:"prettier --write . && eslint --fix .","semantic-release":"semantic-release",typecheck:"tsc"},publishConfig:{access:"public",provenance:!0},files:["dist/index.cjs","dist/index.cjs.map","dist/index.d.ts","dist/index.js","dist/index.js.map","dist/web/index.js","dist/web/index.js.map"],keywords:["xmtp","messaging","web3","sdk","js","javascript","node","nodejs"],author:"XMTP Labs <eng@xmtp.com>",license:"MIT",homepage:"https://github.com/xmtp/xmtp-js",repository:{type:"git",url:"https:git@github.com:xmtp/xmtp-js.git"},bugs:{url:"https://github.com/xmtp/xmtp-js/issues"},release:{branches:["main",{name:"beta",prerelease:!0}]},dependencies:{"@noble/secp256k1":"^1.5.2","@xmtp/proto":"^3.24.0","async-mutex":"^0.4.0",elliptic:"^6.5.4",ethers:"^5.5.3",long:"^5.2.0"},devDependencies:{"@commitlint/cli":"^16.1.0","@commitlint/config-conventional":"^16.0.0","@types/benchmark":"^2.1.2","@types/bl":"^5.0.2","@types/callback-to-async-iterator":"^1.1.4","@types/elliptic":"^6.4.14","@types/jest":"^28.1.3","@types/node":"^18.14.0","@typescript-eslint/eslint-plugin":"^5.38.0","@typescript-eslint/parser":"^5.38.0",benny:"^3.7.1","dd-trace":"^2.12.2",esbuild:"^0.17.16","esbuild-plugin-external-global":"^1.0.1",eslint:"^8.0.1","eslint-config-prettier":"^8.3.0","eslint-config-standard":"^17.0.0","eslint-plugin-import":"^2.26.0","eslint-plugin-jsdoc":"^37.9.1","eslint-plugin-node":"^11.1.0","eslint-plugin-prettier":"^4.0.0","eslint-plugin-promise":"^6.0.1",husky:"^7.0.4",jest:"^28.1.3","jest-environment-jsdom":"^28.1.3",prettier:"^2.4.0",rimraf:"^5.0.0","semantic-release":"^21.0.3","ts-jest":"^28.0.0","ts-node":"^10.9.1",tsup:"^6.7.0",typedoc:"^0.22.11",typescript:"^4.4.3"},engines:{node:">=18"}};var qn=`
XX    XX MM    MM TTTTTT PPPPPP   DDDDD   EEEEEEE VV     VV 
 XX  XX  MMM  MMM   TT   PP   PP  DD  DD  EE      VV     VV 
  XXXX   MM MM MM   TT   PPPPPP   DD   DD EEEEE    VV   VV  
 XX  XX  MM    MM   TT   PP       DD   DD EE        VV VV   
XX    XX MM    MM   TT   PP       DDDDDD  EEEEEEE    VVV    

Connected to the XMTP 'dev' network. Use 'production' for production messages.
https://github.com/xmtp/xmtp-js#xmtp-production-and-dev-network-environments
`;var {MessageApi:Cr$1,SortDirection:le$2}=messageApi,Fr=100,ss$2=16,os$2="X-Client-Version",as$2="X-App-Version",pt$2={local:"http://localhost:5555",dev:"https://dev.xmtp.network",production:"https://production.xmtp.network"};var qe$2=class qe extends Error{code;constructor(e,t){super(e),this.code=t;}static fromObject(e){return new qe$2(e.message,e.code)}},cs$1=i=>i?!!(i.name==="AbortError"||i.message.includes("aborted")):!1,ps$1=i=>!!(i&&"code"in i&&i.code===ss$2),zn=i=>!ps$1(i),ke$2=class ke{pathPrefix;maxRetries;authCache;appVersion;version;constructor(e,t){this.pathPrefix=e,this.maxRetries=t?.maxRetries||5,this.appVersion=t?.appVersion,this.version="xmtp-js/"+Hn.version,e===pt$2.dev&&console.info(qn);}async _query(e){try{return await rt$2(Cr$1.Query,[e,{pathPrefix:this.pathPrefix,mode:"cors",headers:this.headers()}],this.maxRetries,Fr)}catch(t){throw qe$2.fromObject(t)}}_batchQuery(e){return rt$2(Cr$1.BatchQuery,[e,{pathPrefix:this.pathPrefix,mode:"cors",headers:this.headers()}],this.maxRetries,Fr)}async _publish(e,t=0){let r=await this.getToken(),s=this.headers();s.set("Authorization",`Bearer ${r}`);try{return await rt$2(Cr$1.Publish,[e,{pathPrefix:this.pathPrefix,mode:"cors",headers:s}],this.maxRetries,Fr,zn)}catch(o){if(zn(o)||t>=1)throw qe$2.fromObject(o);return await this.authCache?.refresh(),this._publish(e,t+1)}}_subscribe(e,t,r){let s=new AbortController;return (async()=>{for(;;){let a=new Date().getTime();try{if(await Cr$1.Subscribe(e,t,{pathPrefix:this.pathPrefix,signal:s.signal,mode:"cors",headers:this.headers()}),s.signal.aborted)return;console.info("Stream connection closed. Resubscribing"),new Date().getTime()-a<1e3&&await hr$2(1e3),r?.();}catch(c){if(cs$1(c)||s.signal.aborted)return;console.info("Stream connection closed. Resubscribing",c.toString()),new Date().getTime()-a<1e3&&await hr$2(1e3),r?.();}}})(),async()=>{s?.abort();}}async query(e,{direction:t=le$2.SORT_DIRECTION_ASCENDING,limit:r}){let s=[];for await(let o of this.queryIteratePages(e,{direction:t,pageSize:r&&r<100?r:100}))for(let a of o)if(s.push(a),r&&s.length===r)return s;return s}async*queryIterator(e,t){for await(let r of this.queryIteratePages(e,t))for(let s of r)yield s;}async*queryIteratePages({contentTopic:e,startTime:t,endTime:r},{direction:s,pageSize:o=10}){if(!e||!e.length)throw new Error("Must specify content topics");let a=oe$3(t),c=oe$3(r),p;for(;;){let m={limit:o,direction:s,cursor:p},l=await this._query({contentTopics:[e],startTimeNs:a,endTimeNs:c,pagingInfo:m});if(l.envelopes?.length)yield l.envelopes;else return;if(l.pagingInfo?.cursor)p=l.pagingInfo?.cursor;else return}}async batchQuery(e){let r=[];for(let a=0;a<e.length;a+=50){let c=e.slice(a,a+50),p=[];for(let l of c)p.push({contentTopics:[l.contentTopic],startTimeNs:oe$3(l.startTime),endTimeNs:oe$3(l.endTime),pagingInfo:{limit:l.pageSize||10,direction:l.direction||le$2.SORT_DIRECTION_ASCENDING}});let m={requests:p};r.push(m);}let s=await Promise.all(r.map(async a=>this._batchQuery(a))),o=[];for(let a of s){if(!a.responses)throw new Error("BatchQueryResponse missing responses");for(let c of a.responses)c.envelopes?o.push(c.envelopes):o.push([]);}return o}async publish(e){let t=[];for(let{contentTopic:r,message:s,timestamp:o}of e){if(!r.length)throw new Error("Content topic cannot be empty string");if(!s.length)throw new Error("0 length messages not allowed");let a=o||new Date;t.push({contentTopic:r,timestampNs:oe$3(a),message:Uint8Array.from(s)});}return this._publish({envelopes:t})}subscribe(e,t,r){if(!e.contentTopics.length)throw new Error("Must provide list of contentTopics to subscribe to");return this._subscribe(e,t,r)}getToken(){if(!this.authCache)throw new Error("AuthCache is not set on API Client");return this.authCache.getToken()}setAuthenticator(e,t){this.authCache=new ct$2(e,t);}headers(){let e=new Headers;return e.set(os$2,this.version),this.appVersion&&e.set(as$2,this.appVersion),e}};var $n=1e4,Xn=i=>!!(i.recipientAddress&&i.senderAddress),Hr=class{conversations;mutex;latestSeen;seenTopics;constructor(){this.conversations=[],this.mutex=new Mutex$3,this.seenTopics=new Set;}async load(e){let t=await this.mutex.acquire();try{let r=await e({latestSeen:this.latestSeen,existing:this.conversations});for(let s of r)this.seenTopics.has(s.topic)||(this.seenTopics.add(s.topic),this.conversations.push(s),(!this.latestSeen||s.createdAt>this.latestSeen)&&(this.latestSeen=s.createdAt));}finally{t();}return [...this.conversations]}list(){return [...this.conversations]}},Te$1=class Te{client;v1Cache;v2Mutex;constructor(e){this.client=e,this.v1Cache=new Hr,this.v2Mutex=new Mutex$3;}async list(){let[e,t]=await Promise.all([this.listV1Conversations(),this.listV2Conversations()]),r=e.concat(t);return r.sort((s,o)=>s.createdAt.getTime()-o.createdAt.getTime()),r}async listFromCache(){let e=this.v1Cache.list(),t=await this.getV2ConversationsFromKeystore(),r=e.concat(t);return r.sort((s,o)=>s.createdAt.getTime()-o.createdAt.getTime()),r}async listV1Conversations(){return this.v1Cache.load(async({latestSeen:e})=>{let t=await this.getIntroductionPeers({startTime:e?new Date(+e-$n):void 0,direction:le$2.SORT_DIRECTION_ASCENDING});return Array.from(t).map(([r,s])=>new X$3(this.client,r,s))})}async listV2Conversations(){return this.v2Mutex.runExclusive(async()=>{let e=await this.getV2ConversationsFromKeystore(),t=e.reduce((o,a)=>!o||+a.createdAt>+o.createdAt?a:o,void 0),r=await this.updateV2Conversations(t?.createdAt),s=new Set(e.map(o=>o.topic));for(let o of r)s.has(o.topic)||(e.push(o),s.add(o.topic));return e.sort((o,a)=>o.createdAt.getTime()-a.createdAt.getTime()),e})}async getV2ConversationsFromKeystore(){return (await this.client.keystore.getV2Conversations()).map(this.conversationReferenceToV2.bind(this))}async updateV2Conversations(e){let t=await this.client.listInvitations({startTime:e?new Date(+e-$n):void 0,direction:le$2.SORT_DIRECTION_ASCENDING});return this.decodeInvites(t)}async decodeInvites(e,t=!1){let{responses:r}=await this.client.keystore.saveInvites({requests:e.map(o=>({payload:ae$3(o.message),timestampNs:Long.fromString(o.timestampNs),contentTopic:o.contentTopic}))}),s=[];for(let o of r)try{let a=this.saveInviteResponseToConversation(o);s.push(a);}catch(a){if(console.warn("Error saving invite response to conversation: ",a),t)throw a}return s}saveInviteResponseToConversation({result:e,error:t}){if(t||!e||!e.conversation)throw new Error(`Error from keystore: ${t?.code} ${t?.message}}`);return this.conversationReferenceToV2(e.conversation)}conversationReferenceToV2(e){return new te$2(this.client,e.topic,e.peerAddress,j$6(e.createdNs),e.context)}async stream(e){let t=new Set,r=se$2(this.client.address),s=fe$1(this.client.address),o=c=>t.has(c)?!1:(t.add(c),!0),a=async c=>{if(c.contentTopic===r){let p=ae$3(c.message),m=await F$4.fromBytes(p),l=this.getPeerAddress(m);return o(l)?(await m.decrypt(this.client.keystore,this.client.publicKeyBundle),new X$3(this.client,l,m.sent)):void 0}if(c.contentTopic===s){let p=await this.decodeInvites([c],!0);if(p.length)return p[0]}throw new Error("unrecognized invite topic")};return _$7.create(this.client,[s,r],a.bind(this),void 0,e)}async streamAllMessages(e){let t=se$2(this.client.address),r=fe$1(this.client.address),s=new Set([t,r]),o=new Map;for(let l of await this.list())s.add(l.topic),o.set(l.topic,l);let a=async l=>{let b=l.contentTopic;if(!b)return null;if(b===t){let Ee=ae$3(l.message),M=await F$4.fromBytes(Ee);if(!Xn(M))return null;let xe=this.getPeerAddress(M);return new X$3(this.client,xe,M.sent).decodeMessage(l)}if(b===r)return (await this.decodeInvites([l],!0))[0];let T=o.get(b);if(T instanceof X$3||T instanceof te$2)return T.decodeMessage(l);throw console.log("Unknown topic"),new Error("Unknown topic")},c=(l,b)=>s.has(l)?!1:(o.set(l,b),s.add(l),!0),p=l=>{if(l instanceof O$5&&l.contentTopic===t){let b=new X$3(this.client,l.recipientAddress===this.client.address?l.senderAddress:l.recipientAddress,l.sent);return c(b.topic,b)?Array.from(s.values()):void 0}if(l instanceof te$2)return c(l.topic,l)?Array.from(s.values()):void 0},m=await _$7.create(this.client,Array.from(s.values()),a,p,e);return async function*(){for await(let b of m)if(b instanceof O$5&&(yield b),b instanceof te$2)for(let T of await b.messages())yield T;}()}async getIntroductionPeers(e){let t=se$2(this.client.address),r=await this.client.listEnvelopes(t,o=>F$4.fromBytes(ae$3(o.message)),e),s=new Map;for(let o of r){if(!Xn(o))continue;let a=this.getPeerAddress(o);if(a){let c=s.get(a);if(!c||c>o.sent)try{await o.decrypt(this.client.keystore,this.client.publicKeyBundle),s.set(a,o.sent);}catch{continue}}}return s}async newConversation(e,t){let r=await this.client.getUserContact(e);if(!r)throw new Error(`Recipient ${e} is not on the XMTP network`);if(e===this.client.address)throw new Error("self messaging not supported");if(r instanceof P$5&&!t?.conversationId)return new X$3(this.client,e,new Date);if(!t?.conversationId){let a=(await this.listV1Conversations()).find(c=>c.peerAddress===e);if(a){if(!this.client.signedPublicKeyBundle.isFromLegacyBundle())throw new Error("cannot resume pre-existing V1 conversation; client keys not compatible");if(!(r instanceof P$5)&&!r.isFromLegacyBundle())throw new Error("cannot resume pre-existing V1 conversation; peer keys not compatible");return a}}r instanceof P$5&&(r=K$7.fromLegacyBundle(r));let s=o=>o.peerAddress===e&&us$1(t,o.context??void 0);return this.v2Mutex.runExclusive(async()=>{let o=await this.getV2ConversationsFromKeystore(),a=o.find(s);if(a)return a;let c=o[o.length-1]?.createdAt,m=(await this.updateV2Conversations(c)).find(s);return m||this.createV2Convo(r,t)})}async createV2Convo(e,t){let r=new Date,{payload:s,conversation:o}=await this.client.keystore.createInvite({recipient:e,context:t,createdNs:V$3(r)});if(!s||!o)throw new Error("Required field not returned from Keystore");let a=await e.walletSignatureAddress();return await this.client.publishEnvelopes([{contentTopic:fe$1(a),message:s,timestamp:r},{contentTopic:fe$1(this.client.address),message:s,timestamp:r}]),this.conversationReferenceToV2(o)}getPeerAddress(e){return e.recipientAddress===this.client.address?e.senderAddress:e.recipientAddress}};function us$1(i,e){return i?.conversationId===e?.conversationId}function Ar(i){let e;try{e=ContactBundle.decode(i);}catch{let r=PublicKeyBundle.decode(i);e={v1:{keyBundle:new P$5(r)},v2:void 0};}if(e.v1?.keyBundle)return new P$5(e.v1.keyBundle);if(e.v2?.keyBundle)return new K$7(e.v2.keyBundle);throw new Error("unknown or invalid contact bundle")}function Gn(i){return i instanceof P$5?ContactBundle.encode({v1:{keyBundle:i},v2:void 0}).finish():ContactBundle.encode({v1:void 0,v2:{keyBundle:i}}).finish()}var Jn=gn(jn(),1);var re$5=class re{walletAddr;createdNs;constructor({walletAddr:e,createdNs:t}){this.walletAddr=e,this.createdNs=t;}static create(e,t){return t=t||new Date,new re$5({walletAddr:e,createdNs:V$3(t)})}static fromBytes(e){let t=AuthData.decode(e);return new re$5(t)}toBytes(){return AuthData.encode(this).finish()}};var ne$2=class ne{identityKey;authDataBytes;authDataSignature;_authData;constructor({identityKey:e,authDataBytes:t,authDataSignature:r}){if(!e)throw new Error("Missing identity key in token");if(!r)throw new Error("Missing authDataSignature in token");this.identityKey=e,this.authDataBytes=t,this.authDataSignature=r;}get authData(){return this._authData||(this._authData=re$5.fromBytes(this.authDataBytes)),this._authData}get ageMs(){let e=new Date().valueOf(),r=this.authData.createdNs.div(1e6).toNumber();return e-r}toBytes(){return Token.encode(this).finish()}static fromBytes(e){return new ne$2(Token.decode(e))}toBase64(){return Buffer.from(this.toBytes()).toString("base64")}};var Pe$1=class Pe{identityKey;constructor(e){if(!e.publicKey.signature)throw new Error("Provided public key is not signed");this.identityKey=e;}async createToken(e){let r=re$5.create(this.identityKey.publicKey.walletSignatureAddress(),e||new Date).toBytes(),s=(0, Jn.keccak256)(r),o=await this.identityKey.sign(z$4(s));return new ne$2(Token.fromPartial({identityKey:PublicKey.fromPartial(this.identityKey.publicKey),authDataBytes:r,authDataSignature:Signature$5.fromPartial(o)}))}};var fs$1=i=>i instanceof ne$2?i:new ne$2(i),ze$2=class ze{keystore;constructor(e){this.keystore=e;}async createToken(e){let t=await this.keystore.createAuthToken({timestampNs:e?V$3(e):void 0});return fs$1(t)}};var Zn=0,$e$2=class $e{configuration;static createConfiguration(){return {type:Zn,version:0}}constructor(e){this.configuration=e;}get backupType(){return Zn}};var ei=1,Xe$1=class Xe{configuration;static createConfiguration(e){return {type:ei,version:0,topic:"history-v0:"+e}}constructor(e){this.configuration=e;}get backupType(){return ei}};async function ti(i,e){let t=await gs$1(i,e);switch(t.type){case 0:return new $e$2(t);case 1:return new Xe$1(t)}}async function gs$1(i,e){let t;switch((await e()).type){case 0:t=$e$2.createConfiguration();break;case 1:t=Xe$1.createConfiguration(i);break}return t}var ie$2=class ie extends Error{};var {b64Decode:bs$1}=fetcher,Ce$1=class Ce{topic;context;aes256GcmHkdfSha256;constructor({topic:e,context:t,aes256GcmHkdfSha256:r}){if(!e||!e.length)throw new Error("Missing topic");if(!r||!r.keyMaterial||!r.keyMaterial.length)throw new Error("Missing key material");this.topic=e,this.context=t,this.aes256GcmHkdfSha256=r;}static createRandom(e){let t=et$2(Buffer.from(k$3.getRandomValues(new Uint8Array(32))).toString("base64").replace(/=*$/g,"").replace("/","-")),r=k$3.getRandomValues(new Uint8Array(32));return new Ce$1({topic:t,aes256GcmHkdfSha256:{keyMaterial:r},context:e})}toBytes(){return InvitationV1.encode(this).finish()}static fromBytes(e){return new Ce$1(InvitationV1.decode(e))}},We$2=class We{sender;recipient;createdNs;constructor({sender:e,recipient:t,createdNs:r}){if(!e)throw new Error("Missing sender");if(!t)throw new Error("Missing recipient");this.sender=new K$7(e),this.recipient=new K$7(t),this.createdNs=r;}toBytes(){return SealedInvitationHeaderV1.encode(this).finish()}static fromBytes(e){return new We$2(SealedInvitationHeaderV1.decode(e))}},dt$2=class dt{headerBytes;ciphertext;_header;_invitation;constructor({headerBytes:e,ciphertext:t}){if(!e||!e.length)throw new Error("Missing header bytes");if(!t)throw new Error("Missing ciphertext");this.headerBytes=e,this.ciphertext=new U$3(t);}get header(){return this._header?this._header:(this._header=We$2.fromBytes(this.headerBytes),this._header)}async getInvitation(e){if(this._invitation)return this._invitation;let t=this.header,r;e.identityKey.matches(this.header.sender.identityKey)?r=await e.sharedSecret(t.recipient,t.sender.preKey,!1):r=await e.sharedSecret(t.sender,t.recipient.preKey,!0);let s=await H$5(this.ciphertext,r,this.headerBytes);return this._invitation=Ce$1.fromBytes(s),this._invitation}toBytes(){return SealedInvitationV1.encode(this).finish()}static fromBytes(e){return new dt$2(SealedInvitationV1.decode(e))}},pe$2=class pe{v1;constructor({v1:e}){if(e)this.v1=new dt$2(e);else throw new Error("Missing v1 or v2 invitation")}toBytes(){return SealedInvitation.encode(this).finish()}static fromBytes(e){return new pe$2(SealedInvitation.decode(e))}static async fromEnvelope(e){if(!e.message||!e.timestampNs)throw new Error("invalid invitation envelope");let t=pe$2.fromBytes(bs$1(e.message)),r=Long.fromString(e.timestampNs),s=t.v1?.header.createdNs;if(!s||!s.equals(r))throw new Error("envelope and header timestamp mistmatch");return t}static async createV1({sender:e,recipient:t,created:r,invitation:s}){let o=new We$2({sender:e.getPublicKeyBundle(),recipient:t,createdNs:V$3(r)}).toBytes(),a=await e.sharedSecret(t,e.getCurrentPreKey().publicKey,!1),c=s.toBytes(),p=await Q$3(c,a,o);return new pe$2({v1:{headerBytes:o,ciphertext:p}})}};var ri=async(i,e,t,r,s)=>{let o=await i.sharedSecret(e,i.getCurrentPreKey().publicKey,!s);return H$5(t,o,r)},ni=async(i,e,t,r)=>{let s=await i.sharedSecret(e,i.getCurrentPreKey().publicKey,!1);return Q$3(t,s,r)},ii=(i,e,t)=>H$5(i,e,t),si=(i,e,t)=>Q$3(i,e,t);var Xr=(i,e)=>i instanceof x$3?i:new x$3(e,i.message),Ps$1=i=>({result:i}),Ge$2=(i,e,t)=>Promise.all(i.map(async r=>{try{return Ps$1(await e(r))}catch(s){return {error:Xr(s,t)}}})),Wr=i=>i instanceof P$5?i:new P$5(i),oi=i=>i instanceof K$7?i:new K$7(i),Me$2=(i,e,t)=>{for(let r of e)if(!i[r])throw new x$3(ErrorCode.ERROR_CODE_INVALID_INPUT,`Missing field ${String(r)}`);for(let r of t){let s=i[r];if(!s||!s?.length)throw new x$3(ErrorCode.ERROR_CODE_INVALID_INPUT,`Missing field ${String(r)}`)}return !0},Gr=i=>{if(!i?.aes256GcmHkdfSha256?.keyMaterial)throw new x$3(ErrorCode.ERROR_CODE_INVALID_INPUT,"Missing key material");return i.aes256GcmHkdfSha256.keyMaterial},xr=({invitation:i,createdNs:e,peerAddress:t})=>({context:i.context,topic:i.topic,peerAddress:t,createdNs:e}),Ks$1=i=>!!i.invitation,ai=i=>{let e={};for(let[t,r]of Object.entries(i.topics))Ks$1(r)?e[t]=r:console.warn("Invitation missing from topic data");return e};var pi="invitations/v1",me$1=class me{persistence;mutex;topicMap;constructor(e,t=new Map){this.persistence=e,this.mutex=new Mutex$3,this.topicMap=t;}static async create(e){if(e){let t=await e.getItem(pi);if(t)try{let r=ai(TopicMap.decode(t));return new me$1(e,new Map(Object.entries(r)))}catch(r){console.warn(`Error loading invites from store: ${r}`);}}return new me$1(e)}async add(e){await this.mutex.runExclusive(async()=>{let t=!1;for(let r of e)this.topicMap.has(r.invitation.topic)||(this.topicMap.set(r.invitation.topic,r),t=!0);t&&this.persistence&&await this.persistence.setItem(pi,this.toBytes());});}get topics(){return [...this.topicMap.values()]}lookup(e){return this.topicMap.get(e)}toBytes(){return TopicMap.encode({topics:Object.fromEntries(this.topicMap)}).finish()}};var Es$1=As$1.ec,Qr=new Es$1("secp256k1"),ut$2=k$3.subtle,xs$1=Buffer.from("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141","hex"),Bs$1=Buffer.alloc(32,0);function de$2(i,e){if(!i)throw new Error(e||"Assertion failed")}function Ss$1(i){return Buffer.isBuffer(i)&&i.length===32}function Yr(i){return Ss$1(i)?i.compare(Bs$1)>0&&i.compare(xs$1)<0:!1}function ks$1(i,e){if(i.length!==e.length)return !1;let t=0;for(let r=0;r<i.length;r++)t|=i[r]^e[r];return t===0}function jr(i){let e=new Uint8Array(i);return k$3.getRandomValues(e),Buffer.from(e)}async function di(i){let e=await ut$2.digest("SHA-512",i);return Buffer.from(e)}function ui(i){return function(e,t,r){return new Promise(function(s){let o={name:"AES-CBC"};return ut$2.importKey("raw",t,o,!1,[i]).then(function(c){let p={name:"AES-CBC",iv:e};return ut$2[i](p,c,r)}).then(function(c){s(Buffer.from(new Uint8Array(c)));})})}}var Ts$1=ui("encrypt"),Ms$1=ui("decrypt");async function Br(i,e){let t=await ut$2.importKey("raw",i,{name:"HMAC",hash:{name:"SHA-256"}},!1,["sign"]);return Buffer.from(await ut$2.sign({name:"HMAC",hash:"SHA-256"},t,e))}async function Us$1(i,e,t){let r=await Br(i,e);return ks$1(r,t)}function Jr(i){return de$2(i.length===32,"Bad private key"),de$2(Yr(i),"Bad private key"),Buffer.from(Qr.keyFromPrivate(i).getPublic("array"))}function yi(i,e){return new Promise(function(t){de$2(Buffer.isBuffer(i),"Bad private key"),de$2(Buffer.isBuffer(e),"Bad public key"),de$2(i.length===32,"Bad private key"),de$2(Yr(i),"Bad private key"),de$2(e.length===65||e.length===33,"Bad public key"),e.length===65&&de$2(e[0]===4,"Bad public key"),e.length===33&&de$2(e[0]===2||e[0]===3,"Bad public key");let r=Qr.keyFromPrivate(i),s=Qr.keyFromPublic(e),o=r.derive(s.getPublic());t(Buffer.from(o.toArray()));})}async function li(i,e,t){t=t||{};let r=t?.iv||jr(16),s=t?.ephemPrivateKey||jr(32);for(;!Yr(s);){if(t?.ephemPrivateKey)throw new Error("ephemPrivateKey is not valid");s=jr(32);}let o=Jr(s),a=await di(await yi(s,i)),c=a.slice(0,32),p=a.slice(32),m=await Ts$1(r,c,e),l=Buffer.concat([r,o,m]),b=await Br(p,l);return {iv:r,ephemeralPublicKey:o,ciphertext:m,mac:b}}async function mi(i,e){let t=await yi(i,e.ephemeralPublicKey),r=await di(t),s=r.slice(0,32),o=r.slice(32),a=Buffer.concat([e.iv,e.ephemeralPublicKey,e.ciphertext]);return de$2(await Us$1(o,a,e.mac),"Bad mac"),Ms$1(e.iv,s,e.ciphertext)}var{ErrorCode:W$8}=keystore,Ds$1=new TextEncoder().encode("__XMTP__INVITATION__SALT__XMTP__");async function Is$1(i,e){let t=await k$3.subtle.importKey("raw",i,"HKDF",!1,["deriveKey"]);return k$3.subtle.deriveKey({name:"HKDF",hash:"SHA-256",salt:Ds$1,info:e},t,{name:"AES-GCM",length:256},!0,["encrypt","decrypt"])}var G$5=class G{v1Keys;v2Keys;inviteStore;authenticator;accountAddress;constructor(e,t){this.v1Keys=e,this.v2Keys=$$5.fromLegacyBundle(e),this.inviteStore=t,this.authenticator=new Pe$1(e.identityKey);}static async create(e,t){return new G$5(e,await me$1.create(t))}async decryptV1(e){let t=await Ge$2(e.requests,async r=>{if(!Me$2(r,["payload","peerKeys"],["headerBytes"]));let{payload:s,peerKeys:o,headerBytes:a,isSender:c}=r;return {decrypted:await ri(this.v1Keys,Wr(o),s,a,c)}},ErrorCode.ERROR_CODE_UNSPECIFIED);return DecryptResponse.fromPartial({responses:t})}async decryptV2(e){let t=await Ge$2(e.requests,async r=>{if(!Me$2(r,["payload"],["headerBytes"]));let{payload:s,headerBytes:o,contentTopic:a}=r,c=this.inviteStore.lookup(a);if(!c)throw new x$3(ErrorCode.ERROR_CODE_NO_MATCHING_PREKEY,"no topic key");return {decrypted:await ii(s,Gr(c.invitation),o)}},W$8.ERROR_CODE_UNSPECIFIED);return DecryptResponse.fromPartial({responses:t})}async encryptV1(e){let t=await Ge$2(e.requests,async r=>{if(!Me$2(r,["payload","recipient"],["headerBytes"]));let{recipient:s,payload:o,headerBytes:a}=r;return {encrypted:await ni(this.v1Keys,Wr(s),o,a)}},W$8.ERROR_CODE_UNSPECIFIED);return EncryptResponse.fromPartial({responses:t})}async createAuthToken({timestampNs:e}){return this.authenticator.createToken(e?j$6(e):void 0)}async encryptV2(e){let t=await Ge$2(e.requests,async r=>{if(!Me$2(r,["payload"],["headerBytes"]));let{payload:s,headerBytes:o,contentTopic:a}=r,c=this.inviteStore.lookup(a);if(!c)throw new x$3(W$8.ERROR_CODE_NO_MATCHING_PREKEY,"no topic key");return {encrypted:await si(s,Gr(c.invitation),o)}},W$8.ERROR_CODE_INVALID_INPUT);return EncryptResponse.fromPartial({responses:t})}async saveInvites(e){let t=[],r=await Ge$2(e.requests,async({payload:s,timestampNs:o})=>{let a=pe$2.fromBytes(s);if(a.v1){if(!a.v1.header.createdNs.equals(o))throw new Error("envelope and header timestamp mismatch");let p=a.v1.header.sender.equals(this.v2Keys.getPublicKeyBundle()),l={invitation:await a.v1.getInvitation(this.v2Keys),createdNs:a.v1.header.createdNs,peerAddress:p?await a.v1.header.recipient.walletSignatureAddress():await a.v1.header.sender.walletSignatureAddress()};return t.push(l),{conversation:xr(l)}}},W$8.ERROR_CODE_INVALID_INPUT);return await this.inviteStore.add(t),SaveInvitesResponse.fromPartial({responses:r})}async createInvite(e){try{if(!Me$2(e,["recipient"],[]));let t=j$6(e.createdNs),r=oi(e.recipient),s=await this.v2Keys.sharedSecret(r,this.v2Keys.getCurrentPreKey().publicKey,!1),o=[this.accountAddress,await r.walletSignatureAddress()].sort(),a=(e.context?.conversationId||"")+o.join(),c=new TextEncoder().encode(a),p=q$4(await Br(Buffer.from(s),Buffer.from(c))),m=["0",...o].join("|"),l=new TextEncoder().encode(m),b=await Is$1(s,l),T=new Uint8Array(await k$3.subtle.exportKey("raw",b)),Ee=new Ce$1({topic:et$2(p),aes256GcmHkdfSha256:{keyMaterial:T},context:e.context}),M=await pe$2.createV1({sender:this.v2Keys,recipient:r,created:t,invitation:Ee}),xe={invitation:Ee,createdNs:e.createdNs,peerAddress:await r.walletSignatureAddress()};return await this.inviteStore.add([xe]),CreateInviteResponse.fromPartial({conversation:xr(xe),payload:M.toBytes()})}catch(t){throw Xr(t,W$8.ERROR_CODE_INVALID_INPUT)}}async signDigest(e){if(!Me$2(e,["digest"],[]));let{digest:t,identityKey:r,prekeyIndex:s}=e,o;if(r)o=this.v1Keys.identityKey;else if(typeof s<"u"&&Number.isInteger(s)){if(o=this.v1Keys.preKeys[s],!o)throw new x$3(W$8.ERROR_CODE_NO_MATCHING_PREKEY,"no prekey found")}else throw new x$3(W$8.ERROR_CODE_INVALID_INPUT,"must specifify identityKey or prekeyIndex");return o.sign(t)}async getV2Conversations(){let e=this.inviteStore.topics.map(t=>xr(t));return e.sort((t,r)=>t.createdNs.div(1e6).sub(r.createdNs.div(1e6)).toNumber()),e}async getPublicKeyBundle(){return this.v1Keys.getPublicKeyBundle()}async getPrivateKeyBundle(){return this.v1Keys}async getAccountAddress(){return this.accountAddress||(this.accountAddress=await this.v2Keys.getPublicKeyBundle().walletSignatureAddress()),this.accountAddress}lookupTopic(e){return this.inviteStore.lookup(e)}};var Ue$2=class Ue{apiClient;constructor(e){this.apiClient=e;}async getItem(e){for await(let t of this.apiClient.queryIterator({contentTopic:this.buildTopic(e)},{pageSize:1,direction:SortDirection.SORT_DIRECTION_DESCENDING}))if(t.message)try{let r=ae$3(t.message.toString());return Uint8Array.from(r)}catch(r){console.log(r);}return null}async setItem(e,t){let r=Uint8Array.from(t);await this.apiClient.publish([{contentTopic:this.buildTopic(e),message:r}]);}setAuthenticator(e){this.apiClient.setAuthenticator(e);}buildTopic(e){return Dr$1(e)}};var yt$2=class yt{store;constructor(){this.store=new Map;}get length(){return this.store.size}clear(){this.store=new Map;}getItem(e){return this.validateString(e),this.store.has(e)?String(this.store.get(e)):null}key(e){if(e===void 0)throw new TypeError("Failed to execute 'key' on 'Storage': 1 argument required, but only 0 present.");let t=[...this.store.keys()];return e>=t.length?null:t[e]}removeItem(e){this.validateString(e),this.store.delete(e);}setItem(e,t){this.validateString(e),this.validateString(t),this.store.set(String(e),String(t));}validateString(e){if(typeof e!="string")throw new TypeError("Key must be a string")}};var De$1=class De{storage;constructor(){this.storage=typeof localStorage<"u"?localStorage:new yt$2;}async getItem(e){let t=this.storage.getItem(e);return t===null?null:Uint8Array.from(Buffer.from(t,"binary"))}async setItem(e,t){this.storage.setItem(e,Buffer.from(t).toString("binary"));}};var Ie$1=class Ie{prefix;persistence;constructor(e,t){this.prefix=e,this.persistence=t;}getItem(e){return this.persistence.getItem(this.buildKey(e))}setItem(e,t){return this.persistence.setItem(this.buildKey(e),t)}buildKey(e){return this.prefix+e}};var Ne$1=class Ne{persistence;privateKey;privateKeyBytes;publicKey;constructor(e,t){this.persistence=e,this.privateKey=t,this.privateKeyBytes=Buffer.from(t.secp256k1.bytes),this.publicKey=Jr(this.privateKeyBytes);}async getItem(e){let t=await this.persistence.getItem(e);return t?this.decrypt(t):null}async setItem(e,t){let r=await this.encrypt(t);await this.persistence.setItem(e,r);}async encrypt(e){let t=await li(this.publicKey,Buffer.from(e));return this.serializeEcies(t)}async decrypt(e){let t=await this.deserializeEcies(e),r=await mi(this.privateKeyBytes,t);return Uint8Array.from(r)}async serializeEcies(e){return (await ce$3.create(e,this.privateKey)).toBytes()}async deserializeEcies(e){let t=ce$3.fromBytes(e);if(!await t.verify(this.privateKey.publicKey))throw new Error("signature validation failed");let r=t.ciphertext;return {ciphertext:Buffer.from(r.ciphertext),mac:Buffer.from(r.mac),iv:Buffer.from(r.iv),ephemeralPublicKey:Buffer.from(r.ephemeralPublicKey)}}};var je$2=async(i,e)=>{if(!i.persistConversations)return;let t=await e.identityKey.publicKey.walletSignatureAddress(),r=`xmtp/${i.env}/${t}/`;return new Ie$1(r,new Ne$1(new De$1,e.identityKey))};var hi="key_bundle",Ve$2=class Ve{persistence;signer;preEnableIdentityCallback;constructor(e,t,r){this.signer=e,this.persistence=t,this.preEnableIdentityCallback=r;}async getStorageAddress(e){let t=await this.signer.getAddress();return t=getAddress(t),`${t}/${e}`}async loadPrivateKeyBundle(){let e=await this.persistence.getItem(await this.getStorageAddress(hi));if(!e)return null;let[t,r]=await this.fromEncryptedBytes(this.signer,Uint8Array.from(e));return r&&await this.storePrivateKeyBundle(t),t}async storePrivateKeyBundle(e){let t=await this.getStorageAddress(hi),r=await this.toEncryptedBytes(e,this.signer);typeof this.persistence.setAuthenticator=="function"&&this.persistence.setAuthenticator(new Pe$1(e.identityKey)),await this.persistence.setItem(t,r);}async toEncryptedBytes(e,t){let r=e.encode(),s=k$3.getRandomValues(new Uint8Array(32)),o=gi(s),a=await t.getAddress();this.preEnableIdentityCallback&&await this.preEnableIdentityCallback();let c=await t.signMessage(o),p=verifyMessage(o,c);if(p!==a&&(c=await t.signMessage(o),console.log("invalid signature, retrying"),p=verifyMessage(o,c),p!==a))throw new Error("invalid signature");let m=z$4(c),l=await Q$3(r,m);return EncryptedPrivateKeyBundle.encode({v1:{walletPreKey:s,ciphertext:l}}).finish()}async fromEncryptedBytes(e,t){let[r,s]=Vs$1(t);if(!r.walletPreKey)throw new Error("missing wallet pre-key");if(!r.ciphertext?.aes256GcmHkdfSha256)throw new Error("missing bundle ciphertext");this.preEnableIdentityCallback&&await this.preEnableIdentityCallback();let o=z$4(await e.signMessage(gi(r.walletPreKey)));try{let a=new U$3(r.ciphertext),c=await H$5(a,o),[p,m]=fi(c);return [p,s||m]}catch{if(o.length!==65)throw new Error("Expected 65 bytes before trying a different recovery byte");let c=o[o.length-1],p=o.slice(0,o.length-1);c<27?p=new Uint8Array([...p,c+27]):p=new Uint8Array([...p,c-27]);let m=new U$3(r.ciphertext),l=await H$5(m,p),[b,T]=fi(l);return [b,s||T]}}};function Vs$1(i){try{let e=EncryptedPrivateKeyBundle.decode(i);if(e.v1)return [e.v1,!1]}catch{return [EncryptedPrivateKeyBundleV1.decode(i),!0]}throw new Error("unrecognized encrypted private key bundle version")}function fi(i){try{let e=it$2(i);if(e instanceof $$5)throw new Error("V2 bundles not supported yet");return [e,!1]}catch{let t=PrivateKeyBundleV1.decode(i);return [new Z$3(t),!0]}}function gi(i){return `XMTP : Enable Identity
${q$4(i)}

For more info: https://xmtp.org/signatures/`}var Re$1=class Re{async newKeystore(e,t,r){if(!r)throw new ie$2("Wallet required to generate new keys");e.preCreateIdentityCallback&&await e.preCreateIdentityCallback();let s=await Z$3.generate(r);return await new Ve$2(r,new Ue$2(t),e.preEnableIdentityCallback).storePrivateKeyBundle(s),G$5.create(s,await je$2(e,s))}};var Oe$2=class Oe{async newKeystore(e,t,r){if(!r)throw new ie$2("No wallet provided");let o=await new Ve$2(r,new Ue$2(t),e.preEnableIdentityCallback).loadPrivateKeyBundle();if(!o)throw new ie$2("No keys found");return G$5.create(o,await je$2(e,o))}};var _e$1=class _e{async newKeystore(e){let{privateKeyOverride:t}=e;if(!t)throw new ie$2("No private key override provided");let r=it$2(t);if(r instanceof $$5)throw new Error("V2 private key bundle found. Only V1 supported");return G$5.create(r,await je$2(e,r))}};var {b64Decode:bi}=fetcher,Pi=100*1024*1024;function Ls$1(i){let e={privateKeyOverride:void 0,env:"dev",apiUrl:void 0,codecs:[new ot$3],maxContentSize:Pi,persistConversations:!0,skipContactPublishing:!1,keystoreProviders:Hs$1()};return i?.codecs&&(i.codecs=e.codecs.concat(i.codecs)),{...e,...i}}var Ae$2=class Ae{address;keystore;apiClient;contacts;publicKeyBundle;knownPublicKeyBundles;_backupClient;_conversations;_codecs;_maxContentSize;constructor(e,t,r,s){this.contacts=new Set,this.knownPublicKeyBundles=new Map,this.keystore=s,this.publicKeyBundle=e,this.address=e.walletSignatureAddress(),this._conversations=new Te$1(this),this._codecs=new Map,this._maxContentSize=Pi,this.apiClient=t,this._backupClient=r;}get conversations(){return this._conversations}get backupType(){return this._backupClient.backupType}get signedPublicKeyBundle(){return K$7.fromLegacyBundle(this.publicKeyBundle)}static async create(e,t){let r=Ls$1(t),s=Fs$1(r),o=await qs$1(r,s,e),a=new P$5(await o.getPublicKeyBundle()),c=a.walletSignatureAddress();s.setAuthenticator(new ze$2(o));let p=await Ae$2.setupBackupClient(c,r.env),m=new Ae$2(a,s,p,o);return await m.init(r),m}static async getKeys(e,t){let s=await(await Ae$2.create(e,t)).keystore.getPrivateKeyBundle();return new Z$3(s).encode()}static async setupBackupClient(e,t){return ti(e,async()=>Promise.resolve({type:t==="local"?1:0}))}async init(e){e.codecs.forEach(t=>{this.registerCodec(t);}),this._maxContentSize=e.maxContentSize,e.skipContactPublishing||await this.ensureUserContactPublished(e.publishLegacyContact);}async close(){}async ensureUserContactPublished(e=!1){let t=await en(this.apiClient,this.address);t&&t instanceof K$7&&this.signedPublicKeyBundle.equals(t)||(await this.publishUserContact(!0),e||await this.publishUserContact(e));}async publishUserContact(e=!1){let t=e?this.publicKeyBundle:this.signedPublicKeyBundle;await this.publishEnvelopes([{contentTopic:tt$2(this.address),message:Gn(t)}]);}async getUserContact(e){e=getAddress(e);let t=this.knownPublicKeyBundles.get(e);if(t)return t;let r=await en(this.apiClient,e);return r&&this.knownPublicKeyBundles.set(e,r),r}async getUserContacts(e){let t=e.map(a=>getAddress(a)),r=new Map,s=[];for(let a of t){let c=this.knownPublicKeyBundles.get(a);c?r.set(a,c):(r.set(a,void 0),s.push(a));}let o=await vi(this.apiClient,s);for(let a=0;a<o.length;a++){let c=s[a],p=o[a];r.set(c,p),p&&this.knownPublicKeyBundles.set(c,p);}return t.map(a=>r.get(a))}forgetContact(e){e=getAddress(e),this.knownPublicKeyBundles.delete(e);}async canMessage(e){try{return Array.isArray(e)?(await this.getUserContacts(e)).map(s=>!!s):await this.getUserContact(e)!==void 0}catch{return !1}}static async canMessage(e,t){let r=t?.apiUrl||pt$2[t?.env||"dev"];if(Array.isArray(e)){let a=e.map(p=>getAddress(p));return (await vi(new ke$2(r,{appVersion:t?.appVersion}),a)).map(p=>!!p)}try{e=getAddress(e);}catch{return !1}return await en(new ke$2(r,{appVersion:t?.appVersion}),e)!==void 0}validateEnvelope(e){let t=e.message;if(!e.contentTopic)throw new Error("Missing content topic");if(!t||!t.length)throw new Error("Cannot publish empty message")}async publishEnvelopes(e){for(let t of e)this.validateEnvelope(t);await this.apiClient.publish(e);}registerCodec(e){let t=e.contentType,r=`${t.authorityId}/${t.typeId}`;this._codecs.set(r,e);}codecFor(e){let t=`${e.authorityId}/${e.typeId}`,r=this._codecs.get(t);if(r&&!(e.versionMajor>r.contentType.versionMajor))return r}async encodeContent(e,t){let r=t?.contentType||we$1,s=this.codecFor(r);if(!s)throw new Error("unknown content type "+r);let o=s.encode(e,this);return t?.contentFallback&&(o.fallback=t.contentFallback),typeof t?.compression=="number"&&(o.compression=t.compression),await Rn(o),EncodedContent.encode(o).finish()}listInvitations(e){return this.listEnvelopes(fe$1(this.address),async t=>t,e)}async listEnvelopes(e,t,r){r||(r={});let{startTime:s,endTime:o,limit:a}=r,c=await this.apiClient.query({contentTopic:e,startTime:s,endTime:o},{direction:r.direction||SortDirection.SORT_DIRECTION_ASCENDING,limit:a}),p=[];for(let m of c)if(m.message)try{let l=await t(m);p.push(l);}catch(l){console.warn("Error in listEnvelopes mapper",l);}return p}listEnvelopesPaginated(e,t,r){return Ir$1(this.apiClient.queryIteratePages({contentTopic:e,startTime:r?.startTime,endTime:r?.endTime},{direction:r?.direction,pageSize:r?.pageSize||100}),t)}};function Fs$1(i){let e=i.apiUrl||pt$2[i.env];return new ke$2(e,{appVersion:i.appVersion})}async function en(i,e){let t=i.queryIterator({contentTopic:tt$2(e)},{pageSize:5,direction:le$2.SORT_DIRECTION_DESCENDING});for await(let r of t){if(!r.message)continue;let s=Ar(bi(r.message.toString())),o;try{o=await s?.walletSignatureAddress();}catch{o=void 0;}if(o===e)return s}}async function vi(i,e){let t=e.map(tt$2),r=await i.batchQuery(t.map(s=>({contentTopic:s,pageSize:5,direction:le$2.SORT_DIRECTION_DESCENDING})));return Promise.all(e.map(async(s,o)=>{let a=r[o];if(a){for(let c of a)if(c.message)try{let p=Ar(bi(c.message.toString())),m=await p?.walletSignatureAddress();if(s===m)return p;console.info("Received contact bundle with incorrect address");}catch(p){console.info("Invalid contact bundle",p);}}}))}function Hs$1(){return [new _e$1,new Oe$2,new Re$1]}async function qs$1(i,e,t){for(let r of i.keystoreProviders)try{return await r.newKeystore(i,e,t??void 0)}catch(s){if(s instanceof ie$2)continue;throw s}throw new Error("No keystore providers available")}new R$3({authorityId:"xmtp.com",typeId:"typingNotification",versionMajor:1,versionMinor:0});new R$3({authorityId:"xmtp.org",typeId:"composite",versionMajor:1,versionMinor:0});/*! Bundled license information:

	js-sha3/src/sha3.js:
	  (**
	   * [js-sha3]{@link https://github.com/emn178/js-sha3}
	   *
	   * @version 0.8.0
	   * @author Chen, Yi-Cyuan [emn178@gmail.com]
	   * @copyright Chen, Yi-Cyuan 2015-2018
	   * @license MIT
	   *)
	*/

	/* dist/components/dialog-contents/SubscribeIntegrationSelected.svelte generated by Svelte v3.59.2 */

	function add_css$2(target) {
		append_styles(target, "svelte-np1oa7", ".connecting-provider.svelte-np1oa7{display:flex;flex-direction:column;gap:32px;font-weight:400;font-size:14px;line-height:20px;color:var(--dialog-text-color, #161b5d);margin:0 auto;align-items:center;justify-content:space-between}");
	}

	// (127:0) {:else}
	function create_else_block$1(ctx) {
		let percsdialogimageheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogimageheader = new PercsDialogImageHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Connecting…",
					image: /*subscribe*/ ctx[2].headingImage
				}
			});

		percsdialogimageheader.$on("close", /*close_handler_1*/ ctx[6]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "spaced full",
					$$slots: { default: [create_default_slot_3$1] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogimageheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogimageheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogimageheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogimageheader_changes.state = /*state*/ ctx[0];
				percsdialogimageheader.$set(percsdialogimageheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, $state*/ 515) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogimageheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogimageheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogimageheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	// (110:0) {#if selectedSubscriptionOption.type === "email"}
	function create_if_block$2(ctx) {
		let percsdialogimageheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogimageheader = new PercsDialogImageHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Subscribe to continue",
					image: /*subscribe*/ ctx[2].headingImage
				}
			});

		percsdialogimageheader.$on("close", /*close_handler*/ ctx[4]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "spaced full",
					$$slots: { default: [create_default_slot$5] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogimageheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogimageheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogimageheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogimageheader_changes.state = /*state*/ ctx[0];
				percsdialogimageheader.$set(percsdialogimageheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state, $state*/ 515) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogimageheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogimageheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogimageheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	// (139:6) <PercsButton variant="outlined" on:click={() => state.send("BACK")}>
	function create_default_slot_5(ctx) {
		let t;

		return {
			c() {
				t = text("Back");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (138:4) <PercsDialogActions modifiers="margins">
	function create_default_slot_4(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "outlined",
					$$slots: { default: [create_default_slot_5] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler_1*/ ctx[7]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 512) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (129:2) <PercsDialogContent modifiers="spaced full">
	function create_default_slot_3$1(ctx) {
		let div;
		let percsproviderlogo;
		let t0;
		let p;
		let t1;
		let t2_value = /*selectedSubscriptionOption*/ ctx[3].name + "";
		let t2;
		let t3;
		let br;
		let t4;
		let t5_value = /*$state*/ ctx[1].context.provider?.name + "";
		let t5;
		let t6;
		let t7;
		let percsdialogactions;
		let current;

		percsproviderlogo = new PercsProviderLogo({
				props: {
					src: /*selectedSubscriptionOption*/ ctx[3].logo
				}
			});

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_4] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				div = element("div");
				create_component(percsproviderlogo.$$.fragment);
				t0 = space();
				p = element("p");
				t1 = text("Connecting with ");
				t2 = text(t2_value);
				t3 = text(".\n        ");
				br = element("br");
				t4 = text("\n        Please check your ");
				t5 = text(t5_value);
				t6 = text(" notifications.");
				t7 = space();
				create_component(percsdialogactions.$$.fragment);
				attr(div, "class", "connecting-provider svelte-np1oa7");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				mount_component(percsproviderlogo, div, null);
				append(div, t0);
				append(div, p);
				append(p, t1);
				append(p, t2);
				append(p, t3);
				append(p, br);
				append(p, t4);
				append(p, t5);
				append(p, t6);
				insert(target, t7, anchor);
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if ((!current || dirty & /*$state*/ 2) && t5_value !== (t5_value = /*$state*/ ctx[1].context.provider?.name + "")) set_data(t5, t5_value);
				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state*/ 513) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsproviderlogo.$$.fragment, local);
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsproviderlogo.$$.fragment, local);
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div);
				destroy_component(percsproviderlogo);
				if (detaching) detach(t7);
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	// (124:6) <PercsButton variant="outlined" on:click={() => state.send("BACK")}>
	function create_default_slot_2$4(ctx) {
		let t;

		return {
			c() {
				t = text("Back");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (123:4) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$5(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "outlined",
					$$slots: { default: [create_default_slot_2$4] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[5]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 512) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (112:2) <PercsDialogContent modifiers="spaced full">
	function create_default_slot$5(ctx) {
		let div;
		let svg;
		let path;
		let t0;
		let p;
		let t1;
		let br;
		let t2;
		let t3_value = /*$state*/ ctx[1].context.provider?.name + "";
		let t3;
		let t4;
		let t5;
		let percsdialogactions;
		let current;

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$5] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				div = element("div");
				svg = svg_element("svg");
				path = svg_element("path");
				t0 = space();
				p = element("p");
				t1 = text("Subscribing with Email.\n        ");
				br = element("br");
				t2 = text("\n        Please check your ");
				t3 = text(t3_value);
				t4 = text(" notifications.");
				t5 = space();
				create_component(percsdialogactions.$$.fragment);
				attr(path, "stroke-linecap", "round");
				attr(path, "stroke-linejoin", "round");
				attr(path, "d", "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75");
				attr(svg, "class", "button__icon");
				attr(svg, "xmlns", "http://www.w3.org/2000/svg");
				attr(svg, "fill", "none");
				attr(svg, "viewBox", "0 0 24 24");
				attr(svg, "stroke-width", "1.5");
				attr(svg, "stroke", "currentColor");
				attr(div, "class", "connecting-provider svelte-np1oa7");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				append(div, svg);
				append(svg, path);
				append(div, t0);
				append(div, p);
				append(p, t1);
				append(p, br);
				append(p, t2);
				append(p, t3);
				append(p, t4);
				insert(target, t5, anchor);
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				if ((!current || dirty & /*$state*/ 2) && t3_value !== (t3_value = /*$state*/ ctx[1].context.provider?.name + "")) set_data(t3, t3_value);
				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state*/ 513) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div);
				if (detaching) detach(t5);
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	function create_fragment$6(ctx) {
		let current_block_type_index;
		let if_block;
		let if_block_anchor;
		let current;
		const if_block_creators = [create_if_block$2, create_else_block$1];
		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (/*selectedSubscriptionOption*/ ctx[3].type === "email") return 0;
			return 1;
		}

		current_block_type_index = select_block_type(ctx);
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

		return {
			c() {
				if_block.c();
				if_block_anchor = empty$3();
			},
			m(target, anchor) {
				if_blocks[current_block_type_index].m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				if_block.p(ctx, dirty);
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				if_blocks[current_block_type_index].d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	function instance$7($$self, $$props, $$invalidate) {
		let $wallet;

		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(1, $state = $$value)), state);

		component_subscribe($$self, wallet$1, $$value => $$invalidate(8, $wallet = $$value));
		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		if (!$state.context.subscribe || !$state.context.selectedSubscriptionOption) {
			throw new Error("selectedSubscriptionOption not initialized");
		}

		const { subscribe, selectedSubscriptionOption } = $state.context;

		onMount(async () => {
			switch (selectedSubscriptionOption.type) {
				case "email":
					{
						try {
							const { verificationMessage } = selectedSubscriptionOption.settings;
							const signer = await getWalletClient();

							if (signer == null) {
								throw new Error("no signer available");
							}

							const message = verificationMessage.replaceAll("{email}", selectedSubscriptionOption.values.email);
							const signature = await signer.signMessage({ message });

							await callApiRpc("createSubscription", {
								type: selectedSubscriptionOption.type,
								address: signer.account.address.toLowerCase(),
								message,
								signature,
								values: selectedSubscriptionOption.values
							});

							state.send("SUBSCRIBE");
						} catch(err) {
							console.error(err);

							if (err instanceof Error) {
								state.send("ERROR", { message: err.message });
							}
						}

						break;
					}
				case "xmtp_messaging":
					{
						try {
							const { verificationMessage, network, sender } = selectedSubscriptionOption.settings;
							const connectorChainId = await $wallet.connector.getChainId();

							if (network.chainId != null && connectorChainId !== network.chainId) {
								await $wallet.connector.switchChain(network.chainId);
							}

							const signer = await getWalletClient();

							if (signer == null) {
								throw new Error("no signer available");
							}

							const mappedSigner = new MappedSigner(signer);
							const xmtp = await Ae$2.create(mappedSigner, { env: network.env });
							const canMessage = await xmtp.canMessage(sender.address);

							if (!canMessage) {
								throw new Error("Registration with xmtp failed");
							}

							const signature = await signer.signMessage({ message: verificationMessage });

							await callApiRpc("createSubscription", {
								type: selectedSubscriptionOption.type,
								address: signer.account.address.toLowerCase(),
								message: verificationMessage,
								signature
							});

							state.send("SUBSCRIBE");
						} catch(err) {
							if (err instanceof Error) {
								state.send("ERROR", { message: err.message });
							} else {
								console.error(err);
							}
						}

						break;
					}
			} // No action required
		});

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("BACK");

		function close_handler_1(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler_1 = () => state.send("BACK");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [
			state,
			$state,
			subscribe,
			selectedSubscriptionOption,
			close_handler,
			click_handler,
			close_handler_1,
			click_handler_1
		];
	}

	class SubscribeIntegrationSelected extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$7, create_fragment$6, safe_not_equal, { state: 0 }, add_css$2);
		}
	}

	/* dist/components/dialog-contents/SubscribeIntegrationError.svelte generated by Svelte v3.59.2 */

	function create_default_slot_3(ctx) {
		let t;

		return {
			c() {
				t = text("Retry");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (18:4) <PercsButton on:click={() => state.send("BACK")}>
	function create_default_slot_2$3(ctx) {
		let t;

		return {
			c() {
				t = text("Back");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (16:2) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$4(ctx) {
		let percsbutton0;
		let t;
		let percsbutton1;
		let current;

		percsbutton0 = new PercsButton({
				props: {
					variant: "contained",
					$$slots: { default: [create_default_slot_3] },
					$$scope: { ctx }
				}
			});

		percsbutton0.$on("click", /*click_handler*/ ctx[3]);

		percsbutton1 = new PercsButton({
				props: {
					$$slots: { default: [create_default_slot_2$3] },
					$$scope: { ctx }
				}
			});

		percsbutton1.$on("click", /*click_handler_1*/ ctx[4]);

		return {
			c() {
				create_component(percsbutton0.$$.fragment);
				t = space();
				create_component(percsbutton1.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton0, target, anchor);
				insert(target, t, anchor);
				mount_component(percsbutton1, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton0_changes = {};

				if (dirty & /*$$scope*/ 32) {
					percsbutton0_changes.$$scope = { dirty, ctx };
				}

				percsbutton0.$set(percsbutton0_changes);
				const percsbutton1_changes = {};

				if (dirty & /*$$scope*/ 32) {
					percsbutton1_changes.$$scope = { dirty, ctx };
				}

				percsbutton1.$set(percsbutton1_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton0.$$.fragment, local);
				transition_in(percsbutton1.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton0.$$.fragment, local);
				transition_out(percsbutton1.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton0, detaching);
				if (detaching) detach(t);
				destroy_component(percsbutton1, detaching);
			}
		};
	}

	// (12:0) <PercsDialogContent modifiers="spaced full">
	function create_default_slot$4(ctx) {
		let p;
		let t1;
		let percsdialogactions;
		let current;

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$4] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				p = element("p");
				p.textContent = "There was an error subscribing with your wallet, please try again.";
				t1 = space();
				create_component(percsdialogactions.$$.fragment);
			},
			m(target, anchor) {
				insert(target, p, anchor);
				insert(target, t1, anchor);
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state*/ 33) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(p);
				if (detaching) detach(t1);
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	function create_fragment$5(ctx) {
		let percsdialogimageheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogimageheader = new PercsDialogImageHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Error",
					image: /*$state*/ ctx[1].context.subscribe.headingImage
				}
			});

		percsdialogimageheader.$on("close", /*close_handler*/ ctx[2]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "spaced full",
					$$slots: { default: [create_default_slot$4] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogimageheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogimageheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogimageheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogimageheader_changes.state = /*state*/ ctx[0];
				if (dirty & /*$state*/ 2) percsdialogimageheader_changes.image = /*$state*/ ctx[1].context.subscribe.headingImage;
				percsdialogimageheader.$set(percsdialogimageheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state*/ 33) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogimageheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogimageheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogimageheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$6($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(1, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("RETRY");
		const click_handler_1 = () => state.send("BACK");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [state, $state, close_handler, click_handler, click_handler_1];
	}

	class SubscribeIntegrationError extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$6, create_fragment$5, safe_not_equal, { state: 0 });
		}
	}

	/* dist/components/dialog-contents/SubscribeIntegrationSuccess.svelte generated by Svelte v3.59.2 */

	function create_default_slot_1$3(ctx) {
		let t;

		return {
			c() {
				t = text("Done");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (16:0) <PercsDialogContent modifiers="spaced full">
	function create_default_slot$3(ctx) {
		let p;
		let t1;
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					$$slots: { default: [create_default_slot_1$3] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[3]);

		return {
			c() {
				p = element("p");
				p.textContent = "Be on the lookout for new product drops and exclusive offers in your inbox!";
				t1 = space();
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				insert(target, p, anchor);
				insert(target, t1, anchor);
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 32) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(p);
				if (detaching) detach(t1);
				destroy_component(percsbutton, detaching);
			}
		};
	}

	function create_fragment$4(ctx) {
		let percsdialogimageheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogimageheader = new PercsDialogImageHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Thanks for signing up!",
					image: /*subscribe*/ ctx[1].headingImage
				}
			});

		percsdialogimageheader.$on("close", /*close_handler*/ ctx[2]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "spaced full",
					$$slots: { default: [create_default_slot$3] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogimageheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogimageheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogimageheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogimageheader_changes.state = /*state*/ ctx[0];
				percsdialogimageheader.$set(percsdialogimageheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state*/ 33) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogimageheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogimageheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogimageheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$5($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(4, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		if (!$state.context.subscribe) {
			throw new Error("subscribe not initialized");
		}

		const { subscribe } = $state.context;

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("MODAL_CLOSE");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [state, subscribe, close_handler, click_handler];
	}

	class SubscribeIntegrationSuccess extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$5, create_fragment$4, safe_not_equal, { state: 0 });
		}
	}

	/* dist/components/dialog-contents/SubscribeLoading.svelte generated by Svelte v3.59.2 */

	function create_default_slot_2$2(ctx) {
		let t;

		return {
			c() {
				t = text("Back");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (15:2) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$2(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "outlined",
					$$slots: { default: [create_default_slot_2$2] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[3]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 16) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (13:0) <PercsDialogContent modifiers="spaced full">
	function create_default_slot$2(ctx) {
		let percsverticalspacer;
		let t;
		let percsdialogactions;
		let current;
		percsverticalspacer = new PercsVerticalSpacer({});

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$2] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsverticalspacer.$$.fragment);
				t = space();
				create_component(percsdialogactions.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsverticalspacer, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state*/ 17) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsverticalspacer.$$.fragment, local);
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsverticalspacer.$$.fragment, local);
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsverticalspacer, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	function create_fragment$3(ctx) {
		let percsdialogimageheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogimageheader = new PercsDialogImageHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Loading",
					image: /*$state*/ ctx[1].context.subscribe.headingImage
				}
			});

		percsdialogimageheader.$on("close", /*close_handler*/ ctx[2]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "spaced full",
					$$slots: { default: [create_default_slot$2] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogimageheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogimageheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogimageheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogimageheader_changes.state = /*state*/ ctx[0];
				if (dirty & /*$state*/ 2) percsdialogimageheader_changes.image = /*$state*/ ctx[1].context.subscribe.headingImage;
				percsdialogimageheader.$set(percsdialogimageheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state*/ 17) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogimageheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogimageheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogimageheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$4($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(1, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("CONNECT");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [state, $state, close_handler, click_handler];
	}

	class SubscribeLoading extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$4, create_fragment$3, safe_not_equal, { state: 0 });
		}
	}

	/* dist/components/dialog-contents/SubscribeLoadingError.svelte generated by Svelte v3.59.2 */

	function create_default_slot_2$1(ctx) {
		let t;

		return {
			c() {
				t = text("Retry");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (16:2) <PercsDialogActions modifiers="margins">
	function create_default_slot_1$1(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "contained",
					$$slots: { default: [create_default_slot_2$1] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[3]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty & /*$$scope*/ 16) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (12:0) <PercsDialogContent modifiers="spaced">
	function create_default_slot$1(ctx) {
		let p;
		let t1;
		let percsdialogactions;
		let current;

		percsdialogactions = new PercsDialogActions({
				props: {
					modifiers: "margins",
					$$slots: { default: [create_default_slot_1$1] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				p = element("p");
				p.textContent = "There was an error loading the provider, please try again";
				t1 = space();
				create_component(percsdialogactions.$$.fragment);
			},
			m(target, anchor) {
				insert(target, p, anchor);
				insert(target, t1, anchor);
				mount_component(percsdialogactions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogactions_changes = {};

				if (dirty & /*$$scope, state*/ 17) {
					percsdialogactions_changes.$$scope = { dirty, ctx };
				}

				percsdialogactions.$set(percsdialogactions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogactions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogactions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(p);
				if (detaching) detach(t1);
				destroy_component(percsdialogactions, detaching);
			}
		};
	}

	function create_fragment$2(ctx) {
		let percsdialogimageheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogimageheader = new PercsDialogImageHeader({
				props: {
					state: /*state*/ ctx[0],
					text: "Error",
					image: /*$state*/ ctx[1].context.subscribe.headingImage
				}
			});

		percsdialogimageheader.$on("close", /*close_handler*/ ctx[2]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					modifiers: "spaced",
					$$slots: { default: [create_default_slot$1] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogimageheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogimageheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				const percsdialogimageheader_changes = {};
				if (dirty & /*state*/ 1) percsdialogimageheader_changes.state = /*state*/ ctx[0];
				if (dirty & /*$state*/ 2) percsdialogimageheader_changes.image = /*$state*/ ctx[1].context.subscribe.headingImage;
				percsdialogimageheader.$set(percsdialogimageheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty & /*$$scope, state*/ 17) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogimageheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogimageheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogimageheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	function instance$3($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(1, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => state.send("RETRY");

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
		};

		return [state, $state, close_handler, click_handler];
	}

	class SubscribeLoadingError extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$3, create_fragment$2, safe_not_equal, { state: 0 });
		}
	}

	/* dist/components/dialog-contents/DialogContainer.svelte generated by Svelte v3.59.2 */

	function add_css$1(target) {
		append_styles(target, "svelte-tmk0nh", ".dialog__container.svelte-tmk0nh{border-radius:16px;background-color:white;text-align:center;overflow-x:hidden}.dialog__container--list_view.svelte-tmk0nh{max-width:470px}.dialog__container--fixed_width.svelte-tmk0nh{max-width:407px;width:50vw;min-width:300px}.dialog__footer.svelte-tmk0nh{background-color:var(--dialog-background-color, #fdf7f4);padding:12px 32px;display:flex;flex-direction:column;justify-content:space-around}");
	}

	// (113:2) {:else}
	function create_else_block(ctx) {
		let percsdialogheader;
		let t;
		let percsdialogcontent;
		let current;

		percsdialogheader = new PercsDialogHeader({
				props: { state: /*state*/ ctx[0], text: "Error" }
			});

		percsdialogheader.$on("close", /*close_handler_28*/ ctx[31]);

		percsdialogcontent = new PercsDialogContent({
				props: {
					$$slots: { default: [create_default_slot_2] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsdialogheader.$$.fragment);
				t = space();
				create_component(percsdialogcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsdialogheader, target, anchor);
				insert(target, t, anchor);
				mount_component(percsdialogcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsdialogheader_changes = {};
				if (dirty[0] & /*state*/ 1) percsdialogheader_changes.state = /*state*/ ctx[0];
				percsdialogheader.$set(percsdialogheader_changes);
				const percsdialogcontent_changes = {};

				if (dirty[1] & /*$$scope*/ 4) {
					percsdialogcontent_changes.$$scope = { dirty, ctx };
				}

				percsdialogcontent.$set(percsdialogcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsdialogheader.$$.fragment, local);
				transition_in(percsdialogcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsdialogheader.$$.fragment, local);
				transition_out(percsdialogcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsdialogheader, detaching);
				if (detaching) detach(t);
				destroy_component(percsdialogcontent, detaching);
			}
		};
	}

	// (111:53) 
	function create_if_block_30(ctx) {
		let offererrorcontent;
		let current;
		offererrorcontent = new OfferError({ props: { state: /*state*/ ctx[0] } });
		offererrorcontent.$on("close", /*close_handler_27*/ ctx[30]);

		return {
			c() {
				create_component(offererrorcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offererrorcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offererrorcontent_changes = {};
				if (dirty[0] & /*state*/ 1) offererrorcontent_changes.state = /*state*/ ctx[0];
				offererrorcontent.$set(offererrorcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offererrorcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offererrorcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offererrorcontent, detaching);
			}
		};
	}

	// (109:55) 
	function create_if_block_29(ctx) {
		let offerexpiredcontent;
		let current;
		offerexpiredcontent = new OfferExpired({ props: { state: /*state*/ ctx[0] } });
		offerexpiredcontent.$on("close", /*close_handler_26*/ ctx[29]);

		return {
			c() {
				create_component(offerexpiredcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offerexpiredcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offerexpiredcontent_changes = {};
				if (dirty[0] & /*state*/ 1) offerexpiredcontent_changes.state = /*state*/ ctx[0];
				offerexpiredcontent.$set(offerexpiredcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offerexpiredcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offerexpiredcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offerexpiredcontent, detaching);
			}
		};
	}

	// (107:110) 
	function create_if_block_28(ctx) {
		let offerlistcontent;
		let current;
		offerlistcontent = new OfferList({ props: { state: /*state*/ ctx[0] } });
		offerlistcontent.$on("close", /*close_handler_25*/ ctx[28]);

		return {
			c() {
				create_component(offerlistcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offerlistcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offerlistcontent_changes = {};
				if (dirty[0] & /*state*/ 1) offerlistcontent_changes.state = /*state*/ ctx[0];
				offerlistcontent.$set(offerlistcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offerlistcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offerlistcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offerlistcontent, detaching);
			}
		};
	}

	// (105:57) 
	function create_if_block_27(ctx) {
		let offergatecontent;
		let current;
		offergatecontent = new OfferGate({ props: { state: /*state*/ ctx[0] } });
		offergatecontent.$on("close", /*close_handler_24*/ ctx[27]);

		return {
			c() {
				create_component(offergatecontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offergatecontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offergatecontent_changes = {};
				if (dirty[0] & /*state*/ 1) offergatecontent_changes.state = /*state*/ ctx[0];
				offergatecontent.$set(offergatecontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offergatecontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offergatecontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offergatecontent, detaching);
			}
		};
	}

	// (103:317) 
	function create_if_block_26(ctx) {
		let offerredeemerrorcontent;
		let current;
		offerredeemerrorcontent = new OfferRedeemError({ props: { state: /*state*/ ctx[0] } });
		offerredeemerrorcontent.$on("close", /*close_handler_23*/ ctx[26]);

		return {
			c() {
				create_component(offerredeemerrorcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offerredeemerrorcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offerredeemerrorcontent_changes = {};
				if (dirty[0] & /*state*/ 1) offerredeemerrorcontent_changes.state = /*state*/ ctx[0];
				offerredeemerrorcontent.$set(offerredeemerrorcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offerredeemerrorcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offerredeemerrorcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offerredeemerrorcontent, detaching);
			}
		};
	}

	// (101:68) 
	function create_if_block_25(ctx) {
		let offerredeemeventsuccesscontent;
		let current;
		offerredeemeventsuccesscontent = new OfferRedeemEventSuccess({ props: { state: /*state*/ ctx[0] } });
		offerredeemeventsuccesscontent.$on("close", /*close_handler_22*/ ctx[25]);

		return {
			c() {
				create_component(offerredeemeventsuccesscontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offerredeemeventsuccesscontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offerredeemeventsuccesscontent_changes = {};
				if (dirty[0] & /*state*/ 1) offerredeemeventsuccesscontent_changes.state = /*state*/ ctx[0];
				offerredeemeventsuccesscontent.$set(offerredeemeventsuccesscontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offerredeemeventsuccesscontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offerredeemeventsuccesscontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offerredeemeventsuccesscontent, detaching);
			}
		};
	}

	// (99:71) 
	function create_if_block_24(ctx) {
		let offerredeemdiscountsuccesscontent;
		let current;
		offerredeemdiscountsuccesscontent = new OfferRedeemDiscountSuccess({ props: { state: /*state*/ ctx[0] } });
		offerredeemdiscountsuccesscontent.$on("close", /*close_handler_21*/ ctx[24]);

		return {
			c() {
				create_component(offerredeemdiscountsuccesscontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offerredeemdiscountsuccesscontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offerredeemdiscountsuccesscontent_changes = {};
				if (dirty[0] & /*state*/ 1) offerredeemdiscountsuccesscontent_changes.state = /*state*/ ctx[0];
				offerredeemdiscountsuccesscontent.$set(offerredeemdiscountsuccesscontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offerredeemdiscountsuccesscontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offerredeemdiscountsuccesscontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offerredeemdiscountsuccesscontent, detaching);
			}
		};
	}

	// (97:327) 
	function create_if_block_23(ctx) {
		let offerredeemloadingcontent;
		let current;
		offerredeemloadingcontent = new OfferRedeemLoading({ props: { state: /*state*/ ctx[0] } });
		offerredeemloadingcontent.$on("close", /*close_handler_20*/ ctx[23]);

		return {
			c() {
				create_component(offerredeemloadingcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offerredeemloadingcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offerredeemloadingcontent_changes = {};
				if (dirty[0] & /*state*/ 1) offerredeemloadingcontent_changes.state = /*state*/ ctx[0];
				offerredeemloadingcontent.$set(offerredeemloadingcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offerredeemloadingcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offerredeemloadingcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offerredeemloadingcontent, detaching);
			}
		};
	}

	// (95:188) 
	function create_if_block_22(ctx) {
		let offerredeemdetails;
		let current;
		offerredeemdetails = new OfferRedeemDetails({ props: { state: /*state*/ ctx[0] } });
		offerredeemdetails.$on("close", /*close_handler_19*/ ctx[22]);

		return {
			c() {
				create_component(offerredeemdetails.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offerredeemdetails, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offerredeemdetails_changes = {};
				if (dirty[0] & /*state*/ 1) offerredeemdetails_changes.state = /*state*/ ctx[0];
				offerredeemdetails.$set(offerredeemdetails_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offerredeemdetails.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offerredeemdetails.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offerredeemdetails, detaching);
			}
		};
	}

	// (93:56) 
	function create_if_block_21(ctx) {
		let offergiveawaycontent;
		let current;
		offergiveawaycontent = new OfferGiveaway({ props: { state: /*state*/ ctx[0] } });
		offergiveawaycontent.$on("close", /*close_handler_18*/ ctx[21]);

		return {
			c() {
				create_component(offergiveawaycontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offergiveawaycontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offergiveawaycontent_changes = {};
				if (dirty[0] & /*state*/ 1) offergiveawaycontent_changes.state = /*state*/ ctx[0];
				offergiveawaycontent.$set(offergiveawaycontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offergiveawaycontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offergiveawaycontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offergiveawaycontent, detaching);
			}
		};
	}

	// (91:64) 
	function create_if_block_20(ctx) {
		let offergiveawaysuccesscontent;
		let current;
		offergiveawaysuccesscontent = new OfferGiveawaySuccess({ props: { state: /*state*/ ctx[0] } });
		offergiveawaysuccesscontent.$on("close", /*close_handler_17*/ ctx[20]);

		return {
			c() {
				create_component(offergiveawaysuccesscontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offergiveawaysuccesscontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offergiveawaysuccesscontent_changes = {};
				if (dirty[0] & /*state*/ 1) offergiveawaysuccesscontent_changes.state = /*state*/ ctx[0];
				offergiveawaysuccesscontent.$set(offergiveawaysuccesscontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offergiveawaysuccesscontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offergiveawaysuccesscontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offergiveawaysuccesscontent, detaching);
			}
		};
	}

	// (89:122) 
	function create_if_block_19(ctx) {
		let offerselectedeventcontent;
		let current;
		offerselectedeventcontent = new OfferSelectedEvent({ props: { state: /*state*/ ctx[0] } });
		offerselectedeventcontent.$on("close", /*close_handler_16*/ ctx[19]);

		return {
			c() {
				create_component(offerselectedeventcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offerselectedeventcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offerselectedeventcontent_changes = {};
				if (dirty[0] & /*state*/ 1) offerselectedeventcontent_changes.state = /*state*/ ctx[0];
				offerselectedeventcontent.$set(offerselectedeventcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offerselectedeventcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offerselectedeventcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offerselectedeventcontent, detaching);
			}
		};
	}

	// (87:128) 
	function create_if_block_18(ctx) {
		let offerselecteddiscountcontent;
		let current;
		offerselecteddiscountcontent = new OfferSelectedDiscount({ props: { state: /*state*/ ctx[0] } });
		offerselecteddiscountcontent.$on("close", /*close_handler_15*/ ctx[18]);

		return {
			c() {
				create_component(offerselecteddiscountcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offerselecteddiscountcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offerselecteddiscountcontent_changes = {};
				if (dirty[0] & /*state*/ 1) offerselecteddiscountcontent_changes.state = /*state*/ ctx[0];
				offerselecteddiscountcontent.$set(offerselecteddiscountcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offerselecteddiscountcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offerselecteddiscountcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offerselecteddiscountcontent, detaching);
			}
		};
	}

	// (85:53) 
	function create_if_block_17(ctx) {
		let offeremptycontent;
		let current;
		offeremptycontent = new OfferEmpty({ props: { state: /*state*/ ctx[0] } });
		offeremptycontent.$on("close", /*close_handler_14*/ ctx[17]);

		return {
			c() {
				create_component(offeremptycontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offeremptycontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offeremptycontent_changes = {};
				if (dirty[0] & /*state*/ 1) offeremptycontent_changes.state = /*state*/ ctx[0];
				offeremptycontent.$set(offeremptycontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offeremptycontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offeremptycontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offeremptycontent, detaching);
			}
		};
	}

	// (83:55) 
	function create_if_block_16(ctx) {
		let offerloadingcontent;
		let current;
		offerloadingcontent = new OfferLoading({ props: { state: /*state*/ ctx[0] } });
		offerloadingcontent.$on("close", /*close_handler_13*/ ctx[16]);

		return {
			c() {
				create_component(offerloadingcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(offerloadingcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const offerloadingcontent_changes = {};
				if (dirty[0] & /*state*/ 1) offerloadingcontent_changes.state = /*state*/ ctx[0];
				offerloadingcontent.$set(offerloadingcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(offerloadingcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(offerloadingcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(offerloadingcontent, detaching);
			}
		};
	}

	// (81:69) 
	function create_if_block_15(ctx) {
		let subscribeintegrationerror;
		let current;
		subscribeintegrationerror = new SubscribeIntegrationError({ props: { state: /*state*/ ctx[0] } });
		subscribeintegrationerror.$on("close", /*close_handler_12*/ ctx[15]);

		return {
			c() {
				create_component(subscribeintegrationerror.$$.fragment);
			},
			m(target, anchor) {
				mount_component(subscribeintegrationerror, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const subscribeintegrationerror_changes = {};
				if (dirty[0] & /*state*/ 1) subscribeintegrationerror_changes.state = /*state*/ ctx[0];
				subscribeintegrationerror.$set(subscribeintegrationerror_changes);
			},
			i(local) {
				if (current) return;
				transition_in(subscribeintegrationerror.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(subscribeintegrationerror.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(subscribeintegrationerror, detaching);
			}
		};
	}

	// (79:71) 
	function create_if_block_14(ctx) {
		let subscribeintegrationsuccess;
		let current;
		subscribeintegrationsuccess = new SubscribeIntegrationSuccess({ props: { state: /*state*/ ctx[0] } });
		subscribeintegrationsuccess.$on("close", /*close_handler_11*/ ctx[14]);

		return {
			c() {
				create_component(subscribeintegrationsuccess.$$.fragment);
			},
			m(target, anchor) {
				mount_component(subscribeintegrationsuccess, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const subscribeintegrationsuccess_changes = {};
				if (dirty[0] & /*state*/ 1) subscribeintegrationsuccess_changes.state = /*state*/ ctx[0];
				subscribeintegrationsuccess.$set(subscribeintegrationsuccess_changes);
			},
			i(local) {
				if (current) return;
				transition_in(subscribeintegrationsuccess.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(subscribeintegrationsuccess.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(subscribeintegrationsuccess, detaching);
			}
		};
	}

	// (77:72) 
	function create_if_block_13(ctx) {
		let subscribeintegrationselected;
		let current;
		subscribeintegrationselected = new SubscribeIntegrationSelected({ props: { state: /*state*/ ctx[0] } });
		subscribeintegrationselected.$on("close", /*close_handler_10*/ ctx[13]);

		return {
			c() {
				create_component(subscribeintegrationselected.$$.fragment);
			},
			m(target, anchor) {
				mount_component(subscribeintegrationselected, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const subscribeintegrationselected_changes = {};
				if (dirty[0] & /*state*/ 1) subscribeintegrationselected_changes.state = /*state*/ ctx[0];
				subscribeintegrationselected.$set(subscribeintegrationselected_changes);
			},
			i(local) {
				if (current) return;
				transition_in(subscribeintegrationselected.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(subscribeintegrationselected.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(subscribeintegrationselected, detaching);
			}
		};
	}

	// (75:71) 
	function create_if_block_12(ctx) {
		let subscribeintegrationoptions;
		let current;
		subscribeintegrationoptions = new SubscribeIntegrationOptions({ props: { state: /*state*/ ctx[0] } });
		subscribeintegrationoptions.$on("close", /*close_handler_9*/ ctx[12]);

		return {
			c() {
				create_component(subscribeintegrationoptions.$$.fragment);
			},
			m(target, anchor) {
				mount_component(subscribeintegrationoptions, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const subscribeintegrationoptions_changes = {};
				if (dirty[0] & /*state*/ 1) subscribeintegrationoptions_changes.state = /*state*/ ctx[0];
				subscribeintegrationoptions.$set(subscribeintegrationoptions_changes);
			},
			i(local) {
				if (current) return;
				transition_in(subscribeintegrationoptions.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(subscribeintegrationoptions.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(subscribeintegrationoptions, detaching);
			}
		};
	}

	// (73:65) 
	function create_if_block_11(ctx) {
		let subscribeloadingerror;
		let current;
		subscribeloadingerror = new SubscribeLoadingError({ props: { state: /*state*/ ctx[0] } });
		subscribeloadingerror.$on("close", /*close_handler_8*/ ctx[11]);

		return {
			c() {
				create_component(subscribeloadingerror.$$.fragment);
			},
			m(target, anchor) {
				mount_component(subscribeloadingerror, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const subscribeloadingerror_changes = {};
				if (dirty[0] & /*state*/ 1) subscribeloadingerror_changes.state = /*state*/ ctx[0];
				subscribeloadingerror.$set(subscribeloadingerror_changes);
			},
			i(local) {
				if (current) return;
				transition_in(subscribeloadingerror.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(subscribeloadingerror.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(subscribeloadingerror, detaching);
			}
		};
	}

	// (71:59) 
	function create_if_block_10(ctx) {
		let subscribeloading;
		let current;
		subscribeloading = new SubscribeLoading({ props: { state: /*state*/ ctx[0] } });
		subscribeloading.$on("close", /*close_handler_7*/ ctx[10]);

		return {
			c() {
				create_component(subscribeloading.$$.fragment);
			},
			m(target, anchor) {
				mount_component(subscribeloading, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const subscribeloading_changes = {};
				if (dirty[0] & /*state*/ 1) subscribeloading_changes.state = /*state*/ ctx[0];
				subscribeloading.$set(subscribeloading_changes);
			},
			i(local) {
				if (current) return;
				transition_in(subscribeloading.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(subscribeloading.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(subscribeloading, detaching);
			}
		};
	}

	// (69:66) 
	function create_if_block_9(ctx) {
		let providerconnectsuccesscontent;
		let current;
		providerconnectsuccesscontent = new ProviderConnectSuccess({ props: { state: /*state*/ ctx[0] } });
		providerconnectsuccesscontent.$on("close", /*close_handler_6*/ ctx[9]);

		return {
			c() {
				create_component(providerconnectsuccesscontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(providerconnectsuccesscontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const providerconnectsuccesscontent_changes = {};
				if (dirty[0] & /*state*/ 1) providerconnectsuccesscontent_changes.state = /*state*/ ctx[0];
				providerconnectsuccesscontent.$set(providerconnectsuccesscontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(providerconnectsuccesscontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(providerconnectsuccesscontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(providerconnectsuccesscontent, detaching);
			}
		};
	}

	// (67:56) 
	function create_if_block_8(ctx) {
		let provideremptycontent;
		let current;
		provideremptycontent = new ProviderEmpty({ props: { state: /*state*/ ctx[0] } });
		provideremptycontent.$on("close", /*close_handler_5*/ ctx[8]);

		return {
			c() {
				create_component(provideremptycontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(provideremptycontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const provideremptycontent_changes = {};
				if (dirty[0] & /*state*/ 1) provideremptycontent_changes.state = /*state*/ ctx[0];
				provideremptycontent.$set(provideremptycontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(provideremptycontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(provideremptycontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(provideremptycontent, detaching);
			}
		};
	}

	// (65:64) 
	function create_if_block_7(ctx) {
		let providerconnecterrorcontent;
		let current;
		providerconnecterrorcontent = new ProviderConnectError({ props: { state: /*state*/ ctx[0] } });
		providerconnecterrorcontent.$on("close", /*close_handler_4*/ ctx[7]);

		return {
			c() {
				create_component(providerconnecterrorcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(providerconnecterrorcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const providerconnecterrorcontent_changes = {};
				if (dirty[0] & /*state*/ 1) providerconnecterrorcontent_changes.state = /*state*/ ctx[0];
				providerconnecterrorcontent.$set(providerconnecterrorcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(providerconnecterrorcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(providerconnecterrorcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(providerconnecterrorcontent, detaching);
			}
		};
	}

	// (63:61) 
	function create_if_block_6(ctx) {
		let providerconnectingcontent;
		let current;
		providerconnectingcontent = new ProviderConnecting({ props: { state: /*state*/ ctx[0] } });
		providerconnectingcontent.$on("close", /*close_handler_3*/ ctx[6]);

		return {
			c() {
				create_component(providerconnectingcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(providerconnectingcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const providerconnectingcontent_changes = {};
				if (dirty[0] & /*state*/ 1) providerconnectingcontent_changes.state = /*state*/ ctx[0];
				providerconnectingcontent.$set(providerconnectingcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(providerconnectingcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(providerconnectingcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(providerconnectingcontent, detaching);
			}
		};
	}

	// (61:58) 
	function create_if_block_5(ctx) {
		let providerconnectcontent;
		let current;
		providerconnectcontent = new ProviderConnect({ props: { state: /*state*/ ctx[0] } });
		providerconnectcontent.$on("close", /*close_handler_2*/ ctx[5]);

		return {
			c() {
				create_component(providerconnectcontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(providerconnectcontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const providerconnectcontent_changes = {};
				if (dirty[0] & /*state*/ 1) providerconnectcontent_changes.state = /*state*/ ctx[0];
				providerconnectcontent.$set(providerconnectcontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(providerconnectcontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(providerconnectcontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(providerconnectcontent, detaching);
			}
		};
	}

	// (59:52) 
	function create_if_block_4(ctx) {
		let emailgatecontent;
		let current;
		emailgatecontent = new EmailGate({ props: { state: /*state*/ ctx[0] } });
		emailgatecontent.$on("close", /*close_handler_1*/ ctx[4]);

		return {
			c() {
				create_component(emailgatecontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(emailgatecontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const emailgatecontent_changes = {};
				if (dirty[0] & /*state*/ 1) emailgatecontent_changes.state = /*state*/ ctx[0];
				emailgatecontent.$set(emailgatecontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(emailgatecontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(emailgatecontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(emailgatecontent, detaching);
			}
		};
	}

	// (57:2) {#if $state.matches("modal.open.email-gate.success")}
	function create_if_block_3(ctx) {
		let emailgatesuccesscontent;
		let current;
		emailgatesuccesscontent = new EmailGateSuccess({ props: { state: /*state*/ ctx[0] } });
		emailgatesuccesscontent.$on("close", /*close_handler*/ ctx[3]);

		return {
			c() {
				create_component(emailgatesuccesscontent.$$.fragment);
			},
			m(target, anchor) {
				mount_component(emailgatesuccesscontent, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const emailgatesuccesscontent_changes = {};
				if (dirty[0] & /*state*/ 1) emailgatesuccesscontent_changes.state = /*state*/ ctx[0];
				emailgatesuccesscontent.$set(emailgatesuccesscontent_changes);
			},
			i(local) {
				if (current) return;
				transition_in(emailgatesuccesscontent.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(emailgatesuccesscontent.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(emailgatesuccesscontent, detaching);
			}
		};
	}

	// (115:4) <PercsDialogContent>
	function create_default_slot_2(ctx) {
		let p;

		return {
			c() {
				p = element("p");
				p.textContent = "There was an issue";
			},
			m(target, anchor) {
				insert(target, p, anchor);
			},
			p: noop$6,
			d(detaching) {
				if (detaching) detach(p);
			}
		};
	}

	// (120:2) {#if $state.context.offers?.[ 0 ]?.redemption.helpLink || (!$state.matches("modal.open.subscribe") && $state.context.gate?.dismissable === false && !$state.matches("modal.open.connecting-provider") && history.length > 1)}
	function create_if_block$1(ctx) {
		let div;
		let t;
		let show_if = /*$state*/ ctx[2].context.gate?.dismissable === false && !/*$state*/ ctx[2].matches("modal.open.connecting-provider") && history.length > 1;
		let current;
		let if_block0 = /*$state*/ ctx[2].context.offers?.[0]?.redemption.helpLink && create_if_block_2(ctx);
		let if_block1 = show_if && create_if_block_1(ctx);

		return {
			c() {
				div = element("div");
				if (if_block0) if_block0.c();
				t = space();
				if (if_block1) if_block1.c();
				attr(div, "class", "dialog__footer svelte-tmk0nh");
			},
			m(target, anchor) {
				insert(target, div, anchor);
				if (if_block0) if_block0.m(div, null);
				append(div, t);
				if (if_block1) if_block1.m(div, null);
				current = true;
			},
			p(ctx, dirty) {
				if (/*$state*/ ctx[2].context.offers?.[0]?.redemption.helpLink) {
					if (if_block0) {
						if_block0.p(ctx, dirty);

						if (dirty[0] & /*$state*/ 4) {
							transition_in(if_block0, 1);
						}
					} else {
						if_block0 = create_if_block_2(ctx);
						if_block0.c();
						transition_in(if_block0, 1);
						if_block0.m(div, t);
					}
				} else if (if_block0) {
					group_outros();

					transition_out(if_block0, 1, 1, () => {
						if_block0 = null;
					});

					check_outros();
				}

				if (dirty[0] & /*$state*/ 4) show_if = /*$state*/ ctx[2].context.gate?.dismissable === false && !/*$state*/ ctx[2].matches("modal.open.connecting-provider") && history.length > 1;

				if (show_if) {
					if (if_block1) {
						if_block1.p(ctx, dirty);

						if (dirty[0] & /*$state*/ 4) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block_1(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(div, null);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block0);
				transition_in(if_block1);
				current = true;
			},
			o(local) {
				transition_out(if_block0);
				transition_out(if_block1);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div);
				if (if_block0) if_block0.d();
				if (if_block1) if_block1.d();
			}
		};
	}

	// (122:6) {#if $state.context.offers?.[ 0 ]?.redemption.helpLink}
	function create_if_block_2(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "flat",
					as: "a",
					target: "_blank",
					href: /*$state*/ ctx[2].context.offers[0].redemption.helpLink.url,
					$$slots: { default: [create_default_slot_1] },
					$$scope: { ctx }
				}
			});

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};
				if (dirty[0] & /*$state*/ 4) percsbutton_changes.href = /*$state*/ ctx[2].context.offers[0].redemption.helpLink.url;

				if (dirty[0] & /*$state*/ 4 | dirty[1] & /*$$scope*/ 4) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (123:8) <PercsButton           variant="flat"           as="a"           target="_blank"           href={$state.context.offers[ 0 ].redemption.helpLink.url}         >
	function create_default_slot_1(ctx) {
		let t_value = /*$state*/ ctx[2].context.offers[0].redemption.helpLink.text + "";
		let t;

		return {
			c() {
				t = text(t_value);
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			p(ctx, dirty) {
				if (dirty[0] & /*$state*/ 4 && t_value !== (t_value = /*$state*/ ctx[2].context.offers[0].redemption.helpLink.text + "")) set_data(t, t_value);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	// (132:6) {#if $state.context.gate?.dismissable === false && !$state.matches("modal.open.connecting-provider") && history.length > 1}
	function create_if_block_1(ctx) {
		let percsbutton;
		let current;

		percsbutton = new PercsButton({
				props: {
					variant: "flat",
					$$slots: { default: [create_default_slot] },
					$$scope: { ctx }
				}
			});

		percsbutton.$on("click", /*click_handler*/ ctx[32]);

		return {
			c() {
				create_component(percsbutton.$$.fragment);
			},
			m(target, anchor) {
				mount_component(percsbutton, target, anchor);
				current = true;
			},
			p(ctx, dirty) {
				const percsbutton_changes = {};

				if (dirty[1] & /*$$scope*/ 4) {
					percsbutton_changes.$$scope = { dirty, ctx };
				}

				percsbutton.$set(percsbutton_changes);
			},
			i(local) {
				if (current) return;
				transition_in(percsbutton.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(percsbutton.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				destroy_component(percsbutton, detaching);
			}
		};
	}

	// (133:8) <PercsButton           variant="flat"           on:click={() => {             state.send({ type: "MODAL_CLOSE" })             history.back()           }}         >
	function create_default_slot(ctx) {
		let t;

		return {
			c() {
				t = text("Back");
			},
			m(target, anchor) {
				insert(target, t, anchor);
			},
			d(detaching) {
				if (detaching) detach(t);
			}
		};
	}

	function create_fragment$1(ctx) {
		let div1;
		let div0;
		let t0_value = getStateString(/*$state*/ ctx[2].value) + "";
		let t0;
		let t1;
		let show_if_1;
		let show_if_2;
		let show_if_3;
		let show_if_4;
		let show_if_5;
		let show_if_6;
		let show_if_7;
		let show_if_8;
		let show_if_9;
		let show_if_10;
		let show_if_11;
		let show_if_12;
		let show_if_13;
		let show_if_14;
		let show_if_15;
		let show_if_16;
		let show_if_17;
		let show_if_18;
		let show_if_19;
		let show_if_20;
		let show_if_21;
		let show_if_22;
		let show_if_23;
		let show_if_24;
		let show_if_25;
		let show_if_26;
		let show_if_27;
		let show_if_28;
		let current_block_type_index;
		let if_block0;
		let t2;
		let show_if = /*$state*/ ctx[2].context.offers?.[0]?.redemption.helpLink || !/*$state*/ ctx[2].matches("modal.open.subscribe") && /*$state*/ ctx[2].context.gate?.dismissable === false && !/*$state*/ ctx[2].matches("modal.open.connecting-provider") && history.length > 1;
		let current;

		const if_block_creators = [
			create_if_block_3,
			create_if_block_4,
			create_if_block_5,
			create_if_block_6,
			create_if_block_7,
			create_if_block_8,
			create_if_block_9,
			create_if_block_10,
			create_if_block_11,
			create_if_block_12,
			create_if_block_13,
			create_if_block_14,
			create_if_block_15,
			create_if_block_16,
			create_if_block_17,
			create_if_block_18,
			create_if_block_19,
			create_if_block_20,
			create_if_block_21,
			create_if_block_22,
			create_if_block_23,
			create_if_block_24,
			create_if_block_25,
			create_if_block_26,
			create_if_block_27,
			create_if_block_28,
			create_if_block_29,
			create_if_block_30,
			create_else_block
		];

		const if_blocks = [];

		function select_block_type(ctx, dirty) {
			if (dirty[0] & /*$state*/ 4) show_if_1 = null;
			if (dirty[0] & /*$state*/ 4) show_if_2 = null;
			if (dirty[0] & /*$state*/ 4) show_if_3 = null;
			if (dirty[0] & /*$state*/ 4) show_if_4 = null;
			if (dirty[0] & /*$state*/ 4) show_if_5 = null;
			if (dirty[0] & /*$state*/ 4) show_if_6 = null;
			if (dirty[0] & /*$state*/ 4) show_if_7 = null;
			if (dirty[0] & /*$state*/ 4) show_if_8 = null;
			if (dirty[0] & /*$state*/ 4) show_if_9 = null;
			if (dirty[0] & /*$state*/ 4) show_if_10 = null;
			if (dirty[0] & /*$state*/ 4) show_if_11 = null;
			if (dirty[0] & /*$state*/ 4) show_if_12 = null;
			if (dirty[0] & /*$state*/ 4) show_if_13 = null;
			if (dirty[0] & /*$state*/ 4) show_if_14 = null;
			if (dirty[0] & /*$state*/ 4) show_if_15 = null;
			if (dirty[0] & /*$state*/ 4) show_if_16 = null;
			if (dirty[0] & /*$state*/ 4) show_if_17 = null;
			if (dirty[0] & /*$state*/ 4) show_if_18 = null;
			if (dirty[0] & /*$state*/ 4) show_if_19 = null;
			if (dirty[0] & /*$state*/ 4) show_if_20 = null;
			if (dirty[0] & /*$state*/ 4) show_if_21 = null;
			if (dirty[0] & /*$state*/ 4) show_if_22 = null;
			if (dirty[0] & /*$state*/ 4) show_if_23 = null;
			if (dirty[0] & /*$state*/ 4) show_if_24 = null;
			if (dirty[0] & /*$state*/ 4) show_if_25 = null;
			if (dirty[0] & /*$state*/ 4) show_if_26 = null;
			if (dirty[0] & /*$state*/ 4) show_if_27 = null;
			if (dirty[0] & /*$state*/ 4) show_if_28 = null;
			if (show_if_1 == null) show_if_1 = !!/*$state*/ ctx[2].matches("modal.open.email-gate.success");
			if (show_if_1) return 0;
			if (show_if_2 == null) show_if_2 = !!/*$state*/ ctx[2].matches("modal.open.email-gate");
			if (show_if_2) return 1;
			if (show_if_3 == null) show_if_3 = !!/*$state*/ ctx[2].matches("modal.open.provider-connect");
			if (show_if_3) return 2;
			if (show_if_4 == null) show_if_4 = !!/*$state*/ ctx[2].matches("modal.open.provider-connecting");
			if (show_if_4) return 3;
			if (show_if_5 == null) show_if_5 = !!/*$state*/ ctx[2].matches("modal.open.provider-connect-error");
			if (show_if_5) return 4;
			if (show_if_6 == null) show_if_6 = !!/*$state*/ ctx[2].matches("modal.open.provider-empty");
			if (show_if_6) return 5;
			if (show_if_7 == null) show_if_7 = !!/*$state*/ ctx[2].matches("modal.open.provider-connect-success");
			if (show_if_7) return 6;
			if (show_if_8 == null) show_if_8 = !!/*$state*/ ctx[2].matches("modal.open.subscribe.loading");
			if (show_if_8) return 7;
			if (show_if_9 == null) show_if_9 = !!/*$state*/ ctx[2].matches("modal.open.subscribe.loading-error");
			if (show_if_9) return 8;
			if (show_if_10 == null) show_if_10 = !!/*$state*/ ctx[2].matches("modal.open.subscribe.integration-options");
			if (show_if_10) return 9;
			if (show_if_11 == null) show_if_11 = !!/*$state*/ ctx[2].matches("modal.open.subscribe.integration-selected");
			if (show_if_11) return 10;
			if (show_if_12 == null) show_if_12 = !!/*$state*/ ctx[2].matches("modal.open.subscribe.integration-success");
			if (show_if_12) return 11;
			if (show_if_13 == null) show_if_13 = !!/*$state*/ ctx[2].matches("modal.open.subscribe.integration-error");
			if (show_if_13) return 12;
			if (show_if_14 == null) show_if_14 = !!/*$state*/ ctx[2].matches("modal.open.offer.loading");
			if (show_if_14) return 13;
			if (show_if_15 == null) show_if_15 = !!/*$state*/ ctx[2].matches("modal.open.offer.empty");
			if (show_if_15) return 14;
			if (show_if_16 == null) show_if_16 = !!(/*$state*/ ctx[2].matches("modal.open.offer.discount.selected") || /*$state*/ ctx[2].matches("modal.open.offer.discount.redeem-existing"));
			if (show_if_16) return 15;
			if (show_if_17 == null) show_if_17 = !!(/*$state*/ ctx[2].matches("modal.open.offer.event.selected") || /*$state*/ ctx[2].matches("modal.open.offer.event.redeem-existing"));
			if (show_if_17) return 16;
			if (show_if_18 == null) show_if_18 = !!/*$state*/ ctx[2].matches("modal.open.offer.giveaway.success");
			if (show_if_18) return 17;
			if (show_if_19 == null) show_if_19 = !!/*$state*/ ctx[2].matches("modal.open.offer.giveaway");
			if (show_if_19) return 18;
			if (show_if_20 == null) show_if_20 = !!(/*$state*/ ctx[2].matches("modal.open.offer.discount.redeem-details") || /*$state*/ ctx[2].matches("modal.open.offer.event.redeem-details") || /*$state*/ ctx[2].matches("modal.open.offer.gate.redeem-details"));
			if (show_if_20) return 19;
			if (show_if_21 == null) show_if_21 = !!(/*$state*/ ctx[2].matches("modal.open.offer.discount.redeem-loading") || /*$state*/ ctx[2].matches("modal.open.offer.discount.redeem-existing-loading") || /*$state*/ ctx[2].matches("modal.open.offer.event.redeem-loading") || /*$state*/ ctx[2].matches("modal.open.offer.event.redeem-existing-loading") || /*$state*/ ctx[2].matches("modal.open.offer.gate.redeem-loading"));
			if (show_if_21) return 20;
			if (show_if_22 == null) show_if_22 = !!/*$state*/ ctx[2].matches("modal.open.offer.discount.redeem-success");
			if (show_if_22) return 21;
			if (show_if_23 == null) show_if_23 = !!/*$state*/ ctx[2].matches("modal.open.offer.event.redeem-success");
			if (show_if_23) return 22;
			if (show_if_24 == null) show_if_24 = !!(/*$state*/ ctx[2].matches("modal.open.offer.discount.redeem-error") || /*$state*/ ctx[2].matches("modal.open.offer.discount.redeem-existing-error") || /*$state*/ ctx[2].matches("modal.open.offer.event.redeem-error") || /*$state*/ ctx[2].matches("modal.open.offer.event.redeem-existing-error") || /*$state*/ ctx[2].matches("modal.open.offer.gate.redeem-error"));
			if (show_if_24) return 23;
			if (show_if_25 == null) show_if_25 = !!/*$state*/ ctx[2].matches("modal.open.offer.gate.init");
			if (show_if_25) return 24;
			if (show_if_26 == null) show_if_26 = !!(/*$state*/ ctx[2].matches("modal.open.offer.discount.list") || /*$state*/ ctx[2].matches("modal.open.offer.event.list"));
			if (show_if_26) return 25;
			if (show_if_27 == null) show_if_27 = !!/*$state*/ ctx[2].matches("modal.open.offer.expired");
			if (show_if_27) return 26;
			if (show_if_28 == null) show_if_28 = !!/*$state*/ ctx[2].matches("modal.open.offer.error");
			if (show_if_28) return 27;
			return 28;
		}

		current_block_type_index = select_block_type(ctx, [-1, -1]);
		if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
		let if_block1 = show_if && create_if_block$1(ctx);

		return {
			c() {
				div1 = element("div");
				div0 = element("div");
				t0 = text(t0_value);
				t1 = space();
				if_block0.c();
				t2 = space();
				if (if_block1) if_block1.c();
				set_style(div0, "display", "none");
				attr(div1, "class", "dialog__container svelte-tmk0nh");
				attr(div1, "data-testid", "dialog");
				toggle_class(div1, "dialog__container--fixed_width", !/*variableWidth*/ ctx[1]);
				toggle_class(div1, "dialog__container--list_view", /*$state*/ ctx[2].matches("modal.open.offer.list"));
			},
			m(target, anchor) {
				insert(target, div1, anchor);
				append(div1, div0);
				append(div0, t0);
				append(div1, t1);
				if_blocks[current_block_type_index].m(div1, null);
				append(div1, t2);
				if (if_block1) if_block1.m(div1, null);
				current = true;
			},
			p(ctx, dirty) {
				if ((!current || dirty[0] & /*$state*/ 4) && t0_value !== (t0_value = getStateString(/*$state*/ ctx[2].value) + "")) set_data(t0, t0_value);
				let previous_block_index = current_block_type_index;
				current_block_type_index = select_block_type(ctx, dirty);

				if (current_block_type_index === previous_block_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				} else {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
					if_block0 = if_blocks[current_block_type_index];

					if (!if_block0) {
						if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block0.c();
					} else {
						if_block0.p(ctx, dirty);
					}

					transition_in(if_block0, 1);
					if_block0.m(div1, t2);
				}

				if (dirty[0] & /*$state*/ 4) show_if = /*$state*/ ctx[2].context.offers?.[0]?.redemption.helpLink || !/*$state*/ ctx[2].matches("modal.open.subscribe") && /*$state*/ ctx[2].context.gate?.dismissable === false && !/*$state*/ ctx[2].matches("modal.open.connecting-provider") && history.length > 1;

				if (show_if) {
					if (if_block1) {
						if_block1.p(ctx, dirty);

						if (dirty[0] & /*$state*/ 4) {
							transition_in(if_block1, 1);
						}
					} else {
						if_block1 = create_if_block$1(ctx);
						if_block1.c();
						transition_in(if_block1, 1);
						if_block1.m(div1, null);
					}
				} else if (if_block1) {
					group_outros();

					transition_out(if_block1, 1, 1, () => {
						if_block1 = null;
					});

					check_outros();
				}

				if (!current || dirty[0] & /*variableWidth*/ 2) {
					toggle_class(div1, "dialog__container--fixed_width", !/*variableWidth*/ ctx[1]);
				}

				if (!current || dirty[0] & /*$state*/ 4) {
					toggle_class(div1, "dialog__container--list_view", /*$state*/ ctx[2].matches("modal.open.offer.list"));
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block0);
				transition_in(if_block1);
				current = true;
			},
			o(local) {
				transition_out(if_block0);
				transition_out(if_block1);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(div1);
				if_blocks[current_block_type_index].d();
				if (if_block1) if_block1.d();
			}
		};
	}

	function getStateString(stateValue) {
		if (typeof stateValue === "string") {
			return stateValue;
		}

		if (stateValue == null) {
			return null;
		}

		const [[key, value]] = Object.entries(stateValue);
		return `${key}.${getStateString(value)}`;
	}

	function instance$2($$self, $$props, $$invalidate) {
		let $state,
			$$unsubscribe_state = noop$6,
			$$subscribe_state = () => ($$unsubscribe_state(), $$unsubscribe_state = subscribe$1(state, $$value => $$invalidate(2, $state = $$value)), state);

		$$self.$$.on_destroy.push(() => $$unsubscribe_state());
		let { state } = $$props;
		$$subscribe_state();
		let { variableWidth = false } = $$props;

		function close_handler(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_1(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_2(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_3(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_4(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_5(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_6(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_7(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_8(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_9(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_10(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_11(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_12(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_13(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_14(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_15(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_16(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_17(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_18(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_19(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_20(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_21(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_22(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_23(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_24(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_25(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_26(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_27(event) {
			bubble.call(this, $$self, event);
		}

		function close_handler_28(event) {
			bubble.call(this, $$self, event);
		}

		const click_handler = () => {
			state.send({ type: "MODAL_CLOSE" });
			history.back();
		};

		$$self.$$set = $$props => {
			if ('state' in $$props) $$subscribe_state($$invalidate(0, state = $$props.state));
			if ('variableWidth' in $$props) $$invalidate(1, variableWidth = $$props.variableWidth);
		};

		return [
			state,
			variableWidth,
			$state,
			close_handler,
			close_handler_1,
			close_handler_2,
			close_handler_3,
			close_handler_4,
			close_handler_5,
			close_handler_6,
			close_handler_7,
			close_handler_8,
			close_handler_9,
			close_handler_10,
			close_handler_11,
			close_handler_12,
			close_handler_13,
			close_handler_14,
			close_handler_15,
			close_handler_16,
			close_handler_17,
			close_handler_18,
			close_handler_19,
			close_handler_20,
			close_handler_21,
			close_handler_22,
			close_handler_23,
			close_handler_24,
			close_handler_25,
			close_handler_26,
			close_handler_27,
			close_handler_28,
			click_handler
		];
	}

	class DialogContainer extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$2, create_fragment$1, safe_not_equal, { state: 0, variableWidth: 1 }, add_css$1, [-1, -1]);
		}
	}

	/* dist/components/PercsModal.svelte generated by Svelte v3.59.2 */

	function add_css(target) {
		append_styles(target, "svelte-1cp8uj5", "dialog.svelte-1cp8uj5{border:none;padding:0;background:transparent}dialog.svelte-1cp8uj5::backdrop{background:rgba(0, 0, 0, 0.60)}");
	}

	// (52:0) {#if !$wallet.isModalOpen}
	function create_if_block(ctx) {
		let dialog_1;
		let dialogcontainer;
		let current;
		dialogcontainer = new DialogContainer({ props: { state: stateService } });
		dialogcontainer.$on("close", /*close_handler*/ ctx[3]);

		return {
			c() {
				dialog_1 = element("dialog");
				create_component(dialogcontainer.$$.fragment);
				attr(dialog_1, "class", "svelte-1cp8uj5");
			},
			m(target, anchor) {
				insert(target, dialog_1, anchor);
				mount_component(dialogcontainer, dialog_1, null);
				/*dialog_1_binding*/ ctx[4](dialog_1);
				current = true;
			},
			p: noop$6,
			i(local) {
				if (current) return;
				transition_in(dialogcontainer.$$.fragment, local);
				current = true;
			},
			o(local) {
				transition_out(dialogcontainer.$$.fragment, local);
				current = false;
			},
			d(detaching) {
				if (detaching) detach(dialog_1);
				destroy_component(dialogcontainer);
				/*dialog_1_binding*/ ctx[4](null);
			}
		};
	}

	function create_fragment(ctx) {
		let link0;
		let link1;
		let link2;
		let link3;
		let t;
		let if_block_anchor;
		let current;
		let if_block = !/*$wallet*/ ctx[1].isModalOpen && create_if_block(ctx);

		return {
			c() {
				link0 = element("link");
				link1 = element("link");
				link2 = element("link");
				link3 = element("link");
				t = space();
				if (if_block) if_block.c();
				if_block_anchor = empty$3();
				attr(link0, "rel", "stylesheet");
				attr(link0, "href", "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
				attr(link1, "rel", "preload");
				attr(link1, "as", "image");
				attr(link1, "type", "image/webp");
				attr(link1, "href", "https://assets.getpercs.com/nft-gating/metamask.webp");
				attr(link2, "rel", "preload");
				attr(link2, "as", "image");
				attr(link2, "type", "image/webp");
				attr(link2, "href", "https://assets.getpercs.com/nft-gating/wallet-connect.webp");
				attr(link3, "rel", "preload");
				attr(link3, "as", "image");
				attr(link3, "type", "image/webp");
				attr(link3, "href", "https://assets.getpercs.com/nft-gating/coinbase.webp");
			},
			m(target, anchor) {
				append(document.head, link0);
				append(document.head, link1);
				append(document.head, link2);
				append(document.head, link3);
				insert(target, t, anchor);
				if (if_block) if_block.m(target, anchor);
				insert(target, if_block_anchor, anchor);
				current = true;
			},
			p(ctx, [dirty]) {
				if (!/*$wallet*/ ctx[1].isModalOpen) {
					if (if_block) {
						if_block.p(ctx, dirty);

						if (dirty & /*$wallet*/ 2) {
							transition_in(if_block, 1);
						}
					} else {
						if_block = create_if_block(ctx);
						if_block.c();
						transition_in(if_block, 1);
						if_block.m(if_block_anchor.parentNode, if_block_anchor);
					}
				} else if (if_block) {
					group_outros();

					transition_out(if_block, 1, 1, () => {
						if_block = null;
					});

					check_outros();
				}
			},
			i(local) {
				if (current) return;
				transition_in(if_block);
				current = true;
			},
			o(local) {
				transition_out(if_block);
				current = false;
			},
			d(detaching) {
				detach(link0);
				detach(link1);
				detach(link2);
				detach(link3);
				if (detaching) detach(t);
				if (if_block) if_block.d(detaching);
				if (detaching) detach(if_block_anchor);
			}
		};
	}

	function instance$1($$self, $$props, $$invalidate) {
		let $state;
		let $wallet;
		component_subscribe($$self, stateService, $$value => $$invalidate(2, $state = $$value));
		component_subscribe($$self, wallet$1, $$value => $$invalidate(1, $wallet = $$value));
		let dialog = null;

		onMount(() => {
			if (!dialog) {
				throw new Error("dialog missing");
			}

			/** @type {Parameters<typeof dialog.addEventListener>[ 1 ]} event */
			const dialogCancelHandler = event => {
				if ($state.context.gate?.dismissable === false) {
					event.preventDefault();
				}
			};

			const dialogCloseHandler = () => stateService.send("MODAL_CLOSE");
			dialog.addEventListener("cancel", dialogCancelHandler);
			dialog.addEventListener("close", dialogCloseHandler);

			return () => {
				stateService.send({ type: "MODAL_CLOSE" });
				dialog?.removeEventListener("cancel", dialogCancelHandler);
				dialog?.removeEventListener("close", dialogCloseHandler);
			};
		});

		const close_handler = () => dialog?.close();

		function dialog_1_binding($$value) {
			binding_callbacks[$$value ? 'unshift' : 'push'](() => {
				dialog = $$value;
				$$invalidate(0, dialog);
			});
		}

		$$self.$$.update = () => {
			if ($$self.$$.dirty & /*dialog, $state*/ 5) {
				// Backdrop styles only work if dialog triggered by JS
				{
					if (dialog) {
						if ($state.matches("modal.open")) {
							if (!dialog.open) {
								dialog.showModal();
							}
						} else if (dialog.open) {
							dialog.close();
						}
					}
				}
			}
		};

		return [dialog, $wallet, $state, close_handler, dialog_1_binding];
	}

	class PercsModal extends SvelteComponent {
		constructor(options) {
			super();
			init$3(this, options, instance$1, create_fragment, safe_not_equal, {}, add_css);
		}
	}

	/* eslint-disable max-classes-per-file, no-underscore-dangle, prefer-destructuring */


	/**
	 * @typedef {import("./services/state").Gate} Gate
	 */

	/**
	 * Initialize the percs-client
	 * @param {import("./stores/config").Options} options
	 */
	function init(options) {
	  config$2.init(options);
	  init$1();
	}

	/**
	 * Add listeners for events from the PERCS library
	 * @type {typeof addListener}
	 * @returns {() => void}
	 */
	function on(event, handler) {
	  addListener(event, handler);
	  return () => removeListener(event, handler)
	}

	/**
	 * Trigger the modal with the given content
	 * @param {{ scope: string, gate: Gate }} options
	 */
	function openModal(options) {
	  stateService.send({ type: "MODAL_OPEN", ...options });
	}

	/**
	 * Close the modal
	 */
	function closeModal() {
	  stateService.send({ type: "MODAL_CLOSE" });
	}

	/**
	 * @param {{ text: string }} notification
	 */
	function addLauncherNotification(notification) {
	  notifications$1.addNotification(notification);
	}

	var PERCS = /*#__PURE__*/Object.freeze({
		__proto__: null,
		PercsAppLauncher: PercsAppLauncher_1,
		PercsConnectButton: PercsConnectButton,
		PercsModal: PercsModal,
		PercsOfferButton: PercsOfferButton,
		addLauncherNotification: addLauncherNotification,
		closeModal: closeModal,
		init: init,
		on: on,
		openModal: openModal
	});

	/* eslint-disable max-classes-per-file, no-underscore-dangle, prefer-destructuring */


	customElements.define(
	  "percs-connect-button",
	  class extends HTMLElement {
	    constructor() {
	      super();

	      // Create the shadow root.
	      const shadowRoot = this.attachShadow({ mode: "open" });

	      // Instantiate the Svelte Component
	      this._element = new PercsConnectButton({
	        // Tell it that it lives in the shadow root
	        target: shadowRoot,
	        // Pass any props
	        props: {
	          // This is the place where you do any conversion between
	          // the native string attributes and the types you expect
	          // in your svelte components
	          // @todo
	        },
	      });
	    }
	    disconnectedCallback() {
	      // Destroy the Svelte component when this web component gets
	      // disconnected. If this web component is expected to be moved
	      // in the DOM, then you need to use `connectedCallback()` and
	      // set it up again if necessary.
	      this._element?.$destroy();
	    }
	  },
	);

	customElements.define(
	  "percs-offer-button",
	  class extends HTMLElement {
	    constructor() {
	      super();

	      // Create the shadow root.
	      const shadowRoot = this.attachShadow({ mode: "open" });

	      // Instantiate the Svelte Component
	      this._element = new PercsOfferButton({
	        // Tell it that it lives in the shadow root
	        target: shadowRoot,
	        // This is the place where you do any conversion between
	        // the native string attributes and the types you expect
	        // in your svelte components
	        props: attribute_to_object(this.attributes),
	        customElement: true,
	      });
	    }
	    connectedCallback() {
	      this._element.$$set(attribute_to_object(this.attributes));
	    }
	    disconnectedCallback() {
	      // Destroy the Svelte component when this web component gets
	      // disconnected. If this web component is expected to be moved
	      // in the DOM, then you need to use `connectedCallback()` and
	      // set it up again if necessary.
	      this._element?.$destroy();
	    }
	  },
	);

	customElements.define(
	  "percs-modal",
	  class extends HTMLElement {
	    constructor() {
	      super();

	      // Create the shadow root.
	      const shadowRoot = this.attachShadow({ mode: "open" });

	      // Instantiate the Svelte Component
	      this._element = new PercsModal({
	        // Tell it that it lives in the shadow root
	        target: shadowRoot,
	        // Pass any props
	        props: {
	          // This is the place where you do any conversion between
	          // the native string attributes and the types you expect
	          // in your svelte components
	          // @todo
	        },
	      });
	    }
	    disconnectedCallback() {
	      // Destroy the Svelte component when this web component gets
	      // disconnected. If this web component is expected to be moved
	      // in the DOM, then you need to use `connectedCallback()` and
	      // set it up again if necessary.
	      this._element?.$destroy();
	    }
	  },
	);

	customElements.define(
	  "percs-app-launcher",
	  class extends HTMLElement {
	    constructor() {
	      super();

	      // Create the shadow root.
	      const shadowRoot = this.attachShadow({ mode: "open" });

	      // Instantiate the Svelte Component
	      this._element = new PercsAppLauncher_1({
	        // Tell it that it lives in the shadow root
	        target: shadowRoot,
	        // Pass any props
	        props: {
	          // This is the place where you do any conversion between
	          // the native string attributes and the types you expect
	          // in your svelte components
	          // @todo
	          props: attribute_to_object(this.attributes),
	          customElement: true,
	        },
	      });
	    }
	    connectedCallback() {
	      this._element.$$set(attribute_to_object(this.attributes));
	    }
	    disconnectedCallback() {
	      // Destroy the Svelte component when this web component gets
	      // disconnected. If this web component is expected to be moved
	      // in the DOM, then you need to use `connectedCallback()` and
	      // set it up again if necessary.
	      this._element?.$destroy();
	    }
	  },
	);

	window.PERCS = {
	  ...PERCS,
	  components: {
	    PercsAppLauncher: PercsAppLauncher_1,
	    PercsConnectButton,
	    PercsOfferButton,
	    PercsModal,
	  },
	};

	// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js

	var ws$1 = null;

	if (typeof WebSocket !== 'undefined') {
	  ws$1 = WebSocket;
	} else if (typeof MozWebSocket !== 'undefined') {
	  ws$1 = MozWebSocket;
	} else if (typeof global !== 'undefined') {
	  ws$1 = global.WebSocket || global.MozWebSocket;
	} else if (typeof window !== 'undefined') {
	  ws$1 = window.WebSocket || window.MozWebSocket;
	} else if (typeof self !== 'undefined') {
	  ws$1 = self.WebSocket || self.MozWebSocket;
	}

	var ws$2 = ws$1;

	var browser$5 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: ws$2
	});

	var dist$6 = {};

	var CoinbaseWalletSDK$1 = {};

	var walletLogo$1 = {};

	Object.defineProperty(walletLogo$1, "__esModule", { value: true });
	walletLogo$1.walletLogo = void 0;
	const walletLogo = (type, width) => {
	    let height;
	    switch (type) {
	        case "standard":
	            height = width;
	            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E `;
	        case "circle":
	            height = width;
	            return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' viewBox='0 0 999.81 999.81'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052fe;%7D.cls-2%7Bfill:%23fefefe;%7D.cls-3%7Bfill:%230152fe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M655-115.9h56c.83,1.59,2.36.88,3.56,1a478,478,0,0,1,75.06,10.42C891.4-81.76,978.33-32.58,1049.19,44q116.7,126,131.94,297.61c.38,4.14-.34,8.53,1.78,12.45v59c-1.58.84-.91,2.35-1,3.56a482.05,482.05,0,0,1-10.38,74.05c-24,106.72-76.64,196.76-158.83,268.93s-178.18,112.82-287.2,122.6c-4.83.43-9.86-.25-14.51,1.77H654c-1-1.68-2.69-.91-4.06-1a496.89,496.89,0,0,1-105.9-18.59c-93.54-27.42-172.78-77.59-236.91-150.94Q199.34,590.1,184.87,426.58c-.47-5.19.25-10.56-1.77-15.59V355c1.68-1,.91-2.7,1-4.06a498.12,498.12,0,0,1,18.58-105.9c26-88.75,72.64-164.9,140.6-227.57q126-116.27,297.21-131.61C645.32-114.57,650.35-113.88,655-115.9Zm377.92,500c0-192.44-156.31-349.49-347.56-350.15-194.13-.68-350.94,155.13-352.29,347.42-1.37,194.55,155.51,352.1,348.56,352.47C876.15,734.23,1032.93,577.84,1032.93,384.11Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-2' d='M1032.93,384.11c0,193.73-156.78,350.12-351.29,349.74-193-.37-349.93-157.92-348.56-352.47C334.43,189.09,491.24,33.28,685.37,34,876.62,34.62,1032.94,191.67,1032.93,384.11ZM683,496.81q43.74,0,87.48,0c15.55,0,25.32-9.72,25.33-25.21q0-87.48,0-175c0-15.83-9.68-25.46-25.59-25.46H595.77c-15.88,0-25.57,9.64-25.58,25.46q0,87.23,0,174.45c0,16.18,9.59,25.7,25.84,25.71Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-3' d='M683,496.81H596c-16.25,0-25.84-9.53-25.84-25.71q0-87.23,0-174.45c0-15.82,9.7-25.46,25.58-25.46H770.22c15.91,0,25.59,9.63,25.59,25.46q0,87.47,0,175c0,15.49-9.78,25.2-25.33,25.21Q726.74,496.84,683,496.81Z' transform='translate(-183.1 115.9)'/%3E%3C/svg%3E`;
	        case "text":
	            height = (0.1 * width).toFixed(2);
	            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E`;
	        case "textWithLogo":
	            height = (0.25 * width).toFixed(2);
	            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E`;
	        case "textLight":
	            height = (0.1 * width).toFixed(2);
	            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E`;
	        case "textWithLogoLight":
	            height = (0.25 * width).toFixed(2);
	            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E`;
	        default:
	            height = width;
	            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E `;
	    }
	};
	walletLogo$1.walletLogo = walletLogo;

	var ScopedLocalStorage$1 = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(ScopedLocalStorage$1, "__esModule", { value: true });
	ScopedLocalStorage$1.ScopedLocalStorage = void 0;
	class ScopedLocalStorage {
	    constructor(scope) {
	        this.scope = scope;
	    }
	    setItem(key, value) {
	        localStorage.setItem(this.scopedKey(key), value);
	    }
	    getItem(key) {
	        return localStorage.getItem(this.scopedKey(key));
	    }
	    removeItem(key) {
	        localStorage.removeItem(this.scopedKey(key));
	    }
	    clear() {
	        const prefix = this.scopedKey("");
	        const keysToRemove = [];
	        for (let i = 0; i < localStorage.length; i++) {
	            const key = localStorage.key(i);
	            if (typeof key === "string" && key.startsWith(prefix)) {
	                keysToRemove.push(key);
	            }
	        }
	        keysToRemove.forEach(key => localStorage.removeItem(key));
	    }
	    scopedKey(key) {
	        return `${this.scope}:${key}`;
	    }
	}
	ScopedLocalStorage$1.ScopedLocalStorage = ScopedLocalStorage;

	var CoinbaseWalletProvider$1 = {};

	var safeEventEmitter = {};

	var events = {exports: {}};

	var R$2 = typeof Reflect === 'object' ? Reflect : null;
	var ReflectApply = R$2 && typeof R$2.apply === 'function'
	  ? R$2.apply
	  : function ReflectApply(target, receiver, args) {
	    return Function.prototype.apply.call(target, receiver, args);
	  };

	var ReflectOwnKeys;
	if (R$2 && typeof R$2.ownKeys === 'function') {
	  ReflectOwnKeys = R$2.ownKeys;
	} else if (Object.getOwnPropertySymbols) {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target)
	      .concat(Object.getOwnPropertySymbols(target));
	  };
	} else {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target);
	  };
	}

	function ProcessEmitWarning(warning) {
	  if (console && console.warn) console.warn(warning);
	}

	var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
	  return value !== value;
	};

	function EventEmitter() {
	  EventEmitter.init.call(this);
	}
	events.exports = EventEmitter;
	events.exports.once = once$2;

	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;

	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._eventsCount = 0;
	EventEmitter.prototype._maxListeners = undefined;

	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	var defaultMaxListeners = 10;

	function checkListener(listener) {
	  if (typeof listener !== 'function') {
	    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
	  }
	}

	Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
	  enumerable: true,
	  get: function() {
	    return defaultMaxListeners;
	  },
	  set: function(arg) {
	    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
	      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
	    }
	    defaultMaxListeners = arg;
	  }
	});

	EventEmitter.init = function() {

	  if (this._events === undefined ||
	      this._events === Object.getPrototypeOf(this)._events) {
	    this._events = Object.create(null);
	    this._eventsCount = 0;
	  }

	  this._maxListeners = this._maxListeners || undefined;
	};

	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
	  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
	    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
	  }
	  this._maxListeners = n;
	  return this;
	};

	function _getMaxListeners(that) {
	  if (that._maxListeners === undefined)
	    return EventEmitter.defaultMaxListeners;
	  return that._maxListeners;
	}

	EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
	  return _getMaxListeners(this);
	};

	EventEmitter.prototype.emit = function emit(type) {
	  var args = [];
	  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
	  var doError = (type === 'error');

	  var events = this._events;
	  if (events !== undefined)
	    doError = (doError && events.error === undefined);
	  else if (!doError)
	    return false;

	  // If there is no 'error' event listener then throw.
	  if (doError) {
	    var er;
	    if (args.length > 0)
	      er = args[0];
	    if (er instanceof Error) {
	      // Note: The comments on the `throw` lines are intentional, they show
	      // up in Node's output if this results in an unhandled exception.
	      throw er; // Unhandled 'error' event
	    }
	    // At least give some kind of context to the user
	    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
	    err.context = er;
	    throw err; // Unhandled 'error' event
	  }

	  var handler = events[type];

	  if (handler === undefined)
	    return false;

	  if (typeof handler === 'function') {
	    ReflectApply(handler, this, args);
	  } else {
	    var len = handler.length;
	    var listeners = arrayClone$1(handler, len);
	    for (var i = 0; i < len; ++i)
	      ReflectApply(listeners[i], this, args);
	  }

	  return true;
	};

	function _addListener(target, type, listener, prepend) {
	  var m;
	  var events;
	  var existing;

	  checkListener(listener);

	  events = target._events;
	  if (events === undefined) {
	    events = target._events = Object.create(null);
	    target._eventsCount = 0;
	  } else {
	    // To avoid recursion in the case that type === "newListener"! Before
	    // adding it to the listeners, first emit "newListener".
	    if (events.newListener !== undefined) {
	      target.emit('newListener', type,
	                  listener.listener ? listener.listener : listener);

	      // Re-assign `events` because a newListener handler could have caused the
	      // this._events to be assigned to a new object
	      events = target._events;
	    }
	    existing = events[type];
	  }

	  if (existing === undefined) {
	    // Optimize the case of one listener. Don't need the extra array object.
	    existing = events[type] = listener;
	    ++target._eventsCount;
	  } else {
	    if (typeof existing === 'function') {
	      // Adding the second element, need to change to array.
	      existing = events[type] =
	        prepend ? [listener, existing] : [existing, listener];
	      // If we've already got an array, just append.
	    } else if (prepend) {
	      existing.unshift(listener);
	    } else {
	      existing.push(listener);
	    }

	    // Check for listener leak
	    m = _getMaxListeners(target);
	    if (m > 0 && existing.length > m && !existing.warned) {
	      existing.warned = true;
	      // No error code for this since it is a Warning
	      // eslint-disable-next-line no-restricted-syntax
	      var w = new Error('Possible EventEmitter memory leak detected. ' +
	                          existing.length + ' ' + String(type) + ' listeners ' +
	                          'added. Use emitter.setMaxListeners() to ' +
	                          'increase limit');
	      w.name = 'MaxListenersExceededWarning';
	      w.emitter = target;
	      w.type = type;
	      w.count = existing.length;
	      ProcessEmitWarning(w);
	    }
	  }

	  return target;
	}

	EventEmitter.prototype.addListener = function addListener(type, listener) {
	  return _addListener(this, type, listener, false);
	};

	EventEmitter.prototype.on = EventEmitter.prototype.addListener;

	EventEmitter.prototype.prependListener =
	    function prependListener(type, listener) {
	      return _addListener(this, type, listener, true);
	    };

	function onceWrapper() {
	  if (!this.fired) {
	    this.target.removeListener(this.type, this.wrapFn);
	    this.fired = true;
	    if (arguments.length === 0)
	      return this.listener.call(this.target);
	    return this.listener.apply(this.target, arguments);
	  }
	}

	function _onceWrap(target, type, listener) {
	  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
	  var wrapped = onceWrapper.bind(state);
	  wrapped.listener = listener;
	  state.wrapFn = wrapped;
	  return wrapped;
	}

	EventEmitter.prototype.once = function once(type, listener) {
	  checkListener(listener);
	  this.on(type, _onceWrap(this, type, listener));
	  return this;
	};

	EventEmitter.prototype.prependOnceListener =
	    function prependOnceListener(type, listener) {
	      checkListener(listener);
	      this.prependListener(type, _onceWrap(this, type, listener));
	      return this;
	    };

	// Emits a 'removeListener' event if and only if the listener was removed.
	EventEmitter.prototype.removeListener =
	    function removeListener(type, listener) {
	      var list, events, position, i, originalListener;

	      checkListener(listener);

	      events = this._events;
	      if (events === undefined)
	        return this;

	      list = events[type];
	      if (list === undefined)
	        return this;

	      if (list === listener || list.listener === listener) {
	        if (--this._eventsCount === 0)
	          this._events = Object.create(null);
	        else {
	          delete events[type];
	          if (events.removeListener)
	            this.emit('removeListener', type, list.listener || listener);
	        }
	      } else if (typeof list !== 'function') {
	        position = -1;

	        for (i = list.length - 1; i >= 0; i--) {
	          if (list[i] === listener || list[i].listener === listener) {
	            originalListener = list[i].listener;
	            position = i;
	            break;
	          }
	        }

	        if (position < 0)
	          return this;

	        if (position === 0)
	          list.shift();
	        else {
	          spliceOne(list, position);
	        }

	        if (list.length === 1)
	          events[type] = list[0];

	        if (events.removeListener !== undefined)
	          this.emit('removeListener', type, originalListener || listener);
	      }

	      return this;
	    };

	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

	EventEmitter.prototype.removeAllListeners =
	    function removeAllListeners(type) {
	      var listeners, events, i;

	      events = this._events;
	      if (events === undefined)
	        return this;

	      // not listening for removeListener, no need to emit
	      if (events.removeListener === undefined) {
	        if (arguments.length === 0) {
	          this._events = Object.create(null);
	          this._eventsCount = 0;
	        } else if (events[type] !== undefined) {
	          if (--this._eventsCount === 0)
	            this._events = Object.create(null);
	          else
	            delete events[type];
	        }
	        return this;
	      }

	      // emit removeListener for all listeners on all events
	      if (arguments.length === 0) {
	        var keys = Object.keys(events);
	        var key;
	        for (i = 0; i < keys.length; ++i) {
	          key = keys[i];
	          if (key === 'removeListener') continue;
	          this.removeAllListeners(key);
	        }
	        this.removeAllListeners('removeListener');
	        this._events = Object.create(null);
	        this._eventsCount = 0;
	        return this;
	      }

	      listeners = events[type];

	      if (typeof listeners === 'function') {
	        this.removeListener(type, listeners);
	      } else if (listeners !== undefined) {
	        // LIFO order
	        for (i = listeners.length - 1; i >= 0; i--) {
	          this.removeListener(type, listeners[i]);
	        }
	      }

	      return this;
	    };

	function _listeners(target, type, unwrap) {
	  var events = target._events;

	  if (events === undefined)
	    return [];

	  var evlistener = events[type];
	  if (evlistener === undefined)
	    return [];

	  if (typeof evlistener === 'function')
	    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

	  return unwrap ?
	    unwrapListeners(evlistener) : arrayClone$1(evlistener, evlistener.length);
	}

	EventEmitter.prototype.listeners = function listeners(type) {
	  return _listeners(this, type, true);
	};

	EventEmitter.prototype.rawListeners = function rawListeners(type) {
	  return _listeners(this, type, false);
	};

	EventEmitter.listenerCount = function(emitter, type) {
	  if (typeof emitter.listenerCount === 'function') {
	    return emitter.listenerCount(type);
	  } else {
	    return listenerCount.call(emitter, type);
	  }
	};

	EventEmitter.prototype.listenerCount = listenerCount;
	function listenerCount(type) {
	  var events = this._events;

	  if (events !== undefined) {
	    var evlistener = events[type];

	    if (typeof evlistener === 'function') {
	      return 1;
	    } else if (evlistener !== undefined) {
	      return evlistener.length;
	    }
	  }

	  return 0;
	}

	EventEmitter.prototype.eventNames = function eventNames() {
	  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
	};

	function arrayClone$1(arr, n) {
	  var copy = new Array(n);
	  for (var i = 0; i < n; ++i)
	    copy[i] = arr[i];
	  return copy;
	}

	function spliceOne(list, index) {
	  for (; index + 1 < list.length; index++)
	    list[index] = list[index + 1];
	  list.pop();
	}

	function unwrapListeners(arr) {
	  var ret = new Array(arr.length);
	  for (var i = 0; i < ret.length; ++i) {
	    ret[i] = arr[i].listener || arr[i];
	  }
	  return ret;
	}

	function once$2(emitter, name) {
	  return new Promise(function (resolve, reject) {
	    function errorListener(err) {
	      emitter.removeListener(name, resolver);
	      reject(err);
	    }

	    function resolver() {
	      if (typeof emitter.removeListener === 'function') {
	        emitter.removeListener('error', errorListener);
	      }
	      resolve([].slice.call(arguments));
	    }
	    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
	    if (name !== 'error') {
	      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
	    }
	  });
	}

	function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
	  if (typeof emitter.on === 'function') {
	    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
	  }
	}

	function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
	  if (typeof emitter.on === 'function') {
	    if (flags.once) {
	      emitter.once(name, listener);
	    } else {
	      emitter.on(name, listener);
	    }
	  } else if (typeof emitter.addEventListener === 'function') {
	    // EventTarget does not have `error` event semantics like Node
	    // EventEmitters, we do not listen for `error` events here.
	    emitter.addEventListener(name, function wrapListener(arg) {
	      // IE does not have builtin `{ once: true }` support so we
	      // have to do it manually.
	      if (flags.once) {
	        emitter.removeEventListener(name, wrapListener);
	      }
	      listener(arg);
	    });
	  } else {
	    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
	  }
	}

	var eventsExports = events.exports;
	var Ng = /*@__PURE__*/getDefaultExportFromCjs(eventsExports);

	Object.defineProperty(safeEventEmitter, "__esModule", { value: true });
	const events_1 = eventsExports;
	function safeApply(handler, context, args) {
	    try {
	        Reflect.apply(handler, context, args);
	    }
	    catch (err) {
	        // Throw error after timeout so as not to interrupt the stack
	        setTimeout(() => {
	            throw err;
	        });
	    }
	}
	function arrayClone(arr) {
	    const n = arr.length;
	    const copy = new Array(n);
	    for (let i = 0; i < n; i += 1) {
	        copy[i] = arr[i];
	    }
	    return copy;
	}
	let SafeEventEmitter$2 = class SafeEventEmitter extends events_1.EventEmitter {
	    emit(type, ...args) {
	        let doError = type === 'error';
	        const events = this._events;
	        if (events !== undefined) {
	            doError = doError && events.error === undefined;
	        }
	        else if (!doError) {
	            return false;
	        }
	        // If there is no 'error' event listener then throw.
	        if (doError) {
	            let er;
	            if (args.length > 0) {
	                [er] = args;
	            }
	            if (er instanceof Error) {
	                // Note: The comments on the `throw` lines are intentional, they show
	                // up in Node's output if this results in an unhandled exception.
	                throw er; // Unhandled 'error' event
	            }
	            // At least give some kind of context to the user
	            const err = new Error(`Unhandled error.${er ? ` (${er.message})` : ''}`);
	            err.context = er;
	            throw err; // Unhandled 'error' event
	        }
	        const handler = events[type];
	        if (handler === undefined) {
	            return false;
	        }
	        if (typeof handler === 'function') {
	            safeApply(handler, this, args);
	        }
	        else {
	            const len = handler.length;
	            const listeners = arrayClone(handler);
	            for (let i = 0; i < len; i += 1) {
	                safeApply(listeners[i], this, args);
	            }
	        }
	        return true;
	    }
	};
	safeEventEmitter.default = SafeEventEmitter$2;

	var DiagnosticLogger = {};

	// DiagnosticLogger for debugging purposes only
	Object.defineProperty(DiagnosticLogger, "__esModule", { value: true });
	DiagnosticLogger.EVENTS = void 0;
	DiagnosticLogger.EVENTS = {
	    STARTED_CONNECTING: "walletlink_sdk.started.connecting",
	    CONNECTED_STATE_CHANGE: "walletlink_sdk.connected",
	    DISCONNECTED: "walletlink_sdk.disconnected",
	    METADATA_DESTROYED: "walletlink_sdk_metadata_destroyed",
	    LINKED: "walletlink_sdk.linked",
	    FAILURE: "walletlink_sdk.generic_failure",
	    SESSION_CONFIG_RECEIVED: "walletlink_sdk.session_config_event_received",
	    ETH_ACCOUNTS_STATE: "walletlink_sdk.eth_accounts_state",
	    SESSION_STATE_CHANGE: "walletlink_sdk.session_state_change",
	    UNLINKED_ERROR_STATE: "walletlink_sdk.unlinked_error_state",
	    SKIPPED_CLEARING_SESSION: "walletlink_sdk.skipped_clearing_session",
	    GENERAL_ERROR: "walletlink_sdk.general_error",
	    WEB3_REQUEST: "walletlink_sdk.web3.request",
	    WEB3_REQUEST_PUBLISHED: "walletlink_sdk.web3.request_published",
	    WEB3_RESPONSE: "walletlink_sdk.web3.response",
	    UNKNOWN_ADDRESS_ENCOUNTERED: "walletlink_sdk.unknown_address_encountered",
	};

	var errors$2 = {};

	var dist$5 = {};

	var classes$1 = {};

	var fastSafeStringify = stringify$2;
	stringify$2.default = stringify$2;
	stringify$2.stable = deterministicStringify;
	stringify$2.stableStringify = deterministicStringify;

	var LIMIT_REPLACE_NODE = '[...]';
	var CIRCULAR_REPLACE_NODE = '[Circular]';

	var arr = [];
	var replacerStack = [];

	function defaultOptions () {
	  return {
	    depthLimit: Number.MAX_SAFE_INTEGER,
	    edgesLimit: Number.MAX_SAFE_INTEGER
	  }
	}

	// Regular stringify
	function stringify$2 (obj, replacer, spacer, options) {
	  if (typeof options === 'undefined') {
	    options = defaultOptions();
	  }

	  decirc(obj, '', 0, [], undefined, 0, options);
	  var res;
	  try {
	    if (replacerStack.length === 0) {
	      res = JSON.stringify(obj, replacer, spacer);
	    } else {
	      res = JSON.stringify(obj, replaceGetterValues(replacer), spacer);
	    }
	  } catch (_) {
	    return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]')
	  } finally {
	    while (arr.length !== 0) {
	      var part = arr.pop();
	      if (part.length === 4) {
	        Object.defineProperty(part[0], part[1], part[3]);
	      } else {
	        part[0][part[1]] = part[2];
	      }
	    }
	  }
	  return res
	}

	function setReplace (replace, val, k, parent) {
	  var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
	  if (propertyDescriptor.get !== undefined) {
	    if (propertyDescriptor.configurable) {
	      Object.defineProperty(parent, k, { value: replace });
	      arr.push([parent, k, val, propertyDescriptor]);
	    } else {
	      replacerStack.push([val, k, replace]);
	    }
	  } else {
	    parent[k] = replace;
	    arr.push([parent, k, val]);
	  }
	}

	function decirc (val, k, edgeIndex, stack, parent, depth, options) {
	  depth += 1;
	  var i;
	  if (typeof val === 'object' && val !== null) {
	    for (i = 0; i < stack.length; i++) {
	      if (stack[i] === val) {
	        setReplace(CIRCULAR_REPLACE_NODE, val, k, parent);
	        return
	      }
	    }

	    if (
	      typeof options.depthLimit !== 'undefined' &&
	      depth > options.depthLimit
	    ) {
	      setReplace(LIMIT_REPLACE_NODE, val, k, parent);
	      return
	    }

	    if (
	      typeof options.edgesLimit !== 'undefined' &&
	      edgeIndex + 1 > options.edgesLimit
	    ) {
	      setReplace(LIMIT_REPLACE_NODE, val, k, parent);
	      return
	    }

	    stack.push(val);
	    // Optimize for Arrays. Big arrays could kill the performance otherwise!
	    if (Array.isArray(val)) {
	      for (i = 0; i < val.length; i++) {
	        decirc(val[i], i, i, stack, val, depth, options);
	      }
	    } else {
	      var keys = Object.keys(val);
	      for (i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        decirc(val[key], key, i, stack, val, depth, options);
	      }
	    }
	    stack.pop();
	  }
	}

	// Stable-stringify
	function compareFunction (a, b) {
	  if (a < b) {
	    return -1
	  }
	  if (a > b) {
	    return 1
	  }
	  return 0
	}

	function deterministicStringify (obj, replacer, spacer, options) {
	  if (typeof options === 'undefined') {
	    options = defaultOptions();
	  }

	  var tmp = deterministicDecirc(obj, '', 0, [], undefined, 0, options) || obj;
	  var res;
	  try {
	    if (replacerStack.length === 0) {
	      res = JSON.stringify(tmp, replacer, spacer);
	    } else {
	      res = JSON.stringify(tmp, replaceGetterValues(replacer), spacer);
	    }
	  } catch (_) {
	    return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]')
	  } finally {
	    // Ensure that we restore the object as it was.
	    while (arr.length !== 0) {
	      var part = arr.pop();
	      if (part.length === 4) {
	        Object.defineProperty(part[0], part[1], part[3]);
	      } else {
	        part[0][part[1]] = part[2];
	      }
	    }
	  }
	  return res
	}

	function deterministicDecirc (val, k, edgeIndex, stack, parent, depth, options) {
	  depth += 1;
	  var i;
	  if (typeof val === 'object' && val !== null) {
	    for (i = 0; i < stack.length; i++) {
	      if (stack[i] === val) {
	        setReplace(CIRCULAR_REPLACE_NODE, val, k, parent);
	        return
	      }
	    }
	    try {
	      if (typeof val.toJSON === 'function') {
	        return
	      }
	    } catch (_) {
	      return
	    }

	    if (
	      typeof options.depthLimit !== 'undefined' &&
	      depth > options.depthLimit
	    ) {
	      setReplace(LIMIT_REPLACE_NODE, val, k, parent);
	      return
	    }

	    if (
	      typeof options.edgesLimit !== 'undefined' &&
	      edgeIndex + 1 > options.edgesLimit
	    ) {
	      setReplace(LIMIT_REPLACE_NODE, val, k, parent);
	      return
	    }

	    stack.push(val);
	    // Optimize for Arrays. Big arrays could kill the performance otherwise!
	    if (Array.isArray(val)) {
	      for (i = 0; i < val.length; i++) {
	        deterministicDecirc(val[i], i, i, stack, val, depth, options);
	      }
	    } else {
	      // Create a temporary object in the required way
	      var tmp = {};
	      var keys = Object.keys(val).sort(compareFunction);
	      for (i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        deterministicDecirc(val[key], key, i, stack, val, depth, options);
	        tmp[key] = val[key];
	      }
	      if (typeof parent !== 'undefined') {
	        arr.push([parent, k, val]);
	        parent[k] = tmp;
	      } else {
	        return tmp
	      }
	    }
	    stack.pop();
	  }
	}

	// wraps replacer function to handle values we couldn't replace
	// and mark them as replaced value
	function replaceGetterValues (replacer) {
	  replacer =
	    typeof replacer !== 'undefined'
	      ? replacer
	      : function (k, v) {
	        return v
	      };
	  return function (key, val) {
	    if (replacerStack.length > 0) {
	      for (var i = 0; i < replacerStack.length; i++) {
	        var part = replacerStack[i];
	        if (part[1] === key && part[0] === val) {
	          val = part[2];
	          replacerStack.splice(i, 1);
	          break
	        }
	      }
	    }
	    return replacer.call(this, key, val)
	  }
	}

	Object.defineProperty(classes$1, "__esModule", { value: true });
	classes$1.EthereumProviderError = classes$1.EthereumRpcError = void 0;
	const fast_safe_stringify_1$1 = fastSafeStringify;
	/**
	 * Error subclass implementing JSON RPC 2.0 errors and Ethereum RPC errors
	 * per EIP-1474.
	 * Permits any integer error code.
	 */
	let EthereumRpcError$1 = class EthereumRpcError extends Error {
	    constructor(code, message, data) {
	        if (!Number.isInteger(code)) {
	            throw new Error('"code" must be an integer.');
	        }
	        if (!message || typeof message !== 'string') {
	            throw new Error('"message" must be a nonempty string.');
	        }
	        super(message);
	        this.code = code;
	        if (data !== undefined) {
	            this.data = data;
	        }
	    }
	    /**
	     * Returns a plain object with all public class properties.
	     */
	    serialize() {
	        const serialized = {
	            code: this.code,
	            message: this.message,
	        };
	        if (this.data !== undefined) {
	            serialized.data = this.data;
	        }
	        if (this.stack) {
	            serialized.stack = this.stack;
	        }
	        return serialized;
	    }
	    /**
	     * Return a string representation of the serialized error, omitting
	     * any circular references.
	     */
	    toString() {
	        return fast_safe_stringify_1$1.default(this.serialize(), stringifyReplacer$1, 2);
	    }
	};
	classes$1.EthereumRpcError = EthereumRpcError$1;
	/**
	 * Error subclass implementing Ethereum Provider errors per EIP-1193.
	 * Permits integer error codes in the [ 1000 <= 4999 ] range.
	 */
	let EthereumProviderError$1 = class EthereumProviderError extends EthereumRpcError$1 {
	    /**
	     * Create an Ethereum Provider JSON-RPC error.
	     * `code` must be an integer in the 1000 <= 4999 range.
	     */
	    constructor(code, message, data) {
	        if (!isValidEthProviderCode$1(code)) {
	            throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
	        }
	        super(code, message, data);
	    }
	};
	classes$1.EthereumProviderError = EthereumProviderError$1;
	// Internal
	function isValidEthProviderCode$1(code) {
	    return Number.isInteger(code) && code >= 1000 && code <= 4999;
	}
	function stringifyReplacer$1(_, value) {
	    if (value === '[Circular]') {
	        return undefined;
	    }
	    return value;
	}

	var utils$8 = {};

	var errorConstants$1 = {};

	Object.defineProperty(errorConstants$1, "__esModule", { value: true });
	errorConstants$1.errorValues = errorConstants$1.errorCodes = void 0;
	errorConstants$1.errorCodes = {
	    rpc: {
	        invalidInput: -32000,
	        resourceNotFound: -32001,
	        resourceUnavailable: -32002,
	        transactionRejected: -32003,
	        methodNotSupported: -32004,
	        limitExceeded: -32005,
	        parse: -32700,
	        invalidRequest: -32600,
	        methodNotFound: -32601,
	        invalidParams: -32602,
	        internal: -32603,
	    },
	    provider: {
	        userRejectedRequest: 4001,
	        unauthorized: 4100,
	        unsupportedMethod: 4200,
	        disconnected: 4900,
	        chainDisconnected: 4901,
	    },
	};
	errorConstants$1.errorValues = {
	    '-32700': {
	        standard: 'JSON RPC 2.0',
	        message: 'Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text.',
	    },
	    '-32600': {
	        standard: 'JSON RPC 2.0',
	        message: 'The JSON sent is not a valid Request object.',
	    },
	    '-32601': {
	        standard: 'JSON RPC 2.0',
	        message: 'The method does not exist / is not available.',
	    },
	    '-32602': {
	        standard: 'JSON RPC 2.0',
	        message: 'Invalid method parameter(s).',
	    },
	    '-32603': {
	        standard: 'JSON RPC 2.0',
	        message: 'Internal JSON-RPC error.',
	    },
	    '-32000': {
	        standard: 'EIP-1474',
	        message: 'Invalid input.',
	    },
	    '-32001': {
	        standard: 'EIP-1474',
	        message: 'Resource not found.',
	    },
	    '-32002': {
	        standard: 'EIP-1474',
	        message: 'Resource unavailable.',
	    },
	    '-32003': {
	        standard: 'EIP-1474',
	        message: 'Transaction rejected.',
	    },
	    '-32004': {
	        standard: 'EIP-1474',
	        message: 'Method not supported.',
	    },
	    '-32005': {
	        standard: 'EIP-1474',
	        message: 'Request limit exceeded.',
	    },
	    '4001': {
	        standard: 'EIP-1193',
	        message: 'User rejected the request.',
	    },
	    '4100': {
	        standard: 'EIP-1193',
	        message: 'The requested account and/or method has not been authorized by the user.',
	    },
	    '4200': {
	        standard: 'EIP-1193',
	        message: 'The requested method is not supported by this Ethereum provider.',
	    },
	    '4900': {
	        standard: 'EIP-1193',
	        message: 'The provider is disconnected from all chains.',
	    },
	    '4901': {
	        standard: 'EIP-1193',
	        message: 'The provider is disconnected from the specified chain.',
	    },
	};

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.serializeError = exports.isValidCode = exports.getMessageFromCode = exports.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
		const error_constants_1 = errorConstants$1;
		const classes_1 = classes$1;
		const FALLBACK_ERROR_CODE = error_constants_1.errorCodes.rpc.internal;
		const FALLBACK_MESSAGE = 'Unspecified error message. This is a bug, please report it.';
		const FALLBACK_ERROR = {
		    code: FALLBACK_ERROR_CODE,
		    message: getMessageFromCode(FALLBACK_ERROR_CODE),
		};
		exports.JSON_RPC_SERVER_ERROR_MESSAGE = 'Unspecified server error.';
		/**
		 * Gets the message for a given code, or a fallback message if the code has
		 * no corresponding message.
		 */
		function getMessageFromCode(code, fallbackMessage = FALLBACK_MESSAGE) {
		    if (Number.isInteger(code)) {
		        const codeString = code.toString();
		        if (hasKey(error_constants_1.errorValues, codeString)) {
		            return error_constants_1.errorValues[codeString].message;
		        }
		        if (isJsonRpcServerError(code)) {
		            return exports.JSON_RPC_SERVER_ERROR_MESSAGE;
		        }
		    }
		    return fallbackMessage;
		}
		exports.getMessageFromCode = getMessageFromCode;
		/**
		 * Returns whether the given code is valid.
		 * A code is only valid if it has a message.
		 */
		function isValidCode(code) {
		    if (!Number.isInteger(code)) {
		        return false;
		    }
		    const codeString = code.toString();
		    if (error_constants_1.errorValues[codeString]) {
		        return true;
		    }
		    if (isJsonRpcServerError(code)) {
		        return true;
		    }
		    return false;
		}
		exports.isValidCode = isValidCode;
		/**
		 * Serializes the given error to an Ethereum JSON RPC-compatible error object.
		 * Merely copies the given error's values if it is already compatible.
		 * If the given error is not fully compatible, it will be preserved on the
		 * returned object's data.originalError property.
		 */
		function serializeError(error, { fallbackError = FALLBACK_ERROR, shouldIncludeStack = false, } = {}) {
		    var _a, _b;
		    if (!fallbackError ||
		        !Number.isInteger(fallbackError.code) ||
		        typeof fallbackError.message !== 'string') {
		        throw new Error('Must provide fallback error with integer number code and string message.');
		    }
		    if (error instanceof classes_1.EthereumRpcError) {
		        return error.serialize();
		    }
		    const serialized = {};
		    if (error &&
		        typeof error === 'object' &&
		        !Array.isArray(error) &&
		        hasKey(error, 'code') &&
		        isValidCode(error.code)) {
		        const _error = error;
		        serialized.code = _error.code;
		        if (_error.message && typeof _error.message === 'string') {
		            serialized.message = _error.message;
		            if (hasKey(_error, 'data')) {
		                serialized.data = _error.data;
		            }
		        }
		        else {
		            serialized.message = getMessageFromCode(serialized.code);
		            serialized.data = { originalError: assignOriginalError(error) };
		        }
		    }
		    else {
		        serialized.code = fallbackError.code;
		        const message = (_a = error) === null || _a === void 0 ? void 0 : _a.message;
		        serialized.message = (message && typeof message === 'string'
		            ? message
		            : fallbackError.message);
		        serialized.data = { originalError: assignOriginalError(error) };
		    }
		    const stack = (_b = error) === null || _b === void 0 ? void 0 : _b.stack;
		    if (shouldIncludeStack && error && stack && typeof stack === 'string') {
		        serialized.stack = stack;
		    }
		    return serialized;
		}
		exports.serializeError = serializeError;
		// Internal
		function isJsonRpcServerError(code) {
		    return code >= -32099 && code <= -32000;
		}
		function assignOriginalError(error) {
		    if (error && typeof error === 'object' && !Array.isArray(error)) {
		        return Object.assign({}, error);
		    }
		    return error;
		}
		function hasKey(obj, key) {
		    return Object.prototype.hasOwnProperty.call(obj, key);
		}
		
	} (utils$8));

	var errors$1 = {};

	Object.defineProperty(errors$1, "__esModule", { value: true });
	errors$1.ethErrors = void 0;
	const classes_1$1 = classes$1;
	const utils_1$1 = utils$8;
	const error_constants_1$1 = errorConstants$1;
	errors$1.ethErrors = {
	    rpc: {
	        /**
	         * Get a JSON RPC 2.0 Parse (-32700) error.
	         */
	        parse: (arg) => getEthJsonRpcError$1(error_constants_1$1.errorCodes.rpc.parse, arg),
	        /**
	         * Get a JSON RPC 2.0 Invalid Request (-32600) error.
	         */
	        invalidRequest: (arg) => getEthJsonRpcError$1(error_constants_1$1.errorCodes.rpc.invalidRequest, arg),
	        /**
	         * Get a JSON RPC 2.0 Invalid Params (-32602) error.
	         */
	        invalidParams: (arg) => getEthJsonRpcError$1(error_constants_1$1.errorCodes.rpc.invalidParams, arg),
	        /**
	         * Get a JSON RPC 2.0 Method Not Found (-32601) error.
	         */
	        methodNotFound: (arg) => getEthJsonRpcError$1(error_constants_1$1.errorCodes.rpc.methodNotFound, arg),
	        /**
	         * Get a JSON RPC 2.0 Internal (-32603) error.
	         */
	        internal: (arg) => getEthJsonRpcError$1(error_constants_1$1.errorCodes.rpc.internal, arg),
	        /**
	         * Get a JSON RPC 2.0 Server error.
	         * Permits integer error codes in the [ -32099 <= -32005 ] range.
	         * Codes -32000 through -32004 are reserved by EIP-1474.
	         */
	        server: (opts) => {
	            if (!opts || typeof opts !== 'object' || Array.isArray(opts)) {
	                throw new Error('Ethereum RPC Server errors must provide single object argument.');
	            }
	            const { code } = opts;
	            if (!Number.isInteger(code) || code > -32005 || code < -32099) {
	                throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
	            }
	            return getEthJsonRpcError$1(code, opts);
	        },
	        /**
	         * Get an Ethereum JSON RPC Invalid Input (-32000) error.
	         */
	        invalidInput: (arg) => getEthJsonRpcError$1(error_constants_1$1.errorCodes.rpc.invalidInput, arg),
	        /**
	         * Get an Ethereum JSON RPC Resource Not Found (-32001) error.
	         */
	        resourceNotFound: (arg) => getEthJsonRpcError$1(error_constants_1$1.errorCodes.rpc.resourceNotFound, arg),
	        /**
	         * Get an Ethereum JSON RPC Resource Unavailable (-32002) error.
	         */
	        resourceUnavailable: (arg) => getEthJsonRpcError$1(error_constants_1$1.errorCodes.rpc.resourceUnavailable, arg),
	        /**
	         * Get an Ethereum JSON RPC Transaction Rejected (-32003) error.
	         */
	        transactionRejected: (arg) => getEthJsonRpcError$1(error_constants_1$1.errorCodes.rpc.transactionRejected, arg),
	        /**
	         * Get an Ethereum JSON RPC Method Not Supported (-32004) error.
	         */
	        methodNotSupported: (arg) => getEthJsonRpcError$1(error_constants_1$1.errorCodes.rpc.methodNotSupported, arg),
	        /**
	         * Get an Ethereum JSON RPC Limit Exceeded (-32005) error.
	         */
	        limitExceeded: (arg) => getEthJsonRpcError$1(error_constants_1$1.errorCodes.rpc.limitExceeded, arg),
	    },
	    provider: {
	        /**
	         * Get an Ethereum Provider User Rejected Request (4001) error.
	         */
	        userRejectedRequest: (arg) => {
	            return getEthProviderError$1(error_constants_1$1.errorCodes.provider.userRejectedRequest, arg);
	        },
	        /**
	         * Get an Ethereum Provider Unauthorized (4100) error.
	         */
	        unauthorized: (arg) => {
	            return getEthProviderError$1(error_constants_1$1.errorCodes.provider.unauthorized, arg);
	        },
	        /**
	         * Get an Ethereum Provider Unsupported Method (4200) error.
	         */
	        unsupportedMethod: (arg) => {
	            return getEthProviderError$1(error_constants_1$1.errorCodes.provider.unsupportedMethod, arg);
	        },
	        /**
	         * Get an Ethereum Provider Not Connected (4900) error.
	         */
	        disconnected: (arg) => {
	            return getEthProviderError$1(error_constants_1$1.errorCodes.provider.disconnected, arg);
	        },
	        /**
	         * Get an Ethereum Provider Chain Not Connected (4901) error.
	         */
	        chainDisconnected: (arg) => {
	            return getEthProviderError$1(error_constants_1$1.errorCodes.provider.chainDisconnected, arg);
	        },
	        /**
	         * Get a custom Ethereum Provider error.
	         */
	        custom: (opts) => {
	            if (!opts || typeof opts !== 'object' || Array.isArray(opts)) {
	                throw new Error('Ethereum Provider custom errors must provide single object argument.');
	            }
	            const { code, message, data } = opts;
	            if (!message || typeof message !== 'string') {
	                throw new Error('"message" must be a nonempty string');
	            }
	            return new classes_1$1.EthereumProviderError(code, message, data);
	        },
	    },
	};
	// Internal
	function getEthJsonRpcError$1(code, arg) {
	    const [message, data] = parseOpts$1(arg);
	    return new classes_1$1.EthereumRpcError(code, message || utils_1$1.getMessageFromCode(code), data);
	}
	function getEthProviderError$1(code, arg) {
	    const [message, data] = parseOpts$1(arg);
	    return new classes_1$1.EthereumProviderError(code, message || utils_1$1.getMessageFromCode(code), data);
	}
	function parseOpts$1(arg) {
	    if (arg) {
	        if (typeof arg === 'string') {
	            return [arg];
	        }
	        else if (typeof arg === 'object' && !Array.isArray(arg)) {
	            const { message, data } = arg;
	            if (message && typeof message !== 'string') {
	                throw new Error('Must specify string message.');
	            }
	            return [message || undefined, data];
	        }
	    }
	    return [];
	}

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.getMessageFromCode = exports.serializeError = exports.EthereumProviderError = exports.EthereumRpcError = exports.ethErrors = exports.errorCodes = void 0;
		const classes_1 = classes$1;
		Object.defineProperty(exports, "EthereumRpcError", { enumerable: true, get: function () { return classes_1.EthereumRpcError; } });
		Object.defineProperty(exports, "EthereumProviderError", { enumerable: true, get: function () { return classes_1.EthereumProviderError; } });
		const utils_1 = utils$8;
		Object.defineProperty(exports, "serializeError", { enumerable: true, get: function () { return utils_1.serializeError; } });
		Object.defineProperty(exports, "getMessageFromCode", { enumerable: true, get: function () { return utils_1.getMessageFromCode; } });
		const errors_1 = errors$1;
		Object.defineProperty(exports, "ethErrors", { enumerable: true, get: function () { return errors_1.ethErrors; } });
		const error_constants_1 = errorConstants$1;
		Object.defineProperty(exports, "errorCodes", { enumerable: true, get: function () { return error_constants_1.errorCodes; } });
		
	} (dist$5));

	var Web3Response = {};

	var Web3Method = {};

	(function (exports) {
		// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
		// Licensed under the Apache License, version 2.0
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Web3Method = void 0;
		(function (Web3Method) {
		    Web3Method["requestEthereumAccounts"] = "requestEthereumAccounts";
		    Web3Method["signEthereumMessage"] = "signEthereumMessage";
		    Web3Method["signEthereumTransaction"] = "signEthereumTransaction";
		    Web3Method["submitEthereumTransaction"] = "submitEthereumTransaction";
		    Web3Method["ethereumAddressFromSignedMessage"] = "ethereumAddressFromSignedMessage";
		    Web3Method["scanQRCode"] = "scanQRCode";
		    Web3Method["generic"] = "generic";
		    Web3Method["childRequestEthereumAccounts"] = "childRequestEthereumAccounts";
		    Web3Method["addEthereumChain"] = "addEthereumChain";
		    Web3Method["switchEthereumChain"] = "switchEthereumChain";
		    Web3Method["makeEthereumJSONRPCRequest"] = "makeEthereumJSONRPCRequest";
		    Web3Method["watchAsset"] = "watchAsset";
		    Web3Method["selectProvider"] = "selectProvider";
		})(exports.Web3Method || (exports.Web3Method = {})); 
	} (Web3Method));

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(Web3Response, "__esModule", { value: true });
	Web3Response.EthereumAddressFromSignedMessageResponse = Web3Response.SubmitEthereumTransactionResponse = Web3Response.SignEthereumTransactionResponse = Web3Response.SignEthereumMessageResponse = Web3Response.isRequestEthereumAccountsResponse = Web3Response.SelectProviderResponse = Web3Response.WatchAssetReponse = Web3Response.RequestEthereumAccountsResponse = Web3Response.SwitchEthereumChainResponse = Web3Response.AddEthereumChainResponse = Web3Response.isErrorResponse = void 0;
	const Web3Method_1$2 = Web3Method;
	function isErrorResponse(response) {
	    var _a, _b;
	    return (((_a = response) === null || _a === void 0 ? void 0 : _a.method) !== undefined &&
	        ((_b = response) === null || _b === void 0 ? void 0 : _b.errorMessage) !== undefined);
	}
	Web3Response.isErrorResponse = isErrorResponse;
	function AddEthereumChainResponse(addResponse) {
	    return {
	        method: Web3Method_1$2.Web3Method.addEthereumChain,
	        result: addResponse,
	    };
	}
	Web3Response.AddEthereumChainResponse = AddEthereumChainResponse;
	function SwitchEthereumChainResponse(switchResponse) {
	    return {
	        method: Web3Method_1$2.Web3Method.switchEthereumChain,
	        result: switchResponse,
	    };
	}
	Web3Response.SwitchEthereumChainResponse = SwitchEthereumChainResponse;
	function RequestEthereumAccountsResponse(addresses) {
	    return { method: Web3Method_1$2.Web3Method.requestEthereumAccounts, result: addresses };
	}
	Web3Response.RequestEthereumAccountsResponse = RequestEthereumAccountsResponse;
	function WatchAssetReponse(success) {
	    return { method: Web3Method_1$2.Web3Method.watchAsset, result: success };
	}
	Web3Response.WatchAssetReponse = WatchAssetReponse;
	function SelectProviderResponse(selectedProviderKey) {
	    return { method: Web3Method_1$2.Web3Method.selectProvider, result: selectedProviderKey };
	}
	Web3Response.SelectProviderResponse = SelectProviderResponse;
	function isRequestEthereumAccountsResponse(res) {
	    return res && res.method === Web3Method_1$2.Web3Method.requestEthereumAccounts;
	}
	Web3Response.isRequestEthereumAccountsResponse = isRequestEthereumAccountsResponse;
	function SignEthereumMessageResponse(signature) {
	    return { method: Web3Method_1$2.Web3Method.signEthereumMessage, result: signature };
	}
	Web3Response.SignEthereumMessageResponse = SignEthereumMessageResponse;
	function SignEthereumTransactionResponse(signedData) {
	    return { method: Web3Method_1$2.Web3Method.signEthereumTransaction, result: signedData };
	}
	Web3Response.SignEthereumTransactionResponse = SignEthereumTransactionResponse;
	function SubmitEthereumTransactionResponse(txHash) {
	    return { method: Web3Method_1$2.Web3Method.submitEthereumTransaction, result: txHash };
	}
	Web3Response.SubmitEthereumTransactionResponse = SubmitEthereumTransactionResponse;
	function EthereumAddressFromSignedMessageResponse(address) {
	    return {
	        method: Web3Method_1$2.Web3Method.ethereumAddressFromSignedMessage,
	        result: address,
	    };
	}
	Web3Response.EthereumAddressFromSignedMessageResponse = EthereumAddressFromSignedMessageResponse;

	var version$2 = {};

	Object.defineProperty(version$2, "__esModule", { value: true });
	version$2.LIB_VERSION = void 0;
	version$2.LIB_VERSION = "3.7.1";

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.getErrorCode = exports.serializeError = exports.standardErrors = exports.standardErrorMessage = exports.standardErrorCodes = void 0;
		// eslint-disable-next-line no-restricted-imports
		const eth_rpc_errors_1 = dist$5;
		const Web3Response_1 = Web3Response;
		const version_1 = version$2;
		exports.standardErrorCodes = Object.freeze(Object.assign(Object.assign({}, eth_rpc_errors_1.errorCodes), { provider: Object.freeze(Object.assign(Object.assign({}, eth_rpc_errors_1.errorCodes.provider), { unsupportedChain: 4902 })) }));
		function standardErrorMessage(code) {
		    return code !== undefined ? (0, eth_rpc_errors_1.getMessageFromCode)(code) : "Unknown error";
		}
		exports.standardErrorMessage = standardErrorMessage;
		exports.standardErrors = Object.freeze(Object.assign(Object.assign({}, eth_rpc_errors_1.ethErrors), { provider: Object.freeze(Object.assign(Object.assign({}, eth_rpc_errors_1.ethErrors.provider), { unsupportedChain: (chainId = "") => eth_rpc_errors_1.ethErrors.provider.custom({
		            code: exports.standardErrorCodes.provider.unsupportedChain,
		            message: `Unrecognized chain ID ${chainId}. Try adding the chain using wallet_addEthereumChain first.`,
		        }) })) }));
		/**
		 * Serializes an error to a format that is compatible with the Ethereum JSON RPC error format.
		 * See https://docs.cloud.coinbase.com/wallet-sdk/docs/errors
		 * for more information.
		 */
		function serializeError(error, requestOrMethod) {
		    const serialized = (0, eth_rpc_errors_1.serializeError)(getErrorObject(error), {
		        shouldIncludeStack: true,
		    });
		    const docUrl = new URL("https://docs.cloud.coinbase.com/wallet-sdk/docs/errors");
		    docUrl.searchParams.set("version", version_1.LIB_VERSION);
		    docUrl.searchParams.set("code", serialized.code.toString());
		    const method = getMethod(serialized.data, requestOrMethod);
		    if (method) {
		        docUrl.searchParams.set("method", method);
		    }
		    docUrl.searchParams.set("message", serialized.message);
		    return Object.assign(Object.assign({}, serialized), { docUrl: docUrl.href });
		}
		exports.serializeError = serializeError;
		/**
		 * Converts an error to a serializable object.
		 */
		function getErrorObject(error) {
		    if (typeof error === "string") {
		        return {
		            message: error,
		            code: exports.standardErrorCodes.rpc.internal,
		        };
		    }
		    else if ((0, Web3Response_1.isErrorResponse)(error)) {
		        return Object.assign(Object.assign({}, error), { message: error.errorMessage, code: error.errorCode, data: { method: error.method, result: error.result } });
		    }
		    else {
		        return error;
		    }
		}
		/**
		 * Gets the method name from the serialized data or the request.
		 */
		function getMethod(serializedData, request) {
		    var _a;
		    const methodInData = (_a = serializedData) === null || _a === void 0 ? void 0 : _a.method;
		    if (methodInData) {
		        return methodInData;
		    }
		    if (request === undefined) {
		        return undefined;
		    }
		    else if (typeof request === "string") {
		        return request;
		    }
		    else if (!Array.isArray(request)) {
		        return request.method;
		    }
		    else if (request.length > 0) {
		        return request[0].method;
		    }
		    else {
		        return undefined;
		    }
		}
		// ----------------- getErrorCode -----------------
		/**
		 * Returns the error code from an error object.
		 */
		function getErrorCode(error) {
		    var _a;
		    if (typeof error === "number") {
		        return error;
		    }
		    else if (isErrorWithCode(error)) {
		        return (_a = error.code) !== null && _a !== void 0 ? _a : error.errorCode;
		    }
		    return undefined;
		}
		exports.getErrorCode = getErrorCode;
		function isErrorWithCode(error) {
		    return (typeof error === "object" &&
		        error !== null &&
		        (typeof error.code === "number" ||
		            typeof error.errorCode === "number"));
		} 
	} (errors$2));

	var Session$1 = {};

	var sha_js = {exports: {}};

	var safeBuffer = {exports: {}};

	/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */

	(function (module, exports) {
		/* eslint-disable node/no-deprecated-api */
		var buffer = buffer$2;
		var Buffer = buffer.Buffer;

		// alternative to using Object.keys for old browsers
		function copyProps (src, dst) {
		  for (var key in src) {
		    dst[key] = src[key];
		  }
		}
		if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
		  module.exports = buffer;
		} else {
		  // Copy properties from require('buffer')
		  copyProps(buffer, exports);
		  exports.Buffer = SafeBuffer;
		}

		function SafeBuffer (arg, encodingOrOffset, length) {
		  return Buffer(arg, encodingOrOffset, length)
		}

		SafeBuffer.prototype = Object.create(Buffer.prototype);

		// Copy static methods from Buffer
		copyProps(Buffer, SafeBuffer);

		SafeBuffer.from = function (arg, encodingOrOffset, length) {
		  if (typeof arg === 'number') {
		    throw new TypeError('Argument must not be a number')
		  }
		  return Buffer(arg, encodingOrOffset, length)
		};

		SafeBuffer.alloc = function (size, fill, encoding) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  var buf = Buffer(size);
		  if (fill !== undefined) {
		    if (typeof encoding === 'string') {
		      buf.fill(fill, encoding);
		    } else {
		      buf.fill(fill);
		    }
		  } else {
		    buf.fill(0);
		  }
		  return buf
		};

		SafeBuffer.allocUnsafe = function (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  return Buffer(size)
		};

		SafeBuffer.allocUnsafeSlow = function (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('Argument must be a number')
		  }
		  return buffer.SlowBuffer(size)
		}; 
	} (safeBuffer, safeBuffer.exports));

	var safeBufferExports = safeBuffer.exports;

	var Buffer$7 = safeBufferExports.Buffer;

	// prototype class for hash functions
	function Hash$6 (blockSize, finalSize) {
	  this._block = Buffer$7.alloc(blockSize);
	  this._finalSize = finalSize;
	  this._blockSize = blockSize;
	  this._len = 0;
	}

	Hash$6.prototype.update = function (data, enc) {
	  if (typeof data === 'string') {
	    enc = enc || 'utf8';
	    data = Buffer$7.from(data, enc);
	  }

	  var block = this._block;
	  var blockSize = this._blockSize;
	  var length = data.length;
	  var accum = this._len;

	  for (var offset = 0; offset < length;) {
	    var assigned = accum % blockSize;
	    var remainder = Math.min(length - offset, blockSize - assigned);

	    for (var i = 0; i < remainder; i++) {
	      block[assigned + i] = data[offset + i];
	    }

	    accum += remainder;
	    offset += remainder;

	    if ((accum % blockSize) === 0) {
	      this._update(block);
	    }
	  }

	  this._len += length;
	  return this
	};

	Hash$6.prototype.digest = function (enc) {
	  var rem = this._len % this._blockSize;

	  this._block[rem] = 0x80;

	  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	  this._block.fill(0, rem + 1);

	  if (rem >= this._finalSize) {
	    this._update(this._block);
	    this._block.fill(0);
	  }

	  var bits = this._len * 8;

	  // uint32
	  if (bits <= 0xffffffff) {
	    this._block.writeUInt32BE(bits, this._blockSize - 4);

	  // uint64
	  } else {
	    var lowBits = (bits & 0xffffffff) >>> 0;
	    var highBits = (bits - lowBits) / 0x100000000;

	    this._block.writeUInt32BE(highBits, this._blockSize - 8);
	    this._block.writeUInt32BE(lowBits, this._blockSize - 4);
	  }

	  this._update(this._block);
	  var hash = this._hash();

	  return enc ? hash.toString(enc) : hash
	};

	Hash$6.prototype._update = function () {
	  throw new Error('_update must be implemented by subclass')
	};

	var hash = Hash$6;

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
	 * in FIPS PUB 180-1
	 * This source code is derived from sha1.js of the same repository.
	 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
	 * operation was added.
	 */

	var inherits$5 = inherits_browserExports;
	var Hash$5 = hash;
	var Buffer$6 = safeBufferExports.Buffer;

	var K$6 = [
	  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
	];

	var W$7 = new Array(80);

	function Sha () {
	  this.init();
	  this._w = W$7;

	  Hash$5.call(this, 64, 56);
	}

	inherits$5(Sha, Hash$5);

	Sha.prototype.init = function () {
	  this._a = 0x67452301;
	  this._b = 0xefcdab89;
	  this._c = 0x98badcfe;
	  this._d = 0x10325476;
	  this._e = 0xc3d2e1f0;

	  return this
	};

	function rotl5$1 (num) {
	  return (num << 5) | (num >>> 27)
	}

	function rotl30$1 (num) {
	  return (num << 30) | (num >>> 2)
	}

	function ft$3 (s, b, c, d) {
	  if (s === 0) return (b & c) | ((~b) & d)
	  if (s === 2) return (b & c) | (b & d) | (c & d)
	  return b ^ c ^ d
	}

	Sha.prototype._update = function (M) {
	  var W = this._w;

	  var a = this._a | 0;
	  var b = this._b | 0;
	  var c = this._c | 0;
	  var d = this._d | 0;
	  var e = this._e | 0;

	  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4);
	  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];

	  for (var j = 0; j < 80; ++j) {
	    var s = ~~(j / 20);
	    var t = (rotl5$1(a) + ft$3(s, b, c, d) + e + W[j] + K$6[s]) | 0;

	    e = d;
	    d = c;
	    c = rotl30$1(b);
	    b = a;
	    a = t;
	  }

	  this._a = (a + this._a) | 0;
	  this._b = (b + this._b) | 0;
	  this._c = (c + this._c) | 0;
	  this._d = (d + this._d) | 0;
	  this._e = (e + this._e) | 0;
	};

	Sha.prototype._hash = function () {
	  var H = Buffer$6.allocUnsafe(20);

	  H.writeInt32BE(this._a | 0, 0);
	  H.writeInt32BE(this._b | 0, 4);
	  H.writeInt32BE(this._c | 0, 8);
	  H.writeInt32BE(this._d | 0, 12);
	  H.writeInt32BE(this._e | 0, 16);

	  return H
	};

	var sha = Sha;

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */

	var inherits$4 = inherits_browserExports;
	var Hash$4 = hash;
	var Buffer$5 = safeBufferExports.Buffer;

	var K$5 = [
	  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
	];

	var W$6 = new Array(80);

	function Sha1 () {
	  this.init();
	  this._w = W$6;

	  Hash$4.call(this, 64, 56);
	}

	inherits$4(Sha1, Hash$4);

	Sha1.prototype.init = function () {
	  this._a = 0x67452301;
	  this._b = 0xefcdab89;
	  this._c = 0x98badcfe;
	  this._d = 0x10325476;
	  this._e = 0xc3d2e1f0;

	  return this
	};

	function rotl1 (num) {
	  return (num << 1) | (num >>> 31)
	}

	function rotl5 (num) {
	  return (num << 5) | (num >>> 27)
	}

	function rotl30 (num) {
	  return (num << 30) | (num >>> 2)
	}

	function ft$2 (s, b, c, d) {
	  if (s === 0) return (b & c) | ((~b) & d)
	  if (s === 2) return (b & c) | (b & d) | (c & d)
	  return b ^ c ^ d
	}

	Sha1.prototype._update = function (M) {
	  var W = this._w;

	  var a = this._a | 0;
	  var b = this._b | 0;
	  var c = this._c | 0;
	  var d = this._d | 0;
	  var e = this._e | 0;

	  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4);
	  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);

	  for (var j = 0; j < 80; ++j) {
	    var s = ~~(j / 20);
	    var t = (rotl5(a) + ft$2(s, b, c, d) + e + W[j] + K$5[s]) | 0;

	    e = d;
	    d = c;
	    c = rotl30(b);
	    b = a;
	    a = t;
	  }

	  this._a = (a + this._a) | 0;
	  this._b = (b + this._b) | 0;
	  this._c = (c + this._c) | 0;
	  this._d = (d + this._d) | 0;
	  this._e = (e + this._e) | 0;
	};

	Sha1.prototype._hash = function () {
	  var H = Buffer$5.allocUnsafe(20);

	  H.writeInt32BE(this._a | 0, 0);
	  H.writeInt32BE(this._b | 0, 4);
	  H.writeInt32BE(this._c | 0, 8);
	  H.writeInt32BE(this._d | 0, 12);
	  H.writeInt32BE(this._e | 0, 16);

	  return H
	};

	var sha1 = Sha1;

	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */

	var inherits$3 = inherits_browserExports;
	var Hash$3 = hash;
	var Buffer$4 = safeBufferExports.Buffer;

	var K$4 = [
	  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	];

	var W$5 = new Array(64);

	function Sha256$1 () {
	  this.init();

	  this._w = W$5; // new Array(64)

	  Hash$3.call(this, 64, 56);
	}

	inherits$3(Sha256$1, Hash$3);

	Sha256$1.prototype.init = function () {
	  this._a = 0x6a09e667;
	  this._b = 0xbb67ae85;
	  this._c = 0x3c6ef372;
	  this._d = 0xa54ff53a;
	  this._e = 0x510e527f;
	  this._f = 0x9b05688c;
	  this._g = 0x1f83d9ab;
	  this._h = 0x5be0cd19;

	  return this
	};

	function ch (x, y, z) {
	  return z ^ (x & (y ^ z))
	}

	function maj$1 (x, y, z) {
	  return (x & y) | (z & (x | y))
	}

	function sigma0$1 (x) {
	  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
	}

	function sigma1$1 (x) {
	  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
	}

	function gamma0 (x) {
	  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
	}

	function gamma1 (x) {
	  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
	}

	Sha256$1.prototype._update = function (M) {
	  var W = this._w;

	  var a = this._a | 0;
	  var b = this._b | 0;
	  var c = this._c | 0;
	  var d = this._d | 0;
	  var e = this._e | 0;
	  var f = this._f | 0;
	  var g = this._g | 0;
	  var h = this._h | 0;

	  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4);
	  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0;

	  for (var j = 0; j < 64; ++j) {
	    var T1 = (h + sigma1$1(e) + ch(e, f, g) + K$4[j] + W[j]) | 0;
	    var T2 = (sigma0$1(a) + maj$1(a, b, c)) | 0;

	    h = g;
	    g = f;
	    f = e;
	    e = (d + T1) | 0;
	    d = c;
	    c = b;
	    b = a;
	    a = (T1 + T2) | 0;
	  }

	  this._a = (a + this._a) | 0;
	  this._b = (b + this._b) | 0;
	  this._c = (c + this._c) | 0;
	  this._d = (d + this._d) | 0;
	  this._e = (e + this._e) | 0;
	  this._f = (f + this._f) | 0;
	  this._g = (g + this._g) | 0;
	  this._h = (h + this._h) | 0;
	};

	Sha256$1.prototype._hash = function () {
	  var H = Buffer$4.allocUnsafe(32);

	  H.writeInt32BE(this._a, 0);
	  H.writeInt32BE(this._b, 4);
	  H.writeInt32BE(this._c, 8);
	  H.writeInt32BE(this._d, 12);
	  H.writeInt32BE(this._e, 16);
	  H.writeInt32BE(this._f, 20);
	  H.writeInt32BE(this._g, 24);
	  H.writeInt32BE(this._h, 28);

	  return H
	};

	var sha256 = Sha256$1;

	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */

	var inherits$2 = inherits_browserExports;
	var Sha256 = sha256;
	var Hash$2 = hash;
	var Buffer$3 = safeBufferExports.Buffer;

	var W$4 = new Array(64);

	function Sha224 () {
	  this.init();

	  this._w = W$4; // new Array(64)

	  Hash$2.call(this, 64, 56);
	}

	inherits$2(Sha224, Sha256);

	Sha224.prototype.init = function () {
	  this._a = 0xc1059ed8;
	  this._b = 0x367cd507;
	  this._c = 0x3070dd17;
	  this._d = 0xf70e5939;
	  this._e = 0xffc00b31;
	  this._f = 0x68581511;
	  this._g = 0x64f98fa7;
	  this._h = 0xbefa4fa4;

	  return this
	};

	Sha224.prototype._hash = function () {
	  var H = Buffer$3.allocUnsafe(28);

	  H.writeInt32BE(this._a, 0);
	  H.writeInt32BE(this._b, 4);
	  H.writeInt32BE(this._c, 8);
	  H.writeInt32BE(this._d, 12);
	  H.writeInt32BE(this._e, 16);
	  H.writeInt32BE(this._f, 20);
	  H.writeInt32BE(this._g, 24);

	  return H
	};

	var sha224 = Sha224;

	var inherits$1 = inherits_browserExports;
	var Hash$1 = hash;
	var Buffer$2 = safeBufferExports.Buffer;

	var K$3 = [
	  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	];

	var W$3 = new Array(160);

	function Sha512 () {
	  this.init();
	  this._w = W$3;

	  Hash$1.call(this, 128, 112);
	}

	inherits$1(Sha512, Hash$1);

	Sha512.prototype.init = function () {
	  this._ah = 0x6a09e667;
	  this._bh = 0xbb67ae85;
	  this._ch = 0x3c6ef372;
	  this._dh = 0xa54ff53a;
	  this._eh = 0x510e527f;
	  this._fh = 0x9b05688c;
	  this._gh = 0x1f83d9ab;
	  this._hh = 0x5be0cd19;

	  this._al = 0xf3bcc908;
	  this._bl = 0x84caa73b;
	  this._cl = 0xfe94f82b;
	  this._dl = 0x5f1d36f1;
	  this._el = 0xade682d1;
	  this._fl = 0x2b3e6c1f;
	  this._gl = 0xfb41bd6b;
	  this._hl = 0x137e2179;

	  return this
	};

	function Ch (x, y, z) {
	  return z ^ (x & (y ^ z))
	}

	function maj (x, y, z) {
	  return (x & y) | (z & (x | y))
	}

	function sigma0 (x, xl) {
	  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
	}

	function sigma1 (x, xl) {
	  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
	}

	function Gamma0 (x, xl) {
	  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
	}

	function Gamma0l (x, xl) {
	  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
	}

	function Gamma1 (x, xl) {
	  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
	}

	function Gamma1l (x, xl) {
	  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
	}

	function getCarry (a, b) {
	  return (a >>> 0) < (b >>> 0) ? 1 : 0
	}

	Sha512.prototype._update = function (M) {
	  var W = this._w;

	  var ah = this._ah | 0;
	  var bh = this._bh | 0;
	  var ch = this._ch | 0;
	  var dh = this._dh | 0;
	  var eh = this._eh | 0;
	  var fh = this._fh | 0;
	  var gh = this._gh | 0;
	  var hh = this._hh | 0;

	  var al = this._al | 0;
	  var bl = this._bl | 0;
	  var cl = this._cl | 0;
	  var dl = this._dl | 0;
	  var el = this._el | 0;
	  var fl = this._fl | 0;
	  var gl = this._gl | 0;
	  var hl = this._hl | 0;

	  for (var i = 0; i < 32; i += 2) {
	    W[i] = M.readInt32BE(i * 4);
	    W[i + 1] = M.readInt32BE(i * 4 + 4);
	  }
	  for (; i < 160; i += 2) {
	    var xh = W[i - 15 * 2];
	    var xl = W[i - 15 * 2 + 1];
	    var gamma0 = Gamma0(xh, xl);
	    var gamma0l = Gamma0l(xl, xh);

	    xh = W[i - 2 * 2];
	    xl = W[i - 2 * 2 + 1];
	    var gamma1 = Gamma1(xh, xl);
	    var gamma1l = Gamma1l(xl, xh);

	    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	    var Wi7h = W[i - 7 * 2];
	    var Wi7l = W[i - 7 * 2 + 1];

	    var Wi16h = W[i - 16 * 2];
	    var Wi16l = W[i - 16 * 2 + 1];

	    var Wil = (gamma0l + Wi7l) | 0;
	    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0;
	    Wil = (Wil + gamma1l) | 0;
	    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0;
	    Wil = (Wil + Wi16l) | 0;
	    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0;

	    W[i] = Wih;
	    W[i + 1] = Wil;
	  }

	  for (var j = 0; j < 160; j += 2) {
	    Wih = W[j];
	    Wil = W[j + 1];

	    var majh = maj(ah, bh, ch);
	    var majl = maj(al, bl, cl);

	    var sigma0h = sigma0(ah, al);
	    var sigma0l = sigma0(al, ah);
	    var sigma1h = sigma1(eh, el);
	    var sigma1l = sigma1(el, eh);

	    // t1 = h + sigma1 + ch + K[j] + W[j]
	    var Kih = K$3[j];
	    var Kil = K$3[j + 1];

	    var chh = Ch(eh, fh, gh);
	    var chl = Ch(el, fl, gl);

	    var t1l = (hl + sigma1l) | 0;
	    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0;
	    t1l = (t1l + chl) | 0;
	    t1h = (t1h + chh + getCarry(t1l, chl)) | 0;
	    t1l = (t1l + Kil) | 0;
	    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0;
	    t1l = (t1l + Wil) | 0;
	    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0;

	    // t2 = sigma0 + maj
	    var t2l = (sigma0l + majl) | 0;
	    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0;

	    hh = gh;
	    hl = gl;
	    gh = fh;
	    gl = fl;
	    fh = eh;
	    fl = el;
	    el = (dl + t1l) | 0;
	    eh = (dh + t1h + getCarry(el, dl)) | 0;
	    dh = ch;
	    dl = cl;
	    ch = bh;
	    cl = bl;
	    bh = ah;
	    bl = al;
	    al = (t1l + t2l) | 0;
	    ah = (t1h + t2h + getCarry(al, t1l)) | 0;
	  }

	  this._al = (this._al + al) | 0;
	  this._bl = (this._bl + bl) | 0;
	  this._cl = (this._cl + cl) | 0;
	  this._dl = (this._dl + dl) | 0;
	  this._el = (this._el + el) | 0;
	  this._fl = (this._fl + fl) | 0;
	  this._gl = (this._gl + gl) | 0;
	  this._hl = (this._hl + hl) | 0;

	  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0;
	  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0;
	  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0;
	  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0;
	  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0;
	  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0;
	  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0;
	  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0;
	};

	Sha512.prototype._hash = function () {
	  var H = Buffer$2.allocUnsafe(64);

	  function writeInt64BE (h, l, offset) {
	    H.writeInt32BE(h, offset);
	    H.writeInt32BE(l, offset + 4);
	  }

	  writeInt64BE(this._ah, this._al, 0);
	  writeInt64BE(this._bh, this._bl, 8);
	  writeInt64BE(this._ch, this._cl, 16);
	  writeInt64BE(this._dh, this._dl, 24);
	  writeInt64BE(this._eh, this._el, 32);
	  writeInt64BE(this._fh, this._fl, 40);
	  writeInt64BE(this._gh, this._gl, 48);
	  writeInt64BE(this._hh, this._hl, 56);

	  return H
	};

	var sha512$1 = Sha512;

	var inherits = inherits_browserExports;
	var SHA512 = sha512$1;
	var Hash = hash;
	var Buffer$1 = safeBufferExports.Buffer;

	var W$2 = new Array(160);

	function Sha384 () {
	  this.init();
	  this._w = W$2;

	  Hash.call(this, 128, 112);
	}

	inherits(Sha384, SHA512);

	Sha384.prototype.init = function () {
	  this._ah = 0xcbbb9d5d;
	  this._bh = 0x629a292a;
	  this._ch = 0x9159015a;
	  this._dh = 0x152fecd8;
	  this._eh = 0x67332667;
	  this._fh = 0x8eb44a87;
	  this._gh = 0xdb0c2e0d;
	  this._hh = 0x47b5481d;

	  this._al = 0xc1059ed8;
	  this._bl = 0x367cd507;
	  this._cl = 0x3070dd17;
	  this._dl = 0xf70e5939;
	  this._el = 0xffc00b31;
	  this._fl = 0x68581511;
	  this._gl = 0x64f98fa7;
	  this._hl = 0xbefa4fa4;

	  return this
	};

	Sha384.prototype._hash = function () {
	  var H = Buffer$1.allocUnsafe(48);

	  function writeInt64BE (h, l, offset) {
	    H.writeInt32BE(h, offset);
	    H.writeInt32BE(l, offset + 4);
	  }

	  writeInt64BE(this._ah, this._al, 0);
	  writeInt64BE(this._bh, this._bl, 8);
	  writeInt64BE(this._ch, this._cl, 16);
	  writeInt64BE(this._dh, this._dl, 24);
	  writeInt64BE(this._eh, this._el, 32);
	  writeInt64BE(this._fh, this._fl, 40);

	  return H
	};

	var sha384 = Sha384;

	var exports$1 = sha_js.exports = function SHA (algorithm) {
	  algorithm = algorithm.toLowerCase();

	  var Algorithm = exports$1[algorithm];
	  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

	  return new Algorithm()
	};

	exports$1.sha = sha;
	exports$1.sha1 = sha1;
	exports$1.sha224 = sha224;
	exports$1.sha256 = sha256;
	exports$1.sha384 = sha384;
	exports$1.sha512 = sha512$1;

	var sha_jsExports = sha_js.exports;

	var util$3 = {};

	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	var shams = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }

		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }

		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }

		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }

		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}

		return true;
	};

	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = shams;

	var hasSymbols$2 = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }

		return hasSymbolSham();
	};

	var test = {
		foo: {}
	};

	var $Object = Object;

	var hasProto$1 = function hasProto() {
		return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
	};

	/* eslint no-invalid-this: 1 */

	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr$1 = Object.prototype.toString;
	var funcType = '[object Function]';

	var implementation$1 = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr$1.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);

	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };

	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }

	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }

	    return bound;
	};

	var implementation = implementation$1;

	var functionBind = Function.prototype.bind || implementation;

	var bind$3 = functionBind;

	var src = bind$3.call(Function.call, Object.prototype.hasOwnProperty);

	var undefined$2;

	var $SyntaxError$1 = SyntaxError;
	var $Function$1 = Function;
	var $TypeError$2 = TypeError;

	// eslint-disable-next-line consistent-return
	var getEvalledConstructor$1 = function (expressionSyntax) {
		try {
			return $Function$1('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};

	var $gOPD$1 = Object.getOwnPropertyDescriptor;
	if ($gOPD$1) {
		try {
			$gOPD$1({}, '');
		} catch (e) {
			$gOPD$1 = null; // this is IE 8, which has a broken gOPD
		}
	}

	var throwTypeError$1 = function () {
		throw new $TypeError$2();
	};
	var ThrowTypeError$1 = $gOPD$1
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError$1;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD$1(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError$1;
				}
			}
		}())
		: throwTypeError$1;

	var hasSymbols$1 = hasSymbols$2();
	var hasProto = hasProto$1();

	var getProto$1 = Object.getPrototypeOf || (
		hasProto
			? function (x) { return x.__proto__; } // eslint-disable-line no-proto
			: null
	);

	var needsEval$1 = {};

	var TypedArray$1 = typeof Uint8Array === 'undefined' || !getProto$1 ? undefined$2 : getProto$1(Uint8Array);

	var INTRINSICS$1 = {
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$2 : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$2 : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols$1 && getProto$1 ? getProto$1([][Symbol.iterator]()) : undefined$2,
		'%AsyncFromSyncIteratorPrototype%': undefined$2,
		'%AsyncFunction%': needsEval$1,
		'%AsyncGenerator%': needsEval$1,
		'%AsyncGeneratorFunction%': needsEval$1,
		'%AsyncIteratorPrototype%': needsEval$1,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined$2 : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined$2 : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined$2 : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined$2 : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined$2 : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$2 : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$2 : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$2 : FinalizationRegistry,
		'%Function%': $Function$1,
		'%GeneratorFunction%': needsEval$1,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$2 : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$2 : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$2 : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols$1 && getProto$1 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$2,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined$2,
		'%Map%': typeof Map === 'undefined' ? undefined$2 : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$1 || !getProto$1 ? undefined$2 : getProto$1(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined$2 : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined$2 : Proxy,
		'%RangeError%': RangeError,
		'%ReferenceError%': ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined$2 : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined$2 : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$1 || !getProto$1 ? undefined$2 : getProto$1(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$2 : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols$1 && getProto$1 ? getProto$1(''[Symbol.iterator]()) : undefined$2,
		'%Symbol%': hasSymbols$1 ? Symbol : undefined$2,
		'%SyntaxError%': $SyntaxError$1,
		'%ThrowTypeError%': ThrowTypeError$1,
		'%TypedArray%': TypedArray$1,
		'%TypeError%': $TypeError$2,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$2 : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$2 : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$2 : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$2 : Uint32Array,
		'%URIError%': URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$2 : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$2 : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$2 : WeakSet
	};

	if (getProto$1) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto$1 = getProto$1(getProto$1(e));
			INTRINSICS$1['%Error.prototype%'] = errorProto$1;
		}
	}

	var doEval$1 = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor$1('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor$1('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor$1('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto$1) {
				value = getProto$1(gen.prototype);
			}
		}

		INTRINSICS$1[name] = value;

		return value;
	};

	var LEGACY_ALIASES$1 = {
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};

	var bind$2 = functionBind;
	var hasOwn$2 = src;
	var $concat$2 = bind$2.call(Function.call, Array.prototype.concat);
	var $spliceApply$1 = bind$2.call(Function.apply, Array.prototype.splice);
	var $replace$2 = bind$2.call(Function.call, String.prototype.replace);
	var $strSlice$1 = bind$2.call(Function.call, String.prototype.slice);
	var $exec$1 = bind$2.call(Function.call, RegExp.prototype.exec);

	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName$1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar$1 = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath$1 = function stringToPath(string) {
		var first = $strSlice$1(string, 0, 1);
		var last = $strSlice$1(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError$1('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError$1('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace$2(string, rePropName$1, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace$2(subString, reEscapeChar$1, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */

	var getBaseIntrinsic$1 = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn$2(LEGACY_ALIASES$1, intrinsicName)) {
			alias = LEGACY_ALIASES$1[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}

		if (hasOwn$2(INTRINSICS$1, intrinsicName)) {
			var value = INTRINSICS$1[intrinsicName];
			if (value === needsEval$1) {
				value = doEval$1(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError$2('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}

			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}

		throw new $SyntaxError$1('intrinsic ' + name + ' does not exist!');
	};

	var getIntrinsic$1 = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError$2('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError$2('"allowMissing" argument must be a boolean');
		}

		if ($exec$1(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError$1('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath$1(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

		var intrinsic = getBaseIntrinsic$1('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;

		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply$1(parts, $concat$2([0, 1], alias));
		}

		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice$1(part, 0, 1);
			var last = $strSlice$1(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError$1('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}

			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';

			if (hasOwn$2(INTRINSICS$1, intrinsicRealName)) {
				value = INTRINSICS$1[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError$2('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined$2;
				}
				if ($gOPD$1 && (i + 1) >= parts.length) {
					var desc = $gOPD$1(value, part);
					isOwn = !!desc;

					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn$2(value, part);
					value = value[part];
				}

				if (isOwn && !skipFurtherCaching) {
					INTRINSICS$1[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};

	var undefined$1;

	var $SyntaxError = SyntaxError;
	var $Function = Function;
	var $TypeError$1 = TypeError;

	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};

	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}

	var throwTypeError = function () {
		throw new $TypeError$1();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;

	var hasSymbols = hasSymbols$2();

	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

	var needsEval = {};

	var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);

	var INTRINSICS = {
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined$1,
		'%AsyncFromSyncIteratorPrototype%': undefined$1,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined$1 : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined$1 : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
		'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
		'%RangeError%': RangeError,
		'%ReferenceError%': ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined$1,
		'%Symbol%': hasSymbols ? Symbol : undefined$1,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError$1,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
		'%URIError%': URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
	};

	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}

	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen) {
				value = getProto(gen.prototype);
			}
		}

		INTRINSICS[name] = value;

		return value;
	};

	var LEGACY_ALIASES = {
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};

	var bind$1 = functionBind;
	var hasOwn$1 = src;
	var $concat$1 = bind$1.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind$1.call(Function.apply, Array.prototype.splice);
	var $replace$1 = bind$1.call(Function.call, String.prototype.replace);
	var $strSlice = bind$1.call(Function.call, String.prototype.slice);
	var $exec = bind$1.call(Function.call, RegExp.prototype.exec);

	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace$1(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace$1(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */

	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}

		if (hasOwn$1(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError$1('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}

			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}

		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};

	var getIntrinsic = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError$1('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError$1('"allowMissing" argument must be a boolean');
		}

		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;

		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat$1([0, 1], alias));
		}

		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}

			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';

			if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError$1('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined$1;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;

					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn$1(value, part);
					value = value[part];
				}

				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};

	var callBind$1 = {exports: {}};

	(function (module) {

		var bind = functionBind;
		var GetIntrinsic = getIntrinsic;

		var $apply = GetIntrinsic('%Function.prototype.apply%');
		var $call = GetIntrinsic('%Function.prototype.call%');
		var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

		var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
		var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
		var $max = GetIntrinsic('%Math.max%');

		if ($defineProperty) {
			try {
				$defineProperty({}, 'a', { value: 1 });
			} catch (e) {
				// IE 8 has a broken defineProperty
				$defineProperty = null;
			}
		}

		module.exports = function callBind(originalFunction) {
			var func = $reflectApply(bind, $call, arguments);
			if ($gOPD && $defineProperty) {
				var desc = $gOPD(func, 'length');
				if (desc.configurable) {
					// original length, plus the receiver, minus any additional arguments (after the receiver)
					$defineProperty(
						func,
						'length',
						{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
					);
				}
			}
			return func;
		};

		var applyBind = function applyBind() {
			return $reflectApply(bind, $apply, arguments);
		};

		if ($defineProperty) {
			$defineProperty(module.exports, 'apply', { value: applyBind });
		} else {
			module.exports.apply = applyBind;
		} 
	} (callBind$1));

	var callBindExports = callBind$1.exports;

	var GetIntrinsic$1 = getIntrinsic;

	var callBind = callBindExports;

	var $indexOf = callBind(GetIntrinsic$1('String.prototype.indexOf'));

	var callBound$1 = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic$1(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};

	var hasMap = typeof Map === 'function' && Map.prototype;
	var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
	var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
	var mapForEach = hasMap && Map.prototype.forEach;
	var hasSet = typeof Set === 'function' && Set.prototype;
	var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
	var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
	var setForEach = hasSet && Set.prototype.forEach;
	var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
	var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
	var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
	var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
	var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
	var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
	var booleanValueOf = Boolean.prototype.valueOf;
	var objectToString = Object.prototype.toString;
	var functionToString = Function.prototype.toString;
	var $match = String.prototype.match;
	var $slice = String.prototype.slice;
	var $replace = String.prototype.replace;
	var $toUpperCase = String.prototype.toUpperCase;
	var $toLowerCase = String.prototype.toLowerCase;
	var $test = RegExp.prototype.test;
	var $concat = Array.prototype.concat;
	var $join = Array.prototype.join;
	var $arrSlice = Array.prototype.slice;
	var $floor = Math.floor;
	var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
	var gOPS = Object.getOwnPropertySymbols;
	var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
	var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
	// ie, `has-tostringtag/shams
	var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
	    ? Symbol.toStringTag
	    : null;
	var isEnumerable = Object.prototype.propertyIsEnumerable;

	var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
	    [].__proto__ === Array.prototype // eslint-disable-line no-proto
	        ? function (O) {
	            return O.__proto__; // eslint-disable-line no-proto
	        }
	        : null
	);

	function addNumericSeparator(num, str) {
	    if (
	        num === Infinity
	        || num === -Infinity
	        || num !== num
	        || (num && num > -1000 && num < 1000)
	        || $test.call(/e/, str)
	    ) {
	        return str;
	    }
	    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
	    if (typeof num === 'number') {
	        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
	        if (int !== num) {
	            var intStr = String(int);
	            var dec = $slice.call(str, intStr.length + 1);
	            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
	        }
	    }
	    return $replace.call(str, sepRegex, '$&_');
	}

	var utilInspect = require$$3;
	var inspectCustom = utilInspect.custom;
	var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

	var objectInspect = function inspect_(obj, options, depth, seen) {
	    var opts = options || {};

	    if (has$3(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
	        throw new TypeError('option "quoteStyle" must be "single" or "double"');
	    }
	    if (
	        has$3(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
	            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
	            : opts.maxStringLength !== null
	        )
	    ) {
	        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
	    }
	    var customInspect = has$3(opts, 'customInspect') ? opts.customInspect : true;
	    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
	        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
	    }

	    if (
	        has$3(opts, 'indent')
	        && opts.indent !== null
	        && opts.indent !== '\t'
	        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
	    ) {
	        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
	    }
	    if (has$3(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
	        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
	    }
	    var numericSeparator = opts.numericSeparator;

	    if (typeof obj === 'undefined') {
	        return 'undefined';
	    }
	    if (obj === null) {
	        return 'null';
	    }
	    if (typeof obj === 'boolean') {
	        return obj ? 'true' : 'false';
	    }

	    if (typeof obj === 'string') {
	        return inspectString(obj, opts);
	    }
	    if (typeof obj === 'number') {
	        if (obj === 0) {
	            return Infinity / obj > 0 ? '0' : '-0';
	        }
	        var str = String(obj);
	        return numericSeparator ? addNumericSeparator(obj, str) : str;
	    }
	    if (typeof obj === 'bigint') {
	        var bigIntStr = String(obj) + 'n';
	        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
	    }

	    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
	    if (typeof depth === 'undefined') { depth = 0; }
	    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
	        return isArray$5(obj) ? '[Array]' : '[Object]';
	    }

	    var indent = getIndent(opts, depth);

	    if (typeof seen === 'undefined') {
	        seen = [];
	    } else if (indexOf(seen, obj) >= 0) {
	        return '[Circular]';
	    }

	    function inspect(value, from, noIndent) {
	        if (from) {
	            seen = $arrSlice.call(seen);
	            seen.push(from);
	        }
	        if (noIndent) {
	            var newOpts = {
	                depth: opts.depth
	            };
	            if (has$3(opts, 'quoteStyle')) {
	                newOpts.quoteStyle = opts.quoteStyle;
	            }
	            return inspect_(value, newOpts, depth + 1, seen);
	        }
	        return inspect_(value, opts, depth + 1, seen);
	    }

	    if (typeof obj === 'function' && !isRegExp$1(obj)) { // in older engines, regexes are callable
	        var name = nameOf(obj);
	        var keys = arrObjKeys(obj, inspect);
	        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
	    }
	    if (isSymbol(obj)) {
	        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
	        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
	    }
	    if (isElement(obj)) {
	        var s = '<' + $toLowerCase.call(String(obj.nodeName));
	        var attrs = obj.attributes || [];
	        for (var i = 0; i < attrs.length; i++) {
	            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
	        }
	        s += '>';
	        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
	        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
	        return s;
	    }
	    if (isArray$5(obj)) {
	        if (obj.length === 0) { return '[]'; }
	        var xs = arrObjKeys(obj, inspect);
	        if (indent && !singleLineValues(xs)) {
	            return '[' + indentedJoin(xs, indent) + ']';
	        }
	        return '[ ' + $join.call(xs, ', ') + ' ]';
	    }
	    if (isError(obj)) {
	        var parts = arrObjKeys(obj, inspect);
	        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
	            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
	        }
	        if (parts.length === 0) { return '[' + String(obj) + ']'; }
	        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
	    }
	    if (typeof obj === 'object' && customInspect) {
	        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
	            return utilInspect(obj, { depth: maxDepth - depth });
	        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
	            return obj.inspect();
	        }
	    }
	    if (isMap(obj)) {
	        var mapParts = [];
	        if (mapForEach) {
	            mapForEach.call(obj, function (value, key) {
	                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
	            });
	        }
	        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
	    }
	    if (isSet(obj)) {
	        var setParts = [];
	        if (setForEach) {
	            setForEach.call(obj, function (value) {
	                setParts.push(inspect(value, obj));
	            });
	        }
	        return collectionOf('Set', setSize.call(obj), setParts, indent);
	    }
	    if (isWeakMap(obj)) {
	        return weakCollectionOf('WeakMap');
	    }
	    if (isWeakSet(obj)) {
	        return weakCollectionOf('WeakSet');
	    }
	    if (isWeakRef(obj)) {
	        return weakCollectionOf('WeakRef');
	    }
	    if (isNumber$1(obj)) {
	        return markBoxed(inspect(Number(obj)));
	    }
	    if (isBigInt(obj)) {
	        return markBoxed(inspect(bigIntValueOf.call(obj)));
	    }
	    if (isBoolean(obj)) {
	        return markBoxed(booleanValueOf.call(obj));
	    }
	    if (isString$1(obj)) {
	        return markBoxed(inspect(String(obj)));
	    }
	    if (!isDate$1(obj) && !isRegExp$1(obj)) {
	        var ys = arrObjKeys(obj, inspect);
	        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
	        var protoTag = obj instanceof Object ? '' : 'null prototype';
	        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
	        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
	        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
	        if (ys.length === 0) { return tag + '{}'; }
	        if (indent) {
	            return tag + '{' + indentedJoin(ys, indent) + '}';
	        }
	        return tag + '{ ' + $join.call(ys, ', ') + ' }';
	    }
	    return String(obj);
	};

	function wrapQuotes(s, defaultStyle, opts) {
	    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
	    return quoteChar + s + quoteChar;
	}

	function quote(s) {
	    return $replace.call(String(s), /"/g, '&quot;');
	}

	function isArray$5(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isDate$1(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isRegExp$1(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isString$1(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isNumber$1(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

	// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
	function isSymbol(obj) {
	    if (hasShammedSymbols) {
	        return obj && typeof obj === 'object' && obj instanceof Symbol;
	    }
	    if (typeof obj === 'symbol') {
	        return true;
	    }
	    if (!obj || typeof obj !== 'object' || !symToString) {
	        return false;
	    }
	    try {
	        symToString.call(obj);
	        return true;
	    } catch (e) {}
	    return false;
	}

	function isBigInt(obj) {
	    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
	        return false;
	    }
	    try {
	        bigIntValueOf.call(obj);
	        return true;
	    } catch (e) {}
	    return false;
	}

	var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
	function has$3(obj, key) {
	    return hasOwn.call(obj, key);
	}

	function toStr(obj) {
	    return objectToString.call(obj);
	}

	function nameOf(f) {
	    if (f.name) { return f.name; }
	    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
	    if (m) { return m[1]; }
	    return null;
	}

	function indexOf(xs, x) {
	    if (xs.indexOf) { return xs.indexOf(x); }
	    for (var i = 0, l = xs.length; i < l; i++) {
	        if (xs[i] === x) { return i; }
	    }
	    return -1;
	}

	function isMap(x) {
	    if (!mapSize || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        mapSize.call(x);
	        try {
	            setSize.call(x);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof Map; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}

	function isWeakMap(x) {
	    if (!weakMapHas || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakMapHas.call(x, weakMapHas);
	        try {
	            weakSetHas.call(x, weakSetHas);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}

	function isWeakRef(x) {
	    if (!weakRefDeref || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakRefDeref.call(x);
	        return true;
	    } catch (e) {}
	    return false;
	}

	function isSet(x) {
	    if (!setSize || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        setSize.call(x);
	        try {
	            mapSize.call(x);
	        } catch (m) {
	            return true;
	        }
	        return x instanceof Set; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}

	function isWeakSet(x) {
	    if (!weakSetHas || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakSetHas.call(x, weakSetHas);
	        try {
	            weakMapHas.call(x, weakMapHas);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}

	function isElement(x) {
	    if (!x || typeof x !== 'object') { return false; }
	    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
	        return true;
	    }
	    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
	}

	function inspectString(str, opts) {
	    if (str.length > opts.maxStringLength) {
	        var remaining = str.length - opts.maxStringLength;
	        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
	        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
	    }
	    // eslint-disable-next-line no-control-regex
	    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
	    return wrapQuotes(s, 'single', opts);
	}

	function lowbyte(c) {
	    var n = c.charCodeAt(0);
	    var x = {
	        8: 'b',
	        9: 't',
	        10: 'n',
	        12: 'f',
	        13: 'r'
	    }[n];
	    if (x) { return '\\' + x; }
	    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
	}

	function markBoxed(str) {
	    return 'Object(' + str + ')';
	}

	function weakCollectionOf(type) {
	    return type + ' { ? }';
	}

	function collectionOf(type, size, entries, indent) {
	    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
	    return type + ' (' + size + ') {' + joinedEntries + '}';
	}

	function singleLineValues(xs) {
	    for (var i = 0; i < xs.length; i++) {
	        if (indexOf(xs[i], '\n') >= 0) {
	            return false;
	        }
	    }
	    return true;
	}

	function getIndent(opts, depth) {
	    var baseIndent;
	    if (opts.indent === '\t') {
	        baseIndent = '\t';
	    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
	        baseIndent = $join.call(Array(opts.indent + 1), ' ');
	    } else {
	        return null;
	    }
	    return {
	        base: baseIndent,
	        prev: $join.call(Array(depth + 1), baseIndent)
	    };
	}

	function indentedJoin(xs, indent) {
	    if (xs.length === 0) { return ''; }
	    var lineJoiner = '\n' + indent.prev + indent.base;
	    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
	}

	function arrObjKeys(obj, inspect) {
	    var isArr = isArray$5(obj);
	    var xs = [];
	    if (isArr) {
	        xs.length = obj.length;
	        for (var i = 0; i < obj.length; i++) {
	            xs[i] = has$3(obj, i) ? inspect(obj[i], obj) : '';
	        }
	    }
	    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
	    var symMap;
	    if (hasShammedSymbols) {
	        symMap = {};
	        for (var k = 0; k < syms.length; k++) {
	            symMap['$' + syms[k]] = syms[k];
	        }
	    }

	    for (var key in obj) { // eslint-disable-line no-restricted-syntax
	        if (!has$3(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
	        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
	        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
	            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
	            continue; // eslint-disable-line no-restricted-syntax, no-continue
	        } else if ($test.call(/[^\w$]/, key)) {
	            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
	        } else {
	            xs.push(key + ': ' + inspect(obj[key], obj));
	        }
	    }
	    if (typeof gOPS === 'function') {
	        for (var j = 0; j < syms.length; j++) {
	            if (isEnumerable.call(obj, syms[j])) {
	                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
	            }
	        }
	    }
	    return xs;
	}

	var GetIntrinsic = getIntrinsic$1;
	var callBound = callBound$1;
	var inspect = objectInspect;

	var $TypeError = GetIntrinsic('%TypeError%');
	var $WeakMap = GetIntrinsic('%WeakMap%', true);
	var $Map = GetIntrinsic('%Map%', true);

	var $weakMapGet = callBound('WeakMap.prototype.get', true);
	var $weakMapSet = callBound('WeakMap.prototype.set', true);
	var $weakMapHas = callBound('WeakMap.prototype.has', true);
	var $mapGet = callBound('Map.prototype.get', true);
	var $mapSet = callBound('Map.prototype.set', true);
	var $mapHas = callBound('Map.prototype.has', true);

	/*
	 * This function traverses the list returning the node corresponding to the
	 * given key.
	 *
	 * That node is also moved to the head of the list, so that if it's accessed
	 * again we don't need to traverse the whole list. By doing so, all the recently
	 * used nodes can be accessed relatively quickly.
	 */
	var listGetNode = function (list, key) { // eslint-disable-line consistent-return
		for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
			if (curr.key === key) {
				prev.next = curr.next;
				curr.next = list.next;
				list.next = curr; // eslint-disable-line no-param-reassign
				return curr;
			}
		}
	};

	var listGet = function (objects, key) {
		var node = listGetNode(objects, key);
		return node && node.value;
	};
	var listSet = function (objects, key, value) {
		var node = listGetNode(objects, key);
		if (node) {
			node.value = value;
		} else {
			// Prepend the new node to the beginning of the list
			objects.next = { // eslint-disable-line no-param-reassign
				key: key,
				next: objects.next,
				value: value
			};
		}
	};
	var listHas = function (objects, key) {
		return !!listGetNode(objects, key);
	};

	var sideChannel = function getSideChannel() {
		var $wm;
		var $m;
		var $o;
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			get: function (key) { // eslint-disable-line consistent-return
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				} else if ($Map) {
					if ($m) {
						return $mapGet($m, key);
					}
				} else {
					if ($o) { // eslint-disable-line no-lonely-if
						return listGet($o, key);
					}
				}
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				} else if ($Map) {
					if ($m) {
						return $mapHas($m, key);
					}
				} else {
					if ($o) { // eslint-disable-line no-lonely-if
						return listHas($o, key);
					}
				}
				return false;
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if ($Map) {
					if (!$m) {
						$m = new $Map();
					}
					$mapSet($m, key, value);
				} else {
					if (!$o) {
						/*
						 * Initialize the linked list as an empty node, so that we don't have
						 * to special-case handling of the first node: we can always refer to
						 * it as (previous node).next, instead of something like (list).head
						 */
						$o = { key: {}, next: null };
					}
					listSet($o, key, value);
				}
			}
		};
		return channel;
	};

	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;

	var Format = {
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};

	var formats$3 = {
	    'default': Format.RFC3986,
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return String(value);
	        }
	    },
	    RFC1738: Format.RFC1738,
	    RFC3986: Format.RFC3986
	};

	var formats$2 = formats$3;

	var has$2 = Object.prototype.hasOwnProperty;
	var isArray$4 = Array.isArray;

	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }

	    return array;
	}());

	var compactQueue = function compactQueue(queue) {
	    while (queue.length > 1) {
	        var item = queue.pop();
	        var obj = item.obj[item.prop];

	        if (isArray$4(obj)) {
	            var compacted = [];

	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }

	            item.obj[item.prop] = compacted;
	        }
	    }
	};

	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }

	    return obj;
	};

	var merge$2 = function merge(target, source, options) {
	    /* eslint no-param-reassign: 0 */
	    if (!source) {
	        return target;
	    }

	    if (typeof source !== 'object') {
	        if (isArray$4(target)) {
	            target.push(source);
	        } else if (target && typeof target === 'object') {
	            if ((options && (options.plainObjects || options.allowPrototypes)) || !has$2.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }

	        return target;
	    }

	    if (!target || typeof target !== 'object') {
	        return [target].concat(source);
	    }

	    var mergeTarget = target;
	    if (isArray$4(target) && !isArray$4(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }

	    if (isArray$4(target) && isArray$4(source)) {
	        source.forEach(function (item, i) {
	            if (has$2.call(target, i)) {
	                var targetItem = target[i];
	                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
	                    target[i] = merge(targetItem, item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }

	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];

	        if (has$2.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};

	var assign$1 = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};

	var decode = function (str, decoder, charset) {
	    var strWithoutPlus = str.replace(/\+/g, ' ');
	    if (charset === 'iso-8859-1') {
	        // unescape never throws, no try...catch needed:
	        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
	    }
	    // utf-8
	    try {
	        return decodeURIComponent(strWithoutPlus);
	    } catch (e) {
	        return strWithoutPlus;
	    }
	};

	var encode = function encode(str, defaultEncoder, charset, kind, format) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }

	    var string = str;
	    if (typeof str === 'symbol') {
	        string = Symbol.prototype.toString.call(str);
	    } else if (typeof str !== 'string') {
	        string = String(str);
	    }

	    if (charset === 'iso-8859-1') {
	        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
	            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
	        });
	    }

	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);

	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	            || (format === formats$2.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
	        ) {
	            out += string.charAt(i);
	            continue;
	        }

	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }

	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }

	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }

	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        /* eslint operator-linebreak: [2, "before"] */
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }

	    return out;
	};

	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];

	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];

	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }

	    compactQueue(queue);

	    return value;
	};

	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};

	var isBuffer = function isBuffer(obj) {
	    if (!obj || typeof obj !== 'object') {
	        return false;
	    }

	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};

	var combine = function combine(a, b) {
	    return [].concat(a, b);
	};

	var maybeMap = function maybeMap(val, fn) {
	    if (isArray$4(val)) {
	        var mapped = [];
	        for (var i = 0; i < val.length; i += 1) {
	            mapped.push(fn(val[i]));
	        }
	        return mapped;
	    }
	    return fn(val);
	};

	var utils$7 = {
	    arrayToObject: arrayToObject,
	    assign: assign$1,
	    combine: combine,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    maybeMap: maybeMap,
	    merge: merge$2
	};

	var getSideChannel = sideChannel;
	var utils$6 = utils$7;
	var formats$1 = formats$3;
	var has$1 = Object.prototype.hasOwnProperty;

	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    comma: 'comma',
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};

	var isArray$3 = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function (arr, valueOrArray) {
	    push.apply(arr, isArray$3(valueOrArray) ? valueOrArray : [valueOrArray]);
	};

	var toISO = Date.prototype.toISOString;

	var defaultFormat = formats$1['default'];
	var defaults$2 = {
	    addQueryPrefix: false,
	    allowDots: false,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    delimiter: '&',
	    encode: true,
	    encoder: utils$6.encode,
	    encodeValuesOnly: false,
	    format: defaultFormat,
	    formatter: formats$1.formatters[defaultFormat],
	    // deprecated
	    indices: false,
	    serializeDate: function serializeDate(date) {
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};

	var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
	    return typeof v === 'string'
	        || typeof v === 'number'
	        || typeof v === 'boolean'
	        || typeof v === 'symbol'
	        || typeof v === 'bigint';
	};

	var sentinel = {};

	var stringify$1 = function stringify(
	    object,
	    prefix,
	    generateArrayPrefix,
	    commaRoundTrip,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    format,
	    formatter,
	    encodeValuesOnly,
	    charset,
	    sideChannel
	) {
	    var obj = object;

	    var tmpSc = sideChannel;
	    var step = 0;
	    var findFlag = false;
	    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
	        // Where object last appeared in the ref tree
	        var pos = tmpSc.get(object);
	        step += 1;
	        if (typeof pos !== 'undefined') {
	            if (pos === step) {
	                throw new RangeError('Cyclic object value');
	            } else {
	                findFlag = true; // Break while
	            }
	        }
	        if (typeof tmpSc.get(sentinel) === 'undefined') {
	            step = 0;
	        }
	    }

	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (generateArrayPrefix === 'comma' && isArray$3(obj)) {
	        obj = utils$6.maybeMap(obj, function (value) {
	            if (value instanceof Date) {
	                return serializeDate(value);
	            }
	            return value;
	        });
	    }

	    if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults$2.encoder, charset, 'key', format) : prefix;
	        }

	        obj = '';
	    }

	    if (isNonNullishPrimitive(obj) || utils$6.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$2.encoder, charset, 'key', format);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$2.encoder, charset, 'value', format))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }

	    var values = [];

	    if (typeof obj === 'undefined') {
	        return values;
	    }

	    var objKeys;
	    if (generateArrayPrefix === 'comma' && isArray$3(obj)) {
	        // we need to join elements in
	        if (encodeValuesOnly && encoder) {
	            obj = utils$6.maybeMap(obj, encoder);
	        }
	        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
	    } else if (isArray$3(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }

	    var adjustedPrefix = commaRoundTrip && isArray$3(obj) && obj.length === 1 ? prefix + '[]' : prefix;

	    for (var j = 0; j < objKeys.length; ++j) {
	        var key = objKeys[j];
	        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

	        if (skipNulls && value === null) {
	            continue;
	        }

	        var keyPrefix = isArray$3(obj)
	            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
	            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

	        sideChannel.set(object, step);
	        var valueSideChannel = getSideChannel();
	        valueSideChannel.set(sentinel, sideChannel);
	        pushToArray(values, stringify(
	            value,
	            keyPrefix,
	            generateArrayPrefix,
	            commaRoundTrip,
	            strictNullHandling,
	            skipNulls,
	            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray$3(obj) ? null : encoder,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            format,
	            formatter,
	            encodeValuesOnly,
	            charset,
	            valueSideChannel
	        ));
	    }

	    return values;
	};

	var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
	    if (!opts) {
	        return defaults$2;
	    }

	    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }

	    var charset = opts.charset || defaults$2.charset;
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }

	    var format = formats$1['default'];
	    if (typeof opts.format !== 'undefined') {
	        if (!has$1.call(formats$1.formatters, opts.format)) {
	            throw new TypeError('Unknown format option provided.');
	        }
	        format = opts.format;
	    }
	    var formatter = formats$1.formatters[format];

	    var filter = defaults$2.filter;
	    if (typeof opts.filter === 'function' || isArray$3(opts.filter)) {
	        filter = opts.filter;
	    }

	    return {
	        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults$2.addQueryPrefix,
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults$2.allowDots : !!opts.allowDots,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$2.charsetSentinel,
	        delimiter: typeof opts.delimiter === 'undefined' ? defaults$2.delimiter : opts.delimiter,
	        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults$2.encode,
	        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults$2.encoder,
	        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults$2.encodeValuesOnly,
	        filter: filter,
	        format: format,
	        formatter: formatter,
	        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults$2.serializeDate,
	        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults$2.skipNulls,
	        sort: typeof opts.sort === 'function' ? opts.sort : null,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$2.strictNullHandling
	    };
	};

	var stringify_1 = function (object, opts) {
	    var obj = object;
	    var options = normalizeStringifyOptions(opts);

	    var objKeys;
	    var filter;

	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (isArray$3(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }

	    var keys = [];

	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }

	    var arrayFormat;
	    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = opts.arrayFormat;
	    } else if (opts && 'indices' in opts) {
	        arrayFormat = opts.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }

	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
	        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
	    }
	    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }

	    if (options.sort) {
	        objKeys.sort(options.sort);
	    }

	    var sideChannel = getSideChannel();
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];

	        if (options.skipNulls && obj[key] === null) {
	            continue;
	        }
	        pushToArray(keys, stringify$1(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            commaRoundTrip,
	            options.strictNullHandling,
	            options.skipNulls,
	            options.encode ? options.encoder : null,
	            options.filter,
	            options.sort,
	            options.allowDots,
	            options.serializeDate,
	            options.format,
	            options.formatter,
	            options.encodeValuesOnly,
	            options.charset,
	            sideChannel
	        ));
	    }

	    var joined = keys.join(options.delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';

	    if (options.charsetSentinel) {
	        if (options.charset === 'iso-8859-1') {
	            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
	            prefix += 'utf8=%26%2310003%3B&';
	        } else {
	            // encodeURIComponent('✓')
	            prefix += 'utf8=%E2%9C%93&';
	        }
	    }

	    return joined.length > 0 ? prefix + joined : '';
	};

	var utils$5 = utils$7;

	var has = Object.prototype.hasOwnProperty;
	var isArray$2 = Array.isArray;

	var defaults$1 = {
	    allowDots: false,
	    allowPrototypes: false,
	    allowSparse: false,
	    arrayLimit: 20,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    comma: false,
	    decoder: utils$5.decode,
	    delimiter: '&',
	    depth: 5,
	    ignoreQueryPrefix: false,
	    interpretNumericEntities: false,
	    parameterLimit: 1000,
	    parseArrays: true,
	    plainObjects: false,
	    strictNullHandling: false
	};

	var interpretNumericEntities = function (str) {
	    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
	        return String.fromCharCode(parseInt(numberStr, 10));
	    });
	};

	var parseArrayValue = function (val, options) {
	    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
	        return val.split(',');
	    }

	    return val;
	};

	// This is what browsers will submit when the ✓ character occurs in an
	// application/x-www-form-urlencoded body and the encoding of the page containing
	// the form is iso-8859-1, or when the submitted form has an accept-charset
	// attribute of iso-8859-1. Presumably also with other charsets that do not contain
	// the ✓ character, such as us-ascii.
	var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

	// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
	var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = { __proto__: null };

	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
	    var i;

	    var charset = options.charset;
	    if (options.charsetSentinel) {
	        for (i = 0; i < parts.length; ++i) {
	            if (parts[i].indexOf('utf8=') === 0) {
	                if (parts[i] === charsetSentinel) {
	                    charset = 'utf-8';
	                } else if (parts[i] === isoSentinel) {
	                    charset = 'iso-8859-1';
	                }
	                skipIndex = i;
	                i = parts.length; // The eslint settings do not allow break;
	            }
	        }
	    }

	    for (i = 0; i < parts.length; ++i) {
	        if (i === skipIndex) {
	            continue;
	        }
	        var part = parts[i];

	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults$1.decoder, charset, 'key');
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults$1.decoder, charset, 'key');
	            val = utils$5.maybeMap(
	                parseArrayValue(part.slice(pos + 1), options),
	                function (encodedVal) {
	                    return options.decoder(encodedVal, defaults$1.decoder, charset, 'value');
	                }
	            );
	        }

	        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
	            val = interpretNumericEntities(val);
	        }

	        if (part.indexOf('[]=') > -1) {
	            val = isArray$2(val) ? [val] : val;
	        }

	        if (has.call(obj, key)) {
	            obj[key] = utils$5.combine(obj[key], val);
	        } else {
	            obj[key] = val;
	        }
	    }

	    return obj;
	};

	var parseObject = function (chain, val, options, valuesParsed) {
	    var leaf = valuesParsed ? val : parseArrayValue(val, options);

	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];

	        if (root === '[]' && options.parseArrays) {
	            obj = [].concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (!options.parseArrays && cleanRoot === '') {
	                obj = { 0: leaf };
	            } else if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else if (cleanRoot !== '__proto__') {
	                obj[cleanRoot] = leaf;
	            }
	        }

	        leaf = obj;
	    }

	    return leaf;
	};

	var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
	    if (!givenKey) {
	        return;
	    }

	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

	    // The regex chunks

	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;

	    // Get the parent

	    var segment = options.depth > 0 && brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;

	    // Stash the parent if it exists

	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }

	        keys.push(parent);
	    }

	    // Loop through children appending to the array until we hit depth

	    var i = 0;
	    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }

	    // If there's a remainder, just add whatever is left

	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }

	    return parseObject(keys, val, options, valuesParsed);
	};

	var normalizeParseOptions = function normalizeParseOptions(opts) {
	    if (!opts) {
	        return defaults$1;
	    }

	    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }

	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	    var charset = typeof opts.charset === 'undefined' ? defaults$1.charset : opts.charset;

	    return {
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults$1.allowDots : !!opts.allowDots,
	        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults$1.allowPrototypes,
	        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults$1.allowSparse,
	        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults$1.arrayLimit,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$1.charsetSentinel,
	        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults$1.comma,
	        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults$1.decoder,
	        delimiter: typeof opts.delimiter === 'string' || utils$5.isRegExp(opts.delimiter) ? opts.delimiter : defaults$1.delimiter,
	        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
	        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults$1.depth,
	        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
	        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults$1.interpretNumericEntities,
	        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults$1.parameterLimit,
	        parseArrays: opts.parseArrays !== false,
	        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults$1.plainObjects,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$1.strictNullHandling
	    };
	};

	var parse$8 = function (str, opts) {
	    var options = normalizeParseOptions(opts);

	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }

	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};

	    // Iterate over the keys and setup the new object

	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
	        obj = utils$5.merge(obj, newObj, options);
	    }

	    if (options.allowSparse === true) {
	        return obj;
	    }

	    return utils$5.compact(obj);
	};

	var stringify = stringify_1;
	var parse$7 = parse$8;
	var formats = formats$3;

	var lib$1 = {
	    formats: formats,
	    parse: parse$7,
	    stringify: stringify
	};

	var types$4 = {};

	(function (exports) {
		// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
		// Licensed under the Apache License, version 2.0
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.ProviderType = exports.RegExpString = exports.IntNumber = exports.BigIntString = exports.AddressString = exports.HexString = exports.OpaqueType = void 0;
		function OpaqueType() {
		    return (value) => value;
		}
		exports.OpaqueType = OpaqueType;
		exports.HexString = OpaqueType();
		exports.AddressString = OpaqueType();
		exports.BigIntString = OpaqueType();
		function IntNumber(num) {
		    return Math.floor(num);
		}
		exports.IntNumber = IntNumber;
		exports.RegExpString = OpaqueType();
		(function (ProviderType) {
		    ProviderType["CoinbaseWallet"] = "CoinbaseWallet";
		    ProviderType["MetaMask"] = "MetaMask";
		    ProviderType["Unselected"] = "";
		})(exports.ProviderType || (exports.ProviderType = {})); 
	} (types$4));

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	var __importDefault$e = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(util$3, "__esModule", { value: true });
	util$3.isInIFrame = util$3.createQrUrl = util$3.getFavicon = util$3.range = util$3.isBigNumber = util$3.ensureParsedJSONObject = util$3.ensureBN = util$3.ensureRegExpString = util$3.ensureIntNumber = util$3.ensureBuffer = util$3.ensureAddressString = util$3.ensureEvenLengthHexString = util$3.ensureHexString = util$3.isHexString = util$3.prepend0x = util$3.strip0x = util$3.has0xPrefix = util$3.hexStringFromIntNumber = util$3.intNumberFromHexString = util$3.bigIntStringFromBN = util$3.hexStringFromBuffer = util$3.hexStringToUint8Array = util$3.uint8ArrayToHex = util$3.randomBytesHex = void 0;
	const bn_js_1$1 = __importDefault$e(bnExports$1);
	const qs_1 = lib$1;
	const errors_1$3 = errors$2;
	const types_1$3 = types$4;
	const INT_STRING_REGEX = /^[0-9]*$/;
	const HEXADECIMAL_STRING_REGEX = /^[a-f0-9]*$/;
	/**
	 * @param length number of bytes
	 */
	function randomBytesHex(length) {
	    return uint8ArrayToHex(crypto.getRandomValues(new Uint8Array(length)));
	}
	util$3.randomBytesHex = randomBytesHex;
	function uint8ArrayToHex(value) {
	    return [...value].map(b => b.toString(16).padStart(2, "0")).join("");
	}
	util$3.uint8ArrayToHex = uint8ArrayToHex;
	function hexStringToUint8Array(hexString) {
	    return new Uint8Array(hexString.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
	}
	util$3.hexStringToUint8Array = hexStringToUint8Array;
	function hexStringFromBuffer(buf, includePrefix = false) {
	    const hex = buf.toString("hex");
	    return (0, types_1$3.HexString)(includePrefix ? "0x" + hex : hex);
	}
	util$3.hexStringFromBuffer = hexStringFromBuffer;
	function bigIntStringFromBN(bn) {
	    return (0, types_1$3.BigIntString)(bn.toString(10));
	}
	util$3.bigIntStringFromBN = bigIntStringFromBN;
	function intNumberFromHexString(hex) {
	    return (0, types_1$3.IntNumber)(new bn_js_1$1.default(ensureEvenLengthHexString(hex, false), 16).toNumber());
	}
	util$3.intNumberFromHexString = intNumberFromHexString;
	function hexStringFromIntNumber(num) {
	    return (0, types_1$3.HexString)("0x" + new bn_js_1$1.default(num).toString(16));
	}
	util$3.hexStringFromIntNumber = hexStringFromIntNumber;
	function has0xPrefix(str) {
	    return str.startsWith("0x") || str.startsWith("0X");
	}
	util$3.has0xPrefix = has0xPrefix;
	function strip0x(hex) {
	    if (has0xPrefix(hex)) {
	        return hex.slice(2);
	    }
	    return hex;
	}
	util$3.strip0x = strip0x;
	function prepend0x(hex) {
	    if (has0xPrefix(hex)) {
	        return "0x" + hex.slice(2);
	    }
	    return "0x" + hex;
	}
	util$3.prepend0x = prepend0x;
	function isHexString$1(hex) {
	    if (typeof hex !== "string") {
	        return false;
	    }
	    const s = strip0x(hex).toLowerCase();
	    return HEXADECIMAL_STRING_REGEX.test(s);
	}
	util$3.isHexString = isHexString$1;
	function ensureHexString(hex, includePrefix = false) {
	    if (typeof hex === "string") {
	        const s = strip0x(hex).toLowerCase();
	        if (HEXADECIMAL_STRING_REGEX.test(s)) {
	            return (0, types_1$3.HexString)(includePrefix ? "0x" + s : s);
	        }
	    }
	    throw errors_1$3.standardErrors.rpc.invalidParams(`"${String(hex)}" is not a hexadecimal string`);
	}
	util$3.ensureHexString = ensureHexString;
	function ensureEvenLengthHexString(hex, includePrefix = false) {
	    let h = ensureHexString(hex, false);
	    if (h.length % 2 === 1) {
	        h = (0, types_1$3.HexString)("0" + h);
	    }
	    return includePrefix ? (0, types_1$3.HexString)("0x" + h) : h;
	}
	util$3.ensureEvenLengthHexString = ensureEvenLengthHexString;
	function ensureAddressString(str) {
	    if (typeof str === "string") {
	        const s = strip0x(str).toLowerCase();
	        if (isHexString$1(s) && s.length === 40) {
	            return (0, types_1$3.AddressString)(prepend0x(s));
	        }
	    }
	    throw errors_1$3.standardErrors.rpc.invalidParams(`Invalid Ethereum address: ${String(str)}`);
	}
	util$3.ensureAddressString = ensureAddressString;
	function ensureBuffer(str) {
	    if (Buffer.isBuffer(str)) {
	        return str;
	    }
	    if (typeof str === "string") {
	        if (isHexString$1(str)) {
	            const s = ensureEvenLengthHexString(str, false);
	            return Buffer.from(s, "hex");
	        }
	        else {
	            return Buffer.from(str, "utf8");
	        }
	    }
	    throw errors_1$3.standardErrors.rpc.invalidParams(`Not binary data: ${String(str)}`);
	}
	util$3.ensureBuffer = ensureBuffer;
	function ensureIntNumber(num) {
	    if (typeof num === "number" && Number.isInteger(num)) {
	        return (0, types_1$3.IntNumber)(num);
	    }
	    if (typeof num === "string") {
	        if (INT_STRING_REGEX.test(num)) {
	            return (0, types_1$3.IntNumber)(Number(num));
	        }
	        if (isHexString$1(num)) {
	            return (0, types_1$3.IntNumber)(new bn_js_1$1.default(ensureEvenLengthHexString(num, false), 16).toNumber());
	        }
	    }
	    throw errors_1$3.standardErrors.rpc.invalidParams(`Not an integer: ${String(num)}`);
	}
	util$3.ensureIntNumber = ensureIntNumber;
	function ensureRegExpString(regExp) {
	    if (regExp instanceof RegExp) {
	        return (0, types_1$3.RegExpString)(regExp.toString());
	    }
	    throw errors_1$3.standardErrors.rpc.invalidParams(`Not a RegExp: ${String(regExp)}`);
	}
	util$3.ensureRegExpString = ensureRegExpString;
	function ensureBN(val) {
	    if (val !== null && (bn_js_1$1.default.isBN(val) || isBigNumber(val))) {
	        return new bn_js_1$1.default(val.toString(10), 10);
	    }
	    if (typeof val === "number") {
	        return new bn_js_1$1.default(ensureIntNumber(val));
	    }
	    if (typeof val === "string") {
	        if (INT_STRING_REGEX.test(val)) {
	            return new bn_js_1$1.default(val, 10);
	        }
	        if (isHexString$1(val)) {
	            return new bn_js_1$1.default(ensureEvenLengthHexString(val, false), 16);
	        }
	    }
	    throw errors_1$3.standardErrors.rpc.invalidParams(`Not an integer: ${String(val)}`);
	}
	util$3.ensureBN = ensureBN;
	function ensureParsedJSONObject(val) {
	    if (typeof val === "string") {
	        return JSON.parse(val);
	    }
	    if (typeof val === "object") {
	        return val;
	    }
	    throw errors_1$3.standardErrors.rpc.invalidParams(`Not a JSON string or an object: ${String(val)}`);
	}
	util$3.ensureParsedJSONObject = ensureParsedJSONObject;
	function isBigNumber(val) {
	    if (val == null || typeof val.constructor !== "function") {
	        return false;
	    }
	    const { constructor } = val;
	    return (typeof constructor.config === "function" &&
	        typeof constructor.EUCLID === "number");
	}
	util$3.isBigNumber = isBigNumber;
	function range$2(start, stop) {
	    return Array.from({ length: stop - start }, (_, i) => start + i);
	}
	util$3.range = range$2;
	function getFavicon() {
	    const el = document.querySelector('link[sizes="192x192"]') ||
	        document.querySelector('link[sizes="180x180"]') ||
	        document.querySelector('link[rel="icon"]') ||
	        document.querySelector('link[rel="shortcut icon"]');
	    const { protocol, host } = document.location;
	    const href = el ? el.getAttribute("href") : null;
	    if (!href || href.startsWith("javascript:")) {
	        return null;
	    }
	    if (href.startsWith("http://") ||
	        href.startsWith("https://") ||
	        href.startsWith("data:")) {
	        return href;
	    }
	    if (href.startsWith("//")) {
	        return protocol + href;
	    }
	    return `${protocol}//${host}${href}`;
	}
	util$3.getFavicon = getFavicon;
	function createQrUrl(sessionId, sessionSecret, serverUrl, isParentConnection, version, chainId) {
	    const sessionIdKey = isParentConnection ? "parent-id" : "id";
	    const query = (0, qs_1.stringify)({
	        [sessionIdKey]: sessionId,
	        secret: sessionSecret,
	        server: serverUrl,
	        v: version,
	        chainId,
	    });
	    const qrUrl = `${serverUrl}/#/link?${query}`;
	    return qrUrl;
	}
	util$3.createQrUrl = createQrUrl;
	function isInIFrame() {
	    try {
	        return window.frameElement !== null;
	    }
	    catch (e) {
	        return false;
	    }
	}
	util$3.isInIFrame = isInIFrame;

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(Session$1, "__esModule", { value: true });
	Session$1.Session = void 0;
	const sha_js_1 = sha_jsExports;
	const util_1$7 = util$3;
	const STORAGE_KEY_SESSION_ID = "session:id";
	const STORAGE_KEY_SESSION_SECRET = "session:secret";
	const STORAGE_KEY_SESSION_LINKED = "session:linked";
	class Session {
	    constructor(storage, id, secret, linked) {
	        this._storage = storage;
	        this._id = id || (0, util_1$7.randomBytesHex)(16);
	        this._secret = secret || (0, util_1$7.randomBytesHex)(32);
	        this._key = new sha_js_1.sha256()
	            .update(`${this._id}, ${this._secret} WalletLink`) // ensure old sessions stay connected
	            .digest("hex");
	        this._linked = !!linked;
	    }
	    static load(storage) {
	        const id = storage.getItem(STORAGE_KEY_SESSION_ID);
	        const linked = storage.getItem(STORAGE_KEY_SESSION_LINKED);
	        const secret = storage.getItem(STORAGE_KEY_SESSION_SECRET);
	        if (id && secret) {
	            return new Session(storage, id, secret, linked === "1");
	        }
	        return null;
	    }
	    /**
	     * Takes in a session ID and returns the sha256 hash of it.
	     * @param sessionId session ID
	     */
	    static hash(sessionId) {
	        return new sha_js_1.sha256().update(sessionId).digest("hex");
	    }
	    get id() {
	        return this._id;
	    }
	    get secret() {
	        return this._secret;
	    }
	    get key() {
	        return this._key;
	    }
	    get linked() {
	        return this._linked;
	    }
	    set linked(val) {
	        this._linked = val;
	        this.persistLinked();
	    }
	    save() {
	        this._storage.setItem(STORAGE_KEY_SESSION_ID, this._id);
	        this._storage.setItem(STORAGE_KEY_SESSION_SECRET, this._secret);
	        this.persistLinked();
	        return this;
	    }
	    persistLinked() {
	        this._storage.setItem(STORAGE_KEY_SESSION_LINKED, this._linked ? "1" : "0");
	    }
	}
	Session$1.Session = Session;

	var WalletSDKRelayAbstract$1 = {};

	Object.defineProperty(WalletSDKRelayAbstract$1, "__esModule", { value: true });
	WalletSDKRelayAbstract$1.WalletSDKRelayAbstract = WalletSDKRelayAbstract$1.APP_VERSION_KEY = WalletSDKRelayAbstract$1.LOCAL_STORAGE_ADDRESSES_KEY = WalletSDKRelayAbstract$1.WALLET_USER_NAME_KEY = void 0;
	const errors_1$2 = errors$2;
	WalletSDKRelayAbstract$1.WALLET_USER_NAME_KEY = "walletUsername";
	WalletSDKRelayAbstract$1.LOCAL_STORAGE_ADDRESSES_KEY = "Addresses";
	WalletSDKRelayAbstract$1.APP_VERSION_KEY = "AppVersion";
	class WalletSDKRelayAbstract {
	    async makeEthereumJSONRPCRequest(request, jsonRpcUrl) {
	        if (!jsonRpcUrl)
	            throw new Error("Error: No jsonRpcUrl provided");
	        return window
	            .fetch(jsonRpcUrl, {
	            method: "POST",
	            body: JSON.stringify(request),
	            mode: "cors",
	            headers: { "Content-Type": "application/json" },
	        })
	            .then(res => res.json())
	            .then(json => {
	            if (!json) {
	                throw errors_1$2.standardErrors.rpc.parse({});
	            }
	            const response = json;
	            const { error } = response;
	            if (error) {
	                throw (0, errors_1$2.serializeError)(error, request.method);
	            }
	            return response;
	        });
	    }
	}
	WalletSDKRelayAbstract$1.WalletSDKRelayAbstract = WalletSDKRelayAbstract;

	var readableBrowser = {exports: {}};

	var streamBrowser = eventsExports.EventEmitter;

	var buffer_list;
	var hasRequiredBuffer_list;

	function requireBuffer_list () {
		if (hasRequiredBuffer_list) return buffer_list;
		hasRequiredBuffer_list = 1;

		function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

		function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

		function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

		function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

		var _require = buffer$2,
		    Buffer = _require.Buffer;

		var _require2 = require$$3,
		    inspect = _require2.inspect;

		var custom = inspect && inspect.custom || 'inspect';

		function copyBuffer(src, target, offset) {
		  Buffer.prototype.copy.call(src, target, offset);
		}

		buffer_list =
		/*#__PURE__*/
		function () {
		  function BufferList() {
		    _classCallCheck(this, BufferList);

		    this.head = null;
		    this.tail = null;
		    this.length = 0;
		  }

		  _createClass(BufferList, [{
		    key: "push",
		    value: function push(v) {
		      var entry = {
		        data: v,
		        next: null
		      };
		      if (this.length > 0) this.tail.next = entry;else this.head = entry;
		      this.tail = entry;
		      ++this.length;
		    }
		  }, {
		    key: "unshift",
		    value: function unshift(v) {
		      var entry = {
		        data: v,
		        next: this.head
		      };
		      if (this.length === 0) this.tail = entry;
		      this.head = entry;
		      ++this.length;
		    }
		  }, {
		    key: "shift",
		    value: function shift() {
		      if (this.length === 0) return;
		      var ret = this.head.data;
		      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
		      --this.length;
		      return ret;
		    }
		  }, {
		    key: "clear",
		    value: function clear() {
		      this.head = this.tail = null;
		      this.length = 0;
		    }
		  }, {
		    key: "join",
		    value: function join(s) {
		      if (this.length === 0) return '';
		      var p = this.head;
		      var ret = '' + p.data;

		      while (p = p.next) {
		        ret += s + p.data;
		      }

		      return ret;
		    }
		  }, {
		    key: "concat",
		    value: function concat(n) {
		      if (this.length === 0) return Buffer.alloc(0);
		      var ret = Buffer.allocUnsafe(n >>> 0);
		      var p = this.head;
		      var i = 0;

		      while (p) {
		        copyBuffer(p.data, ret, i);
		        i += p.data.length;
		        p = p.next;
		      }

		      return ret;
		    } // Consumes a specified amount of bytes or characters from the buffered data.

		  }, {
		    key: "consume",
		    value: function consume(n, hasStrings) {
		      var ret;

		      if (n < this.head.data.length) {
		        // `slice` is the same for buffers and strings.
		        ret = this.head.data.slice(0, n);
		        this.head.data = this.head.data.slice(n);
		      } else if (n === this.head.data.length) {
		        // First chunk is a perfect match.
		        ret = this.shift();
		      } else {
		        // Result spans more than one buffer.
		        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
		      }

		      return ret;
		    }
		  }, {
		    key: "first",
		    value: function first() {
		      return this.head.data;
		    } // Consumes a specified amount of characters from the buffered data.

		  }, {
		    key: "_getString",
		    value: function _getString(n) {
		      var p = this.head;
		      var c = 1;
		      var ret = p.data;
		      n -= ret.length;

		      while (p = p.next) {
		        var str = p.data;
		        var nb = n > str.length ? str.length : n;
		        if (nb === str.length) ret += str;else ret += str.slice(0, n);
		        n -= nb;

		        if (n === 0) {
		          if (nb === str.length) {
		            ++c;
		            if (p.next) this.head = p.next;else this.head = this.tail = null;
		          } else {
		            this.head = p;
		            p.data = str.slice(nb);
		          }

		          break;
		        }

		        ++c;
		      }

		      this.length -= c;
		      return ret;
		    } // Consumes a specified amount of bytes from the buffered data.

		  }, {
		    key: "_getBuffer",
		    value: function _getBuffer(n) {
		      var ret = Buffer.allocUnsafe(n);
		      var p = this.head;
		      var c = 1;
		      p.data.copy(ret);
		      n -= p.data.length;

		      while (p = p.next) {
		        var buf = p.data;
		        var nb = n > buf.length ? buf.length : n;
		        buf.copy(ret, ret.length - n, 0, nb);
		        n -= nb;

		        if (n === 0) {
		          if (nb === buf.length) {
		            ++c;
		            if (p.next) this.head = p.next;else this.head = this.tail = null;
		          } else {
		            this.head = p;
		            p.data = buf.slice(nb);
		          }

		          break;
		        }

		        ++c;
		      }

		      this.length -= c;
		      return ret;
		    } // Make sure the linked list only shows the minimal necessary information.

		  }, {
		    key: custom,
		    value: function value(_, options) {
		      return inspect(this, _objectSpread({}, options, {
		        // Only inspect one level.
		        depth: 0,
		        // It should not recurse.
		        customInspect: false
		      }));
		    }
		  }]);

		  return BufferList;
		}();
		return buffer_list;
	}

	function destroy(err, cb) {
	  var _this = this;

	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;

	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err) {
	      if (!this._writableState) {
	        process.nextTick(emitErrorNT, this, err);
	      } else if (!this._writableState.errorEmitted) {
	        this._writableState.errorEmitted = true;
	        process.nextTick(emitErrorNT, this, err);
	      }
	    }

	    return this;
	  } // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks


	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  } // if this is a duplex stream mark the writable part as destroyed as well


	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }

	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      if (!_this._writableState) {
	        process.nextTick(emitErrorAndCloseNT, _this, err);
	      } else if (!_this._writableState.errorEmitted) {
	        _this._writableState.errorEmitted = true;
	        process.nextTick(emitErrorAndCloseNT, _this, err);
	      } else {
	        process.nextTick(emitCloseNT, _this);
	      }
	    } else if (cb) {
	      process.nextTick(emitCloseNT, _this);
	      cb(err);
	    } else {
	      process.nextTick(emitCloseNT, _this);
	    }
	  });

	  return this;
	}

	function emitErrorAndCloseNT(self, err) {
	  emitErrorNT(self, err);
	  emitCloseNT(self);
	}

	function emitCloseNT(self) {
	  if (self._writableState && !self._writableState.emitClose) return;
	  if (self._readableState && !self._readableState.emitClose) return;
	  self.emit('close');
	}

	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }

	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finalCalled = false;
	    this._writableState.prefinished = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}

	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}

	function errorOrDestroy(stream, err) {
	  // We have tests that rely on errors being emitted
	  // in the same tick, so changing this is semver major.
	  // For now when you opt-in to autoDestroy we allow
	  // the error to be emitted nextTick. In a future
	  // semver major update we should change the default to this.
	  var rState = stream._readableState;
	  var wState = stream._writableState;
	  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
	}

	var destroy_1 = {
	  destroy: destroy,
	  undestroy: undestroy,
	  errorOrDestroy: errorOrDestroy
	};

	var errorsBrowser = {};

	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

	var codes = {};

	function createErrorType(code, message, Base) {
	  if (!Base) {
	    Base = Error;
	  }

	  function getMessage(arg1, arg2, arg3) {
	    if (typeof message === 'string') {
	      return message;
	    } else {
	      return message(arg1, arg2, arg3);
	    }
	  }

	  var NodeError =
	  /*#__PURE__*/
	  function (_Base) {
	    _inheritsLoose(NodeError, _Base);

	    function NodeError(arg1, arg2, arg3) {
	      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
	    }

	    return NodeError;
	  }(Base);

	  NodeError.prototype.name = Base.name;
	  NodeError.prototype.code = code;
	  codes[code] = NodeError;
	} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


	function oneOf(expected, thing) {
	  if (Array.isArray(expected)) {
	    var len = expected.length;
	    expected = expected.map(function (i) {
	      return String(i);
	    });

	    if (len > 2) {
	      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
	    } else if (len === 2) {
	      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
	    } else {
	      return "of ".concat(thing, " ").concat(expected[0]);
	    }
	  } else {
	    return "of ".concat(thing, " ").concat(String(expected));
	  }
	} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


	function startsWith(str, search, pos) {
	  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
	} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


	function endsWith(str, search, this_len) {
	  if (this_len === undefined || this_len > str.length) {
	    this_len = str.length;
	  }

	  return str.substring(this_len - search.length, this_len) === search;
	} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


	function includes(str, search, start) {
	  if (typeof start !== 'number') {
	    start = 0;
	  }

	  if (start + search.length > str.length) {
	    return false;
	  } else {
	    return str.indexOf(search, start) !== -1;
	  }
	}

	createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
	  return 'The value "' + value + '" is invalid for option "' + name + '"';
	}, TypeError);
	createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
	  // determiner: 'must be' or 'must not be'
	  var determiner;

	  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
	    determiner = 'must not be';
	    expected = expected.replace(/^not /, '');
	  } else {
	    determiner = 'must be';
	  }

	  var msg;

	  if (endsWith(name, ' argument')) {
	    // For cases like 'first argument'
	    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
	  } else {
	    var type = includes(name, '.') ? 'property' : 'argument';
	    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
	  }

	  msg += ". Received type ".concat(typeof actual);
	  return msg;
	}, TypeError);
	createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
	createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
	  return 'The ' + name + ' method is not implemented';
	});
	createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
	createErrorType('ERR_STREAM_DESTROYED', function (name) {
	  return 'Cannot call ' + name + ' after a stream was destroyed';
	});
	createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
	createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
	createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
	createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
	createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
	  return 'Unknown encoding: ' + arg;
	}, TypeError);
	createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
	errorsBrowser.codes = codes;

	var ERR_INVALID_OPT_VALUE = errorsBrowser.codes.ERR_INVALID_OPT_VALUE;

	function highWaterMarkFrom(options, isDuplex, duplexKey) {
	  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
	}

	function getHighWaterMark(state, options, duplexKey, isDuplex) {
	  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);

	  if (hwm != null) {
	    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
	      var name = isDuplex ? duplexKey : 'highWaterMark';
	      throw new ERR_INVALID_OPT_VALUE(name, hwm);
	    }

	    return Math.floor(hwm);
	  } // Default value


	  return state.objectMode ? 16 : 16 * 1024;
	}

	var state = {
	  getHighWaterMark: getHighWaterMark
	};

	var browser$4;
	var hasRequiredBrowser$1;

	function requireBrowser$1 () {
		if (hasRequiredBrowser$1) return browser$4;
		hasRequiredBrowser$1 = 1;
		/**
		 * Module exports.
		 */

		browser$4 = deprecate;

		/**
		 * Mark that a method should not be used.
		 * Returns a modified function which warns once by default.
		 *
		 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
		 *
		 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
		 * will throw an Error when invoked.
		 *
		 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
		 * will invoke `console.trace()` instead of `console.error()`.
		 *
		 * @param {Function} fn - the function to deprecate
		 * @param {String} msg - the string to print to the console when `fn` is invoked
		 * @returns {Function} a new "deprecated" version of `fn`
		 * @api public
		 */

		function deprecate (fn, msg) {
		  if (config('noDeprecation')) {
		    return fn;
		  }

		  var warned = false;
		  function deprecated() {
		    if (!warned) {
		      if (config('throwDeprecation')) {
		        throw new Error(msg);
		      } else if (config('traceDeprecation')) {
		        console.trace(msg);
		      } else {
		        console.warn(msg);
		      }
		      warned = true;
		    }
		    return fn.apply(this, arguments);
		  }

		  return deprecated;
		}

		/**
		 * Checks `localStorage` for boolean values for the given `name`.
		 *
		 * @param {String} name
		 * @returns {Boolean}
		 * @api private
		 */

		function config (name) {
		  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
		  try {
		    if (!commonjsGlobal.localStorage) return false;
		  } catch (_) {
		    return false;
		  }
		  var val = commonjsGlobal.localStorage[name];
		  if (null == val) return false;
		  return String(val).toLowerCase() === 'true';
		}
		return browser$4;
	}

	var _stream_writable;
	var hasRequired_stream_writable;

	function require_stream_writable () {
		if (hasRequired_stream_writable) return _stream_writable;
		hasRequired_stream_writable = 1;

		_stream_writable = Writable;
		// there will be only 2 of these for each stream


		function CorkedRequest(state) {
		  var _this = this;

		  this.next = null;
		  this.entry = null;

		  this.finish = function () {
		    onCorkedFinish(_this, state);
		  };
		}
		/* </replacement> */

		/*<replacement>*/


		var Duplex;
		/*</replacement>*/

		Writable.WritableState = WritableState;
		/*<replacement>*/

		var internalUtil = {
		  deprecate: requireBrowser$1()
		};
		/*</replacement>*/

		/*<replacement>*/

		var Stream = streamBrowser;
		/*</replacement>*/


		var Buffer = buffer$2.Buffer;

		var OurUint8Array = commonjsGlobal.Uint8Array || function () {};

		function _uint8ArrayToBuffer(chunk) {
		  return Buffer.from(chunk);
		}

		function _isUint8Array(obj) {
		  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
		}

		var destroyImpl = destroy_1;

		var _require = state,
		    getHighWaterMark = _require.getHighWaterMark;

		var _require$codes = errorsBrowser.codes,
		    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
		    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
		    ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
		    ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
		    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
		    ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
		    ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
		    ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;

		var errorOrDestroy = destroyImpl.errorOrDestroy;

		inherits_browserExports(Writable, Stream);

		function nop() {}

		function WritableState(options, stream, isDuplex) {
		  Duplex = Duplex || require_stream_duplex();
		  options = options || {}; // Duplex streams are both readable and writable, but share
		  // the same options object.
		  // However, some cases require setting options to different
		  // values for the readable and the writable sides of the duplex stream,
		  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.

		  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
		  // contains buffers or objects.

		  this.objectMode = !!options.objectMode;
		  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
		  // Note: 0 is a valid value, means that we always return false if
		  // the entire buffer is not flushed immediately on write()

		  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex); // if _final has been called

		  this.finalCalled = false; // drain event flag.

		  this.needDrain = false; // at the start of calling end()

		  this.ending = false; // when end() has been called, and returned

		  this.ended = false; // when 'finish' is emitted

		  this.finished = false; // has it been destroyed

		  this.destroyed = false; // should we decode strings into buffers before passing to _write?
		  // this is here so that some node-core streams can optimize string
		  // handling at a lower level.

		  var noDecode = options.decodeStrings === false;
		  this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
		  // encoding is 'binary' so we have to make this configurable.
		  // Everything else in the universe uses 'utf8', though.

		  this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
		  // of how much we're waiting to get pushed to some underlying
		  // socket or file.

		  this.length = 0; // a flag to see when we're in the middle of a write.

		  this.writing = false; // when true all writes will be buffered until .uncork() call

		  this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
		  // or on a later tick.  We set this to true at first, because any
		  // actions that shouldn't happen until "later" should generally also
		  // not happen before the first write call.

		  this.sync = true; // a flag to know if we're processing previously buffered items, which
		  // may call the _write() callback in the same tick, so that we don't
		  // end up in an overlapped onwrite situation.

		  this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)

		  this.onwrite = function (er) {
		    onwrite(stream, er);
		  }; // the callback that the user supplies to write(chunk,encoding,cb)


		  this.writecb = null; // the amount that is being written when _write is called.

		  this.writelen = 0;
		  this.bufferedRequest = null;
		  this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
		  // this must be 0 before 'finish' can be emitted

		  this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
		  // This is relevant for synchronous Transform streams

		  this.prefinished = false; // True if the error was already emitted and should not be thrown again

		  this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.

		  this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')

		  this.autoDestroy = !!options.autoDestroy; // count buffered requests

		  this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
		  // one allocated and free to use, and we maintain at most two

		  this.corkedRequestsFree = new CorkedRequest(this);
		}

		WritableState.prototype.getBuffer = function getBuffer() {
		  var current = this.bufferedRequest;
		  var out = [];

		  while (current) {
		    out.push(current);
		    current = current.next;
		  }

		  return out;
		};

		(function () {
		  try {
		    Object.defineProperty(WritableState.prototype, 'buffer', {
		      get: internalUtil.deprecate(function writableStateBufferGetter() {
		        return this.getBuffer();
		      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
		    });
		  } catch (_) {}
		})(); // Test _writableState for inheritance to account for Duplex streams,
		// whose prototype chain only points to Readable.


		var realHasInstance;

		if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
		  realHasInstance = Function.prototype[Symbol.hasInstance];
		  Object.defineProperty(Writable, Symbol.hasInstance, {
		    value: function value(object) {
		      if (realHasInstance.call(this, object)) return true;
		      if (this !== Writable) return false;
		      return object && object._writableState instanceof WritableState;
		    }
		  });
		} else {
		  realHasInstance = function realHasInstance(object) {
		    return object instanceof this;
		  };
		}

		function Writable(options) {
		  Duplex = Duplex || require_stream_duplex(); // Writable ctor is applied to Duplexes, too.
		  // `realHasInstance` is necessary because using plain `instanceof`
		  // would return false, as no `_writableState` property is attached.
		  // Trying to use the custom `instanceof` for Writable here will also break the
		  // Node.js LazyTransform implementation, which has a non-trivial getter for
		  // `_writableState` that would lead to infinite recursion.
		  // Checking for a Stream.Duplex instance is faster here instead of inside
		  // the WritableState constructor, at least with V8 6.5

		  var isDuplex = this instanceof Duplex;
		  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
		  this._writableState = new WritableState(options, this, isDuplex); // legacy.

		  this.writable = true;

		  if (options) {
		    if (typeof options.write === 'function') this._write = options.write;
		    if (typeof options.writev === 'function') this._writev = options.writev;
		    if (typeof options.destroy === 'function') this._destroy = options.destroy;
		    if (typeof options.final === 'function') this._final = options.final;
		  }

		  Stream.call(this);
		} // Otherwise people can pipe Writable streams, which is just wrong.


		Writable.prototype.pipe = function () {
		  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
		};

		function writeAfterEnd(stream, cb) {
		  var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb

		  errorOrDestroy(stream, er);
		  process.nextTick(cb, er);
		} // Checks that a user-supplied chunk is valid, especially for the particular
		// mode the stream is in. Currently this means that `null` is never accepted
		// and undefined/non-string values are only allowed in object mode.


		function validChunk(stream, state, chunk, cb) {
		  var er;

		  if (chunk === null) {
		    er = new ERR_STREAM_NULL_VALUES();
		  } else if (typeof chunk !== 'string' && !state.objectMode) {
		    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
		  }

		  if (er) {
		    errorOrDestroy(stream, er);
		    process.nextTick(cb, er);
		    return false;
		  }

		  return true;
		}

		Writable.prototype.write = function (chunk, encoding, cb) {
		  var state = this._writableState;
		  var ret = false;

		  var isBuf = !state.objectMode && _isUint8Array(chunk);

		  if (isBuf && !Buffer.isBuffer(chunk)) {
		    chunk = _uint8ArrayToBuffer(chunk);
		  }

		  if (typeof encoding === 'function') {
		    cb = encoding;
		    encoding = null;
		  }

		  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
		  if (typeof cb !== 'function') cb = nop;
		  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
		    state.pendingcb++;
		    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
		  }
		  return ret;
		};

		Writable.prototype.cork = function () {
		  this._writableState.corked++;
		};

		Writable.prototype.uncork = function () {
		  var state = this._writableState;

		  if (state.corked) {
		    state.corked--;
		    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
		  }
		};

		Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
		  // node::ParseEncoding() requires lower case.
		  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
		  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
		  this._writableState.defaultEncoding = encoding;
		  return this;
		};

		Object.defineProperty(Writable.prototype, 'writableBuffer', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function get() {
		    return this._writableState && this._writableState.getBuffer();
		  }
		});

		function decodeChunk(state, chunk, encoding) {
		  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
		    chunk = Buffer.from(chunk, encoding);
		  }

		  return chunk;
		}

		Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function get() {
		    return this._writableState.highWaterMark;
		  }
		}); // if we're already writing something, then just put this
		// in the queue, and wait our turn.  Otherwise, call _write
		// If we return false, then we need a drain event, so set that flag.

		function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
		  if (!isBuf) {
		    var newChunk = decodeChunk(state, chunk, encoding);

		    if (chunk !== newChunk) {
		      isBuf = true;
		      encoding = 'buffer';
		      chunk = newChunk;
		    }
		  }

		  var len = state.objectMode ? 1 : chunk.length;
		  state.length += len;
		  var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.

		  if (!ret) state.needDrain = true;

		  if (state.writing || state.corked) {
		    var last = state.lastBufferedRequest;
		    state.lastBufferedRequest = {
		      chunk: chunk,
		      encoding: encoding,
		      isBuf: isBuf,
		      callback: cb,
		      next: null
		    };

		    if (last) {
		      last.next = state.lastBufferedRequest;
		    } else {
		      state.bufferedRequest = state.lastBufferedRequest;
		    }

		    state.bufferedRequestCount += 1;
		  } else {
		    doWrite(stream, state, false, len, chunk, encoding, cb);
		  }

		  return ret;
		}

		function doWrite(stream, state, writev, len, chunk, encoding, cb) {
		  state.writelen = len;
		  state.writecb = cb;
		  state.writing = true;
		  state.sync = true;
		  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
		  state.sync = false;
		}

		function onwriteError(stream, state, sync, er, cb) {
		  --state.pendingcb;

		  if (sync) {
		    // defer the callback if we are being called synchronously
		    // to avoid piling up things on the stack
		    process.nextTick(cb, er); // this can emit finish, and it will always happen
		    // after error

		    process.nextTick(finishMaybe, stream, state);
		    stream._writableState.errorEmitted = true;
		    errorOrDestroy(stream, er);
		  } else {
		    // the caller expect this to happen before if
		    // it is async
		    cb(er);
		    stream._writableState.errorEmitted = true;
		    errorOrDestroy(stream, er); // this can emit finish, but finish must
		    // always follow error

		    finishMaybe(stream, state);
		  }
		}

		function onwriteStateUpdate(state) {
		  state.writing = false;
		  state.writecb = null;
		  state.length -= state.writelen;
		  state.writelen = 0;
		}

		function onwrite(stream, er) {
		  var state = stream._writableState;
		  var sync = state.sync;
		  var cb = state.writecb;
		  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
		  onwriteStateUpdate(state);
		  if (er) onwriteError(stream, state, sync, er, cb);else {
		    // Check if we're actually ready to finish, but don't emit yet
		    var finished = needFinish(state) || stream.destroyed;

		    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
		      clearBuffer(stream, state);
		    }

		    if (sync) {
		      process.nextTick(afterWrite, stream, state, finished, cb);
		    } else {
		      afterWrite(stream, state, finished, cb);
		    }
		  }
		}

		function afterWrite(stream, state, finished, cb) {
		  if (!finished) onwriteDrain(stream, state);
		  state.pendingcb--;
		  cb();
		  finishMaybe(stream, state);
		} // Must force callback to be called on nextTick, so that we don't
		// emit 'drain' before the write() consumer gets the 'false' return
		// value, and has a chance to attach a 'drain' listener.


		function onwriteDrain(stream, state) {
		  if (state.length === 0 && state.needDrain) {
		    state.needDrain = false;
		    stream.emit('drain');
		  }
		} // if there's something in the buffer waiting, then process it


		function clearBuffer(stream, state) {
		  state.bufferProcessing = true;
		  var entry = state.bufferedRequest;

		  if (stream._writev && entry && entry.next) {
		    // Fast case, write everything using _writev()
		    var l = state.bufferedRequestCount;
		    var buffer = new Array(l);
		    var holder = state.corkedRequestsFree;
		    holder.entry = entry;
		    var count = 0;
		    var allBuffers = true;

		    while (entry) {
		      buffer[count] = entry;
		      if (!entry.isBuf) allBuffers = false;
		      entry = entry.next;
		      count += 1;
		    }

		    buffer.allBuffers = allBuffers;
		    doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
		    // as the hot path ends with doWrite

		    state.pendingcb++;
		    state.lastBufferedRequest = null;

		    if (holder.next) {
		      state.corkedRequestsFree = holder.next;
		      holder.next = null;
		    } else {
		      state.corkedRequestsFree = new CorkedRequest(state);
		    }

		    state.bufferedRequestCount = 0;
		  } else {
		    // Slow case, write chunks one-by-one
		    while (entry) {
		      var chunk = entry.chunk;
		      var encoding = entry.encoding;
		      var cb = entry.callback;
		      var len = state.objectMode ? 1 : chunk.length;
		      doWrite(stream, state, false, len, chunk, encoding, cb);
		      entry = entry.next;
		      state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
		      // it means that we need to wait until it does.
		      // also, that means that the chunk and cb are currently
		      // being processed, so move the buffer counter past them.

		      if (state.writing) {
		        break;
		      }
		    }

		    if (entry === null) state.lastBufferedRequest = null;
		  }

		  state.bufferedRequest = entry;
		  state.bufferProcessing = false;
		}

		Writable.prototype._write = function (chunk, encoding, cb) {
		  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
		};

		Writable.prototype._writev = null;

		Writable.prototype.end = function (chunk, encoding, cb) {
		  var state = this._writableState;

		  if (typeof chunk === 'function') {
		    cb = chunk;
		    chunk = null;
		    encoding = null;
		  } else if (typeof encoding === 'function') {
		    cb = encoding;
		    encoding = null;
		  }

		  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks

		  if (state.corked) {
		    state.corked = 1;
		    this.uncork();
		  } // ignore unnecessary end() calls.


		  if (!state.ending) endWritable(this, state, cb);
		  return this;
		};

		Object.defineProperty(Writable.prototype, 'writableLength', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function get() {
		    return this._writableState.length;
		  }
		});

		function needFinish(state) {
		  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
		}

		function callFinal(stream, state) {
		  stream._final(function (err) {
		    state.pendingcb--;

		    if (err) {
		      errorOrDestroy(stream, err);
		    }

		    state.prefinished = true;
		    stream.emit('prefinish');
		    finishMaybe(stream, state);
		  });
		}

		function prefinish(stream, state) {
		  if (!state.prefinished && !state.finalCalled) {
		    if (typeof stream._final === 'function' && !state.destroyed) {
		      state.pendingcb++;
		      state.finalCalled = true;
		      process.nextTick(callFinal, stream, state);
		    } else {
		      state.prefinished = true;
		      stream.emit('prefinish');
		    }
		  }
		}

		function finishMaybe(stream, state) {
		  var need = needFinish(state);

		  if (need) {
		    prefinish(stream, state);

		    if (state.pendingcb === 0) {
		      state.finished = true;
		      stream.emit('finish');

		      if (state.autoDestroy) {
		        // In case of duplex streams we need a way to detect
		        // if the readable side is ready for autoDestroy as well
		        var rState = stream._readableState;

		        if (!rState || rState.autoDestroy && rState.endEmitted) {
		          stream.destroy();
		        }
		      }
		    }
		  }

		  return need;
		}

		function endWritable(stream, state, cb) {
		  state.ending = true;
		  finishMaybe(stream, state);

		  if (cb) {
		    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
		  }

		  state.ended = true;
		  stream.writable = false;
		}

		function onCorkedFinish(corkReq, state, err) {
		  var entry = corkReq.entry;
		  corkReq.entry = null;

		  while (entry) {
		    var cb = entry.callback;
		    state.pendingcb--;
		    cb(err);
		    entry = entry.next;
		  } // reuse the free corkReq.


		  state.corkedRequestsFree.next = corkReq;
		}

		Object.defineProperty(Writable.prototype, 'destroyed', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function get() {
		    if (this._writableState === undefined) {
		      return false;
		    }

		    return this._writableState.destroyed;
		  },
		  set: function set(value) {
		    // we ignore the value if the stream
		    // has not been initialized yet
		    if (!this._writableState) {
		      return;
		    } // backward compatibility, the user is explicitly
		    // managing destroyed


		    this._writableState.destroyed = value;
		  }
		});
		Writable.prototype.destroy = destroyImpl.destroy;
		Writable.prototype._undestroy = destroyImpl.undestroy;

		Writable.prototype._destroy = function (err, cb) {
		  cb(err);
		};
		return _stream_writable;
	}

	var _stream_duplex;
	var hasRequired_stream_duplex;

	function require_stream_duplex () {
		if (hasRequired_stream_duplex) return _stream_duplex;
		hasRequired_stream_duplex = 1;
		/*<replacement>*/

		var objectKeys = Object.keys || function (obj) {
		  var keys = [];

		  for (var key in obj) {
		    keys.push(key);
		  }

		  return keys;
		};
		/*</replacement>*/


		_stream_duplex = Duplex;

		var Readable = require_stream_readable();

		var Writable = require_stream_writable();

		inherits_browserExports(Duplex, Readable);

		{
		  // Allow the keys array to be GC'ed.
		  var keys = objectKeys(Writable.prototype);

		  for (var v = 0; v < keys.length; v++) {
		    var method = keys[v];
		    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
		  }
		}

		function Duplex(options) {
		  if (!(this instanceof Duplex)) return new Duplex(options);
		  Readable.call(this, options);
		  Writable.call(this, options);
		  this.allowHalfOpen = true;

		  if (options) {
		    if (options.readable === false) this.readable = false;
		    if (options.writable === false) this.writable = false;

		    if (options.allowHalfOpen === false) {
		      this.allowHalfOpen = false;
		      this.once('end', onend);
		    }
		  }
		}

		Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function get() {
		    return this._writableState.highWaterMark;
		  }
		});
		Object.defineProperty(Duplex.prototype, 'writableBuffer', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function get() {
		    return this._writableState && this._writableState.getBuffer();
		  }
		});
		Object.defineProperty(Duplex.prototype, 'writableLength', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function get() {
		    return this._writableState.length;
		  }
		}); // the no-half-open enforcer

		function onend() {
		  // If the writable side ended, then we're ok.
		  if (this._writableState.ended) return; // no more data can be written.
		  // But allow more writes to happen in this tick.

		  process.nextTick(onEndNT, this);
		}

		function onEndNT(self) {
		  self.end();
		}

		Object.defineProperty(Duplex.prototype, 'destroyed', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function get() {
		    if (this._readableState === undefined || this._writableState === undefined) {
		      return false;
		    }

		    return this._readableState.destroyed && this._writableState.destroyed;
		  },
		  set: function set(value) {
		    // we ignore the value if the stream
		    // has not been initialized yet
		    if (this._readableState === undefined || this._writableState === undefined) {
		      return;
		    } // backward compatibility, the user is explicitly
		    // managing destroyed


		    this._readableState.destroyed = value;
		    this._writableState.destroyed = value;
		  }
		});
		return _stream_duplex;
	}

	var string_decoder = {};

	var hasRequiredString_decoder;

	function requireString_decoder () {
		if (hasRequiredString_decoder) return string_decoder;
		hasRequiredString_decoder = 1;

		/*<replacement>*/

		var Buffer = safeBufferExports.Buffer;
		/*</replacement>*/

		var isEncoding = Buffer.isEncoding || function (encoding) {
		  encoding = '' + encoding;
		  switch (encoding && encoding.toLowerCase()) {
		    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
		      return true;
		    default:
		      return false;
		  }
		};

		function _normalizeEncoding(enc) {
		  if (!enc) return 'utf8';
		  var retried;
		  while (true) {
		    switch (enc) {
		      case 'utf8':
		      case 'utf-8':
		        return 'utf8';
		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return 'utf16le';
		      case 'latin1':
		      case 'binary':
		        return 'latin1';
		      case 'base64':
		      case 'ascii':
		      case 'hex':
		        return enc;
		      default:
		        if (retried) return; // undefined
		        enc = ('' + enc).toLowerCase();
		        retried = true;
		    }
		  }
		}
		// Do not cache `Buffer.isEncoding` when checking encoding names as some
		// modules monkey-patch it to support additional encodings
		function normalizeEncoding(enc) {
		  var nenc = _normalizeEncoding(enc);
		  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
		  return nenc || enc;
		}

		// StringDecoder provides an interface for efficiently splitting a series of
		// buffers into a series of JS strings without breaking apart multi-byte
		// characters.
		string_decoder.StringDecoder = StringDecoder;
		function StringDecoder(encoding) {
		  this.encoding = normalizeEncoding(encoding);
		  var nb;
		  switch (this.encoding) {
		    case 'utf16le':
		      this.text = utf16Text;
		      this.end = utf16End;
		      nb = 4;
		      break;
		    case 'utf8':
		      this.fillLast = utf8FillLast;
		      nb = 4;
		      break;
		    case 'base64':
		      this.text = base64Text;
		      this.end = base64End;
		      nb = 3;
		      break;
		    default:
		      this.write = simpleWrite;
		      this.end = simpleEnd;
		      return;
		  }
		  this.lastNeed = 0;
		  this.lastTotal = 0;
		  this.lastChar = Buffer.allocUnsafe(nb);
		}

		StringDecoder.prototype.write = function (buf) {
		  if (buf.length === 0) return '';
		  var r;
		  var i;
		  if (this.lastNeed) {
		    r = this.fillLast(buf);
		    if (r === undefined) return '';
		    i = this.lastNeed;
		    this.lastNeed = 0;
		  } else {
		    i = 0;
		  }
		  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
		  return r || '';
		};

		StringDecoder.prototype.end = utf8End;

		// Returns only complete characters in a Buffer
		StringDecoder.prototype.text = utf8Text;

		// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
		StringDecoder.prototype.fillLast = function (buf) {
		  if (this.lastNeed <= buf.length) {
		    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
		    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
		  }
		  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
		  this.lastNeed -= buf.length;
		};

		// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
		// continuation byte. If an invalid byte is detected, -2 is returned.
		function utf8CheckByte(byte) {
		  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
		  return byte >> 6 === 0x02 ? -1 : -2;
		}

		// Checks at most 3 bytes at the end of a Buffer in order to detect an
		// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
		// needed to complete the UTF-8 character (if applicable) are returned.
		function utf8CheckIncomplete(self, buf, i) {
		  var j = buf.length - 1;
		  if (j < i) return 0;
		  var nb = utf8CheckByte(buf[j]);
		  if (nb >= 0) {
		    if (nb > 0) self.lastNeed = nb - 1;
		    return nb;
		  }
		  if (--j < i || nb === -2) return 0;
		  nb = utf8CheckByte(buf[j]);
		  if (nb >= 0) {
		    if (nb > 0) self.lastNeed = nb - 2;
		    return nb;
		  }
		  if (--j < i || nb === -2) return 0;
		  nb = utf8CheckByte(buf[j]);
		  if (nb >= 0) {
		    if (nb > 0) {
		      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
		    }
		    return nb;
		  }
		  return 0;
		}

		// Validates as many continuation bytes for a multi-byte UTF-8 character as
		// needed or are available. If we see a non-continuation byte where we expect
		// one, we "replace" the validated continuation bytes we've seen so far with
		// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
		// behavior. The continuation byte check is included three times in the case
		// where all of the continuation bytes for a character exist in the same buffer.
		// It is also done this way as a slight performance increase instead of using a
		// loop.
		function utf8CheckExtraBytes(self, buf, p) {
		  if ((buf[0] & 0xC0) !== 0x80) {
		    self.lastNeed = 0;
		    return '\ufffd';
		  }
		  if (self.lastNeed > 1 && buf.length > 1) {
		    if ((buf[1] & 0xC0) !== 0x80) {
		      self.lastNeed = 1;
		      return '\ufffd';
		    }
		    if (self.lastNeed > 2 && buf.length > 2) {
		      if ((buf[2] & 0xC0) !== 0x80) {
		        self.lastNeed = 2;
		        return '\ufffd';
		      }
		    }
		  }
		}

		// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
		function utf8FillLast(buf) {
		  var p = this.lastTotal - this.lastNeed;
		  var r = utf8CheckExtraBytes(this, buf);
		  if (r !== undefined) return r;
		  if (this.lastNeed <= buf.length) {
		    buf.copy(this.lastChar, p, 0, this.lastNeed);
		    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
		  }
		  buf.copy(this.lastChar, p, 0, buf.length);
		  this.lastNeed -= buf.length;
		}

		// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
		// partial character, the character's bytes are buffered until the required
		// number of bytes are available.
		function utf8Text(buf, i) {
		  var total = utf8CheckIncomplete(this, buf, i);
		  if (!this.lastNeed) return buf.toString('utf8', i);
		  this.lastTotal = total;
		  var end = buf.length - (total - this.lastNeed);
		  buf.copy(this.lastChar, 0, end);
		  return buf.toString('utf8', i, end);
		}

		// For UTF-8, a replacement character is added when ending on a partial
		// character.
		function utf8End(buf) {
		  var r = buf && buf.length ? this.write(buf) : '';
		  if (this.lastNeed) return r + '\ufffd';
		  return r;
		}

		// UTF-16LE typically needs two bytes per character, but even if we have an even
		// number of bytes available, we need to check if we end on a leading/high
		// surrogate. In that case, we need to wait for the next two bytes in order to
		// decode the last character properly.
		function utf16Text(buf, i) {
		  if ((buf.length - i) % 2 === 0) {
		    var r = buf.toString('utf16le', i);
		    if (r) {
		      var c = r.charCodeAt(r.length - 1);
		      if (c >= 0xD800 && c <= 0xDBFF) {
		        this.lastNeed = 2;
		        this.lastTotal = 4;
		        this.lastChar[0] = buf[buf.length - 2];
		        this.lastChar[1] = buf[buf.length - 1];
		        return r.slice(0, -1);
		      }
		    }
		    return r;
		  }
		  this.lastNeed = 1;
		  this.lastTotal = 2;
		  this.lastChar[0] = buf[buf.length - 1];
		  return buf.toString('utf16le', i, buf.length - 1);
		}

		// For UTF-16LE we do not explicitly append special replacement characters if we
		// end on a partial character, we simply let v8 handle that.
		function utf16End(buf) {
		  var r = buf && buf.length ? this.write(buf) : '';
		  if (this.lastNeed) {
		    var end = this.lastTotal - this.lastNeed;
		    return r + this.lastChar.toString('utf16le', 0, end);
		  }
		  return r;
		}

		function base64Text(buf, i) {
		  var n = (buf.length - i) % 3;
		  if (n === 0) return buf.toString('base64', i);
		  this.lastNeed = 3 - n;
		  this.lastTotal = 3;
		  if (n === 1) {
		    this.lastChar[0] = buf[buf.length - 1];
		  } else {
		    this.lastChar[0] = buf[buf.length - 2];
		    this.lastChar[1] = buf[buf.length - 1];
		  }
		  return buf.toString('base64', i, buf.length - n);
		}

		function base64End(buf) {
		  var r = buf && buf.length ? this.write(buf) : '';
		  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
		  return r;
		}

		// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
		function simpleWrite(buf) {
		  return buf.toString(this.encoding);
		}

		function simpleEnd(buf) {
		  return buf && buf.length ? this.write(buf) : '';
		}
		return string_decoder;
	}

	var ERR_STREAM_PREMATURE_CLOSE = errorsBrowser.codes.ERR_STREAM_PREMATURE_CLOSE;

	function once$1(callback) {
	  var called = false;
	  return function () {
	    if (called) return;
	    called = true;

	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    callback.apply(this, args);
	  };
	}

	function noop$4() {}

	function isRequest$1(stream) {
	  return stream.setHeader && typeof stream.abort === 'function';
	}

	function eos$1(stream, opts, callback) {
	  if (typeof opts === 'function') return eos$1(stream, null, opts);
	  if (!opts) opts = {};
	  callback = once$1(callback || noop$4);
	  var readable = opts.readable || opts.readable !== false && stream.readable;
	  var writable = opts.writable || opts.writable !== false && stream.writable;

	  var onlegacyfinish = function onlegacyfinish() {
	    if (!stream.writable) onfinish();
	  };

	  var writableEnded = stream._writableState && stream._writableState.finished;

	  var onfinish = function onfinish() {
	    writable = false;
	    writableEnded = true;
	    if (!readable) callback.call(stream);
	  };

	  var readableEnded = stream._readableState && stream._readableState.endEmitted;

	  var onend = function onend() {
	    readable = false;
	    readableEnded = true;
	    if (!writable) callback.call(stream);
	  };

	  var onerror = function onerror(err) {
	    callback.call(stream, err);
	  };

	  var onclose = function onclose() {
	    var err;

	    if (readable && !readableEnded) {
	      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
	      return callback.call(stream, err);
	    }

	    if (writable && !writableEnded) {
	      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
	      return callback.call(stream, err);
	    }
	  };

	  var onrequest = function onrequest() {
	    stream.req.on('finish', onfinish);
	  };

	  if (isRequest$1(stream)) {
	    stream.on('complete', onfinish);
	    stream.on('abort', onclose);
	    if (stream.req) onrequest();else stream.on('request', onrequest);
	  } else if (writable && !stream._writableState) {
	    // legacy streams
	    stream.on('end', onlegacyfinish);
	    stream.on('close', onlegacyfinish);
	  }

	  stream.on('end', onend);
	  stream.on('finish', onfinish);
	  if (opts.error !== false) stream.on('error', onerror);
	  stream.on('close', onclose);
	  return function () {
	    stream.removeListener('complete', onfinish);
	    stream.removeListener('abort', onclose);
	    stream.removeListener('request', onrequest);
	    if (stream.req) stream.req.removeListener('finish', onfinish);
	    stream.removeListener('end', onlegacyfinish);
	    stream.removeListener('close', onlegacyfinish);
	    stream.removeListener('finish', onfinish);
	    stream.removeListener('end', onend);
	    stream.removeListener('error', onerror);
	    stream.removeListener('close', onclose);
	  };
	}

	var endOfStream = eos$1;

	var async_iterator;
	var hasRequiredAsync_iterator;

	function requireAsync_iterator () {
		if (hasRequiredAsync_iterator) return async_iterator;
		hasRequiredAsync_iterator = 1;

		var _Object$setPrototypeO;

		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

		var finished = endOfStream;

		var kLastResolve = Symbol('lastResolve');
		var kLastReject = Symbol('lastReject');
		var kError = Symbol('error');
		var kEnded = Symbol('ended');
		var kLastPromise = Symbol('lastPromise');
		var kHandlePromise = Symbol('handlePromise');
		var kStream = Symbol('stream');

		function createIterResult(value, done) {
		  return {
		    value: value,
		    done: done
		  };
		}

		function readAndResolve(iter) {
		  var resolve = iter[kLastResolve];

		  if (resolve !== null) {
		    var data = iter[kStream].read(); // we defer if data is null
		    // we can be expecting either 'end' or
		    // 'error'

		    if (data !== null) {
		      iter[kLastPromise] = null;
		      iter[kLastResolve] = null;
		      iter[kLastReject] = null;
		      resolve(createIterResult(data, false));
		    }
		  }
		}

		function onReadable(iter) {
		  // we wait for the next tick, because it might
		  // emit an error with process.nextTick
		  process.nextTick(readAndResolve, iter);
		}

		function wrapForNext(lastPromise, iter) {
		  return function (resolve, reject) {
		    lastPromise.then(function () {
		      if (iter[kEnded]) {
		        resolve(createIterResult(undefined, true));
		        return;
		      }

		      iter[kHandlePromise](resolve, reject);
		    }, reject);
		  };
		}

		var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
		var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
		  get stream() {
		    return this[kStream];
		  },

		  next: function next() {
		    var _this = this;

		    // if we have detected an error in the meanwhile
		    // reject straight away
		    var error = this[kError];

		    if (error !== null) {
		      return Promise.reject(error);
		    }

		    if (this[kEnded]) {
		      return Promise.resolve(createIterResult(undefined, true));
		    }

		    if (this[kStream].destroyed) {
		      // We need to defer via nextTick because if .destroy(err) is
		      // called, the error will be emitted via nextTick, and
		      // we cannot guarantee that there is no error lingering around
		      // waiting to be emitted.
		      return new Promise(function (resolve, reject) {
		        process.nextTick(function () {
		          if (_this[kError]) {
		            reject(_this[kError]);
		          } else {
		            resolve(createIterResult(undefined, true));
		          }
		        });
		      });
		    } // if we have multiple next() calls
		    // we will wait for the previous Promise to finish
		    // this logic is optimized to support for await loops,
		    // where next() is only called once at a time


		    var lastPromise = this[kLastPromise];
		    var promise;

		    if (lastPromise) {
		      promise = new Promise(wrapForNext(lastPromise, this));
		    } else {
		      // fast path needed to support multiple this.push()
		      // without triggering the next() queue
		      var data = this[kStream].read();

		      if (data !== null) {
		        return Promise.resolve(createIterResult(data, false));
		      }

		      promise = new Promise(this[kHandlePromise]);
		    }

		    this[kLastPromise] = promise;
		    return promise;
		  }
		}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
		  return this;
		}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
		  var _this2 = this;

		  // destroy(err, cb) is a private API
		  // we can guarantee we have that here, because we control the
		  // Readable class this is attached to
		  return new Promise(function (resolve, reject) {
		    _this2[kStream].destroy(null, function (err) {
		      if (err) {
		        reject(err);
		        return;
		      }

		      resolve(createIterResult(undefined, true));
		    });
		  });
		}), _Object$setPrototypeO), AsyncIteratorPrototype);

		var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
		  var _Object$create;

		  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
		    value: stream,
		    writable: true
		  }), _defineProperty(_Object$create, kLastResolve, {
		    value: null,
		    writable: true
		  }), _defineProperty(_Object$create, kLastReject, {
		    value: null,
		    writable: true
		  }), _defineProperty(_Object$create, kError, {
		    value: null,
		    writable: true
		  }), _defineProperty(_Object$create, kEnded, {
		    value: stream._readableState.endEmitted,
		    writable: true
		  }), _defineProperty(_Object$create, kHandlePromise, {
		    value: function value(resolve, reject) {
		      var data = iterator[kStream].read();

		      if (data) {
		        iterator[kLastPromise] = null;
		        iterator[kLastResolve] = null;
		        iterator[kLastReject] = null;
		        resolve(createIterResult(data, false));
		      } else {
		        iterator[kLastResolve] = resolve;
		        iterator[kLastReject] = reject;
		      }
		    },
		    writable: true
		  }), _Object$create));
		  iterator[kLastPromise] = null;
		  finished(stream, function (err) {
		    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
		      var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
		      // returned by next() and store the error

		      if (reject !== null) {
		        iterator[kLastPromise] = null;
		        iterator[kLastResolve] = null;
		        iterator[kLastReject] = null;
		        reject(err);
		      }

		      iterator[kError] = err;
		      return;
		    }

		    var resolve = iterator[kLastResolve];

		    if (resolve !== null) {
		      iterator[kLastPromise] = null;
		      iterator[kLastResolve] = null;
		      iterator[kLastReject] = null;
		      resolve(createIterResult(undefined, true));
		    }

		    iterator[kEnded] = true;
		  });
		  stream.on('readable', onReadable.bind(null, iterator));
		  return iterator;
		};

		async_iterator = createReadableStreamAsyncIterator;
		return async_iterator;
	}

	var fromBrowser;
	var hasRequiredFromBrowser;

	function requireFromBrowser () {
		if (hasRequiredFromBrowser) return fromBrowser;
		hasRequiredFromBrowser = 1;
		fromBrowser = function () {
		  throw new Error('Readable.from is not available in the browser')
		};
		return fromBrowser;
	}

	var _stream_readable;
	var hasRequired_stream_readable;

	function require_stream_readable () {
		if (hasRequired_stream_readable) return _stream_readable;
		hasRequired_stream_readable = 1;

		_stream_readable = Readable;
		/*<replacement>*/

		var Duplex;
		/*</replacement>*/

		Readable.ReadableState = ReadableState;
		/*<replacement>*/

		eventsExports.EventEmitter;

		var EElistenerCount = function EElistenerCount(emitter, type) {
		  return emitter.listeners(type).length;
		};
		/*</replacement>*/

		/*<replacement>*/


		var Stream = streamBrowser;
		/*</replacement>*/


		var Buffer = buffer$2.Buffer;

		var OurUint8Array = commonjsGlobal.Uint8Array || function () {};

		function _uint8ArrayToBuffer(chunk) {
		  return Buffer.from(chunk);
		}

		function _isUint8Array(obj) {
		  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
		}
		/*<replacement>*/


		var debugUtil = require$$3;

		var debug;

		if (debugUtil && debugUtil.debuglog) {
		  debug = debugUtil.debuglog('stream');
		} else {
		  debug = function debug() {};
		}
		/*</replacement>*/


		var BufferList = requireBuffer_list();

		var destroyImpl = destroy_1;

		var _require = state,
		    getHighWaterMark = _require.getHighWaterMark;

		var _require$codes = errorsBrowser.codes,
		    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
		    ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
		    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
		    ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.


		var StringDecoder;
		var createReadableStreamAsyncIterator;
		var from;

		inherits_browserExports(Readable, Stream);

		var errorOrDestroy = destroyImpl.errorOrDestroy;
		var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

		function prependListener(emitter, event, fn) {
		  // Sadly this is not cacheable as some libraries bundle their own
		  // event emitter implementation with them.
		  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
		  // userland ones.  NEVER DO THIS. This is here only because this code needs
		  // to continue to work with older versions of Node.js that do not include
		  // the prependListener() method. The goal is to eventually remove this hack.

		  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
		}

		function ReadableState(options, stream, isDuplex) {
		  Duplex = Duplex || require_stream_duplex();
		  options = options || {}; // Duplex streams are both readable and writable, but share
		  // the same options object.
		  // However, some cases require setting options to different
		  // values for the readable and the writable sides of the duplex stream.
		  // These options can be provided separately as readableXXX and writableXXX.

		  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag. Used to make read(n) ignore n and to
		  // make all the buffer merging and length checks go away

		  this.objectMode = !!options.objectMode;
		  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
		  // Note: 0 is a valid value, means "don't call _read preemptively ever"

		  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex); // A linked list is used to store data chunks instead of an array because the
		  // linked list can remove elements from the beginning faster than
		  // array.shift()

		  this.buffer = new BufferList();
		  this.length = 0;
		  this.pipes = null;
		  this.pipesCount = 0;
		  this.flowing = null;
		  this.ended = false;
		  this.endEmitted = false;
		  this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
		  // immediately, or on a later tick.  We set this to true at first, because
		  // any actions that shouldn't happen until "later" should generally also
		  // not happen before the first read call.

		  this.sync = true; // whenever we return null, then we set a flag to say
		  // that we're awaiting a 'readable' event emission.

		  this.needReadable = false;
		  this.emittedReadable = false;
		  this.readableListening = false;
		  this.resumeScheduled = false;
		  this.paused = true; // Should close be emitted on destroy. Defaults to true.

		  this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')

		  this.autoDestroy = !!options.autoDestroy; // has it been destroyed

		  this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
		  // encoding is 'binary' so we have to make this configurable.
		  // Everything else in the universe uses 'utf8', though.

		  this.defaultEncoding = options.defaultEncoding || 'utf8'; // the number of writers that are awaiting a drain event in .pipe()s

		  this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled

		  this.readingMore = false;
		  this.decoder = null;
		  this.encoding = null;

		  if (options.encoding) {
		    if (!StringDecoder) StringDecoder = requireString_decoder().StringDecoder;
		    this.decoder = new StringDecoder(options.encoding);
		    this.encoding = options.encoding;
		  }
		}

		function Readable(options) {
		  Duplex = Duplex || require_stream_duplex();
		  if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
		  // the ReadableState constructor, at least with V8 6.5

		  var isDuplex = this instanceof Duplex;
		  this._readableState = new ReadableState(options, this, isDuplex); // legacy

		  this.readable = true;

		  if (options) {
		    if (typeof options.read === 'function') this._read = options.read;
		    if (typeof options.destroy === 'function') this._destroy = options.destroy;
		  }

		  Stream.call(this);
		}

		Object.defineProperty(Readable.prototype, 'destroyed', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function get() {
		    if (this._readableState === undefined) {
		      return false;
		    }

		    return this._readableState.destroyed;
		  },
		  set: function set(value) {
		    // we ignore the value if the stream
		    // has not been initialized yet
		    if (!this._readableState) {
		      return;
		    } // backward compatibility, the user is explicitly
		    // managing destroyed


		    this._readableState.destroyed = value;
		  }
		});
		Readable.prototype.destroy = destroyImpl.destroy;
		Readable.prototype._undestroy = destroyImpl.undestroy;

		Readable.prototype._destroy = function (err, cb) {
		  cb(err);
		}; // Manually shove something into the read() buffer.
		// This returns true if the highWaterMark has not been hit yet,
		// similar to how Writable.write() returns true if you should
		// write() some more.


		Readable.prototype.push = function (chunk, encoding) {
		  var state = this._readableState;
		  var skipChunkCheck;

		  if (!state.objectMode) {
		    if (typeof chunk === 'string') {
		      encoding = encoding || state.defaultEncoding;

		      if (encoding !== state.encoding) {
		        chunk = Buffer.from(chunk, encoding);
		        encoding = '';
		      }

		      skipChunkCheck = true;
		    }
		  } else {
		    skipChunkCheck = true;
		  }

		  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
		}; // Unshift should *always* be something directly out of read()


		Readable.prototype.unshift = function (chunk) {
		  return readableAddChunk(this, chunk, null, true, false);
		};

		function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
		  debug('readableAddChunk', chunk);
		  var state = stream._readableState;

		  if (chunk === null) {
		    state.reading = false;
		    onEofChunk(stream, state);
		  } else {
		    var er;
		    if (!skipChunkCheck) er = chunkInvalid(state, chunk);

		    if (er) {
		      errorOrDestroy(stream, er);
		    } else if (state.objectMode || chunk && chunk.length > 0) {
		      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
		        chunk = _uint8ArrayToBuffer(chunk);
		      }

		      if (addToFront) {
		        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
		      } else if (state.ended) {
		        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
		      } else if (state.destroyed) {
		        return false;
		      } else {
		        state.reading = false;

		        if (state.decoder && !encoding) {
		          chunk = state.decoder.write(chunk);
		          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
		        } else {
		          addChunk(stream, state, chunk, false);
		        }
		      }
		    } else if (!addToFront) {
		      state.reading = false;
		      maybeReadMore(stream, state);
		    }
		  } // We can push more data if we are below the highWaterMark.
		  // Also, if we have no data yet, we can stand some more bytes.
		  // This is to work around cases where hwm=0, such as the repl.


		  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
		}

		function addChunk(stream, state, chunk, addToFront) {
		  if (state.flowing && state.length === 0 && !state.sync) {
		    state.awaitDrain = 0;
		    stream.emit('data', chunk);
		  } else {
		    // update the buffer info.
		    state.length += state.objectMode ? 1 : chunk.length;
		    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
		    if (state.needReadable) emitReadable(stream);
		  }

		  maybeReadMore(stream, state);
		}

		function chunkInvalid(state, chunk) {
		  var er;

		  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
		    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
		  }

		  return er;
		}

		Readable.prototype.isPaused = function () {
		  return this._readableState.flowing === false;
		}; // backwards compatibility.


		Readable.prototype.setEncoding = function (enc) {
		  if (!StringDecoder) StringDecoder = requireString_decoder().StringDecoder;
		  var decoder = new StringDecoder(enc);
		  this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8

		  this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:

		  var p = this._readableState.buffer.head;
		  var content = '';

		  while (p !== null) {
		    content += decoder.write(p.data);
		    p = p.next;
		  }

		  this._readableState.buffer.clear();

		  if (content !== '') this._readableState.buffer.push(content);
		  this._readableState.length = content.length;
		  return this;
		}; // Don't raise the hwm > 1GB


		var MAX_HWM = 0x40000000;

		function computeNewHighWaterMark(n) {
		  if (n >= MAX_HWM) {
		    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
		    n = MAX_HWM;
		  } else {
		    // Get the next highest power of 2 to prevent increasing hwm excessively in
		    // tiny amounts
		    n--;
		    n |= n >>> 1;
		    n |= n >>> 2;
		    n |= n >>> 4;
		    n |= n >>> 8;
		    n |= n >>> 16;
		    n++;
		  }

		  return n;
		} // This function is designed to be inlinable, so please take care when making
		// changes to the function body.


		function howMuchToRead(n, state) {
		  if (n <= 0 || state.length === 0 && state.ended) return 0;
		  if (state.objectMode) return 1;

		  if (n !== n) {
		    // Only flow one buffer at a time
		    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
		  } // If we're asking for more than the current hwm, then raise the hwm.


		  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
		  if (n <= state.length) return n; // Don't have enough

		  if (!state.ended) {
		    state.needReadable = true;
		    return 0;
		  }

		  return state.length;
		} // you can override either this method, or the async _read(n) below.


		Readable.prototype.read = function (n) {
		  debug('read', n);
		  n = parseInt(n, 10);
		  var state = this._readableState;
		  var nOrig = n;
		  if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
		  // already have a bunch of data in the buffer, then just trigger
		  // the 'readable' event and move on.

		  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
		    debug('read: emitReadable', state.length, state.ended);
		    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
		    return null;
		  }

		  n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.

		  if (n === 0 && state.ended) {
		    if (state.length === 0) endReadable(this);
		    return null;
		  } // All the actual chunk generation logic needs to be
		  // *below* the call to _read.  The reason is that in certain
		  // synthetic stream cases, such as passthrough streams, _read
		  // may be a completely synchronous operation which may change
		  // the state of the read buffer, providing enough data when
		  // before there was *not* enough.
		  //
		  // So, the steps are:
		  // 1. Figure out what the state of things will be after we do
		  // a read from the buffer.
		  //
		  // 2. If that resulting state will trigger a _read, then call _read.
		  // Note that this may be asynchronous, or synchronous.  Yes, it is
		  // deeply ugly to write APIs this way, but that still doesn't mean
		  // that the Readable class should behave improperly, as streams are
		  // designed to be sync/async agnostic.
		  // Take note if the _read call is sync or async (ie, if the read call
		  // has returned yet), so that we know whether or not it's safe to emit
		  // 'readable' etc.
		  //
		  // 3. Actually pull the requested chunks out of the buffer and return.
		  // if we need a readable event, then we need to do some reading.


		  var doRead = state.needReadable;
		  debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some

		  if (state.length === 0 || state.length - n < state.highWaterMark) {
		    doRead = true;
		    debug('length less than watermark', doRead);
		  } // however, if we've ended, then there's no point, and if we're already
		  // reading, then it's unnecessary.


		  if (state.ended || state.reading) {
		    doRead = false;
		    debug('reading or ended', doRead);
		  } else if (doRead) {
		    debug('do read');
		    state.reading = true;
		    state.sync = true; // if the length is currently zero, then we *need* a readable event.

		    if (state.length === 0) state.needReadable = true; // call internal read method

		    this._read(state.highWaterMark);

		    state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
		    // and we need to re-evaluate how much data we can return to the user.

		    if (!state.reading) n = howMuchToRead(nOrig, state);
		  }

		  var ret;
		  if (n > 0) ret = fromList(n, state);else ret = null;

		  if (ret === null) {
		    state.needReadable = state.length <= state.highWaterMark;
		    n = 0;
		  } else {
		    state.length -= n;
		    state.awaitDrain = 0;
		  }

		  if (state.length === 0) {
		    // If we have nothing in the buffer, then we want to know
		    // as soon as we *do* get something into the buffer.
		    if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.

		    if (nOrig !== n && state.ended) endReadable(this);
		  }

		  if (ret !== null) this.emit('data', ret);
		  return ret;
		};

		function onEofChunk(stream, state) {
		  debug('onEofChunk');
		  if (state.ended) return;

		  if (state.decoder) {
		    var chunk = state.decoder.end();

		    if (chunk && chunk.length) {
		      state.buffer.push(chunk);
		      state.length += state.objectMode ? 1 : chunk.length;
		    }
		  }

		  state.ended = true;

		  if (state.sync) {
		    // if we are sync, wait until next tick to emit the data.
		    // Otherwise we risk emitting data in the flow()
		    // the readable code triggers during a read() call
		    emitReadable(stream);
		  } else {
		    // emit 'readable' now to make sure it gets picked up.
		    state.needReadable = false;

		    if (!state.emittedReadable) {
		      state.emittedReadable = true;
		      emitReadable_(stream);
		    }
		  }
		} // Don't emit readable right away in sync mode, because this can trigger
		// another read() call => stack overflow.  This way, it might trigger
		// a nextTick recursion warning, but that's not so bad.


		function emitReadable(stream) {
		  var state = stream._readableState;
		  debug('emitReadable', state.needReadable, state.emittedReadable);
		  state.needReadable = false;

		  if (!state.emittedReadable) {
		    debug('emitReadable', state.flowing);
		    state.emittedReadable = true;
		    process.nextTick(emitReadable_, stream);
		  }
		}

		function emitReadable_(stream) {
		  var state = stream._readableState;
		  debug('emitReadable_', state.destroyed, state.length, state.ended);

		  if (!state.destroyed && (state.length || state.ended)) {
		    stream.emit('readable');
		    state.emittedReadable = false;
		  } // The stream needs another readable event if
		  // 1. It is not flowing, as the flow mechanism will take
		  //    care of it.
		  // 2. It is not ended.
		  // 3. It is below the highWaterMark, so we can schedule
		  //    another readable later.


		  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
		  flow(stream);
		} // at this point, the user has presumably seen the 'readable' event,
		// and called read() to consume some data.  that may have triggered
		// in turn another _read(n) call, in which case reading = true if
		// it's in progress.
		// However, if we're not ended, or reading, and the length < hwm,
		// then go ahead and try to read some more preemptively.


		function maybeReadMore(stream, state) {
		  if (!state.readingMore) {
		    state.readingMore = true;
		    process.nextTick(maybeReadMore_, stream, state);
		  }
		}

		function maybeReadMore_(stream, state) {
		  // Attempt to read more data if we should.
		  //
		  // The conditions for reading more data are (one of):
		  // - Not enough data buffered (state.length < state.highWaterMark). The loop
		  //   is responsible for filling the buffer with enough data if such data
		  //   is available. If highWaterMark is 0 and we are not in the flowing mode
		  //   we should _not_ attempt to buffer any extra data. We'll get more data
		  //   when the stream consumer calls read() instead.
		  // - No data in the buffer, and the stream is in flowing mode. In this mode
		  //   the loop below is responsible for ensuring read() is called. Failing to
		  //   call read here would abort the flow and there's no other mechanism for
		  //   continuing the flow if the stream consumer has just subscribed to the
		  //   'data' event.
		  //
		  // In addition to the above conditions to keep reading data, the following
		  // conditions prevent the data from being read:
		  // - The stream has ended (state.ended).
		  // - There is already a pending 'read' operation (state.reading). This is a
		  //   case where the the stream has called the implementation defined _read()
		  //   method, but they are processing the call asynchronously and have _not_
		  //   called push() with new data. In this case we skip performing more
		  //   read()s. The execution ends in this method again after the _read() ends
		  //   up calling push() with more data.
		  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
		    var len = state.length;
		    debug('maybeReadMore read 0');
		    stream.read(0);
		    if (len === state.length) // didn't get any data, stop spinning.
		      break;
		  }

		  state.readingMore = false;
		} // abstract method.  to be overridden in specific implementation classes.
		// call cb(er, data) where data is <= n in length.
		// for virtual (non-string, non-buffer) streams, "length" is somewhat
		// arbitrary, and perhaps not very meaningful.


		Readable.prototype._read = function (n) {
		  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
		};

		Readable.prototype.pipe = function (dest, pipeOpts) {
		  var src = this;
		  var state = this._readableState;

		  switch (state.pipesCount) {
		    case 0:
		      state.pipes = dest;
		      break;

		    case 1:
		      state.pipes = [state.pipes, dest];
		      break;

		    default:
		      state.pipes.push(dest);
		      break;
		  }

		  state.pipesCount += 1;
		  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
		  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
		  var endFn = doEnd ? onend : unpipe;
		  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
		  dest.on('unpipe', onunpipe);

		  function onunpipe(readable, unpipeInfo) {
		    debug('onunpipe');

		    if (readable === src) {
		      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
		        unpipeInfo.hasUnpiped = true;
		        cleanup();
		      }
		    }
		  }

		  function onend() {
		    debug('onend');
		    dest.end();
		  } // when the dest drains, it reduces the awaitDrain counter
		  // on the source.  This would be more elegant with a .once()
		  // handler in flow(), but adding and removing repeatedly is
		  // too slow.


		  var ondrain = pipeOnDrain(src);
		  dest.on('drain', ondrain);
		  var cleanedUp = false;

		  function cleanup() {
		    debug('cleanup'); // cleanup event handlers once the pipe is broken

		    dest.removeListener('close', onclose);
		    dest.removeListener('finish', onfinish);
		    dest.removeListener('drain', ondrain);
		    dest.removeListener('error', onerror);
		    dest.removeListener('unpipe', onunpipe);
		    src.removeListener('end', onend);
		    src.removeListener('end', unpipe);
		    src.removeListener('data', ondata);
		    cleanedUp = true; // if the reader is waiting for a drain event from this
		    // specific writer, then it would cause it to never start
		    // flowing again.
		    // So, if this is awaiting a drain, then we just call it now.
		    // If we don't know, then assume that we are waiting for one.

		    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
		  }

		  src.on('data', ondata);

		  function ondata(chunk) {
		    debug('ondata');
		    var ret = dest.write(chunk);
		    debug('dest.write', ret);

		    if (ret === false) {
		      // If the user unpiped during `dest.write()`, it is possible
		      // to get stuck in a permanently paused state if that write
		      // also returned false.
		      // => Check whether `dest` is still a piping destination.
		      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
		        debug('false write response, pause', state.awaitDrain);
		        state.awaitDrain++;
		      }

		      src.pause();
		    }
		  } // if the dest has an error, then stop piping into it.
		  // however, don't suppress the throwing behavior for this.


		  function onerror(er) {
		    debug('onerror', er);
		    unpipe();
		    dest.removeListener('error', onerror);
		    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
		  } // Make sure our error handler is attached before userland ones.


		  prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.

		  function onclose() {
		    dest.removeListener('finish', onfinish);
		    unpipe();
		  }

		  dest.once('close', onclose);

		  function onfinish() {
		    debug('onfinish');
		    dest.removeListener('close', onclose);
		    unpipe();
		  }

		  dest.once('finish', onfinish);

		  function unpipe() {
		    debug('unpipe');
		    src.unpipe(dest);
		  } // tell the dest that it's being piped to


		  dest.emit('pipe', src); // start the flow if it hasn't been started already.

		  if (!state.flowing) {
		    debug('pipe resume');
		    src.resume();
		  }

		  return dest;
		};

		function pipeOnDrain(src) {
		  return function pipeOnDrainFunctionResult() {
		    var state = src._readableState;
		    debug('pipeOnDrain', state.awaitDrain);
		    if (state.awaitDrain) state.awaitDrain--;

		    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
		      state.flowing = true;
		      flow(src);
		    }
		  };
		}

		Readable.prototype.unpipe = function (dest) {
		  var state = this._readableState;
		  var unpipeInfo = {
		    hasUnpiped: false
		  }; // if we're not piping anywhere, then do nothing.

		  if (state.pipesCount === 0) return this; // just one destination.  most common case.

		  if (state.pipesCount === 1) {
		    // passed in one, but it's not the right one.
		    if (dest && dest !== state.pipes) return this;
		    if (!dest) dest = state.pipes; // got a match.

		    state.pipes = null;
		    state.pipesCount = 0;
		    state.flowing = false;
		    if (dest) dest.emit('unpipe', this, unpipeInfo);
		    return this;
		  } // slow case. multiple pipe destinations.


		  if (!dest) {
		    // remove all.
		    var dests = state.pipes;
		    var len = state.pipesCount;
		    state.pipes = null;
		    state.pipesCount = 0;
		    state.flowing = false;

		    for (var i = 0; i < len; i++) {
		      dests[i].emit('unpipe', this, {
		        hasUnpiped: false
		      });
		    }

		    return this;
		  } // try to find the right one.


		  var index = indexOf(state.pipes, dest);
		  if (index === -1) return this;
		  state.pipes.splice(index, 1);
		  state.pipesCount -= 1;
		  if (state.pipesCount === 1) state.pipes = state.pipes[0];
		  dest.emit('unpipe', this, unpipeInfo);
		  return this;
		}; // set up data events if they are asked for
		// Ensure readable listeners eventually get something


		Readable.prototype.on = function (ev, fn) {
		  var res = Stream.prototype.on.call(this, ev, fn);
		  var state = this._readableState;

		  if (ev === 'data') {
		    // update readableListening so that resume() may be a no-op
		    // a few lines down. This is needed to support once('readable').
		    state.readableListening = this.listenerCount('readable') > 0; // Try start flowing on next tick if stream isn't explicitly paused

		    if (state.flowing !== false) this.resume();
		  } else if (ev === 'readable') {
		    if (!state.endEmitted && !state.readableListening) {
		      state.readableListening = state.needReadable = true;
		      state.flowing = false;
		      state.emittedReadable = false;
		      debug('on readable', state.length, state.reading);

		      if (state.length) {
		        emitReadable(this);
		      } else if (!state.reading) {
		        process.nextTick(nReadingNextTick, this);
		      }
		    }
		  }

		  return res;
		};

		Readable.prototype.addListener = Readable.prototype.on;

		Readable.prototype.removeListener = function (ev, fn) {
		  var res = Stream.prototype.removeListener.call(this, ev, fn);

		  if (ev === 'readable') {
		    // We need to check if there is someone still listening to
		    // readable and reset the state. However this needs to happen
		    // after readable has been emitted but before I/O (nextTick) to
		    // support once('readable', fn) cycles. This means that calling
		    // resume within the same tick will have no
		    // effect.
		    process.nextTick(updateReadableListening, this);
		  }

		  return res;
		};

		Readable.prototype.removeAllListeners = function (ev) {
		  var res = Stream.prototype.removeAllListeners.apply(this, arguments);

		  if (ev === 'readable' || ev === undefined) {
		    // We need to check if there is someone still listening to
		    // readable and reset the state. However this needs to happen
		    // after readable has been emitted but before I/O (nextTick) to
		    // support once('readable', fn) cycles. This means that calling
		    // resume within the same tick will have no
		    // effect.
		    process.nextTick(updateReadableListening, this);
		  }

		  return res;
		};

		function updateReadableListening(self) {
		  var state = self._readableState;
		  state.readableListening = self.listenerCount('readable') > 0;

		  if (state.resumeScheduled && !state.paused) {
		    // flowing needs to be set to true now, otherwise
		    // the upcoming resume will not flow.
		    state.flowing = true; // crude way to check if we should resume
		  } else if (self.listenerCount('data') > 0) {
		    self.resume();
		  }
		}

		function nReadingNextTick(self) {
		  debug('readable nexttick read 0');
		  self.read(0);
		} // pause() and resume() are remnants of the legacy readable stream API
		// If the user uses them, then switch into old mode.


		Readable.prototype.resume = function () {
		  var state = this._readableState;

		  if (!state.flowing) {
		    debug('resume'); // we flow only if there is no one listening
		    // for readable, but we still have to call
		    // resume()

		    state.flowing = !state.readableListening;
		    resume(this, state);
		  }

		  state.paused = false;
		  return this;
		};

		function resume(stream, state) {
		  if (!state.resumeScheduled) {
		    state.resumeScheduled = true;
		    process.nextTick(resume_, stream, state);
		  }
		}

		function resume_(stream, state) {
		  debug('resume', state.reading);

		  if (!state.reading) {
		    stream.read(0);
		  }

		  state.resumeScheduled = false;
		  stream.emit('resume');
		  flow(stream);
		  if (state.flowing && !state.reading) stream.read(0);
		}

		Readable.prototype.pause = function () {
		  debug('call pause flowing=%j', this._readableState.flowing);

		  if (this._readableState.flowing !== false) {
		    debug('pause');
		    this._readableState.flowing = false;
		    this.emit('pause');
		  }

		  this._readableState.paused = true;
		  return this;
		};

		function flow(stream) {
		  var state = stream._readableState;
		  debug('flow', state.flowing);

		  while (state.flowing && stream.read() !== null) {
		  }
		} // wrap an old-style stream as the async data source.
		// This is *not* part of the readable stream interface.
		// It is an ugly unfortunate mess of history.


		Readable.prototype.wrap = function (stream) {
		  var _this = this;

		  var state = this._readableState;
		  var paused = false;
		  stream.on('end', function () {
		    debug('wrapped end');

		    if (state.decoder && !state.ended) {
		      var chunk = state.decoder.end();
		      if (chunk && chunk.length) _this.push(chunk);
		    }

		    _this.push(null);
		  });
		  stream.on('data', function (chunk) {
		    debug('wrapped data');
		    if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode

		    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

		    var ret = _this.push(chunk);

		    if (!ret) {
		      paused = true;
		      stream.pause();
		    }
		  }); // proxy all the other methods.
		  // important when wrapping filters and duplexes.

		  for (var i in stream) {
		    if (this[i] === undefined && typeof stream[i] === 'function') {
		      this[i] = function methodWrap(method) {
		        return function methodWrapReturnFunction() {
		          return stream[method].apply(stream, arguments);
		        };
		      }(i);
		    }
		  } // proxy certain important events.


		  for (var n = 0; n < kProxyEvents.length; n++) {
		    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
		  } // when we try to consume some more bytes, simply unpause the
		  // underlying stream.


		  this._read = function (n) {
		    debug('wrapped _read', n);

		    if (paused) {
		      paused = false;
		      stream.resume();
		    }
		  };

		  return this;
		};

		if (typeof Symbol === 'function') {
		  Readable.prototype[Symbol.asyncIterator] = function () {
		    if (createReadableStreamAsyncIterator === undefined) {
		      createReadableStreamAsyncIterator = requireAsync_iterator();
		    }

		    return createReadableStreamAsyncIterator(this);
		  };
		}

		Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function get() {
		    return this._readableState.highWaterMark;
		  }
		});
		Object.defineProperty(Readable.prototype, 'readableBuffer', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function get() {
		    return this._readableState && this._readableState.buffer;
		  }
		});
		Object.defineProperty(Readable.prototype, 'readableFlowing', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function get() {
		    return this._readableState.flowing;
		  },
		  set: function set(state) {
		    if (this._readableState) {
		      this._readableState.flowing = state;
		    }
		  }
		}); // exposed for testing purposes only.

		Readable._fromList = fromList;
		Object.defineProperty(Readable.prototype, 'readableLength', {
		  // making it explicit this property is not enumerable
		  // because otherwise some prototype manipulation in
		  // userland will fail
		  enumerable: false,
		  get: function get() {
		    return this._readableState.length;
		  }
		}); // Pluck off n bytes from an array of buffers.
		// Length is the combined lengths of all the buffers in the list.
		// This function is designed to be inlinable, so please take care when making
		// changes to the function body.

		function fromList(n, state) {
		  // nothing buffered
		  if (state.length === 0) return null;
		  var ret;
		  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
		    // read it all, truncate the list
		    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
		    state.buffer.clear();
		  } else {
		    // read part of list
		    ret = state.buffer.consume(n, state.decoder);
		  }
		  return ret;
		}

		function endReadable(stream) {
		  var state = stream._readableState;
		  debug('endReadable', state.endEmitted);

		  if (!state.endEmitted) {
		    state.ended = true;
		    process.nextTick(endReadableNT, state, stream);
		  }
		}

		function endReadableNT(state, stream) {
		  debug('endReadableNT', state.endEmitted, state.length); // Check that we didn't get one last unshift.

		  if (!state.endEmitted && state.length === 0) {
		    state.endEmitted = true;
		    stream.readable = false;
		    stream.emit('end');

		    if (state.autoDestroy) {
		      // In case of duplex streams we need a way to detect
		      // if the writable side is ready for autoDestroy as well
		      var wState = stream._writableState;

		      if (!wState || wState.autoDestroy && wState.finished) {
		        stream.destroy();
		      }
		    }
		  }
		}

		if (typeof Symbol === 'function') {
		  Readable.from = function (iterable, opts) {
		    if (from === undefined) {
		      from = requireFromBrowser();
		    }

		    return from(Readable, iterable, opts);
		  };
		}

		function indexOf(xs, x) {
		  for (var i = 0, l = xs.length; i < l; i++) {
		    if (xs[i] === x) return i;
		  }

		  return -1;
		}
		return _stream_readable;
	}

	var _stream_transform = Transform$3;

	var _require$codes$1 = errorsBrowser.codes,
	    ERR_METHOD_NOT_IMPLEMENTED = _require$codes$1.ERR_METHOD_NOT_IMPLEMENTED,
	    ERR_MULTIPLE_CALLBACK = _require$codes$1.ERR_MULTIPLE_CALLBACK,
	    ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes$1.ERR_TRANSFORM_ALREADY_TRANSFORMING,
	    ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes$1.ERR_TRANSFORM_WITH_LENGTH_0;

	var Duplex = require_stream_duplex();

	inherits_browserExports(Transform$3, Duplex);

	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	  var cb = ts.writecb;

	  if (cb === null) {
	    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
	  }

	  ts.writechunk = null;
	  ts.writecb = null;
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	  cb(er);
	  var rs = this._readableState;
	  rs.reading = false;

	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}

	function Transform$3(options) {
	  if (!(this instanceof Transform$3)) return new Transform$3(options);
	  Duplex.call(this, options);
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  }; // start out asking for a readable event once data is transformed.

	  this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.

	  this._readableState.sync = false;

	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  } // When the writable side finishes, then flush out anything remaining.


	  this.on('prefinish', prefinish);
	}

	function prefinish() {
	  var _this = this;

	  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}

	Transform$3.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	}; // This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.


	Transform$3.prototype._transform = function (chunk, encoding, cb) {
	  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
	};

	Transform$3.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;

	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	}; // Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.


	Transform$3.prototype._read = function (n) {
	  var ts = this._transformState;

	  if (ts.writechunk !== null && !ts.transforming) {
	    ts.transforming = true;

	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};

	Transform$3.prototype._destroy = function (err, cb) {
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	  });
	};

	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided

	  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
	  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
	  return stream.push(null);
	}

	var _stream_passthrough = PassThrough;

	var Transform$2 = _stream_transform;

	inherits_browserExports(PassThrough, Transform$2);

	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	  Transform$2.call(this, options);
	}

	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

	var eos;

	function once(callback) {
	  var called = false;
	  return function () {
	    if (called) return;
	    called = true;
	    callback.apply(void 0, arguments);
	  };
	}

	var _require$codes = errorsBrowser.codes,
	    ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
	    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;

	function noop$3(err) {
	  // Rethrow the error if it exists to avoid swallowing it
	  if (err) throw err;
	}

	function isRequest(stream) {
	  return stream.setHeader && typeof stream.abort === 'function';
	}

	function destroyer(stream, reading, writing, callback) {
	  callback = once(callback);
	  var closed = false;
	  stream.on('close', function () {
	    closed = true;
	  });
	  if (eos === undefined) eos = endOfStream;
	  eos(stream, {
	    readable: reading,
	    writable: writing
	  }, function (err) {
	    if (err) return callback(err);
	    closed = true;
	    callback();
	  });
	  var destroyed = false;
	  return function (err) {
	    if (closed) return;
	    if (destroyed) return;
	    destroyed = true; // request.destroy just do .end - .abort is what we want

	    if (isRequest(stream)) return stream.abort();
	    if (typeof stream.destroy === 'function') return stream.destroy();
	    callback(err || new ERR_STREAM_DESTROYED('pipe'));
	  };
	}

	function call(fn) {
	  fn();
	}

	function pipe$1(from, to) {
	  return from.pipe(to);
	}

	function popCallback(streams) {
	  if (!streams.length) return noop$3;
	  if (typeof streams[streams.length - 1] !== 'function') return noop$3;
	  return streams.pop();
	}

	function pipeline() {
	  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
	    streams[_key] = arguments[_key];
	  }

	  var callback = popCallback(streams);
	  if (Array.isArray(streams[0])) streams = streams[0];

	  if (streams.length < 2) {
	    throw new ERR_MISSING_ARGS('streams');
	  }

	  var error;
	  var destroys = streams.map(function (stream, i) {
	    var reading = i < streams.length - 1;
	    var writing = i > 0;
	    return destroyer(stream, reading, writing, function (err) {
	      if (!error) error = err;
	      if (err) destroys.forEach(call);
	      if (reading) return;
	      destroys.forEach(call);
	      callback(error);
	    });
	  });
	  return streams.reduce(pipe$1);
	}

	var pipeline_1 = pipeline;

	(function (module, exports) {
		exports = module.exports = require_stream_readable();
		exports.Stream = exports;
		exports.Readable = exports;
		exports.Writable = require_stream_writable();
		exports.Duplex = require_stream_duplex();
		exports.Transform = _stream_transform;
		exports.PassThrough = _stream_passthrough;
		exports.finished = endOfStream;
		exports.pipeline = pipeline_1; 
	} (readableBrowser, readableBrowser.exports));

	var readableBrowserExports = readableBrowser.exports;

	const { Transform: Transform$1 } = readableBrowserExports;

	var keccak$2 = (KeccakState) => class Keccak extends Transform$1 {
	  constructor (rate, capacity, delimitedSuffix, hashBitLength, options) {
	    super(options);

	    this._rate = rate;
	    this._capacity = capacity;
	    this._delimitedSuffix = delimitedSuffix;
	    this._hashBitLength = hashBitLength;
	    this._options = options;

	    this._state = new KeccakState();
	    this._state.initialize(rate, capacity);
	    this._finalized = false;
	  }

	  _transform (chunk, encoding, callback) {
	    let error = null;
	    try {
	      this.update(chunk, encoding);
	    } catch (err) {
	      error = err;
	    }

	    callback(error);
	  }

	  _flush (callback) {
	    let error = null;
	    try {
	      this.push(this.digest());
	    } catch (err) {
	      error = err;
	    }

	    callback(error);
	  }

	  update (data, encoding) {
	    if (!Buffer.isBuffer(data) && typeof data !== 'string') throw new TypeError('Data must be a string or a buffer')
	    if (this._finalized) throw new Error('Digest already called')
	    if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding);

	    this._state.absorb(data);

	    return this
	  }

	  digest (encoding) {
	    if (this._finalized) throw new Error('Digest already called')
	    this._finalized = true;

	    if (this._delimitedSuffix) this._state.absorbLastFewBits(this._delimitedSuffix);
	    let digest = this._state.squeeze(this._hashBitLength / 8);
	    if (encoding !== undefined) digest = digest.toString(encoding);

	    this._resetState();

	    return digest
	  }

	  // remove result from memory
	  _resetState () {
	    this._state.initialize(this._rate, this._capacity);
	    return this
	  }

	  // because sometimes we need hash right now and little later
	  _clone () {
	    const clone = new Keccak(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
	    this._state.copy(clone._state);
	    clone._finalized = this._finalized;

	    return clone
	  }
	};

	const { Transform } = readableBrowserExports;

	var shake = (KeccakState) => class Shake extends Transform {
	  constructor (rate, capacity, delimitedSuffix, options) {
	    super(options);

	    this._rate = rate;
	    this._capacity = capacity;
	    this._delimitedSuffix = delimitedSuffix;
	    this._options = options;

	    this._state = new KeccakState();
	    this._state.initialize(rate, capacity);
	    this._finalized = false;
	  }

	  _transform (chunk, encoding, callback) {
	    let error = null;
	    try {
	      this.update(chunk, encoding);
	    } catch (err) {
	      error = err;
	    }

	    callback(error);
	  }

	  _flush () {}

	  _read (size) {
	    this.push(this.squeeze(size));
	  }

	  update (data, encoding) {
	    if (!Buffer.isBuffer(data) && typeof data !== 'string') throw new TypeError('Data must be a string or a buffer')
	    if (this._finalized) throw new Error('Squeeze already called')
	    if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding);

	    this._state.absorb(data);

	    return this
	  }

	  squeeze (dataByteLength, encoding) {
	    if (!this._finalized) {
	      this._finalized = true;
	      this._state.absorbLastFewBits(this._delimitedSuffix);
	    }

	    let data = this._state.squeeze(dataByteLength);
	    if (encoding !== undefined) data = data.toString(encoding);

	    return data
	  }

	  _resetState () {
	    this._state.initialize(this._rate, this._capacity);
	    return this
	  }

	  _clone () {
	    const clone = new Shake(this._rate, this._capacity, this._delimitedSuffix, this._options);
	    this._state.copy(clone._state);
	    clone._finalized = this._finalized;

	    return clone
	  }
	};

	const createKeccak = keccak$2;
	const createShake = shake;

	var api = function (KeccakState) {
	  const Keccak = createKeccak(KeccakState);
	  const Shake = createShake(KeccakState);

	  return function (algorithm, options) {
	    const hash = typeof algorithm === 'string' ? algorithm.toLowerCase() : algorithm;
	    switch (hash) {
	      case 'keccak224': return new Keccak(1152, 448, null, 224, options)
	      case 'keccak256': return new Keccak(1088, 512, null, 256, options)
	      case 'keccak384': return new Keccak(832, 768, null, 384, options)
	      case 'keccak512': return new Keccak(576, 1024, null, 512, options)

	      case 'sha3-224': return new Keccak(1152, 448, 0x06, 224, options)
	      case 'sha3-256': return new Keccak(1088, 512, 0x06, 256, options)
	      case 'sha3-384': return new Keccak(832, 768, 0x06, 384, options)
	      case 'sha3-512': return new Keccak(576, 1024, 0x06, 512, options)

	      case 'shake128': return new Shake(1344, 256, 0x1f, options)
	      case 'shake256': return new Shake(1088, 512, 0x1f, options)

	      default: throw new Error('Invald algorithm: ' + algorithm)
	    }
	  }
	};

	var keccakStateUnroll = {};

	const P1600_ROUND_CONSTANTS = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];

	keccakStateUnroll.p1600 = function (s) {
	  for (let round = 0; round < 24; ++round) {
	    // theta
	    const lo0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
	    const hi0 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
	    const lo1 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
	    const hi1 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
	    const lo2 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
	    const hi2 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
	    const lo3 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
	    const hi3 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
	    const lo4 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
	    const hi4 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];

	    let lo = lo4 ^ (lo1 << 1 | hi1 >>> 31);
	    let hi = hi4 ^ (hi1 << 1 | lo1 >>> 31);
	    const t1slo0 = s[0] ^ lo;
	    const t1shi0 = s[1] ^ hi;
	    const t1slo5 = s[10] ^ lo;
	    const t1shi5 = s[11] ^ hi;
	    const t1slo10 = s[20] ^ lo;
	    const t1shi10 = s[21] ^ hi;
	    const t1slo15 = s[30] ^ lo;
	    const t1shi15 = s[31] ^ hi;
	    const t1slo20 = s[40] ^ lo;
	    const t1shi20 = s[41] ^ hi;
	    lo = lo0 ^ (lo2 << 1 | hi2 >>> 31);
	    hi = hi0 ^ (hi2 << 1 | lo2 >>> 31);
	    const t1slo1 = s[2] ^ lo;
	    const t1shi1 = s[3] ^ hi;
	    const t1slo6 = s[12] ^ lo;
	    const t1shi6 = s[13] ^ hi;
	    const t1slo11 = s[22] ^ lo;
	    const t1shi11 = s[23] ^ hi;
	    const t1slo16 = s[32] ^ lo;
	    const t1shi16 = s[33] ^ hi;
	    const t1slo21 = s[42] ^ lo;
	    const t1shi21 = s[43] ^ hi;
	    lo = lo1 ^ (lo3 << 1 | hi3 >>> 31);
	    hi = hi1 ^ (hi3 << 1 | lo3 >>> 31);
	    const t1slo2 = s[4] ^ lo;
	    const t1shi2 = s[5] ^ hi;
	    const t1slo7 = s[14] ^ lo;
	    const t1shi7 = s[15] ^ hi;
	    const t1slo12 = s[24] ^ lo;
	    const t1shi12 = s[25] ^ hi;
	    const t1slo17 = s[34] ^ lo;
	    const t1shi17 = s[35] ^ hi;
	    const t1slo22 = s[44] ^ lo;
	    const t1shi22 = s[45] ^ hi;
	    lo = lo2 ^ (lo4 << 1 | hi4 >>> 31);
	    hi = hi2 ^ (hi4 << 1 | lo4 >>> 31);
	    const t1slo3 = s[6] ^ lo;
	    const t1shi3 = s[7] ^ hi;
	    const t1slo8 = s[16] ^ lo;
	    const t1shi8 = s[17] ^ hi;
	    const t1slo13 = s[26] ^ lo;
	    const t1shi13 = s[27] ^ hi;
	    const t1slo18 = s[36] ^ lo;
	    const t1shi18 = s[37] ^ hi;
	    const t1slo23 = s[46] ^ lo;
	    const t1shi23 = s[47] ^ hi;
	    lo = lo3 ^ (lo0 << 1 | hi0 >>> 31);
	    hi = hi3 ^ (hi0 << 1 | lo0 >>> 31);
	    const t1slo4 = s[8] ^ lo;
	    const t1shi4 = s[9] ^ hi;
	    const t1slo9 = s[18] ^ lo;
	    const t1shi9 = s[19] ^ hi;
	    const t1slo14 = s[28] ^ lo;
	    const t1shi14 = s[29] ^ hi;
	    const t1slo19 = s[38] ^ lo;
	    const t1shi19 = s[39] ^ hi;
	    const t1slo24 = s[48] ^ lo;
	    const t1shi24 = s[49] ^ hi;

	    // rho & pi
	    const t2slo0 = t1slo0;
	    const t2shi0 = t1shi0;
	    const t2slo16 = (t1shi5 << 4 | t1slo5 >>> 28);
	    const t2shi16 = (t1slo5 << 4 | t1shi5 >>> 28);
	    const t2slo7 = (t1slo10 << 3 | t1shi10 >>> 29);
	    const t2shi7 = (t1shi10 << 3 | t1slo10 >>> 29);
	    const t2slo23 = (t1shi15 << 9 | t1slo15 >>> 23);
	    const t2shi23 = (t1slo15 << 9 | t1shi15 >>> 23);
	    const t2slo14 = (t1slo20 << 18 | t1shi20 >>> 14);
	    const t2shi14 = (t1shi20 << 18 | t1slo20 >>> 14);
	    const t2slo10 = (t1slo1 << 1 | t1shi1 >>> 31);
	    const t2shi10 = (t1shi1 << 1 | t1slo1 >>> 31);
	    const t2slo1 = (t1shi6 << 12 | t1slo6 >>> 20);
	    const t2shi1 = (t1slo6 << 12 | t1shi6 >>> 20);
	    const t2slo17 = (t1slo11 << 10 | t1shi11 >>> 22);
	    const t2shi17 = (t1shi11 << 10 | t1slo11 >>> 22);
	    const t2slo8 = (t1shi16 << 13 | t1slo16 >>> 19);
	    const t2shi8 = (t1slo16 << 13 | t1shi16 >>> 19);
	    const t2slo24 = (t1slo21 << 2 | t1shi21 >>> 30);
	    const t2shi24 = (t1shi21 << 2 | t1slo21 >>> 30);
	    const t2slo20 = (t1shi2 << 30 | t1slo2 >>> 2);
	    const t2shi20 = (t1slo2 << 30 | t1shi2 >>> 2);
	    const t2slo11 = (t1slo7 << 6 | t1shi7 >>> 26);
	    const t2shi11 = (t1shi7 << 6 | t1slo7 >>> 26);
	    const t2slo2 = (t1shi12 << 11 | t1slo12 >>> 21);
	    const t2shi2 = (t1slo12 << 11 | t1shi12 >>> 21);
	    const t2slo18 = (t1slo17 << 15 | t1shi17 >>> 17);
	    const t2shi18 = (t1shi17 << 15 | t1slo17 >>> 17);
	    const t2slo9 = (t1shi22 << 29 | t1slo22 >>> 3);
	    const t2shi9 = (t1slo22 << 29 | t1shi22 >>> 3);
	    const t2slo5 = (t1slo3 << 28 | t1shi3 >>> 4);
	    const t2shi5 = (t1shi3 << 28 | t1slo3 >>> 4);
	    const t2slo21 = (t1shi8 << 23 | t1slo8 >>> 9);
	    const t2shi21 = (t1slo8 << 23 | t1shi8 >>> 9);
	    const t2slo12 = (t1slo13 << 25 | t1shi13 >>> 7);
	    const t2shi12 = (t1shi13 << 25 | t1slo13 >>> 7);
	    const t2slo3 = (t1slo18 << 21 | t1shi18 >>> 11);
	    const t2shi3 = (t1shi18 << 21 | t1slo18 >>> 11);
	    const t2slo19 = (t1shi23 << 24 | t1slo23 >>> 8);
	    const t2shi19 = (t1slo23 << 24 | t1shi23 >>> 8);
	    const t2slo15 = (t1slo4 << 27 | t1shi4 >>> 5);
	    const t2shi15 = (t1shi4 << 27 | t1slo4 >>> 5);
	    const t2slo6 = (t1slo9 << 20 | t1shi9 >>> 12);
	    const t2shi6 = (t1shi9 << 20 | t1slo9 >>> 12);
	    const t2slo22 = (t1shi14 << 7 | t1slo14 >>> 25);
	    const t2shi22 = (t1slo14 << 7 | t1shi14 >>> 25);
	    const t2slo13 = (t1slo19 << 8 | t1shi19 >>> 24);
	    const t2shi13 = (t1shi19 << 8 | t1slo19 >>> 24);
	    const t2slo4 = (t1slo24 << 14 | t1shi24 >>> 18);
	    const t2shi4 = (t1shi24 << 14 | t1slo24 >>> 18);

	    // chi
	    s[0] = t2slo0 ^ (~t2slo1 & t2slo2);
	    s[1] = t2shi0 ^ (~t2shi1 & t2shi2);
	    s[10] = t2slo5 ^ (~t2slo6 & t2slo7);
	    s[11] = t2shi5 ^ (~t2shi6 & t2shi7);
	    s[20] = t2slo10 ^ (~t2slo11 & t2slo12);
	    s[21] = t2shi10 ^ (~t2shi11 & t2shi12);
	    s[30] = t2slo15 ^ (~t2slo16 & t2slo17);
	    s[31] = t2shi15 ^ (~t2shi16 & t2shi17);
	    s[40] = t2slo20 ^ (~t2slo21 & t2slo22);
	    s[41] = t2shi20 ^ (~t2shi21 & t2shi22);
	    s[2] = t2slo1 ^ (~t2slo2 & t2slo3);
	    s[3] = t2shi1 ^ (~t2shi2 & t2shi3);
	    s[12] = t2slo6 ^ (~t2slo7 & t2slo8);
	    s[13] = t2shi6 ^ (~t2shi7 & t2shi8);
	    s[22] = t2slo11 ^ (~t2slo12 & t2slo13);
	    s[23] = t2shi11 ^ (~t2shi12 & t2shi13);
	    s[32] = t2slo16 ^ (~t2slo17 & t2slo18);
	    s[33] = t2shi16 ^ (~t2shi17 & t2shi18);
	    s[42] = t2slo21 ^ (~t2slo22 & t2slo23);
	    s[43] = t2shi21 ^ (~t2shi22 & t2shi23);
	    s[4] = t2slo2 ^ (~t2slo3 & t2slo4);
	    s[5] = t2shi2 ^ (~t2shi3 & t2shi4);
	    s[14] = t2slo7 ^ (~t2slo8 & t2slo9);
	    s[15] = t2shi7 ^ (~t2shi8 & t2shi9);
	    s[24] = t2slo12 ^ (~t2slo13 & t2slo14);
	    s[25] = t2shi12 ^ (~t2shi13 & t2shi14);
	    s[34] = t2slo17 ^ (~t2slo18 & t2slo19);
	    s[35] = t2shi17 ^ (~t2shi18 & t2shi19);
	    s[44] = t2slo22 ^ (~t2slo23 & t2slo24);
	    s[45] = t2shi22 ^ (~t2shi23 & t2shi24);
	    s[6] = t2slo3 ^ (~t2slo4 & t2slo0);
	    s[7] = t2shi3 ^ (~t2shi4 & t2shi0);
	    s[16] = t2slo8 ^ (~t2slo9 & t2slo5);
	    s[17] = t2shi8 ^ (~t2shi9 & t2shi5);
	    s[26] = t2slo13 ^ (~t2slo14 & t2slo10);
	    s[27] = t2shi13 ^ (~t2shi14 & t2shi10);
	    s[36] = t2slo18 ^ (~t2slo19 & t2slo15);
	    s[37] = t2shi18 ^ (~t2shi19 & t2shi15);
	    s[46] = t2slo23 ^ (~t2slo24 & t2slo20);
	    s[47] = t2shi23 ^ (~t2shi24 & t2shi20);
	    s[8] = t2slo4 ^ (~t2slo0 & t2slo1);
	    s[9] = t2shi4 ^ (~t2shi0 & t2shi1);
	    s[18] = t2slo9 ^ (~t2slo5 & t2slo6);
	    s[19] = t2shi9 ^ (~t2shi5 & t2shi6);
	    s[28] = t2slo14 ^ (~t2slo10 & t2slo11);
	    s[29] = t2shi14 ^ (~t2shi10 & t2shi11);
	    s[38] = t2slo19 ^ (~t2slo15 & t2slo16);
	    s[39] = t2shi19 ^ (~t2shi15 & t2shi16);
	    s[48] = t2slo24 ^ (~t2slo20 & t2slo21);
	    s[49] = t2shi24 ^ (~t2shi20 & t2shi21);

	    // iota
	    s[0] ^= P1600_ROUND_CONSTANTS[round * 2];
	    s[1] ^= P1600_ROUND_CONSTANTS[round * 2 + 1];
	  }
	};

	const keccakState = keccakStateUnroll;

	function Keccak () {
	  // much faster than `new Array(50)`
	  this.state = [
	    0, 0, 0, 0, 0,
	    0, 0, 0, 0, 0,
	    0, 0, 0, 0, 0,
	    0, 0, 0, 0, 0,
	    0, 0, 0, 0, 0
	  ];

	  this.blockSize = null;
	  this.count = 0;
	  this.squeezing = false;
	}

	Keccak.prototype.initialize = function (rate, capacity) {
	  for (let i = 0; i < 50; ++i) this.state[i] = 0;
	  this.blockSize = rate / 8;
	  this.count = 0;
	  this.squeezing = false;
	};

	Keccak.prototype.absorb = function (data) {
	  for (let i = 0; i < data.length; ++i) {
	    this.state[~~(this.count / 4)] ^= data[i] << (8 * (this.count % 4));
	    this.count += 1;
	    if (this.count === this.blockSize) {
	      keccakState.p1600(this.state);
	      this.count = 0;
	    }
	  }
	};

	Keccak.prototype.absorbLastFewBits = function (bits) {
	  this.state[~~(this.count / 4)] ^= bits << (8 * (this.count % 4));
	  if ((bits & 0x80) !== 0 && this.count === (this.blockSize - 1)) keccakState.p1600(this.state);
	  this.state[~~((this.blockSize - 1) / 4)] ^= 0x80 << (8 * ((this.blockSize - 1) % 4));
	  keccakState.p1600(this.state);
	  this.count = 0;
	  this.squeezing = true;
	};

	Keccak.prototype.squeeze = function (length) {
	  if (!this.squeezing) this.absorbLastFewBits(0x01);

	  const output = Buffer.alloc(length);
	  for (let i = 0; i < length; ++i) {
	    output[i] = (this.state[~~(this.count / 4)] >>> (8 * (this.count % 4))) & 0xff;
	    this.count += 1;
	    if (this.count === this.blockSize) {
	      keccakState.p1600(this.state);
	      this.count = 0;
	    }
	  }

	  return output
	};

	Keccak.prototype.copy = function (dest) {
	  for (let i = 0; i < 50; ++i) dest.state[i] = this.state[i];
	  dest.blockSize = this.blockSize;
	  dest.count = this.count;
	  dest.squeezing = this.squeezing;
	};

	var keccak$1 = Keccak;

	var js$1 = api(keccak$1);

	// Extracted from https://github.com/ethereumjs/ethereumjs-util and stripped out irrelevant code
	// Original code licensed under the Mozilla Public License Version 2.0

	const createKeccakHash = js$1;
	const BN$1 = bnExports$1;

	/**
	 * Returns a buffer filled with 0s
	 * @method zeros
	 * @param {Number} bytes  the number of bytes the buffer should be
	 * @return {Buffer}
	 */
	function zeros (bytes) {
	  return Buffer.allocUnsafe(bytes).fill(0)
	}

	/**
	 * Left Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
	 * Or it truncates the beginning if it exceeds.
	 * @method setLength
	 * @param {Buffer|Array} msg the value to pad
	 * @param {Number} length the number of bytes the output should be
	 * @param {Boolean} [right=false] whether to start padding form the left or right
	 * @return {Buffer|Array}
	 */
	function setLength (msg, length, right) {
	  const buf = zeros(length);
	  msg = toBuffer(msg);
	  if (right) {
	    if (msg.length < length) {
	      msg.copy(buf);
	      return buf
	    }
	    return msg.slice(0, length)
	  } else {
	    if (msg.length < length) {
	      msg.copy(buf, length - msg.length);
	      return buf
	    }
	    return msg.slice(-length)
	  }
	}

	/**
	 * Right Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
	 * Or it truncates the beginning if it exceeds.
	 * @param {Buffer|Array} msg the value to pad
	 * @param {Number} length the number of bytes the output should be
	 * @return {Buffer|Array}
	 */
	function setLengthRight (msg, length) {
	  return setLength(msg, length, true)
	}

	/**
	 * Attempts to turn a value into a `Buffer`. As input it supports `Buffer`, `String`, `Number`, null/undefined, `BN` and other objects with a `toArray()` method.
	 * @param {*} v the value
	 */
	function toBuffer (v) {
	  if (!Buffer.isBuffer(v)) {
	    if (Array.isArray(v)) {
	      v = Buffer.from(v);
	    } else if (typeof v === 'string') {
	      if (isHexString(v)) {
	        v = Buffer.from(padToEven(stripHexPrefix(v)), 'hex');
	      } else {
	        v = Buffer.from(v);
	      }
	    } else if (typeof v === 'number') {
	      v = intToBuffer(v);
	    } else if (v === null || v === undefined) {
	      v = Buffer.allocUnsafe(0);
	    } else if (BN$1.isBN(v)) {
	      v = v.toArrayLike(Buffer);
	    } else if (v.toArray) {
	      // converts a BN to a Buffer
	      v = Buffer.from(v.toArray());
	    } else {
	      throw new Error('invalid type')
	    }
	  }
	  return v
	}

	/**
	 * Converts a `Buffer` into a hex `String`
	 * @param {Buffer} buf
	 * @return {String}
	 */
	function bufferToHex (buf) {
	  buf = toBuffer(buf);
	  return '0x' + buf.toString('hex')
	}

	/**
	 * Creates Keccak hash of the input
	 * @param {Buffer|Array|String|Number} a the input data
	 * @param {Number} [bits=256] the Keccak width
	 * @return {Buffer}
	 */
	function keccak (a, bits) {
	  a = toBuffer(a);
	  if (!bits) bits = 256;

	  return createKeccakHash('keccak' + bits).update(a).digest()
	}

	function padToEven (str) {
	  return str.length % 2 ? '0' + str : str
	}

	function isHexString (str) {
	  return typeof str === 'string' && str.match(/^0x[0-9A-Fa-f]*$/)
	}

	function stripHexPrefix (str) {
	  if (typeof str === 'string' && str.startsWith('0x')) {
	    return str.slice(2)
	  }
	  return str
	}

	var util$2 = {
	  zeros,
	  setLength,
	  setLengthRight,
	  isHexString,
	  stripHexPrefix,
	  toBuffer,
	  bufferToHex,
	  keccak
	};

	// Extracted from https://github.com/ethereumjs/ethereumjs-abi and stripped out irrelevant code
	// Original code licensed under the MIT License - Copyright (c) 2015 Alex Beregszaszi

	const util$1 = util$2;
	const BN = bnExports$1;

	// Convert from short to canonical names
	// FIXME: optimise or make this nicer?
	function elementaryName (name) {
	  if (name.startsWith('int[')) {
	    return 'int256' + name.slice(3)
	  } else if (name === 'int') {
	    return 'int256'
	  } else if (name.startsWith('uint[')) {
	    return 'uint256' + name.slice(4)
	  } else if (name === 'uint') {
	    return 'uint256'
	  } else if (name.startsWith('fixed[')) {
	    return 'fixed128x128' + name.slice(5)
	  } else if (name === 'fixed') {
	    return 'fixed128x128'
	  } else if (name.startsWith('ufixed[')) {
	    return 'ufixed128x128' + name.slice(6)
	  } else if (name === 'ufixed') {
	    return 'ufixed128x128'
	  }
	  return name
	}

	// Parse N from type<N>
	function parseTypeN (type) {
	  return parseInt(/^\D+(\d+)$/.exec(type)[1], 10)
	}

	// Parse N,M from type<N>x<M>
	function parseTypeNxM (type) {
	  var tmp = /^\D+(\d+)x(\d+)$/.exec(type);
	  return [ parseInt(tmp[1], 10), parseInt(tmp[2], 10) ]
	}

	// Parse N in type[<N>] where "type" can itself be an array type.
	function parseTypeArray (type) {
	  var tmp = type.match(/(.*)\[(.*?)\]$/);
	  if (tmp) {
	    return tmp[2] === '' ? 'dynamic' : parseInt(tmp[2], 10)
	  }
	  return null
	}

	function parseNumber (arg) {
	  var type = typeof arg;
	  if (type === 'string') {
	    if (util$1.isHexString(arg)) {
	      return new BN(util$1.stripHexPrefix(arg), 16)
	    } else {
	      return new BN(arg, 10)
	    }
	  } else if (type === 'number') {
	    return new BN(arg)
	  } else if (arg.toArray) {
	    // assume this is a BN for the moment, replace with BN.isBN soon
	    return arg
	  } else {
	    throw new Error('Argument is not a number')
	  }
	}

	// Encodes a single item (can be dynamic array)
	// @returns: Buffer
	function encodeSingle (type, arg) {
	  var size, num, ret, i;

	  if (type === 'address') {
	    return encodeSingle('uint160', parseNumber(arg))
	  } else if (type === 'bool') {
	    return encodeSingle('uint8', arg ? 1 : 0)
	  } else if (type === 'string') {
	    return encodeSingle('bytes', new Buffer(arg, 'utf8'))
	  } else if (isArray$1(type)) {
	    // this part handles fixed-length ([2]) and variable length ([]) arrays
	    // NOTE: we catch here all calls to arrays, that simplifies the rest
	    if (typeof arg.length === 'undefined') {
	      throw new Error('Not an array?')
	    }
	    size = parseTypeArray(type);
	    if (size !== 'dynamic' && size !== 0 && arg.length > size) {
	      throw new Error('Elements exceed array size: ' + size)
	    }
	    ret = [];
	    type = type.slice(0, type.lastIndexOf('['));
	    if (typeof arg === 'string') {
	      arg = JSON.parse(arg);
	    }
	    for (i in arg) {
	      ret.push(encodeSingle(type, arg[i]));
	    }
	    if (size === 'dynamic') {
	      var length = encodeSingle('uint256', arg.length);
	      ret.unshift(length);
	    }
	    return Buffer.concat(ret)
	  } else if (type === 'bytes') {
	    arg = new Buffer(arg);

	    ret = Buffer.concat([ encodeSingle('uint256', arg.length), arg ]);

	    if ((arg.length % 32) !== 0) {
	      ret = Buffer.concat([ ret, util$1.zeros(32 - (arg.length % 32)) ]);
	    }

	    return ret
	  } else if (type.startsWith('bytes')) {
	    size = parseTypeN(type);
	    if (size < 1 || size > 32) {
	      throw new Error('Invalid bytes<N> width: ' + size)
	    }

	    return util$1.setLengthRight(arg, 32)
	  } else if (type.startsWith('uint')) {
	    size = parseTypeN(type);
	    if ((size % 8) || (size < 8) || (size > 256)) {
	      throw new Error('Invalid uint<N> width: ' + size)
	    }

	    num = parseNumber(arg);
	    if (num.bitLength() > size) {
	      throw new Error('Supplied uint exceeds width: ' + size + ' vs ' + num.bitLength())
	    }

	    if (num < 0) {
	      throw new Error('Supplied uint is negative')
	    }

	    return num.toArrayLike(Buffer, 'be', 32)
	  } else if (type.startsWith('int')) {
	    size = parseTypeN(type);
	    if ((size % 8) || (size < 8) || (size > 256)) {
	      throw new Error('Invalid int<N> width: ' + size)
	    }

	    num = parseNumber(arg);
	    if (num.bitLength() > size) {
	      throw new Error('Supplied int exceeds width: ' + size + ' vs ' + num.bitLength())
	    }

	    return num.toTwos(256).toArrayLike(Buffer, 'be', 32)
	  } else if (type.startsWith('ufixed')) {
	    size = parseTypeNxM(type);

	    num = parseNumber(arg);

	    if (num < 0) {
	      throw new Error('Supplied ufixed is negative')
	    }

	    return encodeSingle('uint256', num.mul(new BN(2).pow(new BN(size[1]))))
	  } else if (type.startsWith('fixed')) {
	    size = parseTypeNxM(type);

	    return encodeSingle('int256', parseNumber(arg).mul(new BN(2).pow(new BN(size[1]))))
	  }

	  throw new Error('Unsupported or invalid type: ' + type)
	}

	// Is a type dynamic?
	function isDynamic (type) {
	  // FIXME: handle all types? I don't think anything is missing now
	  return (type === 'string') || (type === 'bytes') || (parseTypeArray(type) === 'dynamic')
	}

	// Is a type an array?
	function isArray$1 (type) {
	  return type.lastIndexOf(']') === type.length - 1
	}

	// Encode a method/event with arguments
	// @types an array of string type names
	// @args  an array of the appropriate values
	function rawEncode (types, values) {
	  var output = [];
	  var data = [];

	  var headLength = 32 * types.length;

	  for (var i in types) {
	    var type = elementaryName(types[i]);
	    var value = values[i];
	    var cur = encodeSingle(type, value);

	    // Use the head/tail method for storing dynamic data
	    if (isDynamic(type)) {
	      output.push(encodeSingle('uint256', headLength));
	      data.push(cur);
	      headLength += cur.length;
	    } else {
	      output.push(cur);
	    }
	  }

	  return Buffer.concat(output.concat(data))
	}

	function solidityPack (types, values) {
	  if (types.length !== values.length) {
	    throw new Error('Number of types are not matching the values')
	  }

	  var size, num;
	  var ret = [];

	  for (var i = 0; i < types.length; i++) {
	    var type = elementaryName(types[i]);
	    var value = values[i];

	    if (type === 'bytes') {
	      ret.push(value);
	    } else if (type === 'string') {
	      ret.push(new Buffer(value, 'utf8'));
	    } else if (type === 'bool') {
	      ret.push(new Buffer(value ? '01' : '00', 'hex'));
	    } else if (type === 'address') {
	      ret.push(util$1.setLength(value, 20));
	    } else if (type.startsWith('bytes')) {
	      size = parseTypeN(type);
	      if (size < 1 || size > 32) {
	        throw new Error('Invalid bytes<N> width: ' + size)
	      }

	      ret.push(util$1.setLengthRight(value, size));
	    } else if (type.startsWith('uint')) {
	      size = parseTypeN(type);
	      if ((size % 8) || (size < 8) || (size > 256)) {
	        throw new Error('Invalid uint<N> width: ' + size)
	      }

	      num = parseNumber(value);
	      if (num.bitLength() > size) {
	        throw new Error('Supplied uint exceeds width: ' + size + ' vs ' + num.bitLength())
	      }

	      ret.push(num.toArrayLike(Buffer, 'be', size / 8));
	    } else if (type.startsWith('int')) {
	      size = parseTypeN(type);
	      if ((size % 8) || (size < 8) || (size > 256)) {
	        throw new Error('Invalid int<N> width: ' + size)
	      }

	      num = parseNumber(value);
	      if (num.bitLength() > size) {
	        throw new Error('Supplied int exceeds width: ' + size + ' vs ' + num.bitLength())
	      }

	      ret.push(num.toTwos(size).toArrayLike(Buffer, 'be', size / 8));
	    } else {
	      // FIXME: support all other types
	      throw new Error('Unsupported or invalid type: ' + type)
	    }
	  }

	  return Buffer.concat(ret)
	}

	function soliditySHA3 (types, values) {
	  return util$1.keccak(solidityPack(types, values))
	}

	var abi$1 = {
	  rawEncode,
	  solidityPack,
	  soliditySHA3
	};

	const util = util$2;
	const abi = abi$1;

	const TYPED_MESSAGE_SCHEMA = {
	  type: 'object',
	  properties: {
	    types: {
	      type: 'object',
	      additionalProperties: {
	        type: 'array',
	        items: {
	          type: 'object',
	          properties: {
	            name: {type: 'string'},
	            type: {type: 'string'},
	          },
	          required: ['name', 'type'],
	        },
	      },
	    },
	    primaryType: {type: 'string'},
	    domain: {type: 'object'},
	    message: {type: 'object'},
	  },
	  required: ['types', 'primaryType', 'domain', 'message'],
	};

	/**
	 * A collection of utility functions used for signing typed data
	 */
	const TypedDataUtils = {
	  /**
	   * Encodes an object by encoding and concatenating each of its members
	   *
	   * @param {string} primaryType - Root type
	   * @param {Object} data - Object to encode
	   * @param {Object} types - Type definitions
	   * @returns {string} - Encoded representation of an object
	   */
	  encodeData (primaryType, data, types, useV4 = true) {
	    const encodedTypes = ['bytes32'];
	    const encodedValues = [this.hashType(primaryType, types)];

	    if(useV4) {
	      const encodeField = (name, type, value) => {
	        if (types[type] !== undefined) {
	          return ['bytes32', value == null ?
	            '0x0000000000000000000000000000000000000000000000000000000000000000' :
	            util.keccak(this.encodeData(type, value, types, useV4))]
	        }

	        if(value === undefined)
	          throw new Error(`missing value for field ${name} of type ${type}`)

	        if (type === 'bytes') {
	          return ['bytes32', util.keccak(value)]
	        }

	        if (type === 'string') {
	          // convert string to buffer - prevents ethUtil from interpreting strings like '0xabcd' as hex
	          if (typeof value === 'string') {
	            value = Buffer.from(value, 'utf8');
	          }
	          return ['bytes32', util.keccak(value)]
	        }

	        if (type.lastIndexOf(']') === type.length - 1) {
	          const parsedType = type.slice(0, type.lastIndexOf('['));
	          const typeValuePairs = value.map(item =>
	            encodeField(name, parsedType, item));
	          return ['bytes32', util.keccak(abi.rawEncode(
	            typeValuePairs.map(([type]) => type),
	            typeValuePairs.map(([, value]) => value),
	          ))]
	        }

	        return [type, value]
	      };

	      for (const field of types[primaryType]) {
	        const [type, value] = encodeField(field.name, field.type, data[field.name]);
	        encodedTypes.push(type);
	        encodedValues.push(value);
	      }
	    } else {
	      for (const field of types[primaryType]) {
	        let value = data[field.name];
	        if (value !== undefined) {
	          if (field.type === 'bytes') {
	            encodedTypes.push('bytes32');
	            value = util.keccak(value);
	            encodedValues.push(value);
	          } else if (field.type === 'string') {
	            encodedTypes.push('bytes32');
	            // convert string to buffer - prevents ethUtil from interpreting strings like '0xabcd' as hex
	            if (typeof value === 'string') {
	              value = Buffer.from(value, 'utf8');
	            }
	            value = util.keccak(value);
	            encodedValues.push(value);
	          } else if (types[field.type] !== undefined) {
	            encodedTypes.push('bytes32');
	            value = util.keccak(this.encodeData(field.type, value, types, useV4));
	            encodedValues.push(value);
	          } else if (field.type.lastIndexOf(']') === field.type.length - 1) {
	            throw new Error('Arrays currently unimplemented in encodeData')
	          } else {
	            encodedTypes.push(field.type);
	            encodedValues.push(value);
	          }
	        }
	      }
	    }

	    return abi.rawEncode(encodedTypes, encodedValues)
	  },

	  /**
	   * Encodes the type of an object by encoding a comma delimited list of its members
	   *
	   * @param {string} primaryType - Root type to encode
	   * @param {Object} types - Type definitions
	   * @returns {string} - Encoded representation of the type of an object
	   */
	  encodeType (primaryType, types) {
	    let result = '';
	    let deps = this.findTypeDependencies(primaryType, types).filter(dep => dep !== primaryType);
	    deps = [primaryType].concat(deps.sort());
	    for (const type of deps) {
	      const children = types[type];
	      if (!children) {
	        throw new Error('No type definition specified: ' + type)
	      }
	      result += type + '(' + types[type].map(({ name, type }) => type + ' ' + name).join(',') + ')';
	    }
	    return result
	  },

	  /**
	   * Finds all types within a type defintion object
	   *
	   * @param {string} primaryType - Root type
	   * @param {Object} types - Type definitions
	   * @param {Array} results - current set of accumulated types
	   * @returns {Array} - Set of all types found in the type definition
	   */
	  findTypeDependencies (primaryType, types, results = []) {
	    primaryType = primaryType.match(/^\w*/)[0];
	    if (results.includes(primaryType) || types[primaryType] === undefined) { return results }
	    results.push(primaryType);
	    for (const field of types[primaryType]) {
	      for (const dep of this.findTypeDependencies(field.type, types, results)) {
	        !results.includes(dep) && results.push(dep);
	      }
	    }
	    return results
	  },

	  /**
	   * Hashes an object
	   *
	   * @param {string} primaryType - Root type
	   * @param {Object} data - Object to hash
	   * @param {Object} types - Type definitions
	   * @returns {Buffer} - Hash of an object
	   */
	  hashStruct (primaryType, data, types, useV4 = true) {
	    return util.keccak(this.encodeData(primaryType, data, types, useV4))
	  },

	  /**
	   * Hashes the type of an object
	   *
	   * @param {string} primaryType - Root type to hash
	   * @param {Object} types - Type definitions
	   * @returns {string} - Hash of an object
	   */
	  hashType (primaryType, types) {
	    return util.keccak(this.encodeType(primaryType, types))
	  },

	  /**
	   * Removes properties from a message object that are not defined per EIP-712
	   *
	   * @param {Object} data - typed message object
	   * @returns {Object} - typed message object with only allowed fields
	   */
	  sanitizeData (data) {
	    const sanitizedData = {};
	    for (const key in TYPED_MESSAGE_SCHEMA.properties) {
	      data[key] && (sanitizedData[key] = data[key]);
	    }
	    if (sanitizedData.types) {
	      sanitizedData.types = Object.assign({ EIP712Domain: [] }, sanitizedData.types);
	    }
	    return sanitizedData
	  },

	  /**
	   * Returns the hash of a typed message as per EIP-712 for signing
	   *
	   * @param {Object} typedData - Types message data to sign
	   * @returns {string} - sha3 hash for signing
	   */
	  hash (typedData, useV4 = true) {
	    const sanitizedData = this.sanitizeData(typedData);
	    const parts = [Buffer.from('1901', 'hex')];
	    parts.push(this.hashStruct('EIP712Domain', sanitizedData.domain, sanitizedData.types, useV4));
	    if (sanitizedData.primaryType !== 'EIP712Domain') {
	      parts.push(this.hashStruct(sanitizedData.primaryType, sanitizedData.message, sanitizedData.types, useV4));
	    }
	    return util.keccak(Buffer.concat(parts))
	  },
	};

	var ethEip712Util = {
	  TYPED_MESSAGE_SCHEMA,
	  TypedDataUtils,

	  hashForSignTypedDataLegacy: function (msgParams) {
	    return typedSignatureHashLegacy(msgParams.data)
	  },

	  hashForSignTypedData_v3: function (msgParams) {
	    return TypedDataUtils.hash(msgParams.data, false)
	  },

	  hashForSignTypedData_v4: function (msgParams) {
	    return TypedDataUtils.hash(msgParams.data)
	  },
	};

	/**
	 * @param typedData - Array of data along with types, as per EIP712.
	 * @returns Buffer
	 */
	function typedSignatureHashLegacy(typedData) {
	  const error = new Error('Expect argument to be non-empty array');
	  if (typeof typedData !== 'object' || !typedData.length) throw error

	  const data = typedData.map(function (e) {
	    return e.type === 'bytes' ? util.toBuffer(e.value) : e.value
	  });
	  const types = typedData.map(function (e) { return e.type });
	  const schema = typedData.map(function (e) {
	    if (!e.name) throw error
	    return e.type + ' ' + e.name
	  });

	  return abi.soliditySHA3(
	    ['bytes32', 'bytes32'],
	    [
	      abi.soliditySHA3(new Array(typedData.length).fill('string'), schema),
	      abi.soliditySHA3(types, data)
	    ]
	  )
	}

	var FilterPolyfill$1 = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(FilterPolyfill$1, "__esModule", { value: true });
	FilterPolyfill$1.filterFromParam = FilterPolyfill$1.FilterPolyfill = void 0;
	const types_1$2 = types$4;
	const util_1$6 = util$3;
	const TIMEOUT = 5 * 60 * 1000; // 5 minutes
	const JSONRPC_TEMPLATE = {
	    jsonrpc: "2.0",
	    id: 0,
	};
	class FilterPolyfill {
	    constructor(provider) {
	        this.logFilters = new Map(); // <id, filter>
	        this.blockFilters = new Set(); // <id>
	        this.pendingTransactionFilters = new Set(); // <id, true>
	        this.cursors = new Map(); // <id, cursor>
	        this.timeouts = new Map(); // <id, setTimeout id>
	        this.nextFilterId = (0, types_1$2.IntNumber)(1);
	        this.provider = provider;
	    }
	    async newFilter(param) {
	        const filter = filterFromParam(param);
	        const id = this.makeFilterId();
	        const cursor = await this.setInitialCursorPosition(id, filter.fromBlock);
	        console.log(`Installing new log filter(${id}):`, filter, "initial cursor position:", cursor);
	        this.logFilters.set(id, filter);
	        this.setFilterTimeout(id);
	        return (0, util_1$6.hexStringFromIntNumber)(id);
	    }
	    async newBlockFilter() {
	        const id = this.makeFilterId();
	        const cursor = await this.setInitialCursorPosition(id, "latest");
	        console.log(`Installing new block filter (${id}) with initial cursor position:`, cursor);
	        this.blockFilters.add(id);
	        this.setFilterTimeout(id);
	        return (0, util_1$6.hexStringFromIntNumber)(id);
	    }
	    async newPendingTransactionFilter() {
	        const id = this.makeFilterId();
	        const cursor = await this.setInitialCursorPosition(id, "latest");
	        console.log(`Installing new block filter (${id}) with initial cursor position:`, cursor);
	        this.pendingTransactionFilters.add(id);
	        this.setFilterTimeout(id);
	        return (0, util_1$6.hexStringFromIntNumber)(id);
	    }
	    uninstallFilter(filterId) {
	        const id = (0, util_1$6.intNumberFromHexString)(filterId);
	        console.log(`Uninstalling filter (${id})`);
	        this.deleteFilter(id);
	        return true;
	    }
	    getFilterChanges(filterId) {
	        const id = (0, util_1$6.intNumberFromHexString)(filterId);
	        if (this.timeouts.has(id)) {
	            // extend timeout
	            this.setFilterTimeout(id);
	        }
	        if (this.logFilters.has(id)) {
	            return this.getLogFilterChanges(id);
	        }
	        else if (this.blockFilters.has(id)) {
	            return this.getBlockFilterChanges(id);
	        }
	        else if (this.pendingTransactionFilters.has(id)) {
	            return this.getPendingTransactionFilterChanges(id);
	        }
	        return Promise.resolve(filterNotFoundError());
	    }
	    async getFilterLogs(filterId) {
	        const id = (0, util_1$6.intNumberFromHexString)(filterId);
	        const filter = this.logFilters.get(id);
	        if (!filter) {
	            return filterNotFoundError();
	        }
	        return this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), { method: "eth_getLogs", params: [paramFromFilter(filter)] }));
	    }
	    makeFilterId() {
	        return (0, types_1$2.IntNumber)(++this.nextFilterId);
	    }
	    sendAsyncPromise(request) {
	        return new Promise((resolve, reject) => {
	            this.provider.sendAsync(request, (err, response) => {
	                if (err) {
	                    return reject(err);
	                }
	                if (Array.isArray(response) || response == null) {
	                    return reject(new Error(`unexpected response received: ${JSON.stringify(response)}`));
	                }
	                resolve(response);
	            });
	        });
	    }
	    deleteFilter(id) {
	        console.log(`Deleting filter (${id})`);
	        this.logFilters.delete(id);
	        this.blockFilters.delete(id);
	        this.pendingTransactionFilters.delete(id);
	        this.cursors.delete(id);
	        this.timeouts.delete(id);
	    }
	    async getLogFilterChanges(id) {
	        const filter = this.logFilters.get(id);
	        const cursorPosition = this.cursors.get(id);
	        if (!cursorPosition || !filter) {
	            return filterNotFoundError();
	        }
	        const currentBlockHeight = await this.getCurrentBlockHeight();
	        const toBlock = filter.toBlock === "latest" ? currentBlockHeight : filter.toBlock;
	        if (cursorPosition > currentBlockHeight) {
	            return emptyResult();
	        }
	        if (cursorPosition > filter.toBlock) {
	            return emptyResult();
	        }
	        console.log(`Fetching logs from ${cursorPosition} to ${toBlock} for filter ${id}`);
	        const response = await this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), { method: "eth_getLogs", params: [
	                paramFromFilter(Object.assign(Object.assign({}, filter), { fromBlock: cursorPosition, toBlock })),
	            ] }));
	        if (Array.isArray(response.result)) {
	            const blocks = response.result.map(log => (0, util_1$6.intNumberFromHexString)(log.blockNumber || "0x0"));
	            const highestBlock = Math.max(...blocks);
	            if (highestBlock && highestBlock > cursorPosition) {
	                const newCursorPosition = (0, types_1$2.IntNumber)(highestBlock + 1);
	                console.log(`Moving cursor position for filter (${id}) from ${cursorPosition} to ${newCursorPosition}`);
	                this.cursors.set(id, newCursorPosition);
	            }
	        }
	        return response;
	    }
	    async getBlockFilterChanges(id) {
	        const cursorPosition = this.cursors.get(id);
	        if (!cursorPosition) {
	            return filterNotFoundError();
	        }
	        const currentBlockHeight = await this.getCurrentBlockHeight();
	        if (cursorPosition > currentBlockHeight) {
	            return emptyResult();
	        }
	        console.log(`Fetching blocks from ${cursorPosition} to ${currentBlockHeight} for filter (${id})`);
	        const blocks = (await Promise.all(
	        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
	        (0, util_1$6.range)(cursorPosition, currentBlockHeight + 1).map(i => this.getBlockHashByNumber((0, types_1$2.IntNumber)(i))))).filter(hash => !!hash);
	        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
	        const newCursorPosition = (0, types_1$2.IntNumber)(cursorPosition + blocks.length);
	        console.log(`Moving cursor position for filter (${id}) from ${cursorPosition} to ${newCursorPosition}`);
	        this.cursors.set(id, newCursorPosition);
	        return Object.assign(Object.assign({}, JSONRPC_TEMPLATE), { result: blocks });
	    }
	    async getPendingTransactionFilterChanges(_id) {
	        // pending transaction filters are not supported
	        return Promise.resolve(emptyResult());
	    }
	    async setInitialCursorPosition(id, startBlock) {
	        const currentBlockHeight = await this.getCurrentBlockHeight();
	        const initialCursorPosition = typeof startBlock === "number" && startBlock > currentBlockHeight
	            ? startBlock
	            : currentBlockHeight;
	        this.cursors.set(id, initialCursorPosition);
	        return initialCursorPosition;
	    }
	    setFilterTimeout(id) {
	        const existing = this.timeouts.get(id);
	        if (existing) {
	            window.clearTimeout(existing);
	        }
	        const timeout = window.setTimeout(() => {
	            console.log(`Filter (${id}) timed out`);
	            this.deleteFilter(id);
	        }, TIMEOUT);
	        this.timeouts.set(id, timeout);
	    }
	    async getCurrentBlockHeight() {
	        const { result } = await this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), { method: "eth_blockNumber", params: [] }));
	        return (0, util_1$6.intNumberFromHexString)((0, util_1$6.ensureHexString)(result));
	    }
	    async getBlockHashByNumber(blockNumber) {
	        const response = await this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), { method: "eth_getBlockByNumber", params: [(0, util_1$6.hexStringFromIntNumber)(blockNumber), false] }));
	        if (response.result && typeof response.result.hash === "string") {
	            return (0, util_1$6.ensureHexString)(response.result.hash);
	        }
	        return null;
	    }
	}
	FilterPolyfill$1.FilterPolyfill = FilterPolyfill;
	function filterFromParam(param) {
	    return {
	        fromBlock: intBlockHeightFromHexBlockHeight(param.fromBlock),
	        toBlock: intBlockHeightFromHexBlockHeight(param.toBlock),
	        addresses: param.address === undefined
	            ? null
	            : Array.isArray(param.address)
	                ? param.address
	                : [param.address],
	        topics: param.topics || [],
	    };
	}
	FilterPolyfill$1.filterFromParam = filterFromParam;
	function paramFromFilter(filter) {
	    const param = {
	        fromBlock: hexBlockHeightFromIntBlockHeight(filter.fromBlock),
	        toBlock: hexBlockHeightFromIntBlockHeight(filter.toBlock),
	        topics: filter.topics,
	    };
	    if (filter.addresses !== null) {
	        param.address = filter.addresses;
	    }
	    return param;
	}
	function intBlockHeightFromHexBlockHeight(value) {
	    if (value === undefined || value === "latest" || value === "pending") {
	        return "latest";
	    }
	    else if (value === "earliest") {
	        return (0, types_1$2.IntNumber)(0);
	    }
	    else if ((0, util_1$6.isHexString)(value)) {
	        return (0, util_1$6.intNumberFromHexString)(value);
	    }
	    throw new Error(`Invalid block option: ${String(value)}`);
	}
	function hexBlockHeightFromIntBlockHeight(value) {
	    if (value === "latest") {
	        return value;
	    }
	    return (0, util_1$6.hexStringFromIntNumber)(value);
	}
	function filterNotFoundError() {
	    return Object.assign(Object.assign({}, JSONRPC_TEMPLATE), { error: { code: -32000, message: "filter not found" } });
	}
	function emptyResult() {
	    return Object.assign(Object.assign({}, JSONRPC_TEMPLATE), { result: [] });
	}

	var JSONRPC = {};

	(function (exports) {
		// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
		// Licensed under the Apache License, version 2.0
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.JSONRPCMethod = void 0;
		(function (JSONRPCMethod) {
		    // synchronous or asynchronous
		    JSONRPCMethod["eth_accounts"] = "eth_accounts";
		    JSONRPCMethod["eth_coinbase"] = "eth_coinbase";
		    JSONRPCMethod["net_version"] = "net_version";
		    JSONRPCMethod["eth_chainId"] = "eth_chainId";
		    JSONRPCMethod["eth_uninstallFilter"] = "eth_uninstallFilter";
		    // asynchronous only
		    JSONRPCMethod["eth_requestAccounts"] = "eth_requestAccounts";
		    JSONRPCMethod["eth_sign"] = "eth_sign";
		    JSONRPCMethod["eth_ecRecover"] = "eth_ecRecover";
		    JSONRPCMethod["personal_sign"] = "personal_sign";
		    JSONRPCMethod["personal_ecRecover"] = "personal_ecRecover";
		    JSONRPCMethod["eth_signTransaction"] = "eth_signTransaction";
		    JSONRPCMethod["eth_sendRawTransaction"] = "eth_sendRawTransaction";
		    JSONRPCMethod["eth_sendTransaction"] = "eth_sendTransaction";
		    JSONRPCMethod["eth_signTypedData_v1"] = "eth_signTypedData_v1";
		    JSONRPCMethod["eth_signTypedData_v2"] = "eth_signTypedData_v2";
		    JSONRPCMethod["eth_signTypedData_v3"] = "eth_signTypedData_v3";
		    JSONRPCMethod["eth_signTypedData_v4"] = "eth_signTypedData_v4";
		    JSONRPCMethod["eth_signTypedData"] = "eth_signTypedData";
		    JSONRPCMethod["cbWallet_arbitrary"] = "walletlink_arbitrary";
		    JSONRPCMethod["wallet_addEthereumChain"] = "wallet_addEthereumChain";
		    JSONRPCMethod["wallet_switchEthereumChain"] = "wallet_switchEthereumChain";
		    JSONRPCMethod["wallet_watchAsset"] = "wallet_watchAsset";
		    // asynchronous pub/sub
		    JSONRPCMethod["eth_subscribe"] = "eth_subscribe";
		    JSONRPCMethod["eth_unsubscribe"] = "eth_unsubscribe";
		    // asynchronous filter methods
		    JSONRPCMethod["eth_newFilter"] = "eth_newFilter";
		    JSONRPCMethod["eth_newBlockFilter"] = "eth_newBlockFilter";
		    JSONRPCMethod["eth_newPendingTransactionFilter"] = "eth_newPendingTransactionFilter";
		    JSONRPCMethod["eth_getFilterChanges"] = "eth_getFilterChanges";
		    JSONRPCMethod["eth_getFilterLogs"] = "eth_getFilterLogs";
		})(exports.JSONRPCMethod || (exports.JSONRPCMethod = {})); 
	} (JSONRPC));

	var SubscriptionManager$1 = {};

	var dist$4 = {};

	var PollingBlockTracker$1 = {};

	var jsonRpcRandomId = IdIterator;

	function IdIterator(opts){
	  opts = opts || {};
	  var max = opts.max || Number.MAX_SAFE_INTEGER;
	  var idCounter = typeof opts.start !== 'undefined' ? opts.start : Math.floor(Math.random() * max);

	  return function createRandomId () {
	    idCounter = idCounter % max;
	    return idCounter++
	  }

	}

	const processFn$1 = (fn, opts) => function () {
		const P = opts.promiseModule;
		const args = new Array(arguments.length);

		for (let i = 0; i < arguments.length; i++) {
			args[i] = arguments[i];
		}

		return new P((resolve, reject) => {
			if (opts.errorFirst) {
				args.push(function (err, result) {
					if (opts.multiArgs) {
						const results = new Array(arguments.length - 1);

						for (let i = 1; i < arguments.length; i++) {
							results[i - 1] = arguments[i];
						}

						if (err) {
							results.unshift(err);
							reject(results);
						} else {
							resolve(results);
						}
					} else if (err) {
						reject(err);
					} else {
						resolve(result);
					}
				});
			} else {
				args.push(function (result) {
					if (opts.multiArgs) {
						const results = new Array(arguments.length - 1);

						for (let i = 0; i < arguments.length; i++) {
							results[i] = arguments[i];
						}

						resolve(results);
					} else {
						resolve(result);
					}
				});
			}

			fn.apply(this, args);
		});
	};

	var pify$2 = (obj, opts) => {
		opts = Object.assign({
			exclude: [/.+(Sync|Stream)$/],
			errorFirst: true,
			promiseModule: Promise
		}, opts);

		const filter = key => {
			const match = pattern => typeof pattern === 'string' ? key === pattern : pattern.test(key);
			return opts.include ? opts.include.some(match) : !opts.exclude.some(match);
		};

		let ret;
		if (typeof obj === 'function') {
			ret = function () {
				if (opts.excludeMain) {
					return obj.apply(this, arguments);
				}

				return processFn$1(obj, opts).apply(this, arguments);
			};
		} else {
			ret = Object.create(Object.getPrototypeOf(obj));
		}

		for (const key in obj) { // eslint-disable-line guard-for-in
			const x = obj[key];
			ret[key] = typeof x === 'function' && filter(key) ? processFn$1(x, opts) : x;
		}

		return ret;
	};

	var BaseBlockTracker$1 = {};

	var __importDefault$d = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(BaseBlockTracker$1, "__esModule", { value: true });
	BaseBlockTracker$1.BaseBlockTracker = void 0;
	const safe_event_emitter_1$2 = __importDefault$d(safeEventEmitter);
	const sec$1 = 1000;
	const calculateSum = (accumulator, currentValue) => accumulator + currentValue;
	const blockTrackerEvents = ['sync', 'latest'];
	class BaseBlockTracker extends safe_event_emitter_1$2.default {
	    constructor(opts) {
	        super();
	        // config
	        this._blockResetDuration = opts.blockResetDuration || 20 * sec$1;
	        // state
	        this._currentBlock = null;
	        this._isRunning = false;
	        // bind functions for internal use
	        this._onNewListener = this._onNewListener.bind(this);
	        this._onRemoveListener = this._onRemoveListener.bind(this);
	        this._resetCurrentBlock = this._resetCurrentBlock.bind(this);
	        // listen for handler changes
	        this._setupInternalEvents();
	    }
	    async destroy() {
	        this._cancelBlockResetTimeout();
	        await this._maybeEnd();
	        super.removeAllListeners();
	    }
	    isRunning() {
	        return this._isRunning;
	    }
	    getCurrentBlock() {
	        return this._currentBlock;
	    }
	    async getLatestBlock() {
	        // return if available
	        if (this._currentBlock) {
	            return this._currentBlock;
	        }
	        // wait for a new latest block
	        const latestBlock = await new Promise((resolve) => this.once('latest', resolve));
	        // return newly set current block
	        return latestBlock;
	    }
	    // dont allow module consumer to remove our internal event listeners
	    removeAllListeners(eventName) {
	        // perform default behavior, preserve fn arity
	        if (eventName) {
	            super.removeAllListeners(eventName);
	        }
	        else {
	            super.removeAllListeners();
	        }
	        // re-add internal events
	        this._setupInternalEvents();
	        // trigger stop check just in case
	        this._onRemoveListener();
	        return this;
	    }
	    _setupInternalEvents() {
	        // first remove listeners for idempotence
	        this.removeListener('newListener', this._onNewListener);
	        this.removeListener('removeListener', this._onRemoveListener);
	        // then add them
	        this.on('newListener', this._onNewListener);
	        this.on('removeListener', this._onRemoveListener);
	    }
	    _onNewListener(eventName) {
	        // `newListener` is called *before* the listener is added
	        if (blockTrackerEvents.includes(eventName)) {
	            this._maybeStart();
	        }
	    }
	    _onRemoveListener() {
	        // `removeListener` is called *after* the listener is removed
	        if (this._getBlockTrackerEventCount() > 0) {
	            return;
	        }
	        this._maybeEnd();
	    }
	    async _maybeStart() {
	        if (this._isRunning) {
	            return;
	        }
	        this._isRunning = true;
	        // cancel setting latest block to stale
	        this._cancelBlockResetTimeout();
	        await this._start();
	        this.emit('_started');
	    }
	    async _maybeEnd() {
	        if (!this._isRunning) {
	            return;
	        }
	        this._isRunning = false;
	        this._setupBlockResetTimeout();
	        await this._end();
	        this.emit('_ended');
	    }
	    _getBlockTrackerEventCount() {
	        return blockTrackerEvents
	            .map((eventName) => this.listenerCount(eventName))
	            .reduce(calculateSum);
	    }
	    _newPotentialLatest(newBlock) {
	        const currentBlock = this._currentBlock;
	        // only update if blok number is higher
	        if (currentBlock && hexToInt$4(newBlock) <= hexToInt$4(currentBlock)) {
	            return;
	        }
	        this._setCurrentBlock(newBlock);
	    }
	    _setCurrentBlock(newBlock) {
	        const oldBlock = this._currentBlock;
	        this._currentBlock = newBlock;
	        this.emit('latest', newBlock);
	        this.emit('sync', { oldBlock, newBlock });
	    }
	    _setupBlockResetTimeout() {
	        // clear any existing timeout
	        this._cancelBlockResetTimeout();
	        // clear latest block when stale
	        this._blockResetTimeout = setTimeout(this._resetCurrentBlock, this._blockResetDuration);
	        // nodejs - dont hold process open
	        if (this._blockResetTimeout.unref) {
	            this._blockResetTimeout.unref();
	        }
	    }
	    _cancelBlockResetTimeout() {
	        if (this._blockResetTimeout) {
	            clearTimeout(this._blockResetTimeout);
	        }
	    }
	    _resetCurrentBlock() {
	        this._currentBlock = null;
	    }
	}
	BaseBlockTracker$1.BaseBlockTracker = BaseBlockTracker;
	/**
	 * Converts a number represented as a string in hexadecimal format into a native
	 * number.
	 *
	 * @param hexInt - The hex string.
	 * @returns The number.
	 */
	function hexToInt$4(hexInt) {
	    return Number.parseInt(hexInt, 16);
	}

	var loggingUtils = {};

	var dist$3 = {};

	var assert$2 = {};

	/**
	 * A `StructFailure` represents a single specific failure in validation.
	 */
	/**
	 * `StructError` objects are thrown (or returned) when validation fails.
	 *
	 * Validation logic is design to exit early for maximum performance. The error
	 * represents the first error encountered during validation. For more detail,
	 * the `error.failures` property is a generator function that can be run to
	 * continue validation and receive all the failures in the data.
	 */
	class StructError extends TypeError {
	    constructor(failure, failures) {
	        let cached;
	        const { message, explanation, ...rest } = failure;
	        const { path } = failure;
	        const msg = path.length === 0 ? message : `At path: ${path.join('.')} -- ${message}`;
	        super(explanation ?? msg);
	        if (explanation != null)
	            this.cause = msg;
	        Object.assign(this, rest);
	        this.name = this.constructor.name;
	        this.failures = () => {
	            return (cached ?? (cached = [failure, ...failures()]));
	        };
	    }
	}

	/**
	 * Check if a value is an iterator.
	 */
	function isIterable$1(x) {
	    return isObject$2(x) && typeof x[Symbol.iterator] === 'function';
	}
	/**
	 * Check if a value is a plain object.
	 */
	function isObject$2(x) {
	    return typeof x === 'object' && x != null;
	}
	/**
	 * Check if a value is a plain object.
	 */
	function isPlainObject(x) {
	    if (Object.prototype.toString.call(x) !== '[object Object]') {
	        return false;
	    }
	    const prototype = Object.getPrototypeOf(x);
	    return prototype === null || prototype === Object.prototype;
	}
	/**
	 * Return a value as a printable string.
	 */
	function print(value) {
	    if (typeof value === 'symbol') {
	        return value.toString();
	    }
	    return typeof value === 'string' ? JSON.stringify(value) : `${value}`;
	}
	/**
	 * Shifts (removes and returns) the first value from the `input` iterator.
	 * Like `Array.prototype.shift()` but for an `Iterator`.
	 */
	function shiftIterator(input) {
	    const { done, value } = input.next();
	    return done ? undefined : value;
	}
	/**
	 * Convert a single validation result to a failure.
	 */
	function toFailure(result, context, struct, value) {
	    if (result === true) {
	        return;
	    }
	    else if (result === false) {
	        result = {};
	    }
	    else if (typeof result === 'string') {
	        result = { message: result };
	    }
	    const { path, branch } = context;
	    const { type } = struct;
	    const { refinement, message = `Expected a value of type \`${type}\`${refinement ? ` with refinement \`${refinement}\`` : ''}, but received: \`${print(value)}\``, } = result;
	    return {
	        value,
	        type,
	        refinement,
	        key: path[path.length - 1],
	        path,
	        branch,
	        ...result,
	        message,
	    };
	}
	/**
	 * Convert a validation result to an iterable of failures.
	 */
	function* toFailures(result, context, struct, value) {
	    if (!isIterable$1(result)) {
	        result = [result];
	    }
	    for (const r of result) {
	        const failure = toFailure(r, context, struct, value);
	        if (failure) {
	            yield failure;
	        }
	    }
	}
	/**
	 * Check a value against a struct, traversing deeply into nested values, and
	 * returning an iterator of failures or success.
	 */
	function* run(value, struct, options = {}) {
	    const { path = [], branch = [value], coerce = false, mask = false } = options;
	    const ctx = { path, branch };
	    if (coerce) {
	        value = struct.coercer(value, ctx);
	        if (mask &&
	            struct.type !== 'type' &&
	            isObject$2(struct.schema) &&
	            isObject$2(value) &&
	            !Array.isArray(value)) {
	            for (const key in value) {
	                if (struct.schema[key] === undefined) {
	                    delete value[key];
	                }
	            }
	        }
	    }
	    let status = 'valid';
	    for (const failure of struct.validator(value, ctx)) {
	        failure.explanation = options.message;
	        status = 'not_valid';
	        yield [failure, undefined];
	    }
	    for (let [k, v, s] of struct.entries(value, ctx)) {
	        const ts = run(v, s, {
	            path: k === undefined ? path : [...path, k],
	            branch: k === undefined ? branch : [...branch, v],
	            coerce,
	            mask,
	            message: options.message,
	        });
	        for (const t of ts) {
	            if (t[0]) {
	                status = t[0].refinement != null ? 'not_refined' : 'not_valid';
	                yield [t[0], undefined];
	            }
	            else if (coerce) {
	                v = t[1];
	                if (k === undefined) {
	                    value = v;
	                }
	                else if (value instanceof Map) {
	                    value.set(k, v);
	                }
	                else if (value instanceof Set) {
	                    value.add(v);
	                }
	                else if (isObject$2(value)) {
	                    if (v !== undefined || k in value)
	                        value[k] = v;
	                }
	            }
	        }
	    }
	    if (status !== 'not_valid') {
	        for (const failure of struct.refiner(value, ctx)) {
	            failure.explanation = options.message;
	            status = 'not_refined';
	            yield [failure, undefined];
	        }
	    }
	    if (status === 'valid') {
	        yield [undefined, value];
	    }
	}

	/**
	 * `Struct` objects encapsulate the validation logic for a specific type of
	 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
	 * validate unknown input data against the struct.
	 */
	class Struct {
	    constructor(props) {
	        const { type, schema, validator, refiner, coercer = (value) => value, entries = function* () { }, } = props;
	        this.type = type;
	        this.schema = schema;
	        this.entries = entries;
	        this.coercer = coercer;
	        if (validator) {
	            this.validator = (value, context) => {
	                const result = validator(value, context);
	                return toFailures(result, context, this, value);
	            };
	        }
	        else {
	            this.validator = () => [];
	        }
	        if (refiner) {
	            this.refiner = (value, context) => {
	                const result = refiner(value, context);
	                return toFailures(result, context, this, value);
	            };
	        }
	        else {
	            this.refiner = () => [];
	        }
	    }
	    /**
	     * Assert that a value passes the struct's validation, throwing if it doesn't.
	     */
	    assert(value, message) {
	        return assert$1(value, this, message);
	    }
	    /**
	     * Create a value with the struct's coercion logic, then validate it.
	     */
	    create(value, message) {
	        return create(value, this, message);
	    }
	    /**
	     * Check if a value passes the struct's validation.
	     */
	    is(value) {
	        return is$2(value, this);
	    }
	    /**
	     * Mask a value, coercing and validating it, but returning only the subset of
	     * properties defined by the struct's schema.
	     */
	    mask(value, message) {
	        return mask(value, this, message);
	    }
	    /**
	     * Validate a value with the struct's validation logic, returning a tuple
	     * representing the result.
	     *
	     * You may optionally pass `true` for the `withCoercion` argument to coerce
	     * the value before attempting to validate it. If you do, the result will
	     * contain the coerced result when successful.
	     */
	    validate(value, options = {}) {
	        return validate(value, this, options);
	    }
	}
	/**
	 * Assert that a value passes a struct, throwing if it doesn't.
	 */
	function assert$1(value, struct, message) {
	    const result = validate(value, struct, { message });
	    if (result[0]) {
	        throw result[0];
	    }
	}
	/**
	 * Create a value with the coercion logic of struct and validate it.
	 */
	function create(value, struct, message) {
	    const result = validate(value, struct, { coerce: true, message });
	    if (result[0]) {
	        throw result[0];
	    }
	    else {
	        return result[1];
	    }
	}
	/**
	 * Mask a value, returning only the subset of properties defined by a struct.
	 */
	function mask(value, struct, message) {
	    const result = validate(value, struct, { coerce: true, mask: true, message });
	    if (result[0]) {
	        throw result[0];
	    }
	    else {
	        return result[1];
	    }
	}
	/**
	 * Check if a value passes a struct.
	 */
	function is$2(value, struct) {
	    const result = validate(value, struct);
	    return !result[0];
	}
	/**
	 * Validate a value against a struct, returning an error if invalid, or the
	 * value (with potential coercion) if valid.
	 */
	function validate(value, struct, options = {}) {
	    const tuples = run(value, struct, options);
	    const tuple = shiftIterator(tuples);
	    if (tuple[0]) {
	        const error = new StructError(tuple[0], function* () {
	            for (const t of tuples) {
	                if (t[0]) {
	                    yield t[0];
	                }
	            }
	        });
	        return [error, undefined];
	    }
	    else {
	        const v = tuple[1];
	        return [undefined, v];
	    }
	}

	function assign(...Structs) {
	    const isType = Structs[0].type === 'type';
	    const schemas = Structs.map((s) => s.schema);
	    const schema = Object.assign({}, ...schemas);
	    return isType ? type(schema) : object(schema);
	}
	/**
	 * Define a new struct type with a custom validation function.
	 */
	function define$1(name, validator) {
	    return new Struct({ type: name, schema: null, validator });
	}
	/**
	 * Create a new struct based on an existing struct, but the value is allowed to
	 * be `undefined`. `log` will be called if the value is not `undefined`.
	 */
	function deprecated(struct, log) {
	    return new Struct({
	        ...struct,
	        refiner: (value, ctx) => value === undefined || struct.refiner(value, ctx),
	        validator(value, ctx) {
	            if (value === undefined) {
	                return true;
	            }
	            else {
	                log(value, ctx);
	                return struct.validator(value, ctx);
	            }
	        },
	    });
	}
	/**
	 * Create a struct with dynamic validation logic.
	 *
	 * The callback will receive the value currently being validated, and must
	 * return a struct object to validate it with. This can be useful to model
	 * validation logic that changes based on its input.
	 */
	function dynamic(fn) {
	    return new Struct({
	        type: 'dynamic',
	        schema: null,
	        *entries(value, ctx) {
	            const struct = fn(value, ctx);
	            yield* struct.entries(value, ctx);
	        },
	        validator(value, ctx) {
	            const struct = fn(value, ctx);
	            return struct.validator(value, ctx);
	        },
	        coercer(value, ctx) {
	            const struct = fn(value, ctx);
	            return struct.coercer(value, ctx);
	        },
	        refiner(value, ctx) {
	            const struct = fn(value, ctx);
	            return struct.refiner(value, ctx);
	        },
	    });
	}
	/**
	 * Create a struct with lazily evaluated validation logic.
	 *
	 * The first time validation is run with the struct, the callback will be called
	 * and must return a struct object to use. This is useful for cases where you
	 * want to have self-referential structs for nested data structures to avoid a
	 * circular definition problem.
	 */
	function lazy(fn) {
	    let struct;
	    return new Struct({
	        type: 'lazy',
	        schema: null,
	        *entries(value, ctx) {
	            struct ?? (struct = fn());
	            yield* struct.entries(value, ctx);
	        },
	        validator(value, ctx) {
	            struct ?? (struct = fn());
	            return struct.validator(value, ctx);
	        },
	        coercer(value, ctx) {
	            struct ?? (struct = fn());
	            return struct.coercer(value, ctx);
	        },
	        refiner(value, ctx) {
	            struct ?? (struct = fn());
	            return struct.refiner(value, ctx);
	        },
	    });
	}
	/**
	 * Create a new struct based on an existing object struct, but excluding
	 * specific properties.
	 *
	 * Like TypeScript's `Omit` utility.
	 */
	function omit(struct, keys) {
	    const { schema } = struct;
	    const subschema = { ...schema };
	    for (const key of keys) {
	        delete subschema[key];
	    }
	    switch (struct.type) {
	        case 'type':
	            return type(subschema);
	        default:
	            return object(subschema);
	    }
	}
	/**
	 * Create a new struct based on an existing object struct, but with all of its
	 * properties allowed to be `undefined`.
	 *
	 * Like TypeScript's `Partial` utility.
	 */
	function partial(struct) {
	    const schema = struct instanceof Struct ? { ...struct.schema } : { ...struct };
	    for (const key in schema) {
	        schema[key] = optional(schema[key]);
	    }
	    return object(schema);
	}
	/**
	 * Create a new struct based on an existing object struct, but only including
	 * specific properties.
	 *
	 * Like TypeScript's `Pick` utility.
	 */
	function pick(struct, keys) {
	    const { schema } = struct;
	    const subschema = {};
	    for (const key of keys) {
	        subschema[key] = schema[key];
	    }
	    return object(subschema);
	}
	/**
	 * Define a new struct type with a custom validation function.
	 *
	 * @deprecated This function has been renamed to `define`.
	 */
	function struct(name, validator) {
	    console.warn('superstruct@0.11 - The `struct` helper has been renamed to `define`.');
	    return define$1(name, validator);
	}

	/**
	 * Ensure that any value passes validation.
	 */
	function any() {
	    return define$1('any', () => true);
	}
	function array(Element) {
	    return new Struct({
	        type: 'array',
	        schema: Element,
	        *entries(value) {
	            if (Element && Array.isArray(value)) {
	                for (const [i, v] of value.entries()) {
	                    yield [i, v, Element];
	                }
	            }
	        },
	        coercer(value) {
	            return Array.isArray(value) ? value.slice() : value;
	        },
	        validator(value) {
	            return (Array.isArray(value) ||
	                `Expected an array value, but received: ${print(value)}`);
	        },
	    });
	}
	/**
	 * Ensure that a value is a bigint.
	 */
	function bigint() {
	    return define$1('bigint', (value) => {
	        return typeof value === 'bigint';
	    });
	}
	/**
	 * Ensure that a value is a boolean.
	 */
	function boolean() {
	    return define$1('boolean', (value) => {
	        return typeof value === 'boolean';
	    });
	}
	/**
	 * Ensure that a value is a valid `Date`.
	 *
	 * Note: this also ensures that the value is *not* an invalid `Date` object,
	 * which can occur when parsing a date fails but still returns a `Date`.
	 */
	function date() {
	    return define$1('date', (value) => {
	        return ((value instanceof Date && !isNaN(value.getTime())) ||
	            `Expected a valid \`Date\` object, but received: ${print(value)}`);
	    });
	}
	function enums(values) {
	    const schema = {};
	    const description = values.map((v) => print(v)).join();
	    for (const key of values) {
	        schema[key] = key;
	    }
	    return new Struct({
	        type: 'enums',
	        schema,
	        validator(value) {
	            return (values.includes(value) ||
	                `Expected one of \`${description}\`, but received: ${print(value)}`);
	        },
	    });
	}
	/**
	 * Ensure that a value is a function.
	 */
	function func() {
	    return define$1('func', (value) => {
	        return (typeof value === 'function' ||
	            `Expected a function, but received: ${print(value)}`);
	    });
	}
	/**
	 * Ensure that a value is an instance of a specific class.
	 */
	function instance(Class) {
	    return define$1('instance', (value) => {
	        return (value instanceof Class ||
	            `Expected a \`${Class.name}\` instance, but received: ${print(value)}`);
	    });
	}
	/**
	 * Ensure that a value is an integer.
	 */
	function integer() {
	    return define$1('integer', (value) => {
	        return ((typeof value === 'number' && !isNaN(value) && Number.isInteger(value)) ||
	            `Expected an integer, but received: ${print(value)}`);
	    });
	}
	/**
	 * Ensure that a value matches all of a set of types.
	 */
	function intersection(Structs) {
	    return new Struct({
	        type: 'intersection',
	        schema: null,
	        *entries(value, ctx) {
	            for (const S of Structs) {
	                yield* S.entries(value, ctx);
	            }
	        },
	        *validator(value, ctx) {
	            for (const S of Structs) {
	                yield* S.validator(value, ctx);
	            }
	        },
	        *refiner(value, ctx) {
	            for (const S of Structs) {
	                yield* S.refiner(value, ctx);
	            }
	        },
	    });
	}
	function literal(constant) {
	    const description = print(constant);
	    const t = typeof constant;
	    return new Struct({
	        type: 'literal',
	        schema: t === 'string' || t === 'number' || t === 'boolean' ? constant : null,
	        validator(value) {
	            return (value === constant ||
	                `Expected the literal \`${description}\`, but received: ${print(value)}`);
	        },
	    });
	}
	function map$1(Key, Value) {
	    return new Struct({
	        type: 'map',
	        schema: null,
	        *entries(value) {
	            if (Key && Value && value instanceof Map) {
	                for (const [k, v] of value.entries()) {
	                    yield [k, k, Key];
	                    yield [k, v, Value];
	                }
	            }
	        },
	        coercer(value) {
	            return value instanceof Map ? new Map(value) : value;
	        },
	        validator(value) {
	            return (value instanceof Map ||
	                `Expected a \`Map\` object, but received: ${print(value)}`);
	        },
	    });
	}
	/**
	 * Ensure that no value ever passes validation.
	 */
	function never$1() {
	    return define$1('never', () => false);
	}
	/**
	 * Augment an existing struct to allow `null` values.
	 */
	function nullable(struct) {
	    return new Struct({
	        ...struct,
	        validator: (value, ctx) => value === null || struct.validator(value, ctx),
	        refiner: (value, ctx) => value === null || struct.refiner(value, ctx),
	    });
	}
	/**
	 * Ensure that a value is a number.
	 */
	function number$1() {
	    return define$1('number', (value) => {
	        return ((typeof value === 'number' && !isNaN(value)) ||
	            `Expected a number, but received: ${print(value)}`);
	    });
	}
	function object(schema) {
	    const knowns = schema ? Object.keys(schema) : [];
	    const Never = never$1();
	    return new Struct({
	        type: 'object',
	        schema: schema ? schema : null,
	        *entries(value) {
	            if (schema && isObject$2(value)) {
	                const unknowns = new Set(Object.keys(value));
	                for (const key of knowns) {
	                    unknowns.delete(key);
	                    yield [key, value[key], schema[key]];
	                }
	                for (const key of unknowns) {
	                    yield [key, value[key], Never];
	                }
	            }
	        },
	        validator(value) {
	            return (isObject$2(value) || `Expected an object, but received: ${print(value)}`);
	        },
	        coercer(value) {
	            return isObject$2(value) ? { ...value } : value;
	        },
	    });
	}
	/**
	 * Augment a struct to allow `undefined` values.
	 */
	function optional(struct) {
	    return new Struct({
	        ...struct,
	        validator: (value, ctx) => value === undefined || struct.validator(value, ctx),
	        refiner: (value, ctx) => value === undefined || struct.refiner(value, ctx),
	    });
	}
	/**
	 * Ensure that a value is an object with keys and values of specific types, but
	 * without ensuring any specific shape of properties.
	 *
	 * Like TypeScript's `Record` utility.
	 */
	function record(Key, Value) {
	    return new Struct({
	        type: 'record',
	        schema: null,
	        *entries(value) {
	            if (isObject$2(value)) {
	                for (const k in value) {
	                    const v = value[k];
	                    yield [k, k, Key];
	                    yield [k, v, Value];
	                }
	            }
	        },
	        validator(value) {
	            return (isObject$2(value) || `Expected an object, but received: ${print(value)}`);
	        },
	    });
	}
	/**
	 * Ensure that a value is a `RegExp`.
	 *
	 * Note: this does not test the value against the regular expression! For that
	 * you need to use the `pattern()` refinement.
	 */
	function regexp() {
	    return define$1('regexp', (value) => {
	        return value instanceof RegExp;
	    });
	}
	function set(Element) {
	    return new Struct({
	        type: 'set',
	        schema: null,
	        *entries(value) {
	            if (Element && value instanceof Set) {
	                for (const v of value) {
	                    yield [v, v, Element];
	                }
	            }
	        },
	        coercer(value) {
	            return value instanceof Set ? new Set(value) : value;
	        },
	        validator(value) {
	            return (value instanceof Set ||
	                `Expected a \`Set\` object, but received: ${print(value)}`);
	        },
	    });
	}
	/**
	 * Ensure that a value is a string.
	 */
	function string() {
	    return define$1('string', (value) => {
	        return (typeof value === 'string' ||
	            `Expected a string, but received: ${print(value)}`);
	    });
	}
	/**
	 * Ensure that a value is a tuple of a specific length, and that each of its
	 * elements is of a specific type.
	 */
	function tuple(Structs) {
	    const Never = never$1();
	    return new Struct({
	        type: 'tuple',
	        schema: null,
	        *entries(value) {
	            if (Array.isArray(value)) {
	                const length = Math.max(Structs.length, value.length);
	                for (let i = 0; i < length; i++) {
	                    yield [i, value[i], Structs[i] || Never];
	                }
	            }
	        },
	        validator(value) {
	            return (Array.isArray(value) ||
	                `Expected an array, but received: ${print(value)}`);
	        },
	    });
	}
	/**
	 * Ensure that a value has a set of known properties of specific types.
	 *
	 * Note: Unrecognized properties are allowed and untouched. This is similar to
	 * how TypeScript's structural typing works.
	 */
	function type(schema) {
	    const keys = Object.keys(schema);
	    return new Struct({
	        type: 'type',
	        schema,
	        *entries(value) {
	            if (isObject$2(value)) {
	                for (const k of keys) {
	                    yield [k, value[k], schema[k]];
	                }
	            }
	        },
	        validator(value) {
	            return (isObject$2(value) || `Expected an object, but received: ${print(value)}`);
	        },
	        coercer(value) {
	            return isObject$2(value) ? { ...value } : value;
	        },
	    });
	}
	/**
	 * Ensure that a value matches one of a set of types.
	 */
	function union(Structs) {
	    const description = Structs.map((s) => s.type).join(' | ');
	    return new Struct({
	        type: 'union',
	        schema: null,
	        coercer(value) {
	            for (const S of Structs) {
	                const [error, coerced] = S.validate(value, { coerce: true });
	                if (!error) {
	                    return coerced;
	                }
	            }
	            return value;
	        },
	        validator(value, ctx) {
	            const failures = [];
	            for (const S of Structs) {
	                const [...tuples] = run(value, S, ctx);
	                const [first] = tuples;
	                if (!first[0]) {
	                    return [];
	                }
	                else {
	                    for (const [failure] of tuples) {
	                        if (failure) {
	                            failures.push(failure);
	                        }
	                    }
	                }
	            }
	            return [
	                `Expected the value to satisfy a union of \`${description}\`, but received: ${print(value)}`,
	                ...failures,
	            ];
	        },
	    });
	}
	/**
	 * Ensure that any value passes validation, without widening its type to `any`.
	 */
	function unknown() {
	    return define$1('unknown', () => true);
	}

	/**
	 * Augment a `Struct` to add an additional coercion step to its input.
	 *
	 * This allows you to transform input data before validating it, to increase the
	 * likelihood that it passes validation—for example for default values, parsing
	 * different formats, etc.
	 *
	 * Note: You must use `create(value, Struct)` on the value to have the coercion
	 * take effect! Using simply `assert()` or `is()` will not use coercion.
	 */
	function coerce$2(struct, condition, coercer) {
	    return new Struct({
	        ...struct,
	        coercer: (value, ctx) => {
	            return is$2(value, condition)
	                ? struct.coercer(coercer(value, ctx), ctx)
	                : struct.coercer(value, ctx);
	        },
	    });
	}
	/**
	 * Augment a struct to replace `undefined` values with a default.
	 *
	 * Note: You must use `create(value, Struct)` on the value to have the coercion
	 * take effect! Using simply `assert()` or `is()` will not use coercion.
	 */
	function defaulted(struct, fallback, options = {}) {
	    return coerce$2(struct, unknown(), (x) => {
	        const f = typeof fallback === 'function' ? fallback() : fallback;
	        if (x === undefined) {
	            return f;
	        }
	        if (!options.strict && isPlainObject(x) && isPlainObject(f)) {
	            const ret = { ...x };
	            let changed = false;
	            for (const key in f) {
	                if (ret[key] === undefined) {
	                    ret[key] = f[key];
	                    changed = true;
	                }
	            }
	            if (changed) {
	                return ret;
	            }
	        }
	        return x;
	    });
	}
	/**
	 * Augment a struct to trim string inputs.
	 *
	 * Note: You must use `create(value, Struct)` on the value to have the coercion
	 * take effect! Using simply `assert()` or `is()` will not use coercion.
	 */
	function trimmed(struct) {
	    return coerce$2(struct, string(), (x) => x.trim());
	}

	/**
	 * Ensure that a string, array, map, or set is empty.
	 */
	function empty$2(struct) {
	    return refine(struct, 'empty', (value) => {
	        const size = getSize(value);
	        return (size === 0 ||
	            `Expected an empty ${struct.type} but received one with a size of \`${size}\``);
	    });
	}
	function getSize(value) {
	    if (value instanceof Map || value instanceof Set) {
	        return value.size;
	    }
	    else {
	        return value.length;
	    }
	}
	/**
	 * Ensure that a number or date is below a threshold.
	 */
	function max$1(struct, threshold, options = {}) {
	    const { exclusive } = options;
	    return refine(struct, 'max', (value) => {
	        return exclusive
	            ? value < threshold
	            : value <= threshold ||
	                `Expected a ${struct.type} less than ${exclusive ? '' : 'or equal to '}${threshold} but received \`${value}\``;
	    });
	}
	/**
	 * Ensure that a number or date is above a threshold.
	 */
	function min$1(struct, threshold, options = {}) {
	    const { exclusive } = options;
	    return refine(struct, 'min', (value) => {
	        return exclusive
	            ? value > threshold
	            : value >= threshold ||
	                `Expected a ${struct.type} greater than ${exclusive ? '' : 'or equal to '}${threshold} but received \`${value}\``;
	    });
	}
	/**
	 * Ensure that a string, array, map or set is not empty.
	 */
	function nonempty(struct) {
	    return refine(struct, 'nonempty', (value) => {
	        const size = getSize(value);
	        return (size > 0 || `Expected a nonempty ${struct.type} but received an empty one`);
	    });
	}
	/**
	 * Ensure that a string matches a regular expression.
	 */
	function pattern(struct, regexp) {
	    return refine(struct, 'pattern', (value) => {
	        return (regexp.test(value) ||
	            `Expected a ${struct.type} matching \`/${regexp.source}/\` but received "${value}"`);
	    });
	}
	/**
	 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
	 */
	function size(struct, min, max = min) {
	    const expected = `Expected a ${struct.type}`;
	    const of = min === max ? `of \`${min}\`` : `between \`${min}\` and \`${max}\``;
	    return refine(struct, 'size', (value) => {
	        if (typeof value === 'number' || value instanceof Date) {
	            return ((min <= value && value <= max) ||
	                `${expected} ${of} but received \`${value}\``);
	        }
	        else if (value instanceof Map || value instanceof Set) {
	            const { size } = value;
	            return ((min <= size && size <= max) ||
	                `${expected} with a size ${of} but received one with a size of \`${size}\``);
	        }
	        else {
	            const { length } = value;
	            return ((min <= length && length <= max) ||
	                `${expected} with a length ${of} but received one with a length of \`${length}\``);
	        }
	    });
	}
	/**
	 * Augment a `Struct` to add an additional refinement to the validation.
	 *
	 * The refiner function is guaranteed to receive a value of the struct's type,
	 * because the struct's existing validation will already have passed. This
	 * allows you to layer additional validation on top of existing structs.
	 */
	function refine(struct, name, refiner) {
	    return new Struct({
	        ...struct,
	        *refiner(value, ctx) {
	            yield* struct.refiner(value, ctx);
	            const result = refiner(value, ctx);
	            const failures = toFailures(result, ctx, struct, value);
	            for (const failure of failures) {
	                yield { ...failure, refinement: name };
	            }
	        },
	    });
	}

	var dist$2 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		Struct: Struct,
		StructError: StructError,
		any: any,
		array: array,
		assert: assert$1,
		assign: assign,
		bigint: bigint,
		boolean: boolean,
		coerce: coerce$2,
		create: create,
		date: date,
		defaulted: defaulted,
		define: define$1,
		deprecated: deprecated,
		dynamic: dynamic,
		empty: empty$2,
		enums: enums,
		func: func,
		instance: instance,
		integer: integer,
		intersection: intersection,
		is: is$2,
		lazy: lazy,
		literal: literal,
		map: map$1,
		mask: mask,
		max: max$1,
		min: min$1,
		never: never$1,
		nonempty: nonempty,
		nullable: nullable,
		number: number$1,
		object: object,
		omit: omit,
		optional: optional,
		partial: partial,
		pattern: pattern,
		pick: pick,
		record: record,
		refine: refine,
		regexp: regexp,
		set: set,
		size: size,
		string: string,
		struct: struct,
		trimmed: trimmed,
		tuple: tuple,
		type: type,
		union: union,
		unknown: unknown,
		validate: validate
	});

	var require$$1$2 = /*@__PURE__*/getAugmentedNamespace(dist$2);

	Object.defineProperty(assert$2, "__esModule", { value: true });
	assert$2.assertExhaustive = assert$2.assertStruct = assert$2.assert = assert$2.AssertionError = void 0;
	const superstruct_1$3 = require$$1$2;
	/**
	 * Type guard for determining whether the given value is an error object with a
	 * `message` property, such as an instance of Error.
	 *
	 * @param error - The object to check.
	 * @returns True or false, depending on the result.
	 */
	function isErrorWithMessage(error) {
	    return typeof error === 'object' && error !== null && 'message' in error;
	}
	/**
	 * Check if a value is a constructor, i.e., a function that can be called with
	 * the `new` keyword.
	 *
	 * @param fn - The value to check.
	 * @returns `true` if the value is a constructor, or `false` otherwise.
	 */
	function isConstructable(fn) {
	    var _a, _b;
	    /* istanbul ignore next */
	    return Boolean(typeof ((_b = (_a = fn === null || fn === void 0 ? void 0 : fn.prototype) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name) === 'string');
	}
	/**
	 * Get the error message from an unknown error object. If the error object has
	 * a `message` property, that property is returned. Otherwise, the stringified
	 * error object is returned.
	 *
	 * @param error - The error object to get the message from.
	 * @returns The error message.
	 */
	function getErrorMessage(error) {
	    const message = isErrorWithMessage(error) ? error.message : String(error);
	    // If the error ends with a period, remove it, as we'll add our own period.
	    if (message.endsWith('.')) {
	        return message.slice(0, -1);
	    }
	    return message;
	}
	/**
	 * Initialise an {@link AssertionErrorConstructor} error.
	 *
	 * @param ErrorWrapper - The error class to use.
	 * @param message - The error message.
	 * @returns The error object.
	 */
	// eslint-disable-next-line @typescript-eslint/naming-convention
	function getError$1(ErrorWrapper, message) {
	    if (isConstructable(ErrorWrapper)) {
	        return new ErrorWrapper({
	            message,
	        });
	    }
	    return ErrorWrapper({
	        message,
	    });
	}
	/**
	 * The default error class that is thrown if an assertion fails.
	 */
	class AssertionError extends Error {
	    constructor(options) {
	        super(options.message);
	        this.code = 'ERR_ASSERTION';
	    }
	}
	assert$2.AssertionError = AssertionError;
	/**
	 * Same as Node.js assert.
	 * If the value is falsy, throws an error, does nothing otherwise.
	 *
	 * @throws {@link AssertionError} If value is falsy.
	 * @param value - The test that should be truthy to pass.
	 * @param message - Message to be passed to {@link AssertionError} or an
	 * {@link Error} instance to throw.
	 * @param ErrorWrapper - The error class to throw if the assertion fails.
	 * Defaults to {@link AssertionError}. If a custom error class is provided for
	 * the `message` argument, this argument is ignored.
	 */
	function assert(value, message = 'Assertion failed.', 
	// eslint-disable-next-line @typescript-eslint/naming-convention
	ErrorWrapper = AssertionError) {
	    if (!value) {
	        if (message instanceof Error) {
	            throw message;
	        }
	        throw getError$1(ErrorWrapper, message);
	    }
	}
	assert$2.assert = assert;
	/**
	 * Assert a value against a Superstruct struct.
	 *
	 * @param value - The value to validate.
	 * @param struct - The struct to validate against.
	 * @param errorPrefix - A prefix to add to the error message. Defaults to
	 * "Assertion failed".
	 * @param ErrorWrapper - The error class to throw if the assertion fails.
	 * Defaults to {@link AssertionError}.
	 * @throws If the value is not valid.
	 */
	function assertStruct(value, struct, errorPrefix = 'Assertion failed', 
	// eslint-disable-next-line @typescript-eslint/naming-convention
	ErrorWrapper = AssertionError) {
	    try {
	        (0, superstruct_1$3.assert)(value, struct);
	    }
	    catch (error) {
	        throw getError$1(ErrorWrapper, `${errorPrefix}: ${getErrorMessage(error)}.`);
	    }
	}
	assert$2.assertStruct = assertStruct;
	/**
	 * Use in the default case of a switch that you want to be fully exhaustive.
	 * Using this function forces the compiler to enforce exhaustivity during
	 * compile-time.
	 *
	 * @example
	 * ```
	 * const number = 1;
	 * switch (number) {
	 *   case 0:
	 *     ...
	 *   case 1:
	 *     ...
	 *   default:
	 *     assertExhaustive(snapPrefix);
	 * }
	 * ```
	 * @param _object - The object on which the switch is being operated.
	 */
	function assertExhaustive(_object) {
	    throw new Error('Invalid branch reached. Should be detected during compilation.');
	}
	assert$2.assertExhaustive = assertExhaustive;

	var base64$1 = {};

	Object.defineProperty(base64$1, "__esModule", { value: true });
	base64$1.base64 = void 0;
	const superstruct_1$2 = require$$1$2;
	const assert_1$3 = assert$2;
	/**
	 * Ensure that a provided string-based struct is valid base64.
	 *
	 * @param struct - The string based struct.
	 * @param options - Optional options to specialize base64 validation. See {@link Base64Options} documentation.
	 * @returns A superstruct validating base64.
	 */
	const base64 = (struct, options = {}) => {
	    var _a, _b;
	    const paddingRequired = (_a = options.paddingRequired) !== null && _a !== void 0 ? _a : false;
	    const characterSet = (_b = options.characterSet) !== null && _b !== void 0 ? _b : 'base64';
	    let letters;
	    if (characterSet === 'base64') {
	        letters = String.raw `[A-Za-z0-9+\/]`;
	    }
	    else {
	        (0, assert_1$3.assert)(characterSet === 'base64url');
	        letters = String.raw `[-_A-Za-z0-9]`;
	    }
	    let re;
	    if (paddingRequired) {
	        re = new RegExp(`^(?:${letters}{4})*(?:${letters}{3}=|${letters}{2}==)?$`, 'u');
	    }
	    else {
	        re = new RegExp(`^(?:${letters}{4})*(?:${letters}{2,3}|${letters}{3}=|${letters}{2}==)?$`, 'u');
	    }
	    return (0, superstruct_1$2.pattern)(struct, re);
	};
	base64$1.base64 = base64;

	var bytes = {};

	var hex = {};

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.remove0x = exports.add0x = exports.assertIsStrictHexString = exports.assertIsHexString = exports.isStrictHexString = exports.isHexString = exports.StrictHexStruct = exports.HexStruct = void 0;
		const superstruct_1 = require$$1$2;
		const assert_1 = assert$2;
		exports.HexStruct = (0, superstruct_1.pattern)((0, superstruct_1.string)(), /^(?:0x)?[0-9a-f]+$/iu);
		exports.StrictHexStruct = (0, superstruct_1.pattern)((0, superstruct_1.string)(), /^0x[0-9a-f]+$/iu);
		/**
		 * Check if a string is a valid hex string.
		 *
		 * @param value - The value to check.
		 * @returns Whether the value is a valid hex string.
		 */
		function isHexString(value) {
		    return (0, superstruct_1.is)(value, exports.HexStruct);
		}
		exports.isHexString = isHexString;
		/**
		 * Strictly check if a string is a valid hex string. A valid hex string must
		 * start with the "0x"-prefix.
		 *
		 * @param value - The value to check.
		 * @returns Whether the value is a valid hex string.
		 */
		function isStrictHexString(value) {
		    return (0, superstruct_1.is)(value, exports.StrictHexStruct);
		}
		exports.isStrictHexString = isStrictHexString;
		/**
		 * Assert that a value is a valid hex string.
		 *
		 * @param value - The value to check.
		 * @throws If the value is not a valid hex string.
		 */
		function assertIsHexString(value) {
		    (0, assert_1.assert)(isHexString(value), 'Value must be a hexadecimal string.');
		}
		exports.assertIsHexString = assertIsHexString;
		/**
		 * Assert that a value is a valid hex string. A valid hex string must start with
		 * the "0x"-prefix.
		 *
		 * @param value - The value to check.
		 * @throws If the value is not a valid hex string.
		 */
		function assertIsStrictHexString(value) {
		    (0, assert_1.assert)(isStrictHexString(value), 'Value must be a hexadecimal string, starting with "0x".');
		}
		exports.assertIsStrictHexString = assertIsStrictHexString;
		/**
		 * Add the `0x`-prefix to a hexadecimal string. If the string already has the
		 * prefix, it is returned as-is.
		 *
		 * @param hexadecimal - The hexadecimal string to add the prefix to.
		 * @returns The prefixed hexadecimal string.
		 */
		function add0x(hexadecimal) {
		    if (hexadecimal.startsWith('0x')) {
		        return hexadecimal;
		    }
		    if (hexadecimal.startsWith('0X')) {
		        return `0x${hexadecimal.substring(2)}`;
		    }
		    return `0x${hexadecimal}`;
		}
		exports.add0x = add0x;
		/**
		 * Remove the `0x`-prefix from a hexadecimal string. If the string doesn't have
		 * the prefix, it is returned as-is.
		 *
		 * @param hexadecimal - The hexadecimal string to remove the prefix from.
		 * @returns The un-prefixed hexadecimal string.
		 */
		function remove0x(hexadecimal) {
		    if (hexadecimal.startsWith('0x') || hexadecimal.startsWith('0X')) {
		        return hexadecimal.substring(2);
		    }
		    return hexadecimal;
		}
		exports.remove0x = remove0x;
		
	} (hex));

	Object.defineProperty(bytes, "__esModule", { value: true });
	bytes.createDataView = bytes.concatBytes = bytes.valueToBytes = bytes.stringToBytes = bytes.numberToBytes = bytes.signedBigIntToBytes = bytes.bigIntToBytes = bytes.hexToBytes = bytes.bytesToString = bytes.bytesToNumber = bytes.bytesToSignedBigInt = bytes.bytesToBigInt = bytes.bytesToHex = bytes.assertIsBytes = bytes.isBytes = void 0;
	const assert_1$2 = assert$2;
	const hex_1$2 = hex;
	// '0'.charCodeAt(0) === 48
	const HEX_MINIMUM_NUMBER_CHARACTER = 48;
	// '9'.charCodeAt(0) === 57
	const HEX_MAXIMUM_NUMBER_CHARACTER = 58;
	const HEX_CHARACTER_OFFSET = 87;
	/**
	 * Memoized function that returns an array to be used as a lookup table for
	 * converting bytes to hexadecimal values.
	 *
	 * The array is created lazily and then cached for future use. The benefit of
	 * this approach is that the performance of converting bytes to hex is much
	 * better than if we were to call `toString(16)` on each byte.
	 *
	 * The downside is that the array is created once and then never garbage
	 * collected. This is not a problem in practice because the array is only 256
	 * elements long.
	 *
	 * @returns A function that returns the lookup table.
	 */
	function getPrecomputedHexValuesBuilder() {
	    // To avoid issues with tree shaking, we need to use a function to return the
	    // array. This is because the array is only used in the `bytesToHex` function
	    // and if we were to use a global variable, the array might be removed by the
	    // tree shaker.
	    const lookupTable = [];
	    return () => {
	        if (lookupTable.length === 0) {
	            for (let i = 0; i < 256; i++) {
	                lookupTable.push(i.toString(16).padStart(2, '0'));
	            }
	        }
	        return lookupTable;
	    };
	}
	/**
	 * Function implementation of the {@link getPrecomputedHexValuesBuilder}
	 * function.
	 */
	const getPrecomputedHexValues = getPrecomputedHexValuesBuilder();
	/**
	 * Check if a value is a `Uint8Array`.
	 *
	 * @param value - The value to check.
	 * @returns Whether the value is a `Uint8Array`.
	 */
	function isBytes(value) {
	    return value instanceof Uint8Array;
	}
	bytes.isBytes = isBytes;
	/**
	 * Assert that a value is a `Uint8Array`.
	 *
	 * @param value - The value to check.
	 * @throws If the value is not a `Uint8Array`.
	 */
	function assertIsBytes(value) {
	    (0, assert_1$2.assert)(isBytes(value), 'Value must be a Uint8Array.');
	}
	bytes.assertIsBytes = assertIsBytes;
	/**
	 * Convert a `Uint8Array` to a hexadecimal string.
	 *
	 * @param bytes - The bytes to convert to a hexadecimal string.
	 * @returns The hexadecimal string.
	 */
	function bytesToHex(bytes) {
	    assertIsBytes(bytes);
	    if (bytes.length === 0) {
	        return '0x';
	    }
	    const lookupTable = getPrecomputedHexValues();
	    const hexadecimal = new Array(bytes.length);
	    for (let i = 0; i < bytes.length; i++) {
	        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	        hexadecimal[i] = lookupTable[bytes[i]];
	    }
	    return (0, hex_1$2.add0x)(hexadecimal.join(''));
	}
	bytes.bytesToHex = bytesToHex;
	/**
	 * Convert a `Uint8Array` to a `bigint`.
	 *
	 * To convert a `Uint8Array` to a `number` instead, use {@link bytesToNumber}.
	 * To convert a two's complement encoded `Uint8Array` to a `bigint`, use
	 * {@link bytesToSignedBigInt}.
	 *
	 * @param bytes - The bytes to convert to a `bigint`.
	 * @returns The `bigint`.
	 */
	function bytesToBigInt(bytes) {
	    assertIsBytes(bytes);
	    const hexadecimal = bytesToHex(bytes);
	    return BigInt(hexadecimal);
	}
	bytes.bytesToBigInt = bytesToBigInt;
	/**
	 * Convert a `Uint8Array` to a signed `bigint`. This assumes that the bytes are
	 * encoded in two's complement.
	 *
	 * To convert a `Uint8Array` to an unsigned `bigint` instead, use
	 * {@link bytesToBigInt}.
	 *
	 * @see https://en.wikipedia.org/wiki/Two%27s_complement
	 * @param bytes - The bytes to convert to a signed `bigint`.
	 * @returns The signed `bigint`.
	 */
	function bytesToSignedBigInt(bytes) {
	    assertIsBytes(bytes);
	    let value = BigInt(0);
	    for (const byte of bytes) {
	        // eslint-disable-next-line no-bitwise
	        value = (value << BigInt(8)) + BigInt(byte);
	    }
	    return BigInt.asIntN(bytes.length * 8, value);
	}
	bytes.bytesToSignedBigInt = bytesToSignedBigInt;
	/**
	 * Convert a `Uint8Array` to a `number`.
	 *
	 * To convert a `Uint8Array` to a `bigint` instead, use {@link bytesToBigInt}.
	 *
	 * @param bytes - The bytes to convert to a number.
	 * @returns The number.
	 * @throws If the resulting number is not a safe integer.
	 */
	function bytesToNumber(bytes) {
	    assertIsBytes(bytes);
	    const bigint = bytesToBigInt(bytes);
	    (0, assert_1$2.assert)(bigint <= BigInt(Number.MAX_SAFE_INTEGER), 'Number is not a safe integer. Use `bytesToBigInt` instead.');
	    return Number(bigint);
	}
	bytes.bytesToNumber = bytesToNumber;
	/**
	 * Convert a UTF-8 encoded `Uint8Array` to a `string`.
	 *
	 * @param bytes - The bytes to convert to a string.
	 * @returns The string.
	 */
	function bytesToString(bytes) {
	    assertIsBytes(bytes);
	    return new TextDecoder().decode(bytes);
	}
	bytes.bytesToString = bytesToString;
	/**
	 * Convert a hexadecimal string to a `Uint8Array`. The string can optionally be
	 * prefixed with `0x`. It accepts even and odd length strings.
	 *
	 * If the value is "0x", an empty `Uint8Array` is returned.
	 *
	 * @param value - The hexadecimal string to convert to bytes.
	 * @returns The bytes as `Uint8Array`.
	 */
	function hexToBytes(value) {
	    var _a;
	    // "0x" is often used as empty byte array.
	    if (((_a = value === null || value === void 0 ? void 0 : value.toLowerCase) === null || _a === void 0 ? void 0 : _a.call(value)) === '0x') {
	        return new Uint8Array();
	    }
	    (0, hex_1$2.assertIsHexString)(value);
	    // Remove the `0x` prefix if it exists, and pad the string to have an even
	    // number of characters.
	    const strippedValue = (0, hex_1$2.remove0x)(value).toLowerCase();
	    const normalizedValue = strippedValue.length % 2 === 0 ? strippedValue : `0${strippedValue}`;
	    const bytes = new Uint8Array(normalizedValue.length / 2);
	    for (let i = 0; i < bytes.length; i++) {
	        // While this is not the prettiest way to convert a hexadecimal string to a
	        // `Uint8Array`, it is a lot faster than using `parseInt` to convert each
	        // character.
	        const c1 = normalizedValue.charCodeAt(i * 2);
	        const c2 = normalizedValue.charCodeAt(i * 2 + 1);
	        const n1 = c1 -
	            (c1 < HEX_MAXIMUM_NUMBER_CHARACTER
	                ? HEX_MINIMUM_NUMBER_CHARACTER
	                : HEX_CHARACTER_OFFSET);
	        const n2 = c2 -
	            (c2 < HEX_MAXIMUM_NUMBER_CHARACTER
	                ? HEX_MINIMUM_NUMBER_CHARACTER
	                : HEX_CHARACTER_OFFSET);
	        bytes[i] = n1 * 16 + n2;
	    }
	    return bytes;
	}
	bytes.hexToBytes = hexToBytes;
	/**
	 * Convert a `bigint` to a `Uint8Array`.
	 *
	 * This assumes that the `bigint` is an unsigned integer. To convert a signed
	 * `bigint` instead, use {@link signedBigIntToBytes}.
	 *
	 * @param value - The bigint to convert to bytes.
	 * @returns The bytes as `Uint8Array`.
	 */
	function bigIntToBytes(value) {
	    (0, assert_1$2.assert)(typeof value === 'bigint', 'Value must be a bigint.');
	    (0, assert_1$2.assert)(value >= BigInt(0), 'Value must be a non-negative bigint.');
	    const hexadecimal = value.toString(16);
	    return hexToBytes(hexadecimal);
	}
	bytes.bigIntToBytes = bigIntToBytes;
	/**
	 * Check if a `bigint` fits in a certain number of bytes.
	 *
	 * @param value - The `bigint` to check.
	 * @param bytes - The number of bytes.
	 * @returns Whether the `bigint` fits in the number of bytes.
	 */
	function bigIntFits(value, bytes) {
	    (0, assert_1$2.assert)(bytes > 0);
	    /* eslint-disable no-bitwise */
	    const mask = value >> BigInt(31);
	    return !(((~value & mask) + (value & ~mask)) >> BigInt(bytes * 8 + ~0));
	    /* eslint-enable no-bitwise */
	}
	/**
	 * Convert a signed `bigint` to a `Uint8Array`. This uses two's complement
	 * encoding to represent negative numbers.
	 *
	 * To convert an unsigned `bigint` to a `Uint8Array` instead, use
	 * {@link bigIntToBytes}.
	 *
	 * @see https://en.wikipedia.org/wiki/Two%27s_complement
	 * @param value - The number to convert to bytes.
	 * @param byteLength - The length of the resulting `Uint8Array`. If the number
	 * is larger than the maximum value that can be represented by the given length,
	 * an error is thrown.
	 * @returns The bytes as `Uint8Array`.
	 */
	function signedBigIntToBytes(value, byteLength) {
	    (0, assert_1$2.assert)(typeof value === 'bigint', 'Value must be a bigint.');
	    (0, assert_1$2.assert)(typeof byteLength === 'number', 'Byte length must be a number.');
	    (0, assert_1$2.assert)(byteLength > 0, 'Byte length must be greater than 0.');
	    (0, assert_1$2.assert)(bigIntFits(value, byteLength), 'Byte length is too small to represent the given value.');
	    // ESLint doesn't like mutating function parameters, so to avoid having to
	    // disable the rule, we create a new variable.
	    let numberValue = value;
	    const bytes = new Uint8Array(byteLength);
	    for (let i = 0; i < bytes.length; i++) {
	        bytes[i] = Number(BigInt.asUintN(8, numberValue));
	        // eslint-disable-next-line no-bitwise
	        numberValue >>= BigInt(8);
	    }
	    return bytes.reverse();
	}
	bytes.signedBigIntToBytes = signedBigIntToBytes;
	/**
	 * Convert a `number` to a `Uint8Array`.
	 *
	 * @param value - The number to convert to bytes.
	 * @returns The bytes as `Uint8Array`.
	 * @throws If the number is not a safe integer.
	 */
	function numberToBytes(value) {
	    (0, assert_1$2.assert)(typeof value === 'number', 'Value must be a number.');
	    (0, assert_1$2.assert)(value >= 0, 'Value must be a non-negative number.');
	    (0, assert_1$2.assert)(Number.isSafeInteger(value), 'Value is not a safe integer. Use `bigIntToBytes` instead.');
	    const hexadecimal = value.toString(16);
	    return hexToBytes(hexadecimal);
	}
	bytes.numberToBytes = numberToBytes;
	/**
	 * Convert a `string` to a UTF-8 encoded `Uint8Array`.
	 *
	 * @param value - The string to convert to bytes.
	 * @returns The bytes as `Uint8Array`.
	 */
	function stringToBytes(value) {
	    (0, assert_1$2.assert)(typeof value === 'string', 'Value must be a string.');
	    return new TextEncoder().encode(value);
	}
	bytes.stringToBytes = stringToBytes;
	/**
	 * Convert a byte-like value to a `Uint8Array`. The value can be a `Uint8Array`,
	 * a `bigint`, a `number`, or a `string`.
	 *
	 * This will attempt to guess the type of the value based on its type and
	 * contents. For more control over the conversion, use the more specific
	 * conversion functions, such as {@link hexToBytes} or {@link stringToBytes}.
	 *
	 * If the value is a `string`, and it is prefixed with `0x`, it will be
	 * interpreted as a hexadecimal string. Otherwise, it will be interpreted as a
	 * UTF-8 string. To convert a hexadecimal string to bytes without interpreting
	 * it as a UTF-8 string, use {@link hexToBytes} instead.
	 *
	 * If the value is a `bigint`, it is assumed to be unsigned. To convert a signed
	 * `bigint` to bytes, use {@link signedBigIntToBytes} instead.
	 *
	 * If the value is a `Uint8Array`, it will be returned as-is.
	 *
	 * @param value - The value to convert to bytes.
	 * @returns The bytes as `Uint8Array`.
	 */
	function valueToBytes(value) {
	    if (typeof value === 'bigint') {
	        return bigIntToBytes(value);
	    }
	    if (typeof value === 'number') {
	        return numberToBytes(value);
	    }
	    if (typeof value === 'string') {
	        if (value.startsWith('0x')) {
	            return hexToBytes(value);
	        }
	        return stringToBytes(value);
	    }
	    if (isBytes(value)) {
	        return value;
	    }
	    throw new TypeError(`Unsupported value type: "${typeof value}".`);
	}
	bytes.valueToBytes = valueToBytes;
	/**
	 * Concatenate multiple byte-like values into a single `Uint8Array`. The values
	 * can be `Uint8Array`, `bigint`, `number`, or `string`. This uses
	 * {@link valueToBytes} under the hood to convert each value to bytes. Refer to
	 * the documentation of that function for more information.
	 *
	 * @param values - The values to concatenate.
	 * @returns The concatenated bytes as `Uint8Array`.
	 */
	function concatBytes(values) {
	    const normalizedValues = new Array(values.length);
	    let byteLength = 0;
	    for (let i = 0; i < values.length; i++) {
	        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	        const value = valueToBytes(values[i]);
	        normalizedValues[i] = value;
	        byteLength += value.length;
	    }
	    const bytes = new Uint8Array(byteLength);
	    for (let i = 0, offset = 0; i < normalizedValues.length; i++) {
	        // While we could simply spread the values into an array and use
	        // `Uint8Array.from`, that is a lot slower than using `Uint8Array.set`.
	        bytes.set(normalizedValues[i], offset);
	        offset += normalizedValues[i].length;
	    }
	    return bytes;
	}
	bytes.concatBytes = concatBytes;
	/**
	 * Create a {@link DataView} from a {@link Uint8Array}. This is a convenience
	 * function that avoids having to create a {@link DataView} manually, which
	 * requires passing the `byteOffset` and `byteLength` parameters every time.
	 *
	 * Not passing the `byteOffset` and `byteLength` parameters can result in
	 * unexpected behavior when the {@link Uint8Array} is a view of a larger
	 * {@link ArrayBuffer}, e.g., when using {@link Uint8Array.subarray}.
	 *
	 * This function also supports Node.js {@link Buffer}s.
	 *
	 * @example
	 * ```typescript
	 * const bytes = new Uint8Array([1, 2, 3]);
	 *
	 * // This is equivalent to:
	 * // const dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
	 * const dataView = createDataView(bytes);
	 * ```
	 * @param bytes - The bytes to create the {@link DataView} from.
	 * @returns The {@link DataView}.
	 */
	function createDataView(bytes) {
	    // To maintain compatibility with Node.js, we need to check if the bytes are
	    // a Buffer. If so, we need to slice the buffer to get the underlying
	    // ArrayBuffer.
	    // eslint-disable-next-line no-restricted-globals
	    if (typeof Buffer !== 'undefined' && bytes instanceof Buffer) {
	        const buffer = bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
	        return new DataView(buffer);
	    }
	    return new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
	}
	bytes.createDataView = createDataView;

	var checksum = {};

	Object.defineProperty(checksum, "__esModule", { value: true });
	checksum.ChecksumStruct = void 0;
	const superstruct_1$1 = require$$1$2;
	const base64_1 = base64$1;
	checksum.ChecksumStruct = (0, superstruct_1$1.size)((0, base64_1.base64)((0, superstruct_1$1.string)(), { paddingRequired: true }), 44, 44);

	var coercers = {};

	Object.defineProperty(coercers, "__esModule", { value: true });
	coercers.createHex = coercers.createBytes = coercers.createBigInt = coercers.createNumber = void 0;
	const superstruct_1 = require$$1$2;
	const assert_1$1 = assert$2;
	const bytes_1 = bytes;
	const hex_1$1 = hex;
	const NumberLikeStruct = (0, superstruct_1.union)([(0, superstruct_1.number)(), (0, superstruct_1.bigint)(), (0, superstruct_1.string)(), hex_1$1.StrictHexStruct]);
	const NumberCoercer = (0, superstruct_1.coerce)((0, superstruct_1.number)(), NumberLikeStruct, Number);
	const BigIntCoercer = (0, superstruct_1.coerce)((0, superstruct_1.bigint)(), NumberLikeStruct, BigInt);
	(0, superstruct_1.union)([hex_1$1.StrictHexStruct, (0, superstruct_1.instance)(Uint8Array)]);
	const BytesCoercer = (0, superstruct_1.coerce)((0, superstruct_1.instance)(Uint8Array), (0, superstruct_1.union)([hex_1$1.StrictHexStruct]), bytes_1.hexToBytes);
	const HexCoercer = (0, superstruct_1.coerce)(hex_1$1.StrictHexStruct, (0, superstruct_1.instance)(Uint8Array), bytes_1.bytesToHex);
	/**
	 * Create a number from a number-like value.
	 *
	 * - If the value is a number, it is returned as-is.
	 * - If the value is a `bigint`, it is converted to a number.
	 * - If the value is a string, it is interpreted as a decimal number.
	 * - If the value is a hex string (i.e., it starts with "0x"), it is
	 * interpreted as a hexadecimal number.
	 *
	 * This validates that the value is a number-like value, and that the resulting
	 * number is not `NaN` or `Infinity`.
	 *
	 * @example
	 * ```typescript
	 * const value = createNumber('0x010203');
	 * console.log(value); // 66051
	 *
	 * const otherValue = createNumber(123n);
	 * console.log(otherValue); // 123
	 * ```
	 * @param value - The value to create the number from.
	 * @returns The created number.
	 * @throws If the value is not a number-like value, or if the resulting number
	 * is `NaN` or `Infinity`.
	 */
	function createNumber(value) {
	    try {
	        const result = (0, superstruct_1.create)(value, NumberCoercer);
	        (0, assert_1$1.assert)(Number.isFinite(result), `Expected a number-like value, got "${value}".`);
	        return result;
	    }
	    catch (error) {
	        if (error instanceof superstruct_1.StructError) {
	            throw new Error(`Expected a number-like value, got "${value}".`);
	        }
	        /* istanbul ignore next */
	        throw error;
	    }
	}
	coercers.createNumber = createNumber;
	/**
	 * Create a `bigint` from a number-like value.
	 *
	 * - If the value is a number, it is converted to a `bigint`.
	 * - If the value is a `bigint`, it is returned as-is.
	 * - If the value is a string, it is interpreted as a decimal number and
	 * converted to a `bigint`.
	 * - If the value is a hex string (i.e., it starts with "0x"), it is
	 * interpreted as a hexadecimal number and converted to a `bigint`.
	 *
	 * @example
	 * ```typescript
	 * const value = createBigInt('0x010203');
	 * console.log(value); // 16909060n
	 *
	 * const otherValue = createBigInt(123);
	 * console.log(otherValue); // 123n
	 * ```
	 * @param value - The value to create the bigint from.
	 * @returns The created bigint.
	 * @throws If the value is not a number-like value.
	 */
	function createBigInt(value) {
	    try {
	        // The `BigInt` constructor throws if the value is not a number-like value.
	        // There is no need to validate the value manually.
	        return (0, superstruct_1.create)(value, BigIntCoercer);
	    }
	    catch (error) {
	        if (error instanceof superstruct_1.StructError) {
	            throw new Error(`Expected a number-like value, got "${String(error.value)}".`);
	        }
	        /* istanbul ignore next */
	        throw error;
	    }
	}
	coercers.createBigInt = createBigInt;
	/**
	 * Create a byte array from a bytes-like value.
	 *
	 * - If the value is a byte array, it is returned as-is.
	 * - If the value is a hex string (i.e., it starts with "0x"), it is interpreted
	 * as a hexadecimal number and converted to a byte array.
	 *
	 * @example
	 * ```typescript
	 * const value = createBytes('0x010203');
	 * console.log(value); // Uint8Array [ 1, 2, 3 ]
	 *
	 * const otherValue = createBytes('0x010203');
	 * console.log(otherValue); // Uint8Array [ 1, 2, 3 ]
	 * ```
	 * @param value - The value to create the byte array from.
	 * @returns The created byte array.
	 * @throws If the value is not a bytes-like value.
	 */
	function createBytes(value) {
	    if (typeof value === 'string' && value.toLowerCase() === '0x') {
	        return new Uint8Array();
	    }
	    try {
	        return (0, superstruct_1.create)(value, BytesCoercer);
	    }
	    catch (error) {
	        if (error instanceof superstruct_1.StructError) {
	            throw new Error(`Expected a bytes-like value, got "${String(error.value)}".`);
	        }
	        /* istanbul ignore next */
	        throw error;
	    }
	}
	coercers.createBytes = createBytes;
	/**
	 * Create a hexadecimal string from a bytes-like value.
	 *
	 * - If the value is a hex string (i.e., it starts with "0x"), it is returned
	 * as-is.
	 * - If the value is a `Uint8Array`, it is converted to a hex string.
	 *
	 * @example
	 * ```typescript
	 * const value = createHex(new Uint8Array([1, 2, 3]));
	 * console.log(value); // '0x010203'
	 *
	 * const otherValue = createHex('0x010203');
	 * console.log(otherValue); // '0x010203'
	 * ```
	 * @param value - The value to create the hex string from.
	 * @returns The created hex string.
	 * @throws If the value is not a bytes-like value.
	 */
	function createHex(value) {
	    if ((value instanceof Uint8Array && value.length === 0) ||
	        (typeof value === 'string' && value.toLowerCase() === '0x')) {
	        return '0x';
	    }
	    try {
	        return (0, superstruct_1.create)(value, HexCoercer);
	    }
	    catch (error) {
	        if (error instanceof superstruct_1.StructError) {
	            throw new Error(`Expected a bytes-like value, got "${String(error.value)}".`);
	        }
	        /* istanbul ignore next */
	        throw error;
	    }
	}
	coercers.createHex = createHex;

	var collections = {};

	var __classPrivateFieldSet$1 = (commonjsGlobal && commonjsGlobal.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
	    if (kind === "m") throw new TypeError("Private method is not writable");
	    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
	    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
	    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
	};
	var __classPrivateFieldGet$1 = (commonjsGlobal && commonjsGlobal.__classPrivateFieldGet) || function (receiver, state, kind, f) {
	    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
	    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
	    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
	};
	var _FrozenMap_map, _FrozenSet_set;
	Object.defineProperty(collections, "__esModule", { value: true });
	collections.FrozenSet = collections.FrozenMap = void 0;
	/**
	 * A {@link ReadonlyMap} that cannot be modified after instantiation.
	 * The implementation uses an inner map hidden via a private field, and the
	 * immutability guarantee relies on it being impossible to get a reference
	 * to this map.
	 */
	class FrozenMap {
	    constructor(entries) {
	        _FrozenMap_map.set(this, void 0);
	        __classPrivateFieldSet$1(this, _FrozenMap_map, new Map(entries), "f");
	        Object.freeze(this);
	    }
	    get size() {
	        return __classPrivateFieldGet$1(this, _FrozenMap_map, "f").size;
	    }
	    [(_FrozenMap_map = new WeakMap(), Symbol.iterator)]() {
	        return __classPrivateFieldGet$1(this, _FrozenMap_map, "f")[Symbol.iterator]();
	    }
	    entries() {
	        return __classPrivateFieldGet$1(this, _FrozenMap_map, "f").entries();
	    }
	    forEach(callbackfn, thisArg) {
	        // We have to wrap the specified callback in order to prevent it from
	        // receiving a reference to the inner map.
	        return __classPrivateFieldGet$1(this, _FrozenMap_map, "f").forEach((value, key, _map) => callbackfn.call(thisArg, value, key, this));
	    }
	    get(key) {
	        return __classPrivateFieldGet$1(this, _FrozenMap_map, "f").get(key);
	    }
	    has(key) {
	        return __classPrivateFieldGet$1(this, _FrozenMap_map, "f").has(key);
	    }
	    keys() {
	        return __classPrivateFieldGet$1(this, _FrozenMap_map, "f").keys();
	    }
	    values() {
	        return __classPrivateFieldGet$1(this, _FrozenMap_map, "f").values();
	    }
	    toString() {
	        return `FrozenMap(${this.size}) {${this.size > 0
            ? ` ${[...this.entries()]
                .map(([key, value]) => `${String(key)} => ${String(value)}`)
                .join(', ')} `
            : ''}}`;
	    }
	}
	collections.FrozenMap = FrozenMap;
	/**
	 * A {@link ReadonlySet} that cannot be modified after instantiation.
	 * The implementation uses an inner set hidden via a private field, and the
	 * immutability guarantee relies on it being impossible to get a reference
	 * to this set.
	 */
	class FrozenSet {
	    constructor(values) {
	        _FrozenSet_set.set(this, void 0);
	        __classPrivateFieldSet$1(this, _FrozenSet_set, new Set(values), "f");
	        Object.freeze(this);
	    }
	    get size() {
	        return __classPrivateFieldGet$1(this, _FrozenSet_set, "f").size;
	    }
	    [(_FrozenSet_set = new WeakMap(), Symbol.iterator)]() {
	        return __classPrivateFieldGet$1(this, _FrozenSet_set, "f")[Symbol.iterator]();
	    }
	    entries() {
	        return __classPrivateFieldGet$1(this, _FrozenSet_set, "f").entries();
	    }
	    forEach(callbackfn, thisArg) {
	        // We have to wrap the specified callback in order to prevent it from
	        // receiving a reference to the inner set.
	        return __classPrivateFieldGet$1(this, _FrozenSet_set, "f").forEach((value, value2, _set) => callbackfn.call(thisArg, value, value2, this));
	    }
	    has(value) {
	        return __classPrivateFieldGet$1(this, _FrozenSet_set, "f").has(value);
	    }
	    keys() {
	        return __classPrivateFieldGet$1(this, _FrozenSet_set, "f").keys();
	    }
	    values() {
	        return __classPrivateFieldGet$1(this, _FrozenSet_set, "f").values();
	    }
	    toString() {
	        return `FrozenSet(${this.size}) {${this.size > 0
            ? ` ${[...this.values()].map((member) => String(member)).join(', ')} `
            : ''}}`;
	    }
	}
	collections.FrozenSet = FrozenSet;
	Object.freeze(FrozenMap);
	Object.freeze(FrozenMap.prototype);
	Object.freeze(FrozenSet);
	Object.freeze(FrozenSet.prototype);

	var json = {};

	var misc = {};

	(function (exports) {
		//
		// Types
		//
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.calculateNumberSize = exports.calculateStringSize = exports.isASCII = exports.isPlainObject = exports.ESCAPE_CHARACTERS_REGEXP = exports.JsonSize = exports.hasProperty = exports.isObject = exports.isNullOrUndefined = exports.isNonEmptyArray = void 0;
		//
		// Type Guards
		//
		/**
		 * A {@link NonEmptyArray} type guard.
		 *
		 * @template Element - The non-empty array member type.
		 * @param value - The value to check.
		 * @returns Whether the value is a non-empty array.
		 */
		function isNonEmptyArray(value) {
		    return Array.isArray(value) && value.length > 0;
		}
		exports.isNonEmptyArray = isNonEmptyArray;
		/**
		 * Type guard for "nullishness".
		 *
		 * @param value - Any value.
		 * @returns `true` if the value is null or undefined, `false` otherwise.
		 */
		function isNullOrUndefined(value) {
		    return value === null || value === undefined;
		}
		exports.isNullOrUndefined = isNullOrUndefined;
		/**
		 * A type guard for {@link RuntimeObject}.
		 *
		 * @param value - The value to check.
		 * @returns Whether the specified value has a runtime type of `object` and is
		 * neither `null` nor an `Array`.
		 */
		function isObject(value) {
		    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
		}
		exports.isObject = isObject;
		//
		// Other utility functions
		//
		/**
		 * A type guard for ensuring an object has a property.
		 *
		 * @param objectToCheck - The object to check.
		 * @param name - The property name to check for.
		 * @returns Whether the specified object has an own property with the specified
		 * name, regardless of whether it is enumerable or not.
		 */
		const hasProperty = (objectToCheck, name) => Object.hasOwnProperty.call(objectToCheck, name);
		exports.hasProperty = hasProperty;
		(function (JsonSize) {
		    JsonSize[JsonSize["Null"] = 4] = "Null";
		    JsonSize[JsonSize["Comma"] = 1] = "Comma";
		    JsonSize[JsonSize["Wrapper"] = 1] = "Wrapper";
		    JsonSize[JsonSize["True"] = 4] = "True";
		    JsonSize[JsonSize["False"] = 5] = "False";
		    JsonSize[JsonSize["Quote"] = 1] = "Quote";
		    JsonSize[JsonSize["Colon"] = 1] = "Colon";
		    // eslint-disable-next-line @typescript-eslint/no-shadow
		    JsonSize[JsonSize["Date"] = 24] = "Date";
		})(exports.JsonSize || (exports.JsonSize = {}));
		/**
		 * Regular expression with pattern matching for (special) escaped characters.
		 */
		exports.ESCAPE_CHARACTERS_REGEXP = /"|\\|\n|\r|\t/gu;
		/**
		 * Check if the value is plain object.
		 *
		 * @param value - Value to be checked.
		 * @returns True if an object is the plain JavaScript object,
		 * false if the object is not plain (e.g. function).
		 */
		function isPlainObject(value) {
		    if (typeof value !== 'object' || value === null) {
		        return false;
		    }
		    try {
		        let proto = value;
		        while (Object.getPrototypeOf(proto) !== null) {
		            proto = Object.getPrototypeOf(proto);
		        }
		        return Object.getPrototypeOf(value) === proto;
		    }
		    catch (_) {
		        return false;
		    }
		}
		exports.isPlainObject = isPlainObject;
		/**
		 * Check if character is ASCII.
		 *
		 * @param character - Character.
		 * @returns True if a character code is ASCII, false if not.
		 */
		function isASCII(character) {
		    return character.charCodeAt(0) <= 127;
		}
		exports.isASCII = isASCII;
		/**
		 * Calculate string size.
		 *
		 * @param value - String value to calculate size.
		 * @returns Number of bytes used to store whole string value.
		 */
		function calculateStringSize(value) {
		    var _a;
		    const size = value.split('').reduce((total, character) => {
		        if (isASCII(character)) {
		            return total + 1;
		        }
		        return total + 2;
		    }, 0);
		    // Also detect characters that need backslash escape
		    return size + ((_a = value.match(exports.ESCAPE_CHARACTERS_REGEXP)) !== null && _a !== void 0 ? _a : []).length;
		}
		exports.calculateStringSize = calculateStringSize;
		/**
		 * Calculate size of a number ofter JSON serialization.
		 *
		 * @param value - Number value to calculate size.
		 * @returns Number of bytes used to store whole number in JSON.
		 */
		function calculateNumberSize(value) {
		    return value.toString().length;
		}
		exports.calculateNumberSize = calculateNumberSize;
		
	} (misc));

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.validateJsonAndGetSize = exports.getJsonRpcIdValidator = exports.assertIsJsonRpcError = exports.isJsonRpcError = exports.assertIsJsonRpcFailure = exports.isJsonRpcFailure = exports.assertIsJsonRpcSuccess = exports.isJsonRpcSuccess = exports.assertIsJsonRpcResponse = exports.isJsonRpcResponse = exports.assertIsPendingJsonRpcResponse = exports.isPendingJsonRpcResponse = exports.JsonRpcResponseStruct = exports.JsonRpcFailureStruct = exports.JsonRpcSuccessStruct = exports.PendingJsonRpcResponseStruct = exports.assertIsJsonRpcRequest = exports.isJsonRpcRequest = exports.assertIsJsonRpcNotification = exports.isJsonRpcNotification = exports.JsonRpcNotificationStruct = exports.JsonRpcRequestStruct = exports.JsonRpcParamsStruct = exports.JsonRpcErrorStruct = exports.JsonRpcIdStruct = exports.JsonRpcVersionStruct = exports.jsonrpc2 = exports.isValidJson = exports.JsonStruct = void 0;
		const superstruct_1 = require$$1$2;
		const assert_1 = assert$2;
		const misc_1 = misc;
		exports.JsonStruct = (0, superstruct_1.define)('Json', (value) => {
		    const [isValid] = validateJsonAndGetSize(value, true);
		    if (!isValid) {
		        return 'Expected a valid JSON-serializable value';
		    }
		    return true;
		});
		/**
		 * Check if the given value is a valid {@link Json} value, i.e., a value that is
		 * serializable to JSON.
		 *
		 * @param value - The value to check.
		 * @returns Whether the value is a valid {@link Json} value.
		 */
		function isValidJson(value) {
		    return (0, superstruct_1.is)(value, exports.JsonStruct);
		}
		exports.isValidJson = isValidJson;
		/**
		 * The string '2.0'.
		 */
		exports.jsonrpc2 = '2.0';
		exports.JsonRpcVersionStruct = (0, superstruct_1.literal)(exports.jsonrpc2);
		exports.JsonRpcIdStruct = (0, superstruct_1.nullable)((0, superstruct_1.union)([(0, superstruct_1.number)(), (0, superstruct_1.string)()]));
		exports.JsonRpcErrorStruct = (0, superstruct_1.object)({
		    code: (0, superstruct_1.integer)(),
		    message: (0, superstruct_1.string)(),
		    data: (0, superstruct_1.optional)(exports.JsonStruct),
		    stack: (0, superstruct_1.optional)((0, superstruct_1.string)()),
		});
		exports.JsonRpcParamsStruct = (0, superstruct_1.optional)((0, superstruct_1.union)([(0, superstruct_1.record)((0, superstruct_1.string)(), exports.JsonStruct), (0, superstruct_1.array)(exports.JsonStruct)]));
		exports.JsonRpcRequestStruct = (0, superstruct_1.object)({
		    id: exports.JsonRpcIdStruct,
		    jsonrpc: exports.JsonRpcVersionStruct,
		    method: (0, superstruct_1.string)(),
		    params: exports.JsonRpcParamsStruct,
		});
		exports.JsonRpcNotificationStruct = (0, superstruct_1.omit)(exports.JsonRpcRequestStruct, ['id']);
		/**
		 * Check if the given value is a valid {@link JsonRpcNotification} object.
		 *
		 * @param value - The value to check.
		 * @returns Whether the given value is a valid {@link JsonRpcNotification}
		 * object.
		 */
		function isJsonRpcNotification(value) {
		    return (0, superstruct_1.is)(value, exports.JsonRpcNotificationStruct);
		}
		exports.isJsonRpcNotification = isJsonRpcNotification;
		/**
		 * Assert that the given value is a valid {@link JsonRpcNotification} object.
		 *
		 * @param value - The value to check.
		 * @param ErrorWrapper - The error class to throw if the assertion fails.
		 * Defaults to {@link AssertionError}.
		 * @throws If the given value is not a valid {@link JsonRpcNotification} object.
		 */
		function assertIsJsonRpcNotification(value, 
		// eslint-disable-next-line @typescript-eslint/naming-convention
		ErrorWrapper) {
		    (0, assert_1.assertStruct)(value, exports.JsonRpcNotificationStruct, 'Invalid JSON-RPC notification', ErrorWrapper);
		}
		exports.assertIsJsonRpcNotification = assertIsJsonRpcNotification;
		/**
		 * Check if the given value is a valid {@link JsonRpcRequest} object.
		 *
		 * @param value - The value to check.
		 * @returns Whether the given value is a valid {@link JsonRpcRequest} object.
		 */
		function isJsonRpcRequest(value) {
		    return (0, superstruct_1.is)(value, exports.JsonRpcRequestStruct);
		}
		exports.isJsonRpcRequest = isJsonRpcRequest;
		/**
		 * Assert that the given value is a valid {@link JsonRpcRequest} object.
		 *
		 * @param value - The JSON-RPC request or notification to check.
		 * @param ErrorWrapper - The error class to throw if the assertion fails.
		 * Defaults to {@link AssertionError}.
		 * @throws If the given value is not a valid {@link JsonRpcRequest} object.
		 */
		function assertIsJsonRpcRequest(value, 
		// eslint-disable-next-line @typescript-eslint/naming-convention
		ErrorWrapper) {
		    (0, assert_1.assertStruct)(value, exports.JsonRpcRequestStruct, 'Invalid JSON-RPC request', ErrorWrapper);
		}
		exports.assertIsJsonRpcRequest = assertIsJsonRpcRequest;
		exports.PendingJsonRpcResponseStruct = (0, superstruct_1.object)({
		    id: exports.JsonRpcIdStruct,
		    jsonrpc: exports.JsonRpcVersionStruct,
		    result: (0, superstruct_1.optional)((0, superstruct_1.unknown)()),
		    error: (0, superstruct_1.optional)(exports.JsonRpcErrorStruct),
		});
		exports.JsonRpcSuccessStruct = (0, superstruct_1.object)({
		    id: exports.JsonRpcIdStruct,
		    jsonrpc: exports.JsonRpcVersionStruct,
		    result: exports.JsonStruct,
		});
		exports.JsonRpcFailureStruct = (0, superstruct_1.object)({
		    id: exports.JsonRpcIdStruct,
		    jsonrpc: exports.JsonRpcVersionStruct,
		    error: exports.JsonRpcErrorStruct,
		});
		exports.JsonRpcResponseStruct = (0, superstruct_1.union)([
		    exports.JsonRpcSuccessStruct,
		    exports.JsonRpcFailureStruct,
		]);
		/**
		 * Type guard to check whether specified JSON-RPC response is a
		 * {@link PendingJsonRpcResponse}.
		 *
		 * @param response - The JSON-RPC response to check.
		 * @returns Whether the specified JSON-RPC response is pending.
		 */
		function isPendingJsonRpcResponse(response) {
		    return (0, superstruct_1.is)(response, exports.PendingJsonRpcResponseStruct);
		}
		exports.isPendingJsonRpcResponse = isPendingJsonRpcResponse;
		/**
		 * Assert that the given value is a valid {@link PendingJsonRpcResponse} object.
		 *
		 * @param response - The JSON-RPC response to check.
		 * @param ErrorWrapper - The error class to throw if the assertion fails.
		 * Defaults to {@link AssertionError}.
		 * @throws If the given value is not a valid {@link PendingJsonRpcResponse}
		 * object.
		 */
		function assertIsPendingJsonRpcResponse(response, 
		// eslint-disable-next-line @typescript-eslint/naming-convention
		ErrorWrapper) {
		    (0, assert_1.assertStruct)(response, exports.PendingJsonRpcResponseStruct, 'Invalid pending JSON-RPC response', ErrorWrapper);
		}
		exports.assertIsPendingJsonRpcResponse = assertIsPendingJsonRpcResponse;
		/**
		 * Type guard to check if a value is a {@link JsonRpcResponse}.
		 *
		 * @param response - The object to check.
		 * @returns Whether the object is a JsonRpcResponse.
		 */
		function isJsonRpcResponse(response) {
		    return (0, superstruct_1.is)(response, exports.JsonRpcResponseStruct);
		}
		exports.isJsonRpcResponse = isJsonRpcResponse;
		/**
		 * Assert that the given value is a valid {@link JsonRpcResponse} object.
		 *
		 * @param value - The value to check.
		 * @param ErrorWrapper - The error class to throw if the assertion fails.
		 * Defaults to {@link AssertionError}.
		 * @throws If the given value is not a valid {@link JsonRpcResponse} object.
		 */
		function assertIsJsonRpcResponse(value, 
		// eslint-disable-next-line @typescript-eslint/naming-convention
		ErrorWrapper) {
		    (0, assert_1.assertStruct)(value, exports.JsonRpcResponseStruct, 'Invalid JSON-RPC response', ErrorWrapper);
		}
		exports.assertIsJsonRpcResponse = assertIsJsonRpcResponse;
		/**
		 * Check if the given value is a valid {@link JsonRpcSuccess} object.
		 *
		 * @param value - The value to check.
		 * @returns Whether the given value is a valid {@link JsonRpcSuccess} object.
		 */
		function isJsonRpcSuccess(value) {
		    return (0, superstruct_1.is)(value, exports.JsonRpcSuccessStruct);
		}
		exports.isJsonRpcSuccess = isJsonRpcSuccess;
		/**
		 * Assert that the given value is a valid {@link JsonRpcSuccess} object.
		 *
		 * @param value - The value to check.
		 * @param ErrorWrapper - The error class to throw if the assertion fails.
		 * Defaults to {@link AssertionError}.
		 * @throws If the given value is not a valid {@link JsonRpcSuccess} object.
		 */
		function assertIsJsonRpcSuccess(value, 
		// eslint-disable-next-line @typescript-eslint/naming-convention
		ErrorWrapper) {
		    (0, assert_1.assertStruct)(value, exports.JsonRpcSuccessStruct, 'Invalid JSON-RPC success response', ErrorWrapper);
		}
		exports.assertIsJsonRpcSuccess = assertIsJsonRpcSuccess;
		/**
		 * Check if the given value is a valid {@link JsonRpcFailure} object.
		 *
		 * @param value - The value to check.
		 * @returns Whether the given value is a valid {@link JsonRpcFailure} object.
		 */
		function isJsonRpcFailure(value) {
		    return (0, superstruct_1.is)(value, exports.JsonRpcFailureStruct);
		}
		exports.isJsonRpcFailure = isJsonRpcFailure;
		/**
		 * Assert that the given value is a valid {@link JsonRpcFailure} object.
		 *
		 * @param value - The value to check.
		 * @param ErrorWrapper - The error class to throw if the assertion fails.
		 * Defaults to {@link AssertionError}.
		 * @throws If the given value is not a valid {@link JsonRpcFailure} object.
		 */
		function assertIsJsonRpcFailure(value, 
		// eslint-disable-next-line @typescript-eslint/naming-convention
		ErrorWrapper) {
		    (0, assert_1.assertStruct)(value, exports.JsonRpcFailureStruct, 'Invalid JSON-RPC failure response', ErrorWrapper);
		}
		exports.assertIsJsonRpcFailure = assertIsJsonRpcFailure;
		/**
		 * Check if the given value is a valid {@link JsonRpcError} object.
		 *
		 * @param value - The value to check.
		 * @returns Whether the given value is a valid {@link JsonRpcError} object.
		 */
		function isJsonRpcError(value) {
		    return (0, superstruct_1.is)(value, exports.JsonRpcErrorStruct);
		}
		exports.isJsonRpcError = isJsonRpcError;
		/**
		 * Assert that the given value is a valid {@link JsonRpcError} object.
		 *
		 * @param value - The value to check.
		 * @param ErrorWrapper - The error class to throw if the assertion fails.
		 * Defaults to {@link AssertionError}.
		 * @throws If the given value is not a valid {@link JsonRpcError} object.
		 */
		function assertIsJsonRpcError(value, 
		// eslint-disable-next-line @typescript-eslint/naming-convention
		ErrorWrapper) {
		    (0, assert_1.assertStruct)(value, exports.JsonRpcErrorStruct, 'Invalid JSON-RPC error', ErrorWrapper);
		}
		exports.assertIsJsonRpcError = assertIsJsonRpcError;
		/**
		 * Gets a function for validating JSON-RPC request / response `id` values.
		 *
		 * By manipulating the options of this factory, you can control the behavior
		 * of the resulting validator for some edge cases. This is useful because e.g.
		 * `null` should sometimes but not always be permitted.
		 *
		 * Note that the empty string (`''`) is always permitted by the JSON-RPC
		 * specification, but that kind of sucks and you may want to forbid it in some
		 * instances anyway.
		 *
		 * For more details, see the
		 * [JSON-RPC Specification](https://www.jsonrpc.org/specification).
		 *
		 * @param options - An options object.
		 * @param options.permitEmptyString - Whether the empty string (i.e. `''`)
		 * should be treated as a valid ID. Default: `true`
		 * @param options.permitFractions - Whether fractional numbers (e.g. `1.2`)
		 * should be treated as valid IDs. Default: `false`
		 * @param options.permitNull - Whether `null` should be treated as a valid ID.
		 * Default: `true`
		 * @returns The JSON-RPC ID validator function.
		 */
		function getJsonRpcIdValidator(options) {
		    const { permitEmptyString, permitFractions, permitNull } = Object.assign({ permitEmptyString: true, permitFractions: false, permitNull: true }, options);
		    /**
		     * Type guard for {@link JsonRpcId}.
		     *
		     * @param id - The JSON-RPC ID value to check.
		     * @returns Whether the given ID is valid per the options given to the
		     * factory.
		     */
		    const isValidJsonRpcId = (id) => {
		        return Boolean((typeof id === 'number' && (permitFractions || Number.isInteger(id))) ||
		            (typeof id === 'string' && (permitEmptyString || id.length > 0)) ||
		            (permitNull && id === null));
		    };
		    return isValidJsonRpcId;
		}
		exports.getJsonRpcIdValidator = getJsonRpcIdValidator;
		/**
		 * Checks whether a value is JSON serializable and counts the total number
		 * of bytes needed to store the serialized version of the value.
		 *
		 * @param jsObject - Potential JSON serializable object.
		 * @param skipSizingProcess - Skip JSON size calculation (default: false).
		 * @returns Tuple [isValid, plainTextSizeInBytes] containing a boolean that signals whether
		 * the value was serializable and a number of bytes that it will use when serialized to JSON.
		 */
		function validateJsonAndGetSize(jsObject, skipSizingProcess = false) {
		    const seenObjects = new Set();
		    /**
		     * Checks whether a value is JSON serializable and counts the total number
		     * of bytes needed to store the serialized version of the value.
		     *
		     * This function assumes the encoding of the JSON is done in UTF-8.
		     *
		     * @param value - Potential JSON serializable value.
		     * @param skipSizing - Skip JSON size calculation (default: false).
		     * @returns Tuple [isValid, plainTextSizeInBytes] containing a boolean that signals whether
		     * the value was serializable and a number of bytes that it will use when serialized to JSON.
		     */
		    function getJsonSerializableInfo(value, skipSizing) {
		        if (value === undefined) {
		            return [false, 0];
		        }
		        else if (value === null) {
		            // Return already specified constant size for null (special object)
		            return [true, skipSizing ? 0 : misc_1.JsonSize.Null];
		        }
		        // Check and calculate sizes for basic (and some special) types
		        const typeOfValue = typeof value;
		        try {
		            if (typeOfValue === 'function') {
		                return [false, 0];
		            }
		            else if (typeOfValue === 'string' || value instanceof String) {
		                return [
		                    true,
		                    skipSizing
		                        ? 0
		                        : (0, misc_1.calculateStringSize)(value) + misc_1.JsonSize.Quote * 2,
		                ];
		            }
		            else if (typeOfValue === 'boolean' || value instanceof Boolean) {
		                if (skipSizing) {
		                    return [true, 0];
		                }
		                // eslint-disable-next-line eqeqeq
		                return [true, value == true ? misc_1.JsonSize.True : misc_1.JsonSize.False];
		            }
		            else if (typeOfValue === 'number' || value instanceof Number) {
		                if (skipSizing) {
		                    return [true, 0];
		                }
		                return [true, (0, misc_1.calculateNumberSize)(value)];
		            }
		            else if (value instanceof Date) {
		                if (skipSizing) {
		                    return [true, 0];
		                }
		                return [
		                    true,
		                    // Note: Invalid dates will serialize to null
		                    isNaN(value.getDate())
		                        ? misc_1.JsonSize.Null
		                        : misc_1.JsonSize.Date + misc_1.JsonSize.Quote * 2,
		                ];
		            }
		        }
		        catch (_) {
		            return [false, 0];
		        }
		        // If object is not plain and cannot be serialized properly,
		        // stop here and return false for serialization
		        if (!(0, misc_1.isPlainObject)(value) && !Array.isArray(value)) {
		            return [false, 0];
		        }
		        // Circular object detection (handling)
		        // Check if the same object already exists
		        if (seenObjects.has(value)) {
		            return [false, 0];
		        }
		        // Add new object to the seen objects set
		        // Only the plain objects should be added (Primitive types are skipped)
		        seenObjects.add(value);
		        // Continue object decomposition
		        try {
		            return [
		                true,
		                Object.entries(value).reduce((sum, [key, nestedValue], idx, arr) => {
		                    // Recursively process next nested object or primitive type
		                    // eslint-disable-next-line prefer-const
		                    let [valid, size] = getJsonSerializableInfo(nestedValue, skipSizing);
		                    if (!valid) {
		                        throw new Error('JSON validation did not pass. Validation process stopped.');
		                    }
		                    // Circular object detection
		                    // Once a child node is visited and processed remove it from the set.
		                    // This will prevent false positives with the same adjacent objects.
		                    seenObjects.delete(value);
		                    if (skipSizing) {
		                        return 0;
		                    }
		                    // Objects will have be serialized with "key": value,
		                    // therefore we include the key in the calculation here
		                    const keySize = Array.isArray(value)
		                        ? 0
		                        : key.length + misc_1.JsonSize.Comma + misc_1.JsonSize.Colon * 2;
		                    const separator = idx < arr.length - 1 ? misc_1.JsonSize.Comma : 0;
		                    return sum + keySize + size + separator;
		                }, 
		                // Starts at 2 because the serialized JSON string data (plain text)
		                // will minimally contain {}/[]
		                skipSizing ? 0 : misc_1.JsonSize.Wrapper * 2),
		            ];
		        }
		        catch (_) {
		            return [false, 0];
		        }
		    }
		    return getJsonSerializableInfo(jsObject, skipSizingProcess);
		}
		exports.validateJsonAndGetSize = validateJsonAndGetSize;
		
	} (json));

	var logging = {};

	var browser$3 = {exports: {}};

	/**
	 * Helpers.
	 */

	var ms$1;
	var hasRequiredMs;

	function requireMs () {
		if (hasRequiredMs) return ms$1;
		hasRequiredMs = 1;
		var s = 1000;
		var m = s * 60;
		var h = m * 60;
		var d = h * 24;
		var w = d * 7;
		var y = d * 365.25;

		/**
		 * Parse or format the given `val`.
		 *
		 * Options:
		 *
		 *  - `long` verbose formatting [false]
		 *
		 * @param {String|Number} val
		 * @param {Object} [options]
		 * @throws {Error} throw an error if val is not a non-empty string or a number
		 * @return {String|Number}
		 * @api public
		 */

		ms$1 = function(val, options) {
		  options = options || {};
		  var type = typeof val;
		  if (type === 'string' && val.length > 0) {
		    return parse(val);
		  } else if (type === 'number' && isFinite(val)) {
		    return options.long ? fmtLong(val) : fmtShort(val);
		  }
		  throw new Error(
		    'val is not a non-empty string or a valid number. val=' +
		      JSON.stringify(val)
		  );
		};

		/**
		 * Parse the given `str` and return milliseconds.
		 *
		 * @param {String} str
		 * @return {Number}
		 * @api private
		 */

		function parse(str) {
		  str = String(str);
		  if (str.length > 100) {
		    return;
		  }
		  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
		    str
		  );
		  if (!match) {
		    return;
		  }
		  var n = parseFloat(match[1]);
		  var type = (match[2] || 'ms').toLowerCase();
		  switch (type) {
		    case 'years':
		    case 'year':
		    case 'yrs':
		    case 'yr':
		    case 'y':
		      return n * y;
		    case 'weeks':
		    case 'week':
		    case 'w':
		      return n * w;
		    case 'days':
		    case 'day':
		    case 'd':
		      return n * d;
		    case 'hours':
		    case 'hour':
		    case 'hrs':
		    case 'hr':
		    case 'h':
		      return n * h;
		    case 'minutes':
		    case 'minute':
		    case 'mins':
		    case 'min':
		    case 'm':
		      return n * m;
		    case 'seconds':
		    case 'second':
		    case 'secs':
		    case 'sec':
		    case 's':
		      return n * s;
		    case 'milliseconds':
		    case 'millisecond':
		    case 'msecs':
		    case 'msec':
		    case 'ms':
		      return n;
		    default:
		      return undefined;
		  }
		}

		/**
		 * Short format for `ms`.
		 *
		 * @param {Number} ms
		 * @return {String}
		 * @api private
		 */

		function fmtShort(ms) {
		  var msAbs = Math.abs(ms);
		  if (msAbs >= d) {
		    return Math.round(ms / d) + 'd';
		  }
		  if (msAbs >= h) {
		    return Math.round(ms / h) + 'h';
		  }
		  if (msAbs >= m) {
		    return Math.round(ms / m) + 'm';
		  }
		  if (msAbs >= s) {
		    return Math.round(ms / s) + 's';
		  }
		  return ms + 'ms';
		}

		/**
		 * Long format for `ms`.
		 *
		 * @param {Number} ms
		 * @return {String}
		 * @api private
		 */

		function fmtLong(ms) {
		  var msAbs = Math.abs(ms);
		  if (msAbs >= d) {
		    return plural(ms, msAbs, d, 'day');
		  }
		  if (msAbs >= h) {
		    return plural(ms, msAbs, h, 'hour');
		  }
		  if (msAbs >= m) {
		    return plural(ms, msAbs, m, 'minute');
		  }
		  if (msAbs >= s) {
		    return plural(ms, msAbs, s, 'second');
		  }
		  return ms + ' ms';
		}

		/**
		 * Pluralization helper.
		 */

		function plural(ms, msAbs, n, name) {
		  var isPlural = msAbs >= n * 1.5;
		  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
		}
		return ms$1;
	}

	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 */

	function setup(env) {
		createDebug.debug = createDebug;
		createDebug.default = createDebug;
		createDebug.coerce = coerce;
		createDebug.disable = disable;
		createDebug.enable = enable;
		createDebug.enabled = enabled;
		createDebug.humanize = requireMs();
		createDebug.destroy = destroy;

		Object.keys(env).forEach(key => {
			createDebug[key] = env[key];
		});

		/**
		* The currently active debug mode names, and names to skip.
		*/

		createDebug.names = [];
		createDebug.skips = [];

		/**
		* Map of special "%n" handling functions, for the debug "format" argument.
		*
		* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
		*/
		createDebug.formatters = {};

		/**
		* Selects a color for a debug namespace
		* @param {String} namespace The namespace string for the debug instance to be colored
		* @return {Number|String} An ANSI color code for the given namespace
		* @api private
		*/
		function selectColor(namespace) {
			let hash = 0;

			for (let i = 0; i < namespace.length; i++) {
				hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
				hash |= 0; // Convert to 32bit integer
			}

			return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
		}
		createDebug.selectColor = selectColor;

		/**
		* Create a debugger with the given `namespace`.
		*
		* @param {String} namespace
		* @return {Function}
		* @api public
		*/
		function createDebug(namespace) {
			let prevTime;
			let enableOverride = null;
			let namespacesCache;
			let enabledCache;

			function debug(...args) {
				// Disabled?
				if (!debug.enabled) {
					return;
				}

				const self = debug;

				// Set `diff` timestamp
				const curr = Number(new Date());
				const ms = curr - (prevTime || curr);
				self.diff = ms;
				self.prev = prevTime;
				self.curr = curr;
				prevTime = curr;

				args[0] = createDebug.coerce(args[0]);

				if (typeof args[0] !== 'string') {
					// Anything else let's inspect with %O
					args.unshift('%O');
				}

				// Apply any `formatters` transformations
				let index = 0;
				args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
					// If we encounter an escaped % then don't increase the array index
					if (match === '%%') {
						return '%';
					}
					index++;
					const formatter = createDebug.formatters[format];
					if (typeof formatter === 'function') {
						const val = args[index];
						match = formatter.call(self, val);

						// Now we need to remove `args[index]` since it's inlined in the `format`
						args.splice(index, 1);
						index--;
					}
					return match;
				});

				// Apply env-specific formatting (colors, etc.)
				createDebug.formatArgs.call(self, args);

				const logFn = self.log || createDebug.log;
				logFn.apply(self, args);
			}

			debug.namespace = namespace;
			debug.useColors = createDebug.useColors();
			debug.color = createDebug.selectColor(namespace);
			debug.extend = extend;
			debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

			Object.defineProperty(debug, 'enabled', {
				enumerable: true,
				configurable: false,
				get: () => {
					if (enableOverride !== null) {
						return enableOverride;
					}
					if (namespacesCache !== createDebug.namespaces) {
						namespacesCache = createDebug.namespaces;
						enabledCache = createDebug.enabled(namespace);
					}

					return enabledCache;
				},
				set: v => {
					enableOverride = v;
				}
			});

			// Env-specific initialization logic for debug instances
			if (typeof createDebug.init === 'function') {
				createDebug.init(debug);
			}

			return debug;
		}

		function extend(namespace, delimiter) {
			const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
			newDebug.log = this.log;
			return newDebug;
		}

		/**
		* Enables a debug mode by namespaces. This can include modes
		* separated by a colon and wildcards.
		*
		* @param {String} namespaces
		* @api public
		*/
		function enable(namespaces) {
			createDebug.save(namespaces);
			createDebug.namespaces = namespaces;

			createDebug.names = [];
			createDebug.skips = [];

			let i;
			const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
			const len = split.length;

			for (i = 0; i < len; i++) {
				if (!split[i]) {
					// ignore empty strings
					continue;
				}

				namespaces = split[i].replace(/\*/g, '.*?');

				if (namespaces[0] === '-') {
					createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
				} else {
					createDebug.names.push(new RegExp('^' + namespaces + '$'));
				}
			}
		}

		/**
		* Disable debug output.
		*
		* @return {String} namespaces
		* @api public
		*/
		function disable() {
			const namespaces = [
				...createDebug.names.map(toNamespace),
				...createDebug.skips.map(toNamespace).map(namespace => '-' + namespace)
			].join(',');
			createDebug.enable('');
			return namespaces;
		}

		/**
		* Returns true if the given mode name is enabled, false otherwise.
		*
		* @param {String} name
		* @return {Boolean}
		* @api public
		*/
		function enabled(name) {
			if (name[name.length - 1] === '*') {
				return true;
			}

			let i;
			let len;

			for (i = 0, len = createDebug.skips.length; i < len; i++) {
				if (createDebug.skips[i].test(name)) {
					return false;
				}
			}

			for (i = 0, len = createDebug.names.length; i < len; i++) {
				if (createDebug.names[i].test(name)) {
					return true;
				}
			}

			return false;
		}

		/**
		* Convert regexp to namespace
		*
		* @param {RegExp} regxep
		* @return {String} namespace
		* @api private
		*/
		function toNamespace(regexp) {
			return regexp.toString()
				.substring(2, regexp.toString().length - 2)
				.replace(/\.\*\?$/, '*');
		}

		/**
		* Coerce `val`.
		*
		* @param {Mixed} val
		* @return {Mixed}
		* @api private
		*/
		function coerce(val) {
			if (val instanceof Error) {
				return val.stack || val.message;
			}
			return val;
		}

		/**
		* XXX DO NOT USE. This is a temporary stub function.
		* XXX It WILL be removed in the next major release.
		*/
		function destroy() {
			console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
		}

		createDebug.enable(createDebug.load());

		return createDebug;
	}

	var common = setup;

	/* eslint-env browser */

	(function (module, exports) {
		/**
		 * This is the web browser implementation of `debug()`.
		 */

		exports.formatArgs = formatArgs;
		exports.save = save;
		exports.load = load;
		exports.useColors = useColors;
		exports.storage = localstorage();
		exports.destroy = (() => {
			let warned = false;

			return () => {
				if (!warned) {
					warned = true;
					console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
				}
			};
		})();

		/**
		 * Colors.
		 */

		exports.colors = [
			'#0000CC',
			'#0000FF',
			'#0033CC',
			'#0033FF',
			'#0066CC',
			'#0066FF',
			'#0099CC',
			'#0099FF',
			'#00CC00',
			'#00CC33',
			'#00CC66',
			'#00CC99',
			'#00CCCC',
			'#00CCFF',
			'#3300CC',
			'#3300FF',
			'#3333CC',
			'#3333FF',
			'#3366CC',
			'#3366FF',
			'#3399CC',
			'#3399FF',
			'#33CC00',
			'#33CC33',
			'#33CC66',
			'#33CC99',
			'#33CCCC',
			'#33CCFF',
			'#6600CC',
			'#6600FF',
			'#6633CC',
			'#6633FF',
			'#66CC00',
			'#66CC33',
			'#9900CC',
			'#9900FF',
			'#9933CC',
			'#9933FF',
			'#99CC00',
			'#99CC33',
			'#CC0000',
			'#CC0033',
			'#CC0066',
			'#CC0099',
			'#CC00CC',
			'#CC00FF',
			'#CC3300',
			'#CC3333',
			'#CC3366',
			'#CC3399',
			'#CC33CC',
			'#CC33FF',
			'#CC6600',
			'#CC6633',
			'#CC9900',
			'#CC9933',
			'#CCCC00',
			'#CCCC33',
			'#FF0000',
			'#FF0033',
			'#FF0066',
			'#FF0099',
			'#FF00CC',
			'#FF00FF',
			'#FF3300',
			'#FF3333',
			'#FF3366',
			'#FF3399',
			'#FF33CC',
			'#FF33FF',
			'#FF6600',
			'#FF6633',
			'#FF9900',
			'#FF9933',
			'#FFCC00',
			'#FFCC33'
		];

		/**
		 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
		 * and the Firebug extension (any Firefox version) are known
		 * to support "%c" CSS customizations.
		 *
		 * TODO: add a `localStorage` variable to explicitly enable/disable colors
		 */

		// eslint-disable-next-line complexity
		function useColors() {
			// NB: In an Electron preload script, document will be defined but not fully
			// initialized. Since we know we're in Chrome, we'll just detect this case
			// explicitly
			if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
				return true;
			}

			// Internet Explorer and Edge do not support colors.
			if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
				return false;
			}

			// Is webkit? http://stackoverflow.com/a/16459606/376773
			// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
			return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
				// Is firebug? http://stackoverflow.com/a/398120/376773
				(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
				// Is firefox >= v31?
				// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
				(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
				// Double check webkit in userAgent just in case we are in a worker
				(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
		}

		/**
		 * Colorize log arguments if enabled.
		 *
		 * @api public
		 */

		function formatArgs(args) {
			args[0] = (this.useColors ? '%c' : '') +
				this.namespace +
				(this.useColors ? ' %c' : ' ') +
				args[0] +
				(this.useColors ? '%c ' : ' ') +
				'+' + module.exports.humanize(this.diff);

			if (!this.useColors) {
				return;
			}

			const c = 'color: ' + this.color;
			args.splice(1, 0, c, 'color: inherit');

			// The final "%c" is somewhat tricky, because there could be other
			// arguments passed either before or after the %c, so we need to
			// figure out the correct index to insert the CSS into
			let index = 0;
			let lastC = 0;
			args[0].replace(/%[a-zA-Z%]/g, match => {
				if (match === '%%') {
					return;
				}
				index++;
				if (match === '%c') {
					// We only are interested in the *last* %c
					// (the user may have provided their own)
					lastC = index;
				}
			});

			args.splice(lastC, 0, c);
		}

		/**
		 * Invokes `console.debug()` when available.
		 * No-op when `console.debug` is not a "function".
		 * If `console.debug` is not available, falls back
		 * to `console.log`.
		 *
		 * @api public
		 */
		exports.log = console.debug || console.log || (() => {});

		/**
		 * Save `namespaces`.
		 *
		 * @param {String} namespaces
		 * @api private
		 */
		function save(namespaces) {
			try {
				if (namespaces) {
					exports.storage.setItem('debug', namespaces);
				} else {
					exports.storage.removeItem('debug');
				}
			} catch (error) {
				// Swallow
				// XXX (@Qix-) should we be logging these?
			}
		}

		/**
		 * Load `namespaces`.
		 *
		 * @return {String} returns the previously persisted debug modes
		 * @api private
		 */
		function load() {
			let r;
			try {
				r = exports.storage.getItem('debug');
			} catch (error) {
				// Swallow
				// XXX (@Qix-) should we be logging these?
			}

			// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
			if (!r && typeof process !== 'undefined' && 'env' in process) {
				r = "production".DEBUG;
			}

			return r;
		}

		/**
		 * Localstorage attempts to return the localstorage.
		 *
		 * This is necessary because safari throws
		 * when a user disables cookies/localstorage
		 * and you attempt to access it.
		 *
		 * @return {LocalStorage}
		 * @api private
		 */

		function localstorage() {
			try {
				// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
				// The Browser also has localStorage in the global context.
				return localStorage;
			} catch (error) {
				// Swallow
				// XXX (@Qix-) should we be logging these?
			}
		}

		module.exports = common(exports);

		const {formatters} = module.exports;

		/**
		 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
		 */

		formatters.j = function (v) {
			try {
				return JSON.stringify(v);
			} catch (error) {
				return '[UnexpectedJSONParseError]: ' + error.message;
			}
		}; 
	} (browser$3, browser$3.exports));

	var browserExports = browser$3.exports;

	var __importDefault$c = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(logging, "__esModule", { value: true });
	logging.createModuleLogger = logging.createProjectLogger = void 0;
	const debug_1$1 = __importDefault$c(browserExports);
	const globalLogger = (0, debug_1$1.default)('metamask');
	/**
	 * Creates a logger via the `debug` library whose log messages will be tagged
	 * using the name of your project. By default, such messages will be
	 * suppressed, but you can reveal them by setting the `DEBUG` environment
	 * variable to `metamask:<projectName>`. You can also set this variable to
	 * `metamask:*` if you want to see log messages from all MetaMask projects that
	 * are also using this function to create their loggers.
	 *
	 * @param projectName - The name of your project. This should be the name of
	 * your NPM package if you're developing one.
	 * @returns An instance of `debug`.
	 */
	function createProjectLogger(projectName) {
	    return globalLogger.extend(projectName);
	}
	logging.createProjectLogger = createProjectLogger;
	/**
	 * Creates a logger via the `debug` library which is derived from the logger for
	 * the whole project whose log messages will be tagged using the name of your
	 * module. By default, such messages will be suppressed, but you can reveal them
	 * by setting the `DEBUG` environment variable to
	 * `metamask:<projectName>:<moduleName>`. You can also set this variable to
	 * `metamask:<projectName>:*` if you want to see log messages from the project,
	 * or `metamask:*` if you want to see log messages from all MetaMask projects.
	 *
	 * @param projectLogger - The logger created via {@link createProjectLogger}.
	 * @param moduleName - The name of your module. You could use the name of the
	 * file where you're using this logger or some other name.
	 * @returns An instance of `debug`.
	 */
	function createModuleLogger(projectLogger, moduleName) {
	    return projectLogger.extend(moduleName);
	}
	logging.createModuleLogger = createModuleLogger;

	var number = {};

	Object.defineProperty(number, "__esModule", { value: true });
	number.hexToBigInt = number.hexToNumber = number.bigIntToHex = number.numberToHex = void 0;
	const assert_1 = assert$2;
	const hex_1 = hex;
	/**
	 * Convert a number to a hexadecimal string. This verifies that the number is a
	 * non-negative safe integer.
	 *
	 * To convert a `bigint` to a hexadecimal string instead, use
	 * {@link bigIntToHex}.
	 *
	 * @example
	 * ```typescript
	 * numberToHex(0); // '0x0'
	 * numberToHex(1); // '0x1'
	 * numberToHex(16); // '0x10'
	 * ```
	 * @param value - The number to convert to a hexadecimal string.
	 * @returns The hexadecimal string, with the "0x"-prefix.
	 * @throws If the number is not a non-negative safe integer.
	 */
	const numberToHex = (value) => {
	    (0, assert_1.assert)(typeof value === 'number', 'Value must be a number.');
	    (0, assert_1.assert)(value >= 0, 'Value must be a non-negative number.');
	    (0, assert_1.assert)(Number.isSafeInteger(value), 'Value is not a safe integer. Use `bigIntToHex` instead.');
	    return (0, hex_1.add0x)(value.toString(16));
	};
	number.numberToHex = numberToHex;
	/**
	 * Convert a `bigint` to a hexadecimal string. This verifies that the `bigint`
	 * is a non-negative integer.
	 *
	 * To convert a number to a hexadecimal string instead, use {@link numberToHex}.
	 *
	 * @example
	 * ```typescript
	 * bigIntToHex(0n); // '0x0'
	 * bigIntToHex(1n); // '0x1'
	 * bigIntToHex(16n); // '0x10'
	 * ```
	 * @param value - The `bigint` to convert to a hexadecimal string.
	 * @returns The hexadecimal string, with the "0x"-prefix.
	 * @throws If the `bigint` is not a non-negative integer.
	 */
	const bigIntToHex = (value) => {
	    (0, assert_1.assert)(typeof value === 'bigint', 'Value must be a bigint.');
	    (0, assert_1.assert)(value >= 0, 'Value must be a non-negative bigint.');
	    return (0, hex_1.add0x)(value.toString(16));
	};
	number.bigIntToHex = bigIntToHex;
	/**
	 * Convert a hexadecimal string to a number. This verifies that the string is a
	 * valid hex string, and that the resulting number is a safe integer. Both
	 * "0x"-prefixed and unprefixed strings are supported.
	 *
	 * To convert a hexadecimal string to a `bigint` instead, use
	 * {@link hexToBigInt}.
	 *
	 * @example
	 * ```typescript
	 * hexToNumber('0x0'); // 0
	 * hexToNumber('0x1'); // 1
	 * hexToNumber('0x10'); // 16
	 * ```
	 * @param value - The hexadecimal string to convert to a number.
	 * @returns The number.
	 * @throws If the value is not a valid hexadecimal string, or if the resulting
	 * number is not a safe integer.
	 */
	const hexToNumber = (value) => {
	    (0, hex_1.assertIsHexString)(value);
	    // `parseInt` accepts values without the "0x"-prefix, whereas `Number` does
	    // not. Using this is slightly faster than `Number(add0x(value))`.
	    const numberValue = parseInt(value, 16);
	    (0, assert_1.assert)(Number.isSafeInteger(numberValue), 'Value is not a safe integer. Use `hexToBigInt` instead.');
	    return numberValue;
	};
	number.hexToNumber = hexToNumber;
	/**
	 * Convert a hexadecimal string to a `bigint`. This verifies that the string is
	 * a valid hex string. Both "0x"-prefixed and unprefixed strings are supported.
	 *
	 * To convert a hexadecimal string to a number instead, use {@link hexToNumber}.
	 *
	 * @example
	 * ```typescript
	 * hexToBigInt('0x0'); // 0n
	 * hexToBigInt('0x1'); // 1n
	 * hexToBigInt('0x10'); // 16n
	 * ```
	 * @param value - The hexadecimal string to convert to a `bigint`.
	 * @returns The `bigint`.
	 * @throws If the value is not a valid hexadecimal string.
	 */
	const hexToBigInt = (value) => {
	    (0, hex_1.assertIsHexString)(value);
	    // The `BigInt` constructor requires the "0x"-prefix to parse a hex string.
	    return BigInt((0, hex_1.add0x)(value));
	};
	number.hexToBigInt = hexToBigInt;

	var opaque = {};

	Object.defineProperty(opaque, "__esModule", { value: true });

	var time$1 = {};

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.timeSince = exports.inMilliseconds = exports.Duration = void 0;
		(function (Duration) {
		    /**
		     * A millisecond.
		     */
		    Duration[Duration["Millisecond"] = 1] = "Millisecond";
		    /**
		     * A second, in milliseconds.
		     */
		    Duration[Duration["Second"] = 1000] = "Second";
		    /**
		     * A minute, in milliseconds.
		     */
		    Duration[Duration["Minute"] = 60000] = "Minute";
		    /**
		     * An hour, in milliseconds.
		     */
		    Duration[Duration["Hour"] = 3600000] = "Hour";
		    /**
		     * A day, in milliseconds.
		     */
		    Duration[Duration["Day"] = 86400000] = "Day";
		    /**
		     * A week, in milliseconds.
		     */
		    Duration[Duration["Week"] = 604800000] = "Week";
		    /**
		     * A year, in milliseconds.
		     */
		    Duration[Duration["Year"] = 31536000000] = "Year";
		})(exports.Duration || (exports.Duration = {}));
		const isNonNegativeInteger = (number) => Number.isInteger(number) && number >= 0;
		const assertIsNonNegativeInteger = (number, name) => {
		    if (!isNonNegativeInteger(number)) {
		        throw new Error(`"${name}" must be a non-negative integer. Received: "${number}".`);
		    }
		};
		/**
		 * Calculates the millisecond value of the specified number of units of time.
		 *
		 * @param count - The number of units of time.
		 * @param duration - The unit of time to count.
		 * @returns The count multiplied by the specified duration.
		 */
		function inMilliseconds(count, duration) {
		    assertIsNonNegativeInteger(count, 'count');
		    return count * duration;
		}
		exports.inMilliseconds = inMilliseconds;
		/**
		 * Gets the milliseconds since a particular Unix epoch timestamp.
		 *
		 * @param timestamp - A Unix millisecond timestamp.
		 * @returns The number of milliseconds elapsed since the specified timestamp.
		 */
		function timeSince(timestamp) {
		    assertIsNonNegativeInteger(timestamp, 'timestamp');
		    return Date.now() - timestamp;
		}
		exports.timeSince = timeSince;
		
	} (time$1));

	var versions = {};

	var re$4 = {exports: {}};

	// Note: this is the semver.org version of the spec that it implements
	// Not necessarily the package version of this code.
	const SEMVER_SPEC_VERSION = '2.0.0';

	const MAX_LENGTH$1 = 256;
	const MAX_SAFE_INTEGER$1 = Number.MAX_SAFE_INTEGER ||
	/* istanbul ignore next */ 9007199254740991;

	// Max safe segment length for coercion.
	const MAX_SAFE_COMPONENT_LENGTH = 16;

	// Max safe length for a build identifier. The max length minus 6 characters for
	// the shortest version with a build 0.0.0+BUILD.
	const MAX_SAFE_BUILD_LENGTH = MAX_LENGTH$1 - 6;

	const RELEASE_TYPES = [
	  'major',
	  'premajor',
	  'minor',
	  'preminor',
	  'patch',
	  'prepatch',
	  'prerelease',
	];

	var constants$4 = {
	  MAX_LENGTH: MAX_LENGTH$1,
	  MAX_SAFE_COMPONENT_LENGTH,
	  MAX_SAFE_BUILD_LENGTH,
	  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$1,
	  RELEASE_TYPES,
	  SEMVER_SPEC_VERSION,
	  FLAG_INCLUDE_PRERELEASE: 0b001,
	  FLAG_LOOSE: 0b010,
	};

	const debug$1 = (
	  typeof process === 'object' &&
	  process.env &&
	  process.env.NODE_DEBUG &&
	  /\bsemver\b/i.test(process.env.NODE_DEBUG)
	) ? (...args) => console.error('SEMVER', ...args)
	  : () => {};

	var debug_1 = debug$1;

	(function (module, exports) {
		const {
		  MAX_SAFE_COMPONENT_LENGTH,
		  MAX_SAFE_BUILD_LENGTH,
		  MAX_LENGTH,
		} = constants$4;
		const debug = debug_1;
		exports = module.exports = {};

		// The actual regexps go on exports.re
		const re = exports.re = [];
		const safeRe = exports.safeRe = [];
		const src = exports.src = [];
		const t = exports.t = {};
		let R = 0;

		const LETTERDASHNUMBER = '[a-zA-Z0-9-]';

		// Replace some greedy regex tokens to prevent regex dos issues. These regex are
		// used internally via the safeRe object since all inputs in this library get
		// normalized first to trim and collapse all extra whitespace. The original
		// regexes are exported for userland consumption and lower level usage. A
		// future breaking change could export the safer regex only with a note that
		// all input should have extra whitespace removed.
		const safeRegexReplacements = [
		  ['\\s', 1],
		  ['\\d', MAX_LENGTH],
		  [LETTERDASHNUMBER, MAX_SAFE_BUILD_LENGTH],
		];

		const makeSafeRegex = (value) => {
		  for (const [token, max] of safeRegexReplacements) {
		    value = value
		      .split(`${token}*`).join(`${token}{0,${max}}`)
		      .split(`${token}+`).join(`${token}{1,${max}}`);
		  }
		  return value
		};

		const createToken = (name, value, isGlobal) => {
		  const safe = makeSafeRegex(value);
		  const index = R++;
		  debug(name, index, value);
		  t[name] = index;
		  src[index] = value;
		  re[index] = new RegExp(value, isGlobal ? 'g' : undefined);
		  safeRe[index] = new RegExp(safe, isGlobal ? 'g' : undefined);
		};

		// The following Regular Expressions can be used for tokenizing,
		// validating, and parsing SemVer version strings.

		// ## Numeric Identifier
		// A single `0`, or a non-zero digit followed by zero or more digits.

		createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
		createToken('NUMERICIDENTIFIERLOOSE', '\\d+');

		// ## Non-numeric Identifier
		// Zero or more digits, followed by a letter or hyphen, and then zero or
		// more letters, digits, or hyphens.

		createToken('NONNUMERICIDENTIFIER', `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);

		// ## Main Version
		// Three dot-separated numeric identifiers.

		createToken('MAINVERSION', `(${src[t.NUMERICIDENTIFIER]})\\.` +
		                   `(${src[t.NUMERICIDENTIFIER]})\\.` +
		                   `(${src[t.NUMERICIDENTIFIER]})`);

		createToken('MAINVERSIONLOOSE', `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` +
		                        `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` +
		                        `(${src[t.NUMERICIDENTIFIERLOOSE]})`);

		// ## Pre-release Version Identifier
		// A numeric identifier, or a non-numeric identifier.

		createToken('PRERELEASEIDENTIFIER', `(?:${src[t.NUMERICIDENTIFIER]
	}|${src[t.NONNUMERICIDENTIFIER]})`);

		createToken('PRERELEASEIDENTIFIERLOOSE', `(?:${src[t.NUMERICIDENTIFIERLOOSE]
	}|${src[t.NONNUMERICIDENTIFIER]})`);

		// ## Pre-release Version
		// Hyphen, followed by one or more dot-separated pre-release version
		// identifiers.

		createToken('PRERELEASE', `(?:-(${src[t.PRERELEASEIDENTIFIER]
	}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);

		createToken('PRERELEASELOOSE', `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]
	}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);

		// ## Build Metadata Identifier
		// Any combination of digits, letters, or hyphens.

		createToken('BUILDIDENTIFIER', `${LETTERDASHNUMBER}+`);

		// ## Build Metadata
		// Plus sign, followed by one or more period-separated build metadata
		// identifiers.

		createToken('BUILD', `(?:\\+(${src[t.BUILDIDENTIFIER]
	}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);

		// ## Full Version String
		// A main version, followed optionally by a pre-release version and
		// build metadata.

		// Note that the only major, minor, patch, and pre-release sections of
		// the version string are capturing groups.  The build metadata is not a
		// capturing group, because it should not ever be used in version
		// comparison.

		createToken('FULLPLAIN', `v?${src[t.MAINVERSION]
	}${src[t.PRERELEASE]}?${
	  src[t.BUILD]}?`);

		createToken('FULL', `^${src[t.FULLPLAIN]}$`);

		// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
		// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
		// common in the npm registry.
		createToken('LOOSEPLAIN', `[v=\\s]*${src[t.MAINVERSIONLOOSE]
	}${src[t.PRERELEASELOOSE]}?${
	  src[t.BUILD]}?`);

		createToken('LOOSE', `^${src[t.LOOSEPLAIN]}$`);

		createToken('GTLT', '((?:<|>)?=?)');

		// Something like "2.*" or "1.2.x".
		// Note that "x.x" is a valid xRange identifer, meaning "any version"
		// Only the first item is strictly required.
		createToken('XRANGEIDENTIFIERLOOSE', `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
		createToken('XRANGEIDENTIFIER', `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);

		createToken('XRANGEPLAIN', `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` +
		                   `(?:\\.(${src[t.XRANGEIDENTIFIER]})` +
		                   `(?:\\.(${src[t.XRANGEIDENTIFIER]})` +
		                   `(?:${src[t.PRERELEASE]})?${
	                     src[t.BUILD]}?` +
		                   `)?)?`);

		createToken('XRANGEPLAINLOOSE', `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` +
		                        `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` +
		                        `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` +
		                        `(?:${src[t.PRERELEASELOOSE]})?${
	                          src[t.BUILD]}?` +
		                        `)?)?`);

		createToken('XRANGE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
		createToken('XRANGELOOSE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);

		// Coercion.
		// Extract anything that could conceivably be a part of a valid semver
		createToken('COERCE', `${'(^|[^\\d])' +
	              '(\\d{1,'}${MAX_SAFE_COMPONENT_LENGTH}})` +
		              `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?` +
		              `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?` +
		              `(?:$|[^\\d])`);
		createToken('COERCERTL', src[t.COERCE], true);

		// Tilde ranges.
		// Meaning is "reasonably at or greater than"
		createToken('LONETILDE', '(?:~>?)');

		createToken('TILDETRIM', `(\\s*)${src[t.LONETILDE]}\\s+`, true);
		exports.tildeTrimReplace = '$1~';

		createToken('TILDE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
		createToken('TILDELOOSE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);

		// Caret ranges.
		// Meaning is "at least and backwards compatible with"
		createToken('LONECARET', '(?:\\^)');

		createToken('CARETTRIM', `(\\s*)${src[t.LONECARET]}\\s+`, true);
		exports.caretTrimReplace = '$1^';

		createToken('CARET', `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
		createToken('CARETLOOSE', `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);

		// A simple gt/lt/eq thing, or just "" to indicate "any version"
		createToken('COMPARATORLOOSE', `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
		createToken('COMPARATOR', `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);

		// An expression to strip any whitespace between the gtlt and the thing
		// it modifies, so that `> 1.2.3` ==> `>1.2.3`
		createToken('COMPARATORTRIM', `(\\s*)${src[t.GTLT]
	}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
		exports.comparatorTrimReplace = '$1$2$3';

		// Something like `1.2.3 - 1.2.4`
		// Note that these all use the loose form, because they'll be
		// checked against either the strict or loose comparator form
		// later.
		createToken('HYPHENRANGE', `^\\s*(${src[t.XRANGEPLAIN]})` +
		                   `\\s+-\\s+` +
		                   `(${src[t.XRANGEPLAIN]})` +
		                   `\\s*$`);

		createToken('HYPHENRANGELOOSE', `^\\s*(${src[t.XRANGEPLAINLOOSE]})` +
		                        `\\s+-\\s+` +
		                        `(${src[t.XRANGEPLAINLOOSE]})` +
		                        `\\s*$`);

		// Star ranges basically just allow anything at all.
		createToken('STAR', '(<|>)?=?\\s*\\*');
		// >=0.0.0 is like a star
		createToken('GTE0', '^\\s*>=\\s*0\\.0\\.0\\s*$');
		createToken('GTE0PRE', '^\\s*>=\\s*0\\.0\\.0-0\\s*$'); 
	} (re$4, re$4.exports));

	var reExports = re$4.exports;

	// parse out just the options we care about
	const looseOption = Object.freeze({ loose: true });
	const emptyOpts = Object.freeze({ });
	const parseOptions$1 = options => {
	  if (!options) {
	    return emptyOpts
	  }

	  if (typeof options !== 'object') {
	    return looseOption
	  }

	  return options
	};
	var parseOptions_1 = parseOptions$1;

	const numeric$1 = /^[0-9]+$/;
	const compareIdentifiers$1 = (a, b) => {
	  const anum = numeric$1.test(a);
	  const bnum = numeric$1.test(b);

	  if (anum && bnum) {
	    a = +a;
	    b = +b;
	  }

	  return a === b ? 0
	    : (anum && !bnum) ? -1
	    : (bnum && !anum) ? 1
	    : a < b ? -1
	    : 1
	};

	const rcompareIdentifiers = (a, b) => compareIdentifiers$1(b, a);

	var identifiers$1 = {
	  compareIdentifiers: compareIdentifiers$1,
	  rcompareIdentifiers,
	};

	const debug = debug_1;
	const { MAX_LENGTH, MAX_SAFE_INTEGER } = constants$4;
	const { safeRe: re$3, t: t$8 } = reExports;

	const parseOptions = parseOptions_1;
	const { compareIdentifiers } = identifiers$1;
	let SemVer$d = class SemVer {
	  constructor (version, options) {
	    options = parseOptions(options);

	    if (version instanceof SemVer) {
	      if (version.loose === !!options.loose &&
	          version.includePrerelease === !!options.includePrerelease) {
	        return version
	      } else {
	        version = version.version;
	      }
	    } else if (typeof version !== 'string') {
	      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`)
	    }

	    if (version.length > MAX_LENGTH) {
	      throw new TypeError(
	        `version is longer than ${MAX_LENGTH} characters`
	      )
	    }

	    debug('SemVer', version, options);
	    this.options = options;
	    this.loose = !!options.loose;
	    // this isn't actually relevant for versions, but keep it so that we
	    // don't run into trouble passing this.options around.
	    this.includePrerelease = !!options.includePrerelease;

	    const m = version.trim().match(options.loose ? re$3[t$8.LOOSE] : re$3[t$8.FULL]);

	    if (!m) {
	      throw new TypeError(`Invalid Version: ${version}`)
	    }

	    this.raw = version;

	    // these are actually numbers
	    this.major = +m[1];
	    this.minor = +m[2];
	    this.patch = +m[3];

	    if (this.major > MAX_SAFE_INTEGER || this.major < 0) {
	      throw new TypeError('Invalid major version')
	    }

	    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) {
	      throw new TypeError('Invalid minor version')
	    }

	    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) {
	      throw new TypeError('Invalid patch version')
	    }

	    // numberify any prerelease numeric ids
	    if (!m[4]) {
	      this.prerelease = [];
	    } else {
	      this.prerelease = m[4].split('.').map((id) => {
	        if (/^[0-9]+$/.test(id)) {
	          const num = +id;
	          if (num >= 0 && num < MAX_SAFE_INTEGER) {
	            return num
	          }
	        }
	        return id
	      });
	    }

	    this.build = m[5] ? m[5].split('.') : [];
	    this.format();
	  }

	  format () {
	    this.version = `${this.major}.${this.minor}.${this.patch}`;
	    if (this.prerelease.length) {
	      this.version += `-${this.prerelease.join('.')}`;
	    }
	    return this.version
	  }

	  toString () {
	    return this.version
	  }

	  compare (other) {
	    debug('SemVer.compare', this.version, this.options, other);
	    if (!(other instanceof SemVer)) {
	      if (typeof other === 'string' && other === this.version) {
	        return 0
	      }
	      other = new SemVer(other, this.options);
	    }

	    if (other.version === this.version) {
	      return 0
	    }

	    return this.compareMain(other) || this.comparePre(other)
	  }

	  compareMain (other) {
	    if (!(other instanceof SemVer)) {
	      other = new SemVer(other, this.options);
	    }

	    return (
	      compareIdentifiers(this.major, other.major) ||
	      compareIdentifiers(this.minor, other.minor) ||
	      compareIdentifiers(this.patch, other.patch)
	    )
	  }

	  comparePre (other) {
	    if (!(other instanceof SemVer)) {
	      other = new SemVer(other, this.options);
	    }

	    // NOT having a prerelease is > having one
	    if (this.prerelease.length && !other.prerelease.length) {
	      return -1
	    } else if (!this.prerelease.length && other.prerelease.length) {
	      return 1
	    } else if (!this.prerelease.length && !other.prerelease.length) {
	      return 0
	    }

	    let i = 0;
	    do {
	      const a = this.prerelease[i];
	      const b = other.prerelease[i];
	      debug('prerelease compare', i, a, b);
	      if (a === undefined && b === undefined) {
	        return 0
	      } else if (b === undefined) {
	        return 1
	      } else if (a === undefined) {
	        return -1
	      } else if (a === b) {
	        continue
	      } else {
	        return compareIdentifiers(a, b)
	      }
	    } while (++i)
	  }

	  compareBuild (other) {
	    if (!(other instanceof SemVer)) {
	      other = new SemVer(other, this.options);
	    }

	    let i = 0;
	    do {
	      const a = this.build[i];
	      const b = other.build[i];
	      debug('prerelease compare', i, a, b);
	      if (a === undefined && b === undefined) {
	        return 0
	      } else if (b === undefined) {
	        return 1
	      } else if (a === undefined) {
	        return -1
	      } else if (a === b) {
	        continue
	      } else {
	        return compareIdentifiers(a, b)
	      }
	    } while (++i)
	  }

	  // preminor will bump the version up to the next minor release, and immediately
	  // down to pre-release. premajor and prepatch work the same way.
	  inc (release, identifier, identifierBase) {
	    switch (release) {
	      case 'premajor':
	        this.prerelease.length = 0;
	        this.patch = 0;
	        this.minor = 0;
	        this.major++;
	        this.inc('pre', identifier, identifierBase);
	        break
	      case 'preminor':
	        this.prerelease.length = 0;
	        this.patch = 0;
	        this.minor++;
	        this.inc('pre', identifier, identifierBase);
	        break
	      case 'prepatch':
	        // If this is already a prerelease, it will bump to the next version
	        // drop any prereleases that might already exist, since they are not
	        // relevant at this point.
	        this.prerelease.length = 0;
	        this.inc('patch', identifier, identifierBase);
	        this.inc('pre', identifier, identifierBase);
	        break
	      // If the input is a non-prerelease version, this acts the same as
	      // prepatch.
	      case 'prerelease':
	        if (this.prerelease.length === 0) {
	          this.inc('patch', identifier, identifierBase);
	        }
	        this.inc('pre', identifier, identifierBase);
	        break

	      case 'major':
	        // If this is a pre-major version, bump up to the same major version.
	        // Otherwise increment major.
	        // 1.0.0-5 bumps to 1.0.0
	        // 1.1.0 bumps to 2.0.0
	        if (
	          this.minor !== 0 ||
	          this.patch !== 0 ||
	          this.prerelease.length === 0
	        ) {
	          this.major++;
	        }
	        this.minor = 0;
	        this.patch = 0;
	        this.prerelease = [];
	        break
	      case 'minor':
	        // If this is a pre-minor version, bump up to the same minor version.
	        // Otherwise increment minor.
	        // 1.2.0-5 bumps to 1.2.0
	        // 1.2.1 bumps to 1.3.0
	        if (this.patch !== 0 || this.prerelease.length === 0) {
	          this.minor++;
	        }
	        this.patch = 0;
	        this.prerelease = [];
	        break
	      case 'patch':
	        // If this is not a pre-release version, it will increment the patch.
	        // If it is a pre-release it will bump up to the same patch version.
	        // 1.2.0-5 patches to 1.2.0
	        // 1.2.0 patches to 1.2.1
	        if (this.prerelease.length === 0) {
	          this.patch++;
	        }
	        this.prerelease = [];
	        break
	      // This probably shouldn't be used publicly.
	      // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
	      case 'pre': {
	        const base = Number(identifierBase) ? 1 : 0;

	        if (!identifier && identifierBase === false) {
	          throw new Error('invalid increment argument: identifier is empty')
	        }

	        if (this.prerelease.length === 0) {
	          this.prerelease = [base];
	        } else {
	          let i = this.prerelease.length;
	          while (--i >= 0) {
	            if (typeof this.prerelease[i] === 'number') {
	              this.prerelease[i]++;
	              i = -2;
	            }
	          }
	          if (i === -1) {
	            // didn't increment anything
	            if (identifier === this.prerelease.join('.') && identifierBase === false) {
	              throw new Error('invalid increment argument: identifier already exists')
	            }
	            this.prerelease.push(base);
	          }
	        }
	        if (identifier) {
	          // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
	          // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
	          let prerelease = [identifier, base];
	          if (identifierBase === false) {
	            prerelease = [identifier];
	          }
	          if (compareIdentifiers(this.prerelease[0], identifier) === 0) {
	            if (isNaN(this.prerelease[1])) {
	              this.prerelease = prerelease;
	            }
	          } else {
	            this.prerelease = prerelease;
	          }
	        }
	        break
	      }
	      default:
	        throw new Error(`invalid increment argument: ${release}`)
	    }
	    this.raw = this.format();
	    if (this.build.length) {
	      this.raw += `+${this.build.join('.')}`;
	    }
	    return this
	  }
	};

	var semver$1 = SemVer$d;

	const SemVer$c = semver$1;
	const parse$6 = (version, options, throwErrors = false) => {
	  if (version instanceof SemVer$c) {
	    return version
	  }
	  try {
	    return new SemVer$c(version, options)
	  } catch (er) {
	    if (!throwErrors) {
	      return null
	    }
	    throw er
	  }
	};

	var parse_1 = parse$6;

	const parse$5 = parse_1;
	const valid$2 = (version, options) => {
	  const v = parse$5(version, options);
	  return v ? v.version : null
	};
	var valid_1 = valid$2;

	const parse$4 = parse_1;
	const clean$1 = (version, options) => {
	  const s = parse$4(version.trim().replace(/^[=v]+/, ''), options);
	  return s ? s.version : null
	};
	var clean_1 = clean$1;

	const SemVer$b = semver$1;

	const inc$1 = (version, release, options, identifier, identifierBase) => {
	  if (typeof (options) === 'string') {
	    identifierBase = identifier;
	    identifier = options;
	    options = undefined;
	  }

	  try {
	    return new SemVer$b(
	      version instanceof SemVer$b ? version.version : version,
	      options
	    ).inc(release, identifier, identifierBase).version
	  } catch (er) {
	    return null
	  }
	};
	var inc_1 = inc$1;

	const parse$3 = parse_1;

	const diff$1 = (version1, version2) => {
	  const v1 = parse$3(version1, null, true);
	  const v2 = parse$3(version2, null, true);
	  const comparison = v1.compare(v2);

	  if (comparison === 0) {
	    return null
	  }

	  const v1Higher = comparison > 0;
	  const highVersion = v1Higher ? v1 : v2;
	  const lowVersion = v1Higher ? v2 : v1;
	  const highHasPre = !!highVersion.prerelease.length;
	  const lowHasPre = !!lowVersion.prerelease.length;

	  if (lowHasPre && !highHasPre) {
	    // Going from prerelease -> no prerelease requires some special casing

	    // If the low version has only a major, then it will always be a major
	    // Some examples:
	    // 1.0.0-1 -> 1.0.0
	    // 1.0.0-1 -> 1.1.1
	    // 1.0.0-1 -> 2.0.0
	    if (!lowVersion.patch && !lowVersion.minor) {
	      return 'major'
	    }

	    // Otherwise it can be determined by checking the high version

	    if (highVersion.patch) {
	      // anything higher than a patch bump would result in the wrong version
	      return 'patch'
	    }

	    if (highVersion.minor) {
	      // anything higher than a minor bump would result in the wrong version
	      return 'minor'
	    }

	    // bumping major/minor/patch all have same result
	    return 'major'
	  }

	  // add the `pre` prefix if we are going to a prerelease version
	  const prefix = highHasPre ? 'pre' : '';

	  if (v1.major !== v2.major) {
	    return prefix + 'major'
	  }

	  if (v1.minor !== v2.minor) {
	    return prefix + 'minor'
	  }

	  if (v1.patch !== v2.patch) {
	    return prefix + 'patch'
	  }

	  // high and low are preleases
	  return 'prerelease'
	};

	var diff_1 = diff$1;

	const SemVer$a = semver$1;
	const major$1 = (a, loose) => new SemVer$a(a, loose).major;
	var major_1 = major$1;

	const SemVer$9 = semver$1;
	const minor$1 = (a, loose) => new SemVer$9(a, loose).minor;
	var minor_1 = minor$1;

	const SemVer$8 = semver$1;
	const patch$1 = (a, loose) => new SemVer$8(a, loose).patch;
	var patch_1 = patch$1;

	const parse$2 = parse_1;
	const prerelease$1 = (version, options) => {
	  const parsed = parse$2(version, options);
	  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null
	};
	var prerelease_1 = prerelease$1;

	const SemVer$7 = semver$1;
	const compare$b = (a, b, loose) =>
	  new SemVer$7(a, loose).compare(new SemVer$7(b, loose));

	var compare_1 = compare$b;

	const compare$a = compare_1;
	const rcompare$1 = (a, b, loose) => compare$a(b, a, loose);
	var rcompare_1 = rcompare$1;

	const compare$9 = compare_1;
	const compareLoose$1 = (a, b) => compare$9(a, b, true);
	var compareLoose_1 = compareLoose$1;

	const SemVer$6 = semver$1;
	const compareBuild$3 = (a, b, loose) => {
	  const versionA = new SemVer$6(a, loose);
	  const versionB = new SemVer$6(b, loose);
	  return versionA.compare(versionB) || versionA.compareBuild(versionB)
	};
	var compareBuild_1 = compareBuild$3;

	const compareBuild$2 = compareBuild_1;
	const sort$1 = (list, loose) => list.sort((a, b) => compareBuild$2(a, b, loose));
	var sort_1 = sort$1;

	const compareBuild$1 = compareBuild_1;
	const rsort$1 = (list, loose) => list.sort((a, b) => compareBuild$1(b, a, loose));
	var rsort_1 = rsort$1;

	const compare$8 = compare_1;
	const gt$6 = (a, b, loose) => compare$8(a, b, loose) > 0;
	var gt_1 = gt$6;

	const compare$7 = compare_1;
	const lt$5 = (a, b, loose) => compare$7(a, b, loose) < 0;
	var lt_1 = lt$5;

	const compare$6 = compare_1;
	const eq$2 = (a, b, loose) => compare$6(a, b, loose) === 0;
	var eq_1 = eq$2;

	const compare$5 = compare_1;
	const neq$2 = (a, b, loose) => compare$5(a, b, loose) !== 0;
	var neq_1 = neq$2;

	const compare$4 = compare_1;
	const gte$3 = (a, b, loose) => compare$4(a, b, loose) >= 0;
	var gte_1 = gte$3;

	const compare$3 = compare_1;
	const lte$3 = (a, b, loose) => compare$3(a, b, loose) <= 0;
	var lte_1 = lte$3;

	const eq$1 = eq_1;
	const neq$1 = neq_1;
	const gt$5 = gt_1;
	const gte$2 = gte_1;
	const lt$4 = lt_1;
	const lte$2 = lte_1;

	const cmp$1 = (a, op, b, loose) => {
	  switch (op) {
	    case '===':
	      if (typeof a === 'object') {
	        a = a.version;
	      }
	      if (typeof b === 'object') {
	        b = b.version;
	      }
	      return a === b

	    case '!==':
	      if (typeof a === 'object') {
	        a = a.version;
	      }
	      if (typeof b === 'object') {
	        b = b.version;
	      }
	      return a !== b

	    case '':
	    case '=':
	    case '==':
	      return eq$1(a, b, loose)

	    case '!=':
	      return neq$1(a, b, loose)

	    case '>':
	      return gt$5(a, b, loose)

	    case '>=':
	      return gte$2(a, b, loose)

	    case '<':
	      return lt$4(a, b, loose)

	    case '<=':
	      return lte$2(a, b, loose)

	    default:
	      throw new TypeError(`Invalid operator: ${op}`)
	  }
	};
	var cmp_1 = cmp$1;

	const SemVer$5 = semver$1;
	const parse$1 = parse_1;
	const { safeRe: re$2, t: t$7 } = reExports;

	const coerce$1 = (version, options) => {
	  if (version instanceof SemVer$5) {
	    return version
	  }

	  if (typeof version === 'number') {
	    version = String(version);
	  }

	  if (typeof version !== 'string') {
	    return null
	  }

	  options = options || {};

	  let match = null;
	  if (!options.rtl) {
	    match = version.match(re$2[t$7.COERCE]);
	  } else {
	    // Find the right-most coercible string that does not share
	    // a terminus with a more left-ward coercible string.
	    // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
	    //
	    // Walk through the string checking with a /g regexp
	    // Manually set the index so as to pick up overlapping matches.
	    // Stop when we get a match that ends at the string end, since no
	    // coercible string can be more right-ward without the same terminus.
	    let next;
	    while ((next = re$2[t$7.COERCERTL].exec(version)) &&
	        (!match || match.index + match[0].length !== version.length)
	    ) {
	      if (!match ||
	            next.index + next[0].length !== match.index + match[0].length) {
	        match = next;
	      }
	      re$2[t$7.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
	    }
	    // leave it in a clean state
	    re$2[t$7.COERCERTL].lastIndex = -1;
	  }

	  if (match === null) {
	    return null
	  }

	  return parse$1(`${match[2]}.${match[3] || '0'}.${match[4] || '0'}`, options)
	};
	var coerce_1 = coerce$1;

	var iterator$1;
	var hasRequiredIterator;

	function requireIterator () {
		if (hasRequiredIterator) return iterator$1;
		hasRequiredIterator = 1;
		iterator$1 = function (Yallist) {
		  Yallist.prototype[Symbol.iterator] = function* () {
		    for (let walker = this.head; walker; walker = walker.next) {
		      yield walker.value;
		    }
		  };
		};
		return iterator$1;
	}

	var yallist;
	var hasRequiredYallist;

	function requireYallist () {
		if (hasRequiredYallist) return yallist;
		hasRequiredYallist = 1;
		yallist = Yallist;

		Yallist.Node = Node;
		Yallist.create = Yallist;

		function Yallist (list) {
		  var self = this;
		  if (!(self instanceof Yallist)) {
		    self = new Yallist();
		  }

		  self.tail = null;
		  self.head = null;
		  self.length = 0;

		  if (list && typeof list.forEach === 'function') {
		    list.forEach(function (item) {
		      self.push(item);
		    });
		  } else if (arguments.length > 0) {
		    for (var i = 0, l = arguments.length; i < l; i++) {
		      self.push(arguments[i]);
		    }
		  }

		  return self
		}

		Yallist.prototype.removeNode = function (node) {
		  if (node.list !== this) {
		    throw new Error('removing node which does not belong to this list')
		  }

		  var next = node.next;
		  var prev = node.prev;

		  if (next) {
		    next.prev = prev;
		  }

		  if (prev) {
		    prev.next = next;
		  }

		  if (node === this.head) {
		    this.head = next;
		  }
		  if (node === this.tail) {
		    this.tail = prev;
		  }

		  node.list.length--;
		  node.next = null;
		  node.prev = null;
		  node.list = null;

		  return next
		};

		Yallist.prototype.unshiftNode = function (node) {
		  if (node === this.head) {
		    return
		  }

		  if (node.list) {
		    node.list.removeNode(node);
		  }

		  var head = this.head;
		  node.list = this;
		  node.next = head;
		  if (head) {
		    head.prev = node;
		  }

		  this.head = node;
		  if (!this.tail) {
		    this.tail = node;
		  }
		  this.length++;
		};

		Yallist.prototype.pushNode = function (node) {
		  if (node === this.tail) {
		    return
		  }

		  if (node.list) {
		    node.list.removeNode(node);
		  }

		  var tail = this.tail;
		  node.list = this;
		  node.prev = tail;
		  if (tail) {
		    tail.next = node;
		  }

		  this.tail = node;
		  if (!this.head) {
		    this.head = node;
		  }
		  this.length++;
		};

		Yallist.prototype.push = function () {
		  for (var i = 0, l = arguments.length; i < l; i++) {
		    push(this, arguments[i]);
		  }
		  return this.length
		};

		Yallist.prototype.unshift = function () {
		  for (var i = 0, l = arguments.length; i < l; i++) {
		    unshift(this, arguments[i]);
		  }
		  return this.length
		};

		Yallist.prototype.pop = function () {
		  if (!this.tail) {
		    return undefined
		  }

		  var res = this.tail.value;
		  this.tail = this.tail.prev;
		  if (this.tail) {
		    this.tail.next = null;
		  } else {
		    this.head = null;
		  }
		  this.length--;
		  return res
		};

		Yallist.prototype.shift = function () {
		  if (!this.head) {
		    return undefined
		  }

		  var res = this.head.value;
		  this.head = this.head.next;
		  if (this.head) {
		    this.head.prev = null;
		  } else {
		    this.tail = null;
		  }
		  this.length--;
		  return res
		};

		Yallist.prototype.forEach = function (fn, thisp) {
		  thisp = thisp || this;
		  for (var walker = this.head, i = 0; walker !== null; i++) {
		    fn.call(thisp, walker.value, i, this);
		    walker = walker.next;
		  }
		};

		Yallist.prototype.forEachReverse = function (fn, thisp) {
		  thisp = thisp || this;
		  for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
		    fn.call(thisp, walker.value, i, this);
		    walker = walker.prev;
		  }
		};

		Yallist.prototype.get = function (n) {
		  for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
		    // abort out of the list early if we hit a cycle
		    walker = walker.next;
		  }
		  if (i === n && walker !== null) {
		    return walker.value
		  }
		};

		Yallist.prototype.getReverse = function (n) {
		  for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
		    // abort out of the list early if we hit a cycle
		    walker = walker.prev;
		  }
		  if (i === n && walker !== null) {
		    return walker.value
		  }
		};

		Yallist.prototype.map = function (fn, thisp) {
		  thisp = thisp || this;
		  var res = new Yallist();
		  for (var walker = this.head; walker !== null;) {
		    res.push(fn.call(thisp, walker.value, this));
		    walker = walker.next;
		  }
		  return res
		};

		Yallist.prototype.mapReverse = function (fn, thisp) {
		  thisp = thisp || this;
		  var res = new Yallist();
		  for (var walker = this.tail; walker !== null;) {
		    res.push(fn.call(thisp, walker.value, this));
		    walker = walker.prev;
		  }
		  return res
		};

		Yallist.prototype.reduce = function (fn, initial) {
		  var acc;
		  var walker = this.head;
		  if (arguments.length > 1) {
		    acc = initial;
		  } else if (this.head) {
		    walker = this.head.next;
		    acc = this.head.value;
		  } else {
		    throw new TypeError('Reduce of empty list with no initial value')
		  }

		  for (var i = 0; walker !== null; i++) {
		    acc = fn(acc, walker.value, i);
		    walker = walker.next;
		  }

		  return acc
		};

		Yallist.prototype.reduceReverse = function (fn, initial) {
		  var acc;
		  var walker = this.tail;
		  if (arguments.length > 1) {
		    acc = initial;
		  } else if (this.tail) {
		    walker = this.tail.prev;
		    acc = this.tail.value;
		  } else {
		    throw new TypeError('Reduce of empty list with no initial value')
		  }

		  for (var i = this.length - 1; walker !== null; i--) {
		    acc = fn(acc, walker.value, i);
		    walker = walker.prev;
		  }

		  return acc
		};

		Yallist.prototype.toArray = function () {
		  var arr = new Array(this.length);
		  for (var i = 0, walker = this.head; walker !== null; i++) {
		    arr[i] = walker.value;
		    walker = walker.next;
		  }
		  return arr
		};

		Yallist.prototype.toArrayReverse = function () {
		  var arr = new Array(this.length);
		  for (var i = 0, walker = this.tail; walker !== null; i++) {
		    arr[i] = walker.value;
		    walker = walker.prev;
		  }
		  return arr
		};

		Yallist.prototype.slice = function (from, to) {
		  to = to || this.length;
		  if (to < 0) {
		    to += this.length;
		  }
		  from = from || 0;
		  if (from < 0) {
		    from += this.length;
		  }
		  var ret = new Yallist();
		  if (to < from || to < 0) {
		    return ret
		  }
		  if (from < 0) {
		    from = 0;
		  }
		  if (to > this.length) {
		    to = this.length;
		  }
		  for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
		    walker = walker.next;
		  }
		  for (; walker !== null && i < to; i++, walker = walker.next) {
		    ret.push(walker.value);
		  }
		  return ret
		};

		Yallist.prototype.sliceReverse = function (from, to) {
		  to = to || this.length;
		  if (to < 0) {
		    to += this.length;
		  }
		  from = from || 0;
		  if (from < 0) {
		    from += this.length;
		  }
		  var ret = new Yallist();
		  if (to < from || to < 0) {
		    return ret
		  }
		  if (from < 0) {
		    from = 0;
		  }
		  if (to > this.length) {
		    to = this.length;
		  }
		  for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
		    walker = walker.prev;
		  }
		  for (; walker !== null && i > from; i--, walker = walker.prev) {
		    ret.push(walker.value);
		  }
		  return ret
		};

		Yallist.prototype.splice = function (start, deleteCount, ...nodes) {
		  if (start > this.length) {
		    start = this.length - 1;
		  }
		  if (start < 0) {
		    start = this.length + start;
		  }

		  for (var i = 0, walker = this.head; walker !== null && i < start; i++) {
		    walker = walker.next;
		  }

		  var ret = [];
		  for (var i = 0; walker && i < deleteCount; i++) {
		    ret.push(walker.value);
		    walker = this.removeNode(walker);
		  }
		  if (walker === null) {
		    walker = this.tail;
		  }

		  if (walker !== this.head && walker !== this.tail) {
		    walker = walker.prev;
		  }

		  for (var i = 0; i < nodes.length; i++) {
		    walker = insert(this, walker, nodes[i]);
		  }
		  return ret;
		};

		Yallist.prototype.reverse = function () {
		  var head = this.head;
		  var tail = this.tail;
		  for (var walker = head; walker !== null; walker = walker.prev) {
		    var p = walker.prev;
		    walker.prev = walker.next;
		    walker.next = p;
		  }
		  this.head = tail;
		  this.tail = head;
		  return this
		};

		function insert (self, node, value) {
		  var inserted = node === self.head ?
		    new Node(value, null, node, self) :
		    new Node(value, node, node.next, self);

		  if (inserted.next === null) {
		    self.tail = inserted;
		  }
		  if (inserted.prev === null) {
		    self.head = inserted;
		  }

		  self.length++;

		  return inserted
		}

		function push (self, item) {
		  self.tail = new Node(item, self.tail, null, self);
		  if (!self.head) {
		    self.head = self.tail;
		  }
		  self.length++;
		}

		function unshift (self, item) {
		  self.head = new Node(item, null, self.head, self);
		  if (!self.tail) {
		    self.tail = self.head;
		  }
		  self.length++;
		}

		function Node (value, prev, next, list) {
		  if (!(this instanceof Node)) {
		    return new Node(value, prev, next, list)
		  }

		  this.list = list;
		  this.value = value;

		  if (prev) {
		    prev.next = this;
		    this.prev = prev;
		  } else {
		    this.prev = null;
		  }

		  if (next) {
		    next.prev = this;
		    this.next = next;
		  } else {
		    this.next = null;
		  }
		}

		try {
		  // add if support for Symbol.iterator is present
		  requireIterator()(Yallist);
		} catch (er) {}
		return yallist;
	}

	var lruCache;
	var hasRequiredLruCache;

	function requireLruCache () {
		if (hasRequiredLruCache) return lruCache;
		hasRequiredLruCache = 1;

		// A linked list to keep track of recently-used-ness
		const Yallist = requireYallist();

		const MAX = Symbol('max');
		const LENGTH = Symbol('length');
		const LENGTH_CALCULATOR = Symbol('lengthCalculator');
		const ALLOW_STALE = Symbol('allowStale');
		const MAX_AGE = Symbol('maxAge');
		const DISPOSE = Symbol('dispose');
		const NO_DISPOSE_ON_SET = Symbol('noDisposeOnSet');
		const LRU_LIST = Symbol('lruList');
		const CACHE = Symbol('cache');
		const UPDATE_AGE_ON_GET = Symbol('updateAgeOnGet');

		const naiveLength = () => 1;

		// lruList is a yallist where the head is the youngest
		// item, and the tail is the oldest.  the list contains the Hit
		// objects as the entries.
		// Each Hit object has a reference to its Yallist.Node.  This
		// never changes.
		//
		// cache is a Map (or PseudoMap) that matches the keys to
		// the Yallist.Node object.
		class LRUCache {
		  constructor (options) {
		    if (typeof options === 'number')
		      options = { max: options };

		    if (!options)
		      options = {};

		    if (options.max && (typeof options.max !== 'number' || options.max < 0))
		      throw new TypeError('max must be a non-negative number')
		    // Kind of weird to have a default max of Infinity, but oh well.
		    this[MAX] = options.max || Infinity;

		    const lc = options.length || naiveLength;
		    this[LENGTH_CALCULATOR] = (typeof lc !== 'function') ? naiveLength : lc;
		    this[ALLOW_STALE] = options.stale || false;
		    if (options.maxAge && typeof options.maxAge !== 'number')
		      throw new TypeError('maxAge must be a number')
		    this[MAX_AGE] = options.maxAge || 0;
		    this[DISPOSE] = options.dispose;
		    this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
		    this[UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
		    this.reset();
		  }

		  // resize the cache when the max changes.
		  set max (mL) {
		    if (typeof mL !== 'number' || mL < 0)
		      throw new TypeError('max must be a non-negative number')

		    this[MAX] = mL || Infinity;
		    trim(this);
		  }
		  get max () {
		    return this[MAX]
		  }

		  set allowStale (allowStale) {
		    this[ALLOW_STALE] = !!allowStale;
		  }
		  get allowStale () {
		    return this[ALLOW_STALE]
		  }

		  set maxAge (mA) {
		    if (typeof mA !== 'number')
		      throw new TypeError('maxAge must be a non-negative number')

		    this[MAX_AGE] = mA;
		    trim(this);
		  }
		  get maxAge () {
		    return this[MAX_AGE]
		  }

		  // resize the cache when the lengthCalculator changes.
		  set lengthCalculator (lC) {
		    if (typeof lC !== 'function')
		      lC = naiveLength;

		    if (lC !== this[LENGTH_CALCULATOR]) {
		      this[LENGTH_CALCULATOR] = lC;
		      this[LENGTH] = 0;
		      this[LRU_LIST].forEach(hit => {
		        hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key);
		        this[LENGTH] += hit.length;
		      });
		    }
		    trim(this);
		  }
		  get lengthCalculator () { return this[LENGTH_CALCULATOR] }

		  get length () { return this[LENGTH] }
		  get itemCount () { return this[LRU_LIST].length }

		  rforEach (fn, thisp) {
		    thisp = thisp || this;
		    for (let walker = this[LRU_LIST].tail; walker !== null;) {
		      const prev = walker.prev;
		      forEachStep(this, fn, walker, thisp);
		      walker = prev;
		    }
		  }

		  forEach (fn, thisp) {
		    thisp = thisp || this;
		    for (let walker = this[LRU_LIST].head; walker !== null;) {
		      const next = walker.next;
		      forEachStep(this, fn, walker, thisp);
		      walker = next;
		    }
		  }

		  keys () {
		    return this[LRU_LIST].toArray().map(k => k.key)
		  }

		  values () {
		    return this[LRU_LIST].toArray().map(k => k.value)
		  }

		  reset () {
		    if (this[DISPOSE] &&
		        this[LRU_LIST] &&
		        this[LRU_LIST].length) {
		      this[LRU_LIST].forEach(hit => this[DISPOSE](hit.key, hit.value));
		    }

		    this[CACHE] = new Map(); // hash of items by key
		    this[LRU_LIST] = new Yallist(); // list of items in order of use recency
		    this[LENGTH] = 0; // length of items in the list
		  }

		  dump () {
		    return this[LRU_LIST].map(hit =>
		      isStale(this, hit) ? false : {
		        k: hit.key,
		        v: hit.value,
		        e: hit.now + (hit.maxAge || 0)
		      }).toArray().filter(h => h)
		  }

		  dumpLru () {
		    return this[LRU_LIST]
		  }

		  set (key, value, maxAge) {
		    maxAge = maxAge || this[MAX_AGE];

		    if (maxAge && typeof maxAge !== 'number')
		      throw new TypeError('maxAge must be a number')

		    const now = maxAge ? Date.now() : 0;
		    const len = this[LENGTH_CALCULATOR](value, key);

		    if (this[CACHE].has(key)) {
		      if (len > this[MAX]) {
		        del(this, this[CACHE].get(key));
		        return false
		      }

		      const node = this[CACHE].get(key);
		      const item = node.value;

		      // dispose of the old one before overwriting
		      // split out into 2 ifs for better coverage tracking
		      if (this[DISPOSE]) {
		        if (!this[NO_DISPOSE_ON_SET])
		          this[DISPOSE](key, item.value);
		      }

		      item.now = now;
		      item.maxAge = maxAge;
		      item.value = value;
		      this[LENGTH] += len - item.length;
		      item.length = len;
		      this.get(key);
		      trim(this);
		      return true
		    }

		    const hit = new Entry(key, value, len, now, maxAge);

		    // oversized objects fall out of cache automatically.
		    if (hit.length > this[MAX]) {
		      if (this[DISPOSE])
		        this[DISPOSE](key, value);

		      return false
		    }

		    this[LENGTH] += hit.length;
		    this[LRU_LIST].unshift(hit);
		    this[CACHE].set(key, this[LRU_LIST].head);
		    trim(this);
		    return true
		  }

		  has (key) {
		    if (!this[CACHE].has(key)) return false
		    const hit = this[CACHE].get(key).value;
		    return !isStale(this, hit)
		  }

		  get (key) {
		    return get(this, key, true)
		  }

		  peek (key) {
		    return get(this, key, false)
		  }

		  pop () {
		    const node = this[LRU_LIST].tail;
		    if (!node)
		      return null

		    del(this, node);
		    return node.value
		  }

		  del (key) {
		    del(this, this[CACHE].get(key));
		  }

		  load (arr) {
		    // reset the cache
		    this.reset();

		    const now = Date.now();
		    // A previous serialized cache has the most recent items first
		    for (let l = arr.length - 1; l >= 0; l--) {
		      const hit = arr[l];
		      const expiresAt = hit.e || 0;
		      if (expiresAt === 0)
		        // the item was created without expiration in a non aged cache
		        this.set(hit.k, hit.v);
		      else {
		        const maxAge = expiresAt - now;
		        // dont add already expired items
		        if (maxAge > 0) {
		          this.set(hit.k, hit.v, maxAge);
		        }
		      }
		    }
		  }

		  prune () {
		    this[CACHE].forEach((value, key) => get(this, key, false));
		  }
		}

		const get = (self, key, doUse) => {
		  const node = self[CACHE].get(key);
		  if (node) {
		    const hit = node.value;
		    if (isStale(self, hit)) {
		      del(self, node);
		      if (!self[ALLOW_STALE])
		        return undefined
		    } else {
		      if (doUse) {
		        if (self[UPDATE_AGE_ON_GET])
		          node.value.now = Date.now();
		        self[LRU_LIST].unshiftNode(node);
		      }
		    }
		    return hit.value
		  }
		};

		const isStale = (self, hit) => {
		  if (!hit || (!hit.maxAge && !self[MAX_AGE]))
		    return false

		  const diff = Date.now() - hit.now;
		  return hit.maxAge ? diff > hit.maxAge
		    : self[MAX_AGE] && (diff > self[MAX_AGE])
		};

		const trim = self => {
		  if (self[LENGTH] > self[MAX]) {
		    for (let walker = self[LRU_LIST].tail;
		      self[LENGTH] > self[MAX] && walker !== null;) {
		      // We know that we're about to delete this one, and also
		      // what the next least recently used key will be, so just
		      // go ahead and set it now.
		      const prev = walker.prev;
		      del(self, walker);
		      walker = prev;
		    }
		  }
		};

		const del = (self, node) => {
		  if (node) {
		    const hit = node.value;
		    if (self[DISPOSE])
		      self[DISPOSE](hit.key, hit.value);

		    self[LENGTH] -= hit.length;
		    self[CACHE].delete(hit.key);
		    self[LRU_LIST].removeNode(node);
		  }
		};

		class Entry {
		  constructor (key, value, length, now, maxAge) {
		    this.key = key;
		    this.value = value;
		    this.length = length;
		    this.now = now;
		    this.maxAge = maxAge || 0;
		  }
		}

		const forEachStep = (self, fn, node, thisp) => {
		  let hit = node.value;
		  if (isStale(self, hit)) {
		    del(self, node);
		    if (!self[ALLOW_STALE])
		      hit = undefined;
		  }
		  if (hit)
		    fn.call(thisp, hit.value, hit.key, self);
		};

		lruCache = LRUCache;
		return lruCache;
	}

	var range$1;
	var hasRequiredRange;

	function requireRange () {
		if (hasRequiredRange) return range$1;
		hasRequiredRange = 1;
		// hoisted class for cyclic dependency
		class Range {
		  constructor (range, options) {
		    options = parseOptions(options);

		    if (range instanceof Range) {
		      if (
		        range.loose === !!options.loose &&
		        range.includePrerelease === !!options.includePrerelease
		      ) {
		        return range
		      } else {
		        return new Range(range.raw, options)
		      }
		    }

		    if (range instanceof Comparator) {
		      // just put it in the set and return
		      this.raw = range.value;
		      this.set = [[range]];
		      this.format();
		      return this
		    }

		    this.options = options;
		    this.loose = !!options.loose;
		    this.includePrerelease = !!options.includePrerelease;

		    // First reduce all whitespace as much as possible so we do not have to rely
		    // on potentially slow regexes like \s*. This is then stored and used for
		    // future error messages as well.
		    this.raw = range
		      .trim()
		      .split(/\s+/)
		      .join(' ');

		    // First, split on ||
		    this.set = this.raw
		      .split('||')
		      // map the range to a 2d array of comparators
		      .map(r => this.parseRange(r.trim()))
		      // throw out any comparator lists that are empty
		      // this generally means that it was not a valid range, which is allowed
		      // in loose mode, but will still throw if the WHOLE range is invalid.
		      .filter(c => c.length);

		    if (!this.set.length) {
		      throw new TypeError(`Invalid SemVer Range: ${this.raw}`)
		    }

		    // if we have any that are not the null set, throw out null sets.
		    if (this.set.length > 1) {
		      // keep the first one, in case they're all null sets
		      const first = this.set[0];
		      this.set = this.set.filter(c => !isNullSet(c[0]));
		      if (this.set.length === 0) {
		        this.set = [first];
		      } else if (this.set.length > 1) {
		        // if we have any that are *, then the range is just *
		        for (const c of this.set) {
		          if (c.length === 1 && isAny(c[0])) {
		            this.set = [c];
		            break
		          }
		        }
		      }
		    }

		    this.format();
		  }

		  format () {
		    this.range = this.set
		      .map((comps) => comps.join(' ').trim())
		      .join('||')
		      .trim();
		    return this.range
		  }

		  toString () {
		    return this.range
		  }

		  parseRange (range) {
		    // memoize range parsing for performance.
		    // this is a very hot path, and fully deterministic.
		    const memoOpts =
		      (this.options.includePrerelease && FLAG_INCLUDE_PRERELEASE) |
		      (this.options.loose && FLAG_LOOSE);
		    const memoKey = memoOpts + ':' + range;
		    const cached = cache.get(memoKey);
		    if (cached) {
		      return cached
		    }

		    const loose = this.options.loose;
		    // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
		    const hr = loose ? re[t.HYPHENRANGELOOSE] : re[t.HYPHENRANGE];
		    range = range.replace(hr, hyphenReplace(this.options.includePrerelease));
		    debug('hyphen replace', range);

		    // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
		    range = range.replace(re[t.COMPARATORTRIM], comparatorTrimReplace);
		    debug('comparator trim', range);

		    // `~ 1.2.3` => `~1.2.3`
		    range = range.replace(re[t.TILDETRIM], tildeTrimReplace);
		    debug('tilde trim', range);

		    // `^ 1.2.3` => `^1.2.3`
		    range = range.replace(re[t.CARETTRIM], caretTrimReplace);
		    debug('caret trim', range);

		    // At this point, the range is completely trimmed and
		    // ready to be split into comparators.

		    let rangeList = range
		      .split(' ')
		      .map(comp => parseComparator(comp, this.options))
		      .join(' ')
		      .split(/\s+/)
		      // >=0.0.0 is equivalent to *
		      .map(comp => replaceGTE0(comp, this.options));

		    if (loose) {
		      // in loose mode, throw out any that are not valid comparators
		      rangeList = rangeList.filter(comp => {
		        debug('loose invalid filter', comp, this.options);
		        return !!comp.match(re[t.COMPARATORLOOSE])
		      });
		    }
		    debug('range list', rangeList);

		    // if any comparators are the null set, then replace with JUST null set
		    // if more than one comparator, remove any * comparators
		    // also, don't include the same comparator more than once
		    const rangeMap = new Map();
		    const comparators = rangeList.map(comp => new Comparator(comp, this.options));
		    for (const comp of comparators) {
		      if (isNullSet(comp)) {
		        return [comp]
		      }
		      rangeMap.set(comp.value, comp);
		    }
		    if (rangeMap.size > 1 && rangeMap.has('')) {
		      rangeMap.delete('');
		    }

		    const result = [...rangeMap.values()];
		    cache.set(memoKey, result);
		    return result
		  }

		  intersects (range, options) {
		    if (!(range instanceof Range)) {
		      throw new TypeError('a Range is required')
		    }

		    return this.set.some((thisComparators) => {
		      return (
		        isSatisfiable(thisComparators, options) &&
		        range.set.some((rangeComparators) => {
		          return (
		            isSatisfiable(rangeComparators, options) &&
		            thisComparators.every((thisComparator) => {
		              return rangeComparators.every((rangeComparator) => {
		                return thisComparator.intersects(rangeComparator, options)
		              })
		            })
		          )
		        })
		      )
		    })
		  }

		  // if ANY of the sets match ALL of its comparators, then pass
		  test (version) {
		    if (!version) {
		      return false
		    }

		    if (typeof version === 'string') {
		      try {
		        version = new SemVer(version, this.options);
		      } catch (er) {
		        return false
		      }
		    }

		    for (let i = 0; i < this.set.length; i++) {
		      if (testSet(this.set[i], version, this.options)) {
		        return true
		      }
		    }
		    return false
		  }
		}

		range$1 = Range;

		const LRU = requireLruCache();
		const cache = new LRU({ max: 1000 });

		const parseOptions = parseOptions_1;
		const Comparator = requireComparator();
		const debug = debug_1;
		const SemVer = semver$1;
		const {
		  safeRe: re,
		  t,
		  comparatorTrimReplace,
		  tildeTrimReplace,
		  caretTrimReplace,
		} = reExports;
		const { FLAG_INCLUDE_PRERELEASE, FLAG_LOOSE } = constants$4;

		const isNullSet = c => c.value === '<0.0.0-0';
		const isAny = c => c.value === '';

		// take a set of comparators and determine whether there
		// exists a version which can satisfy it
		const isSatisfiable = (comparators, options) => {
		  let result = true;
		  const remainingComparators = comparators.slice();
		  let testComparator = remainingComparators.pop();

		  while (result && remainingComparators.length) {
		    result = remainingComparators.every((otherComparator) => {
		      return testComparator.intersects(otherComparator, options)
		    });

		    testComparator = remainingComparators.pop();
		  }

		  return result
		};

		// comprised of xranges, tildes, stars, and gtlt's at this point.
		// already replaced the hyphen ranges
		// turn into a set of JUST comparators.
		const parseComparator = (comp, options) => {
		  debug('comp', comp, options);
		  comp = replaceCarets(comp, options);
		  debug('caret', comp);
		  comp = replaceTildes(comp, options);
		  debug('tildes', comp);
		  comp = replaceXRanges(comp, options);
		  debug('xrange', comp);
		  comp = replaceStars(comp, options);
		  debug('stars', comp);
		  return comp
		};

		const isX = id => !id || id.toLowerCase() === 'x' || id === '*';

		// ~, ~> --> * (any, kinda silly)
		// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
		// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
		// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
		// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
		// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
		// ~0.0.1 --> >=0.0.1 <0.1.0-0
		const replaceTildes = (comp, options) => {
		  return comp
		    .trim()
		    .split(/\s+/)
		    .map((c) => replaceTilde(c, options))
		    .join(' ')
		};

		const replaceTilde = (comp, options) => {
		  const r = options.loose ? re[t.TILDELOOSE] : re[t.TILDE];
		  return comp.replace(r, (_, M, m, p, pr) => {
		    debug('tilde', comp, _, M, m, p, pr);
		    let ret;

		    if (isX(M)) {
		      ret = '';
		    } else if (isX(m)) {
		      ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
		    } else if (isX(p)) {
		      // ~1.2 == >=1.2.0 <1.3.0-0
		      ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
		    } else if (pr) {
		      debug('replaceTilde pr', pr);
		      ret = `>=${M}.${m}.${p}-${pr
	      } <${M}.${+m + 1}.0-0`;
		    } else {
		      // ~1.2.3 == >=1.2.3 <1.3.0-0
		      ret = `>=${M}.${m}.${p
	      } <${M}.${+m + 1}.0-0`;
		    }

		    debug('tilde return', ret);
		    return ret
		  })
		};

		// ^ --> * (any, kinda silly)
		// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
		// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
		// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
		// ^1.2.3 --> >=1.2.3 <2.0.0-0
		// ^1.2.0 --> >=1.2.0 <2.0.0-0
		// ^0.0.1 --> >=0.0.1 <0.0.2-0
		// ^0.1.0 --> >=0.1.0 <0.2.0-0
		const replaceCarets = (comp, options) => {
		  return comp
		    .trim()
		    .split(/\s+/)
		    .map((c) => replaceCaret(c, options))
		    .join(' ')
		};

		const replaceCaret = (comp, options) => {
		  debug('caret', comp, options);
		  const r = options.loose ? re[t.CARETLOOSE] : re[t.CARET];
		  const z = options.includePrerelease ? '-0' : '';
		  return comp.replace(r, (_, M, m, p, pr) => {
		    debug('caret', comp, _, M, m, p, pr);
		    let ret;

		    if (isX(M)) {
		      ret = '';
		    } else if (isX(m)) {
		      ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
		    } else if (isX(p)) {
		      if (M === '0') {
		        ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
		      } else {
		        ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
		      }
		    } else if (pr) {
		      debug('replaceCaret pr', pr);
		      if (M === '0') {
		        if (m === '0') {
		          ret = `>=${M}.${m}.${p}-${pr
	          } <${M}.${m}.${+p + 1}-0`;
		        } else {
		          ret = `>=${M}.${m}.${p}-${pr
	          } <${M}.${+m + 1}.0-0`;
		        }
		      } else {
		        ret = `>=${M}.${m}.${p}-${pr
	        } <${+M + 1}.0.0-0`;
		      }
		    } else {
		      debug('no pr');
		      if (M === '0') {
		        if (m === '0') {
		          ret = `>=${M}.${m}.${p
	          }${z} <${M}.${m}.${+p + 1}-0`;
		        } else {
		          ret = `>=${M}.${m}.${p
	          }${z} <${M}.${+m + 1}.0-0`;
		        }
		      } else {
		        ret = `>=${M}.${m}.${p
	        } <${+M + 1}.0.0-0`;
		      }
		    }

		    debug('caret return', ret);
		    return ret
		  })
		};

		const replaceXRanges = (comp, options) => {
		  debug('replaceXRanges', comp, options);
		  return comp
		    .split(/\s+/)
		    .map((c) => replaceXRange(c, options))
		    .join(' ')
		};

		const replaceXRange = (comp, options) => {
		  comp = comp.trim();
		  const r = options.loose ? re[t.XRANGELOOSE] : re[t.XRANGE];
		  return comp.replace(r, (ret, gtlt, M, m, p, pr) => {
		    debug('xRange', comp, ret, gtlt, M, m, p, pr);
		    const xM = isX(M);
		    const xm = xM || isX(m);
		    const xp = xm || isX(p);
		    const anyX = xp;

		    if (gtlt === '=' && anyX) {
		      gtlt = '';
		    }

		    // if we're including prereleases in the match, then we need
		    // to fix this to -0, the lowest possible prerelease value
		    pr = options.includePrerelease ? '-0' : '';

		    if (xM) {
		      if (gtlt === '>' || gtlt === '<') {
		        // nothing is allowed
		        ret = '<0.0.0-0';
		      } else {
		        // nothing is forbidden
		        ret = '*';
		      }
		    } else if (gtlt && anyX) {
		      // we know patch is an x, because we have any x at all.
		      // replace X with 0
		      if (xm) {
		        m = 0;
		      }
		      p = 0;

		      if (gtlt === '>') {
		        // >1 => >=2.0.0
		        // >1.2 => >=1.3.0
		        gtlt = '>=';
		        if (xm) {
		          M = +M + 1;
		          m = 0;
		          p = 0;
		        } else {
		          m = +m + 1;
		          p = 0;
		        }
		      } else if (gtlt === '<=') {
		        // <=0.7.x is actually <0.8.0, since any 0.7.x should
		        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
		        gtlt = '<';
		        if (xm) {
		          M = +M + 1;
		        } else {
		          m = +m + 1;
		        }
		      }

		      if (gtlt === '<') {
		        pr = '-0';
		      }

		      ret = `${gtlt + M}.${m}.${p}${pr}`;
		    } else if (xm) {
		      ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
		    } else if (xp) {
		      ret = `>=${M}.${m}.0${pr
	      } <${M}.${+m + 1}.0-0`;
		    }

		    debug('xRange return', ret);

		    return ret
		  })
		};

		// Because * is AND-ed with everything else in the comparator,
		// and '' means "any version", just remove the *s entirely.
		const replaceStars = (comp, options) => {
		  debug('replaceStars', comp, options);
		  // Looseness is ignored here.  star is always as loose as it gets!
		  return comp
		    .trim()
		    .replace(re[t.STAR], '')
		};

		const replaceGTE0 = (comp, options) => {
		  debug('replaceGTE0', comp, options);
		  return comp
		    .trim()
		    .replace(re[options.includePrerelease ? t.GTE0PRE : t.GTE0], '')
		};

		// This function is passed to string.replace(re[t.HYPHENRANGE])
		// M, m, patch, prerelease, build
		// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
		// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
		// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
		const hyphenReplace = incPr => ($0,
		  from, fM, fm, fp, fpr, fb,
		  to, tM, tm, tp, tpr, tb) => {
		  if (isX(fM)) {
		    from = '';
		  } else if (isX(fm)) {
		    from = `>=${fM}.0.0${incPr ? '-0' : ''}`;
		  } else if (isX(fp)) {
		    from = `>=${fM}.${fm}.0${incPr ? '-0' : ''}`;
		  } else if (fpr) {
		    from = `>=${from}`;
		  } else {
		    from = `>=${from}${incPr ? '-0' : ''}`;
		  }

		  if (isX(tM)) {
		    to = '';
		  } else if (isX(tm)) {
		    to = `<${+tM + 1}.0.0-0`;
		  } else if (isX(tp)) {
		    to = `<${tM}.${+tm + 1}.0-0`;
		  } else if (tpr) {
		    to = `<=${tM}.${tm}.${tp}-${tpr}`;
		  } else if (incPr) {
		    to = `<${tM}.${tm}.${+tp + 1}-0`;
		  } else {
		    to = `<=${to}`;
		  }

		  return `${from} ${to}`.trim()
		};

		const testSet = (set, version, options) => {
		  for (let i = 0; i < set.length; i++) {
		    if (!set[i].test(version)) {
		      return false
		    }
		  }

		  if (version.prerelease.length && !options.includePrerelease) {
		    // Find the set of versions that are allowed to have prereleases
		    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
		    // That should allow `1.2.3-pr.2` to pass.
		    // However, `1.2.4-alpha.notready` should NOT be allowed,
		    // even though it's within the range set by the comparators.
		    for (let i = 0; i < set.length; i++) {
		      debug(set[i].semver);
		      if (set[i].semver === Comparator.ANY) {
		        continue
		      }

		      if (set[i].semver.prerelease.length > 0) {
		        const allowed = set[i].semver;
		        if (allowed.major === version.major &&
		            allowed.minor === version.minor &&
		            allowed.patch === version.patch) {
		          return true
		        }
		      }
		    }

		    // Version has a -pre, but it's not one of the ones we like.
		    return false
		  }

		  return true
		};
		return range$1;
	}

	var comparator;
	var hasRequiredComparator;

	function requireComparator () {
		if (hasRequiredComparator) return comparator;
		hasRequiredComparator = 1;
		const ANY = Symbol('SemVer ANY');
		// hoisted class for cyclic dependency
		class Comparator {
		  static get ANY () {
		    return ANY
		  }

		  constructor (comp, options) {
		    options = parseOptions(options);

		    if (comp instanceof Comparator) {
		      if (comp.loose === !!options.loose) {
		        return comp
		      } else {
		        comp = comp.value;
		      }
		    }

		    comp = comp.trim().split(/\s+/).join(' ');
		    debug('comparator', comp, options);
		    this.options = options;
		    this.loose = !!options.loose;
		    this.parse(comp);

		    if (this.semver === ANY) {
		      this.value = '';
		    } else {
		      this.value = this.operator + this.semver.version;
		    }

		    debug('comp', this);
		  }

		  parse (comp) {
		    const r = this.options.loose ? re[t.COMPARATORLOOSE] : re[t.COMPARATOR];
		    const m = comp.match(r);

		    if (!m) {
		      throw new TypeError(`Invalid comparator: ${comp}`)
		    }

		    this.operator = m[1] !== undefined ? m[1] : '';
		    if (this.operator === '=') {
		      this.operator = '';
		    }

		    // if it literally is just '>' or '' then allow anything.
		    if (!m[2]) {
		      this.semver = ANY;
		    } else {
		      this.semver = new SemVer(m[2], this.options.loose);
		    }
		  }

		  toString () {
		    return this.value
		  }

		  test (version) {
		    debug('Comparator.test', version, this.options.loose);

		    if (this.semver === ANY || version === ANY) {
		      return true
		    }

		    if (typeof version === 'string') {
		      try {
		        version = new SemVer(version, this.options);
		      } catch (er) {
		        return false
		      }
		    }

		    return cmp(version, this.operator, this.semver, this.options)
		  }

		  intersects (comp, options) {
		    if (!(comp instanceof Comparator)) {
		      throw new TypeError('a Comparator is required')
		    }

		    if (this.operator === '') {
		      if (this.value === '') {
		        return true
		      }
		      return new Range(comp.value, options).test(this.value)
		    } else if (comp.operator === '') {
		      if (comp.value === '') {
		        return true
		      }
		      return new Range(this.value, options).test(comp.semver)
		    }

		    options = parseOptions(options);

		    // Special cases where nothing can possibly be lower
		    if (options.includePrerelease &&
		      (this.value === '<0.0.0-0' || comp.value === '<0.0.0-0')) {
		      return false
		    }
		    if (!options.includePrerelease &&
		      (this.value.startsWith('<0.0.0') || comp.value.startsWith('<0.0.0'))) {
		      return false
		    }

		    // Same direction increasing (> or >=)
		    if (this.operator.startsWith('>') && comp.operator.startsWith('>')) {
		      return true
		    }
		    // Same direction decreasing (< or <=)
		    if (this.operator.startsWith('<') && comp.operator.startsWith('<')) {
		      return true
		    }
		    // same SemVer and both sides are inclusive (<= or >=)
		    if (
		      (this.semver.version === comp.semver.version) &&
		      this.operator.includes('=') && comp.operator.includes('=')) {
		      return true
		    }
		    // opposite directions less than
		    if (cmp(this.semver, '<', comp.semver, options) &&
		      this.operator.startsWith('>') && comp.operator.startsWith('<')) {
		      return true
		    }
		    // opposite directions greater than
		    if (cmp(this.semver, '>', comp.semver, options) &&
		      this.operator.startsWith('<') && comp.operator.startsWith('>')) {
		      return true
		    }
		    return false
		  }
		}

		comparator = Comparator;

		const parseOptions = parseOptions_1;
		const { safeRe: re, t } = reExports;
		const cmp = cmp_1;
		const debug = debug_1;
		const SemVer = semver$1;
		const Range = requireRange();
		return comparator;
	}

	const Range$9 = requireRange();
	const satisfies$4 = (version, range, options) => {
	  try {
	    range = new Range$9(range, options);
	  } catch (er) {
	    return false
	  }
	  return range.test(version)
	};
	var satisfies_1 = satisfies$4;

	const Range$8 = requireRange();

	// Mostly just for testing and legacy API reasons
	const toComparators$1 = (range, options) =>
	  new Range$8(range, options).set
	    .map(comp => comp.map(c => c.value).join(' ').trim().split(' '));

	var toComparators_1 = toComparators$1;

	const SemVer$4 = semver$1;
	const Range$7 = requireRange();

	const maxSatisfying$1 = (versions, range, options) => {
	  let max = null;
	  let maxSV = null;
	  let rangeObj = null;
	  try {
	    rangeObj = new Range$7(range, options);
	  } catch (er) {
	    return null
	  }
	  versions.forEach((v) => {
	    if (rangeObj.test(v)) {
	      // satisfies(v, range, options)
	      if (!max || maxSV.compare(v) === -1) {
	        // compare(max, v, true)
	        max = v;
	        maxSV = new SemVer$4(max, options);
	      }
	    }
	  });
	  return max
	};
	var maxSatisfying_1 = maxSatisfying$1;

	const SemVer$3 = semver$1;
	const Range$6 = requireRange();
	const minSatisfying$1 = (versions, range, options) => {
	  let min = null;
	  let minSV = null;
	  let rangeObj = null;
	  try {
	    rangeObj = new Range$6(range, options);
	  } catch (er) {
	    return null
	  }
	  versions.forEach((v) => {
	    if (rangeObj.test(v)) {
	      // satisfies(v, range, options)
	      if (!min || minSV.compare(v) === 1) {
	        // compare(min, v, true)
	        min = v;
	        minSV = new SemVer$3(min, options);
	      }
	    }
	  });
	  return min
	};
	var minSatisfying_1 = minSatisfying$1;

	const SemVer$2 = semver$1;
	const Range$5 = requireRange();
	const gt$4 = gt_1;

	const minVersion$1 = (range, loose) => {
	  range = new Range$5(range, loose);

	  let minver = new SemVer$2('0.0.0');
	  if (range.test(minver)) {
	    return minver
	  }

	  minver = new SemVer$2('0.0.0-0');
	  if (range.test(minver)) {
	    return minver
	  }

	  minver = null;
	  for (let i = 0; i < range.set.length; ++i) {
	    const comparators = range.set[i];

	    let setMin = null;
	    comparators.forEach((comparator) => {
	      // Clone to avoid manipulating the comparator's semver object.
	      const compver = new SemVer$2(comparator.semver.version);
	      switch (comparator.operator) {
	        case '>':
	          if (compver.prerelease.length === 0) {
	            compver.patch++;
	          } else {
	            compver.prerelease.push(0);
	          }
	          compver.raw = compver.format();
	          /* fallthrough */
	        case '':
	        case '>=':
	          if (!setMin || gt$4(compver, setMin)) {
	            setMin = compver;
	          }
	          break
	        case '<':
	        case '<=':
	          /* Ignore maximum versions */
	          break
	        /* istanbul ignore next */
	        default:
	          throw new Error(`Unexpected operation: ${comparator.operator}`)
	      }
	    });
	    if (setMin && (!minver || gt$4(minver, setMin))) {
	      minver = setMin;
	    }
	  }

	  if (minver && range.test(minver)) {
	    return minver
	  }

	  return null
	};
	var minVersion_1 = minVersion$1;

	const Range$4 = requireRange();
	const validRange$1 = (range, options) => {
	  try {
	    // Return '*' instead of '' so that truthiness works.
	    // This will throw if it's invalid anyway
	    return new Range$4(range, options).range || '*'
	  } catch (er) {
	    return null
	  }
	};
	var valid$1 = validRange$1;

	const SemVer$1 = semver$1;
	const Comparator$2 = requireComparator();
	const { ANY: ANY$1 } = Comparator$2;
	const Range$3 = requireRange();
	const satisfies$3 = satisfies_1;
	const gt$3 = gt_1;
	const lt$3 = lt_1;
	const lte$1 = lte_1;
	const gte$1 = gte_1;

	const outside$3 = (version, range, hilo, options) => {
	  version = new SemVer$1(version, options);
	  range = new Range$3(range, options);

	  let gtfn, ltefn, ltfn, comp, ecomp;
	  switch (hilo) {
	    case '>':
	      gtfn = gt$3;
	      ltefn = lte$1;
	      ltfn = lt$3;
	      comp = '>';
	      ecomp = '>=';
	      break
	    case '<':
	      gtfn = lt$3;
	      ltefn = gte$1;
	      ltfn = gt$3;
	      comp = '<';
	      ecomp = '<=';
	      break
	    default:
	      throw new TypeError('Must provide a hilo val of "<" or ">"')
	  }

	  // If it satisfies the range it is not outside
	  if (satisfies$3(version, range, options)) {
	    return false
	  }

	  // From now on, variable terms are as if we're in "gtr" mode.
	  // but note that everything is flipped for the "ltr" function.

	  for (let i = 0; i < range.set.length; ++i) {
	    const comparators = range.set[i];

	    let high = null;
	    let low = null;

	    comparators.forEach((comparator) => {
	      if (comparator.semver === ANY$1) {
	        comparator = new Comparator$2('>=0.0.0');
	      }
	      high = high || comparator;
	      low = low || comparator;
	      if (gtfn(comparator.semver, high.semver, options)) {
	        high = comparator;
	      } else if (ltfn(comparator.semver, low.semver, options)) {
	        low = comparator;
	      }
	    });

	    // If the edge version comparator has a operator then our version
	    // isn't outside it
	    if (high.operator === comp || high.operator === ecomp) {
	      return false
	    }

	    // If the lowest version comparator has an operator and our version
	    // is less than it then it isn't higher than the range
	    if ((!low.operator || low.operator === comp) &&
	        ltefn(version, low.semver)) {
	      return false
	    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
	      return false
	    }
	  }
	  return true
	};

	var outside_1 = outside$3;

	// Determine if version is greater than all the versions possible in the range.
	const outside$2 = outside_1;
	const gtr$1 = (version, range, options) => outside$2(version, range, '>', options);
	var gtr_1 = gtr$1;

	const outside$1 = outside_1;
	// Determine if version is less than all the versions possible in the range
	const ltr$1 = (version, range, options) => outside$1(version, range, '<', options);
	var ltr_1 = ltr$1;

	const Range$2 = requireRange();
	const intersects$1 = (r1, r2, options) => {
	  r1 = new Range$2(r1, options);
	  r2 = new Range$2(r2, options);
	  return r1.intersects(r2, options)
	};
	var intersects_1 = intersects$1;

	// given a set of versions and a range, create a "simplified" range
	// that includes the same versions that the original range does
	// If the original range is shorter than the simplified one, return that.
	const satisfies$2 = satisfies_1;
	const compare$2 = compare_1;
	var simplify = (versions, range, options) => {
	  const set = [];
	  let first = null;
	  let prev = null;
	  const v = versions.sort((a, b) => compare$2(a, b, options));
	  for (const version of v) {
	    const included = satisfies$2(version, range, options);
	    if (included) {
	      prev = version;
	      if (!first) {
	        first = version;
	      }
	    } else {
	      if (prev) {
	        set.push([first, prev]);
	      }
	      prev = null;
	      first = null;
	    }
	  }
	  if (first) {
	    set.push([first, null]);
	  }

	  const ranges = [];
	  for (const [min, max] of set) {
	    if (min === max) {
	      ranges.push(min);
	    } else if (!max && min === v[0]) {
	      ranges.push('*');
	    } else if (!max) {
	      ranges.push(`>=${min}`);
	    } else if (min === v[0]) {
	      ranges.push(`<=${max}`);
	    } else {
	      ranges.push(`${min} - ${max}`);
	    }
	  }
	  const simplified = ranges.join(' || ');
	  const original = typeof range.raw === 'string' ? range.raw : String(range);
	  return simplified.length < original.length ? simplified : range
	};

	const Range$1 = requireRange();
	const Comparator$1 = requireComparator();
	const { ANY } = Comparator$1;
	const satisfies$1 = satisfies_1;
	const compare$1 = compare_1;

	// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
	// - Every simple range `r1, r2, ...` is a null set, OR
	// - Every simple range `r1, r2, ...` which is not a null set is a subset of
	//   some `R1, R2, ...`
	//
	// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
	// - If c is only the ANY comparator
	//   - If C is only the ANY comparator, return true
	//   - Else if in prerelease mode, return false
	//   - else replace c with `[>=0.0.0]`
	// - If C is only the ANY comparator
	//   - if in prerelease mode, return true
	//   - else replace C with `[>=0.0.0]`
	// - Let EQ be the set of = comparators in c
	// - If EQ is more than one, return true (null set)
	// - Let GT be the highest > or >= comparator in c
	// - Let LT be the lowest < or <= comparator in c
	// - If GT and LT, and GT.semver > LT.semver, return true (null set)
	// - If any C is a = range, and GT or LT are set, return false
	// - If EQ
	//   - If GT, and EQ does not satisfy GT, return true (null set)
	//   - If LT, and EQ does not satisfy LT, return true (null set)
	//   - If EQ satisfies every C, return true
	//   - Else return false
	// - If GT
	//   - If GT.semver is lower than any > or >= comp in C, return false
	//   - If GT is >=, and GT.semver does not satisfy every C, return false
	//   - If GT.semver has a prerelease, and not in prerelease mode
	//     - If no C has a prerelease and the GT.semver tuple, return false
	// - If LT
	//   - If LT.semver is greater than any < or <= comp in C, return false
	//   - If LT is <=, and LT.semver does not satisfy every C, return false
	//   - If GT.semver has a prerelease, and not in prerelease mode
	//     - If no C has a prerelease and the LT.semver tuple, return false
	// - Else return true

	const subset$1 = (sub, dom, options = {}) => {
	  if (sub === dom) {
	    return true
	  }

	  sub = new Range$1(sub, options);
	  dom = new Range$1(dom, options);
	  let sawNonNull = false;

	  OUTER: for (const simpleSub of sub.set) {
	    for (const simpleDom of dom.set) {
	      const isSub = simpleSubset(simpleSub, simpleDom, options);
	      sawNonNull = sawNonNull || isSub !== null;
	      if (isSub) {
	        continue OUTER
	      }
	    }
	    // the null set is a subset of everything, but null simple ranges in
	    // a complex range should be ignored.  so if we saw a non-null range,
	    // then we know this isn't a subset, but if EVERY simple range was null,
	    // then it is a subset.
	    if (sawNonNull) {
	      return false
	    }
	  }
	  return true
	};

	const minimumVersionWithPreRelease = [new Comparator$1('>=0.0.0-0')];
	const minimumVersion = [new Comparator$1('>=0.0.0')];

	const simpleSubset = (sub, dom, options) => {
	  if (sub === dom) {
	    return true
	  }

	  if (sub.length === 1 && sub[0].semver === ANY) {
	    if (dom.length === 1 && dom[0].semver === ANY) {
	      return true
	    } else if (options.includePrerelease) {
	      sub = minimumVersionWithPreRelease;
	    } else {
	      sub = minimumVersion;
	    }
	  }

	  if (dom.length === 1 && dom[0].semver === ANY) {
	    if (options.includePrerelease) {
	      return true
	    } else {
	      dom = minimumVersion;
	    }
	  }

	  const eqSet = new Set();
	  let gt, lt;
	  for (const c of sub) {
	    if (c.operator === '>' || c.operator === '>=') {
	      gt = higherGT(gt, c, options);
	    } else if (c.operator === '<' || c.operator === '<=') {
	      lt = lowerLT(lt, c, options);
	    } else {
	      eqSet.add(c.semver);
	    }
	  }

	  if (eqSet.size > 1) {
	    return null
	  }

	  let gtltComp;
	  if (gt && lt) {
	    gtltComp = compare$1(gt.semver, lt.semver, options);
	    if (gtltComp > 0) {
	      return null
	    } else if (gtltComp === 0 && (gt.operator !== '>=' || lt.operator !== '<=')) {
	      return null
	    }
	  }

	  // will iterate one or zero times
	  for (const eq of eqSet) {
	    if (gt && !satisfies$1(eq, String(gt), options)) {
	      return null
	    }

	    if (lt && !satisfies$1(eq, String(lt), options)) {
	      return null
	    }

	    for (const c of dom) {
	      if (!satisfies$1(eq, String(c), options)) {
	        return false
	      }
	    }

	    return true
	  }

	  let higher, lower;
	  let hasDomLT, hasDomGT;
	  // if the subset has a prerelease, we need a comparator in the superset
	  // with the same tuple and a prerelease, or it's not a subset
	  let needDomLTPre = lt &&
	    !options.includePrerelease &&
	    lt.semver.prerelease.length ? lt.semver : false;
	  let needDomGTPre = gt &&
	    !options.includePrerelease &&
	    gt.semver.prerelease.length ? gt.semver : false;
	  // exception: <1.2.3-0 is the same as <1.2.3
	  if (needDomLTPre && needDomLTPre.prerelease.length === 1 &&
	      lt.operator === '<' && needDomLTPre.prerelease[0] === 0) {
	    needDomLTPre = false;
	  }

	  for (const c of dom) {
	    hasDomGT = hasDomGT || c.operator === '>' || c.operator === '>=';
	    hasDomLT = hasDomLT || c.operator === '<' || c.operator === '<=';
	    if (gt) {
	      if (needDomGTPre) {
	        if (c.semver.prerelease && c.semver.prerelease.length &&
	            c.semver.major === needDomGTPre.major &&
	            c.semver.minor === needDomGTPre.minor &&
	            c.semver.patch === needDomGTPre.patch) {
	          needDomGTPre = false;
	        }
	      }
	      if (c.operator === '>' || c.operator === '>=') {
	        higher = higherGT(gt, c, options);
	        if (higher === c && higher !== gt) {
	          return false
	        }
	      } else if (gt.operator === '>=' && !satisfies$1(gt.semver, String(c), options)) {
	        return false
	      }
	    }
	    if (lt) {
	      if (needDomLTPre) {
	        if (c.semver.prerelease && c.semver.prerelease.length &&
	            c.semver.major === needDomLTPre.major &&
	            c.semver.minor === needDomLTPre.minor &&
	            c.semver.patch === needDomLTPre.patch) {
	          needDomLTPre = false;
	        }
	      }
	      if (c.operator === '<' || c.operator === '<=') {
	        lower = lowerLT(lt, c, options);
	        if (lower === c && lower !== lt) {
	          return false
	        }
	      } else if (lt.operator === '<=' && !satisfies$1(lt.semver, String(c), options)) {
	        return false
	      }
	    }
	    if (!c.operator && (lt || gt) && gtltComp !== 0) {
	      return false
	    }
	  }

	  // if there was a < or >, and nothing in the dom, then must be false
	  // UNLESS it was limited by another range in the other direction.
	  // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
	  if (gt && hasDomLT && !lt && gtltComp !== 0) {
	    return false
	  }

	  if (lt && hasDomGT && !gt && gtltComp !== 0) {
	    return false
	  }

	  // we needed a prerelease range in a specific tuple, but didn't get one
	  // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
	  // because it includes prereleases in the 1.2.3 tuple
	  if (needDomGTPre || needDomLTPre) {
	    return false
	  }

	  return true
	};

	// >=1.2.3 is lower than >1.2.3
	const higherGT = (a, b, options) => {
	  if (!a) {
	    return b
	  }
	  const comp = compare$1(a.semver, b.semver, options);
	  return comp > 0 ? a
	    : comp < 0 ? b
	    : b.operator === '>' && a.operator === '>=' ? b
	    : a
	};

	// <=1.2.3 is higher than <1.2.3
	const lowerLT = (a, b, options) => {
	  if (!a) {
	    return b
	  }
	  const comp = compare$1(a.semver, b.semver, options);
	  return comp < 0 ? a
	    : comp > 0 ? b
	    : b.operator === '<' && a.operator === '<=' ? b
	    : a
	};

	var subset_1 = subset$1;

	// just pre-load all the stuff that index.js lazily exports
	const internalRe = reExports;
	const constants$3 = constants$4;
	const SemVer = semver$1;
	const identifiers = identifiers$1;
	const parse = parse_1;
	const valid = valid_1;
	const clean = clean_1;
	const inc = inc_1;
	const diff = diff_1;
	const major = major_1;
	const minor = minor_1;
	const patch = patch_1;
	const prerelease = prerelease_1;
	const compare = compare_1;
	const rcompare = rcompare_1;
	const compareLoose = compareLoose_1;
	const compareBuild = compareBuild_1;
	const sort = sort_1;
	const rsort = rsort_1;
	const gt$2 = gt_1;
	const lt$2 = lt_1;
	const eq = eq_1;
	const neq = neq_1;
	const gte = gte_1;
	const lte = lte_1;
	const cmp = cmp_1;
	const coerce = coerce_1;
	const Comparator = requireComparator();
	const Range = requireRange();
	const satisfies = satisfies_1;
	const toComparators = toComparators_1;
	const maxSatisfying = maxSatisfying_1;
	const minSatisfying = minSatisfying_1;
	const minVersion = minVersion_1;
	const validRange = valid$1;
	const outside = outside_1;
	const gtr = gtr_1;
	const ltr = ltr_1;
	const intersects = intersects_1;
	const simplifyRange = simplify;
	const subset = subset_1;
	var semver = {
	  parse,
	  valid,
	  clean,
	  inc,
	  diff,
	  major,
	  minor,
	  patch,
	  prerelease,
	  compare,
	  rcompare,
	  compareLoose,
	  compareBuild,
	  sort,
	  rsort,
	  gt: gt$2,
	  lt: lt$2,
	  eq,
	  neq,
	  gte,
	  lte,
	  cmp,
	  coerce,
	  Comparator,
	  Range,
	  satisfies,
	  toComparators,
	  maxSatisfying,
	  minSatisfying,
	  minVersion,
	  validRange,
	  outside,
	  gtr,
	  ltr,
	  intersects,
	  simplifyRange,
	  subset,
	  SemVer,
	  re: internalRe.re,
	  src: internalRe.src,
	  tokens: internalRe.t,
	  SEMVER_SPEC_VERSION: constants$3.SEMVER_SPEC_VERSION,
	  RELEASE_TYPES: constants$3.RELEASE_TYPES,
	  compareIdentifiers: identifiers.compareIdentifiers,
	  rcompareIdentifiers: identifiers.rcompareIdentifiers,
	};

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.satisfiesVersionRange = exports.gtRange = exports.gtVersion = exports.assertIsSemVerRange = exports.assertIsSemVerVersion = exports.isValidSemVerRange = exports.isValidSemVerVersion = exports.VersionRangeStruct = exports.VersionStruct = void 0;
		const semver_1 = semver;
		const superstruct_1 = require$$1$2;
		const assert_1 = assert$2;
		/**
		 * A struct for validating a version string.
		 */
		exports.VersionStruct = (0, superstruct_1.refine)((0, superstruct_1.string)(), 'Version', (value) => {
		    if ((0, semver_1.valid)(value) === null) {
		        return `Expected SemVer version, got "${value}"`;
		    }
		    return true;
		});
		exports.VersionRangeStruct = (0, superstruct_1.refine)((0, superstruct_1.string)(), 'Version range', (value) => {
		    if ((0, semver_1.validRange)(value) === null) {
		        return `Expected SemVer range, got "${value}"`;
		    }
		    return true;
		});
		/**
		 * Checks whether a SemVer version is valid.
		 *
		 * @param version - A potential version.
		 * @returns `true` if the version is valid, and `false` otherwise.
		 */
		function isValidSemVerVersion(version) {
		    return (0, superstruct_1.is)(version, exports.VersionStruct);
		}
		exports.isValidSemVerVersion = isValidSemVerVersion;
		/**
		 * Checks whether a SemVer version range is valid.
		 *
		 * @param versionRange - A potential version range.
		 * @returns `true` if the version range is valid, and `false` otherwise.
		 */
		function isValidSemVerRange(versionRange) {
		    return (0, superstruct_1.is)(versionRange, exports.VersionRangeStruct);
		}
		exports.isValidSemVerRange = isValidSemVerRange;
		/**
		 * Asserts that a value is a valid concrete SemVer version.
		 *
		 * @param version - A potential SemVer concrete version.
		 */
		function assertIsSemVerVersion(version) {
		    (0, assert_1.assertStruct)(version, exports.VersionStruct);
		}
		exports.assertIsSemVerVersion = assertIsSemVerVersion;
		/**
		 * Asserts that a value is a valid SemVer range.
		 *
		 * @param range - A potential SemVer range.
		 */
		function assertIsSemVerRange(range) {
		    (0, assert_1.assertStruct)(range, exports.VersionRangeStruct);
		}
		exports.assertIsSemVerRange = assertIsSemVerRange;
		/**
		 * Checks whether a SemVer version is greater than another.
		 *
		 * @param version1 - The left-hand version.
		 * @param version2 - The right-hand version.
		 * @returns `version1 > version2`.
		 */
		function gtVersion(version1, version2) {
		    return (0, semver_1.gt)(version1, version2);
		}
		exports.gtVersion = gtVersion;
		/**
		 * Checks whether a SemVer version is greater than all possibilities in a range.
		 *
		 * @param version - A SemvVer version.
		 * @param range - The range to check against.
		 * @returns `version > range`.
		 */
		function gtRange(version, range) {
		    return (0, semver_1.gtr)(version, range);
		}
		exports.gtRange = gtRange;
		/**
		 * Returns whether a SemVer version satisfies a SemVer range.
		 *
		 * @param version - The SemVer version to check.
		 * @param versionRange - The SemVer version range to check against.
		 * @returns Whether the version satisfied the version range.
		 */
		function satisfiesVersionRange(version, versionRange) {
		    return (0, semver_1.satisfies)(version, versionRange, {
		        includePrerelease: true,
		    });
		}
		exports.satisfiesVersionRange = satisfiesVersionRange;
		
	} (versions));

	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(assert$2, exports);
		__exportStar(base64$1, exports);
		__exportStar(bytes, exports);
		__exportStar(checksum, exports);
		__exportStar(coercers, exports);
		__exportStar(collections, exports);
		__exportStar(hex, exports);
		__exportStar(json, exports);
		__exportStar(logging, exports);
		__exportStar(misc, exports);
		__exportStar(number, exports);
		__exportStar(opaque, exports);
		__exportStar(time$1, exports);
		__exportStar(versions, exports);
		
	} (dist$3));

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.createModuleLogger = exports.projectLogger = void 0;
		const utils_1 = dist$3;
		Object.defineProperty(exports, "createModuleLogger", { enumerable: true, get: function () { return utils_1.createModuleLogger; } });
		exports.projectLogger = (0, utils_1.createProjectLogger)('eth-block-tracker');
		
	} (loggingUtils));

	var __importDefault$b = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(PollingBlockTracker$1, "__esModule", { value: true });
	PollingBlockTracker$1.PollingBlockTracker = void 0;
	const json_rpc_random_id_1$1 = __importDefault$b(jsonRpcRandomId);
	const pify_1 = __importDefault$b(pify$2);
	const BaseBlockTracker_1$1 = BaseBlockTracker$1;
	const logging_utils_1 = loggingUtils;
	const log = (0, logging_utils_1.createModuleLogger)(logging_utils_1.projectLogger, 'polling-block-tracker');
	const createRandomId$2 = (0, json_rpc_random_id_1$1.default)();
	const sec = 1000;
	class PollingBlockTracker extends BaseBlockTracker_1$1.BaseBlockTracker {
	    constructor(opts = {}) {
	        var _a;
	        // parse + validate args
	        if (!opts.provider) {
	            throw new Error('PollingBlockTracker - no provider specified.');
	        }
	        super({
	            blockResetDuration: (_a = opts.blockResetDuration) !== null && _a !== void 0 ? _a : opts.pollingInterval,
	        });
	        // config
	        this._provider = opts.provider;
	        this._pollingInterval = opts.pollingInterval || 20 * sec;
	        this._retryTimeout = opts.retryTimeout || this._pollingInterval / 10;
	        this._keepEventLoopActive =
	            opts.keepEventLoopActive === undefined ? true : opts.keepEventLoopActive;
	        this._setSkipCacheFlag = opts.setSkipCacheFlag || false;
	    }
	    // trigger block polling
	    async checkForLatestBlock() {
	        await this._updateLatestBlock();
	        return await this.getLatestBlock();
	    }
	    async _start() {
	        this._synchronize();
	    }
	    async _end() {
	        // No-op
	    }
	    async _synchronize() {
	        var _a;
	        while (this._isRunning) {
	            try {
	                await this._updateLatestBlock();
	                const promise = timeout$1(this._pollingInterval, !this._keepEventLoopActive);
	                this.emit('_waitingForNextIteration');
	                await promise;
	            }
	            catch (err) {
	                const newErr = new Error(`PollingBlockTracker - encountered an error while attempting to update latest block:\n${(_a = err.stack) !== null && _a !== void 0 ? _a : err}`);
	                try {
	                    this.emit('error', newErr);
	                }
	                catch (emitErr) {
	                    console.error(newErr);
	                }
	                const promise = timeout$1(this._retryTimeout, !this._keepEventLoopActive);
	                this.emit('_waitingForNextIteration');
	                await promise;
	            }
	        }
	    }
	    async _updateLatestBlock() {
	        // fetch + set latest block
	        const latestBlock = await this._fetchLatestBlock();
	        this._newPotentialLatest(latestBlock);
	    }
	    async _fetchLatestBlock() {
	        const req = {
	            jsonrpc: '2.0',
	            id: createRandomId$2(),
	            method: 'eth_blockNumber',
	            params: [],
	        };
	        if (this._setSkipCacheFlag) {
	            req.skipCache = true;
	        }
	        log('Making request', req);
	        const res = await (0, pify_1.default)((cb) => this._provider.sendAsync(req, cb))();
	        log('Got response', res);
	        if (res.error) {
	            throw new Error(`PollingBlockTracker - encountered error fetching block:\n${res.error.message}`);
	        }
	        return res.result;
	    }
	}
	PollingBlockTracker$1.PollingBlockTracker = PollingBlockTracker;
	/**
	 * Waits for the specified amount of time.
	 *
	 * @param duration - The amount of time in milliseconds.
	 * @param unref - Assuming this function is run in a Node context, governs
	 * whether Node should wait before the `setTimeout` has completed before ending
	 * the process (true for no, false for yes). Defaults to false.
	 * @returns A promise that can be used to wait.
	 */
	function timeout$1(duration, unref) {
	    return new Promise((resolve) => {
	        const timeoutRef = setTimeout(resolve, duration);
	        // don't keep process open
	        if (timeoutRef.unref && unref) {
	            timeoutRef.unref();
	        }
	    });
	}

	var SubscribeBlockTracker$1 = {};

	var __importDefault$a = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(SubscribeBlockTracker$1, "__esModule", { value: true });
	SubscribeBlockTracker$1.SubscribeBlockTracker = void 0;
	const json_rpc_random_id_1 = __importDefault$a(jsonRpcRandomId);
	const BaseBlockTracker_1 = BaseBlockTracker$1;
	const createRandomId$1 = (0, json_rpc_random_id_1.default)();
	class SubscribeBlockTracker extends BaseBlockTracker_1.BaseBlockTracker {
	    constructor(opts = {}) {
	        // parse + validate args
	        if (!opts.provider) {
	            throw new Error('SubscribeBlockTracker - no provider specified.');
	        }
	        // BaseBlockTracker constructor
	        super(opts);
	        // config
	        this._provider = opts.provider;
	        this._subscriptionId = null;
	    }
	    async checkForLatestBlock() {
	        return await this.getLatestBlock();
	    }
	    async _start() {
	        if (this._subscriptionId === undefined || this._subscriptionId === null) {
	            try {
	                const blockNumber = (await this._call('eth_blockNumber'));
	                this._subscriptionId = (await this._call('eth_subscribe', 'newHeads'));
	                this._provider.on('data', this._handleSubData.bind(this));
	                this._newPotentialLatest(blockNumber);
	            }
	            catch (e) {
	                this.emit('error', e);
	            }
	        }
	    }
	    async _end() {
	        if (this._subscriptionId !== null && this._subscriptionId !== undefined) {
	            try {
	                await this._call('eth_unsubscribe', this._subscriptionId);
	                this._subscriptionId = null;
	            }
	            catch (e) {
	                this.emit('error', e);
	            }
	        }
	    }
	    _call(method, ...params) {
	        return new Promise((resolve, reject) => {
	            this._provider.sendAsync({
	                id: createRandomId$1(),
	                method,
	                params,
	                jsonrpc: '2.0',
	            }, (err, res) => {
	                if (err) {
	                    reject(err);
	                }
	                else {
	                    resolve(res.result);
	                }
	            });
	        });
	    }
	    _handleSubData(_, response) {
	        var _a;
	        if (response.method === 'eth_subscription' &&
	            ((_a = response.params) === null || _a === void 0 ? void 0 : _a.subscription) === this._subscriptionId) {
	            this._newPotentialLatest(response.params.result.number);
	        }
	    }
	}
	SubscribeBlockTracker$1.SubscribeBlockTracker = SubscribeBlockTracker;

	var types$3 = {};

	Object.defineProperty(types$3, "__esModule", { value: true });

	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(PollingBlockTracker$1, exports);
		__exportStar(SubscribeBlockTracker$1, exports);
		__exportStar(types$3, exports);
		
	} (dist$4));

	var dist$1 = {};

	var idRemapMiddleware = {};

	var getUniqueId$1 = {};

	Object.defineProperty(getUniqueId$1, "__esModule", { value: true });
	getUniqueId$1.getUniqueId = void 0;
	// uint32 (two's complement) max
	// more conservative than Number.MAX_SAFE_INTEGER
	const MAX = 4294967295;
	let idCounter = Math.floor(Math.random() * MAX);
	function getUniqueId() {
	    idCounter = (idCounter + 1) % MAX;
	    return idCounter;
	}
	getUniqueId$1.getUniqueId = getUniqueId;

	Object.defineProperty(idRemapMiddleware, "__esModule", { value: true });
	idRemapMiddleware.createIdRemapMiddleware = void 0;
	const getUniqueId_1 = getUniqueId$1;
	function createIdRemapMiddleware() {
	    return (req, res, next, _end) => {
	        const originalId = req.id;
	        const newId = getUniqueId_1.getUniqueId();
	        req.id = newId;
	        res.id = newId;
	        next((done) => {
	            req.id = originalId;
	            res.id = originalId;
	            done();
	        });
	    };
	}
	idRemapMiddleware.createIdRemapMiddleware = createIdRemapMiddleware;

	var createAsyncMiddleware$3 = {};

	Object.defineProperty(createAsyncMiddleware$3, "__esModule", { value: true });
	createAsyncMiddleware$3.createAsyncMiddleware = void 0;
	/**
	 * JsonRpcEngine only accepts callback-based middleware directly.
	 * createAsyncMiddleware exists to enable consumers to pass in async middleware
	 * functions.
	 *
	 * Async middleware have no "end" function. Instead, they "end" if they return
	 * without calling "next". Rather than passing in explicit return handlers,
	 * async middleware can simply await "next", and perform operations on the
	 * response object when execution resumes.
	 *
	 * To accomplish this, createAsyncMiddleware passes the async middleware a
	 * wrapped "next" function. That function calls the internal JsonRpcEngine
	 * "next" function with a return handler that resolves a promise when called.
	 *
	 * The return handler will always be called. Its resolution of the promise
	 * enables the control flow described above.
	 */
	function createAsyncMiddleware$2(asyncMiddleware) {
	    return async (req, res, next, end) => {
	        // nextPromise is the key to the implementation
	        // it is resolved by the return handler passed to the
	        // "next" function
	        let resolveNextPromise;
	        const nextPromise = new Promise((resolve) => {
	            resolveNextPromise = resolve;
	        });
	        let returnHandlerCallback = null;
	        let nextWasCalled = false;
	        // This will be called by the consumer's async middleware.
	        const asyncNext = async () => {
	            nextWasCalled = true;
	            // We pass a return handler to next(). When it is called by the engine,
	            // the consumer's async middleware will resume executing.
	            // eslint-disable-next-line node/callback-return
	            next((runReturnHandlersCallback) => {
	                // This callback comes from JsonRpcEngine._runReturnHandlers
	                returnHandlerCallback = runReturnHandlersCallback;
	                resolveNextPromise();
	            });
	            await nextPromise;
	        };
	        try {
	            await asyncMiddleware(req, res, asyncNext);
	            if (nextWasCalled) {
	                await nextPromise; // we must wait until the return handler is called
	                returnHandlerCallback(null);
	            }
	            else {
	                end(null);
	            }
	        }
	        catch (error) {
	            if (returnHandlerCallback) {
	                returnHandlerCallback(error);
	            }
	            else {
	                end(error);
	            }
	        }
	    };
	}
	createAsyncMiddleware$3.createAsyncMiddleware = createAsyncMiddleware$2;

	var createScaffoldMiddleware$3 = {};

	Object.defineProperty(createScaffoldMiddleware$3, "__esModule", { value: true });
	createScaffoldMiddleware$3.createScaffoldMiddleware = void 0;
	function createScaffoldMiddleware$2(handlers) {
	    return (req, res, next, end) => {
	        const handler = handlers[req.method];
	        // if no handler, return
	        if (handler === undefined) {
	            return next();
	        }
	        // if handler is fn, call as middleware
	        if (typeof handler === 'function') {
	            return handler(req, res, next, end);
	        }
	        // if handler is some other value, use as result
	        res.result = handler;
	        return end();
	    };
	}
	createScaffoldMiddleware$3.createScaffoldMiddleware = createScaffoldMiddleware$2;

	var JsonRpcEngine$1 = {};

	var dist = {};

	var classes = {};

	Object.defineProperty(classes, "__esModule", { value: true });
	classes.EthereumProviderError = classes.EthereumRpcError = void 0;
	const fast_safe_stringify_1 = fastSafeStringify;
	/**
	 * Error subclass implementing JSON RPC 2.0 errors and Ethereum RPC errors
	 * per EIP-1474.
	 * Permits any integer error code.
	 */
	class EthereumRpcError extends Error {
	    constructor(code, message, data) {
	        if (!Number.isInteger(code)) {
	            throw new Error('"code" must be an integer.');
	        }
	        if (!message || typeof message !== 'string') {
	            throw new Error('"message" must be a nonempty string.');
	        }
	        super(message);
	        this.code = code;
	        if (data !== undefined) {
	            this.data = data;
	        }
	    }
	    /**
	     * Returns a plain object with all public class properties.
	     */
	    serialize() {
	        const serialized = {
	            code: this.code,
	            message: this.message,
	        };
	        if (this.data !== undefined) {
	            serialized.data = this.data;
	        }
	        if (this.stack) {
	            serialized.stack = this.stack;
	        }
	        return serialized;
	    }
	    /**
	     * Return a string representation of the serialized error, omitting
	     * any circular references.
	     */
	    toString() {
	        return fast_safe_stringify_1.default(this.serialize(), stringifyReplacer, 2);
	    }
	}
	classes.EthereumRpcError = EthereumRpcError;
	/**
	 * Error subclass implementing Ethereum Provider errors per EIP-1193.
	 * Permits integer error codes in the [ 1000 <= 4999 ] range.
	 */
	class EthereumProviderError extends EthereumRpcError {
	    /**
	     * Create an Ethereum Provider JSON-RPC error.
	     * `code` must be an integer in the 1000 <= 4999 range.
	     */
	    constructor(code, message, data) {
	        if (!isValidEthProviderCode(code)) {
	            throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
	        }
	        super(code, message, data);
	    }
	}
	classes.EthereumProviderError = EthereumProviderError;
	// Internal
	function isValidEthProviderCode(code) {
	    return Number.isInteger(code) && code >= 1000 && code <= 4999;
	}
	function stringifyReplacer(_, value) {
	    if (value === '[Circular]') {
	        return undefined;
	    }
	    return value;
	}

	var utils$4 = {};

	var errorConstants = {};

	Object.defineProperty(errorConstants, "__esModule", { value: true });
	errorConstants.errorValues = errorConstants.errorCodes = void 0;
	errorConstants.errorCodes = {
	    rpc: {
	        invalidInput: -32000,
	        resourceNotFound: -32001,
	        resourceUnavailable: -32002,
	        transactionRejected: -32003,
	        methodNotSupported: -32004,
	        limitExceeded: -32005,
	        parse: -32700,
	        invalidRequest: -32600,
	        methodNotFound: -32601,
	        invalidParams: -32602,
	        internal: -32603,
	    },
	    provider: {
	        userRejectedRequest: 4001,
	        unauthorized: 4100,
	        unsupportedMethod: 4200,
	        disconnected: 4900,
	        chainDisconnected: 4901,
	    },
	};
	errorConstants.errorValues = {
	    '-32700': {
	        standard: 'JSON RPC 2.0',
	        message: 'Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text.',
	    },
	    '-32600': {
	        standard: 'JSON RPC 2.0',
	        message: 'The JSON sent is not a valid Request object.',
	    },
	    '-32601': {
	        standard: 'JSON RPC 2.0',
	        message: 'The method does not exist / is not available.',
	    },
	    '-32602': {
	        standard: 'JSON RPC 2.0',
	        message: 'Invalid method parameter(s).',
	    },
	    '-32603': {
	        standard: 'JSON RPC 2.0',
	        message: 'Internal JSON-RPC error.',
	    },
	    '-32000': {
	        standard: 'EIP-1474',
	        message: 'Invalid input.',
	    },
	    '-32001': {
	        standard: 'EIP-1474',
	        message: 'Resource not found.',
	    },
	    '-32002': {
	        standard: 'EIP-1474',
	        message: 'Resource unavailable.',
	    },
	    '-32003': {
	        standard: 'EIP-1474',
	        message: 'Transaction rejected.',
	    },
	    '-32004': {
	        standard: 'EIP-1474',
	        message: 'Method not supported.',
	    },
	    '-32005': {
	        standard: 'EIP-1474',
	        message: 'Request limit exceeded.',
	    },
	    '4001': {
	        standard: 'EIP-1193',
	        message: 'User rejected the request.',
	    },
	    '4100': {
	        standard: 'EIP-1193',
	        message: 'The requested account and/or method has not been authorized by the user.',
	    },
	    '4200': {
	        standard: 'EIP-1193',
	        message: 'The requested method is not supported by this Ethereum provider.',
	    },
	    '4900': {
	        standard: 'EIP-1193',
	        message: 'The provider is disconnected from all chains.',
	    },
	    '4901': {
	        standard: 'EIP-1193',
	        message: 'The provider is disconnected from the specified chain.',
	    },
	};

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.serializeError = exports.isValidCode = exports.getMessageFromCode = exports.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
		const error_constants_1 = errorConstants;
		const classes_1 = classes;
		const FALLBACK_ERROR_CODE = error_constants_1.errorCodes.rpc.internal;
		const FALLBACK_MESSAGE = 'Unspecified error message. This is a bug, please report it.';
		const FALLBACK_ERROR = {
		    code: FALLBACK_ERROR_CODE,
		    message: getMessageFromCode(FALLBACK_ERROR_CODE),
		};
		exports.JSON_RPC_SERVER_ERROR_MESSAGE = 'Unspecified server error.';
		/**
		 * Gets the message for a given code, or a fallback message if the code has
		 * no corresponding message.
		 */
		function getMessageFromCode(code, fallbackMessage = FALLBACK_MESSAGE) {
		    if (Number.isInteger(code)) {
		        const codeString = code.toString();
		        if (hasKey(error_constants_1.errorValues, codeString)) {
		            return error_constants_1.errorValues[codeString].message;
		        }
		        if (isJsonRpcServerError(code)) {
		            return exports.JSON_RPC_SERVER_ERROR_MESSAGE;
		        }
		    }
		    return fallbackMessage;
		}
		exports.getMessageFromCode = getMessageFromCode;
		/**
		 * Returns whether the given code is valid.
		 * A code is only valid if it has a message.
		 */
		function isValidCode(code) {
		    if (!Number.isInteger(code)) {
		        return false;
		    }
		    const codeString = code.toString();
		    if (error_constants_1.errorValues[codeString]) {
		        return true;
		    }
		    if (isJsonRpcServerError(code)) {
		        return true;
		    }
		    return false;
		}
		exports.isValidCode = isValidCode;
		/**
		 * Serializes the given error to an Ethereum JSON RPC-compatible error object.
		 * Merely copies the given error's values if it is already compatible.
		 * If the given error is not fully compatible, it will be preserved on the
		 * returned object's data.originalError property.
		 */
		function serializeError(error, { fallbackError = FALLBACK_ERROR, shouldIncludeStack = false, } = {}) {
		    var _a, _b;
		    if (!fallbackError ||
		        !Number.isInteger(fallbackError.code) ||
		        typeof fallbackError.message !== 'string') {
		        throw new Error('Must provide fallback error with integer number code and string message.');
		    }
		    if (error instanceof classes_1.EthereumRpcError) {
		        return error.serialize();
		    }
		    const serialized = {};
		    if (error &&
		        typeof error === 'object' &&
		        !Array.isArray(error) &&
		        hasKey(error, 'code') &&
		        isValidCode(error.code)) {
		        const _error = error;
		        serialized.code = _error.code;
		        if (_error.message && typeof _error.message === 'string') {
		            serialized.message = _error.message;
		            if (hasKey(_error, 'data')) {
		                serialized.data = _error.data;
		            }
		        }
		        else {
		            serialized.message = getMessageFromCode(serialized.code);
		            serialized.data = { originalError: assignOriginalError(error) };
		        }
		    }
		    else {
		        serialized.code = fallbackError.code;
		        const message = (_a = error) === null || _a === void 0 ? void 0 : _a.message;
		        serialized.message = (message && typeof message === 'string'
		            ? message
		            : fallbackError.message);
		        serialized.data = { originalError: assignOriginalError(error) };
		    }
		    const stack = (_b = error) === null || _b === void 0 ? void 0 : _b.stack;
		    if (shouldIncludeStack && error && stack && typeof stack === 'string') {
		        serialized.stack = stack;
		    }
		    return serialized;
		}
		exports.serializeError = serializeError;
		// Internal
		function isJsonRpcServerError(code) {
		    return code >= -32099 && code <= -32000;
		}
		function assignOriginalError(error) {
		    if (error && typeof error === 'object' && !Array.isArray(error)) {
		        return Object.assign({}, error);
		    }
		    return error;
		}
		function hasKey(obj, key) {
		    return Object.prototype.hasOwnProperty.call(obj, key);
		}
		
	} (utils$4));

	var errors = {};

	Object.defineProperty(errors, "__esModule", { value: true });
	errors.ethErrors = void 0;
	const classes_1 = classes;
	const utils_1 = utils$4;
	const error_constants_1 = errorConstants;
	errors.ethErrors = {
	    rpc: {
	        /**
	         * Get a JSON RPC 2.0 Parse (-32700) error.
	         */
	        parse: (arg) => getEthJsonRpcError(error_constants_1.errorCodes.rpc.parse, arg),
	        /**
	         * Get a JSON RPC 2.0 Invalid Request (-32600) error.
	         */
	        invalidRequest: (arg) => getEthJsonRpcError(error_constants_1.errorCodes.rpc.invalidRequest, arg),
	        /**
	         * Get a JSON RPC 2.0 Invalid Params (-32602) error.
	         */
	        invalidParams: (arg) => getEthJsonRpcError(error_constants_1.errorCodes.rpc.invalidParams, arg),
	        /**
	         * Get a JSON RPC 2.0 Method Not Found (-32601) error.
	         */
	        methodNotFound: (arg) => getEthJsonRpcError(error_constants_1.errorCodes.rpc.methodNotFound, arg),
	        /**
	         * Get a JSON RPC 2.0 Internal (-32603) error.
	         */
	        internal: (arg) => getEthJsonRpcError(error_constants_1.errorCodes.rpc.internal, arg),
	        /**
	         * Get a JSON RPC 2.0 Server error.
	         * Permits integer error codes in the [ -32099 <= -32005 ] range.
	         * Codes -32000 through -32004 are reserved by EIP-1474.
	         */
	        server: (opts) => {
	            if (!opts || typeof opts !== 'object' || Array.isArray(opts)) {
	                throw new Error('Ethereum RPC Server errors must provide single object argument.');
	            }
	            const { code } = opts;
	            if (!Number.isInteger(code) || code > -32005 || code < -32099) {
	                throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
	            }
	            return getEthJsonRpcError(code, opts);
	        },
	        /**
	         * Get an Ethereum JSON RPC Invalid Input (-32000) error.
	         */
	        invalidInput: (arg) => getEthJsonRpcError(error_constants_1.errorCodes.rpc.invalidInput, arg),
	        /**
	         * Get an Ethereum JSON RPC Resource Not Found (-32001) error.
	         */
	        resourceNotFound: (arg) => getEthJsonRpcError(error_constants_1.errorCodes.rpc.resourceNotFound, arg),
	        /**
	         * Get an Ethereum JSON RPC Resource Unavailable (-32002) error.
	         */
	        resourceUnavailable: (arg) => getEthJsonRpcError(error_constants_1.errorCodes.rpc.resourceUnavailable, arg),
	        /**
	         * Get an Ethereum JSON RPC Transaction Rejected (-32003) error.
	         */
	        transactionRejected: (arg) => getEthJsonRpcError(error_constants_1.errorCodes.rpc.transactionRejected, arg),
	        /**
	         * Get an Ethereum JSON RPC Method Not Supported (-32004) error.
	         */
	        methodNotSupported: (arg) => getEthJsonRpcError(error_constants_1.errorCodes.rpc.methodNotSupported, arg),
	        /**
	         * Get an Ethereum JSON RPC Limit Exceeded (-32005) error.
	         */
	        limitExceeded: (arg) => getEthJsonRpcError(error_constants_1.errorCodes.rpc.limitExceeded, arg),
	    },
	    provider: {
	        /**
	         * Get an Ethereum Provider User Rejected Request (4001) error.
	         */
	        userRejectedRequest: (arg) => {
	            return getEthProviderError(error_constants_1.errorCodes.provider.userRejectedRequest, arg);
	        },
	        /**
	         * Get an Ethereum Provider Unauthorized (4100) error.
	         */
	        unauthorized: (arg) => {
	            return getEthProviderError(error_constants_1.errorCodes.provider.unauthorized, arg);
	        },
	        /**
	         * Get an Ethereum Provider Unsupported Method (4200) error.
	         */
	        unsupportedMethod: (arg) => {
	            return getEthProviderError(error_constants_1.errorCodes.provider.unsupportedMethod, arg);
	        },
	        /**
	         * Get an Ethereum Provider Not Connected (4900) error.
	         */
	        disconnected: (arg) => {
	            return getEthProviderError(error_constants_1.errorCodes.provider.disconnected, arg);
	        },
	        /**
	         * Get an Ethereum Provider Chain Not Connected (4901) error.
	         */
	        chainDisconnected: (arg) => {
	            return getEthProviderError(error_constants_1.errorCodes.provider.chainDisconnected, arg);
	        },
	        /**
	         * Get a custom Ethereum Provider error.
	         */
	        custom: (opts) => {
	            if (!opts || typeof opts !== 'object' || Array.isArray(opts)) {
	                throw new Error('Ethereum Provider custom errors must provide single object argument.');
	            }
	            const { code, message, data } = opts;
	            if (!message || typeof message !== 'string') {
	                throw new Error('"message" must be a nonempty string');
	            }
	            return new classes_1.EthereumProviderError(code, message, data);
	        },
	    },
	};
	// Internal
	function getEthJsonRpcError(code, arg) {
	    const [message, data] = parseOpts(arg);
	    return new classes_1.EthereumRpcError(code, message || utils_1.getMessageFromCode(code), data);
	}
	function getEthProviderError(code, arg) {
	    const [message, data] = parseOpts(arg);
	    return new classes_1.EthereumProviderError(code, message || utils_1.getMessageFromCode(code), data);
	}
	function parseOpts(arg) {
	    if (arg) {
	        if (typeof arg === 'string') {
	            return [arg];
	        }
	        else if (typeof arg === 'object' && !Array.isArray(arg)) {
	            const { message, data } = arg;
	            if (message && typeof message !== 'string') {
	                throw new Error('Must specify string message.');
	            }
	            return [message || undefined, data];
	        }
	    }
	    return [];
	}

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.getMessageFromCode = exports.serializeError = exports.EthereumProviderError = exports.EthereumRpcError = exports.ethErrors = exports.errorCodes = void 0;
		const classes_1 = classes;
		Object.defineProperty(exports, "EthereumRpcError", { enumerable: true, get: function () { return classes_1.EthereumRpcError; } });
		Object.defineProperty(exports, "EthereumProviderError", { enumerable: true, get: function () { return classes_1.EthereumProviderError; } });
		const utils_1 = utils$4;
		Object.defineProperty(exports, "serializeError", { enumerable: true, get: function () { return utils_1.serializeError; } });
		Object.defineProperty(exports, "getMessageFromCode", { enumerable: true, get: function () { return utils_1.getMessageFromCode; } });
		const errors_1 = errors;
		Object.defineProperty(exports, "ethErrors", { enumerable: true, get: function () { return errors_1.ethErrors; } });
		const error_constants_1 = errorConstants;
		Object.defineProperty(exports, "errorCodes", { enumerable: true, get: function () { return error_constants_1.errorCodes; } });
		
	} (dist));

	var __importDefault$9 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(JsonRpcEngine$1, "__esModule", { value: true });
	JsonRpcEngine$1.JsonRpcEngine = void 0;
	const safe_event_emitter_1$1 = __importDefault$9(safeEventEmitter);
	const eth_rpc_errors_1 = dist;
	/**
	 * A JSON-RPC request and response processor.
	 * Give it a stack of middleware, pass it requests, and get back responses.
	 */
	class JsonRpcEngine extends safe_event_emitter_1$1.default {
	    constructor() {
	        super();
	        this._middleware = [];
	    }
	    /**
	     * Add a middleware function to the engine's middleware stack.
	     *
	     * @param middleware - The middleware function to add.
	     */
	    push(middleware) {
	        this._middleware.push(middleware);
	    }
	    handle(req, cb) {
	        if (cb && typeof cb !== 'function') {
	            throw new Error('"callback" must be a function if provided.');
	        }
	        if (Array.isArray(req)) {
	            if (cb) {
	                return this._handleBatch(req, cb);
	            }
	            return this._handleBatch(req);
	        }
	        if (cb) {
	            return this._handle(req, cb);
	        }
	        return this._promiseHandle(req);
	    }
	    /**
	     * Returns this engine as a middleware function that can be pushed to other
	     * engines.
	     *
	     * @returns This engine as a middleware function.
	     */
	    asMiddleware() {
	        return async (req, res, next, end) => {
	            try {
	                const [middlewareError, isComplete, returnHandlers,] = await JsonRpcEngine._runAllMiddleware(req, res, this._middleware);
	                if (isComplete) {
	                    await JsonRpcEngine._runReturnHandlers(returnHandlers);
	                    return end(middlewareError);
	                }
	                return next(async (handlerCallback) => {
	                    try {
	                        await JsonRpcEngine._runReturnHandlers(returnHandlers);
	                    }
	                    catch (error) {
	                        return handlerCallback(error);
	                    }
	                    return handlerCallback();
	                });
	            }
	            catch (error) {
	                return end(error);
	            }
	        };
	    }
	    async _handleBatch(reqs, cb) {
	        // The order here is important
	        try {
	            // 2. Wait for all requests to finish, or throw on some kind of fatal
	            // error
	            const responses = await Promise.all(
	            // 1. Begin executing each request in the order received
	            reqs.map(this._promiseHandle.bind(this)));
	            // 3. Return batch response
	            if (cb) {
	                return cb(null, responses);
	            }
	            return responses;
	        }
	        catch (error) {
	            if (cb) {
	                return cb(error);
	            }
	            throw error;
	        }
	    }
	    /**
	     * A promise-wrapped _handle.
	     */
	    _promiseHandle(req) {
	        return new Promise((resolve) => {
	            this._handle(req, (_err, res) => {
	                // There will always be a response, and it will always have any error
	                // that is caught and propagated.
	                resolve(res);
	            });
	        });
	    }
	    /**
	     * Ensures that the request object is valid, processes it, and passes any
	     * error and the response object to the given callback.
	     *
	     * Does not reject.
	     */
	    async _handle(callerReq, cb) {
	        if (!callerReq ||
	            Array.isArray(callerReq) ||
	            typeof callerReq !== 'object') {
	            const error = new eth_rpc_errors_1.EthereumRpcError(eth_rpc_errors_1.errorCodes.rpc.invalidRequest, `Requests must be plain objects. Received: ${typeof callerReq}`, { request: callerReq });
	            return cb(error, { id: undefined, jsonrpc: '2.0', error });
	        }
	        if (typeof callerReq.method !== 'string') {
	            const error = new eth_rpc_errors_1.EthereumRpcError(eth_rpc_errors_1.errorCodes.rpc.invalidRequest, `Must specify a string method. Received: ${typeof callerReq.method}`, { request: callerReq });
	            return cb(error, { id: callerReq.id, jsonrpc: '2.0', error });
	        }
	        const req = Object.assign({}, callerReq);
	        const res = {
	            id: req.id,
	            jsonrpc: req.jsonrpc,
	        };
	        let error = null;
	        try {
	            await this._processRequest(req, res);
	        }
	        catch (_error) {
	            // A request handler error, a re-thrown middleware error, or something
	            // unexpected.
	            error = _error;
	        }
	        if (error) {
	            // Ensure no result is present on an errored response
	            delete res.result;
	            if (!res.error) {
	                res.error = eth_rpc_errors_1.serializeError(error);
	            }
	        }
	        return cb(error, res);
	    }
	    /**
	     * For the given request and response, runs all middleware and their return
	     * handlers, if any, and ensures that internal request processing semantics
	     * are satisfied.
	     */
	    async _processRequest(req, res) {
	        const [error, isComplete, returnHandlers,] = await JsonRpcEngine._runAllMiddleware(req, res, this._middleware);
	        // Throw if "end" was not called, or if the response has neither a result
	        // nor an error.
	        JsonRpcEngine._checkForCompletion(req, res, isComplete);
	        // The return handlers should run even if an error was encountered during
	        // middleware processing.
	        await JsonRpcEngine._runReturnHandlers(returnHandlers);
	        // Now we re-throw the middleware processing error, if any, to catch it
	        // further up the call chain.
	        if (error) {
	            throw error;
	        }
	    }
	    /**
	     * Serially executes the given stack of middleware.
	     *
	     * @returns An array of any error encountered during middleware execution,
	     * a boolean indicating whether the request was completed, and an array of
	     * middleware-defined return handlers.
	     */
	    static async _runAllMiddleware(req, res, middlewareStack) {
	        const returnHandlers = [];
	        let error = null;
	        let isComplete = false;
	        // Go down stack of middleware, call and collect optional returnHandlers
	        for (const middleware of middlewareStack) {
	            [error, isComplete] = await JsonRpcEngine._runMiddleware(req, res, middleware, returnHandlers);
	            if (isComplete) {
	                break;
	            }
	        }
	        return [error, isComplete, returnHandlers.reverse()];
	    }
	    /**
	     * Runs an individual middleware.
	     *
	     * @returns An array of any error encountered during middleware exection,
	     * and a boolean indicating whether the request should end.
	     */
	    static _runMiddleware(req, res, middleware, returnHandlers) {
	        return new Promise((resolve) => {
	            const end = (err) => {
	                const error = err || res.error;
	                if (error) {
	                    res.error = eth_rpc_errors_1.serializeError(error);
	                }
	                // True indicates that the request should end
	                resolve([error, true]);
	            };
	            const next = (returnHandler) => {
	                if (res.error) {
	                    end(res.error);
	                }
	                else {
	                    if (returnHandler) {
	                        if (typeof returnHandler !== 'function') {
	                            end(new eth_rpc_errors_1.EthereumRpcError(eth_rpc_errors_1.errorCodes.rpc.internal, `JsonRpcEngine: "next" return handlers must be functions. ` +
	                                `Received "${typeof returnHandler}" for request:\n${jsonify(req)}`, { request: req }));
	                        }
	                        returnHandlers.push(returnHandler);
	                    }
	                    // False indicates that the request should not end
	                    resolve([null, false]);
	                }
	            };
	            try {
	                middleware(req, res, next, end);
	            }
	            catch (error) {
	                end(error);
	            }
	        });
	    }
	    /**
	     * Serially executes array of return handlers. The request and response are
	     * assumed to be in their scope.
	     */
	    static async _runReturnHandlers(handlers) {
	        for (const handler of handlers) {
	            await new Promise((resolve, reject) => {
	                handler((err) => (err ? reject(err) : resolve()));
	            });
	        }
	    }
	    /**
	     * Throws an error if the response has neither a result nor an error, or if
	     * the "isComplete" flag is falsy.
	     */
	    static _checkForCompletion(req, res, isComplete) {
	        if (!('result' in res) && !('error' in res)) {
	            throw new eth_rpc_errors_1.EthereumRpcError(eth_rpc_errors_1.errorCodes.rpc.internal, `JsonRpcEngine: Response has no error or result for request:\n${jsonify(req)}`, { request: req });
	        }
	        if (!isComplete) {
	            throw new eth_rpc_errors_1.EthereumRpcError(eth_rpc_errors_1.errorCodes.rpc.internal, `JsonRpcEngine: Nothing ended request:\n${jsonify(req)}`, { request: req });
	        }
	    }
	}
	JsonRpcEngine$1.JsonRpcEngine = JsonRpcEngine;
	function jsonify(request) {
	    return JSON.stringify(request, null, 2);
	}

	var mergeMiddleware$1 = {};

	Object.defineProperty(mergeMiddleware$1, "__esModule", { value: true });
	mergeMiddleware$1.mergeMiddleware = void 0;
	const JsonRpcEngine_1 = JsonRpcEngine$1;
	function mergeMiddleware(middlewareStack) {
	    const engine = new JsonRpcEngine_1.JsonRpcEngine();
	    middlewareStack.forEach((middleware) => engine.push(middleware));
	    return engine.asMiddleware();
	}
	mergeMiddleware$1.mergeMiddleware = mergeMiddleware;

	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(idRemapMiddleware, exports);
		__exportStar(createAsyncMiddleware$3, exports);
		__exportStar(createScaffoldMiddleware$3, exports);
		__exportStar(getUniqueId$1, exports);
		__exportStar(JsonRpcEngine$1, exports);
		__exportStar(mergeMiddleware$1, exports);
		
	} (dist$1));

	var lib = {};

	var Mutex$2 = {};

	/******************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global Reflect, Promise, SuppressedError, Symbol */

	var extendStatics = function(d, b) {
	  extendStatics = Object.setPrototypeOf ||
	      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	  return extendStatics(d, b);
	};

	function __extends(d, b) {
	  if (typeof b !== "function" && b !== null)
	      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	  extendStatics(d, b);
	  function __() { this.constructor = d; }
	  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var __assign = function() {
	  __assign = Object.assign || function __assign(t) {
	      for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	      }
	      return t;
	  };
	  return __assign.apply(this, arguments);
	};

	function __rest(s, e) {
	  var t = {};
	  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	      t[p] = s[p];
	  if (s != null && typeof Object.getOwnPropertySymbols === "function")
	      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	              t[p[i]] = s[p[i]];
	      }
	  return t;
	}

	function __decorate$1(decorators, target, key, desc) {
	  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	  return c > 3 && r && Object.defineProperty(target, key, r), r;
	}

	function __param(paramIndex, decorator) {
	  return function (target, key) { decorator(target, key, paramIndex); }
	}

	function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
	  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
	  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
	  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
	  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
	  var _, done = false;
	  for (var i = decorators.length - 1; i >= 0; i--) {
	      var context = {};
	      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
	      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
	      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
	      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
	      if (kind === "accessor") {
	          if (result === void 0) continue;
	          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
	          if (_ = accept(result.get)) descriptor.get = _;
	          if (_ = accept(result.set)) descriptor.set = _;
	          if (_ = accept(result.init)) initializers.unshift(_);
	      }
	      else if (_ = accept(result)) {
	          if (kind === "field") initializers.unshift(_);
	          else descriptor[key] = _;
	      }
	  }
	  if (target) Object.defineProperty(target, contextIn.name, descriptor);
	  done = true;
	}
	function __runInitializers(thisArg, initializers, value) {
	  var useValue = arguments.length > 2;
	  for (var i = 0; i < initializers.length; i++) {
	      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
	  }
	  return useValue ? value : void 0;
	}
	function __propKey(x) {
	  return typeof x === "symbol" ? x : "".concat(x);
	}
	function __setFunctionName(f, name, prefix) {
	  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
	  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
	}
	function __metadata(metadataKey, metadataValue) {
	  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	}

	function __awaiter(thisArg, _arguments, P, generator) {
	  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	  return new (P || (P = Promise))(function (resolve, reject) {
	      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	      step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	}

	function __generator(thisArg, body) {
	  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	  function verb(n) { return function (v) { return step([n, v]); }; }
	  function step(op) {
	      if (f) throw new TypeError("Generator is already executing.");
	      while (g && (g = 0, op[0] && (_ = 0)), _) try {
	          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	          if (y = 0, t) op = [op[0] & 2, t.value];
	          switch (op[0]) {
	              case 0: case 1: t = op; break;
	              case 4: _.label++; return { value: op[1], done: false };
	              case 5: _.label++; y = op[1]; op = [0]; continue;
	              case 7: op = _.ops.pop(); _.trys.pop(); continue;
	              default:
	                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                  if (t[2]) _.ops.pop();
	                  _.trys.pop(); continue;
	          }
	          op = body.call(thisArg, _);
	      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	  }
	}

	var __createBinding$1 = Object.create ? (function(o, m, k, k2) {
	  if (k2 === undefined) k2 = k;
	  var desc = Object.getOwnPropertyDescriptor(m, k);
	  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	  }
	  Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	  if (k2 === undefined) k2 = k;
	  o[k2] = m[k];
	});

	function __exportStar(m, o) {
	  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding$1(o, m, p);
	}

	function __values(o) {
	  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	  if (m) return m.call(o);
	  if (o && typeof o.length === "number") return {
	      next: function () {
	          if (o && i >= o.length) o = void 0;
	          return { value: o && o[i++], done: !o };
	      }
	  };
	  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	}

	function __read(o, n) {
	  var m = typeof Symbol === "function" && o[Symbol.iterator];
	  if (!m) return o;
	  var i = m.call(o), r, ar = [], e;
	  try {
	      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	  }
	  catch (error) { e = { error: error }; }
	  finally {
	      try {
	          if (r && !r.done && (m = i["return"])) m.call(i);
	      }
	      finally { if (e) throw e.error; }
	  }
	  return ar;
	}

	/** @deprecated */
	function __spread() {
	  for (var ar = [], i = 0; i < arguments.length; i++)
	      ar = ar.concat(__read(arguments[i]));
	  return ar;
	}

	/** @deprecated */
	function __spreadArrays() {
	  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	  for (var r = Array(s), k = 0, i = 0; i < il; i++)
	      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	          r[k] = a[j];
	  return r;
	}

	function __spreadArray(to, from, pack) {
	  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	      if (ar || !(i in from)) {
	          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	          ar[i] = from[i];
	      }
	  }
	  return to.concat(ar || Array.prototype.slice.call(from));
	}

	function __await(v) {
	  return this instanceof __await ? (this.v = v, this) : new __await(v);
	}

	function __asyncGenerator(thisArg, _arguments, generator) {
	  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	  var g = generator.apply(thisArg, _arguments || []), i, q = [];
	  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	  function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
	  function fulfill(value) { resume("next", value); }
	  function reject(value) { resume("throw", value); }
	  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	}

	function __asyncDelegator(o) {
	  var i, p;
	  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
	}

	function __asyncValues(o) {
	  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	  var m = o[Symbol.asyncIterator], i;
	  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	}

	function __makeTemplateObject(cooked, raw) {
	  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	  return cooked;
	}
	var __setModuleDefault$1 = Object.create ? (function(o, v) {
	  Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	  o["default"] = v;
	};

	function __importStar$1(mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1(result, mod, k);
	  __setModuleDefault$1(result, mod);
	  return result;
	}

	function __importDefault$8(mod) {
	  return (mod && mod.__esModule) ? mod : { default: mod };
	}

	function __classPrivateFieldGet(receiver, state, kind, f) {
	  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
	  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
	  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
	}

	function __classPrivateFieldSet(receiver, state, value, kind, f) {
	  if (kind === "m") throw new TypeError("Private method is not writable");
	  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
	  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
	  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
	}

	function __classPrivateFieldIn(state, receiver) {
	  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
	  return typeof state === "function" ? receiver === state : state.has(receiver);
	}

	function __addDisposableResource(env, value, async) {
	  if (value !== null && value !== void 0) {
	    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
	    var dispose;
	    if (async) {
	        if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
	        dispose = value[Symbol.asyncDispose];
	    }
	    if (dispose === void 0) {
	        if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
	        dispose = value[Symbol.dispose];
	    }
	    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
	    env.stack.push({ value: value, dispose: dispose, async: async });
	  }
	  else if (async) {
	    env.stack.push({ async: true });
	  }
	  return value;
	}

	var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
	  var e = new Error(message);
	  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
	};

	function __disposeResources(env) {
	  function fail(e) {
	    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
	    env.hasError = true;
	  }
	  function next() {
	    while (env.stack.length) {
	      var rec = env.stack.pop();
	      try {
	        var result = rec.dispose && rec.dispose.call(rec.value);
	        if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
	      }
	      catch (e) {
	          fail(e);
	      }
	    }
	    if (env.hasError) throw env.error;
	  }
	  return next();
	}

	var tslib_es6 = {
	  __extends,
	  __assign,
	  __rest,
	  __decorate: __decorate$1,
	  __param,
	  __metadata,
	  __awaiter,
	  __generator,
	  __createBinding: __createBinding$1,
	  __exportStar,
	  __values,
	  __read,
	  __spread,
	  __spreadArrays,
	  __spreadArray,
	  __await,
	  __asyncGenerator,
	  __asyncDelegator,
	  __asyncValues,
	  __makeTemplateObject,
	  __importStar: __importStar$1,
	  __importDefault: __importDefault$8,
	  __classPrivateFieldGet,
	  __classPrivateFieldSet,
	  __classPrivateFieldIn,
	  __addDisposableResource,
	  __disposeResources,
	};

	var tslib_es6$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		__addDisposableResource: __addDisposableResource,
		get __assign () { return __assign; },
		__asyncDelegator: __asyncDelegator,
		__asyncGenerator: __asyncGenerator,
		__asyncValues: __asyncValues,
		__await: __await,
		__awaiter: __awaiter,
		__classPrivateFieldGet: __classPrivateFieldGet,
		__classPrivateFieldIn: __classPrivateFieldIn,
		__classPrivateFieldSet: __classPrivateFieldSet,
		__createBinding: __createBinding$1,
		__decorate: __decorate$1,
		__disposeResources: __disposeResources,
		__esDecorate: __esDecorate,
		__exportStar: __exportStar,
		__extends: __extends,
		__generator: __generator,
		__importDefault: __importDefault$8,
		__importStar: __importStar$1,
		__makeTemplateObject: __makeTemplateObject,
		__metadata: __metadata,
		__param: __param,
		__propKey: __propKey,
		__read: __read,
		__rest: __rest,
		__runInitializers: __runInitializers,
		__setFunctionName: __setFunctionName,
		__spread: __spread,
		__spreadArray: __spreadArray,
		__spreadArrays: __spreadArrays,
		__values: __values,
		default: tslib_es6
	});

	var require$$0$2 = /*@__PURE__*/getAugmentedNamespace(tslib_es6$1);

	var Semaphore$1 = {};

	Object.defineProperty(Semaphore$1, "__esModule", { value: true });
	var tslib_1$3 = require$$0$2;
	var Semaphore = /** @class */ (function () {
	    function Semaphore(_maxConcurrency) {
	        this._maxConcurrency = _maxConcurrency;
	        this._queue = [];
	        if (_maxConcurrency <= 0) {
	            throw new Error('semaphore must be initialized to a positive value');
	        }
	        this._value = _maxConcurrency;
	    }
	    Semaphore.prototype.acquire = function () {
	        var _this = this;
	        var locked = this.isLocked();
	        var ticket = new Promise(function (r) { return _this._queue.push(r); });
	        if (!locked)
	            this._dispatch();
	        return ticket;
	    };
	    Semaphore.prototype.runExclusive = function (callback) {
	        return tslib_1$3.__awaiter(this, void 0, void 0, function () {
	            var _a, value, release;
	            return tslib_1$3.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0: return [4 /*yield*/, this.acquire()];
	                    case 1:
	                        _a = _b.sent(), value = _a[0], release = _a[1];
	                        _b.label = 2;
	                    case 2:
	                        _b.trys.push([2, , 4, 5]);
	                        return [4 /*yield*/, callback(value)];
	                    case 3: return [2 /*return*/, _b.sent()];
	                    case 4:
	                        release();
	                        return [7 /*endfinally*/];
	                    case 5: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    Semaphore.prototype.isLocked = function () {
	        return this._value <= 0;
	    };
	    Semaphore.prototype.release = function () {
	        if (this._maxConcurrency > 1) {
	            throw new Error('this method is unavailabel on semaphores with concurrency > 1; use the scoped release returned by acquire instead');
	        }
	        if (this._currentReleaser) {
	            var releaser = this._currentReleaser;
	            this._currentReleaser = undefined;
	            releaser();
	        }
	    };
	    Semaphore.prototype._dispatch = function () {
	        var _this = this;
	        var nextConsumer = this._queue.shift();
	        if (!nextConsumer)
	            return;
	        var released = false;
	        this._currentReleaser = function () {
	            if (released)
	                return;
	            released = true;
	            _this._value++;
	            _this._dispatch();
	        };
	        nextConsumer([this._value--, this._currentReleaser]);
	    };
	    return Semaphore;
	}());
	Semaphore$1.default = Semaphore;

	Object.defineProperty(Mutex$2, "__esModule", { value: true });
	var tslib_1$2 = require$$0$2;
	var Semaphore_1 = Semaphore$1;
	var Mutex$1 = /** @class */ (function () {
	    function Mutex() {
	        this._semaphore = new Semaphore_1.default(1);
	    }
	    Mutex.prototype.acquire = function () {
	        return tslib_1$2.__awaiter(this, void 0, void 0, function () {
	            var _a, releaser;
	            return tslib_1$2.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0: return [4 /*yield*/, this._semaphore.acquire()];
	                    case 1:
	                        _a = _b.sent(), releaser = _a[1];
	                        return [2 /*return*/, releaser];
	                }
	            });
	        });
	    };
	    Mutex.prototype.runExclusive = function (callback) {
	        return this._semaphore.runExclusive(function () { return callback(); });
	    };
	    Mutex.prototype.isLocked = function () {
	        return this._semaphore.isLocked();
	    };
	    Mutex.prototype.release = function () {
	        this._semaphore.release();
	    };
	    return Mutex;
	}());
	Mutex$2.default = Mutex$1;

	var withTimeout$1 = {};

	Object.defineProperty(withTimeout$1, "__esModule", { value: true });
	withTimeout$1.withTimeout = void 0;
	var tslib_1$1 = require$$0$2;
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function withTimeout(sync, timeout, timeoutError) {
	    var _this = this;
	    if (timeoutError === void 0) { timeoutError = new Error('timeout'); }
	    return {
	        acquire: function () {
	            return new Promise(function (resolve, reject) { return tslib_1$1.__awaiter(_this, void 0, void 0, function () {
	                var isTimeout, ticket, release;
	                return tslib_1$1.__generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            isTimeout = false;
	                            setTimeout(function () {
	                                isTimeout = true;
	                                reject(timeoutError);
	                            }, timeout);
	                            return [4 /*yield*/, sync.acquire()];
	                        case 1:
	                            ticket = _a.sent();
	                            if (isTimeout) {
	                                release = Array.isArray(ticket) ? ticket[1] : ticket;
	                                release();
	                            }
	                            else {
	                                resolve(ticket);
	                            }
	                            return [2 /*return*/];
	                    }
	                });
	            }); });
	        },
	        runExclusive: function (callback) {
	            return tslib_1$1.__awaiter(this, void 0, void 0, function () {
	                var release, ticket;
	                return tslib_1$1.__generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            release = function () { return undefined; };
	                            _a.label = 1;
	                        case 1:
	                            _a.trys.push([1, , 7, 8]);
	                            return [4 /*yield*/, this.acquire()];
	                        case 2:
	                            ticket = _a.sent();
	                            if (!Array.isArray(ticket)) return [3 /*break*/, 4];
	                            release = ticket[1];
	                            return [4 /*yield*/, callback(ticket[0])];
	                        case 3: return [2 /*return*/, _a.sent()];
	                        case 4:
	                            release = ticket;
	                            return [4 /*yield*/, callback()];
	                        case 5: return [2 /*return*/, _a.sent()];
	                        case 6: return [3 /*break*/, 8];
	                        case 7:
	                            release();
	                            return [7 /*endfinally*/];
	                        case 8: return [2 /*return*/];
	                    }
	                });
	            });
	        },
	        release: function () {
	            sync.release();
	        },
	        isLocked: function () { return sync.isLocked(); },
	    };
	}
	withTimeout$1.withTimeout = withTimeout;

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.withTimeout = exports.Semaphore = exports.Mutex = void 0;
		var Mutex_1 = Mutex$2;
		Object.defineProperty(exports, "Mutex", { enumerable: true, get: function () { return Mutex_1.default; } });
		var Semaphore_1 = Semaphore$1;
		Object.defineProperty(exports, "Semaphore", { enumerable: true, get: function () { return Semaphore_1.default; } });
		var withTimeout_1 = withTimeout$1;
		Object.defineProperty(exports, "withTimeout", { enumerable: true, get: function () { return withTimeout_1.withTimeout; } }); 
	} (lib));

	var immutable = extend$1;

	var hasOwnProperty = Object.prototype.hasOwnProperty;

	function extend$1() {
	    var target = {};

	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i];

	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key];
	            }
	        }
	    }

	    return target
	}

	const extend = immutable;
	const createRandomId = jsonRpcRandomId();

	var ethQuery = EthQuery$1;


	function EthQuery$1(provider){
	  const self = this;
	  self.currentProvider = provider;
	}

	//
	// base queries
	//

	// default block
	EthQuery$1.prototype.getBalance =                          generateFnWithDefaultBlockFor(2, 'eth_getBalance');
	EthQuery$1.prototype.getCode =                             generateFnWithDefaultBlockFor(2, 'eth_getCode');
	EthQuery$1.prototype.getTransactionCount =                 generateFnWithDefaultBlockFor(2, 'eth_getTransactionCount');
	EthQuery$1.prototype.getStorageAt =                        generateFnWithDefaultBlockFor(3, 'eth_getStorageAt');
	EthQuery$1.prototype.call =                                generateFnWithDefaultBlockFor(2, 'eth_call');
	// standard
	EthQuery$1.prototype.protocolVersion =                     generateFnFor('eth_protocolVersion');
	EthQuery$1.prototype.syncing =                             generateFnFor('eth_syncing');
	EthQuery$1.prototype.coinbase =                            generateFnFor('eth_coinbase');
	EthQuery$1.prototype.mining =                              generateFnFor('eth_mining');
	EthQuery$1.prototype.hashrate =                            generateFnFor('eth_hashrate');
	EthQuery$1.prototype.gasPrice =                            generateFnFor('eth_gasPrice');
	EthQuery$1.prototype.accounts =                            generateFnFor('eth_accounts');
	EthQuery$1.prototype.blockNumber =                         generateFnFor('eth_blockNumber');
	EthQuery$1.prototype.getBlockTransactionCountByHash =      generateFnFor('eth_getBlockTransactionCountByHash');
	EthQuery$1.prototype.getBlockTransactionCountByNumber =    generateFnFor('eth_getBlockTransactionCountByNumber');
	EthQuery$1.prototype.getUncleCountByBlockHash =            generateFnFor('eth_getUncleCountByBlockHash');
	EthQuery$1.prototype.getUncleCountByBlockNumber =          generateFnFor('eth_getUncleCountByBlockNumber');
	EthQuery$1.prototype.sign =                                generateFnFor('eth_sign');
	EthQuery$1.prototype.sendTransaction =                     generateFnFor('eth_sendTransaction');
	EthQuery$1.prototype.sendRawTransaction =                  generateFnFor('eth_sendRawTransaction');
	EthQuery$1.prototype.estimateGas =                         generateFnFor('eth_estimateGas');
	EthQuery$1.prototype.getBlockByHash =                      generateFnFor('eth_getBlockByHash');
	EthQuery$1.prototype.getBlockByNumber =                    generateFnFor('eth_getBlockByNumber');
	EthQuery$1.prototype.getTransactionByHash =                generateFnFor('eth_getTransactionByHash');
	EthQuery$1.prototype.getTransactionByBlockHashAndIndex =   generateFnFor('eth_getTransactionByBlockHashAndIndex');
	EthQuery$1.prototype.getTransactionByBlockNumberAndIndex = generateFnFor('eth_getTransactionByBlockNumberAndIndex');
	EthQuery$1.prototype.getTransactionReceipt =               generateFnFor('eth_getTransactionReceipt');
	EthQuery$1.prototype.getUncleByBlockHashAndIndex =         generateFnFor('eth_getUncleByBlockHashAndIndex');
	EthQuery$1.prototype.getUncleByBlockNumberAndIndex =       generateFnFor('eth_getUncleByBlockNumberAndIndex');
	EthQuery$1.prototype.getCompilers =                        generateFnFor('eth_getCompilers');
	EthQuery$1.prototype.compileLLL =                          generateFnFor('eth_compileLLL');
	EthQuery$1.prototype.compileSolidity =                     generateFnFor('eth_compileSolidity');
	EthQuery$1.prototype.compileSerpent =                      generateFnFor('eth_compileSerpent');
	EthQuery$1.prototype.newFilter =                           generateFnFor('eth_newFilter');
	EthQuery$1.prototype.newBlockFilter =                      generateFnFor('eth_newBlockFilter');
	EthQuery$1.prototype.newPendingTransactionFilter =         generateFnFor('eth_newPendingTransactionFilter');
	EthQuery$1.prototype.uninstallFilter =                     generateFnFor('eth_uninstallFilter');
	EthQuery$1.prototype.getFilterChanges =                    generateFnFor('eth_getFilterChanges');
	EthQuery$1.prototype.getFilterLogs =                       generateFnFor('eth_getFilterLogs');
	EthQuery$1.prototype.getLogs =                             generateFnFor('eth_getLogs');
	EthQuery$1.prototype.getWork =                             generateFnFor('eth_getWork');
	EthQuery$1.prototype.submitWork =                          generateFnFor('eth_submitWork');
	EthQuery$1.prototype.submitHashrate =                      generateFnFor('eth_submitHashrate');

	// network level

	EthQuery$1.prototype.sendAsync = function(opts, cb){
	  const self = this;
	  self.currentProvider.sendAsync(createPayload(opts), function(err, response){
	    if (!err && response.error) err = new Error('EthQuery - RPC Error - '+response.error.message);
	    if (err) return cb(err)
	    cb(null, response.result);
	  });
	};

	// util

	function generateFnFor(methodName){
	  return function(){
	    const self = this;
	    var args = [].slice.call(arguments);
	    var cb = args.pop();
	    self.sendAsync({
	      method: methodName,
	      params: args,
	    }, cb);
	  }
	}

	function generateFnWithDefaultBlockFor(argCount, methodName){
	  return function(){
	    const self = this;
	    var args = [].slice.call(arguments);
	    var cb = args.pop();
	    // set optional default block param
	    if (args.length < argCount) args.push('latest');
	    self.sendAsync({
	      method: methodName,
	      params: args,
	    }, cb);
	  }
	}

	function createPayload(data){
	  return extend({
	    // defaults
	    id: createRandomId(),
	    jsonrpc: '2.0',
	    params: [],
	    // user-specified
	  }, data)
	}

	const processFn = (fn, options, proxy, unwrapped) => function (...arguments_) {
		const P = options.promiseModule;

		return new P((resolve, reject) => {
			if (options.multiArgs) {
				arguments_.push((...result) => {
					if (options.errorFirst) {
						if (result[0]) {
							reject(result);
						} else {
							result.shift();
							resolve(result);
						}
					} else {
						resolve(result);
					}
				});
			} else if (options.errorFirst) {
				arguments_.push((error, result) => {
					if (error) {
						reject(error);
					} else {
						resolve(result);
					}
				});
			} else {
				arguments_.push(resolve);
			}

			const self = this === proxy ? unwrapped : this;
			Reflect.apply(fn, self, arguments_);
		});
	};

	const filterCache = new WeakMap();

	var pify$1 = (input, options) => {
		options = {
			exclude: [/.+(?:Sync|Stream)$/],
			errorFirst: true,
			promiseModule: Promise,
			...options
		};

		const objectType = typeof input;
		if (!(input !== null && (objectType === 'object' || objectType === 'function'))) {
			throw new TypeError(`Expected \`input\` to be a \`Function\` or \`Object\`, got \`${input === null ? 'null' : objectType}\``);
		}

		const filter = (target, key) => {
			let cached = filterCache.get(target);

			if (!cached) {
				cached = {};
				filterCache.set(target, cached);
			}

			if (key in cached) {
				return cached[key];
			}

			const match = pattern => (typeof pattern === 'string' || typeof key === 'symbol') ? key === pattern : pattern.test(key);
			const desc = Reflect.getOwnPropertyDescriptor(target, key);
			const writableOrConfigurableOwn = (desc === undefined || desc.writable || desc.configurable);
			const included = options.include ? options.include.some(match) : !options.exclude.some(match);
			const shouldFilter = included && writableOrConfigurableOwn;
			cached[key] = shouldFilter;
			return shouldFilter;
		};

		const cache = new WeakMap();

		const proxy = new Proxy(input, {
			apply(target, thisArg, args) {
				const cached = cache.get(target);

				if (cached) {
					return Reflect.apply(cached, thisArg, args);
				}

				const pified = options.excludeMain ? target : processFn(target, options, proxy, target);
				cache.set(target, pified);
				return Reflect.apply(pified, thisArg, args);
			},

			get(target, key) {
				const property = target[key];

				// eslint-disable-next-line no-use-extend-native/no-use-extend-native
				if (!filter(target, key) || property === Function.prototype[key]) {
					return property;
				}

				const cached = cache.get(property);

				if (cached) {
					return cached;
				}

				if (typeof property === 'function') {
					const pified = processFn(property, options, proxy, target);
					cache.set(property, pified);
					return pified;
				}

				return property;
			}
		});

		return proxy;
	};

	const SafeEventEmitter$1 = safeEventEmitter.default;

	let BaseFilter$3 = class BaseFilter extends SafeEventEmitter$1 {

	  constructor () {
	    super();
	    this.updates = [];
	  }

	  async initialize () {}

	  async update () {
	    throw new Error('BaseFilter - no update method specified')
	  }

	  addResults (newResults) {
	    this.updates = this.updates.concat(newResults);
	    newResults.forEach(result => this.emit('update', result));
	  }

	  addInitialResults (newResults) {}

	  getChangesAndClear () {
	    const updates = this.updates;
	    this.updates = [];
	    return updates
	  }
	  
	};

	var baseFilter = BaseFilter$3;

	const BaseFilter$2 = baseFilter;

	// tracks all results ever recorded
	let BaseFilterWithHistory$1 = class BaseFilterWithHistory extends BaseFilter$2 {

	  constructor () {
	    super();
	    this.allResults = [];
	  }

	  async update () {
	    throw new Error('BaseFilterWithHistory - no update method specified')
	  }

	  addResults (newResults) {
	    this.allResults = this.allResults.concat(newResults);
	    super.addResults(newResults);
	  }

	  addInitialResults (newResults) {
	    this.allResults = this.allResults.concat(newResults);
	    super.addInitialResults(newResults);
	  }

	  getAllResults () {
	    return this.allResults
	  }

	};

	var baseFilterHistory = BaseFilterWithHistory$1;

	var hexUtils = {
	  minBlockRef: minBlockRef$1,
	  maxBlockRef,
	  sortBlockRefs,
	  bnToHex: bnToHex$1,
	  blockRefIsNumber: blockRefIsNumber$1,
	  hexToInt: hexToInt$3,
	  incrementHexInt: incrementHexInt$4,
	  intToHex: intToHex$2,
	  unsafeRandomBytes: unsafeRandomBytes$1,
	};

	function minBlockRef$1(...refs) {
	  const sortedRefs = sortBlockRefs(refs);
	  return sortedRefs[0]
	}

	function maxBlockRef(...refs) {
	  const sortedRefs = sortBlockRefs(refs);
	  return sortedRefs[sortedRefs.length-1]
	}

	function sortBlockRefs(refs) {
	  return refs.sort((refA, refB) => {
	    if (refA === 'latest' || refB === 'earliest') return 1
	    if (refB === 'latest' || refA === 'earliest') return -1
	    return hexToInt$3(refA) - hexToInt$3(refB)
	  })
	}

	function bnToHex$1(bn) {
	  return '0x' + bn.toString(16)
	}

	function blockRefIsNumber$1(blockRef){
	  return blockRef && !['earliest', 'latest', 'pending'].includes(blockRef)
	}

	function hexToInt$3(hexString) {
	  if (hexString === undefined || hexString === null) return hexString
	  return Number.parseInt(hexString, 16)
	}

	function incrementHexInt$4(hexString){
	  if (hexString === undefined || hexString === null) return hexString
	  const value = hexToInt$3(hexString);
	  return intToHex$2(value + 1)
	}

	function intToHex$2(int) {
	  if (int === undefined || int === null) return int
	  let hexString = int.toString(16);
	  const needsLeftPad = hexString.length % 2;
	  if (needsLeftPad) hexString = '0' + hexString;
	  return '0x' + hexString
	}

	function unsafeRandomBytes$1(byteCount) {
	  let result = '0x';
	  for (let i = 0; i < byteCount; i++) {
	    result += unsafeRandomNibble();
	    result += unsafeRandomNibble();
	  }
	  return result
	}

	function unsafeRandomNibble() {
	  return Math.floor(Math.random() * 16).toString(16)
	}

	const EthQuery = ethQuery;
	const pify = pify$1;
	const BaseFilterWithHistory = baseFilterHistory;
	const { bnToHex, hexToInt: hexToInt$2, incrementHexInt: incrementHexInt$3, minBlockRef, blockRefIsNumber } = hexUtils;

	let LogFilter$1 = class LogFilter extends BaseFilterWithHistory {

	  constructor ({ provider, params }) {
	    super();
	    this.type = 'log';
	    this.ethQuery = new EthQuery(provider);
	    this.params = Object.assign({
	      fromBlock: 'latest',
	      toBlock: 'latest',
	      address: undefined,
	      topics: [],
	    }, params);
	    // normalize address parameter
	    if (this.params.address) {
	      // ensure array
	      if (!Array.isArray(this.params.address)) {
	        this.params.address = [this.params.address];
	      }
	      // ensure lowercase
	      this.params.address = this.params.address.map(address => address.toLowerCase());
	    }
	  }

	  async initialize({ currentBlock }) {
	    // resolve params.fromBlock
	    let fromBlock = this.params.fromBlock;
	    if (['latest', 'pending'].includes(fromBlock)) fromBlock = currentBlock;
	    if ('earliest' === fromBlock) fromBlock = '0x0';
	    this.params.fromBlock = fromBlock;
	    // set toBlock for initial lookup
	    const toBlock = minBlockRef(this.params.toBlock, currentBlock);
	    const params = Object.assign({}, this.params, { toBlock });
	    // fetch logs and add to results
	    const newLogs = await this._fetchLogs(params);
	    this.addInitialResults(newLogs);
	  }

	  async update ({ oldBlock, newBlock }) {
	    // configure params for this update
	    const toBlock = newBlock;
	    let fromBlock;
	    // oldBlock is empty on first sync
	    if (oldBlock) {
	      fromBlock = incrementHexInt$3(oldBlock);
	    } else {
	      fromBlock = newBlock;
	    }
	    // fetch logs
	    const params = Object.assign({}, this.params, { fromBlock, toBlock });
	    const newLogs = await this._fetchLogs(params);
	    const matchingLogs = newLogs.filter(log => this.matchLog(log));

	    // add to results
	    this.addResults(matchingLogs);
	  }

	  async _fetchLogs (params) {
	    const newLogs = await pify(cb => this.ethQuery.getLogs(params, cb))();
	    // add to results
	    return newLogs
	  }

	  matchLog(log) {
	    // check if block number in bounds:
	    if (hexToInt$2(this.params.fromBlock) >= hexToInt$2(log.blockNumber)) return false
	    if (blockRefIsNumber(this.params.toBlock) && hexToInt$2(this.params.toBlock) <= hexToInt$2(log.blockNumber)) return false

	    // address is correct:
	    const normalizedLogAddress = log.address && log.address.toLowerCase();
	    if (this.params.address && normalizedLogAddress && !this.params.address.includes(normalizedLogAddress)) return false

	    // topics match:
	    // topics are position-dependant
	    // topics can be nested to represent `or` [[a || b], c]
	    // topics can be null, representing a wild card for that position
	    const topicsMatch = this.params.topics.every((topicPattern, index) => {
	      // pattern is longer than actual topics
	      let logTopic = log.topics[index];
	      if (!logTopic) return false
	      logTopic = logTopic.toLowerCase();
	      // normalize subTopics
	      let subtopicsToMatch = Array.isArray(topicPattern) ? topicPattern : [topicPattern];
	      // check for wild card
	      const subtopicsIncludeWildcard = subtopicsToMatch.includes(null);
	      if (subtopicsIncludeWildcard) return true
	      subtopicsToMatch = subtopicsToMatch.map(topic => topic.toLowerCase());
	      // check each possible matching topic
	      const topicDoesMatch = subtopicsToMatch.includes(logTopic);
	      return topicDoesMatch
	    });

	    return topicsMatch
	  }

	};

	var logFilter = LogFilter$1;

	var getBlocksForRange_1 = getBlocksForRange$3;

	async function getBlocksForRange$3({ provider, fromBlock, toBlock }) {
	  if (!fromBlock) fromBlock = toBlock;

	  const fromBlockNumber = hexToInt$1(fromBlock);
	  const toBlockNumber = hexToInt$1(toBlock);
	  const blockCountToQuery = toBlockNumber - fromBlockNumber + 1;
	  // load all blocks from old to new (inclusive)
	  const missingBlockNumbers = Array(blockCountToQuery).fill()
	                              .map((_,index) => fromBlockNumber + index)
	                              .map(intToHex$1);
	  const blockBodies = await Promise.all(
	    missingBlockNumbers.map(blockNum => query(provider, 'eth_getBlockByNumber', [blockNum, false]))
	  );
	  return blockBodies
	}

	function hexToInt$1(hexString) {
	  if (hexString === undefined || hexString === null) return hexString
	  return Number.parseInt(hexString, 16)
	}

	function intToHex$1(int) {
	  if (int === undefined || int === null) return int
	  const hexString = int.toString(16);
	  return '0x' + hexString
	}

	function sendAsync(provider, request) {
	  return new Promise((resolve, reject) => {
	    provider.sendAsync(request, (error, response) => {
	      if (error) {
	        reject(error);
	      } else if (response.error) {
	        reject(response.error);
	      } else if (response.result) {
	        resolve(response.result);
	      } else {
	        reject(new Error("Result was empty"));
	      }
	    });
	  });
	}

	async function query(provider, method, params) {
	  for (let i = 0; i < 3; i++) {
	    try {
	      return await sendAsync(provider, {
	        id: 1,
	        jsonrpc: "2.0",
	        method,
	        params,
	      });
	    } catch (error) {
	      console.error(
	        `provider.sendAsync failed: ${error.stack || error.message || error}`
	      );
	    }
	  }
	  throw new Error(`Block not found for params: ${JSON.stringify(params)}`);
	}

	const BaseFilter$1 = baseFilter;
	const getBlocksForRange$2 = getBlocksForRange_1;
	const { incrementHexInt: incrementHexInt$2 } = hexUtils;

	let BlockFilter$1 = class BlockFilter extends BaseFilter$1 {

	  constructor ({ provider, params }) {
	    super();
	    this.type = 'block';
	    this.provider = provider;
	  }

	  async update ({ oldBlock, newBlock }) {
	    const toBlock = newBlock;
	    const fromBlock = incrementHexInt$2(oldBlock);
	    const blockBodies = await getBlocksForRange$2({ provider: this.provider, fromBlock, toBlock });
	    const blockHashes = blockBodies.map((block) => block.hash);
	    this.addResults(blockHashes);
	  }

	};

	var blockFilter = BlockFilter$1;

	const BaseFilter = baseFilter;
	const getBlocksForRange$1 = getBlocksForRange_1;
	const { incrementHexInt: incrementHexInt$1 } = hexUtils;

	let TxFilter$1 = class TxFilter extends BaseFilter {

	  constructor ({ provider }) {
	    super();
	    this.type = 'tx';
	    this.provider = provider;
	  }

	  async update ({ oldBlock }) {
	    const toBlock = oldBlock;
	    const fromBlock = incrementHexInt$1(oldBlock);
	    const blocks = await getBlocksForRange$1({ provider: this.provider, fromBlock, toBlock });
	    const blockTxHashes = [];
	    for (const block of blocks) {
	      blockTxHashes.push(...block.transactions);
	    }
	    // add to results
	    this.addResults(blockTxHashes);
	  }

	};

	var txFilter = TxFilter$1;

	const Mutex = lib.Mutex;
	const { createAsyncMiddleware: createAsyncMiddleware$1, createScaffoldMiddleware: createScaffoldMiddleware$1 } = dist$1;
	const LogFilter = logFilter;
	const BlockFilter = blockFilter;
	const TxFilter = txFilter;
	const { intToHex, hexToInt } = hexUtils;

	var ethJsonRpcFilters = createEthFilterMiddleware;

	function createEthFilterMiddleware({ blockTracker, provider }) {

	  // create filter collection
	  let filterIndex = 0;
	  let filters = {};
	  // create update mutex
	  const mutex = new Mutex();
	  const waitForFree = mutexMiddlewareWrapper({ mutex });

	  const middleware = createScaffoldMiddleware$1({
	    // install filters
	    eth_newFilter:                   waitForFree(toFilterCreationMiddleware(newLogFilter)),
	    eth_newBlockFilter:              waitForFree(toFilterCreationMiddleware(newBlockFilter)),
	    eth_newPendingTransactionFilter: waitForFree(toFilterCreationMiddleware(newPendingTransactionFilter)),
	    // uninstall filters
	    eth_uninstallFilter:             waitForFree(toAsyncRpcMiddleware(uninstallFilterHandler)),
	    // checking filter changes
	    eth_getFilterChanges:            waitForFree(toAsyncRpcMiddleware(getFilterChanges)),
	    eth_getFilterLogs:               waitForFree(toAsyncRpcMiddleware(getFilterLogs)),
	  });

	  // setup filter updating and destroy handler
	  const filterUpdater = async ({ oldBlock, newBlock }) => {
	    if (filters.length === 0) return
	    // lock update reads
	    const releaseLock = await mutex.acquire();
	    try {
	      // process all filters in parallel
	      await Promise.all(objValues(filters).map(async (filter) => {
	        try {
	         await filter.update({ oldBlock, newBlock });
	        } catch (err) {
	          // handle each error individually so filter update errors don't affect other filters
	          console.error(err);
	        }
	      }));
	    } catch (err) {
	      // log error so we don't skip the releaseLock
	      console.error(err);
	    }
	    // unlock update reads
	    releaseLock();
	  };

	  // expose filter methods directly
	  middleware.newLogFilter = newLogFilter;
	  middleware.newBlockFilter = newBlockFilter;
	  middleware.newPendingTransactionFilter = newPendingTransactionFilter;
	  middleware.uninstallFilter = uninstallFilterHandler;
	  middleware.getFilterChanges = getFilterChanges;
	  middleware.getFilterLogs = getFilterLogs;

	  // expose destroy method for cleanup
	  middleware.destroy = () => {
	    uninstallAllFilters();
	  };

	  return middleware

	  //
	  // new filters
	  //

	  async function newLogFilter(params) {
	    const filter = new LogFilter({ provider, params });
	    await installFilter(filter);
	    return filter
	  }

	  async function newBlockFilter() {
	    const filter = new BlockFilter({ provider });
	    await installFilter(filter);
	    return filter
	  }

	  async function newPendingTransactionFilter() {
	    const filter = new TxFilter({ provider });
	    await installFilter(filter);
	    return filter
	  }

	  //
	  // get filter changes
	  //

	  async function getFilterChanges(filterIndexHex) {
	    const filterIndex = hexToInt(filterIndexHex);
	    const filter = filters[filterIndex];
	    if (!filter) {
	      throw new Error(`No filter for index "${filterIndex}"`)
	    }
	    const results = filter.getChangesAndClear();
	    return results
	  }

	  async function getFilterLogs(filterIndexHex) {
	    const filterIndex = hexToInt(filterIndexHex);
	    const filter = filters[filterIndex];
	    if (!filter) {
	      throw new Error(`No filter for index "${filterIndex}"`)
	    }
	    // only return results for log filters
	    let results = [];
	    if (filter.type === 'log') {
	      results = filter.getAllResults();
	    }
	    return results
	  }


	  //
	  // remove filters
	  //


	  async function uninstallFilterHandler(filterIndexHex) {
	    // check filter exists
	    const filterIndex = hexToInt(filterIndexHex);
	    const filter = filters[filterIndex];
	    const result = Boolean(filter);
	    // uninstall filter
	    if (result) {
	      await uninstallFilter(filterIndex);
	    }
	    return result
	  }

	  //
	  // utils
	  //

	  async function installFilter(filter) {
	    const prevFilterCount = objValues(filters).length;
	    // install filter
	    const currentBlock = await blockTracker.getLatestBlock();
	    await filter.initialize({ currentBlock });
	    filterIndex++;
	    filters[filterIndex] = filter;
	    filter.id = filterIndex;
	    filter.idHex = intToHex(filterIndex);
	    // update block tracker subs
	    const newFilterCount = objValues(filters).length;
	    updateBlockTrackerSubs({ prevFilterCount, newFilterCount });
	    return filterIndex
	  }

	  async function uninstallFilter(filterIndex) {
	    const prevFilterCount = objValues(filters).length;
	    delete filters[filterIndex];
	    // update block tracker subs
	    const newFilterCount = objValues(filters).length;
	    updateBlockTrackerSubs({ prevFilterCount, newFilterCount });
	  }

	  async function uninstallAllFilters() {
	    const prevFilterCount = objValues(filters).length;
	    filters = {};
	    // update block tracker subs
	    updateBlockTrackerSubs({ prevFilterCount, newFilterCount: 0 });
	  }

	  function updateBlockTrackerSubs({ prevFilterCount, newFilterCount }) {
	    // subscribe
	    if (prevFilterCount === 0 && newFilterCount > 0) {
	      blockTracker.on('sync', filterUpdater);
	      return
	    }
	    // unsubscribe
	    if (prevFilterCount > 0 && newFilterCount === 0) {
	      blockTracker.removeListener('sync', filterUpdater);
	      return
	    }
	  }

	}

	// helper for turning filter constructors into rpc middleware
	function toFilterCreationMiddleware(createFilterFn) {
	  return toAsyncRpcMiddleware(async (...args) => {
	    const filter = await createFilterFn(...args);
	    const result = intToHex(filter.id);
	    return result
	  })
	}

	// helper for pulling out req.params and setting res.result
	function toAsyncRpcMiddleware(asyncFn) {
	  return createAsyncMiddleware$1(async (req, res) => {
	    const result = await asyncFn.apply(null, req.params);
	    res.result = result;
	  })
	}

	function mutexMiddlewareWrapper({ mutex }) {
	  return (middleware) => {
	    return async (req, res, next, end) => {
	      // wait for mutex available
	      // we can release immediately because
	      // we just need to make sure updates aren't active
	      const releaseLock = await mutex.acquire();
	      releaseLock();
	      middleware(req, res, next, end);
	    }
	  }
	}

	function objValues(obj, fn){
	  const values = [];
	  for (let key in obj) {
	    values.push(obj[key]);
	  }
	  return values
	}

	const SafeEventEmitter = safeEventEmitter.default;
	const { createAsyncMiddleware, createScaffoldMiddleware } = dist$1;
	const createFilterMiddleware = ethJsonRpcFilters;
	const { unsafeRandomBytes, incrementHexInt } = hexUtils;
	const getBlocksForRange = getBlocksForRange_1;

	var subscriptionManager = createSubscriptionMiddleware;


	function createSubscriptionMiddleware({ blockTracker, provider }) {
	  // state and utilities for handling subscriptions
	  const subscriptions = {};
	  const filterManager = createFilterMiddleware({ blockTracker, provider });

	  // internal flag
	  let isDestroyed = false;

	  // create subscriptionManager api object
	  const events = new SafeEventEmitter();
	  const middleware = createScaffoldMiddleware({
	    eth_subscribe: createAsyncMiddleware(subscribe),
	    eth_unsubscribe: createAsyncMiddleware(unsubscribe),
	  });
	  middleware.destroy = destroy;
	  return { events, middleware }

	  async function subscribe(req, res) {

	    if (isDestroyed) throw new Error(
	      'SubscriptionManager - attempting to use after destroying'
	    )

	    const subscriptionType = req.params[0];
	    // subId is 16 byte hex string
	    const subId = unsafeRandomBytes(16);

	    // create sub
	    let sub;
	    switch (subscriptionType) {
	      case 'newHeads':
	        sub = createSubNewHeads({ subId });
	        break
	      case 'logs':
	        const filterParams = req.params[1];
	        const filter = await filterManager.newLogFilter(filterParams);
	        sub = createSubFromFilter({ subId, filter });
	        break
	      default:
	        throw new Error(`SubscriptionManager - unsupported subscription type "${subscriptionType}"`)

	    }
	    subscriptions[subId] = sub;

	    res.result = subId;
	    return

	    function createSubNewHeads({ subId }) {
	      const sub = {
	        type: subscriptionType,
	        destroy: async () => {
	          blockTracker.removeListener('sync', sub.update);
	        },
	        update: async ({ oldBlock, newBlock }) => {
	          // for newHeads
	          const toBlock = newBlock;
	          const fromBlock = incrementHexInt(oldBlock);
	          const rawBlocks = await getBlocksForRange({ provider, fromBlock, toBlock });
	          const results = rawBlocks.map(normalizeBlock).filter(block => block !== null);
	          results.forEach((value) => {
	            _emitSubscriptionResult(subId, value);
	          });
	        }
	      };
	      // check for subscription updates on new block
	      blockTracker.on('sync', sub.update);
	      return sub
	    }

	    function createSubFromFilter({ subId, filter }) {
	      filter.on('update', result => _emitSubscriptionResult(subId, result));
	      const sub = {
	        type: subscriptionType,
	        destroy: async () => {
	          return await filterManager.uninstallFilter(filter.idHex)
	        },
	      };
	      return sub
	    }
	  }

	  async function unsubscribe(req, res) {

	    if (isDestroyed) throw new Error(
	      'SubscriptionManager - attempting to use after destroying'
	    )

	    const id = req.params[0];
	    const subscription = subscriptions[id];
	    // if missing, return "false" to indicate it was not removed
	    if (!subscription) {
	      res.result = false;
	      return
	    }
	    // cleanup subscription
	    delete subscriptions[id];
	    await subscription.destroy();
	    res.result = true;
	  }

	  function _emitSubscriptionResult(filterIdHex, value) {
	    events.emit('notification', {
	      jsonrpc: '2.0',
	      method: 'eth_subscription',
	      params: {
	        subscription: filterIdHex,
	        result: value,
	      },
	    });
	  }

	  function destroy() {
	    events.removeAllListeners();
	    for (const id in subscriptions) {
	      subscriptions[id].destroy();
	      delete subscriptions[id];
	    }
	    isDestroyed = true;
	  }
	}

	function normalizeBlock(block) {
	  if (block === null || block === undefined) {
	    return null;
	  }
	  return {
	    hash: block.hash,
	    parentHash: block.parentHash,
	    sha3Uncles: block.sha3Uncles,
	    miner: block.miner,
	    stateRoot: block.stateRoot,
	    transactionsRoot: block.transactionsRoot,
	    receiptsRoot: block.receiptsRoot,
	    logsBloom: block.logsBloom,
	    difficulty: block.difficulty,
	    number: block.number,
	    gasLimit: block.gasLimit,
	    gasUsed: block.gasUsed,
	    nonce: block.nonce,
	    mixHash: block.mixHash,
	    timestamp: block.timestamp,
	    extraData: block.extraData,
	  }
	}

	Object.defineProperty(SubscriptionManager$1, "__esModule", { value: true });
	SubscriptionManager$1.SubscriptionManager = void 0;
	const eth_block_tracker_1 = dist$4;
	const createSubscriptionManager = subscriptionManager;
	const noop$2 = () => { };
	class SubscriptionManager {
	    constructor(provider) {
	        const blockTracker = new eth_block_tracker_1.PollingBlockTracker({
	            provider: provider,
	            pollingInterval: 15 * 1000,
	            setSkipCacheFlag: true,
	        });
	        const { events, middleware } = createSubscriptionManager({
	            blockTracker,
	            provider,
	        });
	        this.events = events;
	        this.subscriptionMiddleware = middleware;
	    }
	    async handleRequest(request) {
	        const result = {};
	        await this.subscriptionMiddleware(request, result, noop$2, noop$2);
	        return result;
	    }
	    destroy() {
	        this.subscriptionMiddleware.destroy();
	    }
	}
	SubscriptionManager$1.SubscriptionManager = SubscriptionManager;

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	var __importDefault$7 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(CoinbaseWalletProvider$1, "__esModule", { value: true });
	CoinbaseWalletProvider$1.CoinbaseWalletProvider = void 0;
	const safe_event_emitter_1 = __importDefault$7(safeEventEmitter);
	const bn_js_1 = __importDefault$7(bnExports$1);
	const DiagnosticLogger_1$2 = DiagnosticLogger;
	const errors_1$1 = errors$2;
	const Session_1$2 = Session$1;
	const WalletSDKRelayAbstract_1$1 = WalletSDKRelayAbstract$1;
	const Web3Method_1$1 = Web3Method;
	const Web3Response_1$1 = Web3Response;
	const util_1$5 = util$3;
	const eth_eip712_util_1 = __importDefault$7(ethEip712Util);
	const FilterPolyfill_1 = FilterPolyfill$1;
	const JSONRPC_1 = JSONRPC;
	const SubscriptionManager_1 = SubscriptionManager$1;
	const DEFAULT_CHAIN_ID_KEY = "DefaultChainId";
	const DEFAULT_JSON_RPC_URL = "DefaultJsonRpcUrl";
	class CoinbaseWalletProvider extends safe_event_emitter_1.default {
	    constructor(options) {
	        var _a, _b;
	        super();
	        this._filterPolyfill = new FilterPolyfill_1.FilterPolyfill(this);
	        this._subscriptionManager = new SubscriptionManager_1.SubscriptionManager(this);
	        this._relay = null;
	        this._addresses = [];
	        this.hasMadeFirstChainChangedEmission = false;
	        this.setProviderInfo = this.setProviderInfo.bind(this);
	        this.updateProviderInfo = this.updateProviderInfo.bind(this);
	        this.getChainId = this.getChainId.bind(this);
	        this.setAppInfo = this.setAppInfo.bind(this);
	        this.enable = this.enable.bind(this);
	        this.close = this.close.bind(this);
	        this.send = this.send.bind(this);
	        this.sendAsync = this.sendAsync.bind(this);
	        this.request = this.request.bind(this);
	        this._setAddresses = this._setAddresses.bind(this);
	        this.scanQRCode = this.scanQRCode.bind(this);
	        this.genericRequest = this.genericRequest.bind(this);
	        this._chainIdFromOpts = options.chainId;
	        this._jsonRpcUrlFromOpts = options.jsonRpcUrl;
	        this._overrideIsMetaMask = options.overrideIsMetaMask;
	        this._relayProvider = options.relayProvider;
	        this._storage = options.storage;
	        this._relayEventManager = options.relayEventManager;
	        this.diagnostic = options.diagnosticLogger;
	        this.reloadOnDisconnect = true;
	        this.isCoinbaseWallet = (_a = options.overrideIsCoinbaseWallet) !== null && _a !== void 0 ? _a : true;
	        this.isCoinbaseBrowser = (_b = options.overrideIsCoinbaseBrowser) !== null && _b !== void 0 ? _b : false;
	        this.qrUrl = options.qrUrl;
	        this.supportsAddressSwitching = options.supportsAddressSwitching;
	        this.isLedger = options.isLedger;
	        const chainId = this.getChainId();
	        const chainIdStr = (0, util_1$5.prepend0x)(chainId.toString(16));
	        // indicate that we've connected, for EIP-1193 compliance
	        this.emit("connect", { chainIdStr });
	        const cachedAddresses = this._storage.getItem(WalletSDKRelayAbstract_1$1.LOCAL_STORAGE_ADDRESSES_KEY);
	        if (cachedAddresses) {
	            const addresses = cachedAddresses.split(" ");
	            if (addresses[0] !== "") {
	                this._addresses = addresses.map(address => (0, util_1$5.ensureAddressString)(address));
	                this.emit("accountsChanged", addresses);
	            }
	        }
	        this._subscriptionManager.events.on("notification", (notification) => {
	            this.emit("message", {
	                type: notification.method,
	                data: notification.params,
	            });
	        });
	        if (this._addresses.length > 0) {
	            void this.initializeRelay();
	        }
	        window.addEventListener("message", event => {
	            var _a;
	            // Used to verify the source and window are correct before proceeding
	            if (event.origin !== location.origin || event.source !== window) {
	                return;
	            }
	            if (event.data.type !== "walletLinkMessage")
	                return; // compatibility with CBW extension
	            if (event.data.data.action === "defaultChainChanged" ||
	                event.data.data.action === "dappChainSwitched") {
	                const _chainId = event.data.data.chainId;
	                const jsonRpcUrl = (_a = event.data.data.jsonRpcUrl) !== null && _a !== void 0 ? _a : this.jsonRpcUrl;
	                this.updateProviderInfo(jsonRpcUrl, Number(_chainId));
	            }
	            if (event.data.data.action === "addressChanged") {
	                this._setAddresses([event.data.data.address]);
	            }
	        });
	    }
	    /** @deprecated Use `.request({ method: 'eth_accounts' })` instead. */
	    get selectedAddress() {
	        return this._addresses[0] || undefined;
	    }
	    /** @deprecated Use the chain ID. If you still need the network ID, use `.request({ method: 'net_version' })`. */
	    get networkVersion() {
	        return this.getChainId().toString(10);
	    }
	    /** @deprecated Use `.request({ method: 'eth_chainId' })` instead. */
	    get chainId() {
	        return (0, util_1$5.prepend0x)(this.getChainId().toString(16));
	    }
	    get isWalletLink() {
	        // backward compatibility
	        return true;
	    }
	    /**
	     * Some DApps (i.e. Alpha Homora) seem to require the window.ethereum object return
	     * true for this method.
	     */
	    get isMetaMask() {
	        return this._overrideIsMetaMask;
	    }
	    get host() {
	        return this.jsonRpcUrl;
	    }
	    get connected() {
	        return true;
	    }
	    isConnected() {
	        return true;
	    }
	    get jsonRpcUrl() {
	        var _a;
	        return ((_a = this._storage.getItem(DEFAULT_JSON_RPC_URL)) !== null && _a !== void 0 ? _a : this._jsonRpcUrlFromOpts);
	    }
	    set jsonRpcUrl(value) {
	        this._storage.setItem(DEFAULT_JSON_RPC_URL, value);
	    }
	    disableReloadOnDisconnect() {
	        this.reloadOnDisconnect = false;
	    }
	    /**
	     * this function is called when coinbase provider is being injected to a dapp
	     * standalone + walletlinked extension, ledger, in-app browser using cipher-web-view
	     */
	    setProviderInfo(jsonRpcUrl, chainId) {
	        // extension tend to use the chianId from the dapp, while in-app browser and ledger overrides the default network
	        if (!(this.isLedger || this.isCoinbaseBrowser)) {
	            this._chainIdFromOpts = chainId;
	            this._jsonRpcUrlFromOpts = jsonRpcUrl;
	        }
	        this.updateProviderInfo(this.jsonRpcUrl, this.getChainId());
	    }
	    updateProviderInfo(jsonRpcUrl, chainId) {
	        this.jsonRpcUrl = jsonRpcUrl;
	        // emit chainChanged event if necessary
	        const originalChainId = this.getChainId();
	        this._storage.setItem(DEFAULT_CHAIN_ID_KEY, chainId.toString(10));
	        const chainChanged = (0, util_1$5.ensureIntNumber)(chainId) !== originalChainId;
	        if (chainChanged || !this.hasMadeFirstChainChangedEmission) {
	            this.emit("chainChanged", this.getChainId());
	            this.hasMadeFirstChainChangedEmission = true;
	        }
	    }
	    async watchAsset(type, address, symbol, decimals, image, chainId) {
	        const relay = await this.initializeRelay();
	        const result = await relay.watchAsset(type, address, symbol, decimals, image, chainId === null || chainId === void 0 ? void 0 : chainId.toString()).promise;
	        return !!result.result;
	    }
	    async addEthereumChain(chainId, rpcUrls, blockExplorerUrls, chainName, iconUrls, nativeCurrency) {
	        var _a, _b;
	        if ((0, util_1$5.ensureIntNumber)(chainId) === this.getChainId()) {
	            return false;
	        }
	        const relay = await this.initializeRelay();
	        const isWhitelistedNetworkOrStandalone = relay.inlineAddEthereumChain(chainId.toString());
	        if (!this._isAuthorized() && !isWhitelistedNetworkOrStandalone) {
	            await relay.requestEthereumAccounts().promise;
	        }
	        const res = await relay.addEthereumChain(chainId.toString(), rpcUrls, iconUrls, blockExplorerUrls, chainName, nativeCurrency).promise;
	        if (((_a = res.result) === null || _a === void 0 ? void 0 : _a.isApproved) === true) {
	            this.updateProviderInfo(rpcUrls[0], chainId);
	        }
	        return ((_b = res.result) === null || _b === void 0 ? void 0 : _b.isApproved) === true;
	    }
	    async switchEthereumChain(chainId) {
	        const relay = await this.initializeRelay();
	        const res = await relay.switchEthereumChain(chainId.toString(10), this.selectedAddress || undefined).promise;
	        // backward compatibility
	        if ((0, Web3Response_1$1.isErrorResponse)(res) && res.errorCode) {
	            if (res.errorCode === errors_1$1.standardErrorCodes.provider.unsupportedChain) {
	                throw errors_1$1.standardErrors.provider.unsupportedChain(chainId);
	            }
	            else {
	                throw errors_1$1.standardErrors.provider.custom({
	                    message: res.errorMessage,
	                    code: res.errorCode,
	                });
	            }
	        }
	        const switchResponse = res.result;
	        if (switchResponse.isApproved && switchResponse.rpcUrl.length > 0) {
	            this.updateProviderInfo(switchResponse.rpcUrl, chainId);
	        }
	    }
	    setAppInfo(appName, appLogoUrl) {
	        void this.initializeRelay().then(relay => relay.setAppInfo(appName, appLogoUrl));
	    }
	    /** @deprecated Use `.request({ method: 'eth_requestAccounts' })` instead. */
	    async enable() {
	        var _a;
	        (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1$2.EVENTS.ETH_ACCOUNTS_STATE, {
	            method: "provider::enable",
	            addresses_length: this._addresses.length,
	            sessionIdHash: this._relay
	                ? Session_1$2.Session.hash(this._relay.session.id)
	                : undefined,
	        });
	        if (this._addresses.length > 0) {
	            return [...this._addresses];
	        }
	        return await this.send(JSONRPC_1.JSONRPCMethod.eth_requestAccounts);
	    }
	    async close() {
	        const relay = await this.initializeRelay();
	        relay.resetAndReload();
	    }
	    send(requestOrMethod, callbackOrParams) {
	        // send<T>(method, params): Promise<T>
	        try {
	            const result = this._send(requestOrMethod, callbackOrParams);
	            if (result instanceof Promise) {
	                return result.catch(error => {
	                    throw (0, errors_1$1.serializeError)(error, requestOrMethod);
	                });
	            }
	        }
	        catch (error) {
	            throw (0, errors_1$1.serializeError)(error, requestOrMethod);
	        }
	    }
	    _send(requestOrMethod, callbackOrParams) {
	        if (typeof requestOrMethod === "string") {
	            const method = requestOrMethod;
	            const params = Array.isArray(callbackOrParams)
	                ? callbackOrParams
	                : callbackOrParams !== undefined
	                    ? [callbackOrParams]
	                    : [];
	            const request = {
	                jsonrpc: "2.0",
	                id: 0,
	                method,
	                params,
	            };
	            return this._sendRequestAsync(request).then(res => res.result);
	        }
	        // send(JSONRPCRequest | JSONRPCRequest[], callback): void
	        if (typeof callbackOrParams === "function") {
	            const request = requestOrMethod;
	            const callback = callbackOrParams;
	            return this._sendAsync(request, callback);
	        }
	        // send(JSONRPCRequest[]): JSONRPCResponse[]
	        if (Array.isArray(requestOrMethod)) {
	            const requests = requestOrMethod;
	            return requests.map(r => this._sendRequest(r));
	        }
	        // send(JSONRPCRequest): JSONRPCResponse
	        const req = requestOrMethod;
	        return this._sendRequest(req);
	    }
	    async sendAsync(request, callback) {
	        try {
	            return this._sendAsync(request, callback).catch(error => {
	                throw (0, errors_1$1.serializeError)(error, request);
	            });
	        }
	        catch (error) {
	            return Promise.reject((0, errors_1$1.serializeError)(error, request));
	        }
	    }
	    async _sendAsync(request, callback) {
	        if (typeof callback !== "function") {
	            throw new Error("callback is required");
	        }
	        // send(JSONRPCRequest[], callback): void
	        if (Array.isArray(request)) {
	            const arrayCb = callback;
	            this._sendMultipleRequestsAsync(request)
	                .then(responses => arrayCb(null, responses))
	                .catch(err => arrayCb(err, null));
	            return;
	        }
	        // send(JSONRPCRequest, callback): void
	        const cb = callback;
	        return this._sendRequestAsync(request)
	            .then(response => cb(null, response))
	            .catch(err => cb(err, null));
	    }
	    async request(args) {
	        try {
	            return this._request(args).catch(error => {
	                throw (0, errors_1$1.serializeError)(error, args.method);
	            });
	        }
	        catch (error) {
	            return Promise.reject((0, errors_1$1.serializeError)(error, args.method));
	        }
	    }
	    async _request(args) {
	        if (!args || typeof args !== "object" || Array.isArray(args)) {
	            throw errors_1$1.standardErrors.rpc.invalidRequest({
	                message: "Expected a single, non-array, object argument.",
	                data: args,
	            });
	        }
	        const { method, params } = args;
	        if (typeof method !== "string" || method.length === 0) {
	            throw errors_1$1.standardErrors.rpc.invalidRequest({
	                message: "'args.method' must be a non-empty string.",
	                data: args,
	            });
	        }
	        if (params !== undefined &&
	            !Array.isArray(params) &&
	            (typeof params !== "object" || params === null)) {
	            throw errors_1$1.standardErrors.rpc.invalidRequest({
	                message: "'args.params' must be an object or array if provided.",
	                data: args,
	            });
	        }
	        const newParams = params === undefined ? [] : params;
	        // Coinbase Wallet Requests
	        const id = this._relayEventManager.makeRequestId();
	        const result = await this._sendRequestAsync({
	            method,
	            params: newParams,
	            jsonrpc: "2.0",
	            id,
	        });
	        return result.result;
	    }
	    async scanQRCode(match) {
	        var _a;
	        const relay = await this.initializeRelay();
	        const res = await relay.scanQRCode((0, util_1$5.ensureRegExpString)(match)).promise;
	        if (typeof res.result !== "string") {
	            throw (0, errors_1$1.serializeError)((_a = res.errorMessage) !== null && _a !== void 0 ? _a : "result was not a string", Web3Method_1$1.Web3Method.scanQRCode);
	        }
	        return res.result;
	    }
	    async genericRequest(data, action) {
	        var _a;
	        const relay = await this.initializeRelay();
	        const res = await relay.genericRequest(data, action).promise;
	        if (typeof res.result !== "string") {
	            throw (0, errors_1$1.serializeError)((_a = res.errorMessage) !== null && _a !== void 0 ? _a : "result was not a string", Web3Method_1$1.Web3Method.generic);
	        }
	        return res.result;
	    }
	    async selectProvider(providerOptions) {
	        var _a;
	        const relay = await this.initializeRelay();
	        const res = await relay.selectProvider(providerOptions).promise;
	        if (typeof res.result !== "string") {
	            throw (0, errors_1$1.serializeError)((_a = res.errorMessage) !== null && _a !== void 0 ? _a : "result was not a string", Web3Method_1$1.Web3Method.selectProvider);
	        }
	        return res.result;
	    }
	    supportsSubscriptions() {
	        return false;
	    }
	    subscribe() {
	        throw new Error("Subscriptions are not supported");
	    }
	    unsubscribe() {
	        throw new Error("Subscriptions are not supported");
	    }
	    disconnect() {
	        return true;
	    }
	    _sendRequest(request) {
	        const response = {
	            jsonrpc: "2.0",
	            id: request.id,
	        };
	        const { method } = request;
	        response.result = this._handleSynchronousMethods(request);
	        if (response.result === undefined) {
	            throw new Error(`Coinbase Wallet does not support calling ${method} synchronously without ` +
	                `a callback. Please provide a callback parameter to call ${method} ` +
	                `asynchronously.`);
	        }
	        return response;
	    }
	    _setAddresses(addresses, isDisconnect) {
	        if (!Array.isArray(addresses)) {
	            throw new Error("addresses is not an array");
	        }
	        const newAddresses = addresses.map(address => (0, util_1$5.ensureAddressString)(address));
	        if (JSON.stringify(newAddresses) === JSON.stringify(this._addresses)) {
	            return;
	        }
	        if (this._addresses.length > 0 &&
	            this.supportsAddressSwitching === false &&
	            !isDisconnect) {
	            /**
	             * The extension currently doesn't support switching selected wallet index
	             * make sure walletlink doesn't update it's address in this case
	             */
	            return;
	        }
	        this._addresses = newAddresses;
	        this.emit("accountsChanged", this._addresses);
	        this._storage.setItem(WalletSDKRelayAbstract_1$1.LOCAL_STORAGE_ADDRESSES_KEY, newAddresses.join(" "));
	    }
	    _sendRequestAsync(request) {
	        return new Promise((resolve, reject) => {
	            try {
	                const syncResult = this._handleSynchronousMethods(request);
	                if (syncResult !== undefined) {
	                    return resolve({
	                        jsonrpc: "2.0",
	                        id: request.id,
	                        result: syncResult,
	                    });
	                }
	                const filterPromise = this._handleAsynchronousFilterMethods(request);
	                if (filterPromise !== undefined) {
	                    filterPromise
	                        .then(res => resolve(Object.assign(Object.assign({}, res), { id: request.id })))
	                        .catch(err => reject(err));
	                    return;
	                }
	                const subscriptionPromise = this._handleSubscriptionMethods(request);
	                if (subscriptionPromise !== undefined) {
	                    subscriptionPromise
	                        .then(res => resolve({
	                        jsonrpc: "2.0",
	                        id: request.id,
	                        result: res.result,
	                    }))
	                        .catch(err => reject(err));
	                    return;
	                }
	            }
	            catch (err) {
	                return reject(err);
	            }
	            this._handleAsynchronousMethods(request)
	                .then(res => res && resolve(Object.assign(Object.assign({}, res), { id: request.id })))
	                .catch(err => reject(err));
	        });
	    }
	    _sendMultipleRequestsAsync(requests) {
	        return Promise.all(requests.map(r => this._sendRequestAsync(r)));
	    }
	    _handleSynchronousMethods(request) {
	        const { method } = request;
	        const params = request.params || [];
	        switch (method) {
	            case JSONRPC_1.JSONRPCMethod.eth_accounts:
	                return this._eth_accounts();
	            case JSONRPC_1.JSONRPCMethod.eth_coinbase:
	                return this._eth_coinbase();
	            case JSONRPC_1.JSONRPCMethod.eth_uninstallFilter:
	                return this._eth_uninstallFilter(params);
	            case JSONRPC_1.JSONRPCMethod.net_version:
	                return this._net_version();
	            case JSONRPC_1.JSONRPCMethod.eth_chainId:
	                return this._eth_chainId();
	            default:
	                return undefined;
	        }
	    }
	    async _handleAsynchronousMethods(request) {
	        const { method } = request;
	        const params = request.params || [];
	        switch (method) {
	            case JSONRPC_1.JSONRPCMethod.eth_requestAccounts:
	                return this._eth_requestAccounts();
	            case JSONRPC_1.JSONRPCMethod.eth_sign:
	                return this._eth_sign(params);
	            case JSONRPC_1.JSONRPCMethod.eth_ecRecover:
	                return this._eth_ecRecover(params);
	            case JSONRPC_1.JSONRPCMethod.personal_sign:
	                return this._personal_sign(params);
	            case JSONRPC_1.JSONRPCMethod.personal_ecRecover:
	                return this._personal_ecRecover(params);
	            case JSONRPC_1.JSONRPCMethod.eth_signTransaction:
	                return this._eth_signTransaction(params);
	            case JSONRPC_1.JSONRPCMethod.eth_sendRawTransaction:
	                return this._eth_sendRawTransaction(params);
	            case JSONRPC_1.JSONRPCMethod.eth_sendTransaction:
	                return this._eth_sendTransaction(params);
	            case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v1:
	                return this._eth_signTypedData_v1(params);
	            case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v2:
	                return this._throwUnsupportedMethodError();
	            case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v3:
	                return this._eth_signTypedData_v3(params);
	            case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v4:
	            case JSONRPC_1.JSONRPCMethod.eth_signTypedData:
	                return this._eth_signTypedData_v4(params);
	            case JSONRPC_1.JSONRPCMethod.cbWallet_arbitrary:
	                return this._cbwallet_arbitrary(params);
	            case JSONRPC_1.JSONRPCMethod.wallet_addEthereumChain:
	                return this._wallet_addEthereumChain(params);
	            case JSONRPC_1.JSONRPCMethod.wallet_switchEthereumChain:
	                return this._wallet_switchEthereumChain(params);
	            case JSONRPC_1.JSONRPCMethod.wallet_watchAsset:
	                return this._wallet_watchAsset(params);
	        }
	        const relay = await this.initializeRelay();
	        return relay.makeEthereumJSONRPCRequest(request, this.jsonRpcUrl);
	    }
	    _handleAsynchronousFilterMethods(request) {
	        const { method } = request;
	        const params = request.params || [];
	        switch (method) {
	            case JSONRPC_1.JSONRPCMethod.eth_newFilter:
	                return this._eth_newFilter(params);
	            case JSONRPC_1.JSONRPCMethod.eth_newBlockFilter:
	                return this._eth_newBlockFilter();
	            case JSONRPC_1.JSONRPCMethod.eth_newPendingTransactionFilter:
	                return this._eth_newPendingTransactionFilter();
	            case JSONRPC_1.JSONRPCMethod.eth_getFilterChanges:
	                return this._eth_getFilterChanges(params);
	            case JSONRPC_1.JSONRPCMethod.eth_getFilterLogs:
	                return this._eth_getFilterLogs(params);
	        }
	        return undefined;
	    }
	    _handleSubscriptionMethods(request) {
	        switch (request.method) {
	            case JSONRPC_1.JSONRPCMethod.eth_subscribe:
	            case JSONRPC_1.JSONRPCMethod.eth_unsubscribe:
	                return this._subscriptionManager.handleRequest(request);
	        }
	        return undefined;
	    }
	    _isKnownAddress(addressString) {
	        try {
	            const addressStr = (0, util_1$5.ensureAddressString)(addressString);
	            const lowercaseAddresses = this._addresses.map(address => (0, util_1$5.ensureAddressString)(address));
	            return lowercaseAddresses.includes(addressStr);
	        }
	        catch (_a) { }
	        return false;
	    }
	    _ensureKnownAddress(addressString) {
	        var _a;
	        if (!this._isKnownAddress(addressString)) {
	            (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1$2.EVENTS.UNKNOWN_ADDRESS_ENCOUNTERED);
	            throw new Error("Unknown Ethereum address");
	        }
	    }
	    _prepareTransactionParams(tx) {
	        const fromAddress = tx.from
	            ? (0, util_1$5.ensureAddressString)(tx.from)
	            : this.selectedAddress;
	        if (!fromAddress) {
	            throw new Error("Ethereum address is unavailable");
	        }
	        this._ensureKnownAddress(fromAddress);
	        const toAddress = tx.to ? (0, util_1$5.ensureAddressString)(tx.to) : null;
	        const weiValue = tx.value != null ? (0, util_1$5.ensureBN)(tx.value) : new bn_js_1.default(0);
	        const data = tx.data ? (0, util_1$5.ensureBuffer)(tx.data) : Buffer.alloc(0);
	        const nonce = tx.nonce != null ? (0, util_1$5.ensureIntNumber)(tx.nonce) : null;
	        const gasPriceInWei = tx.gasPrice != null ? (0, util_1$5.ensureBN)(tx.gasPrice) : null;
	        const maxFeePerGas = tx.maxFeePerGas != null ? (0, util_1$5.ensureBN)(tx.maxFeePerGas) : null;
	        const maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null
	            ? (0, util_1$5.ensureBN)(tx.maxPriorityFeePerGas)
	            : null;
	        const gasLimit = tx.gas != null ? (0, util_1$5.ensureBN)(tx.gas) : null;
	        const chainId = this.getChainId();
	        return {
	            fromAddress,
	            toAddress,
	            weiValue,
	            data,
	            nonce,
	            gasPriceInWei,
	            maxFeePerGas,
	            maxPriorityFeePerGas,
	            gasLimit,
	            chainId,
	        };
	    }
	    _isAuthorized() {
	        return this._addresses.length > 0;
	    }
	    _requireAuthorization() {
	        if (!this._isAuthorized()) {
	            throw errors_1$1.standardErrors.provider.unauthorized({});
	        }
	    }
	    _throwUnsupportedMethodError() {
	        throw errors_1$1.standardErrors.provider.unsupportedMethod({});
	    }
	    async _signEthereumMessage(message, address, addPrefix, typedDataJson) {
	        this._ensureKnownAddress(address);
	        try {
	            const relay = await this.initializeRelay();
	            const res = await relay.signEthereumMessage(message, address, addPrefix, typedDataJson).promise;
	            return { jsonrpc: "2.0", id: 0, result: res.result };
	        }
	        catch (err) {
	            if (typeof err.message === "string" &&
	                err.message.match(/(denied|rejected)/i)) {
	                throw errors_1$1.standardErrors.provider.userRejectedRequest("User denied message signature");
	            }
	            throw err;
	        }
	    }
	    async _ethereumAddressFromSignedMessage(message, signature, addPrefix) {
	        const relay = await this.initializeRelay();
	        const res = await relay.ethereumAddressFromSignedMessage(message, signature, addPrefix).promise;
	        return { jsonrpc: "2.0", id: 0, result: res.result };
	    }
	    _eth_accounts() {
	        return [...this._addresses];
	    }
	    _eth_coinbase() {
	        return this.selectedAddress || null;
	    }
	    _net_version() {
	        return this.getChainId().toString(10);
	    }
	    _eth_chainId() {
	        return (0, util_1$5.hexStringFromIntNumber)(this.getChainId());
	    }
	    getChainId() {
	        const chainIdStr = this._storage.getItem(DEFAULT_CHAIN_ID_KEY);
	        if (!chainIdStr) {
	            return (0, util_1$5.ensureIntNumber)(this._chainIdFromOpts);
	        }
	        const chainId = parseInt(chainIdStr, 10);
	        return (0, util_1$5.ensureIntNumber)(chainId);
	    }
	    async _eth_requestAccounts() {
	        var _a;
	        (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1$2.EVENTS.ETH_ACCOUNTS_STATE, {
	            method: "provider::_eth_requestAccounts",
	            addresses_length: this._addresses.length,
	            sessionIdHash: this._relay
	                ? Session_1$2.Session.hash(this._relay.session.id)
	                : undefined,
	        });
	        if (this._addresses.length > 0) {
	            return Promise.resolve({
	                jsonrpc: "2.0",
	                id: 0,
	                result: this._addresses,
	            });
	        }
	        let res;
	        try {
	            const relay = await this.initializeRelay();
	            res = await relay.requestEthereumAccounts().promise;
	        }
	        catch (err) {
	            if (typeof err.message === "string" &&
	                err.message.match(/(denied|rejected)/i)) {
	                throw errors_1$1.standardErrors.provider.userRejectedRequest("User denied account authorization");
	            }
	            throw err;
	        }
	        if (!res.result) {
	            throw new Error("accounts received is empty");
	        }
	        this._setAddresses(res.result);
	        if (!(this.isLedger || this.isCoinbaseBrowser)) {
	            await this.switchEthereumChain(this.getChainId());
	        }
	        return { jsonrpc: "2.0", id: 0, result: this._addresses };
	    }
	    _eth_sign(params) {
	        this._requireAuthorization();
	        const address = (0, util_1$5.ensureAddressString)(params[0]);
	        const message = (0, util_1$5.ensureBuffer)(params[1]);
	        return this._signEthereumMessage(message, address, false);
	    }
	    _eth_ecRecover(params) {
	        const message = (0, util_1$5.ensureBuffer)(params[0]);
	        const signature = (0, util_1$5.ensureBuffer)(params[1]);
	        return this._ethereumAddressFromSignedMessage(message, signature, false);
	    }
	    _personal_sign(params) {
	        this._requireAuthorization();
	        const message = (0, util_1$5.ensureBuffer)(params[0]);
	        const address = (0, util_1$5.ensureAddressString)(params[1]);
	        return this._signEthereumMessage(message, address, true);
	    }
	    _personal_ecRecover(params) {
	        const message = (0, util_1$5.ensureBuffer)(params[0]);
	        const signature = (0, util_1$5.ensureBuffer)(params[1]);
	        return this._ethereumAddressFromSignedMessage(message, signature, true);
	    }
	    async _eth_signTransaction(params) {
	        this._requireAuthorization();
	        const tx = this._prepareTransactionParams(params[0] || {});
	        try {
	            const relay = await this.initializeRelay();
	            const res = await relay.signEthereumTransaction(tx).promise;
	            return { jsonrpc: "2.0", id: 0, result: res.result };
	        }
	        catch (err) {
	            if (typeof err.message === "string" &&
	                err.message.match(/(denied|rejected)/i)) {
	                throw errors_1$1.standardErrors.provider.userRejectedRequest("User denied transaction signature");
	            }
	            throw err;
	        }
	    }
	    async _eth_sendRawTransaction(params) {
	        const signedTransaction = (0, util_1$5.ensureBuffer)(params[0]);
	        const relay = await this.initializeRelay();
	        const res = await relay.submitEthereumTransaction(signedTransaction, this.getChainId()).promise;
	        return { jsonrpc: "2.0", id: 0, result: res.result };
	    }
	    async _eth_sendTransaction(params) {
	        this._requireAuthorization();
	        const tx = this._prepareTransactionParams(params[0] || {});
	        try {
	            const relay = await this.initializeRelay();
	            const res = await relay.signAndSubmitEthereumTransaction(tx).promise;
	            return { jsonrpc: "2.0", id: 0, result: res.result };
	        }
	        catch (err) {
	            if (typeof err.message === "string" &&
	                err.message.match(/(denied|rejected)/i)) {
	                throw errors_1$1.standardErrors.provider.userRejectedRequest("User denied transaction signature");
	            }
	            throw err;
	        }
	    }
	    async _eth_signTypedData_v1(params) {
	        this._requireAuthorization();
	        const typedData = (0, util_1$5.ensureParsedJSONObject)(params[0]);
	        const address = (0, util_1$5.ensureAddressString)(params[1]);
	        this._ensureKnownAddress(address);
	        const message = eth_eip712_util_1.default.hashForSignTypedDataLegacy({ data: typedData });
	        const typedDataJSON = JSON.stringify(typedData, null, 2);
	        return this._signEthereumMessage(message, address, false, typedDataJSON);
	    }
	    async _eth_signTypedData_v3(params) {
	        this._requireAuthorization();
	        const address = (0, util_1$5.ensureAddressString)(params[0]);
	        const typedData = (0, util_1$5.ensureParsedJSONObject)(params[1]);
	        this._ensureKnownAddress(address);
	        const message = eth_eip712_util_1.default.hashForSignTypedData_v3({ data: typedData });
	        const typedDataJSON = JSON.stringify(typedData, null, 2);
	        return this._signEthereumMessage(message, address, false, typedDataJSON);
	    }
	    async _eth_signTypedData_v4(params) {
	        this._requireAuthorization();
	        const address = (0, util_1$5.ensureAddressString)(params[0]);
	        const typedData = (0, util_1$5.ensureParsedJSONObject)(params[1]);
	        this._ensureKnownAddress(address);
	        const message = eth_eip712_util_1.default.hashForSignTypedData_v4({ data: typedData });
	        const typedDataJSON = JSON.stringify(typedData, null, 2);
	        return this._signEthereumMessage(message, address, false, typedDataJSON);
	    }
	    /** @deprecated */
	    async _cbwallet_arbitrary(params) {
	        const action = params[0];
	        const data = params[1];
	        if (typeof data !== "string") {
	            throw new Error("parameter must be a string");
	        }
	        if (typeof action !== "object" || action === null) {
	            throw new Error("parameter must be an object");
	        }
	        const result = await this.genericRequest(action, data);
	        return { jsonrpc: "2.0", id: 0, result };
	    }
	    async _wallet_addEthereumChain(params) {
	        var _a, _b, _c, _d;
	        const request = params[0];
	        if (((_a = request.rpcUrls) === null || _a === void 0 ? void 0 : _a.length) === 0) {
	            return {
	                jsonrpc: "2.0",
	                id: 0,
	                error: { code: 2, message: `please pass in at least 1 rpcUrl` },
	            };
	        }
	        if (!request.chainName || request.chainName.trim() === "") {
	            throw errors_1$1.standardErrors.rpc.invalidParams("chainName is a required field");
	        }
	        if (!request.nativeCurrency) {
	            throw errors_1$1.standardErrors.rpc.invalidParams("nativeCurrency is a required field");
	        }
	        const chainIdNumber = parseInt(request.chainId, 16);
	        const success = await this.addEthereumChain(chainIdNumber, (_b = request.rpcUrls) !== null && _b !== void 0 ? _b : [], (_c = request.blockExplorerUrls) !== null && _c !== void 0 ? _c : [], request.chainName, (_d = request.iconUrls) !== null && _d !== void 0 ? _d : [], request.nativeCurrency);
	        if (success) {
	            return { jsonrpc: "2.0", id: 0, result: null };
	        }
	        else {
	            return {
	                jsonrpc: "2.0",
	                id: 0,
	                error: { code: 2, message: `unable to add ethereum chain` },
	            };
	        }
	    }
	    async _wallet_switchEthereumChain(params) {
	        const request = params[0];
	        await this.switchEthereumChain(parseInt(request.chainId, 16));
	        return { jsonrpc: "2.0", id: 0, result: null };
	    }
	    async _wallet_watchAsset(params) {
	        const request = (Array.isArray(params) ? params[0] : params);
	        if (!request.type) {
	            throw errors_1$1.standardErrors.rpc.invalidParams("Type is required");
	        }
	        if ((request === null || request === void 0 ? void 0 : request.type) !== "ERC20") {
	            throw errors_1$1.standardErrors.rpc.invalidParams(`Asset of type '${request.type}' is not supported`);
	        }
	        if (!(request === null || request === void 0 ? void 0 : request.options)) {
	            throw errors_1$1.standardErrors.rpc.invalidParams("Options are required");
	        }
	        if (!(request === null || request === void 0 ? void 0 : request.options.address)) {
	            throw errors_1$1.standardErrors.rpc.invalidParams("Address is required");
	        }
	        const chainId = this.getChainId();
	        const { address, symbol, image, decimals } = request.options;
	        const res = await this.watchAsset(request.type, address, symbol, decimals, image, chainId);
	        return { jsonrpc: "2.0", id: 0, result: res };
	    }
	    _eth_uninstallFilter(params) {
	        const filterId = (0, util_1$5.ensureHexString)(params[0]);
	        return this._filterPolyfill.uninstallFilter(filterId);
	    }
	    async _eth_newFilter(params) {
	        const param = params[0];
	        const filterId = await this._filterPolyfill.newFilter(param);
	        return { jsonrpc: "2.0", id: 0, result: filterId };
	    }
	    async _eth_newBlockFilter() {
	        const filterId = await this._filterPolyfill.newBlockFilter();
	        return { jsonrpc: "2.0", id: 0, result: filterId };
	    }
	    async _eth_newPendingTransactionFilter() {
	        const filterId = await this._filterPolyfill.newPendingTransactionFilter();
	        return { jsonrpc: "2.0", id: 0, result: filterId };
	    }
	    _eth_getFilterChanges(params) {
	        const filterId = (0, util_1$5.ensureHexString)(params[0]);
	        return this._filterPolyfill.getFilterChanges(filterId);
	    }
	    _eth_getFilterLogs(params) {
	        const filterId = (0, util_1$5.ensureHexString)(params[0]);
	        return this._filterPolyfill.getFilterLogs(filterId);
	    }
	    initializeRelay() {
	        if (this._relay) {
	            return Promise.resolve(this._relay);
	        }
	        return this._relayProvider().then(relay => {
	            relay.setAccountsCallback((accounts, isDisconnect) => this._setAddresses(accounts, isDisconnect));
	            relay.setChainCallback((chainId, jsonRpcUrl) => {
	                this.updateProviderInfo(jsonRpcUrl, parseInt(chainId, 10));
	            });
	            relay.setDappDefaultChainCallback(this._chainIdFromOpts);
	            this._relay = relay;
	            return relay;
	        });
	    }
	}
	CoinbaseWalletProvider$1.CoinbaseWalletProvider = CoinbaseWalletProvider;

	var WalletSDKUI$1 = {};

	var LinkFlow$1 = {};

	var n$8,l$7,u$5,t$6,i$7,o$6,r$6,f$3,e$7,c$6={},s$6=[],a$4=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,h$6=Array.isArray;function v$4(n,l){for(var u in l)n[u]=l[u];return n}function p$5(n){var l=n.parentNode;l&&l.removeChild(n);}function y$6(l,u,t){var i,o,r,f={};for(r in u)"key"==r?i=u[r]:"ref"==r?o=u[r]:f[r]=u[r];if(arguments.length>2&&(f.children=arguments.length>3?n$8.call(arguments,2):t),"function"==typeof l&&null!=l.defaultProps)for(r in l.defaultProps)void 0===f[r]&&(f[r]=l.defaultProps[r]);return d$6(l,f,i,o,null)}function d$6(n,t,i,o,r){var f={type:n,props:t,key:i,ref:o,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,__h:null,constructor:void 0,__v:null==r?++u$5:r};return null==r&&null!=l$7.vnode&&l$7.vnode(f),f}function _$6(){return {current:null}}function k$2(n){return n.children}function b$5(n,l){this.props=n,this.context=l;}function g$6(n,l){if(null==l)return n.__?g$6(n.__,n.__.__k.indexOf(n)+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return "function"==typeof n.type?g$6(n):null}function m$4(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return m$4(n)}}function w$4(n){(!n.__d&&(n.__d=!0)&&i$7.push(n)&&!x$2.__r++||o$6!==l$7.debounceRendering)&&((o$6=l$7.debounceRendering)||r$6)(x$2);}function x$2(){var n,l,u,t,o,r,e,c,s;for(i$7.sort(f$3);n=i$7.shift();)n.__d&&(l=i$7.length,t=void 0,o=void 0,r=void 0,c=(e=(u=n).__v).__e,(s=u.__P)&&(t=[],o=[],(r=v$4({},e)).__v=e.__v+1,L$5(s,e,r,u.__n,void 0!==s.ownerSVGElement,null!=e.__h?[c]:null,t,null==c?g$6(e):c,e.__h,o),M$5(t,e,o),e.__e!=c&&m$4(e)),i$7.length>l&&i$7.sort(f$3));x$2.__r=0;}function P$4(n,l,u,t,i,o,r,f,e,a,v){var p,y,_,b,g,m,w,x,P,S,H=0,I=t&&t.__k||s$6,T=I.length,j=T,z=l.length;for(u.__k=[],p=0;p<z;p++)null!=(b=u.__k[p]=null==(b=l[p])||"boolean"==typeof b||"function"==typeof b?null:"string"==typeof b||"number"==typeof b||"bigint"==typeof b?d$6(null,b,null,null,b):h$6(b)?d$6(k$2,{children:b},null,null,null):b.__b>0?d$6(b.type,b.props,b.key,b.ref?b.ref:null,b.__v):b)&&(b.__=u,b.__b=u.__b+1,-1===(x=A$3(b,I,w=p+H,j))?_=c$6:(_=I[x]||c$6,I[x]=void 0,j--),L$5(n,b,_,i,o,r,f,e,a,v),g=b.__e,(y=b.ref)&&_.ref!=y&&(_.ref&&O$4(_.ref,null,b),v.push(y,b.__c||g,b)),null!=g&&(null==m&&(m=g),S=!(P=_===c$6||null===_.__v)&&x===w,P?-1==x&&H--:x!==w&&(x===w+1?(H++,S=!0):x>w?j>z-w?(H+=x-w,S=!0):H--:H=x<w&&x==w-1?x-w:0),w=p+H,S=S||x==p&&!P,"function"!=typeof b.type||x===w&&_.__k!==b.__k?"function"==typeof b.type||S?void 0!==b.__d?(e=b.__d,b.__d=void 0):e=g.nextSibling:e=$$4(n,g,e):e=C$4(b,e,n),"function"==typeof u.type&&(u.__d=e)));for(u.__e=m,p=T;p--;)null!=I[p]&&("function"==typeof u.type&&null!=I[p].__e&&I[p].__e==u.__d&&(u.__d=I[p].__e.nextSibling),q$3(I[p],I[p]));}function C$4(n,l,u){for(var t,i=n.__k,o=0;i&&o<i.length;o++)(t=i[o])&&(t.__=n,l="function"==typeof t.type?C$4(t,l,u):$$4(u,t.__e,l));return l}function S$5(n,l){return l=l||[],null==n||"boolean"==typeof n||(h$6(n)?n.some(function(n){S$5(n,l);}):l.push(n)),l}function $$4(n,l,u){return null==u||u.parentNode!==n?n.insertBefore(l,null):l==u&&null!=l.parentNode||n.insertBefore(l,u),l.nextSibling}function A$3(n,l,u,t){var i=n.key,o=n.type,r=u-1,f=u+1,e=l[u];if(null===e||e&&i==e.key&&o===e.type)return u;if(t>(null!=e?1:0))for(;r>=0||f<l.length;){if(r>=0){if((e=l[r])&&i==e.key&&o===e.type)return r;r--;}if(f<l.length){if((e=l[f])&&i==e.key&&o===e.type)return f;f++;}}return -1}function H$4(n,l,u,t,i){var o;for(o in u)"children"===o||"key"===o||o in l||T$4(n,o,null,u[o],t);for(o in l)i&&"function"!=typeof l[o]||"children"===o||"key"===o||"value"===o||"checked"===o||u[o]===l[o]||T$4(n,o,l[o],u[o],t);}function I$2(n,l,u){"-"===l[0]?n.setProperty(l,null==u?"":u):n[l]=null==u?"":"number"!=typeof u||a$4.test(l)?u:u+"px";}function T$4(n,l,u,t,i){var o;n:if("style"===l)if("string"==typeof u)n.style.cssText=u;else {if("string"==typeof t&&(n.style.cssText=t=""),t)for(l in t)u&&l in u||I$2(n.style,l,"");if(u)for(l in u)t&&u[l]===t[l]||I$2(n.style,l,u[l]);}else if("o"===l[0]&&"n"===l[1])o=l!==(l=l.replace(/Capture$/,"")),l=l.toLowerCase()in n?l.toLowerCase().slice(2):l.slice(2),n.l||(n.l={}),n.l[l+o]=u,u?t||n.addEventListener(l,o?z$3:j$5,o):n.removeEventListener(l,o?z$3:j$5,o);else if("dangerouslySetInnerHTML"!==l){if(i)l=l.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if("width"!==l&&"height"!==l&&"href"!==l&&"list"!==l&&"form"!==l&&"tabIndex"!==l&&"download"!==l&&"rowSpan"!==l&&"colSpan"!==l&&l in n)try{n[l]=null==u?"":u;break n}catch(n){}"function"==typeof u||(null==u||!1===u&&"-"!==l[4]?n.removeAttribute(l):n.setAttribute(l,u));}}function j$5(n){return this.l[n.type+!1](l$7.event?l$7.event(n):n)}function z$3(n){return this.l[n.type+!0](l$7.event?l$7.event(n):n)}function L$5(n,u,t,i,o,r,f,e,c,s){var a,p,y,d,_,g,m,w,x,C,S,$,A,H,I,T=u.type;if(void 0!==u.constructor)return null;null!=t.__h&&(c=t.__h,e=u.__e=t.__e,u.__h=null,r=[e]),(a=l$7.__b)&&a(u);try{n:if("function"==typeof T){if(w=u.props,x=(a=T.contextType)&&i[a.__c],C=a?x?x.props.value:a.__:i,t.__c?m=(p=u.__c=t.__c).__=p.__E:("prototype"in T&&T.prototype.render?u.__c=p=new T(w,C):(u.__c=p=new b$5(w,C),p.constructor=T,p.render=B$4),x&&x.sub(p),p.props=w,p.state||(p.state={}),p.context=C,p.__n=i,y=p.__d=!0,p.__h=[],p._sb=[]),null==p.__s&&(p.__s=p.state),null!=T.getDerivedStateFromProps&&(p.__s==p.state&&(p.__s=v$4({},p.__s)),v$4(p.__s,T.getDerivedStateFromProps(w,p.__s))),d=p.props,_=p.state,p.__v=u,y)null==T.getDerivedStateFromProps&&null!=p.componentWillMount&&p.componentWillMount(),null!=p.componentDidMount&&p.__h.push(p.componentDidMount);else {if(null==T.getDerivedStateFromProps&&w!==d&&null!=p.componentWillReceiveProps&&p.componentWillReceiveProps(w,C),!p.__e&&(null!=p.shouldComponentUpdate&&!1===p.shouldComponentUpdate(w,p.__s,C)||u.__v===t.__v)){for(u.__v!==t.__v&&(p.props=w,p.state=p.__s,p.__d=!1),u.__e=t.__e,u.__k=t.__k,u.__k.forEach(function(n){n&&(n.__=u);}),S=0;S<p._sb.length;S++)p.__h.push(p._sb[S]);p._sb=[],p.__h.length&&f.push(p);break n}null!=p.componentWillUpdate&&p.componentWillUpdate(w,p.__s,C),null!=p.componentDidUpdate&&p.__h.push(function(){p.componentDidUpdate(d,_,g);});}if(p.context=C,p.props=w,p.__P=n,p.__e=!1,$=l$7.__r,A=0,"prototype"in T&&T.prototype.render){for(p.state=p.__s,p.__d=!1,$&&$(u),a=p.render(p.props,p.state,p.context),H=0;H<p._sb.length;H++)p.__h.push(p._sb[H]);p._sb=[];}else do{p.__d=!1,$&&$(u),a=p.render(p.props,p.state,p.context),p.state=p.__s;}while(p.__d&&++A<25);p.state=p.__s,null!=p.getChildContext&&(i=v$4(v$4({},i),p.getChildContext())),y||null==p.getSnapshotBeforeUpdate||(g=p.getSnapshotBeforeUpdate(d,_)),P$4(n,h$6(I=null!=a&&a.type===k$2&&null==a.key?a.props.children:a)?I:[I],u,t,i,o,r,f,e,c,s),p.base=u.__e,u.__h=null,p.__h.length&&f.push(p),m&&(p.__E=p.__=null);}else null==r&&u.__v===t.__v?(u.__k=t.__k,u.__e=t.__e):u.__e=N$3(t.__e,u,t,i,o,r,f,c,s);(a=l$7.diffed)&&a(u);}catch(n){u.__v=null,(c||null!=r)&&(u.__e=e,u.__h=!!c,r[r.indexOf(e)]=null),l$7.__e(n,u,t);}}function M$5(n,u,t){for(var i=0;i<t.length;i++)O$4(t[i],t[++i],t[++i]);l$7.__c&&l$7.__c(u,n),n.some(function(u){try{n=u.__h,u.__h=[],n.some(function(n){n.call(u);});}catch(n){l$7.__e(n,u.__v);}});}function N$3(l,u,t,i,o,r,f,e,s){var a,v,y,d=t.props,_=u.props,k=u.type,b=0;if("svg"===k&&(o=!0),null!=r)for(;b<r.length;b++)if((a=r[b])&&"setAttribute"in a==!!k&&(k?a.localName===k:3===a.nodeType)){l=a,r[b]=null;break}if(null==l){if(null===k)return document.createTextNode(_);l=o?document.createElementNS("http://www.w3.org/2000/svg",k):document.createElement(k,_.is&&_),r=null,e=!1;}if(null===k)d===_||e&&l.data===_||(l.data=_);else {if(r=r&&n$8.call(l.childNodes),v=(d=t.props||c$6).dangerouslySetInnerHTML,y=_.dangerouslySetInnerHTML,!e){if(null!=r)for(d={},b=0;b<l.attributes.length;b++)d[l.attributes[b].name]=l.attributes[b].value;(y||v)&&(y&&(v&&y.__html==v.__html||y.__html===l.innerHTML)||(l.innerHTML=y&&y.__html||""));}if(H$4(l,_,d,o,e),y)u.__k=[];else if(P$4(l,h$6(b=u.props.children)?b:[b],u,t,i,o&&"foreignObject"!==k,r,f,r?r[0]:t.__k&&g$6(t,0),e,s),null!=r)for(b=r.length;b--;)null!=r[b]&&p$5(r[b]);e||("value"in _&&void 0!==(b=_.value)&&(b!==l.value||"progress"===k&&!b||"option"===k&&b!==d.value)&&T$4(l,"value",b,d.value,!1),"checked"in _&&void 0!==(b=_.checked)&&b!==l.checked&&T$4(l,"checked",b,d.checked,!1));}return l}function O$4(n,u,t){try{"function"==typeof n?n(u):n.current=u;}catch(n){l$7.__e(n,t);}}function q$3(n,u,t){var i,o;if(l$7.unmount&&l$7.unmount(n),(i=n.ref)&&(i.current&&i.current!==n.__e||O$4(i,null,u)),null!=(i=n.__c)){if(i.componentWillUnmount)try{i.componentWillUnmount();}catch(n){l$7.__e(n,u);}i.base=i.__P=null,n.__c=void 0;}if(i=n.__k)for(o=0;o<i.length;o++)i[o]&&q$3(i[o],u,t||"function"!=typeof n.type);t||null==n.__e||p$5(n.__e),n.__=n.__e=n.__d=void 0;}function B$4(n,l,u){return this.constructor(n,u)}function D$4(u,t,i){var o,r,f,e;l$7.__&&l$7.__(u,t),r=(o="function"==typeof i)?null:i&&i.__k||t.__k,f=[],e=[],L$5(t,u=(!o&&i||t).__k=y$6(k$2,null,[u]),r||c$6,c$6,void 0!==t.ownerSVGElement,!o&&i?[i]:r?null:t.firstChild?n$8.call(t.childNodes):null,f,!o&&i?i:r?r.__e:t.firstChild,o,e),M$5(f,u,e);}function E$3(n,l){D$4(n,l,E$3);}function F$3(l,u,t){var i,o,r,f,e=v$4({},l.props);for(r in l.type&&l.type.defaultProps&&(f=l.type.defaultProps),u)"key"==r?i=u[r]:"ref"==r?o=u[r]:e[r]=void 0===u[r]&&void 0!==f?f[r]:u[r];return arguments.length>2&&(e.children=arguments.length>3?n$8.call(arguments,2):t),d$6(l.type,e,i||l.key,o||l.ref,null)}function G$4(n,l){var u={__c:l="__cC"+e$7++,__:n,Consumer:function(n,l){return n.children(l)},Provider:function(n){var u,t;return this.getChildContext||(u=[],(t={})[l]=this,this.getChildContext=function(){return t},this.shouldComponentUpdate=function(n){this.props.value!==n.value&&u.some(function(n){n.__e=!0,w$4(n);});},this.sub=function(n){u.push(n);var l=n.componentWillUnmount;n.componentWillUnmount=function(){u.splice(u.indexOf(n),1),l&&l.call(n);};}),n.children}};return u.Provider.__=u.Consumer.contextType=u}n$8=s$6.slice,l$7={__e:function(n,l,u,t){for(var i,o,r;l=l.__;)if((i=l.__c)&&!i.__)try{if((o=i.constructor)&&null!=o.getDerivedStateFromError&&(i.setState(o.getDerivedStateFromError(n)),r=i.__d),null!=i.componentDidCatch&&(i.componentDidCatch(n,t||{}),r=i.__d),r)return i.__E=i}catch(l){n=l;}throw n}},u$5=0,t$6=function(n){return null!=n&&void 0===n.constructor},b$5.prototype.setState=function(n,l){var u;u=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=v$4({},this.state),"function"==typeof n&&(n=n(v$4({},u),this.props)),n&&v$4(u,n),null!=n&&this.__v&&(l&&this._sb.push(l),w$4(this));},b$5.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),w$4(this));},b$5.prototype.render=k$2,i$7=[],r$6="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,f$3=function(n,l){return n.__v.__b-l.__v.__b},x$2.__r=0,e$7=0;

	var preact_module = /*#__PURE__*/Object.freeze({
		__proto__: null,
		Component: b$5,
		Fragment: k$2,
		cloneElement: F$3,
		createContext: G$4,
		createElement: y$6,
		createRef: _$6,
		h: y$6,
		hydrate: E$3,
		get isValidElement () { return t$6; },
		get options () { return l$7; },
		render: D$4,
		toChildArray: S$5
	});

	var require$$1$1 = /*@__PURE__*/getAugmentedNamespace(preact_module);

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	function isFunction$1(x) {
	    return typeof x === 'function';
	}

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	var _enable_super_gross_mode_that_will_cause_bad_things = false;
	var config = {
	    Promise: undefined,
	    set useDeprecatedSynchronousErrorHandling(value) {
	        if (value) {
	            var error = /*@__PURE__*/ new Error();
	            /*@__PURE__*/ console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
	        }
	        _enable_super_gross_mode_that_will_cause_bad_things = value;
	    },
	    get useDeprecatedSynchronousErrorHandling() {
	        return _enable_super_gross_mode_that_will_cause_bad_things;
	    },
	};

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	function hostReportError(err) {
	    setTimeout(function () { throw err; }, 0);
	}

	/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */
	var empty$1 = {
	    closed: true,
	    next: function (value) { },
	    error: function (err) {
	        if (config.useDeprecatedSynchronousErrorHandling) {
	            throw err;
	        }
	        else {
	            hostReportError(err);
	        }
	    },
	    complete: function () { }
	};

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	var isArray = /*@__PURE__*/ (function () { return Array.isArray || (function (x) { return x && typeof x.length === 'number'; }); })();

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	function isObject$1(x) {
	    return x !== null && typeof x === 'object';
	}

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	var UnsubscriptionErrorImpl = /*@__PURE__*/ (function () {
	    function UnsubscriptionErrorImpl(errors) {
	        Error.call(this);
	        this.message = errors ?
	            errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
	        this.name = 'UnsubscriptionError';
	        this.errors = errors;
	        return this;
	    }
	    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
	    return UnsubscriptionErrorImpl;
	})();
	var UnsubscriptionError = UnsubscriptionErrorImpl;

	/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */
	var Subscription = /*@__PURE__*/ (function () {
	    function Subscription(unsubscribe) {
	        this.closed = false;
	        this._parentOrParents = null;
	        this._subscriptions = null;
	        if (unsubscribe) {
	            this._ctorUnsubscribe = true;
	            this._unsubscribe = unsubscribe;
	        }
	    }
	    Subscription.prototype.unsubscribe = function () {
	        var errors;
	        if (this.closed) {
	            return;
	        }
	        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
	        this.closed = true;
	        this._parentOrParents = null;
	        this._subscriptions = null;
	        if (_parentOrParents instanceof Subscription) {
	            _parentOrParents.remove(this);
	        }
	        else if (_parentOrParents !== null) {
	            for (var index = 0; index < _parentOrParents.length; ++index) {
	                var parent_1 = _parentOrParents[index];
	                parent_1.remove(this);
	            }
	        }
	        if (isFunction$1(_unsubscribe)) {
	            if (_ctorUnsubscribe) {
	                this._unsubscribe = undefined;
	            }
	            try {
	                _unsubscribe.call(this);
	            }
	            catch (e) {
	                errors = e instanceof UnsubscriptionError ? flattenUnsubscriptionErrors(e.errors) : [e];
	            }
	        }
	        if (isArray(_subscriptions)) {
	            var index = -1;
	            var len = _subscriptions.length;
	            while (++index < len) {
	                var sub = _subscriptions[index];
	                if (isObject$1(sub)) {
	                    try {
	                        sub.unsubscribe();
	                    }
	                    catch (e) {
	                        errors = errors || [];
	                        if (e instanceof UnsubscriptionError) {
	                            errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
	                        }
	                        else {
	                            errors.push(e);
	                        }
	                    }
	                }
	            }
	        }
	        if (errors) {
	            throw new UnsubscriptionError(errors);
	        }
	    };
	    Subscription.prototype.add = function (teardown) {
	        var subscription = teardown;
	        if (!teardown) {
	            return Subscription.EMPTY;
	        }
	        switch (typeof teardown) {
	            case 'function':
	                subscription = new Subscription(teardown);
	            case 'object':
	                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
	                    return subscription;
	                }
	                else if (this.closed) {
	                    subscription.unsubscribe();
	                    return subscription;
	                }
	                else if (!(subscription instanceof Subscription)) {
	                    var tmp = subscription;
	                    subscription = new Subscription();
	                    subscription._subscriptions = [tmp];
	                }
	                break;
	            default: {
	                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
	            }
	        }
	        var _parentOrParents = subscription._parentOrParents;
	        if (_parentOrParents === null) {
	            subscription._parentOrParents = this;
	        }
	        else if (_parentOrParents instanceof Subscription) {
	            if (_parentOrParents === this) {
	                return subscription;
	            }
	            subscription._parentOrParents = [_parentOrParents, this];
	        }
	        else if (_parentOrParents.indexOf(this) === -1) {
	            _parentOrParents.push(this);
	        }
	        else {
	            return subscription;
	        }
	        var subscriptions = this._subscriptions;
	        if (subscriptions === null) {
	            this._subscriptions = [subscription];
	        }
	        else {
	            subscriptions.push(subscription);
	        }
	        return subscription;
	    };
	    Subscription.prototype.remove = function (subscription) {
	        var subscriptions = this._subscriptions;
	        if (subscriptions) {
	            var subscriptionIndex = subscriptions.indexOf(subscription);
	            if (subscriptionIndex !== -1) {
	                subscriptions.splice(subscriptionIndex, 1);
	            }
	        }
	    };
	    Subscription.EMPTY = (function (empty) {
	        empty.closed = true;
	        return empty;
	    }(new Subscription()));
	    return Subscription;
	}());
	function flattenUnsubscriptionErrors(errors) {
	    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError) ? err.errors : err); }, []);
	}

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	var rxSubscriber = /*@__PURE__*/ (function () {
	    return typeof Symbol === 'function'
	        ? /*@__PURE__*/ Symbol('rxSubscriber')
	        : '@@rxSubscriber_' + /*@__PURE__*/ Math.random();
	})();

	/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */
	var Subscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(Subscriber, _super);
	    function Subscriber(destinationOrNext, error, complete) {
	        var _this = _super.call(this) || this;
	        _this.syncErrorValue = null;
	        _this.syncErrorThrown = false;
	        _this.syncErrorThrowable = false;
	        _this.isStopped = false;
	        switch (arguments.length) {
	            case 0:
	                _this.destination = empty$1;
	                break;
	            case 1:
	                if (!destinationOrNext) {
	                    _this.destination = empty$1;
	                    break;
	                }
	                if (typeof destinationOrNext === 'object') {
	                    if (destinationOrNext instanceof Subscriber) {
	                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
	                        _this.destination = destinationOrNext;
	                        destinationOrNext.add(_this);
	                    }
	                    else {
	                        _this.syncErrorThrowable = true;
	                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
	                    }
	                    break;
	                }
	            default:
	                _this.syncErrorThrowable = true;
	                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
	                break;
	        }
	        return _this;
	    }
	    Subscriber.prototype[rxSubscriber] = function () { return this; };
	    Subscriber.create = function (next, error, complete) {
	        var subscriber = new Subscriber(next, error, complete);
	        subscriber.syncErrorThrowable = false;
	        return subscriber;
	    };
	    Subscriber.prototype.next = function (value) {
	        if (!this.isStopped) {
	            this._next(value);
	        }
	    };
	    Subscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._error(err);
	        }
	    };
	    Subscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._complete();
	        }
	    };
	    Subscriber.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.isStopped = true;
	        _super.prototype.unsubscribe.call(this);
	    };
	    Subscriber.prototype._next = function (value) {
	        this.destination.next(value);
	    };
	    Subscriber.prototype._error = function (err) {
	        this.destination.error(err);
	        this.unsubscribe();
	    };
	    Subscriber.prototype._complete = function () {
	        this.destination.complete();
	        this.unsubscribe();
	    };
	    Subscriber.prototype._unsubscribeAndRecycle = function () {
	        var _parentOrParents = this._parentOrParents;
	        this._parentOrParents = null;
	        this.unsubscribe();
	        this.closed = false;
	        this.isStopped = false;
	        this._parentOrParents = _parentOrParents;
	        return this;
	    };
	    return Subscriber;
	}(Subscription));
	var SafeSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SafeSubscriber, _super);
	    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
	        var _this = _super.call(this) || this;
	        _this._parentSubscriber = _parentSubscriber;
	        var next;
	        var context = _this;
	        if (isFunction$1(observerOrNext)) {
	            next = observerOrNext;
	        }
	        else if (observerOrNext) {
	            next = observerOrNext.next;
	            error = observerOrNext.error;
	            complete = observerOrNext.complete;
	            if (observerOrNext !== empty$1) {
	                context = Object.create(observerOrNext);
	                if (isFunction$1(context.unsubscribe)) {
	                    _this.add(context.unsubscribe.bind(context));
	                }
	                context.unsubscribe = _this.unsubscribe.bind(_this);
	            }
	        }
	        _this._context = context;
	        _this._next = next;
	        _this._error = error;
	        _this._complete = complete;
	        return _this;
	    }
	    SafeSubscriber.prototype.next = function (value) {
	        if (!this.isStopped && this._next) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
	                this.__tryOrUnsub(this._next, value);
	            }
	            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            var useDeprecatedSynchronousErrorHandling = config.useDeprecatedSynchronousErrorHandling;
	            if (this._error) {
	                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(this._error, err);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, this._error, err);
	                    this.unsubscribe();
	                }
	            }
	            else if (!_parentSubscriber.syncErrorThrowable) {
	                this.unsubscribe();
	                if (useDeprecatedSynchronousErrorHandling) {
	                    throw err;
	                }
	                hostReportError(err);
	            }
	            else {
	                if (useDeprecatedSynchronousErrorHandling) {
	                    _parentSubscriber.syncErrorValue = err;
	                    _parentSubscriber.syncErrorThrown = true;
	                }
	                else {
	                    hostReportError(err);
	                }
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.complete = function () {
	        var _this = this;
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._complete) {
	                var wrappedComplete = function () { return _this._complete.call(_this._context); };
	                if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(wrappedComplete);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
	                    this.unsubscribe();
	                }
	            }
	            else {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            this.unsubscribe();
	            if (config.useDeprecatedSynchronousErrorHandling) {
	                throw err;
	            }
	            else {
	                hostReportError(err);
	            }
	        }
	    };
	    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
	        if (!config.useDeprecatedSynchronousErrorHandling) {
	            throw new Error('bad call');
	        }
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            if (config.useDeprecatedSynchronousErrorHandling) {
	                parent.syncErrorValue = err;
	                parent.syncErrorThrown = true;
	                return true;
	            }
	            else {
	                hostReportError(err);
	                return true;
	            }
	        }
	        return false;
	    };
	    SafeSubscriber.prototype._unsubscribe = function () {
	        var _parentSubscriber = this._parentSubscriber;
	        this._context = null;
	        this._parentSubscriber = null;
	        _parentSubscriber.unsubscribe();
	    };
	    return SafeSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */
	function canReportError(observer) {
	    while (observer) {
	        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
	        if (closed_1 || isStopped) {
	            return false;
	        }
	        else if (destination && destination instanceof Subscriber) {
	            observer = destination;
	        }
	        else {
	            observer = null;
	        }
	    }
	    return true;
	}

	/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */
	function toSubscriber(nextOrObserver, error, complete) {
	    if (nextOrObserver) {
	        if (nextOrObserver instanceof Subscriber) {
	            return nextOrObserver;
	        }
	        if (nextOrObserver[rxSubscriber]) {
	            return nextOrObserver[rxSubscriber]();
	        }
	    }
	    if (!nextOrObserver && !error && !complete) {
	        return new Subscriber(empty$1);
	    }
	    return new Subscriber(nextOrObserver, error, complete);
	}

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	var observable = /*@__PURE__*/ (function () { return typeof Symbol === 'function' && Symbol.observable || '@@observable'; })();

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	function identity(x) {
	    return x;
	}

	/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */
	function pipe() {
	    var fns = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        fns[_i] = arguments[_i];
	    }
	    return pipeFromArray(fns);
	}
	function pipeFromArray(fns) {
	    if (fns.length === 0) {
	        return identity;
	    }
	    if (fns.length === 1) {
	        return fns[0];
	    }
	    return function piped(input) {
	        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
	    };
	}

	/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */
	var Observable = /*@__PURE__*/ (function () {
	    function Observable(subscribe) {
	        this._isScalar = false;
	        if (subscribe) {
	            this._subscribe = subscribe;
	        }
	    }
	    Observable.prototype.lift = function (operator) {
	        var observable = new Observable();
	        observable.source = this;
	        observable.operator = operator;
	        return observable;
	    };
	    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
	        var operator = this.operator;
	        var sink = toSubscriber(observerOrNext, error, complete);
	        if (operator) {
	            sink.add(operator.call(sink, this.source));
	        }
	        else {
	            sink.add(this.source || (config.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
	                this._subscribe(sink) :
	                this._trySubscribe(sink));
	        }
	        if (config.useDeprecatedSynchronousErrorHandling) {
	            if (sink.syncErrorThrowable) {
	                sink.syncErrorThrowable = false;
	                if (sink.syncErrorThrown) {
	                    throw sink.syncErrorValue;
	                }
	            }
	        }
	        return sink;
	    };
	    Observable.prototype._trySubscribe = function (sink) {
	        try {
	            return this._subscribe(sink);
	        }
	        catch (err) {
	            if (config.useDeprecatedSynchronousErrorHandling) {
	                sink.syncErrorThrown = true;
	                sink.syncErrorValue = err;
	            }
	            if (canReportError(sink)) {
	                sink.error(err);
	            }
	            else {
	                console.warn(err);
	            }
	        }
	    };
	    Observable.prototype.forEach = function (next, promiseCtor) {
	        var _this = this;
	        promiseCtor = getPromiseCtor(promiseCtor);
	        return new promiseCtor(function (resolve, reject) {
	            var subscription;
	            subscription = _this.subscribe(function (value) {
	                try {
	                    next(value);
	                }
	                catch (err) {
	                    reject(err);
	                    if (subscription) {
	                        subscription.unsubscribe();
	                    }
	                }
	            }, reject, resolve);
	        });
	    };
	    Observable.prototype._subscribe = function (subscriber) {
	        var source = this.source;
	        return source && source.subscribe(subscriber);
	    };
	    Observable.prototype[observable] = function () {
	        return this;
	    };
	    Observable.prototype.pipe = function () {
	        var operations = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            operations[_i] = arguments[_i];
	        }
	        if (operations.length === 0) {
	            return this;
	        }
	        return pipeFromArray(operations)(this);
	    };
	    Observable.prototype.toPromise = function (promiseCtor) {
	        var _this = this;
	        promiseCtor = getPromiseCtor(promiseCtor);
	        return new promiseCtor(function (resolve, reject) {
	            var value;
	            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
	        });
	    };
	    Observable.create = function (subscribe) {
	        return new Observable(subscribe);
	    };
	    return Observable;
	}());
	function getPromiseCtor(promiseCtor) {
	    if (!promiseCtor) {
	        promiseCtor = config.Promise || Promise;
	    }
	    if (!promiseCtor) {
	        throw new Error('no Promise impl found');
	    }
	    return promiseCtor;
	}

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ (function () {
	    function ObjectUnsubscribedErrorImpl() {
	        Error.call(this);
	        this.message = 'object unsubscribed';
	        this.name = 'ObjectUnsubscribedError';
	        return this;
	    }
	    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
	    return ObjectUnsubscribedErrorImpl;
	})();
	var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;

	/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */
	var SubjectSubscription = /*@__PURE__*/ (function (_super) {
	    __extends$1(SubjectSubscription, _super);
	    function SubjectSubscription(subject, subscriber) {
	        var _this = _super.call(this) || this;
	        _this.subject = subject;
	        _this.subscriber = subscriber;
	        _this.closed = false;
	        return _this;
	    }
	    SubjectSubscription.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.closed = true;
	        var subject = this.subject;
	        var observers = subject.observers;
	        this.subject = null;
	        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
	            return;
	        }
	        var subscriberIndex = observers.indexOf(this.subscriber);
	        if (subscriberIndex !== -1) {
	            observers.splice(subscriberIndex, 1);
	        }
	    };
	    return SubjectSubscription;
	}(Subscription));

	/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */
	var SubjectSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SubjectSubscriber, _super);
	    function SubjectSubscriber(destination) {
	        var _this = _super.call(this, destination) || this;
	        _this.destination = destination;
	        return _this;
	    }
	    return SubjectSubscriber;
	}(Subscriber));
	var Subject = /*@__PURE__*/ (function (_super) {
	    __extends$1(Subject, _super);
	    function Subject() {
	        var _this = _super.call(this) || this;
	        _this.observers = [];
	        _this.closed = false;
	        _this.isStopped = false;
	        _this.hasError = false;
	        _this.thrownError = null;
	        return _this;
	    }
	    Subject.prototype[rxSubscriber] = function () {
	        return new SubjectSubscriber(this);
	    };
	    Subject.prototype.lift = function (operator) {
	        var subject = new AnonymousSubject(this, this);
	        subject.operator = operator;
	        return subject;
	    };
	    Subject.prototype.next = function (value) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError();
	        }
	        if (!this.isStopped) {
	            var observers = this.observers;
	            var len = observers.length;
	            var copy = observers.slice();
	            for (var i = 0; i < len; i++) {
	                copy[i].next(value);
	            }
	        }
	    };
	    Subject.prototype.error = function (err) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError();
	        }
	        this.hasError = true;
	        this.thrownError = err;
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].error(err);
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.complete = function () {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError();
	        }
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].complete();
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.unsubscribe = function () {
	        this.isStopped = true;
	        this.closed = true;
	        this.observers = null;
	    };
	    Subject.prototype._trySubscribe = function (subscriber) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError();
	        }
	        else {
	            return _super.prototype._trySubscribe.call(this, subscriber);
	        }
	    };
	    Subject.prototype._subscribe = function (subscriber) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError();
	        }
	        else if (this.hasError) {
	            subscriber.error(this.thrownError);
	            return Subscription.EMPTY;
	        }
	        else if (this.isStopped) {
	            subscriber.complete();
	            return Subscription.EMPTY;
	        }
	        else {
	            this.observers.push(subscriber);
	            return new SubjectSubscription(this, subscriber);
	        }
	    };
	    Subject.prototype.asObservable = function () {
	        var observable = new Observable();
	        observable.source = this;
	        return observable;
	    };
	    Subject.create = function (destination, source) {
	        return new AnonymousSubject(destination, source);
	    };
	    return Subject;
	}(Observable));
	var AnonymousSubject = /*@__PURE__*/ (function (_super) {
	    __extends$1(AnonymousSubject, _super);
	    function AnonymousSubject(destination, source) {
	        var _this = _super.call(this) || this;
	        _this.destination = destination;
	        _this.source = source;
	        return _this;
	    }
	    AnonymousSubject.prototype.next = function (value) {
	        var destination = this.destination;
	        if (destination && destination.next) {
	            destination.next(value);
	        }
	    };
	    AnonymousSubject.prototype.error = function (err) {
	        var destination = this.destination;
	        if (destination && destination.error) {
	            this.destination.error(err);
	        }
	    };
	    AnonymousSubject.prototype.complete = function () {
	        var destination = this.destination;
	        if (destination && destination.complete) {
	            this.destination.complete();
	        }
	    };
	    AnonymousSubject.prototype._subscribe = function (subscriber) {
	        var source = this.source;
	        if (source) {
	            return this.source.subscribe(subscriber);
	        }
	        else {
	            return Subscription.EMPTY;
	        }
	    };
	    return AnonymousSubject;
	}(Subject));

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function refCount() {
	    return function refCountOperatorFunction(source) {
	        return source.lift(new RefCountOperator(source));
	    };
	}
	var RefCountOperator = /*@__PURE__*/ (function () {
	    function RefCountOperator(connectable) {
	        this.connectable = connectable;
	    }
	    RefCountOperator.prototype.call = function (subscriber, source) {
	        var connectable = this.connectable;
	        connectable._refCount++;
	        var refCounter = new RefCountSubscriber(subscriber, connectable);
	        var subscription = source.subscribe(refCounter);
	        if (!refCounter.closed) {
	            refCounter.connection = connectable.connect();
	        }
	        return subscription;
	    };
	    return RefCountOperator;
	}());
	var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(RefCountSubscriber, _super);
	    function RefCountSubscriber(destination, connectable) {
	        var _this = _super.call(this, destination) || this;
	        _this.connectable = connectable;
	        return _this;
	    }
	    RefCountSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (!connectable) {
	            this.connection = null;
	            return;
	        }
	        this.connectable = null;
	        var refCount = connectable._refCount;
	        if (refCount <= 0) {
	            this.connection = null;
	            return;
	        }
	        connectable._refCount = refCount - 1;
	        if (refCount > 1) {
	            this.connection = null;
	            return;
	        }
	        var connection = this.connection;
	        var sharedConnection = connectable._connection;
	        this.connection = null;
	        if (sharedConnection && (!connection || sharedConnection === connection)) {
	            sharedConnection.unsubscribe();
	        }
	    };
	    return RefCountSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */
	var ConnectableObservable = /*@__PURE__*/ (function (_super) {
	    __extends$1(ConnectableObservable, _super);
	    function ConnectableObservable(source, subjectFactory) {
	        var _this = _super.call(this) || this;
	        _this.source = source;
	        _this.subjectFactory = subjectFactory;
	        _this._refCount = 0;
	        _this._isComplete = false;
	        return _this;
	    }
	    ConnectableObservable.prototype._subscribe = function (subscriber) {
	        return this.getSubject().subscribe(subscriber);
	    };
	    ConnectableObservable.prototype.getSubject = function () {
	        var subject = this._subject;
	        if (!subject || subject.isStopped) {
	            this._subject = this.subjectFactory();
	        }
	        return this._subject;
	    };
	    ConnectableObservable.prototype.connect = function () {
	        var connection = this._connection;
	        if (!connection) {
	            this._isComplete = false;
	            connection = this._connection = new Subscription();
	            connection.add(this.source
	                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
	            if (connection.closed) {
	                this._connection = null;
	                connection = Subscription.EMPTY;
	            }
	        }
	        return connection;
	    };
	    ConnectableObservable.prototype.refCount = function () {
	        return refCount()(this);
	    };
	    return ConnectableObservable;
	}(Observable));
	var connectableObservableDescriptor = /*@__PURE__*/ (function () {
	    var connectableProto = ConnectableObservable.prototype;
	    return {
	        operator: { value: null },
	        _refCount: { value: 0, writable: true },
	        _subject: { value: null, writable: true },
	        _connection: { value: null, writable: true },
	        _subscribe: { value: connectableProto._subscribe },
	        _isComplete: { value: connectableProto._isComplete, writable: true },
	        getSubject: { value: connectableProto.getSubject },
	        connect: { value: connectableProto.connect },
	        refCount: { value: connectableProto.refCount }
	    };
	})();
	var ConnectableSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(ConnectableSubscriber, _super);
	    function ConnectableSubscriber(destination, connectable) {
	        var _this = _super.call(this, destination) || this;
	        _this.connectable = connectable;
	        return _this;
	    }
	    ConnectableSubscriber.prototype._error = function (err) {
	        this._unsubscribe();
	        _super.prototype._error.call(this, err);
	    };
	    ConnectableSubscriber.prototype._complete = function () {
	        this.connectable._isComplete = true;
	        this._unsubscribe();
	        _super.prototype._complete.call(this);
	    };
	    ConnectableSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (connectable) {
	            this.connectable = null;
	            var connection = connectable._connection;
	            connectable._refCount = 0;
	            connectable._subject = null;
	            connectable._connection = null;
	            if (connection) {
	                connection.unsubscribe();
	            }
	        }
	    };
	    return ConnectableSubscriber;
	}(SubjectSubscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription,_Observable,_Subject PURE_IMPORTS_END */
	function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
	    return function (source) {
	        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
	    };
	}
	var GroupByOperator = /*@__PURE__*/ (function () {
	    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
	        this.keySelector = keySelector;
	        this.elementSelector = elementSelector;
	        this.durationSelector = durationSelector;
	        this.subjectSelector = subjectSelector;
	    }
	    GroupByOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
	    };
	    return GroupByOperator;
	}());
	var GroupBySubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(GroupBySubscriber, _super);
	    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.keySelector = keySelector;
	        _this.elementSelector = elementSelector;
	        _this.durationSelector = durationSelector;
	        _this.subjectSelector = subjectSelector;
	        _this.groups = null;
	        _this.attemptedToUnsubscribe = false;
	        _this.count = 0;
	        return _this;
	    }
	    GroupBySubscriber.prototype._next = function (value) {
	        var key;
	        try {
	            key = this.keySelector(value);
	        }
	        catch (err) {
	            this.error(err);
	            return;
	        }
	        this._group(value, key);
	    };
	    GroupBySubscriber.prototype._group = function (value, key) {
	        var groups = this.groups;
	        if (!groups) {
	            groups = this.groups = new Map();
	        }
	        var group = groups.get(key);
	        var element;
	        if (this.elementSelector) {
	            try {
	                element = this.elementSelector(value);
	            }
	            catch (err) {
	                this.error(err);
	            }
	        }
	        else {
	            element = value;
	        }
	        if (!group) {
	            group = (this.subjectSelector ? this.subjectSelector() : new Subject());
	            groups.set(key, group);
	            var groupedObservable = new GroupedObservable(key, group, this);
	            this.destination.next(groupedObservable);
	            if (this.durationSelector) {
	                var duration = void 0;
	                try {
	                    duration = this.durationSelector(new GroupedObservable(key, group));
	                }
	                catch (err) {
	                    this.error(err);
	                    return;
	                }
	                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
	            }
	        }
	        if (!group.closed) {
	            group.next(element);
	        }
	    };
	    GroupBySubscriber.prototype._error = function (err) {
	        var groups = this.groups;
	        if (groups) {
	            groups.forEach(function (group, key) {
	                group.error(err);
	            });
	            groups.clear();
	        }
	        this.destination.error(err);
	    };
	    GroupBySubscriber.prototype._complete = function () {
	        var groups = this.groups;
	        if (groups) {
	            groups.forEach(function (group, key) {
	                group.complete();
	            });
	            groups.clear();
	        }
	        this.destination.complete();
	    };
	    GroupBySubscriber.prototype.removeGroup = function (key) {
	        this.groups.delete(key);
	    };
	    GroupBySubscriber.prototype.unsubscribe = function () {
	        if (!this.closed) {
	            this.attemptedToUnsubscribe = true;
	            if (this.count === 0) {
	                _super.prototype.unsubscribe.call(this);
	            }
	        }
	    };
	    return GroupBySubscriber;
	}(Subscriber));
	var GroupDurationSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(GroupDurationSubscriber, _super);
	    function GroupDurationSubscriber(key, group, parent) {
	        var _this = _super.call(this, group) || this;
	        _this.key = key;
	        _this.group = group;
	        _this.parent = parent;
	        return _this;
	    }
	    GroupDurationSubscriber.prototype._next = function (value) {
	        this.complete();
	    };
	    GroupDurationSubscriber.prototype._unsubscribe = function () {
	        var _a = this, parent = _a.parent, key = _a.key;
	        this.key = this.parent = null;
	        if (parent) {
	            parent.removeGroup(key);
	        }
	    };
	    return GroupDurationSubscriber;
	}(Subscriber));
	var GroupedObservable = /*@__PURE__*/ (function (_super) {
	    __extends$1(GroupedObservable, _super);
	    function GroupedObservable(key, groupSubject, refCountSubscription) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.groupSubject = groupSubject;
	        _this.refCountSubscription = refCountSubscription;
	        return _this;
	    }
	    GroupedObservable.prototype._subscribe = function (subscriber) {
	        var subscription = new Subscription();
	        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
	        if (refCountSubscription && !refCountSubscription.closed) {
	            subscription.add(new InnerRefCountSubscription(refCountSubscription));
	        }
	        subscription.add(groupSubject.subscribe(subscriber));
	        return subscription;
	    };
	    return GroupedObservable;
	}(Observable));
	var InnerRefCountSubscription = /*@__PURE__*/ (function (_super) {
	    __extends$1(InnerRefCountSubscription, _super);
	    function InnerRefCountSubscription(parent) {
	        var _this = _super.call(this) || this;
	        _this.parent = parent;
	        parent.count++;
	        return _this;
	    }
	    InnerRefCountSubscription.prototype.unsubscribe = function () {
	        var parent = this.parent;
	        if (!parent.closed && !this.closed) {
	            _super.prototype.unsubscribe.call(this);
	            parent.count -= 1;
	            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
	                parent.unsubscribe();
	            }
	        }
	    };
	    return InnerRefCountSubscription;
	}(Subscription));

	/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */
	var BehaviorSubject = /*@__PURE__*/ (function (_super) {
	    __extends$1(BehaviorSubject, _super);
	    function BehaviorSubject(_value) {
	        var _this = _super.call(this) || this;
	        _this._value = _value;
	        return _this;
	    }
	    Object.defineProperty(BehaviorSubject.prototype, "value", {
	        get: function () {
	            return this.getValue();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BehaviorSubject.prototype._subscribe = function (subscriber) {
	        var subscription = _super.prototype._subscribe.call(this, subscriber);
	        if (subscription && !subscription.closed) {
	            subscriber.next(this._value);
	        }
	        return subscription;
	    };
	    BehaviorSubject.prototype.getValue = function () {
	        if (this.hasError) {
	            throw this.thrownError;
	        }
	        else if (this.closed) {
	            throw new ObjectUnsubscribedError();
	        }
	        else {
	            return this._value;
	        }
	    };
	    BehaviorSubject.prototype.next = function (value) {
	        _super.prototype.next.call(this, this._value = value);
	    };
	    return BehaviorSubject;
	}(Subject));

	/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */
	var Action = /*@__PURE__*/ (function (_super) {
	    __extends$1(Action, _super);
	    function Action(scheduler, work) {
	        return _super.call(this) || this;
	    }
	    Action.prototype.schedule = function (state, delay) {
	        return this;
	    };
	    return Action;
	}(Subscription));

	/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */
	var AsyncAction = /*@__PURE__*/ (function (_super) {
	    __extends$1(AsyncAction, _super);
	    function AsyncAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        _this.pending = false;
	        return _this;
	    }
	    AsyncAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        if (this.closed) {
	            return this;
	        }
	        this.state = state;
	        var id = this.id;
	        var scheduler = this.scheduler;
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, delay);
	        }
	        this.pending = true;
	        this.delay = delay;
	        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
	        return this;
	    };
	    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        return setInterval(scheduler.flush.bind(scheduler, this), delay);
	    };
	    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        if (delay !== null && this.delay === delay && this.pending === false) {
	            return id;
	        }
	        clearInterval(id);
	        return undefined;
	    };
	    AsyncAction.prototype.execute = function (state, delay) {
	        if (this.closed) {
	            return new Error('executing a cancelled action');
	        }
	        this.pending = false;
	        var error = this._execute(state, delay);
	        if (error) {
	            return error;
	        }
	        else if (this.pending === false && this.id != null) {
	            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
	        }
	    };
	    AsyncAction.prototype._execute = function (state, delay) {
	        var errored = false;
	        var errorValue = undefined;
	        try {
	            this.work(state);
	        }
	        catch (e) {
	            errored = true;
	            errorValue = !!e && e || new Error(e);
	        }
	        if (errored) {
	            this.unsubscribe();
	            return errorValue;
	        }
	    };
	    AsyncAction.prototype._unsubscribe = function () {
	        var id = this.id;
	        var scheduler = this.scheduler;
	        var actions = scheduler.actions;
	        var index = actions.indexOf(this);
	        this.work = null;
	        this.state = null;
	        this.pending = false;
	        this.scheduler = null;
	        if (index !== -1) {
	            actions.splice(index, 1);
	        }
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, null);
	        }
	        this.delay = null;
	    };
	    return AsyncAction;
	}(Action));

	/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */
	var QueueAction = /*@__PURE__*/ (function (_super) {
	    __extends$1(QueueAction, _super);
	    function QueueAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        return _this;
	    }
	    QueueAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        if (delay > 0) {
	            return _super.prototype.schedule.call(this, state, delay);
	        }
	        this.delay = delay;
	        this.state = state;
	        this.scheduler.flush(this);
	        return this;
	    };
	    QueueAction.prototype.execute = function (state, delay) {
	        return (delay > 0 || this.closed) ?
	            _super.prototype.execute.call(this, state, delay) :
	            this._execute(state, delay);
	    };
	    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        return scheduler.flush(this);
	    };
	    return QueueAction;
	}(AsyncAction));

	var Scheduler = /*@__PURE__*/ (function () {
	    function Scheduler(SchedulerAction, now) {
	        if (now === void 0) {
	            now = Scheduler.now;
	        }
	        this.SchedulerAction = SchedulerAction;
	        this.now = now;
	    }
	    Scheduler.prototype.schedule = function (work, delay, state) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        return new this.SchedulerAction(this, work).schedule(state, delay);
	    };
	    Scheduler.now = function () { return Date.now(); };
	    return Scheduler;
	}());

	/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */
	var AsyncScheduler = /*@__PURE__*/ (function (_super) {
	    __extends$1(AsyncScheduler, _super);
	    function AsyncScheduler(SchedulerAction, now) {
	        if (now === void 0) {
	            now = Scheduler.now;
	        }
	        var _this = _super.call(this, SchedulerAction, function () {
	            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
	                return AsyncScheduler.delegate.now();
	            }
	            else {
	                return now();
	            }
	        }) || this;
	        _this.actions = [];
	        _this.active = false;
	        _this.scheduled = undefined;
	        return _this;
	    }
	    AsyncScheduler.prototype.schedule = function (work, delay, state) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
	            return AsyncScheduler.delegate.schedule(work, delay, state);
	        }
	        else {
	            return _super.prototype.schedule.call(this, work, delay, state);
	        }
	    };
	    AsyncScheduler.prototype.flush = function (action) {
	        var actions = this.actions;
	        if (this.active) {
	            actions.push(action);
	            return;
	        }
	        var error;
	        this.active = true;
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (action = actions.shift());
	        this.active = false;
	        if (error) {
	            while (action = actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsyncScheduler;
	}(Scheduler));

	/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
	var QueueScheduler = /*@__PURE__*/ (function (_super) {
	    __extends$1(QueueScheduler, _super);
	    function QueueScheduler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return QueueScheduler;
	}(AsyncScheduler));

	/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */
	var queueScheduler = /*@__PURE__*/ new QueueScheduler(QueueAction);
	var queue = queueScheduler;

	/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
	var EMPTY = /*@__PURE__*/ new Observable(function (subscriber) { return subscriber.complete(); });
	function empty(scheduler) {
	    return scheduler ? emptyScheduled(scheduler) : EMPTY;
	}
	function emptyScheduled(scheduler) {
	    return new Observable(function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
	}

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	function isScheduler(value) {
	    return value && typeof value.schedule === 'function';
	}

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	var subscribeToArray = function (array) {
	    return function (subscriber) {
	        for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
	            subscriber.next(array[i]);
	        }
	        subscriber.complete();
	    };
	};

	/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
	function scheduleArray(input, scheduler) {
	    return new Observable(function (subscriber) {
	        var sub = new Subscription();
	        var i = 0;
	        sub.add(scheduler.schedule(function () {
	            if (i === input.length) {
	                subscriber.complete();
	                return;
	            }
	            subscriber.next(input[i++]);
	            if (!subscriber.closed) {
	                sub.add(this.schedule());
	            }
	        }));
	        return sub;
	    });
	}

	/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */
	function fromArray(input, scheduler) {
	    if (!scheduler) {
	        return new Observable(subscribeToArray(input));
	    }
	    else {
	        return scheduleArray(input, scheduler);
	    }
	}

	/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */
	function of() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var scheduler = args[args.length - 1];
	    if (isScheduler(scheduler)) {
	        args.pop();
	        return scheduleArray(args, scheduler);
	    }
	    else {
	        return fromArray(args);
	    }
	}

	/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
	function throwError(error, scheduler) {
	    if (!scheduler) {
	        return new Observable(function (subscriber) { return subscriber.error(error); });
	    }
	    else {
	        return new Observable(function (subscriber) { return scheduler.schedule(dispatch$7, 0, { error: error, subscriber: subscriber }); });
	    }
	}
	function dispatch$7(_a) {
	    var error = _a.error, subscriber = _a.subscriber;
	    subscriber.error(error);
	}

	/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */
	var NotificationKind;
	/*@__PURE__*/ (function (NotificationKind) {
	    NotificationKind["NEXT"] = "N";
	    NotificationKind["ERROR"] = "E";
	    NotificationKind["COMPLETE"] = "C";
	})(NotificationKind || (NotificationKind = {}));
	var Notification = /*@__PURE__*/ (function () {
	    function Notification(kind, value, error) {
	        this.kind = kind;
	        this.value = value;
	        this.error = error;
	        this.hasValue = kind === 'N';
	    }
	    Notification.prototype.observe = function (observer) {
	        switch (this.kind) {
	            case 'N':
	                return observer.next && observer.next(this.value);
	            case 'E':
	                return observer.error && observer.error(this.error);
	            case 'C':
	                return observer.complete && observer.complete();
	        }
	    };
	    Notification.prototype.do = function (next, error, complete) {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return next && next(this.value);
	            case 'E':
	                return error && error(this.error);
	            case 'C':
	                return complete && complete();
	        }
	    };
	    Notification.prototype.accept = function (nextOrObserver, error, complete) {
	        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
	            return this.observe(nextOrObserver);
	        }
	        else {
	            return this.do(nextOrObserver, error, complete);
	        }
	    };
	    Notification.prototype.toObservable = function () {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return of(this.value);
	            case 'E':
	                return throwError(this.error);
	            case 'C':
	                return empty();
	        }
	        throw new Error('unexpected notification kind value');
	    };
	    Notification.createNext = function (value) {
	        if (typeof value !== 'undefined') {
	            return new Notification('N', value);
	        }
	        return Notification.undefinedValueNotification;
	    };
	    Notification.createError = function (err) {
	        return new Notification('E', undefined, err);
	    };
	    Notification.createComplete = function () {
	        return Notification.completeNotification;
	    };
	    Notification.completeNotification = new Notification('C');
	    Notification.undefinedValueNotification = new Notification('N', undefined);
	    return Notification;
	}());

	/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */
	function observeOn(scheduler, delay) {
	    if (delay === void 0) {
	        delay = 0;
	    }
	    return function observeOnOperatorFunction(source) {
	        return source.lift(new ObserveOnOperator(scheduler, delay));
	    };
	}
	var ObserveOnOperator = /*@__PURE__*/ (function () {
	    function ObserveOnOperator(scheduler, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
	    };
	    return ObserveOnOperator;
	}());
	var ObserveOnSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(ObserveOnSubscriber, _super);
	    function ObserveOnSubscriber(destination, scheduler, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        var _this = _super.call(this, destination) || this;
	        _this.scheduler = scheduler;
	        _this.delay = delay;
	        return _this;
	    }
	    ObserveOnSubscriber.dispatch = function (arg) {
	        var notification = arg.notification, destination = arg.destination;
	        notification.observe(destination);
	        this.unsubscribe();
	    };
	    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
	        var destination = this.destination;
	        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
	    };
	    ObserveOnSubscriber.prototype._next = function (value) {
	        this.scheduleMessage(Notification.createNext(value));
	    };
	    ObserveOnSubscriber.prototype._error = function (err) {
	        this.scheduleMessage(Notification.createError(err));
	        this.unsubscribe();
	    };
	    ObserveOnSubscriber.prototype._complete = function () {
	        this.scheduleMessage(Notification.createComplete());
	        this.unsubscribe();
	    };
	    return ObserveOnSubscriber;
	}(Subscriber));
	var ObserveOnMessage = /*@__PURE__*/ (function () {
	    function ObserveOnMessage(notification, destination) {
	        this.notification = notification;
	        this.destination = destination;
	    }
	    return ObserveOnMessage;
	}());

	/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */
	var ReplaySubject = /*@__PURE__*/ (function (_super) {
	    __extends$1(ReplaySubject, _super);
	    function ReplaySubject(bufferSize, windowTime, scheduler) {
	        if (bufferSize === void 0) {
	            bufferSize = Number.POSITIVE_INFINITY;
	        }
	        if (windowTime === void 0) {
	            windowTime = Number.POSITIVE_INFINITY;
	        }
	        var _this = _super.call(this) || this;
	        _this.scheduler = scheduler;
	        _this._events = [];
	        _this._infiniteTimeWindow = false;
	        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
	        _this._windowTime = windowTime < 1 ? 1 : windowTime;
	        if (windowTime === Number.POSITIVE_INFINITY) {
	            _this._infiniteTimeWindow = true;
	            _this.next = _this.nextInfiniteTimeWindow;
	        }
	        else {
	            _this.next = _this.nextTimeWindow;
	        }
	        return _this;
	    }
	    ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
	        if (!this.isStopped) {
	            var _events = this._events;
	            _events.push(value);
	            if (_events.length > this._bufferSize) {
	                _events.shift();
	            }
	        }
	        _super.prototype.next.call(this, value);
	    };
	    ReplaySubject.prototype.nextTimeWindow = function (value) {
	        if (!this.isStopped) {
	            this._events.push(new ReplayEvent(this._getNow(), value));
	            this._trimBufferThenGetEvents();
	        }
	        _super.prototype.next.call(this, value);
	    };
	    ReplaySubject.prototype._subscribe = function (subscriber) {
	        var _infiniteTimeWindow = this._infiniteTimeWindow;
	        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
	        var scheduler = this.scheduler;
	        var len = _events.length;
	        var subscription;
	        if (this.closed) {
	            throw new ObjectUnsubscribedError();
	        }
	        else if (this.isStopped || this.hasError) {
	            subscription = Subscription.EMPTY;
	        }
	        else {
	            this.observers.push(subscriber);
	            subscription = new SubjectSubscription(this, subscriber);
	        }
	        if (scheduler) {
	            subscriber.add(subscriber = new ObserveOnSubscriber(subscriber, scheduler));
	        }
	        if (_infiniteTimeWindow) {
	            for (var i = 0; i < len && !subscriber.closed; i++) {
	                subscriber.next(_events[i]);
	            }
	        }
	        else {
	            for (var i = 0; i < len && !subscriber.closed; i++) {
	                subscriber.next(_events[i].value);
	            }
	        }
	        if (this.hasError) {
	            subscriber.error(this.thrownError);
	        }
	        else if (this.isStopped) {
	            subscriber.complete();
	        }
	        return subscription;
	    };
	    ReplaySubject.prototype._getNow = function () {
	        return (this.scheduler || queue).now();
	    };
	    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
	        var now = this._getNow();
	        var _bufferSize = this._bufferSize;
	        var _windowTime = this._windowTime;
	        var _events = this._events;
	        var eventsCount = _events.length;
	        var spliceCount = 0;
	        while (spliceCount < eventsCount) {
	            if ((now - _events[spliceCount].time) < _windowTime) {
	                break;
	            }
	            spliceCount++;
	        }
	        if (eventsCount > _bufferSize) {
	            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
	        }
	        if (spliceCount > 0) {
	            _events.splice(0, spliceCount);
	        }
	        return _events;
	    };
	    return ReplaySubject;
	}(Subject));
	var ReplayEvent = /*@__PURE__*/ (function () {
	    function ReplayEvent(time, value) {
	        this.time = time;
	        this.value = value;
	    }
	    return ReplayEvent;
	}());

	/** PURE_IMPORTS_START tslib,_Subject,_Subscription PURE_IMPORTS_END */
	var AsyncSubject = /*@__PURE__*/ (function (_super) {
	    __extends$1(AsyncSubject, _super);
	    function AsyncSubject() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.value = null;
	        _this.hasNext = false;
	        _this.hasCompleted = false;
	        return _this;
	    }
	    AsyncSubject.prototype._subscribe = function (subscriber) {
	        if (this.hasError) {
	            subscriber.error(this.thrownError);
	            return Subscription.EMPTY;
	        }
	        else if (this.hasCompleted && this.hasNext) {
	            subscriber.next(this.value);
	            subscriber.complete();
	            return Subscription.EMPTY;
	        }
	        return _super.prototype._subscribe.call(this, subscriber);
	    };
	    AsyncSubject.prototype.next = function (value) {
	        if (!this.hasCompleted) {
	            this.value = value;
	            this.hasNext = true;
	        }
	    };
	    AsyncSubject.prototype.error = function (error) {
	        if (!this.hasCompleted) {
	            _super.prototype.error.call(this, error);
	        }
	    };
	    AsyncSubject.prototype.complete = function () {
	        this.hasCompleted = true;
	        if (this.hasNext) {
	            _super.prototype.next.call(this, this.value);
	        }
	        _super.prototype.complete.call(this);
	    };
	    return AsyncSubject;
	}(Subject));

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	var nextHandle = 1;
	var RESOLVED = /*@__PURE__*/ (function () { return /*@__PURE__*/ Promise.resolve(); })();
	var activeHandles = {};
	function findAndClearHandle(handle) {
	    if (handle in activeHandles) {
	        delete activeHandles[handle];
	        return true;
	    }
	    return false;
	}
	var Immediate = {
	    setImmediate: function (cb) {
	        var handle = nextHandle++;
	        activeHandles[handle] = true;
	        RESOLVED.then(function () { return findAndClearHandle(handle) && cb(); });
	        return handle;
	    },
	    clearImmediate: function (handle) {
	        findAndClearHandle(handle);
	    },
	};

	/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */
	var AsapAction = /*@__PURE__*/ (function (_super) {
	    __extends$1(AsapAction, _super);
	    function AsapAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        return _this;
	    }
	    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        scheduler.actions.push(this);
	        return scheduler.scheduled || (scheduler.scheduled = Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
	    };
	    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        if (scheduler.actions.length === 0) {
	            Immediate.clearImmediate(id);
	            scheduler.scheduled = undefined;
	        }
	        return undefined;
	    };
	    return AsapAction;
	}(AsyncAction));

	/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
	var AsapScheduler = /*@__PURE__*/ (function (_super) {
	    __extends$1(AsapScheduler, _super);
	    function AsapScheduler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AsapScheduler.prototype.flush = function (action) {
	        this.active = true;
	        this.scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        var index = -1;
	        var count = actions.length;
	        action = action || actions.shift();
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (++index < count && (action = actions.shift()));
	        this.active = false;
	        if (error) {
	            while (++index < count && (action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsapScheduler;
	}(AsyncScheduler));

	/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */
	var asapScheduler = /*@__PURE__*/ new AsapScheduler(AsapAction);
	var asap = asapScheduler;

	/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */
	var asyncScheduler = /*@__PURE__*/ new AsyncScheduler(AsyncAction);
	var async = asyncScheduler;

	/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */
	var AnimationFrameAction = /*@__PURE__*/ (function (_super) {
	    __extends$1(AnimationFrameAction, _super);
	    function AnimationFrameAction(scheduler, work) {
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        return _this;
	    }
	    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        scheduler.actions.push(this);
	        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function () { return scheduler.flush(null); }));
	    };
	    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        if (scheduler.actions.length === 0) {
	            cancelAnimationFrame(id);
	            scheduler.scheduled = undefined;
	        }
	        return undefined;
	    };
	    return AnimationFrameAction;
	}(AsyncAction));

	/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
	var AnimationFrameScheduler = /*@__PURE__*/ (function (_super) {
	    __extends$1(AnimationFrameScheduler, _super);
	    function AnimationFrameScheduler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    AnimationFrameScheduler.prototype.flush = function (action) {
	        this.active = true;
	        this.scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        var index = -1;
	        var count = actions.length;
	        action = action || actions.shift();
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (++index < count && (action = actions.shift()));
	        this.active = false;
	        if (error) {
	            while (++index < count && (action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AnimationFrameScheduler;
	}(AsyncScheduler));

	/** PURE_IMPORTS_START _AnimationFrameAction,_AnimationFrameScheduler PURE_IMPORTS_END */
	var animationFrameScheduler = /*@__PURE__*/ new AnimationFrameScheduler(AnimationFrameAction);
	var animationFrame = animationFrameScheduler;

	/** PURE_IMPORTS_START tslib,_AsyncAction,_AsyncScheduler PURE_IMPORTS_END */
	var VirtualTimeScheduler = /*@__PURE__*/ (function (_super) {
	    __extends$1(VirtualTimeScheduler, _super);
	    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
	        if (SchedulerAction === void 0) {
	            SchedulerAction = VirtualAction;
	        }
	        if (maxFrames === void 0) {
	            maxFrames = Number.POSITIVE_INFINITY;
	        }
	        var _this = _super.call(this, SchedulerAction, function () { return _this.frame; }) || this;
	        _this.maxFrames = maxFrames;
	        _this.frame = 0;
	        _this.index = -1;
	        return _this;
	    }
	    VirtualTimeScheduler.prototype.flush = function () {
	        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
	        var error, action;
	        while ((action = actions[0]) && action.delay <= maxFrames) {
	            actions.shift();
	            this.frame = action.delay;
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        }
	        if (error) {
	            while (action = actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    VirtualTimeScheduler.frameTimeFactor = 10;
	    return VirtualTimeScheduler;
	}(AsyncScheduler));
	var VirtualAction = /*@__PURE__*/ (function (_super) {
	    __extends$1(VirtualAction, _super);
	    function VirtualAction(scheduler, work, index) {
	        if (index === void 0) {
	            index = scheduler.index += 1;
	        }
	        var _this = _super.call(this, scheduler, work) || this;
	        _this.scheduler = scheduler;
	        _this.work = work;
	        _this.index = index;
	        _this.active = true;
	        _this.index = scheduler.index = index;
	        return _this;
	    }
	    VirtualAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        if (!this.id) {
	            return _super.prototype.schedule.call(this, state, delay);
	        }
	        this.active = false;
	        var action = new VirtualAction(this.scheduler, this.work);
	        this.add(action);
	        return action.schedule(state, delay);
	    };
	    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        this.delay = scheduler.frame + delay;
	        var actions = scheduler.actions;
	        actions.push(this);
	        actions.sort(VirtualAction.sortActions);
	        return true;
	    };
	    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        return undefined;
	    };
	    VirtualAction.prototype._execute = function (state, delay) {
	        if (this.active === true) {
	            return _super.prototype._execute.call(this, state, delay);
	        }
	    };
	    VirtualAction.sortActions = function (a, b) {
	        if (a.delay === b.delay) {
	            if (a.index === b.index) {
	                return 0;
	            }
	            else if (a.index > b.index) {
	                return 1;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (a.delay > b.delay) {
	            return 1;
	        }
	        else {
	            return -1;
	        }
	    };
	    return VirtualAction;
	}(AsyncAction));

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	function noop$1() { }

	/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
	function isObservable(obj) {
	    return !!obj && (obj instanceof Observable || (typeof obj.lift === 'function' && typeof obj.subscribe === 'function'));
	}

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	var ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ (function () {
	    function ArgumentOutOfRangeErrorImpl() {
	        Error.call(this);
	        this.message = 'argument out of range';
	        this.name = 'ArgumentOutOfRangeError';
	        return this;
	    }
	    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
	    return ArgumentOutOfRangeErrorImpl;
	})();
	var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	var EmptyErrorImpl = /*@__PURE__*/ (function () {
	    function EmptyErrorImpl() {
	        Error.call(this);
	        this.message = 'no elements in sequence';
	        this.name = 'EmptyError';
	        return this;
	    }
	    EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
	    return EmptyErrorImpl;
	})();
	var EmptyError = EmptyErrorImpl;

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	var TimeoutErrorImpl = /*@__PURE__*/ (function () {
	    function TimeoutErrorImpl() {
	        Error.call(this);
	        this.message = 'Timeout has occurred';
	        this.name = 'TimeoutError';
	        return this;
	    }
	    TimeoutErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
	    return TimeoutErrorImpl;
	})();
	var TimeoutError = TimeoutErrorImpl;

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function map(project, thisArg) {
	    return function mapOperation(source) {
	        if (typeof project !== 'function') {
	            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
	        }
	        return source.lift(new MapOperator(project, thisArg));
	    };
	}
	var MapOperator = /*@__PURE__*/ (function () {
	    function MapOperator(project, thisArg) {
	        this.project = project;
	        this.thisArg = thisArg;
	    }
	    MapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
	    };
	    return MapOperator;
	}());
	var MapSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(MapSubscriber, _super);
	    function MapSubscriber(destination, project, thisArg) {
	        var _this = _super.call(this, destination) || this;
	        _this.project = project;
	        _this.count = 0;
	        _this.thisArg = thisArg || _this;
	        return _this;
	    }
	    MapSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.project.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return MapSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isArray,_util_isScheduler PURE_IMPORTS_END */
	function bindCallback(callbackFunc, resultSelector, scheduler) {
	    if (resultSelector) {
	        if (isScheduler(resultSelector)) {
	            scheduler = resultSelector;
	        }
	        else {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe(map(function (args) { return isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
	            };
	        }
	    }
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var context = this;
	        var subject;
	        var params = {
	            context: context,
	            subject: subject,
	            callbackFunc: callbackFunc,
	            scheduler: scheduler,
	        };
	        return new Observable(function (subscriber) {
	            if (!scheduler) {
	                if (!subject) {
	                    subject = new AsyncSubject();
	                    var handler = function () {
	                        var innerArgs = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            innerArgs[_i] = arguments[_i];
	                        }
	                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
	                        subject.complete();
	                    };
	                    try {
	                        callbackFunc.apply(context, args.concat([handler]));
	                    }
	                    catch (err) {
	                        if (canReportError(subject)) {
	                            subject.error(err);
	                        }
	                        else {
	                            console.warn(err);
	                        }
	                    }
	                }
	                return subject.subscribe(subscriber);
	            }
	            else {
	                var state = {
	                    args: args, subscriber: subscriber, params: params,
	                };
	                return scheduler.schedule(dispatch$6, 0, state);
	            }
	        });
	    };
	}
	function dispatch$6(state) {
	    var _this = this;
	    var args = state.args, subscriber = state.subscriber, params = state.params;
	    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
	    var subject = params.subject;
	    if (!subject) {
	        subject = params.subject = new AsyncSubject();
	        var handler = function () {
	            var innerArgs = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                innerArgs[_i] = arguments[_i];
	            }
	            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
	            _this.add(scheduler.schedule(dispatchNext$3, 0, { value: value, subject: subject }));
	        };
	        try {
	            callbackFunc.apply(context, args.concat([handler]));
	        }
	        catch (err) {
	            subject.error(err);
	        }
	    }
	    this.add(subject.subscribe(subscriber));
	}
	function dispatchNext$3(state) {
	    var value = state.value, subject = state.subject;
	    subject.next(value);
	    subject.complete();
	}

	/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isScheduler,_util_isArray PURE_IMPORTS_END */
	function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
	    if (resultSelector) {
	        if (isScheduler(resultSelector)) {
	            scheduler = resultSelector;
	        }
	        else {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe(map(function (args) { return isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
	            };
	        }
	    }
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var params = {
	            subject: undefined,
	            args: args,
	            callbackFunc: callbackFunc,
	            scheduler: scheduler,
	            context: this,
	        };
	        return new Observable(function (subscriber) {
	            var context = params.context;
	            var subject = params.subject;
	            if (!scheduler) {
	                if (!subject) {
	                    subject = params.subject = new AsyncSubject();
	                    var handler = function () {
	                        var innerArgs = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            innerArgs[_i] = arguments[_i];
	                        }
	                        var err = innerArgs.shift();
	                        if (err) {
	                            subject.error(err);
	                            return;
	                        }
	                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
	                        subject.complete();
	                    };
	                    try {
	                        callbackFunc.apply(context, args.concat([handler]));
	                    }
	                    catch (err) {
	                        if (canReportError(subject)) {
	                            subject.error(err);
	                        }
	                        else {
	                            console.warn(err);
	                        }
	                    }
	                }
	                return subject.subscribe(subscriber);
	            }
	            else {
	                return scheduler.schedule(dispatch$5, 0, { params: params, subscriber: subscriber, context: context });
	            }
	        });
	    };
	}
	function dispatch$5(state) {
	    var _this = this;
	    var params = state.params, subscriber = state.subscriber, context = state.context;
	    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
	    var subject = params.subject;
	    if (!subject) {
	        subject = params.subject = new AsyncSubject();
	        var handler = function () {
	            var innerArgs = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                innerArgs[_i] = arguments[_i];
	            }
	            var err = innerArgs.shift();
	            if (err) {
	                _this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
	            }
	            else {
	                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
	                _this.add(scheduler.schedule(dispatchNext$2, 0, { value: value, subject: subject }));
	            }
	        };
	        try {
	            callbackFunc.apply(context, args.concat([handler]));
	        }
	        catch (err) {
	            this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
	        }
	    }
	    this.add(subject.subscribe(subscriber));
	}
	function dispatchNext$2(arg) {
	    var value = arg.value, subject = arg.subject;
	    subject.next(value);
	    subject.complete();
	}
	function dispatchError(arg) {
	    var err = arg.err, subject = arg.subject;
	    subject.error(err);
	}

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	var OuterSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(OuterSubscriber, _super);
	    function OuterSubscriber() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.destination.next(innerValue);
	    };
	    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
	        this.destination.error(error);
	    };
	    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.destination.complete();
	    };
	    return OuterSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	var InnerSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(InnerSubscriber, _super);
	    function InnerSubscriber(parent, outerValue, outerIndex) {
	        var _this = _super.call(this) || this;
	        _this.parent = parent;
	        _this.outerValue = outerValue;
	        _this.outerIndex = outerIndex;
	        _this.index = 0;
	        return _this;
	    }
	    InnerSubscriber.prototype._next = function (value) {
	        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
	    };
	    InnerSubscriber.prototype._error = function (error) {
	        this.parent.notifyError(error, this);
	        this.unsubscribe();
	    };
	    InnerSubscriber.prototype._complete = function () {
	        this.parent.notifyComplete(this);
	        this.unsubscribe();
	    };
	    return InnerSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */
	var subscribeToPromise = function (promise) {
	    return function (subscriber) {
	        promise.then(function (value) {
	            if (!subscriber.closed) {
	                subscriber.next(value);
	                subscriber.complete();
	            }
	        }, function (err) { return subscriber.error(err); })
	            .then(null, hostReportError);
	        return subscriber;
	    };
	};

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	function getSymbolIterator() {
	    if (typeof Symbol !== 'function' || !Symbol.iterator) {
	        return '@@iterator';
	    }
	    return Symbol.iterator;
	}
	var iterator = /*@__PURE__*/ getSymbolIterator();

	/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
	var subscribeToIterable = function (iterable) {
	    return function (subscriber) {
	        var iterator$1 = iterable[iterator]();
	        do {
	            var item = void 0;
	            try {
	                item = iterator$1.next();
	            }
	            catch (err) {
	                subscriber.error(err);
	                return subscriber;
	            }
	            if (item.done) {
	                subscriber.complete();
	                break;
	            }
	            subscriber.next(item.value);
	            if (subscriber.closed) {
	                break;
	            }
	        } while (true);
	        if (typeof iterator$1.return === 'function') {
	            subscriber.add(function () {
	                if (iterator$1.return) {
	                    iterator$1.return();
	                }
	            });
	        }
	        return subscriber;
	    };
	};

	/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
	var subscribeToObservable = function (obj) {
	    return function (subscriber) {
	        var obs = obj[observable]();
	        if (typeof obs.subscribe !== 'function') {
	            throw new TypeError('Provided object does not correctly implement Symbol.observable');
	        }
	        else {
	            return obs.subscribe(subscriber);
	        }
	    };
	};

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	function isPromise(value) {
	    return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
	}

	/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */
	var subscribeTo = function (result) {
	    if (!!result && typeof result[observable] === 'function') {
	        return subscribeToObservable(result);
	    }
	    else if (isArrayLike(result)) {
	        return subscribeToArray(result);
	    }
	    else if (isPromise(result)) {
	        return subscribeToPromise(result);
	    }
	    else if (!!result && typeof result[iterator] === 'function') {
	        return subscribeToIterable(result);
	    }
	    else {
	        var value = isObject$1(result) ? 'an invalid object' : "'" + result + "'";
	        var msg = "You provided " + value + " where a stream was expected."
	            + ' You can provide an Observable, Promise, Array, or Iterable.';
	        throw new TypeError(msg);
	    }
	};

	/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */
	function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
	    if (innerSubscriber === void 0) {
	        innerSubscriber = new InnerSubscriber(outerSubscriber, outerValue, outerIndex);
	    }
	    if (innerSubscriber.closed) {
	        return undefined;
	    }
	    if (result instanceof Observable) {
	        return result.subscribe(innerSubscriber);
	    }
	    return subscribeTo(result)(innerSubscriber);
	}

	/** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */
	var NONE = {};
	function combineLatest$1() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    var resultSelector = undefined;
	    var scheduler = undefined;
	    if (isScheduler(observables[observables.length - 1])) {
	        scheduler = observables.pop();
	    }
	    if (typeof observables[observables.length - 1] === 'function') {
	        resultSelector = observables.pop();
	    }
	    if (observables.length === 1 && isArray(observables[0])) {
	        observables = observables[0];
	    }
	    return fromArray(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
	}
	var CombineLatestOperator = /*@__PURE__*/ (function () {
	    function CombineLatestOperator(resultSelector) {
	        this.resultSelector = resultSelector;
	    }
	    CombineLatestOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
	    };
	    return CombineLatestOperator;
	}());
	var CombineLatestSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(CombineLatestSubscriber, _super);
	    function CombineLatestSubscriber(destination, resultSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.resultSelector = resultSelector;
	        _this.active = 0;
	        _this.values = [];
	        _this.observables = [];
	        return _this;
	    }
	    CombineLatestSubscriber.prototype._next = function (observable) {
	        this.values.push(NONE);
	        this.observables.push(observable);
	    };
	    CombineLatestSubscriber.prototype._complete = function () {
	        var observables = this.observables;
	        var len = observables.length;
	        if (len === 0) {
	            this.destination.complete();
	        }
	        else {
	            this.active = len;
	            this.toRespond = len;
	            for (var i = 0; i < len; i++) {
	                var observable = observables[i];
	                this.add(subscribeToResult(this, observable, undefined, i));
	            }
	        }
	    };
	    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
	        if ((this.active -= 1) === 0) {
	            this.destination.complete();
	        }
	    };
	    CombineLatestSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
	        var values = this.values;
	        var oldVal = values[outerIndex];
	        var toRespond = !this.toRespond
	            ? 0
	            : oldVal === NONE ? --this.toRespond : this.toRespond;
	        values[outerIndex] = innerValue;
	        if (toRespond === 0) {
	            if (this.resultSelector) {
	                this._tryResultSelector(values);
	            }
	            else {
	                this.destination.next(values.slice());
	            }
	        }
	    };
	    CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
	        var result;
	        try {
	            result = this.resultSelector.apply(this, values);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return CombineLatestSubscriber;
	}(OuterSubscriber));

	/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */
	function scheduleObservable(input, scheduler) {
	    return new Observable(function (subscriber) {
	        var sub = new Subscription();
	        sub.add(scheduler.schedule(function () {
	            var observable$1 = input[observable]();
	            sub.add(observable$1.subscribe({
	                next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
	                error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
	                complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
	            }));
	        }));
	        return sub;
	    });
	}

	/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
	function schedulePromise(input, scheduler) {
	    return new Observable(function (subscriber) {
	        var sub = new Subscription();
	        sub.add(scheduler.schedule(function () {
	            return input.then(function (value) {
	                sub.add(scheduler.schedule(function () {
	                    subscriber.next(value);
	                    sub.add(scheduler.schedule(function () { return subscriber.complete(); }));
	                }));
	            }, function (err) {
	                sub.add(scheduler.schedule(function () { return subscriber.error(err); }));
	            });
	        }));
	        return sub;
	    });
	}

	/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */
	function scheduleIterable(input, scheduler) {
	    if (!input) {
	        throw new Error('Iterable cannot be null');
	    }
	    return new Observable(function (subscriber) {
	        var sub = new Subscription();
	        var iterator$1;
	        sub.add(function () {
	            if (iterator$1 && typeof iterator$1.return === 'function') {
	                iterator$1.return();
	            }
	        });
	        sub.add(scheduler.schedule(function () {
	            iterator$1 = input[iterator]();
	            sub.add(scheduler.schedule(function () {
	                if (subscriber.closed) {
	                    return;
	                }
	                var value;
	                var done;
	                try {
	                    var result = iterator$1.next();
	                    value = result.value;
	                    done = result.done;
	                }
	                catch (err) {
	                    subscriber.error(err);
	                    return;
	                }
	                if (done) {
	                    subscriber.complete();
	                }
	                else {
	                    subscriber.next(value);
	                    this.schedule();
	                }
	            }));
	        }));
	        return sub;
	    });
	}

	/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
	function isInteropObservable(input) {
	    return input && typeof input[observable] === 'function';
	}

	/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
	function isIterable(input) {
	    return input && typeof input[iterator] === 'function';
	}

	/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */
	function scheduled(input, scheduler) {
	    if (input != null) {
	        if (isInteropObservable(input)) {
	            return scheduleObservable(input, scheduler);
	        }
	        else if (isPromise(input)) {
	            return schedulePromise(input, scheduler);
	        }
	        else if (isArrayLike(input)) {
	            return scheduleArray(input, scheduler);
	        }
	        else if (isIterable(input) || typeof input === 'string') {
	            return scheduleIterable(input, scheduler);
	        }
	    }
	    throw new TypeError((input !== null && typeof input || input) + ' is not observable');
	}

	/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */
	function from(input, scheduler) {
	    if (!scheduler) {
	        if (input instanceof Observable) {
	            return input;
	        }
	        return new Observable(subscribeTo(input));
	    }
	    else {
	        return scheduled(input, scheduler);
	    }
	}

	/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */
	var SimpleInnerSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SimpleInnerSubscriber, _super);
	    function SimpleInnerSubscriber(parent) {
	        var _this = _super.call(this) || this;
	        _this.parent = parent;
	        return _this;
	    }
	    SimpleInnerSubscriber.prototype._next = function (value) {
	        this.parent.notifyNext(value);
	    };
	    SimpleInnerSubscriber.prototype._error = function (error) {
	        this.parent.notifyError(error);
	        this.unsubscribe();
	    };
	    SimpleInnerSubscriber.prototype._complete = function () {
	        this.parent.notifyComplete();
	        this.unsubscribe();
	    };
	    return SimpleInnerSubscriber;
	}(Subscriber));
	var SimpleOuterSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SimpleOuterSubscriber, _super);
	    function SimpleOuterSubscriber() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SimpleOuterSubscriber.prototype.notifyNext = function (innerValue) {
	        this.destination.next(innerValue);
	    };
	    SimpleOuterSubscriber.prototype.notifyError = function (err) {
	        this.destination.error(err);
	    };
	    SimpleOuterSubscriber.prototype.notifyComplete = function () {
	        this.destination.complete();
	    };
	    return SimpleOuterSubscriber;
	}(Subscriber));
	function innerSubscribe(result, innerSubscriber) {
	    if (innerSubscriber.closed) {
	        return undefined;
	    }
	    if (result instanceof Observable) {
	        return result.subscribe(innerSubscriber);
	    }
	    var subscription;
	    try {
	        subscription = subscribeTo(result)(innerSubscriber);
	    }
	    catch (error) {
	        innerSubscriber.error(error);
	    }
	    return subscription;
	}

	/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) {
	        concurrent = Number.POSITIVE_INFINITY;
	    }
	    if (typeof resultSelector === 'function') {
	        return function (source) { return source.pipe(mergeMap(function (a, i) { return from(project(a, i)).pipe(map(function (b, ii) { return resultSelector(a, b, i, ii); })); }, concurrent)); };
	    }
	    else if (typeof resultSelector === 'number') {
	        concurrent = resultSelector;
	    }
	    return function (source) { return source.lift(new MergeMapOperator(project, concurrent)); };
	}
	var MergeMapOperator = /*@__PURE__*/ (function () {
	    function MergeMapOperator(project, concurrent) {
	        if (concurrent === void 0) {
	            concurrent = Number.POSITIVE_INFINITY;
	        }
	        this.project = project;
	        this.concurrent = concurrent;
	    }
	    MergeMapOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
	    };
	    return MergeMapOperator;
	}());
	var MergeMapSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(MergeMapSubscriber, _super);
	    function MergeMapSubscriber(destination, project, concurrent) {
	        if (concurrent === void 0) {
	            concurrent = Number.POSITIVE_INFINITY;
	        }
	        var _this = _super.call(this, destination) || this;
	        _this.project = project;
	        _this.concurrent = concurrent;
	        _this.hasCompleted = false;
	        _this.buffer = [];
	        _this.active = 0;
	        _this.index = 0;
	        return _this;
	    }
	    MergeMapSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            this._tryNext(value);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeMapSubscriber.prototype._tryNext = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.active++;
	        this._innerSub(result);
	    };
	    MergeMapSubscriber.prototype._innerSub = function (ish) {
	        var innerSubscriber = new SimpleInnerSubscriber(this);
	        var destination = this.destination;
	        destination.add(innerSubscriber);
	        var innerSubscription = innerSubscribe(ish, innerSubscriber);
	        if (innerSubscription !== innerSubscriber) {
	            destination.add(innerSubscription);
	        }
	    };
	    MergeMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            this.destination.complete();
	        }
	        this.unsubscribe();
	    };
	    MergeMapSubscriber.prototype.notifyNext = function (innerValue) {
	        this.destination.next(innerValue);
	    };
	    MergeMapSubscriber.prototype.notifyComplete = function () {
	        var buffer = this.buffer;
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return MergeMapSubscriber;
	}(SimpleOuterSubscriber));
	var flatMap = mergeMap;

	/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */
	function mergeAll(concurrent) {
	    if (concurrent === void 0) {
	        concurrent = Number.POSITIVE_INFINITY;
	    }
	    return mergeMap(identity, concurrent);
	}

	/** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */
	function concatAll() {
	    return mergeAll(1);
	}

	/** PURE_IMPORTS_START _of,_operators_concatAll PURE_IMPORTS_END */
	function concat$1() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    return concatAll()(of.apply(void 0, observables));
	}

	/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */
	function defer(observableFactory) {
	    return new Observable(function (subscriber) {
	        var input;
	        try {
	            input = observableFactory();
	        }
	        catch (err) {
	            subscriber.error(err);
	            return undefined;
	        }
	        var source = input ? from(input) : empty();
	        return source.subscribe(subscriber);
	    });
	}

	/** PURE_IMPORTS_START _Observable,_util_isArray,_operators_map,_util_isObject,_from PURE_IMPORTS_END */
	function forkJoin() {
	    var sources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sources[_i] = arguments[_i];
	    }
	    if (sources.length === 1) {
	        var first_1 = sources[0];
	        if (isArray(first_1)) {
	            return forkJoinInternal(first_1, null);
	        }
	        if (isObject$1(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
	            var keys = Object.keys(first_1);
	            return forkJoinInternal(keys.map(function (key) { return first_1[key]; }), keys);
	        }
	    }
	    if (typeof sources[sources.length - 1] === 'function') {
	        var resultSelector_1 = sources.pop();
	        sources = (sources.length === 1 && isArray(sources[0])) ? sources[0] : sources;
	        return forkJoinInternal(sources, null).pipe(map(function (args) { return resultSelector_1.apply(void 0, args); }));
	    }
	    return forkJoinInternal(sources, null);
	}
	function forkJoinInternal(sources, keys) {
	    return new Observable(function (subscriber) {
	        var len = sources.length;
	        if (len === 0) {
	            subscriber.complete();
	            return;
	        }
	        var values = new Array(len);
	        var completed = 0;
	        var emitted = 0;
	        var _loop_1 = function (i) {
	            var source = from(sources[i]);
	            var hasValue = false;
	            subscriber.add(source.subscribe({
	                next: function (value) {
	                    if (!hasValue) {
	                        hasValue = true;
	                        emitted++;
	                    }
	                    values[i] = value;
	                },
	                error: function (err) { return subscriber.error(err); },
	                complete: function () {
	                    completed++;
	                    if (completed === len || !hasValue) {
	                        if (emitted === len) {
	                            subscriber.next(keys ?
	                                keys.reduce(function (result, key, i) { return (result[key] = values[i], result); }, {}) :
	                                values);
	                        }
	                        subscriber.complete();
	                    }
	                }
	            }));
	        };
	        for (var i = 0; i < len; i++) {
	            _loop_1(i);
	        }
	    });
	}

	/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */
	function fromEvent(target, eventName, options, resultSelector) {
	    if (isFunction$1(options)) {
	        resultSelector = options;
	        options = undefined;
	    }
	    if (resultSelector) {
	        return fromEvent(target, eventName, options).pipe(map(function (args) { return isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
	    }
	    return new Observable(function (subscriber) {
	        function handler(e) {
	            if (arguments.length > 1) {
	                subscriber.next(Array.prototype.slice.call(arguments));
	            }
	            else {
	                subscriber.next(e);
	            }
	        }
	        setupSubscription(target, eventName, handler, subscriber, options);
	    });
	}
	function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
	    var unsubscribe;
	    if (isEventTarget(sourceObj)) {
	        var source_1 = sourceObj;
	        sourceObj.addEventListener(eventName, handler, options);
	        unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
	    }
	    else if (isJQueryStyleEventEmitter(sourceObj)) {
	        var source_2 = sourceObj;
	        sourceObj.on(eventName, handler);
	        unsubscribe = function () { return source_2.off(eventName, handler); };
	    }
	    else if (isNodeStyleEventEmitter(sourceObj)) {
	        var source_3 = sourceObj;
	        sourceObj.addListener(eventName, handler);
	        unsubscribe = function () { return source_3.removeListener(eventName, handler); };
	    }
	    else if (sourceObj && sourceObj.length) {
	        for (var i = 0, len = sourceObj.length; i < len; i++) {
	            setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
	        }
	    }
	    else {
	        throw new TypeError('Invalid event target');
	    }
	    subscriber.add(unsubscribe);
	}
	function isNodeStyleEventEmitter(sourceObj) {
	    return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
	}
	function isJQueryStyleEventEmitter(sourceObj) {
	    return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
	}
	function isEventTarget(sourceObj) {
	    return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
	}

	/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */
	function fromEventPattern(addHandler, removeHandler, resultSelector) {
	    if (resultSelector) {
	        return fromEventPattern(addHandler, removeHandler).pipe(map(function (args) { return isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
	    }
	    return new Observable(function (subscriber) {
	        var handler = function () {
	            var e = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                e[_i] = arguments[_i];
	            }
	            return subscriber.next(e.length === 1 ? e[0] : e);
	        };
	        var retValue;
	        try {
	            retValue = addHandler(handler);
	        }
	        catch (err) {
	            subscriber.error(err);
	            return undefined;
	        }
	        if (!isFunction$1(removeHandler)) {
	            return undefined;
	        }
	        return function () { return removeHandler(handler, retValue); };
	    });
	}

	/** PURE_IMPORTS_START _Observable,_util_identity,_util_isScheduler PURE_IMPORTS_END */
	function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
	    var resultSelector;
	    var initialState;
	    if (arguments.length == 1) {
	        var options = initialStateOrOptions;
	        initialState = options.initialState;
	        condition = options.condition;
	        iterate = options.iterate;
	        resultSelector = options.resultSelector || identity;
	        scheduler = options.scheduler;
	    }
	    else if (resultSelectorOrObservable === undefined || isScheduler(resultSelectorOrObservable)) {
	        initialState = initialStateOrOptions;
	        resultSelector = identity;
	        scheduler = resultSelectorOrObservable;
	    }
	    else {
	        initialState = initialStateOrOptions;
	        resultSelector = resultSelectorOrObservable;
	    }
	    return new Observable(function (subscriber) {
	        var state = initialState;
	        if (scheduler) {
	            return scheduler.schedule(dispatch$4, 0, {
	                subscriber: subscriber,
	                iterate: iterate,
	                condition: condition,
	                resultSelector: resultSelector,
	                state: state
	            });
	        }
	        do {
	            if (condition) {
	                var conditionResult = void 0;
	                try {
	                    conditionResult = condition(state);
	                }
	                catch (err) {
	                    subscriber.error(err);
	                    return undefined;
	                }
	                if (!conditionResult) {
	                    subscriber.complete();
	                    break;
	                }
	            }
	            var value = void 0;
	            try {
	                value = resultSelector(state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return undefined;
	            }
	            subscriber.next(value);
	            if (subscriber.closed) {
	                break;
	            }
	            try {
	                state = iterate(state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return undefined;
	            }
	        } while (true);
	        return undefined;
	    });
	}
	function dispatch$4(state) {
	    var subscriber = state.subscriber, condition = state.condition;
	    if (subscriber.closed) {
	        return undefined;
	    }
	    if (state.needIterate) {
	        try {
	            state.state = state.iterate(state.state);
	        }
	        catch (err) {
	            subscriber.error(err);
	            return undefined;
	        }
	    }
	    else {
	        state.needIterate = true;
	    }
	    if (condition) {
	        var conditionResult = void 0;
	        try {
	            conditionResult = condition(state.state);
	        }
	        catch (err) {
	            subscriber.error(err);
	            return undefined;
	        }
	        if (!conditionResult) {
	            subscriber.complete();
	            return undefined;
	        }
	        if (subscriber.closed) {
	            return undefined;
	        }
	    }
	    var value;
	    try {
	        value = state.resultSelector(state.state);
	    }
	    catch (err) {
	        subscriber.error(err);
	        return undefined;
	    }
	    if (subscriber.closed) {
	        return undefined;
	    }
	    subscriber.next(value);
	    if (subscriber.closed) {
	        return undefined;
	    }
	    return this.schedule(state);
	}

	/** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */
	function iif(condition, trueResult, falseResult) {
	    if (trueResult === void 0) {
	        trueResult = EMPTY;
	    }
	    if (falseResult === void 0) {
	        falseResult = EMPTY;
	    }
	    return defer(function () { return condition() ? trueResult : falseResult; });
	}

	/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */
	function isNumeric(val) {
	    return !isArray(val) && (val - parseFloat(val) + 1) >= 0;
	}

	/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */
	function interval(period, scheduler) {
	    if (period === void 0) {
	        period = 0;
	    }
	    if (scheduler === void 0) {
	        scheduler = async;
	    }
	    if (!isNumeric(period) || period < 0) {
	        period = 0;
	    }
	    if (!scheduler || typeof scheduler.schedule !== 'function') {
	        scheduler = async;
	    }
	    return new Observable(function (subscriber) {
	        subscriber.add(scheduler.schedule(dispatch$3, period, { subscriber: subscriber, counter: 0, period: period }));
	        return subscriber;
	    });
	}
	function dispatch$3(state) {
	    var subscriber = state.subscriber, counter = state.counter, period = state.period;
	    subscriber.next(counter);
	    this.schedule({ subscriber: subscriber, counter: counter + 1, period: period }, period);
	}

	/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */
	function merge$1() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    var concurrent = Number.POSITIVE_INFINITY;
	    var scheduler = null;
	    var last = observables[observables.length - 1];
	    if (isScheduler(last)) {
	        scheduler = observables.pop();
	        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
	            concurrent = observables.pop();
	        }
	    }
	    else if (typeof last === 'number') {
	        concurrent = observables.pop();
	    }
	    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable) {
	        return observables[0];
	    }
	    return mergeAll(concurrent)(fromArray(observables, scheduler));
	}

	/** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */
	var NEVER = /*@__PURE__*/ new Observable(noop$1);
	function never() {
	    return NEVER;
	}

	/** PURE_IMPORTS_START _Observable,_from,_util_isArray,_empty PURE_IMPORTS_END */
	function onErrorResumeNext$1() {
	    var sources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sources[_i] = arguments[_i];
	    }
	    if (sources.length === 0) {
	        return EMPTY;
	    }
	    var first = sources[0], remainder = sources.slice(1);
	    if (sources.length === 1 && isArray(first)) {
	        return onErrorResumeNext$1.apply(void 0, first);
	    }
	    return new Observable(function (subscriber) {
	        var subNext = function () { return subscriber.add(onErrorResumeNext$1.apply(void 0, remainder).subscribe(subscriber)); };
	        return from(first).subscribe({
	            next: function (value) { subscriber.next(value); },
	            error: subNext,
	            complete: subNext,
	        });
	    });
	}

	/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
	function pairs(obj, scheduler) {
	    if (!scheduler) {
	        return new Observable(function (subscriber) {
	            var keys = Object.keys(obj);
	            for (var i = 0; i < keys.length && !subscriber.closed; i++) {
	                var key = keys[i];
	                if (obj.hasOwnProperty(key)) {
	                    subscriber.next([key, obj[key]]);
	                }
	            }
	            subscriber.complete();
	        });
	    }
	    else {
	        return new Observable(function (subscriber) {
	            var keys = Object.keys(obj);
	            var subscription = new Subscription();
	            subscription.add(scheduler.schedule(dispatch$2, 0, { keys: keys, index: 0, subscriber: subscriber, subscription: subscription, obj: obj }));
	            return subscription;
	        });
	    }
	}
	function dispatch$2(state) {
	    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
	    if (!subscriber.closed) {
	        if (index < keys.length) {
	            var key = keys[index];
	            subscriber.next([key, obj[key]]);
	            subscription.add(this.schedule({ keys: keys, index: index + 1, subscriber: subscriber, subscription: subscription, obj: obj }));
	        }
	        else {
	            subscriber.complete();
	        }
	    }
	}

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	function not(pred, thisArg) {
	    function notPred() {
	        return !(notPred.pred.apply(notPred.thisArg, arguments));
	    }
	    notPred.pred = pred;
	    notPred.thisArg = thisArg;
	    return notPred;
	}

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function filter(predicate, thisArg) {
	    return function filterOperatorFunction(source) {
	        return source.lift(new FilterOperator(predicate, thisArg));
	    };
	}
	var FilterOperator = /*@__PURE__*/ (function () {
	    function FilterOperator(predicate, thisArg) {
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	    }
	    FilterOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
	    };
	    return FilterOperator;
	}());
	var FilterSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(FilterSubscriber, _super);
	    function FilterSubscriber(destination, predicate, thisArg) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.thisArg = thisArg;
	        _this.count = 0;
	        return _this;
	    }
	    FilterSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.predicate.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this.destination.next(value);
	        }
	    };
	    return FilterSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START _util_not,_util_subscribeTo,_operators_filter,_Observable PURE_IMPORTS_END */
	function partition$1(source, predicate, thisArg) {
	    return [
	        filter(predicate, thisArg)(new Observable(subscribeTo(source))),
	        filter(not(predicate, thisArg))(new Observable(subscribeTo(source)))
	    ];
	}

	/** PURE_IMPORTS_START tslib,_util_isArray,_fromArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
	function race$1() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    if (observables.length === 1) {
	        if (isArray(observables[0])) {
	            observables = observables[0];
	        }
	        else {
	            return observables[0];
	        }
	    }
	    return fromArray(observables, undefined).lift(new RaceOperator());
	}
	var RaceOperator = /*@__PURE__*/ (function () {
	    function RaceOperator() {
	    }
	    RaceOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RaceSubscriber(subscriber));
	    };
	    return RaceOperator;
	}());
	var RaceSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(RaceSubscriber, _super);
	    function RaceSubscriber(destination) {
	        var _this = _super.call(this, destination) || this;
	        _this.hasFirst = false;
	        _this.observables = [];
	        _this.subscriptions = [];
	        return _this;
	    }
	    RaceSubscriber.prototype._next = function (observable) {
	        this.observables.push(observable);
	    };
	    RaceSubscriber.prototype._complete = function () {
	        var observables = this.observables;
	        var len = observables.length;
	        if (len === 0) {
	            this.destination.complete();
	        }
	        else {
	            for (var i = 0; i < len && !this.hasFirst; i++) {
	                var observable = observables[i];
	                var subscription = subscribeToResult(this, observable, undefined, i);
	                if (this.subscriptions) {
	                    this.subscriptions.push(subscription);
	                }
	                this.add(subscription);
	            }
	            this.observables = null;
	        }
	    };
	    RaceSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
	        if (!this.hasFirst) {
	            this.hasFirst = true;
	            for (var i = 0; i < this.subscriptions.length; i++) {
	                if (i !== outerIndex) {
	                    var subscription = this.subscriptions[i];
	                    subscription.unsubscribe();
	                    this.remove(subscription);
	                }
	            }
	            this.subscriptions = null;
	        }
	        this.destination.next(innerValue);
	    };
	    return RaceSubscriber;
	}(OuterSubscriber));

	/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
	function range(start, count, scheduler) {
	    if (start === void 0) {
	        start = 0;
	    }
	    return new Observable(function (subscriber) {
	        if (count === undefined) {
	            count = start;
	            start = 0;
	        }
	        var index = 0;
	        var current = start;
	        if (scheduler) {
	            return scheduler.schedule(dispatch$1, 0, {
	                index: index, count: count, start: start, subscriber: subscriber
	            });
	        }
	        else {
	            do {
	                if (index++ >= count) {
	                    subscriber.complete();
	                    break;
	                }
	                subscriber.next(current++);
	                if (subscriber.closed) {
	                    break;
	                }
	            } while (true);
	        }
	        return undefined;
	    });
	}
	function dispatch$1(state) {
	    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
	    if (index >= count) {
	        subscriber.complete();
	        return;
	    }
	    subscriber.next(start);
	    if (subscriber.closed) {
	        return;
	    }
	    state.index = index + 1;
	    state.start = start + 1;
	    this.schedule(state);
	}

	/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */
	function timer(dueTime, periodOrScheduler, scheduler) {
	    if (dueTime === void 0) {
	        dueTime = 0;
	    }
	    var period = -1;
	    if (isNumeric(periodOrScheduler)) {
	        period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
	    }
	    else if (isScheduler(periodOrScheduler)) {
	        scheduler = periodOrScheduler;
	    }
	    if (!isScheduler(scheduler)) {
	        scheduler = async;
	    }
	    return new Observable(function (subscriber) {
	        var due = isNumeric(dueTime)
	            ? dueTime
	            : (+dueTime - scheduler.now());
	        return scheduler.schedule(dispatch, due, {
	            index: 0, period: period, subscriber: subscriber
	        });
	    });
	}
	function dispatch(state) {
	    var index = state.index, period = state.period, subscriber = state.subscriber;
	    subscriber.next(index);
	    if (subscriber.closed) {
	        return;
	    }
	    else if (period === -1) {
	        return subscriber.complete();
	    }
	    state.index = index + 1;
	    this.schedule(state, period);
	}

	/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */
	function using(resourceFactory, observableFactory) {
	    return new Observable(function (subscriber) {
	        var resource;
	        try {
	            resource = resourceFactory();
	        }
	        catch (err) {
	            subscriber.error(err);
	            return undefined;
	        }
	        var result;
	        try {
	            result = observableFactory(resource);
	        }
	        catch (err) {
	            subscriber.error(err);
	            return undefined;
	        }
	        var source = result ? from(result) : EMPTY;
	        var subscription = source.subscribe(subscriber);
	        return function () {
	            subscription.unsubscribe();
	            if (resource) {
	                resource.unsubscribe();
	            }
	        };
	    });
	}

	/** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_.._internal_symbol_iterator,_innerSubscribe PURE_IMPORTS_END */
	function zip$1() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    var resultSelector = observables[observables.length - 1];
	    if (typeof resultSelector === 'function') {
	        observables.pop();
	    }
	    return fromArray(observables, undefined).lift(new ZipOperator(resultSelector));
	}
	var ZipOperator = /*@__PURE__*/ (function () {
	    function ZipOperator(resultSelector) {
	        this.resultSelector = resultSelector;
	    }
	    ZipOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
	    };
	    return ZipOperator;
	}());
	var ZipSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(ZipSubscriber, _super);
	    function ZipSubscriber(destination, resultSelector, values) {
	        var _this = _super.call(this, destination) || this;
	        _this.resultSelector = resultSelector;
	        _this.iterators = [];
	        _this.active = 0;
	        _this.resultSelector = (typeof resultSelector === 'function') ? resultSelector : undefined;
	        return _this;
	    }
	    ZipSubscriber.prototype._next = function (value) {
	        var iterators = this.iterators;
	        if (isArray(value)) {
	            iterators.push(new StaticArrayIterator(value));
	        }
	        else if (typeof value[iterator] === 'function') {
	            iterators.push(new StaticIterator(value[iterator]()));
	        }
	        else {
	            iterators.push(new ZipBufferIterator(this.destination, this, value));
	        }
	    };
	    ZipSubscriber.prototype._complete = function () {
	        var iterators = this.iterators;
	        var len = iterators.length;
	        this.unsubscribe();
	        if (len === 0) {
	            this.destination.complete();
	            return;
	        }
	        this.active = len;
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            if (iterator.stillUnsubscribed) {
	                var destination = this.destination;
	                destination.add(iterator.subscribe());
	            }
	            else {
	                this.active--;
	            }
	        }
	    };
	    ZipSubscriber.prototype.notifyInactive = function () {
	        this.active--;
	        if (this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    ZipSubscriber.prototype.checkIterators = function () {
	        var iterators = this.iterators;
	        var len = iterators.length;
	        var destination = this.destination;
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
	                return;
	            }
	        }
	        var shouldComplete = false;
	        var args = [];
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            var result = iterator.next();
	            if (iterator.hasCompleted()) {
	                shouldComplete = true;
	            }
	            if (result.done) {
	                destination.complete();
	                return;
	            }
	            args.push(result.value);
	        }
	        if (this.resultSelector) {
	            this._tryresultSelector(args);
	        }
	        else {
	            destination.next(args);
	        }
	        if (shouldComplete) {
	            destination.complete();
	        }
	    };
	    ZipSubscriber.prototype._tryresultSelector = function (args) {
	        var result;
	        try {
	            result = this.resultSelector.apply(this, args);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return ZipSubscriber;
	}(Subscriber));
	var StaticIterator = /*@__PURE__*/ (function () {
	    function StaticIterator(iterator) {
	        this.iterator = iterator;
	        this.nextResult = iterator.next();
	    }
	    StaticIterator.prototype.hasValue = function () {
	        return true;
	    };
	    StaticIterator.prototype.next = function () {
	        var result = this.nextResult;
	        this.nextResult = this.iterator.next();
	        return result;
	    };
	    StaticIterator.prototype.hasCompleted = function () {
	        var nextResult = this.nextResult;
	        return Boolean(nextResult && nextResult.done);
	    };
	    return StaticIterator;
	}());
	var StaticArrayIterator = /*@__PURE__*/ (function () {
	    function StaticArrayIterator(array) {
	        this.array = array;
	        this.index = 0;
	        this.length = 0;
	        this.length = array.length;
	    }
	    StaticArrayIterator.prototype[iterator] = function () {
	        return this;
	    };
	    StaticArrayIterator.prototype.next = function (value) {
	        var i = this.index++;
	        var array = this.array;
	        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
	    };
	    StaticArrayIterator.prototype.hasValue = function () {
	        return this.array.length > this.index;
	    };
	    StaticArrayIterator.prototype.hasCompleted = function () {
	        return this.array.length === this.index;
	    };
	    return StaticArrayIterator;
	}());
	var ZipBufferIterator = /*@__PURE__*/ (function (_super) {
	    __extends$1(ZipBufferIterator, _super);
	    function ZipBufferIterator(destination, parent, observable) {
	        var _this = _super.call(this, destination) || this;
	        _this.parent = parent;
	        _this.observable = observable;
	        _this.stillUnsubscribed = true;
	        _this.buffer = [];
	        _this.isComplete = false;
	        return _this;
	    }
	    ZipBufferIterator.prototype[iterator] = function () {
	        return this;
	    };
	    ZipBufferIterator.prototype.next = function () {
	        var buffer = this.buffer;
	        if (buffer.length === 0 && this.isComplete) {
	            return { value: null, done: true };
	        }
	        else {
	            return { value: buffer.shift(), done: false };
	        }
	    };
	    ZipBufferIterator.prototype.hasValue = function () {
	        return this.buffer.length > 0;
	    };
	    ZipBufferIterator.prototype.hasCompleted = function () {
	        return this.buffer.length === 0 && this.isComplete;
	    };
	    ZipBufferIterator.prototype.notifyComplete = function () {
	        if (this.buffer.length > 0) {
	            this.isComplete = true;
	            this.parent.notifyInactive();
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    ZipBufferIterator.prototype.notifyNext = function (innerValue) {
	        this.buffer.push(innerValue);
	        this.parent.checkIterators();
	    };
	    ZipBufferIterator.prototype.subscribe = function () {
	        return innerSubscribe(this.observable, new SimpleInnerSubscriber(this));
	    };
	    return ZipBufferIterator;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */

	var _esm5 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		ArgumentOutOfRangeError: ArgumentOutOfRangeError,
		AsyncSubject: AsyncSubject,
		BehaviorSubject: BehaviorSubject,
		ConnectableObservable: ConnectableObservable,
		EMPTY: EMPTY,
		EmptyError: EmptyError,
		GroupedObservable: GroupedObservable,
		NEVER: NEVER,
		Notification: Notification,
		get NotificationKind () { return NotificationKind; },
		ObjectUnsubscribedError: ObjectUnsubscribedError,
		Observable: Observable,
		ReplaySubject: ReplaySubject,
		Scheduler: Scheduler,
		Subject: Subject,
		Subscriber: Subscriber,
		Subscription: Subscription,
		TimeoutError: TimeoutError,
		UnsubscriptionError: UnsubscriptionError,
		VirtualAction: VirtualAction,
		VirtualTimeScheduler: VirtualTimeScheduler,
		animationFrame: animationFrame,
		animationFrameScheduler: animationFrameScheduler,
		asap: asap,
		asapScheduler: asapScheduler,
		async: async,
		asyncScheduler: asyncScheduler,
		bindCallback: bindCallback,
		bindNodeCallback: bindNodeCallback,
		combineLatest: combineLatest$1,
		concat: concat$1,
		config: config,
		defer: defer,
		empty: empty,
		forkJoin: forkJoin,
		from: from,
		fromEvent: fromEvent,
		fromEventPattern: fromEventPattern,
		generate: generate,
		identity: identity,
		iif: iif,
		interval: interval,
		isObservable: isObservable,
		merge: merge$1,
		never: never,
		noop: noop$1,
		observable: observable,
		of: of,
		onErrorResumeNext: onErrorResumeNext$1,
		pairs: pairs,
		partition: partition$1,
		pipe: pipe,
		queue: queue,
		queueScheduler: queueScheduler,
		race: race$1,
		range: range,
		scheduled: scheduled,
		throwError: throwError,
		timer: timer,
		using: using,
		zip: zip$1
	});

	var require$$1 = /*@__PURE__*/getAugmentedNamespace(_esm5);

	var ConnectDialog$1 = {};

	function r$5(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r$5(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r$5(e))&&(n&&(n+=" "),n+=t);return n}

	var clsx_m = /*#__PURE__*/Object.freeze({
		__proto__: null,
		clsx: clsx,
		default: clsx
	});

	var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(clsx_m);

	var t$5,r$4,u$4,i$6,o$5=0,f$2=[],c$5=[],e$6=l$7.__b,a$3=l$7.__r,v$3=l$7.diffed,l$6=l$7.__c,m$3=l$7.unmount;function d$5(t,u){l$7.__h&&l$7.__h(r$4,t,o$5||u),o$5=0;var i=r$4.__H||(r$4.__H={__:[],__h:[]});return t>=i.__.length&&i.__.push({__V:c$5}),i.__[t]}function h$5(n){return o$5=1,s$5(B$3,n)}function s$5(n,u,i){var o=d$5(t$5++,2);if(o.t=n,!o.__c&&(o.__=[i?i(u):B$3(void 0,u),function(n){var t=o.__N?o.__N[0]:o.__[0],r=o.t(t,n);t!==r&&(o.__N=[r,o.__[1]],o.__c.setState({}));}],o.__c=r$4,!r$4.u)){var f=function(n,t,r){if(!o.__c.__H)return !0;var u=o.__c.__H.__.filter(function(n){return n.__c});if(u.every(function(n){return !n.__N}))return !c||c.call(this,n,t,r);var i=!1;return u.forEach(function(n){if(n.__N){var t=n.__[0];n.__=n.__N,n.__N=void 0,t!==n.__[0]&&(i=!0);}}),!(!i&&o.__c.props===n)&&(!c||c.call(this,n,t,r))};r$4.u=!0;var c=r$4.shouldComponentUpdate,e=r$4.componentWillUpdate;r$4.componentWillUpdate=function(n,t,r){if(this.__e){var u=c;c=void 0,f(n,t,r),c=u;}e&&e.call(this,n,t,r);},r$4.shouldComponentUpdate=f;}return o.__N||o.__}function p$4(u,i){var o=d$5(t$5++,3);!l$7.__s&&z$2(o.__H,i)&&(o.__=u,o.i=i,r$4.__H.__h.push(o));}function y$5(u,i){var o=d$5(t$5++,4);!l$7.__s&&z$2(o.__H,i)&&(o.__=u,o.i=i,r$4.__h.push(o));}function _$5(n){return o$5=5,F$2(function(){return {current:n}},[])}function A$2(n,t,r){o$5=6,y$5(function(){return "function"==typeof n?(n(t()),function(){return n(null)}):n?(n.current=t(),function(){return n.current=null}):void 0},null==r?r:r.concat(n));}function F$2(n,r){var u=d$5(t$5++,7);return z$2(u.__H,r)?(u.__V=n(),u.i=r,u.__h=n,u.__V):u.__}function T$3(n,t){return o$5=8,F$2(function(){return n},t)}function q$2(n){var u=r$4.context[n.__c],i=d$5(t$5++,9);return i.c=n,u?(null==i.__&&(i.__=!0,u.sub(r$4)),u.props.value):n.__}function x$1(t,r){l$7.useDebugValue&&l$7.useDebugValue(r?r(t):t);}function P$3(n){var u=d$5(t$5++,10),i=h$5();return u.__=n,r$4.componentDidCatch||(r$4.componentDidCatch=function(n,t){u.__&&u.__(n,t),i[1](n);}),[i[0],function(){i[1](void 0);}]}function V$2(){var n=d$5(t$5++,11);if(!n.__){for(var u=r$4.__v;null!==u&&!u.__m&&null!==u.__;)u=u.__;var i=u.__m||(u.__m=[0,0]);n.__="P"+i[0]+"-"+i[1]++;}return n.__}function b$4(){for(var t;t=f$2.shift();)if(t.__P&&t.__H)try{t.__H.__h.forEach(k$1),t.__H.__h.forEach(w$3),t.__H.__h=[];}catch(r){t.__H.__h=[],l$7.__e(r,t.__v);}}l$7.__b=function(n){r$4=null,e$6&&e$6(n);},l$7.__r=function(n){a$3&&a$3(n),t$5=0;var i=(r$4=n.__c).__H;i&&(u$4===r$4?(i.__h=[],r$4.__h=[],i.__.forEach(function(n){n.__N&&(n.__=n.__N),n.__V=c$5,n.__N=n.i=void 0;})):(i.__h.forEach(k$1),i.__h.forEach(w$3),i.__h=[],t$5=0)),u$4=r$4;},l$7.diffed=function(t){v$3&&v$3(t);var o=t.__c;o&&o.__H&&(o.__H.__h.length&&(1!==f$2.push(o)&&i$6===l$7.requestAnimationFrame||((i$6=l$7.requestAnimationFrame)||j$4)(b$4)),o.__H.__.forEach(function(n){n.i&&(n.__H=n.i),n.__V!==c$5&&(n.__=n.__V),n.i=void 0,n.__V=c$5;})),u$4=r$4=null;},l$7.__c=function(t,r){r.some(function(t){try{t.__h.forEach(k$1),t.__h=t.__h.filter(function(n){return !n.__||w$3(n)});}catch(u){r.some(function(n){n.__h&&(n.__h=[]);}),r=[],l$7.__e(u,t.__v);}}),l$6&&l$6(t,r);},l$7.unmount=function(t){m$3&&m$3(t);var r,u=t.__c;u&&u.__H&&(u.__H.__.forEach(function(n){try{k$1(n);}catch(n){r=n;}}),u.__H=void 0,r&&l$7.__e(r,u.__v));};var g$5="function"==typeof requestAnimationFrame;function j$4(n){var t,r=function(){clearTimeout(u),g$5&&cancelAnimationFrame(t),setTimeout(n);},u=setTimeout(r,100);g$5&&(t=requestAnimationFrame(r));}function k$1(n){var t=r$4,u=n.__c;"function"==typeof u&&(n.__c=void 0,u()),r$4=t;}function w$3(n){var t=r$4;n.__c=n.__(),r$4=t;}function z$2(n,t){return !n||n.length!==t.length||t.some(function(t,r){return t!==n[r]})}function B$3(n,t){return "function"==typeof t?t(n):t}

	var hooks_module = /*#__PURE__*/Object.freeze({
		__proto__: null,
		useCallback: T$3,
		useContext: q$2,
		useDebugValue: x$1,
		useEffect: p$4,
		useErrorBoundary: P$3,
		useId: V$2,
		useImperativeHandle: A$2,
		useLayoutEffect: y$5,
		useMemo: F$2,
		useReducer: s$5,
		useRef: _$5,
		useState: h$5
	});

	var require$$2$1 = /*@__PURE__*/getAugmentedNamespace(hooks_module);

	var ConnectContent$1 = {};

	var CloseIcon$1 = {};

	Object.defineProperty(CloseIcon$1, "__esModule", { value: true });
	CloseIcon$1.CloseIcon = void 0;
	const preact_1$b = require$$1$1;
	function CloseIcon(props) {
	    return ((0, preact_1$b.h)("svg", Object.assign({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
	        (0, preact_1$b.h)("path", { d: "M13.7677 13L12.3535 14.4142L18.3535 20.4142L12.3535 26.4142L13.7677 27.8284L19.7677 21.8284L25.7677 27.8284L27.1819 26.4142L21.1819 20.4142L27.1819 14.4142L25.7677 13L19.7677 19L13.7677 13Z" })));
	}
	CloseIcon$1.CloseIcon = CloseIcon;

	var coinbaseRoundSvg = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(coinbaseRoundSvg, "__esModule", { value: true });
	coinbaseRoundSvg.default = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMTQiIGZpbGw9IiMwMDUyRkYiLz48cGF0aCBkPSJNMTQuMDM3IDE4LjkyNmMtMi43NSAwLTQuOTA3LTIuMjA1LTQuOTA3LTQuOTI2IDAtMi43MiAyLjIzLTQuOTI2IDQuOTA3LTQuOTI2YTQuODY2IDQuODY2IDAgMCAxIDQuODMzIDQuMTE4aDQuOTgyYy0uNDQ2LTUuMDczLTQuNjg0LTkuMDQ0LTkuODE1LTkuMDQ0QzguNjEgNC4xNDggNC4xNDkgOC41NiA0LjE0OSAxNHM0LjM4NyA5Ljg1MiA5Ljg5IDkuODUyYzUuMjA0IDAgOS4zNjgtMy45NyA5LjgxNC05LjA0M0gxOC44N2E0Ljg2NiA0Ljg2NiAwIDAgMS00LjgzMyA0LjExN1oiIGZpbGw9IiNmZmYiLz48L3N2Zz4=`;

	var coinbaseWalletRoundSvg = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(coinbaseWalletRoundSvg, "__esModule", { value: true });
	coinbaseWalletRoundSvg.default = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMTQiIGZpbGw9IiMwMDUyRkYiLz48cGF0aCBkPSJNMjMuODUyIDE0QTkuODM0IDkuODM0IDAgMCAxIDE0IDIzLjg1MiA5LjgzNCA5LjgzNCAwIDAgMSA0LjE0OCAxNCA5LjgzNCA5LjgzNCAwIDAgMSAxNCA0LjE0OCA5LjgzNCA5LjgzNCAwIDAgMSAyMy44NTIgMTRaIiBmaWxsPSIjZmZmIi8+PHBhdGggZD0iTTExLjE4NSAxMi41MDRjMC0uNDU2IDAtLjcxLjA5OC0uODYyLjA5OC0uMTUyLjE5Ni0uMzA0LjM0My0uMzU1LjE5Ni0uMTAyLjM5Mi0uMTAyLjg4MS0uMTAyaDIuOTg2Yy40OSAwIC42ODYgMCAuODgyLjEwMi4xNDYuMTAxLjI5My4yMDMuMzQyLjM1NS4wOTguMjAzLjA5OC40MDYuMDk4Ljg2MnYyLjk5MmMwIC40NTcgMCAuNzEtLjA5OC44NjMtLjA5OC4xNTItLjE5NS4zMDQtLjM0Mi4zNTUtLjE5Ni4xMDEtLjM5Mi4xMDEtLjg4Mi4xMDFoLTIuOTg2Yy0uNDkgMC0uNjg1IDAtLjg4LS4xMDEtLjE0OC0uMTAyLS4yOTUtLjIwMy0uMzQ0LS4zNTUtLjA5OC0uMjAzLS4wOTgtLjQwNi0uMDk4LS44NjN2LTIuOTkyWiIgZmlsbD0iIzAwNTJGRiIvPjwvc3ZnPg==`;

	var QRCodeIcon$1 = {};

	Object.defineProperty(QRCodeIcon$1, "__esModule", { value: true });
	QRCodeIcon$1.QRCodeIcon = void 0;
	const preact_1$a = require$$1$1;
	function QRCodeIcon(props) {
	    return ((0, preact_1$a.h)("svg", Object.assign({ width: "10", height: "10", viewBox: "0 0 10 10", xmlns: "http://www.w3.org/2000/svg" }, props),
	        (0, preact_1$a.h)("path", { d: "M8.2271 1.77124L7.0271 1.77124V2.97124H8.2271V1.77124Z" }),
	        (0, preact_1$a.h)("path", { d: "M5.44922 0.199219L5.44922 4.54922L9.79922 4.54922V0.199219L5.44922 0.199219ZM8.89922 3.64922L6.34922 3.64922L6.34922 1.09922L8.89922 1.09922V3.64922Z" }),
	        (0, preact_1$a.h)("path", { d: "M2.97124 1.77124L1.77124 1.77124L1.77124 2.97124H2.97124V1.77124Z" }),
	        (0, preact_1$a.h)("path", { d: "M0.199219 4.54922L4.54922 4.54922L4.54922 0.199219L0.199219 0.199219L0.199219 4.54922ZM1.09922 1.09922L3.64922 1.09922L3.64922 3.64922L1.09922 3.64922L1.09922 1.09922Z" }),
	        (0, preact_1$a.h)("path", { d: "M2.97124 7.0271H1.77124L1.77124 8.2271H2.97124V7.0271Z" }),
	        (0, preact_1$a.h)("path", { d: "M0.199219 9.79922H4.54922L4.54922 5.44922L0.199219 5.44922L0.199219 9.79922ZM1.09922 6.34922L3.64922 6.34922L3.64922 8.89922H1.09922L1.09922 6.34922Z" }),
	        (0, preact_1$a.h)("path", { d: "M8.89922 7.39912H7.99922V5.40112H5.44922L5.44922 9.79912H6.34922L6.34922 6.30112H7.09922V8.29912H9.79922V5.40112H8.89922V7.39912Z" }),
	        (0, preact_1$a.h)("path", { d: "M7.99912 8.89917H7.09912V9.79917H7.99912V8.89917Z" }),
	        (0, preact_1$a.h)("path", { d: "M9.79917 8.89917H8.89917V9.79917H9.79917V8.89917Z" })));
	}
	QRCodeIcon$1.QRCodeIcon = QRCodeIcon;

	var QRLogoCoinbase = {};

	Object.defineProperty(QRLogoCoinbase, "__esModule", { value: true });
	const svg = `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z" fill="white"/>
        <path d="M50.512 94C74.2907 94 93.5673 74.5244 93.5673 50.5C93.5673 26.4756 74.2907 7 50.512 7C26.7332 7 7.45667 26.4756 7.45667 50.5C7.45667 74.5244 26.7332 94 50.512 94Z" fill="#0052FF"/>
        <path d="M50.6248 65.4335C42.3697 65.4335 35.8996 58.7469 35.8996 50.5C35.8996 42.2531 42.5928 35.5664 50.6248 35.5664C57.9873 35.5664 64.0111 40.9157 65.1267 48.0481H80.0749C78.7363 32.6688 66.0191 20.6328 50.6248 20.6328C34.3379 20.6328 20.9514 34.0062 20.9514 50.5C20.9514 66.9936 34.1148 80.3671 50.6248 80.3671C66.2422 80.3671 78.7363 68.331 80.0749 52.9516H65.1267C64.0111 60.0841 57.9873 65.4335 50.6248 65.4335Z" fill="white"/>
    </svg>
`;
	QRLogoCoinbase.default = svg;

	var QRLogoWallet = {};

	Object.defineProperty(QRLogoWallet, "__esModule", { value: true });
	QRLogoWallet.default = `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="50" fill="white"/>
        <circle cx="49.9996" cy="49.9996" r="43.6363" fill="#1B53E4"/>
        <circle cx="49.9996" cy="49.9996" r="43.6363" stroke="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.3379 49.9484C19.3379 66.8508 33.04 80.553 49.9425 80.553C66.8449 80.553 80.5471 66.8508 80.5471 49.9484C80.5471 33.0459 66.8449 19.3438 49.9425 19.3438C33.04 19.3438 19.3379 33.0459 19.3379 49.9484ZM44.0817 40.0799C41.8725 40.0799 40.0817 41.8708 40.0817 44.0799V55.8029C40.0817 58.012 41.8725 59.8029 44.0817 59.8029H55.8046C58.0138 59.8029 59.8046 58.012 59.8046 55.8029V44.0799C59.8046 41.8708 58.0138 40.0799 55.8046 40.0799H44.0817Z" fill="white"/>
    </svg>
`;

	var StatusDotIcon$1 = {};

	Object.defineProperty(StatusDotIcon$1, "__esModule", { value: true });
	StatusDotIcon$1.StatusDotIcon = void 0;
	const preact_1$9 = require$$1$1;
	function StatusDotIcon(props) {
	    return ((0, preact_1$9.h)("svg", Object.assign({ width: "10", height: "10", viewBox: "0 0 10 10", xmlns: "http://www.w3.org/2000/svg" }, props),
	        (0, preact_1$9.h)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.29995 4.99995C2.29995 5.57985 1.82985 6.04995 1.24995 6.04995C0.670052 6.04995 0.199951 5.57985 0.199951 4.99995C0.199951 4.42005 0.670052 3.94995 1.24995 3.94995C1.82985 3.94995 2.29995 4.42005 2.29995 4.99995ZM4.99995 6.04995C5.57985 6.04995 6.04995 5.57985 6.04995 4.99995C6.04995 4.42005 5.57985 3.94995 4.99995 3.94995C4.42005 3.94995 3.94995 4.42005 3.94995 4.99995C3.94995 5.57985 4.42005 6.04995 4.99995 6.04995ZM8.74995 6.04995C9.32985 6.04995 9.79995 5.57985 9.79995 4.99995C9.79995 4.42005 9.32985 3.94995 8.74995 3.94995C8.17005 3.94995 7.69995 4.42005 7.69995 4.99995C7.69995 5.57985 8.17005 6.04995 8.74995 6.04995Z" })));
	}
	StatusDotIcon$1.StatusDotIcon = StatusDotIcon;

	var QRCode$3 = {};

	/**
	 * @fileoverview
	 * - modified davidshimjs/qrcodejs library for use in node.js
	 * - Using the 'QRCode for Javascript library'
	 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
	 * - this library has no dependencies.
	 *
	 * @version 0.9.1 (2016-02-12)
	 * @author davidshimjs, papnkukn
	 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
	 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
	 * @see <a href="https://github.com/davidshimjs/qrcodejs" target="_blank">https://github.com/davidshimjs/qrcodejs</a>
	 */

	//---------------------------------------------------------------------
	// QRCode for JavaScript
	//
	// Copyright (c) 2009 Kazuhiko Arase
	//
	// URL: http://www.d-project.com/
	//
	// Licensed under the MIT license:
	//   http://www.opensource.org/licenses/mit-license.php
	//
	// The word "QR Code" is registered trademark of
	// DENSO WAVE INCORPORATED
	//   http://www.denso-wave.com/qrcode/faqpatent-e.html
	//
	//---------------------------------------------------------------------
	function QR8bitByte(data) {
	  this.mode = QRMode.MODE_8BIT_BYTE;
	  this.data = data;
	  this.parsedData = [];

	  // Added to support UTF-8 Characters
	  for (var i = 0, l = this.data.length; i < l; i++) {
	    var byteArray = [];
	    var code = this.data.charCodeAt(i);

	    if (code > 0x10000) {
	      byteArray[0] = 0xF0 | ((code & 0x1C0000) >>> 18);
	      byteArray[1] = 0x80 | ((code & 0x3F000) >>> 12);
	      byteArray[2] = 0x80 | ((code & 0xFC0) >>> 6);
	      byteArray[3] = 0x80 | (code & 0x3F);
	    } else if (code > 0x800) {
	      byteArray[0] = 0xE0 | ((code & 0xF000) >>> 12);
	      byteArray[1] = 0x80 | ((code & 0xFC0) >>> 6);
	      byteArray[2] = 0x80 | (code & 0x3F);
	    } else if (code > 0x80) {
	      byteArray[0] = 0xC0 | ((code & 0x7C0) >>> 6);
	      byteArray[1] = 0x80 | (code & 0x3F);
	    } else {
	      byteArray[0] = code;
	    }

	    this.parsedData.push(byteArray);
	  }

	  this.parsedData = Array.prototype.concat.apply([], this.parsedData);

	  if (this.parsedData.length != this.data.length) {
	    this.parsedData.unshift(191);
	    this.parsedData.unshift(187);
	    this.parsedData.unshift(239);
	  }
	}

	QR8bitByte.prototype = {
	  getLength: function (buffer) {
	    return this.parsedData.length;
	  },
	  write: function (buffer) {
	    for (var i = 0, l = this.parsedData.length; i < l; i++) {
	      buffer.put(this.parsedData[i], 8);
	    }
	  }
	};

	function QRCodeModel(typeNumber, errorCorrectLevel) {
	  this.typeNumber = typeNumber;
	  this.errorCorrectLevel = errorCorrectLevel;
	  this.modules = null;
	  this.moduleCount = 0;
	  this.dataCache = null;
	  this.dataList = [];
	}

	QRCodeModel.prototype={addData:function(data){var newData=new QR8bitByte(data);this.dataList.push(newData);this.dataCache=null;},isDark:function(row,col){if(row<0||this.moduleCount<=row||col<0||this.moduleCount<=col){throw new Error(row+","+col);}
	return this.modules[row][col];},getModuleCount:function(){return this.moduleCount;},make:function(){this.makeImpl(false,this.getBestMaskPattern());},makeImpl:function(test,maskPattern){this.moduleCount=this.typeNumber*4+17;this.modules=new Array(this.moduleCount);for(var row=0;row<this.moduleCount;row++){this.modules[row]=new Array(this.moduleCount);for(var col=0;col<this.moduleCount;col++){this.modules[row][col]=null;}}
	this.setupPositionProbePattern(0,0);this.setupPositionProbePattern(this.moduleCount-7,0);this.setupPositionProbePattern(0,this.moduleCount-7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(test,maskPattern);if(this.typeNumber>=7){this.setupTypeNumber(test);}
	if(this.dataCache==null){this.dataCache=QRCodeModel.createData(this.typeNumber,this.errorCorrectLevel,this.dataList);}
	this.mapData(this.dataCache,maskPattern);},setupPositionProbePattern:function(row,col){for(var r=-1;r<=7;r++){if(row+r<=-1||this.moduleCount<=row+r)continue;for(var c=-1;c<=7;c++){if(col+c<=-1||this.moduleCount<=col+c)continue;if((0<=r&&r<=6&&(c==0||c==6))||(0<=c&&c<=6&&(r==0||r==6))||(2<=r&&r<=4&&2<=c&&c<=4)){this.modules[row+r][col+c]=true;}else {this.modules[row+r][col+c]=false;}}}},getBestMaskPattern:function(){var minLostPoint=0;var pattern=0;for(var i=0;i<8;i++){this.makeImpl(true,i);var lostPoint=QRUtil.getLostPoint(this);if(i==0||minLostPoint>lostPoint){minLostPoint=lostPoint;pattern=i;}}
	return pattern;},createMovieClip:function(target_mc,instance_name,depth){var qr_mc=target_mc.createEmptyMovieClip(instance_name,depth);var cs=1;this.make();for(var row=0;row<this.modules.length;row++){var y=row*cs;for(var col=0;col<this.modules[row].length;col++){var x=col*cs;var dark=this.modules[row][col];if(dark){qr_mc.beginFill(0,100);qr_mc.moveTo(x,y);qr_mc.lineTo(x+cs,y);qr_mc.lineTo(x+cs,y+cs);qr_mc.lineTo(x,y+cs);qr_mc.endFill();}}}
	return qr_mc;},setupTimingPattern:function(){for(var r=8;r<this.moduleCount-8;r++){if(this.modules[r][6]!=null){continue;}
	this.modules[r][6]=(r%2==0);}
	for(var c=8;c<this.moduleCount-8;c++){if(this.modules[6][c]!=null){continue;}
	this.modules[6][c]=(c%2==0);}},setupPositionAdjustPattern:function(){var pos=QRUtil.getPatternPosition(this.typeNumber);for(var i=0;i<pos.length;i++){for(var j=0;j<pos.length;j++){var row=pos[i];var col=pos[j];if(this.modules[row][col]!=null){continue;}
	for(var r=-2;r<=2;r++){for(var c=-2;c<=2;c++){if(r==-2||r==2||c==-2||c==2||(r==0&&c==0)){this.modules[row+r][col+c]=true;}else {this.modules[row+r][col+c]=false;}}}}}},setupTypeNumber:function(test){var bits=QRUtil.getBCHTypeNumber(this.typeNumber);for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[Math.floor(i/3)][i%3+this.moduleCount-8-3]=mod;}
	for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[i%3+this.moduleCount-8-3][Math.floor(i/3)]=mod;}},setupTypeInfo:function(test,maskPattern){var data=(this.errorCorrectLevel<<3)|maskPattern;var bits=QRUtil.getBCHTypeInfo(data);for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<6){this.modules[i][8]=mod;}else if(i<8){this.modules[i+1][8]=mod;}else {this.modules[this.moduleCount-15+i][8]=mod;}}
	for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<8){this.modules[8][this.moduleCount-i-1]=mod;}else if(i<9){this.modules[8][15-i-1+1]=mod;}else {this.modules[8][15-i-1]=mod;}}
	this.modules[this.moduleCount-8][8]=(!test);},mapData:function(data,maskPattern){var inc=-1;var row=this.moduleCount-1;var bitIndex=7;var byteIndex=0;for(var col=this.moduleCount-1;col>0;col-=2){if(col==6)col--;while(true){for(var c=0;c<2;c++){if(this.modules[row][col-c]==null){var dark=false;if(byteIndex<data.length){dark=(((data[byteIndex]>>>bitIndex)&1)==1);}
	var mask=QRUtil.getMask(maskPattern,row,col-c);if(mask){dark=!dark;}
	this.modules[row][col-c]=dark;bitIndex--;if(bitIndex==-1){byteIndex++;bitIndex=7;}}}
	row+=inc;if(row<0||this.moduleCount<=row){row-=inc;inc=-inc;break;}}}}};QRCodeModel.PAD0=0xEC;QRCodeModel.PAD1=0x11;QRCodeModel.createData=function(typeNumber,errorCorrectLevel,dataList){var rsBlocks=QRRSBlock.getRSBlocks(typeNumber,errorCorrectLevel);var buffer=new QRBitBuffer();for(var i=0;i<dataList.length;i++){var data=dataList[i];buffer.put(data.mode,4);buffer.put(data.getLength(),QRUtil.getLengthInBits(data.mode,typeNumber));data.write(buffer);}
	var totalDataCount=0;for(var i=0;i<rsBlocks.length;i++){totalDataCount+=rsBlocks[i].dataCount;}
	if(buffer.getLengthInBits()>totalDataCount*8){throw new Error("code length overflow. ("
	+buffer.getLengthInBits()
	+">"
	+totalDataCount*8
	+")");}
	if(buffer.getLengthInBits()+4<=totalDataCount*8){buffer.put(0,4);}
	while(buffer.getLengthInBits()%8!=0){buffer.putBit(false);}
	while(true){if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD0,8);if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD1,8);}
	return QRCodeModel.createBytes(buffer,rsBlocks);};QRCodeModel.createBytes=function(buffer,rsBlocks){var offset=0;var maxDcCount=0;var maxEcCount=0;var dcdata=new Array(rsBlocks.length);var ecdata=new Array(rsBlocks.length);for(var r=0;r<rsBlocks.length;r++){var dcCount=rsBlocks[r].dataCount;var ecCount=rsBlocks[r].totalCount-dcCount;maxDcCount=Math.max(maxDcCount,dcCount);maxEcCount=Math.max(maxEcCount,ecCount);dcdata[r]=new Array(dcCount);for(var i=0;i<dcdata[r].length;i++){dcdata[r][i]=0xff&buffer.buffer[i+offset];}
	offset+=dcCount;var rsPoly=QRUtil.getErrorCorrectPolynomial(ecCount);var rawPoly=new QRPolynomial(dcdata[r],rsPoly.getLength()-1);var modPoly=rawPoly.mod(rsPoly);ecdata[r]=new Array(rsPoly.getLength()-1);for(var i=0;i<ecdata[r].length;i++){var modIndex=i+modPoly.getLength()-ecdata[r].length;ecdata[r][i]=(modIndex>=0)?modPoly.get(modIndex):0;}}
	var totalCodeCount=0;for(var i=0;i<rsBlocks.length;i++){totalCodeCount+=rsBlocks[i].totalCount;}
	var data=new Array(totalCodeCount);var index=0;for(var i=0;i<maxDcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<dcdata[r].length){data[index++]=dcdata[r][i];}}}
	for(var i=0;i<maxEcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<ecdata[r].length){data[index++]=ecdata[r][i];}}}
	return data;};var QRMode={MODE_NUMBER:1<<0,MODE_ALPHA_NUM:1<<1,MODE_8BIT_BYTE:1<<2,MODE_KANJI:1<<3};var QRErrorCorrectLevel={L:1,M:0,Q:3,H:2};var QRMaskPattern={PATTERN000:0,PATTERN001:1,PATTERN010:2,PATTERN011:3,PATTERN100:4,PATTERN101:5,PATTERN110:6,PATTERN111:7};var QRUtil={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:(1<<10)|(1<<8)|(1<<5)|(1<<4)|(1<<2)|(1<<1)|(1<<0),G18:(1<<12)|(1<<11)|(1<<10)|(1<<9)|(1<<8)|(1<<5)|(1<<2)|(1<<0),G15_MASK:(1<<14)|(1<<12)|(1<<10)|(1<<4)|(1<<1),getBCHTypeInfo:function(data){var d=data<<10;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)>=0){d^=(QRUtil.G15<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)));}
	return ((data<<10)|d)^QRUtil.G15_MASK;},getBCHTypeNumber:function(data){var d=data<<12;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)>=0){d^=(QRUtil.G18<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)));}
	return (data<<12)|d;},getBCHDigit:function(data){var digit=0;while(data!=0){digit++;data>>>=1;}
	return digit;},getPatternPosition:function(typeNumber){return QRUtil.PATTERN_POSITION_TABLE[typeNumber-1];},getMask:function(maskPattern,i,j){switch(maskPattern){case QRMaskPattern.PATTERN000:return (i+j)%2==0;case QRMaskPattern.PATTERN001:return i%2==0;case QRMaskPattern.PATTERN010:return j%3==0;case QRMaskPattern.PATTERN011:return (i+j)%3==0;case QRMaskPattern.PATTERN100:return (Math.floor(i/2)+Math.floor(j/3))%2==0;case QRMaskPattern.PATTERN101:return (i*j)%2+(i*j)%3==0;case QRMaskPattern.PATTERN110:return ((i*j)%2+(i*j)%3)%2==0;case QRMaskPattern.PATTERN111:return ((i*j)%3+(i+j)%2)%2==0;default:throw new Error("bad maskPattern:"+maskPattern);}},getErrorCorrectPolynomial:function(errorCorrectLength){var a=new QRPolynomial([1],0);for(var i=0;i<errorCorrectLength;i++){a=a.multiply(new QRPolynomial([1,QRMath.gexp(i)],0));}
	return a;},getLengthInBits:function(mode,type){if(1<=type&&type<10){switch(mode){case QRMode.MODE_NUMBER:return 10;case QRMode.MODE_ALPHA_NUM:return 9;case QRMode.MODE_8BIT_BYTE:return 8;case QRMode.MODE_KANJI:return 8;default:throw new Error("mode:"+mode);}}else if(type<27){switch(mode){case QRMode.MODE_NUMBER:return 12;case QRMode.MODE_ALPHA_NUM:return 11;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 10;default:throw new Error("mode:"+mode);}}else if(type<41){switch(mode){case QRMode.MODE_NUMBER:return 14;case QRMode.MODE_ALPHA_NUM:return 13;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 12;default:throw new Error("mode:"+mode);}}else {throw new Error("type:"+type);}},getLostPoint:function(qrCode){var moduleCount=qrCode.getModuleCount();var lostPoint=0;for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount;col++){var sameCount=0;var dark=qrCode.isDark(row,col);for(var r=-1;r<=1;r++){if(row+r<0||moduleCount<=row+r){continue;}
	for(var c=-1;c<=1;c++){if(col+c<0||moduleCount<=col+c){continue;}
	if(r==0&&c==0){continue;}
	if(dark==qrCode.isDark(row+r,col+c)){sameCount++;}}}
	if(sameCount>5){lostPoint+=(3+sameCount-5);}}}
	for(var row=0;row<moduleCount-1;row++){for(var col=0;col<moduleCount-1;col++){var count=0;if(qrCode.isDark(row,col))count++;if(qrCode.isDark(row+1,col))count++;if(qrCode.isDark(row,col+1))count++;if(qrCode.isDark(row+1,col+1))count++;if(count==0||count==4){lostPoint+=3;}}}
	for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount-6;col++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row,col+1)&&qrCode.isDark(row,col+2)&&qrCode.isDark(row,col+3)&&qrCode.isDark(row,col+4)&&!qrCode.isDark(row,col+5)&&qrCode.isDark(row,col+6)){lostPoint+=40;}}}
	for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount-6;row++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row+1,col)&&qrCode.isDark(row+2,col)&&qrCode.isDark(row+3,col)&&qrCode.isDark(row+4,col)&&!qrCode.isDark(row+5,col)&&qrCode.isDark(row+6,col)){lostPoint+=40;}}}
	var darkCount=0;for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount;row++){if(qrCode.isDark(row,col)){darkCount++;}}}
	var ratio=Math.abs(100*darkCount/moduleCount/moduleCount-50)/5;lostPoint+=ratio*10;return lostPoint;}};var QRMath={glog:function(n){if(n<1){throw new Error("glog("+n+")");}
	return QRMath.LOG_TABLE[n];},gexp:function(n){while(n<0){n+=255;}
	while(n>=256){n-=255;}
	return QRMath.EXP_TABLE[n];},EXP_TABLE:new Array(256),LOG_TABLE:new Array(256)};for(var i$5=0;i$5<8;i$5++){QRMath.EXP_TABLE[i$5]=1<<i$5;}
	for(var i$5=8;i$5<256;i$5++){QRMath.EXP_TABLE[i$5]=QRMath.EXP_TABLE[i$5-4]^QRMath.EXP_TABLE[i$5-5]^QRMath.EXP_TABLE[i$5-6]^QRMath.EXP_TABLE[i$5-8];}
	for(var i$5=0;i$5<255;i$5++){QRMath.LOG_TABLE[QRMath.EXP_TABLE[i$5]]=i$5;}
	function QRPolynomial(num,shift){if(num.length==undefined){throw new Error(num.length+"/"+shift);}
	var offset=0;while(offset<num.length&&num[offset]==0){offset++;}
	this.num=new Array(num.length-offset+shift);for(var i=0;i<num.length-offset;i++){this.num[i]=num[i+offset];}}
	QRPolynomial.prototype={get:function(index){return this.num[index];},getLength:function(){return this.num.length;},multiply:function(e){var num=new Array(this.getLength()+e.getLength()-1);for(var i=0;i<this.getLength();i++){for(var j=0;j<e.getLength();j++){num[i+j]^=QRMath.gexp(QRMath.glog(this.get(i))+QRMath.glog(e.get(j)));}}
	return new QRPolynomial(num,0);},mod:function(e){if(this.getLength()-e.getLength()<0){return this;}
	var ratio=QRMath.glog(this.get(0))-QRMath.glog(e.get(0));var num=new Array(this.getLength());for(var i=0;i<this.getLength();i++){num[i]=this.get(i);}
	for(var i=0;i<e.getLength();i++){num[i]^=QRMath.gexp(QRMath.glog(e.get(i))+ratio);}
	return new QRPolynomial(num,0).mod(e);}};function QRRSBlock(totalCount,dataCount){this.totalCount=totalCount;this.dataCount=dataCount;}
	QRRSBlock.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]];QRRSBlock.getRSBlocks=function(typeNumber,errorCorrectLevel){var rsBlock=QRRSBlock.getRsBlockTable(typeNumber,errorCorrectLevel);if(rsBlock==undefined){throw new Error("bad rs block @ typeNumber:"+typeNumber+"/errorCorrectLevel:"+errorCorrectLevel);}
	var length=rsBlock.length/3;var list=[];for(var i=0;i<length;i++){var count=rsBlock[i*3+0];var totalCount=rsBlock[i*3+1];var dataCount=rsBlock[i*3+2];for(var j=0;j<count;j++){list.push(new QRRSBlock(totalCount,dataCount));}}
	return list;};QRRSBlock.getRsBlockTable=function(typeNumber,errorCorrectLevel){switch(errorCorrectLevel){case QRErrorCorrectLevel.L:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+0];case QRErrorCorrectLevel.M:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+1];case QRErrorCorrectLevel.Q:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+2];case QRErrorCorrectLevel.H:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+3];default:return undefined;}};function QRBitBuffer(){this.buffer=[];this.length=0;}
	QRBitBuffer.prototype={get:function(index){var bufIndex=Math.floor(index/8);return ((this.buffer[bufIndex]>>>(7-index%8))&1)==1;},put:function(num,length){for(var i=0;i<length;i++){this.putBit(((num>>>(length-i-1))&1)==1);}},getLengthInBits:function(){return this.length;},putBit:function(bit){var bufIndex=Math.floor(this.length/8);if(this.buffer.length<=bufIndex){this.buffer.push(0);}
	if(bit){this.buffer[bufIndex]|=(0x80>>>(this.length%8));}
	this.length++;}};var QRCodeLimitLength=[[17,14,11,7],[32,26,20,14],[53,42,32,24],[78,62,46,34],[106,84,60,44],[134,106,74,58],[154,122,86,64],[192,152,108,84],[230,180,130,98],[271,213,151,119],[321,251,177,137],[367,287,203,155],[425,331,241,177],[458,362,258,194],[520,412,292,220],[586,450,322,250],[644,504,364,280],[718,560,394,310],[792,624,442,338],[858,666,482,382],[929,711,509,403],[1003,779,565,439],[1091,857,611,461],[1171,911,661,511],[1273,997,715,535],[1367,1059,751,593],[1465,1125,805,625],[1528,1190,868,658],[1628,1264,908,698],[1732,1370,982,742],[1840,1452,1030,790],[1952,1538,1112,842],[2068,1628,1168,898],[2188,1722,1228,958],[2303,1809,1283,983],[2431,1911,1351,1051],[2563,1989,1423,1093],[2699,2099,1499,1139],[2809,2213,1579,1219],[2953,2331,1663,1273]];


	/** Constructor */
	function QRCode$2(options) {

	  //Default options
	  this.options = {
	    padding: 4,
	    width: 256,
	    height: 256,
	    typeNumber: 4,
	    color: "#000000",
	    background: "#ffffff",
	    ecl: "M",
	    image:{
	      svg:"",
	      width:0,
	      height:0
	    }
	  };

	  //In case the options is string
	  if (typeof options === 'string') {
	    options = {
	      content: options
	    };
	  }

	  //Merge options
	  if (options) {
	    for (var i in options) {
	      this.options[i] = options[i];
	    }
	  }

	  if (typeof this.options.content !== 'string') {
	    throw new Error("Expected 'content' as string!");
	  }

	  if (this.options.content.length === 0 /* || this.options.content.length > 7089 */) {
	    throw new Error("Expected 'content' to be non-empty!");
	  }

	  if (!(this.options.padding >= 0)) {
	    throw new Error("Expected 'padding' value to be non-negative!");
	  }

	  if (!(this.options.width > 0) || !(this.options.height > 0)) {
	    throw new Error("Expected 'width' or 'height' value to be higher than zero!");
	  }

	  //Gets the error correction level
	  function _getErrorCorrectLevel(ecl) {
	    switch (ecl) {
	        case "L":
	          return QRErrorCorrectLevel.L;

	        case "M":
	          return QRErrorCorrectLevel.M;

	        case "Q":
	          return QRErrorCorrectLevel.Q;

	        case "H":
	          return QRErrorCorrectLevel.H;

	        default:
	          throw new Error("Unknwon error correction level: " + ecl);
	      }
	  }

	  //Get type number
	  function _getTypeNumber(content, ecl) {
	    var length = _getUTF8Length(content);

	    var type = 1;
	    var limit = 0;
	    for (var i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
	      var table = QRCodeLimitLength[i];
	      if (!table) {
	        throw new Error("Content too long: expected " + limit + " but got " + length);
	      }

	      switch (ecl) {
	        case "L":
	          limit = table[0];
	          break;

	        case "M":
	          limit = table[1];
	          break;

	        case "Q":
	          limit = table[2];
	          break;

	        case "H":
	          limit = table[3];
	          break;

	        default:
	          throw new Error("Unknwon error correction level: " + ecl);
	      }

	      if (length <= limit) {
	        break;
	      }

	      type++;
	    }

	    if (type > QRCodeLimitLength.length) {
	      throw new Error("Content too long");
	    }

	    return type;
	  }

	  //Gets text length
	  function _getUTF8Length(content) {
	    var result = encodeURI(content).toString().replace(/\%[0-9a-fA-F]{2}/g, 'a');
	    return result.length + (result.length != content ? 3 : 0);
	  }

	  //Generate QR Code matrix
	  var content = this.options.content;
	  var type = _getTypeNumber(content, this.options.ecl);
	  var ecl = _getErrorCorrectLevel(this.options.ecl);
	  this.qrcode = new QRCodeModel(type, ecl);
	  this.qrcode.addData(content);
	  this.qrcode.make();
	}

	/** Generates QR Code as SVG image */
	QRCode$2.prototype.svg = function(opt) {
	  var options = this.options || { };
	  var modules = this.qrcode.modules;

	  if (typeof opt == "undefined") {
	    opt = { container: options.container || "svg" };
	  }

	  //Apply new lines and indents in SVG?
	  var pretty = typeof options.pretty != "undefined" ? !!options.pretty : true;

	  var indent = pretty ? '  ' : '';
	  var EOL = pretty ? '\r\n' : '';
	  var width = options.width;
	  var height = options.height;
	  var length = modules.length;
	  var xsize = width / (length + 2 * options.padding);
	  var ysize = height / (length + 2 * options.padding);

	  //Join (union, merge) rectangles into one shape?
	  var join = typeof options.join != "undefined" ? !!options.join : false;

	  //Swap the X and Y modules, pull request #2
	  var swap = typeof options.swap != "undefined" ? !!options.swap : false;

	  //Apply <?xml...?> declaration in SVG?
	  var xmlDeclaration = typeof options.xmlDeclaration != "undefined" ? !!options.xmlDeclaration : true;

	  //Populate with predefined shape instead of "rect" elements, thanks to @kkocdko
	  var predefined = typeof options.predefined != "undefined" ? !!options.predefined : false;
	  var defs = predefined ? indent + '<defs><path id="qrmodule" d="M0 0 h' + ysize + ' v' + xsize + ' H0 z" style="fill:' + options.color + ';shape-rendering:crispEdges;" /></defs>' + EOL : '';

	  //Background rectangle
	  var bgrect = indent + '<rect x="0" y="0" width="' + width + '" height="' + height + '" style="fill:' + options.background + ';shape-rendering:crispEdges;"/>' + EOL;

	  //Rectangles representing modules
	  var modrect = '';
	  var pathdata = '';

	  for (var y = 0; y < length; y++) {
	    for (var x = 0; x < length; x++) {
	      var module = modules[x][y];
	      if (module) {

	        var px = (x * xsize + options.padding * xsize);
	        var py = (y * ysize + options.padding * ysize);

	        //Some users have had issues with the QR Code, thanks to @danioso for the solution
	        if (swap) {
	          var t = px;
	          px = py;
	          py = t;
	        }

	        if (join) {
	          //Module as a part of svg path data, thanks to @danioso
	          var w = xsize + px;
	          var h = ysize + py;

	          px = (Number.isInteger(px))? Number(px): px.toFixed(2);
	          py = (Number.isInteger(py))? Number(py): py.toFixed(2);
	          w = (Number.isInteger(w))? Number(w): w.toFixed(2);
	          h = (Number.isInteger(h))? Number(h): h.toFixed(2);

	          pathdata += ('M' + px + ',' + py + ' V' + h + ' H' + w + ' V' + py + ' H' + px + ' Z ');
	        }
	        else if (predefined) {
	          //Module as a predefined shape, thanks to @kkocdko
	          modrect += indent + '<use x="' + px.toString() + '" y="' + py.toString() + '" href="#qrmodule" />' + EOL;
	        }
	        else {
	          //Module as rectangle element
	          modrect += indent + '<rect x="' + px.toString() + '" y="' + py.toString() + '" width="' + xsize + '" height="' + ysize + '" style="fill:' + options.color + ';shape-rendering:crispEdges;"/>' + EOL;
	        }
	      }
	    }
	  }

	  if (join) {
	    modrect = indent + '<path x="0" y="0" style="fill:' + options.color + ';shape-rendering:crispEdges;" d="' + pathdata + '" />';
	  }
	  let imgSvg = "";
	  if(this.options.image !== undefined && this.options.image.svg){
	    const imgWidth = width * this.options.image.width / 100;
	    const imgHeight = height * this.options.image.height / 100;
	    const imgX = (width/2) - imgWidth/2;
	    const imgY = (height/2) - imgHeight/2;
	    imgSvg += `<svg x="${imgX}" y="${imgY}" width="${imgWidth}" height="${imgHeight}" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">`;
	    imgSvg += this.options.image.svg + EOL;
	    imgSvg += '</svg>';
	  }

	  var svg = "";
	  switch (opt.container) {
	    //Wrapped in SVG document
	    case "svg":
	      if (xmlDeclaration) {
	        svg += '<?xml version="1.0" standalone="yes"?>' + EOL;
	      }
	      svg += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="' + width + '" height="' + height + '">' + EOL;
	      svg += defs + bgrect + modrect;
	      svg += imgSvg;
	      svg += '</svg>';
	      break;

	    //Viewbox for responsive use in a browser, thanks to @danioso
	    case "svg-viewbox":
	      if (xmlDeclaration) {
	        svg += '<?xml version="1.0" standalone="yes"?>' + EOL;
	      }
	      svg += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ' + width + ' ' + height + '">' + EOL;
	      svg += defs + bgrect + modrect;
	      svg += imgSvg;
	      svg += '</svg>';
	      break;


	    //Wrapped in group element
	    case "g":
	      svg += '<g width="' + width + '" height="' + height + '">' + EOL;
	      svg += defs + bgrect + modrect;
	      svg += imgSvg;
	      svg += '</g>';

	      break;

	    //Without a container
	    default:
	      svg += (defs + bgrect + modrect + imgSvg).replace(/^\s+/, ""); //Clear indents on each line
	      break;
	  }

	  return svg;
	};

	var qrcodeSvg = QRCode$2;

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	var __importDefault$6 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(QRCode$3, "__esModule", { value: true });
	QRCode$3.QRCode = void 0;
	const preact_1$8 = require$$1$1;
	const hooks_1$3 = require$$2$1;
	const qrcode_svg_1 = __importDefault$6(qrcodeSvg);
	const QRCode$1 = props => {
	    const [svg, setSvg] = (0, hooks_1$3.useState)("");
	    (0, hooks_1$3.useEffect)(() => {
	        var _a, _b;
	        const qrcode = new qrcode_svg_1.default({
	            content: props.content,
	            background: props.bgColor || "#ffffff",
	            color: props.fgColor || "#000000",
	            container: "svg",
	            ecl: "M",
	            width: (_a = props.width) !== null && _a !== void 0 ? _a : 256,
	            height: (_b = props.height) !== null && _b !== void 0 ? _b : 256,
	            padding: 0,
	            image: props.image,
	        });
	        const base64 = Buffer.from(qrcode.svg(), "utf8").toString("base64");
	        setSvg(`data:image/svg+xml;base64,${base64}`);
	    });
	    return svg ? (0, preact_1$8.h)("img", { src: svg, alt: "QR Code" }) : null;
	};
	QRCode$3.QRCode = QRCode$1;

	var Spinner$1 = {};

	var SpinnerCss = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(SpinnerCss, "__esModule", { value: true });
	SpinnerCss.default = `.-cbwsdk-css-reset .-cbwsdk-spinner{display:inline-block}.-cbwsdk-css-reset .-cbwsdk-spinner svg{display:inline-block;animation:2s linear infinite -cbwsdk-spinner-svg}.-cbwsdk-css-reset .-cbwsdk-spinner svg circle{animation:1.9s ease-in-out infinite both -cbwsdk-spinner-circle;display:block;fill:rgba(0,0,0,0);stroke-dasharray:283;stroke-dashoffset:280;stroke-linecap:round;stroke-width:10px;transform-origin:50% 50%}@keyframes -cbwsdk-spinner-svg{0%{transform:rotateZ(0deg)}100%{transform:rotateZ(360deg)}}@keyframes -cbwsdk-spinner-circle{0%,25%{stroke-dashoffset:280;transform:rotate(0)}50%,75%{stroke-dashoffset:75;transform:rotate(45deg)}100%{stroke-dashoffset:280;transform:rotate(360deg)}}`;

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	var __importDefault$5 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(Spinner$1, "__esModule", { value: true });
	Spinner$1.Spinner = void 0;
	const preact_1$7 = require$$1$1;
	const Spinner_css_1 = __importDefault$5(SpinnerCss);
	const Spinner = props => {
	    var _a;
	    const size = (_a = props.size) !== null && _a !== void 0 ? _a : 64;
	    const color = props.color || "#000";
	    return ((0, preact_1$7.h)("div", { class: "-cbwsdk-spinner" },
	        (0, preact_1$7.h)("style", null, Spinner_css_1.default),
	        (0, preact_1$7.h)("svg", { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", style: { width: size, height: size } },
	            (0, preact_1$7.h)("circle", { style: { cx: 50, cy: 50, r: 45, stroke: color } }))));
	};
	Spinner$1.Spinner = Spinner;

	var ConnectContentCss = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(ConnectContentCss, "__esModule", { value: true });
	ConnectContentCss.default = `.-cbwsdk-css-reset .-cbwsdk-connect-content{height:430px;width:700px;border-radius:12px;padding:30px}.-cbwsdk-css-reset .-cbwsdk-connect-content.light{background:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-content.dark{background:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-connect-content-header{display:flex;align-items:center;justify-content:space-between;margin:0 0 30px}.-cbwsdk-css-reset .-cbwsdk-connect-content-heading{font-style:normal;font-weight:500;font-size:28px;line-height:36px;margin:0}.-cbwsdk-css-reset .-cbwsdk-connect-content-heading.light{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-connect-content-heading.dark{color:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-content-layout{display:flex;flex-direction:row}.-cbwsdk-css-reset .-cbwsdk-connect-content-column-left{margin-right:30px;display:flex;flex-direction:column;justify-content:space-between}.-cbwsdk-css-reset .-cbwsdk-connect-content-column-right{flex:25%;margin-right:34px}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-wrapper{width:220px;height:220px;border-radius:12px;display:flex;justify-content:center;align-items:center;background:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting{position:absolute;top:0;bottom:0;left:0;right:0;display:flex;flex-direction:column;align-items:center;justify-content:center}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting.light{background-color:rgba(255,255,255,.95)}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting.light>p{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting.dark{background-color:rgba(10,11,13,.9)}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting.dark>p{color:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting>p{font-size:12px;font-weight:bold;margin-top:16px}.-cbwsdk-css-reset .-cbwsdk-connect-content-update-app{border-radius:8px;font-size:14px;line-height:20px;padding:12px;width:339px}.-cbwsdk-css-reset .-cbwsdk-connect-content-update-app.light{background:#eef0f3;color:#5b636e}.-cbwsdk-css-reset .-cbwsdk-connect-content-update-app.dark{background:#1e2025;color:#8a919e}.-cbwsdk-css-reset .-cbwsdk-cancel-button{-webkit-appearance:none;border:none;background:none;cursor:pointer;padding:0;margin:0}.-cbwsdk-css-reset .-cbwsdk-cancel-button-x{position:relative;display:block;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-wallet-steps{padding:0 0 0 16px;margin:0;width:100%;list-style:decimal}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-item{list-style-type:decimal;display:list-item;font-style:normal;font-weight:400;font-size:16px;line-height:24px;margin-top:20px}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-item.light{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-item.dark{color:#fff}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-item-wrapper{display:flex;align-items:center}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-pad-left{margin-left:6px}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-icon{display:flex;border-radius:50%;height:24px;width:24px}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-icon svg{margin:auto;display:block}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-icon.light{background:#0052ff}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-icon.dark{background:#588af5}.-cbwsdk-css-reset .-cbwsdk-connect-item{align-items:center;display:flex;flex-direction:row;padding:16px 24px;gap:12px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-connect-item.light{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-connect-item.light.selected{background:#f5f8ff;color:#0052ff}.-cbwsdk-css-reset .-cbwsdk-connect-item.dark{color:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-item.dark.selected{background:#001033;color:#588af5}.-cbwsdk-css-reset .-cbwsdk-connect-item.selected{border-radius:100px;font-weight:600}.-cbwsdk-css-reset .-cbwsdk-connect-item-copy-wrapper{margin:0 4px 0 8px}.-cbwsdk-css-reset .-cbwsdk-connect-item-title{margin:0 0 0;font-size:16px;line-height:24px;font-weight:500}.-cbwsdk-css-reset .-cbwsdk-connect-item-description{font-weight:400;font-size:14px;line-height:20px;margin:0}`;

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	var __importDefault$4 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(ConnectContent$1, "__esModule", { value: true });
	ConnectContent$1.CoinbaseAppSteps = ConnectContent$1.CoinbaseWalletSteps = ConnectContent$1.ConnectItem = ConnectContent$1.ConnectContent = void 0;
	const clsx_1$2 = __importDefault$4(require$$0$1);
	const preact_1$6 = require$$1$1;
	const hooks_1$2 = require$$2$1;
	const util_1$4 = util$3;
	const version_1 = version$2;
	const CloseIcon_1 = CloseIcon$1;
	const coinbase_round_svg_1 = __importDefault$4(coinbaseRoundSvg);
	const coinbase_wallet_round_svg_1 = __importDefault$4(coinbaseWalletRoundSvg);
	const QRCodeIcon_1 = QRCodeIcon$1;
	const QRLogoCoinbase_1 = __importDefault$4(QRLogoCoinbase);
	const QRLogoWallet_1 = __importDefault$4(QRLogoWallet);
	const StatusDotIcon_1 = StatusDotIcon$1;
	const QRCode_1 = QRCode$3;
	const Spinner_1 = Spinner$1;
	const ConnectContent_css_1 = __importDefault$4(ConnectContentCss);
	const wallets = {
	    "coinbase-wallet-app": {
	        title: "Coinbase Wallet app",
	        description: "Connect with your self-custody wallet",
	        icon: coinbase_wallet_round_svg_1.default,
	        steps: CoinbaseWalletSteps,
	    },
	    "coinbase-app": {
	        title: "Coinbase app",
	        description: "Connect with your Coinbase account",
	        icon: coinbase_round_svg_1.default,
	        steps: CoinbaseAppSteps,
	    },
	};
	const makeQrCodeImage = (app) => {
	    switch (app) {
	        case "coinbase-app":
	            return QRLogoCoinbase_1.default;
	        case "coinbase-wallet-app":
	        default:
	            return QRLogoWallet_1.default;
	    }
	};
	const makeIconColor = (theme) => {
	    return theme === "light" ? "#FFFFFF" : "#0A0B0D";
	};
	function ConnectContent(props) {
	    const { theme } = props;
	    const [selected, setSelected] = (0, hooks_1$2.useState)("coinbase-wallet-app");
	    const handleSelect = (0, hooks_1$2.useCallback)((id) => {
	        setSelected(id);
	    }, []);
	    const qrUrl = (0, util_1$4.createQrUrl)(props.sessionId, props.sessionSecret, props.linkAPIUrl, props.isParentConnection, props.version, props.chainId);
	    const wallet = wallets[selected];
	    if (!selected) {
	        return null;
	    }
	    const WalletSteps = wallet.steps;
	    const coinbaseApp = selected === "coinbase-app";
	    return ((0, preact_1$6.h)("div", { "data-testid": "connect-content", class: (0, clsx_1$2.default)("-cbwsdk-connect-content", theme) },
	        (0, preact_1$6.h)("style", null, ConnectContent_css_1.default),
	        (0, preact_1$6.h)("div", { class: "-cbwsdk-connect-content-header" },
	            (0, preact_1$6.h)("h2", { class: (0, clsx_1$2.default)("-cbwsdk-connect-content-heading", theme) }, "Scan to connect with one of our mobile apps"),
	            props.onCancel && ((0, preact_1$6.h)("button", { type: "button", class: "-cbwsdk-cancel-button", onClick: props.onCancel },
	                (0, preact_1$6.h)(CloseIcon_1.CloseIcon, { fill: theme === "light" ? "#0A0B0D" : "#FFFFFF" })))),
	        (0, preact_1$6.h)("div", { class: "-cbwsdk-connect-content-layout" },
	            (0, preact_1$6.h)("div", { class: "-cbwsdk-connect-content-column-left" },
	                (0, preact_1$6.h)("div", null, Object.entries(wallets).map(([key, value]) => {
	                    return ((0, preact_1$6.h)(ConnectItem, { key: key, title: value.title, description: value.description, icon: value.icon, selected: selected === key, onClick: () => handleSelect(key), theme: theme }));
	                })),
	                coinbaseApp && ((0, preact_1$6.h)("div", { class: (0, clsx_1$2.default)("-cbwsdk-connect-content-update-app", theme) },
	                    "Don\u2019t see a ",
	                    (0, preact_1$6.h)("strong", null, "Scan"),
	                    " option? Update your Coinbase app to the latest version and try again."))),
	            (0, preact_1$6.h)("div", { class: "-cbwsdk-connect-content-column-right" },
	                (0, preact_1$6.h)("div", { class: "-cbwsdk-connect-content-qr-wrapper" },
	                    (0, preact_1$6.h)(QRCode_1.QRCode, { content: qrUrl, width: 200, height: 200, fgColor: "#000", bgColor: "transparent", image: {
	                            svg: makeQrCodeImage(selected),
	                            width: 25,
	                            height: 25,
	                        } }),
	                    (0, preact_1$6.h)("input", { type: "hidden", name: "cbw-cbwsdk-version", value: version_1.LIB_VERSION }),
	                    (0, preact_1$6.h)("input", { type: "hidden", value: qrUrl })),
	                (0, preact_1$6.h)(WalletSteps, { theme: theme }),
	                !props.isConnected && ((0, preact_1$6.h)("div", { "data-testid": "connecting-spinner", class: (0, clsx_1$2.default)("-cbwsdk-connect-content-qr-connecting", theme) },
	                    (0, preact_1$6.h)(Spinner_1.Spinner, { size: 36, color: theme === "dark" ? "#FFF" : "#000" }),
	                    (0, preact_1$6.h)("p", null, "Connecting...")))))));
	}
	ConnectContent$1.ConnectContent = ConnectContent;
	function ConnectItem({ title, description, icon, selected, theme, onClick, }) {
	    return ((0, preact_1$6.h)("div", { onClick: onClick, class: (0, clsx_1$2.default)("-cbwsdk-connect-item", theme, { selected }) },
	        (0, preact_1$6.h)("div", null,
	            (0, preact_1$6.h)("img", { src: icon, alt: title })),
	        (0, preact_1$6.h)("div", { class: "-cbwsdk-connect-item-copy-wrapper" },
	            (0, preact_1$6.h)("h3", { class: "-cbwsdk-connect-item-title" }, title),
	            (0, preact_1$6.h)("p", { class: "-cbwsdk-connect-item-description" }, description))));
	}
	ConnectContent$1.ConnectItem = ConnectItem;
	function CoinbaseWalletSteps({ theme }) {
	    return ((0, preact_1$6.h)("ol", { class: "-cbwsdk-wallet-steps" },
	        (0, preact_1$6.h)("li", { class: (0, clsx_1$2.default)("-cbwsdk-wallet-steps-item", theme) },
	            (0, preact_1$6.h)("div", { class: "-cbwsdk-wallet-steps-item-wrapper" }, "Open Coinbase Wallet app")),
	        (0, preact_1$6.h)("li", { class: (0, clsx_1$2.default)("-cbwsdk-wallet-steps-item", theme) },
	            (0, preact_1$6.h)("div", { class: "-cbwsdk-wallet-steps-item-wrapper" },
	                (0, preact_1$6.h)("span", null,
	                    "Tap ",
	                    (0, preact_1$6.h)("strong", null, "Scan"),
	                    " "),
	                (0, preact_1$6.h)("span", { class: (0, clsx_1$2.default)("-cbwsdk-wallet-steps-pad-left", "-cbwsdk-wallet-steps-icon", theme) },
	                    (0, preact_1$6.h)(QRCodeIcon_1.QRCodeIcon, { fill: makeIconColor(theme) }))))));
	}
	ConnectContent$1.CoinbaseWalletSteps = CoinbaseWalletSteps;
	function CoinbaseAppSteps({ theme }) {
	    return ((0, preact_1$6.h)("ol", { class: "-cbwsdk-wallet-steps" },
	        (0, preact_1$6.h)("li", { class: (0, clsx_1$2.default)("-cbwsdk-wallet-steps-item", theme) },
	            (0, preact_1$6.h)("div", { class: "-cbwsdk-wallet-steps-item-wrapper" }, "Open Coinbase app")),
	        (0, preact_1$6.h)("li", { class: (0, clsx_1$2.default)("-cbwsdk-wallet-steps-item", theme) },
	            (0, preact_1$6.h)("div", { class: "-cbwsdk-wallet-steps-item-wrapper" },
	                (0, preact_1$6.h)("span", null,
	                    "Tap ",
	                    (0, preact_1$6.h)("strong", null, "More")),
	                (0, preact_1$6.h)("span", { class: (0, clsx_1$2.default)("-cbwsdk-wallet-steps-pad-left", "-cbwsdk-wallet-steps-icon", theme) },
	                    (0, preact_1$6.h)(StatusDotIcon_1.StatusDotIcon, { fill: makeIconColor(theme) })),
	                (0, preact_1$6.h)("span", { class: "-cbwsdk-wallet-steps-pad-left" },
	                    "then ",
	                    (0, preact_1$6.h)("strong", null, "Scan")),
	                (0, preact_1$6.h)("span", { class: (0, clsx_1$2.default)("-cbwsdk-wallet-steps-pad-left", "-cbwsdk-wallet-steps-icon", theme) },
	                    (0, preact_1$6.h)(QRCodeIcon_1.QRCodeIcon, { fill: makeIconColor(theme) }))))));
	}
	ConnectContent$1.CoinbaseAppSteps = CoinbaseAppSteps;

	var TryExtensionContent$1 = {};

	var ArrowLeftIcon$1 = {};

	Object.defineProperty(ArrowLeftIcon$1, "__esModule", { value: true });
	ArrowLeftIcon$1.ArrowLeftIcon = void 0;
	const preact_1$5 = require$$1$1;
	function ArrowLeftIcon(props) {
	    return ((0, preact_1$5.h)("svg", Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props),
	        (0, preact_1$5.h)("path", { d: "M8.60675 0.155884L7.37816 1.28209L12.7723 7.16662H0V8.83328H12.6548L6.82149 14.6666L8 15.8451L15.8201 8.02501L8.60675 0.155884Z" })));
	}
	ArrowLeftIcon$1.ArrowLeftIcon = ArrowLeftIcon;

	var LaptopIcon$1 = {};

	Object.defineProperty(LaptopIcon$1, "__esModule", { value: true });
	LaptopIcon$1.LaptopIcon = void 0;
	const preact_1$4 = require$$1$1;
	function LaptopIcon(props) {
	    return ((0, preact_1$4.h)("svg", Object.assign({ width: "14", height: "14", viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg" }, props),
	        (0, preact_1$4.h)("path", { d: "M1.8001 2.2002H12.2001V9.40019H1.8001V2.2002ZM3.4001 3.8002V7.80019H10.6001V3.8002H3.4001Z" }),
	        (0, preact_1$4.h)("path", { d: "M13.4001 10.2002H0.600098C0.600098 11.0838 1.31644 11.8002 2.2001 11.8002H11.8001C12.6838 11.8002 13.4001 11.0838 13.4001 10.2002Z" })));
	}
	LaptopIcon$1.LaptopIcon = LaptopIcon;

	var SafeIcon$1 = {};

	Object.defineProperty(SafeIcon$1, "__esModule", { value: true });
	SafeIcon$1.SafeIcon = void 0;
	const preact_1$3 = require$$1$1;
	function SafeIcon(props) {
	    return ((0, preact_1$3.h)("svg", Object.assign({ width: "14", height: "14", viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg" }, props),
	        (0, preact_1$3.h)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M0.600098 0.600098V11.8001H13.4001V0.600098H0.600098ZM7.0001 9.2001C5.3441 9.2001 4.0001 7.8561 4.0001 6.2001C4.0001 4.5441 5.3441 3.2001 7.0001 3.2001C8.6561 3.2001 10.0001 4.5441 10.0001 6.2001C10.0001 7.8561 8.6561 9.2001 7.0001 9.2001ZM0.600098 12.6001H3.8001V13.4001H0.600098V12.6001ZM10.2001 12.6001H13.4001V13.4001H10.2001V12.6001ZM8.8001 6.2001C8.8001 7.19421 7.99421 8.0001 7.0001 8.0001C6.00598 8.0001 5.2001 7.19421 5.2001 6.2001C5.2001 5.20598 6.00598 4.4001 7.0001 4.4001C7.99421 4.4001 8.8001 5.20598 8.8001 6.2001Z" })));
	}
	SafeIcon$1.SafeIcon = SafeIcon;

	var TryExtensionContentCss = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(TryExtensionContentCss, "__esModule", { value: true });
	TryExtensionContentCss.default = `.-cbwsdk-css-reset .-cbwsdk-try-extension{display:flex;margin-top:12px;height:202px;width:700px;border-radius:12px;padding:30px}.-cbwsdk-css-reset .-cbwsdk-try-extension.light{background:#fff}.-cbwsdk-css-reset .-cbwsdk-try-extension.dark{background:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-try-extension-column-half{flex:50%}.-cbwsdk-css-reset .-cbwsdk-try-extension-heading{font-style:normal;font-weight:500;font-size:25px;line-height:32px;margin:0;max-width:204px}.-cbwsdk-css-reset .-cbwsdk-try-extension-heading.light{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-try-extension-heading.dark{color:#fff}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta{appearance:none;border:none;background:none;color:#0052ff;cursor:pointer;padding:0;text-decoration:none;display:block;font-weight:600;font-size:16px;line-height:24px}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta.light{color:#0052ff}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta.dark{color:#588af5}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta-wrapper{display:flex;align-items:center;margin-top:12px}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta-icon{display:block;margin-left:4px;height:14px}.-cbwsdk-css-reset .-cbwsdk-try-extension-list{display:flex;flex-direction:column;justify-content:center;align-items:center;margin:0;padding:0;list-style:none;height:100%}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item{display:flex;align-items:center;flex-flow:nowrap;margin-top:24px}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item:first-of-type{margin-top:0}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon-wrapper{display:block}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon{display:flex;height:32px;width:32px;border-radius:50%}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon svg{margin:auto;display:block}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon.light{background:#eef0f3}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon.dark{background:#1e2025}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-copy{display:block;font-weight:400;font-size:14px;line-height:20px;padding-left:12px}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-copy.light{color:#5b636e}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-copy.dark{color:#8a919e}`;

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	var __importDefault$3 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(TryExtensionContent$1, "__esModule", { value: true });
	TryExtensionContent$1.TryExtensionContent = void 0;
	const clsx_1$1 = __importDefault$3(require$$0$1);
	const preact_1$2 = require$$1$1;
	const hooks_1$1 = require$$2$1;
	const ArrowLeftIcon_1 = ArrowLeftIcon$1;
	const LaptopIcon_1 = LaptopIcon$1;
	const SafeIcon_1 = SafeIcon$1;
	const TryExtensionContent_css_1 = __importDefault$3(TryExtensionContentCss);
	function TryExtensionContent({ theme }) {
	    const [clicked, setClicked] = (0, hooks_1$1.useState)(false);
	    const handleInstallClick = (0, hooks_1$1.useCallback)(() => {
	        window.open("https://api.wallet.coinbase.com/rpc/v2/desktop/chrome", "_blank");
	    }, []);
	    const handleClick = (0, hooks_1$1.useCallback)(() => {
	        if (clicked) {
	            window.location.reload();
	        }
	        else {
	            handleInstallClick();
	            setClicked(true);
	        }
	    }, [handleInstallClick, clicked]);
	    return ((0, preact_1$2.h)("div", { class: (0, clsx_1$1.default)("-cbwsdk-try-extension", theme) },
	        (0, preact_1$2.h)("style", null, TryExtensionContent_css_1.default),
	        (0, preact_1$2.h)("div", { class: "-cbwsdk-try-extension-column-half" },
	            (0, preact_1$2.h)("h3", { class: (0, clsx_1$1.default)("-cbwsdk-try-extension-heading", theme) }, "Or try the Coinbase Wallet browser extension"),
	            (0, preact_1$2.h)("div", { class: "-cbwsdk-try-extension-cta-wrapper" },
	                (0, preact_1$2.h)("button", { class: (0, clsx_1$1.default)("-cbwsdk-try-extension-cta", theme), onClick: handleClick }, clicked ? "Refresh" : "Install"),
	                (0, preact_1$2.h)("div", null, !clicked && ((0, preact_1$2.h)(ArrowLeftIcon_1.ArrowLeftIcon, { class: "-cbwsdk-try-extension-cta-icon", fill: theme === "light" ? "#0052FF" : "#588AF5" }))))),
	        (0, preact_1$2.h)("div", { class: "-cbwsdk-try-extension-column-half" },
	            (0, preact_1$2.h)("ul", { class: "-cbwsdk-try-extension-list" },
	                (0, preact_1$2.h)("li", { class: "-cbwsdk-try-extension-list-item" },
	                    (0, preact_1$2.h)("div", { class: "-cbwsdk-try-extension-list-item-icon-wrapper" },
	                        (0, preact_1$2.h)("span", { class: (0, clsx_1$1.default)("-cbwsdk-try-extension-list-item-icon", theme) },
	                            (0, preact_1$2.h)(LaptopIcon_1.LaptopIcon, { fill: theme === "light" ? "#0A0B0D" : "#FFFFFF" }))),
	                    (0, preact_1$2.h)("div", { class: (0, clsx_1$1.default)("-cbwsdk-try-extension-list-item-copy", theme) }, "Connect with dapps with just one click on your desktop browser")),
	                (0, preact_1$2.h)("li", { class: "-cbwsdk-try-extension-list-item" },
	                    (0, preact_1$2.h)("div", { class: "-cbwsdk-try-extension-list-item-icon-wrapper" },
	                        (0, preact_1$2.h)("span", { class: (0, clsx_1$1.default)("-cbwsdk-try-extension-list-item-icon", theme) },
	                            (0, preact_1$2.h)(SafeIcon_1.SafeIcon, { fill: theme === "light" ? "#0A0B0D" : "#FFFFFF" }))),
	                    (0, preact_1$2.h)("div", { class: (0, clsx_1$1.default)("-cbwsdk-try-extension-list-item-copy", theme) }, "Add an additional layer of security by using a supported Ledger hardware wallet"))))));
	}
	TryExtensionContent$1.TryExtensionContent = TryExtensionContent;

	var ConnectDialogCss = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(ConnectDialogCss, "__esModule", { value: true });
	ConnectDialogCss.default = `.-cbwsdk-css-reset .-cbwsdk-connect-dialog{z-index:2147483647;position:fixed;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-backdrop{z-index:2147483647;position:fixed;top:0;left:0;right:0;bottom:0;transition:opacity .25s}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-backdrop.light{background-color:rgba(0,0,0,.5)}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-backdrop.dark{background-color:rgba(50,53,61,.4)}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-backdrop-hidden{opacity:0}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-box{display:flex;position:relative;flex-direction:column;transform:scale(1);transition:opacity .25s,transform .25s}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-box-hidden{opacity:0;transform:scale(0.85)}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-container{display:block}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-container-hidden{display:none}`;

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	var __importDefault$2 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(ConnectDialog$1, "__esModule", { value: true });
	ConnectDialog$1.ConnectDialog = void 0;
	const clsx_1 = __importDefault$2(require$$0$1);
	const preact_1$1 = require$$1$1;
	const hooks_1 = require$$2$1;
	const ConnectContent_1 = ConnectContent$1;
	const TryExtensionContent_1 = TryExtensionContent$1;
	const ConnectDialog_css_1 = __importDefault$2(ConnectDialogCss);
	const ConnectDialog = (props) => {
	    const { isOpen, darkMode } = props;
	    const [containerHidden, setContainerHidden] = (0, hooks_1.useState)(!isOpen);
	    const [dialogHidden, setDialogHidden] = (0, hooks_1.useState)(!isOpen);
	    (0, hooks_1.useEffect)(() => {
	        const timers = [
	            window.setTimeout(() => {
	                setDialogHidden(!isOpen);
	            }, 10),
	        ];
	        if (isOpen) {
	            setContainerHidden(false);
	        }
	        else {
	            timers.push(window.setTimeout(() => {
	                setContainerHidden(true);
	            }, 360));
	        }
	        return () => {
	            timers.forEach(window.clearTimeout);
	        };
	    }, [props.isOpen]);
	    const theme = darkMode ? "dark" : "light";
	    return ((0, preact_1$1.h)("div", { class: (0, clsx_1.default)("-cbwsdk-connect-dialog-container", containerHidden && "-cbwsdk-connect-dialog-container-hidden") },
	        (0, preact_1$1.h)("style", null, ConnectDialog_css_1.default),
	        (0, preact_1$1.h)("div", { class: (0, clsx_1.default)("-cbwsdk-connect-dialog-backdrop", theme, dialogHidden && "-cbwsdk-connect-dialog-backdrop-hidden") }),
	        (0, preact_1$1.h)("div", { class: "-cbwsdk-connect-dialog" },
	            (0, preact_1$1.h)("div", { class: (0, clsx_1.default)("-cbwsdk-connect-dialog-box", dialogHidden && "-cbwsdk-connect-dialog-box-hidden") },
	                !props.connectDisabled ? ((0, preact_1$1.h)(ConnectContent_1.ConnectContent, { theme: theme, version: props.version, sessionId: props.sessionId, sessionSecret: props.sessionSecret, linkAPIUrl: props.linkAPIUrl, isConnected: props.isConnected, isParentConnection: props.isParentConnection, chainId: props.chainId, onCancel: props.onCancel })) : null,
	                (0, preact_1$1.h)(TryExtensionContent_1.TryExtensionContent, { theme: theme })))));
	};
	ConnectDialog$1.ConnectDialog = ConnectDialog;

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(LinkFlow$1, "__esModule", { value: true });
	LinkFlow$1.LinkFlow = void 0;
	const preact_1 = require$$1$1;
	const rxjs_1$2 = require$$1;
	const ConnectDialog_1 = ConnectDialog$1;
	class LinkFlow {
	    constructor(options) {
	        this.extensionUI$ = new rxjs_1$2.BehaviorSubject({});
	        this.subscriptions = new rxjs_1$2.Subscription();
	        this.isConnected = false;
	        this.chainId = 1;
	        this.isOpen = false;
	        this.onCancel = null;
	        this.root = null;
	        // if true, hide QR code in LinkFlow (which happens if no jsonRpcUrl is provided)
	        this.connectDisabled = false;
	        this.darkMode = options.darkMode;
	        this.version = options.version;
	        this.sessionId = options.sessionId;
	        this.sessionSecret = options.sessionSecret;
	        this.linkAPIUrl = options.linkAPIUrl;
	        this.isParentConnection = options.isParentConnection;
	        this.connected$ = options.connected$;
	        this.chainId$ = options.chainId$;
	    }
	    attach(el) {
	        this.root = document.createElement("div");
	        this.root.className = "-cbwsdk-link-flow-root";
	        el.appendChild(this.root);
	        this.render();
	        this.subscriptions.add(this.connected$.subscribe(v => {
	            if (this.isConnected !== v) {
	                this.isConnected = v;
	                this.render();
	            }
	        }));
	        this.subscriptions.add(this.chainId$.subscribe(chainId => {
	            if (this.chainId !== chainId) {
	                this.chainId = chainId;
	                this.render();
	            }
	        }));
	    }
	    detach() {
	        var _a;
	        if (!this.root) {
	            return;
	        }
	        this.subscriptions.unsubscribe();
	        (0, preact_1.render)(null, this.root);
	        (_a = this.root.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(this.root);
	    }
	    setConnectDisabled(connectDisabled) {
	        this.connectDisabled = connectDisabled;
	    }
	    open(options) {
	        this.isOpen = true;
	        this.onCancel = options.onCancel;
	        this.render();
	    }
	    close() {
	        this.isOpen = false;
	        this.onCancel = null;
	        this.render();
	    }
	    render() {
	        if (!this.root) {
	            return;
	        }
	        const subscription = this.extensionUI$.subscribe(() => {
	            if (!this.root) {
	                return;
	            }
	            (0, preact_1.render)((0, preact_1.h)(ConnectDialog_1.ConnectDialog, { darkMode: this.darkMode, version: this.version, sessionId: this.sessionId, sessionSecret: this.sessionSecret, linkAPIUrl: this.linkAPIUrl, isOpen: this.isOpen, isConnected: this.isConnected, isParentConnection: this.isParentConnection, chainId: this.chainId, onCancel: this.onCancel, connectDisabled: this.connectDisabled }), this.root);
	        });
	        this.subscriptions.add(subscription);
	    }
	}
	LinkFlow$1.LinkFlow = LinkFlow;

	var Snackbar = {};

	var SnackbarCss = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(SnackbarCss, "__esModule", { value: true });
	SnackbarCss.default = `.-cbwsdk-css-reset .-gear-container{margin-left:16px !important;margin-right:9px !important;display:flex;align-items:center;justify-content:center;width:24px;height:24px;transition:opacity .25s}.-cbwsdk-css-reset .-gear-container *{user-select:none}.-cbwsdk-css-reset .-gear-container svg{opacity:0;position:absolute}.-cbwsdk-css-reset .-gear-icon{height:12px;width:12px;z-index:10000}.-cbwsdk-css-reset .-cbwsdk-snackbar{align-items:flex-end;display:flex;flex-direction:column;position:fixed;right:0;top:0;z-index:2147483647}.-cbwsdk-css-reset .-cbwsdk-snackbar *{user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance{display:flex;flex-direction:column;margin:8px 16px 0 16px;overflow:visible;text-align:left;transform:translateX(0);transition:opacity .25s,transform .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header:hover .-gear-container svg{opacity:1}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header{display:flex;align-items:center;background:#fff;overflow:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-cblogo{margin:8px 8px 8px 8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-message{color:#000;font-size:13px;line-height:1.5;user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu{background:#fff;transition:opacity .25s ease-in-out,transform .25s linear,visibility 0s;visibility:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;opacity:0;flex-direction:column;padding-left:8px;padding-right:8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:last-child{margin-bottom:8px !important}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover{background:#f5f7f8;border-radius:6px;transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover span{color:#050f19;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover svg path{fill:#000;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item{visibility:inherit;height:35px;margin-top:8px;margin-bottom:0;display:flex;flex-direction:row;align-items:center;padding:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item *{visibility:inherit;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover{background:rgba(223,95,103,.2);transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover svg path{fill:#df5f67;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover span{color:#df5f67;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-info{color:#aaa;font-size:13px;margin:0 8px 0 32px;position:absolute}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-hidden{opacity:0;text-align:left;transform:translateX(25%);transition:opacity .5s linear}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-expanded .-cbwsdk-snackbar-instance-menu{opacity:1;display:flex;transform:translateY(8px);visibility:visible}`;

	(function (exports) {
		// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
		// Licensed under the Apache License, version 2.0
		var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
		    return (mod && mod.__esModule) ? mod : { "default": mod };
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.SnackbarInstance = exports.SnackbarContainer = exports.Snackbar = void 0;
		const clsx_1 = __importDefault(require$$0$1);
		const preact_1 = require$$1$1;
		const hooks_1 = require$$2$1;
		const Snackbar_css_1 = __importDefault(SnackbarCss);
		const gearIcon = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyIDYuNzV2LTEuNWwtMS43Mi0uNTdjLS4wOC0uMjctLjE5LS41Mi0uMzItLjc3bC44MS0xLjYyLTEuMDYtMS4wNi0xLjYyLjgxYy0uMjQtLjEzLS41LS4yNC0uNzctLjMyTDYuNzUgMGgtMS41bC0uNTcgMS43MmMtLjI3LjA4LS41My4xOS0uNzcuMzJsLTEuNjItLjgxLTEuMDYgMS4wNi44MSAxLjYyYy0uMTMuMjQtLjI0LjUtLjMyLjc3TDAgNS4yNXYxLjVsMS43Mi41N2MuMDguMjcuMTkuNTMuMzIuNzdsLS44MSAxLjYyIDEuMDYgMS4wNiAxLjYyLS44MWMuMjQuMTMuNS4yMy43Ny4zMkw1LjI1IDEyaDEuNWwuNTctMS43MmMuMjctLjA4LjUyLS4xOS43Ny0uMzJsMS42Mi44MSAxLjA2LTEuMDYtLjgxLTEuNjJjLjEzLS4yNC4yMy0uNS4zMi0uNzdMMTIgNi43NXpNNiA4LjVhMi41IDIuNSAwIDAxMC01IDIuNSAyLjUgMCAwMTAgNXoiIGZpbGw9IiMwNTBGMTkiLz48L3N2Zz4=`;
		function makeSnackbarIcon(appSrc) {
		    switch (appSrc) {
		        case "coinbase-app":
		            return `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE0LjY3NCAxOC44NThjLTIuMDQ1IDAtMy42NDgtMS43MjItMy42NDgtMy44NDVzMS42NTktMy44NDUgMy42NDgtMy44NDVjMS44MjQgMCAzLjMxNyAxLjM3NyAzLjU5MyAzLjIxNGgzLjcwM2MtLjMzMS0zLjk2LTMuNDgyLTcuMDU5LTcuMjk2LTcuMDU5LTQuMDM0IDAtNy4zNSAzLjQ0My03LjM1IDcuNjkgMCA0LjI0NiAzLjI2IDcuNjkgNy4zNSA3LjY5IDMuODcgMCA2Ljk2NS0zLjEgNy4yOTYtNy4wNTloLTMuNzAzYy0uMjc2IDEuODM2LTEuNzY5IDMuMjE0LTMuNTkzIDMuMjE0WiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0wIDEwLjY3OGMwLTMuNzExIDAtNS41OTYuNzQyLTcuMDIzQTYuNTMyIDYuNTMyIDAgMCAxIDMuNjU1Ljc0MkM1LjA4MiAwIDYuOTY3IDAgMTAuNjc4IDBoNy45MzhjMy43MTEgMCA1LjU5NiAwIDcuMDIzLjc0MmE2LjUzMSA2LjUzMSAwIDAgMSAyLjkxMyAyLjkxM2MuNzQyIDEuNDI3Ljc0MiAzLjMxMi43NDIgNy4wMjN2Ny45MzhjMCAzLjcxMSAwIDUuNTk2LS43NDIgNy4wMjNhNi41MzEgNi41MzEgMCAwIDEtMi45MTMgMi45MTNjLTEuNDI3Ljc0Mi0zLjMxMi43NDItNy4wMjMuNzQyaC03LjkzOGMtMy43MTEgMC01LjU5NiAwLTcuMDIzLS43NDJhNi41MzEgNi41MzEgMCAwIDEtMi45MTMtMi45MTNDMCAyNC4yMTIgMCAyMi4zODQgMCAxOC42MTZ2LTcuOTM4WiIgZmlsbD0iIzAwNTJGRiIvPjxwYXRoIGQ9Ik0xNC42ODQgMTkuNzczYy0yLjcyNyAwLTQuODY0LTIuMjk1LTQuODY0LTUuMTI2IDAtMi44MzEgMi4yMS01LjEyNyA0Ljg2NC01LjEyNyAyLjQzMiAwIDQuNDIyIDEuODM3IDQuNzkgNC4yODVoNC45MzhjLS40NDItNS4yOC00LjY0My05LjQxMS05LjcyOC05LjQxMS01LjM4IDAtOS44MDIgNC41OS05LjgwMiAxMC4yNTMgMCA1LjY2MiA0LjM0OCAxMC4yNTMgOS44MDIgMTAuMjUzIDUuMTU5IDAgOS4yODYtNC4xMzIgOS43MjgtOS40MTFoLTQuOTM4Yy0uMzY4IDIuNDQ4LTIuMzU4IDQuMjg0LTQuNzkgNC4yODRaIiBmaWxsPSIjZmZmIi8+PC9zdmc+`;
		        case "coinbase-wallet-app":
		        default:
		            return `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEuNDkyIDEwLjQxOWE4LjkzIDguOTMgMCAwMTguOTMtOC45M2gxMS4xNjNhOC45MyA4LjkzIDAgMDE4LjkzIDguOTN2MTEuMTYzYTguOTMgOC45MyAwIDAxLTguOTMgOC45M0gxMC40MjJhOC45MyA4LjkzIDAgMDEtOC45My04LjkzVjEwLjQxOXoiIGZpbGw9IiMxNjUyRjAiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjQxOSAwSDIxLjU4QzI3LjMzNSAwIDMyIDQuNjY1IDMyIDEwLjQxOVYyMS41OEMzMiAyNy4zMzUgMjcuMzM1IDMyIDIxLjU4MSAzMkgxMC40MkM0LjY2NSAzMiAwIDI3LjMzNSAwIDIxLjU4MVYxMC40MkMwIDQuNjY1IDQuNjY1IDAgMTAuNDE5IDB6bTAgMS40ODhhOC45MyA4LjkzIDAgMDAtOC45MyA4LjkzdjExLjE2M2E4LjkzIDguOTMgMCAwMDguOTMgOC45M0gyMS41OGE4LjkzIDguOTMgMCAwMDguOTMtOC45M1YxMC40MmE4LjkzIDguOTMgMCAwMC04LjkzLTguOTNIMTAuNDJ6IiBmaWxsPSIjZmZmIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45OTggMjYuMDQ5Yy01LjU0OSAwLTEwLjA0Ny00LjQ5OC0xMC4wNDctMTAuMDQ3IDAtNS41NDggNC40OTgtMTAuMDQ2IDEwLjA0Ny0xMC4wNDYgNS41NDggMCAxMC4wNDYgNC40OTggMTAuMDQ2IDEwLjA0NiAwIDUuNTQ5LTQuNDk4IDEwLjA0Ny0xMC4wNDYgMTAuMDQ3eiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0xMi43NjIgMTQuMjU0YzAtLjgyMi42NjctMS40ODkgMS40ODktMS40ODloMy40OTdjLjgyMiAwIDEuNDg4LjY2NiAxLjQ4OCAxLjQ4OXYzLjQ5N2MwIC44MjItLjY2NiAxLjQ4OC0xLjQ4OCAxLjQ4OGgtMy40OTdhMS40ODggMS40ODggMCAwMS0xLjQ4OS0xLjQ4OHYtMy40OTh6IiBmaWxsPSIjMTY1MkYwIi8+PC9zdmc+`;
		    }
		}
		class Snackbar {
		    constructor(options) {
		        this.items = new Map();
		        this.nextItemKey = 0;
		        this.root = null;
		        this.darkMode = options.darkMode;
		    }
		    attach(el) {
		        this.root = document.createElement("div");
		        this.root.className = "-cbwsdk-snackbar-root";
		        el.appendChild(this.root);
		        this.render();
		    }
		    presentItem(itemProps) {
		        const key = this.nextItemKey++;
		        this.items.set(key, itemProps);
		        this.render();
		        return () => {
		            this.items.delete(key);
		            this.render();
		        };
		    }
		    clear() {
		        this.items.clear();
		        this.render();
		    }
		    render() {
		        if (!this.root) {
		            return;
		        }
		        (0, preact_1.render)((0, preact_1.h)("div", null,
		            (0, preact_1.h)(exports.SnackbarContainer, { darkMode: this.darkMode }, Array.from(this.items.entries()).map(([key, itemProps]) => ((0, preact_1.h)(exports.SnackbarInstance, Object.assign({}, itemProps, { key: key })))))), this.root);
		    }
		}
		exports.Snackbar = Snackbar;
		const SnackbarContainer = props => ((0, preact_1.h)("div", { class: (0, clsx_1.default)("-cbwsdk-snackbar-container") },
		    (0, preact_1.h)("style", null, Snackbar_css_1.default),
		    (0, preact_1.h)("div", { class: "-cbwsdk-snackbar" }, props.children)));
		exports.SnackbarContainer = SnackbarContainer;
		const SnackbarInstance = ({ autoExpand, message, menuItems, appSrc, }) => {
		    const [hidden, setHidden] = (0, hooks_1.useState)(true);
		    const [expanded, setExpanded] = (0, hooks_1.useState)(autoExpand !== null && autoExpand !== void 0 ? autoExpand : false);
		    (0, hooks_1.useEffect)(() => {
		        const timers = [
		            window.setTimeout(() => {
		                setHidden(false);
		            }, 1),
		            window.setTimeout(() => {
		                setExpanded(true);
		            }, 10000),
		        ];
		        return () => {
		            timers.forEach(window.clearTimeout);
		        };
		    });
		    const toggleExpanded = () => {
		        setExpanded(!expanded);
		    };
		    return ((0, preact_1.h)("div", { class: (0, clsx_1.default)("-cbwsdk-snackbar-instance", hidden && "-cbwsdk-snackbar-instance-hidden", expanded && "-cbwsdk-snackbar-instance-expanded") },
		        (0, preact_1.h)("div", { class: "-cbwsdk-snackbar-instance-header", onClick: toggleExpanded },
		            (0, preact_1.h)("img", { src: makeSnackbarIcon(appSrc), class: "-cbwsdk-snackbar-instance-header-cblogo" }),
		            (0, preact_1.h)("div", { class: "-cbwsdk-snackbar-instance-header-message" }, message),
		            (0, preact_1.h)("div", { class: "-gear-container" },
		                !expanded && ((0, preact_1.h)("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
		                    (0, preact_1.h)("circle", { cx: "12", cy: "12", r: "12", fill: "#F5F7F8" }))),
		                (0, preact_1.h)("img", { src: gearIcon, class: "-gear-icon", title: "Expand" }))),
		        menuItems && menuItems.length > 0 && ((0, preact_1.h)("div", { class: "-cbwsdk-snackbar-instance-menu" }, menuItems.map((action, i) => ((0, preact_1.h)("div", { class: (0, clsx_1.default)("-cbwsdk-snackbar-instance-menu-item", action.isRed && "-cbwsdk-snackbar-instance-menu-item-is-red"), onClick: action.onClick, key: i },
		            (0, preact_1.h)("svg", { width: action.svgWidth, height: action.svgHeight, viewBox: "0 0 10 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
		                (0, preact_1.h)("path", { "fill-rule": action.defaultFillRule, "clip-rule": action.defaultClipRule, d: action.path, fill: "#AAAAAA" })),
		            (0, preact_1.h)("span", { class: (0, clsx_1.default)("-cbwsdk-snackbar-instance-menu-item-info", action.isRed &&
		                    "-cbwsdk-snackbar-instance-menu-item-info-is-red") }, action.info))))))));
		};
		exports.SnackbarInstance = SnackbarInstance; 
	} (Snackbar));

	var cssReset = {};

	var cssResetCss = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(cssResetCss, "__esModule", { value: true });
	cssResetCss.default = `@namespace svg "http://www.w3.org/2000/svg";.-cbwsdk-css-reset,.-cbwsdk-css-reset *{animation:none;animation-delay:0;animation-direction:normal;animation-duration:0;animation-fill-mode:none;animation-iteration-count:1;animation-name:none;animation-play-state:running;animation-timing-function:ease;backface-visibility:visible;background:0;background-attachment:scroll;background-clip:border-box;background-color:rgba(0,0,0,0);background-image:none;background-origin:padding-box;background-position:0 0;background-position-x:0;background-position-y:0;background-repeat:repeat;background-size:auto auto;border:0;border-style:none;border-width:medium;border-color:inherit;border-bottom:0;border-bottom-color:inherit;border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-style:none;border-bottom-width:medium;border-collapse:separate;border-image:none;border-left:0;border-left-color:inherit;border-left-style:none;border-left-width:medium;border-radius:0;border-right:0;border-right-color:inherit;border-right-style:none;border-right-width:medium;border-spacing:0;border-top:0;border-top-color:inherit;border-top-left-radius:0;border-top-right-radius:0;border-top-style:none;border-top-width:medium;box-shadow:none;box-sizing:border-box;caption-side:top;clear:none;clip:auto;color:inherit;columns:auto;column-count:auto;column-fill:balance;column-gap:normal;column-rule:medium none currentColor;column-rule-color:currentColor;column-rule-style:none;column-rule-width:none;column-span:1;column-width:auto;counter-increment:none;counter-reset:none;direction:ltr;empty-cells:show;float:none;font:normal;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;height:auto;hyphens:none;letter-spacing:normal;line-height:normal;list-style:none;list-style-image:none;list-style-position:outside;list-style-type:disc;margin:0;margin-bottom:0;margin-left:0;margin-right:0;margin-top:0;opacity:1;orphans:0;outline:0;outline-color:invert;outline-style:none;outline-width:medium;overflow:visible;overflow-x:visible;overflow-y:visible;padding:0;padding-bottom:0;padding-left:0;padding-right:0;padding-top:0;page-break-after:auto;page-break-before:auto;page-break-inside:auto;perspective:none;perspective-origin:50% 50%;pointer-events:auto;position:static;quotes:"\\201C" "\\201D" "\\2018" "\\2019";tab-size:8;table-layout:auto;text-align:inherit;text-align-last:auto;text-decoration:none;text-decoration-color:inherit;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-shadow:none;text-transform:none;transform:none;transform-style:flat;transition:none;transition-delay:0s;transition-duration:0s;transition-property:none;transition-timing-function:ease;unicode-bidi:normal;vertical-align:baseline;visibility:visible;white-space:normal;widows:0;word-spacing:normal;z-index:auto}.-cbwsdk-css-reset strong{font-weight:bold}.-cbwsdk-css-reset *{box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;line-height:1}.-cbwsdk-css-reset [class*=container]{margin:0;padding:0}.-cbwsdk-css-reset style{display:none}`;

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	var __importDefault$1 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(cssReset, "__esModule", { value: true });
	cssReset.injectCssReset = void 0;
	const cssReset_css_1 = __importDefault$1(cssResetCss);
	function injectCssReset() {
	    const styleEl = document.createElement("style");
	    styleEl.type = "text/css";
	    styleEl.appendChild(document.createTextNode(cssReset_css_1.default));
	    document.documentElement.appendChild(styleEl);
	}
	cssReset.injectCssReset = injectCssReset;

	Object.defineProperty(WalletSDKUI$1, "__esModule", { value: true });
	WalletSDKUI$1.WalletSDKUI = void 0;
	const LinkFlow_1 = LinkFlow$1;
	const Snackbar_1 = Snackbar;
	const cssReset_1 = cssReset;
	class WalletSDKUI {
	    constructor(options) {
	        this.standalone = null;
	        this.attached = false;
	        this.appSrc = null;
	        this.snackbar = new Snackbar_1.Snackbar({
	            darkMode: options.darkMode,
	        });
	        this.linkFlow = new LinkFlow_1.LinkFlow({
	            darkMode: options.darkMode,
	            version: options.version,
	            sessionId: options.session.id,
	            sessionSecret: options.session.secret,
	            linkAPIUrl: options.linkAPIUrl,
	            connected$: options.connected$,
	            chainId$: options.chainId$,
	            isParentConnection: false,
	        });
	    }
	    attach() {
	        if (this.attached) {
	            throw new Error("Coinbase Wallet SDK UI is already attached");
	        }
	        const el = document.documentElement;
	        const container = document.createElement("div");
	        container.className = "-cbwsdk-css-reset";
	        el.appendChild(container);
	        this.linkFlow.attach(container);
	        this.snackbar.attach(container);
	        this.attached = true;
	        (0, cssReset_1.injectCssReset)();
	    }
	    setConnectDisabled(connectDisabled) {
	        this.linkFlow.setConnectDisabled(connectDisabled);
	    }
	    /* istanbul ignore next */
	    addEthereumChain(_options) {
	        // no-op
	    }
	    /* istanbul ignore next */
	    watchAsset(_options) {
	        // no-op
	    }
	    /* istanbul ignore next */
	    switchEthereumChain(_options) {
	        // no-op
	    }
	    requestEthereumAccounts(options) {
	        this.linkFlow.open({ onCancel: options.onCancel });
	    }
	    hideRequestEthereumAccounts() {
	        this.linkFlow.close();
	    }
	    /* istanbul ignore next */
	    signEthereumMessage(_) {
	        // No-op
	    }
	    /* istanbul ignore next */
	    signEthereumTransaction(_) {
	        // No-op
	    }
	    /* istanbul ignore next */
	    submitEthereumTransaction(_) {
	        // No-op
	    }
	    /* istanbul ignore next */
	    ethereumAddressFromSignedMessage(_) {
	        // No-op
	    }
	    showConnecting(options) {
	        let snackbarProps;
	        if (options.isUnlinkedErrorState) {
	            snackbarProps = {
	                autoExpand: true,
	                message: "Connection lost",
	                appSrc: this.appSrc,
	                menuItems: [
	                    {
	                        isRed: false,
	                        info: "Reset connection",
	                        svgWidth: "10",
	                        svgHeight: "11",
	                        path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
	                        defaultFillRule: "evenodd",
	                        defaultClipRule: "evenodd",
	                        onClick: options.onResetConnection,
	                    },
	                ],
	            };
	        }
	        else {
	            snackbarProps = {
	                message: "Confirm on phone",
	                appSrc: this.appSrc,
	                menuItems: [
	                    {
	                        isRed: true,
	                        info: "Cancel transaction",
	                        svgWidth: "11",
	                        svgHeight: "11",
	                        path: "M10.3711 1.52346L9.21775 0.370117L5.37109 4.21022L1.52444 0.370117L0.371094 1.52346L4.2112 5.37012L0.371094 9.21677L1.52444 10.3701L5.37109 6.53001L9.21775 10.3701L10.3711 9.21677L6.53099 5.37012L10.3711 1.52346Z",
	                        defaultFillRule: "inherit",
	                        defaultClipRule: "inherit",
	                        onClick: options.onCancel,
	                    },
	                    {
	                        isRed: false,
	                        info: "Reset connection",
	                        svgWidth: "10",
	                        svgHeight: "11",
	                        path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
	                        defaultFillRule: "evenodd",
	                        defaultClipRule: "evenodd",
	                        onClick: options.onResetConnection,
	                    },
	                ],
	            };
	        }
	        return this.snackbar.presentItem(snackbarProps);
	    }
	    /* istanbul ignore next */
	    setAppSrc(appSrc) {
	        this.appSrc = appSrc;
	    }
	    /* istanbul ignore next */
	    reloadUI() {
	        document.location.reload();
	    }
	    /* istanbul ignore next */
	    inlineAccountsResponse() {
	        return false;
	    }
	    /* istanbul ignore next */
	    inlineAddEthereumChain(_chainId) {
	        return false;
	    }
	    /* istanbul ignore next */
	    inlineWatchAsset() {
	        return false;
	    }
	    /* istanbul ignore next */
	    inlineSwitchEthereumChain() {
	        return false;
	    }
	    /* istanbul ignore next */
	    setStandalone(status) {
	        this.standalone = status;
	    }
	    /* istanbul ignore next */
	    isStandalone() {
	        var _a;
	        return (_a = this.standalone) !== null && _a !== void 0 ? _a : false;
	    }
	}
	WalletSDKUI$1.WalletSDKUI = WalletSDKUI;

	var WalletSDKRelay$1 = {};

	var bindDecorator = {};

	Object.defineProperty(bindDecorator, "__esModule", { value: true });
	var constants$2;
	(function (constants) {
	    constants.typeOfFunction = 'function';
	    constants.boolTrue = true;
	})(constants$2 || (constants$2 = {}));
	function bind(target, propertyKey, descriptor) {
	    if (!descriptor || (typeof descriptor.value !== constants$2.typeOfFunction)) {
	        throw new TypeError("Only methods can be decorated with @bind. <" + propertyKey + "> is not a method!");
	    }
	    return {
	        configurable: constants$2.boolTrue,
	        get: function () {
	            var bound = descriptor.value.bind(this);
	            // Credits to https://github.com/andreypopp/autobind-decorator for memoizing the result of bind against a symbol on the instance.
	            Object.defineProperty(this, propertyKey, {
	                value: bound,
	                configurable: constants$2.boolTrue,
	                writable: constants$2.boolTrue
	            });
	            return bound;
	        }
	    };
	}
	bindDecorator.bind = bind;
	bindDecorator.default = bind;

	/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
	function audit(durationSelector) {
	    return function auditOperatorFunction(source) {
	        return source.lift(new AuditOperator(durationSelector));
	    };
	}
	var AuditOperator = /*@__PURE__*/ (function () {
	    function AuditOperator(durationSelector) {
	        this.durationSelector = durationSelector;
	    }
	    AuditOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
	    };
	    return AuditOperator;
	}());
	var AuditSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(AuditSubscriber, _super);
	    function AuditSubscriber(destination, durationSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.durationSelector = durationSelector;
	        _this.hasValue = false;
	        return _this;
	    }
	    AuditSubscriber.prototype._next = function (value) {
	        this.value = value;
	        this.hasValue = true;
	        if (!this.throttled) {
	            var duration = void 0;
	            try {
	                var durationSelector = this.durationSelector;
	                duration = durationSelector(value);
	            }
	            catch (err) {
	                return this.destination.error(err);
	            }
	            var innerSubscription = innerSubscribe(duration, new SimpleInnerSubscriber(this));
	            if (!innerSubscription || innerSubscription.closed) {
	                this.clearThrottle();
	            }
	            else {
	                this.add(this.throttled = innerSubscription);
	            }
	        }
	    };
	    AuditSubscriber.prototype.clearThrottle = function () {
	        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
	        if (throttled) {
	            this.remove(throttled);
	            this.throttled = undefined;
	            throttled.unsubscribe();
	        }
	        if (hasValue) {
	            this.value = undefined;
	            this.hasValue = false;
	            this.destination.next(value);
	        }
	    };
	    AuditSubscriber.prototype.notifyNext = function () {
	        this.clearThrottle();
	    };
	    AuditSubscriber.prototype.notifyComplete = function () {
	        this.clearThrottle();
	    };
	    return AuditSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START _scheduler_async,_audit,_observable_timer PURE_IMPORTS_END */
	function auditTime(duration, scheduler) {
	    if (scheduler === void 0) {
	        scheduler = async;
	    }
	    return audit(function () { return timer(duration, scheduler); });
	}

	/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
	function buffer(closingNotifier) {
	    return function bufferOperatorFunction(source) {
	        return source.lift(new BufferOperator(closingNotifier));
	    };
	}
	var BufferOperator = /*@__PURE__*/ (function () {
	    function BufferOperator(closingNotifier) {
	        this.closingNotifier = closingNotifier;
	    }
	    BufferOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
	    };
	    return BufferOperator;
	}());
	var BufferSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(BufferSubscriber, _super);
	    function BufferSubscriber(destination, closingNotifier) {
	        var _this = _super.call(this, destination) || this;
	        _this.buffer = [];
	        _this.add(innerSubscribe(closingNotifier, new SimpleInnerSubscriber(_this)));
	        return _this;
	    }
	    BufferSubscriber.prototype._next = function (value) {
	        this.buffer.push(value);
	    };
	    BufferSubscriber.prototype.notifyNext = function () {
	        var buffer = this.buffer;
	        this.buffer = [];
	        this.destination.next(buffer);
	    };
	    return BufferSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function bufferCount(bufferSize, startBufferEvery) {
	    if (startBufferEvery === void 0) {
	        startBufferEvery = null;
	    }
	    return function bufferCountOperatorFunction(source) {
	        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
	    };
	}
	var BufferCountOperator = /*@__PURE__*/ (function () {
	    function BufferCountOperator(bufferSize, startBufferEvery) {
	        this.bufferSize = bufferSize;
	        this.startBufferEvery = startBufferEvery;
	        if (!startBufferEvery || bufferSize === startBufferEvery) {
	            this.subscriberClass = BufferCountSubscriber;
	        }
	        else {
	            this.subscriberClass = BufferSkipCountSubscriber;
	        }
	    }
	    BufferCountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
	    };
	    return BufferCountOperator;
	}());
	var BufferCountSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(BufferCountSubscriber, _super);
	    function BufferCountSubscriber(destination, bufferSize) {
	        var _this = _super.call(this, destination) || this;
	        _this.bufferSize = bufferSize;
	        _this.buffer = [];
	        return _this;
	    }
	    BufferCountSubscriber.prototype._next = function (value) {
	        var buffer = this.buffer;
	        buffer.push(value);
	        if (buffer.length == this.bufferSize) {
	            this.destination.next(buffer);
	            this.buffer = [];
	        }
	    };
	    BufferCountSubscriber.prototype._complete = function () {
	        var buffer = this.buffer;
	        if (buffer.length > 0) {
	            this.destination.next(buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    return BufferCountSubscriber;
	}(Subscriber));
	var BufferSkipCountSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(BufferSkipCountSubscriber, _super);
	    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
	        var _this = _super.call(this, destination) || this;
	        _this.bufferSize = bufferSize;
	        _this.startBufferEvery = startBufferEvery;
	        _this.buffers = [];
	        _this.count = 0;
	        return _this;
	    }
	    BufferSkipCountSubscriber.prototype._next = function (value) {
	        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
	        this.count++;
	        if (count % startBufferEvery === 0) {
	            buffers.push([]);
	        }
	        for (var i = buffers.length; i--;) {
	            var buffer = buffers[i];
	            buffer.push(value);
	            if (buffer.length === bufferSize) {
	                buffers.splice(i, 1);
	                this.destination.next(buffer);
	            }
	        }
	    };
	    BufferSkipCountSubscriber.prototype._complete = function () {
	        var _a = this, buffers = _a.buffers, destination = _a.destination;
	        while (buffers.length > 0) {
	            var buffer = buffers.shift();
	            if (buffer.length > 0) {
	                destination.next(buffer);
	            }
	        }
	        _super.prototype._complete.call(this);
	    };
	    return BufferSkipCountSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_scheduler_async,_Subscriber,_util_isScheduler PURE_IMPORTS_END */
	function bufferTime(bufferTimeSpan) {
	    var length = arguments.length;
	    var scheduler = async;
	    if (isScheduler(arguments[arguments.length - 1])) {
	        scheduler = arguments[arguments.length - 1];
	        length--;
	    }
	    var bufferCreationInterval = null;
	    if (length >= 2) {
	        bufferCreationInterval = arguments[1];
	    }
	    var maxBufferSize = Number.POSITIVE_INFINITY;
	    if (length >= 3) {
	        maxBufferSize = arguments[2];
	    }
	    return function bufferTimeOperatorFunction(source) {
	        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
	    };
	}
	var BufferTimeOperator = /*@__PURE__*/ (function () {
	    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
	        this.bufferTimeSpan = bufferTimeSpan;
	        this.bufferCreationInterval = bufferCreationInterval;
	        this.maxBufferSize = maxBufferSize;
	        this.scheduler = scheduler;
	    }
	    BufferTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
	    };
	    return BufferTimeOperator;
	}());
	var Context = /*@__PURE__*/ (function () {
	    function Context() {
	        this.buffer = [];
	    }
	    return Context;
	}());
	var BufferTimeSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(BufferTimeSubscriber, _super);
	    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.bufferTimeSpan = bufferTimeSpan;
	        _this.bufferCreationInterval = bufferCreationInterval;
	        _this.maxBufferSize = maxBufferSize;
	        _this.scheduler = scheduler;
	        _this.contexts = [];
	        var context = _this.openContext();
	        _this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
	        if (_this.timespanOnly) {
	            var timeSpanOnlyState = { subscriber: _this, context: context, bufferTimeSpan: bufferTimeSpan };
	            _this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
	        }
	        else {
	            var closeState = { subscriber: _this, context: context };
	            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: _this, scheduler: scheduler };
	            _this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
	            _this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
	        }
	        return _this;
	    }
	    BufferTimeSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        var len = contexts.length;
	        var filledBufferContext;
	        for (var i = 0; i < len; i++) {
	            var context_1 = contexts[i];
	            var buffer = context_1.buffer;
	            buffer.push(value);
	            if (buffer.length == this.maxBufferSize) {
	                filledBufferContext = context_1;
	            }
	        }
	        if (filledBufferContext) {
	            this.onBufferFull(filledBufferContext);
	        }
	    };
	    BufferTimeSubscriber.prototype._error = function (err) {
	        this.contexts.length = 0;
	        _super.prototype._error.call(this, err);
	    };
	    BufferTimeSubscriber.prototype._complete = function () {
	        var _a = this, contexts = _a.contexts, destination = _a.destination;
	        while (contexts.length > 0) {
	            var context_2 = contexts.shift();
	            destination.next(context_2.buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    BufferTimeSubscriber.prototype._unsubscribe = function () {
	        this.contexts = null;
	    };
	    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
	        this.closeContext(context);
	        var closeAction = context.closeAction;
	        closeAction.unsubscribe();
	        this.remove(closeAction);
	        if (!this.closed && this.timespanOnly) {
	            context = this.openContext();
	            var bufferTimeSpan = this.bufferTimeSpan;
	            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
	            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
	        }
	    };
	    BufferTimeSubscriber.prototype.openContext = function () {
	        var context = new Context();
	        this.contexts.push(context);
	        return context;
	    };
	    BufferTimeSubscriber.prototype.closeContext = function (context) {
	        this.destination.next(context.buffer);
	        var contexts = this.contexts;
	        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
	        if (spliceIndex >= 0) {
	            contexts.splice(contexts.indexOf(context), 1);
	        }
	    };
	    return BufferTimeSubscriber;
	}(Subscriber));
	function dispatchBufferTimeSpanOnly(state) {
	    var subscriber = state.subscriber;
	    var prevContext = state.context;
	    if (prevContext) {
	        subscriber.closeContext(prevContext);
	    }
	    if (!subscriber.closed) {
	        state.context = subscriber.openContext();
	        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
	    }
	}
	function dispatchBufferCreation(state) {
	    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
	    var context = subscriber.openContext();
	    var action = this;
	    if (!subscriber.closed) {
	        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
	        action.schedule(state, bufferCreationInterval);
	    }
	}
	function dispatchBufferClose(arg) {
	    var subscriber = arg.subscriber, context = arg.context;
	    subscriber.closeContext(context);
	}

	/** PURE_IMPORTS_START tslib,_Subscription,_util_subscribeToResult,_OuterSubscriber PURE_IMPORTS_END */
	function bufferToggle(openings, closingSelector) {
	    return function bufferToggleOperatorFunction(source) {
	        return source.lift(new BufferToggleOperator(openings, closingSelector));
	    };
	}
	var BufferToggleOperator = /*@__PURE__*/ (function () {
	    function BufferToggleOperator(openings, closingSelector) {
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	    }
	    BufferToggleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
	    };
	    return BufferToggleOperator;
	}());
	var BufferToggleSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(BufferToggleSubscriber, _super);
	    function BufferToggleSubscriber(destination, openings, closingSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.closingSelector = closingSelector;
	        _this.contexts = [];
	        _this.add(subscribeToResult(_this, openings));
	        return _this;
	    }
	    BufferToggleSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        var len = contexts.length;
	        for (var i = 0; i < len; i++) {
	            contexts[i].buffer.push(value);
	        }
	    };
	    BufferToggleSubscriber.prototype._error = function (err) {
	        var contexts = this.contexts;
	        while (contexts.length > 0) {
	            var context_1 = contexts.shift();
	            context_1.subscription.unsubscribe();
	            context_1.buffer = null;
	            context_1.subscription = null;
	        }
	        this.contexts = null;
	        _super.prototype._error.call(this, err);
	    };
	    BufferToggleSubscriber.prototype._complete = function () {
	        var contexts = this.contexts;
	        while (contexts.length > 0) {
	            var context_2 = contexts.shift();
	            this.destination.next(context_2.buffer);
	            context_2.subscription.unsubscribe();
	            context_2.buffer = null;
	            context_2.subscription = null;
	        }
	        this.contexts = null;
	        _super.prototype._complete.call(this);
	    };
	    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue) {
	        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
	    };
	    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.closeBuffer(innerSub.context);
	    };
	    BufferToggleSubscriber.prototype.openBuffer = function (value) {
	        try {
	            var closingSelector = this.closingSelector;
	            var closingNotifier = closingSelector.call(this, value);
	            if (closingNotifier) {
	                this.trySubscribe(closingNotifier);
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
	        var contexts = this.contexts;
	        if (contexts && context) {
	            var buffer = context.buffer, subscription = context.subscription;
	            this.destination.next(buffer);
	            contexts.splice(contexts.indexOf(context), 1);
	            this.remove(subscription);
	            subscription.unsubscribe();
	        }
	    };
	    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
	        var contexts = this.contexts;
	        var buffer = [];
	        var subscription = new Subscription();
	        var context = { buffer: buffer, subscription: subscription };
	        contexts.push(context);
	        var innerSubscription = subscribeToResult(this, closingNotifier, context);
	        if (!innerSubscription || innerSubscription.closed) {
	            this.closeBuffer(context);
	        }
	        else {
	            innerSubscription.context = context;
	            this.add(innerSubscription);
	            subscription.add(innerSubscription);
	        }
	    };
	    return BufferToggleSubscriber;
	}(OuterSubscriber));

	/** PURE_IMPORTS_START tslib,_Subscription,_innerSubscribe PURE_IMPORTS_END */
	function bufferWhen(closingSelector) {
	    return function (source) {
	        return source.lift(new BufferWhenOperator(closingSelector));
	    };
	}
	var BufferWhenOperator = /*@__PURE__*/ (function () {
	    function BufferWhenOperator(closingSelector) {
	        this.closingSelector = closingSelector;
	    }
	    BufferWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
	    };
	    return BufferWhenOperator;
	}());
	var BufferWhenSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(BufferWhenSubscriber, _super);
	    function BufferWhenSubscriber(destination, closingSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.closingSelector = closingSelector;
	        _this.subscribing = false;
	        _this.openBuffer();
	        return _this;
	    }
	    BufferWhenSubscriber.prototype._next = function (value) {
	        this.buffer.push(value);
	    };
	    BufferWhenSubscriber.prototype._complete = function () {
	        var buffer = this.buffer;
	        if (buffer) {
	            this.destination.next(buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    BufferWhenSubscriber.prototype._unsubscribe = function () {
	        this.buffer = undefined;
	        this.subscribing = false;
	    };
	    BufferWhenSubscriber.prototype.notifyNext = function () {
	        this.openBuffer();
	    };
	    BufferWhenSubscriber.prototype.notifyComplete = function () {
	        if (this.subscribing) {
	            this.complete();
	        }
	        else {
	            this.openBuffer();
	        }
	    };
	    BufferWhenSubscriber.prototype.openBuffer = function () {
	        var closingSubscription = this.closingSubscription;
	        if (closingSubscription) {
	            this.remove(closingSubscription);
	            closingSubscription.unsubscribe();
	        }
	        var buffer = this.buffer;
	        if (this.buffer) {
	            this.destination.next(buffer);
	        }
	        this.buffer = [];
	        var closingNotifier;
	        try {
	            var closingSelector = this.closingSelector;
	            closingNotifier = closingSelector();
	        }
	        catch (err) {
	            return this.error(err);
	        }
	        closingSubscription = new Subscription();
	        this.closingSubscription = closingSubscription;
	        this.add(closingSubscription);
	        this.subscribing = true;
	        closingSubscription.add(innerSubscribe(closingNotifier, new SimpleInnerSubscriber(this)));
	        this.subscribing = false;
	    };
	    return BufferWhenSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
	function catchError(selector) {
	    return function catchErrorOperatorFunction(source) {
	        var operator = new CatchOperator(selector);
	        var caught = source.lift(operator);
	        return (operator.caught = caught);
	    };
	}
	var CatchOperator = /*@__PURE__*/ (function () {
	    function CatchOperator(selector) {
	        this.selector = selector;
	    }
	    CatchOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
	    };
	    return CatchOperator;
	}());
	var CatchSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(CatchSubscriber, _super);
	    function CatchSubscriber(destination, selector, caught) {
	        var _this = _super.call(this, destination) || this;
	        _this.selector = selector;
	        _this.caught = caught;
	        return _this;
	    }
	    CatchSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var result = void 0;
	            try {
	                result = this.selector(err, this.caught);
	            }
	            catch (err2) {
	                _super.prototype.error.call(this, err2);
	                return;
	            }
	            this._unsubscribeAndRecycle();
	            var innerSubscriber = new SimpleInnerSubscriber(this);
	            this.add(innerSubscriber);
	            var innerSubscription = innerSubscribe(result, innerSubscriber);
	            if (innerSubscription !== innerSubscriber) {
	                this.add(innerSubscription);
	            }
	        }
	    };
	    return CatchSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START _observable_combineLatest PURE_IMPORTS_END */
	function combineAll(project) {
	    return function (source) { return source.lift(new CombineLatestOperator(project)); };
	}

	/** PURE_IMPORTS_START _util_isArray,_observable_combineLatest,_observable_from PURE_IMPORTS_END */
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    var project = null;
	    if (typeof observables[observables.length - 1] === 'function') {
	        project = observables.pop();
	    }
	    if (observables.length === 1 && isArray(observables[0])) {
	        observables = observables[0].slice();
	    }
	    return function (source) { return source.lift.call(from([source].concat(observables)), new CombineLatestOperator(project)); };
	}

	/** PURE_IMPORTS_START _observable_concat PURE_IMPORTS_END */
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    return function (source) { return source.lift.call(concat$1.apply(void 0, [source].concat(observables))); };
	}

	/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */
	function concatMap(project, resultSelector) {
	    return mergeMap(project, resultSelector, 1);
	}

	/** PURE_IMPORTS_START _concatMap PURE_IMPORTS_END */
	function concatMapTo(innerObservable, resultSelector) {
	    return concatMap(function () { return innerObservable; }, resultSelector);
	}

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function count(predicate) {
	    return function (source) { return source.lift(new CountOperator(predicate, source)); };
	}
	var CountOperator = /*@__PURE__*/ (function () {
	    function CountOperator(predicate, source) {
	        this.predicate = predicate;
	        this.source = source;
	    }
	    CountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
	    };
	    return CountOperator;
	}());
	var CountSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(CountSubscriber, _super);
	    function CountSubscriber(destination, predicate, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.source = source;
	        _this.count = 0;
	        _this.index = 0;
	        return _this;
	    }
	    CountSubscriber.prototype._next = function (value) {
	        if (this.predicate) {
	            this._tryPredicate(value);
	        }
	        else {
	            this.count++;
	        }
	    };
	    CountSubscriber.prototype._tryPredicate = function (value) {
	        var result;
	        try {
	            result = this.predicate(value, this.index++, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this.count++;
	        }
	    };
	    CountSubscriber.prototype._complete = function () {
	        this.destination.next(this.count);
	        this.destination.complete();
	    };
	    return CountSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
	function debounce(durationSelector) {
	    return function (source) { return source.lift(new DebounceOperator(durationSelector)); };
	}
	var DebounceOperator = /*@__PURE__*/ (function () {
	    function DebounceOperator(durationSelector) {
	        this.durationSelector = durationSelector;
	    }
	    DebounceOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
	    };
	    return DebounceOperator;
	}());
	var DebounceSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(DebounceSubscriber, _super);
	    function DebounceSubscriber(destination, durationSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.durationSelector = durationSelector;
	        _this.hasValue = false;
	        return _this;
	    }
	    DebounceSubscriber.prototype._next = function (value) {
	        try {
	            var result = this.durationSelector.call(this, value);
	            if (result) {
	                this._tryNext(value, result);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    DebounceSubscriber.prototype._complete = function () {
	        this.emitValue();
	        this.destination.complete();
	    };
	    DebounceSubscriber.prototype._tryNext = function (value, duration) {
	        var subscription = this.durationSubscription;
	        this.value = value;
	        this.hasValue = true;
	        if (subscription) {
	            subscription.unsubscribe();
	            this.remove(subscription);
	        }
	        subscription = innerSubscribe(duration, new SimpleInnerSubscriber(this));
	        if (subscription && !subscription.closed) {
	            this.add(this.durationSubscription = subscription);
	        }
	    };
	    DebounceSubscriber.prototype.notifyNext = function () {
	        this.emitValue();
	    };
	    DebounceSubscriber.prototype.notifyComplete = function () {
	        this.emitValue();
	    };
	    DebounceSubscriber.prototype.emitValue = function () {
	        if (this.hasValue) {
	            var value = this.value;
	            var subscription = this.durationSubscription;
	            if (subscription) {
	                this.durationSubscription = undefined;
	                subscription.unsubscribe();
	                this.remove(subscription);
	            }
	            this.value = undefined;
	            this.hasValue = false;
	            _super.prototype._next.call(this, value);
	        }
	    };
	    return DebounceSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */
	function debounceTime(dueTime, scheduler) {
	    if (scheduler === void 0) {
	        scheduler = async;
	    }
	    return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
	}
	var DebounceTimeOperator = /*@__PURE__*/ (function () {
	    function DebounceTimeOperator(dueTime, scheduler) {
	        this.dueTime = dueTime;
	        this.scheduler = scheduler;
	    }
	    DebounceTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
	    };
	    return DebounceTimeOperator;
	}());
	var DebounceTimeSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(DebounceTimeSubscriber, _super);
	    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.dueTime = dueTime;
	        _this.scheduler = scheduler;
	        _this.debouncedSubscription = null;
	        _this.lastValue = null;
	        _this.hasValue = false;
	        return _this;
	    }
	    DebounceTimeSubscriber.prototype._next = function (value) {
	        this.clearDebounce();
	        this.lastValue = value;
	        this.hasValue = true;
	        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext$1, this.dueTime, this));
	    };
	    DebounceTimeSubscriber.prototype._complete = function () {
	        this.debouncedNext();
	        this.destination.complete();
	    };
	    DebounceTimeSubscriber.prototype.debouncedNext = function () {
	        this.clearDebounce();
	        if (this.hasValue) {
	            var lastValue = this.lastValue;
	            this.lastValue = null;
	            this.hasValue = false;
	            this.destination.next(lastValue);
	        }
	    };
	    DebounceTimeSubscriber.prototype.clearDebounce = function () {
	        var debouncedSubscription = this.debouncedSubscription;
	        if (debouncedSubscription !== null) {
	            this.remove(debouncedSubscription);
	            debouncedSubscription.unsubscribe();
	            this.debouncedSubscription = null;
	        }
	    };
	    return DebounceTimeSubscriber;
	}(Subscriber));
	function dispatchNext$1(subscriber) {
	    subscriber.debouncedNext();
	}

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function defaultIfEmpty(defaultValue) {
	    if (defaultValue === void 0) {
	        defaultValue = null;
	    }
	    return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
	}
	var DefaultIfEmptyOperator = /*@__PURE__*/ (function () {
	    function DefaultIfEmptyOperator(defaultValue) {
	        this.defaultValue = defaultValue;
	    }
	    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
	    };
	    return DefaultIfEmptyOperator;
	}());
	var DefaultIfEmptySubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(DefaultIfEmptySubscriber, _super);
	    function DefaultIfEmptySubscriber(destination, defaultValue) {
	        var _this = _super.call(this, destination) || this;
	        _this.defaultValue = defaultValue;
	        _this.isEmpty = true;
	        return _this;
	    }
	    DefaultIfEmptySubscriber.prototype._next = function (value) {
	        this.isEmpty = false;
	        this.destination.next(value);
	    };
	    DefaultIfEmptySubscriber.prototype._complete = function () {
	        if (this.isEmpty) {
	            this.destination.next(this.defaultValue);
	        }
	        this.destination.complete();
	    };
	    return DefaultIfEmptySubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */
	function isDate(value) {
	    return value instanceof Date && !isNaN(+value);
	}

	/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */
	function delay(delay, scheduler) {
	    if (scheduler === void 0) {
	        scheduler = async;
	    }
	    var absoluteDelay = isDate(delay);
	    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
	    return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
	}
	var DelayOperator = /*@__PURE__*/ (function () {
	    function DelayOperator(delay, scheduler) {
	        this.delay = delay;
	        this.scheduler = scheduler;
	    }
	    DelayOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
	    };
	    return DelayOperator;
	}());
	var DelaySubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(DelaySubscriber, _super);
	    function DelaySubscriber(destination, delay, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.delay = delay;
	        _this.scheduler = scheduler;
	        _this.queue = [];
	        _this.active = false;
	        _this.errored = false;
	        return _this;
	    }
	    DelaySubscriber.dispatch = function (state) {
	        var source = state.source;
	        var queue = source.queue;
	        var scheduler = state.scheduler;
	        var destination = state.destination;
	        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
	            queue.shift().notification.observe(destination);
	        }
	        if (queue.length > 0) {
	            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
	            this.schedule(state, delay_1);
	        }
	        else {
	            this.unsubscribe();
	            source.active = false;
	        }
	    };
	    DelaySubscriber.prototype._schedule = function (scheduler) {
	        this.active = true;
	        var destination = this.destination;
	        destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
	            source: this, destination: this.destination, scheduler: scheduler
	        }));
	    };
	    DelaySubscriber.prototype.scheduleNotification = function (notification) {
	        if (this.errored === true) {
	            return;
	        }
	        var scheduler = this.scheduler;
	        var message = new DelayMessage(scheduler.now() + this.delay, notification);
	        this.queue.push(message);
	        if (this.active === false) {
	            this._schedule(scheduler);
	        }
	    };
	    DelaySubscriber.prototype._next = function (value) {
	        this.scheduleNotification(Notification.createNext(value));
	    };
	    DelaySubscriber.prototype._error = function (err) {
	        this.errored = true;
	        this.queue = [];
	        this.destination.error(err);
	        this.unsubscribe();
	    };
	    DelaySubscriber.prototype._complete = function () {
	        this.scheduleNotification(Notification.createComplete());
	        this.unsubscribe();
	    };
	    return DelaySubscriber;
	}(Subscriber));
	var DelayMessage = /*@__PURE__*/ (function () {
	    function DelayMessage(time, notification) {
	        this.time = time;
	        this.notification = notification;
	    }
	    return DelayMessage;
	}());

	/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
	function delayWhen(delayDurationSelector, subscriptionDelay) {
	    if (subscriptionDelay) {
	        return function (source) {
	            return new SubscriptionDelayObservable(source, subscriptionDelay)
	                .lift(new DelayWhenOperator(delayDurationSelector));
	        };
	    }
	    return function (source) { return source.lift(new DelayWhenOperator(delayDurationSelector)); };
	}
	var DelayWhenOperator = /*@__PURE__*/ (function () {
	    function DelayWhenOperator(delayDurationSelector) {
	        this.delayDurationSelector = delayDurationSelector;
	    }
	    DelayWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
	    };
	    return DelayWhenOperator;
	}());
	var DelayWhenSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(DelayWhenSubscriber, _super);
	    function DelayWhenSubscriber(destination, delayDurationSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.delayDurationSelector = delayDurationSelector;
	        _this.completed = false;
	        _this.delayNotifierSubscriptions = [];
	        _this.index = 0;
	        return _this;
	    }
	    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, _innerValue, _outerIndex, _innerIndex, innerSub) {
	        this.destination.next(outerValue);
	        this.removeSubscription(innerSub);
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
	        var value = this.removeSubscription(innerSub);
	        if (value) {
	            this.destination.next(value);
	        }
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        try {
	            var delayNotifier = this.delayDurationSelector(value, index);
	            if (delayNotifier) {
	                this.tryDelay(delayNotifier, value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    DelayWhenSubscriber.prototype._complete = function () {
	        this.completed = true;
	        this.tryComplete();
	        this.unsubscribe();
	    };
	    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
	        subscription.unsubscribe();
	        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
	        if (subscriptionIdx !== -1) {
	            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
	        }
	        return subscription.outerValue;
	    };
	    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
	        var notifierSubscription = subscribeToResult(this, delayNotifier, value);
	        if (notifierSubscription && !notifierSubscription.closed) {
	            var destination = this.destination;
	            destination.add(notifierSubscription);
	            this.delayNotifierSubscriptions.push(notifierSubscription);
	        }
	    };
	    DelayWhenSubscriber.prototype.tryComplete = function () {
	        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
	            this.destination.complete();
	        }
	    };
	    return DelayWhenSubscriber;
	}(OuterSubscriber));
	var SubscriptionDelayObservable = /*@__PURE__*/ (function (_super) {
	    __extends$1(SubscriptionDelayObservable, _super);
	    function SubscriptionDelayObservable(source, subscriptionDelay) {
	        var _this = _super.call(this) || this;
	        _this.source = source;
	        _this.subscriptionDelay = subscriptionDelay;
	        return _this;
	    }
	    SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
	        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
	    };
	    return SubscriptionDelayObservable;
	}(Observable));
	var SubscriptionDelaySubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SubscriptionDelaySubscriber, _super);
	    function SubscriptionDelaySubscriber(parent, source) {
	        var _this = _super.call(this) || this;
	        _this.parent = parent;
	        _this.source = source;
	        _this.sourceSubscribed = false;
	        return _this;
	    }
	    SubscriptionDelaySubscriber.prototype._next = function (unused) {
	        this.subscribeToSource();
	    };
	    SubscriptionDelaySubscriber.prototype._error = function (err) {
	        this.unsubscribe();
	        this.parent.error(err);
	    };
	    SubscriptionDelaySubscriber.prototype._complete = function () {
	        this.unsubscribe();
	        this.subscribeToSource();
	    };
	    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
	        if (!this.sourceSubscribed) {
	            this.sourceSubscribed = true;
	            this.unsubscribe();
	            this.source.subscribe(this.parent);
	        }
	    };
	    return SubscriptionDelaySubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function dematerialize() {
	    return function dematerializeOperatorFunction(source) {
	        return source.lift(new DeMaterializeOperator());
	    };
	}
	var DeMaterializeOperator = /*@__PURE__*/ (function () {
	    function DeMaterializeOperator() {
	    }
	    DeMaterializeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DeMaterializeSubscriber(subscriber));
	    };
	    return DeMaterializeOperator;
	}());
	var DeMaterializeSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(DeMaterializeSubscriber, _super);
	    function DeMaterializeSubscriber(destination) {
	        return _super.call(this, destination) || this;
	    }
	    DeMaterializeSubscriber.prototype._next = function (value) {
	        value.observe(this.destination);
	    };
	    return DeMaterializeSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
	function distinct(keySelector, flushes) {
	    return function (source) { return source.lift(new DistinctOperator(keySelector, flushes)); };
	}
	var DistinctOperator = /*@__PURE__*/ (function () {
	    function DistinctOperator(keySelector, flushes) {
	        this.keySelector = keySelector;
	        this.flushes = flushes;
	    }
	    DistinctOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
	    };
	    return DistinctOperator;
	}());
	var DistinctSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(DistinctSubscriber, _super);
	    function DistinctSubscriber(destination, keySelector, flushes) {
	        var _this = _super.call(this, destination) || this;
	        _this.keySelector = keySelector;
	        _this.values = new Set();
	        if (flushes) {
	            _this.add(innerSubscribe(flushes, new SimpleInnerSubscriber(_this)));
	        }
	        return _this;
	    }
	    DistinctSubscriber.prototype.notifyNext = function () {
	        this.values.clear();
	    };
	    DistinctSubscriber.prototype.notifyError = function (error) {
	        this._error(error);
	    };
	    DistinctSubscriber.prototype._next = function (value) {
	        if (this.keySelector) {
	            this._useKeySelector(value);
	        }
	        else {
	            this._finalizeNext(value, value);
	        }
	    };
	    DistinctSubscriber.prototype._useKeySelector = function (value) {
	        var key;
	        var destination = this.destination;
	        try {
	            key = this.keySelector(value);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        this._finalizeNext(key, value);
	    };
	    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
	        var values = this.values;
	        if (!values.has(key)) {
	            values.add(key);
	            this.destination.next(value);
	        }
	    };
	    return DistinctSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function distinctUntilChanged(compare, keySelector) {
	    return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
	}
	var DistinctUntilChangedOperator = /*@__PURE__*/ (function () {
	    function DistinctUntilChangedOperator(compare, keySelector) {
	        this.compare = compare;
	        this.keySelector = keySelector;
	    }
	    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
	    };
	    return DistinctUntilChangedOperator;
	}());
	var DistinctUntilChangedSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(DistinctUntilChangedSubscriber, _super);
	    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.keySelector = keySelector;
	        _this.hasKey = false;
	        if (typeof compare === 'function') {
	            _this.compare = compare;
	        }
	        return _this;
	    }
	    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
	        return x === y;
	    };
	    DistinctUntilChangedSubscriber.prototype._next = function (value) {
	        var key;
	        try {
	            var keySelector = this.keySelector;
	            key = keySelector ? keySelector(value) : value;
	        }
	        catch (err) {
	            return this.destination.error(err);
	        }
	        var result = false;
	        if (this.hasKey) {
	            try {
	                var compare = this.compare;
	                result = compare(this.key, key);
	            }
	            catch (err) {
	                return this.destination.error(err);
	            }
	        }
	        else {
	            this.hasKey = true;
	        }
	        if (!result) {
	            this.key = key;
	            this.destination.next(value);
	        }
	    };
	    return DistinctUntilChangedSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START _distinctUntilChanged PURE_IMPORTS_END */
	function distinctUntilKeyChanged(key, compare) {
	    return distinctUntilChanged(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
	}

	/** PURE_IMPORTS_START tslib,_util_EmptyError,_Subscriber PURE_IMPORTS_END */
	function throwIfEmpty(errorFactory) {
	    if (errorFactory === void 0) {
	        errorFactory = defaultErrorFactory;
	    }
	    return function (source) {
	        return source.lift(new ThrowIfEmptyOperator(errorFactory));
	    };
	}
	var ThrowIfEmptyOperator = /*@__PURE__*/ (function () {
	    function ThrowIfEmptyOperator(errorFactory) {
	        this.errorFactory = errorFactory;
	    }
	    ThrowIfEmptyOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ThrowIfEmptySubscriber(subscriber, this.errorFactory));
	    };
	    return ThrowIfEmptyOperator;
	}());
	var ThrowIfEmptySubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(ThrowIfEmptySubscriber, _super);
	    function ThrowIfEmptySubscriber(destination, errorFactory) {
	        var _this = _super.call(this, destination) || this;
	        _this.errorFactory = errorFactory;
	        _this.hasValue = false;
	        return _this;
	    }
	    ThrowIfEmptySubscriber.prototype._next = function (value) {
	        this.hasValue = true;
	        this.destination.next(value);
	    };
	    ThrowIfEmptySubscriber.prototype._complete = function () {
	        if (!this.hasValue) {
	            var err = void 0;
	            try {
	                err = this.errorFactory();
	            }
	            catch (e) {
	                err = e;
	            }
	            this.destination.error(err);
	        }
	        else {
	            return this.destination.complete();
	        }
	    };
	    return ThrowIfEmptySubscriber;
	}(Subscriber));
	function defaultErrorFactory() {
	    return new EmptyError();
	}

	/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */
	function take(count) {
	    return function (source) {
	        if (count === 0) {
	            return empty();
	        }
	        else {
	            return source.lift(new TakeOperator(count));
	        }
	    };
	}
	var TakeOperator = /*@__PURE__*/ (function () {
	    function TakeOperator(total) {
	        this.total = total;
	        if (this.total < 0) {
	            throw new ArgumentOutOfRangeError;
	        }
	    }
	    TakeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeSubscriber(subscriber, this.total));
	    };
	    return TakeOperator;
	}());
	var TakeSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(TakeSubscriber, _super);
	    function TakeSubscriber(destination, total) {
	        var _this = _super.call(this, destination) || this;
	        _this.total = total;
	        _this.count = 0;
	        return _this;
	    }
	    TakeSubscriber.prototype._next = function (value) {
	        var total = this.total;
	        var count = ++this.count;
	        if (count <= total) {
	            this.destination.next(value);
	            if (count === total) {
	                this.destination.complete();
	                this.unsubscribe();
	            }
	        }
	    };
	    return TakeSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START _util_ArgumentOutOfRangeError,_filter,_throwIfEmpty,_defaultIfEmpty,_take PURE_IMPORTS_END */
	function elementAt(index, defaultValue) {
	    if (index < 0) {
	        throw new ArgumentOutOfRangeError();
	    }
	    var hasDefaultValue = arguments.length >= 2;
	    return function (source) {
	        return source.pipe(filter(function (v, i) { return i === index; }), take(1), hasDefaultValue
	            ? defaultIfEmpty(defaultValue)
	            : throwIfEmpty(function () { return new ArgumentOutOfRangeError(); }));
	    };
	}

	/** PURE_IMPORTS_START _observable_concat,_observable_of PURE_IMPORTS_END */
	function endWith() {
	    var array = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        array[_i] = arguments[_i];
	    }
	    return function (source) { return concat$1(source, of.apply(void 0, array)); };
	}

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function every(predicate, thisArg) {
	    return function (source) { return source.lift(new EveryOperator(predicate, thisArg, source)); };
	}
	var EveryOperator = /*@__PURE__*/ (function () {
	    function EveryOperator(predicate, thisArg, source) {
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.source = source;
	    }
	    EveryOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
	    };
	    return EveryOperator;
	}());
	var EverySubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(EverySubscriber, _super);
	    function EverySubscriber(destination, predicate, thisArg, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.thisArg = thisArg;
	        _this.source = source;
	        _this.index = 0;
	        _this.thisArg = thisArg || _this;
	        return _this;
	    }
	    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
	        this.destination.next(everyValueMatch);
	        this.destination.complete();
	    };
	    EverySubscriber.prototype._next = function (value) {
	        var result = false;
	        try {
	            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (!result) {
	            this.notifyComplete(false);
	        }
	    };
	    EverySubscriber.prototype._complete = function () {
	        this.notifyComplete(true);
	    };
	    return EverySubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
	function exhaust() {
	    return function (source) { return source.lift(new SwitchFirstOperator()); };
	}
	var SwitchFirstOperator = /*@__PURE__*/ (function () {
	    function SwitchFirstOperator() {
	    }
	    SwitchFirstOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchFirstSubscriber(subscriber));
	    };
	    return SwitchFirstOperator;
	}());
	var SwitchFirstSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SwitchFirstSubscriber, _super);
	    function SwitchFirstSubscriber(destination) {
	        var _this = _super.call(this, destination) || this;
	        _this.hasCompleted = false;
	        _this.hasSubscription = false;
	        return _this;
	    }
	    SwitchFirstSubscriber.prototype._next = function (value) {
	        if (!this.hasSubscription) {
	            this.hasSubscription = true;
	            this.add(innerSubscribe(value, new SimpleInnerSubscriber(this)));
	        }
	    };
	    SwitchFirstSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (!this.hasSubscription) {
	            this.destination.complete();
	        }
	    };
	    SwitchFirstSubscriber.prototype.notifyComplete = function () {
	        this.hasSubscription = false;
	        if (this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return SwitchFirstSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */
	function exhaustMap(project, resultSelector) {
	    if (resultSelector) {
	        return function (source) { return source.pipe(exhaustMap(function (a, i) { return from(project(a, i)).pipe(map(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
	    }
	    return function (source) {
	        return source.lift(new ExhaustMapOperator(project));
	    };
	}
	var ExhaustMapOperator = /*@__PURE__*/ (function () {
	    function ExhaustMapOperator(project) {
	        this.project = project;
	    }
	    ExhaustMapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ExhaustMapSubscriber(subscriber, this.project));
	    };
	    return ExhaustMapOperator;
	}());
	var ExhaustMapSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(ExhaustMapSubscriber, _super);
	    function ExhaustMapSubscriber(destination, project) {
	        var _this = _super.call(this, destination) || this;
	        _this.project = project;
	        _this.hasSubscription = false;
	        _this.hasCompleted = false;
	        _this.index = 0;
	        return _this;
	    }
	    ExhaustMapSubscriber.prototype._next = function (value) {
	        if (!this.hasSubscription) {
	            this.tryNext(value);
	        }
	    };
	    ExhaustMapSubscriber.prototype.tryNext = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.hasSubscription = true;
	        this._innerSub(result);
	    };
	    ExhaustMapSubscriber.prototype._innerSub = function (result) {
	        var innerSubscriber = new SimpleInnerSubscriber(this);
	        var destination = this.destination;
	        destination.add(innerSubscriber);
	        var innerSubscription = innerSubscribe(result, innerSubscriber);
	        if (innerSubscription !== innerSubscriber) {
	            destination.add(innerSubscription);
	        }
	    };
	    ExhaustMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (!this.hasSubscription) {
	            this.destination.complete();
	        }
	        this.unsubscribe();
	    };
	    ExhaustMapSubscriber.prototype.notifyNext = function (innerValue) {
	        this.destination.next(innerValue);
	    };
	    ExhaustMapSubscriber.prototype.notifyError = function (err) {
	        this.destination.error(err);
	    };
	    ExhaustMapSubscriber.prototype.notifyComplete = function () {
	        this.hasSubscription = false;
	        if (this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return ExhaustMapSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
	function expand(project, concurrent, scheduler) {
	    if (concurrent === void 0) {
	        concurrent = Number.POSITIVE_INFINITY;
	    }
	    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
	    return function (source) { return source.lift(new ExpandOperator(project, concurrent, scheduler)); };
	}
	var ExpandOperator = /*@__PURE__*/ (function () {
	    function ExpandOperator(project, concurrent, scheduler) {
	        this.project = project;
	        this.concurrent = concurrent;
	        this.scheduler = scheduler;
	    }
	    ExpandOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
	    };
	    return ExpandOperator;
	}());
	var ExpandSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(ExpandSubscriber, _super);
	    function ExpandSubscriber(destination, project, concurrent, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.project = project;
	        _this.concurrent = concurrent;
	        _this.scheduler = scheduler;
	        _this.index = 0;
	        _this.active = 0;
	        _this.hasCompleted = false;
	        if (concurrent < Number.POSITIVE_INFINITY) {
	            _this.buffer = [];
	        }
	        return _this;
	    }
	    ExpandSubscriber.dispatch = function (arg) {
	        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
	        subscriber.subscribeToProjection(result, value, index);
	    };
	    ExpandSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        if (destination.closed) {
	            this._complete();
	            return;
	        }
	        var index = this.index++;
	        if (this.active < this.concurrent) {
	            destination.next(value);
	            try {
	                var project = this.project;
	                var result = project(value, index);
	                if (!this.scheduler) {
	                    this.subscribeToProjection(result, value, index);
	                }
	                else {
	                    var state = { subscriber: this, result: result, value: value, index: index };
	                    var destination_1 = this.destination;
	                    destination_1.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
	                }
	            }
	            catch (e) {
	                destination.error(e);
	            }
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
	        this.active++;
	        var destination = this.destination;
	        destination.add(innerSubscribe(result, new SimpleInnerSubscriber(this)));
	    };
	    ExpandSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.hasCompleted && this.active === 0) {
	            this.destination.complete();
	        }
	        this.unsubscribe();
	    };
	    ExpandSubscriber.prototype.notifyNext = function (innerValue) {
	        this._next(innerValue);
	    };
	    ExpandSubscriber.prototype.notifyComplete = function () {
	        var buffer = this.buffer;
	        this.active--;
	        if (buffer && buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        if (this.hasCompleted && this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    return ExpandSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription PURE_IMPORTS_END */
	function finalize(callback) {
	    return function (source) { return source.lift(new FinallyOperator(callback)); };
	}
	var FinallyOperator = /*@__PURE__*/ (function () {
	    function FinallyOperator(callback) {
	        this.callback = callback;
	    }
	    FinallyOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
	    };
	    return FinallyOperator;
	}());
	var FinallySubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(FinallySubscriber, _super);
	    function FinallySubscriber(destination, callback) {
	        var _this = _super.call(this, destination) || this;
	        _this.add(new Subscription(callback));
	        return _this;
	    }
	    return FinallySubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function find(predicate, thisArg) {
	    if (typeof predicate !== 'function') {
	        throw new TypeError('predicate is not a function');
	    }
	    return function (source) { return source.lift(new FindValueOperator(predicate, source, false, thisArg)); };
	}
	var FindValueOperator = /*@__PURE__*/ (function () {
	    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
	        this.predicate = predicate;
	        this.source = source;
	        this.yieldIndex = yieldIndex;
	        this.thisArg = thisArg;
	    }
	    FindValueOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
	    };
	    return FindValueOperator;
	}());
	var FindValueSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(FindValueSubscriber, _super);
	    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.source = source;
	        _this.yieldIndex = yieldIndex;
	        _this.thisArg = thisArg;
	        _this.index = 0;
	        return _this;
	    }
	    FindValueSubscriber.prototype.notifyComplete = function (value) {
	        var destination = this.destination;
	        destination.next(value);
	        destination.complete();
	        this.unsubscribe();
	    };
	    FindValueSubscriber.prototype._next = function (value) {
	        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
	        var index = this.index++;
	        try {
	            var result = predicate.call(thisArg || this, value, index, this.source);
	            if (result) {
	                this.notifyComplete(this.yieldIndex ? index : value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    FindValueSubscriber.prototype._complete = function () {
	        this.notifyComplete(this.yieldIndex ? -1 : undefined);
	    };
	    return FindValueSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START _operators_find PURE_IMPORTS_END */
	function findIndex(predicate, thisArg) {
	    return function (source) { return source.lift(new FindValueOperator(predicate, source, true, thisArg)); };
	}

	/** PURE_IMPORTS_START _util_EmptyError,_filter,_take,_defaultIfEmpty,_throwIfEmpty,_util_identity PURE_IMPORTS_END */
	function first(predicate, defaultValue) {
	    var hasDefaultValue = arguments.length >= 2;
	    return function (source) { return source.pipe(predicate ? filter(function (v, i) { return predicate(v, i, source); }) : identity, take(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () { return new EmptyError(); })); };
	}

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function ignoreElements() {
	    return function ignoreElementsOperatorFunction(source) {
	        return source.lift(new IgnoreElementsOperator());
	    };
	}
	var IgnoreElementsOperator = /*@__PURE__*/ (function () {
	    function IgnoreElementsOperator() {
	    }
	    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
	    };
	    return IgnoreElementsOperator;
	}());
	var IgnoreElementsSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(IgnoreElementsSubscriber, _super);
	    function IgnoreElementsSubscriber() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    IgnoreElementsSubscriber.prototype._next = function (unused) {
	    };
	    return IgnoreElementsSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function isEmpty() {
	    return function (source) { return source.lift(new IsEmptyOperator()); };
	}
	var IsEmptyOperator = /*@__PURE__*/ (function () {
	    function IsEmptyOperator() {
	    }
	    IsEmptyOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new IsEmptySubscriber(observer));
	    };
	    return IsEmptyOperator;
	}());
	var IsEmptySubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(IsEmptySubscriber, _super);
	    function IsEmptySubscriber(destination) {
	        return _super.call(this, destination) || this;
	    }
	    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
	        var destination = this.destination;
	        destination.next(isEmpty);
	        destination.complete();
	    };
	    IsEmptySubscriber.prototype._next = function (value) {
	        this.notifyComplete(false);
	    };
	    IsEmptySubscriber.prototype._complete = function () {
	        this.notifyComplete(true);
	    };
	    return IsEmptySubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */
	function takeLast(count) {
	    return function takeLastOperatorFunction(source) {
	        if (count === 0) {
	            return empty();
	        }
	        else {
	            return source.lift(new TakeLastOperator(count));
	        }
	    };
	}
	var TakeLastOperator = /*@__PURE__*/ (function () {
	    function TakeLastOperator(total) {
	        this.total = total;
	        if (this.total < 0) {
	            throw new ArgumentOutOfRangeError;
	        }
	    }
	    TakeLastOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
	    };
	    return TakeLastOperator;
	}());
	var TakeLastSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(TakeLastSubscriber, _super);
	    function TakeLastSubscriber(destination, total) {
	        var _this = _super.call(this, destination) || this;
	        _this.total = total;
	        _this.ring = new Array();
	        _this.count = 0;
	        return _this;
	    }
	    TakeLastSubscriber.prototype._next = function (value) {
	        var ring = this.ring;
	        var total = this.total;
	        var count = this.count++;
	        if (ring.length < total) {
	            ring.push(value);
	        }
	        else {
	            var index = count % total;
	            ring[index] = value;
	        }
	    };
	    TakeLastSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        var count = this.count;
	        if (count > 0) {
	            var total = this.count >= this.total ? this.total : this.count;
	            var ring = this.ring;
	            for (var i = 0; i < total; i++) {
	                var idx = (count++) % total;
	                destination.next(ring[idx]);
	            }
	        }
	        destination.complete();
	    };
	    return TakeLastSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START _util_EmptyError,_filter,_takeLast,_throwIfEmpty,_defaultIfEmpty,_util_identity PURE_IMPORTS_END */
	function last(predicate, defaultValue) {
	    var hasDefaultValue = arguments.length >= 2;
	    return function (source) { return source.pipe(predicate ? filter(function (v, i) { return predicate(v, i, source); }) : identity, takeLast(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () { return new EmptyError(); })); };
	}

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function mapTo(value) {
	    return function (source) { return source.lift(new MapToOperator(value)); };
	}
	var MapToOperator = /*@__PURE__*/ (function () {
	    function MapToOperator(value) {
	        this.value = value;
	    }
	    MapToOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MapToSubscriber(subscriber, this.value));
	    };
	    return MapToOperator;
	}());
	var MapToSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(MapToSubscriber, _super);
	    function MapToSubscriber(destination, value) {
	        var _this = _super.call(this, destination) || this;
	        _this.value = value;
	        return _this;
	    }
	    MapToSubscriber.prototype._next = function (x) {
	        this.destination.next(this.value);
	    };
	    return MapToSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */
	function materialize() {
	    return function materializeOperatorFunction(source) {
	        return source.lift(new MaterializeOperator());
	    };
	}
	var MaterializeOperator = /*@__PURE__*/ (function () {
	    function MaterializeOperator() {
	    }
	    MaterializeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MaterializeSubscriber(subscriber));
	    };
	    return MaterializeOperator;
	}());
	var MaterializeSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(MaterializeSubscriber, _super);
	    function MaterializeSubscriber(destination) {
	        return _super.call(this, destination) || this;
	    }
	    MaterializeSubscriber.prototype._next = function (value) {
	        this.destination.next(Notification.createNext(value));
	    };
	    MaterializeSubscriber.prototype._error = function (err) {
	        var destination = this.destination;
	        destination.next(Notification.createError(err));
	        destination.complete();
	    };
	    MaterializeSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        destination.next(Notification.createComplete());
	        destination.complete();
	    };
	    return MaterializeSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function scan(accumulator, seed) {
	    var hasSeed = false;
	    if (arguments.length >= 2) {
	        hasSeed = true;
	    }
	    return function scanOperatorFunction(source) {
	        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
	    };
	}
	var ScanOperator = /*@__PURE__*/ (function () {
	    function ScanOperator(accumulator, seed, hasSeed) {
	        if (hasSeed === void 0) {
	            hasSeed = false;
	        }
	        this.accumulator = accumulator;
	        this.seed = seed;
	        this.hasSeed = hasSeed;
	    }
	    ScanOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
	    };
	    return ScanOperator;
	}());
	var ScanSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(ScanSubscriber, _super);
	    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
	        var _this = _super.call(this, destination) || this;
	        _this.accumulator = accumulator;
	        _this._seed = _seed;
	        _this.hasSeed = hasSeed;
	        _this.index = 0;
	        return _this;
	    }
	    Object.defineProperty(ScanSubscriber.prototype, "seed", {
	        get: function () {
	            return this._seed;
	        },
	        set: function (value) {
	            this.hasSeed = true;
	            this._seed = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ScanSubscriber.prototype._next = function (value) {
	        if (!this.hasSeed) {
	            this.seed = value;
	            this.destination.next(value);
	        }
	        else {
	            return this._tryNext(value);
	        }
	    };
	    ScanSubscriber.prototype._tryNext = function (value) {
	        var index = this.index++;
	        var result;
	        try {
	            result = this.accumulator(this.seed, value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	        this.seed = result;
	        this.destination.next(result);
	    };
	    return ScanSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START _scan,_takeLast,_defaultIfEmpty,_util_pipe PURE_IMPORTS_END */
	function reduce(accumulator, seed) {
	    if (arguments.length >= 2) {
	        return function reduceOperatorFunctionWithSeed(source) {
	            return pipe(scan(accumulator, seed), takeLast(1), defaultIfEmpty(seed))(source);
	        };
	    }
	    return function reduceOperatorFunction(source) {
	        return pipe(scan(function (acc, value, index) { return accumulator(acc, value, index + 1); }), takeLast(1))(source);
	    };
	}

	/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */
	function max(comparer) {
	    var max = (typeof comparer === 'function')
	        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
	        : function (x, y) { return x > y ? x : y; };
	    return reduce(max);
	}

	/** PURE_IMPORTS_START _observable_merge PURE_IMPORTS_END */
	function merge() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    return function (source) { return source.lift.call(merge$1.apply(void 0, [source].concat(observables))); };
	}

	/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */
	function mergeMapTo(innerObservable, resultSelector, concurrent) {
	    if (concurrent === void 0) {
	        concurrent = Number.POSITIVE_INFINITY;
	    }
	    if (typeof resultSelector === 'function') {
	        return mergeMap(function () { return innerObservable; }, resultSelector, concurrent);
	    }
	    if (typeof resultSelector === 'number') {
	        concurrent = resultSelector;
	    }
	    return mergeMap(function () { return innerObservable; }, concurrent);
	}

	/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
	function mergeScan(accumulator, seed, concurrent) {
	    if (concurrent === void 0) {
	        concurrent = Number.POSITIVE_INFINITY;
	    }
	    return function (source) { return source.lift(new MergeScanOperator(accumulator, seed, concurrent)); };
	}
	var MergeScanOperator = /*@__PURE__*/ (function () {
	    function MergeScanOperator(accumulator, seed, concurrent) {
	        this.accumulator = accumulator;
	        this.seed = seed;
	        this.concurrent = concurrent;
	    }
	    MergeScanOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
	    };
	    return MergeScanOperator;
	}());
	var MergeScanSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(MergeScanSubscriber, _super);
	    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
	        var _this = _super.call(this, destination) || this;
	        _this.accumulator = accumulator;
	        _this.acc = acc;
	        _this.concurrent = concurrent;
	        _this.hasValue = false;
	        _this.hasCompleted = false;
	        _this.buffer = [];
	        _this.active = 0;
	        _this.index = 0;
	        return _this;
	    }
	    MergeScanSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            var index = this.index++;
	            var destination = this.destination;
	            var ish = void 0;
	            try {
	                var accumulator = this.accumulator;
	                ish = accumulator(this.acc, value, index);
	            }
	            catch (e) {
	                return destination.error(e);
	            }
	            this.active++;
	            this._innerSub(ish);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeScanSubscriber.prototype._innerSub = function (ish) {
	        var innerSubscriber = new SimpleInnerSubscriber(this);
	        var destination = this.destination;
	        destination.add(innerSubscriber);
	        var innerSubscription = innerSubscribe(ish, innerSubscriber);
	        if (innerSubscription !== innerSubscriber) {
	            destination.add(innerSubscription);
	        }
	    };
	    MergeScanSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            if (this.hasValue === false) {
	                this.destination.next(this.acc);
	            }
	            this.destination.complete();
	        }
	        this.unsubscribe();
	    };
	    MergeScanSubscriber.prototype.notifyNext = function (innerValue) {
	        var destination = this.destination;
	        this.acc = innerValue;
	        this.hasValue = true;
	        destination.next(innerValue);
	    };
	    MergeScanSubscriber.prototype.notifyComplete = function () {
	        var buffer = this.buffer;
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            if (this.hasValue === false) {
	                this.destination.next(this.acc);
	            }
	            this.destination.complete();
	        }
	    };
	    return MergeScanSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */
	function min(comparer) {
	    var min = (typeof comparer === 'function')
	        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
	        : function (x, y) { return x < y ? x : y; };
	    return reduce(min);
	}

	/** PURE_IMPORTS_START _observable_ConnectableObservable PURE_IMPORTS_END */
	function multicast(subjectOrSubjectFactory, selector) {
	    return function multicastOperatorFunction(source) {
	        var subjectFactory;
	        if (typeof subjectOrSubjectFactory === 'function') {
	            subjectFactory = subjectOrSubjectFactory;
	        }
	        else {
	            subjectFactory = function subjectFactory() {
	                return subjectOrSubjectFactory;
	            };
	        }
	        if (typeof selector === 'function') {
	            return source.lift(new MulticastOperator(subjectFactory, selector));
	        }
	        var connectable = Object.create(source, connectableObservableDescriptor);
	        connectable.source = source;
	        connectable.subjectFactory = subjectFactory;
	        return connectable;
	    };
	}
	var MulticastOperator = /*@__PURE__*/ (function () {
	    function MulticastOperator(subjectFactory, selector) {
	        this.subjectFactory = subjectFactory;
	        this.selector = selector;
	    }
	    MulticastOperator.prototype.call = function (subscriber, source) {
	        var selector = this.selector;
	        var subject = this.subjectFactory();
	        var subscription = selector(subject).subscribe(subscriber);
	        subscription.add(source.subscribe(subject));
	        return subscription;
	    };
	    return MulticastOperator;
	}());

	/** PURE_IMPORTS_START tslib,_observable_from,_util_isArray,_innerSubscribe PURE_IMPORTS_END */
	function onErrorResumeNext() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i] = arguments[_i];
	    }
	    if (nextSources.length === 1 && isArray(nextSources[0])) {
	        nextSources = nextSources[0];
	    }
	    return function (source) { return source.lift(new OnErrorResumeNextOperator(nextSources)); };
	}
	var OnErrorResumeNextOperator = /*@__PURE__*/ (function () {
	    function OnErrorResumeNextOperator(nextSources) {
	        this.nextSources = nextSources;
	    }
	    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
	    };
	    return OnErrorResumeNextOperator;
	}());
	var OnErrorResumeNextSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(OnErrorResumeNextSubscriber, _super);
	    function OnErrorResumeNextSubscriber(destination, nextSources) {
	        var _this = _super.call(this, destination) || this;
	        _this.destination = destination;
	        _this.nextSources = nextSources;
	        return _this;
	    }
	    OnErrorResumeNextSubscriber.prototype.notifyError = function () {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype.notifyComplete = function () {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype._error = function (err) {
	        this.subscribeToNextSource();
	        this.unsubscribe();
	    };
	    OnErrorResumeNextSubscriber.prototype._complete = function () {
	        this.subscribeToNextSource();
	        this.unsubscribe();
	    };
	    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
	        var next = this.nextSources.shift();
	        if (!!next) {
	            var innerSubscriber = new SimpleInnerSubscriber(this);
	            var destination = this.destination;
	            destination.add(innerSubscriber);
	            var innerSubscription = innerSubscribe(next, innerSubscriber);
	            if (innerSubscription !== innerSubscriber) {
	                destination.add(innerSubscription);
	            }
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    return OnErrorResumeNextSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function pairwise() {
	    return function (source) { return source.lift(new PairwiseOperator()); };
	}
	var PairwiseOperator = /*@__PURE__*/ (function () {
	    function PairwiseOperator() {
	    }
	    PairwiseOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new PairwiseSubscriber(subscriber));
	    };
	    return PairwiseOperator;
	}());
	var PairwiseSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(PairwiseSubscriber, _super);
	    function PairwiseSubscriber(destination) {
	        var _this = _super.call(this, destination) || this;
	        _this.hasPrev = false;
	        return _this;
	    }
	    PairwiseSubscriber.prototype._next = function (value) {
	        var pair;
	        if (this.hasPrev) {
	            pair = [this.prev, value];
	        }
	        else {
	            this.hasPrev = true;
	        }
	        this.prev = value;
	        if (pair) {
	            this.destination.next(pair);
	        }
	    };
	    return PairwiseSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START _util_not,_filter PURE_IMPORTS_END */
	function partition(predicate, thisArg) {
	    return function (source) {
	        return [
	            filter(predicate, thisArg)(source),
	            filter(not(predicate, thisArg))(source)
	        ];
	    };
	}

	/** PURE_IMPORTS_START _map PURE_IMPORTS_END */
	function pluck() {
	    var properties = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        properties[_i] = arguments[_i];
	    }
	    var length = properties.length;
	    if (length === 0) {
	        throw new Error('list of properties cannot be empty.');
	    }
	    return function (source) { return map(plucker(properties, length))(source); };
	}
	function plucker(props, length) {
	    var mapper = function (x) {
	        var currentProp = x;
	        for (var i = 0; i < length; i++) {
	            var p = currentProp != null ? currentProp[props[i]] : undefined;
	            if (p !== void 0) {
	                currentProp = p;
	            }
	            else {
	                return undefined;
	            }
	        }
	        return currentProp;
	    };
	    return mapper;
	}

	/** PURE_IMPORTS_START _Subject,_multicast PURE_IMPORTS_END */
	function publish(selector) {
	    return selector ?
	        multicast(function () { return new Subject(); }, selector) :
	        multicast(new Subject());
	}

	/** PURE_IMPORTS_START _BehaviorSubject,_multicast PURE_IMPORTS_END */
	function publishBehavior(value) {
	    return function (source) { return multicast(new BehaviorSubject(value))(source); };
	}

	/** PURE_IMPORTS_START _AsyncSubject,_multicast PURE_IMPORTS_END */
	function publishLast() {
	    return function (source) { return multicast(new AsyncSubject())(source); };
	}

	/** PURE_IMPORTS_START _ReplaySubject,_multicast PURE_IMPORTS_END */
	function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
	    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
	        scheduler = selectorOrScheduler;
	    }
	    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
	    var subject = new ReplaySubject(bufferSize, windowTime, scheduler);
	    return function (source) { return multicast(function () { return subject; }, selector)(source); };
	}

	/** PURE_IMPORTS_START _util_isArray,_observable_race PURE_IMPORTS_END */
	function race() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    return function raceOperatorFunction(source) {
	        if (observables.length === 1 && isArray(observables[0])) {
	            observables = observables[0];
	        }
	        return source.lift.call(race$1.apply(void 0, [source].concat(observables)));
	    };
	}

	/** PURE_IMPORTS_START tslib,_Subscriber,_observable_empty PURE_IMPORTS_END */
	function repeat(count) {
	    if (count === void 0) {
	        count = -1;
	    }
	    return function (source) {
	        if (count === 0) {
	            return empty();
	        }
	        else if (count < 0) {
	            return source.lift(new RepeatOperator(-1, source));
	        }
	        else {
	            return source.lift(new RepeatOperator(count - 1, source));
	        }
	    };
	}
	var RepeatOperator = /*@__PURE__*/ (function () {
	    function RepeatOperator(count, source) {
	        this.count = count;
	        this.source = source;
	    }
	    RepeatOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
	    };
	    return RepeatOperator;
	}());
	var RepeatSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(RepeatSubscriber, _super);
	    function RepeatSubscriber(destination, count, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.count = count;
	        _this.source = source;
	        return _this;
	    }
	    RepeatSubscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            var _a = this, source = _a.source, count = _a.count;
	            if (count === 0) {
	                return _super.prototype.complete.call(this);
	            }
	            else if (count > -1) {
	                this.count = count - 1;
	            }
	            source.subscribe(this._unsubscribeAndRecycle());
	        }
	    };
	    return RepeatSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */
	function repeatWhen(notifier) {
	    return function (source) { return source.lift(new RepeatWhenOperator(notifier)); };
	}
	var RepeatWhenOperator = /*@__PURE__*/ (function () {
	    function RepeatWhenOperator(notifier) {
	        this.notifier = notifier;
	    }
	    RepeatWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
	    };
	    return RepeatWhenOperator;
	}());
	var RepeatWhenSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(RepeatWhenSubscriber, _super);
	    function RepeatWhenSubscriber(destination, notifier, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.notifier = notifier;
	        _this.source = source;
	        _this.sourceIsBeingSubscribedTo = true;
	        return _this;
	    }
	    RepeatWhenSubscriber.prototype.notifyNext = function () {
	        this.sourceIsBeingSubscribedTo = true;
	        this.source.subscribe(this);
	    };
	    RepeatWhenSubscriber.prototype.notifyComplete = function () {
	        if (this.sourceIsBeingSubscribedTo === false) {
	            return _super.prototype.complete.call(this);
	        }
	    };
	    RepeatWhenSubscriber.prototype.complete = function () {
	        this.sourceIsBeingSubscribedTo = false;
	        if (!this.isStopped) {
	            if (!this.retries) {
	                this.subscribeToRetries();
	            }
	            if (!this.retriesSubscription || this.retriesSubscription.closed) {
	                return _super.prototype.complete.call(this);
	            }
	            this._unsubscribeAndRecycle();
	            this.notifications.next(undefined);
	        }
	    };
	    RepeatWhenSubscriber.prototype._unsubscribe = function () {
	        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
	        if (notifications) {
	            notifications.unsubscribe();
	            this.notifications = undefined;
	        }
	        if (retriesSubscription) {
	            retriesSubscription.unsubscribe();
	            this.retriesSubscription = undefined;
	        }
	        this.retries = undefined;
	    };
	    RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
	        var _unsubscribe = this._unsubscribe;
	        this._unsubscribe = null;
	        _super.prototype._unsubscribeAndRecycle.call(this);
	        this._unsubscribe = _unsubscribe;
	        return this;
	    };
	    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
	        this.notifications = new Subject();
	        var retries;
	        try {
	            var notifier = this.notifier;
	            retries = notifier(this.notifications);
	        }
	        catch (e) {
	            return _super.prototype.complete.call(this);
	        }
	        this.retries = retries;
	        this.retriesSubscription = innerSubscribe(retries, new SimpleInnerSubscriber(this));
	    };
	    return RepeatWhenSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function retry(count) {
	    if (count === void 0) {
	        count = -1;
	    }
	    return function (source) { return source.lift(new RetryOperator(count, source)); };
	}
	var RetryOperator = /*@__PURE__*/ (function () {
	    function RetryOperator(count, source) {
	        this.count = count;
	        this.source = source;
	    }
	    RetryOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
	    };
	    return RetryOperator;
	}());
	var RetrySubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(RetrySubscriber, _super);
	    function RetrySubscriber(destination, count, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.count = count;
	        _this.source = source;
	        return _this;
	    }
	    RetrySubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _a = this, source = _a.source, count = _a.count;
	            if (count === 0) {
	                return _super.prototype.error.call(this, err);
	            }
	            else if (count > -1) {
	                this.count = count - 1;
	            }
	            source.subscribe(this._unsubscribeAndRecycle());
	        }
	    };
	    return RetrySubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */
	function retryWhen(notifier) {
	    return function (source) { return source.lift(new RetryWhenOperator(notifier, source)); };
	}
	var RetryWhenOperator = /*@__PURE__*/ (function () {
	    function RetryWhenOperator(notifier, source) {
	        this.notifier = notifier;
	        this.source = source;
	    }
	    RetryWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
	    };
	    return RetryWhenOperator;
	}());
	var RetryWhenSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(RetryWhenSubscriber, _super);
	    function RetryWhenSubscriber(destination, notifier, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.notifier = notifier;
	        _this.source = source;
	        return _this;
	    }
	    RetryWhenSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var errors = this.errors;
	            var retries = this.retries;
	            var retriesSubscription = this.retriesSubscription;
	            if (!retries) {
	                errors = new Subject();
	                try {
	                    var notifier = this.notifier;
	                    retries = notifier(errors);
	                }
	                catch (e) {
	                    return _super.prototype.error.call(this, e);
	                }
	                retriesSubscription = innerSubscribe(retries, new SimpleInnerSubscriber(this));
	            }
	            else {
	                this.errors = undefined;
	                this.retriesSubscription = undefined;
	            }
	            this._unsubscribeAndRecycle();
	            this.errors = errors;
	            this.retries = retries;
	            this.retriesSubscription = retriesSubscription;
	            errors.next(err);
	        }
	    };
	    RetryWhenSubscriber.prototype._unsubscribe = function () {
	        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
	        if (errors) {
	            errors.unsubscribe();
	            this.errors = undefined;
	        }
	        if (retriesSubscription) {
	            retriesSubscription.unsubscribe();
	            this.retriesSubscription = undefined;
	        }
	        this.retries = undefined;
	    };
	    RetryWhenSubscriber.prototype.notifyNext = function () {
	        var _unsubscribe = this._unsubscribe;
	        this._unsubscribe = null;
	        this._unsubscribeAndRecycle();
	        this._unsubscribe = _unsubscribe;
	        this.source.subscribe(this);
	    };
	    return RetryWhenSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
	function sample(notifier) {
	    return function (source) { return source.lift(new SampleOperator(notifier)); };
	}
	var SampleOperator = /*@__PURE__*/ (function () {
	    function SampleOperator(notifier) {
	        this.notifier = notifier;
	    }
	    SampleOperator.prototype.call = function (subscriber, source) {
	        var sampleSubscriber = new SampleSubscriber(subscriber);
	        var subscription = source.subscribe(sampleSubscriber);
	        subscription.add(innerSubscribe(this.notifier, new SimpleInnerSubscriber(sampleSubscriber)));
	        return subscription;
	    };
	    return SampleOperator;
	}());
	var SampleSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SampleSubscriber, _super);
	    function SampleSubscriber() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.hasValue = false;
	        return _this;
	    }
	    SampleSubscriber.prototype._next = function (value) {
	        this.value = value;
	        this.hasValue = true;
	    };
	    SampleSubscriber.prototype.notifyNext = function () {
	        this.emitValue();
	    };
	    SampleSubscriber.prototype.notifyComplete = function () {
	        this.emitValue();
	    };
	    SampleSubscriber.prototype.emitValue = function () {
	        if (this.hasValue) {
	            this.hasValue = false;
	            this.destination.next(this.value);
	        }
	    };
	    return SampleSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */
	function sampleTime(period, scheduler) {
	    if (scheduler === void 0) {
	        scheduler = async;
	    }
	    return function (source) { return source.lift(new SampleTimeOperator(period, scheduler)); };
	}
	var SampleTimeOperator = /*@__PURE__*/ (function () {
	    function SampleTimeOperator(period, scheduler) {
	        this.period = period;
	        this.scheduler = scheduler;
	    }
	    SampleTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
	    };
	    return SampleTimeOperator;
	}());
	var SampleTimeSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SampleTimeSubscriber, _super);
	    function SampleTimeSubscriber(destination, period, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.period = period;
	        _this.scheduler = scheduler;
	        _this.hasValue = false;
	        _this.add(scheduler.schedule(dispatchNotification, period, { subscriber: _this, period: period }));
	        return _this;
	    }
	    SampleTimeSubscriber.prototype._next = function (value) {
	        this.lastValue = value;
	        this.hasValue = true;
	    };
	    SampleTimeSubscriber.prototype.notifyNext = function () {
	        if (this.hasValue) {
	            this.hasValue = false;
	            this.destination.next(this.lastValue);
	        }
	    };
	    return SampleTimeSubscriber;
	}(Subscriber));
	function dispatchNotification(state) {
	    var subscriber = state.subscriber, period = state.period;
	    subscriber.notifyNext();
	    this.schedule(state, period);
	}

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function sequenceEqual(compareTo, comparator) {
	    return function (source) { return source.lift(new SequenceEqualOperator(compareTo, comparator)); };
	}
	var SequenceEqualOperator = /*@__PURE__*/ (function () {
	    function SequenceEqualOperator(compareTo, comparator) {
	        this.compareTo = compareTo;
	        this.comparator = comparator;
	    }
	    SequenceEqualOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparator));
	    };
	    return SequenceEqualOperator;
	}());
	var SequenceEqualSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SequenceEqualSubscriber, _super);
	    function SequenceEqualSubscriber(destination, compareTo, comparator) {
	        var _this = _super.call(this, destination) || this;
	        _this.compareTo = compareTo;
	        _this.comparator = comparator;
	        _this._a = [];
	        _this._b = [];
	        _this._oneComplete = false;
	        _this.destination.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, _this)));
	        return _this;
	    }
	    SequenceEqualSubscriber.prototype._next = function (value) {
	        if (this._oneComplete && this._b.length === 0) {
	            this.emit(false);
	        }
	        else {
	            this._a.push(value);
	            this.checkValues();
	        }
	    };
	    SequenceEqualSubscriber.prototype._complete = function () {
	        if (this._oneComplete) {
	            this.emit(this._a.length === 0 && this._b.length === 0);
	        }
	        else {
	            this._oneComplete = true;
	        }
	        this.unsubscribe();
	    };
	    SequenceEqualSubscriber.prototype.checkValues = function () {
	        var _c = this, _a = _c._a, _b = _c._b, comparator = _c.comparator;
	        while (_a.length > 0 && _b.length > 0) {
	            var a = _a.shift();
	            var b = _b.shift();
	            var areEqual = false;
	            try {
	                areEqual = comparator ? comparator(a, b) : a === b;
	            }
	            catch (e) {
	                this.destination.error(e);
	            }
	            if (!areEqual) {
	                this.emit(false);
	            }
	        }
	    };
	    SequenceEqualSubscriber.prototype.emit = function (value) {
	        var destination = this.destination;
	        destination.next(value);
	        destination.complete();
	    };
	    SequenceEqualSubscriber.prototype.nextB = function (value) {
	        if (this._oneComplete && this._a.length === 0) {
	            this.emit(false);
	        }
	        else {
	            this._b.push(value);
	            this.checkValues();
	        }
	    };
	    SequenceEqualSubscriber.prototype.completeB = function () {
	        if (this._oneComplete) {
	            this.emit(this._a.length === 0 && this._b.length === 0);
	        }
	        else {
	            this._oneComplete = true;
	        }
	    };
	    return SequenceEqualSubscriber;
	}(Subscriber));
	var SequenceEqualCompareToSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SequenceEqualCompareToSubscriber, _super);
	    function SequenceEqualCompareToSubscriber(destination, parent) {
	        var _this = _super.call(this, destination) || this;
	        _this.parent = parent;
	        return _this;
	    }
	    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
	        this.parent.nextB(value);
	    };
	    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
	        this.parent.error(err);
	        this.unsubscribe();
	    };
	    SequenceEqualCompareToSubscriber.prototype._complete = function () {
	        this.parent.completeB();
	        this.unsubscribe();
	    };
	    return SequenceEqualCompareToSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START _multicast,_refCount,_Subject PURE_IMPORTS_END */
	function shareSubjectFactory() {
	    return new Subject();
	}
	function share() {
	    return function (source) { return refCount()(multicast(shareSubjectFactory)(source)); };
	}

	/** PURE_IMPORTS_START _ReplaySubject PURE_IMPORTS_END */
	function shareReplay(configOrBufferSize, windowTime, scheduler) {
	    var config;
	    if (configOrBufferSize && typeof configOrBufferSize === 'object') {
	        config = configOrBufferSize;
	    }
	    else {
	        config = {
	            bufferSize: configOrBufferSize,
	            windowTime: windowTime,
	            refCount: false,
	            scheduler: scheduler,
	        };
	    }
	    return function (source) { return source.lift(shareReplayOperator(config)); };
	}
	function shareReplayOperator(_a) {
	    var _b = _a.bufferSize, bufferSize = _b === void 0 ? Number.POSITIVE_INFINITY : _b, _c = _a.windowTime, windowTime = _c === void 0 ? Number.POSITIVE_INFINITY : _c, useRefCount = _a.refCount, scheduler = _a.scheduler;
	    var subject;
	    var refCount = 0;
	    var subscription;
	    var hasError = false;
	    var isComplete = false;
	    return function shareReplayOperation(source) {
	        refCount++;
	        var innerSub;
	        if (!subject || hasError) {
	            hasError = false;
	            subject = new ReplaySubject(bufferSize, windowTime, scheduler);
	            innerSub = subject.subscribe(this);
	            subscription = source.subscribe({
	                next: function (value) {
	                    subject.next(value);
	                },
	                error: function (err) {
	                    hasError = true;
	                    subject.error(err);
	                },
	                complete: function () {
	                    isComplete = true;
	                    subscription = undefined;
	                    subject.complete();
	                },
	            });
	            if (isComplete) {
	                subscription = undefined;
	            }
	        }
	        else {
	            innerSub = subject.subscribe(this);
	        }
	        this.add(function () {
	            refCount--;
	            innerSub.unsubscribe();
	            innerSub = undefined;
	            if (subscription && !isComplete && useRefCount && refCount === 0) {
	                subscription.unsubscribe();
	                subscription = undefined;
	                subject = undefined;
	            }
	        });
	    };
	}

	/** PURE_IMPORTS_START tslib,_Subscriber,_util_EmptyError PURE_IMPORTS_END */
	function single(predicate) {
	    return function (source) { return source.lift(new SingleOperator(predicate, source)); };
	}
	var SingleOperator = /*@__PURE__*/ (function () {
	    function SingleOperator(predicate, source) {
	        this.predicate = predicate;
	        this.source = source;
	    }
	    SingleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
	    };
	    return SingleOperator;
	}());
	var SingleSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SingleSubscriber, _super);
	    function SingleSubscriber(destination, predicate, source) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.source = source;
	        _this.seenValue = false;
	        _this.index = 0;
	        return _this;
	    }
	    SingleSubscriber.prototype.applySingleValue = function (value) {
	        if (this.seenValue) {
	            this.destination.error('Sequence contains more than one element');
	        }
	        else {
	            this.seenValue = true;
	            this.singleValue = value;
	        }
	    };
	    SingleSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        if (this.predicate) {
	            this.tryNext(value, index);
	        }
	        else {
	            this.applySingleValue(value);
	        }
	    };
	    SingleSubscriber.prototype.tryNext = function (value, index) {
	        try {
	            if (this.predicate(value, index, this.source)) {
	                this.applySingleValue(value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    SingleSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.index > 0) {
	            destination.next(this.seenValue ? this.singleValue : undefined);
	            destination.complete();
	        }
	        else {
	            destination.error(new EmptyError);
	        }
	    };
	    return SingleSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function skip(count) {
	    return function (source) { return source.lift(new SkipOperator(count)); };
	}
	var SkipOperator = /*@__PURE__*/ (function () {
	    function SkipOperator(total) {
	        this.total = total;
	    }
	    SkipOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SkipSubscriber(subscriber, this.total));
	    };
	    return SkipOperator;
	}());
	var SkipSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SkipSubscriber, _super);
	    function SkipSubscriber(destination, total) {
	        var _this = _super.call(this, destination) || this;
	        _this.total = total;
	        _this.count = 0;
	        return _this;
	    }
	    SkipSubscriber.prototype._next = function (x) {
	        if (++this.count > this.total) {
	            this.destination.next(x);
	        }
	    };
	    return SkipSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError PURE_IMPORTS_END */
	function skipLast(count) {
	    return function (source) { return source.lift(new SkipLastOperator(count)); };
	}
	var SkipLastOperator = /*@__PURE__*/ (function () {
	    function SkipLastOperator(_skipCount) {
	        this._skipCount = _skipCount;
	        if (this._skipCount < 0) {
	            throw new ArgumentOutOfRangeError;
	        }
	    }
	    SkipLastOperator.prototype.call = function (subscriber, source) {
	        if (this._skipCount === 0) {
	            return source.subscribe(new Subscriber(subscriber));
	        }
	        else {
	            return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
	        }
	    };
	    return SkipLastOperator;
	}());
	var SkipLastSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SkipLastSubscriber, _super);
	    function SkipLastSubscriber(destination, _skipCount) {
	        var _this = _super.call(this, destination) || this;
	        _this._skipCount = _skipCount;
	        _this._count = 0;
	        _this._ring = new Array(_skipCount);
	        return _this;
	    }
	    SkipLastSubscriber.prototype._next = function (value) {
	        var skipCount = this._skipCount;
	        var count = this._count++;
	        if (count < skipCount) {
	            this._ring[count] = value;
	        }
	        else {
	            var currentIndex = count % skipCount;
	            var ring = this._ring;
	            var oldValue = ring[currentIndex];
	            ring[currentIndex] = value;
	            this.destination.next(oldValue);
	        }
	    };
	    return SkipLastSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
	function skipUntil(notifier) {
	    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
	}
	var SkipUntilOperator = /*@__PURE__*/ (function () {
	    function SkipUntilOperator(notifier) {
	        this.notifier = notifier;
	    }
	    SkipUntilOperator.prototype.call = function (destination, source) {
	        return source.subscribe(new SkipUntilSubscriber(destination, this.notifier));
	    };
	    return SkipUntilOperator;
	}());
	var SkipUntilSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SkipUntilSubscriber, _super);
	    function SkipUntilSubscriber(destination, notifier) {
	        var _this = _super.call(this, destination) || this;
	        _this.hasValue = false;
	        var innerSubscriber = new SimpleInnerSubscriber(_this);
	        _this.add(innerSubscriber);
	        _this.innerSubscription = innerSubscriber;
	        var innerSubscription = innerSubscribe(notifier, innerSubscriber);
	        if (innerSubscription !== innerSubscriber) {
	            _this.add(innerSubscription);
	            _this.innerSubscription = innerSubscription;
	        }
	        return _this;
	    }
	    SkipUntilSubscriber.prototype._next = function (value) {
	        if (this.hasValue) {
	            _super.prototype._next.call(this, value);
	        }
	    };
	    SkipUntilSubscriber.prototype.notifyNext = function () {
	        this.hasValue = true;
	        if (this.innerSubscription) {
	            this.innerSubscription.unsubscribe();
	        }
	    };
	    SkipUntilSubscriber.prototype.notifyComplete = function () {
	    };
	    return SkipUntilSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function skipWhile(predicate) {
	    return function (source) { return source.lift(new SkipWhileOperator(predicate)); };
	}
	var SkipWhileOperator = /*@__PURE__*/ (function () {
	    function SkipWhileOperator(predicate) {
	        this.predicate = predicate;
	    }
	    SkipWhileOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
	    };
	    return SkipWhileOperator;
	}());
	var SkipWhileSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SkipWhileSubscriber, _super);
	    function SkipWhileSubscriber(destination, predicate) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.skipping = true;
	        _this.index = 0;
	        return _this;
	    }
	    SkipWhileSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        if (this.skipping) {
	            this.tryCallPredicate(value);
	        }
	        if (!this.skipping) {
	            destination.next(value);
	        }
	    };
	    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
	        try {
	            var result = this.predicate(value, this.index++);
	            this.skipping = Boolean(result);
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    return SkipWhileSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START _observable_concat,_util_isScheduler PURE_IMPORTS_END */
	function startWith() {
	    var array = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        array[_i] = arguments[_i];
	    }
	    var scheduler = array[array.length - 1];
	    if (isScheduler(scheduler)) {
	        array.pop();
	        return function (source) { return concat$1(array, source, scheduler); };
	    }
	    else {
	        return function (source) { return concat$1(array, source); };
	    }
	}

	/** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */
	var SubscribeOnObservable = /*@__PURE__*/ (function (_super) {
	    __extends$1(SubscribeOnObservable, _super);
	    function SubscribeOnObservable(source, delayTime, scheduler) {
	        if (delayTime === void 0) {
	            delayTime = 0;
	        }
	        if (scheduler === void 0) {
	            scheduler = asap;
	        }
	        var _this = _super.call(this) || this;
	        _this.source = source;
	        _this.delayTime = delayTime;
	        _this.scheduler = scheduler;
	        if (!isNumeric(delayTime) || delayTime < 0) {
	            _this.delayTime = 0;
	        }
	        if (!scheduler || typeof scheduler.schedule !== 'function') {
	            _this.scheduler = asap;
	        }
	        return _this;
	    }
	    SubscribeOnObservable.create = function (source, delay, scheduler) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        if (scheduler === void 0) {
	            scheduler = asap;
	        }
	        return new SubscribeOnObservable(source, delay, scheduler);
	    };
	    SubscribeOnObservable.dispatch = function (arg) {
	        var source = arg.source, subscriber = arg.subscriber;
	        return this.add(source.subscribe(subscriber));
	    };
	    SubscribeOnObservable.prototype._subscribe = function (subscriber) {
	        var delay = this.delayTime;
	        var source = this.source;
	        var scheduler = this.scheduler;
	        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
	            source: source, subscriber: subscriber
	        });
	    };
	    return SubscribeOnObservable;
	}(Observable));

	/** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */
	function subscribeOn(scheduler, delay) {
	    if (delay === void 0) {
	        delay = 0;
	    }
	    return function subscribeOnOperatorFunction(source) {
	        return source.lift(new SubscribeOnOperator(scheduler, delay));
	    };
	}
	var SubscribeOnOperator = /*@__PURE__*/ (function () {
	    function SubscribeOnOperator(scheduler, delay) {
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    SubscribeOnOperator.prototype.call = function (subscriber, source) {
	        return new SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
	    };
	    return SubscribeOnOperator;
	}());

	/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */
	function switchMap(project, resultSelector) {
	    if (typeof resultSelector === 'function') {
	        return function (source) { return source.pipe(switchMap(function (a, i) { return from(project(a, i)).pipe(map(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
	    }
	    return function (source) { return source.lift(new SwitchMapOperator(project)); };
	}
	var SwitchMapOperator = /*@__PURE__*/ (function () {
	    function SwitchMapOperator(project) {
	        this.project = project;
	    }
	    SwitchMapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
	    };
	    return SwitchMapOperator;
	}());
	var SwitchMapSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(SwitchMapSubscriber, _super);
	    function SwitchMapSubscriber(destination, project) {
	        var _this = _super.call(this, destination) || this;
	        _this.project = project;
	        _this.index = 0;
	        return _this;
	    }
	    SwitchMapSubscriber.prototype._next = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (error) {
	            this.destination.error(error);
	            return;
	        }
	        this._innerSub(result);
	    };
	    SwitchMapSubscriber.prototype._innerSub = function (result) {
	        var innerSubscription = this.innerSubscription;
	        if (innerSubscription) {
	            innerSubscription.unsubscribe();
	        }
	        var innerSubscriber = new SimpleInnerSubscriber(this);
	        var destination = this.destination;
	        destination.add(innerSubscriber);
	        this.innerSubscription = innerSubscribe(result, innerSubscriber);
	        if (this.innerSubscription !== innerSubscriber) {
	            destination.add(this.innerSubscription);
	        }
	    };
	    SwitchMapSubscriber.prototype._complete = function () {
	        var innerSubscription = this.innerSubscription;
	        if (!innerSubscription || innerSubscription.closed) {
	            _super.prototype._complete.call(this);
	        }
	        this.unsubscribe();
	    };
	    SwitchMapSubscriber.prototype._unsubscribe = function () {
	        this.innerSubscription = undefined;
	    };
	    SwitchMapSubscriber.prototype.notifyComplete = function () {
	        this.innerSubscription = undefined;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapSubscriber.prototype.notifyNext = function (innerValue) {
	        this.destination.next(innerValue);
	    };
	    return SwitchMapSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START _switchMap,_util_identity PURE_IMPORTS_END */
	function switchAll() {
	    return switchMap(identity);
	}

	/** PURE_IMPORTS_START _switchMap PURE_IMPORTS_END */
	function switchMapTo(innerObservable, resultSelector) {
	    return resultSelector ? switchMap(function () { return innerObservable; }, resultSelector) : switchMap(function () { return innerObservable; });
	}

	/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
	function takeUntil(notifier) {
	    return function (source) { return source.lift(new TakeUntilOperator(notifier)); };
	}
	var TakeUntilOperator = /*@__PURE__*/ (function () {
	    function TakeUntilOperator(notifier) {
	        this.notifier = notifier;
	    }
	    TakeUntilOperator.prototype.call = function (subscriber, source) {
	        var takeUntilSubscriber = new TakeUntilSubscriber(subscriber);
	        var notifierSubscription = innerSubscribe(this.notifier, new SimpleInnerSubscriber(takeUntilSubscriber));
	        if (notifierSubscription && !takeUntilSubscriber.seenValue) {
	            takeUntilSubscriber.add(notifierSubscription);
	            return source.subscribe(takeUntilSubscriber);
	        }
	        return takeUntilSubscriber;
	    };
	    return TakeUntilOperator;
	}());
	var TakeUntilSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(TakeUntilSubscriber, _super);
	    function TakeUntilSubscriber(destination) {
	        var _this = _super.call(this, destination) || this;
	        _this.seenValue = false;
	        return _this;
	    }
	    TakeUntilSubscriber.prototype.notifyNext = function () {
	        this.seenValue = true;
	        this.complete();
	    };
	    TakeUntilSubscriber.prototype.notifyComplete = function () {
	    };
	    return TakeUntilSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
	function takeWhile(predicate, inclusive) {
	    if (inclusive === void 0) {
	        inclusive = false;
	    }
	    return function (source) {
	        return source.lift(new TakeWhileOperator(predicate, inclusive));
	    };
	}
	var TakeWhileOperator = /*@__PURE__*/ (function () {
	    function TakeWhileOperator(predicate, inclusive) {
	        this.predicate = predicate;
	        this.inclusive = inclusive;
	    }
	    TakeWhileOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate, this.inclusive));
	    };
	    return TakeWhileOperator;
	}());
	var TakeWhileSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(TakeWhileSubscriber, _super);
	    function TakeWhileSubscriber(destination, predicate, inclusive) {
	        var _this = _super.call(this, destination) || this;
	        _this.predicate = predicate;
	        _this.inclusive = inclusive;
	        _this.index = 0;
	        return _this;
	    }
	    TakeWhileSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        var result;
	        try {
	            result = this.predicate(value, this.index++);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        this.nextOrComplete(value, result);
	    };
	    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
	        var destination = this.destination;
	        if (Boolean(predicateResult)) {
	            destination.next(value);
	        }
	        else {
	            if (this.inclusive) {
	                destination.next(value);
	            }
	            destination.complete();
	        }
	    };
	    return TakeWhileSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */
	function tap(nextOrObserver, error, complete) {
	    return function tapOperatorFunction(source) {
	        return source.lift(new DoOperator(nextOrObserver, error, complete));
	    };
	}
	var DoOperator = /*@__PURE__*/ (function () {
	    function DoOperator(nextOrObserver, error, complete) {
	        this.nextOrObserver = nextOrObserver;
	        this.error = error;
	        this.complete = complete;
	    }
	    DoOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
	    };
	    return DoOperator;
	}());
	var TapSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(TapSubscriber, _super);
	    function TapSubscriber(destination, observerOrNext, error, complete) {
	        var _this = _super.call(this, destination) || this;
	        _this._tapNext = noop$1;
	        _this._tapError = noop$1;
	        _this._tapComplete = noop$1;
	        _this._tapError = error || noop$1;
	        _this._tapComplete = complete || noop$1;
	        if (isFunction$1(observerOrNext)) {
	            _this._context = _this;
	            _this._tapNext = observerOrNext;
	        }
	        else if (observerOrNext) {
	            _this._context = observerOrNext;
	            _this._tapNext = observerOrNext.next || noop$1;
	            _this._tapError = observerOrNext.error || noop$1;
	            _this._tapComplete = observerOrNext.complete || noop$1;
	        }
	        return _this;
	    }
	    TapSubscriber.prototype._next = function (value) {
	        try {
	            this._tapNext.call(this._context, value);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(value);
	    };
	    TapSubscriber.prototype._error = function (err) {
	        try {
	            this._tapError.call(this._context, err);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.error(err);
	    };
	    TapSubscriber.prototype._complete = function () {
	        try {
	            this._tapComplete.call(this._context);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        return this.destination.complete();
	    };
	    return TapSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
	var defaultThrottleConfig = {
	    leading: true,
	    trailing: false
	};
	function throttle(durationSelector, config) {
	    if (config === void 0) {
	        config = defaultThrottleConfig;
	    }
	    return function (source) { return source.lift(new ThrottleOperator(durationSelector, !!config.leading, !!config.trailing)); };
	}
	var ThrottleOperator = /*@__PURE__*/ (function () {
	    function ThrottleOperator(durationSelector, leading, trailing) {
	        this.durationSelector = durationSelector;
	        this.leading = leading;
	        this.trailing = trailing;
	    }
	    ThrottleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
	    };
	    return ThrottleOperator;
	}());
	var ThrottleSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(ThrottleSubscriber, _super);
	    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
	        var _this = _super.call(this, destination) || this;
	        _this.destination = destination;
	        _this.durationSelector = durationSelector;
	        _this._leading = _leading;
	        _this._trailing = _trailing;
	        _this._hasValue = false;
	        return _this;
	    }
	    ThrottleSubscriber.prototype._next = function (value) {
	        this._hasValue = true;
	        this._sendValue = value;
	        if (!this._throttled) {
	            if (this._leading) {
	                this.send();
	            }
	            else {
	                this.throttle(value);
	            }
	        }
	    };
	    ThrottleSubscriber.prototype.send = function () {
	        var _a = this, _hasValue = _a._hasValue, _sendValue = _a._sendValue;
	        if (_hasValue) {
	            this.destination.next(_sendValue);
	            this.throttle(_sendValue);
	        }
	        this._hasValue = false;
	        this._sendValue = undefined;
	    };
	    ThrottleSubscriber.prototype.throttle = function (value) {
	        var duration = this.tryDurationSelector(value);
	        if (!!duration) {
	            this.add(this._throttled = innerSubscribe(duration, new SimpleInnerSubscriber(this)));
	        }
	    };
	    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
	        try {
	            return this.durationSelector(value);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return null;
	        }
	    };
	    ThrottleSubscriber.prototype.throttlingDone = function () {
	        var _a = this, _throttled = _a._throttled, _trailing = _a._trailing;
	        if (_throttled) {
	            _throttled.unsubscribe();
	        }
	        this._throttled = undefined;
	        if (_trailing) {
	            this.send();
	        }
	    };
	    ThrottleSubscriber.prototype.notifyNext = function () {
	        this.throttlingDone();
	    };
	    ThrottleSubscriber.prototype.notifyComplete = function () {
	        this.throttlingDone();
	    };
	    return ThrottleSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async,_throttle PURE_IMPORTS_END */
	function throttleTime(duration, scheduler, config) {
	    if (scheduler === void 0) {
	        scheduler = async;
	    }
	    if (config === void 0) {
	        config = defaultThrottleConfig;
	    }
	    return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
	}
	var ThrottleTimeOperator = /*@__PURE__*/ (function () {
	    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
	        this.duration = duration;
	        this.scheduler = scheduler;
	        this.leading = leading;
	        this.trailing = trailing;
	    }
	    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
	    };
	    return ThrottleTimeOperator;
	}());
	var ThrottleTimeSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(ThrottleTimeSubscriber, _super);
	    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
	        var _this = _super.call(this, destination) || this;
	        _this.duration = duration;
	        _this.scheduler = scheduler;
	        _this.leading = leading;
	        _this.trailing = trailing;
	        _this._hasTrailingValue = false;
	        _this._trailingValue = null;
	        return _this;
	    }
	    ThrottleTimeSubscriber.prototype._next = function (value) {
	        if (this.throttled) {
	            if (this.trailing) {
	                this._trailingValue = value;
	                this._hasTrailingValue = true;
	            }
	        }
	        else {
	            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
	            if (this.leading) {
	                this.destination.next(value);
	            }
	            else if (this.trailing) {
	                this._trailingValue = value;
	                this._hasTrailingValue = true;
	            }
	        }
	    };
	    ThrottleTimeSubscriber.prototype._complete = function () {
	        if (this._hasTrailingValue) {
	            this.destination.next(this._trailingValue);
	            this.destination.complete();
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
	        var throttled = this.throttled;
	        if (throttled) {
	            if (this.trailing && this._hasTrailingValue) {
	                this.destination.next(this._trailingValue);
	                this._trailingValue = null;
	                this._hasTrailingValue = false;
	            }
	            throttled.unsubscribe();
	            this.remove(throttled);
	            this.throttled = null;
	        }
	    };
	    return ThrottleTimeSubscriber;
	}(Subscriber));
	function dispatchNext(arg) {
	    var subscriber = arg.subscriber;
	    subscriber.clearThrottle();
	}

	/** PURE_IMPORTS_START _scheduler_async,_scan,_observable_defer,_map PURE_IMPORTS_END */
	function timeInterval(scheduler) {
	    if (scheduler === void 0) {
	        scheduler = async;
	    }
	    return function (source) {
	        return defer(function () {
	            return source.pipe(scan(function (_a, value) {
	                var current = _a.current;
	                return ({ value: value, current: scheduler.now(), last: current });
	            }, { current: scheduler.now(), value: undefined, last: undefined }), map(function (_a) {
	                var current = _a.current, last = _a.last, value = _a.value;
	                return new TimeInterval(value, current - last);
	            }));
	        });
	    };
	}
	var TimeInterval = /*@__PURE__*/ (function () {
	    function TimeInterval(value, interval) {
	        this.value = value;
	        this.interval = interval;
	    }
	    return TimeInterval;
	}());

	/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_innerSubscribe PURE_IMPORTS_END */
	function timeoutWith(due, withObservable, scheduler) {
	    if (scheduler === void 0) {
	        scheduler = async;
	    }
	    return function (source) {
	        var absoluteTimeout = isDate(due);
	        var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
	        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
	    };
	}
	var TimeoutWithOperator = /*@__PURE__*/ (function () {
	    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
	        this.waitFor = waitFor;
	        this.absoluteTimeout = absoluteTimeout;
	        this.withObservable = withObservable;
	        this.scheduler = scheduler;
	    }
	    TimeoutWithOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
	    };
	    return TimeoutWithOperator;
	}());
	var TimeoutWithSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(TimeoutWithSubscriber, _super);
	    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.absoluteTimeout = absoluteTimeout;
	        _this.waitFor = waitFor;
	        _this.withObservable = withObservable;
	        _this.scheduler = scheduler;
	        _this.scheduleTimeout();
	        return _this;
	    }
	    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
	        var withObservable = subscriber.withObservable;
	        subscriber._unsubscribeAndRecycle();
	        subscriber.add(innerSubscribe(withObservable, new SimpleInnerSubscriber(subscriber)));
	    };
	    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
	        var action = this.action;
	        if (action) {
	            this.action = action.schedule(this, this.waitFor);
	        }
	        else {
	            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
	        }
	    };
	    TimeoutWithSubscriber.prototype._next = function (value) {
	        if (!this.absoluteTimeout) {
	            this.scheduleTimeout();
	        }
	        _super.prototype._next.call(this, value);
	    };
	    TimeoutWithSubscriber.prototype._unsubscribe = function () {
	        this.action = undefined;
	        this.scheduler = null;
	        this.withObservable = null;
	    };
	    return TimeoutWithSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START _scheduler_async,_util_TimeoutError,_timeoutWith,_observable_throwError PURE_IMPORTS_END */
	function timeout(due, scheduler) {
	    if (scheduler === void 0) {
	        scheduler = async;
	    }
	    return timeoutWith(due, throwError(new TimeoutError()), scheduler);
	}

	/** PURE_IMPORTS_START _scheduler_async,_map PURE_IMPORTS_END */
	function timestamp(scheduler) {
	    if (scheduler === void 0) {
	        scheduler = async;
	    }
	    return map(function (value) { return new Timestamp(value, scheduler.now()); });
	}
	var Timestamp = /*@__PURE__*/ (function () {
	    function Timestamp(value, timestamp) {
	        this.value = value;
	        this.timestamp = timestamp;
	    }
	    return Timestamp;
	}());

	/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */
	function toArrayReducer(arr, item, index) {
	    if (index === 0) {
	        return [item];
	    }
	    arr.push(item);
	    return arr;
	}
	function toArray() {
	    return reduce(toArrayReducer, []);
	}

	/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */
	function window$1(windowBoundaries) {
	    return function windowOperatorFunction(source) {
	        return source.lift(new WindowOperator$1(windowBoundaries));
	    };
	}
	var WindowOperator$1 = /*@__PURE__*/ (function () {
	    function WindowOperator(windowBoundaries) {
	        this.windowBoundaries = windowBoundaries;
	    }
	    WindowOperator.prototype.call = function (subscriber, source) {
	        var windowSubscriber = new WindowSubscriber$1(subscriber);
	        var sourceSubscription = source.subscribe(windowSubscriber);
	        if (!sourceSubscription.closed) {
	            windowSubscriber.add(innerSubscribe(this.windowBoundaries, new SimpleInnerSubscriber(windowSubscriber)));
	        }
	        return sourceSubscription;
	    };
	    return WindowOperator;
	}());
	var WindowSubscriber$1 = /*@__PURE__*/ (function (_super) {
	    __extends$1(WindowSubscriber, _super);
	    function WindowSubscriber(destination) {
	        var _this = _super.call(this, destination) || this;
	        _this.window = new Subject();
	        destination.next(_this.window);
	        return _this;
	    }
	    WindowSubscriber.prototype.notifyNext = function () {
	        this.openWindow();
	    };
	    WindowSubscriber.prototype.notifyError = function (error) {
	        this._error(error);
	    };
	    WindowSubscriber.prototype.notifyComplete = function () {
	        this._complete();
	    };
	    WindowSubscriber.prototype._next = function (value) {
	        this.window.next(value);
	    };
	    WindowSubscriber.prototype._error = function (err) {
	        this.window.error(err);
	        this.destination.error(err);
	    };
	    WindowSubscriber.prototype._complete = function () {
	        this.window.complete();
	        this.destination.complete();
	    };
	    WindowSubscriber.prototype._unsubscribe = function () {
	        this.window = null;
	    };
	    WindowSubscriber.prototype.openWindow = function () {
	        var prevWindow = this.window;
	        if (prevWindow) {
	            prevWindow.complete();
	        }
	        var destination = this.destination;
	        var newWindow = this.window = new Subject();
	        destination.next(newWindow);
	    };
	    return WindowSubscriber;
	}(SimpleOuterSubscriber));

	/** PURE_IMPORTS_START tslib,_Subscriber,_Subject PURE_IMPORTS_END */
	function windowCount(windowSize, startWindowEvery) {
	    if (startWindowEvery === void 0) {
	        startWindowEvery = 0;
	    }
	    return function windowCountOperatorFunction(source) {
	        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
	    };
	}
	var WindowCountOperator = /*@__PURE__*/ (function () {
	    function WindowCountOperator(windowSize, startWindowEvery) {
	        this.windowSize = windowSize;
	        this.startWindowEvery = startWindowEvery;
	    }
	    WindowCountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
	    };
	    return WindowCountOperator;
	}());
	var WindowCountSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(WindowCountSubscriber, _super);
	    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
	        var _this = _super.call(this, destination) || this;
	        _this.destination = destination;
	        _this.windowSize = windowSize;
	        _this.startWindowEvery = startWindowEvery;
	        _this.windows = [new Subject()];
	        _this.count = 0;
	        destination.next(_this.windows[0]);
	        return _this;
	    }
	    WindowCountSubscriber.prototype._next = function (value) {
	        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
	        var destination = this.destination;
	        var windowSize = this.windowSize;
	        var windows = this.windows;
	        var len = windows.length;
	        for (var i = 0; i < len && !this.closed; i++) {
	            windows[i].next(value);
	        }
	        var c = this.count - windowSize + 1;
	        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
	            windows.shift().complete();
	        }
	        if (++this.count % startWindowEvery === 0 && !this.closed) {
	            var window_1 = new Subject();
	            windows.push(window_1);
	            destination.next(window_1);
	        }
	    };
	    WindowCountSubscriber.prototype._error = function (err) {
	        var windows = this.windows;
	        if (windows) {
	            while (windows.length > 0 && !this.closed) {
	                windows.shift().error(err);
	            }
	        }
	        this.destination.error(err);
	    };
	    WindowCountSubscriber.prototype._complete = function () {
	        var windows = this.windows;
	        if (windows) {
	            while (windows.length > 0 && !this.closed) {
	                windows.shift().complete();
	            }
	        }
	        this.destination.complete();
	    };
	    WindowCountSubscriber.prototype._unsubscribe = function () {
	        this.count = 0;
	        this.windows = null;
	    };
	    return WindowCountSubscriber;
	}(Subscriber));

	/** PURE_IMPORTS_START tslib,_Subject,_scheduler_async,_Subscriber,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */
	function windowTime(windowTimeSpan) {
	    var scheduler = async;
	    var windowCreationInterval = null;
	    var maxWindowSize = Number.POSITIVE_INFINITY;
	    if (isScheduler(arguments[3])) {
	        scheduler = arguments[3];
	    }
	    if (isScheduler(arguments[2])) {
	        scheduler = arguments[2];
	    }
	    else if (isNumeric(arguments[2])) {
	        maxWindowSize = Number(arguments[2]);
	    }
	    if (isScheduler(arguments[1])) {
	        scheduler = arguments[1];
	    }
	    else if (isNumeric(arguments[1])) {
	        windowCreationInterval = Number(arguments[1]);
	    }
	    return function windowTimeOperatorFunction(source) {
	        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
	    };
	}
	var WindowTimeOperator = /*@__PURE__*/ (function () {
	    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
	        this.windowTimeSpan = windowTimeSpan;
	        this.windowCreationInterval = windowCreationInterval;
	        this.maxWindowSize = maxWindowSize;
	        this.scheduler = scheduler;
	    }
	    WindowTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
	    };
	    return WindowTimeOperator;
	}());
	var CountedSubject = /*@__PURE__*/ (function (_super) {
	    __extends$1(CountedSubject, _super);
	    function CountedSubject() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._numberOfNextedValues = 0;
	        return _this;
	    }
	    CountedSubject.prototype.next = function (value) {
	        this._numberOfNextedValues++;
	        _super.prototype.next.call(this, value);
	    };
	    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
	        get: function () {
	            return this._numberOfNextedValues;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return CountedSubject;
	}(Subject));
	var WindowTimeSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(WindowTimeSubscriber, _super);
	    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
	        var _this = _super.call(this, destination) || this;
	        _this.destination = destination;
	        _this.windowTimeSpan = windowTimeSpan;
	        _this.windowCreationInterval = windowCreationInterval;
	        _this.maxWindowSize = maxWindowSize;
	        _this.scheduler = scheduler;
	        _this.windows = [];
	        var window = _this.openWindow();
	        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
	            var closeState = { subscriber: _this, window: window, context: null };
	            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: _this, scheduler: scheduler };
	            _this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
	            _this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
	        }
	        else {
	            var timeSpanOnlyState = { subscriber: _this, window: window, windowTimeSpan: windowTimeSpan };
	            _this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
	        }
	        return _this;
	    }
	    WindowTimeSubscriber.prototype._next = function (value) {
	        var windows = this.windows;
	        var len = windows.length;
	        for (var i = 0; i < len; i++) {
	            var window_1 = windows[i];
	            if (!window_1.closed) {
	                window_1.next(value);
	                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
	                    this.closeWindow(window_1);
	                }
	            }
	        }
	    };
	    WindowTimeSubscriber.prototype._error = function (err) {
	        var windows = this.windows;
	        while (windows.length > 0) {
	            windows.shift().error(err);
	        }
	        this.destination.error(err);
	    };
	    WindowTimeSubscriber.prototype._complete = function () {
	        var windows = this.windows;
	        while (windows.length > 0) {
	            var window_2 = windows.shift();
	            if (!window_2.closed) {
	                window_2.complete();
	            }
	        }
	        this.destination.complete();
	    };
	    WindowTimeSubscriber.prototype.openWindow = function () {
	        var window = new CountedSubject();
	        this.windows.push(window);
	        var destination = this.destination;
	        destination.next(window);
	        return window;
	    };
	    WindowTimeSubscriber.prototype.closeWindow = function (window) {
	        window.complete();
	        var windows = this.windows;
	        windows.splice(windows.indexOf(window), 1);
	    };
	    return WindowTimeSubscriber;
	}(Subscriber));
	function dispatchWindowTimeSpanOnly(state) {
	    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
	    if (window) {
	        subscriber.closeWindow(window);
	    }
	    state.window = subscriber.openWindow();
	    this.schedule(state, windowTimeSpan);
	}
	function dispatchWindowCreation(state) {
	    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
	    var window = subscriber.openWindow();
	    var action = this;
	    var context = { action: action, subscription: null };
	    var timeSpanState = { subscriber: subscriber, window: window, context: context };
	    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
	    action.add(context.subscription);
	    action.schedule(state, windowCreationInterval);
	}
	function dispatchWindowClose(state) {
	    var subscriber = state.subscriber, window = state.window, context = state.context;
	    if (context && context.action && context.subscription) {
	        context.action.remove(context.subscription);
	    }
	    subscriber.closeWindow(window);
	}

	/** PURE_IMPORTS_START tslib,_Subject,_Subscription,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
	function windowToggle(openings, closingSelector) {
	    return function (source) { return source.lift(new WindowToggleOperator(openings, closingSelector)); };
	}
	var WindowToggleOperator = /*@__PURE__*/ (function () {
	    function WindowToggleOperator(openings, closingSelector) {
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	    }
	    WindowToggleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
	    };
	    return WindowToggleOperator;
	}());
	var WindowToggleSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(WindowToggleSubscriber, _super);
	    function WindowToggleSubscriber(destination, openings, closingSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.openings = openings;
	        _this.closingSelector = closingSelector;
	        _this.contexts = [];
	        _this.add(_this.openSubscription = subscribeToResult(_this, openings, openings));
	        return _this;
	    }
	    WindowToggleSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        if (contexts) {
	            var len = contexts.length;
	            for (var i = 0; i < len; i++) {
	                contexts[i].window.next(value);
	            }
	        }
	    };
	    WindowToggleSubscriber.prototype._error = function (err) {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context_1 = contexts[index];
	                context_1.window.error(err);
	                context_1.subscription.unsubscribe();
	            }
	        }
	        _super.prototype._error.call(this, err);
	    };
	    WindowToggleSubscriber.prototype._complete = function () {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context_2 = contexts[index];
	                context_2.window.complete();
	                context_2.subscription.unsubscribe();
	            }
	        }
	        _super.prototype._complete.call(this);
	    };
	    WindowToggleSubscriber.prototype._unsubscribe = function () {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context_3 = contexts[index];
	                context_3.window.unsubscribe();
	                context_3.subscription.unsubscribe();
	            }
	        }
	    };
	    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (outerValue === this.openings) {
	            var closingNotifier = void 0;
	            try {
	                var closingSelector = this.closingSelector;
	                closingNotifier = closingSelector(innerValue);
	            }
	            catch (e) {
	                return this.error(e);
	            }
	            var window_1 = new Subject();
	            var subscription = new Subscription();
	            var context_4 = { window: window_1, subscription: subscription };
	            this.contexts.push(context_4);
	            var innerSubscription = subscribeToResult(this, closingNotifier, context_4);
	            if (innerSubscription.closed) {
	                this.closeWindow(this.contexts.length - 1);
	            }
	            else {
	                innerSubscription.context = context_4;
	                subscription.add(innerSubscription);
	            }
	            this.destination.next(window_1);
	        }
	        else {
	            this.closeWindow(this.contexts.indexOf(outerValue));
	        }
	    };
	    WindowToggleSubscriber.prototype.notifyError = function (err) {
	        this.error(err);
	    };
	    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
	        if (inner !== this.openSubscription) {
	            this.closeWindow(this.contexts.indexOf(inner.context));
	        }
	    };
	    WindowToggleSubscriber.prototype.closeWindow = function (index) {
	        if (index === -1) {
	            return;
	        }
	        var contexts = this.contexts;
	        var context = contexts[index];
	        var window = context.window, subscription = context.subscription;
	        contexts.splice(index, 1);
	        window.complete();
	        subscription.unsubscribe();
	    };
	    return WindowToggleSubscriber;
	}(OuterSubscriber));

	/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
	function windowWhen(closingSelector) {
	    return function windowWhenOperatorFunction(source) {
	        return source.lift(new WindowOperator(closingSelector));
	    };
	}
	var WindowOperator = /*@__PURE__*/ (function () {
	    function WindowOperator(closingSelector) {
	        this.closingSelector = closingSelector;
	    }
	    WindowOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
	    };
	    return WindowOperator;
	}());
	var WindowSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(WindowSubscriber, _super);
	    function WindowSubscriber(destination, closingSelector) {
	        var _this = _super.call(this, destination) || this;
	        _this.destination = destination;
	        _this.closingSelector = closingSelector;
	        _this.openWindow();
	        return _this;
	    }
	    WindowSubscriber.prototype.notifyNext = function (_outerValue, _innerValue, _outerIndex, _innerIndex, innerSub) {
	        this.openWindow(innerSub);
	    };
	    WindowSubscriber.prototype.notifyError = function (error) {
	        this._error(error);
	    };
	    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.openWindow(innerSub);
	    };
	    WindowSubscriber.prototype._next = function (value) {
	        this.window.next(value);
	    };
	    WindowSubscriber.prototype._error = function (err) {
	        this.window.error(err);
	        this.destination.error(err);
	        this.unsubscribeClosingNotification();
	    };
	    WindowSubscriber.prototype._complete = function () {
	        this.window.complete();
	        this.destination.complete();
	        this.unsubscribeClosingNotification();
	    };
	    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
	        if (this.closingNotification) {
	            this.closingNotification.unsubscribe();
	        }
	    };
	    WindowSubscriber.prototype.openWindow = function (innerSub) {
	        if (innerSub === void 0) {
	            innerSub = null;
	        }
	        if (innerSub) {
	            this.remove(innerSub);
	            innerSub.unsubscribe();
	        }
	        var prevWindow = this.window;
	        if (prevWindow) {
	            prevWindow.complete();
	        }
	        var window = this.window = new Subject();
	        this.destination.next(window);
	        var closingNotifier;
	        try {
	            var closingSelector = this.closingSelector;
	            closingNotifier = closingSelector();
	        }
	        catch (e) {
	            this.destination.error(e);
	            this.window.error(e);
	            return;
	        }
	        this.add(this.closingNotification = subscribeToResult(this, closingNotifier));
	    };
	    return WindowSubscriber;
	}(OuterSubscriber));

	/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
	function withLatestFrom() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return function (source) {
	        var project;
	        if (typeof args[args.length - 1] === 'function') {
	            project = args.pop();
	        }
	        var observables = args;
	        return source.lift(new WithLatestFromOperator(observables, project));
	    };
	}
	var WithLatestFromOperator = /*@__PURE__*/ (function () {
	    function WithLatestFromOperator(observables, project) {
	        this.observables = observables;
	        this.project = project;
	    }
	    WithLatestFromOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
	    };
	    return WithLatestFromOperator;
	}());
	var WithLatestFromSubscriber = /*@__PURE__*/ (function (_super) {
	    __extends$1(WithLatestFromSubscriber, _super);
	    function WithLatestFromSubscriber(destination, observables, project) {
	        var _this = _super.call(this, destination) || this;
	        _this.observables = observables;
	        _this.project = project;
	        _this.toRespond = [];
	        var len = observables.length;
	        _this.values = new Array(len);
	        for (var i = 0; i < len; i++) {
	            _this.toRespond.push(i);
	        }
	        for (var i = 0; i < len; i++) {
	            var observable = observables[i];
	            _this.add(subscribeToResult(_this, observable, undefined, i));
	        }
	        return _this;
	    }
	    WithLatestFromSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
	        this.values[outerIndex] = innerValue;
	        var toRespond = this.toRespond;
	        if (toRespond.length > 0) {
	            var found = toRespond.indexOf(outerIndex);
	            if (found !== -1) {
	                toRespond.splice(found, 1);
	            }
	        }
	    };
	    WithLatestFromSubscriber.prototype.notifyComplete = function () {
	    };
	    WithLatestFromSubscriber.prototype._next = function (value) {
	        if (this.toRespond.length === 0) {
	            var args = [value].concat(this.values);
	            if (this.project) {
	                this._tryProject(args);
	            }
	            else {
	                this.destination.next(args);
	            }
	        }
	    };
	    WithLatestFromSubscriber.prototype._tryProject = function (args) {
	        var result;
	        try {
	            result = this.project.apply(this, args);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return WithLatestFromSubscriber;
	}(OuterSubscriber));

	/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */
	function zip() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i] = arguments[_i];
	    }
	    return function zipOperatorFunction(source) {
	        return source.lift.call(zip$1.apply(void 0, [source].concat(observables)));
	    };
	}

	/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */
	function zipAll(project) {
	    return function (source) { return source.lift(new ZipOperator(project)); };
	}

	/** PURE_IMPORTS_START  PURE_IMPORTS_END */

	var operators = /*#__PURE__*/Object.freeze({
		__proto__: null,
		audit: audit,
		auditTime: auditTime,
		buffer: buffer,
		bufferCount: bufferCount,
		bufferTime: bufferTime,
		bufferToggle: bufferToggle,
		bufferWhen: bufferWhen,
		catchError: catchError,
		combineAll: combineAll,
		combineLatest: combineLatest,
		concat: concat,
		concatAll: concatAll,
		concatMap: concatMap,
		concatMapTo: concatMapTo,
		count: count,
		debounce: debounce,
		debounceTime: debounceTime,
		defaultIfEmpty: defaultIfEmpty,
		delay: delay,
		delayWhen: delayWhen,
		dematerialize: dematerialize,
		distinct: distinct,
		distinctUntilChanged: distinctUntilChanged,
		distinctUntilKeyChanged: distinctUntilKeyChanged,
		elementAt: elementAt,
		endWith: endWith,
		every: every,
		exhaust: exhaust,
		exhaustMap: exhaustMap,
		expand: expand,
		filter: filter,
		finalize: finalize,
		find: find,
		findIndex: findIndex,
		first: first,
		flatMap: flatMap,
		groupBy: groupBy,
		ignoreElements: ignoreElements,
		isEmpty: isEmpty,
		last: last,
		map: map,
		mapTo: mapTo,
		materialize: materialize,
		max: max,
		merge: merge,
		mergeAll: mergeAll,
		mergeMap: mergeMap,
		mergeMapTo: mergeMapTo,
		mergeScan: mergeScan,
		min: min,
		multicast: multicast,
		observeOn: observeOn,
		onErrorResumeNext: onErrorResumeNext,
		pairwise: pairwise,
		partition: partition,
		pluck: pluck,
		publish: publish,
		publishBehavior: publishBehavior,
		publishLast: publishLast,
		publishReplay: publishReplay,
		race: race,
		reduce: reduce,
		refCount: refCount,
		repeat: repeat,
		repeatWhen: repeatWhen,
		retry: retry,
		retryWhen: retryWhen,
		sample: sample,
		sampleTime: sampleTime,
		scan: scan,
		sequenceEqual: sequenceEqual,
		share: share,
		shareReplay: shareReplay,
		single: single,
		skip: skip,
		skipLast: skipLast,
		skipUntil: skipUntil,
		skipWhile: skipWhile,
		startWith: startWith,
		subscribeOn: subscribeOn,
		switchAll: switchAll,
		switchMap: switchMap,
		switchMapTo: switchMapTo,
		take: take,
		takeLast: takeLast,
		takeUntil: takeUntil,
		takeWhile: takeWhile,
		tap: tap,
		throttle: throttle,
		throttleTime: throttleTime,
		throwIfEmpty: throwIfEmpty,
		timeInterval: timeInterval,
		timeout: timeout,
		timeoutWith: timeoutWith,
		timestamp: timestamp,
		toArray: toArray,
		window: window$1,
		windowCount: windowCount,
		windowTime: windowTime,
		windowToggle: windowToggle,
		windowWhen: windowWhen,
		withLatestFrom: withLatestFrom,
		zip: zip,
		zipAll: zipAll
	});

	var require$$2 = /*@__PURE__*/getAugmentedNamespace(operators);

	var WalletSDKConnection$1 = {};

	var ClientMessage = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(ClientMessage, "__esModule", { value: true });
	ClientMessage.ClientMessagePublishEvent = ClientMessage.ClientMessageSetSessionConfig = ClientMessage.ClientMessageGetSessionConfig = ClientMessage.ClientMessageIsLinked = ClientMessage.ClientMessageHostSession = void 0;
	function ClientMessageHostSession(params) {
	    return Object.assign({ type: "HostSession" }, params);
	}
	ClientMessage.ClientMessageHostSession = ClientMessageHostSession;
	function ClientMessageIsLinked(params) {
	    return Object.assign({ type: "IsLinked" }, params);
	}
	ClientMessage.ClientMessageIsLinked = ClientMessageIsLinked;
	function ClientMessageGetSessionConfig(params) {
	    return Object.assign({ type: "GetSessionConfig" }, params);
	}
	ClientMessage.ClientMessageGetSessionConfig = ClientMessageGetSessionConfig;
	function ClientMessageSetSessionConfig(params) {
	    return Object.assign({ type: "SetSessionConfig" }, params);
	}
	ClientMessage.ClientMessageSetSessionConfig = ClientMessageSetSessionConfig;
	function ClientMessagePublishEvent(params) {
	    return Object.assign({ type: "PublishEvent" }, params);
	}
	ClientMessage.ClientMessagePublishEvent = ClientMessagePublishEvent;

	var RxWebSocket = {};

	(function (exports) {
		// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
		// Licensed under the Apache License, version 2.0
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.RxWebSocket = exports.ConnectionState = void 0;
		const rxjs_1 = require$$1;
		const operators_1 = require$$2;
		var ConnectionState;
		(function (ConnectionState) {
		    ConnectionState[ConnectionState["DISCONNECTED"] = 0] = "DISCONNECTED";
		    ConnectionState[ConnectionState["CONNECTING"] = 1] = "CONNECTING";
		    ConnectionState[ConnectionState["CONNECTED"] = 2] = "CONNECTED";
		})(ConnectionState = exports.ConnectionState || (exports.ConnectionState = {}));
		/**
		 * Rx-ified WebSocket
		 */
		class RxWebSocket {
		    /**
		     * Constructor
		     * @param url WebSocket server URL
		     * @param [WebSocketClass] Custom WebSocket implementation
		     */
		    constructor(url, WebSocketClass = WebSocket) {
		        this.WebSocketClass = WebSocketClass;
		        this.webSocket = null;
		        this.connectionStateSubject = new rxjs_1.BehaviorSubject(ConnectionState.DISCONNECTED);
		        this.incomingDataSubject = new rxjs_1.Subject();
		        this.url = url.replace(/^http/, "ws");
		    }
		    /**
		     * Make a websocket connection
		     * @returns an Observable that completes when connected
		     */
		    connect() {
		        if (this.webSocket) {
		            return (0, rxjs_1.throwError)(new Error("webSocket object is not null"));
		        }
		        return new rxjs_1.Observable(obs => {
		            let webSocket;
		            try {
		                this.webSocket = webSocket = new this.WebSocketClass(this.url);
		            }
		            catch (err) {
		                obs.error(err);
		                return;
		            }
		            this.connectionStateSubject.next(ConnectionState.CONNECTING);
		            webSocket.onclose = evt => {
		                this.clearWebSocket();
		                obs.error(new Error(`websocket error ${evt.code}: ${evt.reason}`));
		                this.connectionStateSubject.next(ConnectionState.DISCONNECTED);
		            };
		            webSocket.onopen = _ => {
		                obs.next();
		                obs.complete();
		                this.connectionStateSubject.next(ConnectionState.CONNECTED);
		            };
		            webSocket.onmessage = evt => {
		                this.incomingDataSubject.next(evt.data);
		            };
		        }).pipe((0, operators_1.take)(1));
		    }
		    /**
		     * Disconnect from server
		     */
		    disconnect() {
		        const { webSocket } = this;
		        if (!webSocket) {
		            return;
		        }
		        this.clearWebSocket();
		        this.connectionStateSubject.next(ConnectionState.DISCONNECTED);
		        try {
		            webSocket.close();
		        }
		        catch (_a) { }
		    }
		    /**
		     * Emit current connection state and subsequent changes
		     * @returns an Observable for the connection state
		     */
		    get connectionState$() {
		        return this.connectionStateSubject.asObservable();
		    }
		    /**
		     * Emit incoming data from server
		     * @returns an Observable for the data received
		     */
		    get incomingData$() {
		        return this.incomingDataSubject.asObservable();
		    }
		    /**
		     * Emit incoming JSON data from server. non-JSON data are ignored
		     * @returns an Observable for parsed JSON data
		     */
		    get incomingJSONData$() {
		        return this.incomingData$.pipe((0, operators_1.flatMap)(m => {
		            let j;
		            try {
		                j = JSON.parse(m);
		            }
		            catch (err) {
		                return (0, rxjs_1.empty)();
		            }
		            return (0, rxjs_1.of)(j);
		        }));
		    }
		    /**
		     * Send data to server
		     * @param data text to send
		     */
		    sendData(data) {
		        const { webSocket } = this;
		        if (!webSocket) {
		            throw new Error("websocket is not connected");
		        }
		        webSocket.send(data);
		    }
		    clearWebSocket() {
		        const { webSocket } = this;
		        if (!webSocket) {
		            return;
		        }
		        this.webSocket = null;
		        webSocket.onclose = null;
		        webSocket.onerror = null;
		        webSocket.onmessage = null;
		        webSocket.onopen = null;
		    }
		}
		exports.RxWebSocket = RxWebSocket; 
	} (RxWebSocket));

	var ServerMessage = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(ServerMessage, "__esModule", { value: true });
	ServerMessage.isServerMessageFail = void 0;
	function isServerMessageFail(msg) {
	    return (msg &&
	        msg.type === "Fail" &&
	        typeof msg.id === "number" &&
	        typeof msg.sessionId === "string" &&
	        typeof msg.error === "string");
	}
	ServerMessage.isServerMessageFail = isServerMessageFail;

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(WalletSDKConnection$1, "__esModule", { value: true });
	WalletSDKConnection$1.WalletSDKConnection = void 0;
	const rxjs_1$1 = require$$1;
	const operators_1$1 = require$$2;
	const Session_1$1 = Session$1;
	const types_1$1 = types$4;
	const ClientMessage_1 = ClientMessage;
	const DiagnosticLogger_1$1 = DiagnosticLogger;
	const RxWebSocket_1 = RxWebSocket;
	const ServerMessage_1 = ServerMessage;
	const HEARTBEAT_INTERVAL = 10000;
	const REQUEST_TIMEOUT = 60000;
	/**
	 * Coinbase Wallet Connection
	 */
	class WalletSDKConnection {
	    /**
	     * Constructor
	     * @param sessionId Session ID
	     * @param sessionKey Session Key
	     * @param linkAPIUrl Coinbase Wallet link server URL
	     * @param [WebSocketClass] Custom WebSocket implementation
	     */
	    constructor(sessionId, sessionKey, linkAPIUrl, diagnostic, WebSocketClass = WebSocket) {
	        this.sessionId = sessionId;
	        this.sessionKey = sessionKey;
	        this.diagnostic = diagnostic;
	        this.subscriptions = new rxjs_1$1.Subscription();
	        this.destroyed = false;
	        this.lastHeartbeatResponse = 0;
	        this.nextReqId = (0, types_1$1.IntNumber)(1);
	        this.connectedSubject = new rxjs_1$1.BehaviorSubject(false);
	        this.linkedSubject = new rxjs_1$1.BehaviorSubject(false);
	        this.sessionConfigSubject = new rxjs_1$1.ReplaySubject(1);
	        const ws = new RxWebSocket_1.RxWebSocket(linkAPIUrl + "/rpc", WebSocketClass);
	        this.ws = ws;
	        // attempt to reconnect every 5 seconds when disconnected
	        this.subscriptions.add(ws.connectionState$
	            .pipe((0, operators_1$1.tap)(state => {
	            var _a;
	            return (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1$1.EVENTS.CONNECTED_STATE_CHANGE, {
	                state,
	                sessionIdHash: Session_1$1.Session.hash(sessionId),
	            });
	        }), 
	        // ignore initial DISCONNECTED state
	        (0, operators_1$1.skip)(1), 
	        // if DISCONNECTED and not destroyed
	        (0, operators_1$1.filter)(cs => cs === RxWebSocket_1.ConnectionState.DISCONNECTED && !this.destroyed), 
	        // wait 5 seconds
	        (0, operators_1$1.delay)(5000), 
	        // check whether it's destroyed again
	        (0, operators_1$1.filter)(_ => !this.destroyed), 
	        // reconnect
	        (0, operators_1$1.flatMap)(_ => ws.connect()), (0, operators_1$1.retry)())
	            .subscribe());
	        // perform authentication upon connection
	        this.subscriptions.add(ws.connectionState$
	            .pipe(
	        // ignore initial DISCONNECTED and CONNECTING states
	        (0, operators_1$1.skip)(2), (0, operators_1$1.switchMap)(cs => (0, rxjs_1$1.iif)(() => cs === RxWebSocket_1.ConnectionState.CONNECTED, 
	        // if CONNECTED, authenticate, and then check link status
	        this.authenticate().pipe((0, operators_1$1.tap)(_ => this.sendIsLinked()), (0, operators_1$1.tap)(_ => this.sendGetSessionConfig()), (0, operators_1$1.map)(_ => true)), 
	        // if not CONNECTED, emit false immediately
	        (0, rxjs_1$1.of)(false))), (0, operators_1$1.distinctUntilChanged)(), (0, operators_1$1.catchError)(_ => (0, rxjs_1$1.of)(false)))
	            .subscribe(connected => this.connectedSubject.next(connected)));
	        // send heartbeat every n seconds while connected
	        this.subscriptions.add(ws.connectionState$
	            .pipe(
	        // ignore initial DISCONNECTED state
	        (0, operators_1$1.skip)(1), (0, operators_1$1.switchMap)(cs => (0, rxjs_1$1.iif)(() => cs === RxWebSocket_1.ConnectionState.CONNECTED, 
	        // if CONNECTED, start the heartbeat timer
	        (0, rxjs_1$1.timer)(0, HEARTBEAT_INTERVAL))))
	            .subscribe(i => 
	        // first timer event updates lastHeartbeat timestamp
	        // subsequent calls send heartbeat message
	        i === 0 ? this.updateLastHeartbeat() : this.heartbeat()));
	        // handle server's heartbeat responses
	        this.subscriptions.add(ws.incomingData$
	            .pipe((0, operators_1$1.filter)(m => m === "h"))
	            .subscribe(_ => this.updateLastHeartbeat()));
	        // handle link status updates
	        this.subscriptions.add(ws.incomingJSONData$
	            .pipe((0, operators_1$1.filter)(m => ["IsLinkedOK", "Linked"].includes(m.type)))
	            .subscribe(m => {
	            var _a;
	            const msg = m;
	            (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1$1.EVENTS.LINKED, {
	                sessionIdHash: Session_1$1.Session.hash(sessionId),
	                linked: msg.linked,
	                type: m.type,
	                onlineGuests: msg.onlineGuests,
	            });
	            this.linkedSubject.next(msg.linked || msg.onlineGuests > 0);
	        }));
	        // handle session config updates
	        this.subscriptions.add(ws.incomingJSONData$
	            .pipe((0, operators_1$1.filter)(m => ["GetSessionConfigOK", "SessionConfigUpdated"].includes(m.type)))
	            .subscribe(m => {
	            var _a;
	            const msg = m;
	            (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1$1.EVENTS.SESSION_CONFIG_RECEIVED, {
	                sessionIdHash: Session_1$1.Session.hash(sessionId),
	                metadata_keys: msg && msg.metadata ? Object.keys(msg.metadata) : undefined,
	            });
	            this.sessionConfigSubject.next({
	                webhookId: msg.webhookId,
	                webhookUrl: msg.webhookUrl,
	                metadata: msg.metadata,
	            });
	        }));
	    }
	    /**
	     * Make a connection to the server
	     */
	    connect() {
	        var _a;
	        if (this.destroyed) {
	            throw new Error("instance is destroyed");
	        }
	        (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1$1.EVENTS.STARTED_CONNECTING, {
	            sessionIdHash: Session_1$1.Session.hash(this.sessionId),
	        });
	        this.ws.connect().subscribe();
	    }
	    /**
	     * Terminate connection, and mark as destroyed. To reconnect, create a new
	     * instance of WalletSDKConnection
	     */
	    destroy() {
	        var _a;
	        this.subscriptions.unsubscribe();
	        this.ws.disconnect();
	        (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1$1.EVENTS.DISCONNECTED, {
	            sessionIdHash: Session_1$1.Session.hash(this.sessionId),
	        });
	        this.destroyed = true;
	    }
	    get isDestroyed() {
	        return this.destroyed;
	    }
	    /**
	     * Emit true if connected and authenticated, else false
	     * @returns an Observable
	     */
	    get connected$() {
	        return this.connectedSubject.asObservable();
	    }
	    /**
	     * Emit once connected
	     * @returns an Observable
	     */
	    get onceConnected$() {
	        return this.connected$.pipe((0, operators_1$1.filter)(v => v), (0, operators_1$1.take)(1), (0, operators_1$1.map)(() => void 0));
	    }
	    /**
	     * Emit true if linked (a guest has joined before)
	     * @returns an Observable
	     */
	    get linked$() {
	        return this.linkedSubject.asObservable();
	    }
	    /**
	     * Emit once when linked
	     * @returns an Observable
	     */
	    get onceLinked$() {
	        return this.linked$.pipe((0, operators_1$1.filter)(v => v), (0, operators_1$1.take)(1), (0, operators_1$1.map)(() => void 0));
	    }
	    /**
	     * Emit current session config if available, and subsequent updates
	     * @returns an Observable for the session config
	     */
	    get sessionConfig$() {
	        return this.sessionConfigSubject.asObservable();
	    }
	    /**
	     * Emit incoming Event messages
	     * @returns an Observable for the messages
	     */
	    get incomingEvent$() {
	        return this.ws.incomingJSONData$.pipe((0, operators_1$1.filter)(m => {
	            if (m.type !== "Event") {
	                return false;
	            }
	            const sme = m;
	            return (typeof sme.sessionId === "string" &&
	                typeof sme.eventId === "string" &&
	                typeof sme.event === "string" &&
	                typeof sme.data === "string");
	        }), (0, operators_1$1.map)(m => m));
	    }
	    /**
	     * Set session metadata in SessionConfig object
	     * @param key
	     * @param value
	     * @returns an Observable that completes when successful
	     */
	    setSessionMetadata(key, value) {
	        const message = (0, ClientMessage_1.ClientMessageSetSessionConfig)({
	            id: (0, types_1$1.IntNumber)(this.nextReqId++),
	            sessionId: this.sessionId,
	            metadata: { [key]: value },
	        });
	        return this.onceConnected$.pipe((0, operators_1$1.flatMap)(_ => this.makeRequest(message)), (0, operators_1$1.map)(res => {
	            if ((0, ServerMessage_1.isServerMessageFail)(res)) {
	                throw new Error(res.error || "failed to set session metadata");
	            }
	        }));
	    }
	    /**
	     * Publish an event and emit event ID when successful
	     * @param event event name
	     * @param data event data
	     * @param callWebhook whether the webhook should be invoked
	     * @returns an Observable that emits event ID when successful
	     */
	    publishEvent(event, data, callWebhook = false) {
	        const message = (0, ClientMessage_1.ClientMessagePublishEvent)({
	            id: (0, types_1$1.IntNumber)(this.nextReqId++),
	            sessionId: this.sessionId,
	            event,
	            data,
	            callWebhook,
	        });
	        return this.onceLinked$.pipe((0, operators_1$1.flatMap)(_ => this.makeRequest(message)), (0, operators_1$1.map)(res => {
	            if ((0, ServerMessage_1.isServerMessageFail)(res)) {
	                throw new Error(res.error || "failed to publish event");
	            }
	            return res.eventId;
	        }));
	    }
	    sendData(message) {
	        this.ws.sendData(JSON.stringify(message));
	    }
	    updateLastHeartbeat() {
	        this.lastHeartbeatResponse = Date.now();
	    }
	    heartbeat() {
	        if (Date.now() - this.lastHeartbeatResponse > HEARTBEAT_INTERVAL * 2) {
	            this.ws.disconnect();
	            return;
	        }
	        try {
	            this.ws.sendData("h");
	        }
	        catch (_a) { }
	    }
	    makeRequest(message, timeout = REQUEST_TIMEOUT) {
	        const reqId = message.id;
	        try {
	            this.sendData(message);
	        }
	        catch (err) {
	            return (0, rxjs_1$1.throwError)(err);
	        }
	        // await server message with corresponding id
	        return this.ws.incomingJSONData$.pipe((0, operators_1$1.timeoutWith)(timeout, (0, rxjs_1$1.throwError)(new Error(`request ${reqId} timed out`))), (0, operators_1$1.filter)(m => m.id === reqId), (0, operators_1$1.take)(1));
	    }
	    authenticate() {
	        const msg = (0, ClientMessage_1.ClientMessageHostSession)({
	            id: (0, types_1$1.IntNumber)(this.nextReqId++),
	            sessionId: this.sessionId,
	            sessionKey: this.sessionKey,
	        });
	        return this.makeRequest(msg).pipe((0, operators_1$1.map)(res => {
	            if ((0, ServerMessage_1.isServerMessageFail)(res)) {
	                throw new Error(res.error || "failed to authentcate");
	            }
	        }));
	    }
	    sendIsLinked() {
	        const msg = (0, ClientMessage_1.ClientMessageIsLinked)({
	            id: (0, types_1$1.IntNumber)(this.nextReqId++),
	            sessionId: this.sessionId,
	        });
	        this.sendData(msg);
	    }
	    sendGetSessionConfig() {
	        const msg = (0, ClientMessage_1.ClientMessageGetSessionConfig)({
	            id: (0, types_1$1.IntNumber)(this.nextReqId++),
	            sessionId: this.sessionId,
	        });
	        this.sendData(msg);
	    }
	}
	WalletSDKConnection$1.WalletSDKConnection = WalletSDKConnection;

	var aes256gcm$1 = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(aes256gcm$1, "__esModule", { value: true });
	aes256gcm$1.decrypt = aes256gcm$1.encrypt = void 0;
	const util_1$3 = util$3;
	/**
	 *
	 * @param plainText string to be encrypted
	 * @param secret hex representation of 32-byte secret
	 * returns hex string representation of bytes in the order: initialization vector (iv),
	 * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes. Remaining bytes are the
	 * encrypted plainText.
	 */
	async function encrypt(plainText, secret) {
	    if (secret.length !== 64)
	        throw Error(`secret must be 256 bits`);
	    const ivBytes = crypto.getRandomValues(new Uint8Array(12));
	    const secretKey = await crypto.subtle.importKey("raw", (0, util_1$3.hexStringToUint8Array)(secret), { name: "aes-gcm" }, false, ["encrypt", "decrypt"]);
	    const enc = new TextEncoder();
	    // Will return encrypted plainText with auth tag (ie MAC or checksum) appended at the end
	    const encryptedResult = await window.crypto.subtle.encrypt({
	        name: "AES-GCM",
	        iv: ivBytes,
	    }, secretKey, enc.encode(plainText));
	    const tagLength = 16;
	    const authTag = encryptedResult.slice(encryptedResult.byteLength - tagLength);
	    const encryptedPlaintext = encryptedResult.slice(0, encryptedResult.byteLength - tagLength);
	    const authTagBytes = new Uint8Array(authTag);
	    const encryptedPlaintextBytes = new Uint8Array(encryptedPlaintext);
	    const concatted = new Uint8Array([
	        ...ivBytes,
	        ...authTagBytes,
	        ...encryptedPlaintextBytes,
	    ]);
	    return (0, util_1$3.uint8ArrayToHex)(concatted);
	}
	aes256gcm$1.encrypt = encrypt;
	/**
	 *
	 * @param cipherText hex string representation of bytes in the order: initialization vector (iv),
	 * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes.
	 * @param secret hex string representation of 32-byte secret
	 */
	function decrypt(cipherText, secret) {
	    if (secret.length !== 64)
	        throw Error(`secret must be 256 bits`);
	    return new Promise((resolve, reject) => {
	        void (async function () {
	            const secretKey = await crypto.subtle.importKey("raw", (0, util_1$3.hexStringToUint8Array)(secret), { name: "aes-gcm" }, false, ["encrypt", "decrypt"]);
	            const encrypted = (0, util_1$3.hexStringToUint8Array)(cipherText);
	            const ivBytes = encrypted.slice(0, 12);
	            const authTagBytes = encrypted.slice(12, 28);
	            const encryptedPlaintextBytes = encrypted.slice(28);
	            const concattedBytes = new Uint8Array([
	                ...encryptedPlaintextBytes,
	                ...authTagBytes,
	            ]);
	            const algo = {
	                name: "AES-GCM",
	                iv: new Uint8Array(ivBytes),
	            };
	            try {
	                const decrypted = await window.crypto.subtle.decrypt(algo, secretKey, concattedBytes);
	                const decoder = new TextDecoder();
	                resolve(decoder.decode(decrypted));
	            }
	            catch (err) {
	                reject(err);
	            }
	        })();
	    });
	}
	aes256gcm$1.decrypt = decrypt;

	var Web3RequestCanceledMessage$1 = {};

	var RelayMessage = {};

	(function (exports) {
		// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
		// Licensed under the Apache License, version 2.0
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.RelayMessageType = void 0;
		(function (RelayMessageType) {
		    RelayMessageType["SESSION_ID_REQUEST"] = "SESSION_ID_REQUEST";
		    RelayMessageType["SESSION_ID_RESPONSE"] = "SESSION_ID_RESPONSE";
		    RelayMessageType["LINKED"] = "LINKED";
		    RelayMessageType["UNLINKED"] = "UNLINKED";
		    RelayMessageType["WEB3_REQUEST"] = "WEB3_REQUEST";
		    RelayMessageType["WEB3_REQUEST_CANCELED"] = "WEB3_REQUEST_CANCELED";
		    RelayMessageType["WEB3_RESPONSE"] = "WEB3_RESPONSE";
		})(exports.RelayMessageType || (exports.RelayMessageType = {})); 
	} (RelayMessage));

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(Web3RequestCanceledMessage$1, "__esModule", { value: true });
	Web3RequestCanceledMessage$1.Web3RequestCanceledMessage = void 0;
	const RelayMessage_1$2 = RelayMessage;
	function Web3RequestCanceledMessage(id) {
	    return { type: RelayMessage_1$2.RelayMessageType.WEB3_REQUEST_CANCELED, id };
	}
	Web3RequestCanceledMessage$1.Web3RequestCanceledMessage = Web3RequestCanceledMessage;

	var Web3RequestMessage$1 = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(Web3RequestMessage$1, "__esModule", { value: true });
	Web3RequestMessage$1.Web3RequestMessage = void 0;
	const RelayMessage_1$1 = RelayMessage;
	function Web3RequestMessage(params) {
	    return Object.assign({ type: RelayMessage_1$1.RelayMessageType.WEB3_REQUEST }, params);
	}
	Web3RequestMessage$1.Web3RequestMessage = Web3RequestMessage;

	var Web3ResponseMessage$1 = {};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(Web3ResponseMessage$1, "__esModule", { value: true });
	Web3ResponseMessage$1.isWeb3ResponseMessage = Web3ResponseMessage$1.Web3ResponseMessage = void 0;
	const RelayMessage_1 = RelayMessage;
	function Web3ResponseMessage(params) {
	    return Object.assign({ type: RelayMessage_1.RelayMessageType.WEB3_RESPONSE }, params);
	}
	Web3ResponseMessage$1.Web3ResponseMessage = Web3ResponseMessage;
	function isWeb3ResponseMessage(msg) {
	    return msg && msg.type === RelayMessage_1.RelayMessageType.WEB3_RESPONSE;
	}
	Web3ResponseMessage$1.isWeb3ResponseMessage = isWeb3ResponseMessage;

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __decorate = (commonjsGlobal && commonjsGlobal.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(WalletSDKRelay$1, "__esModule", { value: true });
	WalletSDKRelay$1.WalletSDKRelay = void 0;
	const bind_decorator_1 = __importDefault(bindDecorator);
	const rxjs_1 = require$$1;
	const operators_1 = require$$2;
	const DiagnosticLogger_1 = DiagnosticLogger;
	const WalletSDKConnection_1 = WalletSDKConnection$1;
	const errors_1 = errors$2;
	const types_1 = types$4;
	const util_1$2 = util$3;
	const aes256gcm = __importStar(aes256gcm$1);
	const Session_1 = Session$1;
	const WalletSDKRelayAbstract_1 = WalletSDKRelayAbstract$1;
	const Web3Method_1 = Web3Method;
	const Web3RequestCanceledMessage_1 = Web3RequestCanceledMessage$1;
	const Web3RequestMessage_1 = Web3RequestMessage$1;
	const Web3Response_1 = Web3Response;
	const Web3ResponseMessage_1 = Web3ResponseMessage$1;
	class WalletSDKRelay extends WalletSDKRelayAbstract_1.WalletSDKRelayAbstract {
	    constructor(options) {
	        var _a;
	        super();
	        this.accountsCallback = null;
	        this.chainCallback = null;
	        this.dappDefaultChainSubject = new rxjs_1.BehaviorSubject(1);
	        this.dappDefaultChain = 1;
	        this.appName = "";
	        this.appLogoUrl = null;
	        this.subscriptions = new rxjs_1.Subscription();
	        this.linkAPIUrl = options.linkAPIUrl;
	        this.storage = options.storage;
	        this.options = options;
	        const { session, ui, connection } = this.subscribe();
	        this._session = session;
	        this.connection = connection;
	        this.relayEventManager = options.relayEventManager;
	        if (options.diagnosticLogger && options.eventListener) {
	            throw new Error("Can't have both eventListener and diagnosticLogger options, use only diagnosticLogger");
	        }
	        if (options.eventListener) {
	            this.diagnostic = {
	                // eslint-disable-next-line @typescript-eslint/unbound-method
	                log: options.eventListener.onEvent,
	            };
	        }
	        else {
	            this.diagnostic = options.diagnosticLogger;
	        }
	        this._reloadOnDisconnect = (_a = options.reloadOnDisconnect) !== null && _a !== void 0 ? _a : true;
	        this.ui = ui;
	    }
	    subscribe() {
	        this.subscriptions.add(this.dappDefaultChainSubject.subscribe(chainId => {
	            if (this.dappDefaultChain !== chainId) {
	                this.dappDefaultChain = chainId;
	            }
	        }));
	        const session = Session_1.Session.load(this.storage) || new Session_1.Session(this.storage).save();
	        const connection = new WalletSDKConnection_1.WalletSDKConnection(session.id, session.key, this.linkAPIUrl, this.diagnostic);
	        this.subscriptions.add(connection.sessionConfig$.subscribe({
	            next: sessionConfig => {
	                this.onSessionConfigChanged(sessionConfig);
	            },
	            error: () => {
	                var _a;
	                (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.GENERAL_ERROR, {
	                    message: "error while invoking session config callback",
	                });
	            },
	        }));
	        this.subscriptions.add(connection.incomingEvent$
	            .pipe((0, operators_1.filter)(m => m.event === "Web3Response"))
	            .subscribe({ next: this.handleIncomingEvent }));
	        this.subscriptions.add(connection.linked$
	            .pipe((0, operators_1.skip)(1), (0, operators_1.tap)((linked) => {
	            var _a;
	            this.isLinked = linked;
	            const cachedAddresses = this.storage.getItem(WalletSDKRelayAbstract_1.LOCAL_STORAGE_ADDRESSES_KEY);
	            if (linked) {
	                // Only set linked session variable one way
	                this.session.linked = linked;
	            }
	            this.isUnlinkedErrorState = false;
	            if (cachedAddresses) {
	                const addresses = cachedAddresses.split(" ");
	                const wasConnectedViaStandalone = this.storage.getItem("IsStandaloneSigning") === "true";
	                if (addresses[0] !== "" &&
	                    !linked &&
	                    this.session.linked &&
	                    !wasConnectedViaStandalone) {
	                    this.isUnlinkedErrorState = true;
	                    const sessionIdHash = this.getSessionIdHash();
	                    (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.UNLINKED_ERROR_STATE, {
	                        sessionIdHash,
	                    });
	                }
	            }
	        }))
	            .subscribe());
	        // if session is marked destroyed, reset and reload
	        this.subscriptions.add(connection.sessionConfig$
	            .pipe((0, operators_1.filter)(c => !!c.metadata && c.metadata.__destroyed === "1"))
	            .subscribe(() => {
	            var _a;
	            const alreadyDestroyed = connection.isDestroyed;
	            (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.METADATA_DESTROYED, {
	                alreadyDestroyed,
	                sessionIdHash: this.getSessionIdHash(),
	            });
	            return this.resetAndReload();
	        }));
	        this.subscriptions.add(connection.sessionConfig$
	            .pipe((0, operators_1.filter)(c => c.metadata && c.metadata.WalletUsername !== undefined))
	            .pipe((0, operators_1.mergeMap)(c => aes256gcm.decrypt(c.metadata.WalletUsername, session.secret)))
	            .subscribe({
	            next: walletUsername => {
	                this.storage.setItem(WalletSDKRelayAbstract_1.WALLET_USER_NAME_KEY, walletUsername);
	            },
	            error: () => {
	                var _a;
	                (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.GENERAL_ERROR, {
	                    message: "Had error decrypting",
	                    value: "username",
	                });
	            },
	        }));
	        this.subscriptions.add(connection.sessionConfig$
	            .pipe((0, operators_1.filter)(c => c.metadata && c.metadata.AppVersion !== undefined))
	            .pipe((0, operators_1.mergeMap)(c => aes256gcm.decrypt(c.metadata.AppVersion, session.secret)))
	            .subscribe({
	            next: appVersion => {
	                this.storage.setItem(WalletSDKRelayAbstract_1.APP_VERSION_KEY, appVersion);
	            },
	            error: () => {
	                var _a;
	                (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.GENERAL_ERROR, {
	                    message: "Had error decrypting",
	                    value: "appversion",
	                });
	            },
	        }));
	        this.subscriptions.add(connection.sessionConfig$
	            .pipe((0, operators_1.filter)(c => c.metadata &&
	            c.metadata.ChainId !== undefined &&
	            c.metadata.JsonRpcUrl !== undefined))
	            .pipe((0, operators_1.mergeMap)(c => (0, rxjs_1.zip)(aes256gcm.decrypt(c.metadata.ChainId, session.secret), aes256gcm.decrypt(c.metadata.JsonRpcUrl, session.secret))))
	            .pipe((0, operators_1.distinctUntilChanged)())
	            .subscribe({
	            next: ([chainId, jsonRpcUrl]) => {
	                if (this.chainCallback) {
	                    this.chainCallback(chainId, jsonRpcUrl);
	                }
	            },
	            error: () => {
	                var _a;
	                (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.GENERAL_ERROR, {
	                    message: "Had error decrypting",
	                    value: "chainId|jsonRpcUrl",
	                });
	            },
	        }));
	        this.subscriptions.add(connection.sessionConfig$
	            .pipe((0, operators_1.filter)(c => c.metadata && c.metadata.EthereumAddress !== undefined))
	            .pipe((0, operators_1.mergeMap)(c => aes256gcm.decrypt(c.metadata.EthereumAddress, session.secret)))
	            .subscribe({
	            next: selectedAddress => {
	                if (this.accountsCallback) {
	                    this.accountsCallback([selectedAddress]);
	                }
	                if (WalletSDKRelay.accountRequestCallbackIds.size > 0) {
	                    // We get the ethereum address from the metadata.  If for whatever
	                    // reason we don't get a response via an explicit web3 message
	                    // we can still fulfill the eip1102 request.
	                    Array.from(WalletSDKRelay.accountRequestCallbackIds.values()).forEach(id => {
	                        const message = (0, Web3ResponseMessage_1.Web3ResponseMessage)({
	                            id,
	                            response: (0, Web3Response_1.RequestEthereumAccountsResponse)([
	                                selectedAddress,
	                            ]),
	                        });
	                        this.invokeCallback(Object.assign(Object.assign({}, message), { id }));
	                    });
	                    WalletSDKRelay.accountRequestCallbackIds.clear();
	                }
	            },
	            error: () => {
	                var _a;
	                (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.GENERAL_ERROR, {
	                    message: "Had error decrypting",
	                    value: "selectedAddress",
	                });
	            },
	        }));
	        this.subscriptions.add(connection.sessionConfig$
	            .pipe((0, operators_1.filter)(c => c.metadata && c.metadata.AppSrc !== undefined))
	            .pipe((0, operators_1.mergeMap)(c => aes256gcm.decrypt(c.metadata.AppSrc, session.secret)))
	            .subscribe({
	            next: appSrc => {
	                this.ui.setAppSrc(appSrc);
	            },
	            error: () => {
	                var _a;
	                (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.GENERAL_ERROR, {
	                    message: "Had error decrypting",
	                    value: "appSrc",
	                });
	            },
	        }));
	        const ui = this.options.uiConstructor({
	            linkAPIUrl: this.options.linkAPIUrl,
	            version: this.options.version,
	            darkMode: this.options.darkMode,
	            session,
	            connected$: connection.connected$,
	            chainId$: this.dappDefaultChainSubject,
	        });
	        connection.connect();
	        return { session, ui, connection };
	    }
	    attachUI() {
	        this.ui.attach();
	    }
	    resetAndReload() {
	        this.connection
	            .setSessionMetadata("__destroyed", "1")
	            .pipe((0, operators_1.timeout)(1000), (0, operators_1.catchError)(_ => (0, rxjs_1.of)(null)))
	            .subscribe(_ => {
	            var _a, _b, _c;
	            const isStandalone = this.ui.isStandalone();
	            try {
	                this.subscriptions.unsubscribe();
	            }
	            catch (err) {
	                (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.GENERAL_ERROR, {
	                    message: "Had error unsubscribing",
	                });
	            }
	            (_b = this.diagnostic) === null || _b === void 0 ? void 0 : _b.log(DiagnosticLogger_1.EVENTS.SESSION_STATE_CHANGE, {
	                method: "relay::resetAndReload",
	                sessionMetadataChange: "__destroyed, 1",
	                sessionIdHash: this.getSessionIdHash(),
	            });
	            this.connection.destroy();
	            /**
	             * Only clear storage if the session id we have in memory matches the one on disk
	             * Otherwise, in the case where we have 2 tabs, another tab might have cleared
	             * storage already.  In that case if we clear storage again, the user will be in
	             * a state where the first tab allows the user to connect but the session that
	             * was used isn't persisted.  This leaves the user in a state where they aren't
	             * connected to the mobile app.
	             */
	            const storedSession = Session_1.Session.load(this.storage);
	            if ((storedSession === null || storedSession === void 0 ? void 0 : storedSession.id) === this._session.id) {
	                this.storage.clear();
	            }
	            else if (storedSession) {
	                (_c = this.diagnostic) === null || _c === void 0 ? void 0 : _c.log(DiagnosticLogger_1.EVENTS.SKIPPED_CLEARING_SESSION, {
	                    sessionIdHash: this.getSessionIdHash(),
	                    storedSessionIdHash: Session_1.Session.hash(storedSession.id),
	                });
	            }
	            if (this._reloadOnDisconnect) {
	                this.ui.reloadUI();
	                return;
	            }
	            if (this.accountsCallback) {
	                this.accountsCallback([], true);
	            }
	            this.subscriptions = new rxjs_1.Subscription();
	            const { session, ui, connection } = this.subscribe();
	            this._session = session;
	            this.connection = connection;
	            this.ui = ui;
	            if (isStandalone && this.ui.setStandalone)
	                this.ui.setStandalone(true);
	            this.attachUI();
	        }, (err) => {
	            var _a;
	            (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.FAILURE, {
	                method: "relay::resetAndReload",
	                message: `failed to reset and reload with ${err}`,
	                sessionIdHash: this.getSessionIdHash(),
	            });
	        });
	    }
	    setAppInfo(appName, appLogoUrl) {
	        this.appName = appName;
	        this.appLogoUrl = appLogoUrl;
	    }
	    getStorageItem(key) {
	        return this.storage.getItem(key);
	    }
	    get session() {
	        return this._session;
	    }
	    setStorageItem(key, value) {
	        this.storage.setItem(key, value);
	    }
	    signEthereumMessage(message, address, addPrefix, typedDataJson) {
	        return this.sendRequest({
	            method: Web3Method_1.Web3Method.signEthereumMessage,
	            params: {
	                message: (0, util_1$2.hexStringFromBuffer)(message, true),
	                address,
	                addPrefix,
	                typedDataJson: typedDataJson || null,
	            },
	        });
	    }
	    ethereumAddressFromSignedMessage(message, signature, addPrefix) {
	        return this.sendRequest({
	            method: Web3Method_1.Web3Method.ethereumAddressFromSignedMessage,
	            params: {
	                message: (0, util_1$2.hexStringFromBuffer)(message, true),
	                signature: (0, util_1$2.hexStringFromBuffer)(signature, true),
	                addPrefix,
	            },
	        });
	    }
	    signEthereumTransaction(params) {
	        return this.sendRequest({
	            method: Web3Method_1.Web3Method.signEthereumTransaction,
	            params: {
	                fromAddress: params.fromAddress,
	                toAddress: params.toAddress,
	                weiValue: (0, util_1$2.bigIntStringFromBN)(params.weiValue),
	                data: (0, util_1$2.hexStringFromBuffer)(params.data, true),
	                nonce: params.nonce,
	                gasPriceInWei: params.gasPriceInWei
	                    ? (0, util_1$2.bigIntStringFromBN)(params.gasPriceInWei)
	                    : null,
	                maxFeePerGas: params.gasPriceInWei
	                    ? (0, util_1$2.bigIntStringFromBN)(params.gasPriceInWei)
	                    : null,
	                maxPriorityFeePerGas: params.gasPriceInWei
	                    ? (0, util_1$2.bigIntStringFromBN)(params.gasPriceInWei)
	                    : null,
	                gasLimit: params.gasLimit ? (0, util_1$2.bigIntStringFromBN)(params.gasLimit) : null,
	                chainId: params.chainId,
	                shouldSubmit: false,
	            },
	        });
	    }
	    signAndSubmitEthereumTransaction(params) {
	        return this.sendRequest({
	            method: Web3Method_1.Web3Method.signEthereumTransaction,
	            params: {
	                fromAddress: params.fromAddress,
	                toAddress: params.toAddress,
	                weiValue: (0, util_1$2.bigIntStringFromBN)(params.weiValue),
	                data: (0, util_1$2.hexStringFromBuffer)(params.data, true),
	                nonce: params.nonce,
	                gasPriceInWei: params.gasPriceInWei
	                    ? (0, util_1$2.bigIntStringFromBN)(params.gasPriceInWei)
	                    : null,
	                maxFeePerGas: params.maxFeePerGas
	                    ? (0, util_1$2.bigIntStringFromBN)(params.maxFeePerGas)
	                    : null,
	                maxPriorityFeePerGas: params.maxPriorityFeePerGas
	                    ? (0, util_1$2.bigIntStringFromBN)(params.maxPriorityFeePerGas)
	                    : null,
	                gasLimit: params.gasLimit ? (0, util_1$2.bigIntStringFromBN)(params.gasLimit) : null,
	                chainId: params.chainId,
	                shouldSubmit: true,
	            },
	        });
	    }
	    submitEthereumTransaction(signedTransaction, chainId) {
	        return this.sendRequest({
	            method: Web3Method_1.Web3Method.submitEthereumTransaction,
	            params: {
	                signedTransaction: (0, util_1$2.hexStringFromBuffer)(signedTransaction, true),
	                chainId,
	            },
	        });
	    }
	    scanQRCode(regExp) {
	        return this.sendRequest({
	            method: Web3Method_1.Web3Method.scanQRCode,
	            params: { regExp },
	        });
	    }
	    getQRCodeUrl() {
	        return (0, util_1$2.createQrUrl)(this._session.id, this._session.secret, this.linkAPIUrl, false, this.options.version, this.dappDefaultChain);
	    }
	    genericRequest(data, action) {
	        return this.sendRequest({
	            method: Web3Method_1.Web3Method.generic,
	            params: {
	                action,
	                data,
	            },
	        });
	    }
	    sendGenericMessage(request) {
	        return this.sendRequest(request);
	    }
	    sendRequest(request) {
	        let hideSnackbarItem = null;
	        const id = (0, util_1$2.randomBytesHex)(8);
	        const cancel = (error) => {
	            this.publishWeb3RequestCanceledEvent(id);
	            this.handleErrorResponse(id, request.method, error);
	            hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
	        };
	        const promise = new Promise((resolve, reject) => {
	            if (!this.ui.isStandalone()) {
	                hideSnackbarItem = this.ui.showConnecting({
	                    isUnlinkedErrorState: this.isUnlinkedErrorState,
	                    onCancel: cancel,
	                    onResetConnection: this.resetAndReload, // eslint-disable-line @typescript-eslint/unbound-method
	                });
	            }
	            this.relayEventManager.callbacks.set(id, response => {
	                hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
	                if (response.errorMessage) {
	                    return reject(new Error(response.errorMessage));
	                }
	                resolve(response);
	            });
	            if (this.ui.isStandalone()) {
	                this.sendRequestStandalone(id, request);
	            }
	            else {
	                this.publishWeb3RequestEvent(id, request);
	            }
	        });
	        return { promise, cancel };
	    }
	    setConnectDisabled(disabled) {
	        this.ui.setConnectDisabled(disabled);
	    }
	    setAccountsCallback(accountsCallback) {
	        this.accountsCallback = accountsCallback;
	    }
	    setChainCallback(chainCallback) {
	        this.chainCallback = chainCallback;
	    }
	    setDappDefaultChainCallback(chainId) {
	        this.dappDefaultChainSubject.next(chainId);
	    }
	    publishWeb3RequestEvent(id, request) {
	        var _a;
	        const message = (0, Web3RequestMessage_1.Web3RequestMessage)({ id, request });
	        const storedSession = Session_1.Session.load(this.storage);
	        (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.WEB3_REQUEST, {
	            eventId: message.id,
	            method: `relay::${message.request.method}`,
	            sessionIdHash: this.getSessionIdHash(),
	            storedSessionIdHash: storedSession ? Session_1.Session.hash(storedSession.id) : "",
	            isSessionMismatched: ((storedSession === null || storedSession === void 0 ? void 0 : storedSession.id) !== this._session.id).toString(),
	        });
	        this.subscriptions.add(this.publishEvent("Web3Request", message, true).subscribe({
	            next: _ => {
	                var _a;
	                (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.WEB3_REQUEST_PUBLISHED, {
	                    eventId: message.id,
	                    method: `relay::${message.request.method}`,
	                    sessionIdHash: this.getSessionIdHash(),
	                    storedSessionIdHash: storedSession
	                        ? Session_1.Session.hash(storedSession.id)
	                        : "",
	                    isSessionMismatched: ((storedSession === null || storedSession === void 0 ? void 0 : storedSession.id) !== this._session.id).toString(),
	                });
	            },
	            error: err => {
	                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
	                    id: message.id,
	                    response: {
	                        method: message.request.method,
	                        errorMessage: err.message,
	                    },
	                }));
	            },
	        }));
	    }
	    publishWeb3RequestCanceledEvent(id) {
	        const message = (0, Web3RequestCanceledMessage_1.Web3RequestCanceledMessage)(id);
	        this.subscriptions.add(this.publishEvent("Web3RequestCanceled", message, false).subscribe());
	    }
	    publishEvent(event, message, callWebhook) {
	        const secret = this.session.secret;
	        return new rxjs_1.Observable(subscriber => {
	            void aes256gcm
	                .encrypt(JSON.stringify(Object.assign(Object.assign({}, message), { origin: location.origin })), secret)
	                .then((encrypted) => {
	                subscriber.next(encrypted);
	                subscriber.complete();
	            });
	        }).pipe((0, operators_1.mergeMap)((encrypted) => {
	            return this.connection.publishEvent(event, encrypted, callWebhook);
	        }));
	    }
	    handleIncomingEvent(event) {
	        try {
	            this.subscriptions.add((0, rxjs_1.from)(aes256gcm.decrypt(event.data, this.session.secret))
	                .pipe((0, operators_1.map)(c => JSON.parse(c)))
	                .subscribe({
	                next: json => {
	                    const message = (0, Web3ResponseMessage_1.isWeb3ResponseMessage)(json) ? json : null;
	                    if (!message) {
	                        return;
	                    }
	                    this.handleWeb3ResponseMessage(message);
	                },
	                error: () => {
	                    var _a;
	                    (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.GENERAL_ERROR, {
	                        message: "Had error decrypting",
	                        value: "incomingEvent",
	                    });
	                },
	            }));
	        }
	        catch (_a) {
	            return;
	        }
	    }
	    handleWeb3ResponseMessage(message) {
	        var _a;
	        const { response } = message;
	        (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log(DiagnosticLogger_1.EVENTS.WEB3_RESPONSE, {
	            eventId: message.id,
	            method: `relay::${response.method}`,
	            sessionIdHash: this.getSessionIdHash(),
	        });
	        if ((0, Web3Response_1.isRequestEthereumAccountsResponse)(response)) {
	            WalletSDKRelay.accountRequestCallbackIds.forEach(id => this.invokeCallback(Object.assign(Object.assign({}, message), { id })));
	            WalletSDKRelay.accountRequestCallbackIds.clear();
	            return;
	        }
	        this.invokeCallback(message);
	    }
	    handleErrorResponse(id, method, error, errorCode) {
	        var _a;
	        const errorMessage = (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : (0, errors_1.standardErrorMessage)(errorCode);
	        this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
	            id,
	            response: {
	                method,
	                errorMessage,
	                errorCode,
	            },
	        }));
	    }
	    invokeCallback(message) {
	        const callback = this.relayEventManager.callbacks.get(message.id);
	        if (callback) {
	            callback(message.response);
	            this.relayEventManager.callbacks.delete(message.id);
	        }
	    }
	    requestEthereumAccounts() {
	        const request = {
	            method: Web3Method_1.Web3Method.requestEthereumAccounts,
	            params: {
	                appName: this.appName,
	                appLogoUrl: this.appLogoUrl || null,
	            },
	        };
	        const id = (0, util_1$2.randomBytesHex)(8);
	        const cancel = (error) => {
	            this.publishWeb3RequestCanceledEvent(id);
	            this.handleErrorResponse(id, request.method, error);
	        };
	        const promise = new Promise((resolve, reject) => {
	            var _a;
	            this.relayEventManager.callbacks.set(id, response => {
	                this.ui.hideRequestEthereumAccounts();
	                if (response.errorMessage) {
	                    return reject(new Error(response.errorMessage));
	                }
	                resolve(response);
	            });
	            const userAgent = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || null;
	            if (userAgent &&
	                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
	                let location;
	                try {
	                    if ((0, util_1$2.isInIFrame)() && window.top) {
	                        location = window.top.location;
	                    }
	                    else {
	                        location = window.location;
	                    }
	                }
	                catch (e) {
	                    location = window.location;
	                }
	                location.href = `https://www.coinbase.com/connect-dapp?uri=${encodeURIComponent(location.href)}`;
	                return;
	            }
	            if (this.ui.inlineAccountsResponse()) {
	                const onAccounts = (accounts) => {
	                    this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
	                        id,
	                        response: (0, Web3Response_1.RequestEthereumAccountsResponse)(accounts),
	                    }));
	                };
	                this.ui.requestEthereumAccounts({
	                    onCancel: cancel,
	                    onAccounts,
	                });
	            }
	            else {
	                // Error if user closes TryExtensionLinkDialog without connecting
	                const err = errors_1.standardErrors.provider.userRejectedRequest("User denied account authorization");
	                this.ui.requestEthereumAccounts({
	                    onCancel: () => cancel(err),
	                });
	            }
	            WalletSDKRelay.accountRequestCallbackIds.add(id);
	            if (!this.ui.inlineAccountsResponse() && !this.ui.isStandalone()) {
	                this.publishWeb3RequestEvent(id, request);
	            }
	        });
	        return { promise, cancel };
	    }
	    selectProvider(providerOptions) {
	        const request = {
	            method: Web3Method_1.Web3Method.selectProvider,
	            params: {
	                providerOptions,
	            },
	        };
	        const id = (0, util_1$2.randomBytesHex)(8);
	        const cancel = (error) => {
	            this.publishWeb3RequestCanceledEvent(id);
	            this.handleErrorResponse(id, request.method, error);
	        };
	        const promise = new Promise((resolve, reject) => {
	            this.relayEventManager.callbacks.set(id, response => {
	                if (response.errorMessage) {
	                    return reject(new Error(response.errorMessage));
	                }
	                resolve(response);
	            });
	            const _cancel = (_error) => {
	                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
	                    id,
	                    response: (0, Web3Response_1.SelectProviderResponse)(types_1.ProviderType.Unselected),
	                }));
	            };
	            const approve = (selectedProviderKey) => {
	                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
	                    id,
	                    response: (0, Web3Response_1.SelectProviderResponse)(selectedProviderKey),
	                }));
	            };
	            if (this.ui.selectProvider)
	                this.ui.selectProvider({
	                    onApprove: approve,
	                    onCancel: _cancel,
	                    providerOptions,
	                });
	        });
	        return { cancel, promise };
	    }
	    watchAsset(type, address, symbol, decimals, image, chainId) {
	        const request = {
	            method: Web3Method_1.Web3Method.watchAsset,
	            params: {
	                type,
	                options: {
	                    address,
	                    symbol,
	                    decimals,
	                    image,
	                },
	                chainId,
	            },
	        };
	        let hideSnackbarItem = null;
	        const id = (0, util_1$2.randomBytesHex)(8);
	        const cancel = (error) => {
	            this.publishWeb3RequestCanceledEvent(id);
	            this.handleErrorResponse(id, request.method, error);
	            hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
	        };
	        if (!this.ui.inlineWatchAsset()) {
	            hideSnackbarItem = this.ui.showConnecting({
	                isUnlinkedErrorState: this.isUnlinkedErrorState,
	                onCancel: cancel,
	                onResetConnection: this.resetAndReload, // eslint-disable-line @typescript-eslint/unbound-method
	            });
	        }
	        const promise = new Promise((resolve, reject) => {
	            this.relayEventManager.callbacks.set(id, response => {
	                hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
	                if (response.errorMessage) {
	                    return reject(new Error(response.errorMessage));
	                }
	                resolve(response);
	            });
	            const _cancel = (_error) => {
	                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
	                    id,
	                    response: (0, Web3Response_1.WatchAssetReponse)(false),
	                }));
	            };
	            const approve = () => {
	                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
	                    id,
	                    response: (0, Web3Response_1.WatchAssetReponse)(true),
	                }));
	            };
	            if (this.ui.inlineWatchAsset()) {
	                this.ui.watchAsset({
	                    onApprove: approve,
	                    onCancel: _cancel,
	                    type,
	                    address,
	                    symbol,
	                    decimals,
	                    image,
	                    chainId,
	                });
	            }
	            if (!this.ui.inlineWatchAsset() && !this.ui.isStandalone()) {
	                this.publishWeb3RequestEvent(id, request);
	            }
	        });
	        return { cancel, promise };
	    }
	    addEthereumChain(chainId, rpcUrls, iconUrls, blockExplorerUrls, chainName, nativeCurrency) {
	        const request = {
	            method: Web3Method_1.Web3Method.addEthereumChain,
	            params: {
	                chainId,
	                rpcUrls,
	                blockExplorerUrls,
	                chainName,
	                iconUrls,
	                nativeCurrency,
	            },
	        };
	        let hideSnackbarItem = null;
	        const id = (0, util_1$2.randomBytesHex)(8);
	        const cancel = (error) => {
	            this.publishWeb3RequestCanceledEvent(id);
	            this.handleErrorResponse(id, request.method, error);
	            hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
	        };
	        if (!this.ui.inlineAddEthereumChain(chainId)) {
	            hideSnackbarItem = this.ui.showConnecting({
	                isUnlinkedErrorState: this.isUnlinkedErrorState,
	                onCancel: cancel,
	                onResetConnection: this.resetAndReload, // eslint-disable-line @typescript-eslint/unbound-method
	            });
	        }
	        const promise = new Promise((resolve, reject) => {
	            this.relayEventManager.callbacks.set(id, response => {
	                hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
	                if (response.errorMessage) {
	                    return reject(new Error(response.errorMessage));
	                }
	                resolve(response);
	            });
	            const _cancel = (_error) => {
	                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
	                    id,
	                    response: (0, Web3Response_1.AddEthereumChainResponse)({
	                        isApproved: false,
	                        rpcUrl: "",
	                    }),
	                }));
	            };
	            const approve = (rpcUrl) => {
	                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
	                    id,
	                    response: (0, Web3Response_1.AddEthereumChainResponse)({ isApproved: true, rpcUrl }),
	                }));
	            };
	            if (this.ui.inlineAddEthereumChain(chainId)) {
	                this.ui.addEthereumChain({
	                    onCancel: _cancel,
	                    onApprove: approve,
	                    chainId: request.params.chainId,
	                    rpcUrls: request.params.rpcUrls,
	                    blockExplorerUrls: request.params.blockExplorerUrls,
	                    chainName: request.params.chainName,
	                    iconUrls: request.params.iconUrls,
	                    nativeCurrency: request.params.nativeCurrency,
	                });
	            }
	            if (!this.ui.inlineAddEthereumChain(chainId) && !this.ui.isStandalone()) {
	                this.publishWeb3RequestEvent(id, request);
	            }
	        });
	        return { promise, cancel };
	    }
	    switchEthereumChain(chainId, address) {
	        const request = {
	            method: Web3Method_1.Web3Method.switchEthereumChain,
	            params: Object.assign({ chainId }, { address }),
	        };
	        const id = (0, util_1$2.randomBytesHex)(8);
	        const cancel = (error) => {
	            this.publishWeb3RequestCanceledEvent(id);
	            this.handleErrorResponse(id, request.method, error);
	        };
	        const promise = new Promise((resolve, reject) => {
	            this.relayEventManager.callbacks.set(id, response => {
	                if ((0, Web3Response_1.isErrorResponse)(response) && response.errorCode) {
	                    return reject(errors_1.standardErrors.provider.custom({
	                        code: response.errorCode,
	                        message: `Unrecognized chain ID. Try adding the chain using addEthereumChain first.`,
	                    }));
	                }
	                else if (response.errorMessage) {
	                    return reject(new Error(response.errorMessage));
	                }
	                resolve(response);
	            });
	            const _cancel = (error) => {
	                var _a;
	                if (error) {
	                    // backward compatibility
	                    const errorCode = (_a = (0, errors_1.getErrorCode)(error)) !== null && _a !== void 0 ? _a : errors_1.standardErrorCodes.provider.unsupportedChain;
	                    this.handleErrorResponse(id, Web3Method_1.Web3Method.switchEthereumChain, error instanceof Error
	                        ? error
	                        : errors_1.standardErrors.provider.unsupportedChain(chainId), errorCode);
	                }
	                else {
	                    this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
	                        id,
	                        response: (0, Web3Response_1.SwitchEthereumChainResponse)({
	                            isApproved: false,
	                            rpcUrl: "",
	                        }),
	                    }));
	                }
	            };
	            const approve = (rpcUrl) => {
	                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
	                    id,
	                    response: (0, Web3Response_1.SwitchEthereumChainResponse)({
	                        isApproved: true,
	                        rpcUrl,
	                    }),
	                }));
	            };
	            this.ui.switchEthereumChain({
	                onCancel: _cancel,
	                onApprove: approve,
	                chainId: request.params.chainId,
	                address: request.params.address,
	            });
	            if (!this.ui.inlineSwitchEthereumChain() && !this.ui.isStandalone()) {
	                this.publishWeb3RequestEvent(id, request);
	            }
	        });
	        return { promise, cancel };
	    }
	    inlineAddEthereumChain(chainId) {
	        return this.ui.inlineAddEthereumChain(chainId);
	    }
	    getSessionIdHash() {
	        return Session_1.Session.hash(this._session.id);
	    }
	    sendRequestStandalone(id, request) {
	        const _cancel = (error) => {
	            this.handleErrorResponse(id, request.method, error);
	        };
	        const onSuccess = (response) => {
	            this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
	                id,
	                response,
	            }));
	        };
	        switch (request.method) {
	            case Web3Method_1.Web3Method.signEthereumMessage:
	                this.ui.signEthereumMessage({
	                    request,
	                    onSuccess,
	                    onCancel: _cancel,
	                });
	                break;
	            case Web3Method_1.Web3Method.signEthereumTransaction:
	                this.ui.signEthereumTransaction({
	                    request,
	                    onSuccess,
	                    onCancel: _cancel,
	                });
	                break;
	            case Web3Method_1.Web3Method.submitEthereumTransaction:
	                this.ui.submitEthereumTransaction({
	                    request,
	                    onSuccess,
	                    onCancel: _cancel,
	                });
	                break;
	            case Web3Method_1.Web3Method.ethereumAddressFromSignedMessage:
	                this.ui.ethereumAddressFromSignedMessage({
	                    request,
	                    onSuccess,
	                });
	                break;
	            default:
	                _cancel();
	                break;
	        }
	    }
	    onSessionConfigChanged(_nextSessionConfig) { }
	}
	WalletSDKRelay.accountRequestCallbackIds = new Set();
	__decorate([
	    bind_decorator_1.default
	], WalletSDKRelay.prototype, "resetAndReload", null);
	__decorate([
	    bind_decorator_1.default
	], WalletSDKRelay.prototype, "handleIncomingEvent", null);
	WalletSDKRelay$1.WalletSDKRelay = WalletSDKRelay;

	var WalletSDKRelayEventManager$1 = {};

	Object.defineProperty(WalletSDKRelayEventManager$1, "__esModule", { value: true });
	WalletSDKRelayEventManager$1.WalletSDKRelayEventManager = void 0;
	const util_1$1 = util$3;
	class WalletSDKRelayEventManager {
	    constructor() {
	        this._nextRequestId = 0;
	        this.callbacks = new Map();
	    }
	    makeRequestId() {
	        // max nextId == max int32 for compatibility with mobile
	        this._nextRequestId = (this._nextRequestId + 1) % 0x7fffffff;
	        const id = this._nextRequestId;
	        const idStr = (0, util_1$1.prepend0x)(id.toString(16));
	        // unlikely that this will ever be an issue, but just to be safe
	        const callback = this.callbacks.get(idStr);
	        if (callback) {
	            this.callbacks.delete(idStr);
	        }
	        return id;
	    }
	}
	WalletSDKRelayEventManager$1.WalletSDKRelayEventManager = WalletSDKRelayEventManager;

	var name = "@coinbase/wallet-sdk";
	var version$1 = "3.7.1";
	var description = "Coinbase Wallet JavaScript SDK";
	var keywords = [
		"cipher",
		"cipherbrowser",
		"coinbase",
		"coinbasewallet",
		"eth",
		"ether",
		"ethereum",
		"etherium",
		"injection",
		"toshi",
		"wallet",
		"walletlink",
		"web3"
	];
	var main = "dist/index.js";
	var types$2 = "dist/index.d.ts";
	var repository = "https://github.com/coinbase/coinbase-wallet-sdk.git";
	var author = "Coinbase, Inc.";
	var license = "Apache-2.0";
	var scripts = {
		"pretest:unit": "node compile-assets.js",
		"test:unit": "jest",
		"test:unit:coverage": "yarn test:unit && open coverage/lcov-report/index.html",
		"test:karma": "yarn build-npm && karma start",
		prebuild: "rm -rf ./build && node -p \"'export const LIB_VERSION = ' + JSON.stringify(require('./package.json').version) + ';'\" > src/version.ts",
		build: "node compile-assets.js && webpack --config webpack.config.js",
		"build-npm": "tsc -p ./tsconfig.build.json",
		"build:dev": "export LINK_API_URL='http://localhost:3000'; yarn build",
		"build:dev:watch": "nodemon -e 'ts,tsx,js,json,css,scss,svg' --ignore 'src/**/*-css.ts' --ignore 'src/**/*-svg.ts' --watch src/ --exec 'yarn build:dev'",
		"build:prod": "yarn prebuild && yarn build && yarn build-npm && cp ./package.json ../../README.md ./LICENSE build/npm && cp -a src/vendor-js build/npm/dist && sed -i.bak 's|  \"private\": true,||g' build/npm/package.json && rm -f build/npm/package.json.bak",
		"lint:types": "tsc --noEmit",
		"lint:prettier": "prettier --check \"{src,__tests__}/**/*.(js|ts|tsx)\"",
		"lint:eslint": "eslint ./src --ext .ts,.tsx",
		lint: "yarn lint:eslint && yarn lint:types && yarn lint:prettier",
		"fix:eslint": "yarn lint:eslint --fix",
		"fix:prettier": "prettier . --write",
		release: "./scripts/release.sh"
	};
	var dependencies = {
		"@metamask/safe-event-emitter": "2.0.0",
		"@solana/web3.js": "^1.70.1",
		"bind-decorator": "^1.0.11",
		"bn.js": "^5.1.1",
		buffer: "^6.0.3",
		clsx: "^1.1.0",
		"eth-block-tracker": "6.1.0",
		"eth-json-rpc-filters": "5.1.0",
		"eth-rpc-errors": "4.0.2",
		"json-rpc-engine": "6.1.0",
		keccak: "^3.0.1",
		preact: "^10.5.9",
		qs: "^6.10.3",
		rxjs: "^6.6.3",
		"sha.js": "^2.4.11",
		"stream-browserify": "^3.0.0",
		util: "^0.12.4"
	};
	var devDependencies = {
		"@babel/core": "^7.17.9",
		"@babel/plugin-proposal-decorators": "^7.17.9",
		"@babel/plugin-transform-react-jsx": "^7.17.3",
		"@babel/preset-env": "^7.16.11",
		"@babel/preset-typescript": "^7.16.7",
		"@peculiar/webcrypto": "^1.3.3",
		"@testing-library/jest-dom": "^5.16.4",
		"@testing-library/preact": "^2.0.1",
		"@types/bn.js": "^4.11.6",
		"@types/jest": "^27.4.1",
		"@types/node": "^14.14.20",
		"@types/qs": "^6.9.7",
		"@types/sha.js": "^2.4.0",
		"@typescript-eslint/eslint-plugin": "^5.7.0",
		"@typescript-eslint/eslint-plugin-tslint": "^5.7.0",
		"@typescript-eslint/parser": "^5.7.0",
		"babel-jest": "^27.5.1",
		browserify: "17.0.0",
		"copy-webpack-plugin": "^6.4.1",
		"core-js": "^3.8.2",
		eslint: "^8.4.1",
		"eslint-config-prettier": "^8.3.0",
		"eslint-plugin-import": "^2.25.3",
		"eslint-plugin-preact": "^0.1.0",
		"eslint-plugin-prettier": "^4.0.0",
		"eslint-plugin-simple-import-sort": "^7.0.0",
		jasmine: "3.8.0",
		jest: "^27.5.1",
		"jest-chrome": "^0.7.2",
		"jest-websocket-mock": "^2.3.0",
		karma: "^6.4.0",
		"karma-browserify": "8.1.0",
		"karma-chrome-launcher": "^3.1.0",
		"karma-jasmine": "^4.0.1",
		nodemon: "^2.0.6",
		prettier: "^2.5.1",
		"raw-loader": "^4.0.2",
		"regenerator-runtime": "^0.13.7",
		sass: "^1.50.0",
		svgo: "^2.8.0",
		"ts-jest": "^27.1.4",
		"ts-loader": "^8.0.13",
		"ts-node": "^10.7.0",
		tslib: "^2.0.3",
		typescript: "^4.1.3",
		watchify: "4.0.0",
		webpack: "^5.76.0",
		"webpack-cli": "^4.9.2",
		"whatwg-fetch": "^3.5.0"
	};
	var engines = {
		node: ">= 10.0.0"
	};
	var require$$7 = {
		name: name,
		version: version$1,
		description: description,
		keywords: keywords,
		main: main,
		types: types$2,
		repository: repository,
		author: author,
		license: license,
		scripts: scripts,
		dependencies: dependencies,
		devDependencies: devDependencies,
		engines: engines
	};

	// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
	// Licensed under the Apache License, version 2.0
	Object.defineProperty(CoinbaseWalletSDK$1, "__esModule", { value: true });
	CoinbaseWalletSDK$1.CoinbaseWalletSDK = void 0;
	const wallet_logo_1 = walletLogo$1;
	const ScopedLocalStorage_1 = ScopedLocalStorage$1;
	const CoinbaseWalletProvider_1 = CoinbaseWalletProvider$1;
	const WalletSDKUI_1 = WalletSDKUI$1;
	const WalletSDKRelay_1 = WalletSDKRelay$1;
	const WalletSDKRelayEventManager_1 = WalletSDKRelayEventManager$1;
	const util_1 = util$3;
	const LINK_API_URL = "https://www.walletlink.org";
	const SDK_VERSION = require$$7.version ;
	class CoinbaseWalletSDK {
	    /**
	     * Constructor
	     * @param options Coinbase Wallet SDK constructor options
	     */
	    constructor(options) {
	        var _a, _b, _c;
	        this._appName = "";
	        this._appLogoUrl = null;
	        this._relay = null;
	        this._relayEventManager = null;
	        const linkAPIUrl = options.linkAPIUrl || LINK_API_URL;
	        let uiConstructor;
	        if (!options.uiConstructor) {
	            uiConstructor = opts => new WalletSDKUI_1.WalletSDKUI(opts);
	        }
	        else {
	            uiConstructor = options.uiConstructor;
	        }
	        if (typeof options.overrideIsMetaMask === "undefined") {
	            this._overrideIsMetaMask = false;
	        }
	        else {
	            this._overrideIsMetaMask = options.overrideIsMetaMask;
	        }
	        this._overrideIsCoinbaseWallet = (_a = options.overrideIsCoinbaseWallet) !== null && _a !== void 0 ? _a : true;
	        this._overrideIsCoinbaseBrowser =
	            (_b = options.overrideIsCoinbaseBrowser) !== null && _b !== void 0 ? _b : false;
	        if (options.diagnosticLogger && options.eventListener) {
	            throw new Error("Can't have both eventListener and diagnosticLogger options, use only diagnosticLogger");
	        }
	        if (options.eventListener) {
	            this._diagnosticLogger = {
	                // eslint-disable-next-line @typescript-eslint/unbound-method
	                log: options.eventListener.onEvent,
	            };
	        }
	        else {
	            this._diagnosticLogger = options.diagnosticLogger;
	        }
	        this._reloadOnDisconnect = (_c = options.reloadOnDisconnect) !== null && _c !== void 0 ? _c : true;
	        const url = new URL(linkAPIUrl);
	        const origin = `${url.protocol}//${url.host}`;
	        this._storage = new ScopedLocalStorage_1.ScopedLocalStorage(`-walletlink:${origin}`); // needs migration to preserve local states
	        this._storage.setItem("version", CoinbaseWalletSDK.VERSION);
	        if (this.walletExtension || this.coinbaseBrowser) {
	            return;
	        }
	        this._relayEventManager = new WalletSDKRelayEventManager_1.WalletSDKRelayEventManager();
	        this._relay = new WalletSDKRelay_1.WalletSDKRelay({
	            linkAPIUrl,
	            version: SDK_VERSION,
	            darkMode: !!options.darkMode,
	            uiConstructor,
	            storage: this._storage,
	            relayEventManager: this._relayEventManager,
	            diagnosticLogger: this._diagnosticLogger,
	            reloadOnDisconnect: this._reloadOnDisconnect,
	        });
	        this.setAppInfo(options.appName, options.appLogoUrl);
	        if (!!options.headlessMode)
	            return;
	        this._relay.attachUI();
	    }
	    /**
	     * Create a Web3 Provider object
	     * @param jsonRpcUrl Ethereum JSON RPC URL (Default: "")
	     * @param chainId Ethereum Chain ID (Default: 1)
	     * @returns A Web3 Provider
	     */
	    makeWeb3Provider(jsonRpcUrl = "", chainId = 1) {
	        const extension = this.walletExtension;
	        if (extension) {
	            if (!this.isCipherProvider(extension)) {
	                extension.setProviderInfo(jsonRpcUrl, chainId);
	            }
	            if (this._reloadOnDisconnect === false &&
	                typeof extension.disableReloadOnDisconnect === "function")
	                extension.disableReloadOnDisconnect();
	            return extension;
	        }
	        const dappBrowser = this.coinbaseBrowser;
	        if (dappBrowser) {
	            return dappBrowser;
	        }
	        const relay = this._relay;
	        if (!relay || !this._relayEventManager || !this._storage) {
	            throw new Error("Relay not initialized, should never happen");
	        }
	        if (!jsonRpcUrl)
	            relay.setConnectDisabled(true);
	        return new CoinbaseWalletProvider_1.CoinbaseWalletProvider({
	            relayProvider: () => Promise.resolve(relay),
	            relayEventManager: this._relayEventManager,
	            storage: this._storage,
	            jsonRpcUrl,
	            chainId,
	            qrUrl: this.getQrUrl(),
	            diagnosticLogger: this._diagnosticLogger,
	            overrideIsMetaMask: this._overrideIsMetaMask,
	            overrideIsCoinbaseWallet: this._overrideIsCoinbaseWallet,
	            overrideIsCoinbaseBrowser: this._overrideIsCoinbaseBrowser,
	        });
	    }
	    /**
	     * Set application information
	     * @param appName Application name
	     * @param appLogoUrl Application logo image URL
	     */
	    setAppInfo(appName, appLogoUrl) {
	        var _a;
	        this._appName = appName || "DApp";
	        this._appLogoUrl = appLogoUrl || (0, util_1.getFavicon)();
	        const extension = this.walletExtension;
	        if (extension) {
	            if (!this.isCipherProvider(extension)) {
	                extension.setAppInfo(this._appName, this._appLogoUrl);
	            }
	        }
	        else {
	            (_a = this._relay) === null || _a === void 0 ? void 0 : _a.setAppInfo(this._appName, this._appLogoUrl);
	        }
	    }
	    /**
	     * Disconnect. After disconnecting, this will reload the web page to ensure
	     * all potential stale state is cleared.
	     */
	    disconnect() {
	        var _a;
	        const extension = this.walletExtension;
	        if (extension) {
	            void extension.close();
	        }
	        else {
	            (_a = this._relay) === null || _a === void 0 ? void 0 : _a.resetAndReload();
	        }
	    }
	    /**
	     * Return QR URL for mobile wallet connection, will return null if extension is installed
	     */
	    getQrUrl() {
	        var _a, _b;
	        return (_b = (_a = this._relay) === null || _a === void 0 ? void 0 : _a.getQRCodeUrl()) !== null && _b !== void 0 ? _b : null;
	    }
	    /**
	     * Official Coinbase Wallet logo for developers to use on their frontend
	     * @param type Type of wallet logo: "standard" | "circle" | "text" | "textWithLogo" | "textLight" | "textWithLogoLight"
	     * @param width Width of the logo (Optional)
	     * @returns SVG Data URI
	     */
	    getCoinbaseWalletLogo(type, width = 240) {
	        return (0, wallet_logo_1.walletLogo)(type, width);
	    }
	    get walletExtension() {
	        var _a;
	        return (_a = window.coinbaseWalletExtension) !== null && _a !== void 0 ? _a : window.walletLinkExtension;
	    }
	    get coinbaseBrowser() {
	        var _a, _b;
	        try {
	            // Coinbase DApp browser does not inject into iframes so grab provider from top frame if it exists
	            const ethereum = (_a = window.ethereum) !== null && _a !== void 0 ? _a : (_b = window.top) === null || _b === void 0 ? void 0 : _b.ethereum;
	            if (!ethereum) {
	                return undefined;
	            }
	            if ("isCoinbaseBrowser" in ethereum && ethereum.isCoinbaseBrowser) {
	                return ethereum;
	            }
	            else {
	                return undefined;
	            }
	        }
	        catch (e) {
	            return undefined;
	        }
	    }
	    isCipherProvider(provider) {
	        // @ts-expect-error isCipher walletlink property
	        return typeof provider.isCipher === "boolean" && provider.isCipher;
	    }
	}
	CoinbaseWalletSDK$1.CoinbaseWalletSDK = CoinbaseWalletSDK;
	CoinbaseWalletSDK.VERSION = SDK_VERSION;

	(function (exports) {
		// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
		// Licensed under the Apache License, version 2.0
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.CoinbaseWalletProvider = exports.CoinbaseWalletSDK = void 0;
		const CoinbaseWalletSDK_1 = CoinbaseWalletSDK$1;
		const CoinbaseWalletProvider_1 = CoinbaseWalletProvider$1;
		var CoinbaseWalletSDK_2 = CoinbaseWalletSDK$1;
		Object.defineProperty(exports, "CoinbaseWalletSDK", { enumerable: true, get: function () { return CoinbaseWalletSDK_2.CoinbaseWalletSDK; } });
		var CoinbaseWalletProvider_2 = CoinbaseWalletProvider$1;
		Object.defineProperty(exports, "CoinbaseWalletProvider", { enumerable: true, get: function () { return CoinbaseWalletProvider_2.CoinbaseWalletProvider; } });
		exports.default = CoinbaseWalletSDK_1.CoinbaseWalletSDK;
		if (typeof window !== "undefined") {
		    window.CoinbaseWalletSDK = CoinbaseWalletSDK_1.CoinbaseWalletSDK;
		    window.CoinbaseWalletProvider = CoinbaseWalletProvider_1.CoinbaseWalletProvider;
		    /**
		     * @deprecated Use `window.CoinbaseWalletSDK`
		     */
		    window.WalletLink = CoinbaseWalletSDK_1.CoinbaseWalletSDK;
		    /**
		     * @deprecated Use `window.CoinbaseWalletProvider`
		     */
		    window.WalletLinkProvider = CoinbaseWalletProvider_1.CoinbaseWalletProvider;
		} 
	} (dist$6));

	var index$2 = /*@__PURE__*/getDefaultExportFromCjs(dist$6);

	var index$3 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: index$2
	});

	var browser$2 = {};

	var cjs$3 = {};

	Object.defineProperty(cjs$3, "__esModule", { value: true });
	function safeJsonParse$1(value) {
	    if (typeof value !== 'string') {
	        throw new Error(`Cannot safe json parse value of type ${typeof value}`);
	    }
	    try {
	        return JSON.parse(value);
	    }
	    catch (_a) {
	        return value;
	    }
	}
	cjs$3.safeJsonParse = safeJsonParse$1;
	function safeJsonStringify$1(value) {
	    return typeof value === 'string'
	        ? value
	        : JSON.stringify(value, (key, value) => typeof value === 'undefined' ? null : value);
	}
	cjs$3.safeJsonStringify = safeJsonStringify$1;

	var localStorage$1 = {exports: {}};

	var hasRequiredLocalStorage;

	function requireLocalStorage () {
		if (hasRequiredLocalStorage) return localStorage$1.exports;
		hasRequiredLocalStorage = 1;
		(function () {
		    let db;
		    function LocalStorage() { }
		    db = LocalStorage;
		    db.prototype.getItem = function (key) {
		        if (this.hasOwnProperty(key)) {
		            return String(this[key]);
		        }
		        return null;
		    };
		    db.prototype.setItem = function (key, val) {
		        this[key] = String(val);
		    };
		    db.prototype.removeItem = function (key) {
		        delete this[key];
		    };
		    db.prototype.clear = function () {
		        const self = this;
		        Object.keys(self).forEach(function (key) {
		            self[key] = undefined;
		            delete self[key];
		        });
		    };
		    db.prototype.key = function (i) {
		        i = i || 0;
		        return Object.keys(this)[i];
		    };
		    db.prototype.__defineGetter__("length", function () {
		        return Object.keys(this).length;
		    });
		    if (typeof commonjsGlobal !== "undefined" && commonjsGlobal.localStorage) {
		        localStorage$1.exports = commonjsGlobal.localStorage;
		    }
		    else if (typeof window !== "undefined" && window.localStorage) {
		        localStorage$1.exports = window.localStorage;
		    }
		    else {
		        localStorage$1.exports = new LocalStorage();
		    }
		})();
		
		return localStorage$1.exports;
	}

	var shared = {};

	var types$1 = {};

	var hasRequiredTypes$1;

	function requireTypes$1 () {
		if (hasRequiredTypes$1) return types$1;
		hasRequiredTypes$1 = 1;
		Object.defineProperty(types$1, "__esModule", { value: true });
		types$1.IKeyValueStorage = void 0;
		class IKeyValueStorage {
		}
		types$1.IKeyValueStorage = IKeyValueStorage;
		
		return types$1;
	}

	var utils$3 = {};

	var hasRequiredUtils$1;

	function requireUtils$1 () {
		if (hasRequiredUtils$1) return utils$3;
		hasRequiredUtils$1 = 1;
		Object.defineProperty(utils$3, "__esModule", { value: true });
		utils$3.parseEntry = void 0;
		const safe_json_utils_1 = cjs$3;
		function parseEntry(entry) {
		    var _a;
		    return [entry[0], safe_json_utils_1.safeJsonParse((_a = entry[1]) !== null && _a !== void 0 ? _a : "")];
		}
		utils$3.parseEntry = parseEntry;
		
		return utils$3;
	}

	var hasRequiredShared;

	function requireShared () {
		if (hasRequiredShared) return shared;
		hasRequiredShared = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			const tslib_1 = require$$0$4;
			tslib_1.__exportStar(requireTypes$1(), exports);
			tslib_1.__exportStar(requireUtils$1(), exports);
			
		} (shared));
		return shared;
	}

	Object.defineProperty(browser$2, "__esModule", { value: true });
	browser$2.KeyValueStorage = void 0;
	const tslib_1 = require$$0$4;
	const safe_json_utils_1 = cjs$3;
	const localStorage_1 = tslib_1.__importDefault(requireLocalStorage());
	const shared_1 = requireShared();
	class KeyValueStorage {
	    constructor() {
	        this.localStorage = localStorage_1.default;
	    }
	    getKeys() {
	        return tslib_1.__awaiter(this, void 0, void 0, function* () {
	            return Object.keys(this.localStorage);
	        });
	    }
	    getEntries() {
	        return tslib_1.__awaiter(this, void 0, void 0, function* () {
	            return Object.entries(this.localStorage).map(shared_1.parseEntry);
	        });
	    }
	    getItem(key) {
	        return tslib_1.__awaiter(this, void 0, void 0, function* () {
	            const item = this.localStorage.getItem(key);
	            if (item === null) {
	                return undefined;
	            }
	            return safe_json_utils_1.safeJsonParse(item);
	        });
	    }
	    setItem(key, value) {
	        return tslib_1.__awaiter(this, void 0, void 0, function* () {
	            this.localStorage.setItem(key, safe_json_utils_1.safeJsonStringify(value));
	        });
	    }
	    removeItem(key) {
	        return tslib_1.__awaiter(this, void 0, void 0, function* () {
	            this.localStorage.removeItem(key);
	        });
	    }
	}
	browser$2.KeyValueStorage = KeyValueStorage;
	var _default = browser$2.default = KeyValueStorage;

	var cjs$2 = {};

	var heartbeat$2 = {};

	var types = {};

	var heartbeat$1 = {};

	let IEvents$1 = class IEvents {
	};

	var esm = /*#__PURE__*/Object.freeze({
		__proto__: null,
		IEvents: IEvents$1
	});

	var require$$0 = /*@__PURE__*/getAugmentedNamespace(esm);

	var hasRequiredHeartbeat$2;

	function requireHeartbeat$2 () {
		if (hasRequiredHeartbeat$2) return heartbeat$1;
		hasRequiredHeartbeat$2 = 1;
		Object.defineProperty(heartbeat$1, "__esModule", { value: true });
		heartbeat$1.IHeartBeat = void 0;
		const events_1 = require$$0;
		class IHeartBeat extends events_1.IEvents {
		    constructor(opts) {
		        super();
		    }
		}
		heartbeat$1.IHeartBeat = IHeartBeat;
		
		return heartbeat$1;
	}

	var hasRequiredTypes;

	function requireTypes () {
		if (hasRequiredTypes) return types;
		hasRequiredTypes = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			const tslib_1 = require$$0$4;
			tslib_1.__exportStar(requireHeartbeat$2(), exports);
			
		} (types));
		return types;
	}

	var constants$1 = {};

	var heartbeat = {};

	var hasRequiredHeartbeat$1;

	function requireHeartbeat$1 () {
		if (hasRequiredHeartbeat$1) return heartbeat;
		hasRequiredHeartbeat$1 = 1;
		Object.defineProperty(heartbeat, "__esModule", { value: true });
		heartbeat.HEARTBEAT_EVENTS = heartbeat.HEARTBEAT_INTERVAL = void 0;
		const time_1 = cjs$6;
		heartbeat.HEARTBEAT_INTERVAL = time_1.FIVE_SECONDS;
		heartbeat.HEARTBEAT_EVENTS = {
		    pulse: "heartbeat_pulse",
		};
		
		return heartbeat;
	}

	var hasRequiredConstants$1;

	function requireConstants$1 () {
		if (hasRequiredConstants$1) return constants$1;
		hasRequiredConstants$1 = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			const tslib_1 = require$$0$4;
			tslib_1.__exportStar(requireHeartbeat$1(), exports);
			
		} (constants$1));
		return constants$1;
	}

	var hasRequiredHeartbeat;

	function requireHeartbeat () {
		if (hasRequiredHeartbeat) return heartbeat$2;
		hasRequiredHeartbeat = 1;
		Object.defineProperty(heartbeat$2, "__esModule", { value: true });
		heartbeat$2.HeartBeat = void 0;
		const tslib_1 = require$$0$4;
		const events_1 = eventsExports;
		const time_1 = cjs$6;
		const types_1 = requireTypes();
		const constants_1 = requireConstants$1();
		class HeartBeat extends types_1.IHeartBeat {
		    constructor(opts) {
		        super(opts);
		        this.events = new events_1.EventEmitter();
		        this.interval = constants_1.HEARTBEAT_INTERVAL;
		        this.interval = (opts === null || opts === void 0 ? void 0 : opts.interval) || constants_1.HEARTBEAT_INTERVAL;
		    }
		    static init(opts) {
		        return tslib_1.__awaiter(this, void 0, void 0, function* () {
		            const heartbeat = new HeartBeat(opts);
		            yield heartbeat.init();
		            return heartbeat;
		        });
		    }
		    init() {
		        return tslib_1.__awaiter(this, void 0, void 0, function* () {
		            yield this.initialize();
		        });
		    }
		    stop() {
		        clearInterval(this.intervalRef);
		    }
		    on(event, listener) {
		        this.events.on(event, listener);
		    }
		    once(event, listener) {
		        this.events.once(event, listener);
		    }
		    off(event, listener) {
		        this.events.off(event, listener);
		    }
		    removeListener(event, listener) {
		        this.events.removeListener(event, listener);
		    }
		    initialize() {
		        return tslib_1.__awaiter(this, void 0, void 0, function* () {
		            this.intervalRef = setInterval(() => this.pulse(), time_1.toMiliseconds(this.interval));
		        });
		    }
		    pulse() {
		        this.events.emit(constants_1.HEARTBEAT_EVENTS.pulse);
		    }
		}
		heartbeat$2.HeartBeat = HeartBeat;
		
		return heartbeat$2;
	}

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		const tslib_1 = require$$0$4;
		tslib_1.__exportStar(requireHeartbeat(), exports);
		tslib_1.__exportStar(requireTypes(), exports);
		tslib_1.__exportStar(requireConstants$1(), exports);
		
	} (cjs$2));

	var cjs$1 = {};

	var quickFormatUnescaped;
	var hasRequiredQuickFormatUnescaped;

	function requireQuickFormatUnescaped () {
		if (hasRequiredQuickFormatUnescaped) return quickFormatUnescaped;
		hasRequiredQuickFormatUnescaped = 1;
		function tryStringify (o) {
		  try { return JSON.stringify(o) } catch(e) { return '"[Circular]"' }
		}

		quickFormatUnescaped = format;

		function format(f, args, opts) {
		  var ss = (opts && opts.stringify) || tryStringify;
		  var offset = 1;
		  if (typeof f === 'object' && f !== null) {
		    var len = args.length + offset;
		    if (len === 1) return f
		    var objects = new Array(len);
		    objects[0] = ss(f);
		    for (var index = 1; index < len; index++) {
		      objects[index] = ss(args[index]);
		    }
		    return objects.join(' ')
		  }
		  if (typeof f !== 'string') {
		    return f
		  }
		  var argLen = args.length;
		  if (argLen === 0) return f
		  var str = '';
		  var a = 1 - offset;
		  var lastPos = -1;
		  var flen = (f && f.length) || 0;
		  for (var i = 0; i < flen;) {
		    if (f.charCodeAt(i) === 37 && i + 1 < flen) {
		      lastPos = lastPos > -1 ? lastPos : 0;
		      switch (f.charCodeAt(i + 1)) {
		        case 100: // 'd'
		        case 102: // 'f'
		          if (a >= argLen)
		            break
		          if (args[a] == null)  break
		          if (lastPos < i)
		            str += f.slice(lastPos, i);
		          str += Number(args[a]);
		          lastPos = i + 2;
		          i++;
		          break
		        case 105: // 'i'
		          if (a >= argLen)
		            break
		          if (args[a] == null)  break
		          if (lastPos < i)
		            str += f.slice(lastPos, i);
		          str += Math.floor(Number(args[a]));
		          lastPos = i + 2;
		          i++;
		          break
		        case 79: // 'O'
		        case 111: // 'o'
		        case 106: // 'j'
		          if (a >= argLen)
		            break
		          if (args[a] === undefined) break
		          if (lastPos < i)
		            str += f.slice(lastPos, i);
		          var type = typeof args[a];
		          if (type === 'string') {
		            str += '\'' + args[a] + '\'';
		            lastPos = i + 2;
		            i++;
		            break
		          }
		          if (type === 'function') {
		            str += args[a].name || '<anonymous>';
		            lastPos = i + 2;
		            i++;
		            break
		          }
		          str += ss(args[a]);
		          lastPos = i + 2;
		          i++;
		          break
		        case 115: // 's'
		          if (a >= argLen)
		            break
		          if (lastPos < i)
		            str += f.slice(lastPos, i);
		          str += String(args[a]);
		          lastPos = i + 2;
		          i++;
		          break
		        case 37: // '%'
		          if (lastPos < i)
		            str += f.slice(lastPos, i);
		          str += '%';
		          lastPos = i + 2;
		          i++;
		          a--;
		          break
		      }
		      ++a;
		    }
		    ++i;
		  }
		  if (lastPos === -1)
		    return f
		  else if (lastPos < flen) {
		    str += f.slice(lastPos);
		  }

		  return str
		}
		return quickFormatUnescaped;
	}

	var browser$1;
	var hasRequiredBrowser;

	function requireBrowser () {
		if (hasRequiredBrowser) return browser$1;
		hasRequiredBrowser = 1;

		const format = requireQuickFormatUnescaped();

		browser$1 = pino;

		const _console = pfGlobalThisOrFallback().console || {};
		const stdSerializers = {
		  mapHttpRequest: mock,
		  mapHttpResponse: mock,
		  wrapRequestSerializer: passthrough,
		  wrapResponseSerializer: passthrough,
		  wrapErrorSerializer: passthrough,
		  req: mock,
		  res: mock,
		  err: asErrValue
		};

		function shouldSerialize (serialize, serializers) {
		  if (Array.isArray(serialize)) {
		    const hasToFilter = serialize.filter(function (k) {
		      return k !== '!stdSerializers.err'
		    });
		    return hasToFilter
		  } else if (serialize === true) {
		    return Object.keys(serializers)
		  }

		  return false
		}

		function pino (opts) {
		  opts = opts || {};
		  opts.browser = opts.browser || {};

		  const transmit = opts.browser.transmit;
		  if (transmit && typeof transmit.send !== 'function') { throw Error('pino: transmit option must have a send function') }

		  const proto = opts.browser.write || _console;
		  if (opts.browser.write) opts.browser.asObject = true;
		  const serializers = opts.serializers || {};
		  const serialize = shouldSerialize(opts.browser.serialize, serializers);
		  let stdErrSerialize = opts.browser.serialize;

		  if (
		    Array.isArray(opts.browser.serialize) &&
		    opts.browser.serialize.indexOf('!stdSerializers.err') > -1
		  ) stdErrSerialize = false;

		  const levels = ['error', 'fatal', 'warn', 'info', 'debug', 'trace'];

		  if (typeof proto === 'function') {
		    proto.error = proto.fatal = proto.warn =
		    proto.info = proto.debug = proto.trace = proto;
		  }
		  if (opts.enabled === false) opts.level = 'silent';
		  const level = opts.level || 'info';
		  const logger = Object.create(proto);
		  if (!logger.log) logger.log = noop;

		  Object.defineProperty(logger, 'levelVal', {
		    get: getLevelVal
		  });
		  Object.defineProperty(logger, 'level', {
		    get: getLevel,
		    set: setLevel
		  });

		  const setOpts = {
		    transmit,
		    serialize,
		    asObject: opts.browser.asObject,
		    levels,
		    timestamp: getTimeFunction(opts)
		  };
		  logger.levels = pino.levels;
		  logger.level = level;

		  logger.setMaxListeners = logger.getMaxListeners =
		  logger.emit = logger.addListener = logger.on =
		  logger.prependListener = logger.once =
		  logger.prependOnceListener = logger.removeListener =
		  logger.removeAllListeners = logger.listeners =
		  logger.listenerCount = logger.eventNames =
		  logger.write = logger.flush = noop;
		  logger.serializers = serializers;
		  logger._serialize = serialize;
		  logger._stdErrSerialize = stdErrSerialize;
		  logger.child = child;

		  if (transmit) logger._logEvent = createLogEventShape();

		  function getLevelVal () {
		    return this.level === 'silent'
		      ? Infinity
		      : this.levels.values[this.level]
		  }

		  function getLevel () {
		    return this._level
		  }
		  function setLevel (level) {
		    if (level !== 'silent' && !this.levels.values[level]) {
		      throw Error('unknown level ' + level)
		    }
		    this._level = level;

		    set(setOpts, logger, 'error', 'log'); // <-- must stay first
		    set(setOpts, logger, 'fatal', 'error');
		    set(setOpts, logger, 'warn', 'error');
		    set(setOpts, logger, 'info', 'log');
		    set(setOpts, logger, 'debug', 'log');
		    set(setOpts, logger, 'trace', 'log');
		  }

		  function child (bindings, childOptions) {
		    if (!bindings) {
		      throw new Error('missing bindings for child Pino')
		    }
		    childOptions = childOptions || {};
		    if (serialize && bindings.serializers) {
		      childOptions.serializers = bindings.serializers;
		    }
		    const childOptionsSerializers = childOptions.serializers;
		    if (serialize && childOptionsSerializers) {
		      var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
		      var childSerialize = opts.browser.serialize === true
		        ? Object.keys(childSerializers)
		        : serialize;
		      delete bindings.serializers;
		      applySerializers([bindings], childSerialize, childSerializers, this._stdErrSerialize);
		    }
		    function Child (parent) {
		      this._childLevel = (parent._childLevel | 0) + 1;
		      this.error = bind(parent, bindings, 'error');
		      this.fatal = bind(parent, bindings, 'fatal');
		      this.warn = bind(parent, bindings, 'warn');
		      this.info = bind(parent, bindings, 'info');
		      this.debug = bind(parent, bindings, 'debug');
		      this.trace = bind(parent, bindings, 'trace');
		      if (childSerializers) {
		        this.serializers = childSerializers;
		        this._serialize = childSerialize;
		      }
		      if (transmit) {
		        this._logEvent = createLogEventShape(
		          [].concat(parent._logEvent.bindings, bindings)
		        );
		      }
		    }
		    Child.prototype = this;
		    return new Child(this)
		  }
		  return logger
		}

		pino.levels = {
		  values: {
		    fatal: 60,
		    error: 50,
		    warn: 40,
		    info: 30,
		    debug: 20,
		    trace: 10
		  },
		  labels: {
		    10: 'trace',
		    20: 'debug',
		    30: 'info',
		    40: 'warn',
		    50: 'error',
		    60: 'fatal'
		  }
		};

		pino.stdSerializers = stdSerializers;
		pino.stdTimeFunctions = Object.assign({}, { nullTime, epochTime, unixTime, isoTime });

		function set (opts, logger, level, fallback) {
		  const proto = Object.getPrototypeOf(logger);
		  logger[level] = logger.levelVal > logger.levels.values[level]
		    ? noop
		    : (proto[level] ? proto[level] : (_console[level] || _console[fallback] || noop));

		  wrap(opts, logger, level);
		}

		function wrap (opts, logger, level) {
		  if (!opts.transmit && logger[level] === noop) return

		  logger[level] = (function (write) {
		    return function LOG () {
		      const ts = opts.timestamp();
		      const args = new Array(arguments.length);
		      const proto = (Object.getPrototypeOf && Object.getPrototypeOf(this) === _console) ? _console : this;
		      for (var i = 0; i < args.length; i++) args[i] = arguments[i];

		      if (opts.serialize && !opts.asObject) {
		        applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
		      }
		      if (opts.asObject) write.call(proto, asObject(this, level, args, ts));
		      else write.apply(proto, args);

		      if (opts.transmit) {
		        const transmitLevel = opts.transmit.level || logger.level;
		        const transmitValue = pino.levels.values[transmitLevel];
		        const methodValue = pino.levels.values[level];
		        if (methodValue < transmitValue) return
		        transmit(this, {
		          ts,
		          methodLevel: level,
		          methodValue,
		          transmitLevel,
		          transmitValue: pino.levels.values[opts.transmit.level || logger.level],
		          send: opts.transmit.send,
		          val: logger.levelVal
		        }, args);
		      }
		    }
		  })(logger[level]);
		}

		function asObject (logger, level, args, ts) {
		  if (logger._serialize) applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
		  const argsCloned = args.slice();
		  let msg = argsCloned[0];
		  const o = {};
		  if (ts) {
		    o.time = ts;
		  }
		  o.level = pino.levels.values[level];
		  let lvl = (logger._childLevel | 0) + 1;
		  if (lvl < 1) lvl = 1;
		  // deliberate, catching objects, arrays
		  if (msg !== null && typeof msg === 'object') {
		    while (lvl-- && typeof argsCloned[0] === 'object') {
		      Object.assign(o, argsCloned.shift());
		    }
		    msg = argsCloned.length ? format(argsCloned.shift(), argsCloned) : undefined;
		  } else if (typeof msg === 'string') msg = format(argsCloned.shift(), argsCloned);
		  if (msg !== undefined) o.msg = msg;
		  return o
		}

		function applySerializers (args, serialize, serializers, stdErrSerialize) {
		  for (const i in args) {
		    if (stdErrSerialize && args[i] instanceof Error) {
		      args[i] = pino.stdSerializers.err(args[i]);
		    } else if (typeof args[i] === 'object' && !Array.isArray(args[i])) {
		      for (const k in args[i]) {
		        if (serialize && serialize.indexOf(k) > -1 && k in serializers) {
		          args[i][k] = serializers[k](args[i][k]);
		        }
		      }
		    }
		  }
		}

		function bind (parent, bindings, level) {
		  return function () {
		    const args = new Array(1 + arguments.length);
		    args[0] = bindings;
		    for (var i = 1; i < args.length; i++) {
		      args[i] = arguments[i - 1];
		    }
		    return parent[level].apply(this, args)
		  }
		}

		function transmit (logger, opts, args) {
		  const send = opts.send;
		  const ts = opts.ts;
		  const methodLevel = opts.methodLevel;
		  const methodValue = opts.methodValue;
		  const val = opts.val;
		  const bindings = logger._logEvent.bindings;

		  applySerializers(
		    args,
		    logger._serialize || Object.keys(logger.serializers),
		    logger.serializers,
		    logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize
		  );
		  logger._logEvent.ts = ts;
		  logger._logEvent.messages = args.filter(function (arg) {
		    // bindings can only be objects, so reference equality check via indexOf is fine
		    return bindings.indexOf(arg) === -1
		  });

		  logger._logEvent.level.label = methodLevel;
		  logger._logEvent.level.value = methodValue;

		  send(methodLevel, logger._logEvent, val);

		  logger._logEvent = createLogEventShape(bindings);
		}

		function createLogEventShape (bindings) {
		  return {
		    ts: 0,
		    messages: [],
		    bindings: bindings || [],
		    level: { label: '', value: 0 }
		  }
		}

		function asErrValue (err) {
		  const obj = {
		    type: err.constructor.name,
		    msg: err.message,
		    stack: err.stack
		  };
		  for (const key in err) {
		    if (obj[key] === undefined) {
		      obj[key] = err[key];
		    }
		  }
		  return obj
		}

		function getTimeFunction (opts) {
		  if (typeof opts.timestamp === 'function') {
		    return opts.timestamp
		  }
		  if (opts.timestamp === false) {
		    return nullTime
		  }
		  return epochTime
		}

		function mock () { return {} }
		function passthrough (a) { return a }
		function noop () {}

		function nullTime () { return false }
		function epochTime () { return Date.now() }
		function unixTime () { return Math.round(Date.now() / 1000.0) }
		function isoTime () { return new Date(Date.now()).toISOString() } // using Date.now() for testability

		/* eslint-disable */
		/* istanbul ignore next */
		function pfGlobalThisOrFallback () {
		  function defd (o) { return typeof o !== 'undefined' && o }
		  try {
		    if (typeof globalThis !== 'undefined') return globalThis
		    Object.defineProperty(Object.prototype, 'globalThis', {
		      get: function () {
		        delete Object.prototype.globalThis;
		        return (this.globalThis = this)
		      },
		      configurable: true
		    });
		    return globalThis
		  } catch (e) {
		    return defd(self) || defd(window) || defd(this) || {}
		  }
		}
		/* eslint-enable */
		return browser$1;
	}

	var constants = {};

	var hasRequiredConstants;

	function requireConstants () {
		if (hasRequiredConstants) return constants;
		hasRequiredConstants = 1;
		Object.defineProperty(constants, "__esModule", { value: true });
		constants.PINO_CUSTOM_CONTEXT_KEY = constants.PINO_LOGGER_DEFAULTS = void 0;
		constants.PINO_LOGGER_DEFAULTS = {
		    level: "info",
		};
		constants.PINO_CUSTOM_CONTEXT_KEY = "custom_context";
		
		return constants;
	}

	var utils$2 = {};

	var hasRequiredUtils;

	function requireUtils () {
		if (hasRequiredUtils) return utils$2;
		hasRequiredUtils = 1;
		Object.defineProperty(utils$2, "__esModule", { value: true });
		utils$2.generateChildLogger = utils$2.formatChildLoggerContext = utils$2.getLoggerContext = utils$2.setBrowserLoggerContext = utils$2.getBrowserLoggerContext = utils$2.getDefaultLoggerOptions = void 0;
		const constants_1 = requireConstants();
		function getDefaultLoggerOptions(opts) {
		    return Object.assign(Object.assign({}, opts), { level: (opts === null || opts === void 0 ? void 0 : opts.level) || constants_1.PINO_LOGGER_DEFAULTS.level });
		}
		utils$2.getDefaultLoggerOptions = getDefaultLoggerOptions;
		function getBrowserLoggerContext(logger, customContextKey = constants_1.PINO_CUSTOM_CONTEXT_KEY) {
		    return logger[customContextKey] || "";
		}
		utils$2.getBrowserLoggerContext = getBrowserLoggerContext;
		function setBrowserLoggerContext(logger, context, customContextKey = constants_1.PINO_CUSTOM_CONTEXT_KEY) {
		    logger[customContextKey] = context;
		    return logger;
		}
		utils$2.setBrowserLoggerContext = setBrowserLoggerContext;
		function getLoggerContext(logger, customContextKey = constants_1.PINO_CUSTOM_CONTEXT_KEY) {
		    let context = "";
		    if (typeof logger.bindings === "undefined") {
		        context = getBrowserLoggerContext(logger, customContextKey);
		    }
		    else {
		        context = logger.bindings().context || "";
		    }
		    return context;
		}
		utils$2.getLoggerContext = getLoggerContext;
		function formatChildLoggerContext(logger, childContext, customContextKey = constants_1.PINO_CUSTOM_CONTEXT_KEY) {
		    const parentContext = getLoggerContext(logger, customContextKey);
		    const context = parentContext.trim()
		        ? `${parentContext}/${childContext}`
		        : childContext;
		    return context;
		}
		utils$2.formatChildLoggerContext = formatChildLoggerContext;
		function generateChildLogger(logger, childContext, customContextKey = constants_1.PINO_CUSTOM_CONTEXT_KEY) {
		    const context = formatChildLoggerContext(logger, childContext, customContextKey);
		    const child = logger.child({ context });
		    return setBrowserLoggerContext(child, context, customContextKey);
		}
		utils$2.generateChildLogger = generateChildLogger;
		
		return utils$2;
	}

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.pino = void 0;
		const tslib_1 = require$$0$4;
		const pino_1 = tslib_1.__importDefault(requireBrowser());
		Object.defineProperty(exports, "pino", { enumerable: true, get: function () { return pino_1.default; } });
		tslib_1.__exportStar(requireConstants(), exports);
		tslib_1.__exportStar(requireUtils(), exports);
		
	} (cjs$1));

	let n$7 = class n extends IEvents$1{constructor(s){super(),this.opts=s,this.protocol="wc",this.version=2;}};let h$4 = class h extends IEvents$1{constructor(s,t){super(),this.core=s,this.logger=t,this.records=new Map;}};let a$2 = class a{constructor(s,t){this.logger=s,this.core=t;}};let u$3 = class u extends IEvents$1{constructor(s,t){super(),this.relayer=s,this.logger=t;}};let g$4 = class g extends IEvents$1{constructor(s){super();}};let p$3 = class p{constructor(s,t,o,w){this.core=s,this.logger=t,this.name=o;}};let d$4 = class d extends IEvents$1{constructor(s,t){super(),this.relayer=s,this.logger=t;}};let E$2 = class E extends IEvents$1{constructor(s,t){super(),this.core=s,this.logger=t;}};let y$4 = class y{constructor(s,t){this.projectId=s,this.logger=t;}};let b$3 = class b{constructor(s){this.opts=s,this.protocol="wc",this.version=2;}};let S$4 = class S{constructor(s){this.client=s;}};

	const JSONStringify = data => JSON.stringify(data, (_, value) => typeof value === "bigint" ? value.toString() + "n" : value);
	const JSONParse = json => {
	    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
	    const serializedData = json.replace(numbersBiggerThanMaxInt, "$1\"$2n\"$3");
	    return JSON.parse(serializedData, (_, value) => {
	        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
	        if (isCustomFormatBigInt)
	            return BigInt(value.substring(0, value.length - 1));
	        return value;
	    });
	};
	function safeJsonParse(value) {
	    if (typeof value !== "string") {
	        throw new Error(`Cannot safe json parse value of type ${typeof value}`);
	    }
	    try {
	        return JSONParse(value);
	    }
	    catch (_a) {
	        return value;
	    }
	}
	function safeJsonStringify(value) {
	    return typeof value === "string" ? value : JSONStringify(value) || "";
	}

	var ed25519 = {};

	var sha512 = {};

	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		var binary_1 = binary;
		var wipe_1 = wipe$1;
		exports.DIGEST_LENGTH = 64;
		exports.BLOCK_SIZE = 128;
		/**
		 * SHA-2-512 cryptographic hash algorithm.
		 */
		var SHA512 = /** @class */ (function () {
		    function SHA512() {
		        /** Length of hash output */
		        this.digestLength = exports.DIGEST_LENGTH;
		        /** Block size */
		        this.blockSize = exports.BLOCK_SIZE;
		        // Note: Int32Array is used instead of Uint32Array for performance reasons.
		        this._stateHi = new Int32Array(8); // hash state, high bytes
		        this._stateLo = new Int32Array(8); // hash state, low bytes
		        this._tempHi = new Int32Array(16); // temporary state, high bytes
		        this._tempLo = new Int32Array(16); // temporary state, low bytes
		        this._buffer = new Uint8Array(256); // buffer for data to hash
		        this._bufferLength = 0; // number of bytes in buffer
		        this._bytesHashed = 0; // number of total bytes hashed
		        this._finished = false; // indicates whether the hash was finalized
		        this.reset();
		    }
		    SHA512.prototype._initState = function () {
		        this._stateHi[0] = 0x6a09e667;
		        this._stateHi[1] = 0xbb67ae85;
		        this._stateHi[2] = 0x3c6ef372;
		        this._stateHi[3] = 0xa54ff53a;
		        this._stateHi[4] = 0x510e527f;
		        this._stateHi[5] = 0x9b05688c;
		        this._stateHi[6] = 0x1f83d9ab;
		        this._stateHi[7] = 0x5be0cd19;
		        this._stateLo[0] = 0xf3bcc908;
		        this._stateLo[1] = 0x84caa73b;
		        this._stateLo[2] = 0xfe94f82b;
		        this._stateLo[3] = 0x5f1d36f1;
		        this._stateLo[4] = 0xade682d1;
		        this._stateLo[5] = 0x2b3e6c1f;
		        this._stateLo[6] = 0xfb41bd6b;
		        this._stateLo[7] = 0x137e2179;
		    };
		    /**
		     * Resets hash state making it possible
		     * to re-use this instance to hash other data.
		     */
		    SHA512.prototype.reset = function () {
		        this._initState();
		        this._bufferLength = 0;
		        this._bytesHashed = 0;
		        this._finished = false;
		        return this;
		    };
		    /**
		     * Cleans internal buffers and resets hash state.
		     */
		    SHA512.prototype.clean = function () {
		        wipe_1.wipe(this._buffer);
		        wipe_1.wipe(this._tempHi);
		        wipe_1.wipe(this._tempLo);
		        this.reset();
		    };
		    /**
		     * Updates hash state with the given data.
		     *
		     * Throws error when trying to update already finalized hash:
		     * instance must be reset to update it again.
		     */
		    SHA512.prototype.update = function (data, dataLength) {
		        if (dataLength === void 0) { dataLength = data.length; }
		        if (this._finished) {
		            throw new Error("SHA512: can't update because hash was finished.");
		        }
		        var dataPos = 0;
		        this._bytesHashed += dataLength;
		        if (this._bufferLength > 0) {
		            while (this._bufferLength < exports.BLOCK_SIZE && dataLength > 0) {
		                this._buffer[this._bufferLength++] = data[dataPos++];
		                dataLength--;
		            }
		            if (this._bufferLength === this.blockSize) {
		                hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
		                this._bufferLength = 0;
		            }
		        }
		        if (dataLength >= this.blockSize) {
		            dataPos = hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
		            dataLength %= this.blockSize;
		        }
		        while (dataLength > 0) {
		            this._buffer[this._bufferLength++] = data[dataPos++];
		            dataLength--;
		        }
		        return this;
		    };
		    /**
		     * Finalizes hash state and puts hash into out.
		     * If hash was already finalized, puts the same value.
		     */
		    SHA512.prototype.finish = function (out) {
		        if (!this._finished) {
		            var bytesHashed = this._bytesHashed;
		            var left = this._bufferLength;
		            var bitLenHi = (bytesHashed / 0x20000000) | 0;
		            var bitLenLo = bytesHashed << 3;
		            var padLength = (bytesHashed % 128 < 112) ? 128 : 256;
		            this._buffer[left] = 0x80;
		            for (var i = left + 1; i < padLength - 8; i++) {
		                this._buffer[i] = 0;
		            }
		            binary_1.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
		            binary_1.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
		            hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
		            this._finished = true;
		        }
		        for (var i = 0; i < this.digestLength / 8; i++) {
		            binary_1.writeUint32BE(this._stateHi[i], out, i * 8);
		            binary_1.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
		        }
		        return this;
		    };
		    /**
		     * Returns the final hash digest.
		     */
		    SHA512.prototype.digest = function () {
		        var out = new Uint8Array(this.digestLength);
		        this.finish(out);
		        return out;
		    };
		    /**
		     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
		     * used with restoreState(). Only chain value is saved, not buffers or
		     * other state variables.
		     */
		    SHA512.prototype.saveState = function () {
		        if (this._finished) {
		            throw new Error("SHA256: cannot save finished state");
		        }
		        return {
		            stateHi: new Int32Array(this._stateHi),
		            stateLo: new Int32Array(this._stateLo),
		            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
		            bufferLength: this._bufferLength,
		            bytesHashed: this._bytesHashed
		        };
		    };
		    /**
		     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
		     * saveState() and sets bytesHashed to the given value.
		     */
		    SHA512.prototype.restoreState = function (savedState) {
		        this._stateHi.set(savedState.stateHi);
		        this._stateLo.set(savedState.stateLo);
		        this._bufferLength = savedState.bufferLength;
		        if (savedState.buffer) {
		            this._buffer.set(savedState.buffer);
		        }
		        this._bytesHashed = savedState.bytesHashed;
		        this._finished = false;
		        return this;
		    };
		    /**
		     * Cleans state returned by saveState().
		     */
		    SHA512.prototype.cleanSavedState = function (savedState) {
		        wipe_1.wipe(savedState.stateHi);
		        wipe_1.wipe(savedState.stateLo);
		        if (savedState.buffer) {
		            wipe_1.wipe(savedState.buffer);
		        }
		        savedState.bufferLength = 0;
		        savedState.bytesHashed = 0;
		    };
		    return SHA512;
		}());
		exports.SHA512 = SHA512;
		// Constants
		var K = new Int32Array([
		    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
		    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
		    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
		    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
		    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
		    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
		    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
		    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
		    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
		    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
		    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
		    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
		    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
		    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
		    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
		    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
		    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
		    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
		    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
		    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
		    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
		    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
		    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
		    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
		    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
		    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
		    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
		    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
		    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
		    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
		    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
		    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
		    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
		    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
		    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
		    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
		    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
		    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
		    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
		    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
		]);
		function hashBlocks(wh, wl, hh, hl, m, pos, len) {
		    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
		    var h, l;
		    var th, tl;
		    var a, b, c, d;
		    while (len >= 128) {
		        for (var i = 0; i < 16; i++) {
		            var j = 8 * i + pos;
		            wh[i] = binary_1.readUint32BE(m, j);
		            wl[i] = binary_1.readUint32BE(m, j + 4);
		        }
		        for (var i = 0; i < 80; i++) {
		            var bh0 = ah0;
		            var bh1 = ah1;
		            var bh2 = ah2;
		            var bh3 = ah3;
		            var bh4 = ah4;
		            var bh5 = ah5;
		            var bh6 = ah6;
		            var bh7 = ah7;
		            var bl0 = al0;
		            var bl1 = al1;
		            var bl2 = al2;
		            var bl3 = al3;
		            var bl4 = al4;
		            var bl5 = al5;
		            var bl6 = al6;
		            var bl7 = al7;
		            // add
		            h = ah7;
		            l = al7;
		            a = l & 0xffff;
		            b = l >>> 16;
		            c = h & 0xffff;
		            d = h >>> 16;
		            // Sigma1
		            h = ((ah4 >>> 14) | (al4 << (32 - 14))) ^ ((ah4 >>> 18) |
		                (al4 << (32 - 18))) ^ ((al4 >>> (41 - 32)) | (ah4 << (32 - (41 - 32))));
		            l = ((al4 >>> 14) | (ah4 << (32 - 14))) ^ ((al4 >>> 18) |
		                (ah4 << (32 - 18))) ^ ((ah4 >>> (41 - 32)) | (al4 << (32 - (41 - 32))));
		            a += l & 0xffff;
		            b += l >>> 16;
		            c += h & 0xffff;
		            d += h >>> 16;
		            // Ch
		            h = (ah4 & ah5) ^ (~ah4 & ah6);
		            l = (al4 & al5) ^ (~al4 & al6);
		            a += l & 0xffff;
		            b += l >>> 16;
		            c += h & 0xffff;
		            d += h >>> 16;
		            // K
		            h = K[i * 2];
		            l = K[i * 2 + 1];
		            a += l & 0xffff;
		            b += l >>> 16;
		            c += h & 0xffff;
		            d += h >>> 16;
		            // w
		            h = wh[i % 16];
		            l = wl[i % 16];
		            a += l & 0xffff;
		            b += l >>> 16;
		            c += h & 0xffff;
		            d += h >>> 16;
		            b += a >>> 16;
		            c += b >>> 16;
		            d += c >>> 16;
		            th = c & 0xffff | d << 16;
		            tl = a & 0xffff | b << 16;
		            // add
		            h = th;
		            l = tl;
		            a = l & 0xffff;
		            b = l >>> 16;
		            c = h & 0xffff;
		            d = h >>> 16;
		            // Sigma0
		            h = ((ah0 >>> 28) | (al0 << (32 - 28))) ^ ((al0 >>> (34 - 32)) |
		                (ah0 << (32 - (34 - 32)))) ^ ((al0 >>> (39 - 32)) | (ah0 << (32 - (39 - 32))));
		            l = ((al0 >>> 28) | (ah0 << (32 - 28))) ^ ((ah0 >>> (34 - 32)) |
		                (al0 << (32 - (34 - 32)))) ^ ((ah0 >>> (39 - 32)) | (al0 << (32 - (39 - 32))));
		            a += l & 0xffff;
		            b += l >>> 16;
		            c += h & 0xffff;
		            d += h >>> 16;
		            // Maj
		            h = (ah0 & ah1) ^ (ah0 & ah2) ^ (ah1 & ah2);
		            l = (al0 & al1) ^ (al0 & al2) ^ (al1 & al2);
		            a += l & 0xffff;
		            b += l >>> 16;
		            c += h & 0xffff;
		            d += h >>> 16;
		            b += a >>> 16;
		            c += b >>> 16;
		            d += c >>> 16;
		            bh7 = (c & 0xffff) | (d << 16);
		            bl7 = (a & 0xffff) | (b << 16);
		            // add
		            h = bh3;
		            l = bl3;
		            a = l & 0xffff;
		            b = l >>> 16;
		            c = h & 0xffff;
		            d = h >>> 16;
		            h = th;
		            l = tl;
		            a += l & 0xffff;
		            b += l >>> 16;
		            c += h & 0xffff;
		            d += h >>> 16;
		            b += a >>> 16;
		            c += b >>> 16;
		            d += c >>> 16;
		            bh3 = (c & 0xffff) | (d << 16);
		            bl3 = (a & 0xffff) | (b << 16);
		            ah1 = bh0;
		            ah2 = bh1;
		            ah3 = bh2;
		            ah4 = bh3;
		            ah5 = bh4;
		            ah6 = bh5;
		            ah7 = bh6;
		            ah0 = bh7;
		            al1 = bl0;
		            al2 = bl1;
		            al3 = bl2;
		            al4 = bl3;
		            al5 = bl4;
		            al6 = bl5;
		            al7 = bl6;
		            al0 = bl7;
		            if (i % 16 === 15) {
		                for (var j = 0; j < 16; j++) {
		                    // add
		                    h = wh[j];
		                    l = wl[j];
		                    a = l & 0xffff;
		                    b = l >>> 16;
		                    c = h & 0xffff;
		                    d = h >>> 16;
		                    h = wh[(j + 9) % 16];
		                    l = wl[(j + 9) % 16];
		                    a += l & 0xffff;
		                    b += l >>> 16;
		                    c += h & 0xffff;
		                    d += h >>> 16;
		                    // sigma0
		                    th = wh[(j + 1) % 16];
		                    tl = wl[(j + 1) % 16];
		                    h = ((th >>> 1) | (tl << (32 - 1))) ^ ((th >>> 8) |
		                        (tl << (32 - 8))) ^ (th >>> 7);
		                    l = ((tl >>> 1) | (th << (32 - 1))) ^ ((tl >>> 8) |
		                        (th << (32 - 8))) ^ ((tl >>> 7) | (th << (32 - 7)));
		                    a += l & 0xffff;
		                    b += l >>> 16;
		                    c += h & 0xffff;
		                    d += h >>> 16;
		                    // sigma1
		                    th = wh[(j + 14) % 16];
		                    tl = wl[(j + 14) % 16];
		                    h = ((th >>> 19) | (tl << (32 - 19))) ^ ((tl >>> (61 - 32)) |
		                        (th << (32 - (61 - 32)))) ^ (th >>> 6);
		                    l = ((tl >>> 19) | (th << (32 - 19))) ^ ((th >>> (61 - 32)) |
		                        (tl << (32 - (61 - 32)))) ^ ((tl >>> 6) | (th << (32 - 6)));
		                    a += l & 0xffff;
		                    b += l >>> 16;
		                    c += h & 0xffff;
		                    d += h >>> 16;
		                    b += a >>> 16;
		                    c += b >>> 16;
		                    d += c >>> 16;
		                    wh[j] = (c & 0xffff) | (d << 16);
		                    wl[j] = (a & 0xffff) | (b << 16);
		                }
		            }
		        }
		        // add
		        h = ah0;
		        l = al0;
		        a = l & 0xffff;
		        b = l >>> 16;
		        c = h & 0xffff;
		        d = h >>> 16;
		        h = hh[0];
		        l = hl[0];
		        a += l & 0xffff;
		        b += l >>> 16;
		        c += h & 0xffff;
		        d += h >>> 16;
		        b += a >>> 16;
		        c += b >>> 16;
		        d += c >>> 16;
		        hh[0] = ah0 = (c & 0xffff) | (d << 16);
		        hl[0] = al0 = (a & 0xffff) | (b << 16);
		        h = ah1;
		        l = al1;
		        a = l & 0xffff;
		        b = l >>> 16;
		        c = h & 0xffff;
		        d = h >>> 16;
		        h = hh[1];
		        l = hl[1];
		        a += l & 0xffff;
		        b += l >>> 16;
		        c += h & 0xffff;
		        d += h >>> 16;
		        b += a >>> 16;
		        c += b >>> 16;
		        d += c >>> 16;
		        hh[1] = ah1 = (c & 0xffff) | (d << 16);
		        hl[1] = al1 = (a & 0xffff) | (b << 16);
		        h = ah2;
		        l = al2;
		        a = l & 0xffff;
		        b = l >>> 16;
		        c = h & 0xffff;
		        d = h >>> 16;
		        h = hh[2];
		        l = hl[2];
		        a += l & 0xffff;
		        b += l >>> 16;
		        c += h & 0xffff;
		        d += h >>> 16;
		        b += a >>> 16;
		        c += b >>> 16;
		        d += c >>> 16;
		        hh[2] = ah2 = (c & 0xffff) | (d << 16);
		        hl[2] = al2 = (a & 0xffff) | (b << 16);
		        h = ah3;
		        l = al3;
		        a = l & 0xffff;
		        b = l >>> 16;
		        c = h & 0xffff;
		        d = h >>> 16;
		        h = hh[3];
		        l = hl[3];
		        a += l & 0xffff;
		        b += l >>> 16;
		        c += h & 0xffff;
		        d += h >>> 16;
		        b += a >>> 16;
		        c += b >>> 16;
		        d += c >>> 16;
		        hh[3] = ah3 = (c & 0xffff) | (d << 16);
		        hl[3] = al3 = (a & 0xffff) | (b << 16);
		        h = ah4;
		        l = al4;
		        a = l & 0xffff;
		        b = l >>> 16;
		        c = h & 0xffff;
		        d = h >>> 16;
		        h = hh[4];
		        l = hl[4];
		        a += l & 0xffff;
		        b += l >>> 16;
		        c += h & 0xffff;
		        d += h >>> 16;
		        b += a >>> 16;
		        c += b >>> 16;
		        d += c >>> 16;
		        hh[4] = ah4 = (c & 0xffff) | (d << 16);
		        hl[4] = al4 = (a & 0xffff) | (b << 16);
		        h = ah5;
		        l = al5;
		        a = l & 0xffff;
		        b = l >>> 16;
		        c = h & 0xffff;
		        d = h >>> 16;
		        h = hh[5];
		        l = hl[5];
		        a += l & 0xffff;
		        b += l >>> 16;
		        c += h & 0xffff;
		        d += h >>> 16;
		        b += a >>> 16;
		        c += b >>> 16;
		        d += c >>> 16;
		        hh[5] = ah5 = (c & 0xffff) | (d << 16);
		        hl[5] = al5 = (a & 0xffff) | (b << 16);
		        h = ah6;
		        l = al6;
		        a = l & 0xffff;
		        b = l >>> 16;
		        c = h & 0xffff;
		        d = h >>> 16;
		        h = hh[6];
		        l = hl[6];
		        a += l & 0xffff;
		        b += l >>> 16;
		        c += h & 0xffff;
		        d += h >>> 16;
		        b += a >>> 16;
		        c += b >>> 16;
		        d += c >>> 16;
		        hh[6] = ah6 = (c & 0xffff) | (d << 16);
		        hl[6] = al6 = (a & 0xffff) | (b << 16);
		        h = ah7;
		        l = al7;
		        a = l & 0xffff;
		        b = l >>> 16;
		        c = h & 0xffff;
		        d = h >>> 16;
		        h = hh[7];
		        l = hl[7];
		        a += l & 0xffff;
		        b += l >>> 16;
		        c += h & 0xffff;
		        d += h >>> 16;
		        b += a >>> 16;
		        c += b >>> 16;
		        d += c >>> 16;
		        hh[7] = ah7 = (c & 0xffff) | (d << 16);
		        hl[7] = al7 = (a & 0xffff) | (b << 16);
		        pos += 128;
		        len -= 128;
		    }
		    return pos;
		}
		function hash(data) {
		    var h = new SHA512();
		    h.update(data);
		    var digest = h.digest();
		    h.clean();
		    return digest;
		}
		exports.hash = hash;
		
	} (sha512));

	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.convertSecretKeyToX25519 = exports.convertPublicKeyToX25519 = exports.verify = exports.sign = exports.extractPublicKeyFromSecretKey = exports.generateKeyPair = exports.generateKeyPairFromSeed = exports.SEED_LENGTH = exports.SECRET_KEY_LENGTH = exports.PUBLIC_KEY_LENGTH = exports.SIGNATURE_LENGTH = void 0;
		/**
		 * Package ed25519 implements Ed25519 public-key signature algorithm.
		 */
		const random_1 = random;
		const sha512_1 = sha512;
		const wipe_1 = wipe$1;
		exports.SIGNATURE_LENGTH = 64;
		exports.PUBLIC_KEY_LENGTH = 32;
		exports.SECRET_KEY_LENGTH = 64;
		exports.SEED_LENGTH = 32;
		// Returns new zero-filled 16-element GF (Float64Array).
		// If passed an array of numbers, prefills the returned
		// array with them.
		//
		// We use Float64Array, because we need 48-bit numbers
		// for this implementation.
		function gf(init) {
		    const r = new Float64Array(16);
		    if (init) {
		        for (let i = 0; i < init.length; i++) {
		            r[i] = init[i];
		        }
		    }
		    return r;
		}
		// Base point.
		const _9 = new Uint8Array(32);
		_9[0] = 9;
		const gf0 = gf();
		const gf1 = gf([1]);
		const D = gf([
		    0x78a3, 0x1359, 0x4dca, 0x75eb, 0xd8ab, 0x4141, 0x0a4d, 0x0070,
		    0xe898, 0x7779, 0x4079, 0x8cc7, 0xfe73, 0x2b6f, 0x6cee, 0x5203
		]);
		const D2 = gf([
		    0xf159, 0x26b2, 0x9b94, 0xebd6, 0xb156, 0x8283, 0x149a, 0x00e0,
		    0xd130, 0xeef3, 0x80f2, 0x198e, 0xfce7, 0x56df, 0xd9dc, 0x2406
		]);
		const X = gf([
		    0xd51a, 0x8f25, 0x2d60, 0xc956, 0xa7b2, 0x9525, 0xc760, 0x692c,
		    0xdc5c, 0xfdd6, 0xe231, 0xc0a4, 0x53fe, 0xcd6e, 0x36d3, 0x2169
		]);
		const Y = gf([
		    0x6658, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666,
		    0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666
		]);
		const I = gf([
		    0xa0b0, 0x4a0e, 0x1b27, 0xc4ee, 0xe478, 0xad2f, 0x1806, 0x2f43,
		    0xd7a7, 0x3dfb, 0x0099, 0x2b4d, 0xdf0b, 0x4fc1, 0x2480, 0x2b83
		]);
		function set25519(r, a) {
		    for (let i = 0; i < 16; i++) {
		        r[i] = a[i] | 0;
		    }
		}
		function car25519(o) {
		    let c = 1;
		    for (let i = 0; i < 16; i++) {
		        let v = o[i] + c + 65535;
		        c = Math.floor(v / 65536);
		        o[i] = v - c * 65536;
		    }
		    o[0] += c - 1 + 37 * (c - 1);
		}
		function sel25519(p, q, b) {
		    const c = ~(b - 1);
		    for (let i = 0; i < 16; i++) {
		        const t = c & (p[i] ^ q[i]);
		        p[i] ^= t;
		        q[i] ^= t;
		    }
		}
		function pack25519(o, n) {
		    const m = gf();
		    const t = gf();
		    for (let i = 0; i < 16; i++) {
		        t[i] = n[i];
		    }
		    car25519(t);
		    car25519(t);
		    car25519(t);
		    for (let j = 0; j < 2; j++) {
		        m[0] = t[0] - 0xffed;
		        for (let i = 1; i < 15; i++) {
		            m[i] = t[i] - 0xffff - ((m[i - 1] >> 16) & 1);
		            m[i - 1] &= 0xffff;
		        }
		        m[15] = t[15] - 0x7fff - ((m[14] >> 16) & 1);
		        const b = (m[15] >> 16) & 1;
		        m[14] &= 0xffff;
		        sel25519(t, m, 1 - b);
		    }
		    for (let i = 0; i < 16; i++) {
		        o[2 * i] = t[i] & 0xff;
		        o[2 * i + 1] = t[i] >> 8;
		    }
		}
		function verify32(x, y) {
		    let d = 0;
		    for (let i = 0; i < 32; i++) {
		        d |= x[i] ^ y[i];
		    }
		    return (1 & ((d - 1) >>> 8)) - 1;
		}
		function neq25519(a, b) {
		    const c = new Uint8Array(32);
		    const d = new Uint8Array(32);
		    pack25519(c, a);
		    pack25519(d, b);
		    return verify32(c, d);
		}
		function par25519(a) {
		    const d = new Uint8Array(32);
		    pack25519(d, a);
		    return d[0] & 1;
		}
		function unpack25519(o, n) {
		    for (let i = 0; i < 16; i++) {
		        o[i] = n[2 * i] + (n[2 * i + 1] << 8);
		    }
		    o[15] &= 0x7fff;
		}
		function add(o, a, b) {
		    for (let i = 0; i < 16; i++) {
		        o[i] = a[i] + b[i];
		    }
		}
		function sub(o, a, b) {
		    for (let i = 0; i < 16; i++) {
		        o[i] = a[i] - b[i];
		    }
		}
		function mul(o, a, b) {
		    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
		    v = a[0];
		    t0 += v * b0;
		    t1 += v * b1;
		    t2 += v * b2;
		    t3 += v * b3;
		    t4 += v * b4;
		    t5 += v * b5;
		    t6 += v * b6;
		    t7 += v * b7;
		    t8 += v * b8;
		    t9 += v * b9;
		    t10 += v * b10;
		    t11 += v * b11;
		    t12 += v * b12;
		    t13 += v * b13;
		    t14 += v * b14;
		    t15 += v * b15;
		    v = a[1];
		    t1 += v * b0;
		    t2 += v * b1;
		    t3 += v * b2;
		    t4 += v * b3;
		    t5 += v * b4;
		    t6 += v * b5;
		    t7 += v * b6;
		    t8 += v * b7;
		    t9 += v * b8;
		    t10 += v * b9;
		    t11 += v * b10;
		    t12 += v * b11;
		    t13 += v * b12;
		    t14 += v * b13;
		    t15 += v * b14;
		    t16 += v * b15;
		    v = a[2];
		    t2 += v * b0;
		    t3 += v * b1;
		    t4 += v * b2;
		    t5 += v * b3;
		    t6 += v * b4;
		    t7 += v * b5;
		    t8 += v * b6;
		    t9 += v * b7;
		    t10 += v * b8;
		    t11 += v * b9;
		    t12 += v * b10;
		    t13 += v * b11;
		    t14 += v * b12;
		    t15 += v * b13;
		    t16 += v * b14;
		    t17 += v * b15;
		    v = a[3];
		    t3 += v * b0;
		    t4 += v * b1;
		    t5 += v * b2;
		    t6 += v * b3;
		    t7 += v * b4;
		    t8 += v * b5;
		    t9 += v * b6;
		    t10 += v * b7;
		    t11 += v * b8;
		    t12 += v * b9;
		    t13 += v * b10;
		    t14 += v * b11;
		    t15 += v * b12;
		    t16 += v * b13;
		    t17 += v * b14;
		    t18 += v * b15;
		    v = a[4];
		    t4 += v * b0;
		    t5 += v * b1;
		    t6 += v * b2;
		    t7 += v * b3;
		    t8 += v * b4;
		    t9 += v * b5;
		    t10 += v * b6;
		    t11 += v * b7;
		    t12 += v * b8;
		    t13 += v * b9;
		    t14 += v * b10;
		    t15 += v * b11;
		    t16 += v * b12;
		    t17 += v * b13;
		    t18 += v * b14;
		    t19 += v * b15;
		    v = a[5];
		    t5 += v * b0;
		    t6 += v * b1;
		    t7 += v * b2;
		    t8 += v * b3;
		    t9 += v * b4;
		    t10 += v * b5;
		    t11 += v * b6;
		    t12 += v * b7;
		    t13 += v * b8;
		    t14 += v * b9;
		    t15 += v * b10;
		    t16 += v * b11;
		    t17 += v * b12;
		    t18 += v * b13;
		    t19 += v * b14;
		    t20 += v * b15;
		    v = a[6];
		    t6 += v * b0;
		    t7 += v * b1;
		    t8 += v * b2;
		    t9 += v * b3;
		    t10 += v * b4;
		    t11 += v * b5;
		    t12 += v * b6;
		    t13 += v * b7;
		    t14 += v * b8;
		    t15 += v * b9;
		    t16 += v * b10;
		    t17 += v * b11;
		    t18 += v * b12;
		    t19 += v * b13;
		    t20 += v * b14;
		    t21 += v * b15;
		    v = a[7];
		    t7 += v * b0;
		    t8 += v * b1;
		    t9 += v * b2;
		    t10 += v * b3;
		    t11 += v * b4;
		    t12 += v * b5;
		    t13 += v * b6;
		    t14 += v * b7;
		    t15 += v * b8;
		    t16 += v * b9;
		    t17 += v * b10;
		    t18 += v * b11;
		    t19 += v * b12;
		    t20 += v * b13;
		    t21 += v * b14;
		    t22 += v * b15;
		    v = a[8];
		    t8 += v * b0;
		    t9 += v * b1;
		    t10 += v * b2;
		    t11 += v * b3;
		    t12 += v * b4;
		    t13 += v * b5;
		    t14 += v * b6;
		    t15 += v * b7;
		    t16 += v * b8;
		    t17 += v * b9;
		    t18 += v * b10;
		    t19 += v * b11;
		    t20 += v * b12;
		    t21 += v * b13;
		    t22 += v * b14;
		    t23 += v * b15;
		    v = a[9];
		    t9 += v * b0;
		    t10 += v * b1;
		    t11 += v * b2;
		    t12 += v * b3;
		    t13 += v * b4;
		    t14 += v * b5;
		    t15 += v * b6;
		    t16 += v * b7;
		    t17 += v * b8;
		    t18 += v * b9;
		    t19 += v * b10;
		    t20 += v * b11;
		    t21 += v * b12;
		    t22 += v * b13;
		    t23 += v * b14;
		    t24 += v * b15;
		    v = a[10];
		    t10 += v * b0;
		    t11 += v * b1;
		    t12 += v * b2;
		    t13 += v * b3;
		    t14 += v * b4;
		    t15 += v * b5;
		    t16 += v * b6;
		    t17 += v * b7;
		    t18 += v * b8;
		    t19 += v * b9;
		    t20 += v * b10;
		    t21 += v * b11;
		    t22 += v * b12;
		    t23 += v * b13;
		    t24 += v * b14;
		    t25 += v * b15;
		    v = a[11];
		    t11 += v * b0;
		    t12 += v * b1;
		    t13 += v * b2;
		    t14 += v * b3;
		    t15 += v * b4;
		    t16 += v * b5;
		    t17 += v * b6;
		    t18 += v * b7;
		    t19 += v * b8;
		    t20 += v * b9;
		    t21 += v * b10;
		    t22 += v * b11;
		    t23 += v * b12;
		    t24 += v * b13;
		    t25 += v * b14;
		    t26 += v * b15;
		    v = a[12];
		    t12 += v * b0;
		    t13 += v * b1;
		    t14 += v * b2;
		    t15 += v * b3;
		    t16 += v * b4;
		    t17 += v * b5;
		    t18 += v * b6;
		    t19 += v * b7;
		    t20 += v * b8;
		    t21 += v * b9;
		    t22 += v * b10;
		    t23 += v * b11;
		    t24 += v * b12;
		    t25 += v * b13;
		    t26 += v * b14;
		    t27 += v * b15;
		    v = a[13];
		    t13 += v * b0;
		    t14 += v * b1;
		    t15 += v * b2;
		    t16 += v * b3;
		    t17 += v * b4;
		    t18 += v * b5;
		    t19 += v * b6;
		    t20 += v * b7;
		    t21 += v * b8;
		    t22 += v * b9;
		    t23 += v * b10;
		    t24 += v * b11;
		    t25 += v * b12;
		    t26 += v * b13;
		    t27 += v * b14;
		    t28 += v * b15;
		    v = a[14];
		    t14 += v * b0;
		    t15 += v * b1;
		    t16 += v * b2;
		    t17 += v * b3;
		    t18 += v * b4;
		    t19 += v * b5;
		    t20 += v * b6;
		    t21 += v * b7;
		    t22 += v * b8;
		    t23 += v * b9;
		    t24 += v * b10;
		    t25 += v * b11;
		    t26 += v * b12;
		    t27 += v * b13;
		    t28 += v * b14;
		    t29 += v * b15;
		    v = a[15];
		    t15 += v * b0;
		    t16 += v * b1;
		    t17 += v * b2;
		    t18 += v * b3;
		    t19 += v * b4;
		    t20 += v * b5;
		    t21 += v * b6;
		    t22 += v * b7;
		    t23 += v * b8;
		    t24 += v * b9;
		    t25 += v * b10;
		    t26 += v * b11;
		    t27 += v * b12;
		    t28 += v * b13;
		    t29 += v * b14;
		    t30 += v * b15;
		    t0 += 38 * t16;
		    t1 += 38 * t17;
		    t2 += 38 * t18;
		    t3 += 38 * t19;
		    t4 += 38 * t20;
		    t5 += 38 * t21;
		    t6 += 38 * t22;
		    t7 += 38 * t23;
		    t8 += 38 * t24;
		    t9 += 38 * t25;
		    t10 += 38 * t26;
		    t11 += 38 * t27;
		    t12 += 38 * t28;
		    t13 += 38 * t29;
		    t14 += 38 * t30;
		    // t15 left as is
		    // first car
		    c = 1;
		    v = t0 + c + 65535;
		    c = Math.floor(v / 65536);
		    t0 = v - c * 65536;
		    v = t1 + c + 65535;
		    c = Math.floor(v / 65536);
		    t1 = v - c * 65536;
		    v = t2 + c + 65535;
		    c = Math.floor(v / 65536);
		    t2 = v - c * 65536;
		    v = t3 + c + 65535;
		    c = Math.floor(v / 65536);
		    t3 = v - c * 65536;
		    v = t4 + c + 65535;
		    c = Math.floor(v / 65536);
		    t4 = v - c * 65536;
		    v = t5 + c + 65535;
		    c = Math.floor(v / 65536);
		    t5 = v - c * 65536;
		    v = t6 + c + 65535;
		    c = Math.floor(v / 65536);
		    t6 = v - c * 65536;
		    v = t7 + c + 65535;
		    c = Math.floor(v / 65536);
		    t7 = v - c * 65536;
		    v = t8 + c + 65535;
		    c = Math.floor(v / 65536);
		    t8 = v - c * 65536;
		    v = t9 + c + 65535;
		    c = Math.floor(v / 65536);
		    t9 = v - c * 65536;
		    v = t10 + c + 65535;
		    c = Math.floor(v / 65536);
		    t10 = v - c * 65536;
		    v = t11 + c + 65535;
		    c = Math.floor(v / 65536);
		    t11 = v - c * 65536;
		    v = t12 + c + 65535;
		    c = Math.floor(v / 65536);
		    t12 = v - c * 65536;
		    v = t13 + c + 65535;
		    c = Math.floor(v / 65536);
		    t13 = v - c * 65536;
		    v = t14 + c + 65535;
		    c = Math.floor(v / 65536);
		    t14 = v - c * 65536;
		    v = t15 + c + 65535;
		    c = Math.floor(v / 65536);
		    t15 = v - c * 65536;
		    t0 += c - 1 + 37 * (c - 1);
		    // second car
		    c = 1;
		    v = t0 + c + 65535;
		    c = Math.floor(v / 65536);
		    t0 = v - c * 65536;
		    v = t1 + c + 65535;
		    c = Math.floor(v / 65536);
		    t1 = v - c * 65536;
		    v = t2 + c + 65535;
		    c = Math.floor(v / 65536);
		    t2 = v - c * 65536;
		    v = t3 + c + 65535;
		    c = Math.floor(v / 65536);
		    t3 = v - c * 65536;
		    v = t4 + c + 65535;
		    c = Math.floor(v / 65536);
		    t4 = v - c * 65536;
		    v = t5 + c + 65535;
		    c = Math.floor(v / 65536);
		    t5 = v - c * 65536;
		    v = t6 + c + 65535;
		    c = Math.floor(v / 65536);
		    t6 = v - c * 65536;
		    v = t7 + c + 65535;
		    c = Math.floor(v / 65536);
		    t7 = v - c * 65536;
		    v = t8 + c + 65535;
		    c = Math.floor(v / 65536);
		    t8 = v - c * 65536;
		    v = t9 + c + 65535;
		    c = Math.floor(v / 65536);
		    t9 = v - c * 65536;
		    v = t10 + c + 65535;
		    c = Math.floor(v / 65536);
		    t10 = v - c * 65536;
		    v = t11 + c + 65535;
		    c = Math.floor(v / 65536);
		    t11 = v - c * 65536;
		    v = t12 + c + 65535;
		    c = Math.floor(v / 65536);
		    t12 = v - c * 65536;
		    v = t13 + c + 65535;
		    c = Math.floor(v / 65536);
		    t13 = v - c * 65536;
		    v = t14 + c + 65535;
		    c = Math.floor(v / 65536);
		    t14 = v - c * 65536;
		    v = t15 + c + 65535;
		    c = Math.floor(v / 65536);
		    t15 = v - c * 65536;
		    t0 += c - 1 + 37 * (c - 1);
		    o[0] = t0;
		    o[1] = t1;
		    o[2] = t2;
		    o[3] = t3;
		    o[4] = t4;
		    o[5] = t5;
		    o[6] = t6;
		    o[7] = t7;
		    o[8] = t8;
		    o[9] = t9;
		    o[10] = t10;
		    o[11] = t11;
		    o[12] = t12;
		    o[13] = t13;
		    o[14] = t14;
		    o[15] = t15;
		}
		function square(o, a) {
		    mul(o, a, a);
		}
		function inv25519(o, i) {
		    const c = gf();
		    let a;
		    for (a = 0; a < 16; a++) {
		        c[a] = i[a];
		    }
		    for (a = 253; a >= 0; a--) {
		        square(c, c);
		        if (a !== 2 && a !== 4) {
		            mul(c, c, i);
		        }
		    }
		    for (a = 0; a < 16; a++) {
		        o[a] = c[a];
		    }
		}
		function pow2523(o, i) {
		    const c = gf();
		    let a;
		    for (a = 0; a < 16; a++) {
		        c[a] = i[a];
		    }
		    for (a = 250; a >= 0; a--) {
		        square(c, c);
		        if (a !== 1) {
		            mul(c, c, i);
		        }
		    }
		    for (a = 0; a < 16; a++) {
		        o[a] = c[a];
		    }
		}
		function edadd(p, q) {
		    const a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
		    sub(a, p[1], p[0]);
		    sub(t, q[1], q[0]);
		    mul(a, a, t);
		    add(b, p[0], p[1]);
		    add(t, q[0], q[1]);
		    mul(b, b, t);
		    mul(c, p[3], q[3]);
		    mul(c, c, D2);
		    mul(d, p[2], q[2]);
		    add(d, d, d);
		    sub(e, b, a);
		    sub(f, d, c);
		    add(g, d, c);
		    add(h, b, a);
		    mul(p[0], e, f);
		    mul(p[1], h, g);
		    mul(p[2], g, f);
		    mul(p[3], e, h);
		}
		function cswap(p, q, b) {
		    for (let i = 0; i < 4; i++) {
		        sel25519(p[i], q[i], b);
		    }
		}
		function pack(r, p) {
		    const tx = gf(), ty = gf(), zi = gf();
		    inv25519(zi, p[2]);
		    mul(tx, p[0], zi);
		    mul(ty, p[1], zi);
		    pack25519(r, ty);
		    r[31] ^= par25519(tx) << 7;
		}
		function scalarmult(p, q, s) {
		    set25519(p[0], gf0);
		    set25519(p[1], gf1);
		    set25519(p[2], gf1);
		    set25519(p[3], gf0);
		    for (let i = 255; i >= 0; --i) {
		        const b = (s[(i / 8) | 0] >> (i & 7)) & 1;
		        cswap(p, q, b);
		        edadd(q, p);
		        edadd(p, p);
		        cswap(p, q, b);
		    }
		}
		function scalarbase(p, s) {
		    const q = [gf(), gf(), gf(), gf()];
		    set25519(q[0], X);
		    set25519(q[1], Y);
		    set25519(q[2], gf1);
		    mul(q[3], X, Y);
		    scalarmult(p, q, s);
		}
		// Generates key pair from secret 32-byte seed.
		function generateKeyPairFromSeed(seed) {
		    if (seed.length !== exports.SEED_LENGTH) {
		        throw new Error(`ed25519: seed must be ${exports.SEED_LENGTH} bytes`);
		    }
		    const d = (0, sha512_1.hash)(seed);
		    d[0] &= 248;
		    d[31] &= 127;
		    d[31] |= 64;
		    const publicKey = new Uint8Array(32);
		    const p = [gf(), gf(), gf(), gf()];
		    scalarbase(p, d);
		    pack(publicKey, p);
		    const secretKey = new Uint8Array(64);
		    secretKey.set(seed);
		    secretKey.set(publicKey, 32);
		    return {
		        publicKey,
		        secretKey
		    };
		}
		exports.generateKeyPairFromSeed = generateKeyPairFromSeed;
		function generateKeyPair(prng) {
		    const seed = (0, random_1.randomBytes)(32, prng);
		    const result = generateKeyPairFromSeed(seed);
		    (0, wipe_1.wipe)(seed);
		    return result;
		}
		exports.generateKeyPair = generateKeyPair;
		function extractPublicKeyFromSecretKey(secretKey) {
		    if (secretKey.length !== exports.SECRET_KEY_LENGTH) {
		        throw new Error(`ed25519: secret key must be ${exports.SECRET_KEY_LENGTH} bytes`);
		    }
		    return new Uint8Array(secretKey.subarray(32));
		}
		exports.extractPublicKeyFromSecretKey = extractPublicKeyFromSecretKey;
		const L = new Float64Array([
		    0xed, 0xd3, 0xf5, 0x5c, 0x1a, 0x63, 0x12, 0x58, 0xd6, 0x9c, 0xf7, 0xa2,
		    0xde, 0xf9, 0xde, 0x14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x10
		]);
		function modL(r, x) {
		    let carry;
		    let i;
		    let j;
		    let k;
		    for (i = 63; i >= 32; --i) {
		        carry = 0;
		        for (j = i - 32, k = i - 12; j < k; ++j) {
		            x[j] += carry - 16 * x[i] * L[j - (i - 32)];
		            carry = Math.floor((x[j] + 128) / 256);
		            x[j] -= carry * 256;
		        }
		        x[j] += carry;
		        x[i] = 0;
		    }
		    carry = 0;
		    for (j = 0; j < 32; j++) {
		        x[j] += carry - (x[31] >> 4) * L[j];
		        carry = x[j] >> 8;
		        x[j] &= 255;
		    }
		    for (j = 0; j < 32; j++) {
		        x[j] -= carry * L[j];
		    }
		    for (i = 0; i < 32; i++) {
		        x[i + 1] += x[i] >> 8;
		        r[i] = x[i] & 255;
		    }
		}
		function reduce(r) {
		    const x = new Float64Array(64);
		    for (let i = 0; i < 64; i++) {
		        x[i] = r[i];
		    }
		    for (let i = 0; i < 64; i++) {
		        r[i] = 0;
		    }
		    modL(r, x);
		}
		// Returns 64-byte signature of the message under the 64-byte secret key.
		function sign(secretKey, message) {
		    const x = new Float64Array(64);
		    const p = [gf(), gf(), gf(), gf()];
		    const d = (0, sha512_1.hash)(secretKey.subarray(0, 32));
		    d[0] &= 248;
		    d[31] &= 127;
		    d[31] |= 64;
		    const signature = new Uint8Array(64);
		    signature.set(d.subarray(32), 32);
		    const hs = new sha512_1.SHA512();
		    hs.update(signature.subarray(32));
		    hs.update(message);
		    const r = hs.digest();
		    hs.clean();
		    reduce(r);
		    scalarbase(p, r);
		    pack(signature, p);
		    hs.reset();
		    hs.update(signature.subarray(0, 32));
		    hs.update(secretKey.subarray(32));
		    hs.update(message);
		    const h = hs.digest();
		    reduce(h);
		    for (let i = 0; i < 32; i++) {
		        x[i] = r[i];
		    }
		    for (let i = 0; i < 32; i++) {
		        for (let j = 0; j < 32; j++) {
		            x[i + j] += h[i] * d[j];
		        }
		    }
		    modL(signature.subarray(32), x);
		    return signature;
		}
		exports.sign = sign;
		function unpackneg(r, p) {
		    const t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
		    set25519(r[2], gf1);
		    unpack25519(r[1], p);
		    square(num, r[1]);
		    mul(den, num, D);
		    sub(num, num, r[2]);
		    add(den, r[2], den);
		    square(den2, den);
		    square(den4, den2);
		    mul(den6, den4, den2);
		    mul(t, den6, num);
		    mul(t, t, den);
		    pow2523(t, t);
		    mul(t, t, num);
		    mul(t, t, den);
		    mul(t, t, den);
		    mul(r[0], t, den);
		    square(chk, r[0]);
		    mul(chk, chk, den);
		    if (neq25519(chk, num)) {
		        mul(r[0], r[0], I);
		    }
		    square(chk, r[0]);
		    mul(chk, chk, den);
		    if (neq25519(chk, num)) {
		        return -1;
		    }
		    if (par25519(r[0]) === (p[31] >> 7)) {
		        sub(r[0], gf0, r[0]);
		    }
		    mul(r[3], r[0], r[1]);
		    return 0;
		}
		function verify(publicKey, message, signature) {
		    const t = new Uint8Array(32);
		    const p = [gf(), gf(), gf(), gf()];
		    const q = [gf(), gf(), gf(), gf()];
		    if (signature.length !== exports.SIGNATURE_LENGTH) {
		        throw new Error(`ed25519: signature must be ${exports.SIGNATURE_LENGTH} bytes`);
		    }
		    if (unpackneg(q, publicKey)) {
		        return false;
		    }
		    const hs = new sha512_1.SHA512();
		    hs.update(signature.subarray(0, 32));
		    hs.update(publicKey);
		    hs.update(message);
		    const h = hs.digest();
		    reduce(h);
		    scalarmult(p, q, h);
		    scalarbase(q, signature.subarray(32));
		    edadd(p, q);
		    pack(t, p);
		    if (verify32(signature, t)) {
		        return false;
		    }
		    return true;
		}
		exports.verify = verify;
		/**
		 * Convert Ed25519 public key to X25519 public key.
		 *
		 * Throws if given an invalid public key.
		 */
		function convertPublicKeyToX25519(publicKey) {
		    let q = [gf(), gf(), gf(), gf()];
		    if (unpackneg(q, publicKey)) {
		        throw new Error("Ed25519: invalid public key");
		    }
		    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
		    let a = gf();
		    let b = gf();
		    let y = q[1];
		    add(a, gf1, y);
		    sub(b, gf1, y);
		    inv25519(b, b);
		    mul(a, a, b);
		    let z = new Uint8Array(32);
		    pack25519(z, a);
		    return z;
		}
		exports.convertPublicKeyToX25519 = convertPublicKeyToX25519;
		/**
		 *  Convert Ed25519 secret (private) key to X25519 secret key.
		 */
		function convertSecretKeyToX25519(secretKey) {
		    const d = (0, sha512_1.hash)(secretKey.subarray(0, 32));
		    d[0] &= 248;
		    d[31] &= 127;
		    d[31] |= 64;
		    const o = new Uint8Array(d.subarray(0, 32));
		    (0, wipe_1.wipe)(d);
		    return o;
		}
		exports.convertSecretKeyToX25519 = convertSecretKeyToX25519;
		
	} (ed25519));

	const JWT_IRIDIUM_ALG = "EdDSA";
	const JWT_IRIDIUM_TYP = "JWT";
	const JWT_DELIMITER = ".";
	const JWT_ENCODING = "base64url";
	const JSON_ENCODING = "utf8";
	const DATA_ENCODING = "utf8";
	const DID_DELIMITER = ":";
	const DID_PREFIX = "did";
	const DID_METHOD = "key";
	const MULTICODEC_ED25519_ENCODING = "base58btc";
	const MULTICODEC_ED25519_BASE = "z";
	const MULTICODEC_ED25519_HEADER = "K36";
	const KEY_PAIR_SEED_LENGTH = 32;

	function encodeJSON(val) {
	    return toString(fromString$1(safeJsonStringify(val), JSON_ENCODING), JWT_ENCODING);
	}
	function encodeIss(publicKey) {
	    const header = fromString$1(MULTICODEC_ED25519_HEADER, MULTICODEC_ED25519_ENCODING);
	    const multicodec = MULTICODEC_ED25519_BASE +
	        toString(concat$3([header, publicKey]), MULTICODEC_ED25519_ENCODING);
	    return [DID_PREFIX, DID_METHOD, multicodec].join(DID_DELIMITER);
	}
	function encodeSig(bytes) {
	    return toString(bytes, JWT_ENCODING);
	}
	function encodeData(params) {
	    return fromString$1([encodeJSON(params.header), encodeJSON(params.payload)].join(JWT_DELIMITER), DATA_ENCODING);
	}
	function encodeJWT(params) {
	    return [
	        encodeJSON(params.header),
	        encodeJSON(params.payload),
	        encodeSig(params.signature),
	    ].join(JWT_DELIMITER);
	}

	function generateKeyPair(seed = random.randomBytes(KEY_PAIR_SEED_LENGTH)) {
	    return ed25519.generateKeyPairFromSeed(seed);
	}
	async function signJWT(sub, aud, ttl, keyPair, iat = cjs$6.fromMiliseconds(Date.now())) {
	    const header = { alg: JWT_IRIDIUM_ALG, typ: JWT_IRIDIUM_TYP };
	    const iss = encodeIss(keyPair.publicKey);
	    const exp = iat + ttl;
	    const payload = { iss, sub, aud, iat, exp };
	    const data = encodeData({ header, payload });
	    const signature = ed25519.sign(keyPair.secretKey, data);
	    return encodeJWT({ header, payload, signature });
	}

	const PARSE_ERROR = "PARSE_ERROR";
	const INVALID_REQUEST = "INVALID_REQUEST";
	const METHOD_NOT_FOUND = "METHOD_NOT_FOUND";
	const INVALID_PARAMS = "INVALID_PARAMS";
	const INTERNAL_ERROR = "INTERNAL_ERROR";
	const SERVER_ERROR = "SERVER_ERROR";
	const RESERVED_ERROR_CODES = [-32700, -32600, -32601, -32602, -32603];
	const STANDARD_ERROR_MAP = {
	    [PARSE_ERROR]: { code: -32700, message: "Parse error" },
	    [INVALID_REQUEST]: { code: -32600, message: "Invalid Request" },
	    [METHOD_NOT_FOUND]: { code: -32601, message: "Method not found" },
	    [INVALID_PARAMS]: { code: -32602, message: "Invalid params" },
	    [INTERNAL_ERROR]: { code: -32603, message: "Internal error" },
	    [SERVER_ERROR]: { code: -32000, message: "Server error" },
	};
	const DEFAULT_ERROR = SERVER_ERROR;

	function isReservedErrorCode(code) {
	    return RESERVED_ERROR_CODES.includes(code);
	}
	function getError(type) {
	    if (!Object.keys(STANDARD_ERROR_MAP).includes(type)) {
	        return STANDARD_ERROR_MAP[DEFAULT_ERROR];
	    }
	    return STANDARD_ERROR_MAP[type];
	}
	function getErrorByCode(code) {
	    const match = Object.values(STANDARD_ERROR_MAP).find(e => e.code === code);
	    if (!match) {
	        return STANDARD_ERROR_MAP[DEFAULT_ERROR];
	    }
	    return match;
	}
	function parseConnectionError(e, url, type) {
	    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED")
	        ? new Error(`Unavailable ${type} RPC url at ${url}`)
	        : e;
	}

	var cjs = {};

	var crypto$1 = {};

	var hasRequiredCrypto;

	function requireCrypto () {
		if (hasRequiredCrypto) return crypto$1;
		hasRequiredCrypto = 1;
		Object.defineProperty(crypto$1, "__esModule", { value: true });
		crypto$1.isBrowserCryptoAvailable = crypto$1.getSubtleCrypto = crypto$1.getBrowerCrypto = void 0;
		function getBrowerCrypto() {
		    return (commonjsGlobal === null || commonjsGlobal === void 0 ? void 0 : commonjsGlobal.crypto) || (commonjsGlobal === null || commonjsGlobal === void 0 ? void 0 : commonjsGlobal.msCrypto) || {};
		}
		crypto$1.getBrowerCrypto = getBrowerCrypto;
		function getSubtleCrypto() {
		    const browserCrypto = getBrowerCrypto();
		    return browserCrypto.subtle || browserCrypto.webkitSubtle;
		}
		crypto$1.getSubtleCrypto = getSubtleCrypto;
		function isBrowserCryptoAvailable() {
		    return !!getBrowerCrypto() && !!getSubtleCrypto();
		}
		crypto$1.isBrowserCryptoAvailable = isBrowserCryptoAvailable;
		
		return crypto$1;
	}

	var env = {};

	var hasRequiredEnv;

	function requireEnv () {
		if (hasRequiredEnv) return env;
		hasRequiredEnv = 1;
		Object.defineProperty(env, "__esModule", { value: true });
		env.isBrowser = env.isNode = env.isReactNative = void 0;
		function isReactNative() {
		    return (typeof document === "undefined" &&
		        typeof navigator !== "undefined" &&
		        navigator.product === "ReactNative");
		}
		env.isReactNative = isReactNative;
		function isNode() {
		    return (typeof process !== "undefined" &&
		        typeof process.versions !== "undefined" &&
		        typeof process.versions.node !== "undefined");
		}
		env.isNode = isNode;
		function isBrowser() {
		    return !isReactNative() && !isNode();
		}
		env.isBrowser = isBrowser;
		
		return env;
	}

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		const tslib_1 = require$$0$4;
		tslib_1.__exportStar(requireCrypto(), exports);
		tslib_1.__exportStar(requireEnv(), exports);
		
	} (cjs));

	function payloadId(entropy = 3) {
	    const date = Date.now() * Math.pow(10, entropy);
	    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
	    return date + extra;
	}
	function getBigIntRpcId(entropy = 6) {
	    return BigInt(payloadId(entropy));
	}
	function formatJsonRpcRequest(method, params, id) {
	    return {
	        id: id || payloadId(),
	        jsonrpc: "2.0",
	        method,
	        params,
	    };
	}
	function formatJsonRpcResult(id, result) {
	    return {
	        id,
	        jsonrpc: "2.0",
	        result,
	    };
	}
	function formatJsonRpcError(id, error, data) {
	    return {
	        id,
	        jsonrpc: "2.0",
	        error: formatErrorMessage(error, data),
	    };
	}
	function formatErrorMessage(error, data) {
	    if (typeof error === "undefined") {
	        return getError(INTERNAL_ERROR);
	    }
	    if (typeof error === "string") {
	        error = Object.assign(Object.assign({}, getError(SERVER_ERROR)), { message: error });
	    }
	    if (typeof data !== "undefined") {
	        error.data = data;
	    }
	    if (isReservedErrorCode(error.code)) {
	        error = getErrorByCode(error.code);
	    }
	    return error;
	}

	class IEvents {
	}

	class IBaseJsonRpcProvider extends IEvents {
	    constructor() {
	        super();
	    }
	}
	class IJsonRpcProvider extends IBaseJsonRpcProvider {
	    constructor(connection) {
	        super();
	    }
	}

	const HTTP_REGEX = "^https?:";
	const WS_REGEX = "^wss?:";
	function getUrlProtocol(url) {
	    const matches = url.match(new RegExp(/^\w+:/, "gi"));
	    if (!matches || !matches.length)
	        return;
	    return matches[0];
	}
	function matchRegexProtocol(url, regex) {
	    const protocol = getUrlProtocol(url);
	    if (typeof protocol === "undefined")
	        return false;
	    return new RegExp(regex).test(protocol);
	}
	function isHttpUrl(url) {
	    return matchRegexProtocol(url, HTTP_REGEX);
	}
	function isWsUrl(url) {
	    return matchRegexProtocol(url, WS_REGEX);
	}
	function isLocalhostUrl(url) {
	    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
	}

	function isJsonRpcPayload(payload) {
	    return (typeof payload === "object" &&
	        "id" in payload &&
	        "jsonrpc" in payload &&
	        payload.jsonrpc === "2.0");
	}
	function isJsonRpcRequest(payload) {
	    return isJsonRpcPayload(payload) && "method" in payload;
	}
	function isJsonRpcResponse(payload) {
	    return isJsonRpcPayload(payload) && (isJsonRpcResult(payload) || isJsonRpcError(payload));
	}
	function isJsonRpcResult(payload) {
	    return "result" in payload;
	}
	function isJsonRpcError(payload) {
	    return "error" in payload;
	}

	class JsonRpcProvider extends IJsonRpcProvider {
	    constructor(connection) {
	        super(connection);
	        this.events = new eventsExports.EventEmitter();
	        this.hasRegisteredEventListeners = false;
	        this.connection = this.setConnection(connection);
	        if (this.connection.connected) {
	            this.registerEventListeners();
	        }
	    }
	    async connect(connection = this.connection) {
	        await this.open(connection);
	    }
	    async disconnect() {
	        await this.close();
	    }
	    on(event, listener) {
	        this.events.on(event, listener);
	    }
	    once(event, listener) {
	        this.events.once(event, listener);
	    }
	    off(event, listener) {
	        this.events.off(event, listener);
	    }
	    removeListener(event, listener) {
	        this.events.removeListener(event, listener);
	    }
	    async request(request, context) {
	        return this.requestStrict(formatJsonRpcRequest(request.method, request.params || [], request.id || getBigIntRpcId().toString()), context);
	    }
	    async requestStrict(request, context) {
	        return new Promise(async (resolve, reject) => {
	            if (!this.connection.connected) {
	                try {
	                    await this.open();
	                }
	                catch (e) {
	                    reject(e);
	                }
	            }
	            this.events.on(`${request.id}`, response => {
	                if (isJsonRpcError(response)) {
	                    reject(response.error);
	                }
	                else {
	                    resolve(response.result);
	                }
	            });
	            try {
	                await this.connection.send(request, context);
	            }
	            catch (e) {
	                reject(e);
	            }
	        });
	    }
	    setConnection(connection = this.connection) {
	        return connection;
	    }
	    onPayload(payload) {
	        this.events.emit("payload", payload);
	        if (isJsonRpcResponse(payload)) {
	            this.events.emit(`${payload.id}`, payload);
	        }
	        else {
	            this.events.emit("message", {
	                type: payload.method,
	                data: payload.params,
	            });
	        }
	    }
	    onClose(event) {
	        if (event && event.code === 3000) {
	            this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${event.code} ${event.reason ? `(${event.reason})` : ""}`));
	        }
	        this.events.emit("disconnect");
	    }
	    async open(connection = this.connection) {
	        if (this.connection === connection && this.connection.connected)
	            return;
	        if (this.connection.connected)
	            this.close();
	        if (typeof connection === "string") {
	            await this.connection.open(connection);
	            connection = this.connection;
	        }
	        this.connection = this.setConnection(connection);
	        await this.connection.open();
	        this.registerEventListeners();
	        this.events.emit("connect");
	    }
	    async close() {
	        await this.connection.close();
	    }
	    registerEventListeners() {
	        if (this.hasRegisteredEventListeners)
	            return;
	        this.connection.on("payload", (payload) => this.onPayload(payload));
	        this.connection.on("close", (event) => this.onClose(event));
	        this.connection.on("error", (error) => this.events.emit("error", error));
	        this.connection.on("register_error", (error) => this.onClose());
	        this.hasRegisteredEventListeners = true;
	    }
	}

	const resolveWebSocketImplementation = () => {
	    if (typeof global !== "undefined" && typeof global.WebSocket !== "undefined") {
	        return global.WebSocket;
	    }
	    if (typeof window !== "undefined" && typeof window.WebSocket !== "undefined") {
	        return window.WebSocket;
	    }
	    return require("ws");
	};
	const isBrowser = () => typeof window !== "undefined";
	const truncateQuery = (wssUrl) => wssUrl.split("?")[0];

	const EVENT_EMITTER_MAX_LISTENERS_DEFAULT$1 = 10;
	const WS = resolveWebSocketImplementation();
	class WsConnection {
	    constructor(url) {
	        this.url = url;
	        this.events = new eventsExports.EventEmitter();
	        this.registering = false;
	        if (!isWsUrl(url)) {
	            throw new Error(`Provided URL is not compatible with WebSocket connection: ${url}`);
	        }
	        this.url = url;
	    }
	    get connected() {
	        return typeof this.socket !== "undefined";
	    }
	    get connecting() {
	        return this.registering;
	    }
	    on(event, listener) {
	        this.events.on(event, listener);
	    }
	    once(event, listener) {
	        this.events.once(event, listener);
	    }
	    off(event, listener) {
	        this.events.off(event, listener);
	    }
	    removeListener(event, listener) {
	        this.events.removeListener(event, listener);
	    }
	    async open(url = this.url) {
	        await this.register(url);
	    }
	    async close() {
	        return new Promise((resolve, reject) => {
	            if (typeof this.socket === "undefined") {
	                reject(new Error("Connection already closed"));
	                return;
	            }
	            this.socket.onclose = event => {
	                this.onClose(event);
	                resolve();
	            };
	            this.socket.close();
	        });
	    }
	    async send(payload, context) {
	        if (typeof this.socket === "undefined") {
	            this.socket = await this.register();
	        }
	        try {
	            this.socket.send(safeJsonStringify(payload));
	        }
	        catch (e) {
	            this.onError(payload.id, e);
	        }
	    }
	    register(url = this.url) {
	        if (!isWsUrl(url)) {
	            throw new Error(`Provided URL is not compatible with WebSocket connection: ${url}`);
	        }
	        if (this.registering) {
	            const currentMaxListeners = this.events.getMaxListeners();
	            if (this.events.listenerCount("register_error") >= currentMaxListeners ||
	                this.events.listenerCount("open") >= currentMaxListeners) {
	                this.events.setMaxListeners(currentMaxListeners + 1);
	            }
	            return new Promise((resolve, reject) => {
	                this.events.once("register_error", error => {
	                    this.resetMaxListeners();
	                    reject(error);
	                });
	                this.events.once("open", () => {
	                    this.resetMaxListeners();
	                    if (typeof this.socket === "undefined") {
	                        return reject(new Error("WebSocket connection is missing or invalid"));
	                    }
	                    resolve(this.socket);
	                });
	            });
	        }
	        this.url = url;
	        this.registering = true;
	        return new Promise((resolve, reject) => {
	            const opts = !cjs.isReactNative() ? { rejectUnauthorized: !isLocalhostUrl(url) } : undefined;
	            const socket = new WS(url, [], opts);
	            if (isBrowser()) {
	                socket.onerror = (event) => {
	                    const errorEvent = event;
	                    reject(this.emitError(errorEvent.error));
	                };
	            }
	            else {
	                socket.on("error", (errorEvent) => {
	                    reject(this.emitError(errorEvent));
	                });
	            }
	            socket.onopen = () => {
	                this.onOpen(socket);
	                resolve(socket);
	            };
	        });
	    }
	    onOpen(socket) {
	        socket.onmessage = (event) => this.onPayload(event);
	        socket.onclose = event => this.onClose(event);
	        this.socket = socket;
	        this.registering = false;
	        this.events.emit("open");
	    }
	    onClose(event) {
	        this.socket = undefined;
	        this.registering = false;
	        this.events.emit("close", event);
	    }
	    onPayload(e) {
	        if (typeof e.data === "undefined")
	            return;
	        const payload = typeof e.data === "string" ? safeJsonParse(e.data) : e.data;
	        this.events.emit("payload", payload);
	    }
	    onError(id, e) {
	        const error = this.parseError(e);
	        const message = error.message || error.toString();
	        const payload = formatJsonRpcError(id, message);
	        this.events.emit("payload", payload);
	    }
	    parseError(e, url = this.url) {
	        return parseConnectionError(e, truncateQuery(url), "WS");
	    }
	    resetMaxListeners() {
	        if (this.events.getMaxListeners() > EVENT_EMITTER_MAX_LISTENERS_DEFAULT$1) {
	            this.events.setMaxListeners(EVENT_EMITTER_MAX_LISTENERS_DEFAULT$1);
	        }
	    }
	    emitError(errorEvent) {
	        const error = this.parseError(new Error((errorEvent === null || errorEvent === void 0 ? void 0 : errorEvent.message) || `WebSocket connection failed for host: ${truncateQuery(this.url)}`));
	        this.events.emit("register_error", error);
	        return error;
	    }
	}

	var lodash_isequal = {exports: {}};

	/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	lodash_isequal.exports;

	(function (module, exports) {
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;

		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';

		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;

		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;

		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    asyncTag = '[object AsyncFunction]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    nullTag = '[object Null]',
		    objectTag = '[object Object]',
		    promiseTag = '[object Promise]',
		    proxyTag = '[object Proxy]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]',
		    undefinedTag = '[object Undefined]',
		    weakMapTag = '[object WeakMap]';

		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';

		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;

		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;

		/** Used to identify `toStringTag` values of typed arrays. */
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
		typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
		typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
		typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
		typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
		typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
		typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
		typedArrayTags[errorTag] = typedArrayTags[funcTag] =
		typedArrayTags[mapTag] = typedArrayTags[numberTag] =
		typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
		typedArrayTags[setTag] = typedArrayTags[stringTag] =
		typedArrayTags[weakMapTag] = false;

		/** Detect free variable `global` from Node.js. */
		var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

		/** Detect free variable `self`. */
		var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || Function('return this')();

		/** Detect free variable `exports`. */
		var freeExports = exports && !exports.nodeType && exports;

		/** Detect free variable `module`. */
		var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;

		/** Detect free variable `process` from Node.js. */
		var freeProcess = moduleExports && freeGlobal.process;

		/** Used to access faster Node.js helpers. */
		var nodeUtil = (function() {
		  try {
		    return freeProcess && freeProcess.binding && freeProcess.binding('util');
		  } catch (e) {}
		}());

		/* Node.js helper references. */
		var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

		/**
		 * A specialized version of `_.filter` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {Array} Returns the new filtered array.
		 */
		function arrayFilter(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length,
		      resIndex = 0,
		      result = [];

		  while (++index < length) {
		    var value = array[index];
		    if (predicate(value, index, array)) {
		      result[resIndex++] = value;
		    }
		  }
		  return result;
		}

		/**
		 * Appends the elements of `values` to `array`.
		 *
		 * @private
		 * @param {Array} array The array to modify.
		 * @param {Array} values The values to append.
		 * @returns {Array} Returns `array`.
		 */
		function arrayPush(array, values) {
		  var index = -1,
		      length = values.length,
		      offset = array.length;

		  while (++index < length) {
		    array[offset + index] = values[index];
		  }
		  return array;
		}

		/**
		 * A specialized version of `_.some` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {boolean} Returns `true` if any element passes the predicate check,
		 *  else `false`.
		 */
		function arraySome(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length;

		  while (++index < length) {
		    if (predicate(array[index], index, array)) {
		      return true;
		    }
		  }
		  return false;
		}

		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);

		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}

		/**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */
		function baseUnary(func) {
		  return function(value) {
		    return func(value);
		  };
		}

		/**
		 * Checks if a `cache` value for `key` exists.
		 *
		 * @private
		 * @param {Object} cache The cache to query.
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function cacheHas(cache, key) {
		  return cache.has(key);
		}

		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}

		/**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */
		function mapToArray(map) {
		  var index = -1,
		      result = Array(map.size);

		  map.forEach(function(value, key) {
		    result[++index] = [key, value];
		  });
		  return result;
		}

		/**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */
		function overArg(func, transform) {
		  return function(arg) {
		    return func(transform(arg));
		  };
		}

		/**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */
		function setToArray(set) {
		  var index = -1,
		      result = Array(set.size);

		  set.forEach(function(value) {
		    result[++index] = value;
		  });
		  return result;
		}

		/** Used for built-in method references. */
		var arrayProto = Array.prototype,
		    funcProto = Function.prototype,
		    objectProto = Object.prototype;

		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];

		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;

		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;

		/** Used to detect methods masquerading as native. */
		var maskSrcKey = (function() {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? ('Symbol(src)_1.' + uid) : '';
		}());

		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var nativeObjectToString = objectProto.toString;

		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);

		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined,
		    Symbol = root.Symbol,
		    Uint8Array = root.Uint8Array,
		    propertyIsEnumerable = objectProto.propertyIsEnumerable,
		    splice = arrayProto.splice,
		    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetSymbols = Object.getOwnPropertySymbols,
		    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
		    nativeKeys = overArg(Object.keys, Object);

		/* Built-in method references that are verified to be native. */
		var DataView = getNative(root, 'DataView'),
		    Map = getNative(root, 'Map'),
		    Promise = getNative(root, 'Promise'),
		    Set = getNative(root, 'Set'),
		    WeakMap = getNative(root, 'WeakMap'),
		    nativeCreate = getNative(Object, 'create');

		/** Used to detect maps, sets, and weakmaps. */
		var dataViewCtorString = toSource(DataView),
		    mapCtorString = toSource(Map),
		    promiseCtorString = toSource(Promise),
		    setCtorString = toSource(Set),
		    weakMapCtorString = toSource(WeakMap);

		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

		/**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Hash(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */
		function hashClear() {
		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function hashDelete(key) {
		  var result = this.has(key) && delete this.__data__[key];
		  this.size -= result ? 1 : 0;
		  return result;
		}

		/**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function hashGet(key) {
		  var data = this.__data__;
		  if (nativeCreate) {
		    var result = data[key];
		    return result === HASH_UNDEFINED ? undefined : result;
		  }
		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
		}

		/**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function hashHas(key) {
		  var data = this.__data__;
		  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
		}

		/**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */
		function hashSet(key, value) {
		  var data = this.__data__;
		  this.size += this.has(key) ? 0 : 1;
		  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
		  return this;
		}

		// Add methods to `Hash`.
		Hash.prototype.clear = hashClear;
		Hash.prototype['delete'] = hashDelete;
		Hash.prototype.get = hashGet;
		Hash.prototype.has = hashHas;
		Hash.prototype.set = hashSet;

		/**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function ListCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */
		function listCacheClear() {
		  this.__data__ = [];
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function listCacheDelete(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  if (index < 0) {
		    return false;
		  }
		  var lastIndex = data.length - 1;
		  if (index == lastIndex) {
		    data.pop();
		  } else {
		    splice.call(data, index, 1);
		  }
		  --this.size;
		  return true;
		}

		/**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function listCacheGet(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  return index < 0 ? undefined : data[index][1];
		}

		/**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function listCacheHas(key) {
		  return assocIndexOf(this.__data__, key) > -1;
		}

		/**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */
		function listCacheSet(key, value) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  if (index < 0) {
		    ++this.size;
		    data.push([key, value]);
		  } else {
		    data[index][1] = value;
		  }
		  return this;
		}

		// Add methods to `ListCache`.
		ListCache.prototype.clear = listCacheClear;
		ListCache.prototype['delete'] = listCacheDelete;
		ListCache.prototype.get = listCacheGet;
		ListCache.prototype.has = listCacheHas;
		ListCache.prototype.set = listCacheSet;

		/**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function MapCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */
		function mapCacheClear() {
		  this.size = 0;
		  this.__data__ = {
		    'hash': new Hash,
		    'map': new (Map || ListCache),
		    'string': new Hash
		  };
		}

		/**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function mapCacheDelete(key) {
		  var result = getMapData(this, key)['delete'](key);
		  this.size -= result ? 1 : 0;
		  return result;
		}

		/**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function mapCacheGet(key) {
		  return getMapData(this, key).get(key);
		}

		/**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function mapCacheHas(key) {
		  return getMapData(this, key).has(key);
		}

		/**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */
		function mapCacheSet(key, value) {
		  var data = getMapData(this, key),
		      size = data.size;

		  data.set(key, value);
		  this.size += data.size == size ? 0 : 1;
		  return this;
		}

		// Add methods to `MapCache`.
		MapCache.prototype.clear = mapCacheClear;
		MapCache.prototype['delete'] = mapCacheDelete;
		MapCache.prototype.get = mapCacheGet;
		MapCache.prototype.has = mapCacheHas;
		MapCache.prototype.set = mapCacheSet;

		/**
		 *
		 * Creates an array cache object to store unique values.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [values] The values to cache.
		 */
		function SetCache(values) {
		  var index = -1,
		      length = values == null ? 0 : values.length;

		  this.__data__ = new MapCache;
		  while (++index < length) {
		    this.add(values[index]);
		  }
		}

		/**
		 * Adds `value` to the array cache.
		 *
		 * @private
		 * @name add
		 * @memberOf SetCache
		 * @alias push
		 * @param {*} value The value to cache.
		 * @returns {Object} Returns the cache instance.
		 */
		function setCacheAdd(value) {
		  this.__data__.set(value, HASH_UNDEFINED);
		  return this;
		}

		/**
		 * Checks if `value` is in the array cache.
		 *
		 * @private
		 * @name has
		 * @memberOf SetCache
		 * @param {*} value The value to search for.
		 * @returns {number} Returns `true` if `value` is found, else `false`.
		 */
		function setCacheHas(value) {
		  return this.__data__.has(value);
		}

		// Add methods to `SetCache`.
		SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
		SetCache.prototype.has = setCacheHas;

		/**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Stack(entries) {
		  var data = this.__data__ = new ListCache(entries);
		  this.size = data.size;
		}

		/**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */
		function stackClear() {
		  this.__data__ = new ListCache;
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function stackDelete(key) {
		  var data = this.__data__,
		      result = data['delete'](key);

		  this.size = data.size;
		  return result;
		}

		/**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function stackGet(key) {
		  return this.__data__.get(key);
		}

		/**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function stackHas(key) {
		  return this.__data__.has(key);
		}

		/**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */
		function stackSet(key, value) {
		  var data = this.__data__;
		  if (data instanceof ListCache) {
		    var pairs = data.__data__;
		    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
		      pairs.push([key, value]);
		      this.size = ++data.size;
		      return this;
		    }
		    data = this.__data__ = new MapCache(pairs);
		  }
		  data.set(key, value);
		  this.size = data.size;
		  return this;
		}

		// Add methods to `Stack`.
		Stack.prototype.clear = stackClear;
		Stack.prototype['delete'] = stackDelete;
		Stack.prototype.get = stackGet;
		Stack.prototype.has = stackHas;
		Stack.prototype.set = stackSet;

		/**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */
		function arrayLikeKeys(value, inherited) {
		  var isArr = isArray(value),
		      isArg = !isArr && isArguments(value),
		      isBuff = !isArr && !isArg && isBuffer(value),
		      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
		      skipIndexes = isArr || isArg || isBuff || isType,
		      result = skipIndexes ? baseTimes(value.length, String) : [],
		      length = result.length;

		  for (var key in value) {
		    if ((inherited || hasOwnProperty.call(value, key)) &&
		        !(skipIndexes && (
		           // Safari 9 has enumerable `arguments.length` in strict mode.
		           key == 'length' ||
		           // Node.js 0.10 has enumerable non-index properties on buffers.
		           (isBuff && (key == 'offset' || key == 'parent')) ||
		           // PhantomJS 2 has enumerable non-index properties on typed arrays.
		           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
		           // Skip index properties.
		           isIndex(key, length)
		        ))) {
		      result.push(key);
		    }
		  }
		  return result;
		}

		/**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function assocIndexOf(array, key) {
		  var length = array.length;
		  while (length--) {
		    if (eq(array[length][0], key)) {
		      return length;
		    }
		  }
		  return -1;
		}

		/**
		 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
		 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
		 * symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @param {Function} symbolsFunc The function to get the symbols of `object`.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function baseGetAllKeys(object, keysFunc, symbolsFunc) {
		  var result = keysFunc(object);
		  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
		}

		/**
		 * The base implementation of `getTag` without fallbacks for buggy environments.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function baseGetTag(value) {
		  if (value == null) {
		    return value === undefined ? undefinedTag : nullTag;
		  }
		  return (symToStringTag && symToStringTag in Object(value))
		    ? getRawTag(value)
		    : objectToString(value);
		}

		/**
		 * The base implementation of `_.isArguments`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 */
		function baseIsArguments(value) {
		  return isObjectLike(value) && baseGetTag(value) == argsTag;
		}

		/**
		 * The base implementation of `_.isEqual` which supports partial comparisons
		 * and tracks traversed objects.
		 *
		 * @private
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @param {boolean} bitmask The bitmask flags.
		 *  1 - Unordered comparison
		 *  2 - Partial comparison
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 */
		function baseIsEqual(value, other, bitmask, customizer, stack) {
		  if (value === other) {
		    return true;
		  }
		  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
		    return value !== value && other !== other;
		  }
		  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
		}

		/**
		 * A specialized version of `baseIsEqual` for arrays and objects which performs
		 * deep comparisons and tracks traversed objects enabling objects with circular
		 * references to be compared.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
		  var objIsArr = isArray(object),
		      othIsArr = isArray(other),
		      objTag = objIsArr ? arrayTag : getTag(object),
		      othTag = othIsArr ? arrayTag : getTag(other);

		  objTag = objTag == argsTag ? objectTag : objTag;
		  othTag = othTag == argsTag ? objectTag : othTag;

		  var objIsObj = objTag == objectTag,
		      othIsObj = othTag == objectTag,
		      isSameTag = objTag == othTag;

		  if (isSameTag && isBuffer(object)) {
		    if (!isBuffer(other)) {
		      return false;
		    }
		    objIsArr = true;
		    objIsObj = false;
		  }
		  if (isSameTag && !objIsObj) {
		    stack || (stack = new Stack);
		    return (objIsArr || isTypedArray(object))
		      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
		      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
		  }
		  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
		    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
		        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

		    if (objIsWrapped || othIsWrapped) {
		      var objUnwrapped = objIsWrapped ? object.value() : object,
		          othUnwrapped = othIsWrapped ? other.value() : other;

		      stack || (stack = new Stack);
		      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
		    }
		  }
		  if (!isSameTag) {
		    return false;
		  }
		  stack || (stack = new Stack);
		  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
		}

		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}

		/**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */
		function baseIsTypedArray(value) {
		  return isObjectLike(value) &&
		    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
		}

		/**
		 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeys(object) {
		  if (!isPrototype(object)) {
		    return nativeKeys(object);
		  }
		  var result = [];
		  for (var key in Object(object)) {
		    if (hasOwnProperty.call(object, key) && key != 'constructor') {
		      result.push(key);
		    }
		  }
		  return result;
		}

		/**
		 * A specialized version of `baseIsEqualDeep` for arrays with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Array} array The array to compare.
		 * @param {Array} other The other array to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `array` and `other` objects.
		 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
		 */
		function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      arrLength = array.length,
		      othLength = other.length;

		  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
		    return false;
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(array);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var index = -1,
		      result = true,
		      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

		  stack.set(array, other);
		  stack.set(other, array);

		  // Ignore non-index properties.
		  while (++index < arrLength) {
		    var arrValue = array[index],
		        othValue = other[index];

		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, arrValue, index, other, array, stack)
		        : customizer(arrValue, othValue, index, array, other, stack);
		    }
		    if (compared !== undefined) {
		      if (compared) {
		        continue;
		      }
		      result = false;
		      break;
		    }
		    // Recursively compare arrays (susceptible to call stack limits).
		    if (seen) {
		      if (!arraySome(other, function(othValue, othIndex) {
		            if (!cacheHas(seen, othIndex) &&
		                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
		              return seen.push(othIndex);
		            }
		          })) {
		        result = false;
		        break;
		      }
		    } else if (!(
		          arrValue === othValue ||
		            equalFunc(arrValue, othValue, bitmask, customizer, stack)
		        )) {
		      result = false;
		      break;
		    }
		  }
		  stack['delete'](array);
		  stack['delete'](other);
		  return result;
		}

		/**
		 * A specialized version of `baseIsEqualDeep` for comparing objects of
		 * the same `toStringTag`.
		 *
		 * **Note:** This function only supports comparing values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {string} tag The `toStringTag` of the objects to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
		  switch (tag) {
		    case dataViewTag:
		      if ((object.byteLength != other.byteLength) ||
		          (object.byteOffset != other.byteOffset)) {
		        return false;
		      }
		      object = object.buffer;
		      other = other.buffer;

		    case arrayBufferTag:
		      if ((object.byteLength != other.byteLength) ||
		          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
		        return false;
		      }
		      return true;

		    case boolTag:
		    case dateTag:
		    case numberTag:
		      // Coerce booleans to `1` or `0` and dates to milliseconds.
		      // Invalid dates are coerced to `NaN`.
		      return eq(+object, +other);

		    case errorTag:
		      return object.name == other.name && object.message == other.message;

		    case regexpTag:
		    case stringTag:
		      // Coerce regexes to strings and treat strings, primitives and objects,
		      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
		      // for more details.
		      return object == (other + '');

		    case mapTag:
		      var convert = mapToArray;

		    case setTag:
		      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
		      convert || (convert = setToArray);

		      if (object.size != other.size && !isPartial) {
		        return false;
		      }
		      // Assume cyclic values are equal.
		      var stacked = stack.get(object);
		      if (stacked) {
		        return stacked == other;
		      }
		      bitmask |= COMPARE_UNORDERED_FLAG;

		      // Recursively compare objects (susceptible to call stack limits).
		      stack.set(object, other);
		      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
		      stack['delete'](object);
		      return result;

		    case symbolTag:
		      if (symbolValueOf) {
		        return symbolValueOf.call(object) == symbolValueOf.call(other);
		      }
		  }
		  return false;
		}

		/**
		 * A specialized version of `baseIsEqualDeep` for objects with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      objProps = getAllKeys(object),
		      objLength = objProps.length,
		      othProps = getAllKeys(other),
		      othLength = othProps.length;

		  if (objLength != othLength && !isPartial) {
		    return false;
		  }
		  var index = objLength;
		  while (index--) {
		    var key = objProps[index];
		    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
		      return false;
		    }
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(object);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var result = true;
		  stack.set(object, other);
		  stack.set(other, object);

		  var skipCtor = isPartial;
		  while (++index < objLength) {
		    key = objProps[index];
		    var objValue = object[key],
		        othValue = other[key];

		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, objValue, key, other, object, stack)
		        : customizer(objValue, othValue, key, object, other, stack);
		    }
		    // Recursively compare objects (susceptible to call stack limits).
		    if (!(compared === undefined
		          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
		          : compared
		        )) {
		      result = false;
		      break;
		    }
		    skipCtor || (skipCtor = key == 'constructor');
		  }
		  if (result && !skipCtor) {
		    var objCtor = object.constructor,
		        othCtor = other.constructor;

		    // Non `Object` object instances with different constructors are not equal.
		    if (objCtor != othCtor &&
		        ('constructor' in object && 'constructor' in other) &&
		        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
		          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
		      result = false;
		    }
		  }
		  stack['delete'](object);
		  stack['delete'](other);
		  return result;
		}

		/**
		 * Creates an array of own enumerable property names and symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function getAllKeys(object) {
		  return baseGetAllKeys(object, keys, getSymbols);
		}

		/**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */
		function getMapData(map, key) {
		  var data = map.__data__;
		  return isKeyable(key)
		    ? data[typeof key == 'string' ? 'string' : 'hash']
		    : data.map;
		}

		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}

		/**
		 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the raw `toStringTag`.
		 */
		function getRawTag(value) {
		  var isOwn = hasOwnProperty.call(value, symToStringTag),
		      tag = value[symToStringTag];

		  try {
		    value[symToStringTag] = undefined;
		    var unmasked = true;
		  } catch (e) {}

		  var result = nativeObjectToString.call(value);
		  if (unmasked) {
		    if (isOwn) {
		      value[symToStringTag] = tag;
		    } else {
		      delete value[symToStringTag];
		    }
		  }
		  return result;
		}

		/**
		 * Creates an array of the own enumerable symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of symbols.
		 */
		var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
		  if (object == null) {
		    return [];
		  }
		  object = Object(object);
		  return arrayFilter(nativeGetSymbols(object), function(symbol) {
		    return propertyIsEnumerable.call(object, symbol);
		  });
		};

		/**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		var getTag = baseGetTag;

		// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
		if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
		    (Map && getTag(new Map) != mapTag) ||
		    (Promise && getTag(Promise.resolve()) != promiseTag) ||
		    (Set && getTag(new Set) != setTag) ||
		    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
		  getTag = function(value) {
		    var result = baseGetTag(value),
		        Ctor = result == objectTag ? value.constructor : undefined,
		        ctorString = Ctor ? toSource(Ctor) : '';

		    if (ctorString) {
		      switch (ctorString) {
		        case dataViewCtorString: return dataViewTag;
		        case mapCtorString: return mapTag;
		        case promiseCtorString: return promiseTag;
		        case setCtorString: return setTag;
		        case weakMapCtorString: return weakMapTag;
		      }
		    }
		    return result;
		  };
		}

		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return !!length &&
		    (typeof value == 'number' || reIsUint.test(value)) &&
		    (value > -1 && value % 1 == 0 && value < length);
		}

		/**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */
		function isKeyable(value) {
		  var type = typeof value;
		  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
		    ? (value !== '__proto__')
		    : (value === null);
		}

		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && (maskSrcKey in func);
		}

		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

		  return value === proto;
		}

		/**
		 * Converts `value` to a string using `Object.prototype.toString`.
		 *
		 * @private
		 * @param {*} value The value to convert.
		 * @returns {string} Returns the converted string.
		 */
		function objectToString(value) {
		  return nativeObjectToString.call(value);
		}

		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to convert.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return (func + '');
		    } catch (e) {}
		  }
		  return '';
		}

		/**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */
		function eq(value, other) {
		  return value === other || (value !== value && other !== other);
		}

		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
		  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
		    !propertyIsEnumerable.call(value, 'callee');
		};

		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;

		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(value.length) && !isFunction(value);
		}

		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = nativeIsBuffer || stubFalse;

		/**
		 * Performs a deep comparison between two values to determine if they are
		 * equivalent.
		 *
		 * **Note:** This method supports comparing arrays, array buffers, booleans,
		 * date objects, error objects, maps, numbers, `Object` objects, regexes,
		 * sets, strings, symbols, and typed arrays. `Object` objects are compared
		 * by their own, not inherited, enumerable properties. Functions and DOM
		 * nodes are compared by strict equality, i.e. `===`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.isEqual(object, other);
		 * // => true
		 *
		 * object === other;
		 * // => false
		 */
		function isEqual(value, other) {
		  return baseIsEqual(value, other);
		}

		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  if (!isObject(value)) {
		    return false;
		  }
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in Safari 9 which returns 'object' for typed arrays and other constructors.
		  var tag = baseGetTag(value);
		  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
		}

		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' &&
		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}

		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value;
		  return value != null && (type == 'object' || type == 'function');
		}

		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return value != null && typeof value == 'object';
		}

		/**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */
		var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		function keys(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
		}

		/**
		 * This method returns a new empty array.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {Array} Returns the new empty array.
		 * @example
		 *
		 * var arrays = _.times(2, _.stubArray);
		 *
		 * console.log(arrays);
		 * // => [[], []]
		 *
		 * console.log(arrays[0] === arrays[1]);
		 * // => false
		 */
		function stubArray() {
		  return [];
		}

		/**
		 * This method returns `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {boolean} Returns `false`.
		 * @example
		 *
		 * _.times(2, _.stubFalse);
		 * // => [false, false]
		 */
		function stubFalse() {
		  return false;
		}

		module.exports = isEqual; 
	} (lodash_isequal, lodash_isequal.exports));

	var lodash_isequalExports = lodash_isequal.exports;
	var Li = /*@__PURE__*/getDefaultExportFromCjs(lodash_isequalExports);

	function Fi$1(r,e){if(r.length>=255)throw new TypeError("Alphabet too long");for(var t=new Uint8Array(256),i=0;i<t.length;i++)t[i]=255;for(var s=0;s<r.length;s++){var n=r.charAt(s),a=n.charCodeAt(0);if(t[a]!==255)throw new TypeError(n+" is ambiguous");t[a]=s;}var o=r.length,h=r.charAt(0),d=Math.log(o)/Math.log(256),l=Math.log(256)/Math.log(o);function D(u){if(u instanceof Uint8Array||(ArrayBuffer.isView(u)?u=new Uint8Array(u.buffer,u.byteOffset,u.byteLength):Array.isArray(u)&&(u=Uint8Array.from(u))),!(u instanceof Uint8Array))throw new TypeError("Expected Uint8Array");if(u.length===0)return "";for(var y=0,A=0,v=0,R=u.length;v!==R&&u[v]===0;)v++,y++;for(var T=(R-v)*l+1>>>0,m=new Uint8Array(T);v!==R;){for(var S=u[v],x=0,I=T-1;(S!==0||x<A)&&I!==-1;I--,x++)S+=256*m[I]>>>0,m[I]=S%o>>>0,S=S/o>>>0;if(S!==0)throw new Error("Non-zero carry");A=x,v++;}for(var P=T-A;P!==T&&m[P]===0;)P++;for(var B=h.repeat(y);P<T;++P)B+=r.charAt(m[P]);return B}function b(u){if(typeof u!="string")throw new TypeError("Expected String");if(u.length===0)return new Uint8Array;var y=0;if(u[y]!==" "){for(var A=0,v=0;u[y]===h;)A++,y++;for(var R=(u.length-y)*d+1>>>0,T=new Uint8Array(R);u[y];){var m=t[u.charCodeAt(y)];if(m===255)return;for(var S=0,x=R-1;(m!==0||S<v)&&x!==-1;x--,S++)m+=o*T[x]>>>0,T[x]=m%256>>>0,m=m/256>>>0;if(m!==0)throw new Error("Non-zero carry");v=S,y++;}if(u[y]!==" "){for(var I=R-v;I!==R&&T[I]===0;)I++;for(var P=new Uint8Array(A+(R-I)),B=A;I!==R;)P[B++]=T[I++];return P}}}function k(u){var y=b(u);if(y)return y;throw new Error(`Non-${e} character`)}return {encode:D,decodeUnsafe:b,decode:k}}var $i$1=Fi$1,Mi=$i$1;const Oe$1=r=>{if(r instanceof Uint8Array&&r.constructor.name==="Uint8Array")return r;if(r instanceof ArrayBuffer)return new Uint8Array(r);if(ArrayBuffer.isView(r))return new Uint8Array(r.buffer,r.byteOffset,r.byteLength);throw new Error("Unknown type, must be binary type")},Ki=r=>new TextEncoder().encode(r),ki=r=>new TextDecoder().decode(r);class Bi{constructor(e,t,i){this.name=e,this.prefix=t,this.baseEncode=i;}encode(e){if(e instanceof Uint8Array)return `${this.prefix}${this.baseEncode(e)}`;throw Error("Unknown type, must be binary type")}}class ji{constructor(e,t,i){if(this.name=e,this.prefix=t,t.codePointAt(0)===void 0)throw new Error("Invalid prefix character");this.prefixCodePoint=t.codePointAt(0),this.baseDecode=i;}decode(e){if(typeof e=="string"){if(e.codePointAt(0)!==this.prefixCodePoint)throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);return this.baseDecode(e.slice(this.prefix.length))}else throw Error("Can only multibase decode strings")}or(e){return xe$1(this,e)}}class Vi{constructor(e){this.decoders=e;}or(e){return xe$1(this,e)}decode(e){const t=e[0],i=this.decoders[t];if(i)return i.decode(e);throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`)}}const xe$1=(r,e)=>new Vi({...r.decoders||{[r.prefix]:r},...e.decoders||{[e.prefix]:e}});class qi{constructor(e,t,i,s){this.name=e,this.prefix=t,this.baseEncode=i,this.baseDecode=s,this.encoder=new Bi(e,t,i),this.decoder=new ji(e,t,s);}encode(e){return this.encoder.encode(e)}decode(e){return this.decoder.decode(e)}}const H$3=({name:r,prefix:e,encode:t,decode:i})=>new qi(r,e,t,i),M$4=({prefix:r,name:e,alphabet:t})=>{const{encode:i,decode:s}=Mi(t,e);return H$3({prefix:r,name:e,encode:i,decode:n=>Oe$1(s(n))})},Yi=(r,e,t,i)=>{const s={};for(let l=0;l<e.length;++l)s[e[l]]=l;let n=r.length;for(;r[n-1]==="=";)--n;const a=new Uint8Array(n*t/8|0);let o=0,h=0,d=0;for(let l=0;l<n;++l){const D=s[r[l]];if(D===void 0)throw new SyntaxError(`Non-${i} character`);h=h<<t|D,o+=t,o>=8&&(o-=8,a[d++]=255&h>>o);}if(o>=t||255&h<<8-o)throw new SyntaxError("Unexpected end of data");return a},Gi=(r,e,t)=>{const i=e[e.length-1]==="=",s=(1<<t)-1;let n="",a=0,o=0;for(let h=0;h<r.length;++h)for(o=o<<8|r[h],a+=8;a>t;)a-=t,n+=e[s&o>>a];if(a&&(n+=e[s&o<<t-a]),i)for(;n.length*t&7;)n+="=";return n},p$2=({name:r,prefix:e,bitsPerChar:t,alphabet:i})=>H$3({prefix:e,name:r,encode(s){return Gi(s,i,t)},decode(s){return Yi(s,i,t,r)}}),Ji=H$3({prefix:"\0",name:"identity",encode:r=>ki(r),decode:r=>Ki(r)});var Hi=Object.freeze({__proto__:null,identity:Ji});const Wi$1=p$2({prefix:"0",name:"base2",alphabet:"01",bitsPerChar:1});var Xi=Object.freeze({__proto__:null,base2:Wi$1});const Zi=p$2({prefix:"7",name:"base8",alphabet:"01234567",bitsPerChar:3});var Qi=Object.freeze({__proto__:null,base8:Zi});const es$1=M$4({prefix:"9",name:"base10",alphabet:"0123456789"});var ts$1=Object.freeze({__proto__:null,base10:es$1});const is$1=p$2({prefix:"f",name:"base16",alphabet:"0123456789abcdef",bitsPerChar:4}),ss$1=p$2({prefix:"F",name:"base16upper",alphabet:"0123456789ABCDEF",bitsPerChar:4});var rs$1=Object.freeze({__proto__:null,base16:is$1,base16upper:ss$1});const ns$1=p$2({prefix:"b",name:"base32",alphabet:"abcdefghijklmnopqrstuvwxyz234567",bitsPerChar:5}),as$1=p$2({prefix:"B",name:"base32upper",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",bitsPerChar:5}),os$1=p$2({prefix:"c",name:"base32pad",alphabet:"abcdefghijklmnopqrstuvwxyz234567=",bitsPerChar:5}),hs=p$2({prefix:"C",name:"base32padupper",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",bitsPerChar:5}),cs=p$2({prefix:"v",name:"base32hex",alphabet:"0123456789abcdefghijklmnopqrstuv",bitsPerChar:5}),us=p$2({prefix:"V",name:"base32hexupper",alphabet:"0123456789ABCDEFGHIJKLMNOPQRSTUV",bitsPerChar:5}),ls=p$2({prefix:"t",name:"base32hexpad",alphabet:"0123456789abcdefghijklmnopqrstuv=",bitsPerChar:5}),ds=p$2({prefix:"T",name:"base32hexpadupper",alphabet:"0123456789ABCDEFGHIJKLMNOPQRSTUV=",bitsPerChar:5}),gs=p$2({prefix:"h",name:"base32z",alphabet:"ybndrfg8ejkmcpqxot1uwisza345h769",bitsPerChar:5});var ps=Object.freeze({__proto__:null,base32:ns$1,base32upper:as$1,base32pad:os$1,base32padupper:hs,base32hex:cs,base32hexupper:us,base32hexpad:ls,base32hexpadupper:ds,base32z:gs});const Ds=M$4({prefix:"k",name:"base36",alphabet:"0123456789abcdefghijklmnopqrstuvwxyz"}),ys=M$4({prefix:"K",name:"base36upper",alphabet:"0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"});var bs=Object.freeze({__proto__:null,base36:Ds,base36upper:ys});const ms=M$4({name:"base58btc",prefix:"z",alphabet:"123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"}),Es=M$4({name:"base58flickr",prefix:"Z",alphabet:"123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"});var fs=Object.freeze({__proto__:null,base58btc:ms,base58flickr:Es});const ws=p$2({prefix:"m",name:"base64",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",bitsPerChar:6}),vs=p$2({prefix:"M",name:"base64pad",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",bitsPerChar:6}),Is=p$2({prefix:"u",name:"base64url",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",bitsPerChar:6}),Cs=p$2({prefix:"U",name:"base64urlpad",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",bitsPerChar:6});var _s=Object.freeze({__proto__:null,base64:ws,base64pad:vs,base64url:Is,base64urlpad:Cs});const Ae$1=Array.from("\u{1F680}\u{1FA90}\u2604\u{1F6F0}\u{1F30C}\u{1F311}\u{1F312}\u{1F313}\u{1F314}\u{1F315}\u{1F316}\u{1F317}\u{1F318}\u{1F30D}\u{1F30F}\u{1F30E}\u{1F409}\u2600\u{1F4BB}\u{1F5A5}\u{1F4BE}\u{1F4BF}\u{1F602}\u2764\u{1F60D}\u{1F923}\u{1F60A}\u{1F64F}\u{1F495}\u{1F62D}\u{1F618}\u{1F44D}\u{1F605}\u{1F44F}\u{1F601}\u{1F525}\u{1F970}\u{1F494}\u{1F496}\u{1F499}\u{1F622}\u{1F914}\u{1F606}\u{1F644}\u{1F4AA}\u{1F609}\u263A\u{1F44C}\u{1F917}\u{1F49C}\u{1F614}\u{1F60E}\u{1F607}\u{1F339}\u{1F926}\u{1F389}\u{1F49E}\u270C\u2728\u{1F937}\u{1F631}\u{1F60C}\u{1F338}\u{1F64C}\u{1F60B}\u{1F497}\u{1F49A}\u{1F60F}\u{1F49B}\u{1F642}\u{1F493}\u{1F929}\u{1F604}\u{1F600}\u{1F5A4}\u{1F603}\u{1F4AF}\u{1F648}\u{1F447}\u{1F3B6}\u{1F612}\u{1F92D}\u2763\u{1F61C}\u{1F48B}\u{1F440}\u{1F62A}\u{1F611}\u{1F4A5}\u{1F64B}\u{1F61E}\u{1F629}\u{1F621}\u{1F92A}\u{1F44A}\u{1F973}\u{1F625}\u{1F924}\u{1F449}\u{1F483}\u{1F633}\u270B\u{1F61A}\u{1F61D}\u{1F634}\u{1F31F}\u{1F62C}\u{1F643}\u{1F340}\u{1F337}\u{1F63B}\u{1F613}\u2B50\u2705\u{1F97A}\u{1F308}\u{1F608}\u{1F918}\u{1F4A6}\u2714\u{1F623}\u{1F3C3}\u{1F490}\u2639\u{1F38A}\u{1F498}\u{1F620}\u261D\u{1F615}\u{1F33A}\u{1F382}\u{1F33B}\u{1F610}\u{1F595}\u{1F49D}\u{1F64A}\u{1F639}\u{1F5E3}\u{1F4AB}\u{1F480}\u{1F451}\u{1F3B5}\u{1F91E}\u{1F61B}\u{1F534}\u{1F624}\u{1F33C}\u{1F62B}\u26BD\u{1F919}\u2615\u{1F3C6}\u{1F92B}\u{1F448}\u{1F62E}\u{1F646}\u{1F37B}\u{1F343}\u{1F436}\u{1F481}\u{1F632}\u{1F33F}\u{1F9E1}\u{1F381}\u26A1\u{1F31E}\u{1F388}\u274C\u270A\u{1F44B}\u{1F630}\u{1F928}\u{1F636}\u{1F91D}\u{1F6B6}\u{1F4B0}\u{1F353}\u{1F4A2}\u{1F91F}\u{1F641}\u{1F6A8}\u{1F4A8}\u{1F92C}\u2708\u{1F380}\u{1F37A}\u{1F913}\u{1F619}\u{1F49F}\u{1F331}\u{1F616}\u{1F476}\u{1F974}\u25B6\u27A1\u2753\u{1F48E}\u{1F4B8}\u2B07\u{1F628}\u{1F31A}\u{1F98B}\u{1F637}\u{1F57A}\u26A0\u{1F645}\u{1F61F}\u{1F635}\u{1F44E}\u{1F932}\u{1F920}\u{1F927}\u{1F4CC}\u{1F535}\u{1F485}\u{1F9D0}\u{1F43E}\u{1F352}\u{1F617}\u{1F911}\u{1F30A}\u{1F92F}\u{1F437}\u260E\u{1F4A7}\u{1F62F}\u{1F486}\u{1F446}\u{1F3A4}\u{1F647}\u{1F351}\u2744\u{1F334}\u{1F4A3}\u{1F438}\u{1F48C}\u{1F4CD}\u{1F940}\u{1F922}\u{1F445}\u{1F4A1}\u{1F4A9}\u{1F450}\u{1F4F8}\u{1F47B}\u{1F910}\u{1F92E}\u{1F3BC}\u{1F975}\u{1F6A9}\u{1F34E}\u{1F34A}\u{1F47C}\u{1F48D}\u{1F4E3}\u{1F942}"),Rs=Ae$1.reduce((r,e,t)=>(r[t]=e,r),[]),Ts=Ae$1.reduce((r,e,t)=>(r[e.codePointAt(0)]=t,r),[]);function Ss(r){return r.reduce((e,t)=>(e+=Rs[t],e),"")}function Ps(r){const e=[];for(const t of r){const i=Ts[t.codePointAt(0)];if(i===void 0)throw new Error(`Non-base256emoji character: ${t}`);e.push(i);}return new Uint8Array(e)}const Os=H$3({prefix:"\u{1F680}",name:"base256emoji",encode:Ss,decode:Ps});var xs=Object.freeze({__proto__:null,base256emoji:Os}),As=Ne,ze$1=128,zs=127,Ns=~zs,Us=Math.pow(2,31);function Ne(r,e,t){e=e||[],t=t||0;for(var i=t;r>=Us;)e[t++]=r&255|ze$1,r/=128;for(;r&Ns;)e[t++]=r&255|ze$1,r>>>=7;return e[t]=r|0,Ne.bytes=t-i+1,e}var Ls=ae$2,Fs=128,Ue$1=127;function ae$2(r,i){var t=0,i=i||0,s=0,n=i,a,o=r.length;do{if(n>=o)throw ae$2.bytes=0,new RangeError("Could not decode varint");a=r[n++],t+=s<28?(a&Ue$1)<<s:(a&Ue$1)*Math.pow(2,s),s+=7;}while(a>=Fs);return ae$2.bytes=n-i,t}var $s=Math.pow(2,7),Ms=Math.pow(2,14),Ks=Math.pow(2,21),ks=Math.pow(2,28),Bs=Math.pow(2,35),js=Math.pow(2,42),Vs=Math.pow(2,49),qs=Math.pow(2,56),Ys=Math.pow(2,63),Gs=function(r){return r<$s?1:r<Ms?2:r<Ks?3:r<ks?4:r<Bs?5:r<js?6:r<Vs?7:r<qs?8:r<Ys?9:10},Js={encode:As,decode:Ls,encodingLength:Gs},Le$1=Js;const Fe$1=(r,e,t=0)=>(Le$1.encode(r,e,t),e),$e$1=r=>Le$1.encodingLength(r),oe$2=(r,e)=>{const t=e.byteLength,i=$e$1(r),s=i+$e$1(t),n=new Uint8Array(s+t);return Fe$1(r,n,0),Fe$1(t,n,i),n.set(e,s),new Hs(r,t,e,n)};class Hs{constructor(e,t,i,s){this.code=e,this.size=t,this.digest=i,this.bytes=s;}}const Me$1=({name:r,code:e,encode:t})=>new Ws(r,e,t);class Ws{constructor(e,t,i){this.name=e,this.code=t,this.encode=i;}digest(e){if(e instanceof Uint8Array){const t=this.encode(e);return t instanceof Uint8Array?oe$2(this.code,t):t.then(i=>oe$2(this.code,i))}else throw Error("Unknown type, must be binary type")}}const Ke$1=r=>async e=>new Uint8Array(await crypto.subtle.digest(r,e)),Xs=Me$1({name:"sha2-256",code:18,encode:Ke$1("SHA-256")}),Zs=Me$1({name:"sha2-512",code:19,encode:Ke$1("SHA-512")});var Qs=Object.freeze({__proto__:null,sha256:Xs,sha512:Zs});const ke$1=0,er$1="identity",Be$1=Oe$1,tr$1=r=>oe$2(ke$1,Be$1(r)),ir$1={code:ke$1,name:er$1,encode:Be$1,digest:tr$1};var sr$1=Object.freeze({__proto__:null,identity:ir$1});new TextEncoder,new TextDecoder;const je$1={...Hi,...Xi,...Qi,...ts$1,...rs$1,...ps,...bs,...fs,..._s,...xs};({...Qs,...sr$1});function Ve$1(r){return globalThis.Buffer!=null?new Uint8Array(r.buffer,r.byteOffset,r.byteLength):r}function rr$1(r=0){return globalThis.Buffer!=null&&globalThis.Buffer.allocUnsafe!=null?Ve$1(globalThis.Buffer.allocUnsafe(r)):new Uint8Array(r)}function qe$1(r,e,t,i){return {name:r,prefix:e,encoder:{name:r,prefix:e,encode:t},decoder:{decode:i}}}const Ye$1=qe$1("utf8","u",r=>"u"+new TextDecoder("utf8").decode(r),r=>new TextEncoder().encode(r.substring(1))),he$1=qe$1("ascii","a",r=>{let e="a";for(let t=0;t<r.length;t++)e+=String.fromCharCode(r[t]);return e},r=>{r=r.substring(1);const e=rr$1(r.length);for(let t=0;t<r.length;t++)e[t]=r.charCodeAt(t);return e}),nr$1={utf8:Ye$1,"utf-8":Ye$1,hex:je$1.base16,latin1:he$1,ascii:he$1,binary:he$1,...je$1};function ar$1(r,e="utf8"){const t=nr$1[e];if(!t)throw new Error(`Unsupported encoding "${e}"`);return (e==="utf8"||e==="utf-8")&&globalThis.Buffer!=null&&globalThis.Buffer.from!=null?Ve$1(globalThis.Buffer.from(r,"utf-8")):t.decoder.decode(`${t.prefix}${r}`)}const ce$2="wc",Ge$1=2,W$1="core",O$3=`${ce$2}@2:${W$1}:`,Je={name:W$1,logger:"error"},He$1={database:":memory:"},We$1="crypto",ue$1="client_ed25519_seed",Xe=cjs$6.ONE_DAY,Ze$1="keychain",Qe$1="0.3",et$1="messages",tt$1="0.3",it$1=cjs$6.SIX_HOURS,st$1="publisher",rt$1="irn",nt$1="error",le$1="wss://relay.walletconnect.com",de$1="wss://relay.walletconnect.org",at$1="relayer",g$3={message:"relayer_message",message_ack:"relayer_message_ack",connect:"relayer_connect",disconnect:"relayer_disconnect",error:"relayer_error",connection_stalled:"relayer_connection_stalled",transport_closed:"relayer_transport_closed",publish:"relayer_publish"},ot$2="_subscription",L$4={payload:"payload",connect:"connect",disconnect:"disconnect",error:"error"},ht$1=cjs$6.ONE_SECOND/2,ct$1="2.9.0",ut$1=1e4,lt$1="0.3",dt$1="WALLETCONNECT_CLIENT_ID",C$3={created:"subscription_created",deleted:"subscription_deleted",expired:"subscription_expired",disabled:"subscription_disabled",sync:"subscription_sync",resubscribed:"subscription_resubscribed"},gt$1="subscription",pt$1="0.3",Dt$1=cjs$6.FIVE_SECONDS*1e3,yt$1="pairing",bt$1="0.3",F$1={wc_pairingDelete:{req:{ttl:cjs$6.ONE_DAY,prompt:!1,tag:1e3},res:{ttl:cjs$6.ONE_DAY,prompt:!1,tag:1001}},wc_pairingPing:{req:{ttl:cjs$6.THIRTY_SECONDS,prompt:!1,tag:1002},res:{ttl:cjs$6.THIRTY_SECONDS,prompt:!1,tag:1003}},unregistered_method:{req:{ttl:cjs$6.ONE_DAY,prompt:!1,tag:0},res:{ttl:cjs$6.ONE_DAY,prompt:!1,tag:0}}},_$4={created:"history_created",updated:"history_updated",deleted:"history_deleted",sync:"history_sync"},mt$1="history",Et$1="0.3",ft$1="expirer",w$2={created:"expirer_created",deleted:"expirer_deleted",expired:"expirer_expired",sync:"expirer_sync"},wt$1="0.3",X$2="verify-api",ge="https://verify.walletconnect.com";let vt$1 = class vt{constructor(e,t){this.core=e,this.logger=t,this.keychain=new Map,this.name=Ze$1,this.version=Qe$1,this.initialized=!1,this.storagePrefix=O$3,this.init=async()=>{if(!this.initialized){const i=await this.getKeyChain();typeof i<"u"&&(this.keychain=i),this.initialized=!0;}},this.has=i=>(this.isInitialized(),this.keychain.has(i)),this.set=async(i,s)=>{this.isInitialized(),this.keychain.set(i,s),await this.persist();},this.get=i=>{this.isInitialized();const s=this.keychain.get(i);if(typeof s>"u"){const{message:n}=b$6("NO_MATCHING_KEY",`${this.name}: ${i}`);throw new Error(n)}return s},this.del=async i=>{this.isInitialized(),this.keychain.delete(i),await this.persist();},this.core=e,this.logger=cjs$1.generateChildLogger(t,this.name);}get context(){return cjs$1.getLoggerContext(this.logger)}get storageKey(){return this.storagePrefix+this.version+"//"+this.name}async setKeyChain(e){await this.core.storage.setItem(this.storageKey,Bn$1(e));}async getKeyChain(){const e=await this.core.storage.getItem(this.storageKey);return typeof e<"u"?Yn(e):void 0}async persist(){await this.setKeyChain(this.keychain);}isInitialized(){if(!this.initialized){const{message:e}=b$6("NOT_INITIALIZED",this.name);throw new Error(e)}}};let It$1 = class It{constructor(e,t,i){this.core=e,this.logger=t,this.name=We$1,this.initialized=!1,this.init=async()=>{this.initialized||(await this.keychain.init(),this.initialized=!0);},this.hasKeys=s=>(this.isInitialized(),this.keychain.has(s)),this.getClientId=async()=>{this.isInitialized();const s=await this.getClientSeed(),n=generateKeyPair(s);return encodeIss(n.publicKey)},this.generateKeyPair=()=>{this.isInitialized();const s=wn();return this.setPrivateKey(s.publicKey,s.privateKey)},this.signJWT=async s=>{this.isInitialized();const n=await this.getClientSeed(),a=generateKeyPair(n),o=An$1(),h=Xe;return await signJWT(o,s,h,a)},this.generateSharedKey=(s,n,a)=>{this.isInitialized();const o=this.getPrivateKey(s),h=Un(o,n);return this.setSymKey(h,a)},this.setSymKey=async(s,n)=>{this.isInitialized();const a=n||_n$1(s);return await this.keychain.set(a,s),a},this.deleteKeyPair=async s=>{this.isInitialized(),await this.keychain.del(s);},this.deleteSymKey=async s=>{this.isInitialized(),await this.keychain.del(s);},this.encode=async(s,n,a)=>{this.isInitialized();const o=Pe$2(a),h=safeJsonStringify(n);if(Vn$1(o)){const b=o.senderPublicKey,k=o.receiverPublicKey;s=await this.generateSharedKey(b,k);}const d=this.getSymKey(s),{type:l,senderPublicKey:D}=o;return jn$1({type:l,symKey:d,message:h,senderPublicKey:D})},this.decode=async(s,n,a)=>{this.isInitialized();const o=Dn(n,a);if(Vn$1(o)){const l=o.receiverPublicKey,D=o.senderPublicKey;s=await this.generateSharedKey(l,D);}const h=this.getSymKey(s),d=Cn$1({symKey:h,encoded:n});return safeJsonParse(d)},this.getPayloadType=s=>{const n=Z$4(s);return $$6(n.type)},this.getPayloadSenderPublicKey=s=>{const n=Z$4(s);return n.senderPublicKey?toString(n.senderPublicKey,f$5):void 0},this.core=e,this.logger=cjs$1.generateChildLogger(t,this.name),this.keychain=i||new vt$1(this.core,this.logger);}get context(){return cjs$1.getLoggerContext(this.logger)}async setPrivateKey(e,t){return await this.keychain.set(e,t),e}getPrivateKey(e){return this.keychain.get(e)}async getClientSeed(){let e="";try{e=this.keychain.get(ue$1);}catch{e=An$1(),await this.keychain.set(ue$1,e);}return ar$1(e,"base16")}getSymKey(e){return this.keychain.get(e)}isInitialized(){if(!this.initialized){const{message:e}=b$6("NOT_INITIALIZED",this.name);throw new Error(e)}}};let Ct$1 = class Ct extends a$2{constructor(e,t){super(e,t),this.logger=e,this.core=t,this.messages=new Map,this.name=et$1,this.version=tt$1,this.initialized=!1,this.storagePrefix=O$3,this.init=async()=>{if(!this.initialized){this.logger.trace("Initialized");try{const i=await this.getRelayerMessages();typeof i<"u"&&(this.messages=i),this.logger.debug(`Successfully Restored records for ${this.name}`),this.logger.trace({type:"method",method:"restore",size:this.messages.size});}catch(i){this.logger.debug(`Failed to Restore records for ${this.name}`),this.logger.error(i);}finally{this.initialized=!0;}}},this.set=async(i,s)=>{this.isInitialized();const n=$n$1(s);let a=this.messages.get(i);return typeof a>"u"&&(a={}),typeof a[n]<"u"||(a[n]=s,this.messages.set(i,a),await this.persist()),n},this.get=i=>{this.isInitialized();let s=this.messages.get(i);return typeof s>"u"&&(s={}),s},this.has=(i,s)=>{this.isInitialized();const n=this.get(i),a=$n$1(s);return typeof n[a]<"u"},this.del=async i=>{this.isInitialized(),this.messages.delete(i),await this.persist();},this.logger=cjs$1.generateChildLogger(e,this.name),this.core=t;}get context(){return cjs$1.getLoggerContext(this.logger)}get storageKey(){return this.storagePrefix+this.version+"//"+this.name}async setRelayerMessages(e){await this.core.storage.setItem(this.storageKey,Bn$1(e));}async getRelayerMessages(){const e=await this.core.storage.getItem(this.storageKey);return typeof e<"u"?Yn(e):void 0}async persist(){await this.setRelayerMessages(this.messages);}isInitialized(){if(!this.initialized){const{message:e}=b$6("NOT_INITIALIZED",this.name);throw new Error(e)}}};let lr$1 = class lr extends u$3{constructor(e,t){super(e,t),this.relayer=e,this.logger=t,this.events=new eventsExports.EventEmitter,this.name=st$1,this.queue=new Map,this.publishTimeout=cjs$6.toMiliseconds(cjs$6.TEN_SECONDS),this.queueTimeout=cjs$6.toMiliseconds(cjs$6.FIVE_SECONDS),this.needsTransportRestart=!1,this.publish=async(i,s,n)=>{this.logger.debug("Publishing Payload"),this.logger.trace({type:"method",method:"publish",params:{topic:i,message:s,opts:n}});try{const a=n?.ttl||it$1,o=at$3(n),h=n?.prompt||!1,d=n?.tag||0,l=n?.id||getBigIntRpcId().toString(),D={topic:i,message:s,opts:{ttl:a,relay:o,prompt:h,tag:d,id:l}},b=setTimeout(()=>this.queue.set(l,D),this.queueTimeout);try{await await et$3(this.rpcPublish(i,s,a,o,h,d,l),this.publishTimeout),clearTimeout(b),this.relayer.events.emit(g$3.publish,D);}catch{this.logger.debug("Publishing Payload stalled"),this.needsTransportRestart=!0;return}this.logger.debug("Successfully Published Payload"),this.logger.trace({type:"method",method:"publish",params:{topic:i,message:s,opts:n}});}catch(a){throw this.logger.debug("Failed to Publish Payload"),this.logger.error(a),a}},this.on=(i,s)=>{this.events.on(i,s);},this.once=(i,s)=>{this.events.once(i,s);},this.off=(i,s)=>{this.events.off(i,s);},this.removeListener=(i,s)=>{this.events.removeListener(i,s);},this.relayer=e,this.logger=cjs$1.generateChildLogger(t,this.name),this.registerEventListeners();}get context(){return cjs$1.getLoggerContext(this.logger)}rpcPublish(e,t,i,s,n,a,o){var h,d,l,D;const b={method:ut$3(s.protocol).publish,params:{topic:e,message:t,ttl:i,prompt:n,tag:a},id:o};return I$4((h=b.params)==null?void 0:h.prompt)&&((d=b.params)==null||delete d.prompt),I$4((l=b.params)==null?void 0:l.tag)&&((D=b.params)==null||delete D.tag),this.logger.debug("Outgoing Relay Payload"),this.logger.trace({type:"message",direction:"outgoing",request:b}),this.relayer.request(b)}onPublish(e){this.queue.delete(e);}checkQueue(){this.queue.forEach(async e=>{const{topic:t,message:i,opts:s}=e;await this.publish(t,i,s);});}registerEventListeners(){this.relayer.core.heartbeat.on(cjs$2.HEARTBEAT_EVENTS.pulse,()=>{if(this.needsTransportRestart){this.needsTransportRestart=!1,this.relayer.events.emit(g$3.connection_stalled);return}this.checkQueue();}),this.relayer.on(g$3.message_ack,e=>{this.onPublish(e.id.toString());});}};let dr$1 = class dr{constructor(){this.map=new Map,this.set=(e,t)=>{const i=this.get(e);this.exists(e,t)||this.map.set(e,[...i,t]);},this.get=e=>this.map.get(e)||[],this.exists=(e,t)=>this.get(e).includes(t),this.delete=(e,t)=>{if(typeof t>"u"){this.map.delete(e);return}if(!this.map.has(e))return;const i=this.get(e);if(!this.exists(e,t))return;const s=i.filter(n=>n!==t);if(!s.length){this.map.delete(e);return}this.map.set(e,s);},this.clear=()=>{this.map.clear();};}get topics(){return Array.from(this.map.keys())}};var gr=Object.defineProperty,pr=Object.defineProperties,Dr=Object.getOwnPropertyDescriptors,_t$1=Object.getOwnPropertySymbols,yr=Object.prototype.hasOwnProperty,br=Object.prototype.propertyIsEnumerable,Rt$1=(r,e,t)=>e in r?gr(r,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):r[e]=t,K$2=(r,e)=>{for(var t in e||(e={}))yr.call(e,t)&&Rt$1(r,t,e[t]);if(_t$1)for(var t of _t$1(e))br.call(e,t)&&Rt$1(r,t,e[t]);return r},pe$1=(r,e)=>pr(r,Dr(e));let Tt$1 = class Tt extends d$4{constructor(e,t){super(e,t),this.relayer=e,this.logger=t,this.subscriptions=new Map,this.topicMap=new dr$1,this.events=new eventsExports.EventEmitter,this.name=gt$1,this.version=pt$1,this.pending=new Map,this.cached=[],this.initialized=!1,this.pendingSubscriptionWatchLabel="pending_sub_watch_label",this.pollingInterval=20,this.storagePrefix=O$3,this.subscribeTimeout=1e4,this.restartInProgress=!1,this.batchSubscribeTopicsLimit=500,this.init=async()=>{this.initialized||(this.logger.trace("Initialized"),await this.restart(),this.registerEventListeners(),this.onEnable(),this.clientId=await this.relayer.core.crypto.getClientId());},this.subscribe=async(i,s)=>{await this.restartToComplete(),this.isInitialized(),this.logger.debug("Subscribing Topic"),this.logger.trace({type:"method",method:"subscribe",params:{topic:i,opts:s}});try{const n=at$3(s),a={topic:i,relay:n};this.pending.set(i,a);const o=await this.rpcSubscribe(i,n);return this.onSubscribe(o,a),this.logger.debug("Successfully Subscribed Topic"),this.logger.trace({type:"method",method:"subscribe",params:{topic:i,opts:s}}),o}catch(n){throw this.logger.debug("Failed to Subscribe Topic"),this.logger.error(n),n}},this.unsubscribe=async(i,s)=>{await this.restartToComplete(),this.isInitialized(),typeof s?.id<"u"?await this.unsubscribeById(i,s.id,s):await this.unsubscribeByTopic(i,s);},this.isSubscribed=async i=>this.topics.includes(i)?!0:await new Promise((s,n)=>{const a=new cjs$6.Watch;a.start(this.pendingSubscriptionWatchLabel);const o=setInterval(()=>{!this.pending.has(i)&&this.topics.includes(i)&&(clearInterval(o),a.stop(this.pendingSubscriptionWatchLabel),s(!0)),a.elapsed(this.pendingSubscriptionWatchLabel)>=Dt$1&&(clearInterval(o),a.stop(this.pendingSubscriptionWatchLabel),n(new Error("Subscription resolution timeout")));},this.pollingInterval);}).catch(()=>!1),this.on=(i,s)=>{this.events.on(i,s);},this.once=(i,s)=>{this.events.once(i,s);},this.off=(i,s)=>{this.events.off(i,s);},this.removeListener=(i,s)=>{this.events.removeListener(i,s);},this.restart=async()=>{this.restartInProgress=!0,await this.restore(),await this.reset(),this.restartInProgress=!1;},this.relayer=e,this.logger=cjs$1.generateChildLogger(t,this.name),this.clientId="";}get context(){return cjs$1.getLoggerContext(this.logger)}get storageKey(){return this.storagePrefix+this.version+"//"+this.name}get length(){return this.subscriptions.size}get ids(){return Array.from(this.subscriptions.keys())}get values(){return Array.from(this.subscriptions.values())}get topics(){return this.topicMap.topics}hasSubscription(e,t){let i=!1;try{i=this.getSubscription(e).topic===t;}catch{}return i}onEnable(){this.cached=[],this.initialized=!0;}onDisable(){this.cached=this.values,this.subscriptions.clear(),this.topicMap.clear();}async unsubscribeByTopic(e,t){const i=this.topicMap.get(e);await Promise.all(i.map(async s=>await this.unsubscribeById(e,s,t)));}async unsubscribeById(e,t,i){this.logger.debug("Unsubscribing Topic"),this.logger.trace({type:"method",method:"unsubscribe",params:{topic:e,id:t,opts:i}});try{const s=at$3(i);await this.rpcUnsubscribe(e,t,s);const n=w$5("USER_DISCONNECTED",`${this.name}, ${e}`);await this.onUnsubscribe(e,t,n),this.logger.debug("Successfully Unsubscribed Topic"),this.logger.trace({type:"method",method:"unsubscribe",params:{topic:e,id:t,opts:i}});}catch(s){throw this.logger.debug("Failed to Unsubscribe Topic"),this.logger.error(s),s}}async rpcSubscribe(e,t){const i={method:ut$3(t.protocol).subscribe,params:{topic:e}};this.logger.debug("Outgoing Relay Payload"),this.logger.trace({type:"payload",direction:"outgoing",request:i});try{await await et$3(this.relayer.request(i),this.subscribeTimeout);}catch{this.logger.debug("Outgoing Relay Subscribe Payload stalled"),this.relayer.events.emit(g$3.connection_stalled);}return $n$1(e+this.clientId)}async rpcBatchSubscribe(e){if(!e.length)return;const t=e[0].relay,i={method:ut$3(t.protocol).batchSubscribe,params:{topics:e.map(s=>s.topic)}};this.logger.debug("Outgoing Relay Payload"),this.logger.trace({type:"payload",direction:"outgoing",request:i});try{return await await et$3(this.relayer.request(i),this.subscribeTimeout)}catch{this.logger.debug("Outgoing Relay Payload stalled"),this.relayer.events.emit(g$3.connection_stalled);}}rpcUnsubscribe(e,t,i){const s={method:ut$3(i.protocol).unsubscribe,params:{topic:e,id:t}};return this.logger.debug("Outgoing Relay Payload"),this.logger.trace({type:"payload",direction:"outgoing",request:s}),this.relayer.request(s)}onSubscribe(e,t){this.setSubscription(e,pe$1(K$2({},t),{id:e})),this.pending.delete(t.topic);}onBatchSubscribe(e){e.length&&e.forEach(t=>{this.setSubscription(t.id,K$2({},t)),this.pending.delete(t.topic);});}async onUnsubscribe(e,t,i){this.events.removeAllListeners(t),this.hasSubscription(t,e)&&this.deleteSubscription(t,i),await this.relayer.messages.del(e);}async setRelayerSubscriptions(e){await this.relayer.core.storage.setItem(this.storageKey,e);}async getRelayerSubscriptions(){return await this.relayer.core.storage.getItem(this.storageKey)}setSubscription(e,t){this.subscriptions.has(e)||(this.logger.debug("Setting subscription"),this.logger.trace({type:"method",method:"setSubscription",id:e,subscription:t}),this.addSubscription(e,t));}addSubscription(e,t){this.subscriptions.set(e,K$2({},t)),this.topicMap.set(t.topic,e),this.events.emit(C$3.created,t);}getSubscription(e){this.logger.debug("Getting subscription"),this.logger.trace({type:"method",method:"getSubscription",id:e});const t=this.subscriptions.get(e);if(!t){const{message:i}=b$6("NO_MATCHING_KEY",`${this.name}: ${e}`);throw new Error(i)}return t}deleteSubscription(e,t){this.logger.debug("Deleting subscription"),this.logger.trace({type:"method",method:"deleteSubscription",id:e,reason:t});const i=this.getSubscription(e);this.subscriptions.delete(e),this.topicMap.delete(i.topic,e),this.events.emit(C$3.deleted,pe$1(K$2({},i),{reason:t}));}async persist(){await this.setRelayerSubscriptions(this.values),this.events.emit(C$3.sync);}async reset(){if(this.cached.length){const e=Math.ceil(this.cached.length/this.batchSubscribeTopicsLimit);for(let t=0;t<e;t++){const i=this.cached.splice(0,this.batchSubscribeTopicsLimit);await this.batchSubscribe(i);}}this.events.emit(C$3.resubscribed);}async restore(){try{const e=await this.getRelayerSubscriptions();if(typeof e>"u"||!e.length)return;if(this.subscriptions.size){const{message:t}=b$6("RESTORE_WILL_OVERRIDE",this.name);throw this.logger.error(t),this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`),new Error(t)}this.cached=e,this.logger.debug(`Successfully Restored subscriptions for ${this.name}`),this.logger.trace({type:"method",method:"restore",subscriptions:this.values});}catch(e){this.logger.debug(`Failed to Restore subscriptions for ${this.name}`),this.logger.error(e);}}async batchSubscribe(e){if(!e.length)return;const t=await this.rpcBatchSubscribe(e);C$5(t)&&this.onBatchSubscribe(t.map((i,s)=>pe$1(K$2({},e[s]),{id:i})));}async onConnect(){this.restartInProgress||(await this.restart(),this.onEnable());}onDisconnect(){this.onDisable();}async checkPending(){if(this.relayer.transportExplicitlyClosed)return;const e=[];this.pending.forEach(t=>{e.push(t);}),await this.batchSubscribe(e);}registerEventListeners(){this.relayer.core.heartbeat.on(cjs$2.HEARTBEAT_EVENTS.pulse,async()=>{await this.checkPending();}),this.relayer.on(g$3.connect,async()=>{await this.onConnect();}),this.relayer.on(g$3.disconnect,()=>{this.onDisconnect();}),this.events.on(C$3.created,async e=>{const t=C$3.created;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,data:e}),await this.persist();}),this.events.on(C$3.deleted,async e=>{const t=C$3.deleted;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,data:e}),await this.persist();});}isInitialized(){if(!this.initialized){const{message:e}=b$6("NOT_INITIALIZED",this.name);throw new Error(e)}}async restartToComplete(){this.restartInProgress&&await new Promise(e=>{const t=setInterval(()=>{this.restartInProgress||(clearInterval(t),e());},this.pollingInterval);});}};var mr$1=Object.defineProperty,St$1=Object.getOwnPropertySymbols,Er=Object.prototype.hasOwnProperty,fr$1=Object.prototype.propertyIsEnumerable,Pt$1=(r,e,t)=>e in r?mr$1(r,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):r[e]=t,wr=(r,e)=>{for(var t in e||(e={}))Er.call(e,t)&&Pt$1(r,t,e[t]);if(St$1)for(var t of St$1(e))fr$1.call(e,t)&&Pt$1(r,t,e[t]);return r};let Ot$1 = class Ot extends g$4{constructor(e){super(e),this.protocol="wc",this.version=2,this.events=new eventsExports.EventEmitter,this.name=at$1,this.transportExplicitlyClosed=!1,this.initialized=!1,this.reconnecting=!1,this.connectionStatusPollingInterval=20,this.staleConnectionErrors=["socket hang up","socket stalled"],this.request=async t=>{this.logger.debug("Publishing Request Payload");try{return await this.toEstablishConnection(),await this.provider.request(t)}catch(i){throw this.logger.debug("Failed to Publish Request"),this.logger.error(i),i}},this.core=e.core,this.logger=typeof e.logger<"u"&&typeof e.logger!="string"?cjs$1.generateChildLogger(e.logger,this.name):cjs$1.pino(cjs$1.getDefaultLoggerOptions({level:e.logger||nt$1})),this.messages=new Ct$1(this.logger,e.core),this.subscriber=new Tt$1(this,this.logger),this.publisher=new lr$1(this,this.logger),this.relayUrl=e?.relayUrl||le$1,this.projectId=e.projectId,this.provider={};}async init(){this.logger.trace("Initialized"),await this.createProvider(),await Promise.all([this.messages.init(),this.subscriber.init()]);try{await this.transportOpen();}catch{this.logger.warn(`Connection via ${this.relayUrl} failed, attempting to connect via failover domain ${de$1}...`),await this.restartTransport(de$1);}this.registerEventListeners(),this.initialized=!0,setTimeout(async()=>{this.subscriber.topics.length===0&&(this.logger.info("No topics subscribed to after init, closing transport"),await this.transportClose(),this.transportExplicitlyClosed=!1);},ut$1);}get context(){return cjs$1.getLoggerContext(this.logger)}get connected(){return this.provider.connection.connected}get connecting(){return this.provider.connection.connecting}async publish(e,t,i){this.isInitialized(),await this.publisher.publish(e,t,i),await this.recordMessageEvent({topic:e,message:t,publishedAt:Date.now()});}async subscribe(e,t){var i;this.isInitialized();let s=((i=this.subscriber.topicMap.get(e))==null?void 0:i[0])||"";return s||(await Promise.all([new Promise(n=>{this.subscriber.once(C$3.created,a=>{a.topic===e&&n();});}),new Promise(async n=>{s=await this.subscriber.subscribe(e,t),n();})]),s)}async unsubscribe(e,t){this.isInitialized(),await this.subscriber.unsubscribe(e,t);}on(e,t){this.events.on(e,t);}once(e,t){this.events.once(e,t);}off(e,t){this.events.off(e,t);}removeListener(e,t){this.events.removeListener(e,t);}async transportClose(){this.transportExplicitlyClosed=!0,this.connected&&(await this.provider.disconnect(),this.events.emit(g$3.transport_closed));}async transportOpen(e){if(this.transportExplicitlyClosed=!1,!this.reconnecting){this.relayUrl=e||this.relayUrl,this.reconnecting=!0;try{await Promise.all([new Promise(t=>{this.initialized||t(),this.subscriber.once(C$3.resubscribed,()=>{t();});}),await Promise.race([new Promise(async(t,i)=>{await et$3(this.provider.connect(),5e3,`Socket stalled when trying to connect to ${this.relayUrl}`).catch(s=>i(s)).then(()=>t()).finally(()=>this.removeListener(g$3.transport_closed,this.rejectTransportOpen));}),new Promise(t=>this.once(g$3.transport_closed,this.rejectTransportOpen))])]);}catch(t){this.logger.error(t);const i=t;if(!this.isConnectionStalled(i.message))throw t;this.events.emit(g$3.transport_closed);}finally{this.reconnecting=!1;}}}async restartTransport(e){this.transportExplicitlyClosed||this.reconnecting||(this.relayUrl=e||this.relayUrl,this.connected&&await Promise.all([new Promise(t=>{this.provider.once(L$4.disconnect,()=>{t();});}),this.transportClose()]),await this.createProvider(),await this.transportOpen());}isConnectionStalled(e){return this.staleConnectionErrors.some(t=>e.includes(t))}rejectTransportOpen(){throw new Error("Attempt to connect to relay via `transportOpen` has stalled. Retrying...")}async createProvider(){const e=await this.core.crypto.signJWT(this.relayUrl);this.provider=new JsonRpcProvider(new WsConnection(qn$1({sdkVersion:ct$1,protocol:this.protocol,version:this.version,relayUrl:this.relayUrl,projectId:this.projectId,auth:e,useOnCloseEvent:!0}))),this.registerProviderListeners();}async recordMessageEvent(e){const{topic:t,message:i}=e;await this.messages.set(t,i);}async shouldIgnoreMessageEvent(e){const{topic:t,message:i}=e;return await this.subscriber.isSubscribed(t)?this.messages.has(t,i):!0}async onProviderPayload(e){if(this.logger.debug("Incoming Relay Payload"),this.logger.trace({type:"payload",direction:"incoming",payload:e}),isJsonRpcRequest(e)){if(!e.method.endsWith(ot$2))return;const t=e.params,{topic:i,message:s,publishedAt:n}=t.data,a={topic:i,message:s,publishedAt:n};this.logger.debug("Emitting Relayer Payload"),this.logger.trace(wr({type:"event",event:t.id},a)),this.events.emit(t.id,a),await this.acknowledgePayload(e),await this.onMessageEvent(a);}else isJsonRpcResponse(e)&&this.events.emit(g$3.message_ack,e);}async onMessageEvent(e){await this.shouldIgnoreMessageEvent(e)||(this.events.emit(g$3.message,e),await this.recordMessageEvent(e));}async acknowledgePayload(e){const t=formatJsonRpcResult(e.id,!0);await this.provider.connection.send(t);}registerProviderListeners(){this.provider.on(L$4.payload,e=>this.onProviderPayload(e)),this.provider.on(L$4.connect,()=>{this.events.emit(g$3.connect);}),this.provider.on(L$4.disconnect,()=>{this.onProviderDisconnect();}),this.provider.on(L$4.error,e=>{this.logger.error(e),this.events.emit(g$3.error,e);});}registerEventListeners(){this.events.on(g$3.connection_stalled,async()=>{await this.restartTransport();});}onProviderDisconnect(){this.events.emit(g$3.disconnect),this.attemptToReconnect();}attemptToReconnect(){this.transportExplicitlyClosed||setTimeout(async()=>{await this.restartTransport();},cjs$6.toMiliseconds(ht$1));}isInitialized(){if(!this.initialized){const{message:e}=b$6("NOT_INITIALIZED",this.name);throw new Error(e)}}async toEstablishConnection(){if(!this.connected){if(this.connecting)return await new Promise(e=>{const t=setInterval(()=>{this.connected&&(clearInterval(t),e());},this.connectionStatusPollingInterval);});await this.restartTransport();}}};var vr=Object.defineProperty,xt$1=Object.getOwnPropertySymbols,Ir=Object.prototype.hasOwnProperty,Cr=Object.prototype.propertyIsEnumerable,At$1=(r,e,t)=>e in r?vr(r,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):r[e]=t,zt$1=(r,e)=>{for(var t in e||(e={}))Ir.call(e,t)&&At$1(r,t,e[t]);if(xt$1)for(var t of xt$1(e))Cr.call(e,t)&&At$1(r,t,e[t]);return r};let Nt$1 = class Nt extends p$3{constructor(e,t,i,s=O$3,n=void 0){super(e,t,i,s),this.core=e,this.logger=t,this.name=i,this.map=new Map,this.version=lt$1,this.cached=[],this.initialized=!1,this.storagePrefix=O$3,this.init=async()=>{this.initialized||(this.logger.trace("Initialized"),await this.restore(),this.cached.forEach(a=>{this.getKey&&a!==null&&!I$4(a)?this.map.set(this.getKey(a),a):At$2(a)?this.map.set(a.id,a):Ut$2(a)&&this.map.set(a.topic,a);}),this.cached=[],this.initialized=!0);},this.set=async(a,o)=>{this.isInitialized(),this.map.has(a)?await this.update(a,o):(this.logger.debug("Setting value"),this.logger.trace({type:"method",method:"set",key:a,value:o}),this.map.set(a,o),await this.persist());},this.get=a=>(this.isInitialized(),this.logger.debug("Getting value"),this.logger.trace({type:"method",method:"get",key:a}),this.getData(a)),this.getAll=a=>(this.isInitialized(),a?this.values.filter(o=>Object.keys(a).every(h=>Li(o[h],a[h]))):this.values),this.update=async(a,o)=>{this.isInitialized(),this.logger.debug("Updating value"),this.logger.trace({type:"method",method:"update",key:a,update:o});const h=zt$1(zt$1({},this.getData(a)),o);this.map.set(a,h),await this.persist();},this.delete=async(a,o)=>{this.isInitialized(),this.map.has(a)&&(this.logger.debug("Deleting value"),this.logger.trace({type:"method",method:"delete",key:a,reason:o}),this.map.delete(a),await this.persist());},this.logger=cjs$1.generateChildLogger(t,this.name),this.storagePrefix=s,this.getKey=n;}get context(){return cjs$1.getLoggerContext(this.logger)}get storageKey(){return this.storagePrefix+this.version+"//"+this.name}get length(){return this.map.size}get keys(){return Array.from(this.map.keys())}get values(){return Array.from(this.map.values())}async setDataStore(e){await this.core.storage.setItem(this.storageKey,e);}async getDataStore(){return await this.core.storage.getItem(this.storageKey)}getData(e){const t=this.map.get(e);if(!t){const{message:i}=b$6("NO_MATCHING_KEY",`${this.name}: ${e}`);throw this.logger.error(i),new Error(i)}return t}async persist(){await this.setDataStore(this.values);}async restore(){try{const e=await this.getDataStore();if(typeof e>"u"||!e.length)return;if(this.map.size){const{message:t}=b$6("RESTORE_WILL_OVERRIDE",this.name);throw this.logger.error(t),new Error(t)}this.cached=e,this.logger.debug(`Successfully Restored value for ${this.name}`),this.logger.trace({type:"method",method:"restore",value:this.values});}catch(e){this.logger.debug(`Failed to Restore value for ${this.name}`),this.logger.error(e);}}isInitialized(){if(!this.initialized){const{message:e}=b$6("NOT_INITIALIZED",this.name);throw new Error(e)}}};let Ut$1 = class Ut{constructor(e,t){this.core=e,this.logger=t,this.name=yt$1,this.version=bt$1,this.events=new Ng,this.initialized=!1,this.storagePrefix=O$3,this.ignoredPayloadTypes=[U$4],this.registeredMethods=[],this.init=async()=>{this.initialized||(await this.pairings.init(),await this.cleanup(),this.registerRelayerEvents(),this.registerExpirerEvents(),this.initialized=!0,this.logger.trace("Initialized"));},this.register=({methods:i})=>{this.isInitialized(),this.registeredMethods=[...new Set([...this.registeredMethods,...i])];},this.create=async()=>{this.isInitialized();const i=An$1(),s=await this.core.crypto.setSymKey(i),n=ot$4(cjs$6.FIVE_MINUTES),a={protocol:rt$1},o={topic:s,expiry:n,relay:a,active:!1},h=yt$3({protocol:this.core.protocol,version:this.core.version,topic:s,symKey:i,relay:a});return await this.pairings.set(s,o),await this.core.relayer.subscribe(s),this.core.expirer.set(s,n),{topic:s,uri:h}},this.pair=async i=>{this.isInitialized(),this.isValidPair(i);const{topic:s,symKey:n,relay:a}=mt$2(i.uri);if(this.pairings.keys.includes(s))throw new Error(`Pairing already exists: ${s}`);if(this.core.crypto.hasKeys(s))throw new Error(`Keychain already exists: ${s}`);const o=ot$4(cjs$6.FIVE_MINUTES),h={topic:s,relay:a,expiry:o,active:!1};return await this.pairings.set(s,h),await this.core.crypto.setSymKey(n,s),await this.core.relayer.subscribe(s,{relay:a}),this.core.expirer.set(s,o),i.activatePairing&&await this.activate({topic:s}),h},this.activate=async({topic:i})=>{this.isInitialized();const s=ot$4(cjs$6.THIRTY_DAYS);await this.pairings.update(i,{active:!0,expiry:s}),this.core.expirer.set(i,s);},this.ping=async i=>{this.isInitialized(),await this.isValidPing(i);const{topic:s}=i;if(this.pairings.keys.includes(s)){const n=await this.sendRequest(s,"wc_pairingPing",{}),{done:a,resolve:o,reject:h}=Xn$1();this.events.once(it$3("pairing_ping",n),({error:d})=>{d?h(d):o();}),await a();}},this.updateExpiry=async({topic:i,expiry:s})=>{this.isInitialized(),await this.pairings.update(i,{expiry:s});},this.updateMetadata=async({topic:i,metadata:s})=>{this.isInitialized(),await this.pairings.update(i,{peerMetadata:s});},this.getPairings=()=>(this.isInitialized(),this.pairings.values),this.disconnect=async i=>{this.isInitialized(),await this.isValidDisconnect(i);const{topic:s}=i;this.pairings.keys.includes(s)&&(await this.sendRequest(s,"wc_pairingDelete",w$5("USER_DISCONNECTED")),await this.deletePairing(s));},this.sendRequest=async(i,s,n)=>{const a=formatJsonRpcRequest(s,n),o=await this.core.crypto.encode(i,a),h=F$1[s].req;return this.core.history.set(i,a),this.core.relayer.publish(i,o,h),a.id},this.sendResult=async(i,s,n)=>{const a=formatJsonRpcResult(i,n),o=await this.core.crypto.encode(s,a),h=await this.core.history.get(s,i),d=F$1[h.request.method].res;await this.core.relayer.publish(s,o,d),await this.core.history.resolve(a);},this.sendError=async(i,s,n)=>{const a=formatJsonRpcError(i,n),o=await this.core.crypto.encode(s,a),h=await this.core.history.get(s,i),d=F$1[h.request.method]?F$1[h.request.method].res:F$1.unregistered_method.res;await this.core.relayer.publish(s,o,d),await this.core.history.resolve(a);},this.deletePairing=async(i,s)=>{await this.core.relayer.unsubscribe(i),await Promise.all([this.pairings.delete(i,w$5("USER_DISCONNECTED")),this.core.crypto.deleteSymKey(i),s?Promise.resolve():this.core.expirer.del(i)]);},this.cleanup=async()=>{const i=this.pairings.getAll().filter(s=>st$3(s.expiry));await Promise.all(i.map(s=>this.deletePairing(s.topic)));},this.onRelayEventRequest=i=>{const{topic:s,payload:n}=i,a=n.method;if(this.pairings.keys.includes(s))switch(a){case"wc_pairingPing":return this.onPairingPingRequest(s,n);case"wc_pairingDelete":return this.onPairingDeleteRequest(s,n);default:return this.onUnknownRpcMethodRequest(s,n)}},this.onRelayEventResponse=async i=>{const{topic:s,payload:n}=i,a=(await this.core.history.get(s,n.id)).request.method;if(this.pairings.keys.includes(s))switch(a){case"wc_pairingPing":return this.onPairingPingResponse(s,n);default:return this.onUnknownRpcMethodResponse(a)}},this.onPairingPingRequest=async(i,s)=>{const{id:n}=s;try{this.isValidPing({topic:i}),await this.sendResult(n,i,!0),this.events.emit("pairing_ping",{id:n,topic:i});}catch(a){await this.sendError(n,i,a),this.logger.error(a);}},this.onPairingPingResponse=(i,s)=>{const{id:n}=s;setTimeout(()=>{isJsonRpcResult(s)?this.events.emit(it$3("pairing_ping",n),{}):isJsonRpcError(s)&&this.events.emit(it$3("pairing_ping",n),{error:s.error});},500);},this.onPairingDeleteRequest=async(i,s)=>{const{id:n}=s;try{this.isValidDisconnect({topic:i}),await this.deletePairing(i),this.events.emit("pairing_delete",{id:n,topic:i});}catch(a){await this.sendError(n,i,a),this.logger.error(a);}},this.onUnknownRpcMethodRequest=async(i,s)=>{const{id:n,method:a}=s;try{if(this.registeredMethods.includes(a))return;const o=w$5("WC_METHOD_UNSUPPORTED",a);await this.sendError(n,i,o),this.logger.error(o);}catch(o){await this.sendError(n,i,o),this.logger.error(o);}},this.onUnknownRpcMethodResponse=i=>{this.registeredMethods.includes(i)||this.logger.error(w$5("WC_METHOD_UNSUPPORTED",i));},this.isValidPair=i=>{if(!Dt$2(i)){const{message:s}=b$6("MISSING_OR_INVALID",`pair() params: ${i}`);throw new Error(s)}if(!wt$2(i.uri)){const{message:s}=b$6("MISSING_OR_INVALID",`pair() uri: ${i.uri}`);throw new Error(s)}},this.isValidPing=async i=>{if(!Dt$2(i)){const{message:n}=b$6("MISSING_OR_INVALID",`ping() params: ${i}`);throw new Error(n)}const{topic:s}=i;await this.isValidPairingTopic(s);},this.isValidDisconnect=async i=>{if(!Dt$2(i)){const{message:n}=b$6("MISSING_OR_INVALID",`disconnect() params: ${i}`);throw new Error(n)}const{topic:s}=i;await this.isValidPairingTopic(s);},this.isValidPairingTopic=async i=>{if(!m$5(i,!1)){const{message:s}=b$6("MISSING_OR_INVALID",`pairing topic should be a string: ${i}`);throw new Error(s)}if(!this.pairings.keys.includes(i)){const{message:s}=b$6("NO_MATCHING_KEY",`pairing topic doesn't exist: ${i}`);throw new Error(s)}if(st$3(this.pairings.get(i).expiry)){await this.deletePairing(i);const{message:s}=b$6("EXPIRED",`pairing topic: ${i}`);throw new Error(s)}},this.core=e,this.logger=cjs$1.generateChildLogger(t,this.name),this.pairings=new Nt$1(this.core,this.logger,this.name,this.storagePrefix);}get context(){return cjs$1.getLoggerContext(this.logger)}isInitialized(){if(!this.initialized){const{message:e}=b$6("NOT_INITIALIZED",this.name);throw new Error(e)}}registerRelayerEvents(){this.core.relayer.on(g$3.message,async e=>{const{topic:t,message:i}=e;if(this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i)))return;const s=await this.core.crypto.decode(t,i);isJsonRpcRequest(s)?(this.core.history.set(t,s),this.onRelayEventRequest({topic:t,payload:s})):isJsonRpcResponse(s)&&(await this.core.history.resolve(s),await this.onRelayEventResponse({topic:t,payload:s}),this.core.history.delete(t,s.id));});}registerExpirerEvents(){this.core.expirer.on(w$2.expired,async e=>{const{topic:t}=rt$3(e.target);t&&this.pairings.keys.includes(t)&&(await this.deletePairing(t,!0),this.events.emit("pairing_expire",{topic:t}));});}};let Lt$1 = class Lt extends h$4{constructor(e,t){super(e,t),this.core=e,this.logger=t,this.records=new Map,this.events=new eventsExports.EventEmitter,this.name=mt$1,this.version=Et$1,this.cached=[],this.initialized=!1,this.storagePrefix=O$3,this.init=async()=>{this.initialized||(this.logger.trace("Initialized"),await this.restore(),this.cached.forEach(i=>this.records.set(i.id,i)),this.cached=[],this.registerEventListeners(),this.initialized=!0);},this.set=(i,s,n)=>{if(this.isInitialized(),this.logger.debug("Setting JSON-RPC request history record"),this.logger.trace({type:"method",method:"set",topic:i,request:s,chainId:n}),this.records.has(s.id))return;const a={id:s.id,topic:i,request:{method:s.method,params:s.params||null},chainId:n,expiry:ot$4(cjs$6.THIRTY_DAYS)};this.records.set(a.id,a),this.events.emit(_$4.created,a);},this.resolve=async i=>{if(this.isInitialized(),this.logger.debug("Updating JSON-RPC response history record"),this.logger.trace({type:"method",method:"update",response:i}),!this.records.has(i.id))return;const s=await this.getRecord(i.id);typeof s.response>"u"&&(s.response=isJsonRpcError(i)?{error:i.error}:{result:i.result},this.records.set(s.id,s),this.events.emit(_$4.updated,s));},this.get=async(i,s)=>(this.isInitialized(),this.logger.debug("Getting record"),this.logger.trace({type:"method",method:"get",topic:i,id:s}),await this.getRecord(s)),this.delete=(i,s)=>{this.isInitialized(),this.logger.debug("Deleting record"),this.logger.trace({type:"method",method:"delete",id:s}),this.values.forEach(n=>{if(n.topic===i){if(typeof s<"u"&&n.id!==s)return;this.records.delete(n.id),this.events.emit(_$4.deleted,n);}});},this.exists=async(i,s)=>(this.isInitialized(),this.records.has(s)?(await this.getRecord(s)).topic===i:!1),this.on=(i,s)=>{this.events.on(i,s);},this.once=(i,s)=>{this.events.once(i,s);},this.off=(i,s)=>{this.events.off(i,s);},this.removeListener=(i,s)=>{this.events.removeListener(i,s);},this.logger=cjs$1.generateChildLogger(t,this.name);}get context(){return cjs$1.getLoggerContext(this.logger)}get storageKey(){return this.storagePrefix+this.version+"//"+this.name}get size(){return this.records.size}get keys(){return Array.from(this.records.keys())}get values(){return Array.from(this.records.values())}get pending(){const e=[];return this.values.forEach(t=>{if(typeof t.response<"u")return;const i={topic:t.topic,request:formatJsonRpcRequest(t.request.method,t.request.params,t.id),chainId:t.chainId};return e.push(i)}),e}async setJsonRpcRecords(e){await this.core.storage.setItem(this.storageKey,e);}async getJsonRpcRecords(){return await this.core.storage.getItem(this.storageKey)}getRecord(e){this.isInitialized();const t=this.records.get(e);if(!t){const{message:i}=b$6("NO_MATCHING_KEY",`${this.name}: ${e}`);throw new Error(i)}return t}async persist(){await this.setJsonRpcRecords(this.values),this.events.emit(_$4.sync);}async restore(){try{const e=await this.getJsonRpcRecords();if(typeof e>"u"||!e.length)return;if(this.records.size){const{message:t}=b$6("RESTORE_WILL_OVERRIDE",this.name);throw this.logger.error(t),new Error(t)}this.cached=e,this.logger.debug(`Successfully Restored records for ${this.name}`),this.logger.trace({type:"method",method:"restore",records:this.values});}catch(e){this.logger.debug(`Failed to Restore records for ${this.name}`),this.logger.error(e);}}registerEventListeners(){this.events.on(_$4.created,e=>{const t=_$4.created;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,record:e}),this.persist();}),this.events.on(_$4.updated,e=>{const t=_$4.updated;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,record:e}),this.persist();}),this.events.on(_$4.deleted,e=>{const t=_$4.deleted;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,record:e}),this.persist();}),this.core.heartbeat.on(cjs$2.HEARTBEAT_EVENTS.pulse,()=>{this.cleanup();});}cleanup(){try{this.records.forEach(e=>{cjs$6.toMiliseconds(e.expiry||0)-Date.now()<=0&&(this.logger.info(`Deleting expired history log: ${e.id}`),this.delete(e.topic,e.id));});}catch(e){this.logger.warn(e);}}isInitialized(){if(!this.initialized){const{message:e}=b$6("NOT_INITIALIZED",this.name);throw new Error(e)}}};let Ft$1 = class Ft extends E$2{constructor(e,t){super(e,t),this.core=e,this.logger=t,this.expirations=new Map,this.events=new eventsExports.EventEmitter,this.name=ft$1,this.version=wt$1,this.cached=[],this.initialized=!1,this.storagePrefix=O$3,this.init=async()=>{this.initialized||(this.logger.trace("Initialized"),await this.restore(),this.cached.forEach(i=>this.expirations.set(i.target,i)),this.cached=[],this.registerEventListeners(),this.initialized=!0);},this.has=i=>{try{const s=this.formatTarget(i);return typeof this.getExpiration(s)<"u"}catch{return !1}},this.set=(i,s)=>{this.isInitialized();const n=this.formatTarget(i),a={target:n,expiry:s};this.expirations.set(n,a),this.checkExpiry(n,a),this.events.emit(w$2.created,{target:n,expiration:a});},this.get=i=>{this.isInitialized();const s=this.formatTarget(i);return this.getExpiration(s)},this.del=i=>{if(this.isInitialized(),this.has(i)){const s=this.formatTarget(i),n=this.getExpiration(s);this.expirations.delete(s),this.events.emit(w$2.deleted,{target:s,expiration:n});}},this.on=(i,s)=>{this.events.on(i,s);},this.once=(i,s)=>{this.events.once(i,s);},this.off=(i,s)=>{this.events.off(i,s);},this.removeListener=(i,s)=>{this.events.removeListener(i,s);},this.logger=cjs$1.generateChildLogger(t,this.name);}get context(){return cjs$1.getLoggerContext(this.logger)}get storageKey(){return this.storagePrefix+this.version+"//"+this.name}get length(){return this.expirations.size}get keys(){return Array.from(this.expirations.keys())}get values(){return Array.from(this.expirations.values())}formatTarget(e){if(typeof e=="string")return nt$3(e);if(typeof e=="number")return tt$3(e);const{message:t}=b$6("UNKNOWN_TYPE",`Target type: ${typeof e}`);throw new Error(t)}async setExpirations(e){await this.core.storage.setItem(this.storageKey,e);}async getExpirations(){return await this.core.storage.getItem(this.storageKey)}async persist(){await this.setExpirations(this.values),this.events.emit(w$2.sync);}async restore(){try{const e=await this.getExpirations();if(typeof e>"u"||!e.length)return;if(this.expirations.size){const{message:t}=b$6("RESTORE_WILL_OVERRIDE",this.name);throw this.logger.error(t),new Error(t)}this.cached=e,this.logger.debug(`Successfully Restored expirations for ${this.name}`),this.logger.trace({type:"method",method:"restore",expirations:this.values});}catch(e){this.logger.debug(`Failed to Restore expirations for ${this.name}`),this.logger.error(e);}}getExpiration(e){const t=this.expirations.get(e);if(!t){const{message:i}=b$6("NO_MATCHING_KEY",`${this.name}: ${e}`);throw this.logger.error(i),new Error(i)}return t}checkExpiry(e,t){const{expiry:i}=t;cjs$6.toMiliseconds(i)-Date.now()<=0&&this.expire(e,t);}expire(e,t){this.expirations.delete(e),this.events.emit(w$2.expired,{target:e,expiration:t});}checkExpirations(){this.core.relayer.connected&&this.expirations.forEach((e,t)=>this.checkExpiry(t,e));}registerEventListeners(){this.core.heartbeat.on(cjs$2.HEARTBEAT_EVENTS.pulse,()=>this.checkExpirations()),this.events.on(w$2.created,e=>{const t=w$2.created;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,data:e}),this.persist();}),this.events.on(w$2.expired,e=>{const t=w$2.expired;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,data:e}),this.persist();}),this.events.on(w$2.deleted,e=>{const t=w$2.deleted;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,data:e}),this.persist();});}isInitialized(){if(!this.initialized){const{message:e}=b$6("NOT_INITIALIZED",this.name);throw new Error(e)}}};let $t$1 = class $t extends y$4{constructor(e,t){super(e,t),this.projectId=e,this.logger=t,this.name=X$2,this.initialized=!1,this.init=async i=>{$e$3()||!je$3()||(this.verifyUrl=i?.verifyUrl||ge,await this.createIframe());},this.register=async i=>{var s;if(this.initialized||await this.init(),!!this.iframe)try{(s=this.iframe.contentWindow)==null||s.postMessage(i.attestationId,this.verifyUrl),this.logger.info(`postMessage sent: ${i.attestationId} ${this.verifyUrl}`);}catch{}},this.resolve=async i=>{var s;if(this.isDevEnv)return "";this.logger.info(`resolving attestation: ${i.attestationId}`);const n=this.startAbortTimer(cjs$6.FIVE_SECONDS),a=await fetch(`${this.verifyUrl}/attestation/${i.attestationId}`,{signal:this.abortController.signal});return clearTimeout(n),a.status===200?(s=await a.json())==null?void 0:s.origin:""},this.createIframe=async()=>{try{await Promise.race([new Promise((i,s)=>{if(document.getElementById(X$2))return i();const n=document.createElement("iframe");n.setAttribute("id",X$2),n.setAttribute("src",`${this.verifyUrl}/${this.projectId}`),n.style.display="none",n.addEventListener("load",()=>{this.initialized=!0,i();}),n.addEventListener("error",a=>{s(a);}),document.body.append(n),this.iframe=n;}),new Promise(i=>{setTimeout(()=>i("iframe load timeout"),cjs$6.toMiliseconds(cjs$6.ONE_SECOND/2));})]);}catch(i){this.logger.error(`Verify iframe failed to load: ${this.verifyUrl}`),this.logger.error(i);}},this.logger=cjs$1.generateChildLogger(t,this.name),this.verifyUrl=ge,this.abortController=new AbortController,this.isDevEnv=ee$3()&&process.env.IS_VITEST;}get context(){return cjs$1.getLoggerContext(this.logger)}startAbortTimer(e){return setTimeout(()=>this.abortController.abort(),cjs$6.toMiliseconds(e))}};var _r=Object.defineProperty,Mt$1=Object.getOwnPropertySymbols,Rr=Object.prototype.hasOwnProperty,Tr=Object.prototype.propertyIsEnumerable,Kt$1=(r,e,t)=>e in r?_r(r,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):r[e]=t,kt$1=(r,e)=>{for(var t in e||(e={}))Rr.call(e,t)&&Kt$1(r,t,e[t]);if(Mt$1)for(var t of Mt$1(e))Tr.call(e,t)&&Kt$1(r,t,e[t]);return r};let Z$2 = class Z extends n$7{constructor(e){super(e),this.protocol=ce$2,this.version=Ge$1,this.name=W$1,this.events=new eventsExports.EventEmitter,this.initialized=!1,this.on=(i,s)=>this.events.on(i,s),this.once=(i,s)=>this.events.once(i,s),this.off=(i,s)=>this.events.off(i,s),this.removeListener=(i,s)=>this.events.removeListener(i,s),this.projectId=e?.projectId,this.relayUrl=e?.relayUrl||le$1;const t=typeof e?.logger<"u"&&typeof e?.logger!="string"?e.logger:cjs$1.pino(cjs$1.getDefaultLoggerOptions({level:e?.logger||Je.logger}));this.logger=cjs$1.generateChildLogger(t,this.name),this.heartbeat=new cjs$2.HeartBeat,this.crypto=new It$1(this,this.logger,e?.keychain),this.history=new Lt$1(this,this.logger),this.expirer=new Ft$1(this,this.logger),this.storage=e!=null&&e.storage?e.storage:new _default(kt$1(kt$1({},He$1),e?.storageOptions)),this.relayer=new Ot$1({core:this,logger:this.logger,relayUrl:this.relayUrl,projectId:this.projectId}),this.pairing=new Ut$1(this,this.logger),this.verify=new $t$1(this.projectId||"",this.logger);}static async init(e){const t=new Z(e);await t.initialize();const i=await t.crypto.getClientId();return await t.storage.setItem(dt$1,i),t}get context(){return cjs$1.getLoggerContext(this.logger)}async start(){this.initialized||await this.initialize();}async initialize(){this.logger.trace("Initialized");try{await this.crypto.init(),await this.history.init(),await this.expirer.init(),await this.relayer.init(),await this.heartbeat.init(),await this.pairing.init(),this.initialized=!0,this.logger.info("Core Initialization Success");}catch(e){throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`,e),this.logger.error(e.message),e}}};const Sr=Z$2;

	const j$3="wc",J$2=2,X$1="client",b$2=`${j$3}@${J$2}:${X$1}:`,G$3={name:X$1,logger:"error",controller:!1,relayUrl:"wss://relay.walletconnect.com"},ee$1="WALLETCONNECT_DEEPLINK_CHOICE",se$1="proposal",te$1="Proposal expired",ie$1="session",C$2=cjs$6.SEVEN_DAYS,ne$1="engine",O$2={wc_sessionPropose:{req:{ttl:cjs$6.FIVE_MINUTES,prompt:!0,tag:1100},res:{ttl:cjs$6.FIVE_MINUTES,prompt:!1,tag:1101}},wc_sessionSettle:{req:{ttl:cjs$6.FIVE_MINUTES,prompt:!1,tag:1102},res:{ttl:cjs$6.FIVE_MINUTES,prompt:!1,tag:1103}},wc_sessionUpdate:{req:{ttl:cjs$6.ONE_DAY,prompt:!1,tag:1104},res:{ttl:cjs$6.ONE_DAY,prompt:!1,tag:1105}},wc_sessionExtend:{req:{ttl:cjs$6.ONE_DAY,prompt:!1,tag:1106},res:{ttl:cjs$6.ONE_DAY,prompt:!1,tag:1107}},wc_sessionRequest:{req:{ttl:cjs$6.FIVE_MINUTES,prompt:!0,tag:1108},res:{ttl:cjs$6.FIVE_MINUTES,prompt:!1,tag:1109}},wc_sessionEvent:{req:{ttl:cjs$6.FIVE_MINUTES,prompt:!0,tag:1110},res:{ttl:cjs$6.FIVE_MINUTES,prompt:!1,tag:1111}},wc_sessionDelete:{req:{ttl:cjs$6.ONE_DAY,prompt:!1,tag:1112},res:{ttl:cjs$6.ONE_DAY,prompt:!1,tag:1113}},wc_sessionPing:{req:{ttl:cjs$6.THIRTY_SECONDS,prompt:!1,tag:1114},res:{ttl:cjs$6.THIRTY_SECONDS,prompt:!1,tag:1115}}},$$3={min:cjs$6.FIVE_MINUTES,max:cjs$6.SEVEN_DAYS},re$1="request",oe$1=["wc_sessionPropose","wc_sessionRequest","wc_authRequest"];var Ze=Object.defineProperty,es=Object.defineProperties,ss=Object.getOwnPropertyDescriptors,ae$1=Object.getOwnPropertySymbols,ts=Object.prototype.hasOwnProperty,is=Object.prototype.propertyIsEnumerable,ce$1=(d,n,e)=>n in d?Ze(d,n,{enumerable:!0,configurable:!0,writable:!0,value:e}):d[n]=e,w$1=(d,n)=>{for(var e in n||(n={}))ts.call(n,e)&&ce$1(d,e,n[e]);if(ae$1)for(var e of ae$1(n))is.call(n,e)&&ce$1(d,e,n[e]);return d},H$2=(d,n)=>es(d,ss(n));class ns extends S$4{constructor(n){super(n),this.name=ne$1,this.events=new Ng,this.initialized=!1,this.ignoredPayloadTypes=[U$4],this.init=async()=>{this.initialized||(await this.cleanup(),this.registerRelayerEvents(),this.registerExpirerEvents(),this.client.core.pairing.register({methods:Object.keys(O$2)}),this.initialized=!0);},this.connect=async e=>{this.isInitialized();const s=H$2(w$1({},e),{requiredNamespaces:e.requiredNamespaces||{},optionalNamespaces:e.optionalNamespaces||{}});await this.isValidConnect(s);const{pairingTopic:t,requiredNamespaces:i,optionalNamespaces:r,sessionProperties:o,relays:a}=s;let l=t,h,I=!1;if(l&&(I=this.client.core.pairing.pairings.get(l).active),!l||!I){const{topic:v,uri:y}=await this.client.core.pairing.create();l=v,h=y;}const g=await this.client.core.crypto.generateKeyPair(),E=w$1({requiredNamespaces:i,optionalNamespaces:r,relays:a??[{protocol:rt$1}],proposer:{publicKey:g,metadata:this.client.metadata}},o&&{sessionProperties:o}),{reject:m,resolve:V,done:U}=Xn$1(cjs$6.FIVE_MINUTES,te$1);if(this.events.once(it$3("session_connect"),async({error:v,session:y})=>{if(v)m(v);else if(y){y.self.publicKey=g;const F=H$2(w$1({},y),{requiredNamespaces:y.requiredNamespaces,optionalNamespaces:y.optionalNamespaces});await this.client.session.set(y.topic,F),await this.setExpiry(y.topic,y.expiry),l&&await this.client.core.pairing.updateMetadata({topic:l,metadata:y.peer.metadata}),V(F);}}),!l){const{message:v}=b$6("NO_MATCHING_KEY",`connect() pairing topic: ${l}`);throw new Error(v)}const A=await this.sendRequest(l,"wc_sessionPropose",E),le=ot$4(cjs$6.FIVE_MINUTES);return await this.setProposal(A,w$1({id:A,expiry:le},E)),{uri:h,approval:U}},this.pair=async e=>(this.isInitialized(),await this.client.core.pairing.pair(e)),this.approve=async e=>{this.isInitialized(),await this.isValidApprove(e);const{id:s,relayProtocol:t,namespaces:i,sessionProperties:r}=e,o=this.client.proposal.get(s);let{pairingTopic:a,proposer:l,requiredNamespaces:h,optionalNamespaces:I}=o;a=a||"",H$6(h)||(h=St$2(i,"approve()"));const g=await this.client.core.crypto.generateKeyPair(),E=l.publicKey,m=await this.client.core.crypto.generateSharedKey(g,E);a&&s&&(await this.client.core.pairing.updateMetadata({topic:a,metadata:l.metadata}),await this.sendResult(s,a,{relay:{protocol:t??"irn"},responderPublicKey:g}),await this.client.proposal.delete(s,w$5("USER_DISCONNECTED")),await this.client.core.pairing.activate({topic:a}));const V=w$1({relay:{protocol:t??"irn"},namespaces:i,requiredNamespaces:h,optionalNamespaces:I,pairingTopic:a,controller:{publicKey:g,metadata:this.client.metadata},expiry:ot$4(C$2)},r&&{sessionProperties:r});await this.client.core.relayer.subscribe(m),await this.sendRequest(m,"wc_sessionSettle",V);const U=H$2(w$1({},V),{topic:m,pairingTopic:a,acknowledged:!1,self:V.controller,peer:{publicKey:l.publicKey,metadata:l.metadata},controller:g});return await this.client.session.set(m,U),await this.setExpiry(m,ot$4(C$2)),{topic:m,acknowledged:()=>new Promise(A=>setTimeout(()=>A(this.client.session.get(m)),500))}},this.reject=async e=>{this.isInitialized(),await this.isValidReject(e);const{id:s,reason:t}=e,{pairingTopic:i}=this.client.proposal.get(s);i&&(await this.sendError(s,i,t),await this.client.proposal.delete(s,w$5("USER_DISCONNECTED")));},this.update=async e=>{this.isInitialized(),await this.isValidUpdate(e);const{topic:s,namespaces:t}=e,i=await this.sendRequest(s,"wc_sessionUpdate",{namespaces:t}),{done:r,resolve:o,reject:a}=Xn$1();return this.events.once(it$3("session_update",i),({error:l})=>{l?a(l):o();}),await this.client.session.update(s,{namespaces:t}),{acknowledged:r}},this.extend=async e=>{this.isInitialized(),await this.isValidExtend(e);const{topic:s}=e,t=await this.sendRequest(s,"wc_sessionExtend",{}),{done:i,resolve:r,reject:o}=Xn$1();return this.events.once(it$3("session_extend",t),({error:a})=>{a?o(a):r();}),await this.setExpiry(s,ot$4(C$2)),{acknowledged:i}},this.request=async e=>{this.isInitialized(),await this.isValidRequest(e);const{chainId:s,request:t,topic:i,expiry:r}=e,o=await this.sendRequest(i,"wc_sessionRequest",{request:t,chainId:s},r),{done:a,resolve:l,reject:h}=Xn$1(r);this.events.once(it$3("session_request",o),({error:g,result:E})=>{g?h(g):l(E);}),this.client.events.emit("session_request_sent",{topic:i,request:t,chainId:s,id:o});const I=await this.client.core.storage.getItem(ee$1);return ct$3({id:o,topic:i,wcDeepLink:I}),await a()},this.respond=async e=>{this.isInitialized(),await this.isValidRespond(e);const{topic:s,response:t}=e,{id:i}=t;isJsonRpcResult(t)?await this.sendResult(i,s,t.result):isJsonRpcError(t)&&await this.sendError(i,s,t.error),this.deletePendingSessionRequest(e.response.id,{message:"fulfilled",code:0});},this.ping=async e=>{this.isInitialized(),await this.isValidPing(e);const{topic:s}=e;if(this.client.session.keys.includes(s)){const t=await this.sendRequest(s,"wc_sessionPing",{}),{done:i,resolve:r,reject:o}=Xn$1();this.events.once(it$3("session_ping",t),({error:a})=>{a?o(a):r();}),await i();}else this.client.core.pairing.pairings.keys.includes(s)&&await this.client.core.pairing.ping({topic:s});},this.emit=async e=>{this.isInitialized(),await this.isValidEmit(e);const{topic:s,event:t,chainId:i}=e;await this.sendRequest(s,"wc_sessionEvent",{event:t,chainId:i});},this.disconnect=async e=>{this.isInitialized(),await this.isValidDisconnect(e);const{topic:s}=e;if(this.client.session.keys.includes(s)){const t=getBigIntRpcId().toString();let i;const r=o=>{o?.id.toString()===t&&(this.client.core.relayer.events.removeListener(g$3.message_ack,r),i());};await Promise.all([new Promise(o=>{i=o,this.client.core.relayer.on(g$3.message_ack,r);}),this.sendRequest(s,"wc_sessionDelete",w$5("USER_DISCONNECTED"),void 0,t)]),await this.deleteSession(s);}else await this.client.core.pairing.disconnect({topic:s});},this.find=e=>(this.isInitialized(),this.client.session.getAll().filter(s=>Rt$2(s,e))),this.getPendingSessionRequests=()=>(this.isInitialized(),this.client.pendingRequest.getAll()),this.cleanupDuplicatePairings=async e=>{if(e.pairingTopic)try{const s=this.client.core.pairing.pairings.get(e.pairingTopic),t=this.client.core.pairing.pairings.getAll().filter(i=>{var r,o;return ((r=i.peerMetadata)==null?void 0:r.url)&&((o=i.peerMetadata)==null?void 0:o.url)===e.peer.metadata.url&&i.topic&&i.topic!==s.topic});if(t.length===0)return;this.client.logger.info(`Cleaning up ${t.length} duplicate pairing(s)`),await Promise.all(t.map(i=>this.client.core.pairing.disconnect({topic:i.topic}))),this.client.logger.info("Duplicate pairings clean up finished");}catch(s){this.client.logger.error(s);}},this.deleteSession=async(e,s)=>{const{self:t}=this.client.session.get(e);await this.client.core.relayer.unsubscribe(e),this.client.session.delete(e,w$5("USER_DISCONNECTED")),this.client.core.crypto.keychain.has(t.publicKey)&&await this.client.core.crypto.deleteKeyPair(t.publicKey),this.client.core.crypto.keychain.has(e)&&await this.client.core.crypto.deleteSymKey(e),s||this.client.core.expirer.del(e);},this.deleteProposal=async(e,s)=>{await Promise.all([this.client.proposal.delete(e,w$5("USER_DISCONNECTED")),s?Promise.resolve():this.client.core.expirer.del(e)]);},this.deletePendingSessionRequest=async(e,s,t=!1)=>{await Promise.all([this.client.pendingRequest.delete(e,s),t?Promise.resolve():this.client.core.expirer.del(e)]);},this.setExpiry=async(e,s)=>{this.client.session.keys.includes(e)&&await this.client.session.update(e,{expiry:s}),this.client.core.expirer.set(e,s);},this.setProposal=async(e,s)=>{await this.client.proposal.set(e,s),this.client.core.expirer.set(e,s.expiry);},this.setPendingSessionRequest=async e=>{const s=O$2.wc_sessionRequest.req.ttl,{id:t,topic:i,params:r}=e;await this.client.pendingRequest.set(t,{id:t,topic:i,params:r}),s&&this.client.core.expirer.set(t,ot$4(s));},this.sendRequest=async(e,s,t,i,r)=>{const o=formatJsonRpcRequest(s,t);if(je$3()&&oe$1.includes(s)){const h=$n$1(JSON.stringify(o));await this.client.core.verify.register({attestationId:h});}const a=await this.client.core.crypto.encode(e,o),l=O$2[s].req;return i&&(l.ttl=i),r&&(l.id=r),this.client.core.history.set(e,o),this.client.core.relayer.publish(e,a,l),o.id},this.sendResult=async(e,s,t)=>{const i=formatJsonRpcResult(e,t),r=await this.client.core.crypto.encode(s,i),o=await this.client.core.history.get(s,e),a=O$2[o.request.method].res;this.client.core.relayer.publish(s,r,a),await this.client.core.history.resolve(i);},this.sendError=async(e,s,t)=>{const i=formatJsonRpcError(e,t),r=await this.client.core.crypto.encode(s,i),o=await this.client.core.history.get(s,e),a=O$2[o.request.method].res;this.client.core.relayer.publish(s,r,a),await this.client.core.history.resolve(i);},this.cleanup=async()=>{const e=[],s=[];this.client.session.getAll().forEach(t=>{st$3(t.expiry)&&e.push(t.topic);}),this.client.proposal.getAll().forEach(t=>{st$3(t.expiry)&&s.push(t.id);}),await Promise.all([...e.map(t=>this.deleteSession(t)),...s.map(t=>this.deleteProposal(t))]);},this.onRelayEventRequest=e=>{const{topic:s,payload:t}=e,i=t.method;switch(i){case"wc_sessionPropose":return this.onSessionProposeRequest(s,t);case"wc_sessionSettle":return this.onSessionSettleRequest(s,t);case"wc_sessionUpdate":return this.onSessionUpdateRequest(s,t);case"wc_sessionExtend":return this.onSessionExtendRequest(s,t);case"wc_sessionPing":return this.onSessionPingRequest(s,t);case"wc_sessionDelete":return this.onSessionDeleteRequest(s,t);case"wc_sessionRequest":return this.onSessionRequest(s,t);case"wc_sessionEvent":return this.onSessionEventRequest(s,t);default:return this.client.logger.info(`Unsupported request method ${i}`)}},this.onRelayEventResponse=async e=>{const{topic:s,payload:t}=e,i=(await this.client.core.history.get(s,t.id)).request.method;switch(i){case"wc_sessionPropose":return this.onSessionProposeResponse(s,t);case"wc_sessionSettle":return this.onSessionSettleResponse(s,t);case"wc_sessionUpdate":return this.onSessionUpdateResponse(s,t);case"wc_sessionExtend":return this.onSessionExtendResponse(s,t);case"wc_sessionPing":return this.onSessionPingResponse(s,t);case"wc_sessionRequest":return this.onSessionRequestResponse(s,t);default:return this.client.logger.info(`Unsupported response method ${i}`)}},this.onRelayEventUnknownPayload=e=>{const{topic:s}=e,{message:t}=b$6("MISSING_OR_INVALID",`Decoded payload on topic ${s} is not identifiable as a JSON-RPC request or a response.`);throw new Error(t)},this.onSessionProposeRequest=async(e,s)=>{const{params:t,id:i}=s;try{this.isValidConnect(w$1({},s.params));const r=ot$4(cjs$6.FIVE_MINUTES),o=w$1({id:i,pairingTopic:e,expiry:r},t);await this.setProposal(i,o);const a=$n$1(JSON.stringify(s)),l=await this.getVerifyContext(a,o.proposer.metadata);this.client.events.emit("session_proposal",{id:i,params:o,verifyContext:l});}catch(r){await this.sendError(i,e,r),this.client.logger.error(r);}},this.onSessionProposeResponse=async(e,s)=>{const{id:t}=s;if(isJsonRpcResult(s)){const{result:i}=s;this.client.logger.trace({type:"method",method:"onSessionProposeResponse",result:i});const r=this.client.proposal.get(t);this.client.logger.trace({type:"method",method:"onSessionProposeResponse",proposal:r});const o=r.proposer.publicKey;this.client.logger.trace({type:"method",method:"onSessionProposeResponse",selfPublicKey:o});const a=i.responderPublicKey;this.client.logger.trace({type:"method",method:"onSessionProposeResponse",peerPublicKey:a});const l=await this.client.core.crypto.generateSharedKey(o,a);this.client.logger.trace({type:"method",method:"onSessionProposeResponse",sessionTopic:l});const h=await this.client.core.relayer.subscribe(l);this.client.logger.trace({type:"method",method:"onSessionProposeResponse",subscriptionId:h}),await this.client.core.pairing.activate({topic:e});}else isJsonRpcError(s)&&(await this.client.proposal.delete(t,w$5("USER_DISCONNECTED")),this.events.emit(it$3("session_connect"),{error:s.error}));},this.onSessionSettleRequest=async(e,s)=>{const{id:t,params:i}=s;try{this.isValidSessionSettleRequest(i);const{relay:r,controller:o,expiry:a,namespaces:l,requiredNamespaces:h,optionalNamespaces:I,sessionProperties:g,pairingTopic:E}=s.params,m=w$1({topic:e,relay:r,expiry:a,namespaces:l,acknowledged:!0,pairingTopic:E,requiredNamespaces:h,optionalNamespaces:I,controller:o.publicKey,self:{publicKey:"",metadata:this.client.metadata},peer:{publicKey:o.publicKey,metadata:o.metadata}},g&&{sessionProperties:g});await this.sendResult(s.id,e,!0),this.events.emit(it$3("session_connect"),{session:m}),this.cleanupDuplicatePairings(m);}catch(r){await this.sendError(t,e,r),this.client.logger.error(r);}},this.onSessionSettleResponse=async(e,s)=>{const{id:t}=s;isJsonRpcResult(s)?(await this.client.session.update(e,{acknowledged:!0}),this.events.emit(it$3("session_approve",t),{})):isJsonRpcError(s)&&(await this.client.session.delete(e,w$5("USER_DISCONNECTED")),this.events.emit(it$3("session_approve",t),{error:s.error}));},this.onSessionUpdateRequest=async(e,s)=>{const{params:t,id:i}=s;try{this.isValidUpdate(w$1({topic:e},t)),await this.client.session.update(e,{namespaces:t.namespaces}),await this.sendResult(i,e,!0),this.client.events.emit("session_update",{id:i,topic:e,params:t});}catch(r){await this.sendError(i,e,r),this.client.logger.error(r);}},this.onSessionUpdateResponse=(e,s)=>{const{id:t}=s;isJsonRpcResult(s)?this.events.emit(it$3("session_update",t),{}):isJsonRpcError(s)&&this.events.emit(it$3("session_update",t),{error:s.error});},this.onSessionExtendRequest=async(e,s)=>{const{id:t}=s;try{this.isValidExtend({topic:e}),await this.setExpiry(e,ot$4(C$2)),await this.sendResult(t,e,!0),this.client.events.emit("session_extend",{id:t,topic:e});}catch(i){await this.sendError(t,e,i),this.client.logger.error(i);}},this.onSessionExtendResponse=(e,s)=>{const{id:t}=s;isJsonRpcResult(s)?this.events.emit(it$3("session_extend",t),{}):isJsonRpcError(s)&&this.events.emit(it$3("session_extend",t),{error:s.error});},this.onSessionPingRequest=async(e,s)=>{const{id:t}=s;try{this.isValidPing({topic:e}),await this.sendResult(t,e,!0),this.client.events.emit("session_ping",{id:t,topic:e});}catch(i){await this.sendError(t,e,i),this.client.logger.error(i);}},this.onSessionPingResponse=(e,s)=>{const{id:t}=s;setTimeout(()=>{isJsonRpcResult(s)?this.events.emit(it$3("session_ping",t),{}):isJsonRpcError(s)&&this.events.emit(it$3("session_ping",t),{error:s.error});},500);},this.onSessionDeleteRequest=async(e,s)=>{const{id:t}=s;try{this.isValidDisconnect({topic:e,reason:s.params}),await Promise.all([new Promise(i=>{this.client.core.relayer.once(g$3.publish,async()=>{i(await this.deleteSession(e));});}),this.sendResult(t,e,!0)]),this.client.events.emit("session_delete",{id:t,topic:e});}catch(i){this.client.logger.error(i);}},this.onSessionRequest=async(e,s)=>{const{id:t,params:i}=s;try{this.isValidRequest(w$1({topic:e},i)),await this.setPendingSessionRequest({id:t,topic:e,params:i});const r=$n$1(JSON.stringify(s)),o=this.client.session.get(e),a=await this.getVerifyContext(r,o.peer.metadata);this.client.events.emit("session_request",{id:t,topic:e,params:i,verifyContext:a});}catch(r){await this.sendError(t,e,r),this.client.logger.error(r);}},this.onSessionRequestResponse=(e,s)=>{const{id:t}=s;isJsonRpcResult(s)?this.events.emit(it$3("session_request",t),{result:s.result}):isJsonRpcError(s)&&this.events.emit(it$3("session_request",t),{error:s.error});},this.onSessionEventRequest=async(e,s)=>{const{id:t,params:i}=s;try{this.isValidEmit(w$1({topic:e},i)),this.client.events.emit("session_event",{id:t,topic:e,params:i});}catch(r){await this.sendError(t,e,r),this.client.logger.error(r);}},this.isValidConnect=async e=>{if(!Dt$2(e)){const{message:a}=b$6("MISSING_OR_INVALID",`connect() params: ${JSON.stringify(e)}`);throw new Error(a)}const{pairingTopic:s,requiredNamespaces:t,optionalNamespaces:i,sessionProperties:r,relays:o}=e;if(I$4(s)||await this.isValidPairingTopic(s),!jt$1(o,!0)){const{message:a}=b$6("MISSING_OR_INVALID",`connect() relays: ${o}`);throw new Error(a)}!I$4(t)&&H$6(t)!==0&&this.validateNamespaces(t,"requiredNamespaces"),!I$4(i)&&H$6(i)!==0&&this.validateNamespaces(i,"optionalNamespaces"),I$4(r)||this.validateSessionProps(r,"sessionProperties");},this.validateNamespaces=(e,s)=>{const t=$t$2(e,"connect()",s);if(t)throw new Error(t.message)},this.isValidApprove=async e=>{if(!Dt$2(e))throw new Error(b$6("MISSING_OR_INVALID",`approve() params: ${e}`).message);const{id:s,namespaces:t,relayProtocol:i,sessionProperties:r}=e;await this.isValidProposalId(s);const o=this.client.proposal.get(s),a=sn(t,"approve()");if(a)throw new Error(a.message);const l=an(o.requiredNamespaces,t,"approve()");if(l)throw new Error(l.message);if(!m$5(i,!0)){const{message:h}=b$6("MISSING_OR_INVALID",`approve() relayProtocol: ${i}`);throw new Error(h)}I$4(r)||this.validateSessionProps(r,"sessionProperties");},this.isValidReject=async e=>{if(!Dt$2(e)){const{message:i}=b$6("MISSING_OR_INVALID",`reject() params: ${e}`);throw new Error(i)}const{id:s,reason:t}=e;if(await this.isValidProposalId(s),!Vt$1(t)){const{message:i}=b$6("MISSING_OR_INVALID",`reject() reason: ${JSON.stringify(t)}`);throw new Error(i)}},this.isValidSessionSettleRequest=e=>{if(!Dt$2(e)){const{message:l}=b$6("MISSING_OR_INVALID",`onSessionSettleRequest() params: ${e}`);throw new Error(l)}const{relay:s,controller:t,namespaces:i,expiry:r}=e;if(!cn(s)){const{message:l}=b$6("MISSING_OR_INVALID","onSessionSettleRequest() relay protocol should be a string");throw new Error(l)}const o=_t$2(t,"onSessionSettleRequest()");if(o)throw new Error(o.message);const a=sn(i,"onSessionSettleRequest()");if(a)throw new Error(a.message);if(st$3(r)){const{message:l}=b$6("EXPIRED","onSessionSettleRequest()");throw new Error(l)}},this.isValidUpdate=async e=>{if(!Dt$2(e)){const{message:a}=b$6("MISSING_OR_INVALID",`update() params: ${e}`);throw new Error(a)}const{topic:s,namespaces:t}=e;await this.isValidSessionTopic(s);const i=this.client.session.get(s),r=sn(t,"update()");if(r)throw new Error(r.message);const o=an(i.requiredNamespaces,t,"update()");if(o)throw new Error(o.message)},this.isValidExtend=async e=>{if(!Dt$2(e)){const{message:t}=b$6("MISSING_OR_INVALID",`extend() params: ${e}`);throw new Error(t)}const{topic:s}=e;await this.isValidSessionTopic(s);},this.isValidRequest=async e=>{if(!Dt$2(e)){const{message:a}=b$6("MISSING_OR_INVALID",`request() params: ${e}`);throw new Error(a)}const{topic:s,request:t,chainId:i,expiry:r}=e;await this.isValidSessionTopic(s);const{namespaces:o}=this.client.session.get(s);if(!Lt$2(o,i)){const{message:a}=b$6("MISSING_OR_INVALID",`request() chainId: ${i}`);throw new Error(a)}if(!Mt$2(t)){const{message:a}=b$6("MISSING_OR_INVALID",`request() ${JSON.stringify(t)}`);throw new Error(a)}if(!xt$2(o,i,t.method)){const{message:a}=b$6("MISSING_OR_INVALID",`request() method: ${t.method}`);throw new Error(a)}if(r&&!zt$2(r,$$3)){const{message:a}=b$6("MISSING_OR_INVALID",`request() expiry: ${r}. Expiry must be a number (in seconds) between ${$$3.min} and ${$$3.max}`);throw new Error(a)}},this.isValidRespond=async e=>{if(!Dt$2(e)){const{message:i}=b$6("MISSING_OR_INVALID",`respond() params: ${e}`);throw new Error(i)}const{topic:s,response:t}=e;if(await this.isValidSessionTopic(s),!kt$2(t)){const{message:i}=b$6("MISSING_OR_INVALID",`respond() response: ${JSON.stringify(t)}`);throw new Error(i)}},this.isValidPing=async e=>{if(!Dt$2(e)){const{message:t}=b$6("MISSING_OR_INVALID",`ping() params: ${e}`);throw new Error(t)}const{topic:s}=e;await this.isValidSessionOrPairingTopic(s);},this.isValidEmit=async e=>{if(!Dt$2(e)){const{message:o}=b$6("MISSING_OR_INVALID",`emit() params: ${e}`);throw new Error(o)}const{topic:s,event:t,chainId:i}=e;await this.isValidSessionTopic(s);const{namespaces:r}=this.client.session.get(s);if(!Lt$2(r,i)){const{message:o}=b$6("MISSING_OR_INVALID",`emit() chainId: ${i}`);throw new Error(o)}if(!Kt$2(t)){const{message:o}=b$6("MISSING_OR_INVALID",`emit() event: ${JSON.stringify(t)}`);throw new Error(o)}if(!Ft$2(r,i,t.name)){const{message:o}=b$6("MISSING_OR_INVALID",`emit() event: ${JSON.stringify(t)}`);throw new Error(o)}},this.isValidDisconnect=async e=>{if(!Dt$2(e)){const{message:t}=b$6("MISSING_OR_INVALID",`disconnect() params: ${e}`);throw new Error(t)}const{topic:s}=e;await this.isValidSessionOrPairingTopic(s);},this.getVerifyContext=async(e,s)=>{const t={verified:{verifyUrl:s.verifyUrl||"",validation:"UNKNOWN",origin:s.url||""}};try{const i=await this.client.core.verify.resolve({attestationId:e,verifyUrl:s.verifyUrl});i&&(t.verified.origin=i,t.verified.validation=i===s.url?"VALID":"INVALID");}catch(i){this.client.logger.error(i);}return this.client.logger.info(`Verify context: ${JSON.stringify(t)}`),t},this.validateSessionProps=(e,s)=>{Object.values(e).forEach(t=>{if(!m$5(t,!1)){const{message:i}=b$6("MISSING_OR_INVALID",`${s} must be in Record<string, string> format. Received: ${JSON.stringify(t)}`);throw new Error(i)}});};}isInitialized(){if(!this.initialized){const{message:n}=b$6("NOT_INITIALIZED",this.name);throw new Error(n)}}registerRelayerEvents(){this.client.core.relayer.on(g$3.message,async n=>{const{topic:e,message:s}=n;if(this.ignoredPayloadTypes.includes(this.client.core.crypto.getPayloadType(s)))return;const t=await this.client.core.crypto.decode(e,s);isJsonRpcRequest(t)?(this.client.core.history.set(e,t),this.onRelayEventRequest({topic:e,payload:t})):isJsonRpcResponse(t)?(await this.client.core.history.resolve(t),await this.onRelayEventResponse({topic:e,payload:t}),this.client.core.history.delete(e,t.id)):this.onRelayEventUnknownPayload({topic:e,payload:t});});}registerExpirerEvents(){this.client.core.expirer.on(w$2.expired,async n=>{const{topic:e,id:s}=rt$3(n.target);if(s&&this.client.pendingRequest.keys.includes(s))return await this.deletePendingSessionRequest(s,b$6("EXPIRED"),!0);e?this.client.session.keys.includes(e)&&(await this.deleteSession(e,!0),this.client.events.emit("session_expire",{topic:e})):s&&(await this.deleteProposal(s,!0),this.client.events.emit("proposal_expire",{id:s}));});}isValidPairingTopic(n){if(!m$5(n,!1)){const{message:e}=b$6("MISSING_OR_INVALID",`pairing topic should be a string: ${n}`);throw new Error(e)}if(!this.client.core.pairing.pairings.keys.includes(n)){const{message:e}=b$6("NO_MATCHING_KEY",`pairing topic doesn't exist: ${n}`);throw new Error(e)}if(st$3(this.client.core.pairing.pairings.get(n).expiry)){const{message:e}=b$6("EXPIRED",`pairing topic: ${n}`);throw new Error(e)}}async isValidSessionTopic(n){if(!m$5(n,!1)){const{message:e}=b$6("MISSING_OR_INVALID",`session topic should be a string: ${n}`);throw new Error(e)}if(!this.client.session.keys.includes(n)){const{message:e}=b$6("NO_MATCHING_KEY",`session topic doesn't exist: ${n}`);throw new Error(e)}if(st$3(this.client.session.get(n).expiry)){await this.deleteSession(n);const{message:e}=b$6("EXPIRED",`session topic: ${n}`);throw new Error(e)}}async isValidSessionOrPairingTopic(n){if(this.client.session.keys.includes(n))await this.isValidSessionTopic(n);else if(this.client.core.pairing.pairings.keys.includes(n))this.isValidPairingTopic(n);else if(m$5(n,!1)){const{message:e}=b$6("NO_MATCHING_KEY",`session or pairing topic doesn't exist: ${n}`);throw new Error(e)}else {const{message:e}=b$6("MISSING_OR_INVALID",`session or pairing topic should be a string: ${n}`);throw new Error(e)}}async isValidProposalId(n){if(!Ct$2(n)){const{message:e}=b$6("MISSING_OR_INVALID",`proposal id should be a number: ${n}`);throw new Error(e)}if(!this.client.proposal.keys.includes(n)){const{message:e}=b$6("NO_MATCHING_KEY",`proposal id doesn't exist: ${n}`);throw new Error(e)}if(st$3(this.client.proposal.get(n).expiry)){await this.deleteProposal(n);const{message:e}=b$6("EXPIRED",`proposal id: ${n}`);throw new Error(e)}}}class rs extends Nt$1{constructor(n,e){super(n,e,se$1,b$2),this.core=n,this.logger=e;}}class os extends Nt$1{constructor(n,e){super(n,e,ie$1,b$2),this.core=n,this.logger=e;}}class as extends Nt$1{constructor(n,e){super(n,e,re$1,b$2,s=>s.id),this.core=n,this.logger=e;}}let M$3 = class M extends b$3{constructor(n){super(n),this.protocol=j$3,this.version=J$2,this.name=G$3.name,this.events=new eventsExports.EventEmitter,this.on=(s,t)=>this.events.on(s,t),this.once=(s,t)=>this.events.once(s,t),this.off=(s,t)=>this.events.off(s,t),this.removeListener=(s,t)=>this.events.removeListener(s,t),this.removeAllListeners=s=>this.events.removeAllListeners(s),this.connect=async s=>{try{return await this.engine.connect(s)}catch(t){throw this.logger.error(t.message),t}},this.pair=async s=>{try{return await this.engine.pair(s)}catch(t){throw this.logger.error(t.message),t}},this.approve=async s=>{try{return await this.engine.approve(s)}catch(t){throw this.logger.error(t.message),t}},this.reject=async s=>{try{return await this.engine.reject(s)}catch(t){throw this.logger.error(t.message),t}},this.update=async s=>{try{return await this.engine.update(s)}catch(t){throw this.logger.error(t.message),t}},this.extend=async s=>{try{return await this.engine.extend(s)}catch(t){throw this.logger.error(t.message),t}},this.request=async s=>{try{return await this.engine.request(s)}catch(t){throw this.logger.error(t.message),t}},this.respond=async s=>{try{return await this.engine.respond(s)}catch(t){throw this.logger.error(t.message),t}},this.ping=async s=>{try{return await this.engine.ping(s)}catch(t){throw this.logger.error(t.message),t}},this.emit=async s=>{try{return await this.engine.emit(s)}catch(t){throw this.logger.error(t.message),t}},this.disconnect=async s=>{try{return await this.engine.disconnect(s)}catch(t){throw this.logger.error(t.message),t}},this.find=s=>{try{return this.engine.find(s)}catch(t){throw this.logger.error(t.message),t}},this.getPendingSessionRequests=()=>{try{return this.engine.getPendingSessionRequests()}catch(s){throw this.logger.error(s.message),s}},this.name=n?.name||G$3.name,this.metadata=n?.metadata||Fn$1();const e=typeof n?.logger<"u"&&typeof n?.logger!="string"?n.logger:cjs$1.pino(cjs$1.getDefaultLoggerOptions({level:n?.logger||G$3.logger}));this.core=n?.core||new Sr(n),this.logger=cjs$1.generateChildLogger(e,this.name),this.session=new os(this.core,this.logger),this.proposal=new rs(this.core,this.logger),this.pendingRequest=new as(this.core,this.logger),this.engine=new ns(this);}static async init(n){const e=new M(n);return await e.initialize(),e}get context(){return cjs$1.getLoggerContext(this.logger)}get pairing(){return this.core.pairing.pairings}async initialize(){this.logger.trace("Initialized");try{await this.core.start(),await this.session.init(),await this.proposal.init(),await this.pendingRequest.init(),await this.engine.init(),this.core.verify.init({verifyUrl:this.metadata.verifyUrl}),this.logger.info("SignClient Initialization Success");}catch(n){throw this.logger.info("SignClient Initialization Failure"),this.logger.error(n.message),n}}};

	var browserPonyfill = {exports: {}};

	(function (module, exports) {
		var global = typeof self !== 'undefined' ? self : commonjsGlobal;
		var __self__ = (function () {
		function F() {
		this.fetch = false;
		this.DOMException = global.DOMException;
		}
		F.prototype = global;
		return new F();
		})();
		(function(self) {

		((function (exports) {

		  var support = {
		    searchParams: 'URLSearchParams' in self,
		    iterable: 'Symbol' in self && 'iterator' in Symbol,
		    blob:
		      'FileReader' in self &&
		      'Blob' in self &&
		      (function() {
		        try {
		          new Blob();
		          return true
		        } catch (e) {
		          return false
		        }
		      })(),
		    formData: 'FormData' in self,
		    arrayBuffer: 'ArrayBuffer' in self
		  };

		  function isDataView(obj) {
		    return obj && DataView.prototype.isPrototypeOf(obj)
		  }

		  if (support.arrayBuffer) {
		    var viewClasses = [
		      '[object Int8Array]',
		      '[object Uint8Array]',
		      '[object Uint8ClampedArray]',
		      '[object Int16Array]',
		      '[object Uint16Array]',
		      '[object Int32Array]',
		      '[object Uint32Array]',
		      '[object Float32Array]',
		      '[object Float64Array]'
		    ];

		    var isArrayBufferView =
		      ArrayBuffer.isView ||
		      function(obj) {
		        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
		      };
		  }

		  function normalizeName(name) {
		    if (typeof name !== 'string') {
		      name = String(name);
		    }
		    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
		      throw new TypeError('Invalid character in header field name')
		    }
		    return name.toLowerCase()
		  }

		  function normalizeValue(value) {
		    if (typeof value !== 'string') {
		      value = String(value);
		    }
		    return value
		  }

		  // Build a destructive iterator for the value list
		  function iteratorFor(items) {
		    var iterator = {
		      next: function() {
		        var value = items.shift();
		        return {done: value === undefined, value: value}
		      }
		    };

		    if (support.iterable) {
		      iterator[Symbol.iterator] = function() {
		        return iterator
		      };
		    }

		    return iterator
		  }

		  function Headers(headers) {
		    this.map = {};

		    if (headers instanceof Headers) {
		      headers.forEach(function(value, name) {
		        this.append(name, value);
		      }, this);
		    } else if (Array.isArray(headers)) {
		      headers.forEach(function(header) {
		        this.append(header[0], header[1]);
		      }, this);
		    } else if (headers) {
		      Object.getOwnPropertyNames(headers).forEach(function(name) {
		        this.append(name, headers[name]);
		      }, this);
		    }
		  }

		  Headers.prototype.append = function(name, value) {
		    name = normalizeName(name);
		    value = normalizeValue(value);
		    var oldValue = this.map[name];
		    this.map[name] = oldValue ? oldValue + ', ' + value : value;
		  };

		  Headers.prototype['delete'] = function(name) {
		    delete this.map[normalizeName(name)];
		  };

		  Headers.prototype.get = function(name) {
		    name = normalizeName(name);
		    return this.has(name) ? this.map[name] : null
		  };

		  Headers.prototype.has = function(name) {
		    return this.map.hasOwnProperty(normalizeName(name))
		  };

		  Headers.prototype.set = function(name, value) {
		    this.map[normalizeName(name)] = normalizeValue(value);
		  };

		  Headers.prototype.forEach = function(callback, thisArg) {
		    for (var name in this.map) {
		      if (this.map.hasOwnProperty(name)) {
		        callback.call(thisArg, this.map[name], name, this);
		      }
		    }
		  };

		  Headers.prototype.keys = function() {
		    var items = [];
		    this.forEach(function(value, name) {
		      items.push(name);
		    });
		    return iteratorFor(items)
		  };

		  Headers.prototype.values = function() {
		    var items = [];
		    this.forEach(function(value) {
		      items.push(value);
		    });
		    return iteratorFor(items)
		  };

		  Headers.prototype.entries = function() {
		    var items = [];
		    this.forEach(function(value, name) {
		      items.push([name, value]);
		    });
		    return iteratorFor(items)
		  };

		  if (support.iterable) {
		    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
		  }

		  function consumed(body) {
		    if (body.bodyUsed) {
		      return Promise.reject(new TypeError('Already read'))
		    }
		    body.bodyUsed = true;
		  }

		  function fileReaderReady(reader) {
		    return new Promise(function(resolve, reject) {
		      reader.onload = function() {
		        resolve(reader.result);
		      };
		      reader.onerror = function() {
		        reject(reader.error);
		      };
		    })
		  }

		  function readBlobAsArrayBuffer(blob) {
		    var reader = new FileReader();
		    var promise = fileReaderReady(reader);
		    reader.readAsArrayBuffer(blob);
		    return promise
		  }

		  function readBlobAsText(blob) {
		    var reader = new FileReader();
		    var promise = fileReaderReady(reader);
		    reader.readAsText(blob);
		    return promise
		  }

		  function readArrayBufferAsText(buf) {
		    var view = new Uint8Array(buf);
		    var chars = new Array(view.length);

		    for (var i = 0; i < view.length; i++) {
		      chars[i] = String.fromCharCode(view[i]);
		    }
		    return chars.join('')
		  }

		  function bufferClone(buf) {
		    if (buf.slice) {
		      return buf.slice(0)
		    } else {
		      var view = new Uint8Array(buf.byteLength);
		      view.set(new Uint8Array(buf));
		      return view.buffer
		    }
		  }

		  function Body() {
		    this.bodyUsed = false;

		    this._initBody = function(body) {
		      this._bodyInit = body;
		      if (!body) {
		        this._bodyText = '';
		      } else if (typeof body === 'string') {
		        this._bodyText = body;
		      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
		        this._bodyBlob = body;
		      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
		        this._bodyFormData = body;
		      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
		        this._bodyText = body.toString();
		      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
		        this._bodyArrayBuffer = bufferClone(body.buffer);
		        // IE 10-11 can't handle a DataView body.
		        this._bodyInit = new Blob([this._bodyArrayBuffer]);
		      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
		        this._bodyArrayBuffer = bufferClone(body);
		      } else {
		        this._bodyText = body = Object.prototype.toString.call(body);
		      }

		      if (!this.headers.get('content-type')) {
		        if (typeof body === 'string') {
		          this.headers.set('content-type', 'text/plain;charset=UTF-8');
		        } else if (this._bodyBlob && this._bodyBlob.type) {
		          this.headers.set('content-type', this._bodyBlob.type);
		        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
		          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
		        }
		      }
		    };

		    if (support.blob) {
		      this.blob = function() {
		        var rejected = consumed(this);
		        if (rejected) {
		          return rejected
		        }

		        if (this._bodyBlob) {
		          return Promise.resolve(this._bodyBlob)
		        } else if (this._bodyArrayBuffer) {
		          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
		        } else if (this._bodyFormData) {
		          throw new Error('could not read FormData body as blob')
		        } else {
		          return Promise.resolve(new Blob([this._bodyText]))
		        }
		      };

		      this.arrayBuffer = function() {
		        if (this._bodyArrayBuffer) {
		          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
		        } else {
		          return this.blob().then(readBlobAsArrayBuffer)
		        }
		      };
		    }

		    this.text = function() {
		      var rejected = consumed(this);
		      if (rejected) {
		        return rejected
		      }

		      if (this._bodyBlob) {
		        return readBlobAsText(this._bodyBlob)
		      } else if (this._bodyArrayBuffer) {
		        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
		      } else if (this._bodyFormData) {
		        throw new Error('could not read FormData body as text')
		      } else {
		        return Promise.resolve(this._bodyText)
		      }
		    };

		    if (support.formData) {
		      this.formData = function() {
		        return this.text().then(decode)
		      };
		    }

		    this.json = function() {
		      return this.text().then(JSON.parse)
		    };

		    return this
		  }

		  // HTTP methods whose capitalization should be normalized
		  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

		  function normalizeMethod(method) {
		    var upcased = method.toUpperCase();
		    return methods.indexOf(upcased) > -1 ? upcased : method
		  }

		  function Request(input, options) {
		    options = options || {};
		    var body = options.body;

		    if (input instanceof Request) {
		      if (input.bodyUsed) {
		        throw new TypeError('Already read')
		      }
		      this.url = input.url;
		      this.credentials = input.credentials;
		      if (!options.headers) {
		        this.headers = new Headers(input.headers);
		      }
		      this.method = input.method;
		      this.mode = input.mode;
		      this.signal = input.signal;
		      if (!body && input._bodyInit != null) {
		        body = input._bodyInit;
		        input.bodyUsed = true;
		      }
		    } else {
		      this.url = String(input);
		    }

		    this.credentials = options.credentials || this.credentials || 'same-origin';
		    if (options.headers || !this.headers) {
		      this.headers = new Headers(options.headers);
		    }
		    this.method = normalizeMethod(options.method || this.method || 'GET');
		    this.mode = options.mode || this.mode || null;
		    this.signal = options.signal || this.signal;
		    this.referrer = null;

		    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
		      throw new TypeError('Body not allowed for GET or HEAD requests')
		    }
		    this._initBody(body);
		  }

		  Request.prototype.clone = function() {
		    return new Request(this, {body: this._bodyInit})
		  };

		  function decode(body) {
		    var form = new FormData();
		    body
		      .trim()
		      .split('&')
		      .forEach(function(bytes) {
		        if (bytes) {
		          var split = bytes.split('=');
		          var name = split.shift().replace(/\+/g, ' ');
		          var value = split.join('=').replace(/\+/g, ' ');
		          form.append(decodeURIComponent(name), decodeURIComponent(value));
		        }
		      });
		    return form
		  }

		  function parseHeaders(rawHeaders) {
		    var headers = new Headers();
		    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
		    // https://tools.ietf.org/html/rfc7230#section-3.2
		    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
		    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
		      var parts = line.split(':');
		      var key = parts.shift().trim();
		      if (key) {
		        var value = parts.join(':').trim();
		        headers.append(key, value);
		      }
		    });
		    return headers
		  }

		  Body.call(Request.prototype);

		  function Response(bodyInit, options) {
		    if (!options) {
		      options = {};
		    }

		    this.type = 'default';
		    this.status = options.status === undefined ? 200 : options.status;
		    this.ok = this.status >= 200 && this.status < 300;
		    this.statusText = 'statusText' in options ? options.statusText : 'OK';
		    this.headers = new Headers(options.headers);
		    this.url = options.url || '';
		    this._initBody(bodyInit);
		  }

		  Body.call(Response.prototype);

		  Response.prototype.clone = function() {
		    return new Response(this._bodyInit, {
		      status: this.status,
		      statusText: this.statusText,
		      headers: new Headers(this.headers),
		      url: this.url
		    })
		  };

		  Response.error = function() {
		    var response = new Response(null, {status: 0, statusText: ''});
		    response.type = 'error';
		    return response
		  };

		  var redirectStatuses = [301, 302, 303, 307, 308];

		  Response.redirect = function(url, status) {
		    if (redirectStatuses.indexOf(status) === -1) {
		      throw new RangeError('Invalid status code')
		    }

		    return new Response(null, {status: status, headers: {location: url}})
		  };

		  exports.DOMException = self.DOMException;
		  try {
		    new exports.DOMException();
		  } catch (err) {
		    exports.DOMException = function(message, name) {
		      this.message = message;
		      this.name = name;
		      var error = Error(message);
		      this.stack = error.stack;
		    };
		    exports.DOMException.prototype = Object.create(Error.prototype);
		    exports.DOMException.prototype.constructor = exports.DOMException;
		  }

		  function fetch(input, init) {
		    return new Promise(function(resolve, reject) {
		      var request = new Request(input, init);

		      if (request.signal && request.signal.aborted) {
		        return reject(new exports.DOMException('Aborted', 'AbortError'))
		      }

		      var xhr = new XMLHttpRequest();

		      function abortXhr() {
		        xhr.abort();
		      }

		      xhr.onload = function() {
		        var options = {
		          status: xhr.status,
		          statusText: xhr.statusText,
		          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
		        };
		        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
		        var body = 'response' in xhr ? xhr.response : xhr.responseText;
		        resolve(new Response(body, options));
		      };

		      xhr.onerror = function() {
		        reject(new TypeError('Network request failed'));
		      };

		      xhr.ontimeout = function() {
		        reject(new TypeError('Network request failed'));
		      };

		      xhr.onabort = function() {
		        reject(new exports.DOMException('Aborted', 'AbortError'));
		      };

		      xhr.open(request.method, request.url, true);

		      if (request.credentials === 'include') {
		        xhr.withCredentials = true;
		      } else if (request.credentials === 'omit') {
		        xhr.withCredentials = false;
		      }

		      if ('responseType' in xhr && support.blob) {
		        xhr.responseType = 'blob';
		      }

		      request.headers.forEach(function(value, name) {
		        xhr.setRequestHeader(name, value);
		      });

		      if (request.signal) {
		        request.signal.addEventListener('abort', abortXhr);

		        xhr.onreadystatechange = function() {
		          // DONE (success or failure)
		          if (xhr.readyState === 4) {
		            request.signal.removeEventListener('abort', abortXhr);
		          }
		        };
		      }

		      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
		    })
		  }

		  fetch.polyfill = true;

		  if (!self.fetch) {
		    self.fetch = fetch;
		    self.Headers = Headers;
		    self.Request = Request;
		    self.Response = Response;
		  }

		  exports.Headers = Headers;
		  exports.Request = Request;
		  exports.Response = Response;
		  exports.fetch = fetch;

		  Object.defineProperty(exports, '__esModule', { value: true });

		  return exports;

		}))({});
		})(__self__);
		__self__.fetch.ponyfill = true;
		// Remove "polyfill" property added by whatwg-fetch
		delete __self__.fetch.polyfill;
		// Choose between native implementation (global) or custom implementation (__self__)
		// var ctx = global.fetch ? global : __self__;
		var ctx = __self__; // this line disable service worker support temporarily
		exports = ctx.fetch; // To enable: import fetch from 'cross-fetch'
		exports.default = ctx.fetch; // For TypeScript consumers without esModuleInterop.
		exports.fetch = ctx.fetch; // To enable: import {fetch} from 'cross-fetch'
		exports.Headers = ctx.Headers;
		exports.Request = ctx.Request;
		exports.Response = ctx.Response;
		module.exports = exports; 
	} (browserPonyfill, browserPonyfill.exports));

	var browserPonyfillExports = browserPonyfill.exports;
	var fetch$1 = /*@__PURE__*/getDefaultExportFromCjs(browserPonyfillExports);

	const DEFAULT_HTTP_HEADERS = {
	    Accept: "application/json",
	    "Content-Type": "application/json",
	};
	const DEFAULT_HTTP_METHOD = "POST";
	const DEFAULT_FETCH_OPTS = {
	    headers: DEFAULT_HTTP_HEADERS,
	    method: DEFAULT_HTTP_METHOD,
	};
	const EVENT_EMITTER_MAX_LISTENERS_DEFAULT = 10;
	class HttpConnection {
	    constructor(url, disableProviderPing = false) {
	        this.url = url;
	        this.disableProviderPing = disableProviderPing;
	        this.events = new eventsExports.EventEmitter();
	        this.isAvailable = false;
	        this.registering = false;
	        if (!isHttpUrl(url)) {
	            throw new Error(`Provided URL is not compatible with HTTP connection: ${url}`);
	        }
	        this.url = url;
	        this.disableProviderPing = disableProviderPing;
	    }
	    get connected() {
	        return this.isAvailable;
	    }
	    get connecting() {
	        return this.registering;
	    }
	    on(event, listener) {
	        this.events.on(event, listener);
	    }
	    once(event, listener) {
	        this.events.once(event, listener);
	    }
	    off(event, listener) {
	        this.events.off(event, listener);
	    }
	    removeListener(event, listener) {
	        this.events.removeListener(event, listener);
	    }
	    async open(url = this.url) {
	        await this.register(url);
	    }
	    async close() {
	        if (!this.isAvailable) {
	            throw new Error("Connection already closed");
	        }
	        this.onClose();
	    }
	    async send(payload, context) {
	        if (!this.isAvailable) {
	            await this.register();
	        }
	        try {
	            const body = safeJsonStringify(payload);
	            const res = await fetch$1(this.url, Object.assign(Object.assign({}, DEFAULT_FETCH_OPTS), { body }));
	            const data = await res.json();
	            this.onPayload({ data });
	        }
	        catch (e) {
	            this.onError(payload.id, e);
	        }
	    }
	    async register(url = this.url) {
	        if (!isHttpUrl(url)) {
	            throw new Error(`Provided URL is not compatible with HTTP connection: ${url}`);
	        }
	        if (this.registering) {
	            const currentMaxListeners = this.events.getMaxListeners();
	            if (this.events.listenerCount("register_error") >= currentMaxListeners ||
	                this.events.listenerCount("open") >= currentMaxListeners) {
	                this.events.setMaxListeners(currentMaxListeners + 1);
	            }
	            return new Promise((resolve, reject) => {
	                this.events.once("register_error", error => {
	                    this.resetMaxListeners();
	                    reject(error);
	                });
	                this.events.once("open", () => {
	                    this.resetMaxListeners();
	                    if (typeof this.isAvailable === "undefined") {
	                        return reject(new Error("HTTP connection is missing or invalid"));
	                    }
	                    resolve();
	                });
	            });
	        }
	        this.url = url;
	        this.registering = true;
	        try {
	            if (!this.disableProviderPing) {
	                const body = safeJsonStringify({ id: 1, jsonrpc: "2.0", method: "test", params: [] });
	                await fetch$1(url, Object.assign(Object.assign({}, DEFAULT_FETCH_OPTS), { body }));
	            }
	            this.onOpen();
	        }
	        catch (e) {
	            const error = this.parseError(e);
	            this.events.emit("register_error", error);
	            this.onClose();
	            throw error;
	        }
	    }
	    onOpen() {
	        this.isAvailable = true;
	        this.registering = false;
	        this.events.emit("open");
	    }
	    onClose() {
	        this.isAvailable = false;
	        this.registering = false;
	        this.events.emit("close");
	    }
	    onPayload(e) {
	        if (typeof e.data === "undefined")
	            return;
	        const payload = typeof e.data === "string" ? safeJsonParse(e.data) : e.data;
	        this.events.emit("payload", payload);
	    }
	    onError(id, e) {
	        const error = this.parseError(e);
	        const message = error.message || error.toString();
	        const payload = formatJsonRpcError(id, message);
	        this.events.emit("payload", payload);
	    }
	    parseError(e, url = this.url) {
	        return parseConnectionError(e, url, "HTTP");
	    }
	    resetMaxListeners() {
	        if (this.events.getMaxListeners() > EVENT_EMITTER_MAX_LISTENERS_DEFAULT) {
	            this.events.setMaxListeners(EVENT_EMITTER_MAX_LISTENERS_DEFAULT);
	        }
	    }
	}

	const Ca="error",Hg="wss://relay.walletconnect.com",$g="wc",Ug="universal_provider",Ia=`${$g}@2:${Ug}:`,Wg="https://rpc.walletconnect.com/v1",ot$1={DEFAULT_CHAIN_CHANGED:"default_chain_changed"};var pe=typeof globalThis<"u"?globalThis:typeof window<"u"?window:typeof global<"u"?global:typeof self<"u"?self:{},$i={exports:{}};/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */(function(C,u){(function(){var i,p="4.17.21",I=200,D="Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",F="Expected a function",Fn="Invalid `variable` option passed into `_.template`",Gt="__lodash_hash_undefined__",lr=500,At="__lodash_placeholder__",Ln=1,Mn=2,Ct=4,It=1,de=2,vn=1,ft=2,Mi=4,Dn=8,xt=16,Nn=32,Et=64,qn=128,zt=256,pr=512,Ta=30,La="...",Da=800,Na=16,qi=1,Ha=2,$a=3,ct=1/0,kn=9007199254740991,Ua=17976931348623157e292,ge=0/0,Hn=4294967295,Wa=Hn-1,Fa=Hn>>>1,Ma=[["ary",qn],["bind",vn],["bindKey",ft],["curry",Dn],["curryRight",xt],["flip",pr],["partial",Nn],["partialRight",Et],["rearg",zt]],yt="[object Arguments]",ve="[object Array]",qa="[object AsyncFunction]",Kt="[object Boolean]",Yt="[object Date]",Ba="[object DOMException]",_e="[object Error]",me="[object Function]",Bi="[object GeneratorFunction]",yn="[object Map]",Zt="[object Number]",Ga="[object Null]",Bn="[object Object]",Gi="[object Promise]",za="[object Proxy]",Jt="[object RegExp]",Sn="[object Set]",Xt="[object String]",we="[object Symbol]",Ka="[object Undefined]",Qt="[object WeakMap]",Ya="[object WeakSet]",Vt="[object ArrayBuffer]",St="[object DataView]",dr="[object Float32Array]",gr="[object Float64Array]",vr="[object Int8Array]",_r="[object Int16Array]",mr="[object Int32Array]",wr="[object Uint8Array]",Pr="[object Uint8ClampedArray]",Ar="[object Uint16Array]",Cr="[object Uint32Array]",Za=/\b__p \+= '';/g,Ja=/\b(__p \+=) '' \+/g,Xa=/(__e\(.*?\)|\b__t\)) \+\n'';/g,zi=/&(?:amp|lt|gt|quot|#39);/g,Ki=/[&<>"']/g,Qa=RegExp(zi.source),Va=RegExp(Ki.source),ka=/<%-([\s\S]+?)%>/g,ja=/<%([\s\S]+?)%>/g,Yi=/<%=([\s\S]+?)%>/g,no=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,to=/^\w*$/,eo=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,Ir=/[\\^$.*+?()[\]{}|]/g,ro=RegExp(Ir.source),xr=/^\s+/,io=/\s/,so=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,uo=/\{\n\/\* \[wrapped with (.+)\] \*/,ao=/,? & /,oo=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,fo=/[()=,{}\[\]\/\s]/,co=/\\(\\)?/g,ho=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,Zi=/\w*$/,lo=/^[-+]0x[0-9a-f]+$/i,po=/^0b[01]+$/i,go=/^\[object .+?Constructor\]$/,vo=/^0o[0-7]+$/i,_o=/^(?:0|[1-9]\d*)$/,mo=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,Pe=/($^)/,wo=/['\n\r\u2028\u2029\\]/g,Ae="\\ud800-\\udfff",Po="\\u0300-\\u036f",Ao="\\ufe20-\\ufe2f",Co="\\u20d0-\\u20ff",Ji=Po+Ao+Co,Xi="\\u2700-\\u27bf",Qi="a-z\\xdf-\\xf6\\xf8-\\xff",Io="\\xac\\xb1\\xd7\\xf7",xo="\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",Eo="\\u2000-\\u206f",yo=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",Vi="A-Z\\xc0-\\xd6\\xd8-\\xde",ki="\\ufe0e\\ufe0f",ji=Io+xo+Eo+yo,Er="['\u2019]",So="["+Ae+"]",ns="["+ji+"]",Ce="["+Ji+"]",ts="\\d+",Oo="["+Xi+"]",es="["+Qi+"]",rs="[^"+Ae+ji+ts+Xi+Qi+Vi+"]",yr="\\ud83c[\\udffb-\\udfff]",Ro="(?:"+Ce+"|"+yr+")",is="[^"+Ae+"]",Sr="(?:\\ud83c[\\udde6-\\uddff]){2}",Or="[\\ud800-\\udbff][\\udc00-\\udfff]",Ot="["+Vi+"]",ss="\\u200d",us="(?:"+es+"|"+rs+")",bo="(?:"+Ot+"|"+rs+")",as="(?:"+Er+"(?:d|ll|m|re|s|t|ve))?",os="(?:"+Er+"(?:D|LL|M|RE|S|T|VE))?",fs=Ro+"?",cs="["+ki+"]?",To="(?:"+ss+"(?:"+[is,Sr,Or].join("|")+")"+cs+fs+")*",Lo="\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",Do="\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",hs=cs+fs+To,No="(?:"+[Oo,Sr,Or].join("|")+")"+hs,Ho="(?:"+[is+Ce+"?",Ce,Sr,Or,So].join("|")+")",$o=RegExp(Er,"g"),Uo=RegExp(Ce,"g"),Rr=RegExp(yr+"(?="+yr+")|"+Ho+hs,"g"),Wo=RegExp([Ot+"?"+es+"+"+as+"(?="+[ns,Ot,"$"].join("|")+")",bo+"+"+os+"(?="+[ns,Ot+us,"$"].join("|")+")",Ot+"?"+us+"+"+as,Ot+"+"+os,Do,Lo,ts,No].join("|"),"g"),Fo=RegExp("["+ss+Ae+Ji+ki+"]"),Mo=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,qo=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],Bo=-1,B={};B[dr]=B[gr]=B[vr]=B[_r]=B[mr]=B[wr]=B[Pr]=B[Ar]=B[Cr]=!0,B[yt]=B[ve]=B[Vt]=B[Kt]=B[St]=B[Yt]=B[_e]=B[me]=B[yn]=B[Zt]=B[Bn]=B[Jt]=B[Sn]=B[Xt]=B[Qt]=!1;var q={};q[yt]=q[ve]=q[Vt]=q[St]=q[Kt]=q[Yt]=q[dr]=q[gr]=q[vr]=q[_r]=q[mr]=q[yn]=q[Zt]=q[Bn]=q[Jt]=q[Sn]=q[Xt]=q[we]=q[wr]=q[Pr]=q[Ar]=q[Cr]=!0,q[_e]=q[me]=q[Qt]=!1;var Go={\u00C0:"A",\u00C1:"A",\u00C2:"A",\u00C3:"A",\u00C4:"A",\u00C5:"A",\u00E0:"a",\u00E1:"a",\u00E2:"a",\u00E3:"a",\u00E4:"a",\u00E5:"a",\u00C7:"C",\u00E7:"c",\u00D0:"D",\u00F0:"d",\u00C8:"E",\u00C9:"E",\u00CA:"E",\u00CB:"E",\u00E8:"e",\u00E9:"e",\u00EA:"e",\u00EB:"e",\u00CC:"I",\u00CD:"I",\u00CE:"I",\u00CF:"I",\u00EC:"i",\u00ED:"i",\u00EE:"i",\u00EF:"i",\u00D1:"N",\u00F1:"n",\u00D2:"O",\u00D3:"O",\u00D4:"O",\u00D5:"O",\u00D6:"O",\u00D8:"O",\u00F2:"o",\u00F3:"o",\u00F4:"o",\u00F5:"o",\u00F6:"o",\u00F8:"o",\u00D9:"U",\u00DA:"U",\u00DB:"U",\u00DC:"U",\u00F9:"u",\u00FA:"u",\u00FB:"u",\u00FC:"u",\u00DD:"Y",\u00FD:"y",\u00FF:"y",\u00C6:"Ae",\u00E6:"ae",\u00DE:"Th",\u00FE:"th",\u00DF:"ss",\u0100:"A",\u0102:"A",\u0104:"A",\u0101:"a",\u0103:"a",\u0105:"a",\u0106:"C",\u0108:"C",\u010A:"C",\u010C:"C",\u0107:"c",\u0109:"c",\u010B:"c",\u010D:"c",\u010E:"D",\u0110:"D",\u010F:"d",\u0111:"d",\u0112:"E",\u0114:"E",\u0116:"E",\u0118:"E",\u011A:"E",\u0113:"e",\u0115:"e",\u0117:"e",\u0119:"e",\u011B:"e",\u011C:"G",\u011E:"G",\u0120:"G",\u0122:"G",\u011D:"g",\u011F:"g",\u0121:"g",\u0123:"g",\u0124:"H",\u0126:"H",\u0125:"h",\u0127:"h",\u0128:"I",\u012A:"I",\u012C:"I",\u012E:"I",\u0130:"I",\u0129:"i",\u012B:"i",\u012D:"i",\u012F:"i",\u0131:"i",\u0134:"J",\u0135:"j",\u0136:"K",\u0137:"k",\u0138:"k",\u0139:"L",\u013B:"L",\u013D:"L",\u013F:"L",\u0141:"L",\u013A:"l",\u013C:"l",\u013E:"l",\u0140:"l",\u0142:"l",\u0143:"N",\u0145:"N",\u0147:"N",\u014A:"N",\u0144:"n",\u0146:"n",\u0148:"n",\u014B:"n",\u014C:"O",\u014E:"O",\u0150:"O",\u014D:"o",\u014F:"o",\u0151:"o",\u0154:"R",\u0156:"R",\u0158:"R",\u0155:"r",\u0157:"r",\u0159:"r",\u015A:"S",\u015C:"S",\u015E:"S",\u0160:"S",\u015B:"s",\u015D:"s",\u015F:"s",\u0161:"s",\u0162:"T",\u0164:"T",\u0166:"T",\u0163:"t",\u0165:"t",\u0167:"t",\u0168:"U",\u016A:"U",\u016C:"U",\u016E:"U",\u0170:"U",\u0172:"U",\u0169:"u",\u016B:"u",\u016D:"u",\u016F:"u",\u0171:"u",\u0173:"u",\u0174:"W",\u0175:"w",\u0176:"Y",\u0177:"y",\u0178:"Y",\u0179:"Z",\u017B:"Z",\u017D:"Z",\u017A:"z",\u017C:"z",\u017E:"z",\u0132:"IJ",\u0133:"ij",\u0152:"Oe",\u0153:"oe",\u0149:"'n",\u017F:"s"},zo={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"},Ko={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"},Yo={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Zo=parseFloat,Jo=parseInt,ls=typeof pe=="object"&&pe&&pe.Object===Object&&pe,Xo=typeof self=="object"&&self&&self.Object===Object&&self,k=ls||Xo||Function("return this")(),br=u&&!u.nodeType&&u,ht=br&&!0&&C&&!C.nodeType&&C,ps=ht&&ht.exports===br,Tr=ps&&ls.process,_n=function(){try{var h=ht&&ht.require&&ht.require("util").types;return h||Tr&&Tr.binding&&Tr.binding("util")}catch{}}(),ds=_n&&_n.isArrayBuffer,gs=_n&&_n.isDate,vs=_n&&_n.isMap,_s=_n&&_n.isRegExp,ms=_n&&_n.isSet,ws=_n&&_n.isTypedArray;function cn(h,g,d){switch(d.length){case 0:return h.call(g);case 1:return h.call(g,d[0]);case 2:return h.call(g,d[0],d[1]);case 3:return h.call(g,d[0],d[1],d[2])}return h.apply(g,d)}function Qo(h,g,d,P){for(var S=-1,$=h==null?0:h.length;++S<$;){var X=h[S];g(P,X,d(X),h);}return P}function mn(h,g){for(var d=-1,P=h==null?0:h.length;++d<P&&g(h[d],d,h)!==!1;);return h}function Vo(h,g){for(var d=h==null?0:h.length;d--&&g(h[d],d,h)!==!1;);return h}function Ps(h,g){for(var d=-1,P=h==null?0:h.length;++d<P;)if(!g(h[d],d,h))return !1;return !0}function jn(h,g){for(var d=-1,P=h==null?0:h.length,S=0,$=[];++d<P;){var X=h[d];g(X,d,h)&&($[S++]=X);}return $}function Ie(h,g){var d=h==null?0:h.length;return !!d&&Rt(h,g,0)>-1}function Lr(h,g,d){for(var P=-1,S=h==null?0:h.length;++P<S;)if(d(g,h[P]))return !0;return !1}function G(h,g){for(var d=-1,P=h==null?0:h.length,S=Array(P);++d<P;)S[d]=g(h[d],d,h);return S}function nt(h,g){for(var d=-1,P=g.length,S=h.length;++d<P;)h[S+d]=g[d];return h}function Dr(h,g,d,P){var S=-1,$=h==null?0:h.length;for(P&&$&&(d=h[++S]);++S<$;)d=g(d,h[S],S,h);return d}function ko(h,g,d,P){var S=h==null?0:h.length;for(P&&S&&(d=h[--S]);S--;)d=g(d,h[S],S,h);return d}function Nr(h,g){for(var d=-1,P=h==null?0:h.length;++d<P;)if(g(h[d],d,h))return !0;return !1}var jo=Hr("length");function nf(h){return h.split("")}function tf(h){return h.match(oo)||[]}function As(h,g,d){var P;return d(h,function(S,$,X){if(g(S,$,X))return P=$,!1}),P}function xe(h,g,d,P){for(var S=h.length,$=d+(P?1:-1);P?$--:++$<S;)if(g(h[$],$,h))return $;return -1}function Rt(h,g,d){return g===g?df(h,g,d):xe(h,Cs,d)}function ef(h,g,d,P){for(var S=d-1,$=h.length;++S<$;)if(P(h[S],g))return S;return -1}function Cs(h){return h!==h}function Is(h,g){var d=h==null?0:h.length;return d?Ur(h,g)/d:ge}function Hr(h){return function(g){return g==null?i:g[h]}}function $r(h){return function(g){return h==null?i:h[g]}}function xs(h,g,d,P,S){return S(h,function($,X,M){d=P?(P=!1,$):g(d,$,X,M);}),d}function rf(h,g){var d=h.length;for(h.sort(g);d--;)h[d]=h[d].value;return h}function Ur(h,g){for(var d,P=-1,S=h.length;++P<S;){var $=g(h[P]);$!==i&&(d=d===i?$:d+$);}return d}function Wr(h,g){for(var d=-1,P=Array(h);++d<h;)P[d]=g(d);return P}function sf(h,g){return G(g,function(d){return [d,h[d]]})}function Es(h){return h&&h.slice(0,Rs(h)+1).replace(xr,"")}function hn(h){return function(g){return h(g)}}function Fr(h,g){return G(g,function(d){return h[d]})}function kt(h,g){return h.has(g)}function ys(h,g){for(var d=-1,P=h.length;++d<P&&Rt(g,h[d],0)>-1;);return d}function Ss(h,g){for(var d=h.length;d--&&Rt(g,h[d],0)>-1;);return d}function uf(h,g){for(var d=h.length,P=0;d--;)h[d]===g&&++P;return P}var af=$r(Go),of=$r(zo);function ff(h){return "\\"+Yo[h]}function cf(h,g){return h==null?i:h[g]}function bt(h){return Fo.test(h)}function hf(h){return Mo.test(h)}function lf(h){for(var g,d=[];!(g=h.next()).done;)d.push(g.value);return d}function Mr(h){var g=-1,d=Array(h.size);return h.forEach(function(P,S){d[++g]=[S,P];}),d}function Os(h,g){return function(d){return h(g(d))}}function tt(h,g){for(var d=-1,P=h.length,S=0,$=[];++d<P;){var X=h[d];(X===g||X===At)&&(h[d]=At,$[S++]=d);}return $}function Ee(h){var g=-1,d=Array(h.size);return h.forEach(function(P){d[++g]=P;}),d}function pf(h){var g=-1,d=Array(h.size);return h.forEach(function(P){d[++g]=[P,P];}),d}function df(h,g,d){for(var P=d-1,S=h.length;++P<S;)if(h[P]===g)return P;return -1}function gf(h,g,d){for(var P=d+1;P--;)if(h[P]===g)return P;return P}function Tt(h){return bt(h)?_f(h):jo(h)}function On(h){return bt(h)?mf(h):nf(h)}function Rs(h){for(var g=h.length;g--&&io.test(h.charAt(g)););return g}var vf=$r(Ko);function _f(h){for(var g=Rr.lastIndex=0;Rr.test(h);)++g;return g}function mf(h){return h.match(Rr)||[]}function wf(h){return h.match(Wo)||[]}var Pf=function h(g){g=g==null?k:Lt.defaults(k.Object(),g,Lt.pick(k,qo));var d=g.Array,P=g.Date,S=g.Error,$=g.Function,X=g.Math,M=g.Object,qr=g.RegExp,Af=g.String,wn=g.TypeError,ye=d.prototype,Cf=$.prototype,Dt=M.prototype,Se=g["__core-js_shared__"],Oe=Cf.toString,W=Dt.hasOwnProperty,If=0,bs=function(){var n=/[^.]+$/.exec(Se&&Se.keys&&Se.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),Re=Dt.toString,xf=Oe.call(M),Ef=k._,yf=qr("^"+Oe.call(W).replace(Ir,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),be=ps?g.Buffer:i,et=g.Symbol,Te=g.Uint8Array,Ts=be?be.allocUnsafe:i,Le=Os(M.getPrototypeOf,M),Ls=M.create,Ds=Dt.propertyIsEnumerable,De=ye.splice,Ns=et?et.isConcatSpreadable:i,jt=et?et.iterator:i,lt=et?et.toStringTag:i,Ne=function(){try{var n=_t(M,"defineProperty");return n({},"",{}),n}catch{}}(),Sf=g.clearTimeout!==k.clearTimeout&&g.clearTimeout,Of=P&&P.now!==k.Date.now&&P.now,Rf=g.setTimeout!==k.setTimeout&&g.setTimeout,He=X.ceil,$e=X.floor,Br=M.getOwnPropertySymbols,bf=be?be.isBuffer:i,Hs=g.isFinite,Tf=ye.join,Lf=Os(M.keys,M),Q=X.max,nn=X.min,Df=P.now,Nf=g.parseInt,$s=X.random,Hf=ye.reverse,Gr=_t(g,"DataView"),ne=_t(g,"Map"),zr=_t(g,"Promise"),Nt=_t(g,"Set"),te=_t(g,"WeakMap"),ee=_t(M,"create"),Ue=te&&new te,Ht={},$f=mt(Gr),Uf=mt(ne),Wf=mt(zr),Ff=mt(Nt),Mf=mt(te),We=et?et.prototype:i,re=We?We.valueOf:i,Us=We?We.toString:i;function a(n){if(K(n)&&!O(n)&&!(n instanceof N)){if(n instanceof Pn)return n;if(W.call(n,"__wrapped__"))return Wu(n)}return new Pn(n)}var $t=function(){function n(){}return function(t){if(!z(t))return {};if(Ls)return Ls(t);n.prototype=t;var e=new n;return n.prototype=i,e}}();function Fe(){}function Pn(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=i;}a.templateSettings={escape:ka,evaluate:ja,interpolate:Yi,variable:"",imports:{_:a}},a.prototype=Fe.prototype,a.prototype.constructor=a,Pn.prototype=$t(Fe.prototype),Pn.prototype.constructor=Pn;function N(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=Hn,this.__views__=[];}function qf(){var n=new N(this.__wrapped__);return n.__actions__=un(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=un(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=un(this.__views__),n}function Bf(){if(this.__filtered__){var n=new N(this);n.__dir__=-1,n.__filtered__=!0;}else n=this.clone(),n.__dir__*=-1;return n}function Gf(){var n=this.__wrapped__.value(),t=this.__dir__,e=O(n),r=t<0,s=e?n.length:0,o=th(0,s,this.__views__),f=o.start,c=o.end,l=c-f,v=r?c:f-1,_=this.__iteratees__,m=_.length,w=0,A=nn(l,this.__takeCount__);if(!e||!r&&s==l&&A==l)return au(n,this.__actions__);var E=[];n:for(;l--&&w<A;){v+=t;for(var b=-1,y=n[v];++b<m;){var L=_[b],H=L.iteratee,dn=L.type,sn=H(y);if(dn==Ha)y=sn;else if(!sn){if(dn==qi)continue n;break n}}E[w++]=y;}return E}N.prototype=$t(Fe.prototype),N.prototype.constructor=N;function pt(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1]);}}function zf(){this.__data__=ee?ee(null):{},this.size=0;}function Kf(n){var t=this.has(n)&&delete this.__data__[n];return this.size-=t?1:0,t}function Yf(n){var t=this.__data__;if(ee){var e=t[n];return e===Gt?i:e}return W.call(t,n)?t[n]:i}function Zf(n){var t=this.__data__;return ee?t[n]!==i:W.call(t,n)}function Jf(n,t){var e=this.__data__;return this.size+=this.has(n)?0:1,e[n]=ee&&t===i?Gt:t,this}pt.prototype.clear=zf,pt.prototype.delete=Kf,pt.prototype.get=Yf,pt.prototype.has=Zf,pt.prototype.set=Jf;function Gn(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1]);}}function Xf(){this.__data__=[],this.size=0;}function Qf(n){var t=this.__data__,e=Me(t,n);if(e<0)return !1;var r=t.length-1;return e==r?t.pop():De.call(t,e,1),--this.size,!0}function Vf(n){var t=this.__data__,e=Me(t,n);return e<0?i:t[e][1]}function kf(n){return Me(this.__data__,n)>-1}function jf(n,t){var e=this.__data__,r=Me(e,n);return r<0?(++this.size,e.push([n,t])):e[r][1]=t,this}Gn.prototype.clear=Xf,Gn.prototype.delete=Qf,Gn.prototype.get=Vf,Gn.prototype.has=kf,Gn.prototype.set=jf;function zn(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1]);}}function nc(){this.size=0,this.__data__={hash:new pt,map:new(ne||Gn),string:new pt};}function tc(n){var t=ke(this,n).delete(n);return this.size-=t?1:0,t}function ec(n){return ke(this,n).get(n)}function rc(n){return ke(this,n).has(n)}function ic(n,t){var e=ke(this,n),r=e.size;return e.set(n,t),this.size+=e.size==r?0:1,this}zn.prototype.clear=nc,zn.prototype.delete=tc,zn.prototype.get=ec,zn.prototype.has=rc,zn.prototype.set=ic;function dt(n){var t=-1,e=n==null?0:n.length;for(this.__data__=new zn;++t<e;)this.add(n[t]);}function sc(n){return this.__data__.set(n,Gt),this}function uc(n){return this.__data__.has(n)}dt.prototype.add=dt.prototype.push=sc,dt.prototype.has=uc;function Rn(n){var t=this.__data__=new Gn(n);this.size=t.size;}function ac(){this.__data__=new Gn,this.size=0;}function oc(n){var t=this.__data__,e=t.delete(n);return this.size=t.size,e}function fc(n){return this.__data__.get(n)}function cc(n){return this.__data__.has(n)}function hc(n,t){var e=this.__data__;if(e instanceof Gn){var r=e.__data__;if(!ne||r.length<I-1)return r.push([n,t]),this.size=++e.size,this;e=this.__data__=new zn(r);}return e.set(n,t),this.size=e.size,this}Rn.prototype.clear=ac,Rn.prototype.delete=oc,Rn.prototype.get=fc,Rn.prototype.has=cc,Rn.prototype.set=hc;function Ws(n,t){var e=O(n),r=!e&&wt(n),s=!e&&!r&&at(n),o=!e&&!r&&!s&&Mt(n),f=e||r||s||o,c=f?Wr(n.length,Af):[],l=c.length;for(var v in n)(t||W.call(n,v))&&!(f&&(v=="length"||s&&(v=="offset"||v=="parent")||o&&(v=="buffer"||v=="byteLength"||v=="byteOffset")||Jn(v,l)))&&c.push(v);return c}function Fs(n){var t=n.length;return t?n[ti(0,t-1)]:i}function lc(n,t){return je(un(n),gt(t,0,n.length))}function pc(n){return je(un(n))}function Kr(n,t,e){(e!==i&&!bn(n[t],e)||e===i&&!(t in n))&&Kn(n,t,e);}function ie(n,t,e){var r=n[t];(!(W.call(n,t)&&bn(r,e))||e===i&&!(t in n))&&Kn(n,t,e);}function Me(n,t){for(var e=n.length;e--;)if(bn(n[e][0],t))return e;return -1}function dc(n,t,e,r){return rt(n,function(s,o,f){t(r,s,e(s),f);}),r}function Ms(n,t){return n&&Un(t,V(t),n)}function gc(n,t){return n&&Un(t,on(t),n)}function Kn(n,t,e){t=="__proto__"&&Ne?Ne(n,t,{configurable:!0,enumerable:!0,value:e,writable:!0}):n[t]=e;}function Yr(n,t){for(var e=-1,r=t.length,s=d(r),o=n==null;++e<r;)s[e]=o?i:yi(n,t[e]);return s}function gt(n,t,e){return n===n&&(e!==i&&(n=n<=e?n:e),t!==i&&(n=n>=t?n:t)),n}function An(n,t,e,r,s,o){var f,c=t&Ln,l=t&Mn,v=t&Ct;if(e&&(f=s?e(n,r,s,o):e(n)),f!==i)return f;if(!z(n))return n;var _=O(n);if(_){if(f=rh(n),!c)return un(n,f)}else {var m=tn(n),w=m==me||m==Bi;if(at(n))return cu(n,c);if(m==Bn||m==yt||w&&!s){if(f=l||w?{}:Ru(n),!c)return l?Yc(n,gc(f,n)):Kc(n,Ms(f,n))}else {if(!q[m])return s?n:{};f=ih(n,m,c);}}o||(o=new Rn);var A=o.get(n);if(A)return A;o.set(n,f),ia(n)?n.forEach(function(y){f.add(An(y,t,e,y,n,o));}):ea(n)&&n.forEach(function(y,L){f.set(L,An(y,t,e,L,n,o));});var E=v?l?li:hi:l?on:V,b=_?i:E(n);return mn(b||n,function(y,L){b&&(L=y,y=n[L]),ie(f,L,An(y,t,e,L,n,o));}),f}function vc(n){var t=V(n);return function(e){return qs(e,n,t)}}function qs(n,t,e){var r=e.length;if(n==null)return !r;for(n=M(n);r--;){var s=e[r],o=t[s],f=n[s];if(f===i&&!(s in n)||!o(f))return !1}return !0}function Bs(n,t,e){if(typeof n!="function")throw new wn(F);return he(function(){n.apply(i,e);},t)}function se(n,t,e,r){var s=-1,o=Ie,f=!0,c=n.length,l=[],v=t.length;if(!c)return l;e&&(t=G(t,hn(e))),r?(o=Lr,f=!1):t.length>=I&&(o=kt,f=!1,t=new dt(t));n:for(;++s<c;){var _=n[s],m=e==null?_:e(_);if(_=r||_!==0?_:0,f&&m===m){for(var w=v;w--;)if(t[w]===m)continue n;l.push(_);}else o(t,m,r)||l.push(_);}return l}var rt=gu($n),Gs=gu(Jr,!0);function _c(n,t){var e=!0;return rt(n,function(r,s,o){return e=!!t(r,s,o),e}),e}function qe(n,t,e){for(var r=-1,s=n.length;++r<s;){var o=n[r],f=t(o);if(f!=null&&(c===i?f===f&&!pn(f):e(f,c)))var c=f,l=o;}return l}function mc(n,t,e,r){var s=n.length;for(e=R(e),e<0&&(e=-e>s?0:s+e),r=r===i||r>s?s:R(r),r<0&&(r+=s),r=e>r?0:ua(r);e<r;)n[e++]=t;return n}function zs(n,t){var e=[];return rt(n,function(r,s,o){t(r,s,o)&&e.push(r);}),e}function j(n,t,e,r,s){var o=-1,f=n.length;for(e||(e=uh),s||(s=[]);++o<f;){var c=n[o];t>0&&e(c)?t>1?j(c,t-1,e,r,s):nt(s,c):r||(s[s.length]=c);}return s}var Zr=vu(),Ks=vu(!0);function $n(n,t){return n&&Zr(n,t,V)}function Jr(n,t){return n&&Ks(n,t,V)}function Be(n,t){return jn(t,function(e){return Xn(n[e])})}function vt(n,t){t=st(t,n);for(var e=0,r=t.length;n!=null&&e<r;)n=n[Wn(t[e++])];return e&&e==r?n:i}function Ys(n,t,e){var r=t(n);return O(n)?r:nt(r,e(n))}function en(n){return n==null?n===i?Ka:Ga:lt&&lt in M(n)?nh(n):ph(n)}function Xr(n,t){return n>t}function wc(n,t){return n!=null&&W.call(n,t)}function Pc(n,t){return n!=null&&t in M(n)}function Ac(n,t,e){return n>=nn(t,e)&&n<Q(t,e)}function Qr(n,t,e){for(var r=e?Lr:Ie,s=n[0].length,o=n.length,f=o,c=d(o),l=1/0,v=[];f--;){var _=n[f];f&&t&&(_=G(_,hn(t))),l=nn(_.length,l),c[f]=!e&&(t||s>=120&&_.length>=120)?new dt(f&&_):i;}_=n[0];var m=-1,w=c[0];n:for(;++m<s&&v.length<l;){var A=_[m],E=t?t(A):A;if(A=e||A!==0?A:0,!(w?kt(w,E):r(v,E,e))){for(f=o;--f;){var b=c[f];if(!(b?kt(b,E):r(n[f],E,e)))continue n}w&&w.push(E),v.push(A);}}return v}function Cc(n,t,e,r){return $n(n,function(s,o,f){t(r,e(s),o,f);}),r}function ue(n,t,e){t=st(t,n),n=Du(n,t);var r=n==null?n:n[Wn(In(t))];return r==null?i:cn(r,n,e)}function Zs(n){return K(n)&&en(n)==yt}function Ic(n){return K(n)&&en(n)==Vt}function xc(n){return K(n)&&en(n)==Yt}function ae(n,t,e,r,s){return n===t?!0:n==null||t==null||!K(n)&&!K(t)?n!==n&&t!==t:Ec(n,t,e,r,ae,s)}function Ec(n,t,e,r,s,o){var f=O(n),c=O(t),l=f?ve:tn(n),v=c?ve:tn(t);l=l==yt?Bn:l,v=v==yt?Bn:v;var _=l==Bn,m=v==Bn,w=l==v;if(w&&at(n)){if(!at(t))return !1;f=!0,_=!1;}if(w&&!_)return o||(o=new Rn),f||Mt(n)?yu(n,t,e,r,s,o):kc(n,t,l,e,r,s,o);if(!(e&It)){var A=_&&W.call(n,"__wrapped__"),E=m&&W.call(t,"__wrapped__");if(A||E){var b=A?n.value():n,y=E?t.value():t;return o||(o=new Rn),s(b,y,e,r,o)}}return w?(o||(o=new Rn),jc(n,t,e,r,s,o)):!1}function yc(n){return K(n)&&tn(n)==yn}function Vr(n,t,e,r){var s=e.length,o=s,f=!r;if(n==null)return !o;for(n=M(n);s--;){var c=e[s];if(f&&c[2]?c[1]!==n[c[0]]:!(c[0]in n))return !1}for(;++s<o;){c=e[s];var l=c[0],v=n[l],_=c[1];if(f&&c[2]){if(v===i&&!(l in n))return !1}else {var m=new Rn;if(r)var w=r(v,_,l,n,t,m);if(!(w===i?ae(_,v,It|de,r,m):w))return !1}}return !0}function Js(n){if(!z(n)||oh(n))return !1;var t=Xn(n)?yf:go;return t.test(mt(n))}function Sc(n){return K(n)&&en(n)==Jt}function Oc(n){return K(n)&&tn(n)==Sn}function Rc(n){return K(n)&&sr(n.length)&&!!B[en(n)]}function Xs(n){return typeof n=="function"?n:n==null?fn:typeof n=="object"?O(n)?ks(n[0],n[1]):Vs(n):_a(n)}function kr(n){if(!ce(n))return Lf(n);var t=[];for(var e in M(n))W.call(n,e)&&e!="constructor"&&t.push(e);return t}function bc(n){if(!z(n))return lh(n);var t=ce(n),e=[];for(var r in n)r=="constructor"&&(t||!W.call(n,r))||e.push(r);return e}function jr(n,t){return n<t}function Qs(n,t){var e=-1,r=an(n)?d(n.length):[];return rt(n,function(s,o,f){r[++e]=t(s,o,f);}),r}function Vs(n){var t=di(n);return t.length==1&&t[0][2]?Tu(t[0][0],t[0][1]):function(e){return e===n||Vr(e,n,t)}}function ks(n,t){return vi(n)&&bu(t)?Tu(Wn(n),t):function(e){var r=yi(e,n);return r===i&&r===t?Si(e,n):ae(t,r,It|de)}}function Ge(n,t,e,r,s){n!==t&&Zr(t,function(o,f){if(s||(s=new Rn),z(o))Tc(n,t,f,e,Ge,r,s);else {var c=r?r(mi(n,f),o,f+"",n,t,s):i;c===i&&(c=o),Kr(n,f,c);}},on);}function Tc(n,t,e,r,s,o,f){var c=mi(n,e),l=mi(t,e),v=f.get(l);if(v){Kr(n,e,v);return}var _=o?o(c,l,e+"",n,t,f):i,m=_===i;if(m){var w=O(l),A=!w&&at(l),E=!w&&!A&&Mt(l);_=l,w||A||E?O(c)?_=c:Y(c)?_=un(c):A?(m=!1,_=cu(l,!0)):E?(m=!1,_=hu(l,!0)):_=[]:le(l)||wt(l)?(_=c,wt(c)?_=aa(c):(!z(c)||Xn(c))&&(_=Ru(l))):m=!1;}m&&(f.set(l,_),s(_,l,r,o,f),f.delete(l)),Kr(n,e,_);}function js(n,t){var e=n.length;if(e)return t+=t<0?e:0,Jn(t,e)?n[t]:i}function nu(n,t,e){t.length?t=G(t,function(o){return O(o)?function(f){return vt(f,o.length===1?o[0]:o)}:o}):t=[fn];var r=-1;t=G(t,hn(x()));var s=Qs(n,function(o,f,c){var l=G(t,function(v){return v(o)});return {criteria:l,index:++r,value:o}});return rf(s,function(o,f){return zc(o,f,e)})}function Lc(n,t){return tu(n,t,function(e,r){return Si(n,r)})}function tu(n,t,e){for(var r=-1,s=t.length,o={};++r<s;){var f=t[r],c=vt(n,f);e(c,f)&&oe(o,st(f,n),c);}return o}function Dc(n){return function(t){return vt(t,n)}}function ni(n,t,e,r){var s=r?ef:Rt,o=-1,f=t.length,c=n;for(n===t&&(t=un(t)),e&&(c=G(n,hn(e)));++o<f;)for(var l=0,v=t[o],_=e?e(v):v;(l=s(c,_,l,r))>-1;)c!==n&&De.call(c,l,1),De.call(n,l,1);return n}function eu(n,t){for(var e=n?t.length:0,r=e-1;e--;){var s=t[e];if(e==r||s!==o){var o=s;Jn(s)?De.call(n,s,1):ii(n,s);}}return n}function ti(n,t){return n+$e($s()*(t-n+1))}function Nc(n,t,e,r){for(var s=-1,o=Q(He((t-n)/(e||1)),0),f=d(o);o--;)f[r?o:++s]=n,n+=e;return f}function ei(n,t){var e="";if(!n||t<1||t>kn)return e;do t%2&&(e+=n),t=$e(t/2),t&&(n+=n);while(t);return e}function T(n,t){return wi(Lu(n,t,fn),n+"")}function Hc(n){return Fs(qt(n))}function $c(n,t){var e=qt(n);return je(e,gt(t,0,e.length))}function oe(n,t,e,r){if(!z(n))return n;t=st(t,n);for(var s=-1,o=t.length,f=o-1,c=n;c!=null&&++s<o;){var l=Wn(t[s]),v=e;if(l==="__proto__"||l==="constructor"||l==="prototype")return n;if(s!=f){var _=c[l];v=r?r(_,l,c):i,v===i&&(v=z(_)?_:Jn(t[s+1])?[]:{});}ie(c,l,v),c=c[l];}return n}var ru=Ue?function(n,t){return Ue.set(n,t),n}:fn,Uc=Ne?function(n,t){return Ne(n,"toString",{configurable:!0,enumerable:!1,value:Ri(t),writable:!0})}:fn;function Wc(n){return je(qt(n))}function Cn(n,t,e){var r=-1,s=n.length;t<0&&(t=-t>s?0:s+t),e=e>s?s:e,e<0&&(e+=s),s=t>e?0:e-t>>>0,t>>>=0;for(var o=d(s);++r<s;)o[r]=n[r+t];return o}function Fc(n,t){var e;return rt(n,function(r,s,o){return e=t(r,s,o),!e}),!!e}function ze(n,t,e){var r=0,s=n==null?r:n.length;if(typeof t=="number"&&t===t&&s<=Fa){for(;r<s;){var o=r+s>>>1,f=n[o];f!==null&&!pn(f)&&(e?f<=t:f<t)?r=o+1:s=o;}return s}return ri(n,t,fn,e)}function ri(n,t,e,r){var s=0,o=n==null?0:n.length;if(o===0)return 0;t=e(t);for(var f=t!==t,c=t===null,l=pn(t),v=t===i;s<o;){var _=$e((s+o)/2),m=e(n[_]),w=m!==i,A=m===null,E=m===m,b=pn(m);if(f)var y=r||E;else v?y=E&&(r||w):c?y=E&&w&&(r||!A):l?y=E&&w&&!A&&(r||!b):A||b?y=!1:y=r?m<=t:m<t;y?s=_+1:o=_;}return nn(o,Wa)}function iu(n,t){for(var e=-1,r=n.length,s=0,o=[];++e<r;){var f=n[e],c=t?t(f):f;if(!e||!bn(c,l)){var l=c;o[s++]=f===0?0:f;}}return o}function su(n){return typeof n=="number"?n:pn(n)?ge:+n}function ln(n){if(typeof n=="string")return n;if(O(n))return G(n,ln)+"";if(pn(n))return Us?Us.call(n):"";var t=n+"";return t=="0"&&1/n==-ct?"-0":t}function it(n,t,e){var r=-1,s=Ie,o=n.length,f=!0,c=[],l=c;if(e)f=!1,s=Lr;else if(o>=I){var v=t?null:Qc(n);if(v)return Ee(v);f=!1,s=kt,l=new dt;}else l=t?[]:c;n:for(;++r<o;){var _=n[r],m=t?t(_):_;if(_=e||_!==0?_:0,f&&m===m){for(var w=l.length;w--;)if(l[w]===m)continue n;t&&l.push(m),c.push(_);}else s(l,m,e)||(l!==c&&l.push(m),c.push(_));}return c}function ii(n,t){return t=st(t,n),n=Du(n,t),n==null||delete n[Wn(In(t))]}function uu(n,t,e,r){return oe(n,t,e(vt(n,t)),r)}function Ke(n,t,e,r){for(var s=n.length,o=r?s:-1;(r?o--:++o<s)&&t(n[o],o,n););return e?Cn(n,r?0:o,r?o+1:s):Cn(n,r?o+1:0,r?s:o)}function au(n,t){var e=n;return e instanceof N&&(e=e.value()),Dr(t,function(r,s){return s.func.apply(s.thisArg,nt([r],s.args))},e)}function si(n,t,e){var r=n.length;if(r<2)return r?it(n[0]):[];for(var s=-1,o=d(r);++s<r;)for(var f=n[s],c=-1;++c<r;)c!=s&&(o[s]=se(o[s]||f,n[c],t,e));return it(j(o,1),t,e)}function ou(n,t,e){for(var r=-1,s=n.length,o=t.length,f={};++r<s;){var c=r<o?t[r]:i;e(f,n[r],c);}return f}function ui(n){return Y(n)?n:[]}function ai(n){return typeof n=="function"?n:fn}function st(n,t){return O(n)?n:vi(n,t)?[n]:Uu(U(n))}var Mc=T;function ut(n,t,e){var r=n.length;return e=e===i?r:e,!t&&e>=r?n:Cn(n,t,e)}var fu=Sf||function(n){return k.clearTimeout(n)};function cu(n,t){if(t)return n.slice();var e=n.length,r=Ts?Ts(e):new n.constructor(e);return n.copy(r),r}function oi(n){var t=new n.constructor(n.byteLength);return new Te(t).set(new Te(n)),t}function qc(n,t){var e=t?oi(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.byteLength)}function Bc(n){var t=new n.constructor(n.source,Zi.exec(n));return t.lastIndex=n.lastIndex,t}function Gc(n){return re?M(re.call(n)):{}}function hu(n,t){var e=t?oi(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.length)}function lu(n,t){if(n!==t){var e=n!==i,r=n===null,s=n===n,o=pn(n),f=t!==i,c=t===null,l=t===t,v=pn(t);if(!c&&!v&&!o&&n>t||o&&f&&l&&!c&&!v||r&&f&&l||!e&&l||!s)return 1;if(!r&&!o&&!v&&n<t||v&&e&&s&&!r&&!o||c&&e&&s||!f&&s||!l)return -1}return 0}function zc(n,t,e){for(var r=-1,s=n.criteria,o=t.criteria,f=s.length,c=e.length;++r<f;){var l=lu(s[r],o[r]);if(l){if(r>=c)return l;var v=e[r];return l*(v=="desc"?-1:1)}}return n.index-t.index}function pu(n,t,e,r){for(var s=-1,o=n.length,f=e.length,c=-1,l=t.length,v=Q(o-f,0),_=d(l+v),m=!r;++c<l;)_[c]=t[c];for(;++s<f;)(m||s<o)&&(_[e[s]]=n[s]);for(;v--;)_[c++]=n[s++];return _}function du(n,t,e,r){for(var s=-1,o=n.length,f=-1,c=e.length,l=-1,v=t.length,_=Q(o-c,0),m=d(_+v),w=!r;++s<_;)m[s]=n[s];for(var A=s;++l<v;)m[A+l]=t[l];for(;++f<c;)(w||s<o)&&(m[A+e[f]]=n[s++]);return m}function un(n,t){var e=-1,r=n.length;for(t||(t=d(r));++e<r;)t[e]=n[e];return t}function Un(n,t,e,r){var s=!e;e||(e={});for(var o=-1,f=t.length;++o<f;){var c=t[o],l=r?r(e[c],n[c],c,e,n):i;l===i&&(l=n[c]),s?Kn(e,c,l):ie(e,c,l);}return e}function Kc(n,t){return Un(n,gi(n),t)}function Yc(n,t){return Un(n,Su(n),t)}function Ye(n,t){return function(e,r){var s=O(e)?Qo:dc,o=t?t():{};return s(e,n,x(r,2),o)}}function Ut(n){return T(function(t,e){var r=-1,s=e.length,o=s>1?e[s-1]:i,f=s>2?e[2]:i;for(o=n.length>3&&typeof o=="function"?(s--,o):i,f&&rn(e[0],e[1],f)&&(o=s<3?i:o,s=1),t=M(t);++r<s;){var c=e[r];c&&n(t,c,r,o);}return t})}function gu(n,t){return function(e,r){if(e==null)return e;if(!an(e))return n(e,r);for(var s=e.length,o=t?s:-1,f=M(e);(t?o--:++o<s)&&r(f[o],o,f)!==!1;);return e}}function vu(n){return function(t,e,r){for(var s=-1,o=M(t),f=r(t),c=f.length;c--;){var l=f[n?c:++s];if(e(o[l],l,o)===!1)break}return t}}function Zc(n,t,e){var r=t&vn,s=fe(n);function o(){var f=this&&this!==k&&this instanceof o?s:n;return f.apply(r?e:this,arguments)}return o}function _u(n){return function(t){t=U(t);var e=bt(t)?On(t):i,r=e?e[0]:t.charAt(0),s=e?ut(e,1).join(""):t.slice(1);return r[n]()+s}}function Wt(n){return function(t){return Dr(ga(da(t).replace($o,"")),n,"")}}function fe(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var e=$t(n.prototype),r=n.apply(e,t);return z(r)?r:e}}function Jc(n,t,e){var r=fe(n);function s(){for(var o=arguments.length,f=d(o),c=o,l=Ft(s);c--;)f[c]=arguments[c];var v=o<3&&f[0]!==l&&f[o-1]!==l?[]:tt(f,l);if(o-=v.length,o<e)return Cu(n,t,Ze,s.placeholder,i,f,v,i,i,e-o);var _=this&&this!==k&&this instanceof s?r:n;return cn(_,this,f)}return s}function mu(n){return function(t,e,r){var s=M(t);if(!an(t)){var o=x(e,3);t=V(t),e=function(c){return o(s[c],c,s)};}var f=n(t,e,r);return f>-1?s[o?t[f]:f]:i}}function wu(n){return Zn(function(t){var e=t.length,r=e,s=Pn.prototype.thru;for(n&&t.reverse();r--;){var o=t[r];if(typeof o!="function")throw new wn(F);if(s&&!f&&Ve(o)=="wrapper")var f=new Pn([],!0);}for(r=f?r:e;++r<e;){o=t[r];var c=Ve(o),l=c=="wrapper"?pi(o):i;l&&_i(l[0])&&l[1]==(qn|Dn|Nn|zt)&&!l[4].length&&l[9]==1?f=f[Ve(l[0])].apply(f,l[3]):f=o.length==1&&_i(o)?f[c]():f.thru(o);}return function(){var v=arguments,_=v[0];if(f&&v.length==1&&O(_))return f.plant(_).value();for(var m=0,w=e?t[m].apply(this,v):_;++m<e;)w=t[m].call(this,w);return w}})}function Ze(n,t,e,r,s,o,f,c,l,v){var _=t&qn,m=t&vn,w=t&ft,A=t&(Dn|xt),E=t&pr,b=w?i:fe(n);function y(){for(var L=arguments.length,H=d(L),dn=L;dn--;)H[dn]=arguments[dn];if(A)var sn=Ft(y),gn=uf(H,sn);if(r&&(H=pu(H,r,s,A)),o&&(H=du(H,o,f,A)),L-=gn,A&&L<v){var Z=tt(H,sn);return Cu(n,t,Ze,y.placeholder,e,H,Z,c,l,v-L)}var Tn=m?e:this,Vn=w?Tn[n]:n;return L=H.length,c?H=dh(H,c):E&&L>1&&H.reverse(),_&&l<L&&(H.length=l),this&&this!==k&&this instanceof y&&(Vn=b||fe(Vn)),Vn.apply(Tn,H)}return y}function Pu(n,t){return function(e,r){return Cc(e,n,t(r),{})}}function Je(n,t){return function(e,r){var s;if(e===i&&r===i)return t;if(e!==i&&(s=e),r!==i){if(s===i)return r;typeof e=="string"||typeof r=="string"?(e=ln(e),r=ln(r)):(e=su(e),r=su(r)),s=n(e,r);}return s}}function fi(n){return Zn(function(t){return t=G(t,hn(x())),T(function(e){var r=this;return n(t,function(s){return cn(s,r,e)})})})}function Xe(n,t){t=t===i?" ":ln(t);var e=t.length;if(e<2)return e?ei(t,n):t;var r=ei(t,He(n/Tt(t)));return bt(t)?ut(On(r),0,n).join(""):r.slice(0,n)}function Xc(n,t,e,r){var s=t&vn,o=fe(n);function f(){for(var c=-1,l=arguments.length,v=-1,_=r.length,m=d(_+l),w=this&&this!==k&&this instanceof f?o:n;++v<_;)m[v]=r[v];for(;l--;)m[v++]=arguments[++c];return cn(w,s?e:this,m)}return f}function Au(n){return function(t,e,r){return r&&typeof r!="number"&&rn(t,e,r)&&(e=r=i),t=Qn(t),e===i?(e=t,t=0):e=Qn(e),r=r===i?t<e?1:-1:Qn(r),Nc(t,e,r,n)}}function Qe(n){return function(t,e){return typeof t=="string"&&typeof e=="string"||(t=xn(t),e=xn(e)),n(t,e)}}function Cu(n,t,e,r,s,o,f,c,l,v){var _=t&Dn,m=_?f:i,w=_?i:f,A=_?o:i,E=_?i:o;t|=_?Nn:Et,t&=~(_?Et:Nn),t&Mi||(t&=~(vn|ft));var b=[n,t,s,A,m,E,w,c,l,v],y=e.apply(i,b);return _i(n)&&Nu(y,b),y.placeholder=r,Hu(y,n,t)}function ci(n){var t=X[n];return function(e,r){if(e=xn(e),r=r==null?0:nn(R(r),292),r&&Hs(e)){var s=(U(e)+"e").split("e"),o=t(s[0]+"e"+(+s[1]+r));return s=(U(o)+"e").split("e"),+(s[0]+"e"+(+s[1]-r))}return t(e)}}var Qc=Nt&&1/Ee(new Nt([,-0]))[1]==ct?function(n){return new Nt(n)}:Li;function Iu(n){return function(t){var e=tn(t);return e==yn?Mr(t):e==Sn?pf(t):sf(t,n(t))}}function Yn(n,t,e,r,s,o,f,c){var l=t&ft;if(!l&&typeof n!="function")throw new wn(F);var v=r?r.length:0;if(v||(t&=~(Nn|Et),r=s=i),f=f===i?f:Q(R(f),0),c=c===i?c:R(c),v-=s?s.length:0,t&Et){var _=r,m=s;r=s=i;}var w=l?i:pi(n),A=[n,t,e,r,s,_,m,o,f,c];if(w&&hh(A,w),n=A[0],t=A[1],e=A[2],r=A[3],s=A[4],c=A[9]=A[9]===i?l?0:n.length:Q(A[9]-v,0),!c&&t&(Dn|xt)&&(t&=~(Dn|xt)),!t||t==vn)var E=Zc(n,t,e);else t==Dn||t==xt?E=Jc(n,t,c):(t==Nn||t==(vn|Nn))&&!s.length?E=Xc(n,t,e,r):E=Ze.apply(i,A);var b=w?ru:Nu;return Hu(b(E,A),n,t)}function xu(n,t,e,r){return n===i||bn(n,Dt[e])&&!W.call(r,e)?t:n}function Eu(n,t,e,r,s,o){return z(n)&&z(t)&&(o.set(t,n),Ge(n,t,i,Eu,o),o.delete(t)),n}function Vc(n){return le(n)?i:n}function yu(n,t,e,r,s,o){var f=e&It,c=n.length,l=t.length;if(c!=l&&!(f&&l>c))return !1;var v=o.get(n),_=o.get(t);if(v&&_)return v==t&&_==n;var m=-1,w=!0,A=e&de?new dt:i;for(o.set(n,t),o.set(t,n);++m<c;){var E=n[m],b=t[m];if(r)var y=f?r(b,E,m,t,n,o):r(E,b,m,n,t,o);if(y!==i){if(y)continue;w=!1;break}if(A){if(!Nr(t,function(L,H){if(!kt(A,H)&&(E===L||s(E,L,e,r,o)))return A.push(H)})){w=!1;break}}else if(!(E===b||s(E,b,e,r,o))){w=!1;break}}return o.delete(n),o.delete(t),w}function kc(n,t,e,r,s,o,f){switch(e){case St:if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)return !1;n=n.buffer,t=t.buffer;case Vt:return !(n.byteLength!=t.byteLength||!o(new Te(n),new Te(t)));case Kt:case Yt:case Zt:return bn(+n,+t);case _e:return n.name==t.name&&n.message==t.message;case Jt:case Xt:return n==t+"";case yn:var c=Mr;case Sn:var l=r&It;if(c||(c=Ee),n.size!=t.size&&!l)return !1;var v=f.get(n);if(v)return v==t;r|=de,f.set(n,t);var _=yu(c(n),c(t),r,s,o,f);return f.delete(n),_;case we:if(re)return re.call(n)==re.call(t)}return !1}function jc(n,t,e,r,s,o){var f=e&It,c=hi(n),l=c.length,v=hi(t),_=v.length;if(l!=_&&!f)return !1;for(var m=l;m--;){var w=c[m];if(!(f?w in t:W.call(t,w)))return !1}var A=o.get(n),E=o.get(t);if(A&&E)return A==t&&E==n;var b=!0;o.set(n,t),o.set(t,n);for(var y=f;++m<l;){w=c[m];var L=n[w],H=t[w];if(r)var dn=f?r(H,L,w,t,n,o):r(L,H,w,n,t,o);if(!(dn===i?L===H||s(L,H,e,r,o):dn)){b=!1;break}y||(y=w=="constructor");}if(b&&!y){var sn=n.constructor,gn=t.constructor;sn!=gn&&"constructor"in n&&"constructor"in t&&!(typeof sn=="function"&&sn instanceof sn&&typeof gn=="function"&&gn instanceof gn)&&(b=!1);}return o.delete(n),o.delete(t),b}function Zn(n){return wi(Lu(n,i,qu),n+"")}function hi(n){return Ys(n,V,gi)}function li(n){return Ys(n,on,Su)}var pi=Ue?function(n){return Ue.get(n)}:Li;function Ve(n){for(var t=n.name+"",e=Ht[t],r=W.call(Ht,t)?e.length:0;r--;){var s=e[r],o=s.func;if(o==null||o==n)return s.name}return t}function Ft(n){var t=W.call(a,"placeholder")?a:n;return t.placeholder}function x(){var n=a.iteratee||bi;return n=n===bi?Xs:n,arguments.length?n(arguments[0],arguments[1]):n}function ke(n,t){var e=n.__data__;return ah(t)?e[typeof t=="string"?"string":"hash"]:e.map}function di(n){for(var t=V(n),e=t.length;e--;){var r=t[e],s=n[r];t[e]=[r,s,bu(s)];}return t}function _t(n,t){var e=cf(n,t);return Js(e)?e:i}function nh(n){var t=W.call(n,lt),e=n[lt];try{n[lt]=i;var r=!0;}catch{}var s=Re.call(n);return r&&(t?n[lt]=e:delete n[lt]),s}var gi=Br?function(n){return n==null?[]:(n=M(n),jn(Br(n),function(t){return Ds.call(n,t)}))}:Di,Su=Br?function(n){for(var t=[];n;)nt(t,gi(n)),n=Le(n);return t}:Di,tn=en;(Gr&&tn(new Gr(new ArrayBuffer(1)))!=St||ne&&tn(new ne)!=yn||zr&&tn(zr.resolve())!=Gi||Nt&&tn(new Nt)!=Sn||te&&tn(new te)!=Qt)&&(tn=function(n){var t=en(n),e=t==Bn?n.constructor:i,r=e?mt(e):"";if(r)switch(r){case $f:return St;case Uf:return yn;case Wf:return Gi;case Ff:return Sn;case Mf:return Qt}return t});function th(n,t,e){for(var r=-1,s=e.length;++r<s;){var o=e[r],f=o.size;switch(o.type){case"drop":n+=f;break;case"dropRight":t-=f;break;case"take":t=nn(t,n+f);break;case"takeRight":n=Q(n,t-f);break}}return {start:n,end:t}}function eh(n){var t=n.match(uo);return t?t[1].split(ao):[]}function Ou(n,t,e){t=st(t,n);for(var r=-1,s=t.length,o=!1;++r<s;){var f=Wn(t[r]);if(!(o=n!=null&&e(n,f)))break;n=n[f];}return o||++r!=s?o:(s=n==null?0:n.length,!!s&&sr(s)&&Jn(f,s)&&(O(n)||wt(n)))}function rh(n){var t=n.length,e=new n.constructor(t);return t&&typeof n[0]=="string"&&W.call(n,"index")&&(e.index=n.index,e.input=n.input),e}function Ru(n){return typeof n.constructor=="function"&&!ce(n)?$t(Le(n)):{}}function ih(n,t,e){var r=n.constructor;switch(t){case Vt:return oi(n);case Kt:case Yt:return new r(+n);case St:return qc(n,e);case dr:case gr:case vr:case _r:case mr:case wr:case Pr:case Ar:case Cr:return hu(n,e);case yn:return new r;case Zt:case Xt:return new r(n);case Jt:return Bc(n);case Sn:return new r;case we:return Gc(n)}}function sh(n,t){var e=t.length;if(!e)return n;var r=e-1;return t[r]=(e>1?"& ":"")+t[r],t=t.join(e>2?", ":" "),n.replace(so,`{
/* [wrapped with `+t+`] */
`)}function uh(n){return O(n)||wt(n)||!!(Ns&&n&&n[Ns])}function Jn(n,t){var e=typeof n;return t=t??kn,!!t&&(e=="number"||e!="symbol"&&_o.test(n))&&n>-1&&n%1==0&&n<t}function rn(n,t,e){if(!z(e))return !1;var r=typeof t;return (r=="number"?an(e)&&Jn(t,e.length):r=="string"&&t in e)?bn(e[t],n):!1}function vi(n,t){if(O(n))return !1;var e=typeof n;return e=="number"||e=="symbol"||e=="boolean"||n==null||pn(n)?!0:to.test(n)||!no.test(n)||t!=null&&n in M(t)}function ah(n){var t=typeof n;return t=="string"||t=="number"||t=="symbol"||t=="boolean"?n!=="__proto__":n===null}function _i(n){var t=Ve(n),e=a[t];if(typeof e!="function"||!(t in N.prototype))return !1;if(n===e)return !0;var r=pi(e);return !!r&&n===r[0]}function oh(n){return !!bs&&bs in n}var fh=Se?Xn:Ni;function ce(n){var t=n&&n.constructor,e=typeof t=="function"&&t.prototype||Dt;return n===e}function bu(n){return n===n&&!z(n)}function Tu(n,t){return function(e){return e==null?!1:e[n]===t&&(t!==i||n in M(e))}}function ch(n){var t=rr(n,function(r){return e.size===lr&&e.clear(),r}),e=t.cache;return t}function hh(n,t){var e=n[1],r=t[1],s=e|r,o=s<(vn|ft|qn),f=r==qn&&e==Dn||r==qn&&e==zt&&n[7].length<=t[8]||r==(qn|zt)&&t[7].length<=t[8]&&e==Dn;if(!(o||f))return n;r&vn&&(n[2]=t[2],s|=e&vn?0:Mi);var c=t[3];if(c){var l=n[3];n[3]=l?pu(l,c,t[4]):c,n[4]=l?tt(n[3],At):t[4];}return c=t[5],c&&(l=n[5],n[5]=l?du(l,c,t[6]):c,n[6]=l?tt(n[5],At):t[6]),c=t[7],c&&(n[7]=c),r&qn&&(n[8]=n[8]==null?t[8]:nn(n[8],t[8])),n[9]==null&&(n[9]=t[9]),n[0]=t[0],n[1]=s,n}function lh(n){var t=[];if(n!=null)for(var e in M(n))t.push(e);return t}function ph(n){return Re.call(n)}function Lu(n,t,e){return t=Q(t===i?n.length-1:t,0),function(){for(var r=arguments,s=-1,o=Q(r.length-t,0),f=d(o);++s<o;)f[s]=r[t+s];s=-1;for(var c=d(t+1);++s<t;)c[s]=r[s];return c[t]=e(f),cn(n,this,c)}}function Du(n,t){return t.length<2?n:vt(n,Cn(t,0,-1))}function dh(n,t){for(var e=n.length,r=nn(t.length,e),s=un(n);r--;){var o=t[r];n[r]=Jn(o,e)?s[o]:i;}return n}function mi(n,t){if(!(t==="constructor"&&typeof n[t]=="function")&&t!="__proto__")return n[t]}var Nu=$u(ru),he=Rf||function(n,t){return k.setTimeout(n,t)},wi=$u(Uc);function Hu(n,t,e){var r=t+"";return wi(n,sh(r,gh(eh(r),e)))}function $u(n){var t=0,e=0;return function(){var r=Df(),s=Na-(r-e);if(e=r,s>0){if(++t>=Da)return arguments[0]}else t=0;return n.apply(i,arguments)}}function je(n,t){var e=-1,r=n.length,s=r-1;for(t=t===i?r:t;++e<t;){var o=ti(e,s),f=n[o];n[o]=n[e],n[e]=f;}return n.length=t,n}var Uu=ch(function(n){var t=[];return n.charCodeAt(0)===46&&t.push(""),n.replace(eo,function(e,r,s,o){t.push(s?o.replace(co,"$1"):r||e);}),t});function Wn(n){if(typeof n=="string"||pn(n))return n;var t=n+"";return t=="0"&&1/n==-ct?"-0":t}function mt(n){if(n!=null){try{return Oe.call(n)}catch{}try{return n+""}catch{}}return ""}function gh(n,t){return mn(Ma,function(e){var r="_."+e[0];t&e[1]&&!Ie(n,r)&&n.push(r);}),n.sort()}function Wu(n){if(n instanceof N)return n.clone();var t=new Pn(n.__wrapped__,n.__chain__);return t.__actions__=un(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function vh(n,t,e){(e?rn(n,t,e):t===i)?t=1:t=Q(R(t),0);var r=n==null?0:n.length;if(!r||t<1)return [];for(var s=0,o=0,f=d(He(r/t));s<r;)f[o++]=Cn(n,s,s+=t);return f}function _h(n){for(var t=-1,e=n==null?0:n.length,r=0,s=[];++t<e;){var o=n[t];o&&(s[r++]=o);}return s}function mh(){var n=arguments.length;if(!n)return [];for(var t=d(n-1),e=arguments[0],r=n;r--;)t[r-1]=arguments[r];return nt(O(e)?un(e):[e],j(t,1))}var wh=T(function(n,t){return Y(n)?se(n,j(t,1,Y,!0)):[]}),Ph=T(function(n,t){var e=In(t);return Y(e)&&(e=i),Y(n)?se(n,j(t,1,Y,!0),x(e,2)):[]}),Ah=T(function(n,t){var e=In(t);return Y(e)&&(e=i),Y(n)?se(n,j(t,1,Y,!0),i,e):[]});function Ch(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===i?1:R(t),Cn(n,t<0?0:t,r)):[]}function Ih(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===i?1:R(t),t=r-t,Cn(n,0,t<0?0:t)):[]}function xh(n,t){return n&&n.length?Ke(n,x(t,3),!0,!0):[]}function Eh(n,t){return n&&n.length?Ke(n,x(t,3),!0):[]}function yh(n,t,e,r){var s=n==null?0:n.length;return s?(e&&typeof e!="number"&&rn(n,t,e)&&(e=0,r=s),mc(n,t,e,r)):[]}function Fu(n,t,e){var r=n==null?0:n.length;if(!r)return -1;var s=e==null?0:R(e);return s<0&&(s=Q(r+s,0)),xe(n,x(t,3),s)}function Mu(n,t,e){var r=n==null?0:n.length;if(!r)return -1;var s=r-1;return e!==i&&(s=R(e),s=e<0?Q(r+s,0):nn(s,r-1)),xe(n,x(t,3),s,!0)}function qu(n){var t=n==null?0:n.length;return t?j(n,1):[]}function Sh(n){var t=n==null?0:n.length;return t?j(n,ct):[]}function Oh(n,t){var e=n==null?0:n.length;return e?(t=t===i?1:R(t),j(n,t)):[]}function Rh(n){for(var t=-1,e=n==null?0:n.length,r={};++t<e;){var s=n[t];r[s[0]]=s[1];}return r}function Bu(n){return n&&n.length?n[0]:i}function bh(n,t,e){var r=n==null?0:n.length;if(!r)return -1;var s=e==null?0:R(e);return s<0&&(s=Q(r+s,0)),Rt(n,t,s)}function Th(n){var t=n==null?0:n.length;return t?Cn(n,0,-1):[]}var Lh=T(function(n){var t=G(n,ui);return t.length&&t[0]===n[0]?Qr(t):[]}),Dh=T(function(n){var t=In(n),e=G(n,ui);return t===In(e)?t=i:e.pop(),e.length&&e[0]===n[0]?Qr(e,x(t,2)):[]}),Nh=T(function(n){var t=In(n),e=G(n,ui);return t=typeof t=="function"?t:i,t&&e.pop(),e.length&&e[0]===n[0]?Qr(e,i,t):[]});function Hh(n,t){return n==null?"":Tf.call(n,t)}function In(n){var t=n==null?0:n.length;return t?n[t-1]:i}function $h(n,t,e){var r=n==null?0:n.length;if(!r)return -1;var s=r;return e!==i&&(s=R(e),s=s<0?Q(r+s,0):nn(s,r-1)),t===t?gf(n,t,s):xe(n,Cs,s,!0)}function Uh(n,t){return n&&n.length?js(n,R(t)):i}var Wh=T(Gu);function Gu(n,t){return n&&n.length&&t&&t.length?ni(n,t):n}function Fh(n,t,e){return n&&n.length&&t&&t.length?ni(n,t,x(e,2)):n}function Mh(n,t,e){return n&&n.length&&t&&t.length?ni(n,t,i,e):n}var qh=Zn(function(n,t){var e=n==null?0:n.length,r=Yr(n,t);return eu(n,G(t,function(s){return Jn(s,e)?+s:s}).sort(lu)),r});function Bh(n,t){var e=[];if(!(n&&n.length))return e;var r=-1,s=[],o=n.length;for(t=x(t,3);++r<o;){var f=n[r];t(f,r,n)&&(e.push(f),s.push(r));}return eu(n,s),e}function Pi(n){return n==null?n:Hf.call(n)}function Gh(n,t,e){var r=n==null?0:n.length;return r?(e&&typeof e!="number"&&rn(n,t,e)?(t=0,e=r):(t=t==null?0:R(t),e=e===i?r:R(e)),Cn(n,t,e)):[]}function zh(n,t){return ze(n,t)}function Kh(n,t,e){return ri(n,t,x(e,2))}function Yh(n,t){var e=n==null?0:n.length;if(e){var r=ze(n,t);if(r<e&&bn(n[r],t))return r}return -1}function Zh(n,t){return ze(n,t,!0)}function Jh(n,t,e){return ri(n,t,x(e,2),!0)}function Xh(n,t){var e=n==null?0:n.length;if(e){var r=ze(n,t,!0)-1;if(bn(n[r],t))return r}return -1}function Qh(n){return n&&n.length?iu(n):[]}function Vh(n,t){return n&&n.length?iu(n,x(t,2)):[]}function kh(n){var t=n==null?0:n.length;return t?Cn(n,1,t):[]}function jh(n,t,e){return n&&n.length?(t=e||t===i?1:R(t),Cn(n,0,t<0?0:t)):[]}function nl(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===i?1:R(t),t=r-t,Cn(n,t<0?0:t,r)):[]}function tl(n,t){return n&&n.length?Ke(n,x(t,3),!1,!0):[]}function el(n,t){return n&&n.length?Ke(n,x(t,3)):[]}var rl=T(function(n){return it(j(n,1,Y,!0))}),il=T(function(n){var t=In(n);return Y(t)&&(t=i),it(j(n,1,Y,!0),x(t,2))}),sl=T(function(n){var t=In(n);return t=typeof t=="function"?t:i,it(j(n,1,Y,!0),i,t)});function ul(n){return n&&n.length?it(n):[]}function al(n,t){return n&&n.length?it(n,x(t,2)):[]}function ol(n,t){return t=typeof t=="function"?t:i,n&&n.length?it(n,i,t):[]}function Ai(n){if(!(n&&n.length))return [];var t=0;return n=jn(n,function(e){if(Y(e))return t=Q(e.length,t),!0}),Wr(t,function(e){return G(n,Hr(e))})}function zu(n,t){if(!(n&&n.length))return [];var e=Ai(n);return t==null?e:G(e,function(r){return cn(t,i,r)})}var fl=T(function(n,t){return Y(n)?se(n,t):[]}),cl=T(function(n){return si(jn(n,Y))}),hl=T(function(n){var t=In(n);return Y(t)&&(t=i),si(jn(n,Y),x(t,2))}),ll=T(function(n){var t=In(n);return t=typeof t=="function"?t:i,si(jn(n,Y),i,t)}),pl=T(Ai);function dl(n,t){return ou(n||[],t||[],ie)}function gl(n,t){return ou(n||[],t||[],oe)}var vl=T(function(n){var t=n.length,e=t>1?n[t-1]:i;return e=typeof e=="function"?(n.pop(),e):i,zu(n,e)});function Ku(n){var t=a(n);return t.__chain__=!0,t}function _l(n,t){return t(n),n}function nr(n,t){return t(n)}var ml=Zn(function(n){var t=n.length,e=t?n[0]:0,r=this.__wrapped__,s=function(o){return Yr(o,n)};return t>1||this.__actions__.length||!(r instanceof N)||!Jn(e)?this.thru(s):(r=r.slice(e,+e+(t?1:0)),r.__actions__.push({func:nr,args:[s],thisArg:i}),new Pn(r,this.__chain__).thru(function(o){return t&&!o.length&&o.push(i),o}))});function wl(){return Ku(this)}function Pl(){return new Pn(this.value(),this.__chain__)}function Al(){this.__values__===i&&(this.__values__=sa(this.value()));var n=this.__index__>=this.__values__.length,t=n?i:this.__values__[this.__index__++];return {done:n,value:t}}function Cl(){return this}function Il(n){for(var t,e=this;e instanceof Fe;){var r=Wu(e);r.__index__=0,r.__values__=i,t?s.__wrapped__=r:t=r;var s=r;e=e.__wrapped__;}return s.__wrapped__=n,t}function xl(){var n=this.__wrapped__;if(n instanceof N){var t=n;return this.__actions__.length&&(t=new N(this)),t=t.reverse(),t.__actions__.push({func:nr,args:[Pi],thisArg:i}),new Pn(t,this.__chain__)}return this.thru(Pi)}function El(){return au(this.__wrapped__,this.__actions__)}var yl=Ye(function(n,t,e){W.call(n,e)?++n[e]:Kn(n,e,1);});function Sl(n,t,e){var r=O(n)?Ps:_c;return e&&rn(n,t,e)&&(t=i),r(n,x(t,3))}function Ol(n,t){var e=O(n)?jn:zs;return e(n,x(t,3))}var Rl=mu(Fu),bl=mu(Mu);function Tl(n,t){return j(tr(n,t),1)}function Ll(n,t){return j(tr(n,t),ct)}function Dl(n,t,e){return e=e===i?1:R(e),j(tr(n,t),e)}function Yu(n,t){var e=O(n)?mn:rt;return e(n,x(t,3))}function Zu(n,t){var e=O(n)?Vo:Gs;return e(n,x(t,3))}var Nl=Ye(function(n,t,e){W.call(n,e)?n[e].push(t):Kn(n,e,[t]);});function Hl(n,t,e,r){n=an(n)?n:qt(n),e=e&&!r?R(e):0;var s=n.length;return e<0&&(e=Q(s+e,0)),ur(n)?e<=s&&n.indexOf(t,e)>-1:!!s&&Rt(n,t,e)>-1}var $l=T(function(n,t,e){var r=-1,s=typeof t=="function",o=an(n)?d(n.length):[];return rt(n,function(f){o[++r]=s?cn(t,f,e):ue(f,t,e);}),o}),Ul=Ye(function(n,t,e){Kn(n,e,t);});function tr(n,t){var e=O(n)?G:Qs;return e(n,x(t,3))}function Wl(n,t,e,r){return n==null?[]:(O(t)||(t=t==null?[]:[t]),e=r?i:e,O(e)||(e=e==null?[]:[e]),nu(n,t,e))}var Fl=Ye(function(n,t,e){n[e?0:1].push(t);},function(){return [[],[]]});function Ml(n,t,e){var r=O(n)?Dr:xs,s=arguments.length<3;return r(n,x(t,4),e,s,rt)}function ql(n,t,e){var r=O(n)?ko:xs,s=arguments.length<3;return r(n,x(t,4),e,s,Gs)}function Bl(n,t){var e=O(n)?jn:zs;return e(n,ir(x(t,3)))}function Gl(n){var t=O(n)?Fs:Hc;return t(n)}function zl(n,t,e){(e?rn(n,t,e):t===i)?t=1:t=R(t);var r=O(n)?lc:$c;return r(n,t)}function Kl(n){var t=O(n)?pc:Wc;return t(n)}function Yl(n){if(n==null)return 0;if(an(n))return ur(n)?Tt(n):n.length;var t=tn(n);return t==yn||t==Sn?n.size:kr(n).length}function Zl(n,t,e){var r=O(n)?Nr:Fc;return e&&rn(n,t,e)&&(t=i),r(n,x(t,3))}var Jl=T(function(n,t){if(n==null)return [];var e=t.length;return e>1&&rn(n,t[0],t[1])?t=[]:e>2&&rn(t[0],t[1],t[2])&&(t=[t[0]]),nu(n,j(t,1),[])}),er=Of||function(){return k.Date.now()};function Xl(n,t){if(typeof t!="function")throw new wn(F);return n=R(n),function(){if(--n<1)return t.apply(this,arguments)}}function Ju(n,t,e){return t=e?i:t,t=n&&t==null?n.length:t,Yn(n,qn,i,i,i,i,t)}function Xu(n,t){var e;if(typeof t!="function")throw new wn(F);return n=R(n),function(){return --n>0&&(e=t.apply(this,arguments)),n<=1&&(t=i),e}}var Ci=T(function(n,t,e){var r=vn;if(e.length){var s=tt(e,Ft(Ci));r|=Nn;}return Yn(n,r,t,e,s)}),Qu=T(function(n,t,e){var r=vn|ft;if(e.length){var s=tt(e,Ft(Qu));r|=Nn;}return Yn(t,r,n,e,s)});function Vu(n,t,e){t=e?i:t;var r=Yn(n,Dn,i,i,i,i,i,t);return r.placeholder=Vu.placeholder,r}function ku(n,t,e){t=e?i:t;var r=Yn(n,xt,i,i,i,i,i,t);return r.placeholder=ku.placeholder,r}function ju(n,t,e){var r,s,o,f,c,l,v=0,_=!1,m=!1,w=!0;if(typeof n!="function")throw new wn(F);t=xn(t)||0,z(e)&&(_=!!e.leading,m="maxWait"in e,o=m?Q(xn(e.maxWait)||0,t):o,w="trailing"in e?!!e.trailing:w);function A(Z){var Tn=r,Vn=s;return r=s=i,v=Z,f=n.apply(Vn,Tn),f}function E(Z){return v=Z,c=he(L,t),_?A(Z):f}function b(Z){var Tn=Z-l,Vn=Z-v,ma=t-Tn;return m?nn(ma,o-Vn):ma}function y(Z){var Tn=Z-l,Vn=Z-v;return l===i||Tn>=t||Tn<0||m&&Vn>=o}function L(){var Z=er();if(y(Z))return H(Z);c=he(L,b(Z));}function H(Z){return c=i,w&&r?A(Z):(r=s=i,f)}function dn(){c!==i&&fu(c),v=0,r=l=s=c=i;}function sn(){return c===i?f:H(er())}function gn(){var Z=er(),Tn=y(Z);if(r=arguments,s=this,l=Z,Tn){if(c===i)return E(l);if(m)return fu(c),c=he(L,t),A(l)}return c===i&&(c=he(L,t)),f}return gn.cancel=dn,gn.flush=sn,gn}var Ql=T(function(n,t){return Bs(n,1,t)}),Vl=T(function(n,t,e){return Bs(n,xn(t)||0,e)});function kl(n){return Yn(n,pr)}function rr(n,t){if(typeof n!="function"||t!=null&&typeof t!="function")throw new wn(F);var e=function(){var r=arguments,s=t?t.apply(this,r):r[0],o=e.cache;if(o.has(s))return o.get(s);var f=n.apply(this,r);return e.cache=o.set(s,f)||o,f};return e.cache=new(rr.Cache||zn),e}rr.Cache=zn;function ir(n){if(typeof n!="function")throw new wn(F);return function(){var t=arguments;switch(t.length){case 0:return !n.call(this);case 1:return !n.call(this,t[0]);case 2:return !n.call(this,t[0],t[1]);case 3:return !n.call(this,t[0],t[1],t[2])}return !n.apply(this,t)}}function jl(n){return Xu(2,n)}var np=Mc(function(n,t){t=t.length==1&&O(t[0])?G(t[0],hn(x())):G(j(t,1),hn(x()));var e=t.length;return T(function(r){for(var s=-1,o=nn(r.length,e);++s<o;)r[s]=t[s].call(this,r[s]);return cn(n,this,r)})}),Ii=T(function(n,t){var e=tt(t,Ft(Ii));return Yn(n,Nn,i,t,e)}),na=T(function(n,t){var e=tt(t,Ft(na));return Yn(n,Et,i,t,e)}),tp=Zn(function(n,t){return Yn(n,zt,i,i,i,t)});function ep(n,t){if(typeof n!="function")throw new wn(F);return t=t===i?t:R(t),T(n,t)}function rp(n,t){if(typeof n!="function")throw new wn(F);return t=t==null?0:Q(R(t),0),T(function(e){var r=e[t],s=ut(e,0,t);return r&&nt(s,r),cn(n,this,s)})}function ip(n,t,e){var r=!0,s=!0;if(typeof n!="function")throw new wn(F);return z(e)&&(r="leading"in e?!!e.leading:r,s="trailing"in e?!!e.trailing:s),ju(n,t,{leading:r,maxWait:t,trailing:s})}function sp(n){return Ju(n,1)}function up(n,t){return Ii(ai(t),n)}function ap(){if(!arguments.length)return [];var n=arguments[0];return O(n)?n:[n]}function op(n){return An(n,Ct)}function fp(n,t){return t=typeof t=="function"?t:i,An(n,Ct,t)}function cp(n){return An(n,Ln|Ct)}function hp(n,t){return t=typeof t=="function"?t:i,An(n,Ln|Ct,t)}function lp(n,t){return t==null||qs(n,t,V(t))}function bn(n,t){return n===t||n!==n&&t!==t}var pp=Qe(Xr),dp=Qe(function(n,t){return n>=t}),wt=Zs(function(){return arguments}())?Zs:function(n){return K(n)&&W.call(n,"callee")&&!Ds.call(n,"callee")},O=d.isArray,gp=ds?hn(ds):Ic;function an(n){return n!=null&&sr(n.length)&&!Xn(n)}function Y(n){return K(n)&&an(n)}function vp(n){return n===!0||n===!1||K(n)&&en(n)==Kt}var at=bf||Ni,_p=gs?hn(gs):xc;function mp(n){return K(n)&&n.nodeType===1&&!le(n)}function wp(n){if(n==null)return !0;if(an(n)&&(O(n)||typeof n=="string"||typeof n.splice=="function"||at(n)||Mt(n)||wt(n)))return !n.length;var t=tn(n);if(t==yn||t==Sn)return !n.size;if(ce(n))return !kr(n).length;for(var e in n)if(W.call(n,e))return !1;return !0}function Pp(n,t){return ae(n,t)}function Ap(n,t,e){e=typeof e=="function"?e:i;var r=e?e(n,t):i;return r===i?ae(n,t,i,e):!!r}function xi(n){if(!K(n))return !1;var t=en(n);return t==_e||t==Ba||typeof n.message=="string"&&typeof n.name=="string"&&!le(n)}function Cp(n){return typeof n=="number"&&Hs(n)}function Xn(n){if(!z(n))return !1;var t=en(n);return t==me||t==Bi||t==qa||t==za}function ta(n){return typeof n=="number"&&n==R(n)}function sr(n){return typeof n=="number"&&n>-1&&n%1==0&&n<=kn}function z(n){var t=typeof n;return n!=null&&(t=="object"||t=="function")}function K(n){return n!=null&&typeof n=="object"}var ea=vs?hn(vs):yc;function Ip(n,t){return n===t||Vr(n,t,di(t))}function xp(n,t,e){return e=typeof e=="function"?e:i,Vr(n,t,di(t),e)}function Ep(n){return ra(n)&&n!=+n}function yp(n){if(fh(n))throw new S(D);return Js(n)}function Sp(n){return n===null}function Op(n){return n==null}function ra(n){return typeof n=="number"||K(n)&&en(n)==Zt}function le(n){if(!K(n)||en(n)!=Bn)return !1;var t=Le(n);if(t===null)return !0;var e=W.call(t,"constructor")&&t.constructor;return typeof e=="function"&&e instanceof e&&Oe.call(e)==xf}var Ei=_s?hn(_s):Sc;function Rp(n){return ta(n)&&n>=-kn&&n<=kn}var ia=ms?hn(ms):Oc;function ur(n){return typeof n=="string"||!O(n)&&K(n)&&en(n)==Xt}function pn(n){return typeof n=="symbol"||K(n)&&en(n)==we}var Mt=ws?hn(ws):Rc;function bp(n){return n===i}function Tp(n){return K(n)&&tn(n)==Qt}function Lp(n){return K(n)&&en(n)==Ya}var Dp=Qe(jr),Np=Qe(function(n,t){return n<=t});function sa(n){if(!n)return [];if(an(n))return ur(n)?On(n):un(n);if(jt&&n[jt])return lf(n[jt]());var t=tn(n),e=t==yn?Mr:t==Sn?Ee:qt;return e(n)}function Qn(n){if(!n)return n===0?n:0;if(n=xn(n),n===ct||n===-ct){var t=n<0?-1:1;return t*Ua}return n===n?n:0}function R(n){var t=Qn(n),e=t%1;return t===t?e?t-e:t:0}function ua(n){return n?gt(R(n),0,Hn):0}function xn(n){if(typeof n=="number")return n;if(pn(n))return ge;if(z(n)){var t=typeof n.valueOf=="function"?n.valueOf():n;n=z(t)?t+"":t;}if(typeof n!="string")return n===0?n:+n;n=Es(n);var e=po.test(n);return e||vo.test(n)?Jo(n.slice(2),e?2:8):lo.test(n)?ge:+n}function aa(n){return Un(n,on(n))}function Hp(n){return n?gt(R(n),-kn,kn):n===0?n:0}function U(n){return n==null?"":ln(n)}var $p=Ut(function(n,t){if(ce(t)||an(t)){Un(t,V(t),n);return}for(var e in t)W.call(t,e)&&ie(n,e,t[e]);}),oa=Ut(function(n,t){Un(t,on(t),n);}),ar=Ut(function(n,t,e,r){Un(t,on(t),n,r);}),Up=Ut(function(n,t,e,r){Un(t,V(t),n,r);}),Wp=Zn(Yr);function Fp(n,t){var e=$t(n);return t==null?e:Ms(e,t)}var Mp=T(function(n,t){n=M(n);var e=-1,r=t.length,s=r>2?t[2]:i;for(s&&rn(t[0],t[1],s)&&(r=1);++e<r;)for(var o=t[e],f=on(o),c=-1,l=f.length;++c<l;){var v=f[c],_=n[v];(_===i||bn(_,Dt[v])&&!W.call(n,v))&&(n[v]=o[v]);}return n}),qp=T(function(n){return n.push(i,Eu),cn(fa,i,n)});function Bp(n,t){return As(n,x(t,3),$n)}function Gp(n,t){return As(n,x(t,3),Jr)}function zp(n,t){return n==null?n:Zr(n,x(t,3),on)}function Kp(n,t){return n==null?n:Ks(n,x(t,3),on)}function Yp(n,t){return n&&$n(n,x(t,3))}function Zp(n,t){return n&&Jr(n,x(t,3))}function Jp(n){return n==null?[]:Be(n,V(n))}function Xp(n){return n==null?[]:Be(n,on(n))}function yi(n,t,e){var r=n==null?i:vt(n,t);return r===i?e:r}function Qp(n,t){return n!=null&&Ou(n,t,wc)}function Si(n,t){return n!=null&&Ou(n,t,Pc)}var Vp=Pu(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Re.call(t)),n[t]=e;},Ri(fn)),kp=Pu(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Re.call(t)),W.call(n,t)?n[t].push(e):n[t]=[e];},x),jp=T(ue);function V(n){return an(n)?Ws(n):kr(n)}function on(n){return an(n)?Ws(n,!0):bc(n)}function nd(n,t){var e={};return t=x(t,3),$n(n,function(r,s,o){Kn(e,t(r,s,o),r);}),e}function td(n,t){var e={};return t=x(t,3),$n(n,function(r,s,o){Kn(e,s,t(r,s,o));}),e}var ed=Ut(function(n,t,e){Ge(n,t,e);}),fa=Ut(function(n,t,e,r){Ge(n,t,e,r);}),rd=Zn(function(n,t){var e={};if(n==null)return e;var r=!1;t=G(t,function(o){return o=st(o,n),r||(r=o.length>1),o}),Un(n,li(n),e),r&&(e=An(e,Ln|Mn|Ct,Vc));for(var s=t.length;s--;)ii(e,t[s]);return e});function id(n,t){return ca(n,ir(x(t)))}var sd=Zn(function(n,t){return n==null?{}:Lc(n,t)});function ca(n,t){if(n==null)return {};var e=G(li(n),function(r){return [r]});return t=x(t),tu(n,e,function(r,s){return t(r,s[0])})}function ud(n,t,e){t=st(t,n);var r=-1,s=t.length;for(s||(s=1,n=i);++r<s;){var o=n==null?i:n[Wn(t[r])];o===i&&(r=s,o=e),n=Xn(o)?o.call(n):o;}return n}function ad(n,t,e){return n==null?n:oe(n,t,e)}function od(n,t,e,r){return r=typeof r=="function"?r:i,n==null?n:oe(n,t,e,r)}var ha=Iu(V),la=Iu(on);function fd(n,t,e){var r=O(n),s=r||at(n)||Mt(n);if(t=x(t,4),e==null){var o=n&&n.constructor;s?e=r?new o:[]:z(n)?e=Xn(o)?$t(Le(n)):{}:e={};}return (s?mn:$n)(n,function(f,c,l){return t(e,f,c,l)}),e}function cd(n,t){return n==null?!0:ii(n,t)}function hd(n,t,e){return n==null?n:uu(n,t,ai(e))}function ld(n,t,e,r){return r=typeof r=="function"?r:i,n==null?n:uu(n,t,ai(e),r)}function qt(n){return n==null?[]:Fr(n,V(n))}function pd(n){return n==null?[]:Fr(n,on(n))}function dd(n,t,e){return e===i&&(e=t,t=i),e!==i&&(e=xn(e),e=e===e?e:0),t!==i&&(t=xn(t),t=t===t?t:0),gt(xn(n),t,e)}function gd(n,t,e){return t=Qn(t),e===i?(e=t,t=0):e=Qn(e),n=xn(n),Ac(n,t,e)}function vd(n,t,e){if(e&&typeof e!="boolean"&&rn(n,t,e)&&(t=e=i),e===i&&(typeof t=="boolean"?(e=t,t=i):typeof n=="boolean"&&(e=n,n=i)),n===i&&t===i?(n=0,t=1):(n=Qn(n),t===i?(t=n,n=0):t=Qn(t)),n>t){var r=n;n=t,t=r;}if(e||n%1||t%1){var s=$s();return nn(n+s*(t-n+Zo("1e-"+((s+"").length-1))),t)}return ti(n,t)}var _d=Wt(function(n,t,e){return t=t.toLowerCase(),n+(e?pa(t):t)});function pa(n){return Oi(U(n).toLowerCase())}function da(n){return n=U(n),n&&n.replace(mo,af).replace(Uo,"")}function md(n,t,e){n=U(n),t=ln(t);var r=n.length;e=e===i?r:gt(R(e),0,r);var s=e;return e-=t.length,e>=0&&n.slice(e,s)==t}function wd(n){return n=U(n),n&&Va.test(n)?n.replace(Ki,of):n}function Pd(n){return n=U(n),n&&ro.test(n)?n.replace(Ir,"\\$&"):n}var Ad=Wt(function(n,t,e){return n+(e?"-":"")+t.toLowerCase()}),Cd=Wt(function(n,t,e){return n+(e?" ":"")+t.toLowerCase()}),Id=_u("toLowerCase");function xd(n,t,e){n=U(n),t=R(t);var r=t?Tt(n):0;if(!t||r>=t)return n;var s=(t-r)/2;return Xe($e(s),e)+n+Xe(He(s),e)}function Ed(n,t,e){n=U(n),t=R(t);var r=t?Tt(n):0;return t&&r<t?n+Xe(t-r,e):n}function yd(n,t,e){n=U(n),t=R(t);var r=t?Tt(n):0;return t&&r<t?Xe(t-r,e)+n:n}function Sd(n,t,e){return e||t==null?t=0:t&&(t=+t),Nf(U(n).replace(xr,""),t||0)}function Od(n,t,e){return (e?rn(n,t,e):t===i)?t=1:t=R(t),ei(U(n),t)}function Rd(){var n=arguments,t=U(n[0]);return n.length<3?t:t.replace(n[1],n[2])}var bd=Wt(function(n,t,e){return n+(e?"_":"")+t.toLowerCase()});function Td(n,t,e){return e&&typeof e!="number"&&rn(n,t,e)&&(t=e=i),e=e===i?Hn:e>>>0,e?(n=U(n),n&&(typeof t=="string"||t!=null&&!Ei(t))&&(t=ln(t),!t&&bt(n))?ut(On(n),0,e):n.split(t,e)):[]}var Ld=Wt(function(n,t,e){return n+(e?" ":"")+Oi(t)});function Dd(n,t,e){return n=U(n),e=e==null?0:gt(R(e),0,n.length),t=ln(t),n.slice(e,e+t.length)==t}function Nd(n,t,e){var r=a.templateSettings;e&&rn(n,t,e)&&(t=i),n=U(n),t=ar({},t,r,xu);var s=ar({},t.imports,r.imports,xu),o=V(s),f=Fr(s,o),c,l,v=0,_=t.interpolate||Pe,m="__p += '",w=qr((t.escape||Pe).source+"|"+_.source+"|"+(_===Yi?ho:Pe).source+"|"+(t.evaluate||Pe).source+"|$","g"),A="//# sourceURL="+(W.call(t,"sourceURL")?(t.sourceURL+"").replace(/\s/g," "):"lodash.templateSources["+ ++Bo+"]")+`
`;n.replace(w,function(y,L,H,dn,sn,gn){return H||(H=dn),m+=n.slice(v,gn).replace(wo,ff),L&&(c=!0,m+=`' +
__e(`+L+`) +
'`),sn&&(l=!0,m+=`';
`+sn+`;
__p += '`),H&&(m+=`' +
((__t = (`+H+`)) == null ? '' : __t) +
'`),v=gn+y.length,y}),m+=`';
`;var E=W.call(t,"variable")&&t.variable;if(!E)m=`with (obj) {
`+m+`
}
`;else if(fo.test(E))throw new S(Fn);m=(l?m.replace(Za,""):m).replace(Ja,"$1").replace(Xa,"$1;"),m="function("+(E||"obj")+`) {
`+(E?"":`obj || (obj = {});
`)+"var __t, __p = ''"+(c?", __e = _.escape":"")+(l?`, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
`:`;
`)+m+`return __p
}`;var b=va(function(){return $(o,A+"return "+m).apply(i,f)});if(b.source=m,xi(b))throw b;return b}function Hd(n){return U(n).toLowerCase()}function $d(n){return U(n).toUpperCase()}function Ud(n,t,e){if(n=U(n),n&&(e||t===i))return Es(n);if(!n||!(t=ln(t)))return n;var r=On(n),s=On(t),o=ys(r,s),f=Ss(r,s)+1;return ut(r,o,f).join("")}function Wd(n,t,e){if(n=U(n),n&&(e||t===i))return n.slice(0,Rs(n)+1);if(!n||!(t=ln(t)))return n;var r=On(n),s=Ss(r,On(t))+1;return ut(r,0,s).join("")}function Fd(n,t,e){if(n=U(n),n&&(e||t===i))return n.replace(xr,"");if(!n||!(t=ln(t)))return n;var r=On(n),s=ys(r,On(t));return ut(r,s).join("")}function Md(n,t){var e=Ta,r=La;if(z(t)){var s="separator"in t?t.separator:s;e="length"in t?R(t.length):e,r="omission"in t?ln(t.omission):r;}n=U(n);var o=n.length;if(bt(n)){var f=On(n);o=f.length;}if(e>=o)return n;var c=e-Tt(r);if(c<1)return r;var l=f?ut(f,0,c).join(""):n.slice(0,c);if(s===i)return l+r;if(f&&(c+=l.length-c),Ei(s)){if(n.slice(c).search(s)){var v,_=l;for(s.global||(s=qr(s.source,U(Zi.exec(s))+"g")),s.lastIndex=0;v=s.exec(_);)var m=v.index;l=l.slice(0,m===i?c:m);}}else if(n.indexOf(ln(s),c)!=c){var w=l.lastIndexOf(s);w>-1&&(l=l.slice(0,w));}return l+r}function qd(n){return n=U(n),n&&Qa.test(n)?n.replace(zi,vf):n}var Bd=Wt(function(n,t,e){return n+(e?" ":"")+t.toUpperCase()}),Oi=_u("toUpperCase");function ga(n,t,e){return n=U(n),t=e?i:t,t===i?hf(n)?wf(n):tf(n):n.match(t)||[]}var va=T(function(n,t){try{return cn(n,i,t)}catch(e){return xi(e)?e:new S(e)}}),Gd=Zn(function(n,t){return mn(t,function(e){e=Wn(e),Kn(n,e,Ci(n[e],n));}),n});function zd(n){var t=n==null?0:n.length,e=x();return n=t?G(n,function(r){if(typeof r[1]!="function")throw new wn(F);return [e(r[0]),r[1]]}):[],T(function(r){for(var s=-1;++s<t;){var o=n[s];if(cn(o[0],this,r))return cn(o[1],this,r)}})}function Kd(n){return vc(An(n,Ln))}function Ri(n){return function(){return n}}function Yd(n,t){return n==null||n!==n?t:n}var Zd=wu(),Jd=wu(!0);function fn(n){return n}function bi(n){return Xs(typeof n=="function"?n:An(n,Ln))}function Xd(n){return Vs(An(n,Ln))}function Qd(n,t){return ks(n,An(t,Ln))}var Vd=T(function(n,t){return function(e){return ue(e,n,t)}}),kd=T(function(n,t){return function(e){return ue(n,e,t)}});function Ti(n,t,e){var r=V(t),s=Be(t,r);e==null&&!(z(t)&&(s.length||!r.length))&&(e=t,t=n,n=this,s=Be(t,V(t)));var o=!(z(e)&&"chain"in e)||!!e.chain,f=Xn(n);return mn(s,function(c){var l=t[c];n[c]=l,f&&(n.prototype[c]=function(){var v=this.__chain__;if(o||v){var _=n(this.__wrapped__),m=_.__actions__=un(this.__actions__);return m.push({func:l,args:arguments,thisArg:n}),_.__chain__=v,_}return l.apply(n,nt([this.value()],arguments))});}),n}function jd(){return k._===this&&(k._=Ef),this}function Li(){}function ng(n){return n=R(n),T(function(t){return js(t,n)})}var tg=fi(G),eg=fi(Ps),rg=fi(Nr);function _a(n){return vi(n)?Hr(Wn(n)):Dc(n)}function ig(n){return function(t){return n==null?i:vt(n,t)}}var sg=Au(),ug=Au(!0);function Di(){return []}function Ni(){return !1}function ag(){return {}}function og(){return ""}function fg(){return !0}function cg(n,t){if(n=R(n),n<1||n>kn)return [];var e=Hn,r=nn(n,Hn);t=x(t),n-=Hn;for(var s=Wr(r,t);++e<n;)t(e);return s}function hg(n){return O(n)?G(n,Wn):pn(n)?[n]:un(Uu(U(n)))}function lg(n){var t=++If;return U(n)+t}var pg=Je(function(n,t){return n+t},0),dg=ci("ceil"),gg=Je(function(n,t){return n/t},1),vg=ci("floor");function _g(n){return n&&n.length?qe(n,fn,Xr):i}function mg(n,t){return n&&n.length?qe(n,x(t,2),Xr):i}function wg(n){return Is(n,fn)}function Pg(n,t){return Is(n,x(t,2))}function Ag(n){return n&&n.length?qe(n,fn,jr):i}function Cg(n,t){return n&&n.length?qe(n,x(t,2),jr):i}var Ig=Je(function(n,t){return n*t},1),xg=ci("round"),Eg=Je(function(n,t){return n-t},0);function yg(n){return n&&n.length?Ur(n,fn):0}function Sg(n,t){return n&&n.length?Ur(n,x(t,2)):0}return a.after=Xl,a.ary=Ju,a.assign=$p,a.assignIn=oa,a.assignInWith=ar,a.assignWith=Up,a.at=Wp,a.before=Xu,a.bind=Ci,a.bindAll=Gd,a.bindKey=Qu,a.castArray=ap,a.chain=Ku,a.chunk=vh,a.compact=_h,a.concat=mh,a.cond=zd,a.conforms=Kd,a.constant=Ri,a.countBy=yl,a.create=Fp,a.curry=Vu,a.curryRight=ku,a.debounce=ju,a.defaults=Mp,a.defaultsDeep=qp,a.defer=Ql,a.delay=Vl,a.difference=wh,a.differenceBy=Ph,a.differenceWith=Ah,a.drop=Ch,a.dropRight=Ih,a.dropRightWhile=xh,a.dropWhile=Eh,a.fill=yh,a.filter=Ol,a.flatMap=Tl,a.flatMapDeep=Ll,a.flatMapDepth=Dl,a.flatten=qu,a.flattenDeep=Sh,a.flattenDepth=Oh,a.flip=kl,a.flow=Zd,a.flowRight=Jd,a.fromPairs=Rh,a.functions=Jp,a.functionsIn=Xp,a.groupBy=Nl,a.initial=Th,a.intersection=Lh,a.intersectionBy=Dh,a.intersectionWith=Nh,a.invert=Vp,a.invertBy=kp,a.invokeMap=$l,a.iteratee=bi,a.keyBy=Ul,a.keys=V,a.keysIn=on,a.map=tr,a.mapKeys=nd,a.mapValues=td,a.matches=Xd,a.matchesProperty=Qd,a.memoize=rr,a.merge=ed,a.mergeWith=fa,a.method=Vd,a.methodOf=kd,a.mixin=Ti,a.negate=ir,a.nthArg=ng,a.omit=rd,a.omitBy=id,a.once=jl,a.orderBy=Wl,a.over=tg,a.overArgs=np,a.overEvery=eg,a.overSome=rg,a.partial=Ii,a.partialRight=na,a.partition=Fl,a.pick=sd,a.pickBy=ca,a.property=_a,a.propertyOf=ig,a.pull=Wh,a.pullAll=Gu,a.pullAllBy=Fh,a.pullAllWith=Mh,a.pullAt=qh,a.range=sg,a.rangeRight=ug,a.rearg=tp,a.reject=Bl,a.remove=Bh,a.rest=ep,a.reverse=Pi,a.sampleSize=zl,a.set=ad,a.setWith=od,a.shuffle=Kl,a.slice=Gh,a.sortBy=Jl,a.sortedUniq=Qh,a.sortedUniqBy=Vh,a.split=Td,a.spread=rp,a.tail=kh,a.take=jh,a.takeRight=nl,a.takeRightWhile=tl,a.takeWhile=el,a.tap=_l,a.throttle=ip,a.thru=nr,a.toArray=sa,a.toPairs=ha,a.toPairsIn=la,a.toPath=hg,a.toPlainObject=aa,a.transform=fd,a.unary=sp,a.union=rl,a.unionBy=il,a.unionWith=sl,a.uniq=ul,a.uniqBy=al,a.uniqWith=ol,a.unset=cd,a.unzip=Ai,a.unzipWith=zu,a.update=hd,a.updateWith=ld,a.values=qt,a.valuesIn=pd,a.without=fl,a.words=ga,a.wrap=up,a.xor=cl,a.xorBy=hl,a.xorWith=ll,a.zip=pl,a.zipObject=dl,a.zipObjectDeep=gl,a.zipWith=vl,a.entries=ha,a.entriesIn=la,a.extend=oa,a.extendWith=ar,Ti(a,a),a.add=pg,a.attempt=va,a.camelCase=_d,a.capitalize=pa,a.ceil=dg,a.clamp=dd,a.clone=op,a.cloneDeep=cp,a.cloneDeepWith=hp,a.cloneWith=fp,a.conformsTo=lp,a.deburr=da,a.defaultTo=Yd,a.divide=gg,a.endsWith=md,a.eq=bn,a.escape=wd,a.escapeRegExp=Pd,a.every=Sl,a.find=Rl,a.findIndex=Fu,a.findKey=Bp,a.findLast=bl,a.findLastIndex=Mu,a.findLastKey=Gp,a.floor=vg,a.forEach=Yu,a.forEachRight=Zu,a.forIn=zp,a.forInRight=Kp,a.forOwn=Yp,a.forOwnRight=Zp,a.get=yi,a.gt=pp,a.gte=dp,a.has=Qp,a.hasIn=Si,a.head=Bu,a.identity=fn,a.includes=Hl,a.indexOf=bh,a.inRange=gd,a.invoke=jp,a.isArguments=wt,a.isArray=O,a.isArrayBuffer=gp,a.isArrayLike=an,a.isArrayLikeObject=Y,a.isBoolean=vp,a.isBuffer=at,a.isDate=_p,a.isElement=mp,a.isEmpty=wp,a.isEqual=Pp,a.isEqualWith=Ap,a.isError=xi,a.isFinite=Cp,a.isFunction=Xn,a.isInteger=ta,a.isLength=sr,a.isMap=ea,a.isMatch=Ip,a.isMatchWith=xp,a.isNaN=Ep,a.isNative=yp,a.isNil=Op,a.isNull=Sp,a.isNumber=ra,a.isObject=z,a.isObjectLike=K,a.isPlainObject=le,a.isRegExp=Ei,a.isSafeInteger=Rp,a.isSet=ia,a.isString=ur,a.isSymbol=pn,a.isTypedArray=Mt,a.isUndefined=bp,a.isWeakMap=Tp,a.isWeakSet=Lp,a.join=Hh,a.kebabCase=Ad,a.last=In,a.lastIndexOf=$h,a.lowerCase=Cd,a.lowerFirst=Id,a.lt=Dp,a.lte=Np,a.max=_g,a.maxBy=mg,a.mean=wg,a.meanBy=Pg,a.min=Ag,a.minBy=Cg,a.stubArray=Di,a.stubFalse=Ni,a.stubObject=ag,a.stubString=og,a.stubTrue=fg,a.multiply=Ig,a.nth=Uh,a.noConflict=jd,a.noop=Li,a.now=er,a.pad=xd,a.padEnd=Ed,a.padStart=yd,a.parseInt=Sd,a.random=vd,a.reduce=Ml,a.reduceRight=ql,a.repeat=Od,a.replace=Rd,a.result=ud,a.round=xg,a.runInContext=h,a.sample=Gl,a.size=Yl,a.snakeCase=bd,a.some=Zl,a.sortedIndex=zh,a.sortedIndexBy=Kh,a.sortedIndexOf=Yh,a.sortedLastIndex=Zh,a.sortedLastIndexBy=Jh,a.sortedLastIndexOf=Xh,a.startCase=Ld,a.startsWith=Dd,a.subtract=Eg,a.sum=yg,a.sumBy=Sg,a.template=Nd,a.times=cg,a.toFinite=Qn,a.toInteger=R,a.toLength=ua,a.toLower=Hd,a.toNumber=xn,a.toSafeInteger=Hp,a.toString=U,a.toUpper=$d,a.trim=Ud,a.trimEnd=Wd,a.trimStart=Fd,a.truncate=Md,a.unescape=qd,a.uniqueId=lg,a.upperCase=Bd,a.upperFirst=Oi,a.each=Yu,a.eachRight=Zu,a.first=Bu,Ti(a,function(){var n={};return $n(a,function(t,e){W.call(a.prototype,e)||(n[e]=t);}),n}(),{chain:!1}),a.VERSION=p,mn(["bind","bindKey","curry","curryRight","partial","partialRight"],function(n){a[n].placeholder=a;}),mn(["drop","take"],function(n,t){N.prototype[n]=function(e){e=e===i?1:Q(R(e),0);var r=this.__filtered__&&!t?new N(this):this.clone();return r.__filtered__?r.__takeCount__=nn(e,r.__takeCount__):r.__views__.push({size:nn(e,Hn),type:n+(r.__dir__<0?"Right":"")}),r},N.prototype[n+"Right"]=function(e){return this.reverse()[n](e).reverse()};}),mn(["filter","map","takeWhile"],function(n,t){var e=t+1,r=e==qi||e==$a;N.prototype[n]=function(s){var o=this.clone();return o.__iteratees__.push({iteratee:x(s,3),type:e}),o.__filtered__=o.__filtered__||r,o};}),mn(["head","last"],function(n,t){var e="take"+(t?"Right":"");N.prototype[n]=function(){return this[e](1).value()[0]};}),mn(["initial","tail"],function(n,t){var e="drop"+(t?"":"Right");N.prototype[n]=function(){return this.__filtered__?new N(this):this[e](1)};}),N.prototype.compact=function(){return this.filter(fn)},N.prototype.find=function(n){return this.filter(n).head()},N.prototype.findLast=function(n){return this.reverse().find(n)},N.prototype.invokeMap=T(function(n,t){return typeof n=="function"?new N(this):this.map(function(e){return ue(e,n,t)})}),N.prototype.reject=function(n){return this.filter(ir(x(n)))},N.prototype.slice=function(n,t){n=R(n);var e=this;return e.__filtered__&&(n>0||t<0)?new N(e):(n<0?e=e.takeRight(-n):n&&(e=e.drop(n)),t!==i&&(t=R(t),e=t<0?e.dropRight(-t):e.take(t-n)),e)},N.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},N.prototype.toArray=function(){return this.take(Hn)},$n(N.prototype,function(n,t){var e=/^(?:filter|find|map|reject)|While$/.test(t),r=/^(?:head|last)$/.test(t),s=a[r?"take"+(t=="last"?"Right":""):t],o=r||/^find/.test(t);s&&(a.prototype[t]=function(){var f=this.__wrapped__,c=r?[1]:arguments,l=f instanceof N,v=c[0],_=l||O(f),m=function(L){var H=s.apply(a,nt([L],c));return r&&w?H[0]:H};_&&e&&typeof v=="function"&&v.length!=1&&(l=_=!1);var w=this.__chain__,A=!!this.__actions__.length,E=o&&!w,b=l&&!A;if(!o&&_){f=b?f:new N(this);var y=n.apply(f,c);return y.__actions__.push({func:nr,args:[m],thisArg:i}),new Pn(y,w)}return E&&b?n.apply(this,c):(y=this.thru(m),E?r?y.value()[0]:y.value():y)});}),mn(["pop","push","shift","sort","splice","unshift"],function(n){var t=ye[n],e=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",r=/^(?:pop|shift)$/.test(n);a.prototype[n]=function(){var s=arguments;if(r&&!this.__chain__){var o=this.value();return t.apply(O(o)?o:[],s)}return this[e](function(f){return t.apply(O(f)?f:[],s)})};}),$n(N.prototype,function(n,t){var e=a[t];if(e){var r=e.name+"";W.call(Ht,r)||(Ht[r]=[]),Ht[r].push({name:t,func:e});}}),Ht[Ze(i,ft).name]=[{name:"wrapper",func:i}],N.prototype.clone=qf,N.prototype.reverse=Bf,N.prototype.value=Gf,a.prototype.at=ml,a.prototype.chain=wl,a.prototype.commit=Pl,a.prototype.next=Al,a.prototype.plant=Il,a.prototype.reverse=xl,a.prototype.toJSON=a.prototype.valueOf=a.prototype.value=El,a.prototype.first=a.prototype.head,jt&&(a.prototype[jt]=Cl),a},Lt=Pf();ht?((ht.exports=Lt)._=Lt,br._=Lt):k._=Lt;}).call(pe);})($i,$i.exports);var Fg=Object.defineProperty,Mg=Object.defineProperties,qg=Object.getOwnPropertyDescriptors,xa=Object.getOwnPropertySymbols,Bg=Object.prototype.hasOwnProperty,Gg=Object.prototype.propertyIsEnumerable,Ea=(C,u,i)=>u in C?Fg(C,u,{enumerable:!0,configurable:!0,writable:!0,value:i}):C[u]=i,fr=(C,u)=>{for(var i in u||(u={}))Bg.call(u,i)&&Ea(C,i,u[i]);if(xa)for(var i of xa(u))Gg.call(u,i)&&Ea(C,i,u[i]);return C},zg=(C,u)=>Mg(C,qg(u));function En(C,u,i){let p;const I=Ui(C);return u.rpcMap&&(p=u.rpcMap[I]),p||(p=`${Wg}?chainId=eip155:${I}&projectId=${i}`),p}function Ui(C){return C.includes("eip155")?Number(C.split(":")[1]):Number(C)}function ya(C){return C.map(u=>`${u.split(":")[0]}:${u.split(":")[1]}`)}function Kg(C,u){const i=Object.keys(u.namespaces).filter(I=>I.includes(C));if(!i.length)return [];const p=[];return i.forEach(I=>{const D=u.namespaces[I].accounts;p.push(...D);}),p}function Yg(C={},u={}){const i=Sa(C),p=Sa(u);return $i.exports.merge(i,p)}function Sa(C){var u,i,p,I;const D={};if(!H$6(C))return D;for(const[F,Fn]of Object.entries(C)){const Gt=te$3(F)?[F]:Fn.chains,lr=Fn.methods||[],At=Fn.events||[],Ln=Fn.rpcMap||{},Mn=Ze$2(F);D[Mn]=zg(fr(fr({},D[Mn]),Fn),{chains:S$6(Gt,(u=D[Mn])==null?void 0:u.chains),methods:S$6(lr,(i=D[Mn])==null?void 0:i.methods),events:S$6(At,(p=D[Mn])==null?void 0:p.events),rpcMap:fr(fr({},Ln),(I=D[Mn])==null?void 0:I.rpcMap)});}return D}function Zg(C){return C.includes(":")?C.split(":")[2]:C}function Jg(C){const u={};for(const[i,p]of Object.entries(C)){const I=p.methods||[],D=p.events||[],F=p.accounts||[],Fn=te$3(i)?[i]:p.chains?p.chains:ya(p.accounts);u[i]={chains:Fn,methods:I,events:D,accounts:F};}return u}const Oa={},J$1=C=>Oa[C],Wi=(C,u)=>{Oa[C]=u;};class Xg{constructor(u){this.name="polkadot",this.namespace=u.namespace,this.events=J$1("events"),this.client=J$1("client"),this.chainId=this.getDefaultChain(),this.httpProviders=this.createHttpProviders();}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}requestAccounts(){return this.getAccounts()}getDefaultChain(){if(this.chainId)return this.chainId;if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}request(u){return this.namespace.methods.includes(u.request.method)?this.client.request(u):this.getHttpProvider().request(u.request)}setDefaultChain(u,i){if(this.chainId=u,!this.httpProviders[u]){const p=i||En(`${this.name}:${u}`,this.namespace);if(!p)throw new Error(`No RPC url provided for chainId: ${u}`);this.setHttpProvider(u,p);}this.events.emit(ot$1.DEFAULT_CHAIN_CHANGED,`${this.name}:${this.chainId}`);}getAccounts(){const u=this.namespace.accounts;return u?u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2])||[]:[]}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{var p;u[i]=this.createHttpProvider(i,(p=this.namespace.rpcMap)==null?void 0:p[i]);}),u}getHttpProvider(){const u=`${this.name}:${this.chainId}`,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}setHttpProvider(u,i){const p=this.createHttpProvider(u,i);p&&(this.httpProviders[u]=p);}createHttpProvider(u,i){const p=i||En(u,this.namespace);return typeof p>"u"?void 0:new JsonRpcProvider(new HttpConnection(p,J$1("disableProviderPing")))}}class Qg{constructor(u){this.name="eip155",this.namespace=u.namespace,this.events=J$1("events"),this.client=J$1("client"),this.httpProviders=this.createHttpProviders(),this.chainId=parseInt(this.getDefaultChain());}async request(u){switch(u.request.method){case"eth_requestAccounts":return this.getAccounts();case"eth_accounts":return this.getAccounts();case"wallet_switchEthereumChain":return await this.handleSwitchChain(u);case"eth_chainId":return parseInt(this.getDefaultChain())}return this.namespace.methods.includes(u.request.method)?await this.client.request(u):this.getHttpProvider().request(u.request)}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}setDefaultChain(u,i){const p=Ui(u);if(!this.httpProviders[p]){const I=i||En(`${this.name}:${p}`,this.namespace,this.client.core.projectId);if(!I)throw new Error(`No RPC url provided for chainId: ${p}`);this.setHttpProvider(p,I);}this.chainId=p,this.events.emit(ot$1.DEFAULT_CHAIN_CHANGED,`${this.name}:${p}`);}requestAccounts(){return this.getAccounts()}getDefaultChain(){if(this.chainId)return this.chainId.toString();if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}createHttpProvider(u,i){const p=i||En(`${this.name}:${u}`,this.namespace,this.client.core.projectId);return typeof p>"u"?void 0:new JsonRpcProvider(new HttpConnection(p,J$1("disableProviderPing")))}setHttpProvider(u,i){const p=this.createHttpProvider(u,i);p&&(this.httpProviders[u]=p);}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{var p;const I=Ui(i);u[I]=this.createHttpProvider(I,(p=this.namespace.rpcMap)==null?void 0:p[i]);}),u}getAccounts(){const u=this.namespace.accounts;return u?[...new Set(u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2]))]:[]}getHttpProvider(){const u=this.chainId,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}async handleSwitchChain(u){var i,p;let I=u.request.params?(i=u.request.params[0])==null?void 0:i.chainId:"0x0";I=I.startsWith("0x")?I:`0x${I}`;const D=parseInt(I,16);if(this.isChainApproved(D))this.setDefaultChain(`${D}`);else if(this.namespace.methods.includes("wallet_switchEthereumChain"))await this.client.request({topic:u.topic,request:{method:u.request.method,params:[{chainId:I}]},chainId:(p=this.namespace.chains)==null?void 0:p[0]}),this.setDefaultChain(`${D}`);else throw new Error(`Failed to switch to chain 'eip155:${D}'. The chain is not approved or the wallet does not support 'wallet_switchEthereumChain' method.`);return null}isChainApproved(u){return this.namespace.chains.includes(`${this.name}:${u}`)}}class Vg{constructor(u){this.name="solana",this.namespace=u.namespace,this.events=J$1("events"),this.client=J$1("client"),this.chainId=this.getDefaultChain(),this.httpProviders=this.createHttpProviders();}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}requestAccounts(){return this.getAccounts()}request(u){return this.namespace.methods.includes(u.request.method)?this.client.request(u):this.getHttpProvider().request(u.request)}setDefaultChain(u,i){if(!this.httpProviders[u]){const p=i||En(`${this.name}:${u}`,this.namespace,this.client.core.projectId);if(!p)throw new Error(`No RPC url provided for chainId: ${u}`);this.setHttpProvider(u,p);}this.chainId=u,this.events.emit(ot$1.DEFAULT_CHAIN_CHANGED,`${this.name}:${this.chainId}`);}getDefaultChain(){if(this.chainId)return this.chainId;if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}getAccounts(){const u=this.namespace.accounts;return u?[...new Set(u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2]))]:[]}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{var p;u[i]=this.createHttpProvider(i,(p=this.namespace.rpcMap)==null?void 0:p[i]);}),u}getHttpProvider(){const u=`${this.name}:${this.chainId}`,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}setHttpProvider(u,i){const p=this.createHttpProvider(u,i);p&&(this.httpProviders[u]=p);}createHttpProvider(u,i){const p=i||En(u,this.namespace,this.client.core.projectId);return typeof p>"u"?void 0:new JsonRpcProvider(new HttpConnection(p,J$1("disableProviderPing")))}}class kg{constructor(u){this.name="cosmos",this.namespace=u.namespace,this.events=J$1("events"),this.client=J$1("client"),this.chainId=this.getDefaultChain(),this.httpProviders=this.createHttpProviders();}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}requestAccounts(){return this.getAccounts()}getDefaultChain(){if(this.chainId)return this.chainId;if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}request(u){return this.namespace.methods.includes(u.request.method)?this.client.request(u):this.getHttpProvider().request(u.request)}setDefaultChain(u,i){if(this.chainId=u,!this.httpProviders[u]){const p=i||En(`${this.name}:${u}`,this.namespace,this.client.core.projectId);if(!p)throw new Error(`No RPC url provided for chainId: ${u}`);this.setHttpProvider(u,p);}this.events.emit(ot$1.DEFAULT_CHAIN_CHANGED,`${this.name}:${this.chainId}`);}getAccounts(){const u=this.namespace.accounts;return u?[...new Set(u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2]))]:[]}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{var p;u[i]=this.createHttpProvider(i,(p=this.namespace.rpcMap)==null?void 0:p[i]);}),u}getHttpProvider(){const u=`${this.name}:${this.chainId}`,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}setHttpProvider(u,i){const p=this.createHttpProvider(u,i);p&&(this.httpProviders[u]=p);}createHttpProvider(u,i){const p=i||En(u,this.namespace,this.client.core.projectId);return typeof p>"u"?void 0:new JsonRpcProvider(new HttpConnection(p,J$1("disableProviderPing")))}}class jg{constructor(u){this.name="cip34",this.namespace=u.namespace,this.events=J$1("events"),this.client=J$1("client"),this.chainId=this.getDefaultChain(),this.httpProviders=this.createHttpProviders();}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}requestAccounts(){return this.getAccounts()}getDefaultChain(){if(this.chainId)return this.chainId;if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}request(u){return this.namespace.methods.includes(u.request.method)?this.client.request(u):this.getHttpProvider().request(u.request)}setDefaultChain(u,i){if(this.chainId=u,!this.httpProviders[u]){const p=i||this.getCardanoRPCUrl(u);if(!p)throw new Error(`No RPC url provided for chainId: ${u}`);this.setHttpProvider(u,p);}this.events.emit(ot$1.DEFAULT_CHAIN_CHANGED,`${this.name}:${this.chainId}`);}getAccounts(){const u=this.namespace.accounts;return u?[...new Set(u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2]))]:[]}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{const p=this.getCardanoRPCUrl(i);u[i]=this.createHttpProvider(i,p);}),u}getHttpProvider(){const u=`${this.name}:${this.chainId}`,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}getCardanoRPCUrl(u){const i=this.namespace.rpcMap;if(i)return i[u]}setHttpProvider(u,i){const p=this.createHttpProvider(u,i);p&&(this.httpProviders[u]=p);}createHttpProvider(u,i){const p=i||this.getCardanoRPCUrl(u);return typeof p>"u"?void 0:new JsonRpcProvider(new HttpConnection(p,J$1("disableProviderPing")))}}class nv{constructor(u){this.name="elrond",this.namespace=u.namespace,this.events=J$1("events"),this.client=J$1("client"),this.chainId=this.getDefaultChain(),this.httpProviders=this.createHttpProviders();}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}requestAccounts(){return this.getAccounts()}request(u){return this.namespace.methods.includes(u.request.method)?this.client.request(u):this.getHttpProvider().request(u.request)}setDefaultChain(u,i){if(!this.httpProviders[u]){const p=i||En(`${this.name}:${u}`,this.namespace,this.client.core.projectId);if(!p)throw new Error(`No RPC url provided for chainId: ${u}`);this.setHttpProvider(u,p);}this.chainId=u,this.events.emit(ot$1.DEFAULT_CHAIN_CHANGED,`${this.name}:${this.chainId}`);}getDefaultChain(){if(this.chainId)return this.chainId;if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}getAccounts(){const u=this.namespace.accounts;return u?[...new Set(u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2]))]:[]}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{var p;u[i]=this.createHttpProvider(i,(p=this.namespace.rpcMap)==null?void 0:p[i]);}),u}getHttpProvider(){const u=`${this.name}:${this.chainId}`,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}setHttpProvider(u,i){const p=this.createHttpProvider(u,i);p&&(this.httpProviders[u]=p);}createHttpProvider(u,i){const p=i||En(u,this.namespace,this.client.core.projectId);return typeof p>"u"?void 0:new JsonRpcProvider(new HttpConnection(p,J$1("disableProviderPing")))}}class tv{constructor(u){this.name="multiversx",this.namespace=u.namespace,this.events=J$1("events"),this.client=J$1("client"),this.chainId=this.getDefaultChain(),this.httpProviders=this.createHttpProviders();}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}requestAccounts(){return this.getAccounts()}request(u){return this.namespace.methods.includes(u.request.method)?this.client.request(u):this.getHttpProvider().request(u.request)}setDefaultChain(u,i){if(!this.httpProviders[u]){const p=i||En(`${this.name}:${u}`,this.namespace,this.client.core.projectId);if(!p)throw new Error(`No RPC url provided for chainId: ${u}`);this.setHttpProvider(u,p);}this.chainId=u,this.events.emit(ot$1.DEFAULT_CHAIN_CHANGED,`${this.name}:${this.chainId}`);}getDefaultChain(){if(this.chainId)return this.chainId;if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}getAccounts(){const u=this.namespace.accounts;return u?[...new Set(u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2]))]:[]}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{var p;u[i]=this.createHttpProvider(i,(p=this.namespace.rpcMap)==null?void 0:p[i]);}),u}getHttpProvider(){const u=`${this.name}:${this.chainId}`,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}setHttpProvider(u,i){const p=this.createHttpProvider(u,i);p&&(this.httpProviders[u]=p);}createHttpProvider(u,i){const p=i||En(u,this.namespace,this.client.core.projectId);return typeof p>"u"?void 0:new JsonRpcProvider(new HttpConnection(p,J$1("disableProviderPing")))}}var ev=Object.defineProperty,rv=Object.defineProperties,iv=Object.getOwnPropertyDescriptors,Ra=Object.getOwnPropertySymbols,sv=Object.prototype.hasOwnProperty,uv=Object.prototype.propertyIsEnumerable,ba=(C,u,i)=>u in C?ev(C,u,{enumerable:!0,configurable:!0,writable:!0,value:i}):C[u]=i,cr$1=(C,u)=>{for(var i in u||(u={}))sv.call(u,i)&&ba(C,i,u[i]);if(Ra)for(var i of Ra(u))uv.call(u,i)&&ba(C,i,u[i]);return C},Fi=(C,u)=>rv(C,iv(u));let hr$1 = class hr{constructor(u){this.events=new Ng,this.rpcProviders={},this.shouldAbortPairingAttempt=!1,this.maxPairingAttempts=10,this.disableProviderPing=!1,this.providerOpts=u,this.logger=typeof u?.logger<"u"&&typeof u?.logger!="string"?u.logger:cjs$1.pino(cjs$1.getDefaultLoggerOptions({level:u?.logger||Ca})),this.disableProviderPing=u?.disableProviderPing||!1;}static async init(u){const i=new hr(u);return await i.initialize(),i}async request(u,i){const[p,I]=this.validateChain(i);if(!this.session)throw new Error("Please call connect() before request()");return await this.getProvider(p).request({request:cr$1({},u),chainId:`${p}:${I}`,topic:this.session.topic})}sendAsync(u,i,p){this.request(u,p).then(I=>i(null,I)).catch(I=>i(I,void 0));}async enable(){if(!this.client)throw new Error("Sign Client not initialized");return this.session||await this.connect({namespaces:this.namespaces,optionalNamespaces:this.optionalNamespaces,sessionProperties:this.sessionProperties}),await this.requestAccounts()}async disconnect(){var u;if(!this.session)throw new Error("Please call connect() before enable()");await this.client.disconnect({topic:(u=this.session)==null?void 0:u.topic,reason:w$5("USER_DISCONNECTED")}),await this.cleanup();}async connect(u){if(!this.client)throw new Error("Sign Client not initialized");if(this.setNamespaces(u),await this.cleanupPendingPairings(),!u.skipPairing)return await this.pair(u.pairingTopic)}on(u,i){this.events.on(u,i);}once(u,i){this.events.once(u,i);}removeListener(u,i){this.events.removeListener(u,i);}off(u,i){this.events.off(u,i);}get isWalletConnect(){return !0}async pair(u){this.shouldAbortPairingAttempt=!1;let i=0;do{if(this.shouldAbortPairingAttempt)throw new Error("Pairing aborted");if(i>=this.maxPairingAttempts)throw new Error("Max auto pairing attempts reached");const{uri:p,approval:I}=await this.client.connect({pairingTopic:u,requiredNamespaces:this.namespaces,optionalNamespaces:this.optionalNamespaces,sessionProperties:this.sessionProperties});p&&(this.uri=p,this.events.emit("display_uri",p)),await I().then(D=>{this.session=D,this.namespaces||(this.namespaces=Jg(D.namespaces),this.persist("namespaces",this.namespaces));}).catch(D=>{if(D.message!==te$1)throw D;i++;});}while(!this.session);return this.onConnect(),this.session}setDefaultChain(u,i){try{if(!this.session)return;const[p,I]=this.validateChain(u);this.getProvider(p).setDefaultChain(I,i);}catch(p){if(!/Please call connect/.test(p.message))throw p}}async cleanupPendingPairings(u={}){this.logger.info("Cleaning up inactive pairings...");const i=this.client.pairing.getAll();if(C$5(i)){for(const p of i)u.deletePairings?this.client.core.expirer.set(p.topic,0):await this.client.core.relayer.subscriber.unsubscribe(p.topic);this.logger.info(`Inactive pairings cleared: ${i.length}`);}}abortPairingAttempt(){this.shouldAbortPairingAttempt=!0;}async checkStorage(){if(this.namespaces=await this.getFromStore("namespaces"),this.optionalNamespaces=await this.getFromStore("optionalNamespaces")||{},this.client.session.length){const u=this.client.session.keys.length-1;this.session=this.client.session.get(this.client.session.keys[u]),this.createProviders();}}async initialize(){this.logger.trace("Initialized"),await this.createClient(),await this.checkStorage(),this.registerEventListeners();}async createClient(){this.client=this.providerOpts.client||await M$3.init({logger:this.providerOpts.logger||Ca,relayUrl:this.providerOpts.relayUrl||Hg,projectId:this.providerOpts.projectId,metadata:this.providerOpts.metadata,storageOptions:this.providerOpts.storageOptions,name:this.providerOpts.name}),this.logger.trace("SignClient Initialized");}createProviders(){if(!this.client)throw new Error("Sign Client not initialized");if(!this.session)throw new Error("Session not initialized. Please call connect() before enable()");const u=[...new Set(Object.keys(this.session.namespaces).map(i=>Ze$2(i)))];Wi("client",this.client),Wi("events",this.events),Wi("disableProviderPing",this.disableProviderPing),u.forEach(i=>{if(!this.session)return;const p=Kg(i,this.session),I=ya(p),D=Yg(this.namespaces,this.optionalNamespaces),F=Fi(cr$1({},D[i]),{accounts:p,chains:I});switch(i){case"eip155":this.rpcProviders[i]=new Qg({namespace:F});break;case"solana":this.rpcProviders[i]=new Vg({namespace:F});break;case"cosmos":this.rpcProviders[i]=new kg({namespace:F});break;case"polkadot":this.rpcProviders[i]=new Xg({namespace:F});break;case"cip34":this.rpcProviders[i]=new jg({namespace:F});break;case"elrond":this.rpcProviders[i]=new nv({namespace:F});break;case"multiversx":this.rpcProviders[i]=new tv({namespace:F});break}});}registerEventListeners(){if(typeof this.client>"u")throw new Error("Sign Client is not initialized");this.client.on("session_ping",u=>{this.events.emit("session_ping",u);}),this.client.on("session_event",u=>{const{params:i}=u,{event:p}=i;if(p.name==="accountsChanged"){const I=p.data;I&&C$5(I)&&this.events.emit("accountsChanged",I.map(Zg));}else p.name==="chainChanged"?this.onChainChanged(i.chainId):this.events.emit(p.name,p.data);this.events.emit("session_event",u);}),this.client.on("session_update",({topic:u,params:i})=>{var p;const{namespaces:I}=i,D=(p=this.client)==null?void 0:p.session.get(u);this.session=Fi(cr$1({},D),{namespaces:I}),this.onSessionUpdate(),this.events.emit("session_update",{topic:u,params:i});}),this.client.on("session_delete",async u=>{await this.cleanup(),this.events.emit("session_delete",u),this.events.emit("disconnect",Fi(cr$1({},w$5("USER_DISCONNECTED")),{data:u.topic}));}),this.on(ot$1.DEFAULT_CHAIN_CHANGED,u=>{this.onChainChanged(u,!0);});}getProvider(u){if(!this.rpcProviders[u])throw new Error(`Provider not found: ${u}`);return this.rpcProviders[u]}onSessionUpdate(){Object.keys(this.rpcProviders).forEach(u=>{var i;this.getProvider(u).updateNamespace((i=this.session)==null?void 0:i.namespaces[u]);});}setNamespaces(u){const{namespaces:i,optionalNamespaces:p,sessionProperties:I}=u;i&&Object.keys(i).length&&(this.namespaces=i),p&&Object.keys(p).length&&(this.optionalNamespaces=p),this.sessionProperties=I,this.persist("namespaces",i),this.persist("optionalNamespaces",p);}validateChain(u){const[i,p]=u?.split(":")||["",""];if(!this.namespaces||!Object.keys(this.namespaces).length)return [i,p];if(i&&!Object.keys(this.namespaces||{}).map(F=>Ze$2(F)).includes(i))throw new Error(`Namespace '${i}' is not configured. Please call connect() first with namespace config.`);if(i&&p)return [i,p];const I=Ze$2(Object.keys(this.namespaces)[0]),D=this.rpcProviders[I].getDefaultChain();return [I,D]}async requestAccounts(){const[u]=this.validateChain();return await this.getProvider(u).requestAccounts()}onChainChanged(u,i=!1){var p;if(!this.namespaces)return;const[I,D]=this.validateChain(u);i||this.getProvider(I).setDefaultChain(D),((p=this.namespaces[I])!=null?p:this.namespaces[`${I}:${D}`]).defaultChain=D,this.persist("namespaces",this.namespaces),this.events.emit("chainChanged",D);}onConnect(){this.createProviders(),this.events.emit("connect",{session:this.session});}async cleanup(){this.session=void 0,this.namespaces=void 0,this.optionalNamespaces=void 0,this.sessionProperties=void 0,this.persist("namespaces",void 0),this.persist("optionalNamespaces",void 0),this.persist("sessionProperties",void 0),await this.cleanupPendingPairings({deletePairings:!0});}persist(u,i){this.client.core.storage.setItem(`${Ia}/${u}`,i);}async getFromStore(u){return await this.client.core.storage.getItem(`${Ia}/${u}`)}};const av=hr$1;

	const P$2="wc",S$3="ethereum_provider",$$2=`${P$2}@2:${S$3}:`,j$2="https://rpc.walletconnect.com/v1/",u$2=["eth_sendTransaction","personal_sign"],E$1=["eth_accounts","eth_requestAccounts","eth_sendRawTransaction","eth_sign","eth_signTransaction","eth_signTypedData","eth_signTypedData_v3","eth_signTypedData_v4","wallet_switchEthereumChain","wallet_addEthereumChain","wallet_getPermissions","wallet_requestPermissions","wallet_registerOnboarding","wallet_watchAsset","wallet_scanQRCode"],m$2=["chainChanged","accountsChanged"],_$3=["message","disconnect","connect"];var N$2=Object.defineProperty,q$1=Object.defineProperties,D$3=Object.getOwnPropertyDescriptors,y$3=Object.getOwnPropertySymbols,U$2=Object.prototype.hasOwnProperty,Q$2=Object.prototype.propertyIsEnumerable,O$1=(a,t,s)=>t in a?N$2(a,t,{enumerable:!0,configurable:!0,writable:!0,value:s}):a[t]=s,p$1=(a,t)=>{for(var s in t||(t={}))U$2.call(t,s)&&O$1(a,s,t[s]);if(y$3)for(var s of y$3(t))Q$2.call(t,s)&&O$1(a,s,t[s]);return a},M$2=(a,t)=>q$1(a,D$3(t));function g$2(a){return Number(a[0].split(":")[1])}function f$1(a){return `0x${a.toString(16)}`}function L$3(a){const{chains:t,optionalChains:s,methods:i,optionalMethods:n,events:e,optionalEvents:h,rpcMap:c}=a;if(!C$5(t))throw new Error("Invalid chains");const o={chains:t,methods:i||u$2,events:e||m$2,rpcMap:p$1({},t.length?{[g$2(t)]:c[g$2(t)]}:{})},r=e?.filter(l=>!m$2.includes(l)),d=i?.filter(l=>!u$2.includes(l));if(!s&&!h&&!n&&!(r!=null&&r.length)&&!(d!=null&&d.length))return {required:t.length?o:void 0};const C=r?.length&&d?.length||!s,I={chains:[...new Set(C?o.chains.concat(s||[]):s)],methods:[...new Set(o.methods.concat(n!=null&&n.length?n:E$1))],events:[...new Set(o.events.concat(h||_$3))],rpcMap:c};return {required:t.length?o:void 0,optional:s.length?I:void 0}}let v$2 = class v{constructor(){this.events=new eventsExports.EventEmitter,this.namespace="eip155",this.accounts=[],this.chainId=1,this.STORAGE_KEY=$$2,this.on=(t,s)=>(this.events.on(t,s),this),this.once=(t,s)=>(this.events.once(t,s),this),this.removeListener=(t,s)=>(this.events.removeListener(t,s),this),this.off=(t,s)=>(this.events.off(t,s),this),this.parseAccount=t=>this.isCompatibleChainId(t)?this.parseAccountId(t).address:t,this.signer={},this.rpc={};}static async init(t){const s=new v;return await s.initialize(t),s}async request(t){return await this.signer.request(t,this.formatChainId(this.chainId))}sendAsync(t,s){this.signer.sendAsync(t,s,this.formatChainId(this.chainId));}get connected(){return this.signer.client?this.signer.client.core.relayer.connected:!1}get connecting(){return this.signer.client?this.signer.client.core.relayer.connecting:!1}async enable(){return this.session||await this.connect(),await this.request({method:"eth_requestAccounts"})}async connect(t){if(!this.signer.client)throw new Error("Provider not initialized. Call init() first");this.loadConnectOpts(t);const{required:s,optional:i}=L$3(this.rpc);try{const n=await new Promise(async(h,c)=>{var o;this.rpc.showQrModal&&((o=this.modal)==null||o.subscribeModal(r=>{!r.open&&!this.signer.session&&(this.signer.abortPairingAttempt(),c(new Error("Connection request reset. Please try again.")));})),await this.signer.connect(M$2(p$1({namespaces:p$1({},s&&{[this.namespace]:s})},i&&{optionalNamespaces:{[this.namespace]:i}}),{pairingTopic:t?.pairingTopic})).then(r=>{h(r);}).catch(r=>{c(new Error(r.message));});});if(!n)return;this.setChainIds(this.rpc.chains);const e=On$1(n.namespaces,[this.namespace]);this.setAccounts(e),this.events.emit("connect",{chainId:f$1(this.chainId)});}catch(n){throw this.signer.logger.error(n),n}finally{this.modal&&this.modal.closeModal();}}async disconnect(){this.session&&await this.signer.disconnect(),this.reset();}get isWalletConnect(){return !0}get session(){return this.signer.session}registerEventListeners(){this.signer.on("session_event",t=>{const{params:s}=t,{event:i}=s;i.name==="accountsChanged"?(this.accounts=this.parseAccounts(i.data),this.events.emit("accountsChanged",this.accounts)):i.name==="chainChanged"?this.setChainId(this.formatChainId(i.data)):this.events.emit(i.name,i.data),this.events.emit("session_event",t);}),this.signer.on("chainChanged",t=>{const s=parseInt(t);this.chainId=s,this.events.emit("chainChanged",f$1(this.chainId)),this.persist();}),this.signer.on("session_update",t=>{this.events.emit("session_update",t);}),this.signer.on("session_delete",t=>{this.reset(),this.events.emit("session_delete",t),this.events.emit("disconnect",M$2(p$1({},w$5("USER_DISCONNECTED")),{data:t.topic,name:"USER_DISCONNECTED"}));}),this.signer.on("display_uri",t=>{var s,i;this.rpc.showQrModal&&((s=this.modal)==null||s.closeModal(),(i=this.modal)==null||i.openModal({uri:t})),this.events.emit("display_uri",t);});}switchEthereumChain(t){this.request({method:"wallet_switchEthereumChain",params:[{chainId:t.toString(16)}]});}isCompatibleChainId(t){return typeof t=="string"?t.startsWith(`${this.namespace}:`):!1}formatChainId(t){return `${this.namespace}:${t}`}parseChainId(t){return Number(t.split(":")[1])}setChainIds(t){const s=t.filter(i=>this.isCompatibleChainId(i)).map(i=>this.parseChainId(i));s.length&&(this.chainId=s[0],this.events.emit("chainChanged",f$1(this.chainId)),this.persist());}setChainId(t){if(this.isCompatibleChainId(t)){const s=this.parseChainId(t);this.chainId=s,this.switchEthereumChain(s);}}parseAccountId(t){const[s,i,n]=t.split(":");return {chainId:`${s}:${i}`,address:n}}setAccounts(t){this.accounts=t.filter(s=>this.parseChainId(this.parseAccountId(s).chainId)===this.chainId).map(s=>this.parseAccountId(s).address),this.events.emit("accountsChanged",this.accounts);}getRpcConfig(t){var s,i;const n=(s=t?.chains)!=null?s:[],e=(i=t?.optionalChains)!=null?i:[],h=n.concat(e);if(!h.length)throw new Error("No chains specified in either `chains` or `optionalChains`");const c=n.length?t?.methods||u$2:[],o=n.length?t?.events||m$2:[],r=t?.optionalMethods||[],d=t?.optionalEvents||[],C=t?.rpcMap||this.buildRpcMap(h,t.projectId),I=t?.qrModalOptions||void 0;return {chains:n?.map(l=>this.formatChainId(l)),optionalChains:e.map(l=>this.formatChainId(l)),methods:c,events:o,optionalMethods:r,optionalEvents:d,rpcMap:C,showQrModal:!!(t!=null&&t.showQrModal),qrModalOptions:I,projectId:t.projectId,metadata:t.metadata}}buildRpcMap(t,s){const i={};return t.forEach(n=>{i[n]=this.getRpcUrl(n,s);}),i}async initialize(t){if(this.rpc=this.getRpcConfig(t),this.chainId=this.rpc.chains.length?g$2(this.rpc.chains):g$2(this.rpc.optionalChains),this.signer=await av.init({projectId:this.rpc.projectId,metadata:this.rpc.metadata,disableProviderPing:t.disableProviderPing,relayUrl:t.relayUrl,storageOptions:t.storageOptions}),this.registerEventListeners(),await this.loadPersistedSession(),this.rpc.showQrModal){let s;try{const{WalletConnectModal:i}=await Promise.resolve().then(function () { return index$1; });s=i;}catch{throw new Error("To use QR modal, please install @walletconnect/modal package")}if(s)try{this.modal=new s(p$1({walletConnectVersion:2,projectId:this.rpc.projectId,standaloneChains:this.rpc.chains},this.rpc.qrModalOptions));}catch(i){throw this.signer.logger.error(i),new Error("Could not generate WalletConnectModal Instance")}}}loadConnectOpts(t){if(!t)return;const{chains:s,optionalChains:i,rpcMap:n}=t;s&&C$5(s)&&(this.rpc.chains=s.map(e=>this.formatChainId(e)),s.forEach(e=>{this.rpc.rpcMap[e]=n?.[e]||this.getRpcUrl(e);})),i&&C$5(i)&&(this.rpc.optionalChains=[],this.rpc.optionalChains=i?.map(e=>this.formatChainId(e)),i.forEach(e=>{this.rpc.rpcMap[e]=n?.[e]||this.getRpcUrl(e);}));}getRpcUrl(t,s){var i;return ((i=this.rpc.rpcMap)==null?void 0:i[t])||`${j$2}?chainId=eip155:${t}&projectId=${s||this.rpc.projectId}`}async loadPersistedSession(){if(!this.session)return;const t=await this.signer.client.core.storage.getItem(`${this.STORAGE_KEY}/chainId`),s=this.session.namespaces[`${this.namespace}:${t}`]?this.session.namespaces[`${this.namespace}:${t}`]:this.session.namespaces[this.namespace];this.setChainIds(t?[this.formatChainId(t)]:s?.accounts),this.setAccounts(s?.accounts);}reset(){this.chainId=1,this.accounts=[];}persist(){this.session&&this.signer.client.core.storage.setItem(`${this.STORAGE_KEY}/chainId`,this.chainId);}parseAccounts(t){return typeof t=="string"||t instanceof String?[this.parseAccount(t)]:t.map(s=>this.parseAccount(s))}};const G$2=v$2;

	var index_es = /*#__PURE__*/Object.freeze({
		__proto__: null,
		EthereumProvider: G$2,
		OPTIONAL_EVENTS: _$3,
		OPTIONAL_METHODS: E$1,
		REQUIRED_EVENTS: m$2,
		REQUIRED_METHODS: u$2,
		default: v$2
	});

	const t$4=Symbol();const s$4=Object.getPrototypeOf,c$4=new WeakMap,l$5=e=>e&&(c$4.has(e)?c$4.get(e):s$4(e)===Object.prototype||s$4(e)===Array.prototype),y$2=e=>l$5(e)&&e[t$4]||null,h$3=(e,t=!0)=>{c$4.set(e,t);};

	const isObject = (x) => typeof x === "object" && x !== null;
	const proxyStateMap = /* @__PURE__ */ new WeakMap();
	const refSet = /* @__PURE__ */ new WeakSet();
	const buildProxyFunction = (objectIs = Object.is, newProxy = (target, handler) => new Proxy(target, handler), canProxy = (x) => isObject(x) && !refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer), defaultHandlePromise = (promise) => {
	  switch (promise.status) {
	    case "fulfilled":
	      return promise.value;
	    case "rejected":
	      throw promise.reason;
	    default:
	      throw promise;
	  }
	}, snapCache = /* @__PURE__ */ new WeakMap(), createSnapshot = (target, version, handlePromise = defaultHandlePromise) => {
	  const cache = snapCache.get(target);
	  if ((cache == null ? void 0 : cache[0]) === version) {
	    return cache[1];
	  }
	  const snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
	  h$3(snap, true);
	  snapCache.set(target, [version, snap]);
	  Reflect.ownKeys(target).forEach((key) => {
	    if (Object.getOwnPropertyDescriptor(snap, key)) {
	      return;
	    }
	    const value = Reflect.get(target, key);
	    const desc = {
	      value,
	      enumerable: true,
	      // This is intentional to avoid copying with proxy-compare.
	      // It's still non-writable, so it avoids assigning a value.
	      configurable: true
	    };
	    if (refSet.has(value)) {
	      h$3(value, false);
	    } else if (value instanceof Promise) {
	      delete desc.value;
	      desc.get = () => handlePromise(value);
	    } else if (proxyStateMap.has(value)) {
	      const [target2, ensureVersion] = proxyStateMap.get(
	        value
	      );
	      desc.value = createSnapshot(
	        target2,
	        ensureVersion(),
	        handlePromise
	      );
	    }
	    Object.defineProperty(snap, key, desc);
	  });
	  return snap;
	}, proxyCache = /* @__PURE__ */ new WeakMap(), versionHolder = [1, 1], proxyFunction = (initialObject) => {
	  if (!isObject(initialObject)) {
	    throw new Error("object required");
	  }
	  const found = proxyCache.get(initialObject);
	  if (found) {
	    return found;
	  }
	  let version = versionHolder[0];
	  const listeners = /* @__PURE__ */ new Set();
	  const notifyUpdate = (op, nextVersion = ++versionHolder[0]) => {
	    if (version !== nextVersion) {
	      version = nextVersion;
	      listeners.forEach((listener) => listener(op, nextVersion));
	    }
	  };
	  let checkVersion = versionHolder[1];
	  const ensureVersion = (nextCheckVersion = ++versionHolder[1]) => {
	    if (checkVersion !== nextCheckVersion && !listeners.size) {
	      checkVersion = nextCheckVersion;
	      propProxyStates.forEach(([propProxyState]) => {
	        const propVersion = propProxyState[1](nextCheckVersion);
	        if (propVersion > version) {
	          version = propVersion;
	        }
	      });
	    }
	    return version;
	  };
	  const createPropListener = (prop) => (op, nextVersion) => {
	    const newOp = [...op];
	    newOp[1] = [prop, ...newOp[1]];
	    notifyUpdate(newOp, nextVersion);
	  };
	  const propProxyStates = /* @__PURE__ */ new Map();
	  const addPropListener = (prop, propProxyState) => {
	    if ((undefined ? undefined.MODE : void 0) !== "production" && propProxyStates.has(prop)) {
	      throw new Error("prop listener already exists");
	    }
	    if (listeners.size) {
	      const remove = propProxyState[3](createPropListener(prop));
	      propProxyStates.set(prop, [propProxyState, remove]);
	    } else {
	      propProxyStates.set(prop, [propProxyState]);
	    }
	  };
	  const removePropListener = (prop) => {
	    var _a;
	    const entry = propProxyStates.get(prop);
	    if (entry) {
	      propProxyStates.delete(prop);
	      (_a = entry[1]) == null ? void 0 : _a.call(entry);
	    }
	  };
	  const addListener = (listener) => {
	    listeners.add(listener);
	    if (listeners.size === 1) {
	      propProxyStates.forEach(([propProxyState, prevRemove], prop) => {
	        if ((undefined ? undefined.MODE : void 0) !== "production" && prevRemove) {
	          throw new Error("remove already exists");
	        }
	        const remove = propProxyState[3](createPropListener(prop));
	        propProxyStates.set(prop, [propProxyState, remove]);
	      });
	    }
	    const removeListener = () => {
	      listeners.delete(listener);
	      if (listeners.size === 0) {
	        propProxyStates.forEach(([propProxyState, remove], prop) => {
	          if (remove) {
	            remove();
	            propProxyStates.set(prop, [propProxyState]);
	          }
	        });
	      }
	    };
	    return removeListener;
	  };
	  const baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
	  const handler = {
	    deleteProperty(target, prop) {
	      const prevValue = Reflect.get(target, prop);
	      removePropListener(prop);
	      const deleted = Reflect.deleteProperty(target, prop);
	      if (deleted) {
	        notifyUpdate(["delete", [prop], prevValue]);
	      }
	      return deleted;
	    },
	    set(target, prop, value, receiver) {
	      const hasPrevValue = Reflect.has(target, prop);
	      const prevValue = Reflect.get(target, prop, receiver);
	      if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) {
	        return true;
	      }
	      removePropListener(prop);
	      if (isObject(value)) {
	        value = y$2(value) || value;
	      }
	      let nextValue = value;
	      if (value instanceof Promise) {
	        value.then((v) => {
	          value.status = "fulfilled";
	          value.value = v;
	          notifyUpdate(["resolve", [prop], v]);
	        }).catch((e) => {
	          value.status = "rejected";
	          value.reason = e;
	          notifyUpdate(["reject", [prop], e]);
	        });
	      } else {
	        if (!proxyStateMap.has(value) && canProxy(value)) {
	          nextValue = proxyFunction(value);
	        }
	        const childProxyState = !refSet.has(nextValue) && proxyStateMap.get(nextValue);
	        if (childProxyState) {
	          addPropListener(prop, childProxyState);
	        }
	      }
	      Reflect.set(target, prop, nextValue, receiver);
	      notifyUpdate(["set", [prop], value, prevValue]);
	      return true;
	    }
	  };
	  const proxyObject = newProxy(baseObject, handler);
	  proxyCache.set(initialObject, proxyObject);
	  const proxyState = [
	    baseObject,
	    ensureVersion,
	    createSnapshot,
	    addListener
	  ];
	  proxyStateMap.set(proxyObject, proxyState);
	  Reflect.ownKeys(initialObject).forEach((key) => {
	    const desc = Object.getOwnPropertyDescriptor(
	      initialObject,
	      key
	    );
	    if ("value" in desc) {
	      proxyObject[key] = initialObject[key];
	      delete desc.value;
	      delete desc.writable;
	    }
	    Object.defineProperty(baseObject, key, desc);
	  });
	  return proxyObject;
	}) => [
	  // public functions
	  proxyFunction,
	  // shared state
	  proxyStateMap,
	  refSet,
	  // internal things
	  objectIs,
	  newProxy,
	  canProxy,
	  defaultHandlePromise,
	  snapCache,
	  createSnapshot,
	  proxyCache,
	  versionHolder
	];
	const [defaultProxyFunction] = buildProxyFunction();
	function proxy(initialObject = {}) {
	  return defaultProxyFunction(initialObject);
	}
	function subscribe(proxyObject, callback, notifyInSync) {
	  const proxyState = proxyStateMap.get(proxyObject);
	  if ((undefined ? undefined.MODE : void 0) !== "production" && !proxyState) {
	    console.warn("Please use proxy object");
	  }
	  let promise;
	  const ops = [];
	  const addListener = proxyState[3];
	  let isListenerActive = false;
	  const listener = (op) => {
	    ops.push(op);
	    if (notifyInSync) {
	      callback(ops.splice(0));
	      return;
	    }
	    if (!promise) {
	      promise = Promise.resolve().then(() => {
	        promise = void 0;
	        if (isListenerActive) {
	          callback(ops.splice(0));
	        }
	      });
	    }
	  };
	  const removeListener = addListener(listener);
	  isListenerActive = true;
	  return () => {
	    isListenerActive = false;
	    removeListener();
	  };
	}
	function snapshot(proxyObject, handlePromise) {
	  const proxyState = proxyStateMap.get(proxyObject);
	  if ((undefined ? undefined.MODE : void 0) !== "production" && !proxyState) {
	    console.warn("Please use proxy object");
	  }
	  const [target, ensureVersion, createSnapshot] = proxyState;
	  return createSnapshot(target, ensureVersion(), handlePromise);
	}

	const n$6=proxy({history:["ConnectWallet"],view:"ConnectWallet",data:void 0}),N$1={state:n$6,subscribe(e){return subscribe(n$6,()=>e(n$6))},push(e,t){e!==n$6.view&&(n$6.view=e,t&&(n$6.data=t),n$6.history.push(e));},reset(e){n$6.view=e,n$6.history=[e];},replace(e){n$6.history.length>1&&(n$6.history[n$6.history.length-1]=e,n$6.view=e);},goBack(){if(n$6.history.length>1){n$6.history.pop();const[e]=n$6.history.slice(-1);n$6.view=e;}},setData(e){n$6.data=e;}},i$4={WALLETCONNECT_DEEPLINK_CHOICE:"WALLETCONNECT_DEEPLINK_CHOICE",WCM_VERSION:"WCM_VERSION",RECOMMENDED_WALLET_AMOUNT:9,isMobile(){return typeof window<"u"?Boolean(window.matchMedia("(pointer:coarse)").matches||/Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent)):!1},isAndroid(){return i$4.isMobile()&&navigator.userAgent.toLowerCase().includes("android")},isIos(){const e=navigator.userAgent.toLowerCase();return i$4.isMobile()&&(e.includes("iphone")||e.includes("ipad"))},isHttpUrl(e){return e.startsWith("http://")||e.startsWith("https://")},isArray(e){return Array.isArray(e)&&e.length>0},formatNativeUrl(e,t,s){if(i$4.isHttpUrl(e))return this.formatUniversalUrl(e,t,s);let o=e;o.includes("://")||(o=e.replaceAll("/","").replaceAll(":",""),o=`${o}://`),o.endsWith("/")||(o=`${o}/`),this.setWalletConnectDeepLink(o,s);const a=encodeURIComponent(t);return `${o}wc?uri=${a}`},formatUniversalUrl(e,t,s){if(!i$4.isHttpUrl(e))return this.formatNativeUrl(e,t,s);let o=e;o.endsWith("/")||(o=`${o}/`),this.setWalletConnectDeepLink(o,s);const a=encodeURIComponent(t);return `${o}wc?uri=${a}`},async wait(e){return new Promise(t=>{setTimeout(t,e);})},openHref(e,t){window.open(e,t,"noreferrer noopener");},setWalletConnectDeepLink(e,t){try{localStorage.setItem(i$4.WALLETCONNECT_DEEPLINK_CHOICE,JSON.stringify({href:e,name:t}));}catch{console.info("Unable to set WalletConnect deep link");}},setWalletConnectAndroidDeepLink(e){try{const[t]=e.split("?");localStorage.setItem(i$4.WALLETCONNECT_DEEPLINK_CHOICE,JSON.stringify({href:t,name:"Android"}));}catch{console.info("Unable to set WalletConnect android deep link");}},removeWalletConnectDeepLink(){try{localStorage.removeItem(i$4.WALLETCONNECT_DEEPLINK_CHOICE);}catch{console.info("Unable to remove WalletConnect deep link");}},setModalVersionInStorage(){try{typeof localStorage<"u"&&localStorage.setItem(i$4.WCM_VERSION,"2.5.9");}catch{console.info("Unable to set Web3Modal version in storage");}},getWalletRouterData(){var e;const t=(e=N$1.state.data)==null?void 0:e.Wallet;if(!t)throw new Error('Missing "Wallet" view data');return t}},T$2=typeof location<"u"&&(location.hostname.includes("localhost")||location.protocol.includes("https")),r$3=proxy({enabled:T$2,userSessionId:"",events:[],connectedWalletId:void 0}),$$1={state:r$3,subscribe(e){return subscribe(r$3.events,()=>e(snapshot(r$3.events[r$3.events.length-1])))},initialize(){r$3.enabled&&typeof(crypto==null?void 0:crypto.randomUUID)<"u"&&(r$3.userSessionId=crypto.randomUUID());},setConnectedWalletId(e){r$3.connectedWalletId=e;},click(e){if(r$3.enabled){const t={type:"CLICK",name:e.name,userSessionId:r$3.userSessionId,timestamp:Date.now(),data:e};r$3.events.push(t);}},track(e){if(r$3.enabled){const t={type:"TRACK",name:e.name,userSessionId:r$3.userSessionId,timestamp:Date.now(),data:e};r$3.events.push(t);}},view(e){if(r$3.enabled){const t={type:"VIEW",name:e.name,userSessionId:r$3.userSessionId,timestamp:Date.now(),data:e};r$3.events.push(t);}}},l$4=proxy({chains:void 0,walletConnectUri:void 0,isAuth:!1,isCustomDesktop:!1,isCustomMobile:!1,isDataLoaded:!1,isUiLoaded:!1}),c$3={state:l$4,subscribe(e){return subscribe(l$4,()=>e(l$4))},setChains(e){l$4.chains=e;},setWalletConnectUri(e){l$4.walletConnectUri=e;},setIsCustomDesktop(e){l$4.isCustomDesktop=e;},setIsCustomMobile(e){l$4.isCustomMobile=e;},setIsDataLoaded(e){l$4.isDataLoaded=e;},setIsUiLoaded(e){l$4.isUiLoaded=e;},setIsAuth(e){l$4.isAuth=e;}},y$1=proxy({projectId:"",mobileWallets:void 0,desktopWallets:void 0,walletImages:void 0,chains:void 0,enableAuthMode:!1,enableExplorer:!0,explorerExcludedWalletIds:void 0,explorerRecommendedWalletIds:void 0,termsOfServiceUrl:void 0,privacyPolicyUrl:void 0}),C$1={state:y$1,subscribe(e){return subscribe(y$1,()=>e(y$1))},setConfig(e){var t,s;$$1.initialize(),c$3.setChains(e.chains),c$3.setIsAuth(Boolean(e.enableAuthMode)),c$3.setIsCustomMobile(Boolean((t=e.mobileWallets)==null?void 0:t.length)),c$3.setIsCustomDesktop(Boolean((s=e.desktopWallets)==null?void 0:s.length)),i$4.setModalVersionInStorage(),Object.assign(y$1,e);}},L$2="https://explorer-api.walletconnect.com";async function W(e,t){const s=new URL(e,L$2);return s.searchParams.append("projectId",C$1.state.projectId),Object.entries(t).forEach(([o,a])=>{a&&s.searchParams.append(o,String(a));}),(await fetch(s)).json()}const m$1={async getDesktopListings(e){return W("/w3m/v1/getDesktopListings",e)},async getMobileListings(e){return W("/w3m/v1/getMobileListings",e)},async getInjectedListings(e){return W("/w3m/v1/getInjectedListings",e)},async getAllListings(e){return W("/w3m/v1/getAllListings",e)},getWalletImageUrl(e){return `${L$2}/w3m/v1/getWalletImage/${e}?projectId=${C$1.state.projectId}`},getAssetImageUrl(e){return `${L$2}/w3m/v1/getAssetImage/${e}?projectId=${C$1.state.projectId}`}};var P$1=Object.defineProperty,O=Object.getOwnPropertySymbols,_$2=Object.prototype.hasOwnProperty,R$1=Object.prototype.propertyIsEnumerable,U$1=(e,t,s)=>t in e?P$1(e,t,{enumerable:!0,configurable:!0,writable:!0,value:s}):e[t]=s,B$2=(e,t)=>{for(var s in t||(t={}))_$2.call(t,s)&&U$1(e,s,t[s]);if(O)for(var s of O(t))R$1.call(t,s)&&U$1(e,s,t[s]);return e};const M$1=i$4.isMobile(),d$3=proxy({wallets:{listings:[],total:0,page:1},search:{listings:[],total:0,page:1},recomendedWallets:[]}),G$1={state:d$3,async getRecomendedWallets(){const{explorerRecommendedWalletIds:e,explorerExcludedWalletIds:t}=C$1.state;if(e==="NONE"||t==="ALL"&&!e)return d$3.recomendedWallets;if(i$4.isArray(e)){const s={recommendedIds:e.join(",")},{listings:o}=await m$1.getAllListings(s),a=Object.values(o);a.sort((u,v)=>{const w=e.indexOf(u.id),f=e.indexOf(v.id);return w-f}),d$3.recomendedWallets=a;}else {const{chains:s,isAuth:o}=c$3.state,a=s?.join(","),u=i$4.isArray(t),v={page:1,sdks:o?"auth_v1":void 0,entries:i$4.RECOMMENDED_WALLET_AMOUNT,chains:a,version:2,excludedIds:u?t.join(","):void 0},{listings:w}=M$1?await m$1.getMobileListings(v):await m$1.getDesktopListings(v);d$3.recomendedWallets=Object.values(w);}return d$3.recomendedWallets},async getWallets(e){const t=B$2({},e),{explorerRecommendedWalletIds:s,explorerExcludedWalletIds:o}=C$1.state,{recomendedWallets:a}=d$3;if(o==="ALL")return d$3.wallets;a.length?t.excludedIds=a.map(k=>k.id).join(","):i$4.isArray(s)&&(t.excludedIds=s.join(",")),i$4.isArray(o)&&(t.excludedIds=[t.excludedIds,o].filter(Boolean).join(",")),c$3.state.isAuth&&(t.sdks="auth_v1");const{page:u,search:v}=e,{listings:w,total:f}=M$1?await m$1.getMobileListings(t):await m$1.getDesktopListings(t),E=Object.values(w),A=v?"search":"wallets";return d$3[A]={listings:[...d$3[A].listings,...E],total:f,page:u??1},{listings:E,total:f}},getWalletImageUrl(e){return m$1.getWalletImageUrl(e)},getAssetImageUrl(e){return m$1.getAssetImageUrl(e)},resetSearch(){d$3.search={listings:[],total:0,page:1};}},I$1=proxy({open:!1}),Q$1={state:I$1,subscribe(e){return subscribe(I$1,()=>e(I$1))},async open(e){return new Promise(t=>{const{isUiLoaded:s,isDataLoaded:o}=c$3.state;if(c$3.setWalletConnectUri(e?.uri),c$3.setChains(e?.chains),N$1.reset("ConnectWallet"),s&&o)I$1.open=!0,t();else {const a=setInterval(()=>{const u=c$3.state;u.isUiLoaded&&u.isDataLoaded&&(clearInterval(a),I$1.open=!0,t());},200);}})},close(){I$1.open=!1;}};var H$1=Object.defineProperty,D$2=Object.getOwnPropertySymbols,V$1=Object.prototype.hasOwnProperty,K$1=Object.prototype.propertyIsEnumerable,j$1=(e,t,s)=>t in e?H$1(e,t,{enumerable:!0,configurable:!0,writable:!0,value:s}):e[t]=s,z$1=(e,t)=>{for(var s in t||(t={}))V$1.call(t,s)&&j$1(e,s,t[s]);if(D$2)for(var s of D$2(t))K$1.call(t,s)&&j$1(e,s,t[s]);return e};function J(){return typeof matchMedia<"u"&&matchMedia("(prefers-color-scheme: dark)").matches}const b$1=proxy({themeMode:J()?"dark":"light"}),X={state:b$1,subscribe(e){return subscribe(b$1,()=>e(b$1))},setThemeConfig(e){const{themeMode:t,themeVariables:s}=e;t&&(b$1.themeMode=t),s&&(b$1.themeVariables=z$1({},s));}},g$1=proxy({open:!1,message:"",variant:"success"}),Y$1={state:g$1,subscribe(e){return subscribe(g$1,()=>e(g$1))},openToast(e,t){g$1.open=!0,g$1.message=e,g$1.variant=t;},closeToast(){g$1.open=!1;}};typeof window<"u"&&(window.Buffer||(window.Buffer=buffer$2.Buffer),window.global||(window.global=window),window.process||(window.process={env:{}}),window.global||(window.global=window));

	let d$2 = class d{constructor(e){this.openModal=Q$1.open,this.closeModal=Q$1.close,this.subscribeModal=Q$1.subscribe,this.setTheme=X.setThemeConfig,X.setThemeConfig(e),C$1.setConfig(e),this.initUi();}async initUi(){if(typeof window<"u"){await Promise.resolve().then(function () { return index; });const e=document.createElement("wcm-modal");document.body.insertAdjacentElement("beforeend",e),c$3.setIsUiLoaded(!0);}}};

	var index$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		WalletConnectModal: d$2
	});

	/**
	 * @license
	 * Copyright 2019 Google LLC
	 * SPDX-License-Identifier: BSD-3-Clause
	 */
	const t$3=window,e$5=t$3.ShadowRoot&&(void 0===t$3.ShadyCSS||t$3.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,s$3=Symbol(),n$5=new WeakMap;let o$4 = class o{constructor(t,e,n){if(this._$cssResult$=!0,n!==s$3)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e;}get styleSheet(){let t=this.o;const s=this.t;if(e$5&&void 0===t){const e=void 0!==s&&1===s.length;e&&(t=n$5.get(s)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),e&&n$5.set(s,t));}return t}toString(){return this.cssText}};const r$2=t=>new o$4("string"==typeof t?t:t+"",void 0,s$3),i$3=(t,...e)=>{const n=1===t.length?t[0]:e.reduce(((e,s,n)=>e+(t=>{if(!0===t._$cssResult$)return t.cssText;if("number"==typeof t)return t;throw Error("Value passed to 'css' function must be a 'css' function result: "+t+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(s)+t[n+1]),t[0]);return new o$4(n,t,s$3)},S$2=(s,n)=>{e$5?s.adoptedStyleSheets=n.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet)):n.forEach((e=>{const n=document.createElement("style"),o=t$3.litNonce;void 0!==o&&n.setAttribute("nonce",o),n.textContent=e.cssText,s.appendChild(n);}));},c$2=e$5?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const s of t.cssRules)e+=s.cssText;return r$2(e)})(t):t;

	/**
	 * @license
	 * Copyright 2017 Google LLC
	 * SPDX-License-Identifier: BSD-3-Clause
	 */var s$2;const e$4=window,r$1=e$4.trustedTypes,h$2=r$1?r$1.emptyScript:"",o$3=e$4.reactiveElementPolyfillSupport,n$4={toAttribute(t,i){switch(i){case Boolean:t=t?h$2:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t);}return t},fromAttribute(t,i){let s=t;switch(i){case Boolean:s=null!==t;break;case Number:s=null===t?null:Number(t);break;case Object:case Array:try{s=JSON.parse(t);}catch(t){s=null;}}return s}},a$1=(t,i)=>i!==t&&(i==i||t==t),l$3={attribute:!0,type:String,converter:n$4,reflect:!1,hasChanged:a$1},d$1="finalized";let u$1 = class u extends HTMLElement{constructor(){super(),this._$Ei=new Map,this.isUpdatePending=!1,this.hasUpdated=!1,this._$El=null,this.u();}static addInitializer(t){var i;this.finalize(),(null!==(i=this.h)&&void 0!==i?i:this.h=[]).push(t);}static get observedAttributes(){this.finalize();const t=[];return this.elementProperties.forEach(((i,s)=>{const e=this._$Ep(s,i);void 0!==e&&(this._$Ev.set(e,s),t.push(e));})),t}static createProperty(t,i=l$3){if(i.state&&(i.attribute=!1),this.finalize(),this.elementProperties.set(t,i),!i.noAccessor&&!this.prototype.hasOwnProperty(t)){const s="symbol"==typeof t?Symbol():"__"+t,e=this.getPropertyDescriptor(t,s,i);void 0!==e&&Object.defineProperty(this.prototype,t,e);}}static getPropertyDescriptor(t,i,s){return {get(){return this[i]},set(e){const r=this[t];this[i]=e,this.requestUpdate(t,r,s);},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)||l$3}static finalize(){if(this.hasOwnProperty(d$1))return !1;this[d$1]=!0;const t=Object.getPrototypeOf(this);if(t.finalize(),void 0!==t.h&&(this.h=[...t.h]),this.elementProperties=new Map(t.elementProperties),this._$Ev=new Map,this.hasOwnProperty("properties")){const t=this.properties,i=[...Object.getOwnPropertyNames(t),...Object.getOwnPropertySymbols(t)];for(const s of i)this.createProperty(s,t[s]);}return this.elementStyles=this.finalizeStyles(this.styles),!0}static finalizeStyles(i){const s=[];if(Array.isArray(i)){const e=new Set(i.flat(1/0).reverse());for(const i of e)s.unshift(c$2(i));}else void 0!==i&&s.push(c$2(i));return s}static _$Ep(t,i){const s=i.attribute;return !1===s?void 0:"string"==typeof s?s:"string"==typeof t?t.toLowerCase():void 0}u(){var t;this._$E_=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$Eg(),this.requestUpdate(),null===(t=this.constructor.h)||void 0===t||t.forEach((t=>t(this)));}addController(t){var i,s;(null!==(i=this._$ES)&&void 0!==i?i:this._$ES=[]).push(t),void 0!==this.renderRoot&&this.isConnected&&(null===(s=t.hostConnected)||void 0===s||s.call(t));}removeController(t){var i;null===(i=this._$ES)||void 0===i||i.splice(this._$ES.indexOf(t)>>>0,1);}_$Eg(){this.constructor.elementProperties.forEach(((t,i)=>{this.hasOwnProperty(i)&&(this._$Ei.set(i,this[i]),delete this[i]);}));}createRenderRoot(){var t;const s=null!==(t=this.shadowRoot)&&void 0!==t?t:this.attachShadow(this.constructor.shadowRootOptions);return S$2(s,this.constructor.elementStyles),s}connectedCallback(){var t;void 0===this.renderRoot&&(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostConnected)||void 0===i?void 0:i.call(t)}));}enableUpdating(t){}disconnectedCallback(){var t;null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostDisconnected)||void 0===i?void 0:i.call(t)}));}attributeChangedCallback(t,i,s){this._$AK(t,s);}_$EO(t,i,s=l$3){var e;const r=this.constructor._$Ep(t,s);if(void 0!==r&&!0===s.reflect){const h=(void 0!==(null===(e=s.converter)||void 0===e?void 0:e.toAttribute)?s.converter:n$4).toAttribute(i,s.type);this._$El=t,null==h?this.removeAttribute(r):this.setAttribute(r,h),this._$El=null;}}_$AK(t,i){var s;const e=this.constructor,r=e._$Ev.get(t);if(void 0!==r&&this._$El!==r){const t=e.getPropertyOptions(r),h="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==(null===(s=t.converter)||void 0===s?void 0:s.fromAttribute)?t.converter:n$4;this._$El=r,this[r]=h.fromAttribute(i,t.type),this._$El=null;}}requestUpdate(t,i,s){let e=!0;void 0!==t&&(((s=s||this.constructor.getPropertyOptions(t)).hasChanged||a$1)(this[t],i)?(this._$AL.has(t)||this._$AL.set(t,i),!0===s.reflect&&this._$El!==t&&(void 0===this._$EC&&(this._$EC=new Map),this._$EC.set(t,s))):e=!1),!this.isUpdatePending&&e&&(this._$E_=this._$Ej());}async _$Ej(){this.isUpdatePending=!0;try{await this._$E_;}catch(t){Promise.reject(t);}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var t;if(!this.isUpdatePending)return;this.hasUpdated,this._$Ei&&(this._$Ei.forEach(((t,i)=>this[i]=t)),this._$Ei=void 0);let i=!1;const s=this._$AL;try{i=this.shouldUpdate(s),i?(this.willUpdate(s),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostUpdate)||void 0===i?void 0:i.call(t)})),this.update(s)):this._$Ek();}catch(t){throw i=!1,this._$Ek(),t}i&&this._$AE(s);}willUpdate(t){}_$AE(t){var i;null===(i=this._$ES)||void 0===i||i.forEach((t=>{var i;return null===(i=t.hostUpdated)||void 0===i?void 0:i.call(t)})),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t);}_$Ek(){this._$AL=new Map,this.isUpdatePending=!1;}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$E_}shouldUpdate(t){return !0}update(t){void 0!==this._$EC&&(this._$EC.forEach(((t,i)=>this._$EO(i,this[i],t))),this._$EC=void 0),this._$Ek();}updated(t){}firstUpdated(t){}};u$1[d$1]=!0,u$1.elementProperties=new Map,u$1.elementStyles=[],u$1.shadowRootOptions={mode:"open"},null==o$3||o$3({ReactiveElement:u$1}),(null!==(s$2=e$4.reactiveElementVersions)&&void 0!==s$2?s$2:e$4.reactiveElementVersions=[]).push("1.6.2");

	/**
	 * @license
	 * Copyright 2017 Google LLC
	 * SPDX-License-Identifier: BSD-3-Clause
	 */
	var t$2;const i$2=window,s$1=i$2.trustedTypes,e$3=s$1?s$1.createPolicy("lit-html",{createHTML:t=>t}):void 0,o$2="$lit$",n$3=`lit$${(Math.random()+"").slice(9)}$`,l$2="?"+n$3,h$1=`<${l$2}>`,r=document,u=()=>r.createComment(""),d=t=>null===t||"object"!=typeof t&&"function"!=typeof t,c$1=Array.isArray,v$1=t=>c$1(t)||"function"==typeof(null==t?void 0:t[Symbol.iterator]),a="[ \t\n\f\r]",f=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,_$1=/-->/g,m=/>/g,p=RegExp(`>|${a}(?:([^\\s"'>=/]+)(${a}*=${a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`,"g"),g=/'/g,$=/"/g,y=/^(?:script|style|textarea|title)$/i,w=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),x=w(1),b=w(2),T$1=Symbol.for("lit-noChange"),A$1=Symbol.for("lit-nothing"),E=new WeakMap,C=r.createTreeWalker(r,129,null,!1);function P(t,i){if(!Array.isArray(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return void 0!==e$3?e$3.createHTML(i):i}const V=(t,i)=>{const s=t.length-1,e=[];let l,r=2===i?"<svg>":"",u=f;for(let i=0;i<s;i++){const s=t[i];let d,c,v=-1,a=0;for(;a<s.length&&(u.lastIndex=a,c=u.exec(s),null!==c);)a=u.lastIndex,u===f?"!--"===c[1]?u=_$1:void 0!==c[1]?u=m:void 0!==c[2]?(y.test(c[2])&&(l=RegExp("</"+c[2],"g")),u=p):void 0!==c[3]&&(u=p):u===p?">"===c[0]?(u=null!=l?l:f,v=-1):void 0===c[1]?v=-2:(v=u.lastIndex-c[2].length,d=c[1],u=void 0===c[3]?p:'"'===c[3]?$:g):u===$||u===g?u=p:u===_$1||u===m?u=f:(u=p,l=void 0);const w=u===p&&t[i+1].startsWith("/>")?" ":"";r+=u===f?s+h$1:v>=0?(e.push(d),s.slice(0,v)+o$2+s.slice(v)+n$3+w):s+n$3+(-2===v?(e.push(void 0),i):w);}return [P(t,r+(t[s]||"<?>")+(2===i?"</svg>":"")),e]};class N{constructor({strings:t,_$litType$:i},e){let h;this.parts=[];let r=0,d=0;const c=t.length-1,v=this.parts,[a,f]=V(t,i);if(this.el=N.createElement(a,e),C.currentNode=this.el.content,2===i){const t=this.el.content,i=t.firstChild;i.remove(),t.append(...i.childNodes);}for(;null!==(h=C.nextNode())&&v.length<c;){if(1===h.nodeType){if(h.hasAttributes()){const t=[];for(const i of h.getAttributeNames())if(i.endsWith(o$2)||i.startsWith(n$3)){const s=f[d++];if(t.push(i),void 0!==s){const t=h.getAttribute(s.toLowerCase()+o$2).split(n$3),i=/([.?@])?(.*)/.exec(s);v.push({type:1,index:r,name:i[2],strings:t,ctor:"."===i[1]?H:"?"===i[1]?L$1:"@"===i[1]?z:k});}else v.push({type:6,index:r});}for(const i of t)h.removeAttribute(i);}if(y.test(h.tagName)){const t=h.textContent.split(n$3),i=t.length-1;if(i>0){h.textContent=s$1?s$1.emptyScript:"";for(let s=0;s<i;s++)h.append(t[s],u()),C.nextNode(),v.push({type:2,index:++r});h.append(t[i],u());}}}else if(8===h.nodeType)if(h.data===l$2)v.push({type:2,index:r});else {let t=-1;for(;-1!==(t=h.data.indexOf(n$3,t+1));)v.push({type:7,index:r}),t+=n$3.length-1;}r++;}}static createElement(t,i){const s=r.createElement("template");return s.innerHTML=t,s}}function S$1(t,i,s=t,e){var o,n,l,h;if(i===T$1)return i;let r=void 0!==e?null===(o=s._$Co)||void 0===o?void 0:o[e]:s._$Cl;const u=d(i)?void 0:i._$litDirective$;return (null==r?void 0:r.constructor)!==u&&(null===(n=null==r?void 0:r._$AO)||void 0===n||n.call(r,!1),void 0===u?r=void 0:(r=new u(t),r._$AT(t,s,e)),void 0!==e?(null!==(l=(h=s)._$Co)&&void 0!==l?l:h._$Co=[])[e]=r:s._$Cl=r),void 0!==r&&(i=S$1(t,r._$AS(t,i.values),r,e)),i}class M{constructor(t,i){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=i;}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){var i;const{el:{content:s},parts:e}=this._$AD,o=(null!==(i=null==t?void 0:t.creationScope)&&void 0!==i?i:r).importNode(s,!0);C.currentNode=o;let n=C.nextNode(),l=0,h=0,u=e[0];for(;void 0!==u;){if(l===u.index){let i;2===u.type?i=new R(n,n.nextSibling,this,t):1===u.type?i=new u.ctor(n,u.name,u.strings,this,t):6===u.type&&(i=new Z$1(n,this,t)),this._$AV.push(i),u=e[++h];}l!==(null==u?void 0:u.index)&&(n=C.nextNode(),l++);}return C.currentNode=r,o}v(t){let i=0;for(const s of this._$AV)void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++;}}class R{constructor(t,i,s,e){var o;this.type=2,this._$AH=A$1,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cp=null===(o=null==e?void 0:e.isConnected)||void 0===o||o;}get _$AU(){var t,i;return null!==(i=null===(t=this._$AM)||void 0===t?void 0:t._$AU)&&void 0!==i?i:this._$Cp}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===(null==t?void 0:t.nodeType)&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=S$1(this,t,i),d(t)?t===A$1||null==t||""===t?(this._$AH!==A$1&&this._$AR(),this._$AH=A$1):t!==this._$AH&&t!==T$1&&this._(t):void 0!==t._$litType$?this.g(t):void 0!==t.nodeType?this.$(t):v$1(t)?this.T(t):this._(t);}k(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}$(t){this._$AH!==t&&(this._$AR(),this._$AH=this.k(t));}_(t){this._$AH!==A$1&&d(this._$AH)?this._$AA.nextSibling.data=t:this.$(r.createTextNode(t)),this._$AH=t;}g(t){var i;const{values:s,_$litType$:e}=t,o="number"==typeof e?this._$AC(t):(void 0===e.el&&(e.el=N.createElement(P(e.h,e.h[0]),this.options)),e);if((null===(i=this._$AH)||void 0===i?void 0:i._$AD)===o)this._$AH.v(s);else {const t=new M(o,this),i=t.u(this.options);t.v(s),this.$(i),this._$AH=t;}}_$AC(t){let i=E.get(t.strings);return void 0===i&&E.set(t.strings,i=new N(t)),i}T(t){c$1(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const o of t)e===i.length?i.push(s=new R(this.k(u()),this.k(u()),this,this.options)):s=i[e],s._$AI(o),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e);}_$AR(t=this._$AA.nextSibling,i){var s;for(null===(s=this._$AP)||void 0===s||s.call(this,!1,!0,i);t&&t!==this._$AB;){const i=t.nextSibling;t.remove(),t=i;}}setConnected(t){var i;void 0===this._$AM&&(this._$Cp=t,null===(i=this._$AP)||void 0===i||i.call(this,t));}}class k{constructor(t,i,s,e,o){this.type=1,this._$AH=A$1,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=o,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=A$1;}get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}_$AI(t,i=this,s,e){const o=this.strings;let n=!1;if(void 0===o)t=S$1(this,t,i,0),n=!d(t)||t!==this._$AH&&t!==T$1,n&&(this._$AH=t);else {const e=t;let l,h;for(t=o[0],l=0;l<o.length-1;l++)h=S$1(this,e[s+l],i,l),h===T$1&&(h=this._$AH[l]),n||(n=!d(h)||h!==this._$AH[l]),h===A$1?t=A$1:t!==A$1&&(t+=(null!=h?h:"")+o[l+1]),this._$AH[l]=h;}n&&!e&&this.j(t);}j(t){t===A$1?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,null!=t?t:"");}}class H extends k{constructor(){super(...arguments),this.type=3;}j(t){this.element[this.name]=t===A$1?void 0:t;}}const I=s$1?s$1.emptyScript:"";let L$1 = class L extends k{constructor(){super(...arguments),this.type=4;}j(t){t&&t!==A$1?this.element.setAttribute(this.name,I):this.element.removeAttribute(this.name);}};class z extends k{constructor(t,i,s,e,o){super(t,i,s,e,o),this.type=5;}_$AI(t,i=this){var s;if((t=null!==(s=S$1(this,t,i,0))&&void 0!==s?s:A$1)===T$1)return;const e=this._$AH,o=t===A$1&&e!==A$1||t.capture!==e.capture||t.once!==e.once||t.passive!==e.passive,n=t!==A$1&&(e===A$1||o);o&&this.element.removeEventListener(this.name,this,e),n&&this.element.addEventListener(this.name,this,t),this._$AH=t;}handleEvent(t){var i,s;"function"==typeof this._$AH?this._$AH.call(null!==(s=null===(i=this.options)||void 0===i?void 0:i.host)&&void 0!==s?s:this.element,t):this._$AH.handleEvent(t);}}let Z$1 = class Z{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s;}get _$AU(){return this._$AM._$AU}_$AI(t){S$1(this,t);}};const B$1=i$2.litHtmlPolyfillSupport;null==B$1||B$1(N,R),(null!==(t$2=i$2.litHtmlVersions)&&void 0!==t$2?t$2:i$2.litHtmlVersions=[]).push("2.7.5");const D$1=(t,i,s)=>{var e,o;const n=null!==(e=null==s?void 0:s.renderBefore)&&void 0!==e?e:i;let l=n._$litPart$;if(void 0===l){const t=null!==(o=null==s?void 0:s.renderBefore)&&void 0!==o?o:null;n._$litPart$=l=new R(i.insertBefore(u(),t),t,void 0,null!=s?s:{});}return l._$AI(t),l};

	/**
	 * @license
	 * Copyright 2017 Google LLC
	 * SPDX-License-Identifier: BSD-3-Clause
	 */var l$1,o$1;class s extends u$1{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0;}createRenderRoot(){var t,e;const i=super.createRenderRoot();return null!==(t=(e=this.renderOptions).renderBefore)&&void 0!==t||(e.renderBefore=i.firstChild),i}update(t){const i=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=D$1(i,this.renderRoot,this.renderOptions);}connectedCallback(){var t;super.connectedCallback(),null===(t=this._$Do)||void 0===t||t.setConnected(!0);}disconnectedCallback(){var t;super.disconnectedCallback(),null===(t=this._$Do)||void 0===t||t.setConnected(!1);}render(){return T$1}}s.finalized=!0,s._$litElement$=!0,null===(l$1=globalThis.litElementHydrateSupport)||void 0===l$1||l$1.call(globalThis,{LitElement:s});const n$2=globalThis.litElementPolyfillSupport;null==n$2||n$2({LitElement:s});(null!==(o$1=globalThis.litElementVersions)&&void 0!==o$1?o$1:globalThis.litElementVersions=[]).push("3.3.2");

	/**
	 * @license
	 * Copyright 2017 Google LLC
	 * SPDX-License-Identifier: BSD-3-Clause
	 */
	const e$2=e=>n=>"function"==typeof n?((e,n)=>(customElements.define(e,n),n))(e,n):((e,n)=>{const{kind:t,elements:s}=n;return {kind:t,elements:s,finisher(n){customElements.define(e,n);}}})(e,n);

	/**
	 * @license
	 * Copyright 2017 Google LLC
	 * SPDX-License-Identifier: BSD-3-Clause
	 */
	const i$1=(i,e)=>"method"===e.kind&&e.descriptor&&!("value"in e.descriptor)?{...e,finisher(n){n.createProperty(e.key,i);}}:{kind:"field",key:Symbol(),placement:"own",descriptor:{},originalKey:e.key,initializer(){"function"==typeof e.initializer&&(this[e.key]=e.initializer.call(this));},finisher(n){n.createProperty(e.key,i);}},e$1=(i,e,n)=>{e.constructor.createProperty(n,i);};function n$1(n){return (t,o)=>void 0!==o?e$1(n,t,o):i$1(n,t)}

	/**
	 * @license
	 * Copyright 2017 Google LLC
	 * SPDX-License-Identifier: BSD-3-Clause
	 */function t$1(t){return n$1({...t,state:!0})}

	/**
	 * @license
	 * Copyright 2021 Google LLC
	 * SPDX-License-Identifier: BSD-3-Clause
	 */var n;null!=(null===(n=window.HTMLSlotElement)||void 0===n?void 0:n.prototype.assignedElements)?(o,n)=>o.assignedElements(n):(o,n)=>o.assignedNodes(n).filter((o=>o.nodeType===Node.ELEMENT_NODE));

	/**
	 * @license
	 * Copyright 2017 Google LLC
	 * SPDX-License-Identifier: BSD-3-Clause
	 */
	const t={ATTRIBUTE:1,CHILD:2,PROPERTY:3,BOOLEAN_ATTRIBUTE:4,EVENT:5,ELEMENT:6},e=t=>(...e)=>({_$litDirective$:t,values:e});class i{constructor(t){}get _$AU(){return this._$AM._$AU}_$AT(t,e,i){this._$Ct=t,this._$AM=e,this._$Ci=i;}_$AS(t,e){return this.update(t,e)}update(t,e){return this.render(...e)}}

	/**
	 * @license
	 * Copyright 2018 Google LLC
	 * SPDX-License-Identifier: BSD-3-Clause
	 */const o=e(class extends i{constructor(t$1){var i;if(super(t$1),t$1.type!==t.ATTRIBUTE||"class"!==t$1.name||(null===(i=t$1.strings)||void 0===i?void 0:i.length)>2)throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.")}render(t){return " "+Object.keys(t).filter((i=>t[i])).join(" ")+" "}update(i,[s]){var r,o;if(void 0===this.it){this.it=new Set,void 0!==i.strings&&(this.nt=new Set(i.strings.join(" ").split(/\s/).filter((t=>""!==t))));for(const t in s)s[t]&&!(null===(r=this.nt)||void 0===r?void 0:r.has(t))&&this.it.add(t);return this.render(s)}const e=i.element.classList;this.it.forEach((t=>{t in s||(e.remove(t),this.it.delete(t));}));for(const t in s){const i=!!s[t];i===this.it.has(t)||(null===(o=this.nt)||void 0===o?void 0:o.has(t))||(i?(e.add(t),this.it.add(t)):(e.remove(t),this.it.delete(t)));}return T$1}});

	function addUniqueItem(array, item) {
	    array.indexOf(item) === -1 && array.push(item);
	}

	const clamp = (min, max, v) => Math.min(Math.max(v, min), max);

	const defaults = {
	    duration: 0.3,
	    delay: 0,
	    endDelay: 0,
	    repeat: 0,
	    easing: "ease",
	};

	const isNumber = (value) => typeof value === "number";

	const isEasingList = (easing) => Array.isArray(easing) && !isNumber(easing[0]);

	const wrap = (min, max, v) => {
	    const rangeSize = max - min;
	    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
	};

	function getEasingForSegment(easing, i) {
	    return isEasingList(easing)
	        ? easing[wrap(0, easing.length, i)]
	        : easing;
	}

	const mix = (min, max, progress) => -progress * min + progress * max + min;

	const noop = () => { };
	const noopReturn = (v) => v;

	const progress = (min, max, value) => max - min === 0 ? 1 : (value - min) / (max - min);

	function fillOffset(offset, remaining) {
	    const min = offset[offset.length - 1];
	    for (let i = 1; i <= remaining; i++) {
	        const offsetProgress = progress(0, remaining, i);
	        offset.push(mix(min, 1, offsetProgress));
	    }
	}
	function defaultOffset(length) {
	    const offset = [0];
	    fillOffset(offset, length - 1);
	    return offset;
	}

	function interpolate(output, input = defaultOffset(output.length), easing = noopReturn) {
	    const length = output.length;
	    /**
	     * If the input length is lower than the output we
	     * fill the input to match. This currently assumes the input
	     * is an animation progress value so is a good candidate for
	     * moving outside the function.
	     */
	    const remainder = length - input.length;
	    remainder > 0 && fillOffset(input, remainder);
	    return (t) => {
	        let i = 0;
	        for (; i < length - 2; i++) {
	            if (t < input[i + 1])
	                break;
	        }
	        let progressInRange = clamp(0, 1, progress(input[i], input[i + 1], t));
	        const segmentEasing = getEasingForSegment(easing, i);
	        progressInRange = segmentEasing(progressInRange);
	        return mix(output[i], output[i + 1], progressInRange);
	    };
	}

	const isCubicBezier = (easing) => Array.isArray(easing) && isNumber(easing[0]);

	const isEasingGenerator = (easing) => typeof easing === "object" &&
	    Boolean(easing.createAnimation);

	const isFunction = (value) => typeof value === "function";

	const isString = (value) => typeof value === "string";

	const time = {
	    ms: (seconds) => seconds * 1000,
	    s: (milliseconds) => milliseconds / 1000,
	};

	/*
	  Bezier function generator

	  This has been modified from Gaëtan Renaudeau's BezierEasing
	  https://github.com/gre/bezier-easing/blob/master/src/index.js
	  https://github.com/gre/bezier-easing/blob/master/LICENSE
	  
	  I've removed the newtonRaphsonIterate algo because in benchmarking it
	  wasn't noticiably faster than binarySubdivision, indeed removing it
	  usually improved times, depending on the curve.

	  I also removed the lookup table, as for the added bundle size and loop we're
	  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
	  to 12 to compensate and this still tended to be faster for no perceivable
	  loss in accuracy.

	  Usage
	    const easeOut = cubicBezier(.17,.67,.83,.67);
	    const x = easeOut(0.5); // returns 0.627...
	*/
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	const calcBezier = (t, a1, a2) => (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
	const subdivisionPrecision = 0.0000001;
	const subdivisionMaxIterations = 12;
	function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
	    let currentX;
	    let currentT;
	    let i = 0;
	    do {
	        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
	        currentX = calcBezier(currentT, mX1, mX2) - x;
	        if (currentX > 0.0) {
	            upperBound = currentT;
	        }
	        else {
	            lowerBound = currentT;
	        }
	    } while (Math.abs(currentX) > subdivisionPrecision &&
	        ++i < subdivisionMaxIterations);
	    return currentT;
	}
	function cubicBezier(mX1, mY1, mX2, mY2) {
	    // If this is a linear gradient, return linear easing
	    if (mX1 === mY1 && mX2 === mY2)
	        return noopReturn;
	    const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
	    // If animation is at start/end, return t without easing
	    return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
	}

	const steps = (steps, direction = "end") => (progress) => {
	    progress =
	        direction === "end"
	            ? Math.min(progress, 0.999)
	            : Math.max(progress, 0.001);
	    const expanded = progress * steps;
	    const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
	    return clamp(0, 1, rounded / steps);
	};

	const namedEasings = {
	    ease: cubicBezier(0.25, 0.1, 0.25, 1.0),
	    "ease-in": cubicBezier(0.42, 0.0, 1.0, 1.0),
	    "ease-in-out": cubicBezier(0.42, 0.0, 0.58, 1.0),
	    "ease-out": cubicBezier(0.0, 0.0, 0.58, 1.0),
	};
	const functionArgsRegex = /\((.*?)\)/;
	function getEasingFunction(definition) {
	    // If already an easing function, return
	    if (isFunction(definition))
	        return definition;
	    // If an easing curve definition, return bezier function
	    if (isCubicBezier(definition))
	        return cubicBezier(...definition);
	    // If we have a predefined easing function, return
	    if (namedEasings[definition])
	        return namedEasings[definition];
	    // If this is a steps function, attempt to create easing curve
	    if (definition.startsWith("steps")) {
	        const args = functionArgsRegex.exec(definition);
	        if (args) {
	            const argsArray = args[1].split(",");
	            return steps(parseFloat(argsArray[0]), argsArray[1].trim());
	        }
	    }
	    return noopReturn;
	}

	class Animation {
	    constructor(output, keyframes = [0, 1], { easing, duration: initialDuration = defaults.duration, delay = defaults.delay, endDelay = defaults.endDelay, repeat = defaults.repeat, offset, direction = "normal", } = {}) {
	        this.startTime = null;
	        this.rate = 1;
	        this.t = 0;
	        this.cancelTimestamp = null;
	        this.easing = noopReturn;
	        this.duration = 0;
	        this.totalDuration = 0;
	        this.repeat = 0;
	        this.playState = "idle";
	        this.finished = new Promise((resolve, reject) => {
	            this.resolve = resolve;
	            this.reject = reject;
	        });
	        easing = easing || defaults.easing;
	        if (isEasingGenerator(easing)) {
	            const custom = easing.createAnimation(keyframes);
	            easing = custom.easing;
	            keyframes = custom.keyframes || keyframes;
	            initialDuration = custom.duration || initialDuration;
	        }
	        this.repeat = repeat;
	        this.easing = isEasingList(easing) ? noopReturn : getEasingFunction(easing);
	        this.updateDuration(initialDuration);
	        const interpolate$1 = interpolate(keyframes, offset, isEasingList(easing) ? easing.map(getEasingFunction) : noopReturn);
	        this.tick = (timestamp) => {
	            var _a;
	            // TODO: Temporary fix for OptionsResolver typing
	            delay = delay;
	            let t = 0;
	            if (this.pauseTime !== undefined) {
	                t = this.pauseTime;
	            }
	            else {
	                t = (timestamp - this.startTime) * this.rate;
	            }
	            this.t = t;
	            // Convert to seconds
	            t /= 1000;
	            // Rebase on delay
	            t = Math.max(t - delay, 0);
	            /**
	             * If this animation has finished, set the current time
	             * to the total duration.
	             */
	            if (this.playState === "finished" && this.pauseTime === undefined) {
	                t = this.totalDuration;
	            }
	            /**
	             * Get the current progress (0-1) of the animation. If t is >
	             * than duration we'll get values like 2.5 (midway through the
	             * third iteration)
	             */
	            const progress = t / this.duration;
	            // TODO progress += iterationStart
	            /**
	             * Get the current iteration (0 indexed). For instance the floor of
	             * 2.5 is 2.
	             */
	            let currentIteration = Math.floor(progress);
	            /**
	             * Get the current progress of the iteration by taking the remainder
	             * so 2.5 is 0.5 through iteration 2
	             */
	            let iterationProgress = progress % 1.0;
	            if (!iterationProgress && progress >= 1) {
	                iterationProgress = 1;
	            }
	            /**
	             * If iteration progress is 1 we count that as the end
	             * of the previous iteration.
	             */
	            iterationProgress === 1 && currentIteration--;
	            /**
	             * Reverse progress if we're not running in "normal" direction
	             */
	            const iterationIsOdd = currentIteration % 2;
	            if (direction === "reverse" ||
	                (direction === "alternate" && iterationIsOdd) ||
	                (direction === "alternate-reverse" && !iterationIsOdd)) {
	                iterationProgress = 1 - iterationProgress;
	            }
	            const p = t >= this.totalDuration ? 1 : Math.min(iterationProgress, 1);
	            const latest = interpolate$1(this.easing(p));
	            output(latest);
	            const isAnimationFinished = this.pauseTime === undefined &&
	                (this.playState === "finished" || t >= this.totalDuration + endDelay);
	            if (isAnimationFinished) {
	                this.playState = "finished";
	                (_a = this.resolve) === null || _a === void 0 ? void 0 : _a.call(this, latest);
	            }
	            else if (this.playState !== "idle") {
	                this.frameRequestId = requestAnimationFrame(this.tick);
	            }
	        };
	        this.play();
	    }
	    play() {
	        const now = performance.now();
	        this.playState = "running";
	        if (this.pauseTime !== undefined) {
	            this.startTime = now - this.pauseTime;
	        }
	        else if (!this.startTime) {
	            this.startTime = now;
	        }
	        this.cancelTimestamp = this.startTime;
	        this.pauseTime = undefined;
	        this.frameRequestId = requestAnimationFrame(this.tick);
	    }
	    pause() {
	        this.playState = "paused";
	        this.pauseTime = this.t;
	    }
	    finish() {
	        this.playState = "finished";
	        this.tick(0);
	    }
	    stop() {
	        var _a;
	        this.playState = "idle";
	        if (this.frameRequestId !== undefined) {
	            cancelAnimationFrame(this.frameRequestId);
	        }
	        (_a = this.reject) === null || _a === void 0 ? void 0 : _a.call(this, false);
	    }
	    cancel() {
	        this.stop();
	        this.tick(this.cancelTimestamp);
	    }
	    reverse() {
	        this.rate *= -1;
	    }
	    commitStyles() { }
	    updateDuration(duration) {
	        this.duration = duration;
	        this.totalDuration = duration * (this.repeat + 1);
	    }
	    get currentTime() {
	        return this.t;
	    }
	    set currentTime(t) {
	        if (this.pauseTime !== undefined || this.rate === 0) {
	            this.pauseTime = t;
	        }
	        else {
	            this.startTime = performance.now() - t / this.rate;
	        }
	    }
	    get playbackRate() {
	        return this.rate;
	    }
	    set playbackRate(rate) {
	        this.rate = rate;
	    }
	}

	var invariant = function () { };
	{
	    invariant = function (check, message) {
	        if (!check) {
	            throw new Error(message);
	        }
	    };
	}

	/**
	 * The MotionValue tracks the state of a single animatable
	 * value. Currently, updatedAt and current are unused. The
	 * long term idea is to use this to minimise the number
	 * of DOM reads, and to abstract the DOM interactions here.
	 */
	class MotionValue {
	    setAnimation(animation) {
	        this.animation = animation;
	        animation === null || animation === void 0 ? void 0 : animation.finished.then(() => this.clearAnimation()).catch(() => { });
	    }
	    clearAnimation() {
	        this.animation = this.generator = undefined;
	    }
	}

	const data = new WeakMap();
	function getAnimationData(element) {
	    if (!data.has(element)) {
	        data.set(element, {
	            transforms: [],
	            values: new Map(),
	        });
	    }
	    return data.get(element);
	}
	function getMotionValue(motionValues, name) {
	    if (!motionValues.has(name)) {
	        motionValues.set(name, new MotionValue());
	    }
	    return motionValues.get(name);
	}

	/**
	 * A list of all transformable axes. We'll use this list to generated a version
	 * of each axes for each transform.
	 */
	const axes = ["", "X", "Y", "Z"];
	/**
	 * An ordered array of each transformable value. By default, transform values
	 * will be sorted to this order.
	 */
	const order = ["translate", "scale", "rotate", "skew"];
	const transformAlias = {
	    x: "translateX",
	    y: "translateY",
	    z: "translateZ",
	};
	const rotation = {
	    syntax: "<angle>",
	    initialValue: "0deg",
	    toDefaultUnit: (v) => v + "deg",
	};
	const baseTransformProperties = {
	    translate: {
	        syntax: "<length-percentage>",
	        initialValue: "0px",
	        toDefaultUnit: (v) => v + "px",
	    },
	    rotate: rotation,
	    scale: {
	        syntax: "<number>",
	        initialValue: 1,
	        toDefaultUnit: noopReturn,
	    },
	    skew: rotation,
	};
	const transformDefinitions = new Map();
	const asTransformCssVar = (name) => `--motion-${name}`;
	/**
	 * Generate a list of every possible transform key
	 */
	const transforms = ["x", "y", "z"];
	order.forEach((name) => {
	    axes.forEach((axis) => {
	        transforms.push(name + axis);
	        transformDefinitions.set(asTransformCssVar(name + axis), baseTransformProperties[name]);
	    });
	});
	/**
	 * A function to use with Array.sort to sort transform keys by their default order.
	 */
	const compareTransformOrder = (a, b) => transforms.indexOf(a) - transforms.indexOf(b);
	/**
	 * Provide a quick way to check if a string is the name of a transform
	 */
	const transformLookup = new Set(transforms);
	const isTransform = (name) => transformLookup.has(name);
	const addTransformToElement = (element, name) => {
	    // Map x to translateX etc
	    if (transformAlias[name])
	        name = transformAlias[name];
	    const { transforms } = getAnimationData(element);
	    addUniqueItem(transforms, name);
	    /**
	     * TODO: An optimisation here could be to cache the transform in element data
	     * and only update if this has changed.
	     */
	    element.style.transform = buildTransformTemplate(transforms);
	};
	const buildTransformTemplate = (transforms) => transforms
	    .sort(compareTransformOrder)
	    .reduce(transformListToString, "")
	    .trim();
	const transformListToString = (template, name) => `${template} ${name}(var(${asTransformCssVar(name)}))`;

	const isCssVar = (name) => name.startsWith("--");
	const registeredProperties = new Set();
	function registerCssVariable(name) {
	    if (registeredProperties.has(name))
	        return;
	    registeredProperties.add(name);
	    try {
	        const { syntax, initialValue } = transformDefinitions.has(name)
	            ? transformDefinitions.get(name)
	            : {};
	        CSS.registerProperty({
	            name,
	            inherits: false,
	            syntax,
	            initialValue,
	        });
	    }
	    catch (e) { }
	}

	const testAnimation = (keyframes, options) => document.createElement("div").animate(keyframes, options);
	const featureTests = {
	    cssRegisterProperty: () => typeof CSS !== "undefined" &&
	        Object.hasOwnProperty.call(CSS, "registerProperty"),
	    waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
	    partialKeyframes: () => {
	        try {
	            testAnimation({ opacity: [1] });
	        }
	        catch (e) {
	            return false;
	        }
	        return true;
	    },
	    finished: () => Boolean(testAnimation({ opacity: [0, 1] }, { duration: 0.001 }).finished),
	    linearEasing: () => {
	        try {
	            testAnimation({ opacity: 0 }, { easing: "linear(0, 1)" });
	        }
	        catch (e) {
	            return false;
	        }
	        return true;
	    },
	};
	const results = {};
	const supports = {};
	for (const key in featureTests) {
	    supports[key] = () => {
	        if (results[key] === undefined)
	            results[key] = featureTests[key]();
	        return results[key];
	    };
	}

	// Create a linear easing point for every x second
	const resolution = 0.015;
	const generateLinearEasingPoints = (easing, duration) => {
	    let points = "";
	    const numPoints = Math.round(duration / resolution);
	    for (let i = 0; i < numPoints; i++) {
	        points += easing(progress(0, numPoints - 1, i)) + ", ";
	    }
	    return points.substring(0, points.length - 2);
	};
	const convertEasing = (easing, duration) => {
	    if (isFunction(easing)) {
	        return supports.linearEasing()
	            ? `linear(${generateLinearEasingPoints(easing, duration)})`
	            : defaults.easing;
	    }
	    else {
	        return isCubicBezier(easing) ? cubicBezierAsString(easing) : easing;
	    }
	};
	const cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;

	function hydrateKeyframes(keyframes, readInitialValue) {
	    for (let i = 0; i < keyframes.length; i++) {
	        if (keyframes[i] === null) {
	            keyframes[i] = i ? keyframes[i - 1] : readInitialValue();
	        }
	    }
	    return keyframes;
	}
	const keyframesList = (keyframes) => Array.isArray(keyframes) ? keyframes : [keyframes];

	function getStyleName(key) {
	    if (transformAlias[key])
	        key = transformAlias[key];
	    return isTransform(key) ? asTransformCssVar(key) : key;
	}

	const style = {
	    get: (element, name) => {
	        name = getStyleName(name);
	        let value = isCssVar(name)
	            ? element.style.getPropertyValue(name)
	            : getComputedStyle(element)[name];
	        if (!value && value !== 0) {
	            const definition = transformDefinitions.get(name);
	            if (definition)
	                value = definition.initialValue;
	        }
	        return value;
	    },
	    set: (element, name, value) => {
	        name = getStyleName(name);
	        if (isCssVar(name)) {
	            element.style.setProperty(name, value);
	        }
	        else {
	            element.style[name] = value;
	        }
	    },
	};

	function stopAnimation(animation, needsCommit = true) {
	    if (!animation || animation.playState === "finished")
	        return;
	    // Suppress error thrown by WAAPI
	    try {
	        if (animation.stop) {
	            animation.stop();
	        }
	        else {
	            needsCommit && animation.commitStyles();
	            animation.cancel();
	        }
	    }
	    catch (e) { }
	}

	function getUnitConverter(keyframes, definition) {
	    var _a;
	    let toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || noopReturn;
	    const finalKeyframe = keyframes[keyframes.length - 1];
	    if (isString(finalKeyframe)) {
	        const unit = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
	        if (unit)
	            toUnit = (value) => value + unit;
	    }
	    return toUnit;
	}

	function getDevToolsRecord() {
	    return window.__MOTION_DEV_TOOLS_RECORD;
	}
	function animateStyle(element, key, keyframesDefinition, options = {}, AnimationPolyfill) {
	    const record = getDevToolsRecord();
	    const isRecording = options.record !== false && record;
	    let animation;
	    let { duration = defaults.duration, delay = defaults.delay, endDelay = defaults.endDelay, repeat = defaults.repeat, easing = defaults.easing, persist = false, direction, offset, allowWebkitAcceleration = false, } = options;
	    const data = getAnimationData(element);
	    const valueIsTransform = isTransform(key);
	    let canAnimateNatively = supports.waapi();
	    /**
	     * If this is an individual transform, we need to map its
	     * key to a CSS variable and update the element's transform style
	     */
	    valueIsTransform && addTransformToElement(element, key);
	    const name = getStyleName(key);
	    const motionValue = getMotionValue(data.values, name);
	    /**
	     * Get definition of value, this will be used to convert numerical
	     * keyframes into the default value type.
	     */
	    const definition = transformDefinitions.get(name);
	    /**
	     * Stop the current animation, if any. Because this will trigger
	     * commitStyles (DOM writes) and we might later trigger DOM reads,
	     * this is fired now and we return a factory function to create
	     * the actual animation that can get called in batch,
	     */
	    stopAnimation(motionValue.animation, !(isEasingGenerator(easing) && motionValue.generator) &&
	        options.record !== false);
	    /**
	     * Batchable factory function containing all DOM reads.
	     */
	    return () => {
	        const readInitialValue = () => { var _a, _b; return (_b = (_a = style.get(element, name)) !== null && _a !== void 0 ? _a : definition === null || definition === void 0 ? void 0 : definition.initialValue) !== null && _b !== void 0 ? _b : 0; };
	        /**
	         * Replace null values with the previous keyframe value, or read
	         * it from the DOM if it's the first keyframe.
	         */
	        let keyframes = hydrateKeyframes(keyframesList(keyframesDefinition), readInitialValue);
	        /**
	         * Detect unit type of keyframes.
	         */
	        const toUnit = getUnitConverter(keyframes, definition);
	        if (isEasingGenerator(easing)) {
	            const custom = easing.createAnimation(keyframes, key !== "opacity", readInitialValue, name, motionValue);
	            easing = custom.easing;
	            keyframes = custom.keyframes || keyframes;
	            duration = custom.duration || duration;
	        }
	        /**
	         * If this is a CSS variable we need to register it with the browser
	         * before it can be animated natively. We also set it with setProperty
	         * rather than directly onto the element.style object.
	         */
	        if (isCssVar(name)) {
	            if (supports.cssRegisterProperty()) {
	                registerCssVariable(name);
	            }
	            else {
	                canAnimateNatively = false;
	            }
	        }
	        /**
	         * If we've been passed a custom easing function, and this browser
	         * does **not** support linear() easing, and the value is a transform
	         * (and thus a pure number) we can still support the custom easing
	         * by falling back to the animation polyfill.
	         */
	        if (valueIsTransform &&
	            !supports.linearEasing() &&
	            (isFunction(easing) || (isEasingList(easing) && easing.some(isFunction)))) {
	            canAnimateNatively = false;
	        }
	        /**
	         * If we can animate this value with WAAPI, do so.
	         */
	        if (canAnimateNatively) {
	            /**
	             * Convert numbers to default value types. Currently this only supports
	             * transforms but it could also support other value types.
	             */
	            if (definition) {
	                keyframes = keyframes.map((value) => isNumber(value) ? definition.toDefaultUnit(value) : value);
	            }
	            /**
	             * If this browser doesn't support partial/implicit keyframes we need to
	             * explicitly provide one.
	             */
	            if (keyframes.length === 1 &&
	                (!supports.partialKeyframes() || isRecording)) {
	                keyframes.unshift(readInitialValue());
	            }
	            const animationOptions = {
	                delay: time.ms(delay),
	                duration: time.ms(duration),
	                endDelay: time.ms(endDelay),
	                easing: !isEasingList(easing)
	                    ? convertEasing(easing, duration)
	                    : undefined,
	                direction,
	                iterations: repeat + 1,
	                fill: "both",
	            };
	            animation = element.animate({
	                [name]: keyframes,
	                offset,
	                easing: isEasingList(easing)
	                    ? easing.map((thisEasing) => convertEasing(thisEasing, duration))
	                    : undefined,
	            }, animationOptions);
	            /**
	             * Polyfill finished Promise in browsers that don't support it
	             */
	            if (!animation.finished) {
	                animation.finished = new Promise((resolve, reject) => {
	                    animation.onfinish = resolve;
	                    animation.oncancel = reject;
	                });
	            }
	            const target = keyframes[keyframes.length - 1];
	            animation.finished
	                .then(() => {
	                if (persist)
	                    return;
	                // Apply styles to target
	                style.set(element, name, target);
	                // Ensure fill modes don't persist
	                animation.cancel();
	            })
	                .catch(noop);
	            /**
	             * This forces Webkit to run animations on the main thread by exploiting
	             * this condition:
	             * https://trac.webkit.org/browser/webkit/trunk/Source/WebCore/platform/graphics/ca/GraphicsLayerCA.cpp?rev=281238#L1099
	             *
	             * This fixes Webkit's timing bugs, like accelerated animations falling
	             * out of sync with main thread animations and massive delays in starting
	             * accelerated animations in WKWebView.
	             */
	            if (!allowWebkitAcceleration)
	                animation.playbackRate = 1.000001;
	            /**
	             * If we can't animate the value natively then we can fallback to the numbers-only
	             * polyfill for transforms.
	             */
	        }
	        else if (AnimationPolyfill && valueIsTransform) {
	            /**
	             * If any keyframe is a string (because we measured it from the DOM), we need to convert
	             * it into a number before passing to the Animation polyfill.
	             */
	            keyframes = keyframes.map((value) => typeof value === "string" ? parseFloat(value) : value);
	            /**
	             * If we only have a single keyframe, we need to create an initial keyframe by reading
	             * the current value from the DOM.
	             */
	            if (keyframes.length === 1) {
	                keyframes.unshift(parseFloat(readInitialValue()));
	            }
	            animation = new AnimationPolyfill((latest) => {
	                style.set(element, name, toUnit ? toUnit(latest) : latest);
	            }, keyframes, Object.assign(Object.assign({}, options), { duration,
	                easing }));
	        }
	        else {
	            const target = keyframes[keyframes.length - 1];
	            style.set(element, name, definition && isNumber(target)
	                ? definition.toDefaultUnit(target)
	                : target);
	        }
	        if (isRecording) {
	            record(element, key, keyframes, {
	                duration,
	                delay: delay,
	                easing,
	                repeat,
	                offset,
	            }, "motion-one");
	        }
	        motionValue.setAnimation(animation);
	        return animation;
	    };
	}

	const getOptions = (options, key) => 
	/**
	 * TODO: Make test for this
	 * Always return a new object otherwise delay is overwritten by results of stagger
	 * and this results in no stagger
	 */
	options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options);

	function resolveElements(elements, selectorCache) {
	    var _a;
	    if (typeof elements === "string") {
	        if (selectorCache) {
	            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : (selectorCache[elements] = document.querySelectorAll(elements));
	            elements = selectorCache[elements];
	        }
	        else {
	            elements = document.querySelectorAll(elements);
	        }
	    }
	    else if (elements instanceof Element) {
	        elements = [elements];
	    }
	    /**
	     * Return an empty array
	     */
	    return Array.from(elements || []);
	}

	const createAnimation = (factory) => factory();
	const withControls = (animationFactory, options, duration = defaults.duration) => {
	    return new Proxy({
	        animations: animationFactory.map(createAnimation).filter(Boolean),
	        duration,
	        options,
	    }, controls);
	};
	/**
	 * TODO:
	 * Currently this returns the first animation, ideally it would return
	 * the first active animation.
	 */
	const getActiveAnimation = (state) => state.animations[0];
	const controls = {
	    get: (target, key) => {
	        const activeAnimation = getActiveAnimation(target);
	        switch (key) {
	            case "duration":
	                return target.duration;
	            case "currentTime":
	                return time.s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
	            case "playbackRate":
	            case "playState":
	                return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
	            case "finished":
	                if (!target.finished) {
	                    target.finished = Promise.all(target.animations.map(selectFinished)).catch(noop);
	                }
	                return target.finished;
	            case "stop":
	                return () => {
	                    target.animations.forEach((animation) => stopAnimation(animation));
	                };
	            case "forEachNative":
	                /**
	                 * This is for internal use only, fire a callback for each
	                 * underlying animation.
	                 */
	                return (callback) => {
	                    target.animations.forEach((animation) => callback(animation, target));
	                };
	            default:
	                return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined"
	                    ? undefined
	                    : () => target.animations.forEach((animation) => animation[key]());
	        }
	    },
	    set: (target, key, value) => {
	        switch (key) {
	            case "currentTime":
	                value = time.ms(value);
	            case "currentTime":
	            case "playbackRate":
	                for (let i = 0; i < target.animations.length; i++) {
	                    target.animations[i][key] = value;
	                }
	                return true;
	        }
	        return false;
	    },
	};
	const selectFinished = (animation) => animation.finished;

	function resolveOption(option, i, total) {
	    return isFunction(option) ? option(i, total) : option;
	}

	function createAnimate(AnimatePolyfill) {
	    return function animate(elements, keyframes, options = {}) {
	        elements = resolveElements(elements);
	        const numElements = elements.length;
	        invariant(Boolean(numElements), "No valid element provided.");
	        invariant(Boolean(keyframes), "No keyframes defined.");
	        /**
	         * Create and start new animations
	         */
	        const animationFactories = [];
	        for (let i = 0; i < numElements; i++) {
	            const element = elements[i];
	            for (const key in keyframes) {
	                const valueOptions = getOptions(options, key);
	                valueOptions.delay = resolveOption(valueOptions.delay, i, numElements);
	                const animation = animateStyle(element, key, keyframes[key], valueOptions, AnimatePolyfill);
	                animationFactories.push(animation);
	            }
	        }
	        return withControls(animationFactories, options, 
	        /**
	         * TODO:
	         * If easing is set to spring or glide, duration will be dynamically
	         * generated. Ideally we would dynamically generate this from
	         * animation.effect.getComputedTiming().duration but this isn't
	         * supported in iOS13 or our number polyfill. Perhaps it's possible
	         * to Proxy animations returned from animateStyle that has duration
	         * as a getter.
	         */
	        options.duration);
	    };
	}

	const animate$1 = createAnimate(Animation);

	function animateProgress(target, options = {}) {
	    return withControls([
	        () => {
	            const animation = new Animation(target, [0, 1], options);
	            animation.finished.catch(() => { });
	            return animation;
	        },
	    ], options, options.duration);
	}
	function animate(target, keyframesOrOptions, options) {
	    const factory = isFunction(target) ? animateProgress : animate$1;
	    return factory(target, keyframesOrOptions, options);
	}

	/**
	 * @license
	 * Copyright 2018 Google LLC
	 * SPDX-License-Identifier: BSD-3-Clause
	 */const l=l=>null!=l?l:A$1;

	var browser = {};

	// can-promise has a crash in some versions of react native that dont have
	// standard global objects
	// https://github.com/soldair/node-qrcode/issues/157

	var canPromise$1 = function () {
	  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
	};

	var qrcode = {};

	var utils$1 = {};

	let toSJISFunction;
	const CODEWORDS_COUNT = [
	  0, // Not used
	  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
	  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
	  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
	  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
	];

	/**
	 * Returns the QR Code size for the specified version
	 *
	 * @param  {Number} version QR Code version
	 * @return {Number}         size of QR code
	 */
	utils$1.getSymbolSize = function getSymbolSize (version) {
	  if (!version) throw new Error('"version" cannot be null or undefined')
	  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
	  return version * 4 + 17
	};

	/**
	 * Returns the total number of codewords used to store data and EC information.
	 *
	 * @param  {Number} version QR Code version
	 * @return {Number}         Data length in bits
	 */
	utils$1.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
	  return CODEWORDS_COUNT[version]
	};

	/**
	 * Encode data with Bose-Chaudhuri-Hocquenghem
	 *
	 * @param  {Number} data Value to encode
	 * @return {Number}      Encoded value
	 */
	utils$1.getBCHDigit = function (data) {
	  let digit = 0;

	  while (data !== 0) {
	    digit++;
	    data >>>= 1;
	  }

	  return digit
	};

	utils$1.setToSJISFunction = function setToSJISFunction (f) {
	  if (typeof f !== 'function') {
	    throw new Error('"toSJISFunc" is not a valid function.')
	  }

	  toSJISFunction = f;
	};

	utils$1.isKanjiModeEnabled = function () {
	  return typeof toSJISFunction !== 'undefined'
	};

	utils$1.toSJIS = function toSJIS (kanji) {
	  return toSJISFunction(kanji)
	};

	var errorCorrectionLevel = {};

	(function (exports) {
		exports.L = { bit: 1 };
		exports.M = { bit: 0 };
		exports.Q = { bit: 3 };
		exports.H = { bit: 2 };

		function fromString (string) {
		  if (typeof string !== 'string') {
		    throw new Error('Param is not a string')
		  }

		  const lcStr = string.toLowerCase();

		  switch (lcStr) {
		    case 'l':
		    case 'low':
		      return exports.L

		    case 'm':
		    case 'medium':
		      return exports.M

		    case 'q':
		    case 'quartile':
		      return exports.Q

		    case 'h':
		    case 'high':
		      return exports.H

		    default:
		      throw new Error('Unknown EC Level: ' + string)
		  }
		}

		exports.isValid = function isValid (level) {
		  return level && typeof level.bit !== 'undefined' &&
		    level.bit >= 0 && level.bit < 4
		};

		exports.from = function from (value, defaultValue) {
		  if (exports.isValid(value)) {
		    return value
		  }

		  try {
		    return fromString(value)
		  } catch (e) {
		    return defaultValue
		  }
		}; 
	} (errorCorrectionLevel));

	function BitBuffer$1 () {
	  this.buffer = [];
	  this.length = 0;
	}

	BitBuffer$1.prototype = {

	  get: function (index) {
	    const bufIndex = Math.floor(index / 8);
	    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
	  },

	  put: function (num, length) {
	    for (let i = 0; i < length; i++) {
	      this.putBit(((num >>> (length - i - 1)) & 1) === 1);
	    }
	  },

	  getLengthInBits: function () {
	    return this.length
	  },

	  putBit: function (bit) {
	    const bufIndex = Math.floor(this.length / 8);
	    if (this.buffer.length <= bufIndex) {
	      this.buffer.push(0);
	    }

	    if (bit) {
	      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8));
	    }

	    this.length++;
	  }
	};

	var bitBuffer = BitBuffer$1;

	/**
	 * Helper class to handle QR Code symbol modules
	 *
	 * @param {Number} size Symbol size
	 */

	function BitMatrix$1 (size) {
	  if (!size || size < 1) {
	    throw new Error('BitMatrix size must be defined and greater than 0')
	  }

	  this.size = size;
	  this.data = new Uint8Array(size * size);
	  this.reservedBit = new Uint8Array(size * size);
	}

	/**
	 * Set bit value at specified location
	 * If reserved flag is set, this bit will be ignored during masking process
	 *
	 * @param {Number}  row
	 * @param {Number}  col
	 * @param {Boolean} value
	 * @param {Boolean} reserved
	 */
	BitMatrix$1.prototype.set = function (row, col, value, reserved) {
	  const index = row * this.size + col;
	  this.data[index] = value;
	  if (reserved) this.reservedBit[index] = true;
	};

	/**
	 * Returns bit value at specified location
	 *
	 * @param  {Number}  row
	 * @param  {Number}  col
	 * @return {Boolean}
	 */
	BitMatrix$1.prototype.get = function (row, col) {
	  return this.data[row * this.size + col]
	};

	/**
	 * Applies xor operator at specified location
	 * (used during masking process)
	 *
	 * @param {Number}  row
	 * @param {Number}  col
	 * @param {Boolean} value
	 */
	BitMatrix$1.prototype.xor = function (row, col, value) {
	  this.data[row * this.size + col] ^= value;
	};

	/**
	 * Check if bit at specified location is reserved
	 *
	 * @param {Number}   row
	 * @param {Number}   col
	 * @return {Boolean}
	 */
	BitMatrix$1.prototype.isReserved = function (row, col) {
	  return this.reservedBit[row * this.size + col]
	};

	var bitMatrix = BitMatrix$1;

	var alignmentPattern = {};

	/**
	 * Alignment pattern are fixed reference pattern in defined positions
	 * in a matrix symbology, which enables the decode software to re-synchronise
	 * the coordinate mapping of the image modules in the event of moderate amounts
	 * of distortion of the image.
	 *
	 * Alignment patterns are present only in QR Code symbols of version 2 or larger
	 * and their number depends on the symbol version.
	 */

	(function (exports) {
		const getSymbolSize = utils$1.getSymbolSize;

		/**
		 * Calculate the row/column coordinates of the center module of each alignment pattern
		 * for the specified QR Code version.
		 *
		 * The alignment patterns are positioned symmetrically on either side of the diagonal
		 * running from the top left corner of the symbol to the bottom right corner.
		 *
		 * Since positions are simmetrical only half of the coordinates are returned.
		 * Each item of the array will represent in turn the x and y coordinate.
		 * @see {@link getPositions}
		 *
		 * @param  {Number} version QR Code version
		 * @return {Array}          Array of coordinate
		 */
		exports.getRowColCoords = function getRowColCoords (version) {
		  if (version === 1) return []

		  const posCount = Math.floor(version / 7) + 2;
		  const size = getSymbolSize(version);
		  const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
		  const positions = [size - 7]; // Last coord is always (size - 7)

		  for (let i = 1; i < posCount - 1; i++) {
		    positions[i] = positions[i - 1] - intervals;
		  }

		  positions.push(6); // First coord is always 6

		  return positions.reverse()
		};

		/**
		 * Returns an array containing the positions of each alignment pattern.
		 * Each array's element represent the center point of the pattern as (x, y) coordinates
		 *
		 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
		 * and filtering out the items that overlaps with finder pattern
		 *
		 * @example
		 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
		 * The alignment patterns, therefore, are to be centered on (row, column)
		 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
		 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
		 * and are not therefore used for alignment patterns.
		 *
		 * let pos = getPositions(7)
		 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
		 *
		 * @param  {Number} version QR Code version
		 * @return {Array}          Array of coordinates
		 */
		exports.getPositions = function getPositions (version) {
		  const coords = [];
		  const pos = exports.getRowColCoords(version);
		  const posLength = pos.length;

		  for (let i = 0; i < posLength; i++) {
		    for (let j = 0; j < posLength; j++) {
		      // Skip if position is occupied by finder patterns
		      if ((i === 0 && j === 0) || // top-left
		          (i === 0 && j === posLength - 1) || // bottom-left
		          (i === posLength - 1 && j === 0)) { // top-right
		        continue
		      }

		      coords.push([pos[i], pos[j]]);
		    }
		  }

		  return coords
		}; 
	} (alignmentPattern));

	var finderPattern = {};

	const getSymbolSize = utils$1.getSymbolSize;
	const FINDER_PATTERN_SIZE = 7;

	/**
	 * Returns an array containing the positions of each finder pattern.
	 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
	 *
	 * @param  {Number} version QR Code version
	 * @return {Array}          Array of coordinates
	 */
	finderPattern.getPositions = function getPositions (version) {
	  const size = getSymbolSize(version);

	  return [
	    // top-left
	    [0, 0],
	    // top-right
	    [size - FINDER_PATTERN_SIZE, 0],
	    // bottom-left
	    [0, size - FINDER_PATTERN_SIZE]
	  ]
	};

	var maskPattern = {};

	/**
	 * Data mask pattern reference
	 * @type {Object}
	 */

	(function (exports) {
		exports.Patterns = {
		  PATTERN000: 0,
		  PATTERN001: 1,
		  PATTERN010: 2,
		  PATTERN011: 3,
		  PATTERN100: 4,
		  PATTERN101: 5,
		  PATTERN110: 6,
		  PATTERN111: 7
		};

		/**
		 * Weighted penalty scores for the undesirable features
		 * @type {Object}
		 */
		const PenaltyScores = {
		  N1: 3,
		  N2: 3,
		  N3: 40,
		  N4: 10
		};

		/**
		 * Check if mask pattern value is valid
		 *
		 * @param  {Number}  mask    Mask pattern
		 * @return {Boolean}         true if valid, false otherwise
		 */
		exports.isValid = function isValid (mask) {
		  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
		};

		/**
		 * Returns mask pattern from a value.
		 * If value is not valid, returns undefined
		 *
		 * @param  {Number|String} value        Mask pattern value
		 * @return {Number}                     Valid mask pattern or undefined
		 */
		exports.from = function from (value) {
		  return exports.isValid(value) ? parseInt(value, 10) : undefined
		};

		/**
		* Find adjacent modules in row/column with the same color
		* and assign a penalty value.
		*
		* Points: N1 + i
		* i is the amount by which the number of adjacent modules of the same color exceeds 5
		*/
		exports.getPenaltyN1 = function getPenaltyN1 (data) {
		  const size = data.size;
		  let points = 0;
		  let sameCountCol = 0;
		  let sameCountRow = 0;
		  let lastCol = null;
		  let lastRow = null;

		  for (let row = 0; row < size; row++) {
		    sameCountCol = sameCountRow = 0;
		    lastCol = lastRow = null;

		    for (let col = 0; col < size; col++) {
		      let module = data.get(row, col);
		      if (module === lastCol) {
		        sameCountCol++;
		      } else {
		        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
		        lastCol = module;
		        sameCountCol = 1;
		      }

		      module = data.get(col, row);
		      if (module === lastRow) {
		        sameCountRow++;
		      } else {
		        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
		        lastRow = module;
		        sameCountRow = 1;
		      }
		    }

		    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
		    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
		  }

		  return points
		};

		/**
		 * Find 2x2 blocks with the same color and assign a penalty value
		 *
		 * Points: N2 * (m - 1) * (n - 1)
		 */
		exports.getPenaltyN2 = function getPenaltyN2 (data) {
		  const size = data.size;
		  let points = 0;

		  for (let row = 0; row < size - 1; row++) {
		    for (let col = 0; col < size - 1; col++) {
		      const last = data.get(row, col) +
		        data.get(row, col + 1) +
		        data.get(row + 1, col) +
		        data.get(row + 1, col + 1);

		      if (last === 4 || last === 0) points++;
		    }
		  }

		  return points * PenaltyScores.N2
		};

		/**
		 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
		 * preceded or followed by light area 4 modules wide
		 *
		 * Points: N3 * number of pattern found
		 */
		exports.getPenaltyN3 = function getPenaltyN3 (data) {
		  const size = data.size;
		  let points = 0;
		  let bitsCol = 0;
		  let bitsRow = 0;

		  for (let row = 0; row < size; row++) {
		    bitsCol = bitsRow = 0;
		    for (let col = 0; col < size; col++) {
		      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col);
		      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;

		      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row);
		      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
		    }
		  }

		  return points * PenaltyScores.N3
		};

		/**
		 * Calculate proportion of dark modules in entire symbol
		 *
		 * Points: N4 * k
		 *
		 * k is the rating of the deviation of the proportion of dark modules
		 * in the symbol from 50% in steps of 5%
		 */
		exports.getPenaltyN4 = function getPenaltyN4 (data) {
		  let darkCount = 0;
		  const modulesCount = data.data.length;

		  for (let i = 0; i < modulesCount; i++) darkCount += data.data[i];

		  const k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10);

		  return k * PenaltyScores.N4
		};

		/**
		 * Return mask value at given position
		 *
		 * @param  {Number} maskPattern Pattern reference value
		 * @param  {Number} i           Row
		 * @param  {Number} j           Column
		 * @return {Boolean}            Mask value
		 */
		function getMaskAt (maskPattern, i, j) {
		  switch (maskPattern) {
		    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
		    case exports.Patterns.PATTERN001: return i % 2 === 0
		    case exports.Patterns.PATTERN010: return j % 3 === 0
		    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
		    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
		    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
		    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
		    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

		    default: throw new Error('bad maskPattern:' + maskPattern)
		  }
		}

		/**
		 * Apply a mask pattern to a BitMatrix
		 *
		 * @param  {Number}    pattern Pattern reference number
		 * @param  {BitMatrix} data    BitMatrix data
		 */
		exports.applyMask = function applyMask (pattern, data) {
		  const size = data.size;

		  for (let col = 0; col < size; col++) {
		    for (let row = 0; row < size; row++) {
		      if (data.isReserved(row, col)) continue
		      data.xor(row, col, getMaskAt(pattern, row, col));
		    }
		  }
		};

		/**
		 * Returns the best mask pattern for data
		 *
		 * @param  {BitMatrix} data
		 * @return {Number} Mask pattern reference number
		 */
		exports.getBestMask = function getBestMask (data, setupFormatFunc) {
		  const numPatterns = Object.keys(exports.Patterns).length;
		  let bestPattern = 0;
		  let lowerPenalty = Infinity;

		  for (let p = 0; p < numPatterns; p++) {
		    setupFormatFunc(p);
		    exports.applyMask(p, data);

		    // Calculate penalty
		    const penalty =
		      exports.getPenaltyN1(data) +
		      exports.getPenaltyN2(data) +
		      exports.getPenaltyN3(data) +
		      exports.getPenaltyN4(data);

		    // Undo previously applied mask
		    exports.applyMask(p, data);

		    if (penalty < lowerPenalty) {
		      lowerPenalty = penalty;
		      bestPattern = p;
		    }
		  }

		  return bestPattern
		}; 
	} (maskPattern));

	var errorCorrectionCode = {};

	const ECLevel$1 = errorCorrectionLevel;

	const EC_BLOCKS_TABLE = [
	// L  M  Q  H
	  1, 1, 1, 1,
	  1, 1, 1, 1,
	  1, 1, 2, 2,
	  1, 2, 2, 4,
	  1, 2, 4, 4,
	  2, 4, 4, 4,
	  2, 4, 6, 5,
	  2, 4, 6, 6,
	  2, 5, 8, 8,
	  4, 5, 8, 8,
	  4, 5, 8, 11,
	  4, 8, 10, 11,
	  4, 9, 12, 16,
	  4, 9, 16, 16,
	  6, 10, 12, 18,
	  6, 10, 17, 16,
	  6, 11, 16, 19,
	  6, 13, 18, 21,
	  7, 14, 21, 25,
	  8, 16, 20, 25,
	  8, 17, 23, 25,
	  9, 17, 23, 34,
	  9, 18, 25, 30,
	  10, 20, 27, 32,
	  12, 21, 29, 35,
	  12, 23, 34, 37,
	  12, 25, 34, 40,
	  13, 26, 35, 42,
	  14, 28, 38, 45,
	  15, 29, 40, 48,
	  16, 31, 43, 51,
	  17, 33, 45, 54,
	  18, 35, 48, 57,
	  19, 37, 51, 60,
	  19, 38, 53, 63,
	  20, 40, 56, 66,
	  21, 43, 59, 70,
	  22, 45, 62, 74,
	  24, 47, 65, 77,
	  25, 49, 68, 81
	];

	const EC_CODEWORDS_TABLE = [
	// L  M  Q  H
	  7, 10, 13, 17,
	  10, 16, 22, 28,
	  15, 26, 36, 44,
	  20, 36, 52, 64,
	  26, 48, 72, 88,
	  36, 64, 96, 112,
	  40, 72, 108, 130,
	  48, 88, 132, 156,
	  60, 110, 160, 192,
	  72, 130, 192, 224,
	  80, 150, 224, 264,
	  96, 176, 260, 308,
	  104, 198, 288, 352,
	  120, 216, 320, 384,
	  132, 240, 360, 432,
	  144, 280, 408, 480,
	  168, 308, 448, 532,
	  180, 338, 504, 588,
	  196, 364, 546, 650,
	  224, 416, 600, 700,
	  224, 442, 644, 750,
	  252, 476, 690, 816,
	  270, 504, 750, 900,
	  300, 560, 810, 960,
	  312, 588, 870, 1050,
	  336, 644, 952, 1110,
	  360, 700, 1020, 1200,
	  390, 728, 1050, 1260,
	  420, 784, 1140, 1350,
	  450, 812, 1200, 1440,
	  480, 868, 1290, 1530,
	  510, 924, 1350, 1620,
	  540, 980, 1440, 1710,
	  570, 1036, 1530, 1800,
	  570, 1064, 1590, 1890,
	  600, 1120, 1680, 1980,
	  630, 1204, 1770, 2100,
	  660, 1260, 1860, 2220,
	  720, 1316, 1950, 2310,
	  750, 1372, 2040, 2430
	];

	/**
	 * Returns the number of error correction block that the QR Code should contain
	 * for the specified version and error correction level.
	 *
	 * @param  {Number} version              QR Code version
	 * @param  {Number} errorCorrectionLevel Error correction level
	 * @return {Number}                      Number of error correction blocks
	 */
	errorCorrectionCode.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
	  switch (errorCorrectionLevel) {
	    case ECLevel$1.L:
	      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
	    case ECLevel$1.M:
	      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
	    case ECLevel$1.Q:
	      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
	    case ECLevel$1.H:
	      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
	    default:
	      return undefined
	  }
	};

	/**
	 * Returns the number of error correction codewords to use for the specified
	 * version and error correction level.
	 *
	 * @param  {Number} version              QR Code version
	 * @param  {Number} errorCorrectionLevel Error correction level
	 * @return {Number}                      Number of error correction codewords
	 */
	errorCorrectionCode.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
	  switch (errorCorrectionLevel) {
	    case ECLevel$1.L:
	      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
	    case ECLevel$1.M:
	      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
	    case ECLevel$1.Q:
	      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
	    case ECLevel$1.H:
	      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
	    default:
	      return undefined
	  }
	};

	var polynomial = {};

	var galoisField = {};

	const EXP_TABLE = new Uint8Array(512);
	const LOG_TABLE = new Uint8Array(256)
	/**
	 * Precompute the log and anti-log tables for faster computation later
	 *
	 * For each possible value in the galois field 2^8, we will pre-compute
	 * the logarithm and anti-logarithm (exponential) of this value
	 *
	 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
	 */
	;(function initTables () {
	  let x = 1;
	  for (let i = 0; i < 255; i++) {
	    EXP_TABLE[i] = x;
	    LOG_TABLE[x] = i;

	    x <<= 1; // multiply by 2

	    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
	    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
	    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
	      x ^= 0x11D;
	    }
	  }

	  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
	  // stay inside the bounds (because we will mainly use this table for the multiplication of
	  // two GF numbers, no more).
	  // @see {@link mul}
	  for (let i = 255; i < 512; i++) {
	    EXP_TABLE[i] = EXP_TABLE[i - 255];
	  }
	}());

	/**
	 * Returns log value of n inside Galois Field
	 *
	 * @param  {Number} n
	 * @return {Number}
	 */
	galoisField.log = function log (n) {
	  if (n < 1) throw new Error('log(' + n + ')')
	  return LOG_TABLE[n]
	};

	/**
	 * Returns anti-log value of n inside Galois Field
	 *
	 * @param  {Number} n
	 * @return {Number}
	 */
	galoisField.exp = function exp (n) {
	  return EXP_TABLE[n]
	};

	/**
	 * Multiplies two number inside Galois Field
	 *
	 * @param  {Number} x
	 * @param  {Number} y
	 * @return {Number}
	 */
	galoisField.mul = function mul (x, y) {
	  if (x === 0 || y === 0) return 0

	  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
	  // @see {@link initTables}
	  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
	};

	(function (exports) {
		const GF = galoisField;

		/**
		 * Multiplies two polynomials inside Galois Field
		 *
		 * @param  {Uint8Array} p1 Polynomial
		 * @param  {Uint8Array} p2 Polynomial
		 * @return {Uint8Array}    Product of p1 and p2
		 */
		exports.mul = function mul (p1, p2) {
		  const coeff = new Uint8Array(p1.length + p2.length - 1);

		  for (let i = 0; i < p1.length; i++) {
		    for (let j = 0; j < p2.length; j++) {
		      coeff[i + j] ^= GF.mul(p1[i], p2[j]);
		    }
		  }

		  return coeff
		};

		/**
		 * Calculate the remainder of polynomials division
		 *
		 * @param  {Uint8Array} divident Polynomial
		 * @param  {Uint8Array} divisor  Polynomial
		 * @return {Uint8Array}          Remainder
		 */
		exports.mod = function mod (divident, divisor) {
		  let result = new Uint8Array(divident);

		  while ((result.length - divisor.length) >= 0) {
		    const coeff = result[0];

		    for (let i = 0; i < divisor.length; i++) {
		      result[i] ^= GF.mul(divisor[i], coeff);
		    }

		    // remove all zeros from buffer head
		    let offset = 0;
		    while (offset < result.length && result[offset] === 0) offset++;
		    result = result.slice(offset);
		  }

		  return result
		};

		/**
		 * Generate an irreducible generator polynomial of specified degree
		 * (used by Reed-Solomon encoder)
		 *
		 * @param  {Number} degree Degree of the generator polynomial
		 * @return {Uint8Array}    Buffer containing polynomial coefficients
		 */
		exports.generateECPolynomial = function generateECPolynomial (degree) {
		  let poly = new Uint8Array([1]);
		  for (let i = 0; i < degree; i++) {
		    poly = exports.mul(poly, new Uint8Array([1, GF.exp(i)]));
		  }

		  return poly
		}; 
	} (polynomial));

	const Polynomial = polynomial;

	function ReedSolomonEncoder$1 (degree) {
	  this.genPoly = undefined;
	  this.degree = degree;

	  if (this.degree) this.initialize(this.degree);
	}

	/**
	 * Initialize the encoder.
	 * The input param should correspond to the number of error correction codewords.
	 *
	 * @param  {Number} degree
	 */
	ReedSolomonEncoder$1.prototype.initialize = function initialize (degree) {
	  // create an irreducible generator polynomial
	  this.degree = degree;
	  this.genPoly = Polynomial.generateECPolynomial(this.degree);
	};

	/**
	 * Encodes a chunk of data
	 *
	 * @param  {Uint8Array} data Buffer containing input data
	 * @return {Uint8Array}      Buffer containing encoded data
	 */
	ReedSolomonEncoder$1.prototype.encode = function encode (data) {
	  if (!this.genPoly) {
	    throw new Error('Encoder not initialized')
	  }

	  // Calculate EC for this data block
	  // extends data size to data+genPoly size
	  const paddedData = new Uint8Array(data.length + this.degree);
	  paddedData.set(data);

	  // The error correction codewords are the remainder after dividing the data codewords
	  // by a generator polynomial
	  const remainder = Polynomial.mod(paddedData, this.genPoly);

	  // return EC data blocks (last n byte, where n is the degree of genPoly)
	  // If coefficients number in remainder are less than genPoly degree,
	  // pad with 0s to the left to reach the needed number of coefficients
	  const start = this.degree - remainder.length;
	  if (start > 0) {
	    const buff = new Uint8Array(this.degree);
	    buff.set(remainder, start);

	    return buff
	  }

	  return remainder
	};

	var reedSolomonEncoder = ReedSolomonEncoder$1;

	var version = {};

	var mode = {};

	var versionCheck = {};

	/**
	 * Check if QR Code version is valid
	 *
	 * @param  {Number}  version QR Code version
	 * @return {Boolean}         true if valid version, false otherwise
	 */

	versionCheck.isValid = function isValid (version) {
	  return !isNaN(version) && version >= 1 && version <= 40
	};

	var regex = {};

	const numeric = '[0-9]+';
	const alphanumeric = '[A-Z $%*+\\-./:]+';
	let kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
	  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
	  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
	  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+';
	kanji = kanji.replace(/u/g, '\\u');

	const byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+';

	regex.KANJI = new RegExp(kanji, 'g');
	regex.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
	regex.BYTE = new RegExp(byte, 'g');
	regex.NUMERIC = new RegExp(numeric, 'g');
	regex.ALPHANUMERIC = new RegExp(alphanumeric, 'g');

	const TEST_KANJI = new RegExp('^' + kanji + '$');
	const TEST_NUMERIC = new RegExp('^' + numeric + '$');
	const TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');

	regex.testKanji = function testKanji (str) {
	  return TEST_KANJI.test(str)
	};

	regex.testNumeric = function testNumeric (str) {
	  return TEST_NUMERIC.test(str)
	};

	regex.testAlphanumeric = function testAlphanumeric (str) {
	  return TEST_ALPHANUMERIC.test(str)
	};

	(function (exports) {
		const VersionCheck = versionCheck;
		const Regex = regex;

		/**
		 * Numeric mode encodes data from the decimal digit set (0 - 9)
		 * (byte values 30HEX to 39HEX).
		 * Normally, 3 data characters are represented by 10 bits.
		 *
		 * @type {Object}
		 */
		exports.NUMERIC = {
		  id: 'Numeric',
		  bit: 1 << 0,
		  ccBits: [10, 12, 14]
		};

		/**
		 * Alphanumeric mode encodes data from a set of 45 characters,
		 * i.e. 10 numeric digits (0 - 9),
		 *      26 alphabetic characters (A - Z),
		 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
		 * Normally, two input characters are represented by 11 bits.
		 *
		 * @type {Object}
		 */
		exports.ALPHANUMERIC = {
		  id: 'Alphanumeric',
		  bit: 1 << 1,
		  ccBits: [9, 11, 13]
		};

		/**
		 * In byte mode, data is encoded at 8 bits per character.
		 *
		 * @type {Object}
		 */
		exports.BYTE = {
		  id: 'Byte',
		  bit: 1 << 2,
		  ccBits: [8, 16, 16]
		};

		/**
		 * The Kanji mode efficiently encodes Kanji characters in accordance with
		 * the Shift JIS system based on JIS X 0208.
		 * The Shift JIS values are shifted from the JIS X 0208 values.
		 * JIS X 0208 gives details of the shift coded representation.
		 * Each two-byte character value is compacted to a 13-bit binary codeword.
		 *
		 * @type {Object}
		 */
		exports.KANJI = {
		  id: 'Kanji',
		  bit: 1 << 3,
		  ccBits: [8, 10, 12]
		};

		/**
		 * Mixed mode will contain a sequences of data in a combination of any of
		 * the modes described above
		 *
		 * @type {Object}
		 */
		exports.MIXED = {
		  bit: -1
		};

		/**
		 * Returns the number of bits needed to store the data length
		 * according to QR Code specifications.
		 *
		 * @param  {Mode}   mode    Data mode
		 * @param  {Number} version QR Code version
		 * @return {Number}         Number of bits
		 */
		exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
		  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

		  if (!VersionCheck.isValid(version)) {
		    throw new Error('Invalid version: ' + version)
		  }

		  if (version >= 1 && version < 10) return mode.ccBits[0]
		  else if (version < 27) return mode.ccBits[1]
		  return mode.ccBits[2]
		};

		/**
		 * Returns the most efficient mode to store the specified data
		 *
		 * @param  {String} dataStr Input data string
		 * @return {Mode}           Best mode
		 */
		exports.getBestModeForData = function getBestModeForData (dataStr) {
		  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
		  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
		  else if (Regex.testKanji(dataStr)) return exports.KANJI
		  else return exports.BYTE
		};

		/**
		 * Return mode name as string
		 *
		 * @param {Mode} mode Mode object
		 * @returns {String}  Mode name
		 */
		exports.toString = function toString (mode) {
		  if (mode && mode.id) return mode.id
		  throw new Error('Invalid mode')
		};

		/**
		 * Check if input param is a valid mode object
		 *
		 * @param   {Mode}    mode Mode object
		 * @returns {Boolean} True if valid mode, false otherwise
		 */
		exports.isValid = function isValid (mode) {
		  return mode && mode.bit && mode.ccBits
		};

		/**
		 * Get mode object from its name
		 *
		 * @param   {String} string Mode name
		 * @returns {Mode}          Mode object
		 */
		function fromString (string) {
		  if (typeof string !== 'string') {
		    throw new Error('Param is not a string')
		  }

		  const lcStr = string.toLowerCase();

		  switch (lcStr) {
		    case 'numeric':
		      return exports.NUMERIC
		    case 'alphanumeric':
		      return exports.ALPHANUMERIC
		    case 'kanji':
		      return exports.KANJI
		    case 'byte':
		      return exports.BYTE
		    default:
		      throw new Error('Unknown mode: ' + string)
		  }
		}

		/**
		 * Returns mode from a value.
		 * If value is not a valid mode, returns defaultValue
		 *
		 * @param  {Mode|String} value        Encoding mode
		 * @param  {Mode}        defaultValue Fallback value
		 * @return {Mode}                     Encoding mode
		 */
		exports.from = function from (value, defaultValue) {
		  if (exports.isValid(value)) {
		    return value
		  }

		  try {
		    return fromString(value)
		  } catch (e) {
		    return defaultValue
		  }
		}; 
	} (mode));

	(function (exports) {
		const Utils = utils$1;
		const ECCode = errorCorrectionCode;
		const ECLevel = errorCorrectionLevel;
		const Mode = mode;
		const VersionCheck = versionCheck;

		// Generator polynomial used to encode version information
		const G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0);
		const G18_BCH = Utils.getBCHDigit(G18);

		function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
		  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
		    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
		      return currentVersion
		    }
		  }

		  return undefined
		}

		function getReservedBitsCount (mode, version) {
		  // Character count indicator + mode indicator bits
		  return Mode.getCharCountIndicator(mode, version) + 4
		}

		function getTotalBitsFromDataArray (segments, version) {
		  let totalBits = 0;

		  segments.forEach(function (data) {
		    const reservedBits = getReservedBitsCount(data.mode, version);
		    totalBits += reservedBits + data.getBitsLength();
		  });

		  return totalBits
		}

		function getBestVersionForMixedData (segments, errorCorrectionLevel) {
		  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
		    const length = getTotalBitsFromDataArray(segments, currentVersion);
		    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
		      return currentVersion
		    }
		  }

		  return undefined
		}

		/**
		 * Returns version number from a value.
		 * If value is not a valid version, returns defaultValue
		 *
		 * @param  {Number|String} value        QR Code version
		 * @param  {Number}        defaultValue Fallback value
		 * @return {Number}                     QR Code version number
		 */
		exports.from = function from (value, defaultValue) {
		  if (VersionCheck.isValid(value)) {
		    return parseInt(value, 10)
		  }

		  return defaultValue
		};

		/**
		 * Returns how much data can be stored with the specified QR code version
		 * and error correction level
		 *
		 * @param  {Number} version              QR Code version (1-40)
		 * @param  {Number} errorCorrectionLevel Error correction level
		 * @param  {Mode}   mode                 Data mode
		 * @return {Number}                      Quantity of storable data
		 */
		exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
		  if (!VersionCheck.isValid(version)) {
		    throw new Error('Invalid QR Code version')
		  }

		  // Use Byte mode as default
		  if (typeof mode === 'undefined') mode = Mode.BYTE;

		  // Total codewords for this QR code version (Data + Error correction)
		  const totalCodewords = Utils.getSymbolTotalCodewords(version);

		  // Total number of error correction codewords
		  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);

		  // Total number of data codewords
		  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;

		  if (mode === Mode.MIXED) return dataTotalCodewordsBits

		  const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version);

		  // Return max number of storable codewords
		  switch (mode) {
		    case Mode.NUMERIC:
		      return Math.floor((usableBits / 10) * 3)

		    case Mode.ALPHANUMERIC:
		      return Math.floor((usableBits / 11) * 2)

		    case Mode.KANJI:
		      return Math.floor(usableBits / 13)

		    case Mode.BYTE:
		    default:
		      return Math.floor(usableBits / 8)
		  }
		};

		/**
		 * Returns the minimum version needed to contain the amount of data
		 *
		 * @param  {Segment} data                    Segment of data
		 * @param  {Number} [errorCorrectionLevel=H] Error correction level
		 * @param  {Mode} mode                       Data mode
		 * @return {Number}                          QR Code version
		 */
		exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
		  let seg;

		  const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M);

		  if (Array.isArray(data)) {
		    if (data.length > 1) {
		      return getBestVersionForMixedData(data, ecl)
		    }

		    if (data.length === 0) {
		      return 1
		    }

		    seg = data[0];
		  } else {
		    seg = data;
		  }

		  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
		};

		/**
		 * Returns version information with relative error correction bits
		 *
		 * The version information is included in QR Code symbols of version 7 or larger.
		 * It consists of an 18-bit sequence containing 6 data bits,
		 * with 12 error correction bits calculated using the (18, 6) Golay code.
		 *
		 * @param  {Number} version QR Code version
		 * @return {Number}         Encoded version info bits
		 */
		exports.getEncodedBits = function getEncodedBits (version) {
		  if (!VersionCheck.isValid(version) || version < 7) {
		    throw new Error('Invalid QR Code version')
		  }

		  let d = version << 12;

		  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
		    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH));
		  }

		  return (version << 12) | d
		}; 
	} (version));

	var formatInfo = {};

	const Utils$3 = utils$1;

	const G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0);
	const G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1);
	const G15_BCH = Utils$3.getBCHDigit(G15);

	/**
	 * Returns format information with relative error correction bits
	 *
	 * The format information is a 15-bit sequence containing 5 data bits,
	 * with 10 error correction bits calculated using the (15, 5) BCH code.
	 *
	 * @param  {Number} errorCorrectionLevel Error correction level
	 * @param  {Number} mask                 Mask pattern
	 * @return {Number}                      Encoded format information bits
	 */
	formatInfo.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
	  const data = ((errorCorrectionLevel.bit << 3) | mask);
	  let d = data << 10;

	  while (Utils$3.getBCHDigit(d) - G15_BCH >= 0) {
	    d ^= (G15 << (Utils$3.getBCHDigit(d) - G15_BCH));
	  }

	  // xor final data with mask pattern in order to ensure that
	  // no combination of Error Correction Level and data mask pattern
	  // will result in an all-zero data string
	  return ((data << 10) | d) ^ G15_MASK
	};

	var segments = {};

	const Mode$4 = mode;

	function NumericData (data) {
	  this.mode = Mode$4.NUMERIC;
	  this.data = data.toString();
	}

	NumericData.getBitsLength = function getBitsLength (length) {
	  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
	};

	NumericData.prototype.getLength = function getLength () {
	  return this.data.length
	};

	NumericData.prototype.getBitsLength = function getBitsLength () {
	  return NumericData.getBitsLength(this.data.length)
	};

	NumericData.prototype.write = function write (bitBuffer) {
	  let i, group, value;

	  // The input data string is divided into groups of three digits,
	  // and each group is converted to its 10-bit binary equivalent.
	  for (i = 0; i + 3 <= this.data.length; i += 3) {
	    group = this.data.substr(i, 3);
	    value = parseInt(group, 10);

	    bitBuffer.put(value, 10);
	  }

	  // If the number of input digits is not an exact multiple of three,
	  // the final one or two digits are converted to 4 or 7 bits respectively.
	  const remainingNum = this.data.length - i;
	  if (remainingNum > 0) {
	    group = this.data.substr(i);
	    value = parseInt(group, 10);

	    bitBuffer.put(value, remainingNum * 3 + 1);
	  }
	};

	var numericData = NumericData;

	const Mode$3 = mode;

	/**
	 * Array of characters available in alphanumeric mode
	 *
	 * As per QR Code specification, to each character
	 * is assigned a value from 0 to 44 which in this case coincides
	 * with the array index
	 *
	 * @type {Array}
	 */
	const ALPHA_NUM_CHARS = [
	  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
	  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
	  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
	  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
	];

	function AlphanumericData (data) {
	  this.mode = Mode$3.ALPHANUMERIC;
	  this.data = data;
	}

	AlphanumericData.getBitsLength = function getBitsLength (length) {
	  return 11 * Math.floor(length / 2) + 6 * (length % 2)
	};

	AlphanumericData.prototype.getLength = function getLength () {
	  return this.data.length
	};

	AlphanumericData.prototype.getBitsLength = function getBitsLength () {
	  return AlphanumericData.getBitsLength(this.data.length)
	};

	AlphanumericData.prototype.write = function write (bitBuffer) {
	  let i;

	  // Input data characters are divided into groups of two characters
	  // and encoded as 11-bit binary codes.
	  for (i = 0; i + 2 <= this.data.length; i += 2) {
	    // The character value of the first character is multiplied by 45
	    let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;

	    // The character value of the second digit is added to the product
	    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);

	    // The sum is then stored as 11-bit binary number
	    bitBuffer.put(value, 11);
	  }

	  // If the number of input data characters is not a multiple of two,
	  // the character value of the final character is encoded as a 6-bit binary number.
	  if (this.data.length % 2) {
	    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
	  }
	};

	var alphanumericData = AlphanumericData;

	var encodeUtf8$1 = function encodeUtf8 (input) {
	  var result = [];
	  var size = input.length;

	  for (var index = 0; index < size; index++) {
	    var point = input.charCodeAt(index);

	    if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
	      var second = input.charCodeAt(index + 1);

	      if (second >= 0xDC00 && second <= 0xDFFF) {
	        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	        point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
	        index += 1;
	      }
	    }

	    // US-ASCII
	    if (point < 0x80) {
	      result.push(point);
	      continue
	    }

	    // 2-byte UTF-8
	    if (point < 0x800) {
	      result.push((point >> 6) | 192);
	      result.push((point & 63) | 128);
	      continue
	    }

	    // 3-byte UTF-8
	    if (point < 0xD800 || (point >= 0xE000 && point < 0x10000)) {
	      result.push((point >> 12) | 224);
	      result.push(((point >> 6) & 63) | 128);
	      result.push((point & 63) | 128);
	      continue
	    }

	    // 4-byte UTF-8
	    if (point >= 0x10000 && point <= 0x10FFFF) {
	      result.push((point >> 18) | 240);
	      result.push(((point >> 12) & 63) | 128);
	      result.push(((point >> 6) & 63) | 128);
	      result.push((point & 63) | 128);
	      continue
	    }

	    // Invalid character
	    result.push(0xEF, 0xBF, 0xBD);
	  }

	  return new Uint8Array(result).buffer
	};

	const encodeUtf8 = encodeUtf8$1;
	const Mode$2 = mode;

	function ByteData (data) {
	  this.mode = Mode$2.BYTE;
	  if (typeof (data) === 'string') {
	    data = encodeUtf8(data);
	  }
	  this.data = new Uint8Array(data);
	}

	ByteData.getBitsLength = function getBitsLength (length) {
	  return length * 8
	};

	ByteData.prototype.getLength = function getLength () {
	  return this.data.length
	};

	ByteData.prototype.getBitsLength = function getBitsLength () {
	  return ByteData.getBitsLength(this.data.length)
	};

	ByteData.prototype.write = function (bitBuffer) {
	  for (let i = 0, l = this.data.length; i < l; i++) {
	    bitBuffer.put(this.data[i], 8);
	  }
	};

	var byteData = ByteData;

	const Mode$1 = mode;
	const Utils$2 = utils$1;

	function KanjiData (data) {
	  this.mode = Mode$1.KANJI;
	  this.data = data;
	}

	KanjiData.getBitsLength = function getBitsLength (length) {
	  return length * 13
	};

	KanjiData.prototype.getLength = function getLength () {
	  return this.data.length
	};

	KanjiData.prototype.getBitsLength = function getBitsLength () {
	  return KanjiData.getBitsLength(this.data.length)
	};

	KanjiData.prototype.write = function (bitBuffer) {
	  let i;

	  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
	  // These byte values are shifted from the JIS X 0208 values.
	  // JIS X 0208 gives details of the shift coded representation.
	  for (i = 0; i < this.data.length; i++) {
	    let value = Utils$2.toSJIS(this.data[i]);

	    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
	    if (value >= 0x8140 && value <= 0x9FFC) {
	      // Subtract 0x8140 from Shift JIS value
	      value -= 0x8140;

	    // For characters with Shift JIS values from 0xE040 to 0xEBBF
	    } else if (value >= 0xE040 && value <= 0xEBBF) {
	      // Subtract 0xC140 from Shift JIS value
	      value -= 0xC140;
	    } else {
	      throw new Error(
	        'Invalid SJIS character: ' + this.data[i] + '\n' +
	        'Make sure your charset is UTF-8')
	    }

	    // Multiply most significant byte of result by 0xC0
	    // and add least significant byte to product
	    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff);

	    // Convert result to a 13-bit binary string
	    bitBuffer.put(value, 13);
	  }
	};

	var kanjiData = KanjiData;

	var dijkstra = {exports: {}};

	(function (module) {

		/******************************************************************************
		 * Created 2008-08-19.
		 *
		 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
		 *
		 * Copyright (C) 2008
		 *   Wyatt Baldwin <self@wyattbaldwin.com>
		 *   All rights reserved
		 *
		 * Licensed under the MIT license.
		 *
		 *   http://www.opensource.org/licenses/mit-license.php
		 *
		 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
		 * THE SOFTWARE.
		 *****************************************************************************/
		var dijkstra = {
		  single_source_shortest_paths: function(graph, s, d) {
		    // Predecessor map for each node that has been encountered.
		    // node ID => predecessor node ID
		    var predecessors = {};

		    // Costs of shortest paths from s to all nodes encountered.
		    // node ID => cost
		    var costs = {};
		    costs[s] = 0;

		    // Costs of shortest paths from s to all nodes encountered; differs from
		    // `costs` in that it provides easy access to the node that currently has
		    // the known shortest path from s.
		    // XXX: Do we actually need both `costs` and `open`?
		    var open = dijkstra.PriorityQueue.make();
		    open.push(s, 0);

		    var closest,
		        u, v,
		        cost_of_s_to_u,
		        adjacent_nodes,
		        cost_of_e,
		        cost_of_s_to_u_plus_cost_of_e,
		        cost_of_s_to_v,
		        first_visit;
		    while (!open.empty()) {
		      // In the nodes remaining in graph that have a known cost from s,
		      // find the node, u, that currently has the shortest path from s.
		      closest = open.pop();
		      u = closest.value;
		      cost_of_s_to_u = closest.cost;

		      // Get nodes adjacent to u...
		      adjacent_nodes = graph[u] || {};

		      // ...and explore the edges that connect u to those nodes, updating
		      // the cost of the shortest paths to any or all of those nodes as
		      // necessary. v is the node across the current edge from u.
		      for (v in adjacent_nodes) {
		        if (adjacent_nodes.hasOwnProperty(v)) {
		          // Get the cost of the edge running from u to v.
		          cost_of_e = adjacent_nodes[v];

		          // Cost of s to u plus the cost of u to v across e--this is *a*
		          // cost from s to v that may or may not be less than the current
		          // known cost to v.
		          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

		          // If we haven't visited v yet OR if the current known cost from s to
		          // v is greater than the new cost we just found (cost of s to u plus
		          // cost of u to v across e), update v's cost in the cost list and
		          // update v's predecessor in the predecessor list (it's now u).
		          cost_of_s_to_v = costs[v];
		          first_visit = (typeof costs[v] === 'undefined');
		          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
		            costs[v] = cost_of_s_to_u_plus_cost_of_e;
		            open.push(v, cost_of_s_to_u_plus_cost_of_e);
		            predecessors[v] = u;
		          }
		        }
		      }
		    }

		    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
		      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
		      throw new Error(msg);
		    }

		    return predecessors;
		  },

		  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
		    var nodes = [];
		    var u = d;
		    while (u) {
		      nodes.push(u);
		      predecessors[u];
		      u = predecessors[u];
		    }
		    nodes.reverse();
		    return nodes;
		  },

		  find_path: function(graph, s, d) {
		    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
		    return dijkstra.extract_shortest_path_from_predecessor_list(
		      predecessors, d);
		  },

		  /**
		   * A very naive priority queue implementation.
		   */
		  PriorityQueue: {
		    make: function (opts) {
		      var T = dijkstra.PriorityQueue,
		          t = {},
		          key;
		      opts = opts || {};
		      for (key in T) {
		        if (T.hasOwnProperty(key)) {
		          t[key] = T[key];
		        }
		      }
		      t.queue = [];
		      t.sorter = opts.sorter || T.default_sorter;
		      return t;
		    },

		    default_sorter: function (a, b) {
		      return a.cost - b.cost;
		    },

		    /**
		     * Add a new item to the queue and ensure the highest priority element
		     * is at the front of the queue.
		     */
		    push: function (value, cost) {
		      var item = {value: value, cost: cost};
		      this.queue.push(item);
		      this.queue.sort(this.sorter);
		    },

		    /**
		     * Return the highest priority element in the queue.
		     */
		    pop: function () {
		      return this.queue.shift();
		    },

		    empty: function () {
		      return this.queue.length === 0;
		    }
		  }
		};


		// node.js module exports
		{
		  module.exports = dijkstra;
		} 
	} (dijkstra));

	var dijkstraExports = dijkstra.exports;

	(function (exports) {
		const Mode = mode;
		const NumericData = numericData;
		const AlphanumericData = alphanumericData;
		const ByteData = byteData;
		const KanjiData = kanjiData;
		const Regex = regex;
		const Utils = utils$1;
		const dijkstra = dijkstraExports;

		/**
		 * Returns UTF8 byte length
		 *
		 * @param  {String} str Input string
		 * @return {Number}     Number of byte
		 */
		function getStringByteLength (str) {
		  return unescape(encodeURIComponent(str)).length
		}

		/**
		 * Get a list of segments of the specified mode
		 * from a string
		 *
		 * @param  {Mode}   mode Segment mode
		 * @param  {String} str  String to process
		 * @return {Array}       Array of object with segments data
		 */
		function getSegments (regex, mode, str) {
		  const segments = [];
		  let result;

		  while ((result = regex.exec(str)) !== null) {
		    segments.push({
		      data: result[0],
		      index: result.index,
		      mode: mode,
		      length: result[0].length
		    });
		  }

		  return segments
		}

		/**
		 * Extracts a series of segments with the appropriate
		 * modes from a string
		 *
		 * @param  {String} dataStr Input string
		 * @return {Array}          Array of object with segments data
		 */
		function getSegmentsFromString (dataStr) {
		  const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr);
		  const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr);
		  let byteSegs;
		  let kanjiSegs;

		  if (Utils.isKanjiModeEnabled()) {
		    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr);
		    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr);
		  } else {
		    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr);
		    kanjiSegs = [];
		  }

		  const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);

		  return segs
		    .sort(function (s1, s2) {
		      return s1.index - s2.index
		    })
		    .map(function (obj) {
		      return {
		        data: obj.data,
		        mode: obj.mode,
		        length: obj.length
		      }
		    })
		}

		/**
		 * Returns how many bits are needed to encode a string of
		 * specified length with the specified mode
		 *
		 * @param  {Number} length String length
		 * @param  {Mode} mode     Segment mode
		 * @return {Number}        Bit length
		 */
		function getSegmentBitsLength (length, mode) {
		  switch (mode) {
		    case Mode.NUMERIC:
		      return NumericData.getBitsLength(length)
		    case Mode.ALPHANUMERIC:
		      return AlphanumericData.getBitsLength(length)
		    case Mode.KANJI:
		      return KanjiData.getBitsLength(length)
		    case Mode.BYTE:
		      return ByteData.getBitsLength(length)
		  }
		}

		/**
		 * Merges adjacent segments which have the same mode
		 *
		 * @param  {Array} segs Array of object with segments data
		 * @return {Array}      Array of object with segments data
		 */
		function mergeSegments (segs) {
		  return segs.reduce(function (acc, curr) {
		    const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
		    if (prevSeg && prevSeg.mode === curr.mode) {
		      acc[acc.length - 1].data += curr.data;
		      return acc
		    }

		    acc.push(curr);
		    return acc
		  }, [])
		}

		/**
		 * Generates a list of all possible nodes combination which
		 * will be used to build a segments graph.
		 *
		 * Nodes are divided by groups. Each group will contain a list of all the modes
		 * in which is possible to encode the given text.
		 *
		 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
		 * The group for '12345' will contain then 3 objects, one for each
		 * possible encoding mode.
		 *
		 * Each node represents a possible segment.
		 *
		 * @param  {Array} segs Array of object with segments data
		 * @return {Array}      Array of object with segments data
		 */
		function buildNodes (segs) {
		  const nodes = [];
		  for (let i = 0; i < segs.length; i++) {
		    const seg = segs[i];

		    switch (seg.mode) {
		      case Mode.NUMERIC:
		        nodes.push([seg,
		          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
		          { data: seg.data, mode: Mode.BYTE, length: seg.length }
		        ]);
		        break
		      case Mode.ALPHANUMERIC:
		        nodes.push([seg,
		          { data: seg.data, mode: Mode.BYTE, length: seg.length }
		        ]);
		        break
		      case Mode.KANJI:
		        nodes.push([seg,
		          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
		        ]);
		        break
		      case Mode.BYTE:
		        nodes.push([
		          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
		        ]);
		    }
		  }

		  return nodes
		}

		/**
		 * Builds a graph from a list of nodes.
		 * All segments in each node group will be connected with all the segments of
		 * the next group and so on.
		 *
		 * At each connection will be assigned a weight depending on the
		 * segment's byte length.
		 *
		 * @param  {Array} nodes    Array of object with segments data
		 * @param  {Number} version QR Code version
		 * @return {Object}         Graph of all possible segments
		 */
		function buildGraph (nodes, version) {
		  const table = {};
		  const graph = { start: {} };
		  let prevNodeIds = ['start'];

		  for (let i = 0; i < nodes.length; i++) {
		    const nodeGroup = nodes[i];
		    const currentNodeIds = [];

		    for (let j = 0; j < nodeGroup.length; j++) {
		      const node = nodeGroup[j];
		      const key = '' + i + j;

		      currentNodeIds.push(key);
		      table[key] = { node: node, lastCount: 0 };
		      graph[key] = {};

		      for (let n = 0; n < prevNodeIds.length; n++) {
		        const prevNodeId = prevNodeIds[n];

		        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
		          graph[prevNodeId][key] =
		            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
		            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);

		          table[prevNodeId].lastCount += node.length;
		        } else {
		          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;

		          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
		            4 + Mode.getCharCountIndicator(node.mode, version); // switch cost
		        }
		      }
		    }

		    prevNodeIds = currentNodeIds;
		  }

		  for (let n = 0; n < prevNodeIds.length; n++) {
		    graph[prevNodeIds[n]].end = 0;
		  }

		  return { map: graph, table: table }
		}

		/**
		 * Builds a segment from a specified data and mode.
		 * If a mode is not specified, the more suitable will be used.
		 *
		 * @param  {String} data             Input data
		 * @param  {Mode | String} modesHint Data mode
		 * @return {Segment}                 Segment
		 */
		function buildSingleSegment (data, modesHint) {
		  let mode;
		  const bestMode = Mode.getBestModeForData(data);

		  mode = Mode.from(modesHint, bestMode);

		  // Make sure data can be encoded
		  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
		    throw new Error('"' + data + '"' +
		      ' cannot be encoded with mode ' + Mode.toString(mode) +
		      '.\n Suggested mode is: ' + Mode.toString(bestMode))
		  }

		  // Use Mode.BYTE if Kanji support is disabled
		  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
		    mode = Mode.BYTE;
		  }

		  switch (mode) {
		    case Mode.NUMERIC:
		      return new NumericData(data)

		    case Mode.ALPHANUMERIC:
		      return new AlphanumericData(data)

		    case Mode.KANJI:
		      return new KanjiData(data)

		    case Mode.BYTE:
		      return new ByteData(data)
		  }
		}

		/**
		 * Builds a list of segments from an array.
		 * Array can contain Strings or Objects with segment's info.
		 *
		 * For each item which is a string, will be generated a segment with the given
		 * string and the more appropriate encoding mode.
		 *
		 * For each item which is an object, will be generated a segment with the given
		 * data and mode.
		 * Objects must contain at least the property "data".
		 * If property "mode" is not present, the more suitable mode will be used.
		 *
		 * @param  {Array} array Array of objects with segments data
		 * @return {Array}       Array of Segments
		 */
		exports.fromArray = function fromArray (array) {
		  return array.reduce(function (acc, seg) {
		    if (typeof seg === 'string') {
		      acc.push(buildSingleSegment(seg, null));
		    } else if (seg.data) {
		      acc.push(buildSingleSegment(seg.data, seg.mode));
		    }

		    return acc
		  }, [])
		};

		/**
		 * Builds an optimized sequence of segments from a string,
		 * which will produce the shortest possible bitstream.
		 *
		 * @param  {String} data    Input string
		 * @param  {Number} version QR Code version
		 * @return {Array}          Array of segments
		 */
		exports.fromString = function fromString (data, version) {
		  const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled());

		  const nodes = buildNodes(segs);
		  const graph = buildGraph(nodes, version);
		  const path = dijkstra.find_path(graph.map, 'start', 'end');

		  const optimizedSegs = [];
		  for (let i = 1; i < path.length - 1; i++) {
		    optimizedSegs.push(graph.table[path[i]].node);
		  }

		  return exports.fromArray(mergeSegments(optimizedSegs))
		};

		/**
		 * Splits a string in various segments with the modes which
		 * best represent their content.
		 * The produced segments are far from being optimized.
		 * The output of this function is only used to estimate a QR Code version
		 * which may contain the data.
		 *
		 * @param  {string} data Input string
		 * @return {Array}       Array of segments
		 */
		exports.rawSplit = function rawSplit (data) {
		  return exports.fromArray(
		    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
		  )
		}; 
	} (segments));

	const Utils$1 = utils$1;
	const ECLevel = errorCorrectionLevel;
	const BitBuffer = bitBuffer;
	const BitMatrix = bitMatrix;
	const AlignmentPattern = alignmentPattern;
	const FinderPattern = finderPattern;
	const MaskPattern = maskPattern;
	const ECCode = errorCorrectionCode;
	const ReedSolomonEncoder = reedSolomonEncoder;
	const Version = version;
	const FormatInfo = formatInfo;
	const Mode = mode;
	const Segments = segments;

	/**
	 * QRCode for JavaScript
	 *
	 * modified by Ryan Day for nodejs support
	 * Copyright (c) 2011 Ryan Day
	 *
	 * Licensed under the MIT license:
	 *   http://www.opensource.org/licenses/mit-license.php
	 *
	//---------------------------------------------------------------------
	// QRCode for JavaScript
	//
	// Copyright (c) 2009 Kazuhiko Arase
	//
	// URL: http://www.d-project.com/
	//
	// Licensed under the MIT license:
	//   http://www.opensource.org/licenses/mit-license.php
	//
	// The word "QR Code" is registered trademark of
	// DENSO WAVE INCORPORATED
	//   http://www.denso-wave.com/qrcode/faqpatent-e.html
	//
	//---------------------------------------------------------------------
	*/

	/**
	 * Add finder patterns bits to matrix
	 *
	 * @param  {BitMatrix} matrix  Modules matrix
	 * @param  {Number}    version QR Code version
	 */
	function setupFinderPattern (matrix, version) {
	  const size = matrix.size;
	  const pos = FinderPattern.getPositions(version);

	  for (let i = 0; i < pos.length; i++) {
	    const row = pos[i][0];
	    const col = pos[i][1];

	    for (let r = -1; r <= 7; r++) {
	      if (row + r <= -1 || size <= row + r) continue

	      for (let c = -1; c <= 7; c++) {
	        if (col + c <= -1 || size <= col + c) continue

	        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
	          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
	          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
	          matrix.set(row + r, col + c, true, true);
	        } else {
	          matrix.set(row + r, col + c, false, true);
	        }
	      }
	    }
	  }
	}

	/**
	 * Add timing pattern bits to matrix
	 *
	 * Note: this function must be called before {@link setupAlignmentPattern}
	 *
	 * @param  {BitMatrix} matrix Modules matrix
	 */
	function setupTimingPattern (matrix) {
	  const size = matrix.size;

	  for (let r = 8; r < size - 8; r++) {
	    const value = r % 2 === 0;
	    matrix.set(r, 6, value, true);
	    matrix.set(6, r, value, true);
	  }
	}

	/**
	 * Add alignment patterns bits to matrix
	 *
	 * Note: this function must be called after {@link setupTimingPattern}
	 *
	 * @param  {BitMatrix} matrix  Modules matrix
	 * @param  {Number}    version QR Code version
	 */
	function setupAlignmentPattern (matrix, version) {
	  const pos = AlignmentPattern.getPositions(version);

	  for (let i = 0; i < pos.length; i++) {
	    const row = pos[i][0];
	    const col = pos[i][1];

	    for (let r = -2; r <= 2; r++) {
	      for (let c = -2; c <= 2; c++) {
	        if (r === -2 || r === 2 || c === -2 || c === 2 ||
	          (r === 0 && c === 0)) {
	          matrix.set(row + r, col + c, true, true);
	        } else {
	          matrix.set(row + r, col + c, false, true);
	        }
	      }
	    }
	  }
	}

	/**
	 * Add version info bits to matrix
	 *
	 * @param  {BitMatrix} matrix  Modules matrix
	 * @param  {Number}    version QR Code version
	 */
	function setupVersionInfo (matrix, version) {
	  const size = matrix.size;
	  const bits = Version.getEncodedBits(version);
	  let row, col, mod;

	  for (let i = 0; i < 18; i++) {
	    row = Math.floor(i / 3);
	    col = i % 3 + size - 8 - 3;
	    mod = ((bits >> i) & 1) === 1;

	    matrix.set(row, col, mod, true);
	    matrix.set(col, row, mod, true);
	  }
	}

	/**
	 * Add format info bits to matrix
	 *
	 * @param  {BitMatrix} matrix               Modules matrix
	 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
	 * @param  {Number}    maskPattern          Mask pattern reference value
	 */
	function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
	  const size = matrix.size;
	  const bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern);
	  let i, mod;

	  for (i = 0; i < 15; i++) {
	    mod = ((bits >> i) & 1) === 1;

	    // vertical
	    if (i < 6) {
	      matrix.set(i, 8, mod, true);
	    } else if (i < 8) {
	      matrix.set(i + 1, 8, mod, true);
	    } else {
	      matrix.set(size - 15 + i, 8, mod, true);
	    }

	    // horizontal
	    if (i < 8) {
	      matrix.set(8, size - i - 1, mod, true);
	    } else if (i < 9) {
	      matrix.set(8, 15 - i - 1 + 1, mod, true);
	    } else {
	      matrix.set(8, 15 - i - 1, mod, true);
	    }
	  }

	  // fixed module
	  matrix.set(size - 8, 8, 1, true);
	}

	/**
	 * Add encoded data bits to matrix
	 *
	 * @param  {BitMatrix}  matrix Modules matrix
	 * @param  {Uint8Array} data   Data codewords
	 */
	function setupData (matrix, data) {
	  const size = matrix.size;
	  let inc = -1;
	  let row = size - 1;
	  let bitIndex = 7;
	  let byteIndex = 0;

	  for (let col = size - 1; col > 0; col -= 2) {
	    if (col === 6) col--;

	    while (true) {
	      for (let c = 0; c < 2; c++) {
	        if (!matrix.isReserved(row, col - c)) {
	          let dark = false;

	          if (byteIndex < data.length) {
	            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1);
	          }

	          matrix.set(row, col - c, dark);
	          bitIndex--;

	          if (bitIndex === -1) {
	            byteIndex++;
	            bitIndex = 7;
	          }
	        }
	      }

	      row += inc;

	      if (row < 0 || size <= row) {
	        row -= inc;
	        inc = -inc;
	        break
	      }
	    }
	  }
	}

	/**
	 * Create encoded codewords from data input
	 *
	 * @param  {Number}   version              QR Code version
	 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
	 * @param  {ByteData} data                 Data input
	 * @return {Uint8Array}                    Buffer containing encoded codewords
	 */
	function createData (version, errorCorrectionLevel, segments) {
	  // Prepare data buffer
	  const buffer = new BitBuffer();

	  segments.forEach(function (data) {
	    // prefix data with mode indicator (4 bits)
	    buffer.put(data.mode.bit, 4);

	    // Prefix data with character count indicator.
	    // The character count indicator is a string of bits that represents the
	    // number of characters that are being encoded.
	    // The character count indicator must be placed after the mode indicator
	    // and must be a certain number of bits long, depending on the QR version
	    // and data mode
	    // @see {@link Mode.getCharCountIndicator}.
	    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version));

	    // add binary data sequence to buffer
	    data.write(buffer);
	  });

	  // Calculate required number of bits
	  const totalCodewords = Utils$1.getSymbolTotalCodewords(version);
	  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
	  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;

	  // Add a terminator.
	  // If the bit string is shorter than the total number of required bits,
	  // a terminator of up to four 0s must be added to the right side of the string.
	  // If the bit string is more than four bits shorter than the required number of bits,
	  // add four 0s to the end.
	  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
	    buffer.put(0, 4);
	  }

	  // If the bit string is fewer than four bits shorter, add only the number of 0s that
	  // are needed to reach the required number of bits.

	  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
	  // pad the string on the right with 0s to make the string's length a multiple of 8.
	  while (buffer.getLengthInBits() % 8 !== 0) {
	    buffer.putBit(0);
	  }

	  // Add pad bytes if the string is still shorter than the total number of required bits.
	  // Extend the buffer to fill the data capacity of the symbol corresponding to
	  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
	  // and 00010001 (0x11) alternately.
	  const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
	  for (let i = 0; i < remainingByte; i++) {
	    buffer.put(i % 2 ? 0x11 : 0xEC, 8);
	  }

	  return createCodewords(buffer, version, errorCorrectionLevel)
	}

	/**
	 * Encode input data with Reed-Solomon and return codewords with
	 * relative error correction bits
	 *
	 * @param  {BitBuffer} bitBuffer            Data to encode
	 * @param  {Number}    version              QR Code version
	 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
	 * @return {Uint8Array}                     Buffer containing encoded codewords
	 */
	function createCodewords (bitBuffer, version, errorCorrectionLevel) {
	  // Total codewords for this QR code version (Data + Error correction)
	  const totalCodewords = Utils$1.getSymbolTotalCodewords(version);

	  // Total number of error correction codewords
	  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);

	  // Total number of data codewords
	  const dataTotalCodewords = totalCodewords - ecTotalCodewords;

	  // Total number of blocks
	  const ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel);

	  // Calculate how many blocks each group should contain
	  const blocksInGroup2 = totalCodewords % ecTotalBlocks;
	  const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;

	  const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);

	  const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
	  const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;

	  // Number of EC codewords is the same for both groups
	  const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;

	  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
	  const rs = new ReedSolomonEncoder(ecCount);

	  let offset = 0;
	  const dcData = new Array(ecTotalBlocks);
	  const ecData = new Array(ecTotalBlocks);
	  let maxDataSize = 0;
	  const buffer = new Uint8Array(bitBuffer.buffer);

	  // Divide the buffer into the required number of blocks
	  for (let b = 0; b < ecTotalBlocks; b++) {
	    const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;

	    // extract a block of data from buffer
	    dcData[b] = buffer.slice(offset, offset + dataSize);

	    // Calculate EC codewords for this data block
	    ecData[b] = rs.encode(dcData[b]);

	    offset += dataSize;
	    maxDataSize = Math.max(maxDataSize, dataSize);
	  }

	  // Create final data
	  // Interleave the data and error correction codewords from each block
	  const data = new Uint8Array(totalCodewords);
	  let index = 0;
	  let i, r;

	  // Add data codewords
	  for (i = 0; i < maxDataSize; i++) {
	    for (r = 0; r < ecTotalBlocks; r++) {
	      if (i < dcData[r].length) {
	        data[index++] = dcData[r][i];
	      }
	    }
	  }

	  // Apped EC codewords
	  for (i = 0; i < ecCount; i++) {
	    for (r = 0; r < ecTotalBlocks; r++) {
	      data[index++] = ecData[r][i];
	    }
	  }

	  return data
	}

	/**
	 * Build QR Code symbol
	 *
	 * @param  {String} data                 Input string
	 * @param  {Number} version              QR Code version
	 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
	 * @param  {MaskPattern} maskPattern     Mask pattern
	 * @return {Object}                      Object containing symbol data
	 */
	function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
	  let segments;

	  if (Array.isArray(data)) {
	    segments = Segments.fromArray(data);
	  } else if (typeof data === 'string') {
	    let estimatedVersion = version;

	    if (!estimatedVersion) {
	      const rawSegments = Segments.rawSplit(data);

	      // Estimate best version that can contain raw splitted segments
	      estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel);
	    }

	    // Build optimized segments
	    // If estimated version is undefined, try with the highest version
	    segments = Segments.fromString(data, estimatedVersion || 40);
	  } else {
	    throw new Error('Invalid data')
	  }

	  // Get the min version that can contain data
	  const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel);

	  // If no version is found, data cannot be stored
	  if (!bestVersion) {
	    throw new Error('The amount of data is too big to be stored in a QR Code')
	  }

	  // If not specified, use min version as default
	  if (!version) {
	    version = bestVersion;

	  // Check if the specified version can contain the data
	  } else if (version < bestVersion) {
	    throw new Error('\n' +
	      'The chosen QR Code version cannot contain this amount of data.\n' +
	      'Minimum version required to store current data is: ' + bestVersion + '.\n'
	    )
	  }

	  const dataBits = createData(version, errorCorrectionLevel, segments);

	  // Allocate matrix buffer
	  const moduleCount = Utils$1.getSymbolSize(version);
	  const modules = new BitMatrix(moduleCount);

	  // Add function modules
	  setupFinderPattern(modules, version);
	  setupTimingPattern(modules);
	  setupAlignmentPattern(modules, version);

	  // Add temporary dummy bits for format info just to set them as reserved.
	  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
	  // since the masking operation must be performed only on the encoding region.
	  // These blocks will be replaced with correct values later in code.
	  setupFormatInfo(modules, errorCorrectionLevel, 0);

	  if (version >= 7) {
	    setupVersionInfo(modules, version);
	  }

	  // Add data codewords
	  setupData(modules, dataBits);

	  if (isNaN(maskPattern)) {
	    // Find best mask pattern
	    maskPattern = MaskPattern.getBestMask(modules,
	      setupFormatInfo.bind(null, modules, errorCorrectionLevel));
	  }

	  // Apply mask pattern
	  MaskPattern.applyMask(maskPattern, modules);

	  // Replace format info bits with correct values
	  setupFormatInfo(modules, errorCorrectionLevel, maskPattern);

	  return {
	    modules: modules,
	    version: version,
	    errorCorrectionLevel: errorCorrectionLevel,
	    maskPattern: maskPattern,
	    segments: segments
	  }
	}

	/**
	 * QR Code
	 *
	 * @param {String | Array} data                 Input data
	 * @param {Object} options                      Optional configurations
	 * @param {Number} options.version              QR Code version
	 * @param {String} options.errorCorrectionLevel Error correction level
	 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
	 */
	qrcode.create = function create (data, options) {
	  if (typeof data === 'undefined' || data === '') {
	    throw new Error('No input text')
	  }

	  let errorCorrectionLevel = ECLevel.M;
	  let version;
	  let mask;

	  if (typeof options !== 'undefined') {
	    // Use higher error correction level as default
	    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M);
	    version = Version.from(options.version);
	    mask = MaskPattern.from(options.maskPattern);

	    if (options.toSJISFunc) {
	      Utils$1.setToSJISFunction(options.toSJISFunc);
	    }
	  }

	  return createSymbol(data, version, errorCorrectionLevel, mask)
	};

	var canvas = {};

	var utils = {};

	(function (exports) {
		function hex2rgba (hex) {
		  if (typeof hex === 'number') {
		    hex = hex.toString();
		  }

		  if (typeof hex !== 'string') {
		    throw new Error('Color should be defined as hex string')
		  }

		  let hexCode = hex.slice().replace('#', '').split('');
		  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
		    throw new Error('Invalid hex color: ' + hex)
		  }

		  // Convert from short to long form (fff -> ffffff)
		  if (hexCode.length === 3 || hexCode.length === 4) {
		    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
		      return [c, c]
		    }));
		  }

		  // Add default alpha value
		  if (hexCode.length === 6) hexCode.push('F', 'F');

		  const hexValue = parseInt(hexCode.join(''), 16);

		  return {
		    r: (hexValue >> 24) & 255,
		    g: (hexValue >> 16) & 255,
		    b: (hexValue >> 8) & 255,
		    a: hexValue & 255,
		    hex: '#' + hexCode.slice(0, 6).join('')
		  }
		}

		exports.getOptions = function getOptions (options) {
		  if (!options) options = {};
		  if (!options.color) options.color = {};

		  const margin = typeof options.margin === 'undefined' ||
		    options.margin === null ||
		    options.margin < 0
		    ? 4
		    : options.margin;

		  const width = options.width && options.width >= 21 ? options.width : undefined;
		  const scale = options.scale || 4;

		  return {
		    width: width,
		    scale: width ? 4 : scale,
		    margin: margin,
		    color: {
		      dark: hex2rgba(options.color.dark || '#000000ff'),
		      light: hex2rgba(options.color.light || '#ffffffff')
		    },
		    type: options.type,
		    rendererOpts: options.rendererOpts || {}
		  }
		};

		exports.getScale = function getScale (qrSize, opts) {
		  return opts.width && opts.width >= qrSize + opts.margin * 2
		    ? opts.width / (qrSize + opts.margin * 2)
		    : opts.scale
		};

		exports.getImageWidth = function getImageWidth (qrSize, opts) {
		  const scale = exports.getScale(qrSize, opts);
		  return Math.floor((qrSize + opts.margin * 2) * scale)
		};

		exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
		  const size = qr.modules.size;
		  const data = qr.modules.data;
		  const scale = exports.getScale(size, opts);
		  const symbolSize = Math.floor((size + opts.margin * 2) * scale);
		  const scaledMargin = opts.margin * scale;
		  const palette = [opts.color.light, opts.color.dark];

		  for (let i = 0; i < symbolSize; i++) {
		    for (let j = 0; j < symbolSize; j++) {
		      let posDst = (i * symbolSize + j) * 4;
		      let pxColor = opts.color.light;

		      if (i >= scaledMargin && j >= scaledMargin &&
		        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
		        const iSrc = Math.floor((i - scaledMargin) / scale);
		        const jSrc = Math.floor((j - scaledMargin) / scale);
		        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
		      }

		      imgData[posDst++] = pxColor.r;
		      imgData[posDst++] = pxColor.g;
		      imgData[posDst++] = pxColor.b;
		      imgData[posDst] = pxColor.a;
		    }
		  }
		}; 
	} (utils));

	(function (exports) {
		const Utils = utils;

		function clearCanvas (ctx, canvas, size) {
		  ctx.clearRect(0, 0, canvas.width, canvas.height);

		  if (!canvas.style) canvas.style = {};
		  canvas.height = size;
		  canvas.width = size;
		  canvas.style.height = size + 'px';
		  canvas.style.width = size + 'px';
		}

		function getCanvasElement () {
		  try {
		    return document.createElement('canvas')
		  } catch (e) {
		    throw new Error('You need to specify a canvas element')
		  }
		}

		exports.render = function render (qrData, canvas, options) {
		  let opts = options;
		  let canvasEl = canvas;

		  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
		    opts = canvas;
		    canvas = undefined;
		  }

		  if (!canvas) {
		    canvasEl = getCanvasElement();
		  }

		  opts = Utils.getOptions(opts);
		  const size = Utils.getImageWidth(qrData.modules.size, opts);

		  const ctx = canvasEl.getContext('2d');
		  const image = ctx.createImageData(size, size);
		  Utils.qrToImageData(image.data, qrData, opts);

		  clearCanvas(ctx, canvasEl, size);
		  ctx.putImageData(image, 0, 0);

		  return canvasEl
		};

		exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
		  let opts = options;

		  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
		    opts = canvas;
		    canvas = undefined;
		  }

		  if (!opts) opts = {};

		  const canvasEl = exports.render(qrData, canvas, opts);

		  const type = opts.type || 'image/png';
		  const rendererOpts = opts.rendererOpts || {};

		  return canvasEl.toDataURL(type, rendererOpts.quality)
		}; 
	} (canvas));

	var svgTag = {};

	const Utils = utils;

	function getColorAttrib (color, attrib) {
	  const alpha = color.a / 255;
	  const str = attrib + '="' + color.hex + '"';

	  return alpha < 1
	    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
	    : str
	}

	function svgCmd (cmd, x, y) {
	  let str = cmd + x;
	  if (typeof y !== 'undefined') str += ' ' + y;

	  return str
	}

	function qrToPath (data, size, margin) {
	  let path = '';
	  let moveBy = 0;
	  let newRow = false;
	  let lineLength = 0;

	  for (let i = 0; i < data.length; i++) {
	    const col = Math.floor(i % size);
	    const row = Math.floor(i / size);

	    if (!col && !newRow) newRow = true;

	    if (data[i]) {
	      lineLength++;

	      if (!(i > 0 && col > 0 && data[i - 1])) {
	        path += newRow
	          ? svgCmd('M', col + margin, 0.5 + row + margin)
	          : svgCmd('m', moveBy, 0);

	        moveBy = 0;
	        newRow = false;
	      }

	      if (!(col + 1 < size && data[i + 1])) {
	        path += svgCmd('h', lineLength);
	        lineLength = 0;
	      }
	    } else {
	      moveBy++;
	    }
	  }

	  return path
	}

	svgTag.render = function render (qrData, options, cb) {
	  const opts = Utils.getOptions(options);
	  const size = qrData.modules.size;
	  const data = qrData.modules.data;
	  const qrcodesize = size + opts.margin * 2;

	  const bg = !opts.color.light.a
	    ? ''
	    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
	      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';

	  const path =
	    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
	    ' d="' + qrToPath(data, size, opts.margin) + '"/>';

	  const viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"';

	  const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';

	  const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';

	  if (typeof cb === 'function') {
	    cb(null, svgTag);
	  }

	  return svgTag
	};

	const canPromise = canPromise$1;

	const QRCode = qrcode;
	const CanvasRenderer = canvas;
	const SvgRenderer = svgTag;

	function renderCanvas (renderFunc, canvas, text, opts, cb) {
	  const args = [].slice.call(arguments, 1);
	  const argsNum = args.length;
	  const isLastArgCb = typeof args[argsNum - 1] === 'function';

	  if (!isLastArgCb && !canPromise()) {
	    throw new Error('Callback required as last argument')
	  }

	  if (isLastArgCb) {
	    if (argsNum < 2) {
	      throw new Error('Too few arguments provided')
	    }

	    if (argsNum === 2) {
	      cb = text;
	      text = canvas;
	      canvas = opts = undefined;
	    } else if (argsNum === 3) {
	      if (canvas.getContext && typeof cb === 'undefined') {
	        cb = opts;
	        opts = undefined;
	      } else {
	        cb = opts;
	        opts = text;
	        text = canvas;
	        canvas = undefined;
	      }
	    }
	  } else {
	    if (argsNum < 1) {
	      throw new Error('Too few arguments provided')
	    }

	    if (argsNum === 1) {
	      text = canvas;
	      canvas = opts = undefined;
	    } else if (argsNum === 2 && !canvas.getContext) {
	      opts = text;
	      text = canvas;
	      canvas = undefined;
	    }

	    return new Promise(function (resolve, reject) {
	      try {
	        const data = QRCode.create(text, opts);
	        resolve(renderFunc(data, canvas, opts));
	      } catch (e) {
	        reject(e);
	      }
	    })
	  }

	  try {
	    const data = QRCode.create(text, opts);
	    cb(null, renderFunc(data, canvas, opts));
	  } catch (e) {
	    cb(e);
	  }
	}

	browser.create = QRCode.create;
	browser.toCanvas = renderCanvas.bind(null, CanvasRenderer.render);
	browser.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL);

	// only svg for now.
	browser.toString = renderCanvas.bind(null, function (data, _, opts) {
	  return SvgRenderer.render(data, opts)
	});

	var et=Object.defineProperty,Be=Object.getOwnPropertySymbols,tt=Object.prototype.hasOwnProperty,ot=Object.prototype.propertyIsEnumerable,Ue=(e,o,r)=>o in e?et(e,o,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[o]=r,ve=(e,o)=>{for(var r in o||(o={}))tt.call(o,r)&&Ue(e,r,o[r]);if(Be)for(var r of Be(o))ot.call(o,r)&&Ue(e,r,o[r]);return e};function rt(){var e;const o=(e=X.state.themeMode)!=null?e:"dark",r={light:{foreground:{1:"rgb(20,20,20)",2:"rgb(121,134,134)",3:"rgb(158,169,169)"},background:{1:"rgb(255,255,255)",2:"rgb(241,243,243)",3:"rgb(228,231,231)"},overlay:"rgba(0,0,0,0.1)"},dark:{foreground:{1:"rgb(228,231,231)",2:"rgb(148,158,158)",3:"rgb(110,119,119)"},background:{1:"rgb(20,20,20)",2:"rgb(39,42,42)",3:"rgb(59,64,64)"},overlay:"rgba(255,255,255,0.1)"}}[o];return {"--wcm-color-fg-1":r.foreground[1],"--wcm-color-fg-2":r.foreground[2],"--wcm-color-fg-3":r.foreground[3],"--wcm-color-bg-1":r.background[1],"--wcm-color-bg-2":r.background[2],"--wcm-color-bg-3":r.background[3],"--wcm-color-overlay":r.overlay}}function He(){return {"--wcm-accent-color":"#3396FF","--wcm-accent-fill-color":"#FFFFFF","--wcm-z-index":"89","--wcm-background-color":"#3396FF","--wcm-background-border-radius":"8px","--wcm-container-border-radius":"30px","--wcm-wallet-icon-border-radius":"15px","--wcm-wallet-icon-large-border-radius":"30px","--wcm-wallet-icon-small-border-radius":"7px","--wcm-input-border-radius":"28px","--wcm-button-border-radius":"10px","--wcm-notification-border-radius":"36px","--wcm-secondary-button-border-radius":"28px","--wcm-icon-button-border-radius":"50%","--wcm-button-hover-highlight-border-radius":"10px","--wcm-text-big-bold-size":"20px","--wcm-text-big-bold-weight":"600","--wcm-text-big-bold-line-height":"24px","--wcm-text-big-bold-letter-spacing":"-0.03em","--wcm-text-big-bold-text-transform":"none","--wcm-text-xsmall-bold-size":"10px","--wcm-text-xsmall-bold-weight":"700","--wcm-text-xsmall-bold-line-height":"12px","--wcm-text-xsmall-bold-letter-spacing":"0.02em","--wcm-text-xsmall-bold-text-transform":"uppercase","--wcm-text-xsmall-regular-size":"12px","--wcm-text-xsmall-regular-weight":"600","--wcm-text-xsmall-regular-line-height":"14px","--wcm-text-xsmall-regular-letter-spacing":"-0.03em","--wcm-text-xsmall-regular-text-transform":"none","--wcm-text-small-thin-size":"14px","--wcm-text-small-thin-weight":"500","--wcm-text-small-thin-line-height":"16px","--wcm-text-small-thin-letter-spacing":"-0.03em","--wcm-text-small-thin-text-transform":"none","--wcm-text-small-regular-size":"14px","--wcm-text-small-regular-weight":"600","--wcm-text-small-regular-line-height":"16px","--wcm-text-small-regular-letter-spacing":"-0.03em","--wcm-text-small-regular-text-transform":"none","--wcm-text-medium-regular-size":"16px","--wcm-text-medium-regular-weight":"600","--wcm-text-medium-regular-line-height":"20px","--wcm-text-medium-regular-letter-spacing":"-0.03em","--wcm-text-medium-regular-text-transform":"none","--wcm-font-family":"-apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, 'Helvetica Neue', sans-serif","--wcm-font-feature-settings":"'tnum' on, 'lnum' on, 'case' on","--wcm-success-color":"rgb(38,181,98)","--wcm-error-color":"rgb(242, 90, 103)","--wcm-overlay-background-color":"rgba(0, 0, 0, 0.3)","--wcm-overlay-backdrop-filter":"none"}}const h={getPreset(e){return He()[e]},setTheme(){const e=document.querySelector(":root"),{themeVariables:o}=X.state;if(e){const r=ve(ve(ve({},rt()),He()),o);Object.entries(r).forEach(([a,t])=>e.style.setProperty(a,t));}},globalCss:i$3`*,::after,::before{margin:0;padding:0;box-sizing:border-box;font-style:normal;text-rendering:optimizeSpeed;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-tap-highlight-color:transparent;backface-visibility:hidden}button{cursor:pointer;display:flex;justify-content:center;align-items:center;position:relative;border:none;background-color:transparent;transition:all .2s ease}@media (hover:hover) and (pointer:fine){button:active{transition:all .1s ease;transform:scale(.93)}}button::after{content:'';position:absolute;top:0;bottom:0;left:0;right:0;transition:background-color,.2s ease}button:disabled{cursor:not-allowed}button svg,button wcm-text{position:relative;z-index:1}input{border:none;outline:0;appearance:none}img{display:block}::selection{color:var(--wcm-accent-fill-color);background:var(--wcm-accent-color)}`},at=i$3`button{border-radius:var(--wcm-secondary-button-border-radius);height:28px;padding:0 10px;background-color:var(--wcm-accent-color)}button path{fill:var(--wcm-accent-fill-color)}button::after{border-radius:inherit;border:1px solid var(--wcm-color-overlay)}button:disabled::after{background-color:transparent}.wcm-icon-left svg{margin-right:5px}.wcm-icon-right svg{margin-left:5px}button:active::after{background-color:var(--wcm-color-overlay)}.wcm-ghost,.wcm-ghost:active::after,.wcm-outline{background-color:transparent}.wcm-ghost:active{opacity:.5}@media(hover:hover){button:hover::after{background-color:var(--wcm-color-overlay)}.wcm-ghost:hover::after{background-color:transparent}.wcm-ghost:hover{opacity:.5}}button:disabled{background-color:var(--wcm-color-bg-3);pointer-events:none}.wcm-ghost::after{border-color:transparent}.wcm-ghost path{fill:var(--wcm-color-fg-2)}.wcm-outline path{fill:var(--wcm-accent-color)}.wcm-outline:disabled{background-color:transparent;opacity:.5}`;var lt=Object.defineProperty,it=Object.getOwnPropertyDescriptor,F=(e,o,r,a)=>{for(var t=a>1?void 0:a?it(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&lt(o,r,t),t};let T=class extends s{constructor(){super(...arguments),this.disabled=!1,this.iconLeft=void 0,this.iconRight=void 0,this.onClick=()=>null,this.variant="default";}render(){const e={"wcm-icon-left":this.iconLeft!==void 0,"wcm-icon-right":this.iconRight!==void 0,"wcm-ghost":this.variant==="ghost","wcm-outline":this.variant==="outline"};let o$1="inverse";return this.variant==="ghost"&&(o$1="secondary"),this.variant==="outline"&&(o$1="accent"),x`<button class="${o(e)}" ?disabled="${this.disabled}" @click="${this.onClick}">${this.iconLeft}<wcm-text variant="small-regular" color="${o$1}"><slot></slot></wcm-text>${this.iconRight}</button>`}};T.styles=[h.globalCss,at],F([n$1({type:Boolean})],T.prototype,"disabled",2),F([n$1()],T.prototype,"iconLeft",2),F([n$1()],T.prototype,"iconRight",2),F([n$1()],T.prototype,"onClick",2),F([n$1()],T.prototype,"variant",2),T=F([e$2("wcm-button")],T);const nt=i$3`:host{display:inline-block}button{padding:0 15px 1px;height:40px;border-radius:var(--wcm-button-border-radius);color:var(--wcm-accent-fill-color);background-color:var(--wcm-accent-color)}button::after{content:'';top:0;bottom:0;left:0;right:0;position:absolute;background-color:transparent;border-radius:inherit;transition:background-color .2s ease;border:1px solid var(--wcm-color-overlay)}button:active::after{background-color:var(--wcm-color-overlay)}button:disabled{padding-bottom:0;background-color:var(--wcm-color-bg-3);color:var(--wcm-color-fg-3)}.wcm-secondary{color:var(--wcm-accent-color);background-color:transparent}.wcm-secondary::after{display:none}@media(hover:hover){button:hover::after{background-color:var(--wcm-color-overlay)}}`;var ct=Object.defineProperty,st=Object.getOwnPropertyDescriptor,ue=(e,o,r,a)=>{for(var t=a>1?void 0:a?st(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&ct(o,r,t),t};let ee=class extends s{constructor(){super(...arguments),this.disabled=!1,this.variant="primary";}render(){const e={"wcm-secondary":this.variant==="secondary"};return x`<button ?disabled="${this.disabled}" class="${o(e)}"><slot></slot></button>`}};ee.styles=[h.globalCss,nt],ue([n$1({type:Boolean})],ee.prototype,"disabled",2),ue([n$1()],ee.prototype,"variant",2),ee=ue([e$2("wcm-button-big")],ee);const dt=i$3`:host{background-color:var(--wcm-color-bg-2);border-top:1px solid var(--wcm-color-bg-3)}div{padding:10px 20px;display:inherit;flex-direction:inherit;align-items:inherit;width:inherit;justify-content:inherit}`;var mt=Object.defineProperty,ht=Object.getOwnPropertyDescriptor,wt=(e,o,r,a)=>{for(var t=a>1?void 0:a?ht(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&mt(o,r,t),t};let be=class extends s{render(){return x`<div><slot></slot></div>`}};be.styles=[h.globalCss,dt],be=wt([e$2("wcm-info-footer")],be);const v={CROSS_ICON:b`<svg width="12" height="12" viewBox="0 0 12 12"><path d="M9.94 11A.75.75 0 1 0 11 9.94L7.414 6.353a.5.5 0 0 1 0-.708L11 2.061A.75.75 0 1 0 9.94 1L6.353 4.586a.5.5 0 0 1-.708 0L2.061 1A.75.75 0 0 0 1 2.06l3.586 3.586a.5.5 0 0 1 0 .708L1 9.939A.75.75 0 1 0 2.06 11l3.586-3.586a.5.5 0 0 1 .708 0L9.939 11Z" fill="#fff"/></svg>`,WALLET_CONNECT_LOGO:b`<svg width="178" height="29" viewBox="0 0 178 29" id="wcm-wc-logo"><path d="M10.683 7.926c5.284-5.17 13.85-5.17 19.134 0l.636.623a.652.652 0 0 1 0 .936l-2.176 2.129a.343.343 0 0 1-.478 0l-.875-.857c-3.686-3.607-9.662-3.607-13.348 0l-.937.918a.343.343 0 0 1-.479 0l-2.175-2.13a.652.652 0 0 1 0-.936l.698-.683Zm23.633 4.403 1.935 1.895a.652.652 0 0 1 0 .936l-8.73 8.543a.687.687 0 0 1-.956 0L20.37 17.64a.172.172 0 0 0-.239 0l-6.195 6.063a.687.687 0 0 1-.957 0l-8.73-8.543a.652.652 0 0 1 0-.936l1.936-1.895a.687.687 0 0 1 .957 0l6.196 6.064a.172.172 0 0 0 .239 0l6.195-6.064a.687.687 0 0 1 .957 0l6.196 6.064a.172.172 0 0 0 .24 0l6.195-6.064a.687.687 0 0 1 .956 0ZM48.093 20.948l2.338-9.355c.139-.515.258-1.07.416-1.942.12.872.258 1.427.357 1.942l2.022 9.355h4.181l3.528-13.874h-3.21l-1.943 8.523a24.825 24.825 0 0 0-.456 2.457c-.158-.931-.317-1.625-.495-2.438l-1.883-8.542h-4.201l-2.042 8.542a41.204 41.204 0 0 0-.475 2.438 41.208 41.208 0 0 0-.476-2.438l-1.903-8.542h-3.349l3.508 13.874h4.083ZM63.33 21.304c1.585 0 2.596-.654 3.11-1.605-.059.297-.078.595-.078.892v.357h2.655V15.22c0-2.735-1.248-4.32-4.3-4.32-2.636 0-4.36 1.466-4.52 3.487h2.914c.1-.891.734-1.426 1.705-1.426.911 0 1.407.515 1.407 1.11 0 .435-.258.693-1.03.792l-1.388.159c-2.061.257-3.825 1.01-3.825 3.19 0 1.982 1.645 3.092 3.35 3.092Zm.891-2.041c-.773 0-1.348-.436-1.348-1.19 0-.733.655-1.09 1.645-1.268l.674-.119c.575-.118.892-.218 1.09-.396v.912c0 1.228-.892 2.06-2.06 2.06ZM70.398 7.074v13.874h2.874V7.074h-2.874ZM74.934 7.074v13.874h2.874V7.074h-2.874ZM84.08 21.304c2.735 0 4.5-1.546 4.697-3.567h-2.893c-.139.892-.892 1.387-1.804 1.387-1.228 0-2.12-.99-2.14-2.358h6.897v-.555c0-3.21-1.764-5.312-4.816-5.312-2.933 0-4.994 2.062-4.994 5.173 0 3.37 2.12 5.232 5.053 5.232Zm-2.16-6.421c.119-1.11.932-1.922 2.081-1.922 1.11 0 1.883.772 1.903 1.922H81.92ZM94.92 21.146c.633 0 1.248-.1 1.525-.179v-2.18c-.218.04-.475.06-.693.06-1.05 0-1.427-.595-1.427-1.566v-3.805h2.338v-2.24h-2.338V7.788H91.47v3.448H89.37v2.24h2.1v4.201c0 2.3 1.15 3.469 3.45 3.469ZM104.62 21.304c3.924 0 6.302-2.299 6.599-5.608h-3.111c-.238 1.803-1.506 3.032-3.369 3.032-2.2 0-3.746-1.784-3.746-4.796 0-2.953 1.605-4.638 3.805-4.638 1.883 0 2.953 1.15 3.171 2.834h3.191c-.317-3.448-2.854-5.41-6.342-5.41-3.984 0-7.036 2.695-7.036 7.214 0 4.677 2.676 7.372 6.838 7.372ZM117.449 21.304c2.993 0 5.114-1.882 5.114-5.172 0-3.23-2.121-5.233-5.114-5.233-2.972 0-5.093 2.002-5.093 5.233 0 3.29 2.101 5.172 5.093 5.172Zm0-2.22c-1.327 0-2.18-1.09-2.18-2.952 0-1.903.892-2.973 2.18-2.973 1.308 0 2.2 1.07 2.2 2.973 0 1.862-.872 2.953-2.2 2.953ZM126.569 20.948v-5.689c0-1.208.753-2.1 1.823-2.1 1.011 0 1.606.773 1.606 2.06v5.729h2.873v-6.144c0-2.339-1.229-3.905-3.428-3.905-1.526 0-2.458.734-2.953 1.606a5.31 5.31 0 0 0 .079-.892v-.377h-2.874v9.712h2.874ZM137.464 20.948v-5.689c0-1.208.753-2.1 1.823-2.1 1.011 0 1.606.773 1.606 2.06v5.729h2.873v-6.144c0-2.339-1.228-3.905-3.428-3.905-1.526 0-2.458.734-2.953 1.606a5.31 5.31 0 0 0 .079-.892v-.377h-2.874v9.712h2.874ZM149.949 21.304c2.735 0 4.499-1.546 4.697-3.567h-2.893c-.139.892-.892 1.387-1.804 1.387-1.228 0-2.12-.99-2.14-2.358h6.897v-.555c0-3.21-1.764-5.312-4.816-5.312-2.933 0-4.994 2.062-4.994 5.173 0 3.37 2.12 5.232 5.053 5.232Zm-2.16-6.421c.119-1.11.932-1.922 2.081-1.922 1.11 0 1.883.772 1.903 1.922h-3.984ZM160.876 21.304c3.013 0 4.658-1.645 4.975-4.201h-2.874c-.099 1.07-.713 1.982-2.001 1.982-1.309 0-2.2-1.21-2.2-2.993 0-1.942 1.03-2.933 2.259-2.933 1.209 0 1.803.872 1.883 1.882h2.873c-.218-2.358-1.823-4.142-4.776-4.142-2.874 0-5.153 1.903-5.153 5.193 0 3.25 1.923 5.212 5.014 5.212ZM172.067 21.146c.634 0 1.248-.1 1.526-.179v-2.18c-.218.04-.476.06-.694.06-1.05 0-1.427-.595-1.427-1.566v-3.805h2.339v-2.24h-2.339V7.788h-2.854v3.448h-2.1v2.24h2.1v4.201c0 2.3 1.15 3.469 3.449 3.469Z" fill="#fff"/></svg>`,WALLET_CONNECT_ICON:b`<svg width="28" height="20" viewBox="0 0 28 20"><g clip-path="url(#a)"><path d="M7.386 6.482c3.653-3.576 9.575-3.576 13.228 0l.44.43a.451.451 0 0 1 0 .648L19.55 9.033a.237.237 0 0 1-.33 0l-.606-.592c-2.548-2.496-6.68-2.496-9.228 0l-.648.634a.237.237 0 0 1-.33 0L6.902 7.602a.451.451 0 0 1 0-.647l.483-.473Zm16.338 3.046 1.339 1.31a.451.451 0 0 1 0 .648l-6.035 5.909a.475.475 0 0 1-.662 0L14.083 13.2a.119.119 0 0 0-.166 0l-4.283 4.194a.475.475 0 0 1-.662 0l-6.035-5.91a.451.451 0 0 1 0-.647l1.338-1.31a.475.475 0 0 1 .662 0l4.283 4.194c.046.044.12.044.166 0l4.283-4.194a.475.475 0 0 1 .662 0l4.283 4.194c.046.044.12.044.166 0l4.283-4.194a.475.475 0 0 1 .662 0Z" fill="#000000"/></g><defs><clipPath id="a"><path fill="#ffffff" d="M0 0h28v20H0z"/></clipPath></defs></svg>`,WALLET_CONNECT_ICON_COLORED:b`<svg width="96" height="96" fill="none"><path fill="#fff" d="M25.322 33.597c12.525-12.263 32.83-12.263 45.355 0l1.507 1.476a1.547 1.547 0 0 1 0 2.22l-5.156 5.048a.814.814 0 0 1-1.134 0l-2.074-2.03c-8.737-8.555-22.903-8.555-31.64 0l-2.222 2.175a.814.814 0 0 1-1.134 0l-5.156-5.049a1.547 1.547 0 0 1 0-2.22l1.654-1.62Zm56.019 10.44 4.589 4.494a1.547 1.547 0 0 1 0 2.22l-20.693 20.26a1.628 1.628 0 0 1-2.267 0L48.283 56.632a.407.407 0 0 0-.567 0L33.03 71.012a1.628 1.628 0 0 1-2.268 0L10.07 50.75a1.547 1.547 0 0 1 0-2.22l4.59-4.494a1.628 1.628 0 0 1 2.267 0l14.687 14.38c.156.153.41.153.567 0l14.685-14.38a1.628 1.628 0 0 1 2.268 0l14.687 14.38c.156.153.41.153.567 0l14.686-14.38a1.628 1.628 0 0 1 2.268 0Z"/><path stroke="#000" d="M25.672 33.954c12.33-12.072 32.325-12.072 44.655 0l1.508 1.476a1.047 1.047 0 0 1 0 1.506l-5.157 5.048a.314.314 0 0 1-.434 0l-2.074-2.03c-8.932-8.746-23.409-8.746-32.34 0l-2.222 2.174a.314.314 0 0 1-.434 0l-5.157-5.048a1.047 1.047 0 0 1 0-1.506l1.655-1.62Zm55.319 10.44 4.59 4.494a1.047 1.047 0 0 1 0 1.506l-20.694 20.26a1.128 1.128 0 0 1-1.568 0l-14.686-14.38a.907.907 0 0 0-1.267 0L32.68 70.655a1.128 1.128 0 0 1-1.568 0L10.42 50.394a1.047 1.047 0 0 1 0-1.506l4.59-4.493a1.128 1.128 0 0 1 1.567 0l14.687 14.379a.907.907 0 0 0 1.266 0l-.35-.357.35.357 14.686-14.38a1.128 1.128 0 0 1 1.568 0l14.687 14.38a.907.907 0 0 0 1.267 0l14.686-14.38a1.128 1.128 0 0 1 1.568 0Z"/></svg>`,BACK_ICON:b`<svg width="10" height="18" viewBox="0 0 10 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.735.179a.75.75 0 0 1 .087 1.057L2.92 8.192a1.25 1.25 0 0 0 0 1.617l5.902 6.956a.75.75 0 1 1-1.144.97L1.776 10.78a2.75 2.75 0 0 1 0-3.559L7.678.265A.75.75 0 0 1 8.735.18Z" fill="#fff"/></svg>`,COPY_ICON:b`<svg width="24" height="24" fill="none"><path fill="#fff" fill-rule="evenodd" d="M7.01 7.01c.03-1.545.138-2.5.535-3.28A5 5 0 0 1 9.73 1.545C10.8 1 12.2 1 15 1c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C23 4.8 23 6.2 23 9c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185c-.78.397-1.735.505-3.28.534l-.001.01c-.03 1.54-.138 2.493-.534 3.27a5 5 0 0 1-2.185 2.186C13.2 23 11.8 23 9 23c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C1 19.2 1 17.8 1 15c0-2.8 0-4.2.545-5.27A5 5 0 0 1 3.73 7.545C4.508 7.149 5.46 7.04 7 7.01h.01ZM15 15.5c-1.425 0-2.403-.001-3.162-.063-.74-.06-1.139-.172-1.427-.319a3.5 3.5 0 0 1-1.53-1.529c-.146-.288-.257-.686-.318-1.427C8.501 11.403 8.5 10.425 8.5 9c0-1.425.001-2.403.063-3.162.06-.74.172-1.139.318-1.427a3.5 3.5 0 0 1 1.53-1.53c.288-.146.686-.257 1.427-.318.759-.062 1.737-.063 3.162-.063 1.425 0 2.403.001 3.162.063.74.06 1.139.172 1.427.318a3.5 3.5 0 0 1 1.53 1.53c.146.288.257.686.318 1.427.062.759.063 1.737.063 3.162 0 1.425-.001 2.403-.063 3.162-.06.74-.172 1.139-.319 1.427a3.5 3.5 0 0 1-1.529 1.53c-.288.146-.686.257-1.427.318-.759.062-1.737.063-3.162.063ZM7 8.511c-.444.009-.825.025-1.162.052-.74.06-1.139.172-1.427.318a3.5 3.5 0 0 0-1.53 1.53c-.146.288-.257.686-.318 1.427-.062.759-.063 1.737-.063 3.162 0 1.425.001 2.403.063 3.162.06.74.172 1.139.318 1.427a3.5 3.5 0 0 0 1.53 1.53c.288.146.686.257 1.427.318.759.062 1.737.063 3.162.063 1.425 0 2.403-.001 3.162-.063.74-.06 1.139-.172 1.427-.319a3.5 3.5 0 0 0 1.53-1.53c.146-.287.257-.685.318-1.426.027-.337.043-.718.052-1.162H15c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C7 13.2 7 11.8 7 9v-.489Z" clip-rule="evenodd"/></svg>`,RETRY_ICON:b`<svg width="15" height="16" viewBox="0 0 15 16"><path d="M6.464 2.03A.75.75 0 0 0 5.403.97L2.08 4.293a1 1 0 0 0 0 1.414L5.403 9.03a.75.75 0 0 0 1.06-1.06L4.672 6.177a.25.25 0 0 1 .177-.427h2.085a4 4 0 1 1-3.93 4.746c-.077-.407-.405-.746-.82-.746-.414 0-.755.338-.7.748a5.501 5.501 0 1 0 5.45-6.248H4.848a.25.25 0 0 1-.177-.427L6.464 2.03Z" fill="#fff"/></svg>`,DESKTOP_ICON:b`<svg width="16" height="16" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 5.98c0-1.85 0-2.775.394-3.466a3 3 0 0 1 1.12-1.12C2.204 1 3.13 1 4.98 1h6.04c1.85 0 2.775 0 3.466.394a3 3 0 0 1 1.12 1.12C16 3.204 16 4.13 16 5.98v1.04c0 1.85 0 2.775-.394 3.466a3 3 0 0 1-1.12 1.12C13.796 12 12.87 12 11.02 12H4.98c-1.85 0-2.775 0-3.466-.394a3 3 0 0 1-1.12-1.12C0 9.796 0 8.87 0 7.02V5.98ZM4.98 2.5h6.04c.953 0 1.568.001 2.034.043.446.04.608.108.69.154a1.5 1.5 0 0 1 .559.56c.046.08.114.243.154.69.042.465.043 1.08.043 2.033v1.04c0 .952-.001 1.568-.043 2.034-.04.446-.108.608-.154.69a1.499 1.499 0 0 1-.56.559c-.08.046-.243.114-.69.154-.466.042-1.08.043-2.033.043H4.98c-.952 0-1.568-.001-2.034-.043-.446-.04-.608-.108-.69-.154a1.5 1.5 0 0 1-.559-.56c-.046-.08-.114-.243-.154-.69-.042-.465-.043-1.08-.043-2.033V5.98c0-.952.001-1.568.043-2.034.04-.446.108-.608.154-.69a1.5 1.5 0 0 1 .56-.559c.08-.046.243-.114.69-.154.465-.042 1.08-.043 2.033-.043Z" fill="#fff"/><path d="M4 14.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z" fill="#fff"/></svg>`,MOBILE_ICON:b`<svg width="16" height="16" viewBox="0 0 16 16"><path d="M6.75 5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3 4.98c0-1.85 0-2.775.394-3.466a3 3 0 0 1 1.12-1.12C5.204 0 6.136 0 8 0s2.795 0 3.486.394a3 3 0 0 1 1.12 1.12C13 2.204 13 3.13 13 4.98v6.04c0 1.85 0 2.775-.394 3.466a3 3 0 0 1-1.12 1.12C10.796 16 9.864 16 8 16s-2.795 0-3.486-.394a3 3 0 0 1-1.12-1.12C3 13.796 3 12.87 3 11.02V4.98Zm8.5 0v6.04c0 .953-.001 1.568-.043 2.034-.04.446-.108.608-.154.69a1.499 1.499 0 0 1-.56.559c-.08.045-.242.113-.693.154-.47.042-1.091.043-2.05.043-.959 0-1.58-.001-2.05-.043-.45-.04-.613-.109-.693-.154a1.5 1.5 0 0 1-.56-.56c-.046-.08-.114-.243-.154-.69-.042-.466-.043-1.08-.043-2.033V4.98c0-.952.001-1.568.043-2.034.04-.446.108-.608.154-.69a1.5 1.5 0 0 1 .56-.559c.08-.045.243-.113.693-.154C6.42 1.501 7.041 1.5 8 1.5c.959 0 1.58.001 2.05.043.45.04.613.109.693.154a1.5 1.5 0 0 1 .56.56c.046.08.114.243.154.69.042.465.043 1.08.043 2.033Z" fill="#fff"/></svg>`,ARROW_DOWN_ICON:b`<svg width="14" height="14" viewBox="0 0 14 14"><path d="M2.28 7.47a.75.75 0 0 0-1.06 1.06l5.25 5.25a.75.75 0 0 0 1.06 0l5.25-5.25a.75.75 0 0 0-1.06-1.06l-3.544 3.543a.25.25 0 0 1-.426-.177V.75a.75.75 0 0 0-1.5 0v10.086a.25.25 0 0 1-.427.176L2.28 7.47Z" fill="#fff"/></svg>`,ARROW_UP_RIGHT_ICON:b`<svg width="15" height="14" fill="none"><path d="M4.5 1.75A.75.75 0 0 1 5.25 1H12a1.5 1.5 0 0 1 1.5 1.5v6.75a.75.75 0 0 1-1.5 0V4.164a.25.25 0 0 0-.427-.176L4.061 11.5A.75.75 0 0 1 3 10.44l7.513-7.513a.25.25 0 0 0-.177-.427H5.25a.75.75 0 0 1-.75-.75Z" fill="#fff"/></svg>`,ARROW_RIGHT_ICON:b`<svg width="6" height="14" viewBox="0 0 6 14"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.181 1.099a.75.75 0 0 1 1.024.279l2.433 4.258a2.75 2.75 0 0 1 0 2.729l-2.433 4.257a.75.75 0 1 1-1.303-.744L4.335 7.62a1.25 1.25 0 0 0 0-1.24L1.902 2.122a.75.75 0 0 1 .28-1.023Z" fill="#fff"/></svg>`,QRCODE_ICON:b`<svg width="25" height="24" viewBox="0 0 25 24"><path d="M23.748 9a.748.748 0 0 0 .748-.752c-.018-2.596-.128-4.07-.784-5.22a6 6 0 0 0-2.24-2.24c-1.15-.656-2.624-.766-5.22-.784a.748.748 0 0 0-.752.748c0 .414.335.749.748.752 1.015.007 1.82.028 2.494.088.995.09 1.561.256 1.988.5.7.398 1.28.978 1.679 1.678.243.427.41.993.498 1.988.061.675.082 1.479.09 2.493a.753.753 0 0 0 .75.749ZM3.527.788C4.677.132 6.152.022 8.747.004A.748.748 0 0 1 9.5.752a.753.753 0 0 1-.749.752c-1.014.007-1.818.028-2.493.088-.995.09-1.561.256-1.988.5-.7.398-1.28.978-1.679 1.678-.243.427-.41.993-.499 1.988-.06.675-.081 1.479-.088 2.493A.753.753 0 0 1 1.252 9a.748.748 0 0 1-.748-.752c.018-2.596.128-4.07.784-5.22a6 6 0 0 1 2.24-2.24ZM1.252 15a.748.748 0 0 0-.748.752c.018 2.596.128 4.07.784 5.22a6 6 0 0 0 2.24 2.24c1.15.656 2.624.766 5.22.784a.748.748 0 0 0 .752-.748.753.753 0 0 0-.749-.752c-1.014-.007-1.818-.028-2.493-.089-.995-.089-1.561-.255-1.988-.498a4.5 4.5 0 0 1-1.679-1.68c-.243-.426-.41-.992-.499-1.987-.06-.675-.081-1.479-.088-2.493A.753.753 0 0 0 1.252 15ZM22.996 15.749a.753.753 0 0 1 .752-.749c.415 0 .751.338.748.752-.018 2.596-.128 4.07-.784 5.22a6 6 0 0 1-2.24 2.24c-1.15.656-2.624.766-5.22.784a.748.748 0 0 1-.752-.748c0-.414.335-.749.748-.752 1.015-.007 1.82-.028 2.494-.089.995-.089 1.561-.255 1.988-.498a4.5 4.5 0 0 0 1.679-1.68c.243-.426.41-.992.498-1.987.061-.675.082-1.479.09-2.493Z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7 4a2.5 2.5 0 0 0-2.5 2.5v2A2.5 2.5 0 0 0 7 11h2a2.5 2.5 0 0 0 2.5-2.5v-2A2.5 2.5 0 0 0 9 4H7Zm2 1.5H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1ZM13.5 6.5A2.5 2.5 0 0 1 16 4h2a2.5 2.5 0 0 1 2.5 2.5v2A2.5 2.5 0 0 1 18 11h-2a2.5 2.5 0 0 1-2.5-2.5v-2Zm2.5-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1ZM7 13a2.5 2.5 0 0 0-2.5 2.5v2A2.5 2.5 0 0 0 7 20h2a2.5 2.5 0 0 0 2.5-2.5v-2A2.5 2.5 0 0 0 9 13H7Zm2 1.5H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z" fill="#fff"/><path d="M13.5 15.5c0-.465 0-.697.038-.89a2 2 0 0 1 1.572-1.572C15.303 13 15.535 13 16 13v2.5h-2.5ZM18 13c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89H18V13ZM18 17.5h2.5c0 .465 0 .697-.038.89a2 2 0 0 1-1.572 1.572C18.697 20 18.465 20 18 20v-2.5ZM13.5 17.5H16V20c-.465 0-.697 0-.89-.038a2 2 0 0 1-1.572-1.572c-.038-.193-.038-.425-.038-.89Z" fill="#fff"/></svg>`,SCAN_ICON:b`<svg width="16" height="16" fill="none"><path fill="#fff" d="M10 15.216c0 .422.347.763.768.74 1.202-.064 2.025-.222 2.71-.613a5.001 5.001 0 0 0 1.865-1.866c.39-.684.549-1.507.613-2.709a.735.735 0 0 0-.74-.768.768.768 0 0 0-.76.732c-.009.157-.02.306-.032.447-.073.812-.206 1.244-.384 1.555-.31.545-.761.996-1.306 1.306-.311.178-.743.311-1.555.384-.141.013-.29.023-.447.032a.768.768 0 0 0-.732.76ZM10 .784c0 .407.325.737.732.76.157.009.306.02.447.032.812.073 1.244.206 1.555.384a3.5 3.5 0 0 1 1.306 1.306c.178.311.311.743.384 1.555.013.142.023.29.032.447a.768.768 0 0 0 .76.732.734.734 0 0 0 .74-.768c-.064-1.202-.222-2.025-.613-2.71A5 5 0 0 0 13.477.658c-.684-.39-1.507-.549-2.709-.613a.735.735 0 0 0-.768.74ZM5.232.044A.735.735 0 0 1 6 .784a.768.768 0 0 1-.732.76c-.157.009-.305.02-.447.032-.812.073-1.244.206-1.555.384A3.5 3.5 0 0 0 1.96 3.266c-.178.311-.311.743-.384 1.555-.013.142-.023.29-.032.447A.768.768 0 0 1 .784 6a.735.735 0 0 1-.74-.768c.064-1.202.222-2.025.613-2.71A5 5 0 0 1 2.523.658C3.207.267 4.03.108 5.233.044ZM5.268 14.456a.768.768 0 0 1 .732.76.734.734 0 0 1-.768.74c-1.202-.064-2.025-.222-2.71-.613a5 5 0 0 1-1.865-1.866c-.39-.684-.549-1.507-.613-2.709A.735.735 0 0 1 .784 10c.407 0 .737.325.76.732.009.157.02.306.032.447.073.812.206 1.244.384 1.555a3.5 3.5 0 0 0 1.306 1.306c.311.178.743.311 1.555.384.142.013.29.023.447.032Z"/></svg>`,CHECKMARK_ICON:b`<svg width="13" height="12" viewBox="0 0 13 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.155.132a.75.75 0 0 1 .232 1.035L5.821 11.535a1 1 0 0 1-1.626.09L.665 7.21a.75.75 0 1 1 1.17-.937L4.71 9.867a.25.25 0 0 0 .406-.023L11.12.364a.75.75 0 0 1 1.035-.232Z" fill="#fff"/></svg>`,SEARCH_ICON:b`<svg width="20" height="21"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.432 13.992c-.354-.353-.91-.382-1.35-.146a5.5 5.5 0 1 1 2.265-2.265c-.237.441-.208.997.145 1.35l3.296 3.296a.75.75 0 1 1-1.06 1.061l-3.296-3.296Zm.06-5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" fill="#949E9E"/></svg>`,WALLET_PLACEHOLDER:b`<svg width="60" height="60" fill="none" viewBox="0 0 60 60"><g clip-path="url(#q)"><path id="wallet-placeholder-fill" fill="#fff" d="M0 24.9c0-9.251 0-13.877 1.97-17.332a15 15 0 0 1 5.598-5.597C11.023 0 15.648 0 24.9 0h10.2c9.252 0 13.877 0 17.332 1.97a15 15 0 0 1 5.597 5.598C60 11.023 60 15.648 60 24.9v10.2c0 9.252 0 13.877-1.97 17.332a15.001 15.001 0 0 1-5.598 5.597C48.977 60 44.352 60 35.1 60H24.9c-9.251 0-13.877 0-17.332-1.97a15 15 0 0 1-5.597-5.598C0 48.977 0 44.352 0 35.1V24.9Z"/><path id="wallet-placeholder-dash" stroke="#000" stroke-dasharray="4 4" stroke-width="1.5" d="M.04 41.708a231.598 231.598 0 0 1-.039-4.403l.75-.001L.75 35.1v-2.55H0v-5.1h.75V24.9l.001-2.204h-.75c.003-1.617.011-3.077.039-4.404l.75.016c.034-1.65.099-3.08.218-4.343l-.746-.07c.158-1.678.412-3.083.82-4.316l.713.236c.224-.679.497-1.296.827-1.875a14.25 14.25 0 0 1 1.05-1.585L3.076 5.9A15 15 0 0 1 5.9 3.076l.455.596a14.25 14.25 0 0 1 1.585-1.05c.579-.33 1.196-.603 1.875-.827l-.236-.712C10.812.674 12.217.42 13.895.262l.07.746C15.23.89 16.66.824 18.308.79l-.016-.75C19.62.012 21.08.004 22.695.001l.001.75L24.9.75h2.55V0h5.1v.75h2.55l2.204.001v-.75c1.617.003 3.077.011 4.404.039l-.016.75c1.65.034 3.08.099 4.343.218l.07-.746c1.678.158 3.083.412 4.316.82l-.236.713c.679.224 1.296.497 1.875.827a14.24 14.24 0 0 1 1.585 1.05l.455-.596A14.999 14.999 0 0 1 56.924 5.9l-.596.455c.384.502.735 1.032 1.05 1.585.33.579.602 1.196.827 1.875l.712-.236c.409 1.233.663 2.638.822 4.316l-.747.07c.119 1.264.184 2.694.218 4.343l.75-.016c.028 1.327.036 2.787.039 4.403l-.75.001.001 2.204v2.55H60v5.1h-.75v2.55l-.001 2.204h.75a231.431 231.431 0 0 1-.039 4.404l-.75-.016c-.034 1.65-.099 3.08-.218 4.343l.747.07c-.159 1.678-.413 3.083-.822 4.316l-.712-.236a10.255 10.255 0 0 1-.827 1.875 14.242 14.242 0 0 1-1.05 1.585l.596.455a14.997 14.997 0 0 1-2.824 2.824l-.455-.596c-.502.384-1.032.735-1.585 1.05-.579.33-1.196.602-1.875.827l.236.712c-1.233.409-2.638.663-4.316.822l-.07-.747c-1.264.119-2.694.184-4.343.218l.016.75c-1.327.028-2.787.036-4.403.039l-.001-.75-2.204.001h-2.55V60h-5.1v-.75H24.9l-2.204-.001v.75a231.431 231.431 0 0 1-4.404-.039l.016-.75c-1.65-.034-3.08-.099-4.343-.218l-.07.747c-1.678-.159-3.083-.413-4.316-.822l.236-.712a10.258 10.258 0 0 1-1.875-.827 14.252 14.252 0 0 1-1.585-1.05l-.455.596A14.999 14.999 0 0 1 3.076 54.1l.596-.455a14.24 14.24 0 0 1-1.05-1.585 10.259 10.259 0 0 1-.827-1.875l-.712.236C.674 49.188.42 47.783.262 46.105l.746-.07C.89 44.77.824 43.34.79 41.692l-.75.016Z"/><path fill="#fff" fill-rule="evenodd" d="M35.643 32.145c-.297-.743-.445-1.114-.401-1.275a.42.42 0 0 1 .182-.27c.134-.1.463-.1 1.123-.1.742 0 1.499.046 2.236-.05a6 6 0 0 0 5.166-5.166c.051-.39.051-.855.051-1.784 0-.928 0-1.393-.051-1.783a6 6 0 0 0-5.166-5.165c-.39-.052-.854-.052-1.783-.052h-7.72c-4.934 0-7.401 0-9.244 1.051a8 8 0 0 0-2.985 2.986C16.057 22.28 16.003 24.58 16 29 15.998 31.075 16 33.15 16 35.224A7.778 7.778 0 0 0 23.778 43H28.5c1.394 0 2.09 0 2.67-.116a6 6 0 0 0 4.715-4.714c.115-.58.115-1.301.115-2.744 0-1.31 0-1.964-.114-2.49a4.998 4.998 0 0 0-.243-.792Z" clip-rule="evenodd"/><path fill="#9EA9A9" fill-rule="evenodd" d="M37 18h-7.72c-2.494 0-4.266.002-5.647.126-1.361.122-2.197.354-2.854.728a6.5 6.5 0 0 0-2.425 2.426c-.375.657-.607 1.492-.729 2.853-.11 1.233-.123 2.777-.125 4.867 0 .7 0 1.05.097 1.181.096.13.182.181.343.2.163.02.518-.18 1.229-.581a6.195 6.195 0 0 1 3.053-.8H37c.977 0 1.32-.003 1.587-.038a4.5 4.5 0 0 0 3.874-3.874c.036-.268.039-.611.039-1.588 0-.976-.003-1.319-.038-1.587a4.5 4.5 0 0 0-3.875-3.874C38.32 18.004 37.977 18 37 18Zm-7.364 12.5h-7.414a4.722 4.722 0 0 0-4.722 4.723 6.278 6.278 0 0 0 6.278 6.278H28.5c1.466 0 1.98-.008 2.378-.087a4.5 4.5 0 0 0 3.535-3.536c.08-.397.087-.933.087-2.451 0-1.391-.009-1.843-.08-2.17a3.5 3.5 0 0 0-2.676-2.676c-.328-.072-.762-.08-2.108-.08Z" clip-rule="evenodd"/></g><defs><clipPath id="q"><path fill="#fff" d="M0 0h60v60H0z"/></clipPath></defs></svg>`,GLOBE_ICON:b`<svg width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="#fff" fill-rule="evenodd" d="M15.5 8a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Zm-2.113.75c.301 0 .535.264.47.558a6.01 6.01 0 0 1-2.867 3.896c-.203.116-.42-.103-.334-.32.409-1.018.691-2.274.797-3.657a.512.512 0 0 1 .507-.477h1.427Zm.47-2.058c.065.294-.169.558-.47.558H11.96a.512.512 0 0 1-.507-.477c-.106-1.383-.389-2.638-.797-3.656-.087-.217.13-.437.333-.32a6.01 6.01 0 0 1 2.868 3.895Zm-4.402.558c.286 0 .515-.24.49-.525-.121-1.361-.429-2.534-.83-3.393-.279-.6-.549-.93-.753-1.112a.535.535 0 0 0-.724 0c-.204.182-.474.513-.754 1.112-.4.859-.708 2.032-.828 3.393a.486.486 0 0 0 .49.525h2.909Zm-5.415 0c.267 0 .486-.21.507-.477.106-1.383.389-2.638.797-3.656.087-.217-.13-.437-.333-.32a6.01 6.01 0 0 0-2.868 3.895c-.065.294.169.558.47.558H4.04ZM2.143 9.308c-.065-.294.169-.558.47-.558H4.04c.267 0 .486.21.507.477.106 1.383.389 2.639.797 3.657.087.217-.13.436-.333.32a6.01 6.01 0 0 1-2.868-3.896Zm3.913-.033a.486.486 0 0 1 .49-.525h2.909c.286 0 .515.24.49.525-.121 1.361-.428 2.535-.83 3.394-.279.6-.549.93-.753 1.112a.535.535 0 0 1-.724 0c-.204-.182-.474-.513-.754-1.112-.4-.859-.708-2.033-.828-3.394Z" clip-rule="evenodd"/></svg>`},pt=i$3`.wcm-toolbar-placeholder{top:0;bottom:0;left:0;right:0;width:100%;position:absolute;display:block;pointer-events:none;height:100px;border-radius:calc(var(--wcm-background-border-radius) * .9);background-color:var(--wcm-background-color);background-position:center;background-size:cover}.wcm-toolbar{height:38px;display:flex;position:relative;margin:5px 15px 5px 5px;justify-content:space-between;align-items:center}.wcm-toolbar img,.wcm-toolbar svg{height:28px;object-position:left center;object-fit:contain}#wcm-wc-logo path{fill:var(--wcm-accent-fill-color)}button{width:28px;height:28px;border-radius:var(--wcm-icon-button-border-radius);border:0;display:flex;justify-content:center;align-items:center;cursor:pointer;background-color:var(--wcm-color-bg-1);box-shadow:0 0 0 1px var(--wcm-color-overlay)}button:active{background-color:var(--wcm-color-bg-2)}button svg{display:block;object-position:center}button path{fill:var(--wcm-color-fg-1)}.wcm-toolbar div{display:flex}@media(hover:hover){button:hover{background-color:var(--wcm-color-bg-2)}}`;var gt=Object.defineProperty,vt=Object.getOwnPropertyDescriptor,ut=(e,o,r,a)=>{for(var t=a>1?void 0:a?vt(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&gt(o,r,t),t};let fe=class extends s{render(){return x`<div class="wcm-toolbar-placeholder"></div><div class="wcm-toolbar">${v.WALLET_CONNECT_LOGO} <button @click="${Q$1.close}">${v.CROSS_ICON}</button></div>`}};fe.styles=[h.globalCss,pt],fe=ut([e$2("wcm-modal-backcard")],fe);const bt=i$3`main{padding:20px;padding-top:0;width:100%}`;var ft=Object.defineProperty,xt=Object.getOwnPropertyDescriptor,yt=(e,o,r,a)=>{for(var t=a>1?void 0:a?xt(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&ft(o,r,t),t};let xe=class extends s{render(){return x`<main><slot></slot></main>`}};xe.styles=[h.globalCss,bt],xe=yt([e$2("wcm-modal-content")],xe);const $t=i$3`footer{padding:10px;display:flex;flex-direction:column;align-items:inherit;justify-content:inherit;border-top:1px solid var(--wcm-color-bg-2)}`;var Ct=Object.defineProperty,kt=Object.getOwnPropertyDescriptor,Ot=(e,o,r,a)=>{for(var t=a>1?void 0:a?kt(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Ct(o,r,t),t};let ye=class extends s{render(){return x`<footer><slot></slot></footer>`}};ye.styles=[h.globalCss,$t],ye=Ot([e$2("wcm-modal-footer")],ye);const Wt=i$3`header{display:flex;justify-content:center;align-items:center;padding:20px;position:relative}.wcm-border{border-bottom:1px solid var(--wcm-color-bg-2);margin-bottom:20px}header button{padding:15px 20px}header button:active{opacity:.5}@media(hover:hover){header button:hover{opacity:.5}}.wcm-back-btn{position:absolute;left:0}.wcm-action-btn{position:absolute;right:0}path{fill:var(--wcm-accent-color)}`;var It=Object.defineProperty,Et=Object.getOwnPropertyDescriptor,te=(e,o,r,a)=>{for(var t=a>1?void 0:a?Et(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&It(o,r,t),t};let S=class extends s{constructor(){super(...arguments),this.title="",this.onAction=void 0,this.actionIcon=void 0,this.border=!1;}backBtnTemplate(){return x`<button class="wcm-back-btn" @click="${N$1.goBack}">${v.BACK_ICON}</button>`}actionBtnTemplate(){return x`<button class="wcm-action-btn" @click="${this.onAction}">${this.actionIcon}</button>`}render(){const e={"wcm-border":this.border},o$1=N$1.state.history.length>1,r=this.title?x`<wcm-text variant="big-bold">${this.title}</wcm-text>`:x`<slot></slot>`;return x`<header class="${o(e)}">${o$1?this.backBtnTemplate():null} ${r} ${this.onAction?this.actionBtnTemplate():null}</header>`}};S.styles=[h.globalCss,Wt],te([n$1()],S.prototype,"title",2),te([n$1()],S.prototype,"onAction",2),te([n$1()],S.prototype,"actionIcon",2),te([n$1({type:Boolean})],S.prototype,"border",2),S=te([e$2("wcm-modal-header")],S);const c={MOBILE_BREAKPOINT:600,WCM_RECENT_WALLET_DATA:"WCM_RECENT_WALLET_DATA",EXPLORER_WALLET_URL:"https://explorer.walletconnect.com/?type=wallet",getShadowRootElement(e,o){const r=e.renderRoot.querySelector(o);if(!r)throw new Error(`${o} not found`);return r},getWalletIcon({id:e,image_id:o}){const{walletImages:r}=C$1.state;return r!=null&&r[e]?r[e]:o?G$1.getWalletImageUrl(o):""},getWalletName(e,o=!1){return o?e.split(" ")[0]:e},isMobileAnimation(){return window.innerWidth<=c.MOBILE_BREAKPOINT},async preloadImage(e){const o=new Promise((r,a)=>{const t=new Image;t.onload=r,t.onerror=a,t.src=e;});return Promise.race([o,i$4.wait(3e3)])},getErrorMessage(e){return e instanceof Error?e.message:"Unknown Error"},debounce(e,o=500){let r;return (...a)=>{function t(){e(...a);}r&&clearTimeout(r),r=setTimeout(t,o);}},handleMobileLinking(e){const{walletConnectUri:o}=c$3.state,{mobile:r,name:a}=e,t=r?.native,l=r?.universal;c.setRecentWallet(e);function i(s){let $="";t?$=i$4.formatUniversalUrl(t,s,a):l&&($=i$4.formatNativeUrl(l,s,a)),i$4.openHref($,"_self");}o&&i(o);},handleAndroidLinking(){const{walletConnectUri:e}=c$3.state;e&&(i$4.setWalletConnectAndroidDeepLink(e),i$4.openHref(e,"_self"));},async handleUriCopy(){const{walletConnectUri:e}=c$3.state;if(e)try{await navigator.clipboard.writeText(e),Y$1.openToast("Link copied","success");}catch{Y$1.openToast("Failed to copy","error");}},getCustomImageUrls(){const{walletImages:e}=C$1.state,o=Object.values(e??{});return Object.values(o)},truncate(e,o=8){return e.length<=o?e:`${e.substring(0,4)}...${e.substring(e.length-4)}`},setRecentWallet(e){try{localStorage.setItem(c.WCM_RECENT_WALLET_DATA,JSON.stringify(e));}catch{console.info("Unable to set recent wallet");}},getRecentWallet(){try{const e=localStorage.getItem(c.WCM_RECENT_WALLET_DATA);return e?JSON.parse(e):void 0}catch{console.info("Unable to get recent wallet");}},caseSafeIncludes(e,o){return e.toUpperCase().includes(o.toUpperCase())},openWalletExplorerUrl(){i$4.openHref(c.EXPLORER_WALLET_URL,"_blank");},getCachedRouterWalletPlatforms(){const{desktop:e,mobile:o}=i$4.getWalletRouterData(),r=Boolean(e?.native),a=Boolean(e?.universal),t=Boolean(o?.native)||Boolean(o?.universal);return {isDesktop:r,isMobile:t,isWeb:a}},goToConnectingView(e){N$1.setData({Wallet:e});const o=i$4.isMobile(),{isDesktop:r,isWeb:a,isMobile:t}=c.getCachedRouterWalletPlatforms();o?t?N$1.push("MobileConnecting"):a?N$1.push("WebConnecting"):N$1.push("InstallWallet"):r?N$1.push("DesktopConnecting"):a?N$1.push("WebConnecting"):t?N$1.push("MobileQrcodeConnecting"):N$1.push("InstallWallet");}},Mt=i$3`.wcm-router{overflow:hidden;will-change:transform}.wcm-content{display:flex;flex-direction:column}`;var Lt=Object.defineProperty,Rt=Object.getOwnPropertyDescriptor,$e=(e,o,r,a)=>{for(var t=a>1?void 0:a?Rt(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Lt(o,r,t),t};let oe=class extends s{constructor(){super(),this.view=N$1.state.view,this.prevView=N$1.state.view,this.unsubscribe=void 0,this.oldHeight="0px",this.resizeObserver=void 0,this.unsubscribe=N$1.subscribe(e=>{this.view!==e.view&&this.onChangeRoute();});}firstUpdated(){this.resizeObserver=new ResizeObserver(([e])=>{const o=`${e.contentRect.height}px`;this.oldHeight!=="0px"&&animate(this.routerEl,{height:[this.oldHeight,o]},{duration:.2}),this.oldHeight=o;}),this.resizeObserver.observe(this.contentEl);}disconnectedCallback(){var e,o;(e=this.unsubscribe)==null||e.call(this),(o=this.resizeObserver)==null||o.disconnect();}get routerEl(){return c.getShadowRootElement(this,".wcm-router")}get contentEl(){return c.getShadowRootElement(this,".wcm-content")}viewTemplate(){switch(this.view){case"ConnectWallet":return x`<wcm-connect-wallet-view></wcm-connect-wallet-view>`;case"DesktopConnecting":return x`<wcm-desktop-connecting-view></wcm-desktop-connecting-view>`;case"MobileConnecting":return x`<wcm-mobile-connecting-view></wcm-mobile-connecting-view>`;case"WebConnecting":return x`<wcm-web-connecting-view></wcm-web-connecting-view>`;case"MobileQrcodeConnecting":return x`<wcm-mobile-qr-connecting-view></wcm-mobile-qr-connecting-view>`;case"WalletExplorer":return x`<wcm-wallet-explorer-view></wcm-wallet-explorer-view>`;case"Qrcode":return x`<wcm-qrcode-view></wcm-qrcode-view>`;case"InstallWallet":return x`<wcm-install-wallet-view></wcm-install-wallet-view>`;default:return x`<div>Not Found</div>`}}async onChangeRoute(){await animate(this.routerEl,{opacity:[1,0],scale:[1,1.02]},{duration:.15,delay:.1}).finished,this.view=N$1.state.view,animate(this.routerEl,{opacity:[0,1],scale:[.99,1]},{duration:.37,delay:.05});}render(){return x`<div class="wcm-router"><div class="wcm-content">${this.viewTemplate()}</div></div>`}};oe.styles=[h.globalCss,Mt],$e([t$1()],oe.prototype,"view",2),$e([t$1()],oe.prototype,"prevView",2),oe=$e([e$2("wcm-modal-router")],oe);const At=i$3`div{height:36px;width:max-content;display:flex;justify-content:center;align-items:center;padding:9px 15px 11px;position:absolute;top:12px;box-shadow:0 6px 14px -6px rgba(10,16,31,.3),0 10px 32px -4px rgba(10,16,31,.15);z-index:2;left:50%;transform:translateX(-50%);pointer-events:none;backdrop-filter:blur(20px) saturate(1.8);-webkit-backdrop-filter:blur(20px) saturate(1.8);border-radius:var(--wcm-notification-border-radius);border:1px solid var(--wcm-color-overlay);background-color:var(--wcm-color-overlay)}svg{margin-right:5px}@-moz-document url-prefix(){div{background-color:var(--wcm-color-bg-3)}}.wcm-success path{fill:var(--wcm-accent-color)}.wcm-error path{fill:var(--wcm-error-color)}`;var Pt=Object.defineProperty,Tt=Object.getOwnPropertyDescriptor,ze=(e,o,r,a)=>{for(var t=a>1?void 0:a?Tt(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Pt(o,r,t),t};let ne=class extends s{constructor(){super(),this.open=!1,this.unsubscribe=void 0,this.timeout=void 0,this.unsubscribe=Y$1.subscribe(e=>{e.open?(this.open=!0,this.timeout=setTimeout(()=>Y$1.closeToast(),2200)):(this.open=!1,clearTimeout(this.timeout));});}disconnectedCallback(){var e;(e=this.unsubscribe)==null||e.call(this),clearTimeout(this.timeout),Y$1.closeToast();}render(){const{message:e,variant:o$1}=Y$1.state,r={"wcm-success":o$1==="success","wcm-error":o$1==="error"};return this.open?x`<div class="${o(r)}">${o$1==="success"?v.CHECKMARK_ICON:null} ${o$1==="error"?v.CROSS_ICON:null}<wcm-text variant="small-regular">${e}</wcm-text></div>`:null}};ne.styles=[h.globalCss,At],ze([t$1()],ne.prototype,"open",2),ne=ze([e$2("wcm-modal-toast")],ne);const jt=.1,Ve=2.5,A=7;function Ce(e,o,r){return e===o?!1:(e-o<0?o-e:e-o)<=r+jt}function _t(e,o){const r=Array.prototype.slice.call(browser.create(e,{errorCorrectionLevel:o}).modules.data,0),a=Math.sqrt(r.length);return r.reduce((t,l,i)=>(i%a===0?t.push([l]):t[t.length-1].push(l))&&t,[])}const Dt={generate(e,o,r){const a="#141414",t="#ffffff",l=[],i=_t(e,"Q"),s=o/i.length,$=[{x:0,y:0},{x:1,y:0},{x:0,y:1}];$.forEach(({x:y,y:u})=>{const O=(i.length-A)*s*y,b$1=(i.length-A)*s*u,E=.45;for(let M=0;M<$.length;M+=1){const V=s*(A-M*2);l.push(b`<rect fill="${M%2===0?a:t}" height="${V}" rx="${V*E}" ry="${V*E}" width="${V}" x="${O+s*M}" y="${b$1+s*M}">`);}});const f=Math.floor((r+25)/s),Ne=i.length/2-f/2,Ze=i.length/2+f/2-1,Se=[];i.forEach((y,u)=>{y.forEach((O,b)=>{if(i[u][b]&&!(u<A&&b<A||u>i.length-(A+1)&&b<A||u<A&&b>i.length-(A+1))&&!(u>Ne&&u<Ze&&b>Ne&&b<Ze)){const E=u*s+s/2,M=b*s+s/2;Se.push([E,M]);}});});const J={};return Se.forEach(([y,u])=>{J[y]?J[y].push(u):J[y]=[u];}),Object.entries(J).map(([y,u])=>{const O=u.filter(b=>u.every(E=>!Ce(b,E,s)));return [Number(y),O]}).forEach(([y,u])=>{u.forEach(O=>{l.push(b`<circle cx="${y}" cy="${O}" fill="${a}" r="${s/Ve}">`);});}),Object.entries(J).filter(([y,u])=>u.length>1).map(([y,u])=>{const O=u.filter(b=>u.some(E=>Ce(b,E,s)));return [Number(y),O]}).map(([y,u])=>{u.sort((b,E)=>b<E?-1:1);const O=[];for(const b of u){const E=O.find(M=>M.some(V=>Ce(b,V,s)));E?E.push(b):O.push([b]);}return [y,O.map(b=>[b[0],b[b.length-1]])]}).forEach(([y,u])=>{u.forEach(([O,b$1])=>{l.push(b`<line x1="${y}" x2="${y}" y1="${O}" y2="${b$1}" stroke="${a}" stroke-width="${s/(Ve/2)}" stroke-linecap="round">`);});}),l}},Nt=i$3`@keyframes fadeIn{0%{opacity:0}100%{opacity:1}}div{position:relative;user-select:none;display:block;overflow:hidden;aspect-ratio:1/1;animation:fadeIn ease .2s}.wcm-dark{background-color:#fff;border-radius:var(--wcm-container-border-radius);padding:18px;box-shadow:0 2px 5px #000}svg:first-child,wcm-wallet-image{position:absolute;top:50%;left:50%;transform:translateY(-50%) translateX(-50%)}wcm-wallet-image{transform:translateY(-50%) translateX(-50%)}wcm-wallet-image{width:25%;height:25%;border-radius:var(--wcm-wallet-icon-border-radius)}svg:first-child{transform:translateY(-50%) translateX(-50%) scale(.9)}svg:first-child path:first-child{fill:var(--wcm-accent-color)}svg:first-child path:last-child{stroke:var(--wcm-color-overlay)}`;var Zt=Object.defineProperty,St=Object.getOwnPropertyDescriptor,q=(e,o,r,a)=>{for(var t=a>1?void 0:a?St(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Zt(o,r,t),t};let j=class extends s{constructor(){super(...arguments),this.uri="",this.size=0,this.imageId=void 0,this.walletId=void 0,this.imageUrl=void 0;}svgTemplate(){const e=X.state.themeMode==="light"?this.size:this.size-36;return b`<svg height="${e}" width="${e}">${Dt.generate(this.uri,e,e/4)}</svg>`}render(){const e={"wcm-dark":X.state.themeMode==="dark"};return x`<div style="${`width: ${this.size}px`}" class="${o(e)}">${this.walletId||this.imageUrl?x`<wcm-wallet-image walletId="${l(this.walletId)}" imageId="${l(this.imageId)}" imageUrl="${l(this.imageUrl)}"></wcm-wallet-image>`:v.WALLET_CONNECT_ICON_COLORED} ${this.svgTemplate()}</div>`}};j.styles=[h.globalCss,Nt],q([n$1()],j.prototype,"uri",2),q([n$1({type:Number})],j.prototype,"size",2),q([n$1()],j.prototype,"imageId",2),q([n$1()],j.prototype,"walletId",2),q([n$1()],j.prototype,"imageUrl",2),j=q([e$2("wcm-qrcode")],j);const Bt=i$3`:host{position:relative;height:28px;width:80%}input{width:100%;height:100%;line-height:28px!important;border-radius:var(--wcm-input-border-radius);font-style:normal;font-family:-apple-system,system-ui,BlinkMacSystemFont,'Segoe UI',Roboto,Ubuntu,'Helvetica Neue',sans-serif;font-feature-settings:'case' on;font-weight:500;font-size:16px;letter-spacing:-.03em;padding:0 10px 0 34px;transition:.2s all ease;color:var(--wcm-color-fg-1);background-color:var(--wcm-color-bg-3);box-shadow:inset 0 0 0 1px var(--wcm-color-overlay);caret-color:var(--wcm-accent-color)}input::placeholder{color:var(--wcm-color-fg-2)}svg{left:10px;top:4px;pointer-events:none;position:absolute;width:20px;height:20px}input:focus-within{box-shadow:inset 0 0 0 1px var(--wcm-accent-color)}path{fill:var(--wcm-color-fg-2)}`;var Ut=Object.defineProperty,Ht=Object.getOwnPropertyDescriptor,Fe=(e,o,r,a)=>{for(var t=a>1?void 0:a?Ht(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Ut(o,r,t),t};let ce=class extends s{constructor(){super(...arguments),this.onChange=()=>null;}render(){return x`<input type="text" @input="${this.onChange}" placeholder="Search wallets"> ${v.SEARCH_ICON}`}};ce.styles=[h.globalCss,Bt],Fe([n$1()],ce.prototype,"onChange",2),ce=Fe([e$2("wcm-search-input")],ce);const zt=i$3`@keyframes rotate{100%{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}100%{stroke-dasharray:90,150;stroke-dashoffset:-124}}svg{animation:rotate 2s linear infinite;display:flex;justify-content:center;align-items:center}svg circle{stroke-linecap:round;animation:dash 1.5s ease infinite;stroke:var(--wcm-accent-color)}`;var Vt=Object.defineProperty,Ft=Object.getOwnPropertyDescriptor,qt=(e,o,r,a)=>{for(var t=a>1?void 0:a?Ft(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Vt(o,r,t),t};let ke=class extends s{render(){return x`<svg viewBox="0 0 50 50" width="24" height="24"><circle cx="25" cy="25" r="20" fill="none" stroke-width="4" stroke="#fff"/></svg>`}};ke.styles=[h.globalCss,zt],ke=qt([e$2("wcm-spinner")],ke);const Qt=i$3`span{font-style:normal;font-family:var(--wcm-font-family);font-feature-settings:var(--wcm-font-feature-settings)}.wcm-xsmall-bold{font-family:var(--wcm-text-xsmall-bold-font-family);font-weight:var(--wcm-text-xsmall-bold-weight);font-size:var(--wcm-text-xsmall-bold-size);line-height:var(--wcm-text-xsmall-bold-line-height);letter-spacing:var(--wcm-text-xsmall-bold-letter-spacing);text-transform:var(--wcm-text-xsmall-bold-text-transform)}.wcm-xsmall-regular{font-family:var(--wcm-text-xsmall-regular-font-family);font-weight:var(--wcm-text-xsmall-regular-weight);font-size:var(--wcm-text-xsmall-regular-size);line-height:var(--wcm-text-xsmall-regular-line-height);letter-spacing:var(--wcm-text-xsmall-regular-letter-spacing);text-transform:var(--wcm-text-xsmall-regular-text-transform)}.wcm-small-thin{font-family:var(--wcm-text-small-thin-font-family);font-weight:var(--wcm-text-small-thin-weight);font-size:var(--wcm-text-small-thin-size);line-height:var(--wcm-text-small-thin-line-height);letter-spacing:var(--wcm-text-small-thin-letter-spacing);text-transform:var(--wcm-text-small-thin-text-transform)}.wcm-small-regular{font-family:var(--wcm-text-small-regular-font-family);font-weight:var(--wcm-text-small-regular-weight);font-size:var(--wcm-text-small-regular-size);line-height:var(--wcm-text-small-regular-line-height);letter-spacing:var(--wcm-text-small-regular-letter-spacing);text-transform:var(--wcm-text-small-regular-text-transform)}.wcm-medium-regular{font-family:var(--wcm-text-medium-regular-font-family);font-weight:var(--wcm-text-medium-regular-weight);font-size:var(--wcm-text-medium-regular-size);line-height:var(--wcm-text-medium-regular-line-height);letter-spacing:var(--wcm-text-medium-regular-letter-spacing);text-transform:var(--wcm-text-medium-regular-text-transform)}.wcm-big-bold{font-family:var(--wcm-text-big-bold-font-family);font-weight:var(--wcm-text-big-bold-weight);font-size:var(--wcm-text-big-bold-size);line-height:var(--wcm-text-big-bold-line-height);letter-spacing:var(--wcm-text-big-bold-letter-spacing);text-transform:var(--wcm-text-big-bold-text-transform)}:host(*){color:var(--wcm-color-fg-1)}.wcm-color-primary{color:var(--wcm-color-fg-1)}.wcm-color-secondary{color:var(--wcm-color-fg-2)}.wcm-color-tertiary{color:var(--wcm-color-fg-3)}.wcm-color-inverse{color:var(--wcm-accent-fill-color)}.wcm-color-accnt{color:var(--wcm-accent-color)}.wcm-color-error{color:var(--wcm-error-color)}`;var Kt=Object.defineProperty,Yt=Object.getOwnPropertyDescriptor,Oe=(e,o,r,a)=>{for(var t=a>1?void 0:a?Yt(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Kt(o,r,t),t};let re=class extends s{constructor(){super(...arguments),this.variant="medium-regular",this.color="primary";}render(){const e={"wcm-big-bold":this.variant==="big-bold","wcm-medium-regular":this.variant==="medium-regular","wcm-small-regular":this.variant==="small-regular","wcm-small-thin":this.variant==="small-thin","wcm-xsmall-regular":this.variant==="xsmall-regular","wcm-xsmall-bold":this.variant==="xsmall-bold","wcm-color-primary":this.color==="primary","wcm-color-secondary":this.color==="secondary","wcm-color-tertiary":this.color==="tertiary","wcm-color-inverse":this.color==="inverse","wcm-color-accnt":this.color==="accent","wcm-color-error":this.color==="error"};return x`<span><slot class="${o(e)}"></slot></span>`}};re.styles=[h.globalCss,Qt],Oe([n$1()],re.prototype,"variant",2),Oe([n$1()],re.prototype,"color",2),re=Oe([e$2("wcm-text")],re);const Gt=i$3`button{width:100%;height:100%;border-radius:var(--wcm-button-hover-highlight-border-radius);display:flex;align-items:flex-start}button:active{background-color:var(--wcm-color-overlay)}@media(hover:hover){button:hover{background-color:var(--wcm-color-overlay)}}button>div{width:80px;padding:5px 0;display:flex;flex-direction:column;align-items:center}wcm-text{width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center}wcm-wallet-image{height:60px;width:60px;transition:all .2s ease;border-radius:var(--wcm-wallet-icon-border-radius);margin-bottom:5px}.wcm-sublabel{margin-top:2px}`;var Xt=Object.defineProperty,Jt=Object.getOwnPropertyDescriptor,_=(e,o,r,a)=>{for(var t=a>1?void 0:a?Jt(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Xt(o,r,t),t};let L=class extends s{constructor(){super(...arguments),this.onClick=()=>null,this.name="",this.walletId="",this.label=void 0,this.imageId=void 0,this.installed=!1,this.recent=!1;}sublabelTemplate(){return this.recent?x`<wcm-text class="wcm-sublabel" variant="xsmall-bold" color="tertiary">RECENT</wcm-text>`:this.installed?x`<wcm-text class="wcm-sublabel" variant="xsmall-bold" color="tertiary">INSTALLED</wcm-text>`:null}handleClick(){$$1.click({name:"WALLET_BUTTON",walletId:this.walletId}),this.onClick();}render(){var e;return x`<button @click="${this.handleClick.bind(this)}"><div><wcm-wallet-image walletId="${this.walletId}" imageId="${l(this.imageId)}"></wcm-wallet-image><wcm-text variant="xsmall-regular">${(e=this.label)!=null?e:c.getWalletName(this.name,!0)}</wcm-text>${this.sublabelTemplate()}</div></button>`}};L.styles=[h.globalCss,Gt],_([n$1()],L.prototype,"onClick",2),_([n$1()],L.prototype,"name",2),_([n$1()],L.prototype,"walletId",2),_([n$1()],L.prototype,"label",2),_([n$1()],L.prototype,"imageId",2),_([n$1({type:Boolean})],L.prototype,"installed",2),_([n$1({type:Boolean})],L.prototype,"recent",2),L=_([e$2("wcm-wallet-button")],L);const eo=i$3`:host{display:block}div{overflow:hidden;position:relative;border-radius:inherit;width:100%;height:100%;background-color:var(--wcm-color-overlay)}svg{position:relative;width:100%;height:100%}div::after{content:'';position:absolute;top:0;bottom:0;left:0;right:0;border-radius:inherit;border:1px solid var(--wcm-color-overlay)}div img{width:100%;height:100%;object-fit:cover;object-position:center}#wallet-placeholder-fill{fill:var(--wcm-color-bg-3)}#wallet-placeholder-dash{stroke:var(--wcm-color-overlay)}`;var to=Object.defineProperty,oo=Object.getOwnPropertyDescriptor,se=(e,o,r,a)=>{for(var t=a>1?void 0:a?oo(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&to(o,r,t),t};let Q=class extends s{constructor(){super(...arguments),this.walletId="",this.imageId=void 0,this.imageUrl=void 0;}render(){var e;const o=(e=this.imageUrl)!=null&&e.length?this.imageUrl:c.getWalletIcon({id:this.walletId,image_id:this.imageId});return x`${o.length?x`<div><img src="${o}" alt="${this.id}"></div>`:v.WALLET_PLACEHOLDER}`}};Q.styles=[h.globalCss,eo],se([n$1()],Q.prototype,"walletId",2),se([n$1()],Q.prototype,"imageId",2),se([n$1()],Q.prototype,"imageUrl",2),Q=se([e$2("wcm-wallet-image")],Q);var ro=Object.defineProperty,ao=Object.getOwnPropertyDescriptor,qe=(e,o,r,a)=>{for(var t=a>1?void 0:a?ao(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&ro(o,r,t),t};let We=class extends s{constructor(){super(),this.preload=!0,this.preloadData();}async loadImages(e){try{e!=null&&e.length&&await Promise.all(e.map(async o=>c.preloadImage(o)));}catch{console.info("Unsuccessful attempt at preloading some images",e);}}async preloadListings(){if(C$1.state.enableExplorer){await G$1.getRecomendedWallets(),c$3.setIsDataLoaded(!0);const{recomendedWallets:e}=G$1.state,o=e.map(r=>c.getWalletIcon(r));await this.loadImages(o);}else c$3.setIsDataLoaded(!0);}async preloadCustomImages(){const e=c.getCustomImageUrls();await this.loadImages(e);}async preloadData(){try{this.preload&&(this.preload=!1,await Promise.all([this.preloadListings(),this.preloadCustomImages()]));}catch(e){console.error(e),Y$1.openToast("Failed preloading","error");}}};qe([t$1()],We.prototype,"preload",2),We=qe([e$2("wcm-explorer-context")],We);var lo=Object.defineProperty,io=Object.getOwnPropertyDescriptor,no=(e,o,r,a)=>{for(var t=a>1?void 0:a?io(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&lo(o,r,t),t};let Qe=class extends s{constructor(){super(),this.unsubscribeTheme=void 0,h.setTheme(),this.unsubscribeTheme=X.subscribe(h.setTheme);}disconnectedCallback(){var e;(e=this.unsubscribeTheme)==null||e.call(this);}};Qe=no([e$2("wcm-theme-context")],Qe);const co=i$3`@keyframes scroll{0%{transform:translate3d(0,0,0)}100%{transform:translate3d(calc(-70px * 9),0,0)}}.wcm-slider{position:relative;overflow-x:hidden;padding:10px 0;margin:0 -20px;width:calc(100% + 40px)}.wcm-track{display:flex;width:calc(70px * 18);animation:scroll 20s linear infinite;opacity:.7}.wcm-track svg{margin:0 5px}wcm-wallet-image{width:60px;height:60px;margin:0 5px;border-radius:var(--wcm-wallet-icon-border-radius)}.wcm-grid{display:grid;grid-template-columns:repeat(4,80px);justify-content:space-between}.wcm-title{display:flex;align-items:center;margin-bottom:10px}.wcm-title svg{margin-right:6px}.wcm-title path{fill:var(--wcm-accent-color)}wcm-modal-footer .wcm-title{padding:0 10px}wcm-button-big{position:absolute;top:50%;left:50%;transform:translateY(-50%) translateX(-50%);filter:drop-shadow(0 0 17px var(--wcm-color-bg-1))}wcm-info-footer{flex-direction:column;align-items:center;display:flex;width:100%;padding:5px 0}wcm-info-footer wcm-text{text-align:center;margin-bottom:15px}#wallet-placeholder-fill{fill:var(--wcm-color-bg-3)}#wallet-placeholder-dash{stroke:var(--wcm-color-overlay)}`;var so=Object.defineProperty,mo=Object.getOwnPropertyDescriptor,ho=(e,o,r,a)=>{for(var t=a>1?void 0:a?mo(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&so(o,r,t),t};let Ie=class extends s{onGoToQrcode(){N$1.push("Qrcode");}render(){const{recomendedWallets:e}=G$1.state,o=[...e,...e],r=i$4.RECOMMENDED_WALLET_AMOUNT*2;return x`<wcm-modal-header title="Connect your wallet" .onAction="${this.onGoToQrcode}" .actionIcon="${v.QRCODE_ICON}"></wcm-modal-header><wcm-modal-content><div class="wcm-title">${v.MOBILE_ICON}<wcm-text variant="small-regular" color="accent">WalletConnect</wcm-text></div><div class="wcm-slider"><div class="wcm-track">${[...Array(r)].map((a,t)=>{const l=o[t%o.length];return l?x`<wcm-wallet-image walletId="${l.id}" imageId="${l.image_id}"></wcm-wallet-image>`:v.WALLET_PLACEHOLDER})}</div><wcm-button-big @click="${c.handleAndroidLinking}"><wcm-text variant="medium-regular" color="inverse">Select Wallet</wcm-text></wcm-button-big></div></wcm-modal-content><wcm-info-footer><wcm-text color="secondary" variant="small-thin">Choose WalletConnect to see supported apps on your device</wcm-text></wcm-info-footer>`}};Ie.styles=[h.globalCss,co],Ie=ho([e$2("wcm-android-wallet-selection")],Ie);const wo=i$3`@keyframes loading{to{stroke-dashoffset:0}}@keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(1px,0,0)}30%,50%,70%{transform:translate3d(-2px,0,0)}40%,60%{transform:translate3d(2px,0,0)}}:host{display:flex;flex-direction:column;align-items:center}div{position:relative;width:110px;height:110px;display:flex;justify-content:center;align-items:center;margin:40px 0 20px 0;transform:translate3d(0,0,0)}svg{position:absolute;width:110px;height:110px;fill:none;stroke:transparent;stroke-linecap:round;stroke-width:2px;top:0;left:0}use{stroke:var(--wcm-accent-color);animation:loading 1s linear infinite}wcm-wallet-image{border-radius:var(--wcm-wallet-icon-large-border-radius);width:90px;height:90px}wcm-text{margin-bottom:40px}.wcm-error svg{stroke:var(--wcm-error-color)}.wcm-error use{display:none}.wcm-error{animation:shake .4s cubic-bezier(.36,.07,.19,.97) both}.wcm-stale svg,.wcm-stale use{display:none}`;var po=Object.defineProperty,go=Object.getOwnPropertyDescriptor,K=(e,o,r,a)=>{for(var t=a>1?void 0:a?go(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&po(o,r,t),t};let D=class extends s{constructor(){super(...arguments),this.walletId=void 0,this.imageId=void 0,this.isError=!1,this.isStale=!1,this.label="";}svgLoaderTemplate(){var e,o;const r=(o=(e=X.state.themeVariables)==null?void 0:e["--wcm-wallet-icon-large-border-radius"])!=null?o:h.getPreset("--wcm-wallet-icon-large-border-radius");let a=0;r.includes("%")?a=88/100*parseInt(r,10):a=parseInt(r,10),a*=1.17;const t=317-a*1.57,l=425-a*1.8;return x`<svg viewBox="0 0 110 110" width="110" height="110"><rect id="wcm-loader" x="2" y="2" width="106" height="106" rx="${a}"/><use xlink:href="#wcm-loader" stroke-dasharray="106 ${t}" stroke-dashoffset="${l}"></use></svg>`}render(){const e={"wcm-error":this.isError,"wcm-stale":this.isStale};return x`<div class="${o(e)}">${this.svgLoaderTemplate()}<wcm-wallet-image walletId="${l(this.walletId)}" imageId="${l(this.imageId)}"></wcm-wallet-image></div><wcm-text variant="medium-regular" color="${this.isError?"error":"primary"}">${this.isError?"Connection declined":this.label}</wcm-text>`}};D.styles=[h.globalCss,wo],K([n$1()],D.prototype,"walletId",2),K([n$1()],D.prototype,"imageId",2),K([n$1({type:Boolean})],D.prototype,"isError",2),K([n$1({type:Boolean})],D.prototype,"isStale",2),K([n$1()],D.prototype,"label",2),D=K([e$2("wcm-connector-waiting")],D);const G={manualWallets(){var e,o;const{mobileWallets:r,desktopWallets:a}=C$1.state,t=(e=G.recentWallet())==null?void 0:e.id,l=i$4.isMobile()?r:a,i=l?.filter(s=>t!==s.id);return (o=i$4.isMobile()?i?.map(({id:s,name:$,links:f})=>({id:s,name:$,mobile:f,links:f})):i?.map(({id:s,name:$,links:f})=>({id:s,name:$,desktop:f,links:f})))!=null?o:[]},recentWallet(){return c.getRecentWallet()},recomendedWallets(e=!1){var o;const r=e||(o=G.recentWallet())==null?void 0:o.id,{recomendedWallets:a}=G$1.state;return a.filter(t=>r!==t.id)}},Z={onConnecting(e){c.goToConnectingView(e);},manualWalletsTemplate(){return G.manualWallets().map(e=>x`<wcm-wallet-button walletId="${e.id}" name="${e.name}" .onClick="${()=>this.onConnecting(e)}"></wcm-wallet-button>`)},recomendedWalletsTemplate(e=!1){return G.recomendedWallets(e).map(o=>x`<wcm-wallet-button name="${o.name}" walletId="${o.id}" imageId="${o.image_id}" .onClick="${()=>this.onConnecting(o)}"></wcm-wallet-button>`)},recentWalletTemplate(){const e=G.recentWallet();if(e)return x`<wcm-wallet-button name="${e.name}" walletId="${e.id}" imageId="${l(e.image_id)}" .recent="${!0}" .onClick="${()=>this.onConnecting(e)}"></wcm-wallet-button>`}},vo=i$3`.wcm-grid{display:grid;grid-template-columns:repeat(4,80px);justify-content:space-between}.wcm-desktop-title,.wcm-mobile-title{display:flex;align-items:center}.wcm-mobile-title{justify-content:space-between;margin-bottom:20px;margin-top:-10px}.wcm-desktop-title{margin-bottom:10px;padding:0 10px}.wcm-subtitle{display:flex;align-items:center}.wcm-subtitle:last-child path{fill:var(--wcm-color-fg-3)}.wcm-desktop-title svg,.wcm-mobile-title svg{margin-right:6px}.wcm-desktop-title path,.wcm-mobile-title path{fill:var(--wcm-accent-color)}`;var uo=Object.defineProperty,bo=Object.getOwnPropertyDescriptor,fo=(e,o,r,a)=>{for(var t=a>1?void 0:a?bo(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&uo(o,r,t),t};let Ee=class extends s{render(){const{explorerExcludedWalletIds:e,enableExplorer:o}=C$1.state,r=e!=="ALL"&&o,a=Z.manualWalletsTemplate(),t=Z.recomendedWalletsTemplate();let l=[Z.recentWalletTemplate(),...a,...t];l=l.filter(Boolean);const i=l.length>4||r;let s=[];i?s=l.slice(0,3):s=l;const $=Boolean(s.length);return x`<wcm-modal-header .border="${!0}" title="Connect your wallet" .onAction="${c.handleUriCopy}" .actionIcon="${v.COPY_ICON}"></wcm-modal-header><wcm-modal-content><div class="wcm-mobile-title"><div class="wcm-subtitle">${v.MOBILE_ICON}<wcm-text variant="small-regular" color="accent">Mobile</wcm-text></div><div class="wcm-subtitle">${v.SCAN_ICON}<wcm-text variant="small-regular" color="secondary">Scan with your wallet</wcm-text></div></div><wcm-walletconnect-qr></wcm-walletconnect-qr></wcm-modal-content>${$?x`<wcm-modal-footer><div class="wcm-desktop-title">${v.DESKTOP_ICON}<wcm-text variant="small-regular" color="accent">Desktop</wcm-text></div><div class="wcm-grid">${s} ${i?x`<wcm-view-all-wallets-button></wcm-view-all-wallets-button>`:null}</div></wcm-modal-footer>`:null}`}};Ee.styles=[h.globalCss,vo],Ee=fo([e$2("wcm-desktop-wallet-selection")],Ee);const xo=i$3`div{background-color:var(--wcm-color-bg-2);padding:10px 20px 15px 20px;border-top:1px solid var(--wcm-color-bg-3);text-align:center}a{color:var(--wcm-accent-color);text-decoration:none;transition:opacity .2s ease-in-out;display:inline}a:active{opacity:.8}@media(hover:hover){a:hover{opacity:.8}}`;var yo=Object.defineProperty,$o=Object.getOwnPropertyDescriptor,Co=(e,o,r,a)=>{for(var t=a>1?void 0:a?$o(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&yo(o,r,t),t};let Me=class extends s{render(){const{termsOfServiceUrl:e,privacyPolicyUrl:o}=C$1.state;return e??o?x`<div><wcm-text variant="small-regular" color="secondary">By connecting your wallet to this app, you agree to the app's ${e?x`<a href="${e}" target="_blank" rel="noopener noreferrer">Terms of Service</a>`:null} ${e&&o?"and":null} ${o?x`<a href="${o}" target="_blank" rel="noopener noreferrer">Privacy Policy</a>`:null}</wcm-text></div>`:null}};Me.styles=[h.globalCss,xo],Me=Co([e$2("wcm-legal-notice")],Me);const ko=i$3`div{display:grid;grid-template-columns:repeat(4,80px);margin:0 -10px;justify-content:space-between;row-gap:10px}`;var Oo=Object.defineProperty,Wo=Object.getOwnPropertyDescriptor,Io=(e,o,r,a)=>{for(var t=a>1?void 0:a?Wo(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Oo(o,r,t),t};let Le=class extends s{onQrcode(){N$1.push("Qrcode");}render(){const{explorerExcludedWalletIds:e,enableExplorer:o}=C$1.state,r=e!=="ALL"&&o,a=Z.manualWalletsTemplate(),t=Z.recomendedWalletsTemplate();let l=[Z.recentWalletTemplate(),...a,...t];l=l.filter(Boolean);const i=l.length>8||r;let s=[];i?s=l.slice(0,7):s=l;const $=Boolean(s.length);return x`<wcm-modal-header title="Connect your wallet" .onAction="${this.onQrcode}" .actionIcon="${v.QRCODE_ICON}"></wcm-modal-header>${$?x`<wcm-modal-content><div>${s} ${i?x`<wcm-view-all-wallets-button></wcm-view-all-wallets-button>`:null}</div></wcm-modal-content>`:null}`}};Le.styles=[h.globalCss,ko],Le=Io([e$2("wcm-mobile-wallet-selection")],Le);const Eo=i$3`:host{all:initial}.wcm-overlay{top:0;bottom:0;left:0;right:0;position:fixed;z-index:var(--wcm-z-index);overflow:hidden;display:flex;justify-content:center;align-items:center;opacity:0;pointer-events:none;background-color:var(--wcm-overlay-background-color);backdrop-filter:var(--wcm-overlay-backdrop-filter)}@media(max-height:720px) and (orientation:landscape){.wcm-overlay{overflow:scroll;align-items:flex-start;padding:20px 0}}.wcm-active{pointer-events:auto}.wcm-container{position:relative;max-width:360px;width:100%;outline:0;border-radius:var(--wcm-background-border-radius) var(--wcm-background-border-radius) var(--wcm-container-border-radius) var(--wcm-container-border-radius);border:1px solid var(--wcm-color-overlay);overflow:hidden}.wcm-card{width:100%;position:relative;border-radius:var(--wcm-container-border-radius);overflow:hidden;box-shadow:0 6px 14px -6px rgba(10,16,31,.12),0 10px 32px -4px rgba(10,16,31,.1),0 0 0 1px var(--wcm-color-overlay);background-color:var(--wcm-color-bg-1);color:var(--wcm-color-fg-1)}@media(max-width:600px){.wcm-container{max-width:440px;border-radius:var(--wcm-background-border-radius) var(--wcm-background-border-radius) 0 0}.wcm-card{border-radius:var(--wcm-container-border-radius) var(--wcm-container-border-radius) 0 0}.wcm-overlay{align-items:flex-end}}@media(max-width:440px){.wcm-container{border:0}}`;var Mo=Object.defineProperty,Lo=Object.getOwnPropertyDescriptor,Re=(e,o,r,a)=>{for(var t=a>1?void 0:a?Lo(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Mo(o,r,t),t};let ae=class extends s{constructor(){super(),this.open=!1,this.active=!1,this.unsubscribeModal=void 0,this.abortController=void 0,this.unsubscribeModal=Q$1.subscribe(e=>{e.open?this.onOpenModalEvent():this.onCloseModalEvent();});}disconnectedCallback(){var e;(e=this.unsubscribeModal)==null||e.call(this);}get overlayEl(){return c.getShadowRootElement(this,".wcm-overlay")}get containerEl(){return c.getShadowRootElement(this,".wcm-container")}toggleBodyScroll(e){if(document.querySelector("body"))if(e){const o=document.getElementById("wcm-styles");o?.remove();}else document.head.insertAdjacentHTML("beforeend",'<style id="wcm-styles">html,body{touch-action:none;overflow:hidden;overscroll-behavior:contain;}</style>');}onCloseModal(e){e.target===e.currentTarget&&Q$1.close();}onOpenModalEvent(){this.toggleBodyScroll(!1),this.addKeyboardEvents(),this.open=!0,setTimeout(async()=>{const e=c.isMobileAnimation()?{y:["50vh","0vh"]}:{scale:[.98,1]},o=.1,r=.2;await Promise.all([animate(this.overlayEl,{opacity:[0,1]},{delay:o,duration:r}).finished,animate(this.containerEl,e,{delay:o,duration:r}).finished]),this.active=!0;},0);}async onCloseModalEvent(){this.toggleBodyScroll(!0),this.removeKeyboardEvents();const e=c.isMobileAnimation()?{y:["0vh","50vh"]}:{scale:[1,.98]},o=.2;await Promise.all([animate(this.overlayEl,{opacity:[1,0]},{duration:o}).finished,animate(this.containerEl,e,{duration:o}).finished]),this.containerEl.removeAttribute("style"),this.active=!1,this.open=!1;}addKeyboardEvents(){this.abortController=new AbortController,window.addEventListener("keydown",e=>{var o;e.key==="Escape"?Q$1.close():e.key==="Tab"&&((o=e.target)!=null&&o.tagName.includes("wcm-")||this.containerEl.focus());},this.abortController),this.containerEl.focus();}removeKeyboardEvents(){var e;(e=this.abortController)==null||e.abort(),this.abortController=void 0;}render(){const e={"wcm-overlay":!0,"wcm-active":this.active};return x`<wcm-explorer-context></wcm-explorer-context><wcm-theme-context></wcm-theme-context><div id="wcm-modal" class="${o(e)}" @click="${this.onCloseModal}" role="alertdialog" aria-modal="true"><div class="wcm-container" tabindex="0">${this.open?x`<wcm-modal-backcard></wcm-modal-backcard><div class="wcm-card"><wcm-modal-router></wcm-modal-router><wcm-modal-toast></wcm-modal-toast></div>`:null}</div></div>`}};ae.styles=[h.globalCss,Eo],Re([t$1()],ae.prototype,"open",2),Re([t$1()],ae.prototype,"active",2),ae=Re([e$2("wcm-modal")],ae);const Ro=i$3`div{display:flex;margin-top:15px}slot{display:inline-block;margin:0 5px}wcm-button{margin:0 5px}`;var Ao=Object.defineProperty,Po=Object.getOwnPropertyDescriptor,le=(e,o,r,a)=>{for(var t=a>1?void 0:a?Po(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Ao(o,r,t),t};let B=class extends s{constructor(){super(...arguments),this.isMobile=!1,this.isDesktop=!1,this.isWeb=!1,this.isRetry=!1;}onMobile(){i$4.isMobile()?N$1.replace("MobileConnecting"):N$1.replace("MobileQrcodeConnecting");}onDesktop(){N$1.replace("DesktopConnecting");}onWeb(){N$1.replace("WebConnecting");}render(){return x`<div>${this.isRetry?x`<slot></slot>`:null} ${this.isMobile?x`<wcm-button .onClick="${this.onMobile}" .iconLeft="${v.MOBILE_ICON}" variant="outline">Mobile</wcm-button>`:null} ${this.isDesktop?x`<wcm-button .onClick="${this.onDesktop}" .iconLeft="${v.DESKTOP_ICON}" variant="outline">Desktop</wcm-button>`:null} ${this.isWeb?x`<wcm-button .onClick="${this.onWeb}" .iconLeft="${v.GLOBE_ICON}" variant="outline">Web</wcm-button>`:null}</div>`}};B.styles=[h.globalCss,Ro],le([n$1({type:Boolean})],B.prototype,"isMobile",2),le([n$1({type:Boolean})],B.prototype,"isDesktop",2),le([n$1({type:Boolean})],B.prototype,"isWeb",2),le([n$1({type:Boolean})],B.prototype,"isRetry",2),B=le([e$2("wcm-platform-selection")],B);const To=i$3`button{display:flex;flex-direction:column;padding:5px 10px;border-radius:var(--wcm-button-hover-highlight-border-radius);height:100%;justify-content:flex-start}.wcm-icons{width:60px;height:60px;display:flex;flex-wrap:wrap;padding:7px;border-radius:var(--wcm-wallet-icon-border-radius);justify-content:space-between;align-items:center;margin-bottom:5px;background-color:var(--wcm-color-bg-2);box-shadow:inset 0 0 0 1px var(--wcm-color-overlay)}button:active{background-color:var(--wcm-color-overlay)}@media(hover:hover){button:hover{background-color:var(--wcm-color-overlay)}}.wcm-icons img{width:21px;height:21px;object-fit:cover;object-position:center;border-radius:calc(var(--wcm-wallet-icon-border-radius)/ 2);border:1px solid var(--wcm-color-overlay)}.wcm-icons svg{width:21px;height:21px}.wcm-icons img:nth-child(1),.wcm-icons img:nth-child(2),.wcm-icons svg:nth-child(1),.wcm-icons svg:nth-child(2){margin-bottom:4px}wcm-text{width:100%;text-align:center}#wallet-placeholder-fill{fill:var(--wcm-color-bg-3)}#wallet-placeholder-dash{stroke:var(--wcm-color-overlay)}`;var jo=Object.defineProperty,_o=Object.getOwnPropertyDescriptor,Do=(e,o,r,a)=>{for(var t=a>1?void 0:a?_o(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&jo(o,r,t),t};let Ae=class extends s{onClick(){N$1.push("WalletExplorer");}render(){const{recomendedWallets:e}=G$1.state,o=G.manualWallets(),r=[...e,...o].reverse().slice(0,4);return x`<button @click="${this.onClick}"><div class="wcm-icons">${r.map(a=>{const t=c.getWalletIcon(a);if(t)return x`<img src="${t}">`;const l=c.getWalletIcon({id:a.id});return l?x`<img src="${l}">`:v.WALLET_PLACEHOLDER})} ${[...Array(4-r.length)].map(()=>v.WALLET_PLACEHOLDER)}</div><wcm-text variant="xsmall-regular">View All</wcm-text></button>`}};Ae.styles=[h.globalCss,To],Ae=Do([e$2("wcm-view-all-wallets-button")],Ae);const No=i$3`.wcm-qr-container{width:100%;display:flex;justify-content:center;align-items:center;aspect-ratio:1/1}`;var Zo=Object.defineProperty,So=Object.getOwnPropertyDescriptor,de=(e,o,r,a)=>{for(var t=a>1?void 0:a?So(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Zo(o,r,t),t};let Y=class extends s{constructor(){super(),this.walletId="",this.imageId="",this.uri="",setTimeout(()=>{const{walletConnectUri:e}=c$3.state;this.uri=e;},0);}get overlayEl(){return c.getShadowRootElement(this,".wcm-qr-container")}render(){return x`<div class="wcm-qr-container">${this.uri?x`<wcm-qrcode size="${this.overlayEl.offsetWidth}" uri="${this.uri}" walletId="${l(this.walletId)}" imageId="${l(this.imageId)}"></wcm-qrcode>`:x`<wcm-spinner></wcm-spinner>`}</div>`}};Y.styles=[h.globalCss,No],de([n$1()],Y.prototype,"walletId",2),de([n$1()],Y.prototype,"imageId",2),de([t$1()],Y.prototype,"uri",2),Y=de([e$2("wcm-walletconnect-qr")],Y);var Bo=Object.defineProperty,Uo=Object.getOwnPropertyDescriptor,Ho=(e,o,r,a)=>{for(var t=a>1?void 0:a?Uo(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Bo(o,r,t),t};let Pe=class extends s{viewTemplate(){return i$4.isAndroid()?x`<wcm-android-wallet-selection></wcm-android-wallet-selection>`:i$4.isMobile()?x`<wcm-mobile-wallet-selection></wcm-mobile-wallet-selection>`:x`<wcm-desktop-wallet-selection></wcm-desktop-wallet-selection>`}render(){return x`${this.viewTemplate()}<wcm-legal-notice></wcm-legal-notice>`}};Pe.styles=[h.globalCss],Pe=Ho([e$2("wcm-connect-wallet-view")],Pe);const zo=i$3`wcm-info-footer{flex-direction:column;align-items:center;display:flex;width:100%;padding:5px 0}wcm-text{text-align:center}`;var Vo=Object.defineProperty,Fo=Object.getOwnPropertyDescriptor,Ke=(e,o,r,a)=>{for(var t=a>1?void 0:a?Fo(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Vo(o,r,t),t};let me=class extends s{constructor(){super(),this.isError=!1,this.openDesktopApp();}onFormatAndRedirect(e){const{desktop:o,name:r}=i$4.getWalletRouterData(),a=o?.native;if(a){const t=i$4.formatNativeUrl(a,e,r);i$4.openHref(t,"_self");}}openDesktopApp(){const{walletConnectUri:e}=c$3.state,o=i$4.getWalletRouterData();c.setRecentWallet(o),e&&this.onFormatAndRedirect(e);}render(){const{name:e,id:o,image_id:r}=i$4.getWalletRouterData(),{isMobile:a,isWeb:t}=c.getCachedRouterWalletPlatforms();return x`<wcm-modal-header title="${e}" .onAction="${c.handleUriCopy}" .actionIcon="${v.COPY_ICON}"></wcm-modal-header><wcm-modal-content><wcm-connector-waiting walletId="${o}" imageId="${l(r)}" label="${`Continue in ${e}...`}" .isError="${this.isError}"></wcm-connector-waiting></wcm-modal-content><wcm-info-footer><wcm-text color="secondary" variant="small-thin">${`Connection can continue loading if ${e} is not installed on your device`}</wcm-text><wcm-platform-selection .isMobile="${a}" .isWeb="${t}" .isRetry="${!0}"><wcm-button .onClick="${this.openDesktopApp.bind(this)}" .iconRight="${v.RETRY_ICON}">Retry</wcm-button></wcm-platform-selection></wcm-info-footer>`}};me.styles=[h.globalCss,zo],Ke([t$1()],me.prototype,"isError",2),me=Ke([e$2("wcm-desktop-connecting-view")],me);const qo=i$3`wcm-info-footer{flex-direction:column;align-items:center;display:flex;width:100%;padding:5px 0}wcm-text{text-align:center}wcm-button{margin-top:15px}`;var Qo=Object.defineProperty,Ko=Object.getOwnPropertyDescriptor,Yo=(e,o,r,a)=>{for(var t=a>1?void 0:a?Ko(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Qo(o,r,t),t};let Te=class extends s{onInstall(e){e&&i$4.openHref(e,"_blank");}render(){const{name:e,id:o,image_id:r,homepage:a}=i$4.getWalletRouterData();return x`<wcm-modal-header title="${e}"></wcm-modal-header><wcm-modal-content><wcm-connector-waiting walletId="${o}" imageId="${l(r)}" label="Not Detected" .isStale="${!0}"></wcm-connector-waiting></wcm-modal-content><wcm-info-footer><wcm-text color="secondary" variant="small-thin">${`Download ${e} to continue. If multiple browser extensions are installed, disable non ${e} ones and try again`}</wcm-text><wcm-button .onClick="${()=>this.onInstall(a)}" .iconLeft="${v.ARROW_DOWN_ICON}">Download</wcm-button></wcm-info-footer>`}};Te.styles=[h.globalCss,qo],Te=Yo([e$2("wcm-install-wallet-view")],Te);const Go=i$3`wcm-wallet-image{border-radius:var(--wcm-wallet-icon-large-border-radius);width:96px;height:96px;margin-bottom:20px}wcm-info-footer{display:flex;width:100%}.wcm-app-store{justify-content:space-between}.wcm-app-store wcm-wallet-image{margin-right:10px;margin-bottom:0;width:28px;height:28px;border-radius:var(--wcm-wallet-icon-small-border-radius)}.wcm-app-store div{display:flex;align-items:center}.wcm-app-store wcm-button{margin-right:-10px}.wcm-note{flex-direction:column;align-items:center;padding:5px 0}.wcm-note wcm-text{text-align:center}wcm-platform-selection{margin-top:-15px}.wcm-note wcm-text{margin-top:15px}.wcm-note wcm-text span{color:var(--wcm-accent-color)}`;var Xo=Object.defineProperty,Jo=Object.getOwnPropertyDescriptor,Ye=(e,o,r,a)=>{for(var t=a>1?void 0:a?Jo(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&Xo(o,r,t),t};let he=class extends s{constructor(){super(),this.isError=!1,this.openMobileApp();}onFormatAndRedirect(e,o=!1){const{mobile:r,name:a}=i$4.getWalletRouterData(),t=r?.native,l=r?.universal;if(t&&!o){const i=i$4.formatNativeUrl(t,e,a);i$4.openHref(i,"_self");}else if(l){const i=i$4.formatUniversalUrl(l,e,a);i$4.openHref(i,"_self");}}openMobileApp(e=!1){const{walletConnectUri:o}=c$3.state,r=i$4.getWalletRouterData();c.setRecentWallet(r),o&&this.onFormatAndRedirect(o,e);}onGoToAppStore(e){e&&i$4.openHref(e,"_blank");}render(){const{name:e,id:o,image_id:r,app:a,mobile:t}=i$4.getWalletRouterData(),{isWeb:l$1}=c.getCachedRouterWalletPlatforms(),i=a?.ios,s=t?.universal;return x`<wcm-modal-header title="${e}"></wcm-modal-header><wcm-modal-content><wcm-connector-waiting walletId="${o}" imageId="${l(r)}" label="Tap 'Open' to continue…" .isError="${this.isError}"></wcm-connector-waiting></wcm-modal-content><wcm-info-footer class="wcm-note"><wcm-platform-selection .isWeb="${l$1}" .isRetry="${!0}"><wcm-button .onClick="${()=>this.openMobileApp(!1)}" .iconRight="${v.RETRY_ICON}">Retry</wcm-button></wcm-platform-selection>${s?x`<wcm-text color="secondary" variant="small-thin">Still doesn't work? <span tabindex="0" @click="${()=>this.openMobileApp(!0)}">Try this alternate link</span></wcm-text>`:null}</wcm-info-footer><wcm-info-footer class="wcm-app-store"><div><wcm-wallet-image walletId="${o}" imageId="${l(r)}"></wcm-wallet-image><wcm-text>${`Get ${e}`}</wcm-text></div><wcm-button .iconRight="${v.ARROW_RIGHT_ICON}" .onClick="${()=>this.onGoToAppStore(i)}" variant="ghost">App Store</wcm-button></wcm-info-footer>`}};he.styles=[h.globalCss,Go],Ye([t$1()],he.prototype,"isError",2),he=Ye([e$2("wcm-mobile-connecting-view")],he);const er=i$3`wcm-info-footer{flex-direction:column;align-items:center;display:flex;width:100%;padding:5px 0}wcm-text{text-align:center}`;var tr=Object.defineProperty,or=Object.getOwnPropertyDescriptor,rr=(e,o,r,a)=>{for(var t=a>1?void 0:a?or(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&tr(o,r,t),t};let je=class extends s{render(){const{name:e,id:o,image_id:r}=i$4.getWalletRouterData(),{isDesktop:a,isWeb:t}=c.getCachedRouterWalletPlatforms();return x`<wcm-modal-header title="${e}" .onAction="${c.handleUriCopy}" .actionIcon="${v.COPY_ICON}"></wcm-modal-header><wcm-modal-content><wcm-walletconnect-qr walletId="${o}" imageId="${l(r)}"></wcm-walletconnect-qr></wcm-modal-content><wcm-info-footer><wcm-text color="secondary" variant="small-thin">${`Scan this QR Code with your phone's camera or inside ${e} app`}</wcm-text><wcm-platform-selection .isDesktop="${a}" .isWeb="${t}"></wcm-platform-selection></wcm-info-footer>`}};je.styles=[h.globalCss,er],je=rr([e$2("wcm-mobile-qr-connecting-view")],je);var ar=Object.defineProperty,lr=Object.getOwnPropertyDescriptor,ir=(e,o,r,a)=>{for(var t=a>1?void 0:a?lr(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&ar(o,r,t),t};let _e=class extends s{render(){return x`<wcm-modal-header title="Scan the code" .onAction="${c.handleUriCopy}" .actionIcon="${v.COPY_ICON}"></wcm-modal-header><wcm-modal-content><wcm-walletconnect-qr></wcm-walletconnect-qr></wcm-modal-content>`}};_e.styles=[h.globalCss],_e=ir([e$2("wcm-qrcode-view")],_e);const nr=i$3`wcm-modal-content{height:clamp(200px,60vh,600px);display:block;overflow:scroll;scrollbar-width:none;position:relative;margin-top:1px}.wcm-grid{display:grid;grid-template-columns:repeat(4,80px);justify-content:space-between;margin:-15px -10px;padding-top:20px}wcm-modal-content::after,wcm-modal-content::before{content:'';position:fixed;pointer-events:none;z-index:1;width:100%;height:20px;opacity:1}wcm-modal-content::before{box-shadow:0 -1px 0 0 var(--wcm-color-bg-1);background:linear-gradient(var(--wcm-color-bg-1),rgba(255,255,255,0))}wcm-modal-content::after{box-shadow:0 1px 0 0 var(--wcm-color-bg-1);background:linear-gradient(rgba(255,255,255,0),var(--wcm-color-bg-1));top:calc(100% - 20px)}wcm-modal-content::-webkit-scrollbar{display:none}.wcm-placeholder-block{display:flex;justify-content:center;align-items:center;height:100px;overflow:hidden}.wcm-empty,.wcm-loading{display:flex}.wcm-loading .wcm-placeholder-block{height:100%}.wcm-end-reached .wcm-placeholder-block{height:0;opacity:0}.wcm-empty .wcm-placeholder-block{opacity:1;height:100%}wcm-wallet-button{margin:calc((100% - 60px)/ 3) 0}`;var cr=Object.defineProperty,sr=Object.getOwnPropertyDescriptor,ie=(e,o,r,a)=>{for(var t=a>1?void 0:a?sr(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&cr(o,r,t),t};const De=40;let U=class extends s{constructor(){super(...arguments),this.loading=!G$1.state.wallets.listings.length,this.firstFetch=!G$1.state.wallets.listings.length,this.search="",this.endReached=!1,this.intersectionObserver=void 0,this.searchDebounce=c.debounce(e=>{e.length>=3?(this.firstFetch=!0,this.endReached=!1,this.search=e,G$1.resetSearch(),this.fetchWallets()):this.search&&(this.search="",this.endReached=this.isLastPage(),G$1.resetSearch());});}firstUpdated(){this.createPaginationObserver();}disconnectedCallback(){var e;(e=this.intersectionObserver)==null||e.disconnect();}get placeholderEl(){return c.getShadowRootElement(this,".wcm-placeholder-block")}createPaginationObserver(){this.intersectionObserver=new IntersectionObserver(([e])=>{e.isIntersecting&&!(this.search&&this.firstFetch)&&this.fetchWallets();}),this.intersectionObserver.observe(this.placeholderEl);}isLastPage(){const{wallets:e,search:o}=G$1.state,{listings:r,total:a}=this.search?o:e;return a<=De||r.length>=a}async fetchWallets(){var e;const{wallets:o,search:r}=G$1.state,{listings:a,total:t,page:l}=this.search?r:o;if(!this.endReached&&(this.firstFetch||t>De&&a.length<t))try{this.loading=!0;const i=(e=c$3.state.chains)==null?void 0:e.join(","),{listings:s}=await G$1.getWallets({page:this.firstFetch?1:l+1,entries:De,search:this.search,version:2,chains:i}),$=s.map(f=>c.getWalletIcon(f));await Promise.all([...$.map(async f=>c.preloadImage(f)),i$4.wait(300)]),this.endReached=this.isLastPage();}catch(i){console.error(i),Y$1.openToast(c.getErrorMessage(i),"error");}finally{this.loading=!1,this.firstFetch=!1;}}onConnect(e){i$4.isAndroid()?c.handleMobileLinking(e):c.goToConnectingView(e);}onSearchChange(e){const{value:o}=e.target;this.searchDebounce(o);}render(){const{wallets:e,search:o$1}=G$1.state,{listings:r}=this.search?o$1:e,a=this.loading&&!r.length,t=this.search.length>=3;let l=Z.manualWalletsTemplate(),i=Z.recomendedWalletsTemplate(!0);t&&(l=l.filter(({values:f})=>c.caseSafeIncludes(f[0],this.search)),i=i.filter(({values:f})=>c.caseSafeIncludes(f[0],this.search)));const s=!this.loading&&!r.length&&!i.length,$={"wcm-loading":a,"wcm-end-reached":this.endReached||!this.loading,"wcm-empty":s};return x`<wcm-modal-header><wcm-search-input .onChange="${this.onSearchChange.bind(this)}"></wcm-search-input></wcm-modal-header><wcm-modal-content class="${o($)}"><div class="wcm-grid">${a?null:l} ${a?null:i} ${a?null:r.map(f=>x`${f?x`<wcm-wallet-button imageId="${f.image_id}" name="${f.name}" walletId="${f.id}" .onClick="${()=>this.onConnect(f)}"></wcm-wallet-button>`:null}`)}</div><div class="wcm-placeholder-block">${s?x`<wcm-text variant="big-bold" color="secondary">No results found</wcm-text>`:null} ${!s&&this.loading?x`<wcm-spinner></wcm-spinner>`:null}</div></wcm-modal-content>`}};U.styles=[h.globalCss,nr],ie([t$1()],U.prototype,"loading",2),ie([t$1()],U.prototype,"firstFetch",2),ie([t$1()],U.prototype,"search",2),ie([t$1()],U.prototype,"endReached",2),U=ie([e$2("wcm-wallet-explorer-view")],U);const dr=i$3`wcm-info-footer{flex-direction:column;align-items:center;display:flex;width:100%;padding:5px 0}wcm-text{text-align:center}`;var mr=Object.defineProperty,hr=Object.getOwnPropertyDescriptor,Ge=(e,o,r,a)=>{for(var t=a>1?void 0:a?hr(o,r):o,l=e.length-1,i;l>=0;l--)(i=e[l])&&(t=(a?i(o,r,t):i(t))||t);return a&&t&&mr(o,r,t),t};let we=class extends s{constructor(){super(),this.isError=!1,this.openWebWallet();}onFormatAndRedirect(e){const{desktop:o,name:r}=i$4.getWalletRouterData(),a=o?.universal;if(a){const t=i$4.formatUniversalUrl(a,e,r);i$4.openHref(t,"_blank");}}openWebWallet(){const{walletConnectUri:e}=c$3.state,o=i$4.getWalletRouterData();c.setRecentWallet(o),e&&this.onFormatAndRedirect(e);}render(){const{name:e,id:o,image_id:r}=i$4.getWalletRouterData(),{isMobile:a,isDesktop:t}=c.getCachedRouterWalletPlatforms(),l$1=i$4.isMobile();return x`<wcm-modal-header title="${e}" .onAction="${c.handleUriCopy}" .actionIcon="${v.COPY_ICON}"></wcm-modal-header><wcm-modal-content><wcm-connector-waiting walletId="${o}" imageId="${l(r)}" label="${`Continue in ${e}...`}" .isError="${this.isError}"></wcm-connector-waiting></wcm-modal-content><wcm-info-footer><wcm-text color="secondary" variant="small-thin">${`${e} web app has opened in a new tab. Go there, accept the connection, and come back`}</wcm-text><wcm-platform-selection .isMobile="${a}" .isDesktop="${l$1?!1:t}" .isRetry="${!0}"><wcm-button .onClick="${this.openWebWallet.bind(this)}" .iconRight="${v.RETRY_ICON}">Retry</wcm-button></wcm-platform-selection></wcm-info-footer>`}};we.styles=[h.globalCss,dr],Ge([t$1()],we.prototype,"isError",2),we=Ge([e$2("wcm-web-connecting-view")],we);

	var index = /*#__PURE__*/Object.freeze({
		__proto__: null,
		get WcmModal () { return ae; },
		get WcmQrCode () { return j; }
	});

})();
window.global=window,function(t){"use strict";function e(){}const n=t=>t;function r(t,e){for(const n in e)t[n]=e[n];return t}function o(t){return t()}function i(){return Object.create(null)}function a(t){t.forEach(o)}function s(t){return"function"==typeof t}function c(t,e){return t!=t?e==e:t!==e||t&&"object"==typeof t||"function"==typeof t}let l;function u(t,e){return l||(l=document.createElement("a")),l.href=e,t===l.href}function d(t,...n){if(null==t)return e;const r=t.subscribe(...n);return r.unsubscribe?()=>r.unsubscribe():r}function h(t){let e;return d(t,(t=>e=t))(),e}function f(t,e,n){t.$$.on_destroy.push(d(e,n))}function p(t){const e={};for(const n in t)"$"!==n[0]&&(e[n]=t[n]);return e}function g(t,e,n){return t.set(n),e}const m="undefined"!=typeof window;let w=m?()=>window.performance.now():()=>Date.now(),b=m?t=>requestAnimationFrame(t):e;const y=new Set;function v(t){y.forEach((e=>{e.c(t)||(y.delete(e),e.f())})),0!==y.size&&b(v)}function _(t){let e;return 0===y.size&&b(v),{promise:new Promise((n=>{y.add(e={c:t,f:n})})),abort(){y.delete(e)}}}function x(t,e){t.appendChild(e)}function k(t){if(!t)return document;const e=t.getRootNode?t.getRootNode():t.ownerDocument;return e&&e.host?e:t.ownerDocument}function M(t){const e=A("style");return function(t,e){x(t.head||t,e),e.sheet}(k(t),e),e.sheet}function C(t,e,n){t.insertBefore(e,n||null)}function S(t){t.parentNode&&t.parentNode.removeChild(t)}function E(t,e){for(let n=0;n<t.length;n+=1)t[n]&&t[n].d(e)}function A(t){return document.createElement(t)}function I(t){return document.createElementNS("http://www.w3.org/2000/svg",t)}function T(t){return document.createTextNode(t)}function R(){return T(" ")}function O(){return T("")}function N(t,e,n,r){return t.addEventListener(e,n,r),()=>t.removeEventListener(e,n,r)}function B(t){return function(e){return e.stopPropagation(),t.call(this,e)}}function $(t,e,n){null==n?t.removeAttribute(e):t.getAttribute(e)!==n&&t.setAttribute(e,n)}function P(t,e,n){e in t?t[e]="boolean"==typeof t[e]&&""===n||n:$(t,e,n)}function U(t,e){e=""+e,t.wholeText!==e&&(t.data=e)}function L(t,e){t.value=null==e?"":e}function j(t,e,n,r){null===n?t.style.removeProperty(e):t.style.setProperty(e,n,r?"important":"")}function z(t,e){for(let n=0;n<t.options.length;n+=1){const r=t.options[n];if(r.__value===e)return void(r.selected=!0)}t.selectedIndex=-1}function q(t,e,n){t.classList[n?"add":"remove"](e)}class D{constructor(t=!1){this.is_svg=!1,this.is_svg=t,this.e=this.n=null}c(t){this.h(t)}m(t,e,n=null){this.e||(this.is_svg?this.e=I(e.nodeName):this.e=A(e.nodeName),this.t=e,this.c(t)),this.i(n)}h(t){this.e.innerHTML=t,this.n=Array.from(this.e.childNodes)}i(t){for(let e=0;e<this.n.length;e+=1)C(this.t,this.n[e],t)}p(t){this.d(),this.h(t),this.i(this.a)}d(){this.n.forEach(S)}}function F(t){const e={};for(const n of t)e[n.name]=n.value;return e}const W=new Map;let H,Y=0;function K(t,e,n,r,o,i,a,s=0){const c=16.666/r;let l="{\n";for(let t=0;t<=1;t+=c){const r=e+(n-e)*i(t);l+=100*t+`%{${a(r,1-r)}}\n`}const u=l+`100% {${a(n,1-n)}}\n}`,d=`__svelte_${function(t){let e=5381,n=t.length;for(;n--;)e=(e<<5)-e^t.charCodeAt(n);return e>>>0}(u)}_${s}`,h=k(t),{stylesheet:f,rules:p}=W.get(h)||function(t,e){const n={stylesheet:M(e),rules:{}};return W.set(t,n),n}(h,t);p[d]||(p[d]=!0,f.insertRule(`@keyframes ${d} ${u}`,f.cssRules.length));const g=t.style.animation||"";return t.style.animation=`${g?`${g}, `:""}${d} ${r}ms linear ${o}ms 1 both`,Y+=1,d}function J(t,e){const n=(t.style.animation||"").split(", "),r=n.filter(e?t=>t.indexOf(e)<0:t=>-1===t.indexOf("__svelte")),o=n.length-r.length;o&&(t.style.animation=r.join(", "),Y-=o,Y||b((()=>{Y||(W.forEach((t=>{const{ownerNode:e}=t.stylesheet;e&&S(e)})),W.clear())})))}function V(t){H=t}function Q(t){(function(){if(!H)throw new Error("Function called outside component initialization");return H})().$$.on_mount.push(t)}const Z=[],G=[],X=[],tt=[],et=Promise.resolve();let nt=!1;function rt(t){X.push(t)}const ot=new Set;let it,at=0;function st(){if(0!==at)return;const t=H;do{try{for(;at<Z.length;){const t=Z[at];at++,V(t),ct(t.$$)}}catch(t){throw Z.length=0,at=0,t}for(V(null),Z.length=0,at=0;G.length;)G.pop()();for(let t=0;t<X.length;t+=1){const e=X[t];ot.has(e)||(ot.add(e),e())}X.length=0}while(Z.length);for(;tt.length;)tt.pop()();nt=!1,ot.clear(),V(t)}function ct(t){if(null!==t.fragment){t.update(),a(t.before_update);const e=t.dirty;t.dirty=[-1],t.fragment&&t.fragment.p(t.ctx,e),t.after_update.forEach(rt)}}function lt(){return it||(it=Promise.resolve(),it.then((()=>{it=null}))),it}function ut(t,e,n){t.dispatchEvent(function(t,e,{bubbles:n=!1,cancelable:r=!1}={}){const o=document.createEvent("CustomEvent");return o.initCustomEvent(t,n,r,e),o}(`${e?"intro":"outro"}${n}`))}const dt=new Set;let ht;function ft(){ht={r:0,c:[],p:ht}}function pt(){ht.r||a(ht.c),ht=ht.p}function gt(t,e){t&&t.i&&(dt.delete(t),t.i(e))}function mt(t,e,n,r){if(t&&t.o){if(dt.has(t))return;dt.add(t),ht.c.push((()=>{dt.delete(t),r&&(n&&t.d(1),r())})),t.o(e)}else r&&r()}const wt={duration:0};function bt(t,r,o){const i={direction:"in"};let a,c,l=r(t,o,i),u=!1,d=0;function h(){a&&J(t,a)}function f(){const{delay:r=0,duration:o=300,easing:i=n,tick:s=e,css:f}=l||wt;f&&(a=K(t,0,1,o,r,i,f,d++)),s(0,1);const p=w()+r,g=p+o;c&&c.abort(),u=!0,rt((()=>ut(t,!0,"start"))),c=_((e=>{if(u){if(e>=g)return s(1,0),ut(t,!0,"end"),h(),u=!1;if(e>=p){const t=i((e-p)/o);s(t,1-t)}}return u}))}let p=!1;return{start(){p||(p=!0,J(t),s(l)?(l=l(i),lt().then(f)):f())},invalidate(){p=!1},end(){u&&(h(),u=!1)}}}function yt(t,r,o){const i={direction:"out"};let c,l=r(t,o,i),u=!0;const d=ht;function h(){const{delay:r=0,duration:o=300,easing:i=n,tick:s=e,css:h}=l||wt;h&&(c=K(t,1,0,o,r,i,h));const f=w()+r,p=f+o;rt((()=>ut(t,!1,"start"))),_((e=>{if(u){if(e>=p)return s(0,1),ut(t,!1,"end"),--d.r||a(d.c),!1;if(e>=f){const t=i((e-f)/o);s(1-t,t)}}return u}))}return d.r+=1,s(l)?lt().then((()=>{l=l(i),h()})):h(),{end(e){e&&l.tick&&l.tick(1,0),u&&(c&&J(t,c),u=!1)}}}function vt(t,r,o,i){const c={direction:"both"};let l=r(t,o,c),u=i?0:1,d=null,h=null,f=null;function p(){f&&J(t,f)}function g(t,e){const n=t.b-u;return e*=Math.abs(n),{a:u,b:t.b,d:n,duration:e,start:t.start,end:t.start+e,group:t.group}}function m(r){const{delay:o=0,duration:i=300,easing:s=n,tick:c=e,css:m}=l||wt,b={start:w()+o,b:r};r||(b.group=ht,ht.r+=1),d||h?h=b:(m&&(p(),f=K(t,u,r,i,o,s,m)),r&&c(0,1),d=g(b,i),rt((()=>ut(t,r,"start"))),_((e=>{if(h&&e>h.start&&(d=g(h,i),h=null,ut(t,d.b,"start"),m&&(p(),f=K(t,u,d.b,d.duration,0,s,l.css))),d)if(e>=d.end)c(u=d.b,1-u),ut(t,d.b,"end"),h||(d.b?p():--d.group.r||a(d.group.c)),d=null;else if(e>=d.start){const t=e-d.start;u=d.a+d.d*s(t/d.duration),c(u,1-u)}return!(!d&&!h)})))}return{run(t){s(l)?lt().then((()=>{l=l(c),m(t)})):m(t)},end(){p(),d=h=null}}}const _t="undefined"!=typeof window?window:"undefined"!=typeof globalThis?globalThis:global;function xt(t,e){-1===t.$$.dirty[0]&&(Z.push(t),nt||(nt=!0,et.then(st)),t.$$.dirty.fill(0)),t.$$.dirty[e/31|0]|=1<<e%31}function kt(t,n,r,c,l,u,d,h=[-1]){const f=H;V(t);const p=t.$$={fragment:null,ctx:[],props:u,update:e,not_equal:l,bound:i(),on_mount:[],on_destroy:[],on_disconnect:[],before_update:[],after_update:[],context:new Map(n.context||(f?f.$$.context:[])),callbacks:i(),dirty:h,skip_bound:!1,root:n.target||f.$$.root};d&&d(p.root);let g=!1;if(p.ctx=r?r(t,n.props||{},((e,n,...r)=>{const o=r.length?r[0]:n;return p.ctx&&l(p.ctx[e],p.ctx[e]=o)&&(!p.skip_bound&&p.bound[e]&&p.bound[e](o),g&&xt(t,e)),n})):[],p.update(),g=!0,a(p.before_update),p.fragment=!!c&&c(p.ctx),n.target){if(n.hydrate){const t=function(t){return Array.from(t.childNodes)}(n.target);p.fragment&&p.fragment.l(t),t.forEach(S)}else p.fragment&&p.fragment.c();n.intro&&gt(t.$$.fragment),function(t,e,n,r){const{fragment:i,after_update:c}=t.$$;i&&i.m(e,n),r||rt((()=>{const e=t.$$.on_mount.map(o).filter(s);t.$$.on_destroy?t.$$.on_destroy.push(...e):a(e),t.$$.on_mount=[]})),c.forEach(rt)}(t,n.target,n.anchor,n.customElement),st()}V(f)}let Mt;function Ct(t){const e=t-1;return e*e*e+1}function St(t,{delay:e=0,duration:n=400,easing:r=Ct,x:o=0,y:i=0,opacity:a=0}={}){const s=getComputedStyle(t),c=+s.opacity,l="none"===s.transform?"":s.transform,u=c*(1-a);return{delay:e,duration:n,easing:r,css:(t,e)=>`\n\t\t\ttransform: ${l} translate(${(1-t)*o}px, ${(1-t)*i}px);\n\t\t\topacity: ${c-u*e}`}}function Et(t,{delay:e=0,duration:n=400,easing:r=Ct}={}){const o=getComputedStyle(t),i=+o.opacity,a=parseFloat(o.height),s=parseFloat(o.paddingTop),c=parseFloat(o.paddingBottom),l=parseFloat(o.marginTop),u=parseFloat(o.marginBottom),d=parseFloat(o.borderTopWidth),h=parseFloat(o.borderBottomWidth);return{delay:e,duration:n,easing:r,css:t=>`overflow: hidden;opacity: ${Math.min(20*t,1)*i};height: ${t*a}px;padding-top: ${t*s}px;padding-bottom: ${t*c}px;margin-top: ${t*l}px;margin-bottom: ${t*u}px;border-top-width: ${t*d}px;border-bottom-width: ${t*h}px;`}}"function"==typeof HTMLElement&&(Mt=class extends HTMLElement{constructor(){super(),this.attachShadow({mode:"open"})}connectedCallback(){const{on_mount:t}=this.$$;this.$$.on_disconnect=t.map(o).filter(s);for(const t in this.$$.slotted)this.appendChild(this.$$.slotted[t])}attributeChangedCallback(t,e,n){this[t]=n}disconnectedCallback(){a(this.$$.on_disconnect)}$destroy(){!function(t,e){const n=t.$$;null!==n.fragment&&(a(n.on_destroy),n.fragment&&n.fragment.d(e),n.on_destroy=n.fragment=null,n.ctx=[])}(this,1),this.$destroy=e}$on(t,n){if(!s(n))return e;const r=this.$$.callbacks[t]||(this.$$.callbacks[t]=[]);return r.push(n),()=>{const t=r.indexOf(n);-1!==t&&r.splice(t,1)}}$set(t){var e;this.$$set&&(e=t,0!==Object.keys(e).length)&&(this.$$.skip_bound=!0,this.$$set(t),this.$$.skip_bound=!1)}});let At={host:"https://engage.getpercs.com",shop:"leisureproject-co.myshopify.com"},It=0;async function Tt(t,e={}){const n=await fetch(`${At.host}/api`,{method:"POST",credentials:"omit",headers:{"Content-Type":"application/json"},body:JSON.stringify({jsonrpc:"2.0",method:t,params:{...e,shop:At.shop},id:++It})}).catch((t=>{if("Failed to fetch"===t.message)throw new Error("Service is temporarily unavailable.  Please try again later");throw t})),r=await n.json();if(r.error)throw new Error(r.error.message);return r.result}async function Rt(t){return Tt("addAccountKey",t)}async function Ot(t){return Tt("getOwnedTokens",t)}function Nt(t){let e=t.host.ownerDocument.querySelectorAll('form[action="/cart/add"]');return 0===e.length&&(e=t.host.ownerDocument.querySelectorAll('form[data-type="add-to-cart-form"]')),e}function Bt(t){const e=new FormData(t),n=Array.from(e.entries()).find((([t])=>"id"===t));return n?n[1]:null}function $t(t,e){const n={};for(const e of t.children)"INPUT"===e.tagName&&(n[e.getAttribute("name")]=e);for(const[r,o]of Object.entries(e)){const e=`properties[${r}]`;if(n[e])n[e].setAttribute("value",o);else{const n=document.createElement("input");n.type="hidden",n.name=e,n.value=o,t.appendChild(n)}}}const Pt=[[["7800134009083"],{"id":2291,"redemptionType":"multiple","brandColor":"#102246","headerText":"Ready to claim free Leisure?","buttonColor":"#102246","rejectMessage":"Sorry, the ETH wallet connected did not hold the correct holographic NFT at the snapshot for this claim. Please try again next month.","headerImageUrl":"https://cdn.shopify.com/s/files/1/0625/5031/1163/files/NEW_PERCS_Banner.png?","backgroundColor":"#ffffff","descriptionText":"Verify you own a Holographic trait Leisure Creature to claim your free monthly 12-pack of Leisure."}]],Ut=[[["7596156715259","7596158419195","8067172892923","7596157993211"],{"id":2175,"brandColor":"#102246","headerText":"Prove you own a Leisure Creature NFT and are a member of the Leisure Project Hydration Club to gain access to this product's special pricing.","buttonColor":"#102246","rejectMessage":"","headerImageUrl":"https://cdn.shopify.com/s/files/1/0625/5031/1163/files/LPHC_Discount_Model.png?v=1687879712","backgroundColor":"#ebc34c","descriptionText":"Only LPHC Members can access exclusive discounts. Copy and paste the discount code if adding multiple discounts.","discount":{"type":"fixed_amount","amount":"83.98"}}],[["7596156715259","7596158419195","8067172892923","7596157993211"],{"id":2176,"brandColor":"#102246","headerText":"Prove you own a Leisure Creature NFT and are a member of the Leisure Project Hydration Club to gain access to this product's special pricing.","buttonColor":"#102246","rejectMessage":"","headerImageUrl":"https://cdn.shopify.com/s/files/1/0625/5031/1163/files/LPHC_Discount_Model.png?v=1687879712","backgroundColor":"#ebc34c","descriptionText":"Only LPHC Members can access exclusive discounts. Copy and paste the discount code if adding multiple discounts.","discount":{"type":"fixed_amount","amount":"41.99"}}],[["7596156715259","7596158419195","8067172892923","7596157993211"],{"id":2177,"brandColor":"#102246","headerText":"Prove you own a Leisure Creature NFT and are a member of the Leisure Project Hydration Club to gain access to this product's special pricing.","buttonColor":"#102246","rejectMessage":"","headerImageUrl":"https://cdn.shopify.com/s/files/1/0625/5031/1163/files/LPHC_Discount_Model.png?v=1687879712","backgroundColor":"#ebc34c","descriptionText":"Only LPHC Members can access exclusive discounts. Copy and paste the discount code if adding multiple discounts.","discount":{"type":"fixed_amount","amount":"125.97"}}],[["7596156715259","7596158419195","8067172892923","7596157993211"],{"id":2174,"brandColor":"#102246","headerText":"Prove you own a Leisure Creature NFT and are a member of the Leisure Project Hydration Club to gain access to this product's special pricing.","buttonColor":"#102246","rejectMessage":"You aren't a member of the Leisure Project Hydration Club. Learn more at https://leisureproject.co/pages/nft ","headerImageUrl":"https://cdn.shopify.com/s/files/1/0625/5031/1163/files/LPHC_Discount_Model.png?v=1687879712","backgroundColor":"#ebc34c","descriptionText":"Only LPHC Members can access exclusive discounts. Copy and paste the discount code if adding multiple discounts.","discount":{"type":"percentage","amount":"13.5"}}],[["7806443487483","7806443520251","7806443323643","7806443258107","7806443028731","7806443454715","7806376345851","7806443356411"],{"id":2173,"brandColor":"#102246","headerText":"Prove you own a Leisure Creature NFT and are a member of the Leisure Project Hydration Club to gain access to this product's special pricing.","buttonColor":"#102246","rejectMessage":"You aren't a member of the Leisure Project Hydration Club. Learn more at https://leisureproject.co/pages/nft ","headerImageUrl":"https://cdn.shopify.com/s/files/1/0625/5031/1163/files/LPHC_Discount_Model.png?v=1687879712","backgroundColor":"#ebc34c","descriptionText":"Only LPHC Members can access exclusive discounts. Copy and paste the discount code if adding multiple discounts.","discount":{"type":"percentage","amount":"20"}}],[["8144147415291","8144146759931","8147442434299"],{"id":2185,"brandColor":"#102246","headerText":"Prove you own a Leisure Creature NFT and are a member of the Leisure Project Hydration Club to gain access to this product's special pricing.","buttonColor":"#102246","rejectMessage":"You aren't a member of the Leisure Project Hydration Club. Learn more at https://leisureproject.co/pages/nft ","headerImageUrl":"https://cdn.shopify.com/s/files/1/0625/5031/1163/files/LPHC_Discount_Model.png?v=1687879712","backgroundColor":"#ebc34c","descriptionText":"Only LPHC Members can access exclusive discounts. Copy and paste the discount code if adding multiple discounts.","discount":{"type":"percentage","amount":"13.5"}}]],Lt={"shopName":"leisureproject.co","brandColor":"#102246","walletConnect":true,"showAccessGateBackButton":true,"derivedKeys":{"enabled":true,"timeout":1200},"percsClient":{"launcher":{"enabled":true,"title":"Discounts Available","description":"Connect a qualified wallet to claim this discount.","illustration":"https://cdn.shopify.com/s/files/1/0625/5031/1163/files/PERCS_Banner.png","hide":true}}},jt=[];function zt(t,n=e){let r;const o=new Set;function i(e){if(c(t,e)&&(t=e,r)){const e=!jt.length;for(const e of o)e[1](),jt.push(e,t);if(e){for(let t=0;t<jt.length;t+=2)jt[t][0](jt[t+1]);jt.length=0}}}return{set:i,update:function(e){i(e(t))},subscribe:function(a,s=e){const c=[a,s];return o.add(c),1===o.size&&(r=n(i)||e),a(t),()=>{o.delete(c),0===o.size&&(r(),r=null)}}}}function qt(t,e,n){if(!t)return zt(n);const r=t.getItem(e);r&&(n=JSON.parse(r));const{subscribe:o,set:i}=zt(n);return{subscribe:o,set(n){t.setItem(e,JSON.stringify(n)),i(n)}}}function Dt(t,e){return qt(window?.sessionStorage,t,e)}function Ft(t,e){return qt(window?.localStorage,t,e)}let Wt=null,Ht=[],Yt=null!=window.ethereum,Kt=!1;const{set:Jt,subscribe:Vt}=zt({isAvailable:Yt,isConnected:Kt,accounts:Ht});function Qt(){Wt=window.ethereum,Wt.addListener("accountsChanged",Gt),Kt=!0}async function Zt(){null!=window.ethereum&&(Wt||(Qt(),Ht=[],Jt({isAvailable:Yt,isConnected:Kt,accounts:Ht})),await window.ethereum.request({method:"eth_requestAccounts"}).then(Gt,console.error))}function Gt(t){t=t.map((t=>t.toLowerCase())).sort(),Ht.toString()!==t.toString()&&(Ht=t,Jt({isAvailable:Yt,isConnected:Kt,accounts:Ht}))}Yt?async function(){if(!Wt){Qt();Gt(await Wt.request({method:"eth_accounts"}))}}().then((()=>{}),console.error):Zt();var Xt={subscribe:Vt,connect:Zt,async disconnect(){Wt.removeListener("accountsChanged",Gt),Wt=null,Kt=!1,Ht=[],Jt({isAvailable:Yt,isConnected:Kt,accounts:Ht})},async requestAccounts(){await window.ethereum.request({method:"eth_requestAccounts"}).then(Gt,console.error)},signPersonalMessage:async(t,e)=>Wt.request({method:"personal_sign",params:[e,t,""]})},te="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function ee(t){var e=t.default;if("function"==typeof e){var n=function(){return e.apply(this,arguments)};n.prototype=e.prototype}else n={};return Object.defineProperty(n,"__esModule",{value:!0}),Object.keys(t).forEach((function(e){var r=Object.getOwnPropertyDescriptor(t,e);Object.defineProperty(n,e,r.get?r:{enumerable:!0,get:function(){return t[e]}})})),n}var ne={},re={};Object.defineProperty(re,"__esModule",{value:!0});var oe=re.getLocalStorage=re.getLocalStorageOrThrow=re.getCrypto=re.getCryptoOrThrow=re.getLocation=re.getLocationOrThrow=re.getNavigator=re.getNavigatorOrThrow=re.getDocument=re.getDocumentOrThrow=re.getFromWindowOrThrow=re.getFromWindow=void 0;function ie(t){let e;return"undefined"!=typeof window&&void 0!==window[t]&&(e=window[t]),e}var ae=re.getFromWindow=ie;function se(t){const e=ie(t);if(!e)throw new Error(`${t} is not defined in Window`);return e}var ce=re.getFromWindowOrThrow=se;var le=re.getDocumentOrThrow=function(){return se("document")};var ue=re.getDocument=function(){return ie("document")};var de=re.getNavigatorOrThrow=function(){return se("navigator")};var he=re.getNavigator=function(){return ie("navigator")};var fe=re.getLocationOrThrow=function(){return se("location")};var pe=re.getLocation=function(){return ie("location")};var ge=re.getCryptoOrThrow=function(){return se("crypto")};var me=re.getCrypto=function(){return ie("crypto")};var we=re.getLocalStorageOrThrow=function(){return se("localStorage")};oe=re.getLocalStorage=function(){return ie("localStorage")},Object.defineProperty(ne,"__esModule",{value:!0});var be=ne.getWindowMetadata=void 0;const ye=re;be=ne.getWindowMetadata=function(){let t,e;try{t=ye.getDocumentOrThrow(),e=ye.getLocationOrThrow()}catch(t){return null}function n(...e){const n=t.getElementsByTagName("meta");for(let t=0;t<n.length;t++){const r=n[t],o=["itemprop","property","name"].map((t=>r.getAttribute(t))).filter((t=>!!t&&e.includes(t)));if(o.length&&o){const t=r.getAttribute("content");if(t)return t}}return""}const r=function(){let e=n("name","og:site_name","og:title","twitter:title");return e||(e=t.title),e}(),o=n("description","og:description","twitter:description","keywords"),i=e.origin,a=function(){const n=t.getElementsByTagName("link"),r=[];for(let t=0;t<n.length;t++){const o=n[t],i=o.getAttribute("rel");if(i&&i.toLowerCase().indexOf("icon")>-1){const t=o.getAttribute("href");if(t)if(-1===t.toLowerCase().indexOf("https:")&&-1===t.toLowerCase().indexOf("http:")&&0!==t.indexOf("//")){let n=e.protocol+"//"+e.host;if(0===t.indexOf("/"))n+=t;else{const r=e.pathname.split("/");r.pop();n+=r.join("/")+"/"+t}r.push(n)}else if(0===t.indexOf("//")){const n=e.protocol+t;r.push(n)}else r.push(t)}}return r}();return{description:o,url:i,icons:a,name:r}};var ve=function(){for(var t=0,e=0,n=arguments.length;e<n;e++)t+=arguments[e].length;var r=Array(t),o=0;for(e=0;e<n;e++)for(var i=arguments[e],a=0,s=i.length;a<s;a++,o++)r[o]=i[a];return r},_e=function(t,e,n){this.name=t,this.version=e,this.os=n,this.type="browser"},xe=function(t){this.version=t,this.type="node",this.name="node",this.os=process.platform},ke=function(t,e,n,r){this.name=t,this.version=e,this.os=n,this.bot=r,this.type="bot-device"},Me=function(){this.type="bot",this.bot=!0,this.name="bot",this.version=null,this.os=null},Ce=function(){this.type="react-native",this.name="react-native",this.version=null,this.os=null},Se=/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/,Ee=3,Ae=[["aol",/AOLShield\/([0-9\._]+)/],["edge",/Edge\/([0-9\._]+)/],["edge-ios",/EdgiOS\/([0-9\._]+)/],["yandexbrowser",/YaBrowser\/([0-9\._]+)/],["kakaotalk",/KAKAOTALK\s([0-9\.]+)/],["samsung",/SamsungBrowser\/([0-9\.]+)/],["silk",/\bSilk\/([0-9._-]+)\b/],["miui",/MiuiBrowser\/([0-9\.]+)$/],["beaker",/BeakerBrowser\/([0-9\.]+)/],["edge-chromium",/EdgA?\/([0-9\.]+)/],["chromium-webview",/(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],["chrome",/(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],["phantomjs",/PhantomJS\/([0-9\.]+)(:?\s|$)/],["crios",/CriOS\/([0-9\.]+)(:?\s|$)/],["firefox",/Firefox\/([0-9\.]+)(?:\s|$)/],["fxios",/FxiOS\/([0-9\.]+)/],["opera-mini",/Opera Mini.*Version\/([0-9\.]+)/],["opera",/Opera\/([0-9\.]+)(?:\s|$)/],["opera",/OPR\/([0-9\.]+)(:?\s|$)/],["ie",/Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],["ie",/MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],["ie",/MSIE\s(7\.0)/],["bb10",/BB10;\sTouch.*Version\/([0-9\.]+)/],["android",/Android\s([0-9\.]+)/],["ios",/Version\/([0-9\._]+).*Mobile.*Safari.*/],["safari",/Version\/([0-9\._]+).*Safari/],["facebook",/FBAV\/([0-9\.]+)/],["instagram",/Instagram\s([0-9\.]+)/],["ios-webview",/AppleWebKit\/([0-9\.]+).*Mobile/],["ios-webview",/AppleWebKit\/([0-9\.]+).*Gecko\)$/],["searchbot",/alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/]],Ie=[["iOS",/iP(hone|od|ad)/],["Android OS",/Android/],["BlackBerry OS",/BlackBerry|BB10/],["Windows Mobile",/IEMobile/],["Amazon OS",/Kindle/],["Windows 3.11",/Win16/],["Windows 95",/(Windows 95)|(Win95)|(Windows_95)/],["Windows 98",/(Windows 98)|(Win98)/],["Windows 2000",/(Windows NT 5.0)|(Windows 2000)/],["Windows XP",/(Windows NT 5.1)|(Windows XP)/],["Windows Server 2003",/(Windows NT 5.2)/],["Windows Vista",/(Windows NT 6.0)/],["Windows 7",/(Windows NT 6.1)/],["Windows 8",/(Windows NT 6.2)/],["Windows 8.1",/(Windows NT 6.3)/],["Windows 10",/(Windows NT 10.0)/],["Windows ME",/Windows ME/],["Open BSD",/OpenBSD/],["Sun OS",/SunOS/],["Chrome OS",/CrOS/],["Linux",/(Linux)|(X11)/],["Mac OS",/(Mac_PowerPC)|(Macintosh)/],["QNX",/QNX/],["BeOS",/BeOS/],["OS/2",/OS\/2/]];function Te(t){return t?Re(t):"undefined"==typeof document&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product?new Ce:"undefined"!=typeof navigator?Re(navigator.userAgent):function(){var t="undefined"!=typeof process&&process.version;return t?new xe(process.version.slice(1)):null}()}function Re(t){var e=function(t){return""!==t&&Ae.reduce((function(e,n){var r=n[0],o=n[1];if(e)return e;var i=o.exec(t);return!!i&&[r,i]}),!1)}(t);if(!e)return null;var n=e[0],r=e[1];if("searchbot"===n)return new Me;var o=r[1]&&r[1].split(/[._]/).slice(0,3);o?o.length<Ee&&(o=ve(o,function(t){for(var e=[],n=0;n<t;n++)e.push("0");return e}(Ee-o.length))):o=[];var i=o.join("."),a=function(t){for(var e=0,n=Ie.length;e<n;e++){var r=Ie[e],o=r[0];if(r[1].exec(t))return o}return null}(t),s=Se.exec(t);return s&&s[1]?new ke(n,i,a,s[1]):new _e(n,i,a)}function Oe(t){return Te(t)}function Ne(){const t=Oe();return t&&t.os?t.os:void 0}function Be(){const t=Ne();return!!t&&t.toLowerCase().includes("android")}function $e(){const t=Ne();return!!t&&(t.toLowerCase().includes("ios")||t.toLowerCase().includes("mac")&&navigator.maxTouchPoints>1)}function Pe(){return!!Ne()&&(Be()||$e())}function Ue(){const t=Oe();return!(!t||!t.name)&&"node"===t.name.toLowerCase()}function Le(){return!Ue()&&!!We()}const je=ae,ze=ce,qe=le,De=ue,Fe=de,We=he,He=fe,Ye=pe,Ke=ge,Je=me,Ve=we,Qe=oe;function Ze(){return be()}const Ge=function(t){if("string"!=typeof t)throw new Error("Cannot safe json parse value of type "+typeof t);try{return JSON.parse(t)}catch(e){return t}},Xe=function(t){return"string"==typeof t?t:JSON.stringify(t)};function tn(t,e){const n=Xe(e),r=Qe();r&&r.setItem(t,n)}function en(t){let e=null,n=null;const r=Qe();return r&&(n=r.getItem(t)),e=n?Ge(n):n,e}function nn(t){const e=Qe();e&&e.removeItem(t)}const rn="WALLETCONNECT_DEEPLINK_CHOICE";function on(t,e){return t.filter((t=>t.name.toLowerCase().includes(e.toLowerCase())))[0]}const an="https://registry.walletconnect.com";function sn(t,e="mobile"){var n;return{name:t.name||"",shortName:t.metadata.shortName||"",color:t.metadata.colors.primary||"",logo:null!==(n=t.image_url.sm)&&void 0!==n?n:"",universalLink:t[e].universal||"",deepLink:t[e].native||""}}var cn=Object.freeze({__proto__:null,detectEnv:Oe,detectOS:Ne,isAndroid:Be,isIOS:$e,isMobile:Pe,isNode:Ue,isBrowser:Le,getFromWindow:je,getFromWindowOrThrow:ze,getDocumentOrThrow:qe,getDocument:De,getNavigatorOrThrow:Fe,getNavigator:We,getLocationOrThrow:He,getLocation:Ye,getCryptoOrThrow:Ke,getCrypto:Je,getLocalStorageOrThrow:Ve,getLocalStorage:Qe,getClientMeta:Ze,safeJsonParse:Ge,safeJsonStringify:Xe,setLocal:tn,getLocal:en,removeLocal:nn,mobileLinkChoiceKey:rn,formatIOSMobile:function(t,e){const n=encodeURIComponent(t);return e.universalLink?`${e.universalLink}/wc?uri=${n}`:e.deepLink?`${e.deepLink}${e.deepLink.endsWith(":")?"//":"/"}wc?uri=${n}`:""},saveMobileLinkInfo:function(t){const e=t.href.split("?")[0];tn(rn,Object.assign(Object.assign({},t),{href:e}))},getMobileRegistryEntry:on,getMobileLinkRegistry:function(t,e){let n=t;return e&&(n=e.map((e=>on(t,e))).filter(Boolean)),n},getWalletRegistryUrl:function(){return an+"/api/v2/wallets"},getDappRegistryUrl:function(){return an+"/api/v2/dapps"},formatMobileRegistryEntry:sn,formatMobileRegistry:function(t,e="mobile"){return Object.values(t).filter((t=>!!t[e].universal||!!t[e].native)).map((t=>sn(t,e)))}});const ln=["session_request","session_update","exchange_key","connect","disconnect","display_uri","modal_closed","transport_open","transport_close","transport_error"],un=["eth_sendTransaction","eth_signTransaction","eth_sign","eth_signTypedData","eth_signTypedData_v1","eth_signTypedData_v2","eth_signTypedData_v3","eth_signTypedData_v4","personal_sign","wallet_addEthereumChain","wallet_switchEthereumChain","wallet_getPermissions","wallet_requestPermissions","wallet_registerOnboarding","wallet_watchAsset","wallet_scanQRCode"];var dn={exports:{}},hn=ee(Object.freeze({__proto__:null,default:{}}));(function(t,e){function n(t,e){if(!t)throw new Error(e||"Assertion failed")}function r(t,e){t.super_=e;var n=function(){};n.prototype=e.prototype,t.prototype=new n,t.prototype.constructor=t}function o(t,e,n){if(o.isBN(t))return t;this.negative=0,this.words=null,this.length=0,this.red=null,null!==t&&("le"!==e&&"be"!==e||(n=e,e=10),this._init(t||0,e||10,n||"be"))}var i;"object"==typeof t?t.exports=o:e.BN=o,o.BN=o,o.wordSize=26;try{i=hn.Buffer}catch(t){}function a(t,e,n){for(var r=0,o=Math.min(t.length,n),i=e;i<o;i++){var a=t.charCodeAt(i)-48;r<<=4,r|=a>=49&&a<=54?a-49+10:a>=17&&a<=22?a-17+10:15&a}return r}function s(t,e,n,r){for(var o=0,i=Math.min(t.length,n),a=e;a<i;a++){var s=t.charCodeAt(a)-48;o*=r,o+=s>=49?s-49+10:s>=17?s-17+10:s}return o}o.isBN=function(t){return t instanceof o||null!==t&&"object"==typeof t&&t.constructor.wordSize===o.wordSize&&Array.isArray(t.words)},o.max=function(t,e){return t.cmp(e)>0?t:e},o.min=function(t,e){return t.cmp(e)<0?t:e},o.prototype._init=function(t,e,r){if("number"==typeof t)return this._initNumber(t,e,r);if("object"==typeof t)return this._initArray(t,e,r);"hex"===e&&(e=16),n(e===(0|e)&&e>=2&&e<=36);var o=0;"-"===(t=t.toString().replace(/\s+/g,""))[0]&&o++,16===e?this._parseHex(t,o):this._parseBase(t,e,o),"-"===t[0]&&(this.negative=1),this.strip(),"le"===r&&this._initArray(this.toArray(),e,r)},o.prototype._initNumber=function(t,e,r){t<0&&(this.negative=1,t=-t),t<67108864?(this.words=[67108863&t],this.length=1):t<4503599627370496?(this.words=[67108863&t,t/67108864&67108863],this.length=2):(n(t<9007199254740992),this.words=[67108863&t,t/67108864&67108863,1],this.length=3),"le"===r&&this._initArray(this.toArray(),e,r)},o.prototype._initArray=function(t,e,r){if(n("number"==typeof t.length),t.length<=0)return this.words=[0],this.length=1,this;this.length=Math.ceil(t.length/3),this.words=new Array(this.length);for(var o=0;o<this.length;o++)this.words[o]=0;var i,a,s=0;if("be"===r)for(o=t.length-1,i=0;o>=0;o-=3)a=t[o]|t[o-1]<<8|t[o-2]<<16,this.words[i]|=a<<s&67108863,this.words[i+1]=a>>>26-s&67108863,(s+=24)>=26&&(s-=26,i++);else if("le"===r)for(o=0,i=0;o<t.length;o+=3)a=t[o]|t[o+1]<<8|t[o+2]<<16,this.words[i]|=a<<s&67108863,this.words[i+1]=a>>>26-s&67108863,(s+=24)>=26&&(s-=26,i++);return this.strip()},o.prototype._parseHex=function(t,e){this.length=Math.ceil((t.length-e)/6),this.words=new Array(this.length);for(var n=0;n<this.length;n++)this.words[n]=0;var r,o,i=0;for(n=t.length-6,r=0;n>=e;n-=6)o=a(t,n,n+6),this.words[r]|=o<<i&67108863,this.words[r+1]|=o>>>26-i&4194303,(i+=24)>=26&&(i-=26,r++);n+6!==e&&(o=a(t,e,n+6),this.words[r]|=o<<i&67108863,this.words[r+1]|=o>>>26-i&4194303),this.strip()},o.prototype._parseBase=function(t,e,n){this.words=[0],this.length=1;for(var r=0,o=1;o<=67108863;o*=e)r++;r--,o=o/e|0;for(var i=t.length-n,a=i%r,c=Math.min(i,i-a)+n,l=0,u=n;u<c;u+=r)l=s(t,u,u+r,e),this.imuln(o),this.words[0]+l<67108864?this.words[0]+=l:this._iaddn(l);if(0!==a){var d=1;for(l=s(t,u,t.length,e),u=0;u<a;u++)d*=e;this.imuln(d),this.words[0]+l<67108864?this.words[0]+=l:this._iaddn(l)}},o.prototype.copy=function(t){t.words=new Array(this.length);for(var e=0;e<this.length;e++)t.words[e]=this.words[e];t.length=this.length,t.negative=this.negative,t.red=this.red},o.prototype.clone=function(){var t=new o(null);return this.copy(t),t},o.prototype._expand=function(t){for(;this.length<t;)this.words[this.length++]=0;return this},o.prototype.strip=function(){for(;this.length>1&&0===this.words[this.length-1];)this.length--;return this._normSign()},o.prototype._normSign=function(){return 1===this.length&&0===this.words[0]&&(this.negative=0),this},o.prototype.inspect=function(){return(this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"};var c=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"],l=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5],u=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];function d(t,e,n){n.negative=e.negative^t.negative;var r=t.length+e.length|0;n.length=r,r=r-1|0;var o=0|t.words[0],i=0|e.words[0],a=o*i,s=67108863&a,c=a/67108864|0;n.words[0]=s;for(var l=1;l<r;l++){for(var u=c>>>26,d=67108863&c,h=Math.min(l,e.length-1),f=Math.max(0,l-t.length+1);f<=h;f++){var p=l-f|0;u+=(a=(o=0|t.words[p])*(i=0|e.words[f])+d)/67108864|0,d=67108863&a}n.words[l]=0|d,c=0|u}return 0!==c?n.words[l]=0|c:n.length--,n.strip()}o.prototype.toString=function(t,e){var r;if(e=0|e||1,16===(t=t||10)||"hex"===t){r="";for(var o=0,i=0,a=0;a<this.length;a++){var s=this.words[a],d=(16777215&(s<<o|i)).toString(16);r=0!=(i=s>>>24-o&16777215)||a!==this.length-1?c[6-d.length]+d+r:d+r,(o+=2)>=26&&(o-=26,a--)}for(0!==i&&(r=i.toString(16)+r);r.length%e!=0;)r="0"+r;return 0!==this.negative&&(r="-"+r),r}if(t===(0|t)&&t>=2&&t<=36){var h=l[t],f=u[t];r="";var p=this.clone();for(p.negative=0;!p.isZero();){var g=p.modn(f).toString(t);r=(p=p.idivn(f)).isZero()?g+r:c[h-g.length]+g+r}for(this.isZero()&&(r="0"+r);r.length%e!=0;)r="0"+r;return 0!==this.negative&&(r="-"+r),r}n(!1,"Base should be between 2 and 36")},o.prototype.toNumber=function(){var t=this.words[0];return 2===this.length?t+=67108864*this.words[1]:3===this.length&&1===this.words[2]?t+=4503599627370496+67108864*this.words[1]:this.length>2&&n(!1,"Number can only safely store up to 53 bits"),0!==this.negative?-t:t},o.prototype.toJSON=function(){return this.toString(16)},o.prototype.toBuffer=function(t,e){return n(void 0!==i),this.toArrayLike(i,t,e)},o.prototype.toArray=function(t,e){return this.toArrayLike(Array,t,e)},o.prototype.toArrayLike=function(t,e,r){var o=this.byteLength(),i=r||Math.max(1,o);n(o<=i,"byte array longer than desired length"),n(i>0,"Requested array length <= 0"),this.strip();var a,s,c="le"===e,l=new t(i),u=this.clone();if(c){for(s=0;!u.isZero();s++)a=u.andln(255),u.iushrn(8),l[s]=a;for(;s<i;s++)l[s]=0}else{for(s=0;s<i-o;s++)l[s]=0;for(s=0;!u.isZero();s++)a=u.andln(255),u.iushrn(8),l[i-s-1]=a}return l},Math.clz32?o.prototype._countBits=function(t){return 32-Math.clz32(t)}:o.prototype._countBits=function(t){var e=t,n=0;return e>=4096&&(n+=13,e>>>=13),e>=64&&(n+=7,e>>>=7),e>=8&&(n+=4,e>>>=4),e>=2&&(n+=2,e>>>=2),n+e},o.prototype._zeroBits=function(t){if(0===t)return 26;var e=t,n=0;return 0==(8191&e)&&(n+=13,e>>>=13),0==(127&e)&&(n+=7,e>>>=7),0==(15&e)&&(n+=4,e>>>=4),0==(3&e)&&(n+=2,e>>>=2),0==(1&e)&&n++,n},o.prototype.bitLength=function(){var t=this.words[this.length-1],e=this._countBits(t);return 26*(this.length-1)+e},o.prototype.zeroBits=function(){if(this.isZero())return 0;for(var t=0,e=0;e<this.length;e++){var n=this._zeroBits(this.words[e]);if(t+=n,26!==n)break}return t},o.prototype.byteLength=function(){return Math.ceil(this.bitLength()/8)},o.prototype.toTwos=function(t){return 0!==this.negative?this.abs().inotn(t).iaddn(1):this.clone()},o.prototype.fromTwos=function(t){return this.testn(t-1)?this.notn(t).iaddn(1).ineg():this.clone()},o.prototype.isNeg=function(){return 0!==this.negative},o.prototype.neg=function(){return this.clone().ineg()},o.prototype.ineg=function(){return this.isZero()||(this.negative^=1),this},o.prototype.iuor=function(t){for(;this.length<t.length;)this.words[this.length++]=0;for(var e=0;e<t.length;e++)this.words[e]=this.words[e]|t.words[e];return this.strip()},o.prototype.ior=function(t){return n(0==(this.negative|t.negative)),this.iuor(t)},o.prototype.or=function(t){return this.length>t.length?this.clone().ior(t):t.clone().ior(this)},o.prototype.uor=function(t){return this.length>t.length?this.clone().iuor(t):t.clone().iuor(this)},o.prototype.iuand=function(t){var e;e=this.length>t.length?t:this;for(var n=0;n<e.length;n++)this.words[n]=this.words[n]&t.words[n];return this.length=e.length,this.strip()},o.prototype.iand=function(t){return n(0==(this.negative|t.negative)),this.iuand(t)},o.prototype.and=function(t){return this.length>t.length?this.clone().iand(t):t.clone().iand(this)},o.prototype.uand=function(t){return this.length>t.length?this.clone().iuand(t):t.clone().iuand(this)},o.prototype.iuxor=function(t){var e,n;this.length>t.length?(e=this,n=t):(e=t,n=this);for(var r=0;r<n.length;r++)this.words[r]=e.words[r]^n.words[r];if(this!==e)for(;r<e.length;r++)this.words[r]=e.words[r];return this.length=e.length,this.strip()},o.prototype.ixor=function(t){return n(0==(this.negative|t.negative)),this.iuxor(t)},o.prototype.xor=function(t){return this.length>t.length?this.clone().ixor(t):t.clone().ixor(this)},o.prototype.uxor=function(t){return this.length>t.length?this.clone().iuxor(t):t.clone().iuxor(this)},o.prototype.inotn=function(t){n("number"==typeof t&&t>=0);var e=0|Math.ceil(t/26),r=t%26;this._expand(e),r>0&&e--;for(var o=0;o<e;o++)this.words[o]=67108863&~this.words[o];return r>0&&(this.words[o]=~this.words[o]&67108863>>26-r),this.strip()},o.prototype.notn=function(t){return this.clone().inotn(t)},o.prototype.setn=function(t,e){n("number"==typeof t&&t>=0);var r=t/26|0,o=t%26;return this._expand(r+1),this.words[r]=e?this.words[r]|1<<o:this.words[r]&~(1<<o),this.strip()},o.prototype.iadd=function(t){var e,n,r;if(0!==this.negative&&0===t.negative)return this.negative=0,e=this.isub(t),this.negative^=1,this._normSign();if(0===this.negative&&0!==t.negative)return t.negative=0,e=this.isub(t),t.negative=1,e._normSign();this.length>t.length?(n=this,r=t):(n=t,r=this);for(var o=0,i=0;i<r.length;i++)e=(0|n.words[i])+(0|r.words[i])+o,this.words[i]=67108863&e,o=e>>>26;for(;0!==o&&i<n.length;i++)e=(0|n.words[i])+o,this.words[i]=67108863&e,o=e>>>26;if(this.length=n.length,0!==o)this.words[this.length]=o,this.length++;else if(n!==this)for(;i<n.length;i++)this.words[i]=n.words[i];return this},o.prototype.add=function(t){var e;return 0!==t.negative&&0===this.negative?(t.negative=0,e=this.sub(t),t.negative^=1,e):0===t.negative&&0!==this.negative?(this.negative=0,e=t.sub(this),this.negative=1,e):this.length>t.length?this.clone().iadd(t):t.clone().iadd(this)},o.prototype.isub=function(t){if(0!==t.negative){t.negative=0;var e=this.iadd(t);return t.negative=1,e._normSign()}if(0!==this.negative)return this.negative=0,this.iadd(t),this.negative=1,this._normSign();var n,r,o=this.cmp(t);if(0===o)return this.negative=0,this.length=1,this.words[0]=0,this;o>0?(n=this,r=t):(n=t,r=this);for(var i=0,a=0;a<r.length;a++)i=(e=(0|n.words[a])-(0|r.words[a])+i)>>26,this.words[a]=67108863&e;for(;0!==i&&a<n.length;a++)i=(e=(0|n.words[a])+i)>>26,this.words[a]=67108863&e;if(0===i&&a<n.length&&n!==this)for(;a<n.length;a++)this.words[a]=n.words[a];return this.length=Math.max(this.length,a),n!==this&&(this.negative=1),this.strip()},o.prototype.sub=function(t){return this.clone().isub(t)};var h=function(t,e,n){var r,o,i,a=t.words,s=e.words,c=n.words,l=0,u=0|a[0],d=8191&u,h=u>>>13,f=0|a[1],p=8191&f,g=f>>>13,m=0|a[2],w=8191&m,b=m>>>13,y=0|a[3],v=8191&y,_=y>>>13,x=0|a[4],k=8191&x,M=x>>>13,C=0|a[5],S=8191&C,E=C>>>13,A=0|a[6],I=8191&A,T=A>>>13,R=0|a[7],O=8191&R,N=R>>>13,B=0|a[8],$=8191&B,P=B>>>13,U=0|a[9],L=8191&U,j=U>>>13,z=0|s[0],q=8191&z,D=z>>>13,F=0|s[1],W=8191&F,H=F>>>13,Y=0|s[2],K=8191&Y,J=Y>>>13,V=0|s[3],Q=8191&V,Z=V>>>13,G=0|s[4],X=8191&G,tt=G>>>13,et=0|s[5],nt=8191&et,rt=et>>>13,ot=0|s[6],it=8191&ot,at=ot>>>13,st=0|s[7],ct=8191&st,lt=st>>>13,ut=0|s[8],dt=8191&ut,ht=ut>>>13,ft=0|s[9],pt=8191&ft,gt=ft>>>13;n.negative=t.negative^e.negative,n.length=19;var mt=(l+(r=Math.imul(d,q))|0)+((8191&(o=(o=Math.imul(d,D))+Math.imul(h,q)|0))<<13)|0;l=((i=Math.imul(h,D))+(o>>>13)|0)+(mt>>>26)|0,mt&=67108863,r=Math.imul(p,q),o=(o=Math.imul(p,D))+Math.imul(g,q)|0,i=Math.imul(g,D);var wt=(l+(r=r+Math.imul(d,W)|0)|0)+((8191&(o=(o=o+Math.imul(d,H)|0)+Math.imul(h,W)|0))<<13)|0;l=((i=i+Math.imul(h,H)|0)+(o>>>13)|0)+(wt>>>26)|0,wt&=67108863,r=Math.imul(w,q),o=(o=Math.imul(w,D))+Math.imul(b,q)|0,i=Math.imul(b,D),r=r+Math.imul(p,W)|0,o=(o=o+Math.imul(p,H)|0)+Math.imul(g,W)|0,i=i+Math.imul(g,H)|0;var bt=(l+(r=r+Math.imul(d,K)|0)|0)+((8191&(o=(o=o+Math.imul(d,J)|0)+Math.imul(h,K)|0))<<13)|0;l=((i=i+Math.imul(h,J)|0)+(o>>>13)|0)+(bt>>>26)|0,bt&=67108863,r=Math.imul(v,q),o=(o=Math.imul(v,D))+Math.imul(_,q)|0,i=Math.imul(_,D),r=r+Math.imul(w,W)|0,o=(o=o+Math.imul(w,H)|0)+Math.imul(b,W)|0,i=i+Math.imul(b,H)|0,r=r+Math.imul(p,K)|0,o=(o=o+Math.imul(p,J)|0)+Math.imul(g,K)|0,i=i+Math.imul(g,J)|0;var yt=(l+(r=r+Math.imul(d,Q)|0)|0)+((8191&(o=(o=o+Math.imul(d,Z)|0)+Math.imul(h,Q)|0))<<13)|0;l=((i=i+Math.imul(h,Z)|0)+(o>>>13)|0)+(yt>>>26)|0,yt&=67108863,r=Math.imul(k,q),o=(o=Math.imul(k,D))+Math.imul(M,q)|0,i=Math.imul(M,D),r=r+Math.imul(v,W)|0,o=(o=o+Math.imul(v,H)|0)+Math.imul(_,W)|0,i=i+Math.imul(_,H)|0,r=r+Math.imul(w,K)|0,o=(o=o+Math.imul(w,J)|0)+Math.imul(b,K)|0,i=i+Math.imul(b,J)|0,r=r+Math.imul(p,Q)|0,o=(o=o+Math.imul(p,Z)|0)+Math.imul(g,Q)|0,i=i+Math.imul(g,Z)|0;var vt=(l+(r=r+Math.imul(d,X)|0)|0)+((8191&(o=(o=o+Math.imul(d,tt)|0)+Math.imul(h,X)|0))<<13)|0;l=((i=i+Math.imul(h,tt)|0)+(o>>>13)|0)+(vt>>>26)|0,vt&=67108863,r=Math.imul(S,q),o=(o=Math.imul(S,D))+Math.imul(E,q)|0,i=Math.imul(E,D),r=r+Math.imul(k,W)|0,o=(o=o+Math.imul(k,H)|0)+Math.imul(M,W)|0,i=i+Math.imul(M,H)|0,r=r+Math.imul(v,K)|0,o=(o=o+Math.imul(v,J)|0)+Math.imul(_,K)|0,i=i+Math.imul(_,J)|0,r=r+Math.imul(w,Q)|0,o=(o=o+Math.imul(w,Z)|0)+Math.imul(b,Q)|0,i=i+Math.imul(b,Z)|0,r=r+Math.imul(p,X)|0,o=(o=o+Math.imul(p,tt)|0)+Math.imul(g,X)|0,i=i+Math.imul(g,tt)|0;var _t=(l+(r=r+Math.imul(d,nt)|0)|0)+((8191&(o=(o=o+Math.imul(d,rt)|0)+Math.imul(h,nt)|0))<<13)|0;l=((i=i+Math.imul(h,rt)|0)+(o>>>13)|0)+(_t>>>26)|0,_t&=67108863,r=Math.imul(I,q),o=(o=Math.imul(I,D))+Math.imul(T,q)|0,i=Math.imul(T,D),r=r+Math.imul(S,W)|0,o=(o=o+Math.imul(S,H)|0)+Math.imul(E,W)|0,i=i+Math.imul(E,H)|0,r=r+Math.imul(k,K)|0,o=(o=o+Math.imul(k,J)|0)+Math.imul(M,K)|0,i=i+Math.imul(M,J)|0,r=r+Math.imul(v,Q)|0,o=(o=o+Math.imul(v,Z)|0)+Math.imul(_,Q)|0,i=i+Math.imul(_,Z)|0,r=r+Math.imul(w,X)|0,o=(o=o+Math.imul(w,tt)|0)+Math.imul(b,X)|0,i=i+Math.imul(b,tt)|0,r=r+Math.imul(p,nt)|0,o=(o=o+Math.imul(p,rt)|0)+Math.imul(g,nt)|0,i=i+Math.imul(g,rt)|0;var xt=(l+(r=r+Math.imul(d,it)|0)|0)+((8191&(o=(o=o+Math.imul(d,at)|0)+Math.imul(h,it)|0))<<13)|0;l=((i=i+Math.imul(h,at)|0)+(o>>>13)|0)+(xt>>>26)|0,xt&=67108863,r=Math.imul(O,q),o=(o=Math.imul(O,D))+Math.imul(N,q)|0,i=Math.imul(N,D),r=r+Math.imul(I,W)|0,o=(o=o+Math.imul(I,H)|0)+Math.imul(T,W)|0,i=i+Math.imul(T,H)|0,r=r+Math.imul(S,K)|0,o=(o=o+Math.imul(S,J)|0)+Math.imul(E,K)|0,i=i+Math.imul(E,J)|0,r=r+Math.imul(k,Q)|0,o=(o=o+Math.imul(k,Z)|0)+Math.imul(M,Q)|0,i=i+Math.imul(M,Z)|0,r=r+Math.imul(v,X)|0,o=(o=o+Math.imul(v,tt)|0)+Math.imul(_,X)|0,i=i+Math.imul(_,tt)|0,r=r+Math.imul(w,nt)|0,o=(o=o+Math.imul(w,rt)|0)+Math.imul(b,nt)|0,i=i+Math.imul(b,rt)|0,r=r+Math.imul(p,it)|0,o=(o=o+Math.imul(p,at)|0)+Math.imul(g,it)|0,i=i+Math.imul(g,at)|0;var kt=(l+(r=r+Math.imul(d,ct)|0)|0)+((8191&(o=(o=o+Math.imul(d,lt)|0)+Math.imul(h,ct)|0))<<13)|0;l=((i=i+Math.imul(h,lt)|0)+(o>>>13)|0)+(kt>>>26)|0,kt&=67108863,r=Math.imul($,q),o=(o=Math.imul($,D))+Math.imul(P,q)|0,i=Math.imul(P,D),r=r+Math.imul(O,W)|0,o=(o=o+Math.imul(O,H)|0)+Math.imul(N,W)|0,i=i+Math.imul(N,H)|0,r=r+Math.imul(I,K)|0,o=(o=o+Math.imul(I,J)|0)+Math.imul(T,K)|0,i=i+Math.imul(T,J)|0,r=r+Math.imul(S,Q)|0,o=(o=o+Math.imul(S,Z)|0)+Math.imul(E,Q)|0,i=i+Math.imul(E,Z)|0,r=r+Math.imul(k,X)|0,o=(o=o+Math.imul(k,tt)|0)+Math.imul(M,X)|0,i=i+Math.imul(M,tt)|0,r=r+Math.imul(v,nt)|0,o=(o=o+Math.imul(v,rt)|0)+Math.imul(_,nt)|0,i=i+Math.imul(_,rt)|0,r=r+Math.imul(w,it)|0,o=(o=o+Math.imul(w,at)|0)+Math.imul(b,it)|0,i=i+Math.imul(b,at)|0,r=r+Math.imul(p,ct)|0,o=(o=o+Math.imul(p,lt)|0)+Math.imul(g,ct)|0,i=i+Math.imul(g,lt)|0;var Mt=(l+(r=r+Math.imul(d,dt)|0)|0)+((8191&(o=(o=o+Math.imul(d,ht)|0)+Math.imul(h,dt)|0))<<13)|0;l=((i=i+Math.imul(h,ht)|0)+(o>>>13)|0)+(Mt>>>26)|0,Mt&=67108863,r=Math.imul(L,q),o=(o=Math.imul(L,D))+Math.imul(j,q)|0,i=Math.imul(j,D),r=r+Math.imul($,W)|0,o=(o=o+Math.imul($,H)|0)+Math.imul(P,W)|0,i=i+Math.imul(P,H)|0,r=r+Math.imul(O,K)|0,o=(o=o+Math.imul(O,J)|0)+Math.imul(N,K)|0,i=i+Math.imul(N,J)|0,r=r+Math.imul(I,Q)|0,o=(o=o+Math.imul(I,Z)|0)+Math.imul(T,Q)|0,i=i+Math.imul(T,Z)|0,r=r+Math.imul(S,X)|0,o=(o=o+Math.imul(S,tt)|0)+Math.imul(E,X)|0,i=i+Math.imul(E,tt)|0,r=r+Math.imul(k,nt)|0,o=(o=o+Math.imul(k,rt)|0)+Math.imul(M,nt)|0,i=i+Math.imul(M,rt)|0,r=r+Math.imul(v,it)|0,o=(o=o+Math.imul(v,at)|0)+Math.imul(_,it)|0,i=i+Math.imul(_,at)|0,r=r+Math.imul(w,ct)|0,o=(o=o+Math.imul(w,lt)|0)+Math.imul(b,ct)|0,i=i+Math.imul(b,lt)|0,r=r+Math.imul(p,dt)|0,o=(o=o+Math.imul(p,ht)|0)+Math.imul(g,dt)|0,i=i+Math.imul(g,ht)|0;var Ct=(l+(r=r+Math.imul(d,pt)|0)|0)+((8191&(o=(o=o+Math.imul(d,gt)|0)+Math.imul(h,pt)|0))<<13)|0;l=((i=i+Math.imul(h,gt)|0)+(o>>>13)|0)+(Ct>>>26)|0,Ct&=67108863,r=Math.imul(L,W),o=(o=Math.imul(L,H))+Math.imul(j,W)|0,i=Math.imul(j,H),r=r+Math.imul($,K)|0,o=(o=o+Math.imul($,J)|0)+Math.imul(P,K)|0,i=i+Math.imul(P,J)|0,r=r+Math.imul(O,Q)|0,o=(o=o+Math.imul(O,Z)|0)+Math.imul(N,Q)|0,i=i+Math.imul(N,Z)|0,r=r+Math.imul(I,X)|0,o=(o=o+Math.imul(I,tt)|0)+Math.imul(T,X)|0,i=i+Math.imul(T,tt)|0,r=r+Math.imul(S,nt)|0,o=(o=o+Math.imul(S,rt)|0)+Math.imul(E,nt)|0,i=i+Math.imul(E,rt)|0,r=r+Math.imul(k,it)|0,o=(o=o+Math.imul(k,at)|0)+Math.imul(M,it)|0,i=i+Math.imul(M,at)|0,r=r+Math.imul(v,ct)|0,o=(o=o+Math.imul(v,lt)|0)+Math.imul(_,ct)|0,i=i+Math.imul(_,lt)|0,r=r+Math.imul(w,dt)|0,o=(o=o+Math.imul(w,ht)|0)+Math.imul(b,dt)|0,i=i+Math.imul(b,ht)|0;var St=(l+(r=r+Math.imul(p,pt)|0)|0)+((8191&(o=(o=o+Math.imul(p,gt)|0)+Math.imul(g,pt)|0))<<13)|0;l=((i=i+Math.imul(g,gt)|0)+(o>>>13)|0)+(St>>>26)|0,St&=67108863,r=Math.imul(L,K),o=(o=Math.imul(L,J))+Math.imul(j,K)|0,i=Math.imul(j,J),r=r+Math.imul($,Q)|0,o=(o=o+Math.imul($,Z)|0)+Math.imul(P,Q)|0,i=i+Math.imul(P,Z)|0,r=r+Math.imul(O,X)|0,o=(o=o+Math.imul(O,tt)|0)+Math.imul(N,X)|0,i=i+Math.imul(N,tt)|0,r=r+Math.imul(I,nt)|0,o=(o=o+Math.imul(I,rt)|0)+Math.imul(T,nt)|0,i=i+Math.imul(T,rt)|0,r=r+Math.imul(S,it)|0,o=(o=o+Math.imul(S,at)|0)+Math.imul(E,it)|0,i=i+Math.imul(E,at)|0,r=r+Math.imul(k,ct)|0,o=(o=o+Math.imul(k,lt)|0)+Math.imul(M,ct)|0,i=i+Math.imul(M,lt)|0,r=r+Math.imul(v,dt)|0,o=(o=o+Math.imul(v,ht)|0)+Math.imul(_,dt)|0,i=i+Math.imul(_,ht)|0;var Et=(l+(r=r+Math.imul(w,pt)|0)|0)+((8191&(o=(o=o+Math.imul(w,gt)|0)+Math.imul(b,pt)|0))<<13)|0;l=((i=i+Math.imul(b,gt)|0)+(o>>>13)|0)+(Et>>>26)|0,Et&=67108863,r=Math.imul(L,Q),o=(o=Math.imul(L,Z))+Math.imul(j,Q)|0,i=Math.imul(j,Z),r=r+Math.imul($,X)|0,o=(o=o+Math.imul($,tt)|0)+Math.imul(P,X)|0,i=i+Math.imul(P,tt)|0,r=r+Math.imul(O,nt)|0,o=(o=o+Math.imul(O,rt)|0)+Math.imul(N,nt)|0,i=i+Math.imul(N,rt)|0,r=r+Math.imul(I,it)|0,o=(o=o+Math.imul(I,at)|0)+Math.imul(T,it)|0,i=i+Math.imul(T,at)|0,r=r+Math.imul(S,ct)|0,o=(o=o+Math.imul(S,lt)|0)+Math.imul(E,ct)|0,i=i+Math.imul(E,lt)|0,r=r+Math.imul(k,dt)|0,o=(o=o+Math.imul(k,ht)|0)+Math.imul(M,dt)|0,i=i+Math.imul(M,ht)|0;var At=(l+(r=r+Math.imul(v,pt)|0)|0)+((8191&(o=(o=o+Math.imul(v,gt)|0)+Math.imul(_,pt)|0))<<13)|0;l=((i=i+Math.imul(_,gt)|0)+(o>>>13)|0)+(At>>>26)|0,At&=67108863,r=Math.imul(L,X),o=(o=Math.imul(L,tt))+Math.imul(j,X)|0,i=Math.imul(j,tt),r=r+Math.imul($,nt)|0,o=(o=o+Math.imul($,rt)|0)+Math.imul(P,nt)|0,i=i+Math.imul(P,rt)|0,r=r+Math.imul(O,it)|0,o=(o=o+Math.imul(O,at)|0)+Math.imul(N,it)|0,i=i+Math.imul(N,at)|0,r=r+Math.imul(I,ct)|0,o=(o=o+Math.imul(I,lt)|0)+Math.imul(T,ct)|0,i=i+Math.imul(T,lt)|0,r=r+Math.imul(S,dt)|0,o=(o=o+Math.imul(S,ht)|0)+Math.imul(E,dt)|0,i=i+Math.imul(E,ht)|0;var It=(l+(r=r+Math.imul(k,pt)|0)|0)+((8191&(o=(o=o+Math.imul(k,gt)|0)+Math.imul(M,pt)|0))<<13)|0;l=((i=i+Math.imul(M,gt)|0)+(o>>>13)|0)+(It>>>26)|0,It&=67108863,r=Math.imul(L,nt),o=(o=Math.imul(L,rt))+Math.imul(j,nt)|0,i=Math.imul(j,rt),r=r+Math.imul($,it)|0,o=(o=o+Math.imul($,at)|0)+Math.imul(P,it)|0,i=i+Math.imul(P,at)|0,r=r+Math.imul(O,ct)|0,o=(o=o+Math.imul(O,lt)|0)+Math.imul(N,ct)|0,i=i+Math.imul(N,lt)|0,r=r+Math.imul(I,dt)|0,o=(o=o+Math.imul(I,ht)|0)+Math.imul(T,dt)|0,i=i+Math.imul(T,ht)|0;var Tt=(l+(r=r+Math.imul(S,pt)|0)|0)+((8191&(o=(o=o+Math.imul(S,gt)|0)+Math.imul(E,pt)|0))<<13)|0;l=((i=i+Math.imul(E,gt)|0)+(o>>>13)|0)+(Tt>>>26)|0,Tt&=67108863,r=Math.imul(L,it),o=(o=Math.imul(L,at))+Math.imul(j,it)|0,i=Math.imul(j,at),r=r+Math.imul($,ct)|0,o=(o=o+Math.imul($,lt)|0)+Math.imul(P,ct)|0,i=i+Math.imul(P,lt)|0,r=r+Math.imul(O,dt)|0,o=(o=o+Math.imul(O,ht)|0)+Math.imul(N,dt)|0,i=i+Math.imul(N,ht)|0;var Rt=(l+(r=r+Math.imul(I,pt)|0)|0)+((8191&(o=(o=o+Math.imul(I,gt)|0)+Math.imul(T,pt)|0))<<13)|0;l=((i=i+Math.imul(T,gt)|0)+(o>>>13)|0)+(Rt>>>26)|0,Rt&=67108863,r=Math.imul(L,ct),o=(o=Math.imul(L,lt))+Math.imul(j,ct)|0,i=Math.imul(j,lt),r=r+Math.imul($,dt)|0,o=(o=o+Math.imul($,ht)|0)+Math.imul(P,dt)|0,i=i+Math.imul(P,ht)|0;var Ot=(l+(r=r+Math.imul(O,pt)|0)|0)+((8191&(o=(o=o+Math.imul(O,gt)|0)+Math.imul(N,pt)|0))<<13)|0;l=((i=i+Math.imul(N,gt)|0)+(o>>>13)|0)+(Ot>>>26)|0,Ot&=67108863,r=Math.imul(L,dt),o=(o=Math.imul(L,ht))+Math.imul(j,dt)|0,i=Math.imul(j,ht);var Nt=(l+(r=r+Math.imul($,pt)|0)|0)+((8191&(o=(o=o+Math.imul($,gt)|0)+Math.imul(P,pt)|0))<<13)|0;l=((i=i+Math.imul(P,gt)|0)+(o>>>13)|0)+(Nt>>>26)|0,Nt&=67108863;var Bt=(l+(r=Math.imul(L,pt))|0)+((8191&(o=(o=Math.imul(L,gt))+Math.imul(j,pt)|0))<<13)|0;return l=((i=Math.imul(j,gt))+(o>>>13)|0)+(Bt>>>26)|0,Bt&=67108863,c[0]=mt,c[1]=wt,c[2]=bt,c[3]=yt,c[4]=vt,c[5]=_t,c[6]=xt,c[7]=kt,c[8]=Mt,c[9]=Ct,c[10]=St,c[11]=Et,c[12]=At,c[13]=It,c[14]=Tt,c[15]=Rt,c[16]=Ot,c[17]=Nt,c[18]=Bt,0!==l&&(c[19]=l,n.length++),n};function f(t,e,n){return(new p).mulp(t,e,n)}function p(t,e){this.x=t,this.y=e}Math.imul||(h=d),o.prototype.mulTo=function(t,e){var n,r=this.length+t.length;return n=10===this.length&&10===t.length?h(this,t,e):r<63?d(this,t,e):r<1024?function(t,e,n){n.negative=e.negative^t.negative,n.length=t.length+e.length;for(var r=0,o=0,i=0;i<n.length-1;i++){var a=o;o=0;for(var s=67108863&r,c=Math.min(i,e.length-1),l=Math.max(0,i-t.length+1);l<=c;l++){var u=i-l,d=(0|t.words[u])*(0|e.words[l]),h=67108863&d;s=67108863&(h=h+s|0),o+=(a=(a=a+(d/67108864|0)|0)+(h>>>26)|0)>>>26,a&=67108863}n.words[i]=s,r=a,a=o}return 0!==r?n.words[i]=r:n.length--,n.strip()}(this,t,e):f(this,t,e),n},p.prototype.makeRBT=function(t){for(var e=new Array(t),n=o.prototype._countBits(t)-1,r=0;r<t;r++)e[r]=this.revBin(r,n,t);return e},p.prototype.revBin=function(t,e,n){if(0===t||t===n-1)return t;for(var r=0,o=0;o<e;o++)r|=(1&t)<<e-o-1,t>>=1;return r},p.prototype.permute=function(t,e,n,r,o,i){for(var a=0;a<i;a++)r[a]=e[t[a]],o[a]=n[t[a]]},p.prototype.transform=function(t,e,n,r,o,i){this.permute(i,t,e,n,r,o);for(var a=1;a<o;a<<=1)for(var s=a<<1,c=Math.cos(2*Math.PI/s),l=Math.sin(2*Math.PI/s),u=0;u<o;u+=s)for(var d=c,h=l,f=0;f<a;f++){var p=n[u+f],g=r[u+f],m=n[u+f+a],w=r[u+f+a],b=d*m-h*w;w=d*w+h*m,m=b,n[u+f]=p+m,r[u+f]=g+w,n[u+f+a]=p-m,r[u+f+a]=g-w,f!==s&&(b=c*d-l*h,h=c*h+l*d,d=b)}},p.prototype.guessLen13b=function(t,e){var n=1|Math.max(e,t),r=1&n,o=0;for(n=n/2|0;n;n>>>=1)o++;return 1<<o+1+r},p.prototype.conjugate=function(t,e,n){if(!(n<=1))for(var r=0;r<n/2;r++){var o=t[r];t[r]=t[n-r-1],t[n-r-1]=o,o=e[r],e[r]=-e[n-r-1],e[n-r-1]=-o}},p.prototype.normalize13b=function(t,e){for(var n=0,r=0;r<e/2;r++){var o=8192*Math.round(t[2*r+1]/e)+Math.round(t[2*r]/e)+n;t[r]=67108863&o,n=o<67108864?0:o/67108864|0}return t},p.prototype.convert13b=function(t,e,r,o){for(var i=0,a=0;a<e;a++)i+=0|t[a],r[2*a]=8191&i,i>>>=13,r[2*a+1]=8191&i,i>>>=13;for(a=2*e;a<o;++a)r[a]=0;n(0===i),n(0==(-8192&i))},p.prototype.stub=function(t){for(var e=new Array(t),n=0;n<t;n++)e[n]=0;return e},p.prototype.mulp=function(t,e,n){var r=2*this.guessLen13b(t.length,e.length),o=this.makeRBT(r),i=this.stub(r),a=new Array(r),s=new Array(r),c=new Array(r),l=new Array(r),u=new Array(r),d=new Array(r),h=n.words;h.length=r,this.convert13b(t.words,t.length,a,r),this.convert13b(e.words,e.length,l,r),this.transform(a,i,s,c,r,o),this.transform(l,i,u,d,r,o);for(var f=0;f<r;f++){var p=s[f]*u[f]-c[f]*d[f];c[f]=s[f]*d[f]+c[f]*u[f],s[f]=p}return this.conjugate(s,c,r),this.transform(s,c,h,i,r,o),this.conjugate(h,i,r),this.normalize13b(h,r),n.negative=t.negative^e.negative,n.length=t.length+e.length,n.strip()},o.prototype.mul=function(t){var e=new o(null);return e.words=new Array(this.length+t.length),this.mulTo(t,e)},o.prototype.mulf=function(t){var e=new o(null);return e.words=new Array(this.length+t.length),f(this,t,e)},o.prototype.imul=function(t){return this.clone().mulTo(t,this)},o.prototype.imuln=function(t){n("number"==typeof t),n(t<67108864);for(var e=0,r=0;r<this.length;r++){var o=(0|this.words[r])*t,i=(67108863&o)+(67108863&e);e>>=26,e+=o/67108864|0,e+=i>>>26,this.words[r]=67108863&i}return 0!==e&&(this.words[r]=e,this.length++),this},o.prototype.muln=function(t){return this.clone().imuln(t)},o.prototype.sqr=function(){return this.mul(this)},o.prototype.isqr=function(){return this.imul(this.clone())},o.prototype.pow=function(t){var e=function(t){for(var e=new Array(t.bitLength()),n=0;n<e.length;n++){var r=n/26|0,o=n%26;e[n]=(t.words[r]&1<<o)>>>o}return e}(t);if(0===e.length)return new o(1);for(var n=this,r=0;r<e.length&&0===e[r];r++,n=n.sqr());if(++r<e.length)for(var i=n.sqr();r<e.length;r++,i=i.sqr())0!==e[r]&&(n=n.mul(i));return n},o.prototype.iushln=function(t){n("number"==typeof t&&t>=0);var e,r=t%26,o=(t-r)/26,i=67108863>>>26-r<<26-r;if(0!==r){var a=0;for(e=0;e<this.length;e++){var s=this.words[e]&i,c=(0|this.words[e])-s<<r;this.words[e]=c|a,a=s>>>26-r}a&&(this.words[e]=a,this.length++)}if(0!==o){for(e=this.length-1;e>=0;e--)this.words[e+o]=this.words[e];for(e=0;e<o;e++)this.words[e]=0;this.length+=o}return this.strip()},o.prototype.ishln=function(t){return n(0===this.negative),this.iushln(t)},o.prototype.iushrn=function(t,e,r){var o;n("number"==typeof t&&t>=0),o=e?(e-e%26)/26:0;var i=t%26,a=Math.min((t-i)/26,this.length),s=67108863^67108863>>>i<<i,c=r;if(o-=a,o=Math.max(0,o),c){for(var l=0;l<a;l++)c.words[l]=this.words[l];c.length=a}if(0===a);else if(this.length>a)for(this.length-=a,l=0;l<this.length;l++)this.words[l]=this.words[l+a];else this.words[0]=0,this.length=1;var u=0;for(l=this.length-1;l>=0&&(0!==u||l>=o);l--){var d=0|this.words[l];this.words[l]=u<<26-i|d>>>i,u=d&s}return c&&0!==u&&(c.words[c.length++]=u),0===this.length&&(this.words[0]=0,this.length=1),this.strip()},o.prototype.ishrn=function(t,e,r){return n(0===this.negative),this.iushrn(t,e,r)},o.prototype.shln=function(t){return this.clone().ishln(t)},o.prototype.ushln=function(t){return this.clone().iushln(t)},o.prototype.shrn=function(t){return this.clone().ishrn(t)},o.prototype.ushrn=function(t){return this.clone().iushrn(t)},o.prototype.testn=function(t){n("number"==typeof t&&t>=0);var e=t%26,r=(t-e)/26,o=1<<e;return!(this.length<=r||!(this.words[r]&o))},o.prototype.imaskn=function(t){n("number"==typeof t&&t>=0);var e=t%26,r=(t-e)/26;if(n(0===this.negative,"imaskn works only with positive numbers"),this.length<=r)return this;if(0!==e&&r++,this.length=Math.min(r,this.length),0!==e){var o=67108863^67108863>>>e<<e;this.words[this.length-1]&=o}return this.strip()},o.prototype.maskn=function(t){return this.clone().imaskn(t)},o.prototype.iaddn=function(t){return n("number"==typeof t),n(t<67108864),t<0?this.isubn(-t):0!==this.negative?1===this.length&&(0|this.words[0])<t?(this.words[0]=t-(0|this.words[0]),this.negative=0,this):(this.negative=0,this.isubn(t),this.negative=1,this):this._iaddn(t)},o.prototype._iaddn=function(t){this.words[0]+=t;for(var e=0;e<this.length&&this.words[e]>=67108864;e++)this.words[e]-=67108864,e===this.length-1?this.words[e+1]=1:this.words[e+1]++;return this.length=Math.max(this.length,e+1),this},o.prototype.isubn=function(t){if(n("number"==typeof t),n(t<67108864),t<0)return this.iaddn(-t);if(0!==this.negative)return this.negative=0,this.iaddn(t),this.negative=1,this;if(this.words[0]-=t,1===this.length&&this.words[0]<0)this.words[0]=-this.words[0],this.negative=1;else for(var e=0;e<this.length&&this.words[e]<0;e++)this.words[e]+=67108864,this.words[e+1]-=1;return this.strip()},o.prototype.addn=function(t){return this.clone().iaddn(t)},o.prototype.subn=function(t){return this.clone().isubn(t)},o.prototype.iabs=function(){return this.negative=0,this},o.prototype.abs=function(){return this.clone().iabs()},o.prototype._ishlnsubmul=function(t,e,r){var o,i,a=t.length+r;this._expand(a);var s=0;for(o=0;o<t.length;o++){i=(0|this.words[o+r])+s;var c=(0|t.words[o])*e;s=((i-=67108863&c)>>26)-(c/67108864|0),this.words[o+r]=67108863&i}for(;o<this.length-r;o++)s=(i=(0|this.words[o+r])+s)>>26,this.words[o+r]=67108863&i;if(0===s)return this.strip();for(n(-1===s),s=0,o=0;o<this.length;o++)s=(i=-(0|this.words[o])+s)>>26,this.words[o]=67108863&i;return this.negative=1,this.strip()},o.prototype._wordDiv=function(t,e){var n=(this.length,t.length),r=this.clone(),i=t,a=0|i.words[i.length-1];0!=(n=26-this._countBits(a))&&(i=i.ushln(n),r.iushln(n),a=0|i.words[i.length-1]);var s,c=r.length-i.length;if("mod"!==e){(s=new o(null)).length=c+1,s.words=new Array(s.length);for(var l=0;l<s.length;l++)s.words[l]=0}var u=r.clone()._ishlnsubmul(i,1,c);0===u.negative&&(r=u,s&&(s.words[c]=1));for(var d=c-1;d>=0;d--){var h=67108864*(0|r.words[i.length+d])+(0|r.words[i.length+d-1]);for(h=Math.min(h/a|0,67108863),r._ishlnsubmul(i,h,d);0!==r.negative;)h--,r.negative=0,r._ishlnsubmul(i,1,d),r.isZero()||(r.negative^=1);s&&(s.words[d]=h)}return s&&s.strip(),r.strip(),"div"!==e&&0!==n&&r.iushrn(n),{div:s||null,mod:r}},o.prototype.divmod=function(t,e,r){return n(!t.isZero()),this.isZero()?{div:new o(0),mod:new o(0)}:0!==this.negative&&0===t.negative?(s=this.neg().divmod(t,e),"mod"!==e&&(i=s.div.neg()),"div"!==e&&(a=s.mod.neg(),r&&0!==a.negative&&a.iadd(t)),{div:i,mod:a}):0===this.negative&&0!==t.negative?(s=this.divmod(t.neg(),e),"mod"!==e&&(i=s.div.neg()),{div:i,mod:s.mod}):0!=(this.negative&t.negative)?(s=this.neg().divmod(t.neg(),e),"div"!==e&&(a=s.mod.neg(),r&&0!==a.negative&&a.isub(t)),{div:s.div,mod:a}):t.length>this.length||this.cmp(t)<0?{div:new o(0),mod:this}:1===t.length?"div"===e?{div:this.divn(t.words[0]),mod:null}:"mod"===e?{div:null,mod:new o(this.modn(t.words[0]))}:{div:this.divn(t.words[0]),mod:new o(this.modn(t.words[0]))}:this._wordDiv(t,e);var i,a,s},o.prototype.div=function(t){return this.divmod(t,"div",!1).div},o.prototype.mod=function(t){return this.divmod(t,"mod",!1).mod},o.prototype.umod=function(t){return this.divmod(t,"mod",!0).mod},o.prototype.divRound=function(t){var e=this.divmod(t);if(e.mod.isZero())return e.div;var n=0!==e.div.negative?e.mod.isub(t):e.mod,r=t.ushrn(1),o=t.andln(1),i=n.cmp(r);return i<0||1===o&&0===i?e.div:0!==e.div.negative?e.div.isubn(1):e.div.iaddn(1)},o.prototype.modn=function(t){n(t<=67108863);for(var e=(1<<26)%t,r=0,o=this.length-1;o>=0;o--)r=(e*r+(0|this.words[o]))%t;return r},o.prototype.idivn=function(t){n(t<=67108863);for(var e=0,r=this.length-1;r>=0;r--){var o=(0|this.words[r])+67108864*e;this.words[r]=o/t|0,e=o%t}return this.strip()},o.prototype.divn=function(t){return this.clone().idivn(t)},o.prototype.egcd=function(t){n(0===t.negative),n(!t.isZero());var e=this,r=t.clone();e=0!==e.negative?e.umod(t):e.clone();for(var i=new o(1),a=new o(0),s=new o(0),c=new o(1),l=0;e.isEven()&&r.isEven();)e.iushrn(1),r.iushrn(1),++l;for(var u=r.clone(),d=e.clone();!e.isZero();){for(var h=0,f=1;0==(e.words[0]&f)&&h<26;++h,f<<=1);if(h>0)for(e.iushrn(h);h-- >0;)(i.isOdd()||a.isOdd())&&(i.iadd(u),a.isub(d)),i.iushrn(1),a.iushrn(1);for(var p=0,g=1;0==(r.words[0]&g)&&p<26;++p,g<<=1);if(p>0)for(r.iushrn(p);p-- >0;)(s.isOdd()||c.isOdd())&&(s.iadd(u),c.isub(d)),s.iushrn(1),c.iushrn(1);e.cmp(r)>=0?(e.isub(r),i.isub(s),a.isub(c)):(r.isub(e),s.isub(i),c.isub(a))}return{a:s,b:c,gcd:r.iushln(l)}},o.prototype._invmp=function(t){n(0===t.negative),n(!t.isZero());var e=this,r=t.clone();e=0!==e.negative?e.umod(t):e.clone();for(var i,a=new o(1),s=new o(0),c=r.clone();e.cmpn(1)>0&&r.cmpn(1)>0;){for(var l=0,u=1;0==(e.words[0]&u)&&l<26;++l,u<<=1);if(l>0)for(e.iushrn(l);l-- >0;)a.isOdd()&&a.iadd(c),a.iushrn(1);for(var d=0,h=1;0==(r.words[0]&h)&&d<26;++d,h<<=1);if(d>0)for(r.iushrn(d);d-- >0;)s.isOdd()&&s.iadd(c),s.iushrn(1);e.cmp(r)>=0?(e.isub(r),a.isub(s)):(r.isub(e),s.isub(a))}return(i=0===e.cmpn(1)?a:s).cmpn(0)<0&&i.iadd(t),i},o.prototype.gcd=function(t){if(this.isZero())return t.abs();if(t.isZero())return this.abs();var e=this.clone(),n=t.clone();e.negative=0,n.negative=0;for(var r=0;e.isEven()&&n.isEven();r++)e.iushrn(1),n.iushrn(1);for(;;){for(;e.isEven();)e.iushrn(1);for(;n.isEven();)n.iushrn(1);var o=e.cmp(n);if(o<0){var i=e;e=n,n=i}else if(0===o||0===n.cmpn(1))break;e.isub(n)}return n.iushln(r)},o.prototype.invm=function(t){return this.egcd(t).a.umod(t)},o.prototype.isEven=function(){return 0==(1&this.words[0])},o.prototype.isOdd=function(){return 1==(1&this.words[0])},o.prototype.andln=function(t){return this.words[0]&t},o.prototype.bincn=function(t){n("number"==typeof t);var e=t%26,r=(t-e)/26,o=1<<e;if(this.length<=r)return this._expand(r+1),this.words[r]|=o,this;for(var i=o,a=r;0!==i&&a<this.length;a++){var s=0|this.words[a];i=(s+=i)>>>26,s&=67108863,this.words[a]=s}return 0!==i&&(this.words[a]=i,this.length++),this},o.prototype.isZero=function(){return 1===this.length&&0===this.words[0]},o.prototype.cmpn=function(t){var e,r=t<0;if(0!==this.negative&&!r)return-1;if(0===this.negative&&r)return 1;if(this.strip(),this.length>1)e=1;else{r&&(t=-t),n(t<=67108863,"Number is too big");var o=0|this.words[0];e=o===t?0:o<t?-1:1}return 0!==this.negative?0|-e:e},o.prototype.cmp=function(t){if(0!==this.negative&&0===t.negative)return-1;if(0===this.negative&&0!==t.negative)return 1;var e=this.ucmp(t);return 0!==this.negative?0|-e:e},o.prototype.ucmp=function(t){if(this.length>t.length)return 1;if(this.length<t.length)return-1;for(var e=0,n=this.length-1;n>=0;n--){var r=0|this.words[n],o=0|t.words[n];if(r!==o){r<o?e=-1:r>o&&(e=1);break}}return e},o.prototype.gtn=function(t){return 1===this.cmpn(t)},o.prototype.gt=function(t){return 1===this.cmp(t)},o.prototype.gten=function(t){return this.cmpn(t)>=0},o.prototype.gte=function(t){return this.cmp(t)>=0},o.prototype.ltn=function(t){return-1===this.cmpn(t)},o.prototype.lt=function(t){return-1===this.cmp(t)},o.prototype.lten=function(t){return this.cmpn(t)<=0},o.prototype.lte=function(t){return this.cmp(t)<=0},o.prototype.eqn=function(t){return 0===this.cmpn(t)},o.prototype.eq=function(t){return 0===this.cmp(t)},o.red=function(t){return new _(t)},o.prototype.toRed=function(t){return n(!this.red,"Already a number in reduction context"),n(0===this.negative,"red works only with positives"),t.convertTo(this)._forceRed(t)},o.prototype.fromRed=function(){return n(this.red,"fromRed works only with numbers in reduction context"),this.red.convertFrom(this)},o.prototype._forceRed=function(t){return this.red=t,this},o.prototype.forceRed=function(t){return n(!this.red,"Already a number in reduction context"),this._forceRed(t)},o.prototype.redAdd=function(t){return n(this.red,"redAdd works only with red numbers"),this.red.add(this,t)},o.prototype.redIAdd=function(t){return n(this.red,"redIAdd works only with red numbers"),this.red.iadd(this,t)},o.prototype.redSub=function(t){return n(this.red,"redSub works only with red numbers"),this.red.sub(this,t)},o.prototype.redISub=function(t){return n(this.red,"redISub works only with red numbers"),this.red.isub(this,t)},o.prototype.redShl=function(t){return n(this.red,"redShl works only with red numbers"),this.red.shl(this,t)},o.prototype.redMul=function(t){return n(this.red,"redMul works only with red numbers"),this.red._verify2(this,t),this.red.mul(this,t)},o.prototype.redIMul=function(t){return n(this.red,"redMul works only with red numbers"),this.red._verify2(this,t),this.red.imul(this,t)},o.prototype.redSqr=function(){return n(this.red,"redSqr works only with red numbers"),this.red._verify1(this),this.red.sqr(this)},o.prototype.redISqr=function(){return n(this.red,"redISqr works only with red numbers"),this.red._verify1(this),this.red.isqr(this)},o.prototype.redSqrt=function(){return n(this.red,"redSqrt works only with red numbers"),this.red._verify1(this),this.red.sqrt(this)},o.prototype.redInvm=function(){return n(this.red,"redInvm works only with red numbers"),this.red._verify1(this),this.red.invm(this)},o.prototype.redNeg=function(){return n(this.red,"redNeg works only with red numbers"),this.red._verify1(this),this.red.neg(this)},o.prototype.redPow=function(t){return n(this.red&&!t.red,"redPow(normalNum)"),this.red._verify1(this),this.red.pow(this,t)};var g={k256:null,p224:null,p192:null,p25519:null};function m(t,e){this.name=t,this.p=new o(e,16),this.n=this.p.bitLength(),this.k=new o(1).iushln(this.n).isub(this.p),this.tmp=this._tmp()}function w(){m.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f")}function b(){m.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001")}function y(){m.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff")}function v(){m.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed")}function _(t){if("string"==typeof t){var e=o._prime(t);this.m=e.p,this.prime=e}else n(t.gtn(1),"modulus must be greater than 1"),this.m=t,this.prime=null}function x(t){_.call(this,t),this.shift=this.m.bitLength(),this.shift%26!=0&&(this.shift+=26-this.shift%26),this.r=new o(1).iushln(this.shift),this.r2=this.imod(this.r.sqr()),this.rinv=this.r._invmp(this.m),this.minv=this.rinv.mul(this.r).isubn(1).div(this.m),this.minv=this.minv.umod(this.r),this.minv=this.r.sub(this.minv)}m.prototype._tmp=function(){var t=new o(null);return t.words=new Array(Math.ceil(this.n/13)),t},m.prototype.ireduce=function(t){var e,n=t;do{this.split(n,this.tmp),e=(n=(n=this.imulK(n)).iadd(this.tmp)).bitLength()}while(e>this.n);var r=e<this.n?-1:n.ucmp(this.p);return 0===r?(n.words[0]=0,n.length=1):r>0?n.isub(this.p):n.strip(),n},m.prototype.split=function(t,e){t.iushrn(this.n,0,e)},m.prototype.imulK=function(t){return t.imul(this.k)},r(w,m),w.prototype.split=function(t,e){for(var n=4194303,r=Math.min(t.length,9),o=0;o<r;o++)e.words[o]=t.words[o];if(e.length=r,t.length<=9)return t.words[0]=0,void(t.length=1);var i=t.words[9];for(e.words[e.length++]=i&n,o=10;o<t.length;o++){var a=0|t.words[o];t.words[o-10]=(a&n)<<4|i>>>22,i=a}i>>>=22,t.words[o-10]=i,0===i&&t.length>10?t.length-=10:t.length-=9},w.prototype.imulK=function(t){t.words[t.length]=0,t.words[t.length+1]=0,t.length+=2;for(var e=0,n=0;n<t.length;n++){var r=0|t.words[n];e+=977*r,t.words[n]=67108863&e,e=64*r+(e/67108864|0)}return 0===t.words[t.length-1]&&(t.length--,0===t.words[t.length-1]&&t.length--),t},r(b,m),r(y,m),r(v,m),v.prototype.imulK=function(t){for(var e=0,n=0;n<t.length;n++){var r=19*(0|t.words[n])+e,o=67108863&r;r>>>=26,t.words[n]=o,e=r}return 0!==e&&(t.words[t.length++]=e),t},o._prime=function(t){if(g[t])return g[t];var e;if("k256"===t)e=new w;else if("p224"===t)e=new b;else if("p192"===t)e=new y;else{if("p25519"!==t)throw new Error("Unknown prime "+t);e=new v}return g[t]=e,e},_.prototype._verify1=function(t){n(0===t.negative,"red works only with positives"),n(t.red,"red works only with red numbers")},_.prototype._verify2=function(t,e){n(0==(t.negative|e.negative),"red works only with positives"),n(t.red&&t.red===e.red,"red works only with red numbers")},_.prototype.imod=function(t){return this.prime?this.prime.ireduce(t)._forceRed(this):t.umod(this.m)._forceRed(this)},_.prototype.neg=function(t){return t.isZero()?t.clone():this.m.sub(t)._forceRed(this)},_.prototype.add=function(t,e){this._verify2(t,e);var n=t.add(e);return n.cmp(this.m)>=0&&n.isub(this.m),n._forceRed(this)},_.prototype.iadd=function(t,e){this._verify2(t,e);var n=t.iadd(e);return n.cmp(this.m)>=0&&n.isub(this.m),n},_.prototype.sub=function(t,e){this._verify2(t,e);var n=t.sub(e);return n.cmpn(0)<0&&n.iadd(this.m),n._forceRed(this)},_.prototype.isub=function(t,e){this._verify2(t,e);var n=t.isub(e);return n.cmpn(0)<0&&n.iadd(this.m),n},_.prototype.shl=function(t,e){return this._verify1(t),this.imod(t.ushln(e))},_.prototype.imul=function(t,e){return this._verify2(t,e),this.imod(t.imul(e))},_.prototype.mul=function(t,e){return this._verify2(t,e),this.imod(t.mul(e))},_.prototype.isqr=function(t){return this.imul(t,t.clone())},_.prototype.sqr=function(t){return this.mul(t,t)},_.prototype.sqrt=function(t){if(t.isZero())return t.clone();var e=this.m.andln(3);if(n(e%2==1),3===e){var r=this.m.add(new o(1)).iushrn(2);return this.pow(t,r)}for(var i=this.m.subn(1),a=0;!i.isZero()&&0===i.andln(1);)a++,i.iushrn(1);n(!i.isZero());var s=new o(1).toRed(this),c=s.redNeg(),l=this.m.subn(1).iushrn(1),u=this.m.bitLength();for(u=new o(2*u*u).toRed(this);0!==this.pow(u,l).cmp(c);)u.redIAdd(c);for(var d=this.pow(u,i),h=this.pow(t,i.addn(1).iushrn(1)),f=this.pow(t,i),p=a;0!==f.cmp(s);){for(var g=f,m=0;0!==g.cmp(s);m++)g=g.redSqr();n(m<p);var w=this.pow(d,new o(1).iushln(p-m-1));h=h.redMul(w),d=w.redSqr(),f=f.redMul(d),p=m}return h},_.prototype.invm=function(t){var e=t._invmp(this.m);return 0!==e.negative?(e.negative=0,this.imod(e).redNeg()):this.imod(e)},_.prototype.pow=function(t,e){if(e.isZero())return new o(1).toRed(this);if(0===e.cmpn(1))return t.clone();var n=new Array(16);n[0]=new o(1).toRed(this),n[1]=t;for(var r=2;r<n.length;r++)n[r]=this.mul(n[r-1],t);var i=n[0],a=0,s=0,c=e.bitLength()%26;for(0===c&&(c=26),r=e.length-1;r>=0;r--){for(var l=e.words[r],u=c-1;u>=0;u--){var d=l>>u&1;i!==n[0]&&(i=this.sqr(i)),0!==d||0!==a?(a<<=1,a|=d,(4==++s||0===r&&0===u)&&(i=this.mul(i,n[a]),s=0,a=0)):s=0}c=26}return i},_.prototype.convertTo=function(t){var e=t.umod(this.m);return e===t?e.clone():e},_.prototype.convertFrom=function(t){var e=t.clone();return e.red=null,e},o.mont=function(t){return new x(t)},r(x,_),x.prototype.convertTo=function(t){return this.imod(t.ushln(this.shift))},x.prototype.convertFrom=function(t){var e=this.imod(t.mul(this.rinv));return e.red=null,e},x.prototype.imul=function(t,e){if(t.isZero()||e.isZero())return t.words[0]=0,t.length=1,t;var n=t.imul(e),r=n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),o=n.isub(r).iushrn(this.shift),i=o;return o.cmp(this.m)>=0?i=o.isub(this.m):o.cmpn(0)<0&&(i=o.iadd(this.m)),i._forceRed(this)},x.prototype.mul=function(t,e){if(t.isZero()||e.isZero())return new o(0)._forceRed(this);var n=t.mul(e),r=n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),i=n.isub(r).iushrn(this.shift),a=i;return i.cmp(this.m)>=0?a=i.isub(this.m):i.cmpn(0)<0&&(a=i.iadd(this.m)),a._forceRed(this)},x.prototype.invm=function(t){return this.imod(t._invmp(this.m).mul(this.r2))._forceRed(this)}})(dn,te);var fn=dn.exports,pn=wn;wn.strict=bn,wn.loose=yn;var gn=Object.prototype.toString,mn={"[object Int8Array]":!0,"[object Int16Array]":!0,"[object Int32Array]":!0,"[object Uint8Array]":!0,"[object Uint8ClampedArray]":!0,"[object Uint16Array]":!0,"[object Uint32Array]":!0,"[object Float32Array]":!0,"[object Float64Array]":!0};function wn(t){return bn(t)||yn(t)}function bn(t){return t instanceof Int8Array||t instanceof Int16Array||t instanceof Int32Array||t instanceof Uint8Array||t instanceof Uint8ClampedArray||t instanceof Uint16Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array}function yn(t){return mn[gn.call(t)]}var vn=pn.strict,_n=function(t){if(vn(t)){var e=Buffer.from(t.buffer);return t.byteLength!==t.buffer.byteLength&&(e=e.slice(t.byteOffset,t.byteOffset+t.byteLength)),e}return Buffer.from(t)};const xn="hex",kn="utf8",Mn="0";function Cn(t){return new Uint8Array(t)}function Sn(t,e=!1){const n=t.toString(xn);return e?$n(n):n}function En(t){return _n(t)}function An(t,e=!1){return Sn(En(t),e)}function In(t){return En(t).toString(kn)}function Tn(t){return Cn(function(t){return Buffer.from(Bn(t),xn)}(t))}function Rn(t){return Buffer.from(t,kn)}function On(...t){let e=[];return t.forEach((t=>e=e.concat(Array.from(t)))),new Uint8Array([...e])}function Nn(t,e=8,n=Mn){return function(t,e,n=Mn){return function(t,e,n,r=Mn){const o=e-t.length;let i=t;if(o>0){const e=r.repeat(o);i=n?e+t:t+e}return i}(t,e,!0,n)}(t,function(t,e=8){const n=t%e;return n?(t-n)/e*e+e:t}(t.length,e),n)}function Bn(t){return t.replace(/^0x/,"")}function $n(t){return t.startsWith("0x")?t:`0x${t}`}function Pn(t){return(t=Nn(t=Bn(t),2))&&(t=$n(t)),t}function Un(t){return En(new Uint8Array(t))}function Ln(t,e){return function(t,e=!1){return Sn(Rn(t),e)}(t,!e)}function jn(t,e){const n=Bn(Pn(new fn(t).toString(16)));return e?n:$n(n)}var zn={exports:{}};
/**
     * [js-sha3]{@link https://github.com/emn178/js-sha3}
     *
     * @version 0.8.0
     * @author Chen, Yi-Cyuan [emn178@gmail.com]
     * @copyright Chen, Yi-Cyuan 2015-2018
     * @license MIT
     */!function(t){!function(){var e="input is invalid type",n="object"==typeof window,r=n?window:{};r.JS_SHA3_NO_WINDOW&&(n=!1);var o=!n&&"object"==typeof self;!r.JS_SHA3_NO_NODE_JS&&"object"==typeof process&&process.versions&&process.versions.node?r=te:o&&(r=self);var i=!r.JS_SHA3_NO_COMMON_JS&&t.exports,a=!r.JS_SHA3_NO_ARRAY_BUFFER&&"undefined"!=typeof ArrayBuffer,s="0123456789abcdef".split(""),c=[4,1024,262144,67108864],l=[0,8,16,24],u=[1,0,32898,0,32906,2147483648,2147516416,2147483648,32907,0,2147483649,0,2147516545,2147483648,32777,2147483648,138,0,136,0,2147516425,0,2147483658,0,2147516555,0,139,2147483648,32905,2147483648,32771,2147483648,32770,2147483648,128,2147483648,32778,0,2147483658,2147483648,2147516545,2147483648,32896,2147483648,2147483649,0,2147516424,2147483648],d=[224,256,384,512],h=[128,256],f=["hex","buffer","arrayBuffer","array","digest"],p={128:168,256:136};!r.JS_SHA3_NO_NODE_JS&&Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),!a||!r.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW&&ArrayBuffer.isView||(ArrayBuffer.isView=function(t){return"object"==typeof t&&t.buffer&&t.buffer.constructor===ArrayBuffer});for(var g=function(t,e,n){return function(r){return new T(t,e,t).update(r)[n]()}},m=function(t,e,n){return function(r,o){return new T(t,e,o).update(r)[n]()}},w=function(t,e,n){return function(e,r,o,i){return x["cshake"+t].update(e,r,o,i)[n]()}},b=function(t,e,n){return function(e,r,o,i){return x["kmac"+t].update(e,r,o,i)[n]()}},y=function(t,e,n,r){for(var o=0;o<f.length;++o){var i=f[o];t[i]=e(n,r,i)}return t},v=function(t,e){var n=g(t,e,"hex");return n.create=function(){return new T(t,e,t)},n.update=function(t){return n.create().update(t)},y(n,g,t,e)},_=[{name:"keccak",padding:[1,256,65536,16777216],bits:d,createMethod:v},{name:"sha3",padding:[6,1536,393216,100663296],bits:d,createMethod:v},{name:"shake",padding:[31,7936,2031616,520093696],bits:h,createMethod:function(t,e){var n=m(t,e,"hex");return n.create=function(n){return new T(t,e,n)},n.update=function(t,e){return n.create(e).update(t)},y(n,m,t,e)}},{name:"cshake",padding:c,bits:h,createMethod:function(t,e){var n=p[t],r=w(t,0,"hex");return r.create=function(r,o,i){return o||i?new T(t,e,r).bytepad([o,i],n):x["shake"+t].create(r)},r.update=function(t,e,n,o){return r.create(e,n,o).update(t)},y(r,w,t,e)}},{name:"kmac",padding:c,bits:h,createMethod:function(t,e){var n=p[t],r=b(t,0,"hex");return r.create=function(r,o,i){return new R(t,e,o).bytepad(["KMAC",i],n).bytepad([r],n)},r.update=function(t,e,n,o){return r.create(t,n,o).update(e)},y(r,b,t,e)}}],x={},k=[],M=0;M<_.length;++M)for(var C=_[M],S=C.bits,E=0;E<S.length;++E){var A=C.name+"_"+S[E];if(k.push(A),x[A]=C.createMethod(S[E],C.padding),"sha3"!==C.name){var I=C.name+S[E];k.push(I),x[I]=x[A]}}function T(t,e,n){this.blocks=[],this.s=[],this.padding=e,this.outputBits=n,this.reset=!0,this.finalized=!1,this.block=0,this.start=0,this.blockCount=1600-(t<<1)>>5,this.byteCount=this.blockCount<<2,this.outputBlocks=n>>5,this.extraBytes=(31&n)>>3;for(var r=0;r<50;++r)this.s[r]=0}function R(t,e,n){T.call(this,t,e,n)}T.prototype.update=function(t){if(this.finalized)throw new Error("finalize already called");var n,r=typeof t;if("string"!==r){if("object"!==r)throw new Error(e);if(null===t)throw new Error(e);if(a&&t.constructor===ArrayBuffer)t=new Uint8Array(t);else if(!(Array.isArray(t)||a&&ArrayBuffer.isView(t)))throw new Error(e);n=!0}for(var o,i,s=this.blocks,c=this.byteCount,u=t.length,d=this.blockCount,h=0,f=this.s;h<u;){if(this.reset)for(this.reset=!1,s[0]=this.block,o=1;o<d+1;++o)s[o]=0;if(n)for(o=this.start;h<u&&o<c;++h)s[o>>2]|=t[h]<<l[3&o++];else for(o=this.start;h<u&&o<c;++h)(i=t.charCodeAt(h))<128?s[o>>2]|=i<<l[3&o++]:i<2048?(s[o>>2]|=(192|i>>6)<<l[3&o++],s[o>>2]|=(128|63&i)<<l[3&o++]):i<55296||i>=57344?(s[o>>2]|=(224|i>>12)<<l[3&o++],s[o>>2]|=(128|i>>6&63)<<l[3&o++],s[o>>2]|=(128|63&i)<<l[3&o++]):(i=65536+((1023&i)<<10|1023&t.charCodeAt(++h)),s[o>>2]|=(240|i>>18)<<l[3&o++],s[o>>2]|=(128|i>>12&63)<<l[3&o++],s[o>>2]|=(128|i>>6&63)<<l[3&o++],s[o>>2]|=(128|63&i)<<l[3&o++]);if(this.lastByteIndex=o,o>=c){for(this.start=o-c,this.block=s[d],o=0;o<d;++o)f[o]^=s[o];O(f),this.reset=!0}else this.start=o}return this},T.prototype.encode=function(t,e){var n=255&t,r=1,o=[n];for(n=255&(t>>=8);n>0;)o.unshift(n),n=255&(t>>=8),++r;return e?o.push(r):o.unshift(r),this.update(o),o.length},T.prototype.encodeString=function(t){var n,r=typeof t;if("string"!==r){if("object"!==r)throw new Error(e);if(null===t)throw new Error(e);if(a&&t.constructor===ArrayBuffer)t=new Uint8Array(t);else if(!(Array.isArray(t)||a&&ArrayBuffer.isView(t)))throw new Error(e);n=!0}var o=0,i=t.length;if(n)o=i;else for(var s=0;s<t.length;++s){var c=t.charCodeAt(s);c<128?o+=1:c<2048?o+=2:c<55296||c>=57344?o+=3:(c=65536+((1023&c)<<10|1023&t.charCodeAt(++s)),o+=4)}return o+=this.encode(8*o),this.update(t),o},T.prototype.bytepad=function(t,e){for(var n=this.encode(e),r=0;r<t.length;++r)n+=this.encodeString(t[r]);var o=e-n%e,i=[];return i.length=o,this.update(i),this},T.prototype.finalize=function(){if(!this.finalized){this.finalized=!0;var t=this.blocks,e=this.lastByteIndex,n=this.blockCount,r=this.s;if(t[e>>2]|=this.padding[3&e],this.lastByteIndex===this.byteCount)for(t[0]=t[n],e=1;e<n+1;++e)t[e]=0;for(t[n-1]|=2147483648,e=0;e<n;++e)r[e]^=t[e];O(r)}},T.prototype.toString=T.prototype.hex=function(){this.finalize();for(var t,e=this.blockCount,n=this.s,r=this.outputBlocks,o=this.extraBytes,i=0,a=0,c="";a<r;){for(i=0;i<e&&a<r;++i,++a)t=n[i],c+=s[t>>4&15]+s[15&t]+s[t>>12&15]+s[t>>8&15]+s[t>>20&15]+s[t>>16&15]+s[t>>28&15]+s[t>>24&15];a%e==0&&(O(n),i=0)}return o&&(t=n[i],c+=s[t>>4&15]+s[15&t],o>1&&(c+=s[t>>12&15]+s[t>>8&15]),o>2&&(c+=s[t>>20&15]+s[t>>16&15])),c},T.prototype.arrayBuffer=function(){this.finalize();var t,e=this.blockCount,n=this.s,r=this.outputBlocks,o=this.extraBytes,i=0,a=0,s=this.outputBits>>3;t=o?new ArrayBuffer(r+1<<2):new ArrayBuffer(s);for(var c=new Uint32Array(t);a<r;){for(i=0;i<e&&a<r;++i,++a)c[a]=n[i];a%e==0&&O(n)}return o&&(c[i]=n[i],t=t.slice(0,s)),t},T.prototype.buffer=T.prototype.arrayBuffer,T.prototype.digest=T.prototype.array=function(){this.finalize();for(var t,e,n=this.blockCount,r=this.s,o=this.outputBlocks,i=this.extraBytes,a=0,s=0,c=[];s<o;){for(a=0;a<n&&s<o;++a,++s)t=s<<2,e=r[a],c[t]=255&e,c[t+1]=e>>8&255,c[t+2]=e>>16&255,c[t+3]=e>>24&255;s%n==0&&O(r)}return i&&(t=s<<2,e=r[a],c[t]=255&e,i>1&&(c[t+1]=e>>8&255),i>2&&(c[t+2]=e>>16&255)),c},R.prototype=new T,R.prototype.finalize=function(){return this.encode(this.outputBits,!0),T.prototype.finalize.call(this)};var O=function(t){var e,n,r,o,i,a,s,c,l,d,h,f,p,g,m,w,b,y,v,_,x,k,M,C,S,E,A,I,T,R,O,N,B,$,P,U,L,j,z,q,D,F,W,H,Y,K,J,V,Q,Z,G,X,tt,et,nt,rt,ot,it,at,st,ct,lt,ut;for(r=0;r<48;r+=2)o=t[0]^t[10]^t[20]^t[30]^t[40],i=t[1]^t[11]^t[21]^t[31]^t[41],a=t[2]^t[12]^t[22]^t[32]^t[42],s=t[3]^t[13]^t[23]^t[33]^t[43],c=t[4]^t[14]^t[24]^t[34]^t[44],l=t[5]^t[15]^t[25]^t[35]^t[45],d=t[6]^t[16]^t[26]^t[36]^t[46],h=t[7]^t[17]^t[27]^t[37]^t[47],e=(f=t[8]^t[18]^t[28]^t[38]^t[48])^(a<<1|s>>>31),n=(p=t[9]^t[19]^t[29]^t[39]^t[49])^(s<<1|a>>>31),t[0]^=e,t[1]^=n,t[10]^=e,t[11]^=n,t[20]^=e,t[21]^=n,t[30]^=e,t[31]^=n,t[40]^=e,t[41]^=n,e=o^(c<<1|l>>>31),n=i^(l<<1|c>>>31),t[2]^=e,t[3]^=n,t[12]^=e,t[13]^=n,t[22]^=e,t[23]^=n,t[32]^=e,t[33]^=n,t[42]^=e,t[43]^=n,e=a^(d<<1|h>>>31),n=s^(h<<1|d>>>31),t[4]^=e,t[5]^=n,t[14]^=e,t[15]^=n,t[24]^=e,t[25]^=n,t[34]^=e,t[35]^=n,t[44]^=e,t[45]^=n,e=c^(f<<1|p>>>31),n=l^(p<<1|f>>>31),t[6]^=e,t[7]^=n,t[16]^=e,t[17]^=n,t[26]^=e,t[27]^=n,t[36]^=e,t[37]^=n,t[46]^=e,t[47]^=n,e=d^(o<<1|i>>>31),n=h^(i<<1|o>>>31),t[8]^=e,t[9]^=n,t[18]^=e,t[19]^=n,t[28]^=e,t[29]^=n,t[38]^=e,t[39]^=n,t[48]^=e,t[49]^=n,g=t[0],m=t[1],K=t[11]<<4|t[10]>>>28,J=t[10]<<4|t[11]>>>28,I=t[20]<<3|t[21]>>>29,T=t[21]<<3|t[20]>>>29,st=t[31]<<9|t[30]>>>23,ct=t[30]<<9|t[31]>>>23,F=t[40]<<18|t[41]>>>14,W=t[41]<<18|t[40]>>>14,$=t[2]<<1|t[3]>>>31,P=t[3]<<1|t[2]>>>31,w=t[13]<<12|t[12]>>>20,b=t[12]<<12|t[13]>>>20,V=t[22]<<10|t[23]>>>22,Q=t[23]<<10|t[22]>>>22,R=t[33]<<13|t[32]>>>19,O=t[32]<<13|t[33]>>>19,lt=t[42]<<2|t[43]>>>30,ut=t[43]<<2|t[42]>>>30,et=t[5]<<30|t[4]>>>2,nt=t[4]<<30|t[5]>>>2,U=t[14]<<6|t[15]>>>26,L=t[15]<<6|t[14]>>>26,y=t[25]<<11|t[24]>>>21,v=t[24]<<11|t[25]>>>21,Z=t[34]<<15|t[35]>>>17,G=t[35]<<15|t[34]>>>17,N=t[45]<<29|t[44]>>>3,B=t[44]<<29|t[45]>>>3,C=t[6]<<28|t[7]>>>4,S=t[7]<<28|t[6]>>>4,rt=t[17]<<23|t[16]>>>9,ot=t[16]<<23|t[17]>>>9,j=t[26]<<25|t[27]>>>7,z=t[27]<<25|t[26]>>>7,_=t[36]<<21|t[37]>>>11,x=t[37]<<21|t[36]>>>11,X=t[47]<<24|t[46]>>>8,tt=t[46]<<24|t[47]>>>8,H=t[8]<<27|t[9]>>>5,Y=t[9]<<27|t[8]>>>5,E=t[18]<<20|t[19]>>>12,A=t[19]<<20|t[18]>>>12,it=t[29]<<7|t[28]>>>25,at=t[28]<<7|t[29]>>>25,q=t[38]<<8|t[39]>>>24,D=t[39]<<8|t[38]>>>24,k=t[48]<<14|t[49]>>>18,M=t[49]<<14|t[48]>>>18,t[0]=g^~w&y,t[1]=m^~b&v,t[10]=C^~E&I,t[11]=S^~A&T,t[20]=$^~U&j,t[21]=P^~L&z,t[30]=H^~K&V,t[31]=Y^~J&Q,t[40]=et^~rt&it,t[41]=nt^~ot&at,t[2]=w^~y&_,t[3]=b^~v&x,t[12]=E^~I&R,t[13]=A^~T&O,t[22]=U^~j&q,t[23]=L^~z&D,t[32]=K^~V&Z,t[33]=J^~Q&G,t[42]=rt^~it&st,t[43]=ot^~at&ct,t[4]=y^~_&k,t[5]=v^~x&M,t[14]=I^~R&N,t[15]=T^~O&B,t[24]=j^~q&F,t[25]=z^~D&W,t[34]=V^~Z&X,t[35]=Q^~G&tt,t[44]=it^~st&lt,t[45]=at^~ct&ut,t[6]=_^~k&g,t[7]=x^~M&m,t[16]=R^~N&C,t[17]=O^~B&S,t[26]=q^~F&$,t[27]=D^~W&P,t[36]=Z^~X&H,t[37]=G^~tt&Y,t[46]=st^~lt&et,t[47]=ct^~ut&nt,t[8]=k^~g&w,t[9]=M^~m&b,t[18]=N^~C&E,t[19]=B^~S&A,t[28]=F^~$&U,t[29]=W^~P&L,t[38]=X^~H&K,t[39]=tt^~Y&J,t[48]=lt^~et&rt,t[49]=ut^~nt&ot,t[0]^=u[r],t[1]^=u[r+1]};if(i)t.exports=x;else for(M=0;M<k.length;++M)r[k[M]]=x[k[M]]}()}(zn);var qn={},Dn=function(t,e){return Dn=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])},Dn(t,e)};
/*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */var Fn=function(){return Fn=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t},Fn.apply(this,arguments)};function Wn(t){var e="function"==typeof Symbol&&Symbol.iterator,n=e&&t[e],r=0;if(n)return n.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&r>=t.length&&(t=void 0),{value:t&&t[r++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")}function Hn(t,e){var n="function"==typeof Symbol&&t[Symbol.iterator];if(!n)return t;var r,o,i=n.call(t),a=[];try{for(;(void 0===e||e-- >0)&&!(r=i.next()).done;)a.push(r.value)}catch(t){o={error:t}}finally{try{r&&!r.done&&(n=i.return)&&n.call(i)}finally{if(o)throw o.error}}return a}function Yn(t){return this instanceof Yn?(this.v=t,this):new Yn(t)}var Kn,Jn=Object.freeze({__proto__:null,__extends:function(t,e){function n(){this.constructor=t}Dn(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)},get __assign(){return Fn},__rest:function(t,e){var n={};for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&e.indexOf(r)<0&&(n[r]=t[r]);if(null!=t&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(t);o<r.length;o++)e.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(t,r[o])&&(n[r[o]]=t[r[o]])}return n},__decorate:function(t,e,n,r){var o,i=arguments.length,a=i<3?e:null===r?r=Object.getOwnPropertyDescriptor(e,n):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(t,e,n,r);else for(var s=t.length-1;s>=0;s--)(o=t[s])&&(a=(i<3?o(a):i>3?o(e,n,a):o(e,n))||a);return i>3&&a&&Object.defineProperty(e,n,a),a},__param:function(t,e){return function(n,r){e(n,r,t)}},__metadata:function(t,e){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(t,e)},__awaiter:function(t,e,n,r){return new(n||(n=Promise))((function(o,i){function a(t){try{c(r.next(t))}catch(t){i(t)}}function s(t){try{c(r.throw(t))}catch(t){i(t)}}function c(t){var e;t.done?o(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e)}))).then(a,s)}c((r=r.apply(t,e||[])).next())}))},__generator:function(t,e){var n,r,o,i,a={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function s(i){return function(s){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,r=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!(o=a.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){a=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){a.label=i[1];break}if(6===i[0]&&a.label<o[1]){a.label=o[1],o=i;break}if(o&&a.label<o[2]){a.label=o[2],a.ops.push(i);break}o[2]&&a.ops.pop(),a.trys.pop();continue}i=e.call(t,a)}catch(t){i=[6,t],r=0}finally{n=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,s])}}},__createBinding:function(t,e,n,r){void 0===r&&(r=n),t[r]=e[n]},__exportStar:function(t,e){for(var n in t)"default"===n||e.hasOwnProperty(n)||(e[n]=t[n])},__values:Wn,__read:Hn,__spread:function(){for(var t=[],e=0;e<arguments.length;e++)t=t.concat(Hn(arguments[e]));return t},__spreadArrays:function(){for(var t=0,e=0,n=arguments.length;e<n;e++)t+=arguments[e].length;var r=Array(t),o=0;for(e=0;e<n;e++)for(var i=arguments[e],a=0,s=i.length;a<s;a++,o++)r[o]=i[a];return r},__await:Yn,__asyncGenerator:function(t,e,n){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var r,o=n.apply(t,e||[]),i=[];return r={},a("next"),a("throw"),a("return"),r[Symbol.asyncIterator]=function(){return this},r;function a(t){o[t]&&(r[t]=function(e){return new Promise((function(n,r){i.push([t,e,n,r])>1||s(t,e)}))})}function s(t,e){try{!function(t){t.value instanceof Yn?Promise.resolve(t.value.v).then(c,l):u(i[0][2],t)}(o[t](e))}catch(t){u(i[0][3],t)}}function c(t){s("next",t)}function l(t){s("throw",t)}function u(t,e){t(e),i.shift(),i.length&&s(i[0][0],i[0][1])}},__asyncDelegator:function(t){var e,n;return e={},r("next"),r("throw",(function(t){throw t})),r("return"),e[Symbol.iterator]=function(){return this},e;function r(r,o){e[r]=t[r]?function(e){return(n=!n)?{value:Yn(t[r](e)),done:"return"===r}:o?o(e):e}:o}},__asyncValues:function(t){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var e,n=t[Symbol.asyncIterator];return n?n.call(t):(t=Wn(t),e={},r("next"),r("throw"),r("return"),e[Symbol.asyncIterator]=function(){return this},e);function r(n){e[n]=t[n]&&function(e){return new Promise((function(r,o){(function(t,e,n,r){Promise.resolve(r).then((function(e){t({value:e,done:n})}),e)})(r,o,(e=t[n](e)).done,e.value)}))}}},__makeTemplateObject:function(t,e){return Object.defineProperty?Object.defineProperty(t,"raw",{value:e}):t.raw=e,t},__importStar:function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e},__importDefault:function(t){return t&&t.__esModule?t:{default:t}},__classPrivateFieldGet:function(t,e){if(!e.has(t))throw new TypeError("attempted to get private field on non-instance");return e.get(t)},__classPrivateFieldSet:function(t,e,n){if(!e.has(t))throw new TypeError("attempted to set private field on non-instance");return e.set(t,n),n}}),Vn=ee(Jn),Qn={};var Zn,Gn={};function Xn(t){return Pn(t)}function tr(t){return function(t){const e=t.startsWith("0x");return t=(t=Bn(t)).startsWith(Mn)?t.substring(1):t,e?$n(t):t}($n(t))}!function(t){Object.defineProperty(t,"__esModule",{value:!0});const e=Vn;e.__exportStar(function(){if(Kn)return Qn;function t(){return(null==te?void 0:te.crypto)||(null==te?void 0:te.msCrypto)||{}}function e(){const e=t();return e.subtle||e.webkitSubtle}return Kn=1,Object.defineProperty(Qn,"__esModule",{value:!0}),Qn.isBrowserCryptoAvailable=Qn.getSubtleCrypto=Qn.getBrowerCrypto=void 0,Qn.getBrowerCrypto=t,Qn.getSubtleCrypto=e,Qn.isBrowserCryptoAvailable=function(){return!!t()&&!!e()},Qn}(),t),e.__exportStar(function(){if(Zn)return Gn;function t(){return"undefined"==typeof document&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product}function e(){return"undefined"!=typeof process&&void 0!==process.versions&&void 0!==process.versions.node}return Zn=1,Object.defineProperty(Gn,"__esModule",{value:!0}),Gn.isBrowser=Gn.isNode=Gn.isReactNative=void 0,Gn.isReactNative=t,Gn.isNode=e,Gn.isBrowser=function(){return!t()&&!e()},Gn}(),t)}(qn);const er=function(){return Date.now()*Math.pow(10,3)+Math.floor(Math.random()*Math.pow(10,3))};function nr(){const t=((t,e)=>{for(e=t="";t++<36;e+=51*t&52?(15^t?8^Math.random()*(20^t?16:4):4).toString(16):"-");return e})();return t}function rr(t,e){return function(t,e){return!("string"!=typeof t||!t.match(/^0x[0-9A-Fa-f]*$/)||e&&t.length!==2+2*e)}(t,e)}function or(t){return void 0!==t.result}function ir(t){return void 0!==t.error}function ar(t){return void 0!==t.event}function sr(t){t=Bn(t.toLowerCase());const e=Bn(zn.exports.keccak_256(Rn(t)));let n="";for(let r=0;r<t.length;r++)parseInt(e[r],16)>7?n+=t[r].toUpperCase():n+=t[r];return $n(n)}function cr(t){var e;return(e=t)&&e.length&&!rr(t[0])&&(t[0]=Ln(t[0])),t}function lr(t){if(void 0!==t.type&&"0"!==t.type)return t;if(void 0===t.from||(!(e=t.from)||"0x"!==e.toLowerCase().substring(0,2)||!/^(0x)?[0-9a-f]{40}$/i.test(e)||!/^(0x)?[0-9a-f]{40}$/.test(e)&&!/^(0x)?[0-9A-F]{40}$/.test(e)&&e!==sr(e)))throw new Error("Transaction object must include a valid 'from' value.");var e;function n(t){let e=t;return("number"==typeof t||"string"==typeof t&&!function(t){return""===t||"string"==typeof t&&""===t.trim()}(t))&&(rr(t)?"string"==typeof t&&(e=Xn(t)):e=jn(t)),"string"==typeof e&&(e=tr(e)),e}const r={from:Xn(t.from),to:void 0===t.to?void 0:Xn(t.to),gasPrice:void 0===t.gasPrice?"":n(t.gasPrice),gas:void 0===t.gas?void 0===t.gasLimit?"":n(t.gasLimit):n(t.gas),value:void 0===t.value?"":n(t.value),nonce:void 0===t.nonce?"":n(t.nonce),data:void 0===t.data?"":Xn(t.data)||"0x"},o=["gasPrice","gas","value","nonce"];return Object.keys(r).forEach((t=>{(void 0===r[t]||"string"==typeof r[t]&&!r[t].trim().length)&&o.includes(t)&&delete r[t]})),r}var ur={},dr=t=>encodeURIComponent(t).replace(/[!'()*]/g,(t=>`%${t.charCodeAt(0).toString(16).toUpperCase()}`)),hr="%[a-f0-9]{2}",fr=new RegExp("("+hr+")|([^%]+?)","gi"),pr=new RegExp("("+hr+")+","gi");function gr(t,e){try{return[decodeURIComponent(t.join(""))]}catch(t){}if(1===t.length)return t;e=e||1;var n=t.slice(0,e),r=t.slice(e);return Array.prototype.concat.call([],gr(n),gr(r))}function mr(t){try{return decodeURIComponent(t)}catch(r){for(var e=t.match(fr)||[],n=1;n<e.length;n++)e=(t=gr(e,n).join("")).match(fr)||[];return t}}var wr=function(t){if("string"!=typeof t)throw new TypeError("Expected `encodedURI` to be of type `string`, got `"+typeof t+"`");try{return t=t.replace(/\+/g," "),decodeURIComponent(t)}catch(e){return function(t){for(var e={"%FE%FF":"��","%FF%FE":"��"},n=pr.exec(t);n;){try{e[n[0]]=decodeURIComponent(n[0])}catch(t){var r=mr(n[0]);r!==n[0]&&(e[n[0]]=r)}n=pr.exec(t)}e["%C2"]="�";for(var o=Object.keys(e),i=0;i<o.length;i++){var a=o[i];t=t.replace(new RegExp(a,"g"),e[a])}return t}(t)}},br=(t,e)=>{if("string"!=typeof t||"string"!=typeof e)throw new TypeError("Expected the arguments to be of type `string`");if(""===e)return[t];const n=t.indexOf(e);return-1===n?[t]:[t.slice(0,n),t.slice(n+e.length)]};function yr(t){return ur.parse(t)}function vr(t){return ur.stringify(t)}!function(t){const e=dr,n=wr,r=br;function o(t){if("string"!=typeof t||1!==t.length)throw new TypeError("arrayFormatSeparator must be single character string")}function i(t,n){return n.encode?n.strict?e(t):encodeURIComponent(t):t}function a(t,e){return e.decode?n(t):t}function s(t){return Array.isArray(t)?t.sort():"object"==typeof t?s(Object.keys(t)).sort(((t,e)=>Number(t)-Number(e))).map((e=>t[e])):t}function c(t){const e=t.indexOf("#");return-1!==e&&(t=t.slice(0,e)),t}function l(t){const e=(t=c(t)).indexOf("?");return-1===e?"":t.slice(e+1)}function u(t,e){return e.parseNumbers&&!Number.isNaN(Number(t))&&"string"==typeof t&&""!==t.trim()?t=Number(t):!e.parseBooleans||null===t||"true"!==t.toLowerCase()&&"false"!==t.toLowerCase()||(t="true"===t.toLowerCase()),t}function d(t,e){o((e=Object.assign({decode:!0,sort:!0,arrayFormat:"none",arrayFormatSeparator:",",parseNumbers:!1,parseBooleans:!1},e)).arrayFormatSeparator);const n=function(t){let e;switch(t.arrayFormat){case"index":return(t,n,r)=>{e=/\[(\d*)\]$/.exec(t),t=t.replace(/\[\d*\]$/,""),e?(void 0===r[t]&&(r[t]={}),r[t][e[1]]=n):r[t]=n};case"bracket":return(t,n,r)=>{e=/(\[\])$/.exec(t),t=t.replace(/\[\]$/,""),e?void 0!==r[t]?r[t]=[].concat(r[t],n):r[t]=[n]:r[t]=n};case"comma":case"separator":return(e,n,r)=>{const o="string"==typeof n&&n.split("").indexOf(t.arrayFormatSeparator)>-1?n.split(t.arrayFormatSeparator).map((e=>a(e,t))):null===n?n:a(n,t);r[e]=o};default:return(t,e,n)=>{void 0!==n[t]?n[t]=[].concat(n[t],e):n[t]=e}}}(e),i=Object.create(null);if("string"!=typeof t)return i;if(!(t=t.trim().replace(/^[?#&]/,"")))return i;for(const o of t.split("&")){let[t,s]=r(e.decode?o.replace(/\+/g," "):o,"=");s=void 0===s?null:["comma","separator"].includes(e.arrayFormat)?s:a(s,e),n(a(t,e),s,i)}for(const t of Object.keys(i)){const n=i[t];if("object"==typeof n&&null!==n)for(const t of Object.keys(n))n[t]=u(n[t],e);else i[t]=u(n,e)}return!1===e.sort?i:(!0===e.sort?Object.keys(i).sort():Object.keys(i).sort(e.sort)).reduce(((t,e)=>{const n=i[e];return Boolean(n)&&"object"==typeof n&&!Array.isArray(n)?t[e]=s(n):t[e]=n,t}),Object.create(null))}t.extract=l,t.parse=d,t.stringify=(t,e)=>{if(!t)return"";o((e=Object.assign({encode:!0,strict:!0,arrayFormat:"none",arrayFormatSeparator:","},e)).arrayFormatSeparator);const n=n=>e.skipNull&&null==t[n]||e.skipEmptyString&&""===t[n],r=function(t){switch(t.arrayFormat){case"index":return e=>(n,r)=>{const o=n.length;return void 0===r||t.skipNull&&null===r||t.skipEmptyString&&""===r?n:null===r?[...n,[i(e,t),"[",o,"]"].join("")]:[...n,[i(e,t),"[",i(o,t),"]=",i(r,t)].join("")]};case"bracket":return e=>(n,r)=>void 0===r||t.skipNull&&null===r||t.skipEmptyString&&""===r?n:null===r?[...n,[i(e,t),"[]"].join("")]:[...n,[i(e,t),"[]=",i(r,t)].join("")];case"comma":case"separator":return e=>(n,r)=>null==r||0===r.length?n:0===n.length?[[i(e,t),"=",i(r,t)].join("")]:[[n,i(r,t)].join(t.arrayFormatSeparator)];default:return e=>(n,r)=>void 0===r||t.skipNull&&null===r||t.skipEmptyString&&""===r?n:null===r?[...n,i(e,t)]:[...n,[i(e,t),"=",i(r,t)].join("")]}}(e),a={};for(const e of Object.keys(t))n(e)||(a[e]=t[e]);const s=Object.keys(a);return!1!==e.sort&&s.sort(e.sort),s.map((n=>{const o=t[n];return void 0===o?"":null===o?i(n,e):Array.isArray(o)?o.reduce(r(n),[]).join("&"):i(n,e)+"="+i(o,e)})).filter((t=>t.length>0)).join("&")},t.parseUrl=(t,e)=>{e=Object.assign({decode:!0},e);const[n,o]=r(t,"#");return Object.assign({url:n.split("?")[0]||"",query:d(l(t),e)},e&&e.parseFragmentIdentifier&&o?{fragmentIdentifier:a(o,e)}:{})},t.stringifyUrl=(e,n)=>{n=Object.assign({encode:!0,strict:!0},n);const r=c(e.url).split("?")[0]||"",o=t.extract(e.url),a=t.parse(o,{sort:!1}),s=Object.assign(a,e.query);let l=t.stringify(s,n);l&&(l=`?${l}`);let u=function(t){let e="";const n=t.indexOf("#");return-1!==n&&(e=t.slice(n)),e}(e.url);return e.fragmentIdentifier&&(u=`#${i(e.fragmentIdentifier,n)}`),`${r}${l}${u}`}}(ur);class _r{constructor(){this._eventEmitters=[],"undefined"!=typeof window&&void 0!==window.addEventListener&&(window.addEventListener("online",(()=>this.trigger("online"))),window.addEventListener("offline",(()=>this.trigger("offline"))))}on(t,e){this._eventEmitters.push({event:t,callback:e})}trigger(t){let e=[];t&&(e=this._eventEmitters.filter((e=>e.event===t))),e.forEach((t=>{t.callback()}))}}const xr=void 0!==global.WebSocket?global.WebSocket:require("ws");class kr{constructor(t){if(this.opts=t,this._queue=[],this._events=[],this._subscriptions=[],this._protocol=t.protocol,this._version=t.version,this._url="",this._netMonitor=null,this._socket=null,this._nextSocket=null,this._subscriptions=t.subscriptions||[],this._netMonitor=t.netMonitor||new _r,!t.url||"string"!=typeof t.url)throw new Error("Missing or invalid WebSocket url");this._url=t.url,this._netMonitor.on("online",(()=>this._socketCreate()))}set readyState(t){}get readyState(){return this._socket?this._socket.readyState:-1}set connecting(t){}get connecting(){return 0===this.readyState}set connected(t){}get connected(){return 1===this.readyState}set closing(t){}get closing(){return 2===this.readyState}set closed(t){}get closed(){return 3===this.readyState}open(){this._socketCreate()}close(){this._socketClose()}send(t,e,n){if(!e||"string"!=typeof e)throw new Error("Missing or invalid topic field");this._socketSend({topic:e,type:"pub",payload:t,silent:!!n})}subscribe(t){this._socketSend({topic:t,type:"sub",payload:"",silent:!0})}on(t,e){this._events.push({event:t,callback:e})}_socketCreate(){if(this._nextSocket)return;const t=function(t,e,n){var r,o;const i=t.startsWith("https")?t.replace("https","wss"):t.startsWith("http")?t.replace("http","ws"):t,a=i.split("?"),s=Le()?{protocol:e,version:n,env:"browser",host:(null===(r=Ye())||void 0===r?void 0:r.host)||""}:{protocol:e,version:n,env:(null===(o=Oe())||void 0===o?void 0:o.name)||""},c=function(t,e){let n=yr(t);return n=Object.assign(Object.assign({},n),e),vr(n)}(function(t){const e=-1!==t.indexOf("?")?t.indexOf("?"):void 0;return void 0!==e?t.substr(e):""}(a[1]||""),s);return a[0]+"?"+c}(this._url,this._protocol,this._version);if(this._nextSocket=new xr(t),!this._nextSocket)throw new Error("Failed to create socket");this._nextSocket.onmessage=t=>this._socketReceive(t),this._nextSocket.onopen=()=>this._socketOpen(),this._nextSocket.onerror=t=>this._socketError(t),this._nextSocket.onclose=()=>{setTimeout((()=>{this._nextSocket=null,this._socketCreate()}),1e3)}}_socketOpen(){this._socketClose(),this._socket=this._nextSocket,this._nextSocket=null,this._queueSubscriptions(),this._pushQueue()}_socketClose(){this._socket&&(this._socket.onclose=()=>{},this._socket.close())}_socketSend(t){const e=JSON.stringify(t);this._socket&&1===this._socket.readyState?this._socket.send(e):(this._setToQueue(t),this._socketCreate())}async _socketReceive(t){let e;try{e=JSON.parse(t.data)}catch(t){return}if(this._socketSend({topic:e.topic,type:"ack",payload:"",silent:!0}),this._socket&&1===this._socket.readyState){const t=this._events.filter((t=>"message"===t.event));t&&t.length&&t.forEach((t=>t.callback(e)))}}_socketError(t){const e=this._events.filter((t=>"error"===t.event));e&&e.length&&e.forEach((e=>e.callback(t)))}_queueSubscriptions(){this._subscriptions.forEach((t=>this._queue.push({topic:t,type:"sub",payload:"",silent:!0}))),this._subscriptions=this.opts.subscriptions||[]}_setToQueue(t){this._queue.push(t)}_pushQueue(){this._queue.forEach((t=>this._socketSend(t))),this._queue=[]}}const Mr="Session currently connected",Cr="Session currently disconnected",Sr="JSON RPC response format is invalid",Er="User close QRCode Modal";class Ar{constructor(){this._eventEmitters=[]}subscribe(t){this._eventEmitters.push(t)}unsubscribe(t){this._eventEmitters=this._eventEmitters.filter((e=>e.event!==t))}trigger(t){let e,n=[];e=void 0!==t.method?t.method:or(t)||ir(t)?`response:${t.id}`:ar(t)?t.event:"",e&&(n=this._eventEmitters.filter((t=>t.event===e))),n&&n.length||function(t){return ln.includes(t)||t.startsWith("wc_")}(e)||ar(e)||(n=this._eventEmitters.filter((t=>"call_request"===t.event))),n.forEach((e=>{if(ir(t)){const n=new Error(t.error.message);e.callback(n,null)}else e.callback(null,t)}))}}class Ir{constructor(t="walletconnect"){this.storageId=t}getSession(){let t=null;const e=en(this.storageId);return e&&void 0!==e.bridge&&(t=e),t}setSession(t){return tn(this.storageId,t),t}removeSession(){nn(this.storageId)}}const Tr="walletconnect.org",Rr="abcdefghijklmnopqrstuvwxyz0123456789".split("").map((t=>`https://${t}.bridge.walletconnect.org`));function Or(){return Rr[Math.floor(Math.random()*Rr.length)]}function Nr(t){return function(t){return function(t){return function(t){let e=t.indexOf("//")>-1?t.split("/")[2]:t.split("/")[0];return e=e.split(":")[0],e=e.split("?")[0],e}(t).split(".").slice(-2).join(".")}(t)===Tr}(t)?Or():t}class Br{constructor(t){if(this.protocol="wc",this.version=1,this._bridge="",this._key=null,this._clientId="",this._clientMeta=null,this._peerId="",this._peerMeta=null,this._handshakeId=0,this._handshakeTopic="",this._connected=!1,this._accounts=[],this._chainId=0,this._networkId=0,this._rpcUrl="",this._eventManager=new Ar,this._clientMeta=Ze()||t.connectorOpts.clientMeta||null,this._cryptoLib=t.cryptoLib,this._sessionStorage=t.sessionStorage||new Ir(t.connectorOpts.storageId),this._qrcodeModal=t.connectorOpts.qrcodeModal,this._qrcodeModalOptions=t.connectorOpts.qrcodeModalOptions,this._signingMethods=[...un,...t.connectorOpts.signingMethods||[]],!t.connectorOpts.bridge&&!t.connectorOpts.uri&&!t.connectorOpts.session)throw new Error("Missing one of the required parameters: bridge / uri / session");t.connectorOpts.bridge&&(this.bridge=Nr(t.connectorOpts.bridge)),t.connectorOpts.uri&&(this.uri=t.connectorOpts.uri);const e=t.connectorOpts.session||this._getStorageSession();e&&(this.session=e),this.handshakeId&&this._subscribeToSessionResponse(this.handshakeId,"Session request rejected"),this._transport=t.transport||new kr({protocol:this.protocol,version:this.version,url:this.bridge,subscriptions:[this.clientId]}),this._subscribeToInternalEvents(),this._initTransport(),t.connectorOpts.uri&&this._subscribeToSessionRequest(),t.pushServerOpts&&this._registerPushServer(t.pushServerOpts)}set bridge(t){t&&(this._bridge=t)}get bridge(){return this._bridge}set key(t){if(!t)return;const e=Tn(t).buffer;this._key=e}get key(){if(this._key){return t=this._key,e=!0,An(new Uint8Array(t),!e)}var t,e;return""}set clientId(t){t&&(this._clientId=t)}get clientId(){let t=this._clientId;return t||(t=this._clientId=nr()),this._clientId}set peerId(t){t&&(this._peerId=t)}get peerId(){return this._peerId}set clientMeta(t){}get clientMeta(){let t=this._clientMeta;return t||(t=this._clientMeta=Ze()),t}set peerMeta(t){this._peerMeta=t}get peerMeta(){return this._peerMeta}set handshakeTopic(t){t&&(this._handshakeTopic=t)}get handshakeTopic(){return this._handshakeTopic}set handshakeId(t){t&&(this._handshakeId=t)}get handshakeId(){return this._handshakeId}get uri(){return this._formatUri()}set uri(t){if(!t)return;const{handshakeTopic:e,bridge:n,key:r}=this._parseUri(t);this.handshakeTopic=e,this.bridge=n,this.key=r}set chainId(t){this._chainId=t}get chainId(){return this._chainId}set networkId(t){this._networkId=t}get networkId(){return this._networkId}set accounts(t){this._accounts=t}get accounts(){return this._accounts}set rpcUrl(t){this._rpcUrl=t}get rpcUrl(){return this._rpcUrl}set connected(t){}get connected(){return this._connected}set pending(t){}get pending(){return!!this._handshakeTopic}get session(){return{connected:this.connected,accounts:this.accounts,chainId:this.chainId,bridge:this.bridge,key:this.key,clientId:this.clientId,clientMeta:this.clientMeta,peerId:this.peerId,peerMeta:this.peerMeta,handshakeId:this.handshakeId,handshakeTopic:this.handshakeTopic}}set session(t){t&&(this._connected=t.connected,this.accounts=t.accounts,this.chainId=t.chainId,this.bridge=t.bridge,this.key=t.key,this.clientId=t.clientId,this.clientMeta=t.clientMeta,this.peerId=t.peerId,this.peerMeta=t.peerMeta,this.handshakeId=t.handshakeId,this.handshakeTopic=t.handshakeTopic)}on(t,e){const n={event:t,callback:e};this._eventManager.subscribe(n)}off(t){this._eventManager.unsubscribe(t)}async createInstantRequest(t){this._key=await this._generateKey();const e=this._formatRequest({method:"wc_instantRequest",params:[{peerId:this.clientId,peerMeta:this.clientMeta,request:this._formatRequest(t)}]});this.handshakeId=e.id,this.handshakeTopic=nr(),this._eventManager.trigger({event:"display_uri",params:[this.uri]}),this.on("modal_closed",(()=>{throw new Error(Er)}));const n=()=>{this.killSession()};try{const t=await this._sendCallRequest(e);return t&&n(),t}catch(t){throw n(),t}}async connect(t){if(!this._qrcodeModal)throw new Error("QRCode Modal not provided");return this.connected?{chainId:this.chainId,accounts:this.accounts}:(await this.createSession(t),new Promise((async(t,e)=>{this.on("modal_closed",(()=>e(new Error(Er)))),this.on("connect",((n,r)=>{if(n)return e(n);t(r.params[0])}))})))}async createSession(t){if(this._connected)throw new Error(Mr);if(this.pending)return;this._key=await this._generateKey();const e=this._formatRequest({method:"wc_sessionRequest",params:[{peerId:this.clientId,peerMeta:this.clientMeta,chainId:t&&t.chainId?t.chainId:null}]});this.handshakeId=e.id,this.handshakeTopic=nr(),this._sendSessionRequest(e,"Session update rejected",{topic:this.handshakeTopic}),this._eventManager.trigger({event:"display_uri",params:[this.uri]})}approveSession(t){if(this._connected)throw new Error(Mr);this.chainId=t.chainId,this.accounts=t.accounts,this.networkId=t.networkId||0,this.rpcUrl=t.rpcUrl||"";const e={approved:!0,chainId:this.chainId,networkId:this.networkId,accounts:this.accounts,rpcUrl:this.rpcUrl,peerId:this.clientId,peerMeta:this.clientMeta},n={id:this.handshakeId,jsonrpc:"2.0",result:e};this._sendResponse(n),this._connected=!0,this._setStorageSession(),this._eventManager.trigger({event:"connect",params:[{peerId:this.peerId,peerMeta:this.peerMeta,chainId:this.chainId,accounts:this.accounts}]})}rejectSession(t){if(this._connected)throw new Error(Mr);const e=t&&t.message?t.message:"Session Rejected",n=this._formatResponse({id:this.handshakeId,error:{message:e}});this._sendResponse(n),this._connected=!1,this._eventManager.trigger({event:"disconnect",params:[{message:e}]}),this._removeStorageSession()}updateSession(t){if(!this._connected)throw new Error(Cr);this.chainId=t.chainId,this.accounts=t.accounts,this.networkId=t.networkId||0,this.rpcUrl=t.rpcUrl||"";const e={approved:!0,chainId:this.chainId,networkId:this.networkId,accounts:this.accounts,rpcUrl:this.rpcUrl},n=this._formatRequest({method:"wc_sessionUpdate",params:[e]});this._sendSessionRequest(n,"Session update rejected"),this._eventManager.trigger({event:"session_update",params:[{chainId:this.chainId,accounts:this.accounts}]}),this._manageStorageSession()}async killSession(t){const e=t?t.message:"Session Disconnected",n=this._formatRequest({method:"wc_sessionUpdate",params:[{approved:!1,chainId:null,networkId:null,accounts:null}]});await this._sendRequest(n),this._handleSessionDisconnect(e)}async sendTransaction(t){if(!this._connected)throw new Error(Cr);const e=lr(t),n=this._formatRequest({method:"eth_sendTransaction",params:[e]});return await this._sendCallRequest(n)}async signTransaction(t){if(!this._connected)throw new Error(Cr);const e=lr(t),n=this._formatRequest({method:"eth_signTransaction",params:[e]});return await this._sendCallRequest(n)}async signMessage(t){if(!this._connected)throw new Error(Cr);const e=this._formatRequest({method:"eth_sign",params:t});return await this._sendCallRequest(e)}async signPersonalMessage(t){if(!this._connected)throw new Error(Cr);t=cr(t);const e=this._formatRequest({method:"personal_sign",params:t});return await this._sendCallRequest(e)}async signTypedData(t){if(!this._connected)throw new Error(Cr);const e=this._formatRequest({method:"eth_signTypedData",params:t});return await this._sendCallRequest(e)}async updateChain(t){if(!this._connected)throw new Error("Session currently disconnected");const e=this._formatRequest({method:"wallet_updateChain",params:[t]});return await this._sendCallRequest(e)}unsafeSend(t,e){return this._sendRequest(t,e),this._eventManager.trigger({event:"call_request_sent",params:[{request:t,options:e}]}),new Promise(((e,n)=>{this._subscribeToResponse(t.id,((t,r)=>{if(t)n(t);else{if(!r)throw new Error("Missing JSON RPC response");e(r)}}))}))}async sendCustomRequest(t,e){if(!this._connected)throw new Error(Cr);switch(t.method){case"eth_accounts":return this.accounts;case"eth_chainId":return jn(this.chainId);case"eth_sendTransaction":case"eth_signTransaction":t.params&&(t.params[0]=lr(t.params[0]));break;case"personal_sign":t.params&&(t.params=cr(t.params))}const n=this._formatRequest(t);return await this._sendCallRequest(n,e)}approveRequest(t){if(!or(t))throw new Error('JSON-RPC success response must include "result" field');{const e=this._formatResponse(t);this._sendResponse(e)}}rejectRequest(t){if(!ir(t))throw new Error('JSON-RPC error response must include "error" field');{const e=this._formatResponse(t);this._sendResponse(e)}}transportClose(){this._transport.close()}async _sendRequest(t,e){const n=this._formatRequest(t),r=await this._encrypt(n),o=void 0!==(null==e?void 0:e.topic)?e.topic:this.peerId,i=JSON.stringify(r),a=void 0!==(null==e?void 0:e.forcePushNotification)?!e.forcePushNotification:function(t){return!!t.method.startsWith("wc_")||!un.includes(t.method)}(n);this._transport.send(i,o,a)}async _sendResponse(t){const e=await this._encrypt(t),n=this.peerId,r=JSON.stringify(e);this._transport.send(r,n,!0)}async _sendSessionRequest(t,e,n){this._sendRequest(t,n),this._subscribeToSessionResponse(t.id,e)}_sendCallRequest(t,e){return this._sendRequest(t,e),this._eventManager.trigger({event:"call_request_sent",params:[{request:t,options:e}]}),this._subscribeToCallResponse(t.id)}_formatRequest(t){if(void 0===t.method)throw new Error('JSON RPC request must have valid "method" value');return{id:void 0===t.id?er():t.id,jsonrpc:"2.0",method:t.method,params:void 0===t.params?[]:t.params}}_formatResponse(t){if(void 0===t.id)throw new Error('JSON RPC request must have valid "id" value');const e={id:t.id,jsonrpc:"2.0"};if(ir(t)){const n=function(t){const e=t.message||"Failed or Rejected Request";let n=-32e3;if(t&&!t.code)switch(e){case"Parse error":n=-32700;break;case"Invalid request":n=-32600;break;case"Method not found":n=-32601;break;case"Invalid params":n=-32602;break;case"Internal error":n=-32603;break;default:n=-32e3}const r={code:n,message:e};return t.data&&(r.data=t.data),r}(t.error);return Object.assign(Object.assign(Object.assign({},e),t),{error:n})}if(or(t)){return Object.assign(Object.assign({},e),t)}throw new Error(Sr)}_handleSessionDisconnect(t){const e=t||"Session Disconnected";this._connected||(this._qrcodeModal&&this._qrcodeModal.close(),nn(rn)),this._connected&&(this._connected=!1),this._handshakeId&&(this._handshakeId=0),this._handshakeTopic&&(this._handshakeTopic=""),this._peerId&&(this._peerId=""),this._eventManager.trigger({event:"disconnect",params:[{message:e}]}),this._removeStorageSession(),this.transportClose()}_handleSessionResponse(t,e){e&&e.approved?(this._connected?(e.chainId&&(this.chainId=e.chainId),e.accounts&&(this.accounts=e.accounts),this._eventManager.trigger({event:"session_update",params:[{chainId:this.chainId,accounts:this.accounts}]})):(this._connected=!0,e.chainId&&(this.chainId=e.chainId),e.accounts&&(this.accounts=e.accounts),e.peerId&&!this.peerId&&(this.peerId=e.peerId),e.peerMeta&&!this.peerMeta&&(this.peerMeta=e.peerMeta),this._eventManager.trigger({event:"connect",params:[{peerId:this.peerId,peerMeta:this.peerMeta,chainId:this.chainId,accounts:this.accounts}]})),this._manageStorageSession()):this._handleSessionDisconnect(t)}async _handleIncomingMessages(t){if(![this.clientId,this.handshakeTopic].includes(t.topic))return;let e;try{e=JSON.parse(t.payload)}catch(t){return}const n=await this._decrypt(e);n&&this._eventManager.trigger(n)}_subscribeToSessionRequest(){this._transport.subscribe(this.handshakeTopic)}_subscribeToResponse(t,e){this.on(`response:${t}`,e)}_subscribeToSessionResponse(t,e){this._subscribeToResponse(t,((t,n)=>{t?this._handleSessionResponse(t.message):or(n)?this._handleSessionResponse(e,n.result):n.error&&n.error.message?this._handleSessionResponse(n.error.message):this._handleSessionResponse(e)}))}_subscribeToCallResponse(t){return new Promise(((e,n)=>{this._subscribeToResponse(t,((t,r)=>{t?n(t):or(r)?e(r.result):r.error&&r.error.message?n(r.error):n(new Error(Sr))}))}))}_subscribeToInternalEvents(){this.on("display_uri",(()=>{this._qrcodeModal&&this._qrcodeModal.open(this.uri,(()=>{this._eventManager.trigger({event:"modal_closed",params:[]})}),this._qrcodeModalOptions)})),this.on("connect",(()=>{this._qrcodeModal&&this._qrcodeModal.close()})),this.on("call_request_sent",((t,e)=>{const{request:n}=e.params[0];if(Pe()&&this._signingMethods.includes(n.method)){const t=en(rn);t&&(window.location.href=t.href)}})),this.on("wc_sessionRequest",((t,e)=>{t&&this._eventManager.trigger({event:"error",params:[{code:"SESSION_REQUEST_ERROR",message:t.toString()}]}),this.handshakeId=e.id,this.peerId=e.params[0].peerId,this.peerMeta=e.params[0].peerMeta;const n=Object.assign(Object.assign({},e),{method:"session_request"});this._eventManager.trigger(n)})),this.on("wc_sessionUpdate",((t,e)=>{t&&this._handleSessionResponse(t.message),this._handleSessionResponse("Session disconnected",e.params[0])}))}_initTransport(){this._transport.on("message",(t=>this._handleIncomingMessages(t))),this._transport.on("open",(()=>this._eventManager.trigger({event:"transport_open",params:[]}))),this._transport.on("close",(()=>this._eventManager.trigger({event:"transport_close",params:[]}))),this._transport.on("error",(()=>this._eventManager.trigger({event:"transport_error",params:["Websocket connection failed"]}))),this._transport.open()}_formatUri(){return`${this.protocol}:${this.handshakeTopic}@${this.version}?bridge=${encodeURIComponent(this.bridge)}&key=${this.key}`}_parseUri(t){const e=function(t){const e=t.indexOf(":"),n=-1!==t.indexOf("?")?t.indexOf("?"):void 0,r=t.substring(0,e),o=function(t){const e=t.split("@");return{handshakeTopic:e[0],version:parseInt(e[1],10)}}(t.substring(e+1,n)),i=function(t){const e=yr(t);return{key:e.key||"",bridge:e.bridge||""}}(void 0!==n?t.substr(n):"");return Object.assign(Object.assign({protocol:r},o),i)}(t);if(e.protocol===this.protocol){if(!e.handshakeTopic)throw Error("Invalid or missing handshakeTopic parameter value");const t=e.handshakeTopic;if(!e.bridge)throw Error("Invalid or missing bridge url parameter value");const n=decodeURIComponent(e.bridge);if(!e.key)throw Error("Invalid or missing key parameter value");return{handshakeTopic:t,bridge:n,key:e.key}}throw new Error("URI format is invalid")}async _generateKey(){if(this._cryptoLib){return await this._cryptoLib.generateKey()}return null}async _encrypt(t){const e=this._key;if(this._cryptoLib&&e){return await this._cryptoLib.encrypt(t,e)}return null}async _decrypt(t){const e=this._key;if(this._cryptoLib&&e){return await this._cryptoLib.decrypt(t,e)}return null}_getStorageSession(){let t=null;return this._sessionStorage&&(t=this._sessionStorage.getSession()),t}_setStorageSession(){this._sessionStorage&&this._sessionStorage.setSession(this.session)}_removeStorageSession(){this._sessionStorage&&this._sessionStorage.removeSession()}_manageStorageSession(){this._connected?this._setStorageSession():this._removeStorageSession()}_registerPushServer(t){if(!t.url||"string"!=typeof t.url)throw Error("Invalid or missing pushServerOpts.url parameter value");if(!t.type||"string"!=typeof t.type)throw Error("Invalid or missing pushServerOpts.type parameter value");if(!t.token||"string"!=typeof t.token)throw Error("Invalid or missing pushServerOpts.token parameter value");const e={bridge:this.bridge,topic:this.clientId,type:t.type,token:t.token,peerName:"",language:t.language||""};this.on("connect",(async(n,r)=>{if(n)throw n;if(t.peerMeta){const t=r.params[0].peerMeta.name;e.peerName=t}try{const n=await fetch(`${t.url}/new`,{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json"},body:JSON.stringify(e)});if(!(await n.json()).success)throw Error("Failed to register in Push Server")}catch(n){throw Error("Failed to register in Push Server")}}))}}const $r=256,Pr=256,Ur="AES-CBC",Lr=`SHA-${$r}`,jr="HMAC",zr="encrypt",qr="decrypt",Dr="sign",Fr="verify";async function Wr(t,e=Ur){return qn.getSubtleCrypto().importKey("raw",t,function(t){return t===Ur?{length:$r,name:Ur}:{hash:{name:Lr},name:jr}}(e),!0,function(t){return t===Ur?[zr,qr]:[Dr,Fr]}(e))}function Hr(t,e,n){return async function(t,e,n){const r=qn.getSubtleCrypto(),o=await Wr(e,Ur),i=await r.encrypt({iv:t,name:Ur},o,n);return new Uint8Array(i)}(t,e,n)}function Yr(t,e,n){return async function(t,e,n){const r=qn.getSubtleCrypto(),o=await Wr(e,Ur),i=await r.decrypt({iv:t,name:Ur},o,n);return new Uint8Array(i)}(t,e,n)}async function Kr(t,e){const n=await async function(t,e){const n=qn.getSubtleCrypto(),r=await Wr(t,jr),o=await n.sign({length:Pr,name:jr},r,e);return new Uint8Array(o)}(t,e);return n}async function Jr(t){const e=function(t){return qn.getBrowerCrypto().getRandomValues(new Uint8Array(t))}((t||256)/8);return Cn(En(e)).buffer}async function Vr(t,e){const n=Tn(t.data),r=Tn(t.iv),o=An(Tn(t.hmac),!1),i=On(n,r),a=An(await Kr(e,i),!1);return Bn(o)===Bn(a)}var Qr=Object.freeze({__proto__:null,generateKey:Jr,verifyHmac:Vr,encrypt:async function(t,e,n){const r=Cn(Un(e)),o=Cn(Un(n||await Jr(128))),i=An(o,!1),a=Cn(Rn(JSON.stringify(t))),s=await Hr(o,r,a),c=An(s,!1),l=On(s,o);return{data:c,hmac:An(await Kr(r,l),!1),iv:i}},decrypt:async function(t,e){const n=Cn(Un(e));if(!n)throw new Error("Missing key: required for decryption");if(!await Vr(t,n))return null;const r=Tn(t.data),o=Tn(t.iv),i=In(await Yr(o,n,r));let a;try{a=JSON.parse(i)}catch(t){return null}return a}});class Zr extends Br{constructor(t,e){super({cryptoLib:Qr,connectorOpts:t,pushServerOpts:e})}}var Gr=ee(cn),Xr={},to={},eo={},no={}.toString,ro=Array.isArray||function(t){return"[object Array]"==no.call(t)},oo=ro;ao.TYPED_ARRAY_SUPPORT=function(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()}catch(t){return!1}}();var io=ao.TYPED_ARRAY_SUPPORT?2147483647:1073741823;function ao(t,e,n){return ao.TYPED_ARRAY_SUPPORT||this instanceof ao?"number"==typeof t?lo(this,t):function(t,e,n,r){if("number"==typeof e)throw new TypeError('"value" argument must not be a number');if("undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer)return function(t,e,n,r){if(n<0||e.byteLength<n)throw new RangeError("'offset' is out of bounds");if(e.byteLength<n+(r||0))throw new RangeError("'length' is out of bounds");var o;o=void 0===n&&void 0===r?new Uint8Array(e):void 0===r?new Uint8Array(e,n):new Uint8Array(e,n,r);ao.TYPED_ARRAY_SUPPORT?o.__proto__=ao.prototype:o=uo(t,o);return o}(t,e,n,r);if("string"==typeof e)return function(t,e){var n=0|fo(e),r=co(t,n),o=r.write(e);o!==n&&(r=r.slice(0,o));return r}(t,e);return function(t,e){if(ao.isBuffer(e)){var n=0|so(e.length),r=co(t,n);return 0===r.length||e.copy(r,0,0,n),r}if(e){if("undefined"!=typeof ArrayBuffer&&e.buffer instanceof ArrayBuffer||"length"in e)return"number"!=typeof e.length||(o=e.length)!=o?co(t,0):uo(t,e);if("Buffer"===e.type&&Array.isArray(e.data))return uo(t,e.data)}var o;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(t,e)}(this,t,e,n):new ao(t,e,n)}function so(t){if(t>=io)throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+io.toString(16)+" bytes");return 0|t}function co(t,e){var n;return ao.TYPED_ARRAY_SUPPORT?(n=new Uint8Array(e)).__proto__=ao.prototype:(null===(n=t)&&(n=new ao(e)),n.length=e),n}function lo(t,e){var n=co(t,e<0?0:0|so(e));if(!ao.TYPED_ARRAY_SUPPORT)for(var r=0;r<e;++r)n[r]=0;return n}function uo(t,e){for(var n=e.length<0?0:0|so(e.length),r=co(t,n),o=0;o<n;o+=1)r[o]=255&e[o];return r}function ho(t,e){var n;e=e||1/0;for(var r=t.length,o=null,i=[],a=0;a<r;++a){if((n=t.charCodeAt(a))>55295&&n<57344){if(!o){if(n>56319){(e-=3)>-1&&i.push(239,191,189);continue}if(a+1===r){(e-=3)>-1&&i.push(239,191,189);continue}o=n;continue}if(n<56320){(e-=3)>-1&&i.push(239,191,189),o=n;continue}n=65536+(o-55296<<10|n-56320)}else o&&(e-=3)>-1&&i.push(239,191,189);if(o=null,n<128){if((e-=1)<0)break;i.push(n)}else if(n<2048){if((e-=2)<0)break;i.push(n>>6|192,63&n|128)}else if(n<65536){if((e-=3)<0)break;i.push(n>>12|224,n>>6&63|128,63&n|128)}else{if(!(n<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;i.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128)}}return i}function fo(t){return ao.isBuffer(t)?t.length:"undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(t)||t instanceof ArrayBuffer)?t.byteLength:("string"!=typeof t&&(t=""+t),0===t.length?0:ho(t).length)}ao.TYPED_ARRAY_SUPPORT&&(ao.prototype.__proto__=Uint8Array.prototype,ao.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&ao[Symbol.species]===ao&&Object.defineProperty(ao,Symbol.species,{value:null,configurable:!0,enumerable:!1,writable:!1})),ao.prototype.write=function(t,e,n){void 0===e||void 0===n&&"string"==typeof e?(n=this.length,e=0):isFinite(e)&&(e|=0,isFinite(n)?n|=0:n=void 0);var r=this.length-e;if((void 0===n||n>r)&&(n=r),t.length>0&&(n<0||e<0)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");return function(t,e,n,r){return function(t,e,n,r){for(var o=0;o<r&&!(o+n>=e.length||o>=t.length);++o)e[o+n]=t[o];return o}(ho(e,t.length-n),t,n,r)}(this,t,e,n)},ao.prototype.slice=function(t,e){var n,r=this.length;if((t=~~t)<0?(t+=r)<0&&(t=0):t>r&&(t=r),(e=void 0===e?r:~~e)<0?(e+=r)<0&&(e=0):e>r&&(e=r),e<t&&(e=t),ao.TYPED_ARRAY_SUPPORT)(n=this.subarray(t,e)).__proto__=ao.prototype;else{var o=e-t;n=new ao(o,void 0);for(var i=0;i<o;++i)n[i]=this[i+t]}return n},ao.prototype.copy=function(t,e,n,r){if(n||(n=0),r||0===r||(r=this.length),e>=t.length&&(e=t.length),e||(e=0),r>0&&r<n&&(r=n),r===n)return 0;if(0===t.length||0===this.length)return 0;if(e<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("sourceStart out of bounds");if(r<0)throw new RangeError("sourceEnd out of bounds");r>this.length&&(r=this.length),t.length-e<r-n&&(r=t.length-e+n);var o,i=r-n;if(this===t&&n<e&&e<r)for(o=i-1;o>=0;--o)t[o+e]=this[o+n];else if(i<1e3||!ao.TYPED_ARRAY_SUPPORT)for(o=0;o<i;++o)t[o+e]=this[o+n];else Uint8Array.prototype.set.call(t,this.subarray(n,n+i),e);return i},ao.prototype.fill=function(t,e,n){if("string"==typeof t){if("string"==typeof e?(e=0,n=this.length):"string"==typeof n&&(n=this.length),1===t.length){var r=t.charCodeAt(0);r<256&&(t=r)}}else"number"==typeof t&&(t&=255);if(e<0||this.length<e||this.length<n)throw new RangeError("Out of range index");if(n<=e)return this;var o;if(e>>>=0,n=void 0===n?this.length:n>>>0,t||(t=0),"number"==typeof t)for(o=e;o<n;++o)this[o]=t;else{var i=ao.isBuffer(t)?t:new ao(t),a=i.length;for(o=0;o<n-e;++o)this[o+e]=i[o%a]}return this},ao.concat=function(t,e){if(!oo(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return co(null,0);var n;if(void 0===e)for(e=0,n=0;n<t.length;++n)e+=t[n].length;var r=lo(null,e),o=0;for(n=0;n<t.length;++n){var i=t[n];if(!ao.isBuffer(i))throw new TypeError('"list" argument must be an Array of Buffers');i.copy(r,o),o+=i.length}return r},ao.byteLength=fo,ao.prototype._isBuffer=!0,ao.isBuffer=function(t){return!(null==t||!t._isBuffer)},eo.alloc=function(t){var e=new ao(t);return e.fill(0),e},eo.from=function(t){return new ao(t)};var po,go={},mo=[0,26,44,70,100,134,172,196,242,292,346,404,466,532,581,655,733,815,901,991,1085,1156,1258,1364,1474,1588,1706,1828,1921,2051,2185,2323,2465,2611,2761,2876,3034,3196,3362,3532,3706];go.getSymbolSize=function(t){if(!t)throw new Error('"version" cannot be null or undefined');if(t<1||t>40)throw new Error('"version" should be in range from 1 to 40');return 4*t+17},go.getSymbolTotalCodewords=function(t){return mo[t]},go.getBCHDigit=function(t){for(var e=0;0!==t;)e++,t>>>=1;return e},go.setToSJISFunction=function(t){if("function"!=typeof t)throw new Error('"toSJISFunc" is not a valid function.');po=t},go.isKanjiModeEnabled=function(){return void 0!==po},go.toSJIS=function(t){return po(t)};var wo,bo={};function yo(){this.buffer=[],this.length=0}(wo=bo).L={bit:1},wo.M={bit:0},wo.Q={bit:3},wo.H={bit:2},wo.isValid=function(t){return t&&void 0!==t.bit&&t.bit>=0&&t.bit<4},wo.from=function(t,e){if(wo.isValid(t))return t;try{return function(t){if("string"!=typeof t)throw new Error("Param is not a string");switch(t.toLowerCase()){case"l":case"low":return wo.L;case"m":case"medium":return wo.M;case"q":case"quartile":return wo.Q;case"h":case"high":return wo.H;default:throw new Error("Unknown EC Level: "+t)}}(t)}catch(t){return e}},yo.prototype={get:function(t){var e=Math.floor(t/8);return 1==(this.buffer[e]>>>7-t%8&1)},put:function(t,e){for(var n=0;n<e;n++)this.putBit(1==(t>>>e-n-1&1))},getLengthInBits:function(){return this.length},putBit:function(t){var e=Math.floor(this.length/8);this.buffer.length<=e&&this.buffer.push(0),t&&(this.buffer[e]|=128>>>this.length%8),this.length++}};var vo=yo,_o=eo;function xo(t){if(!t||t<1)throw new Error("BitMatrix size must be defined and greater than 0");this.size=t,this.data=_o.alloc(t*t),this.reservedBit=_o.alloc(t*t)}xo.prototype.set=function(t,e,n,r){var o=t*this.size+e;this.data[o]=n,r&&(this.reservedBit[o]=!0)},xo.prototype.get=function(t,e){return this.data[t*this.size+e]},xo.prototype.xor=function(t,e,n){this.data[t*this.size+e]^=n},xo.prototype.isReserved=function(t,e){return this.reservedBit[t*this.size+e]};var ko=xo,Mo={};!function(t){var e=go.getSymbolSize;t.getRowColCoords=function(t){if(1===t)return[];for(var n=Math.floor(t/7)+2,r=e(t),o=145===r?26:2*Math.ceil((r-13)/(2*n-2)),i=[r-7],a=1;a<n-1;a++)i[a]=i[a-1]-o;return i.push(6),i.reverse()},t.getPositions=function(e){for(var n=[],r=t.getRowColCoords(e),o=r.length,i=0;i<o;i++)for(var a=0;a<o;a++)0===i&&0===a||0===i&&a===o-1||i===o-1&&0===a||n.push([r[i],r[a]]);return n}}(Mo);var Co={},So=go.getSymbolSize;Co.getPositions=function(t){var e=So(t);return[[0,0],[e-7,0],[0,e-7]]};var Eo={};!function(t){t.Patterns={PATTERN000:0,PATTERN001:1,PATTERN010:2,PATTERN011:3,PATTERN100:4,PATTERN101:5,PATTERN110:6,PATTERN111:7};var e=3,n=3,r=40,o=10;function i(e,n,r){switch(e){case t.Patterns.PATTERN000:return(n+r)%2==0;case t.Patterns.PATTERN001:return n%2==0;case t.Patterns.PATTERN010:return r%3==0;case t.Patterns.PATTERN011:return(n+r)%3==0;case t.Patterns.PATTERN100:return(Math.floor(n/2)+Math.floor(r/3))%2==0;case t.Patterns.PATTERN101:return n*r%2+n*r%3==0;case t.Patterns.PATTERN110:return(n*r%2+n*r%3)%2==0;case t.Patterns.PATTERN111:return(n*r%3+(n+r)%2)%2==0;default:throw new Error("bad maskPattern:"+e)}}t.isValid=function(t){return null!=t&&""!==t&&!isNaN(t)&&t>=0&&t<=7},t.from=function(e){return t.isValid(e)?parseInt(e,10):void 0},t.getPenaltyN1=function(t){for(var n=t.size,r=0,o=0,i=0,a=null,s=null,c=0;c<n;c++){o=i=0,a=s=null;for(var l=0;l<n;l++){var u=t.get(c,l);u===a?o++:(o>=5&&(r+=e+(o-5)),a=u,o=1),(u=t.get(l,c))===s?i++:(i>=5&&(r+=e+(i-5)),s=u,i=1)}o>=5&&(r+=e+(o-5)),i>=5&&(r+=e+(i-5))}return r},t.getPenaltyN2=function(t){for(var e=t.size,r=0,o=0;o<e-1;o++)for(var i=0;i<e-1;i++){var a=t.get(o,i)+t.get(o,i+1)+t.get(o+1,i)+t.get(o+1,i+1);4!==a&&0!==a||r++}return r*n},t.getPenaltyN3=function(t){for(var e=t.size,n=0,o=0,i=0,a=0;a<e;a++){o=i=0;for(var s=0;s<e;s++)o=o<<1&2047|t.get(a,s),s>=10&&(1488===o||93===o)&&n++,i=i<<1&2047|t.get(s,a),s>=10&&(1488===i||93===i)&&n++}return n*r},t.getPenaltyN4=function(t){for(var e=0,n=t.data.length,r=0;r<n;r++)e+=t.data[r];return Math.abs(Math.ceil(100*e/n/5)-10)*o},t.applyMask=function(t,e){for(var n=e.size,r=0;r<n;r++)for(var o=0;o<n;o++)e.isReserved(o,r)||e.xor(o,r,i(t,o,r))},t.getBestMask=function(e,n){for(var r=Object.keys(t.Patterns).length,o=0,i=1/0,a=0;a<r;a++){n(a),t.applyMask(a,e);var s=t.getPenaltyN1(e)+t.getPenaltyN2(e)+t.getPenaltyN3(e)+t.getPenaltyN4(e);t.applyMask(a,e),s<i&&(i=s,o=a)}return o}}(Eo);var Ao={},Io=bo,To=[1,1,1,1,1,1,1,1,1,1,2,2,1,2,2,4,1,2,4,4,2,4,4,4,2,4,6,5,2,4,6,6,2,5,8,8,4,5,8,8,4,5,8,11,4,8,10,11,4,9,12,16,4,9,16,16,6,10,12,18,6,10,17,16,6,11,16,19,6,13,18,21,7,14,21,25,8,16,20,25,8,17,23,25,9,17,23,34,9,18,25,30,10,20,27,32,12,21,29,35,12,23,34,37,12,25,34,40,13,26,35,42,14,28,38,45,15,29,40,48,16,31,43,51,17,33,45,54,18,35,48,57,19,37,51,60,19,38,53,63,20,40,56,66,21,43,59,70,22,45,62,74,24,47,65,77,25,49,68,81],Ro=[7,10,13,17,10,16,22,28,15,26,36,44,20,36,52,64,26,48,72,88,36,64,96,112,40,72,108,130,48,88,132,156,60,110,160,192,72,130,192,224,80,150,224,264,96,176,260,308,104,198,288,352,120,216,320,384,132,240,360,432,144,280,408,480,168,308,448,532,180,338,504,588,196,364,546,650,224,416,600,700,224,442,644,750,252,476,690,816,270,504,750,900,300,560,810,960,312,588,870,1050,336,644,952,1110,360,700,1020,1200,390,728,1050,1260,420,784,1140,1350,450,812,1200,1440,480,868,1290,1530,510,924,1350,1620,540,980,1440,1710,570,1036,1530,1800,570,1064,1590,1890,600,1120,1680,1980,630,1204,1770,2100,660,1260,1860,2220,720,1316,1950,2310,750,1372,2040,2430];Ao.getBlocksCount=function(t,e){switch(e){case Io.L:return To[4*(t-1)+0];case Io.M:return To[4*(t-1)+1];case Io.Q:return To[4*(t-1)+2];case Io.H:return To[4*(t-1)+3];default:return}},Ao.getTotalCodewordsCount=function(t,e){switch(e){case Io.L:return Ro[4*(t-1)+0];case Io.M:return Ro[4*(t-1)+1];case Io.Q:return Ro[4*(t-1)+2];case Io.H:return Ro[4*(t-1)+3];default:return}};var Oo={},No={},Bo=eo,$o=Bo.alloc(512),Po=Bo.alloc(256);!function(){for(var t=1,e=0;e<255;e++)$o[e]=t,Po[t]=e,256&(t<<=1)&&(t^=285);for(e=255;e<512;e++)$o[e]=$o[e-255]}(),No.log=function(t){if(t<1)throw new Error("log("+t+")");return Po[t]},No.exp=function(t){return $o[t]},No.mul=function(t,e){return 0===t||0===e?0:$o[Po[t]+Po[e]]},function(t){var e=eo,n=No;t.mul=function(t,r){for(var o=e.alloc(t.length+r.length-1),i=0;i<t.length;i++)for(var a=0;a<r.length;a++)o[i+a]^=n.mul(t[i],r[a]);return o},t.mod=function(t,r){for(var o=e.from(t);o.length-r.length>=0;){for(var i=o[0],a=0;a<r.length;a++)o[a]^=n.mul(r[a],i);for(var s=0;s<o.length&&0===o[s];)s++;o=o.slice(s)}return o},t.generateECPolynomial=function(r){for(var o=e.from([1]),i=0;i<r;i++)o=t.mul(o,[1,n.exp(i)]);return o}}(Oo);for(var Uo={},Lo={byteLength:function(t){var e=Wo(t),n=e[0],r=e[1];return 3*(n+r)/4-r},toByteArray:function(t){var e,n,r=Wo(t),o=r[0],i=r[1],a=new qo(function(t,e,n){return 3*(e+n)/4-n}(0,o,i)),s=0,c=i>0?o-4:o;for(n=0;n<c;n+=4)e=zo[t.charCodeAt(n)]<<18|zo[t.charCodeAt(n+1)]<<12|zo[t.charCodeAt(n+2)]<<6|zo[t.charCodeAt(n+3)],a[s++]=e>>16&255,a[s++]=e>>8&255,a[s++]=255&e;2===i&&(e=zo[t.charCodeAt(n)]<<2|zo[t.charCodeAt(n+1)]>>4,a[s++]=255&e);1===i&&(e=zo[t.charCodeAt(n)]<<10|zo[t.charCodeAt(n+1)]<<4|zo[t.charCodeAt(n+2)]>>2,a[s++]=e>>8&255,a[s++]=255&e);return a},fromByteArray:function(t){for(var e,n=t.length,r=n%3,o=[],i=16383,a=0,s=n-r;a<s;a+=i)o.push(Ho(t,a,a+i>s?s:a+i));1===r?(e=t[n-1],o.push(jo[e>>2]+jo[e<<4&63]+"==")):2===r&&(e=(t[n-2]<<8)+t[n-1],o.push(jo[e>>10]+jo[e>>4&63]+jo[e<<2&63]+"="));return o.join("")}},jo=[],zo=[],qo="undefined"!=typeof Uint8Array?Uint8Array:Array,Do="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",Fo=0;Fo<64;++Fo)jo[Fo]=Do[Fo],zo[Do.charCodeAt(Fo)]=Fo;function Wo(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var n=t.indexOf("=");return-1===n&&(n=e),[n,n===e?0:4-n%4]}function Ho(t,e,n){for(var r,o,i=[],a=e;a<n;a+=3)r=(t[a]<<16&16711680)+(t[a+1]<<8&65280)+(255&t[a+2]),i.push(jo[(o=r)>>18&63]+jo[o>>12&63]+jo[o>>6&63]+jo[63&o]);return i.join("")}zo["-".charCodeAt(0)]=62,zo["_".charCodeAt(0)]=63;var Yo={
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
read:function(t,e,n,r,o){var i,a,s=8*o-r-1,c=(1<<s)-1,l=c>>1,u=-7,d=n?o-1:0,h=n?-1:1,f=t[e+d];for(d+=h,i=f&(1<<-u)-1,f>>=-u,u+=s;u>0;i=256*i+t[e+d],d+=h,u-=8);for(a=i&(1<<-u)-1,i>>=-u,u+=r;u>0;a=256*a+t[e+d],d+=h,u-=8);if(0===i)i=1-l;else{if(i===c)return a?NaN:1/0*(f?-1:1);a+=Math.pow(2,r),i-=l}return(f?-1:1)*a*Math.pow(2,i-r)},write:function(t,e,n,r,o,i){var a,s,c,l=8*i-o-1,u=(1<<l)-1,d=u>>1,h=23===o?Math.pow(2,-24)-Math.pow(2,-77):0,f=r?0:i-1,p=r?1:-1,g=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(s=isNaN(e)?1:0,a=u):(a=Math.floor(Math.log(e)/Math.LN2),e*(c=Math.pow(2,-a))<1&&(a--,c*=2),(e+=a+d>=1?h/c:h*Math.pow(2,1-d))*c>=2&&(a++,c/=2),a+d>=u?(s=0,a=u):a+d>=1?(s=(e*c-1)*Math.pow(2,o),a+=d):(s=e*Math.pow(2,d-1)*Math.pow(2,o),a=0));o>=8;t[n+f]=255&s,f+=p,s/=256,o-=8);for(a=a<<o|s,l+=o;l>0;t[n+f]=255&a,f+=p,a/=256,l-=8);t[n+f-p]|=128*g}};
/*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <https://feross.org>
     * @license  MIT
     */
!function(t){var e=Lo,n=Yo,r="function"==typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("nodejs.util.inspect.custom"):null;t.Buffer=a,t.SlowBuffer=function(t){+t!=t&&(t=0);return a.alloc(+t)},t.INSPECT_MAX_BYTES=50;var o=2147483647;function i(t){if(t>o)throw new RangeError('The value "'+t+'" is invalid for option "size"');var e=new Uint8Array(t);return Object.setPrototypeOf(e,a.prototype),e}function a(t,e,n){if("number"==typeof t){if("string"==typeof e)throw new TypeError('The "string" argument must be of type string. Received type number');return l(t)}return s(t,e,n)}function s(t,e,n){if("string"==typeof t)return function(t,e){"string"==typeof e&&""!==e||(e="utf8");if(!a.isEncoding(e))throw new TypeError("Unknown encoding: "+e);var n=0|f(t,e),r=i(n),o=r.write(t,e);o!==n&&(r=r.slice(0,o));return r}(t,e);if(ArrayBuffer.isView(t))return function(t){if(j(t,Uint8Array)){var e=new Uint8Array(t);return d(e.buffer,e.byteOffset,e.byteLength)}return u(t)}(t);if(null==t)throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof t);if(j(t,ArrayBuffer)||t&&j(t.buffer,ArrayBuffer))return d(t,e,n);if("undefined"!=typeof SharedArrayBuffer&&(j(t,SharedArrayBuffer)||t&&j(t.buffer,SharedArrayBuffer)))return d(t,e,n);if("number"==typeof t)throw new TypeError('The "value" argument must not be of type number. Received type number');var r=t.valueOf&&t.valueOf();if(null!=r&&r!==t)return a.from(r,e,n);var o=function(t){if(a.isBuffer(t)){var e=0|h(t.length),n=i(e);return 0===n.length||t.copy(n,0,0,e),n}if(void 0!==t.length)return"number"!=typeof t.length||z(t.length)?i(0):u(t);if("Buffer"===t.type&&Array.isArray(t.data))return u(t.data)}(t);if(o)return o;if("undefined"!=typeof Symbol&&null!=Symbol.toPrimitive&&"function"==typeof t[Symbol.toPrimitive])return a.from(t[Symbol.toPrimitive]("string"),e,n);throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof t)}function c(t){if("number"!=typeof t)throw new TypeError('"size" argument must be of type number');if(t<0)throw new RangeError('The value "'+t+'" is invalid for option "size"')}function l(t){return c(t),i(t<0?0:0|h(t))}function u(t){for(var e=t.length<0?0:0|h(t.length),n=i(e),r=0;r<e;r+=1)n[r]=255&t[r];return n}function d(t,e,n){if(e<0||t.byteLength<e)throw new RangeError('"offset" is outside of buffer bounds');if(t.byteLength<e+(n||0))throw new RangeError('"length" is outside of buffer bounds');var r;return r=void 0===e&&void 0===n?new Uint8Array(t):void 0===n?new Uint8Array(t,e):new Uint8Array(t,e,n),Object.setPrototypeOf(r,a.prototype),r}function h(t){if(t>=o)throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+o.toString(16)+" bytes");return 0|t}function f(t,e){if(a.isBuffer(t))return t.length;if(ArrayBuffer.isView(t)||j(t,ArrayBuffer))return t.byteLength;if("string"!=typeof t)throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type '+typeof t);var n=t.length,r=arguments.length>2&&!0===arguments[2];if(!r&&0===n)return 0;for(var o=!1;;)switch(e){case"ascii":case"latin1":case"binary":return n;case"utf8":case"utf-8":return P(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*n;case"hex":return n>>>1;case"base64":return U(t).length;default:if(o)return r?-1:P(t).length;e=(""+e).toLowerCase(),o=!0}}function p(t,e,n){var r=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return"";if((void 0===n||n>this.length)&&(n=this.length),n<=0)return"";if((n>>>=0)<=(e>>>=0))return"";for(t||(t="utf8");;)switch(t){case"hex":return A(this,e,n);case"utf8":case"utf-8":return M(this,e,n);case"ascii":return S(this,e,n);case"latin1":case"binary":return E(this,e,n);case"base64":return k(this,e,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return I(this,e,n);default:if(r)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),r=!0}}function g(t,e,n){var r=t[e];t[e]=t[n],t[n]=r}function m(t,e,n,r,o){if(0===t.length)return-1;if("string"==typeof n?(r=n,n=0):n>2147483647?n=2147483647:n<-2147483648&&(n=-2147483648),z(n=+n)&&(n=o?0:t.length-1),n<0&&(n=t.length+n),n>=t.length){if(o)return-1;n=t.length-1}else if(n<0){if(!o)return-1;n=0}if("string"==typeof e&&(e=a.from(e,r)),a.isBuffer(e))return 0===e.length?-1:w(t,e,n,r,o);if("number"==typeof e)return e&=255,"function"==typeof Uint8Array.prototype.indexOf?o?Uint8Array.prototype.indexOf.call(t,e,n):Uint8Array.prototype.lastIndexOf.call(t,e,n):w(t,[e],n,r,o);throw new TypeError("val must be string, number or Buffer")}function w(t,e,n,r,o){var i,a=1,s=t.length,c=e.length;if(void 0!==r&&("ucs2"===(r=String(r).toLowerCase())||"ucs-2"===r||"utf16le"===r||"utf-16le"===r)){if(t.length<2||e.length<2)return-1;a=2,s/=2,c/=2,n/=2}function l(t,e){return 1===a?t[e]:t.readUInt16BE(e*a)}if(o){var u=-1;for(i=n;i<s;i++)if(l(t,i)===l(e,-1===u?0:i-u)){if(-1===u&&(u=i),i-u+1===c)return u*a}else-1!==u&&(i-=i-u),u=-1}else for(n+c>s&&(n=s-c),i=n;i>=0;i--){for(var d=!0,h=0;h<c;h++)if(l(t,i+h)!==l(e,h)){d=!1;break}if(d)return i}return-1}function b(t,e,n,r){n=Number(n)||0;var o=t.length-n;r?(r=Number(r))>o&&(r=o):r=o;var i=e.length;r>i/2&&(r=i/2);for(var a=0;a<r;++a){var s=parseInt(e.substr(2*a,2),16);if(z(s))return a;t[n+a]=s}return a}function y(t,e,n,r){return L(P(e,t.length-n),t,n,r)}function v(t,e,n,r){return L(function(t){for(var e=[],n=0;n<t.length;++n)e.push(255&t.charCodeAt(n));return e}(e),t,n,r)}function _(t,e,n,r){return L(U(e),t,n,r)}function x(t,e,n,r){return L(function(t,e){for(var n,r,o,i=[],a=0;a<t.length&&!((e-=2)<0);++a)r=(n=t.charCodeAt(a))>>8,o=n%256,i.push(o),i.push(r);return i}(e,t.length-n),t,n,r)}function k(t,n,r){return 0===n&&r===t.length?e.fromByteArray(t):e.fromByteArray(t.slice(n,r))}function M(t,e,n){n=Math.min(t.length,n);for(var r=[],o=e;o<n;){var i,a,s,c,l=t[o],u=null,d=l>239?4:l>223?3:l>191?2:1;if(o+d<=n)switch(d){case 1:l<128&&(u=l);break;case 2:128==(192&(i=t[o+1]))&&(c=(31&l)<<6|63&i)>127&&(u=c);break;case 3:i=t[o+1],a=t[o+2],128==(192&i)&&128==(192&a)&&(c=(15&l)<<12|(63&i)<<6|63&a)>2047&&(c<55296||c>57343)&&(u=c);break;case 4:i=t[o+1],a=t[o+2],s=t[o+3],128==(192&i)&&128==(192&a)&&128==(192&s)&&(c=(15&l)<<18|(63&i)<<12|(63&a)<<6|63&s)>65535&&c<1114112&&(u=c)}null===u?(u=65533,d=1):u>65535&&(u-=65536,r.push(u>>>10&1023|55296),u=56320|1023&u),r.push(u),o+=d}return function(t){var e=t.length;if(e<=C)return String.fromCharCode.apply(String,t);var n="",r=0;for(;r<e;)n+=String.fromCharCode.apply(String,t.slice(r,r+=C));return n}(r)}t.kMaxLength=o,a.TYPED_ARRAY_SUPPORT=function(){try{var t=new Uint8Array(1),e={foo:function(){return 42}};return Object.setPrototypeOf(e,Uint8Array.prototype),Object.setPrototypeOf(t,e),42===t.foo()}catch(t){return!1}}(),a.TYPED_ARRAY_SUPPORT||"undefined"==typeof console||"function"!=typeof console.error||console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."),Object.defineProperty(a.prototype,"parent",{enumerable:!0,get:function(){if(a.isBuffer(this))return this.buffer}}),Object.defineProperty(a.prototype,"offset",{enumerable:!0,get:function(){if(a.isBuffer(this))return this.byteOffset}}),a.poolSize=8192,a.from=function(t,e,n){return s(t,e,n)},Object.setPrototypeOf(a.prototype,Uint8Array.prototype),Object.setPrototypeOf(a,Uint8Array),a.alloc=function(t,e,n){return function(t,e,n){return c(t),t<=0?i(t):void 0!==e?"string"==typeof n?i(t).fill(e,n):i(t).fill(e):i(t)}(t,e,n)},a.allocUnsafe=function(t){return l(t)},a.allocUnsafeSlow=function(t){return l(t)},a.isBuffer=function(t){return null!=t&&!0===t._isBuffer&&t!==a.prototype},a.compare=function(t,e){if(j(t,Uint8Array)&&(t=a.from(t,t.offset,t.byteLength)),j(e,Uint8Array)&&(e=a.from(e,e.offset,e.byteLength)),!a.isBuffer(t)||!a.isBuffer(e))throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');if(t===e)return 0;for(var n=t.length,r=e.length,o=0,i=Math.min(n,r);o<i;++o)if(t[o]!==e[o]){n=t[o],r=e[o];break}return n<r?-1:r<n?1:0},a.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},a.concat=function(t,e){if(!Array.isArray(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return a.alloc(0);var n;if(void 0===e)for(e=0,n=0;n<t.length;++n)e+=t[n].length;var r=a.allocUnsafe(e),o=0;for(n=0;n<t.length;++n){var i=t[n];if(j(i,Uint8Array))o+i.length>r.length?a.from(i).copy(r,o):Uint8Array.prototype.set.call(r,i,o);else{if(!a.isBuffer(i))throw new TypeError('"list" argument must be an Array of Buffers');i.copy(r,o)}o+=i.length}return r},a.byteLength=f,a.prototype._isBuffer=!0,a.prototype.swap16=function(){var t=this.length;if(t%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var e=0;e<t;e+=2)g(this,e,e+1);return this},a.prototype.swap32=function(){var t=this.length;if(t%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var e=0;e<t;e+=4)g(this,e,e+3),g(this,e+1,e+2);return this},a.prototype.swap64=function(){var t=this.length;if(t%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var e=0;e<t;e+=8)g(this,e,e+7),g(this,e+1,e+6),g(this,e+2,e+5),g(this,e+3,e+4);return this},a.prototype.toString=function(){var t=this.length;return 0===t?"":0===arguments.length?M(this,0,t):p.apply(this,arguments)},a.prototype.toLocaleString=a.prototype.toString,a.prototype.equals=function(t){if(!a.isBuffer(t))throw new TypeError("Argument must be a Buffer");return this===t||0===a.compare(this,t)},a.prototype.inspect=function(){var e="",n=t.INSPECT_MAX_BYTES;return e=this.toString("hex",0,n).replace(/(.{2})/g,"$1 ").trim(),this.length>n&&(e+=" ... "),"<Buffer "+e+">"},r&&(a.prototype[r]=a.prototype.inspect),a.prototype.compare=function(t,e,n,r,o){if(j(t,Uint8Array)&&(t=a.from(t,t.offset,t.byteLength)),!a.isBuffer(t))throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type '+typeof t);if(void 0===e&&(e=0),void 0===n&&(n=t?t.length:0),void 0===r&&(r=0),void 0===o&&(o=this.length),e<0||n>t.length||r<0||o>this.length)throw new RangeError("out of range index");if(r>=o&&e>=n)return 0;if(r>=o)return-1;if(e>=n)return 1;if(this===t)return 0;for(var i=(o>>>=0)-(r>>>=0),s=(n>>>=0)-(e>>>=0),c=Math.min(i,s),l=this.slice(r,o),u=t.slice(e,n),d=0;d<c;++d)if(l[d]!==u[d]){i=l[d],s=u[d];break}return i<s?-1:s<i?1:0},a.prototype.includes=function(t,e,n){return-1!==this.indexOf(t,e,n)},a.prototype.indexOf=function(t,e,n){return m(this,t,e,n,!0)},a.prototype.lastIndexOf=function(t,e,n){return m(this,t,e,n,!1)},a.prototype.write=function(t,e,n,r){if(void 0===e)r="utf8",n=this.length,e=0;else if(void 0===n&&"string"==typeof e)r=e,n=this.length,e=0;else{if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e>>>=0,isFinite(n)?(n>>>=0,void 0===r&&(r="utf8")):(r=n,n=void 0)}var o=this.length-e;if((void 0===n||n>o)&&(n=o),t.length>0&&(n<0||e<0)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");r||(r="utf8");for(var i=!1;;)switch(r){case"hex":return b(this,t,e,n);case"utf8":case"utf-8":return y(this,t,e,n);case"ascii":case"latin1":case"binary":return v(this,t,e,n);case"base64":return _(this,t,e,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return x(this,t,e,n);default:if(i)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),i=!0}},a.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var C=4096;function S(t,e,n){var r="";n=Math.min(t.length,n);for(var o=e;o<n;++o)r+=String.fromCharCode(127&t[o]);return r}function E(t,e,n){var r="";n=Math.min(t.length,n);for(var o=e;o<n;++o)r+=String.fromCharCode(t[o]);return r}function A(t,e,n){var r=t.length;(!e||e<0)&&(e=0),(!n||n<0||n>r)&&(n=r);for(var o="",i=e;i<n;++i)o+=q[t[i]];return o}function I(t,e,n){for(var r=t.slice(e,n),o="",i=0;i<r.length-1;i+=2)o+=String.fromCharCode(r[i]+256*r[i+1]);return o}function T(t,e,n){if(t%1!=0||t<0)throw new RangeError("offset is not uint");if(t+e>n)throw new RangeError("Trying to access beyond buffer length")}function R(t,e,n,r,o,i){if(!a.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(e>o||e<i)throw new RangeError('"value" argument is out of bounds');if(n+r>t.length)throw new RangeError("Index out of range")}function O(t,e,n,r,o,i){if(n+r>t.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("Index out of range")}function N(t,e,r,o,i){return e=+e,r>>>=0,i||O(t,0,r,4),n.write(t,e,r,o,23,4),r+4}function B(t,e,r,o,i){return e=+e,r>>>=0,i||O(t,0,r,8),n.write(t,e,r,o,52,8),r+8}a.prototype.slice=function(t,e){var n=this.length;(t=~~t)<0?(t+=n)<0&&(t=0):t>n&&(t=n),(e=void 0===e?n:~~e)<0?(e+=n)<0&&(e=0):e>n&&(e=n),e<t&&(e=t);var r=this.subarray(t,e);return Object.setPrototypeOf(r,a.prototype),r},a.prototype.readUintLE=a.prototype.readUIntLE=function(t,e,n){t>>>=0,e>>>=0,n||T(t,e,this.length);for(var r=this[t],o=1,i=0;++i<e&&(o*=256);)r+=this[t+i]*o;return r},a.prototype.readUintBE=a.prototype.readUIntBE=function(t,e,n){t>>>=0,e>>>=0,n||T(t,e,this.length);for(var r=this[t+--e],o=1;e>0&&(o*=256);)r+=this[t+--e]*o;return r},a.prototype.readUint8=a.prototype.readUInt8=function(t,e){return t>>>=0,e||T(t,1,this.length),this[t]},a.prototype.readUint16LE=a.prototype.readUInt16LE=function(t,e){return t>>>=0,e||T(t,2,this.length),this[t]|this[t+1]<<8},a.prototype.readUint16BE=a.prototype.readUInt16BE=function(t,e){return t>>>=0,e||T(t,2,this.length),this[t]<<8|this[t+1]},a.prototype.readUint32LE=a.prototype.readUInt32LE=function(t,e){return t>>>=0,e||T(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},a.prototype.readUint32BE=a.prototype.readUInt32BE=function(t,e){return t>>>=0,e||T(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},a.prototype.readIntLE=function(t,e,n){t>>>=0,e>>>=0,n||T(t,e,this.length);for(var r=this[t],o=1,i=0;++i<e&&(o*=256);)r+=this[t+i]*o;return r>=(o*=128)&&(r-=Math.pow(2,8*e)),r},a.prototype.readIntBE=function(t,e,n){t>>>=0,e>>>=0,n||T(t,e,this.length);for(var r=e,o=1,i=this[t+--r];r>0&&(o*=256);)i+=this[t+--r]*o;return i>=(o*=128)&&(i-=Math.pow(2,8*e)),i},a.prototype.readInt8=function(t,e){return t>>>=0,e||T(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},a.prototype.readInt16LE=function(t,e){t>>>=0,e||T(t,2,this.length);var n=this[t]|this[t+1]<<8;return 32768&n?4294901760|n:n},a.prototype.readInt16BE=function(t,e){t>>>=0,e||T(t,2,this.length);var n=this[t+1]|this[t]<<8;return 32768&n?4294901760|n:n},a.prototype.readInt32LE=function(t,e){return t>>>=0,e||T(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},a.prototype.readInt32BE=function(t,e){return t>>>=0,e||T(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},a.prototype.readFloatLE=function(t,e){return t>>>=0,e||T(t,4,this.length),n.read(this,t,!0,23,4)},a.prototype.readFloatBE=function(t,e){return t>>>=0,e||T(t,4,this.length),n.read(this,t,!1,23,4)},a.prototype.readDoubleLE=function(t,e){return t>>>=0,e||T(t,8,this.length),n.read(this,t,!0,52,8)},a.prototype.readDoubleBE=function(t,e){return t>>>=0,e||T(t,8,this.length),n.read(this,t,!1,52,8)},a.prototype.writeUintLE=a.prototype.writeUIntLE=function(t,e,n,r){(t=+t,e>>>=0,n>>>=0,r)||R(this,t,e,n,Math.pow(2,8*n)-1,0);var o=1,i=0;for(this[e]=255&t;++i<n&&(o*=256);)this[e+i]=t/o&255;return e+n},a.prototype.writeUintBE=a.prototype.writeUIntBE=function(t,e,n,r){(t=+t,e>>>=0,n>>>=0,r)||R(this,t,e,n,Math.pow(2,8*n)-1,0);var o=n-1,i=1;for(this[e+o]=255&t;--o>=0&&(i*=256);)this[e+o]=t/i&255;return e+n},a.prototype.writeUint8=a.prototype.writeUInt8=function(t,e,n){return t=+t,e>>>=0,n||R(this,t,e,1,255,0),this[e]=255&t,e+1},a.prototype.writeUint16LE=a.prototype.writeUInt16LE=function(t,e,n){return t=+t,e>>>=0,n||R(this,t,e,2,65535,0),this[e]=255&t,this[e+1]=t>>>8,e+2},a.prototype.writeUint16BE=a.prototype.writeUInt16BE=function(t,e,n){return t=+t,e>>>=0,n||R(this,t,e,2,65535,0),this[e]=t>>>8,this[e+1]=255&t,e+2},a.prototype.writeUint32LE=a.prototype.writeUInt32LE=function(t,e,n){return t=+t,e>>>=0,n||R(this,t,e,4,4294967295,0),this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t,e+4},a.prototype.writeUint32BE=a.prototype.writeUInt32BE=function(t,e,n){return t=+t,e>>>=0,n||R(this,t,e,4,4294967295,0),this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t,e+4},a.prototype.writeIntLE=function(t,e,n,r){if(t=+t,e>>>=0,!r){var o=Math.pow(2,8*n-1);R(this,t,e,n,o-1,-o)}var i=0,a=1,s=0;for(this[e]=255&t;++i<n&&(a*=256);)t<0&&0===s&&0!==this[e+i-1]&&(s=1),this[e+i]=(t/a>>0)-s&255;return e+n},a.prototype.writeIntBE=function(t,e,n,r){if(t=+t,e>>>=0,!r){var o=Math.pow(2,8*n-1);R(this,t,e,n,o-1,-o)}var i=n-1,a=1,s=0;for(this[e+i]=255&t;--i>=0&&(a*=256);)t<0&&0===s&&0!==this[e+i+1]&&(s=1),this[e+i]=(t/a>>0)-s&255;return e+n},a.prototype.writeInt8=function(t,e,n){return t=+t,e>>>=0,n||R(this,t,e,1,127,-128),t<0&&(t=255+t+1),this[e]=255&t,e+1},a.prototype.writeInt16LE=function(t,e,n){return t=+t,e>>>=0,n||R(this,t,e,2,32767,-32768),this[e]=255&t,this[e+1]=t>>>8,e+2},a.prototype.writeInt16BE=function(t,e,n){return t=+t,e>>>=0,n||R(this,t,e,2,32767,-32768),this[e]=t>>>8,this[e+1]=255&t,e+2},a.prototype.writeInt32LE=function(t,e,n){return t=+t,e>>>=0,n||R(this,t,e,4,2147483647,-2147483648),this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24,e+4},a.prototype.writeInt32BE=function(t,e,n){return t=+t,e>>>=0,n||R(this,t,e,4,2147483647,-2147483648),t<0&&(t=4294967295+t+1),this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t,e+4},a.prototype.writeFloatLE=function(t,e,n){return N(this,t,e,!0,n)},a.prototype.writeFloatBE=function(t,e,n){return N(this,t,e,!1,n)},a.prototype.writeDoubleLE=function(t,e,n){return B(this,t,e,!0,n)},a.prototype.writeDoubleBE=function(t,e,n){return B(this,t,e,!1,n)},a.prototype.copy=function(t,e,n,r){if(!a.isBuffer(t))throw new TypeError("argument should be a Buffer");if(n||(n=0),r||0===r||(r=this.length),e>=t.length&&(e=t.length),e||(e=0),r>0&&r<n&&(r=n),r===n)return 0;if(0===t.length||0===this.length)return 0;if(e<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("Index out of range");if(r<0)throw new RangeError("sourceEnd out of bounds");r>this.length&&(r=this.length),t.length-e<r-n&&(r=t.length-e+n);var o=r-n;return this===t&&"function"==typeof Uint8Array.prototype.copyWithin?this.copyWithin(e,n,r):Uint8Array.prototype.set.call(t,this.subarray(n,r),e),o},a.prototype.fill=function(t,e,n,r){if("string"==typeof t){if("string"==typeof e?(r=e,e=0,n=this.length):"string"==typeof n&&(r=n,n=this.length),void 0!==r&&"string"!=typeof r)throw new TypeError("encoding must be a string");if("string"==typeof r&&!a.isEncoding(r))throw new TypeError("Unknown encoding: "+r);if(1===t.length){var o=t.charCodeAt(0);("utf8"===r&&o<128||"latin1"===r)&&(t=o)}}else"number"==typeof t?t&=255:"boolean"==typeof t&&(t=Number(t));if(e<0||this.length<e||this.length<n)throw new RangeError("Out of range index");if(n<=e)return this;var i;if(e>>>=0,n=void 0===n?this.length:n>>>0,t||(t=0),"number"==typeof t)for(i=e;i<n;++i)this[i]=t;else{var s=a.isBuffer(t)?t:a.from(t,r),c=s.length;if(0===c)throw new TypeError('The value "'+t+'" is invalid for argument "value"');for(i=0;i<n-e;++i)this[i+e]=s[i%c]}return this};var $=/[^+/0-9A-Za-z-_]/g;function P(t,e){var n;e=e||1/0;for(var r=t.length,o=null,i=[],a=0;a<r;++a){if((n=t.charCodeAt(a))>55295&&n<57344){if(!o){if(n>56319){(e-=3)>-1&&i.push(239,191,189);continue}if(a+1===r){(e-=3)>-1&&i.push(239,191,189);continue}o=n;continue}if(n<56320){(e-=3)>-1&&i.push(239,191,189),o=n;continue}n=65536+(o-55296<<10|n-56320)}else o&&(e-=3)>-1&&i.push(239,191,189);if(o=null,n<128){if((e-=1)<0)break;i.push(n)}else if(n<2048){if((e-=2)<0)break;i.push(n>>6|192,63&n|128)}else if(n<65536){if((e-=3)<0)break;i.push(n>>12|224,n>>6&63|128,63&n|128)}else{if(!(n<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;i.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128)}}return i}function U(t){return e.toByteArray(function(t){if((t=(t=t.split("=")[0]).trim().replace($,"")).length<2)return"";for(;t.length%4!=0;)t+="=";return t}(t))}function L(t,e,n,r){for(var o=0;o<r&&!(o+n>=e.length||o>=t.length);++o)e[o+n]=t[o];return o}function j(t,e){return t instanceof e||null!=t&&null!=t.constructor&&null!=t.constructor.name&&t.constructor.name===e.name}function z(t){return t!=t}var q=function(){for(var t="0123456789abcdef",e=new Array(256),n=0;n<16;++n)for(var r=16*n,o=0;o<16;++o)e[r+o]=t[n]+t[o];return e}()}(Uo);var Ko=eo,Jo=Oo,Vo=Uo.Buffer;function Qo(t){this.genPoly=void 0,this.degree=t,this.degree&&this.initialize(this.degree)}Qo.prototype.initialize=function(t){this.degree=t,this.genPoly=Jo.generateECPolynomial(this.degree)},Qo.prototype.encode=function(t){if(!this.genPoly)throw new Error("Encoder not initialized");var e=Ko.alloc(this.degree),n=Vo.concat([t,e],t.length+this.degree),r=Jo.mod(n,this.genPoly),o=this.degree-r.length;if(o>0){var i=Ko.alloc(this.degree);return r.copy(i,o),i}return r};var Zo=Qo,Go={},Xo={},ti={isValid:function(t){return!isNaN(t)&&t>=1&&t<=40}},ei={},ni="[0-9]+",ri="(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+",oi="(?:(?![A-Z0-9 $%*+\\-./:]|"+(ri=ri.replace(/u/g,"\\u"))+")(?:.|[\r\n]))+";ei.KANJI=new RegExp(ri,"g"),ei.BYTE_KANJI=new RegExp("[^A-Z0-9 $%*+\\-./:]+","g"),ei.BYTE=new RegExp(oi,"g"),ei.NUMERIC=new RegExp(ni,"g"),ei.ALPHANUMERIC=new RegExp("[A-Z $%*+\\-./:]+","g");var ii=new RegExp("^"+ri+"$"),ai=new RegExp("^"+ni+"$"),si=new RegExp("^[A-Z0-9 $%*+\\-./:]+$");ei.testKanji=function(t){return ii.test(t)},ei.testNumeric=function(t){return ai.test(t)},ei.testAlphanumeric=function(t){return si.test(t)},function(t){var e=ti,n=ei;t.NUMERIC={id:"Numeric",bit:1,ccBits:[10,12,14]},t.ALPHANUMERIC={id:"Alphanumeric",bit:2,ccBits:[9,11,13]},t.BYTE={id:"Byte",bit:4,ccBits:[8,16,16]},t.KANJI={id:"Kanji",bit:8,ccBits:[8,10,12]},t.MIXED={bit:-1},t.getCharCountIndicator=function(t,n){if(!t.ccBits)throw new Error("Invalid mode: "+t);if(!e.isValid(n))throw new Error("Invalid version: "+n);return n>=1&&n<10?t.ccBits[0]:n<27?t.ccBits[1]:t.ccBits[2]},t.getBestModeForData=function(e){return n.testNumeric(e)?t.NUMERIC:n.testAlphanumeric(e)?t.ALPHANUMERIC:n.testKanji(e)?t.KANJI:t.BYTE},t.toString=function(t){if(t&&t.id)return t.id;throw new Error("Invalid mode")},t.isValid=function(t){return t&&t.bit&&t.ccBits},t.from=function(e,n){if(t.isValid(e))return e;try{return function(e){if("string"!=typeof e)throw new Error("Param is not a string");switch(e.toLowerCase()){case"numeric":return t.NUMERIC;case"alphanumeric":return t.ALPHANUMERIC;case"kanji":return t.KANJI;case"byte":return t.BYTE;default:throw new Error("Unknown mode: "+e)}}(e)}catch(t){return n}}}(Xo),function(t){var e=go,n=Ao,r=bo,o=Xo,i=ti,a=ro,s=e.getBCHDigit(7973);function c(t,e){return o.getCharCountIndicator(t,e)+4}function l(t,e){var n=0;return t.forEach((function(t){var r=c(t.mode,e);n+=r+t.getBitsLength()})),n}t.from=function(t,e){return i.isValid(t)?parseInt(t,10):e},t.getCapacity=function(t,r,a){if(!i.isValid(t))throw new Error("Invalid QR Code version");void 0===a&&(a=o.BYTE);var s=8*(e.getSymbolTotalCodewords(t)-n.getTotalCodewordsCount(t,r));if(a===o.MIXED)return s;var l=s-c(a,t);switch(a){case o.NUMERIC:return Math.floor(l/10*3);case o.ALPHANUMERIC:return Math.floor(l/11*2);case o.KANJI:return Math.floor(l/13);case o.BYTE:default:return Math.floor(l/8)}},t.getBestVersionForData=function(e,n){var i,s=r.from(n,r.M);if(a(e)){if(e.length>1)return function(e,n){for(var r=1;r<=40;r++)if(l(e,r)<=t.getCapacity(r,n,o.MIXED))return r}(e,s);if(0===e.length)return 1;i=e[0]}else i=e;return function(e,n,r){for(var o=1;o<=40;o++)if(n<=t.getCapacity(o,r,e))return o}(i.mode,i.getLength(),s)},t.getEncodedBits=function(t){if(!i.isValid(t)||t<7)throw new Error("Invalid QR Code version");for(var n=t<<12;e.getBCHDigit(n)-s>=0;)n^=7973<<e.getBCHDigit(n)-s;return t<<12|n}}(Go);var ci={},li=go,ui=li.getBCHDigit(1335);ci.getEncodedBits=function(t,e){for(var n=t.bit<<3|e,r=n<<10;li.getBCHDigit(r)-ui>=0;)r^=1335<<li.getBCHDigit(r)-ui;return 21522^(n<<10|r)};var di={},hi=Xo;function fi(t){this.mode=hi.NUMERIC,this.data=t.toString()}fi.getBitsLength=function(t){return 10*Math.floor(t/3)+(t%3?t%3*3+1:0)},fi.prototype.getLength=function(){return this.data.length},fi.prototype.getBitsLength=function(){return fi.getBitsLength(this.data.length)},fi.prototype.write=function(t){var e,n,r;for(e=0;e+3<=this.data.length;e+=3)n=this.data.substr(e,3),r=parseInt(n,10),t.put(r,10);var o=this.data.length-e;o>0&&(n=this.data.substr(e),r=parseInt(n,10),t.put(r,3*o+1))};var pi=fi,gi=Xo,mi=["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"," ","$","%","*","+","-",".","/",":"];function wi(t){this.mode=gi.ALPHANUMERIC,this.data=t}wi.getBitsLength=function(t){return 11*Math.floor(t/2)+t%2*6},wi.prototype.getLength=function(){return this.data.length},wi.prototype.getBitsLength=function(){return wi.getBitsLength(this.data.length)},wi.prototype.write=function(t){var e;for(e=0;e+2<=this.data.length;e+=2){var n=45*mi.indexOf(this.data[e]);n+=mi.indexOf(this.data[e+1]),t.put(n,11)}this.data.length%2&&t.put(mi.indexOf(this.data[e]),6)};var bi=wi,yi=eo,vi=Xo;function _i(t){this.mode=vi.BYTE,this.data=yi.from(t)}_i.getBitsLength=function(t){return 8*t},_i.prototype.getLength=function(){return this.data.length},_i.prototype.getBitsLength=function(){return _i.getBitsLength(this.data.length)},_i.prototype.write=function(t){for(var e=0,n=this.data.length;e<n;e++)t.put(this.data[e],8)};var xi=_i,ki=Xo,Mi=go;function Ci(t){this.mode=ki.KANJI,this.data=t}Ci.getBitsLength=function(t){return 13*t},Ci.prototype.getLength=function(){return this.data.length},Ci.prototype.getBitsLength=function(){return Ci.getBitsLength(this.data.length)},Ci.prototype.write=function(t){var e;for(e=0;e<this.data.length;e++){var n=Mi.toSJIS(this.data[e]);if(n>=33088&&n<=40956)n-=33088;else{if(!(n>=57408&&n<=60351))throw new Error("Invalid SJIS character: "+this.data[e]+"\nMake sure your charset is UTF-8");n-=49472}n=192*(n>>>8&255)+(255&n),t.put(n,13)}};var Si=Ci,Ei={exports:{}};!function(t){var e={single_source_shortest_paths:function(t,n,r){var o={},i={};i[n]=0;var a,s,c,l,u,d,h,f=e.PriorityQueue.make();for(f.push(n,0);!f.empty();)for(c in s=(a=f.pop()).value,l=a.cost,u=t[s]||{})u.hasOwnProperty(c)&&(d=l+u[c],h=i[c],(void 0===i[c]||h>d)&&(i[c]=d,f.push(c,d),o[c]=s));if(void 0!==r&&void 0===i[r]){var p=["Could not find a path from ",n," to ",r,"."].join("");throw new Error(p)}return o},extract_shortest_path_from_predecessor_list:function(t,e){for(var n=[],r=e;r;)n.push(r),t[r],r=t[r];return n.reverse(),n},find_path:function(t,n,r){var o=e.single_source_shortest_paths(t,n,r);return e.extract_shortest_path_from_predecessor_list(o,r)},PriorityQueue:{make:function(t){var n,r=e.PriorityQueue,o={};for(n in t=t||{},r)r.hasOwnProperty(n)&&(o[n]=r[n]);return o.queue=[],o.sorter=t.sorter||r.default_sorter,o},default_sorter:function(t,e){return t.cost-e.cost},push:function(t,e){var n={value:t,cost:e};this.queue.push(n),this.queue.sort(this.sorter)},pop:function(){return this.queue.shift()},empty:function(){return 0===this.queue.length}}};t.exports=e}(Ei),function(t){var e=Xo,n=pi,r=bi,o=xi,i=Si,a=ei,s=go,c=Ei.exports;function l(t){return unescape(encodeURIComponent(t)).length}function u(t,e,n){for(var r,o=[];null!==(r=t.exec(n));)o.push({data:r[0],index:r.index,mode:e,length:r[0].length});return o}function d(t){var n,r,o=u(a.NUMERIC,e.NUMERIC,t),i=u(a.ALPHANUMERIC,e.ALPHANUMERIC,t);return s.isKanjiModeEnabled()?(n=u(a.BYTE,e.BYTE,t),r=u(a.KANJI,e.KANJI,t)):(n=u(a.BYTE_KANJI,e.BYTE,t),r=[]),o.concat(i,n,r).sort((function(t,e){return t.index-e.index})).map((function(t){return{data:t.data,mode:t.mode,length:t.length}}))}function h(t,a){switch(a){case e.NUMERIC:return n.getBitsLength(t);case e.ALPHANUMERIC:return r.getBitsLength(t);case e.KANJI:return i.getBitsLength(t);case e.BYTE:return o.getBitsLength(t)}}function f(t,a){var c,l=e.getBestModeForData(t);if((c=e.from(a,l))!==e.BYTE&&c.bit<l.bit)throw new Error('"'+t+'" cannot be encoded with mode '+e.toString(c)+".\n Suggested mode is: "+e.toString(l));switch(c!==e.KANJI||s.isKanjiModeEnabled()||(c=e.BYTE),c){case e.NUMERIC:return new n(t);case e.ALPHANUMERIC:return new r(t);case e.KANJI:return new i(t);case e.BYTE:return new o(t)}}t.fromArray=function(t){return t.reduce((function(t,e){return"string"==typeof e?t.push(f(e,null)):e.data&&t.push(f(e.data,e.mode)),t}),[])},t.fromString=function(n,r){for(var o=function(t){for(var n=[],r=0;r<t.length;r++){var o=t[r];switch(o.mode){case e.NUMERIC:n.push([o,{data:o.data,mode:e.ALPHANUMERIC,length:o.length},{data:o.data,mode:e.BYTE,length:o.length}]);break;case e.ALPHANUMERIC:n.push([o,{data:o.data,mode:e.BYTE,length:o.length}]);break;case e.KANJI:n.push([o,{data:o.data,mode:e.BYTE,length:l(o.data)}]);break;case e.BYTE:n.push([{data:o.data,mode:e.BYTE,length:l(o.data)}])}}return n}(d(n,s.isKanjiModeEnabled())),i=function(t,n){for(var r={},o={start:{}},i=["start"],a=0;a<t.length;a++){for(var s=t[a],c=[],l=0;l<s.length;l++){var u=s[l],d=""+a+l;c.push(d),r[d]={node:u,lastCount:0},o[d]={};for(var f=0;f<i.length;f++){var p=i[f];r[p]&&r[p].node.mode===u.mode?(o[p][d]=h(r[p].lastCount+u.length,u.mode)-h(r[p].lastCount,u.mode),r[p].lastCount+=u.length):(r[p]&&(r[p].lastCount=u.length),o[p][d]=h(u.length,u.mode)+4+e.getCharCountIndicator(u.mode,n))}}i=c}for(f=0;f<i.length;f++)o[i[f]].end=0;return{map:o,table:r}}(o,r),a=c.find_path(i.map,"start","end"),u=[],f=1;f<a.length-1;f++)u.push(i.table[a[f]].node);return t.fromArray(function(t){return t.reduce((function(t,e){var n=t.length-1>=0?t[t.length-1]:null;return n&&n.mode===e.mode?(t[t.length-1].data+=e.data,t):(t.push(e),t)}),[])}(u))},t.rawSplit=function(e){return t.fromArray(d(e,s.isKanjiModeEnabled()))}}(di);var Ai=eo,Ii=go,Ti=bo,Ri=vo,Oi=ko,Ni=Mo,Bi=Co,$i=Eo,Pi=Ao,Ui=Zo,Li=Go,ji=ci,zi=Xo,qi=di,Di=ro;function Fi(t,e,n){var r,o,i=t.size,a=ji.getEncodedBits(e,n);for(r=0;r<15;r++)o=1==(a>>r&1),r<6?t.set(r,8,o,!0):r<8?t.set(r+1,8,o,!0):t.set(i-15+r,8,o,!0),r<8?t.set(8,i-r-1,o,!0):r<9?t.set(8,15-r-1+1,o,!0):t.set(8,15-r-1,o,!0);t.set(i-8,8,1,!0)}function Wi(t,e,n){var r=new Ri;n.forEach((function(e){r.put(e.mode.bit,4),r.put(e.getLength(),zi.getCharCountIndicator(e.mode,t)),e.write(r)}));var o=8*(Ii.getSymbolTotalCodewords(t)-Pi.getTotalCodewordsCount(t,e));for(r.getLengthInBits()+4<=o&&r.put(0,4);r.getLengthInBits()%8!=0;)r.putBit(0);for(var i=(o-r.getLengthInBits())/8,a=0;a<i;a++)r.put(a%2?17:236,8);return function(t,e,n){for(var r=Ii.getSymbolTotalCodewords(e),o=Pi.getTotalCodewordsCount(e,n),i=r-o,a=Pi.getBlocksCount(e,n),s=a-r%a,c=Math.floor(r/a),l=Math.floor(i/a),u=l+1,d=c-l,h=new Ui(d),f=0,p=new Array(a),g=new Array(a),m=0,w=Ai.from(t.buffer),b=0;b<a;b++){var y=b<s?l:u;p[b]=w.slice(f,f+y),g[b]=h.encode(p[b]),f+=y,m=Math.max(m,y)}var v,_,x=Ai.alloc(r),k=0;for(v=0;v<m;v++)for(_=0;_<a;_++)v<p[_].length&&(x[k++]=p[_][v]);for(v=0;v<d;v++)for(_=0;_<a;_++)x[k++]=g[_][v];return x}(r,t,e)}function Hi(t,e,n,r){var o;if(Di(t))o=qi.fromArray(t);else{if("string"!=typeof t)throw new Error("Invalid data");var i=e;if(!i){var a=qi.rawSplit(t);i=Li.getBestVersionForData(a,n)}o=qi.fromString(t,i||40)}var s=Li.getBestVersionForData(o,n);if(!s)throw new Error("The amount of data is too big to be stored in a QR Code");if(e){if(e<s)throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: "+s+".\n")}else e=s;var c=Wi(e,n,o),l=Ii.getSymbolSize(e),u=new Oi(l);return function(t,e){for(var n=t.size,r=Bi.getPositions(e),o=0;o<r.length;o++)for(var i=r[o][0],a=r[o][1],s=-1;s<=7;s++)if(!(i+s<=-1||n<=i+s))for(var c=-1;c<=7;c++)a+c<=-1||n<=a+c||(s>=0&&s<=6&&(0===c||6===c)||c>=0&&c<=6&&(0===s||6===s)||s>=2&&s<=4&&c>=2&&c<=4?t.set(i+s,a+c,!0,!0):t.set(i+s,a+c,!1,!0))}(u,e),function(t){for(var e=t.size,n=8;n<e-8;n++){var r=n%2==0;t.set(n,6,r,!0),t.set(6,n,r,!0)}}(u),function(t,e){for(var n=Ni.getPositions(e),r=0;r<n.length;r++)for(var o=n[r][0],i=n[r][1],a=-2;a<=2;a++)for(var s=-2;s<=2;s++)-2===a||2===a||-2===s||2===s||0===a&&0===s?t.set(o+a,i+s,!0,!0):t.set(o+a,i+s,!1,!0)}(u,e),Fi(u,n,0),e>=7&&function(t,e){for(var n,r,o,i=t.size,a=Li.getEncodedBits(e),s=0;s<18;s++)n=Math.floor(s/3),r=s%3+i-8-3,o=1==(a>>s&1),t.set(n,r,o,!0),t.set(r,n,o,!0)}(u,e),function(t,e){for(var n=t.size,r=-1,o=n-1,i=7,a=0,s=n-1;s>0;s-=2)for(6===s&&s--;;){for(var c=0;c<2;c++)if(!t.isReserved(o,s-c)){var l=!1;a<e.length&&(l=1==(e[a]>>>i&1)),t.set(o,s-c,l),-1==--i&&(a++,i=7)}if((o+=r)<0||n<=o){o-=r,r=-r;break}}}(u,c),isNaN(r)&&(r=$i.getBestMask(u,Fi.bind(null,u,n))),$i.applyMask(r,u),Fi(u,n,r),{modules:u,version:e,errorCorrectionLevel:n,maskPattern:r,segments:o}}to.create=function(t,e){if(void 0===t||""===t)throw new Error("No input text");var n,r,o=Ti.M;return void 0!==e&&(o=Ti.from(e.errorCorrectionLevel,Ti.M),n=Li.from(e.version),r=$i.from(e.maskPattern),e.toSJISFunc&&Ii.setToSJISFunction(e.toSJISFunc)),Hi(t,n,o,r)};var Yi={},Ki={};!function(t){function e(t){if("number"==typeof t&&(t=t.toString()),"string"!=typeof t)throw new Error("Color should be defined as hex string");var e=t.slice().replace("#","").split("");if(e.length<3||5===e.length||e.length>8)throw new Error("Invalid hex color: "+t);3!==e.length&&4!==e.length||(e=Array.prototype.concat.apply([],e.map((function(t){return[t,t]})))),6===e.length&&e.push("F","F");var n=parseInt(e.join(""),16);return{r:n>>24&255,g:n>>16&255,b:n>>8&255,a:255&n,hex:"#"+e.slice(0,6).join("")}}t.getOptions=function(t){t||(t={}),t.color||(t.color={});var n=void 0===t.margin||null===t.margin||t.margin<0?4:t.margin,r=t.width&&t.width>=21?t.width:void 0,o=t.scale||4;return{width:r,scale:r?4:o,margin:n,color:{dark:e(t.color.dark||"#000000ff"),light:e(t.color.light||"#ffffffff")},type:t.type,rendererOpts:t.rendererOpts||{}}},t.getScale=function(t,e){return e.width&&e.width>=t+2*e.margin?e.width/(t+2*e.margin):e.scale},t.getImageWidth=function(e,n){var r=t.getScale(e,n);return Math.floor((e+2*n.margin)*r)},t.qrToImageData=function(e,n,r){for(var o=n.modules.size,i=n.modules.data,a=t.getScale(o,r),s=Math.floor((o+2*r.margin)*a),c=r.margin*a,l=[r.color.light,r.color.dark],u=0;u<s;u++)for(var d=0;d<s;d++){var h=4*(u*s+d),f=r.color.light;if(u>=c&&d>=c&&u<s-c&&d<s-c)f=l[i[Math.floor((u-c)/a)*o+Math.floor((d-c)/a)]?1:0];e[h++]=f.r,e[h++]=f.g,e[h++]=f.b,e[h]=f.a}}}(Ki),function(t){var e=Ki;t.render=function(t,n,r){var o=r,i=n;void 0!==o||n&&n.getContext||(o=n,n=void 0),n||(i=function(){try{return document.createElement("canvas")}catch(t){throw new Error("You need to specify a canvas element")}}()),o=e.getOptions(o);var a=e.getImageWidth(t.modules.size,o),s=i.getContext("2d"),c=s.createImageData(a,a);return e.qrToImageData(c.data,t,o),function(t,e,n){t.clearRect(0,0,e.width,e.height),e.style||(e.style={}),e.height=n,e.width=n,e.style.height=n+"px",e.style.width=n+"px"}(s,i,a),s.putImageData(c,0,0),i},t.renderToDataURL=function(e,n,r){var o=r;void 0!==o||n&&n.getContext||(o=n,n=void 0),o||(o={});var i=t.render(e,n,o),a=o.type||"image/png",s=o.rendererOpts||{};return i.toDataURL(a,s.quality)}}(Yi);var Ji={},Vi=Ki;function Qi(t,e){var n=t.a/255,r=e+'="'+t.hex+'"';return n<1?r+" "+e+'-opacity="'+n.toFixed(2).slice(1)+'"':r}function Zi(t,e,n){var r=t+e;return void 0!==n&&(r+=" "+n),r}Ji.render=function(t,e,n){var r=Vi.getOptions(e),o=t.modules.size,i=t.modules.data,a=o+2*r.margin,s=r.color.light.a?"<path "+Qi(r.color.light,"fill")+' d="M0 0h'+a+"v"+a+'H0z"/>':"",c="<path "+Qi(r.color.dark,"stroke")+' d="'+function(t,e,n){for(var r="",o=0,i=!1,a=0,s=0;s<t.length;s++){var c=Math.floor(s%e),l=Math.floor(s/e);c||i||(i=!0),t[s]?(a++,s>0&&c>0&&t[s-1]||(r+=i?Zi("M",c+n,.5+l+n):Zi("m",o,0),o=0,i=!1),c+1<e&&t[s+1]||(r+=Zi("h",a),a=0)):o++}return r}(i,o,r.margin)+'"/>',l='viewBox="0 0 '+a+" "+a+'"',u='<svg xmlns="http://www.w3.org/2000/svg" '+(r.width?'width="'+r.width+'" height="'+r.width+'" ':"")+l+' shape-rendering="crispEdges">'+s+c+"</svg>\n";return"function"==typeof n&&n(null,u),u};var Gi=function(){return"function"==typeof Promise&&Promise.prototype&&Promise.prototype.then},Xi=to,ta=Yi,ea=Ji;function na(t,e,n,r,o){var i=[].slice.call(arguments,1),a=i.length,s="function"==typeof i[a-1];if(!s&&!Gi())throw new Error("Callback required as last argument");if(!s){if(a<1)throw new Error("Too few arguments provided");return 1===a?(n=e,e=r=void 0):2!==a||e.getContext||(r=n,n=e,e=void 0),new Promise((function(o,i){try{var a=Xi.create(n,r);o(t(a,e,r))}catch(t){i(t)}}))}if(a<2)throw new Error("Too few arguments provided");2===a?(o=n,n=e,e=r=void 0):3===a&&(e.getContext&&void 0===o?(o=r,r=void 0):(o=r,r=n,n=e,e=void 0));try{var c=Xi.create(n,r);o(null,t(c,e,r))}catch(t){o(t)}}Xr.create=Xi.create,Xr.toCanvas=na.bind(null,ta.render),Xr.toDataURL=na.bind(null,ta.renderToDataURL),Xr.toString=na.bind(null,(function(t,e,n){return ea.render(t,n)}));var ra=function(){var t=document.getSelection();if(!t.rangeCount)return function(){};for(var e=document.activeElement,n=[],r=0;r<t.rangeCount;r++)n.push(t.getRangeAt(r));switch(e.tagName.toUpperCase()){case"INPUT":case"TEXTAREA":e.blur();break;default:e=null}return t.removeAllRanges(),function(){"Caret"===t.type&&t.removeAllRanges(),t.rangeCount||n.forEach((function(e){t.addRange(e)})),e&&e.focus()}},oa={"text/plain":"Text","text/html":"Url",default:"Text"};var ia,aa,sa,ca,la,ua,da,ha=function(t,e){var n,r,o,i,a,s,c=!1;e||(e={}),n=e.debug||!1;try{if(o=ra(),i=document.createRange(),a=document.getSelection(),(s=document.createElement("span")).textContent=t,s.ariaHidden="true",s.style.all="unset",s.style.position="fixed",s.style.top=0,s.style.clip="rect(0, 0, 0, 0)",s.style.whiteSpace="pre",s.style.webkitUserSelect="text",s.style.MozUserSelect="text",s.style.msUserSelect="text",s.style.userSelect="text",s.addEventListener("copy",(function(r){if(r.stopPropagation(),e.format)if(r.preventDefault(),void 0===r.clipboardData){n&&console.warn("unable to use e.clipboardData"),n&&console.warn("trying IE specific stuff"),window.clipboardData.clearData();var o=oa[e.format]||oa.default;window.clipboardData.setData(o,t)}else r.clipboardData.clearData(),r.clipboardData.setData(e.format,t);e.onCopy&&(r.preventDefault(),e.onCopy(r.clipboardData))})),document.body.appendChild(s),i.selectNodeContents(s),a.addRange(i),!document.execCommand("copy"))throw new Error("copy command was unsuccessful");c=!0}catch(o){n&&console.error("unable to copy using execCommand: ",o),n&&console.warn("trying IE specific stuff");try{window.clipboardData.setData(e.format||"text",t),e.onCopy&&e.onCopy(window.clipboardData),c=!0}catch(o){n&&console.error("unable to copy using clipboardData: ",o),n&&console.error("falling back to prompt"),r=function(t){var e=(/mac os x/i.test(navigator.userAgent)?"⌘":"Ctrl")+"+C";return t.replace(/#{\s*key\s*}/g,e)}("message"in e?e.message:"Copy to clipboard: #{key}, Enter"),window.prompt(r,t)}}finally{a&&("function"==typeof a.removeRange?a.removeRange(i):a.removeAllRanges()),s&&document.body.removeChild(s),o()}return c},fa={},pa=[],ga=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord/i;function ma(t,e){for(var n in e)t[n]=e[n];return t}function wa(t){var e=t.parentNode;e&&e.removeChild(t)}function ba(t,e,n){var r,o=arguments,i={};for(r in e)"key"!==r&&"ref"!==r&&(i[r]=e[r]);if(arguments.length>3)for(n=[n],r=3;r<arguments.length;r++)n.push(o[r]);if(null!=n&&(i.children=n),"function"==typeof t&&null!=t.defaultProps)for(r in t.defaultProps)void 0===i[r]&&(i[r]=t.defaultProps[r]);return ya(t,i,e&&e.key,e&&e.ref,null)}function ya(t,e,n,r,o){var i={type:t,props:e,key:n,ref:r,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,constructor:void 0,__v:o};return null==o&&(i.__v=i),ia.vnode&&ia.vnode(i),i}function va(){return{}}function _a(t){return t.children}function xa(t,e){this.props=t,this.context=e}function ka(t,e){if(null==e)return t.__?ka(t.__,t.__.__k.indexOf(t)+1):null;for(var n;e<t.__k.length;e++)if(null!=(n=t.__k[e])&&null!=n.__e)return n.__e;return"function"==typeof t.type?ka(t):null}function Ma(t){var e,n;if(null!=(t=t.__)&&null!=t.__c){for(t.__e=t.__c.base=null,e=0;e<t.__k.length;e++)if(null!=(n=t.__k[e])&&null!=n.__e){t.__e=t.__c.base=n.__e;break}return Ma(t)}}function Ca(t){(!t.__d&&(t.__d=!0)&&aa.push(t)&&!sa++||la!==ia.debounceRendering)&&((la=ia.debounceRendering)||ca)(Sa)}function Sa(){for(var t;sa=aa.length;)t=aa.sort((function(t,e){return t.__v.__b-e.__v.__b})),aa=[],t.some((function(t){var e,n,r,o,i,a,s;t.__d&&(a=(i=(e=t).__v).__e,(s=e.__P)&&(n=[],(r=ma({},i)).__v=r,o=Oa(s,i,r,e.__n,void 0!==s.ownerSVGElement,null,n,null==a?ka(i):a),Na(n,i),o!=a&&Ma(i)))}))}function Ea(t,e,n,r,o,i,a,s,c){var l,u,d,h,f,p,g,m=n&&n.__k||pa,w=m.length;if(s==fa&&(s=null!=i?i[0]:w?ka(n,0):null),l=0,e.__k=Aa(e.__k,(function(n){if(null!=n){if(n.__=e,n.__b=e.__b+1,null===(d=m[l])||d&&n.key==d.key&&n.type===d.type)m[l]=void 0;else for(u=0;u<w;u++){if((d=m[u])&&n.key==d.key&&n.type===d.type){m[u]=void 0;break}d=null}if(h=Oa(t,n,d=d||fa,r,o,i,a,s,c),(u=n.ref)&&d.ref!=u&&(g||(g=[]),d.ref&&g.push(d.ref,null,n),g.push(u,n.__c||h,n)),null!=h){var b;if(null==p&&(p=h),void 0!==n.__d)b=n.__d,n.__d=void 0;else if(i==d||h!=s||null==h.parentNode){t:if(null==s||s.parentNode!==t)t.appendChild(h),b=null;else{for(f=s,u=0;(f=f.nextSibling)&&u<w;u+=2)if(f==h)break t;t.insertBefore(h,s),b=s}"option"==e.type&&(t.value="")}s=void 0!==b?b:h.nextSibling,"function"==typeof e.type&&(e.__d=s)}else s&&d.__e==s&&s.parentNode!=t&&(s=ka(d))}return l++,n})),e.__e=p,null!=i&&"function"!=typeof e.type)for(l=i.length;l--;)null!=i[l]&&wa(i[l]);for(l=w;l--;)null!=m[l]&&$a(m[l],m[l]);if(g)for(l=0;l<g.length;l++)Ba(g[l],g[++l],g[++l])}function Aa(t,e,n){if(null==n&&(n=[]),null==t||"boolean"==typeof t)e&&n.push(e(null));else if(Array.isArray(t))for(var r=0;r<t.length;r++)Aa(t[r],e,n);else n.push(e?e("string"==typeof t||"number"==typeof t?ya(null,t,null,null,t):null!=t.__e||null!=t.__c?ya(t.type,t.props,t.key,null,t.__v):t):t);return n}function Ia(t,e,n){"-"===e[0]?t.setProperty(e,n):t[e]="number"==typeof n&&!1===ga.test(e)?n+"px":null==n?"":n}function Ta(t,e,n,r,o){var i,a,s,c,l;if(o?"className"===e&&(e="class"):"class"===e&&(e="className"),"style"===e)if(i=t.style,"string"==typeof n)i.cssText=n;else{if("string"==typeof r&&(i.cssText="",r=null),r)for(c in r)n&&c in n||Ia(i,c,"");if(n)for(l in n)r&&n[l]===r[l]||Ia(i,l,n[l])}else"o"===e[0]&&"n"===e[1]?(a=e!==(e=e.replace(/Capture$/,"")),s=e.toLowerCase(),e=(s in t?s:e).slice(2),n?(r||t.addEventListener(e,Ra,a),(t.l||(t.l={}))[e]=n):t.removeEventListener(e,Ra,a)):"list"!==e&&"tagName"!==e&&"form"!==e&&"type"!==e&&"size"!==e&&!o&&e in t?t[e]=null==n?"":n:"function"!=typeof n&&"dangerouslySetInnerHTML"!==e&&(e!==(e=e.replace(/^xlink:?/,""))?null==n||!1===n?t.removeAttributeNS("http://www.w3.org/1999/xlink",e.toLowerCase()):t.setAttributeNS("http://www.w3.org/1999/xlink",e.toLowerCase(),n):null==n||!1===n&&!/^ar/.test(e)?t.removeAttribute(e):t.setAttribute(e,n))}function Ra(t){this.l[t.type](ia.event?ia.event(t):t)}function Oa(t,e,n,r,o,i,a,s,c){var l,u,d,h,f,p,g,m,w,b,y=e.type;if(void 0!==e.constructor)return null;(l=ia.__b)&&l(e);try{t:if("function"==typeof y){if(m=e.props,w=(l=y.contextType)&&r[l.__c],b=l?w?w.props.value:l.__:r,n.__c?g=(u=e.__c=n.__c).__=u.__E:("prototype"in y&&y.prototype.render?e.__c=u=new y(m,b):(e.__c=u=new xa(m,b),u.constructor=y,u.render=Pa),w&&w.sub(u),u.props=m,u.state||(u.state={}),u.context=b,u.__n=r,d=u.__d=!0,u.__h=[]),null==u.__s&&(u.__s=u.state),null!=y.getDerivedStateFromProps&&(u.__s==u.state&&(u.__s=ma({},u.__s)),ma(u.__s,y.getDerivedStateFromProps(m,u.__s))),h=u.props,f=u.state,d)null==y.getDerivedStateFromProps&&null!=u.componentWillMount&&u.componentWillMount(),null!=u.componentDidMount&&u.__h.push(u.componentDidMount);else{if(null==y.getDerivedStateFromProps&&m!==h&&null!=u.componentWillReceiveProps&&u.componentWillReceiveProps(m,b),!u.__e&&null!=u.shouldComponentUpdate&&!1===u.shouldComponentUpdate(m,u.__s,b)||e.__v===n.__v&&!u.__){for(u.props=m,u.state=u.__s,e.__v!==n.__v&&(u.__d=!1),u.__v=e,e.__e=n.__e,e.__k=n.__k,u.__h.length&&a.push(u),l=0;l<e.__k.length;l++)e.__k[l]&&(e.__k[l].__=e);break t}null!=u.componentWillUpdate&&u.componentWillUpdate(m,u.__s,b),null!=u.componentDidUpdate&&u.__h.push((function(){u.componentDidUpdate(h,f,p)}))}u.context=b,u.props=m,u.state=u.__s,(l=ia.__r)&&l(e),u.__d=!1,u.__v=e,u.__P=t,l=u.render(u.props,u.state,u.context),e.__k=null!=l&&l.type==_a&&null==l.key?l.props.children:Array.isArray(l)?l:[l],null!=u.getChildContext&&(r=ma(ma({},r),u.getChildContext())),d||null==u.getSnapshotBeforeUpdate||(p=u.getSnapshotBeforeUpdate(h,f)),Ea(t,e,n,r,o,i,a,s,c),u.base=e.__e,u.__h.length&&a.push(u),g&&(u.__E=u.__=null),u.__e=!1}else null==i&&e.__v===n.__v?(e.__k=n.__k,e.__e=n.__e):e.__e=function(t,e,n,r,o,i,a,s){var c,l,u,d,h,f=n.props,p=e.props;if(o="svg"===e.type||o,null!=i)for(c=0;c<i.length;c++)if(null!=(l=i[c])&&((null===e.type?3===l.nodeType:l.localName===e.type)||t==l)){t=l,i[c]=null;break}if(null==t){if(null===e.type)return document.createTextNode(p);t=o?document.createElementNS("http://www.w3.org/2000/svg",e.type):document.createElement(e.type,p.is&&{is:p.is}),i=null,s=!1}if(null===e.type)f!==p&&t.data!=p&&(t.data=p);else{if(null!=i&&(i=pa.slice.call(t.childNodes)),u=(f=n.props||fa).dangerouslySetInnerHTML,d=p.dangerouslySetInnerHTML,!s){if(f===fa)for(f={},h=0;h<t.attributes.length;h++)f[t.attributes[h].name]=t.attributes[h].value;(d||u)&&(d&&u&&d.__html==u.__html||(t.innerHTML=d&&d.__html||""))}(function(t,e,n,r,o){var i;for(i in n)"children"===i||"key"===i||i in e||Ta(t,i,null,n[i],r);for(i in e)o&&"function"!=typeof e[i]||"children"===i||"key"===i||"value"===i||"checked"===i||n[i]===e[i]||Ta(t,i,e[i],n[i],r)})(t,p,f,o,s),d?e.__k=[]:(e.__k=e.props.children,Ea(t,e,n,r,"foreignObject"!==e.type&&o,i,a,fa,s)),s||("value"in p&&void 0!==(c=p.value)&&c!==t.value&&Ta(t,"value",c,f.value,!1),"checked"in p&&void 0!==(c=p.checked)&&c!==t.checked&&Ta(t,"checked",c,f.checked,!1))}return t}(n.__e,e,n,r,o,i,a,c);(l=ia.diffed)&&l(e)}catch(t){e.__v=null,ia.__e(t,e,n)}return e.__e}function Na(t,e){ia.__c&&ia.__c(e,t),t.some((function(e){try{t=e.__h,e.__h=[],t.some((function(t){t.call(e)}))}catch(t){ia.__e(t,e.__v)}}))}function Ba(t,e,n){try{"function"==typeof t?t(e):t.current=e}catch(t){ia.__e(t,n)}}function $a(t,e,n){var r,o,i;if(ia.unmount&&ia.unmount(t),(r=t.ref)&&(r.current&&r.current!==t.__e||Ba(r,null,e)),n||"function"==typeof t.type||(n=null!=(o=t.__e)),t.__e=t.__d=void 0,null!=(r=t.__c)){if(r.componentWillUnmount)try{r.componentWillUnmount()}catch(t){ia.__e(t,e)}r.base=r.__P=null}if(r=t.__k)for(i=0;i<r.length;i++)r[i]&&$a(r[i],e,n);null!=o&&wa(o)}function Pa(t,e,n){return this.constructor(t,n)}function Ua(t,e,n){var r,o,i;ia.__&&ia.__(t,e),o=(r=n===ua)?null:n&&n.__k||e.__k,t=ba(_a,null,[t]),i=[],Oa(e,(r?e:n||e).__k=t,o||fa,fa,void 0!==e.ownerSVGElement,n&&!r?[n]:o?null:pa.slice.call(e.childNodes),i,n||fa,r),Na(i,t)}function La(t,e){Ua(t,e,ua)}function ja(t,e){var n,r;for(r in e=ma(ma({},t.props),e),arguments.length>2&&(e.children=pa.slice.call(arguments,2)),n={},e)"key"!==r&&"ref"!==r&&(n[r]=e[r]);return ya(t.type,n,e.key||t.key,e.ref||t.ref,null)}function za(t){var e={},n={__c:"__cC"+da++,__:t,Consumer:function(t,e){return t.children(e)},Provider:function(t){var r,o=this;return this.getChildContext||(r=[],this.getChildContext=function(){return e[n.__c]=o,e},this.shouldComponentUpdate=function(t){o.props.value!==t.value&&r.some((function(e){e.context=t.value,Ca(e)}))},this.sub=function(t){r.push(t);var e=t.componentWillUnmount;t.componentWillUnmount=function(){r.splice(r.indexOf(t),1),e&&e.call(t)}}),t.children}};return n.Consumer.contextType=n,n.Provider.__=n,n}ia={__e:function(t,e){for(var n,r;e=e.__;)if((n=e.__c)&&!n.__)try{if(n.constructor&&null!=n.constructor.getDerivedStateFromError&&(r=!0,n.setState(n.constructor.getDerivedStateFromError(t))),null!=n.componentDidCatch&&(r=!0,n.componentDidCatch(t)),r)return Ca(n.__E=n)}catch(e){t=e}throw t}},xa.prototype.setState=function(t,e){var n;n=this.__s!==this.state?this.__s:this.__s=ma({},this.state),"function"==typeof t&&(t=t(n,this.props)),t&&ma(n,t),null!=t&&this.__v&&(e&&this.__h.push(e),Ca(this))},xa.prototype.forceUpdate=function(t){this.__v&&(this.__e=!0,t&&this.__h.push(t),Ca(this))},xa.prototype.render=_a,aa=[],sa=0,ca="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,ua=fa,da=0;var qa,Da,Fa,Wa=0,Ha=[],Ya=ia.__r,Ka=ia.diffed,Ja=ia.__c,Va=ia.unmount;function Qa(t,e){ia.__h&&ia.__h(Da,t,Wa||e),Wa=0;var n=Da.__H||(Da.__H={__:[],__h:[]});return t>=n.__.length&&n.__.push({}),n.__[t]}function Za(t){return Wa=1,Ga(ds,t)}function Ga(t,e,n){var r=Qa(qa++,2);return r.__c||(r.__c=Da,r.__=[n?n(e):ds(void 0,e),function(e){var n=t(r.__[0],e);r.__[0]!==n&&(r.__[0]=n,r.__c.setState({}))}]),r.__}function Xa(t,e){var n=Qa(qa++,3);!ia.__s&&us(n.__H,e)&&(n.__=t,n.__H=e,Da.__H.__h.push(n))}function ts(t,e){var n=Qa(qa++,4);!ia.__s&&us(n.__H,e)&&(n.__=t,n.__H=e,Da.__h.push(n))}function es(t){return Wa=5,rs((function(){return{current:t}}),[])}function ns(t,e,n){Wa=6,ts((function(){"function"==typeof t?t(e()):t&&(t.current=e())}),null==n?n:n.concat(t))}function rs(t,e){var n=Qa(qa++,7);return us(n.__H,e)?(n.__H=e,n.__h=t,n.__=t()):n.__}function os(t,e){return Wa=8,rs((function(){return t}),e)}function is(t){var e=Da.context[t.__c],n=Qa(qa++,9);return n.__c=t,e?(null==n.__&&(n.__=!0,e.sub(Da)),e.props.value):t.__}function as(t,e){ia.useDebugValue&&ia.useDebugValue(e?e(t):t)}function ss(){Ha.some((function(t){if(t.__P)try{t.__H.__h.forEach(cs),t.__H.__h.forEach(ls),t.__H.__h=[]}catch(e){return t.__H.__h=[],ia.__e(e,t.__v),!0}})),Ha=[]}function cs(t){t.t&&t.t()}function ls(t){var e=t.__();"function"==typeof e&&(t.t=e)}function us(t,e){return!t||e.some((function(e,n){return e!==t[n]}))}function ds(t,e){return"function"==typeof e?e(t):e}function hs(t,e){for(var n in e)t[n]=e[n];return t}function fs(t,e){for(var n in t)if("__source"!==n&&!(n in e))return!0;for(var r in e)if("__source"!==r&&t[r]!==e[r])return!0;return!1}ia.__r=function(t){Ya&&Ya(t),qa=0,(Da=t.__c).__H&&(Da.__H.__h.forEach(cs),Da.__H.__h.forEach(ls),Da.__H.__h=[])},ia.diffed=function(t){Ka&&Ka(t);var e=t.__c;if(e){var n=e.__H;n&&n.__h.length&&(1!==Ha.push(e)&&Fa===ia.requestAnimationFrame||((Fa=ia.requestAnimationFrame)||function(t){var e,n=function(){clearTimeout(r),cancelAnimationFrame(e),setTimeout(t)},r=setTimeout(n,100);"undefined"!=typeof window&&(e=requestAnimationFrame(n))})(ss))}},ia.__c=function(t,e){e.some((function(t){try{t.__h.forEach(cs),t.__h=t.__h.filter((function(t){return!t.__||ls(t)}))}catch(n){e.some((function(t){t.__h&&(t.__h=[])})),e=[],ia.__e(n,t.__v)}})),Ja&&Ja(t,e)},ia.unmount=function(t){Va&&Va(t);var e=t.__c;if(e){var n=e.__H;if(n)try{n.__.forEach((function(t){return t.t&&t.t()}))}catch(t){ia.__e(t,e.__v)}}};var ps=function(t){var e,n;function r(e){var n;return(n=t.call(this,e)||this).isPureReactComponent=!0,n}return n=t,(e=r).prototype=Object.create(n.prototype),e.prototype.constructor=e,e.__proto__=n,r.prototype.shouldComponentUpdate=function(t,e){return fs(this.props,t)||fs(this.state,e)},r}(xa);function gs(t,e){function n(t){var n=this.props.ref,r=n==t.ref;return!r&&n&&(n.call?n(null):n.current=null),e?!e(this.props,t)||!r:fs(this.props,t)}function r(e){return this.shouldComponentUpdate=n,ba(t,hs({},e))}return r.prototype.isReactComponent=!0,r.displayName="Memo("+(t.displayName||t.name)+")",r.t=!0,r}var ms=ia.__b;function ws(t){function e(e){var n=hs({},e);return delete n.ref,t(n,e.ref)}return e.prototype.isReactComponent=e.t=!0,e.displayName="ForwardRef("+(t.displayName||t.name)+")",e}ia.__b=function(t){t.type&&t.type.t&&t.ref&&(t.props.ref=t.ref,t.ref=null),ms&&ms(t)};var bs=function(t,e){return t?Aa(t).reduce((function(t,n,r){return t.concat(e(n,r))}),[]):null},ys={map:bs,forEach:bs,count:function(t){return t?Aa(t).length:0},only:function(t){if(1!==(t=Aa(t)).length)throw new Error("Children.only() expects only one child.");return t[0]},toArray:Aa},vs=ia.__e;function _s(t){return t&&((t=hs({},t)).__c=null,t.__k=t.__k&&t.__k.map(_s)),t}function xs(){this.__u=0,this.o=null,this.__b=null}function ks(t){var e=t.__.__c;return e&&e.u&&e.u(t)}function Ms(t){var e,n,r;function o(o){if(e||(e=t()).then((function(t){n=t.default||t}),(function(t){r=t})),r)throw r;if(!n)throw e;return ba(n,o)}return o.displayName="Lazy",o.t=!0,o}function Cs(){this.i=null,this.l=null}ia.__e=function(t,e,n){if(t.then)for(var r,o=e;o=o.__;)if((r=o.__c)&&r.__c)return r.__c(t,e.__c);vs(t,e,n)},(xs.prototype=new xa).__c=function(t,e){var n=this;null==n.o&&(n.o=[]),n.o.push(e);var r=ks(n.__v),o=!1,i=function(){o||(o=!0,r?r(a):a())};e.__c=e.componentWillUnmount,e.componentWillUnmount=function(){i(),e.__c&&e.__c()};var a=function(){var t;if(!--n.__u)for(n.__v.__k[0]=n.state.u,n.setState({u:n.__b=null});t=n.o.pop();)t.forceUpdate()};n.__u++||n.setState({u:n.__b=n.__v.__k[0]}),t.then(i,i)},xs.prototype.render=function(t,e){return this.__b&&(this.__v.__k[0]=_s(this.__b),this.__b=null),[ba(xa,null,e.u?null:t.children),e.u&&t.fallback]};var Ss=function(t,e,n){if(++n[1]===n[0]&&t.l.delete(e),t.props.revealOrder&&("t"!==t.props.revealOrder[0]||!t.l.size))for(n=t.i;n;){for(;n.length>3;)n.pop()();if(n[1]<n[0])break;t.i=n=n[2]}};(Cs.prototype=new xa).u=function(t){var e=this,n=ks(e.__v),r=e.l.get(t);return r[0]++,function(o){var i=function(){e.props.revealOrder?(r.push(o),Ss(e,t,r)):o()};n?n(i):i()}},Cs.prototype.render=function(t){this.i=null,this.l=new Map;var e=Aa(t.children);t.revealOrder&&"b"===t.revealOrder[0]&&e.reverse();for(var n=e.length;n--;)this.l.set(e[n],this.i=[1,0,this.i]);return t.children},Cs.prototype.componentDidUpdate=Cs.prototype.componentDidMount=function(){var t=this;t.l.forEach((function(e,n){Ss(t,n,e)}))};var Es=function(){function t(){}var e=t.prototype;return e.getChildContext=function(){return this.props.context},e.render=function(t){return t.children},t}();function As(t){var e=this,n=t.container,r=ba(Es,{context:e.context},t.vnode);return e.s&&e.s!==n&&(e.v.parentNode&&e.s.removeChild(e.v),$a(e.h),e.p=!1),t.vnode?e.p?(n.__k=e.__k,Ua(r,n),e.__k=n.__k):(e.v=document.createTextNode(""),La("",n),n.appendChild(e.v),e.p=!0,e.s=n,Ua(r,n,e.v),e.__k=e.v.__k):e.p&&(e.v.parentNode&&e.s.removeChild(e.v),$a(e.h)),e.h=r,e.componentWillUnmount=function(){e.v.parentNode&&e.s.removeChild(e.v),$a(e.h)},null}function Is(t,e){return ba(As,{vnode:t,container:e})}var Ts=/^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/;xa.prototype.isReactComponent={};var Rs="undefined"!=typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103;function Os(t,e,n){if(null==e.__k)for(;e.firstChild;)e.removeChild(e.firstChild);return Ua(t,e),"function"==typeof n&&n(),t?t.__c:null}var Ns=ia.event;function Bs(t,e){t["UNSAFE_"+e]&&!t[e]&&Object.defineProperty(t,e,{configurable:!1,get:function(){return this["UNSAFE_"+e]},set:function(t){this["UNSAFE_"+e]=t}})}ia.event=function(t){Ns&&(t=Ns(t)),t.persist=function(){};var e=!1,n=!1,r=t.stopPropagation;t.stopPropagation=function(){r.call(t),e=!0};var o=t.preventDefault;return t.preventDefault=function(){o.call(t),n=!0},t.isPropagationStopped=function(){return e},t.isDefaultPrevented=function(){return n},t.nativeEvent=t};var $s={configurable:!0,get:function(){return this.class}},Ps=ia.vnode;ia.vnode=function(t){t.$$typeof=Rs;var e=t.type,n=t.props;if(e){if(n.class!=n.className&&($s.enumerable="className"in n,null!=n.className&&(n.class=n.className),Object.defineProperty(n,"className",$s)),"function"!=typeof e){var r,o,i;for(i in n.defaultValue&&void 0!==n.value&&(n.value||0===n.value||(n.value=n.defaultValue),delete n.defaultValue),Array.isArray(n.value)&&n.multiple&&"select"===e&&(Aa(n.children).forEach((function(t){-1!=n.value.indexOf(t.props.value)&&(t.props.selected=!0)})),delete n.value),n)if(r=Ts.test(i))break;if(r)for(i in o=t.props={},n)o[Ts.test(i)?i.replace(/[A-Z0-9]/,"-$&").toLowerCase():i]=n[i]}!function(e){var n=t.type,r=t.props;if(r&&"string"==typeof n){var o={};for(var i in r)/^on(Ani|Tra|Tou)/.test(i)&&(r[i.toLowerCase()]=r[i],delete r[i]),o[i.toLowerCase()]=i;if(o.ondoubleclick&&(r.ondblclick=r[o.ondoubleclick],delete r[o.ondoubleclick]),o.onbeforeinput&&(r.onbeforeinput=r[o.onbeforeinput],delete r[o.onbeforeinput]),o.onchange&&("textarea"===n||"input"===n.toLowerCase()&&!/^fil|che|ra/i.test(r.type))){var a=o.oninput||"oninput";r[a]||(r[a]=r[o.onchange],delete r[o.onchange])}}}(),"function"==typeof e&&!e.m&&e.prototype&&(Bs(e.prototype,"componentWillMount"),Bs(e.prototype,"componentWillReceiveProps"),Bs(e.prototype,"componentWillUpdate"),e.m=!0)}Ps&&Ps(t)};function Us(t){return ba.bind(null,t)}function Ls(t){return!!t&&t.$$typeof===Rs}function js(t){return Ls(t)?ja.apply(null,arguments):t}function zs(t){return!!t.__k&&(Ua(null,t),!0)}function qs(t){return t&&(t.base||1===t.nodeType&&t)||null}var Ds=function(t,e){return t(e)},Fs={useState:Za,useReducer:Ga,useEffect:Xa,useLayoutEffect:ts,useRef:es,useImperativeHandle:ns,useMemo:rs,useCallback:os,useContext:is,useDebugValue:as,version:"16.8.0",Children:ys,render:Os,hydrate:Os,unmountComponentAtNode:zs,createPortal:Is,createElement:ba,createContext:za,createFactory:Us,cloneElement:js,createRef:va,Fragment:_a,isValidElement:Ls,findDOMNode:qs,Component:xa,PureComponent:ps,memo:gs,forwardRef:ws,unstable_batchedUpdates:Ds,Suspense:xs,SuspenseList:Cs,lazy:Ms},Ws=Object.freeze({__proto__:null,default:Fs,version:"16.8.0",Children:ys,render:Os,hydrate:function(t,e,n){return La(t,e),"function"==typeof n&&n(),t?t.__c:null},unmountComponentAtNode:zs,createPortal:Is,createFactory:Us,cloneElement:js,isValidElement:Ls,findDOMNode:qs,PureComponent:ps,memo:gs,forwardRef:ws,unstable_batchedUpdates:Ds,Suspense:xs,SuspenseList:Cs,lazy:Ms,createElement:ba,createContext:za,createRef:va,Fragment:_a,Component:xa,useState:Za,useReducer:Ga,useEffect:Xa,useLayoutEffect:ts,useRef:es,useImperativeHandle:ns,useMemo:rs,useCallback:os,useContext:is,useDebugValue:as,useErrorBoundary:function(t){var e=Qa(qa++,10),n=Za();return e.__=t,Da.componentDidCatch||(Da.componentDidCatch=function(t){e.__&&e.__(t),n[1](t)}),[n[0],function(){n[1](void 0)}]}}),Hs=ee(Ws);function Ys(t){return t&&"object"==typeof t&&"default"in t?t.default:t}var Ks=Gr,Js=Ys(Xr),Vs=Ys(ha),Qs=Hs;var Zs=':root {\n  --animation-duration: 300ms;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.animated {\n  animation-duration: var(--animation-duration);\n  animation-fill-mode: both;\n}\n\n.fadeIn {\n  animation-name: fadeIn;\n}\n\n.fadeOut {\n  animation-name: fadeOut;\n}\n\n#walletconnect-wrapper {\n  -webkit-user-select: none;\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  user-select: none;\n  width: 100%;\n  z-index: 99999999999999;\n}\n\n.walletconnect-modal__headerLogo {\n  height: 21px;\n}\n\n.walletconnect-modal__header p {\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n  align-items: flex-start;\n  display: flex;\n  flex: 1;\n  margin-left: 5px;\n}\n\n.walletconnect-modal__close__wrapper {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  z-index: 10000;\n  background: white;\n  border-radius: 26px;\n  padding: 6px;\n  box-sizing: border-box;\n  width: 26px;\n  height: 26px;\n  cursor: pointer;\n}\n\n.walletconnect-modal__close__icon {\n  position: relative;\n  top: 7px;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: rotate(45deg);\n}\n\n.walletconnect-modal__close__line1 {\n  position: absolute;\n  width: 100%;\n  border: 1px solid rgb(48, 52, 59);\n}\n\n.walletconnect-modal__close__line2 {\n  position: absolute;\n  width: 100%;\n  border: 1px solid rgb(48, 52, 59);\n  transform: rotate(90deg);\n}\n\n.walletconnect-qrcode__base {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  background: rgba(37, 41, 46, 0.95);\n  height: 100%;\n  left: 0;\n  pointer-events: auto;\n  position: fixed;\n  top: 0;\n  transition: 0.4s cubic-bezier(0.19, 1, 0.22, 1);\n  width: 100%;\n  will-change: opacity;\n  padding: 40px;\n  box-sizing: border-box;\n}\n\n.walletconnect-qrcode__text {\n  color: rgba(60, 66, 82, 0.6);\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 1.1875em;\n  margin: 10px 0 20px 0;\n  text-align: center;\n  width: 100%;\n}\n\n@media only screen and (max-width: 768px) {\n  .walletconnect-qrcode__text {\n    font-size: 4vw;\n  }\n}\n\n@media only screen and (max-width: 320px) {\n  .walletconnect-qrcode__text {\n    font-size: 14px;\n  }\n}\n\n.walletconnect-qrcode__image {\n  width: calc(100% - 30px);\n  box-sizing: border-box;\n  cursor: none;\n  margin: 0 auto;\n}\n\n.walletconnect-qrcode__notification {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  font-size: 16px;\n  padding: 16px 20px;\n  border-radius: 16px;\n  text-align: center;\n  transition: all 0.1s ease-in-out;\n  background: white;\n  color: black;\n  margin-bottom: -60px;\n  opacity: 0;\n}\n\n.walletconnect-qrcode__notification.notification__show {\n  opacity: 1;\n}\n\n@media only screen and (max-width: 768px) {\n  .walletconnect-modal__header {\n    height: 130px;\n  }\n  .walletconnect-modal__base {\n    overflow: auto;\n  }\n}\n\n@media only screen and (min-device-width: 415px) and (max-width: 768px) {\n  #content {\n    max-width: 768px;\n    box-sizing: border-box;\n  }\n}\n\n@media only screen and (min-width: 375px) and (max-width: 415px) {\n  #content {\n    max-width: 414px;\n    box-sizing: border-box;\n  }\n}\n\n@media only screen and (min-width: 320px) and (max-width: 375px) {\n  #content {\n    max-width: 375px;\n    box-sizing: border-box;\n  }\n}\n\n@media only screen and (max-width: 320px) {\n  #content {\n    max-width: 320px;\n    box-sizing: border-box;\n  }\n}\n\n.walletconnect-modal__base {\n  -webkit-font-smoothing: antialiased;\n  background: #ffffff;\n  border-radius: 24px;\n  box-shadow: 0 10px 50px 5px rgba(0, 0, 0, 0.4);\n  font-family: ui-rounded, "SF Pro Rounded", "SF Pro Text", medium-content-sans-serif-font,\n    -apple-system, BlinkMacSystemFont, ui-sans-serif, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell,\n    "Open Sans", "Helvetica Neue", sans-serif;\n  margin-top: 41px;\n  padding: 24px 24px 22px;\n  pointer-events: auto;\n  position: relative;\n  text-align: center;\n  transition: 0.4s cubic-bezier(0.19, 1, 0.22, 1);\n  will-change: transform;\n  overflow: visible;\n  transform: translateY(-50%);\n  top: 50%;\n  max-width: 500px;\n  margin: auto;\n}\n\n@media only screen and (max-width: 320px) {\n  .walletconnect-modal__base {\n    padding: 24px 12px;\n  }\n}\n\n.walletconnect-modal__base .hidden {\n  transform: translateY(150%);\n  transition: 0.125s cubic-bezier(0.4, 0, 1, 1);\n}\n\n.walletconnect-modal__header {\n  align-items: center;\n  display: flex;\n  height: 26px;\n  left: 0;\n  justify-content: space-between;\n  position: absolute;\n  top: -42px;\n  width: 100%;\n}\n\n.walletconnect-modal__base .wc-logo {\n  align-items: center;\n  display: flex;\n  height: 26px;\n  margin-top: 15px;\n  padding-bottom: 15px;\n  pointer-events: auto;\n}\n\n.walletconnect-modal__base .wc-logo div {\n  background-color: #3399ff;\n  height: 21px;\n  margin-right: 5px;\n  mask-image: url("images/wc-logo.svg") center no-repeat;\n  width: 32px;\n}\n\n.walletconnect-modal__base .wc-logo p {\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.walletconnect-modal__base h2 {\n  color: rgba(60, 66, 82, 0.6);\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 1.1875em;\n  margin: 0 0 19px 0;\n  text-align: center;\n  width: 100%;\n}\n\n.walletconnect-modal__base__row {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  align-items: center;\n  border-radius: 20px;\n  cursor: pointer;\n  display: flex;\n  height: 56px;\n  justify-content: space-between;\n  padding: 0 15px;\n  position: relative;\n  margin: 0px 0px 8px;\n  text-align: left;\n  transition: 0.15s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  will-change: transform;\n  text-decoration: none;\n}\n\n.walletconnect-modal__base__row:hover {\n  background: rgba(60, 66, 82, 0.06);\n}\n\n.walletconnect-modal__base__row:active {\n  background: rgba(60, 66, 82, 0.06);\n  transform: scale(0.975);\n  transition: 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.walletconnect-modal__base__row__h3 {\n  color: #25292e;\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0;\n  padding-bottom: 3px;\n}\n\n.walletconnect-modal__base__row__right {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.walletconnect-modal__base__row__right__app-icon {\n  border-radius: 8px;\n  height: 34px;\n  margin: 0 11px 2px 0;\n  width: 34px;\n  background-size: 100%;\n  box-shadow: 0 4px 12px 0 rgba(37, 41, 46, 0.25);\n}\n\n.walletconnect-modal__base__row__right__caret {\n  height: 18px;\n  opacity: 0.3;\n  transition: 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  width: 8px;\n  will-change: opacity;\n}\n\n.walletconnect-modal__base__row:hover .caret,\n.walletconnect-modal__base__row:active .caret {\n  opacity: 0.6;\n}\n\n.walletconnect-modal__mobile__toggle {\n  width: 80%;\n  display: flex;\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n  border-radius: 8px;\n  margin-bottom: 18px;\n  background: #d4d5d9;\n}\n\n.walletconnect-modal__single_wallet {\n  display: flex;\n  justify-content: center;\n  margin-top: 7px;\n  margin-bottom: 18px;\n}\n\n.walletconnect-modal__single_wallet a {\n  cursor: pointer;\n  color: rgb(64, 153, 255);\n  font-size: 21px;\n  font-weight: 800;\n  text-decoration: none !important;\n  margin: 0 auto;\n}\n\n.walletconnect-modal__mobile__toggle_selector {\n  width: calc(50% - 8px);\n  background: white;\n  position: absolute;\n  border-radius: 5px;\n  height: calc(100% - 8px);\n  top: 4px;\n  transition: all 0.2s ease-in-out;\n  transform: translate3d(4px, 0, 0);\n}\n\n.walletconnect-modal__mobile__toggle.right__selected .walletconnect-modal__mobile__toggle_selector {\n  transform: translate3d(calc(100% + 12px), 0, 0);\n}\n\n.walletconnect-modal__mobile__toggle a {\n  font-size: 12px;\n  width: 50%;\n  text-align: center;\n  padding: 8px;\n  margin: 0;\n  font-weight: 600;\n  z-index: 1;\n}\n\n.walletconnect-modal__footer {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n@media only screen and (max-width: 768px) {\n  .walletconnect-modal__footer {\n    margin-top: 5vw;\n  }\n}\n\n.walletconnect-modal__footer a {\n  cursor: pointer;\n  color: #898d97;\n  font-size: 15px;\n  margin: 0 auto;\n}\n\n@media only screen and (max-width: 320px) {\n  .walletconnect-modal__footer a {\n    font-size: 14px;\n  }\n}\n\n.walletconnect-connect__buttons__wrapper {\n  max-height: 44vh;\n}\n\n.walletconnect-connect__buttons__wrapper__android {\n  margin: 50% 0;\n}\n\n.walletconnect-connect__buttons__wrapper__wrap {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  margin: 10px 0;\n}\n\n@media only screen and (min-width: 768px) {\n  .walletconnect-connect__buttons__wrapper__wrap {\n    margin-top: 40px;\n  }\n}\n\n.walletconnect-connect__button {\n  background-color: rgb(64, 153, 255);\n  padding: 12px;\n  border-radius: 8px;\n  text-decoration: none;\n  color: rgb(255, 255, 255);\n  font-weight: 500;\n}\n\n.walletconnect-connect__button__icon_anchor {\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin: 8px;\n  width: 42px;\n  justify-self: center;\n  flex-direction: column;\n  text-decoration: none !important;\n}\n\n@media only screen and (max-width: 320px) {\n  .walletconnect-connect__button__icon_anchor {\n    margin: 4px;\n  }\n}\n\n.walletconnect-connect__button__icon {\n  border-radius: 10px;\n  height: 42px;\n  margin: 0;\n  width: 42px;\n  background-size: cover !important;\n  box-shadow: 0 4px 12px 0 rgba(37, 41, 46, 0.25);\n}\n\n.walletconnect-connect__button__text {\n  color: #424952;\n  font-size: 2.7vw;\n  text-decoration: none !important;\n  padding: 0;\n  margin-top: 1.8vw;\n  font-weight: 600;\n}\n\n@media only screen and (min-width: 768px) {\n  .walletconnect-connect__button__text {\n    font-size: 16px;\n    margin-top: 12px;\n  }\n}\n\n.walletconnect-search__input {\n  border: none;\n  background: #d4d5d9;\n  border-style: none;\n  padding: 8px 16px;\n  outline: none;\n  font-style: normal;\n  font-stretch: normal;\n  font-size: 16px;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  border-radius: 8px;\n  width: calc(100% - 16px);\n  margin: 0;\n  margin-bottom: 8px;\n}\n';"undefined"==typeof Symbol||(Symbol.iterator||(Symbol.iterator=Symbol("Symbol.iterator"))),"undefined"==typeof Symbol||(Symbol.asyncIterator||(Symbol.asyncIterator=Symbol("Symbol.asyncIterator")));var Gs="data:image/svg+xml,%3Csvg height='185' viewBox='0 0 300 185' width='300' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m61.4385429 36.2562612c48.9112241-47.8881663 128.2119871-47.8881663 177.1232091 0l5.886545 5.7634174c2.445561 2.3944081 2.445561 6.2765112 0 8.6709204l-20.136695 19.715503c-1.222781 1.1972051-3.2053 1.1972051-4.428081 0l-8.100584-7.9311479c-34.121692-33.4079817-89.443886-33.4079817-123.5655788 0l-8.6750562 8.4936051c-1.2227816 1.1972041-3.205301 1.1972041-4.4280806 0l-20.1366949-19.7155031c-2.4455612-2.3944092-2.4455612-6.2765122 0-8.6709204zm218.7677961 40.7737449 17.921697 17.546897c2.445549 2.3943969 2.445563 6.2764769.000031 8.6708899l-80.810171 79.121134c-2.445544 2.394426-6.410582 2.394453-8.85616.000062-.00001-.00001-.000022-.000022-.000032-.000032l-57.354143-56.154572c-.61139-.598602-1.60265-.598602-2.21404 0-.000004.000004-.000007.000008-.000011.000011l-57.3529212 56.154531c-2.4455368 2.394432-6.4105755 2.394472-8.8561612.000087-.0000143-.000014-.0000296-.000028-.0000449-.000044l-80.81241943-79.122185c-2.44556021-2.394408-2.44556021-6.2765115 0-8.6709197l17.92172963-17.5468673c2.4455602-2.3944082 6.4105989-2.3944082 8.8561602 0l57.3549775 56.155357c.6113908.598602 1.602649.598602 2.2140398 0 .0000092-.000009.0000174-.000017.0000265-.000024l57.3521031-56.155333c2.445505-2.3944633 6.410544-2.3945531 8.856161-.0002.000034.0000336.000068.0000673.000101.000101l57.354902 56.155432c.61139.598601 1.60265.598601 2.21404 0l57.353975-56.1543249c2.445561-2.3944092 6.410599-2.3944092 8.85616 0z' fill='%233b99fc'/%3E%3C/svg%3E",Xs="WalletConnect",tc=300,ec="rgb(64, 153, 255)",nc="walletconnect-wrapper",rc="walletconnect-style-sheet",oc="walletconnect-qrcode-modal",ic="walletconnect-qrcode-close",ac="walletconnect-qrcode-text",sc="walletconnect-connect-button";function cc(t){return Qs.createElement("div",{className:"walletconnect-modal__header"},Qs.createElement("img",{src:Gs,className:"walletconnect-modal__headerLogo"}),Qs.createElement("p",null,Xs),Qs.createElement("div",{className:"walletconnect-modal__close__wrapper",onClick:t.onClose},Qs.createElement("div",{id:ic,className:"walletconnect-modal__close__icon"},Qs.createElement("div",{className:"walletconnect-modal__close__line1"}),Qs.createElement("div",{className:"walletconnect-modal__close__line2"}))))}function lc(t){return Qs.createElement("a",{className:"walletconnect-connect__button",href:t.href,id:sc+"-"+t.name,onClick:t.onClick,rel:"noopener noreferrer",style:{backgroundColor:t.color},target:"_blank"},t.name)}var uc="data:image/svg+xml,%3Csvg fill='none' height='18' viewBox='0 0 8 18' width='8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath clip-rule='evenodd' d='m.586301.213898c-.435947.33907-.5144813.967342-.175411 1.403292l4.87831 6.27212c.28087.36111.28087.86677 0 1.22788l-4.878311 6.27211c-.33907.436-.260536 1.0642.175412 1.4033.435949.3391 1.064219.2605 1.403289-.1754l4.87832-6.2721c.84259-1.08336.84259-2.60034 0-3.68367l-4.87832-6.27212c-.33907-.4359474-.96734-.514482-1.403289-.175412z' fill='%233c4252' fill-rule='evenodd'/%3E%3C/svg%3E";function dc(t){var e=t.color,n=t.href,r=t.name,o=t.logo,i=t.onClick;return Qs.createElement("a",{className:"walletconnect-modal__base__row",href:n,onClick:i,rel:"noopener noreferrer",target:"_blank"},Qs.createElement("h3",{className:"walletconnect-modal__base__row__h3"},r),Qs.createElement("div",{className:"walletconnect-modal__base__row__right"},Qs.createElement("div",{className:"walletconnect-modal__base__row__right__app-icon",style:{background:"url('"+o+"') "+e,backgroundSize:"100%"}}),Qs.createElement("img",{src:uc,className:"walletconnect-modal__base__row__right__caret"})))}function hc(t){var e=t.color,n=t.href,r=t.name,o=t.logo,i=t.onClick,a=window.innerWidth<768?(r.length>8?2.5:2.7)+"vw":"inherit";return Qs.createElement("a",{className:"walletconnect-connect__button__icon_anchor",href:n,onClick:i,rel:"noopener noreferrer",target:"_blank"},Qs.createElement("div",{className:"walletconnect-connect__button__icon",style:{background:"url('"+o+"') "+e,backgroundSize:"100%"}}),Qs.createElement("div",{style:{fontSize:a},className:"walletconnect-connect__button__text"},r))}var fc=5,pc=12;function gc(t){var e=Ks.isAndroid(),n=Qs.useState(""),r=n[0],o=n[1],i=Qs.useState(""),a=i[0],s=i[1],c=Qs.useState(1),l=c[0],u=c[1],d=a?t.links.filter((function(t){return t.name.toLowerCase().includes(a.toLowerCase())})):t.links,h=t.errorMessage,f=a||d.length>fc,p=Math.ceil(d.length/pc),g=[(l-1)*pc+1,l*pc],m=d.length?d.filter((function(t,e){return e+1>=g[0]&&e+1<=g[1]})):[],w=!(e||!(p>1)),b=void 0;return Qs.createElement("div",null,Qs.createElement("p",{id:ac,className:"walletconnect-qrcode__text"},e?t.text.connect_mobile_wallet:t.text.choose_preferred_wallet),!e&&Qs.createElement("input",{className:"walletconnect-search__input",placeholder:"Search",value:r,onChange:function(t){o(t.target.value),clearTimeout(b),t.target.value?b=setTimeout((function(){s(t.target.value),u(1)}),1e3):(o(""),s(""),u(1))}}),Qs.createElement("div",{className:"walletconnect-connect__buttons__wrapper"+(e?"__android":f&&d.length?"__wrap":"")},e?Qs.createElement(lc,{name:t.text.connect,color:ec,href:t.uri,onClick:Qs.useCallback((function(){Ks.saveMobileLinkInfo({name:"Unknown",href:t.uri})}),[])}):m.length?m.map((function(e){var n=e.color,r=e.name,o=e.shortName,i=e.logo,a=Ks.formatIOSMobile(t.uri,e),s=Qs.useCallback((function(){Ks.saveMobileLinkInfo({name:r,href:a})}),[m]);return f?Qs.createElement(hc,{color:n,href:a,name:o||r,logo:i,onClick:s}):Qs.createElement(dc,{color:n,href:a,name:r,logo:i,onClick:s})})):Qs.createElement(Qs.Fragment,null,Qs.createElement("p",null,h.length?t.errorMessage:t.links.length&&!d.length?t.text.no_wallets_found:t.text.loading))),w&&Qs.createElement("div",{className:"walletconnect-modal__footer"},Array(p).fill(0).map((function(t,e){var n=e+1,r=l===n;return Qs.createElement("a",{style:{margin:"auto 10px",fontWeight:r?"bold":"normal"},onClick:function(){return u(n)}},n)}))))}function mc(t){var e=!!t.message.trim();return Qs.createElement("div",{className:"walletconnect-qrcode__notification"+(e?" notification__show":"")},t.message)}var wc=function(t){try{var e="";return Promise.resolve(Js.toString(t,{margin:0,type:"svg"})).then((function(t){return"string"==typeof t&&(e=t.replace("<svg",'<svg class="walletconnect-qrcode__image"')),e}))}catch(t){return Promise.reject(t)}};function bc(t){var e=Qs.useState(""),n=e[0],r=e[1],o=Qs.useState(""),i=o[0],a=o[1];Qs.useEffect((function(){try{return Promise.resolve(wc(t.uri)).then((function(t){a(t)}))}catch(t){Promise.reject(t)}}),[]);return Qs.createElement("div",null,Qs.createElement("p",{id:ac,className:"walletconnect-qrcode__text"},t.text.scan_qrcode_with_wallet),Qs.createElement("div",{dangerouslySetInnerHTML:{__html:i}}),Qs.createElement("div",{className:"walletconnect-modal__footer"},Qs.createElement("a",{onClick:function(){Vs(t.uri)?(r(t.text.copied_to_clipboard),setInterval((function(){return r("")}),1200)):(r("Error"),setInterval((function(){return r("")}),1200))}},t.text.copy_to_clipboard)),Qs.createElement(mc,{message:n}))}function yc(t){var e=Ks.isAndroid(),n=Ks.isMobile(),r=n?t.qrcodeModalOptions&&t.qrcodeModalOptions.mobileLinks?t.qrcodeModalOptions.mobileLinks:void 0:t.qrcodeModalOptions&&t.qrcodeModalOptions.desktopLinks?t.qrcodeModalOptions.desktopLinks:void 0,o=Qs.useState(!1),i=o[0],a=o[1],s=Qs.useState(!1),c=s[0],l=s[1],u=Qs.useState(!n),d=u[0],h=u[1],f={mobile:n,text:t.text,uri:t.uri,qrcodeModalOptions:t.qrcodeModalOptions},p=Qs.useState(""),g=p[0],m=p[1],w=Qs.useState(!1),b=w[0],y=w[1],v=Qs.useState([]),_=v[0],x=v[1],k=Qs.useState(""),M=k[0],C=k[1],S=function(){c||i||r&&!r.length||_.length>0||Qs.useEffect((function(){!function(){try{if(e)return Promise.resolve();a(!0);var o=function(t,e){try{var n=t()}catch(t){return e(t)}return n&&n.then?n.then(void 0,e):n}((function(){var e=t.qrcodeModalOptions&&t.qrcodeModalOptions.registryUrl?t.qrcodeModalOptions.registryUrl:Ks.getWalletRegistryUrl();return Promise.resolve(fetch(e)).then((function(e){return Promise.resolve(e.json()).then((function(e){var o=e.listings,i=n?"mobile":"desktop",s=Ks.getMobileLinkRegistry(Ks.formatMobileRegistry(o,i),r);a(!1),l(!0),C(s.length?"":t.text.no_supported_wallets),x(s);var c=1===s.length;c&&(m(Ks.formatIOSMobile(t.uri,s[0])),h(!0)),y(c)}))}))}),(function(e){a(!1),l(!0),C(t.text.something_went_wrong),console.error(e)}));return Promise.resolve(o&&o.then?o.then((function(){})):void 0)}catch(t){return Promise.reject(t)}}()}))};S();var E=n?d:!d;return Qs.createElement("div",{id:oc,className:"walletconnect-qrcode__base animated fadeIn"},Qs.createElement("div",{className:"walletconnect-modal__base"},Qs.createElement(cc,{onClose:t.onClose}),b&&d?Qs.createElement("div",{className:"walletconnect-modal__single_wallet"},Qs.createElement("a",{onClick:function(){return Ks.saveMobileLinkInfo({name:_[0].name,href:g})},href:g,rel:"noopener noreferrer",target:"_blank"},t.text.connect_with+" "+(b?_[0].name:"")+" ›")):e||i||!i&&_.length?Qs.createElement("div",{className:"walletconnect-modal__mobile__toggle"+(E?" right__selected":"")},Qs.createElement("div",{className:"walletconnect-modal__mobile__toggle_selector"}),n?Qs.createElement(Qs.Fragment,null,Qs.createElement("a",{onClick:function(){return h(!1),S()}},t.text.mobile),Qs.createElement("a",{onClick:function(){return h(!0)}},t.text.qrcode)):Qs.createElement(Qs.Fragment,null,Qs.createElement("a",{onClick:function(){return h(!0)}},t.text.qrcode),Qs.createElement("a",{onClick:function(){return h(!1),S()}},t.text.desktop))):null,Qs.createElement("div",null,d||!e&&!i&&!_.length?Qs.createElement(bc,Object.assign({},f)):Qs.createElement(gc,Object.assign({},f,{links:_,errorMessage:M})))))}var vc={de:{choose_preferred_wallet:"Wähle bevorzugte Wallet",connect_mobile_wallet:"Verbinde mit Mobile Wallet",scan_qrcode_with_wallet:"Scanne den QR-code mit einer WalletConnect kompatiblen Wallet",connect:"Verbinden",qrcode:"QR-Code",mobile:"Mobile",desktop:"Desktop",copy_to_clipboard:"In die Zwischenablage kopieren",copied_to_clipboard:"In die Zwischenablage kopiert!",connect_with:"Verbinden mit Hilfe von",loading:"Laden...",something_went_wrong:"Etwas ist schief gelaufen",no_supported_wallets:"Es gibt noch keine unterstützten Wallet",no_wallets_found:"keine Wallet gefunden"},en:{choose_preferred_wallet:"Choose your preferred wallet",connect_mobile_wallet:"Connect to Mobile Wallet",scan_qrcode_with_wallet:"Scan QR code with a WalletConnect-compatible wallet",connect:"Connect",qrcode:"QR Code",mobile:"Mobile",desktop:"Desktop",copy_to_clipboard:"Copy to clipboard",copied_to_clipboard:"Copied to clipboard!",connect_with:"Connect with",loading:"Loading...",something_went_wrong:"Something went wrong",no_supported_wallets:"There are no supported wallets yet",no_wallets_found:"No wallets found"},es:{choose_preferred_wallet:"Elige tu billetera preferida",connect_mobile_wallet:"Conectar a billetera móvil",scan_qrcode_with_wallet:"Escanea el código QR con una billetera compatible con WalletConnect",connect:"Conectar",qrcode:"Código QR",mobile:"Móvil",desktop:"Desktop",copy_to_clipboard:"Copiar",copied_to_clipboard:"Copiado!",connect_with:"Conectar mediante",loading:"Cargando...",something_went_wrong:"Algo salió mal",no_supported_wallets:"Todavía no hay billeteras compatibles",no_wallets_found:"No se encontraron billeteras"},fr:{choose_preferred_wallet:"Choisissez votre portefeuille préféré",connect_mobile_wallet:"Se connecter au portefeuille mobile",scan_qrcode_with_wallet:"Scannez le QR code avec un portefeuille compatible WalletConnect",connect:"Se connecter",qrcode:"QR Code",mobile:"Mobile",desktop:"Desktop",copy_to_clipboard:"Copier",copied_to_clipboard:"Copié!",connect_with:"Connectez-vous à l'aide de",loading:"Chargement...",something_went_wrong:"Quelque chose a mal tourné",no_supported_wallets:"Il n'y a pas encore de portefeuilles pris en charge",no_wallets_found:"Aucun portefeuille trouvé"},ko:{choose_preferred_wallet:"원하는 지갑을 선택하세요",connect_mobile_wallet:"모바일 지갑과 연결",scan_qrcode_with_wallet:"WalletConnect 지원 지갑에서 QR코드를 스캔하세요",connect:"연결",qrcode:"QR 코드",mobile:"모바일",desktop:"데스크탑",copy_to_clipboard:"클립보드에 복사",copied_to_clipboard:"클립보드에 복사되었습니다!",connect_with:"와 연결하다",loading:"로드 중...",something_went_wrong:"문제가 발생했습니다.",no_supported_wallets:"아직 지원되는 지갑이 없습니다",no_wallets_found:"지갑을 찾을 수 없습니다"},pt:{choose_preferred_wallet:"Escolha sua carteira preferida",connect_mobile_wallet:"Conectar-se à carteira móvel",scan_qrcode_with_wallet:"Ler o código QR com uma carteira compatível com WalletConnect",connect:"Conectar",qrcode:"Código QR",mobile:"Móvel",desktop:"Desktop",copy_to_clipboard:"Copiar",copied_to_clipboard:"Copiado!",connect_with:"Ligar por meio de",loading:"Carregamento...",something_went_wrong:"Algo correu mal",no_supported_wallets:"Ainda não há carteiras suportadas",no_wallets_found:"Nenhuma carteira encontrada"},zh:{choose_preferred_wallet:"选择你的钱包",connect_mobile_wallet:"连接至移动端钱包",scan_qrcode_with_wallet:"使用兼容 WalletConnect 的钱包扫描二维码",connect:"连接",qrcode:"二维码",mobile:"移动",desktop:"桌面",copy_to_clipboard:"复制到剪贴板",copied_to_clipboard:"复制到剪贴板成功！",connect_with:"通过以下方式连接",loading:"正在加载...",something_went_wrong:"出了问题",no_supported_wallets:"目前还没有支持的钱包",no_wallets_found:"没有找到钱包"},fa:{choose_preferred_wallet:"کیف پول مورد نظر خود را انتخاب کنید",connect_mobile_wallet:"به کیف پول موبایل وصل شوید",scan_qrcode_with_wallet:"کد QR را با یک کیف پول سازگار با WalletConnect اسکن کنید",connect:"اتصال",qrcode:"کد QR",mobile:"سیار",desktop:"دسکتاپ",copy_to_clipboard:"کپی به کلیپ بورد",copied_to_clipboard:"در کلیپ بورد کپی شد!",connect_with:"ارتباط با",loading:"...بارگذاری",something_went_wrong:"مشکلی پیش آمد",no_supported_wallets:"هنوز هیچ کیف پول پشتیبانی شده ای وجود ندارد",no_wallets_found:"هیچ کیف پولی پیدا نشد"}};function _c(){var t=Ks.getDocumentOrThrow(),e=t.getElementById(oc);e&&(e.className=e.className.replace("fadeIn","fadeOut"),setTimeout((function(){var e=t.getElementById(nc);e&&t.body.removeChild(e)}),tc))}function xc(t){return function(){_c(),t&&t()}}function kc(t,e,n){!function(){var t=Ks.getDocumentOrThrow(),e=t.getElementById(rc);e&&t.head.removeChild(e);var n=t.createElement("style");n.setAttribute("id",rc),n.innerText=Zs,t.head.appendChild(n)}();var r,o=function(){var t=Ks.getDocumentOrThrow(),e=t.createElement("div");return e.setAttribute("id",nc),t.body.appendChild(e),e}();Qs.render(Qs.createElement(yc,{text:(r=Ks.getNavigatorOrThrow().language.split("-")[0]||"en",vc[r]||vc.en),uri:t,onClose:xc(e),qrcodeModalOptions:n}),o)}var Mc=function(){return"undefined"!=typeof process&&void 0!==process.versions&&void 0!==process.versions.node};var Cc={open:function(t,e,n){console.log(t),Mc()?function(t){Js.toString(t,{type:"terminal"}).then(console.log)}(t):kc(t,e,n)},close:function(){Mc()||_c()}};let Sc=[],Ec=!0,Ac=!1;const{set:Ic,subscribe:Tc}=zt({isAvailable:Ec,isConnected:Ac,accounts:Sc});let Rc=null;const Oc={subscribe:Tc,async connect(){Rc=new Zr({bridge:"https://bridge.walletconnect.org",qrcodeModal:Cc}),Rc.connected?(Sc=Rc.accounts.map((t=>t.toLowerCase())),Ic({isAvailable:Ec,isConnected:Ac,accounts:Sc})):Rc.createSession(),Rc.on("connect",((t,e)=>{t?console.error("Error(connect):",t):null!=e.params[0].accounts&&(Ac=!0,Sc=e.params[0].accounts.map((t=>t.toLowerCase())),Ic({isAvailable:Ec,isConnected:Ac,accounts:Sc}))})),Rc.on("session_update",((t,e)=>{t?console.error("Error(session_update):",t):(Sc=e.params[0].accounts.map((t=>t.toLowerCase())),Ic({isAvailable:Ec,isConnected:Ac,accounts:Sc}))})),Rc.on("disconnect",((t,e)=>{t&&console.error("Error(disconnect):",t),Oc.disconnect(),Ic({isAvailable:Ec,isConnected:!1,accounts:[]})}))},async disconnect(){Rc&&(null!=Rc.connected&&Rc.killSession(),Rc=null,Ac=!1,Sc=[],Ic({isAvailable:Ec,isConnected:Ac,accounts:Sc}))},signPersonalMessage:async(t,e)=>Rc.signPersonalMessage([e,t])},Nc=[Xt,Oc],{subscribe:Bc}=function(t,n,r){const o=!Array.isArray(t),i=o?[t]:t,c=n.length<2;return l=t=>{let r=!1;const l=[];let u=0,h=e;const f=()=>{if(u)return;h();const r=n(o?l[0]:l,t);c?t(r):h=s(r)?r:e},p=i.map(((t,e)=>d(t,(t=>{l[e]=t,u&=~(1<<e),r&&f()}),(()=>{u|=1<<e}))));return r=!0,f(),function(){a(p),h()}},{subscribe:zt(r,l).subscribe};var l}(Nc,(t=>({isConnected:t.some((t=>t.isConnected)),accounts:t.flatMap((t=>t.accounts))}))),$c=Ft("percs_wallets",{});var Pc={subscribe:Bc,async signPersonalMessage(t,e){if(Lt.derivedKeys?.enabled){const n=h($c);if(n[t]&&n[t].expiry){new Date(n[t].expiry)<=new Date&&(delete n[t],$c.set({...n}))}if(!n[t]){const e=await window.crypto.subtle.generateKey({name:"ECDSA",namedCurve:"P-521"},!0,["sign"]),r=await window.crypto.subtle.exportKey("jwk",e.privateKey);delete r.ext,delete r.key_ops;const o=await window.crypto.subtle.exportKey("jwk",e.publicKey);delete o.ext,delete o.key_ops;for(const e of Nc){if(h(e).accounts.includes(t)){const i=[`Login to ${Lt.shopName}`,`Valid: ${(new Date).toString().replace(/ \(.*\)/,"")}`,`Key: ${JSON.stringify(o)}`];let a;if(Lt.derivedKeys.timeout){const t=new Date;t.setSeconds(t.getSeconds()+Lt.derivedKeys.timeout),a=t.toString().replace(/ \(.*\)/,""),i.splice(2,0,`Expires: ${a}`)}const s=i.join("\n"),c=await e.signPersonalMessage(t,s),l=await Rt({type:"EVM",message:s,signature:c});n[t]={index:l.index,expiry:a,privateKey:r,publicKey:o,message:s,signature:c},$c.set({...n});break}}}if(n[t]){const{privateKey:r,index:o}=n[t],i=await window.crypto.subtle.importKey("jwk",r,{name:"ECDSA",namedCurve:"P-521"},!1,["sign"]),a=new Uint8Array(e.slice(2).match(/../g).map((t=>parseInt(t,16)))).buffer,s=await window.crypto.subtle.sign({name:"ECDSA",hash:"SHA-512"},i,a),c=Array.prototype.map.call(new Uint8Array(s),(t=>("00"+t.toString(16)).slice(-2))).join("");return{signature:`0x${c}`,keyIndex:o}}}for(const n of Nc){if(h(n).accounts.includes(t)){return{signature:await n.signPersonalMessage(t,e)}}}throw new Error("Account not connected")}};function Uc(t){return t<=.03928?t/12.92:((t+.055)/1.055)**2.4}function Lc(t){const e=function(t,e,n){return.2126*Uc(t/255)+.7152*Uc(e/255)+.0722*Uc(n/255)}(parseInt(t.slice(1,3),16),parseInt(t.slice(3,5),16),parseInt(t.slice(5,7),16));return(e+.05)/.05>1.05/(e+.05)?"#000000":"#ffffff"}function jc(t,e,n){const r=t.slice();return r[39]=e[n],r}function zc(t){let e;return{c(){e=A("percs-modal"),j(e,"--dialog-background-color",t[1].backgroundColor??"#fdf7f4"),j(e,"--dialog-header-text-color",t[1].dialogHeaderTextColor??t[6]??"#000000"),j(e,"--dialog-text-color",t[6]??"#000000"),j(e,"--dialog-button-color",t[1].buttonColor??Lt.brandColor),j(e,"--dialog-button-text-color",t[7]??"#ffffff"),j(e,"--app-launcher-button-display",Lt.percsClient.launcher.hide?"none":"inline")},m(t,n){C(t,e,n)},p(t,n){2&n[0]&&j(e,"--dialog-background-color",t[1].backgroundColor??"#fdf7f4"),66&n[0]&&j(e,"--dialog-header-text-color",t[1].dialogHeaderTextColor??t[6]??"#000000"),64&n[0]&&j(e,"--dialog-text-color",t[6]??"#000000"),2&n[0]&&j(e,"--dialog-button-color",t[1].buttonColor??Lt.brandColor),128&n[0]&&j(e,"--dialog-button-text-color",t[7]??"#ffffff")},d(t){t&&S(e)}}}function qc(t){let e,n,r,o,i,a,s,c,l,u,d=t[1].headerText+"",h=0===t[0].accounts.length&&Wc(t),f=t[3]&&Hc(t);const p=[Vc,Jc,Kc,Yc],g=[];function m(t,e){return 0===t[0].accounts.length?0:null==t[11]?1:t[11].length?2:t[3]?-1:3}return~(c=m(t))&&(l=g[c]=p[c](t)),{c(){e=A("div"),n=A("div"),r=A("h2"),o=T(d),i=R(),h&&h.c(),a=R(),f&&f.c(),s=R(),l&&l.c(),$(r,"class","font-bold"),$(n,"id","content"),$(e,"id","wrapper"),$(e,"class","discount"),j(e,"--brand-color",t[1].buttonColor??Lt.brandColor)},m(t,l){C(t,e,l),x(e,n),x(n,r),x(r,o),x(n,i),h&&h.m(n,null),x(n,a),f&&f.m(n,null),x(n,s),~c&&g[c].m(n,null),u=!0},p(t,r){(!u||2&r[0])&&d!==(d=t[1].headerText+"")&&U(o,d),0===t[0].accounts.length?h?h.p(t,r):(h=Wc(t),h.c(),h.m(n,a)):h&&(h.d(1),h=null),t[3]?f?f.p(t,r):(f=Hc(t),f.c(),f.m(n,s)):f&&(f.d(1),f=null);let i=c;c=m(t),c===i?~c&&g[c].p(t,r):(l&&(ft(),mt(g[i],1,1,(()=>{g[i]=null})),pt()),~c?(l=g[c],l?l.p(t,r):(l=g[c]=p[c](t),l.c()),gt(l,1),l.m(n,null)):l=null),(!u||2&r[0])&&j(e,"--brand-color",t[1].buttonColor??Lt.brandColor)},i(t){u||(gt(l),u=!0)},o(t){mt(l),u=!1},d(t){t&&S(e),h&&h.d(),f&&f.d(),~c&&g[c].d()}}}function Dc(t){let n,r,o,i;return{c(){n=A("nft-app-launcher"),P(n,"title",r=t[1].headerText),P(n,"description",o=t[1].descriptionText),P(n,"illustration",i=t[1].headerImageUrl),P(n,"scope",`product:${t[16]}`),j(n,"--dialog-background-color",t[1].backgroundColor??"#fdf7f4"),j(n,"--dialog-header-text-color",t[1].dialogHeaderTextColor??t[6]??"#000000"),j(n,"--dialog-text-color",t[1].backgroundColor?Lc(t[1].backgroundColor??"#ffffff"):"#000000"),j(n,"--dialog-button-color",t[1].buttonColor??Lt.brandColor),j(n,"--dialog-button-text-color",t[1].buttonColor?Lc(t[1].buttonColor??"#000000"):"#ffffff"),j(n,"--app-launcher-button-display",Lt.percsClient.launcher.hide?"none":"inline")},m(t,e){C(t,n,e)},p(t,e){2&e[0]&&r!==(r=t[1].headerText)&&P(n,"title",r),2&e[0]&&o!==(o=t[1].descriptionText)&&P(n,"description",o),2&e[0]&&i!==(i=t[1].headerImageUrl)&&P(n,"illustration",i),2&e[0]&&j(n,"--dialog-background-color",t[1].backgroundColor??"#fdf7f4"),66&e[0]&&j(n,"--dialog-header-text-color",t[1].dialogHeaderTextColor??t[6]??"#000000"),2&e[0]&&j(n,"--dialog-text-color",t[1].backgroundColor?Lc(t[1].backgroundColor??"#ffffff"):"#000000"),2&e[0]&&j(n,"--dialog-button-color",t[1].buttonColor??Lt.brandColor),2&e[0]&&j(n,"--dialog-button-text-color",t[1].buttonColor?Lc(t[1].buttonColor??"#000000"):"#ffffff")},i:e,o:e,d(t){t&&S(n)}}}function Fc(t){let n,r,o,i,a,s,c,l,u,d=t[1].headerText+"",h=t[1].headerImageUrl&&ll(t);function f(t,e){return t[9]?.allow?dl:ul}let p=f(t),g=p(t),m=t[3]&&hl(t);function w(t,e){return 0===t[0].accounts.length?ml:null==t[9]?gl:t[9].allow?pl:t[3]?void 0:fl}let b=w(t),y=b&&b(t),v=Lt.showAccessGateBackButton&&function(t){let n,r,o,i;return{c(){n=A("div"),r=A("div"),r.textContent="Go Back",$(r,"class","underline text-blue-600 hover:text-blue-800 visited:text-purple-600 cursor-pointer"),j(n,"padding","5px")},m(e,a){C(e,n,a),x(n,r),o||(i=N(r,"click",t[25]),o=!0)},p:e,d(t){t&&S(n),o=!1,i()}}}(t);return{c(){n=A("div"),r=A("div"),h&&h.c(),o=R(),i=A("h2"),a=T(d),s=R(),g.c(),c=R(),m&&m.c(),l=R(),y&&y.c(),u=R(),v&&v.c(),$(r,"class","content"),$(n,"class","wrapper access"),q(n,"is-root",!t[5]),j(n,"--brand-color",t[1].buttonColor??Lt.brandColor),j(n,"--dialog-header-text-color",t[1].dialogHeaderTextColor??t[6]??"#000000"),j(n,"--dialog-background-color",t[1].backgroundColor??"#fdf7f4"),j(n,"--dialog-text-color",t[6]??"#000000"),j(n,"--dialog-button-text-color",t[7]??"#ffffff")},m(t,e){C(t,n,e),x(n,r),h&&h.m(r,null),x(r,o),x(r,i),x(i,a),x(r,s),g.m(r,null),x(r,c),m&&m.m(r,null),x(r,l),y&&y.m(r,null),x(r,u),v&&v.m(r,null)},p(t,e){t[1].headerImageUrl?h?h.p(t,e):(h=ll(t),h.c(),h.m(r,o)):h&&(h.d(1),h=null),2&e[0]&&d!==(d=t[1].headerText+"")&&U(a,d),p===(p=f(t))&&g?g.p(t,e):(g.d(1),g=p(t),g&&(g.c(),g.m(r,c))),t[3]?m?m.p(t,e):(m=hl(t),m.c(),m.m(r,l)):m&&(m.d(1),m=null),b===(b=w(t))&&y?y.p(t,e):(y&&y.d(1),y=b&&b(t),y&&(y.c(),y.m(r,u))),Lt.showAccessGateBackButton&&v.p(t,e),32&e[0]&&q(n,"is-root",!t[5]),2&e[0]&&j(n,"--brand-color",t[1].buttonColor??Lt.brandColor),66&e[0]&&j(n,"--dialog-header-text-color",t[1].dialogHeaderTextColor??t[6]??"#000000"),2&e[0]&&j(n,"--dialog-background-color",t[1].backgroundColor??"#fdf7f4"),64&e[0]&&j(n,"--dialog-text-color",t[6]??"#000000"),128&e[0]&&j(n,"--dialog-button-text-color",t[7]??"#ffffff")},i:e,o:e,d(t){t&&S(n),h&&h.d(),g.d(),m&&m.d(),y&&y.d(),v&&v.d()}}}function Wc(t){let e,n,r=t[1].descriptionText+"";return{c(){e=A("p"),n=T(r),$(e,"class","py-2")},m(t,r){C(t,e,r),x(e,n)},p(t,e){2&e[0]&&r!==(r=t[1].descriptionText+"")&&U(n,r)},d(t){t&&S(e)}}}function Hc(t){let e,n;return{c(){e=A("div"),n=T(t[3]),$(e,"class","error")},m(t,r){C(t,e,r),x(e,n)},p(t,e){8&e[0]&&U(n,t[3])},d(t){t&&S(e)}}}function Yc(t){let n,r,o,i,a=(t[0].accounts[0]||"unknown wallet")+"";function s(t,e){return t[1].rejectMessage?Zc:Qc}let c=s(t),l=c(t);return{c(){l.c(),n=R(),r=A("h5"),o=T("connected wallet: "),i=T(a),$(r,"class","text-gray-500 truncate overflow-ellipsis")},m(t,e){l.m(t,e),C(t,n,e),C(t,r,e),x(r,o),x(r,i)},p(t,e){c===(c=s(t))&&l?l.p(t,e):(l.d(1),l=c(t),l&&(l.c(),l.m(n.parentNode,n))),1&e[0]&&a!==(a=(t[0].accounts[0]||"unknown wallet")+"")&&U(i,a)},i:e,o:e,d(t){l.d(t),t&&S(n),t&&S(r)}}}function Kc(t){let e,n,r,o,i,a,s=`${t[11].length} ${1===t[11].length?"token":"tokens"}!`,c=t[11],l=[];for(let e=0;e<c.length;e+=1)l[e]=sl(jc(t,c,e));const u=t=>mt(l[t],1,1,(()=>{l[t]=null}));return{c(){e=A("div"),n=T("You own "),r=T(s),o=R(),i=A("ul");for(let t=0;t<l.length;t+=1)l[t].c();$(i,"class","mt-3 overflow-y-auto max-h-52")},m(t,s){C(t,e,s),x(e,n),x(e,r),C(t,o,s),C(t,i,s);for(let t=0;t<l.length;t+=1)l[t].m(i,null);a=!0},p(t,e){if((!a||2048&e[0])&&s!==(s=`${t[11].length} ${1===t[11].length?"token":"tokens"}!`)&&U(r,s),7346176&e[0]){let n;for(c=t[11],n=0;n<c.length;n+=1){const r=jc(t,c,n);l[n]?(l[n].p(r,e),gt(l[n],1)):(l[n]=sl(r),l[n].c(),gt(l[n],1),l[n].m(i,null))}for(ft(),n=c.length;n<l.length;n+=1)u(n);pt()}},i(t){if(!a){for(let t=0;t<c.length;t+=1)gt(l[t]);a=!0}},o(t){l=l.filter(Boolean);for(let t=0;t<l.length;t+=1)mt(l[t]);a=!1},d(t){t&&S(e),t&&S(o),t&&S(i),E(l,t)}}}function Jc(t){let n;return{c(){n=A("div"),n.textContent="Loading your NFTs…"},m(t,e){C(t,n,e)},p:e,i:e,o:e,d(t){t&&S(n)}}}function Vc(t){let n,r,o,i,a,c,l,u=t[14].isAvailable&&Lt.walletConnect&&cl(t);return{c(){n=A("div"),r=A("button"),o=T("Connect your wallet"),i=R(),u&&u.c(),a=O(),$(r,"class","cta"),r.disabled=t[2],j(n,"padding","5px")},m(e,d){C(e,n,d),x(n,r),x(r,o),C(e,i,d),u&&u.m(e,d),C(e,a,d),c||(l=N(r,"click",(function(){s(t[19](t[14].isAvailable?Xt.connect:Oc.connect))&&t[19](t[14].isAvailable?Xt.connect:Oc.connect).apply(this,arguments)})),c=!0)},p(e,n){t=e,4&n[0]&&(r.disabled=t[2]),t[14].isAvailable&&Lt.walletConnect?u?u.p(t,n):(u=cl(t),u.c(),u.m(a.parentNode,a)):u&&(u.d(1),u=null)},i:e,o:e,d(t){t&&S(n),t&&S(i),u&&u.d(t),t&&S(a),c=!1,l()}}}function Qc(t){let n;return{c(){n=A("div"),n.innerHTML='You don’t have any of the right NFTs connected to your wallet.  Visit our <a href="https://percs.notion.site/I-can-t-see-my-NFTs-when-I-connect-my-wallet-d20495c88e57424391a0357b634f0e6c" class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600" target="_blank">support page</a> for more information'},m(t,e){C(t,n,e)},p:e,d(t){t&&S(n)}}}function Zc(t){let e,n,r=t[1].rejectMessage+"";return{c(){e=A("div"),n=T(r)},m(t,r){C(t,e,r),x(e,n)},p(t,e){2&e[0]&&r!==(r=t[1].rejectMessage+"")&&U(n,r)},d(t){t&&S(e)}}}function Gc(t){let n;return{c(){n=A("p"),n.textContent="Redeem your token",$(n,"class","text-gray-500 truncate overflow-ellipsis")},m(t,e){C(t,n,e)},p:e,i:e,o:e,d(t){t&&S(n)}}}function Xc(t){let n;return{c(){n=A("p"),n.textContent="Code already redeemed",$(n,"class","text-gray-500 truncate overflow-ellipsis")},m(t,e){C(t,n,e)},p:e,i:e,o:e,d(t){t&&S(n)}}}function tl(t){let e,n,r,o;const i=[nl,el],a=[];function s(t,e){return t[12]===t[39].code?0:1}return e=s(t),n=a[e]=i[e](t),{c(){n.c(),r=O()},m(t,n){a[e].m(t,n),C(t,r,n),o=!0},p(t,o){let c=e;e=s(t),e===c?a[e].p(t,o):(ft(),mt(a[c],1,1,(()=>{a[c]=null})),pt(),n=a[e],n?n.p(t,o):(n=a[e]=i[e](t),n.c()),gt(n,1),n.m(r.parentNode,r))},i(t){o||(gt(n),o=!0)},o(t){mt(n),o=!1},d(t){a[e].d(t),t&&S(r)}}}function el(t){let e,n,r,o,i,a=t[39].code+"";return{c(){e=A("p"),n=T(a),$(e,"class","text-gray-500 truncate overflow-ellipsis"),$(e,"title",r=t[39].code)},m(t,r){C(t,e,r),x(e,n),i=!0},p(t,o){(!i||2048&o[0])&&a!==(a=t[39].code+"")&&U(n,a),(!i||2048&o[0]&&r!==(r=t[39].code))&&$(e,"title",r)},i(t){i||(rt((()=>{o||(o=vt(e,Et,{delay:100,duration:200},!0)),o.run(1)})),i=!0)},o(t){o||(o=vt(e,Et,{delay:100,duration:200},!1)),o.run(0),i=!1},d(t){t&&S(e),t&&o&&o.end()}}}function nl(t){let e,n,r,o,i;return{c(){e=A("p"),n=T("Discount code copied!"),$(e,"class","text-green-500 truncate overflow-ellipsis"),$(e,"title",r=t[39].code)},m(t,r){C(t,e,r),x(e,n),i=!0},p(t,n){(!i||2048&n[0]&&r!==(r=t[39].code))&&$(e,"title",r)},i(t){i||(rt((()=>{o||(o=vt(e,Et,{delay:100,duration:200},!0)),o.run(1)})),i=!0)},o(t){o||(o=vt(e,Et,{delay:100,duration:200},!1)),o.run(0),i=!1},d(t){t&&S(e),t&&o&&o.end()}}}function rl(t){let n,r,o;function i(){return t[27](t[39])}return{c(){n=A("button"),n.innerHTML='<span class="sr-only">Redeem your NFT</span> \n                      \n                      <svg xmlns="http://www.w3.org/2000/svg" class="min-w-6 h-6" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M6.625 2.655A9 9 0 0119 11a1 1 0 11-2 0 7 7 0 00-9.625-6.492 1 1 0 11-.75-1.853zM4.662 4.959A1 1 0 014.75 6.37 6.97 6.97 0 003 11a1 1 0 11-2 0 8.97 8.97 0 012.25-5.953 1 1 0 011.412-.088z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M5 11a5 5 0 1110 0 1 1 0 11-2 0 3 3 0 10-6 0c0 1.677-.345 3.276-.968 4.729a1 1 0 11-1.838-.789A9.964 9.964 0 005 11zm8.921 2.012a1 1 0 01.831 1.145 19.86 19.86 0 01-.545 2.436 1 1 0 11-1.92-.558c.207-.713.371-1.445.49-2.192a1 1 0 011.144-.83z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M10 10a1 1 0 011 1c0 2.236-.46 4.368-1.29 6.304a1 1 0 01-1.838-.789A13.952 13.952 0 009 11a1 1 0 011-1z" clip-rule="evenodd"></path></svg>',$(n,"type","button"),$(n,"title","Redeem your NFT"),$(n,"class","w-8 h-8 bg-white inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500")},m(t,e){C(t,n,e),r||(o=N(n,"click",B(i)),r=!0)},p(e,n){t=e},i:e,o:e,d(t){t&&S(n),r=!1,o()}}}function ol(t){let e,n,r,o,i,a,s,c;const l=[al,il],u=[];function d(t,e){return t[12]===t[39].code?0:1}function h(){return t[26](t[39])}return o=d(t),i=u[o]=l[o](t),{c(){e=A("button"),n=A("span"),n.textContent="Copy your discount code",r=R(),i.c(),$(n,"class","sr-only"),$(e,"type","button"),$(e,"title","Copy your discount code"),$(e,"class","w-8 h-8 bg-white inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500")},m(t,i){C(t,e,i),x(e,n),x(e,r),u[o].m(e,null),a=!0,s||(c=N(e,"click",B(h)),s=!0)},p(n,r){let a=o;o=d(t=n),o!==a&&(ft(),mt(u[a],1,1,(()=>{u[a]=null})),pt(),i=u[o],i||(i=u[o]=l[o](t),i.c()),gt(i,1),i.m(e,null))},i(t){a||(gt(i),a=!0)},o(t){mt(i),a=!1},d(t){t&&S(e),u[o].d(),s=!1,c()}}}function il(t){let e,n,r,o,i;return{c(){e=I("svg"),n=I("path"),$(n,"stroke-linecap","round"),$(n,"stroke-linejoin","round"),$(n,"stroke-width","2"),$(n,"d","M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"),$(e,"class","min-w-6 h-6"),$(e,"fill","none"),$(e,"viewBox","0 0 24 24"),$(e,"stroke","currentColor"),$(e,"xmlns","http://www.w3.org/2000/svg")},m(t,r){C(t,e,r),x(e,n),i=!0},i(t){i||(rt((()=>{o&&o.end(1),r=bt(e,St,{y:16,delay:100,duration:200}),r.start()})),i=!0)},o(t){r&&r.invalidate(),o=yt(e,St,{y:-16,duration:100}),i=!1},d(t){t&&S(e),t&&o&&o.end()}}}function al(t){let e,n,r,o,i;return{c(){e=I("svg"),n=I("path"),$(n,"stroke-linecap","round"),$(n,"stroke-linejoin","round"),$(n,"stroke-width","2"),$(n,"d","M5 13l4 4L19 7"),$(e,"class","min-w-6 h-6 text-green-500"),$(e,"fill","none"),$(e,"stroke","currentColor"),$(e,"viewBox","0 0 24 24"),$(e,"xmlns","http://www.w3.org/2000/svg")},m(t,r){C(t,e,r),x(e,n),i=!0},i(t){i||(rt((()=>{o&&o.end(1),r=bt(e,St,{y:16,delay:100,duration:200}),r.start()})),i=!0)},o(t){r&&r.invalidate(),o=yt(e,St,{y:-16,duration:100}),i=!1},d(t){t&&S(e),t&&o&&o.end()}}}function sl(t){let e,n,r,o,i,a,s,c,l,u,d,h,f,p,g,m,w,b,y,v,_,k,M,E=t[39].id+"",I=t[39].id+"";const O=[tl,Xc,Gc],B=[];function P(t,e){return t[39].code?0:t[39].isRedeemed?1:2}h=P(t),f=B[h]=O[h](t);const L=[ol,rl],j=[];function z(t,e){return t[39].code?0:1}function q(){return t[28](t[39])}return m=z(t),w=j[m]=L[m](t),{c(){e=A("li"),n=A("div"),r=T("#"),o=T(E),i=R(),a=A("div"),s=A("div"),c=A("span"),l=T("Token #"),u=T(I),d=R(),f.c(),p=R(),g=A("div"),w.c(),b=R(),$(n,"class","token-list-item__token flex-shrink-0 flex items-center justify-center w-16 bg-pink-600 text-white text-sm font-medium rounded-l-md"),$(c,"class","token-list-item__token-name text-gray-900 font-medium hover:text-gray-600 truncate overflow-ellipsis"),$(s,"class","flex-1 px-4 py-2 text-sm truncate overflow-ellipsis"),$(g,"class","flex-shrink-0 pr-2 flex"),$(a,"class","flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate overflow-ellipsis"),$(e,"class",y="token-list-item flex shadow-sm rounded-md "+(t[39].isRedeemed?"token-list-item--is-redeemed":""))},m(t,f){C(t,e,f),x(e,n),x(n,r),x(n,o),x(e,i),x(e,a),x(a,s),x(s,c),x(c,l),x(c,u),x(s,d),B[h].m(s,null),x(a,p),x(a,g),j[m].m(g,null),x(e,b),_=!0,k||(M=N(e,"click",q),k=!0)},p(n,r){t=n,(!_||2048&r[0])&&E!==(E=t[39].id+"")&&U(o,E),(!_||2048&r[0])&&I!==(I=t[39].id+"")&&U(u,I);let i=h;h=P(t),h===i?B[h].p(t,r):(ft(),mt(B[i],1,1,(()=>{B[i]=null})),pt(),f=B[h],f?f.p(t,r):(f=B[h]=O[h](t),f.c()),gt(f,1),f.m(s,null));let a=m;m=z(t),m===a?j[m].p(t,r):(ft(),mt(j[a],1,1,(()=>{j[a]=null})),pt(),w=j[m],w?w.p(t,r):(w=j[m]=L[m](t),w.c()),gt(w,1),w.m(g,null)),(!_||2048&r[0]&&y!==(y="token-list-item flex shadow-sm rounded-md "+(t[39].isRedeemed?"token-list-item--is-redeemed":"")))&&$(e,"class",y)},i(t){_||(gt(f),gt(w),v||rt((()=>{v=bt(e,Et,{duration:200}),v.start()})),_=!0)},o(t){mt(f),mt(w),_=!1},d(t){t&&S(e),B[h].d(),j[m].d(),k=!1,M()}}}function cl(t){let e,n,r,o,i;return{c(){e=A("div"),n=A("button"),r=T("WalletConnect your wallet"),$(n,"class","cta"),n.disabled=t[2],j(e,"padding","5px")},m(a,s){C(a,e,s),x(e,n),x(n,r),o||(i=N(n,"click",t[19](Oc.connect)),o=!0)},p(t,e){4&e[0]&&(n.disabled=t[2])},d(t){t&&S(e),o=!1,i()}}}function ll(t){let e,n,r;return{c(){e=A("img"),u(e.src,n=t[1].headerImageUrl)||$(e,"src",n),$(e,"alt",r=t[1].headerText)},m(t,n){C(t,e,n)},p(t,o){2&o[0]&&!u(e.src,n=t[1].headerImageUrl)&&$(e,"src",n),2&o[0]&&r!==(r=t[1].headerText)&&$(e,"alt",r)},d(t){t&&S(e)}}}function ul(t){let e,n,r=t[1].descriptionText+"";return{c(){e=A("p"),n=T(r)},m(t,r){C(t,e,r),x(e,n)},p(t,e){2&e[0]&&r!==(r=t[1].descriptionText+"")&&U(n,r)},d(t){t&&S(e)}}}function dl(t){let n;return{c(){n=A("div"),n.textContent="Congratulations!",$(n,"class","message")},m(t,e){C(t,n,e)},p:e,d(t){t&&S(n)}}}function hl(t){let e,n;return{c(){e=A("div"),n=T(t[3]),$(e,"class","error")},m(t,r){C(t,e,r),x(e,n)},p(t,e){8&e[0]&&U(n,t[3])},d(t){t&&S(e)}}}function fl(t){let e,n,r,o,i=(t[0].accounts[0]||"unknown wallet")+"";function a(t,e){return t[1].rejectMessage?bl:wl}let s=a(t),c=s(t);return{c(){c.c(),e=R(),n=A("h5"),r=T("connected wallet: "),o=T(i),$(n,"class","text-gray-500 truncate overflow-ellipsis")},m(t,i){c.m(t,i),C(t,e,i),C(t,n,i),x(n,r),x(n,o)},p(t,n){s===(s=a(t))&&c?c.p(t,n):(c.d(1),c=s(t),c&&(c.c(),c.m(e.parentNode,e))),1&n[0]&&i!==(i=(t[0].accounts[0]||"unknown wallet")+"")&&U(o,i)},d(t){c.d(t),t&&S(e),t&&S(n)}}}function pl(t){let e,n,r,o;return{c(){e=A("button"),n=T("Unlock this product"),$(e,"class","cta"),e.disabled=t[2]},m(i,a){C(i,e,a),x(e,n),r||(o=N(e,"click",t[23]),r=!0)},p(t,n){4&n[0]&&(e.disabled=t[2])},d(t){t&&S(e),r=!1,o()}}}function gl(t){let e,n=!t[3]&&yl();return{c(){n&&n.c(),e=O()},m(t,r){n&&n.m(t,r),C(t,e,r)},p(t,r){t[3]?n&&(n.d(1),n=null):n||(n=yl(),n.c(),n.m(e.parentNode,e))},d(t){n&&n.d(t),t&&S(e)}}}function ml(t){let e,n,r,o,i,a,c,l,u=t[14].isAvailable&&Lt.walletConnect&&vl(t);return{c(){e=A("div"),n=A("button"),r=T("Connect your wallet"),i=R(),u&&u.c(),a=O(),$(n,"class","cta"),n.disabled=t[2],$(e,"style",o=t[14].isAvailable&&Lt.walletConnect?"padding: 5px;":"")},m(o,d){C(o,e,d),x(e,n),x(n,r),C(o,i,d),u&&u.m(o,d),C(o,a,d),c||(l=N(n,"click",(function(){s(t[19](t[14].isAvailable?Xt.connect:Oc.connect))&&t[19](t[14].isAvailable?Xt.connect:Oc.connect).apply(this,arguments)})),c=!0)},p(r,i){t=r,4&i[0]&&(n.disabled=t[2]),16384&i[0]&&o!==(o=t[14].isAvailable&&Lt.walletConnect?"padding: 5px;":"")&&$(e,"style",o),t[14].isAvailable&&Lt.walletConnect?u?u.p(t,i):(u=vl(t),u.c(),u.m(a.parentNode,a)):u&&(u.d(1),u=null)},d(t){t&&S(e),t&&S(i),u&&u.d(t),t&&S(a),c=!1,l()}}}function wl(t){let n;return{c(){n=A("div"),n.innerHTML='You don’t have any of the right NFTs connected to your wallet. Visit our <a href="https://percs.notion.site/I-can-t-see-my-NFTs-when-I-connect-my-wallet-d20495c88e57424391a0357b634f0e6c" class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600" target="_blank">support page</a> for more information.'},m(t,e){C(t,n,e)},p:e,d(t){t&&S(n)}}}function bl(t){let e,n,r=t[1].rejectMessage+"";return{c(){e=A("div"),n=T(r)},m(t,r){C(t,e,r),x(e,n)},p(t,e){2&e[0]&&r!==(r=t[1].rejectMessage+"")&&U(n,r)},d(t){t&&S(e)}}}function yl(t){let e;return{c(){e=A("div"),e.textContent="Loading your NFTs…"},m(t,n){C(t,e,n)},d(t){t&&S(e)}}}function vl(t){let e,n,r,o,i;return{c(){e=A("div"),n=A("button"),r=T("Connect using WalletConnect"),$(n,"class","cta"),n.disabled=t[2],j(e,"padding","5px")},m(a,s){C(a,e,s),x(e,n),x(n,r),o||(i=N(n,"click",t[19](Oc.connect)),o=!0)},p(t,e){4&e[0]&&(n.disabled=t[2])},d(t){t&&S(e),o=!1,i()}}}function _l(t){let n,r,o,i,a,s,c,l,u,d,h=`<style>${t[15]}</style>`,f=t[8]&&t[13]&&zc(t);const p=[Fc,Dc,qc],g=[];function m(t,e){return t[8]&&t[13]&&!Lt.percsClient.launcher.enabled?0:!t[8]&&t[10]&&Lt.percsClient.launcher.enabled&&t[13]?1:t[10]&&t[13]&&!Lt.percsClient.launcher.enabled?2:-1}return~(c=m(t))&&(l=g[c]=p[c](t)),{c(){n=new D(!1),r=O(),o=R(),i=A("div"),a=R(),f&&f.c(),s=R(),l&&l.c(),u=O(),this.c=e,n.a=r},m(e,l){n.m(h,document.head),x(document.head,r),C(e,o,l),C(e,i,l),t[24](i),C(e,a,l),f&&f.m(e,l),C(e,s,l),~c&&g[c].m(e,l),C(e,u,l),d=!0},p(t,e){t[8]&&t[13]?f?f.p(t,e):(f=zc(t),f.c(),f.m(s.parentNode,s)):f&&(f.d(1),f=null);let n=c;c=m(t),c===n?~c&&g[c].p(t,e):(l&&(ft(),mt(g[n],1,1,(()=>{g[n]=null})),pt()),~c?(l=g[c],l?l.p(t,e):(l=g[c]=p[c](t),l.c()),gt(l,1),l.m(u.parentNode,u)):l=null)},i(t){d||(gt(l),d=!0)},o(t){mt(l),d=!1},d(e){S(r),e&&n.d(),e&&S(o),e&&S(i),t[24](null),e&&S(a),f&&f.d(e),e&&S(s),~c&&g[c].d(e),e&&S(u)}}}function xl(t,e,n){let o,i,a,s;f(t,Pc,(t=>n(0,o=t))),f(t,Xt,(t=>n(14,s=t)));const{customer:c,product:l,variant:u,"customer-token":d,selector:h}=e,m=Dt("verified_accounts",[]);f(t,m,(t=>n(31,a=t)));const w=Dt("token_codes",{});let b;f(t,w,(t=>n(30,i=t)));let y,v=!1,_="",x=!1,k="#000000",M="#ffffff",C=!1,S=null,E=!1,A=null,I=null,T=null;async function R(t){try{const{redeemMessage:e}=t,{signature:r,keyIndex:o}=await Pc.signPersonalMessage(t.account,e),a=await async function(t){return Tt("getTokenCode",t)}({customerId:c,productId:l,token:t,message:e,signature:r,account:t.account,keyIndex:o});g(w,i[`${t.campaignId}-${t.smartContract.address}-${t.id}`]=a,i),t.code=a,n(11,A)}catch(t){console.error(t)}}function O(t){navigator.clipboard&&t.code&&navigator.clipboard.writeText(t.code).then((()=>{n(12,I=t.code),T&&clearTimeout(T),T=setTimeout((()=>{n(12,I=null),T=null}),6e3)}),(t=>{console.error("problem copying",t)}))}function N(t){return t.code?O(t):t.isRedeemed?void 0:R(t)}async function B(){if(o.accounts.length>0){if(n(3,_=""),n(2,v=!0),C)try{n(9,S=await async function(t){return Tt("checkProductAccess",t)}({customerId:c,productId:l,variantId:u,accounts:o.accounts})),S.allow&&S.allowedAddresses&&(S.verify||await $())}catch(t){n(3,_=t.message)}else if(E)try{n(11,A=await Ot({productId:l,accounts:o.accounts}));for(const t of A)t.code=i[`${t.campaignId}-${t.smartContract.address}-${t.id}`]}catch(t){n(3,_=t.message)}n(2,v=!1)}}async function $(){n(8,C=!1);const t=y.parentNode.host.ownerDocument.querySelector(h||".product-form__buttons");t&&(t.style.display="block");const e=Ut.find((([t])=>t.includes(l)));if(n(10,E=!!e),E){n(1,b=e[1]),n(11,A=await Ot({productId:l,accounts:o.accounts}));for(const t of A)t.code=i[`${t.campaignId}-${t.smartContract.address}-${t.id}`]}}let P=!1;Q((async()=>{n(13,P=!0);const t=y.parentNode;if(t&&t.append(...t.host.querySelectorAll("[shadowRoot]")),!l)return n(8,C=!1),void n(10,E=!1);const e=Pt.find((([t])=>t.includes(l)));n(8,C=!!e);const r=Ut.find((([t])=>t.includes(l)));if(n(10,E=!!r),C)n(1,b=e[1]),n(6,k=Lc(b.backgroundColor??"#ffffff")),n(7,M=Lc(b.buttonColor??"#000000")),setTimeout((()=>{"PERCS"in window&&"openModal"in window.PERCS&&(window.PERCS.init({clientKey:"WB1f44EqONrVTApCMF8hXXlBnhijJBcNkIWc6/91gL8OREXPevxEo8GpAGA6tj4/-tCR9nFgDTzhV9RGp6yK1Kmw",apiHost:"https://engage.getpercs.com"}),window.PERCS.openModal({scope:`product:${l}`,gate:{dismissable:!1,title:b.headerText,description:b.descriptionText,illustration:b.headerImageUrl},offerSelectedType:"access"}),window.PERCS.on("offer_redeem",(async t=>{if("properties"in t&&"_perc_request_id"in t.properties){Nt(y.parentNode).forEach((e=>{e&&$t(e,t.properties)})),await $()}})))}),0);else{if(!E)return;n(1,b=r[1])}null!=y?.parentNode?.host?.closest(".Modal__content")&&n(5,x=!0)}));return t.$$set=t=>{n(38,e=r(r({},e),p(t)))},t.$$.update=()=>{1&t.$$.dirty[0]&&o.accounts&&B()},e=p(e),[o,b,v,_,y,x,k,M,C,S,E,A,I,P,s,"\n    .walletconnect-modal__mobile__toggle {\n      cursor: pointer;\n    }\n    div:empty.walletconnect-connect__button__icon,\n    div:empty.walletconnect-modal__mobile__toggle_selector,\n    div:empty.walletconnect-modal__close__line1,\n    div:empty.walletconnect-modal__close__line2 {\n      display: block;\n      cursor: pointer;\n    }\n  ",l,m,w,function(t){return async()=>{n(3,_=""),n(2,v=!0);try{await t()}catch(t){console.error(t),n(3,_=t.message)}n(2,v=!1)}},R,O,N,async function(){if(S&&S.allow&&S.verify){if(!S.allowedAddresses||0===S.allowedAddresses.length)return;const[t]=S.allowedAddresses;try{n(2,v=!0);const{message:e}=S,{signature:r,keyIndex:o}=await Pc.signPersonalMessage(t,e),i=await async function(t){return Tt("unlockProduct",t)}({type:"ETH",message:e,signature:r,account:t,keyIndex:o});if("properties"in i){Nt(y.parentNode).forEach((t=>{t&&$t(t,i.properties)}))}await $(),g(m,a=[...a,t],a)}catch(t){console.error(t),n(3,_=t.message)}n(2,v=!1)}else n(3,_="You don’t have the required NFT")},function(t){G[t?"unshift":"push"]((()=>{y=t,n(4,y)}))},()=>history.back(),t=>O(t),t=>R(t),t=>N(t)]}customElements.define("nft-connect",class extends Mt{constructor(t){super(),this.shadowRoot.innerHTML='<style>*,::before,::after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}::before,::after{--tw-content:\'\'}h2,h5{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}button{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button{text-transform:none}button,[type=\'button\']{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}h2,h5,p{margin:0}ul{list-style:none;margin:0;padding:0}button{cursor:pointer}:disabled{cursor:default}img,svg{display:block;vertical-align:middle}img{max-width:100%;height:auto}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-date-and-time-value{min-height:1.5em}::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{padding-top:0;padding-bottom:0}*,::before,::after{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x:  ;--tw-pan-y:  ;--tw-pinch-zoom:  ;--tw-scroll-snap-strictness:proximity;--tw-ordinal:  ;--tw-slashed-zero:  ;--tw-numeric-figure:  ;--tw-numeric-spacing:  ;--tw-numeric-fraction:  ;--tw-ring-inset:  ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur:  ;--tw-brightness:  ;--tw-contrast:  ;--tw-grayscale:  ;--tw-hue-rotate:  ;--tw-invert:  ;--tw-saturate:  ;--tw-sepia:  ;--tw-drop-shadow:  ;--tw-backdrop-blur:  ;--tw-backdrop-brightness:  ;--tw-backdrop-contrast:  ;--tw-backdrop-grayscale:  ;--tw-backdrop-hue-rotate:  ;--tw-backdrop-invert:  ;--tw-backdrop-opacity:  ;--tw-backdrop-saturate:  ;--tw-backdrop-sepia:  }::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x:  ;--tw-pan-y:  ;--tw-pinch-zoom:  ;--tw-scroll-snap-strictness:proximity;--tw-ordinal:  ;--tw-slashed-zero:  ;--tw-numeric-figure:  ;--tw-numeric-spacing:  ;--tw-numeric-fraction:  ;--tw-ring-inset:  ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur:  ;--tw-brightness:  ;--tw-contrast:  ;--tw-grayscale:  ;--tw-hue-rotate:  ;--tw-invert:  ;--tw-saturate:  ;--tw-sepia:  ;--tw-drop-shadow:  ;--tw-backdrop-blur:  ;--tw-backdrop-brightness:  ;--tw-backdrop-contrast:  ;--tw-backdrop-grayscale:  ;--tw-backdrop-hue-rotate:  ;--tw-backdrop-invert:  ;--tw-backdrop-opacity:  ;--tw-backdrop-saturate:  ;--tw-backdrop-sepia:  }::after,::before{box-sizing:border-box}::-moz-focus-inner{border-style:none;padding:0}:-moz-focusring{outline:1px dotted ButtonText}:-moz-ui-invalid{box-shadow:none}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}h2,p{margin:0}ul{list-style:none;margin:0;padding:0}:root{font-family:Inter var, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";line-height:1.5;color:#111}*,::after,::before{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}button{font-family:inherit;font-size:100%;line-height:1.15;margin:0;text-transform:none;-webkit-appearance:button;background-color:transparent;background-image:none;cursor:pointer}h2{font-size:inherit;font-weight:inherit}button{padding:0;line-height:inherit;color:inherit}svg{display:block}*,::after,::before{--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-transform:translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));--tw-border-opacity:1;border-color:rgba(229, 231, 235, var(--tw-border-opacity));--tw-shadow:0 0 #0000;--tw-ring-inset:var(--tw-empty,  );--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(59, 130, 246, 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-blur:var(--tw-empty,  );--tw-brightness:var(--tw-empty,  );--tw-contrast:var(--tw-empty,  );--tw-grayscale:var(--tw-empty,  );--tw-hue-rotate:var(--tw-empty,  );--tw-invert:var(--tw-empty,  );--tw-saturate:var(--tw-empty,  );--tw-sepia:var(--tw-empty,  );--tw-drop-shadow:var(--tw-empty,  );--tw-filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);--tw-backdrop-blur:var(--tw-empty,  );--tw-backdrop-brightness:var(--tw-empty,  );--tw-backdrop-contrast:var(--tw-empty,  );--tw-backdrop-grayscale:var(--tw-empty,  );--tw-backdrop-hue-rotate:var(--tw-empty,  );--tw-backdrop-invert:var(--tw-empty,  );--tw-backdrop-opacity:var(--tw-empty,  );--tw-backdrop-saturate:var(--tw-empty,  );--tw-backdrop-sepia:var(--tw-empty,  );--tw-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-date-and-time-value{min-height:1.5em}@font-face{font-family:Inter var;font-style:normal;font-weight:100 900;font-display:swap;src:url("/fonts/Inter-roman.var.woff2?v=3.18") format("woff2");font-named-instance:Regular}@font-face{font-family:Inter var;font-style:italic;font-weight:100 900;font-display:swap;src:url("/fonts/Inter-italic.var.woff2?v=3.18") format("woff2");font-named-instance:Italic}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border-width:0}.mt-3{margin-top:.75rem}.flex{display:flex}.inline-flex{display:inline-flex}.h-6{height:1.5rem}.h-8{height:2rem}.min-w-6{min-width:1.5rem}.w-8{width:2rem}.w-16{width:4rem}.flex-1{flex:1 1 0%}.flex-shrink-0{flex-shrink:0}.items-center{align-items:center}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.overflow-ellipsis{text-overflow:ellipsis}.rounded-md{border-radius:.375rem}.rounded-full{border-radius:9999px}.rounded-l-md{border-top-left-radius:.375rem;border-bottom-left-radius:.375rem}.rounded-r-md{border-top-right-radius:.375rem;border-bottom-right-radius:.375rem}.border-r{border-right-width:1px}.border-t{border-top-width:1px}.border-b{border-bottom-width:1px}.border-gray-200{--tw-border-opacity:1;border-color:rgba(229, 231, 235, var(--tw-border-opacity))}.bg-white{--tw-bg-opacity:1;background-color:rgba(255, 255, 255, var(--tw-bg-opacity))}.bg-transparent{background-color:transparent}.bg-pink-600{--tw-bg-opacity:1;background-color:rgba(219, 39, 119, var(--tw-bg-opacity))}.py-2{padding-top:.5rem;padding-bottom:.5rem}.px-4{padding-left:1rem;padding-right:1rem}.pr-2{padding-right:.5rem}.text-sm{font-size:.875rem;line-height:1.25rem}.font-bold{font-weight:700}.font-medium{font-weight:500}.text-gray-900{--tw-text-opacity:1;color:rgba(17, 24, 39, var(--tw-text-opacity))}.text-gray-400{--tw-text-opacity:1;color:rgba(156, 163, 175, var(--tw-text-opacity))}.text-gray-500{--tw-text-opacity:1;color:rgba(107, 114, 128, var(--tw-text-opacity))}.text-green-500{--tw-text-opacity:1;color:rgba(16, 185, 129, var(--tw-text-opacity))}.text-white{--tw-text-opacity:1;color:rgba(255, 255, 255, var(--tw-text-opacity))}.shadow-sm{--tw-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.05);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}.hover\\:text-gray-500:hover{--tw-text-opacity:1;color:rgba(107, 114, 128, var(--tw-text-opacity))}.hover\\:text-gray-600:hover{--tw-text-opacity:1;color:rgba(75, 85, 99, var(--tw-text-opacity))}.hover\\:text-blue-800{color:rgba(44, 82, 130)}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:ring-2:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)}.focus\\:ring-indigo-500:focus{--tw-ring-opacity:1;--tw-ring-color:rgba(99, 102, 241, var(--tw-ring-opacity))}#wrapper{position:fixed;bottom:20px;right:20px;width:260px;display:flex;background:rgba(4, 9, 17, .8);z-index:1000;border-radius:0.8rem}#content{background-color:var(--dialog-background-color, #fdf7f4);margin:auto;width:100%;max-width:252px;margin:4px;padding:12px;border-radius:.8rem;text-align:center}.token-list-item{margin-top:0.5rem;cursor:pointer}.token-list-item__token{--tw-text-opacity:1;flex-shrink:0;justify-content:center;align-items:center;background-color:var(--brand-color);color:rgba(255, 255, 255, 1)}.token-list-item--is-redeemed .token-list-item__token{--tw-text-opacity:1;background-color:rgba(0, 0, 0, 1)}.token-list-item--is-redeemed .token-list-item__token-name{text-decoration:line-through}.cta{font-size:18px;padding:6px 10px;background-color:var(--brand-color, #426efb);color:var(--dialog-button-text-color, #ffffff);border:none;border-radius:4px;cursor:pointer}.wrapper{position:fixed;height:100%;width:100%;top:0;left:0;display:flex;background:rgba(0,0,0,.8);z-index:1000}.content{background-color:var(--dialog-background-color, #fdf7f4);color:var(--dialog-text-color, #000000);margin:auto;border-radius:.8rem;text-align:center;padding:3rem 2rem}.is-root.wrapper{height:100vh;width:100vw}.is-root .content{min-width:80vw;min-height:80vh;display:flex;flex-direction:column;align-items:center;justify-content:center}img{max-height:calc(min(500px, 40vh));max-width:80vw}button{font-size:20px;padding:12px 20px;background-color:var(--brand-color);color:var(--dialog-button-text-color, #ffffff);border:none;border-radius:4px;cursor:pointer}.message{font-size:30px;font-weight:bold;padding-bottom:3rem}.error{padding-bottom:15px;padding-top:15px;color:rgb(215, 44, 13)}.wrapper.access h2{font-weight:bold;font-size:22.5px;margin:18px 0}.wrapper.access p{margin:15px 0}.underline{text-decoration:underline}.text-blue-600{color:rgb(37 99 235)}.visited\\:text-purple-600{color:rgb(128 90 213)}.cursor-pointer{cursor:pointer}</style>',kt(this,{target:this.shadowRoot,props:F(this.attributes),customElement:!0},xl,_l,c,{},null,[-1,-1]),t&&(t.target&&C(t.target,this,t.anchor),t.props&&(this.$set(t.props),st()))}});const kl=zt({isModalOpen:!1,productId:null,variantId:null,campaignSettings:null});function Ml(t){let e;function n(t,e){return t[0]?Sl:Cl}let r=n(t),o=r(t);return{c(){o.c(),e=O()},m(t,n){o.m(t,n),C(t,e,n)},p(t,i){r===(r=n(t))&&o?o.p(t,i):(o.d(1),o=r(t),o&&(o.c(),o.m(e.parentNode,e)))},d(t){o.d(t),t&&S(e)}}}function Cl(t){let e,n,r,o;return{c(){e=A("button"),n=A("slot"),$(e,"type","button"),$(e,"class","cta w-full"),j(e,"--brand-color",t[2].buttonColor??Lt.brandColor),j(e,"--button-text-color",t[3]??"#ffffff")},m(i,a){C(i,e,a),x(e,n),r||(o=N(e,"click",t[5]),r=!0)},p(t,n){4&n&&j(e,"--brand-color",t[2].buttonColor??Lt.brandColor),8&n&&j(e,"--button-text-color",t[3]??"#ffffff")},d(t){t&&S(e),r=!1,o()}}}function Sl(t){let n,r,o;return{c(){n=A("button"),n.innerHTML="<slot></slot>",$(n,"type","button"),$(n,"class","w-full")},m(e,i){C(e,n,i),r||(o=N(n,"click",t[5]),r=!0)},p:e,d(t){t&&S(n),r=!1,o()}}}function El(t){let e;return{c(){e=A("nft-buy-modal")},m(t,n){C(t,e,n)},d(t){t&&S(e)}}}function Al(t){let n,r,o,i,a,s,c=`<style>${t[4]}</style>`,l=Lt.buyButtonStyles&&function(t){let n,r,o=`<style>${Lt.buyButtonStyles}</style>`;return{c(){n=new D(!1),r=O(),n.a=r},m(t,e){n.m(o,t,e),C(t,r,e)},p:e,d(t){t&&S(r),t&&n.d()}}}(),u=t[2]&&Ml(t),d=!t[1]&&El();return{c(){n=new D(!1),r=O(),l&&l.c(),o=O(),i=R(),u&&u.c(),a=R(),d&&d.c(),s=O(),this.c=e,n.a=r},m(t,e){n.m(c,document.head),x(document.head,r),l&&l.m(document.head,null),x(document.head,o),C(t,i,e),u&&u.m(t,e),C(t,a,e),d&&d.m(t,e),C(t,s,e)},p(t,[e]){Lt.buyButtonStyles&&l.p(t,e),t[2]?u?u.p(t,e):(u=Ml(t),u.c(),u.m(a.parentNode,a)):u&&(u.d(1),u=null),t[1]?d&&(d.d(1),d=null):d||(d=El(),d.c(),d.m(s.parentNode,s))},i:e,o:e,d(t){S(r),t&&n.d(),l&&l.d(t),S(o),t&&S(i),u&&u.d(t),t&&S(a),d&&d.d(t),t&&S(s)}}}function Il(t,e,n){let{product:r}=e,{variant:o}=e,{custom:i=!1}=e,{component:a=!1}=e;let s,c,l,u,d=!1,h="#ffffff";return Q((async()=>{s?(u=Pt.find((([t])=>t.includes(s))),d=!!u,d&&(n(2,l=u[1]),n(3,h=Lc(l.buttonColor??"#000000")))):d=!1})),t.$$set=t=>{"product"in t&&n(6,r=t.product),"variant"in t&&n(7,o=t.variant),"custom"in t&&n(0,i=t.custom),"component"in t&&n(1,a=t.component)},t.$$.update=()=>{192&t.$$.dirty&&(s=r,c=o)},[i,a,l,h,"\n    .walletconnect-modal__mobile__toggle {\n      cursor: pointer;\n    }\n    div:empty.walletconnect-connect__button__icon,\n    div:empty.walletconnect-modal__mobile__toggle_selector,\n    div:empty.walletconnect-modal__close__line1,\n    div:empty.walletconnect-modal__close__line2 {\n      display: block;\n      cursor: pointer;\n    }\n  ",async function(){kl.set({productId:s,variantId:c,isModalOpen:!0,campaignSettings:u[1]})},r,o]}customElements.define("nft-buy-button",class extends Mt{constructor(t){super(),this.shadowRoot.innerHTML="<style>*,::before,::after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}::before,::after{--tw-content:''}button{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button{text-transform:none}button,[type='button']{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}button{cursor:pointer}:disabled{cursor:default}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-date-and-time-value{min-height:1.5em}::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{padding-top:0;padding-bottom:0}*,::before,::after{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x:  ;--tw-pan-y:  ;--tw-pinch-zoom:  ;--tw-scroll-snap-strictness:proximity;--tw-ordinal:  ;--tw-slashed-zero:  ;--tw-numeric-figure:  ;--tw-numeric-spacing:  ;--tw-numeric-fraction:  ;--tw-ring-inset:  ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur:  ;--tw-brightness:  ;--tw-contrast:  ;--tw-grayscale:  ;--tw-hue-rotate:  ;--tw-invert:  ;--tw-saturate:  ;--tw-sepia:  ;--tw-drop-shadow:  ;--tw-backdrop-blur:  ;--tw-backdrop-brightness:  ;--tw-backdrop-contrast:  ;--tw-backdrop-grayscale:  ;--tw-backdrop-hue-rotate:  ;--tw-backdrop-invert:  ;--tw-backdrop-opacity:  ;--tw-backdrop-saturate:  ;--tw-backdrop-sepia:  }::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x:  ;--tw-pan-y:  ;--tw-pinch-zoom:  ;--tw-scroll-snap-strictness:proximity;--tw-ordinal:  ;--tw-slashed-zero:  ;--tw-numeric-figure:  ;--tw-numeric-spacing:  ;--tw-numeric-fraction:  ;--tw-ring-inset:  ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur:  ;--tw-brightness:  ;--tw-contrast:  ;--tw-grayscale:  ;--tw-hue-rotate:  ;--tw-invert:  ;--tw-saturate:  ;--tw-sepia:  ;--tw-drop-shadow:  ;--tw-backdrop-blur:  ;--tw-backdrop-brightness:  ;--tw-backdrop-contrast:  ;--tw-backdrop-grayscale:  ;--tw-backdrop-hue-rotate:  ;--tw-backdrop-invert:  ;--tw-backdrop-opacity:  ;--tw-backdrop-saturate:  ;--tw-backdrop-sepia:  }.cta{font-size:18px;padding:6px 10px;background-color:var(--brand-color, #000000);color:var(--button-text-color, #ffffff);border:none;border-radius:4px;cursor:pointer}button:disabled{opacity:0.4}@keyframes circleSpin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}</style>",kt(this,{target:this.shadowRoot,props:F(this.attributes),customElement:!0},Il,Al,c,{product:6,variant:7,custom:0,component:1},null),t&&(t.target&&C(t.target,this,t.anchor),t.props&&(this.$set(t.props),st()))}static get observedAttributes(){return["product","variant","custom","component"]}get product(){return this.$$.ctx[6]}set product(t){this.$$set({product:t}),st()}get variant(){return this.$$.ctx[7]}set variant(t){this.$$set({variant:t}),st()}get custom(){return this.$$.ctx[0]}set custom(t){this.$$set({custom:t}),st()}get component(){return this.$$.ctx[1]}set component(t){this.$$set({component:t}),st()}});const Tl=new TextEncoder;const{window:Rl}=_t;function Ol(t,e,n){const r=t.slice();return r[29]=e[n],r}function Nl(t){let e,n,r,o,i,a,s,c,l,u,d,h,f,p=t[1].campaignSettings.headerText+"",g=t[1].campaignSettings.headerImageUrl&&Bl(t);function m(t,e){return t[7].length>0?Pl:$l}let w=m(t),b=w(t),y=t[4]&&Ul(t);function v(t,e){return 0===t[0].accounts.length?ql:t[8]&&!t[7].length?zl:t[7].length>0?jl:t[4]?void 0:Ll}let _=v(t),k=_&&_(t);return{c(){e=A("div"),n=A("div"),r=A("div"),r.textContent="×",o=R(),i=A("div"),g&&g.c(),a=R(),s=A("h2"),c=T(p),l=R(),b.c(),u=R(),y&&y.c(),d=R(),k&&k.c(),$(r,"class","absolute cursor-pointer"),j(r,"right","8px"),j(r,"top","0"),j(r,"font-size","24px"),j(r,"width","30px"),$(s,"class","text-3xl text-center leading-8 font-extrabold tracking-tight sm:text-4xl"),$(i,"class","space-y-4 flex flex-col items-center justify-center"),j(n,"max-height","100vh"),$(n,"class","content relative"),$(e,"class","wrapper access"),j(e,"--brand-color",t[1].campaignSettings.buttonColor??Lt.brandColor),j(e,"--dialog-header-text-color",t[1].campaignSettings.dialogHeaderTextColor??t[10]??"#000000"),j(e,"--dialog-background-color",t[1].campaignSettings.backgroundColor??"#ffffff"),j(e,"--dialog-text-color",t[10]??"#000000"),j(e,"--dialog-button-text-color",t[9]??"#ffffff"),q(e,"is-root",!Xl)},m(p,m){C(p,e,m),x(e,n),x(n,r),x(n,o),x(n,i),g&&g.m(i,null),x(i,a),x(i,s),x(s,c),x(i,l),b.m(i,null),x(i,u),y&&y.m(i,null),x(i,d),k&&k.m(i,null),h||(f=N(r,"click",t[19]),h=!0)},p(t,n){t[1].campaignSettings.headerImageUrl?g?g.p(t,n):(g=Bl(t),g.c(),g.m(i,a)):g&&(g.d(1),g=null),2&n[0]&&p!==(p=t[1].campaignSettings.headerText+"")&&U(c,p),w===(w=m(t))&&b?b.p(t,n):(b.d(1),b=w(t),b&&(b.c(),b.m(i,u))),t[4]?y?y.p(t,n):(y=Ul(t),y.c(),y.m(i,d)):y&&(y.d(1),y=null),_===(_=v(t))&&k?k.p(t,n):(k&&k.d(1),k=_&&_(t),k&&(k.c(),k.m(i,null))),2&n[0]&&j(e,"--brand-color",t[1].campaignSettings.buttonColor??Lt.brandColor),1026&n[0]&&j(e,"--dialog-header-text-color",t[1].campaignSettings.dialogHeaderTextColor??t[10]??"#000000"),2&n[0]&&j(e,"--dialog-background-color",t[1].campaignSettings.backgroundColor??"#ffffff"),1024&n[0]&&j(e,"--dialog-text-color",t[10]??"#000000"),512&n[0]&&j(e,"--dialog-button-text-color",t[9]??"#ffffff")},d(t){t&&S(e),g&&g.d(),b.d(),y&&y.d(),k&&k.d(),h=!1,f()}}}function Bl(t){let e,n,r;return{c(){e=A("img"),j(e,"max-height","40vh"),j(e,"max-width","80vw"),u(e.src,n=t[1].campaignSettings.headerImageUrl)||$(e,"src",n),$(e,"alt",r=t[1].campaignSettings.headerText)},m(t,n){C(t,e,n)},p(t,o){2&o[0]&&!u(e.src,n=t[1].campaignSettings.headerImageUrl)&&$(e,"src",n),2&o[0]&&r!==(r=t[1].campaignSettings.headerText)&&$(e,"alt",r)},d(t){t&&S(e)}}}function $l(t){let e,n,r=t[1].campaignSettings.descriptionText+"";return{c(){e=A("p"),n=T(r)},m(t,r){C(t,e,r),x(e,n)},p(t,e){2&e[0]&&r!==(r=t[1].campaignSettings.descriptionText+"")&&U(n,r)},d(t){t&&S(e)}}}function Pl(t){let n;return{c(){n=A("div"),n.textContent="Congratulations!",$(n,"class","message")},m(t,e){C(t,n,e)},p:e,d(t){t&&S(n)}}}function Ul(t){let e,n;return{c(){e=A("div"),n=T(t[4]),$(e,"class","error")},m(t,r){C(t,e,r),x(e,n)},p(t,e){16&e[0]&&U(n,t[4])},d(t){t&&S(e)}}}function Ll(t){let e,n,r,o,i=(t[0].accounts[0]||"unknown wallet")+"";function a(t,e){return t[1].campaignSettings.rejectMessage?Fl:Dl}let s=a(t),c=s(t);return{c(){c.c(),e=R(),n=A("h5"),r=T("connected wallet: "),o=T(i),$(n,"class","text-gray-500 truncate overflow-ellipsis")},m(t,i){c.m(t,i),C(t,e,i),C(t,n,i),x(n,r),x(n,o)},p(t,n){s===(s=a(t))&&c?c.p(t,n):(c.d(1),c=s(t),c&&(c.c(),c.m(e.parentNode,e))),1&n[0]&&i!==(i=(t[0].accounts[0]||"unknown wallet")+"")&&U(o,i)},d(t){c.d(t),t&&S(e),t&&S(n)}}}function jl(t){let e,n,r,o,i,a,s=t[7],c=[];for(let e=0;e<s.length;e+=1)c[e]=Jl(Ol(t,s,e));function l(t,e){return t[3]?Ql:"single"!==t[1].campaignSettings.redemptionType&&t[7].length>0?Vl:void 0}let u=l(t),d=u&&u(t);return{c(){e=A("fieldset"),n=A("legend"),n.textContent="Tokens",r=R(),o=A("div");for(let t=0;t<c.length;t+=1)c[t].c();i=R(),d&&d.c(),a=O(),$(n,"class","sr-only"),$(o,"class","divide-y divide-gray-200 overflow-y-auto max-h-52"),$(e,"class","border-b")},m(t,s){C(t,e,s),x(e,n),x(e,r),x(e,o);for(let t=0;t<c.length;t+=1)c[t].m(o,null);C(t,i,s),d&&d.m(t,s),C(t,a,s)},p(t,e){if(65730&e[0]){let n;for(s=t[7],n=0;n<s.length;n+=1){const r=Ol(t,s,n);c[n]?c[n].p(r,e):(c[n]=Jl(r),c[n].c(),c[n].m(o,null))}for(;n<c.length;n+=1)c[n].d(1);c.length=s.length}u===(u=l(t))&&d?d.p(t,e):(d&&d.d(1),d=u&&u(t),d&&(d.c(),d.m(a.parentNode,a)))},d(t){t&&S(e),E(c,t),t&&S(i),d&&d.d(t),t&&S(a)}}}function zl(t){let n;return{c(){n=A("div"),n.textContent="Loading your NFTs…"},m(t,e){C(t,n,e)},p:e,d(t){t&&S(n)}}}function ql(t){let e,n,r,o,i,a,c,l,u=t[11].isAvailable&&Lt.walletConnect&&Zl(t);return{c(){e=A("div"),n=A("button"),r=T("Connect your wallet"),i=R(),u&&u.c(),a=O(),$(n,"class","cta"),n.disabled=t[2],$(e,"style",o=t[11].isAvailable&&Lt.walletConnect?"padding: 5px":"")},m(o,d){C(o,e,d),x(e,n),x(n,r),C(o,i,d),u&&u.m(o,d),C(o,a,d),c||(l=N(n,"click",(function(){s(t[15](t[11].isAvailable?Xt.connect:Oc.connect))&&t[15](t[11].isAvailable?Xt.connect:Oc.connect).apply(this,arguments)})),c=!0)},p(r,i){t=r,4&i[0]&&(n.disabled=t[2]),2048&i[0]&&o!==(o=t[11].isAvailable&&Lt.walletConnect?"padding: 5px":"")&&$(e,"style",o),t[11].isAvailable&&Lt.walletConnect?u?u.p(t,i):(u=Zl(t),u.c(),u.m(a.parentNode,a)):u&&(u.d(1),u=null)},d(t){t&&S(e),t&&S(i),u&&u.d(t),t&&S(a),c=!1,l()}}}function Dl(t){let n;return{c(){n=A("div"),n.innerHTML='You don’t have any of the right NFTs connected to your wallet.  Visit our <a href="https://percs.notion.site/I-can-t-see-my-NFTs-when-I-connect-my-wallet-d20495c88e57424391a0357b634f0e6c" class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600" target="_blank">support page</a> for more information'},m(t,e){C(t,n,e)},p:e,d(t){t&&S(n)}}}function Fl(t){let e,n,r=t[1].campaignSettings.rejectMessage+"";return{c(){e=A("div"),n=T(r)},m(t,r){C(t,e,r),x(e,n)},p(t,e){2&e[0]&&r!==(r=t[1].campaignSettings.rejectMessage+"")&&U(n,r)},d(t){t&&S(e)}}}function Wl(t){let e;return{c(){e=A("div"),$(e,"class","mr-3 inline-block h-14 w-14 rounded-md"),j(e,"background-color",t[1].campaignSettings.buttonColor??Lt.brandColor)},m(t,n){C(t,e,n)},p(t,n){2&n[0]&&j(e,"background-color",t[1].campaignSettings.buttonColor??Lt.brandColor)},d(t){t&&S(e)}}}function Hl(t){let e,n,r;return{c(){e=A("img"),$(e,"class","mr-3 inline-block h-14 w-14 rounded-md"),u(e.src,n=t[29].imageThumbnailUrl)||$(e,"src",n),$(e,"alt",r=t[29].title||`#${t[29].id}`)},m(t,n){C(t,e,n)},p(t,o){128&o[0]&&!u(e.src,n=t[29].imageThumbnailUrl)&&$(e,"src",n),128&o[0]&&r!==(r=t[29].title||`#${t[29].id}`)&&$(e,"alt",r)},d(t){t&&S(e)}}}function Yl(t){let e,n,r,o,i,a,s;return{c(){e=A("input"),e.disabled=n=t[29].isRedeemed,e.__value=r=t[29],e.value=e.__value,$(e,"id",o="token-"+t[29].smartContract.address+"-$"+t[29].id),$(e,"aria-describedby",i="token-"+t[29].smartContract.address+"-$"+t[29].id+"-contract"),$(e,"name","tokens"),$(e,"type","checkbox"),$(e,"class","focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"),t[22][0].push(e)},m(n,r){C(n,e,r),e.checked=~t[6].indexOf(e.__value),a||(s=N(e,"change",t[21]),a=!0)},p(t,a){128&a[0]&&n!==(n=t[29].isRedeemed)&&(e.disabled=n),128&a[0]&&r!==(r=t[29])&&(e.__value=r,e.value=e.__value),128&a[0]&&o!==(o="token-"+t[29].smartContract.address+"-$"+t[29].id)&&$(e,"id",o),128&a[0]&&i!==(i="token-"+t[29].smartContract.address+"-$"+t[29].id+"-contract")&&$(e,"aria-describedby",i),64&a[0]&&(e.checked=~t[6].indexOf(e.__value))},d(n){n&&S(e),t[22][0].splice(t[22][0].indexOf(e),1),a=!1,s()}}}function Kl(t){let e,n,r,o,i=t[29].isRedeemed?"Unlock":"Redeem";function a(){return t[20](t[29])}return{c(){e=A("button"),n=T(i),$(e,"type","button"),$(e,"class","inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500")},m(t,i){C(t,e,i),x(e,n),r||(o=N(e,"click",a),r=!0)},p(e,r){t=e,128&r[0]&&i!==(i=t[29].isRedeemed?"Unlock":"Redeem")&&U(n,i)},d(t){t&&S(e),r=!1,o()}}}function Jl(t){let e,n,r,o,i,a,s,c,l,u,d,h,f,p,g=(t[29].title||`#${t[29].id}`)+"",m=t[29].smartContract.address+"";function w(t,e){return t[29].imageThumbnailUrl?Hl:Wl}let b=w(t),y=b(t);function v(t,e){return t[29].redemption||"single"===t[1].campaignSettings.redemptionType?Kl:"multiple"===t[1].campaignSettings.redemptionType?Yl:void 0}let _=v(t),k=_&&_(t);return{c(){e=A("div"),y.c(),n=R(),r=A("div"),o=A("label"),i=T(g),s=R(),c=A("p"),l=T(m),d=R(),h=A("div"),k&&k.c(),f=R(),$(o,"for",a="token-"+t[29].smartContract.address+"-$"+t[29].id),$(o,"class","font-medium text-md"),$(c,"id",u="token-"+t[29].smartContract.address+"-$"+t[29].id+"-contract"),$(c,"class","text-sm text-gray-500 truncate"),$(r,"class","min-w-0 flex-1"),$(h,"class","ml-3 flex items-center h-5"),$(e,"class",p="relative flex items-center p-4 "+(t[29].isRedeemed?"line-through":""))},m(t,a){C(t,e,a),y.m(e,null),x(e,n),x(e,r),x(r,o),x(o,i),x(r,s),x(r,c),x(c,l),x(e,d),x(e,h),k&&k.m(h,null),x(e,f)},p(t,r){b===(b=w(t))&&y?y.p(t,r):(y.d(1),y=b(t),y&&(y.c(),y.m(e,n))),128&r[0]&&g!==(g=(t[29].title||`#${t[29].id}`)+"")&&U(i,g),128&r[0]&&a!==(a="token-"+t[29].smartContract.address+"-$"+t[29].id)&&$(o,"for",a),128&r[0]&&m!==(m=t[29].smartContract.address+"")&&U(l,m),128&r[0]&&u!==(u="token-"+t[29].smartContract.address+"-$"+t[29].id+"-contract")&&$(c,"id",u),_===(_=v(t))&&k?k.p(t,r):(k&&k.d(1),k=_&&_(t),k&&(k.c(),k.m(h,null))),128&r[0]&&p!==(p="relative flex items-center p-4 "+(t[29].isRedeemed?"line-through":""))&&$(e,"class",p)},d(t){t&&S(e),y.d(),k&&k.d()}}}function Vl(t){let e,n,r,o,i,a,s,c;return{c(){e=A("button"),n=I("svg"),r=I("path"),o=I("path"),i=I("path"),a=T("\n              Redeem Tokens"),$(r,"fill-rule","evenodd"),$(r,"d","M6.625 2.655A9 9 0 0119 11a1 1 0 11-2 0 7 7 0 00-9.625-6.492 1 1 0 11-.75-1.853zM4.662 4.959A1 1 0 014.75 6.37 6.97 6.97 0 003 11a1 1 0 11-2 0 8.97 8.97 0 012.25-5.953 1 1 0 011.412-.088z"),$(r,"clip-rule","evenodd"),$(o,"fill-rule","evenodd"),$(o,"d","M5 11a5 5 0 1110 0 1 1 0 11-2 0 3 3 0 10-6 0c0 1.677-.345 3.276-.968 4.729a1 1 0 11-1.838-.789A9.964 9.964 0 005 11zm8.921 2.012a1 1 0 01.831 1.145 19.86 19.86 0 01-.545 2.436 1 1 0 11-1.92-.558c.207-.713.371-1.445.49-2.192a1 1 0 011.144-.83z"),$(o,"clip-rule","evenodd"),$(i,"fill-rule","evenodd"),$(i,"d","M10 10a1 1 0 011 1c0 2.236-.46 4.368-1.29 6.304a1 1 0 01-1.838-.789A13.952 13.952 0 009 11a1 1 0 011-1z"),$(i,"clip-rule","evenodd"),$(n,"xmlns","http://www.w3.org/2000/svg"),$(n,"class","min-w-6 h-6 mr-2"),$(n,"viewBox","0 0 20 20"),$(n,"fill","currentColor"),$(e,"type","button"),e.disabled=t[2],$(e,"class","cta inline-flex items-center px-4 py-2 text-base leading-4 font-medium")},m(l,u){C(l,e,u),x(e,n),x(n,r),x(n,o),x(n,i),x(e,a),s||(c=N(e,"click",t[23]),s=!0)},p(t,n){4&n[0]&&(e.disabled=t[2])},d(t){t&&S(e),s=!1,c()}}}function Ql(t){let n;return{c(){n=A("div"),$(n,"class","circle-loader")},m(t,e){C(t,n,e)},p:e,d(t){t&&S(n)}}}function Zl(t){let e,n,r,o,i;return{c(){e=A("div"),n=A("button"),r=T("Connect using WalletConnect"),$(n,"class","cta"),n.disabled=t[2],j(e,"padding","5px")},m(a,s){C(a,e,s),x(e,n),x(n,r),o||(i=N(n,"click",t[15](Oc.connect)),o=!0)},p(t,e){4&e[0]&&(n.disabled=t[2])},d(t){t&&S(e),o=!1,i()}}}function Gl(t){let n,r,o,i,a,s,c,l,u,d=`<style>${t[13]}</style>`,h=Lt.buyButtonStyles&&function(t){let n,r,o=`<style>${Lt.buyButtonStyles}</style>`;return{c(){n=new D(!1),r=O(),n.a=r},m(t,e){n.m(o,t,e),C(t,r,e)},p:e,d(t){t&&S(r),t&&n.d()}}}(),f=t[1].isModalOpen&&Nl(t);return{c(){n=new D(!1),r=O(),h&&h.c(),o=O(),i=R(),a=A("div"),s=R(),f&&f.c(),c=O(),this.c=e,n.a=r},m(e,p){n.m(d,document.head),x(document.head,r),h&&h.m(document.head,null),x(document.head,o),C(e,i,p),C(e,a,p),t[18](a),C(e,s,p),f&&f.m(e,p),C(e,c,p),l||(u=N(Rl,"keydown",t[14]),l=!0)},p(t,e){Lt.buyButtonStyles&&h.p(t,e),t[1].isModalOpen?f?f.p(t,e):(f=Nl(t),f.c(),f.m(c.parentNode,c)):f&&(f.d(1),f=null)},i:e,o:e,d(e){S(r),e&&n.d(),h&&h.d(e),S(o),e&&S(i),e&&S(a),t[18](null),e&&S(s),f&&f.d(e),e&&S(c),l=!1,u()}}}let Xl=!1;function tu(t,e,n){let r,o,i,a;f(t,Pc,(t=>n(0,r=t))),f(t,kl,(t=>n(1,o=t))),f(t,Xt,(t=>n(11,a=t)));const s=Dt("campaign_redemptions",{});f(t,s,(t=>n(26,i=t)));let c,l=!1,u=!1,d="",h=[],p=[],m=!1,w=null,b="#ffffff",y="#000000",v=null;async function _(){if(0===r.accounts.length)return n(4,d=""),n(7,p=[]),void(v=null);const t=`${o.campaignSettings.id}|${o.productId}|${JSON.stringify(r.accounts)}`;if(t!==v){if(n(4,d=""),n(7,p=[]),0===r.accounts.length)return;v=t,n(8,m=!0),n(7,p=await Ot({campaignId:`${o.campaignSettings.id}`,productId:o.productId,accounts:r.accounts})),n(8,m=!1),function(){if(p){const t=i[`${o.campaignSettings.id}`];w={};for(const e of p){if(t){const n=t.find((([t])=>t.includes(`${e.smartContract.type}|${e.smartContract.address}|${e.id}`)));n&&(e.redemption=n[1])}w[e.account]||(w[e.account]=[]),w[e.account].push(e)}r.accounts.length&&w&&w[r.accounts[0]]&&(h.length>0&&h.some((t=>!w[r.accounts[0]].includes(t)))&&n(6,h=h.filter((t=>!t.isRedeemed&&w[r.accounts[0]].includes(t)))),0===h.length&&n(6,h=w[r.accounts[0]].filter((({isRedeemed:t})=>!t))))}}()}}async function x(t){if(0!==t.length){for(const e of t)if(e.redemption?.url)return n(3,u=!0),void(window.location.href=e.redemption.url);n(2,l=!0);try{const e=function(t){const e=Tl.encode(t);let n="";for(const t of e)n+=("0"+t.toString(16)).slice(-2);return"0x"+n}(t.map((t=>{return e=t.redeemMessage,decodeURIComponent(e.replace(/\s+/g,"").replace(/[0-9a-f]{2}/g,"%$&")).slice(2);var e})).join("\n---\n")),{account:r,campaignId:a}=t[0],{signature:l,keyIndex:h}=await Pc.signPersonalMessage(r,e),[f]=Nt(c.parentNode);if(!o.variantId&&!f)throw new Error("Missing variant");n(3,u=!0);const p=await async function(t){return Tt("redeemTokens",t)}({campaignId:a,productId:o.productId,variantId:o.variantId||Bt(f),tokens:t.map((({id:t,smartContract:{type:e,address:n}})=>({id:t,smartContract:{type:e,address:n}}))),message:e,signature:l,account:r,keyIndex:h});if("url"in p){const e=[t.map((({id:t,smartContract:{type:e,address:n}})=>`${e}|${n}|${t}`)),p];return i[`${a}`]?g(s,i[`${a}`]=[...i[`${a}`],e],i):g(s,i[`${a}`]=[e],i),void(window.location.href=p.url)}"properties"in p&&(f?($t(f,p.properties),kl.update((t=>({...t,isModalOpen:!1})))):n(4,d="Incompatible redemption"))}catch(t){console.error(t),n(4,d=t.message)}n(2,l=!1),n(3,u=!1)}else n(4,d="You must select a token")}let k=null;const M=[[]];return t.$$.update=()=>{3&t.$$.dirty[0]&&o.isModalOpen&&o.campaignSettings&&o.productId&&(r.accounts,_()),2&t.$$.dirty[0]&&(o.campaignSettings?.backgroundColor&&n(10,y=Lc(o.campaignSettings.backgroundColor)),o.campaignSettings?.buttonColor&&n(9,b=Lc(o.campaignSettings.buttonColor))),131073&t.$$.dirty[0]&&(!k||r.accounts.length&&!r.accounts.includes(k))&&n(17,k=r.accounts[0])},[r,o,l,u,d,c,h,p,m,b,y,a,s,"\n    .walletconnect-modal__mobile__toggle {\n      cursor: pointer;\n    }\n    div:empty.walletconnect-connect__button__icon,\n    div:empty.walletconnect-modal__mobile__toggle_selector,\n    div:empty.walletconnect-modal__close__line1,\n    div:empty.walletconnect-modal__close__line2 {\n      display: block;\n      cursor: pointer;\n    }\n  ",function(t){"Escape"===t.code&&kl.update((t=>({...t,isModalOpen:!1})))},function(t){return async()=>{n(4,d=""),n(2,l=!0);try{await t()}catch(t){console.error(t),n(4,d=t.message)}n(2,l=!1)}},x,k,function(t){G[t?"unshift":"push"]((()=>{c=t,n(5,c)}))},()=>kl.update((t=>({...t,isModalOpen:!1}))),t=>x([t]),function(){h=function(t,e,n){const r=new Set;for(let e=0;e<t.length;e+=1)t[e].checked&&r.add(t[e].__value);return n||r.delete(e),Array.from(r)}(M[0],this.__value,this.checked),n(6,h)},M,()=>x(h)]}function eu(t,e,n){const r=t.slice();return r[15]=e[n],r[17]=n,r}function nu(t){let n;return{c(){n=A("p"),n.textContent="Select the contract and input the token ID of the NFT.",$(n,"class","mt-1 text-sm text-gray-500")},m(t,e){C(t,n,e)},p:e,d(t){t&&S(n)}}}function ru(t){let e,n,r,o;return{c(){e=A("p"),n=T("Input the token ID of the NFT to check from "),r=T(t[0]),o=T("."),$(e,"class","mt-1 text-sm text-gray-500")},m(t,i){C(t,e,i),x(e,n),x(e,r),x(e,o)},p(t,e){1&e&&U(r,t[0])},d(t){t&&S(e)}}}function ou(t){let e,n,r,o,i,a,s,c,l=t[4],u=[];for(let e=0;e<l.length;e+=1)u[e]=au(eu(t,l,e));return{c(){e=A("div"),n=A("div"),r=A("label"),r.textContent="Contract",o=R(),i=A("div"),a=A("select");for(let t=0;t<u.length;t+=1)u[t].c();$(r,"for","address"),$(r,"class","block text-sm font-medium text-gray-700"),$(a,"id","eth-address"),$(a,"name","address"),$(a,"class","block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"),a.required=!0,void 0===t[5]&&rt((()=>t[11].call(a))),$(i,"class","mt-1"),$(n,"class","sm:col-span-3"),$(e,"class","sm:col-span-6")},m(l,d){C(l,e,d),x(e,n),x(n,r),x(n,o),x(n,i),x(i,a);for(let t=0;t<u.length;t+=1)u[t].m(a,null);z(a,t[5]),s||(c=N(a,"change",t[11]),s=!0)},p(t,e){if(16&e){let n;for(l=t[4],n=0;n<l.length;n+=1){const r=eu(t,l,n);u[n]?u[n].p(r,e):(u[n]=au(r),u[n].c(),u[n].m(a,null))}for(;n<u.length;n+=1)u[n].d(1);u.length=l.length}48&e&&z(a,t[5])},d(t){t&&S(e),E(u,t),s=!1,c()}}}function iu(t){let e,n,r;return{c(){e=A("input"),$(e,"type","hidden"),$(e,"id","eth-address"),$(e,"name","address")},m(o,i){C(o,e,i),L(e,t[5]),n||(r=N(e,"input",t[10]),n=!0)},p(t,n){48&n&&L(e,t[5])},d(t){t&&S(e),n=!1,r()}}}function au(t){let e,n,r,o,i,a,s,c,l=t[15].name+"",u=t[15].address+"";return{c(){e=A("option"),n=T(l),r=T(" - "),o=T(u),i=R(),$(e,"id",a=t[15].address),$(e,"name",s=t[15].name),e.__value=c=t[15].address,e.value=e.__value},m(t,a){C(t,e,a),x(e,n),x(e,r),x(e,o),x(e,i)},p(t,r){16&r&&l!==(l=t[15].name+"")&&U(n,l),16&r&&u!==(u=t[15].address+"")&&U(o,u),16&r&&a!==(a=t[15].address)&&$(e,"id",a),16&r&&s!==(s=t[15].name)&&$(e,"name",s),16&r&&c!==(c=t[15].address)&&(e.__value=c,e.value=e.__value)},d(t){t&&S(e)}}}function su(t){let e,n,r=t[2].message+"";return{c(){e=A("p"),n=T(r),$(e,"class","message")},m(t,r){C(t,e,r),x(e,n)},p(t,e){4&e&&r!==(r=t[2].message+"")&&U(n,r)},d(t){t&&S(e)}}}function cu(t){let e,n;return{c(){e=A("p"),n=T(t[3]),$(e,"class","error")},m(t,r){C(t,e,r),x(e,n)},p(t,e){8&e&&U(n,t[3])},d(t){t&&S(e)}}}function lu(t){let n,r,o,i,s,c,l,u,d,h,f,p,g,m,w,b,y,v,_,k,M,E,I,B,P,U,z,q=Lt.buyButtonStyles&&function(t){let n,r,o=`<style>${Lt.buyButtonStyles}</style>`;return{c(){n=new D(!1),r=O(),n.a=r},m(t,e){n.m(o,t,e),C(t,r,e)},p:e,d(t){t&&S(r),t&&n.d()}}}();function F(t,e){return t[0]?ru:nu}let W=F(t),H=W(t);function Y(t,e){return t[0]?iu:ou}let K=Y(t),J=K(t);function V(t,e){return t[3]?cu:t[2]&&"message"in t[2]&&t[2].message?su:void 0}let Q=V(t),Z=Q&&Q(t);return{c(){q&&q.c(),n=O(),r=R(),o=A("div"),i=A("form"),s=A("div"),c=A("div"),l=A("div"),u=A("h3"),u.textContent="Check NFT Redemption",d=R(),H.c(),h=R(),f=A("div"),J.c(),p=R(),g=A("div"),m=A("label"),m.textContent="Token ID",w=R(),b=A("div"),y=A("input"),v=R(),_=A("div"),k=A("div"),M=A("button"),E=T("Check NFT"),I=R(),B=A("div"),P=A("div"),Z&&Z.c(),this.c=e,$(u,"class","text-lg font-medium leading-6 text-gray-900"),$(m,"for","token-id"),$(m,"class","block text-sm font-medium text-gray-700"),$(y,"type","text"),$(y,"name","token-id"),$(y,"id","token-id"),$(y,"autocomplete","token-id"),$(y,"class","block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"),y.required=!0,$(b,"class","mt-1"),$(g,"class","sm:col-span-6"),$(f,"class","mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"),$(s,"class","space-y-8 divide-y divide-gray-200"),$(M,"type","submit"),$(M,"class","ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-md font-medium text-white"),j(M,"background-color",Lt.brandColor),M.disabled=t[6],$(k,"class","flex justify-end"),$(_,"class","pt-5"),$(P,"class","flex justify-end"),$(B,"class","pt-5"),$(i,"class","space-y-8 divide-gray-200"),$(o,"class","redemption-block")},m(e,a){var S;q&&q.m(document.head,null),x(document.head,n),C(e,r,a),C(e,o,a),x(o,i),x(i,s),x(s,c),x(c,l),x(l,u),x(l,d),H.m(l,null),x(c,h),x(c,f),J.m(f,null),x(f,p),x(f,g),x(g,m),x(g,w),x(g,b),x(b,y),L(y,t[1]),x(i,v),x(i,_),x(_,k),x(k,M),x(M,E),x(i,I),x(i,B),x(B,P),Z&&Z.m(P,null),U||(z=[N(y,"input",t[12]),N(i,"submit",(S=t[7],function(t){return t.preventDefault(),S.call(this,t)}))],U=!0)},p(t,[e]){Lt.buyButtonStyles&&q.p(t,e),W===(W=F(t))&&H?H.p(t,e):(H.d(1),H=W(t),H&&(H.c(),H.m(l,null))),K===(K=Y(t))&&J?J.p(t,e):(J.d(1),J=K(t),J&&(J.c(),J.m(f,p))),2&e&&y.value!==t[1]&&L(y,t[1]),64&e&&(M.disabled=t[6]),Q===(Q=V(t))&&Z?Z.p(t,e):(Z&&Z.d(1),Z=Q&&Q(t),Z&&(Z.c(),Z.m(P,null)))},i:e,o:e,d(t){q&&q.d(t),S(n),t&&S(r),t&&S(o),H.d(),J.d(),Z&&Z.d(),U=!1,a(z)}}}function uu(t,e,n){let{product:r}=e,{contract:o}=e,{campaign:i}=e,a="",s={message:""},c=null,l=null,u=null,d=[],h=null,f=!1;return Q((async()=>{if(l||u){const t=await async function(t){return Tt("getProductCampaignContracts",t)}({campaignId:u,productId:l});if(n(4,d=t.campaignContracts),0===d.length)n(3,c="Error: No contracts associated with this campaign.");else{const[t]=d;n(5,h=t.address)}}else n(3,c="failed to fetch contracts")})),t.$$set=t=>{"product"in t&&n(8,r=t.product),"contract"in t&&n(0,o=t.contract),"campaign"in t&&n(9,i=t.campaign)},t.$$.update=()=>{769&t.$$.dirty&&(l=r,n(5,h=o),u=i)},[o,a,s,c,d,h,f,async function(){n(2,s={message:""}),n(3,c=null);try{if(n(6,f=!0),!h)throw Error("Contract Required");n(2,s=await async function(t){return Tt("checkTokenRedemption",t)}({address:h.toLowerCase(),token:a,productId:l,campaignId:u})),n(6,f=!1)}catch(t){n(3,c="Error: "+t.message),n(6,f=!1)}},r,i,function(){h=this.value,n(5,h),n(8,r),n(0,o),n(9,i),n(4,d)},function(){h=function(t){const e=t.querySelector(":checked")||t.options[0];return e&&e.__value}(this),n(5,h),n(8,r),n(0,o),n(9,i),n(4,d)},function(){a=this.value,n(1,a)}]}customElements.define("nft-buy-modal",class extends Mt{constructor(t){super(),this.shadowRoot.innerHTML="<style>*,::before,::after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}::before,::after{--tw-content:''}h2,h5{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}button,input{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button{text-transform:none}button,[type='button']{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}h2,h5,p{margin:0}fieldset{margin:0;padding:0}legend{padding:0}input::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder{opacity:1;color:#9ca3af}button{cursor:pointer}:disabled{cursor:default}img,svg{display:block;vertical-align:middle}img{max-width:100%;height:auto}input::-moz-placeholder{color:#6b7280;opacity:1}input::placeholder{color:#6b7280;opacity:1}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-date-and-time-value{min-height:1.5em}::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{padding-top:0;padding-bottom:0}[type='checkbox']{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;-webkit-print-color-adjust:exact;print-color-adjust:exact;display:inline-block;vertical-align:middle;background-origin:border-box;-webkit-user-select:none;-moz-user-select:none;user-select:none;flex-shrink:0;height:1rem;width:1rem;color:#2563eb;background-color:#fff;border-color:#6b7280;border-width:1px;--tw-shadow:0 0 #0000}[type='checkbox']{border-radius:0px}[type='checkbox']:focus{outline:2px solid transparent;outline-offset:2px;--tw-ring-inset:var(--tw-empty,/*!*/ /*!*/);--tw-ring-offset-width:2px;--tw-ring-offset-color:#fff;--tw-ring-color:#2563eb;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)}[type='checkbox']:checked{border-color:transparent;background-color:currentColor;background-size:100% 100%;background-position:center;background-repeat:no-repeat}[type='checkbox']:checked{background-image:url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e\")}[type='checkbox']:checked:hover,[type='checkbox']:checked:focus{border-color:transparent;background-color:currentColor}[type='checkbox']:indeterminate{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3e%3cpath stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8h8'/%3e%3c/svg%3e\");border-color:transparent;background-color:currentColor;background-size:100% 100%;background-position:center;background-repeat:no-repeat}[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus{border-color:transparent;background-color:currentColor}*,::before,::after{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x:  ;--tw-pan-y:  ;--tw-pinch-zoom:  ;--tw-scroll-snap-strictness:proximity;--tw-ordinal:  ;--tw-slashed-zero:  ;--tw-numeric-figure:  ;--tw-numeric-spacing:  ;--tw-numeric-fraction:  ;--tw-ring-inset:  ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur:  ;--tw-brightness:  ;--tw-contrast:  ;--tw-grayscale:  ;--tw-hue-rotate:  ;--tw-invert:  ;--tw-saturate:  ;--tw-sepia:  ;--tw-drop-shadow:  ;--tw-backdrop-blur:  ;--tw-backdrop-brightness:  ;--tw-backdrop-contrast:  ;--tw-backdrop-grayscale:  ;--tw-backdrop-hue-rotate:  ;--tw-backdrop-invert:  ;--tw-backdrop-opacity:  ;--tw-backdrop-saturate:  ;--tw-backdrop-sepia:  }::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x:  ;--tw-pan-y:  ;--tw-pinch-zoom:  ;--tw-scroll-snap-strictness:proximity;--tw-ordinal:  ;--tw-slashed-zero:  ;--tw-numeric-figure:  ;--tw-numeric-spacing:  ;--tw-numeric-fraction:  ;--tw-ring-inset:  ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur:  ;--tw-brightness:  ;--tw-contrast:  ;--tw-grayscale:  ;--tw-hue-rotate:  ;--tw-invert:  ;--tw-saturate:  ;--tw-sepia:  ;--tw-drop-shadow:  ;--tw-backdrop-blur:  ;--tw-backdrop-brightness:  ;--tw-backdrop-contrast:  ;--tw-backdrop-grayscale:  ;--tw-backdrop-hue-rotate:  ;--tw-backdrop-invert:  ;--tw-backdrop-opacity:  ;--tw-backdrop-saturate:  ;--tw-backdrop-sepia:  }.cta{font-size:18px;padding:6px 10px;background-color:var(--brand-color, #000000);color:var(--dialog-button-text-color, #ffffff);border:none;border-radius:4px;cursor:pointer}button:disabled{opacity:0.4}.wrapper{position:fixed;height:100%;width:100%;top:0;left:0;display:flex;background:rgba(0,0,0,.8);z-index:1000}.content{background-color:var(--dialog-background-color, #ffffff);color:var(--dialog-text-color, #000000);margin:auto;border-radius:.8rem;text-align:center;padding:3rem 2rem}.is-root.wrapper{height:100vh;width:100vw}.is-root .content{min-width:80vw;min-height:80vh;display:flex;flex-direction:column;align-items:center;justify-content:center}.message{font-size:30px;font-weight:bold;padding-bottom:3rem}.error{padding-bottom:15px;padding-top:15px;color:rgb(215, 44, 13)}.circle-loader{width:60px;height:60px;box-sizing:border-box;position:relative;border:3px solid transparent;border-top-color:#285fe0;border-radius:50%;animation:circleSpin 2s linear infinite}.circle-loader:before,.circle-loader:after{content:\"\";box-sizing:border-box;position:absolute;border:3px solid transparent;border-radius:50%}.circle-loader:after{border-top-color:#fd665f;top:9px;left:9px;right:9px;bottom:9px;animation:circleSpin 1.5s linear infinite}.circle-loader:before{border-top-color:#fbb338;top:3px;left:3px;right:3px;bottom:3px;animation:circleSpin 3s linear infinite}@keyframes circleSpin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}.absolute{position:absolute}.relative{position:relative}.text-center{text-align:center}.items-center{align-items:center}.justify-center{justify-content:center}.flex{display:flex}.flex-col{flex-direction:column}.space-y-4>*+*{margin-top:1rem}.cursor-pointer{cursor:pointer}.sr-only{display:none}.mr-3{margin-right:0.75rem}.ml-3{margin-left:0.75rem}.p-4{padding:1rem}.h-5{height:1.25rem}.underline{text-decoration:underline}.line-through{text-decoration:line-through}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.overflow-ellipsis{text-overflow:ellipsis}.border{border-width:1px}.border-b{border-bottom-width:1px}.border-gray-300{border-color:rgb(209 213 219)}.text-blue-600{color:rgb(37 99 235)}.text-indigo-600{color:rgb(79 70 229)}.text-gray-500{color:rgb(107 114 128)}.text-gray-700{color:rgb(55 65 81)}.text-sm{font-size:.875rem;line-height:1.25rem}.text-md{font-size:1rem;line-height:1.5rem}.font-medium{font-weight:500}.rounded{border-radius:.25rem}.rounded-md{border-radius:.375rem}.flex-1{flex:1 1 0%}.text-3xl{font-size:1.875rem;line-height:2.25rem}.w-4{width:1rem}.h-4{height:1rem}.h-6{height:1.5rem}.w-14{width:3.5rem}.h-14{height:3.5rem}.inline-block{display:inline-block}.inline-flex{display:inline-flex}.bg-white{background-color:white}.px-4{padding-left:1rem;padding-right:1rem}.py-2{padding-left:0.5rem;padding-right:0.5rem}.min-w-0{min-width:0px}.font-extrabold{font-weight:800}.tracking-tight{letter-spacing:-0.025em}.mr-2{margin-right:0.5rem}.min-w-6{min-width:1.5rem}.shadow-sm{--tw-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.05);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}.max-h-52{max-height:13rem}.overflow-y-auto{overflow-y:auto}.leading-8{line-height:2rem}.sm\\:text-4xl{font-size:2.25rem;line-height:2.5rem}.divide-y{border-top-width:1px;border-bottom-width:0px}.divide-gray-200>*+*{border-color:rgb(229 231 235)}.text-base{font-size:1rem;line-height:1.5rem}.leading-4{line-height:1rem}.hover\\:bg-gray-50{background-color:rgb(249 250 251)}.focus\\:outline-none{outline:2px solid transparent;outline-offset:2px}.focus\\:ring-2{box-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)}.focus\\:ring-offset-2{--tw-ring-offset-width:2px;box-shadow:0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow)}.focus\\:ring-indigo-500{--tw-ring-color:rgb(99 102 241)}.hover\\:text-blue-800{color:rgb(30 64 175)}.visited\\:text-purple-600{color:rgb(147 51 234)}</style>",kt(this,{target:this.shadowRoot,props:F(this.attributes),customElement:!0},tu,Gl,c,{},null,[-1,-1]),t&&t.target&&C(t.target,this,t.anchor)}});customElements.define("nft-redemption-check",class extends Mt{constructor(t){super(),this.shadowRoot.innerHTML="<style>*,::before,::after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}::before,::after{--tw-content:''}h3{font-size:inherit;font-weight:inherit}button,input,select{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type='submit']{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}h3,p{margin:0}input::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder{opacity:1;color:#9ca3af}button{cursor:pointer}:disabled{cursor:default}[type='text'],select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;border-color:#6b7280;border-width:1px;border-radius:0px;padding-top:0.5rem;padding-right:0.75rem;padding-bottom:0.5rem;padding-left:0.75rem;font-size:1rem;line-height:1.5rem;--tw-shadow:0 0 #0000}[type='text']:focus,select:focus{outline:2px solid transparent;outline-offset:2px;--tw-ring-inset:var(--tw-empty,/*!*/ /*!*/);--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#2563eb;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);border-color:#2563eb}input::-moz-placeholder{color:#6b7280;opacity:1}input::placeholder{color:#6b7280;opacity:1}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-date-and-time-value{min-height:1.5em}::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{padding-top:0;padding-bottom:0}select{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");background-position:right 0.5rem center;background-repeat:no-repeat;background-size:1.5em 1.5em;padding-right:2.5rem;-webkit-print-color-adjust:exact;print-color-adjust:exact}*,::before,::after{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x:  ;--tw-pan-y:  ;--tw-pinch-zoom:  ;--tw-scroll-snap-strictness:proximity;--tw-ordinal:  ;--tw-slashed-zero:  ;--tw-numeric-figure:  ;--tw-numeric-spacing:  ;--tw-numeric-fraction:  ;--tw-ring-inset:  ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur:  ;--tw-brightness:  ;--tw-contrast:  ;--tw-grayscale:  ;--tw-hue-rotate:  ;--tw-invert:  ;--tw-saturate:  ;--tw-sepia:  ;--tw-drop-shadow:  ;--tw-backdrop-blur:  ;--tw-backdrop-brightness:  ;--tw-backdrop-contrast:  ;--tw-backdrop-grayscale:  ;--tw-backdrop-hue-rotate:  ;--tw-backdrop-invert:  ;--tw-backdrop-opacity:  ;--tw-backdrop-saturate:  ;--tw-backdrop-sepia:  }::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x:  ;--tw-pan-y:  ;--tw-pinch-zoom:  ;--tw-scroll-snap-strictness:proximity;--tw-ordinal:  ;--tw-slashed-zero:  ;--tw-numeric-figure:  ;--tw-numeric-spacing:  ;--tw-numeric-fraction:  ;--tw-ring-inset:  ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur:  ;--tw-brightness:  ;--tw-contrast:  ;--tw-grayscale:  ;--tw-hue-rotate:  ;--tw-invert:  ;--tw-saturate:  ;--tw-sepia:  ;--tw-drop-shadow:  ;--tw-backdrop-blur:  ;--tw-backdrop-brightness:  ;--tw-backdrop-contrast:  ;--tw-backdrop-grayscale:  ;--tw-backdrop-hue-rotate:  ;--tw-backdrop-invert:  ;--tw-backdrop-opacity:  ;--tw-backdrop-saturate:  ;--tw-backdrop-sepia:  }button:disabled{opacity:0.4}.message{font-size:1.35rem;font-weight:bold;padding-bottom:15px;padding-top:15px}.error{padding-bottom:15px;padding-top:15px;color:rgb(215, 44, 13)}.redemption-block{padding-bottom:15px;padding-top:15px}.space-y-8>*+*{margin-top:2rem}.divide-gray-200>*+*{border-color:rgb(229 231 235)}.divide-y{border-top-width:1px;border-bottom-width:0px}.text-lg{font-size:1.125rem;line-height:1.75rem}.font-medium{font-weight:500}.leading-6{line-height:1.5rem}.text-gray-900{color:rgb(17 24 39)}.mt-1{margin-top:0.25rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-gray-500{color:rgb(107 114 128)}.mt-6{margin-top:1.5rem}.grid{display:grid}.grid-cols-1{grid-template-columns:repeat(1, minmax(0, 1fr))}.gap-y-6{row-gap:1.5rem}.gap-x-4{-moz-column-gap:1rem;column-gap:1rem}.block{display:'block' }@media(min-width: 640px){.sm\\:grid-cols-6{grid-template-columns:repeat(6, minmax(0, 1fr))}.sm\\:col-span-3{grid-column:span 3 / span 3}}.text-gray-700{color:rgb(55 65 81)}.w-full{width:100%}.rounded-md{border-radius:.375rem}.border-gray-300{border-color:rgb(209 213 219)}.shadow-sm{--tw-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.05);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}.focus\\:border-indigo-500{border-color:rgb(99 102 241)}.focus\\:ring-indigo-500{--tw-ring-color:rgb(99 102 241)}.sm\\:text-sm{font-size:.875rem;line-height:1.25rem}.sm\\:col-span-6{grid-column:span 6 / span 6}.flex{display:flex}.justify-end{justify-content:flex-end}.ml-3{margin-left:0.75rem}.inline-flex{display:inline-flex}.justify-center{justify-content:center}.border{border-width:1px}.border-transparent{border-color:transparent}.bg-indigo-600{background-color:rgb(79 70 229)}.py-2{padding-left:0.5rem;padding-right:0.5rem}.px-4{padding-left:1rem;padding-right:1rem}.text-white{color:white}.text-md{font-size:1rem;line-height:1.5rem}</style>",kt(this,{target:this.shadowRoot,props:F(this.attributes),customElement:!0},uu,lu,c,{product:8,contract:0,campaign:9},null),t&&(t.target&&C(t.target,this,t.anchor),t.props&&(this.$set(t.props),st()))}static get observedAttributes(){return["product","contract","campaign"]}get product(){return this.$$.ctx[8]}set product(t){this.$$set({product:t}),st()}get contract(){return this.$$.ctx[0]}set contract(t){this.$$set({contract:t}),st()}get campaign(){return this.$$.ctx[9]}set campaign(t){this.$$set({campaign:t}),st()}});const du=Ft("percs_discount",{isDiscountApplied:!1});function hu(t){let e;return{c(){e=A("percs-app-launcher"),P(e,"scope",t[3]),P(e,"title",t[0]),P(e,"description",t[1]),P(e,"illustration",t[2])},m(t,n){C(t,e,n)},p(t,n){8&n&&P(e,"scope",t[3]),1&n&&P(e,"title",t[0]),2&n&&P(e,"description",t[1]),4&n&&P(e,"illustration",t[2])},d(t){t&&S(e)}}}function fu(t){let n,r,o=t[4]&&hu(t);return{c(){o&&o.c(),n=R(),r=A("percs-modal"),this.c=e},m(t,e){o&&o.m(t,e),C(t,n,e),C(t,r,e)},p(t,[e]){t[4]?o?o.p(t,e):(o=hu(t),o.c(),o.m(n.parentNode,n)):o&&(o.d(1),o=null)},i:e,o:e,d(t){o&&o.d(t),t&&S(n),t&&S(r)}}}function pu(e,n,r){let o;f(e,du,(t=>r(5,o=t)));let{title:i}=n,{description:a}=n,{illustration:s}=n,{scope:c}=n,l=!1;return t.browser&&(window.PERCS.init({clientKey:"WB1f44EqONrVTApCMF8hXXlBnhijJBcNkIWc6/91gL8OREXPevxEo8GpAGA6tj4/-tCR9nFgDTzhV9RGp6yK1Kmw",apiHost:"https://engage.getpercs.com",redemptionActions:[{type:"button",text:"Apply Discount at Checkout",onAction:async t=>(du.set({isDiscountApplied:!0}),window.open(`/discount/${t.value}?redirect=${encodeURIComponent(window.location.pathname)}`,"_self"),"Your discount will be applied for this item on checkout")}]}),Q((()=>{r(4,l=!0),o.isDiscountApplied&&(window.PERCS.addLauncherNotification({text:"Your discount code has been added to your cart and will be available on checkout"}),du.set({isDiscountApplied:!1}))}))),e.$$set=t=>{"title"in t&&r(0,i=t.title),"description"in t&&r(1,a=t.description),"illustration"in t&&r(2,s=t.illustration),"scope"in t&&r(3,c=t.scope)},[i,a,s,c,l]}customElements.define("nft-app-launcher",class extends Mt{constructor(t){super(),kt(this,{target:this.shadowRoot,props:F(this.attributes),customElement:!0},pu,fu,c,{title:0,description:1,illustration:2,scope:3},null),t&&(t.target&&C(t.target,this,t.anchor),t.props&&(this.$set(t.props),st()))}static get observedAttributes(){return["title","description","illustration","scope"]}get title(){return this.$$.ctx[0]}set title(t){this.$$set({title:t}),st()}get description(){return this.$$.ctx[1]}set description(t){this.$$set({description:t}),st()}get illustration(){return this.$$.ctx[2]}set illustration(t){this.$$set({illustration:t}),st()}get scope(){return this.$$.ctx[3]}set scope(t){this.$$set({scope:t}),st()}}),"PERCS"in window&&(window.PERCS={...window.PERCS,openProductModal:t=>{for(const e of Ut){const[n,r]=e;if(n.includes(t.toString()))return void window.PERCS.openModal({scope:`product:${t}`,gate:{title:r.headerText,description:r.descriptionText,illustration:r.headerImageUrl},offerSelectedType:"discount"})}}})}({"browser":true});
//# sourceMappingURL=bundle.js.map
